
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec674"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec674"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hOXrc", function(module, exports) {
/** @license React v16.8.6
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $63ReS = parcelRequire("63ReS");
var $cf95364949609aef$var$n = "function" === typeof Symbol && Symbol.for, $cf95364949609aef$var$p = $cf95364949609aef$var$n ? Symbol.for("react.element") : 60103, $cf95364949609aef$var$q = $cf95364949609aef$var$n ? Symbol.for("react.portal") : 60106, $cf95364949609aef$var$r = $cf95364949609aef$var$n ? Symbol.for("react.fragment") : 60107, $cf95364949609aef$var$t = $cf95364949609aef$var$n ? Symbol.for("react.strict_mode") : 60108, $cf95364949609aef$var$u = $cf95364949609aef$var$n ? Symbol.for("react.profiler") : 60114, $cf95364949609aef$var$v = $cf95364949609aef$var$n ? Symbol.for("react.provider") : 60109, $cf95364949609aef$var$w = $cf95364949609aef$var$n ? Symbol.for("react.context") : 60110, $cf95364949609aef$var$x = $cf95364949609aef$var$n ? Symbol.for("react.concurrent_mode") : 60111, $cf95364949609aef$var$y = $cf95364949609aef$var$n ? Symbol.for("react.forward_ref") : 60112, $cf95364949609aef$var$z = $cf95364949609aef$var$n ? Symbol.for("react.suspense") : 60113, $cf95364949609aef$var$aa = $cf95364949609aef$var$n ? Symbol.for("react.memo") : 60115, $cf95364949609aef$var$ba = $cf95364949609aef$var$n ? Symbol.for("react.lazy") : 60116, $cf95364949609aef$var$A = "function" === typeof Symbol && Symbol.iterator;
function $cf95364949609aef$var$ca(a, b, d, c, e, g, h, f) {
    if (!a) {
        a = void 0;
        if (void 0 === b) a = Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var l = [
                d,
                c,
                e,
                g,
                h,
                f
            ], m = 0;
            a = Error(b.replace(/%s/g, function() {
                return l[m++];
            }));
            a.name = "Invariant Violation";
        }
        a.framesToPop = 1;
        throw a;
    }
}
function $cf95364949609aef$var$B(a) {
    for(var b = arguments.length - 1, d = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 0; c < b; c++)d += "&args[]=" + encodeURIComponent(arguments[c + 1]);
    $cf95364949609aef$var$ca(!1, "Minified React error #" + a + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", d);
}
var $cf95364949609aef$var$C = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $cf95364949609aef$var$D = {};
function $cf95364949609aef$var$E(a, b, d) {
    this.props = a;
    this.context = b;
    this.refs = $cf95364949609aef$var$D;
    this.updater = d || $cf95364949609aef$var$C;
}
$cf95364949609aef$var$E.prototype.isReactComponent = {};
$cf95364949609aef$var$E.prototype.setState = function(a, b) {
    "object" !== typeof a && "function" !== typeof a && null != a && $cf95364949609aef$var$B("85");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$cf95364949609aef$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $cf95364949609aef$var$F() {}
$cf95364949609aef$var$F.prototype = $cf95364949609aef$var$E.prototype;
function $cf95364949609aef$var$G(a, b, d) {
    this.props = a;
    this.context = b;
    this.refs = $cf95364949609aef$var$D;
    this.updater = d || $cf95364949609aef$var$C;
}
var $cf95364949609aef$var$H = $cf95364949609aef$var$G.prototype = new $cf95364949609aef$var$F;
$cf95364949609aef$var$H.constructor = $cf95364949609aef$var$G;
$63ReS($cf95364949609aef$var$H, $cf95364949609aef$var$E.prototype);
$cf95364949609aef$var$H.isPureReactComponent = !0;
var $cf95364949609aef$var$I = {
    current: null
}, $cf95364949609aef$var$J = {
    current: null
}, $cf95364949609aef$var$K = Object.prototype.hasOwnProperty, $cf95364949609aef$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $cf95364949609aef$var$M(a, b, d) {
    var c = void 0, e = {}, g = null, h = null;
    if (null != b) for(c in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (g = "" + b.key), b)$cf95364949609aef$var$K.call(b, c) && !$cf95364949609aef$var$L.hasOwnProperty(c) && (e[c] = b[c]);
    var f = arguments.length - 2;
    if (1 === f) e.children = d;
    else if (1 < f) {
        for(var l = Array(f), m = 0; m < f; m++)l[m] = arguments[m + 2];
        e.children = l;
    }
    if (a && a.defaultProps) for(c in f = a.defaultProps, f)void 0 === e[c] && (e[c] = f[c]);
    return {
        $$typeof: $cf95364949609aef$var$p,
        type: a,
        key: g,
        ref: h,
        props: e,
        _owner: $cf95364949609aef$var$J.current
    };
}
function $cf95364949609aef$var$da(a, b) {
    return {
        $$typeof: $cf95364949609aef$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $cf95364949609aef$var$N(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $cf95364949609aef$var$p;
}
function $cf95364949609aef$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $cf95364949609aef$var$O = /\/+/g, $cf95364949609aef$var$P = [];
function $cf95364949609aef$var$Q(a, b, d, c) {
    if ($cf95364949609aef$var$P.length) {
        var e = $cf95364949609aef$var$P.pop();
        e.result = a;
        e.keyPrefix = b;
        e.func = d;
        e.context = c;
        e.count = 0;
        return e;
    }
    return {
        result: a,
        keyPrefix: b,
        func: d,
        context: c,
        count: 0
    };
}
function $cf95364949609aef$var$R(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $cf95364949609aef$var$P.length && $cf95364949609aef$var$P.push(a);
}
function $cf95364949609aef$var$S(a, b, d, c) {
    var e = typeof a;
    if ("undefined" === e || "boolean" === e) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(e){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $cf95364949609aef$var$p:
                case $cf95364949609aef$var$q:
                    g = !0;
            }
    }
    if (g) return d(c, a, "" === b ? "." + $cf95364949609aef$var$T(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var h = 0; h < a.length; h++){
        e = a[h];
        var f = b + $cf95364949609aef$var$T(e, h);
        g += $cf95364949609aef$var$S(e, f, d, c);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $cf95364949609aef$var$A && a[$cf95364949609aef$var$A] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), h = 0; !(e = a.next()).done;)e = e.value, f = b + $cf95364949609aef$var$T(e, h++), g += $cf95364949609aef$var$S(e, f, d, c);
    else "object" === e && (d = "" + a, $cf95364949609aef$var$B("31", "[object Object]" === d ? "object with keys {" + Object.keys(a).join(", ") + "}" : d, ""));
    return g;
}
function $cf95364949609aef$var$U(a, b, d) {
    return null == a ? 0 : $cf95364949609aef$var$S(a, "", b, d);
}
function $cf95364949609aef$var$T(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $cf95364949609aef$var$escape(a.key) : b.toString(36);
}
function $cf95364949609aef$var$ea(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $cf95364949609aef$var$fa(a, b, d) {
    var c = a.result, e = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $cf95364949609aef$var$V(a, c, d, function(a) {
        return a;
    }) : null != a && ($cf95364949609aef$var$N(a) && (a = $cf95364949609aef$var$da(a, e + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($cf95364949609aef$var$O, "$&/") + "/") + d)), c.push(a));
}
function $cf95364949609aef$var$V(a, b, d, c, e) {
    var g = "";
    null != d && (g = ("" + d).replace($cf95364949609aef$var$O, "$&/") + "/");
    b = $cf95364949609aef$var$Q(b, g, c, e);
    $cf95364949609aef$var$U(a, $cf95364949609aef$var$fa, b);
    $cf95364949609aef$var$R(b);
}
function $cf95364949609aef$var$W() {
    var a = $cf95364949609aef$var$I.current;
    null === a && $cf95364949609aef$var$B("321");
    return a;
}
var $cf95364949609aef$var$X = {
    Children: {
        map: function(a, b, d) {
            if (null == a) return a;
            var c = [];
            $cf95364949609aef$var$V(a, c, null, b, d);
            return c;
        },
        forEach: function(a, b, d) {
            if (null == a) return a;
            b = $cf95364949609aef$var$Q(null, null, b, d);
            $cf95364949609aef$var$U(a, $cf95364949609aef$var$ea, b);
            $cf95364949609aef$var$R(b);
        },
        count: function(a) {
            return $cf95364949609aef$var$U(a, function() {
                return null;
            }, null);
        },
        toArray: function(a) {
            var b = [];
            $cf95364949609aef$var$V(a, b, null, function(a) {
                return a;
            });
            return b;
        },
        only: function(a) {
            $cf95364949609aef$var$N(a) || $cf95364949609aef$var$B("143");
            return a;
        }
    },
    createRef: function() {
        return {
            current: null
        };
    },
    Component: $cf95364949609aef$var$E,
    PureComponent: $cf95364949609aef$var$G,
    createContext: function(a, b) {
        void 0 === b && (b = null);
        a = {
            $$typeof: $cf95364949609aef$var$w,
            _calculateChangedBits: b,
            _currentValue: a,
            _currentValue2: a,
            _threadCount: 0,
            Provider: null,
            Consumer: null
        };
        a.Provider = {
            $$typeof: $cf95364949609aef$var$v,
            _context: a
        };
        return a.Consumer = a;
    },
    forwardRef: function(a) {
        return {
            $$typeof: $cf95364949609aef$var$y,
            render: a
        };
    },
    lazy: function(a) {
        return {
            $$typeof: $cf95364949609aef$var$ba,
            _ctor: a,
            _status: -1,
            _result: null
        };
    },
    memo: function(a, b) {
        return {
            $$typeof: $cf95364949609aef$var$aa,
            type: a,
            compare: void 0 === b ? null : b
        };
    },
    useCallback: function(a, b) {
        return $cf95364949609aef$var$W().useCallback(a, b);
    },
    useContext: function(a, b) {
        return $cf95364949609aef$var$W().useContext(a, b);
    },
    useEffect: function(a, b) {
        return $cf95364949609aef$var$W().useEffect(a, b);
    },
    useImperativeHandle: function(a, b, d) {
        return $cf95364949609aef$var$W().useImperativeHandle(a, b, d);
    },
    useDebugValue: function() {},
    useLayoutEffect: function(a, b) {
        return $cf95364949609aef$var$W().useLayoutEffect(a, b);
    },
    useMemo: function(a, b) {
        return $cf95364949609aef$var$W().useMemo(a, b);
    },
    useReducer: function(a, b, d) {
        return $cf95364949609aef$var$W().useReducer(a, b, d);
    },
    useRef: function(a) {
        return $cf95364949609aef$var$W().useRef(a);
    },
    useState: function(a) {
        return $cf95364949609aef$var$W().useState(a);
    },
    Fragment: $cf95364949609aef$var$r,
    StrictMode: $cf95364949609aef$var$t,
    Suspense: $cf95364949609aef$var$z,
    createElement: $cf95364949609aef$var$M,
    cloneElement: function(a, b, d) {
        (null === a || void 0 === a) && $cf95364949609aef$var$B("267", a);
        var c = void 0, e = $63ReS({}, a.props), g = a.key, h = a.ref, f = a._owner;
        if (null != b) {
            void 0 !== b.ref && (h = b.ref, f = $cf95364949609aef$var$J.current);
            void 0 !== b.key && (g = "" + b.key);
            var l = void 0;
            a.type && a.type.defaultProps && (l = a.type.defaultProps);
            for(c in b)$cf95364949609aef$var$K.call(b, c) && !$cf95364949609aef$var$L.hasOwnProperty(c) && (e[c] = void 0 === b[c] && void 0 !== l ? l[c] : b[c]);
        }
        c = arguments.length - 2;
        if (1 === c) e.children = d;
        else if (1 < c) {
            l = Array(c);
            for(var m = 0; m < c; m++)l[m] = arguments[m + 2];
            e.children = l;
        }
        return {
            $$typeof: $cf95364949609aef$var$p,
            type: a.type,
            key: g,
            ref: h,
            props: e,
            _owner: f
        };
    },
    createFactory: function(a) {
        var b = $cf95364949609aef$var$M.bind(null, a);
        b.type = a;
        return b;
    },
    isValidElement: $cf95364949609aef$var$N,
    version: "16.8.6",
    unstable_ConcurrentMode: $cf95364949609aef$var$x,
    unstable_Profiler: $cf95364949609aef$var$u,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
        ReactCurrentDispatcher: $cf95364949609aef$var$I,
        ReactCurrentOwner: $cf95364949609aef$var$J,
        assign: $63ReS
    }
}, $cf95364949609aef$var$Y = {
    default: $cf95364949609aef$var$X
}, $cf95364949609aef$var$Z = $cf95364949609aef$var$Y && $cf95364949609aef$var$X || $cf95364949609aef$var$Y;
module.exports = $cf95364949609aef$var$Z.default || $cf95364949609aef$var$Z;

});
parcelRegister("63ReS", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $469c520767420a99$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $469c520767420a99$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $469c520767420a99$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $469c520767420a99$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $469c520767420a99$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $469c520767420a99$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $469c520767420a99$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($469c520767420a99$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($469c520767420a99$var$getOwnPropertySymbols) {
            symbols = $469c520767420a99$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($469c520767420a99$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});


parcelRegister("fYsVz", function(module, exports) {
/** @license React v16.8.6
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $6wXVr = parcelRequire("6wXVr");

var $63ReS = parcelRequire("63ReS");

var $jmjQ5 = parcelRequire("jmjQ5");
function $ba12e603ee3d5d8e$var$ba(a, b, c, d, e, f, g, h) {
    if (!a) {
        a = void 0;
        if (void 0 === b) a = Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var l = [
                c,
                d,
                e,
                f,
                g,
                h
            ], k = 0;
            a = Error(b.replace(/%s/g, function() {
                return l[k++];
            }));
            a.name = "Invariant Violation";
        }
        a.framesToPop = 1;
        throw a;
    }
}
function $ba12e603ee3d5d8e$var$x(a) {
    for(var b = arguments.length - 1, c = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, d = 0; d < b; d++)c += "&args[]=" + encodeURIComponent(arguments[d + 1]);
    $ba12e603ee3d5d8e$var$ba(!1, "Minified React error #" + a + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", c);
}
$6wXVr || $ba12e603ee3d5d8e$var$x("227");
function $ba12e603ee3d5d8e$var$ca(a, b, c, d, e, f, g, h, l) {
    var k = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, k);
    } catch (m) {
        this.onError(m);
    }
}
var $ba12e603ee3d5d8e$var$da = !1, $ba12e603ee3d5d8e$var$ea = null, $ba12e603ee3d5d8e$var$fa = !1, $ba12e603ee3d5d8e$var$ha = null, $ba12e603ee3d5d8e$var$ia = {
    onError: function(a) {
        $ba12e603ee3d5d8e$var$da = !0;
        $ba12e603ee3d5d8e$var$ea = a;
    }
};
function $ba12e603ee3d5d8e$var$ja(a, b, c, d, e, f, g, h, l) {
    $ba12e603ee3d5d8e$var$da = !1;
    $ba12e603ee3d5d8e$var$ea = null;
    $ba12e603ee3d5d8e$var$ca.apply($ba12e603ee3d5d8e$var$ia, arguments);
}
function $ba12e603ee3d5d8e$var$ka(a, b, c, d, e, f, g, h, l) {
    $ba12e603ee3d5d8e$var$ja.apply(this, arguments);
    if ($ba12e603ee3d5d8e$var$da) {
        if ($ba12e603ee3d5d8e$var$da) {
            var k = $ba12e603ee3d5d8e$var$ea;
            $ba12e603ee3d5d8e$var$da = !1;
            $ba12e603ee3d5d8e$var$ea = null;
        } else $ba12e603ee3d5d8e$var$x("198"), k = void 0;
        $ba12e603ee3d5d8e$var$fa || ($ba12e603ee3d5d8e$var$fa = !0, $ba12e603ee3d5d8e$var$ha = k);
    }
}
var $ba12e603ee3d5d8e$var$la = null, $ba12e603ee3d5d8e$var$ma = {};
function $ba12e603ee3d5d8e$var$na() {
    if ($ba12e603ee3d5d8e$var$la) for(var a in $ba12e603ee3d5d8e$var$ma){
        var b = $ba12e603ee3d5d8e$var$ma[a], c = $ba12e603ee3d5d8e$var$la.indexOf(a);
        -1 < c || $ba12e603ee3d5d8e$var$x("96", a);
        if (!$ba12e603ee3d5d8e$var$oa[c]) {
            b.extractEvents || $ba12e603ee3d5d8e$var$x("97", a);
            $ba12e603ee3d5d8e$var$oa[c] = b;
            c = b.eventTypes;
            for(var d in c){
                var e = void 0;
                var f = c[d], g = b, h = d;
                $ba12e603ee3d5d8e$var$pa.hasOwnProperty(h) && $ba12e603ee3d5d8e$var$x("99", h);
                $ba12e603ee3d5d8e$var$pa[h] = f;
                var l = f.phasedRegistrationNames;
                if (l) {
                    for(e in l)l.hasOwnProperty(e) && $ba12e603ee3d5d8e$var$qa(l[e], g, h);
                    e = !0;
                } else f.registrationName ? ($ba12e603ee3d5d8e$var$qa(f.registrationName, g, h), e = !0) : e = !1;
                e || $ba12e603ee3d5d8e$var$x("98", d, a);
            }
        }
    }
}
function $ba12e603ee3d5d8e$var$qa(a, b, c) {
    $ba12e603ee3d5d8e$var$ra[a] && $ba12e603ee3d5d8e$var$x("100", a);
    $ba12e603ee3d5d8e$var$ra[a] = b;
    $ba12e603ee3d5d8e$var$sa[a] = b.eventTypes[c].dependencies;
}
var $ba12e603ee3d5d8e$var$oa = [], $ba12e603ee3d5d8e$var$pa = {}, $ba12e603ee3d5d8e$var$ra = {}, $ba12e603ee3d5d8e$var$sa = {}, $ba12e603ee3d5d8e$var$ta = null, $ba12e603ee3d5d8e$var$ua = null, $ba12e603ee3d5d8e$var$va = null;
function $ba12e603ee3d5d8e$var$wa(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = $ba12e603ee3d5d8e$var$va(c);
    $ba12e603ee3d5d8e$var$ka(d, b, void 0, a);
    a.currentTarget = null;
}
function $ba12e603ee3d5d8e$var$xa(a, b) {
    null == b && $ba12e603ee3d5d8e$var$x("30");
    if (null == a) return b;
    if (Array.isArray(a)) {
        if (Array.isArray(b)) return a.push.apply(a, b), a;
        a.push(b);
        return a;
    }
    return Array.isArray(b) ? [
        a
    ].concat(b) : [
        a,
        b
    ];
}
function $ba12e603ee3d5d8e$var$ya(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var $ba12e603ee3d5d8e$var$za = null;
function $ba12e603ee3d5d8e$var$Aa(a) {
    if (a) {
        var b = a._dispatchListeners, c = a._dispatchInstances;
        if (Array.isArray(b)) for(var d = 0; d < b.length && !a.isPropagationStopped(); d++)$ba12e603ee3d5d8e$var$wa(a, b[d], c[d]);
        else b && $ba12e603ee3d5d8e$var$wa(a, b, c);
        a._dispatchListeners = null;
        a._dispatchInstances = null;
        a.isPersistent() || a.constructor.release(a);
    }
}
var $ba12e603ee3d5d8e$var$Ba = {
    injectEventPluginOrder: function(a) {
        $ba12e603ee3d5d8e$var$la && $ba12e603ee3d5d8e$var$x("101");
        $ba12e603ee3d5d8e$var$la = Array.prototype.slice.call(a);
        $ba12e603ee3d5d8e$var$na();
    },
    injectEventPluginsByName: function(a) {
        var b = !1, c;
        for(c in a)if (a.hasOwnProperty(c)) {
            var d = a[c];
            $ba12e603ee3d5d8e$var$ma.hasOwnProperty(c) && $ba12e603ee3d5d8e$var$ma[c] === d || ($ba12e603ee3d5d8e$var$ma[c] && $ba12e603ee3d5d8e$var$x("102", c), $ba12e603ee3d5d8e$var$ma[c] = d, b = !0);
        }
        b && $ba12e603ee3d5d8e$var$na();
    }
};
function $ba12e603ee3d5d8e$var$Ca(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = $ba12e603ee3d5d8e$var$ta(c);
    if (!d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    c && "function" !== typeof c && $ba12e603ee3d5d8e$var$x("231", b, typeof c);
    return c;
}
function $ba12e603ee3d5d8e$var$Da(a) {
    null !== a && ($ba12e603ee3d5d8e$var$za = $ba12e603ee3d5d8e$var$xa($ba12e603ee3d5d8e$var$za, a));
    a = $ba12e603ee3d5d8e$var$za;
    $ba12e603ee3d5d8e$var$za = null;
    if (a && ($ba12e603ee3d5d8e$var$ya(a, $ba12e603ee3d5d8e$var$Aa), $ba12e603ee3d5d8e$var$za && $ba12e603ee3d5d8e$var$x("95"), $ba12e603ee3d5d8e$var$fa)) throw a = $ba12e603ee3d5d8e$var$ha, $ba12e603ee3d5d8e$var$fa = !1, $ba12e603ee3d5d8e$var$ha = null, a;
}
var $ba12e603ee3d5d8e$var$Ea = Math.random().toString(36).slice(2), $ba12e603ee3d5d8e$var$Fa = "__reactInternalInstance$" + $ba12e603ee3d5d8e$var$Ea, $ba12e603ee3d5d8e$var$Ga = "__reactEventHandlers$" + $ba12e603ee3d5d8e$var$Ea;
function $ba12e603ee3d5d8e$var$Ha(a) {
    if (a[$ba12e603ee3d5d8e$var$Fa]) return a[$ba12e603ee3d5d8e$var$Fa];
    for(; !a[$ba12e603ee3d5d8e$var$Fa];)if (a.parentNode) a = a.parentNode;
    else return null;
    a = a[$ba12e603ee3d5d8e$var$Fa];
    return 5 === a.tag || 6 === a.tag ? a : null;
}
function $ba12e603ee3d5d8e$var$Ia(a) {
    a = a[$ba12e603ee3d5d8e$var$Fa];
    return !a || 5 !== a.tag && 6 !== a.tag ? null : a;
}
function $ba12e603ee3d5d8e$var$Ja(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    $ba12e603ee3d5d8e$var$x("33");
}
function $ba12e603ee3d5d8e$var$Ka(a) {
    return a[$ba12e603ee3d5d8e$var$Ga] || null;
}
function $ba12e603ee3d5d8e$var$La(a) {
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $ba12e603ee3d5d8e$var$Ma(a, b, c) {
    if (b = $ba12e603ee3d5d8e$var$Ca(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = $ba12e603ee3d5d8e$var$xa(c._dispatchListeners, b), c._dispatchInstances = $ba12e603ee3d5d8e$var$xa(c._dispatchInstances, a);
}
function $ba12e603ee3d5d8e$var$Na(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
        for(var b = a._targetInst, c = []; b;)c.push(b), b = $ba12e603ee3d5d8e$var$La(b);
        for(b = c.length; 0 < b--;)$ba12e603ee3d5d8e$var$Ma(c[b], "captured", a);
        for(b = 0; b < c.length; b++)$ba12e603ee3d5d8e$var$Ma(c[b], "bubbled", a);
    }
}
function $ba12e603ee3d5d8e$var$Oa(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = $ba12e603ee3d5d8e$var$Ca(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = $ba12e603ee3d5d8e$var$xa(c._dispatchListeners, b), c._dispatchInstances = $ba12e603ee3d5d8e$var$xa(c._dispatchInstances, a));
}
function $ba12e603ee3d5d8e$var$Pa(a) {
    a && a.dispatchConfig.registrationName && $ba12e603ee3d5d8e$var$Oa(a._targetInst, null, a);
}
function $ba12e603ee3d5d8e$var$Qa(a) {
    $ba12e603ee3d5d8e$var$ya(a, $ba12e603ee3d5d8e$var$Na);
}
var $ba12e603ee3d5d8e$var$Ra = !("undefined" === typeof window || !window.document || !window.document.createElement);
function $ba12e603ee3d5d8e$var$Sa(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $ba12e603ee3d5d8e$var$Ta = {
    animationend: $ba12e603ee3d5d8e$var$Sa("Animation", "AnimationEnd"),
    animationiteration: $ba12e603ee3d5d8e$var$Sa("Animation", "AnimationIteration"),
    animationstart: $ba12e603ee3d5d8e$var$Sa("Animation", "AnimationStart"),
    transitionend: $ba12e603ee3d5d8e$var$Sa("Transition", "TransitionEnd")
}, $ba12e603ee3d5d8e$var$Ua = {}, $ba12e603ee3d5d8e$var$Va = {};
$ba12e603ee3d5d8e$var$Ra && ($ba12e603ee3d5d8e$var$Va = document.createElement("div").style, "AnimationEvent" in window || (delete $ba12e603ee3d5d8e$var$Ta.animationend.animation, delete $ba12e603ee3d5d8e$var$Ta.animationiteration.animation, delete $ba12e603ee3d5d8e$var$Ta.animationstart.animation), "TransitionEvent" in window || delete $ba12e603ee3d5d8e$var$Ta.transitionend.transition);
function $ba12e603ee3d5d8e$var$Wa(a) {
    if ($ba12e603ee3d5d8e$var$Ua[a]) return $ba12e603ee3d5d8e$var$Ua[a];
    if (!$ba12e603ee3d5d8e$var$Ta[a]) return a;
    var b = $ba12e603ee3d5d8e$var$Ta[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $ba12e603ee3d5d8e$var$Va) return $ba12e603ee3d5d8e$var$Ua[a] = b[c];
    return a;
}
var $ba12e603ee3d5d8e$var$Xa = $ba12e603ee3d5d8e$var$Wa("animationend"), $ba12e603ee3d5d8e$var$Ya = $ba12e603ee3d5d8e$var$Wa("animationiteration"), $ba12e603ee3d5d8e$var$Za = $ba12e603ee3d5d8e$var$Wa("animationstart"), $ba12e603ee3d5d8e$var$$a = $ba12e603ee3d5d8e$var$Wa("transitionend"), $ba12e603ee3d5d8e$var$ab = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $ba12e603ee3d5d8e$var$bb = null, $ba12e603ee3d5d8e$var$cb = null, $ba12e603ee3d5d8e$var$db = null;
function $ba12e603ee3d5d8e$var$eb() {
    if ($ba12e603ee3d5d8e$var$db) return $ba12e603ee3d5d8e$var$db;
    var a, b = $ba12e603ee3d5d8e$var$cb, c = b.length, d, e = "value" in $ba12e603ee3d5d8e$var$bb ? $ba12e603ee3d5d8e$var$bb.value : $ba12e603ee3d5d8e$var$bb.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $ba12e603ee3d5d8e$var$db = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $ba12e603ee3d5d8e$var$fb() {
    return !0;
}
function $ba12e603ee3d5d8e$var$gb() {
    return !1;
}
function $ba12e603ee3d5d8e$var$y(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;
    for(var e in a)a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? $ba12e603ee3d5d8e$var$fb : $ba12e603ee3d5d8e$var$gb;
    this.isPropagationStopped = $ba12e603ee3d5d8e$var$gb;
    return this;
}
$63ReS($ba12e603ee3d5d8e$var$y.prototype, {
    preventDefault: function() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $ba12e603ee3d5d8e$var$fb);
    },
    stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $ba12e603ee3d5d8e$var$fb);
    },
    persist: function() {
        this.isPersistent = $ba12e603ee3d5d8e$var$fb;
    },
    isPersistent: $ba12e603ee3d5d8e$var$gb,
    destructor: function() {
        var a = this.constructor.Interface, b;
        for(b in a)this[b] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null;
        this.isPropagationStopped = this.isDefaultPrevented = $ba12e603ee3d5d8e$var$gb;
        this._dispatchInstances = this._dispatchListeners = null;
    }
});
$ba12e603ee3d5d8e$var$y.Interface = {
    type: null,
    target: null,
    currentTarget: function() {
        return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
};
$ba12e603ee3d5d8e$var$y.extend = function(a) {
    function b() {}
    function c() {
        return d.apply(this, arguments);
    }
    var d = this;
    b.prototype = d.prototype;
    var e = new b;
    $63ReS(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = $63ReS({}, d.Interface, a);
    c.extend = d.extend;
    $ba12e603ee3d5d8e$var$hb(c);
    return c;
};
$ba12e603ee3d5d8e$var$hb($ba12e603ee3d5d8e$var$y);
function $ba12e603ee3d5d8e$var$ib(a, b, c, d) {
    if (this.eventPool.length) {
        var e = this.eventPool.pop();
        this.call(e, a, b, c, d);
        return e;
    }
    return new this(a, b, c, d);
}
function $ba12e603ee3d5d8e$var$jb(a) {
    a instanceof this || $ba12e603ee3d5d8e$var$x("279");
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
}
function $ba12e603ee3d5d8e$var$hb(a) {
    a.eventPool = [];
    a.getPooled = $ba12e603ee3d5d8e$var$ib;
    a.release = $ba12e603ee3d5d8e$var$jb;
}
var $ba12e603ee3d5d8e$var$kb = $ba12e603ee3d5d8e$var$y.extend({
    data: null
}), $ba12e603ee3d5d8e$var$lb = $ba12e603ee3d5d8e$var$y.extend({
    data: null
}), $ba12e603ee3d5d8e$var$mb = [
    9,
    13,
    27,
    32
], $ba12e603ee3d5d8e$var$nb = $ba12e603ee3d5d8e$var$Ra && "CompositionEvent" in window, $ba12e603ee3d5d8e$var$ob = null;
$ba12e603ee3d5d8e$var$Ra && "documentMode" in document && ($ba12e603ee3d5d8e$var$ob = document.documentMode);
var $ba12e603ee3d5d8e$var$pb = $ba12e603ee3d5d8e$var$Ra && "TextEvent" in window && !$ba12e603ee3d5d8e$var$ob, $ba12e603ee3d5d8e$var$qb = $ba12e603ee3d5d8e$var$Ra && (!$ba12e603ee3d5d8e$var$nb || $ba12e603ee3d5d8e$var$ob && 8 < $ba12e603ee3d5d8e$var$ob && 11 >= $ba12e603ee3d5d8e$var$ob), $ba12e603ee3d5d8e$var$rb = String.fromCharCode(32), $ba12e603ee3d5d8e$var$sb = {
    beforeInput: {
        phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
        },
        dependencies: [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]
    },
    compositionEnd: {
        phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
        },
        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
        phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
        },
        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
        phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
        },
        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
}, $ba12e603ee3d5d8e$var$tb = !1;
function $ba12e603ee3d5d8e$var$ub(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $ba12e603ee3d5d8e$var$mb.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "blur":
            return !0;
        default:
            return !1;
    }
}
function $ba12e603ee3d5d8e$var$vb(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $ba12e603ee3d5d8e$var$wb = !1;
function $ba12e603ee3d5d8e$var$xb(a, b) {
    switch(a){
        case "compositionend":
            return $ba12e603ee3d5d8e$var$vb(b);
        case "keypress":
            if (32 !== b.which) return null;
            $ba12e603ee3d5d8e$var$tb = !0;
            return $ba12e603ee3d5d8e$var$rb;
        case "textInput":
            return a = b.data, a === $ba12e603ee3d5d8e$var$rb && $ba12e603ee3d5d8e$var$tb ? null : a;
        default:
            return null;
    }
}
function $ba12e603ee3d5d8e$var$yb(a, b) {
    if ($ba12e603ee3d5d8e$var$wb) return "compositionend" === a || !$ba12e603ee3d5d8e$var$nb && $ba12e603ee3d5d8e$var$ub(a, b) ? (a = $ba12e603ee3d5d8e$var$eb(), $ba12e603ee3d5d8e$var$db = $ba12e603ee3d5d8e$var$cb = $ba12e603ee3d5d8e$var$bb = null, $ba12e603ee3d5d8e$var$wb = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $ba12e603ee3d5d8e$var$qb && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $ba12e603ee3d5d8e$var$zb = {
    eventTypes: $ba12e603ee3d5d8e$var$sb,
    extractEvents: function(a, b, c, d) {
        var e = void 0;
        var f = void 0;
        if ($ba12e603ee3d5d8e$var$nb) b: {
            switch(a){
                case "compositionstart":
                    e = $ba12e603ee3d5d8e$var$sb.compositionStart;
                    break b;
                case "compositionend":
                    e = $ba12e603ee3d5d8e$var$sb.compositionEnd;
                    break b;
                case "compositionupdate":
                    e = $ba12e603ee3d5d8e$var$sb.compositionUpdate;
                    break b;
            }
            e = void 0;
        }
        else $ba12e603ee3d5d8e$var$wb ? $ba12e603ee3d5d8e$var$ub(a, c) && (e = $ba12e603ee3d5d8e$var$sb.compositionEnd) : "keydown" === a && 229 === c.keyCode && (e = $ba12e603ee3d5d8e$var$sb.compositionStart);
        e ? ($ba12e603ee3d5d8e$var$qb && "ko" !== c.locale && ($ba12e603ee3d5d8e$var$wb || e !== $ba12e603ee3d5d8e$var$sb.compositionStart ? e === $ba12e603ee3d5d8e$var$sb.compositionEnd && $ba12e603ee3d5d8e$var$wb && (f = $ba12e603ee3d5d8e$var$eb()) : ($ba12e603ee3d5d8e$var$bb = d, $ba12e603ee3d5d8e$var$cb = "value" in $ba12e603ee3d5d8e$var$bb ? $ba12e603ee3d5d8e$var$bb.value : $ba12e603ee3d5d8e$var$bb.textContent, $ba12e603ee3d5d8e$var$wb = !0)), e = $ba12e603ee3d5d8e$var$kb.getPooled(e, b, c, d), f ? e.data = f : (f = $ba12e603ee3d5d8e$var$vb(c), null !== f && (e.data = f)), $ba12e603ee3d5d8e$var$Qa(e), f = e) : f = null;
        (a = $ba12e603ee3d5d8e$var$pb ? $ba12e603ee3d5d8e$var$xb(a, c) : $ba12e603ee3d5d8e$var$yb(a, c)) ? (b = $ba12e603ee3d5d8e$var$lb.getPooled($ba12e603ee3d5d8e$var$sb.beforeInput, b, c, d), b.data = a, $ba12e603ee3d5d8e$var$Qa(b)) : b = null;
        return null === f ? b : null === b ? f : [
            f,
            b
        ];
    }
}, $ba12e603ee3d5d8e$var$Ab = null, $ba12e603ee3d5d8e$var$Bb = null, $ba12e603ee3d5d8e$var$Cb = null;
function $ba12e603ee3d5d8e$var$Db(a) {
    if (a = $ba12e603ee3d5d8e$var$ua(a)) {
        "function" !== typeof $ba12e603ee3d5d8e$var$Ab && $ba12e603ee3d5d8e$var$x("280");
        var b = $ba12e603ee3d5d8e$var$ta(a.stateNode);
        $ba12e603ee3d5d8e$var$Ab(a.stateNode, a.type, b);
    }
}
function $ba12e603ee3d5d8e$var$Eb(a) {
    $ba12e603ee3d5d8e$var$Bb ? $ba12e603ee3d5d8e$var$Cb ? $ba12e603ee3d5d8e$var$Cb.push(a) : $ba12e603ee3d5d8e$var$Cb = [
        a
    ] : $ba12e603ee3d5d8e$var$Bb = a;
}
function $ba12e603ee3d5d8e$var$Fb() {
    if ($ba12e603ee3d5d8e$var$Bb) {
        var a = $ba12e603ee3d5d8e$var$Bb, b = $ba12e603ee3d5d8e$var$Cb;
        $ba12e603ee3d5d8e$var$Cb = $ba12e603ee3d5d8e$var$Bb = null;
        $ba12e603ee3d5d8e$var$Db(a);
        if (b) for(a = 0; a < b.length; a++)$ba12e603ee3d5d8e$var$Db(b[a]);
    }
}
function $ba12e603ee3d5d8e$var$Gb(a, b) {
    return a(b);
}
function $ba12e603ee3d5d8e$var$Hb(a, b, c) {
    return a(b, c);
}
function $ba12e603ee3d5d8e$var$Ib() {}
var $ba12e603ee3d5d8e$var$Jb = !1;
function $ba12e603ee3d5d8e$var$Kb(a, b) {
    if ($ba12e603ee3d5d8e$var$Jb) return a(b);
    $ba12e603ee3d5d8e$var$Jb = !0;
    try {
        return $ba12e603ee3d5d8e$var$Gb(a, b);
    } finally{
        if ($ba12e603ee3d5d8e$var$Jb = !1, null !== $ba12e603ee3d5d8e$var$Bb || null !== $ba12e603ee3d5d8e$var$Cb) $ba12e603ee3d5d8e$var$Ib(), $ba12e603ee3d5d8e$var$Fb();
    }
}
var $ba12e603ee3d5d8e$var$Lb = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $ba12e603ee3d5d8e$var$Mb(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$ba12e603ee3d5d8e$var$Lb[a.type] : "textarea" === b ? !0 : !1;
}
function $ba12e603ee3d5d8e$var$Nb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
function $ba12e603ee3d5d8e$var$Ob(a) {
    if (!$ba12e603ee3d5d8e$var$Ra) return !1;
    a = "on" + a;
    var b = a in document;
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
}
function $ba12e603ee3d5d8e$var$Pb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $ba12e603ee3d5d8e$var$Qb(a) {
    var b = $ba12e603ee3d5d8e$var$Pb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $ba12e603ee3d5d8e$var$Rb(a) {
    a._valueTracker || (a._valueTracker = $ba12e603ee3d5d8e$var$Qb(a));
}
function $ba12e603ee3d5d8e$var$Sb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $ba12e603ee3d5d8e$var$Pb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
var $ba12e603ee3d5d8e$var$Tb = $6wXVr.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
$ba12e603ee3d5d8e$var$Tb.hasOwnProperty("ReactCurrentDispatcher") || ($ba12e603ee3d5d8e$var$Tb.ReactCurrentDispatcher = {
    current: null
});
var $ba12e603ee3d5d8e$var$Ub = /^(.*)[\\\/]/, $ba12e603ee3d5d8e$var$z = "function" === typeof Symbol && Symbol.for, $ba12e603ee3d5d8e$var$Vb = $ba12e603ee3d5d8e$var$z ? Symbol.for("react.element") : 60103, $ba12e603ee3d5d8e$var$Wb = $ba12e603ee3d5d8e$var$z ? Symbol.for("react.portal") : 60106, $ba12e603ee3d5d8e$var$Xb = $ba12e603ee3d5d8e$var$z ? Symbol.for("react.fragment") : 60107, $ba12e603ee3d5d8e$var$Yb = $ba12e603ee3d5d8e$var$z ? Symbol.for("react.strict_mode") : 60108, $ba12e603ee3d5d8e$var$Zb = $ba12e603ee3d5d8e$var$z ? Symbol.for("react.profiler") : 60114, $ba12e603ee3d5d8e$var$$b = $ba12e603ee3d5d8e$var$z ? Symbol.for("react.provider") : 60109, $ba12e603ee3d5d8e$var$ac = $ba12e603ee3d5d8e$var$z ? Symbol.for("react.context") : 60110, $ba12e603ee3d5d8e$var$bc = $ba12e603ee3d5d8e$var$z ? Symbol.for("react.concurrent_mode") : 60111, $ba12e603ee3d5d8e$var$cc = $ba12e603ee3d5d8e$var$z ? Symbol.for("react.forward_ref") : 60112, $ba12e603ee3d5d8e$var$dc = $ba12e603ee3d5d8e$var$z ? Symbol.for("react.suspense") : 60113, $ba12e603ee3d5d8e$var$ec = $ba12e603ee3d5d8e$var$z ? Symbol.for("react.memo") : 60115, $ba12e603ee3d5d8e$var$fc = $ba12e603ee3d5d8e$var$z ? Symbol.for("react.lazy") : 60116, $ba12e603ee3d5d8e$var$gc = "function" === typeof Symbol && Symbol.iterator;
function $ba12e603ee3d5d8e$var$hc(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $ba12e603ee3d5d8e$var$gc && a[$ba12e603ee3d5d8e$var$gc] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $ba12e603ee3d5d8e$var$ic(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $ba12e603ee3d5d8e$var$bc:
            return "ConcurrentMode";
        case $ba12e603ee3d5d8e$var$Xb:
            return "Fragment";
        case $ba12e603ee3d5d8e$var$Wb:
            return "Portal";
        case $ba12e603ee3d5d8e$var$Zb:
            return "Profiler";
        case $ba12e603ee3d5d8e$var$Yb:
            return "StrictMode";
        case $ba12e603ee3d5d8e$var$dc:
            return "Suspense";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $ba12e603ee3d5d8e$var$ac:
            return "Context.Consumer";
        case $ba12e603ee3d5d8e$var$$b:
            return "Context.Provider";
        case $ba12e603ee3d5d8e$var$cc:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case $ba12e603ee3d5d8e$var$ec:
            return $ba12e603ee3d5d8e$var$ic(a.type);
        case $ba12e603ee3d5d8e$var$fc:
            if (a = 1 === a._status ? a._result : null) return $ba12e603ee3d5d8e$var$ic(a);
    }
    return null;
}
function $ba12e603ee3d5d8e$var$jc(a) {
    var b = "";
    do {
        a: switch(a.tag){
            case 3:
            case 4:
            case 6:
            case 7:
            case 10:
            case 9:
                var c = "";
                break a;
            default:
                var d = a._debugOwner, e = a._debugSource, f = $ba12e603ee3d5d8e$var$ic(a.type);
                c = null;
                d && (c = $ba12e603ee3d5d8e$var$ic(d.type));
                d = f;
                f = "";
                e ? f = " (at " + e.fileName.replace($ba12e603ee3d5d8e$var$Ub, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                c = "\n    in " + (d || "Unknown") + f;
        }
        b += c;
        a = a.return;
    }while (a);
    return b;
}
var $ba12e603ee3d5d8e$var$kc = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $ba12e603ee3d5d8e$var$lc = Object.prototype.hasOwnProperty, $ba12e603ee3d5d8e$var$mc = {}, $ba12e603ee3d5d8e$var$nc = {};
function $ba12e603ee3d5d8e$var$oc(a) {
    if ($ba12e603ee3d5d8e$var$lc.call($ba12e603ee3d5d8e$var$nc, a)) return !0;
    if ($ba12e603ee3d5d8e$var$lc.call($ba12e603ee3d5d8e$var$mc, a)) return !1;
    if ($ba12e603ee3d5d8e$var$kc.test(a)) return $ba12e603ee3d5d8e$var$nc[a] = !0;
    $ba12e603ee3d5d8e$var$mc[a] = !0;
    return !1;
}
function $ba12e603ee3d5d8e$var$pc(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $ba12e603ee3d5d8e$var$qc(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $ba12e603ee3d5d8e$var$pc(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $ba12e603ee3d5d8e$var$C(a, b, c, d, e) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
}
var $ba12e603ee3d5d8e$var$D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $ba12e603ee3d5d8e$var$D[a] = new $ba12e603ee3d5d8e$var$C(a, 0, !1, a, null);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $ba12e603ee3d5d8e$var$D[b] = new $ba12e603ee3d5d8e$var$C(b, 1, !1, a[1], null);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $ba12e603ee3d5d8e$var$D[a] = new $ba12e603ee3d5d8e$var$C(a, 2, !1, a.toLowerCase(), null);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $ba12e603ee3d5d8e$var$D[a] = new $ba12e603ee3d5d8e$var$C(a, 2, !1, a, null);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $ba12e603ee3d5d8e$var$D[a] = new $ba12e603ee3d5d8e$var$C(a, 3, !1, a.toLowerCase(), null);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $ba12e603ee3d5d8e$var$D[a] = new $ba12e603ee3d5d8e$var$C(a, 3, !0, a, null);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $ba12e603ee3d5d8e$var$D[a] = new $ba12e603ee3d5d8e$var$C(a, 4, !1, a, null);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $ba12e603ee3d5d8e$var$D[a] = new $ba12e603ee3d5d8e$var$C(a, 6, !1, a, null);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $ba12e603ee3d5d8e$var$D[a] = new $ba12e603ee3d5d8e$var$C(a, 5, !1, a.toLowerCase(), null);
});
var $ba12e603ee3d5d8e$var$rc = /[\-:]([a-z])/g;
function $ba12e603ee3d5d8e$var$sc(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($ba12e603ee3d5d8e$var$rc, $ba12e603ee3d5d8e$var$sc);
    $ba12e603ee3d5d8e$var$D[b] = new $ba12e603ee3d5d8e$var$C(b, 1, !1, a, null);
});
"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($ba12e603ee3d5d8e$var$rc, $ba12e603ee3d5d8e$var$sc);
    $ba12e603ee3d5d8e$var$D[b] = new $ba12e603ee3d5d8e$var$C(b, 1, !1, a, "http://www.w3.org/1999/xlink");
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($ba12e603ee3d5d8e$var$rc, $ba12e603ee3d5d8e$var$sc);
    $ba12e603ee3d5d8e$var$D[b] = new $ba12e603ee3d5d8e$var$C(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace");
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $ba12e603ee3d5d8e$var$D[a] = new $ba12e603ee3d5d8e$var$C(a, 1, !1, a.toLowerCase(), null);
});
function $ba12e603ee3d5d8e$var$tc(a, b, c, d) {
    var e = $ba12e603ee3d5d8e$var$D.hasOwnProperty(b) ? $ba12e603ee3d5d8e$var$D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || ($ba12e603ee3d5d8e$var$qc(b, c, e, d) && (c = null), d || null === e ? $ba12e603ee3d5d8e$var$oc(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
function $ba12e603ee3d5d8e$var$uc(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function $ba12e603ee3d5d8e$var$vc(a, b) {
    var c = b.checked;
    return $63ReS({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $ba12e603ee3d5d8e$var$wc(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $ba12e603ee3d5d8e$var$uc(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $ba12e603ee3d5d8e$var$xc(a, b) {
    b = b.checked;
    null != b && $ba12e603ee3d5d8e$var$tc(a, "checked", b, !1);
}
function $ba12e603ee3d5d8e$var$yc(a, b) {
    $ba12e603ee3d5d8e$var$xc(a, b);
    var c = $ba12e603ee3d5d8e$var$uc(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $ba12e603ee3d5d8e$var$zc(a, b.type, c) : b.hasOwnProperty("defaultValue") && $ba12e603ee3d5d8e$var$zc(a, b.type, $ba12e603ee3d5d8e$var$uc(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $ba12e603ee3d5d8e$var$Ac(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !a.defaultChecked;
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $ba12e603ee3d5d8e$var$zc(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $ba12e603ee3d5d8e$var$Bc = {
    change: {
        phasedRegistrationNames: {
            bubbled: "onChange",
            captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
};
function $ba12e603ee3d5d8e$var$Cc(a, b, c) {
    a = $ba12e603ee3d5d8e$var$y.getPooled($ba12e603ee3d5d8e$var$Bc.change, a, b, c);
    a.type = "change";
    $ba12e603ee3d5d8e$var$Eb(c);
    $ba12e603ee3d5d8e$var$Qa(a);
    return a;
}
var $ba12e603ee3d5d8e$var$Dc = null, $ba12e603ee3d5d8e$var$Ec = null;
function $ba12e603ee3d5d8e$var$Fc(a) {
    $ba12e603ee3d5d8e$var$Da(a);
}
function $ba12e603ee3d5d8e$var$Gc(a) {
    var b = $ba12e603ee3d5d8e$var$Ja(a);
    if ($ba12e603ee3d5d8e$var$Sb(b)) return a;
}
function $ba12e603ee3d5d8e$var$Hc(a, b) {
    if ("change" === a) return b;
}
var $ba12e603ee3d5d8e$var$Ic = !1;
$ba12e603ee3d5d8e$var$Ra && ($ba12e603ee3d5d8e$var$Ic = $ba12e603ee3d5d8e$var$Ob("input") && (!document.documentMode || 9 < document.documentMode));
function $ba12e603ee3d5d8e$var$Jc() {
    $ba12e603ee3d5d8e$var$Dc && ($ba12e603ee3d5d8e$var$Dc.detachEvent("onpropertychange", $ba12e603ee3d5d8e$var$Kc), $ba12e603ee3d5d8e$var$Ec = $ba12e603ee3d5d8e$var$Dc = null);
}
function $ba12e603ee3d5d8e$var$Kc(a) {
    "value" === a.propertyName && $ba12e603ee3d5d8e$var$Gc($ba12e603ee3d5d8e$var$Ec) && (a = $ba12e603ee3d5d8e$var$Cc($ba12e603ee3d5d8e$var$Ec, a, $ba12e603ee3d5d8e$var$Nb(a)), $ba12e603ee3d5d8e$var$Kb($ba12e603ee3d5d8e$var$Fc, a));
}
function $ba12e603ee3d5d8e$var$Lc(a, b, c) {
    "focus" === a ? ($ba12e603ee3d5d8e$var$Jc(), $ba12e603ee3d5d8e$var$Dc = b, $ba12e603ee3d5d8e$var$Ec = c, $ba12e603ee3d5d8e$var$Dc.attachEvent("onpropertychange", $ba12e603ee3d5d8e$var$Kc)) : "blur" === a && $ba12e603ee3d5d8e$var$Jc();
}
function $ba12e603ee3d5d8e$var$Mc(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $ba12e603ee3d5d8e$var$Gc($ba12e603ee3d5d8e$var$Ec);
}
function $ba12e603ee3d5d8e$var$Nc(a, b) {
    if ("click" === a) return $ba12e603ee3d5d8e$var$Gc(b);
}
function $ba12e603ee3d5d8e$var$Oc(a, b) {
    if ("input" === a || "change" === a) return $ba12e603ee3d5d8e$var$Gc(b);
}
var $ba12e603ee3d5d8e$var$Pc = {
    eventTypes: $ba12e603ee3d5d8e$var$Bc,
    _isInputEventSupported: $ba12e603ee3d5d8e$var$Ic,
    extractEvents: function(a, b, c, d) {
        var e = b ? $ba12e603ee3d5d8e$var$Ja(b) : window, f = void 0, g = void 0, h = e.nodeName && e.nodeName.toLowerCase();
        "select" === h || "input" === h && "file" === e.type ? f = $ba12e603ee3d5d8e$var$Hc : $ba12e603ee3d5d8e$var$Mb(e) ? $ba12e603ee3d5d8e$var$Ic ? f = $ba12e603ee3d5d8e$var$Oc : (f = $ba12e603ee3d5d8e$var$Mc, g = $ba12e603ee3d5d8e$var$Lc) : (h = e.nodeName) && "input" === h.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (f = $ba12e603ee3d5d8e$var$Nc);
        if (f && (f = f(a, b))) return $ba12e603ee3d5d8e$var$Cc(f, c, d);
        g && g(a, e, b);
        "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && $ba12e603ee3d5d8e$var$zc(e, "number", e.value);
    }
}, $ba12e603ee3d5d8e$var$Qc = $ba12e603ee3d5d8e$var$y.extend({
    view: null,
    detail: null
}), $ba12e603ee3d5d8e$var$Rc = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $ba12e603ee3d5d8e$var$Sc(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $ba12e603ee3d5d8e$var$Rc[a]) ? !!b[a] : !1;
}
function $ba12e603ee3d5d8e$var$Tc() {
    return $ba12e603ee3d5d8e$var$Sc;
}
var $ba12e603ee3d5d8e$var$Uc = 0, $ba12e603ee3d5d8e$var$Vc = 0, $ba12e603ee3d5d8e$var$Wc = !1, $ba12e603ee3d5d8e$var$Xc = !1, $ba12e603ee3d5d8e$var$Yc = $ba12e603ee3d5d8e$var$Qc.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: $ba12e603ee3d5d8e$var$Tc,
    button: null,
    buttons: null,
    relatedTarget: function(a) {
        return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        var b = $ba12e603ee3d5d8e$var$Uc;
        $ba12e603ee3d5d8e$var$Uc = a.screenX;
        return $ba12e603ee3d5d8e$var$Wc ? "mousemove" === a.type ? a.screenX - b : 0 : ($ba12e603ee3d5d8e$var$Wc = !0, 0);
    },
    movementY: function(a) {
        if ("movementY" in a) return a.movementY;
        var b = $ba12e603ee3d5d8e$var$Vc;
        $ba12e603ee3d5d8e$var$Vc = a.screenY;
        return $ba12e603ee3d5d8e$var$Xc ? "mousemove" === a.type ? a.screenY - b : 0 : ($ba12e603ee3d5d8e$var$Xc = !0, 0);
    }
}), $ba12e603ee3d5d8e$var$Zc = $ba12e603ee3d5d8e$var$Yc.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
}), $ba12e603ee3d5d8e$var$$c = {
    mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    pointerEnter: {
        registrationName: "onPointerEnter",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    },
    pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    }
}, $ba12e603ee3d5d8e$var$ad = {
    eventTypes: $ba12e603ee3d5d8e$var$$c,
    extractEvents: function(a, b, c, d) {
        var e = "mouseover" === a || "pointerover" === a, f = "mouseout" === a || "pointerout" === a;
        if (e && (c.relatedTarget || c.fromElement) || !f && !e) return null;
        e = d.window === d ? d : (e = d.ownerDocument) ? e.defaultView || e.parentWindow : window;
        f ? (f = b, b = (b = c.relatedTarget || c.toElement) ? $ba12e603ee3d5d8e$var$Ha(b) : null) : f = null;
        if (f === b) return null;
        var g = void 0, h = void 0, l = void 0, k = void 0;
        if ("mouseout" === a || "mouseover" === a) g = $ba12e603ee3d5d8e$var$Yc, h = $ba12e603ee3d5d8e$var$$c.mouseLeave, l = $ba12e603ee3d5d8e$var$$c.mouseEnter, k = "mouse";
        else if ("pointerout" === a || "pointerover" === a) g = $ba12e603ee3d5d8e$var$Zc, h = $ba12e603ee3d5d8e$var$$c.pointerLeave, l = $ba12e603ee3d5d8e$var$$c.pointerEnter, k = "pointer";
        var m = null == f ? e : $ba12e603ee3d5d8e$var$Ja(f);
        e = null == b ? e : $ba12e603ee3d5d8e$var$Ja(b);
        a = g.getPooled(h, f, c, d);
        a.type = k + "leave";
        a.target = m;
        a.relatedTarget = e;
        c = g.getPooled(l, b, c, d);
        c.type = k + "enter";
        c.target = e;
        c.relatedTarget = m;
        d = b;
        if (f && d) a: {
            b = f;
            e = d;
            k = 0;
            for(g = b; g; g = $ba12e603ee3d5d8e$var$La(g))k++;
            g = 0;
            for(l = e; l; l = $ba12e603ee3d5d8e$var$La(l))g++;
            for(; 0 < k - g;)b = $ba12e603ee3d5d8e$var$La(b), k--;
            for(; 0 < g - k;)e = $ba12e603ee3d5d8e$var$La(e), g--;
            for(; k--;){
                if (b === e || b === e.alternate) break a;
                b = $ba12e603ee3d5d8e$var$La(b);
                e = $ba12e603ee3d5d8e$var$La(e);
            }
            b = null;
        }
        else b = null;
        e = b;
        for(b = []; f && f !== e;){
            k = f.alternate;
            if (null !== k && k === e) break;
            b.push(f);
            f = $ba12e603ee3d5d8e$var$La(f);
        }
        for(f = []; d && d !== e;){
            k = d.alternate;
            if (null !== k && k === e) break;
            f.push(d);
            d = $ba12e603ee3d5d8e$var$La(d);
        }
        for(d = 0; d < b.length; d++)$ba12e603ee3d5d8e$var$Oa(b[d], "bubbled", a);
        for(d = f.length; 0 < d--;)$ba12e603ee3d5d8e$var$Oa(f[d], "captured", c);
        return [
            a,
            c
        ];
    }
};
function $ba12e603ee3d5d8e$var$bd(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $ba12e603ee3d5d8e$var$cd = Object.prototype.hasOwnProperty;
function $ba12e603ee3d5d8e$var$dd(a, b) {
    if ($ba12e603ee3d5d8e$var$bd(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!$ba12e603ee3d5d8e$var$cd.call(b, c[d]) || !$ba12e603ee3d5d8e$var$bd(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function $ba12e603ee3d5d8e$var$ed(a) {
    var b = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        if (0 !== (b.effectTag & 2)) return 1;
        for(; b.return;)if (b = b.return, 0 !== (b.effectTag & 2)) return 1;
    }
    return 3 === b.tag ? 2 : 3;
}
function $ba12e603ee3d5d8e$var$fd(a) {
    2 !== $ba12e603ee3d5d8e$var$ed(a) && $ba12e603ee3d5d8e$var$x("188");
}
function $ba12e603ee3d5d8e$var$gd(a) {
    var b = a.alternate;
    if (!b) return b = $ba12e603ee3d5d8e$var$ed(a), 3 === b && $ba12e603ee3d5d8e$var$x("188"), 1 === b ? null : a;
    for(var c = a, d = b;;){
        var e = c.return, f = e ? e.alternate : null;
        if (!e || !f) break;
        if (e.child === f.child) {
            for(var g = e.child; g;){
                if (g === c) return $ba12e603ee3d5d8e$var$fd(e), a;
                if (g === d) return $ba12e603ee3d5d8e$var$fd(e), b;
                g = g.sibling;
            }
            $ba12e603ee3d5d8e$var$x("188");
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            g = !1;
            for(var h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                g || $ba12e603ee3d5d8e$var$x("189");
            }
        }
        c.alternate !== d && $ba12e603ee3d5d8e$var$x("190");
    }
    3 !== c.tag && $ba12e603ee3d5d8e$var$x("188");
    return c.stateNode.current === c ? a : b;
}
function $ba12e603ee3d5d8e$var$hd(a) {
    a = $ba12e603ee3d5d8e$var$gd(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
var $ba12e603ee3d5d8e$var$id = $ba12e603ee3d5d8e$var$y.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
}), $ba12e603ee3d5d8e$var$jd = $ba12e603ee3d5d8e$var$y.extend({
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $ba12e603ee3d5d8e$var$kd = $ba12e603ee3d5d8e$var$Qc.extend({
    relatedTarget: null
});
function $ba12e603ee3d5d8e$var$ld(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
var $ba12e603ee3d5d8e$var$md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $ba12e603ee3d5d8e$var$nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $ba12e603ee3d5d8e$var$od = $ba12e603ee3d5d8e$var$Qc.extend({
    key: function(a) {
        if (a.key) {
            var b = $ba12e603ee3d5d8e$var$md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $ba12e603ee3d5d8e$var$ld(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $ba12e603ee3d5d8e$var$nd[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: $ba12e603ee3d5d8e$var$Tc,
    charCode: function(a) {
        return "keypress" === a.type ? $ba12e603ee3d5d8e$var$ld(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $ba12e603ee3d5d8e$var$ld(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $ba12e603ee3d5d8e$var$pd = $ba12e603ee3d5d8e$var$Yc.extend({
    dataTransfer: null
}), $ba12e603ee3d5d8e$var$qd = $ba12e603ee3d5d8e$var$Qc.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: $ba12e603ee3d5d8e$var$Tc
}), $ba12e603ee3d5d8e$var$rd = $ba12e603ee3d5d8e$var$y.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
}), $ba12e603ee3d5d8e$var$sd = $ba12e603ee3d5d8e$var$Yc.extend({
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
}), $ba12e603ee3d5d8e$var$td = [
    [
        "abort",
        "abort"
    ],
    [
        $ba12e603ee3d5d8e$var$Xa,
        "animationEnd"
    ],
    [
        $ba12e603ee3d5d8e$var$Ya,
        "animationIteration"
    ],
    [
        $ba12e603ee3d5d8e$var$Za,
        "animationStart"
    ],
    [
        "canplay",
        "canPlay"
    ],
    [
        "canplaythrough",
        "canPlayThrough"
    ],
    [
        "drag",
        "drag"
    ],
    [
        "dragenter",
        "dragEnter"
    ],
    [
        "dragexit",
        "dragExit"
    ],
    [
        "dragleave",
        "dragLeave"
    ],
    [
        "dragover",
        "dragOver"
    ],
    [
        "durationchange",
        "durationChange"
    ],
    [
        "emptied",
        "emptied"
    ],
    [
        "encrypted",
        "encrypted"
    ],
    [
        "ended",
        "ended"
    ],
    [
        "error",
        "error"
    ],
    [
        "gotpointercapture",
        "gotPointerCapture"
    ],
    [
        "load",
        "load"
    ],
    [
        "loadeddata",
        "loadedData"
    ],
    [
        "loadedmetadata",
        "loadedMetadata"
    ],
    [
        "loadstart",
        "loadStart"
    ],
    [
        "lostpointercapture",
        "lostPointerCapture"
    ],
    [
        "mousemove",
        "mouseMove"
    ],
    [
        "mouseout",
        "mouseOut"
    ],
    [
        "mouseover",
        "mouseOver"
    ],
    [
        "playing",
        "playing"
    ],
    [
        "pointermove",
        "pointerMove"
    ],
    [
        "pointerout",
        "pointerOut"
    ],
    [
        "pointerover",
        "pointerOver"
    ],
    [
        "progress",
        "progress"
    ],
    [
        "scroll",
        "scroll"
    ],
    [
        "seeking",
        "seeking"
    ],
    [
        "stalled",
        "stalled"
    ],
    [
        "suspend",
        "suspend"
    ],
    [
        "timeupdate",
        "timeUpdate"
    ],
    [
        "toggle",
        "toggle"
    ],
    [
        "touchmove",
        "touchMove"
    ],
    [
        $ba12e603ee3d5d8e$var$$a,
        "transitionEnd"
    ],
    [
        "waiting",
        "waiting"
    ],
    [
        "wheel",
        "wheel"
    ]
], $ba12e603ee3d5d8e$var$ud = {}, $ba12e603ee3d5d8e$var$vd = {};
function $ba12e603ee3d5d8e$var$wd(a, b) {
    var c = a[0];
    a = a[1];
    var d = "on" + (a[0].toUpperCase() + a.slice(1));
    b = {
        phasedRegistrationNames: {
            bubbled: d,
            captured: d + "Capture"
        },
        dependencies: [
            c
        ],
        isInteractive: b
    };
    $ba12e603ee3d5d8e$var$ud[a] = b;
    $ba12e603ee3d5d8e$var$vd[c] = b;
}
[
    [
        "blur",
        "blur"
    ],
    [
        "cancel",
        "cancel"
    ],
    [
        "click",
        "click"
    ],
    [
        "close",
        "close"
    ],
    [
        "contextmenu",
        "contextMenu"
    ],
    [
        "copy",
        "copy"
    ],
    [
        "cut",
        "cut"
    ],
    [
        "auxclick",
        "auxClick"
    ],
    [
        "dblclick",
        "doubleClick"
    ],
    [
        "dragend",
        "dragEnd"
    ],
    [
        "dragstart",
        "dragStart"
    ],
    [
        "drop",
        "drop"
    ],
    [
        "focus",
        "focus"
    ],
    [
        "input",
        "input"
    ],
    [
        "invalid",
        "invalid"
    ],
    [
        "keydown",
        "keyDown"
    ],
    [
        "keypress",
        "keyPress"
    ],
    [
        "keyup",
        "keyUp"
    ],
    [
        "mousedown",
        "mouseDown"
    ],
    [
        "mouseup",
        "mouseUp"
    ],
    [
        "paste",
        "paste"
    ],
    [
        "pause",
        "pause"
    ],
    [
        "play",
        "play"
    ],
    [
        "pointercancel",
        "pointerCancel"
    ],
    [
        "pointerdown",
        "pointerDown"
    ],
    [
        "pointerup",
        "pointerUp"
    ],
    [
        "ratechange",
        "rateChange"
    ],
    [
        "reset",
        "reset"
    ],
    [
        "seeked",
        "seeked"
    ],
    [
        "submit",
        "submit"
    ],
    [
        "touchcancel",
        "touchCancel"
    ],
    [
        "touchend",
        "touchEnd"
    ],
    [
        "touchstart",
        "touchStart"
    ],
    [
        "volumechange",
        "volumeChange"
    ]
].forEach(function(a) {
    $ba12e603ee3d5d8e$var$wd(a, !0);
});
$ba12e603ee3d5d8e$var$td.forEach(function(a) {
    $ba12e603ee3d5d8e$var$wd(a, !1);
});
var $ba12e603ee3d5d8e$var$xd = {
    eventTypes: $ba12e603ee3d5d8e$var$ud,
    isInteractiveTopLevelEventType: function(a) {
        a = $ba12e603ee3d5d8e$var$vd[a];
        return void 0 !== a && !0 === a.isInteractive;
    },
    extractEvents: function(a, b, c, d) {
        var e = $ba12e603ee3d5d8e$var$vd[a];
        if (!e) return null;
        switch(a){
            case "keypress":
                if (0 === $ba12e603ee3d5d8e$var$ld(c)) return null;
            case "keydown":
            case "keyup":
                a = $ba12e603ee3d5d8e$var$od;
                break;
            case "blur":
            case "focus":
                a = $ba12e603ee3d5d8e$var$kd;
                break;
            case "click":
                if (2 === c.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
                a = $ba12e603ee3d5d8e$var$Yc;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                a = $ba12e603ee3d5d8e$var$pd;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                a = $ba12e603ee3d5d8e$var$qd;
                break;
            case $ba12e603ee3d5d8e$var$Xa:
            case $ba12e603ee3d5d8e$var$Ya:
            case $ba12e603ee3d5d8e$var$Za:
                a = $ba12e603ee3d5d8e$var$id;
                break;
            case $ba12e603ee3d5d8e$var$$a:
                a = $ba12e603ee3d5d8e$var$rd;
                break;
            case "scroll":
                a = $ba12e603ee3d5d8e$var$Qc;
                break;
            case "wheel":
                a = $ba12e603ee3d5d8e$var$sd;
                break;
            case "copy":
            case "cut":
            case "paste":
                a = $ba12e603ee3d5d8e$var$jd;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                a = $ba12e603ee3d5d8e$var$Zc;
                break;
            default:
                a = $ba12e603ee3d5d8e$var$y;
        }
        b = a.getPooled(e, b, c, d);
        $ba12e603ee3d5d8e$var$Qa(b);
        return b;
    }
}, $ba12e603ee3d5d8e$var$yd = $ba12e603ee3d5d8e$var$xd.isInteractiveTopLevelEventType, $ba12e603ee3d5d8e$var$zd = [];
function $ba12e603ee3d5d8e$var$Ad(a) {
    var b = a.targetInst, c = b;
    do {
        if (!c) {
            a.ancestors.push(c);
            break;
        }
        var d;
        for(d = c; d.return;)d = d.return;
        d = 3 !== d.tag ? null : d.stateNode.containerInfo;
        if (!d) break;
        a.ancestors.push(c);
        c = $ba12e603ee3d5d8e$var$Ha(d);
    }while (c);
    for(c = 0; c < a.ancestors.length; c++){
        b = a.ancestors[c];
        var e = $ba12e603ee3d5d8e$var$Nb(a.nativeEvent);
        d = a.topLevelType;
        for(var f = a.nativeEvent, g = null, h = 0; h < $ba12e603ee3d5d8e$var$oa.length; h++){
            var l = $ba12e603ee3d5d8e$var$oa[h];
            l && (l = l.extractEvents(d, b, f, e)) && (g = $ba12e603ee3d5d8e$var$xa(g, l));
        }
        $ba12e603ee3d5d8e$var$Da(g);
    }
}
var $ba12e603ee3d5d8e$var$Bd = !0;
function $ba12e603ee3d5d8e$var$E(a, b) {
    if (!b) return null;
    var c = ($ba12e603ee3d5d8e$var$yd(a) ? $ba12e603ee3d5d8e$var$Cd : $ba12e603ee3d5d8e$var$Dd).bind(null, a);
    b.addEventListener(a, c, !1);
}
function $ba12e603ee3d5d8e$var$Ed(a, b) {
    if (!b) return null;
    var c = ($ba12e603ee3d5d8e$var$yd(a) ? $ba12e603ee3d5d8e$var$Cd : $ba12e603ee3d5d8e$var$Dd).bind(null, a);
    b.addEventListener(a, c, !0);
}
function $ba12e603ee3d5d8e$var$Cd(a, b) {
    $ba12e603ee3d5d8e$var$Hb($ba12e603ee3d5d8e$var$Dd, a, b);
}
function $ba12e603ee3d5d8e$var$Dd(a, b) {
    if ($ba12e603ee3d5d8e$var$Bd) {
        var c = $ba12e603ee3d5d8e$var$Nb(b);
        c = $ba12e603ee3d5d8e$var$Ha(c);
        null === c || "number" !== typeof c.tag || 2 === $ba12e603ee3d5d8e$var$ed(c) || (c = null);
        if ($ba12e603ee3d5d8e$var$zd.length) {
            var d = $ba12e603ee3d5d8e$var$zd.pop();
            d.topLevelType = a;
            d.nativeEvent = b;
            d.targetInst = c;
            a = d;
        } else a = {
            topLevelType: a,
            nativeEvent: b,
            targetInst: c,
            ancestors: []
        };
        try {
            $ba12e603ee3d5d8e$var$Kb($ba12e603ee3d5d8e$var$Ad, a);
        } finally{
            a.topLevelType = null, a.nativeEvent = null, a.targetInst = null, a.ancestors.length = 0, 10 > $ba12e603ee3d5d8e$var$zd.length && $ba12e603ee3d5d8e$var$zd.push(a);
        }
    }
}
var $ba12e603ee3d5d8e$var$Fd = {}, $ba12e603ee3d5d8e$var$Gd = 0, $ba12e603ee3d5d8e$var$Hd = "_reactListenersID" + ("" + Math.random()).slice(2);
function $ba12e603ee3d5d8e$var$Id(a) {
    Object.prototype.hasOwnProperty.call(a, $ba12e603ee3d5d8e$var$Hd) || (a[$ba12e603ee3d5d8e$var$Hd] = $ba12e603ee3d5d8e$var$Gd++, $ba12e603ee3d5d8e$var$Fd[a[$ba12e603ee3d5d8e$var$Hd]] = {});
    return $ba12e603ee3d5d8e$var$Fd[a[$ba12e603ee3d5d8e$var$Hd]];
}
function $ba12e603ee3d5d8e$var$Jd(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $ba12e603ee3d5d8e$var$Kd(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $ba12e603ee3d5d8e$var$Ld(a, b) {
    var c = $ba12e603ee3d5d8e$var$Kd(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $ba12e603ee3d5d8e$var$Kd(c);
    }
}
function $ba12e603ee3d5d8e$var$Md(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $ba12e603ee3d5d8e$var$Md(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $ba12e603ee3d5d8e$var$Nd() {
    for(var a = window, b = $ba12e603ee3d5d8e$var$Jd(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $ba12e603ee3d5d8e$var$Jd(a.document);
    }
    return b;
}
function $ba12e603ee3d5d8e$var$Od(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $ba12e603ee3d5d8e$var$Pd() {
    var a = $ba12e603ee3d5d8e$var$Nd();
    if ($ba12e603ee3d5d8e$var$Od(a)) {
        if ("selectionStart" in a) var b = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            b = (b = a.ownerDocument) && b.defaultView || window;
            var c = b.getSelection && b.getSelection();
            if (c && 0 !== c.rangeCount) {
                b = c.anchorNode;
                var d = c.anchorOffset, e = c.focusNode;
                c = c.focusOffset;
                try {
                    b.nodeType, e.nodeType;
                } catch (A) {
                    b = null;
                    break a;
                }
                var f = 0, g = -1, h = -1, l = 0, k = 0, m = a, p = null;
                b: for(;;){
                    for(var t;;){
                        m !== b || 0 !== d && 3 !== m.nodeType || (g = f + d);
                        m !== e || 0 !== c && 3 !== m.nodeType || (h = f + c);
                        3 === m.nodeType && (f += m.nodeValue.length);
                        if (null === (t = m.firstChild)) break;
                        p = m;
                        m = t;
                    }
                    for(;;){
                        if (m === a) break b;
                        p === b && ++l === d && (g = f);
                        p === e && ++k === c && (h = f);
                        if (null !== (t = m.nextSibling)) break;
                        m = p;
                        p = m.parentNode;
                    }
                    m = t;
                }
                b = -1 === g || -1 === h ? null : {
                    start: g,
                    end: h
                };
            } else b = null;
        }
        b = b || {
            start: 0,
            end: 0
        };
    } else b = null;
    return {
        focusedElem: a,
        selectionRange: b
    };
}
function $ba12e603ee3d5d8e$var$Qd(a) {
    var b = $ba12e603ee3d5d8e$var$Nd(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $ba12e603ee3d5d8e$var$Md(c.ownerDocument.documentElement, c)) {
        if (null !== d && $ba12e603ee3d5d8e$var$Od(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $ba12e603ee3d5d8e$var$Ld(c, f);
                var g = $ba12e603ee3d5d8e$var$Ld(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $ba12e603ee3d5d8e$var$Rd = $ba12e603ee3d5d8e$var$Ra && "documentMode" in document && 11 >= document.documentMode, $ba12e603ee3d5d8e$var$Sd = {
    select: {
        phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
        },
        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
}, $ba12e603ee3d5d8e$var$Td = null, $ba12e603ee3d5d8e$var$Ud = null, $ba12e603ee3d5d8e$var$Vd = null, $ba12e603ee3d5d8e$var$Wd = !1;
function $ba12e603ee3d5d8e$var$Xd(a, b) {
    var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
    if ($ba12e603ee3d5d8e$var$Wd || null == $ba12e603ee3d5d8e$var$Td || $ba12e603ee3d5d8e$var$Td !== $ba12e603ee3d5d8e$var$Jd(c)) return null;
    c = $ba12e603ee3d5d8e$var$Td;
    "selectionStart" in c && $ba12e603ee3d5d8e$var$Od(c) ? c = {
        start: c.selectionStart,
        end: c.selectionEnd
    } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
        anchorNode: c.anchorNode,
        anchorOffset: c.anchorOffset,
        focusNode: c.focusNode,
        focusOffset: c.focusOffset
    });
    return $ba12e603ee3d5d8e$var$Vd && $ba12e603ee3d5d8e$var$dd($ba12e603ee3d5d8e$var$Vd, c) ? null : ($ba12e603ee3d5d8e$var$Vd = c, a = $ba12e603ee3d5d8e$var$y.getPooled($ba12e603ee3d5d8e$var$Sd.select, $ba12e603ee3d5d8e$var$Ud, a, b), a.type = "select", a.target = $ba12e603ee3d5d8e$var$Td, $ba12e603ee3d5d8e$var$Qa(a), a);
}
var $ba12e603ee3d5d8e$var$Yd = {
    eventTypes: $ba12e603ee3d5d8e$var$Sd,
    extractEvents: function(a, b, c, d) {
        var e = d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument, f;
        if (!(f = !e)) {
            a: {
                e = $ba12e603ee3d5d8e$var$Id(e);
                f = $ba12e603ee3d5d8e$var$sa.onSelect;
                for(var g = 0; g < f.length; g++){
                    var h = f[g];
                    if (!e.hasOwnProperty(h) || !e[h]) {
                        e = !1;
                        break a;
                    }
                }
                e = !0;
            }
            f = !e;
        }
        if (f) return null;
        e = b ? $ba12e603ee3d5d8e$var$Ja(b) : window;
        switch(a){
            case "focus":
                if ($ba12e603ee3d5d8e$var$Mb(e) || "true" === e.contentEditable) $ba12e603ee3d5d8e$var$Td = e, $ba12e603ee3d5d8e$var$Ud = b, $ba12e603ee3d5d8e$var$Vd = null;
                break;
            case "blur":
                $ba12e603ee3d5d8e$var$Vd = $ba12e603ee3d5d8e$var$Ud = $ba12e603ee3d5d8e$var$Td = null;
                break;
            case "mousedown":
                $ba12e603ee3d5d8e$var$Wd = !0;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                return $ba12e603ee3d5d8e$var$Wd = !1, $ba12e603ee3d5d8e$var$Xd(c, d);
            case "selectionchange":
                if ($ba12e603ee3d5d8e$var$Rd) break;
            case "keydown":
            case "keyup":
                return $ba12e603ee3d5d8e$var$Xd(c, d);
        }
        return null;
    }
};
$ba12e603ee3d5d8e$var$Ba.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
$ba12e603ee3d5d8e$var$ta = $ba12e603ee3d5d8e$var$Ka;
$ba12e603ee3d5d8e$var$ua = $ba12e603ee3d5d8e$var$Ia;
$ba12e603ee3d5d8e$var$va = $ba12e603ee3d5d8e$var$Ja;
$ba12e603ee3d5d8e$var$Ba.injectEventPluginsByName({
    SimpleEventPlugin: $ba12e603ee3d5d8e$var$xd,
    EnterLeaveEventPlugin: $ba12e603ee3d5d8e$var$ad,
    ChangeEventPlugin: $ba12e603ee3d5d8e$var$Pc,
    SelectEventPlugin: $ba12e603ee3d5d8e$var$Yd,
    BeforeInputEventPlugin: $ba12e603ee3d5d8e$var$zb
});
function $ba12e603ee3d5d8e$var$Zd(a) {
    var b = "";
    $6wXVr.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $ba12e603ee3d5d8e$var$$d(a, b) {
    a = $63ReS({
        children: void 0
    }, b);
    if (b = $ba12e603ee3d5d8e$var$Zd(b.children)) a.children = b;
    return a;
}
function $ba12e603ee3d5d8e$var$ae(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $ba12e603ee3d5d8e$var$uc(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $ba12e603ee3d5d8e$var$be(a, b) {
    null != b.dangerouslySetInnerHTML && $ba12e603ee3d5d8e$var$x("91");
    return $63ReS({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $ba12e603ee3d5d8e$var$ce(a, b) {
    var c = b.value;
    null == c && (c = b.defaultValue, b = b.children, null != b && (null != c && $ba12e603ee3d5d8e$var$x("92"), Array.isArray(b) && (1 >= b.length || $ba12e603ee3d5d8e$var$x("93"), b = b[0]), c = b), null == c && (c = ""));
    a._wrapperState = {
        initialValue: $ba12e603ee3d5d8e$var$uc(c)
    };
}
function $ba12e603ee3d5d8e$var$de(a, b) {
    var c = $ba12e603ee3d5d8e$var$uc(b.value), d = $ba12e603ee3d5d8e$var$uc(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $ba12e603ee3d5d8e$var$ee(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && (a.value = b);
}
var $ba12e603ee3d5d8e$var$fe = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function $ba12e603ee3d5d8e$var$ge(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $ba12e603ee3d5d8e$var$he(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $ba12e603ee3d5d8e$var$ge(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $ba12e603ee3d5d8e$var$ie = void 0, $ba12e603ee3d5d8e$var$je = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== $ba12e603ee3d5d8e$var$fe.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        $ba12e603ee3d5d8e$var$ie = $ba12e603ee3d5d8e$var$ie || document.createElement("div");
        $ba12e603ee3d5d8e$var$ie.innerHTML = "<svg>" + b + "</svg>";
        for(b = $ba12e603ee3d5d8e$var$ie.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $ba12e603ee3d5d8e$var$ke(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $ba12e603ee3d5d8e$var$le = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $ba12e603ee3d5d8e$var$me = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($ba12e603ee3d5d8e$var$le).forEach(function(a) {
    $ba12e603ee3d5d8e$var$me.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $ba12e603ee3d5d8e$var$le[b] = $ba12e603ee3d5d8e$var$le[a];
    });
});
function $ba12e603ee3d5d8e$var$ne(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $ba12e603ee3d5d8e$var$le.hasOwnProperty(a) && $ba12e603ee3d5d8e$var$le[a] ? ("" + b).trim() : b + "px";
}
function $ba12e603ee3d5d8e$var$oe(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $ba12e603ee3d5d8e$var$ne(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $ba12e603ee3d5d8e$var$pe = $63ReS({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $ba12e603ee3d5d8e$var$qe(a, b) {
    b && ($ba12e603ee3d5d8e$var$pe[a] && (null != b.children || null != b.dangerouslySetInnerHTML) && $ba12e603ee3d5d8e$var$x("137", a, ""), null != b.dangerouslySetInnerHTML && (null != b.children && $ba12e603ee3d5d8e$var$x("60"), "object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML || $ba12e603ee3d5d8e$var$x("61")), null != b.style && "object" !== typeof b.style && $ba12e603ee3d5d8e$var$x("62", ""));
}
function $ba12e603ee3d5d8e$var$re(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function $ba12e603ee3d5d8e$var$se(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = $ba12e603ee3d5d8e$var$Id(a);
    b = $ba12e603ee3d5d8e$var$sa[b];
    for(var d = 0; d < b.length; d++){
        var e = b[d];
        if (!c.hasOwnProperty(e) || !c[e]) {
            switch(e){
                case "scroll":
                    $ba12e603ee3d5d8e$var$Ed("scroll", a);
                    break;
                case "focus":
                case "blur":
                    $ba12e603ee3d5d8e$var$Ed("focus", a);
                    $ba12e603ee3d5d8e$var$Ed("blur", a);
                    c.blur = !0;
                    c.focus = !0;
                    break;
                case "cancel":
                case "close":
                    $ba12e603ee3d5d8e$var$Ob(e) && $ba12e603ee3d5d8e$var$Ed(e, a);
                    break;
                case "invalid":
                case "submit":
                case "reset":
                    break;
                default:
                    -1 === $ba12e603ee3d5d8e$var$ab.indexOf(e) && $ba12e603ee3d5d8e$var$E(e, a);
            }
            c[e] = !0;
        }
    }
}
function $ba12e603ee3d5d8e$var$te() {}
var $ba12e603ee3d5d8e$var$ue = null, $ba12e603ee3d5d8e$var$ve = null;
function $ba12e603ee3d5d8e$var$we(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function $ba12e603ee3d5d8e$var$xe(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $ba12e603ee3d5d8e$var$ye = "function" === typeof setTimeout ? setTimeout : void 0, $ba12e603ee3d5d8e$var$ze = "function" === typeof clearTimeout ? clearTimeout : void 0, $ba12e603ee3d5d8e$var$Ae = $jmjQ5.unstable_scheduleCallback, $ba12e603ee3d5d8e$var$Be = $jmjQ5.unstable_cancelCallback;
function $ba12e603ee3d5d8e$var$Ce(a, b, c, d, e) {
    a[$ba12e603ee3d5d8e$var$Ga] = e;
    "input" === c && "radio" === e.type && null != e.name && $ba12e603ee3d5d8e$var$xc(a, e);
    $ba12e603ee3d5d8e$var$re(c, d);
    d = $ba12e603ee3d5d8e$var$re(c, e);
    for(var f = 0; f < b.length; f += 2){
        var g = b[f], h = b[f + 1];
        "style" === g ? $ba12e603ee3d5d8e$var$oe(a, h) : "dangerouslySetInnerHTML" === g ? $ba12e603ee3d5d8e$var$je(a, h) : "children" === g ? $ba12e603ee3d5d8e$var$ke(a, h) : $ba12e603ee3d5d8e$var$tc(a, g, h, d);
    }
    switch(c){
        case "input":
            $ba12e603ee3d5d8e$var$yc(a, e);
            break;
        case "textarea":
            $ba12e603ee3d5d8e$var$de(a, e);
            break;
        case "select":
            b = a._wrapperState.wasMultiple, a._wrapperState.wasMultiple = !!e.multiple, c = e.value, null != c ? $ba12e603ee3d5d8e$var$ae(a, !!e.multiple, c, !1) : b !== !!e.multiple && (null != e.defaultValue ? $ba12e603ee3d5d8e$var$ae(a, !!e.multiple, e.defaultValue, !0) : $ba12e603ee3d5d8e$var$ae(a, !!e.multiple, e.multiple ? [] : "", !1));
    }
}
function $ba12e603ee3d5d8e$var$De(a) {
    for(a = a.nextSibling; a && 1 !== a.nodeType && 3 !== a.nodeType;)a = a.nextSibling;
    return a;
}
function $ba12e603ee3d5d8e$var$Ee(a) {
    for(a = a.firstChild; a && 1 !== a.nodeType && 3 !== a.nodeType;)a = a.nextSibling;
    return a;
}
new Set;
var $ba12e603ee3d5d8e$var$Fe = [], $ba12e603ee3d5d8e$var$Ge = -1;
function $ba12e603ee3d5d8e$var$F(a) {
    0 > $ba12e603ee3d5d8e$var$Ge || (a.current = $ba12e603ee3d5d8e$var$Fe[$ba12e603ee3d5d8e$var$Ge], $ba12e603ee3d5d8e$var$Fe[$ba12e603ee3d5d8e$var$Ge] = null, $ba12e603ee3d5d8e$var$Ge--);
}
function $ba12e603ee3d5d8e$var$G(a, b) {
    $ba12e603ee3d5d8e$var$Ge++;
    $ba12e603ee3d5d8e$var$Fe[$ba12e603ee3d5d8e$var$Ge] = a.current;
    a.current = b;
}
var $ba12e603ee3d5d8e$var$He = {}, $ba12e603ee3d5d8e$var$H = {
    current: $ba12e603ee3d5d8e$var$He
}, $ba12e603ee3d5d8e$var$I = {
    current: !1
}, $ba12e603ee3d5d8e$var$Ie = $ba12e603ee3d5d8e$var$He;
function $ba12e603ee3d5d8e$var$Je(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $ba12e603ee3d5d8e$var$He;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $ba12e603ee3d5d8e$var$J(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $ba12e603ee3d5d8e$var$Ke(a) {
    $ba12e603ee3d5d8e$var$F($ba12e603ee3d5d8e$var$I, a);
    $ba12e603ee3d5d8e$var$F($ba12e603ee3d5d8e$var$H, a);
}
function $ba12e603ee3d5d8e$var$Le(a) {
    $ba12e603ee3d5d8e$var$F($ba12e603ee3d5d8e$var$I, a);
    $ba12e603ee3d5d8e$var$F($ba12e603ee3d5d8e$var$H, a);
}
function $ba12e603ee3d5d8e$var$Me(a, b, c) {
    $ba12e603ee3d5d8e$var$H.current !== $ba12e603ee3d5d8e$var$He && $ba12e603ee3d5d8e$var$x("168");
    $ba12e603ee3d5d8e$var$G($ba12e603ee3d5d8e$var$H, b, a);
    $ba12e603ee3d5d8e$var$G($ba12e603ee3d5d8e$var$I, c, a);
}
function $ba12e603ee3d5d8e$var$Ne(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)e in a || $ba12e603ee3d5d8e$var$x("108", $ba12e603ee3d5d8e$var$ic(b) || "Unknown", e);
    return $63ReS({}, c, d);
}
function $ba12e603ee3d5d8e$var$Oe(a) {
    var b = a.stateNode;
    b = b && b.__reactInternalMemoizedMergedChildContext || $ba12e603ee3d5d8e$var$He;
    $ba12e603ee3d5d8e$var$Ie = $ba12e603ee3d5d8e$var$H.current;
    $ba12e603ee3d5d8e$var$G($ba12e603ee3d5d8e$var$H, b, a);
    $ba12e603ee3d5d8e$var$G($ba12e603ee3d5d8e$var$I, $ba12e603ee3d5d8e$var$I.current, a);
    return !0;
}
function $ba12e603ee3d5d8e$var$Pe(a, b, c) {
    var d = a.stateNode;
    d || $ba12e603ee3d5d8e$var$x("169");
    c ? (b = $ba12e603ee3d5d8e$var$Ne(a, b, $ba12e603ee3d5d8e$var$Ie), d.__reactInternalMemoizedMergedChildContext = b, $ba12e603ee3d5d8e$var$F($ba12e603ee3d5d8e$var$I, a), $ba12e603ee3d5d8e$var$F($ba12e603ee3d5d8e$var$H, a), $ba12e603ee3d5d8e$var$G($ba12e603ee3d5d8e$var$H, b, a)) : $ba12e603ee3d5d8e$var$F($ba12e603ee3d5d8e$var$I, a);
    $ba12e603ee3d5d8e$var$G($ba12e603ee3d5d8e$var$I, c, a);
}
var $ba12e603ee3d5d8e$var$Qe = null, $ba12e603ee3d5d8e$var$Re = null;
function $ba12e603ee3d5d8e$var$Se(a) {
    return function(b) {
        try {
            return a(b);
        } catch (c) {}
    };
}
function $ba12e603ee3d5d8e$var$Te(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        var c = b.inject(a);
        $ba12e603ee3d5d8e$var$Qe = $ba12e603ee3d5d8e$var$Se(function(a) {
            return b.onCommitFiberRoot(c, a);
        });
        $ba12e603ee3d5d8e$var$Re = $ba12e603ee3d5d8e$var$Se(function(a) {
            return b.onCommitFiberUnmount(c, a);
        });
    } catch (d) {}
    return !0;
}
function $ba12e603ee3d5d8e$var$Ue(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.contextDependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
}
function $ba12e603ee3d5d8e$var$K(a, b, c, d) {
    return new $ba12e603ee3d5d8e$var$Ue(a, b, c, d);
}
function $ba12e603ee3d5d8e$var$Ve(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $ba12e603ee3d5d8e$var$We(a) {
    if ("function" === typeof a) return $ba12e603ee3d5d8e$var$Ve(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $ba12e603ee3d5d8e$var$cc) return 11;
        if (a === $ba12e603ee3d5d8e$var$ec) return 14;
    }
    return 2;
}
function $ba12e603ee3d5d8e$var$Xe(a, b) {
    var c = a.alternate;
    null === c ? (c = $ba12e603ee3d5d8e$var$K(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    c.contextDependencies = a.contextDependencies;
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $ba12e603ee3d5d8e$var$Ye(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $ba12e603ee3d5d8e$var$Ve(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $ba12e603ee3d5d8e$var$Xb:
            return $ba12e603ee3d5d8e$var$Ze(c.children, e, f, b);
        case $ba12e603ee3d5d8e$var$bc:
            return $ba12e603ee3d5d8e$var$$e(c, e | 3, f, b);
        case $ba12e603ee3d5d8e$var$Yb:
            return $ba12e603ee3d5d8e$var$$e(c, e | 2, f, b);
        case $ba12e603ee3d5d8e$var$Zb:
            return a = $ba12e603ee3d5d8e$var$K(12, c, b, e | 4), a.elementType = $ba12e603ee3d5d8e$var$Zb, a.type = $ba12e603ee3d5d8e$var$Zb, a.expirationTime = f, a;
        case $ba12e603ee3d5d8e$var$dc:
            return a = $ba12e603ee3d5d8e$var$K(13, c, b, e), a.elementType = $ba12e603ee3d5d8e$var$dc, a.type = $ba12e603ee3d5d8e$var$dc, a.expirationTime = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $ba12e603ee3d5d8e$var$$b:
                    g = 10;
                    break a;
                case $ba12e603ee3d5d8e$var$ac:
                    g = 9;
                    break a;
                case $ba12e603ee3d5d8e$var$cc:
                    g = 11;
                    break a;
                case $ba12e603ee3d5d8e$var$ec:
                    g = 14;
                    break a;
                case $ba12e603ee3d5d8e$var$fc:
                    g = 16;
                    d = null;
                    break a;
            }
            $ba12e603ee3d5d8e$var$x("130", null == a ? a : typeof a, "");
    }
    b = $ba12e603ee3d5d8e$var$K(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
}
function $ba12e603ee3d5d8e$var$Ze(a, b, c, d) {
    a = $ba12e603ee3d5d8e$var$K(7, a, d, b);
    a.expirationTime = c;
    return a;
}
function $ba12e603ee3d5d8e$var$$e(a, b, c, d) {
    a = $ba12e603ee3d5d8e$var$K(8, a, d, b);
    b = 0 === (b & 1) ? $ba12e603ee3d5d8e$var$Yb : $ba12e603ee3d5d8e$var$bc;
    a.elementType = b;
    a.type = b;
    a.expirationTime = c;
    return a;
}
function $ba12e603ee3d5d8e$var$af(a, b, c) {
    a = $ba12e603ee3d5d8e$var$K(6, a, null, b);
    a.expirationTime = c;
    return a;
}
function $ba12e603ee3d5d8e$var$bf(a, b, c) {
    b = $ba12e603ee3d5d8e$var$K(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $ba12e603ee3d5d8e$var$cf(a, b) {
    a.didError = !1;
    var c = a.earliestPendingTime;
    0 === c ? a.earliestPendingTime = a.latestPendingTime = b : c < b ? a.earliestPendingTime = b : a.latestPendingTime > b && (a.latestPendingTime = b);
    $ba12e603ee3d5d8e$var$df(b, a);
}
function $ba12e603ee3d5d8e$var$ef(a, b) {
    a.didError = !1;
    if (0 === b) a.earliestPendingTime = 0, a.latestPendingTime = 0, a.earliestSuspendedTime = 0, a.latestSuspendedTime = 0, a.latestPingedTime = 0;
    else {
        b < a.latestPingedTime && (a.latestPingedTime = 0);
        var c = a.latestPendingTime;
        0 !== c && (c > b ? a.earliestPendingTime = a.latestPendingTime = 0 : a.earliestPendingTime > b && (a.earliestPendingTime = a.latestPendingTime));
        c = a.earliestSuspendedTime;
        0 === c ? $ba12e603ee3d5d8e$var$cf(a, b) : b < a.latestSuspendedTime ? (a.earliestSuspendedTime = 0, a.latestSuspendedTime = 0, a.latestPingedTime = 0, $ba12e603ee3d5d8e$var$cf(a, b)) : b > c && $ba12e603ee3d5d8e$var$cf(a, b);
    }
    $ba12e603ee3d5d8e$var$df(0, a);
}
function $ba12e603ee3d5d8e$var$ff(a, b) {
    a.didError = !1;
    a.latestPingedTime >= b && (a.latestPingedTime = 0);
    var c = a.earliestPendingTime, d = a.latestPendingTime;
    c === b ? a.earliestPendingTime = d === b ? a.latestPendingTime = 0 : d : d === b && (a.latestPendingTime = c);
    c = a.earliestSuspendedTime;
    d = a.latestSuspendedTime;
    0 === c ? a.earliestSuspendedTime = a.latestSuspendedTime = b : c < b ? a.earliestSuspendedTime = b : d > b && (a.latestSuspendedTime = b);
    $ba12e603ee3d5d8e$var$df(b, a);
}
function $ba12e603ee3d5d8e$var$gf(a, b) {
    var c = a.earliestPendingTime;
    a = a.earliestSuspendedTime;
    c > b && (b = c);
    a > b && (b = a);
    return b;
}
function $ba12e603ee3d5d8e$var$df(a, b) {
    var c = b.earliestSuspendedTime, d = b.latestSuspendedTime, e = b.earliestPendingTime, f = b.latestPingedTime;
    e = 0 !== e ? e : f;
    0 === e && (0 === a || d < a) && (e = d);
    a = e;
    0 !== a && c > a && (a = c);
    b.nextExpirationTimeToWorkOn = e;
    b.expirationTime = a;
}
function $ba12e603ee3d5d8e$var$L(a, b) {
    if (a && a.defaultProps) {
        b = $63ReS({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
    }
    return b;
}
function $ba12e603ee3d5d8e$var$hf(a) {
    var b = a._result;
    switch(a._status){
        case 1:
            return b;
        case 2:
            throw b;
        case 0:
            throw b;
        default:
            a._status = 0;
            b = a._ctor;
            b = b();
            b.then(function(b) {
                0 === a._status && (b = b.default, a._status = 1, a._result = b);
            }, function(b) {
                0 === a._status && (a._status = 2, a._result = b);
            });
            switch(a._status){
                case 1:
                    return a._result;
                case 2:
                    throw a._result;
            }
            a._result = b;
            throw b;
    }
}
var $ba12e603ee3d5d8e$var$jf = (new $6wXVr.Component).refs;
function $ba12e603ee3d5d8e$var$kf(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $63ReS({}, b, c);
    a.memoizedState = c;
    d = a.updateQueue;
    null !== d && 0 === a.expirationTime && (d.baseState = c);
}
var $ba12e603ee3d5d8e$var$tf = {
    isMounted: function(a) {
        return (a = a._reactInternalFiber) ? 2 === $ba12e603ee3d5d8e$var$ed(a) : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = $ba12e603ee3d5d8e$var$lf();
        d = $ba12e603ee3d5d8e$var$mf(d, a);
        var e = $ba12e603ee3d5d8e$var$nf(d);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        $ba12e603ee3d5d8e$var$of();
        $ba12e603ee3d5d8e$var$pf(a, e);
        $ba12e603ee3d5d8e$var$qf(a, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = $ba12e603ee3d5d8e$var$lf();
        d = $ba12e603ee3d5d8e$var$mf(d, a);
        var e = $ba12e603ee3d5d8e$var$nf(d);
        e.tag = $ba12e603ee3d5d8e$var$rf;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        $ba12e603ee3d5d8e$var$of();
        $ba12e603ee3d5d8e$var$pf(a, e);
        $ba12e603ee3d5d8e$var$qf(a, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternalFiber;
        var c = $ba12e603ee3d5d8e$var$lf();
        c = $ba12e603ee3d5d8e$var$mf(c, a);
        var d = $ba12e603ee3d5d8e$var$nf(c);
        d.tag = $ba12e603ee3d5d8e$var$sf;
        void 0 !== b && null !== b && (d.callback = b);
        $ba12e603ee3d5d8e$var$of();
        $ba12e603ee3d5d8e$var$pf(a, d);
        $ba12e603ee3d5d8e$var$qf(a, c);
    }
};
function $ba12e603ee3d5d8e$var$uf(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$ba12e603ee3d5d8e$var$dd(c, d) || !$ba12e603ee3d5d8e$var$dd(e, f) : !0;
}
function $ba12e603ee3d5d8e$var$vf(a, b, c) {
    var d = !1, e = $ba12e603ee3d5d8e$var$He;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $ba12e603ee3d5d8e$var$M(f) : (e = $ba12e603ee3d5d8e$var$J(b) ? $ba12e603ee3d5d8e$var$Ie : $ba12e603ee3d5d8e$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $ba12e603ee3d5d8e$var$Je(a, e) : $ba12e603ee3d5d8e$var$He);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $ba12e603ee3d5d8e$var$tf;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $ba12e603ee3d5d8e$var$wf(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $ba12e603ee3d5d8e$var$tf.enqueueReplaceState(b, b.state, null);
}
function $ba12e603ee3d5d8e$var$xf(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $ba12e603ee3d5d8e$var$jf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $ba12e603ee3d5d8e$var$M(f) : (f = $ba12e603ee3d5d8e$var$J(b) ? $ba12e603ee3d5d8e$var$Ie : $ba12e603ee3d5d8e$var$H.current, e.context = $ba12e603ee3d5d8e$var$Je(a, f));
    f = a.updateQueue;
    null !== f && ($ba12e603ee3d5d8e$var$yf(a, f, c, e, d), e.state = a.memoizedState);
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($ba12e603ee3d5d8e$var$kf(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $ba12e603ee3d5d8e$var$tf.enqueueReplaceState(e, e.state, null), f = a.updateQueue, null !== f && ($ba12e603ee3d5d8e$var$yf(a, f, c, e, d), e.state = a.memoizedState));
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
}
var $ba12e603ee3d5d8e$var$zf = Array.isArray;
function $ba12e603ee3d5d8e$var$Af(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            var d = void 0;
            c && (1 !== c.tag && $ba12e603ee3d5d8e$var$x("309"), d = c.stateNode);
            d || $ba12e603ee3d5d8e$var$x("147", a);
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === $ba12e603ee3d5d8e$var$jf && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        "string" !== typeof a && $ba12e603ee3d5d8e$var$x("284");
        c._owner || $ba12e603ee3d5d8e$var$x("290", a);
    }
    return a;
}
function $ba12e603ee3d5d8e$var$Bf(a, b) {
    "textarea" !== a.type && $ba12e603ee3d5d8e$var$x("31", "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, "");
}
function $ba12e603ee3d5d8e$var$Cf(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.effectTag = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b, c) {
        a = $ba12e603ee3d5d8e$var$Xe(a, b, c);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $ba12e603ee3d5d8e$var$af(c, a.mode, d), b.return = a, b;
        b = e(b, c, d);
        b.return = a;
        return b;
    }
    function l(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props, d), d.ref = $ba12e603ee3d5d8e$var$Af(a, b, c), d.return = a, d;
        d = $ba12e603ee3d5d8e$var$Ye(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $ba12e603ee3d5d8e$var$Af(a, b, c);
        d.return = a;
        return d;
    }
    function k(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $ba12e603ee3d5d8e$var$bf(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || [], d);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $ba12e603ee3d5d8e$var$Ze(c, a.mode, d, f), b.return = a, b;
        b = e(b, c, d);
        b.return = a;
        return b;
    }
    function p(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = $ba12e603ee3d5d8e$var$af("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $ba12e603ee3d5d8e$var$Vb:
                    return c = $ba12e603ee3d5d8e$var$Ye(b.type, b.key, b.props, null, a.mode, c), c.ref = $ba12e603ee3d5d8e$var$Af(a, null, b), c.return = a, c;
                case $ba12e603ee3d5d8e$var$Wb:
                    return b = $ba12e603ee3d5d8e$var$bf(b, a.mode, c), b.return = a, b;
            }
            if ($ba12e603ee3d5d8e$var$zf(b) || $ba12e603ee3d5d8e$var$hc(b)) return b = $ba12e603ee3d5d8e$var$Ze(b, a.mode, c, null), b.return = a, b;
            $ba12e603ee3d5d8e$var$Bf(a, b);
        }
        return null;
    }
    function t(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $ba12e603ee3d5d8e$var$Vb:
                    return c.key === e ? c.type === $ba12e603ee3d5d8e$var$Xb ? m(a, b, c.props.children, d, e) : l(a, b, c, d) : null;
                case $ba12e603ee3d5d8e$var$Wb:
                    return c.key === e ? k(a, b, c, d) : null;
            }
            if ($ba12e603ee3d5d8e$var$zf(c) || $ba12e603ee3d5d8e$var$hc(c)) return null !== e ? null : m(a, b, c, d, null);
            $ba12e603ee3d5d8e$var$Bf(a, c);
        }
        return null;
    }
    function A(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $ba12e603ee3d5d8e$var$Vb:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === $ba12e603ee3d5d8e$var$Xb ? m(b, a, d.props.children, e, d.key) : l(b, a, d, e);
                case $ba12e603ee3d5d8e$var$Wb:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
            }
            if ($ba12e603ee3d5d8e$var$zf(d) || $ba12e603ee3d5d8e$var$hc(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $ba12e603ee3d5d8e$var$Bf(b, d);
        }
        return null;
    }
    function v(e, g, h, k) {
        for(var l = null, m = null, q = g, u = g = 0, B = null; null !== q && u < h.length; u++){
            q.index > u ? (B = q, q = null) : B = q.sibling;
            var w = t(e, q, h[u], k);
            if (null === w) {
                null === q && (q = B);
                break;
            }
            a && q && null === w.alternate && b(e, q);
            g = f(w, g, u);
            null === m ? l = w : m.sibling = w;
            m = w;
            q = B;
        }
        if (u === h.length) return c(e, q), l;
        if (null === q) {
            for(; u < h.length; u++)if (q = p(e, h[u], k)) g = f(q, g, u), null === m ? l = q : m.sibling = q, m = q;
            return l;
        }
        for(q = d(e, q); u < h.length; u++)if (B = A(q, e, u, h[u], k)) a && null !== B.alternate && q.delete(null === B.key ? u : B.key), g = f(B, g, u), null === m ? l = B : m.sibling = B, m = B;
        a && q.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function R(e, g, h, k) {
        var l = $ba12e603ee3d5d8e$var$hc(h);
        "function" !== typeof l && $ba12e603ee3d5d8e$var$x("150");
        h = l.call(h);
        null == h && $ba12e603ee3d5d8e$var$x("151");
        for(var m = l = null, q = g, u = g = 0, B = null, w = h.next(); null !== q && !w.done; u++, w = h.next()){
            q.index > u ? (B = q, q = null) : B = q.sibling;
            var v = t(e, q, w.value, k);
            if (null === v) {
                q || (q = B);
                break;
            }
            a && q && null === v.alternate && b(e, q);
            g = f(v, g, u);
            null === m ? l = v : m.sibling = v;
            m = v;
            q = B;
        }
        if (w.done) return c(e, q), l;
        if (null === q) {
            for(; !w.done; u++, w = h.next())w = p(e, w.value, k), null !== w && (g = f(w, g, u), null === m ? l = w : m.sibling = w, m = w);
            return l;
        }
        for(q = d(e, q); !w.done; u++, w = h.next())w = A(q, e, u, w.value, k), null !== w && (a && null !== w.alternate && q.delete(null === w.key ? u : w.key), g = f(w, g, u), null === m ? l = w : m.sibling = w, m = w);
        a && q.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === $ba12e603ee3d5d8e$var$Xb && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case $ba12e603ee3d5d8e$var$Vb:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            if (7 === k.tag ? f.type === $ba12e603ee3d5d8e$var$Xb : k.elementType === f.type) {
                                c(a, k.sibling);
                                d = e(k, f.type === $ba12e603ee3d5d8e$var$Xb ? f.props.children : f.props, h);
                                d.ref = $ba12e603ee3d5d8e$var$Af(a, k, f);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, k);
                                break;
                            }
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === $ba12e603ee3d5d8e$var$Xb ? (d = $ba12e603ee3d5d8e$var$Ze(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $ba12e603ee3d5d8e$var$Ye(f.type, f.key, f.props, null, a.mode, h), h.ref = $ba12e603ee3d5d8e$var$Af(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $ba12e603ee3d5d8e$var$Wb:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || [], h);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = $ba12e603ee3d5d8e$var$bf(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f, h), d.return = a, a = d) : (c(a, d), d = $ba12e603ee3d5d8e$var$af(f, a.mode, h), d.return = a, a = d), g(a);
        if ($ba12e603ee3d5d8e$var$zf(f)) return v(a, d, f, h);
        if ($ba12e603ee3d5d8e$var$hc(f)) return R(a, d, f, h);
        l && $ba12e603ee3d5d8e$var$Bf(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 0:
                h = a.type, $ba12e603ee3d5d8e$var$x("152", h.displayName || h.name || "Component");
        }
        return c(a, d);
    };
}
var $ba12e603ee3d5d8e$var$Df = $ba12e603ee3d5d8e$var$Cf(!0), $ba12e603ee3d5d8e$var$Ef = $ba12e603ee3d5d8e$var$Cf(!1), $ba12e603ee3d5d8e$var$Ff = {}, $ba12e603ee3d5d8e$var$N = {
    current: $ba12e603ee3d5d8e$var$Ff
}, $ba12e603ee3d5d8e$var$Gf = {
    current: $ba12e603ee3d5d8e$var$Ff
}, $ba12e603ee3d5d8e$var$Hf = {
    current: $ba12e603ee3d5d8e$var$Ff
};
function $ba12e603ee3d5d8e$var$If(a) {
    a === $ba12e603ee3d5d8e$var$Ff && $ba12e603ee3d5d8e$var$x("174");
    return a;
}
function $ba12e603ee3d5d8e$var$Jf(a, b) {
    $ba12e603ee3d5d8e$var$G($ba12e603ee3d5d8e$var$Hf, b, a);
    $ba12e603ee3d5d8e$var$G($ba12e603ee3d5d8e$var$Gf, a, a);
    $ba12e603ee3d5d8e$var$G($ba12e603ee3d5d8e$var$N, $ba12e603ee3d5d8e$var$Ff, a);
    var c = b.nodeType;
    switch(c){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $ba12e603ee3d5d8e$var$he(null, "");
            break;
        default:
            c = 8 === c ? b.parentNode : b, b = c.namespaceURI || null, c = c.tagName, b = $ba12e603ee3d5d8e$var$he(b, c);
    }
    $ba12e603ee3d5d8e$var$F($ba12e603ee3d5d8e$var$N, a);
    $ba12e603ee3d5d8e$var$G($ba12e603ee3d5d8e$var$N, b, a);
}
function $ba12e603ee3d5d8e$var$Kf(a) {
    $ba12e603ee3d5d8e$var$F($ba12e603ee3d5d8e$var$N, a);
    $ba12e603ee3d5d8e$var$F($ba12e603ee3d5d8e$var$Gf, a);
    $ba12e603ee3d5d8e$var$F($ba12e603ee3d5d8e$var$Hf, a);
}
function $ba12e603ee3d5d8e$var$Lf(a) {
    $ba12e603ee3d5d8e$var$If($ba12e603ee3d5d8e$var$Hf.current);
    var b = $ba12e603ee3d5d8e$var$If($ba12e603ee3d5d8e$var$N.current);
    var c = $ba12e603ee3d5d8e$var$he(b, a.type);
    b !== c && ($ba12e603ee3d5d8e$var$G($ba12e603ee3d5d8e$var$Gf, a, a), $ba12e603ee3d5d8e$var$G($ba12e603ee3d5d8e$var$N, c, a));
}
function $ba12e603ee3d5d8e$var$Mf(a) {
    $ba12e603ee3d5d8e$var$Gf.current === a && ($ba12e603ee3d5d8e$var$F($ba12e603ee3d5d8e$var$N, a), $ba12e603ee3d5d8e$var$F($ba12e603ee3d5d8e$var$Gf, a));
}
var $ba12e603ee3d5d8e$var$Nf = 0, $ba12e603ee3d5d8e$var$Of = 2, $ba12e603ee3d5d8e$var$Pf = 4, $ba12e603ee3d5d8e$var$Qf = 8, $ba12e603ee3d5d8e$var$Rf = 16, $ba12e603ee3d5d8e$var$Sf = 32, $ba12e603ee3d5d8e$var$Tf = 64, $ba12e603ee3d5d8e$var$Uf = 128, $ba12e603ee3d5d8e$var$Vf = $ba12e603ee3d5d8e$var$Tb.ReactCurrentDispatcher, $ba12e603ee3d5d8e$var$Wf = 0, $ba12e603ee3d5d8e$var$Xf = null, $ba12e603ee3d5d8e$var$O = null, $ba12e603ee3d5d8e$var$P = null, $ba12e603ee3d5d8e$var$Yf = null, $ba12e603ee3d5d8e$var$Q = null, $ba12e603ee3d5d8e$var$Zf = null, $ba12e603ee3d5d8e$var$$f = 0, $ba12e603ee3d5d8e$var$ag = null, $ba12e603ee3d5d8e$var$bg = 0, $ba12e603ee3d5d8e$var$cg = !1, $ba12e603ee3d5d8e$var$dg = null, $ba12e603ee3d5d8e$var$eg = 0;
function $ba12e603ee3d5d8e$var$fg() {
    $ba12e603ee3d5d8e$var$x("321");
}
function $ba12e603ee3d5d8e$var$gg(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$ba12e603ee3d5d8e$var$bd(a[c], b[c])) return !1;
    return !0;
}
function $ba12e603ee3d5d8e$var$hg(a, b, c, d, e, f) {
    $ba12e603ee3d5d8e$var$Wf = f;
    $ba12e603ee3d5d8e$var$Xf = b;
    $ba12e603ee3d5d8e$var$P = null !== a ? a.memoizedState : null;
    $ba12e603ee3d5d8e$var$Vf.current = null === $ba12e603ee3d5d8e$var$P ? $ba12e603ee3d5d8e$var$ig : $ba12e603ee3d5d8e$var$jg;
    b = c(d, e);
    if ($ba12e603ee3d5d8e$var$cg) {
        do $ba12e603ee3d5d8e$var$cg = !1, $ba12e603ee3d5d8e$var$eg += 1, $ba12e603ee3d5d8e$var$P = null !== a ? a.memoizedState : null, $ba12e603ee3d5d8e$var$Zf = $ba12e603ee3d5d8e$var$Yf, $ba12e603ee3d5d8e$var$ag = $ba12e603ee3d5d8e$var$Q = $ba12e603ee3d5d8e$var$O = null, $ba12e603ee3d5d8e$var$Vf.current = $ba12e603ee3d5d8e$var$jg, b = c(d, e);
        while ($ba12e603ee3d5d8e$var$cg);
        $ba12e603ee3d5d8e$var$dg = null;
        $ba12e603ee3d5d8e$var$eg = 0;
    }
    $ba12e603ee3d5d8e$var$Vf.current = $ba12e603ee3d5d8e$var$kg;
    a = $ba12e603ee3d5d8e$var$Xf;
    a.memoizedState = $ba12e603ee3d5d8e$var$Yf;
    a.expirationTime = $ba12e603ee3d5d8e$var$$f;
    a.updateQueue = $ba12e603ee3d5d8e$var$ag;
    a.effectTag |= $ba12e603ee3d5d8e$var$bg;
    a = null !== $ba12e603ee3d5d8e$var$O && null !== $ba12e603ee3d5d8e$var$O.next;
    $ba12e603ee3d5d8e$var$Wf = 0;
    $ba12e603ee3d5d8e$var$Zf = $ba12e603ee3d5d8e$var$Q = $ba12e603ee3d5d8e$var$Yf = $ba12e603ee3d5d8e$var$P = $ba12e603ee3d5d8e$var$O = $ba12e603ee3d5d8e$var$Xf = null;
    $ba12e603ee3d5d8e$var$$f = 0;
    $ba12e603ee3d5d8e$var$ag = null;
    $ba12e603ee3d5d8e$var$bg = 0;
    a && $ba12e603ee3d5d8e$var$x("300");
    return b;
}
function $ba12e603ee3d5d8e$var$lg() {
    $ba12e603ee3d5d8e$var$Vf.current = $ba12e603ee3d5d8e$var$kg;
    $ba12e603ee3d5d8e$var$Wf = 0;
    $ba12e603ee3d5d8e$var$Zf = $ba12e603ee3d5d8e$var$Q = $ba12e603ee3d5d8e$var$Yf = $ba12e603ee3d5d8e$var$P = $ba12e603ee3d5d8e$var$O = $ba12e603ee3d5d8e$var$Xf = null;
    $ba12e603ee3d5d8e$var$$f = 0;
    $ba12e603ee3d5d8e$var$ag = null;
    $ba12e603ee3d5d8e$var$bg = 0;
    $ba12e603ee3d5d8e$var$cg = !1;
    $ba12e603ee3d5d8e$var$dg = null;
    $ba12e603ee3d5d8e$var$eg = 0;
}
function $ba12e603ee3d5d8e$var$mg() {
    var a = {
        memoizedState: null,
        baseState: null,
        queue: null,
        baseUpdate: null,
        next: null
    };
    null === $ba12e603ee3d5d8e$var$Q ? $ba12e603ee3d5d8e$var$Yf = $ba12e603ee3d5d8e$var$Q = a : $ba12e603ee3d5d8e$var$Q = $ba12e603ee3d5d8e$var$Q.next = a;
    return $ba12e603ee3d5d8e$var$Q;
}
function $ba12e603ee3d5d8e$var$ng() {
    if (null !== $ba12e603ee3d5d8e$var$Zf) $ba12e603ee3d5d8e$var$Q = $ba12e603ee3d5d8e$var$Zf, $ba12e603ee3d5d8e$var$Zf = $ba12e603ee3d5d8e$var$Q.next, $ba12e603ee3d5d8e$var$O = $ba12e603ee3d5d8e$var$P, $ba12e603ee3d5d8e$var$P = null !== $ba12e603ee3d5d8e$var$O ? $ba12e603ee3d5d8e$var$O.next : null;
    else {
        null === $ba12e603ee3d5d8e$var$P && $ba12e603ee3d5d8e$var$x("310");
        $ba12e603ee3d5d8e$var$O = $ba12e603ee3d5d8e$var$P;
        var a = {
            memoizedState: $ba12e603ee3d5d8e$var$O.memoizedState,
            baseState: $ba12e603ee3d5d8e$var$O.baseState,
            queue: $ba12e603ee3d5d8e$var$O.queue,
            baseUpdate: $ba12e603ee3d5d8e$var$O.baseUpdate,
            next: null
        };
        $ba12e603ee3d5d8e$var$Q = null === $ba12e603ee3d5d8e$var$Q ? $ba12e603ee3d5d8e$var$Yf = a : $ba12e603ee3d5d8e$var$Q.next = a;
        $ba12e603ee3d5d8e$var$P = $ba12e603ee3d5d8e$var$O.next;
    }
    return $ba12e603ee3d5d8e$var$Q;
}
function $ba12e603ee3d5d8e$var$og(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $ba12e603ee3d5d8e$var$pg(a) {
    var b = $ba12e603ee3d5d8e$var$ng(), c = b.queue;
    null === c && $ba12e603ee3d5d8e$var$x("311");
    c.lastRenderedReducer = a;
    if (0 < $ba12e603ee3d5d8e$var$eg) {
        var d = c.dispatch;
        if (null !== $ba12e603ee3d5d8e$var$dg) {
            var e = $ba12e603ee3d5d8e$var$dg.get(c);
            if (void 0 !== e) {
                $ba12e603ee3d5d8e$var$dg.delete(c);
                var f = b.memoizedState;
                do f = a(f, e.action), e = e.next;
                while (null !== e);
                $ba12e603ee3d5d8e$var$bd(f, b.memoizedState) || ($ba12e603ee3d5d8e$var$qg = !0);
                b.memoizedState = f;
                b.baseUpdate === c.last && (b.baseState = f);
                c.lastRenderedState = f;
                return [
                    f,
                    d
                ];
            }
        }
        return [
            b.memoizedState,
            d
        ];
    }
    d = c.last;
    var g = b.baseUpdate;
    f = b.baseState;
    null !== g ? (null !== d && (d.next = null), d = g.next) : d = null !== d ? d.next : null;
    if (null !== d) {
        var h = e = null, l = d, k = !1;
        do {
            var m = l.expirationTime;
            m < $ba12e603ee3d5d8e$var$Wf ? (k || (k = !0, h = g, e = f), m > $ba12e603ee3d5d8e$var$$f && ($ba12e603ee3d5d8e$var$$f = m)) : f = l.eagerReducer === a ? l.eagerState : a(f, l.action);
            g = l;
            l = l.next;
        }while (null !== l && l !== d);
        k || (h = g, e = f);
        $ba12e603ee3d5d8e$var$bd(f, b.memoizedState) || ($ba12e603ee3d5d8e$var$qg = !0);
        b.memoizedState = f;
        b.baseUpdate = h;
        b.baseState = e;
        c.lastRenderedState = f;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $ba12e603ee3d5d8e$var$rg(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    null === $ba12e603ee3d5d8e$var$ag ? ($ba12e603ee3d5d8e$var$ag = {
        lastEffect: null
    }, $ba12e603ee3d5d8e$var$ag.lastEffect = a.next = a) : (b = $ba12e603ee3d5d8e$var$ag.lastEffect, null === b ? $ba12e603ee3d5d8e$var$ag.lastEffect = a.next = a : (c = b.next, b.next = a, a.next = c, $ba12e603ee3d5d8e$var$ag.lastEffect = a));
    return a;
}
function $ba12e603ee3d5d8e$var$sg(a, b, c, d) {
    var e = $ba12e603ee3d5d8e$var$mg();
    $ba12e603ee3d5d8e$var$bg |= a;
    e.memoizedState = $ba12e603ee3d5d8e$var$rg(b, c, void 0, void 0 === d ? null : d);
}
function $ba12e603ee3d5d8e$var$tg(a, b, c, d) {
    var e = $ba12e603ee3d5d8e$var$ng();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $ba12e603ee3d5d8e$var$O) {
        var g = $ba12e603ee3d5d8e$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $ba12e603ee3d5d8e$var$gg(d, g.deps)) {
            $ba12e603ee3d5d8e$var$rg($ba12e603ee3d5d8e$var$Nf, c, f, d);
            return;
        }
    }
    $ba12e603ee3d5d8e$var$bg |= a;
    e.memoizedState = $ba12e603ee3d5d8e$var$rg(b, c, f, d);
}
function $ba12e603ee3d5d8e$var$ug(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $ba12e603ee3d5d8e$var$vg() {}
function $ba12e603ee3d5d8e$var$wg(a, b, c) {
    25 > $ba12e603ee3d5d8e$var$eg || $ba12e603ee3d5d8e$var$x("301");
    var d = a.alternate;
    if (a === $ba12e603ee3d5d8e$var$Xf || null !== d && d === $ba12e603ee3d5d8e$var$Xf) {
        if ($ba12e603ee3d5d8e$var$cg = !0, a = {
            expirationTime: $ba12e603ee3d5d8e$var$Wf,
            action: c,
            eagerReducer: null,
            eagerState: null,
            next: null
        }, null === $ba12e603ee3d5d8e$var$dg && ($ba12e603ee3d5d8e$var$dg = new Map), c = $ba12e603ee3d5d8e$var$dg.get(b), void 0 === c) $ba12e603ee3d5d8e$var$dg.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    } else {
        $ba12e603ee3d5d8e$var$of();
        var e = $ba12e603ee3d5d8e$var$lf();
        e = $ba12e603ee3d5d8e$var$mf(e, a);
        var f = {
            expirationTime: e,
            action: c,
            eagerReducer: null,
            eagerState: null,
            next: null
        }, g = b.last;
        if (null === g) f.next = f;
        else {
            var h = g.next;
            null !== h && (f.next = h);
            g.next = f;
        }
        b.last = f;
        if (0 === a.expirationTime && (null === d || 0 === d.expirationTime) && (d = b.lastRenderedReducer, null !== d)) try {
            var l = b.lastRenderedState, k = d(l, c);
            f.eagerReducer = d;
            f.eagerState = k;
            if ($ba12e603ee3d5d8e$var$bd(k, l)) return;
        } catch (m) {} finally{}
        $ba12e603ee3d5d8e$var$qf(a, e);
    }
}
var $ba12e603ee3d5d8e$var$kg = {
    readContext: $ba12e603ee3d5d8e$var$M,
    useCallback: $ba12e603ee3d5d8e$var$fg,
    useContext: $ba12e603ee3d5d8e$var$fg,
    useEffect: $ba12e603ee3d5d8e$var$fg,
    useImperativeHandle: $ba12e603ee3d5d8e$var$fg,
    useLayoutEffect: $ba12e603ee3d5d8e$var$fg,
    useMemo: $ba12e603ee3d5d8e$var$fg,
    useReducer: $ba12e603ee3d5d8e$var$fg,
    useRef: $ba12e603ee3d5d8e$var$fg,
    useState: $ba12e603ee3d5d8e$var$fg,
    useDebugValue: $ba12e603ee3d5d8e$var$fg
}, $ba12e603ee3d5d8e$var$ig = {
    readContext: $ba12e603ee3d5d8e$var$M,
    useCallback: function(a, b) {
        $ba12e603ee3d5d8e$var$mg().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $ba12e603ee3d5d8e$var$M,
    useEffect: function(a, b) {
        return $ba12e603ee3d5d8e$var$sg(516, $ba12e603ee3d5d8e$var$Uf | $ba12e603ee3d5d8e$var$Tf, a, b);
    },
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $ba12e603ee3d5d8e$var$sg(4, $ba12e603ee3d5d8e$var$Pf | $ba12e603ee3d5d8e$var$Sf, $ba12e603ee3d5d8e$var$ug.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $ba12e603ee3d5d8e$var$sg(4, $ba12e603ee3d5d8e$var$Pf | $ba12e603ee3d5d8e$var$Sf, a, b);
    },
    useMemo: function(a, b) {
        var c = $ba12e603ee3d5d8e$var$mg();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $ba12e603ee3d5d8e$var$mg();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            last: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = $ba12e603ee3d5d8e$var$wg.bind(null, $ba12e603ee3d5d8e$var$Xf, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $ba12e603ee3d5d8e$var$mg();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: function(a) {
        var b = $ba12e603ee3d5d8e$var$mg();
        "function" === typeof a && (a = a());
        b.memoizedState = b.baseState = a;
        a = b.queue = {
            last: null,
            dispatch: null,
            lastRenderedReducer: $ba12e603ee3d5d8e$var$og,
            lastRenderedState: a
        };
        a = a.dispatch = $ba12e603ee3d5d8e$var$wg.bind(null, $ba12e603ee3d5d8e$var$Xf, a);
        return [
            b.memoizedState,
            a
        ];
    },
    useDebugValue: $ba12e603ee3d5d8e$var$vg
}, $ba12e603ee3d5d8e$var$jg = {
    readContext: $ba12e603ee3d5d8e$var$M,
    useCallback: function(a, b) {
        var c = $ba12e603ee3d5d8e$var$ng();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && $ba12e603ee3d5d8e$var$gg(b, d[1])) return d[0];
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useContext: $ba12e603ee3d5d8e$var$M,
    useEffect: function(a, b) {
        return $ba12e603ee3d5d8e$var$tg(516, $ba12e603ee3d5d8e$var$Uf | $ba12e603ee3d5d8e$var$Tf, a, b);
    },
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $ba12e603ee3d5d8e$var$tg(4, $ba12e603ee3d5d8e$var$Pf | $ba12e603ee3d5d8e$var$Sf, $ba12e603ee3d5d8e$var$ug.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $ba12e603ee3d5d8e$var$tg(4, $ba12e603ee3d5d8e$var$Pf | $ba12e603ee3d5d8e$var$Sf, a, b);
    },
    useMemo: function(a, b) {
        var c = $ba12e603ee3d5d8e$var$ng();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && $ba12e603ee3d5d8e$var$gg(b, d[1])) return d[0];
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: $ba12e603ee3d5d8e$var$pg,
    useRef: function() {
        return $ba12e603ee3d5d8e$var$ng().memoizedState;
    },
    useState: function(a) {
        return $ba12e603ee3d5d8e$var$pg($ba12e603ee3d5d8e$var$og, a);
    },
    useDebugValue: $ba12e603ee3d5d8e$var$vg
}, $ba12e603ee3d5d8e$var$xg = null, $ba12e603ee3d5d8e$var$yg = null, $ba12e603ee3d5d8e$var$zg = !1;
function $ba12e603ee3d5d8e$var$Ag(a, b) {
    var c = $ba12e603ee3d5d8e$var$K(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function $ba12e603ee3d5d8e$var$Bg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function $ba12e603ee3d5d8e$var$Cg(a) {
    if ($ba12e603ee3d5d8e$var$zg) {
        var b = $ba12e603ee3d5d8e$var$yg;
        if (b) {
            var c = b;
            if (!$ba12e603ee3d5d8e$var$Bg(a, b)) {
                b = $ba12e603ee3d5d8e$var$De(c);
                if (!b || !$ba12e603ee3d5d8e$var$Bg(a, b)) {
                    a.effectTag |= 2;
                    $ba12e603ee3d5d8e$var$zg = !1;
                    $ba12e603ee3d5d8e$var$xg = a;
                    return;
                }
                $ba12e603ee3d5d8e$var$Ag($ba12e603ee3d5d8e$var$xg, c);
            }
            $ba12e603ee3d5d8e$var$xg = a;
            $ba12e603ee3d5d8e$var$yg = $ba12e603ee3d5d8e$var$Ee(b);
        } else a.effectTag |= 2, $ba12e603ee3d5d8e$var$zg = !1, $ba12e603ee3d5d8e$var$xg = a;
    }
}
function $ba12e603ee3d5d8e$var$Dg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 18 !== a.tag;)a = a.return;
    $ba12e603ee3d5d8e$var$xg = a;
}
function $ba12e603ee3d5d8e$var$Eg(a) {
    if (a !== $ba12e603ee3d5d8e$var$xg) return !1;
    if (!$ba12e603ee3d5d8e$var$zg) return $ba12e603ee3d5d8e$var$Dg(a), $ba12e603ee3d5d8e$var$zg = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !$ba12e603ee3d5d8e$var$xe(b, a.memoizedProps)) for(b = $ba12e603ee3d5d8e$var$yg; b;)$ba12e603ee3d5d8e$var$Ag(a, b), b = $ba12e603ee3d5d8e$var$De(b);
    $ba12e603ee3d5d8e$var$Dg(a);
    $ba12e603ee3d5d8e$var$yg = $ba12e603ee3d5d8e$var$xg ? $ba12e603ee3d5d8e$var$De(a.stateNode) : null;
    return !0;
}
function $ba12e603ee3d5d8e$var$Fg() {
    $ba12e603ee3d5d8e$var$yg = $ba12e603ee3d5d8e$var$xg = null;
    $ba12e603ee3d5d8e$var$zg = !1;
}
var $ba12e603ee3d5d8e$var$Gg = $ba12e603ee3d5d8e$var$Tb.ReactCurrentOwner, $ba12e603ee3d5d8e$var$qg = !1;
function $ba12e603ee3d5d8e$var$S(a, b, c, d) {
    b.child = null === a ? $ba12e603ee3d5d8e$var$Ef(b, null, c, d) : $ba12e603ee3d5d8e$var$Df(b, a.child, c, d);
}
function $ba12e603ee3d5d8e$var$Hg(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $ba12e603ee3d5d8e$var$Ig(b, e);
    d = $ba12e603ee3d5d8e$var$hg(a, b, c, d, f, e);
    if (null !== a && !$ba12e603ee3d5d8e$var$qg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $ba12e603ee3d5d8e$var$Jg(a, b, e);
    b.effectTag |= 1;
    $ba12e603ee3d5d8e$var$S(a, b, d, e);
    return b.child;
}
function $ba12e603ee3d5d8e$var$Kg(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !$ba12e603ee3d5d8e$var$Ve(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, $ba12e603ee3d5d8e$var$Lg(a, b, g, d, e, f);
        a = $ba12e603ee3d5d8e$var$Ye(c.type, null, d, null, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : $ba12e603ee3d5d8e$var$dd, c(e, d) && a.ref === b.ref)) return $ba12e603ee3d5d8e$var$Jg(a, b, f);
    b.effectTag |= 1;
    a = $ba12e603ee3d5d8e$var$Xe(g, d, f);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $ba12e603ee3d5d8e$var$Lg(a, b, c, d, e, f) {
    return null !== a && $ba12e603ee3d5d8e$var$dd(a.memoizedProps, d) && a.ref === b.ref && ($ba12e603ee3d5d8e$var$qg = !1, e < f) ? $ba12e603ee3d5d8e$var$Jg(a, b, f) : $ba12e603ee3d5d8e$var$Mg(a, b, c, d, f);
}
function $ba12e603ee3d5d8e$var$Ng(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}
function $ba12e603ee3d5d8e$var$Mg(a, b, c, d, e) {
    var f = $ba12e603ee3d5d8e$var$J(c) ? $ba12e603ee3d5d8e$var$Ie : $ba12e603ee3d5d8e$var$H.current;
    f = $ba12e603ee3d5d8e$var$Je(b, f);
    $ba12e603ee3d5d8e$var$Ig(b, e);
    c = $ba12e603ee3d5d8e$var$hg(a, b, c, d, f, e);
    if (null !== a && !$ba12e603ee3d5d8e$var$qg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $ba12e603ee3d5d8e$var$Jg(a, b, e);
    b.effectTag |= 1;
    $ba12e603ee3d5d8e$var$S(a, b, c, e);
    return b.child;
}
function $ba12e603ee3d5d8e$var$Og(a, b, c, d, e) {
    if ($ba12e603ee3d5d8e$var$J(c)) {
        var f = !0;
        $ba12e603ee3d5d8e$var$Oe(b);
    } else f = !1;
    $ba12e603ee3d5d8e$var$Ig(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), $ba12e603ee3d5d8e$var$vf(b, c, d, e), $ba12e603ee3d5d8e$var$xf(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var l = g.context, k = c.contextType;
        "object" === typeof k && null !== k ? k = $ba12e603ee3d5d8e$var$M(k) : (k = $ba12e603ee3d5d8e$var$J(c) ? $ba12e603ee3d5d8e$var$Ie : $ba12e603ee3d5d8e$var$H.current, k = $ba12e603ee3d5d8e$var$Je(b, k));
        var m = c.getDerivedStateFromProps, p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        p || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || l !== k) && $ba12e603ee3d5d8e$var$wf(b, g, d, k);
        $ba12e603ee3d5d8e$var$Pg = !1;
        var t = b.memoizedState;
        l = g.state = t;
        var A = b.updateQueue;
        null !== A && ($ba12e603ee3d5d8e$var$yf(b, A, d, g, e), l = b.memoizedState);
        h !== d || t !== l || $ba12e603ee3d5d8e$var$I.current || $ba12e603ee3d5d8e$var$Pg ? ("function" === typeof m && ($ba12e603ee3d5d8e$var$kf(b, c, m, d), l = b.memoizedState), (h = $ba12e603ee3d5d8e$var$Pg || $ba12e603ee3d5d8e$var$uf(b, c, h, d, t, l, k)) ? (p || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = l), g.props = d, g.state = l, g.context = k, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    } else g = b.stateNode, h = b.memoizedProps, g.props = b.type === b.elementType ? h : $ba12e603ee3d5d8e$var$L(b.type, h), l = g.context, k = c.contextType, "object" === typeof k && null !== k ? k = $ba12e603ee3d5d8e$var$M(k) : (k = $ba12e603ee3d5d8e$var$J(c) ? $ba12e603ee3d5d8e$var$Ie : $ba12e603ee3d5d8e$var$H.current, k = $ba12e603ee3d5d8e$var$Je(b, k)), m = c.getDerivedStateFromProps, (p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || l !== k) && $ba12e603ee3d5d8e$var$wf(b, g, d, k), $ba12e603ee3d5d8e$var$Pg = !1, l = b.memoizedState, t = g.state = l, A = b.updateQueue, null !== A && ($ba12e603ee3d5d8e$var$yf(b, A, d, g, e), t = b.memoizedState), h !== d || l !== t || $ba12e603ee3d5d8e$var$I.current || $ba12e603ee3d5d8e$var$Pg ? ("function" === typeof m && ($ba12e603ee3d5d8e$var$kf(b, c, m, d), t = b.memoizedState), (m = $ba12e603ee3d5d8e$var$Pg || $ba12e603ee3d5d8e$var$uf(b, c, h, d, l, t, k)) ? (p || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, t, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, t, k)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && l === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && l === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = t), g.props = d, g.state = t, g.context = k, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && l === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && l === a.memoizedState || (b.effectTag |= 256), d = !1);
    return $ba12e603ee3d5d8e$var$Qg(a, b, c, d, f, e);
}
function $ba12e603ee3d5d8e$var$Qg(a, b, c, d, e, f) {
    $ba12e603ee3d5d8e$var$Ng(a, b);
    var g = 0 !== (b.effectTag & 64);
    if (!d && !g) return e && $ba12e603ee3d5d8e$var$Pe(b, c, !1), $ba12e603ee3d5d8e$var$Jg(a, b, f);
    d = b.stateNode;
    $ba12e603ee3d5d8e$var$Gg.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.effectTag |= 1;
    null !== a && g ? (b.child = $ba12e603ee3d5d8e$var$Df(b, a.child, null, f), b.child = $ba12e603ee3d5d8e$var$Df(b, null, h, f)) : $ba12e603ee3d5d8e$var$S(a, b, h, f);
    b.memoizedState = d.state;
    e && $ba12e603ee3d5d8e$var$Pe(b, c, !0);
    return b.child;
}
function $ba12e603ee3d5d8e$var$Rg(a) {
    var b = a.stateNode;
    b.pendingContext ? $ba12e603ee3d5d8e$var$Me(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $ba12e603ee3d5d8e$var$Me(a, b.context, !1);
    $ba12e603ee3d5d8e$var$Jf(a, b.containerInfo);
}
function $ba12e603ee3d5d8e$var$Sg(a, b, c) {
    var d = b.mode, e = b.pendingProps, f = b.memoizedState;
    if (0 === (b.effectTag & 64)) {
        f = null;
        var g = !1;
    } else f = {
        timedOutAt: null !== f ? f.timedOutAt : 0
    }, g = !0, b.effectTag &= -65;
    if (null === a) {
        if (g) {
            var h = e.fallback;
            a = $ba12e603ee3d5d8e$var$Ze(null, d, 0, null);
            0 === (b.mode & 1) && (a.child = null !== b.memoizedState ? b.child.child : b.child);
            d = $ba12e603ee3d5d8e$var$Ze(h, d, c, null);
            a.sibling = d;
            c = a;
            c.return = d.return = b;
        } else c = d = $ba12e603ee3d5d8e$var$Ef(b, null, e.children, c);
    } else null !== a.memoizedState ? (d = a.child, h = d.sibling, g ? (c = e.fallback, e = $ba12e603ee3d5d8e$var$Xe(d, d.pendingProps, 0), 0 === (b.mode & 1) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== d.child && (e.child = g)), d = e.sibling = $ba12e603ee3d5d8e$var$Xe(h, c, h.expirationTime), c = e, e.childExpirationTime = 0, c.return = d.return = b) : c = d = $ba12e603ee3d5d8e$var$Df(b, d.child, e.children, c)) : (h = a.child, g ? (g = e.fallback, e = $ba12e603ee3d5d8e$var$Ze(null, d, 0, null), e.child = h, 0 === (b.mode & 1) && (e.child = null !== b.memoizedState ? b.child.child : b.child), d = e.sibling = $ba12e603ee3d5d8e$var$Ze(g, d, c, null), d.effectTag |= 2, c = e, e.childExpirationTime = 0, c.return = d.return = b) : d = c = $ba12e603ee3d5d8e$var$Df(b, h, e.children, c)), b.stateNode = a.stateNode;
    b.memoizedState = f;
    b.child = c;
    return d;
}
function $ba12e603ee3d5d8e$var$Jg(a, b, c) {
    null !== a && (b.contextDependencies = a.contextDependencies);
    if (b.childExpirationTime < c) return null;
    null !== a && b.child !== a.child && $ba12e603ee3d5d8e$var$x("153");
    if (null !== b.child) {
        a = b.child;
        c = $ba12e603ee3d5d8e$var$Xe(a, a.pendingProps, a.expirationTime);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $ba12e603ee3d5d8e$var$Xe(a, a.pendingProps, a.expirationTime), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $ba12e603ee3d5d8e$var$Tg(a, b, c) {
    var d = b.expirationTime;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $ba12e603ee3d5d8e$var$I.current) $ba12e603ee3d5d8e$var$qg = !0;
        else if (d < c) {
            $ba12e603ee3d5d8e$var$qg = !1;
            switch(b.tag){
                case 3:
                    $ba12e603ee3d5d8e$var$Rg(b);
                    $ba12e603ee3d5d8e$var$Fg();
                    break;
                case 5:
                    $ba12e603ee3d5d8e$var$Lf(b);
                    break;
                case 1:
                    $ba12e603ee3d5d8e$var$J(b.type) && $ba12e603ee3d5d8e$var$Oe(b);
                    break;
                case 4:
                    $ba12e603ee3d5d8e$var$Jf(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    $ba12e603ee3d5d8e$var$Ug(b, b.memoizedProps.value);
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        d = b.child.childExpirationTime;
                        if (0 !== d && d >= c) return $ba12e603ee3d5d8e$var$Sg(a, b, c);
                        b = $ba12e603ee3d5d8e$var$Jg(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
            }
            return $ba12e603ee3d5d8e$var$Jg(a, b, c);
        }
    } else $ba12e603ee3d5d8e$var$qg = !1;
    b.expirationTime = 0;
    switch(b.tag){
        case 2:
            d = b.elementType;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            var e = $ba12e603ee3d5d8e$var$Je(b, $ba12e603ee3d5d8e$var$H.current);
            $ba12e603ee3d5d8e$var$Ig(b, c);
            e = $ba12e603ee3d5d8e$var$hg(null, b, d, a, e, c);
            b.effectTag |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                $ba12e603ee3d5d8e$var$lg();
                if ($ba12e603ee3d5d8e$var$J(d)) {
                    var f = !0;
                    $ba12e603ee3d5d8e$var$Oe(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && $ba12e603ee3d5d8e$var$kf(b, d, g, a);
                e.updater = $ba12e603ee3d5d8e$var$tf;
                b.stateNode = e;
                e._reactInternalFiber = b;
                $ba12e603ee3d5d8e$var$xf(b, d, a, c);
                b = $ba12e603ee3d5d8e$var$Qg(null, b, d, !0, f, c);
            } else b.tag = 0, $ba12e603ee3d5d8e$var$S(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            f = b.pendingProps;
            a = $ba12e603ee3d5d8e$var$hf(e);
            b.type = a;
            e = b.tag = $ba12e603ee3d5d8e$var$We(a);
            f = $ba12e603ee3d5d8e$var$L(a, f);
            g = void 0;
            switch(e){
                case 0:
                    g = $ba12e603ee3d5d8e$var$Mg(null, b, a, f, c);
                    break;
                case 1:
                    g = $ba12e603ee3d5d8e$var$Og(null, b, a, f, c);
                    break;
                case 11:
                    g = $ba12e603ee3d5d8e$var$Hg(null, b, a, f, c);
                    break;
                case 14:
                    g = $ba12e603ee3d5d8e$var$Kg(null, b, a, $ba12e603ee3d5d8e$var$L(a.type, f), d, c);
                    break;
                default:
                    $ba12e603ee3d5d8e$var$x("306", a, "");
            }
            return g;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $ba12e603ee3d5d8e$var$L(d, e), $ba12e603ee3d5d8e$var$Mg(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $ba12e603ee3d5d8e$var$L(d, e), $ba12e603ee3d5d8e$var$Og(a, b, d, e, c);
        case 3:
            $ba12e603ee3d5d8e$var$Rg(b);
            d = b.updateQueue;
            null === d && $ba12e603ee3d5d8e$var$x("282");
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            $ba12e603ee3d5d8e$var$yf(b, d, b.pendingProps, null, c);
            d = b.memoizedState.element;
            if (d === e) $ba12e603ee3d5d8e$var$Fg(), b = $ba12e603ee3d5d8e$var$Jg(a, b, c);
            else {
                e = b.stateNode;
                if (e = (null === a || null === a.child) && e.hydrate) $ba12e603ee3d5d8e$var$yg = $ba12e603ee3d5d8e$var$Ee(b.stateNode.containerInfo), $ba12e603ee3d5d8e$var$xg = b, e = $ba12e603ee3d5d8e$var$zg = !0;
                e ? (b.effectTag |= 2, b.child = $ba12e603ee3d5d8e$var$Ef(b, null, d, c)) : ($ba12e603ee3d5d8e$var$S(a, b, d, c), $ba12e603ee3d5d8e$var$Fg());
                b = b.child;
            }
            return b;
        case 5:
            return $ba12e603ee3d5d8e$var$Lf(b), null === a && $ba12e603ee3d5d8e$var$Cg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $ba12e603ee3d5d8e$var$xe(d, e) ? g = null : null !== f && $ba12e603ee3d5d8e$var$xe(d, f) && (b.effectTag |= 16), $ba12e603ee3d5d8e$var$Ng(a, b), 1 !== c && b.mode & 1 && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : ($ba12e603ee3d5d8e$var$S(a, b, g, c), b = b.child), b;
        case 6:
            return null === a && $ba12e603ee3d5d8e$var$Cg(b), null;
        case 13:
            return $ba12e603ee3d5d8e$var$Sg(a, b, c);
        case 4:
            return $ba12e603ee3d5d8e$var$Jf(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $ba12e603ee3d5d8e$var$Df(b, null, d, c) : $ba12e603ee3d5d8e$var$S(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $ba12e603ee3d5d8e$var$L(d, e), $ba12e603ee3d5d8e$var$Hg(a, b, d, e, c);
        case 7:
            return $ba12e603ee3d5d8e$var$S(a, b, b.pendingProps, c), b.child;
        case 8:
            return $ba12e603ee3d5d8e$var$S(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $ba12e603ee3d5d8e$var$S(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                $ba12e603ee3d5d8e$var$Ug(b, f);
                if (null !== g) {
                    var h = g.value;
                    f = $ba12e603ee3d5d8e$var$bd(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0;
                    if (0 === f) {
                        if (g.children === e.children && !$ba12e603ee3d5d8e$var$I.current) {
                            b = $ba12e603ee3d5d8e$var$Jg(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var l = h.contextDependencies;
                        if (null !== l) {
                            g = h.child;
                            for(var k = l.first; null !== k;){
                                if (k.context === d && 0 !== (k.observedBits & f)) {
                                    1 === h.tag && (k = $ba12e603ee3d5d8e$var$nf(c), k.tag = $ba12e603ee3d5d8e$var$sf, $ba12e603ee3d5d8e$var$pf(h, k));
                                    h.expirationTime < c && (h.expirationTime = c);
                                    k = h.alternate;
                                    null !== k && k.expirationTime < c && (k.expirationTime = c);
                                    k = c;
                                    for(var m = h.return; null !== m;){
                                        var p = m.alternate;
                                        if (m.childExpirationTime < k) m.childExpirationTime = k, null !== p && p.childExpirationTime < k && (p.childExpirationTime = k);
                                        else if (null !== p && p.childExpirationTime < k) p.childExpirationTime = k;
                                        else break;
                                        m = m.return;
                                    }
                                    l.expirationTime < c && (l.expirationTime = c);
                                    break;
                                }
                                k = k.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                $ba12e603ee3d5d8e$var$S(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, $ba12e603ee3d5d8e$var$Ig(b, c), e = $ba12e603ee3d5d8e$var$M(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, $ba12e603ee3d5d8e$var$S(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = $ba12e603ee3d5d8e$var$L(e, b.pendingProps), f = $ba12e603ee3d5d8e$var$L(e.type, f), $ba12e603ee3d5d8e$var$Kg(a, b, e, f, d, c);
        case 15:
            return $ba12e603ee3d5d8e$var$Lg(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $ba12e603ee3d5d8e$var$L(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, $ba12e603ee3d5d8e$var$J(d) ? (a = !0, $ba12e603ee3d5d8e$var$Oe(b)) : a = !1, $ba12e603ee3d5d8e$var$Ig(b, c), $ba12e603ee3d5d8e$var$vf(b, d, e, c), $ba12e603ee3d5d8e$var$xf(b, d, e, c), $ba12e603ee3d5d8e$var$Qg(null, b, d, !0, a, c);
    }
    $ba12e603ee3d5d8e$var$x("156");
}
var $ba12e603ee3d5d8e$var$Vg = {
    current: null
}, $ba12e603ee3d5d8e$var$Wg = null, $ba12e603ee3d5d8e$var$Xg = null, $ba12e603ee3d5d8e$var$Yg = null;
function $ba12e603ee3d5d8e$var$Ug(a, b) {
    var c = a.type._context;
    $ba12e603ee3d5d8e$var$G($ba12e603ee3d5d8e$var$Vg, c._currentValue, a);
    c._currentValue = b;
}
function $ba12e603ee3d5d8e$var$Zg(a) {
    var b = $ba12e603ee3d5d8e$var$Vg.current;
    $ba12e603ee3d5d8e$var$F($ba12e603ee3d5d8e$var$Vg, a);
    a.type._context._currentValue = b;
}
function $ba12e603ee3d5d8e$var$Ig(a, b) {
    $ba12e603ee3d5d8e$var$Wg = a;
    $ba12e603ee3d5d8e$var$Yg = $ba12e603ee3d5d8e$var$Xg = null;
    var c = a.contextDependencies;
    null !== c && c.expirationTime >= b && ($ba12e603ee3d5d8e$var$qg = !0);
    a.contextDependencies = null;
}
function $ba12e603ee3d5d8e$var$M(a, b) {
    if ($ba12e603ee3d5d8e$var$Yg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) $ba12e603ee3d5d8e$var$Yg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        null === $ba12e603ee3d5d8e$var$Xg ? (null === $ba12e603ee3d5d8e$var$Wg && $ba12e603ee3d5d8e$var$x("308"), $ba12e603ee3d5d8e$var$Xg = b, $ba12e603ee3d5d8e$var$Wg.contextDependencies = {
            first: b,
            expirationTime: 0
        }) : $ba12e603ee3d5d8e$var$Xg = $ba12e603ee3d5d8e$var$Xg.next = b;
    }
    return a._currentValue;
}
var $ba12e603ee3d5d8e$var$$g = 0, $ba12e603ee3d5d8e$var$rf = 1, $ba12e603ee3d5d8e$var$sf = 2, $ba12e603ee3d5d8e$var$ah = 3, $ba12e603ee3d5d8e$var$Pg = !1;
function $ba12e603ee3d5d8e$var$bh(a) {
    return {
        baseState: a,
        firstUpdate: null,
        lastUpdate: null,
        firstCapturedUpdate: null,
        lastCapturedUpdate: null,
        firstEffect: null,
        lastEffect: null,
        firstCapturedEffect: null,
        lastCapturedEffect: null
    };
}
function $ba12e603ee3d5d8e$var$ch(a) {
    return {
        baseState: a.baseState,
        firstUpdate: a.firstUpdate,
        lastUpdate: a.lastUpdate,
        firstCapturedUpdate: null,
        lastCapturedUpdate: null,
        firstEffect: null,
        lastEffect: null,
        firstCapturedEffect: null,
        lastCapturedEffect: null
    };
}
function $ba12e603ee3d5d8e$var$nf(a) {
    return {
        expirationTime: a,
        tag: $ba12e603ee3d5d8e$var$$g,
        payload: null,
        callback: null,
        next: null,
        nextEffect: null
    };
}
function $ba12e603ee3d5d8e$var$dh(a, b) {
    null === a.lastUpdate ? a.firstUpdate = a.lastUpdate = b : (a.lastUpdate.next = b, a.lastUpdate = b);
}
function $ba12e603ee3d5d8e$var$pf(a, b) {
    var c = a.alternate;
    if (null === c) {
        var d = a.updateQueue;
        var e = null;
        null === d && (d = a.updateQueue = $ba12e603ee3d5d8e$var$bh(a.memoizedState));
    } else d = a.updateQueue, e = c.updateQueue, null === d ? null === e ? (d = a.updateQueue = $ba12e603ee3d5d8e$var$bh(a.memoizedState), e = c.updateQueue = $ba12e603ee3d5d8e$var$bh(c.memoizedState)) : d = a.updateQueue = $ba12e603ee3d5d8e$var$ch(e) : null === e && (e = c.updateQueue = $ba12e603ee3d5d8e$var$ch(d));
    null === e || d === e ? $ba12e603ee3d5d8e$var$dh(d, b) : null === d.lastUpdate || null === e.lastUpdate ? ($ba12e603ee3d5d8e$var$dh(d, b), $ba12e603ee3d5d8e$var$dh(e, b)) : ($ba12e603ee3d5d8e$var$dh(d, b), e.lastUpdate = b);
}
function $ba12e603ee3d5d8e$var$eh(a, b) {
    var c = a.updateQueue;
    c = null === c ? a.updateQueue = $ba12e603ee3d5d8e$var$bh(a.memoizedState) : $ba12e603ee3d5d8e$var$fh(a, c);
    null === c.lastCapturedUpdate ? c.firstCapturedUpdate = c.lastCapturedUpdate = b : (c.lastCapturedUpdate.next = b, c.lastCapturedUpdate = b);
}
function $ba12e603ee3d5d8e$var$fh(a, b) {
    var c = a.alternate;
    null !== c && b === c.updateQueue && (b = a.updateQueue = $ba12e603ee3d5d8e$var$ch(b));
    return b;
}
function $ba12e603ee3d5d8e$var$gh(a, b, c, d, e, f) {
    switch(c.tag){
        case $ba12e603ee3d5d8e$var$rf:
            return a = c.payload, "function" === typeof a ? a.call(f, d, e) : a;
        case $ba12e603ee3d5d8e$var$ah:
            a.effectTag = a.effectTag & -2049 | 64;
        case $ba12e603ee3d5d8e$var$$g:
            a = c.payload;
            e = "function" === typeof a ? a.call(f, d, e) : a;
            if (null === e || void 0 === e) break;
            return $63ReS({}, d, e);
        case $ba12e603ee3d5d8e$var$sf:
            $ba12e603ee3d5d8e$var$Pg = !0;
    }
    return d;
}
function $ba12e603ee3d5d8e$var$yf(a, b, c, d, e) {
    $ba12e603ee3d5d8e$var$Pg = !1;
    b = $ba12e603ee3d5d8e$var$fh(a, b);
    for(var f = b.baseState, g = null, h = 0, l = b.firstUpdate, k = f; null !== l;){
        var m = l.expirationTime;
        m < e ? (null === g && (g = l, f = k), h < m && (h = m)) : (k = $ba12e603ee3d5d8e$var$gh(a, b, l, k, c, d), null !== l.callback && (a.effectTag |= 32, l.nextEffect = null, null === b.lastEffect ? b.firstEffect = b.lastEffect = l : (b.lastEffect.nextEffect = l, b.lastEffect = l)));
        l = l.next;
    }
    m = null;
    for(l = b.firstCapturedUpdate; null !== l;){
        var p = l.expirationTime;
        p < e ? (null === m && (m = l, null === g && (f = k)), h < p && (h = p)) : (k = $ba12e603ee3d5d8e$var$gh(a, b, l, k, c, d), null !== l.callback && (a.effectTag |= 32, l.nextEffect = null, null === b.lastCapturedEffect ? b.firstCapturedEffect = b.lastCapturedEffect = l : (b.lastCapturedEffect.nextEffect = l, b.lastCapturedEffect = l)));
        l = l.next;
    }
    null === g && (b.lastUpdate = null);
    null === m ? b.lastCapturedUpdate = null : a.effectTag |= 32;
    null === g && null === m && (f = k);
    b.baseState = f;
    b.firstUpdate = g;
    b.firstCapturedUpdate = m;
    a.expirationTime = h;
    a.memoizedState = k;
}
function $ba12e603ee3d5d8e$var$hh(a, b, c) {
    null !== b.firstCapturedUpdate && (null !== b.lastUpdate && (b.lastUpdate.next = b.firstCapturedUpdate, b.lastUpdate = b.lastCapturedUpdate), b.firstCapturedUpdate = b.lastCapturedUpdate = null);
    $ba12e603ee3d5d8e$var$ih(b.firstEffect, c);
    b.firstEffect = b.lastEffect = null;
    $ba12e603ee3d5d8e$var$ih(b.firstCapturedEffect, c);
    b.firstCapturedEffect = b.lastCapturedEffect = null;
}
function $ba12e603ee3d5d8e$var$ih(a, b) {
    for(; null !== a;){
        var c = a.callback;
        if (null !== c) {
            a.callback = null;
            var d = b;
            "function" !== typeof c && $ba12e603ee3d5d8e$var$x("191", c);
            c.call(d);
        }
        a = a.nextEffect;
    }
}
function $ba12e603ee3d5d8e$var$jh(a, b) {
    return {
        value: a,
        source: b,
        stack: $ba12e603ee3d5d8e$var$jc(b)
    };
}
function $ba12e603ee3d5d8e$var$kh(a) {
    a.effectTag |= 4;
}
var $ba12e603ee3d5d8e$var$lh = void 0, $ba12e603ee3d5d8e$var$mh = void 0, $ba12e603ee3d5d8e$var$nh = void 0, $ba12e603ee3d5d8e$var$oh = void 0;
$ba12e603ee3d5d8e$var$lh = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$ba12e603ee3d5d8e$var$mh = function() {};
$ba12e603ee3d5d8e$var$nh = function(a, b, c, d, e) {
    var f = a.memoizedProps;
    if (f !== d) {
        var g = b.stateNode;
        $ba12e603ee3d5d8e$var$If($ba12e603ee3d5d8e$var$N.current);
        a = null;
        switch(c){
            case "input":
                f = $ba12e603ee3d5d8e$var$vc(g, f);
                d = $ba12e603ee3d5d8e$var$vc(g, d);
                a = [];
                break;
            case "option":
                f = $ba12e603ee3d5d8e$var$$d(g, f);
                d = $ba12e603ee3d5d8e$var$$d(g, d);
                a = [];
                break;
            case "select":
                f = $63ReS({}, f, {
                    value: void 0
                });
                d = $63ReS({}, d, {
                    value: void 0
                });
                a = [];
                break;
            case "textarea":
                f = $ba12e603ee3d5d8e$var$be(g, f);
                d = $ba12e603ee3d5d8e$var$be(g, d);
                a = [];
                break;
            default:
                "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = $ba12e603ee3d5d8e$var$te);
        }
        $ba12e603ee3d5d8e$var$qe(c, d);
        g = c = void 0;
        var h = null;
        for(c in f)if (!d.hasOwnProperty(c) && f.hasOwnProperty(c) && null != f[c]) {
            if ("style" === c) {
                var l = f[c];
                for(g in l)l.hasOwnProperty(g) && (h || (h = {}), h[g] = "");
            } else "dangerouslySetInnerHTML" !== c && "children" !== c && "suppressContentEditableWarning" !== c && "suppressHydrationWarning" !== c && "autoFocus" !== c && ($ba12e603ee3d5d8e$var$ra.hasOwnProperty(c) ? a || (a = []) : (a = a || []).push(c, null));
        }
        for(c in d){
            var k = d[c];
            l = null != f ? f[c] : void 0;
            if (d.hasOwnProperty(c) && k !== l && (null != k || null != l)) {
                if ("style" === c) {
                    if (l) {
                        for(g in l)!l.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (h || (h = {}), h[g] = "");
                        for(g in k)k.hasOwnProperty(g) && l[g] !== k[g] && (h || (h = {}), h[g] = k[g]);
                    } else h || (a || (a = []), a.push(c, h)), h = k;
                } else "dangerouslySetInnerHTML" === c ? (k = k ? k.__html : void 0, l = l ? l.__html : void 0, null != k && l !== k && (a = a || []).push(c, "" + k)) : "children" === c ? l === k || "string" !== typeof k && "number" !== typeof k || (a = a || []).push(c, "" + k) : "suppressContentEditableWarning" !== c && "suppressHydrationWarning" !== c && ($ba12e603ee3d5d8e$var$ra.hasOwnProperty(c) ? (null != k && $ba12e603ee3d5d8e$var$se(e, c), a || l === k || (a = [])) : (a = a || []).push(c, k));
            }
        }
        h && (a = a || []).push("style", h);
        e = a;
        (b.updateQueue = e) && $ba12e603ee3d5d8e$var$kh(b);
    }
};
$ba12e603ee3d5d8e$var$oh = function(a, b, c, d) {
    c !== d && $ba12e603ee3d5d8e$var$kh(b);
};
var $ba12e603ee3d5d8e$var$ph = "function" === typeof WeakSet ? WeakSet : Set;
function $ba12e603ee3d5d8e$var$qh(a, b) {
    var c = b.source, d = b.stack;
    null === d && null !== c && (d = $ba12e603ee3d5d8e$var$jc(c));
    null !== c && $ba12e603ee3d5d8e$var$ic(c.type);
    b = b.value;
    null !== a && 1 === a.tag && $ba12e603ee3d5d8e$var$ic(a.type);
    try {
        console.error(b);
    } catch (e) {
        setTimeout(function() {
            throw e;
        });
    }
}
function $ba12e603ee3d5d8e$var$rh(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            $ba12e603ee3d5d8e$var$sh(a, c);
        }
        else b.current = null;
    }
}
function $ba12e603ee3d5d8e$var$th(a, b, c) {
    c = c.updateQueue;
    c = null !== c ? c.lastEffect : null;
    if (null !== c) {
        var d = c = c.next;
        do {
            if ((d.tag & a) !== $ba12e603ee3d5d8e$var$Nf) {
                var e = d.destroy;
                d.destroy = void 0;
                void 0 !== e && e();
            }
            (d.tag & b) !== $ba12e603ee3d5d8e$var$Nf && (e = d.create, d.destroy = e());
            d = d.next;
        }while (d !== c);
    }
}
function $ba12e603ee3d5d8e$var$uh(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d.style.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = $ba12e603ee3d5d8e$var$ne("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if (13 === c.tag && null !== c.memoizedState) {
            d = c.child.sibling;
            d.return = c;
            c = d;
            continue;
        } else if (null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function $ba12e603ee3d5d8e$var$vh(a) {
    "function" === typeof $ba12e603ee3d5d8e$var$Re && $ba12e603ee3d5d8e$var$Re(a);
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            var b = a.updateQueue;
            if (null !== b && (b = b.lastEffect, null !== b)) {
                var c = b = b.next;
                do {
                    var d = c.destroy;
                    if (void 0 !== d) {
                        var e = a;
                        try {
                            d();
                        } catch (f) {
                            $ba12e603ee3d5d8e$var$sh(e, f);
                        }
                    }
                    c = c.next;
                }while (c !== b);
            }
            break;
        case 1:
            $ba12e603ee3d5d8e$var$rh(a);
            b = a.stateNode;
            if ("function" === typeof b.componentWillUnmount) try {
                b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
            } catch (f) {
                $ba12e603ee3d5d8e$var$sh(a, f);
            }
            break;
        case 5:
            $ba12e603ee3d5d8e$var$rh(a);
            break;
        case 4:
            $ba12e603ee3d5d8e$var$wh(a);
    }
}
function $ba12e603ee3d5d8e$var$xh(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $ba12e603ee3d5d8e$var$yh(a) {
    a: {
        for(var b = a.return; null !== b;){
            if ($ba12e603ee3d5d8e$var$xh(b)) {
                var c = b;
                break a;
            }
            b = b.return;
        }
        $ba12e603ee3d5d8e$var$x("160");
        c = void 0;
    }
    var d = b = void 0;
    switch(c.tag){
        case 5:
            b = c.stateNode;
            d = !1;
            break;
        case 3:
            b = c.stateNode.containerInfo;
            d = !0;
            break;
        case 4:
            b = c.stateNode.containerInfo;
            d = !0;
            break;
        default:
            $ba12e603ee3d5d8e$var$x("161");
    }
    c.effectTag & 16 && ($ba12e603ee3d5d8e$var$ke(b, ""), c.effectTag &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || $ba12e603ee3d5d8e$var$xh(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    for(var e = a;;){
        if (5 === e.tag || 6 === e.tag) {
            if (c) {
                if (d) {
                    var f = b, g = e.stateNode, h = c;
                    8 === f.nodeType ? f.parentNode.insertBefore(g, h) : f.insertBefore(g, h);
                } else b.insertBefore(e.stateNode, c);
            } else d ? (g = b, h = e.stateNode, 8 === g.nodeType ? (f = g.parentNode, f.insertBefore(h, g)) : (f = g, f.appendChild(h)), g = g._reactRootContainer, null !== g && void 0 !== g || null !== f.onclick || (f.onclick = $ba12e603ee3d5d8e$var$te)) : b.appendChild(e.stateNode);
        } else if (4 !== e.tag && null !== e.child) {
            e.child.return = e;
            e = e.child;
            continue;
        }
        if (e === a) break;
        for(; null === e.sibling;){
            if (null === e.return || e.return === a) return;
            e = e.return;
        }
        e.sibling.return = e.return;
        e = e.sibling;
    }
}
function $ba12e603ee3d5d8e$var$wh(a) {
    for(var b = a, c = !1, d = void 0, e = void 0;;){
        if (!c) {
            c = b.return;
            a: for(;;){
                null === c && $ba12e603ee3d5d8e$var$x("160");
                switch(c.tag){
                    case 5:
                        d = c.stateNode;
                        e = !1;
                        break a;
                    case 3:
                        d = c.stateNode.containerInfo;
                        e = !0;
                        break a;
                    case 4:
                        d = c.stateNode.containerInfo;
                        e = !0;
                        break a;
                }
                c = c.return;
            }
            c = !0;
        }
        if (5 === b.tag || 6 === b.tag) {
            a: for(var f = b, g = f;;)if ($ba12e603ee3d5d8e$var$vh(g), null !== g.child && 4 !== g.tag) g.child.return = g, g = g.child;
            else {
                if (g === f) break;
                for(; null === g.sibling;){
                    if (null === g.return || g.return === f) break a;
                    g = g.return;
                }
                g.sibling.return = g.return;
                g = g.sibling;
            }
            e ? (f = d, g = b.stateNode, 8 === f.nodeType ? f.parentNode.removeChild(g) : f.removeChild(g)) : d.removeChild(b.stateNode);
        } else if (4 === b.tag) {
            if (null !== b.child) {
                d = b.stateNode.containerInfo;
                e = !0;
                b.child.return = b;
                b = b.child;
                continue;
            }
        } else if ($ba12e603ee3d5d8e$var$vh(b), null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return;
            b = b.return;
            4 === b.tag && (c = !1);
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
}
function $ba12e603ee3d5d8e$var$zh(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $ba12e603ee3d5d8e$var$th($ba12e603ee3d5d8e$var$Pf, $ba12e603ee3d5d8e$var$Qf, b);
            break;
        case 1:
            break;
        case 5:
            var c = b.stateNode;
            if (null != c) {
                var d = b.memoizedProps;
                a = null !== a ? a.memoizedProps : d;
                var e = b.type, f = b.updateQueue;
                b.updateQueue = null;
                null !== f && $ba12e603ee3d5d8e$var$Ce(c, f, e, a, d, b);
            }
            break;
        case 6:
            null === b.stateNode && $ba12e603ee3d5d8e$var$x("162");
            b.stateNode.nodeValue = b.memoizedProps;
            break;
        case 3:
            break;
        case 12:
            break;
        case 13:
            c = b.memoizedState;
            d = void 0;
            a = b;
            null === c ? d = !1 : (d = !0, a = b.child, 0 === c.timedOutAt && (c.timedOutAt = $ba12e603ee3d5d8e$var$lf()));
            null !== a && $ba12e603ee3d5d8e$var$uh(a, d);
            c = b.updateQueue;
            if (null !== c) {
                b.updateQueue = null;
                var g = b.stateNode;
                null === g && (g = b.stateNode = new $ba12e603ee3d5d8e$var$ph);
                c.forEach(function(a) {
                    var c = $ba12e603ee3d5d8e$var$Ah.bind(null, b, a);
                    g.has(a) || (g.add(a), a.then(c, c));
                });
            }
            break;
        case 17:
            break;
        default:
            $ba12e603ee3d5d8e$var$x("163");
    }
}
var $ba12e603ee3d5d8e$var$Bh = "function" === typeof WeakMap ? WeakMap : Map;
function $ba12e603ee3d5d8e$var$Ch(a, b, c) {
    c = $ba12e603ee3d5d8e$var$nf(c);
    c.tag = $ba12e603ee3d5d8e$var$ah;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $ba12e603ee3d5d8e$var$Dh(d);
        $ba12e603ee3d5d8e$var$qh(a, b);
    };
    return c;
}
function $ba12e603ee3d5d8e$var$Eh(a, b, c) {
    c = $ba12e603ee3d5d8e$var$nf(c);
    c.tag = $ba12e603ee3d5d8e$var$ah;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === $ba12e603ee3d5d8e$var$Fh ? $ba12e603ee3d5d8e$var$Fh = new Set([
            this
        ]) : $ba12e603ee3d5d8e$var$Fh.add(this));
        var c = b.value, e = b.stack;
        $ba12e603ee3d5d8e$var$qh(a, b);
        this.componentDidCatch(c, {
            componentStack: null !== e ? e : ""
        });
    });
    return c;
}
function $ba12e603ee3d5d8e$var$Gh(a) {
    switch(a.tag){
        case 1:
            $ba12e603ee3d5d8e$var$J(a.type) && $ba12e603ee3d5d8e$var$Ke(a);
            var b = a.effectTag;
            return b & 2048 ? (a.effectTag = b & -2049 | 64, a) : null;
        case 3:
            return $ba12e603ee3d5d8e$var$Kf(a), $ba12e603ee3d5d8e$var$Le(a), b = a.effectTag, 0 !== (b & 64) && $ba12e603ee3d5d8e$var$x("285"), a.effectTag = b & -2049 | 64, a;
        case 5:
            return $ba12e603ee3d5d8e$var$Mf(a), null;
        case 13:
            return b = a.effectTag, b & 2048 ? (a.effectTag = b & -2049 | 64, a) : null;
        case 18:
            return null;
        case 4:
            return $ba12e603ee3d5d8e$var$Kf(a), null;
        case 10:
            return $ba12e603ee3d5d8e$var$Zg(a), null;
        default:
            return null;
    }
}
var $ba12e603ee3d5d8e$var$Hh = $ba12e603ee3d5d8e$var$Tb.ReactCurrentDispatcher, $ba12e603ee3d5d8e$var$Ih = $ba12e603ee3d5d8e$var$Tb.ReactCurrentOwner, $ba12e603ee3d5d8e$var$Jh = 1073741822, $ba12e603ee3d5d8e$var$Kh = !1, $ba12e603ee3d5d8e$var$T = null, $ba12e603ee3d5d8e$var$Lh = null, $ba12e603ee3d5d8e$var$U = 0, $ba12e603ee3d5d8e$var$Mh = -1, $ba12e603ee3d5d8e$var$Nh = !1, $ba12e603ee3d5d8e$var$V = null, $ba12e603ee3d5d8e$var$Oh = !1, $ba12e603ee3d5d8e$var$Ph = null, $ba12e603ee3d5d8e$var$Qh = null, $ba12e603ee3d5d8e$var$Rh = null, $ba12e603ee3d5d8e$var$Fh = null;
function $ba12e603ee3d5d8e$var$Sh() {
    if (null !== $ba12e603ee3d5d8e$var$T) for(var a = $ba12e603ee3d5d8e$var$T.return; null !== a;){
        var b = a;
        switch(b.tag){
            case 1:
                var c = b.type.childContextTypes;
                null !== c && void 0 !== c && $ba12e603ee3d5d8e$var$Ke(b);
                break;
            case 3:
                $ba12e603ee3d5d8e$var$Kf(b);
                $ba12e603ee3d5d8e$var$Le(b);
                break;
            case 5:
                $ba12e603ee3d5d8e$var$Mf(b);
                break;
            case 4:
                $ba12e603ee3d5d8e$var$Kf(b);
                break;
            case 10:
                $ba12e603ee3d5d8e$var$Zg(b);
        }
        a = a.return;
    }
    $ba12e603ee3d5d8e$var$Lh = null;
    $ba12e603ee3d5d8e$var$U = 0;
    $ba12e603ee3d5d8e$var$Mh = -1;
    $ba12e603ee3d5d8e$var$Nh = !1;
    $ba12e603ee3d5d8e$var$T = null;
}
function $ba12e603ee3d5d8e$var$Th() {
    for(; null !== $ba12e603ee3d5d8e$var$V;){
        var a = $ba12e603ee3d5d8e$var$V.effectTag;
        a & 16 && $ba12e603ee3d5d8e$var$ke($ba12e603ee3d5d8e$var$V.stateNode, "");
        if (a & 128) {
            var b = $ba12e603ee3d5d8e$var$V.alternate;
            null !== b && (b = b.ref, null !== b && ("function" === typeof b ? b(null) : b.current = null));
        }
        switch(a & 14){
            case 2:
                $ba12e603ee3d5d8e$var$yh($ba12e603ee3d5d8e$var$V);
                $ba12e603ee3d5d8e$var$V.effectTag &= -3;
                break;
            case 6:
                $ba12e603ee3d5d8e$var$yh($ba12e603ee3d5d8e$var$V);
                $ba12e603ee3d5d8e$var$V.effectTag &= -3;
                $ba12e603ee3d5d8e$var$zh($ba12e603ee3d5d8e$var$V.alternate, $ba12e603ee3d5d8e$var$V);
                break;
            case 4:
                $ba12e603ee3d5d8e$var$zh($ba12e603ee3d5d8e$var$V.alternate, $ba12e603ee3d5d8e$var$V);
                break;
            case 8:
                a = $ba12e603ee3d5d8e$var$V, $ba12e603ee3d5d8e$var$wh(a), a.return = null, a.child = null, a.memoizedState = null, a.updateQueue = null, a = a.alternate, null !== a && (a.return = null, a.child = null, a.memoizedState = null, a.updateQueue = null);
        }
        $ba12e603ee3d5d8e$var$V = $ba12e603ee3d5d8e$var$V.nextEffect;
    }
}
function $ba12e603ee3d5d8e$var$Uh() {
    for(; null !== $ba12e603ee3d5d8e$var$V;){
        if ($ba12e603ee3d5d8e$var$V.effectTag & 256) a: {
            var a = $ba12e603ee3d5d8e$var$V.alternate, b = $ba12e603ee3d5d8e$var$V;
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    $ba12e603ee3d5d8e$var$th($ba12e603ee3d5d8e$var$Of, $ba12e603ee3d5d8e$var$Nf, b);
                    break a;
                case 1:
                    if (b.effectTag & 256 && null !== a) {
                        var c = a.memoizedProps, d = a.memoizedState;
                        a = b.stateNode;
                        b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : $ba12e603ee3d5d8e$var$L(b.type, c), d);
                        a.__reactInternalSnapshotBeforeUpdate = b;
                    }
                    break a;
                case 3:
                case 5:
                case 6:
                case 4:
                case 17:
                    break a;
                default:
                    $ba12e603ee3d5d8e$var$x("163");
            }
        }
        $ba12e603ee3d5d8e$var$V = $ba12e603ee3d5d8e$var$V.nextEffect;
    }
}
function $ba12e603ee3d5d8e$var$Vh(a, b) {
    for(; null !== $ba12e603ee3d5d8e$var$V;){
        var c = $ba12e603ee3d5d8e$var$V.effectTag;
        if (c & 36) {
            var d = $ba12e603ee3d5d8e$var$V.alternate, e = $ba12e603ee3d5d8e$var$V, f = b;
            switch(e.tag){
                case 0:
                case 11:
                case 15:
                    $ba12e603ee3d5d8e$var$th($ba12e603ee3d5d8e$var$Rf, $ba12e603ee3d5d8e$var$Sf, e);
                    break;
                case 1:
                    var g = e.stateNode;
                    if (e.effectTag & 4) {
                        if (null === d) g.componentDidMount();
                        else {
                            var h = e.elementType === e.type ? d.memoizedProps : $ba12e603ee3d5d8e$var$L(e.type, d.memoizedProps);
                            g.componentDidUpdate(h, d.memoizedState, g.__reactInternalSnapshotBeforeUpdate);
                        }
                    }
                    d = e.updateQueue;
                    null !== d && $ba12e603ee3d5d8e$var$hh(e, d, g, f);
                    break;
                case 3:
                    d = e.updateQueue;
                    if (null !== d) {
                        g = null;
                        if (null !== e.child) switch(e.child.tag){
                            case 5:
                                g = e.child.stateNode;
                                break;
                            case 1:
                                g = e.child.stateNode;
                        }
                        $ba12e603ee3d5d8e$var$hh(e, d, g, f);
                    }
                    break;
                case 5:
                    f = e.stateNode;
                    null === d && e.effectTag & 4 && $ba12e603ee3d5d8e$var$we(e.type, e.memoizedProps) && f.focus();
                    break;
                case 6:
                    break;
                case 4:
                    break;
                case 12:
                    break;
                case 13:
                    break;
                case 17:
                    break;
                default:
                    $ba12e603ee3d5d8e$var$x("163");
            }
        }
        c & 128 && (e = $ba12e603ee3d5d8e$var$V.ref, null !== e && (f = $ba12e603ee3d5d8e$var$V.stateNode, "function" === typeof e ? e(f) : e.current = f));
        c & 512 && ($ba12e603ee3d5d8e$var$Ph = a);
        $ba12e603ee3d5d8e$var$V = $ba12e603ee3d5d8e$var$V.nextEffect;
    }
}
function $ba12e603ee3d5d8e$var$Wh(a, b) {
    $ba12e603ee3d5d8e$var$Rh = $ba12e603ee3d5d8e$var$Qh = $ba12e603ee3d5d8e$var$Ph = null;
    var c = $ba12e603ee3d5d8e$var$W;
    $ba12e603ee3d5d8e$var$W = !0;
    do {
        if (b.effectTag & 512) {
            var d = !1, e = void 0;
            try {
                var f = b;
                $ba12e603ee3d5d8e$var$th($ba12e603ee3d5d8e$var$Uf, $ba12e603ee3d5d8e$var$Nf, f);
                $ba12e603ee3d5d8e$var$th($ba12e603ee3d5d8e$var$Nf, $ba12e603ee3d5d8e$var$Tf, f);
            } catch (g) {
                d = !0, e = g;
            }
            d && $ba12e603ee3d5d8e$var$sh(b, e);
        }
        b = b.nextEffect;
    }while (null !== b);
    $ba12e603ee3d5d8e$var$W = c;
    c = a.expirationTime;
    0 !== c && $ba12e603ee3d5d8e$var$Xh(a, c);
    $ba12e603ee3d5d8e$var$X || $ba12e603ee3d5d8e$var$W || $ba12e603ee3d5d8e$var$Yh(1073741823, !1);
}
function $ba12e603ee3d5d8e$var$of() {
    null !== $ba12e603ee3d5d8e$var$Qh && $ba12e603ee3d5d8e$var$Be($ba12e603ee3d5d8e$var$Qh);
    null !== $ba12e603ee3d5d8e$var$Rh && $ba12e603ee3d5d8e$var$Rh();
}
function $ba12e603ee3d5d8e$var$Zh(a, b) {
    $ba12e603ee3d5d8e$var$Oh = $ba12e603ee3d5d8e$var$Kh = !0;
    a.current === b && $ba12e603ee3d5d8e$var$x("177");
    var c = a.pendingCommitExpirationTime;
    0 === c && $ba12e603ee3d5d8e$var$x("261");
    a.pendingCommitExpirationTime = 0;
    var d = b.expirationTime, e = b.childExpirationTime;
    $ba12e603ee3d5d8e$var$ef(a, e > d ? e : d);
    $ba12e603ee3d5d8e$var$Ih.current = null;
    d = void 0;
    1 < b.effectTag ? null !== b.lastEffect ? (b.lastEffect.nextEffect = b, d = b.firstEffect) : d = b : d = b.firstEffect;
    $ba12e603ee3d5d8e$var$ue = $ba12e603ee3d5d8e$var$Bd;
    $ba12e603ee3d5d8e$var$ve = $ba12e603ee3d5d8e$var$Pd();
    $ba12e603ee3d5d8e$var$Bd = !1;
    for($ba12e603ee3d5d8e$var$V = d; null !== $ba12e603ee3d5d8e$var$V;){
        e = !1;
        var f = void 0;
        try {
            $ba12e603ee3d5d8e$var$Uh();
        } catch (h) {
            e = !0, f = h;
        }
        e && (null === $ba12e603ee3d5d8e$var$V && $ba12e603ee3d5d8e$var$x("178"), $ba12e603ee3d5d8e$var$sh($ba12e603ee3d5d8e$var$V, f), null !== $ba12e603ee3d5d8e$var$V && ($ba12e603ee3d5d8e$var$V = $ba12e603ee3d5d8e$var$V.nextEffect));
    }
    for($ba12e603ee3d5d8e$var$V = d; null !== $ba12e603ee3d5d8e$var$V;){
        e = !1;
        f = void 0;
        try {
            $ba12e603ee3d5d8e$var$Th();
        } catch (h) {
            e = !0, f = h;
        }
        e && (null === $ba12e603ee3d5d8e$var$V && $ba12e603ee3d5d8e$var$x("178"), $ba12e603ee3d5d8e$var$sh($ba12e603ee3d5d8e$var$V, f), null !== $ba12e603ee3d5d8e$var$V && ($ba12e603ee3d5d8e$var$V = $ba12e603ee3d5d8e$var$V.nextEffect));
    }
    $ba12e603ee3d5d8e$var$Qd($ba12e603ee3d5d8e$var$ve);
    $ba12e603ee3d5d8e$var$ve = null;
    $ba12e603ee3d5d8e$var$Bd = !!$ba12e603ee3d5d8e$var$ue;
    $ba12e603ee3d5d8e$var$ue = null;
    a.current = b;
    for($ba12e603ee3d5d8e$var$V = d; null !== $ba12e603ee3d5d8e$var$V;){
        e = !1;
        f = void 0;
        try {
            $ba12e603ee3d5d8e$var$Vh(a, c);
        } catch (h) {
            e = !0, f = h;
        }
        e && (null === $ba12e603ee3d5d8e$var$V && $ba12e603ee3d5d8e$var$x("178"), $ba12e603ee3d5d8e$var$sh($ba12e603ee3d5d8e$var$V, f), null !== $ba12e603ee3d5d8e$var$V && ($ba12e603ee3d5d8e$var$V = $ba12e603ee3d5d8e$var$V.nextEffect));
    }
    if (null !== d && null !== $ba12e603ee3d5d8e$var$Ph) {
        var g = $ba12e603ee3d5d8e$var$Wh.bind(null, a, d);
        $ba12e603ee3d5d8e$var$Qh = $jmjQ5.unstable_runWithPriority($jmjQ5.unstable_NormalPriority, function() {
            return $ba12e603ee3d5d8e$var$Ae(g);
        });
        $ba12e603ee3d5d8e$var$Rh = g;
    }
    $ba12e603ee3d5d8e$var$Kh = $ba12e603ee3d5d8e$var$Oh = !1;
    "function" === typeof $ba12e603ee3d5d8e$var$Qe && $ba12e603ee3d5d8e$var$Qe(b.stateNode);
    c = b.expirationTime;
    b = b.childExpirationTime;
    b = b > c ? b : c;
    0 === b && ($ba12e603ee3d5d8e$var$Fh = null);
    $ba12e603ee3d5d8e$var$$h(a, b);
}
function $ba12e603ee3d5d8e$var$ai(a) {
    for(;;){
        var b = a.alternate, c = a.return, d = a.sibling;
        if (0 === (a.effectTag & 1024)) {
            $ba12e603ee3d5d8e$var$T = a;
            a: {
                var e = b;
                b = a;
                var f = $ba12e603ee3d5d8e$var$U;
                var g = b.pendingProps;
                switch(b.tag){
                    case 2:
                        break;
                    case 16:
                        break;
                    case 15:
                    case 0:
                        break;
                    case 1:
                        $ba12e603ee3d5d8e$var$J(b.type) && $ba12e603ee3d5d8e$var$Ke(b);
                        break;
                    case 3:
                        $ba12e603ee3d5d8e$var$Kf(b);
                        $ba12e603ee3d5d8e$var$Le(b);
                        g = b.stateNode;
                        g.pendingContext && (g.context = g.pendingContext, g.pendingContext = null);
                        if (null === e || null === e.child) $ba12e603ee3d5d8e$var$Eg(b), b.effectTag &= -3;
                        $ba12e603ee3d5d8e$var$mh(b);
                        break;
                    case 5:
                        $ba12e603ee3d5d8e$var$Mf(b);
                        var h = $ba12e603ee3d5d8e$var$If($ba12e603ee3d5d8e$var$Hf.current);
                        f = b.type;
                        if (null !== e && null != b.stateNode) $ba12e603ee3d5d8e$var$nh(e, b, f, g, h), e.ref !== b.ref && (b.effectTag |= 128);
                        else if (g) {
                            var l = $ba12e603ee3d5d8e$var$If($ba12e603ee3d5d8e$var$N.current);
                            if ($ba12e603ee3d5d8e$var$Eg(b)) {
                                g = b;
                                e = g.stateNode;
                                var k = g.type, m = g.memoizedProps, p = h;
                                e[$ba12e603ee3d5d8e$var$Fa] = g;
                                e[$ba12e603ee3d5d8e$var$Ga] = m;
                                f = void 0;
                                h = k;
                                switch(h){
                                    case "iframe":
                                    case "object":
                                        $ba12e603ee3d5d8e$var$E("load", e);
                                        break;
                                    case "video":
                                    case "audio":
                                        for(k = 0; k < $ba12e603ee3d5d8e$var$ab.length; k++)$ba12e603ee3d5d8e$var$E($ba12e603ee3d5d8e$var$ab[k], e);
                                        break;
                                    case "source":
                                        $ba12e603ee3d5d8e$var$E("error", e);
                                        break;
                                    case "img":
                                    case "image":
                                    case "link":
                                        $ba12e603ee3d5d8e$var$E("error", e);
                                        $ba12e603ee3d5d8e$var$E("load", e);
                                        break;
                                    case "form":
                                        $ba12e603ee3d5d8e$var$E("reset", e);
                                        $ba12e603ee3d5d8e$var$E("submit", e);
                                        break;
                                    case "details":
                                        $ba12e603ee3d5d8e$var$E("toggle", e);
                                        break;
                                    case "input":
                                        $ba12e603ee3d5d8e$var$wc(e, m);
                                        $ba12e603ee3d5d8e$var$E("invalid", e);
                                        $ba12e603ee3d5d8e$var$se(p, "onChange");
                                        break;
                                    case "select":
                                        e._wrapperState = {
                                            wasMultiple: !!m.multiple
                                        };
                                        $ba12e603ee3d5d8e$var$E("invalid", e);
                                        $ba12e603ee3d5d8e$var$se(p, "onChange");
                                        break;
                                    case "textarea":
                                        $ba12e603ee3d5d8e$var$ce(e, m), $ba12e603ee3d5d8e$var$E("invalid", e), $ba12e603ee3d5d8e$var$se(p, "onChange");
                                }
                                $ba12e603ee3d5d8e$var$qe(h, m);
                                k = null;
                                for(f in m)m.hasOwnProperty(f) && (l = m[f], "children" === f ? "string" === typeof l ? e.textContent !== l && (k = [
                                    "children",
                                    l
                                ]) : "number" === typeof l && e.textContent !== "" + l && (k = [
                                    "children",
                                    "" + l
                                ]) : $ba12e603ee3d5d8e$var$ra.hasOwnProperty(f) && null != l && $ba12e603ee3d5d8e$var$se(p, f));
                                switch(h){
                                    case "input":
                                        $ba12e603ee3d5d8e$var$Rb(e);
                                        $ba12e603ee3d5d8e$var$Ac(e, m, !0);
                                        break;
                                    case "textarea":
                                        $ba12e603ee3d5d8e$var$Rb(e);
                                        $ba12e603ee3d5d8e$var$ee(e, m);
                                        break;
                                    case "select":
                                    case "option":
                                        break;
                                    default:
                                        "function" === typeof m.onClick && (e.onclick = $ba12e603ee3d5d8e$var$te);
                                }
                                f = k;
                                g.updateQueue = f;
                                g = null !== f ? !0 : !1;
                                g && $ba12e603ee3d5d8e$var$kh(b);
                            } else {
                                m = b;
                                p = f;
                                e = g;
                                k = 9 === h.nodeType ? h : h.ownerDocument;
                                l === $ba12e603ee3d5d8e$var$fe.html && (l = $ba12e603ee3d5d8e$var$ge(p));
                                l === $ba12e603ee3d5d8e$var$fe.html ? "script" === p ? (e = k.createElement("div"), e.innerHTML = "<script>\x3c/script>", k = e.removeChild(e.firstChild)) : "string" === typeof e.is ? k = k.createElement(p, {
                                    is: e.is
                                }) : (k = k.createElement(p), "select" === p && (p = k, e.multiple ? p.multiple = !0 : e.size && (p.size = e.size))) : k = k.createElementNS(l, p);
                                e = k;
                                e[$ba12e603ee3d5d8e$var$Fa] = m;
                                e[$ba12e603ee3d5d8e$var$Ga] = g;
                                $ba12e603ee3d5d8e$var$lh(e, b, !1, !1);
                                p = e;
                                k = f;
                                m = g;
                                var t = h, A = $ba12e603ee3d5d8e$var$re(k, m);
                                switch(k){
                                    case "iframe":
                                    case "object":
                                        $ba12e603ee3d5d8e$var$E("load", p);
                                        h = m;
                                        break;
                                    case "video":
                                    case "audio":
                                        for(h = 0; h < $ba12e603ee3d5d8e$var$ab.length; h++)$ba12e603ee3d5d8e$var$E($ba12e603ee3d5d8e$var$ab[h], p);
                                        h = m;
                                        break;
                                    case "source":
                                        $ba12e603ee3d5d8e$var$E("error", p);
                                        h = m;
                                        break;
                                    case "img":
                                    case "image":
                                    case "link":
                                        $ba12e603ee3d5d8e$var$E("error", p);
                                        $ba12e603ee3d5d8e$var$E("load", p);
                                        h = m;
                                        break;
                                    case "form":
                                        $ba12e603ee3d5d8e$var$E("reset", p);
                                        $ba12e603ee3d5d8e$var$E("submit", p);
                                        h = m;
                                        break;
                                    case "details":
                                        $ba12e603ee3d5d8e$var$E("toggle", p);
                                        h = m;
                                        break;
                                    case "input":
                                        $ba12e603ee3d5d8e$var$wc(p, m);
                                        h = $ba12e603ee3d5d8e$var$vc(p, m);
                                        $ba12e603ee3d5d8e$var$E("invalid", p);
                                        $ba12e603ee3d5d8e$var$se(t, "onChange");
                                        break;
                                    case "option":
                                        h = $ba12e603ee3d5d8e$var$$d(p, m);
                                        break;
                                    case "select":
                                        p._wrapperState = {
                                            wasMultiple: !!m.multiple
                                        };
                                        h = $63ReS({}, m, {
                                            value: void 0
                                        });
                                        $ba12e603ee3d5d8e$var$E("invalid", p);
                                        $ba12e603ee3d5d8e$var$se(t, "onChange");
                                        break;
                                    case "textarea":
                                        $ba12e603ee3d5d8e$var$ce(p, m);
                                        h = $ba12e603ee3d5d8e$var$be(p, m);
                                        $ba12e603ee3d5d8e$var$E("invalid", p);
                                        $ba12e603ee3d5d8e$var$se(t, "onChange");
                                        break;
                                    default:
                                        h = m;
                                }
                                $ba12e603ee3d5d8e$var$qe(k, h);
                                l = void 0;
                                var v = k, R = p, u = h;
                                for(l in u)if (u.hasOwnProperty(l)) {
                                    var q = u[l];
                                    "style" === l ? $ba12e603ee3d5d8e$var$oe(R, q) : "dangerouslySetInnerHTML" === l ? (q = q ? q.__html : void 0, null != q && $ba12e603ee3d5d8e$var$je(R, q)) : "children" === l ? "string" === typeof q ? ("textarea" !== v || "" !== q) && $ba12e603ee3d5d8e$var$ke(R, q) : "number" === typeof q && $ba12e603ee3d5d8e$var$ke(R, "" + q) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($ba12e603ee3d5d8e$var$ra.hasOwnProperty(l) ? null != q && $ba12e603ee3d5d8e$var$se(t, l) : null != q && $ba12e603ee3d5d8e$var$tc(R, l, q, A));
                                }
                                switch(k){
                                    case "input":
                                        $ba12e603ee3d5d8e$var$Rb(p);
                                        $ba12e603ee3d5d8e$var$Ac(p, m, !1);
                                        break;
                                    case "textarea":
                                        $ba12e603ee3d5d8e$var$Rb(p);
                                        $ba12e603ee3d5d8e$var$ee(p, m);
                                        break;
                                    case "option":
                                        null != m.value && p.setAttribute("value", "" + $ba12e603ee3d5d8e$var$uc(m.value));
                                        break;
                                    case "select":
                                        h = p;
                                        h.multiple = !!m.multiple;
                                        p = m.value;
                                        null != p ? $ba12e603ee3d5d8e$var$ae(h, !!m.multiple, p, !1) : null != m.defaultValue && $ba12e603ee3d5d8e$var$ae(h, !!m.multiple, m.defaultValue, !0);
                                        break;
                                    default:
                                        "function" === typeof h.onClick && (p.onclick = $ba12e603ee3d5d8e$var$te);
                                }
                                (g = $ba12e603ee3d5d8e$var$we(f, g)) && $ba12e603ee3d5d8e$var$kh(b);
                                b.stateNode = e;
                            }
                            null !== b.ref && (b.effectTag |= 128);
                        } else null === b.stateNode && $ba12e603ee3d5d8e$var$x("166");
                        break;
                    case 6:
                        e && null != b.stateNode ? $ba12e603ee3d5d8e$var$oh(e, b, e.memoizedProps, g) : ("string" !== typeof g && null === b.stateNode && $ba12e603ee3d5d8e$var$x("166"), e = $ba12e603ee3d5d8e$var$If($ba12e603ee3d5d8e$var$Hf.current), $ba12e603ee3d5d8e$var$If($ba12e603ee3d5d8e$var$N.current), $ba12e603ee3d5d8e$var$Eg(b) ? (g = b, f = g.stateNode, e = g.memoizedProps, f[$ba12e603ee3d5d8e$var$Fa] = g, (g = f.nodeValue !== e) && $ba12e603ee3d5d8e$var$kh(b)) : (f = b, g = (9 === e.nodeType ? e : e.ownerDocument).createTextNode(g), g[$ba12e603ee3d5d8e$var$Fa] = b, f.stateNode = g));
                        break;
                    case 11:
                        break;
                    case 13:
                        g = b.memoizedState;
                        if (0 !== (b.effectTag & 64)) {
                            b.expirationTime = f;
                            $ba12e603ee3d5d8e$var$T = b;
                            break a;
                        }
                        g = null !== g;
                        f = null !== e && null !== e.memoizedState;
                        null !== e && !g && f && (e = e.child.sibling, null !== e && (h = b.firstEffect, null !== h ? (b.firstEffect = e, e.nextEffect = h) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8));
                        if (g || f) b.effectTag |= 4;
                        break;
                    case 7:
                        break;
                    case 8:
                        break;
                    case 12:
                        break;
                    case 4:
                        $ba12e603ee3d5d8e$var$Kf(b);
                        $ba12e603ee3d5d8e$var$mh(b);
                        break;
                    case 10:
                        $ba12e603ee3d5d8e$var$Zg(b);
                        break;
                    case 9:
                        break;
                    case 14:
                        break;
                    case 17:
                        $ba12e603ee3d5d8e$var$J(b.type) && $ba12e603ee3d5d8e$var$Ke(b);
                        break;
                    case 18:
                        break;
                    default:
                        $ba12e603ee3d5d8e$var$x("156");
                }
                $ba12e603ee3d5d8e$var$T = null;
            }
            b = a;
            if (1 === $ba12e603ee3d5d8e$var$U || 1 !== b.childExpirationTime) {
                g = 0;
                for(f = b.child; null !== f;)e = f.expirationTime, h = f.childExpirationTime, e > g && (g = e), h > g && (g = h), f = f.sibling;
                b.childExpirationTime = g;
            }
            if (null !== $ba12e603ee3d5d8e$var$T) return $ba12e603ee3d5d8e$var$T;
            null !== c && 0 === (c.effectTag & 1024) && (null === c.firstEffect && (c.firstEffect = a.firstEffect), null !== a.lastEffect && (null !== c.lastEffect && (c.lastEffect.nextEffect = a.firstEffect), c.lastEffect = a.lastEffect), 1 < a.effectTag && (null !== c.lastEffect ? c.lastEffect.nextEffect = a : c.firstEffect = a, c.lastEffect = a));
        } else {
            a = $ba12e603ee3d5d8e$var$Gh(a, $ba12e603ee3d5d8e$var$U);
            if (null !== a) return a.effectTag &= 1023, a;
            null !== c && (c.firstEffect = c.lastEffect = null, c.effectTag |= 1024);
        }
        if (null !== d) return d;
        if (null !== c) a = c;
        else break;
    }
    return null;
}
function $ba12e603ee3d5d8e$var$bi(a) {
    var b = $ba12e603ee3d5d8e$var$Tg(a.alternate, a, $ba12e603ee3d5d8e$var$U);
    a.memoizedProps = a.pendingProps;
    null === b && (b = $ba12e603ee3d5d8e$var$ai(a));
    $ba12e603ee3d5d8e$var$Ih.current = null;
    return b;
}
function $ba12e603ee3d5d8e$var$ci(a, b) {
    $ba12e603ee3d5d8e$var$Kh && $ba12e603ee3d5d8e$var$x("243");
    $ba12e603ee3d5d8e$var$of();
    $ba12e603ee3d5d8e$var$Kh = !0;
    var c = $ba12e603ee3d5d8e$var$Hh.current;
    $ba12e603ee3d5d8e$var$Hh.current = $ba12e603ee3d5d8e$var$kg;
    var d = a.nextExpirationTimeToWorkOn;
    if (d !== $ba12e603ee3d5d8e$var$U || a !== $ba12e603ee3d5d8e$var$Lh || null === $ba12e603ee3d5d8e$var$T) $ba12e603ee3d5d8e$var$Sh(), $ba12e603ee3d5d8e$var$Lh = a, $ba12e603ee3d5d8e$var$U = d, $ba12e603ee3d5d8e$var$T = $ba12e603ee3d5d8e$var$Xe($ba12e603ee3d5d8e$var$Lh.current, null, $ba12e603ee3d5d8e$var$U), a.pendingCommitExpirationTime = 0;
    var e = !1;
    do {
        try {
            if (b) for(; null !== $ba12e603ee3d5d8e$var$T && !$ba12e603ee3d5d8e$var$di();)$ba12e603ee3d5d8e$var$T = $ba12e603ee3d5d8e$var$bi($ba12e603ee3d5d8e$var$T);
            else for(; null !== $ba12e603ee3d5d8e$var$T;)$ba12e603ee3d5d8e$var$T = $ba12e603ee3d5d8e$var$bi($ba12e603ee3d5d8e$var$T);
        } catch (u) {
            if ($ba12e603ee3d5d8e$var$Yg = $ba12e603ee3d5d8e$var$Xg = $ba12e603ee3d5d8e$var$Wg = null, $ba12e603ee3d5d8e$var$lg(), null === $ba12e603ee3d5d8e$var$T) e = !0, $ba12e603ee3d5d8e$var$Dh(u);
            else {
                null === $ba12e603ee3d5d8e$var$T && $ba12e603ee3d5d8e$var$x("271");
                var f = $ba12e603ee3d5d8e$var$T, g = f.return;
                if (null === g) e = !0, $ba12e603ee3d5d8e$var$Dh(u);
                else {
                    a: {
                        var h = a, l = g, k = f, m = u;
                        g = $ba12e603ee3d5d8e$var$U;
                        k.effectTag |= 1024;
                        k.firstEffect = k.lastEffect = null;
                        if (null !== m && "object" === typeof m && "function" === typeof m.then) {
                            var p = m;
                            m = l;
                            var t = -1, A = -1;
                            do {
                                if (13 === m.tag) {
                                    var v = m.alternate;
                                    if (null !== v && (v = v.memoizedState, null !== v)) {
                                        A = 10 * (1073741822 - v.timedOutAt);
                                        break;
                                    }
                                    v = m.pendingProps.maxDuration;
                                    if ("number" === typeof v) {
                                        if (0 >= v) t = 0;
                                        else if (-1 === t || v < t) t = v;
                                    }
                                }
                                m = m.return;
                            }while (null !== m);
                            m = l;
                            do {
                                if (v = 13 === m.tag) v = void 0 === m.memoizedProps.fallback ? !1 : null === m.memoizedState;
                                if (v) {
                                    l = m.updateQueue;
                                    null === l ? (l = new Set, l.add(p), m.updateQueue = l) : l.add(p);
                                    if (0 === (m.mode & 1)) {
                                        m.effectTag |= 64;
                                        k.effectTag &= -1957;
                                        1 === k.tag && (null === k.alternate ? k.tag = 17 : (g = $ba12e603ee3d5d8e$var$nf(1073741823), g.tag = $ba12e603ee3d5d8e$var$sf, $ba12e603ee3d5d8e$var$pf(k, g)));
                                        k.expirationTime = 1073741823;
                                        break a;
                                    }
                                    k = h;
                                    l = g;
                                    var R = k.pingCache;
                                    null === R ? (R = k.pingCache = new $ba12e603ee3d5d8e$var$Bh, v = new Set, R.set(p, v)) : (v = R.get(p), void 0 === v && (v = new Set, R.set(p, v)));
                                    v.has(l) || (v.add(l), k = $ba12e603ee3d5d8e$var$ei.bind(null, k, p, l), p.then(k, k));
                                    -1 === t ? h = 1073741823 : (-1 === A && (A = 10 * (1073741822 - $ba12e603ee3d5d8e$var$gf(h, g)) - 5E3), h = A + t);
                                    0 <= h && $ba12e603ee3d5d8e$var$Mh < h && ($ba12e603ee3d5d8e$var$Mh = h);
                                    m.effectTag |= 2048;
                                    m.expirationTime = g;
                                    break a;
                                }
                                m = m.return;
                            }while (null !== m);
                            m = Error(($ba12e603ee3d5d8e$var$ic(k.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + $ba12e603ee3d5d8e$var$jc(k));
                        }
                        $ba12e603ee3d5d8e$var$Nh = !0;
                        m = $ba12e603ee3d5d8e$var$jh(m, k);
                        h = l;
                        do {
                            switch(h.tag){
                                case 3:
                                    h.effectTag |= 2048;
                                    h.expirationTime = g;
                                    g = $ba12e603ee3d5d8e$var$Ch(h, m, g);
                                    $ba12e603ee3d5d8e$var$eh(h, g);
                                    break a;
                                case 1:
                                    if (t = m, A = h.type, k = h.stateNode, 0 === (h.effectTag & 64) && ("function" === typeof A.getDerivedStateFromError || null !== k && "function" === typeof k.componentDidCatch && (null === $ba12e603ee3d5d8e$var$Fh || !$ba12e603ee3d5d8e$var$Fh.has(k)))) {
                                        h.effectTag |= 2048;
                                        h.expirationTime = g;
                                        g = $ba12e603ee3d5d8e$var$Eh(h, t, g);
                                        $ba12e603ee3d5d8e$var$eh(h, g);
                                        break a;
                                    }
                            }
                            h = h.return;
                        }while (null !== h);
                    }
                    $ba12e603ee3d5d8e$var$T = $ba12e603ee3d5d8e$var$ai(f);
                    continue;
                }
            }
        }
        break;
    }while (1);
    $ba12e603ee3d5d8e$var$Kh = !1;
    $ba12e603ee3d5d8e$var$Hh.current = c;
    $ba12e603ee3d5d8e$var$Yg = $ba12e603ee3d5d8e$var$Xg = $ba12e603ee3d5d8e$var$Wg = null;
    $ba12e603ee3d5d8e$var$lg();
    if (e) $ba12e603ee3d5d8e$var$Lh = null, a.finishedWork = null;
    else if (null !== $ba12e603ee3d5d8e$var$T) a.finishedWork = null;
    else {
        c = a.current.alternate;
        null === c && $ba12e603ee3d5d8e$var$x("281");
        $ba12e603ee3d5d8e$var$Lh = null;
        if ($ba12e603ee3d5d8e$var$Nh) {
            e = a.latestPendingTime;
            f = a.latestSuspendedTime;
            g = a.latestPingedTime;
            if (0 !== e && e < d || 0 !== f && f < d || 0 !== g && g < d) {
                $ba12e603ee3d5d8e$var$ff(a, d);
                $ba12e603ee3d5d8e$var$fi(a, c, d, a.expirationTime, -1);
                return;
            }
            if (!a.didError && b) {
                a.didError = !0;
                d = a.nextExpirationTimeToWorkOn = d;
                b = a.expirationTime = 1073741823;
                $ba12e603ee3d5d8e$var$fi(a, c, d, b, -1);
                return;
            }
        }
        b && -1 !== $ba12e603ee3d5d8e$var$Mh ? ($ba12e603ee3d5d8e$var$ff(a, d), b = 10 * (1073741822 - $ba12e603ee3d5d8e$var$gf(a, d)), b < $ba12e603ee3d5d8e$var$Mh && ($ba12e603ee3d5d8e$var$Mh = b), b = 10 * (1073741822 - $ba12e603ee3d5d8e$var$lf()), b = $ba12e603ee3d5d8e$var$Mh - b, $ba12e603ee3d5d8e$var$fi(a, c, d, a.expirationTime, 0 > b ? 0 : b)) : (a.pendingCommitExpirationTime = d, a.finishedWork = c);
    }
}
function $ba12e603ee3d5d8e$var$sh(a, b) {
    for(var c = a.return; null !== c;){
        switch(c.tag){
            case 1:
                var d = c.stateNode;
                if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $ba12e603ee3d5d8e$var$Fh || !$ba12e603ee3d5d8e$var$Fh.has(d))) {
                    a = $ba12e603ee3d5d8e$var$jh(b, a);
                    a = $ba12e603ee3d5d8e$var$Eh(c, a, 1073741823);
                    $ba12e603ee3d5d8e$var$pf(c, a);
                    $ba12e603ee3d5d8e$var$qf(c, 1073741823);
                    return;
                }
                break;
            case 3:
                a = $ba12e603ee3d5d8e$var$jh(b, a);
                a = $ba12e603ee3d5d8e$var$Ch(c, a, 1073741823);
                $ba12e603ee3d5d8e$var$pf(c, a);
                $ba12e603ee3d5d8e$var$qf(c, 1073741823);
                return;
        }
        c = c.return;
    }
    3 === a.tag && (c = $ba12e603ee3d5d8e$var$jh(b, a), c = $ba12e603ee3d5d8e$var$Ch(a, c, 1073741823), $ba12e603ee3d5d8e$var$pf(a, c), $ba12e603ee3d5d8e$var$qf(a, 1073741823));
}
function $ba12e603ee3d5d8e$var$mf(a, b) {
    var c = $jmjQ5.unstable_getCurrentPriorityLevel(), d = void 0;
    if (0 === (b.mode & 1)) d = 1073741823;
    else if ($ba12e603ee3d5d8e$var$Kh && !$ba12e603ee3d5d8e$var$Oh) d = $ba12e603ee3d5d8e$var$U;
    else {
        switch(c){
            case $jmjQ5.unstable_ImmediatePriority:
                d = 1073741823;
                break;
            case $jmjQ5.unstable_UserBlockingPriority:
                d = 1073741822 - 10 * (((1073741822 - a + 15) / 10 | 0) + 1);
                break;
            case $jmjQ5.unstable_NormalPriority:
                d = 1073741822 - 25 * (((1073741822 - a + 500) / 25 | 0) + 1);
                break;
            case $jmjQ5.unstable_LowPriority:
            case $jmjQ5.unstable_IdlePriority:
                d = 1;
                break;
            default:
                $ba12e603ee3d5d8e$var$x("313");
        }
        null !== $ba12e603ee3d5d8e$var$Lh && d === $ba12e603ee3d5d8e$var$U && --d;
    }
    c === $jmjQ5.unstable_UserBlockingPriority && (0 === $ba12e603ee3d5d8e$var$gi || d < $ba12e603ee3d5d8e$var$gi) && ($ba12e603ee3d5d8e$var$gi = d);
    return d;
}
function $ba12e603ee3d5d8e$var$ei(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    if (null !== $ba12e603ee3d5d8e$var$Lh && $ba12e603ee3d5d8e$var$U === c) $ba12e603ee3d5d8e$var$Lh = null;
    else if (b = a.earliestSuspendedTime, d = a.latestSuspendedTime, 0 !== b && c <= b && c >= d) {
        a.didError = !1;
        b = a.latestPingedTime;
        if (0 === b || b > c) a.latestPingedTime = c;
        $ba12e603ee3d5d8e$var$df(c, a);
        c = a.expirationTime;
        0 !== c && $ba12e603ee3d5d8e$var$Xh(a, c);
    }
}
function $ba12e603ee3d5d8e$var$Ah(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = $ba12e603ee3d5d8e$var$lf();
    b = $ba12e603ee3d5d8e$var$mf(b, a);
    a = $ba12e603ee3d5d8e$var$hi(a, b);
    null !== a && ($ba12e603ee3d5d8e$var$cf(a, b), b = a.expirationTime, 0 !== b && $ba12e603ee3d5d8e$var$Xh(a, b));
}
function $ba12e603ee3d5d8e$var$hi(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a.return, e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;
    else for(; null !== d;){
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        if (null === d.return && 3 === d.tag) {
            e = d.stateNode;
            break;
        }
        d = d.return;
    }
    return e;
}
function $ba12e603ee3d5d8e$var$qf(a, b) {
    a = $ba12e603ee3d5d8e$var$hi(a, b);
    null !== a && (!$ba12e603ee3d5d8e$var$Kh && 0 !== $ba12e603ee3d5d8e$var$U && b > $ba12e603ee3d5d8e$var$U && $ba12e603ee3d5d8e$var$Sh(), $ba12e603ee3d5d8e$var$cf(a, b), $ba12e603ee3d5d8e$var$Kh && !$ba12e603ee3d5d8e$var$Oh && $ba12e603ee3d5d8e$var$Lh === a || $ba12e603ee3d5d8e$var$Xh(a, a.expirationTime), $ba12e603ee3d5d8e$var$ii > $ba12e603ee3d5d8e$var$ji && ($ba12e603ee3d5d8e$var$ii = 0, $ba12e603ee3d5d8e$var$x("185")));
}
function $ba12e603ee3d5d8e$var$ki(a, b, c, d, e) {
    return $jmjQ5.unstable_runWithPriority($jmjQ5.unstable_ImmediatePriority, function() {
        return a(b, c, d, e);
    });
}
var $ba12e603ee3d5d8e$var$li = null, $ba12e603ee3d5d8e$var$Y = null, $ba12e603ee3d5d8e$var$mi = 0, $ba12e603ee3d5d8e$var$ni = void 0, $ba12e603ee3d5d8e$var$W = !1, $ba12e603ee3d5d8e$var$oi = null, $ba12e603ee3d5d8e$var$Z = 0, $ba12e603ee3d5d8e$var$gi = 0, $ba12e603ee3d5d8e$var$pi = !1, $ba12e603ee3d5d8e$var$qi = null, $ba12e603ee3d5d8e$var$X = !1, $ba12e603ee3d5d8e$var$ri = !1, $ba12e603ee3d5d8e$var$si = null, $ba12e603ee3d5d8e$var$ti = $jmjQ5.unstable_now(), $ba12e603ee3d5d8e$var$ui = 1073741822 - ($ba12e603ee3d5d8e$var$ti / 10 | 0), $ba12e603ee3d5d8e$var$vi = $ba12e603ee3d5d8e$var$ui, $ba12e603ee3d5d8e$var$ji = 50, $ba12e603ee3d5d8e$var$ii = 0, $ba12e603ee3d5d8e$var$wi = null;
function $ba12e603ee3d5d8e$var$xi() {
    $ba12e603ee3d5d8e$var$ui = 1073741822 - (($jmjQ5.unstable_now() - $ba12e603ee3d5d8e$var$ti) / 10 | 0);
}
function $ba12e603ee3d5d8e$var$yi(a, b) {
    if (0 !== $ba12e603ee3d5d8e$var$mi) {
        if (b < $ba12e603ee3d5d8e$var$mi) return;
        null !== $ba12e603ee3d5d8e$var$ni && $jmjQ5.unstable_cancelCallback($ba12e603ee3d5d8e$var$ni);
    }
    $ba12e603ee3d5d8e$var$mi = b;
    a = $jmjQ5.unstable_now() - $ba12e603ee3d5d8e$var$ti;
    $ba12e603ee3d5d8e$var$ni = $jmjQ5.unstable_scheduleCallback($ba12e603ee3d5d8e$var$zi, {
        timeout: 10 * (1073741822 - b) - a
    });
}
function $ba12e603ee3d5d8e$var$fi(a, b, c, d, e) {
    a.expirationTime = d;
    0 !== e || $ba12e603ee3d5d8e$var$di() ? 0 < e && (a.timeoutHandle = $ba12e603ee3d5d8e$var$ye($ba12e603ee3d5d8e$var$Ai.bind(null, a, b, c), e)) : (a.pendingCommitExpirationTime = c, a.finishedWork = b);
}
function $ba12e603ee3d5d8e$var$Ai(a, b, c) {
    a.pendingCommitExpirationTime = c;
    a.finishedWork = b;
    $ba12e603ee3d5d8e$var$xi();
    $ba12e603ee3d5d8e$var$vi = $ba12e603ee3d5d8e$var$ui;
    $ba12e603ee3d5d8e$var$Bi(a, c);
}
function $ba12e603ee3d5d8e$var$$h(a, b) {
    a.expirationTime = b;
    a.finishedWork = null;
}
function $ba12e603ee3d5d8e$var$lf() {
    if ($ba12e603ee3d5d8e$var$W) return $ba12e603ee3d5d8e$var$vi;
    $ba12e603ee3d5d8e$var$Ci();
    if (0 === $ba12e603ee3d5d8e$var$Z || 1 === $ba12e603ee3d5d8e$var$Z) $ba12e603ee3d5d8e$var$xi(), $ba12e603ee3d5d8e$var$vi = $ba12e603ee3d5d8e$var$ui;
    return $ba12e603ee3d5d8e$var$vi;
}
function $ba12e603ee3d5d8e$var$Xh(a, b) {
    null === a.nextScheduledRoot ? (a.expirationTime = b, null === $ba12e603ee3d5d8e$var$Y ? ($ba12e603ee3d5d8e$var$li = $ba12e603ee3d5d8e$var$Y = a, a.nextScheduledRoot = a) : ($ba12e603ee3d5d8e$var$Y = $ba12e603ee3d5d8e$var$Y.nextScheduledRoot = a, $ba12e603ee3d5d8e$var$Y.nextScheduledRoot = $ba12e603ee3d5d8e$var$li)) : b > a.expirationTime && (a.expirationTime = b);
    $ba12e603ee3d5d8e$var$W || ($ba12e603ee3d5d8e$var$X ? $ba12e603ee3d5d8e$var$ri && ($ba12e603ee3d5d8e$var$oi = a, $ba12e603ee3d5d8e$var$Z = 1073741823, $ba12e603ee3d5d8e$var$Di(a, 1073741823, !1)) : 1073741823 === b ? $ba12e603ee3d5d8e$var$Yh(1073741823, !1) : $ba12e603ee3d5d8e$var$yi(a, b));
}
function $ba12e603ee3d5d8e$var$Ci() {
    var a = 0, b = null;
    if (null !== $ba12e603ee3d5d8e$var$Y) for(var c = $ba12e603ee3d5d8e$var$Y, d = $ba12e603ee3d5d8e$var$li; null !== d;){
        var e = d.expirationTime;
        if (0 === e) {
            (null === c || null === $ba12e603ee3d5d8e$var$Y) && $ba12e603ee3d5d8e$var$x("244");
            if (d === d.nextScheduledRoot) {
                $ba12e603ee3d5d8e$var$li = $ba12e603ee3d5d8e$var$Y = d.nextScheduledRoot = null;
                break;
            } else if (d === $ba12e603ee3d5d8e$var$li) $ba12e603ee3d5d8e$var$li = e = d.nextScheduledRoot, $ba12e603ee3d5d8e$var$Y.nextScheduledRoot = e, d.nextScheduledRoot = null;
            else if (d === $ba12e603ee3d5d8e$var$Y) {
                $ba12e603ee3d5d8e$var$Y = c;
                $ba12e603ee3d5d8e$var$Y.nextScheduledRoot = $ba12e603ee3d5d8e$var$li;
                d.nextScheduledRoot = null;
                break;
            } else c.nextScheduledRoot = d.nextScheduledRoot, d.nextScheduledRoot = null;
            d = c.nextScheduledRoot;
        } else {
            e > a && (a = e, b = d);
            if (d === $ba12e603ee3d5d8e$var$Y) break;
            if (1073741823 === a) break;
            c = d;
            d = d.nextScheduledRoot;
        }
    }
    $ba12e603ee3d5d8e$var$oi = b;
    $ba12e603ee3d5d8e$var$Z = a;
}
var $ba12e603ee3d5d8e$var$Ei = !1;
function $ba12e603ee3d5d8e$var$di() {
    return $ba12e603ee3d5d8e$var$Ei ? !0 : $jmjQ5.unstable_shouldYield() ? $ba12e603ee3d5d8e$var$Ei = !0 : !1;
}
function $ba12e603ee3d5d8e$var$zi() {
    try {
        if (!$ba12e603ee3d5d8e$var$di() && null !== $ba12e603ee3d5d8e$var$li) {
            $ba12e603ee3d5d8e$var$xi();
            var a = $ba12e603ee3d5d8e$var$li;
            do {
                var b = a.expirationTime;
                0 !== b && $ba12e603ee3d5d8e$var$ui <= b && (a.nextExpirationTimeToWorkOn = $ba12e603ee3d5d8e$var$ui);
                a = a.nextScheduledRoot;
            }while (a !== $ba12e603ee3d5d8e$var$li);
        }
        $ba12e603ee3d5d8e$var$Yh(0, !0);
    } finally{
        $ba12e603ee3d5d8e$var$Ei = !1;
    }
}
function $ba12e603ee3d5d8e$var$Yh(a, b) {
    $ba12e603ee3d5d8e$var$Ci();
    if (b) for($ba12e603ee3d5d8e$var$xi(), $ba12e603ee3d5d8e$var$vi = $ba12e603ee3d5d8e$var$ui; null !== $ba12e603ee3d5d8e$var$oi && 0 !== $ba12e603ee3d5d8e$var$Z && a <= $ba12e603ee3d5d8e$var$Z && !($ba12e603ee3d5d8e$var$Ei && $ba12e603ee3d5d8e$var$ui > $ba12e603ee3d5d8e$var$Z);)$ba12e603ee3d5d8e$var$Di($ba12e603ee3d5d8e$var$oi, $ba12e603ee3d5d8e$var$Z, $ba12e603ee3d5d8e$var$ui > $ba12e603ee3d5d8e$var$Z), $ba12e603ee3d5d8e$var$Ci(), $ba12e603ee3d5d8e$var$xi(), $ba12e603ee3d5d8e$var$vi = $ba12e603ee3d5d8e$var$ui;
    else for(; null !== $ba12e603ee3d5d8e$var$oi && 0 !== $ba12e603ee3d5d8e$var$Z && a <= $ba12e603ee3d5d8e$var$Z;)$ba12e603ee3d5d8e$var$Di($ba12e603ee3d5d8e$var$oi, $ba12e603ee3d5d8e$var$Z, !1), $ba12e603ee3d5d8e$var$Ci();
    b && ($ba12e603ee3d5d8e$var$mi = 0, $ba12e603ee3d5d8e$var$ni = null);
    0 !== $ba12e603ee3d5d8e$var$Z && $ba12e603ee3d5d8e$var$yi($ba12e603ee3d5d8e$var$oi, $ba12e603ee3d5d8e$var$Z);
    $ba12e603ee3d5d8e$var$ii = 0;
    $ba12e603ee3d5d8e$var$wi = null;
    if (null !== $ba12e603ee3d5d8e$var$si) for(a = $ba12e603ee3d5d8e$var$si, $ba12e603ee3d5d8e$var$si = null, b = 0; b < a.length; b++){
        var c = a[b];
        try {
            c._onComplete();
        } catch (d) {
            $ba12e603ee3d5d8e$var$pi || ($ba12e603ee3d5d8e$var$pi = !0, $ba12e603ee3d5d8e$var$qi = d);
        }
    }
    if ($ba12e603ee3d5d8e$var$pi) throw a = $ba12e603ee3d5d8e$var$qi, $ba12e603ee3d5d8e$var$qi = null, $ba12e603ee3d5d8e$var$pi = !1, a;
}
function $ba12e603ee3d5d8e$var$Bi(a, b) {
    $ba12e603ee3d5d8e$var$W && $ba12e603ee3d5d8e$var$x("253");
    $ba12e603ee3d5d8e$var$oi = a;
    $ba12e603ee3d5d8e$var$Z = b;
    $ba12e603ee3d5d8e$var$Di(a, b, !1);
    $ba12e603ee3d5d8e$var$Yh(1073741823, !1);
}
function $ba12e603ee3d5d8e$var$Di(a, b, c) {
    $ba12e603ee3d5d8e$var$W && $ba12e603ee3d5d8e$var$x("245");
    $ba12e603ee3d5d8e$var$W = !0;
    if (c) {
        var d = a.finishedWork;
        null !== d ? $ba12e603ee3d5d8e$var$Fi(a, d, b) : (a.finishedWork = null, d = a.timeoutHandle, -1 !== d && (a.timeoutHandle = -1, $ba12e603ee3d5d8e$var$ze(d)), $ba12e603ee3d5d8e$var$ci(a, c), d = a.finishedWork, null !== d && ($ba12e603ee3d5d8e$var$di() ? a.finishedWork = d : $ba12e603ee3d5d8e$var$Fi(a, d, b)));
    } else d = a.finishedWork, null !== d ? $ba12e603ee3d5d8e$var$Fi(a, d, b) : (a.finishedWork = null, d = a.timeoutHandle, -1 !== d && (a.timeoutHandle = -1, $ba12e603ee3d5d8e$var$ze(d)), $ba12e603ee3d5d8e$var$ci(a, c), d = a.finishedWork, null !== d && $ba12e603ee3d5d8e$var$Fi(a, d, b));
    $ba12e603ee3d5d8e$var$W = !1;
}
function $ba12e603ee3d5d8e$var$Fi(a, b, c) {
    var d = a.firstBatch;
    if (null !== d && d._expirationTime >= c && (null === $ba12e603ee3d5d8e$var$si ? $ba12e603ee3d5d8e$var$si = [
        d
    ] : $ba12e603ee3d5d8e$var$si.push(d), d._defer)) {
        a.finishedWork = b;
        a.expirationTime = 0;
        return;
    }
    a.finishedWork = null;
    a === $ba12e603ee3d5d8e$var$wi ? $ba12e603ee3d5d8e$var$ii++ : ($ba12e603ee3d5d8e$var$wi = a, $ba12e603ee3d5d8e$var$ii = 0);
    $jmjQ5.unstable_runWithPriority($jmjQ5.unstable_ImmediatePriority, function() {
        $ba12e603ee3d5d8e$var$Zh(a, b);
    });
}
function $ba12e603ee3d5d8e$var$Dh(a) {
    null === $ba12e603ee3d5d8e$var$oi && $ba12e603ee3d5d8e$var$x("246");
    $ba12e603ee3d5d8e$var$oi.expirationTime = 0;
    $ba12e603ee3d5d8e$var$pi || ($ba12e603ee3d5d8e$var$pi = !0, $ba12e603ee3d5d8e$var$qi = a);
}
function $ba12e603ee3d5d8e$var$Gi(a, b) {
    var c = $ba12e603ee3d5d8e$var$X;
    $ba12e603ee3d5d8e$var$X = !0;
    try {
        return a(b);
    } finally{
        ($ba12e603ee3d5d8e$var$X = c) || $ba12e603ee3d5d8e$var$W || $ba12e603ee3d5d8e$var$Yh(1073741823, !1);
    }
}
function $ba12e603ee3d5d8e$var$Hi(a, b) {
    if ($ba12e603ee3d5d8e$var$X && !$ba12e603ee3d5d8e$var$ri) {
        $ba12e603ee3d5d8e$var$ri = !0;
        try {
            return a(b);
        } finally{
            $ba12e603ee3d5d8e$var$ri = !1;
        }
    }
    return a(b);
}
function $ba12e603ee3d5d8e$var$Ii(a, b, c) {
    $ba12e603ee3d5d8e$var$X || $ba12e603ee3d5d8e$var$W || 0 === $ba12e603ee3d5d8e$var$gi || ($ba12e603ee3d5d8e$var$Yh($ba12e603ee3d5d8e$var$gi, !1), $ba12e603ee3d5d8e$var$gi = 0);
    var d = $ba12e603ee3d5d8e$var$X;
    $ba12e603ee3d5d8e$var$X = !0;
    try {
        return $jmjQ5.unstable_runWithPriority($jmjQ5.unstable_UserBlockingPriority, function() {
            return a(b, c);
        });
    } finally{
        ($ba12e603ee3d5d8e$var$X = d) || $ba12e603ee3d5d8e$var$W || $ba12e603ee3d5d8e$var$Yh(1073741823, !1);
    }
}
function $ba12e603ee3d5d8e$var$Ji(a, b, c, d, e) {
    var f = b.current;
    a: if (c) {
        c = c._reactInternalFiber;
        b: {
            2 === $ba12e603ee3d5d8e$var$ed(c) && 1 === c.tag || $ba12e603ee3d5d8e$var$x("170");
            var g = c;
            do {
                switch(g.tag){
                    case 3:
                        g = g.stateNode.context;
                        break b;
                    case 1:
                        if ($ba12e603ee3d5d8e$var$J(g.type)) {
                            g = g.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                g = g.return;
            }while (null !== g);
            $ba12e603ee3d5d8e$var$x("171");
            g = void 0;
        }
        if (1 === c.tag) {
            var h = c.type;
            if ($ba12e603ee3d5d8e$var$J(h)) {
                c = $ba12e603ee3d5d8e$var$Ne(c, h, g);
                break a;
            }
        }
        c = g;
    } else c = $ba12e603ee3d5d8e$var$He;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = e;
    e = $ba12e603ee3d5d8e$var$nf(d);
    e.payload = {
        element: a
    };
    b = void 0 === b ? null : b;
    null !== b && (e.callback = b);
    $ba12e603ee3d5d8e$var$of();
    $ba12e603ee3d5d8e$var$pf(f, e);
    $ba12e603ee3d5d8e$var$qf(f, d);
    return d;
}
function $ba12e603ee3d5d8e$var$Ki(a, b, c, d) {
    var e = b.current, f = $ba12e603ee3d5d8e$var$lf();
    e = $ba12e603ee3d5d8e$var$mf(f, e);
    return $ba12e603ee3d5d8e$var$Ji(a, b, c, e, d);
}
function $ba12e603ee3d5d8e$var$Li(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $ba12e603ee3d5d8e$var$Mi(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $ba12e603ee3d5d8e$var$Wb,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
$ba12e603ee3d5d8e$var$Ab = function(a, b, c) {
    switch(b){
        case "input":
            $ba12e603ee3d5d8e$var$yc(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $ba12e603ee3d5d8e$var$Ka(d);
                        e || $ba12e603ee3d5d8e$var$x("90");
                        $ba12e603ee3d5d8e$var$Sb(d);
                        $ba12e603ee3d5d8e$var$yc(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $ba12e603ee3d5d8e$var$de(a, c);
            break;
        case "select":
            b = c.value, null != b && $ba12e603ee3d5d8e$var$ae(a, !!c.multiple, b, !1);
    }
};
function $ba12e603ee3d5d8e$var$Ni(a) {
    var b = 1073741822 - 25 * (((1073741822 - $ba12e603ee3d5d8e$var$lf() + 500) / 25 | 0) + 1);
    b >= $ba12e603ee3d5d8e$var$Jh && (b = $ba12e603ee3d5d8e$var$Jh - 1);
    this._expirationTime = $ba12e603ee3d5d8e$var$Jh = b;
    this._root = a;
    this._callbacks = this._next = null;
    this._hasChildren = this._didComplete = !1;
    this._children = null;
    this._defer = !0;
}
$ba12e603ee3d5d8e$var$Ni.prototype.render = function(a) {
    this._defer || $ba12e603ee3d5d8e$var$x("250");
    this._hasChildren = !0;
    this._children = a;
    var b = this._root._internalRoot, c = this._expirationTime, d = new $ba12e603ee3d5d8e$var$Oi;
    $ba12e603ee3d5d8e$var$Ji(a, b, null, c, d._onCommit);
    return d;
};
$ba12e603ee3d5d8e$var$Ni.prototype.then = function(a) {
    if (this._didComplete) a();
    else {
        var b = this._callbacks;
        null === b && (b = this._callbacks = []);
        b.push(a);
    }
};
$ba12e603ee3d5d8e$var$Ni.prototype.commit = function() {
    var a = this._root._internalRoot, b = a.firstBatch;
    this._defer && null !== b || $ba12e603ee3d5d8e$var$x("251");
    if (this._hasChildren) {
        var c = this._expirationTime;
        if (b !== this) {
            this._hasChildren && (c = this._expirationTime = b._expirationTime, this.render(this._children));
            for(var d = null, e = b; e !== this;)d = e, e = e._next;
            null === d && $ba12e603ee3d5d8e$var$x("251");
            d._next = e._next;
            this._next = b;
            a.firstBatch = this;
        }
        this._defer = !1;
        $ba12e603ee3d5d8e$var$Bi(a, c);
        b = this._next;
        this._next = null;
        b = a.firstBatch = b;
        null !== b && b._hasChildren && b.render(b._children);
    } else this._next = null, this._defer = !1;
};
$ba12e603ee3d5d8e$var$Ni.prototype._onComplete = function() {
    if (!this._didComplete) {
        this._didComplete = !0;
        var a = this._callbacks;
        if (null !== a) for(var b = 0; b < a.length; b++)(0, a[b])();
    }
};
function $ba12e603ee3d5d8e$var$Oi() {
    this._callbacks = null;
    this._didCommit = !1;
    this._onCommit = this._onCommit.bind(this);
}
$ba12e603ee3d5d8e$var$Oi.prototype.then = function(a) {
    if (this._didCommit) a();
    else {
        var b = this._callbacks;
        null === b && (b = this._callbacks = []);
        b.push(a);
    }
};
$ba12e603ee3d5d8e$var$Oi.prototype._onCommit = function() {
    if (!this._didCommit) {
        this._didCommit = !0;
        var a = this._callbacks;
        if (null !== a) for(var b = 0; b < a.length; b++){
            var c = a[b];
            "function" !== typeof c && $ba12e603ee3d5d8e$var$x("191", c);
            c();
        }
    }
};
function $ba12e603ee3d5d8e$var$Pi(a, b, c) {
    b = $ba12e603ee3d5d8e$var$K(3, null, null, b ? 3 : 0);
    a = {
        current: b,
        containerInfo: a,
        pendingChildren: null,
        pingCache: null,
        earliestPendingTime: 0,
        latestPendingTime: 0,
        earliestSuspendedTime: 0,
        latestSuspendedTime: 0,
        latestPingedTime: 0,
        didError: !1,
        pendingCommitExpirationTime: 0,
        finishedWork: null,
        timeoutHandle: -1,
        context: null,
        pendingContext: null,
        hydrate: c,
        nextExpirationTimeToWorkOn: 0,
        expirationTime: 0,
        firstBatch: null,
        nextScheduledRoot: null
    };
    this._internalRoot = b.stateNode = a;
}
$ba12e603ee3d5d8e$var$Pi.prototype.render = function(a, b) {
    var c = this._internalRoot, d = new $ba12e603ee3d5d8e$var$Oi;
    b = void 0 === b ? null : b;
    null !== b && d.then(b);
    $ba12e603ee3d5d8e$var$Ki(a, c, null, d._onCommit);
    return d;
};
$ba12e603ee3d5d8e$var$Pi.prototype.unmount = function(a) {
    var b = this._internalRoot, c = new $ba12e603ee3d5d8e$var$Oi;
    a = void 0 === a ? null : a;
    null !== a && c.then(a);
    $ba12e603ee3d5d8e$var$Ki(null, b, null, c._onCommit);
    return c;
};
$ba12e603ee3d5d8e$var$Pi.prototype.legacy_renderSubtreeIntoContainer = function(a, b, c) {
    var d = this._internalRoot, e = new $ba12e603ee3d5d8e$var$Oi;
    c = void 0 === c ? null : c;
    null !== c && e.then(c);
    $ba12e603ee3d5d8e$var$Ki(b, d, a, e._onCommit);
    return e;
};
$ba12e603ee3d5d8e$var$Pi.prototype.createBatch = function() {
    var a = new $ba12e603ee3d5d8e$var$Ni(this), b = a._expirationTime, c = this._internalRoot, d = c.firstBatch;
    if (null === d) c.firstBatch = a, a._next = null;
    else {
        for(c = null; null !== d && d._expirationTime >= b;)c = d, d = d._next;
        a._next = d;
        null !== c && (c._next = a);
    }
    return a;
};
function $ba12e603ee3d5d8e$var$Qi(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
$ba12e603ee3d5d8e$var$Gb = $ba12e603ee3d5d8e$var$Gi;
$ba12e603ee3d5d8e$var$Hb = $ba12e603ee3d5d8e$var$Ii;
$ba12e603ee3d5d8e$var$Ib = function() {
    $ba12e603ee3d5d8e$var$W || 0 === $ba12e603ee3d5d8e$var$gi || ($ba12e603ee3d5d8e$var$Yh($ba12e603ee3d5d8e$var$gi, !1), $ba12e603ee3d5d8e$var$gi = 0);
};
function $ba12e603ee3d5d8e$var$Ri(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new $ba12e603ee3d5d8e$var$Pi(a, !1, b);
}
function $ba12e603ee3d5d8e$var$Si(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        if ("function" === typeof e) {
            var g = e;
            e = function() {
                var a = $ba12e603ee3d5d8e$var$Li(f._internalRoot);
                g.call(a);
            };
        }
        null != a ? f.legacy_renderSubtreeIntoContainer(a, b, e) : f.render(b, e);
    } else {
        f = c._reactRootContainer = $ba12e603ee3d5d8e$var$Ri(c, d);
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $ba12e603ee3d5d8e$var$Li(f._internalRoot);
                h.call(a);
            };
        }
        $ba12e603ee3d5d8e$var$Hi(function() {
            null != a ? f.legacy_renderSubtreeIntoContainer(a, b, e) : f.render(b, e);
        });
    }
    return $ba12e603ee3d5d8e$var$Li(f._internalRoot);
}
function $ba12e603ee3d5d8e$var$Ti(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    $ba12e603ee3d5d8e$var$Qi(b) || $ba12e603ee3d5d8e$var$x("200");
    return $ba12e603ee3d5d8e$var$Mi(a, b, null, c);
}
var $ba12e603ee3d5d8e$var$Vi = {
    createPortal: $ba12e603ee3d5d8e$var$Ti,
    findDOMNode: function(a) {
        if (null == a) return null;
        if (1 === a.nodeType) return a;
        var b = a._reactInternalFiber;
        void 0 === b && ("function" === typeof a.render ? $ba12e603ee3d5d8e$var$x("188") : $ba12e603ee3d5d8e$var$x("268", Object.keys(a)));
        a = $ba12e603ee3d5d8e$var$hd(b);
        a = null === a ? null : a.stateNode;
        return a;
    },
    hydrate: function(a, b, c) {
        $ba12e603ee3d5d8e$var$Qi(b) || $ba12e603ee3d5d8e$var$x("200");
        return $ba12e603ee3d5d8e$var$Si(null, a, b, !0, c);
    },
    render: function(a, b, c) {
        $ba12e603ee3d5d8e$var$Qi(b) || $ba12e603ee3d5d8e$var$x("200");
        return $ba12e603ee3d5d8e$var$Si(null, a, b, !1, c);
    },
    unstable_renderSubtreeIntoContainer: function(a, b, c, d) {
        $ba12e603ee3d5d8e$var$Qi(c) || $ba12e603ee3d5d8e$var$x("200");
        (null == a || void 0 === a._reactInternalFiber) && $ba12e603ee3d5d8e$var$x("38");
        return $ba12e603ee3d5d8e$var$Si(a, b, c, !1, d);
    },
    unmountComponentAtNode: function(a) {
        $ba12e603ee3d5d8e$var$Qi(a) || $ba12e603ee3d5d8e$var$x("40");
        return a._reactRootContainer ? ($ba12e603ee3d5d8e$var$Hi(function() {
            $ba12e603ee3d5d8e$var$Si(null, null, a, !1, function() {
                a._reactRootContainer = null;
            });
        }), !0) : !1;
    },
    unstable_createPortal: function() {
        return $ba12e603ee3d5d8e$var$Ti.apply(void 0, arguments);
    },
    unstable_batchedUpdates: $ba12e603ee3d5d8e$var$Gi,
    unstable_interactiveUpdates: $ba12e603ee3d5d8e$var$Ii,
    flushSync: function(a, b) {
        $ba12e603ee3d5d8e$var$W && $ba12e603ee3d5d8e$var$x("187");
        var c = $ba12e603ee3d5d8e$var$X;
        $ba12e603ee3d5d8e$var$X = !0;
        try {
            return $ba12e603ee3d5d8e$var$ki(a, b);
        } finally{
            $ba12e603ee3d5d8e$var$X = c, $ba12e603ee3d5d8e$var$Yh(1073741823, !1);
        }
    },
    unstable_createRoot: $ba12e603ee3d5d8e$var$Ui,
    unstable_flushControlled: function(a) {
        var b = $ba12e603ee3d5d8e$var$X;
        $ba12e603ee3d5d8e$var$X = !0;
        try {
            $ba12e603ee3d5d8e$var$ki(a);
        } finally{
            ($ba12e603ee3d5d8e$var$X = b) || $ba12e603ee3d5d8e$var$W || $ba12e603ee3d5d8e$var$Yh(1073741823, !1);
        }
    },
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
        Events: [
            $ba12e603ee3d5d8e$var$Ia,
            $ba12e603ee3d5d8e$var$Ja,
            $ba12e603ee3d5d8e$var$Ka,
            $ba12e603ee3d5d8e$var$Ba.injectEventPluginsByName,
            $ba12e603ee3d5d8e$var$pa,
            $ba12e603ee3d5d8e$var$Qa,
            function(a) {
                $ba12e603ee3d5d8e$var$ya(a, $ba12e603ee3d5d8e$var$Pa);
            },
            $ba12e603ee3d5d8e$var$Eb,
            $ba12e603ee3d5d8e$var$Fb,
            $ba12e603ee3d5d8e$var$Dd,
            $ba12e603ee3d5d8e$var$Da
        ]
    }
};
function $ba12e603ee3d5d8e$var$Ui(a, b) {
    $ba12e603ee3d5d8e$var$Qi(a) || $ba12e603ee3d5d8e$var$x("299", "unstable_createRoot");
    return new $ba12e603ee3d5d8e$var$Pi(a, !0, null != b && !0 === b.hydrate);
}
(function(a) {
    var b = a.findFiberByHostInstance;
    return $ba12e603ee3d5d8e$var$Te($63ReS({}, a, {
        overrideProps: null,
        currentDispatcherRef: $ba12e603ee3d5d8e$var$Tb.ReactCurrentDispatcher,
        findHostInstanceByFiber: function(a) {
            a = $ba12e603ee3d5d8e$var$hd(a);
            return null === a ? null : a.stateNode;
        },
        findFiberByHostInstance: function(a) {
            return b ? b(a) : null;
        }
    }));
})({
    findFiberByHostInstance: $ba12e603ee3d5d8e$var$Ha,
    bundleType: 0,
    version: "16.8.6",
    rendererPackageName: "react-dom"
});
var $ba12e603ee3d5d8e$var$Wi = {
    default: $ba12e603ee3d5d8e$var$Vi
}, $ba12e603ee3d5d8e$var$Xi = $ba12e603ee3d5d8e$var$Wi && $ba12e603ee3d5d8e$var$Vi || $ba12e603ee3d5d8e$var$Wi;
module.exports = $ba12e603ee3d5d8e$var$Xi.default || $ba12e603ee3d5d8e$var$Xi;

});
parcelRegister("6wXVr", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hOXrc"));

});

parcelRegister("jmjQ5", function(module, exports) {
'use strict';

module.exports = (parcelRequire("f6aY4"));

});
parcelRegister("f6aY4", function(module, exports) {
/** @license React v0.13.6
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: !0
});
var $afdfec8a6436669b$var$d = null, $afdfec8a6436669b$var$e = !1, $afdfec8a6436669b$var$g = 3, $afdfec8a6436669b$var$k = -1, $afdfec8a6436669b$var$l = -1, $afdfec8a6436669b$var$m = !1, $afdfec8a6436669b$var$n = !1;
function $afdfec8a6436669b$var$p() {
    if (!$afdfec8a6436669b$var$m) {
        var a = $afdfec8a6436669b$var$d.expirationTime;
        $afdfec8a6436669b$var$n ? $afdfec8a6436669b$var$q() : $afdfec8a6436669b$var$n = !0;
        $afdfec8a6436669b$var$r($afdfec8a6436669b$var$t, a);
    }
}
function $afdfec8a6436669b$var$u() {
    var a = $afdfec8a6436669b$var$d, b = $afdfec8a6436669b$var$d.next;
    if ($afdfec8a6436669b$var$d === b) $afdfec8a6436669b$var$d = null;
    else {
        var c = $afdfec8a6436669b$var$d.previous;
        $afdfec8a6436669b$var$d = c.next = b;
        b.previous = c;
    }
    a.next = a.previous = null;
    c = a.callback;
    b = a.expirationTime;
    a = a.priorityLevel;
    var f = $afdfec8a6436669b$var$g, Q = $afdfec8a6436669b$var$l;
    $afdfec8a6436669b$var$g = a;
    $afdfec8a6436669b$var$l = b;
    try {
        var h = c();
    } finally{
        $afdfec8a6436669b$var$g = f, $afdfec8a6436669b$var$l = Q;
    }
    if ("function" === typeof h) {
        if (h = {
            callback: h,
            priorityLevel: a,
            expirationTime: b,
            next: null,
            previous: null
        }, null === $afdfec8a6436669b$var$d) $afdfec8a6436669b$var$d = h.next = h.previous = h;
        else {
            c = null;
            a = $afdfec8a6436669b$var$d;
            do {
                if (a.expirationTime >= b) {
                    c = a;
                    break;
                }
                a = a.next;
            }while (a !== $afdfec8a6436669b$var$d);
            null === c ? c = $afdfec8a6436669b$var$d : c === $afdfec8a6436669b$var$d && ($afdfec8a6436669b$var$d = h, $afdfec8a6436669b$var$p());
            b = c.previous;
            b.next = c.previous = h;
            h.next = c;
            h.previous = b;
        }
    }
}
function $afdfec8a6436669b$var$v() {
    if (-1 === $afdfec8a6436669b$var$k && null !== $afdfec8a6436669b$var$d && 1 === $afdfec8a6436669b$var$d.priorityLevel) {
        $afdfec8a6436669b$var$m = !0;
        try {
            do $afdfec8a6436669b$var$u();
            while (null !== $afdfec8a6436669b$var$d && 1 === $afdfec8a6436669b$var$d.priorityLevel);
        } finally{
            $afdfec8a6436669b$var$m = !1, null !== $afdfec8a6436669b$var$d ? $afdfec8a6436669b$var$p() : $afdfec8a6436669b$var$n = !1;
        }
    }
}
function $afdfec8a6436669b$var$t(a) {
    $afdfec8a6436669b$var$m = !0;
    var b = $afdfec8a6436669b$var$e;
    $afdfec8a6436669b$var$e = a;
    try {
        if (a) for(; null !== $afdfec8a6436669b$var$d;){
            var c = module.exports.unstable_now();
            if ($afdfec8a6436669b$var$d.expirationTime <= c) do $afdfec8a6436669b$var$u();
            while (null !== $afdfec8a6436669b$var$d && $afdfec8a6436669b$var$d.expirationTime <= c);
            else break;
        }
        else if (null !== $afdfec8a6436669b$var$d) do $afdfec8a6436669b$var$u();
        while (null !== $afdfec8a6436669b$var$d && !$afdfec8a6436669b$var$w());
    } finally{
        $afdfec8a6436669b$var$m = !1, $afdfec8a6436669b$var$e = b, null !== $afdfec8a6436669b$var$d ? $afdfec8a6436669b$var$p() : $afdfec8a6436669b$var$n = !1, $afdfec8a6436669b$var$v();
    }
}
var $afdfec8a6436669b$var$x = Date, $afdfec8a6436669b$var$y = "function" === typeof setTimeout ? setTimeout : void 0, $afdfec8a6436669b$var$z = "function" === typeof clearTimeout ? clearTimeout : void 0, $afdfec8a6436669b$var$A = "function" === typeof requestAnimationFrame ? requestAnimationFrame : void 0, $afdfec8a6436669b$var$B = "function" === typeof cancelAnimationFrame ? cancelAnimationFrame : void 0, $afdfec8a6436669b$var$C, $afdfec8a6436669b$var$D;
function $afdfec8a6436669b$var$E(a) {
    $afdfec8a6436669b$var$C = $afdfec8a6436669b$var$A(function(b) {
        $afdfec8a6436669b$var$z($afdfec8a6436669b$var$D);
        a(b);
    });
    $afdfec8a6436669b$var$D = $afdfec8a6436669b$var$y(function() {
        $afdfec8a6436669b$var$B($afdfec8a6436669b$var$C);
        a(module.exports.unstable_now());
    }, 100);
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $afdfec8a6436669b$var$F = performance;
    module.exports.unstable_now = function() {
        return $afdfec8a6436669b$var$F.now();
    };
} else module.exports.unstable_now = function() {
    return $afdfec8a6436669b$var$x.now();
};
var $afdfec8a6436669b$var$r, $afdfec8a6436669b$var$q, $afdfec8a6436669b$var$w, $afdfec8a6436669b$var$G = null;
"undefined" !== typeof window ? $afdfec8a6436669b$var$G = window : "undefined" !== typeof $parcel$global && ($afdfec8a6436669b$var$G = $parcel$global);
if ($afdfec8a6436669b$var$G && $afdfec8a6436669b$var$G._schedMock) {
    var $afdfec8a6436669b$var$H = $afdfec8a6436669b$var$G._schedMock;
    $afdfec8a6436669b$var$r = $afdfec8a6436669b$var$H[0];
    $afdfec8a6436669b$var$q = $afdfec8a6436669b$var$H[1];
    $afdfec8a6436669b$var$w = $afdfec8a6436669b$var$H[2];
    module.exports.unstable_now = $afdfec8a6436669b$var$H[3];
} else if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $afdfec8a6436669b$var$I = null, $afdfec8a6436669b$var$J = function(a) {
        if (null !== $afdfec8a6436669b$var$I) try {
            $afdfec8a6436669b$var$I(a);
        } finally{
            $afdfec8a6436669b$var$I = null;
        }
    };
    $afdfec8a6436669b$var$r = function(a) {
        null !== $afdfec8a6436669b$var$I ? setTimeout($afdfec8a6436669b$var$r, 0, a) : ($afdfec8a6436669b$var$I = a, setTimeout($afdfec8a6436669b$var$J, 0, !1));
    };
    $afdfec8a6436669b$var$q = function() {
        $afdfec8a6436669b$var$I = null;
    };
    $afdfec8a6436669b$var$w = function() {
        return !1;
    };
} else {
    "undefined" !== typeof console && ("function" !== typeof $afdfec8a6436669b$var$A && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"), "function" !== typeof $afdfec8a6436669b$var$B && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));
    var $afdfec8a6436669b$var$K = null, $afdfec8a6436669b$var$L = !1, $afdfec8a6436669b$var$M = -1, $afdfec8a6436669b$var$N = !1, $afdfec8a6436669b$var$O = !1, $afdfec8a6436669b$var$P = 0, $afdfec8a6436669b$var$R = 33, $afdfec8a6436669b$var$S = 33;
    $afdfec8a6436669b$var$w = function() {
        return $afdfec8a6436669b$var$P <= module.exports.unstable_now();
    };
    var $afdfec8a6436669b$var$T = new MessageChannel, $afdfec8a6436669b$var$U = $afdfec8a6436669b$var$T.port2;
    $afdfec8a6436669b$var$T.port1.onmessage = function() {
        $afdfec8a6436669b$var$L = !1;
        var a = $afdfec8a6436669b$var$K, b = $afdfec8a6436669b$var$M;
        $afdfec8a6436669b$var$K = null;
        $afdfec8a6436669b$var$M = -1;
        var c = module.exports.unstable_now(), f = !1;
        if (0 >= $afdfec8a6436669b$var$P - c) {
            if (-1 !== b && b <= c) f = !0;
            else {
                $afdfec8a6436669b$var$N || ($afdfec8a6436669b$var$N = !0, $afdfec8a6436669b$var$E($afdfec8a6436669b$var$V));
                $afdfec8a6436669b$var$K = a;
                $afdfec8a6436669b$var$M = b;
                return;
            }
        }
        if (null !== a) {
            $afdfec8a6436669b$var$O = !0;
            try {
                a(f);
            } finally{
                $afdfec8a6436669b$var$O = !1;
            }
        }
    };
    var $afdfec8a6436669b$var$V = function(a) {
        if (null !== $afdfec8a6436669b$var$K) {
            $afdfec8a6436669b$var$E($afdfec8a6436669b$var$V);
            var b = a - $afdfec8a6436669b$var$P + $afdfec8a6436669b$var$S;
            b < $afdfec8a6436669b$var$S && $afdfec8a6436669b$var$R < $afdfec8a6436669b$var$S ? (8 > b && (b = 8), $afdfec8a6436669b$var$S = b < $afdfec8a6436669b$var$R ? $afdfec8a6436669b$var$R : b) : $afdfec8a6436669b$var$R = b;
            $afdfec8a6436669b$var$P = a + $afdfec8a6436669b$var$S;
            $afdfec8a6436669b$var$L || ($afdfec8a6436669b$var$L = !0, $afdfec8a6436669b$var$U.postMessage(void 0));
        } else $afdfec8a6436669b$var$N = !1;
    };
    $afdfec8a6436669b$var$r = function(a, b) {
        $afdfec8a6436669b$var$K = a;
        $afdfec8a6436669b$var$M = b;
        $afdfec8a6436669b$var$O || 0 > b ? $afdfec8a6436669b$var$U.postMessage(void 0) : $afdfec8a6436669b$var$N || ($afdfec8a6436669b$var$N = !0, $afdfec8a6436669b$var$E($afdfec8a6436669b$var$V));
    };
    $afdfec8a6436669b$var$q = function() {
        $afdfec8a6436669b$var$K = null;
        $afdfec8a6436669b$var$L = !1;
        $afdfec8a6436669b$var$M = -1;
    };
}
module.exports.unstable_ImmediatePriority = 1;
module.exports.unstable_UserBlockingPriority = 2;
module.exports.unstable_NormalPriority = 3;
module.exports.unstable_IdlePriority = 5;
module.exports.unstable_LowPriority = 4;
module.exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $afdfec8a6436669b$var$g, f = $afdfec8a6436669b$var$k;
    $afdfec8a6436669b$var$g = a;
    $afdfec8a6436669b$var$k = module.exports.unstable_now();
    try {
        return b();
    } finally{
        $afdfec8a6436669b$var$g = c, $afdfec8a6436669b$var$k = f, $afdfec8a6436669b$var$v();
    }
};
module.exports.unstable_next = function(a) {
    switch($afdfec8a6436669b$var$g){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $afdfec8a6436669b$var$g;
    }
    var c = $afdfec8a6436669b$var$g, f = $afdfec8a6436669b$var$k;
    $afdfec8a6436669b$var$g = b;
    $afdfec8a6436669b$var$k = module.exports.unstable_now();
    try {
        return a();
    } finally{
        $afdfec8a6436669b$var$g = c, $afdfec8a6436669b$var$k = f, $afdfec8a6436669b$var$v();
    }
};
module.exports.unstable_scheduleCallback = function(a, b) {
    var c = -1 !== $afdfec8a6436669b$var$k ? $afdfec8a6436669b$var$k : module.exports.unstable_now();
    if ("object" === typeof b && null !== b && "number" === typeof b.timeout) b = c + b.timeout;
    else switch($afdfec8a6436669b$var$g){
        case 1:
            b = c + -1;
            break;
        case 2:
            b = c + 250;
            break;
        case 5:
            b = c + 1073741823;
            break;
        case 4:
            b = c + 1E4;
            break;
        default:
            b = c + 5E3;
    }
    a = {
        callback: a,
        priorityLevel: $afdfec8a6436669b$var$g,
        expirationTime: b,
        next: null,
        previous: null
    };
    if (null === $afdfec8a6436669b$var$d) $afdfec8a6436669b$var$d = a.next = a.previous = a, $afdfec8a6436669b$var$p();
    else {
        c = null;
        var f = $afdfec8a6436669b$var$d;
        do {
            if (f.expirationTime > b) {
                c = f;
                break;
            }
            f = f.next;
        }while (f !== $afdfec8a6436669b$var$d);
        null === c ? c = $afdfec8a6436669b$var$d : c === $afdfec8a6436669b$var$d && ($afdfec8a6436669b$var$d = a, $afdfec8a6436669b$var$p());
        b = c.previous;
        b.next = c.previous = a;
        a.next = c;
        a.previous = b;
    }
    return a;
};
module.exports.unstable_cancelCallback = function(a) {
    var b = a.next;
    if (null !== b) {
        if (b === a) $afdfec8a6436669b$var$d = null;
        else {
            a === $afdfec8a6436669b$var$d && ($afdfec8a6436669b$var$d = b);
            var c = a.previous;
            c.next = b;
            b.previous = c;
        }
        a.next = a.previous = null;
    }
};
module.exports.unstable_wrapCallback = function(a) {
    var b = $afdfec8a6436669b$var$g;
    return function() {
        var c = $afdfec8a6436669b$var$g, f = $afdfec8a6436669b$var$k;
        $afdfec8a6436669b$var$g = b;
        $afdfec8a6436669b$var$k = module.exports.unstable_now();
        try {
            return a.apply(this, arguments);
        } finally{
            $afdfec8a6436669b$var$g = c, $afdfec8a6436669b$var$k = f, $afdfec8a6436669b$var$v();
        }
    };
};
module.exports.unstable_getCurrentPriorityLevel = function() {
    return $afdfec8a6436669b$var$g;
};
module.exports.unstable_shouldYield = function() {
    return !$afdfec8a6436669b$var$e && (null !== $afdfec8a6436669b$var$d && $afdfec8a6436669b$var$d.expirationTime < $afdfec8a6436669b$var$l || $afdfec8a6436669b$var$w());
};
module.exports.unstable_continueExecution = function() {
    null !== $afdfec8a6436669b$var$d && $afdfec8a6436669b$var$p();
};
module.exports.unstable_pauseExecution = function() {};
module.exports.unstable_getFirstCallbackNode = function() {
    return $afdfec8a6436669b$var$d;
};

});



parcelRegister("hhMOc", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $fw1dk = parcelRequire("fw1dk");
function $c959e297fe11a7ad$var$emptyFunction() {}
function $c959e297fe11a7ad$var$emptyFunctionWithReset() {}
$c959e297fe11a7ad$var$emptyFunctionWithReset.resetWarningCache = $c959e297fe11a7ad$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $fw1dk) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $c959e297fe11a7ad$var$emptyFunctionWithReset,
        resetWarningCache: $c959e297fe11a7ad$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("fw1dk", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $b4bac93c3b7c5975$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $b4bac93c3b7c5975$var$ReactPropTypesSecret;

});


parcelRegister("3iOUP", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $267a8c513e879743$export$2b8d127b894957b9; }, function (v) { return $267a8c513e879743$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $267a8c513e879743$export$cea3a54a6425200c; }, function (v) { return $267a8c513e879743$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $267a8c513e879743$export$a7c73072b1a182ae; }, function (v) { return $267a8c513e879743$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $267a8c513e879743$export$9f27bc3417b4524d; }, function (v) { return $267a8c513e879743$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $267a8c513e879743$export$db77ccec0bb4ccac; }, function (v) { return $267a8c513e879743$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $267a8c513e879743$export$8392c0c9d3dcbd35; }, function (v) { return $267a8c513e879743$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $267a8c513e879743$export$ffb0004e005737fa; }, function (v) { return $267a8c513e879743$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $267a8c513e879743$export$b624eff549462981; }, function (v) { return $267a8c513e879743$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $267a8c513e879743$export$7897aa7841a5380c; }, function (v) { return $267a8c513e879743$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $267a8c513e879743$export$602eac185826482c; }, function (v) { return $267a8c513e879743$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $267a8c513e879743$export$e2c29f18771995cb; }, function (v) { return $267a8c513e879743$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $267a8c513e879743$export$5f8d39834fd61797; }, function (v) { return $267a8c513e879743$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $267a8c513e879743$export$74bf444e3cd11ea5; }, function (v) { return $267a8c513e879743$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $267a8c513e879743$export$92387174baf9b227; }, function (v) { return $267a8c513e879743$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $267a8c513e879743$export$ec112efeb987d9c6; }, function (v) { return $267a8c513e879743$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $267a8c513e879743$export$b706b080d889d2c9; }, function (v) { return $267a8c513e879743$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $267a8c513e879743$export$5be5a87408f70ddc; }, function (v) { return $267a8c513e879743$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $267a8c513e879743$export$45a5e7f76e0caa8d; }, function (v) { return $267a8c513e879743$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $267a8c513e879743$export$455c2e768291efa6; }, function (v) { return $267a8c513e879743$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $267a8c513e879743$export$9522e17588c12572; }, function (v) { return $267a8c513e879743$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $267a8c513e879743$export$2110ac352bb060b9; }, function (v) { return $267a8c513e879743$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $267a8c513e879743$export$56885ab8b9c456ab; }, function (v) { return $267a8c513e879743$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $267a8c513e879743$export$d927fcb6adf8f9de; }, function (v) { return $267a8c513e879743$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $267a8c513e879743$export$b82d16f27459e05a; }, function (v) { return $267a8c513e879743$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $267a8c513e879743$export$522c17b4f5e123e8; }, function (v) { return $267a8c513e879743$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $267a8c513e879743$export$1aabd8a0274ecfd6; }, function (v) { return $267a8c513e879743$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $267a8c513e879743$export$9b621391a187a31a; }, function (v) { return $267a8c513e879743$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $267a8c513e879743$export$f5bbd400c2f4426f; }, function (v) { return $267a8c513e879743$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $267a8c513e879743$export$2b8d127b894957b9;
var $267a8c513e879743$export$cea3a54a6425200c;
var $267a8c513e879743$export$a7c73072b1a182ae;
var $267a8c513e879743$export$9f27bc3417b4524d;
var $267a8c513e879743$export$db77ccec0bb4ccac;
var $267a8c513e879743$export$8392c0c9d3dcbd35;
var $267a8c513e879743$export$ffb0004e005737fa;
var $267a8c513e879743$export$b624eff549462981;
var $267a8c513e879743$export$7897aa7841a5380c;
var $267a8c513e879743$export$602eac185826482c;
var $267a8c513e879743$export$e2c29f18771995cb;
var $267a8c513e879743$export$5f8d39834fd61797;
var $267a8c513e879743$export$74bf444e3cd11ea5;
var $267a8c513e879743$export$92387174baf9b227;
var $267a8c513e879743$export$ec112efeb987d9c6;
var $267a8c513e879743$export$b706b080d889d2c9;
var $267a8c513e879743$export$5be5a87408f70ddc;
var $267a8c513e879743$export$45a5e7f76e0caa8d;
var $267a8c513e879743$export$455c2e768291efa6;
var $267a8c513e879743$export$9522e17588c12572;
var $267a8c513e879743$export$2110ac352bb060b9;
var $267a8c513e879743$export$56885ab8b9c456ab;
var $267a8c513e879743$export$d927fcb6adf8f9de;
var $267a8c513e879743$export$b82d16f27459e05a;
var $267a8c513e879743$export$522c17b4f5e123e8;
var $267a8c513e879743$export$1aabd8a0274ecfd6;
var $267a8c513e879743$export$9b621391a187a31a;
var $267a8c513e879743$export$f5bbd400c2f4426f;
'use strict';
var $267a8c513e879743$var$b = "function" === typeof Symbol && Symbol.for, $267a8c513e879743$var$c = $267a8c513e879743$var$b ? Symbol.for("react.element") : 60103, $267a8c513e879743$var$d = $267a8c513e879743$var$b ? Symbol.for("react.portal") : 60106, $267a8c513e879743$var$e = $267a8c513e879743$var$b ? Symbol.for("react.fragment") : 60107, $267a8c513e879743$var$f = $267a8c513e879743$var$b ? Symbol.for("react.strict_mode") : 60108, $267a8c513e879743$var$g = $267a8c513e879743$var$b ? Symbol.for("react.profiler") : 60114, $267a8c513e879743$var$h = $267a8c513e879743$var$b ? Symbol.for("react.provider") : 60109, $267a8c513e879743$var$k = $267a8c513e879743$var$b ? Symbol.for("react.context") : 60110, $267a8c513e879743$var$l = $267a8c513e879743$var$b ? Symbol.for("react.async_mode") : 60111, $267a8c513e879743$var$m = $267a8c513e879743$var$b ? Symbol.for("react.concurrent_mode") : 60111, $267a8c513e879743$var$n = $267a8c513e879743$var$b ? Symbol.for("react.forward_ref") : 60112, $267a8c513e879743$var$p = $267a8c513e879743$var$b ? Symbol.for("react.suspense") : 60113, $267a8c513e879743$var$q = $267a8c513e879743$var$b ? Symbol.for("react.suspense_list") : 60120, $267a8c513e879743$var$r = $267a8c513e879743$var$b ? Symbol.for("react.memo") : 60115, $267a8c513e879743$var$t = $267a8c513e879743$var$b ? Symbol.for("react.lazy") : 60116, $267a8c513e879743$var$v = $267a8c513e879743$var$b ? Symbol.for("react.block") : 60121, $267a8c513e879743$var$w = $267a8c513e879743$var$b ? Symbol.for("react.fundamental") : 60117, $267a8c513e879743$var$x = $267a8c513e879743$var$b ? Symbol.for("react.responder") : 60118, $267a8c513e879743$var$y = $267a8c513e879743$var$b ? Symbol.for("react.scope") : 60119;
function $267a8c513e879743$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $267a8c513e879743$var$c:
                switch(a = a.type, a){
                    case $267a8c513e879743$var$l:
                    case $267a8c513e879743$var$m:
                    case $267a8c513e879743$var$e:
                    case $267a8c513e879743$var$g:
                    case $267a8c513e879743$var$f:
                    case $267a8c513e879743$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $267a8c513e879743$var$k:
                            case $267a8c513e879743$var$n:
                            case $267a8c513e879743$var$t:
                            case $267a8c513e879743$var$r:
                            case $267a8c513e879743$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $267a8c513e879743$var$d:
                return u;
        }
    }
}
function $267a8c513e879743$var$A(a) {
    return $267a8c513e879743$var$z(a) === $267a8c513e879743$var$m;
}
$267a8c513e879743$export$2b8d127b894957b9 = $267a8c513e879743$var$l;
$267a8c513e879743$export$cea3a54a6425200c = $267a8c513e879743$var$m;
$267a8c513e879743$export$a7c73072b1a182ae = $267a8c513e879743$var$k;
$267a8c513e879743$export$9f27bc3417b4524d = $267a8c513e879743$var$h;
$267a8c513e879743$export$db77ccec0bb4ccac = $267a8c513e879743$var$c;
$267a8c513e879743$export$8392c0c9d3dcbd35 = $267a8c513e879743$var$n;
$267a8c513e879743$export$ffb0004e005737fa = $267a8c513e879743$var$e;
$267a8c513e879743$export$b624eff549462981 = $267a8c513e879743$var$t;
$267a8c513e879743$export$7897aa7841a5380c = $267a8c513e879743$var$r;
$267a8c513e879743$export$602eac185826482c = $267a8c513e879743$var$d;
$267a8c513e879743$export$e2c29f18771995cb = $267a8c513e879743$var$g;
$267a8c513e879743$export$5f8d39834fd61797 = $267a8c513e879743$var$f;
$267a8c513e879743$export$74bf444e3cd11ea5 = $267a8c513e879743$var$p;
$267a8c513e879743$export$92387174baf9b227 = function(a) {
    return $267a8c513e879743$var$A(a) || $267a8c513e879743$var$z(a) === $267a8c513e879743$var$l;
};
$267a8c513e879743$export$ec112efeb987d9c6 = $267a8c513e879743$var$A;
$267a8c513e879743$export$b706b080d889d2c9 = function(a) {
    return $267a8c513e879743$var$z(a) === $267a8c513e879743$var$k;
};
$267a8c513e879743$export$5be5a87408f70ddc = function(a) {
    return $267a8c513e879743$var$z(a) === $267a8c513e879743$var$h;
};
$267a8c513e879743$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $267a8c513e879743$var$c;
};
$267a8c513e879743$export$455c2e768291efa6 = function(a) {
    return $267a8c513e879743$var$z(a) === $267a8c513e879743$var$n;
};
$267a8c513e879743$export$9522e17588c12572 = function(a) {
    return $267a8c513e879743$var$z(a) === $267a8c513e879743$var$e;
};
$267a8c513e879743$export$2110ac352bb060b9 = function(a) {
    return $267a8c513e879743$var$z(a) === $267a8c513e879743$var$t;
};
$267a8c513e879743$export$56885ab8b9c456ab = function(a) {
    return $267a8c513e879743$var$z(a) === $267a8c513e879743$var$r;
};
$267a8c513e879743$export$d927fcb6adf8f9de = function(a) {
    return $267a8c513e879743$var$z(a) === $267a8c513e879743$var$d;
};
$267a8c513e879743$export$b82d16f27459e05a = function(a) {
    return $267a8c513e879743$var$z(a) === $267a8c513e879743$var$g;
};
$267a8c513e879743$export$522c17b4f5e123e8 = function(a) {
    return $267a8c513e879743$var$z(a) === $267a8c513e879743$var$f;
};
$267a8c513e879743$export$1aabd8a0274ecfd6 = function(a) {
    return $267a8c513e879743$var$z(a) === $267a8c513e879743$var$p;
};
$267a8c513e879743$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $267a8c513e879743$var$e || a === $267a8c513e879743$var$m || a === $267a8c513e879743$var$g || a === $267a8c513e879743$var$f || a === $267a8c513e879743$var$p || a === $267a8c513e879743$var$q || "object" === typeof a && null !== a && (a.$$typeof === $267a8c513e879743$var$t || a.$$typeof === $267a8c513e879743$var$r || a.$$typeof === $267a8c513e879743$var$h || a.$$typeof === $267a8c513e879743$var$k || a.$$typeof === $267a8c513e879743$var$n || a.$$typeof === $267a8c513e879743$var$w || a.$$typeof === $267a8c513e879743$var$x || a.$$typeof === $267a8c513e879743$var$y || a.$$typeof === $267a8c513e879743$var$v);
};
$267a8c513e879743$export$f5bbd400c2f4426f = $267a8c513e879743$var$z;

});

parcelRegister("e0Twa", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $a33c2177723f8ce7$export$2b8d127b894957b9; }, function (v) { return $a33c2177723f8ce7$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $a33c2177723f8ce7$export$cea3a54a6425200c; }, function (v) { return $a33c2177723f8ce7$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $a33c2177723f8ce7$export$a7c73072b1a182ae; }, function (v) { return $a33c2177723f8ce7$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $a33c2177723f8ce7$export$9f27bc3417b4524d; }, function (v) { return $a33c2177723f8ce7$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $a33c2177723f8ce7$export$db77ccec0bb4ccac; }, function (v) { return $a33c2177723f8ce7$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $a33c2177723f8ce7$export$8392c0c9d3dcbd35; }, function (v) { return $a33c2177723f8ce7$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $a33c2177723f8ce7$export$ffb0004e005737fa; }, function (v) { return $a33c2177723f8ce7$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $a33c2177723f8ce7$export$b624eff549462981; }, function (v) { return $a33c2177723f8ce7$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $a33c2177723f8ce7$export$7897aa7841a5380c; }, function (v) { return $a33c2177723f8ce7$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $a33c2177723f8ce7$export$602eac185826482c; }, function (v) { return $a33c2177723f8ce7$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $a33c2177723f8ce7$export$e2c29f18771995cb; }, function (v) { return $a33c2177723f8ce7$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $a33c2177723f8ce7$export$5f8d39834fd61797; }, function (v) { return $a33c2177723f8ce7$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $a33c2177723f8ce7$export$74bf444e3cd11ea5; }, function (v) { return $a33c2177723f8ce7$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $a33c2177723f8ce7$export$92387174baf9b227; }, function (v) { return $a33c2177723f8ce7$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $a33c2177723f8ce7$export$ec112efeb987d9c6; }, function (v) { return $a33c2177723f8ce7$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $a33c2177723f8ce7$export$b706b080d889d2c9; }, function (v) { return $a33c2177723f8ce7$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $a33c2177723f8ce7$export$5be5a87408f70ddc; }, function (v) { return $a33c2177723f8ce7$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $a33c2177723f8ce7$export$45a5e7f76e0caa8d; }, function (v) { return $a33c2177723f8ce7$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $a33c2177723f8ce7$export$455c2e768291efa6; }, function (v) { return $a33c2177723f8ce7$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $a33c2177723f8ce7$export$9522e17588c12572; }, function (v) { return $a33c2177723f8ce7$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $a33c2177723f8ce7$export$2110ac352bb060b9; }, function (v) { return $a33c2177723f8ce7$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $a33c2177723f8ce7$export$56885ab8b9c456ab; }, function (v) { return $a33c2177723f8ce7$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $a33c2177723f8ce7$export$d927fcb6adf8f9de; }, function (v) { return $a33c2177723f8ce7$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $a33c2177723f8ce7$export$b82d16f27459e05a; }, function (v) { return $a33c2177723f8ce7$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $a33c2177723f8ce7$export$522c17b4f5e123e8; }, function (v) { return $a33c2177723f8ce7$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $a33c2177723f8ce7$export$1aabd8a0274ecfd6; }, function (v) { return $a33c2177723f8ce7$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $a33c2177723f8ce7$export$9b621391a187a31a; }, function (v) { return $a33c2177723f8ce7$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $a33c2177723f8ce7$export$f5bbd400c2f4426f; }, function (v) { return $a33c2177723f8ce7$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a33c2177723f8ce7$export$2b8d127b894957b9;
var $a33c2177723f8ce7$export$cea3a54a6425200c;
var $a33c2177723f8ce7$export$a7c73072b1a182ae;
var $a33c2177723f8ce7$export$9f27bc3417b4524d;
var $a33c2177723f8ce7$export$db77ccec0bb4ccac;
var $a33c2177723f8ce7$export$8392c0c9d3dcbd35;
var $a33c2177723f8ce7$export$ffb0004e005737fa;
var $a33c2177723f8ce7$export$b624eff549462981;
var $a33c2177723f8ce7$export$7897aa7841a5380c;
var $a33c2177723f8ce7$export$602eac185826482c;
var $a33c2177723f8ce7$export$e2c29f18771995cb;
var $a33c2177723f8ce7$export$5f8d39834fd61797;
var $a33c2177723f8ce7$export$74bf444e3cd11ea5;
var $a33c2177723f8ce7$export$92387174baf9b227;
var $a33c2177723f8ce7$export$ec112efeb987d9c6;
var $a33c2177723f8ce7$export$b706b080d889d2c9;
var $a33c2177723f8ce7$export$5be5a87408f70ddc;
var $a33c2177723f8ce7$export$45a5e7f76e0caa8d;
var $a33c2177723f8ce7$export$455c2e768291efa6;
var $a33c2177723f8ce7$export$9522e17588c12572;
var $a33c2177723f8ce7$export$2110ac352bb060b9;
var $a33c2177723f8ce7$export$56885ab8b9c456ab;
var $a33c2177723f8ce7$export$d927fcb6adf8f9de;
var $a33c2177723f8ce7$export$b82d16f27459e05a;
var $a33c2177723f8ce7$export$522c17b4f5e123e8;
var $a33c2177723f8ce7$export$1aabd8a0274ecfd6;
var $a33c2177723f8ce7$export$9b621391a187a31a;
var $a33c2177723f8ce7$export$f5bbd400c2f4426f;
'use strict';
var $a33c2177723f8ce7$var$b = "function" === typeof Symbol && Symbol.for, $a33c2177723f8ce7$var$c = $a33c2177723f8ce7$var$b ? Symbol.for("react.element") : 60103, $a33c2177723f8ce7$var$d = $a33c2177723f8ce7$var$b ? Symbol.for("react.portal") : 60106, $a33c2177723f8ce7$var$e = $a33c2177723f8ce7$var$b ? Symbol.for("react.fragment") : 60107, $a33c2177723f8ce7$var$f = $a33c2177723f8ce7$var$b ? Symbol.for("react.strict_mode") : 60108, $a33c2177723f8ce7$var$g = $a33c2177723f8ce7$var$b ? Symbol.for("react.profiler") : 60114, $a33c2177723f8ce7$var$h = $a33c2177723f8ce7$var$b ? Symbol.for("react.provider") : 60109, $a33c2177723f8ce7$var$k = $a33c2177723f8ce7$var$b ? Symbol.for("react.context") : 60110, $a33c2177723f8ce7$var$l = $a33c2177723f8ce7$var$b ? Symbol.for("react.async_mode") : 60111, $a33c2177723f8ce7$var$m = $a33c2177723f8ce7$var$b ? Symbol.for("react.concurrent_mode") : 60111, $a33c2177723f8ce7$var$n = $a33c2177723f8ce7$var$b ? Symbol.for("react.forward_ref") : 60112, $a33c2177723f8ce7$var$p = $a33c2177723f8ce7$var$b ? Symbol.for("react.suspense") : 60113, $a33c2177723f8ce7$var$q = $a33c2177723f8ce7$var$b ? Symbol.for("react.suspense_list") : 60120, $a33c2177723f8ce7$var$r = $a33c2177723f8ce7$var$b ? Symbol.for("react.memo") : 60115, $a33c2177723f8ce7$var$t = $a33c2177723f8ce7$var$b ? Symbol.for("react.lazy") : 60116, $a33c2177723f8ce7$var$v = $a33c2177723f8ce7$var$b ? Symbol.for("react.block") : 60121, $a33c2177723f8ce7$var$w = $a33c2177723f8ce7$var$b ? Symbol.for("react.fundamental") : 60117, $a33c2177723f8ce7$var$x = $a33c2177723f8ce7$var$b ? Symbol.for("react.responder") : 60118, $a33c2177723f8ce7$var$y = $a33c2177723f8ce7$var$b ? Symbol.for("react.scope") : 60119;
function $a33c2177723f8ce7$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $a33c2177723f8ce7$var$c:
                switch(a = a.type, a){
                    case $a33c2177723f8ce7$var$l:
                    case $a33c2177723f8ce7$var$m:
                    case $a33c2177723f8ce7$var$e:
                    case $a33c2177723f8ce7$var$g:
                    case $a33c2177723f8ce7$var$f:
                    case $a33c2177723f8ce7$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $a33c2177723f8ce7$var$k:
                            case $a33c2177723f8ce7$var$n:
                            case $a33c2177723f8ce7$var$t:
                            case $a33c2177723f8ce7$var$r:
                            case $a33c2177723f8ce7$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $a33c2177723f8ce7$var$d:
                return u;
        }
    }
}
function $a33c2177723f8ce7$var$A(a) {
    return $a33c2177723f8ce7$var$z(a) === $a33c2177723f8ce7$var$m;
}
$a33c2177723f8ce7$export$2b8d127b894957b9 = $a33c2177723f8ce7$var$l;
$a33c2177723f8ce7$export$cea3a54a6425200c = $a33c2177723f8ce7$var$m;
$a33c2177723f8ce7$export$a7c73072b1a182ae = $a33c2177723f8ce7$var$k;
$a33c2177723f8ce7$export$9f27bc3417b4524d = $a33c2177723f8ce7$var$h;
$a33c2177723f8ce7$export$db77ccec0bb4ccac = $a33c2177723f8ce7$var$c;
$a33c2177723f8ce7$export$8392c0c9d3dcbd35 = $a33c2177723f8ce7$var$n;
$a33c2177723f8ce7$export$ffb0004e005737fa = $a33c2177723f8ce7$var$e;
$a33c2177723f8ce7$export$b624eff549462981 = $a33c2177723f8ce7$var$t;
$a33c2177723f8ce7$export$7897aa7841a5380c = $a33c2177723f8ce7$var$r;
$a33c2177723f8ce7$export$602eac185826482c = $a33c2177723f8ce7$var$d;
$a33c2177723f8ce7$export$e2c29f18771995cb = $a33c2177723f8ce7$var$g;
$a33c2177723f8ce7$export$5f8d39834fd61797 = $a33c2177723f8ce7$var$f;
$a33c2177723f8ce7$export$74bf444e3cd11ea5 = $a33c2177723f8ce7$var$p;
$a33c2177723f8ce7$export$92387174baf9b227 = function(a) {
    return $a33c2177723f8ce7$var$A(a) || $a33c2177723f8ce7$var$z(a) === $a33c2177723f8ce7$var$l;
};
$a33c2177723f8ce7$export$ec112efeb987d9c6 = $a33c2177723f8ce7$var$A;
$a33c2177723f8ce7$export$b706b080d889d2c9 = function(a) {
    return $a33c2177723f8ce7$var$z(a) === $a33c2177723f8ce7$var$k;
};
$a33c2177723f8ce7$export$5be5a87408f70ddc = function(a) {
    return $a33c2177723f8ce7$var$z(a) === $a33c2177723f8ce7$var$h;
};
$a33c2177723f8ce7$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a33c2177723f8ce7$var$c;
};
$a33c2177723f8ce7$export$455c2e768291efa6 = function(a) {
    return $a33c2177723f8ce7$var$z(a) === $a33c2177723f8ce7$var$n;
};
$a33c2177723f8ce7$export$9522e17588c12572 = function(a) {
    return $a33c2177723f8ce7$var$z(a) === $a33c2177723f8ce7$var$e;
};
$a33c2177723f8ce7$export$2110ac352bb060b9 = function(a) {
    return $a33c2177723f8ce7$var$z(a) === $a33c2177723f8ce7$var$t;
};
$a33c2177723f8ce7$export$56885ab8b9c456ab = function(a) {
    return $a33c2177723f8ce7$var$z(a) === $a33c2177723f8ce7$var$r;
};
$a33c2177723f8ce7$export$d927fcb6adf8f9de = function(a) {
    return $a33c2177723f8ce7$var$z(a) === $a33c2177723f8ce7$var$d;
};
$a33c2177723f8ce7$export$b82d16f27459e05a = function(a) {
    return $a33c2177723f8ce7$var$z(a) === $a33c2177723f8ce7$var$g;
};
$a33c2177723f8ce7$export$522c17b4f5e123e8 = function(a) {
    return $a33c2177723f8ce7$var$z(a) === $a33c2177723f8ce7$var$f;
};
$a33c2177723f8ce7$export$1aabd8a0274ecfd6 = function(a) {
    return $a33c2177723f8ce7$var$z(a) === $a33c2177723f8ce7$var$p;
};
$a33c2177723f8ce7$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $a33c2177723f8ce7$var$e || a === $a33c2177723f8ce7$var$m || a === $a33c2177723f8ce7$var$g || a === $a33c2177723f8ce7$var$f || a === $a33c2177723f8ce7$var$p || a === $a33c2177723f8ce7$var$q || "object" === typeof a && null !== a && (a.$$typeof === $a33c2177723f8ce7$var$t || a.$$typeof === $a33c2177723f8ce7$var$r || a.$$typeof === $a33c2177723f8ce7$var$h || a.$$typeof === $a33c2177723f8ce7$var$k || a.$$typeof === $a33c2177723f8ce7$var$n || a.$$typeof === $a33c2177723f8ce7$var$w || a.$$typeof === $a33c2177723f8ce7$var$x || a.$$typeof === $a33c2177723f8ce7$var$y || a.$$typeof === $a33c2177723f8ce7$var$v);
};
$a33c2177723f8ce7$export$f5bbd400c2f4426f = $a33c2177723f8ce7$var$z;

});

parcelRegister("g1Jo8", function(module, exports) {
(function() {
    var base64map = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/', crypt = {
        // Bit-wise rotation left
        rotl: function(n, b) {
            return n << b | n >>> 32 - b;
        },
        // Bit-wise rotation right
        rotr: function(n, b) {
            return n << 32 - b | n >>> b;
        },
        // Swap big-endian to little-endian and vice versa
        endian: function(n) {
            // If number given, swap endian
            if (n.constructor == Number) return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
            // Else, assume array and swap all items
            for(var i = 0; i < n.length; i++)n[i] = crypt.endian(n[i]);
            return n;
        },
        // Generate an array of any length of random bytes
        randomBytes: function(n) {
            for(var bytes = []; n > 0; n--)bytes.push(Math.floor(Math.random() * 256));
            return bytes;
        },
        // Convert a byte array to big-endian 32-bit words
        bytesToWords: function(bytes) {
            for(var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)words[b >>> 5] |= bytes[i] << 24 - b % 32;
            return words;
        },
        // Convert big-endian 32-bit words to a byte array
        wordsToBytes: function(words) {
            for(var bytes = [], b = 0; b < words.length * 32; b += 8)bytes.push(words[b >>> 5] >>> 24 - b % 32 & 0xFF);
            return bytes;
        },
        // Convert a byte array to a hex string
        bytesToHex: function(bytes) {
            for(var hex = [], i = 0; i < bytes.length; i++){
                hex.push((bytes[i] >>> 4).toString(16));
                hex.push((bytes[i] & 0xF).toString(16));
            }
            return hex.join('');
        },
        // Convert a hex string to a byte array
        hexToBytes: function(hex) {
            for(var bytes = [], c = 0; c < hex.length; c += 2)bytes.push(parseInt(hex.substr(c, 2), 16));
            return bytes;
        },
        // Convert a byte array to a base-64 string
        bytesToBase64: function(bytes) {
            for(var base64 = [], i = 0; i < bytes.length; i += 3){
                var triplet = bytes[i] << 16 | bytes[i + 1] << 8 | bytes[i + 2];
                for(var j = 0; j < 4; j++)if (i * 8 + j * 6 <= bytes.length * 8) base64.push(base64map.charAt(triplet >>> 6 * (3 - j) & 0x3F));
                else base64.push('=');
            }
            return base64.join('');
        },
        // Convert a base-64 string to a byte array
        base64ToBytes: function(base64) {
            // Remove non-base-64 characters
            base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');
            for(var bytes = [], i = 0, imod4 = 0; i < base64.length; imod4 = ++i % 4){
                if (imod4 == 0) continue;
                bytes.push((base64map.indexOf(base64.charAt(i - 1)) & Math.pow(2, -2 * imod4 + 8) - 1) << imod4 * 2 | base64map.indexOf(base64.charAt(i)) >>> 6 - imod4 * 2);
            }
            return bytes;
        }
    };
    module.exports = crypt;
})();

});

parcelRegister("kIiXo", function(module, exports) {
var $f1469f24eae00d85$var$charenc = {
    // UTF-8 encoding
    utf8: {
        // Convert a string to a byte array
        stringToBytes: function(str) {
            return $f1469f24eae00d85$var$charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
        },
        // Convert a byte array to a string
        bytesToString: function(bytes) {
            return decodeURIComponent(escape($f1469f24eae00d85$var$charenc.bin.bytesToString(bytes)));
        }
    },
    // Binary encoding
    bin: {
        // Convert a string to a byte array
        stringToBytes: function(str) {
            for(var bytes = [], i = 0; i < str.length; i++)bytes.push(str.charCodeAt(i) & 0xFF);
            return bytes;
        },
        // Convert a byte array to a string
        bytesToString: function(bytes) {
            for(var str = [], i = 0; i < bytes.length; i++)str.push(String.fromCharCode(bytes[i]));
            return str.join('');
        }
    }
};
module.exports = $f1469f24eae00d85$var$charenc;

});

parcelRegister("166vg", function(module, exports) {
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ // The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function(obj) {
    return obj != null && ($0ccb65640bad2cdb$var$isBuffer(obj) || $0ccb65640bad2cdb$var$isSlowBuffer(obj) || !!obj._isBuffer);
};
function $0ccb65640bad2cdb$var$isBuffer(obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
}
// For Node v0.10 support. Remove this eventually.
function $0ccb65640bad2cdb$var$isSlowBuffer(obj) {
    return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && $0ccb65640bad2cdb$var$isBuffer(obj.slice(0, 0));
}

});

parcelRegister("5K180", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $3zA27 = parcelRequire("3zA27");
function $42e21fa19b7d3d5f$var$emptyFunction() {}
function $42e21fa19b7d3d5f$var$emptyFunctionWithReset() {}
$42e21fa19b7d3d5f$var$emptyFunctionWithReset.resetWarningCache = $42e21fa19b7d3d5f$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $3zA27) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $42e21fa19b7d3d5f$var$emptyFunctionWithReset,
        resetWarningCache: $42e21fa19b7d3d5f$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("3zA27", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $29a09769181933c9$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $29a09769181933c9$var$ReactPropTypesSecret;

});


parcelRegister("iBItf", function(module, exports) {
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */ 
exports = module.exports = (parcelRequire("A5MjY"));
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();
/**
 * Colors.
 */ exports.colors = [
    'lightseagreen',
    'forestgreen',
    'goldenrod',
    'dodgerblue',
    'darkorchid',
    'crimson'
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') return true;
    // is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ exports.formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (err) {
        return '[UnexpectedJSONParseError]: ' + err.message;
    }
};
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    var useColors = this.useColors;
    args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);
    if (!useColors) return;
    var c = 'color: ' + this.color;
    args.splice(1, 0, c, 'color: inherit');
    // the final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    var index = 0;
    var lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, function(match) {
        if ('%%' === match) return;
        index++;
        if ('%c' === match) // we only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */ function log() {
    // this hackery is required for IE8/9, where
    // the `console.log` function doesn't have 'apply'
    return 'object' === typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
}
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (null == namespaces) exports.storage.removeItem('debug');
        else exports.storage.debug = namespaces;
    } catch (e) {}
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    var r;
    try {
        r = exports.storage.debug;
    } catch (e) {}
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    r;
    return r;
}
/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */ exports.enable(load());
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        return window.localStorage;
    } catch (e) {}
}

});
parcelRegister("A5MjY", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */ exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;

exports.humanize = (parcelRequire("hiUSq"));
/**
 * The currently active debug mode names, and names to skip.
 */ exports.names = [];
exports.skips = [];
/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */ exports.formatters = {};
/**
 * Previous log timestamp.
 */ var prevTime;
/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */ function selectColor(namespace) {
    var hash = 0, i;
    for(i in namespace){
        hash = (hash << 5) - hash + namespace.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
    }
    return exports.colors[Math.abs(hash) % exports.colors.length];
}
/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */ function createDebug(namespace) {
    function debug() {
        // disabled?
        if (!debug.enabled) return;
        var self = debug;
        // set `diff` timestamp
        var curr = +new Date();
        var ms = curr - (prevTime || curr);
        self.diff = ms;
        self.prev = prevTime;
        self.curr = curr;
        prevTime = curr;
        // turn the `arguments` into a proper Array
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        args[0] = exports.coerce(args[0]);
        if ('string' !== typeof args[0]) // anything else let's inspect with %O
        args.unshift('%O');
        // apply any `formatters` transformations
        var index = 0;
        args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
            // if we encounter an escaped % then don't increase the array index
            if (match === '%%') return match;
            index++;
            var formatter = exports.formatters[format];
            if ('function' === typeof formatter) {
                var val = args[index];
                match = formatter.call(self, val);
                // now we need to remove `args[index]` since it's inlined in the `format`
                args.splice(index, 1);
                index--;
            }
            return match;
        });
        // apply env-specific formatting (colors, etc.)
        exports.formatArgs.call(self, args);
        var logFn = debug.log || exports.log || console.log.bind(console);
        logFn.apply(self, args);
    }
    debug.namespace = namespace;
    debug.enabled = exports.enabled(namespace);
    debug.useColors = exports.useColors();
    debug.color = selectColor(namespace);
    // env-specific initialization logic for debug instances
    if ('function' === typeof exports.init) exports.init(debug);
    return debug;
}
/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */ function enable(namespaces) {
    exports.save(namespaces);
    exports.names = [];
    exports.skips = [];
    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;
    for(var i = 0; i < len; i++){
        if (!split[i]) continue; // ignore empty strings
        namespaces = split[i].replace(/\*/g, '.*?');
        if (namespaces[0] === '-') exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
        else exports.names.push(new RegExp('^' + namespaces + '$'));
    }
}
/**
 * Disable debug output.
 *
 * @api public
 */ function disable() {
    exports.enable('');
}
/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */ function enabled(name) {
    var i, len;
    for(i = 0, len = exports.skips.length; i < len; i++){
        if (exports.skips[i].test(name)) return false;
    }
    for(i = 0, len = exports.names.length; i < len; i++){
        if (exports.names[i].test(name)) return true;
    }
    return false;
}
/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */ function coerce(val) {
    if (val instanceof Error) return val.stack || val.message;
    return val;
}

});
parcelRegister("hiUSq", function(module, exports) {
/**
 * Helpers.
 */ var $c9903ca632719f92$var$s = 1000;
var $c9903ca632719f92$var$m = $c9903ca632719f92$var$s * 60;
var $c9903ca632719f92$var$h = $c9903ca632719f92$var$m * 60;
var $c9903ca632719f92$var$d = $c9903ca632719f92$var$h * 24;
var $c9903ca632719f92$var$y = $c9903ca632719f92$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === 'string' && val.length > 0) return $c9903ca632719f92$var$parse(val);
    else if (type === 'number' && isNaN(val) === false) return options.long ? $c9903ca632719f92$var$fmtLong(val) : $c9903ca632719f92$var$fmtShort(val);
    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $c9903ca632719f92$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch(type){
        case 'years':
        case 'year':
        case 'yrs':
        case 'yr':
        case 'y':
            return n * $c9903ca632719f92$var$y;
        case 'days':
        case 'day':
        case 'd':
            return n * $c9903ca632719f92$var$d;
        case 'hours':
        case 'hour':
        case 'hrs':
        case 'hr':
        case 'h':
            return n * $c9903ca632719f92$var$h;
        case 'minutes':
        case 'minute':
        case 'mins':
        case 'min':
        case 'm':
            return n * $c9903ca632719f92$var$m;
        case 'seconds':
        case 'second':
        case 'secs':
        case 'sec':
        case 's':
            return n * $c9903ca632719f92$var$s;
        case 'milliseconds':
        case 'millisecond':
        case 'msecs':
        case 'msec':
        case 'ms':
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $c9903ca632719f92$var$fmtShort(ms) {
    if (ms >= $c9903ca632719f92$var$d) return Math.round(ms / $c9903ca632719f92$var$d) + 'd';
    if (ms >= $c9903ca632719f92$var$h) return Math.round(ms / $c9903ca632719f92$var$h) + 'h';
    if (ms >= $c9903ca632719f92$var$m) return Math.round(ms / $c9903ca632719f92$var$m) + 'm';
    if (ms >= $c9903ca632719f92$var$s) return Math.round(ms / $c9903ca632719f92$var$s) + 's';
    return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $c9903ca632719f92$var$fmtLong(ms) {
    return $c9903ca632719f92$var$plural(ms, $c9903ca632719f92$var$d, 'day') || $c9903ca632719f92$var$plural(ms, $c9903ca632719f92$var$h, 'hour') || $c9903ca632719f92$var$plural(ms, $c9903ca632719f92$var$m, 'minute') || $c9903ca632719f92$var$plural(ms, $c9903ca632719f92$var$s, 'second') || ms + ' ms';
}
/**
 * Pluralization helper.
 */ function $c9903ca632719f92$var$plural(ms, n, name) {
    if (ms < n) return;
    if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
    return Math.ceil(ms / n) + ' ' + name + 's';
}

});



parcelRegister("3UKyI", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $lsQhA = parcelRequire("lsQhA");
var $2d9ab7b7b26b653d$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $2d9ab7b7b26b653d$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$2d9ab7b7b26b653d$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($2d9ab7b7b26b653d$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($2d9ab7b7b26b653d$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($2d9ab7b7b26b653d$var$isNull(x) || !$2d9ab7b7b26b653d$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $2d9ab7b7b26b653d$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    var warned;
    return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    function deprecated() {
        if (!warned) {
            if ($lsQhA.throwDeprecation) throw new Error(msg);
            else if ($lsQhA.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
};
var $2d9ab7b7b26b653d$var$debugs = {};
var $2d9ab7b7b26b653d$var$debugEnvRegex = /^$/;
var $2d9ab7b7b26b653d$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$2d9ab7b7b26b653d$var$debugs[set]) {
        if ($2d9ab7b7b26b653d$var$debugEnvRegex.test(set)) {
            var pid = $lsQhA.pid;
            $2d9ab7b7b26b653d$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $2d9ab7b7b26b653d$var$debugs[set] = function() {};
    }
    return $2d9ab7b7b26b653d$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $2d9ab7b7b26b653d$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $2d9ab7b7b26b653d$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($2d9ab7b7b26b653d$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($2d9ab7b7b26b653d$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($2d9ab7b7b26b653d$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($2d9ab7b7b26b653d$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($2d9ab7b7b26b653d$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $2d9ab7b7b26b653d$var$stylizeWithColor;
    return $2d9ab7b7b26b653d$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $2d9ab7b7b26b653d$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$2d9ab7b7b26b653d$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$2d9ab7b7b26b653d$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $2d9ab7b7b26b653d$var$stylizeWithColor(str, styleType) {
    var style = $2d9ab7b7b26b653d$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $2d9ab7b7b26b653d$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $2d9ab7b7b26b653d$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $2d9ab7b7b26b653d$var$stylizeNoColor(str, styleType) {
    return str;
}
function $2d9ab7b7b26b653d$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $2d9ab7b7b26b653d$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $2d9ab7b7b26b653d$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$2d9ab7b7b26b653d$var$isString(ret)) ret = $2d9ab7b7b26b653d$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $2d9ab7b7b26b653d$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $2d9ab7b7b26b653d$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($2d9ab7b7b26b653d$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $2d9ab7b7b26b653d$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($2d9ab7b7b26b653d$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($2d9ab7b7b26b653d$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($2d9ab7b7b26b653d$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($2d9ab7b7b26b653d$var$isError(value)) return $2d9ab7b7b26b653d$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($2d9ab7b7b26b653d$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($2d9ab7b7b26b653d$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($2d9ab7b7b26b653d$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($2d9ab7b7b26b653d$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($2d9ab7b7b26b653d$var$isError(value)) base = ' ' + $2d9ab7b7b26b653d$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($2d9ab7b7b26b653d$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $2d9ab7b7b26b653d$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $2d9ab7b7b26b653d$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $2d9ab7b7b26b653d$var$reduceToSingleString(output, base, braces);
}
function $2d9ab7b7b26b653d$var$formatPrimitive(ctx, value) {
    if ($2d9ab7b7b26b653d$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($2d9ab7b7b26b653d$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($2d9ab7b7b26b653d$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($2d9ab7b7b26b653d$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($2d9ab7b7b26b653d$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $2d9ab7b7b26b653d$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $2d9ab7b7b26b653d$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($2d9ab7b7b26b653d$var$hasOwnProperty(value, String(i))) output.push($2d9ab7b7b26b653d$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($2d9ab7b7b26b653d$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $2d9ab7b7b26b653d$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$2d9ab7b7b26b653d$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($2d9ab7b7b26b653d$var$isNull(recurseTimes)) str = $2d9ab7b7b26b653d$var$formatValue(ctx, desc.value, null);
            else str = $2d9ab7b7b26b653d$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($2d9ab7b7b26b653d$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $2d9ab7b7b26b653d$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("yNoK7"));
function $2d9ab7b7b26b653d$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $2d9ab7b7b26b653d$var$isArray;
function $2d9ab7b7b26b653d$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $2d9ab7b7b26b653d$var$isBoolean;
function $2d9ab7b7b26b653d$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $2d9ab7b7b26b653d$var$isNull;
function $2d9ab7b7b26b653d$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $2d9ab7b7b26b653d$var$isNullOrUndefined;
function $2d9ab7b7b26b653d$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $2d9ab7b7b26b653d$var$isNumber;
function $2d9ab7b7b26b653d$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $2d9ab7b7b26b653d$var$isString;
function $2d9ab7b7b26b653d$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $2d9ab7b7b26b653d$var$isSymbol;
function $2d9ab7b7b26b653d$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $2d9ab7b7b26b653d$var$isUndefined;
function $2d9ab7b7b26b653d$var$isRegExp(re) {
    return $2d9ab7b7b26b653d$var$isObject(re) && $2d9ab7b7b26b653d$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $2d9ab7b7b26b653d$var$isRegExp;
module.exports.types.isRegExp = $2d9ab7b7b26b653d$var$isRegExp;
function $2d9ab7b7b26b653d$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $2d9ab7b7b26b653d$var$isObject;
function $2d9ab7b7b26b653d$var$isDate(d) {
    return $2d9ab7b7b26b653d$var$isObject(d) && $2d9ab7b7b26b653d$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $2d9ab7b7b26b653d$var$isDate;
module.exports.types.isDate = $2d9ab7b7b26b653d$var$isDate;
function $2d9ab7b7b26b653d$var$isError(e) {
    return $2d9ab7b7b26b653d$var$isObject(e) && ($2d9ab7b7b26b653d$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $2d9ab7b7b26b653d$var$isError;
module.exports.types.isNativeError = $2d9ab7b7b26b653d$var$isError;
function $2d9ab7b7b26b653d$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $2d9ab7b7b26b653d$var$isFunction;
function $2d9ab7b7b26b653d$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $2d9ab7b7b26b653d$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("l1G5g"));
function $2d9ab7b7b26b653d$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $2d9ab7b7b26b653d$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $2d9ab7b7b26b653d$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $2d9ab7b7b26b653d$var$timestamp() {
    var d = new Date();
    var time = [
        $2d9ab7b7b26b653d$var$pad(d.getHours()),
        $2d9ab7b7b26b653d$var$pad(d.getMinutes()),
        $2d9ab7b7b26b653d$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $2d9ab7b7b26b653d$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $2d9ab7b7b26b653d$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("hrcGl"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$2d9ab7b7b26b653d$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $2d9ab7b7b26b653d$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $2d9ab7b7b26b653d$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($2d9ab7b7b26b653d$var$kCustomPromisifiedSymbol && original[$2d9ab7b7b26b653d$var$kCustomPromisifiedSymbol]) {
        var fn = original[$2d9ab7b7b26b653d$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $2d9ab7b7b26b653d$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($2d9ab7b7b26b653d$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $2d9ab7b7b26b653d$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $2d9ab7b7b26b653d$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $2d9ab7b7b26b653d$var$kCustomPromisifiedSymbol;
function $2d9ab7b7b26b653d$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $2d9ab7b7b26b653d$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $lsQhA.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $lsQhA.nextTick($2d9ab7b7b26b653d$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $2d9ab7b7b26b653d$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $2d9ab7b7b26b653d$var$callbackify;

});
parcelRegister("lsQhA", function(module, exports) {
// shim for using process in browser
var $fa04c4c140cfd1fe$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $fa04c4c140cfd1fe$var$cachedSetTimeout;
var $fa04c4c140cfd1fe$var$cachedClearTimeout;
function $fa04c4c140cfd1fe$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $fa04c4c140cfd1fe$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $fa04c4c140cfd1fe$var$cachedSetTimeout = setTimeout;
        else $fa04c4c140cfd1fe$var$cachedSetTimeout = $fa04c4c140cfd1fe$var$defaultSetTimout;
    } catch (e) {
        $fa04c4c140cfd1fe$var$cachedSetTimeout = $fa04c4c140cfd1fe$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $fa04c4c140cfd1fe$var$cachedClearTimeout = clearTimeout;
        else $fa04c4c140cfd1fe$var$cachedClearTimeout = $fa04c4c140cfd1fe$var$defaultClearTimeout;
    } catch (e) {
        $fa04c4c140cfd1fe$var$cachedClearTimeout = $fa04c4c140cfd1fe$var$defaultClearTimeout;
    }
})();
function $fa04c4c140cfd1fe$var$runTimeout(fun) {
    if ($fa04c4c140cfd1fe$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($fa04c4c140cfd1fe$var$cachedSetTimeout === $fa04c4c140cfd1fe$var$defaultSetTimout || !$fa04c4c140cfd1fe$var$cachedSetTimeout) && setTimeout) {
        $fa04c4c140cfd1fe$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $fa04c4c140cfd1fe$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $fa04c4c140cfd1fe$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $fa04c4c140cfd1fe$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $fa04c4c140cfd1fe$var$runClearTimeout(marker) {
    if ($fa04c4c140cfd1fe$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($fa04c4c140cfd1fe$var$cachedClearTimeout === $fa04c4c140cfd1fe$var$defaultClearTimeout || !$fa04c4c140cfd1fe$var$cachedClearTimeout) && clearTimeout) {
        $fa04c4c140cfd1fe$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $fa04c4c140cfd1fe$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $fa04c4c140cfd1fe$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $fa04c4c140cfd1fe$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $fa04c4c140cfd1fe$var$queue = [];
var $fa04c4c140cfd1fe$var$draining = false;
var $fa04c4c140cfd1fe$var$currentQueue;
var $fa04c4c140cfd1fe$var$queueIndex = -1;
function $fa04c4c140cfd1fe$var$cleanUpNextTick() {
    if (!$fa04c4c140cfd1fe$var$draining || !$fa04c4c140cfd1fe$var$currentQueue) return;
    $fa04c4c140cfd1fe$var$draining = false;
    if ($fa04c4c140cfd1fe$var$currentQueue.length) $fa04c4c140cfd1fe$var$queue = $fa04c4c140cfd1fe$var$currentQueue.concat($fa04c4c140cfd1fe$var$queue);
    else $fa04c4c140cfd1fe$var$queueIndex = -1;
    if ($fa04c4c140cfd1fe$var$queue.length) $fa04c4c140cfd1fe$var$drainQueue();
}
function $fa04c4c140cfd1fe$var$drainQueue() {
    if ($fa04c4c140cfd1fe$var$draining) return;
    var timeout = $fa04c4c140cfd1fe$var$runTimeout($fa04c4c140cfd1fe$var$cleanUpNextTick);
    $fa04c4c140cfd1fe$var$draining = true;
    var len = $fa04c4c140cfd1fe$var$queue.length;
    while(len){
        $fa04c4c140cfd1fe$var$currentQueue = $fa04c4c140cfd1fe$var$queue;
        $fa04c4c140cfd1fe$var$queue = [];
        while(++$fa04c4c140cfd1fe$var$queueIndex < len)if ($fa04c4c140cfd1fe$var$currentQueue) $fa04c4c140cfd1fe$var$currentQueue[$fa04c4c140cfd1fe$var$queueIndex].run();
        $fa04c4c140cfd1fe$var$queueIndex = -1;
        len = $fa04c4c140cfd1fe$var$queue.length;
    }
    $fa04c4c140cfd1fe$var$currentQueue = null;
    $fa04c4c140cfd1fe$var$draining = false;
    $fa04c4c140cfd1fe$var$runClearTimeout(timeout);
}
$fa04c4c140cfd1fe$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $fa04c4c140cfd1fe$var$queue.push(new $fa04c4c140cfd1fe$var$Item(fun, args));
    if ($fa04c4c140cfd1fe$var$queue.length === 1 && !$fa04c4c140cfd1fe$var$draining) $fa04c4c140cfd1fe$var$runTimeout($fa04c4c140cfd1fe$var$drainQueue);
};
// v8 likes predictible objects
function $fa04c4c140cfd1fe$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$fa04c4c140cfd1fe$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$fa04c4c140cfd1fe$var$process.title = 'browser';
$fa04c4c140cfd1fe$var$process.browser = true;
$fa04c4c140cfd1fe$var$process.env = {};
$fa04c4c140cfd1fe$var$process.argv = [];
$fa04c4c140cfd1fe$var$process.version = ''; // empty string to avoid regexp issues
$fa04c4c140cfd1fe$var$process.versions = {};
function $fa04c4c140cfd1fe$var$noop() {}
$fa04c4c140cfd1fe$var$process.on = $fa04c4c140cfd1fe$var$noop;
$fa04c4c140cfd1fe$var$process.addListener = $fa04c4c140cfd1fe$var$noop;
$fa04c4c140cfd1fe$var$process.once = $fa04c4c140cfd1fe$var$noop;
$fa04c4c140cfd1fe$var$process.off = $fa04c4c140cfd1fe$var$noop;
$fa04c4c140cfd1fe$var$process.removeListener = $fa04c4c140cfd1fe$var$noop;
$fa04c4c140cfd1fe$var$process.removeAllListeners = $fa04c4c140cfd1fe$var$noop;
$fa04c4c140cfd1fe$var$process.emit = $fa04c4c140cfd1fe$var$noop;
$fa04c4c140cfd1fe$var$process.prependListener = $fa04c4c140cfd1fe$var$noop;
$fa04c4c140cfd1fe$var$process.prependOnceListener = $fa04c4c140cfd1fe$var$noop;
$fa04c4c140cfd1fe$var$process.listeners = function(name) {
    return [];
};
$fa04c4c140cfd1fe$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$fa04c4c140cfd1fe$var$process.cwd = function() {
    return '/';
};
$fa04c4c140cfd1fe$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$fa04c4c140cfd1fe$var$process.umask = function() {
    return 0;
};

});

parcelRegister("yNoK7", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $cZ3NM = parcelRequire("cZ3NM");

var $icFwd = parcelRequire("icFwd");

var $404CY = parcelRequire("404CY");

var $dhHts = parcelRequire("dhHts");
function $06897e851ebdb7dc$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $06897e851ebdb7dc$var$BigIntSupported = typeof BigInt !== 'undefined';
var $06897e851ebdb7dc$var$SymbolSupported = typeof Symbol !== 'undefined';
var $06897e851ebdb7dc$var$ObjectToString = $06897e851ebdb7dc$var$uncurryThis(Object.prototype.toString);
var $06897e851ebdb7dc$var$numberValue = $06897e851ebdb7dc$var$uncurryThis(Number.prototype.valueOf);
var $06897e851ebdb7dc$var$stringValue = $06897e851ebdb7dc$var$uncurryThis(String.prototype.valueOf);
var $06897e851ebdb7dc$var$booleanValue = $06897e851ebdb7dc$var$uncurryThis(Boolean.prototype.valueOf);
if ($06897e851ebdb7dc$var$BigIntSupported) var $06897e851ebdb7dc$var$bigIntValue = $06897e851ebdb7dc$var$uncurryThis(BigInt.prototype.valueOf);
if ($06897e851ebdb7dc$var$SymbolSupported) var $06897e851ebdb7dc$var$symbolValue = $06897e851ebdb7dc$var$uncurryThis(Symbol.prototype.valueOf);
function $06897e851ebdb7dc$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $cZ3NM;
module.exports.isGeneratorFunction = $icFwd;
module.exports.isTypedArray = $dhHts;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $06897e851ebdb7dc$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $06897e851ebdb7dc$var$isPromise;
function $06897e851ebdb7dc$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $dhHts(value) || $06897e851ebdb7dc$var$isDataView(value);
}
module.exports.isArrayBufferView = $06897e851ebdb7dc$var$isArrayBufferView;
function $06897e851ebdb7dc$var$isUint8Array(value) {
    return $404CY(value) === 'Uint8Array';
}
module.exports.isUint8Array = $06897e851ebdb7dc$var$isUint8Array;
function $06897e851ebdb7dc$var$isUint8ClampedArray(value) {
    return $404CY(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $06897e851ebdb7dc$var$isUint8ClampedArray;
function $06897e851ebdb7dc$var$isUint16Array(value) {
    return $404CY(value) === 'Uint16Array';
}
module.exports.isUint16Array = $06897e851ebdb7dc$var$isUint16Array;
function $06897e851ebdb7dc$var$isUint32Array(value) {
    return $404CY(value) === 'Uint32Array';
}
module.exports.isUint32Array = $06897e851ebdb7dc$var$isUint32Array;
function $06897e851ebdb7dc$var$isInt8Array(value) {
    return $404CY(value) === 'Int8Array';
}
module.exports.isInt8Array = $06897e851ebdb7dc$var$isInt8Array;
function $06897e851ebdb7dc$var$isInt16Array(value) {
    return $404CY(value) === 'Int16Array';
}
module.exports.isInt16Array = $06897e851ebdb7dc$var$isInt16Array;
function $06897e851ebdb7dc$var$isInt32Array(value) {
    return $404CY(value) === 'Int32Array';
}
module.exports.isInt32Array = $06897e851ebdb7dc$var$isInt32Array;
function $06897e851ebdb7dc$var$isFloat32Array(value) {
    return $404CY(value) === 'Float32Array';
}
module.exports.isFloat32Array = $06897e851ebdb7dc$var$isFloat32Array;
function $06897e851ebdb7dc$var$isFloat64Array(value) {
    return $404CY(value) === 'Float64Array';
}
module.exports.isFloat64Array = $06897e851ebdb7dc$var$isFloat64Array;
function $06897e851ebdb7dc$var$isBigInt64Array(value) {
    return $404CY(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $06897e851ebdb7dc$var$isBigInt64Array;
function $06897e851ebdb7dc$var$isBigUint64Array(value) {
    return $404CY(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $06897e851ebdb7dc$var$isBigUint64Array;
function $06897e851ebdb7dc$var$isMapToString(value) {
    return $06897e851ebdb7dc$var$ObjectToString(value) === '[object Map]';
}
$06897e851ebdb7dc$var$isMapToString.working = typeof Map !== 'undefined' && $06897e851ebdb7dc$var$isMapToString(new Map());
function $06897e851ebdb7dc$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $06897e851ebdb7dc$var$isMapToString.working ? $06897e851ebdb7dc$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $06897e851ebdb7dc$var$isMap;
function $06897e851ebdb7dc$var$isSetToString(value) {
    return $06897e851ebdb7dc$var$ObjectToString(value) === '[object Set]';
}
$06897e851ebdb7dc$var$isSetToString.working = typeof Set !== 'undefined' && $06897e851ebdb7dc$var$isSetToString(new Set());
function $06897e851ebdb7dc$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $06897e851ebdb7dc$var$isSetToString.working ? $06897e851ebdb7dc$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $06897e851ebdb7dc$var$isSet;
function $06897e851ebdb7dc$var$isWeakMapToString(value) {
    return $06897e851ebdb7dc$var$ObjectToString(value) === '[object WeakMap]';
}
$06897e851ebdb7dc$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $06897e851ebdb7dc$var$isWeakMapToString(new WeakMap());
function $06897e851ebdb7dc$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $06897e851ebdb7dc$var$isWeakMapToString.working ? $06897e851ebdb7dc$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $06897e851ebdb7dc$var$isWeakMap;
function $06897e851ebdb7dc$var$isWeakSetToString(value) {
    return $06897e851ebdb7dc$var$ObjectToString(value) === '[object WeakSet]';
}
$06897e851ebdb7dc$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $06897e851ebdb7dc$var$isWeakSetToString(new WeakSet());
function $06897e851ebdb7dc$var$isWeakSet(value) {
    return $06897e851ebdb7dc$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $06897e851ebdb7dc$var$isWeakSet;
function $06897e851ebdb7dc$var$isArrayBufferToString(value) {
    return $06897e851ebdb7dc$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$06897e851ebdb7dc$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $06897e851ebdb7dc$var$isArrayBufferToString(new ArrayBuffer());
function $06897e851ebdb7dc$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $06897e851ebdb7dc$var$isArrayBufferToString.working ? $06897e851ebdb7dc$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $06897e851ebdb7dc$var$isArrayBuffer;
function $06897e851ebdb7dc$var$isDataViewToString(value) {
    return $06897e851ebdb7dc$var$ObjectToString(value) === '[object DataView]';
}
$06897e851ebdb7dc$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $06897e851ebdb7dc$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $06897e851ebdb7dc$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $06897e851ebdb7dc$var$isDataViewToString.working ? $06897e851ebdb7dc$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $06897e851ebdb7dc$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $06897e851ebdb7dc$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $06897e851ebdb7dc$var$isSharedArrayBufferToString(value) {
    return $06897e851ebdb7dc$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $06897e851ebdb7dc$var$isSharedArrayBuffer(value) {
    if (typeof $06897e851ebdb7dc$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $06897e851ebdb7dc$var$isSharedArrayBufferToString.working === 'undefined') $06897e851ebdb7dc$var$isSharedArrayBufferToString.working = $06897e851ebdb7dc$var$isSharedArrayBufferToString(new $06897e851ebdb7dc$var$SharedArrayBufferCopy());
    return $06897e851ebdb7dc$var$isSharedArrayBufferToString.working ? $06897e851ebdb7dc$var$isSharedArrayBufferToString(value) : value instanceof $06897e851ebdb7dc$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $06897e851ebdb7dc$var$isSharedArrayBuffer;
function $06897e851ebdb7dc$var$isAsyncFunction(value) {
    return $06897e851ebdb7dc$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $06897e851ebdb7dc$var$isAsyncFunction;
function $06897e851ebdb7dc$var$isMapIterator(value) {
    return $06897e851ebdb7dc$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $06897e851ebdb7dc$var$isMapIterator;
function $06897e851ebdb7dc$var$isSetIterator(value) {
    return $06897e851ebdb7dc$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $06897e851ebdb7dc$var$isSetIterator;
function $06897e851ebdb7dc$var$isGeneratorObject(value) {
    return $06897e851ebdb7dc$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $06897e851ebdb7dc$var$isGeneratorObject;
function $06897e851ebdb7dc$var$isWebAssemblyCompiledModule(value) {
    return $06897e851ebdb7dc$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $06897e851ebdb7dc$var$isWebAssemblyCompiledModule;
function $06897e851ebdb7dc$var$isNumberObject(value) {
    return $06897e851ebdb7dc$var$checkBoxedPrimitive(value, $06897e851ebdb7dc$var$numberValue);
}
module.exports.isNumberObject = $06897e851ebdb7dc$var$isNumberObject;
function $06897e851ebdb7dc$var$isStringObject(value) {
    return $06897e851ebdb7dc$var$checkBoxedPrimitive(value, $06897e851ebdb7dc$var$stringValue);
}
module.exports.isStringObject = $06897e851ebdb7dc$var$isStringObject;
function $06897e851ebdb7dc$var$isBooleanObject(value) {
    return $06897e851ebdb7dc$var$checkBoxedPrimitive(value, $06897e851ebdb7dc$var$booleanValue);
}
module.exports.isBooleanObject = $06897e851ebdb7dc$var$isBooleanObject;
function $06897e851ebdb7dc$var$isBigIntObject(value) {
    return $06897e851ebdb7dc$var$BigIntSupported && $06897e851ebdb7dc$var$checkBoxedPrimitive(value, $06897e851ebdb7dc$var$bigIntValue);
}
module.exports.isBigIntObject = $06897e851ebdb7dc$var$isBigIntObject;
function $06897e851ebdb7dc$var$isSymbolObject(value) {
    return $06897e851ebdb7dc$var$SymbolSupported && $06897e851ebdb7dc$var$checkBoxedPrimitive(value, $06897e851ebdb7dc$var$symbolValue);
}
module.exports.isSymbolObject = $06897e851ebdb7dc$var$isSymbolObject;
function $06897e851ebdb7dc$var$isBoxedPrimitive(value) {
    return $06897e851ebdb7dc$var$isNumberObject(value) || $06897e851ebdb7dc$var$isStringObject(value) || $06897e851ebdb7dc$var$isBooleanObject(value) || $06897e851ebdb7dc$var$isBigIntObject(value) || $06897e851ebdb7dc$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $06897e851ebdb7dc$var$isBoxedPrimitive;
function $06897e851ebdb7dc$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($06897e851ebdb7dc$var$isArrayBuffer(value) || $06897e851ebdb7dc$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $06897e851ebdb7dc$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("cZ3NM", function(module, exports) {
'use strict';

var $973e21822c4597c6$var$hasToStringTag = (parcelRequire("7hwiR"))();

var $7RlT5 = parcelRequire("7RlT5");
var $973e21822c4597c6$var$$toString = $7RlT5('Object.prototype.toString');
/** @type {import('.')} */ var $973e21822c4597c6$var$isStandardArguments = function isArguments(value) {
    if ($973e21822c4597c6$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $973e21822c4597c6$var$$toString(value) === '[object Arguments]';
};
/** @type {import('.')} */ var $973e21822c4597c6$var$isLegacyArguments = function isArguments(value) {
    if ($973e21822c4597c6$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && 'length' in value && typeof value.length === 'number' && value.length >= 0 && $973e21822c4597c6$var$$toString(value) !== '[object Array]' && 'callee' in value && $973e21822c4597c6$var$$toString(value.callee) === '[object Function]';
};
var $973e21822c4597c6$var$supportsStandardArguments = function() {
    return $973e21822c4597c6$var$isStandardArguments(arguments);
}();
// @ts-expect-error TODO make this not error
$973e21822c4597c6$var$isStandardArguments.isLegacyArguments = $973e21822c4597c6$var$isLegacyArguments; // for tests
/** @type {import('.')} */ module.exports = $973e21822c4597c6$var$supportsStandardArguments ? $973e21822c4597c6$var$isStandardArguments : $973e21822c4597c6$var$isLegacyArguments;

});
parcelRegister("7hwiR", function(module, exports) {
'use strict';

var $bAqIz = parcelRequire("bAqIz");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $bAqIz() && !!Symbol.toStringTag;
};

});
parcelRegister("bAqIz", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("7RlT5", function(module, exports) {
'use strict';

var $chEcS = parcelRequire("chEcS");

var $hAIQH = parcelRequire("hAIQH");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $5b8e760f9e9fee75$var$$indexOf = $hAIQH([
    $chEcS('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $chEcS(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $5b8e760f9e9fee75$var$$indexOf(name, '.prototype.') > -1) return $hAIQH(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("chEcS", function(module, exports) {
'use strict';
var $8f1642c5110672f6$var$undefined1;

var $g17Q0 = parcelRequire("g17Q0");

var $6Sj0N = parcelRequire("6Sj0N");

var $e8Bmi = parcelRequire("e8Bmi");

var $9rU9Z = parcelRequire("9rU9Z");

var $8DgcR = parcelRequire("8DgcR");

var $lcGPl = parcelRequire("lcGPl");

var $9Jy7Z = parcelRequire("9Jy7Z");

var $iW3vs = parcelRequire("iW3vs");

var $3BOab = parcelRequire("3BOab");

var $cB16Y = parcelRequire("cB16Y");

var $3aMfA = parcelRequire("3aMfA");

var $7Z2L7 = parcelRequire("7Z2L7");

var $jk9OZ = parcelRequire("jk9OZ");

var $gySxy = parcelRequire("gySxy");

var $lqwhp = parcelRequire("lqwhp");
var $8f1642c5110672f6$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $8f1642c5110672f6$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $8f1642c5110672f6$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $b8eKQ = parcelRequire("b8eKQ");

var $fhZdm = parcelRequire("fhZdm");
var $8f1642c5110672f6$var$throwTypeError = function() {
    throw new $9Jy7Z();
};
var $8f1642c5110672f6$var$ThrowTypeError = $b8eKQ ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $8f1642c5110672f6$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $b8eKQ(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $8f1642c5110672f6$var$throwTypeError;
        }
    }
}() : $8f1642c5110672f6$var$throwTypeError;

var $8f1642c5110672f6$var$hasSymbols = (parcelRequire("4Ga8J"))();

var $Vza6z = parcelRequire("Vza6z");

var $2Xt7C = parcelRequire("2Xt7C");

var $axMXM = parcelRequire("axMXM");

var $5K6un = parcelRequire("5K6un");

var $jkv8l = parcelRequire("jkv8l");
var $8f1642c5110672f6$var$needsEval = {};
var $8f1642c5110672f6$var$TypedArray = typeof Uint8Array === 'undefined' || !$Vza6z ? undefined : $Vza6z(Uint8Array);
var $8f1642c5110672f6$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $8f1642c5110672f6$var$hasSymbols && $Vza6z ? $Vza6z([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $8f1642c5110672f6$var$needsEval,
    '%AsyncGenerator%': $8f1642c5110672f6$var$needsEval,
    '%AsyncGeneratorFunction%': $8f1642c5110672f6$var$needsEval,
    '%AsyncIteratorPrototype%': $8f1642c5110672f6$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $6Sj0N,
    '%eval%': eval,
    '%EvalError%': $e8Bmi,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $8f1642c5110672f6$var$$Function,
    '%GeneratorFunction%': $8f1642c5110672f6$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $8f1642c5110672f6$var$hasSymbols && $Vza6z ? $Vza6z($Vza6z([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$8f1642c5110672f6$var$hasSymbols || !$Vza6z ? undefined : $Vza6z(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $g17Q0,
    '%Object.getOwnPropertyDescriptor%': $b8eKQ,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $9rU9Z,
    '%ReferenceError%': $8DgcR,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$8f1642c5110672f6$var$hasSymbols || !$Vza6z ? undefined : $Vza6z(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $8f1642c5110672f6$var$hasSymbols && $Vza6z ? $Vza6z(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $8f1642c5110672f6$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $lcGPl,
    '%ThrowTypeError%': $8f1642c5110672f6$var$ThrowTypeError,
    '%TypedArray%': $8f1642c5110672f6$var$TypedArray,
    '%TypeError%': $9Jy7Z,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $iW3vs,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $jkv8l,
    '%Function.prototype.apply%': $5K6un,
    '%Object.defineProperty%': $fhZdm,
    '%Object.getPrototypeOf%': $2Xt7C,
    '%Math.abs%': $3BOab,
    '%Math.floor%': $cB16Y,
    '%Math.max%': $3aMfA,
    '%Math.min%': $7Z2L7,
    '%Math.pow%': $jk9OZ,
    '%Math.round%': $gySxy,
    '%Math.sign%': $lqwhp,
    '%Reflect.getPrototypeOf%': $axMXM
};
if ($Vza6z) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $8f1642c5110672f6$var$errorProto = $Vza6z($Vza6z(e));
    $8f1642c5110672f6$var$INTRINSICS['%Error.prototype%'] = $8f1642c5110672f6$var$errorProto;
}
var $8f1642c5110672f6$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $8f1642c5110672f6$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $8f1642c5110672f6$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $8f1642c5110672f6$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $Vza6z) value = $Vza6z(gen.prototype);
    }
    $8f1642c5110672f6$var$INTRINSICS[name] = value;
    return value;
};
var $8f1642c5110672f6$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $brztX = parcelRequire("brztX");

var $d8yTy = parcelRequire("d8yTy");
var $8f1642c5110672f6$var$$concat = $brztX.call($jkv8l, Array.prototype.concat);
var $8f1642c5110672f6$var$$spliceApply = $brztX.call($5K6un, Array.prototype.splice);
var $8f1642c5110672f6$var$$replace = $brztX.call($jkv8l, String.prototype.replace);
var $8f1642c5110672f6$var$$strSlice = $brztX.call($jkv8l, String.prototype.slice);
var $8f1642c5110672f6$var$$exec = $brztX.call($jkv8l, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $8f1642c5110672f6$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $8f1642c5110672f6$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $8f1642c5110672f6$var$stringToPath = function stringToPath(string) {
    var first = $8f1642c5110672f6$var$$strSlice(string, 0, 1);
    var last = $8f1642c5110672f6$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $lcGPl('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $lcGPl('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $8f1642c5110672f6$var$$replace(string, $8f1642c5110672f6$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $8f1642c5110672f6$var$$replace(subString, $8f1642c5110672f6$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $8f1642c5110672f6$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($d8yTy($8f1642c5110672f6$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $8f1642c5110672f6$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($d8yTy($8f1642c5110672f6$var$INTRINSICS, intrinsicName)) {
        var value = $8f1642c5110672f6$var$INTRINSICS[intrinsicName];
        if (value === $8f1642c5110672f6$var$needsEval) value = $8f1642c5110672f6$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $9Jy7Z('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $lcGPl('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $9Jy7Z('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $9Jy7Z('"allowMissing" argument must be a boolean');
    if ($8f1642c5110672f6$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $lcGPl('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $8f1642c5110672f6$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $8f1642c5110672f6$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $8f1642c5110672f6$var$$spliceApply(parts, $8f1642c5110672f6$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $8f1642c5110672f6$var$$strSlice(part, 0, 1);
        var last = $8f1642c5110672f6$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $lcGPl('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($d8yTy($8f1642c5110672f6$var$INTRINSICS, intrinsicRealName)) value = $8f1642c5110672f6$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $9Jy7Z('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($b8eKQ && i + 1 >= parts.length) {
                var desc = $b8eKQ(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $d8yTy(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $8f1642c5110672f6$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("g17Q0", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("6Sj0N", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("e8Bmi", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("9rU9Z", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("8DgcR", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("lcGPl", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("9Jy7Z", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("iW3vs", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("3BOab", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("cB16Y", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("3aMfA", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("7Z2L7", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("jk9OZ", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("gySxy", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("lqwhp", function(module, exports) {
'use strict';

var $dmxUi = parcelRequire("dmxUi");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($dmxUi(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("dmxUi", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("b8eKQ", function(module, exports) {
'use strict';

var $eI7g3 = parcelRequire("eI7g3");
var $81abe2fe0315508c$require$$gOPD = $eI7g3;
if ($81abe2fe0315508c$require$$gOPD) try {
    $81abe2fe0315508c$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $81abe2fe0315508c$require$$gOPD = null;
}
module.exports = $81abe2fe0315508c$require$$gOPD;

});
parcelRegister("eI7g3", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("fhZdm", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $b217ed74aef9a6b6$var$$defineProperty = Object.defineProperty || false;
if ($b217ed74aef9a6b6$var$$defineProperty) try {
    $b217ed74aef9a6b6$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $b217ed74aef9a6b6$var$$defineProperty = false;
}
module.exports = $b217ed74aef9a6b6$var$$defineProperty;

});

parcelRegister("4Ga8J", function(module, exports) {
'use strict';
var $3682f338fbcce27d$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $bAqIz = parcelRequire("bAqIz");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $3682f338fbcce27d$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $3682f338fbcce27d$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $bAqIz();
};

});

parcelRegister("Vza6z", function(module, exports) {
'use strict';

var $axMXM = parcelRequire("axMXM");

var $2Xt7C = parcelRequire("2Xt7C");

var $4xWEW = parcelRequire("4xWEW");
/** @type {import('.')} */ module.exports = $axMXM ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $axMXM(O);
} : $2Xt7C ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $2Xt7C(O);
} : $4xWEW ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $4xWEW(O);
} : null;

});
parcelRegister("axMXM", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("2Xt7C", function(module, exports) {
'use strict';

var $g17Q0 = parcelRequire("g17Q0");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $g17Q0.getPrototypeOf || null;

});

parcelRegister("4xWEW", function(module, exports) {
'use strict';

var $hAIQH = parcelRequire("hAIQH");

var $b8eKQ = parcelRequire("b8eKQ");
var $34f7bf08096f2580$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $34f7bf08096f2580$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $34f7bf08096f2580$var$desc = !!$34f7bf08096f2580$var$hasProtoAccessor && $b8eKQ && $b8eKQ(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $34f7bf08096f2580$var$$Object = Object;
var $34f7bf08096f2580$var$$getPrototypeOf = $34f7bf08096f2580$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $34f7bf08096f2580$var$desc && typeof $34f7bf08096f2580$var$desc.get === 'function' ? $hAIQH([
    $34f7bf08096f2580$var$desc.get
]) : typeof $34f7bf08096f2580$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $34f7bf08096f2580$var$$getPrototypeOf(value == null ? value : $34f7bf08096f2580$var$$Object(value));
} : false;

});
parcelRegister("hAIQH", function(module, exports) {
'use strict';

var $brztX = parcelRequire("brztX");

var $9Jy7Z = parcelRequire("9Jy7Z");

var $jkv8l = parcelRequire("jkv8l");

var $awnpU = parcelRequire("awnpU");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $9Jy7Z('a function is required');
    return $awnpU($brztX, $jkv8l, args);
};

});
parcelRegister("brztX", function(module, exports) {
'use strict';

var $7aqau = parcelRequire("7aqau");
module.exports = Function.prototype.bind || $7aqau;

});
parcelRegister("7aqau", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $537dc40680be58e3$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $537dc40680be58e3$var$toStr = Object.prototype.toString;
var $537dc40680be58e3$var$max = Math.max;
var $537dc40680be58e3$var$funcType = '[object Function]';
var $537dc40680be58e3$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $537dc40680be58e3$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $537dc40680be58e3$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $537dc40680be58e3$var$toStr.apply(target) !== $537dc40680be58e3$var$funcType) throw new TypeError($537dc40680be58e3$var$ERROR_MESSAGE + target);
    var args = $537dc40680be58e3$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $537dc40680be58e3$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $537dc40680be58e3$var$concatty(args, arguments));
    };
    var boundLength = $537dc40680be58e3$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $537dc40680be58e3$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("jkv8l", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("awnpU", function(module, exports) {
'use strict';

var $brztX = parcelRequire("brztX");

var $5K6un = parcelRequire("5K6un");

var $jkv8l = parcelRequire("jkv8l");

var $bqfhu = parcelRequire("bqfhu");
/** @type {import('./actualApply')} */ module.exports = $bqfhu || $brztX.call($jkv8l, $5K6un);

});
parcelRegister("5K6un", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("bqfhu", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("d8yTy", function(module, exports) {
'use strict';
var $99071721c2a05db0$var$call = Function.prototype.call;
var $99071721c2a05db0$var$$hasOwn = Object.prototype.hasOwnProperty;

var $brztX = parcelRequire("brztX");
/** @type {import('.')} */ module.exports = $brztX.call($99071721c2a05db0$var$call, $99071721c2a05db0$var$$hasOwn);

});




parcelRegister("icFwd", function(module, exports) {
'use strict';

var $7RlT5 = parcelRequire("7RlT5");

var $ktj71 = parcelRequire("ktj71");
var $d4098db29f29ef7a$var$isFnRegex = $ktj71(/^\s*(?:function)?\*/);

var $d4098db29f29ef7a$var$hasToStringTag = (parcelRequire("7hwiR"))();

var $Vza6z = parcelRequire("Vza6z");
var $d4098db29f29ef7a$var$toStr = $7RlT5('Object.prototype.toString');
var $d4098db29f29ef7a$var$fnToStr = $7RlT5('Function.prototype.toString');

var $9EDmV = parcelRequire("9EDmV");
/** @type {import('.')} */ module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($d4098db29f29ef7a$var$isFnRegex($d4098db29f29ef7a$var$fnToStr(fn))) return true;
    if (!$d4098db29f29ef7a$var$hasToStringTag) {
        var str = $d4098db29f29ef7a$var$toStr(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$Vza6z) return false;
    var GeneratorFunction = $9EDmV();
    return GeneratorFunction && $Vza6z(fn) === GeneratorFunction.prototype;
};

});
parcelRegister("ktj71", function(module, exports) {
'use strict';

var $7RlT5 = parcelRequire("7RlT5");

var $9JUri = parcelRequire("9JUri");
var $ee75576162d6a237$var$$exec = $7RlT5('RegExp.prototype.exec');

var $9Jy7Z = parcelRequire("9Jy7Z");
/** @type {import('.')} */ module.exports = function regexTester(regex) {
    if (!$9JUri(regex)) throw new $9Jy7Z('`regex` must be a RegExp');
    return function test(s) {
        return $ee75576162d6a237$var$$exec(regex, s) !== null;
    };
};

});
parcelRegister("9JUri", function(module, exports) {
'use strict';

var $7RlT5 = parcelRequire("7RlT5");

var $717418aef1e59995$var$hasToStringTag = (parcelRequire("7hwiR"))();

var $d8yTy = parcelRequire("d8yTy");

var $b8eKQ = parcelRequire("b8eKQ");
/** @type {import('.')} */ var $717418aef1e59995$var$fn;
if ($717418aef1e59995$var$hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $717418aef1e59995$var$$exec = $7RlT5('RegExp.prototype.exec');
    /** @type {object} */ var $717418aef1e59995$var$isRegexMarker = {};
    var $717418aef1e59995$var$throwRegexMarker = function() {
        throw $717418aef1e59995$var$isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var $717418aef1e59995$var$badStringifier = {
        toString: $717418aef1e59995$var$throwRegexMarker,
        valueOf: $717418aef1e59995$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') $717418aef1e59995$var$badStringifier[Symbol.toPrimitive] = $717418aef1e59995$var$throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    $717418aef1e59995$var$fn = function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ $b8eKQ(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && $d8yTy(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $717418aef1e59995$var$$exec(value, /** @type {unknown} */ $717418aef1e59995$var$badStringifier);
        } catch (e) {
            return e === $717418aef1e59995$var$isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $717418aef1e59995$var$$toString = $7RlT5('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var $717418aef1e59995$var$regexClass = '[object RegExp]';
    /** @type {import('.')} */ $717418aef1e59995$var$fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $717418aef1e59995$var$$toString(value) === $717418aef1e59995$var$regexClass;
    };
}
module.exports = $717418aef1e59995$var$fn;

});


parcelRegister("9EDmV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $44ff5fe4f8457e09$export$2e2bcd8739ae039; });

var $4FkJo = parcelRequire("4FkJo");
var /** @type {import('./index.d.mts').default} */ $44ff5fe4f8457e09$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($4FkJo)));

});
parcelRegister("4FkJo", function(module, exports) {
'use strict';
// eslint-disable-next-line no-extra-parens, no-empty-function
const $365b12878caba5b9$var$cached = /** @type {GeneratorFunctionConstructor} */ (function*() {}).constructor;
/** @type {import('.')} */ module.exports = ()=>$365b12878caba5b9$var$cached;

});



parcelRegister("404CY", function(module, exports) {
'use strict';

var $Kf9cF = parcelRequire("Kf9cF");

var $g8yRP = parcelRequire("g8yRP");

var $loaP6 = parcelRequire("loaP6");

var $7RlT5 = parcelRequire("7RlT5");

var $b8eKQ = parcelRequire("b8eKQ");

var $Vza6z = parcelRequire("Vza6z");
var $2e9ac06fe13b9b12$var$$toString = $7RlT5('Object.prototype.toString');

var $2e9ac06fe13b9b12$var$hasToStringTag = (parcelRequire("7hwiR"))();
var $2e9ac06fe13b9b12$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $2e9ac06fe13b9b12$var$typedArrays = $g8yRP();
var $2e9ac06fe13b9b12$var$$slice = $7RlT5('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $2e9ac06fe13b9b12$var$$indexOf = $7RlT5('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $2e9ac06fe13b9b12$var$cache = {
    __proto__: null
};
if ($2e9ac06fe13b9b12$var$hasToStringTag && $b8eKQ && $Vza6z) $Kf9cF($2e9ac06fe13b9b12$var$typedArrays, function(typedArray) {
    var arr = new $2e9ac06fe13b9b12$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $Vza6z) {
        var proto = $Vza6z(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $b8eKQ(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $Vza6z(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $b8eKQ(superProto, Symbol.toStringTag);
        }
        if (descriptor && descriptor.get) {
            var bound = $loaP6(descriptor.get);
            $2e9ac06fe13b9b12$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = bound;
        }
    }
});
else $Kf9cF($2e9ac06fe13b9b12$var$typedArrays, function(typedArray) {
    var arr = new $2e9ac06fe13b9b12$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) {
        var bound = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
        $loaP6(fn);
        $2e9ac06fe13b9b12$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = bound;
    }
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $2e9ac06fe13b9b12$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $Kf9cF(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $2e9ac06fe13b9b12$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $2e9ac06fe13b9b12$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $2e9ac06fe13b9b12$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $Kf9cF(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $2e9ac06fe13b9b12$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $2e9ac06fe13b9b12$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$2e9ac06fe13b9b12$var$hasToStringTag) {
        /** @type {string} */ var tag = $2e9ac06fe13b9b12$var$$slice($2e9ac06fe13b9b12$var$$toString(value), 8, -1);
        if ($2e9ac06fe13b9b12$var$$indexOf($2e9ac06fe13b9b12$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $2e9ac06fe13b9b12$var$trySlices(value);
    }
    if (!$b8eKQ) return null;
     // unknown engine
    return $2e9ac06fe13b9b12$var$tryTypedArrays(value);
};

});
parcelRegister("Kf9cF", function(module, exports) {
'use strict';

var $7M8JE = parcelRequire("7M8JE");
var $08b00bf56aab7f1a$var$toStr = Object.prototype.toString;
var $08b00bf56aab7f1a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $08b00bf56aab7f1a$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($08b00bf56aab7f1a$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $08b00bf56aab7f1a$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $08b00bf56aab7f1a$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($08b00bf56aab7f1a$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $08b00bf56aab7f1a$var$isArray(x) {
    return $08b00bf56aab7f1a$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$7M8JE(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($08b00bf56aab7f1a$var$isArray(list)) $08b00bf56aab7f1a$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $08b00bf56aab7f1a$var$forEachString(list, iterator, receiver);
    else $08b00bf56aab7f1a$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("7M8JE", function(module, exports) {
'use strict';
var $5a93cabd1832138d$var$fnToStr = Function.prototype.toString;
var $5a93cabd1832138d$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $5a93cabd1832138d$var$badArrayLike;
var $5a93cabd1832138d$var$isCallableMarker;
if (typeof $5a93cabd1832138d$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $5a93cabd1832138d$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $5a93cabd1832138d$var$isCallableMarker;
        }
    });
    $5a93cabd1832138d$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $5a93cabd1832138d$var$reflectApply(function() {
        throw 42;
    }, null, $5a93cabd1832138d$var$badArrayLike);
} catch (_) {
    if (_ !== $5a93cabd1832138d$var$isCallableMarker) $5a93cabd1832138d$var$reflectApply = null;
}
else $5a93cabd1832138d$var$reflectApply = null;
var $5a93cabd1832138d$var$constructorRegex = /^\s*class\b/;
var $5a93cabd1832138d$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $5a93cabd1832138d$var$fnToStr.call(value);
        return $5a93cabd1832138d$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $5a93cabd1832138d$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($5a93cabd1832138d$var$isES6ClassFn(value)) return false;
        $5a93cabd1832138d$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $5a93cabd1832138d$var$toStr = Object.prototype.toString;
var $5a93cabd1832138d$var$objectClass = '[object Object]';
var $5a93cabd1832138d$var$fnClass = '[object Function]';
var $5a93cabd1832138d$var$genClass = '[object GeneratorFunction]';
var $5a93cabd1832138d$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $5a93cabd1832138d$var$ddaClass2 = '[object HTML document.all class]';
var $5a93cabd1832138d$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $5a93cabd1832138d$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $5a93cabd1832138d$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $5a93cabd1832138d$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $5a93cabd1832138d$var$all = document.all;
    if ($5a93cabd1832138d$var$toStr.call($5a93cabd1832138d$var$all) === $5a93cabd1832138d$var$toStr.call(document.all)) $5a93cabd1832138d$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($5a93cabd1832138d$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $5a93cabd1832138d$var$toStr.call(value);
            return (str === $5a93cabd1832138d$var$ddaClass || str === $5a93cabd1832138d$var$ddaClass2 || str === $5a93cabd1832138d$var$ddaClass3 // opera 12.16
             || str === $5a93cabd1832138d$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $5a93cabd1832138d$var$reflectApply ? function isCallable(value) {
    if ($5a93cabd1832138d$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $5a93cabd1832138d$var$reflectApply(value, null, $5a93cabd1832138d$var$badArrayLike);
    } catch (e) {
        if (e !== $5a93cabd1832138d$var$isCallableMarker) return false;
    }
    return !$5a93cabd1832138d$var$isES6ClassFn(value) && $5a93cabd1832138d$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($5a93cabd1832138d$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($5a93cabd1832138d$var$hasToStringTag) return $5a93cabd1832138d$var$tryFunctionObject(value);
    if ($5a93cabd1832138d$var$isES6ClassFn(value)) return false;
    var strClass = $5a93cabd1832138d$var$toStr.call(value);
    if (strClass !== $5a93cabd1832138d$var$fnClass && strClass !== $5a93cabd1832138d$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $5a93cabd1832138d$var$tryFunctionObject(value);
};

});


parcelRegister("g8yRP", function(module, exports) {
'use strict';

var $jzQOE = parcelRequire("jzQOE");
var $bbf8709ba40adf4a$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $jzQOE.length; i++)if (typeof $bbf8709ba40adf4a$var$g[$jzQOE[i]] === 'function') // @ts-expect-error
    out[out.length] = $jzQOE[i];
    return out;
};

});
parcelRegister("jzQOE", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float16Array',
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("loaP6", function(module, exports) {
'use strict';

var $fqKEt = parcelRequire("fqKEt");

var $fhZdm = parcelRequire("fhZdm");

var $hAIQH = parcelRequire("hAIQH");

var $fyRf4 = parcelRequire("fyRf4");
module.exports = function callBind(originalFunction) {
    var func = $hAIQH(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $fqKEt(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($fhZdm) $fhZdm(module.exports, 'apply', {
    value: $fyRf4
});
else module.exports.apply = $fyRf4;

});
parcelRegister("fqKEt", function(module, exports) {
'use strict';

var $chEcS = parcelRequire("chEcS");

var $cb59G = parcelRequire("cb59G");

var $b3bd78c872b4e009$var$hasDescriptors = (parcelRequire("94oR7"))();

var $b8eKQ = parcelRequire("b8eKQ");

var $9Jy7Z = parcelRequire("9Jy7Z");
var $b3bd78c872b4e009$var$$floor = $chEcS('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $9Jy7Z('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $b3bd78c872b4e009$var$$floor(length) !== length) throw new $9Jy7Z('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $b8eKQ) {
        var desc = $b8eKQ(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($b3bd78c872b4e009$var$hasDescriptors) $cb59G(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $cb59G(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("cb59G", function(module, exports) {
'use strict';

var $fhZdm = parcelRequire("fhZdm");

var $lcGPl = parcelRequire("lcGPl");

var $9Jy7Z = parcelRequire("9Jy7Z");

var $b8eKQ = parcelRequire("b8eKQ");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $9Jy7Z('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $9Jy7Z('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $9Jy7Z('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $9Jy7Z('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $9Jy7Z('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $9Jy7Z('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$b8eKQ && $b8eKQ(obj, property);
    if ($fhZdm) $fhZdm(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $lcGPl('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("94oR7", function(module, exports) {
'use strict';

var $fhZdm = parcelRequire("fhZdm");
var $69a7c49b147e7f83$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$fhZdm;
};
$69a7c49b147e7f83$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$fhZdm) return null;
    try {
        return $fhZdm([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $69a7c49b147e7f83$var$hasPropertyDescriptors;

});


parcelRegister("fyRf4", function(module, exports) {
'use strict';

var $brztX = parcelRequire("brztX");

var $5K6un = parcelRequire("5K6un");

var $awnpU = parcelRequire("awnpU");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $awnpU($brztX, $5K6un, arguments);
};

});



parcelRegister("dhHts", function(module, exports) {
'use strict';

var $404CY = parcelRequire("404CY");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$404CY(value);
};

});


parcelRegister("l1G5g", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});

parcelRegister("hrcGl", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRegister("dUzj6", function(module, exports) {
/** @license React v16.8.6
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $63ReS = parcelRequire("63ReS");

var $6wXVr = parcelRequire("6wXVr");
function $a20be49b574e35ab$var$aa(a, b, d, c, f, e, h, g) {
    if (!a) {
        a = void 0;
        if (void 0 === b) a = Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var D = [
                d,
                c,
                f,
                e,
                h,
                g
            ], B = 0;
            a = Error(b.replace(/%s/g, function() {
                return D[B++];
            }));
            a.name = "Invariant Violation";
        }
        a.framesToPop = 1;
        throw a;
    }
}
function $a20be49b574e35ab$var$r(a) {
    for(var b = arguments.length - 1, d = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 0; c < b; c++)d += "&args[]=" + encodeURIComponent(arguments[c + 1]);
    $a20be49b574e35ab$var$aa(!1, "Minified React error #" + a + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", d);
}
var $a20be49b574e35ab$var$v = "function" === typeof Symbol && Symbol.for, $a20be49b574e35ab$var$ba = $a20be49b574e35ab$var$v ? Symbol.for("react.portal") : 60106, $a20be49b574e35ab$var$x = $a20be49b574e35ab$var$v ? Symbol.for("react.fragment") : 60107, $a20be49b574e35ab$var$ca = $a20be49b574e35ab$var$v ? Symbol.for("react.strict_mode") : 60108, $a20be49b574e35ab$var$da = $a20be49b574e35ab$var$v ? Symbol.for("react.profiler") : 60114, $a20be49b574e35ab$var$z = $a20be49b574e35ab$var$v ? Symbol.for("react.provider") : 60109, $a20be49b574e35ab$var$ea = $a20be49b574e35ab$var$v ? Symbol.for("react.context") : 60110, $a20be49b574e35ab$var$fa = $a20be49b574e35ab$var$v ? Symbol.for("react.concurrent_mode") : 60111, $a20be49b574e35ab$var$ha = $a20be49b574e35ab$var$v ? Symbol.for("react.forward_ref") : 60112, $a20be49b574e35ab$var$A = $a20be49b574e35ab$var$v ? Symbol.for("react.suspense") : 60113, $a20be49b574e35ab$var$ia = $a20be49b574e35ab$var$v ? Symbol.for("react.memo") : 60115, $a20be49b574e35ab$var$ja = $a20be49b574e35ab$var$v ? Symbol.for("react.lazy") : 60116;
function $a20be49b574e35ab$var$C(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $a20be49b574e35ab$var$fa:
            return "ConcurrentMode";
        case $a20be49b574e35ab$var$x:
            return "Fragment";
        case $a20be49b574e35ab$var$ba:
            return "Portal";
        case $a20be49b574e35ab$var$da:
            return "Profiler";
        case $a20be49b574e35ab$var$ca:
            return "StrictMode";
        case $a20be49b574e35ab$var$A:
            return "Suspense";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $a20be49b574e35ab$var$ea:
            return "Context.Consumer";
        case $a20be49b574e35ab$var$z:
            return "Context.Provider";
        case $a20be49b574e35ab$var$ha:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case $a20be49b574e35ab$var$ia:
            return $a20be49b574e35ab$var$C(a.type);
        case $a20be49b574e35ab$var$ja:
            if (a = 1 === a._status ? a._result : null) return $a20be49b574e35ab$var$C(a);
    }
    return null;
}
var $a20be49b574e35ab$var$E = $6wXVr.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
$a20be49b574e35ab$var$E.hasOwnProperty("ReactCurrentDispatcher") || ($a20be49b574e35ab$var$E.ReactCurrentDispatcher = {
    current: null
});
var $a20be49b574e35ab$var$ka = {};
function $a20be49b574e35ab$var$F(a, b) {
    for(var d = a._threadCount | 0; d <= b; d++)a[d] = a._currentValue2, a._threadCount = d + 1;
}
function $a20be49b574e35ab$var$la(a, b, d) {
    var c = a.contextType;
    if ("object" === typeof c && null !== c) return $a20be49b574e35ab$var$F(c, d), c[d];
    if (a = a.contextTypes) {
        d = {};
        for(var f in a)d[f] = b[f];
        b = d;
    } else b = $a20be49b574e35ab$var$ka;
    return b;
}
for(var $a20be49b574e35ab$var$G = new Uint16Array(16), $a20be49b574e35ab$var$H = 0; 15 > $a20be49b574e35ab$var$H; $a20be49b574e35ab$var$H++)$a20be49b574e35ab$var$G[$a20be49b574e35ab$var$H] = $a20be49b574e35ab$var$H + 1;
$a20be49b574e35ab$var$G[15] = 0;
var $a20be49b574e35ab$var$ma = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $a20be49b574e35ab$var$na = Object.prototype.hasOwnProperty, $a20be49b574e35ab$var$oa = {}, $a20be49b574e35ab$var$pa = {};
function $a20be49b574e35ab$var$qa(a) {
    if ($a20be49b574e35ab$var$na.call($a20be49b574e35ab$var$pa, a)) return !0;
    if ($a20be49b574e35ab$var$na.call($a20be49b574e35ab$var$oa, a)) return !1;
    if ($a20be49b574e35ab$var$ma.test(a)) return $a20be49b574e35ab$var$pa[a] = !0;
    $a20be49b574e35ab$var$oa[a] = !0;
    return !1;
}
function $a20be49b574e35ab$var$ra(a, b, d, c) {
    if (null !== d && 0 === d.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (c) return !1;
            if (null !== d) return !d.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $a20be49b574e35ab$var$sa(a, b, d, c) {
    if (null === b || "undefined" === typeof b || $a20be49b574e35ab$var$ra(a, b, d, c)) return !0;
    if (c) return !1;
    if (null !== d) switch(d.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $a20be49b574e35ab$var$I(a, b, d, c, f) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = c;
    this.attributeNamespace = f;
    this.mustUseProperty = d;
    this.propertyName = a;
    this.type = b;
}
var $a20be49b574e35ab$var$J = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $a20be49b574e35ab$var$J[a] = new $a20be49b574e35ab$var$I(a, 0, !1, a, null);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $a20be49b574e35ab$var$J[b] = new $a20be49b574e35ab$var$I(b, 1, !1, a[1], null);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $a20be49b574e35ab$var$J[a] = new $a20be49b574e35ab$var$I(a, 2, !1, a.toLowerCase(), null);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $a20be49b574e35ab$var$J[a] = new $a20be49b574e35ab$var$I(a, 2, !1, a, null);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $a20be49b574e35ab$var$J[a] = new $a20be49b574e35ab$var$I(a, 3, !1, a.toLowerCase(), null);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $a20be49b574e35ab$var$J[a] = new $a20be49b574e35ab$var$I(a, 3, !0, a, null);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $a20be49b574e35ab$var$J[a] = new $a20be49b574e35ab$var$I(a, 4, !1, a, null);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $a20be49b574e35ab$var$J[a] = new $a20be49b574e35ab$var$I(a, 6, !1, a, null);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $a20be49b574e35ab$var$J[a] = new $a20be49b574e35ab$var$I(a, 5, !1, a.toLowerCase(), null);
});
var $a20be49b574e35ab$var$K = /[\-:]([a-z])/g;
function $a20be49b574e35ab$var$L(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($a20be49b574e35ab$var$K, $a20be49b574e35ab$var$L);
    $a20be49b574e35ab$var$J[b] = new $a20be49b574e35ab$var$I(b, 1, !1, a, null);
});
"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($a20be49b574e35ab$var$K, $a20be49b574e35ab$var$L);
    $a20be49b574e35ab$var$J[b] = new $a20be49b574e35ab$var$I(b, 1, !1, a, "http://www.w3.org/1999/xlink");
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($a20be49b574e35ab$var$K, $a20be49b574e35ab$var$L);
    $a20be49b574e35ab$var$J[b] = new $a20be49b574e35ab$var$I(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace");
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $a20be49b574e35ab$var$J[a] = new $a20be49b574e35ab$var$I(a, 1, !1, a.toLowerCase(), null);
});
var $a20be49b574e35ab$var$ta = /["'&<>]/;
function $a20be49b574e35ab$var$M(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $a20be49b574e35ab$var$ta.exec(a);
    if (b) {
        var d = "", c, f = 0;
        for(c = b.index; c < a.length; c++){
            switch(a.charCodeAt(c)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== c && (d += a.substring(f, c));
            f = c + 1;
            d += b;
        }
        a = f !== c ? d + a.substring(f, c) : d;
    }
    return a;
}
var $a20be49b574e35ab$var$N = null, $a20be49b574e35ab$var$O = null, $a20be49b574e35ab$var$P = null, $a20be49b574e35ab$var$Q = !1, $a20be49b574e35ab$var$S = !1, $a20be49b574e35ab$var$T = null, $a20be49b574e35ab$var$U = 0;
function $a20be49b574e35ab$var$V() {
    null === $a20be49b574e35ab$var$N && $a20be49b574e35ab$var$r("321");
    return $a20be49b574e35ab$var$N;
}
function $a20be49b574e35ab$var$ua() {
    0 < $a20be49b574e35ab$var$U && $a20be49b574e35ab$var$r("312");
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $a20be49b574e35ab$var$W() {
    null === $a20be49b574e35ab$var$P ? null === $a20be49b574e35ab$var$O ? ($a20be49b574e35ab$var$Q = !1, $a20be49b574e35ab$var$O = $a20be49b574e35ab$var$P = $a20be49b574e35ab$var$ua()) : ($a20be49b574e35ab$var$Q = !0, $a20be49b574e35ab$var$P = $a20be49b574e35ab$var$O) : null === $a20be49b574e35ab$var$P.next ? ($a20be49b574e35ab$var$Q = !1, $a20be49b574e35ab$var$P = $a20be49b574e35ab$var$P.next = $a20be49b574e35ab$var$ua()) : ($a20be49b574e35ab$var$Q = !0, $a20be49b574e35ab$var$P = $a20be49b574e35ab$var$P.next);
    return $a20be49b574e35ab$var$P;
}
function $a20be49b574e35ab$var$va(a, b, d, c) {
    for(; $a20be49b574e35ab$var$S;)$a20be49b574e35ab$var$S = !1, $a20be49b574e35ab$var$U += 1, $a20be49b574e35ab$var$P = null, d = a(b, c);
    $a20be49b574e35ab$var$O = $a20be49b574e35ab$var$N = null;
    $a20be49b574e35ab$var$U = 0;
    $a20be49b574e35ab$var$P = $a20be49b574e35ab$var$T = null;
    return d;
}
function $a20be49b574e35ab$var$wa(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $a20be49b574e35ab$var$xa(a, b, d) {
    $a20be49b574e35ab$var$N = $a20be49b574e35ab$var$V();
    $a20be49b574e35ab$var$P = $a20be49b574e35ab$var$W();
    if ($a20be49b574e35ab$var$Q) {
        var c = $a20be49b574e35ab$var$P.queue;
        b = c.dispatch;
        if (null !== $a20be49b574e35ab$var$T && (d = $a20be49b574e35ab$var$T.get(c), void 0 !== d)) {
            $a20be49b574e35ab$var$T.delete(c);
            c = $a20be49b574e35ab$var$P.memoizedState;
            do c = a(c, d.action), d = d.next;
            while (null !== d);
            $a20be49b574e35ab$var$P.memoizedState = c;
            return [
                c,
                b
            ];
        }
        return [
            $a20be49b574e35ab$var$P.memoizedState,
            b
        ];
    }
    a = a === $a20be49b574e35ab$var$wa ? "function" === typeof b ? b() : b : void 0 !== d ? d(b) : b;
    $a20be49b574e35ab$var$P.memoizedState = a;
    a = $a20be49b574e35ab$var$P.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $a20be49b574e35ab$var$ya.bind(null, $a20be49b574e35ab$var$N, a);
    return [
        $a20be49b574e35ab$var$P.memoizedState,
        a
    ];
}
function $a20be49b574e35ab$var$ya(a, b, d) {
    25 > $a20be49b574e35ab$var$U || $a20be49b574e35ab$var$r("301");
    if (a === $a20be49b574e35ab$var$N) {
        if ($a20be49b574e35ab$var$S = !0, a = {
            action: d,
            next: null
        }, null === $a20be49b574e35ab$var$T && ($a20be49b574e35ab$var$T = new Map), d = $a20be49b574e35ab$var$T.get(b), void 0 === d) $a20be49b574e35ab$var$T.set(b, a);
        else {
            for(b = d; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $a20be49b574e35ab$var$za() {}
var $a20be49b574e35ab$var$X = 0, $a20be49b574e35ab$var$Aa = {
    readContext: function(a) {
        var b = $a20be49b574e35ab$var$X;
        $a20be49b574e35ab$var$F(a, b);
        return a[b];
    },
    useContext: function(a) {
        $a20be49b574e35ab$var$V();
        var b = $a20be49b574e35ab$var$X;
        $a20be49b574e35ab$var$F(a, b);
        return a[b];
    },
    useMemo: function(a, b) {
        $a20be49b574e35ab$var$N = $a20be49b574e35ab$var$V();
        $a20be49b574e35ab$var$P = $a20be49b574e35ab$var$W();
        b = void 0 === b ? null : b;
        if (null !== $a20be49b574e35ab$var$P) {
            var d = $a20be49b574e35ab$var$P.memoizedState;
            if (null !== d && null !== b) {
                a: {
                    var c = d[1];
                    if (null === c) c = !1;
                    else {
                        for(var f = 0; f < c.length && f < b.length; f++){
                            var e = b[f], h = c[f];
                            if ((e !== h || 0 === e && 1 / e !== 1 / h) && (e === e || h === h)) {
                                c = !1;
                                break a;
                            }
                        }
                        c = !0;
                    }
                }
                if (c) return d[0];
            }
        }
        a = a();
        $a20be49b574e35ab$var$P.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: $a20be49b574e35ab$var$xa,
    useRef: function(a) {
        $a20be49b574e35ab$var$N = $a20be49b574e35ab$var$V();
        $a20be49b574e35ab$var$P = $a20be49b574e35ab$var$W();
        var b = $a20be49b574e35ab$var$P.memoizedState;
        return null === b ? (a = {
            current: a
        }, $a20be49b574e35ab$var$P.memoizedState = a) : b;
    },
    useState: function(a) {
        return $a20be49b574e35ab$var$xa($a20be49b574e35ab$var$wa, a);
    },
    useLayoutEffect: function() {},
    useCallback: function(a) {
        return a;
    },
    useImperativeHandle: $a20be49b574e35ab$var$za,
    useEffect: $a20be49b574e35ab$var$za,
    useDebugValue: $a20be49b574e35ab$var$za
}, $a20be49b574e35ab$var$Ba = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function $a20be49b574e35ab$var$Ca(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
var $a20be49b574e35ab$var$Da = {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
}, $a20be49b574e35ab$var$Ea = $63ReS({
    menuitem: !0
}, $a20be49b574e35ab$var$Da), $a20be49b574e35ab$var$Y = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $a20be49b574e35ab$var$Fa = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($a20be49b574e35ab$var$Y).forEach(function(a) {
    $a20be49b574e35ab$var$Fa.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $a20be49b574e35ab$var$Y[b] = $a20be49b574e35ab$var$Y[a];
    });
});
var $a20be49b574e35ab$var$Ga = /([A-Z])/g, $a20be49b574e35ab$var$Ha = /^ms-/, $a20be49b574e35ab$var$Z = $6wXVr.Children.toArray, $a20be49b574e35ab$var$Ia = $a20be49b574e35ab$var$E.ReactCurrentDispatcher, $a20be49b574e35ab$var$Ja = {
    listing: !0,
    pre: !0,
    textarea: !0
}, $a20be49b574e35ab$var$Ka = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $a20be49b574e35ab$var$La = {}, $a20be49b574e35ab$var$Ma = {};
function $a20be49b574e35ab$var$Na(a) {
    if (void 0 === a || null === a) return a;
    var b = "";
    $6wXVr.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
var $a20be49b574e35ab$var$Oa = Object.prototype.hasOwnProperty, $a20be49b574e35ab$var$Pa = {
    children: null,
    dangerouslySetInnerHTML: null,
    suppressContentEditableWarning: null,
    suppressHydrationWarning: null
};
function $a20be49b574e35ab$var$Qa(a, b) {
    void 0 === a && $a20be49b574e35ab$var$r("152", $a20be49b574e35ab$var$C(b) || "Component");
}
function $a20be49b574e35ab$var$Ra(a, b, d) {
    function c(c, f) {
        var e = $a20be49b574e35ab$var$la(f, b, d), g = [], h = !1, l = {
            isMounted: function() {
                return !1;
            },
            enqueueForceUpdate: function() {
                if (null === g) return null;
            },
            enqueueReplaceState: function(a, b) {
                h = !0;
                g = [
                    b
                ];
            },
            enqueueSetState: function(a, b) {
                if (null === g) return null;
                g.push(b);
            }
        }, k = void 0;
        if (f.prototype && f.prototype.isReactComponent) {
            if (k = new f(c.props, e, l), "function" === typeof f.getDerivedStateFromProps) {
                var t = f.getDerivedStateFromProps.call(null, c.props, k.state);
                null != t && (k.state = $63ReS({}, k.state, t));
            }
        } else if ($a20be49b574e35ab$var$N = {}, k = f(c.props, e, l), k = $a20be49b574e35ab$var$va(f, c.props, k, e), null == k || null == k.render) {
            a = k;
            $a20be49b574e35ab$var$Qa(a, f);
            return;
        }
        k.props = c.props;
        k.context = e;
        k.updater = l;
        l = k.state;
        void 0 === l && (k.state = l = null);
        if ("function" === typeof k.UNSAFE_componentWillMount || "function" === typeof k.componentWillMount) {
            if ("function" === typeof k.componentWillMount && "function" !== typeof f.getDerivedStateFromProps && k.componentWillMount(), "function" === typeof k.UNSAFE_componentWillMount && "function" !== typeof f.getDerivedStateFromProps && k.UNSAFE_componentWillMount(), g.length) {
                l = g;
                var m = h;
                g = null;
                h = !1;
                if (m && 1 === l.length) k.state = l[0];
                else {
                    t = m ? l[0] : k.state;
                    var u = !0;
                    for(m = m ? 1 : 0; m < l.length; m++){
                        var w = l[m];
                        w = "function" === typeof w ? w.call(k, t, c.props, e) : w;
                        null != w && (u ? (u = !1, t = $63ReS({}, t, w)) : $63ReS(t, w));
                    }
                    k.state = t;
                }
            } else g = null;
        }
        a = k.render();
        $a20be49b574e35ab$var$Qa(a, f);
        c = void 0;
        if ("function" === typeof k.getChildContext && (e = f.childContextTypes, "object" === typeof e)) {
            c = k.getChildContext();
            for(var R in c)R in e || $a20be49b574e35ab$var$r("108", $a20be49b574e35ab$var$C(f) || "Unknown", R);
        }
        c && (b = $63ReS({}, b, c));
    }
    for(; $6wXVr.isValidElement(a);){
        var f = a, e = f.type;
        if ("function" !== typeof e) break;
        c(f, e);
    }
    return {
        child: a,
        context: b
    };
}
var $a20be49b574e35ab$var$Sa = function() {
    function a(b, d) {
        if (!(this instanceof a)) throw new TypeError("Cannot call a class as a function");
        $6wXVr.isValidElement(b) ? b.type !== $a20be49b574e35ab$var$x ? b = [
            b
        ] : (b = b.props.children, b = $6wXVr.isValidElement(b) ? [
            b
        ] : $a20be49b574e35ab$var$Z(b)) : b = $a20be49b574e35ab$var$Z(b);
        b = {
            type: null,
            domNamespace: $a20be49b574e35ab$var$Ba.html,
            children: b,
            childIndex: 0,
            context: $a20be49b574e35ab$var$ka,
            footer: ""
        };
        var c = $a20be49b574e35ab$var$G[0];
        if (0 === c) {
            var f = $a20be49b574e35ab$var$G;
            c = f.length;
            var e = 2 * c;
            65536 >= e || $a20be49b574e35ab$var$r("304");
            var h = new Uint16Array(e);
            h.set(f);
            $a20be49b574e35ab$var$G = h;
            $a20be49b574e35ab$var$G[0] = c + 1;
            for(f = c; f < e - 1; f++)$a20be49b574e35ab$var$G[f] = f + 1;
            $a20be49b574e35ab$var$G[e - 1] = 0;
        } else $a20be49b574e35ab$var$G[0] = $a20be49b574e35ab$var$G[c];
        this.threadID = c;
        this.stack = [
            b
        ];
        this.exhausted = !1;
        this.currentSelectValue = null;
        this.previousWasTextNode = !1;
        this.makeStaticMarkup = d;
        this.suspenseDepth = 0;
        this.contextIndex = -1;
        this.contextStack = [];
        this.contextValueStack = [];
    }
    a.prototype.destroy = function() {
        if (!this.exhausted) {
            this.exhausted = !0;
            this.clearProviders();
            var a = this.threadID;
            $a20be49b574e35ab$var$G[a] = $a20be49b574e35ab$var$G[0];
            $a20be49b574e35ab$var$G[0] = a;
        }
    };
    a.prototype.pushProvider = function(a) {
        var b = ++this.contextIndex, c = a.type._context, f = this.threadID;
        $a20be49b574e35ab$var$F(c, f);
        var e = c[f];
        this.contextStack[b] = c;
        this.contextValueStack[b] = e;
        c[f] = a.props.value;
    };
    a.prototype.popProvider = function() {
        var a = this.contextIndex, d = this.contextStack[a], c = this.contextValueStack[a];
        this.contextStack[a] = null;
        this.contextValueStack[a] = null;
        this.contextIndex--;
        d[this.threadID] = c;
    };
    a.prototype.clearProviders = function() {
        for(var a = this.contextIndex; 0 <= a; a--)this.contextStack[a][this.threadID] = this.contextValueStack[a];
    };
    a.prototype.read = function(a) {
        if (this.exhausted) return null;
        var b = $a20be49b574e35ab$var$X;
        $a20be49b574e35ab$var$X = this.threadID;
        var c = $a20be49b574e35ab$var$Ia.current;
        $a20be49b574e35ab$var$Ia.current = $a20be49b574e35ab$var$Aa;
        try {
            for(var f = [
                ""
            ], e = !1; f[0].length < a;){
                if (0 === this.stack.length) {
                    this.exhausted = !0;
                    var h = this.threadID;
                    $a20be49b574e35ab$var$G[h] = $a20be49b574e35ab$var$G[0];
                    $a20be49b574e35ab$var$G[0] = h;
                    break;
                }
                var g = this.stack[this.stack.length - 1];
                if (e || g.childIndex >= g.children.length) {
                    var D = g.footer;
                    "" !== D && (this.previousWasTextNode = !1);
                    this.stack.pop();
                    if ("select" === g.type) this.currentSelectValue = null;
                    else if (null != g.type && null != g.type.type && g.type.type.$$typeof === $a20be49b574e35ab$var$z) this.popProvider(g.type);
                    else if (g.type === $a20be49b574e35ab$var$A) {
                        this.suspenseDepth--;
                        var B = f.pop();
                        if (e) {
                            e = !1;
                            var n = g.fallbackFrame;
                            n || $a20be49b574e35ab$var$r("303");
                            this.stack.push(n);
                            continue;
                        } else f[this.suspenseDepth] += B;
                    }
                    f[this.suspenseDepth] += D;
                } else {
                    var l = g.children[g.childIndex++], k = "";
                    try {
                        k += this.render(l, g.context, g.domNamespace);
                    } catch (t) {
                        throw t;
                    } finally{}
                    f.length <= this.suspenseDepth && f.push("");
                    f[this.suspenseDepth] += k;
                }
            }
            return f[0];
        } finally{
            $a20be49b574e35ab$var$Ia.current = c, $a20be49b574e35ab$var$X = b;
        }
    };
    a.prototype.render = function(a, d, c) {
        if ("string" === typeof a || "number" === typeof a) {
            c = "" + a;
            if ("" === c) return "";
            if (this.makeStaticMarkup) return $a20be49b574e35ab$var$M(c);
            if (this.previousWasTextNode) return "\x3c!-- --\x3e" + $a20be49b574e35ab$var$M(c);
            this.previousWasTextNode = !0;
            return $a20be49b574e35ab$var$M(c);
        }
        d = $a20be49b574e35ab$var$Ra(a, d, this.threadID);
        a = d.child;
        d = d.context;
        if (null === a || !1 === a) return "";
        if (!$6wXVr.isValidElement(a)) {
            if (null != a && null != a.$$typeof) {
                var b = a.$$typeof;
                b === $a20be49b574e35ab$var$ba && $a20be49b574e35ab$var$r("257");
                $a20be49b574e35ab$var$r("258", b.toString());
            }
            a = $a20be49b574e35ab$var$Z(a);
            this.stack.push({
                type: null,
                domNamespace: c,
                children: a,
                childIndex: 0,
                context: d,
                footer: ""
            });
            return "";
        }
        b = a.type;
        if ("string" === typeof b) return this.renderDOM(a, d, c);
        switch(b){
            case $a20be49b574e35ab$var$ca:
            case $a20be49b574e35ab$var$fa:
            case $a20be49b574e35ab$var$da:
            case $a20be49b574e35ab$var$x:
                return a = $a20be49b574e35ab$var$Z(a.props.children), this.stack.push({
                    type: null,
                    domNamespace: c,
                    children: a,
                    childIndex: 0,
                    context: d,
                    footer: ""
                }), "";
            case $a20be49b574e35ab$var$A:
                $a20be49b574e35ab$var$r("294");
        }
        if ("object" === typeof b && null !== b) switch(b.$$typeof){
            case $a20be49b574e35ab$var$ha:
                $a20be49b574e35ab$var$N = {};
                var e = b.render(a.props, a.ref);
                e = $a20be49b574e35ab$var$va(b.render, a.props, e, a.ref);
                e = $a20be49b574e35ab$var$Z(e);
                this.stack.push({
                    type: null,
                    domNamespace: c,
                    children: e,
                    childIndex: 0,
                    context: d,
                    footer: ""
                });
                return "";
            case $a20be49b574e35ab$var$ia:
                return a = [
                    $6wXVr.createElement(b.type, $63ReS({
                        ref: a.ref
                    }, a.props))
                ], this.stack.push({
                    type: null,
                    domNamespace: c,
                    children: a,
                    childIndex: 0,
                    context: d,
                    footer: ""
                }), "";
            case $a20be49b574e35ab$var$z:
                return b = $a20be49b574e35ab$var$Z(a.props.children), c = {
                    type: a,
                    domNamespace: c,
                    children: b,
                    childIndex: 0,
                    context: d,
                    footer: ""
                }, this.pushProvider(a), this.stack.push(c), "";
            case $a20be49b574e35ab$var$ea:
                b = a.type;
                e = a.props;
                var h = this.threadID;
                $a20be49b574e35ab$var$F(b, h);
                b = $a20be49b574e35ab$var$Z(e.children(b[h]));
                this.stack.push({
                    type: a,
                    domNamespace: c,
                    children: b,
                    childIndex: 0,
                    context: d,
                    footer: ""
                });
                return "";
            case $a20be49b574e35ab$var$ja:
                $a20be49b574e35ab$var$r("295");
        }
        $a20be49b574e35ab$var$r("130", null == b ? b : typeof b, "");
    };
    a.prototype.renderDOM = function(a, d, c) {
        var b = a.type.toLowerCase();
        c === $a20be49b574e35ab$var$Ba.html && $a20be49b574e35ab$var$Ca(b);
        $a20be49b574e35ab$var$La.hasOwnProperty(b) || ($a20be49b574e35ab$var$Ka.test(b) || $a20be49b574e35ab$var$r("65", b), $a20be49b574e35ab$var$La[b] = !0);
        var e = a.props;
        if ("input" === b) e = $63ReS({
            type: void 0
        }, e, {
            defaultChecked: void 0,
            defaultValue: void 0,
            value: null != e.value ? e.value : e.defaultValue,
            checked: null != e.checked ? e.checked : e.defaultChecked
        });
        else if ("textarea" === b) {
            var h = e.value;
            if (null == h) {
                h = e.defaultValue;
                var g = e.children;
                null != g && (null != h && $a20be49b574e35ab$var$r("92"), Array.isArray(g) && (1 >= g.length || $a20be49b574e35ab$var$r("93"), g = g[0]), h = "" + g);
                null == h && (h = "");
            }
            e = $63ReS({}, e, {
                value: void 0,
                children: "" + h
            });
        } else if ("select" === b) this.currentSelectValue = null != e.value ? e.value : e.defaultValue, e = $63ReS({}, e, {
            value: void 0
        });
        else if ("option" === b) {
            g = this.currentSelectValue;
            var D = $a20be49b574e35ab$var$Na(e.children);
            if (null != g) {
                var B = null != e.value ? e.value + "" : D;
                h = !1;
                if (Array.isArray(g)) {
                    for(var n = 0; n < g.length; n++)if ("" + g[n] === B) {
                        h = !0;
                        break;
                    }
                } else h = "" + g === B;
                e = $63ReS({
                    selected: void 0,
                    children: void 0
                }, e, {
                    selected: h,
                    children: D
                });
            }
        }
        if (h = e) $a20be49b574e35ab$var$Ea[b] && (null != h.children || null != h.dangerouslySetInnerHTML) && $a20be49b574e35ab$var$r("137", b, ""), null != h.dangerouslySetInnerHTML && (null != h.children && $a20be49b574e35ab$var$r("60"), "object" === typeof h.dangerouslySetInnerHTML && "__html" in h.dangerouslySetInnerHTML || $a20be49b574e35ab$var$r("61")), null != h.style && "object" !== typeof h.style && $a20be49b574e35ab$var$r("62", "");
        h = e;
        g = this.makeStaticMarkup;
        D = 1 === this.stack.length;
        B = "<" + a.type;
        for(y in h)if ($a20be49b574e35ab$var$Oa.call(h, y)) {
            var l = h[y];
            if (null != l) {
                if ("style" === y) {
                    n = void 0;
                    var k = "", t = "";
                    for(n in l)if (l.hasOwnProperty(n)) {
                        var m = 0 === n.indexOf("--"), u = l[n];
                        if (null != u) {
                            var w = n;
                            if ($a20be49b574e35ab$var$Ma.hasOwnProperty(w)) w = $a20be49b574e35ab$var$Ma[w];
                            else {
                                var R = w.replace($a20be49b574e35ab$var$Ga, "-$1").toLowerCase().replace($a20be49b574e35ab$var$Ha, "-ms-");
                                w = $a20be49b574e35ab$var$Ma[w] = R;
                            }
                            k += t + w + ":";
                            t = n;
                            m = null == u || "boolean" === typeof u || "" === u ? "" : m || "number" !== typeof u || 0 === u || $a20be49b574e35ab$var$Y.hasOwnProperty(t) && $a20be49b574e35ab$var$Y[t] ? ("" + u).trim() : u + "px";
                            k += m;
                            t = ";";
                        }
                    }
                    l = k || null;
                }
                n = null;
                b: if (m = b, u = h, -1 === m.indexOf("-")) m = "string" === typeof u.is;
                else switch(m){
                    case "annotation-xml":
                    case "color-profile":
                    case "font-face":
                    case "font-face-src":
                    case "font-face-uri":
                    case "font-face-format":
                    case "font-face-name":
                    case "missing-glyph":
                        m = !1;
                        break b;
                    default:
                        m = !0;
                }
                if (m) $a20be49b574e35ab$var$Pa.hasOwnProperty(y) || (n = y, n = $a20be49b574e35ab$var$qa(n) && null != l ? n + "=" + ('"' + $a20be49b574e35ab$var$M(l) + '"') : "");
                else {
                    m = y;
                    n = l;
                    l = $a20be49b574e35ab$var$J.hasOwnProperty(m) ? $a20be49b574e35ab$var$J[m] : null;
                    if (u = "style" !== m) u = null !== l ? 0 === l.type : !(2 < m.length) || "o" !== m[0] && "O" !== m[0] || "n" !== m[1] && "N" !== m[1] ? !1 : !0;
                    u || $a20be49b574e35ab$var$sa(m, n, l, !1) ? n = "" : null !== l ? (m = l.attributeName, l = l.type, n = 3 === l || 4 === l && !0 === n ? m + '=""' : m + "=" + ('"' + $a20be49b574e35ab$var$M(n) + '"')) : n = $a20be49b574e35ab$var$qa(m) ? m + "=" + ('"' + $a20be49b574e35ab$var$M(n) + '"') : "";
                }
                n && (B += " " + n);
            }
        }
        g || D && (B += ' data-reactroot=""');
        var y = B;
        h = "";
        $a20be49b574e35ab$var$Da.hasOwnProperty(b) ? y += "/>" : (y += ">", h = "</" + a.type + ">");
        a: {
            g = e.dangerouslySetInnerHTML;
            if (null != g) {
                if (null != g.__html) {
                    g = g.__html;
                    break a;
                }
            } else if (g = e.children, "string" === typeof g || "number" === typeof g) {
                g = $a20be49b574e35ab$var$M(g);
                break a;
            }
            g = null;
        }
        null != g ? (e = [], $a20be49b574e35ab$var$Ja[b] && "\n" === g.charAt(0) && (y += "\n"), y += g) : e = $a20be49b574e35ab$var$Z(e.children);
        a = a.type;
        c = null == c || "http://www.w3.org/1999/xhtml" === c ? $a20be49b574e35ab$var$Ca(a) : "http://www.w3.org/2000/svg" === c && "foreignObject" === a ? "http://www.w3.org/1999/xhtml" : c;
        this.stack.push({
            domNamespace: c,
            type: b,
            children: e,
            childIndex: 0,
            context: d,
            footer: h
        });
        this.previousWasTextNode = !1;
        return y;
    };
    return a;
}(), $a20be49b574e35ab$var$Ta = {
    renderToString: function(a) {
        a = new $a20be49b574e35ab$var$Sa(a, !1);
        try {
            return a.read(Infinity);
        } finally{
            a.destroy();
        }
    },
    renderToStaticMarkup: function(a) {
        a = new $a20be49b574e35ab$var$Sa(a, !0);
        try {
            return a.read(Infinity);
        } finally{
            a.destroy();
        }
    },
    renderToNodeStream: function() {
        $a20be49b574e35ab$var$r("207");
    },
    renderToStaticNodeStream: function() {
        $a20be49b574e35ab$var$r("208");
    },
    version: "16.8.6"
}, $a20be49b574e35ab$var$Ua = {
    default: $a20be49b574e35ab$var$Ta
}, $a20be49b574e35ab$var$Va = $a20be49b574e35ab$var$Ua && $a20be49b574e35ab$var$Ta || $a20be49b574e35ab$var$Ua;
module.exports = $a20be49b574e35ab$var$Va.default || $a20be49b574e35ab$var$Va;

});

parcelRegister("djpOD", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("d88yw")).source;
    re.src_Cc = (parcelRequire("1KJbe")).source;
    re.src_Z = (parcelRequire("dZtKE")).source;
    re.src_P = (parcelRequire("eNm53")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,4}[a-zA-Z0-9%/]|' + // github has ... in commit range links,
    // google has .... in links (issue #66)
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});
parcelRegister("d88yw", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("1KJbe", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("dZtKE", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

});

parcelRegister("eNm53", function(module, exports) {
module.exports = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});


parcelRegister("k0VX2", function(module, exports) {
exports = module.exports = function(bytes) {
    var i = 0;
    while(i < bytes.length){
        if (bytes[i] == 0x09 || bytes[i] == 0x0A || bytes[i] == 0x0D || 0x20 <= bytes[i] && bytes[i] <= 0x7E) {
            i += 1;
            continue;
        }
        if (0xC2 <= bytes[i] && bytes[i] <= 0xDF && 0x80 <= bytes[i + 1] && bytes[i + 1] <= 0xBF) {
            i += 2;
            continue;
        }
        if (bytes[i] == 0xE0 && 0xA0 <= bytes[i + 1] && bytes[i + 1] <= 0xBF && 0x80 <= bytes[i + 2] && bytes[i + 2] <= 0xBF || (0xE1 <= bytes[i] && bytes[i] <= 0xEC || bytes[i] == 0xEE || bytes[i] == 0xEF) && 0x80 <= bytes[i + 1] && bytes[i + 1] <= 0xBF && 0x80 <= bytes[i + 2] && bytes[i + 2] <= 0xBF || bytes[i] == 0xED && 0x80 <= bytes[i + 1] && bytes[i + 1] <= 0x9F && 0x80 <= bytes[i + 2] && bytes[i + 2] <= 0xBF) {
            i += 3;
            continue;
        }
        if (bytes[i] == 0xF0 && 0x90 <= bytes[i + 1] && bytes[i + 1] <= 0xBF && 0x80 <= bytes[i + 2] && bytes[i + 2] <= 0xBF && 0x80 <= bytes[i + 3] && bytes[i + 3] <= 0xBF || 0xF1 <= bytes[i] && bytes[i] <= 0xF3 && 0x80 <= bytes[i + 1] && bytes[i + 1] <= 0xBF && 0x80 <= bytes[i + 2] && bytes[i + 2] <= 0xBF && 0x80 <= bytes[i + 3] && bytes[i + 3] <= 0xBF || bytes[i] == 0xF4 && 0x80 <= bytes[i + 1] && bytes[i + 1] <= 0x8F && 0x80 <= bytes[i + 2] && bytes[i + 2] <= 0xBF && 0x80 <= bytes[i + 3] && bytes[i + 3] <= 0xBF) {
            i += 4;
            continue;
        }
        return false;
    }
    return true;
};

});

parcelRegister("hObpn", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $lsQhA = parcelRequire("lsQhA");
'use strict';
function $cf6ff49cf8f07b77$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $cf6ff49cf8f07b77$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cf6ff49cf8f07b77$var$_typeof(o);
}
function $cf6ff49cf8f07b77$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $cf6ff49cf8f07b77$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $cf6ff49cf8f07b77$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $cf6ff49cf8f07b77$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cf6ff49cf8f07b77$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $cf6ff49cf8f07b77$var$_toPropertyKey(arg) {
    var key = $cf6ff49cf8f07b77$var$_toPrimitive(arg, "string");
    return $cf6ff49cf8f07b77$var$_typeof(key) === "symbol" ? key : String(key);
}
function $cf6ff49cf8f07b77$var$_toPrimitive(input, hint) {
    if ($cf6ff49cf8f07b77$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($cf6ff49cf8f07b77$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $cf6ff49cf8f07b77$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $93pP4 = parcelRequire("93pP4");
var $cf6ff49cf8f07b77$var$_require$codes = $93pP4.codes, $cf6ff49cf8f07b77$var$ERR_AMBIGUOUS_ARGUMENT = $cf6ff49cf8f07b77$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $cf6ff49cf8f07b77$var$ERR_INVALID_ARG_TYPE = $cf6ff49cf8f07b77$var$_require$codes.ERR_INVALID_ARG_TYPE, $cf6ff49cf8f07b77$var$ERR_INVALID_ARG_VALUE = $cf6ff49cf8f07b77$var$_require$codes.ERR_INVALID_ARG_VALUE, $cf6ff49cf8f07b77$var$ERR_INVALID_RETURN_VALUE = $cf6ff49cf8f07b77$var$_require$codes.ERR_INVALID_RETURN_VALUE, $cf6ff49cf8f07b77$var$ERR_MISSING_ARGS = $cf6ff49cf8f07b77$var$_require$codes.ERR_MISSING_ARGS;

var $k60ko = parcelRequire("k60ko");

var $3UKyI = parcelRequire("3UKyI");
var $cf6ff49cf8f07b77$var$inspect = $3UKyI.inspect;

var $3UKyI = parcelRequire("3UKyI");
var $cf6ff49cf8f07b77$require$_require$types = $3UKyI.types;
var $cf6ff49cf8f07b77$var$isPromise = $cf6ff49cf8f07b77$require$_require$types.isPromise, $cf6ff49cf8f07b77$var$isRegExp = $cf6ff49cf8f07b77$require$_require$types.isRegExp;

var $cf6ff49cf8f07b77$var$objectAssign = (parcelRequire("6zyDG"))();

var $cf6ff49cf8f07b77$var$objectIs = (parcelRequire("eyTeg"))();

var $cf6ff49cf8f07b77$var$RegExpPrototypeTest = (parcelRequire("9wHVc"))('RegExp.prototype.test');
var $cf6ff49cf8f07b77$var$errorCache = new Map();
var $cf6ff49cf8f07b77$var$isDeepEqual;
var $cf6ff49cf8f07b77$var$isDeepStrictEqual;
var $cf6ff49cf8f07b77$var$parseExpressionAt;
var $cf6ff49cf8f07b77$var$findNodeAround;
var $cf6ff49cf8f07b77$var$decoder;

function $cf6ff49cf8f07b77$var$lazyLoadComparison() {
    var comparison = (parcelRequire("PYPCO"));
    $cf6ff49cf8f07b77$var$isDeepEqual = comparison.isDeepEqual;
    $cf6ff49cf8f07b77$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $cf6ff49cf8f07b77$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $cf6ff49cf8f07b77$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    '\\b',
    '',
    '',
    "\\u000b",
    '\\f',
    '',
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $cf6ff49cf8f07b77$var$escapeFn = function escapeFn(str) {
    return $cf6ff49cf8f07b77$var$meta[str.charCodeAt(0)];
};
var $cf6ff49cf8f07b77$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $cf6ff49cf8f07b77$var$assert = module.exports = $cf6ff49cf8f07b77$var$ok;
var $cf6ff49cf8f07b77$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $cf6ff49cf8f07b77$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $k60ko(obj);
}
function $cf6ff49cf8f07b77$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = 'Failed';
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($cf6ff49cf8f07b77$var$warned === false) {
            $cf6ff49cf8f07b77$var$warned = true;
            var warn = $lsQhA.emitWarning ? $lsQhA.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
        }
        if (argsLen === 2) operator = '!=';
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? 'fail' : operator,
        stackStartFn: stackStartFn || $cf6ff49cf8f07b77$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $k60ko(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$cf6ff49cf8f07b77$var$assert.fail = $cf6ff49cf8f07b77$var$fail;
// The AssertionError is defined in internal/error.
$cf6ff49cf8f07b77$var$assert.AssertionError = $k60ko;
function $cf6ff49cf8f07b77$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = 'No value argument passed to `assert.ok()`';
        } else if (message instanceof Error) throw message;
        var err = new $k60ko({
            actual: value,
            expected: true,
            message: message,
            operator: '==',
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $cf6ff49cf8f07b77$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $cf6ff49cf8f07b77$var$innerOk.apply(void 0, [
        $cf6ff49cf8f07b77$var$ok,
        args.length
    ].concat(args));
}
$cf6ff49cf8f07b77$var$assert.ok = $cf6ff49cf8f07b77$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $cf6ff49cf8f07b77$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $cf6ff49cf8f07b77$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $cf6ff49cf8f07b77$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '==',
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$cf6ff49cf8f07b77$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $cf6ff49cf8f07b77$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $cf6ff49cf8f07b77$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '!=',
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$cf6ff49cf8f07b77$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $cf6ff49cf8f07b77$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($cf6ff49cf8f07b77$var$isDeepEqual === undefined) $cf6ff49cf8f07b77$var$lazyLoadComparison();
    if (!$cf6ff49cf8f07b77$var$isDeepEqual(actual, expected)) $cf6ff49cf8f07b77$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepEqual',
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$cf6ff49cf8f07b77$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $cf6ff49cf8f07b77$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($cf6ff49cf8f07b77$var$isDeepEqual === undefined) $cf6ff49cf8f07b77$var$lazyLoadComparison();
    if ($cf6ff49cf8f07b77$var$isDeepEqual(actual, expected)) $cf6ff49cf8f07b77$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepEqual',
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $cf6ff49cf8f07b77$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $cf6ff49cf8f07b77$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($cf6ff49cf8f07b77$var$isDeepEqual === undefined) $cf6ff49cf8f07b77$var$lazyLoadComparison();
    if (!$cf6ff49cf8f07b77$var$isDeepStrictEqual(actual, expected)) $cf6ff49cf8f07b77$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepStrictEqual',
        stackStartFn: deepStrictEqual
    });
};
$cf6ff49cf8f07b77$var$assert.notDeepStrictEqual = $cf6ff49cf8f07b77$var$notDeepStrictEqual;
function $cf6ff49cf8f07b77$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $cf6ff49cf8f07b77$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($cf6ff49cf8f07b77$var$isDeepEqual === undefined) $cf6ff49cf8f07b77$var$lazyLoadComparison();
    if ($cf6ff49cf8f07b77$var$isDeepStrictEqual(actual, expected)) $cf6ff49cf8f07b77$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepStrictEqual',
        stackStartFn: $cf6ff49cf8f07b77$var$notDeepStrictEqual
    });
}
$cf6ff49cf8f07b77$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $cf6ff49cf8f07b77$var$ERR_MISSING_ARGS('actual', 'expected');
    if (!$cf6ff49cf8f07b77$var$objectIs(actual, expected)) $cf6ff49cf8f07b77$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'strictEqual',
        stackStartFn: strictEqual
    });
};
$cf6ff49cf8f07b77$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $cf6ff49cf8f07b77$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($cf6ff49cf8f07b77$var$objectIs(actual, expected)) $cf6ff49cf8f07b77$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notStrictEqual',
        stackStartFn: notStrictEqual
    });
};
var $cf6ff49cf8f07b77$var$Comparison = /*#__PURE__*/ $cf6ff49cf8f07b77$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $cf6ff49cf8f07b77$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === 'string' && $cf6ff49cf8f07b77$var$isRegExp(obj[key]) && $cf6ff49cf8f07b77$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $cf6ff49cf8f07b77$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$cf6ff49cf8f07b77$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $cf6ff49cf8f07b77$var$Comparison(actual, keys);
            var b = new $cf6ff49cf8f07b77$var$Comparison(expected, keys, actual);
            var err = new $k60ko({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $cf6ff49cf8f07b77$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $cf6ff49cf8f07b77$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== 'function') {
        if ($cf6ff49cf8f07b77$var$isRegExp(expected)) return $cf6ff49cf8f07b77$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $cf6ff49cf8f07b77$var$ERR_INVALID_ARG_TYPE('expected', [
            'Function',
            'RegExp'
        ], expected);
        // Handle primitives properly.
        if ($cf6ff49cf8f07b77$var$_typeof(actual) !== 'object' || actual === null) {
            var err = new $k60ko({
                actual: actual,
                expected: expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push('name', 'message');
        else if (keys.length === 0) throw new $cf6ff49cf8f07b77$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
        if ($cf6ff49cf8f07b77$var$isDeepEqual === undefined) $cf6ff49cf8f07b77$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === 'string' && $cf6ff49cf8f07b77$var$isRegExp(expected[key]) && $cf6ff49cf8f07b77$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $cf6ff49cf8f07b77$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $cf6ff49cf8f07b77$var$getActual(fn) {
    if (typeof fn !== 'function') throw new $cf6ff49cf8f07b77$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $cf6ff49cf8f07b77$var$NO_EXCEPTION_SENTINEL;
}
function $cf6ff49cf8f07b77$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $cf6ff49cf8f07b77$var$isPromise(obj) || obj !== null && $cf6ff49cf8f07b77$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function $cf6ff49cf8f07b77$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === 'function') {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$cf6ff49cf8f07b77$var$checkIsPromise(resultPromise)) throw new $cf6ff49cf8f07b77$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
        } else if ($cf6ff49cf8f07b77$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $cf6ff49cf8f07b77$var$ERR_INVALID_ARG_TYPE('promiseFn', [
            'Function',
            'Promise'
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $cf6ff49cf8f07b77$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $cf6ff49cf8f07b77$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === 'string') {
        if (arguments.length === 4) throw new $cf6ff49cf8f07b77$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if ($cf6ff49cf8f07b77$var$_typeof(actual) === 'object' && actual !== null) {
            if (actual.message === error) throw new $cf6ff49cf8f07b77$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
        } else if (actual === error) throw new $cf6ff49cf8f07b77$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
        message = error;
        error = undefined;
    } else if (error != null && $cf6ff49cf8f07b77$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $cf6ff49cf8f07b77$var$ERR_INVALID_ARG_TYPE('error', [
        'Object',
        'Error',
        'Function',
        'RegExp'
    ], error);
    if (actual === $cf6ff49cf8f07b77$var$NO_EXCEPTION_SENTINEL) {
        var details = '';
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
        $cf6ff49cf8f07b77$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$cf6ff49cf8f07b77$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $cf6ff49cf8f07b77$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $cf6ff49cf8f07b77$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === 'string') {
        message = error;
        error = undefined;
    }
    if (!error || $cf6ff49cf8f07b77$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
        $cf6ff49cf8f07b77$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$cf6ff49cf8f07b77$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $cf6ff49cf8f07b77$var$expectsError.apply(void 0, [
        throws,
        $cf6ff49cf8f07b77$var$getActual(promiseFn)
    ].concat(args));
};
$cf6ff49cf8f07b77$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $cf6ff49cf8f07b77$var$waitForActual(promiseFn).then(function(result) {
        return $cf6ff49cf8f07b77$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$cf6ff49cf8f07b77$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $cf6ff49cf8f07b77$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $cf6ff49cf8f07b77$var$getActual(fn)
    ].concat(args));
};
$cf6ff49cf8f07b77$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $cf6ff49cf8f07b77$var$waitForActual(fn).then(function(result) {
        return $cf6ff49cf8f07b77$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$cf6ff49cf8f07b77$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = 'ifError got unwanted exception: ';
        if ($cf6ff49cf8f07b77$var$_typeof(err) === 'object' && typeof err.message === 'string') {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $cf6ff49cf8f07b77$var$inspect(err);
        var newErr = new $k60ko({
            actual: err,
            expected: null,
            operator: 'ifError',
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === 'string') {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split('\n');
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split('\n');
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $cf6ff49cf8f07b77$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$cf6ff49cf8f07b77$var$isRegExp(regexp)) throw new $cf6ff49cf8f07b77$var$ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
    var match = fnName === 'match';
    if (typeof string !== 'string' || $cf6ff49cf8f07b77$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat($cf6ff49cf8f07b77$var$_typeof(string), " (").concat($cf6ff49cf8f07b77$var$inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat($cf6ff49cf8f07b77$var$inspect(regexp), ". Input:\n\n").concat($cf6ff49cf8f07b77$var$inspect(string), "\n"));
        var err = new $k60ko({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$cf6ff49cf8f07b77$var$assert.match = function match(string, regexp, message) {
    $cf6ff49cf8f07b77$var$internalMatch(string, regexp, message, match, 'match');
};
$cf6ff49cf8f07b77$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $cf6ff49cf8f07b77$var$internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
};
// Expose a strict only variant of assert
function $cf6ff49cf8f07b77$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $cf6ff49cf8f07b77$var$innerOk.apply(void 0, [
        $cf6ff49cf8f07b77$var$strict,
        args.length
    ].concat(args));
}
$cf6ff49cf8f07b77$var$assert.strict = $cf6ff49cf8f07b77$var$objectAssign($cf6ff49cf8f07b77$var$strict, $cf6ff49cf8f07b77$var$assert, {
    equal: $cf6ff49cf8f07b77$var$assert.strictEqual,
    deepEqual: $cf6ff49cf8f07b77$var$assert.deepStrictEqual,
    notEqual: $cf6ff49cf8f07b77$var$assert.notStrictEqual,
    notDeepEqual: $cf6ff49cf8f07b77$var$assert.notDeepStrictEqual
});
$cf6ff49cf8f07b77$var$assert.strict.strict = $cf6ff49cf8f07b77$var$assert.strict;

});
parcelRegister("93pP4", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $69786cbf4f06268b$export$e45cb6485273080e; }, function (v) { return $69786cbf4f06268b$export$e45cb6485273080e = v; });
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $69786cbf4f06268b$export$e45cb6485273080e;
'use strict';
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $69786cbf4f06268b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $69786cbf4f06268b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $69786cbf4f06268b$var$_typeof(o);
}
function $69786cbf4f06268b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $69786cbf4f06268b$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $69786cbf4f06268b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $69786cbf4f06268b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $69786cbf4f06268b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $69786cbf4f06268b$var$_toPropertyKey(arg) {
    var key = $69786cbf4f06268b$var$_toPrimitive(arg, "string");
    return $69786cbf4f06268b$var$_typeof(key) === "symbol" ? key : String(key);
}
function $69786cbf4f06268b$var$_toPrimitive(input, hint) {
    if ($69786cbf4f06268b$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($69786cbf4f06268b$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $69786cbf4f06268b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $69786cbf4f06268b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $69786cbf4f06268b$var$_setPrototypeOf(subClass, superClass);
}
function $69786cbf4f06268b$var$_setPrototypeOf(o, p) {
    $69786cbf4f06268b$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $69786cbf4f06268b$var$_setPrototypeOf(o, p);
}
function $69786cbf4f06268b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $69786cbf4f06268b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $69786cbf4f06268b$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $69786cbf4f06268b$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $69786cbf4f06268b$var$_possibleConstructorReturn(this, result);
    };
}
function $69786cbf4f06268b$var$_possibleConstructorReturn(self, call) {
    if (call && ($69786cbf4f06268b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $69786cbf4f06268b$var$_assertThisInitialized(self);
}
function $69786cbf4f06268b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $69786cbf4f06268b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $69786cbf4f06268b$var$_getPrototypeOf(o) {
    $69786cbf4f06268b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $69786cbf4f06268b$var$_getPrototypeOf(o);
}
var $69786cbf4f06268b$var$codes = {};
// Lazy loaded
var $69786cbf4f06268b$var$assert;
var $69786cbf4f06268b$var$util;
function $69786cbf4f06268b$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $69786cbf4f06268b$var$_inherits(NodeError, _Base);
        var _super = $69786cbf4f06268b$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $69786cbf4f06268b$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $69786cbf4f06268b$var$_createClass(NodeError);
    }(Base);
    $69786cbf4f06268b$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $69786cbf4f06268b$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $69786cbf4f06268b$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $69786cbf4f06268b$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $69786cbf4f06268b$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$69786cbf4f06268b$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);

$69786cbf4f06268b$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    if ($69786cbf4f06268b$var$assert === undefined) $69786cbf4f06268b$var$assert = (parcelRequire("hObpn"));
    $69786cbf4f06268b$var$assert(typeof name === 'string', "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $69786cbf4f06268b$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($69786cbf4f06268b$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($69786cbf4f06268b$var$oneOf(expected, 'type'));
    else {
        var type = $69786cbf4f06268b$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($69786cbf4f06268b$var$oneOf(expected, 'type'));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($69786cbf4f06268b$var$_typeof(actual));
    return msg;
}, TypeError);

$69786cbf4f06268b$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
    if ($69786cbf4f06268b$var$util === undefined) $69786cbf4f06268b$var$util = (parcelRequire("3UKyI"));
    var inspected = $69786cbf4f06268b$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$69786cbf4f06268b$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($69786cbf4f06268b$var$_typeof(value));
    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);

$69786cbf4f06268b$var$createErrorType('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($69786cbf4f06268b$var$assert === undefined) $69786cbf4f06268b$var$assert = (parcelRequire("hObpn"));
    $69786cbf4f06268b$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg = 'The ';
    var len = args.length;
    args = args.map(function(a) {
        return "\"".concat(a, "\"");
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(', ');
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$69786cbf4f06268b$export$e45cb6485273080e = $69786cbf4f06268b$var$codes;

});

parcelRegister("k60ko", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $lsQhA = parcelRequire("lsQhA");
'use strict';
function $ea149f4e0fa9a812$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ea149f4e0fa9a812$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ea149f4e0fa9a812$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ea149f4e0fa9a812$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ea149f4e0fa9a812$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ea149f4e0fa9a812$var$_defineProperty(obj, key, value) {
    key = $ea149f4e0fa9a812$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ea149f4e0fa9a812$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ea149f4e0fa9a812$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $ea149f4e0fa9a812$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $ea149f4e0fa9a812$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ea149f4e0fa9a812$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ea149f4e0fa9a812$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $ea149f4e0fa9a812$var$_toPropertyKey(arg) {
    var key = $ea149f4e0fa9a812$var$_toPrimitive(arg, "string");
    return $ea149f4e0fa9a812$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ea149f4e0fa9a812$var$_toPrimitive(input, hint) {
    if ($ea149f4e0fa9a812$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ea149f4e0fa9a812$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $ea149f4e0fa9a812$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $ea149f4e0fa9a812$var$_setPrototypeOf(subClass, superClass);
}
function $ea149f4e0fa9a812$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ea149f4e0fa9a812$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $ea149f4e0fa9a812$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $ea149f4e0fa9a812$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $ea149f4e0fa9a812$var$_possibleConstructorReturn(this, result);
    };
}
function $ea149f4e0fa9a812$var$_possibleConstructorReturn(self, call) {
    if (call && ($ea149f4e0fa9a812$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $ea149f4e0fa9a812$var$_assertThisInitialized(self);
}
function $ea149f4e0fa9a812$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ea149f4e0fa9a812$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $ea149f4e0fa9a812$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$ea149f4e0fa9a812$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $ea149f4e0fa9a812$var$_construct(Class, arguments, $ea149f4e0fa9a812$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $ea149f4e0fa9a812$var$_setPrototypeOf(Wrapper, Class);
    };
    return $ea149f4e0fa9a812$var$_wrapNativeSuper(Class);
}
function $ea149f4e0fa9a812$var$_construct(Parent, args, Class) {
    if ($ea149f4e0fa9a812$var$_isNativeReflectConstruct()) $ea149f4e0fa9a812$var$_construct = Reflect.construct.bind();
    else $ea149f4e0fa9a812$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $ea149f4e0fa9a812$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $ea149f4e0fa9a812$var$_construct.apply(null, arguments);
}
function $ea149f4e0fa9a812$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $ea149f4e0fa9a812$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $ea149f4e0fa9a812$var$_setPrototypeOf(o, p) {
    $ea149f4e0fa9a812$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ea149f4e0fa9a812$var$_setPrototypeOf(o, p);
}
function $ea149f4e0fa9a812$var$_getPrototypeOf(o) {
    $ea149f4e0fa9a812$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ea149f4e0fa9a812$var$_getPrototypeOf(o);
}
function $ea149f4e0fa9a812$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ea149f4e0fa9a812$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ea149f4e0fa9a812$var$_typeof(o);
}

var $3UKyI = parcelRequire("3UKyI");
var $ea149f4e0fa9a812$var$inspect = $3UKyI.inspect;

var $93pP4 = parcelRequire("93pP4");
var $ea149f4e0fa9a812$var$ERR_INVALID_ARG_TYPE = $93pP4.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $ea149f4e0fa9a812$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $ea149f4e0fa9a812$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return '';
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $ea149f4e0fa9a812$var$blue = '';
var $ea149f4e0fa9a812$var$green = '';
var $ea149f4e0fa9a812$var$red = '';
var $ea149f4e0fa9a812$var$white = '';
var $ea149f4e0fa9a812$var$kReadableOperator = {
    deepStrictEqual: 'Expected values to be strictly deep-equal:',
    strictEqual: 'Expected values to be strictly equal:',
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: 'Expected values to be loosely deep-equal:',
    equal: 'Expected values to be loosely equal:',
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: 'Values identical but not reference-equal:'
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $ea149f4e0fa9a812$var$kMaxShortLength = 10;
function $ea149f4e0fa9a812$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, 'message', {
        value: source.message
    });
    return target;
}
function $ea149f4e0fa9a812$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $ea149f4e0fa9a812$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $ea149f4e0fa9a812$var$createErrDiff(actual, expected, operator) {
    var other = '';
    var res = '';
    var lastPos = 0;
    var end = '';
    var skipped = false;
    var actualInspected = $ea149f4e0fa9a812$var$inspectValue(actual);
    var actualLines = actualInspected.split('\n');
    var expectedLines = $ea149f4e0fa9a812$var$inspectValue(expected).split('\n');
    var i = 0;
    var indicator = '';
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === 'strictEqual' && $ea149f4e0fa9a812$var$_typeof(actual) === 'object' && $ea149f4e0fa9a812$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $ea149f4e0fa9a812$var$kMaxShortLength) {
            if (($ea149f4e0fa9a812$var$_typeof(actual) !== 'object' || actual === null) && ($ea149f4e0fa9a812$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($ea149f4e0fa9a812$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== 'strictEqualObject') {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $lsQhA.stderr && $lsQhA.stderr.isTTY ? $lsQhA.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($ea149f4e0fa9a812$var$repeat(' ', i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split('\n');
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($ea149f4e0fa9a812$var$blue, "...").concat($ea149f4e0fa9a812$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($ea149f4e0fa9a812$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
    }
    if (i > 3) {
        end = "\n".concat($ea149f4e0fa9a812$var$blue, "...").concat($ea149f4e0fa9a812$var$white).concat(end);
        skipped = true;
    }
    if (other !== '') {
        end = "\n  ".concat(other).concat(end);
        other = '';
    }
    var printedLines = 0;
    var msg = $ea149f4e0fa9a812$var$kReadableOperator[operator] + "\n".concat($ea149f4e0fa9a812$var$green, "+ actual").concat($ea149f4e0fa9a812$var$white, " ").concat($ea149f4e0fa9a812$var$red, "- expected").concat($ea149f4e0fa9a812$var$white);
    var skippedMsg = " ".concat($ea149f4e0fa9a812$var$blue, "...").concat($ea149f4e0fa9a812$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($ea149f4e0fa9a812$var$blue, "...").concat($ea149f4e0fa9a812$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($ea149f4e0fa9a812$var$red, "-").concat($ea149f4e0fa9a812$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($ea149f4e0fa9a812$var$blue, "...").concat($ea149f4e0fa9a812$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($ea149f4e0fa9a812$var$green, "+").concat($ea149f4e0fa9a812$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$ea149f4e0fa9a812$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $ea149f4e0fa9a812$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($ea149f4e0fa9a812$var$blue, "...").concat($ea149f4e0fa9a812$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($ea149f4e0fa9a812$var$green, "+").concat($ea149f4e0fa9a812$var$white, " ").concat(actualLine);
                other += "\n".concat($ea149f4e0fa9a812$var$red, "-").concat($ea149f4e0fa9a812$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = '';
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($ea149f4e0fa9a812$var$blue, "...").concat($ea149f4e0fa9a812$var$white).concat(other, "\n") + "".concat($ea149f4e0fa9a812$var$blue, "...").concat($ea149f4e0fa9a812$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $ea149f4e0fa9a812$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $ea149f4e0fa9a812$var$_inherits(AssertionError, _Error);
    var _super = $ea149f4e0fa9a812$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $ea149f4e0fa9a812$var$_classCallCheck(this, AssertionError);
        if ($ea149f4e0fa9a812$var$_typeof(options) !== 'object' || options === null) throw new $ea149f4e0fa9a812$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($lsQhA.stderr && $lsQhA.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($lsQhA.stderr && $lsQhA.stderr.getColorDepth && $lsQhA.stderr.getColorDepth() !== 1) {
                    $ea149f4e0fa9a812$var$blue = "\x1B[34m";
                    $ea149f4e0fa9a812$var$green = "\x1B[32m";
                    $ea149f4e0fa9a812$var$white = "\x1B[39m";
                    $ea149f4e0fa9a812$var$red = "\x1B[31m";
                } else {
                    $ea149f4e0fa9a812$var$blue = '';
                    $ea149f4e0fa9a812$var$green = '';
                    $ea149f4e0fa9a812$var$white = '';
                    $ea149f4e0fa9a812$var$red = '';
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($ea149f4e0fa9a812$var$_typeof(actual) === 'object' && actual !== null && $ea149f4e0fa9a812$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                actual = $ea149f4e0fa9a812$var$copyError(actual);
                expected = $ea149f4e0fa9a812$var$copyError(expected);
            }
            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, $ea149f4e0fa9a812$var$createErrDiff(actual, expected, operator));
            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $ea149f4e0fa9a812$var$kReadableOperator[operator];
                var res = $ea149f4e0fa9a812$var$inspectValue(actual).split('\n');
                // In case "actual" is an object, it should not be reference equal.
                if (operator === 'notStrictEqual' && $ea149f4e0fa9a812$var$_typeof(actual) === 'object' && actual !== null) base = $ea149f4e0fa9a812$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($ea149f4e0fa9a812$var$blue, "...").concat($ea149f4e0fa9a812$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
            } else {
                var _res = $ea149f4e0fa9a812$var$inspectValue(actual);
                var other = '';
                var knownOperators = $ea149f4e0fa9a812$var$kReadableOperator[operator];
                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                    _res = "".concat($ea149f4e0fa9a812$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($ea149f4e0fa9a812$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($ea149f4e0fa9a812$var$_assertThisInitialized(_this), 'name', {
            value: 'AssertionError [ERR_ASSERTION]',
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = 'ERR_ASSERTION';
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($ea149f4e0fa9a812$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = 'AssertionError';
        return $ea149f4e0fa9a812$var$_possibleConstructorReturn(_this);
    }
    $ea149f4e0fa9a812$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $ea149f4e0fa9a812$var$inspect(this, $ea149f4e0fa9a812$var$_objectSpread($ea149f4e0fa9a812$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $ea149f4e0fa9a812$var$_wrapNativeSuper(Error), $ea149f4e0fa9a812$var$inspect.custom);
module.exports = $ea149f4e0fa9a812$var$AssertionError;

});

parcelRegister("6zyDG", function(module, exports) {
'use strict';

var $kUSua = parcelRequire("kUSua");
var $4c90e19197ce00b0$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = 'abcdefghijklmnopqrst';
    var letters = str.split('');
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = '';
    for(var k in obj)actual += k;
    return str !== actual;
};
var $4c90e19197ce00b0$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, 'xy');
    } catch (e) {
        return thrower[1] === 'y';
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $kUSua;
    if ($4c90e19197ce00b0$var$lacksProperEnumerationOrder()) return $kUSua;
    if ($4c90e19197ce00b0$var$assignHasPendingExceptions()) return $kUSua;
    return Object.assign;
};

});
parcelRegister("kUSua", function(module, exports) {
'use strict';

var $aUZSG = parcelRequire("aUZSG");

var $f3a34d50b1073c7d$var$hasSymbols = (parcelRequire("bAqIz"))();

var $7RlT5 = parcelRequire("7RlT5");

var $g17Q0 = parcelRequire("g17Q0");
var $f3a34d50b1073c7d$var$$push = $7RlT5('Array.prototype.push');
var $f3a34d50b1073c7d$var$$propIsEnumerable = $7RlT5('Object.prototype.propertyIsEnumerable');
var $f3a34d50b1073c7d$var$originalGetSymbols = $f3a34d50b1073c7d$var$hasSymbols ? $g17Q0.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError('target must be an object');
    var to = $g17Q0(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $g17Q0(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $aUZSG(from);
        var getSymbols = $f3a34d50b1073c7d$var$hasSymbols && ($g17Q0.getOwnPropertySymbols || $f3a34d50b1073c7d$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($f3a34d50b1073c7d$var$$propIsEnumerable(from, key)) $f3a34d50b1073c7d$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($f3a34d50b1073c7d$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});
parcelRegister("aUZSG", function(module, exports) {
'use strict';
var $7f2f229f89396902$var$slice = Array.prototype.slice;

var $1X2ck = parcelRequire("1X2ck");
var $7f2f229f89396902$var$origKeys = Object.keys;

var $7f2f229f89396902$var$keysShim = $7f2f229f89396902$var$origKeys ? function keys(o) {
    return $7f2f229f89396902$var$origKeys(o);
} : (parcelRequire("5sRCg"));
var $7f2f229f89396902$var$originalKeys = Object.keys;
$7f2f229f89396902$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($1X2ck(object)) return $7f2f229f89396902$var$originalKeys($7f2f229f89396902$var$slice.call(object));
            return $7f2f229f89396902$var$originalKeys(object);
        };
    } else Object.keys = $7f2f229f89396902$var$keysShim;
    return Object.keys || $7f2f229f89396902$var$keysShim;
};
module.exports = $7f2f229f89396902$var$keysShim;

});
parcelRegister("1X2ck", function(module, exports) {
'use strict';
var $16bd01905a98261d$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $16bd01905a98261d$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $16bd01905a98261d$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("5sRCg", function(module, exports) {
'use strict';
var $3fa9285a883a7b19$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $3fa9285a883a7b19$var$has = Object.prototype.hasOwnProperty;
    var $3fa9285a883a7b19$var$toStr = Object.prototype.toString;
    var $3fa9285a883a7b19$var$isArgs = (parcelRequire("1X2ck")); // eslint-disable-line global-require
    var $3fa9285a883a7b19$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $3fa9285a883a7b19$var$hasDontEnumBug = !$3fa9285a883a7b19$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $3fa9285a883a7b19$var$hasProtoEnumBug = $3fa9285a883a7b19$var$isEnumerable.call(function() {}, 'prototype');
    var $3fa9285a883a7b19$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $3fa9285a883a7b19$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $3fa9285a883a7b19$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $3fa9285a883a7b19$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$3fa9285a883a7b19$var$excludedKeys['$' + k] && $3fa9285a883a7b19$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $3fa9285a883a7b19$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $3fa9285a883a7b19$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$3fa9285a883a7b19$var$hasAutomationEqualityBug) return $3fa9285a883a7b19$var$equalsConstructorPrototype(o);
        try {
            return $3fa9285a883a7b19$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $3fa9285a883a7b19$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $3fa9285a883a7b19$var$toStr.call(object) === '[object Function]';
        var isArguments = $3fa9285a883a7b19$var$isArgs(object);
        var isString = isObject && $3fa9285a883a7b19$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $3fa9285a883a7b19$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$3fa9285a883a7b19$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $3fa9285a883a7b19$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($3fa9285a883a7b19$var$hasDontEnumBug) {
            var skipConstructor = $3fa9285a883a7b19$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $3fa9285a883a7b19$var$dontEnums.length; ++k)if (!(skipConstructor && $3fa9285a883a7b19$var$dontEnums[k] === 'constructor') && $3fa9285a883a7b19$var$has.call(object, $3fa9285a883a7b19$var$dontEnums[k])) theKeys.push($3fa9285a883a7b19$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $3fa9285a883a7b19$var$keysShim;

});




parcelRegister("eyTeg", function(module, exports) {
'use strict';

var $9r4oR = parcelRequire("9r4oR");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $9r4oR;
};

});
parcelRegister("9r4oR", function(module, exports) {
'use strict';
var $6dea0c6ff626c045$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($6dea0c6ff626c045$var$numberIsNaN(a) && $6dea0c6ff626c045$var$numberIsNaN(b)) return true;
    return false;
};

});


parcelRegister("9wHVc", function(module, exports) {
'use strict';

var $chEcS = parcelRequire("chEcS");

var $loaP6 = parcelRequire("loaP6");
var $6ef92c1b2e3cec7f$var$$indexOf = $loaP6($chEcS('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $chEcS(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $6ef92c1b2e3cec7f$var$$indexOf(name, '.prototype.') > -1) return $loaP6(intrinsic);
    return intrinsic;
};

});

parcelRegister("PYPCO", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
function $09c3f36f958d08af$var$_slicedToArray(arr, i) {
    return $09c3f36f958d08af$var$_arrayWithHoles(arr) || $09c3f36f958d08af$var$_iterableToArrayLimit(arr, i) || $09c3f36f958d08af$var$_unsupportedIterableToArray(arr, i) || $09c3f36f958d08af$var$_nonIterableRest();
}
function $09c3f36f958d08af$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $09c3f36f958d08af$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $09c3f36f958d08af$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $09c3f36f958d08af$var$_arrayLikeToArray(o, minLen);
}
function $09c3f36f958d08af$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $09c3f36f958d08af$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $09c3f36f958d08af$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $09c3f36f958d08af$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $09c3f36f958d08af$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $09c3f36f958d08af$var$_typeof(o);
}
var $09c3f36f958d08af$var$regexFlagsSupported = /a/g.flags !== undefined;
var $09c3f36f958d08af$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $09c3f36f958d08af$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $09c3f36f958d08af$var$objectIs = Object.is ? Object.is : (parcelRequire("b4Hc4"));
var $09c3f36f958d08af$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $09c3f36f958d08af$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("2Evsc"));
function $09c3f36f958d08af$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $09c3f36f958d08af$var$hasOwnProperty = $09c3f36f958d08af$var$uncurryThis(Object.prototype.hasOwnProperty);
var $09c3f36f958d08af$var$propertyIsEnumerable = $09c3f36f958d08af$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $09c3f36f958d08af$var$objectToString = $09c3f36f958d08af$var$uncurryThis(Object.prototype.toString);

var $3UKyI = parcelRequire("3UKyI");
var $09c3f36f958d08af$require$_require$types = $3UKyI.types;
var $09c3f36f958d08af$var$isAnyArrayBuffer = $09c3f36f958d08af$require$_require$types.isAnyArrayBuffer, $09c3f36f958d08af$var$isArrayBufferView = $09c3f36f958d08af$require$_require$types.isArrayBufferView, $09c3f36f958d08af$var$isDate = $09c3f36f958d08af$require$_require$types.isDate, $09c3f36f958d08af$var$isMap = $09c3f36f958d08af$require$_require$types.isMap, $09c3f36f958d08af$var$isRegExp = $09c3f36f958d08af$require$_require$types.isRegExp, $09c3f36f958d08af$var$isSet = $09c3f36f958d08af$require$_require$types.isSet, $09c3f36f958d08af$var$isNativeError = $09c3f36f958d08af$require$_require$types.isNativeError, $09c3f36f958d08af$var$isBoxedPrimitive = $09c3f36f958d08af$require$_require$types.isBoxedPrimitive, $09c3f36f958d08af$var$isNumberObject = $09c3f36f958d08af$require$_require$types.isNumberObject, $09c3f36f958d08af$var$isStringObject = $09c3f36f958d08af$require$_require$types.isStringObject, $09c3f36f958d08af$var$isBooleanObject = $09c3f36f958d08af$require$_require$types.isBooleanObject, $09c3f36f958d08af$var$isBigIntObject = $09c3f36f958d08af$require$_require$types.isBigIntObject, $09c3f36f958d08af$var$isSymbolObject = $09c3f36f958d08af$require$_require$types.isSymbolObject, $09c3f36f958d08af$var$isFloat32Array = $09c3f36f958d08af$require$_require$types.isFloat32Array, $09c3f36f958d08af$var$isFloat64Array = $09c3f36f958d08af$require$_require$types.isFloat64Array;
function $09c3f36f958d08af$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $09c3f36f958d08af$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($09c3f36f958d08af$var$isNonIndex).concat($09c3f36f958d08af$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $09c3f36f958d08af$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $09c3f36f958d08af$var$ONLY_ENUMERABLE = undefined;
var $09c3f36f958d08af$var$kStrict = true;
var $09c3f36f958d08af$var$kLoose = false;
var $09c3f36f958d08af$var$kNoIterator = 0;
var $09c3f36f958d08af$var$kIsArray = 1;
var $09c3f36f958d08af$var$kIsSet = 2;
var $09c3f36f958d08af$var$kIsMap = 3;
// Check if they have the same source and flags
function $09c3f36f958d08af$var$areSimilarRegExps(a, b) {
    return $09c3f36f958d08af$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $09c3f36f958d08af$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $09c3f36f958d08af$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $09c3f36f958d08af$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $09c3f36f958d08af$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $09c3f36f958d08af$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $09c3f36f958d08af$var$isEqualBoxedPrimitive(val1, val2) {
    if ($09c3f36f958d08af$var$isNumberObject(val1)) return $09c3f36f958d08af$var$isNumberObject(val2) && $09c3f36f958d08af$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($09c3f36f958d08af$var$isStringObject(val1)) return $09c3f36f958d08af$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($09c3f36f958d08af$var$isBooleanObject(val1)) return $09c3f36f958d08af$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($09c3f36f958d08af$var$isBigIntObject(val1)) return $09c3f36f958d08af$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $09c3f36f958d08af$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $09c3f36f958d08af$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $09c3f36f958d08af$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($09c3f36f958d08af$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $09c3f36f958d08af$var$numberIsNaN(val1) && $09c3f36f958d08af$var$numberIsNaN(val2);
        if ($09c3f36f958d08af$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $09c3f36f958d08af$var$_typeof(val1) !== 'object') {
            if (val2 === null || $09c3f36f958d08af$var$_typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $09c3f36f958d08af$var$_typeof(val2) !== 'object') return false;
    }
    var val1Tag = $09c3f36f958d08af$var$objectToString(val1);
    var val2Tag = $09c3f36f958d08af$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $09c3f36f958d08af$var$getOwnNonIndexProperties(val1, $09c3f36f958d08af$var$ONLY_ENUMERABLE);
        var keys2 = $09c3f36f958d08af$var$getOwnNonIndexProperties(val2, $09c3f36f958d08af$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $09c3f36f958d08af$var$keyCheck(val1, val2, strict, memos, $09c3f36f958d08af$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === '[object Object]') {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$09c3f36f958d08af$var$isMap(val1) && $09c3f36f958d08af$var$isMap(val2) || !$09c3f36f958d08af$var$isSet(val1) && $09c3f36f958d08af$var$isSet(val2)) return false;
    }
    if ($09c3f36f958d08af$var$isDate(val1)) {
        if (!$09c3f36f958d08af$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($09c3f36f958d08af$var$isRegExp(val1)) {
        if (!$09c3f36f958d08af$var$isRegExp(val2) || !$09c3f36f958d08af$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($09c3f36f958d08af$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($09c3f36f958d08af$var$isArrayBufferView(val1)) {
        if (!strict && ($09c3f36f958d08af$var$isFloat32Array(val1) || $09c3f36f958d08af$var$isFloat64Array(val1))) {
            if (!$09c3f36f958d08af$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$09c3f36f958d08af$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $09c3f36f958d08af$var$getOwnNonIndexProperties(val1, $09c3f36f958d08af$var$ONLY_ENUMERABLE);
        var _keys2 = $09c3f36f958d08af$var$getOwnNonIndexProperties(val2, $09c3f36f958d08af$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $09c3f36f958d08af$var$keyCheck(val1, val2, strict, memos, $09c3f36f958d08af$var$kNoIterator, _keys);
    } else if ($09c3f36f958d08af$var$isSet(val1)) {
        if (!$09c3f36f958d08af$var$isSet(val2) || val1.size !== val2.size) return false;
        return $09c3f36f958d08af$var$keyCheck(val1, val2, strict, memos, $09c3f36f958d08af$var$kIsSet);
    } else if ($09c3f36f958d08af$var$isMap(val1)) {
        if (!$09c3f36f958d08af$var$isMap(val2) || val1.size !== val2.size) return false;
        return $09c3f36f958d08af$var$keyCheck(val1, val2, strict, memos, $09c3f36f958d08af$var$kIsMap);
    } else if ($09c3f36f958d08af$var$isAnyArrayBuffer(val1)) {
        if (!$09c3f36f958d08af$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($09c3f36f958d08af$var$isBoxedPrimitive(val1) && !$09c3f36f958d08af$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $09c3f36f958d08af$var$keyCheck(val1, val2, strict, memos, $09c3f36f958d08af$var$kNoIterator);
}
function $09c3f36f958d08af$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $09c3f36f958d08af$var$propertyIsEnumerable(val, k);
    });
}
function $09c3f36f958d08af$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$09c3f36f958d08af$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $09c3f36f958d08af$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($09c3f36f958d08af$var$propertyIsEnumerable(val1, key)) {
                    if (!$09c3f36f958d08af$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($09c3f36f958d08af$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $09c3f36f958d08af$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $09c3f36f958d08af$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $09c3f36f958d08af$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $09c3f36f958d08af$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $09c3f36f958d08af$var$kNoIterator || iterationType === $09c3f36f958d08af$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $09c3f36f958d08af$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $09c3f36f958d08af$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $09c3f36f958d08af$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($09c3f36f958d08af$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $09c3f36f958d08af$var$findLooseMatchingPrimitives(prim) {
    switch($09c3f36f958d08af$var$_typeof(prim)){
        case 'undefined':
            return null;
        case 'object':
            // Only pass in null as object!
            return undefined;
        case 'symbol':
            return false;
        case 'string':
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case 'number':
            if ($09c3f36f958d08af$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $09c3f36f958d08af$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $09c3f36f958d08af$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $09c3f36f958d08af$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $09c3f36f958d08af$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$09c3f36f958d08af$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $09c3f36f958d08af$var$innerDeepEqual(item, curB, false, memo);
}
function $09c3f36f958d08af$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $09c3f36f958d08af$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($09c3f36f958d08af$var$_typeof(val) === 'object' && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$09c3f36f958d08af$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $09c3f36f958d08af$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($09c3f36f958d08af$var$_typeof(_val) === 'object' && _val !== null) {
                if (!$09c3f36f958d08af$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$09c3f36f958d08af$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $09c3f36f958d08af$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $09c3f36f958d08af$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($09c3f36f958d08af$var$innerDeepEqual(key1, key2, strict, memo) && $09c3f36f958d08af$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $09c3f36f958d08af$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $09c3f36f958d08af$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $09c3f36f958d08af$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($09c3f36f958d08af$var$_typeof(key) === 'object' && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$09c3f36f958d08af$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$09c3f36f958d08af$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $09c3f36f958d08af$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $09c3f36f958d08af$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($09c3f36f958d08af$var$_typeof(_key) === 'object' && _key !== null) {
                if (!$09c3f36f958d08af$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$09c3f36f958d08af$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$09c3f36f958d08af$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $09c3f36f958d08af$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $09c3f36f958d08af$var$kIsSet) {
        if (!$09c3f36f958d08af$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $09c3f36f958d08af$var$kIsMap) {
        if (!$09c3f36f958d08af$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $09c3f36f958d08af$var$kIsArray) for(; i < a.length; i++){
        if ($09c3f36f958d08af$var$hasOwnProperty(a, i)) {
            if (!$09c3f36f958d08af$var$hasOwnProperty(b, i) || !$09c3f36f958d08af$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($09c3f36f958d08af$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$09c3f36f958d08af$var$hasOwnProperty(b, key) || !$09c3f36f958d08af$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$09c3f36f958d08af$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $09c3f36f958d08af$var$isDeepEqual(val1, val2) {
    return $09c3f36f958d08af$var$innerDeepEqual(val1, val2, $09c3f36f958d08af$var$kLoose);
}
function $09c3f36f958d08af$var$isDeepStrictEqual(val1, val2) {
    return $09c3f36f958d08af$var$innerDeepEqual(val1, val2, $09c3f36f958d08af$var$kStrict);
}
module.exports = {
    isDeepEqual: $09c3f36f958d08af$var$isDeepEqual,
    isDeepStrictEqual: $09c3f36f958d08af$var$isDeepStrictEqual
};

});
parcelRegister("b4Hc4", function(module, exports) {
'use strict';

var $PKxbN = parcelRequire("PKxbN");

var $loaP6 = parcelRequire("loaP6");

var $9r4oR = parcelRequire("9r4oR");

var $eyTeg = parcelRequire("eyTeg");

var $hePQt = parcelRequire("hePQt");
var $810192c8e75a885d$var$polyfill = $loaP6($eyTeg(), Object);
$PKxbN($810192c8e75a885d$var$polyfill, {
    getPolyfill: $eyTeg,
    implementation: $9r4oR,
    shim: $hePQt
});
module.exports = $810192c8e75a885d$var$polyfill;

});
parcelRegister("PKxbN", function(module, exports) {
'use strict';

var $aUZSG = parcelRequire("aUZSG");
var $09b8dc47b179198e$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $09b8dc47b179198e$var$toStr = Object.prototype.toString;
var $09b8dc47b179198e$var$concat = Array.prototype.concat;

var $cb59G = parcelRequire("cb59G");
var $09b8dc47b179198e$var$isFunction = function(fn) {
    return typeof fn === 'function' && $09b8dc47b179198e$var$toStr.call(fn) === '[object Function]';
};

var $09b8dc47b179198e$var$supportsDescriptors = (parcelRequire("94oR7"))();
var $09b8dc47b179198e$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$09b8dc47b179198e$var$isFunction(predicate) || !predicate()) return;
    }
    if ($09b8dc47b179198e$var$supportsDescriptors) $cb59G(object, name, value, true);
    else $cb59G(object, name, value);
};
var $09b8dc47b179198e$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $aUZSG(map);
    if ($09b8dc47b179198e$var$hasSymbols) props = $09b8dc47b179198e$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$09b8dc47b179198e$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$09b8dc47b179198e$var$defineProperties.supportsDescriptors = !!$09b8dc47b179198e$var$supportsDescriptors;
module.exports = $09b8dc47b179198e$var$defineProperties;

});

parcelRegister("hePQt", function(module, exports) {
'use strict';

var $eyTeg = parcelRequire("eyTeg");

var $PKxbN = parcelRequire("PKxbN");
module.exports = function shimObjectIs() {
    var polyfill = $eyTeg();
    $PKxbN(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("2Evsc", function(module, exports) {
'use strict';

var $loaP6 = parcelRequire("loaP6");

var $PKxbN = parcelRequire("PKxbN");

var $jj0u2 = parcelRequire("jj0u2");

var $gaMk0 = parcelRequire("gaMk0");

var $382b5 = parcelRequire("382b5");
var $1ee7b748c80f27bc$var$polyfill = $loaP6($gaMk0(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $PKxbN($1ee7b748c80f27bc$var$polyfill, {
    getPolyfill: $gaMk0,
    implementation: $jj0u2,
    shim: $382b5
});
module.exports = $1ee7b748c80f27bc$var$polyfill;

});
parcelRegister("jj0u2", function(module, exports) {
'use strict';
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("gaMk0", function(module, exports) {
'use strict';

var $jj0u2 = parcelRequire("jj0u2");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
    return $jj0u2;
};

});

parcelRegister("382b5", function(module, exports) {
'use strict';

var $PKxbN = parcelRequire("PKxbN");

var $gaMk0 = parcelRequire("gaMk0");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $gaMk0();
    $PKxbN(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRegister("iKZi9", function(module, exports) {

var $5cWAY = parcelRequire("5cWAY");
function $da7c1129081c1011$var$scrollIntoView(elem, container, config) {
    config = config || {};
    // document 归一化到 window
    if (container.nodeType === 9) container = $5cWAY.getWindow(container);
    var allowHorizontalScroll = config.allowHorizontalScroll;
    var onlyScrollIfNeeded = config.onlyScrollIfNeeded;
    var alignWithTop = config.alignWithTop;
    var alignWithLeft = config.alignWithLeft;
    allowHorizontalScroll = allowHorizontalScroll === undefined ? true : allowHorizontalScroll;
    var isWin = $5cWAY.isWindow(container);
    var elemOffset = $5cWAY.offset(elem);
    var eh = $5cWAY.outerHeight(elem);
    var ew = $5cWAY.outerWidth(elem);
    var containerOffset, ch, cw, containerScroll, diffTop, diffBottom, win, winScroll, ww, wh;
    if (isWin) {
        win = container;
        wh = $5cWAY.height(win);
        ww = $5cWAY.width(win);
        winScroll = {
            left: $5cWAY.scrollLeft(win),
            top: $5cWAY.scrollTop(win)
        };
        // elem 相对 container 可视视窗的距离
        diffTop = {
            left: elemOffset.left - winScroll.left,
            top: elemOffset.top - winScroll.top
        };
        diffBottom = {
            left: elemOffset.left + ew - (winScroll.left + ww),
            top: elemOffset.top + eh - (winScroll.top + wh)
        };
        containerScroll = winScroll;
    } else {
        containerOffset = $5cWAY.offset(container);
        ch = container.clientHeight;
        cw = container.clientWidth;
        containerScroll = {
            left: container.scrollLeft,
            top: container.scrollTop
        };
        // elem 相对 container 可视视窗的距离
        // 注意边框, offset 是边框到根节点
        diffTop = {
            left: elemOffset.left - (containerOffset.left + (parseFloat($5cWAY.css(container, 'borderLeftWidth')) || 0)),
            top: elemOffset.top - (containerOffset.top + (parseFloat($5cWAY.css(container, 'borderTopWidth')) || 0))
        };
        diffBottom = {
            left: elemOffset.left + ew - (containerOffset.left + cw + (parseFloat($5cWAY.css(container, 'borderRightWidth')) || 0)),
            top: elemOffset.top + eh - (containerOffset.top + ch + (parseFloat($5cWAY.css(container, 'borderBottomWidth')) || 0))
        };
    }
    if (diffTop.top < 0 || diffBottom.top > 0) {
        // 强制向上
        if (alignWithTop === true) $5cWAY.scrollTop(container, containerScroll.top + diffTop.top);
        else if (alignWithTop === false) $5cWAY.scrollTop(container, containerScroll.top + diffBottom.top);
        else // 自动调整
        if (diffTop.top < 0) $5cWAY.scrollTop(container, containerScroll.top + diffTop.top);
        else $5cWAY.scrollTop(container, containerScroll.top + diffBottom.top);
    } else if (!onlyScrollIfNeeded) {
        alignWithTop = alignWithTop === undefined ? true : !!alignWithTop;
        if (alignWithTop) $5cWAY.scrollTop(container, containerScroll.top + diffTop.top);
        else $5cWAY.scrollTop(container, containerScroll.top + diffBottom.top);
    }
    if (allowHorizontalScroll) {
        if (diffTop.left < 0 || diffBottom.left > 0) {
            // 强制向上
            if (alignWithLeft === true) $5cWAY.scrollLeft(container, containerScroll.left + diffTop.left);
            else if (alignWithLeft === false) $5cWAY.scrollLeft(container, containerScroll.left + diffBottom.left);
            else // 自动调整
            if (diffTop.left < 0) $5cWAY.scrollLeft(container, containerScroll.left + diffTop.left);
            else $5cWAY.scrollLeft(container, containerScroll.left + diffBottom.left);
        } else if (!onlyScrollIfNeeded) {
            alignWithLeft = alignWithLeft === undefined ? true : !!alignWithLeft;
            if (alignWithLeft) $5cWAY.scrollLeft(container, containerScroll.left + diffTop.left);
            else $5cWAY.scrollLeft(container, containerScroll.left + diffBottom.left);
        }
    }
}
module.exports = $da7c1129081c1011$var$scrollIntoView;

});
parcelRegister("5cWAY", function(module, exports) {
var $3cab868e160fe765$var$RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
function $3cab868e160fe765$var$getClientPosition(elem) {
    var box, x, y;
    var doc = elem.ownerDocument;
    var body = doc.body;
    var docElem = doc && doc.documentElement;
    // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
    box = elem.getBoundingClientRect();
    // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
    // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
    // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
    x = box.left;
    y = box.top;
    // In IE, most of the time, 2 extra pixels are added to the top and left
    // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
    // IE6 standards mode, this border can be overridden by setting the
    // document element's border to zero -- thus, we cannot rely on the
    // offset always being 2 pixels.
    // In quirks mode, the offset can be determined by querying the body's
    // clientLeft/clientTop, but in standards mode, it is found by querying
    // the document element's clientLeft/clientTop.  Since we already called
    // getClientBoundingRect we have already forced a reflow, so it is not
    // too expensive just to query them all.
    // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
    // 窗口边框标准是设 documentElement ,quirks 时设置 body
    // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
    // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
    // 标准 ie 下 docElem.clientTop 就是 border-top
    // ie7 html 即窗口边框改变不了。永远为 2
    // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
    x -= docElem.clientLeft || body.clientLeft || 0;
    y -= docElem.clientTop || body.clientTop || 0;
    return {
        left: x,
        top: y
    };
}
function $3cab868e160fe765$var$getScroll(w, top) {
    var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
    var method = 'scroll' + (top ? 'Top' : 'Left');
    if (typeof ret !== 'number') {
        var d = w.document;
        //ie6,7,8 standard mode
        ret = d.documentElement[method];
        if (typeof ret !== 'number') //quirks mode
        ret = d.body[method];
    }
    return ret;
}
function $3cab868e160fe765$var$getScrollLeft(w) {
    return $3cab868e160fe765$var$getScroll(w);
}
function $3cab868e160fe765$var$getScrollTop(w) {
    return $3cab868e160fe765$var$getScroll(w, true);
}
function $3cab868e160fe765$var$getOffset(el) {
    var pos = $3cab868e160fe765$var$getClientPosition(el);
    var doc = el.ownerDocument;
    var w = doc.defaultView || doc.parentWindow;
    pos.left += $3cab868e160fe765$var$getScrollLeft(w);
    pos.top += $3cab868e160fe765$var$getScrollTop(w);
    return pos;
}
function $3cab868e160fe765$var$_getComputedStyle(elem, name, computedStyle) {
    var val = '';
    var d = elem.ownerDocument;
    // https://github.com/kissyteam/kissy/issues/61
    if (computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null)) val = computedStyle.getPropertyValue(name) || computedStyle[name];
    return val;
}
var $3cab868e160fe765$var$_RE_NUM_NO_PX = new RegExp('^(' + $3cab868e160fe765$var$RE_NUM + ')(?!px)[a-z%]+$', 'i');
var $3cab868e160fe765$var$RE_POS = /^(top|right|bottom|left)$/, $3cab868e160fe765$var$CURRENT_STYLE = 'currentStyle', $3cab868e160fe765$var$RUNTIME_STYLE = 'runtimeStyle', $3cab868e160fe765$var$LEFT = 'left', $3cab868e160fe765$var$PX = 'px';
function $3cab868e160fe765$var$_getComputedStyleIE(elem, name) {
    // currentStyle maybe null
    // http://msdn.microsoft.com/en-us/library/ms535231.aspx
    var ret = elem[$3cab868e160fe765$var$CURRENT_STYLE] && elem[$3cab868e160fe765$var$CURRENT_STYLE][name];
    // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
    // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
    // 在 ie 下不对，需要直接用 offset 方式
    // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
    // From the awesome hack by Dean Edwards
    // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
    // If we're not dealing with a regular pixel number
    // but a number that has a weird ending, we need to convert it to pixels
    // exclude left right for relativity
    if ($3cab868e160fe765$var$_RE_NUM_NO_PX.test(ret) && !$3cab868e160fe765$var$RE_POS.test(name)) {
        // Remember the original values
        var style = elem.style, left = style[$3cab868e160fe765$var$LEFT], rsLeft = elem[$3cab868e160fe765$var$RUNTIME_STYLE][$3cab868e160fe765$var$LEFT];
        // prevent flashing of content
        elem[$3cab868e160fe765$var$RUNTIME_STYLE][$3cab868e160fe765$var$LEFT] = elem[$3cab868e160fe765$var$CURRENT_STYLE][$3cab868e160fe765$var$LEFT];
        // Put in the new values to get a computed value out
        style[$3cab868e160fe765$var$LEFT] = name === 'fontSize' ? '1em' : ret || 0;
        ret = style.pixelLeft + $3cab868e160fe765$var$PX;
        // Revert the changed values
        style[$3cab868e160fe765$var$LEFT] = left;
        elem[$3cab868e160fe765$var$RUNTIME_STYLE][$3cab868e160fe765$var$LEFT] = rsLeft;
    }
    return ret === '' ? 'auto' : ret;
}
var $3cab868e160fe765$var$getComputedStyleX;
if (typeof window !== 'undefined') $3cab868e160fe765$var$getComputedStyleX = window.getComputedStyle ? $3cab868e160fe765$var$_getComputedStyle : $3cab868e160fe765$var$_getComputedStyleIE;
// 设置 elem 相对 elem.ownerDocument 的坐标
function $3cab868e160fe765$var$setOffset(elem, offset) {
    // set position first, in-case top/left are set even on static elem
    if ($3cab868e160fe765$var$css(elem, 'position') === 'static') elem.style.position = 'relative';
    var old = $3cab868e160fe765$var$getOffset(elem), ret = {}, current, key;
    for(key in offset){
        current = parseFloat($3cab868e160fe765$var$css(elem, key)) || 0;
        ret[key] = current + offset[key] - old[key];
    }
    $3cab868e160fe765$var$css(elem, ret);
}
function $3cab868e160fe765$var$each(arr, fn) {
    for(var i = 0; i < arr.length; i++)fn(arr[i]);
}
function $3cab868e160fe765$var$isBorderBoxFn(elem) {
    return $3cab868e160fe765$var$getComputedStyleX(elem, 'boxSizing') === 'border-box';
}
var $3cab868e160fe765$var$BOX_MODELS = [
    'margin',
    'border',
    'padding'
], $3cab868e160fe765$var$CONTENT_INDEX = -1, $3cab868e160fe765$var$PADDING_INDEX = 2, $3cab868e160fe765$var$BORDER_INDEX = 1, $3cab868e160fe765$var$MARGIN_INDEX = 0;
function $3cab868e160fe765$var$swap(elem, options, callback) {
    var old = {}, style = elem.style, name;
    // Remember the old values, and insert the new ones
    for(name in options){
        old[name] = style[name];
        style[name] = options[name];
    }
    callback.call(elem);
    // Revert the old values
    for(name in options)style[name] = old[name];
}
function $3cab868e160fe765$var$getPBMWidth(elem, props, which) {
    var value = 0, prop, j, i;
    for(j = 0; j < props.length; j++){
        prop = props[j];
        if (prop) for(i = 0; i < which.length; i++){
            var cssProp;
            if (prop === 'border') cssProp = prop + which[i] + 'Width';
            else cssProp = prop + which[i];
            value += parseFloat($3cab868e160fe765$var$getComputedStyleX(elem, cssProp)) || 0;
        }
    }
    return value;
}
/**
 * A crude way of determining if an object is a window
 * @member util
 */ function $3cab868e160fe765$var$isWindow(obj) {
    // must use == for ie8
    /*jshint eqeqeq:false*/ return obj != null && obj == obj.window;
}
var $3cab868e160fe765$var$domUtils = {};
$3cab868e160fe765$var$each([
    'Width',
    'Height'
], function(name) {
    $3cab868e160fe765$var$domUtils['doc' + name] = function(refWin) {
        var d = refWin.document;
        return Math.max(//firefox chrome documentElement.scrollHeight< body.scrollHeight
        //ie standard mode : documentElement.scrollHeight> body.scrollHeight
        d.documentElement['scroll' + name], //quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
        d.body['scroll' + name], $3cab868e160fe765$var$domUtils['viewport' + name](d));
    };
    $3cab868e160fe765$var$domUtils['viewport' + name] = function(win) {
        // pc browser includes scrollbar in window.innerWidth
        var prop = 'client' + name, doc = win.document, body = doc.body, documentElement = doc.documentElement, documentElementProp = documentElement[prop];
        // 标准模式取 documentElement
        // backcompat 取 body
        return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
    };
});
/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */ function $3cab868e160fe765$var$getWH(elem, name, extra) {
    if ($3cab868e160fe765$var$isWindow(elem)) return name === 'width' ? $3cab868e160fe765$var$domUtils.viewportWidth(elem) : $3cab868e160fe765$var$domUtils.viewportHeight(elem);
    else if (elem.nodeType === 9) return name === 'width' ? $3cab868e160fe765$var$domUtils.docWidth(elem) : $3cab868e160fe765$var$domUtils.docHeight(elem);
    var which = name === 'width' ? [
        'Left',
        'Right'
    ] : [
        'Top',
        'Bottom'
    ], borderBoxValue = name === 'width' ? elem.offsetWidth : elem.offsetHeight;
    var computedStyle = $3cab868e160fe765$var$getComputedStyleX(elem);
    var isBorderBox = $3cab868e160fe765$var$isBorderBoxFn(elem, computedStyle);
    var cssBoxValue = 0;
    if (borderBoxValue == null || borderBoxValue <= 0) {
        borderBoxValue = undefined;
        // Fall back to computed then un computed css if necessary
        cssBoxValue = $3cab868e160fe765$var$getComputedStyleX(elem, name);
        if (cssBoxValue == null || Number(cssBoxValue) < 0) cssBoxValue = elem.style[name] || 0;
        // Normalize '', auto, and prepare for extra
        cssBoxValue = parseFloat(cssBoxValue) || 0;
    }
    if (extra === undefined) extra = isBorderBox ? $3cab868e160fe765$var$BORDER_INDEX : $3cab868e160fe765$var$CONTENT_INDEX;
    var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
    var val = borderBoxValue || cssBoxValue;
    if (extra === $3cab868e160fe765$var$CONTENT_INDEX) {
        if (borderBoxValueOrIsBorderBox) return val - $3cab868e160fe765$var$getPBMWidth(elem, [
            'border',
            'padding'
        ], which, computedStyle);
        else return cssBoxValue;
    } else if (borderBoxValueOrIsBorderBox) return val + (extra === $3cab868e160fe765$var$BORDER_INDEX ? 0 : extra === $3cab868e160fe765$var$PADDING_INDEX ? -$3cab868e160fe765$var$getPBMWidth(elem, [
        'border'
    ], which, computedStyle) : $3cab868e160fe765$var$getPBMWidth(elem, [
        'margin'
    ], which, computedStyle));
    else return cssBoxValue + $3cab868e160fe765$var$getPBMWidth(elem, $3cab868e160fe765$var$BOX_MODELS.slice(extra), which, computedStyle);
}
var $3cab868e160fe765$var$cssShow = {
    position: 'absolute',
    visibility: 'hidden',
    display: 'block'
};
// fix #119 : https://github.com/kissyteam/kissy/issues/119
function $3cab868e160fe765$var$getWHIgnoreDisplay(elem) {
    var val, args = arguments;
    // in case elem is window
    // elem.offsetWidth === undefined
    if (elem.offsetWidth !== 0) val = $3cab868e160fe765$var$getWH.apply(undefined, args);
    else $3cab868e160fe765$var$swap(elem, $3cab868e160fe765$var$cssShow, function() {
        val = $3cab868e160fe765$var$getWH.apply(undefined, args);
    });
    return val;
}
$3cab868e160fe765$var$each([
    'width',
    'height'
], function(name) {
    var first = name.charAt(0).toUpperCase() + name.slice(1);
    $3cab868e160fe765$var$domUtils['outer' + first] = function(el, includeMargin) {
        return el && $3cab868e160fe765$var$getWHIgnoreDisplay(el, name, includeMargin ? $3cab868e160fe765$var$MARGIN_INDEX : $3cab868e160fe765$var$BORDER_INDEX);
    };
    var which = name === 'width' ? [
        'Left',
        'Right'
    ] : [
        'Top',
        'Bottom'
    ];
    $3cab868e160fe765$var$domUtils[name] = function(elem, val) {
        if (val !== undefined) {
            if (elem) {
                var computedStyle = $3cab868e160fe765$var$getComputedStyleX(elem);
                var isBorderBox = $3cab868e160fe765$var$isBorderBoxFn(elem);
                if (isBorderBox) val += $3cab868e160fe765$var$getPBMWidth(elem, [
                    'padding',
                    'border'
                ], which, computedStyle);
                return $3cab868e160fe765$var$css(elem, name, val);
            }
            return;
        }
        return elem && $3cab868e160fe765$var$getWHIgnoreDisplay(elem, name, $3cab868e160fe765$var$CONTENT_INDEX);
    };
});
function $3cab868e160fe765$var$css(el, name, value) {
    if (typeof name === 'object') {
        for(var i in name)$3cab868e160fe765$var$css(el, i, name[i]);
        return;
    }
    if (typeof value !== 'undefined') {
        if (typeof value === 'number') value = value + 'px';
        el.style[name] = value;
    } else return $3cab868e160fe765$var$getComputedStyleX(el, name);
}
function $3cab868e160fe765$var$mix(to, from) {
    for(var i in from)to[i] = from[i];
    return to;
}
var $3cab868e160fe765$var$utils = module.exports = {
    getWindow: function(node) {
        var doc = node.ownerDocument || node;
        return doc.defaultView || doc.parentWindow;
    },
    offset: function(el, value) {
        if (typeof value !== 'undefined') $3cab868e160fe765$var$setOffset(el, value);
        else return $3cab868e160fe765$var$getOffset(el);
    },
    isWindow: $3cab868e160fe765$var$isWindow,
    each: $3cab868e160fe765$var$each,
    css: $3cab868e160fe765$var$css,
    clone: function(obj) {
        var ret = {};
        for(var i in obj)ret[i] = obj[i];
        var overflow = obj.overflow;
        if (overflow) for(i in obj)ret.overflow[i] = obj.overflow[i];
        return ret;
    },
    mix: $3cab868e160fe765$var$mix,
    scrollLeft: function(w, v) {
        if ($3cab868e160fe765$var$isWindow(w)) {
            if (v === undefined) return $3cab868e160fe765$var$getScrollLeft(w);
            else window.scrollTo(v, $3cab868e160fe765$var$getScrollTop(w));
        } else {
            if (v === undefined) return w.scrollLeft;
            else w.scrollLeft = v;
        }
    },
    scrollTop: function(w, v) {
        if ($3cab868e160fe765$var$isWindow(w)) {
            if (v === undefined) return $3cab868e160fe765$var$getScrollTop(w);
            else window.scrollTo($3cab868e160fe765$var$getScrollLeft(w), v);
        } else {
            if (v === undefined) return w.scrollTop;
            else w.scrollTop = v;
        }
    },
    merge: function() {
        var ret = {};
        for(var i = 0; i < arguments.length; i++)$3cab868e160fe765$var$utils.mix(ret, arguments[i]);
        return ret;
    },
    viewportWidth: 0,
    viewportHeight: 0
};
$3cab868e160fe765$var$mix($3cab868e160fe765$var$utils, $3cab868e160fe765$var$domUtils);

});


var $4db1849af9bfbaed$exports = {};
$parcel$extendImportMap({
    "3Uadk": "ku-logo.108a4850.png",
    "7Bd9n": "nsf.4ba61612.png",
    "ddWNw": "osep-idea.6b671f00.png",
    "bRHai": "texthelp.dcdcf7f0.png",
    "2B05T": "logo-footer.aad6fbf4.svg",
    "6HS2M": "CEG_flowChart.1ac6d8e7.svg",
    "jMbat": "CERA_flowChart.60b622ff.svg",
    "gyh7g": "CT_flowChart.9c17ba4a.svg",
    "2Jugt": "QEG_flowChart.5e19b9d9.svg",
    "3v8yC": "bracket-small.37013ec8.svg",
    "gxB9R": "rating-never.158d79ae.svg",
    "8xEjf": "rating-sometimes.51169ec3.svg",
    "971mb": "rating-usually.ba998cd0.svg",
    "7znd4": "rating-always.8a020c7e.svg",
    "6PUeY": "rating-dontknow.03564df3.svg",
    "b73Vi": "google-slides-logo-square.acb08818.svg",
    "ijK7G": "corgi-tongue.c9f5dd43.gif",
    "jQ7Bt": "google_classroom-square.61301c98.svg",
    "9zUDe": "google-slides-icon-x16.e1cc9173.png",
    "8GOmI": "bowl.52c23845.png",
    "8Gots": "loginWhy0.f2d726d9.jpg",
    "ihElY": "loginWhy1.ba555cfb.jpg",
    "8Sr3O": "loginWhy2.aee8dc61.jpg",
    "eyv73": "loginWhy3.b27c7667.jpg",
    "b8Bh1": "loginResearch.369fc707.jpg",
    "46wHe": "loginWhatGoogle.1131e65e.png",
    "8gH0P": "loginWhatCollab.e0bbe1f8.png",
    "gqrtm": "loginWhatUDL.6aef0d14.png",
    "f9MzL": "loginWhatNGSS.a6faa3e9.png",
    "d5GJj": "loginWhatSIM.fc86683d.png",
    "3utiB": "loginWhatPresent.3a119e78.png",
    "5uvCa": "loginTeach.148c0950.jpg",
    "5zxoH": "CEG_icon.3176cff0.png",
    "dlxz7": "QEG_icon.c9de924e.png",
    "ecV3l": "CT_icon.dc84c3cc.png",
    "azyQv": "CERA_icon.41c3ca36.png",
    "bAICM": "mark.fe1d0c00.svg",
    "bA5u8": "rotate_device.2622f05b.svg"
});


var $6wXVr = parcelRequire("6wXVr");
var $39d800d77e473b3f$exports = {};
'use strict';
function $39d800d77e473b3f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($39d800d77e473b3f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$39d800d77e473b3f$var$checkDCE();

$39d800d77e473b3f$exports = (parcelRequire("fYsVz"));



var $6wXVr = parcelRequire("6wXVr");
var $c9687236993bf07d$exports = {};
"use strict";
var $c9687236993bf07d$var$__rest = $c9687236993bf07d$exports && $c9687236993bf07d$exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }
    return t;
};
$c9687236993bf07d$exports.__esModule = true;

var $6wXVr = parcelRequire("6wXVr");
var $dfb755f17758685f$export$1e511d4a378977f5;
var $dfb755f17758685f$export$336a96caafd77c8;
var $dfb755f17758685f$export$c345014757622bba;
"use strict";
$dfb755f17758685f$export$1e511d4a378977f5 = true;
var $dfb755f17758685f$var$R = {
    "`` ": [
        /^(.*?(?:(?!`).|^))(``+)\s(.*?)\s\2(?!`)(.*)$/,
        [
            1,
            3,
            4
        ]
    ],
    "``": [
        /^(.*?(?:(?!`).|^))(``+)(?!`)(.*?(?!`).)\2(?!`)(.*)$/,
        [
            1,
            3,
            4
        ]
    ],
    "*": /^(|.*?\W)\*(\S.*?)\*(|\W.*)$/,
    "**": /^(|.*?\W)\*\*(\S.*?)\*\*(|\W.*)$/,
    "_": /^(|.*?\W)_(\S.*?)_(|\W.*)$/,
    "__": /^(|.*?\W)__(\S.*?)__(|\W.*)$/,
    "~": /^(|.*?\W)~(\S.*?)~(|\W.*)$/,
    "~~": /^(|.*?\W)~~(\S.*?)~~(|\W.*)$/,
    "[]": /^(.*?)\[(.*?)\](.*)$/,
    "#": /^(|.*?(?=\n))\n*\s*#([^#].*?)#*\s*\n+([\S\s]*)$/,
    "##": /^(|.*?(?=\n))\n*\s*##([^#].*?)#*\s*\n+([\S\s]*)$/,
    "###": /^(|.*?(?=\n))\n*\s*###([^#].*?)#*\s*\n+([\S\s]*)$/,
    "####": /^(|.*?(?=\n))\n*\s*####([^#].*?)#*\s*\n+([\S\s]*)$/,
    "\n": /^(.*?)[^\S\n]*\n()[^\S\n]*([\s\S]*)$/,
    "{{}}": /^(.*?)\{\{(.*?)\}\}(.*)$/,
    "{}": /^(.*?)\{(.*?)\}(.*)$/
};
$dfb755f17758685f$export$336a96caafd77c8 = [
    {
        maybe: /[\*_\{\[\n]/,
        tags: {
            strong: $dfb755f17758685f$var$R["*"],
            em: $dfb755f17758685f$var$R["_"],
            p: $dfb755f17758685f$var$R["[]"],
            h1: $dfb755f17758685f$var$R["#"],
            h2: $dfb755f17758685f$var$R["##"],
            h3: $dfb755f17758685f$var$R["###"],
            h4: $dfb755f17758685f$var$R["####"],
            br: $dfb755f17758685f$var$R["\n"],
            self: $dfb755f17758685f$var$R["{{}}"],
            inter: $dfb755f17758685f$var$R["{}"]
        }
    },
    {
        maybe: /[`\*_~\{\[\n]/,
        tags: {
            literals: $dfb755f17758685f$var$R["`` "],
            literal: $dfb755f17758685f$var$R["``"],
            strong: $dfb755f17758685f$var$R["**"],
            em: $dfb755f17758685f$var$R["*"],
            b: $dfb755f17758685f$var$R["__"],
            i: $dfb755f17758685f$var$R["_"],
            strike: $dfb755f17758685f$var$R["~~"],
            u: $dfb755f17758685f$var$R["~"],
            p: $dfb755f17758685f$var$R["[]"],
            h1: $dfb755f17758685f$var$R["#"],
            h2: $dfb755f17758685f$var$R["##"],
            h3: $dfb755f17758685f$var$R["###"],
            h4: $dfb755f17758685f$var$R["####"],
            br: $dfb755f17758685f$var$R["\n"],
            self: $dfb755f17758685f$var$R["{{}}"],
            inter: $dfb755f17758685f$var$R["{}"]
        }
    }
];
function $dfb755f17758685f$var$mdMatch(md, value) {
    if (!value.match(md.maybe)) return null;
    var tags = md.tags;
    var match = null;
    for(var ctag in tags){
        if (!tags.hasOwnProperty(ctag)) continue;
        var rg = tags[ctag];
        var _a = rg instanceof RegExp ? [
            rg,
            [
                1,
                2,
                3
            ]
        ] : rg, regex = _a[0], groups = _a[1];
        var cmatch = regex.exec(value);
        if (cmatch) {
            if (match == null || cmatch[groups[0]].length < match.head.length) match = {
                tag: ctag,
                head: cmatch[groups[0]],
                body: cmatch[groups[1]],
                tail: cmatch[groups[2]]
            };
        }
    }
    return match;
}
$dfb755f17758685f$export$c345014757622bba = $dfb755f17758685f$var$mdMatch;


function $c9687236993bf07d$var$isString(s) {
    return typeof s === 'string' || s instanceof String;
}
function $c9687236993bf07d$var$isObject(o) {
    return typeof o === 'object';
}
function $c9687236993bf07d$var$isFunction(o) {
    return typeof o === 'function';
}
function $c9687236993bf07d$var$get(obj, path) {
    var spath = path.split('.');
    for(var i = 0, len = spath.length; i < len; i++){
        if (!obj || !$c9687236993bf07d$var$isObject(obj)) return undefined;
        obj = obj[spath[i]];
    }
    return obj;
}
function $c9687236993bf07d$var$first(o) {
    for(var k in o){
        if (k != '__') return o[k];
    }
}
function $c9687236993bf07d$var$flatten(l) {
    var r = [];
    var s = '';
    var flush = function() {
        return s && (r.push(s), s = '');
    };
    for(var _i = 0, l_1 = l; _i < l_1.length; _i++){
        var i = l_1[_i];
        if (i == null) continue;
        if ($c9687236993bf07d$var$isString(i)) s += i;
        else {
            flush();
            r.push(i);
        }
    }
    flush();
    return r.length > 1 ? r : r.length ? r[0] : null;
}
var $c9687236993bf07d$var$matcher = /** @class */ function() {
    function matcher(mdFlavor, inter, self) {
        this.mdFlavor = mdFlavor;
        this.inter = inter;
        this.self = self;
    }
    matcher.prototype.M = function(value) {
        if (!value) return null;
        var m = $dfb755f17758685f$export$c345014757622bba(this.mdFlavor, value);
        if (!m) return value;
        var middle = null;
        switch(m.tag){
            case "inter":
                middle = this.inter && this.inter(m.body);
                break;
            case "self":
                middle = this.self && this.self(m.body);
                break;
            case "literals":
            case "literal":
                middle = m.body;
                break;
            default:
                middle = $6wXVr.createElement(m.tag, {
                    key: m.tag + m.body
                }, this.M(m.body));
                break;
        }
        return $c9687236993bf07d$var$flatten([
            this.M(m.head),
            middle,
            this.M(m.tail)
        ]);
    };
    return matcher;
}();
function $c9687236993bf07d$var$rangeHit(node, val) {
    for(var t in node){
        if (!node.hasOwnProperty(t)) continue;
        var range = t.match(/^(-?\d+)\.\.(-?\d+)$/);
        if (range && +range[1] <= val && val <= +range[2]) return node[t];
    }
}
function $c9687236993bf07d$var$resolveContextPath(node, p, path, context) {
    var key = path[p];
    var trans;
    if (key != null && context[key] != null) {
        trans = $c9687236993bf07d$var$get(node, context[key].toString());
        if (trans == null && +context[key] === context[key]) trans = $c9687236993bf07d$var$rangeHit(node, +context[key]);
    }
    if (trans == null) trans = node._;
    if (trans == null) trans = $c9687236993bf07d$var$first(node);
    if (trans != null && !$c9687236993bf07d$var$isString(trans)) return $c9687236993bf07d$var$resolveContextPath(trans, p + 1, path, context);
    return trans;
}
function $c9687236993bf07d$var$resolveContext(node, context) {
    if (context == null) return $c9687236993bf07d$var$resolveContextPath(node, 0, [], null);
    else if (!$c9687236993bf07d$var$isObject(context)) return $c9687236993bf07d$var$resolveContextPath(node, 0, [
        '_'
    ], {
        _: context
    });
    else {
        var ctx_keys = [];
        if (node.__) ctx_keys = node.__.split('.');
        else for(var k in context){
            if (!context.hasOwnProperty(k)) continue;
            ctx_keys.push(k);
        }
        return $c9687236993bf07d$var$resolveContextPath(node, 0, ctx_keys, context);
    }
}
var $c9687236993bf07d$var$MDText = /** @class */ function() {
    function MDText(texts, opt) {
        this.texts = texts;
        this.MDFlavor = 0;
        // public access is deprecated
        this.notFound = undefined;
        this.p = this.factory('p');
        this.span = this.factory('span');
        this.li = this.factory('li');
        this.div = this.factory('div');
        this.button = this.factory('button');
        this.a = this.factory('a');
        this.text = this.factory(null);
        this.setOpts(opt);
    }
    MDText.prototype.setTexts = function(texts, opt) {
        this.texts = texts;
        this.setOpts(opt);
    };
    MDText.prototype.setOpts = function(opt) {
        if (!opt) return;
        if (opt.notFound !== undefined) this.notFound = opt.notFound;
        if (opt.MDFlavor !== undefined) this.MDFlavor = opt.MDFlavor;
    };
    MDText.prototype.interpolate = function(exp, vars) {
        var _a = exp.split(','), vn = _a[0], flags = _a[1];
        var v = $c9687236993bf07d$var$get(vars, vn);
        if (v == null) return null;
        else if ($6wXVr.isValidElement(v)) return $6wXVr.cloneElement(v, {
            key: 'r'
        });
        var vs;
        if (flags && flags.match(/l/)) vs = v.toLocaleString();
        else vs = v.toString();
        return vs;
    };
    MDText.prototype.format = function(value, vars) {
        var _this = this;
        if (!value) return value;
        return new $c9687236993bf07d$var$matcher($dfb755f17758685f$export$336a96caafd77c8[this.MDFlavor], function(exp) {
            return _this.interpolate(exp, vars);
        }, function(exp) {
            return _this.translate(exp, vars);
        }).M(value);
    };
    MDText.prototype.translate = function(key, options) {
        if (!key) return key;
        var trans = $c9687236993bf07d$var$get(this.texts, key);
        var context = options && options.context;
        if (trans != null && !($c9687236993bf07d$var$isString(trans) || $c9687236993bf07d$var$isFunction(trans))) trans = $c9687236993bf07d$var$resolveContext(trans, context);
        if (trans == null) trans = options && options.notFound !== undefined ? options.notFound : this.notFound !== undefined ? this.notFound : key;
        if ($c9687236993bf07d$var$isFunction(trans)) trans = trans(key, context);
        return this.format(trans, options);
    };
    MDText.prototype.factory = function(tagF) {
        var _this = this;
        // name High Order Function for React Dev tools
        var MDText = function(props) {
            var text = props.text, tag = props.tag, restProps = $c9687236993bf07d$var$__rest(props, [
                "text",
                "tag"
            ]);
            var key;
            var options;
            if (text == null || $c9687236993bf07d$var$isString(text)) {
                key = text;
                options = props;
                var notFound = restProps.notFound, context = restProps.context, rest2Props = $c9687236993bf07d$var$__rest(restProps, [
                    "notFound",
                    "context"
                ]);
                restProps = rest2Props;
            } else {
                key = text.key;
                options = text;
            }
            var aTag = tagF || tag;
            var translation = _this.translate(key, options);
            return aTag ? $6wXVr.createElement(aTag, restProps, translation) : translation;
        };
        return MDText;
    };
    return MDText;
}();
$c9687236993bf07d$exports.MDText = $c9687236993bf07d$var$MDText;
var $c9687236993bf07d$var$singleton = new $c9687236993bf07d$var$MDText(null);
$c9687236993bf07d$exports["default"] = $c9687236993bf07d$var$singleton;


// This file contains text for all of the instructional hints that describe how to use the various
// fields in the Content Enhancement Routines.
const $198066ba87364cec$var$texts = {
    footer: {
        nsf: {
            url: "https://www.nsf.gov",
            grant: "This material is based upon work supported by the National Science Foundation under grant #1813556. Any opinions, findings, conclusions, or recommendations expressed in this material are those of the author(s) and do not necessarily reflect the views of the National Science Foundation."
        },
        texthelp: {
            thanks: "CAST would like to thank TextHelp Systems Ltd. for use of the SpeechStream toolbar."
        },
        osep: {
            grant: "This material is based upon work supported by the Office of Special Education Programs under grant #H327S190008. Any opinions, findings, conclusions, or recommendations expressed in this material are those of the author(s) and do not necessarily reflect the views of the Office of Special Education Programs."
        }
    },
    "utility": {
        footer: "Co-Organize Your Learning (CORGI) is a google application for students and teachers to use to collaboratively answer questions requiring higher order reasoning. The CORGI guides are adapted from Strategic Instruction Model (SIM) routines developed by Janis A. Bulgren, B. Keith Lenz, Donald D. Deshler, & Jean B. Schumaker at the University of Kansas. CORGI is funded by the Investing in Innovation (i3) Development Grant awarded to SRI International (#U411C14003).",
        migrationHeader: "CORGI has a new home",
        migrationBody: "The i3 Enhanced Unit project is ending and, therefore, the old CORGI site, corgi.sri.com, has been deactivated. Please bookmark the new CORGI site: "
    },
    "unit-org-2": {
        title: "Unit Organizer",
        abbr: "UO",
        blurb: "We use the Unit Organizer to organize the critical content to be learned for each unit. We also include the unit self-test questions we are responsible for answering and the type of reasoning we will use to answer the questions. The schedule of assignments will help us see how the tasks are related to helping us answer the unit self-test questions.",
        footer: {
            sri: "Originally developed, validated and copyrighted, \u2018The Unit Organizer Routine\u2019 by B. Keith Lenz, Janis A. Bulgren, Jean B. Schumaker, Donald D. Deshler, and Daniel A. Boudah. Edge Enterprises Inc. (1994). The authors have granted their permission to SRI to adapt the Unit Organizer Routine and display and distribute the adaptation on this site via an application hosted by Google, funded by the U.S. Department of Education, Investing in Innovation (i3) Development Grant #U411C140003.  The contents of this site were developed under the i3 grant from the Department of Education. However, those contents do not necessarily represent the policy of the Department of Education, and you should not assume endorsement by the Federal Government.",
            nsf: "This material is based upon work supported by the National Science Foundation under\n                                    grant #1813556. Any opinions, findings, conclusions, or recommendations expressed in\n                                    this material are those of the author(s) and do not necessarily reflect the views of\n                                    the National Science Foundation."
        },
        overall: {
            label: "Bigger Picture",
            help: "In this section, the name of the idea or theme that holds several units together is noted.",
            placeholder: "Type the bigger picture for the unit here."
        },
        unitTitle: {
            label: "Unit title",
            placeholder: "Enter the unit title here."
        },
        prevUnit: {
            label: "Previous Unit",
            placeholder: "Title of the previous unit."
        },
        nextUnit: {
            label: "Next Unit",
            placeholder: "Title of the next unit."
        },
        unitMap: {
            label: "Unit Map",
            help: "In this section, we show a visual way of organizing the information in the unit."
        },
        unitAbout: {
            label: "Unit Paraphrase",
            help: "In this section, a paraphrase is written that captures the main idea of the unit and distinguishes it from other units. It is written in student friendly language that is easy to understand.",
            placeholder: "Paraphrase what the unit is about."
        },
        connector: {
            placeholder: "Add connecting phrase here."
        },
        mainIdea: {
            label: "Main Ideas",
            help: "In this section, we list the main ideas or essential ideas of the unit, which is the critical content that you need to learn.",
            placeholder: "Add new main idea here."
        },
        questions: {
            label: "Self-test Questions",
            help: "In this section, we ask questions that, if answered by the end of the unit, show that we have mastered the critical content for the unit.",
            placeholder: "Type self-test question here."
        },
        orgtype: {
            label: "Unit Relationships",
            help: "The level and way of thinking that we want to use when working and interacting with the critical content.  The unit relationship determines how we are going to be working with and showing mastery of the content."
        },
        schedlist: {
            label: "Unit Schedule",
            help: "This section is a schedule of the most important activities and events in the unit (quizzes, tests, high impact activities).",
            datePlaceholder: "Date",
            assignmentPlaceholder: "Assignment"
        }
    },
    "cause-effect": {
        title: "Cause & Effect Guide",
        abbr: "CEG",
        example: "The Seasons",
        blurb: " The Cause & Effect Guide helps us explain the relationship between an event, its causes, and its effects.",
        footer: "Originally developed, validated and copyrighted, 'Teaching Cause and Effect' by Janis A. Bulgren, Ph.D. University of Kansas. (2013). The authors have granted their permission to SRI to adapt the Cause and Effect Routine and display and distribute the adaptation on this site via an application hosted by Google, funded by the U.S. Department of Education, Investing in Innovation (i3) Development Grant #U411C140003.  The contents of this site were developed under the i3 grant from the Department of Education. However, those contents do not necessarily represent the policy of the Department of Education, and you should not assume endorsement by the Federal Government.",
        mnemonic: "REASON",
        mnemonicSteps: [
            "Restate the question",
            "Examine the key terms",
            "Analyze critical event & background information",
            "Specify causes and connections",
            "Organize effects and connections",
            "Nail down the answer"
        ],
        connector: {
            placeholder: "Add connecting phrase here.",
            empty: "No relationship selected"
        },
        sections: [
            {
                key: "toc",
                title: "Cause & Effect Steps"
            },
            {
                stepnum: 1,
                key: "question",
                title: "What is the essential question?",
                topic: "The title for my topic is...",
                description: "Enter your essential question in the form of a question.",
                info: {
                    label: "Essential Question",
                    text: [
                        "*Essential questions* are complex and thought-provoking questions that don\u2019t have simple answers. They drive us to ask more questions and draw connections between events, characteristics, and features.",
                        "For example, we\u2019ll explore the *topic* \u2018The Seasons\u2019 through the *essential question*."
                    ],
                    image: {
                        src: '/example/cause-effect/essentialquestion.svg',
                        alt: "Two text boxes displaying the topic and essential question. Topic: The Seasons Essential Question: How does the tilt of the Earth\u2019s axis cause our seasons?"
                    }
                },
                tooltip: {
                    key: "essential question",
                    definition: "Essential questions don't have simple answers. They promote inquiry and critical thinking practices."
                }
            },
            {
                stepnum: 2,
                key: "terms",
                title: "What are the key terms?",
                description: "Define the key terms that will help you explore your topic.",
                term: {
                    label: "Word or Phrase",
                    placeholder: "Enter key term"
                },
                def: {
                    label: "Definition",
                    placeholder: "Enter the definition"
                },
                info: {
                    label: "Key Terms",
                    text: [
                        "Key terms are the words and phrases that will help you better understand your topic and respond to the essential question.",
                        ""
                    ]
                },
                tooltip: {
                    key: "key terms",
                    definition: "Key terms are vocabulary words and phrases that will enhance your understanding of a topic."
                }
            },
            {
                stepnum: 3,
                key: "event",
                title: "What is the main event?",
                description: "Describe the critical event, topic, idea, or issue and provide background information.",
                placeholder: "The main event or idea I am exploring is...",
                info: {
                    label: "Main event or idea",
                    text: [
                        'A *main event or idea* is the description of the critical topic that happens because of one or more causes and creates one or more effects.',
                        ''
                    ],
                    image: {
                        src: '/example/cause-effect/event.svg',
                        alt: "Two text boxes displaying the essential question and the main event. Essential Question: How does the tilt of the Earth\u2019s axis cause our seasons? Main event or idea: On Earth, we experience temperature changes throughout the year called seasons. The Northern Hemisphere and Southern Hemisphere have opposite seasons."
                    }
                },
                tooltip: {
                    key: "main event",
                    definition: "The main event is the central point or idea."
                }
            },
            {
                stepnum: 4,
                key: "causes",
                title: "What are the causes of the main event?",
                description: "Describe the causes of the main event. Enter up to four causes.",
                info: {
                    label: "Causes and connections",
                    text: [
                        'The *causes and connections* have a relationship to the main event or idea. They may lead to the event or prompt it to happen. ',
                        ''
                    ],
                    image: {
                        src: '/example/cause-effect/causes.svg',
                        alt: 'Two text boxes displaying a cause and the main event connected by a vertical arrow. Cause: The Earth revolves around the sun every 365 days on a tilted axis. Main event: On Earth, we experience temperature changes throughout the year called seasons. The Northern Hemisphere and Southern Hemisphere have opposite seasons.'
                    }
                },
                tooltip: {
                    key: "causes",
                    definition: "The causes of the main event led to it or prompted it to happen."
                }
            },
            {
                stepnum: 5,
                key: "causes-event",
                title: "What is the relationship to the causes?",
                description: "Select the relationship between the causes and connections and the main event or idea. Or, enter your own.",
                info: {
                    label: "Relationship to the main event",
                    text: [
                        'The *relationship* to the main event helps to define how the causes connect to the main event.',
                        ''
                    ],
                    image: {
                        src: '/example/cause-effect/causes-event.svg',
                        alt: 'Three text boxes displaying a cause, the relationship, and the main event connected by a vertical arrow. Cause: The Earth revolves around the sun every 365 days on a tilted axis. Relationship: Produces. Main event: On Earth, we experience temperature changes throughout the year called seasons. The Northern Hemisphere and Southern Hemisphere have opposite seasons.'
                    }
                },
                tooltip: {
                    key: "relationship",
                    definition: "The relationship describes the connection between causes and the main event."
                }
            },
            {
                stepnum: 6,
                key: "effects",
                title: "What are the effects of the main event?",
                description: "Describe the effects of the main event. Enter up to four effects.",
                label: "Effects of the main event",
                info: {
                    label: "Effects of the main event",
                    text: [
                        'The *effects and connections* have a relationship to the main event or idea. They may happen directly because of the main event or due to a secondary reason.',
                        ''
                    ],
                    image: {
                        src: '/example/cause-effect/effects.svg',
                        alt: 'Two text boxes displaying the main event and an effect connected by a vertical arrow. Main event: On Earth, we experience temperature changes throughout the year called seasons. The Northern Hemisphere and Southern Hemisphere have opposite seasons. Effect: When the Northern Hemisphere is tilted toward the sun, it is experiencing summer.'
                    }
                },
                tooltip: {
                    key: "effects",
                    definition: "The effects happen as a result of the main event."
                }
            },
            {
                stepnum: 7,
                key: "event-effects",
                title: "What is the relationship to the effects?",
                description: "Select the relationship between the main event or idea and its effects. Or, enter your own.",
                info: {
                    label: "Relationship to the effects",
                    text: [
                        'The *relationship* to the main event helps to define how the main event connects to the effects.',
                        ''
                    ],
                    image: {
                        src: '/example/cause-effect/event-effects.svg',
                        alt: 'Three text boxes displaying a cause, the relationship, and the main event connected by a vertical arrow. Main event: On Earth, we experience temperature changes throughout the year called seasons. The Northern Hemisphere and Southern Hemisphere have opposite seasons. Relationship: Results in. Effect: When the Northern Hemisphere is tilted toward the sun, it is experiencing summer.'
                    }
                },
                tooltip: {
                    key: "relationship",
                    definition: "The relationship describes the connection between the main event and the effects."
                }
            },
            {
                stepnum: 8,
                key: "summary",
                title: "What is the summary?",
                description: "Summarize what you\u2019ve learned through your exploration of this cause & effect relationship.",
                info: {
                    label: "Summary",
                    text: [
                        'Incorporate the causes, relationships, and effects of the main event or idea you have explored in the previous steps into your *summary*.',
                        ''
                    ]
                },
                tooltip: {
                    key: "summary",
                    definition: "The summary is your response to the essential question based on what you\u2019ve learned."
                }
            },
            {
                stepnum: 9,
                key: "extensions",
                title: "Extensions",
                description: "What additional questions has this exploration generated?"
            },
            {
                stepnum: 10,
                key: "complete",
                title: "Review",
                description: "Check your understanding of the Cause & Effect relationship you've explored. When the guide is complete, go to the 'Create & Share' page.",
                prompts: [
                    "You have not yet entered a Topic. Go to step 1 to complete this section.",
                    "You have not yet entered an Essential Question. Go to Step 1 to complete this section.",
                    "You have not yet entered a Main Event. Go to Step 2 to complete this section.",
                    "You have not yet entered any Causes of the Main Event. Go to Step 3 to complete this section.",
                    "You have not yet selected a relationship between the Cause and the Main Event. Go to Step 4 to complete this section.",
                    "You have not yet entered any Effects of the Main Event. Go to Step 5 to complete this section.",
                    "You have not yet selected a relationship between the Main Event and the Effects. Go to Step 6 to complete this section.",
                    "You have not yet entered a Summary. Go to Step 7 to complete this section."
                ],
                // see CORGI-481 for criteria - no check for Extensions step
                empty: {
                    topic: "Topic not yet entered",
                    question: "You have not yet entered an Essential Question.",
                    terms: "You have not yet entered any Key Terms.",
                    event: "You have not yet entered a Main Event.",
                    cause: "You have not yet entered any Causes.",
                    connector: "No relationship selected",
                    effect: "You have not yet entered any Effects of the Main Event.",
                    summary: "You have not yet entered a Summary."
                }
            },
            {
                stepnum: 11,
                key: "create-share",
                title: "Create and Share"
            }
        ],
        topic: {
            label: "Essential Question",
            help: "In this box, we can restate a complex or unclear question into something more simple and direct.",
            placeholder: "The title for my topic is",
            empty: "Topic not yet entered"
        },
        question: {
            label: "Essential Question",
            help: "In this box, we can restate a complex or unclear question into something more simple and direct.",
            placeholder: "The essential question I am investigating is...",
            empty: "You have not yet entered an Essential Question."
        },
        terms: {
            label: "Key Terms",
            singleLabel: "Key Terms",
            description: "Define key terms that we need to know in order to complete the cause and effect guide.",
            termPlaceholder: "Enter the key term",
            defPlaceholder: "Enter the definition",
            empty: "You have not yet entered any Key Terms.",
            term: {
                label: "Word or Phrase",
                placeholder: "Enter the key term"
            },
            def: {
                label: "Definition",
                placeholder: "Enter the definition"
            },
            info: {
                label: "Key Terms",
                text: [
                    "Knowing key terms can help you learn content and demonstrate your understanding. Here is where you add 3-5 key terms that relate to your topic. If you understand the meaning of the terms simply add your own definition. If you need help with their meaning simply search the CORGI dictionary and then add a definition that makes sense.",
                    ""
                ]
            }
        },
        "causes-event": {
            placeholder: "Add connecting phrase here.",
            empty: "No relationship selected"
        },
        event: {
            label: "Event and Background Information",
            singleLabel: "Event",
            help: "It is helpful to fully understand the main event before we try to identify causes and effects, so, in this box, we can type words or phrases to describe the critical event from the restated question. Then, we can list background information that helps us understand details of the event.",
            placeholder: "The main event or idea I am exploring is...",
            empty: "You have not yet entered a Main Event."
        },
        cause: {
            label: "Causes and Connections",
            singleLabel: "Cause",
            help: "In this box, we will include one or more short statements that describe critical causes of the event.  After we describe the causes of the event, we use connecting phrases to create connections between the causes and the event.  Examples include: which led to, leading to, and causing. These connecting verbs will result in complete sentences that can be read across the guide, from causes to event to effects.",
            placeholder: "A cause and connection of the main event I am exploring is...",
            empty: "You have not yet entered any Causes."
        },
        "event-effects": {
            placeholder: "Add connecting phrase here.",
            empty: "No relationship selected"
        },
        effect: {
            label: "Effects of the Main Event",
            singleLabel: "Effect",
            help: "In box 5, we will include one or more short statements that describe critical effects of the event. After we describe the effects of the event, we use connecting phrases to create connections between the event and the effects.  Examples include: which led to, leading to, and causing. These connecting verbs will result in complete sentences that can be read across the guide, from causes to event to effects.",
            placeholder: "Organize effects and connections.",
            empty: "You have not yet entered any Effects of the Main Event."
        },
        answer: {
            label: "Summary",
            singleLabel: "Summary",
            help: "We are finally ready to write our answer to the original question. The answer should include the name of the event, the causes and effects, and an explanation for each. It\u2019s an opportunity to use all the information we have gathered and put our answer in our own words.",
            placeholder: "My response to the essential question is...",
            empty: "You have not yet entered a Summary."
        },
        extensions: {
            placeholder: " I would like to learn more about\u2026"
        }
    },
    "cera": {
        title: "Claim, Evidence, Reasoning Guide",
        abbr: "CERA",
        blurb: "The Claim, Evidence, Reasoning Guide helps us use reasoning to determine if a claim is supported by evidence.",
        footer: "Developed by CAST Inc. (2021). The contents of this site were developed under the Stepping Up grant under the Office of Special Education Programs. However, those contents do not necessarily represent the policy of the Office of Special Education Programs, and you should not assume endorsement by the Federal Government.",
        sections: [
            {
                key: "toc",
                title: "Claim, Evidence, Reasoning Guide Steps"
            },
            {
                stepnum: 1,
                key: "essentialquestion",
                title: "What is the essential question?",
                description: "Enter your essential question in the form of a question.",
                tooltip: {
                    key: "essential question",
                    definition: "Essential questions don't have simple answers. They promote inquiry and critical thinking practices."
                }
            },
            {
                stepnum: 2,
                key: "terms",
                title: "What are the key terms?",
                description: "Define the key terms that will help you explore your topic.",
                term: {
                    label: "Word or Phrase",
                    placeholder: "Enter key term"
                },
                def: {
                    label: "Definition",
                    placeholder: "Enter the definition"
                },
                tooltip: {
                    key: "key terms",
                    definition: "Key terms are vocabulary words and phrases that will enhance your understanding of a topic."
                }
            },
            {
                stepnum: 3,
                key: "claim",
                title: "What is the claim?",
                description: "Enter a claim that responds to the essential question and add more details.",
                tooltip: {
                    key: "claim",
                    definition: "A claim is a statement that may or may not be true."
                }
            },
            {
                stepnum: 4,
                key: "evidencesupport",
                title: "What evidence supports the claim?",
                description: "Enter one piece of evidence per row. Include your sources.",
                tooltip: {
                    key: "evidence",
                    definition: "Supporting evidence helps prove a claim is true or accurate."
                }
            },
            {
                stepnum: 5,
                key: "evidenceopposes",
                title: "What evidence opposes the claim?",
                description: "Did you find any evidence that does not support the claim? Enter one piece of evidence per row. Include your sources.",
                tooltip: {
                    key: "opposes",
                    definition: "Opposing evidence counters or refutes the claim."
                }
            },
            {
                stepnum: 6,
                key: "evidencequality",
                title: "How strong or weak is the evidence? ",
                description: "Determine if each piece of evidence is weak or strong. Explain your choice."
            },
            {
                stepnum: 7,
                key: "reasoning",
                title: "What is your reasoning?",
                description: "Now that you have evaluated the evidence, does the evidence support the claim? Why or why not? Explain your reasoning.",
                tooltip: {
                    key: "reasoning",
                    definition: "Reasoning is the thought process that leads to agreeing or disagreeing with a claim and describing how evidence supports a claim."
                }
            },
            {
                stepnum: 8,
                key: "complete",
                title: "Review",
                description: "Check your understanding of the Claim, Evidence, and Reasoning relationship you've explored. When the guide is complete, go to the 'Create & Share' page."
            },
            {
                stepnum: 9,
                key: "create-share",
                title: "Create and Share"
            }
        ],
        topic: {
            title: "Topic",
            placeholder: "The title for my topic is\u2026",
            empty: "You have not yet entered a Topic."
        },
        essentialquestion: {
            title: "Essential Question",
            placeholder: "The essential question is...",
            empty: "You have not yet entered an Essential Question."
        },
        claim: {
            title: "Claim",
            placeholder: "The claim is\u2026 ",
            empty: "You have not yet entered a Claim."
        },
        claimcontext: {
            title: "Context for the Claim",
            placeholder: "More details about the claim...",
            empty: "You have not yet entered a Claim Background/Context."
        },
        evidencesupport: {
            placeholder: "The evidence is\u2026",
            empty: "You have not yet entered any Supporting Evidence. "
        },
        citation: {
            placeholder: "The source is..."
        },
        evidenceopposes: {
            placeholder: "The opposing evidence is...",
            empty: "You have not yet entered any Opposing Evidence."
        },
        qualitytype: {
            placeholder: "The quality of the evidence is..."
        },
        qualitynote: {
            label: 'Reason for rating',
            placeholder: "The evidence is weak/strong because...",
            empty: "You have not entered the Evidence Quality."
        },
        reasoningtype: {
            placeholder: "Select a sentence starter..."
        },
        reasoningnote: {
            placeholder: "Write your own...",
            empty: "You have not entered the Reasoning."
        },
        terms: {
            label: "Key Terms",
            description: "Define key terms that we need to know in order to complete the Claim, Evidence, Reasoning guide.",
            help: "In this section, we need to identify and understand the key terms so we can answer the questions.  If not already provided, type any Key Terms and use a dictionary or background knowledge to define them.",
            termPlaceholder: "Enter the key term",
            defPlaceholder: "Enter the definition",
            empty: "You have not yet entered any Key Terms.",
            term: {
                label: "Word or Phrase",
                placeholder: "Enter the key term"
            },
            def: {
                label: "Definition",
                placeholder: "Enter the definition"
            },
            info: {
                label: "Key Terms",
                text: [
                    "Knowing key terms can help you learn content and demonstrate your understanding. Here is where you add 3-5 key terms that relate to your topic. If you understand the meaning of the terms simply add your own definition. If you need help with their meaning simply search the CORGI dictionary and then add a definition that makes sense.",
                    ""
                ]
            }
        }
    },
    "question-exp": {
        title: "Question Exploration Guide",
        abbr: "QEG",
        example: "Equinox & Solstice",
        blurb: " The Question Exploration Guide helps us break down an essential question, respond to it, and relate it to our broader understandings.",
        footer: "Originally developed, validated and copyrighted, 'The Question Exploration Routine' by Janis A. Bulgren, B. Keith Lenz, Donald D. Deshler, and Jean Schumaker. Edge Enterprises Inc. (2001). The authors have granted their permission to SRI to adapt the Question Exploration Routine and display and distribute the adaptation on this site via an application hosted by Google, funded by the U.S. Department of Education, Investing in Innovation (i3) Development Grant #U411C140003.  The contents of this site were developed under the i3 grant from the Department of Education. However, those contents do not necessarily represent the policy of the Department of Education, and you should not assume endorsement by the Federal Government.",
        mnemonic: "ANSWER",
        mnemonicSteps: [
            "Ask a Critical Question",
            "Note and explain key terms",
            "Search for Supporting Questions and their answers",
            "Work out a Main Idea answer to the critical question that is concise and usable",
            "Explore the Main Idea to show deeper understanding",
            "Relate the main idea to today\u2019s world"
        ],
        sections: [
            {
                key: "toc",
                title: "Question Exploration Steps"
            },
            {
                stepnum: 1,
                key: "essentialquestion",
                title: "What is the essential question?",
                description: "Enter your essential question in the form of a question.",
                info: {
                    label: "Essential Question",
                    text: [
                        "Essential questions are complex and thought-provoking questions that don\u2019t have simple answers. They drive us to ask more questions and draw connections between events, characteristics, and features.",
                        "_For example, we\u2019ll explore the *topic* \u2018The Equinox & The Solstice\u2019 through the *essential question*_"
                    ],
                    image: {
                        src: '/example/question-exp/essential-question.svg',
                        alt: 'Two text boxes containing the topic and essential question. Topic: The Equinox & The Solstice Essential Question: Why do our seasons have equinoxes and solstices?'
                    }
                },
                tooltip: {
                    key: "essential question",
                    definition: "Essential questions don't have simple answers. They promote inquiry and critical thinking practices."
                }
            },
            {
                stepnum: 2,
                key: "terms",
                title: "What are the key terms?",
                description: "Define the key terms that will help you explore your topic. ",
                term: {
                    label: "Word or Phrase",
                    placeholder: "Enter key term"
                },
                def: {
                    label: "Definition",
                    placeholder: "Enter the definition"
                },
                info: {
                    label: "Key Terms",
                    text: [
                        "Key terms are the words and phrases that will help you better understand your topic and respond to the essential question.",
                        ""
                    ]
                },
                tooltip: {
                    key: "key terms",
                    definition: "Key terms are vocabulary words and phrases that will enhance your understanding of a topic."
                }
            },
            {
                stepnum: 3,
                key: "relatedquestion",
                title: "What are the supporting questions?",
                description: "Enter questions starting with 'Who', 'What', 'Where', 'When', 'Why', and \u2018How\u2019 to explore the essential question more deeply.",
                info: {
                    label: "Supporting Questions",
                    text: [
                        'Break down your essential question into smaller, focused questions that will help you understand your topic.',
                        ''
                    ],
                    image: {
                        src: '/example/question-exp/related-question.svg',
                        alt: 'Two text boxes containing the essential question and a supporting question. Essential Question: Why do our seasons have equinoxes and solstices? Supporting Question: How do you identify the two types of equinoxes?'
                    }
                },
                tooltip: {
                    key: "supporting questions",
                    definition: "Supporting questions break down the essential question into smaller, more focused questions."
                }
            },
            {
                stepnum: 4,
                key: "relatedquestionresponse",
                title: "What are your responses to the supporting questions?",
                description: "Research your supporting questions and enter your responses.",
                info: {
                    label: "Response to the Supporting Questions",
                    text: [
                        'Think about how the responses to your supporting questions will help you respond to your essential question.',
                        ''
                    ],
                    image: {
                        src: '/example/question-exp/related-question-response.svg',
                        alt: 'Two text boxes containing a supporting question and its response. Supporting Question: How do you identify two types of equinoxes? Response: An equinox happens when the earth experiences equal amounts of daytime and nighttime hours.                        '
                    }
                }
            },
            {
                stepnum: 5,
                key: "essentialquestionresponse",
                title: "What is your response to the essential question? ",
                description: "Based on your exploration, create a response to the essential question. This response should provide the main idea. Refer to your responses to the supporting questions when entering this response.",
                info: {
                    label: "Response to the Essential Question",
                    text: [
                        "Refer to your responses to the supporting questions when entering this response. Essential questions are complex - it\u2019s okay if your question doesn\u2019t have a single, clear cut answer. ",
                        ''
                    ],
                    image: {
                        src: '/example/question-exp/essential-question-response.svg',
                        alt: 'Two text boxes containing the essential question and its response. Essential Question: Why do our seasons have equinoxes and solstices?'
                    }
                },
                tooltip: {
                    key: "response",
                    definition: "Essential questions are complex - it\u2019s okay if your response doesn\u2019t have a single, clear cut answer."
                }
            },
            {
                stepnum: 6,
                key: "contextresponse",
                title: "How can you apply what you have learned in this exploration to the class or real-world?",
                description: "Describe the class or real-world context for your response.",
                info: {
                    label: "Context Response",
                    text: [
                        "Why is the information you\u2019ve learned through this exploration useful? How does it change or add to your understanding of this class or world?",
                        ''
                    ],
                    image: {
                        src: '/example/question-exp/context-response.svg',
                        alt: "Two text boxes containing the response to the essential question and its real-world context. Response to the essential question: An equinox and a solstice are both caused because the Earth\u2019s tilt toward the sun changes throughout the year. Real-world context: We can use our knowledge about equinoxes and solstices to explain why the days get longer and shorter throughout the year."
                    }
                }
            },
            {
                stepnum: 7,
                key: "extensions",
                title: "What additional questions has this exploration generated?",
                description: "Enter the new questions this exploration has surfaced.",
                info: {
                    label: "Extensions",
                    text: [
                        'Did your exploration unlock new topics to study? Record your additional questions here.',
                        ''
                    ],
                    image: {
                        src: '/example/question-exp/extensions.svg',
                        alt: "Two text boxes containing the response to the essential question and an extension. Response to the essential question: An equinox and a solstice are both caused because the Earth\u2019s tilt toward the sun changes throughout the year. Extension: Why was the solstice so important to ancient civilizations such as the Ancient Greeks, the Druids, and the Mayan People?"
                    }
                }
            },
            {
                stepnum: 8,
                key: "complete",
                title: "Review",
                description: "Check your understanding of the essential question you\u2019ve explored. Review any incomplete sections. When the guide is complete, go to the 'Create & Share' page."
            },
            {
                key: "create-share",
                title: "Create and Share"
            }
        ],
        topic: {
            title: "Topic",
            placeholder: "The title for my topic is\u2026",
            empty: "Topic not yet entered"
        },
        essentialquestion: {
            title: "Essential Question",
            placeholder: "The essential question I am exploring is...",
            empty: "You have not yet entered an Essential Question."
        },
        relatedquestion: {
            toptitle: "Supporting Questions & Responses",
            title: "Questions",
            placeholder: "A supporting question is...",
            empty: "You have not yet entered any Supporting Question."
        },
        relatedquestionresponse: {
            title: "Responses",
            placeholder: "My response to this supporting question is...",
            empty: "You have not yet entered any Supporting Question Responses."
        },
        essentialquestionresponse: {
            title: "Response to Essential Question",
            placeholder: "My response to the essential question is...",
            empty: "You have not yet entered a Response to the Essential Question."
        },
        contextresponse: {
            title: "Context for Response",
            placeholder: "The main idea relates to the real world because...",
            empty: "You have not yet entered a Real-world Context."
        },
        extensions: {
            title: "Extensions",
            placeholder: "I would like to learn more about...",
            empty: "You have not yet entered any Extensions."
        },
        terms: {
            label: "Key Terms",
            description: "Define key terms that we need to know in order to complete the Question Exploration guide.",
            help: "In this section, we need to identify and understand the key terms so we can answer the questions.  If not already provided, type any Key Terms and use a dictionary or background knowledge to define them.",
            termPlaceholder: "Enter the key term",
            defPlaceholder: "Enter the definition",
            empty: "You have not yet entered any Key Terms.",
            term: {
                label: "Word or Phrase",
                placeholder: "Enter the key term"
            },
            def: {
                label: "Definition",
                placeholder: "Enter the definition"
            },
            info: {
                label: "Key Terms",
                text: [
                    "Knowing key terms can help you learn content and demonstrate your understanding. Here is where you add 3-5 key terms that relate to your topic. If you understand the meaning of the terms simply add your own definition. If you need help with their meaning simply search the CORGI dictionary and then add a definition that makes sense.",
                    ""
                ]
            }
        }
    },
    "comparison": {
        title: "Comparison Guide",
        abbr: "CT",
        example: "Lunar vs. Solar Eclipse",
        blurb: "The Comparison Guide helps us describe the similarities and differences between two concepts.",
        footer: "Originally developed, validated and copyrighted, \u2018The Concept Comparison Routine\u2019 by Janis A. Bulgren, B. Keith Lenz, Donald D. Deshler, & Jean B. Schumaker, Edge Enterprises Inc. (1995). The authors have granted their permission to SRI to adapt the Concept Comparison Routine and display and distribute the adaptation on this site via an application hosted by Google, funded by the U.S. Department of Education, Investing in Innovation (i3) Development Grant #U411C140003.  The contents of this site were developed under the i3 grant from the Department of Education. However, those contents do not necessarily represent the policy of the Department of Education, and you should not assume endorsement by the Federal Government.",
        mnemonic: "COMPARING",
        mnemonicSteps: [
            "Communicate targeted concepts",
            "Obtain the Overall Concept",
            "Make lists of known characteristics",
            "Pin down Like Characteristics",
            "Assemble Like Categories",
            "Record Unlike Characteristics",
            "Identify Unlike Categories",
            "Nail down a summary",
            "Go beyond the basics"
        ],
        sections: [
            {
                key: "toc",
                title: "Comparison Steps"
            },
            {
                stepnum: 1,
                key: "essentialquestion",
                title: "What is the essential question?",
                description: "Enter your essential question in the form of a question.",
                info: {
                    label: "Essential Question",
                    text: [
                        "*Essential questions* are complex and thought-provoking questions that don\u2019t have a simple answer. They drive us to ask more questions and draw connections between events, characteristics, and features.",
                        "For example, the essential question \u201CWhy do solar and lunar eclipses occur?\u201D helps us compare two different types of eclipses."
                    ],
                    image: {
                        src: "/example/comparison/essentialquestion.svg",
                        alt: "A section of a graphic organizer with the essential question \u201CWhy do solar and lunar eclipses occur?\u201D entered into it"
                    }
                },
                tooltip: {
                    key: "essential question",
                    definition: "Essential questions don't have simple answers. They promote inquiry and critical thinking practices."
                }
            },
            {
                stepnum: 2,
                key: "terms",
                title: "What are the key terms?",
                description: "Define the key terms that will help you explore your topic.",
                term: {
                    label: "Word or Phrase",
                    placeholder: "Enter key term"
                },
                def: {
                    label: "Definition",
                    placeholder: "Enter the definition"
                },
                info: {
                    label: "Key Terms",
                    text: [
                        "Key terms are the words and phrases that will help you better understand your topic and respond to the essential question.",
                        ""
                    ]
                },
                tooltip: {
                    key: "key terms",
                    definition: "Key terms are vocabulary words and phrases that will enhance your understanding of a topic."
                }
            },
            {
                stepnum: 3,
                key: "concepts",
                title: "What two concepts are you comparing?",
                description: "Create a title and describe the two concepts you are comparing.",
                info: {
                    label: "Concepts",
                    text: [
                        'In this step you would *list* and *define* your concept.',
                        "For example, you can list Solar Eclipse and add the definition: \u201CA solar eclipse is when the moon blocks the sun\u2019s rays, casting a shadow on Earth.\u201D You can also add an image to help visualize your definition."
                    ],
                    image: {
                        src: "/example/comparison/concepts.svg",
                        alt: "A screenshot of a graphic organizer showing the concept 'Solar Eclipse' and its description below it."
                    }
                },
                tooltip: {
                    key: "concepts",
                    definition: "A concept is a topic or an idea."
                }
            },
            {
                stepnum: 4,
                key: "overall",
                title: "What's the overall concept?",
                description: "Enter a word or phrase that describes both concepts.",
                info: {
                    label: "The Overall Concept",
                    text: [
                        'The *Overall Concept* is a label we give to a category that includes both concepts.',
                        "For example, solar and lunar eclipses are both phenomena that happen in space when one object casts a shadow on another object. The overall concept for this comparison routine is \u201CTypes of space phenomena.\u201D"
                    ],
                    image: {
                        src: "/example/comparison/overall.svg",
                        alt: 'A screenshot of a graphic organizer with two yellow text boxes at the top with terms to compare. Arrows flow from the bottom of each yellow box and join to point to a larger white text box with the phrase "Types of space phenomena."'
                    }
                },
                tooltip: {
                    key: "overall concept",
                    definition: "The overall concept is a big category that includes both concepts."
                }
            },
            {
                stepnum: 5,
                key: "characteristics",
                title: "What are the key characteristics?",
                description: "List the characteristics of Concept A and Concept B. Keep in mind that you will want to list characteristics that are similar and different between the two concepts.",
                info: {
                    label: "Characteristics",
                    text: [
                        "Solar and lunar eclipses each have *characteristics* that make them unique. Use the \u201CAdd Characteristic\u201D button to create a list of defining characteristics under each concept.",
                        "Here, you could list the following characteristic under solar eclipse: \u201CSolar eclipses happen during the day.\u201D"
                    ],
                    image: {
                        src: "/example/comparison/characteristics.svg",
                        alt: "A screenshot of a graphic organizer with \u201CSolar Eclipse\u201D as the heading in a yellow text box. Below is a white text box with the text \u201CSolar eclipses happen during the day.\u201D"
                    }
                },
                tooltip: {
                    key: "key characteristics",
                    definition: "Key characteristics describe the traits or features of a concept that make it unique."
                }
            },
            {
                stepnum: 6,
                key: "likeCharacteristics",
                title: "What characteristics are similar?",
                description: "Match any characteristics that are the same or close to the same. Some characteristics may not have a match.",
                info: {
                    label: "Like Characteristics",
                    text: [
                        "Solar and lunar eclipses have *similarities*. To connect these similarities, click the \u201CMake similar pair\u201D button. Click the characteristics you would like to pair and press the \u201CAdd Pair\u201D button.",
                        "For example, \u201CDepending on the alignment of the earth, sun, and moon, you could see a total or partial solar eclipse\u201D and \u201CDepending on the alignment of the earth, sun, and moon, you could see a total or partial lunar eclipse\u201D are a *similar* pair."
                    ],
                    image: {
                        src: "/example/comparison/likecharacteristics.svg",
                        alt: 'A screenshot of a graphic organizer. Two yellow text boxes are side by side at the top forming columns. Each yellow text box contains a concept: one box contains "Solar Eclipse" and the other box contains "Lunar Eclipse". Below each column are bulleted text. Below "Solar Eclipse" is the bulleted text: "Depending on the alignment of the earth, sun, and moon, you could see a total or partial solar eclipse." And below "Lunar Eclipse" is the bulleted text: "Depending on the alignment of the earth, sun, and moon, you could see a total or partial lunar eclipse." Below the text in the bullet points is a green button that says \u201CAdd Pair.\u201D'
                    }
                },
                tooltip: {
                    key: "similar",
                    definition: "Similar characteristics are related or have something in common."
                }
            },
            {
                stepnum: 7,
                key: "likeCategories",
                title: "What category describes each similar pair?",
                description: "Create a big category that describes how each similar pair is connected.",
                info: {
                    label: "Like Categories",
                    text: [
                        '',
                        "For example, solar and lunar eclipses are both fully or partially visible based on the alignment of the sun, moon, and earth.  The category for this similar pair is:  \u201CThe amount of eclipse that could occur.\u201D"
                    ],
                    image: {
                        src: "/example/comparison/likecategories.svg",
                        alt: 'A screenshot of a graphic organizer with two yellow text boxes at the top with comparative phrases. One text box has the phrase "Depending on the alignment of the earth, sun, and moon, you could see a total or partial solar eclipse." The other text box has the phrase "Depending on the alignment of the earth, sun, and moon, you could see a total or partial lunar eclipse." Arrows flow from the bottom of each yellow box and join to point to a larger white text box below with a categorizing phrase: "The amount of eclipse that could occur.\u201D'
                    }
                },
                tooltip: {
                    key: "category",
                    definition: "The similar pair category is a label for a group that both characteristics belong to."
                }
            },
            {
                stepnum: 8,
                key: "unlikeCharacteristics",
                title: "What characteristics are different?",
                description: "Match any characteristics that are different. Some characteristics may not have a match.",
                info: {
                    label: "Unlike Characteristics",
                    text: [
                        "Solar and lunar eclipses have *differences*. To connect these differences, click the \u201CMake pair\u201D button. Click the characteristics you would like to pair and press the \u201CAdd Pair\u201D button.",
                        "The statements \u201CSolar eclipses happen during the day\u201D and \u201CLunar eclipses can be seen at night\u201D are a *different* pair."
                    ],
                    image: {
                        src: "/example/comparison/unlikecharacteristics.svg",
                        alt: 'A screenshot of a graphic organizer. Two yellow text boxes are side by side at the top forming columns. Each yellow text box contains a concept: one box contains "Solar eclipse" and the other box contains "Lunar eclipse". Below each column are bulleted text. Below "Solar eclipse" is the bulleted text: \u201CSolar eclipses happen during the day\u201D and below "Lunar eclipse" is the bulleted text: \u201CLunar eclipses can be seen at night.\u201D Below the text in the bullet points is a green button that says \u201CAdd Pair.\u201D'
                    }
                },
                tooltip: {
                    key: "different",
                    definition: "Different characteristics are contrasting or opposite."
                }
            },
            {
                stepnum: 9,
                key: "unlikeCategories",
                title: "What category describes each different pair?",
                description: "Create a big category that describes how each different pair is connected.",
                info: {
                    label: "Unlike Categories",
                    text: [
                        '',
                        "For example, the characteristics \u201CSolar eclipses happen during the day\u201D and \u201CLunar eclipses can be seen at night\u201D belong to the same category: \u201CThe time of day when an eclipse could occur.\u201D"
                    ],
                    image: {
                        src: "/example/comparison/unlikecategories.svg",
                        alt: 'A screenshot of a graphic organizer with two yellow text boxes at the top with comparative phrases. One text box has the phrase "Solar eclipses happen during the day" The other text box has the phrase \u201CLunar eclipses can be seen at night.\u201D Arrows flow from the bottom of each yellow box and join to point to a larger white text box below with a categorizing phrase: "The time of day when an eclipse could occur.\u201D'
                    }
                },
                tooltip: {
                    key: "category",
                    definition: "The different pair category is a label for a group that both characteristics belong to."
                }
            },
            {
                stepnum: 10,
                key: "summary",
                title: "What is the summary?",
                description: "Summarize what you\u2019ve learned through your exploration of this comparison.",
                info: {
                    label: "Summary",
                    text: [
                        "A *summary* is a brief explanation that includes main points and evidence of what you have learned.\nThe purpose of the summary is to respond to the essential question using the comparison you\u2019ve performed.\nThis summary would include the similar and different characteristics between solar and lunar eclipses as well as the categories that connect those characteristics.\n",
                        ''
                    ]
                },
                tooltip: {
                    key: "summary",
                    definition: "The summary is your response to the essential question based on what you\u2019ve learned."
                }
            },
            {
                stepnum: 11,
                key: "extensions",
                title: "Extensions",
                description: "What additional questions has this exploration generated?"
            },
            {
                stepnum: 12,
                key: "complete",
                title: "Review",
                description: "Check your understanding of the Comparison you've explored. When the guide is complete, go to the 'Create & Share' page.",
                likeLabel: "Similar Characteristic pair",
                unlikeLabel: "Different Characteristic pair"
            },
            {
                key: "create-share",
                title: "Create and Share"
            }
        ],
        essentialquestion: {
            placeholder: "The essential question I am exploring is...",
            empty: "You have not yet entered an Essential Question."
        },
        concept1: {
            label: "Concept A",
            singleLabel: "Concepts",
            help: 'Take the example of Glaciers vs. Aquifers, we\'ll use these concepts to help you fill out this guide. Glaciers and aquifers are types of freshwater natural resources. In this first step you would list and define your concept.\n\n_For example, you can list glaciers and add the definition; "A huge mass of ice and snow that forms where snow gathers faster than it melts". You can also add an image to help visualize your definition._',
            placeholder: "Concept A",
            empty: "You have not yet entered a title of Concept A"
        },
        concept2: {
            label: "Concept B",
            singleLabel: "Concepts",
            help: "Take the example of {example}, we'll use these concepts to help you fill out this guide. Glaciers and aquifers are types of freshwater natural resources. In this first step you would list and define your concept.\n\n_For example, you can list glaciers and add the definition; \"A huge mass of ice and snow that forms where snow gathersfaster than it melts\u201D. You can also add an image to help visualize your definition._",
            placeholder: "Concept B",
            empty: "You have not yet entered a title of Concept B"
        },
        description1: {
            label: "Describe Concept A",
            singleLabel: "Concept Descriptions",
            placeholder: "I would describe Concept A as...",
            empty: "You have not yet entered a description of Concept A"
        },
        description2: {
            label: "Describe Concept B",
            placeholder: "I would describe Concept B as...",
            empty: "You have not yet entered a description of Concept B"
        },
        terms: {
            label: "Key Terms",
            singleLabel: "Key Terms",
            description: "define key terms that we need to know in order to complete the comparison.",
            termPlaceholder: "Enter the key term",
            defPlaceholder: "Enter the definition",
            empty: "You have not yet entered any Key Terms.",
            term: {
                label: "Word or Phrase",
                placeholder: "Enter the key term"
            },
            def: {
                label: "Definition",
                placeholder: "Enter the definition"
            },
            info: {
                label: "Key Terms",
                text: [
                    "Knowing key terms can help you learn content and demonstrate your understanding. Here is where you add 3-5 key terms that relate to your topic. If you understand the meaning of the terms simply add your own definition. If you need help with their meaning simply search the CORGI dictionary and then add a definition that makes sense.",
                    ""
                ]
            }
        },
        overall: {
            label: "The Overall Concept",
            singleLabel: "The Overall Concept",
            help: "Glaciers and aquifers both contain large amounts of freshwater. The overall concept for this comparison guide is: '*Sources of freshwater*'",
            placeholder: "Concept A and Concept B are both examples of...",
            empty: "You have not yet entered an Overall Concept"
        },
        characteristics1: {
            label: "Characteristics",
            singleLabel: "Characteristics",
            help: "Glaciers and aquifers each have characteristics that make them unique. Use the '*Add Characteristic*' button to create a list of defining characteristics under each concept.\n\n_Here you could list the following characteristic under *glaciers*: \"Huge mass of ice that moves slowly over land.\"_",
            placeholder: "A characteristic of Concept A is...",
            delete: "Remove this characteristic?",
            empty: "You have not yet entered any Characteristics of Concept A"
        },
        characteristics2: {
            label: "Characteristics",
            help: "Glaciers and aquifers each have characteristics that make them unique. Use the '*Add Characteristic*' button to create a list of defining characteristics under each concept.\n\n_Here you could list the following characteristic under *glaciers*: \"Huge mass of ice that moves slowly over land.\"_",
            placeholder: "A characteristic of Concept B is...",
            delete: "Remove this characteristic?",
            empty: "You have not yet entered any Characteristics of Concept B"
        },
        likecharacteristics: {
            label: "Like Characteristics",
            singleLabel: "Like characteristic",
            buttonText: "Make pair",
            modalTitle: "Find a similar pair",
            help: 'Glaciers and aquifers have similarities. To connect these similarities, click the "*Make similar pair*" button. Click the characteristics you would like to pair and press the "*Add Pair*" button.\n\n_As an example "The most important resource provided by glaciers is freshwater" and "Aquifers provide an important resource of freshwater" are *similar* because they are sources of freshwater._',
            delete: "Unpair these similar characteristics?",
            deleteInstructions: "(Unpairing a characteristic pair does not remove the characteristics from the guide)",
            empty: "You have not yet entered any Similar Characteristics"
        },
        likecategories: {
            label: "Like Categories",
            singleLabel: "Category",
            help: "For example, glaciers and aquifers are both disappearing because of depletion. The category for this similar pair is:  \u2018*Important resources of freshwater for people.*\u2019",
            placeholder: "The category that describes this similar pair is..."
        },
        unlikecharacteristics: {
            label: "Unlike Characteristics",
            singleLabel: "Unlike characteristic",
            secondaryLabel: "Unlike characteristic of B",
            buttonText: "Make pair",
            modalTitle: "Find a different pair",
            help: 'Glaciers and aquifers have differences. To identify these differences, click the "*Make pair*" button. Click the characteristics you would like to pair and press the "*Add Pair*" button.\n\n_The statements "Glaciers begin forming in places where more snow piles up each year than melts" and "Aquifers form when rain falls and snow melts and some of it sinks into the earth, and ends up inside the underlying rocks" show that both features are *different*._',
            delete: "Unpair these different characteristics?",
            deleteInstructions: "(Unpairing a characteristic pair does not remove the characteristics from the guide)",
            empty: "You have not yet entered any Different Characteristics"
        },
        unlikecategories: {
            label: "Unlike Categories",
            singleLabel: "Category",
            help: "For example, glaciers and aquifers are created differently and contain different features. The category for this pair is:\n\u2018*Defining characteristics of natural features.*\u2019",
            placeholder: "The category that describes this pair is..."
        },
        summary: {
            label: "Summary",
            singleLabel: "Summary",
            help: "A summary is a brief explanation that includes main points and evidence of what you have learned.\n\n_This summary would include statements about the similarities and differences between glaciers and aquifers. It includes statements about their importance, their features, and the need to conserve them._",
            placeholder: "In conclusion, after comparing Concept A and Concept B, I have learned...",
            empty: "You have not yet entered a Summary"
        },
        extensions: {
            label: "Extensions",
            singleLabel: "Extensions",
            help: "Your teacher will add an extension so that we can use our understandings in new situations.",
            placeholder: "Write your extension here.",
            empty: "You have not yet entered any Extensions"
        }
    },
    library: [
        {
            title: "Chemical Reaction",
            overview: "https://docs.google.com/document/d/1CjOx1YQWrYfUrfewnIJoon7D8HN_SZR_o2UCR784SUU/edit?usp=sharing",
            level: "Grades 6-8",
            tags: [
                "Physical Science"
            ],
            description: "In this unit, students will explore matter and its interactions in the form of chemical reactions. They will understand what happens to atoms when substances react in a chemical process, how chemical reactions affect the number of atoms involved (thus the mass of reactants vs. mass of products), and what the characteristics of exothermic and endothermic chemical reactions are.",
            lessons: [
                {
                    title: "Atoms, Substances, & Chemical Reactions",
                    type: "question-exp",
                    id: "1IHXEwdoMl0aY0rnYN8iwZRGUyXaoleXG"
                },
                {
                    title: "Conservation of Mass during a Chemical Reaction",
                    type: "cause-effect",
                    id: "13I2eOchCJ24FfADppkd5hIfYEZd2cRaZ"
                },
                {
                    title: "Exothermic & Endothermic Chemical Reaction",
                    type: "comparison",
                    id: "1AUL-5ngU44Ts10K3LRTn5XGcOWVzDpX9"
                }
            ]
        },
        {
            title: "Cycles of Matter and Energy Transfer in Ecosystems",
            overview: "https://docs.google.com/document/d/1zQqvaF7d7T0BVNSdLNEoNOUqwpU2PXms9vW8Ct06Nd8/edit",
            level: "Grades 6-8",
            tags: [
                "Physical Science"
            ],
            description: "In this 3-lesson unit, students will explore how cycles of matter and energy transfer. They will understand how matter cycles through living and nonliving parts in an ecosystem, explore how energy flows, and understand the characteristics of matter cycles and energy flows in an ecosystem.",
            lessons: [
                {
                    title: "Movement of Matter and Energy in an Ecosystem",
                    type: "comparison",
                    id: "1Lq9fkDho785VDEBw-FoSJYU5HiIRw0V1"
                },
                {
                    title: "Energy Flow Within and Outside of an Ecosystem",
                    type: "question-exp",
                    id: "1tvVjprFbmmZwEquUWx8UtvJVrDSeS4da"
                },
                {
                    title: "Matter Cycles in an Ecosystem",
                    type: "question-exp",
                    id: "1G_Q6zaLJUP3FtYi-agOvlOovmkUfXVaJ"
                }
            ]
        },
        {
            title: "Earth's Place in the Universe",
            overview: "https://docs.google.com/document/d/1dAB-lNMeE-E38YOxARfWgHytGgQ0Jq9f0H16WyvXqw8/edit",
            level: "Grades 6-8",
            tags: [
                "Earth Science"
            ],
            description: "In this unit, students will explore the place Earth has within our solar system. They will understand how the relationship between the Earth, its moon, and the sun cause a variety of phenomena we experience on Earth, such as day and night, the seasons, and eclipses.",
            lessons: [
                {
                    title: "Solar vs. Lunar Eclipses",
                    type: "comparison",
                    id: "1NO9IQpQrN_nWoNreKvD-uXXRNZ1-XMz9"
                },
                {
                    title: "The Seasons",
                    type: "cause-effect",
                    id: "16RFu_D_vwdxx9oIpCnDTm7wLHtHNZdVz"
                },
                {
                    title: "The Equinox & Solstice",
                    type: "question-exp",
                    id: "1bLSSyAWJ7NTRgTSHxJr6ekir-19SbWLw"
                },
                {
                    title: "Daylight Savings Time",
                    type: "cera",
                    id: "13--h0IKpwhKR6q8Qo004M7AWlRrMG-Ke"
                }
            ]
        },
        {
            title: "Forces and Interactions",
            overview: "https://docs.google.com/document/d/1ljhy0pjVT9fhp-m4PZ2cLC4Ngr3N-vGRlpftqcUqgXQ/edit",
            level: "Grades 6-8",
            tags: [
                "Physical Science"
            ],
            description: "In this unit, students will explore Newton\u2019s Law of Motion. They will understand how electromagnetic forces attract or repel and the interaction of gravitational force.",
            lessons: [
                {
                    title: "Newton\u2019s Law of Motion",
                    type: "cause-effect",
                    id: "19vSj4blbjeC81YANpk7Uj22c58hYGtqQ"
                },
                {
                    title: "Electric & Magnetic Force",
                    type: "comparison",
                    id: "1cLas8HNNCsSmoWJYgqwi_GiRdtqeuUMI"
                },
                {
                    title: "Gravitational Forces",
                    type: "question-exp",
                    id: "10HWyXvDZZeHwczb16nyAD-JzOJ3DeYTj"
                }
            ]
        },
        {
            title: "Global Climate Change",
            overview: "https://docs.google.com/document/d/1tjErHzI_Zk6rhVc-jpgGQIirz67w-TRmKIWQDfIeR04/edit?usp=sharing",
            level: "Grades 6-8",
            tags: [
                "Earth Science"
            ],
            description: "In this unit, students will explore how natural processes and human activities have impacted global temperatures, as well as explore how humans can adapt to reduce their impact on global climate change for the future.",
            lessons: [
                {
                    title: "Natural Processes & Human Activities Affect Global Temperatures",
                    type: "comparison",
                    id: "1M2tFLp1WDWc7v7Xy-8u1JDOdA7BxHuZw"
                },
                {
                    title: "Human Activities Impact Climate Change",
                    type: "cera",
                    id: "1ejwAuThL32LKvjM_FYpymhjKFcIKpYkt"
                },
                {
                    title: "Human Activities Contributing to Global Warming",
                    type: "cause-effect",
                    id: "160dE_Nd3HWGjKdVVACFuhXd-Grq5SFd2"
                },
                {
                    title: "Humans Can Reduce Their Impact On Climate Change",
                    type: "question-exp",
                    id: "1jUEq2QoGdAZIZcJSdbGcn8uHAQl4gTfA"
                }
            ]
        },
        {
            title: "Heredity",
            overview: "https://docs.google.com/document/d/1wITI3vvTorlYBP7g2TrmIC92QjBaO0aZ-M_XujoBCq0/edit?usp=sharing",
            level: "Grades 6-8",
            tags: [
                "Life Science"
            ],
            description: "In this abbreviated unit, students will explore inheritance and variation of traits. They will understand the growth of organisms and how organisms inherit traits and why there are variations in traits of offspring.",
            lessons: [
                {
                    title: "Asexual & Sexual Reproduction",
                    type: "comparison",
                    id: "1PxfjRMcPC9_YbTTj0BaJyZx9TFZ5avvh"
                },
                {
                    title: "Genetic Variation in Sexually Reproducing Organisms",
                    type: "cause-effect",
                    id: "1qgDst4lMnsZ6wB0_4D49C9t415kIfbRW"
                },
                {
                    title: "Role of Genes in Making Protein Molecules",
                    type: "question-exp",
                    id: "1EYOyfsiYTnV5WnLQlfbmDma5ZGQ-mhS_"
                },
                {
                    title: "Mutations",
                    type: "cause-effect",
                    id: "1XgCJjQiSXJJ4PVdMMa8nOD_7leqYgsMi"
                }
            ]
        },
        {
            title: "Kinetic and Potential Energy",
            overview: "https://docs.google.com/document/d/12zD7dTE_krWk19xS28-4Jh7UXin3awMgB71DN7ZzScI/edit?usp=sharing",
            level: "Grades 6-8",
            tags: [
                "Physical Science"
            ],
            description: "In this unit, students will explore kinetic and potential energy. They will understand the relationship between kinetic energy, mass, and velocity, as well as the relationship between potential energy, mass, and height.",
            lessons: [
                {
                    title: "Potential Energy and Mass or Height",
                    type: "question-exp",
                    id: "16SZ-6iJycE0L-jBYD_FLwn1o_wJwrpxq"
                },
                {
                    title: "Kinetic Energy and Mass or Velocity - A",
                    type: "cause-effect",
                    id: "1WruV7BpHq9pynPQWdO18Beg1_Fx8JkUy"
                },
                {
                    title: "Kinetic Energy and Mass or Velocity - B",
                    type: "question-exp",
                    id: "1mkpx2tR2I6WcZRR7R_mCpgHwwlBUWuPn"
                },
                {
                    title: "Kinetic & Potential Energy",
                    type: "comparison",
                    id: "1AOiwi5wFOQUvqVHvuLB7VNJdn6YjKrwh"
                }
            ]
        },
        {
            title: "Natural Resources and Natural Hazards",
            overview: "https://docs.google.com/document/d/13hZMEU6dftjb_5SUKHXXg6O63gzK4J8eAY9fjp3TEwM/edit?usp=sharing",
            level: "Grades 6-8",
            tags: [
                "Earth Science"
            ],
            description: "In this 3-lesson unit, students will explore different natural resources humans depend on and map and predict future natural hazards. They will understand the relationship of geographic distributions of natural resources, renewable and nonrenewable resources of groundwater, and natural hazards.",
            lessons: [
                {
                    title: "Unequal Distribution of Earth\u2019s Resources",
                    type: "cera",
                    id: "1QIBG6W79aQ5--gUrtCHrlemqWtliFcsQ"
                },
                {
                    title: "Renewable and Nonrenewable Groundwater",
                    type: "comparison",
                    id: "1wNuYAWKa7TMaARKZQESm3K4kvMSCUZYF"
                },
                {
                    title: "Predicting Natural Hazards",
                    type: "question-exp",
                    id: "1Wi4qKA_5kZBqv7XsVoD1Fb8L2fl19aHG"
                }
            ]
        },
        {
            title: "Natural Selection and Adaptation",
            overview: "https://docs.google.com/document/d/1d4Y7bMFfjqyPPihYhE8OeR5kLH3qFq857TtteK9ayuA/edit?usp=sharing",
            level: "Grades 6-8",
            tags: [
                "Life Science"
            ],
            description: "In this unit, students will explore how natural selection and adaptation affect biological evolution and diversity. They will understand how natural selection leads to predominance of certain traits, characteristics of natural and artificial selection, and the impacts of environmental changes on the distribution of traits in a species.",
            lessons: [
                {
                    title: "Natural Selection and Adaptation",
                    type: "question-exp",
                    id: "1oXGX8aiUPOoGF6h4vdrejzVFbDoMbfPs"
                },
                {
                    title: "Natural Selection & Artificial Selection",
                    type: "comparison",
                    id: "1eX83dKrPmKw6RVzmcN4gWylEAuhRp9hJ"
                },
                {
                    title: "Distribution of Traits in a Species",
                    type: "cause-effect",
                    id: "13NoDRdirhkeD1DZoI9RGvcWhFjYRGRwE"
                }
            ]
        },
        {
            title: "Structure and Properties of Matter and its Interactions",
            overview: "https://docs.google.com/document/d/1mwgCBJUCkSDcX-ji1kHCxwEWzYA0k40HTyCrgmFPm7w/edit?usp=sharing",
            level: "Grades 6-8",
            tags: [
                "Physical Science"
            ],
            description: "In this 4-lesson unit, students will explore and understand the fundamental principles governing the composition, structure, and behavior of matter, and how matter interacts with other substances and energy.",
            lessons: [
                {
                    title: "How Atoms Combine To Create Pure Substance",
                    type: "cause-effect",
                    id: "1EsIkkdpbRTDFDCg4DZGkXSxSiYGYl1zK"
                },
                {
                    title: "How Pressure and Temperature Affect States of Matter",
                    type: "cause-effect",
                    id: "1BxFDtr1DGjFOoPHrDztHpLmn9PMgsJtc"
                },
                {
                    title: "Crystalline & Amorphous Solids",
                    type: "comparison",
                    id: "1aYE-ZQRVxImjEpUV7o5twhImXpIIYLlV"
                },
                {
                    title: "Physical & Chemical Properties Of Pure Substances",
                    type: "question-exp",
                    id: "1eUJQl0olouEoZWry09gyPJ79_8_YsImm"
                }
            ]
        }
    ]
};
var $198066ba87364cec$export$2e2bcd8739ae039 = $198066ba87364cec$var$texts;



var $6wXVr = parcelRequire("6wXVr");
var $c83591d04bda8b2b$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c83591d04bda8b2b$var$ReactIs, $c83591d04bda8b2b$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$c83591d04bda8b2b$exports = (parcelRequire("hhMOc"))();



var $6wXVr = parcelRequire("6wXVr");

class $d8775d5311bbf499$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    componentDidMount() {
        //console.log("Mounted: ", this, ReactDOM.findDOMNode(this));
        this.tagForTTS((0, (/*@__PURE__*/$parcel$interopDefault($39d800d77e473b3f$exports))).findDOMNode(this));
    }
    componentDidUpdate() {
        //console.log("Updated: ", this, ReactDOM.findDOMNode(this));
        this.tagForTTS((0, (/*@__PURE__*/$parcel$interopDefault($39d800d77e473b3f$exports))).findDOMNode(this));
    }
    tagForTTS(node) {
        // Have to check since this can get called before texthelp toolbar has been loaded.
        if (window.$rw_parseNewSection && window.$rw_isPageLoaded()) window.$rw_parseNewSection(node);
    }
    // make Error Boundary https://reactjs.org/docs/error-boundaries.html
    constructor(props){
        super(props);
        this.state = undefined !== props && props.state ? props.state : {};
        this.state.hasError = false;
    }
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: false
        };
    }
    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.log(error.message, errorInfo.componentStack);
    }
}




var $6wXVr = parcelRequire("6wXVr");

const $21f9ebdc444decaf$export$6e22c362a0406a2c = (string)=>{
    return undefined === string || null === string || 0 === string.trim().length;
};
const $21f9ebdc444decaf$export$b3aa3c8c005aa38c = (key, fragment, sep)=>{
    const prefix = $21f9ebdc444decaf$export$6e22c362a0406a2c(key) ? '' : sep;
    return key + (!$21f9ebdc444decaf$export$6e22c362a0406a2c(fragment) ? prefix + fragment : '');
};


// type.identifier.item
const $d6bad315ad35dae0$var$GetText = (props)=>{
    var key = "";
    if ((0, $21f9ebdc444decaf$export$6e22c362a0406a2c)(props.key)) {
        key = (0, $21f9ebdc444decaf$export$b3aa3c8c005aa38c)(key, props.type, '.');
        key = (0, $21f9ebdc444decaf$export$b3aa3c8c005aa38c)(key, props.identifier, '.');
        key = (0, $21f9ebdc444decaf$export$b3aa3c8c005aa38c)(key, props.item, '.');
    } else key = props.key;
    return props.tag ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).text, {
        tag: props.tag,
        text: key
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(key);
};
var $d6bad315ad35dae0$export$2e2bcd8739ae039 = $d6bad315ad35dae0$var$GetText;




var $6wXVr = parcelRequire("6wXVr");
const $0f09ddde1e7ea4cb$var$AppContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createContext({});
var $0f09ddde1e7ea4cb$export$2e2bcd8739ae039 = $0f09ddde1e7ea4cb$var$AppContext;
class $0f09ddde1e7ea4cb$export$20d2b7652facc723 extends (0, $6wXVr.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($0f09ddde1e7ea4cb$var$AppContext.Provider, {
            value: this.props.value
        }, this.props.children);
    }
}




var $6wXVr = parcelRequire("6wXVr");
function $37ba0e6d5a59440b$export$2c618a4308a30424(docType, docId, section, hash) {
    const doc = {
        section: section,
        type: docType,
        id: docId
    };
    const sectionSep = '/'; // #?
    const type = 'unit-org-2' === docType ? 'unit-organizer' : docType;
    var location = "/" + type + "/" + docId + (section ? sectionSep + section : "");
    // FIXME: temporally only support Comparison
    if (docType !== 'comparison' && docType !== 'cause-effect' && docType !== 'question-exp' && docType !== 'cera') location = '/docs';
    return {
        pathname: location,
        state: doc,
        hash: hash
    };
}



function $a42a7806547d87ca$export$2e2bcd8739ae039(t, e) {
    return $a42a7806547d87ca$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $a42a7806547d87ca$export$2e2bcd8739ae039(t, e);
}


function $d88944f419270775$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $a42a7806547d87ca$export$2e2bcd8739ae039)(t, o);
}



var $6wXVr = parcelRequire("6wXVr");

function $0880524001953467$export$2e2bcd8739ae039() {
    return $0880524001953467$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0880524001953467$export$2e2bcd8739ae039.apply(null, arguments);
}


function $8da10516c75361be$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $8da10516c75361be$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $8da10516c75361be$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $8da10516c75361be$var$isAbsolute(to);
    var isFromAbs = from && $8da10516c75361be$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $8da10516c75361be$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $8da10516c75361be$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $8da10516c75361be$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $8da10516c75361be$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$8da10516c75361be$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $8da10516c75361be$export$2e2bcd8739ae039 = $8da10516c75361be$var$resolvePathname;


function $6210a2ad3829c836$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $6210a2ad3829c836$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $6210a2ad3829c836$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $6210a2ad3829c836$var$valueOf(a);
        var bValue = $6210a2ad3829c836$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $6210a2ad3829c836$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $6210a2ad3829c836$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $6210a2ad3829c836$export$2e2bcd8739ae039 = $6210a2ad3829c836$var$valueEqual;



var $999fb696ed0e9e3a$var$isProduction = true;
var $999fb696ed0e9e3a$var$prefix = 'Invariant failed';
function $999fb696ed0e9e3a$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($999fb696ed0e9e3a$var$isProduction) throw new Error($999fb696ed0e9e3a$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($999fb696ed0e9e3a$var$prefix, ": ").concat(provided) : $999fb696ed0e9e3a$var$prefix;
    throw new Error(value);
}


function $957fd8ce316388b9$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $957fd8ce316388b9$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $957fd8ce316388b9$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $957fd8ce316388b9$var$stripBasename(path, prefix) {
    return $957fd8ce316388b9$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $957fd8ce316388b9$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $957fd8ce316388b9$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $957fd8ce316388b9$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $957fd8ce316388b9$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $957fd8ce316388b9$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $0880524001953467$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $8da10516c75361be$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $957fd8ce316388b9$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $6210a2ad3829c836$export$2e2bcd8739ae039)(a.state, b.state);
}
function $957fd8ce316388b9$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $957fd8ce316388b9$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $957fd8ce316388b9$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $957fd8ce316388b9$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $957fd8ce316388b9$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $957fd8ce316388b9$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $957fd8ce316388b9$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $957fd8ce316388b9$var$PopStateEvent = 'popstate';
var $957fd8ce316388b9$var$HashChangeEvent = 'hashchange';
function $957fd8ce316388b9$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $957fd8ce316388b9$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$957fd8ce316388b9$var$canUseDOM && (0, $999fb696ed0e9e3a$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $957fd8ce316388b9$var$supportsHistory();
    var needsHashChangeListener = !$957fd8ce316388b9$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $957fd8ce316388b9$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $957fd8ce316388b9$var$stripTrailingSlash($957fd8ce316388b9$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $957fd8ce316388b9$var$stripBasename(path, basename);
        return $957fd8ce316388b9$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $957fd8ce316388b9$var$createTransitionManager();
    function setState(nextState) {
        (0, $0880524001953467$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($957fd8ce316388b9$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($957fd8ce316388b9$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($957fd8ce316388b9$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $957fd8ce316388b9$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $957fd8ce316388b9$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $957fd8ce316388b9$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($957fd8ce316388b9$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($957fd8ce316388b9$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($957fd8ce316388b9$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($957fd8ce316388b9$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $957fd8ce316388b9$var$HashChangeEvent$1 = 'hashchange';
var $957fd8ce316388b9$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $957fd8ce316388b9$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $957fd8ce316388b9$var$stripLeadingSlash,
        decodePath: $957fd8ce316388b9$var$addLeadingSlash
    },
    slash: {
        encodePath: $957fd8ce316388b9$var$addLeadingSlash,
        decodePath: $957fd8ce316388b9$var$addLeadingSlash
    }
};
function $957fd8ce316388b9$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $957fd8ce316388b9$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $957fd8ce316388b9$var$pushHashPath(path) {
    window.location.hash = path;
}
function $957fd8ce316388b9$var$replaceHashPath(path) {
    window.location.replace($957fd8ce316388b9$var$stripHash(window.location.href) + '#' + path);
}
function $957fd8ce316388b9$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$957fd8ce316388b9$var$canUseDOM && (0, $999fb696ed0e9e3a$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $957fd8ce316388b9$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $957fd8ce316388b9$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $957fd8ce316388b9$var$stripTrailingSlash($957fd8ce316388b9$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $957fd8ce316388b9$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($957fd8ce316388b9$var$getHashPath());
        if (basename) path = $957fd8ce316388b9$var$stripBasename(path, basename);
        return $957fd8ce316388b9$export$90c043f1c57770b8(path);
    }
    var transitionManager = $957fd8ce316388b9$var$createTransitionManager();
    function setState(nextState) {
        (0, $0880524001953467$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $957fd8ce316388b9$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $957fd8ce316388b9$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $957fd8ce316388b9$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($957fd8ce316388b9$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($957fd8ce316388b9$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $957fd8ce316388b9$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $957fd8ce316388b9$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $957fd8ce316388b9$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $957fd8ce316388b9$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $957fd8ce316388b9$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $957fd8ce316388b9$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $957fd8ce316388b9$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $957fd8ce316388b9$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $957fd8ce316388b9$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($957fd8ce316388b9$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $957fd8ce316388b9$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $957fd8ce316388b9$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $957fd8ce316388b9$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $957fd8ce316388b9$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($957fd8ce316388b9$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($957fd8ce316388b9$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($957fd8ce316388b9$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $957fd8ce316388b9$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $957fd8ce316388b9$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $957fd8ce316388b9$var$createTransitionManager();
    function setState(nextState) {
        (0, $0880524001953467$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $957fd8ce316388b9$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $957fd8ce316388b9$export$90c043f1c57770b8(entry, undefined, createKey()) : $957fd8ce316388b9$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $957fd8ce316388b9$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $957fd8ce316388b9$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $957fd8ce316388b9$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $957fd8ce316388b9$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}





var $3defa6dbe9f3e3cf$exports = {};
var $b19758b74b65b4f7$exports = {};
$b19758b74b65b4f7$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};


/**
 * Expose `pathToRegexp`.
 */ $3defa6dbe9f3e3cf$exports = $3defa6dbe9f3e3cf$var$pathToRegexp;
$3defa6dbe9f3e3cf$exports.parse = $3defa6dbe9f3e3cf$var$parse;
$3defa6dbe9f3e3cf$exports.compile = $3defa6dbe9f3e3cf$var$compile;
$3defa6dbe9f3e3cf$exports.tokensToFunction = $3defa6dbe9f3e3cf$var$tokensToFunction;
$3defa6dbe9f3e3cf$exports.tokensToRegExp = $3defa6dbe9f3e3cf$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $3defa6dbe9f3e3cf$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $3defa6dbe9f3e3cf$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $3defa6dbe9f3e3cf$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $3defa6dbe9f3e3cf$var$escapeGroup(pattern) : asterisk ? '.*' : $3defa6dbe9f3e3cf$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $3defa6dbe9f3e3cf$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $3defa6dbe9f3e3cf$var$escapeString(delimiter) + ']+?';
    return $3defa6dbe9f3e3cf$var$escapeString(prevText) + '|(?:(?!' + $3defa6dbe9f3e3cf$var$escapeString(prevText) + ')[^' + $3defa6dbe9f3e3cf$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $3defa6dbe9f3e3cf$var$compile(str, options) {
    return $3defa6dbe9f3e3cf$var$tokensToFunction($3defa6dbe9f3e3cf$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $3defa6dbe9f3e3cf$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $3defa6dbe9f3e3cf$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $3defa6dbe9f3e3cf$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $3defa6dbe9f3e3cf$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $3defa6dbe9f3e3cf$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($b19758b74b65b4f7$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $3defa6dbe9f3e3cf$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $3defa6dbe9f3e3cf$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $3defa6dbe9f3e3cf$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $3defa6dbe9f3e3cf$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $3defa6dbe9f3e3cf$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $3defa6dbe9f3e3cf$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $3defa6dbe9f3e3cf$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $3defa6dbe9f3e3cf$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($3defa6dbe9f3e3cf$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $3defa6dbe9f3e3cf$var$flags(options));
    return $3defa6dbe9f3e3cf$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $3defa6dbe9f3e3cf$var$stringToRegexp(path, keys, options) {
    return $3defa6dbe9f3e3cf$var$tokensToRegExp($3defa6dbe9f3e3cf$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $3defa6dbe9f3e3cf$var$tokensToRegExp(tokens, keys, options) {
    if (!$b19758b74b65b4f7$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $3defa6dbe9f3e3cf$var$escapeString(token);
        else {
            var prefix = $3defa6dbe9f3e3cf$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $3defa6dbe9f3e3cf$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $3defa6dbe9f3e3cf$var$attachKeys(new RegExp('^' + route, $3defa6dbe9f3e3cf$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $3defa6dbe9f3e3cf$var$pathToRegexp(path, keys, options) {
    if (!$b19758b74b65b4f7$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $3defa6dbe9f3e3cf$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($b19758b74b65b4f7$exports(path)) return $3defa6dbe9f3e3cf$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $3defa6dbe9f3e3cf$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $652a6fe866f059a7$exports = {};
'use strict';

$652a6fe866f059a7$exports = (parcelRequire("3iOUP"));


function $3bf266e5f300dc76$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


var $6d404afa15c02f43$exports = {};
'use strict';
var $301ffbec4f791f7a$exports = {};
'use strict';

$301ffbec4f791f7a$exports = (parcelRequire("e0Twa"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $6d404afa15c02f43$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $6d404afa15c02f43$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $6d404afa15c02f43$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $6d404afa15c02f43$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $6d404afa15c02f43$var$TYPE_STATICS = {};
$6d404afa15c02f43$var$TYPE_STATICS[$301ffbec4f791f7a$exports.ForwardRef] = $6d404afa15c02f43$var$FORWARD_REF_STATICS;
$6d404afa15c02f43$var$TYPE_STATICS[$301ffbec4f791f7a$exports.Memo] = $6d404afa15c02f43$var$MEMO_STATICS;
function $6d404afa15c02f43$var$getStatics(component) {
    // React v16.11 and below
    if ($301ffbec4f791f7a$exports.isMemo(component)) return $6d404afa15c02f43$var$MEMO_STATICS;
     // React v16.12 and above
    return $6d404afa15c02f43$var$TYPE_STATICS[component['$$typeof']] || $6d404afa15c02f43$var$REACT_STATICS;
}
var $6d404afa15c02f43$var$defineProperty = Object.defineProperty;
var $6d404afa15c02f43$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $6d404afa15c02f43$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $6d404afa15c02f43$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $6d404afa15c02f43$var$getPrototypeOf = Object.getPrototypeOf;
var $6d404afa15c02f43$var$objectPrototype = Object.prototype;
function $6d404afa15c02f43$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($6d404afa15c02f43$var$objectPrototype) {
            var inheritedComponent = $6d404afa15c02f43$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $6d404afa15c02f43$var$objectPrototype) $6d404afa15c02f43$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $6d404afa15c02f43$var$getOwnPropertyNames(sourceComponent);
        if ($6d404afa15c02f43$var$getOwnPropertySymbols) keys = keys.concat($6d404afa15c02f43$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $6d404afa15c02f43$var$getStatics(targetComponent);
        var sourceStatics = $6d404afa15c02f43$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$6d404afa15c02f43$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $6d404afa15c02f43$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $6d404afa15c02f43$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$6d404afa15c02f43$exports = $6d404afa15c02f43$var$hoistNonReactStatics;


var $fc353641e976e80e$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $fc353641e976e80e$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $fc353641e976e80e$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $fc353641e976e80e$var$commonjsGlobal[key] = ($fc353641e976e80e$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $fc353641e976e80e$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $fc353641e976e80e$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $fc353641e976e80e$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $fc353641e976e80e$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $fc353641e976e80e$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $d88944f419270775$export$2e2bcd8739ae039)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $fc353641e976e80e$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($fc353641e976e80e$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $fc353641e976e80e$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $d88944f419270775$export$2e2bcd8739ae039)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $fc353641e976e80e$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $fc353641e976e80e$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $fc353641e976e80e$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $fc353641e976e80e$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createContext || $fc353641e976e80e$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $fc353641e976e80e$var$createNamedContext = function createNamedContext(name) {
    var context = $fc353641e976e80e$var$createContext();
    context.displayName = name;
    return context;
};
var $fc353641e976e80e$export$c213558b66925821 = /*#__PURE__*/ $fc353641e976e80e$var$createNamedContext("Router-History");
var $fc353641e976e80e$export$63baa8ccbe60bb07 = /*#__PURE__*/ $fc353641e976e80e$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $fc353641e976e80e$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $d88944f419270775$export$2e2bcd8739ae039)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($fc353641e976e80e$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($fc353641e976e80e$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $fc353641e976e80e$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $d88944f419270775$export$2e2bcd8739ae039)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $957fd8ce316388b9$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($fc353641e976e80e$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component);
var $fc353641e976e80e$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $d88944f419270775$export$2e2bcd8739ae039)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $fc353641e976e80e$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($fc353641e976e80e$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $999fb696ed0e9e3a$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($fc353641e976e80e$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $fc353641e976e80e$var$messageType;
var $fc353641e976e80e$var$cache = {};
var $fc353641e976e80e$var$cacheLimit = 10000;
var $fc353641e976e80e$var$cacheCount = 0;
function $fc353641e976e80e$var$compilePath(path) {
    if ($fc353641e976e80e$var$cache[path]) return $fc353641e976e80e$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($3defa6dbe9f3e3cf$exports))).compile(path);
    if ($fc353641e976e80e$var$cacheCount < $fc353641e976e80e$var$cacheLimit) {
        $fc353641e976e80e$var$cache[path] = generator;
        $fc353641e976e80e$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $fc353641e976e80e$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $fc353641e976e80e$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $fc353641e976e80e$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($fc353641e976e80e$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $999fb696ed0e9e3a$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $957fd8ce316388b9$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $fc353641e976e80e$export$82476f982757e71e(to, computedMatch.params) : (0, $0880524001953467$export$2e2bcd8739ae039)({}, to, {
            pathname: $fc353641e976e80e$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($fc353641e976e80e$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $957fd8ce316388b9$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $957fd8ce316388b9$export$c3e8bb440bd55b18)(prevLocation, (0, $0880524001953467$export$2e2bcd8739ae039)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $fc353641e976e80e$var$cache$1 = {};
var $fc353641e976e80e$var$cacheLimit$1 = 10000;
var $fc353641e976e80e$var$cacheCount$1 = 0;
function $fc353641e976e80e$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $fc353641e976e80e$var$cache$1[cacheKey] || ($fc353641e976e80e$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($3defa6dbe9f3e3cf$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($fc353641e976e80e$var$cacheCount$1 < $fc353641e976e80e$var$cacheLimit$1) {
        pathCache[path] = result;
        $fc353641e976e80e$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $fc353641e976e80e$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $fc353641e976e80e$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $fc353641e976e80e$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Children.count(children) === 0;
}
function $fc353641e976e80e$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $fc353641e976e80e$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $d88944f419270775$export$2e2bcd8739ae039)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($fc353641e976e80e$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $999fb696ed0e9e3a$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $fc353641e976e80e$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $0880524001953467$export$2e2bcd8739ae039)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $fc353641e976e80e$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($fc353641e976e80e$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component);
function $fc353641e976e80e$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $fc353641e976e80e$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $0880524001953467$export$2e2bcd8739ae039)({}, location, {
        pathname: $fc353641e976e80e$var$addLeadingSlash(basename) + location.pathname
    });
}
function $fc353641e976e80e$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $fc353641e976e80e$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $0880524001953467$export$2e2bcd8739ae039)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $fc353641e976e80e$var$createURL(location) {
    return typeof location === "string" ? location : (0, $957fd8ce316388b9$export$fe53371bee54353d)(location);
}
function $fc353641e976e80e$var$staticHandler(methodName) {
    return function() {
        (0, $999fb696ed0e9e3a$export$2e2bcd8739ae039)(false);
    };
}
function $fc353641e976e80e$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $fc353641e976e80e$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $d88944f419270775$export$2e2bcd8739ae039)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $fc353641e976e80e$var$noop;
        };
        _this.handleBlock = function() {
            return $fc353641e976e80e$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $fc353641e976e80e$var$addBasename(basename, (0, $957fd8ce316388b9$export$90c043f1c57770b8)(location));
        context.url = $fc353641e976e80e$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $3bf266e5f300dc76$export$2e2bcd8739ae039)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $fc353641e976e80e$var$addLeadingSlash(basename + $fc353641e976e80e$var$createURL(path));
            },
            action: "POP",
            location: $fc353641e976e80e$var$stripBasename(basename, (0, $957fd8ce316388b9$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $fc353641e976e80e$var$staticHandler("go"),
            goBack: $fc353641e976e80e$var$staticHandler("goBack"),
            goForward: $fc353641e976e80e$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($fc353641e976e80e$export$55185c17a0fcbe46, (0, $0880524001953467$export$2e2bcd8739ae039)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $fc353641e976e80e$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $d88944f419270775$export$2e2bcd8739ae039)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($fc353641e976e80e$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $999fb696ed0e9e3a$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $fc353641e976e80e$export$81336c211d5ff295(location.pathname, (0, $0880524001953467$export$2e2bcd8739ae039)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $fc353641e976e80e$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $3bf266e5f300dc76$export$2e2bcd8739ae039)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($fc353641e976e80e$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $999fb696ed0e9e3a$export$2e2bcd8739ae039)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement(Component, (0, $0880524001953467$export$2e2bcd8739ae039)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6d404afa15c02f43$exports)))(C, Component);
}
var $fc353641e976e80e$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).useContext;
function $fc353641e976e80e$export$3420e1dc2c4a518c() {
    return $fc353641e976e80e$var$useContext($fc353641e976e80e$export$c213558b66925821);
}
function $fc353641e976e80e$export$45d76561a5302f2b() {
    return $fc353641e976e80e$var$useContext($fc353641e976e80e$export$63baa8ccbe60bb07).location;
}
function $fc353641e976e80e$export$99eaa27ddbbb95ef() {
    var match = $fc353641e976e80e$var$useContext($fc353641e976e80e$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $fc353641e976e80e$export$632be4bb944c1bc7(path) {
    var location = $fc353641e976e80e$export$45d76561a5302f2b();
    var match = $fc353641e976e80e$var$useContext($fc353641e976e80e$export$63baa8ccbe60bb07).match;
    return path ? $fc353641e976e80e$export$81336c211d5ff295(location.pathname, path) : match;
}
var $fc353641e976e80e$var$global$1, $fc353641e976e80e$var$key, $fc353641e976e80e$var$buildNames, $fc353641e976e80e$var$initialBuildName, $fc353641e976e80e$var$secondaryBuildName;




var $6wXVr = parcelRequire("6wXVr");






/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $923ec6a2a40b86c6$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $d88944f419270775$export$2e2bcd8739ae039)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $957fd8ce316388b9$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $923ec6a2a40b86c6$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $d88944f419270775$export$2e2bcd8739ae039)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $957fd8ce316388b9$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component);
var $923ec6a2a40b86c6$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $923ec6a2a40b86c6$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $957fd8ce316388b9$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $923ec6a2a40b86c6$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $923ec6a2a40b86c6$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).forwardRef;
if (typeof $923ec6a2a40b86c6$var$forwardRef === "undefined") $923ec6a2a40b86c6$var$forwardRef = $923ec6a2a40b86c6$var$forwardRefShim;
function $923ec6a2a40b86c6$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $923ec6a2a40b86c6$var$LinkAnchor = $923ec6a2a40b86c6$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $3bf266e5f300dc76$export$2e2bcd8739ae039)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $0880524001953467$export$2e2bcd8739ae039)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$923ec6a2a40b86c6$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($923ec6a2a40b86c6$var$forwardRefShim !== $923ec6a2a40b86c6$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $923ec6a2a40b86c6$export$a6c7ac8248d6e38a = $923ec6a2a40b86c6$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $923ec6a2a40b86c6$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $3bf266e5f300dc76$export$2e2bcd8739ae039)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $999fb696ed0e9e3a$export$2e2bcd8739ae039)(false);
        var history = context.history;
        var location = $923ec6a2a40b86c6$var$normalizeToLocation($923ec6a2a40b86c6$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $0880524001953467$export$2e2bcd8739ae039)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $923ec6a2a40b86c6$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $957fd8ce316388b9$export$fe53371bee54353d)(context.location) === (0, $957fd8ce316388b9$export$fe53371bee54353d)($923ec6a2a40b86c6$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($923ec6a2a40b86c6$var$forwardRefShim !== $923ec6a2a40b86c6$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement(component, props);
    });
});
var $923ec6a2a40b86c6$var$toType, $923ec6a2a40b86c6$var$refType;
var $923ec6a2a40b86c6$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $923ec6a2a40b86c6$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).forwardRef;
if (typeof $923ec6a2a40b86c6$var$forwardRef$1 === "undefined") $923ec6a2a40b86c6$var$forwardRef$1 = $923ec6a2a40b86c6$var$forwardRefShim$1;
function $923ec6a2a40b86c6$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $923ec6a2a40b86c6$export$b0d92dbee9b5b60d = $923ec6a2a40b86c6$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $3bf266e5f300dc76$export$2e2bcd8739ae039)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $999fb696ed0e9e3a$export$2e2bcd8739ae039)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $923ec6a2a40b86c6$var$normalizeToLocation($923ec6a2a40b86c6$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $fc353641e976e80e$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $923ec6a2a40b86c6$var$joinClassnames(className, activeClassName);
            style = (0, $0880524001953467$export$2e2bcd8739ae039)({}, style, activeStyle);
        }
        var props = (0, $0880524001953467$export$2e2bcd8739ae039)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($923ec6a2a40b86c6$var$forwardRefShim$1 !== $923ec6a2a40b86c6$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($923ec6a2a40b86c6$export$a6c7ac8248d6e38a, props);
    });
});
var $923ec6a2a40b86c6$var$ariaCurrentType;



var $6wXVr = parcelRequire("6wXVr");

function $7a6def086ebe18be$export$2e2bcd8739ae039(props) {
    const doc = (0, $6wXVr.useContext)((0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039));
    const to = props.to ? props.to : $37ba0e6d5a59440b$export$2c618a4308a30424(doc.fileType, doc.fileId, props.section);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        ...props,
        to: to
    }, props.children);
}


function $e10f0f56b55cf4b2$export$2e2bcd8739ae039(props) {
    const doc = (0, $6wXVr.useContext)((0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039));
    const page = undefined !== props.page && props.page && props.page[0] === '/' ? props.page.substr(1) : props.page;
    const to = props.page ? $37ba0e6d5a59440b$export$2c618a4308a30424(page, null, null, props.hash ? props.hash : null) : props.to ? props.to : $37ba0e6d5a59440b$export$2c618a4308a30424(doc.fileType, doc.fileId, props.section);
    const pages = [
        "login",
        "about",
        "faq",
        "docs",
        "support",
        "privacy",
        "accessibility",
        "migration",
        "attributions",
        "library"
    ];
    const organizer = [
        'unit-org-2',
        'cause-effect',
        'question-exp',
        'comparison',
        'cera'
    ];
    const hash = undefined !== props.hash && props.hash ? props.hash : "";
    if (undefined !== to.state && to.state.type && pages.includes(to.state.type)) {
        if ("privacy" === to.state.type) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            className: props.className,
            href: "/privacy.html"
        }, props.children);
        if ("accessibility" === to.state.type) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            className: props.className,
            href: "/accessibility.html"
        }, props.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            ...props,
            href: '/' + to.state.type + hash
        }, props.children);
    }
    if (to.state.type && organizer.includes(to.state.type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $7a6def086ebe18be$export$2e2bcd8739ae039), {
        to: to,
        hash: hash
    }, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
        href: to.pathname + hash,
        className: props.className ? props.className : null
    }, props.children);
}


var $48f81c6a4092094d$exports = {};
$48f81c6a4092094d$exports = $parcel$resolve("3Uadk");


var $6fef002bbeb73771$exports = {};
$6fef002bbeb73771$exports = $parcel$resolve("7Bd9n");


var $8ff4feaf43573350$exports = {};
$8ff4feaf43573350$exports = $parcel$resolve("ddWNw");


var $7f050a5aae06e935$exports = {};
$7f050a5aae06e935$exports = $parcel$resolve("bRHai");


var $b6a122760433a7a2$exports = {};
$b6a122760433a7a2$exports = $parcel$resolve("2B05T");


class $cdcd31d564710d43$export$2e2bcd8739ae039 extends (0, $d8775d5311bbf499$export$2e2bcd8739ae039) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    showFooter() {
        const docType = this.context.fileType;
        if (undefined !== docType) {
            if ("comparison" === docType || "question-exp" === docType || "cause-effect" === docType || "cera" === docType) return false;
        }
        return true;
    }
    render() {
        const docType = this.context.fileType;
        const type = !(0, $21f9ebdc444decaf$export$6e22c362a0406a2c)(docType) && this.props.valid ? docType : "utility";
        const footer1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $d6bad315ad35dae0$export$2e2bcd8739ae039), {
            type: type,
            item: 'footer'
        });
        const year = new Date().getFullYear();
        return this.showFooter() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("footer", {
            className: "print-none"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "footer-site"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "footer-site-brand"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "footer-site-logo"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "footer-site-title"
        }, "Corgi"), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "footer-site-tagline"
        }, "Co-Organize Your Learning"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "footer-site-row row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "footer-site-header"
        }, "Site Map"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", {
            className: "list-unstyled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e10f0f56b55cf4b2$export$2e2bcd8739ae039), {
            page: "docs",
            hash: "#new"
        }, "Begin a new guide")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e10f0f56b55cf4b2$export$2e2bcd8739ae039), {
            page: "docs"
        }, "My recent guides")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e10f0f56b55cf4b2$export$2e2bcd8739ae039), {
            page: "about"
        }, "About Corgi")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e10f0f56b55cf4b2$export$2e2bcd8739ae039), {
            page: "support"
        }, "How to use Corgi")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e10f0f56b55cf4b2$export$2e2bcd8739ae039), {
            page: "faq"
        }, "Corgi FAQ")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e10f0f56b55cf4b2$export$2e2bcd8739ae039), {
            page: "attributions"
        }, "Attributions")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e10f0f56b55cf4b2$export$2e2bcd8739ae039), {
            page: "privacy"
        }, "Privacy Policy")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e10f0f56b55cf4b2$export$2e2bcd8739ae039), {
            page: "accessibility"
        }, "Accessibility Policy")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "footer-site-header"
        }, "Our Partners"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", {
            className: "list-unstyled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://kucrl.ku.edu/"
        }, "University of Kansas")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://www.sri.com/education-learning"
        }, "SRI International")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://www.sccoe.org/"
        }, "Santa Clara County Office of Education")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://www.evergreenevaluation.net"
        }, "Evergreen Evaluation & Consulting, Inc.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "footer-site-header"
        }, "Contact Us"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", {
            className: "list-unstyled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "media"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media-object"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-envelope",
            "aria-hidden": "true"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "mailto:corgi@cast.org"
        }, "corgi@cast.org"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "media"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media-object"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-phone",
            "aria-hidden": "true"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media-body"
        }, "(781) 245-2212"))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "footer-site-media media"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media-object"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://kucrl.ku.edu/"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($48f81c6a4092094d$exports))),
            className: "img-fluid",
            alt: "KU: The University of Kansas"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, footer1))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "footer-site-media media"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media-object"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate("footer.nsf.url")
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($6fef002bbeb73771$exports))),
            className: "img-fluid",
            alt: "National Science Foundation"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).p, {
            text: {
                key: "footer.nsf.grant"
            }
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "footer-site-media media"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media-object"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://osepideasthatwork.org/"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8ff4feaf43573350$exports))),
            className: "img-fluid",
            alt: "OSEP Ideas That Work"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).p, {
            text: {
                key: "footer.osep.grant"
            }
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "footer-site-media media"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media-object"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://texthelp.com"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($7f050a5aae06e935$exports))),
            className: "img-fluid",
            alt: "Texthelp"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).p, {
            text: {
                key: "footer.texthelp.thanks"
            }
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "footer-site-copy row",
            style: {
                paddingTop: '0.75rem',
                paddingBottom: '.75rem',
                borderTop: '1px solid #bfc6cd'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "footer-cast"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "footer-cast-brand"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "http://www.cast.org",
            className: "footer-cast-logo"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($b6a122760433a7a2$exports))),
            alt: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "footer-cast-title"
        }, "CAST"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "footer-cast-tagline"
        }, "Until learning has no limits"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "footer-cast-row row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "footer-cast-header"
        }, "Connect with us"), "Follow us:", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", {
            className: "list list-horizontal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://www.facebook.com/CASTUDL",
            className: "footer-cast-social"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fab fa-facebook-square",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, 'Follow us on Facebook"'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://www.twitter.com/CAST_UDL",
            className: "footer-cast-social"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fab fa-twitter-square",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Follow us on Twitter"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://www.linkedin.com/company/castorg",
            className: "footer-cast-social"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fab fa-linkedin",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Follow us on LinkedIn"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://www.instagram.com/cast_udl",
            className: "footer-cast-social"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fab fa-instagram-square",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Follow us on Instragram"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://www.pinterest.com/cast_udl",
            className: "footer-cast-social"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fab fa-pinterest-square",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Follow us on Pinterest"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://www.youtube.com/user/UDLCAST",
            className: "footer-cast-social"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fab fa-youtube-square",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Follow us on YouTube")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", {
            className: "list-unstyled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://bit.ly/cast-newsletter"
        }, "Subscribe to our newsletter")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://us4.campaign-archive.com/home/?u=89e11c7455f4cb757154eb608&id=7396dac1a2"
        }, "Newsletter archive")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "footer-cast-header"
        }, "More from CAST"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", {
            className: "list-unstyled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://publishing.cast.org"
        }, "CAST Publishing")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://udlguidelines.cast.org"
        }, "UDL Guidelines")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "http://udloncampus.cast.org"
        }, "UDL on Campus")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://aem.cast.org/"
        }, "National Center on Accessible Educational Materials (AEM Center)")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://cites.cast.org"
        }, "Center on Inclusive Technology & Education Systems (CITES)")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "footer-cast-header"
        }, "Contact CAST"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", {
            className: "list-unstyled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "media"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media-object"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-envelope",
            "aria-hidden": "true"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "mailto:cast@cast.org"
        }, "cast@cast.org"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "media"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media-object"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-phone",
            "aria-hidden": "true"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media-body"
        }, "(781) 245-2212")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "media"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media-object"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-location-dot",
            "aria-hidden": "true"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media-body"
        }, "50 Salem St", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("br", null), "Building B, Ste 303", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("br", null), "Lynnfield, MA 01940-0030"))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "footer-cast-copy row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", {
            className: "list list-horizontal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://www.cast.org/get-involved/donate",
            className: "footer-cast-btn-donate btn"
        }, "Donate")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://www.cast.org/site/terms-of-use"
        }, "Terms of Use")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col"
        }, "\xa9 CAST, Inc. ", year))))) : null;
    }
}
$cdcd31d564710d43$export$2e2bcd8739ae039.propTypes = {
    doc: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).object,
    valid: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).bool.isRequired
};


// These are the base64url encodings of the "flowchart graphics"
// suitable for sending as a document thumbnail to the Google Drive API.
// Original graphics are in public/img.
// Strings below are made with base64 <file.png> | tr '+/' '-_' | tr -d '='
// Or you could use https://www.npmjs.com/package/url-safe-base64file
const $294eb611d6d6000b$var$images = {
    'cause-effect': 'iVBORw0KGgoAAAANSUhEUgAACG4AAARkCAYAAAApTMDLAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAIbqADAAQAAAABAAAEZAAAAACRV-0CAABAAElEQVR4AezdCZxeZX0v8P877-yTyb5vEBKCLIJBFgGVUhQruIIoalXqerW9ba-911qtbbXuem2vWq24VS1qta6ASJCrbG4oVGRLICGEEJbsy2S2d973PmeiXtTMMJOZyZmZ8z11SPK-5zz_53zPA51P3t_8n9Jt2_fWwkGAAAECBAgQIECAAAECBAgQmKACx85om6AzN20CBAgQIECAAAECBAgQIECAQEQdBAIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgXwEBDfycVeVAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIKDjhjVAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEMhLQMeNvOTVJUCAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAovILhR-CUAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEMhLQHAjL3l1CRAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcILCG4UfgkAIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBPISENzIS15dAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoPACghuFXwIACBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgbwEBDfykleXAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQKLyA4EbhlwAAAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAIC8BwY285NUlQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECi8guFH4JQCAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQyEtAcCMveXUJECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBwgsIbhR-CQAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIE8hIQ3MhLXl0CBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECg8AKCG4VfAgAIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBvAQEN_KSV5cAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAovIDgRuGXAAACBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIEAgLwHBjbzk1SVAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQKLyC4UfglAIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBDIS0BwIy95dQkQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHCCwhuFH4JACBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgTyEhDcyEteXQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKDwAoIbhV8CAAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIG8BAQ38pJXlwABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECi8gOBG4ZcAAAIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQCAvAcGNvOTVJUCAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAovILhR-CUAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEMhLQHAjL3l1CRAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcILCG4UfgkAIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBPISENzIS15dAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoPACghuFXwIACBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgbwEBDfykleXAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQKLyA4EbhlwAAAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAIC8BwY285NUlQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECi8guFH4JQCAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQyEtAcCMveXUJECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBwgsIbhR-CQAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIE8hIQ3MhLXl0CBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECg8AKCG4VfAgAIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBvAQEN_KSV5cAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAovIDgRuGXAAACBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIEAgLwHBjbzk1SVAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQKLyC4UfglAIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBDIS0BwIy95dQkQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHCCwhuFH4JACBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgTyEhDcyEteXQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKDwAoIbhV8CAAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIG8BAQ38pJXlwABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECi8gOBG4ZcAAAIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQCAvAcGNvOTVJUCAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAovILhR-CUAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEMhLQHAjL3l1CRAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcILCG4UfgkAIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBPISENzIS15dAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoPACghuFXwIACBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgbwEBDfykleXAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQKLyA4EbhlwAAAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAIC8BwY285NUlQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECi8guFH4JQCAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQyEtAcCMveXUJECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBwgsIbhR-CQAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIE8hIQ3MhLXl0CBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECg8AKCG4VfAgAIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBvAQEN_KSV5cAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAovIDgRuGXAAACBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIEAgLwHBjbzk1SVAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQKLyC4UfglAIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBDIS0BwIy95dQkQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHCCwhuFH4JACBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgTyEhDcyEteXQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKDwAoIbhV8CAAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIG8BAQ38pJXlwABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECi8gOBG4ZcAAAIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQCAvAcGNvOTVJUCAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAovILhR-CUAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEMhLQHAjL3l1CRAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcILCG4UfgkAIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBPISENzIS15dAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoPACghuFXwIACBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgbwEBDfykleXAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQKLyA4EbhlwAAAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAIC8BwY285NUlQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECi8guFH4JQCAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQyEtAcCMveXUJECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBwgsIbhR-CQAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIE8hIQ3MhLXl0CBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECg8AKCG4VfAgAIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBvAQEN_KSV5cAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAovIDgRuGXAAACBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIEAgLwHBjbzk1SVAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQKLyC4UfglAIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBDIS0BwIy95dQkQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHCCwhuFH4JACBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgTyEhDcyEteXQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKDwAoIbhV8CAAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIG8BAQ38pJXlwABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECi8gOBG4ZcAAAIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQCAvAcGNvOTVJUCAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAovILhR-CUAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEMhLQHAjL3l1CRAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcILCG4UfgkAIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBPISENzIS15dAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoPACghuFXwIACBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgbwEBDfykleXAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQKLyA4EbhlwAAAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAIC8BwY285NUlQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECi8guFH4JQCAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQyEtAcCMveXUJECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBwgsIbhR-CQAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIE8hIQ3MhLXl0CBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECg8AKCG4VfAgAIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBvAQEN_KSV5cAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAovIDgRuGXAAACBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIEAgLwHBjbzk1SVAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQKLyC4UfglAIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBDIS0BwIy95dQkQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHCCwhuFH4JACBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgTyEhDcyEteXQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKDwAoIbhV8CAAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIG8BAQ38pJXlwABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECi8gOBG4ZcAAAIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQCAvAcGNvOTVJUCAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAovILhR-CUAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEMhLQHAjL3l1CRAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcILCG4UfgkAIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBPISENzIS15dAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoPACghuFXwIACBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgbwEBDfykleXAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQKLyA4EbhlwAAAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAIC8BwY285NUlQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECi8guFH4JQCAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQyEtAcCMveXUJECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBwgsIbhR-CQAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIE8hIQ3MhLXl0CBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECg8AKCG4VfAgAIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBvAQEN_KSV5cAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAovIDgRuGXAAACBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIEAgLwHBjbzk1SVAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQKLyC4UfglAIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBDIS0BwIy95dQkQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHCCwhuFH4JACBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgTyEhDcyEteXQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKDwAoIbhV8CAAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIG8BAQ38pJXlwABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECi8gOBG4ZcAAAIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQCAvAcGNvOTVJUCAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAovILhR-CUAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEMhLQHAjL3l1CRAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcILCG4UfgkAIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBPISENzIS15dAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoPACghuFXwIACBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgbwEBDfykleXAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQKLyA4EbhlwAAAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAIC8BwY285NUlQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECi8guFH4JQCAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQyEtAcCMveXUJECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBwgsIbhR-CQAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIE8hIQ3MhLXl0CBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECg8AKCG4VfAgAIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBvAQEN_KSV5cAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAovIDgRuGXAAACBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIEAgLwHBjbzk1SVAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQKLyC4UfglAIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBDIS0BwIy95dQkQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHCCwhuFH4JACBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgTyEhDcyEteXQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKDwAoIbhV8CAAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIG8BAQ38pJXlwABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECi8gOBG4ZcAAAIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQCAvAcGNvOTVJUCAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAovILhR-CUAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEMhLQHAjL3l1CRAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcILCG4UfgkAIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBPISENzIS15dAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoPACghuFXwIACBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgbwEBDfykleXAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQKLyA4EbhlwAAAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAIC8BwY285NUlQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECi8guFH4JQCAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQyEtAcCMveXUJECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBwgsIbhR-CQAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIE8hIQ3MhLXl0CBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECg8AKCG4VfAgAIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBvAQEN_KSV5cAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAovIDgRuGXAAACBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIEAgLwHBjbzk1SVAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQKLyC4UfglAIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBDIS0BwIy95dQkQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHCCwhuFH4JACBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgTyEhDcyEteXQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKDwAoIbhV8CAAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIG8BAQ38pJXlwABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECi8gOBG4ZcAAAIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQCAvAcGNvOTVJUCAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAovILhR-CUAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEMhLQHAjL3l1CRAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcILCG4UfgkAIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBPISENzIS15dAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoPACghuFXwIACBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgbwEBDfykleXAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQKLyA4EbhlwAAAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAIC8BwY285NUlQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECi8guFH4JQCAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQyEtAcCMveXUJECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBwgsIbhR-CQAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIE8hIQ3MhLXl0CBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECg8AKCG4VfAgAIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBvAQEN_KSV5cAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAovIDgRuGXAAACBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIEAgLwHBjbzk1SVAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQKLyC4UfglAIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBDIS0BwIy95dQkQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHCCwhuFH4JACBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgTyEhDcyEteXQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKDwAoIbhV8CAAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIG8BAQ38pJXlwABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECi8gOBG4ZcAAAIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQCAvAcGNvOTVJUCAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAovILhR-CUAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEMhLoD6vwuoSIECAAAECBAgQIECAAAECBAgQIDC6Arfcckts3Lgxtm3bNroDG23MBOrq6uKoo46KE044IVpbW8eszoEGXrt2baxbty4efPDBA73ttXEoUKvV4ogjjohjjjkm5s2bd0hn-PDDD8cdd9wR69evj1KpdEhrK3bwAgsXLuxfMytXrjz4QQ7iyn379sUvfvGLWLNmTVSr1YMYwSV5CMyaNSuWLl0aq1atyqO8mgQIECi0QOm27XtrhRZw8wQIECBAgACBQQR6e3ujq3Nf7N21Kx5MfwG-fu2a2Lzh3njkgc2xdcvD0dWxN_Z17Et_CdEXTU3N0T59ekyZNi3ap7anX2fEnAXzY_Fhy2LJEctjxuw50dbeHo3NzVEulwep6i0CBAgQIEBgOALHzmgbzunOJTApBfr6-uKdb39b3HvPL-PoxRFz2iuT8j4n403Voi7u2FSOm-7cGZ_4xCfi6KOPPiS3ecknPharv3tZHL-sIQ6b3RtpCTkmgEA5BX3WPFiOG27dGW9-85vi3HOfdUhm_Z3vXB6XfPyjccxhjXHUgr7o80H8IXEfaZHsrx42bGmIa36-M5733GfFG__qTSMdckjX33nnnfG2t7wpDptbimMW90UpBDeGBDcOTtqypz5-fFd3tE-bE5_9t8_7-6tx8ExMgQCB4ggIbhTnWbtTAgQIECBAYIgCnemnQrY8uDnuu3ttrL3t9lh7-y_i_nvWRcfePUMc4fdPy36Kbsbs2XH4yqNixTHHxrKjjo7D0k9JzZq_IJpSkMNBgAABAgQIHLyA4MbB27ly8gi8_GUvjcOn74i_e3FrpG89HRNQ4CdreuItn90dl37xi5H9hPxYHp_9zKfj-1d9JT7-hinR0qRzwlhaj9XYm7f1xcUf2hHvevf74tRTTx2rMv3j3nbbbfGGN7whPvc_Z6YP4jXxHlPsMRq8s7sWr_3Injjv-S-Ll7z0ZWNUZf-wW7ZsiQsuuCDectHUOOdEf98xpthjNHiWy3rHl_ZFecYT4u_f8e4xqmJYAgQIEPhdAcGN3xXxZwIECBAgQKCQAlm72Qfvuy9-et0P4tabfhIb1t4VO7am9tLp9Wp_f7LRaFJWSu1ko_-rXN8Q01OQY0nqxrHi2GPj-JNPiWVHHxNT2qcW0t9NEyBAgACBkQgIboxEz7WTQSDbHuUdf__m-Oqb24U2JvgDvfynPfHDTSvive__0Jjdyc6dO-P85z8vvvl3M2NKi5TPmEEfgoHv3Ngb7_pafXzu378cDQ0NY1Ix60J58cteHH9zfm8cs3RsaozJxA36ewJ7O6vx4vfviUu_9NWYnrqFjtXxN3_9xnjivLvj_NObxqqEcQ-BQBbeePVHu-Mv_tc7bJtyCLyVIECAQCYgHmsdECBAgAABAoUW6O7sjPVr7ozrrvxO_PyGG2L71oej0lvJ8hrpGI2wxqN5a_3jZmNXe3piy-YHY2vaS_oXP_1xXP7lL8aCxUvi5DPPilP-4KxYmrZWaWhsfPTFfk-AAAECBAgQIEDggAIb05Z-px7VKLRxQJ2J9eLjDy_Hl2-8d0wn_cADD8QRi6cIbYyp8qEZ_KjFDfFI-oGDSqUyZsGNbBumh7duj8ctnnlobkqVMRPIgloL5zTHpk2bxjS4cV_aXva1Z_joacwe5CEaOOvelW29ln2PsWrVqkNUVRkCBAgUW8D_9yz283f3BAgQIECgsAKdHR2x7q474vtXXBY3_eDa2LUjddc45Mf-IEf2F2H79u5N87mz_-vyL10ap_3h2fHEpzw1Vh53fEybOTPq633bdsgfj4IECBAgQIAAgQkisGPHjpjTXkmz9dPNE-SRDTjNudPqYvuOXQO-PxpvZOtl7vTyaAxljJwFsg9WZ01viayLSktLy5jMJlsvM6c2CYaNie6hH3TO1LrInulYHtt37Ik506aNZQljHyKB7HuLbdvy-PuyQ3SDyhAgQGCcCfgEYJw9ENMhQIAAAQIExlagN_0k0rrbb4-rv_W1-Pl118bObdtTX43R7qwxsnvYu3tXmt83-kMlC5YsjRNOeVKc-axnx7KVR43ZT1GNbMauJkCAAAECBAgQIECAAAECBAgQIECAAAECBA5WQHDjYOVcR4AAAQIECEw4gR3btsb__fa3YvXX_zO2PPhA9PVlgY3xFdr4DWraT6WS9hK-f_362HTvurhh9VXx-NOeFGc_89lx5PGPj7Yp7VEqlX5zut8QIECAAAECBAgQIECAAAECBAgQIECAAAECE1NAcGNiPjezJkCAAAECBIYhkAUg1t72y7jiP74UP7v-2ujat28YV-d96v7tVHZu3xrXX3F5_DAFOE487clxxjnn9HfiyLZRKZe1Oc77KalPgAABAgQIECBAgAABAgQIECBAgAABAgQOVkBw42DlXEeAAAECBAhMCIF9e_bGtd-9Ii679AvxwH33pTmPvMNGaoaxf5THGio1xMiaYoxmX4y-FEK56bofxM9v-EEsPWJl2kLlWfHUPzo3Zs2dqwPHhFiRJkmAAAECBAgQIECAAAECBAgQIECAAAECBH5bQHDjtz38iQABAgQIEJhEAtseeSSu_vrXYvU3vhLbHtma7uyxkhYHvvm-bNuSvlI0NDREc2M5fUW0NES0pn-0trZGW2tjNNbXR0-lL_bu7Uxfe6O7py96-yK6KnXp9Vp0dvZGtdoX9ak5RrlupFGOWhorYsM9a-OBj30kfnDFZXH2s58TT_rDp8esefOiPs3FQYAAAQIECBAgQIAAAQIECBAgQIAAAQIECEwMAX-rPzGek1kSIECAAAECwxTYfN-GuOyL_x7XXnlFdKSuGwcT2sgCF00trbFsfnusWNgcK5dMjeWLp8TKeRFLp3ZEW313f0eN_z-1lOaI5lRqRnT1lWNrV0ts3NEY6x6pxLqN22P9pj1x__ZabH6kI_bt60hhj7oYWYajFr09PXHf3WvjMx_6YAqofCPOOf_8eNJZZ6cAx3wBjv__YPyOAAECBAgQIECAAAECBAgQIECAAAECBAiMWwHBjXH7aEyMAAECBAgQOFiB-9fdE1_7t8_ED7-3Orq7utMwQ--0kRpZRKlWisWHzY-zVi2IM1aWYuWCUsyb2hPN9T3p3Z0R6aRapRr9W6YMMHRzfV8sae-IJdM74owVdRGnNUZnz7x4aFdjrH-wK27e0Bc33tkdazc8HJ0d-9J2KqWoS6eN5Nh07_r47Ic-EFd_4-vxlHOeEWc_94KYPT-lTBwECBAgQIAAAQIECBAgQIAAAQIECBAgQIDAuBUQ3Bi3j8bECBAgQIAAgYMRuD-FF772b5-OG69eHT3dWdBigGTF7wxerdaiLm2FctSyBXHuGQvj7KNrccS0jmhq7ItSXS0FNVJeo3toY2VD7w91pPOzJEi2Z0o6Wup6Y9ns9DWrFE85qhyvfGpr3Ld9RVy3NuKam7fEvRt3REfaUqVWS1uqHFQrjjTPVPL-9evjK5-6JG66_ro498IXxYlPeWpMmzEzdQcZ6RYt_bfhHwQIECBAgAABAgQIECBAgAABAgQIECBAgMAoCghujCKmoQgQIECAAIF8Bfbs3hWXf-nS-PH_vWZ4oY26ciyaPzOe9ZRFccGpDbF82u7U_yKFLVLnjWrf_tDGaNxZFg6JLEuSwiQNpWrMaiulr0qcuKQUFz9lbvxk_cK4-uYd8bM1u-Pe-3dEua4vbaVyMGGLWlQqlbj79tviw3fcEU940qnxRy98cRx_0inROmXKaNyKMQgQIECAAAECBAgQIECAAAECBAgQIECAAIFREhDcGCVIwxAgQIAAAQL5CnR2dMTPrrs2fnDFZdG1rzNN5rG7Y2RntKUgw9NOXRR_fOa0OHZxTzTVdke1ksIa_bfz2GMc7F3_piPHr-pMa-yOZxzXE2cd0xb3b2mPH9w-O771k11x1z1bU8OOSpQPJr-Rxq7VqnHLj34cd916azz-iSfFH114URxz4hOjpbX1YKfuOgIECBAgQIAAAQIECBAgQIAAAQIECBAgQGAUBQQ3RhHTUAQIECBAgEA-Ar29vXHPXXfE1z_32SGHNiqp-8WiebPipecsiBecUh9z2nb1b2uSddjI46il-dR6UieOtJ3K8rmRtlQpx3mrZsf19yyIb9zwcPzynh2xe09n2kKldhBbntQiC7bcdN11seaXv4ynPPPceOYLXhgLlh4W5XI5j9tVkwABAgQIECBAgAABAgQIECBAgAABAgQIEPiVgOCGpUCAAAECBAhMaIFaal2xecOG-EYKbWy85-4h3UuKPsSxy-fEa581L552XF20lbuifxuTfDIbvzXn_gBHNVI4oxLz20tx4Ym9ce5xM-LqO-bEFT_dHjev2RXbd-5JW6hkdzG8I-sjsmvH9rj8i_8et_70J_GM8y-IM875o5gxa_bwBnI2AQIECBAgQIAAAQIECBAgQIAAAQIECBAgMGoCghujRmkgAgQIECBAIA-BbQ8_HN_96lfilhtvGFL5uvr6OO24ufH6c6fHScuqUY7eyKvLxmATfvRWKm31vfG8J1binBNmxh33TY-v_7QrrvrpQ7FjRxbgGGyUgd_beM898ekPvi9uuPrqOPfCF8YTn_LUtG1M-8AXeIcAAQIECBAgQIAAAQIECBAgQIAAAQIECBAYEwHBjTFhNSgBAgQIECBwKAS6u7piza3_FT-8ZvX-jhmPUbQadXHGcXPiL549LVYdntpaZNuTpK_xfvRPMW2j0po6g5y0POKYJU3xvFOPiC_d0BHX3fJwbN22O22hknXpGE6Ko5bMIu685ea47561ccoNZ8ZzX35xLDlieTQ0NIx3EvMjQIAAAQIECBAgQIAAAQIECBAgQIAAAQKTRkBwY9I8SjdCgAABAgSKJ_Dwg5vjmsu-GTu3b083P3gAo1orxYlHz45XnzMzVi1NiYW-FNrI2lpMoKO_M0hfRGtdb5xyWG88YXFjXH_y8vj6DTvixtu2xa5dHQexhUot9u3ZEz_4zhVxz513xHkvuihOe9o5MX3mrGEGQSYQpKkSIECAAAECBAgQIECAAAECBAgQIECAAIFxJCC4MY4ehqkQIECAAAECQxfYvXNH_Piaa-LmG29MFw0ewKimlhXHrpgRr33GzDhtRRbYSMGNCRbaeLRMdj_Z0VCqxNlH98XpR06LX9w7tX8LldU_3hS7d--LumHvoVKLTfeuj0-9_71x_VWr4_xXvCKOO_nUaGltfXRpvydAgAABAgQIECBAgAABAgQIECBAgAABAgRGWUBwY5RBDUeAAAECBAiMvUA17fGxeePGuOGq7zxm_qIvhRwOXzA1XnzmrDj9caUol_omxPYoQ1HMsie1tIVKS7k7nrQi4vFLG-PM41bGF655JG69e0fs6-iM-vJwtk9JjUiS7R23_Dwe2LA-nvrM8-K8F74o5i5eEuVyeShTcg4BAgQIECBAgAABAgQIECBAgAABAgQIECAwTAHBjWGCOZ0AAQIECBDIX2DH1q1x49WrU7jg3jSZgbttZMGGlpamOPvE9jj7-HK0NVajVhn4_Pzv7OBm8OstVNrKlTjv2EqcvmJOfPvnM-Mr122NO-_ZkgbtS1uoDCfAUYtdO7bHZV_8Qtz-85vi-Re_Mk464ynR2t5-cBN0FQECBAgQIECAAAECBAgQIECAAAECBAgQIDCgQN2A73iDAAECBAgQIDAOBSqVSjy0aWP8149vjEpf3-AzTFmF049ui-ec2hZzU-ZgMoY2Hg2QbaGSfc1o7o5XnFGJj71-XrzpJUfF4UvmRqnu4DpmrF-zJj7-rnfEv77nXbH29tuit7f30SX9ngABAgQIECBAgAABAgQIECBAgAABAgQIEBihgODGCAFdToAAAQIECBxagc59HXH3bbfFpvXrUxJj4O4ZKb8Qi-e1xTNOmh6Pm1eaNNujDEU768BRS1-HzeyOVz-tHB99_aJ47plLon1qW1RSx5GB1Q40ei327d0b1155RfzTW98c37_827Fn184Dneg1AgQIECBAgAABAgQIECBAgAABAgQIECBA4CAEBDcOAs0lBAgQIECAQD4CtRTU2Pbww_GLH_-wv7PEYLNobKiPM49tizOOKkdDfWq9Mby0wmBDT4j3stut9taivq8njpm3L951UWu8_eLlcfqqRVEuN0R1kNDLgW-wFpvv2xCfSJ03Pvm-98aaX94avT09Bz7VqwQIECBAgAABAgQIECBAgAABAgQIECBAgMCQBeqHfKYTCRAgQIAAAQI5C2RBgY3r7onbbr45zWTgJEalGrFqWWvqtjE15k4rp8YcA5-b8y2Nefms80ikHWWaSpV4zgl9cfrK2fHtn02PS7_3SNy3eXtKdySsYRyV3p7-7htrbv2vOO-iF8eZ5z07ps2YOYwRnEqAAAECBAgQIECAAAECBAgQIECAAAECBAg8WkDHjUdr-D0BAgQIECAwrgV279wZa269NXq6uwacZ5bRaGtpiFVHtsdRixtSd4l06qjnNtKA1ZSGqFaythZp_PRrLQtAjHqhAe9zuG9kAY5q2iZldmt3vOLJpfiX1y-MC5-2Itrb0_YpaVuV4R21eOiBB-LSj300PvmB98X6u-6M3t7k4CBAgAABAgQIECBAgAABAgQIECBAgAABAgSGLaDjxrDJXECAAAECBAjkJbBj69a4_Wc_HbR8tgXI0nmt8cQVTTGrtZoyFcMNJQw6_P6QRillX5tmpa9p6eS0DUtfCpL07Izo3b3_4lL6Fis7Zxwe2fYp5VJvPG5eJf7hBQ1xypGHxRe-tyNuXfNI2j6lEnWldD9DOmrR1dkZ11_5nbj3jjvi-Rf_SZz2tKdH25T2IV3tJAIECBAgQIAAAQIECBAgQIAAAQIECBAgQGC_gOCGlUCAAAECBAhMCIF9e_embVLujoc2bx50vo31dXHSypZ4wuHN-0MWg549nDdTACT9r9S-PGLh06I0c1VE8-z9AY1KR9S6tkTsWR-x7Zao7bgthTh2pcFTu48hByGGM5eRnbt_-5RaNKYAx_NPKsXJy-fFt386Nb54zUPxwCO7UrBjOOPXYtN9G-KT739P3PyjH8bzX35xLFt5VNQ3NAxnEOcSIECAAAECBAgQIECAAAECBAgQIECAAIHCCghuFPbRu3ECBAgQIDCxBLLgxtrbb4vuzn2DTnze3OlxwrL21G2jsn_3kkHPHuqbv-raMW1lxBEXRWnuk1Ig41HfRjVOi1LrwoiZx6dQxzkRu9dEbP5-1LbdFNG1bX-R_gDHsBIRQ53cQZ-XbStT66nF4umd8Zqn18fxRyyLS67cEjfdsTU5d0Vd3VDnu7_7xo2rr-oP17zo1a-Lk5781GiZMuWg5-ZCAgQIECBAgAABAgQIECBAgAABAgQIECBQFIHx2cO7KPrukwABAgQIEBiyQMee3bFp_brIwgYDHdl7Kxc0xOMWN6YtPwY66yBezwaeemSUVrw8Yu4Zvx3a-K3hUtGGtijNOjHi2D-P0vFvidKip6fXpqaERF_6GmTyvzXOof1Dtn1KQ7U3nrysM_75VbPiLy5YHksXz0pbp5RSk5HhzLkW969bFx971z_Gly75eDx4_8Z0y8O5_tDet2oECBAgQIAAAQIECBAgQIAAAQIECBAgQGA8CAhujIenYA4ECBAgQIDAoAK9PT2x5aGHYkvaJmWwIEB9Q32sWNgcC6f1Rmm0khspcFFqXRylpc9PgYxVaeeToSVCSnUNaTuV46N09H-P0glvTl06npp2TmlK4Y3qoPea15vVNK1q2kNlZnN3vO6svvg_r1kYz_6Dw6OluXnYeZN9e_fEt77wufjfb_3ruOPmn0dvb29et6UuAQIECBAgQIAAAQIECBAgQIAAAQIECBAY9wKCG-P-EZkgAQIECBAg0NPTHQ9t2hhbU3gjJR8OCJK92tqUghtL26O1OW1jcuDTDnjtgC9mIYtyS-qykbZGmZ26aKQwxrCP-pYozT45SsemAEfWsaN1URoijTteAxx9tSilLhknHNYb__DC9vifL14ehy2aGX3D7r4Rcfcvb4t_-ts3x1Vf-0p07NkzbDoXECBAgAABAgQIECBAgAABAgQIECBAgACBIggIbhThKbtHAgQIECAwwQU69uyNzRs3po4QKfAwwFFL3SJam0txxKyeaKqrDHOLjwEGzdIfbUsjZj0hSk0zBzppaK9n1x92fpSOe2OU5qTtVvq7b6TtU8bhkSgj2z5lRlN3vOL0SrzvNUvjnFMXRmNjc9o-ZTiJmFp_p5RPf-B9ccl73t2_dcpgz3AcUpgSAQIECBAgQIAAAQIECBAgQIAAAQIECBAYc4H046gOAgQIECBAgMD4Fcg-6N-5dWusve2Xg4Yx6svlmDe7PebMbEyhiEpEZTgBgwPcf9YRo3FalOY9OWLGcQc4YfgvlerKEWn7lGhbErH5e1G7_7KIfQ9G2n8lDTa0LViGX_Xgr6im7hvZcfLSzjjyT2bG6v-aGp_8zpZYf_-2NNuh-2bP8NorL48N69bGBX_yqnjSWWdHY1PaNsZBgAABAgQIECBAgAABAgQIECBAgAABAgQIhI4bFgEBAgQIECAwrgX6KpXY-shDsWHt2gHnWUshgvpyKZbOqo-ZrSkAMXBjjgHHOOAbWbeN6Y-LUn3bAd8-6BebZkQsfU6UHve6X4VC0pzH6dYp2T1WUwhmemNPXHhKLd7zykVx1smLoqkpdd_IWnMM8cie0X3pGX783e-Mr3zyX2Pvrl1DvNJpBAgQIECAAAECBAgQIECAAAECBAgQIEBgcgsIbkzu5-vuCBAgQIDAhBfYt3dP3Js-8O_t6R7wXrLdO5qa6mPZgnK01vemDMTQAwUDDlrXGKUU2oj25QOeMpI3SmmrlNLc06N0zH-P0oKzIlK9qI3PrVOy-8zCG6W-apy0pDPe__Lp8brnLYuF82ZEemnIRxbe2Ldnd_znpz8Z__LOd8T69FwrKZjjIECAAAECBAgQIECAAAECBAgQIECAAAECRRYQ3Cjy03fvBAgQIEBgAgjs3b0n1t95-6AzrUsNK-bNmhLHrZgz6HlDfjMFKEpZt40Zj49SQ_uQLxv-iaUotR8RsfI1UVr-kojmueM7vJHyMNWULZnZ0ht_9vRSfODVi-LMU5ZGQ0PDMDZOSbeYoH70vdXxvr_687jmm9-Irs7O4dO5ggABAgQIECBAgAABAgQIECBAgAABAgQITBKB-klyH26DAAECBAgQmKQCXZ37YvPG-we9u7pSKeZOrcbxC1L3htHotpFVm7I4IgtvpLHH-ig1z4o47PmpbUj6dcN_Rm3vH5TPfQAAQABJREFUhlSynGqPdeWDG7_aV4u6ur44LTUjWTZvWnxuaUt87fsPxCNb9_RvWTOUUbPuGw9veiA-888fiK1bHo5nvfCimDpzVuIepzc9lJtyDgECBAgQIECAAAECBAgQIECAAAECBAgQOAgBHTcOAs0lBAgQIECAwKERqPT2xvZtW2Pvrp2DFmxqaoxFc9tTJ4jOyLZNGdFRS3t_NExJwY0U2micPqKhhnVxfWuUFj4tdd94ZcT0Y9KlaR4jvZdhTWB4J1dTQKaWAhzzp_TEG59ZH2996ZJ4_Mr5KWxSTs9gaBPPwhtdHfviq5d8Ij78jr-LdXfdaeuU4T0GZxMgQIAAAQIECBAgQIAAAQIECBAgQIDAJBAQ3JgED9EtECBAgACBySrQua8jNq1bF93dXYPeYktzQyxbMj11axiFb23SNinRMKO_20YphSkO6VFXH6U5p0Xp6D-LmHrk_o4bQ8tAHNJp_rpYNrWs-0Z9rTeeu6oa__SaefGic5bGlCktQw5vZGNlAY6fX3d92jrlL-OGq66M7q7Bn_ev6_uVAAECBAgQIECAAAECBAgQIECAAAECBAhMBoFR-HRjMjC4BwIECBAgQGA8CnTt64yHNj8QPYN8kJ996N_WFHHE7FraWWSkKYd0fV1DlFpT54im2Sk4kcO3SmmrkNK0lVE66rUR045Oc0hzGmIHi7yeYTa9aqUWK-Z2x988ry3-7IJlsWj-zNQzJNv2ZGjPJHuOWx58MD75_vfGVz99yWN2WcnrXtUlQIAAAQIECBAgQIAAAQIECBAgQIAAAQKjLZDDpxGjfQvGI0CAAAECBCarQNZp45EH7h88t5ByAVOaS3H4jM6Us8iCAiM4soxBOaVAWhdFNKfgRo5HadYTIo56dcTMVSlMUh734Y2Mqtpbiyn1vfGqJ1fjPa9cEmccPz-qtbR1yjDCG3t374qvfuqS-Ojb_yE2bbg3qtW0ZYyDAAECBAgQIECAAAECBAgQIECAAAECBAhMYgHBjUn8cN0aAQIECBCYyALZB_b79uyNnVu3DnobzU1NsWTx7Jja2jDoeUN7MyU36lJwo21x6rgxa2iXjOFZdTOOi9Ixfx4x_8z9gZJx3nkjo6hWU-eTNM8zlnfHB181Oy58-hHR1JS2ThlieOPXnD_-_jXxgTf9VWS_9nR3__plvxIgQIAAAQIECBAgQIAAAQIECBAgQIAAgUknILgx6R6pGyJAgAABApNDoNLbGzu3b409qQPDQEfWIKOxoRyL57REa3PWlWKgM4f6eurY0TSjf5uUUl39UC8a0_NKbYui7siLI-aensIbaU618d-BInsM1b5azGvvib89vzne-OKVMXtme_SlUMdQH1IW9Ljv7rvj4-_-x7jyK1-Kjj17xtTZ4AQIECBAgAABAgQIECBAgAABAgQIECBAIC8BwY285NUlQIAAAQIEBhWo9PTEtkceid3bd6bzDpzIqKXODo31tVg-pxqtjSnQMNKOFKUU3GieG9GS7zYpvwfTMj9KK18ZseDs1BGkeUKEN7J7yLZOaW9MW6ec0RMf-m_L4vijF0TfMLdO2b19e3z-w_8cn3r_e2LLQw-mR3zgtfB7Zl4gQIAAAQIECBAgQIAAAQIECBAgQIAAAQITREBwY4I8KNMkQIAAAQJFE-it9MaeXbuiJwU4Bj5KMaW1HEtmVqKu3Bf9DR0GPnkI75Si1DwztfFIX-PsKLXMi7qVr47S0mdHNEwZeUjlEN1f1nkj7Z8SZ6zoiY--dl68_LyV0dzcnKI4Qw9gVCqV-P7ll8WH3vrmuOsXt0Rv6sbiIECAAAECBAgQIECAAAECBAgQIECAAAECk0VgfPQAnyya7oMAAQIECBAYNYFKbyX2puDGYJ_v15XrYvrUKdE-pSXVHYUP80sp09qYtkppmDpq9zGqAzVOi9IRL4paX3fE5tUR2a9Zl5BxfmQRjVrqvrFkZle86dlNcfi85fHxb94fj2zbHfX9MeLHvocs6HHnzTfHR97-d3HRa18fJ595VjSlAIijeAJ1dbLnxXvq7pgAAQIECBAgQIAAAQIECBAgQIDA5BYQ3Jjcz9fdESBAgACBCSvQ29sTe3ZsH7QzQ31d1nGjPqY0Z9_SjDC4kW3B0Zg6WaRuG6W6cfwtUhbeWPHHUcs-vH4ghTcqnRMivJEtxGpPLdoauuPi0yMWzjw8PvytLXHn3Q-n7Ek1Uq-Tx1yrWXhj84YN8Yn3viduuv66mDp9Rrq2ZPuUx5SbPCdkoY0p7e0xf-niWLp8ZSxYvCSaW1snzw26EwIECBAgQIAAAQIECBAgQIAAAQIECikwjj-VKOTzcNMECBAgQIBAEqilEEXnvo7YtXP7gB5ZF4dS-sfUlhTeyBovVAc8dYhv1KLUMC0i2yol67wxjo9SUwosrHhF1Mppy5H7r0iZlb0TJ7yRbZ2Sjmcc1xNHzZ8fn1jdFt-8dmP_ljhDC29E7N29M66_8jvpnsfxQzK1sRVI_41oTIGNo094Qjz9uefH6U8_J3TiGFtyoxMgQIAAAQIECBAgQIAAAQIECBAgMHYCghtjZ2tkAgQIECBA4CAFqtVq9HR1x-6dOwceIX1wWypHtDf3xZSGyqBbqgw8yKPfSYGC-tRxI_sa58GN_lk3TInS4RemLUhSaGPz99K2KV0TY96_Is-6bxw-uzP-9oLWmN62LC793qbYs6cjykPc-iXrvpH9z1Fcge7OffGLH_0w7rn99lh35-3xorSFju4bxV0P7pwAAQIECBAgQIAAAQIECBAgQIDARBYY3z9OOpFlzZ0AAQIECBA4aIGs40ZXx97YtT0Lbhz40_ns1br0XntDT7SUe6JWPfB5w5pEQ0sKbrQN65JcT26cGqXlL4lYcHaad2o7ktwm0tG_dUp6dv_r3Lp42x8vj8MXzoq-9Bwn1l1MJPFJNte0ULK1snfPrvjWv38-PvrOt8e-vSnI5CBAgAABAgQIECBAgAABAgQIECBAgMAEExDcmGAPzHQJECBAgEARBLIQRldXV-zaMfBWKZlDc1NjTJ-edckojTyzkIUestBGwwQKbiSDUvOcqFt5cZQWPH1ihjfSsy7VqnHhyT3xkT9dGqevWpx2QCmnD-TFN4rw7_qo3GNaKn19ffHD1VfGR97-d7Fj29ZRGdYgBAgQIECAAAECBAgQIECAAAECBAgQOFQCghuHSlodAgQIECBAYMgCfX2V6EjbZnR3dQ54TSm909LatD-4MeBZQ30jffJbSjvI1bemNh5NQ71o_JzXOD1KR7wwYu4ZEeXGCdd5I4to1PpqcdzCznjvH8-KZ515WDTUN0ZVeGP8rLEJMJO-tMXST75_TXzmf78_deHYPQFmbIoECBAgQIAAAQIECBAgQIAAAQIECBDYLyC4YSUQIECAAAEC406gt7cnddvYNui8SnWlaG4ox8z2tEXISI8sOVBuSF8puFEqj3S0fK5vmZ-2TXlpxMwTUvgk3cME2zYlm26ttxZLZnTHu17UFK99_sqYOqUt-ibYfeTz8FXtF0hrqK_aFzeuvir-9d3vjM6ODjAECBAgQIAAAQIECBAgQIAAAQIECBCYEAKCGxPiMZkkAQIECBAolkCltzc6dg_-E_NZx43m1Fxielv6diYLXozoSANkgY1y6rYxUYMb6f5LbYsjlr0oYtrKFN4YDZcRoQ774uwxVlPnjbbGavzZORGvf95hMWf2tKgKbwzbsrAXZOGNtG3Kj65ZHZ__6IejY--ewlK4cQIECBAgQIAAAQIECBAgQIAAAQIEJo5A6gnuIECAAAECBAiML4FqXzV6ursHnVT2IX9T-k6mrTn9rjroqUN4M42RBTbqUhIk61YxgY-6mcdH7chXR23NpyL2rEk2CaeUxVwmzpGFNxrLlXjNH5Tj2MWHxbv-46G4-96tqftGNUrp_xyTTyA10BnVo1KpxFX_-R-xd9fOeP1b3hatU6aM6vgGI0CAAAECBAgQIECAAAECBAgQIECAwGgKCG6MpqaxCBAgQIAAgVERqKWwQU9Pz6BjlbKsRV36gL9-xKmN_XWywEbquFGKiR3cyG6mNPPxESsvjtpdH4_Yu2H_tikTMLxRV6rEk5f3xQdfNT_-6VstcefGvVFL3RTSHWa36ZgMAmldVtO_7zt37olKCmwNdmSdV-qGuo7Tfx_6-irxw6u_259besNb_z6aW9NWSA4CBAgQIECAAAECBAgQIECAAAECBAiMQwHBjXH4UEyJAAECBAgUXaCWOitUKr2DM6TP7hvSh7hNKbwxKkcpfVuUbZWSbTEyCY7SrFVRO_zCiHu-ENH18IS8o2r2aNOH9ccu6In3vWxG3LtzQdRK2RYwo_TMJ6TK5Jp0Xbkutu_qjnf-2x2x8aHOSH884JE98rbmcnR09qZ_RYcYrkrXVCp9cePVq2PqtBnx4jf8abRNaT_g-F4kQIAAAQIECBAgQIAAAQIECBAgQIBAngKCG3nqq02AAAECBAgcUCD7yfrersG3Ssl6LtSXa9FUTj-lP9LP8bNPhbNAQF1DGnWIHwofcObj68W6RU9LGYdq1Nal8EZnCm9k9zgBj2qlFrNau2JWe1eavW4bE_ARDjzlcim2t_RGc11f6rxRS8GNAz_fSuq0ctqqI2PRooXx-a9-vz_AM8Cpv1crC4Fd-dUvx56dO-N1b3lr2jZFeOP3kLxAgAABAgQIECBAgAABAgQIECBAgECuAoIbufIrToAAAQIECBxIoJo-pK1UKgd66zevZTsmlEvV_cGN37w6gt_0hxpSsOHAnxuPYOA8Ly1FacFZqe3Arqjd-9WI7p0TN7zRl8I12S4pI07p5Pk81P5dgboU3OjqqUZ_d5XfffNRf66lcFVra0u88S3_GO1TPxQfvuQr6T8AjUNrkNPfeaMS1199ZX9Hnde_9W3R3NLyqNH9lgABAgQIECBAgAABAgQIECBAgAABAvkKTMwfu8zXTHUCBAgQIEBgjAVq1Wr09PQ8ZpX6LLhRl7ZUyTpmjPhIiY3-bVImVXKj_8PtWPiMiNlPSi1K0ofVo2I1YmwDEBi2QF8KdDVPmRlv-Ku3xQuf94dRq1aGFePpS9um3LD6O3Hpv3wk9u3dO-z6LiBAgAABAgQIECBAgAABAgQIECBAgMBYCQhujJWscQkQIECAAIGDFujfKqUn2xZj4CPruFGfvpNpTFulPNZP6w88yq_fybZKyQIbaZuUCbqdyK_v5EC_lhqnRWnFyyJmPXF_kEN440BMXpsAAn1p25MsvPG37_xgvPIVF0XWnWc4yznr5HPFf3wxPvm-d0en8MYEeOKmSIAAAQIECBAgQIAAAQIECBAgQKAYAoIbxXjO7pIAAQIECEwogWrquFHpfYytUtKeJg1NTaO4s0n6tqg_vDGhqIY82VLL3Cgd8dKI6Ufv7ywynE-7h1zFiQQOjcDUGfPif_z1W-PVF780qinMUR1qeivbcSeFN6797hXxife-K7o6Ow_NhFUhQIAAAQIECBAgQIAAAQIECBAgQIDAIAKCG4PgeIsAAQIECBDISSAFN7JtEQY7SilkMao5i_7BJtk2Kb8DWJq2IkrLLopoW5pCKunN0dhh5ndq-COBQyUwZer0eMNf_o94wQuenbZNqQ6r80a2bcr1q6-MSz9m25RD9bzUIUCAAAECBAgQIECAAAECBAgQIEBgYAHBjYFtvEOAAAECBAjkJVBXFw31DYNWr9aq0dvdsz-AMOiZQ3wzjVeEJENp9olROvwFEc3zRs9uiMROIzDaAjNmzY23vf2d8cqLL0rBjYPYNuXLl8Yn3_-e2GfblNF-NMYjQIAAAQIECBAgQIAAAQIECBAgQGAYAoIbw8ByKgECBAgQIHBoBMopuNHY3DR4sdQtorevFpVqefQ6b_RvHzLZ21CkVhsLz45Ycl5Ew7SUVZns9zv4MvLuxBeYOn1W_OWb_iaFN15yENum9MW1V17eH97otm3KxF8M7oAAAQIECBAgQIAAAQIECBAgQIDABBUQ3JigD860CRAgQIDAZBaoK5ejvnHw4EYWN-ir1kVXX13_rh8j80hhhv6OG6nrRgFyDKVSCrtkwY35T40otwhvjGzxuHocCLRPnRF_-pdvjAtf8Jz0r_LwOm9k26Zc990r4kv_-i_R2dExDu7GFAgQIECAAAECBAgQIECAAAECBAgQKJqA4EbRnrj7JUCAAAECE0CglDpuNDUOvlVK1iiiN-Usuvvq05YfKXgx4iMNWC3GdikZVamhPeqWvTBi1gkRdWXhjRGvHwPkLTBj5tx469v_MV75irRtyjDDG5XeSnz7i1-IT33gvcIbeT9I9QkQIECAAAECBAgQIECAAAECBAgUUEBwo4AP3S0TIECAAIHxLlBOQYLGltQJ4jGOatRFd-__Y-8-4CSr6rz_fyt0zj3T3ZMzTIYhLgK7BkRQVAQUdxVFWX1k_z5_DIAiSfQxrK6gsooKSM6IDCjxUUFhQTIDM8MEhsk5dM4Vnt-pYcZhpm51VXdVd4XP8VXSc8O557zv7a7bfX_1-9ntTFriNlyqjT2vAQ6cL6vLGuWbfJpUOSU9hvniwjxyVqDGlU355sX6_Of-TZFwv8Viue_p5JrLvPHEQw9a8MYP1UPZlOTQ2AoBBBBAAAEEEEAAAQQQQAABBBBAAAEE0iJA4EZaGOkEAQQQQAABBNIp4LeMG0VFxQm7dI9jQ1GfeiPpiNqwzlyplGj_7v8mPHKerRx1mDTByqaUjLa5J_-QO88UmE4eCbiyKf_7q-frE6d_JOXMGy5448mH_6i7r72GzBt5dE0wFQQQQAABBBBAAAEEEEAAAQQQQAABBLJdgMCNbD9DjA8BBBBAAIECFPAHLONGcRKBG2ErlZKOwA1XaiVqnYV6Cy5ww4W9-CecJJ8L3rDyKbEAlgK85phyfgnUjdpdNuXzrmyKfW-nEpPkyqY8cNstuv4nlE3Jr6uC2SCAAAIIIIAAAggggAACCCCAAAIIIJC9AgRuZO-5YWQIIIAAAggUrICLoygqLR1w_uGwTz19tlk6km64wA3LuOEe8hZc8xdZ4MbJksu-ESgyBzJvFNw1kIcTrqkbra9b2ZRzPru7bEo41bIpf3xQv_3Jj9Tb05OHOkwJAQQQQAABBBBAAAEEEEAAAQQQQAABBLJJgMCNbDobjAUBBBBAAAEEYgKBYFClJSUJNVysRrdVNmnptC-GHLhhHUQsYCNSeBk39iKXjpImnSpVTTdPbhH3uvBFTgtUWtmUL3_tfJ1x2oft-zuUUkzS7rIpf9Dd1_1KPV1dOe3A4BFAAAEEEEAAAQQQQAABBBBAAAEEEEAguwX4q3x2nx9GhwACCCCAQEEKBIuKVVNvgQQJWsQ-Pd_VG9aONku5MeTADXcgVyrFIkEKMePG287--vnyTTlTKm8yh7cX8h8EclzAlU259Lvf0-fP_jcL3IikFLzR39evhbfcpN9e9WOCN3L8OmD4CCCAAAIIIIAAAggggAACCCCAAAIIZLMAgRvZfHYYGwIIIIAAAgUqUBQsUnlVlYoTlEtxcQW9VieluTUdn4R_O-NGtIAzbrx9rfkaj7GyKZadoKSakikF-v2Xj9OutbIpX_vmJfrcZz9pyXVCSrVsyp8fuD8WvNHZ0Z6PPMwJAQQQQAABBBBAAAEEEEAAAQQQQAABBEZYgMCNET4BHB4BBBBAAAEEDhSIWhxFeUWFquvqDly5z5Ke7h61tdqD1Mg-CwfzpcvYEbFsG6EeC1YIDaaH_NnHXySNO0Gqmy_5gwRv5M-ZLfiZVFXX6v__2gU6_bQP2XUdTinzhiub8hcL3rjppz8h80bBX0kAIIAAAggggAACCCCAAAIIIIAAAgggkH4BAjfSb0qPCCCAAAIIIDBEAb_fr7LyCtXV11tP8euguKUhS7vR3uNXf7hY_kD87ZIbiu3rSqSEOq1iimXdKPDmK6mXb_LpUtVU4-d2scAvh7yaviubcpkrm_LZf7XAjdSCN0IWvPHnBxfqhljwRndeuTAZBBBAAAEEEEAAAQQQQAABBBBAAAEEEBhZAf4SP7L-HB0BBBBAAAEE4gi4wI3SsjLVxAI34mzgFvl89uDVp7aeIrX1BbziOzx29lgctoexIR7Ixnjr5knjP2glUyzrSdQVpqEhkB8CtXUN-tpFF-vsz5ypSCT1sil_Wnifbvzpf6mroyM_QJgFAggggAACCCCAAAIIIIAAAggggAACCIy4AIEbI34KGAACCCCAAAII7C_gs6CMkvIyVdd4l0px-TUiLuNGb1SdvfYvt2AozY4ZC9pwwRu0mIBv7HulhmOkYAnBG1wTeSVQVVWn877-TZ1-6in2gySUUmySK5vigjdu-vlVVjaFnxd5dWEwGQQQQAABBBBAAAEEEEAAAQQQQAABBEZIgMCNEYLnsAgggAACCCCQWKC4uES1o0dZYg3viAyXB6KtM6SOntDQAzcs8iPqsm24cilkmIidHF9RhfyTT5OqZ5mvZTXBJfFFy9qcEqgb1WBlU_7PoMumuOCNm392JcEbOXXWGSwCCCCAAAIIIIAAAggggAACCCCAAALZKUDgRnaeF0aFAAIIIIBAwQsEi4Kqqq5NGCwQsk--t7Z1qL0jTZ96j1g__a78QaTg_fcCVE6ykiknSWWj9y7iCwTyRaC2vkFfv-hSnX2WlU0Jp1425bH779XNP79S3Z0W8EVDAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQGKUDgxiDh2A0BBBBAAAEEMisQCARi5VL8wWCCA0XV0dGnra0RRcP-IVZLscwe_e32ak0YLJJgMHm7yjfmX6Sm46xkSgU2eXuWC3dilRYgdt4F39Bpp37Iru9wSollXNmUx39_r5VNcZk3ugoXkZkjgAACCCCAAAIIIIAAAggggAACCCCAwJAECNwYEh87I4AAAggggECmBIqsVIorZVA3qs4OEb9ciiuj0hcJaOW2MnX3B-Tzx98uqTG6kiyuVEpvq6KRvqR2KZSNfIFi-SedLo06VAoUEbxRKCe-gOZZV9-oy_6PlU35zCctcMMCwVwdpiSby_zzfxf-fnfwRneasv8keWw2QwABBBBAAAEEEEAAAQQQQAABBBBAAIH8ECBwIz_OI7NAAAEEEEAg7wSCRUUa1dSo6horl-LRXJhGT39Ea7b0qLvXypsMIW4jdgh7YBvLuBErl-Jx0EJdXNYo38SPWMmUsSaQwlPtQvVi3jkn4II3vhYrm_JxRSIplk3pD-nx--_TzT-9iswbOXfmGTACCCCAAAIIIIAAAggggAACCCCAAAIjL0DgxsifA0aAAAIIIIAAAnEE_H6_yiurVFM_OmE8Rl9vnzZu2aH2rv44vaS6yAISYuVS2lLdsSC299XNk0YfRcmUgjjbhTnJqljZlIt02kc_KEVSLJtiwRuPLfydbv75Vert7ilMQGaNAAIIIDBiApFIRIEAf-YbsROQxgO7RICZbuFwWAH7fYuWHwKBgE_unGaq8fMlU7Ij0697r3DnNJPN_Rwbhh9lmZwCfb8tELTrJZpKSkrkEEAAAQSGJMAd-pD42BkBBBBAAAEEMilQWlqmxgkTE5ZAiViWjJb2fm1oK7USJ0PMBGG_jEb7WqQ-AjfintdAiWXdOEWqPVjyB0i8EReJhbkuUFffoMu-8z197rNnplw2Jdzfb5k3fqebfnaleiibkuuXAuNHAAEEckpg6tSpWrHZ7s9oOS-wclNIUyaNy-g8pk2bphUbCDTNKPIwdd7dG9WO5m6NG5e5a2bs2LHa2dJtWS6H-Pv2MJlwmMQC7nvfvWdksk2eOE5vbg5l8hD0PUwCy-3eItPXyzBNhcMggAACOSFA4EZOnCYGiQACCCCAQGEKlFaUa_ykiSoqKfUE8NnnODr7fFqxzT4FMOTPdNgfovpad5dL8TxiYa_wVUyQxp0klY42CP5wV9hXQ_7Ovm50o87_5qX67FlWNiWcWtmUkMu8cf-9uuVqK5tC8Eb-XiTMDAEEEMgygVmzZmnp2j5t2MGDsiw7NSkP56cLu3To4ZblLoOtqalJUV-xnlnam8Gj0PVwCPz64W7NnztHLmNlpprre96c2brnKa6XTBkPV78vv9mv7bt6NGbMmIwe0v0Mu-fpzGWByejg6XyvwJbmsJ5a1KLZs2fvXcYXCCCAAAKZFcjcHV1mx03vCCCAAAIIIFAAAi7jxrip01SSIHDDMXT3hrRha0fs0_FDZnGlUix4Ixrljwxelr7GY6VRR1rJlGKL3SB4w8uJ5bktUFlTp6-ef5FOPfVku85TL5vy6H336uarf6renu7chmD0CCCAAAI5IeA-Ef_5L3xJZ_14l1ZuJHgjJ07afoPs6I7qK79p01ubevWlc7-839r0_rO4uFiXX_F9XXxTq_6yqFfhzFZNSO_g6S0m0Nsf1Y3_t1sPPNuh7_3wvzKucvFl39GNj7fpqvs75Y5Nyy0B9z3-9JI-ff3aZl13_fVyPwMy2b74v_5DT73WplO_u1PuZxst9wTetOxPn7uqReef_zW5ewwaAggggMDwCASH5zAcBQEEEEAAAQQQSF2gyP6YUD-6QTX19Wpr2eXZQU93r9ZuaFZ7_zhVF_cPIZjAqrBG-qSerVJv89tZJTwPW7ArfMEyyUqmRDtWS61vmJlRUMC2YK-HfJ547agGXf6d76u2plq33nav5ZgJKNm68-FQSI9b8EbA59dnzvuqSkq9MwflsyFzQwABBBAYPoFTTz1NkydP1eXfu0Itbc0aVVMyfAfnSEMTsBuMXS29OuGE9-onv74go9kT9gx03rx5uueee3TRhV_Tf967VWNHlykc5gHrHp9s_m8g4NOWHd2WBWOWfv_776qszH4_y3AbPXq0HnvsMV38zfP10e8s0xiulwyLp697d71stutlwtgmXX_9TzR9-vT0de7RUzAY1JNPPqkr_-uHOvOHT6i-1t6P-NCHh1b2Ld7Z2qva6ip9-4rv6bjjjsu-ATIiBBBAII8FCNzI45PL1BBAAAEEEMgHAfdHqPGTp2j9W296TidifwDY0iYt3lKq46b0uw_HD77FAje27y6XEisHMviu8nlPX_V0RRuPl7o2WpCLlZchciOfT3dBz63elU256DK7wn265fZ7FYn47GFKEpFK9twj1N-vh393l9zPqM-e9xWVlpUXtCWTRwABBBDIvMCCBQt06x33qK-vT83NFohMywkBnwVuTJgwYdjH6sol3HDz7QpZwOnmzZuHJWBk2CeZhweMRCKx6yUQCAzr7Nzv5j-9-hoL8Alrw4YNXC_Dqj_4g7nrxWVMcMEUmSyps_8I3bEu_OYlsZe7XqIEbuxPlLX_rquri2VlyXRmlqwFYGAIIIDACAoQuDGC-BwaAQQQQAABBAYWKKus1PgpUxJu6H7_37arW0tXt-i4qUP445V7FhuxjB3dO2LlUhIetOBX2mPsse9V1GXc2P6cFDa3JJ5lFzwbADkpUFVdq69ceFEsYOOGm-6ymvDB5DNv9If06H132_Y-C974mmXe4NPPOXkRMGgEEEAghwTcgxb3qrT7aBoCAwm4h6vuepk8efJAm7IegZiACxjheuFiSEVgJALTUhkf2yKAAAIIIJAtAv5sGQjjQAABBBBAAAEE4glUVFZp6syZKipO9LDTp86uPq3aYPV2w_ZANZlPw8c7mIs8iEYU7bcMEn3t9nXcjVj4toCvdJR8kz4qlY0jaIOrIu8FautG62vfuERnf-ZMm6v9nEjh54Mrm_Lo7-7Wbb_4mfp6evLeigkigAACCCCAAAIIIIAAAggggAACCCCAQGoCBG6k5sXWCCCAAAIIIDDMAsGiIjWOHa_JM1wd1vgpHeyD7ApFpDXbI9rVZf8YQtINi_qwzroscGOXPZvtHebZ5t7hfLVzpDFWMiVYQc3a3Dt9jDhFgUrLvHGBlU0561Nn2E-jiJVNSTJ6wzZzZVMeuudO3fqLn6unuzvFI7M5AggggAACCCCAAAIIIIAAAggggAACCOSzAIEb-Xx2mRsCCCCAAAJ5IOBS99aNHqXpc-bGSg14TanfyhFs2d6hXa09LmnGEJqLAum0cinbFA3zcHVASH-RfGPeLVVOtrgas0slDcGAnbMBAtknUFlTq69_42J99qxP2M-acEqXfNh-Trngjdt_-d_q7SEwLPvOLiNCAAEEEEAAAQQQQAABBBBAAAEEEEBgZAQI3BgZd46KAAIIIIAAAikIVFRXa-LU6QoEvVNp-K08SkdPRG9tK1J_OJAwyCPhoWMZNyxgo2erZd1oS7gpK3cL-ComSk2WdaO41hYkmYEAPARyWKAmVjblUn32M5-wSz71sikPu-CNa_5b_b19OazA0BFAAAEEEEAAAQQQQAABBBBAAAEEEEAgXQIEbqRLkn4QQAABBBBAIGMCJSUlGjdpsuobGu0YltUhTnNLu3pDenNjj7p6wl6bxdkzziKXOaJnp72220oCEeIIvXORBbv4xvyLVDPTytQUQfZOHf6VpwJVlnnjwm9drk9b2RSrq5Ry2ZQ_3nWb7r7uV-rrJfNGnl4iTAsBBBBAAAEEEEAAAQQQQAABBBBAAIGkBQjcSJqKDRFAAAEEEEBgpASCRcVqGDtWjWPHJRxCn316ffUWK5fS5UupfMGBnfoV7d1h5VK2WBCCBYHQBhTwlTZIY95jWTfqbVuCXQYEY4O8EKisrtX5rmzKp3eXTYmkcOm7sil_vPsO3XPtr9XfR-aNvLggmAQCCCCAAAIIIIAAAggggAACCCCAAAKDFCBwY5Bw7IYAAggggAACwytQUVmlyQfNVCDgffvis0wZK7f4tHyzbZPCA9QDZuIybvQ2WwqPzYqG-DT8AT4eC_wN_yTVHyoFS81_KCfA4wAsRiALBWrqR-vr37SyKWd9Qj4L9EoleKO7s3N38Mb11yrU35-Fs2NICCCAAAIIIIAAAggggAACCCCAAAIIIDAcAt5PPobj6BwDAQQQQAABBBBIUqC8qkoHz5-n0rKKhHts2LxLb25oVU_YbnPiV1VJuP_elS7Thsu40evKpdCSEiiqsJIp75FKRiW1ORshkC8CsbIpF1vZlH87w37spFY2xQVv_OHOW2OZNyibki9XBPNAAAEEEEAAAQQQQAABBBBAAAEEEEAgNQECN1LzYmsEEEAAAQQQGCGBsvJyTZw6TaMaG20E3hEZvf1hLbOMG2taiuXze2838DSiinZtimXdGHhbttgrUDtbqp0v-YvIurEXhS8KQSBWNuUiy7zx6Y8rGrHMG5HkZ93d0akH77pNv7PMG5RNSd6NLRFAAAEEEEAAAQQQQAABBBBAAAEEEMgXAQI38uVMMg8EEEAAAQQKQKC6tk5zjzzSZupdhiMUimjFuja9ZVk3fG6zwcZuuFIfPZZto2ujouG-AtBNzxR9RZXyNb1LKh9n9obvfarSc0B6QSCLBGrqRlnZlMusbMrHbVSpl0158E4L3rjheoI3suicMhQEEEAAAQQQQAABBBBAAAEEEEAAAQSGQ4DAjeFQ5hgIIIAAAgggkBaB6ro6zTrkUAWDQc_-_BYssKOlR6u2-tXaP5SsGxZ0EO6SOtftDuDwPCIrDhAYdYRUN1cKlBywigUI5LvA7rIpV-isT1nZlGjqZVMeuP1m3ftbMm_k-3XC_BBAAAEEEEAAAQQQQAABBBBAAAEEENhXgMCNfTX4GgEEEEAAAQSyWqCouFhjJ03W5IMO9hynS_LQ1hXSW5u7taO930p2eG6aeIXL1OEybbS7wI2tibdl7TsEfIFiqfE4qXT0O5bzDwQKRaCyukbnf_NSfebTZwyubModt-q-G8m8USjXC_NEAAEEEEAAAQQQQAABBBBAAAEEEEBgsI8ykEMAAQQQQAABBIZdwO_3a1Rjk-YecZRVQPG-jYmEQlqztVdrtlnsRSiwu2RHyqN1ZT4iirpyKd3WUSSUcg-FvIO_fr5l3TjUAmfsPFEupZAvhYKduyubcv5Fl-kzZ1nmDSub4qovJdu6Ozv14O0WvEHZlGTJ2A4BBBBAwARef_113XbbbVgggAACCCCAAAJDFnD3FO7egoYAAgggMHwC3nnGh28MHAkBBBBAAAEEEEhaoKKyUpOmT1dxeal6u6yUSZwWDPi0fnu_3lgX0pFTgqoutdiBFB6a7u3SZ0EHoXYL3NikaKhLvuLqvav4YgCBQKl8TccruuVJC3qJf54G6IHVCOS8QFVNnS68-IrYz5877rpfkYiFnPldOp8Bmv286mxv1wN33BILPDvj8_8ul3GIhgACCCCAwP4CHR0deuyxx_TAAw9ozZo1sdXvec97NGHChP035d8IIIAAAggggEBSAhs2bNC1114b23bKlCk69dRTddJJJ6nS_iZHQwABBBDInIA9jaAhgAACCCCAAAK5I1BcWqrxU6Zq7Hj3x2jvB6AtLe1avr5NOztc0MZgojZc99a_BWyoc7PU35o7SNky0uoZUo29fBGybmTLOWEcwy5QVV2rCyzzxln_ZmVTomEL3kh-CF3tHXrg9pt1_003qL_PSjfREEAAAQQQ2Efg17_-tU477TT9_Oc_3xu04VY_-OCD-2zFlwgggAACCCCAQGoC-95LuMBQd6_h7jncvQcNAQQQQCBzAgRuZM6WnhFAAAEEEEAgAwKBQED1DQ2actDBCXt3yTJWbpHe2Oy3h6XeAR4JO3k7MCTatVHq2mDBByk8cU3ccUGs9RXXyFd_hBQst_kOMnimIKSYZL4LuLIpF3zLyqZ86uP2U8VKMKXw7dBln6ReeJsFb9xyI8Eb-X6hMD8EEEAgRYGioiL19vYesNfDDz8cd_kBG7IAAQQQQAABBBDYT8DdW7h7if2bW-7uPWgIIIAAApkTIHAjc7b0jAACCCCAAAIZEqiqqdHsBYeptKLC8wguVGPD5mat2tCq3pDd8gw6dsP27dokta-xkh_9nsdjhYdA43FS-TjzN8cUHlZ79MZiBHJWYHfZlG_rU__2MfteSCHzhn3fxMqm3HKT7r_5RoX6-TmUsxcBA0cAAQTSLPDhD3_YSnAd-Ke9trY2Pfroo2k-Gt0hgAACCCCAQCEIuHsIdy-xf3P3HO7eg4YAAgggkDmBA3-7y9yx6BkBBBBAAAEEEEiLQHlFpabPnqOGpkbrzzsio7cvFMu4sba12OIGvLdLPCjbL9wdC9yI9mxLvClrDxSonCjVHiIF-FTGgTgsKTSBqhorm_ItF7zhyqaEUiqb0tHervtvvVG_J3ij0C4b5osAAgh4CjQ1NemYY46Ju_53v_td3OUsRAABBBBAAAEEEgl43UO4ew5370FDAAEEEMicAIEbmbOlZwQQQAABBBDIkIDP51PtqFGafZiV4UiQxiEUjmjlmla9tbFNPpftYbCxG1bXINrx1u6sGxmaU75268h940-0wI2qwfvnKw7zKkiBmtp6fePib-ssVzbFl3rZFFcy5X7LvtHf11eQfkwaAQQQQOCdAmeeeeY7F7z9r7Vr1-q5556Lu46FCCCAAAIIIIBAPAF37-DuIeI1r3uOeNuyDAEEEEBgcAIEbgzOjb0QQAABBBBAYIQFqmrrNGfB4QoEg54j8VuAx462Xq3a4lNr_1CybljUR89Oq1ewTtFQl-fxWBFfwFdhWTfqZkn-QKI4m_g7sxSBPBRwmTdc8MbHT7M0symWTemyzBsLLXBj4a03UzYlD68NpoQAAgikKnD44Ydr-vTpcXe755574i5nIQIIIIAAAgggEE_A697B3Wu4ew4aAggggEBmBQjcyKwvvSOAAAIIIIBAhgSKS0o0ftJkTZ5xkOcRLG5D7d0hrdjYqe1t_UPI-GAdxcqlWNaNrk2ex2OFh0CgRL6G48zflUtxqU9oCCDggjfO_9Yl-sQZH1E0kmLZlLZWK5nyWwveuIngDS4lBBBAAAF5fQL2hRde0OLFixFCAAEEEEAAAQQGFHD3DO7eIV7zuteIty3LEEAAAQQGL0DgxuDt2BMBBBBAAAEERlDA7_dr9NixOuSoo60CiivIEb-FQyGt2dqn1Vv9CoX9VprAe9v4PdhSt0-4z8qlrLbAjc2em7EigUDdHKli_O7gGWI3EkCxqpAEGpvG6vyLLtWZH_-I_RQbRNmUm2_SA5Z5g7IphXTVMFcEEEDgQIH3v__9qqurO3CFLbnuuuviLmchAggggAACCCCwr4DXPYO7x3D3GjQEEEAAgcwLELiReWOOgAACCCCAAAIZEigrL9eUgw5Wif3XqwX9Pq3f2a_F63rV0WMRA4OI24j17YI3elusXMoGiXIpXtyey31lTVK1y47iTgCRG55QrCgwAZ8amsbogm9dpo-fnnrZlI5Y5o0b9ODttyhkQWo0BBBAAIHCFCgqKtIZZ5wRd_KvvPKKXnzxxbjrWIgAAggggAACCDgBd6_g7hniNXeP4e41aAgggAACmRcgcCPzxhwBAQQQQAABBDIkUFxaqnFTpmrcxAl2BO-IjLaWdq1Y266tbT5Fo4MMGvDZbVN_u-SybvTuytCM8rhb8_O5wI1gVaJTlccATA0BLwEL3mgcY2VTLrWHboMpm9Km-278rR60zBsEb3gZsxwBBBDIf4FPfOITqq2tjTvR66-_Pu5yFiKAAAIIIIAAAk7A617B3Vu4ewwaAggggMDwCBC4MTzOHAUBBBBAAAEEMiAQCARUO2qUps6clbD3gGXdWLEloqUboopEvAM8EnbydqaIaPtqRdtXWdKISOLNWXugwKjDpfIxFrhh52CQ8TMHdsoSBPJAwL4nGi3zxoUXXWZlUz5qP23CFmSW_Lw6O9p138036g-330bZlOTZ2BIBBBDIK4GysjKdddZZcee0dOlS_elPf4q7joUIIIAAAgggUNgC7h7B3SvEa-7ewt1j0BBAAAEEhkeAwI3hceYoCCCAAAIIIJAhgarqGs05_EiVV1QmPMKmrc1aub5VXf2BWNxAwo29VvoCUvdmRdvelMLdXlux3EPAVz5WqphkgRtBjy1YjEAhC7jMG027M2-cNoiyKa0tuu-m661sym0Kh8KFDMncEUAAgYIV-NjHPqaGhoa48__lL3-pzs7OuOtYiAACCCCAAAKFKeDuDdw9Qrzm7incvQUNAQQQQGD4BAjcGD5rjoQAAggggAACGRAor6zUtFmzNWbCeOvdO5tGX39YSzf5tXKXBQ1YBo5Bt3Cf1GYZNzrWD7qLwt3R3Ovnm39polNVuDzMHAGXecPKplx48eX6-OkftsQ-IcsSlDxLe4sFb9x4nR647RbKpiTPxpYIIIBA3ggUFxfr7LPPjjufnTt36rrrrou7joUIIIAAAgggUJgC7t7A3SPEa-6ewt1b0BBAAAEEhk-AwI3hs-ZICCCAAAIIIJAhgZq6es078mjr3bu2QCQS1ar1zXpzXZuVILBbIFeuY1DNjtH-liLtlnVDKTxRHdSx8m8nX60FbgQscCNBkE3-zZoZIZCCgP1samhq0gXfukyfOOMjgyubYpk3HrnrdsqmpMDOpggggEC-CJxyyimaNm1a3OksXLhQy5cvj7uOhQgggAACCCBQWALunsDdG8Rr7l7C3VPQEEAAAQSGV4DAjeH15mgIIIAAAgggkAGB6tpazVqwQCWl3nU3A5Zlo7k9rDe3SDu6g3JVTwbXLOCjv92ybljgRtfWwXVRwHv5SkdZuZQJuwNnvONsCliIqSPgBFzZlDG64OLLdMaesinJfr_Ydh2trbrnhuv1xztvt8wblE3hmkIAAQQKSSAQCOj888-3GOUDg5QjlsbpP__zP9Xf319IJMwVAQQQQAABBPYTcPcC7p7A3Rvs39w9hLuXcPcUNAQQQACB4RUgcGN4vTkaAggggAACCGRAIFhUpHGTJuugufOs9wP_SL3nkF09fVq1sUNbd_XsTs7hvemeXQ78r9sn0muBGyulTsqlHAg0wJKApdmsmWmnidvQAaRYXegC9seyxqbdZVNc8EaqZVPampt172-v1R_vuFXhMMEbhX45MX8EECgsgfnz53t-SnbVqlW65pprCguE2SKAAAIIIIDAOwTcvYC7J4jXXKYNdy9BQwABBBAYfgH-Yj785hwRAQQQQAABBNIs4D4NUD96tOYddVTCnn1WSmXttrCWbQ6opz8Q95OICTuIrXw72qN7i5VLWS2FugbehS3-IWCpTnxV0yxww31yI9kUAv_Yna8QKCyBt8umWOaNj1vwhk9hK_WUvEBnR7t-d8Nv9ZCVTQnx6erk4dgSAQQQyAOBc889V7WWlS5eu----_Tss8_GW8UyBBBAAAEEEMhzAXcP4O4F4jV37-DuIWgIIIAAAiMjQODGyLhzVAQQQAABBBBIs0BpeYUmzThI5ZXl1nP8VBpWLUUbd3Rp8aoOtXUP4RPoLuigr2131o2eHWmeSQF0V9YoBUoLYKJMEYF0COwum3KhBW-c_rEPW7xTWJFkgzdsu_ZWl3njuljwBpk30nE-6AMBBBDIDYHq6mp9-ctf9hzsD3_4Q-3cudNzPSsQQAABBBBAIP8E3Hu_uwfwau7ewd1D0BBAAAEERkaAwI2RceeoCCCAAAIIIJBmgeKSEo2fNEmjGiwoIEHr6-3Rsk39Wr2jyGp5JtgwmVXtb9lTUUstGR1qR8kcLI-2KbI_ApTUWXyNPVVO9gF0Hk2fqSCQqoDLKtQ4Zqy-ccnlseCNlMumtDTr7ut-o4fuvE0hyqakys_2CCCAQM4KnHTSSXrf-94Xd_wtLS265JJL1NfXF3c9CxFAAAEEEEAgvwTce75773f3APHaCSecIHfvQEMAAQQQGDkBAjdGzp4jI4AAAggggEAaBdyDzaqaOo2dNEV-v_ctjt-2W7mxQ0tWd-wO3IifnGPgkfnsGN2bFWlebNk34v_SO3AnhbmFr6jKAjdG2eQHi1-Ybsy60AVc5o0mC94YRNkUC5ByZVPuuf56PXrvXZRNKfRLifkjgEBBCVx44YUaO3Zs3DkvXbpU3_ve9-KuYyECCCCAAAII5JeAe8937_3xmrtXuOCCC-KtYhkCCCCAwDAKeD_VGMZBcCgEEEAAAQQQQCAdAtVWi3PGnLlWLqXCuvMOCmhv69LSDSFt7CiVC_gYdLOSBWpbqajLvEFLXsCVSQm61JvOnpQbycOxZcEL2M-r0Y1jtLtsyimxsinRZL-FbLtY2ZTrrtXD99ypcJhMQQV_PQGAAAIFIVBRUaHLL79cwWAw7nyffPJJXXfddXHXsRABBBBAAAEE8kPAvde79_x4zd0juHsFd89AQwABBBAYWQECN0bWn6MjgAACCCCAQBoFioqLNXH6dDU0xf9U4Z5DuQeWyzZ0a8XGbgvc2LN0kP_tWK9o25tSuGeQHRTgboESqaisACfOlBEYusDesimXftvKppximYNCKZV9amneqXsseOOhu29XP-nxh35C6AEBBBDIAYG5c-fqnHPO8RzprbfeqoULF3quZwUCCCCAAAII5K6Ae4937_Vezd0juHsFGgIIIIDAyAsQuDHy54ARIIAAAggggEAaBabNnK3JBx9seRy8P4buHnxu3NaupevC2tVTLJ9_sNEbtl-4S9q1yLJurErjLPK_K1-AT3Lk_1lmhpkTsLIpDU268JJv6-Onfdhy14QV8f6R985hxDJvtOiuX1-j-278LWVT3qnDvxBAAIG8FTjrrLN04oknes7vpz_9KcEbnjqsQAABBBBAIDcFXNCGe4_3au7ewN0j0BBAAAEEskOAwI3sOA-MAgEEEEAAAQTSJDC6sUnTZs5UdU2dZ48uy0Z7d1iL1vRozY6QFPDcdOAVrlxKx1rrcJ2VLbC-aMkJBIqtUspQ4JM7DFshkLcC9oOswX7eXXDxZbHMG7KfRUmXTTGUzo52_fHO2_XI7-62jB2UTcnb64SJIYAAAvsIXHTRRZo_f_4-S_7xZdTeRK666irdf__9_1jIVwgggAACCCCQswLuPd29t7v3-HjN3RO4ewMaAggggED2CBC4kT3ngpEggAACCCCAQBoEAkVBTZ05S5OtZIpFBnj2GO4PafXGFq3b3G8PLYODL5nis9up3l1WLmWZ1LPT83is2E_Ab4Ebfhe44X2O9tuDfyKAwH4CLntQ05ix-oZl3jjDlU0Jp1A25e3MG3f_6ho9fM-dlE3Zz5Z_IoAAAvkoUFRUpB_84AcaP3685_Tcp3Lvvvtuz_WsQAABBBBAAIHsF3Dv5Ykybbh7AXdP4O4NaAgggAAC2SNA4Eb2nAtGggACCCCAAAJpEHAPMsdNmqqJM6YrGPDO6BAM-LS1JWTlUnrV3NFvQQSDDSCw_VymjZZlFryx0r7mk-tJnUa__XEglnEj_ic_kuqDjRBAwAQs80aTZd645HKdcfopu8umpPBjqL29TXda8Mb9N92oUIisQVxSCCCAQL4L1NTU6Mc__rHq6ryz0_3yl7_UT37yE4XDllmOhgACCCCAAAI5I-Deu917uHsv92ruHsDdC7h7AhoCCCCAQHYJELiRXeeD0SCAAAIIIIBAGgSq62o1cep01TaMst68AzJ6unu0YlOvNjUHhxZv4QIQujYo2rxE6m9PwwwKoAuXqpOYjQI40UxxeAR8amwc83bZlA_ZIVMrm9LR3qoH77hNj993Dw_phueEcRQEEEBgRAUmTpyoq6--WvX19Z7jePDBB3XBBReoo6PDcxtWIIAAAggggED2CLj3bPfe7d7DvZp773f3AO5egIYAAgggkH0CBG5k3zlhRAgggAACCCAwRIHikhKNmzxFDVZCIFELWJaNlZv6tGSdlUsZ6gcKI5a1o2Wp1P5mokOybo9ALDNJCmkB9uzHfxFAIK6AyzY0Zsx4XXjpFTrjVCubEkm1bEqz7vjVL_WYBW-E-u3nGQ0BBBBAIK8FJk-erJ___OcaNcoFOsdvL730kr70pS9pxYoV8TdgKQIIIIAAAghkhYB7r3bv2e6926u593z33u_uAWgIIIAAAtkpQOBGdp4XRoUAAggggAACQxSYOHWaps-eq9LyMuvJO-vG9p2ten1Nl7Z1F8k36HIpbw-2Y50izYulEJ9MHPD0Re3BcCxaxvvcDNgHGyCAwAECjY1NFrzxbZ3xsUGUTWlt1e3X_EK_v_kGyqYcIMsCBBBAIP8E9gRvjB492nNy69ev17nnnqvbbrtNUZcxjYYAAggggAACWSPg3pvde7R7r3bv2V7NvdcTtOGlw3IEEEAgewQI3Miec8FIEEAAAQQQQCCNAqOamjRt5izVJkgB7Q4XCkW0ZH2_lm227A9DiiGwncOd0i4L3GhfncaZ5GdX0VC3lUoJ2eR4AJCfZ5hZjZyATw0WvHHBxZfp9LeDN1J5ztZhwRsP2h_-Hr__d5a1g6w4I3ceOTICCCAwPAKTJk3Sr371K02fPt3zgKFQSNdee63OO-88bd682XM7ViCAAAIIIIDA8Am492T33uzeo917tVdz7_Huvd6959MQQAABBLJbgMCN7D4_jA4BBBBAAAEEBingygZMOXimJk2bYT14BwfYZlq_qVnL1naro694aFk3XPkPy7oRbbNyKZG-QY68QHYL9xbIRJkmAsMvECubMnacLrzk2zrt1A8paqWcUonBaG9t1u2_-G896sqmJPgD4PDPjCMigAACCGRCoMkCnq-55hode-yxCbtftGiRPvvZz-qmm25SXx_3ugmxWIkAAggggECGBNx7sHsvdu_J7r05UXPv7e493r3X0xBAAAEEsl8g8P998-Irsn-YjBABBBBAAAEEEEhdoKyiQju2bNLKpUsV6rfSHHGae8DZE_YpGCzRQZOKNbbWgjwG-yFzn8XERrokf4l81dOk4ro4R2SR7CFydOtf_5GZxEXP0ApSwJUnau-KaOHf27SzPayAR7misEUdzJo2Rh845XQFi0sL0ir1SQ48n8IAAEAASURBVPtUYT8DDz38SO3atknLl6-wFPd-Jfvt1tfbq-WvLZKL9J95yAL5_cT8p34O2GM4BRrLiofzcBwLgbwTKCoq0gknnKDu7m4tWbLEc37hcFivvPKKHn_8cTU2NmrKlCme27ICAQQQQAABBNIr8Ne__lXf-ta39NRTT8m9Jydqn_zkJ2Pbuvd4GgIIIIBAbggQuJEb54lRIoAAAggggMAgBNwvp52dXdrw1krt2r7Ds4ewlUtxARwzx5fp4LFF9qDSO0OHZyd7VrisGy7bRvlY-SqnWPmVwJ41_HePQF-7opv_LHVtsiUWtEHcxh6ZgvsvgRsZPuX2c62iolKHHnaYmrdv0bJly-37LbXgjdUrVqiiqkrTZ8-J_ZzM8IjpHoFBCxC4MWg6dkRgr4C7Hz766KM1depUvfjiiwmzanR0dOiJJ57Q888_r3orTThx4sS9_fAFAggggAACCKRX4JlnntEPfvAD3X333XLvwYlalf3-dumll-rMM8_kd7hEUKxDAAEEslCAwI0sPCkMCQEEEEAAAQTSJxAIBLR-9WqtWWEPLD2a3z7l3xPya9yoMs2dHFR5iW042NgNl3UjZFk3AmWWdcPKtBRXexy1cBdHeyyIZtNjUl-LIRC4UbhXgoshIONGps-_ewhXWVWtw448Sju3bdQbbyyzH2-BpDNv9Pb0xDJvuOCNqTNnkXkj0yeM_gctQODGoOnYEYEDBKZYFo0PfOADWrVqlTZv3nzA-n0XbN--XX_605_0t7_9TdXV1Zo8eTIPifYF4msEEEAAAQQGKRCxzJMuSPK73_2u7r33Xrn33IHaEUccoSuvvFJz584daFPWI4AAAghkoQCBG1l4UhgSAggggAACCKRPoKi4RDu3btHqlcvV09Xt2XGflVIpKy3WrMmVGls92KiNPd3b_v1dipY3yVc13Z5Ok1Jij0zsv13rpfUPS-FebN4BU3j_IHBj-M753rIp2zda2ZSVKZZNseCN113ZFL8OPuQQgjeG77RxpBQECNxIAYtNEUhCwL1vnHzyySovL9drr702YDr25uZmPfnkk3rkkUdinwQeM2aM3Cd-aQgggAACCCCQmoALmnSBGj_84Q_10EMPyb3HDtRKSkp07rnn6vzzz4-VzBxoe9YjgAACCGSnAIEb2XleGBUCCCCAAAIIpEkgGAyqs71dby1fZp823-bZq9-CK7pDQU1qLNG88fZ4ckgVTixQI9JjWTdKLXBjsmXdqPE8bkGuaF4qbXvajEIEbhTkBfCPSRO48Q-LzH-1u2zKIQsOV_OOzVr2xgpFUymbYpk3XOaiypoaTZ81m09TZ_6EcYQUBQjcSBGMzRFIUmDevHk68cQTtXXrVq1bt27AvTo7O_Xqq6_qvvvu06JFi2LbNzY2yj1QoiGAAAIIIIBAfIG2trZYdo1f_OIXci_3XureU5Np__zP_xwL8jjmmGOS2ZxtEEAAAQSyWCCYxWNjaAgggAACCCCAQFoExlm65-mz5mjNyhXqs4ePXm3nrjYtXlOtjfMqNKW-1z6RPoTMG5F-yQIUoq3L5Suf4GpCeB22wJZHpK6NVoombPMmE0mBnXymO8ICrmzK2HET9I1Lr4iVg1r44MOKRAKWQSO5gbU279Jt__2z2L7vP-10BZLdMbnu2QoBBBBAIEsFxo4dq-9___t64YUXdPXVV2vt2rUDjtTdR7_88suxlytd6FK2H3vssbGXK8VCQwABBBBAoNAF1qxZo2eeeSb2WrJkyYDZrfb3cuXJzjvvPB111FH7r-LfCCCAAAI5KkDgRo6eOIaNAAIIIIAAAskLNI4dZ-n9D9Urf39GW9Z7f1IwYn9gfvWtdi1ZV6Kp9QENIWxjd6BGz3ZFd70uX918qWxM8gPO5y3D_RbMsswe_FoABw0BBEZEoLGxSRdd_l3V1NXppptuTyl4o62lRbf-4mfq6mjXqZ85m7IpI3IGOSgCCCAwMgLuwdBNN92kBx98UHfccUcsC0cyIwmHw7FyK67kyq9__WvV19fHAjnmzJkjl9Fj5syZKi0tTaYrtkEAAQQQQCAnBXrsQ0TLly_X4sWLtXTpUrlAjV27dg1qLk1NTfrUpz6lj370o3LBkTQEEEAAgfwRIHAjf84lM0EAAQQQQAABDwG_fSp86kEHadK0GQkDN9yn0bft6tZra6M6ema5Gsq7LTHEYMM3LJtE1LJutLxhgQor5CttsGAOfqGOdm-XOuxTmi6biRHREEBgJAR8Gt3QqHO__FW1Wr3k-xda5o2oZd5I8nuy3YI37r_5BlXW1urEU08biQlwTAQQQACBERJwD4hOO-202MOixx57TLfffrvWr1-f0mjcg6qnnnoq9nI7uj7HjBmjSZMmaeLEiXtfo0ePVp0FGVZVVaXUPxsjgAACCCAwEgLtVqa32X6_2rFjR-y90b0_upcrNbZly5aUM2rsPwf3HvnpT39aJ510EgEb--PwbwQQQCBPBAjcyJMTyTQQQAABBBBAILHAuMlTdJClaH7thefU0xW_Tqh7ZtnZ1a-XV7RqxbygGmYk-RTT69AuUKNrnaI7XpSvdpZU2ui1ZeEsb3lN6nf-gw2IKRwqZopApgUa7JNa37zsO7HD3P_AQxa8EUyhbEqzbvnZlVI4ovdZ8EYgkGS9lUxPiv4RQAABBIZFwAVbfOhDH9LJJ5-sJ598UgsXLtSiRYsGVWrQZeTYuHFj7PXss88eMP5gMKhaCxZ0r4qKChUVFam4uDj2X_e1e9EQGAkBF_i_7_Xorkv3KikpiWWWcYFHo0aNin1NAFLiM-QeeLugrp07d8YefLuve3t71dfXF3v19_fv_e-QSpomHgZrEUgo4K7DPS93bbqvOzs71WKB7e4VCoUS7j-Yle7nzKGHHqqPfexjeu973yv3bxoCCCCAQP4KELiRv-eWmSGAAAIIIIDAPgIlln754PnzNX3mLC155WVb4xU4ENXabd16Y21Eh00uUXkwZFU9vLbd5wBeX7rMEjsXKVI3T_7xJ9pWhftLtlOM7nhFinTv5i9cCq-rheUIDLtAQ2OjvunKptRa2ZSbUy-bcouVTfFZVqP3ffRUyqYM-9njgAgggMDIC7jMdu973_tiLxd88fDDD-uRRx6Jfdo4XaNzD8Lcp5fdi4ZArgq4AKRx48ZpypQp73hNnjy5YIKP3EPutWvXas2aNe94bdq0KSMPvHP1WmHcCDgBl3Xqgx_8YCxIcvz48aAggAACCBSIAIEbBXKimSYCCCCAAAIISBOnTteE6dP0xqJXFYmE45K4UgE7W3q0ZG27trUENHl03M1SWGgd9m6Tdr0q1c6WKiamsG-ebdq5Ueq2VySSZxNjOgjksoBPDa5syv_-ilpbdun3Dzxsn5YO2ie5kptTm6UC_uMdt6lp4gTNP-Ko5HZiKwQQQACBvBRwD5a--MUv6t___d_14osv6umnn5bLoLF169a8nC-TQiAVAReA5MoluNff_va3vbu67BxzLTPkggULYq85c-bEsnbs3SCHv3AZCZYuXapXX3019lqyZEksi0YOT4mhI5BRgSbLiPiud71Lxx9_vI488kgC4zOqTecIIIBAdgoQuJGd54VRIYAAAggggEAGBGrq6zX14Fkabb8Mb9u82Y4QP5OGLxrR0g1hLd7o16S6iH2a3HPT5EYZ6ZeaX1O0ZYF85fZJiViHye2aV1uZgbq325QscCPZp8J5BcBkEMheAVc25RuXXKFouF8L__CYIv5iuUC2ZNr6Nau08JYbNX7SFNU3NCSzC9sggAACCOSxgMvCcfTRR8debppvvvmm_ud__kfPP_-8li9fHit3kMfTZ2oIpCTgyoG8_PLLsZfb0ZVacQ9sTzjhhNjD27KyspT6G-mNu7u7Y0Fbf_7zn2MBXC54g4YAAvEF3Pf7zJkzY--Xxx13nGbMmBF_Q5YigAACCBSMAIEbBXOqmSgCCCCAAAIIBK3-9eQZB2nC1KnasXWLJX7wCNywh5XrNjXr5eUl-qcZtWoot3IpHkEeSan6AlLPdkV3viJf3RypfEJSu-XVRqFuK5NiJWr62yiTklcnlsnkj4BPjU1jdNG3rWxKdbluvv33FrxRklTwRqg_pDeXLtaTD_1Bp3_unPwhYSYIIIAAAmkRcA-i3Ovss8-WK5WwYsUKuU_eL168WG-88QYZOdKiTCf5IuACHZ555pnYy2XjOPbYY3XyySfHPoWfzXN02XUeffTR2LhdMAoNAQQOFHAZNWbPnq158-bFMu0cfPDBBVMq6UANliCAAAIIxBMgcCOeCssQQAABBBBAIG8FJk6bppmHLNDKJYvV3mpBBB4BGf32IHLR2pDe2BRVw8G2WfzKKsk7udIsLUsVbV4qX-kYyV9Yt2HRznU2_zd2e5NtI_nrhi0RGE4B-95saBqvc7_6LbU079LCh_-qqGXeSOZbtqOtXW-88opaT92lmrr64Rw1x0IAAQQQyCGBIgukdmUh3OvMM8-Mjdx9Qn_9-vWx155SEtu2bVOzleNyr87OzhyaIUNFIH0CLgDiiSeeiL0mT56sf_3Xf9UHPvCBrHnQ6wKxHn_8cd11111au3Zt-iZOTwjkqEBFRYXq6upir8bGRk2aNCn2mjhxotwr1zLo5OhpYNgIIIBATgsU1hODnD5VDB4BBBBAAAEE0iFQVVOr6VY3eKz90tzeuiRhl6s2NuvVN8t06JQq1RT1KeqRoSNhJ3tWuqwb3ZsV3facfDUzpcrJe9YUwH8ts8n25y3bRrPFyVg6kyTLLxQADFNEIAsFXOaNcbroOz-ygI1vauFDf02qbErY_nC_fctmrVm5QocefUwWzoshIYAAAghkq4B7kOU-dexe8ZrLQNDS0hJ7uQfZ7t_u5R4a73lFo_Ez6cXrj2UIpFNgzzW473_b2tr2Bh65a9cFILW2tg7psC4w4kc_-pF--9vfxgI4zjjjDAUC9jvmCLRwOKz77rsvFrCxY8eOtIygpqYm9rC7trZ274Pv6urqWJCKC_ja95WWA9IJAikK-Cyafd_r0JU5cS-XGcddt-7l_k1DAAEEEEBgKAIEbgxFj30RQAABBBBAICcFDpo7TwfPP1Sr3limcDgUdw7ul_L2zpCefaNTR80s1rEzfBa4EXfT1BY2v67IjuflL7OsG4GS1PbN0a2j3dsU3fI3yWUdIWgjR8_iyA_b7_fZH8IK43tmxLXt51_jmIn69n_-XKMbfqCbbv2dQtFgwswb7nlZZ3ubdtonpGkIIIAAAgikU8A9CHOfXHYvGgK5KuAyx7iMMi67jAvCWLNmjV5__fVYQFIqc3KBEr_4xS_0hz_8QV_96ld1xBFHpLL7kLd96aWX9LOf_WzQGTbcw-358-drypQpcllEXBYCl5XAZSqgIYAAAggggAAChS5A4EahXwHMHwEEEEAAgQIUcGn8D5o3X6888z_aGEvp6vEJPYvUeGtzl5atr9GCycUqC4SHlnXDRS30t1j2iRelmjlS3dyC0I9ufUbq2W7ZNsyZwI2COOepTNLvt8pB9krUAgG_Fi9bp29f-CUFg0WJNmVdOgV8frW27FRpabHauyIJAzcs1kMRC87q7uxI5wjoCwEEEEAAAQQQyAsBF5gwe_bs2GvfCblAjtdeey32evbZZ5MO5HDBH1_72tf03ve-V-edd55GjRq1b7dp_3rnzp26-uqrY2VbUuncBWq8613v0iGHHBJ7uUANGgIIIIAAAggggEB8AQI34ruwFAEEEEAAAQTyWMBl05gxe46m2WuTferJK7WyfcBfO1u79dpbHXrP_HpNqU8DigteaF-paPNr8lVPtawb5WnoNHu7iHZtkTb_xZ7odmfvIBnZyAnYt0NFiV-lRZbRJsEoAhbZsWZTq1bf90SCrViVCQG_peD22f8GCq5xx3Y_SyNDKSmViQnQJwIIIIAAAgggkMUCLpDBvU455RS7j4ro1Vdf1ZNPPqm__vWvsRIrAw39iSee0KJFi3TFFVdowYIFA20-qPVuTK7_Xbt2JbV_XV2d3v3ud-s973lPbEz-ZG4kk-qZjRBAAAEEEEAAgfwWIHAjv88vs0MAAQQQQAABD4GGseM0__Aj9eaS17V5_QbbyuOxsWXdeOWtXr34ZliTLAtt7G9OHpt6HOqdi-0T7OprU3THi_LVWsaN-vm2Pk_TUNhD3Oj6P0gdqy1wI3-n-c4TzL9SEYjaQ_6KioBGVxfZQ_-ehLu6gCtfgF9fEiJlaOVQfuRlaEh0iwACCCCAAAII5J2AC3A4_PDDY6-vfOUrsewW99xzj5YtW5Zwri6gwmXf-MIXvqBPf_rTCbdNdeXtt9-u66-_3kqMWtnLAdqsWbN05plnxrKABCz4l4YAAggggAACCCCQmgB_-UzNi60RQAABBBBAIE8ESkpLNWPePE2cPuPtwI34E3MhFRu3tuiFlRU6ZmatJtb0e2boiN9DnKUueKNthSI7XpC_aopUVB1no9xfFO3aZGVh_i6Fe20yA9TCyP3pMoNBCLiAAL_9TfeIGaV68vWOWPhUnoYxDUKHXRBAAAEEEEAAAQQKVcAFPrz__e-PvVwplZtvvlkvvPCCJ4cLrPjNb36jFStW6PLLL9dQAydcf9_97neTKo1y1FFH6eyzz46VQvEcICsQQAABBBBAAAEEBhTgL-gDErEBAggggAACCOSrwBhLSTvt4FmqrKq0KXo_LnYpa19Z2alFq_sViXpvl7yT9RGy7ALbn7eSKa8nv1subelKwmx9WurebKO2W850sOXS_Blr8gKhqD50ZKUaawIWFJX8bmyJAAIIIIAAAggggEAhCBxyyCG68sor9YMf_EDjx49POGVXOsUFboRCoYTbJVrp9nV9uL4SNTcWNyY3NjdGGgIIIIAAAggggMDQBAjcGJofeyOAAAIIIIBADgtUVFbpoHnzNXbSFJuF9xNjv5Vo2LC1TU8t6dHa1iL5gmmIQnBZNzrXKbr5b1ZKZF0OK8YfeqR5saJbnrQSKVYjJQ1c8Y_C0nwQcJfIlKYSfeGkeoWtdAoNAQQQQAABBBBAAAEEDhQ4_vjjdcstt-hzn_tcwowaTz31lC699FL19_cf2MkAS9w-bl_Xh1dz2Tw-__nPx8bixkRDAAEEEEAAAQQQSI8AgRvpcaQXBBBAAAEEEMhRgelz5miWfTooECxKOIOe3pBeWtmsJat7FI34ZbEcQ28R-xRU82uWdWORBTik_ke1oQ8gMz1E-1ql9Q9JXRssHoYH8ZlRzq9eo3adfPKfa3X6u2rU3Rfhssmv08tsEEAAAQQQQAABBNIkUFRUpHPOOUdXXXWVRo0a5dnrM888o-9___ue671WuH3cvl7NHdMd2wVuuLHQEEAAAQQQQAABBNInQOBG-izpCQEEEEAAAQRyUKC2fpTmHnGkJk2dZqP3jsYIBizrxrYePbeiR1vaEm6avILLutG7Q9HtL1n2jfXJ75fNW0bDim58VNppcwr1JiLN5lkwtmEWcPE9leV-fesTDVY2pVq9Vj6lP0zQzzCfBg6HAAIIIIAAAgggkCMChx12mG644QbNnz_fc8R_-ctfdNddd3mu33_FnXfeKbePV3PHcsd0x6YhgAACCCCAAAIIpF-AwI30m9IjAggggAACCOSQgM9SZxw09xDNPuxwFRcn_sRQf1-fXljZpVdWRxUKpysmwYJFLOtGZOv_WKBDRw7JxR9q1EqkaKP9sa_fsm4kCISJvzdLC1kgYoEajbVB_ewLY_SDzzTq4HHFsewbrnyKq6DigjtcKAevETB427-Qr0_mjgACCCCAAAIIZJtAXV1dLPvFEUcc4Tm03_zmN3r55Zc91-9Z4ba59tpr9_zzgP-6Y7hMG-6YNAQQQAABBBBAAIHMCAQz0y29IoAAAggggAACuSNQO3qU5h91lN5Y9IrWLF9uD4bdo-EDm99iLFZvaNHflpTrkCk1mlDTZyVODtwutSXWaX-7tP3vitbMlK_h6NR2z6Kto73Niq77o9TtSqTYwLwTmGTRqPNlKPGvWe_ZZefJiViERkWZX589sV7_MrfSvtc6Y6_VW_u1qz2kkH2_ZefIvaVzfo2BByzAzUqZq7MvIBfARkMAAQQQQAABBBDIDoGSkhL96Ec_0iWXXKLnnnvugEGFw2FdccUVuvXWW1VTU3PAeregtbU1to3bNl77p3_6p1jZleLi4nirWYYAAggggAACCCCQJgECN9IESTcIIIAAAgggkLsCwWBQU2fN1rRZs7R25UpFI_H_YOVmGAqF9PdlbTpiRqlOOyqgwNAjN-xJtCVB61it6Na_yVcxQSofl3OY0XCPomvul3bZp7nC_TYnHq8P20m08jSxdBSpHNBdc-6VhS3igjMsvcaUscWa0lSkf_2XGoVt2e6sG6kGqGThBHNwSFH7dn5tnU8X3tqmbVu25uAMGDICCCCAAAIIIJC_Ai6g4vvf_76-_OUva7l9EGH_1tLSol_96le66KKL9l8V-7db57aJ12bOnEnQRjwYliGAAAIIIIAAAhkQIHAjA6h0iQACCCCAAAK5J9A4dpzmHXm0lr36qjauXWsTiP-A2G8BCRu3tOuxF8t00Pg6LZjoUzQUf9uUFFyww_YXFamaJv-ED9lH3EtT2n1EN470W6aNB6RNj0l9lj2EoI3hOx2RPvnGf1AatcDcLSVCki266S_Sjhey9lzFyqJY6RTXggGfvWyosX8REBRjGOb_cz_iShJXkhrmEXE4BBBAAAEEEEAAgX0F9gRvfOELX4gbhPHII4_owx_-sObNm7fvblq8eLHcunittraWoI14MCxDAAEEEEAAAQQyJEDgRoZg6RYBBBBAAAEEcksgYHUAZs0_VAfbH7I2rVtnCQy8gzHC9vH_V1e36-9vlGtGY5kqiyxwwTICDKm57Ae9Oyx4wx6m186VrGxKrrToTsuyscGCNnp32ZCzM4tDrlimPE6XbWPUofKNOyG1wI2uzRa48bwdLncCIby_I1NWY4dBCPj9fG8Pgo1dEEAAAQQQQACBYRNobGyMlTz5-te_rohLY7dPc7_fXnnllbr--uutBN7ugG9XGsUti_e7r7v3-853viPXJw0BBBBAAAEEEEBgeAT469vwOHMUBBBAAAEEEMgBgbGTJmnBu47X2EkTbbTeD7QDdge1c2en_rKoVYvXhayGQ6KtU5i4C95oWarIlqes3EhPCjuO3KbR1mWKrrpD6t5kg7Dxe7ON3CDz-cgumiGFTBt7KHw-4rf3WPDf5AT2_-N_cnuxFQIIIIAAAggggMBwChx--OE69dRT4x5y1apVeuKJJ_auc1-7ZfGa6-Owww6Lt4plCCCAAAIIIIAAAhkSIHAjQ7B0iwACCCCAAAK5J-CzEh8zDz1Ucw8_QoFg4gfbrnTDktWdeuTlHm3usBoCabmrsqiHcJdl3fi71OkCIbI7x0C0Y42iK2-T2t-04BUbK0Ebw3_Ru6ANf3Hqxw2Wpb4PexS0ABk3Cvr0M3kEEEAAAQQQyCGBL37xi6qrq4s74rvuumvv8n2_3rvQvnD7uj5oCCCAAAIIIIAAAsMrkJZHDMM7ZI6GAAIIIIAAAghkTmDM-Ak65r3v1_TZs-UCORK1np4ePfrCTi18oU9t_SVyCTOG3qyTzvWKbHhI6rHSKVnaou2rFV32a0s98qIFm_QTtDEi58mCZQIWYDTowI3E1_eITImDIoAAAggggAACCCCAwJAEKisr9R__8R9x-1ixYoVeeuml2Mt9Ha-5fV0fNAQQQAABBBBAAIHhFUjL44XhHTJHQwABBBBAAAEEMifggjVmzJ2r2QsOU0lpacID-e2597Yd7brvb9v0xKIeSzoRSE_wRtRqr2x5UmpenJUlU6IdaxVdcaO06zVLCuLqxBAAkPBCydRKq1Mtn2Xb8Lsa1SmeA5dxI8VdMjUN-s0NAUql5MZ5YpQIIIAAAggggIATOOmkkzR-_Pi4GC7Thle2DbeP25eGAAIIIIAAAgggMPwCBG4MvzlHRAABBBBAAIEsF6itH6UFxxyryTMOGnCkwYBPqze165YnWvXkMikU9g09jsGl7uhtVnTjY5Z9Y6ONwR7QZ0mLdqxT9M2bLWjjZSuPEiJoY6TPi9_K9PgSl_WJO8QApVLiurDQU4BSKZ40rEAAAQQQQAABBLJOwH0g4cwzz4w7rueff14vvPBC3HVun4EyT8bdkYUIIIAAAggggAACQxYgcGPIhHSAAAIIIIAAAvkoMO-II3XcB06WC-IYqPkV0aLlO_Tje7fqD6_61B0ODj14wx7IR3e-pOiGh61kys6BhjAs66PNSxVd8jNLM_KMZQLpI2hjWNQTHcSVSnEZN0pSz54RJPVxIlnWIYAAAggggAACCCCQ6wIf-tCHVF1dfcA0opa5L142Nbet24eGAAIIIIAAAgggMDICBG6MjDtHRQABBBBAAIEsFyguKdGR__wvOvy44xUIDJzRwOeLaPnaZl31-426__mQuiNFaSmbEt30fxXd8XdL5dE1cmJWDiW67VlF3_iF1LLEMm1QHmXkTsY-R3alUvyWOSNogRup1j0prtmnI75EYGCBeH_cH3gvtkAAAQQQQAABBBAYKYES-502lbInblu3Dw0BBBBAAAEEEEBgZAQI3BgZd46KAAIIIIAAAjkgMGbCRB3_gQ_q4PnzbLS-AUcc9Ee1YXObbv7zNj36igVvhAJDzLxht2rhLkXXPCC1v2kVU8IDjiHtG0T6Fd30J0WXX2tjWLW7e0u7S8sGAQvcsKANX6A05cH4XLBHkHIpKcMV8A6USingk8_UEUAAAQQQQCBnBd797ncnPfZUtk26UzZEAAEEEEAAAQQQSFpg4I-PJt0VGyKAAAIIIIAAAvklEAgENP-oo7R1wzpt37JZO7Zsswnaw_IELRjwaeXqFv33g1GFo0366BFBFftCcskRBtcCsYCJ6NoH5CuqlSonWjfDEzgR7d6u6LrfSxsfl_pa7bg2luE59OCoCm0vd1G5oI2AC8BI8cT47Fy666l_k-1KLHehXTqDmS8ZNwajxj4IIIAAAggggMDICsyfP1_19fXatWtXwoG4bdy2NAQQQAABBBBAAIGRE-CvtCNnz5ERQAABBBBAIAcEXMmUY044UcdZ5o3yygob8cAPyC3eQ2s2temGx3bpL4vDFurhH1rmDX9Q0a1PK7rhYak38R_c0kUa3bVI0df_S1r3oAVttNm0CdpIl236-nGBGxa0ERhMOmM7n7FyKYOOKErfNOgpJwTIuJETp4lBIoAAAggggAAC7xDwWbbE448__h3L4v3DbeO2pSGAAAIIIIAAAgiMnACBGyNnz5ERQAABBBBAIEcE6hsa9P6PfEz_9J73qbTMSlMk8fesgC-qFetadM_THXp5g18Rm2sSu3mIuD2jFrjxqKJbnpZCnR7bpWGxBWlENzyi6NKrpeZXrVRLPxkZ0sCamS4s6CJoGTd8g0ii5_YhcCMzpyVPeyXjRp6eWKaFAAIIIIAAAnkvsGDBggHnmMw2A3bCBggggAACCCCAAAJDEhjEX3mHdDx2RgABBBBAAAEEclJg0owZOuPz_24PyX16-vFHFOrtG6Boim0aDenp17aqotyvyg_WaGZj30CVVhLYWPBGuFPRt-6USmrkazhmd5mMBHuktCpqmUF2vKjo2oUWsPG6HavHdifLRkqGw76xZXIJWBaYwUQE-QPyFddaCR8LKRrM_sM-Vw6IAAIIIIAAAggggAACgxGYPXv2gLsls82AnbABAggggAACCCCAwJAECNwYEh87I4AAAggggEAhCUycNl2nf-4cBawWytOPP6re7i578J1YIBIK6cmXt2pcjV_nfKBSTZUhRcMD7OTZpSVL690mvXWPZVqokuoPkfxFnlsntcIFbHRulNb_UdHNT1pZFFeKxZ7ku9IotCwWsGvISuiotN7GOIgkem7fklEWSDTYazGLaRgaAggggAACCCCAAAII7BUYP368qqur1dZmJTDjNLfObUNDAAEEEEAAAQQQGFmBQfyVd2QHzNERQAABBBBAAIGRFJhkwRsfP-cLOvFjZ6iiyjJfDJCtwK3v7OzXIy-16M-v9agvZFkShnIH5itStG2Zoqtuk1qX2YP30OA5OtZYBo-7FX3lO4que9CCNlp2B2wMaYCDHw57pigQKLFyJxZ8MdBFGLdbuzBLG2yNK-JDQ2BgAb9_KD-4Bu6fLRBAAAEEEEAAAQQyJ5Aoo0aidZkbET0jgAACCCCAAAII7C_AX9_2F-HfCCCAAAIIIIDAAAJjJ07S6Wefow-cfroqKgcO3gj4o9qwuU0P_L1TL6zxW4kVC94Y4BgJV7vgjeZFirxxjbTLyppE-hNu_o6VYSvxsus1RRb_VJGXLlN05Q0WWbJmd-aFQQUAvKN3_jFcAi5TRqBYKmuyIw7yaiodbfu6XwfIujFcpy2XjxOJEOSTy-ePsSOAAAIIIIBAYQtMmDDBEyDROs-dWIEAAggggAACCCCQdgFKpaSdlA4RQAABBBBAoBAE6hsb9IEzzlRnR4f--tAfrGxKT8LH3y5449XlO_SHvwc1sb5ak-rsIehQnoNa8Iballvwxq_km3amfI3HWvmU8gPpLVBD4U5Fu63Eys5XFN3-nNT-lhTqsm3dA3t7cE_AxoFuubDEbxk3XLmTwWZICVbaNWOvSC_XQC6c7xEeIxk3RvgEcHgEEEAAAQQQQGAIAo2NjZ57J1rnuRMrEEAAAQQQQAABBNIuQOBG2knpEAEEEEAAAQQKRWDshIk62YI32lvb9PwTf1IoFE449XAopL--3qaZk8p15jFBVQRDcokTBt1c8EbnakVd5o3mxVLtPKnIHsRHbRzu1bPD1m9QtHOtBXmssmCNDjuUy87ggjVIvDZo96zY0S4cv53_cgvcGGzGjSIL9CmusuukJytmxCAQQAABBBBAAAEEEEAgMwJNTS5TX_yWaF38PViKAAIIIIAAAgggkAkBAjcyoUqfCCCAAAIIIFAwAtNmzdapn_qMujva9Mqzzyact0tssXV7mx58Jqhpo0fr3bPtkbs9fx9K7EYsCCPUrujaB6T1f7QO3e2dpfJwgRthK6HiAjRir4D91160_BEoqrZTWjHo-fiCVYoWWeBG91aujUErsiMCCCCAAAIIIIAAAtkvkCg4I9G67J8ZI0QAAQQQQAABBPJHgI9a5s-5ZCYIIIAAAgggMEICBx9yiN77kVM1Yeq0AauO-C14Y_n6Tv11aa-2dljGhIDLgDHUZrd0geLdARp76q-4II1gmS23chouMwMZNoaKnGX723VTOmZo59UFbRRXW5DPUGr2ZBkLw8mYQCTCdZIxXDpGAAEEEEAAAQQyLFBTU-N5hETrPHdiBQIIIIAAAggggEDaBQjcSDspHSKAAAIIIIBAoQn4_X4tOOZYvet971d5pT0MT9Bc1o2e7l49-0abXl4VsvIq0cEWuohzFBcEsu8rziYsyhMBO8-VE20uQ7idd0E9xfXWx9ByvuQJKNMYQMD9nKMhgAACCCCAAAII5KZASYnd-3u0ROs8dmExAggggAACCCCAQAYE-OtbBlDpEgEEEEAAAQQKT6Cmrl7v_uApOvy44wfMuhGwO7BV69r0yEvtWrvLZcooPC9mPEQBu2Z8lZOHlnHDhuArG2f_ZxlZCN4Y4glhdwQQQAABBBBAAAEEslcgUXBGonXZOyNGhgACCCCAAAII5J8AgRv5d06ZEQIIIIAAAgiMkMCEadP0vg-fqpmHLBgweCMSCeulNzv0_MpehSJEbozQKcvhw1opnPLxQw7cUIX14Urq0BBAAAEEEEAAAQQQQCBvBUpLSz3nlmid506sQAABBBBAAAEEEEi7AIEbaSelQwQQQAABBBAoVAGf1UGZeeihsawbFVU1AybS2L6jQ08t7dKKnUXyBQneKNTrJvV5R6SSevlKqm3XIV435ZZxI2B_xI1SLiX181BYe0Qidt3REEAAAQQQQAABBHJSoLjYMj16tETrPHZhMQIIIIAAAggggEAGBAjcyAAqXSKAAAIIIIBA4QpUVFbp8GOP15wFh9kzde-H6m5VKBzRKyua9dKKbvWGg4k2L1xQZn6ggHuAXjlpd8DFgWtTW1Jh_cQybhC4kRpc4W3t9_OrY-GddWaMAAIIIIAAAggggAACCCCAAAIIIDBcAvz1bbikOQ4CCCCAAAIIFIzAtFmzdeQ_v1ujmhoTzjlgd2I720Ja9Fa3trbYw3i_d6BHwo5YWWACEfkqp9j14p3uOFkQX3GVVDo62c3ZDgEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQCADAsEM9EmXCCCAAAIIIIBAQQsEAgEdcvTRWvrKy_rbo39UJOKdzSDU36flG3q1bENU42p8Cipq_6MhkEDAXSBVky1wI5BgoxRWVR8s7Xo9hR3YFAEEEEAAAQQQQAABBHJNYObMmbk2ZMaLAAIIIIAAAggUlACBGwV1upksAggggAACCAyXQNPESTr2xBO17q1VWr18qaIe0Rgu68bK9e36-_JiHT6lWqMrbYQe2w7X2DlOFgtELTNLcbVlyRhrpXjSkzzPVztHUd_vs3jSDC0bBCKuRA8NAQQQQCDrBdra2nTDb6_T2reWa9eu5qwfLwNEAIGRFzj7058Y-UEwAgQQyBqB-vo6TZ42U1_8X-eqoqIia8bFQBBAAIFCECBwoxDOMnNEAAEEEEAAgWEX8Pt8mjZrjg6eN0_r3lyuUCjsOYZ-l3Vjs0-rdwY1uqLfcztWIKCoXUdW2sRXOsow0lRap2q6dWXZO1xQCA0BDwG_Pz2BQh7dsxgBBBBAIA0Cmzdv1hfO-ZxOfVexPnmkTw01_OxOAytdIIAAAgggUFAC21u36IU3N-uDH3xAd911l8aNG1dQ82eyCCCAwEgKELgxkvocGwEEEEAAAQTyWqBu9GjNPORQvfrcc9q6Ya1n1g33-H3VxnbLvFGiwyYWKWgLSLqR15fG4Cfnsh5Y4IaKa62P9ARu-IprFC0fL3WsTVsWj8FPkD0RQAABBBBAYDACfX19-uQnP6kLP16lU44uGUwX7IMAAggggAACCGjqGOloq6w0ralK3zj_PN1w8x0qLi5GBgEEEEBgGAQIvR8GZA6BAAIIIIAAAoUpEAwGNW32bE2fNVsJP61uz99bWzq1eH1YmztKJe7QCvOCGXDWFs5jWQ985ROlQBr_aBIsla_G_ioTDQ04AjYoXAFKpRTuuWfmCCCQGwIvvfSSDptZa0EbZbkxYEaJAAIIIIAAAlkt8MEjy9RQ1S93j0FDAAEEEBgeAR4LDI8zR0EAAQQQQACBAhWYMHmqZs6fr_LKKk8BlzehLxTV6m39Wr_LHp7705NJwfOArMhNAZeGpciuo5qDdpc2SdcsfJaEr24OpVLS5Zmn_SQMPsvTOTMtBBBAIJcEVq1apTkTKHuWS-eMsSKAAAIIIJDtArPHR-TuMWgIIIAAAsMjQODG8DhzFAQQQAABBBAoUIFgUZEmH3SQJkydmlDAfZp907ZmbdvRKVcNg4bAgQIWuRG0wI3a2ekvaVIxxfqusENy8R3ozhInQMYNrgMEEEAguwVCoZCV2wtn9yAZHQIIIIAAAgjklEDQH5Irx0ZDAAEEEBgeAQI3hseZoyCAAAIIIIBAAQtMnDZDE6dNTyjgtywb7d0-rd9ZpLa-InswT9aNhGCFurJygnyljTb79F4fvjIrYlsxyZ7O88CnUC8t5o0AAggggAACCCCAAAIIIIAAAggggAACIydA4MbI2XNkBBBAAAEEECgQgarqGk2YMk21o0Z5Pm53j-F7-qVtrSF19lpmhfQ-ly8Q6TyfpgvmqZtn10Yg_RMtrZfKx1m5FCvVQ0MgjgClUuKgsAgBBBBAAAEEEEAAAQQQQAABBBBAAIE0CRC4kSZIukEAAQQQQAABBLwEgsVFGjtpkkY3jfUMyHDP5Ht6etXS2hH7r1dfLC9kgf_H3n3AR3qVd9__31PUu7TSarVF23dd1wU3bGOzbjQHDA7YhNAhODwhhIQkJHkeQnghGIwBA6aHbpsWA6a4425ct7jteu1t2l7U29T3OqOVvUUz0kozoym_w2dYae52zvfc489ozjXX5ZNXZ4EbvgwEblikkFdtWWF8pcUMzNhTCFAqJQUOmxBAAAEEEEAAAQQQQAABBBBAAAEEEJiiAIEbUwTkcAQQQAABBBBAYDwB9031hhktapzRZLsmT6URjUbV2RtST19MXtyybtAQGBWIx6yUyRx5VVbORBl6C9-0Qiqts6wbdi0aAggggAACCCCAAAIIIIAAAggggAACCCCAQNYEMvSpb9b6z4UQQAABBBBAAIG8EKisqVZFVbXi9r9kzWdpNwZjQfWGS0XcRjKlIn3eSph4TadIgcrMAdQul8qa7fzJ79HMXZwzI4AAAggggAACCCCAAAIIIIAAAggggAACxStA4Ebxzj0jRwABBBBAAIEsCgQCQZVWVCjgT13mIhyRQhF7i-Zqp9AQSAhYIIVn9029K5MSyJiJ59l913iynZ8_ETKGnMcndpmDaAgggAACCCCAAAIIIIAAAggggAACCCCQGQE-fcuMK2dFAAEEEEAAAQQOEQgEAiorL1cgWJI0JsPFakRiPg1Z8EY8TuDGIYDF_EvMbojKuVYmZZ4FcGT27bvXcnbGr1HMU5nPY4_FKKGTz_NH3xFAAAEEEEAAAQQQQAABBBBAAAEEclsgs5_85vbY6R0CCCCAAAIIIJA1AReG8VIBipd-OPTybp-YPLn10SS7HHoAvxWHQNxuCBe0UT7DxpvZgB6vck4iSETumjQEEEAAAQQQQAABBBBAAAEEEEAAAQQQQACBrAgQuJEVZi6CAAIIIIAAAsUuELVojEgopGg0mpTCBWsEfTGVl8Tly-z6fNI-sCHXBOyuCFbKazjBYjYyVyblpVH7y-Q1n2kRROGXnuIHBJwApVK4DxBAAAEEEEAAAQQQQAABBBBAAAEEEMicAIEbmbPlzAgggAACCCCAwEsCodCwBvt6FbbgjWTZNOK2oSwQVaUFblitlJeO5YciFnCZL0pbpOZXZidww5VimfGKRLAIWTeK-L5j6AgggAACCCCAAAIIIIAAAggggAACCCCQVQECN7LKzcUQQAABBBBAoFgF-rq71dPVLc9LnkojZsEaZX4L3AgM234EbhTrvXLouO1-aTxRXmndoU9n8Devql2qXmjBQ7mXdcNlovHZayjFyyiDMsV96pir4URDAAEEEEAAAQQQQAABBBBAAAEEEEAAgYwIZCHfckb6zUkRQAABBBBAAIG8EYhEItq26UXt6NhqfU4ekBEMlqihrlzVVX7F3co0WTcyNsc-FwHgt9P7DsQx26-JFrX5sWo2ObNI7QvIm3l2drJtHCBQsEqqO1bqfHr0mWn7102LF7D_D9g82T_xwaiiloUkEPTZ8_aceznZnMWjMV4u0zZLXBgBBBBAAAEEEEAAAQQQQAABBBBAAAEEpipA4MZUBTkeAQQQQAABBBAYR6Bn_349u3q1dmzZlHRx2cVoVFQE1DqjygI3Sm1BOveyHYwzzJzfnAjWSPQyrq27B_X4hl5tsX-37xtKBADUVAY1s75Epy6p0dLZVSotHQkMiMcsMGA6Rhe3CJK6Y-TVLLaghQMBJlnqhzfzXMV33CkNd2b92m6IibmyQI3h4ajufbJL9z21X89vG9Ce7rAF1cRVYsEcleUBnTC_Smctr9Ppx9TKzZ-bKLedhgACCCCAAAIIIIAAAggggAACCCCAAAII5JMAgRv5NFv0FQEEEEAAAQTyTiBuERnr1q7Rs6ueSLmg7NaaK0rimlUbU639mzTCI-8Epr_DiSAAe9e7b39Yd6_apx_fsV2PWdBGZ19YoVBMkQML_S4JR9CyOFSU-dXeUqbLXtmit5zTosWzK-X3e4q5bBzZbBa44c0837JNVGTzqiPXql1m5VIWWeTEI1m9tiuDIgvK2GYBNTfevUPfu3WbBdkMq3cwMmY_fnX_LtVU-DWnuVzvu6RNbz5npubY3MmqehDAMSYZTyKAAAIIIIAAAggggAACCCCAAAIIIIBADgoQuJGDk0KXEEAAAQQQQKBwBHZu69Dj99-rbRs3phyUZwvWsyzbRntriWUTiCg-9jp1ynOw8UgBnwUBhEJR_fGBvfra77bqntWdGg7bqv4YzcVvuG3u0dkb1pMW3PHN33fob143W3_z-jlqrCtVLDL2sWOcbmpPxSzjSsVsqfEEy3jharpkt7n7UW2XKL73saxd2GfBMZFwXD-7e7u-8IvN5t8zoWv3DET19KY-feyb6_TtP3bo3966UJe_qiURhEPwxoQIJ7STb7Ss0IT2ZicEEEAAAQQQQAABBBBAAAEEEEAAAQQQOBqB7OZcPpqesS8CCCCAAAIIIJDnAkMDA3r0nj_piQfvVzSaPBLDlUkpK_Hp1EXlOnZ2iZTtzA557pys-y4QYHfnsD7-7fW68nNrddtj-5IGbSQ7R8eeIf379zfosv9cpXtX71fcpeXIeLMbwt0UjSvkVbTa1bJxzSMH5c04VapZaH3JfLCKm6vu_oj-_hvP6e02VxMN2ji41y7w5plN_Xr3NWv1_i89rR37h-UL8ufOwUb8jAACCCCAAAIIIIAAAggggAACCCCAAAK5KcAnmbk5L_QKAQQQQAABBPJcwJVIeWbVk3rg9tu0f8_ulJVPbL1Zrc11OqG9XA0lwyn3zXOWrHXfZdp4Yfug3veFp_WNW7aqfyg6pWvfu7ZT7_nCU7pvlQVv2Lkz2hKRPA3yWs6xmI1gRi-V8uRWosWbdZHVHLHsHxlsrpTNvq6Q3nX1Wn3tN1ssUGRqFwtF4vrpnTv0j5aBY9e-Ifms_A0NAQQQQAABBBBAAAEEEEAAAQQQQAABBBDIZQE-xczl2aFvCCCAAAIIIJC3AuvXrtHvbvyx1q1ZNW4gRiAQ1ClLKi1wIyCPd2dTnnMXtOFKnfzLt9fptidclo0pRgIc6NELOwb0EcsI8ejTXRlOgmH9rVsuNbgyKdN8Q7isG-UtFryRPGPMVCbMs6CN4VhM__yd9br5wd1TOdUhx4Yta83P79upT3znefX0heUqv9CmJhCzeaIhgAACCCCAAAIIIIAAAggggAACCCCAQGYEpvmT4MwMirMigAACCCCAAALTKfDU44_qp1__qh5_4H4L2kgdNBCxRBDL2qv1mpMrNbvOfkm9-3QOKy-u7dkKfd9QRJ_56Yv642N7j7o0yniDXPNirz7y9ee0e38oc8EA_lJ5895sMRtWNmeam1fRJjWfeaBcSnpvThdM4eIpvv_7bfrhndvTPtKwZd74yd07dO0vN8mzrBsEb6SdmBMigAACCCCAAAIIIIAAAggggAACCCCAQJoECNxIEySnQQABBBBAAAEEhoeG9PDdd-nHX_2yVv35IcVjqRe63ebKyjKdsbRGx831yecnbmOqd5Fnhveu6tKP7thuARxTK4-SrC-PruvWj-7arowUEHFlSZpOk1ezdPqzbTgAy_jhtV1sWTdm2M2Z-n5O5pXseZdt4_mOfn36hhfkgiwy0UKRmH5w-3atsjnzgvzpMxVjnw-_qfhxLAIIIIAAAggggAACCCCAAAIIIIAAAqkE-PQtlQ7bEEAAAQQQQACBCQrs2rZNv_rB9_S9az6nZ1etmuBRno5tr9R5J5SoqcIW7K28A23yAi6jQreVSLnu15sTpVImf6bUR7pZcmU9enoj6a1k4gIjXLYNFygRKE3diWxudWVbGk-xK6b3_oxb5Y0b_rRTHXuGMzYaR7pt35ButOuELZCHrBuTp6ZUyuTtOBIBBBBAAAEEEEAAAQQQQAABBBBAAIHxBALj7cB2BBBAAAEEEEAAgeQCOzs69PCdd-ieP_5Om59fr1hsYlkeYrZovbC9UW9fOUOntNv549E0L4sn73OhbvECnn73yF49ZtkVQhnK4DBq9-L2Aa3b2qczj6-XxsmsMnrMuP_GQpZt4yx59cdYpgtLHZIjzZUz0fy3Kr77QQsuGrRfEs9MuXcuG8ZP7twx5fOMd4JwOG6BGzv03tfM1uLZFfZSS28AynjXZzsCCCCAAAIIIIAAAggggAACCCCAAAIIIDCeAIEb4wmxHQEEEEAAAQSKXiBuX9uPRCKKRaMKhYbV39OjrS--qEfvvUdrHnlIe3buUjQSmnAliagFbTQ2VutNZ9XpvGVSid-CNuw52uQFXCiBC4a5_Ym96s9QiZSDe9fdH9H-7rBiFsTgS0fIjbsBSuvlzX6tZduoPPhSOfGzVzVPmnWR4pt_IflKptwnn5VJ2WhlUrbvz1y2jdFOujCN3V0h3blqnxa3VYw-zb8IIIAAAggggAACCCCAAAIIIIAAAggggEDOCBC4kTNTQUcQQAABBBBAIFcEIuGIdu_Yps0bnteeHTvU07lffb096unq0r5du7Rt0yb1dndNqrsuuKCsvESvObVOf3FKUDVllqGDoI1JWR58kBf0tHX7oNZt6Vc4CxkVSoI-lZT40pR7wo3EwguaTpOaX5FT2TZeMnY1Rua-Xtp5tzRs975vihlB7HT7esIW7OTCKjLfInZPPPxMlz5gWTdoCCCAAAIIIIAAAggggAACCCCAAAIIIIBArgkQuJFrM0J_EEAAAQQQQGDaBNwi8ovPPas7fv2_euL--yyTxk5bWLZsGAetLY_8fNATR9FbV1GjsrJcl53TrPdcUKlZdZFE0MbkznYUFy6GXS2Dw_b9oURmhWi6SpekcKutDKi5tkTewTdHiv1Tbkpk22iUt-Ct8tKQzSLltaaw0aucq_isldImy7qRyDIy-ZIpcZujOTPK5PdP_hxHMxR3T6ze2KuoBXBk65pH0z_2RQABBBBAAAEEEEAAAQQQQAABBBBAAIHiFiBwo7jnn9EjgAACCCCAwAGBsJVCefRPd-mX__NdbVz3nC3wujQY6QupcKerckEb5zbrvSsrNKeeoI203ny2_r-3N6zegcghgTZpvcZBJ1s-p0oLZlfIs4CAKd8lFhzkzX2DvMo5doXsBDIcNJSJ_2hZN7w5lyq--8_SQMeUMoO4eJfWxlLNskePlZ3JdHPX298T0T67R2bWlygLsT2ZHlLWz-_z-bJ-TS6IAAIIIIAAAggggAACCCCAAAIIIIBAsQjw6VuxzDTjRAABBBBAAIGkAtFo1DJs3KtfWdDGhmeesaANK18y9eX4l67nyjQ0NVbrXa-drQ9eVKk5dSPlUaa84P_SFfhBFlQwMBxRFqqkqNTKpPz1ha2qKPNPPUgkFpJqFsubdYGVH8n9mGqvsk1qv8yCNqb-Z0TQsm287xI7X9ZaXO61mNPBMVmzOPoLxVydJxoCCCCAAAIIIIAAAggggAACCCCAAAIIZERg6p-4ZqRbnBQBBBBAAAEEEMiewIann9Ktv_i5nn_mabto-sIp3Lf847bAfdKyFv3fv5qjD6wMqrV2pPRK-q6SPadcv1LA78tKvooPvG623nhWs_xTnURXIiVYK6_9LVLZDOPN4WwbB02-b_Zr5M04w8r8TDFThpW3ecfKWTrr2LqDzs6PCCCAAAIIIIAAAggggAACCCCAAAIIIIBA8QkQuFF8c86IEUAAAQQQQOAggaHBQa155GE9s-rJg56d2o-uDEM05qmmrkqXr5ynT79jpl57QkxVQSvjkY2UEFPrfn4ebeZBCwSwxBsZba87bYY-fnm7ysvSkB3DBW60nC3NPGdKZUcyOuCxTu4LSguvNPAqi0xy2Wkm12L2WmhuKtMX3r_UypeUTu4kEz3K7ovSgE-1lQHLkjLViJuJXpT9EEAAAQQQQAABBBBAAAEEEEAAAQQQQACBiQkQuDExJ_ZCAAEEEEAAgQIV2LLheT27-kkN9PdNeYTeLEU-AABAAElEQVRuPXg4Eld5RbnOP322PvPudv37ZZU6dtaQfFZmwK3T0zIkYPhNNSWqKg9kLHjjVSc06NqrlqmtudzmcoqL_3HLVlHVLm_BFfL8GQ5ayAC5V7tMarPyLombevIWsXBMZx5fr2s-sEQzaksy0NORU_osomfx7ApVlFp5m4xdpbBP7PPxp2NhzzCjQwABBBBAAAEEEEAAAQQQQAABBBCYToE0fFVwOrvPtRFAAAEEEEAAgakJ7OzYqp1bO6xIhUvVcHRLuqNf3HdHxeOeWlsadNYJdbp4RZlOaZcaKsKJDBuxySclmNrgiuloy94wt7lUs5tKtXXPkCJpzmzyVxfM0qffuUhzZ1rQxlTP7YIdSurkW_oBqWKmzVKG04Rk6D7wFr5D8Z6NUudqG8Lk_6xwwRtXXtxm81euj1z_nJ7Y0JP2Hgf8nk5eVCMXezD6uk37RTghAggggAACCCCAAAIIIIAAAggggAACCCAwSYHJf8I6yQtyGAIIIIAAAgggkCsC0UhEvd3dGhwYP9tG1DIsRCwAwyVacN88LykJqLxkpPRC-5wGnXdCrV61VJpdH1V5MGwL2Z7iln3j6EJBckUm__rhgilarexGuwVWPLq-J22BG2WWoeEf3jRPH__LdtXWBBWzOZ1as-Mt24bX_map6WS7T_xTO900Hu1Z8ImWvE_xx_9NivQn7vnJdicWiunsFQ36-X-cqH_81jr95qE9Vm5oqtYv96Y06NPFpzbJs3I6Uw68efm0RfVTzLIG0RBAAAEEEEAAAQQQQAABBBBAAAEEEEAgMwIEbmTGlbMigAACCCCAQB4IuIXISMSyYoyzHhkM-jW7sUJt9X4rxSFbwK9Ua3Odls0p00ltETVXDlowR8hGbIvCLlTDzkfIRnZvAJdFwWfvbC89s0W3PbZXQxYIMNW2bHal_tECNq44f5aV2PDSELRhPXIlUhpPkdd2sXU4ONUuTvvxXv0x0sIrFF_3LeuLK6Ux-ewhLvPGgtYK3fiJE3Tdr7fqa7_Zoo07B6c8Rpdt4_wTG3Rce6V7YdIQQAABBBBAAAEEEEAAAQQQQAABBBBAAIGcEyBwI-emhA4hgAACCCCAQLYEXHkUn89lPEi9mltZWaG3nd-qd5wbVEWJZUsIuMVpS78R7bdv78cSgR8jX0ZPfZ5sjatYrxMPx_WaVzTqxAU1unvNfoUnmR2jxOb3PVa64-8ua9eSuRXyoha0kY7sDy5CqLJd3vKrpNKGgpkmb-5fKN75lLTrvgPBKFMI3jDnYMCnj711vgXhzNC1v9ys7_yhQ-EplKdxmXH-auUs1dWVymX2oCGAAAIIIIAAAggggAACCCCAAAIIIIAAArkm4L4WR0MAAQQQQAABBIpSwB8MqKS01KpVpH5LFAqFFRnqlz9uWTVsATk2FBt5WIaA8bJ1FCXsNA3ahc1UVgT00TfPU3Nt6aR6cVx7tb77D8fq8x9cpuXzKhNBG-MF9kzoQjHLtBGskbfk_fKq5tkhkw9umND1srmT315DSz8o1SyxbDM2zik2lz3FZd9YPLdKX_rQMv3hM6fogpMbLaDj6M1cto2LrETKa09vsnIuBFZNcWo4HAEEEEAAAQQQQAABBBBAAAEEEEAAAQQyJJB6lSJDF-W0CCCAAAIIIIBALgh4nqdgSYlKgqkX-YcGhzQwGLKyKmlZws-FoRdsH-IWWHPBKU36j7cvUGPNxJPLzZlRpn-8vF23_NcKXbmyTZWlvgOlUdKx2G9ZHjy_vMXvktf8isTPhTYBXmWbZRL5kGUSqbcXSXqyWrjgDRessdLm85ZPnaSvfXi5zlxeKxeMMZHm4rFOW1qrz75niSrK_OnJmjKRC7MPAggggAACCCCAAAIIIIAAAggggAACCCBwlAIT_zT7KE_M7ggggAACCCCAQD4IlJZXqLSiPGVXXQaArmGf-iJBVVqJlPg4pVVSnoyNGRVwc-X3WamT185WadDTp366UZt3DihZpZPFsyv1l-c06y2vatVxC6oUiFtZFDtJOsI1Xh6oFeVZ-DZ5sy-yoI3CffvtNayQln1I8Weus-wWAzbWqceIu_mMR2IqsfIp7790nq6wkkV3r9qvH92xQ398bK96B8fO8BG04I4rV7bqk29fpPa28gNBOC_PCD8hgAACCCCAAAIIIIAAAggggAACCCCAAAK5JFC4nxznkjJ9QQABBBBAAIGcFSivqFCZBW-kyqXhFvF7hwLqCwXU4kVT7Zqz4yymjsUtSiNowRvvuqhNpy6t0c_u2a1bHt6tHftDiaCMaiunssKCNC48dYYuWtGguS3l8pdYwEbYSnSkNWTDRR3ELGDjtfLmv1Xypc7sUghz5M1aKYX7FH_2azYcl3lj6sEbzsW9BuOhqKrKA3rDOTN13on12rxrSHev2a_713bquS396hmOqsHm9pQltXrLuS165bH1idI5MQv8oCGAAAIIIIAAAggggAACCCCAAAIIIIAAArksQOBGLs8OfUMAAQQQQACBjAskAjcqKlNex-Vf6AtZ8MZwyt3YmEMCMQvesEo4Oq69RsfNq9G_XTlfvf2RROaN6sqgyi0bR2IH63Pc0jrEwi40IJ3NzhezbBCzLpS35J1SIPU9ls4rT--5LLvI3EsV79sibflfi9soSWt33LzKAjiqLYDjuAXVOm5-tT586Vybw5cv4-bdlUFy0R4EbbzsMtWffL70BOFMtR8cjwACCCCAAAIIIIAAAggggAACCCCAQCEKELhRiLPKmBBAAAEEEEBgwgIVlVWqqqm2_W2hN0m2Bbco3DsYU98Q39yfMGwO7Jgos3FgRT_o96mpdiSIwK39u8chq_3p7q-7buv58i3_G6mkPt1nz-3zWYkU37IP2KvJ8pds-a0Fb6T_T47E_EXdJB7ZDp73I7fyDAIIIIAAAggggAACCCCAAAIIIIAAAgggkHsCfG0q9-aEHiGAAAIIIIBAFgXKqypVUVWl8b5N3tcXVt-A1dKg5a3ASwEbmRyBlUZR3MrptJwt75irii9oY9TWXybPgjdc9g1FXaqasYMsRnfnXwQQQAABBBBAAAEEEEAAAQQQQAABBBBAoJgFCNwo5tln7AgggAACCCCg8spKVVVXjZRWSOExMDik_oHBkcQcKfZjUxELJFI9xOS1XWJBG38rr6SxiDFs6P4KeUvfZ-ViLrDgDYKe8v1miMXIOJTvc0j_EUAAAQQQQAABBBBAAAEEEEAAAQRyV4DAjdydG3qGAAIIIIAAAlkQKK9wGTdq5A8mL-fgiqi4wI1ey7oRi_oSRVWy0DUukVcCtqjtefIWvE3e8qvklTblVe8z1tlApXzHfVTe_LdY0g238E_mjYxZZ_jE42UlyvDlOT0CCCCAAAIIIIAAAggggAACCCCAAAIFLUDgRkFPL4NDAAEEEEAAgfEEPFtsr6qpUUVFVYpdPUWs-kX3UKl6oxbgwTuoFFZFuCkeGckusfjd8ha9QwpUFCFCiiFb8Ia31MqmOBvXXCkZWt4JkHEj76aMDiOAAAIIIIAAAggggAACCCCAAAII5JEAyw55NFl0FQEEEEAAAQTSL-ACNyqrqxOPpGe3lBvhmE_7Bz31Dlvghh1DQyAhEAtJZa3yjv9HyypxuQVwlAEzloAvOBK4sehdFthSKcUs2IWWVwJk3Mir6aKzCCCAAAIIIIAAAggggAACCCCAAAJ5JpA8J3ieDYTuIoAAAggggAACkxFwi5GVViqlsqbaDncBGUeWcnDPhmNxdfbF1Tds22smcyWOKSwBuw9iUXkzzpIWv0te7SIbHgE9qefYk2_hlYrXmNX67yje87xlrylJfQhbc0aAjBs5MxV0BAEEEEAAAQQQQAABBBBAAAEEEECgAAUI3CjASWVICCCAAAIIIHB0Aq5USmVVqlIpUjQaU1dPSP0DlmGBVsQCLmDDskUEquQteKO8eZdJJXVF7HH0Q_dmnCaVtyj-9JelzjUjJ_D8R38ijsiqABk3ssrNxRBAAAEEEEAAAQQQQAABBBBAAAEEikyAUilFNuEMFwEEEEAAAQSOFBi3VIodEglH1NPbp77BARIrHElYHM_EYyNBGzWLrTTKP1jpj3cStDHZma-aJ--UT0ntVl7GgmDkSs7QEEAAAQQQQAABBBBAAAEEEEAAAQQQQACBIhUg40aRTjzDRgABBBBAAIGXBSoqq1Re5UqlWDaFFK2v32XcsL1iPiuKER1n7xQnYlOeCYyURVFJjTwLNPBmXWgZI5psDJRGmcpEei5rybIPSpaBI7buO1LPc0bqMm_gOhXXTB1LqZRMyXJeBBBAAAEEEEAAAQQQQAABBBBAAAEE7PttICCAAAIIIIAAAsUuECwJqrq2RqVl5RoeGhyTw2dryUNRv3oGg4rE_Ap60fHiPMY8D0_mk8CBsii-Mqn5VHnz3yqv_niLKyBpXVpnsfEky77xX9Lm_1V86--kUNdIAAfOaWWe6skolTJVQY5HAAEEEEAAAQQQQAABBBBAAAEEEEAguQCBG8lt2IIAAggggAACRSIQCJaotq5BVbXVFrgxZKM-MvOGz_MscEPqtIwbw2HJDhlrtyIRK4JhutIdXlCqXS5v3qXyWl8t-ex3WkYEvNIGacl7LUDmTMU3_Ejav9rqE1kQld-90GgIIIAAAggggAACCCCAAAIIIIAAAggggEBhCxC4Udjzy-gQQAABBBBAYAICwRIL3GhsVGV1jfbt2jPmERa3ocFQTF19UQ1FYqoqdeUcjgzwGPNgnswTAZvPuEXnWFI6b8bpUutK-_cVUkmtPUf5jmxMold3TCL7Rnzvk9LW3yq--yG7rM1LIvsGc5CNOeAaCCCAAAIIIIAAAggggAACCCCAAAIIIJB9AQI3sm_OFRFAAAEEEEAgxwQCwaBqLONGRWVlYnk-WThGaCiszp5-DQ_7pUrKZeTYNE6yOzEpZsEans2pv0KqP1Ze24XyrHwHARuTJJ3qYZ4LnLGAmfpjpL1PKL7lt1L3M5aBw9LduFeoz-aKQJqpKnM8AggggAACCCCAAAIIIIAAAggggAACCOSQAIEbOTQZdAUBBBBAAAEEpkfAs3QaVTXVqqiqHlkPThK5EQ6F1d83pKHhKksCwLf_p2e20nFVl1kjIkUtYKOkRqqaaUECx8ubZQEbtYvtHuAtcjqUp3yOgAVSzTxHXstZiu9bpfjW30k966WB7TZ_Noc-m6dEJo4pX2mCJxj9DwOv_QmCsRsCCCCAAAIIIIAAAggggAACCCCAAAIITFCAT6UnCMVuCCCAAAIIIFDYAhUVFSqzjBtxtyCcpPksyUbXcKn2D5VrQTxs3_mPUywlidXRP53cfWrZFUbPa_-6uXWlUPwWeFNnmTUaTrCAjePk1SwZCeAgi8PRT1s2jrBsKF7TKYmH-jsU73pmpIRK52ppuGskeOOlAI50BFW4-8QNzLKxJP574H5xmT5KRkYbD408765ZRCVcYjHzoCGAAAIIIIAAAggggAACCCCAAAIIIIBARgQI3MgIKydFAAEEEEAAgXwTKLXAjSrLuOEPBBSNWDaGMZrPMnN0WrWGPb1xRW0NM5CONeIxrlM8T42WKbG3pP6gLYK7h0N1ZWjc4rlbOLe5cMEWL_08ung8Fn5itf3AYrqV03AlNVz2DFcGpaxJqlkozwVs1C2XSu330jq7zljnKZ4ZyLuRVs6W5x4tZ0tDuy2I41nF9z5qEVWWiSPSY7EW4ZGHu2cSc2vzm7inRkc6Ot8H7pWXAjPsd3ev-Owe9FuARrBWql5k98oy-3eu_V5vt5E9727LaL_Uv03at9oygTxmwSOddnK7L919VsDN5yLXaAgggAACCCCAAAIIIIAAAggggAACCCCQEQECNzLCykkRQAABBBBAIN8EysrKVFNfr7LyMvX32sLsGLk03Ppvd19E-3rCilqpFAI3pjDLMctaELDMFzXt8izrhWptgbyy1TJfNIwsoMsCNoa7bXF-r_272_61xfHhPYq7RfKIRc_Ehg5c3C3Ejy7O28Kyv1Reab0FarRI5fYoa5YqWuW5n92iPK0wBAIVVuLG7h33mH2JxfcMS30v2gv0eft3k-KD20fuE3evuG2WIWckCMgF_rhMGXbPuGAhX5n9aw-7Z7yq-Rak4R4W4FPZduB-sf0Oa4lnLABIbRda2ZYd0pbfKr799pEADle-hYYAAggggAACCCCAAAIIIIAAAggggAACCBylAJ8sHiUYuyOAAAIIIIBAYQqUV1aptqFBJSWl6rf_JWs9FtTR1VWmWMQWjkv4Bnoyp-TP28J53Cdv1qulWRdb0MbxFsBRPvbuLiuGZck4uCUWzV32jagL3HBZEw4swrudXMYDgjOcRJE1z5JlWPBF3TEjDxt94j5x90jYXsvRPovZcIEb7mGZOBKZI-y-8VmQT6DSsmnYa9kFER11s-tWzJKWvl9e8-mKPXWtBXJ02MUL808sSqUc9Q3CAQgggAACCCCAAAIIIIAAAggggAACCExYoDA_VZzw8NkRAQQQQAABBBAYEQiWlKiyslrB0tKUJENDw9rXG9FAJKDyUheEkHJ3Nh4i4BbNy-XNv1zevEttwdyVKplE82zR3WVcoCGQSsBl0nAPNWa2II67H-tPkHfs3ym-9nMj2WHccwXWKJVSYBPKcBBAAAEEEEAAAQQQQAABBBBAAAEEckqg8D5RzCleOoMAAggggAAC-SRQXVej6tracbu8tz-o_UOpAzzGPUnR7eCCNirlLf2gBW68dfJBG0XnxoDzQsACNbyGE-UteMeBjBtEdOXFvNFJBBBAAAEEEEAAAQQQQAABBBBAAAEEckSAwI0cmQi6gQACCCCAAALTL1BT3yj3SJVGIx6Pa1-_PXot20aiHsP09zv3e2BWCspb8k55bRdYFgSCXnJ_zujhUQtYiRRv1vnyWs-z8iyhoz481w-gVEquzxD9QwABBBBAAAEEEEAAAQQQQAABBBDIZwECN_J59ug7AggggAACCKRVoKa2TnUN9fJSlDlw36Pf1zWkzr7CW5hNK-bBJ4tb4EbjSfJmnnegdMXBG_kZgQIS8FsJHwveUNAy98Qty0wBNUqlFNBkMhQEEEAAAQQQQAABBBBAAAEEEEAAgZwTIHAj56aEDiGAAAIIIIDAdAnUWNBGbUODfH5_yi509_Sps6tPMZJupHQa2WihLsEaefPeLJXUTGB_dkEgjwVcyZTaZVJNuwVuuEwzNAQQQAABBBBAAAEEEEAAAQQQQAABBBBAYHwBAjfGN2IPBBBAAAEEECgSgfKKStU3zlBZWVnSEXuep-FQXDu7A-qJ2H4-6qUkxUpsiMprPkte3RIrLRNIvStbESgEAX-5vKZT7b8NJTYal6OHhgACCCCAAAIIIIAAAggggAACCCCAAAIIpBYgcCO1D1sRQAABBBBAoIgEXCmAGsu4UV1fn3TULkwjFPW0q8-vzkF7K0XcRlKrxKK1F5RazpEC5Sn2YxMCBSTgs4w9dScWXFmgmEsxREMAAQQQQAABBBBAAAEEEEAAAQQQQACBjAgQuJERVk6KAAIIIIAAAvko4LJp1Dc2qaGp0bqfPCIjHIlpV-eQOvvCqXbLR4L09jkelWqPlVc515xSl59J74U5GwLTKWB_YrlSKYHCKg3kAttoCCCAAAIIIIAAAggggAACCCCAAAIIIJAZAT59y4wrZ0UAAQQQQACBPBVomDEjEbyRqvvhcET79vaqq7sv1W5si1mZlPrjpNI6s0geCAMUAoUm4LkyKVVtlnSGLBWFNreMBwEEEEAAAQQQQAABBBBAAAEEEEAAgUwIELiRCVXOiQACCCCAAAJ5K1BTW6cqeyTKfCQZhQtB6B2MqLvfp1jML0vUQTtCwBas_WW2eG3ZNnyBI7byBAIFLeDZn1kVrQU9RAaHAAIIIIAAAggggAACCCCAAAIIIIAAAukTIHAjfZacCQEEEEAAAQQKQCBQWmKlUppVWVObdDQ-C9ToD_u1tz-owYi9nSJwY2yrYJVU0mA-vOUcG4hnC1bA7nmvzAVuxAtmiLEY2UMKZjIZCAIIIIAAAggggAACCCCAAAIIIIBAzgnwKXrOTQkdQgABBBBAAIHpFCgtLdOMWa2qb7CAgyQRGS4OYWAoqp37htVn_5JyY4wZcyUi_JXySuvNxz_GDjyFQCELWDRX1RyL2yicwA2fjz8dC_mOZWwIIIAAAggggAACCCCAAAIIIIAAAtMrwKdv0-vP1RFAAAEEEEAgxwSCJZZxY0azquvqkoRtjIRzDA4Oa8_-Hg0NhnJsBDnSHbdgHSi3jBs11iFSkuTIrNCNbAm4-kkByzhDQwABBBBAAAEEEEAAAQQQQAABBBBAAAEEJiBAwfEJILELAggggAACCBSPgGcLrtW1taqprRuJN0jyhfm4lQ3YP-CzcimlmhuNJEITkuxaPHgHj9QcvaAFbfjItnEwy9H-PDAwoB3bd2jb9m3as3O39nftVyiU5mAhC7Lx-_2qr29Q04wZmmUZZ2bPmaPq6uqj7S77HyTg2b0fL6BsM5RKOWhy-REBBBBAAAEEEEAAAQQQQAABBBBAAIE0CxC4kWZQTocAAggggAAC-S9QVVNjGTdq5bOF16gFZYzVXNWAPT1-bev2dGLMU8BH2MYhTq6eTBllUg4xOYpfuru79etf3azbb79Vzz23Trt27FDMAixcYJF7pL3ZueP2cNdosDJBy485RmeccYbeduUVmtXWlvbLFf4JbY7ca8AXtHIp7r8hGZizLCNSKiXL4FwOAQQQQAABBBBAAAEEEEAAAQQQQKCoBAjcKKrpZrAIIIAAAgggMBGBiqoqNTS1qKyiTP29_XbIkUEZPluH7ewZ1q59g4rGAha4MZEzF9M-btG6xAac_wvW2Z61e_70J339a1_X6ieeUG9fn1z5npLS7Fn29_frwfvv158ffli33nqrPvL3H9FrX__6bDMUwPUOvAaSBH8VwAAZAgIIIIAAAggggAACCCCAAAIIIIAAAgikSYAlhjRBchoEEEAAAQQQKByByuoa1TfPUGl5ecpBdXX3as--Xg2PnZQj5bGFvdEFuljAhss2QODGhKc6Go3ql7_4pf7pYx_Tww88oFAkovLyMgWsjEk2HV1mhTK79wOBgJ579ll97KP_oC9_6csaGhqa8FjY0U2ZC9xwGTeODPzCBwEEEEAAAQQQQAABBBBAAAEEEEAAAQQQOFiAwI2DNfgZAQQQQAABBBAwAb8tlNdauYjqWiv1MUa2jVGkWCymbV1B7ewvy-a6-ujlc_tfV87DZdzIRFmP3B75pHt304036ZP__u_au3efZdkIypewm76MJa4kSzAYVCgU0hc__3l98QvXTHpsRXmgi9eIRwvmNeD-e0dDAAEEEEAAAQQQQAABBBBAAAEEEEAAgcwIELiRGVfOigACCCCAAAJ5LlDf2CT3SNXcuuyunph2dfON-iOcEoEbZNw4wiXJE888_Yy-df316h8ctIANt9P0BWwc3kUXwOGCSH7yox_p4YceOnwzvycVsFQ80eGkW_Ntg8vEQkMAAQQQQAABBBBAAAEEEEAAAQQQQACBzAjw6VtmXDkrAggggAACCOS5QH1TkxpbmuXzuTIVyduu_X3abeVSaIcLWOCBl9ru8COK9feBgQFd-8VrtHXLlgMJSnInaGN0TvxWNqW3p0dfuPrz2rFjx-jT_JtUwIK54pahIuYCN3JvPpN2mw0IIIAAAggggAACCCCAAAIIIIAAAgggMC0CBG5MCzsXRQABBBBAAIFcF6hvaFTjjBYFgoGUXe3tGdTOrogGo0GqghwiZQvXMcs4kKLUzCG7F_Ev99z9Jz30oGWysKwWubzEX1Jaqj8__LB-9ctfFvFsTXzo8WhoJHhj4oewJwIIIIAAAggggAACCCCAAAIIIIAAAggUqQCBG0U68QwbAQQQQAABBFILlFZUaMbMVlXX1SXd0VUDCUV92rgvqO29VhZkpMZF0v2LasNotoE4ZWRSzXt3V5d-c_PN6uu1rC2JqI1cDt2QSkpK9JMf_kh79-xJNSy2ufs-OlBQDrGYZRChIYAAAggggAACCCCAAAIIIIAAAggggEBGBAjcyAgrJ0UAAQQQQACBfBfwLCqjyQI3ZsycaUMZezHdPRsKx7Rtd7_2dA9a4Ea-jzpd_TcZF68Rs4wDZNxIibpq1Srde9998vv9Se6ylIdnfaN7XezatUu_-MUvsn7tvLtgxP6bUEDN5-M_cAU0nQwFAQQQQAABBBBAAAEEEEAAAQQQQCDHBPj0LccmhO4ggAACCCCAQO4IzJjZosYWF7iRvEUiEe3Z16fOriHFo8lCPJIfX7hb7Nv5sbANj4wbyeY4Go3qd7-9RaHh4bzItjE6jnA4rDtuvU1DQ0OjT_HvEQJ234c67dmxg76O2J0nEEAAAQQQmKJAIBBQJO6f4lk4HAEEEEAAAQQQeFkgEgskMm--_Aw_IYAAAghkUoDAjUzqcm4EEEAAAQQQyGuB2oYGNbe2KmjlIZI1v5VH6R32aXt3iYYirlxKsj2L7XlbuI7Ywj6lUpJO_MDAgB595JFEaEs-Le-77CAdHR3atHFj0rEV_QZXKmhor8Vt5NPMFv2sAYAAAgjktcDChQv13DYCN_J6Euk8AggggAACOSbwdIcn9x6DhgACCCCQHQGWFrLjzFUQQAABBBBAIA8FSsrK1dw2W_VNjdb7sRdg3bps31BM2_eGLIAjwkLt6Dy7heuoKxVBxo1RksP_fX798-rp6TlgNPb9dfgxufC7K5eyZ88ebdmyJRe6k6N9iCs-tC9H-za5bsVi9pqmIYAAAgjkrMApp5yiPb1B_eGxwirVlbPgdAwBBBBAAIECF_jdI4N6cl2X3HsMGgIIIIBAdgQC2bkMV0EAAQQQQAABBPJPoKS0VDNnzVbDjBnavX3HmANwgRsD_YPatbdPPf0laq7MnwX4MQeUrict00Y83CvPBXDQxhR4au1aDbsyKXnWfD6f-vv6tfFFMm4knTp334cs40aSgK-kx-XwBjfvNAQQQACB3BUosQxxV1_zFb3tbW_TCzs9vWKxTzNq-G937s4YPUMAAQQQQCA3Bfb0xLR2c1y_fiism266iVIpuTlN9AoBBApUgMCNAp1YhoUAAggggAACUxdwC5X1zTNU39iU8mSeZZXo6PRpy_4SzW-Kyq8YeSZc_ErUghJioZR2xbxxw4YNCoXDB8rJ5FfAj8_v0-ZNmxQKhfgQZ6ybOB6VBl3Gjfya17GGwnMIIIAAAvkjMGvWLP3hD3_Qt7_1Df3ssXXq7OzKn87TUwQQyKiAy4O4e_euMa_R3NzCu9YxZXgSgeIUqK-v07wFS3XDTe9XTU1NcSIwagQQQGCaBAjcmCZ4LosAAggggAAC-SFQVV2j2qYmBe1bjOHQ2NkRfLY2u6MrrM27Q4os8OTnHZZNrqHEzCvcL5W5rBt84_PwO767q0uxaDQR5JNvy_uuXEp3T3ciY4j7hi_tUIF4eMACl-zez7eJPXQY_IYAAgggkIcClZWV-vuPfiwPe06XEUAgkwIu09-FF1445iW-9d0fqdSyTdIQQAABBBBAAAEEpleAT9Cn15-rI4AAAggggECOC1TV1Kpl5ixV2IfgyVZhXbmUzs5ebdvVowESTByYUUNxGTcifQcySuT4RE9D98KRiAW3uO--5V9zgRuRcESxGKVwjpw9Mxmw0kpxm98Casx1AU0mQ0EAAQQQQACBohNIVaIx1baig2LACCCAAAIIIIDANAoQuDGN-FwaAQQQQAABBHJfoLyiQjMs7XSNpYpM1VzmhE37AuroLksW35Hq8MLb5qJZLHAj7jJuxFncH2uCgwFLzeLSteRhi8fjCgQD8lvJFNphAu5-H-iw-9_K4BRQc6WjaAgggAACCCCAAAL5KZAqOCPVtvwcLb1GAAEEEEAAAQTyU4BP3_Jz3ug1AggggAACCGRRoKllpppaWu2KybMjuC1b9wxp674hC9zIz8X4tJNGzCLSm9It7dfMoxNWVldZ3Eae3isWuFFhQU1-6gIdecclAje2238uXOBGns7vkaPiGQQQQAABBBBAAIE8FgiFkqeGTLUtj4dM1xFAAAEEEEAAgbwTIHAj76aMDiOAAAIIIIBAtgVaZrWpdfYc-QPBlJfet69Hu_YOKBzzWK6Vvc2MWeDGcCcZN5LcNbW1tfL5_Xl5r8QscKO6ukYlJSVJRlfMT1sY14AFbsQKq1RKMc8oY0cAAQQQQAABBPJdoLfXBdSP3VJtG_sInkUAAQQQQAABBBDIhACBG5lQ5ZwIIIAAAgggUFACdU1Namufp4qqqqTjct-rH7AvMa3bFdC23lLJzzftExEJg7sPZB5ISle0G2a3tSngyqXkYdaNqJUGmtk60zJu-It2_pIOPBpSfHifbU6eoSfpsWxAAAEEEEAAAQQQQCADAnv27El61lTbkh7EBgQQQAABBBBAAIG0CxC4kXZSTogAAggggAAChSbg8_nUPHuuWlpduZSxm1t7Hw5F9cL2AW3bN0iFBMfk2VtNF7gRNg8WsY-4cRYsWKjSUgvyybMWt2wb5eXlarNMNLTDBSxYI9xtjz7bQPDW4Tr8jgACCCCAAAIIIDA9Art3299lSVqqbUkO4WkEEEAAAQQQQACBDAgQuJEBVE6JAAIIIIAAAoUn0DJrlgVvzLaBJV-MjcVi2rWn1x4RRaO-fEykkOaJ8yk-tMsWsfvtvGQfOBx3waKFKisvk8VB5JWPu8_r6-vVMnPm4UPid7vP40P77Z7vGQlcQgQBBBBAAAEEEEAAgRwQSJVVI9W2HOg6XUAAAQQQQAABBIpGgMCNoplqBooAAggggAACUxGot3IpM9tmq6S0JOlp_PbOqmvI03qLVegasl98yYM8kp6kkDYkMm7slKKWfWAkOqGQRjflsTQ1NmrJkqVyGV3yqbkyKS5oY6EFntAOE3D3-ZB9mzHUReDGYTT8igACCCCAAAIIIDB9Art22R-pSVqqbUkO4WkEEEAAAQQQQACBDAjk16fEGQDglAgggAACCCCAwEQEyisqNXv-AjVbuRRXFmWs5p7v6x1Sx64edfaGCFZw2UkivYoPWwaCeGwssqw850p7bN-2zbKgRLNyvYlexB8I6BWnvSJxn-RTPhLPbvR58-Ylsm5MdKxZ2c_mubu7e3rn2d3ng9stWMle_ymy82TFI80XcZlWaAgggAACCCCAAAL5KfD8888n7XiqbUkPYgMCCCCAAAIIIIBA2gUI3Eg7KSdEAAEEEEAAgUIUCJaUqG1eu2a0zhpneDF17Pe0dX-JojGvwJZuxxn6mJtdNEuHBSdExtya6Sd7unv03W9_W-97z3v10EMPKRwOZ_qSR3X-FSefrNKyMvNxh-VH-EaJvRZOP-OMoxpnNnbu7OzUpz_1KV3z-S9ox44d2bjkkdeIDtr9vtViNvxHbsvzZ_ItM0yec9N9BBBAAAEEEEAgbQKDg4Pq6LC_yZI0t83tQ0MAAQQQQAABBBCYXgECN6bXn6sjgAACCCCAQB4JNLa0qKWtTS5TQpKkG3LlUrbtDWldx6BCYVuIT7ZjHo17Sl21cinxng1SbHoCJq7_2tf0-auv1trVa_T9735Pvb29UxpOug9esmSJTrbgDZcVJB_CNlw_q2tq9NrXvS7dFFM6XyQS0b333KOf_-xn-vIXv6hPffKTln3DypVktdkMhnoU791kZZIKL3Ajq5RcDAEEEEAAAQQQQCBtAuvXr1eq7Glum9uHhgACCCCAAAIIIDC9AgRuTK8_V0cAAQQQQACBPBKoqavXLMu6UVVTlzIgY__-br24vV-dgyzeJqa3b7MFbrjSEdlte_fu1T333qNoJKZgSVB_towbd9x2u4aGhrLbkRRXa2xs1NnnnJNij9za5MrNnHHmGWqZ2ZJTHduzZ4--_z_ftxIlMZWWl-uhBx7Uc88-l-U-jgRuaMC-zWgBS4XWUn3YX2hjZTwIIIAAAggggEAhCaxbt27c4Uxkn3FPwg4IIIAAAggggAACUxIovE8Up8TBwQgggAACCCCAQHIBV9KiZVab6hsak-_ktliWjRd2edqwh8CNBEa4U_HBPVYJJJbaLc1bu7u6FAmF5dl8-Hyeurq79bMbb9Lu3bsTGS7SfLlJnc6zzp1y6ilqbm62PrlT5HbeDdff1196qZnmTiqZUCikm3_1v1r1xJMKWICOa_39_eru6k78nLX_c1lTXNBGdNgumTs-6Ro_pVLSJcl5EEAAAQQQQACB7Ao8-uij415wIvuMexJ2QAABBBBAAAEEEJiSAIEbU-LjYAQQQAABBBAoNoHWOXM1q7095cK1W7LduK1T67f0aDiWvKxK0di5Mim9Gy0mIbvlUsot84LP_3LwTElJqR5_7FH97re_1cDAQM7wn3DiiTrJyqW4-yaXwzaGh4f1yrPP1llnnZUzdi4LxOrVq_X9733Xkly8_KeN3-bdPbLa4lHFu-3bjAWYbSOrjlwMAQQQQAABBBBAIG0Cg4ODeuKJJ8Y9n9vH7UtDAAEEEEAAAQQQmD6Blz_dnL4-cGUEEEAAAQQQQCBvBGbOnqO5CxeqpLQsZZ8HhqJ6altcW7stA4C_8L59n3Lwh2y0sbsyKX0WuOECOLLYmmbMUEVFxUtXTCSJsEX1H33_B1ZG41m5sh-50ILBoP7iTW9SZWVlyoCg6exr3LJJuCwbb7rsTaqrs1JBOdJcZo1vXf8N7di-M5FVZbRb1dXVqq6pGf01O_-6-7vblWcp5td7dqi5CgIIIIAAAggggMDEBB555BGFw-P_Heb2cfvSEEAAAQQQQAABBKZPgMCN6bPnyggggAACCCCQhwKllsVh1rz5amxpSdp7FyAQCkf1wtZebd7VZ_vZonfSvYtgg8u00W8lJGKRrA62pKRE8-bNU8ACI0ab3-_Tjh079d3vfEednZ2jT0_7v-edf16iZIpLuWEFN6a9P4d3IBKJ6Ljjj9c55557-KZp-9316c477tB99_zppTl2cnHLwtHQ0KCmpnFKGqW15zZrw3Y_DW63uI2ifrWnVZWTIYAAAggggAACCExN4L777pvwCY5m3wmflB0RQAABBBBAAAEEJixA4MaEqdgRAQQQQAABBBAYEZi3aJHmLVyScn3Ws8X3nftD2mDruP0hCxzwFfNirmkM7bFolm4DzG5QwoqTVqjEAjcOvqorqXH7H2_TTTfcIJexIRdaWVmZ_s9H_t6CDZpkyS2y7pTKwGXbcP374FUfUnOKgKVU50j3NtenFzds0Je-eK2Gh0KHZNtw21pntapt9ux0Xzb5-eIxqetpKWLZZYo7TCu5EVsQQAABBBBAAAEEsirQ3d2te-65Z8LXdPu6Y2gIIIAAAggggAAC0yNA4Mb0uHNVBBBAAAEEEMhjgaaZMzXXgjfKrLRFsmaxAersC2tDx4D29lrGiaKO2zCM4f2KD-ywuI3slic55dRTVWZZUg7m91kQjUsF_OMf_khr16yRy9yQC80FmVz5V39lRnHFcih4IxQKa-UFF-j1r399LjAl-tDb25sI2tj04kb5g4FD-uUyrSxZulSlpaWHPJ_RX9x93b1-pCxQRi_EyRFAAAEEEEAAAQQQmJjALbfcouHh4SN2du-Xx3qv7PZ1x9AQQAABBBBAAAEEpkeAwI3pceeqCCCAAAIIIJDHAmXlFVq4bLlmz2u3rBsHhwQcOqioBQds2hPS1n1-K9_gHRI8cOiehf6bveUMd1kZiZ1ZL5fS1tam44471jIy2BwclHcjYIv9HR0d-t53vqt9eywbSA40n0X7vO3KK3TmK18pnwVvHJwlZLq6FwqFdMKJJ-ifP_Gv8vv909WNI677sxtvSpRJ8QcODtpwYp5qa2t11lmvPOKYjD5hZYDifRst6CY3goAyOlZOjgACCCCAAAIIIJDzAjErH3jzzTeP2c-VK1fq_PPPH3ObO8YdS0MAAQQQQAABBBDIvgCBG9k354oIIIAAAgggkOcCbgG7rb1drRa4kar0R8DWuV_YEdKTLw5pcNgWlZPHeOS5yHjdt4G7jAS9trAdc6Ukstdq6-r0ynPOscANe9trwRAHN_cts9tvu10_-P735TI45EJrbm7Wf37qU1psGSPilnZjOsM3XNBGa2urPvO5_9a8efNygSfRh2efeVbXf-1r9u3B0BHlitxLrMX6fPqZZ2axv3ZfuVJAg_vsNc6fV1mE51IIIIAAAggggAACSQRuvfVW7dq1a8ytb3nLW3T55ZePuc0d446lIYAAAggggAACCGRfgE8Ws2_OFRFAAAEEEECgAATqm2ZozoKFqqyuPWLx-ODhdXf16qnNw9rcHTz46eL72bOMF32bpJBl3shiLgkXsHHsscepoaHBruqW9Q8N3nDP_OTHP9Edt96moaEh-23626LFi3T1F6_R6aefrmg4okjUlZc5tN-Z7GXcAlycxeLFi3XNl67ViSeemMnLHdW5Ozs79bnPflZ79-yVy5pycHNCbr7POOMMlZeXHbwpsz_HYyNlgEL7XQ8yey3OjgACCCCAAAIIIIDAOAKDg4P69re_PeZe7r29e5_vHsne57tj3TloCCCAAAIIIIAAAtkV4JPF7HpzNQQQQAABBBAoEIGKqqpEqZSG5paUI3KVVJ7b2q_ntgxZytmR0IGUBxTqRs8W2V3gxpAtbttCdzbbkiVLtMge3hjlR3x-n7o6u_SVL39Z69etUzQRJJHN3o19reOPPz4RvPHGyy5TRUW5whbAkY3sG2Er7-MCIC665GJ99RvX62zLVpIrzc3NV6-7TnffdZeCJUcGQrkgnNKyMl1wwQVZ7rKJ9W22ckCWtYWMG1m253IIIIAAAggggAAChwv8-Mc_1t69ew9_OvH7wZk2Dv754J3dse4cNAQQQAABBBBAAIHsChC4kV1vroYAAggggAACBSQwZ_5Ctds3lTwXnZGs2aY9e_v0xMawtveX2xfyU-yb7BwF8byNO9JrWTc2W7mUSFZHVN9QrzNOP00u2GYkccWh2StcEMCLG17QZz_zGW3dssUqqhy6PaudPehic-bM0eeu-bx-8KMf6fK3vlVlpWWKWr1pF8Aw0sf09NPVsHbndIFFrzz7bH3jW9_S17_xDS1fvvyg3kz_j9-xb_59_7vfUyBwaKYN17NEURnjeMWpp-rY447Nbmcj_VL3OgvaKNbXdna5uRoCCCCAAAIIIIBAcoHNmzfrpptuGnOHRYsW6ZyDArPdz-65sZo7hzsXDQEEEEAAAQQQQCB7AgRuZM-aKyGAAAIIIIBAgQm0zp2rBUuXq6KyOunI3FLuUCimNS_0af32QcV96VlsT3rBXN5g2Qji3c9Z4EYo671ceeGFmtnSYgkRxn77Gywt0cMPPKSvfvVr2r_PlbzIjVZaUqpXnHaaPvPfn9X__PAH-ksL4GifN8_G4WlocMgycYQVSwSaHN195QI1XDmUUCik-vr6RGaNb3z7W_r2976riy6-SGWWuSKX2oMPPKCvX_fVRIBJskApz0rhXGiZQqprarLYdXO3LDLx7vUWuOHP4nWzfykX4ENDAAEEEEAAAQQQyF2B4eFh_cd__EfiPf5YvfzIRz5yyJcO3Ptq99xYzf2d4M7lzklDAAEEEEAAAQQQyI7AkV9Xy851uQoCCCCAAAIIIJD3AoFgUIssK8G8xUv0zJOPWRaEsYfkWT6A7fsGtW5rVKcvqlBlIJTtaiFjdyzrz1oYiwvciAxIweTBLpno1tJly3Tc8cepY9s2hUNjf_jos6CO3_zqV4kAjw9-6G9UXZ3dPqYad0lJiU47_fTEY9vWrbrlllv0yJ8f0QsvvKDNmzZZcFBIwdJS-RMZXZJnfnCL7-7D14bGRi1auFAnnXKyLr7kEp1-xhmpLj-t25577jn9f5_6L3V1dSlor7nDWyLbhmULmTNvrk4--eTDN2f2dyv7Ex_YLg3aw3dk3zJ78eye3b0-aAgggAACCCCAAAK5K3DNNddok_1tMFZ79atfrRNPPPGITe45t-0uK0d4eHPncuf8xCc-cfgmfkcAAQQQQAABBBDIgACBGxlA5ZQIIIAAAgggUDwCc61UymIrzbD-qTUWEDB2Jgm33rmva0hrNvZq-wkBLW4pHp9DR2oBBcN7rVzKRnlljZahILtvRd_45jfrvnvuU6cFbowV2uCyWIQjUX3z619XZVWl_vqd71RlZeWhQ8iB39qshMoHP_Qhvff979O2ju3atHGjHn30Uf3ut7_VFgvqcIFChntET6M2tpmtM_U3V12lFSet0Lz2dtXV1R2xXy49sc6CNj76d3-np596Wi54JVlzo3VBG8lSPSc7bsrPxyOKd64pijIpZNyY8t3CCRBAAAEEEEAAgYwJ_PznP9cf__jHMc_vsuldZX8DJGtu24MPPpjIyHf4Pu6ci-1v3ssvv_zwTfyOAAIIIIAAAgggkGYBvjaVZlBOhwACCCCAAALFJVBVU6ulJ6zQ7PkLLO1s8rF7iunZbVGt3uJTKGJFHVLsm_ws-b7FBh0NS11P279jB7lkcoQrVqzQilNPlt-VbEkENxx5Nb_fp0g0puu-9GX97MYbNTBg2UFytAUCQQu-mKdXnX-e_vbDH7aSKq-wTC6WASJJf6ORiNpmz9YVb79SJ5pFrgdtbN--Q__yTx_X2jVrUwRtjASp1Fm5l9e94fXyB7IbDKSY3c_7nzLxwv-ziowbSV5YPI0AAggggAACCEyzwM0336zrrrsuaS8--tGPqrm5Oel2t83tk6y5c7tr0BBAAAEEEEAAAQQyK1D4nzBm1o-zI4AAAggggECRC_j9fs1buEjzFi22YIzkb61cBYttO7r0yLM92tmT5cXlXJqjuAVsdG-QYtkP3KitrdUll7xGZWWlB8rajB3i4II3hoaG9aVrvqhf3_xrDQ4O5pLgmH1x2ULcvThec3WsIxbAkett3759-uT__Q899thjNl9lKbvrxrRs2XKdc-65KfdL_0YL_xncJQ10FEXGjfT7cUYEEEAAAQQQQACBqQq4EorXXntt0tO89rWv1Wte85qk20c3uH3cvsmau4a7Fg0BBBBAAAEEEEAgcwLJVxcyd03OjAACCCCAAAIIFJTAjNZZWnjMMaptaEyZScNlQ_jz8_16_IVhy4wwdtBAQcGMNRgLYIkP7JCG9tnW2Fh7ZPS5M886Q0tskd8lPEk1Az4LhOjp7dOn__OTuvGnNygctswKOdzi8VSjyeGOj9E1V0v7w5au-Y-__4NKS0vH2OPlp9yog5Zl44orr0iRlePl_dP6Uzwq7V11IHuMu6NoCCCAAAIIIIAAAghkR8CVsfvmN7-pq6--2oLSx_5bYMGCBSkzaRzeU5d1wx0zVnPXcNdy16SE3lhCPIcAAggggAACCExdgMCNqRtyBgQQQAABBBAocoESW1xuX7hYM-fMOZDJITnI7r39enBdSJt6y-UFinGx17JCWNBGfGCrxW3YwneWW1tbm15x-ukqGycgwHXLZd4Y6B_U5_77v_Wt67-h3t7eLPe2-C637rl1-sjfflj333vvuIEYiXI39hn1smXLdNY5r8w-lrt_u9ZMS_aY7A-WKyKAAAIIIIAAAgjkioD7u-Sf_umf9JOf_CRpl5qamvTZz3523EDog0_ggqbdMe7YZM1d012bv42SCfE8AggggAACCCAweQECNyZvx5EIIIAAAggggMBLAu1LlmjpcSeo1MpwJGtW0UHDoaiefL5bazcOKBrzUmboSHae_H7e3n5Ge6TeLZbyYjpKdnh6w6Vv0CwL4PAlStuM_e20UWN_wK_QcEhfvOYa_dcn_1M7d-5I-o220WP4d3ICd915pz78t1fpySeftA-YU5dHGb2CK5Ny2ZvfrAbLdpP1FupSvM_KpNAQQAABBBBAAAEEEMiSwP3336_3vOc9evTRR5NesaGhQV_-8pfV2tqadJ9kG9wx7lh3jmTNXdv1wfWFhgACCCCAAAIIIJA-AQI30mfJmRBAAAEEEECgiAVq6ht0_Gmnae7CRYkyHMkofF5c2_YO6dHnBrW71yI5_EWYdcMCJuLdz1oUS5cxpQ6cSOY4leePsbI2r165MpHRYSJXd2VTZLN60w036APve79uv_VWRSLTEXSSfNQugMFFAeXj3dTT06PPfPrT-j9X_a3WW8aNkpKS5AM9sMVl24hFolq6dKnOv2DluPunfQcrkxLvfdGyx-wxd8siQ0MAAQQQQAABBBBAIIMCO3fu1L_-67_qE5_4hHbt2pX0SnV1dbr22ms1x7JBTra5Y9053LmSNdcH1xfXJ9c3GgIIIIAAAggggMDUBQjcmLohZ0AAAQQQQAABBBICi445VstPOkX-YDCpiFtfHxoc1qoXB_XUFlt-jubnYnvSAU5kgxeQup8ziN0WtxGbyBFp3-dNb75MTTNmWKCDC3UYP3zDzVvQAgpWP7FKH_voP-iT_-__6YUNG3Im-4brnwsmGW8kPp9PZWUTy2aRdvTDTjg0NKj77rlX73_3exKlaAYGBhRM8do57PBEgMc5552n2bNnH74p87-7-7ZvkxTqTgTMZP6C038FaplP_xzQAwQQQAABBBAoPoHdu3frK1_5it7xjnfogQceSAng3hdfd911mj9_fsr9JrLRncOda7z32q5Prm-uj66vNAQQQAABBBBAAIHJC_iv-udPfHLyh3MkAggggAACCCCAwKhAiZV3iEWj2rFls_bvSf4tKFs7V2d_VJUVpVo-p0zVZdMTvDDa7-z_a1EG0QGpZom86gWSzwI5styqa2q0y74ZtmbNGsViUUtWYX2aQPP7_QqHI1r1-OO6-667rbZzn8rLy9Tc3Dzhc0zgMhPeZfv27XrMUhXf8ttbdPfdd6m7u9tKwLjDjxxP3KI6XCkfVyamvKJc1dXVE75OOnd0ARquz1-59kv6wuc_r61btyoQCMgFlUy0uYCbNhvHv3ziX9XQOB1lUqzcT8ctFryxxe7fws-44QKC9vT69PsnhtTf1z_mNLmXUHllpZavOFlLjz9hzH14EoFMCjSXj5-tJ5PX59wIIIAAAgikU2CDBYlff_31-ry9X37qqacUtb8zU7XTTz9d11h5R_d3Sbqay7hx8cUXy_Vl27ZtSU_r-vbMM8_oV7_6lTo6OjRr1qyUpVaSnogNCCCAAAIIIIBAkQtk_1PyIgdn-AgggAACCCBQuAJu4Xnh8mO07IQTten55xUaHrSMDGOPNxIK6b6nunXi_FJddqont_SbZNexT5Dvz7pyKXsfl9d6vpWLyX4GiNLSUr3u0jfojttv1-YtWywMwOkfGewwFvNo9o2Ojm36_H9_Vj_8wfd16qmn6sJLLtHFF10kFxSSyRYOh_XQAw_q97__nZ584kltsHttcHDQgjLK5D9Q1mWs6weCAb344ov68FVXad7cuVpx8kl642WX6cwzzzyqoImxzj2R51w65V_87GcWYHK3nn36mUSQiZsHFwxztM1vr7VLXvc6LVq8-GgPTcP-lilncLfinU9NS9BRGgbAKRBAAAEEEEAAAQRyUMAFZd9555264447tHHjxgn10AWgX3HFFfrgBz-YkUDyqqoqXX311frmN7-pG6x0ZDzZH7jWW5cB8FYrK-keLmPHBRdcoJVWotIFctAQQAABBBBAAAEExhfwntrfV1RrBOOTsAcCCCCAAAIIIDB5AfdB1gO336obvnW9tr34QtLADXcFz_PrgtNn6W9fV6tjW0NWNmXy182_I-0taEmdvFOvtqwb85xG1ofgSj_8-7_8q37xi18o6rJuTLIP0UhUkWhElZZtwKUSvtCCN15tH1LOXzBfjZYNYqLZPFIBDFqWip07d-lu-yD397__vdY995x6enoSH5wGrLxIsiwbni_RXwAAQABJREFUY53Tjdt9qOqa-xbdokWL9EYrHfPqla_WjBnNcsEU6Wjum3f79-_XWstq8vvf_V4PPfiAdu7YqZAFLbmSKEeTYePg_rj-t5nzj2_4qebNc_dOllvcStJ03Kb4U5-3wI3i-IZ_1F6uqy25yN99r1u77T4cq7mApga7f970rvfqDVe8faxdeA6BjAocW1-Z0fNzcgQQQAABBNIt0Nvbq9WrV2vVqlV68skn9bwFZB9Na29v18c__nEdd9xxR3PYpPd1mT9cEMemTZuO6hyLLdj6pJNO0ooVK3TiiSdOW-a_o-o0OyOAAAIIIIAAAtMgQMaNaUDnkggggAACCCBQuAJukX7xscdpuWXd2Ll5ky2QJ4_GcAvbjz6zRw-2BzS_qUwVgZjiMVshLZYWsZIL3c9Jla22AJ6eYIGjoXOBA5de9qZEreht27bboa5kzdEHkPgDfrmHK6HiMlp8w1Iaf8u-kXbs8cfr_PNepWPsg1QX0DHHslzUHEU2Dhf00LG1wzJqrNd999yru__0J3V1dsqzfvvsPgtaBo3J9NeNu6RkJOCgv78_8UHx4489pq-1tupc6--5575Ky45ZnuhzeXn50ZCqx0q1dGzr0OZNm-XOec-f7tHz69cnzuGu614fUw0McYEfl__lX45bb_uoOn40O1vghixbjCzwqpjaZANtismIsSKAAAIIIIAAAmMJuL_7XDYNF_DgHps3b9YLL7yQ-NshVQaLsc7lnnPvp__6r_9aV1555aSy1yU773jPuwCR__mf_9FPf_pT_fCHP9Tw8PB4hyS2u4AU9_iZZd9zfw8sWLBACxcuTARht1vwiXu4rByTycQ3oQ6wEwIIIIAAAgggkCcCBG7kyUTRTQQQQAABBBDIH4GWttk65exztf6ptdqc4ltTto6tfV3Dun31gJbNLdcrF9mCvKJFUjLFAiSi9kHfvieklrOmJXDD3VGuFvSrzjtPv_j5zzUcGp5E2MbL96V9BmkfRNqkHmhrn1ylR__850SQREtLi9rmzNaMhhlqntlsQRxzEtktgiXBxHa3KN7b0629e_Zp157d6ti8xTJs7LQgiG2W4WCnO7GCFmwRsACRyQRrjPbp8H_dB6fu4bNz79mzRzf8-Ke66YYbNdcyWbRaIMecOXO0dPlyzWxpVmNTU-Lh-hq24ImIBap0dnUm6l1vtXIzrp71Nisfs2PHdm23QBiXGcMFiAQC6fuTw5WJmWsBMG_4izdM0we7rkxKp5VJWW3T8PJcH-5aiL-7-aQhgAACCCAwHQIuK4ELaO20ANahoSELlg0nMni5YE73cJnEJrP4PR1j4ZqFJeDuO3f_jd6Lo_emy4zn7tfR-7bbgpvTcY-699avec1r9Pa3v10zZ86cFkwXXPGOd7xDF154oX7yk5_oD3_4Q2L8E-2Mc3BBK-5xcHN_k9TW1qq-vl4NDQ2Jf13Quxuzy9bn_h3928LtS0Mg2wLuvnN_247ei6P3ZpmVLB29b6urq7PdLa6HAAIIIFBgAun7FLXAYBgOAggggAACCCAwFYHlJ1oa2NPP1Hb7NpVb5E7W_L641r7QqdueKNXC5irNqrUPoYom64ZlGOnbJC_UJwXdBxzZ_wDOffjy1iuv0J8sm8V2C5JQImwmPf3wW0aMSnu4MtB7du-2gIYdiWCGgD9gQRgjHz66QA-3_u_KtESt3IrL2jH64a_7UNRnj9Iyl40kPX1Kdh-6511ARll5WeJD5Q4LxNhkdbUftufLLOvG6IekriyL64n7wPXgD6rdt-3CobCNxUsEVLj9M_WB6gUXXaj29vmuy9lvcQte6FpjBbwtW0wW5iT7A-SKCCCAAAIIZF_ABWNssfceLgvB6MMFsI4ufI-WeMt-z7giArkh4BaGL730Ur3tbW9TkwVT50JzgSMf-9jH9M53vlM33nijfvOb3yQCqybbN_e3RVdXV-Kx0f4OoSGQjwIusGM08Mi9Rlxpz9GH-wKCey3TEEAAAQQQSCVA4EYqHbYhgAACCCCAAAKTFKipb9CprzxHG55-Ws-uejyxeJ_sVOHhkO5e3a0lc8p1-Wm2eO63rBvFUDHFlZoY3DUSvFE-wyIHgsmIMvq8q7n8hkvfoO98-zuWRSKU9oADiw2xUiqBxGN0IG5-k6UW9vt9OtoSJaPnTce_iW8SWYCGC9JwzWVacAsqrrkPVA9uo8EZLsjEX57Z0iGuH21tbfrrd74r7XN08JhS_mxlUuJ7LUtMLGxxG5kdb8p-TMNGSqVMAzqXRAABBApUwJWWW7t2rdasWaOn7b2yC249_D1GgQ6dYSFwVALHHnusLr74Yq1cuVK5-k1-F0jy4Q9_OFG65a677tKtt96aeF0f1UDZGYECEXCBhrvtSxvusW7dukNG5f52dlkt3ev6hBNO0PFWWtWVDaIhgAACCCBwsACBGwdr8DMCCCCAAAIIIJAmAbfIufi447XizLO05YUN6u916XHHPrlb2N--q1u_fiCg-fbB19lLbL8k-459hnx91lJNhLukHvtAo2mFDWJ6Ajdcdoi_eNObdNcdd2r9-vVGH7dcCi6vROaam_N8ydgwGpyR6PFIxzMHk-LMLnDjCqvjvWjxohR7ZXhTyN2vz9tFXNmQ4grcoFRKhu8tTo8AAggUsMC-fft0__3366GHHkoEbLjSJzQEEDhSwL3vdgu55557ri666KJE0PKRe-XmM66syRvf-MbEY5tlMrztttt07733ygVqEZiVm3NGr7Ir4F4H27dbWVF73H777YmLu4AsF8Bx5pln6uyzz1ZjY2N2O8XVEEAAAQRyToDAjZybEjqEAAIIIIAAAoUiUFFVpZMtcGP92tV67L57Uw7LKkzomU19un11tRa2VmpmlX2jvxiCN1ydkK5npaFOqbLcjDIbMJFsElzWjfMvWJlIzz0cGk62G89Pk4D75pKboyv-6u3T1AO7rJVJifdutFQpe-2X4gracOhk3HAKNAQQQACBiQq4hVu3aHvfffclvn3Pwu1E5div2ARmz56tU045RSeffHLiUVtbm_cELkveu9_97sSju7tbTzzxROLx-OOPq6OjI-_HxwAQSJeAC2R88MEHE48vfvGLiWwc55xzTiJ4y72OaAgggAACxSdA4EbxzTkjRgABBBBAAIEsCixYfozOuuAibbVvGu3alvxDKpfIYGhoWPet7dRx80r05lNdzociiNzwgop3r5M3uEOqaLG4jel5e-q-3faXb32rHrjvfj3z9DP2rbCo3SXTE0SSxdszLy41utDz3ve_f3prert7oucFKdRtcRvUJs6Lm4dOIoAAAghkVcAFWrpgjZtvvlmrVq3K6rW5GAK5LBCwsokNDQ2aNWtWIqPG_PnztXDhQrW3t6vKgv0LublAlPPPPz_xcOPs6-vTpk2b9MILL2jjxo2JjBwuA8H-_fvl_htCQ6BYBdzfvU899VTicf3112vFihWJDDYuA4_7bwgNAQQQQKA4BPgvfnHMM6NEAAEEEEAAgWkS8P__7N0HfBzltTbwZ7averXk3rGNbWyKjQ22MTam2WBaKAZCIECAcEPLDUngI9wEkptKLklISLgkFzAJoSYECISWgE3HDWxwL7JsWbJ62zrfOSPJcdldrSztald63h-LVrNT3vnPjHa879lz7HYce-Isq1zKS3_-E3ytrVF7YpfkE9vK6_HMci9OGJuHQbn9IHBDgyMC9TBr1sLIOxLyiURUn0S_oB-cXioZHb5_z71oaGxg2EaiweNcv9_nw8wTT8RZi8-Oc4kEzeargVm9WuJ55ELth42lUvrhQecuU4ACFIhTYPfu3VawxosvvojaWikr1sMtIyPDGvTOz8-HppV3Op3WQ8vd6UMHtPYv7dbDm-fqKBBVQM87PR87zsWOnx6PxzpnteyBPvpCFo2oCF18QQNVJk2aZD0OXlSzc2hpJX1oIEer_NvZ7_cf8AgEAiy9cjAcf0-KgAZWaHBRxzmp56I-NGtGTU2Ndc42Nzf3WF80AFIfeXl5WLhwIRYvXozS0tIeWz9XRAEKUIACqSnQe5-Mp6YHe0UBClCAAhSgAAV6XCCvsAgnzF9gBW-sWP62fNAUfROGYWLVhmq88XkeFh9rR5ZDvuUfY_7oa0qjV2wOmFUfwhi2UAI3Mnq146efeSZe_cereOO11yCFMSR4g1k3evOA6Idj2VIv-4tfugKZmZm91xUtk9JcLmV9PpWaIc7e6we3TAEKUIACFEghAQ3YePTRR_HSSy9165vyWo5LB6OGDx-OYcOGWT_1eXFxsTX4rYPhbBSgQN8X0AAXfYwaNarv7yz3sE8KaFCHBh1VVlZaZVi3bduG7du3W8_1PfNwguE1IHLp0qV44okncMYZZ-CLX_wiSkokWykbBShAAQr0SQEGbvTJw8qdogAFKEABClAg1QRGHDEO02bPwfbNm7B3966owRsaJtDa6scfX6vCxEFFmDJEQgckmKNvB2_IXjdtlYHxnTBceZLRwN5rhy9HggQ068aKFSuwt6qqPblC6gdvaGyPBgRFivHR3suXAa2W-nvS1s-O_4dCIcyW1LBnLlrUMal3fmqZlOpVQFC-QcXAjd45BtwqBShAAQqkjMCePXusgI0XXnjhsAI2vF4vjjzySEyePHnfN-81qwYbBShAAQpQIJ0FNNBQAxH1oe9x-zfNxtFRCmXNmjVYu3YtWlpa9p8l5nPN9vH8889bwZKagePyyy_HgAEDYi7DFylAAQpQIP0EGLiRfseMPaYABShAAQpQIA0F3JIud9pJ87BT6vm-8uzT0PIP0ZqWTFm3tRZ_Wp6NgjMyMSxHa_2Go83eB6ZLOEHIB3PPezCyR0vWjV7MrCCaM044AafMn4-nn34aoXAoZXJudARn6AHfP0DDKXyZDgOZEu_ishmw7_dqWHrfGjbRHNIH4D_oNOoI5NDAjo7nqXJC6beR9Ju2t_7n12HriDzppc6ZoRaYFW9L0EbvBRX10q7v26x-G5qNAhSgAAX6t4B-k_ixxx7D448_bqWK74rGwIEDMXv2bOuhZRK0nCAbBShAAQpQoL8IaIDi9OnTrYfus35JQQM53nrrLeuxa9euuCg0gOMvf_mLFcCxZMkSXHbZZVa5prgW5kwUoAAFKJDyAgzcSPlDxA5SgAIUoAAFKNBXBIrlWxcnnnqaZN3YjNXvvxtzt2xmEC8s34MJgwbivOMdyHbJsHqsGisx15YGL5oBYO9qYMR5vR644Xa7camkH9WsGxs3bRJ3jXbonbAGDdAItm8-x24gR6p0jPLaMDbTwFC3DUO9BkpdNnhk7EOH1SVuw2odvdXlJW4DErNh_QzK8z1-E1tbwtZjU5OJba1h1ElsUL28KPEd0ECQjvW0ra0X_i_nutYLvurqqzFu3Lhe6MB-m9TjX78RaJFSKZbyfq_xKQUoQAEKUKCfCHzwwQe47777UFZWFvceawDmmVKGbu7cuRg9enTcy3FGClCAAhSgQF8X0ADGKVOmWI8bb7wRm-SzhzfffBMvvviiVWqls_3XYMo__OEPePXVV3HLLbdg2rRpnS3C1ylAAQpQIA0EGLiRBgeJXaQABShAAQpQoO8IjJ04GbMleKNCPvTes6ssaiyGJhhoaW7CY_-sx5jSYswYEzogk0LfEWnfEy2P0irfMGnYKmkjciVOondvUydNnoTzLrgAv_if_0FzS3OvhG1okIW2cZk2TMq2YV6hHVPlZ55GVrQ3fdY-W8ekmD91_uES7DEtty17gv6uARsf14fxbm0IayWQ47PGEGolkMMjs_x7SzFX2-Mv6odQk486CufLMej1JkFU5h4JtAr5BaTNrdf7xA5QgAIUoAAFkiRQV1eHn__853jttdfi2qJmaNJvFJ999tk4QbKYMWNTXGyciQIUoAAF-rmABjjq48orr8Ty5cvx17_-Fe-__z40E2WspgGVt912G-ZL1tCbb74ZubnyeQobBShAAQqkrUDvfiKetmzsOAUoQAEKUIACFDg8AafUPD1uzlyUbd2Cl59-Er5WKcEQZeRdsx5s3LIHD7_qwMCCPIwu0uQPsf_Rfni9SoWlZEDctxdm7ToY-UcC9t6_Tb34kovx0Ycf4I3X3pBMFFoyJTlhDNYRlnNicpYNF5c6MSPfhiGSZSMsqTM0mEMzaPRky5JMHvMK7DityIGagIk1DSH8vSqEl6uCEtTRln0jOXvetlemXBDZOTm47obrMaCk92v2mr4aoFqywVjlihi40ZPnHtdFAQpQgAKpLbBy5Up897vfRVVVVacddTgcWLhwIS699FKUSpY5NgpQgAIUoAAFui6gAY-zZs2yHrt378bSpUvxwgsvQEukxGoaYLlq1SrcddddmDp1aqxZ-RoFKEABCqSwgP2G2799dwr3j12jAAUoQAEKUIACfU7AI7VNnU6nFbxRtTt2HVMN3thR5UdpQRZGD5KSGI4eHrVPKV0JjrC5YBTIhwzOLOlZMsMFDoVwezzWwMPbb7-N-vr69vIhie2TlirJcxi4eqgLt45wYpoEbWhgRUCiORIZsqPrlpgNSPUVjJAgkePz7Jhb4ECjdGhLiwmprgLpRlKalkg59_zzcMNXv9r739KVgB1UfgDslm8Zh-WDMk2F0w-b_tXZU2_gxY9b0dTYFFFAabyZmZgw9RiMm3xUxHk4kQKJFBjgdSVy9Vw3BfqVgAZR_t___R9--MMfoqkp8t_9DhAN2Fi0aJEV4LFgwQJkZek9HBsFKEABClCAAt0V0PdUzV51-umnw-fzWeVUYmXgaG5uxiuvvGJtVsuwGP3036_ddefyFKAABXpTgIEbvanPbVOAAhSgAAUo0C8F9B_P-UXFVvaMrRs2oLmxMaqD_js7FAxhZ70dYwdnY0iBIQPoOozaB5uWofDXSuDGFCBDvqmZAmUpBg0ahKrKSqz8-GMr00Xb5x6JGbzX4IzRmQa-f4QLZxU7kCkBHBrIkciAjYPPIj2zdJsapDHAZeDkQgdK3Qa2toRRKZVCpEsJbfotolGjRuGHP_kJ8vLyErqtuFauZVK2_7Ut44at97PAxNXnBMyk58XuWhMvrfAxcCMBvlxlzwgwcKNnHLkWCmhplG9-85t48cUXJSucvgNEb7Nnz8aPfvQjnHrqqQzYiM7EVyhAAQpQgALdEugI4DjttNOgWTi2b98edX363r1ixQqsXr0aM2fOhEe-kMJGAQpQgALpI8Bcv-lzrNhTClCAAhSgAAX6kIDL7caMefMx67TT4c7wxtwzu9yxbd1Wif99tQab95hRS6vEXElavChRAYF6mNWrJHrAlxI91iCbq6-9FlOPOcbK_xF7-OLwu6zBEnOlXMl94z2YnmuHbqenS6J0pXe6fS3LonEaF5U68MsjPTi1yG5l5ejKeroyr35zyCWlhL55x7cxZMiQriyauHn9Uialbn1vJ39J3P5xzRSgAAUoQIH9BMrLy3H99dfjYwlYjdW0FMp___d_495772VZlFhQfI0CFKAABSjQgwL6_qvvvfoe3FlZMn0v1_d0fW9nowAFKECB9BFg4Eb6HCv2lAIUoAAFKECBPiaQV1iE2aedgSnTZnZagcFuB95bswePLw-hokW--Z_gzAe9Ri1ZDczK9yWAI3oWkmT3rbCwEDffegsKCgrag2Y0rKHnmgZtHJtjw7dGuTBWMm5owEQqtVbNBOI18L2xbpwhwRs--T0RXfT7_Vh01llYIN_aTYlmhmE27QSatgE2Z0p0qTc7obWW2ShAAQpQoO8KrFu3Dtdddx3Kysqi7qS-FyxZsgSPPvqolbo96ox8gQIUoAAFKECBhAlo-RR9L9b35Fj_TtP3dH1v1_d4NgpQgAIUSA8BfvqWHseJvaQABShAAQpQoI8KDB8zFifMX4CBw0Z0GrwhNVPw_Ns78fa6MJqCEsnRVrejj8nI7WlLOcyGzZJyIpAy-zZTPhi5-tpr4JI67m2ZMHomdEHLowz2GPiGBG0MleAI_T0Vm192N0_ihb4t_TxdM2_0cD-1RIrW4L3ltltjfvCUVBspk4Lq1ZL9pVU221cjpZIqyo1RgAIUoECKCixfvhw33XQTamtro_ZQA1h_-tOfWgNAbskcx0YBClCAAhSgQO8J6HuxBmXoe7O-R0dr-t6u7_H6Xs9GAQpQgAKpL8DAjdQ_RuwhBShAAQpQgAJ9WMDhdOK4ObOtkimZWTkx91S_8F5b14yHXq7Gys0hBHt48DzmxpP5YtgPc8_b7QPmydxw9G3pt1guv-IKzJ0_H6aU9OiJsA0NAMlxGLhmqBMTs2zQzBup3DQTSKHLwJ2jXZiZZ--xzCBaIiUvLw_f-d53MXTYsJQhMIMtMCuWSbYNiVhhowAFKEABCvRRgWXLluHOO-9Ea6sGKkZuxx13HH7_-9_j2GOPjTwDp1KAAhSgAAUo0CsC-t6s79H6Xh2t6Xu8vtfrez4bBShAAQqktgADN1L7-LB3FKAABShAAQr0A4Hs3DzMPvV0TJ05s9O9dUiijQ1bqvDwP33YXGmXAII-mAlASlSg9nMpl1IvHqkTzZCRkYHbvv51HDlpIsyQBm90r2-69NwCOxYWd2Tx6PTw9_oMGlxSIsEbN49wIl-qh3S3rIsGbZimiVu-fhumT5_e6_u3rwN6DjZsBJq1HjD_yaQueqzYKEABClCgbwl88MEH-M53vgPNfBWtXXbZZda3efPz86PNwukUoAAFKEABCvSigL5Ha-YNfc-O1vS9Xt_z9b2fjQIUoAAFUleAn0Km7rFhzyhAAQpQgAIU6EcCg0eMxElnnoWxEyd1WgHFbgvjXx_swJ_e8aGiyd7p_GnHaMgtassemPWbZLQ4-kBCb-zX2CPG4lt33IHS0lIZyNbQi8ML3tCl8iXbxhWDnHDJ7h7eWnpDQOJppLNH59hwbolEbnQjfEUDNvTDo_POPx-XSG3elGpSJsXc867sXuqU6-ltn1i1k3u7b9w-BShAAQp0XWDVqlW4Q-5p_H5_xIXtdjtuu-02XHvttXKv2QcDhSPuNSdSgAIUoAAF0lNA36v1PVvfu_U9PFLT93x979d7ADYKUIACFEhNAQZupOZxYa8oQAEKUIACFOhnAvoP6ynHz8Cc089EbkFRp8EYpmQEeOK1nXhlhR_1AaPT-dOLU25Rg3WSdWOtBG5EHkzozf2ZNWsWbr_j28jJzkboMIM3tMzNGQPsGJEhAyHpFLUh8NpdzbxxxSAHJmXbD7vESygUwikLFuCO_3cnXC5Xbx7SQ7Zt-muA6tWys6FDXuMEClCAAhSgQLoLrF-_HrfffnvU8igejwf33HMPFi9enO67yv5TgAIUoAAF-pWAvnfre7i-l0dqWjZF7wH0XoCNAhSgAAVST4CBG6l3TNgjClCAAhSgAAX6qYBb_mE97aS5OH7u3KjfkOigscl4f0tzK37_eh3e3WhHa0hu6_rSlyENKQNT_YnsZKXscuqVaDh78dm45ivXwuP1dDnzhsZ6FDoNnFrkgCdN78atkiluA-cMcMJ-GOddIBDAMcccg-_dey8KCgs7TuvU-KnBGtVrgNYK6U-aHqDUkGQvKEABClAgBQVqa2utb9s2NzdH7J2WhvvZz36GE088MeLrnEgBClCAAhSgQGoL6Hu4vpfre3qkpvcAmnlD7wnYKEABClAgtQT4SWRqHQ_2hgIUoAAFKECBfi4wcOgwzF20GEUlpZ1KOCT75fbtlXjw5Xp8WmaX8IbI6TA7XVEqzmA4gIb1MBu3pFy5FOUypJzL9V_9Kq6--mq43G5I1Q9p1v_0Sczml9mm59kx0mvAPIygh5grT-KLAYmnOa3IhoESwNGV0Bqfz4fRY8bghz_9CQYPGZzEHse5KSmPYu5dAfjkQywt28NmCYTDXTnKRKMABShAgVQU0BJld955JyoqNDjx0OaWe5of_OAHmDRp0qEvcgoFKEABClCAAmkjoO_l-p6u7-2Rmt4L6D2B3huwUYACFKBA6gjwk8jUORbsCQUoQAEKUIACFLAExh81BaddcDHyi4s7LYGipUs_XlOGX7xYg88rJEtFn8kQIBENZhDmnvekLkdrSp4ZWt7mpltuwX9-4xvWN1niKZuioR16Az4l24ZCl6094CMld6_TTum-5DoMnFlsh5Z-iafph0LTpk3Drx98EGPHjo1nkSTPI3vVWi1lej7T6Jwkb5ubowAFKEABCiRW4L777sPq1VIKLEJzOBz43ve-h6OPPjrCq5xEAQpQgAIUoEC6Ceh7ur6363t8pKb3BHpvwEYBClCAAqkjwMCN1DkW7AkFKEABClCAAhSwBGw2G-ZLXdIp02bA7fF2On5slzu6f63Yg9--XIed1aG-kyRAs25UfwyztUpcNEwg9Zp-AHLll6_CTbfegqKiIgQCEmwSo68dZVKOyLLBaEvTkXo71YUeOeXcOyHXAan8EmOvJfYmFBKbAGbNno3_-dUvMW78uC5sJYmzmmGYDVuApm0SYeNK4oZTf1P6d4mNAhSgAAXSV-D555-HPiI1Q4IV77rrLsyYMSPSy5xGAQpQgAIUoECaCuh7u77H63t9pKb3Bn_7298ivcRpFKAABSjQCwL89K0X0LlJClCAAhSgAAUo0JlAbn4BFl2yBCPHH4nOBkz13982BPHy-1V45qMwqlvlFi_KP8o7225qvS475q8H9n4kI_--1Orafr3R43P1Ndfgp_f9DEcfczSCErwRlECFaKEMhRIPMFzKi-gc6d409mSgx8AQKfsSjBJbo6VRHJKd5OIlS_Cr3_waQ4cOTd3dliwvqHxfDl2cKURSd0_YMwpQgAIUoMA-gbIyyc72i1_s-_3gJ1dddRXmzp178GT-TgEKUIACFKBAHxDQ93h9r4_W7r__fui9AhsFKEABCvS-gHyqz0YBClCAAhSgAAUokIoCYydNxkXXXIfBI0d12j397kTQ34Lfv7wHT39goM4nt3mRv1DR6bpSagYzALPiHama0pxS3YrUmTknnYQHH3oId0id2JEjRkiWiTDCVlaNf0c06LMCSVNR4DLSukxKx_53ZBAZ5rFBdndfM2W_NctGOBzG_FNOwe8efhg_-OF_Izc3d988qfdEcqVImRSz8l2JhIqcSjb1-sweUYACFKAABWIL6Hvxvffei9bWyKXn5syZgyuuuCL2SvgqBShAAQpQgAJpLaDv9fqeH6npPYLeK-g9AxsFKEABCvSuAAM3etefW6cABShAAQpQgAIxBaZKWsuFF16CotLSuJJo1Nc14OG_7cKLa2xoCMrgc7pn3tD-N8s3P-o-A8KBmFap8GJJSQmuvf46PPL4UvzHTTehVH4PS3SD3--3gjhsUlBkuAQ52PtCUI2A68c62VInpdjKINIWrOHz-a0aukdNmYKf_fw-3C-lUebOO7nTzDG9fvxMyYGydwXgq5Wu9JED1IOo_BCvBzG5KgpQgAJJFHjsscfw6aefRtziqFGjcMcdd0R8jRMpQAEKUIACFOhbAvqer-_9kZreK-g9AxsFKEABCvSuAAM3etefW6cABShAAQpQgAIxBbQO6UlnLsLMk-cjMyu30zgMu9zd7a6sxW-e24H31hvwhWVCWo9BS_99VVK-QsqlhFO3XMrBB1HLgdz69dvwf48-gmuu-womTpwo1TfCCEkAx1DPvzNwHLxcOv7ulE7n2SQ4paUFGRkZOHHWifive76HJ556Euecdx5ycnLSY7ckMMjcs1z62heK2PQ8eWclm3p-i1wjBShAAQp0V2DDhg34wx_-EHE1Ho8H99xzD7xeb8TXOZECFKAABShAgb4loO_5-t6v9wCRmt4z6L0DGwUoQAEK9J6A_Ybbv313722eW6YABShAAQpQgAIU6EzA6XJh5BHjsWd3OXaX7UAwEIy5iE1iHerqffi8IoxRpVkYXGDAZqRrsIBEnWgmBMntYBROA1waBJA-kSiFRUWYPXs2Tjl1ASYceSSCUk8ks2YnpuXYOg3CiXmQU-hFQ47P565ijDv7Yvzn17-O6264HlOPPtrKupFC3eykK2GYtZ8DO_4iNYekLI8hFxHbPgH967G71sRLK3xoamzaN33_J5ocx5uZiQlTj8G4yUft_xKfUyApAgO8rqRshxuhQDoJ6DdrKyoqInb5a1_7GqZPnx7xNU6kAAUoQAEKUKBvCugXK7Kzs_HOO-8csoOaZXHjxo1YtGjRIa9xAgUoQAEKJEeAn0gmx5lboQAFKEABClCAAt0SyC8uxoXXfAXjJ0-FwyklUDppdjvw2aa9-Nlf9uDDrXYEIRPSJ97hwL2zSU6Hxq0wm3ZI_EbsoJUDF0yd30ql1M35F5yP--7_OS79zg8hUQ2p07nu9MQMw2d348Jbv4m777oTM2bOiPrtne5sJuHLhkMwK98FWiW7C4M2InIz40ZEFk6kAAUokLICL730EtauXRuxfxqwcc4550R8jRMpQAEKUIACFOjbAnoPEC14U-8d9B6CjQIUoAAFekeAgRu9486tUoACFKAABShAgS4LDB4-AhdffwOGjzlCsjVIxoZO1uCS2IDVn-_FD_68C6t3GAib6XrrJ3uqZVKq0qtcSqTDk5ubixHHzoRj0EipyNEHSnLIPtgGDEHRsbPg1GihdG1BySJR-6mcZ3pMOruy0nUnu9dv_fYVGwUoQAEKpIdAc3MzHnzwwYid1W_ZfvOb34z4GidSgAIUoAAFKNA_BPReQO8JIjW9h9B7CTYKUIACFEi-QLp-ep98KW6RAhSgAAUoQAEKpIDAhClH44Irr8awMaPjGl922E18srEaP3iyCit32BBK1-ANwykZEZbBbKmUo5CuZV_aT6CcQthHTpTd0IHwNN8Xmx2OCVLCJis_Ba6Ow-yCHAezYQtQvxGw9ZFMKIdJEWsxZtyIpcPXKEABCqSWwO9__3tUV1dH7NT111-PIinlxkYBClCAAhSgQP8V0HsBvSeI1PQeQu8l2ChAAQpQIPkCDNxIvjm3SAEKUIACFKAABbolMGP-fCy6-DIUlQ6Maz12m4kP11biJ8_WYPVOCd6A3AKmXVIB6bCvBqhZKZkqJPtGOjfJTOEYdwwMDXYw0zlwQ_rucsN54sJ0PhpyDCTLRrWcVwHJusEyKVGPJTNuRKXhCxSgAAVSSqCsrAxPP_10xD6NGzcOCxem-ft2xD3jRApQgAIUoAAFuiqg9wR6bxCp6b2E3lOwUYACFKBAcgUYuJFcb26NAhSgAAUoQAEKdFvAJlkO5p29GAsvWoL8YvnGZBxBGE7JvPHu6grc--e9WCWZN8KQshZxLNftzvboCkIwK5YDwfRP2ek46kTYBg5P78ANKZ3hGDUR9nFH9-hRTvrKAg1yXi1jto1O4JlxoxMgvkwBClAgRQQeeeQRBIPBQ3pjGAZuuukmKbeXdjeAh-wLJ1CAAhSgAAUo0H2BWPcGei-h9xRsFKAABSiQXAEGbiTXm1ujAAUoQAEKUIACPSLgcDiw8OIlmHfWOcjJzYtrnQ57GB-t3YO7l1Zg-UYHAmEJ3ki31rAVZu2nQDiQbj0_oL9GYSkcR8-xMlYc8EI6_aIJN06_PL0DHiTbhlm9BmjawWwb6XTusa8UoAAFKBBRYOfOnfjHP_4R8bUFCxZg0qRJEV_jRApQgAIUoAAF-qeA3hvoPUKkpvcUem_BRgEKUIACyRNg4EbyrLklClCAAhSgAAUo0KMCLrcb533pKpwswRtZOblxJdDQzBtrNlTj-0-U460NTrSa9jSqDiGBJv69MCs_lMCNNC-XImeC84RFUi4lNw0zn0jnA37Yj5wmj-k9ek4nfWVmULJtvNVWLiXpG-cGKUABClCAAj0roN-MDYWkBNhBzS33jNddd91BU_krBShAAQpQgAIUgHWPoPcKBze9p2DWjYNV-DsFKECBxAowcCOxvlw7BShAAQpQgAIUSKhAVnYOLrz6Gsw540xkyPN4sl87HSbWbt6LH_xxB95YZ0NzSAIi4lkwoXsS58pNSfNQ9znQWi0LyPM0braBw-A47hQJQgmn117oMbDZ4Dr5fBg5BenV9wN6a8JslEwbdZ8dMJW_RBYIp9t5Gnk3OJUCFKBAnxUoLy-Pmm3jrLPOQlGRlNdjowAFKEABClCAAgcJ6D2C3itEapp1Q-8x2ChAAQpQIDkCDNxIjjO3QgEKUIACFKAABRImoNk2Lr3hRpx6_vnIzs2PKwbDJbEam8tq8N2lO_DHZTbU-uW2MB2CN2xOoHEzzPr1aV8uRVOduOZdAFvRYIlBSaMglFAQ9rFTJehkfsLO6aSsONyebaOlgmVSkgLOjVCAAhSgQCIFli5dCq1Hf3BzuVy49NJLD57M3ylAAQpQgAIUoMA-Ab1X0HuGg5veW-g9BhsFKEABCiRHgIEbyXHmVihAAQpQgAIUoEBCBTR44_wvfRkz558Cb1Z2XDEYdrkT3FNRj_uf24aHXguhstkuiRSMhPaz-yuX_pkBmFUfAKGW7q-ul9dgHzYOzhMXyT6lUdYNpxuuBZfAyMjuZb1ubj7QBNSsaQ8ASvXzvpv72gOL2yTLChsFKEABCqSmQGNjI1555ZWInVu0aBEKCwsjvsaJFKAABShAAQpQQAX0XkHvGSI1vcfQew02ClCAAhRIvAA_fUu8MbdAAQpQgAIUoAAFkiKQnZuHJdd_FXNOOyP-4A3JvNFY34iHX9iBB_7egh11DqsMBlJ5HNuQrBtVH8Js3i2uaRTwEOkssNnhnH02jNLhsiuH1qSPtEivTgv44Th6DpyzIn-g06t969LGw1ImZTtQv0nOdzmf2ChAAQpQgAJpLPDCCy_A5_MdsgdOp5PZNg5R4QQKUIACFKAABSIJaNYNvXc4uOk9ht5rsFGAAhSgQOIFGLiReGNugQIUoAAFKEABCiRNIK-wCJd_7WYsumgJsvMK4sq8oUk2gv4WPPr3HbhzaS3e3-pAABLAkbKlU6TDgQaYFcuk461Js03UhmyDR8F18vmAy5uoTfTMekMh2CTAxHPhTYBdzo90blImBXsla4u_nmVS0vk4su8UoAAFKGAJPPfccxElTjnlFBQXF0d8jRMpQAEKUIACFKDA_gJ6zzB_fuSSqNHuNfZfns8pQAEKUKD7Agzc6L4h10ABClCAAhSgAAVSSiArOwfnXXEVTl50FjKzc-NOnmFDEP_8qBx3PVaB19YaaA0ZkIQQKdok04aUSzEDMvDeB5qWHnGMO1qybpipuTem9EsCedznXQfb0LGp2ceu9Koj8MeW5gEoXdnnbs4bDqd5dptu7j8XpwAFKJCqAu-99x527twZsXvnnHNOxOmcSAEKUIACFKAABSIJnHvuuZEmW_caes_BRgEKUIACiRVg4EZifbl2ClCAAhSgAAUo0CsC3qxMXPyV63HGFy5CTn5-3H1w2Exs2FKJux8pxyNvhVDV5IShKTlSrkmfmssleGOFBDscmho85brbSYeMjGy4L7gRRoF8KzYVB8iDfjinnyplXRancCaWTpA7XjZDMGs-BVrk_DH4z6EOls5-2my06syIr1OAAhToDYFnn3024mbHjx-PCRMmRHyNEylAAQpQgAIUoEAkAb130HuISC3aPUekeTmNAhSgAAUOT4Cfvh2eG5eiAAUoQAEKUIACKS-QkZmFC6--Vkqn3IKSwYPj7q9d7hD37q3BfX_ehv_3RAPWVbgQ1kHb_UqnaCiH9ZD_6eRID433iDR937S4exRpRulPoA5m5btSLqUl0gxpN81-xFR4Lr4F8GYCZgplNwgFYZ8wDe4rvg04Dq13m27QZjgAs_wfEiAT6tGuW9eDrHHf-R3h_E_sNdGju3PIyphx4xASTqAABSjQ6wJVVVV49125F4rQon1jNsKsnEQBClCAAhSgAAX2CUS7h9B7Dr33YKMABShAgcQJMDdw4my5ZgpQgAIUoAAFKNDrAi6PB_POWixBFgaeevi32LWjTAaWTWjli1hNB5-DAT9eWV6O8qoArjszH7OPADIdQauaRyhkQv6D_tTqHro6a53yJCgxB4FQCMGgjPPbpbyGU7ZujWYDGjWsTzUOxC6j2PrTIRNsMl_bi7oieWjcgqwwZuUQXbhuA8zmXTCc2bLilK3rIjsTR5PsD84TFiG0fhX8r_85jgWSMEswANugkfB86Q7YCkuSsMFEb0JOrPrN8tjQ5Q3JGdqWoKP9XLYil_Q8lZM0JD-D7T_D8lOTpnScxvpEp_kkTiQoF4fLYVgPm3UhyDp1vfKwrgW9JuQ0tus1oReLFekhPztW1tk1IbMmqjHjRqJkuV4KUIAChy_w97__Xd5j9M3owJabmxu1Rv2Bc_I3ClCAAhSgAAUocKDA_Pnz8cADD6Curu6AF_SeQ-89LrvssgOm8xcKUIACFOg5AQZu9Jwl10QBClCAAhSgAAVSUsBut-OUc85Fdm4O_vzQb7F1_ecScBGMK3hDhpqxet0ufGt3Hc6YPgCj8n1obPJhT30IlbUBVDWG0dAcQqtfBqaDJvwBU4I2ZJS57T_LQwelXRK84ZQBa7c-5Hlupg1FuU4UZtsxINeO4mx5Lj-L5Hd9LTfTgYIsO1xeWVoHuHXgWga9DxybkOwPrbsALXuRPVJGu9M8cEO1HA64L7oZ4YYqBN9_tT1SQF_ohSZBG0ZuIbzX_Bfsoyb1QgcSsEnNsrFnmZw38i2hOMqkWAFF1r-Y5ByU4IvmpjBqGgOobQ6jTs79yvogquqkpFCDX66HMKrkuqhqDKJRXvfLdeCT60GviaA811NYm6zJelgBHHIt6PXgkUdOplwHOXINyHVRLNdBYa4DJXl25Mu1kJtlk592ax5XhkR0aJSUjtNp4NSh43W6mR5vkQYGe3wjXCEFKEABCnRJoLa2Fk6nE4FA4IDlTjvtNLhcrgOm8RcKUIACFKAABSgQj4DeQ-i9xJ__fOAXSvSeQ-892ChAAQpQIHECDNxInC3XTAEKUIACFKAABVJK4PiT56N06FAs_dUvsfLdd-D3tXQavKE7oPEQjfXN-OPLWyWzgAwYy8izJgOwBqDliWbT0OfaNMYiUtNB7I6Rax3AbsvO4ZOx8PaMHToOLc-9bgOFWU4ZvLajNM-BYnkMLXRg9EA3po7yoKTQaW1bV6DrMCU9gbnrDaB0NgyvJ9Km026akZ0L79XfQ2tGDgJvttetjwabqL2TjCm2kqHwXvd92Ccen6itJH29pr8G5t4VcrJJAMdBgT7WqSv_s7LDyHmts2wsb8WqzT5s3e1DWbUEZUigRkWtPiR4Q4I4ghKsZGiWDF1O9sbKomGto-13awfbXzt4Z316TbS2TZVncv77rWtEz2u9zKzzW3565JoYIAEdJXltwU2lEtgxvNSJIwa5MHGoG8UFEsCkK-i4JvQ5GwUoQAEK9AuBG2-8EZdffjleeeUVvPjii9i0aZO132eeeWa_2H_uJAUoQAEKUIACiRHQe4mOwI3Ro0dDfz_11FOhWb3YKEABClAgcQIM3EicLddMAQpQgAIUoAAFUk5g-JgjcM3t35LgjV_g3TdeRUtTc9x9dEgAh5Y-OZxmLdW-6P7P7ftCPnSthjVYXVkXxK6aAFbK6LWOQXtdko3A25aBYHiRQwI4vDh-XIY1cJ0p010tWySyREpfeApkFTKI3QeakZ0Hz5JvABJcE3jvFa1J01ZLI9H7ptECkmnDPmICPFf9P9gnTEv0FpO3flNSUzTIuaIPe9s_gzTgQuqSWIEPLa1hNLaEsHqbH-993oiVW3yoqA5ib0MADS1tGWXsEtDh0EANeei14DzM60F3ev_rQJ9bQR_6wkFNA5p21QRRtjdolSbS6KgMj4E8ybxRIJlqxkoAx7GjPTh2jBejSl3wemySuKVtn0y9huSQ9kRjqZSeUOQ6KEABCvS8gA6gfOELX7Aen3_-OT744AOMGjWq5zfENVKAAhSgAAUo0G8E9F7i2muvxbRp0zBu3Lh-s9_cUQpQgAK9LcDAjd4-Atw-BShAAQpQgAIUSJJAwO9HVUUFtny-TjJnhGC3aZCDjupaQ8hJ6kXszWhiCU2EYLcGxNv6pQPP9VqaosmPTeU-_PPTJjj-pqVWHDhhghfzj8rAhNDLGHLSZNjdfefbH1bmja_cC9uAYfD_43GY9TWAM4Fpz6V8jtbdcE6bD_eX7pTtDol9sNLtVVPSyFd-IPvYCpvTLREYBloaQ9hW6cMnEqTx9xWN-GhTM5rkXAvKSaclSDSXjFZU0UAILfXTG00DOiSxjASKyNalpIo2jUHZ26AZQELYsNOHl1c0WEEkmp1m1qQszJkggU3DXBiU54Ihuwop15KskipWB_k_ClCAAhToFQEdWOHgSq_Qc6MUoAAFKECBPidw2WWX9bl94g5RgAIUSHUBBm6k-hFi_yhAAQpQgAIUoEA3BXaXbcf7b76JT1d8hM3rPsPePbtlEFcyOFjfxO-dweiu7JIGc-ijrbU9CVlZCAL481sBPPl2LYaVPoWJU3Zixqw5WLBgAUoHDpSsCDLinu7N7YX74pvhGH8sWp_6JUIbVwmG7Ne_QXpgD-VECARgGzgCroVfgmvueYBst2812cfWShh7_gXT7sSnW1rx6moJ1NjQgnVlrdglmTWckk5DTxml7QiWSFUD7aN9_3NAD6GUbdmw24_PdlbjkVdrMNoqpeLBDAnimCfBTUVSagVSnkXLsLBRgAIUoAAFKEABClCAAhSgAAUoQAEKUIACqSXAwI3UOh7sDQUoQAEKUIACFOgRgaAMxG_dsB7_fPEFrHrvHezcvg0hmWZFa8jAbV8Yu9UyFza5mzVhw7ZdLdi4_UW8_sa_sPSRR3HyvJPxhYsuwvARI-B0pn_5FPvU2fAOPwKBfzwB_xtPwqytaiufoulJNJCjq03TmGiGDYlUMDyZcMxaDPfiq2EbPLqra0qP-SVQqXXnu_jk03I89s8GfPB5M8prA_D5TbgdNnhch2GYgnuuwRxaBUaLDH22w4c12ySTyMcNePwNNxYck4VFx2VhSLFT5pH9lQiOrmThCHdl5hS0YZcoQAEKUIACFKAABShAAQpQgAIUoAAFKJDKAsYn1Y194XP7VDZm3yhAAQpQgAIUoEDSBBrr67B-zRr866UX8NGyt1FfW7OvEEp_uOkLy2C0qdlEJCChIC8Pp5x2KhaddRamTZ8Oj8eTtOOQyA2Fd22F__UnEVqzDKGdW2A21sPQ0jJ2KaPSkTLi4A5ooIbW19BgjaA8PBmwlQyDY_JMOGefBfvYo3s4i8fBHei93_fu3Yvlb7-NZx_5Gd5ZsR0tkpnCMKX8SHt2jd7rWXK2HJZjb4bbSr6U5Nlx1vQcnC5BHBOHSzYXr4GwBK901iRRB9aU2XDjQzXYs7si4uyaAKSgeADO_dKXcdYll0achxMpkEiBifmZiVw9100BClCAAhSgAAUoQAEKUIACFKAABRIqwMCNhPJy5RSgAAUoQAEKUCA5Av7WVnzw1j_x2nPPSEmUj-FrbbHSanQ-JJuc_vXGVjRWIeD3wZuZiRNPPBEXXXwR5s6bB7fb3Rvd6fFtmvU1CG1eg_C2zxHauhahbesQrtwFs7VJAhNkczKQrqlVJEYBNil9YuQVwz7ySNhHTZTMGmNgH3MUjIKSHu9XqqywoaEBzz3zLJ566kmsWrFSumWDQzNNJLnFugb1ECWzheWECIUM5EjAxpxJmTjvhBzMPypbzpXY2Tc0cGPVduBrD9cxcCOZB4zb6pIAAze6xMWZKUABClCAAhSgAAUoQAEKUIACFEgxAZZKSbEDwu5QgAIUoAAFKECBrggEJXvCupUr8OITf8SaD95DQ10d9JvvGrTQk00SWbStU37q4G_H-nUY3JBqHVqiQZuWL9GAAfl-v_W7Rg7ovNod6yFJH6x1afIHeUEX63josob80rFk-woO-4eu1yVBGgF_AK-8_DI-_vgjzJk9B9dcfx2OPFICGLTMSBo3IycfjqlzAHmYzQ2SeaMWZksTIMEqZnMt0CTPvRkwMnJguCXbiFue5xTAyMxJ473uvOt-vx_vLF-O3zzwa3z04YdoaW6W88BjnWedLx3fHHpO6_mrJ7Wez9r0GtBzzianlV4XNjmh9VzWado6furzfdeErkLXISvR9eg6NTGKrlIXs-lC8l_btaFLdq9JYRyrf42-MJ5_T0rGrG_Bacc24Yvz8jG61CWvSQYOjdJgowAFKEABClCAAhSgAAUoQAEKUIACFKAABZIqwMCNpHJzYxSgAAUoQAEKUKDnBMq3b8Nflz6CZa-8IiVRamVguG3AVQeCu9tCGlghI8lBGcTVAWSPW7-l70B2hoEsjx1eSVqR5XEgL9OG_Ew78rPtyJB5nJLRwO2Qnzp4LaPNQala4guGrfX4A2E0tJqobQijqjGAhuYwWqRMQ0NLGE2tIetnQ7MJv2xcB5idcqeq5Syswetu7JD2Q8uk1NXW4_m__hXLly_DRZcswSWXLsGgQYNkGzrMnt7NyMiWAA3JnNCPWzgcxvrP1-PXDzyAl196SbLOtMKQKAp3D5TI0YCKkJzLek1o2ZEsyViRm2FHjlwLWV4bcuQ6KM5xIj9LSvRk2VEg10Nuhk2uE5ucx3o9GHDJtaEJPwKyDn_ARECurVa_xNe0BlHdGEZNQ9vPvdbPEBpbTNQ3h-T1MOrkp19KvGhwiEPWZZf17B8I0tXDruuxO4HK-iCWvlGHV1c24ZI5ubhsXp6UGHJELJ_SF66TrjpxfgpQgAIUoAAFKEABClCAAhSgAAUoQAEKJEuAgRvJkuZ2KEABClCAAhSgQA8JtDQ24V9_fxEvPvknlG3eiJBGR0jrTsCGLmt941_-p2EMJQV2-Qa-B2MHOjFyoBulMpibLwPShTIgXZgjA9YSrGGXAWlr9FgXPjhYZP_fNfKjo3U8159Sw8PvC8mAdcgauK6WAeu9MpBcXhvCpnI_Pi_zYfPuVtRL1RebBKV0N4jDrqPdsnfV1bX41f3344033sBXv3oDTjn11D5TPqWDub_91Kwajz36KH7329-hYtduOF1OOT8P_586evqG5bzW7BdhOU-Lc-0YW-rG6MFuHDHIhcEFDrkO9CFBGnJdZMn1YF04umDHuX_wz30vdFwEMm_HU_1pPZf_adkSCeiobgzJ9RDAXgl02lMXwJbdfmzaHcB6uTa27GqFLyBZPiSIozvZOOy6sLSK2gDuf34v3vmsBVeflo95R2Va3dG_CR1NA2PYKEABClCAAhSgAAUoQAEKUIACFKAABShAgcQIHP6nmYnpD9dKAQpQgAIUoAAFKBBDYPeO7Xj6_x7GspdfQXNTvTVIvN_YaowlD3xJB2TbxmFNKxOA12PgCBmUnjnOiykjvRhaJNk0stoyargko4A1OqzxIe0RHtYPyRrw71HqA9cf32-ybRl4LilwoqRIljAkjYemEZDx4aamIGqaQqhrMLG5wocPN7Vi2dom7KoJtGUrkEFr2Ewrg0H7iHd8m9TFZLDaMJz4ZNUq3HnHHVi5ajWuueZqFA8YINPbBrLjXhln7FUBK8vG-vW4_2f34bXXXkVri88K2uh6pyS7jMYlSDYNzUThlaCkgXJezhyfiRMneDGixG1ll8mRLBteCdSwmnURyTMN8JBsGPFfh7HmbHtNT8MiCQopypNtyTWi15kZBBokmKNWrosKCW5avbUFy9c1YeUWn2TnCEtGDiliJEEmbQFObV2M9_-a1Ub3YPm6ZgmW8uELs3JxjQRw5GZL9g3ZNzYKUIACFKAABShAAQpQgAIUoAAFKEABClAgsQLGJ9WN_CQuscZcOwUoQAEKUIACFOi2gA5Qf_Lh-3j817_Ehk_WWFk2DucmTss9-KQUSZaUcNCB6aNGeHDChAxMG-vFkEIHXE4bbNZAsXRZB6RlI_pIZtNhakOTY-jotf4iA-pBGST3-6UUhmQbeP_zJr3ymWEAAEAASURBVLy9thmf7wxgd21QAlDMtrIqhxF0EdKaMDJgPX36NPy___ovTJgwQbIYtA_MyytsqSsQkpP59ddex3fvvhvbt26VDBtOKyinKz2WUAcENAhIzvGBcv6PGODCnIlenDwlGyMHOOF22aysFtY69TqQi0HjNXqjWZeDdXG0XxdSasUvj2rJWLNiYwve_LQJH21oRVmVH3USyOGRuiyHcyrrtaZlXeZOysDtFxRj9BA3AlLSaE2ZDTc-VIM9uysi7r72r6B4AM790pdx1iWXRpyHEymQSIGJ-ZmJXD3XTQEKUIACFKAABShAAQpQgAIUoAAFEirAwI2E8nLlFKAABShAAQpQoPsCAb8fLz35BF7442PYvXPnYa1Q4xM0AEMzaZw0OQszrMwaHgwscsIhgRqmDAAnO0CjqztijVlraQeJqwhIEMfGnX6s2tqKf65psrJx1LdqORUt9aJzdq0F_AGMGjMaN996K04__TS4PZ6urYBzJ1WgpaUFDz34IP73dw-hrr5BAhQ00if-ptklwiEDLhfkWsjEvMkZOGZsBsYPdsEpQU2Q6yFdKoO0BXQYmiwEldUBrN7Wivel5MnfVzRg-56gBGK1J-2In0fjWLRii1Ua5uazC7HgmCys3iGBG79j4EYXGDlrkgUYuJFkcG6OAhSgAAUoQAEKUIACFKAABShAgR4VYKmUHuXkyihAAQpQgAIUoEDPCjQ3NeJvSx_FC3_-E-r2VlshCfF-4V8HnjUYw2Y3MXaQG2cfn4O5MkA9dpAHbq-M8srAdVgiOtKlFILut6npDmS_HBLAMWGUx3qccWwWPivz46_vNeAfK-tRVS95FGQe3W8pihLXAXG6nNi0YQO-9527UVm5B0suvRQZGRlxLcuZkivg8_nw_XvuwZ-WLkVQAiziD9owYSVYkUgHzTgzQ8qgXDo3F5Ml60xhXvs_i6QsSNgqAZTcferO1vQaN9ujrkryXVggmUJOnpyNC07MwetrmvHs8npsqmi1AlU0k43GPnXWdBZTIjfW7_Dhnj9VoMUXxrCBuZ0txtcpQAEKUIACFKAABShAAQpQgAIUoAAFKECBwxRgxo3DhONiFKAABShAAQpQINEC9bU1eOLB3-DNF55HY0N9lzYnCSTgdRuYNNwjARtZOPXoLJTkt5WS0OCHVM-u0ZWdtbWXVQnJIP6mXX48s7wOr6xoxOZdgiAZODTII94WCobg8rhxy8034_Irv4TMTKbej9cuGfM1Nzfj3u9-D0sffUQCc-IvjRKWE94fNDAgx5DsEdm4eHaeXBtuOKU0kKaX0HI7falZWTjkvNdrvao-iJc-bMTT79Tj020tCIiDswvh-_q3IifDhpOmFuHDrQZ272KplL50rvSlfWHGjb50NLkvFKAABShAAQpQgAIUoAAFKECB_ifAwI3-d8y5xxSgAAUoQAEKpIFAXU01Hr3_53j71ZfR0tgUd481o4AO2h4j2SguOikXpxyVjfwcu3zbvm8NTEcDsYI4ZMB6e4Ufz71bjyf-VYddNUExiT_7hg7iu9xOXH3NNbjuhhuQlZUVbXOcnkSBuro63HXHHXju2eck4MIZ95b1msj2GFg4PQcXnpiLo8dIGRy5RsKhuFeR1jNaYUtSDqmuISQZaRrxh9dqsVbKqcSbfUN3XkvLGHBIaRk7_FK6KVLTvzsFxQNw7pe-jLMuuTTSLJxGgYQKMHAjobxceZoJ6N9qfVRXV6dZz_tvdw15Ix06dGivAIRCIehj165dcs9s3Tn0Sj-40fgFNNvakCFDJPOc1MTrhabnS1lZGc-XXrA_nE3q-TJw4EA4HA4pLarfekh-27Fjx74sgcnfOrfYVYGCggL5t5_LenR1Wc5PAQpQgALdE-jCd626tyEuTQEKUIACFKAABSgQn4C_1YdnH_kD3n3jtbiDNqyyKLL6QYVOLJmdg4VSFmWIlEzQj_L6S9CG6qoDJPBiWKkLNy4sxLzJWXjkjVq8-GE9mlrD8kGVjtnH_kDaJoEfvlY_Hn7of5Hh9eKKq65i5g3F7cXm9_vwg3vuxbNPPwOnfIAUTwvJeaCDD1MkiOnWxcWYdoQHXskcYfo1DKH_NGtfJXArL8uG8-bk4rgxXiuo6ZHXq1HbaLZdE7EvifZrJiSDgP0k2qX_nB7cUwpQoA8KLFu2DPff92PU1jegKM_dB_ewb-6SaRqorvNh_vyTcdt_fitpg6vr16-Xe6y7saN8NwYVZUhZOb2ZZkt1Abv8o2ZXVTMmHTke3__hT-GVf7Mko1VVVUn2u7vwydrPMJDnSzLIe2Qber6Uy_kyZGAJ_vvH96G0tLRH1tvZSrTE5f0__wlee-0NFOS6rS9TdLYMX08NgapaH_JysvGtO-_G1KlTU6NT7AUFKECBfiLAjBv95EBzNylAAQpQgAIUSA-BgHw7cplk2Xj4Jz9CXU1NXJ0OyFiqfBEeM8dn4j_OKsCU0V753ehz5R_iwthvJqtCijj4_GH85Z0GPPRKNdbv9EuJDRms7iR4Q1ejZVO8mV7c9Z27ccGFX7C-obTf6vk0SQJhGUD46Y9-jF_-4n75VmHn3xLTsIxgyECRBirMysV1pxegMFfi1eWbZhyLkOpBck0EAiY-2NCCB16owrK1zVaaHns3v3ynX9Blxo0kXRTcTEQBZtyIyMKJ_UzgL395Fr_65f345fW5GDOI39VKt8Pf2GLikh_uRUNzGK-__nrC7z03bdqEK6-8EvdckYeZE1zo7r1Aunmne399cj_3q78146_vNOGZZ55BUVFRQneppaUFp512Gq5YkI0lcz1wOzuJ_E1ob7jyrgpoFsJ_rvHhu0vr8MADD2DSpEldXUWX5td_w82dO9f6bOLeL2Yhy8vzpUuAKTDzhp1BXPM_1bjttluwePG5KdAjdoECFKBA_xCw33D7t-_uH7vKvaQABShAAQpQgAKpLaApTD_5-EM8_9ij2LF5c1yd1aCNgfl2XDGvADcvLsC4IW4JSrDGqONavi_PpJkGTPmAyi4jypMk68LkkR40NoewrTIo6aDbSsrE2n9NI-v3-aHfRDz2uGMxoKSE6YBjgSXotWeefho__uGPZO1Gp98-1aAN_cbquIEufPPCAfjygnxkuG1WwIZcXmwioA4a1DR0gAsnjMtAQLJxbNrthy_QNv1wkTRww5uZiQlTj8G4yUcd7mq4HAUOW2CAN75sPIe9AS5IgRQX0DIXt956Gx77RgGGDWDQRoofrojdc8lA-JK5GdhUYcfG7TWYNu34iPP1xEQtpXPxRRfix1_OxYzxLuveoCfWy3UkT8AhwbgacAPDjmf-vhKnnX5mQjd--9dvxvRRTbh-YQZ022zpJaD3_yNLHfJ5gQM__O0bOOfc8xNaauc3v_4lmqs34Tc35kD_trGln0Bhjg2nHO3GD373Hk46eT6ys7PTbyfYYwpQgAJpKNDN71Wl4R6zyxSgAAUoQAEKUCBFBcq2bMbrf3kO61au6LSHOviqVQumj_XgB1cMxFcXF0p6Y6c1KNvpwv1whnDQxFTJRPLjqwfixjMLkJdpl1TQMojdSdEMu8OObVu24u67vmPV_dbgGrbkCSx_exm-LyVSdHChs5rremh0nlOmZOO3_zEYC2dkW0dXKqawRRAwBWZgoQPfurgE91xeiuFSWikQjDAjJ1GAAhSgQFoIfPbZZ5h1VB5KJaCXLb0FLpxlx6qPP0joTlRUVKAo34NjxzLoLaHQSVj5RbPdWPPpWglUln_cJKjpuj9Zuw5fOSMjQVvgapMlMHOCftHDj927dyd0k_o37JZzeL4kFDkJKx9S5MDEES6sW7cuCVvjJihAAQpQQAUYuMHzgAIUoAAFKEABCqSAQF31Xrz5wvN4759vSDYIiciI0XQgWh9zJ2XgzosHYM6kTLjkrk6zS7BFFwhLOmGvfNvnhoWF-NZFRRhW7BBHo9PgDafLiZUfr5ByHT9CY2Nj9A3wlR4V2LNnD-695x7skYEFuz32IFRILgid5fK5-fjRVSUYXuqCHm_G2cQ-JPr5vlvcFh6fIwFgJThyuAt-ybzBRgEKUIAC6SewZcsWHDEw9j1k-u1V_-zxWClzs3V7eUJ3frNk9ztiiCeh2-DKkyPgdUuJwHwvyssTd85oRp_CPC90W2zpL6DXvr5nJLJt21GOMQOZ_SmRxsla9zi5t0j0-ZKsfeF2KEABCqSDAAM30uEosY8UoAAFKEABCvRpgWAwiI-Wv43lr_0DLU1NMfdVB6I1zekZx2bh2xcNwKRhHikgIRPlP7bOBXSgWks6XHBCLr6zZABGFEuWEkswNqBNogJe_NsLeEPqjevxYkusQCAQwMMP_S9WrVwJt9vdycZMOB0GvjgvH9-4oAh5WXaEpfwHW3wC1t8U-d-0IzLxvctKcPQYNzNvxEfHuShAAQqklICWeAtpOjG2tBdIRuCpBsWGEpihIe0PQprtQEjufTsLdO7OLvHvS3f0Um9Zfa_QY5rIpn_H-C-yRAonb91BOV86y36ZvN5wSxSgAAX6vkBi36H7vh_3kAIUoAAFKEABCnRbYOPaT_DW319E-bZtMdelWTb089VzZ-Tg9i8UY_xgtxWEEHMhvniIgPUhkljOOzobd186AMO1xExb-Msh83ZMsEm0TEtLKx74xS-xs6xMMjnwY6gOm0T8fOedd_CHhx_uNGhDj4PdbsM1p0rQxnlF8ErqGQZtHN4RsclVcPToDNz7xVIcP84Dn__w1sOlKEABClCAAhSgAAUoQAEKUIACFKAABShAga4LMHCj62ZcggIUoAAFKEABCvSYQFNjA1a9_x42fPJpp0EYWgpl3tRMXHt6PoZJsEFYIznYDkvACt6QUhonTc7Et75QhMGFjk7LamjJlM_WfYbHHn0Ufj9HtQ8LPo6FWlqacf9996G1tTXmN3vCGrQhATWXnZyHGxYVwiVlcHhNxAEcYxZDTMcP9eD2CyQwbKhTssvEmJkvUYACFKAABShAAQpQgAIUoAAFKEABClCAAj0mwMCNHqPkiihAAQpQgAIUoEDXBDRbwObP1mHNe--hsb42ZuBAQEqWHz3agxvPLMCoEnfMebvWi_47t4a9aDDMKcdk46tnFkqJDcnW0EksjJZMeeapp7Bm1WoJEmA68kScPY8_ulRKpKyKme7ZtHKkGJg5PhNfXViATI-UR-Hh6JHDYZO_S5NGenHLOUUoyJE8HJ1cEz2yUa6EAhSgAAUoQAEKUIACFKAABShAAQpQgAL9XICBG_38BODuU4ACFKAABSjQewINdbV4_803sW7VxzEHRzVoY-QAJ66XoI0Jw70weAfXYwdNB6WV8_xZuThrWg5cDkNCAqKPVGvJlKrKvfjtgw_C5_P1WD-4ojaBXbvK8fjjj1u2seromqaBkSVO3HFhsQQXOFgepYdPIElegrlTsvCV0wshp3zMv089vGmujgIUoAAFKEABClCAAhSgAAUoQAEKUIAC_VKAH_v3y8POnaYABShAAQpQIBUENq1bh_VrViEYiF6PICRZBDwuA5eelIdpkl1AAwvYelZAMzU47cC1Z-Tj2NFeGaiObWyz2fDRhx9h3adrmXWjZw8Flr-9DBvWr4fT6Yy6Zg2ryfbY8LWzi3DEUBfCweiBNlFXwhc6FciwGzhnZg7OnpHNkimdanEGClCAAhSgAAUoQAEKUIACFKAABShAAQp0T4CBG93z49IUoAAFKEABClDgsARampqw4dM12LF5c6fLnygBGydPzUSum1997xTrMGcIS1aTwYVOXHNGHoqyHZCEDlGb3WFHxa7deOutt-D3-aPOxxe6JtBQX4-_PPcXa6FY2TZ8gTDOPj4Hpx2TZZW66dpWOHe8Alp5pijPgSUSNDa42ImgXCNsFKAABShAAQpQgAIUoAAFKEABClCAAhSgQGIEGLiRGFeulQIUoAAFKEABCsQU2LjuU6x-7100NTZEnS8siQQKc-y4eE4uhhU5YxTwiLoKvtAFAVNGqmdNyMKi6dlwStaNWCVTnG4nnn7qKewo2yFlJJjxoQvMUWd99913rWAYl8sVdZ5gyERpvhNL5ubBLVk3SB-VqkdeMOSP0BHDPFgs14RdstJ0dqaHJX1NKBjokW1zJRSgAAUoQAEKUIACFKAABShAAQpQgAIU6E8CDNzoT0eb-0oBClCAAhSgQEoI-H0-7NiyGeU7diBWVQ4t4XHKlExMGu6BQ8oWpF6TYVyNdrAeUu4lrA8ZtI34aH_dlJ-mfHXfWqazYeDk7rEGATikLM05M3IwqECybkjajWg9tMso9rYtW_HOsuVSRkL2ia3bAk_9-Uk5LTTPQ_Smx-iUKVmYMNwNMyVLpEgHrXNbz_H2cz7i9aDXyUHXBHTfo51x0U0S_YqWTDnvhGwJHnN1GihjSqCH39ea6C5x_RSgAAUoQAEKUIACFKAABShAAQpQgAIU6HMCjj63R9whClCAAhSgAAUokOICjXX1KNu8BXXV1VF7GpJx3yFSnmDB1CwUSdaN3mk6iKwD0e2D0dZz7YkMMBsS_2uTzAgOb9tPfW6TW0udbmh_JdBEn-sgts5vDWbrTxmsDkl5kbBPfsojLM-teXR-DU7R5dt_WuuQSUls2r0jhroxZ1Imyt-qQyCk_df-HNpsErzxrzffxBcuuhBOp_PQGTglboGqqiqs-Phj2Gxy_KM0zUBTku_A5SfnyTkj_8mjV5p1vnZcE3pOt_di3zXh0QggOW300XFN6Hmt-ybnktVxDezQhyxsBXa0XxNBvSbkYa2041qQZfSa2HddJHevdbODCl1W8MZPn9lrXebReuD3-1C9pxL-1la4POLARgEKUIACFKAABShAAQpQgAIUoAAFKEABCsQlwMCNuJg4EwUoQAEKUIACFOg5gb2VFdhTXiYlBfxRB58DUhJi7qQMHDnCC6fcsSVukLpj4LkjQEEHiCXwQkdrNRjDVQhklsJwFwPufMAjv7uKZGA6A7DL6xqsofPpALVtv4ANGaA2ZB1WuREraEMHuvUhg9WaacDUgI32II5AI9AqQSz-Gpi-yrbnLbsAX1XboLY1MN4-0G0FUUjf9Kc1kN1zx0XXpGVPnE4Dpx-XhX992ohtldbGI25EgwxWrlyB3bt2YcTIkdb-RpyREzsVePP111FfXx_TUE-fWUdmYuJIj5xC0Y9LpxvrbAbrYtPrQbeh55kGXLQHUdglGMEzAMgota4NQ68Hd4E8l4cGMdklgEcDNqzrQp-3B2voz47nBwR-yDas60CuBSuISc5zDWgKSAkl317rYfpq5KdcF816Tchznd-6lrSP7f3sWLd1fcjkHm4el03-HmXiqWV12F4ZhF1366CmXWptbsLWDRtQsascQ0eOOmgO_koBClCAAhSgAAUoQAEKUIACFKAABShAAQpEE2DgRjQZTqcABShAAQpQgAIJENCyGju2bEH59u1R166ZBQqy7ZgsJVKyM2z7vtAfdYEuvaADxTLYq8ET2pwSgOHIkUcm4C0BsiUAIXMYkDXU-t2wy-sakGEFc2hgRteahljE30wYVpCHBneEJcZDAjpa9gBN5TCbtgJ1myS4QwawA00ygF0nA9zyU4M3NGgE2sf4txRrTjNg4pjRXowocaNsb1C7ErU1NDRi-fJ3MGToUGbdiKrU-QtvvfUWWpqb4XRJ0EOUpof6rOnZcm7IOdyjTa8JDZxoP9DOLAnEyJVrQn56BwK5o9uuCe8g-X2AXAru9utBgzG6fk10teuGlZlDr4kgTD33W3fLNbEdZsMWoGFbW1BHsFmuDb0mWmT10ifJBmP97OrGosxvM0wMklIps47MwB9erYPXHfli08Cn-toa7Ja_bwzciILJyRSgAAUoQAEKUIACFKAABShAAQpQgAIUiCDAwI0IKJxEAQpQgAIUoAAFEiWgJQTKt25GpXwj3fpif4QN6bj04AIHxg52w-uUweFoM0ZYNvokGZTW-is2GXB1S8aMzMGSNWAwjJwxEqwh34yXYA3DJQEcPRX9EL0jMV6RvnUEiOiYuEOyG2hf8460emUN12vARkuZBHFshFm_UZ5LFgIZxEarZCfQoA9DsxxEHlSOseEDXtLtuBw2zJ6YgY83tqCxNXLkhm7G1-rDu--8g_MvOJ-BGwcoxv9LbU0NNkmWBuv4RllMK9aMLnViygg5J2LNGGX5iJOtICENYJIghwwJysgcKo9BMLLHyjUh10WWXB92yaLR223fNeGSa0ICqbyS_SZ_cvuVKjltWiRbTfNWoH6zBHNskOtBronmcgnkkOn7Apu6eU2YBjKzbDh6lBdPuuuhCU_0T0mk1lBXhw1rP8HUmSfEDMSJtCynUYACFKAABShAAQpQgAIUoAAFKEABClCgvwowcKO_HnnuNwUoQAEKUIACvSJQX1uLqt274PdJOYQITcekJWYAU2WAtKTQIYOzhztKLSPdHYtqxgzvUBgFU4HCKW1BGppdQ0s79GqgRgSAGJOscWK3ZELQR97Etp5LBgJTS6o07wCqVsKsel-COOR3MyAPBdAIkCgjzDG2pcuefFQm_vBabdTADV08LMEw27Zus7JFeDwSVMDWZYHtkp1h9-4KSRKhWSIiN38gjDOPzUZelv3w45is80GDcOSc0JImXgnMKJkpQRBHyXMpB-SRICHNppFWTUoSeaVciz4Kj237exGol2AOuQYaNsGsXgHsXdUW2KRlVSRzhrX_Xb7uTUjYCCZKFqChA5zYWB6wqsEcTKXELU2N2L5xA_x-HwM3Dgbi7xSgAAUoQAEKUIACFKAABShAAQpQgAIUiCLAwI0oMJxMAQpQgAIUoAAFEiFQV70XdTXyTfhoTQY-HQ4D44a6kO2WgWwdZ-1Sk8HZkAQtaFCGlnkoPArGgBNg5I6TNBJSZkIHrftSc2ZKkg0p85I1HCiWQfjgFZKNQ7I3VPwLqJYB65YK8ZAyElYmjq7te4EECYwtdWFXdUCqaOiBODQAxCbBBnX1dajcU4m8_HyJETl0nr7EnYh9qaysRI1k3Yhlp6xHStCAzWUg7O_iRWGVQZFsM5pRRq-JoukwSk-U8idyzmhWlwjHNRH7mZx1CpQzV053CW7KkRIvg-ZJ5o0GmDWrYe5-S66Nz-SakPJDYb8Eqeg_BeO_JgyJyigucKI4x4ENZfI3JkoL-P3YW7kHLY1NkqVD_-awUYACFKAABShAAQpQgAIUoAAFKEABClCAAp0JMHCjMyG-TgEKUIACFKAABXpQQIM2aiV4I1Zz2g2MLHZJmZRYcx38mgxmh6Tsg2ajKJwAo-g4oEQCNrwDZMb4B2cPXmta_S4lJQynDBQXHSP7fwxMLRchGTjMPR8CMnCNUKPsjpZS6XyvNDTALWVqxg504e11zQhJBE2kxQybDVYWFQk-GD12TMysEZ1vtX_OsWvXLjQ1NSErKysigJZJKZJggdJ8-adLl2I2ZOawBBi4JRtFkWSj0GtCgzZcco30l2aImVsCikpPkuwis2E27WgLapLsNKiVIA6zPagp4tl9IJJeAU4JKhsuGTfeX99y4IsH_dba0oKqit0oKi096BX-SgEKUIACFKAABShAAQpQgAIUoAAFKEABCkQSYOBGJBVOowAFKEABClCAAgkSqN27F7V7o2fc0HHp3Ew7CmWg2m6LFCpwcMdkVFvrE7hkcHrITBgDT5bsGuPTsOTDwfvV_d-NjEHAsHNgDD4DZv1GoPw1CeJ4WzIQ1LQHAEhASxRiJXW7bDhiqFuOAxCQhA2Rmk0CN2qqq1Eu5W9MXYitSwLBYBCbNm6EOkZroZCJgQXtgRtyunfazPaZ5Pgbg-YDA2bByBnV6WJ9fgbDBkMy0xhZl8t1cR5Mzb6x6w3JxPEvyVTTJPFdegyiHwe9aJzyN2nCUI8ENTXAH5RQjijXT2tzM8p3bMf4KVKeiY0CFKAABShAAQpQgAIUoAAFKEABClCAAhToVICBG50ScQYKUIACFKAABSjQMwJaQqCxrg76bfSoTcb-B-TakOWJNYCqS8vgdFgemk2gZAaMIYvaBqf1G_ZsBwrY3TDyJwJ5Ui5m6EKYW58EKj-QaAwN4IiRgUMq1QwuciJTjkWrlueIMEitA9e-Vh-qKqtg6vFg65JAswzw7ywri5mpJCQBMSW5DiuYCVbJmmibkGMUlqwzGZLloWQObMPPl9IoRTJzhAMXbRX9ZbqWGJIsJCiYLCf5ApjbngX2rpAAjnrh0lQ_kc2chokRJS64JPOGBm5Ea36fD9UVUqaIjQIUoAAFKEABClCAAhSgAAUoQAEKUIACFIhLgJ_sx8XEmShAAQpQgAIUoED3Bfx-H3wyoBnuyAgQZZWZHjtczsgDp22LSICAKYEdWhJkxAUwCo5iho0olgdMlqAWI2c0MPl2YM-7Mlj9TFsJFc2UESl1gEzOcBvI8hqo0vHsA1a23y-ybFNTY9eqeOy3eH9-qhk3GhsbhT-qrhWrkSHBM045FmYgSrCAKSlRbC5g0FwYwxdLkI4E6rB1LiBmRsEUGHnjYe56W66Jp4F6ycRhBYAdekxscpzyM23Qn7FaSI5rS7Nk8WCjAAUoQAEKUIACFKAABShAAQpQgAIUoAAF4hJg4EZcTJyJAhSgAAUoQAEKdF9AM274fa1tmTKirE6Hpd0StOGIeJcmr5qaUWAIjGGLpSyKlIFw50VZEydHE7CCBEqkrIxk4QiX_Q3QbAP-2rZgmP3Ho4XbLXVSvE4JklF6yTZgRAjf0DIfTU3NkgCFGTeimUeb3ha40RSzVIrGCHjdcgzsErihmU8ObhoIlSnXxOjLYJTOlQCOiBfPwUvx9_0FbJKVZvA8ycAhAS87XoC5Q66LYIPMIWln9mt6eWhgWYzKNtbcoXAIvliZhfZbJ59SgAIUoAAFKEABClCAAhSgAAUoQAEKUIACAD_V5FlAAQpQgAIUoAAFkiQQDAStjBua4CFWc0sZAodt_wgCnVsjByRoI3cCbGOuBAoly4ZmGGA7fAFXDmwjL4GZPRrm-v8FGreIsQQI7EfvkrtljwRumDJtv8kHbFMDQbTkhwYhsHVNQM2ammJnZnCIb7a3LXjmwLXrNSGPQsk8M_56GNkjDnyZv3VRQMKSvFJmZszlQPYYmJ__FmgtlxP_wL8zHpcGlkkQjaw92jURDoVil4TqYs84OwUoQAEKUIACFKAABShAAQpQgAIUoAAF-roAAzf6-hHm_lGAAhSgAAUokDICwWDAyrjRWWYGLZPikEwPBzYZJi04FsbYK6UMxDgZMT3wm_AHzsvf4haQoACj-HjAlQvz0_sleGOjZERpj9IQcj0WbpcNkmwj6ii1Dl63tDDjRtzm-80YDptW0Eu0UinKbpdTPUtKpURsAyRzyoT_kICD4ogvc-JhCGj5lJITJMTfA_Oz3wFNW-Tc__c_GzUDSqaUramMsepwKAyflIYyJbAm2rGNsThfogAFKEABClCAAhSgAAUoQAEKUIACFKBAvxP49ydw_W7XucMUoAAFKEABClAguQKhQAChYKjTkhp2ybahg6P7mhmQ4IITYRxxpXwTfqRM3v_FfXPxSTcEjNzxwKRbYX7yM6Bhk5XgRFdnk2OhyU9ixG3AJpEFdTV7sXvbZ_AX5bdlgehGX_rLojabHZU7t6O5qTF6qRSBt8nF4JQyKdZB2B-nZBaMI2-ShBC5-0_l854QsDlhFB0HY6IX4XW_bLsm2oM39HrQv1GxmgZshCWbigap2TXyho0CFKAABShAAQpQgAIUoAAFKEABClCAAhSIKcDAjZg8fJECFKAABShAAQr0rIAOaHbWdJZ9s2l5lKxRMEZ-QX4Ol0VjD5h2tm6-Hl3AyBkDjLtWgjd-IiUi2vIJ6NHadyyiLOp0OfHuO-_joiVXWUEGUWbj5AgCOrCvZWaiZmXQeI0wIPFO_27hAJA_Bca46xi08W-Vnn-mWX3yJlhZfsw1P5aDUC_bsEOSpCCk_4ujmTof4zbikOIsFKAABShAAQpQgAIUoAAFKEABClCAAv1dgIEb_f0M4P5TgAIUoAAFKJByAuH9IwUcmTCGniGZNkZJzAZHQBN9sIyCyTCHnAls_qNEDAQkY0DngRvap2AohPr6JnkW34B2ovcjndYfNWijfSdMMQ11XBP60-6BMepiKY8yIJ12Mz37qpk39JoonQuU_c3aBw0dC8p1EVc7IHVQXEtwJgpQgAIUoAAFKEABClCAAhSgAAUoQAEK9EsBBm70y8POnaYABShAAQpQoDcEnG433B63VRZi_wQCB_fFHzAlEKBtZNQomCplUmYAzqyDZ-PviRCQ4BjboAUIV74HNH6GgIxQt8rxiCfRSdsYNTOi9ORhUc1AyERdk1wP-kvYDwyYIWU8ju3JzXBdsQQkeMw24lyEqz8CmsrR7DfR6jNjXhJaYsjpdEmZFFusNfM1ClCAAhSgAAUoQAEKUIACFKAABShAAQpQoF2An6TxVKAABShAAQpQgAJJEnB7PMjIyo45mKlj05UNITS16kC1xNgWHwe48pPUQ27GEvAWS4mI8YDDgerGMCprA1LKQ-MG9OiwJVtAk2zsqPTD1xSCzZUFY8CJgI3x58k7DnLeuwusADINKNu8y48Wf-yUG3anE1m5edFL4CSv89wSBShAAQpQgAIUoAAFKEABClCAAhSgAAXSQoCBG2lxmNhJClCAAhSgAAX6gkBGZhaysnNkzDnGoLOMke6pCaChKQB4B0k5iMFSGsLVF3Y_rfbByBkn7jkoqwqgWgIGDJZA6bXj55DsDeU1QeyRABp4coDCqb3Wl367YZv8DcqfjEDYxLoyHzQrUKw4JpfLjbzCgn7LxR2nAAUoQAEKUIACFKAABShAAQpQgAIUoEBXBRi40VUxzk8BClCAAhSgAAUOU8DpcslgZiGysmTwOUrTnA57G8KoqPMh6JBMG67_z959AMZR3Hsc_6n3Lrn3XnHBhWYwvfcWklBDTUhCDwQIIdQk9FCT0DumBzDV4A7G3ca9N9lWs4pldb2ZM-bJRne6O-3qVL773ubudmf_M_PZXSFr_zeTZLbwK5sXLtc2h8W1U0V1rH5YV64fZ61xrS4C-xaIiAjThpxKM-pGuZkyKM4kb5gRUViaViAsXGExKSoPS9TCtTs90wf5Gn8mLi5OHbt2a9o2UhsCCCCAAAIIIIAAAggggAACCCCAAAItWICnAC345NF0BBBAAAEEEGh5AulZ7ZSe5ePBs3kaWmamIZi6uFQF5eZXtbAIs_p6RNryDFpEi80oJ9uLavXND8UmcaOWaVJCeNLMgBsqNVMHfTZ3p6oqTAKBSSJgaWIBcw6qzM-ilVtqtWRDeYM_kmITEtS5R48mbiTVIYAAAggggAACCCCAAAIIIIAAAggg0HIF-Ktnyz13tBwBBBBAAAEEWqBA-06dlNXZTH_iZbEpGlU10oylu7Q5O081VbvMFrOBpWkFqnbos9k52pJXrdpaMy0ES0gFYqLC9PH3xdq4tUiqLg1pW9pk5eYeKCvdqZkLs7XJ3BMRPv4VGRkVqcz2Hc3aoU1S0WkEEEAAAQQQQAABBBBAAAEEEEAAAQSCEfDxJ7dgwnEMAggggAACCCCAgC-B9Hbt1bVnbyUkJXotZkcYWLO9Rt_NXq7CHVuk2kqvZdnhjsC2tYs1ccZm7TKjn7CEXsAOOpNTXK2XPtso7VgY-ga1sRZUV1Vo3ZKF-vDbfEWaH1DeBgGy25NS0jR4_1GKjU9oY0p0FwEEEEAAAQQQQAABBBBAAAEEEEAAgeAFIoM_lCMRQAABBBBAAAEEAhWIjolRz_791bFrD61eutiM5vDzCPbhZ0WV9N7UrRo8aooOyByi6KROPy_IFlcEairz9cI7U7R0XaFqzAkyj6m91hMREanTLrhQfQYMNmVJ8vAK5WNHZFSUvnr_Xc2aOtlHKZlRHsL17pSNGvfJBzri_LGmrPfz4jMQOwMWKCnO1ytvvq-1W2sUEenbPTk1VX2HDFFkJP_UDBiaAxBAAAEEEEAAAQQQQAABBBBAAAEE2qwAf01rs6eejiOAAAIIIIBAKATCzcPnrj17qXufPlq7fKmqq6vrbUZkhLQ8u1qvTZiobr2HqMfIk6RI76N01BuEjUEI1Orbz9_RR59_r12VtbKjn_ha7Hk84-LfKDEp2Vcx9jUgkNmxoxbOna2ynTu9lrTnIr8kTA__92Ptf-hJSul-sNey7HBOoKy0WF-897Le_3KRwiO83xA24Sw6Jtb8vOrj-RnnXAuIhAACCCCAAAIIIIAAAggggAACCCCAQOsXYKqU1n-O6SECCCCAAAIINDOBrA4d1X_IfkrLyvI65YBtcpR5SPrlnFw9--8nlL30C6na-0PtZtbFFtqcSi2b8pIeeOQZZeeW_nhufDyoNiM-HHv2OYqJjWuh_W0-ze4zcJBGHnBQg2NoxERHaMGqfP31L3eocN205tOBVtqSivISTfv0Fd374LMqN4lM3qZIsd23owclpiR7pklJSUtvpSJ0CwEEEEAAAQQQQAABBBBAAAEEEEAAAXcESNxwx5WoCCCAAAIIIICAVwE7NUSfIUNlH1Y3NN1DTW243vhyvf714ANaNf0lVe_aYo5hSg6vuEHuqC3P0eQJ_9T1tz2gBStyVGv-z9cUKXZfn6FDNdwkGzAlRJDo-xx2yq_PV4S5Nxpaok2Z_32zUtddf6PWfPeayRggoakhs4D3m2l_inLX6O3_3Kubb39QBcWViojw_U_HyOgo9ew3QKMPHR9wdRyAAAIIIIAAAggggAACCCCAAAIIIIBAWxdgqpS2fgXQfwQQQAABBBAIiUCPfv006pDDtHrZUuVkZ3ttg5lZRTW1EXr9q81atu5hXXjG9zripHOU1G2smTol1RznfUQIr0HZ8f8C1TnatOw7_e_NV_TcO98rt7ha4WZODl9JG_Zgm6xx7BlnKaNdezMKAefg_0GDf9drwCAdeepp-vydt83oDWb4Bh9LrTH_atYWrf7dHfr9xd_pyJPPU2q3_cwR8T6OYlfDAjWqKtumhd9N0cvPPasPv16q2rDIBpM27C2QntlOBx9zvDLbt2-4GkoggAACCCCAAAIIIIAAAggggAACCCCAwF4CJG7sxcEHBBBAAAEEEECgaQQiIiI0_KCDtWbZEn3-_ruqqqz0WrF9KBphpk2Zs8pM5fHIFxr72RydetRgHXbYoUrrM97MT9BbCm94pAKvFbS1HbXGunCFNi35Wm--P0lfTFmsZZvLTMJGuCJM0kZDi03qGDJqtMYcepii_BghoqF47N8tEBMbq1N-dYHmTJuivG3bfSZv2HMQae6JddsrddP972j4O5N0zGEjdebpxyizzziTv9EN1kAEastVsX2Jpn39sd77eJpmzVuhzXmViomOVIO3hLll4hKTNNL8PDvw8CMCqZWyCCCAAAIIIIAAAggggAACCCCAAAIIIPCjAIkbXAoIIIAAAggggECIBLI6dNChJ5yozRs2aOGsmeZBte-GRJnf3HZVRerrhTv03dKp6jlhjo4a9ZoOHt1f3fqPVlrX4YrJNA-so5JNoDizNpyE4LvG1rDXou6SyktUtH2tCjfO18LZ0_Tlt6v03Q_bta2gXNU1ZkSByPAGR9nYo5Gclq5zL79SiSl2xBMWJwW69Oip0y64WP_9x_1-hY00WQU1tZGavbxQC1Z_pVc-mKkDhrbXEQcM0pDRhyul8xAlZ3SUohNNvBi_Yrb-QuaeqC1VedEO5Zt7YuPSmZo-bYYmz16nlRvyVVxaZRKYohQb4-c_Fc0Prm69euv4c85VXEJC6-ejhwgggAACCCCAAAIIIIAAAggggAACCLgg4Odf41yomZAIIIAAAggggAAC6tV_kA488iht3bhR27M3NZi8EWGmTjHDa6i8OlxLN1Voycb1evzD9eqdNUkjesdr5JDO6tazv9I79VFW-x5Kad9BEYlpZm6PJDNsh03oiDVra03oKJWqS6TKIpUXFGj7ts3K27peedmrtWLpYs1enK35a8uUX1Jjpn8wimYok_DwSNmH__4uUVHROvs3l6rP4CFmFJQIfw-jXAACx5_9C61YsEBTP__U56gbe0J6zmNUhGrNfbE5r0ITvt6gCV-tV1riZ557Ysx-PdWz31Clte-pzI5d1cEkTMWb5BvF2vvBJnRE7wnVyl5_TFqqKlJFUYFytudpW_YW5Wav1bbNK7R40VJ9uyhb63OrPUlLdmSfsLBwRUcH5pGUnKKjTjtDPfr2b2V-dAcBBBBAAAEEEEAAAQQQQAABBBBAAIGmEyBxo-msqQkBBBBAAAEEEPiZQExcrMYdd7x2lZTog9de0o7cvJ-VqW_D7oesdo8nk0Mrt9ZoyeYivTZ1h5JjlyjVfPE9PSFcGemJyspIVcd2GcrISFZaaooy01OV1S5T6WmpikvKUExcsiKizQHRJrkjMt4keJjROuwaaUcoCOGvi3ZKk-ryH9ddqq0sUXVZsaoqSlVWWqjiwnwVGK8t23OVm1eogh2FysvboW25O1SQv0O5BUUq2FmjHSVhKjWJLtF2KhTTnYjd2S_1sfrcZtM7zrjwYh1zxtmKCvDhts_A7NxLIDIyUlfccpt2le7U7GlT_UresAHs9Cn2vrCJHPa2KNxVqy8XlGri7IWKipinFJOzlJEcoXaZaUpOTVVysrkfzL2QnpKkduYe6dy5vblHMpSYlKb4pGRFxSQqKs6sMQkK99wX5n6IMGtYCBN2auw9UaaaqjJVlu_0rBWlRSrbVaKdxUXm-s_Rtm152pydqxxzLxQUFqnUbC8qLlS-uS-2FRSrwOY21dipZqIUaUaaiWxEAlJsQryOO-tcHX7iyXudQz4ggAACCCCAAAIIIIAAAggggAACCCCAQGACIfxLfGANpTQCCCCAAAIIINBaBRLNQ-IjTj5V5eXlmjjhTRUV5DU48sa-FvbZq01IqK0NV6l5truzoFZm1gPVrisyo0oUKip8vXlAW2NWk4phRpiINPOuRJkH5BEmkyHMjDoRZpIa4szUCLExUYqJNkkOpmC4CRodHam42HizLVrRZl90TIyiomI8o03YY-zD8vDwCHO8TWsIM4kR5r3d9uPDYM_0LzU1ZjqSajOlhRnpwmyoMZ9rq2s8r9VmW01lhSqqqlRRXqEyY1BWVq7SXebBdEWVqsxxFRXV2mXWCvO5xnyuteue46qrTblKU65WVVVh5jXM81A63IwcsLtdEaatYUpo5G-9tk-Hn3KqTjOJGzbZhsVdgcSUFF32p1tNcs5NWr5ooee6CbRGm8BhLl-zRprROCJVUlWrIpMXtXr7DnMd5Zskj1pzX9Sa68O8mnsnxoymEmFG7ogw5e1ILLuvH3ON20QNcz3ZrBDPiBQx0UqIi1NMbIy5Z8x9EWvWSHusOcZz3dnEkd3XX7g5NtzcG-H2XrGvZr-9_j3XcXWt7PVvr-Vqcx3be6La3B_2Xqky13R5RYV2mXuhrMzcH-Z9WWmpZ5-5q83_m-P23Af22Fpzr9jjKytVUWnuJbNWmf7a-6HWtttkskTYNkXEmqQjY2Jv18Ys5vjY2Dgde9pZOvOSS83Pk6jGRONYBBBAAAEEEEAAAQQQQAABBBBAAAEE2rxAI_-E3eb9AEAAAQQQQAABBBwRSM3M1Im_OM98uz9an7zxuvJztpmHsYGHtoMNmDwFs5jkDPtiMzXMYkOZ57jmYa7no2or7Eb74ccNnhK799n__anqn7_5_0KuvPvxibJ5-fHdPrXU2fpTGfvQ2HywSSl23eeIxny0j7yjzAP6E84-V7-44reKSzAjk7A0iUD7zp11_X3_0NP33a2506cFlbyxp6H2qokwiROeu8GTVLT7vrD77SVeYRJ_KsprVVtu7gfPfWH32OWnG2D3x33-1yYiubnY68_LjVCnWts7s3iKenpq3kfI5JI4ei_srmT3_8YnJpp74hc6-9IrFGuSWFgQQAABBBBAAAEEEEAAAQQQQAABBBBAoHECTv5du3Et4WgEEEAAAQQQQKCNCySnpunEc85Tl-499PzDD2jrpk2OiXge7f74fNcG3f25zoaGnw471paWEsg-NO_QtavOufwqHWqms7FTeLA0rUC7Tp11w33_1KcT3tIb_31aFWbUCadTJereC7vf1-1j3Xuk7va2-d6OGtKjT1-dd-XV2n_codwTbfMyoNcIIIAAAggggAACCCCAAAIIIIAAAi4I8NdnF1AJiQACCCCAAAIIBCtgR3QYM_4IpWVkacJz_9Gi779TeVmZCWdGA3D6iXWwjWzFx-1-TB-m-JRkHTj-cJ306_PVtUdvHlCH8Jzb0R3OuPgS9RwwQG8-86RWLF6oGjPNiP0_liYQMDeFnRQpJSNDYw8_QqdfcLE6dOnaBBVTBQIIIIAAAggggAACCCCAAAIIIIAAAm1HgMSNtnOu6SkCCCCAAAIItBCB8PBw9R82TNfec59mfPG5vvnkY600D6srystND0jgcOs02hE24pIStd-o0Tr5V-drwNBhZroJM98ES7MQGHHgQRo0cn998e4Es76n9auXm9shjAQOt86OTdgwuTEJickaNX68jjvjHA0YPtyt2oiLAAIIIIAAAggggAACCCCAAAIIIIBAmxYgcaNNn346jwACCCCAAALNWSAhMUlHn36mGYHjcC2ZO1vTv_xC82fOVHHhjubc7BbZtvSsdjrAOB949DEaOGyEokjYaJbnMSYmRied92sdcMTRWjxnlqZMnKj5381UdWVls2xvS21UuJkSpV3nrhprRv-x94VNmGFBAAEEEEAAAQQQQAABBBBAAAEEEEAAAfcESNxwz5bICCCAAAIIIICAIwIpaek68MhjNOKgcSrI2a55387Q7GlTtX7FchXk5nimjTCDRfy4MCLHHol9X-2IGnucIqKilJiU5BlV45BjjlX_4SNkkzciI_n1eF-35vg5s317jT_hZI099Aht3bzRJG98q9nffK31a9eopMgkNu2ZRcW8MqWKlzPouR1-_MFh5mGKjI5SSnqG-u83XAcdeZSG7D9aiSkp3BNe-NiMAAIIIIAAAggggAACCCCAAAIIIICAkwL8ZdpJTWIhgAACCCCAAAIuCsTGxaljt-6e9YRzztOW9es1b8Y0LV-8WLlbt2hHXq5yt29TRVmFacWeJ9e2QW0rmWP3o-jdSRo_PpZWlLHLyMhUZqdO6tKtp3oN6K9B-49Shy5dFRER4eJZI7SbAnGJCerZf4BnPfXXF2jt8mUmsWmmVv2wSPnbtyvfJDrl5-WptrpatSY5wbO0xWQOz-3w053hYYiKjVVW-47K6tRBnbr2UO-BA7Xf2AOU1aGjm6eM2AgggAACCCCAAAIIIIAAAggggAACCCBQjwCJG_WgsAkBBBBAAAEEEGgJAp26d5ddTzSNLSstVWFBvvLMw-q8rVu1ecN6ZW_YYB5eb1NBQZ7yt-WodGeReXjdEnoWfBvjEhKV2a6dMjp2ULsOnU2iRke1Nw-n7WtW-w7KMCujagTv25yPDA8PN8kHgzyrbefOkmIzQk2O8s2oNLnZ2dq4ZrW2btlsRqnJVaHdnp9v7pudzblLDrStVnFmyqX2Hc09YFablJHVsbM6dOqstKwstTPb0s39Eh5O8pID2IRAAAEEEEAAAQQQQAABBBBAAAEEEEAgaAESN4Km40AEEEAAAQQQQKD5CMTGx8uu7Tt38TSqpqZGVZWVnrWyskKVFZUqNQ-ybWJHztZsM51EkXYVF6mkpEQ7i-1aqNLinSorKzVly1VdVa1Kz_EVnvdV1ZWqMduqzcgFdroRz-gFpg77Yc9IBnteA1EJCzMTmJiHxuHh5tW-jwhXeNjuNTo2RjExMbIjA0RHRys6JlYxcfZ9rFIz0pWUkqbktDSlpqcpKTVdaZmZZvqTZNnjoqJs-RhFmilRWNqmQIJJWLBrl569PAD2-iwvK1NV1Y_3RUWFSoqLlZO9xSQ2bVOxuR9Kzf1g75OdRWa1r2Z_-a4yc91Xee6Lmuoac1-Y-6myykxRVGXuDfP6031g7wezmHpsXcHcD_Zwz71gRoGxU_vsvif23B8R5pqOVmxsnKLMte25N8x1HhMfq7i4BKXYeyI5RclmupNUc18kpaYq1XNPpHiOi47efT9wT1hlFgQQQAABBBBAAAEEEEAAAQQQQAABBJqXAIkbzet80BoEEEAAAQQQQMARATv6gE1csOtPS_v26ta7z08feYNAWxKwSRB2uiHJrrsXOwJFz7799nzkFQEEEEAAAQQQQAABBBBAAAEEEEAAAQQQCIlAeEhqpVIEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABkbjBRYAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCIRIgMSNEMFTLQIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAgggQOIG1wACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIBAiARI3QgRPtQgggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAIkbXAMIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggECIBEjcCBE81SKAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAiRucA0ggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIhEiBxI0TwVIsAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCJC4wTWAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAgiESIDEjRDBUy0CCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIEDiBtcAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCAQIgESN0IET7UIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggACJG1wDCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIBAiARI3AgRPNUigAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIkbnANIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACIRIgcSNE8FSLAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAgiQuME1gAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIhEiAxI0QwVMtAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCBA4gbXAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAgggECIBEjdCBE-1CCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAiRtcAwgggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAQIgESNwIETzVIoAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACkRAggAACCCCAAAIIIIAAAgi0TYEduXnKy92u4h0FSs9qp45duykqOrptYtBrBBBAAAEEEEAAAQQQQAABBBBAAAEEQiRA4kaI4KkWAQQQQAABBBBAAAEEEAiFwMY1q_XphLc0Z_pUZW_csFcTwsLClNWxozp376Ee_frruLPPVYfOXfYqwwcEEEAAAQQQQAABBBBAAAEEEEAAAQQQcFaAxA1nPYmGAAIIIIAAAggggAA3rsqhAABAAElEQVQCCDRLATu6xn8f-rumfTpRtbW19bbRbt--ZYtnnTdzhj54-UWNP-lkXfGnWxUbH1_vMWxEAAEEEEAAAQQQQAABBBBAAAEEEEAAgcYJhDfucI5GAAEEEEAAAQQQQAABBBBo7gLLFizQtb88S1MnfuI1aaO-PtTU1GjShx_ohvPP8yRz1FeGbQgggAACCCCAAAIIIIAAAggggAACCCDQOAESNxrnx9EIIIAAAggggAACCCCAQLMWWLl4kW6_4hLl5-QE3U47vco91_xeFeXlQcfgQAQQQAABBBBAAAEEEEAAAQQQQAABBBCoX4DEjfpd2IoAAggggAACCCCAAAIItHiBvO3bdc-1ziRcrFu5XC88_GCLN6EDCCCAAAIIIIAAAggggAACCCCAAAIINDcBEjea2xmhPQgggAACCCCAAAIIIICAQwIvPvKQCnJzHYomff7e29qR51w8xxpGIAQQQAABBBBAAAEEEEAAAQQQQAABBFqwAIkbLfjk0XQEEEAAAQQQQAABBBBAwJvA2hXLNXniR952B7W9sqJCn779VlDHchACCCCAgHsCaWlpyimOdK8CIjeZwPbCGqWnJblan71etu-odrUOgjeNQE2NlLdjl1JTU12r0F4v-UXlsnWxtHyBnKIa2XPq5mJ_huWYn2UsLV_A_m6RkZHR8jtCDxBAAIEWIkDiRgs5UTQTAQQQQAABBBBAAAEEEAhE4PN3JgRS3O-y82fO8LssBRFAAAEEmkagW7duWrqplgerTcPtai1zV1epW_eertbRuXNnZeeWq2QXD1ZdhW6C4Ms3V6ldZroiI91L3IqIiFB7U4eti6VlC9h7fvXGYnXp0sXVjnTv0VML13K9uIrcBMFtsta3y8plf8dgQQABBBBoGgESN5rGmVoQQAABBBBAAAEEEEAAgSYV-H7qFFfqW7nkB1WWV7gSm6AIIIAAAsEJjBgxQr367qe_vV5K8kZwhM3iqM_mlOnR9wp1_Y23uNoeOzrDL391vn77ZIl2lde6WhfB3RNYv71aV_0rX3--_U5FRUW5VpGN_cfrbtIfny7U5lxGanEN2uXA9l6_-umduuCC810docV24_d_vEGPvFfseejvcrcI75KATdqwv1MkpWTJ_o7BggACCCDQNAJhi_NL-O28aaypBQEEEEAAAQQQQAABBBBoEoHsjRt05SknuFbXI2-8o579-7sWn8AIBCowOC0h0EMoj0CrE6iurtbFF12g4sJcje0frawkvu3cYk5yWISWbArXhhzzoOyev2vgwIFN0vSHHvyH3v_gIx25f6q6ZVSS9NMk6o2vJCIiXCuyI7Vkfbkuv-pqnXDCSY0P6keETz75SPff_w8dsl-a-nWsUnU1I7b4wRbyIuHmq7sb8qK0aF2ljjnuZF1-xW-bpE1Lly7VFVdcodEDUzWoi7lWakn6aRJ4Byqx06PYUbxsQuhtd9wlO-oOCwIIIIBA0wiQuNE0ztSCAAIIIIAAAq1QwP5xPHfbVpUWl6hsV6lZd6ncrGVlpQoPC1dsfLxi4-LM-uNrfIL5tkKK4hJ4uNQKLwe6hECzElj4_SzdfvklrrXp7n8_q6Gjx7oWn8AIBCpA4kagYpRvzQLz5s3Thg0bVFBQ0Jq72ar6FhYWpn79-mnYsGGKN_-GaMpl5cqVWr16tbZs2aJw-4SXpdkL1Jivwvfq1cuT4NO-ffsmbe-2bdtkH8ivWbOG66VJ5YOvzF4vnTp1Uu_evdW3b9_gAwVxZGlpqRYsWKAVK1aotpbvDwdBGJJD0tLSPNOjMNJGSPipFAEE2rgAiRtt_AKg-wgggAACCCDQsIBN0FizdImWLpivTevWatumTdpqvs2eszXbfMso8G-NJCanqL35w0k7M7d0VsdOnvedzDzWvQcMUEp6RsMNogQCCCDQgMDUTyfqgVtubKBU8Lv_9MDDOujIo4MPwJEIOCxA4obDoIRDAAEEEEAAAQQQQAABBBBAAIEmFYhs0tqoDAEEEEAAAQQQaCECy8y3QubNnK4f5s7RysULPaNpONX0kqJC2XX1sqU_C5mWmaleZmjk3v0HqteAQRo4fLhSMzJ_Vo4NCCCAgC-B0p0lvnY3el9VRUWjYxAAAQQQQAABBBBAAAEEEEAAAQQQQAABBHYLkLjBlYAAAggggAACCPwosHbFck359BPZb6rnZG8JiUtBbq7mTJ3qWfc0oEvPnhq8_2gNHTlKQ0aPkU3uYEEAAQR8CSQmJ_va3eh9KenpjY5BAAQQQAABBBBAAAEEEEAAAQQQQAABBBDYLUDiBlcCAggggAACCLRpgaqqKk355GO99_IL2rBqZbO02LR2rez62dtvedrXy0ypMuqQwzRq3GHqN3So7JzYLAgggEBdgaSUlLofHX-fmsG0To6jEhABBBBAAAEEEEAAAQQQQAABBBBAoM0KkLjRZk89HUcAAQQQQKBtC5SXlenzdyfog5dfVM7WrS0KY82yZbLrW_99RinpGTrgiCM17phjPaNyhIeHt6i-0FgEEHBHIKtjJ3cCm6iRUVFq37mra_EJjAACCCCAAAIIIIAAAggggAACCCCAQFsTIHGjrZ1x-osAAggggAAC-uL9d_XyY4-osCC_xWsU5ud5RuKwo3HYJI5DjztBR5x8quyoHCwIINB2BTp27abUzAztyM1zHGGImbopNi7O8bgERAABBBBAAAEEEEAAAQQQQAABBBBAoK0K8JXMtnrm6TcCCCCAAAJtUGD9qhW6-eLz9fidf2kVSRv7nkKbxPG_117WteedpQ9ffXnf3XxGAIE2JjB0_zGu9HjM-PGuxCUoAggggAACCCCAAAIIIIAAAggggAACbVWAxI22eubpNwIIIIAAAm1IoKqqSi8-9rCu_cXZWjp_XpvoeVVlZZvoJ51EAAHvAmdecqmcnj7Jjuxz5Mmnea-UPQgggAACCCCAAAIIIIAAAggggAACCCAQsACJGwGTcQACCCCAAAIItCSBgtxc3XbZxXr3-WdVXV3dkpreqLZGRUc16ngORgCBli_Qs19_HXfWuY525BdXXKnY-HhHYxIMAQQQQAABBBBAAAEEEEAAAQQQQACBti5A4kZbvwLoPwIIIIAAAq1YYMm8ObrmvDPbzCgbdU9lZFR03Y-8RwCBNirwq6t_r-TUNEd6v_-4cTr-7F84EosgCCCAAAIIIIAAAggggAACCCCAAAIIIPD_AiRu_L8F7xBAAAEEEECgFQl88f67ZqSNS7QjN68V9cr_rkSRuOE_FiURaMUCiUnJuvjaGxrdQzt6x433PaCwsLBGxyIAAggggAACCCCAAAIIIIAAAggggAACCOwtQOLG3h58QgABBBBAAIFWIPDphLf0-J1_aVNTo-x72qJimCplXxM-I9BWBY445VRd87d7FBUd3Eg8Bx55lO577iXFJSS0VUL6jQACCCCAAAIIIIAAAggggAACCCCAgKsCka5GJzgCCCCAAAIIINDEAh-_-Zr-ff-9TVxr86suMpLEjeZ3VmgRAqETOPzkU9VzwAC99uQT-u6bSX41pH2nzjrvyt_KHsuCAAIIIIAAAggggAACCCCAAAIIIIAAAu4JkLjhni2REUAAAQQQQKCJBSZOeJOkjR_Ng_1mfROfMqpDAIEmFOjRt7_-_PBj2rhmtWZPnaKF339r3q9V8Y4Cle3apdi4OKVltdOgESM0etx4jT5svCIj-SdjE54iqkIAAQQQQAABBBBAAAEEEEAAAQQQaKMC_BWujZ54uo0AAggggEBrE1i1dIn--8_7W1u3gu5PZFRwUyIEXSEHIoBAixHo2qu37Hr6hRf_1Obq6mpFRET89Jk3CCCAAAIIIIAAAggggAACCCCAAAIIINB0AuFNVxU1IYAAAggggAAC7giUlZbqgZtvVFVlpTsVtMCokVFMldICTxtNRiBkAiRthIyeihFAAAEEEEAAAQQQQAABBBBAAAEEEBCJG1wECCCAAAIIINDiBZ65725lb1jf4vvhZAeYKsVJTWIhgAACCCCAAAIIIIAAAggggAACCCCAAAIIIOCeAFOluGdLZAQQQAABBBBoAoHJEz_SpI8-bIKafl5Fn0GD1W_IUKVltVN6ZpZnTcvKUmx8nHbtLFXpzmKz7lRpiXkt2amSoiLlbNmsrZs2avP6dcrbvv3nQR3aQuKGQ5CEQQABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEDAZQESN1wGJjwCCCCAAAIIuCeQbRIgnrrnLvcqqCdyz_79Ne7YE3TwMceqQ-cu9ZTwf1NJUaHWLl-m5YsWaen8ufph7hyT8LHT_wA-SkZF8WueDx52IYAAAggggAACCCCAAAIIIIAAAggggAACCCDQbAT4i36zORU0BAEEEEAAAQQCEaiqqtKDN9_oWKJDQ3UPGrG_rrr1dnXr3aehon7vT0xO0dDRYz2rPai6uloLZs7Unb-_0u8Y3gpGRUV728V2BBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQaEYCJG40o5NBUxBAAAEEEEDAf4FXn3hMK39Y7P8BQZaMjYvT-X-4Rif94ldBRvD_sIiICI085BDPSB5bN2_y_8B6SjJVSj0obEIAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAoBkKkLjRDE8KTUIAAQQQQAAB3wJb1q_Tey8-77uQA3sHjxylP951j9p36uxANP9DDBy5vxqbuBHJiBv-g1MSAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAIEQCoSHsG6qRgABBBBAAAEEghL48LWXVVtbG9Sx_h40cMRI3fnkv5s8acO2b7BJ3GjsEhUd1dgQHI8AAggggAACCCCAAAIIIIAAAggggAACCCCAAAJNIMCIG02ATBUIIIAAAggg4JxAceEOTfrwA-cC1hOpa6_euu3RxxUVE13PXvc3DXEgcaO5j7hRWlKipfPmKXf7VhUWFKgwP1-FO_JVlP_j-4I8FRcWKiY2VsmpaUpOS1VyinlNN6v9bNbU9Az1G7qfuvTs6f5JaeU1bFyzWtO_-Ewb16zR1k0btXXjRlVUlBvnVCWlpCrRrPZ9Rrt26jt4iPoOGaqOXbs1O5WK8nKtXrZUKxcvUvaG9SopKVZJUaFKi4u106zF5r19lcn7SkhKNmvS7jUx0fQxRV179lKPfv3Vs98AtevUqdn1jwYhgAACCCCAAAIIIIAAAggggAACCCCAQOsUIHGjdZ5XeoUAAggggECrFZg44U2Vl5W51j_7YPqOJ55RonmoG6qlY7fuSs3I1I683KCbEBUdmqQTbw2uqakxD9MXa_630zVv5gytWLRQ1dXV3or_tL2qstLzoD1744aftu37JrN9e-039gANP-BADRtzgMdu3zKh_GxHh6mqqFRlZYWqqipVVVllVvtqPpvXCvve7K-q2v25qsrs_6n8nrJ7yleZOPb9nvLmc3mFjjztdPUZOCigbtoEhq8-eE9ff_yh1ixbVu-xudu2ya71LfYe6T98mEaPG68DDz9KqZkZ9RVzdZu9LhbPma0VJlFj5eKF2rBqlV_XlW2Uvb983WPxJqmj3-ChGjVunEYfdrg6dO7ial-cCO65dsy1UW2vIc_1Vr37mquo8GyrNNurPdfO7jKVFaZc9e7rqdpec9W7r7e9jv_xeqv2XLv2urMxK3TB769RfGKSE80mBgIIIIAAAggggAACCCCAAAIIIIAAAm1eIGxxfom744y3eWIAEEAAAQQQQMApgUrz8PHSE4_Wjtw8p0LuFScyMlIPvPqm-bZ9_722h-LD32-8TjO-_DyoqsPCwvT-3EVBHevkQWWlpZry6SeaN2O6Fsz6dvdIB05W4CVW9779NOLAg3TCuec1-VQ3NhHgD2efoUr7kNtcrzbBwiatuL385vqbdMqvL_CrGnsfffzGa5rw7H88o1H4dVADhcLDwzXi4IN12yNPyL53c7Gjakwzo4N88e47WjJvjptV7RXbjsQz_sSTdbRJkkkxo700ZrHXRLVJ4PGWzBNnEiKyOnTwWoXnOjvnTE9yxu4kC5tQUeW1vBs7XvjiG6VlZroRmpgIBCUwOC0hqOM4CAEEEEAAAQQQQAABBBBAAAEEEGgOAoy40RzOAm1AAAEEEEAAAb8Epkz8xLWkDduAY888p1kkbdi2DN5__6ATNyKjo2yIkC12RJRP3nxd777wnIp2FDR5O9avXCG7fvTaKzrilNN07mVXKLNDxyZphxlcw0z9kt8kddWtZNvmzXU_en1vk4Gefeifys3O9lommB02EWHutGmuJm3YKVC-eO9tTTY_B-zUJ0292OlkXv7XI3r96Sc08sCDFW2m8bGjWuxO0vlxZBQ7aooducIz4oUdyeLHUVTsKCt2NAs_k3mOOfNs_e62O7x20XOd5buTwOa1UnYggAACCCCAAAIIIIAAAggggAACCCCAgGsCJG64RktgBBBAAAEEEHBa4P1XXnQ65E_x4hISdO4VV_70OdRvBo8YFXQToqJjgj62MQfaKTsmvv2m3nn-WZ9TUDSmjkCOtSMQfP7u25r0vw90zOln6exLL1d6VlYgIVpM2a2bN_psa0lxkZ6-725NNUkPbi0xJpHBjSVn61b927R91pRv3AgfcEw7ikpzaUvAjecABBBAAAEEEEAAAQQQQAABBBBAAAEEEGiWAiRuNMvTQqMQQAABBBBAYF-BeTNnaMOqlftuduzzGRddopS0dMfiNTZQj379FJ-UFNTIAlGRTTvihp1643MzEsLbZuqN_Jycxnbd8ePtg_ZP3npdX3zwjk445zz9-nd_UHRMaJJbHO_cjwF9jbix0ExT8_Btt7h-bmLi4h3tXq0ZVuLjN1_TK48_pl07dzoam2AIIIAAAggggAACCCCAAAIIIIAAAggggEBzEiBxozmdDdqCAAIIIIAAAl4FPnj5Ba_7GrsjLTNTp_zqgsaGcfT4sLAwDRg2zDP9RKCBo5pwqhQ7GsK9116tNcuWBdrMJi9vRwT54OUXtXT-PN368GNKzchs8ja4VeG2zZvqDW37-8IjD8pOZeL2EhPrXDLM-lUr9Pjf_qoVixa63WziI4AAAggggAACCCCAAAIIIIAAAggggAACIRcID3kLaAACCCCAAAIIINCAgB3FwY644dZy6vkXKTYuzq3wQccdMnJ0UMdGRUUHdVygBy1fuFA3nH9ui0jaqNs3mwxww_m_dHUEl7r1NcX7ivJy7cjN-6kqO8rIQ3--Wc899M8mSdqwFcc6NOKGnc7luvPOIWnjp7PJGwQQQAABBBBAAAEEEEAAAQQQQAABBBBo7QIkbrT2M0z_EEAAAQQQaAUCc6dPc7UXBx91jKvxgw0-aMTIoA6NbIIRNyZ99KFuveyivZIFgmpsiA7Kyd6imy76dVAjmoSoyQ1Wu_XHUTdKS0r0199dqckTP2rwGCcLxMTGNjqcTdp46LabVVVV1ehYBEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBFqKAFOltJQzRTsRQAABBBBowwJzpk91rfe9BgxQu06dXIvfmMB9Bw9R3yFDVVNdHVCYTj16BFQ-kMK1tbV68dGH9N6LzwdyWLMsu2vnTt31x9_qsj_dohPOOa9ZtjGQRm3bslGde3TXX668NCSjoDR21Jo9SRtNMa1LIK6URQABBBBAAAEEEEAAAQQQQAABBBBAAAEE3BYgccNtYeIjgAACCCCAQKMEqk3SwvzvZjYqhq-DDzzyaF-7Q7ovMipKD7z8ekjbULdy-0D9_uuv0XffTKq7uUW_t3165r57lNGuvcaOP6JF92Xl4h_07vPPa93K5SHpR0wjphsiaSMkp4xKEUAAAQQQQAABBBBAAAEEEEAAAQQQQKCZCDBVSjM5ETQDAQQQQAABBOoXWLZgnkqLi-vf6cDWA484yoEobSPEK0882qqSNuqetcfuuF2527bV3dTi3v_vtZdDlrRhsWJi44IyW75woWd6FEbaCIqPgxBAAAEEEEAAAQQQQAABBBBAAAEEEECgFQiQuNEKTiJdQAABBBBAoDUL_DBntmvd69yjp7r26u1a_NYUeNbkr_XOc8-2pi7t1ZeSokI9eMtNInlgL5aAPsTExQZU3ha23k_dcyfuActxAAIIIIAAAggggAACCCCAAAIIIIAAAgi0JgESN1rT2aQvCCCAAAIItEKB1UuXuNar4WMPdC12awq8dfMmPXL7n1tTl-rty5J5c_TGM0_Vu8_fjYlJyfrV736v3gMH-XtIqykXGxsfcF8-ev1VrV0RmqldAm5sMzqgLV9nzeg00BQEEEAAAQQQQAABBBBAAAEEEEAAAQQcE4h0LBKBEEAAAQQQQAABFwRWLVvqQtTdIbv17uNa7NYSuLK8Qvdf_0ftdHG6muZk9dZ_ntbQ0WM0dNTooJoVFROtcy69wrPmbN2qWZMn6dtJk_TDnO9VXV0dVMyWclCgI27k5-Totaced717Hbt114Ch-yklI0OJySmKiYlRcWGhigoLtH7lSq1YtDCk56Zdp07q3ruvuvXto-59zGuvvupiRgPytbTl68yXC_sQQAABBBBAAAEEEEAAAQQQQAABBBBoqQIkbrTUM0e7EUAAAQQQaAMCxYU7lJud7VpPu_bu5Vrs1hL46fvv0trlbWdEhNraWj36l1v1zP8mKiIiolGnMatDB5147i89a0lxkWZPnazvTBLH3BnTVLZrV6NiN8eDY-PiAmrWf_95v3bt3BnQMf4WTk5N0-kXXqzDTjhJGe3a-TystKREM7_6Uq8984SrP2_SMjPVo28_dfMkZ9gkjT6eqZpi4wMfqaRuh9radVa377xHAAEEEEAAAQQQQAABBBBAAAEEEECgtQiQuNFaziT9QAABBBBAoBUKuDlNiuXq2qt3K1Rzrkuzp03Rl--_51xAPyKFh4crKSVVyWmpZhSEGhXk5rj2cN9bc3Kyt2jGF59r3HHHeysS8HY7tcX4E072rHYUk_mzZpokjq_09UcfqqqqKuB4zfGAmFj_Ezc2rF6l6V985ko3jj7tDF16483yNyEiPjFRR556mg49_gS98MhD-uj1V1xp129vu0NjDjvcldh7graF62xPX3lFAAEEEEAAAQQQQAABBBBAAAEEEECgNQmQuNGaziZ9QQABBBBAoJUJrFuxwrUepaSly34rn8W7wIT_PuN9p0N7Mjt21MiDDtGIAw_S4JH7y56XfZey0lJt27LJTDnylaZ-NlEb16zZt4jjnz949SVHEzfqNtBOczF63GGe1SbHFOTm1t3dpO9tooydniOrYydltu-gOaY927ZsDqoNMQGMuDHzqy-CqqOhg869_Cr98qrfNVSs3v1R0dG67KablZCUpDf__VS9ZRqzccqnn7ieuFG3fc3pOqvbLt4jgAACCCCAAAIIIIAAAggggAACCCCAwM8FSNz4uQlbEEAAAQQQQKCZCOS4OE1Kl55Mk-LrNC-e872WLVjgq0ij9qVmZOrXV_9BR516usLCwnzGsiMndO_Tz7PaB_NL58_VY3_9i7asX-fzuMbsXLl4kZYumK-Bw4Y3JkyzPdYmyhx8zHEmkWD8XskyT9xVqc_ffTuodscFkLgx48svg6rD10Gjxh0adNJG3bg28WPp_HlaOOvbupsb_f77yd-ovKxMMbGxjY5FAAQQQAABBBBAAAEEEEAAAQQQQAABBBBoXQLhras79AYBBBBAAAEEWpNA7vatrnWna28SN3zhvv3sf3ztbtS-I045VU9_8LHslBYNJW3UV9HA4SP1yBtv6_hzzq1vt2PbPnzlJcdiNZdAvQcO0j3_fV5_ffLfHv99Rzjp3rdv0E2N9jMhIXvDeq1buTzoeuo7MNYkjfzu9jvr2xXUtt_efociI53NcS_btUvfT_kmqPZwEAIIIIAAAggggAACCCCAAAIIIIAAAgi0bgESN1r3-aV3CCCAAAIItGiB3K3uJW506Ny1Rdu42fhVS5do3swZrlRhkzb-eOc9iktIaFR8O2rBlbfcrlN-dX6j4vg6-NtJXyone4uvIi1mX2b79rrm7vv00Gtvacj-o722u0fffl73NbQjNja-oSKe_TO-cn60jYOPOVbpWVl-1e9PoY5dumrkweP8KRpQmQWzvguoPIURQAABBBBAAAEEEEAAAQQQQAABBBBAoG0IkLjRNs4zvUQAAQQQQKBFCrg54kZcfOMSB1okqJ-Nfsel0TYOOuoY_eGvd_vZCv-KXXzdjRp50MH-FQ6wVE1NjT5-47UAj2p-xc-65FI99cEnOvzEkxtsXPc-wY-4ERPv3xQgM778vMF2BFrATrnj9HLEyac6HVJL5811PCYBEUAAAQQQQAABBBBAAAEEEEAAAQQQQKDlC5C40fLPIT1AAAEEEECgVQpUVVZqR26ea32LTYhzLXZLDrxp7VrNNCNNOL3EJyXpqltvD2pqFF9tCQ8P1w33P6DE5BRfxYLeN3va1KCPDfWB1uSOx5_R-b-_RtExMX41JyklNeiRK2JiG76namtrtWbZUr_a4m8hO_qKnT7H6WW_MWOdDqmNa1arpKjQ8bgERAABBBBAAAEEEEAAAQQQQAABBBBAAIGWLUDiRss-f7QeAQQQQACBVitQXOjuw83YOEbcqO_i-ebjD2Ufrju9nH3JZUpOTXM6rCdegkkKOfXX7kyZ4nnQXlzkSrvdDNqhcxf986VXzXQfgY9GEux0KbFxDSduFObnyY5k4uTSo18_xxOCbPvsddWuUycnm-qJlb1hg-MxCYgAAggggAACCCCAAAIIIIAAAggggAACLVuAxI2Wff5oPQIIIIAAAq1WoLy8zNW-xcU3_JDZ1QY00-CLZs9yvGVZHTro5F_-2vG4dQOedN6vZEf1cGNZtmC-G2Fdi9m1V2_9_YVX1al7j6DqCHa6FH9G3ChwYRSd7n37B9VPfw7q0aefP8UCKlO4oyCg8hRGAAEEEEAAAQQQQAABBBBAAAEEEEAAgdYvQOJG6z_H9BABBBBAAIEWKVBR5m7iBiNu_PyyKCst1crFi3--o5Fbxh13gqKioxsZxffh8YlJOvq0M3wXCnLv0nlzgzwyNIfd8uAjSs3MCLrybn2DS1aIiYttsM6CnJwGywRaIDXNnZFcbDuS0lIDbU6D5YvySdxoEIkCCCCAAAIIIIAAAggggAACCCCAAAIItDEBEjfa2AmnuwgggAACCLQUgYryclebyogbP-ddMm-eqqurf76jkVvGjD-ikRH8O3z0uEP9KxhgqaXzW9aIGzaJpTFLsKNMxMbFN1htfq7ziRtx8e5NexSf0DjL-kAKC_Lr28w2BBBAAAEEEEAAAQQQQAABBBBAAAEEEGjDAiRutOGTT9cRQAABBBBozgLlZbtcbV5cgnsPe11tuIvBF83-zvHoqRmZGrDfMMfj1hdw4PCRio1zfgqclT8sUlVVVX1VtsptXXv2Unh44P9MiIlteMQNNxI3YhMaThgJ9kS5kuAVFhZsczgOAQQQQAABBBBAAAEEEEAAAQQQQAABBFqpQOB_kW2lEHQLAQQQQAABBJqXQHmZuyNuREXFNK8ON4PWLPp-luOtGDVunMKa6EF1ZFSU9hs91vE-2NFf1ixd4njc5howKiZanbp3D6h5_iRt2ICFeXkBxfWncElRkT_FgirjRsJOWiOmsQmqExyEAAIIIIAAAggggAACCCCAAAIIIIAAAs1eILLZt5AGIoAAAggggECbFHD7Yf-uslKlKqNN2tbX6dKSEq12ITmhR99-9VXn2rZ-ZnSPWVO-cTz-2uXL1G_ofo7Hba4Bf3Pdn5SzLdvv5kVHR_tVNio6yq9ygRTK3bYtkOIBlS0rdX7kn9R0fu4EdBIojAACCCCAAAIIIIAAAggggAACCCCAQBsQIHGjDZxkuogAAggggEBLFEhMTna12WU7S12N39KC_zBvjmpqahxvdufuvRyP6Stgp27dfO0Oel9RYWHQx7bEA0cecogrzU5ITnE8bt62rY7H3BNw1y7nf06kZWbuCc8rAggggAACCCCAAAIIIIAAAggggAACCCDgEWCqFC4EBBBAAAEEEGiWAm4nbpTuLG6W_Q5VozatXetK1Z179nAlrregHbq6k7hRUtS2Eje8-TZ2e5IriRvujbhRkJPT2C7_7HhG3PgZCRsQQAABBBBAAAEEEEAAAQQQQAABBBBo8wIkbrT5SwAABBBAAAEEmqeA-4kbO5tnx0PUqqIdBY7XHGWmz2jXsZPjcX0F7Nilq6_dQe8jcSNour0OTEhO2uuzEx_cnCplw-qVTjTxpxjh4eFKTkv_6TNvEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABK0DiBtcBAggggAACCDRLgYQkl6dKKSFxo-6JL9mxo-5HR95nmaSNsLAwR2L5GyQ-MVGJLlw7JW1sqhR_vQMt58Y0IcWFO1SYnxdoUxosv7O4WPkOj7iRnJ7W5PdEgx2lAAIIIIAAAggggAACCCCAAAIIIIAAAgiEXIDEjZCfAhqAAAIIIIAAAvUJ2G-m24fwbi2lO0vcCt0i47ox4kZ8QkJILGITna-3pIipdZw4mb36D3QlcWHihDedaN5eMebNnL7XZyc-9Oo_wIkwxEAAAQQQQAABBBBAAAEEEEAAAQQQQACBViZA4kYrO6F0BwEEEEAAgdYk4OaoG6Wlpa2JqtF9KXRhxI2Y2LhGtyuYAHFxztdbXFQYTFM4Zh8Bm4zVtVfvfbY2_uMnb72pyvKKxgeqE2Ha55_W-eTM2wPGH-lMIKIggAACCCCAAAIIIIAAAggggAACCCCAQKsSIHGjVZ1OOoMAAggggEDrEkhMTnKtQ25MreBaY5sgcImZbsLpJSY-1umQfsWLjnG-3p0kbvhl70-h_kP386dYQGXs_fz1J_8L6BhfhXOyt2j2tCm-igS1byyJG0G5cRACCCCAAAIIIIAAAggggAACCCCAAAKtXSCytXeQ_iGAAAIIIIBAyxVISk5xrfHrV61wLXZLDFxU4HziRmxsfEgo3Bjpo6SoKCR9aY2VDhqxv754_13Hu_bhKy_q6NPOcGQqln___T7HR_AYMGyYUjMzHO83ARFAAAEEEEAAAQQQQKBlCWzbtk3Lly1XQUG-CvILVFxcpOTkZKWlpyvdrPa1fbv2yszKdKVjoa7flU4RFAEEEEAAgVYgQOJGKziJdAEBBBBAAIHWKpBg_nDh1rJ2-XK3QrfIuMUujLgRG-v8yBf-4EbHxPhTLKAykVHRAZWnsHeBA444Uk_d-zdVlJd7LxTEno1r1ujJe_6m3912RxBH__8h_3vtZc2a_PX_b3Do3QGHH-VQJMIggAACCCCAAAIIIIBASxNYtnSp3nz9Dc2YMV2rV632q_mdOnfWyP1HmnV_HXLIOPXq3cuv4-orFOr662sT2xBAAAEEEEBgbwESN_b24BMCCCCAAAIINCOBxCT3EjcKcnNVaL7dkpKW3ox6HJqmlJhv99TU1DheeXhkhOMx_QnodEKArTMpNdWfqinjh0B8YqIOOvIYfePg1CZ7qv38nQmKiAjXJdfdpEATeGpra_XWf57Wa089sSeco68HHH6Eo_EIhgACCCCAAAIIIIAAAs1fYOXKlXr4wQf1xWefy_6bI5Bly-bNsutHH-6eFnLIkCE67YwzdNbZZykxyb-pZUNdfyD9pSwCCCCAAAJtXYDEjbZ-BdB_BBBAAAEEmrFAUlqaq61bt2K5ho090NU6WkLw8LAwV5pZ7vCICv42srxsl79F_S6Xkkbiht9YfhQ86rTTXEncsFVPfOtNzZs-XRdfd6NGHXqYIiN9_5OnqqpK30_-Rq8--S9tXOPfN9_86OJeRUaNO1Qdu3XfaxsfEEAAAQQQQAABBBBAoHULfPzRR_rTDTeqrKzMkY4uXrxYdi0t3anfXn11gzFDXX-DDaQAAggggAACCOwl4PuvmHsV5QMCCCCAAAIIINC0An0GDnK1QjtdCokbUnxiksJM8kag3_5p6ORU7HLmj1MN1bPv_opy5-tNSiZxY1_nxnweOnqs-g4ZqpWLFzUmjNdjt27epPuu_6PizbfQbNJE9959lZaRqSSTgFNeukvFRYUqMiPuLF-0QEvmzlXZLueTffY0LiomWpf96c97PvKKAAIIIIAAAggggAACbUDgP888o7_fd78rPW0oOd1WGur6Xek4QRFAAAEEEGjlAiRutPITTPcQQAABBBBoyQIDho1wtfl2xA2W3QIJJnnDTpni5FLu0LeKAm1TmQsJI4lMlRLoaWiw_G-uv1E3X3xBg-UaU6C0uFhTPvm4MSEafew5v7lcHTp3aXQcAiCAAAIIINBaBCorKzVn9hxt3LhBuTm5ysvLU25ujgryC5SQEK90k2yZkZFu1gylp2coMytLgwYPUnKye9MothZb-tF2Baqrq7Vm9WotW7pMK8y_c-39VFJSouKSYlVVVinNjGaZnp5u7q90tWvf3txTg9W_f39FRUW1XTQXez5l8hT94_6_u1ZDVFS0z9ihrt9n49iJAAIIIIAAAl4FSNzwSsMOBBBAAAEEEAi1QEa7dsrq0EE5W7e60pQFs771jDJhR5to60uCGZnA-cQN90Yx8HW-yl0YPSGZxA1f5EHtGzh8pA488ijN_OrLoI5vCQd17NpNp194SUtoKm1EAAEEEEDAVYGt5vf5yd98o8lff63p06Zr586dAdVnf1_v2auXho8YoeHDh2vEyJEaOGhgQDEojEBrE7BTU3715Zf66MMPNXnyZJWXlQfUxejoaPUzyRsjzH116PjDdOBBByk2NjagGE4Xvuuvd6rYJF9XVFZ4Ek5soldVVaUqKiq1-32Vea0wq301-8xqXz2rKVdb60yLxowZo2f--5-gguXl5ur6a65xfETLuo2JjPL-WCfU9ddtJ-8RQAABBBBAIDAB7_-FDywOpRFAAAEEEEAAAVcE7KgbOVsnuhI7PydHi77_TvuNOcCV-C0paKL5BuO2LZsdbfKunaWOxvMnmJ3upXRniT9FAyqTnJoWUHkK-ydw5c23a-n8-dqRl-vfAS2s1OU336oo8wdxFgQQQAABBNqqwOZNm_XQAw_oww8-aNRDTPs7nh1NwK7vvv22hzOrXZbGH364jj_-BB10yMHyZ-qAtnoe6HfrErBJCi8-_7yeePwJMwVg8KMmVlRUaPGiRZ715ZdeUkxMjA448ACdeNLJOv7EExQXF9fkcO---26j-uRUg0tLg_-37PPPPaeCgoKAm2JHP6mqqvLrZ2VUpPfHOqGuP-COt_ED7H24auUqLV-2VMuWLfOMmmOTqK787VVtXIbuI4AAAm1TwPt_4dumB71GAAEEEEAAgWYm0H-__TT1M3cSN2xXJ330PxI3jEN8kvNDT2_fuqXJr6a8bVs937pyuuKklBSnQxLPCKRmZuj6e-_XX668zK8_ULYktF9f_UeNPOjgltRk2ooAAggggIBjAvah5ZOPP65XX37FfFO-wrG4dQPlbM_RhDff8qx2Coi77r1Hxx53XN0ivEeg1QnMnTtXN113vdatW-d43-wIHpO_mexZJ331lR5_6knH62jtAe30NK--8qrf3TzltFN19jnnqG_ffmZaqEzPcTZGrvmSydW__Z15iL-03liRkfVPcRPq-uttLBt_ErDTg_2wePHuBA2bqLFkqdauXetJ2PmpkHkzaNCguh95jwACCCDQhgRI3GhDJ5uuIoAAAggg0BIF7Igbbi7fTvpSFbf-RdHm20VteUlMTnK8-6VmiNuiHQVqytEqss1c6W4sTdkHN9rfnGPaEW8uuf4mPfuAe3NAN3X_L_zjdTrjIqZIaWp36kMAAQQQaB4C38-apasuv0I7duxosgbl5-dr3dp1TVYfFSEQCoHJX3-j3111lcrKylyv3tdUHK5X3oIrsAkv_o6Ccs_99-ncX_ziZ71NTEyUXe10LV4TN7xMlRLq-n_WGTbsJXD3XX8zUxv9b69tfEAAAQQQQKCuQHjdD7xHAAEEEEAAAQSam0DP_gNcTarYZebX_u7rSc2t203enkQXRtywncjesLFJ-7Jl_XpX6us9kG-8uAL7Y9BTfnW-fvXbq92sosliX3ztDSRtNJk2FSGAAAIINDeBj__3kS46_4ImTdrYYxDN9GR7KHhthQIzZ8zQFZdd1iRJG5bPTpvCErjArG-_8-ugUaNH15u0UffgYSOG1_2413s7rUp9S6jrr69NbEMAAQQQQAAB_wVI3PDfipIIIIAAAgggEAIBO1d1n0FDXK35yw_eczV-SwiekOz8VCm239mb3Emk8GbqxogbWR07qV2nTt6qZLtDAudcdqVs0kNYWJhDEZs-zKU3_kmnXXBR01dMjQgggAACCDQDgf8884yu-cMfZKdbCMUSFV3_g8xQtIU6EXBSoLS0VLf86U8_m07ByTr2jUXixr4i_n3-7jv_EjcuuOjCBgMOGzbMa5koL1OlhLp-rw1mBwIIIIAAAgj4JUDihl9MFEIAAQQQQACBUAoM8PEHCyfaNf_bGZo15RsnQrXYGFkdOrjS9rXLl7sS11vQNS7UN3T_Ud6qY7vDAjbp4c8PP6aEJOen7nG4qXuF69Kzp-7693M6-Zfn77WdDwgggAACCLQVgbfefFN_v-9-1dbWhqzLjLgRMnoqdlngsUce0aaNm1yuZe_woUrcuPueezRm7Ni9G9OCPm3a6N-Ikz169GywVz3MvzFSU1PrLedtKptQ119vY9mIAAIIIIAAAn4LRPpdkoIIIIAAAggggECIBIaMHK13X3jO1dr_ff-9GjbmAMXExrpaj9PBK8srFBUT3eiw_ffzPgxrY4LPnT7NM4pCY2L4e2yZ-SbaD3Nn-1vc73KD9x_td1kKNl5gzGGH65E33tHvzjhZFSH6xq6_vYg2Q0jbkUJONwknkV6GK_Y3FuUQQAABBBBoqQKrV63WXX-9M-jmp6WlKatdOyWbEeBKS3eqpLhEBTt2qLioKKCYJG4ExEXhFiJQXV2tdya8HXBr27dvr169e5u1l8LDwlVSUqL8gnytXb1GmzZtUk1Njc-YoUrcOPHkk2TXNaadb7z-mt57510VFBT4bGtz2WmNKysr_WpOp87-jeg4e_48v-LZQqGu3--GUhABBBBAAAEEvAqQuOGVhh0IIIAAAggg0FwERhx8sDI7dlRudrZrTcrJ3qI3__OULvj9ta7V4WRg-4e2d55_Vt98_KEeef2dRidv9Ow_wBPDJoI4uWxYvUo5W7fKrRE96rZ1waxvVeXnH8rqHtfQ-8GjGHGjISOn98-eNqXZJ22MHneYLr_5VqbRcfrkEw8BBBBAoEUJVFRUeKZH2bVrV0DtHjxksM48-2wdf8IJysrKqvfY_Lw8rVq1SgsXLNDMmTM1-etv6i23Z2MUSZR7KHhtRQLTp00PKHFh0OBBuuPOO7W_j3_D2Af8U6dM0e9_-zuvUqFK3NjTIJtw8ufbbtMNN92kY488Shv9GMnC9vmWW2_dE8Lna01tjS654EJPsoPPggHs3GESzvxdYl34wkio6_e375RDAAEEEEAAAe8CJG54t2EPAggggAACCDQTgfDwcJ107i_1wiMPutqiD156UYefeIq69urtaj2NDb5-1Qo9cddftXzhQk-oCc_9R7-8yvsf3fypLzIyUn0GDdHSeXP9KR5QmbnTp-rYM88O6JhgCs-eOiWYw3wek2m-qdaxS1efZdjprEBhfp5eefxRZ4M6FC01M0PjTzhZh590snr07e9QVMIggAACCCDQcgUe-Mc_tHTJEr87YB9WXn_jjbrokosVFhbm87j0jAyNsauZNuHSyy_XAaPHKDcnx-sx0dExXvexA4GWKjDDjGDo73Ls8cfpX088IfvvZ19LYmKiJ2nKTsWxbu3aeouGOnFjT6PsSDrRfo4wmZKSouEj_B9J8sijjtIH77-_p6pGv1Y4_CWIQBsU6voDbS_lEUAAAQQQQODnAiRu_NyELQgggAACCCDQDAWOPuNMvf70EyovK3OtdVVVVbrv-mt0z3-eV1pmpmv1BBu4zHyT8Y1nntSHr7wkO2TunuXdF541CScnqWO37ns2BfU6YL9hriRufPXhe64nblibbyd9FVS_fR002EzTw9K0Ai88-pB2Fhc3baU-arPToYw94kgdceKpGn7ggQ3-IdxHKHYhgAACCCDQqgTycnP16suv-N2nmNgYvfjKyz5HAvAVbPTo0Zr4ySdei8SYB7xOLGXm3xt2tI88s-bn5SvfJJWGmQfhCfEJSkhMUGpqmvr06eP3w2Qn2tSSY9jRHbK3bNHmzZs9njZpICU11TimeF7bmWlyGko0cLL_5WYqvhyTAJSbk2vOca4KdxTKtiktPU3p6Rnq0rWLmkvSgu33VjN6oT9LVrss3XPffQFZjjVJUc09ccOfvgdb5qRTTnY0cSPYdrSF45rzfWdHM7U_E_b8vLevdkSW9PR0ZWRkKsMk72eYJEL7ZRcWBBBAAAEE3BbgvzZuCxMfAQQQQAABBBwRSExK1viTTtFnb7_lSDxvQTavW6tbfnOhJ3kjw_wRsTksNknjy_ff9SSuFJg_kO-7VJohqp--7x7d-dS_990V0OcB-_n_7aRAAtuRQebOmK6RBx0cyGEBlf3o9VdVtMP5uY-HmAcELE0nsGbZMk368IOmq3CfmiIiIsyIO33Uc8AA9TZrrwEDzesgxcbH71OSjwgggAACCCDw0osvyT6M82exo2s8_MijQSdt2DpGjx3jM3EjKjrKn6bsVWb9unVavHixflj8g1nt62L5M92A_Z2hR88e5tv9I3S6STA_4MAD9orr74e335ogO91MZaVZTRJ5ZUWlqqoqzWe7ms-e1wozHeCP7-0-T5kqjRg5UldcdWW9Vb337rvaVbrLE6vCxqgnrqces91TR524Q4YO0dV_-EO9cf3ZaP1ee-VVz7natGmTiouKfB5mkyR69e6tfv36qf-A_hoydKiGDR-uhIQEn8cFsnPlihX65uuv9fWkrzV3zhzjUuX1cNseO-XGIeMO0XFmKp9u3bp5LdsUO7Zv2-5XNccdd7xJhkn1q-yeQmMOGKs333hjz8e9XptT8speDXPwwyHjxsmO0lFYWOhIVPuw39-loeml7M_MQM9BqOvft-_N-b7bsGGDpk2Zqmlm1M6ZM79t8OeUnYprwMCBGm5-Ng0zo7qMMn8n6NKly75d5jMCCCCAAAKNFiBxo9GEBEAAAQQQQACBphI46Re_dD1xw_Yle8N63XrpRbrbjLxhp8oI1VJbW6uZk77Uq088pk1ehrDd07b5387Q1M8matyxx-_ZFPBrfzPihlvLG8884VriRmlJsd574TnHmx6flKRDjj7W8bgE9C7w_EP_8L7Tjz1DR4_VNX-7W5tMAla2mQc7d2u2Csw3Kct3lZl1lyIiIxSXmGQeBCQq3nyzsu5qR6zp3ruPohz6tq4fzaUIAggggAACLVbAJmy89or_o22ceNJJOua4xv1eNdpMleJrsVMqNLRs3rRZUyZP1ozp0_Xdt9-a0TTyGzqk3v02sXr1qtWe9Z0Jb3se7v_1b3_ToeMPq7e8t42333qrJ3HC235f2-20M96WO_9yh-xIF0252CSY5559Vu--_Y4aeihdt132WrLT7dSdcscmxtgEDvtg_Zrrrm1wWp268eq-n_3997r_3vs0f968upt9vrftsdeHXR964EGdfuYZ-r1JZOnUubPP49zaWVpa6lfowUOG-FWubiE7DZFNmqlvycjMqm9zq9pmH8bbn0sT3gzsyyF2hIYN69dr5YqVWrnSriu0auUqrVm92m-f0SNG-izbvXt3fTX5m3rLhLr-ehtVZ2Nzvu8WL1qkhx96SJO_rt-2Tjf2emsT3BaZL6TY9eWXXvLss_fO0cccI_vft0GDB-1V3n6wSXkbN2zU-vXrtH7des81M-f72T8rV9-Gzz_7TKv9uJ4effxfiouLqy8E2xBAAAEEWqgAiRst9MTRbAQQQAABBNqiQDfzUHXY2AO14LuZrnc_e-MG3WpG3rjm7ns1cLjvP6o43ZgK88dCO-rA-6-86Eki8Tf-cw_-Q6MOOVRxQX47zU4P065TJ203Qxk7vdhRNz57Z4IrU6a8_K9HVVLs-5t8wfTnuLPO8TzYD-ZYjglc4Pupk7Xw-1mBH1jniCTzjbnMDh096_DgvvhaJxpvEUAAAQQQQMCbgH04X1Dg32hn9uHo9Tfd6C2U39sHDBygpORkr9-Mbihx4_RTTvU8dPO7wgAK2m9vX3LRRbrw4ot1-x1_CeDIll_UPkS-8447PKNs2MRzJxabGLNg_nzP-sdrrwk4cWOjSeC9-86_6asvv2xUc-zIHPah_gfvva-7771XZ5x1ZqPiBXNwVpZ_CRTFQUw12LFjR33-VeOMgulTczrmT7fcogvNvbvvkmCSvL0t06dN08UXXOhttyPbff08C3X93jrYnO87O13TXXfeqc8_-9xb8wPebhN1nnnqKb34_PNavGzpXscfcehhsiMO2Z-PwSzrTWKQXRta7GhMIm-jISb2I4AAAi1KILxFtZbGIoAAAggggECbFzj5V79uMoOtmzfp5osv0AN_vkm527a5Xu8W802MV5_4l35z3FF66t6_BZS0YRuXb-Zlfe2pxxvVzjGHHdGo430d_Mx9d2vhrG99FQl43wcvv6hP3qp_eN-Ag9U5INI8YDjll-fX2cJbNwXsH-dffOTBRlfh6w-sjQ5OAAQQQAABBBD4SeB_H3740_uG3hx3wvHq2rVrQ8Ua3G-nDth_1P5ey9kEEV_LFheSk_etzz7A-9ejj-67udV-riiv0JWXXa5XX35FTiVt1MWyI2-Ehwf252ub8HHWaac3OmmjbjvsN-dvuuEGPfjPf9bd3CTvO3Xu5Fc93zcyAdqvSlphITu9jJ0CY9_ViZ9ZjeEKdJqUxtRV37GB1t-c77v58-br9FNPczRpo65ZfVbZ2dlBJ23Ujc17BBBAAIG2J8CIG23vnNNjBBBAAAEEWrSAHVGiY5euyt60scn6MXXiJ5r19SSddcmlOv6cXygpJbC5g3011CaE2ClOpk78WKv3-ZaGr-O87fvo9Vd1xCmnqWe__t6K-Nx-0nm_1MdvvOrKH17tw_n7b7hWf33iGfUbup_Pdvizc9JHH-q5h9z54-n4E0-SHYGEpWkEpn_-qTauWdPoyuz0NiwIIIAAAggg4K6AfYi9YMF8vys59rjj_C7bUMFrr79eJ59ySr3FunTpUu_2PRsT4uOVt-eDi6-PPfKoRo8ZqwMObP3Dfz34wD816auvXNP0NepAfZXatvzx6t8HNFVLfXG8bXvqiSeVZH7fvPzKK70VcXz7oYcd5kmMaSjw99_N0s6dO82UgAkNFWV_CxCIjml46ic3uxFI_c35vvv4o488SVflZeWucQVi5VojCIwAAggg0GoESNxoNaeSjiCAAAIIINA2BOw37S667kbdd90fmrTD5WVlevXJx_X600-q_7DhGjPuMI0yw1_a6VsCWbZt2axlC-Zpmfkm2FLzunb58kAOb7CsHYrzqXvu1D9efK3BsvUV6Ni1m0YfOl6zJn9d3-5Gb9tphvD900X_x959QEdRdQEcv0kglDSS0Iv03gJIk45KV8BOl6KoCCiiiIqIKBawYS8gikhHmiIgHaX3Kl16SYVQEgJ8762GD9J2Jtm-_3fOnN2defPKb3YTyNy9r6t0fLyndOrbT7IbWIs8ZaexkVHyzfuj5M_FC1MestnrDt162qwtGrIu8MuP31uvZKAGGTcMIFEFAQQQQACBLArs3LFDjN4Ey5kzpzRp2jSLPf7_9MqVK4veMlNyO-iGts48odPne3rgxubNm-X7ceMzcykMn2MmcGOHWpqx31NPy9WrVw23n5mKH475wBKYjY7S_AAAQABJREFUU6Nmjcycbvqcho0aic4KERsbm-G5eumiZ_o-JeMmfC_ZsvEn_wyx3OBgWlkcHDlso_278udu86ZN8sJzz4te8siexaiVPcdA2wgggAACniPAv-I851oyEwQQQAABBLxGoF6z5irzxaOyYNpUh89ZB0bs2bLZsv0w9iPJW6CA5C9cVPKEhUlIeJh6DJfg0DC5fi1J4qJjJC42Ri6oP6LFqe3E0cOigw7sXf5Wf7RcNGuGtHjgoUx1dV-XbnYL3NAD0oYzx4-TNeobcfe27yj1721hyaJibbD7dmyXtcuXyO_Tp4kOALFXqdOkmRQrVcpezdNuCgG9fM6hvXtT7M3cywAybmQOjrMQQAABBBAwIbBefbPfaKlStarkypXLaHW71tMZNxxVVq1cKYcOHpJSpTP-N-W0mTNk8aJFsnjhItm_f7_Nhjdp6hRZ9PtCS9v7bBwonjzI7775xu5LARgN8taZJp7rP8DuQRt67vom8Isq88vipUtEf6nA3kXfFB72xnDLDWhrff25erUM7N9fho8YIfnz57dWneMuLOCvrrszi5H-XflzpwOddPYdewdt6GtE4IYz36n0jQACCHieAIEbnndNmRECCCCAAAJeIdBr0EuyS32D4ujBA06dr17qRG-uVn745COp1_xuCc4Tanpo1WrXsSy1cnifbbOBpBzIyX-OiA5-0VuJsuUtwRIhKvBFL1GSKyC3nI-JVQEvURIbFaWylGyVmMjIlE3Y5fUDPXvbpV0aTVvglx9sk21Dtx4QyFIpaSuzFwEEEEAAAdsJbNhgPHCjTNmytus4iy1Zy7hRrnx5uatBA6lUqZKUVEG8efKEqH9bBEqUCrw-dvSoTJ82TZYtXWp4FKtWrrAauFG1WjXR26DBg-WfI0csgRZTfp4sR9Rza0Vn9kivJGcmef6FQXJUjV0HhkydMkUFkxxM7xRT-y-cvyArli03dI6vr6_o5XIeeOhBKVqsmCV7xMX4eDl37pwcPHBANm3cJL_MmpVmW0Yzbox4fbj8888_abaR3k4_Pz8ppa7zBRUQfvr06fSqpbn_yOHDFtMWrVqmedzWO9t36CDz584z9P5buOB3WbZkqXTo2FHuV-cVL1FcChYs6JAgE1vP21XbCwkJUVlX6qQa3uXLl0VnJDJSatWqJb7qPZheySizkLP7Tx6zK3_uhgx-UU6dOpU8VMOPyT8X9O-Lixfj5cyZs3Lh_PkMzydwI0MeDiKAAAIImBQgcMMkGNURQAABBBBAwDUE9DdABr_7vrzQ9TG5mpDoGoNyoVHEn4-TCR9_IAPeeCtTo7qvczcZ-8ZrmTo3Mycd2f-36M3ZpX23HlJRLYVj73Jgz25Zp76lF38h4z8CZWYcP37yodS8q6FUUQE4OgjGlcuxQwdl819_2myIuQjcuM3Snu-zad9-JXd3eEDKVKx0W5-8QAABBBDwfIH9-4xnhihbtozLgORWgcHplcd79ZLXXh-W5mGduaBipYqib9LPmT3bUOYD3dCO7cZu4CZ3WrxECenz5JMSFRUt3379dfLudB-NZnu44447pPcTfSwBCp-NHZtue2YO_KX-_ZaQkGDolHfee08efPj2TID58uWTEiVLWm5-P9a5s2xVy0gePnQoVXtGAjf-VpnbZs2cmerc9HZE1Kghr7z2qlSuUuXmN-Ujz0XKwt9_l1FvvWV4XuO--87ynkivH1vvf-udUXJ_m7bq_WE9g2NiYqJMmzrVsulxaEe93Ioti37__blurS2bzHJb-_ftk7dHjjTdTouWLdMMxEivoWrVq8vkNLJ_6iw7Le6-O73Tbtv_w6SfRC8llZni7P71mF35c7d1y1ZZ8scfhmn156P_wIHSqEljKVe2nPjn8L_t3OjoaPnh--_l808_u21_8gt__xzJT28-Vo-IkGsqC2vKcuTwEdHLGlkr-vdOkaJFrFUTv2zpB_9YPZkKCCCAAAIuKUDghkteFgaFAAIIIIAAAkYEipcpJ70GvShfv_O2kepeV2fjqlVq_fErkiMTfxBq3LqN_PjZRw5Z2sVVLkzZKlWl-4Dn7TKca9euqQwxG2St-pbm-hVL5ZzJb_WZGdTS-XNFb7oULl5CqtxZW6rVqu2SgRyrFy00MzWrdXOrb8V6c3Hk--y3aVNEb0XVTZcmbdpZtgKFrf9x0ZuvD3NHAAEEPEUgTqWgN1pKlChptKrd6wXkDki3j7r16qV77NYDOvOBvsGvlyGxVnbuNBe4Ya09Vzp-6qSxb7JXrlI5VdBGWvPQ_pkN3Bg_blxaTaa575ln-8lzgwaJzgJya8mbL6906dbVEszRs0cPq9-w1-du2rhRfRv_jBRQS2c6ouh-pv8yS_r07GU6c4oO5Dh79qwjhunUPo4dOybfjxtvegxFixY1FbhhugMPPMGVP3fffmM98C35khQvXlzGfvG5ZJThJEwti9tCZQ1KL3AjrYwbU9TyrmmV5wYMsGTPSevYrfv075ohrwy9dRfPEUAAAQS8RIDADS-50EwTAQQQQAABTxVo80gn2fLnn7J-5XJPnWKm5qVvoA7__KtMBW3oDvV60gPfGCUjnu2bqf7d7aSAoCB56b0PJFs22_3z-IpKlbv5r9Uqs8ZS2bhqhV2ya1hz1svR6G3RzOmWqq4WyKGDWGxZfp38k6xauMCWTapvKOYQHRCiN50uPZdKmxsQGGzJZlKsdGmbvmcyM3Bnv8-Oq1Thkz7_1LLpbDWNVRBHwxYtM7VMU2bmzzkIIIAAAo4VuHr1qkoff9Fwp0HBrrOMWYD6HZ5eubP2nekdSrVffzvfSOCGXmLFU8sZg0HI5cqVN0RQTwVuTPn551R1rWXc0Jky5s35N2A51ckpdjRp2sSyJE2K3be9jKgRId1V4Mbnn3562_70Xmxcv0Ha3tcuvcM236-zp8xQwRv9nnpa1vz1l83bp0EEjAi48ufOsuSUWhrKSNHBUHN-nS-B6v941kq5cioTh_obiQ6CSlnSCtxIWYfXCCCAAAIIGBWw3V-mjfZIPQQQQAABBBBAwMYC_UeMlIGPPCDRap1kikjZylXktU8-kzzhWVsmo6Za4_uhXn1kxvjvPJ61__CRkr9w4SzPMykpSZapbBd6GZSt69e43DI-GQVy1L-3hUODEPS67MfSSImdlYuwdpltA0GsjSVb9uxyhwreKFWhopQsX0FKV6gk5atVT_UtTmvtmD3uqu-zPdu2it7GjX5XatRvIM3bd5C77r7X7PSojwACCCDgwgJxsXGmRpc7d_rLk5hqyAaVc6cTuFFGLecSGhpquIeSKtuUkRIfH2-kmlvWuXT5kqFx79yxQy0XcE38_DJO51-nXl0pXaZ0qjZLlsrYWi9dk9aN1JQN6ffhW6NGpdyd5usej_eQ7779RmUuTEjz-K07N25wbOCG7js4OFgm_jxJJk38SUarZWg8-X12qzXPXUfAlT938-fNk-vXrxvC6vvM04aCNnRj2dX_-3Twxs6dO1O1TeBGKhJ2IIAAAghkQYDAjSzgcSoCCCCAAAIIuIZAcJ5QS3aJtwb0s-sSFK4x24xH0aLjg_LkkFcle4p1WTM-K_2jXfoNkN1btqhtU_qV3PxI20c7S_2777HJLC6o1OGfjXjdJm05opFbAzkm1K5jySLhiH51H5fUzYyraXxjyVH926KfJPWt40NqXXW9JRcdMKWXGmrerr0K5jD2LdPkc40-uvr7TAeWbFBZZg7s2UXghtGLSj0EEEDATQRiYmNMjTS9YAlTjdioctt27SStoIuixYqa6iE8r7HgaJ2dJCEhQTzxpl5egwb79--XQQOfk-FvjhC93EB6JX_-_LLwjz_SO5zu_vXr1qV77NYDDRs3kkIGg7TDwsOltArM3b1r961NpPl83759ae63984rajnMkydPin6PURBwtIArf-7Wr1tviKNgwYLyWKdOhuomV6pStWqagRvWMgMln88jAggggAACRgQI3DCiRB0EEEAAAQQQcHmBEmXLy-iJU2Rk_6fl4N49Lj9eWw_QP0cOefqV16X5_e1t2rRe_3nwu6PluUcflPMm_1Bv04HYqbGKNWpKz0GD7dQ6zWYkoJen0cuOXDaRbj2j9lzlWGxUpMz96UfLdkeZsnJvhwekzSOPic7OQUEAAQQQQMDdBc7Hmcu44Uo3tCpVriR6c2Tx1MCNEiUyzoRxq_Gv8-fL6lWrpF___tKhYwfRgRG2Kps2bjTUVMOGjQzVS65UWC07aSRwI1YFbTu6HDxwUPo-8YQcUcvVObO40mfbmQ7e2Lerfu50dp8tmzcbuiSdu3axLH1iqPJ_lYYMHSpP9Xsm1SmulFkq1eDYgQACCCDgdgIEbrjdJWPACCCAAAIIIJCeQKj65teo8T_KB0NfkvUrlqVXzeP2l1bLNAwc-bYUL1POLnMLV9-Ae_6td2XEs33t0r6zGm3UsrUMHPG2ZFdr1VKcI1CwSFE5vO9v53TugF6PHtgv48a8JwumT5Wnhr4q1evWd0CvdIEAAggggID9BMzerL18ydiSGvYbMS3bQ6Bps2aWpQOMZnyIUwE_o956S95_911p0LCB3Ne-vdytMt4FBQdlenj7VbYLo4ET__xzRCaM_95wX9HRUYbqxsaYy0BjqNEMKq356y_p9_TTcj7ufAa17HdIZ49p0LChtG7TWu5RyyxSvE_AlT93u9QyJpcM_s4pWaqU6Yunf15l5WeW6Q45AQEEEEDAKwUI3PDKy86kEUAAAQQQ8FyBnLlyySsfjZXxH7wvcydN9NyJqpnp5VA69e0nHbo_bnXd6KxC1GzQQAWHjJIvRr7h9stbaIuHevWRbv2fyyoL52dRoMZdDTw6cCOZRy9J8_pTT0jDFq2k9-AhEpYvX_IhHhFAAAEEEHArgeCQEFPjjVdLo7lb0WO-qDKC6aCTy5evSGJiwm1TOHvm7G2vvfGFvnmplxmY-OOPpqavl1NbsXyFZcuuspHVq19fWqkgAL2MTWBgoKm2zCxTMu7b70y1bbTy-fOOC6D4ZdYseWXIy6aWRymslocpdscdopeFKFS4kFquJlx8fHxum968uXNl-7Ztt-1L68ULL74o3Xp0N32d0mrLXvt0YJnZ95EeS46cOe01JI9r15U_d0f_OWrYu2hRc0tkGW6YiggggAACCGRRgMCNLAJyOgIIIIAAAgi4noD-Y5S-OVpI_ZHq2_fekevXr7veILM4oooRNaT_8DeliIk0xVnsUpq3u1-Kqf7eeWGgRJ11zz9Y-_n5ydOvDbcsX5FVD87PukC7Tl0tS4roP-J7Q1m96HfZsWG9vPn1t6KXd6IggAACCCDgbgIhJgM3dACEK5czZ86oIILlsmHdejmslp7Qy08YzeLgyvNyxNiGvvqqrFu3Tvb9nbnsaTpbx6qVKy3bqJFvWbJwdOnaVSpWqmho-LExjl-mJOXAHLUU3p7de-TVl4caCtrIli2btGjZUrp27yZ16tZNOeRUr_eqZUaNBG7UqVsnU0ERqTq0446GjRrJN-PsE6Rjx2G7VdOu_LmLMbG0axECN9zqfcdgEUAAAW8S8PWmyTJXBBBAAAEEEPAugTaPdJJhY7-UvIUKeczE9dISg0a9K--oJWEcGbSRDFi2SlX5cNJ0qVg9InmX2zzmDgqS4Z9_RdCGC10xvQzPAz37uNCI7D-UuJhoebVPLzmo_khOQQABBBBAwN0EgoODTQ353Nlzpuo7ovKNGzfk1_nzpUO7-6RB3XqWLAY6m8HWLVsI2jBxAfxV9r9PPh2rshXkMHFW2lV1gM-Un3-W-9q0kecGDJAYA0uQxMU5P3AjlwMyNSQmJMoLzz2nMr8kpo13y95SpUvLslUrZeznnxkK2rjlVJ4iYEjAlT93Rpcuyqk-t2FhYYbmSyUEEEAAAQQcLUDghqPF6Q8BBBBAAAEEHCqgl_j4es5v0nfoa269PEFo3rzy1CvD5PPZ86VJ63apUtw6EjVP3nB569vvpcUDDzmy2yz1ddfd96qAk6lSvW79LLXDybYX6PLMs9Lg3pa2b9iFW4w_HyfDnuwl-3Zsd-FRMjQEEEAAAQRSC_j6-kqQCoY1Wvbu3Wu0qkPq7dyxQ1q3aCEDn-0vO3fudEifntxJ2XLlZMq0aVKyVCmbTXP-3HnS6p57ZcFvv2XYppHgjgwbsMHBsPBwG7SScROj339PjCxPUbhIEfnhp4lSyIO-tJCxDEedIeDKn7vY2DhDJDrbow7goyCAAAIIIOCKAgRuuOJVYUwIIIAAAgggYFMBncK2zSOPyTfzFkrvF16SELW2r7uUoJA80mPgIPlm_kJp_fCjolPfukLRpv2GvSFDxnwkpSpUcIUhpTmGqrXrypifpljGWajYHWnWYafzBV58b4w80qev8wfiwBFcvHBB3uz_jJw3kdLXgcOjKwQQQAABBNIVyF8gf7rHUh7Yu2d3yl1Oe62zbDz28CNyYP8Bp43BEzuuWq2azPvtV-nSravNphcVFSX9n-mXYfDG5ctXbNZfZhvKr7LH2bPs3rVbJoz_3moX2dX_zX4kaMOqExWyLuDKnzsjWWm0gA7ciIyMzDoGLSCAAAIIIGAHAdf4y78dJkaTCCCAAAIIIIBASoHsKp3v_V27S4sHH5Zfp_wssyaMF_3Nd1cs1erUkxYdH5R6ze-W7P7-rjhEy5h0Jgu9bf7zT5kx_lvZtXmjS4y1dIWK0n3g8xJR7y6XGA-DyFjAx8dHuvTrL03atJM5EyfIst_myVWVFtrTywWV4vv7j8bIwBFve_pUmR8CCCCAgAcJRNSoIQcPHDQ0o507d1m-2ax_1zuzbN60SQYNfE6uXbvmzGF4bN966YERI0fKo491UoEG42X-vHmGlvawBvLKkJelUuXKUrx48VRVzWR-0dko_FS2GJ0xxkdtfn7quc-_z_U-_dpHvU5-nnzMz89P7fOxHLv5XNf31ft9pUGjhqnGZcsdv8yaaSgzQPN77pYSJUvasmvaQiBNAVf-3OXJE5LmmNPaefrUKcmXL19ah9iHAAIIIICAUwUI3HAqP50jgAACCCCAgDMEcubKJQ_27G3JYLFg-lTZsHK5ZckCZ_8hN1x9Y-vu-zvIPSpgo0DhIs6gyXSfekkave3ZtlVmjvtWNqxakem2MnuizkZSMaKGtFKZSRq2aJXZZjjPiQJF1R-c-70-Qro-O0DmTpoosyf-IElXrzpxRPbveuncOXJP-45Suead9u-MHhBAAAEEELCBQI2aNWXm9BmGWopS32pet3at1KvvvOXqLl26JIOfH2QqaKNI0aJSRN3sDw0LldA8oaL__5BcLlw4b3j-yed4y2OlypXk_Q_GyIsvD5HJk36WubNny5EjRzI9_QsqQ1n_Z56ROSpbSsrgnzx58hhud8q0qaKDN9yt_Db_V0NDrluvnqF6aVW6cZ0lI9JyYV_aAq78ucujflYbLadPn5Gq1YzWph4CCCCAAAKOEyBww3HW9IQAAggggAACLiaQOzDQEsChgzguX7woOzZtkG3qD8vb1v0lxw4dsvto9be2SleqrG7Y1hKdYSOiXn3LN7fs3rEdO6hYPUJeG_u5nD5xXLavXyd7Nm-SnSoLx9mTJ-3Sa94CBaTmXQ2lVsPGUr1uPckVEGCXfmjUcQL7d-6QmRPGybplS-X69euO69iJPX359kj5ZNos9W1PPyeOgq4RQAABBBAwJlCrVi1jFf-rNfuXX5wauDFv7lw5evSooTHr5T4eevhhdUMv_Tt6x48fJ3DDiqb-JvuA5wZath3bt8vcOXPUNld0II_ZopcL0RlTat15e5BrSEiw4aa2bNnidoEb8Spo5cyZM4bmWKhgIUP10qqk389GSsrAGSPnUMfzBFz5c2cmqOTUyROed3GYEQIIIICARwgQuOERl5FJIIAAAggggEBWBfQN_zqNm1o23VbU2bOybb0K4lizRnZu2ShRp08bSlOb0Tj0Ui3lKleTyrXulCrqD97lq0Xc9u29jM51t2MFixSVgh2LWpZ70WOPVH903K0COHZt2SR_b98mMVGREh933nA2Bb1cTJ6wMAkJC5fQ8LxSqUZNqdWokRQvU86laELz5pU5W3a61JjcZTBHD-yXiZ9-IutVBhxvK8cOHZQdG9YZXtqH95m3vUOYLwIIIOBaAmXKlhWdLl9nQzBSdNaA5194QQqogFtnlHkqaMBIeUlliXjyqaeMVHWJOjduuEemBB0Eo7chQ4fKsqXLZOqUybJcPZopy5ctSxW4kdfEMgdbVeBG23btzHTp9LonTQS-R2YiICZ5ggf2709-muFjaKjxbAYZNuSCBz__9FOVGWhdqpG1btNGOnXpnGq_N-9w5c9d4SKFDV-aX9Xvpe6PP264PhURQAABBBBwlACBG46Sph8EEEAAAQQQcCsBvWxJ83b3WzY9cL1cw7kzpyXy1EmVPeKURJ07KwmXL0nClQS1XVbPr6j0y0kSEBwsISpFZ4hKqxySRwUahIdJsPojV0houOXRW79RrzNjNG7d1rLd-ka4cvmyXIiLk_jzejuvgjni5FJ8vOhsKHnCw_8L1ghTr4NuPY3nHiRwNTFRpn37lcyaMF6SkpI8aGbmprJm6R-GAzfMtUxtBBBAAAEEbCugv3nftHkzmacyKBgpeqmSkW-MkM--_MJIdcN1zqt_O86YNl169emd7jmJ6t8Z69etT_d48oFChQq5VdCGHnec-nezOxW9rOG9Le61bCuXr5DXXn1VTp4w9q33kydSZ--LUEskGi1r_lpjtKrL1ItX_ycyWvbu3WO06m31oqOjRW9GSj71_2NPLRN_nCiR586lml6FihVS7fP2Ha78uaseESH654yR_1Nu2rhRdu7YIVWqVnXoJfXzNZZh8ZL6WxMFAQQQQMA7BQjc8M7rzqwRQAABBBBAwKRAtuzZpVDRYpbN5KlUz0BArxeut3wFC2ZQi0OeKnBk_98yeshgOX74sE2mqN9HwaFhmWrrxo3rKkArSXQgydXEBImLjZGrCYmZaiszJ61dtkSeGjos1frtmWmLcxBAAAEEELC3QI_HexoO3NBj-X3BAvll1izp-MADNhna_Lnz5O23Rsq5s-ekWLFicm_LFmm2e1Zl0TOy9FrV6ukvjZJmw3bcmT27sT_Xms2yYDRIwsjUfpk5U0a_936qqhE1IuSLr79OtT_ljsZNm8i8336Vdq1ay6lTp1IeTvU6TgV5pyx58-WV4sWLyz___JPyUKrXe_fsUZk-psijjz2W6pir7ghT2QaNlh3bdxitelu9X2bOuu11ei9y5swpgSqw3hOLXoonraANT5yrLebkyp-73LlzS-UqVWTb1q2Gpjph_Pcy5qMPDdVNr5LOfGRmGaEw9cUeI8VoRisjbVEHAQQQQMC9BIz9T8C95sRoEUAAAQQQQAABBBBAwMUFNq9eLe-__IJcvngxyyPVgVU9Bjwv7Tp3FV9f3yy3l9xA_IXzEnn6lBzas1f27dou65cvsyyjlHzclo-xkVGyd9sWqRhR05bN0hYCCCCAAAJ2EdA36KtVry7bt20z3P6QwS9abnB16NjR8DkpK65auVI--ehj0UtfJJeRI0ZIw8aNJJcKBk5ZdOCGkeKf3d9INUudyZN-Nlw3MxULFyli6LR_jhyReLVcTaBatiajclVlDnxTZTyZpYItbFUuXbosadnuUjfBjZaQkBBpd9998u0331g9JVxl4kur1FTLTxoJ3NDnvvfOO3LPPfdIuFraMLPlxPETsmjhQunZu1dmmzB8XrhaHtJo0Z9DHUzT8cEHjZ4ix48fl48_NHbT2tFZCQxPwgYV9c8UijkBV_7c1alTx3Dgxq_z50uPno9blnIyJ_BvxqP333nX8jvtrXdGGT7d6Oc6Sv3fkIIAAggg4J0Ctvurpnf6MWsEEEAAAQQQQAABBBAwKbBg-lQZOfAZmwRtFCp2h7z_489yf9fuNg3a0FMKDAqWEmXLS_P721uyYXy34A95beznUrh4CZMzNlZ956ZNxipSCwEEEEAAARcQeLxXT1Oj0JkvXhz0grykAjjOpbEsQXqNRZ6LlK---FKaN24iPbv3uC1oQ59z8uRJGfvxJ2me7u9vLCBj399_p3n-rTsTEhLkuf4D5Osvv7x1t82flyhRwlCbl9WSg9PVUjEZFb0cwCMPPiSTJ03KqJrNjp05fdpQhpPkDmPjYpOfZvhYQC27mFZp2bpVWrvT3Hc-7rw83bevJWAhzQoZ7Fy7Zo0M6PesNG_SRN4eOVItv7Mug9q2ORQUHCR6CR-jRQfnHDGYxU4vj_LSC4NFv4eMlJatjDsbac-V6qxcscKVhuMWY3Hlz137jh0MG-qgts6PPiaLFy02fI5efmvct9_J3U2aWrL4TJs6VfbsNr5UUV6DgWOb1f8L9e8cCgIIIICA9wkQuOF915wZI4AAAggggAACCCDgNIG_liyWr0aNNPVH_fQGq5cvGvPTZCldoWJ6VWy6X2fzqN2oiXw8ZYY0uLelTdvWjcWYuIll885pEAEEEEAAAZMCrdu0kXLlypk6S6eVnzVjhtzTtJk8N2CAzJ0zx5IxIT4-3tKOvpF25swZ2bhhg3yrltzo06uXNKxfX8a8_74cPXo03b6-HzdO9u_fn-p46dKlDaWx37dvnyxeuCjV-ck79Lfy72_bVubPm5e8y26PevkPo-X9d9-VH77__rYb8Npp4e-_S68ej8ujDz0sO7ZvN9pcluslJSXJaQNLn-iOdPaKpUuWGuqzfIUKada7W2XQMBroohvYvGmztG3ZSgWy_Jzhv0V1QIO-mTt0yBCpV7uOdO3UWX779Ve5du2aZRwfjB6T5nhsvbNJ06aGm9RLK7Rt3Vo-GD1aLqaT0U5__qb8_LPc26y5qeCTFi1t_-9ewxMzUfHSpYty6OAhw5u-4a5vkFPMCbjy565CxYrSqHFjwxPSn_V-Tz0l33z1lVy5ciXd8w4cOCAfjhljCdh45-23JTb236AzHZD49sg30z0v5YHwvGlnD0pZT49r5vQZKXfffL1h_Xr5aeLEm695ggACCCDgOQI-O6Pjb3jOdJgJAggggAACCCCAAAIIuKrAPwf2yUvdu8gV9YeorJZcAQHy_g-T5I7SZbLaVKbOT1TfgHqpR2c5bOAbukY7uOueFjJktLGU1UbbpB4C3iJQOTTAW6bKPBFwKQGdqaJj-_aScCXr3wzOrpY-04EbmS21VYr8ydOmpjq9ScNGKkjgeKr9KXfkzp1bBj7_vLS9r50ULFhQ9FIkmzZukt9--1WWL12Wsrqh16vXrrG0Zajyf5X0zfUq6uajGVMfHx_RS6ycj4sTfQM_K0Xf9Bz_w4QMA14mTfxJhg8blmY3T_d7RvSN_pKlSklgYGCqOnFqjL_Omy9fqcwlJ0-cSHU85Q59XdZt2pjmUji67sQff5QRrw9PeZrV1zlz5pRy5ctLBRUUkjdfXjl18pScUOM5efKECj45LToIJaMyfsIEady0SUZVsnxs2dKl8kSv3qbb0e6ly5SxBLUUKVrEsqzNoYMHRd981plHzJQWrVrKF-qmtjOKDsKYMvlnmfTTT6Y-D7Yaa68-veWV114z3NxutVSQDvAyUjZs2SyhoaFGqhqu48j-Xflz99eff0r3Ll0NuyVX1D9r7mrQQIqon6VBwcFyVgUR6oxOx1QwnLUlmb5USz7d2-Le5KbSfdy5c6d0aHdfusdvPaC_NKB_ntatV0_CwsIs2YJ0wMaSxX_IEfX7Sf_OXLZqpenfMbf2wXMEEEAAAdcTIHDD9a4JI0IAAQQQQAABBBBAwOMELsVfkOcefUjOqD-G26K88tFYqdu0uS2aynQba5ctlXcGDcj0-SlPrBhRQ979nm9OpXThNQJGBAjcMKJEHQTsI6C_9fvGsNft07iJVvVNtwWLFom-UX1r6f3447JiubnlELIaRJLcv5-fn1SqXFlq16kttVXmhjvVo5Gbte3btZNdO3clN-Pwx5CQEKlTt67lhqG-aVihYoXbAjkyCty4dbC6nWB1AzS3CrjVQTmRkedMBw50fOABGf3hB7c2e9tz_S35-9u2U1kWDt62394vqlStKrPnzbV3N5abvPpmrzOKDm5ZtOQPS1CQo_rXS1H8vmCBygwy2VRWEHuMz0jgxtmzZy030hernz16SR09fiNF_4ypWq3qzc9YrTvvTDc4KaP2nNW_q3_unnriSfljsfElUDIyNnJMZ0r6_Y_FlmCKjOrrDB2N72ogp9WyUrYoj6usVK-9nnYQnS3apw0EEEAAAccLELjheHN6RAABBBBAAAEEEEDA6wSmffeNTPp8rE3mXVN9E2r4Z1_bpK2sNKK_idmteSO5lMVvtiaPQS_98tW8BckveUQAARMCBG6YwKIqAnYQePbpZyw3W-3QtKEmCxUqJF99961UVkESKcsnH30sn37yScrdTnu9aMkSKVW6VIb962U5BvR7NsM6jjyoAzAWLF4k-fPnt3RrNHAjq2MMCgqy3AwtUKBAhk3t3bNHHuzY0eFZGXQmCp2Rwp5FBwPopVqcUYYMfVme6NvXoV03btDQUCYWRwwqo8CNRb8vlG_Uck7btm4VnSUnqyU5kENnq-nz5JNWm3N2_3qArvy5O3_-vCX7yfFj1rMtWcU2WOFVlYWoZ-9eVmvrJVe--Oxzq_WMVMiVK5es_OtPQwGBRtqjDgIIIICA8wV8nT8ERoAAAggggAACCCCAAAKeLJCgvgk5_-efbDbFVg89arO2stJQtmzZpEDhwllp4rZzk_5bN_22nbxAAAEEEEDADQQ--exTeaxTJ6eMtGGjRjLn1_lpBm3oAfV-oo9NU8lbliXJwu__a9evWXVqo5ZbiKhRw2o9MxV0Bo3CmRy3Xt7EaCYBM2OyVnfoa6-KtaAN3UYFtbTMaw7O-qIzkVSvEWFtClk-Xq9-fctyCVluyGQD-pv8jg7a0EPM6lI_JqeZ6eorV66UrVu22CRoQw9CZ6TZvGmzTJ82zdCYnN2_HqQrf-50pp-xn30mOmuMI0qVKlWkpcEgroceeeS2DEZZGd9ltQTpD99PyEoTnIsAAggg4GICBG642AVhOAgggAACCCCAAAIIeJrA4tkzJS4m2mbTKl-1ms3aympDofnyZbWJm-eH57ddWzcb5QkCCCCAAAIOENBLgrz1zih5-ZWhNrshZW3YOhuD7nPCxB8lLCws3eqBgYHy-htvpHvczIHgkGD5Qn3L_pn-9s-GoS1tVXRQjXYqW66srZq0ezsvv_qKPPKo8WDdTl06y6j33rW6VEFWB67fd2-MfFMmTZlsKKgkq_3p81948UWHBkZ1696d5RdsceG8oA1X_txVq15dJk-bejNTkD0uh6-vr-jPy7SZMw0vKXTHHXdIvfr1bDacPbt326wtGkIAAQQQcL4AgRvOvwaMAAEEEEAAAQQQQAABjxZYOme2zeaXU6WDzROe12btZbWhKxcvZ7WJm-eH5cs4DfjNijxBAAEEEEDARQV0iv_vxo-XMmXL2G2EekmBzl27yKKlSwzfzNbLWdzbokWWxlS7Th35dcEC1c690qhR4yy1ZeTkO2vXNpR2P6O2dEDLZ19-YQlw8ff3lxIlSmZU3SWO6cCI90aPlj5PPGF6PDrQY8LEiXZZNkC_77p06ypLViyXrt26mR5bVk_QQUrDhr9u1wwCeVVA8udffSnD3xyR1eFyvhcJuPLnrmq1ajJr7hypUrWqza-IDgzRbevPi38Of1Ptvz5ihASprCBZKQEBAZa-v1bLhFEQQAABBDxHgMANz7mWzAQBBBBAAAEEEEAAAZcUOH7ksM3GZSS9uM06M9BQ9NkzBmoZqxKen8ANY1LUQgABBBBwZYEmzZrKgkWL5IOPP1KBAiVsNlSdOaNTly6ycMkf8uZbb0k-k1mvxn7-mQwaPFhy5MxhakzFixe3BBLoDAuF_ltqpEjRIlKqdGlT7WSm8qvDhsmXKsNHaGioqdNDQkLk-RcGyVIVZNCqdeub5xYvUfzmc1d7or-5fn-H9paAnAcffijTw6tbr66a9wrpP3Bglm-M6kHom6t9nnxClq1aKSNGjswwu0umB23wxB49e8r8Bb9J0-bNRHvZqujPls4asPCPxWq5h1a2apZ2vEjAlT93BQsWlFnqiwRjPvrQJr-Tat15p6WtmbN_Eb1ESmZK2bJl1c_2ryRPnjymT9e_w7r36GH5Xag_txQEEEAAAc8SyOZZ02E2CCCAAAIIIIAAAggg4EoCkWfOSMKVKzYb0tWERImLjpKQsHCbtZnZhmIiI-XsqZOZPT3VeeH586faxw4EEEAAAQTcUcDHx0fad-gg7e67T5Ys_kNWrlwpf61eLUePHjU1ndy5c4u-SabbadOureRSmbcyW3TGhGee7Sft7r9Phr82TFapMWVUSpYqJU8_84y079hB9FIwKUujxo3lxInjkjNHTksWhJw5c0qOHDlUYMj_X1v2qZts-jF5CzMZhHFvyxZSvUaEDB0yRFYuXyE3btxIOZSbr_Orf0t0Uzf0uvXoLvpmfMqiM25oBz0WfzVWy_gsj2rc_73W-5OfWx7V_PSNQp0JI7nom_v6G-Y7d-yQvbv3yL79--XC-fPJh0096uws97fvIB0ffEAKFSpk6tz0KgcFB8nA55-TXr17y9SpU2TVipWyaeNGuWLw36T6ZupdDRpY3ndNmzUz_W369MZli_0lSpa0ZLU5cfyETJn8s8yfO0-OHTtmumn9PqimshE8oIJk7rv_ftGfNQoCWRFw5c-dDnTq0LGj5b0-f948y--lv_78U2JjYw1NWf9s7fjgg_KQ-rzo3w22KPXq17cES72tAhEXLvhdEhISMmy2UuVKcs-9LaSLyjgVntd1MlBmOGgOIoAAAgiYFvDZGR2f_r_2TTfHCQgggAACCCCAAAIIIIDA_wW2r18rw_r2-f8OGzwb9ukXcmdD-6cotzbUGeO_k4mffmytmuHjg98dLY1a_v9bsYZPpCICCEjl0AAUEEDADQT0DeZ1a9bKKRX4GB0VLTExMRIdHS0XLlyQYJXZICw8TGU0CJciRYrInbXvlMrq28xpBU3YYqrnVaDBwQMH1XbAsp1RWbTCw8OlWLFiclfDhlKmjP2We8ns-M-dO2cJ3jh8-JBEqgDSxMRES-aRwioTSJ269aRipYqZbTrL58XFxVkCCE4cPy4nT5y0XNNLly5KfPxFuXgx3hJwEhQU_O91Vku46JuQVapUVRkt_h8QkuVBZNCAttqyeYscOnhQve_-fe_FRMfI9RvXVUYT_b4LlcLqfRcREWGzG7MZDMemh_RnaMe27bJ9-zY5c_qM6Pe23vTnytfXx2IerLKw6EwsJVXgR7XqEeqzVVn08jkUBOwp4MqfOx0Et2vnTtm9e_d_v4-iLY9J15IkT0geCVEBXKVVZqUqVavY_WdCfHy8rFi2XA6qn0_65_yFC-clXP0uzKcCRgoVLiQ6yKNAAbIz2vO9StsIIICAqwgQuOEqV4JxIIAAAggggAACCCDggQLLfp0nH7821KYzq1H_Lnnji29s2qbZxs6dPi0vdH5E4tQf_m1RsmXLJj8sWSGBwSG2aI42EPA6AQI3vO6SM2EEEEAAAQQQQAABBBBAAAEEPErAdovheRQLk0EAAQQQQAABBBBAAAFbCISbXH_eSJ9b1vwlq35fYKSqXepcvnhR3hk0wGZBG3qQNeo3IGjDLleLRhFAAAEEEEAAAQQQQAABBBBAAAEEEHB9AQI3XP8aMUIEEEAAAQQQQAABBNxWIF-hwnYZ-0evvSwrFsy3S9sZNbp7yyYZ8EhHObhnd0bVTB9r1JolUkyjcQICCCCAAAIIIIAAAggggAACCCCAAAIeIsBSKR5yIZkGAggggAACCCCAAAKuKJB09ao8WKeG3YZWpVZt6fxMP6lUo5b4-PjYpZ_r16_LxtUrZeGMabJp9SrLGu227Mg_Rw6ZuHSV5Myd25bN0hYCXiXAUiledbmZLAIIIIAAAggggAACCCCAAAIeJ5DN42bEhBBAAAEEEEAAAQQQQMBlBLJlzy5harmU6HPn7DKmnZs2yCu9H5eQsHCp07iJlK1cRYqVLi1FSpSUkNAw033qQJOoc2flzIkTcmDnDtm7fZvs3bbVpsuipBxU3WbNCdpIicJrBBBAAAEEEEAAAQQQQAABBBBAAAEEvEiAjBtedLGZKgIIIIAAAggggAACzhAY2quH6CVGHF2yZcsmgSF5JCgkWAKCgiRbNn_x9fOTbNn9xMfXV5ISkyQxMUGuJiSox0SJi45WW5RDh5kzVy4ZO2O2FChcxKH90hkCniZAxg1Pu6LMBwEEEEAAAQQQQAABBBBAAAHvEiDjhnddb2aLAAIIIIAAAggggIDDBZq2beeUwI2kpCSJjYq0bA6ftMEOuw14jqANg1ZUQwABBBBAAAEEEEAAAQQQQAABBBBAwFMFfD11YswLAQQQQAABBBBAAAEEXEOgWbv7JTA4xDUG40KjqBhRQ9o-2tmFRsRQEEAAAQQQQAABBBBAAAEEEEAAAQQQQMAZAgRuOEOdPhFAAAEEEEAAAQQQ8CIB_xw5pOVDD3nRjK1PNXsOfxnwxkjx8fGxXpkaCCCAAAIIIIAAAggggAACCCCAAAIIIODRAgRuePTlZXIIIIAAAggggAACCLiGQJtHOoufn59rDMbJo_D19ZV-w0ZI4eIlnDwSukcAAQQQQAABBBBAAAEEEEAAAQQQQAABVxAgcMMVrgJjQAABBBBAAAEEEEDAwwXyFiggXfoN8PBZWp9edn9_GTL6I2nW9j7rlamBAAIIIIAAAggggAACCCCAAAIIIIAAAl4hQOCGV1xmJokAAggggAACCCCAgPMFHuzZWy2Z8ojzB-KkEeTMnVuGf_al1Gt-t5NGQLcIIIAAAggggAACCCCAAAIIIIAAAggg4IoCBG644lVhTAgggAACCCCAAAIIeKjAU0NfkzsbNfbQ2aU_raCQPPLWN-Olau266VfiCAIIIIAAAggggAACCCCAAAIIIIAAAgh4pQCBG1552Zk0AggggAACCCCAAALOEfD19ZUX3_tAqtWu45wBOKHXOo2byphJU6Rs5SpO6J0uEUAAAQQQQAABBBBAAAEEEEAAAQQQQMDVBXx2RsffcPVBMj4EEEAAAQQQQAABBBDwPIHfpk2WHz75SK5cuuR5k1MzKlaqlPQe_LLUqH-XR86PSSHgSgKVQwNcaTiMBQEEEEAAAQQQQAABBBBAAAEEEDAlQOCGKS4qI4AAAggggAACCCCAgC0Fzp06KZ-PfEO2rPnLls06ta2AoCDp9NQz0ubRzuLn5-fUsdA5At4iQOCGt1xp5okAAggggAACCCCAAAIIIICAZwoQuOGZ15VZIYAAAggggAACCCDgVgJ_Ll4ov0-fKts3rHercd862CIlSkrjVq1VwEYnCc4TeushniOAgJ0FCNywMzDNI4AAAggggAACCCCAAAIIIICAXQUI3LArL40jgAACCCCAAAIIIICAGYHTJ47Lktm_yNJ5syXyzBkzpzqlbnj-_NKoVRtp3LqtlK5Q0SljoFMEEBAhcIN3AQIIIIAAAggggAACCCCAAAIIuLMAgRvufPUYOwIIIIAAAggggAACHipw48YN2bp2jezYuE72bd8u-3ftlCuXLzt9tr6-vqIza1SqWcuSXaNyzTvFx8fH6eNiAAh4uwCBG97-DmD-CCCAAAIIIIAAAggggAACCLi3AIEb7n39GD0CCCCAAAIIIIAAAl4hcP36dfln_375e_s2-XvnNjl19KglI0fMubOSlJRkF4OAoCApWa6ClChXXj2WlxLly0vxUmUkew5_u_RHowggkHkBAjcyb8eZCCCAAAIIIIAAAggggAACCCDgfAECN5x_DRgBAggggAACCCCAAAIIZFJAZ-aIi4qWyLOnJersGct28UK8JCYkyNVEtSUkSuLVRElSrxMTE9W-RPHPkUNyBQRI7sBAya0ecwXox0D1mPvm87wF8kvegoUyOSpOQwABRwsQuOFocfpDAAEEEEAAAQQQQAABBBBAAAFbChC4YUtN2kIAAQQQQAABBBBAAAEEEEAAAYcLELjhcHI6RAABBBBAAAEEEEAAAQQQQAABGwr42rAtmkIAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBAwIUDghgksqiKAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAArYUIHDDlpq0hQACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIImBAgcMMEFlURQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAFbChC4YUtN2kIAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBEwIELhhAouqCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAgh4okBSUpInTos5IYAAAggggAACbiGQzS1GySARQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEDApgK7d-2Wz8Z-Ijt37JSTJ09Kvvz5pHTp0tLnySelabNmNu2LxhBAAAEEEEAAAQTSF_DZGR1_I_3DHEEAAQQQQAABBBBAAAEEEEAAAQRcW6ByaIBrD5DRIYAAAggg4IICX37-hXzy0UeSXqaNRx97TN5-9x2HjvzGjRtyYP9-uXLlyi1bgiQkv064op6r1-oxrTr1G9wlj3Xq5NAx0xkCCCCAAAIIIGALATJu2EKRNhBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQcBOBP1evlg9Gj85wtFOnTJGWrVpJ46ZNMqxny4MXL16U1i1aZrrJ0LDQTJ_LiQgggAACCCCAgDMFfJ3ZOX0jgAACCCCAAAIIIIAAAggggAACCCCAAAIIIICAYwVeHTrUUIeff_qpoXpUQgABBBBAAAEEEMiaAIEbWfPjbAQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEE3Ebg1KlTcvzYcUPjPXDggKF6VEIAAQQQQAABBBDImgBLpWTNj7MRQAABBBBAAAEEEEAAAQQQQAABBBBAAAEE7Cxw9epV2bRxkxw7dlQiz0VKVFSUREaek5joGAkIyC1h4XklPDxMbeESFhYuefPlk0qVK0lwcLCdR-Z-ze_ds8fwoOPi4iQ2Nlby5Mlj-BwqIoAAAggggAACCJgXIHDDvBlnIIAAAggggAACCCCAAAIIIIAAAggggAACCNhZ4PTp07Ji-XJZsWyZ_Ln6T7l48aKpHn18fKRkqVISUaOGRERESI2aNaVipYqm2vDEypcvXzY1Le1IQQABBBBAAAEEELCvAIEb9vWldQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAETAieOn5APx4yRuXPmyI0bN0yceXtVfe6hgwct26wZMywH8-XPJ02bNZPWrdvIXQ0bSLZs3vcn8pIlS90OlcGrwoULS0hISAY1bHsoV65cMvzNEbJuzVpZv26dREdH27YDWkMAAQQQQAABBFxUwPv-VeqiF4JhIYAAAggggAACCCCAAAIIIIAAAggggAAC3iwQExMjX3z2mUya-JMkJibaheLc2XMyfeo0yxYWFiYjR70tLVu1sktfrtpoiZIlJHv27KKXn7FWqlavZq2KTY_7-flJt-7dLZtueP--fbJ27VqZ-MOPlgAcm3ZGYwgggAACCCCAgAsJ-LrQWBgKAggggAACCCCAAAIIIIAAAggggAACCCCAgBcKbFi_Xu5t1ly-HzfebkEbKVl1Nocjh4-k3O3xr3VWi8d79rQ6zxw5c8igFwZbrWfPCmXLlbMEcdS6s5Y9u6FtBBBAAAEEEEDA6QIEbjj9EjAABBBAAAEEEEAAAQQQQAABBBBAAAEEEEDAewV-nTdfHu_WXWJjYx2O4O_v7_A-XaHDZwcOkNJlSqc7FF9fX3n1tWEZ1kn3ZA4ggAACCCCAAAIImBYgcMM0GScggAACCCCAAAIIIIAAAggggAACCCCAAAII2ELg26-_lucGDJCEhARbNGe6DW8N3AgICJB5v_4mfZ9-WkJCQm66-fj4SNVq1WT6rJnSuWuXm_t5ggACCCCAAAIIIGBfgWz2bZ7WEUAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBILTBt6lR57513Ux9w4B7_HN6ZcUMT67m_OOQlyxZ5LlJOnzktpUqVkty5czvwCtAVAggggAACCCCAgBYgcIP3AQIIIIAAAggggAACCCCAAAIIIIAAAggggIBDBQ4eOCgj3xiR6T6DQ4Ilf_78kidPqFy5fFni4-MlLi5OYmJiTLWZI0cOU_U9tXLefHlFbxQEEEAAAQQQQAAB5wgQuOEcd3pFAAEEEEAAAQQQQAABBBBAAAEEEEAAAQS8UiAxMdGyPMplFXBhppQrV04efPhhad2mtRQuUiTNU-MvXJCDBw_Krp27ZP36dbJ44aIMl2Hx1qVS0sRjJwIIIIAAAggggIDTBAjccBo9HSOAAAIIIIAAAggggAACCCCAAAIIIIAAAt4nMOb992XP7t2GJ66zYvQfOFCe6Puk-Pn5ZXheYFCQVI-IsGydu3aR_s_0kwW__ZbuOQRupEvDAQQQQAABBBBAAAEHChC44UBsukIAAQQQQAABBBBAAAEEEEAAAQQQQAABBLxZICoyUiZN_MkwgQ6sGDdhgtSrX8_wObdWbNqsGYEbt4K42PPr16_L2bNnJSY6RmJjYyxL3Vy5fEXyhOaR8PBwKVGypISEhLjEqBMSEuTcuXMSeS5SoqIiJS42TgIDAyU0LFTCwsKlaLGiwtI7LnGpGAQCCCCAAAJuKUDghlteNgaNAAIIIIAAAggggAACCCCAAAIIIIAAAgi4n8CPP_yY4dIlKWc05qMPMx20odtq0rSp-Pj4yI0bN1I2bXltNOPGjGnTRS_xcvWq2pKS5GriVUlKuqpe6029tjwmSlLyc33MUidJatSsKX2ffirN_n-ZNUsuX7psaStRt5FGu5Z-1H5LH7e0W6VqFXl2wIA0271158YNG-TA_v2i208en24z8b_xWeak29fzUvO7rY4655vvvhNfX99bm8zS831__y1__fmX2v6UDevXywW1vE1GpXDhwpaxZ1THXsf279sny5ctk2VLl8nmTZvUdUpKtysdtFHrzjulYaOG0qpNG7njjjvSrcsBBBBAAAEEEEAgpQCBGylFeI0AAggggAACCCCAAAIIIIAAAggggAACCCBgcwGdseDnn4xn22itbn63ads2S-PImy-vVK5SRXbu2JFmO_7-OdLcn3LnsFdftQROpNxv5HXOnDnTrTbi9eESHx-f7nFbHJgxfbrowJPMFp0VwxaBG2vXrJWPP_xQdCCJmXLy5Ekz1W1SV4_x3VHvyNYtWwy3p9_fOhhFbx-O-UA6PviA9FeBNYWLFDHcBhURQAABBBBAwHsFbBcm672GzBwBBBBAAAEEEEAAAQQQQAABBBBAAAEEEEDAisCsGTMtS2FYqWY5nD17dhk85CUjVa3Wada8ebp1jGbcSLcBDlgVOHzokHTt1MmymQ3asNq4jSscO3ZM-vZ5Qh57-BFTQRsph6Ezc0yfOk3uadZc9PueggACCCCAAAIIWBMg44Y1IY4jgAACCCCAAAIIIIAAAggggAACCCCAAAIIZFlg3ty5htto2aqVFC9e3HD9jCq2btNa_v57b5pVQsNC09zPTtsIrFu7Tp7p21fi4uJs06AdW9m2das82buPREVF2awXvbzOS4MHy-HDh-SFF1-0Wbs0hAACCCCAAAKeJ0DghuddU2aEAAIIIIAAAggggAACCCCAAAIIIIAAAgi4lIC-gb1t21bDY2rZupXhulNsLhcAADjHSURBVNYqlitfXr746itr1ThuY4E5s2fLyy--lOklZmw8nAybW7pkiQx8tr9cvnw5w3qZPfjl519IUFCQPPnUU5ltgvMQQAABBBBAwMMFWCrFwy8w00MAAQQQQAABBBBAAAEEEEAAAQQQQAABBJwtsHPHDkm4kmBoGDly5pCmzZoZqksl1xTYsX272wRt6LH2e-ppuwVtJF-hD8d8IFs2b0l-ySMCCCCAAAIIIHCbAIEbt3HwAgEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQMDWAuvXrTfcZJUqVSVXrlyG6zui4rSZM-SZZ_tJ2bJlbdrdpKlTpF___qKzgtirDFZZL0a-_bY0btJE_P397dXNzXZ11ornBz7nFpk2Ll68KM_1H-CQsSYlJcmLL7wgN27cuGnFEwQQQAABBBBAIFmApVKSJXhEAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQsIvAhg3GAzdsHRxhiwlVrVZN9DZo8GD558gRWbxokUz5ebIcUc-tlYxu1FeuXFn09vwLg-To0aOyeOEimTplihw6eNBas4aP582XVzp16WzZ4i9ckOXLlsu8uXNlyR9_GG7DTMV3VJDIkcOHzZxiqRsaGioFChaUbH5-cu7cOYmMjJRr166ZbsfMCSNeHy7__POPmVPET42vVKlSckFZnj592tS52kVf4xatWpo6j8oIIIAAAggg4PkCBG54_jVmhggggAACCCCAAAIIIIAAAggggAACCCCAgFMF9u_bb7j_MjbOamG4Y4MVi5coIX2efFKioqLl26-_tnqWj4-P1Tq6wh133CG9n-hjCQj4bOxYQ-eYrRQYFCTt7r9PypYra5fAjSgVbDFj2nRTw-rWvbt07tY1VTYTHfCye_du-WPRYpk-darpIAlrg_h7716ZNXOmtWo3j0fUqCGvvPaqVK5SRXLkyGHZH3kuUhb-_ruMeustSUgwthTQuO--I3DjpipPEEAAAQQQQCBZgMCNZAkeEUAAAQQQQAABBBBAAAEEEEAAAQQQQAABBOwiEBcba7jdEiVLGK5LRdcSmDJ5siQmJhoalA5oGf7mCOnarVua9fXx5Iwkp0-fUsEb09Ksl9md48eNM3yqXibnuUGDxNf39tXndTaTLiroRAdz9OzRQy6cP2-1zU0bN8qZM2ekQIECVutSAQEEEEAAAQS8R-D2f2V4z7yZKQIIIIAAAggggAACCCCAAAIIIIAAAggggIADBK5evSoXL1403FOQygpBcT8BvazJ5Ek_Gxq4DsoY89GH6QZtGGokC5V0pox5c-YaaqFJ0yaWJXJSBm3cenJEjQjprgI3jJaN6zcYrUo9BBBAAAEEEPASAQI3vORCM00EEEAAAQQQQAABBBBAAAEEEEAAAQQQQMAZAnGxcaa6DQgIMFXfFpWTkpIsS13Ex8dLXFycqUATW_TvCW1s3bLF8HIm9erXk_YdOjht2nNmzzaUGSR37tzy1qhRhsbZ4_EekiPnv0uoWDth4wYCN6wZcRwBBBBAAAFvE2CpFG-74swXAQQQQAABBBBAAAEEEEAAAQQQQAABBBBwoEBMbIyp3nJnMnCjR9ducunSRUlKuibXriVJ0lW1qSwQSSrjR_KjzgpxNemqXFN1kv6ro_elLA898rC8-_77KXfzOgOBrVu2ZnD09kMPPPTQ7Tsc_Gr9unWGemzYuJEUKlzYUN2w8HApXbq07N6122r9ffv2Wa1DBQQQQAABBBDwLgECN7zrejNbBBBAAAEEEEAAAQQQQAABBBBAAAEEEEDAoQLnVQYLM8Xf399M9Zt1N23cKFeuXLn5mieOFdAZN4yUwMBAadW6tZGqdquj3ytGSsOGjYxUu1mncOEihgI3YmNjb57DEwQQQAABBBBAQAsQuMH7AAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQMBuAmYDMS5fumS3sdCw_QS2bTWWcaNho0aSK1cu-w3ESsv7VbYLo4ET__xzRCaM_95Ki_8_HB0d9f8XGTyLjTGXhSaDpjiEAAIIIIAAAh4iQOCGh1xIpoEAAggggAACCCCAAAIIIIAAAggggAACCLiiQHBIiKlhXbx40VR9Kjtf4KpajubkyZOGBlKgYEFD9exVycwyJeO-_c4uwzh__rxd2qVRBBBAAAEEEHBfAV_3HTojRwABBBBAAAEEEEAAAQQQQAABBBBAAAEEEHB1gRCTgRvx8QRuuPo1TTm-CyYCEfLmzZvydIe-jo1x_jIl2bJnd-ic6QwBBBBAAAEEXF-AwA3Xv0aMEAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQcFuB4OBgU2OPiow0VT-5ckBgYPLTLD_mzpU7y214UwNmMkiE5w13Kk1cnPMDN3LlzOlUAzpHAAEEEEAAAdcTYKkU17smjAgBBBBAAAEEEEAAAQQQQAABBBBAAAEEEPAYAV9fXwkKCpILFy4YmtO-fX9LW2lnqO6tlVav-UvWr1snfyxaLEv--MPw0h3JbRQpWlTatG0rbdu1lSpVqybv5tGAQFxcnIFa_1ZxdsaNmJgYw2O1V8WwcOcGr9hrXrSLAAIIIIAAApkXIHAj83aciQACCCCAAAIIIIAAAggggAACCCCAAAIIIGBAIH-B_IYDN_bu2WugxdRVsqvlJxo0bGjZhr85Qnbv2i09u3eXqKio1JVT7Jk5-xepHhGRYi8vjQpcvOg-y9tcvnzF6LTsVi9__vx2a5uGEUAAAQQQQMA9BQjccM_rxqgRQAABBBBAAAEEEEAAAQQQQAABBBBAAAG3EYioUUMOHjhoaLy7du40VM9apUqVK0lAQIChwA2CNqxpZnw8Z65cGVe45Wh0VPQtrxz_VGd_MVoKFykifipjjM4a46M2Pz_13Off53qffu2jXic_Tz7m5-en9vlYjt18ruv76v2-0qBRQ6NDoB4CCCCAAAIIeIkAgRtecqGZJgIIIIAAAggggAACCCCAAAIIIIAAAggg4CyBGjVryszpMwx1f_r0admyeYvUqFnDUH0qOV8gUAXIGC3R0dYzoBhtKzP18uTJY_i0KdOmig7eoCCAAAIIIIAAAvYW8LV3B7SPAAIIIIAAAggggAACCCCAAAIIIIAAAggg4N0CtWrVMgUwb84cU_Wp7FyBgIBAwwOIiY4xXNceFUNCgg03u2XLFsN1qYgAAggggAACCGRFgMCNrOhxLgIIIIAAAggggAACCCCAAAIIIIAAAggggIBVgTJly4qZJSrmqsCNuLg4q-26Q4UbN264wzCzNEYzwRCnTp3KUl9ZPTlvvnyGm9hK4IZhKyoigAACCCCAQNYECNzImh9nI4AAAggggAACCCCAAAIIIIAAAggggAACCFgR8PHxkabNm1mp9f_DsbGx8sHo0f_f4cbPPCUAJaNLEBgUJPnz58-oys1jK5Yvl8SExJuvHf0kIsL4Ejxr_lrj6OHRHwIIIIAAAgh4qQCBG1564Zk2AggggAACCCCAAAIIIIAAAggggAACCCDgSIEej_c01d2UnyfLX3_-aeocR1bOnj2boe4iIyMN1UuudPLEieSnbvVYvkIFQ-O9cOGCLF-2zFDd5EqXL11Ofprlx7z58krx4sUNtbN3zx6ZOmWKobpUQgABBBBAAAEEsiJA4EZW9DgXAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAwJBARI0IqVa9uqG6utL169elb58nZN3adYbPcWTFwkWKGOrunyNHJF4FK1grV69elWGvviazZs60VtUlj1cwGLihBz_7l1mG57Bi2XJZ8NtvhusbqVizVi0j1Sx13nvnHYkyGXyTsvETx0_I9-PGp9zNawQQQAABBBBA4KYAgRs3KXiCAAIIIIAAAggggAACCCCAAAIIIIAAAgggYE-Bx3uZy7px-fJl6fV4D_ls7NhMLa9x48YNu02nRIkShtrWc5g-bXqGdTdt3CiPPPiQTJ40KcN6rnywdt06hoe3aOEi-frLr6zW15k5-j39tFy7ds1qXTMVWrZuZbj6-bjz8nTfvnL8-HHD5yRXXLtmjQzo96w0b9JE3h45Utavc80gpOTx8ogAAggggAACzhMwlsvNeeOjZwQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEPEWjdpo189fkXsm_fPsMzSriSIB9_-JEl-KF9h_Zy9z33SJWqVcXPz--2Ni5duiT7Vbt79-6VLZs3y7o1a-XYsWO31bHlC6PLbeg-33_3XfH19ZFHHntMcuXKZRnG0aNHZc_u3TJ18hRZuWKFLYfmlLYaNW4swSHBogMdjJTR770nSUlX5QkVFOHv73_bKdHR0fLu26Psln1Ev4d04M0RlQ3FSNm8abO0bdlKXn7lFXm002PqWqb9nVgdpLN61WpZuuQPWbZ0mUSeO3db8x-MHiNTZ2QcxHPbCbxAAAEEEEAAAa8R8NkZHW-_kGOvYWSiCCCAAAIIIIAAAggggAACCCDgLIHKoQHO6pp-EUAAAQQyIbDv77-lY_v2ogMyMlt8fHwkNDRUQsNC5fLlKxIXGysXL17MbHNy4Mhh0-fqbB5VKlY0NQ89br3Eyvm4OLlgYPmUjAalAyXG_zBBdJtmy_Zt2-SB9h0MnbZ99y7JnTu3obovv_SSzLCSXSRlQzpoo0rVKhJRo4bExsTKtm1b5dDBQ5KZbCk6k8Z7778vgUFBKbtJ9Xrijz_KiNeHp9pvbUfOnDmlXPnyopeGyZsvr5w6eUpOnDghJ0-ekNOnTqtglKQMmxg_YYI0btokwzocRAABBBBAAAHvEyBww_uuOTNGAAEEEEAAAQQQQAABBBBAwKMECNzwqMvJZBBAwEsEfpo4Ud4Y9rrLzDYzgRt68O3btZNdO3c5bR4hISFSp25dqVuvnmWrULFCuoEcZ86ckT8WLZbFixbJurVr5erVq4bGHRQcLK1bt5b7O3RQfdRNt33d2I7t2y0BIZkJujA0GAOVdCaWipUqSb36_5rUrl07zUCOK1euyP1t26kgkYMGWrVdFZ0tZva8ubZrkJYQQAABBBBAwCMECNzwiMvIJBBAAAEEEEAAAQQQQAABBBDwXgECN7z32jNzBBBwb4Fnn35Gfl-wwCUmkdnAjd9-_VUG9HvWJeagB6EDORYsXiT58-e_OaYFv_0m3379jSWoIqsBFYUKFZLHe_WS3k_0udl-yicvvTDYbkucpOzLyGsdyLHr772SLVvqleP37tkjD3bsaCpripE-rdX54quvpEWrltaqcRwBBBBAAAEEvEgg7YXYvAiAqSKAAAIIIIAAAggggAACCCCAAAIIIIAAAgg4XuCTzz6Vxzp1cnzHNuyxTdu2liU-bNikJYNG4cKFM9VknFqCJTEx8bZzVyxfLnpplKwGbehGT506pYJtfrut_ZQvBg95SQIDA1Pudtrra9eupTv3Cmqpm9ccnPlFZ0epXiPCaR50jAACCCCAAAKuKUDghmteF0aFAAIIIIAAAggggAACCCCAAAIIIIAAAgh4tIDOhPDWO6Pk5VeGZrj8hj0RcuTIIU88-WSWutDjt1XRgSwTJv4oZcuVtVWTDm9HZ_v48puvRdvaqtSqVctWTaVqp1OXzjLqvXcle_bsqY7ZckdQUJC8MfJNmTRlshQoUMCWTdMWAggggAACCHiAAIEbHnARmQICCCCAAAIIIIAAAggggAACCCCAAAIIIOCuAn1U4MR348dLmbJlHDYFvaRInyefkGWrVsqQLAZe3Fm7tvTs3StLYw8LC5PPvvzCEsji7-8vJUqUzFJ7zj65_l13ycdjx6a5PInZsT348EMycfLPktksJEb6e-TRR1XAzEQJDQ01Ut1UHR0Q0qVbV1myYrl07dbN1LlURgABBBBAAAHvESBww3uuNTNFAAEEEEAAAQQQQAABBBBAAAEEEEAAAQRcUqBJs6ayYNEi-eDjj1TQQgm7jFEHROh-xnz0oaxZv15l-nhFdHYIW5RXhw2TL7_-2vSNfx1A8vwLg2SpuqnfqnXrm0MpXqL4zefu-uTeli3kl7lzpWq1apmagr42X3_3rbw3erToa2fvLCR169VV12GF9B84UIKCgzM15ltP0m0kBweNGDlSdHAOBQEEEEAAAQQQSE8gW3oH2I8AAggggAACCCCAAAIIIIAAAggggAACCCCAgKMEfHx8pH2HDtLuvvtkyeI_ZOXKlfLX6tVy9OjRTA3B19dXyleoILXurCV16taVxk2aSGBgYKbaMnKSDlSoXiNChg4ZIiuXr5AbN26ke5oOSujWo4fauqc5Jp1xQ2dqyJkzp_irJUf0o156JGfOHP89_rv_333_HcuhHtVxvSSHq5SKlSrKzNm_yLSpU2XOL7Nl08aNcv369QyHp5dF6awyVLRu08YSsJFcuVz5CrJ2zVrLHC3z_m--yc-1k55_Tr3_FjP9XC_LY6QEBQfJwOefk169e8vUqVNk1YqVljFfuXLFyOmSJ08euatBA8t7uGmzZura-Rs6j0oIIIAAAggggIDPzuj49P_1iA8CCCCAAAIIIIAAAggggAACCCDg4gKVQwNcfIQMDwEEEEAgKwLHjh2TdeqG_alTJyU6KlpiYmIkOjpazp8_b7lBHxAQILlz55bAoEApVqyYFC9eQnTGilKlS4s-5oxy7tw5S_DG4cOHJDIyUhITEyVfvnyW5T7q1K0nOqDBG0vkuUhZvXqVnD51WrRRdHSUhIfnlTvuKCZ3FC8upcuUsVxDV7LR127L5i1y6OBB9d779_0XEx0j129cVxlWwlQmjVApXKSIRERESMlSpVxp6IwFAQQQQAABBNxIgMANN7pYDBUBBBBAAAEEEEAAAQQQQAABBFILELiR2oQ9CCCAAAIIIIAAAggggAACCCDgPgK-7jNURooAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCHiWAIEbnnU9mQ0CCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIuJEAgRtudLEYKgIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAgh4lgCBG551PZkNAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCLiRAIEbbnSxGCoCCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIeJYAgRuedT2ZDQIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAgi4kQCBG250sRgqAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCHiWAIEbnnU9mQ0CCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIuJEAgRtudLEYKgIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAgh4lgCBG551PZkNAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCLiRAIEbbnSxGCoCCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIeJYAgRuedT2ZDQIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAgi4kQCBG250sRgqAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCHiWAIEbnnU9mQ0CCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIuJEAgRtudLEYKgIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAgh4lgCBG551PZkNAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCLiRAIEbbnSxGCoCCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIeJYAgRuedT2ZDQIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAgi4kQCBG250sRgqAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCHiWAIEbnnU9mQ0CCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIuJEAgRtudLEYKgIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAgh4lgCBG551PZkNAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCLiRAIEbbnSxGCoCCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIeJYAgRuedT2ZDQIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAgi4kQCBG250sRgqAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCHiWAIEbnnU9mQ0CCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIuJEAgRtudLEYKgIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAgh4lgCBG551PZkNAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCLiRAIEbbnSxGCoCCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIeJYAgRuedT2ZDQIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAgi4kQCBG250sRgqAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCHiWAIEbnnU9mQ0CCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIuJEAgRtudLEYKgIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAgh4lgCBG551PZkNAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAv9r1w6KAAAACAj2by3HmW3A-iJAgAABAiEBx43QWKISIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECXwKOG197akOAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAiEBBw3QmOJSoAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECHwJOG587akNAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgEBJw3AiNJSoBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECDwJeC48bWnNgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgEBIwHEjNJaoBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAwJeA48bXntoQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECIQHHjdBYohIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQJfAo4bX3tqQ4AAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECIQEHDdCY4lKgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIfAk4bnztqQ0BAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECAQEnDcCI0lKgECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIPAl4Ljxtac2BAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAQEjAcSM0lqgECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIDAl4Djxtee2hAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIhAceN0FiiEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAl8Cjhtfe2pDgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIhAQcN0JjiUqAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAh8CThufO2pDQECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIBAScNwIjSUqAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAg8CXguPG1pzYECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIBASMBxIzSWqAQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgMCXgOPG157aECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAiEBx43QWKISIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECXwKOG197akOAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAiEBBw3QmOJSoAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECHwJOG587akNAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgEBJw3AiNJSoBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECDwJeC48bWnNgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgEBIwHEjNJaoBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAwJeA48bXntoQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECIQHHjdBYohIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQJfAo4bX3tqQ4AAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECIQEHDdCY4lKgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIfAk4bnztqQ0BAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECAQEnDcCI0lKgECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIPAl4Ljxtac2BAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAQEjAcSM0lqgECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIDAl4Djxtee2hAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIhAceN0FiiEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAl8Cjhtfe2pDgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIhAQcN0JjiUqAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAh8CThufO2pDQECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIBAScNwIjSUqAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAg8CXguPG1pzYECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIBASMBxIzSWqAQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgMCXgOPG157aECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAiEBx43QWKISIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECXwKOG197akOAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAiEBBw3QmOJSoAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECHwJOG587akNAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgEBJw3AiNJSoBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECDwJeC48bWnNgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgEBIwHEjNJaoBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAwJeA48bXntoQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECIQHHjdBYohIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQJfAo4bX3tqQ4AAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECIQEHDdCY4lKgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIfAk4bnztqQ0BAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECAQEnDcCI0lKgECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIPAl4Ljxtac2BAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAQEjAcSM0lqgECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIDAl4Djxtee2hAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIhAceN0FiiEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAl8Cjhtfe2pDgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIhAQcN0JjiUqAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAh8CThufO2pDQECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIBAScNwIjSUqAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAg8CXguPG1pzYECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIBASMBxIzSWqAQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgMCXgOPG157aECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAiEBx43QWKISIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECXwKOG197akOAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAiEBBw3QmOJSoAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECHwJOG587akNAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgEBJw3AiNJSoBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECDwJeC48bWnNgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgEBIwHEjNJaoBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAwJeA48bXntoQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECIQHHjdBYohIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQJfAo4bX3tqQ4AAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECIQEHDdCY4lKgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIfAk4bnztqQ0BAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECAQEnDcCI0lKgECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIPAl4Ljxtac2BAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAQEjAcSM0lqgECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIDAl4Djxtee2hAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIhAceN0FiiEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAl8Cjhtfe2pDgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIhAQcN0JjiUqAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAh8CThufO2pDQECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIBAScNwIjSUqAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAg8CXguPG1pzYECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIBASMBxIzSWqAQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgMCXgOPG157aECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAiEBx43QWKISIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECXwKOG197akOAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAiEBBw3QmOJSoAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECHwJOG587akNAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgEBJw3AiNJSoBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECDwJeC48bWnNgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgEBIwHEjNJaoBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAwJeA48bXntoQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECIQHHjdBYohIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQJfAo4bX3tqQ4AAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECIQEHDdCY4lKgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIfAk4bnztqQ0BAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECAQEnDcCI0lKgECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIPAl4Ljxtac2BAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAQEjAcSM0lqgECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIDAl4Djxtee2hAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIhAceN0FiiEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAl8Cjhtfe2pDgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIhAQcN0JjiUqAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAh8CThufO2pDQECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIBAScNwIjSUqAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAg8CXguPG1pzYECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIBASMBxIzSWqAQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgMCXgOPG157aECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAiEBx43QWKISIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECXwKOG197akOAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAiEBBw3QmOJSoAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECHwJOG587akNAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgEBJw3AiNJSoBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECDwJeC48bWnNgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgEBIwHEjNJaoBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAwJeA48bXntoQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECIQHHjdBYohIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQJfAo4bX3tqQ4AAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECIQEHDdCY4lKgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIfAk4bnztqQ0BAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECAQEnDcCI0lKgECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIPAl4Ljxtac2BAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAQEjAcSM0lqgECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIDAl4Djxtee2hAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIhAceN0FiiEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAl8Cjhtfe2pDgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIhAQcN0JjiUqAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAh8CThufO2pDQECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIBAScNwIjSUqAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAg8CXguPG1pzYECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIBASMBxIzSWqAQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgMCXgOPG157aECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAiEBx43QWKISIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECXwKOG197akOAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAiEBBw3QmOJSoAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECHwJOG587akNAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgEBJw3AiNJSoBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECDwJeC48bWnNgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgEBIwHEjNJaoBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAwJeA48bXntoQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECIQHHjdBYohIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQJfAo4bX3tqQ4AAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECIQEHDdCY4lKgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIfAk4bnztqQ0BAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECAQEnDcCI0lKgECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIPAl4Ljxtac2BAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAQEjAcSM0lqgECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIDAl4Djxtee2hAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIhAceN0FiiEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAl8Cjhtfe2pDgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIhAQcN0JjiUqAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAh8CThufO2pDQECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIBAScNwIjSUqAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAg8CXguPG1pzYECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIBASMBxIzSWqAQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgMCXgOPG157aECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAiEBx43QWKISIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECXwKOG197akOAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAiEBBw3QmOJSoAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECHwJOG587akNAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgEBJw3AiNJSoBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECDwJeC48bWnNgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgEBIwHEjNJaoBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAwJeA48bXntoQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECIQHHjdBYohIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQJfAo4bX3tqQ4AAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECIQEHDdCY4lKgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIfAk4bnztqQ0BAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECAQEnDcCI0lKgECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIPAl4Ljxtac2BAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAQEjAcSM0lqgECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIDAl4Djxtee2hAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIhAceN0FiiEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAl8Cjhtfe2pDgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIhAQcN0JjiUqAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAh8CThufO2pDQECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIBAScNwIjSUqAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAg8CUwNjGVf-QPaqgAAAAASUVORK5CYII',
    'cera': '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',
    'comparison': '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',
    'question-exp': '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'
};
var $294eb611d6d6000b$export$2e2bcd8739ae039 = $294eb611d6d6000b$var$images;


/**
 * @fileoverview Fire store util replaces realtime util
 */ const $f4dbba15e44db9fb$export$6d3c090e66a883b1 = ()=>undefined;


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ const $3117f6f4eeb4c314$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: '${JSCORE_VERSION}'
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $3117f6f4eeb4c314$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $3117f6f4eeb4c314$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $3117f6f4eeb4c314$export$a39cad550e7ab28a = function(message) {
    return new Error('Firebase Database (' + $3117f6f4eeb4c314$export$588c7fdda06fbb0a.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $3117f6f4eeb4c314$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $3117f6f4eeb4c314$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
// TODO(dlarocque): Define this as a class, since we no longer target ES5.
const $3117f6f4eeb4c314$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error('encodeByteArray takes an array as a parameter');
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($3117f6f4eeb4c314$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $3117f6f4eeb4c314$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $3117f6f4eeb4c314$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $3117f6f4eeb4c314$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */ const $3117f6f4eeb4c314$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $3117f6f4eeb4c314$var$stringToByteArray$1(str);
    return $3117f6f4eeb4c314$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $3117f6f4eeb4c314$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $3117f6f4eeb4c314$export$e510a73ee562749(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $3117f6f4eeb4c314$export$c62426fdd000a97e = function(str) {
    try {
        return $3117f6f4eeb4c314$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $3117f6f4eeb4c314$export$6c40052bed430212(value) {
    return $3117f6f4eeb4c314$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $3117f6f4eeb4c314$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$3117f6f4eeb4c314$var$isValidKey(prop)) continue;
        target[prop] = $3117f6f4eeb4c314$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $3117f6f4eeb4c314$var$isValidKey(key) {
    return key !== '__proto__';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $3117f6f4eeb4c314$export$a4e55266d2135a7f() {
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('Unable to locate global object.');
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $3117f6f4eeb4c314$var$getDefaultsFromGlobal = ()=>$3117f6f4eeb4c314$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $3117f6f4eeb4c314$var$getDefaultsFromEnvVariable = ()=>{
    return;
};
const $3117f6f4eeb4c314$var$getDefaultsFromCookie = ()=>{
    if (typeof document === 'undefined') return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $3117f6f4eeb4c314$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $3117f6f4eeb4c314$export$212bb2fc580a90a8 = ()=>{
    try {
        return (0, $f4dbba15e44db9fb$export$6d3c090e66a883b1)() || $3117f6f4eeb4c314$var$getDefaultsFromGlobal() || $3117f6f4eeb4c314$var$getDefaultsFromEnvVariable() || $3117f6f4eeb4c314$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $3117f6f4eeb4c314$export$9c11895284c8adad = (productName)=>$3117f6f4eeb4c314$export$212bb2fc580a90a8()?.emulatorHosts?.[productName];
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $3117f6f4eeb4c314$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $3117f6f4eeb4c314$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $3117f6f4eeb4c314$export$3dfb6827a9f89756 = ()=>$3117f6f4eeb4c314$export$212bb2fc580a90a8()?.config;
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $3117f6f4eeb4c314$export$5539a1a3afe87d6 = (name)=>$3117f6f4eeb4c314$export$212bb2fc580a90a8()?.[`_${name}`];
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $3117f6f4eeb4c314$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks whether host is a cloud workstation or not.
 * @public
 */ function $3117f6f4eeb4c314$export$5b4d24b45140ad90(url) {
    // `isCloudWorkstation` is called without protocol in certain connect*Emulator functions
    // In HTTP request builders, it's called with the protocol.
    // If called with protocol prefix, it's a valid URL, so we extract the hostname
    // If called without, we assume the string is the hostname.
    try {
        const host = url.startsWith('http://') || url.startsWith('https://') ? new URL(url).hostname : url;
        return host.endsWith('.cloudworkstations.dev');
    } catch  {
        return false;
    }
}
/**
 * Makes a fetch request to the given server.
 * Mostly used for forwarding cookies in Firebase Studio.
 * @public
 */ async function $3117f6f4eeb4c314$export$c0f0d0ce4283a937(endpoint) {
    const result = await fetch(endpoint, {
        credentials: 'include'
    });
    return result.ok;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $3117f6f4eeb4c314$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = {
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: 'custom',
            identities: {}
        },
        // Override with user options
        ...token
    };
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        $3117f6f4eeb4c314$export$4b5284a3025a455(JSON.stringify(header)),
        $3117f6f4eeb4c314$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join('.');
}
const $3117f6f4eeb4c314$var$emulatorStatus = {};
// Checks whether any products are running on an emulator
function $3117f6f4eeb4c314$var$getEmulatorSummary() {
    const summary = {
        prod: [],
        emulator: []
    };
    for (const key of Object.keys($3117f6f4eeb4c314$var$emulatorStatus))if ($3117f6f4eeb4c314$var$emulatorStatus[key]) summary.emulator.push(key);
    else summary.prod.push(key);
    return summary;
}
function $3117f6f4eeb4c314$var$getOrCreateEl(id) {
    let parentDiv = document.getElementById(id);
    let created = false;
    if (!parentDiv) {
        parentDiv = document.createElement('div');
        parentDiv.setAttribute('id', id);
        created = true;
    }
    return {
        created: created,
        element: parentDiv
    };
}
let $3117f6f4eeb4c314$var$previouslyDismissed = false;
/**
 * Updates Emulator Banner. Primarily used for Firebase Studio
 * @param name
 * @param isRunningEmulator
 * @public
 */ function $3117f6f4eeb4c314$export$fd3d2954543183b1(name, isRunningEmulator) {
    if (typeof window === 'undefined' || typeof document === 'undefined' || !$3117f6f4eeb4c314$export$5b4d24b45140ad90(window.location.host) || $3117f6f4eeb4c314$var$emulatorStatus[name] === isRunningEmulator || $3117f6f4eeb4c314$var$emulatorStatus[name] || // If already set to use emulator, can't go back to prod.
    $3117f6f4eeb4c314$var$previouslyDismissed) return;
    $3117f6f4eeb4c314$var$emulatorStatus[name] = isRunningEmulator;
    function prefixedId(id) {
        return `__firebase__banner__${id}`;
    }
    const bannerId = '__firebase__banner';
    const summary = $3117f6f4eeb4c314$var$getEmulatorSummary();
    const showError = summary.prod.length > 0;
    function tearDown() {
        const element = document.getElementById(bannerId);
        if (element) element.remove();
    }
    function setupBannerStyles(bannerEl) {
        bannerEl.style.display = 'flex';
        bannerEl.style.background = '#7faaf0';
        bannerEl.style.position = 'fixed';
        bannerEl.style.bottom = '5px';
        bannerEl.style.left = '5px';
        bannerEl.style.padding = '.5em';
        bannerEl.style.borderRadius = '5px';
        bannerEl.style.alignItems = 'center';
    }
    function setupIconStyles(prependIcon, iconId) {
        prependIcon.setAttribute('width', '24');
        prependIcon.setAttribute('id', iconId);
        prependIcon.setAttribute('height', '24');
        prependIcon.setAttribute('viewBox', '0 0 24 24');
        prependIcon.setAttribute('fill', 'none');
        prependIcon.style.marginLeft = '-6px';
    }
    function setupCloseBtn() {
        const closeBtn = document.createElement('span');
        closeBtn.style.cursor = 'pointer';
        closeBtn.style.marginLeft = '16px';
        closeBtn.style.fontSize = '24px';
        closeBtn.innerHTML = ' &times;';
        closeBtn.onclick = ()=>{
            $3117f6f4eeb4c314$var$previouslyDismissed = true;
            tearDown();
        };
        return closeBtn;
    }
    function setupLinkStyles(learnMoreLink, learnMoreId) {
        learnMoreLink.setAttribute('id', learnMoreId);
        learnMoreLink.innerText = 'Learn more';
        learnMoreLink.href = 'https://firebase.google.com/docs/studio/preview-apps#preview-backend';
        learnMoreLink.setAttribute('target', '__blank');
        learnMoreLink.style.paddingLeft = '5px';
        learnMoreLink.style.textDecoration = 'underline';
    }
    function setupDom() {
        const banner = $3117f6f4eeb4c314$var$getOrCreateEl(bannerId);
        const firebaseTextId = prefixedId('text');
        const firebaseText = document.getElementById(firebaseTextId) || document.createElement('span');
        const learnMoreId = prefixedId('learnmore');
        const learnMoreLink = document.getElementById(learnMoreId) || document.createElement('a');
        const prependIconId = prefixedId('preprendIcon');
        const prependIcon = document.getElementById(prependIconId) || document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        if (banner.created) {
            // update styles
            const bannerEl = banner.element;
            setupBannerStyles(bannerEl);
            setupLinkStyles(learnMoreLink, learnMoreId);
            const closeBtn = setupCloseBtn();
            setupIconStyles(prependIcon, prependIconId);
            bannerEl.append(prependIcon, firebaseText, learnMoreLink, closeBtn);
            document.body.appendChild(bannerEl);
        }
        if (showError) {
            firebaseText.innerText = `Preview backend disconnected.`;
            prependIcon.innerHTML = `<g clip-path="url(#clip0_6013_33858)">
<path d="M4.8 17.6L12 5.6L19.2 17.6H4.8ZM6.91667 16.4H17.0833L12 7.93333L6.91667 16.4ZM12 15.6C12.1667 15.6 12.3056 15.5444 12.4167 15.4333C12.5389 15.3111 12.6 15.1667 12.6 15C12.6 14.8333 12.5389 14.6944 12.4167 14.5833C12.3056 14.4611 12.1667 14.4 12 14.4C11.8333 14.4 11.6889 14.4611 11.5667 14.5833C11.4556 14.6944 11.4 14.8333 11.4 15C11.4 15.1667 11.4556 15.3111 11.5667 15.4333C11.6889 15.5444 11.8333 15.6 12 15.6ZM11.4 13.6H12.6V10.4H11.4V13.6Z" fill="#212121"/>
</g>
<defs>
<clipPath id="clip0_6013_33858">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`;
        } else {
            prependIcon.innerHTML = `<g clip-path="url(#clip0_6083_34804)">
<path d="M11.4 15.2H12.6V11.2H11.4V15.2ZM12 10C12.1667 10 12.3056 9.94444 12.4167 9.83333C12.5389 9.71111 12.6 9.56667 12.6 9.4C12.6 9.23333 12.5389 9.09444 12.4167 8.98333C12.3056 8.86111 12.1667 8.8 12 8.8C11.8333 8.8 11.6889 8.86111 11.5667 8.98333C11.4556 9.09444 11.4 9.23333 11.4 9.4C11.4 9.56667 11.4556 9.71111 11.5667 9.83333C11.6889 9.94444 11.8333 10 12 10ZM12 18.4C11.1222 18.4 10.2944 18.2333 9.51667 17.9C8.73889 17.5667 8.05556 17.1111 7.46667 16.5333C6.88889 15.9444 6.43333 15.2611 6.1 14.4833C5.76667 13.7056 5.6 12.8778 5.6 12C5.6 11.1111 5.76667 10.2833 6.1 9.51667C6.43333 8.73889 6.88889 8.06111 7.46667 7.48333C8.05556 6.89444 8.73889 6.43333 9.51667 6.1C10.2944 5.76667 11.1222 5.6 12 5.6C12.8889 5.6 13.7167 5.76667 14.4833 6.1C15.2611 6.43333 15.9389 6.89444 16.5167 7.48333C17.1056 8.06111 17.5667 8.73889 17.9 9.51667C18.2333 10.2833 18.4 11.1111 18.4 12C18.4 12.8778 18.2333 13.7056 17.9 14.4833C17.5667 15.2611 17.1056 15.9444 16.5167 16.5333C15.9389 17.1111 15.2611 17.5667 14.4833 17.9C13.7167 18.2333 12.8889 18.4 12 18.4ZM12 17.2C13.4444 17.2 14.6722 16.6944 15.6833 15.6833C16.6944 14.6722 17.2 13.4444 17.2 12C17.2 10.5556 16.6944 9.32778 15.6833 8.31667C14.6722 7.30555 13.4444 6.8 12 6.8C10.5556 6.8 9.32778 7.30555 8.31667 8.31667C7.30556 9.32778 6.8 10.5556 6.8 12C6.8 13.4444 7.30556 14.6722 8.31667 15.6833C9.32778 16.6944 10.5556 17.2 12 17.2Z" fill="#212121"/>
</g>
<defs>
<clipPath id="clip0_6083_34804">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`;
            firebaseText.innerText = 'Preview backend running in this workspace.';
        }
        firebaseText.setAttribute('id', firebaseTextId);
    }
    if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', setupDom);
    else setupDom();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $3117f6f4eeb4c314$export$c36915b22ce77c19() {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') return navigator['userAgent'];
    else return '';
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $3117f6f4eeb4c314$export$872f8323f01d7ae0() {
    return typeof window !== 'undefined' && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($3117f6f4eeb4c314$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $3117f6f4eeb4c314$export$8ee0fc9ee280b4ee() {
    const forceEnvironment = $3117f6f4eeb4c314$export$212bb2fc580a90a8()?.forceEnvironment;
    if (forceEnvironment === 'node') return true;
    else if (forceEnvironment === 'browser') return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === '[object process]';
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment.
 * Note: This will return true for certain test frameworks that are incompletely
 * mimicking a browser, and should not lead to assuming all browser APIs are
 * available.
 */ function $3117f6f4eeb4c314$export$4e09c449d6c407f7() {
    return typeof window !== 'undefined' || $3117f6f4eeb4c314$export$97b87b8868ff7a3c();
}
/**
 * Detect Web Worker context.
 */ function $3117f6f4eeb4c314$export$97b87b8868ff7a3c() {
    return typeof WorkerGlobalScope !== 'undefined' && typeof self !== 'undefined' && self instanceof WorkerGlobalScope;
}
/**
 * Detect Cloudflare Worker context.
 */ function $3117f6f4eeb4c314$export$ad9e9b75cb9fb797() {
    return typeof navigator !== 'undefined' && navigator.userAgent === 'Cloudflare-Workers';
}
function $3117f6f4eeb4c314$export$caa8774a9107a58e() {
    const runtime = typeof chrome === 'object' ? chrome.runtime : typeof browser === 'object' ? browser.runtime : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $3117f6f4eeb4c314$export$f7a1e23e542d38e3() {
    return typeof navigator === 'object' && navigator['product'] === 'ReactNative';
}
/** Detects Electron apps. */ function $3117f6f4eeb4c314$export$f2f6a8999f8ebd30() {
    return $3117f6f4eeb4c314$export$c36915b22ce77c19().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */ function $3117f6f4eeb4c314$export$7e7b1a9668aaed8() {
    const ua = $3117f6f4eeb4c314$export$c36915b22ce77c19();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */ function $3117f6f4eeb4c314$export$202944b2d2824246() {
    return $3117f6f4eeb4c314$export$c36915b22ce77c19().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $3117f6f4eeb4c314$export$5d1d834fbbf8bab7() {
    return $3117f6f4eeb4c314$export$588c7fdda06fbb0a.NODE_CLIENT === true || $3117f6f4eeb4c314$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $3117f6f4eeb4c314$export$95df08bae54cb4df() {
    return !$3117f6f4eeb4c314$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}
/** Returns true if we are running in Safari or WebKit */ function $3117f6f4eeb4c314$export$ef10bcfb06572016() {
    return !$3117f6f4eeb4c314$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && (navigator.userAgent.includes('Safari') || navigator.userAgent.includes('WebKit')) && !navigator.userAgent.includes('Chrome');
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $3117f6f4eeb4c314$export$3865db50535c2055() {
    try {
        return typeof indexedDB === 'object';
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $3117f6f4eeb4c314$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                reject(request.error?.message || '');
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $3117f6f4eeb4c314$export$f172b7eb6cf60599() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // TypeScript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $3117f6f4eeb4c314$var$ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $3117f6f4eeb4c314$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $3117f6f4eeb4c314$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        // TODO(dlarocque): Replace this with `new.target`: https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        //                   which we can now use since we no longer target ES5.
        Object.setPrototypeOf(this, $3117f6f4eeb4c314$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $3117f6f4eeb4c314$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $3117f6f4eeb4c314$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $3117f6f4eeb4c314$var$replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $3117f6f4eeb4c314$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $3117f6f4eeb4c314$var$replaceTemplate(template, data) {
    return template.replace($3117f6f4eeb4c314$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $3117f6f4eeb4c314$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $3117f6f4eeb4c314$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data JavaScript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $3117f6f4eeb4c314$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $3117f6f4eeb4c314$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = $3117f6f4eeb4c314$export$c5a53ce6a17cf18d($3117f6f4eeb4c314$export$c62426fdd000a97e(parts[0]) || '');
        claims = $3117f6f4eeb4c314$export$c5a53ce6a17cf18d($3117f6f4eeb4c314$export$c62426fdd000a97e(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $3117f6f4eeb4c314$export$5f870fcca7ae6a88 = function(token) {
    const claims = $3117f6f4eeb4c314$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) validSince = claims['nbf'];
        else if (claims.hasOwnProperty('iat')) validSince = claims['iat'];
        if (claims.hasOwnProperty('exp')) validUntil = claims['exp'];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $3117f6f4eeb4c314$export$701c661ec91095f2 = function(token) {
    const claims = $3117f6f4eeb4c314$export$2f872c0f2117be69(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) return claims['iat'];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $3117f6f4eeb4c314$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $3117f6f4eeb4c314$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $3117f6f4eeb4c314$export$fc970ed23da99565 = function(token) {
    const claims = $3117f6f4eeb4c314$export$2f872c0f2117be69(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $3117f6f4eeb4c314$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $3117f6f4eeb4c314$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $3117f6f4eeb4c314$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $3117f6f4eeb4c314$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $3117f6f4eeb4c314$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($3117f6f4eeb4c314$var$isObject(aProp) && $3117f6f4eeb4c314$var$isObject(bProp)) {
            if (!$3117f6f4eeb4c314$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $3117f6f4eeb4c314$var$isObject(thing) {
    return thing !== null && typeof thing === 'object';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $3117f6f4eeb4c314$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $3117f6f4eeb4c314$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject('timeout!'), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $3117f6f4eeb4c314$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $3117f6f4eeb4c314$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $3117f6f4eeb4c314$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) return '';
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $3117f6f4eeb4c314$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === 'string') while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $3117f6f4eeb4c314$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $3117f6f4eeb4c314$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $3117f6f4eeb4c314$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber synchronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error('Missing Observer.');
        // Assemble an Observer object when passed as callback functions.
        if ($3117f6f4eeb4c314$var$implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $3117f6f4eeb4c314$var$noop;
        if (observer.error === undefined) observer.error = $3117f6f4eeb4c314$var$noop;
        if (observer.complete === undefined) observer.complete = $3117f6f4eeb4c314$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== 'undefined' && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $3117f6f4eeb4c314$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $3117f6f4eeb4c314$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === 'function') return true;
    }
    return false;
}
function $3117f6f4eeb4c314$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $3117f6f4eeb4c314$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = 'at least ' + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    if (argError) {
        const error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $3117f6f4eeb4c314$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $3117f6f4eeb4c314$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== 'string') //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($3117f6f4eeb4c314$export$adea4917e02d93dc(fnName, 'namespace') + 'must be a valid firebase namespace.');
}
function $3117f6f4eeb4c314$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== 'function') throw new Error($3117f6f4eeb4c314$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid function.');
}
function $3117f6f4eeb4c314$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== 'object' || context === null) throw new Error($3117f6f4eeb4c314$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid context object.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in JavaScript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $3117f6f4eeb4c314$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $3117f6f4eeb4c314$export$a7a9523472993e97(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $3117f6f4eeb4c314$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $3117f6f4eeb4c314$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $3117f6f4eeb4c314$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $3117f6f4eeb4c314$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $3117f6f4eeb4c314$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $3117f6f4eeb4c314$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $3117f6f4eeb4c314$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $3117f6f4eeb4c314$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $3117f6f4eeb4c314$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($3117f6f4eeb4c314$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $3117f6f4eeb4c314$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $3117f6f4eeb4c314$var$indicator(i);
}
function $3117f6f4eeb4c314$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return 'th';
    const dec = i % 10;
    if (dec === 1) return 'st';
    if (dec === 2) return 'nd';
    if (dec === 3) return 'rd';
    return 'th';
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $3117f6f4eeb4c314$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @public
 * Generates a SHA-256 hash for the given input string.
 *
 * @param input The string to hash.
 * @returns A promise that resolves to the SHA-256 hash as a hex string.
 */ async function $3117f6f4eeb4c314$export$7220bf91e5c1b402(input) {
    const textEncoder = new TextEncoder();
    const data = textEncoder.encode(input);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    // Convert ArrayBuffer to hex string
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hexHash = hashArray.map((b)=>b.toString(16).padStart(2, '0')).join('');
    return hexHash;
}



/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $ad76b76e741ec0c7$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $ad76b76e741ec0c7$var$DEFAULT_ENTRY_NAME = '[DEFAULT]';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $ad76b76e741ec0c7$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide multiple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $3117f6f4eeb4c314$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options?.identifier);
        const optional = options?.optional ?? false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/cannot be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($ad76b76e741ec0c7$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $ad76b76e741ec0c7$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $ad76b76e741ec0c7$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>'INTERNAL' in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>'_delete' in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $ad76b76e741ec0c7$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $ad76b76e741ec0c7$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = this.onInitCallbacks.get(normalizedIdentifier) ?? new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch  {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $ad76b76e741ec0c7$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch  {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $ad76b76e741ec0c7$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $ad76b76e741ec0c7$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $ad76b76e741ec0c7$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $ad76b76e741ec0c7$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $ad76b76e741ec0c7$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $ad76b76e741ec0c7$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $ad76b76e741ec0c7$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


var $0c1331d0a001f5bc$exports = {};

$parcel$export($0c1331d0a001f5bc$exports, "_DEFAULT_ENTRY_NAME", function () { return $0c1331d0a001f5bc$export$9f30fa0c10967f7f; });
$parcel$export($0c1331d0a001f5bc$exports, "_apps", function () { return $0c1331d0a001f5bc$export$b4e3c36c855b14b5; });
$parcel$export($0c1331d0a001f5bc$exports, "_serverApps", function () { return $0c1331d0a001f5bc$export$fb03ad8d3d5c5f76; });
$parcel$export($0c1331d0a001f5bc$exports, "_components", function () { return $0c1331d0a001f5bc$export$9566bce3835c0f28; });
$parcel$export($0c1331d0a001f5bc$exports, "_addComponent", function () { return $0c1331d0a001f5bc$export$fa5244b94c62d36a; });
$parcel$export($0c1331d0a001f5bc$exports, "_addOrOverwriteComponent", function () { return $0c1331d0a001f5bc$export$4393112b42e2b41d; });
$parcel$export($0c1331d0a001f5bc$exports, "_registerComponent", function () { return $0c1331d0a001f5bc$export$c930050e7bb63965; });
$parcel$export($0c1331d0a001f5bc$exports, "_getProvider", function () { return $0c1331d0a001f5bc$export$fa0d6da0f5838f50; });
$parcel$export($0c1331d0a001f5bc$exports, "_removeServiceInstance", function () { return $0c1331d0a001f5bc$export$48d18de2ff1c45a5; });
$parcel$export($0c1331d0a001f5bc$exports, "_isFirebaseApp", function () { return $0c1331d0a001f5bc$export$110778f8e98b8257; });
$parcel$export($0c1331d0a001f5bc$exports, "_isFirebaseServerAppSettings", function () { return $0c1331d0a001f5bc$export$38e311c93c671bec; });
$parcel$export($0c1331d0a001f5bc$exports, "_isFirebaseServerApp", function () { return $0c1331d0a001f5bc$export$643c8bc6c389f34e; });
$parcel$export($0c1331d0a001f5bc$exports, "_clearComponents", function () { return $0c1331d0a001f5bc$export$3685d89b9c3cdfaf; });
$parcel$export($0c1331d0a001f5bc$exports, "registerVersion", function () { return $0c1331d0a001f5bc$export$d29d5299a7137abc; });
$parcel$export($0c1331d0a001f5bc$exports, "deleteApp", function () { return $0c1331d0a001f5bc$export$6eec44aa53d5ea34; });
$parcel$export($0c1331d0a001f5bc$exports, "SDK_VERSION", function () { return $0c1331d0a001f5bc$export$31499a9cd224b78c; });
$parcel$export($0c1331d0a001f5bc$exports, "initializeApp", function () { return $0c1331d0a001f5bc$export$c55cfd413944906d; });
$parcel$export($0c1331d0a001f5bc$exports, "initializeServerApp", function () { return $0c1331d0a001f5bc$export$45a407ab953b136b; });
$parcel$export($0c1331d0a001f5bc$exports, "getApp", function () { return $0c1331d0a001f5bc$export$f9962582c9e66d99; });
$parcel$export($0c1331d0a001f5bc$exports, "getApps", function () { return $0c1331d0a001f5bc$export$68ddedf7d44b3bdf; });
$parcel$export($0c1331d0a001f5bc$exports, "onLog", function () { return $0c1331d0a001f5bc$export$a82ad227dc8163dc; });
$parcel$export($0c1331d0a001f5bc$exports, "setLogLevel", function () { return $0c1331d0a001f5bc$export$c622e99c0ce7b1c9; });
$parcel$export($0c1331d0a001f5bc$exports, "FirebaseError", function () { return $3117f6f4eeb4c314$export$dd24e9cd51226c56; });

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $6640afd658bf2724$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $6640afd658bf2724$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($6640afd658bf2724$export$243e62d78d3b544d || ($6640afd658bf2724$export$243e62d78d3b544d = {}));
const $6640afd658bf2724$var$levelStringToEnum = {
    'debug': $6640afd658bf2724$export$243e62d78d3b544d.DEBUG,
    'verbose': $6640afd658bf2724$export$243e62d78d3b544d.VERBOSE,
    'info': $6640afd658bf2724$export$243e62d78d3b544d.INFO,
    'warn': $6640afd658bf2724$export$243e62d78d3b544d.WARN,
    'error': $6640afd658bf2724$export$243e62d78d3b544d.ERROR,
    'silent': $6640afd658bf2724$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $6640afd658bf2724$var$defaultLogLevel = $6640afd658bf2724$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $6640afd658bf2724$var$ConsoleMethod = {
    [$6640afd658bf2724$export$243e62d78d3b544d.DEBUG]: 'log',
    [$6640afd658bf2724$export$243e62d78d3b544d.VERBOSE]: 'log',
    [$6640afd658bf2724$export$243e62d78d3b544d.INFO]: 'info',
    [$6640afd658bf2724$export$243e62d78d3b544d.WARN]: 'warn',
    [$6640afd658bf2724$export$243e62d78d3b544d.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $6640afd658bf2724$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $6640afd658bf2724$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $6640afd658bf2724$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $6640afd658bf2724$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $6640afd658bf2724$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $6640afd658bf2724$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $6640afd658bf2724$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? $6640afd658bf2724$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') throw new TypeError('Value assigned to `logHandler` must be a function');
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $6640afd658bf2724$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $6640afd658bf2724$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $6640afd658bf2724$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $6640afd658bf2724$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $6640afd658bf2724$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $6640afd658bf2724$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $6640afd658bf2724$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $6640afd658bf2724$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $6640afd658bf2724$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $6640afd658bf2724$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $6640afd658bf2724$export$c622e99c0ce7b1c9(level) {
    $6640afd658bf2724$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $6640afd658bf2724$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $6640afd658bf2724$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $6640afd658bf2724$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === 'string') return arg;
                else if (typeof arg === 'number' || typeof arg === 'boolean') return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(' ');
            if (level >= (customLogLevel ?? instance.logLevel)) logCallback({
                level: $6640afd658bf2724$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



const $df56a7cb4addbeff$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $df56a7cb4addbeff$var$idbProxyableTypes;
let $df56a7cb4addbeff$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $df56a7cb4addbeff$var$getIdbProxyableTypes() {
    return $df56a7cb4addbeff$var$idbProxyableTypes || ($df56a7cb4addbeff$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $df56a7cb4addbeff$var$getCursorAdvanceMethods() {
    return $df56a7cb4addbeff$var$cursorAdvanceMethods || ($df56a7cb4addbeff$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $df56a7cb4addbeff$var$cursorRequestMap = new WeakMap();
const $df56a7cb4addbeff$var$transactionDoneMap = new WeakMap();
const $df56a7cb4addbeff$var$transactionStoreNamesMap = new WeakMap();
const $df56a7cb4addbeff$var$transformCache = new WeakMap();
const $df56a7cb4addbeff$export$407448d2b89b1813 = new WeakMap();
function $df56a7cb4addbeff$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($df56a7cb4addbeff$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $df56a7cb4addbeff$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $df56a7cb4addbeff$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $df56a7cb4addbeff$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($df56a7cb4addbeff$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $df56a7cb4addbeff$var$transactionDoneMap.set(tx, done);
}
let $df56a7cb4addbeff$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $df56a7cb4addbeff$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') return target.objectStoreNames || $df56a7cb4addbeff$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $df56a7cb4addbeff$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $df56a7cb4addbeff$export$43caf9889c228507(callback) {
    $df56a7cb4addbeff$var$idbProxyTraps = callback($df56a7cb4addbeff$var$idbProxyTraps);
}
function $df56a7cb4addbeff$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !('objectStoreNames' in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($df56a7cb4addbeff$export$3b14a55fb2447963(this), storeNames, ...args);
        $df56a7cb4addbeff$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $df56a7cb4addbeff$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($df56a7cb4addbeff$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($df56a7cb4addbeff$export$3b14a55fb2447963(this), args);
        return $df56a7cb4addbeff$export$efccba1c4a2ef57b($df56a7cb4addbeff$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $df56a7cb4addbeff$export$efccba1c4a2ef57b(func.apply($df56a7cb4addbeff$export$3b14a55fb2447963(this), args));
    };
}
function $df56a7cb4addbeff$var$transformCachableValue(value) {
    if (typeof value === 'function') return $df56a7cb4addbeff$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $df56a7cb4addbeff$var$cacheDonePromiseForTransaction(value);
    if ($df56a7cb4addbeff$export$23f2a1d2818174ef(value, $df56a7cb4addbeff$var$getIdbProxyableTypes())) return new Proxy(value, $df56a7cb4addbeff$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $df56a7cb4addbeff$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $df56a7cb4addbeff$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($df56a7cb4addbeff$var$transformCache.has(value)) return $df56a7cb4addbeff$var$transformCache.get(value);
    const newValue = $df56a7cb4addbeff$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $df56a7cb4addbeff$var$transformCache.set(value, newValue);
        $df56a7cb4addbeff$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $df56a7cb4addbeff$export$3b14a55fb2447963 = (value)=>$df56a7cb4addbeff$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $7f1f6f4a4e054c97$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $df56a7cb4addbeff$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade((0, $df56a7cb4addbeff$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $df56a7cb4addbeff$export$efccba1c4a2ef57b)(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $7f1f6f4a4e054c97$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $df56a7cb4addbeff$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $7f1f6f4a4e054c97$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $7f1f6f4a4e054c97$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $7f1f6f4a4e054c97$var$cachedMethods = new Map();
function $7f1f6f4a4e054c97$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($7f1f6f4a4e054c97$var$cachedMethods.get(prop)) return $7f1f6f4a4e054c97$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $7f1f6f4a4e054c97$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $7f1f6f4a4e054c97$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $7f1f6f4a4e054c97$var$cachedMethods.set(prop, method);
    return method;
}
(0, $df56a7cb4addbeff$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$7f1f6f4a4e054c97$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$7f1f6f4a4e054c97$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $0c1331d0a001f5bc$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($0c1331d0a001f5bc$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $0c1331d0a001f5bc$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return component?.type === "VERSION" /* ComponentType.VERSION */ ;
}
const $0c1331d0a001f5bc$var$name$q = "@firebase/app";
const $0c1331d0a001f5bc$var$version$1 = "0.14.9";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0c1331d0a001f5bc$var$logger = new (0, $6640afd658bf2724$export$efa9a398d6368992)('@firebase/app');
const $0c1331d0a001f5bc$var$name$p = "@firebase/app-compat";
const $0c1331d0a001f5bc$var$name$o = "@firebase/analytics-compat";
const $0c1331d0a001f5bc$var$name$n = "@firebase/analytics";
const $0c1331d0a001f5bc$var$name$m = "@firebase/app-check-compat";
const $0c1331d0a001f5bc$var$name$l = "@firebase/app-check";
const $0c1331d0a001f5bc$var$name$k = "@firebase/auth";
const $0c1331d0a001f5bc$var$name$j = "@firebase/auth-compat";
const $0c1331d0a001f5bc$var$name$i = "@firebase/database";
const $0c1331d0a001f5bc$var$name$h = "@firebase/data-connect";
const $0c1331d0a001f5bc$var$name$g = "@firebase/database-compat";
const $0c1331d0a001f5bc$var$name$f = "@firebase/functions";
const $0c1331d0a001f5bc$var$name$e = "@firebase/functions-compat";
const $0c1331d0a001f5bc$var$name$d = "@firebase/installations";
const $0c1331d0a001f5bc$var$name$c = "@firebase/installations-compat";
const $0c1331d0a001f5bc$var$name$b = "@firebase/messaging";
const $0c1331d0a001f5bc$var$name$a = "@firebase/messaging-compat";
const $0c1331d0a001f5bc$var$name$9 = "@firebase/performance";
const $0c1331d0a001f5bc$var$name$8 = "@firebase/performance-compat";
const $0c1331d0a001f5bc$var$name$7 = "@firebase/remote-config";
const $0c1331d0a001f5bc$var$name$6 = "@firebase/remote-config-compat";
const $0c1331d0a001f5bc$var$name$5 = "@firebase/storage";
const $0c1331d0a001f5bc$var$name$4 = "@firebase/storage-compat";
const $0c1331d0a001f5bc$var$name$3 = "@firebase/firestore";
const $0c1331d0a001f5bc$var$name$2 = "@firebase/ai";
const $0c1331d0a001f5bc$var$name$1 = "@firebase/firestore-compat";
const $0c1331d0a001f5bc$var$name = "firebase";
const $0c1331d0a001f5bc$var$version = "12.10.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $0c1331d0a001f5bc$export$9f30fa0c10967f7f = '[DEFAULT]';
const $0c1331d0a001f5bc$var$PLATFORM_LOG_STRING = {
    [$0c1331d0a001f5bc$var$name$q]: 'fire-core',
    [$0c1331d0a001f5bc$var$name$p]: 'fire-core-compat',
    [$0c1331d0a001f5bc$var$name$n]: 'fire-analytics',
    [$0c1331d0a001f5bc$var$name$o]: 'fire-analytics-compat',
    [$0c1331d0a001f5bc$var$name$l]: 'fire-app-check',
    [$0c1331d0a001f5bc$var$name$m]: 'fire-app-check-compat',
    [$0c1331d0a001f5bc$var$name$k]: 'fire-auth',
    [$0c1331d0a001f5bc$var$name$j]: 'fire-auth-compat',
    [$0c1331d0a001f5bc$var$name$i]: 'fire-rtdb',
    [$0c1331d0a001f5bc$var$name$h]: 'fire-data-connect',
    [$0c1331d0a001f5bc$var$name$g]: 'fire-rtdb-compat',
    [$0c1331d0a001f5bc$var$name$f]: 'fire-fn',
    [$0c1331d0a001f5bc$var$name$e]: 'fire-fn-compat',
    [$0c1331d0a001f5bc$var$name$d]: 'fire-iid',
    [$0c1331d0a001f5bc$var$name$c]: 'fire-iid-compat',
    [$0c1331d0a001f5bc$var$name$b]: 'fire-fcm',
    [$0c1331d0a001f5bc$var$name$a]: 'fire-fcm-compat',
    [$0c1331d0a001f5bc$var$name$9]: 'fire-perf',
    [$0c1331d0a001f5bc$var$name$8]: 'fire-perf-compat',
    [$0c1331d0a001f5bc$var$name$7]: 'fire-rc',
    [$0c1331d0a001f5bc$var$name$6]: 'fire-rc-compat',
    [$0c1331d0a001f5bc$var$name$5]: 'fire-gcs',
    [$0c1331d0a001f5bc$var$name$4]: 'fire-gcs-compat',
    [$0c1331d0a001f5bc$var$name$3]: 'fire-fst',
    [$0c1331d0a001f5bc$var$name$1]: 'fire-fst-compat',
    [$0c1331d0a001f5bc$var$name$2]: 'fire-vertex',
    'fire-js': 'fire-js',
    [$0c1331d0a001f5bc$var$name]: 'fire-js-all'
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $0c1331d0a001f5bc$export$b4e3c36c855b14b5 = new Map();
/**
 * @internal
 */ const $0c1331d0a001f5bc$export$fb03ad8d3d5c5f76 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0c1331d0a001f5bc$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $0c1331d0a001f5bc$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $0c1331d0a001f5bc$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $0c1331d0a001f5bc$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $0c1331d0a001f5bc$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($0c1331d0a001f5bc$export$9566bce3835c0f28.has(componentName)) {
        $0c1331d0a001f5bc$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $0c1331d0a001f5bc$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $0c1331d0a001f5bc$export$b4e3c36c855b14b5.values())$0c1331d0a001f5bc$export$fa5244b94c62d36a(app, component);
    for (const serverApp of $0c1331d0a001f5bc$export$fb03ad8d3d5c5f76.values())$0c1331d0a001f5bc$export$fa5244b94c62d36a(serverApp, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $0c1331d0a001f5bc$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider('heartbeat').getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $0c1331d0a001f5bc$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $0c1331d0a001f5bc$export$9f30fa0c10967f7f) {
    $0c1331d0a001f5bc$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp, FirebaseOptions or FirebaseAppSettings.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function $0c1331d0a001f5bc$export$110778f8e98b8257(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp, FirebaseOptions or FirebaseAppSettings.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $0c1331d0a001f5bc$export$38e311c93c671bec(obj) {
    if ($0c1331d0a001f5bc$export$110778f8e98b8257(obj)) return false;
    return 'authIdToken' in obj || 'appCheckToken' in obj || 'releaseOnDeref' in obj || 'automaticDataCollectionEnabled' in obj;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $0c1331d0a001f5bc$export$643c8bc6c389f34e(obj) {
    if (obj === null || obj === undefined) return false;
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function $0c1331d0a001f5bc$export$3685d89b9c3cdfaf() {
    $0c1331d0a001f5bc$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0c1331d0a001f5bc$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */ ]: 'Firebase Server App has been deleted',
    ["no-options" /* AppError.NO_OPTIONS */ ]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */ ]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */ ]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */ ]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */ ]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.',
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ ]: 'FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.',
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ ]: 'FirebaseServerApp is not for use in browser environments.'
};
const $0c1331d0a001f5bc$var$ERROR_FACTORY = new (0, $3117f6f4eeb4c314$export$3fa6e1b18a3b2d40)('app', 'Firebase', $0c1331d0a001f5bc$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $0c1331d0a001f5bc$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = {
            ...options
        };
        this._config = {
            ...config
        };
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $ad76b76e741ec0c7$export$16fa2f45be04daa8)('app', ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $0c1331d0a001f5bc$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Parse the token and check to see if the `exp` claim is in the future.
// Reports an error to the console if the token or claim could not be parsed, or if `exp` is in
// the past.
function $0c1331d0a001f5bc$var$validateTokenTTL(base64Token, tokenName) {
    const secondPart = (0, $3117f6f4eeb4c314$export$c62426fdd000a97e)(base64Token.split('.')[1]);
    if (secondPart === null) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: second part could not be parsed.`);
        return;
    }
    const expClaim = JSON.parse(secondPart).exp;
    if (expClaim === undefined) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: expiration claim could not be parsed`);
        return;
    }
    const exp = JSON.parse(secondPart).exp * 1000;
    const now = new Date().getTime();
    const diff = exp - now;
    if (diff <= 0) console.error(`FirebaseServerApp ${tokenName} is invalid: the token has expired.`);
}
class $0c1331d0a001f5bc$var$FirebaseServerAppImpl extends $0c1331d0a001f5bc$var$FirebaseAppImpl {
    constructor(options, serverConfig, name, container){
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : true;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name: name,
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        super(options, config, container);
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = {
            automaticDataCollectionEnabled: automaticDataCollectionEnabled,
            ...serverConfig
        };
        // Ensure that the current time is within the `authIdtoken` window of validity.
        if (this._serverConfig.authIdToken) $0c1331d0a001f5bc$var$validateTokenTTL(this._serverConfig.authIdToken, 'authIdToken');
        // Ensure that the current time is within the `appCheckToken` window of validity.
        if (this._serverConfig.appCheckToken) $0c1331d0a001f5bc$var$validateTokenTTL(this._serverConfig.appCheckToken, 'appCheckToken');
        this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== 'undefined') this._finalizationRegistry = new FinalizationRegistry(()=>{
            this.automaticCleanup();
        });
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        $0c1331d0a001f5bc$export$d29d5299a7137abc($0c1331d0a001f5bc$var$name$q, $0c1331d0a001f5bc$var$version$1, 'serverapp');
    }
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) return;
        this._refCount++;
        if (obj !== undefined && this._finalizationRegistry !== null) this._finalizationRegistry.register(obj, this);
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) return 0;
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        $0c1331d0a001f5bc$export$6eec44aa53d5ea34(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $0c1331d0a001f5bc$var$ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $0c1331d0a001f5bc$export$31499a9cd224b78c = $0c1331d0a001f5bc$var$version;
function $0c1331d0a001f5bc$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = {
        name: $0c1331d0a001f5bc$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: true,
        ...rawConfig
    };
    const name = config.name;
    if (typeof name !== 'string' || !name) throw $0c1331d0a001f5bc$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $3117f6f4eeb4c314$export$3dfb6827a9f89756)());
    if (!options) throw $0c1331d0a001f5bc$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $0c1331d0a001f5bc$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $3117f6f4eeb4c314$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $3117f6f4eeb4c314$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $0c1331d0a001f5bc$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $ad76b76e741ec0c7$export$436a80eea5d5c0c5)(name);
    for (const component of $0c1331d0a001f5bc$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $0c1331d0a001f5bc$var$FirebaseAppImpl(options, config, container);
    $0c1331d0a001f5bc$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
function $0c1331d0a001f5bc$export$45a407ab953b136b(_options, _serverAppConfig = {}) {
    if ((0, $3117f6f4eeb4c314$export$4e09c449d6c407f7)() && !(0, $3117f6f4eeb4c314$export$97b87b8868ff7a3c)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw $0c1331d0a001f5bc$var$ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    let firebaseOptions;
    let serverAppSettings = _serverAppConfig || {};
    if (_options) {
        if ($0c1331d0a001f5bc$export$110778f8e98b8257(_options)) firebaseOptions = _options.options;
        else if ($0c1331d0a001f5bc$export$38e311c93c671bec(_options)) serverAppSettings = _options;
        else firebaseOptions = _options;
    }
    if (serverAppSettings.automaticDataCollectionEnabled === undefined) serverAppSettings.automaticDataCollectionEnabled = true;
    firebaseOptions || (firebaseOptions = (0, $3117f6f4eeb4c314$export$3dfb6827a9f89756)());
    if (!firebaseOptions) throw $0c1331d0a001f5bc$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    // Build an app name based on a hash of the configuration options.
    const nameObj = {
        ...serverAppSettings,
        ...firebaseOptions
    };
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    const hashCode = (s)=>{
        return [
            ...s
        ].reduce((hash, c)=>Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
    };
    if (serverAppSettings.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === 'undefined') throw $0c1331d0a001f5bc$var$ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    const nameString = '' + hashCode(JSON.stringify(nameObj));
    const existingApp = $0c1331d0a001f5bc$export$fb03ad8d3d5c5f76.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(serverAppSettings.releaseOnDeref);
        return existingApp;
    }
    const container = new (0, $ad76b76e741ec0c7$export$436a80eea5d5c0c5)(nameString);
    for (const component of $0c1331d0a001f5bc$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $0c1331d0a001f5bc$var$FirebaseServerAppImpl(firebaseOptions, serverAppSettings, nameString, container);
    $0c1331d0a001f5bc$export$fb03ad8d3d5c5f76.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $0c1331d0a001f5bc$export$f9962582c9e66d99(name = $0c1331d0a001f5bc$export$9f30fa0c10967f7f) {
    const app = $0c1331d0a001f5bc$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $0c1331d0a001f5bc$export$9f30fa0c10967f7f && (0, $3117f6f4eeb4c314$export$3dfb6827a9f89756)()) return $0c1331d0a001f5bc$export$c55cfd413944906d();
    if (!app) throw $0c1331d0a001f5bc$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $0c1331d0a001f5bc$export$68ddedf7d44b3bdf() {
    return Array.from($0c1331d0a001f5bc$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $0c1331d0a001f5bc$export$6eec44aa53d5ea34(app) {
    let cleanupProviders = false;
    const name = app.name;
    if ($0c1331d0a001f5bc$export$b4e3c36c855b14b5.has(name)) {
        cleanupProviders = true;
        $0c1331d0a001f5bc$export$b4e3c36c855b14b5.delete(name);
    } else if ($0c1331d0a001f5bc$export$fb03ad8d3d5c5f76.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            $0c1331d0a001f5bc$export$fb03ad8d3d5c5f76.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $0c1331d0a001f5bc$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = $0c1331d0a001f5bc$var$PLATFORM_LOG_STRING[libraryKeyOrName] ?? libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push('and');
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $0c1331d0a001f5bc$var$logger.warn(warning.join(' '));
        return;
    }
    $0c1331d0a001f5bc$export$c930050e7bb63965(new (0, $ad76b76e741ec0c7$export$16fa2f45be04daa8)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $0c1331d0a001f5bc$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') throw $0c1331d0a001f5bc$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $6640afd658bf2724$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $0c1331d0a001f5bc$export$c622e99c0ce7b1c9(logLevel) {
    (0, $6640afd658bf2724$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0c1331d0a001f5bc$var$DB_NAME = 'firebase-heartbeat-database';
const $0c1331d0a001f5bc$var$DB_VERSION = 1;
const $0c1331d0a001f5bc$var$STORE_NAME = 'firebase-heartbeat-store';
let $0c1331d0a001f5bc$var$dbPromise = null;
function $0c1331d0a001f5bc$var$getDbPromise() {
    if (!$0c1331d0a001f5bc$var$dbPromise) $0c1331d0a001f5bc$var$dbPromise = (0, $7f1f6f4a4e054c97$export$ca0ed41b1a2af7e)($0c1331d0a001f5bc$var$DB_NAME, $0c1331d0a001f5bc$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($0c1331d0a001f5bc$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw $0c1331d0a001f5bc$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $0c1331d0a001f5bc$var$dbPromise;
}
async function $0c1331d0a001f5bc$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $0c1331d0a001f5bc$var$getDbPromise();
        const tx = db.transaction($0c1331d0a001f5bc$var$STORE_NAME);
        const result = await tx.objectStore($0c1331d0a001f5bc$var$STORE_NAME).get($0c1331d0a001f5bc$var$computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, $3117f6f4eeb4c314$export$dd24e9cd51226c56)) $0c1331d0a001f5bc$var$logger.warn(e.message);
        else {
            const idbGetError = $0c1331d0a001f5bc$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e?.message
            });
            $0c1331d0a001f5bc$var$logger.warn(idbGetError.message);
        }
    }
}
async function $0c1331d0a001f5bc$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $0c1331d0a001f5bc$var$getDbPromise();
        const tx = db.transaction($0c1331d0a001f5bc$var$STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore($0c1331d0a001f5bc$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $0c1331d0a001f5bc$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $3117f6f4eeb4c314$export$dd24e9cd51226c56)) $0c1331d0a001f5bc$var$logger.warn(e.message);
        else {
            const idbGetError = $0c1331d0a001f5bc$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e?.message
            });
            $0c1331d0a001f5bc$var$logger.warn(idbGetError.message);
        }
    }
}
function $0c1331d0a001f5bc$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0c1331d0a001f5bc$var$MAX_HEADER_BYTES = 1024;
const $0c1331d0a001f5bc$var$MAX_NUM_STORED_HEARTBEATS = 30;
class $0c1331d0a001f5bc$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new $0c1331d0a001f5bc$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        try {
            const platformLogger = this.container.getProvider('platform-logger').getImmediate();
            // This is the "Firebase user agent" string from the platform logger
            // service, not the browser user agent.
            const agent = platformLogger.getPlatformInfoString();
            const date = $0c1331d0a001f5bc$var$getUTCDateString();
            if (this._heartbeatsCache?.heartbeats == null) {
                this._heartbeatsCache = await this._heartbeatsCachePromise;
                // If we failed to construct a heartbeats cache, then return immediately.
                if (this._heartbeatsCache?.heartbeats == null) return;
            }
            // Do not store a heartbeat if one is already stored for this day
            // or if a header has already been sent today.
            if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
            else {
                // There is no entry for this date. Create one.
                this._heartbeatsCache.heartbeats.push({
                    date: date,
                    agent: agent
                });
                // If the number of stored heartbeats exceeds the maximum number of stored heartbeats, remove the heartbeat with the earliest date.
                // Since this is executed each time a heartbeat is pushed, the limit can only be exceeded by one, so only one needs to be removed.
                if (this._heartbeatsCache.heartbeats.length > $0c1331d0a001f5bc$var$MAX_NUM_STORED_HEARTBEATS) {
                    const earliestHeartbeatIdx = $0c1331d0a001f5bc$var$getEarliestHeartbeatIdx(this._heartbeatsCache.heartbeats);
                    this._heartbeatsCache.heartbeats.splice(earliestHeartbeatIdx, 1);
                }
            }
            return this._storage.overwrite(this._heartbeatsCache);
        } catch (e) {
            $0c1331d0a001f5bc$var$logger.warn(e);
        }
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        try {
            if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
            // If it's still null or the array is empty, there is no data to send.
            if (this._heartbeatsCache?.heartbeats == null || this._heartbeatsCache.heartbeats.length === 0) return '';
            const date = $0c1331d0a001f5bc$var$getUTCDateString();
            // Extract as many heartbeats from the cache as will fit under the size limit.
            const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $0c1331d0a001f5bc$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
            const headerString = (0, $3117f6f4eeb4c314$export$4b5284a3025a455)(JSON.stringify({
                version: 2,
                heartbeats: heartbeatsToSend
            }));
            // Store last sent date to prevent another being logged/sent for the same day.
            this._heartbeatsCache.lastSentHeartbeatDate = date;
            if (unsentEntries.length > 0) {
                // Store any unsent entries if they exist.
                this._heartbeatsCache.heartbeats = unsentEntries;
                // This seems more likely than emptying the array (below) to lead to some odd state
                // since the cache isn't empty and this will be called again on the next request,
                // and is probably safest if we await it.
                await this._storage.overwrite(this._heartbeatsCache);
            } else {
                this._heartbeatsCache.heartbeats = [];
                // Do not wait for this, to reduce latency.
                this._storage.overwrite(this._heartbeatsCache);
            }
            return headerString;
        } catch (e) {
            $0c1331d0a001f5bc$var$logger.warn(e);
            return '';
        }
    }
}
function $0c1331d0a001f5bc$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $0c1331d0a001f5bc$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $0c1331d0a001f5bc$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($0c1331d0a001f5bc$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($0c1331d0a001f5bc$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $0c1331d0a001f5bc$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $3117f6f4eeb4c314$export$3865db50535c2055)()) return false;
        else return (0, $3117f6f4eeb4c314$export$a8a3018f3d187a4d)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $0c1331d0a001f5bc$var$readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject?.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $0c1331d0a001f5bc$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: heartbeatsObject.lastSentHeartbeatDate ?? existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $0c1331d0a001f5bc$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: heartbeatsObject.lastSentHeartbeatDate ?? existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $0c1331d0a001f5bc$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $3117f6f4eeb4c314$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * Returns the index of the heartbeat with the earliest date.
 * If the heartbeats array is empty, -1 is returned.
 */ function $0c1331d0a001f5bc$var$getEarliestHeartbeatIdx(heartbeats) {
    if (heartbeats.length === 0) return -1;
    let earliestHeartbeatIdx = 0;
    let earliestHeartbeatDate = heartbeats[0].date;
    for(let i = 1; i < heartbeats.length; i++)if (heartbeats[i].date < earliestHeartbeatDate) {
        earliestHeartbeatDate = heartbeats[i].date;
        earliestHeartbeatIdx = i;
    }
    return earliestHeartbeatIdx;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0c1331d0a001f5bc$var$registerCoreComponents(variant) {
    $0c1331d0a001f5bc$export$c930050e7bb63965(new (0, $ad76b76e741ec0c7$export$16fa2f45be04daa8)('platform-logger', (container)=>new $0c1331d0a001f5bc$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $0c1331d0a001f5bc$export$c930050e7bb63965(new (0, $ad76b76e741ec0c7$export$16fa2f45be04daa8)('heartbeat', (container)=>new $0c1331d0a001f5bc$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $0c1331d0a001f5bc$export$d29d5299a7137abc($0c1331d0a001f5bc$var$name$q, $0c1331d0a001f5bc$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    $0c1331d0a001f5bc$export$d29d5299a7137abc($0c1331d0a001f5bc$var$name$q, $0c1331d0a001f5bc$var$version$1, 'esm2020');
    // Register platform SDK identifier (no version).
    $0c1331d0a001f5bc$export$d29d5299a7137abc('fire-js', '');
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $0c1331d0a001f5bc$var$registerCoreComponents('');



/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Global context object for a collection of services using
 * a shared authentication state.
 *
 * marked as internal because it references internal types exported from @firebase/app
 * @internal
 */ class $42ddf94e6f3c0a26$var$FirebaseAppImpl {
    constructor(_delegate, firebase){
        this._delegate = _delegate;
        this.firebase = firebase;
        // add itself to container
        (0, $0c1331d0a001f5bc$export$fa5244b94c62d36a)(_delegate, new (0, $ad76b76e741ec0c7$export$16fa2f45be04daa8)('app-compat', ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
        this.container = _delegate.container;
    }
    get automaticDataCollectionEnabled() {
        return this._delegate.automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this._delegate.automaticDataCollectionEnabled = val;
    }
    get name() {
        return this._delegate.name;
    }
    get options() {
        return this._delegate.options;
    }
    delete() {
        return new Promise((resolve)=>{
            this._delegate.checkDestroyed();
            resolve();
        }).then(()=>{
            this.firebase.INTERNAL.removeApp(this.name);
            return (0, $0c1331d0a001f5bc$export$6eec44aa53d5ea34)(this._delegate);
        });
    }
    /**
     * Return a service instance associated with this app (creating it
     * on demand), identified by the passed instanceIdentifier.
     *
     * NOTE: Currently storage and functions are the only ones that are leveraging this
     * functionality. They invoke it by calling:
     *
     * ```javascript
     * firebase.app().storage('STORAGE BUCKET ID')
     * ```
     *
     * The service name is passed to this already
     * @internal
     */ _getService(name, instanceIdentifier = (0, $0c1331d0a001f5bc$export$9f30fa0c10967f7f)) {
        this._delegate.checkDestroyed();
        // Initialize instance if InstantiationMode is `EXPLICIT`.
        const provider = this._delegate.container.getProvider(name);
        if (!provider.isInitialized() && provider.getComponent()?.instantiationMode === "EXPLICIT" /* InstantiationMode.EXPLICIT */ ) provider.initialize();
        // getImmediate will always succeed because _getService is only called for registered components.
        return provider.getImmediate({
            identifier: instanceIdentifier
        });
    }
    /**
     * Remove a service instance from the cache, so we will create a new instance for this service
     * when people try to get it again.
     *
     * NOTE: currently only firestore uses this functionality to support firestore shutdown.
     *
     * @param name The service name
     * @param instanceIdentifier instance identifier in case multiple instances are allowed
     * @internal
     */ _removeServiceInstance(name, instanceIdentifier = (0, $0c1331d0a001f5bc$export$9f30fa0c10967f7f)) {
        this._delegate.container// eslint-disable-next-line @typescript-eslint/no-explicit-any
        .getProvider(name).clearInstance(instanceIdentifier);
    }
    /**
     * @param component the component being added to this app's container
     * @internal
     */ _addComponent(component) {
        (0, $0c1331d0a001f5bc$export$fa5244b94c62d36a)(this._delegate, component);
    }
    _addOrOverwriteComponent(component) {
        (0, $0c1331d0a001f5bc$export$4393112b42e2b41d)(this._delegate, component);
    }
    toJSON() {
        return {
            name: this.name,
            automaticDataCollectionEnabled: this.automaticDataCollectionEnabled,
            options: this.options
        };
    }
}
// TODO: investigate why the following needs to be commented out
// Prevent dead-code elimination of these methods w/o invalid property
// copying.
// (FirebaseAppImpl.prototype.name && FirebaseAppImpl.prototype.options) ||
//   FirebaseAppImpl.prototype.delete ||
//   console.log('dc');
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $42ddf94e6f3c0a26$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call Firebase App.initializeApp()",
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance."
};
const $42ddf94e6f3c0a26$var$ERROR_FACTORY = new (0, $3117f6f4eeb4c314$export$3fa6e1b18a3b2d40)('app-compat', 'Firebase', $42ddf94e6f3c0a26$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Because auth can't share code with other components, we attach the utility functions
 * in an internal namespace to share code.
 * This function return a firebase namespace object without
 * any utility functions, so it can be shared between the regular firebaseNamespace and
 * the lite version.
 */ function $42ddf94e6f3c0a26$var$createFirebaseNamespaceCore(firebaseAppImpl) {
    const apps = {};
    // // eslint-disable-next-line @typescript-eslint/no-explicit-any
    // const components = new Map<string, Component<any>>();
    // A namespace is a plain JavaScript Object.
    const namespace = {
        // Hack to prevent Babel from modifying the object returned
        // as the firebase namespace.
        // @ts-ignore
        __esModule: true,
        initializeApp: initializeAppCompat,
        app: // @ts-ignore
        app,
        registerVersion: $0c1331d0a001f5bc$export$d29d5299a7137abc,
        setLogLevel: $0c1331d0a001f5bc$export$c622e99c0ce7b1c9,
        onLog: $0c1331d0a001f5bc$export$a82ad227dc8163dc,
        // @ts-ignore
        apps: null,
        SDK_VERSION: $0c1331d0a001f5bc$export$31499a9cd224b78c,
        INTERNAL: {
            registerComponent: registerComponentCompat,
            removeApp: removeApp,
            useAsService: useAsService,
            modularAPIs: $0c1331d0a001f5bc$exports
        }
    };
    // Inject a circular default export to allow Babel users who were previously
    // using:
    //
    //   import firebase from 'firebase';
    //   which becomes: var firebase = require('firebase').default;
    //
    // instead of
    //
    //   import * as firebase from 'firebase';
    //   which becomes: var firebase = require('firebase');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    namespace['default'] = namespace;
    // firebase.apps is a read-only getter.
    Object.defineProperty(namespace, 'apps', {
        get: getApps
    });
    /**
     * Called by App.delete() - but before any services associated with the App
     * are deleted.
     */ function removeApp(name) {
        delete apps[name];
    }
    /**
     * Get the App object for a given name (or DEFAULT).
     */ function app(name) {
        name = name || $0c1331d0a001f5bc$export$9f30fa0c10967f7f;
        if (!(0, $3117f6f4eeb4c314$export$2344b14b097df817)(apps, name)) throw $42ddf94e6f3c0a26$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
            appName: name
        });
        return apps[name];
    }
    // @ts-ignore
    app['App'] = firebaseAppImpl;
    /**
     * Create a new App instance (name must be unique).
     *
     * This function is idempotent. It can be called more than once and return the same instance using the same options and config.
     */ function initializeAppCompat(options, rawConfig = {}) {
        const app = $0c1331d0a001f5bc$export$c55cfd413944906d(options, rawConfig);
        if ((0, $3117f6f4eeb4c314$export$2344b14b097df817)(apps, app.name)) return apps[app.name];
        const appCompat = new firebaseAppImpl(app, namespace);
        apps[app.name] = appCompat;
        return appCompat;
    }
    /*
     * Return an array of all the non-deleted FirebaseApps.
     */ function getApps() {
        // Make a copy so caller cannot mutate the apps list.
        return Object.keys(apps).map((name)=>apps[name]);
    }
    function registerComponentCompat(component) {
        const componentName = component.name;
        const componentNameWithoutCompat = componentName.replace('-compat', '');
        if ($0c1331d0a001f5bc$export$c930050e7bb63965(component) && component.type === "PUBLIC" /* ComponentType.PUBLIC */ ) {
            // create service namespace for public components
            // The Service namespace is an accessor function ...
            const serviceNamespace = (appArg = app())=>{
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (typeof appArg[componentNameWithoutCompat] !== 'function') // Invalid argument.
                // This happens in the following case: firebase.storage('gs:/')
                throw $42ddf94e6f3c0a26$var$ERROR_FACTORY.create("invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ , {
                    appName: componentName
                });
                // Forward service instance lookup to the FirebaseApp.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return appArg[componentNameWithoutCompat]();
            };
            // ... and a container for service-level properties.
            if (component.serviceProps !== undefined) (0, $3117f6f4eeb4c314$export$54e9fb29908872fa)(serviceNamespace, component.serviceProps);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            namespace[componentNameWithoutCompat] = serviceNamespace;
            // Patch the FirebaseAppImpl prototype
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            firebaseAppImpl.prototype[componentNameWithoutCompat] = // TODO: The eslint disable can be removed and the 'ignoreRestArgs'
            // option added to the no-explicit-any rule when ESlint releases it.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            function(...args) {
                const serviceFxn = this._getService.bind(this, componentName);
                return serviceFxn.apply(this, component.multipleInstances ? args : []);
            };
        }
        return component.type === "PUBLIC" /* ComponentType.PUBLIC */  ? namespace[componentNameWithoutCompat] : null;
    }
    // Map the requested service to a registered service name
    // (used to map auth to serverAuth service when needed).
    function useAsService(app, name) {
        if (name === 'serverAuth') return null;
        const useService = name;
        return useService;
    }
    return namespace;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Return a firebase namespace object.
 *
 * In production, this will be called exactly once and the result
 * assigned to the 'firebase' global.  It may be called multiple times
 * in unit tests.
 */ function $42ddf94e6f3c0a26$var$createFirebaseNamespace() {
    const namespace = $42ddf94e6f3c0a26$var$createFirebaseNamespaceCore($42ddf94e6f3c0a26$var$FirebaseAppImpl);
    namespace.INTERNAL = {
        ...namespace.INTERNAL,
        createFirebaseNamespace: $42ddf94e6f3c0a26$var$createFirebaseNamespace,
        extendNamespace: extendNamespace,
        createSubscribe: $3117f6f4eeb4c314$export$364097d812234b3f,
        ErrorFactory: $3117f6f4eeb4c314$export$3fa6e1b18a3b2d40,
        deepExtend: $3117f6f4eeb4c314$export$54e9fb29908872fa
    };
    /**
     * Patch the top-level firebase namespace with additional properties.
     *
     * firebase.INTERNAL.extendNamespace()
     */ function extendNamespace(props) {
        (0, $3117f6f4eeb4c314$export$54e9fb29908872fa)(namespace, props);
    }
    return namespace;
}
const $42ddf94e6f3c0a26$var$firebase$1 = $42ddf94e6f3c0a26$var$createFirebaseNamespace();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $42ddf94e6f3c0a26$var$logger = new (0, $6640afd658bf2724$export$efa9a398d6368992)('@firebase/app-compat');
const $42ddf94e6f3c0a26$var$name = "@firebase/app-compat";
const $42ddf94e6f3c0a26$var$version = "0.5.9";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $42ddf94e6f3c0a26$var$registerCoreComponents(variant) {
    // Register `app` package.
    (0, $0c1331d0a001f5bc$export$d29d5299a7137abc)($42ddf94e6f3c0a26$var$name, $42ddf94e6f3c0a26$var$version, variant);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ try {
    const globals = (0, $3117f6f4eeb4c314$export$a4e55266d2135a7f)();
    // Firebase Lite detection
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (globals.firebase !== undefined) {
        $42ddf94e6f3c0a26$var$logger.warn(`
      Warning: Firebase is already defined in the global scope. Please make sure
      Firebase library is only loaded once.
    `);
        // eslint-disable-next-line
        const sdkVersion = globals.firebase.SDK_VERSION;
        if (sdkVersion && sdkVersion.indexOf('LITE') >= 0) $42ddf94e6f3c0a26$var$logger.warn(`
        Warning: You are trying to load Firebase while using Firebase Performance standalone script.
        You should load Firebase Performance with this instance of Firebase to avoid loading duplicate code.
        `);
    }
} catch  {
// ignore errors thrown by getGlobal
}
const $42ddf94e6f3c0a26$export$2e2bcd8739ae039 = $42ddf94e6f3c0a26$var$firebase$1;
$42ddf94e6f3c0a26$var$registerCoreComponents();


var $d516c1b302a2a1b7$var$name = "firebase";
var $d516c1b302a2a1b7$var$version = "12.10.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $42ddf94e6f3c0a26$export$2e2bcd8739ae039).registerVersion($d516c1b302a2a1b7$var$name, $d516c1b302a2a1b7$var$version, 'app-compat');






var $584ae1ea48b31d46$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
var $584ae1ea48b31d46$export$2e2bcd8739ae039 = {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/ var $584ae1ea48b31d46$export$70ffa26850098d01;
var $584ae1ea48b31d46$export$9f5a3dfc7a9f5dd;
(function() {
    var h; /** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    function k(d, a) {
        function c() {}
        c.prototype = a.prototype;
        d.F = a.prototype;
        d.prototype = new c;
        d.prototype.constructor = d;
        d.D = function(f, e, g) {
            for(var b = Array(arguments.length - 2), r = 2; r < arguments.length; r++)b[r - 2] = arguments[r];
            return a.prototype[e].apply(f, b);
        };
    }
    function l() {
        this.blockSize = -1;
    }
    function m() {
        this.blockSize = -1;
        this.blockSize = 64;
        this.g = Array(4);
        this.C = Array(this.blockSize);
        this.o = this.h = 0;
        this.u();
    }
    k(m, l);
    m.prototype.u = function() {
        this.g[0] = 1732584193;
        this.g[1] = 4023233417;
        this.g[2] = 2562383102;
        this.g[3] = 271733878;
        this.o = this.h = 0;
    };
    function n(d, a, c) {
        c || (c = 0);
        const f = Array(16);
        if (typeof a === "string") for(var e = 0; e < 16; ++e)f[e] = a.charCodeAt(c++) | a.charCodeAt(c++) << 8 | a.charCodeAt(c++) << 16 | a.charCodeAt(c++) << 24;
        else for(e = 0; e < 16; ++e)f[e] = a[c++] | a[c++] << 8 | a[c++] << 16 | a[c++] << 24;
        a = d.g[0];
        c = d.g[1];
        e = d.g[2];
        let g = d.g[3], b;
        b = a + (g ^ c & (e ^ g)) + f[0] + 3614090360 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + f[1] + 3905402710 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + f[2] + 606105819 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + f[3] + 3250441966 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + f[4] + 4118548399 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + f[5] + 1200080426 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + f[6] + 2821735955 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + f[7] + 4249261313 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + f[8] + 1770035416 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + f[9] + 2336552879 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + f[10] + 4294925233 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + f[11] + 2304563134 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + f[12] + 1804603682 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + f[13] + 4254626195 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + f[14] + 2792965006 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + f[15] + 1236535329 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (e ^ g & (c ^ e)) + f[1] + 4129170786 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + f[6] + 3225465664 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + f[11] + 643717713 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + f[0] + 3921069994 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + f[5] + 3593408605 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + f[10] + 38016083 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + f[15] + 3634488961 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + f[4] + 3889429448 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + f[9] + 568446438 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + f[14] + 3275163606 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + f[3] + 4107603335 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + f[8] + 1163531501 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + f[13] + 2850285829 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + f[2] + 4243563512 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + f[7] + 1735328473 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + f[12] + 2368359562 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (c ^ e ^ g) + f[5] + 4294588738 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + f[8] + 2272392833 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + f[11] + 1839030562 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + f[14] + 4259657740 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + f[1] + 2763975236 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + f[4] + 1272893353 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + f[7] + 4139469664 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + f[10] + 3200236656 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + f[13] + 681279174 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + f[0] + 3936430074 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + f[3] + 3572445317 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + f[6] + 76029189 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + f[9] + 3654602809 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + f[12] + 3873151461 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + f[15] + 530742520 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + f[2] + 3299628645 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (e ^ (c | ~g)) + f[0] + 4096336452 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + f[7] + 1126891415 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + f[14] + 2878612391 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + f[5] + 4237533241 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + f[12] + 1700485571 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + f[3] + 2399980690 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + f[10] + 4293915773 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + f[1] + 2240044497 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + f[8] + 1873313359 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + f[15] + 4264355552 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + f[6] + 2734768916 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + f[13] + 1309151649 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + f[4] + 4149444226 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + f[11] + 3174756917 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + f[2] + 718787259 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + f[9] + 3951481745 & 4294967295;
        d.g[0] = d.g[0] + a & 4294967295;
        d.g[1] = d.g[1] + (e + (b << 21 & 4294967295 | b >>> 11)) & 4294967295;
        d.g[2] = d.g[2] + e & 4294967295;
        d.g[3] = d.g[3] + g & 4294967295;
    }
    m.prototype.v = function(d, a) {
        a === void 0 && (a = d.length);
        const c = a - this.blockSize, f = this.C;
        let e = this.h, g = 0;
        for(; g < a;){
            if (e == 0) for(; g <= c;)n(this, d, g), g += this.blockSize;
            if (typeof d === "string") {
                for(; g < a;)if (f[e++] = d.charCodeAt(g++), e == this.blockSize) {
                    n(this, f);
                    e = 0;
                    break;
                }
            } else for(; g < a;)if (f[e++] = d[g++], e == this.blockSize) {
                n(this, f);
                e = 0;
                break;
            }
        }
        this.h = e;
        this.o += a;
    };
    m.prototype.A = function() {
        var d = Array((this.h < 56 ? this.blockSize : this.blockSize * 2) - this.h);
        d[0] = 128;
        for(var a = 1; a < d.length - 8; ++a)d[a] = 0;
        a = this.o * 8;
        for(var c = d.length - 8; c < d.length; ++c)d[c] = a & 255, a /= 256;
        this.v(d);
        d = Array(16);
        a = 0;
        for(c = 0; c < 4; ++c)for(let f = 0; f < 32; f += 8)d[a++] = this.g[c] >>> f & 255;
        return d;
    };
    function p(d, a) {
        var c = q;
        return Object.prototype.hasOwnProperty.call(c, d) ? c[d] : c[d] = a(d);
    }
    function t(d, a) {
        this.h = a;
        const c = [];
        let f = !0;
        for(let e = d.length - 1; e >= 0; e--){
            const g = d[e] | 0;
            f && g == a || (c[e] = g, f = !1);
        }
        this.g = c;
    }
    var q = {};
    function u(d) {
        return -128 <= d && d < 128 ? p(d, function(a) {
            return new t([
                a | 0
            ], a < 0 ? -1 : 0);
        }) : new t([
            d | 0
        ], d < 0 ? -1 : 0);
    }
    function v(d) {
        if (isNaN(d) || !isFinite(d)) return w;
        if (d < 0) return x(v(-d));
        const a = [];
        let c = 1;
        for(let f = 0; d >= c; f++)a[f] = d / c | 0, c *= 4294967296;
        return new t(a, 0);
    }
    function y(d, a) {
        if (d.length == 0) throw Error("number format error: empty string");
        a = a || 10;
        if (a < 2 || 36 < a) throw Error("radix out of range: " + a);
        if (d.charAt(0) == "-") return x(y(d.substring(1), a));
        if (d.indexOf("-") >= 0) throw Error('number format error: interior "-" character');
        const c = v(Math.pow(a, 8));
        let f = w;
        for(let g = 0; g < d.length; g += 8){
            var e = Math.min(8, d.length - g);
            const b = parseInt(d.substring(g, g + e), a);
            e < 8 ? (e = v(Math.pow(a, e)), f = f.j(e).add(v(b))) : (f = f.j(c), f = f.add(v(b)));
        }
        return f;
    }
    var w = u(0), z = u(1), A = u(16777216);
    h = t.prototype;
    h.m = function() {
        if (B(this)) return -x(this).m();
        let d = 0, a = 1;
        for(let c = 0; c < this.g.length; c++){
            const f = this.i(c);
            d += (f >= 0 ? f : 4294967296 + f) * a;
            a *= 4294967296;
        }
        return d;
    };
    h.toString = function(d) {
        d = d || 10;
        if (d < 2 || 36 < d) throw Error("radix out of range: " + d);
        if (C(this)) return "0";
        if (B(this)) return "-" + x(this).toString(d);
        const a = v(Math.pow(d, 6));
        var c = this;
        let f = "";
        for(;;){
            const e = D(c, a).g;
            c = F(c, e.j(a));
            let g = ((c.g.length > 0 ? c.g[0] : c.h) >>> 0).toString(d);
            c = e;
            if (C(c)) return g + f;
            for(; g.length < 6;)g = "0" + g;
            f = g + f;
        }
    };
    h.i = function(d) {
        return d < 0 ? 0 : d < this.g.length ? this.g[d] : this.h;
    };
    function C(d) {
        if (d.h != 0) return !1;
        for(let a = 0; a < d.g.length; a++)if (d.g[a] != 0) return !1;
        return !0;
    }
    function B(d) {
        return d.h == -1;
    }
    h.l = function(d) {
        d = F(this, d);
        return B(d) ? -1 : C(d) ? 0 : 1;
    };
    function x(d) {
        const a = d.g.length, c = [];
        for(let f = 0; f < a; f++)c[f] = ~d.g[f];
        return new t(c, ~d.h).add(z);
    }
    h.abs = function() {
        return B(this) ? x(this) : this;
    };
    h.add = function(d) {
        const a = Math.max(this.g.length, d.g.length), c = [];
        let f = 0;
        for(let e = 0; e <= a; e++){
            let g = f + (this.i(e) & 65535) + (d.i(e) & 65535), b = (g >>> 16) + (this.i(e) >>> 16) + (d.i(e) >>> 16);
            f = b >>> 16;
            g &= 65535;
            b &= 65535;
            c[e] = b << 16 | g;
        }
        return new t(c, c[c.length - 1] & -2147483648 ? -1 : 0);
    };
    function F(d, a) {
        return d.add(x(a));
    }
    h.j = function(d) {
        if (C(this) || C(d)) return w;
        if (B(this)) return B(d) ? x(this).j(x(d)) : x(x(this).j(d));
        if (B(d)) return x(this.j(x(d)));
        if (this.l(A) < 0 && d.l(A) < 0) return v(this.m() * d.m());
        const a = this.g.length + d.g.length, c = [];
        for(var f = 0; f < 2 * a; f++)c[f] = 0;
        for(f = 0; f < this.g.length; f++)for(let e = 0; e < d.g.length; e++){
            const g = this.i(f) >>> 16, b = this.i(f) & 65535, r = d.i(e) >>> 16, E = d.i(e) & 65535;
            c[2 * f + 2 * e] += b * E;
            G(c, 2 * f + 2 * e);
            c[2 * f + 2 * e + 1] += g * E;
            G(c, 2 * f + 2 * e + 1);
            c[2 * f + 2 * e + 1] += b * r;
            G(c, 2 * f + 2 * e + 1);
            c[2 * f + 2 * e + 2] += g * r;
            G(c, 2 * f + 2 * e + 2);
        }
        for(d = 0; d < a; d++)c[d] = c[2 * d + 1] << 16 | c[2 * d];
        for(d = a; d < 2 * a; d++)c[d] = 0;
        return new t(c, 0);
    };
    function G(d, a) {
        for(; (d[a] & 65535) != d[a];)d[a + 1] += d[a] >>> 16, d[a] &= 65535, a++;
    }
    function H(d, a) {
        this.g = d;
        this.h = a;
    }
    function D(d, a) {
        if (C(a)) throw Error("division by zero");
        if (C(d)) return new H(w, w);
        if (B(d)) return a = D(x(d), a), new H(x(a.g), x(a.h));
        if (B(a)) return a = D(d, x(a)), new H(x(a.g), a.h);
        if (d.g.length > 30) {
            if (B(d) || B(a)) throw Error("slowDivide_ only works with positive integers.");
            for(var c = z, f = a; f.l(d) <= 0;)c = I(c), f = I(f);
            var e = J(c, 1), g = J(f, 1);
            f = J(f, 2);
            for(c = J(c, 2); !C(f);){
                var b = g.add(f);
                b.l(d) <= 0 && (e = e.add(c), g = b);
                f = J(f, 1);
                c = J(c, 1);
            }
            a = F(d, e.j(a));
            return new H(e, a);
        }
        for(e = w; d.l(a) >= 0;){
            c = Math.max(1, Math.floor(d.m() / a.m()));
            f = Math.ceil(Math.log(c) / Math.LN2);
            f = f <= 48 ? 1 : Math.pow(2, f - 48);
            g = v(c);
            for(b = g.j(a); B(b) || b.l(d) > 0;)c -= f, g = v(c), b = g.j(a);
            C(g) && (g = z);
            e = e.add(g);
            d = F(d, b);
        }
        return new H(e, d);
    }
    h.B = function(d) {
        return D(this, d).h;
    };
    h.and = function(d) {
        const a = Math.max(this.g.length, d.g.length), c = [];
        for(let f = 0; f < a; f++)c[f] = this.i(f) & d.i(f);
        return new t(c, this.h & d.h);
    };
    h.or = function(d) {
        const a = Math.max(this.g.length, d.g.length), c = [];
        for(let f = 0; f < a; f++)c[f] = this.i(f) | d.i(f);
        return new t(c, this.h | d.h);
    };
    h.xor = function(d) {
        const a = Math.max(this.g.length, d.g.length), c = [];
        for(let f = 0; f < a; f++)c[f] = this.i(f) ^ d.i(f);
        return new t(c, this.h ^ d.h);
    };
    function I(d) {
        const a = d.g.length + 1, c = [];
        for(let f = 0; f < a; f++)c[f] = d.i(f) << 1 | d.i(f - 1) >>> 31;
        return new t(c, d.h);
    }
    function J(d, a) {
        const c = a >> 5;
        a %= 32;
        const f = d.g.length - c, e = [];
        for(let g = 0; g < f; g++)e[g] = a > 0 ? d.i(g + c) >>> a | d.i(g + c + 1) << 32 - a : d.i(g + c);
        return new t(e, d.h);
    }
    m.prototype.digest = m.prototype.A;
    m.prototype.reset = m.prototype.u;
    m.prototype.update = m.prototype.v;
    $584ae1ea48b31d46$export$9f5a3dfc7a9f5dd = $584ae1ea48b31d46$export$2e2bcd8739ae039.Md5 = m;
    t.prototype.add = t.prototype.add;
    t.prototype.multiply = t.prototype.j;
    t.prototype.modulo = t.prototype.B;
    t.prototype.compare = t.prototype.l;
    t.prototype.toNumber = t.prototype.m;
    t.prototype.toString = t.prototype.toString;
    t.prototype.getBits = t.prototype.i;
    t.fromNumber = v;
    t.fromString = y;
    $584ae1ea48b31d46$export$70ffa26850098d01 = $584ae1ea48b31d46$export$2e2bcd8739ae039.Integer = t;
}).apply(typeof $584ae1ea48b31d46$var$commonjsGlobal !== 'undefined' ? $584ae1ea48b31d46$var$commonjsGlobal : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});



var $87c0e2812a00f0b8$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
var $87c0e2812a00f0b8$export$2e2bcd8739ae039 = {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/ var $87c0e2812a00f0b8$export$26404658cda3ee02;
var $87c0e2812a00f0b8$export$ddb1030448106742;
var $87c0e2812a00f0b8$export$aa726fb96ad3e039;
var $87c0e2812a00f0b8$export$3d7865934588d77e;
var $87c0e2812a00f0b8$export$d4e71bc0b80dc0fb;
var $87c0e2812a00f0b8$export$cbbc350c1dfc80cb;
var $87c0e2812a00f0b8$export$d61e24a684f9e51;
var $87c0e2812a00f0b8$export$888d0d9ab79d08fc;
var $87c0e2812a00f0b8$export$66869136fc133c3a;
(function() {
    var h, aa = Object.defineProperty;
    function ba(a) {
        a = [
            "object" == typeof globalThis && globalThis,
            a,
            "object" == typeof window && window,
            "object" == typeof self && self,
            "object" == typeof $87c0e2812a00f0b8$var$commonjsGlobal && $87c0e2812a00f0b8$var$commonjsGlobal
        ];
        for(var b = 0; b < a.length; ++b){
            var c = a[b];
            if (c && c.Math == Math) return c;
        }
        throw Error("Cannot find global object");
    }
    var ca = ba(this);
    function da(a, b) {
        if (b) a: {
            var c = ca;
            a = a.split(".");
            for(var d = 0; d < a.length - 1; d++){
                var e = a[d];
                if (!(e in c)) break a;
                c = c[e];
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && b != null && aa(c, a, {
                configurable: !0,
                writable: !0,
                value: b
            });
        }
    }
    da("Symbol.dispose", function(a) {
        return a ? a : Symbol("Symbol.dispose");
    });
    da("Array.prototype.values", function(a) {
        return a ? a : function() {
            return this[Symbol.iterator]();
        };
    });
    da("Object.entries", function(a) {
        return a ? a : function(b) {
            var c = [], d;
            for(d in b)Object.prototype.hasOwnProperty.call(b, d) && c.push([
                d,
                b[d]
            ]);
            return c;
        };
    }); /** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    var ea = ea || {}, l = this || self;
    function n(a) {
        var b = typeof a;
        return b == "object" && a != null || b == "function";
    }
    function fa(a, b, c) {
        return a.call.apply(a.bind, arguments);
    }
    function p(a, b, c) {
        p = fa;
        return p.apply(null, arguments);
    }
    function ha(a, b) {
        var c = Array.prototype.slice.call(arguments, 1);
        return function() {
            var d = c.slice();
            d.push.apply(d, arguments);
            return a.apply(this, d);
        };
    }
    function t(a, b) {
        function c() {}
        c.prototype = b.prototype;
        a.Z = b.prototype;
        a.prototype = new c;
        a.prototype.constructor = a;
        a.Ob = function(d, e, f) {
            for(var g = Array(arguments.length - 2), k = 2; k < arguments.length; k++)g[k - 2] = arguments[k];
            return b.prototype[e].apply(d, g);
        };
    }
    var ia = typeof AsyncContext !== "undefined" && typeof AsyncContext.Snapshot === "function" ? (a)=>a && AsyncContext.Snapshot.wrap(a) : (a)=>a;
    function ja(a) {
        const b = a.length;
        if (b > 0) {
            const c = Array(b);
            for(let d = 0; d < b; d++)c[d] = a[d];
            return c;
        }
        return [];
    }
    function ka(a, b) {
        for(let d = 1; d < arguments.length; d++){
            const e = arguments[d];
            var c = typeof e;
            c = c != "object" ? c : e ? Array.isArray(e) ? "array" : c : "null";
            if (c == "array" || c == "object" && typeof e.length == "number") {
                c = a.length || 0;
                const f = e.length || 0;
                a.length = c + f;
                for(let g = 0; g < f; g++)a[c + g] = e[g];
            } else a.push(e);
        }
    }
    class la {
        constructor(a, b){
            this.i = a;
            this.j = b;
            this.h = 0;
            this.g = null;
        }
        get() {
            let a;
            this.h > 0 ? (this.h--, a = this.g, this.g = a.next, a.next = null) : a = this.i();
            return a;
        }
    }
    function ma(a) {
        l.setTimeout(()=>{
            throw a;
        }, 0);
    }
    function na() {
        var a = oa;
        let b = null;
        a.g && (b = a.g, a.g = a.g.next, a.g || (a.h = null), b.next = null);
        return b;
    }
    class pa {
        constructor(){
            this.h = this.g = null;
        }
        add(a, b) {
            const c = qa.get();
            c.set(a, b);
            this.h ? this.h.next = c : this.g = c;
            this.h = c;
        }
    }
    var qa = new la(()=>new ra, (a)=>a.reset());
    class ra {
        constructor(){
            this.next = this.g = this.h = null;
        }
        set(a, b) {
            this.h = a;
            this.g = b;
            this.next = null;
        }
        reset() {
            this.next = this.g = this.h = null;
        }
    }
    let u, v = !1, oa = new pa, ta = ()=>{
        const a = Promise.resolve(void 0);
        u = ()=>{
            a.then(sa);
        };
    };
    function sa() {
        for(var a; a = na();){
            try {
                a.h.call(a.g);
            } catch (c) {
                ma(c);
            }
            var b = qa;
            b.j(a);
            b.h < 100 && (b.h++, a.next = b.g, b.g = a);
        }
        v = !1;
    }
    function w() {
        this.u = this.u;
        this.C = this.C;
    }
    w.prototype.u = !1;
    w.prototype.dispose = function() {
        this.u || (this.u = !0, this.N());
    };
    w.prototype[Symbol.dispose] = function() {
        this.dispose();
    };
    w.prototype.N = function() {
        if (this.C) for(; this.C.length;)this.C.shift()();
    };
    function x(a, b) {
        this.type = a;
        this.g = this.target = b;
        this.defaultPrevented = !1;
    }
    x.prototype.h = function() {
        this.defaultPrevented = !0;
    };
    var ua = function() {
        if (!l.addEventListener || !Object.defineProperty) return !1;
        var a = !1, b = Object.defineProperty({}, "passive", {
            get: function() {
                a = !0;
            }
        });
        try {
            const c = ()=>{};
            l.addEventListener("test", c, b);
            l.removeEventListener("test", c, b);
        } catch (c) {}
        return a;
    }();
    function y(a) {
        return /^[\s\xa0]*$/.test(a);
    }
    function z(a, b) {
        x.call(this, a ? a.type : "");
        this.relatedTarget = this.g = this.target = null;
        this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
        this.key = "";
        this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
        this.state = null;
        this.pointerId = 0;
        this.pointerType = "";
        this.i = null;
        a && this.init(a, b);
    }
    t(z, x);
    z.prototype.init = function(a, b) {
        const c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
        this.target = a.target || a.srcElement;
        this.g = b;
        b = a.relatedTarget;
        b || (c == "mouseover" ? b = a.fromElement : c == "mouseout" && (b = a.toElement));
        this.relatedTarget = b;
        d ? (this.clientX = d.clientX !== void 0 ? d.clientX : d.pageX, this.clientY = d.clientY !== void 0 ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = a.clientX !== void 0 ? a.clientX : a.pageX, this.clientY = a.clientY !== void 0 ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
        this.button = a.button;
        this.key = a.key || "";
        this.ctrlKey = a.ctrlKey;
        this.altKey = a.altKey;
        this.shiftKey = a.shiftKey;
        this.metaKey = a.metaKey;
        this.pointerId = a.pointerId || 0;
        this.pointerType = a.pointerType;
        this.state = a.state;
        this.i = a;
        a.defaultPrevented && z.Z.h.call(this);
    };
    z.prototype.h = function() {
        z.Z.h.call(this);
        const a = this.i;
        a.preventDefault ? a.preventDefault() : a.returnValue = !1;
    };
    var B = "closure_listenable_" + (Math.random() * 1E6 | 0);
    var va = 0;
    function wa(a, b, c, d, e) {
        this.listener = a;
        this.proxy = null;
        this.src = b;
        this.type = c;
        this.capture = !!d;
        this.ha = e;
        this.key = ++va;
        this.da = this.fa = !1;
    }
    function xa(a) {
        a.da = !0;
        a.listener = null;
        a.proxy = null;
        a.src = null;
        a.ha = null;
    }
    function ya(a, b, c) {
        for(const d in a)b.call(c, a[d], d, a);
    }
    function Aa(a, b) {
        for(const c in a)b.call(void 0, a[c], c, a);
    }
    function Ba(a) {
        const b = {};
        for(const c in a)b[c] = a[c];
        return b;
    }
    const Ca = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
    function Da(a, b) {
        let c, d;
        for(let e = 1; e < arguments.length; e++){
            d = arguments[e];
            for(c in d)a[c] = d[c];
            for(let f = 0; f < Ca.length; f++)c = Ca[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
        }
    }
    function Ea(a) {
        this.src = a;
        this.g = {};
        this.h = 0;
    }
    Ea.prototype.add = function(a, b, c, d, e) {
        const f = a.toString();
        a = this.g[f];
        a || (a = this.g[f] = [], this.h++);
        const g = Fa(a, b, d, e);
        g > -1 ? (b = a[g], c || (b.fa = !1)) : (b = new wa(b, this.src, f, !!d, e), b.fa = c, a.push(b));
        return b;
    };
    function Ga(a, b) {
        const c = b.type;
        if (c in a.g) {
            var d = a.g[c], e = Array.prototype.indexOf.call(d, b, void 0), f;
            (f = e >= 0) && Array.prototype.splice.call(d, e, 1);
            f && (xa(b), a.g[c].length == 0 && (delete a.g[c], a.h--));
        }
    }
    function Fa(a, b, c, d) {
        for(let e = 0; e < a.length; ++e){
            const f = a[e];
            if (!f.da && f.listener == b && f.capture == !!c && f.ha == d) return e;
        }
        return -1;
    }
    var Ha = "closure_lm_" + (Math.random() * 1E6 | 0), Ia = {};
    function Ka(a, b, c, d, e) {
        if (d && d.once) return La(a, b, c, d, e);
        if (Array.isArray(b)) {
            for(let f = 0; f < b.length; f++)Ka(a, b[f], c, d, e);
            return null;
        }
        c = Ma(c);
        return a && a[B] ? a.J(b, c, n(d) ? !!d.capture : !!d, e) : Na(a, b, c, !1, d, e);
    }
    function Na(a, b, c, d, e, f) {
        if (!b) throw Error("Invalid event type");
        const g = n(e) ? !!e.capture : !!e;
        let k = Oa(a);
        k || (a[Ha] = k = new Ea(a));
        c = k.add(b, c, d, g, f);
        if (c.proxy) return c;
        d = Pa();
        c.proxy = d;
        d.src = a;
        d.listener = c;
        if (a.addEventListener) ua || (e = g), e === void 0 && (e = !1), a.addEventListener(b.toString(), d, e);
        else if (a.attachEvent) a.attachEvent(Qa(b.toString()), d);
        else if (a.addListener && a.removeListener) a.addListener(d);
        else throw Error("addEventListener and attachEvent are unavailable.");
        return c;
    }
    function Pa() {
        function a(c) {
            return b.call(a.src, a.listener, c);
        }
        const b = Ra;
        return a;
    }
    function La(a, b, c, d, e) {
        if (Array.isArray(b)) {
            for(let f = 0; f < b.length; f++)La(a, b[f], c, d, e);
            return null;
        }
        c = Ma(c);
        return a && a[B] ? a.K(b, c, n(d) ? !!d.capture : !!d, e) : Na(a, b, c, !0, d, e);
    }
    function Sa(a, b, c, d, e) {
        if (Array.isArray(b)) for(var f = 0; f < b.length; f++)Sa(a, b[f], c, d, e);
        else (d = n(d) ? !!d.capture : !!d, c = Ma(c), a && a[B]) ? (a = a.i, f = String(b).toString(), f in a.g && (b = a.g[f], c = Fa(b, c, d, e), c > -1 && (xa(b[c]), Array.prototype.splice.call(b, c, 1), b.length == 0 && (delete a.g[f], a.h--)))) : a && (a = Oa(a)) && (b = a.g[b.toString()], a = -1, b && (a = Fa(b, c, d, e)), (c = a > -1 ? b[a] : null) && Ta(c));
    }
    function Ta(a) {
        if (typeof a !== "number" && a && !a.da) {
            var b = a.src;
            if (b && b[B]) Ga(b.i, a);
            else {
                var c = a.type, d = a.proxy;
                b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(Qa(c), d) : b.addListener && b.removeListener && b.removeListener(d);
                (c = Oa(b)) ? (Ga(c, a), c.h == 0 && (c.src = null, b[Ha] = null)) : xa(a);
            }
        }
    }
    function Qa(a) {
        return a in Ia ? Ia[a] : Ia[a] = "on" + a;
    }
    function Ra(a, b) {
        if (a.da) a = !0;
        else {
            b = new z(b, this);
            const c = a.listener, d = a.ha || a.src;
            a.fa && Ta(a);
            a = c.call(d, b);
        }
        return a;
    }
    function Oa(a) {
        a = a[Ha];
        return a instanceof Ea ? a : null;
    }
    var Ua = "__closure_events_fn_" + (Math.random() * 1E9 >>> 0);
    function Ma(a) {
        if (typeof a === "function") return a;
        a[Ua] || (a[Ua] = function(b) {
            return a.handleEvent(b);
        });
        return a[Ua];
    }
    function C() {
        w.call(this);
        this.i = new Ea(this);
        this.M = this;
        this.G = null;
    }
    t(C, w);
    C.prototype[B] = !0;
    C.prototype.removeEventListener = function(a, b, c, d) {
        Sa(this, a, b, c, d);
    };
    function D(a, b) {
        var c, d = a.G;
        if (d) for(c = []; d; d = d.G)c.push(d);
        a = a.M;
        d = b.type || b;
        if (typeof b === "string") b = new x(b, a);
        else if (b instanceof x) b.target = b.target || a;
        else {
            var e = b;
            b = new x(d, a);
            Da(b, e);
        }
        e = !0;
        let f, g;
        if (c) for(g = c.length - 1; g >= 0; g--)f = b.g = c[g], e = Va(f, d, !0, b) && e;
        f = b.g = a;
        e = Va(f, d, !0, b) && e;
        e = Va(f, d, !1, b) && e;
        if (c) for(g = 0; g < c.length; g++)f = b.g = c[g], e = Va(f, d, !1, b) && e;
    }
    C.prototype.N = function() {
        C.Z.N.call(this);
        if (this.i) {
            var a = this.i;
            for(const c in a.g){
                const d = a.g[c];
                for(let e = 0; e < d.length; e++)xa(d[e]);
                delete a.g[c];
                a.h--;
            }
        }
        this.G = null;
    };
    C.prototype.J = function(a, b, c, d) {
        return this.i.add(String(a), b, !1, c, d);
    };
    C.prototype.K = function(a, b, c, d) {
        return this.i.add(String(a), b, !0, c, d);
    };
    function Va(a, b, c, d) {
        b = a.i.g[String(b)];
        if (!b) return !0;
        b = b.concat();
        let e = !0;
        for(let f = 0; f < b.length; ++f){
            const g = b[f];
            if (g && !g.da && g.capture == c) {
                const k = g.listener, q = g.ha || g.src;
                g.fa && Ga(a.i, g);
                e = k.call(q, d) !== !1 && e;
            }
        }
        return e && !d.defaultPrevented;
    }
    function Wa(a, b) {
        if (typeof a !== "function") {
            if (a && typeof a.handleEvent == "function") a = p(a.handleEvent, a);
            else throw Error("Invalid listener argument");
        }
        return Number(b) > 2147483647 ? -1 : l.setTimeout(a, b || 0);
    }
    function Xa(a) {
        a.g = Wa(()=>{
            a.g = null;
            a.i && (a.i = !1, Xa(a));
        }, a.l);
        const b = a.h;
        a.h = null;
        a.m.apply(null, b);
    }
    class Ya extends w {
        constructor(a, b){
            super();
            this.m = a;
            this.l = b;
            this.h = null;
            this.i = !1;
            this.g = null;
        }
        j(a) {
            this.h = arguments;
            this.g ? this.i = !0 : Xa(this);
        }
        N() {
            super.N();
            this.g && (l.clearTimeout(this.g), this.g = null, this.i = !1, this.h = null);
        }
    }
    function E(a) {
        w.call(this);
        this.h = a;
        this.g = {};
    }
    t(E, w);
    var Za = [];
    function $a(a) {
        ya(a.g, function(b, c) {
            this.g.hasOwnProperty(c) && Ta(b);
        }, a);
        a.g = {};
    }
    E.prototype.N = function() {
        E.Z.N.call(this);
        $a(this);
    };
    E.prototype.handleEvent = function() {
        throw Error("EventHandler.handleEvent not implemented");
    };
    var ab = l.JSON.stringify;
    var cb = l.JSON.parse;
    var db = class {
        stringify(a) {
            return l.JSON.stringify(a, void 0);
        }
        parse(a) {
            return l.JSON.parse(a, void 0);
        }
    };
    function eb() {}
    function fb() {}
    var H = {
        OPEN: "a",
        hb: "b",
        ERROR: "c",
        tb: "d"
    };
    function gb() {
        x.call(this, "d");
    }
    t(gb, x);
    function hb() {
        x.call(this, "c");
    }
    t(hb, x);
    var I = {}, ib = null;
    function jb() {
        return ib = ib || new C;
    }
    I.Ia = "serverreachability";
    function kb(a) {
        x.call(this, I.Ia, a);
    }
    t(kb, x);
    function lb(a) {
        const b = jb();
        D(b, new kb(b));
    }
    I.STAT_EVENT = "statevent";
    function mb(a, b) {
        x.call(this, I.STAT_EVENT, a);
        this.stat = b;
    }
    t(mb, x);
    function J(a) {
        const b = jb();
        D(b, new mb(b, a));
    }
    I.Ja = "timingevent";
    function nb(a, b) {
        x.call(this, I.Ja, a);
        this.size = b;
    }
    t(nb, x);
    function ob(a, b) {
        if (typeof a !== "function") throw Error("Fn must not be null and must be a function");
        return l.setTimeout(function() {
            a();
        }, b);
    }
    function pb() {
        this.g = !0;
    }
    pb.prototype.ua = function() {
        this.g = !1;
    };
    function qb(a, b, c, d, e, f) {
        a.info(function() {
            if (a.g) {
                if (f) {
                    var g = "";
                    var k = f.split("&");
                    for(let m = 0; m < k.length; m++){
                        var q = k[m].split("=");
                        if (q.length > 1) {
                            const r = q[0];
                            q = q[1];
                            const A = r.split("_");
                            g = A.length >= 2 && A[1] == "type" ? g + (r + "=" + q + "&") : g + (r + "=redacted&");
                        }
                    }
                } else g = null;
            } else g = f;
            return "XMLHTTP REQ (" + d + ") [attempt " + e + "]: " + b + "\n" + c + "\n" + g;
        });
    }
    function rb(a, b, c, d, e, f, g) {
        a.info(function() {
            return "XMLHTTP RESP (" + d + ") [ attempt " + e + "]: " + b + "\n" + c + "\n" + f + " " + g;
        });
    }
    function K(a, b, c, d) {
        a.info(function() {
            return "XMLHTTP TEXT (" + b + "): " + sb(a, c) + (d ? " " + d : "");
        });
    }
    function tb(a, b) {
        a.info(function() {
            return "TIMEOUT: " + b;
        });
    }
    pb.prototype.info = function() {};
    function sb(a, b) {
        if (!a.g) return b;
        if (!b) return null;
        try {
            const f = JSON.parse(b);
            if (f) {
                for(a = 0; a < f.length; a++)if (Array.isArray(f[a])) {
                    var c = f[a];
                    if (!(c.length < 2)) {
                        var d = c[1];
                        if (Array.isArray(d) && !(d.length < 1)) {
                            var e = d[0];
                            if (e != "noop" && e != "stop" && e != "close") for(let g = 1; g < d.length; g++)d[g] = "";
                        }
                    }
                }
            }
            return ab(f);
        } catch (f) {
            return b;
        }
    }
    var ub = {
        NO_ERROR: 0,
        cb: 1,
        qb: 2,
        pb: 3,
        kb: 4,
        ob: 5,
        rb: 6,
        Ga: 7,
        TIMEOUT: 8,
        ub: 9
    };
    var vb = {
        ib: "complete",
        Fb: "success",
        ERROR: "error",
        Ga: "abort",
        xb: "ready",
        yb: "readystatechange",
        TIMEOUT: "timeout",
        sb: "incrementaldata",
        wb: "progress",
        lb: "downloadprogress",
        Nb: "uploadprogress"
    };
    var wb;
    function xb() {}
    t(xb, eb);
    xb.prototype.g = function() {
        return new XMLHttpRequest;
    };
    wb = new xb;
    function L(a) {
        return encodeURIComponent(String(a));
    }
    function yb(a) {
        var b = 1;
        a = a.split(":");
        const c = [];
        for(; b > 0 && a.length;)c.push(a.shift()), b--;
        a.length && c.push(a.join(":"));
        return c;
    }
    function N(a, b, c, d) {
        this.j = a;
        this.i = b;
        this.l = c;
        this.S = d || 1;
        this.V = new E(this);
        this.H = 45E3;
        this.J = null;
        this.o = !1;
        this.u = this.B = this.A = this.M = this.F = this.T = this.D = null;
        this.G = [];
        this.g = null;
        this.C = 0;
        this.m = this.v = null;
        this.X = -1;
        this.K = !1;
        this.P = 0;
        this.O = null;
        this.W = this.L = this.U = this.R = !1;
        this.h = new zb;
    }
    function zb() {
        this.i = null;
        this.g = "";
        this.h = !1;
    }
    var Ab = {}, Bb = {};
    function Cb(a, b, c) {
        a.M = 1;
        a.A = Db(O(b));
        a.u = c;
        a.R = !0;
        Eb(a, null);
    }
    function Eb(a, b) {
        a.F = Date.now();
        Fb(a);
        a.B = O(a.A);
        var c = a.B, d = a.S;
        Array.isArray(d) || (d = [
            String(d)
        ]);
        Gb(c.i, "t", d);
        a.C = 0;
        c = a.j.L;
        a.h = new zb;
        a.g = Hb(a.j, c ? b : null, !a.u);
        a.P > 0 && (a.O = new Ya(p(a.Y, a, a.g), a.P));
        b = a.V;
        c = a.g;
        d = a.ba;
        var e = "readystatechange";
        Array.isArray(e) || (e && (Za[0] = e.toString()), e = Za);
        for(let f = 0; f < e.length; f++){
            const g = Ka(c, e[f], d || b.handleEvent, !1, b.h || b);
            if (!g) break;
            b.g[g.key] = g;
        }
        b = a.J ? Ba(a.J) : {};
        a.u ? (a.v || (a.v = "POST"), b["Content-Type"] = "application/x-www-form-urlencoded", a.g.ea(a.B, a.v, a.u, b)) : (a.v = "GET", a.g.ea(a.B, a.v, null, b));
        lb();
        qb(a.i, a.v, a.B, a.l, a.S, a.u);
    }
    N.prototype.ba = function(a) {
        a = a.target;
        const b = this.O;
        b && P(a) == 3 ? b.j() : this.Y(a);
    };
    N.prototype.Y = function(a) {
        try {
            if (a == this.g) a: {
                const k = P(this.g), q = this.g.ya(), m = this.g.ca();
                if (!(k < 3) && (k != 3 || this.g && (this.h.h || this.g.la() || Ib(this.g)))) {
                    this.K || k != 4 || q == 7 || (q == 8 || m <= 0 ? lb(3) : lb(2));
                    Jb(this);
                    var b = this.g.ca();
                    this.X = b;
                    var c = Kb(this);
                    this.o = b == 200;
                    rb(this.i, this.v, this.B, this.l, this.S, k, b);
                    if (this.o) {
                        if (this.U && !this.L) {
                            b: {
                                if (this.g) {
                                    var d, e = this.g;
                                    if ((d = e.g ? e.g.getResponseHeader("X-HTTP-Initial-Response") : null) && !y(d)) {
                                        var f = d;
                                        break b;
                                    }
                                }
                                f = null;
                            }
                            if (a = f) K(this.i, this.l, a, "Initial handshake response via X-HTTP-Initial-Response"), this.L = !0, Lb(this, a);
                            else {
                                this.o = !1;
                                this.m = 3;
                                J(12);
                                Q(this);
                                Mb(this);
                                break a;
                            }
                        }
                        if (this.R) {
                            a = !0;
                            let r;
                            for(; !this.K && this.C < c.length;)if (r = Nb(this, c), r == Bb) {
                                k == 4 && (this.m = 4, J(14), a = !1);
                                K(this.i, this.l, null, "[Incomplete Response]");
                                break;
                            } else if (r == Ab) {
                                this.m = 4;
                                J(15);
                                K(this.i, this.l, c, "[Invalid Chunk]");
                                a = !1;
                                break;
                            } else K(this.i, this.l, r, null), Lb(this, r);
                            Ob(this) && this.C != 0 && (this.h.g = this.h.g.slice(this.C), this.C = 0);
                            k != 4 || c.length != 0 || this.h.h || (this.m = 1, J(16), a = !1);
                            this.o = this.o && a;
                            if (!a) K(this.i, this.l, c, "[Invalid Chunked Response]"), Q(this), Mb(this);
                            else if (c.length > 0 && !this.W) {
                                this.W = !0;
                                var g = this.j;
                                g.g == this && g.aa && !g.P && (g.j.info("Great, no buffering proxy detected. Bytes received: " + c.length), Pb(g), g.P = !0, J(11));
                            }
                        } else K(this.i, this.l, c, null), Lb(this, c);
                        k == 4 && Q(this);
                        this.o && !this.K && (k == 4 ? Qb(this.j, this) : (this.o = !1, Fb(this)));
                    } else Rb(this.g), b == 400 && c.indexOf("Unknown SID") > 0 ? (this.m = 3, J(12)) : (this.m = 0, J(13)), Q(this), Mb(this);
                }
            }
        } catch (k) {} finally{}
    };
    function Kb(a) {
        if (!Ob(a)) return a.g.la();
        const b = Ib(a.g);
        if (b === "") return "";
        let c = "";
        const d = b.length, e = P(a.g) == 4;
        if (!a.h.i) {
            if (typeof TextDecoder === "undefined") return Q(a), Mb(a), "";
            a.h.i = new l.TextDecoder;
        }
        for(let f = 0; f < d; f++)a.h.h = !0, c += a.h.i.decode(b[f], {
            stream: !(e && f == d - 1)
        });
        b.length = 0;
        a.h.g += c;
        a.C = 0;
        return a.h.g;
    }
    function Ob(a) {
        return a.g ? a.v == "GET" && a.M != 2 && a.j.Aa : !1;
    }
    function Nb(a, b) {
        var c = a.C, d = b.indexOf("\n", c);
        if (d == -1) return Bb;
        c = Number(b.substring(c, d));
        if (isNaN(c)) return Ab;
        d += 1;
        if (d + c > b.length) return Bb;
        b = b.slice(d, d + c);
        a.C = d + c;
        return b;
    }
    N.prototype.cancel = function() {
        this.K = !0;
        Q(this);
    };
    function Fb(a) {
        a.T = Date.now() + a.H;
        Sb(a, a.H);
    }
    function Sb(a, b) {
        if (a.D != null) throw Error("WatchDog timer not null");
        a.D = ob(p(a.aa, a), b);
    }
    function Jb(a) {
        a.D && (l.clearTimeout(a.D), a.D = null);
    }
    N.prototype.aa = function() {
        this.D = null;
        const a = Date.now();
        a - this.T >= 0 ? (tb(this.i, this.B), this.M != 2 && (lb(), J(17)), Q(this), this.m = 2, Mb(this)) : Sb(this, this.T - a);
    };
    function Mb(a) {
        a.j.I == 0 || a.K || Qb(a.j, a);
    }
    function Q(a) {
        Jb(a);
        var b = a.O;
        b && typeof b.dispose == "function" && b.dispose();
        a.O = null;
        $a(a.V);
        a.g && (b = a.g, a.g = null, b.abort(), b.dispose());
    }
    function Lb(a, b) {
        try {
            var c = a.j;
            if (c.I != 0 && (c.g == a || Tb(c.h, a))) {
                if (!a.L && Tb(c.h, a) && c.I == 3) {
                    try {
                        var d = c.Ba.g.parse(b);
                    } catch (m) {
                        d = null;
                    }
                    if (Array.isArray(d) && d.length == 3) {
                        var e = d;
                        if (e[0] == 0) {
                            a: if (!c.v) {
                                if (c.g) {
                                    if (c.g.F + 3E3 < a.F) Ub(c), Vb(c);
                                    else break a;
                                }
                                Wb(c);
                                J(18);
                            }
                        } else c.xa = e[1], 0 < c.xa - c.K && e[2] < 37500 && c.F && c.A == 0 && !c.C && (c.C = ob(p(c.Va, c), 6E3));
                        Xb(c.h) <= 1 && c.ta && (c.ta = void 0);
                    } else R(c, 11);
                } else if ((a.L || c.g == a) && Ub(c), !y(b)) for(e = c.Ba.g.parse(b), b = 0; b < e.length; b++){
                    let m = e[b];
                    const r = m[0];
                    if (!(r <= c.K)) {
                        if (c.K = r, m = m[1], c.I == 2) {
                            if (m[0] == "c") {
                                c.M = m[1];
                                c.ba = m[2];
                                const A = m[3];
                                A != null && (c.ka = A, c.j.info("VER=" + c.ka));
                                const M = m[4];
                                M != null && (c.za = M, c.j.info("SVER=" + c.za));
                                const F = m[5];
                                F != null && typeof F === "number" && F > 0 && (d = 1.5 * F, c.O = d, c.j.info("backChannelRequestTimeoutMs_=" + d));
                                d = c;
                                const G = a.g;
                                if (G) {
                                    const za = G.g ? G.g.getResponseHeader("X-Client-Wire-Protocol") : null;
                                    if (za) {
                                        var f = d.h;
                                        f.g || za.indexOf("spdy") == -1 && za.indexOf("quic") == -1 && za.indexOf("h2") == -1 || (f.j = f.l, f.g = new Set, f.h && (Yb(f, f.h), f.h = null));
                                    }
                                    if (d.G) {
                                        const bb = G.g ? G.g.getResponseHeader("X-HTTP-Session-Id") : null;
                                        bb && (d.wa = bb, S(d.J, d.G, bb));
                                    }
                                }
                                c.I = 3;
                                c.l && c.l.ra();
                                c.aa && (c.T = Date.now() - a.F, c.j.info("Handshake RTT: " + c.T + "ms"));
                                d = c;
                                var g = a;
                                d.na = Zb(d, d.L ? d.ba : null, d.W);
                                if (g.L) {
                                    $b(d.h, g);
                                    var k = g, q = d.O;
                                    q && (k.H = q);
                                    k.D && (Jb(k), Fb(k));
                                    d.g = g;
                                } else ac(d);
                                c.i.length > 0 && bc(c);
                            } else m[0] != "stop" && m[0] != "close" || R(c, 7);
                        } else c.I == 3 && (m[0] == "stop" || m[0] == "close" ? m[0] == "stop" ? R(c, 7) : cc(c) : m[0] != "noop" && c.l && c.l.qa(m), c.A = 0);
                    }
                }
            }
            lb(4);
        } catch (m) {}
    }
    var dc = class {
        constructor(a, b){
            this.g = a;
            this.map = b;
        }
    };
    function ec(a) {
        this.l = a || 10;
        l.PerformanceNavigationTiming ? (a = l.performance.getEntriesByType("navigation"), a = a.length > 0 && (a[0].nextHopProtocol == "hq" || a[0].nextHopProtocol == "h2")) : a = !!(l.chrome && l.chrome.loadTimes && l.chrome.loadTimes() && l.chrome.loadTimes().wasFetchedViaSpdy);
        this.j = a ? this.l : 1;
        this.g = null;
        this.j > 1 && (this.g = new Set);
        this.h = null;
        this.i = [];
    }
    function fc(a) {
        return a.h ? !0 : a.g ? a.g.size >= a.j : !1;
    }
    function Xb(a) {
        return a.h ? 1 : a.g ? a.g.size : 0;
    }
    function Tb(a, b) {
        return a.h ? a.h == b : a.g ? a.g.has(b) : !1;
    }
    function Yb(a, b) {
        a.g ? a.g.add(b) : a.h = b;
    }
    function $b(a, b) {
        a.h && a.h == b ? a.h = null : a.g && a.g.has(b) && a.g.delete(b);
    }
    ec.prototype.cancel = function() {
        this.i = hc(this);
        if (this.h) this.h.cancel(), this.h = null;
        else if (this.g && this.g.size !== 0) {
            for (const a of this.g.values())a.cancel();
            this.g.clear();
        }
    };
    function hc(a) {
        if (a.h != null) return a.i.concat(a.h.G);
        if (a.g != null && a.g.size !== 0) {
            let b = a.i;
            for (const c of a.g.values())b = b.concat(c.G);
            return b;
        }
        return ja(a.i);
    }
    var ic = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^\\\\/?#]*)@)?([^\\\\/?#]*?)(?::([0-9]+))?(?=[\\\\/?#]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$");
    function jc(a, b) {
        if (a) {
            a = a.split("&");
            for(let c = 0; c < a.length; c++){
                const d = a[c].indexOf("=");
                let e, f = null;
                d >= 0 ? (e = a[c].substring(0, d), f = a[c].substring(d + 1)) : e = a[c];
                b(e, f ? decodeURIComponent(f.replace(/\+/g, " ")) : "");
            }
        }
    }
    function T(a) {
        this.g = this.o = this.j = "";
        this.u = null;
        this.m = this.h = "";
        this.l = !1;
        let b;
        a instanceof T ? (this.l = a.l, kc(this, a.j), this.o = a.o, this.g = a.g, lc(this, a.u), this.h = a.h, mc(this, nc(a.i)), this.m = a.m) : a && (b = String(a).match(ic)) ? (this.l = !1, kc(this, b[1] || "", !0), this.o = oc(b[2] || ""), this.g = oc(b[3] || "", !0), lc(this, b[4]), this.h = oc(b[5] || "", !0), mc(this, b[6] || "", !0), this.m = oc(b[7] || "")) : (this.l = !1, this.i = new pc(null, this.l));
    }
    T.prototype.toString = function() {
        const a = [];
        var b = this.j;
        b && a.push(qc(b, rc, !0), ":");
        var c = this.g;
        if (c || b == "file") a.push("//"), (b = this.o) && a.push(qc(b, rc, !0), "@"), a.push(L(c).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.u, c != null && a.push(":", String(c));
        if (c = this.h) this.g && c.charAt(0) != "/" && a.push("/"), a.push(qc(c, c.charAt(0) == "/" ? sc : tc, !0));
        (c = this.i.toString()) && a.push("?", c);
        (c = this.m) && a.push("#", qc(c, uc));
        return a.join("");
    };
    T.prototype.resolve = function(a) {
        const b = O(this);
        let c = !!a.j;
        c ? kc(b, a.j) : c = !!a.o;
        c ? b.o = a.o : c = !!a.g;
        c ? b.g = a.g : c = a.u != null;
        var d = a.h;
        if (c) lc(b, a.u);
        else if (c = !!a.h) {
            if (d.charAt(0) != "/") {
                if (this.g && !this.h) d = "/" + d;
                else {
                    var e = b.h.lastIndexOf("/");
                    e != -1 && (d = b.h.slice(0, e + 1) + d);
                }
            }
            e = d;
            if (e == ".." || e == ".") d = "";
            else if (e.indexOf("./") != -1 || e.indexOf("/.") != -1) {
                d = e.lastIndexOf("/", 0) == 0;
                e = e.split("/");
                const f = [];
                for(let g = 0; g < e.length;){
                    const k = e[g++];
                    k == "." ? d && g == e.length && f.push("") : k == ".." ? ((f.length > 1 || f.length == 1 && f[0] != "") && f.pop(), d && g == e.length && f.push("")) : (f.push(k), d = !0);
                }
                d = f.join("/");
            } else d = e;
        }
        c ? b.h = d : c = a.i.toString() !== "";
        c ? mc(b, nc(a.i)) : c = !!a.m;
        c && (b.m = a.m);
        return b;
    };
    function O(a) {
        return new T(a);
    }
    function kc(a, b, c) {
        a.j = c ? oc(b, !0) : b;
        a.j && (a.j = a.j.replace(/:$/, ""));
    }
    function lc(a, b) {
        if (b) {
            b = Number(b);
            if (isNaN(b) || b < 0) throw Error("Bad port number " + b);
            a.u = b;
        } else a.u = null;
    }
    function mc(a, b, c) {
        b instanceof pc ? (a.i = b, vc(a.i, a.l)) : (c || (b = qc(b, wc)), a.i = new pc(b, a.l));
    }
    function S(a, b, c) {
        a.i.set(b, c);
    }
    function Db(a) {
        S(a, "zx", Math.floor(Math.random() * 2147483648).toString(36) + Math.abs(Math.floor(Math.random() * 2147483648) ^ Date.now()).toString(36));
        return a;
    }
    function oc(a, b) {
        return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
    }
    function qc(a, b, c) {
        return typeof a === "string" ? (a = encodeURI(a).replace(b, xc), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
    }
    function xc(a) {
        a = a.charCodeAt(0);
        return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
    }
    var rc = /[#\/\?@]/g, tc = /[#\?:]/g, sc = /[#\?]/g, wc = /[#\?@]/g, uc = /#/g;
    function pc(a, b) {
        this.h = this.g = null;
        this.i = a || null;
        this.j = !!b;
    }
    function U(a) {
        a.g || (a.g = new Map, a.h = 0, a.i && jc(a.i, function(b, c) {
            a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
        }));
    }
    h = pc.prototype;
    h.add = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        let c = this.g.get(a);
        c || this.g.set(a, c = []);
        c.push(b);
        this.h += 1;
        return this;
    };
    function yc(a, b) {
        U(a);
        b = V(a, b);
        a.g.has(b) && (a.i = null, a.h -= a.g.get(b).length, a.g.delete(b));
    }
    function zc(a, b) {
        U(a);
        b = V(a, b);
        return a.g.has(b);
    }
    h.forEach = function(a, b) {
        U(this);
        this.g.forEach(function(c, d) {
            c.forEach(function(e) {
                a.call(b, e, d, this);
            }, this);
        }, this);
    };
    function Ac(a, b) {
        U(a);
        let c = [];
        if (typeof b === "string") zc(a, b) && (c = c.concat(a.g.get(V(a, b))));
        else for(a = Array.from(a.g.values()), b = 0; b < a.length; b++)c = c.concat(a[b]);
        return c;
    }
    h.set = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        zc(this, a) && (this.h -= this.g.get(a).length);
        this.g.set(a, [
            b
        ]);
        this.h += 1;
        return this;
    };
    h.get = function(a, b) {
        if (!a) return b;
        a = Ac(this, a);
        return a.length > 0 ? String(a[0]) : b;
    };
    function Gb(a, b, c) {
        yc(a, b);
        c.length > 0 && (a.i = null, a.g.set(V(a, b), ja(c)), a.h += c.length);
    }
    h.toString = function() {
        if (this.i) return this.i;
        if (!this.g) return "";
        const a = [], b = Array.from(this.g.keys());
        for(let d = 0; d < b.length; d++){
            var c = b[d];
            const e = L(c);
            c = Ac(this, c);
            for(let f = 0; f < c.length; f++){
                let g = e;
                c[f] !== "" && (g += "=" + L(c[f]));
                a.push(g);
            }
        }
        return this.i = a.join("&");
    };
    function nc(a) {
        const b = new pc;
        b.i = a.i;
        a.g && (b.g = new Map(a.g), b.h = a.h);
        return b;
    }
    function V(a, b) {
        b = String(b);
        a.j && (b = b.toLowerCase());
        return b;
    }
    function vc(a, b) {
        b && !a.j && (U(a), a.i = null, a.g.forEach(function(c, d) {
            const e = d.toLowerCase();
            d != e && (yc(this, d), Gb(this, e, c));
        }, a));
        a.j = b;
    }
    function Bc(a, b) {
        const c = new pb;
        if (l.Image) {
            const d = new Image;
            d.onload = ha(W, c, "TestLoadImage: loaded", !0, b, d);
            d.onerror = ha(W, c, "TestLoadImage: error", !1, b, d);
            d.onabort = ha(W, c, "TestLoadImage: abort", !1, b, d);
            d.ontimeout = ha(W, c, "TestLoadImage: timeout", !1, b, d);
            l.setTimeout(function() {
                if (d.ontimeout) d.ontimeout();
            }, 1E4);
            d.src = a;
        } else b(!1);
    }
    function Cc(a, b) {
        const c = new pb, d = new AbortController, e = setTimeout(()=>{
            d.abort();
            W(c, "TestPingServer: timeout", !1, b);
        }, 1E4);
        fetch(a, {
            signal: d.signal
        }).then((f)=>{
            clearTimeout(e);
            f.ok ? W(c, "TestPingServer: ok", !0, b) : W(c, "TestPingServer: server error", !1, b);
        }).catch(()=>{
            clearTimeout(e);
            W(c, "TestPingServer: error", !1, b);
        });
    }
    function W(a, b, c, d, e) {
        try {
            e && (e.onload = null, e.onerror = null, e.onabort = null, e.ontimeout = null), d(c);
        } catch (f) {}
    }
    function Dc() {
        this.g = new db;
    }
    function Ec(a) {
        this.i = a.Sb || null;
        this.h = a.ab || !1;
    }
    t(Ec, eb);
    Ec.prototype.g = function() {
        return new Fc(this.i, this.h);
    };
    function Fc(a, b) {
        C.call(this);
        this.H = a;
        this.o = b;
        this.m = void 0;
        this.status = this.readyState = 0;
        this.responseType = this.responseText = this.response = this.statusText = "";
        this.onreadystatechange = null;
        this.A = new Headers;
        this.h = null;
        this.F = "GET";
        this.D = "";
        this.g = !1;
        this.B = this.j = this.l = null;
        this.v = new AbortController;
    }
    t(Fc, C);
    h = Fc.prototype;
    h.open = function(a, b) {
        if (this.readyState != 0) throw this.abort(), Error("Error reopening a connection");
        this.F = a;
        this.D = b;
        this.readyState = 1;
        Gc(this);
    };
    h.send = function(a) {
        if (this.readyState != 1) throw this.abort(), Error("need to call open() first. ");
        if (this.v.signal.aborted) throw this.abort(), Error("Request was aborted.");
        this.g = !0;
        const b = {
            headers: this.A,
            method: this.F,
            credentials: this.m,
            cache: void 0,
            signal: this.v.signal
        };
        a && (b.body = a);
        (this.H || l).fetch(new Request(this.D, b)).then(this.Pa.bind(this), this.ga.bind(this));
    };
    h.abort = function() {
        this.response = this.responseText = "";
        this.A = new Headers;
        this.status = 0;
        this.v.abort();
        this.j && this.j.cancel("Request was aborted.").catch(()=>{});
        this.readyState >= 1 && this.g && this.readyState != 4 && (this.g = !1, Hc(this));
        this.readyState = 0;
    };
    h.Pa = function(a) {
        if (this.g && (this.l = a, this.h || (this.status = this.l.status, this.statusText = this.l.statusText, this.h = a.headers, this.readyState = 2, Gc(this)), this.g && (this.readyState = 3, Gc(this), this.g))) {
            if (this.responseType === "arraybuffer") a.arrayBuffer().then(this.Na.bind(this), this.ga.bind(this));
            else if (typeof l.ReadableStream !== "undefined" && "body" in a) {
                this.j = a.body.getReader();
                if (this.o) {
                    if (this.responseType) throw Error('responseType must be empty for "streamBinaryChunks" mode responses.');
                    this.response = [];
                } else this.response = this.responseText = "", this.B = new TextDecoder;
                Ic(this);
            } else a.text().then(this.Oa.bind(this), this.ga.bind(this));
        }
    };
    function Ic(a) {
        a.j.read().then(a.Ma.bind(a)).catch(a.ga.bind(a));
    }
    h.Ma = function(a) {
        if (this.g) {
            if (this.o && a.value) this.response.push(a.value);
            else if (!this.o) {
                var b = a.value ? a.value : new Uint8Array(0);
                if (b = this.B.decode(b, {
                    stream: !a.done
                })) this.response = this.responseText += b;
            }
            a.done ? Hc(this) : Gc(this);
            this.readyState == 3 && Ic(this);
        }
    };
    h.Oa = function(a) {
        this.g && (this.response = this.responseText = a, Hc(this));
    };
    h.Na = function(a) {
        this.g && (this.response = a, Hc(this));
    };
    h.ga = function() {
        this.g && Hc(this);
    };
    function Hc(a) {
        a.readyState = 4;
        a.l = null;
        a.j = null;
        a.B = null;
        Gc(a);
    }
    h.setRequestHeader = function(a, b) {
        this.A.append(a, b);
    };
    h.getResponseHeader = function(a) {
        return this.h ? this.h.get(a.toLowerCase()) || "" : "";
    };
    h.getAllResponseHeaders = function() {
        if (!this.h) return "";
        const a = [], b = this.h.entries();
        for(var c = b.next(); !c.done;)c = c.value, a.push(c[0] + ": " + c[1]), c = b.next();
        return a.join("\r\n");
    };
    function Gc(a) {
        a.onreadystatechange && a.onreadystatechange.call(a);
    }
    Object.defineProperty(Fc.prototype, "withCredentials", {
        get: function() {
            return this.m === "include";
        },
        set: function(a) {
            this.m = a ? "include" : "same-origin";
        }
    });
    function Jc(a) {
        let b = "";
        ya(a, function(c, d) {
            b += d;
            b += ":";
            b += c;
            b += "\r\n";
        });
        return b;
    }
    function Kc(a, b, c) {
        a: {
            for(d in c){
                var d = !1;
                break a;
            }
            d = !0;
        }
        d || (c = Jc(c), typeof a === "string" ? c != null && L(c) : S(a, b, c));
    }
    function X(a) {
        C.call(this);
        this.headers = new Map;
        this.L = a || null;
        this.h = !1;
        this.g = null;
        this.D = "";
        this.o = 0;
        this.l = "";
        this.j = this.B = this.v = this.A = !1;
        this.m = null;
        this.F = "";
        this.H = !1;
    }
    t(X, C);
    var Lc = /^https?$/i, Mc = [
        "POST",
        "PUT"
    ];
    h = X.prototype;
    h.Fa = function(a) {
        this.H = a;
    };
    h.ea = function(a, b, c, d) {
        if (this.g) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.D + "; newUri=" + a);
        b = b ? b.toUpperCase() : "GET";
        this.D = a;
        this.l = "";
        this.o = 0;
        this.A = !1;
        this.h = !0;
        this.g = this.L ? this.L.g() : wb.g();
        this.g.onreadystatechange = ia(p(this.Ca, this));
        try {
            this.B = !0, this.g.open(b, String(a), !0), this.B = !1;
        } catch (f) {
            Nc(this, f);
            return;
        }
        a = c || "";
        c = new Map(this.headers);
        if (d) {
            if (Object.getPrototypeOf(d) === Object.prototype) for(var e in d)c.set(e, d[e]);
            else if (typeof d.keys === "function" && typeof d.get === "function") for (const f of d.keys())c.set(f, d.get(f));
            else throw Error("Unknown input type for opt_headers: " + String(d));
        }
        d = Array.from(c.keys()).find((f)=>"content-type" == f.toLowerCase());
        e = l.FormData && a instanceof l.FormData;
        !(Array.prototype.indexOf.call(Mc, b, void 0) >= 0) || d || e || c.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
        for (const [f, g] of c)this.g.setRequestHeader(f, g);
        this.F && (this.g.responseType = this.F);
        "withCredentials" in this.g && this.g.withCredentials !== this.H && (this.g.withCredentials = this.H);
        try {
            this.m && (clearTimeout(this.m), this.m = null), this.v = !0, this.g.send(a), this.v = !1;
        } catch (f) {
            Nc(this, f);
        }
    };
    function Nc(a, b) {
        a.h = !1;
        a.g && (a.j = !0, a.g.abort(), a.j = !1);
        a.l = b;
        a.o = 5;
        Oc(a);
        Pc(a);
    }
    function Oc(a) {
        a.A || (a.A = !0, D(a, "complete"), D(a, "error"));
    }
    h.abort = function(a) {
        this.g && this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1, this.o = a || 7, D(this, "complete"), D(this, "abort"), Pc(this));
    };
    h.N = function() {
        this.g && (this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1), Pc(this, !0));
        X.Z.N.call(this);
    };
    h.Ca = function() {
        this.u || (this.B || this.v || this.j ? Qc(this) : this.Xa());
    };
    h.Xa = function() {
        Qc(this);
    };
    function Qc(a) {
        if (a.h && typeof ea != "undefined") {
            if (a.v && P(a) == 4) setTimeout(a.Ca.bind(a), 0);
            else if (D(a, "readystatechange"), P(a) == 4) {
                a.h = !1;
                try {
                    const f = a.ca();
                    a: switch(f){
                        case 200:
                        case 201:
                        case 202:
                        case 204:
                        case 206:
                        case 304:
                        case 1223:
                            var b = !0;
                            break a;
                        default:
                            b = !1;
                    }
                    var c;
                    if (!(c = b)) {
                        var d;
                        if (d = f === 0) {
                            let g = String(a.D).match(ic)[1] || null;
                            !g && l.self && l.self.location && (g = l.self.location.protocol.slice(0, -1));
                            d = !Lc.test(g ? g.toLowerCase() : "");
                        }
                        c = d;
                    }
                    if (c) D(a, "complete"), D(a, "success");
                    else {
                        a.o = 6;
                        try {
                            var e = P(a) > 2 ? a.g.statusText : "";
                        } catch (g) {
                            e = "";
                        }
                        a.l = e + " [" + a.ca() + "]";
                        Oc(a);
                    }
                } finally{
                    Pc(a);
                }
            }
        }
    }
    function Pc(a, b) {
        if (a.g) {
            a.m && (clearTimeout(a.m), a.m = null);
            const c = a.g;
            a.g = null;
            b || D(a, "ready");
            try {
                c.onreadystatechange = null;
            } catch (d) {}
        }
    }
    h.isActive = function() {
        return !!this.g;
    };
    function P(a) {
        return a.g ? a.g.readyState : 0;
    }
    h.ca = function() {
        try {
            return P(this) > 2 ? this.g.status : -1;
        } catch (a) {
            return -1;
        }
    };
    h.la = function() {
        try {
            return this.g ? this.g.responseText : "";
        } catch (a) {
            return "";
        }
    };
    h.La = function(a) {
        if (this.g) {
            var b = this.g.responseText;
            a && b.indexOf(a) == 0 && (b = b.substring(a.length));
            return cb(b);
        }
    };
    function Ib(a) {
        try {
            if (!a.g) return null;
            if ("response" in a.g) return a.g.response;
            switch(a.F){
                case "":
                case "text":
                    return a.g.responseText;
                case "arraybuffer":
                    if ("mozResponseArrayBuffer" in a.g) return a.g.mozResponseArrayBuffer;
            }
            return null;
        } catch (b) {
            return null;
        }
    }
    function Rb(a) {
        const b = {};
        a = (a.g && P(a) >= 2 ? a.g.getAllResponseHeaders() || "" : "").split("\r\n");
        for(let d = 0; d < a.length; d++){
            if (y(a[d])) continue;
            var c = yb(a[d]);
            const e = c[0];
            c = c[1];
            if (typeof c !== "string") continue;
            c = c.trim();
            const f = b[e] || [];
            b[e] = f;
            f.push(c);
        }
        Aa(b, function(d) {
            return d.join(", ");
        });
    }
    h.ya = function() {
        return this.o;
    };
    h.Ha = function() {
        return typeof this.l === "string" ? this.l : String(this.l);
    };
    function Rc(a, b, c) {
        return c && c.internalChannelParams ? c.internalChannelParams[a] || b : b;
    }
    function Sc(a) {
        this.za = 0;
        this.i = [];
        this.j = new pb;
        this.ba = this.na = this.J = this.W = this.g = this.wa = this.G = this.H = this.u = this.U = this.o = null;
        this.Ya = this.V = 0;
        this.Sa = Rc("failFast", !1, a);
        this.F = this.C = this.v = this.m = this.l = null;
        this.X = !0;
        this.xa = this.K = -1;
        this.Y = this.A = this.D = 0;
        this.Qa = Rc("baseRetryDelayMs", 5E3, a);
        this.Za = Rc("retryDelaySeedMs", 1E4, a);
        this.Ta = Rc("forwardChannelMaxRetries", 2, a);
        this.va = Rc("forwardChannelRequestTimeoutMs", 2E4, a);
        this.ma = a && a.xmlHttpFactory || void 0;
        this.Ua = a && a.Rb || void 0;
        this.Aa = a && a.useFetchStreams || !1;
        this.O = void 0;
        this.L = a && a.supportsCrossDomainXhr || !1;
        this.M = "";
        this.h = new ec(a && a.concurrentRequestLimit);
        this.Ba = new Dc;
        this.S = a && a.fastHandshake || !1;
        this.R = a && a.encodeInitMessageHeaders || !1;
        this.S && this.R && (this.R = !1);
        this.Ra = a && a.Pb || !1;
        a && a.ua && this.j.ua();
        a && a.forceLongPolling && (this.X = !1);
        this.aa = !this.S && this.X && a && a.detectBufferingProxy || !1;
        this.ia = void 0;
        a && a.longPollingTimeout && a.longPollingTimeout > 0 && (this.ia = a.longPollingTimeout);
        this.ta = void 0;
        this.T = 0;
        this.P = !1;
        this.ja = this.B = null;
    }
    h = Sc.prototype;
    h.ka = 8;
    h.I = 1;
    h.connect = function(a, b, c, d) {
        J(0);
        this.W = a;
        this.H = b || {};
        c && d !== void 0 && (this.H.OSID = c, this.H.OAID = d);
        this.F = this.X;
        this.J = Zb(this, null, this.W);
        bc(this);
    };
    function cc(a) {
        Tc(a);
        if (a.I == 3) {
            var b = a.V++, c = O(a.J);
            S(c, "SID", a.M);
            S(c, "RID", b);
            S(c, "TYPE", "terminate");
            Uc(a, c);
            b = new N(a, a.j, b);
            b.M = 2;
            b.A = Db(O(c));
            c = !1;
            if (l.navigator && l.navigator.sendBeacon) try {
                c = l.navigator.sendBeacon(b.A.toString(), "");
            } catch (d) {}
            !c && l.Image && ((new Image).src = b.A, c = !0);
            c || (b.g = Hb(b.j, null), b.g.ea(b.A));
            b.F = Date.now();
            Fb(b);
        }
        Vc(a);
    }
    function Vb(a) {
        a.g && (Pb(a), a.g.cancel(), a.g = null);
    }
    function Tc(a) {
        Vb(a);
        a.v && (l.clearTimeout(a.v), a.v = null);
        Ub(a);
        a.h.cancel();
        a.m && (typeof a.m === "number" && l.clearTimeout(a.m), a.m = null);
    }
    function bc(a) {
        if (!fc(a.h) && !a.m) {
            a.m = !0;
            var b = a.Ea;
            u || ta();
            v || (u(), v = !0);
            oa.add(b, a);
            a.D = 0;
        }
    }
    function Wc(a, b) {
        if (Xb(a.h) >= a.h.j - (a.m ? 1 : 0)) return !1;
        if (a.m) return a.i = b.G.concat(a.i), !0;
        if (a.I == 1 || a.I == 2 || a.D >= (a.Sa ? 0 : a.Ta)) return !1;
        a.m = ob(p(a.Ea, a, b), Xc(a, a.D));
        a.D++;
        return !0;
    }
    h.Ea = function(a) {
        if (this.m) {
            if (this.m = null, this.I == 1) {
                if (!a) {
                    this.V = Math.floor(Math.random() * 1E5);
                    a = this.V++;
                    const e = new N(this, this.j, a);
                    let f = this.o;
                    this.U && (f ? (f = Ba(f), Da(f, this.U)) : f = this.U);
                    this.u !== null || this.R || (e.J = f, f = null);
                    if (this.S) a: {
                        var b = 0;
                        for(var c = 0; c < this.i.length; c++){
                            b: {
                                var d = this.i[c];
                                if ("__data__" in d.map && (d = d.map.__data__, typeof d === "string")) {
                                    d = d.length;
                                    break b;
                                }
                                d = void 0;
                            }
                            if (d === void 0) break;
                            b += d;
                            if (b > 4096) {
                                b = c;
                                break a;
                            }
                            if (b === 4096 || c === this.i.length - 1) {
                                b = c + 1;
                                break a;
                            }
                        }
                        b = 1E3;
                    }
                    else b = 1E3;
                    b = Yc(this, e, b);
                    c = O(this.J);
                    S(c, "RID", a);
                    S(c, "CVER", 22);
                    this.G && S(c, "X-HTTP-Session-Id", this.G);
                    Uc(this, c);
                    f && (this.R ? b = "headers=" + L(Jc(f)) + "&" + b : this.u && Kc(c, this.u, f));
                    Yb(this.h, e);
                    this.Ra && S(c, "TYPE", "init");
                    this.S ? (S(c, "$req", b), S(c, "SID", "null"), e.U = !0, Cb(e, c, null)) : Cb(e, c, b);
                    this.I = 2;
                }
            } else this.I == 3 && (a ? Zc(this, a) : this.i.length == 0 || fc(this.h) || Zc(this));
        }
    };
    function Zc(a, b) {
        var c;
        b ? c = b.l : c = a.V++;
        const d = O(a.J);
        S(d, "SID", a.M);
        S(d, "RID", c);
        S(d, "AID", a.K);
        Uc(a, d);
        a.u && a.o && Kc(d, a.u, a.o);
        c = new N(a, a.j, c, a.D + 1);
        a.u === null && (c.J = a.o);
        b && (a.i = b.G.concat(a.i));
        b = Yc(a, c, 1E3);
        c.H = Math.round(a.va * .5) + Math.round(a.va * .5 * Math.random());
        Yb(a.h, c);
        Cb(c, d, b);
    }
    function Uc(a, b) {
        a.H && ya(a.H, function(c, d) {
            S(b, d, c);
        });
        a.l && ya({}, function(c, d) {
            S(b, d, c);
        });
    }
    function Yc(a, b, c) {
        c = Math.min(a.i.length, c);
        const d = a.l ? p(a.l.Ka, a.l, a) : null;
        a: {
            var e = a.i;
            let k = -1;
            for(;;){
                const q = [
                    "count=" + c
                ];
                k == -1 ? c > 0 ? (k = e[0].g, q.push("ofs=" + k)) : k = 0 : q.push("ofs=" + k);
                let m = !0;
                for(let r = 0; r < c; r++){
                    var f = e[r].g;
                    const A = e[r].map;
                    f -= k;
                    if (f < 0) k = Math.max(0, e[r].g - 100), m = !1;
                    else try {
                        f = "req" + f + "_";
                        try {
                            var g = A instanceof Map ? A : Object.entries(A);
                            for (const [M, F] of g){
                                let G = F;
                                n(F) && (G = ab(F));
                                q.push(f + M + "=" + encodeURIComponent(G));
                            }
                        } catch (M) {
                            throw q.push(f + "type=" + encodeURIComponent("_badmap")), M;
                        }
                    } catch (M) {
                        d && d(A);
                    }
                }
                if (m) {
                    g = q.join("&");
                    break a;
                }
            }
            g = void 0;
        }
        a = a.i.splice(0, c);
        b.G = a;
        return g;
    }
    function ac(a) {
        if (!a.g && !a.v) {
            a.Y = 1;
            var b = a.Da;
            u || ta();
            v || (u(), v = !0);
            oa.add(b, a);
            a.A = 0;
        }
    }
    function Wb(a) {
        if (a.g || a.v || a.A >= 3) return !1;
        a.Y++;
        a.v = ob(p(a.Da, a), Xc(a, a.A));
        a.A++;
        return !0;
    }
    h.Da = function() {
        this.v = null;
        $c(this);
        if (this.aa && !(this.P || this.g == null || this.T <= 0)) {
            var a = 4 * this.T;
            this.j.info("BP detection timer enabled: " + a);
            this.B = ob(p(this.Wa, this), a);
        }
    };
    h.Wa = function() {
        this.B && (this.B = null, this.j.info("BP detection timeout reached."), this.j.info("Buffering proxy detected and switch to long-polling!"), this.F = !1, this.P = !0, J(10), Vb(this), $c(this));
    };
    function Pb(a) {
        a.B != null && (l.clearTimeout(a.B), a.B = null);
    }
    function $c(a) {
        a.g = new N(a, a.j, "rpc", a.Y);
        a.u === null && (a.g.J = a.o);
        a.g.P = 0;
        var b = O(a.na);
        S(b, "RID", "rpc");
        S(b, "SID", a.M);
        S(b, "AID", a.K);
        S(b, "CI", a.F ? "0" : "1");
        !a.F && a.ia && S(b, "TO", a.ia);
        S(b, "TYPE", "xmlhttp");
        Uc(a, b);
        a.u && a.o && Kc(b, a.u, a.o);
        a.O && (a.g.H = a.O);
        var c = a.g;
        a = a.ba;
        c.M = 1;
        c.A = Db(O(b));
        c.u = null;
        c.R = !0;
        Eb(c, a);
    }
    h.Va = function() {
        this.C != null && (this.C = null, Vb(this), Wb(this), J(19));
    };
    function Ub(a) {
        a.C != null && (l.clearTimeout(a.C), a.C = null);
    }
    function Qb(a, b) {
        var c = null;
        if (a.g == b) {
            Ub(a);
            Pb(a);
            a.g = null;
            var d = 2;
        } else if (Tb(a.h, b)) c = b.G, $b(a.h, b), d = 1;
        else return;
        if (a.I != 0) {
            if (b.o) {
                if (d == 1) {
                    c = b.u ? b.u.length : 0;
                    b = Date.now() - b.F;
                    var e = a.D;
                    d = jb();
                    D(d, new nb(d, c));
                    bc(a);
                } else ac(a);
            } else if (e = b.m, e == 3 || e == 0 && b.X > 0 || !(d == 1 && Wc(a, b) || d == 2 && Wb(a))) switch(c && c.length > 0 && (b = a.h, b.i = b.i.concat(c)), e){
                case 1:
                    R(a, 5);
                    break;
                case 4:
                    R(a, 10);
                    break;
                case 3:
                    R(a, 6);
                    break;
                default:
                    R(a, 2);
            }
        }
    }
    function Xc(a, b) {
        let c = a.Qa + Math.floor(Math.random() * a.Za);
        a.isActive() || (c *= 2);
        return c * b;
    }
    function R(a, b) {
        a.j.info("Error code " + b);
        if (b == 2) {
            var c = p(a.bb, a), d = a.Ua;
            const e = !d;
            d = new T(d || "//www.google.com/images/cleardot.gif");
            l.location && l.location.protocol == "http" || kc(d, "https");
            Db(d);
            e ? Bc(d.toString(), c) : Cc(d.toString(), c);
        } else J(2);
        a.I = 0;
        a.l && a.l.pa(b);
        Vc(a);
        Tc(a);
    }
    h.bb = function(a) {
        a ? (this.j.info("Successfully pinged google.com"), J(2)) : (this.j.info("Failed to ping google.com"), J(1));
    };
    function Vc(a) {
        a.I = 0;
        a.ja = [];
        if (a.l) {
            const b = hc(a.h);
            if (b.length != 0 || a.i.length != 0) ka(a.ja, b), ka(a.ja, a.i), a.h.i.length = 0, ja(a.i), a.i.length = 0;
            a.l.oa();
        }
    }
    function Zb(a, b, c) {
        var d = c instanceof T ? O(c) : new T(c);
        if (d.g != "") b && (d.g = b + "." + d.g), lc(d, d.u);
        else {
            var e = l.location;
            d = e.protocol;
            b = b ? b + "." + e.hostname : e.hostname;
            e = +e.port;
            const f = new T(null);
            d && kc(f, d);
            b && (f.g = b);
            e && lc(f, e);
            c && (f.h = c);
            d = f;
        }
        c = a.G;
        b = a.wa;
        c && b && S(d, c, b);
        S(d, "VER", a.ka);
        Uc(a, d);
        return d;
    }
    function Hb(a, b, c) {
        if (b && !a.L) throw Error("Can't create secondary domain capable XhrIo object.");
        b = a.Aa && !a.ma ? new X(new Ec({
            ab: c
        })) : new X(a.ma);
        b.Fa(a.L);
        return b;
    }
    h.isActive = function() {
        return !!this.l && this.l.isActive(this);
    };
    function ad() {}
    h = ad.prototype;
    h.ra = function() {};
    h.qa = function() {};
    h.pa = function() {};
    h.oa = function() {};
    h.isActive = function() {
        return !0;
    };
    h.Ka = function() {};
    function bd() {}
    bd.prototype.g = function(a, b) {
        return new Y(a, b);
    };
    function Y(a, b) {
        C.call(this);
        this.g = new Sc(b);
        this.l = a;
        this.h = b && b.messageUrlParams || null;
        a = b && b.messageHeaders || null;
        b && b.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = {
            "X-Client-Protocol": "webchannel"
        });
        this.g.o = a;
        a = b && b.initMessageHeaders || null;
        b && b.messageContentType && (a ? a["X-WebChannel-Content-Type"] = b.messageContentType : a = {
            "X-WebChannel-Content-Type": b.messageContentType
        });
        b && b.sa && (a ? a["X-WebChannel-Client-Profile"] = b.sa : a = {
            "X-WebChannel-Client-Profile": b.sa
        });
        this.g.U = a;
        (a = b && b.Qb) && !y(a) && (this.g.u = a);
        this.A = b && b.supportsCrossDomainXhr || !1;
        this.v = b && b.sendRawJson || !1;
        (b = b && b.httpSessionIdParam) && !y(b) && (this.g.G = b, a = this.h, a !== null && b in a && (a = this.h, b in a && delete a[b]));
        this.j = new Z(this);
    }
    t(Y, C);
    Y.prototype.m = function() {
        this.g.l = this.j;
        this.A && (this.g.L = !0);
        this.g.connect(this.l, this.h || void 0);
    };
    Y.prototype.close = function() {
        cc(this.g);
    };
    Y.prototype.o = function(a) {
        var b = this.g;
        if (typeof a === "string") {
            var c = {};
            c.__data__ = a;
            a = c;
        } else this.v && (c = {}, c.__data__ = ab(a), a = c);
        b.i.push(new dc(b.Ya++, a));
        b.I == 3 && bc(b);
    };
    Y.prototype.N = function() {
        this.g.l = null;
        delete this.j;
        cc(this.g);
        delete this.g;
        Y.Z.N.call(this);
    };
    function cd(a) {
        gb.call(this);
        a.__headers__ && (this.headers = a.__headers__, this.statusCode = a.__status__, delete a.__headers__, delete a.__status__);
        var b = a.__sm__;
        if (b) {
            a: {
                for(const c in b){
                    a = c;
                    break a;
                }
                a = void 0;
            }
            if (this.i = a) a = this.i, b = b !== null && a in b ? b[a] : void 0;
            this.data = b;
        } else this.data = a;
    }
    t(cd, gb);
    function dd() {
        hb.call(this);
        this.status = 1;
    }
    t(dd, hb);
    function Z(a) {
        this.g = a;
    }
    t(Z, ad);
    Z.prototype.ra = function() {
        D(this.g, "a");
    };
    Z.prototype.qa = function(a) {
        D(this.g, new cd(a));
    };
    Z.prototype.pa = function(a) {
        D(this.g, new dd());
    };
    Z.prototype.oa = function() {
        D(this.g, "b");
    };
    bd.prototype.createWebChannel = bd.prototype.g;
    Y.prototype.send = Y.prototype.o;
    Y.prototype.open = Y.prototype.m;
    Y.prototype.close = Y.prototype.close;
    $87c0e2812a00f0b8$export$66869136fc133c3a = $87c0e2812a00f0b8$export$2e2bcd8739ae039.createWebChannelTransport = function() {
        return new bd;
    };
    $87c0e2812a00f0b8$export$888d0d9ab79d08fc = $87c0e2812a00f0b8$export$2e2bcd8739ae039.getStatEventTarget = function() {
        return jb();
    };
    $87c0e2812a00f0b8$export$d61e24a684f9e51 = $87c0e2812a00f0b8$export$2e2bcd8739ae039.Event = I;
    $87c0e2812a00f0b8$export$cbbc350c1dfc80cb = $87c0e2812a00f0b8$export$2e2bcd8739ae039.Stat = {
        jb: 0,
        mb: 1,
        nb: 2,
        Hb: 3,
        Mb: 4,
        Jb: 5,
        Kb: 6,
        Ib: 7,
        Gb: 8,
        Lb: 9,
        PROXY: 10,
        NOPROXY: 11,
        Eb: 12,
        Ab: 13,
        Bb: 14,
        zb: 15,
        Cb: 16,
        Db: 17,
        fb: 18,
        eb: 19,
        gb: 20
    };
    ub.NO_ERROR = 0;
    ub.TIMEOUT = 8;
    ub.HTTP_ERROR = 6;
    $87c0e2812a00f0b8$export$d4e71bc0b80dc0fb = $87c0e2812a00f0b8$export$2e2bcd8739ae039.ErrorCode = ub;
    vb.COMPLETE = "complete";
    $87c0e2812a00f0b8$export$3d7865934588d77e = $87c0e2812a00f0b8$export$2e2bcd8739ae039.EventType = vb;
    fb.EventType = H;
    H.OPEN = "a";
    H.CLOSE = "b";
    H.ERROR = "c";
    H.MESSAGE = "d";
    C.prototype.listen = C.prototype.J;
    $87c0e2812a00f0b8$export$aa726fb96ad3e039 = $87c0e2812a00f0b8$export$2e2bcd8739ae039.WebChannel = fb;
    $87c0e2812a00f0b8$export$ddb1030448106742 = $87c0e2812a00f0b8$export$2e2bcd8739ae039.FetchXmlHttpFactory = Ec;
    X.prototype.listenOnce = X.prototype.K;
    X.prototype.getLastError = X.prototype.Ha;
    X.prototype.getLastErrorCode = X.prototype.ya;
    X.prototype.getStatus = X.prototype.ca;
    X.prototype.getResponseJson = X.prototype.La;
    X.prototype.getResponseText = X.prototype.la;
    X.prototype.send = X.prototype.ea;
    X.prototype.setWithCredentials = X.prototype.Fa;
    $87c0e2812a00f0b8$export$26404658cda3ee02 = $87c0e2812a00f0b8$export$2e2bcd8739ae039.XhrIo = X;
}).apply(typeof $87c0e2812a00f0b8$var$commonjsGlobal !== 'undefined' ? $87c0e2812a00f0b8$var$commonjsGlobal : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $9efcfb26a96dcb10$export$a143d493d941bafc;
var $9efcfb26a96dcb10$export$e4cf37d7f6fb9e0a;
var $9efcfb26a96dcb10$export$f99ded8fe4b79145;
var $9efcfb26a96dcb10$export$599f31c3813fae4d;
'use strict';
var $71709ed37693c3f2$export$a48f0734ac7c2329;
var $71709ed37693c3f2$export$d622b2ad8d90c771;
var $71709ed37693c3f2$export$6100ba28696e12de;
'use strict';
$71709ed37693c3f2$export$a48f0734ac7c2329 = $71709ed37693c3f2$var$byteLength;
$71709ed37693c3f2$export$d622b2ad8d90c771 = $71709ed37693c3f2$var$toByteArray;
$71709ed37693c3f2$export$6100ba28696e12de = $71709ed37693c3f2$var$fromByteArray;
var $71709ed37693c3f2$var$lookup = [];
var $71709ed37693c3f2$var$revLookup = [];
var $71709ed37693c3f2$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $71709ed37693c3f2$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $71709ed37693c3f2$var$i = 0, $71709ed37693c3f2$var$len = $71709ed37693c3f2$var$code.length; $71709ed37693c3f2$var$i < $71709ed37693c3f2$var$len; ++$71709ed37693c3f2$var$i){
    $71709ed37693c3f2$var$lookup[$71709ed37693c3f2$var$i] = $71709ed37693c3f2$var$code[$71709ed37693c3f2$var$i];
    $71709ed37693c3f2$var$revLookup[$71709ed37693c3f2$var$code.charCodeAt($71709ed37693c3f2$var$i)] = $71709ed37693c3f2$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$71709ed37693c3f2$var$revLookup['-'.charCodeAt(0)] = 62;
$71709ed37693c3f2$var$revLookup['_'.charCodeAt(0)] = 63;
function $71709ed37693c3f2$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $71709ed37693c3f2$var$byteLength(b64) {
    var lens = $71709ed37693c3f2$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $71709ed37693c3f2$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $71709ed37693c3f2$var$toByteArray(b64) {
    var tmp;
    var lens = $71709ed37693c3f2$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $71709ed37693c3f2$var$Arr($71709ed37693c3f2$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $71709ed37693c3f2$var$revLookup[b64.charCodeAt(i)] << 18 | $71709ed37693c3f2$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $71709ed37693c3f2$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $71709ed37693c3f2$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $71709ed37693c3f2$var$revLookup[b64.charCodeAt(i)] << 2 | $71709ed37693c3f2$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $71709ed37693c3f2$var$revLookup[b64.charCodeAt(i)] << 10 | $71709ed37693c3f2$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $71709ed37693c3f2$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $71709ed37693c3f2$var$tripletToBase64(num) {
    return $71709ed37693c3f2$var$lookup[num >> 18 & 0x3F] + $71709ed37693c3f2$var$lookup[num >> 12 & 0x3F] + $71709ed37693c3f2$var$lookup[num >> 6 & 0x3F] + $71709ed37693c3f2$var$lookup[num & 0x3F];
}
function $71709ed37693c3f2$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($71709ed37693c3f2$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $71709ed37693c3f2$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($71709ed37693c3f2$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($71709ed37693c3f2$var$lookup[tmp >> 2] + $71709ed37693c3f2$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($71709ed37693c3f2$var$lookup[tmp >> 10] + $71709ed37693c3f2$var$lookup[tmp >> 4 & 0x3F] + $71709ed37693c3f2$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $ba1d77ea5b38c29a$export$aafa59e2e03f2942;
var $ba1d77ea5b38c29a$export$68d8715fc104d294;
$ba1d77ea5b38c29a$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$ba1d77ea5b38c29a$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $9efcfb26a96dcb10$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$9efcfb26a96dcb10$export$a143d493d941bafc = $9efcfb26a96dcb10$var$Buffer;
$9efcfb26a96dcb10$export$e4cf37d7f6fb9e0a = $9efcfb26a96dcb10$var$SlowBuffer;
$9efcfb26a96dcb10$export$f99ded8fe4b79145 = 50;
const $9efcfb26a96dcb10$var$K_MAX_LENGTH = 0x7fffffff;
$9efcfb26a96dcb10$export$599f31c3813fae4d = $9efcfb26a96dcb10$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $9efcfb26a96dcb10$var$Buffer.TYPED_ARRAY_SUPPORT = $9efcfb26a96dcb10$var$typedArraySupport();
if (!$9efcfb26a96dcb10$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $9efcfb26a96dcb10$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($9efcfb26a96dcb10$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$9efcfb26a96dcb10$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($9efcfb26a96dcb10$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$9efcfb26a96dcb10$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $9efcfb26a96dcb10$var$createBuffer(length) {
    if (length > $9efcfb26a96dcb10$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $9efcfb26a96dcb10$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $9efcfb26a96dcb10$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $9efcfb26a96dcb10$var$allocUnsafe(arg);
    }
    return $9efcfb26a96dcb10$var$from(arg, encodingOrOffset, length);
}
$9efcfb26a96dcb10$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $9efcfb26a96dcb10$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $9efcfb26a96dcb10$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $9efcfb26a96dcb10$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($9efcfb26a96dcb10$var$isInstance(value, ArrayBuffer) || value && $9efcfb26a96dcb10$var$isInstance(value.buffer, ArrayBuffer)) return $9efcfb26a96dcb10$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($9efcfb26a96dcb10$var$isInstance(value, SharedArrayBuffer) || value && $9efcfb26a96dcb10$var$isInstance(value.buffer, SharedArrayBuffer))) return $9efcfb26a96dcb10$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $9efcfb26a96dcb10$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $9efcfb26a96dcb10$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $9efcfb26a96dcb10$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $9efcfb26a96dcb10$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $9efcfb26a96dcb10$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($9efcfb26a96dcb10$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($9efcfb26a96dcb10$var$Buffer, Uint8Array);
function $9efcfb26a96dcb10$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $9efcfb26a96dcb10$var$alloc(size, fill, encoding) {
    $9efcfb26a96dcb10$var$assertSize(size);
    if (size <= 0) return $9efcfb26a96dcb10$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $9efcfb26a96dcb10$var$createBuffer(size).fill(fill, encoding) : $9efcfb26a96dcb10$var$createBuffer(size).fill(fill);
    return $9efcfb26a96dcb10$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $9efcfb26a96dcb10$var$Buffer.alloc = function(size, fill, encoding) {
    return $9efcfb26a96dcb10$var$alloc(size, fill, encoding);
};
function $9efcfb26a96dcb10$var$allocUnsafe(size) {
    $9efcfb26a96dcb10$var$assertSize(size);
    return $9efcfb26a96dcb10$var$createBuffer(size < 0 ? 0 : $9efcfb26a96dcb10$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $9efcfb26a96dcb10$var$Buffer.allocUnsafe = function(size) {
    return $9efcfb26a96dcb10$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $9efcfb26a96dcb10$var$Buffer.allocUnsafeSlow = function(size) {
    return $9efcfb26a96dcb10$var$allocUnsafe(size);
};
function $9efcfb26a96dcb10$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$9efcfb26a96dcb10$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $9efcfb26a96dcb10$var$byteLength(string, encoding) | 0;
    let buf = $9efcfb26a96dcb10$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $9efcfb26a96dcb10$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $9efcfb26a96dcb10$var$checked(array.length) | 0;
    const buf = $9efcfb26a96dcb10$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $9efcfb26a96dcb10$var$fromArrayView(arrayView) {
    if ($9efcfb26a96dcb10$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $9efcfb26a96dcb10$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $9efcfb26a96dcb10$var$fromArrayLike(arrayView);
}
function $9efcfb26a96dcb10$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $9efcfb26a96dcb10$var$Buffer.prototype);
    return buf;
}
function $9efcfb26a96dcb10$var$fromObject(obj) {
    if ($9efcfb26a96dcb10$var$Buffer.isBuffer(obj)) {
        const len = $9efcfb26a96dcb10$var$checked(obj.length) | 0;
        const buf = $9efcfb26a96dcb10$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $9efcfb26a96dcb10$var$numberIsNaN(obj.length)) return $9efcfb26a96dcb10$var$createBuffer(0);
        return $9efcfb26a96dcb10$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $9efcfb26a96dcb10$var$fromArrayLike(obj.data);
}
function $9efcfb26a96dcb10$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $9efcfb26a96dcb10$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $9efcfb26a96dcb10$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $9efcfb26a96dcb10$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $9efcfb26a96dcb10$var$Buffer.alloc(+length);
}
$9efcfb26a96dcb10$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $9efcfb26a96dcb10$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$9efcfb26a96dcb10$var$Buffer.compare = function compare(a, b) {
    if ($9efcfb26a96dcb10$var$isInstance(a, Uint8Array)) a = $9efcfb26a96dcb10$var$Buffer.from(a, a.offset, a.byteLength);
    if ($9efcfb26a96dcb10$var$isInstance(b, Uint8Array)) b = $9efcfb26a96dcb10$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$9efcfb26a96dcb10$var$Buffer.isBuffer(a) || !$9efcfb26a96dcb10$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$9efcfb26a96dcb10$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$9efcfb26a96dcb10$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $9efcfb26a96dcb10$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $9efcfb26a96dcb10$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($9efcfb26a96dcb10$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$9efcfb26a96dcb10$var$Buffer.isBuffer(buf)) buf = $9efcfb26a96dcb10$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$9efcfb26a96dcb10$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $9efcfb26a96dcb10$var$byteLength(string, encoding) {
    if ($9efcfb26a96dcb10$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $9efcfb26a96dcb10$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $9efcfb26a96dcb10$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $9efcfb26a96dcb10$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $9efcfb26a96dcb10$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$9efcfb26a96dcb10$var$Buffer.byteLength = $9efcfb26a96dcb10$var$byteLength;
function $9efcfb26a96dcb10$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $9efcfb26a96dcb10$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $9efcfb26a96dcb10$var$utf8Slice(this, start, end);
        case 'ascii':
            return $9efcfb26a96dcb10$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $9efcfb26a96dcb10$var$latin1Slice(this, start, end);
        case 'base64':
            return $9efcfb26a96dcb10$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $9efcfb26a96dcb10$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$9efcfb26a96dcb10$var$Buffer.prototype._isBuffer = true;
function $9efcfb26a96dcb10$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$9efcfb26a96dcb10$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$9efcfb26a96dcb10$var$swap(this, i, i + 1);
    return this;
};
$9efcfb26a96dcb10$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $9efcfb26a96dcb10$var$swap(this, i, i + 3);
        $9efcfb26a96dcb10$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$9efcfb26a96dcb10$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $9efcfb26a96dcb10$var$swap(this, i, i + 7);
        $9efcfb26a96dcb10$var$swap(this, i + 1, i + 6);
        $9efcfb26a96dcb10$var$swap(this, i + 2, i + 5);
        $9efcfb26a96dcb10$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$9efcfb26a96dcb10$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $9efcfb26a96dcb10$var$utf8Slice(this, 0, length);
    return $9efcfb26a96dcb10$var$slowToString.apply(this, arguments);
};
$9efcfb26a96dcb10$var$Buffer.prototype.toLocaleString = $9efcfb26a96dcb10$var$Buffer.prototype.toString;
$9efcfb26a96dcb10$var$Buffer.prototype.equals = function equals(b) {
    if (!$9efcfb26a96dcb10$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $9efcfb26a96dcb10$var$Buffer.compare(this, b) === 0;
};
$9efcfb26a96dcb10$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $9efcfb26a96dcb10$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($9efcfb26a96dcb10$var$customInspectSymbol) $9efcfb26a96dcb10$var$Buffer.prototype[$9efcfb26a96dcb10$var$customInspectSymbol] = $9efcfb26a96dcb10$var$Buffer.prototype.inspect;
$9efcfb26a96dcb10$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($9efcfb26a96dcb10$var$isInstance(target, Uint8Array)) target = $9efcfb26a96dcb10$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$9efcfb26a96dcb10$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $9efcfb26a96dcb10$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($9efcfb26a96dcb10$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $9efcfb26a96dcb10$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($9efcfb26a96dcb10$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $9efcfb26a96dcb10$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $9efcfb26a96dcb10$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $9efcfb26a96dcb10$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$9efcfb26a96dcb10$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$9efcfb26a96dcb10$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $9efcfb26a96dcb10$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$9efcfb26a96dcb10$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $9efcfb26a96dcb10$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $9efcfb26a96dcb10$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($9efcfb26a96dcb10$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $9efcfb26a96dcb10$var$utf8Write(buf, string, offset, length) {
    return $9efcfb26a96dcb10$var$blitBuffer($9efcfb26a96dcb10$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $9efcfb26a96dcb10$var$asciiWrite(buf, string, offset, length) {
    return $9efcfb26a96dcb10$var$blitBuffer($9efcfb26a96dcb10$var$asciiToBytes(string), buf, offset, length);
}
function $9efcfb26a96dcb10$var$base64Write(buf, string, offset, length) {
    return $9efcfb26a96dcb10$var$blitBuffer($9efcfb26a96dcb10$var$base64ToBytes(string), buf, offset, length);
}
function $9efcfb26a96dcb10$var$ucs2Write(buf, string, offset, length) {
    return $9efcfb26a96dcb10$var$blitBuffer($9efcfb26a96dcb10$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$9efcfb26a96dcb10$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $9efcfb26a96dcb10$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $9efcfb26a96dcb10$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $9efcfb26a96dcb10$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $9efcfb26a96dcb10$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $9efcfb26a96dcb10$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$9efcfb26a96dcb10$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $9efcfb26a96dcb10$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $71709ed37693c3f2$export$6100ba28696e12de(buf);
    else return $71709ed37693c3f2$export$6100ba28696e12de(buf.slice(start, end));
}
function $9efcfb26a96dcb10$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $9efcfb26a96dcb10$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $9efcfb26a96dcb10$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $9efcfb26a96dcb10$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $9efcfb26a96dcb10$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $9efcfb26a96dcb10$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $9efcfb26a96dcb10$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $9efcfb26a96dcb10$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $9efcfb26a96dcb10$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $9efcfb26a96dcb10$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $9efcfb26a96dcb10$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$9efcfb26a96dcb10$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $9efcfb26a96dcb10$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $9efcfb26a96dcb10$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$9efcfb26a96dcb10$var$Buffer.prototype.readUintLE = $9efcfb26a96dcb10$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $9efcfb26a96dcb10$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$9efcfb26a96dcb10$var$Buffer.prototype.readUintBE = $9efcfb26a96dcb10$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $9efcfb26a96dcb10$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$9efcfb26a96dcb10$var$Buffer.prototype.readUint8 = $9efcfb26a96dcb10$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9efcfb26a96dcb10$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$9efcfb26a96dcb10$var$Buffer.prototype.readUint16LE = $9efcfb26a96dcb10$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9efcfb26a96dcb10$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$9efcfb26a96dcb10$var$Buffer.prototype.readUint16BE = $9efcfb26a96dcb10$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9efcfb26a96dcb10$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$9efcfb26a96dcb10$var$Buffer.prototype.readUint32LE = $9efcfb26a96dcb10$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9efcfb26a96dcb10$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$9efcfb26a96dcb10$var$Buffer.prototype.readUint32BE = $9efcfb26a96dcb10$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9efcfb26a96dcb10$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$9efcfb26a96dcb10$var$Buffer.prototype.readBigUInt64LE = $9efcfb26a96dcb10$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $9efcfb26a96dcb10$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $9efcfb26a96dcb10$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$9efcfb26a96dcb10$var$Buffer.prototype.readBigUInt64BE = $9efcfb26a96dcb10$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $9efcfb26a96dcb10$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $9efcfb26a96dcb10$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$9efcfb26a96dcb10$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $9efcfb26a96dcb10$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$9efcfb26a96dcb10$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $9efcfb26a96dcb10$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$9efcfb26a96dcb10$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9efcfb26a96dcb10$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$9efcfb26a96dcb10$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9efcfb26a96dcb10$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$9efcfb26a96dcb10$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9efcfb26a96dcb10$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$9efcfb26a96dcb10$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9efcfb26a96dcb10$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$9efcfb26a96dcb10$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9efcfb26a96dcb10$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$9efcfb26a96dcb10$var$Buffer.prototype.readBigInt64LE = $9efcfb26a96dcb10$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $9efcfb26a96dcb10$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $9efcfb26a96dcb10$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$9efcfb26a96dcb10$var$Buffer.prototype.readBigInt64BE = $9efcfb26a96dcb10$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $9efcfb26a96dcb10$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $9efcfb26a96dcb10$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$9efcfb26a96dcb10$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9efcfb26a96dcb10$var$checkOffset(offset, 4, this.length);
    return $ba1d77ea5b38c29a$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$9efcfb26a96dcb10$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9efcfb26a96dcb10$var$checkOffset(offset, 4, this.length);
    return $ba1d77ea5b38c29a$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$9efcfb26a96dcb10$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9efcfb26a96dcb10$var$checkOffset(offset, 8, this.length);
    return $ba1d77ea5b38c29a$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$9efcfb26a96dcb10$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9efcfb26a96dcb10$var$checkOffset(offset, 8, this.length);
    return $ba1d77ea5b38c29a$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $9efcfb26a96dcb10$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$9efcfb26a96dcb10$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$9efcfb26a96dcb10$var$Buffer.prototype.writeUintLE = $9efcfb26a96dcb10$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $9efcfb26a96dcb10$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$9efcfb26a96dcb10$var$Buffer.prototype.writeUintBE = $9efcfb26a96dcb10$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $9efcfb26a96dcb10$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$9efcfb26a96dcb10$var$Buffer.prototype.writeUint8 = $9efcfb26a96dcb10$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9efcfb26a96dcb10$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$9efcfb26a96dcb10$var$Buffer.prototype.writeUint16LE = $9efcfb26a96dcb10$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9efcfb26a96dcb10$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$9efcfb26a96dcb10$var$Buffer.prototype.writeUint16BE = $9efcfb26a96dcb10$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9efcfb26a96dcb10$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$9efcfb26a96dcb10$var$Buffer.prototype.writeUint32LE = $9efcfb26a96dcb10$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9efcfb26a96dcb10$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$9efcfb26a96dcb10$var$Buffer.prototype.writeUint32BE = $9efcfb26a96dcb10$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9efcfb26a96dcb10$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $9efcfb26a96dcb10$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $9efcfb26a96dcb10$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $9efcfb26a96dcb10$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $9efcfb26a96dcb10$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$9efcfb26a96dcb10$var$Buffer.prototype.writeBigUInt64LE = $9efcfb26a96dcb10$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $9efcfb26a96dcb10$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$9efcfb26a96dcb10$var$Buffer.prototype.writeBigUInt64BE = $9efcfb26a96dcb10$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $9efcfb26a96dcb10$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$9efcfb26a96dcb10$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $9efcfb26a96dcb10$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$9efcfb26a96dcb10$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $9efcfb26a96dcb10$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$9efcfb26a96dcb10$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9efcfb26a96dcb10$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$9efcfb26a96dcb10$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9efcfb26a96dcb10$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$9efcfb26a96dcb10$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9efcfb26a96dcb10$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$9efcfb26a96dcb10$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9efcfb26a96dcb10$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$9efcfb26a96dcb10$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9efcfb26a96dcb10$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$9efcfb26a96dcb10$var$Buffer.prototype.writeBigInt64LE = $9efcfb26a96dcb10$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $9efcfb26a96dcb10$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$9efcfb26a96dcb10$var$Buffer.prototype.writeBigInt64BE = $9efcfb26a96dcb10$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $9efcfb26a96dcb10$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $9efcfb26a96dcb10$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $9efcfb26a96dcb10$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9efcfb26a96dcb10$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $ba1d77ea5b38c29a$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$9efcfb26a96dcb10$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $9efcfb26a96dcb10$var$writeFloat(this, value, offset, true, noAssert);
};
$9efcfb26a96dcb10$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $9efcfb26a96dcb10$var$writeFloat(this, value, offset, false, noAssert);
};
function $9efcfb26a96dcb10$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9efcfb26a96dcb10$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $ba1d77ea5b38c29a$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$9efcfb26a96dcb10$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $9efcfb26a96dcb10$var$writeDouble(this, value, offset, true, noAssert);
};
$9efcfb26a96dcb10$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $9efcfb26a96dcb10$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$9efcfb26a96dcb10$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$9efcfb26a96dcb10$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$9efcfb26a96dcb10$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$9efcfb26a96dcb10$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $9efcfb26a96dcb10$var$Buffer.isBuffer(val) ? val : $9efcfb26a96dcb10$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $9efcfb26a96dcb10$var$errors = {};
function $9efcfb26a96dcb10$var$E(sym, getMessage, Base) {
    $9efcfb26a96dcb10$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$9efcfb26a96dcb10$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$9efcfb26a96dcb10$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$9efcfb26a96dcb10$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $9efcfb26a96dcb10$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $9efcfb26a96dcb10$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $9efcfb26a96dcb10$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $9efcfb26a96dcb10$var$checkBounds(buf, offset, byteLength) {
    $9efcfb26a96dcb10$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $9efcfb26a96dcb10$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $9efcfb26a96dcb10$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $9efcfb26a96dcb10$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $9efcfb26a96dcb10$var$checkBounds(buf, offset, byteLength);
}
function $9efcfb26a96dcb10$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $9efcfb26a96dcb10$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $9efcfb26a96dcb10$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $9efcfb26a96dcb10$var$validateNumber(value, type);
        throw new $9efcfb26a96dcb10$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $9efcfb26a96dcb10$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $9efcfb26a96dcb10$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $9efcfb26a96dcb10$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $9efcfb26a96dcb10$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($9efcfb26a96dcb10$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $9efcfb26a96dcb10$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $9efcfb26a96dcb10$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $9efcfb26a96dcb10$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $9efcfb26a96dcb10$var$base64ToBytes(str) {
    return $71709ed37693c3f2$export$d622b2ad8d90c771($9efcfb26a96dcb10$var$base64clean(str));
}
function $9efcfb26a96dcb10$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $9efcfb26a96dcb10$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $9efcfb26a96dcb10$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $9efcfb26a96dcb10$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $9efcfb26a96dcb10$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $9efcfb26a96dcb10$var$BufferBigIntNotDefined : fn;
}
function $9efcfb26a96dcb10$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $63c47e8a587a7f36$require$Buffer = $9efcfb26a96dcb10$export$a143d493d941bafc;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */ class $63c47e8a587a7f36$var$User {
    constructor(e){
        this.uid = e;
    }
    isAuthenticated() {
        return null != this.uid;
    }
    /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */ toKey() {
        return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
    }
    isEqual(e) {
        return e.uid === this.uid;
    }
}
/** A user with a null UID. */ $63c47e8a587a7f36$var$User.UNAUTHENTICATED = new $63c47e8a587a7f36$var$User(null), // TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
$63c47e8a587a7f36$var$User.GOOGLE_CREDENTIALS = new $63c47e8a587a7f36$var$User("google-credentials-uid"), $63c47e8a587a7f36$var$User.FIRST_PARTY = new $63c47e8a587a7f36$var$User("first-party-uid"), $63c47e8a587a7f36$var$User.MOCK_USER = new $63c47e8a587a7f36$var$User("mock-user");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $63c47e8a587a7f36$var$S = "12.10.0";
function $63c47e8a587a7f36$export$71511d61b312f219(e) {
    $63c47e8a587a7f36$var$S = e;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Formats an object as a JSON string, suitable for logging. */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $63c47e8a587a7f36$var$D = new (0, $6640afd658bf2724$export$efa9a398d6368992)("@firebase/firestore");
// Helper methods are needed because variables can't be exported as read/write
function $63c47e8a587a7f36$var$__PRIVATE_getLogLevel() {
    return $63c47e8a587a7f36$var$D.logLevel;
}
/**
 * Sets the verbosity of Cloud Firestore logs (debug, error, or silent).
 *
 * @param logLevel - The verbosity you set for activity and error logging. Can
 *   be any of the following values:
 *
 *   <ul>
 *     <li>`debug` for the most verbose logging level, primarily for
 *     debugging.</li>
 *     <li>`error` to log errors only.</li>
 *     <li><code>`silent` to turn off logging.</li>
 *   </ul>
 */ function $63c47e8a587a7f36$export$8c78c7c36408ea29(e) {
    $63c47e8a587a7f36$var$D.setLogLevel(e);
}
function $63c47e8a587a7f36$export$21579262ef46735b(e, ...t) {
    if ($63c47e8a587a7f36$var$D.logLevel <= (0, $6640afd658bf2724$export$243e62d78d3b544d).DEBUG) {
        const n = t.map($63c47e8a587a7f36$var$__PRIVATE_argToString);
        $63c47e8a587a7f36$var$D.debug(`Firestore (${$63c47e8a587a7f36$var$S}): ${e}`, ...n);
    }
}
function $63c47e8a587a7f36$var$__PRIVATE_logError(e, ...t) {
    if ($63c47e8a587a7f36$var$D.logLevel <= (0, $6640afd658bf2724$export$243e62d78d3b544d).ERROR) {
        const n = t.map($63c47e8a587a7f36$var$__PRIVATE_argToString);
        $63c47e8a587a7f36$var$D.error(`Firestore (${$63c47e8a587a7f36$var$S}): ${e}`, ...n);
    }
}
/**
 * @internal
 */ function $63c47e8a587a7f36$export$4c3d22f3d993c33f(e, ...t) {
    if ($63c47e8a587a7f36$var$D.logLevel <= (0, $6640afd658bf2724$export$243e62d78d3b544d).WARN) {
        const n = t.map($63c47e8a587a7f36$var$__PRIVATE_argToString);
        $63c47e8a587a7f36$var$D.warn(`Firestore (${$63c47e8a587a7f36$var$S}): ${e}`, ...n);
    }
}
/**
 * Converts an additional log parameter to a string representation.
 */ function $63c47e8a587a7f36$var$__PRIVATE_argToString(e) {
    if ("string" == typeof e) return e;
    try {
        return function __PRIVATE_formatJSON(e) {
            return JSON.stringify(e);
        }(e);
    } catch (t) {
        // Converting to JSON failed, just log the object directly
        return e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(e, t, n) {
    let r = "Unexpected state";
    "string" == typeof t ? r = t : n = t, $63c47e8a587a7f36$var$__PRIVATE__fail(e, r, n);
}
function $63c47e8a587a7f36$var$__PRIVATE__fail(e, t, n) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    let r = `FIRESTORE (${$63c47e8a587a7f36$var$S}) INTERNAL ASSERTION FAILED: ${t} (ID: ${e.toString(16)})`;
    if (void 0 !== n) try {
        r += " CONTEXT: " + JSON.stringify(n);
    } catch (e) {
        r += " CONTEXT: " + n;
    }
    // NOTE: We don't use FirestoreError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw $63c47e8a587a7f36$var$__PRIVATE_logError(r), new Error(r);
}
function $63c47e8a587a7f36$export$c18d01048907ea92(e, t, n, r) {
    let i = "Unexpected state";
    "string" == typeof n ? i = n : r = n, e || $63c47e8a587a7f36$var$__PRIVATE__fail(t, i, r);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * The code of callsites invoking this function are stripped out in production
 * builds. Any side-effects of code within the debugAssert() invocation will not
 * happen in this case.
 *
 * @internal
 */ function $63c47e8a587a7f36$export$53a70dd1ebbae346(e, t) {
    e || $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(57014, t);
}
/**
 * Casts `obj` to `T`. In non-production builds, verifies that `obj` is an
 * instance of `T` before casting.
 */ function $63c47e8a587a7f36$var$__PRIVATE_debugCast(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    return e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $63c47e8a587a7f36$export$e7094788287c5e9b = {
    // Causes are copied from:
    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
    /** Not an error; returned on success. */ OK: "ok",
    /** The operation was cancelled (typically by the caller). */ CANCELLED: "cancelled",
    /** Unknown error or an error from a different error domain. */ UNKNOWN: "unknown",
    /**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */ INVALID_ARGUMENT: "invalid-argument",
    /**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */ DEADLINE_EXCEEDED: "deadline-exceeded",
    /** Some requested entity (e.g., file or directory) was not found. */ NOT_FOUND: "not-found",
    /**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */ ALREADY_EXISTS: "already-exists",
    /**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller cannot be identified
     * (use UNAUTHENTICATED instead for those errors).
     */ PERMISSION_DENIED: "permission-denied",
    /**
     * The request does not have valid authentication credentials for the
     * operation.
     */ UNAUTHENTICATED: "unauthenticated",
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */ RESOURCE_EXHAUSTED: "resource-exhausted",
    /**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */ FAILED_PRECONDITION: "failed-precondition",
    /**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ ABORTED: "aborted",
    /**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */ OUT_OF_RANGE: "out-of-range",
    /** Operation is not implemented or not supported/enabled in this service. */ UNIMPLEMENTED: "unimplemented",
    /**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */ INTERNAL: "internal",
    /**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ UNAVAILABLE: "unavailable",
    /** Unrecoverable data loss or corruption. */ DATA_LOSS: "data-loss"
};
/** An error returned by a Firestore operation. */ class $63c47e8a587a7f36$export$4368d992c4eafac0 extends (0, $3117f6f4eeb4c314$export$dd24e9cd51226c56) {
    /** @hideconstructor */ constructor(/**
     * The backend error code associated with this error.
     */ e, /**
     * A custom error description.
     */ t){
        super(e, t), this.code = e, this.message = t, // HACK: We write a toString property directly because Error is not a real
        // class and so inheritance does not work correctly. We could alternatively
        // do the same "back-door inheritance" trick that FirebaseError does.
        this.toString = ()=>`${this.name}: [code=${this.code}]: ${this.message}`;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $63c47e8a587a7f36$var$__PRIVATE_Deferred {
    constructor(){
        this.promise = new Promise((e, t)=>{
            this.resolve = e, this.reject = t;
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $63c47e8a587a7f36$var$__PRIVATE_OAuthToken {
    constructor(e, t){
        this.user = t, this.type = "OAuth", this.headers = new Map, this.headers.set("Authorization", `Bearer ${e}`);
    }
}
/**
 * A CredentialsProvider that always yields an empty token.
 * @internal
 */ class $63c47e8a587a7f36$export$158acd800e1ef08b {
    getToken() {
        return Promise.resolve(null);
    }
    invalidateToken() {}
    start(e, t) {
        // Fire with initial user.
        e.enqueueRetryable(()=>t($63c47e8a587a7f36$var$User.UNAUTHENTICATED));
    }
    shutdown() {}
}
/**
 * A CredentialsProvider that always returns a constant token. Used for
 * emulator token mocking.
 */ class $63c47e8a587a7f36$var$__PRIVATE_EmulatorAuthCredentialsProvider {
    constructor(e){
        this.token = e, /**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */ this.changeListener = null;
    }
    getToken() {
        return Promise.resolve(this.token);
    }
    invalidateToken() {}
    start(e, t) {
        this.changeListener = t, // Fire with initial user.
        e.enqueueRetryable(()=>t(this.token.user));
    }
    shutdown() {
        this.changeListener = null;
    }
}
class $63c47e8a587a7f36$export$407448d2b89b1813 {
    constructor(e){
        this.t = e, /** Tracks the current User. */ this.currentUser = $63c47e8a587a7f36$var$User.UNAUTHENTICATED, /**
         * Counter used to detect if the token changed while a getToken request was
         * outstanding.
         */ this.i = 0, this.forceRefresh = !1, this.auth = null;
    }
    start(e, t) {
        $63c47e8a587a7f36$export$c18d01048907ea92(void 0 === this.o, 42304);
        let n = this.i;
        // A change listener that prevents double-firing for the same token change.
        const __PRIVATE_guardedChangeListener = (e)=>this.i !== n ? (n = this.i, t(e)) : Promise.resolve();
        // A promise that can be waited on to block on the next token change.
        // This promise is re-created after each change.
        let r = new $63c47e8a587a7f36$var$__PRIVATE_Deferred;
        this.o = ()=>{
            this.i++, this.currentUser = this.u(), r.resolve(), r = new $63c47e8a587a7f36$var$__PRIVATE_Deferred, e.enqueueRetryable(()=>__PRIVATE_guardedChangeListener(this.currentUser));
        };
        const __PRIVATE_awaitNextToken = ()=>{
            const t = r;
            e.enqueueRetryable(async ()=>{
                await t.promise, await __PRIVATE_guardedChangeListener(this.currentUser);
            });
        }, __PRIVATE_registerAuth = (e)=>{
            $63c47e8a587a7f36$export$21579262ef46735b("FirebaseAuthCredentialsProvider", "Auth detected"), this.auth = e, this.o && (this.auth.addAuthTokenListener(this.o), __PRIVATE_awaitNextToken());
        };
        this.t.onInit((e)=>__PRIVATE_registerAuth(e)), // Our users can initialize Auth right after Firestore, so we give it
        // a chance to register itself with the component framework before we
        // determine whether to start up in unauthenticated mode.
        setTimeout(()=>{
            if (!this.auth) {
                const e = this.t.getImmediate({
                    optional: !0
                });
                e ? __PRIVATE_registerAuth(e) : // If auth is still not available, proceed with `null` user
                ($63c47e8a587a7f36$export$21579262ef46735b("FirebaseAuthCredentialsProvider", "Auth not yet detected"), r.resolve(), r = new $63c47e8a587a7f36$var$__PRIVATE_Deferred);
            }
        }, 0), __PRIVATE_awaitNextToken();
    }
    getToken() {
        // Take note of the current value of the tokenCounter so that this method
        // can fail (with an ABORTED error) if there is a token change while the
        // request is outstanding.
        const e = this.i, t = this.forceRefresh;
        return this.forceRefresh = !1, this.auth ? this.auth.getToken(t).then((t)=>// Cancel the request since the token changed while the request was
            // outstanding so the response is potentially for a previous user (which
            // user, we can't be sure).
            this.i !== e ? ($63c47e8a587a7f36$export$21579262ef46735b("FirebaseAuthCredentialsProvider", "getToken aborted due to token change."), this.getToken()) : t ? ($63c47e8a587a7f36$export$c18d01048907ea92("string" == typeof t.accessToken, 31837, {
                l: t
            }), new $63c47e8a587a7f36$var$__PRIVATE_OAuthToken(t.accessToken, this.currentUser)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.auth && this.o && this.auth.removeAuthTokenListener(this.o), this.o = void 0;
    }
    // Auth.getUid() can return null even with a user logged in. It is because
    // getUid() is synchronous, but the auth code populating Uid is asynchronous.
    // This method should only be called in the AuthTokenListener callback
    // to guarantee to get the actual user.
    u() {
        const e = this.auth && this.auth.getUid();
        return $63c47e8a587a7f36$export$c18d01048907ea92(null === e || "string" == typeof e, 2055, {
            h: e
        }), new $63c47e8a587a7f36$var$User(e);
    }
}
/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * Technically this may no longer be necessary since the SDK should gracefully
 * recover from unauthenticated errors (see b/33147818 for context), but it's
 * safer to keep the implementation as-is.
 */ class $63c47e8a587a7f36$var$__PRIVATE_FirstPartyToken {
    constructor(e, t, n){
        this.P = e, this.T = t, this.I = n, this.type = "FirstParty", this.user = $63c47e8a587a7f36$var$User.FIRST_PARTY, this.R = new Map;
    }
    /**
     * Gets an authorization token, using a provided factory function, or return
     * null.
     */ A() {
        return this.I ? this.I() : null;
    }
    get headers() {
        this.R.set("X-Goog-AuthUser", this.P);
        // Use array notation to prevent minification
        const e = this.A();
        return e && this.R.set("Authorization", e), this.T && this.R.set("X-Goog-Iam-Authorization-Token", this.T), this.R;
    }
}
/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */ class $63c47e8a587a7f36$var$__PRIVATE_FirstPartyAuthCredentialsProvider {
    constructor(e, t, n){
        this.P = e, this.T = t, this.I = n;
    }
    getToken() {
        return Promise.resolve(new $63c47e8a587a7f36$var$__PRIVATE_FirstPartyToken(this.P, this.T, this.I));
    }
    start(e, t) {
        // Fire with initial uid.
        e.enqueueRetryable(()=>t($63c47e8a587a7f36$var$User.FIRST_PARTY));
    }
    shutdown() {}
    invalidateToken() {}
}
class $63c47e8a587a7f36$var$AppCheckToken {
    constructor(e){
        this.value = e, this.type = "AppCheck", this.headers = new Map, e && e.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
    }
}
class $63c47e8a587a7f36$export$8b22cf2602fb60ce {
    constructor(t, n){
        this.V = n, this.forceRefresh = !1, this.appCheck = null, this.m = null, this.p = null, (0, $0c1331d0a001f5bc$export$643c8bc6c389f34e)(t) && t.settings.appCheckToken && (this.p = t.settings.appCheckToken);
    }
    start(e, t) {
        $63c47e8a587a7f36$export$c18d01048907ea92(void 0 === this.o, 3512);
        const onTokenChanged = (e)=>{
            null != e.error && $63c47e8a587a7f36$export$21579262ef46735b("FirebaseAppCheckTokenProvider", `Error getting App Check token; using placeholder token instead. Error: ${e.error.message}`);
            const n = e.token !== this.m;
            return this.m = e.token, $63c47e8a587a7f36$export$21579262ef46735b("FirebaseAppCheckTokenProvider", `Received ${n ? "new" : "existing"} token.`), n ? t(e.token) : Promise.resolve();
        };
        this.o = (t)=>{
            e.enqueueRetryable(()=>onTokenChanged(t));
        };
        const __PRIVATE_registerAppCheck = (e)=>{
            $63c47e8a587a7f36$export$21579262ef46735b("FirebaseAppCheckTokenProvider", "AppCheck detected"), this.appCheck = e, this.o && this.appCheck.addTokenListener(this.o);
        };
        this.V.onInit((e)=>__PRIVATE_registerAppCheck(e)), // Our users can initialize AppCheck after Firestore, so we give it
        // a chance to register itself with the component framework.
        setTimeout(()=>{
            if (!this.appCheck) {
                const e = this.V.getImmediate({
                    optional: !0
                });
                e ? __PRIVATE_registerAppCheck(e) : // If AppCheck is still not available, proceed without it.
                $63c47e8a587a7f36$export$21579262ef46735b("FirebaseAppCheckTokenProvider", "AppCheck not yet detected");
            }
        }, 0);
    }
    getToken() {
        if (this.p) return Promise.resolve(new $63c47e8a587a7f36$var$AppCheckToken(this.p));
        const e = this.forceRefresh;
        return this.forceRefresh = !1, this.appCheck ? this.appCheck.getToken(e).then((e)=>e ? ($63c47e8a587a7f36$export$c18d01048907ea92("string" == typeof e.token, 44558, {
                tokenResult: e
            }), this.m = e.token, new $63c47e8a587a7f36$var$AppCheckToken(e.token)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.appCheck && this.o && this.appCheck.removeTokenListener(this.o), this.o = void 0;
    }
}
/**
 * An AppCheck token provider that always yields an empty token.
 * @internal
 */ class $63c47e8a587a7f36$export$24baa2b76016ce0e {
    getToken() {
        return Promise.resolve(new $63c47e8a587a7f36$var$AppCheckToken(""));
    }
    invalidateToken() {}
    start(e, t) {}
    shutdown() {}
}
/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Generates `nBytes` of random bytes.
 *
 * If `nBytes < 0` , an error will be thrown.
 */ function $63c47e8a587a7f36$var$__PRIVATE_randomBytes(e) {
    // Polyfills for IE and WebWorker by using `self` and `msCrypto` when `crypto` is not available.
    const t = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    "undefined" != typeof self && (self.crypto || self.msCrypto), n = new Uint8Array(e);
    if (t && "function" == typeof t.getRandomValues) t.getRandomValues(n);
    else // Falls back to Math.random
    for(let t = 0; t < e; t++)n[t] = Math.floor(256 * Math.random());
    return n;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A utility class for generating unique alphanumeric IDs of a specified length.
 *
 * @internal
 * Exported internally for testing purposes.
 */ class $63c47e8a587a7f36$export$a07804094c3ecf2d {
    static newId() {
        // Alphanumeric characters
        const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", t = 62 * Math.floor(256 / 62);
        // The largest byte value that is a multiple of `char.length`.
        let n = "";
        for(; n.length < 20;){
            const r = $63c47e8a587a7f36$var$__PRIVATE_randomBytes(40);
            for(let i = 0; i < r.length; ++i)// Only accept values that are [0, maxMultiple), this ensures they can
            // be evenly mapped to indices of `chars` via a modulo operation.
            n.length < 20 && r[i] < t && (n += e.charAt(r[i] % 62));
        }
        return n;
    }
}
function $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(e, t) {
    return e < t ? -1 : e > t ? 1 : 0;
}
/** Compare strings in UTF-8 encoded byte order */ function $63c47e8a587a7f36$var$__PRIVATE_compareUtf8Strings(e, t) {
    // Find the first differing character (a.k.a. "UTF-16 code unit") in the two strings and,
    // if found, use that character to determine the relative ordering of the two strings as a
    // whole. Comparing UTF-16 strings in UTF-8 byte order can be done simply and efficiently by
    // comparing the UTF-16 code units (chars). This serendipitously works because of the way UTF-8
    // and UTF-16 happen to represent Unicode code points.
    // After finding the first pair of differing characters, there are two cases:
    // Case 1: Both characters are non-surrogates (code points less than or equal to 0xFFFF) or
    // both are surrogates from a surrogate pair (that collectively represent code points greater
    // than 0xFFFF). In this case their numeric order as UTF-16 code units is the same as the
    // lexicographical order of their corresponding UTF-8 byte sequences. A direct comparison is
    // sufficient.
    // Case 2: One character is a surrogate and the other is not. In this case the surrogate-
    // containing string is always ordered after the non-surrogate. This is because surrogates are
    // used to represent code points greater than 0xFFFF which have 4-byte UTF-8 representations
    // and are lexicographically greater than the 1, 2, or 3-byte representations of code points
    // less than or equal to 0xFFFF.
    // An example of why Case 2 is required is comparing the following two Unicode code points:
    // |-----------------------|------------|---------------------|-----------------|
    // | Name                  | Code Point | UTF-8 Encoding      | UTF-16 Encoding |
    // |-----------------------|------------|---------------------|-----------------|
    // | Replacement Character | U+FFFD     | 0xEF 0xBF 0xBD      | 0xFFFD          |
    // | Grinning Face         | U+1F600    | 0xF0 0x9F 0x98 0x80 | 0xD83D 0xDE00   |
    // |-----------------------|------------|---------------------|-----------------|
    // A lexicographical comparison of the UTF-8 encodings of these code points would order
    // "Replacement Character" _before_ "Grinning Face" because 0xEF is less than 0xF0. However, a
    // direct comparison of the UTF-16 code units, as would be done in case 1, would erroneously
    // produce the _opposite_ ordering, because 0xFFFD is _greater than_ 0xD83D. As it turns out,
    // this relative ordering holds for all comparisons of UTF-16 code points requiring a surrogate
    // pair with those that do not.
    const n = Math.min(e.length, t.length);
    for(let r = 0; r < n; r++){
        const n = e.charAt(r), i = t.charAt(r);
        if (n !== i) return $63c47e8a587a7f36$var$__PRIVATE_isSurrogate(n) === $63c47e8a587a7f36$var$__PRIVATE_isSurrogate(i) ? $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(n, i) : $63c47e8a587a7f36$var$__PRIVATE_isSurrogate(n) ? 1 : -1;
    }
    // Use the lengths of the strings to determine the overall comparison result since either the
    // strings were equal or one is a prefix of the other.
    return $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(e.length, t.length);
}
const $63c47e8a587a7f36$var$v = 55296, $63c47e8a587a7f36$var$F = 57343;
function $63c47e8a587a7f36$var$__PRIVATE_isSurrogate(e) {
    const t = e.charCodeAt(0);
    return t >= $63c47e8a587a7f36$var$v && t <= $63c47e8a587a7f36$var$F;
}
/** Helper to compare arrays using isEqual(). */ function $63c47e8a587a7f36$var$__PRIVATE_arrayEquals(e, t, n) {
    return e.length === t.length && e.every((e, r)=>n(e, t[r]));
}
/**
 * Verifies equality for an optional value.
 */ function $63c47e8a587a7f36$export$7060da4b5db56fb9(e, t, n) {
    return void 0 === e && void 0 === t || void 0 !== e && void 0 !== t && n(e, t);
}
/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */ function $63c47e8a587a7f36$var$__PRIVATE_immediateSuccessor(e) {
    // Return the input string, with an additional NUL byte appended.
    return e + "\0";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $63c47e8a587a7f36$export$7a0bdf7d4a91ea88 = "__name__";
/**
 * Path represents an ordered sequence of string segments.
 */ class $63c47e8a587a7f36$var$BasePath {
    constructor(e, t, n){
        void 0 === t ? t = 0 : t > e.length && $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(637, {
            offset: t,
            range: e.length
        }), void 0 === n ? n = e.length - t : n > e.length - t && $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(1746, {
            length: n,
            range: e.length - t
        }), this.segments = e, this.offset = t, this.len = n;
    }
    get length() {
        return this.len;
    }
    isEqual(e) {
        return 0 === $63c47e8a587a7f36$var$BasePath.comparator(this, e);
    }
    child(e) {
        const t = this.segments.slice(this.offset, this.limit());
        return e instanceof $63c47e8a587a7f36$var$BasePath ? e.forEach((e)=>{
            t.push(e);
        }) : t.push(e), this.construct(t);
    }
    /** The index of one past the last segment of the path. */ limit() {
        return this.offset + this.length;
    }
    popFirst(e) {
        return e = void 0 === e ? 1 : e, this.construct(this.segments, this.offset + e, this.length - e);
    }
    popLast() {
        return this.construct(this.segments, this.offset, this.length - 1);
    }
    firstSegment() {
        return this.segments[this.offset];
    }
    lastSegment() {
        return this.get(this.length - 1);
    }
    get(e) {
        return this.segments[this.offset + e];
    }
    isEmpty() {
        return 0 === this.length;
    }
    isPrefixOf(e) {
        if (e.length < this.length) return !1;
        for(let t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return !1;
        return !0;
    }
    isImmediateParentOf(e) {
        if (this.length + 1 !== e.length) return !1;
        for(let t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return !1;
        return !0;
    }
    forEach(e) {
        for(let t = this.offset, n = this.limit(); t < n; t++)e(this.segments[t]);
    }
    toArray() {
        return this.segments.slice(this.offset, this.limit());
    }
    /**
     * Compare 2 paths segment by segment, prioritizing numeric IDs
     * (e.g., "__id123__") in numeric ascending order, followed by string
     * segments in lexicographical order.
     */ static comparator(e, t) {
        const n = Math.min(e.length, t.length);
        for(let r = 0; r < n; r++){
            const n = $63c47e8a587a7f36$var$BasePath.compareSegments(e.get(r), t.get(r));
            if (0 !== n) return n;
        }
        return $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(e.length, t.length);
    }
    static compareSegments(e, t) {
        const n = $63c47e8a587a7f36$var$BasePath.isNumericId(e), r = $63c47e8a587a7f36$var$BasePath.isNumericId(t);
        return n && !r ? -1 : !n && r ? 1 : n && r ? $63c47e8a587a7f36$var$BasePath.extractNumericId(e).compare($63c47e8a587a7f36$var$BasePath.extractNumericId(t)) : $63c47e8a587a7f36$var$__PRIVATE_compareUtf8Strings(e, t);
    }
    // Checks if a segment is a numeric ID (starts with "__id" and ends with "__").
    static isNumericId(e) {
        return e.startsWith("__id") && e.endsWith("__");
    }
    static extractNumericId(e) {
        return (0, $584ae1ea48b31d46$export$70ffa26850098d01).fromString(e.substring(4, e.length - 2));
    }
}
/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 *
 * @internal
 */ class $63c47e8a587a7f36$export$db202ddc8be9136 extends $63c47e8a587a7f36$var$BasePath {
    construct(e, t, n) {
        return new $63c47e8a587a7f36$export$db202ddc8be9136(e, t, n);
    }
    canonicalString() {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        return this.toArray().join("/");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns a string representation of this path
     * where each path segment has been encoded with
     * `encodeURIComponent`.
     */ toUriEncodedString() {
        return this.toArray().map(encodeURIComponent).join("/");
    }
    /**
     * Creates a resource path from the given slash-delimited string. If multiple
     * arguments are provided, all components are combined. Leading and trailing
     * slashes from all components are ignored.
     */ static fromString(...e) {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        const t = [];
        for (const n of e){
            if (n.indexOf("//") >= 0) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, `Invalid segment (${n}). Paths must not contain // in them.`);
            // Strip leading and trailing slashed.
            t.push(...n.split("/").filter((e)=>e.length > 0));
        }
        return new $63c47e8a587a7f36$export$db202ddc8be9136(t);
    }
    static emptyPath() {
        return new $63c47e8a587a7f36$export$db202ddc8be9136([]);
    }
}
const $63c47e8a587a7f36$var$x = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
/**
 * A dot-separated path for navigating sub-objects within a document.
 * @internal
 */ class $63c47e8a587a7f36$export$cf2f7c5792f80b46 extends $63c47e8a587a7f36$var$BasePath {
    construct(e, t, n) {
        return new $63c47e8a587a7f36$export$cf2f7c5792f80b46(e, t, n);
    }
    /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */ static isValidIdentifier(e) {
        return $63c47e8a587a7f36$var$x.test(e);
    }
    canonicalString() {
        return this.toArray().map((e)=>(e = e.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), $63c47e8a587a7f36$export$cf2f7c5792f80b46.isValidIdentifier(e) || (e = "`" + e + "`"), e)).join(".");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns true if this field references the key of a document.
     */ isKeyField() {
        return 1 === this.length && this.get(0) === $63c47e8a587a7f36$export$7a0bdf7d4a91ea88;
    }
    /**
     * The field designating the key of a document.
     */ static keyField() {
        return new $63c47e8a587a7f36$export$cf2f7c5792f80b46([
            $63c47e8a587a7f36$export$7a0bdf7d4a91ea88
        ]);
    }
    /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */ static fromServerFormat(e) {
        const t = [];
        let n = "", r = 0;
        const __PRIVATE_addCurrentSegment = ()=>{
            if (0 === n.length) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, `Invalid field path (${e}). Paths must not be empty, begin with '.', end with '.', or contain '..'`);
            t.push(n), n = "";
        };
        let i = !1;
        for(; r < e.length;){
            const t = e[r];
            if ("\\" === t) {
                if (r + 1 === e.length) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, "Path has trailing escape character: " + e);
                const t = e[r + 1];
                if ("\\" !== t && "." !== t && "`" !== t) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, "Path has invalid escape sequence: " + e);
                n += t, r += 2;
            } else "`" === t ? (i = !i, r++) : "." !== t || i ? (n += t, r++) : (__PRIVATE_addCurrentSegment(), r++);
        }
        if (__PRIVATE_addCurrentSegment(), i) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, "Unterminated ` in path: " + e);
        return new $63c47e8a587a7f36$export$cf2f7c5792f80b46(t);
    }
    static emptyPath() {
        return new $63c47e8a587a7f36$export$cf2f7c5792f80b46([]);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ class $63c47e8a587a7f36$export$90a7f3efeed30595 {
    constructor(e){
        this.path = e;
    }
    static fromPath(e) {
        return new $63c47e8a587a7f36$export$90a7f3efeed30595($63c47e8a587a7f36$export$db202ddc8be9136.fromString(e));
    }
    static fromName(e) {
        return new $63c47e8a587a7f36$export$90a7f3efeed30595($63c47e8a587a7f36$export$db202ddc8be9136.fromString(e).popFirst(5));
    }
    static empty() {
        return new $63c47e8a587a7f36$export$90a7f3efeed30595($63c47e8a587a7f36$export$db202ddc8be9136.emptyPath());
    }
    get collectionGroup() {
        return this.path.popLast().lastSegment();
    }
    /** Returns true if the document is in the specified collectionId. */ hasCollectionId(e) {
        return this.path.length >= 2 && this.path.get(this.path.length - 2) === e;
    }
    /** Returns the collection group (i.e. the name of the parent collection) for this key. */ getCollectionGroup() {
        return this.path.get(this.path.length - 2);
    }
    /** Returns the fully qualified path to the parent collection. */ getCollectionPath() {
        return this.path.popLast();
    }
    isEqual(e) {
        return null !== e && 0 === $63c47e8a587a7f36$export$db202ddc8be9136.comparator(this.path, e.path);
    }
    toString() {
        return this.path.toString();
    }
    static comparator(e, t) {
        return $63c47e8a587a7f36$export$db202ddc8be9136.comparator(e.path, t.path);
    }
    static isDocumentKey(e) {
        return e.length % 2 == 0;
    }
    /**
     * Creates and returns a new document key with the given segments.
     *
     * @param segments - The segments of the path to the document
     * @returns A new instance of DocumentKey
     */ static fromSegments(e) {
        return new $63c47e8a587a7f36$export$90a7f3efeed30595(new $63c47e8a587a7f36$export$db202ddc8be9136(e.slice()));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $63c47e8a587a7f36$var$__PRIVATE_validateNonEmptyArgument(e, t, n) {
    if (!n) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, `Function ${e}() cannot be called with an empty ${t}.`);
}
/**
 * Validates that two boolean options are not set at the same time.
 * @internal
 */ function $63c47e8a587a7f36$export$23ebac1979863676(e, t, n, r) {
    if (!0 === t && !0 === r) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, `${e} and ${n} cannot be used together.`);
}
/**
 * Validates that `path` refers to a document (indicated by the fact it contains
 * an even numbers of segments).
 */ function $63c47e8a587a7f36$var$__PRIVATE_validateDocumentPath(e) {
    if (!$63c47e8a587a7f36$export$90a7f3efeed30595.isDocumentKey(e)) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, `Invalid document reference. Document references must have an even number of segments, but ${e} has ${e.length}.`);
}
/**
 * Validates that `path` refers to a collection (indicated by the fact it
 * contains an odd numbers of segments).
 */ function $63c47e8a587a7f36$var$__PRIVATE_validateCollectionPath(e) {
    if ($63c47e8a587a7f36$export$90a7f3efeed30595.isDocumentKey(e)) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, `Invalid collection reference. Collection references must have an odd number of segments, but ${e} has ${e.length}.`);
}
/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */ function $63c47e8a587a7f36$export$7f557e5eb95176c2(e) {
    return "object" == typeof e && null !== e && (Object.getPrototypeOf(e) === Object.prototype || null === Object.getPrototypeOf(e));
}
/** Returns a string describing the type / value of the provided input. */ function $63c47e8a587a7f36$export$efccba1c4a2ef57b(e) {
    if (void 0 === e) return "undefined";
    if (null === e) return "null";
    if ("string" == typeof e) return e.length > 20 && (e = `${e.substring(0, 20)}...`), JSON.stringify(e);
    if ("number" == typeof e || "boolean" == typeof e) return "" + e;
    if ("object" == typeof e) {
        if (e instanceof Array) return "an array";
        {
            const t = /** try to get the constructor name for an object. */ function __PRIVATE_tryGetCustomObjectType(e) {
                if (e.constructor) return e.constructor.name;
                return null;
            }(e);
            return t ? `a custom ${t} object` : "an object";
        }
    }
    return "function" == typeof e ? "a function" : $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(12329, {
        type: typeof e
    });
}
function $63c47e8a587a7f36$export$4a5767248b18ef41(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    if ("_delegate" in e && // Unwrap Compat types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e = e._delegate), !(e instanceof t)) {
        if (t.name === e.constructor.name) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
        {
            const n = $63c47e8a587a7f36$export$efccba1c4a2ef57b(e);
            throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, `Expected type '${t.name}', but it was: ${n}`);
        }
    }
    return e;
}
function $63c47e8a587a7f36$export$953cecd6e717a553(e, t) {
    if (t <= 0) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, `Function ${e}() requires a positive number, but it was: ${t}.`);
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper function to define a JSON schema {@link Property}.
 * @private
 * @internal
 */ function $63c47e8a587a7f36$export$ffb5f4729a158638(e, t) {
    const n = {
        typeString: e
    };
    return t && (n.value = t), n;
}
/**
 * Validates the JSON object based on the provided schema, and narrows the type to the provided
 * JSON schema.
 * @private
 * @internal
 *
 * @param json - A JSON object to validate.
 * @param scheme - a {@link JsonSchema} that defines the properties to validate.
 * @returns true if the JSON schema exists within the object. Throws a FirestoreError otherwise.
 */ function $63c47e8a587a7f36$export$9bb611d729802a56(e, t) {
    if (!$63c47e8a587a7f36$export$7f557e5eb95176c2(e)) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, "JSON must be an object");
    let n;
    for(const r in t)if (t[r]) {
        const i = t[r].typeString, s = "value" in t[r] ? {
            value: t[r].value
        } : void 0;
        if (!(r in e)) {
            n = `JSON missing required field: '${r}'`;
            break;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const o = e[r];
        if (i && typeof o !== i) {
            n = `JSON field '${r}' must be a ${i}.`;
            break;
        }
        if (void 0 !== s && o !== s.value) {
            n = `Expected '${r}' field to equal '${s.value}'`;
            break;
        }
    }
    if (n) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, n);
    return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The earliest date supported by Firestore timestamps (0001-01-01T00:00:00Z).
const $63c47e8a587a7f36$var$O = -62135596800, $63c47e8a587a7f36$var$N = 1e6;
// Number of nanoseconds in a millisecond.
/**
 * A `Timestamp` represents a point in time independent of any time zone or
 * calendar, represented as seconds and fractions of seconds at nanosecond
 * resolution in UTC Epoch time.
 *
 * It is encoded using the Proleptic Gregorian Calendar which extends the
 * Gregorian calendar backwards to year one. It is encoded assuming all minutes
 * are 60 seconds long, i.e. leap seconds are "smeared" so that no leap second
 * table is needed for interpretation. Range is from 0001-01-01T00:00:00Z to
 * 9999-12-31T23:59:59.999999999Z.
 *
 * For examples and further specifications, refer to the
 * {@link https://github.com/google/protobuf/blob/master/src/google/protobuf/timestamp.proto | Timestamp definition}.
 */ class $63c47e8a587a7f36$export$3d12bd131bb975d1 {
    /**
     * Creates a new timestamp with the current date, with millisecond precision.
     *
     * @returns a new timestamp representing the current date.
     */ static now() {
        return $63c47e8a587a7f36$export$3d12bd131bb975d1.fromMillis(Date.now());
    }
    /**
     * Creates a new timestamp from the given date.
     *
     * @param date - The date to initialize the `Timestamp` from.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     date.
     */ static fromDate(e) {
        return $63c47e8a587a7f36$export$3d12bd131bb975d1.fromMillis(e.getTime());
    }
    /**
     * Creates a new timestamp from the given number of milliseconds.
     *
     * @param milliseconds - Number of milliseconds since Unix epoch
     *     1970-01-01T00:00:00Z.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     number of milliseconds.
     */ static fromMillis(e) {
        const t = Math.floor(e / 1e3), n = Math.floor((e - 1e3 * t) * $63c47e8a587a7f36$var$N);
        return new $63c47e8a587a7f36$export$3d12bd131bb975d1(t, n);
    }
    /**
     * Creates a new timestamp.
     *
     * @param seconds - The number of seconds of UTC time since Unix epoch
     *     1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
     *     9999-12-31T23:59:59Z inclusive.
     * @param nanoseconds - The non-negative fractions of a second at nanosecond
     *     resolution. Negative second values with fractions must still have
     *     non-negative nanoseconds values that count forward in time. Must be
     *     from 0 to 999,999,999 inclusive.
     */ constructor(/**
     * The number of seconds of UTC time since Unix epoch 1970-01-01T00:00:00Z.
     */ e, /**
     * The fractions of a second at nanosecond resolution.*
     */ t){
        if (this.seconds = e, this.nanoseconds = t, t < 0) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (t >= 1e9) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (e < $63c47e8a587a7f36$var$O) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
        // This will break in the year 10,000.
        if (e >= 253402300800) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
    }
    /**
     * Converts a `Timestamp` to a JavaScript `Date` object. This conversion
     * causes a loss of precision since `Date` objects only support millisecond
     * precision.
     *
     * @returns JavaScript `Date` object representing the same point in time as
     *     this `Timestamp`, with millisecond precision.
     */ toDate() {
        return new Date(this.toMillis());
    }
    /**
     * Converts a `Timestamp` to a numeric timestamp (in milliseconds since
     * epoch). This operation causes a loss of precision.
     *
     * @returns The point in time corresponding to this timestamp, represented as
     *     the number of milliseconds since Unix epoch 1970-01-01T00:00:00Z.
     */ toMillis() {
        return 1e3 * this.seconds + this.nanoseconds / $63c47e8a587a7f36$var$N;
    }
    _compareTo(e) {
        return this.seconds === e.seconds ? $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(this.nanoseconds, e.nanoseconds) : $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(this.seconds, e.seconds);
    }
    /**
     * Returns true if this `Timestamp` is equal to the provided one.
     *
     * @param other - The `Timestamp` to compare against.
     * @returns true if this `Timestamp` is equal to the provided one.
     */ isEqual(e) {
        return e.seconds === this.seconds && e.nanoseconds === this.nanoseconds;
    }
    /** Returns a textual representation of this `Timestamp`. */ toString() {
        return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
    }
    /**
     * Returns a JSON-serializable representation of this `Timestamp`.
     */ toJSON() {
        return {
            type: $63c47e8a587a7f36$export$3d12bd131bb975d1._jsonSchemaVersion,
            seconds: this.seconds,
            nanoseconds: this.nanoseconds
        };
    }
    /**
     * Builds a `Timestamp` instance from a JSON object created by {@link Timestamp.toJSON}.
     */ static fromJSON(e) {
        if ($63c47e8a587a7f36$export$9bb611d729802a56(e, $63c47e8a587a7f36$export$3d12bd131bb975d1._jsonSchema)) return new $63c47e8a587a7f36$export$3d12bd131bb975d1(e.seconds, e.nanoseconds);
    }
    /**
     * Converts this object to a primitive string, which allows `Timestamp` objects
     * to be compared using the `>`, `<=`, `>=` and `>` operators.
     */ valueOf() {
        // This method returns a string of the form <seconds>.<nanoseconds> where
        // <seconds> is translated to have a non-negative value and both <seconds>
        // and <nanoseconds> are left-padded with zeroes to be a consistent length.
        // Strings with this format then have a lexicographical ordering that matches
        // the expected ordering. The <seconds> translation is done to avoid having
        // a leading negative sign (i.e. a leading '-' character) in its string
        // representation, which would affect its lexicographical ordering.
        const e = this.seconds - $63c47e8a587a7f36$var$O;
        // Note: Up to 12 decimal digits are required to represent all valid
        // 'seconds' values.
        return String(e).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
    }
}
$63c47e8a587a7f36$export$3d12bd131bb975d1._jsonSchemaVersion = "firestore/timestamp/1.0", $63c47e8a587a7f36$export$3d12bd131bb975d1._jsonSchema = {
    type: $63c47e8a587a7f36$export$ffb5f4729a158638("string", $63c47e8a587a7f36$export$3d12bd131bb975d1._jsonSchemaVersion),
    seconds: $63c47e8a587a7f36$export$ffb5f4729a158638("number"),
    nanoseconds: $63c47e8a587a7f36$export$ffb5f4729a158638("number")
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */ class $63c47e8a587a7f36$var$SnapshotVersion {
    static fromTimestamp(e) {
        return new $63c47e8a587a7f36$var$SnapshotVersion(e);
    }
    static min() {
        return new $63c47e8a587a7f36$var$SnapshotVersion(new $63c47e8a587a7f36$export$3d12bd131bb975d1(0, 0));
    }
    static max() {
        return new $63c47e8a587a7f36$var$SnapshotVersion(new $63c47e8a587a7f36$export$3d12bd131bb975d1(253402300799, 999999999));
    }
    constructor(e){
        this.timestamp = e;
    }
    compareTo(e) {
        return this.timestamp._compareTo(e.timestamp);
    }
    isEqual(e) {
        return this.timestamp.isEqual(e.timestamp);
    }
    /** Returns a number representation of the version for use in spec tests. */ toMicroseconds() {
        // Convert to microseconds.
        return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
    }
    toString() {
        return "SnapshotVersion(" + this.timestamp.toString() + ")";
    }
    toTimestamp() {
        return this.timestamp;
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The initial mutation batch id for each index. Gets updated during index
 * backfill.
 */ const $63c47e8a587a7f36$var$B = -1;
/**
 * The initial sequence number for each index. Gets updated during index
 * backfill.
 */ /**
 * An index definition for field indexes in Firestore.
 *
 * Every index is associated with a collection. The definition contains a list
 * of fields and their index kind (which can be `ASCENDING`, `DESCENDING` or
 * `CONTAINS` for ArrayContains/ArrayContainsAny queries).
 *
 * Unlike the backend, the SDK does not differentiate between collection or
 * collection group-scoped indices. Every index can be used for both single
 * collection and collection group queries.
 */ class $63c47e8a587a7f36$export$ee7c8ad385a60b7b {
    constructor(/**
     * The index ID. Returns -1 if the index ID is not available (e.g. the index
     * has not yet been persisted).
     */ e, /** The collection ID this index applies to. */ t, /** The field segments for this index. */ n, /** Shows how up-to-date the index is for the current user. */ r){
        this.indexId = e, this.collectionGroup = t, this.fields = n, this.indexState = r;
    }
}
/** An ID for an index that has not yet been added to persistence.  */ /** Returns the ArrayContains/ArrayContainsAny segment for this index. */ function $63c47e8a587a7f36$var$__PRIVATE_fieldIndexGetArraySegment(e) {
    return e.fields.find((e)=>2 /* IndexKind.CONTAINS */  === e.kind);
}
/** Returns all directional (ascending/descending) segments for this index. */ function $63c47e8a587a7f36$var$__PRIVATE_fieldIndexGetDirectionalSegments(e) {
    return e.fields.filter((e)=>2 /* IndexKind.CONTAINS */  !== e.kind);
}
/**
 * Returns the order of the document key component for the given index.
 *
 * PORTING NOTE: This is only used in the Web IndexedDb implementation.
 */ /**
 * Compares indexes by collection group and segments. Ignores update time and
 * index ID.
 */ function $63c47e8a587a7f36$var$__PRIVATE_fieldIndexSemanticComparator(e, t) {
    let n = $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
    if (0 !== n) return n;
    for(let r = 0; r < Math.min(e.fields.length, t.fields.length); ++r)if (n = $63c47e8a587a7f36$var$__PRIVATE_indexSegmentComparator(e.fields[r], t.fields[r]), 0 !== n) return n;
    return $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(e.fields.length, t.fields.length);
}
/** Returns a debug representation of the field index */ $63c47e8a587a7f36$export$ee7c8ad385a60b7b.UNKNOWN_ID = -1;
/** An index component consisting of field path and index type.  */ class $63c47e8a587a7f36$export$c9170ad7d4cd7e57 {
    constructor(/** The field path of the component. */ e, /** The fields sorting order. */ t){
        this.fieldPath = e, this.kind = t;
    }
}
function $63c47e8a587a7f36$var$__PRIVATE_indexSegmentComparator(e, t) {
    const n = $63c47e8a587a7f36$export$cf2f7c5792f80b46.comparator(e.fieldPath, t.fieldPath);
    return 0 !== n ? n : $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(e.kind, t.kind);
}
/**
 * Stores the "high water mark" that indicates how updated the Index is for the
 * current user.
 */ class $63c47e8a587a7f36$export$995eb9fca571757 {
    constructor(/**
     * Indicates when the index was last updated (relative to other indexes).
     */ e, /** The the latest indexed read time, document and batch id. */ t){
        this.sequenceNumber = e, this.offset = t;
    }
    /** The state of an index that has not yet been backfilled. */ static empty() {
        return new $63c47e8a587a7f36$export$995eb9fca571757(0, $63c47e8a587a7f36$var$IndexOffset.min());
    }
}
/**
 * Creates an offset that matches all documents with a read time higher than
 * `readTime`.
 */ function $63c47e8a587a7f36$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(e, t) {
    // We want to create an offset that matches all documents with a read time
    // greater than the provided read time. To do so, we technically need to
    // create an offset for `(readTime, MAX_DOCUMENT_KEY)`. While we could use
    // Unicode codepoints to generate MAX_DOCUMENT_KEY, it is much easier to use
    // `(readTime + 1, DocumentKey.empty())` since `> DocumentKey.empty()` matches
    // all valid document IDs.
    const n = e.toTimestamp().seconds, r = e.toTimestamp().nanoseconds + 1, i = $63c47e8a587a7f36$var$SnapshotVersion.fromTimestamp(1e9 === r ? new $63c47e8a587a7f36$export$3d12bd131bb975d1(n + 1, 0) : new $63c47e8a587a7f36$export$3d12bd131bb975d1(n, r));
    return new $63c47e8a587a7f36$var$IndexOffset(i, $63c47e8a587a7f36$export$90a7f3efeed30595.empty(), t);
}
/** Creates a new offset based on the provided document. */ function $63c47e8a587a7f36$var$__PRIVATE_newIndexOffsetFromDocument(e) {
    return new $63c47e8a587a7f36$var$IndexOffset(e.readTime, e.key, $63c47e8a587a7f36$var$B);
}
/**
 * Stores the latest read time, document and batch ID that were processed for an
 * index.
 */ class $63c47e8a587a7f36$var$IndexOffset {
    constructor(/**
     * The latest read time version that has been indexed by Firestore for this
     * field index.
     */ e, /**
     * The key of the last document that was indexed for this query. Use
     * `DocumentKey.empty()` if no document has been indexed.
     */ t, /*
     * The largest mutation batch id that's been processed by Firestore.
     */ n){
        this.readTime = e, this.documentKey = t, this.largestBatchId = n;
    }
    /** Returns an offset that sorts before all regular offsets. */ static min() {
        return new $63c47e8a587a7f36$var$IndexOffset($63c47e8a587a7f36$var$SnapshotVersion.min(), $63c47e8a587a7f36$export$90a7f3efeed30595.empty(), $63c47e8a587a7f36$var$B);
    }
    /** Returns an offset that sorts after all regular offsets. */ static max() {
        return new $63c47e8a587a7f36$var$IndexOffset($63c47e8a587a7f36$var$SnapshotVersion.max(), $63c47e8a587a7f36$export$90a7f3efeed30595.empty(), $63c47e8a587a7f36$var$B);
    }
}
function $63c47e8a587a7f36$var$__PRIVATE_indexOffsetComparator(e, t) {
    let n = e.readTime.compareTo(t.readTime);
    return 0 !== n ? n : (n = $63c47e8a587a7f36$export$90a7f3efeed30595.comparator(e.documentKey, t.documentKey), 0 !== n ? n : $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(e.largestBatchId, t.largestBatchId));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $63c47e8a587a7f36$var$L = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.";
/**
 * A base class representing a persistence transaction, encapsulating both the
 * transaction's sequence numbers as well as a list of onCommitted listeners.
 *
 * When you call Persistence.runTransaction(), it will create a transaction and
 * pass it to your callback. You then pass it to any method that operates
 * on persistence.
 */ class $63c47e8a587a7f36$var$PersistenceTransaction {
    constructor(){
        this.onCommittedListeners = [];
    }
    addOnCommittedListener(e) {
        this.onCommittedListeners.push(e);
    }
    raiseOnCommittedEvent() {
        this.onCommittedListeners.forEach((e)=>e());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err - An error returned by a LocalStore operation.
 * @returns A Promise that resolves after we recovered, or the original error.
 */ async function $63c47e8a587a7f36$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e) {
    if (e.code !== $63c47e8a587a7f36$export$e7094788287c5e9b.FAILED_PRECONDITION || e.message !== $63c47e8a587a7f36$var$L) throw e;
    $63c47e8a587a7f36$export$21579262ef46735b("LocalStore", "Unexpectedly lost primary lease");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * PersistencePromise is essentially a re-implementation of Promise except
 * it has a .next() method instead of .then() and .next() and .catch() callbacks
 * are executed synchronously when a PersistencePromise resolves rather than
 * asynchronously (Promise implementations use setImmediate() or similar).
 *
 * This is necessary to interoperate with IndexedDB which will automatically
 * commit transactions if control is returned to the event loop without
 * synchronously initiating another operation on the transaction.
 *
 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
 * Promises.
 */ class $63c47e8a587a7f36$var$PersistencePromise {
    constructor(e){
        // NOTE: next/catchCallback will always point to our own wrapper functions,
        // not the user's raw next() or catch() callbacks.
        this.nextCallback = null, this.catchCallback = null, // When the operation resolves, we'll set result or error and mark isDone.
        this.result = void 0, this.error = void 0, this.isDone = !1, // Set to true when .then() or .catch() are called and prevents additional
        // chaining.
        this.callbackAttached = !1, e((e)=>{
            this.isDone = !0, this.result = e, this.nextCallback && // value should be defined unless T is Void, but we can't express
            // that in the type system.
            this.nextCallback(e);
        }, (e)=>{
            this.isDone = !0, this.error = e, this.catchCallback && this.catchCallback(e);
        });
    }
    catch(e) {
        return this.next(void 0, e);
    }
    next(e, t) {
        return this.callbackAttached && $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(59440), this.callbackAttached = !0, this.isDone ? this.error ? this.wrapFailure(t, this.error) : this.wrapSuccess(e, this.result) : new $63c47e8a587a7f36$var$PersistencePromise((n, r)=>{
            this.nextCallback = (t)=>{
                this.wrapSuccess(e, t).next(n, r);
            }, this.catchCallback = (e)=>{
                this.wrapFailure(t, e).next(n, r);
            };
        });
    }
    toPromise() {
        return new Promise((e, t)=>{
            this.next(e, t);
        });
    }
    wrapUserFunction(e) {
        try {
            const t = e();
            return t instanceof $63c47e8a587a7f36$var$PersistencePromise ? t : $63c47e8a587a7f36$var$PersistencePromise.resolve(t);
        } catch (e) {
            return $63c47e8a587a7f36$var$PersistencePromise.reject(e);
        }
    }
    wrapSuccess(e, t) {
        return e ? this.wrapUserFunction(()=>e(t)) : $63c47e8a587a7f36$var$PersistencePromise.resolve(t);
    }
    wrapFailure(e, t) {
        return e ? this.wrapUserFunction(()=>e(t)) : $63c47e8a587a7f36$var$PersistencePromise.reject(t);
    }
    static resolve(e) {
        return new $63c47e8a587a7f36$var$PersistencePromise((t, n)=>{
            t(e);
        });
    }
    static reject(e) {
        return new $63c47e8a587a7f36$var$PersistencePromise((t, n)=>{
            n(e);
        });
    }
    static waitFor(// Accept all Promise types in waitFor().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e) {
        return new $63c47e8a587a7f36$var$PersistencePromise((t, n)=>{
            let r = 0, i = 0, s = !1;
            e.forEach((e)=>{
                ++r, e.next(()=>{
                    ++i, s && i === r && t();
                }, (e)=>n(e));
            }), s = !0, i === r && t();
        });
    }
    /**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */ static or(e) {
        let t = $63c47e8a587a7f36$var$PersistencePromise.resolve(!1);
        for (const n of e)t = t.next((e)=>e ? $63c47e8a587a7f36$var$PersistencePromise.resolve(e) : n());
        return t;
    }
    static forEach(e, t) {
        const n = [];
        return e.forEach((e, r)=>{
            n.push(t.call(this, e, r));
        }), this.waitFor(n);
    }
    /**
     * Concurrently map all array elements through asynchronous function.
     */ static mapArray(e, t) {
        return new $63c47e8a587a7f36$var$PersistencePromise((n, r)=>{
            const i = e.length, s = new Array(i);
            let o = 0;
            for(let _ = 0; _ < i; _++){
                const a = _;
                t(e[a]).next((e)=>{
                    s[a] = e, ++o, o === i && n(s);
                }, (e)=>r(e));
            }
        });
    }
    /**
     * An alternative to recursive PersistencePromise calls, that avoids
     * potential memory problems from unbounded chains of promises.
     *
     * The `action` will be called repeatedly while `condition` is true.
     */ static doWhile(e, t) {
        return new $63c47e8a587a7f36$var$PersistencePromise((n, r)=>{
            const process = ()=>{
                !0 === e() ? t().next(()=>{
                    process();
                }, r) : n();
            };
            process();
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `indexedDB` are guarded by SimpleDb.isAvailable() and getGlobal()
/* eslint-disable no-restricted-globals */ const $63c47e8a587a7f36$var$k = "SimpleDb";
/**
 * The maximum number of retry attempts for an IndexedDb transaction that fails
 * with a DOMException.
 */ /**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */ class $63c47e8a587a7f36$var$__PRIVATE_SimpleDbTransaction {
    static open(e, t, n, r) {
        try {
            return new $63c47e8a587a7f36$var$__PRIVATE_SimpleDbTransaction(t, e.transaction(r, n));
        } catch (e) {
            throw new $63c47e8a587a7f36$var$__PRIVATE_IndexedDbTransactionError(t, e);
        }
    }
    constructor(e, t){
        this.action = e, this.transaction = t, this.aborted = !1, /**
         * A `Promise` that resolves with the result of the IndexedDb transaction.
         */ this.S = new $63c47e8a587a7f36$var$__PRIVATE_Deferred, this.transaction.oncomplete = ()=>{
            this.S.resolve();
        }, this.transaction.onabort = ()=>{
            t.error ? this.S.reject(new $63c47e8a587a7f36$var$__PRIVATE_IndexedDbTransactionError(e, t.error)) : this.S.resolve();
        }, this.transaction.onerror = (t)=>{
            const n = $63c47e8a587a7f36$var$__PRIVATE_checkForAndReportiOSError(t.target.error);
            this.S.reject(new $63c47e8a587a7f36$var$__PRIVATE_IndexedDbTransactionError(e, n));
        };
    }
    get D() {
        return this.S.promise;
    }
    abort(e) {
        e && this.S.reject(e), this.aborted || ($63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$k, "Aborting transaction:", e ? e.message : "Client-initiated abort"), this.aborted = !0, this.transaction.abort());
    }
    C() {
        // If the browser supports V3 IndexedDB, we invoke commit() explicitly to
        // speed up index DB processing if the event loop remains blocks.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const e = this.transaction;
        this.aborted || "function" != typeof e.commit || e.commit();
    }
    /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */ store(e) {
        const t = this.transaction.objectStore(e);
        return new $63c47e8a587a7f36$var$__PRIVATE_SimpleDbStore(t);
    }
}
/**
 * Provides a wrapper around IndexedDb with a simplified interface that uses
 * Promise-like return values to chain operations. Real promises cannot be used
 * since .then() continuations are executed asynchronously (e.g. via
 * .setImmediate), which would cause IndexedDB to end the transaction.
 * See PersistencePromise for more details.
 */ class $63c47e8a587a7f36$var$__PRIVATE_SimpleDb {
    /** Deletes the specified database. */ static delete(e) {
        $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$k, "Removing database:", e);
        return $63c47e8a587a7f36$var$__PRIVATE_wrapRequest((0, $3117f6f4eeb4c314$export$a4e55266d2135a7f)().indexedDB.deleteDatabase(e)).toPromise();
    }
    /** Returns true if IndexedDB is available in the current environment. */ static v() {
        if (!(0, $3117f6f4eeb4c314$export$3865db50535c2055)()) return !1;
        if ($63c47e8a587a7f36$var$__PRIVATE_SimpleDb.F()) return !0;
        // We extensively use indexed array values and compound keys,
        // which IE and Edge do not support. However, they still have indexedDB
        // defined on the window, so we need to check for them here and make sure
        // to return that persistence is not enabled for those browsers.
        // For tracking support of this feature, see here:
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
        // Check the UA string to find out the browser.
        const e = (0, $3117f6f4eeb4c314$export$c36915b22ce77c19)(), t = $63c47e8a587a7f36$var$__PRIVATE_SimpleDb.M(e), n = 0 < t && t < 10, r = $63c47e8a587a7f36$var$__PRIVATE_getAndroidVersion(e), i = 0 < r && r < 4.5;
        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        // Edge
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        // iOS Safari: Disable for users running iOS version < 10.
        return !(e.indexOf("MSIE ") > 0 || e.indexOf("Trident/") > 0 || e.indexOf("Edge/") > 0 || n || i);
    }
    /**
     * Returns true if the backing IndexedDB store is the Node IndexedDBShim
     * (see https://github.com/axemclion/IndexedDBShim).
     */ static F() {
        return false;
    }
    /** Helper to get a typed SimpleDbStore from a transaction. */ static O(e, t) {
        return e.store(t);
    }
    // visible for testing
    /** Parse User Agent to determine iOS version. Returns -1 if not found. */ static M(e) {
        const t = e.match(/i(?:phone|pad|pod) os ([\d_]+)/i), n = t ? t[1].split("_").slice(0, 2).join(".") : "-1";
        return Number(n);
    }
    /*
     * Creates a new SimpleDb wrapper for IndexedDb database `name`.
     *
     * Note that `version` must not be a downgrade. IndexedDB does not support
     * downgrading the schema version. We currently do not support any way to do
     * versioning outside of IndexedDB's versioning mechanism, as only
     * version-upgrade transactions are allowed to do things like create
     * objectstores.
     */ constructor(e, t, n){
        this.name = e, this.version = t, this.N = n, this.B = null;
        // NOTE: According to https://bugs.webkit.org/show_bug.cgi?id=197050, the
        // bug we're checking for should exist in iOS >= 12.2 and < 13, but for
        // whatever reason it's much harder to hit after 12.2 so we only proactively
        // log on 12.2.
        12.2 === $63c47e8a587a7f36$var$__PRIVATE_SimpleDb.M((0, $3117f6f4eeb4c314$export$c36915b22ce77c19)()) && $63c47e8a587a7f36$var$__PRIVATE_logError("Firestore persistence suffers from a bug in iOS 12.2 Safari that may cause your app to stop working. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
    }
    /**
     * Opens the specified database, creating or upgrading it if necessary.
     */ async L(e) {
        return this.db || ($63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$k, "Opening database:", this.name), this.db = await new Promise((t, n)=>{
            // TODO(mikelehen): Investigate browser compatibility.
            // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
            // suggests IE9 and older WebKit browsers handle upgrade
            // differently. They expect setVersion, as described here:
            // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
            const r = indexedDB.open(this.name, this.version);
            r.onsuccess = (e)=>{
                const n = e.target.result;
                t(n);
            }, r.onblocked = ()=>{
                n(new $63c47e8a587a7f36$var$__PRIVATE_IndexedDbTransactionError(e, "Cannot upgrade IndexedDB schema while another tab is open. Close all tabs that access Firestore and reload this page to proceed."));
            }, r.onerror = (t)=>{
                const r = t.target.error;
                "VersionError" === r.name ? n(new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.FAILED_PRECONDITION, "A newer version of the Firestore SDK was previously used and so the persisted data is not compatible with the version of the SDK you are now using. The SDK will operate with persistence disabled. If you need persistence, please re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB data for your app to start fresh.")) : "InvalidStateError" === r.name ? n(new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.FAILED_PRECONDITION, "Unable to open an IndexedDB connection. This could be due to running in a private browsing session on a browser whose private browsing sessions do not support IndexedDB: " + r)) : n(new $63c47e8a587a7f36$var$__PRIVATE_IndexedDbTransactionError(e, r));
            }, r.onupgradeneeded = (e)=>{
                $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$k, 'Database "' + this.name + '" requires upgrade from version:', e.oldVersion);
                const t = e.target.result;
                this.N.k(t, r.transaction, e.oldVersion, this.version).next(()=>{
                    $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$k, "Database upgrade to version " + this.version + " complete");
                });
            };
        })), this.K && (this.db.onversionchange = (e)=>this.K(e)), this.db;
    }
    q(e) {
        this.K = e, this.db && (this.db.onversionchange = (t)=>e(t));
    }
    async runTransaction(e, t, n, r) {
        const i = "readonly" === t;
        let s = 0;
        for(;;){
            ++s;
            try {
                this.db = await this.L(e);
                const t = $63c47e8a587a7f36$var$__PRIVATE_SimpleDbTransaction.open(this.db, e, i ? "readonly" : "readwrite", n), s = r(t).next((e)=>(t.C(), e)).catch((e)=>// Abort the transaction if there was an error.
                    (t.abort(e), $63c47e8a587a7f36$var$PersistencePromise.reject(e))).toPromise();
                // As noted above, errors are propagated by aborting the transaction. So
                // we swallow any error here to avoid the browser logging it as unhandled.
                return s.catch(()=>{}), // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
                // fire), but still return the original transactionFnResult back to the
                // caller.
                await t.D, s;
            } catch (e) {
                const t = e, n = "FirebaseError" !== t.name && s < 3;
                // TODO(schmidt-sebastian): We could probably be smarter about this and
                // not retry exceptions that are likely unrecoverable (such as quota
                // exceeded errors).
                // Note: We cannot use an instanceof check for FirestoreException, since the
                // exception is wrapped in a generic error by our async/await handling.
                if ($63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$k, "Transaction failed with error:", t.message, "Retrying:", n), this.close(), !n) return Promise.reject(t);
            }
        }
    }
    close() {
        this.db && this.db.close(), this.db = void 0;
    }
}
/** Parse User Agent to determine Android version. Returns -1 if not found. */ function $63c47e8a587a7f36$var$__PRIVATE_getAndroidVersion(e) {
    const t = e.match(/Android ([\d.]+)/i), n = t ? t[1].split(".").slice(0, 2).join(".") : "-1";
    return Number(n);
}
/**
 * A controller for iterating over a key range or index. It allows an iterate
 * callback to delete the currently-referenced object, or jump to a new key
 * within the key range or index.
 */ class $63c47e8a587a7f36$var$__PRIVATE_IterationController {
    constructor(e){
        this.U = e, this.$ = !1, this.W = null;
    }
    get isDone() {
        return this.$;
    }
    get G() {
        return this.W;
    }
    set cursor(e) {
        this.U = e;
    }
    /**
     * This function can be called to stop iteration at any point.
     */ done() {
        this.$ = !0;
    }
    /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */ j(e) {
        this.W = e;
    }
    /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */ delete() {
        return $63c47e8a587a7f36$var$__PRIVATE_wrapRequest(this.U.delete());
    }
}
/** An error that wraps exceptions that thrown during IndexedDB execution. */ class $63c47e8a587a7f36$var$__PRIVATE_IndexedDbTransactionError extends $63c47e8a587a7f36$export$4368d992c4eafac0 {
    constructor(e, t){
        super($63c47e8a587a7f36$export$e7094788287c5e9b.UNAVAILABLE, `IndexedDB transaction '${e}' failed: ${t}`), this.name = "IndexedDbTransactionError";
    }
}
/** Verifies whether `e` is an IndexedDbTransactionError. */ function $63c47e8a587a7f36$var$__PRIVATE_isIndexedDbTransactionError(e) {
    // Use name equality, as instanceof checks on errors don't work with errors
    // that wrap other errors.
    return "IndexedDbTransactionError" === e.name;
}
/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */ class $63c47e8a587a7f36$var$__PRIVATE_SimpleDbStore {
    constructor(e){
        this.store = e;
    }
    put(e, t) {
        let n;
        return void 0 !== t ? ($63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$k, "PUT", this.store.name, e, t), n = this.store.put(t, e)) : ($63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$k, "PUT", this.store.name, "<auto-key>", e), n = this.store.put(e)), $63c47e8a587a7f36$var$__PRIVATE_wrapRequest(n);
    }
    /**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value - The object to write.
     * @returns The key of the value to add.
     */ add(e) {
        $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$k, "ADD", this.store.name, e, e);
        return $63c47e8a587a7f36$var$__PRIVATE_wrapRequest(this.store.add(e));
    }
    /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @returns The object with the specified key or null if no object exists.
     */ get(e) {
        // We're doing an unsafe cast to ValueType.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $63c47e8a587a7f36$var$__PRIVATE_wrapRequest(this.store.get(e)).next((t)=>// Normalize nonexistence to null.
            (void 0 === t && (t = null), $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$k, "GET", this.store.name, e, t), t));
    }
    delete(e) {
        $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$k, "DELETE", this.store.name, e);
        return $63c47e8a587a7f36$var$__PRIVATE_wrapRequest(this.store.delete(e));
    }
    /**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */ count() {
        $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$k, "COUNT", this.store.name);
        return $63c47e8a587a7f36$var$__PRIVATE_wrapRequest(this.store.count());
    }
    H(e, t) {
        const n = this.options(e, t), r = n.index ? this.store.index(n.index) : this.store;
        // Use `getAll()` if the browser supports IndexedDB v3, as it is roughly
        // 20% faster.
        if ("function" == typeof r.getAll) {
            const e = r.getAll(n.range);
            return new $63c47e8a587a7f36$var$PersistencePromise((t, n)=>{
                e.onerror = (e)=>{
                    n(e.target.error);
                }, e.onsuccess = (e)=>{
                    t(e.target.result);
                };
            });
        }
        {
            const e = this.cursor(n), t = [];
            return this.J(e, (e, n)=>{
                t.push(n);
            }).next(()=>t);
        }
    }
    /**
     * Loads the first `count` elements from the provided index range. Loads all
     * elements if no limit is provided.
     */ Z(e, t) {
        const n = this.store.getAll(e, null === t ? void 0 : t);
        return new $63c47e8a587a7f36$var$PersistencePromise((e, t)=>{
            n.onerror = (e)=>{
                t(e.target.error);
            }, n.onsuccess = (t)=>{
                e(t.target.result);
            };
        });
    }
    X(e, t) {
        $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$k, "DELETE ALL", this.store.name);
        const n = this.options(e, t);
        n.Y = !1;
        const r = this.cursor(n);
        return this.J(r, (e, t, n)=>n.delete());
    }
    ee(e, t) {
        let n;
        t ? n = e : (n = {}, t = e);
        const r = this.cursor(n);
        return this.J(r, t);
    }
    /**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */ te(e) {
        const t = this.cursor({});
        return new $63c47e8a587a7f36$var$PersistencePromise((n, r)=>{
            t.onerror = (e)=>{
                const t = $63c47e8a587a7f36$var$__PRIVATE_checkForAndReportiOSError(e.target.error);
                r(t);
            }, t.onsuccess = (t)=>{
                const r = t.target.result;
                r ? e(r.primaryKey, r.value).next((e)=>{
                    e ? r.continue() : n();
                }) : n();
            };
        });
    }
    J(e, t) {
        const n = [];
        return new $63c47e8a587a7f36$var$PersistencePromise((r, i)=>{
            e.onerror = (e)=>{
                i(e.target.error);
            }, e.onsuccess = (e)=>{
                const i = e.target.result;
                if (!i) return void r();
                const s = new $63c47e8a587a7f36$var$__PRIVATE_IterationController(i), o = t(i.primaryKey, i.value, s);
                if (o instanceof $63c47e8a587a7f36$var$PersistencePromise) {
                    const e = o.catch((e)=>(s.done(), $63c47e8a587a7f36$var$PersistencePromise.reject(e)));
                    n.push(e);
                }
                s.isDone ? r() : null === s.G ? i.continue() : i.continue(s.G);
            };
        }).next(()=>$63c47e8a587a7f36$var$PersistencePromise.waitFor(n));
    }
    options(e, t) {
        let n;
        return void 0 !== e && ("string" == typeof e ? n = e : t = e), {
            index: n,
            range: t
        };
    }
    cursor(e) {
        let t = "next";
        if (e.reverse && (t = "prev"), e.index) {
            const n = this.store.index(e.index);
            return e.Y ? n.openKeyCursor(e.range, t) : n.openCursor(e.range, t);
        }
        return this.store.openCursor(e.range, t);
    }
}
/**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */ function $63c47e8a587a7f36$var$__PRIVATE_wrapRequest(e) {
    return new $63c47e8a587a7f36$var$PersistencePromise((t, n)=>{
        e.onsuccess = (e)=>{
            const n = e.target.result;
            t(n);
        }, e.onerror = (e)=>{
            const t = $63c47e8a587a7f36$var$__PRIVATE_checkForAndReportiOSError(e.target.error);
            n(t);
        };
    });
}
// Guard so we only report the error once.
let $63c47e8a587a7f36$var$K = !1;
function $63c47e8a587a7f36$var$__PRIVATE_checkForAndReportiOSError(e) {
    const t = $63c47e8a587a7f36$var$__PRIVATE_SimpleDb.M((0, $3117f6f4eeb4c314$export$c36915b22ce77c19)());
    if (t >= 12.2 && t < 13) {
        const t = "An internal error was encountered in the Indexed Database server";
        if (e.message.indexOf(t) >= 0) {
            // Wrap error in a more descriptive one.
            const e = new $63c47e8a587a7f36$export$4368d992c4eafac0("internal", `IOS_INDEXEDDB_BUG1: IndexedDb has thrown '${t}'. This is likely due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.`);
            return $63c47e8a587a7f36$var$K || ($63c47e8a587a7f36$var$K = !0, // Throw a global exception outside of this promise chain, for the user to
            // potentially catch.
            setTimeout(()=>{
                throw e;
            }, 0)), e;
        }
    }
    return e;
}
const $63c47e8a587a7f36$var$q = "IndexBackfiller";
/** How long we wait to try running index backfill after SDK initialization. */ /** This class is responsible for the scheduling of Index Backfiller. */ class $63c47e8a587a7f36$var$__PRIVATE_IndexBackfillerScheduler {
    constructor(e, t){
        this.asyncQueue = e, this.ne = t, this.task = null;
    }
    start() {
        this.re(15e3);
    }
    stop() {
        this.task && (this.task.cancel(), this.task = null);
    }
    get started() {
        return null !== this.task;
    }
    re(e) {
        $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$q, `Scheduled in ${e}ms`), this.task = this.asyncQueue.enqueueAfterDelay("index_backfill" /* TimerId.IndexBackfill */ , e, async ()=>{
            this.task = null;
            try {
                const e = await this.ne.ie();
                $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$q, `Documents written: ${e}`);
            } catch (e) {
                $63c47e8a587a7f36$var$__PRIVATE_isIndexedDbTransactionError(e) ? $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$q, "Ignoring IndexedDB error during index backfill: ", e) : await $63c47e8a587a7f36$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
            }
            await this.re(6e4);
        });
    }
}
/** Implements the steps for backfilling indexes. */ class $63c47e8a587a7f36$var$__PRIVATE_IndexBackfiller {
    constructor(/**
     * LocalStore provides access to IndexManager and LocalDocumentView.
     * These properties will update when the user changes. Consequently,
     * making a local copy of IndexManager and LocalDocumentView will require
     * updates over time. The simpler solution is to rely on LocalStore to have
     * an up-to-date references to IndexManager and LocalDocumentStore.
     */ e, t){
        this.localStore = e, this.persistence = t;
    }
    async ie(e = 50) {
        return this.persistence.runTransaction("Backfill Indexes", "readwrite-primary", (t)=>this.se(t, e));
    }
    /** Writes index entries until the cap is reached. Returns the number of documents processed. */ se(e, t) {
        const n = new Set;
        let r = t, i = !0;
        return $63c47e8a587a7f36$var$PersistencePromise.doWhile(()=>!0 === i && r > 0, ()=>this.localStore.indexManager.getNextCollectionGroupToUpdate(e).next((t)=>{
                if (null !== t && !n.has(t)) return $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$q, `Processing collection: ${t}`), this.oe(e, t, r).next((e)=>{
                    r -= e, n.add(t);
                });
                i = !1;
            })).next(()=>t - r);
    }
    /**
     * Writes entries for the provided collection group. Returns the number of documents processed.
     */ oe(e, t, n) {
        // Use the earliest offset of all field indexes to query the local cache.
        return this.localStore.indexManager.getMinOffsetFromCollectionGroup(e, t).next((r)=>this.localStore.localDocuments.getNextDocuments(e, t, r, n).next((n)=>{
                const i = n.changes;
                return this.localStore.indexManager.updateIndexEntries(e, i).next(()=>this._e(r, n)).next((n)=>($63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$q, `Updating offset: ${n}`), this.localStore.indexManager.updateCollectionGroup(e, t, n))).next(()=>i.size);
            }));
    }
    /** Returns the next offset based on the provided documents. */ _e(e, t) {
        let n = e;
        return t.changes.forEach((e, t)=>{
            const r = $63c47e8a587a7f36$var$__PRIVATE_newIndexOffsetFromDocument(t);
            $63c47e8a587a7f36$var$__PRIVATE_indexOffsetComparator(r, n) > 0 && (n = r);
        }), new $63c47e8a587a7f36$var$IndexOffset(n.readTime, n.documentKey, Math.max(t.batchId, e.largestBatchId));
    }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */ class $63c47e8a587a7f36$var$__PRIVATE_ListenSequence {
    constructor(e, t){
        this.previousValue = e, t && (t.sequenceNumberHandler = (e)=>this.ae(e), this.ue = (e)=>t.writeSequenceNumber(e));
    }
    ae(e) {
        return this.previousValue = Math.max(e, this.previousValue), this.previousValue;
    }
    next() {
        const e = ++this.previousValue;
        return this.ue && this.ue(e), e;
    }
}
$63c47e8a587a7f36$var$__PRIVATE_ListenSequence.ce = -1;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Sentinel value that sorts before any Mutation Batch ID. */ const $63c47e8a587a7f36$var$U = -1;
/**
 * Returns whether a variable is either undefined or null.
 */ function $63c47e8a587a7f36$var$__PRIVATE_isNullOrUndefined(e) {
    return null == e;
}
/** Returns whether the value represents -0. */ function $63c47e8a587a7f36$var$__PRIVATE_isNegativeZero(e) {
    // Detect if the value is -0.0. Based on polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    return 0 === e && 1 / e == -1 / 0;
}
function $63c47e8a587a7f36$export$136fd86de524d3c2(e) {
    return "number" == typeof e;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value - The value to test for being an integer and in the safe range
 */ function $63c47e8a587a7f36$var$isSafeInteger(e) {
    return "number" == typeof e && Number.isInteger(e) && !$63c47e8a587a7f36$var$__PRIVATE_isNegativeZero(e) && e <= Number.MAX_SAFE_INTEGER && e >= Number.MIN_SAFE_INTEGER;
}
function $63c47e8a587a7f36$export$39c1cc7c062529d4(e) {
    return "string" == typeof e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $63c47e8a587a7f36$var$$ = "";
/**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */ function $63c47e8a587a7f36$var$__PRIVATE_encodeResourcePath(e) {
    let t = "";
    for(let n = 0; n < e.length; n++)t.length > 0 && (t = $63c47e8a587a7f36$var$__PRIVATE_encodeSeparator(t)), t = $63c47e8a587a7f36$var$__PRIVATE_encodeSegment(e.get(n), t);
    return $63c47e8a587a7f36$var$__PRIVATE_encodeSeparator(t);
}
/** Encodes a single segment of a resource path into the given result */ function $63c47e8a587a7f36$var$__PRIVATE_encodeSegment(e, t) {
    let n = t;
    const r = e.length;
    for(let t = 0; t < r; t++){
        const r = e.charAt(t);
        switch(r){
            case "\0":
                n += "";
                break;
            case $63c47e8a587a7f36$var$$:
                n += "";
                break;
            default:
                n += r;
        }
    }
    return n;
}
/** Encodes a path separator into the given result */ function $63c47e8a587a7f36$var$__PRIVATE_encodeSeparator(e) {
    return e + $63c47e8a587a7f36$var$$ + "";
}
/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */ function $63c47e8a587a7f36$var$__PRIVATE_decodeResourcePath(e) {
    // Event the empty path must encode as a path of at least length 2. A path
    // with exactly 2 must be the empty path.
    const t = e.length;
    if ($63c47e8a587a7f36$export$c18d01048907ea92(t >= 2, 64408, {
        path: e
    }), 2 === t) return $63c47e8a587a7f36$export$c18d01048907ea92(e.charAt(0) === $63c47e8a587a7f36$var$$ && "" === e.charAt(1), 56145, {
        path: e
    }), $63c47e8a587a7f36$export$db202ddc8be9136.emptyPath();
    // Escape characters cannot exist past the second-to-last position in the
    // source value.
    const __PRIVATE_lastReasonableEscapeIndex = t - 2, n = [];
    let r = "";
    for(let i = 0; i < t;){
        // The last two characters of a valid encoded path must be a separator, so
        // there must be an end to this segment.
        const t = e.indexOf($63c47e8a587a7f36$var$$, i);
        (t < 0 || t > __PRIVATE_lastReasonableEscapeIndex) && $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(50515, {
            path: e
        });
        switch(e.charAt(t + 1)){
            case "":
                const s = e.substring(i, t);
                let o;
                0 === r.length ? // Avoid copying for the common case of a segment that excludes \0
                // and \001
                o = s : (r += s, o = r, r = ""), n.push(o);
                break;
            case "":
                r += e.substring(i, t), r += "\0";
                break;
            case "":
                // The escape character can be used in the output to encode itself.
                r += e.substring(i, t + 1);
                break;
            default:
                $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(61167, {
                    path: e
                });
        }
        i = t + 2;
    }
    return new $63c47e8a587a7f36$export$db202ddc8be9136(n);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $63c47e8a587a7f36$var$W = "remoteDocuments", $63c47e8a587a7f36$var$Q = "owner", $63c47e8a587a7f36$var$G = "owner", $63c47e8a587a7f36$var$z = "mutationQueues", $63c47e8a587a7f36$var$j = "userId", $63c47e8a587a7f36$var$H = "mutations", $63c47e8a587a7f36$var$J = "batchId", $63c47e8a587a7f36$var$Z = "userMutationsIndex", $63c47e8a587a7f36$var$X = [
    "userId",
    "batchId"
];
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Name of the IndexedDb object store.
 *
 * Note that the name 'owner' is chosen to ensure backwards compatibility with
 * older clients that only supported single locked access to the persistence
 * layer.
 */ /**
 * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
 * index to iterate over all at document mutations for a given path or lower.
 */ function $63c47e8a587a7f36$var$__PRIVATE_newDbDocumentMutationPrefixForPath(e, t) {
    return [
        e,
        $63c47e8a587a7f36$var$__PRIVATE_encodeResourcePath(t)
    ];
}
/**
 * Creates a full index key of [userId, encodedPath, batchId] for inserting
 * and deleting into the DbDocumentMutations index.
 */ function $63c47e8a587a7f36$var$__PRIVATE_newDbDocumentMutationKey(e, t, n) {
    return [
        e,
        $63c47e8a587a7f36$var$__PRIVATE_encodeResourcePath(t),
        n
    ];
}
/**
 * Because we store all the useful information for this store in the key,
 * there is no useful information to store as the value. The raw (unencoded)
 * path cannot be stored because IndexedDb doesn't store prototype
 * information.
 */ const $63c47e8a587a7f36$var$Y = {}, $63c47e8a587a7f36$var$ee = "documentMutations", $63c47e8a587a7f36$var$te = "remoteDocumentsV14", $63c47e8a587a7f36$var$ne = [
    "prefixPath",
    "collectionGroup",
    "readTime",
    "documentId"
], $63c47e8a587a7f36$var$re = "documentKeyIndex", $63c47e8a587a7f36$var$ie = [
    "prefixPath",
    "collectionGroup",
    "documentId"
], $63c47e8a587a7f36$var$se = "collectionGroupIndex", $63c47e8a587a7f36$var$oe = [
    "collectionGroup",
    "readTime",
    "prefixPath",
    "documentId"
], $63c47e8a587a7f36$var$_e = "remoteDocumentGlobal", $63c47e8a587a7f36$var$ae = "remoteDocumentGlobalKey", $63c47e8a587a7f36$var$ue = "targets", $63c47e8a587a7f36$var$ce = "queryTargetsIndex", $63c47e8a587a7f36$var$le = [
    "canonicalId",
    "targetId"
], $63c47e8a587a7f36$var$he = "targetDocuments", $63c47e8a587a7f36$var$Pe = [
    "targetId",
    "path"
], $63c47e8a587a7f36$var$Te = "documentTargetsIndex", $63c47e8a587a7f36$var$Ie = [
    "path",
    "targetId"
], $63c47e8a587a7f36$var$Ee = "targetGlobalKey", $63c47e8a587a7f36$var$Re = "targetGlobal", $63c47e8a587a7f36$var$Ae = "collectionParents", $63c47e8a587a7f36$var$Ve = [
    "collectionId",
    "parent"
], $63c47e8a587a7f36$var$de = "clientMetadata", $63c47e8a587a7f36$var$me = "clientId", $63c47e8a587a7f36$var$fe = "bundles", $63c47e8a587a7f36$var$ge = "bundleId", $63c47e8a587a7f36$var$pe = "namedQueries", $63c47e8a587a7f36$var$ye = "name", $63c47e8a587a7f36$var$we = "indexConfiguration", $63c47e8a587a7f36$var$be = "indexId", $63c47e8a587a7f36$var$Se = "collectionGroupIndex", $63c47e8a587a7f36$var$De = "collectionGroup", $63c47e8a587a7f36$var$Ce = "indexState", $63c47e8a587a7f36$var$ve = [
    "indexId",
    "uid"
], $63c47e8a587a7f36$var$Fe = "sequenceNumberIndex", $63c47e8a587a7f36$var$Me = [
    "uid",
    "sequenceNumber"
], $63c47e8a587a7f36$var$xe = "indexEntries", $63c47e8a587a7f36$var$Oe = [
    "indexId",
    "uid",
    "arrayValue",
    "directionalValue",
    "orderedDocumentKey",
    "documentKey"
], $63c47e8a587a7f36$var$Ne = "documentKeyIndex", $63c47e8a587a7f36$var$Be = [
    "indexId",
    "uid",
    "orderedDocumentKey"
], $63c47e8a587a7f36$var$Le = "documentOverlays", $63c47e8a587a7f36$var$ke = [
    "userId",
    "collectionPath",
    "documentId"
], $63c47e8a587a7f36$var$Ke = "collectionPathOverlayIndex", $63c47e8a587a7f36$var$qe = [
    "userId",
    "collectionPath",
    "largestBatchId"
], $63c47e8a587a7f36$var$Ue = "collectionGroupOverlayIndex", $63c47e8a587a7f36$var$$e = [
    "userId",
    "collectionGroup",
    "largestBatchId"
], $63c47e8a587a7f36$var$We = "globals", $63c47e8a587a7f36$var$Qe = "name", $63c47e8a587a7f36$var$Ge = [
    $63c47e8a587a7f36$var$z,
    $63c47e8a587a7f36$var$H,
    $63c47e8a587a7f36$var$ee,
    $63c47e8a587a7f36$var$W,
    $63c47e8a587a7f36$var$ue,
    $63c47e8a587a7f36$var$Q,
    $63c47e8a587a7f36$var$Re,
    $63c47e8a587a7f36$var$he,
    $63c47e8a587a7f36$var$de,
    $63c47e8a587a7f36$var$_e,
    $63c47e8a587a7f36$var$Ae,
    $63c47e8a587a7f36$var$fe,
    $63c47e8a587a7f36$var$pe
], $63c47e8a587a7f36$var$ze = [
    ...$63c47e8a587a7f36$var$Ge,
    $63c47e8a587a7f36$var$Le
], $63c47e8a587a7f36$var$je = [
    $63c47e8a587a7f36$var$z,
    $63c47e8a587a7f36$var$H,
    $63c47e8a587a7f36$var$ee,
    $63c47e8a587a7f36$var$te,
    $63c47e8a587a7f36$var$ue,
    $63c47e8a587a7f36$var$Q,
    $63c47e8a587a7f36$var$Re,
    $63c47e8a587a7f36$var$he,
    $63c47e8a587a7f36$var$de,
    $63c47e8a587a7f36$var$_e,
    $63c47e8a587a7f36$var$Ae,
    $63c47e8a587a7f36$var$fe,
    $63c47e8a587a7f36$var$pe,
    $63c47e8a587a7f36$var$Le
], $63c47e8a587a7f36$var$He = $63c47e8a587a7f36$var$je, $63c47e8a587a7f36$var$Je = [
    ...$63c47e8a587a7f36$var$He,
    $63c47e8a587a7f36$var$we,
    $63c47e8a587a7f36$var$Ce,
    $63c47e8a587a7f36$var$xe
], $63c47e8a587a7f36$var$Ze = $63c47e8a587a7f36$var$Je, $63c47e8a587a7f36$var$Xe = [
    ...$63c47e8a587a7f36$var$Je,
    $63c47e8a587a7f36$var$We
], $63c47e8a587a7f36$var$Ye = $63c47e8a587a7f36$var$Xe;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $63c47e8a587a7f36$var$__PRIVATE_IndexedDbTransaction extends $63c47e8a587a7f36$var$PersistenceTransaction {
    constructor(e, t){
        super(), this.le = e, this.currentSequenceNumber = t;
    }
}
function $63c47e8a587a7f36$var$__PRIVATE_getStore(e, t) {
    const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    return $63c47e8a587a7f36$var$__PRIVATE_SimpleDb.O(n.le, t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $63c47e8a587a7f36$var$__PRIVATE_objectSize(e) {
    let t = 0;
    for(const n in e)Object.prototype.hasOwnProperty.call(e, n) && t++;
    return t;
}
function $63c47e8a587a7f36$var$forEach(e, t) {
    for(const n in e)Object.prototype.hasOwnProperty.call(e, n) && t(n, e[n]);
}
function $63c47e8a587a7f36$export$a9c23c6ac3fc3eca(e, t) {
    const n = [];
    for(const r in e)Object.prototype.hasOwnProperty.call(e, r) && n.push(t(e[r], r, e));
    return n;
}
function $63c47e8a587a7f36$var$isEmpty(e) {
    for(const t in e)if (Object.prototype.hasOwnProperty.call(e, t)) return !1;
    return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
class $63c47e8a587a7f36$var$SortedMap {
    constructor(e, t){
        this.comparator = e, this.root = t || $63c47e8a587a7f36$var$LLRBNode.EMPTY;
    }
    // Returns a copy of the map, with the specified key/value added or replaced.
    insert(e, t) {
        return new $63c47e8a587a7f36$var$SortedMap(this.comparator, this.root.insert(e, t, this.comparator).copy(null, null, $63c47e8a587a7f36$var$LLRBNode.BLACK, null, null));
    }
    // Returns a copy of the map, with the specified key removed.
    remove(e) {
        return new $63c47e8a587a7f36$var$SortedMap(this.comparator, this.root.remove(e, this.comparator).copy(null, null, $63c47e8a587a7f36$var$LLRBNode.BLACK, null, null));
    }
    // Returns the value of the node with the given key, or null.
    get(e) {
        let t = this.root;
        for(; !t.isEmpty();){
            const n = this.comparator(e, t.key);
            if (0 === n) return t.value;
            n < 0 ? t = t.left : n > 0 && (t = t.right);
        }
        return null;
    }
    // Returns the index of the element in this sorted map, or -1 if it doesn't
    // exist.
    indexOf(e) {
        // Number of nodes that were pruned when descending right
        let t = 0, n = this.root;
        for(; !n.isEmpty();){
            const r = this.comparator(e, n.key);
            if (0 === r) return t + n.left.size;
            r < 0 ? n = n.left : // Count all nodes left of the node plus the node itself
            (t += n.left.size + 1, n = n.right);
        }
        // Node not found
        return -1;
    }
    isEmpty() {
        return this.root.isEmpty();
    }
    // Returns the total number of nodes in the map.
    get size() {
        return this.root.size;
    }
    // Returns the minimum key in the map.
    minKey() {
        return this.root.minKey();
    }
    // Returns the maximum key in the map.
    maxKey() {
        return this.root.maxKey();
    }
    // Traverses the map in key order and calls the specified action function
    // for each key/value pair. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(e) {
        return this.root.inorderTraversal(e);
    }
    forEach(e) {
        this.inorderTraversal((t, n)=>(e(t, n), !1));
    }
    toString() {
        const e = [];
        return this.inorderTraversal((t, n)=>(e.push(`${t}:${n}`), !1)), `{${e.join(", ")}}`;
    }
    // Traverses the map in reverse key order and calls the specified action
    // function for each key/value pair. If action returns true, traversal is
    // aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(e) {
        return this.root.reverseTraversal(e);
    }
    // Returns an iterator over the SortedMap.
    getIterator() {
        return new $63c47e8a587a7f36$var$SortedMapIterator(this.root, null, this.comparator, !1);
    }
    getIteratorFrom(e) {
        return new $63c47e8a587a7f36$var$SortedMapIterator(this.root, e, this.comparator, !1);
    }
    getReverseIterator() {
        return new $63c47e8a587a7f36$var$SortedMapIterator(this.root, null, this.comparator, !0);
    }
    getReverseIteratorFrom(e) {
        return new $63c47e8a587a7f36$var$SortedMapIterator(this.root, e, this.comparator, !0);
    }
}
// end SortedMap
// An iterator over an LLRBNode.
class $63c47e8a587a7f36$var$SortedMapIterator {
    constructor(e, t, n, r){
        this.isReverse = r, this.nodeStack = [];
        let i = 1;
        for(; !e.isEmpty();)if (i = t ? n(e.key, t) : 1, // flip the comparison if we're going in reverse
        t && r && (i *= -1), i < 0) // This node is less than our start key. ignore it
        e = this.isReverse ? e.left : e.right;
        else {
            if (0 === i) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.nodeStack.push(e);
                break;
            }
            // This node is greater than our start key, add it to the stack and move
            // to the next one
            this.nodeStack.push(e), e = this.isReverse ? e.right : e.left;
        }
    }
    getNext() {
        let e = this.nodeStack.pop();
        const t = {
            key: e.key,
            value: e.value
        };
        if (this.isReverse) for(e = e.left; !e.isEmpty();)this.nodeStack.push(e), e = e.right;
        else for(e = e.right; !e.isEmpty();)this.nodeStack.push(e), e = e.left;
        return t;
    }
    hasNext() {
        return this.nodeStack.length > 0;
    }
    peek() {
        if (0 === this.nodeStack.length) return null;
        const e = this.nodeStack[this.nodeStack.length - 1];
        return {
            key: e.key,
            value: e.value
        };
    }
}
// end SortedMapIterator
// Represents a node in a Left-leaning Red-Black tree.
class $63c47e8a587a7f36$var$LLRBNode {
    constructor(e, t, n, r, i){
        this.key = e, this.value = t, this.color = null != n ? n : $63c47e8a587a7f36$var$LLRBNode.RED, this.left = null != r ? r : $63c47e8a587a7f36$var$LLRBNode.EMPTY, this.right = null != i ? i : $63c47e8a587a7f36$var$LLRBNode.EMPTY, this.size = this.left.size + 1 + this.right.size;
    }
    // Returns a copy of the current node, optionally replacing pieces of it.
    copy(e, t, n, r, i) {
        return new $63c47e8a587a7f36$var$LLRBNode(null != e ? e : this.key, null != t ? t : this.value, null != n ? n : this.color, null != r ? r : this.left, null != i ? i : this.right);
    }
    isEmpty() {
        return !1;
    }
    // Traverses the tree in key order and calls the specified action function
    // for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(e) {
        return this.left.inorderTraversal(e) || e(this.key, this.value) || this.right.inorderTraversal(e);
    }
    // Traverses the tree in reverse key order and calls the specified action
    // function for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(e) {
        return this.right.reverseTraversal(e) || e(this.key, this.value) || this.left.reverseTraversal(e);
    }
    // Returns the minimum node in the tree.
    min() {
        return this.left.isEmpty() ? this : this.left.min();
    }
    // Returns the maximum key in the tree.
    minKey() {
        return this.min().key;
    }
    // Returns the maximum key in the tree.
    maxKey() {
        return this.right.isEmpty() ? this.key : this.right.maxKey();
    }
    // Returns new tree, with the key/value added.
    insert(e, t, n) {
        let r = this;
        const i = n(e, r.key);
        return r = i < 0 ? r.copy(null, null, null, r.left.insert(e, t, n), null) : 0 === i ? r.copy(null, t, null, null, null) : r.copy(null, null, null, null, r.right.insert(e, t, n)), r.fixUp();
    }
    removeMin() {
        if (this.left.isEmpty()) return $63c47e8a587a7f36$var$LLRBNode.EMPTY;
        let e = this;
        return e.left.isRed() || e.left.left.isRed() || (e = e.moveRedLeft()), e = e.copy(null, null, null, e.left.removeMin(), null), e.fixUp();
    }
    // Returns new tree, with the specified item removed.
    remove(e, t) {
        let n, r = this;
        if (t(e, r.key) < 0) r.left.isEmpty() || r.left.isRed() || r.left.left.isRed() || (r = r.moveRedLeft()), r = r.copy(null, null, null, r.left.remove(e, t), null);
        else {
            if (r.left.isRed() && (r = r.rotateRight()), r.right.isEmpty() || r.right.isRed() || r.right.left.isRed() || (r = r.moveRedRight()), 0 === t(e, r.key)) {
                if (r.right.isEmpty()) return $63c47e8a587a7f36$var$LLRBNode.EMPTY;
                n = r.right.min(), r = r.copy(n.key, n.value, null, null, r.right.removeMin());
            }
            r = r.copy(null, null, null, null, r.right.remove(e, t));
        }
        return r.fixUp();
    }
    isRed() {
        return this.color;
    }
    // Returns new tree after performing any needed rotations.
    fixUp() {
        let e = this;
        return e.right.isRed() && !e.left.isRed() && (e = e.rotateLeft()), e.left.isRed() && e.left.left.isRed() && (e = e.rotateRight()), e.left.isRed() && e.right.isRed() && (e = e.colorFlip()), e;
    }
    moveRedLeft() {
        let e = this.colorFlip();
        return e.right.left.isRed() && (e = e.copy(null, null, null, null, e.right.rotateRight()), e = e.rotateLeft(), e = e.colorFlip()), e;
    }
    moveRedRight() {
        let e = this.colorFlip();
        return e.left.left.isRed() && (e = e.rotateRight(), e = e.colorFlip()), e;
    }
    rotateLeft() {
        const e = this.copy(null, null, $63c47e8a587a7f36$var$LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, e, null);
    }
    rotateRight() {
        const e = this.copy(null, null, $63c47e8a587a7f36$var$LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, e);
    }
    colorFlip() {
        const e = this.left.copy(null, null, !this.left.color, null, null), t = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, e, t);
    }
    // For testing.
    checkMaxDepth() {
        const e = this.check();
        return Math.pow(2, e) <= this.size + 1;
    }
    // In a balanced RB tree, the black-depth (number of black nodes) from root to
    // leaves is equal on both sides.  This function verifies that or asserts.
    check() {
        if (this.isRed() && this.left.isRed()) throw $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(43730, {
            key: this.key,
            value: this.value
        });
        if (this.right.isRed()) throw $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(14113, {
            key: this.key,
            value: this.value
        });
        const e = this.left.check();
        if (e !== this.right.check()) throw $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(27949);
        return e + (this.isRed() ? 0 : 1);
    }
}
// end LLRBNode
// Empty node is shared between all LLRB trees.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$63c47e8a587a7f36$var$LLRBNode.EMPTY = null, $63c47e8a587a7f36$var$LLRBNode.RED = !0, $63c47e8a587a7f36$var$LLRBNode.BLACK = !1;
// end LLRBEmptyNode
$63c47e8a587a7f36$var$LLRBNode.EMPTY = new // Represents an empty node (a leaf node in the Red-Black Tree).
class LLRBEmptyNode {
    constructor(){
        this.size = 0;
    }
    get key() {
        throw $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(57766);
    }
    get value() {
        throw $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(16141);
    }
    get color() {
        throw $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(16727);
    }
    get left() {
        throw $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(29726);
    }
    get right() {
        throw $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(36894);
    }
    // Returns a copy of the current node.
    copy(e, t, n, r, i) {
        return this;
    }
    // Returns a copy of the tree, with the specified key/value added.
    insert(e, t, n) {
        return new $63c47e8a587a7f36$var$LLRBNode(e, t);
    }
    // Returns a copy of the tree, with the specified key removed.
    remove(e, t) {
        return this;
    }
    isEmpty() {
        return !0;
    }
    inorderTraversal(e) {
        return !1;
    }
    reverseTraversal(e) {
        return !1;
    }
    minKey() {
        return null;
    }
    maxKey() {
        return null;
    }
    isRed() {
        return !1;
    }
    // For testing.
    checkMaxDepth() {
        return !0;
    }
    check() {
        return 0;
    }
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */ class $63c47e8a587a7f36$var$SortedSet {
    constructor(e){
        this.comparator = e, this.data = new $63c47e8a587a7f36$var$SortedMap(this.comparator);
    }
    has(e) {
        return null !== this.data.get(e);
    }
    first() {
        return this.data.minKey();
    }
    last() {
        return this.data.maxKey();
    }
    get size() {
        return this.data.size;
    }
    indexOf(e) {
        return this.data.indexOf(e);
    }
    /** Iterates elements in order defined by "comparator" */ forEach(e) {
        this.data.inorderTraversal((t, n)=>(e(t), !1));
    }
    /** Iterates over `elem`s such that: range[0] &lt;= elem &lt; range[1]. */ forEachInRange(e, t) {
        const n = this.data.getIteratorFrom(e[0]);
        for(; n.hasNext();){
            const r = n.getNext();
            if (this.comparator(r.key, e[1]) >= 0) return;
            t(r.key);
        }
    }
    /**
     * Iterates over `elem`s such that: start &lt;= elem until false is returned.
     */ forEachWhile(e, t) {
        let n;
        for(n = void 0 !== t ? this.data.getIteratorFrom(t) : this.data.getIterator(); n.hasNext();){
            if (!e(n.getNext().key)) return;
        }
    }
    /** Finds the least element greater than or equal to `elem`. */ firstAfterOrEqual(e) {
        const t = this.data.getIteratorFrom(e);
        return t.hasNext() ? t.getNext().key : null;
    }
    getIterator() {
        return new $63c47e8a587a7f36$var$SortedSetIterator(this.data.getIterator());
    }
    getIteratorFrom(e) {
        return new $63c47e8a587a7f36$var$SortedSetIterator(this.data.getIteratorFrom(e));
    }
    /** Inserts or updates an element */ add(e) {
        return this.copy(this.data.remove(e).insert(e, !0));
    }
    /** Deletes an element */ delete(e) {
        return this.has(e) ? this.copy(this.data.remove(e)) : this;
    }
    isEmpty() {
        return this.data.isEmpty();
    }
    unionWith(e) {
        let t = this;
        // Make sure `result` always refers to the larger one of the two sets.
        return t.size < e.size && (t = e, e = this), e.forEach((e)=>{
            t = t.add(e);
        }), t;
    }
    isEqual(e) {
        if (!(e instanceof $63c47e8a587a7f36$var$SortedSet)) return !1;
        if (this.size !== e.size) return !1;
        const t = this.data.getIterator(), n = e.data.getIterator();
        for(; t.hasNext();){
            const e = t.getNext().key, r = n.getNext().key;
            if (0 !== this.comparator(e, r)) return !1;
        }
        return !0;
    }
    toArray() {
        const e = [];
        return this.forEach((t)=>{
            e.push(t);
        }), e;
    }
    toString() {
        const e = [];
        return this.forEach((t)=>e.push(t)), "SortedSet(" + e.toString() + ")";
    }
    copy(e) {
        const t = new $63c47e8a587a7f36$var$SortedSet(this.comparator);
        return t.data = e, t;
    }
}
class $63c47e8a587a7f36$var$SortedSetIterator {
    constructor(e){
        this.iter = e;
    }
    getNext() {
        return this.iter.getNext().key;
    }
    hasNext() {
        return this.iter.hasNext();
    }
}
/**
 * Compares two sorted sets for equality using their natural ordering. The
 * method computes the intersection and invokes `onAdd` for every element that
 * is in `after` but not `before`. `onRemove` is invoked for every element in
 * `before` but missing from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original set.
 * @param after - The elements to diff against the original set.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ /**
 * Returns the next element from the iterator or `undefined` if none available.
 */ function $63c47e8a587a7f36$var$__PRIVATE_advanceIterator(e) {
    return e.hasNext() ? e.getNext() : void 0;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */ class $63c47e8a587a7f36$var$FieldMask {
    constructor(e){
        this.fields = e, // TODO(dimond): validation of FieldMask
        // Sort the field mask to support `FieldMask.isEqual()` and assert below.
        e.sort($63c47e8a587a7f36$export$cf2f7c5792f80b46.comparator);
    }
    static empty() {
        return new $63c47e8a587a7f36$var$FieldMask([]);
    }
    /**
     * Returns a new FieldMask object that is the result of adding all the given
     * fields paths to this field mask.
     */ unionWith(e) {
        let t = new $63c47e8a587a7f36$var$SortedSet($63c47e8a587a7f36$export$cf2f7c5792f80b46.comparator);
        for (const e of this.fields)t = t.add(e);
        for (const n of e)t = t.add(n);
        return new $63c47e8a587a7f36$var$FieldMask(t.toArray());
    }
    /**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */ covers(e) {
        for (const t of this.fields)if (t.isPrefixOf(e)) return !0;
        return !1;
    }
    isEqual(e) {
        return $63c47e8a587a7f36$var$__PRIVATE_arrayEquals(this.fields, e.fields, (e, t)=>e.isEqual(t));
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error encountered while decoding base64 string.
 */ class $63c47e8a587a7f36$var$__PRIVATE_Base64DecodeError extends Error {
    constructor(){
        super(...arguments), this.name = "Base64DecodeError";
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ /** True if and only if the Base64 conversion functions are available. */ function $63c47e8a587a7f36$export$a05254e7c3aeba6e() {
    return "undefined" != typeof atob;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Immutable class that represents a "proto" byte string.
 *
 * Proto byte strings can either be Base64-encoded strings or Uint8Arrays when
 * sent on the wire. This class abstracts away this differentiation by holding
 * the proto byte string in a common class that must be converted into a string
 * before being sent as a proto.
 * @internal
 */ class $63c47e8a587a7f36$export$9d398bebfec1c039 {
    constructor(e){
        this.binaryString = e;
    }
    static fromBase64String(e) {
        const t = function __PRIVATE_decodeBase64(e) {
            try {
                return atob(e);
            } catch (e) {
                // Check that `DOMException` is defined before using it to avoid
                // "ReferenceError: Property 'DOMException' doesn't exist" in react-native.
                // (https://github.com/firebase/firebase-js-sdk/issues/7115)
                throw "undefined" != typeof DOMException && e instanceof DOMException ? new $63c47e8a587a7f36$var$__PRIVATE_Base64DecodeError("Invalid base64 string: " + e) : e;
            }
        }(e);
        return new $63c47e8a587a7f36$export$9d398bebfec1c039(t);
    }
    static fromUint8Array(e) {
        // TODO(indexing); Remove the copy of the byte string here as this method
        // is frequently called during indexing.
        const t = /**
 * Helper function to convert an Uint8array to a binary string.
 */ function __PRIVATE_binaryStringFromUint8Array(e) {
            let t = "";
            for(let n = 0; n < e.length; ++n)t += String.fromCharCode(e[n]);
            return t;
        }(e);
        return new $63c47e8a587a7f36$export$9d398bebfec1c039(t);
    }
    [Symbol.iterator]() {
        let e = 0;
        return {
            next: ()=>e < this.binaryString.length ? {
                    value: this.binaryString.charCodeAt(e++),
                    done: !1
                } : {
                    value: void 0,
                    done: !0
                }
        };
    }
    toBase64() {
        return function __PRIVATE_encodeBase64(e) {
            return btoa(e);
        }(this.binaryString);
    }
    toUint8Array() {
        return function __PRIVATE_uint8ArrayFromBinaryString(e) {
            const t = new Uint8Array(e.length);
            for(let n = 0; n < e.length; n++)t[n] = e.charCodeAt(n);
            return t;
        }(this.binaryString);
    }
    approximateByteSize() {
        return 2 * this.binaryString.length;
    }
    compareTo(e) {
        return $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(this.binaryString, e.binaryString);
    }
    isEqual(e) {
        return this.binaryString === e.binaryString;
    }
}
$63c47e8a587a7f36$export$9d398bebfec1c039.EMPTY_BYTE_STRING = new $63c47e8a587a7f36$export$9d398bebfec1c039("");
const $63c47e8a587a7f36$var$et = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
/**
 * Converts the possible Proto values for a timestamp value into a "seconds and
 * nanos" representation.
 */ function $63c47e8a587a7f36$var$__PRIVATE_normalizeTimestamp(e) {
    // The json interface (for the browser) will return an iso timestamp string,
    // while the proto js library (for node) will return a
    // google.protobuf.Timestamp instance.
    if ($63c47e8a587a7f36$export$c18d01048907ea92(!!e, 39018), "string" == typeof e) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        let t = 0;
        const n = $63c47e8a587a7f36$var$et.exec(e);
        if ($63c47e8a587a7f36$export$c18d01048907ea92(!!n, 46558, {
            timestamp: e
        }), n[1]) {
            // Pad the fraction out to 9 digits (nanos).
            let e = n[1];
            e = (e + "000000000").substr(0, 9), t = Number(e);
        }
        // Parse the date to get the seconds.
        const r = new Date(e);
        return {
            seconds: Math.floor(r.getTime() / 1e3),
            nanos: t
        };
    }
    return {
        seconds: $63c47e8a587a7f36$var$__PRIVATE_normalizeNumber(e.seconds),
        nanos: $63c47e8a587a7f36$var$__PRIVATE_normalizeNumber(e.nanos)
    };
}
/**
 * Converts the possible Proto types for numbers into a JavaScript number.
 * Returns 0 if the value is not numeric.
 */ function $63c47e8a587a7f36$var$__PRIVATE_normalizeNumber(e) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    return "number" == typeof e ? e : "string" == typeof e ? Number(e) : 0;
}
/** Converts the possible Proto types for Blobs into a ByteString. */ function $63c47e8a587a7f36$var$__PRIVATE_normalizeByteString(e) {
    return "string" == typeof e ? $63c47e8a587a7f36$export$9d398bebfec1c039.fromBase64String(e) : $63c47e8a587a7f36$export$9d398bebfec1c039.fromUint8Array(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a locally-applied ServerTimestamp.
 *
 * Server Timestamps are backed by MapValues that contain an internal field
 * `__type__` with a value of `server_timestamp`. The previous value and local
 * write time are stored in its `__previous_value__` and `__local_write_time__`
 * fields respectively.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   transform. They can only exist in the local view of a document. Therefore
 *   they do not need to be parsed or serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */ const $63c47e8a587a7f36$var$tt = "server_timestamp", $63c47e8a587a7f36$var$nt = "__type__", $63c47e8a587a7f36$var$rt = "__previous_value__", $63c47e8a587a7f36$var$it = "__local_write_time__";
function $63c47e8a587a7f36$export$2408f22a0fab9ae5(e) {
    const t = (e?.mapValue?.fields || {})[$63c47e8a587a7f36$var$nt]?.stringValue;
    return t === $63c47e8a587a7f36$var$tt;
}
/**
 * Creates a new ServerTimestamp proto value (using the internal format).
 */ /**
 * Returns the value of the field before this ServerTimestamp was set.
 *
 * Preserving the previous values allows the user to display the last resoled
 * value until the backend responds with the timestamp.
 */ function $63c47e8a587a7f36$var$__PRIVATE_getPreviousValue(e) {
    const t = e.mapValue.fields[$63c47e8a587a7f36$var$rt];
    return $63c47e8a587a7f36$export$2408f22a0fab9ae5(t) ? $63c47e8a587a7f36$var$__PRIVATE_getPreviousValue(t) : t;
}
/**
 * Returns the local time at which this timestamp was first set.
 */ function $63c47e8a587a7f36$var$__PRIVATE_getLocalWriteTime(e) {
    const t = $63c47e8a587a7f36$var$__PRIVATE_normalizeTimestamp(e.mapValue.fields[$63c47e8a587a7f36$var$it].timestampValue);
    return new $63c47e8a587a7f36$export$3d12bd131bb975d1(t.seconds, t.nanos);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $63c47e8a587a7f36$var$DatabaseInfo {
    /**
     * Constructs a DatabaseInfo using the provided host, databaseId and
     * persistenceKey.
     *
     * @param databaseId - The database to use.
     * @param appId - The Firebase App Id.
     * @param persistenceKey - A unique identifier for this Firestore's local
     * storage (used in conjunction with the databaseId).
     * @param host - The Firestore backend host to connect to.
     * @param ssl - Whether to use SSL when connecting.
     * @param forceLongPolling - Whether to use the forceLongPolling option
     * when using WebChannel as the network transport.
     * @param autoDetectLongPolling - Whether to use the detectBufferingProxy
     * option when using WebChannel as the network transport.
     * @param longPollingOptions - Options that configure long-polling.
     * @param useFetchStreams - Whether to use the Fetch API instead of
     * XMLHTTPRequest
     */ constructor(e, t, n, r, i, s, o, _, a, u, c){
        this.databaseId = e, this.appId = t, this.persistenceKey = n, this.host = r, this.ssl = i, this.forceLongPolling = s, this.autoDetectLongPolling = o, this.longPollingOptions = _, this.useFetchStreams = a, this.isUsingEmulator = u, this.apiKey = c;
    }
}
/** The default database name for a project. */ const $63c47e8a587a7f36$var$st = "(default)";
/**
 * Represents the database ID a Firestore client is associated with.
 * @internal
 */ class $63c47e8a587a7f36$export$890c4ad488842ce7 {
    constructor(e, t){
        this.projectId = e, this.database = t || $63c47e8a587a7f36$var$st;
    }
    static empty() {
        return new $63c47e8a587a7f36$export$890c4ad488842ce7("", "");
    }
    get isDefaultDatabase() {
        return this.database === $63c47e8a587a7f36$var$st;
    }
    isEqual(e) {
        return e instanceof $63c47e8a587a7f36$export$890c4ad488842ce7 && e.projectId === this.projectId && e.database === this.database;
    }
}
function $63c47e8a587a7f36$export$db3b6bfb95261072(e, t) {
    if (!Object.prototype.hasOwnProperty.apply(e.options, [
        "projectId"
    ])) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
    return new $63c47e8a587a7f36$export$890c4ad488842ce7(e.options.projectId, t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $63c47e8a587a7f36$var$ot = "__type__", $63c47e8a587a7f36$var$_t = "__max__", $63c47e8a587a7f36$var$at = {
    mapValue: {
        fields: {
            __type__: {
                stringValue: $63c47e8a587a7f36$var$_t
            }
        }
    }
}, $63c47e8a587a7f36$var$ut = "__vector__", $63c47e8a587a7f36$var$ct = "value", $63c47e8a587a7f36$var$lt = {
    nullValue: "NULL_VALUE"
};
/** Extracts the backend's type order for the provided value. */ function $63c47e8a587a7f36$var$__PRIVATE_typeOrder(e) {
    return "nullValue" in e ? 0 /* TypeOrder.NullValue */  : "booleanValue" in e ? 1 /* TypeOrder.BooleanValue */  : "integerValue" in e || "doubleValue" in e ? 2 /* TypeOrder.NumberValue */  : "timestampValue" in e ? 3 /* TypeOrder.TimestampValue */  : "stringValue" in e ? 5 /* TypeOrder.StringValue */  : "bytesValue" in e ? 6 /* TypeOrder.BlobValue */  : "referenceValue" in e ? 7 /* TypeOrder.RefValue */  : "geoPointValue" in e ? 8 /* TypeOrder.GeoPointValue */  : "arrayValue" in e ? 9 /* TypeOrder.ArrayValue */  : "mapValue" in e ? $63c47e8a587a7f36$export$2408f22a0fab9ae5(e) ? 4 /* TypeOrder.ServerTimestampValue */  : $63c47e8a587a7f36$var$__PRIVATE_isMaxValue(e) ? 9007199254740991 /* TypeOrder.MaxValue */  : $63c47e8a587a7f36$var$__PRIVATE_isVectorValue(e) ? 10 /* TypeOrder.VectorValue */  : 11 /* TypeOrder.ObjectValue */  : $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(28295, {
        value: e
    });
}
/** Tests `left` and `right` for equality based on the backend semantics. */ function $63c47e8a587a7f36$var$__PRIVATE_valueEquals(e, t) {
    if (e === t) return !0;
    const n = $63c47e8a587a7f36$var$__PRIVATE_typeOrder(e);
    if (n !== $63c47e8a587a7f36$var$__PRIVATE_typeOrder(t)) return !1;
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return !0;
        case 1 /* TypeOrder.BooleanValue */ :
            return e.booleanValue === t.booleanValue;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $63c47e8a587a7f36$var$__PRIVATE_getLocalWriteTime(e).isEqual($63c47e8a587a7f36$var$__PRIVATE_getLocalWriteTime(t));
        case 3 /* TypeOrder.TimestampValue */ :
            return function __PRIVATE_timestampEquals(e, t) {
                if ("string" == typeof e.timestampValue && "string" == typeof t.timestampValue && e.timestampValue.length === t.timestampValue.length) // Use string equality for ISO 8601 timestamps
                return e.timestampValue === t.timestampValue;
                const n = $63c47e8a587a7f36$var$__PRIVATE_normalizeTimestamp(e.timestampValue), r = $63c47e8a587a7f36$var$__PRIVATE_normalizeTimestamp(t.timestampValue);
                return n.seconds === r.seconds && n.nanos === r.nanos;
            }(e, t);
        case 5 /* TypeOrder.StringValue */ :
            return e.stringValue === t.stringValue;
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_blobEquals(e, t) {
                return $63c47e8a587a7f36$var$__PRIVATE_normalizeByteString(e.bytesValue).isEqual($63c47e8a587a7f36$var$__PRIVATE_normalizeByteString(t.bytesValue));
            }(e, t);
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue === t.referenceValue;
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_geoPointEquals(e, t) {
                return $63c47e8a587a7f36$var$__PRIVATE_normalizeNumber(e.geoPointValue.latitude) === $63c47e8a587a7f36$var$__PRIVATE_normalizeNumber(t.geoPointValue.latitude) && $63c47e8a587a7f36$var$__PRIVATE_normalizeNumber(e.geoPointValue.longitude) === $63c47e8a587a7f36$var$__PRIVATE_normalizeNumber(t.geoPointValue.longitude);
            }(e, t);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_numberEquals(e, t) {
                if ("integerValue" in e && "integerValue" in t) return $63c47e8a587a7f36$var$__PRIVATE_normalizeNumber(e.integerValue) === $63c47e8a587a7f36$var$__PRIVATE_normalizeNumber(t.integerValue);
                if ("doubleValue" in e && "doubleValue" in t) {
                    const n = $63c47e8a587a7f36$var$__PRIVATE_normalizeNumber(e.doubleValue), r = $63c47e8a587a7f36$var$__PRIVATE_normalizeNumber(t.doubleValue);
                    return n === r ? $63c47e8a587a7f36$var$__PRIVATE_isNegativeZero(n) === $63c47e8a587a7f36$var$__PRIVATE_isNegativeZero(r) : isNaN(n) && isNaN(r);
                }
                return !1;
            }(e, t);
        case 9 /* TypeOrder.ArrayValue */ :
            return $63c47e8a587a7f36$var$__PRIVATE_arrayEquals(e.arrayValue.values || [], t.arrayValue.values || [], $63c47e8a587a7f36$var$__PRIVATE_valueEquals);
        case 10 /* TypeOrder.VectorValue */ :
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_objectEquals(e, t) {
                const n = e.mapValue.fields || {}, r = t.mapValue.fields || {};
                if ($63c47e8a587a7f36$var$__PRIVATE_objectSize(n) !== $63c47e8a587a7f36$var$__PRIVATE_objectSize(r)) return !1;
                for(const e in n)if (n.hasOwnProperty(e) && (void 0 === r[e] || !$63c47e8a587a7f36$var$__PRIVATE_valueEquals(n[e], r[e]))) return !1;
                return !0;
            }(e, t);
        default:
            return $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(52216, {
                left: e
            });
    }
}
function $63c47e8a587a7f36$var$__PRIVATE_arrayValueContains(e, t) {
    return void 0 !== (e.values || []).find((e)=>$63c47e8a587a7f36$var$__PRIVATE_valueEquals(e, t));
}
function $63c47e8a587a7f36$var$__PRIVATE_valueCompare(e, t) {
    if (e === t) return 0;
    const n = $63c47e8a587a7f36$var$__PRIVATE_typeOrder(e), r = $63c47e8a587a7f36$var$__PRIVATE_typeOrder(t);
    if (n !== r) return $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(n, r);
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return 0;
        case 1 /* TypeOrder.BooleanValue */ :
            return $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(e.booleanValue, t.booleanValue);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_compareNumbers(e, t) {
                const n = $63c47e8a587a7f36$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue), r = $63c47e8a587a7f36$var$__PRIVATE_normalizeNumber(t.integerValue || t.doubleValue);
                return n < r ? -1 : n > r ? 1 : n === r ? 0 : // one or both are NaN.
                isNaN(n) ? isNaN(r) ? 0 : -1 : 1;
            }(e, t);
        case 3 /* TypeOrder.TimestampValue */ :
            return $63c47e8a587a7f36$var$__PRIVATE_compareTimestamps(e.timestampValue, t.timestampValue);
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $63c47e8a587a7f36$var$__PRIVATE_compareTimestamps($63c47e8a587a7f36$var$__PRIVATE_getLocalWriteTime(e), $63c47e8a587a7f36$var$__PRIVATE_getLocalWriteTime(t));
        case 5 /* TypeOrder.StringValue */ :
            return $63c47e8a587a7f36$var$__PRIVATE_compareUtf8Strings(e.stringValue, t.stringValue);
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_compareBlobs(e, t) {
                const n = $63c47e8a587a7f36$var$__PRIVATE_normalizeByteString(e), r = $63c47e8a587a7f36$var$__PRIVATE_normalizeByteString(t);
                return n.compareTo(r);
            }(e.bytesValue, t.bytesValue);
        case 7 /* TypeOrder.RefValue */ :
            return function __PRIVATE_compareReferences(e, t) {
                const n = e.split("/"), r = t.split("/");
                for(let e = 0; e < n.length && e < r.length; e++){
                    const t = $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(n[e], r[e]);
                    if (0 !== t) return t;
                }
                return $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(n.length, r.length);
            }(e.referenceValue, t.referenceValue);
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_compareGeoPoints(e, t) {
                const n = $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator($63c47e8a587a7f36$var$__PRIVATE_normalizeNumber(e.latitude), $63c47e8a587a7f36$var$__PRIVATE_normalizeNumber(t.latitude));
                if (0 !== n) return n;
                return $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator($63c47e8a587a7f36$var$__PRIVATE_normalizeNumber(e.longitude), $63c47e8a587a7f36$var$__PRIVATE_normalizeNumber(t.longitude));
            }(e.geoPointValue, t.geoPointValue);
        case 9 /* TypeOrder.ArrayValue */ :
            return $63c47e8a587a7f36$var$__PRIVATE_compareArrays(e.arrayValue, t.arrayValue);
        case 10 /* TypeOrder.VectorValue */ :
            return function __PRIVATE_compareVectors(e, t) {
                const n = e.fields || {}, r = t.fields || {}, i = n[$63c47e8a587a7f36$var$ct]?.arrayValue, s = r[$63c47e8a587a7f36$var$ct]?.arrayValue, o = $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(i?.values?.length || 0, s?.values?.length || 0);
                if (0 !== o) return o;
                return $63c47e8a587a7f36$var$__PRIVATE_compareArrays(i, s);
            }(e.mapValue, t.mapValue);
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_compareMaps(e, t) {
                if (e === $63c47e8a587a7f36$var$at.mapValue && t === $63c47e8a587a7f36$var$at.mapValue) return 0;
                if (e === $63c47e8a587a7f36$var$at.mapValue) return 1;
                if (t === $63c47e8a587a7f36$var$at.mapValue) return -1;
                const n = e.fields || {}, r = Object.keys(n), i = t.fields || {}, s = Object.keys(i);
                // Even though MapValues are likely sorted correctly based on their insertion
                // order (e.g. when received from the backend), local modifications can bring
                // elements out of order. We need to re-sort the elements to ensure that
                // canonical IDs are independent of insertion order.
                r.sort(), s.sort();
                for(let e = 0; e < r.length && e < s.length; ++e){
                    const t = $63c47e8a587a7f36$var$__PRIVATE_compareUtf8Strings(r[e], s[e]);
                    if (0 !== t) return t;
                    const o = $63c47e8a587a7f36$var$__PRIVATE_valueCompare(n[r[e]], i[s[e]]);
                    if (0 !== o) return o;
                }
                return $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(r.length, s.length);
            }(e.mapValue, t.mapValue);
        default:
            throw $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(23264, {
                he: n
            });
    }
}
function $63c47e8a587a7f36$var$__PRIVATE_compareTimestamps(e, t) {
    if ("string" == typeof e && "string" == typeof t && e.length === t.length) return $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(e, t);
    const n = $63c47e8a587a7f36$var$__PRIVATE_normalizeTimestamp(e), r = $63c47e8a587a7f36$var$__PRIVATE_normalizeTimestamp(t), i = $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(n.seconds, r.seconds);
    return 0 !== i ? i : $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(n.nanos, r.nanos);
}
function $63c47e8a587a7f36$var$__PRIVATE_compareArrays(e, t) {
    const n = e.values || [], r = t.values || [];
    for(let e = 0; e < n.length && e < r.length; ++e){
        const t = $63c47e8a587a7f36$var$__PRIVATE_valueCompare(n[e], r[e]);
        if (t) return t;
    }
    return $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(n.length, r.length);
}
function $63c47e8a587a7f36$var$canonicalId(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_canonifyValue(e);
}
function $63c47e8a587a7f36$var$__PRIVATE_canonifyValue(e) {
    return "nullValue" in e ? "null" : "booleanValue" in e ? "" + e.booleanValue : "integerValue" in e ? "" + e.integerValue : "doubleValue" in e ? "" + e.doubleValue : "timestampValue" in e ? function __PRIVATE_canonifyTimestamp(e) {
        const t = $63c47e8a587a7f36$var$__PRIVATE_normalizeTimestamp(e);
        return `time(${t.seconds},${t.nanos})`;
    }(e.timestampValue) : "stringValue" in e ? e.stringValue : "bytesValue" in e ? function __PRIVATE_canonifyByteString(e) {
        return $63c47e8a587a7f36$var$__PRIVATE_normalizeByteString(e).toBase64();
    }(e.bytesValue) : "referenceValue" in e ? function __PRIVATE_canonifyReference(e) {
        return $63c47e8a587a7f36$export$90a7f3efeed30595.fromName(e).toString();
    }(e.referenceValue) : "geoPointValue" in e ? function __PRIVATE_canonifyGeoPoint(e) {
        return `geo(${e.latitude},${e.longitude})`;
    }(e.geoPointValue) : "arrayValue" in e ? function __PRIVATE_canonifyArray(e) {
        let t = "[", n = !0;
        for (const r of e.values || [])n ? n = !1 : t += ",", t += $63c47e8a587a7f36$var$__PRIVATE_canonifyValue(r);
        return t + "]";
    }(e.arrayValue) : "mapValue" in e ? function __PRIVATE_canonifyMap(e) {
        // Iteration order in JavaScript is not guaranteed. To ensure that we generate
        // matching canonical IDs for identical maps, we need to sort the keys.
        const t = Object.keys(e.fields || {}).sort();
        let n = "{", r = !0;
        for (const i of t)r ? r = !1 : n += ",", n += `${i}:${$63c47e8a587a7f36$var$__PRIVATE_canonifyValue(e.fields[i])}`;
        return n + "}";
    }(e.mapValue) : $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(61005, {
        value: e
    });
}
function $63c47e8a587a7f36$var$__PRIVATE_estimateByteSize(e) {
    switch($63c47e8a587a7f36$var$__PRIVATE_typeOrder(e)){
        case 0 /* TypeOrder.NullValue */ :
        case 1 /* TypeOrder.BooleanValue */ :
            return 4;
        case 2 /* TypeOrder.NumberValue */ :
            return 8;
        case 3 /* TypeOrder.TimestampValue */ :
        case 8 /* TypeOrder.GeoPointValue */ :
            // GeoPoints are made up of two distinct numbers (latitude + longitude)
            return 16;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            const t = $63c47e8a587a7f36$var$__PRIVATE_getPreviousValue(e);
            return t ? 16 + $63c47e8a587a7f36$var$__PRIVATE_estimateByteSize(t) : 16;
        case 5 /* TypeOrder.StringValue */ :
            // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Data_structures:
            // "JavaScript's String type is [...] a set of elements of 16-bit unsigned
            // integer values"
            return 2 * e.stringValue.length;
        case 6 /* TypeOrder.BlobValue */ :
            return $63c47e8a587a7f36$var$__PRIVATE_normalizeByteString(e.bytesValue).approximateByteSize();
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue.length;
        case 9 /* TypeOrder.ArrayValue */ :
            return function __PRIVATE_estimateArrayByteSize(e) {
                return (e.values || []).reduce((e, t)=>e + $63c47e8a587a7f36$var$__PRIVATE_estimateByteSize(t), 0);
            }(e.arrayValue);
        case 10 /* TypeOrder.VectorValue */ :
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_estimateMapByteSize(e) {
                let t = 0;
                return $63c47e8a587a7f36$var$forEach(e.fields, (e, n)=>{
                    t += e.length + $63c47e8a587a7f36$var$__PRIVATE_estimateByteSize(n);
                }), t;
            }(e.mapValue);
        default:
            throw $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(13486, {
                value: e
            });
    }
}
function $63c47e8a587a7f36$export$43caf9889c228507(e, t) {
    return {
        referenceValue: `projects/${e.projectId}/databases/${e.database}/documents/${t.path.canonicalString()}`
    };
}
/** Returns true if `value` is an IntegerValue . */ function $63c47e8a587a7f36$var$isInteger(e) {
    return !!e && "integerValue" in e;
}
/** Returns true if `value` is a DoubleValue. */ /** Returns true if `value` is an ArrayValue. */ function $63c47e8a587a7f36$var$isArray(e) {
    return !!e && "arrayValue" in e;
}
/** Returns true if `value` is a NullValue. */ function $63c47e8a587a7f36$var$__PRIVATE_isNullValue(e) {
    return !!e && "nullValue" in e;
}
/** Returns true if `value` is NaN. */ function $63c47e8a587a7f36$var$__PRIVATE_isNanValue(e) {
    return !!e && "doubleValue" in e && isNaN(Number(e.doubleValue));
}
/** Returns true if `value` is a MapValue. */ function $63c47e8a587a7f36$var$__PRIVATE_isMapValue(e) {
    return !!e && "mapValue" in e;
}
/** Returns true if `value` is a VetorValue. */ function $63c47e8a587a7f36$var$__PRIVATE_isVectorValue(e) {
    const t = (e?.mapValue?.fields || {})[$63c47e8a587a7f36$var$ot]?.stringValue;
    return t === $63c47e8a587a7f36$var$ut;
}
/** Creates a deep copy of `source`. */ function $63c47e8a587a7f36$var$__PRIVATE_deepClone(e) {
    if (e.geoPointValue) return {
        geoPointValue: {
            ...e.geoPointValue
        }
    };
    if (e.timestampValue && "object" == typeof e.timestampValue) return {
        timestampValue: {
            ...e.timestampValue
        }
    };
    if (e.mapValue) {
        const t = {
            mapValue: {
                fields: {}
            }
        };
        return $63c47e8a587a7f36$var$forEach(e.mapValue.fields, (e, n)=>t.mapValue.fields[e] = $63c47e8a587a7f36$var$__PRIVATE_deepClone(n)), t;
    }
    if (e.arrayValue) {
        const t = {
            arrayValue: {
                values: []
            }
        };
        for(let n = 0; n < (e.arrayValue.values || []).length; ++n)t.arrayValue.values[n] = $63c47e8a587a7f36$var$__PRIVATE_deepClone(e.arrayValue.values[n]);
        return t;
    }
    return {
        ...e
    };
}
/** Returns true if the Value represents the canonical {@link #MAX_VALUE} . */ function $63c47e8a587a7f36$var$__PRIVATE_isMaxValue(e) {
    return (((e.mapValue || {}).fields || {}).__type__ || {}).stringValue === $63c47e8a587a7f36$var$_t;
}
const $63c47e8a587a7f36$var$ht = {
    mapValue: {
        fields: {
            [$63c47e8a587a7f36$var$ot]: {
                stringValue: $63c47e8a587a7f36$var$ut
            },
            [$63c47e8a587a7f36$var$ct]: {
                arrayValue: {}
            }
        }
    }
};
/** Returns the lowest value for the given value type (inclusive). */ function $63c47e8a587a7f36$var$__PRIVATE_valuesGetLowerBound(e) {
    return "nullValue" in e ? $63c47e8a587a7f36$var$lt : "booleanValue" in e ? {
        booleanValue: !1
    } : "integerValue" in e || "doubleValue" in e ? {
        doubleValue: NaN
    } : "timestampValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "stringValue" in e ? {
        stringValue: ""
    } : "bytesValue" in e ? {
        bytesValue: ""
    } : "referenceValue" in e ? $63c47e8a587a7f36$export$43caf9889c228507($63c47e8a587a7f36$export$890c4ad488842ce7.empty(), $63c47e8a587a7f36$export$90a7f3efeed30595.empty()) : "geoPointValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "arrayValue" in e ? {
        arrayValue: {}
    } : "mapValue" in e ? $63c47e8a587a7f36$var$__PRIVATE_isVectorValue(e) ? $63c47e8a587a7f36$var$ht : {
        mapValue: {}
    } : $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(35942, {
        value: e
    });
}
/** Returns the largest value for the given value type (exclusive). */ function $63c47e8a587a7f36$var$__PRIVATE_valuesGetUpperBound(e) {
    return "nullValue" in e ? {
        booleanValue: !1
    } : "booleanValue" in e ? {
        doubleValue: NaN
    } : "integerValue" in e || "doubleValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "timestampValue" in e ? {
        stringValue: ""
    } : "stringValue" in e ? {
        bytesValue: ""
    } : "bytesValue" in e ? $63c47e8a587a7f36$export$43caf9889c228507($63c47e8a587a7f36$export$890c4ad488842ce7.empty(), $63c47e8a587a7f36$export$90a7f3efeed30595.empty()) : "referenceValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "geoPointValue" in e ? {
        arrayValue: {}
    } : "arrayValue" in e ? $63c47e8a587a7f36$var$ht : "mapValue" in e ? $63c47e8a587a7f36$var$__PRIVATE_isVectorValue(e) ? {
        mapValue: {}
    } : $63c47e8a587a7f36$var$at : $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(61959, {
        value: e
    });
}
function $63c47e8a587a7f36$var$__PRIVATE_lowerBoundCompare(e, t) {
    const n = $63c47e8a587a7f36$var$__PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? -1 : !e.inclusive && t.inclusive ? 1 : 0;
}
function $63c47e8a587a7f36$var$__PRIVATE_upperBoundCompare(e, t) {
    const n = $63c47e8a587a7f36$var$__PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? 1 : !e.inclusive && t.inclusive ? -1 : 0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ObjectValue represents a MapValue in the Firestore Proto and offers the
 * ability to add and remove fields (via the ObjectValueBuilder).
 */ class $63c47e8a587a7f36$export$c4ce752e73470fba {
    constructor(e){
        this.value = e;
    }
    static empty() {
        return new $63c47e8a587a7f36$export$c4ce752e73470fba({
            mapValue: {}
        });
    }
    /**
     * Returns the value at the given path or null.
     *
     * @param path - the path to search
     * @returns The value at the path or null if the path is not set.
     */ field(e) {
        if (e.isEmpty()) return this.value;
        {
            let t = this.value;
            for(let n = 0; n < e.length - 1; ++n)if (t = (t.mapValue.fields || {})[e.get(n)], !$63c47e8a587a7f36$var$__PRIVATE_isMapValue(t)) return null;
            return t = (t.mapValue.fields || {})[e.lastSegment()], t || null;
        }
    }
    /**
     * Sets the field to the provided value.
     *
     * @param path - The field path to set.
     * @param value - The value to set.
     */ set(e, t) {
        this.getFieldsMap(e.popLast())[e.lastSegment()] = $63c47e8a587a7f36$var$__PRIVATE_deepClone(t);
    }
    /**
     * Sets the provided fields to the provided values.
     *
     * @param data - A map of fields to values (or null for deletes).
     */ setAll(e) {
        let t = $63c47e8a587a7f36$export$cf2f7c5792f80b46.emptyPath(), n = {}, r = [];
        e.forEach((e, i)=>{
            if (!t.isImmediateParentOf(i)) {
                // Insert the accumulated changes at this parent location
                const e = this.getFieldsMap(t);
                this.applyChanges(e, n, r), n = {}, r = [], t = i.popLast();
            }
            e ? n[i.lastSegment()] = $63c47e8a587a7f36$var$__PRIVATE_deepClone(e) : r.push(i.lastSegment());
        });
        const i = this.getFieldsMap(t);
        this.applyChanges(i, n, r);
    }
    /**
     * Removes the field at the specified path. If there is no field at the
     * specified path, nothing is changed.
     *
     * @param path - The field path to remove.
     */ delete(e) {
        const t = this.field(e.popLast());
        $63c47e8a587a7f36$var$__PRIVATE_isMapValue(t) && t.mapValue.fields && delete t.mapValue.fields[e.lastSegment()];
    }
    isEqual(e) {
        return $63c47e8a587a7f36$var$__PRIVATE_valueEquals(this.value, e.value);
    }
    /**
     * Returns the map that contains the leaf element of `path`. If the parent
     * entry does not yet exist, or if it is not a map, a new map will be created.
     */ getFieldsMap(e) {
        let t = this.value;
        t.mapValue.fields || (t.mapValue = {
            fields: {}
        });
        for(let n = 0; n < e.length; ++n){
            let r = t.mapValue.fields[e.get(n)];
            $63c47e8a587a7f36$var$__PRIVATE_isMapValue(r) && r.mapValue.fields || (r = {
                mapValue: {
                    fields: {}
                }
            }, t.mapValue.fields[e.get(n)] = r), t = r;
        }
        return t.mapValue.fields;
    }
    /**
     * Modifies `fieldsMap` by adding, replacing or deleting the specified
     * entries.
     */ applyChanges(e, t, n) {
        $63c47e8a587a7f36$var$forEach(t, (t, n)=>e[t] = n);
        for (const t of n)delete e[t];
    }
    clone() {
        return new $63c47e8a587a7f36$export$c4ce752e73470fba($63c47e8a587a7f36$var$__PRIVATE_deepClone(this.value));
    }
}
/**
 * Returns a FieldMask built from all fields in a MapValue.
 */ function $63c47e8a587a7f36$var$__PRIVATE_extractFieldMask(e) {
    const t = [];
    return $63c47e8a587a7f36$var$forEach(e.fields, (e, n)=>{
        const r = new $63c47e8a587a7f36$export$cf2f7c5792f80b46([
            e
        ]);
        if ($63c47e8a587a7f36$var$__PRIVATE_isMapValue(n)) {
            const e = $63c47e8a587a7f36$var$__PRIVATE_extractFieldMask(n.mapValue).fields;
            if (0 === e.length) // Preserve the empty map by adding it to the FieldMask.
            t.push(r);
            else // For nested and non-empty ObjectValues, add the FieldPath of the
            // leaf nodes.
            for (const n of e)t.push(r.child(n));
        } else // For nested and non-empty ObjectValues, add the FieldPath of the leaf
        // nodes.
        t.push(r);
    }), new $63c47e8a587a7f36$var$FieldMask(t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a document in Firestore with a key, version, data and whether it
 * has local mutations applied to it.
 *
 * Documents can transition between states via `convertToFoundDocument()`,
 * `convertToNoDocument()` and `convertToUnknownDocument()`. If a document does
 * not transition to one of these states even after all mutations have been
 * applied, `isValidDocument()` returns false and the document should be removed
 * from all views.
 */ class $63c47e8a587a7f36$var$MutableDocument {
    constructor(e, t, n, r, i, s, o){
        this.key = e, this.documentType = t, this.version = n, this.readTime = r, this.createTime = i, this.data = s, this.documentState = o;
    }
    /**
     * Creates a document with no known version or data, but which can serve as
     * base document for mutations.
     */ static newInvalidDocument(e) {
        return new $63c47e8a587a7f36$var$MutableDocument(e, 0 /* DocumentType.INVALID */ , /* version */ $63c47e8a587a7f36$var$SnapshotVersion.min(), /* readTime */ $63c47e8a587a7f36$var$SnapshotVersion.min(), /* createTime */ $63c47e8a587a7f36$var$SnapshotVersion.min(), $63c47e8a587a7f36$export$c4ce752e73470fba.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist with the given data at the
     * given version.
     */ static newFoundDocument(e, t, n, r) {
        return new $63c47e8a587a7f36$var$MutableDocument(e, 1 /* DocumentType.FOUND_DOCUMENT */ , /* version */ t, /* readTime */ $63c47e8a587a7f36$var$SnapshotVersion.min(), /* createTime */ n, r, 0 /* DocumentState.SYNCED */ );
    }
    /** Creates a new document that is known to not exist at the given version. */ static newNoDocument(e, t) {
        return new $63c47e8a587a7f36$var$MutableDocument(e, 2 /* DocumentType.NO_DOCUMENT */ , /* version */ t, /* readTime */ $63c47e8a587a7f36$var$SnapshotVersion.min(), /* createTime */ $63c47e8a587a7f36$var$SnapshotVersion.min(), $63c47e8a587a7f36$export$c4ce752e73470fba.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist at the given version but
     * whose data is not known (e.g. a document that was updated without a known
     * base document).
     */ static newUnknownDocument(e, t) {
        return new $63c47e8a587a7f36$var$MutableDocument(e, 3 /* DocumentType.UNKNOWN_DOCUMENT */ , /* version */ t, /* readTime */ $63c47e8a587a7f36$var$SnapshotVersion.min(), /* createTime */ $63c47e8a587a7f36$var$SnapshotVersion.min(), $63c47e8a587a7f36$export$c4ce752e73470fba.empty(), 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ );
    }
    /**
     * Changes the document type to indicate that it exists and that its version
     * and data are known.
     */ convertToFoundDocument(e, t) {
        // If a document is switching state from being an invalid or deleted
        // document to a valid (FOUND_DOCUMENT) document, either due to receiving an
        // update from Watch or due to applying a local set mutation on top
        // of a deleted document, our best guess about its createTime would be the
        // version at which the document transitioned to a FOUND_DOCUMENT.
        return !this.createTime.isEqual($63c47e8a587a7f36$var$SnapshotVersion.min()) || 2 /* DocumentType.NO_DOCUMENT */  !== this.documentType && 0 /* DocumentType.INVALID */  !== this.documentType || (this.createTime = e), this.version = e, this.documentType = 1 /* DocumentType.FOUND_DOCUMENT */ , this.data = t, this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it doesn't exist at the given
     * version.
     */ convertToNoDocument(e) {
        return this.version = e, this.documentType = 2 /* DocumentType.NO_DOCUMENT */ , this.data = $63c47e8a587a7f36$export$c4ce752e73470fba.empty(), this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it exists at a given version but
     * that its data is not known (e.g. a document that was updated without a known
     * base document).
     */ convertToUnknownDocument(e) {
        return this.version = e, this.documentType = 3 /* DocumentType.UNKNOWN_DOCUMENT */ , this.data = $63c47e8a587a7f36$export$c4ce752e73470fba.empty(), this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasCommittedMutations() {
        return this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasLocalMutations() {
        return this.documentState = 1 /* DocumentState.HAS_LOCAL_MUTATIONS */ , this.version = $63c47e8a587a7f36$var$SnapshotVersion.min(), this;
    }
    setReadTime(e) {
        return this.readTime = e, this;
    }
    get hasLocalMutations() {
        return 1 /* DocumentState.HAS_LOCAL_MUTATIONS */  === this.documentState;
    }
    get hasCommittedMutations() {
        return 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */  === this.documentState;
    }
    get hasPendingWrites() {
        return this.hasLocalMutations || this.hasCommittedMutations;
    }
    isValidDocument() {
        return 0 /* DocumentType.INVALID */  !== this.documentType;
    }
    isFoundDocument() {
        return 1 /* DocumentType.FOUND_DOCUMENT */  === this.documentType;
    }
    isNoDocument() {
        return 2 /* DocumentType.NO_DOCUMENT */  === this.documentType;
    }
    isUnknownDocument() {
        return 3 /* DocumentType.UNKNOWN_DOCUMENT */  === this.documentType;
    }
    isEqual(e) {
        return e instanceof $63c47e8a587a7f36$var$MutableDocument && this.key.isEqual(e.key) && this.version.isEqual(e.version) && this.documentType === e.documentType && this.documentState === e.documentState && this.data.isEqual(e.data);
    }
    mutableCopy() {
        return new $63c47e8a587a7f36$var$MutableDocument(this.key, this.documentType, this.version, this.readTime, this.createTime, this.data.clone(), this.documentState);
    }
    toString() {
        return `Document(${this.key}, ${this.version}, ${JSON.stringify(this.data.value)}, {createTime: ${this.createTime}}), {documentType: ${this.documentType}}), {documentState: ${this.documentState}})`;
    }
}
/**
 * Compares the value for field `field` in the provided documents. Throws if
 * the field does not exist in both documents.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a bound of a query.
 *
 * The bound is specified with the given components representing a position and
 * whether it's just before or just after the position (relative to whatever the
 * query order is).
 *
 * The position represents a logical index position for a query. It's a prefix
 * of values for the (potentially implicit) order by clauses of a query.
 *
 * Bound provides a function to determine whether a document comes before or
 * after a bound. This is influenced by whether the position is just before or
 * just after the provided values.
 */ class $63c47e8a587a7f36$export$625550452a3fa3ec {
    constructor(e, t){
        this.position = e, this.inclusive = t;
    }
}
function $63c47e8a587a7f36$var$__PRIVATE_boundCompareToDocument(e, t, n) {
    let r = 0;
    for(let i = 0; i < e.position.length; i++){
        const s = t[i], o = e.position[i];
        if (s.field.isKeyField()) r = $63c47e8a587a7f36$export$90a7f3efeed30595.comparator($63c47e8a587a7f36$export$90a7f3efeed30595.fromName(o.referenceValue), n.key);
        else r = $63c47e8a587a7f36$var$__PRIVATE_valueCompare(o, n.data.field(s.field));
        if ("desc" /* Direction.DESCENDING */  === s.dir && (r *= -1), 0 !== r) break;
    }
    return r;
}
/**
 * Returns true if a document sorts after a bound using the provided sort
 * order.
 */ function $63c47e8a587a7f36$var$__PRIVATE_boundEquals(e, t) {
    if (null === e) return null === t;
    if (null === t) return !1;
    if (e.inclusive !== t.inclusive || e.position.length !== t.position.length) return !1;
    for(let n = 0; n < e.position.length; n++){
        if (!$63c47e8a587a7f36$var$__PRIVATE_valueEquals(e.position[n], t.position[n])) return !1;
    }
    return !0;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */ class $63c47e8a587a7f36$export$306ddfe3a8403e2 {
    constructor(e, t = "asc" /* Direction.ASCENDING */ ){
        this.field = e, this.dir = t;
    }
}
function $63c47e8a587a7f36$var$__PRIVATE_orderByEquals(e, t) {
    return e.dir === t.dir && e.field.isEqual(t.field);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $63c47e8a587a7f36$var$Filter {
}
class $63c47e8a587a7f36$export$dda1d9f60106f0e9 extends $63c47e8a587a7f36$var$Filter {
    constructor(e, t, n){
        super(), this.field = e, this.op = t, this.value = n;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(e, t, n) {
        return e.isKeyField() ? "in" /* Operator.IN */  === t || "not-in" /* Operator.NOT_IN */  === t ? this.createKeyFieldInFilter(e, t, n) : new $63c47e8a587a7f36$var$__PRIVATE_KeyFieldFilter(e, t, n) : "array-contains" /* Operator.ARRAY_CONTAINS */  === t ? new $63c47e8a587a7f36$var$__PRIVATE_ArrayContainsFilter(e, n) : "in" /* Operator.IN */  === t ? new $63c47e8a587a7f36$var$__PRIVATE_InFilter(e, n) : "not-in" /* Operator.NOT_IN */  === t ? new $63c47e8a587a7f36$var$__PRIVATE_NotInFilter(e, n) : "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === t ? new $63c47e8a587a7f36$var$__PRIVATE_ArrayContainsAnyFilter(e, n) : new $63c47e8a587a7f36$export$dda1d9f60106f0e9(e, t, n);
    }
    static createKeyFieldInFilter(e, t, n) {
        return "in" /* Operator.IN */  === t ? new $63c47e8a587a7f36$var$__PRIVATE_KeyFieldInFilter(e, n) : new $63c47e8a587a7f36$var$__PRIVATE_KeyFieldNotInFilter(e, n);
    }
    matches(e) {
        const t = e.data.field(this.field);
        // Types do not have to match in NOT_EQUAL filters.
        return "!=" /* Operator.NOT_EQUAL */  === this.op ? null !== t && void 0 === t.nullValue && this.matchesComparison($63c47e8a587a7f36$var$__PRIVATE_valueCompare(t, this.value)) : null !== t && $63c47e8a587a7f36$var$__PRIVATE_typeOrder(this.value) === $63c47e8a587a7f36$var$__PRIVATE_typeOrder(t) && this.matchesComparison($63c47e8a587a7f36$var$__PRIVATE_valueCompare(t, this.value));
    // Only compare types with matching backend order (such as double and int).
    }
    matchesComparison(e) {
        switch(this.op){
            case "<" /* Operator.LESS_THAN */ :
                return e < 0;
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                return e <= 0;
            case "==" /* Operator.EQUAL */ :
                return 0 === e;
            case "!=" /* Operator.NOT_EQUAL */ :
                return 0 !== e;
            case ">" /* Operator.GREATER_THAN */ :
                return e > 0;
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                return e >= 0;
            default:
                return $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(47266, {
                    operator: this.op
                });
        }
    }
    isInequality() {
        return [
            "<" /* Operator.LESS_THAN */ ,
            "<=" /* Operator.LESS_THAN_OR_EQUAL */ ,
            ">" /* Operator.GREATER_THAN */ ,
            ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ,
            "!=" /* Operator.NOT_EQUAL */ ,
            "not-in" /* Operator.NOT_IN */ 
        ].indexOf(this.op) >= 0;
    }
    getFlattenedFilters() {
        return [
            this
        ];
    }
    getFilters() {
        return [
            this
        ];
    }
}
class $63c47e8a587a7f36$export$35e795649ee09318 extends $63c47e8a587a7f36$var$Filter {
    constructor(e, t){
        super(), this.filters = e, this.op = t, this.Pe = null;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(e, t) {
        return new $63c47e8a587a7f36$export$35e795649ee09318(e, t);
    }
    matches(e) {
        return $63c47e8a587a7f36$var$__PRIVATE_compositeFilterIsConjunction(this) ? void 0 === this.filters.find((t)=>!t.matches(e)) : void 0 !== this.filters.find((t)=>t.matches(e));
    }
    getFlattenedFilters() {
        return null !== this.Pe || (this.Pe = this.filters.reduce((e, t)=>e.concat(t.getFlattenedFilters()), [])), this.Pe;
    }
    // Returns a mutable copy of `this.filters`
    getFilters() {
        return Object.assign([], this.filters);
    }
}
function $63c47e8a587a7f36$var$__PRIVATE_compositeFilterIsConjunction(e) {
    return "and" /* CompositeOperator.AND */  === e.op;
}
function $63c47e8a587a7f36$var$__PRIVATE_compositeFilterIsDisjunction(e) {
    return "or" /* CompositeOperator.OR */  === e.op;
}
/**
 * Returns true if this filter is a conjunction of field filters only. Returns false otherwise.
 */ function $63c47e8a587a7f36$var$__PRIVATE_compositeFilterIsFlatConjunction(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_compositeFilterIsFlat(e) && $63c47e8a587a7f36$var$__PRIVATE_compositeFilterIsConjunction(e);
}
/**
 * Returns true if this filter does not contain any composite filters. Returns false otherwise.
 */ function $63c47e8a587a7f36$var$__PRIVATE_compositeFilterIsFlat(e) {
    for (const t of e.filters)if (t instanceof $63c47e8a587a7f36$export$35e795649ee09318) return !1;
    return !0;
}
function $63c47e8a587a7f36$var$__PRIVATE_canonifyFilter(e) {
    if (e instanceof $63c47e8a587a7f36$export$dda1d9f60106f0e9) // TODO(b/29183165): Technically, this won't be unique if two values have
    // the same description, such as the int 3 and the string "3". So we should
    // add the types in here somehow, too.
    return e.field.canonicalString() + e.op.toString() + $63c47e8a587a7f36$var$canonicalId(e.value);
    if ($63c47e8a587a7f36$var$__PRIVATE_compositeFilterIsFlatConjunction(e)) // Older SDK versions use an implicit AND operation between their filters.
    // In the new SDK versions, the developer may use an explicit AND filter.
    // To stay consistent with the old usages, we add a special case to ensure
    // the canonical ID for these two are the same. For example:
    // `col.whereEquals("a", 1).whereEquals("b", 2)` should have the same
    // canonical ID as `col.where(and(equals("a",1), equals("b",2)))`.
    return e.filters.map((e)=>$63c47e8a587a7f36$var$__PRIVATE_canonifyFilter(e)).join(",");
    {
        // filter instanceof CompositeFilter
        const t = e.filters.map((e)=>$63c47e8a587a7f36$var$__PRIVATE_canonifyFilter(e)).join(",");
        return `${e.op}(${t})`;
    }
}
function $63c47e8a587a7f36$var$__PRIVATE_filterEquals(e, t) {
    return e instanceof $63c47e8a587a7f36$export$dda1d9f60106f0e9 ? function __PRIVATE_fieldFilterEquals(e, t) {
        return t instanceof $63c47e8a587a7f36$export$dda1d9f60106f0e9 && e.op === t.op && e.field.isEqual(t.field) && $63c47e8a587a7f36$var$__PRIVATE_valueEquals(e.value, t.value);
    }(e, t) : e instanceof $63c47e8a587a7f36$export$35e795649ee09318 ? function __PRIVATE_compositeFilterEquals(e, t) {
        if (t instanceof $63c47e8a587a7f36$export$35e795649ee09318 && e.op === t.op && e.filters.length === t.filters.length) return e.filters.reduce((e, n, r)=>e && $63c47e8a587a7f36$var$__PRIVATE_filterEquals(n, t.filters[r]), !0);
        return !1;
    }(e, t) : void $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(19439);
}
function $63c47e8a587a7f36$var$__PRIVATE_compositeFilterWithAddedFilters(e, t) {
    const n = e.filters.concat(t);
    return $63c47e8a587a7f36$export$35e795649ee09318.create(n, e.op);
}
/** Returns a debug description for `filter`. */ function $63c47e8a587a7f36$var$__PRIVATE_stringifyFilter(e) {
    return e instanceof $63c47e8a587a7f36$export$dda1d9f60106f0e9 ? function __PRIVATE_stringifyFieldFilter(e) {
        return `${e.field.canonicalString()} ${e.op} ${$63c47e8a587a7f36$var$canonicalId(e.value)}`;
    }(e) : e instanceof $63c47e8a587a7f36$export$35e795649ee09318 ? function __PRIVATE_stringifyCompositeFilter(e) {
        return e.op.toString() + " {" + e.getFilters().map($63c47e8a587a7f36$var$__PRIVATE_stringifyFilter).join(" ,") + "}";
    }(e) : "Filter";
}
class $63c47e8a587a7f36$var$__PRIVATE_KeyFieldFilter extends $63c47e8a587a7f36$export$dda1d9f60106f0e9 {
    constructor(e, t, n){
        super(e, t, n), this.key = $63c47e8a587a7f36$export$90a7f3efeed30595.fromName(n.referenceValue);
    }
    matches(e) {
        const t = $63c47e8a587a7f36$export$90a7f3efeed30595.comparator(e.key, this.key);
        return this.matchesComparison(t);
    }
}
/** Filter that matches on key fields within an array. */ class $63c47e8a587a7f36$var$__PRIVATE_KeyFieldInFilter extends $63c47e8a587a7f36$export$dda1d9f60106f0e9 {
    constructor(e, t){
        super(e, "in" /* Operator.IN */ , t), this.keys = $63c47e8a587a7f36$var$__PRIVATE_extractDocumentKeysFromArrayValue("in" /* Operator.IN */ , t);
    }
    matches(e) {
        return this.keys.some((t)=>t.isEqual(e.key));
    }
}
/** Filter that matches on key fields not present within an array. */ class $63c47e8a587a7f36$var$__PRIVATE_KeyFieldNotInFilter extends $63c47e8a587a7f36$export$dda1d9f60106f0e9 {
    constructor(e, t){
        super(e, "not-in" /* Operator.NOT_IN */ , t), this.keys = $63c47e8a587a7f36$var$__PRIVATE_extractDocumentKeysFromArrayValue("not-in" /* Operator.NOT_IN */ , t);
    }
    matches(e) {
        return !this.keys.some((t)=>t.isEqual(e.key));
    }
}
function $63c47e8a587a7f36$var$__PRIVATE_extractDocumentKeysFromArrayValue(e, t) {
    return (t.arrayValue?.values || []).map((e)=>$63c47e8a587a7f36$export$90a7f3efeed30595.fromName(e.referenceValue));
}
/** A Filter that implements the array-contains operator. */ class $63c47e8a587a7f36$var$__PRIVATE_ArrayContainsFilter extends $63c47e8a587a7f36$export$dda1d9f60106f0e9 {
    constructor(e, t){
        super(e, "array-contains" /* Operator.ARRAY_CONTAINS */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return $63c47e8a587a7f36$var$isArray(t) && $63c47e8a587a7f36$var$__PRIVATE_arrayValueContains(t.arrayValue, this.value);
    }
}
/** A Filter that implements the IN operator. */ class $63c47e8a587a7f36$var$__PRIVATE_InFilter extends $63c47e8a587a7f36$export$dda1d9f60106f0e9 {
    constructor(e, t){
        super(e, "in" /* Operator.IN */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return null !== t && $63c47e8a587a7f36$var$__PRIVATE_arrayValueContains(this.value.arrayValue, t);
    }
}
/** A Filter that implements the not-in operator. */ class $63c47e8a587a7f36$var$__PRIVATE_NotInFilter extends $63c47e8a587a7f36$export$dda1d9f60106f0e9 {
    constructor(e, t){
        super(e, "not-in" /* Operator.NOT_IN */ , t);
    }
    matches(e) {
        if ($63c47e8a587a7f36$var$__PRIVATE_arrayValueContains(this.value.arrayValue, {
            nullValue: "NULL_VALUE"
        })) return !1;
        const t = e.data.field(this.field);
        return null !== t && void 0 === t.nullValue && !$63c47e8a587a7f36$var$__PRIVATE_arrayValueContains(this.value.arrayValue, t);
    }
}
/** A Filter that implements the array-contains-any operator. */ class $63c47e8a587a7f36$var$__PRIVATE_ArrayContainsAnyFilter extends $63c47e8a587a7f36$export$dda1d9f60106f0e9 {
    constructor(e, t){
        super(e, "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return !(!$63c47e8a587a7f36$var$isArray(t) || !t.arrayValue.values) && t.arrayValue.values.some((e)=>$63c47e8a587a7f36$var$__PRIVATE_arrayValueContains(this.value.arrayValue, e));
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Visible for testing
class $63c47e8a587a7f36$var$__PRIVATE_TargetImpl {
    constructor(e, t = null, n = [], r = [], i = null, s = null, o = null){
        this.path = e, this.collectionGroup = t, this.orderBy = n, this.filters = r, this.limit = i, this.startAt = s, this.endAt = o, this.Te = null;
    }
}
/**
 * Initializes a Target with a path and optional additional query constraints.
 * Path must currently be empty if this is a collection group query.
 *
 * NOTE: you should always construct `Target` from `Query.toTarget` instead of
 * using this factory method, because `Query` provides an implicit `orderBy`
 * property.
 */ function $63c47e8a587a7f36$var$__PRIVATE_newTarget(e, t = null, n = [], r = [], i = null, s = null, o = null) {
    return new $63c47e8a587a7f36$var$__PRIVATE_TargetImpl(e, t, n, r, i, s, o);
}
function $63c47e8a587a7f36$var$__PRIVATE_canonifyTarget(e) {
    const t = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    if (null === t.Te) {
        let e = t.path.canonicalString();
        null !== t.collectionGroup && (e += "|cg:" + t.collectionGroup), e += "|f:", e += t.filters.map((e)=>$63c47e8a587a7f36$var$__PRIVATE_canonifyFilter(e)).join(","), e += "|ob:", e += t.orderBy.map((e)=>(function __PRIVATE_canonifyOrderBy(e) {
                // TODO(b/29183165): Make this collision robust.
                return e.field.canonicalString() + e.dir;
            })(e)).join(","), $63c47e8a587a7f36$var$__PRIVATE_isNullOrUndefined(t.limit) || (e += "|l:", e += t.limit), t.startAt && (e += "|lb:", e += t.startAt.inclusive ? "b:" : "a:", e += t.startAt.position.map((e)=>$63c47e8a587a7f36$var$canonicalId(e)).join(",")), t.endAt && (e += "|ub:", e += t.endAt.inclusive ? "a:" : "b:", e += t.endAt.position.map((e)=>$63c47e8a587a7f36$var$canonicalId(e)).join(",")), t.Te = e;
    }
    return t.Te;
}
function $63c47e8a587a7f36$var$__PRIVATE_targetEquals(e, t) {
    if (e.limit !== t.limit) return !1;
    if (e.orderBy.length !== t.orderBy.length) return !1;
    for(let n = 0; n < e.orderBy.length; n++)if (!$63c47e8a587a7f36$var$__PRIVATE_orderByEquals(e.orderBy[n], t.orderBy[n])) return !1;
    if (e.filters.length !== t.filters.length) return !1;
    for(let n = 0; n < e.filters.length; n++)if (!$63c47e8a587a7f36$var$__PRIVATE_filterEquals(e.filters[n], t.filters[n])) return !1;
    return e.collectionGroup === t.collectionGroup && !!e.path.isEqual(t.path) && !!$63c47e8a587a7f36$var$__PRIVATE_boundEquals(e.startAt, t.startAt) && $63c47e8a587a7f36$var$__PRIVATE_boundEquals(e.endAt, t.endAt);
}
function $63c47e8a587a7f36$var$__PRIVATE_targetIsDocumentTarget(e) {
    return $63c47e8a587a7f36$export$90a7f3efeed30595.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
}
/** Returns the field filters that target the given field path. */ function $63c47e8a587a7f36$var$__PRIVATE_targetGetFieldFiltersForPath(e, t) {
    return e.filters.filter((e)=>e instanceof $63c47e8a587a7f36$export$dda1d9f60106f0e9 && e.field.isEqual(t));
}
/**
 * Returns the values that are used in ARRAY_CONTAINS or ARRAY_CONTAINS_ANY
 * filters. Returns `null` if there are no such filters.
 */ /**
 * Returns the value to use as the lower bound for ascending index segment at
 * the provided `fieldPath` (or the upper bound for an descending segment).
 */ function $63c47e8a587a7f36$var$__PRIVATE_targetGetAscendingBound(e, t, n) {
    let r = $63c47e8a587a7f36$var$lt, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $63c47e8a587a7f36$var$__PRIVATE_targetGetFieldFiltersForPath(e, t)){
        let e = $63c47e8a587a7f36$var$lt, t = !0;
        switch(n.op){
            case "<" /* Operator.LESS_THAN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                e = $63c47e8a587a7f36$var$__PRIVATE_valuesGetLowerBound(n.value);
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                e = n.value;
                break;
            case ">" /* Operator.GREATER_THAN */ :
                e = n.value, t = !1;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                e = $63c47e8a587a7f36$var$lt;
        }
        $63c47e8a587a7f36$var$__PRIVATE_lowerBoundCompare({
            value: r,
            inclusive: i
        }, {
            value: e,
            inclusive: t
        }) < 0 && (r = e, i = t);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            const e = n.position[s];
            $63c47e8a587a7f36$var$__PRIVATE_lowerBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: e,
                inclusive: n.inclusive
            }) < 0 && (r = e, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/**
 * Returns the value to use as the upper bound for ascending index segment at
 * the provided `fieldPath` (or the lower bound for a descending segment).
 */ function $63c47e8a587a7f36$var$__PRIVATE_targetGetDescendingBound(e, t, n) {
    let r = $63c47e8a587a7f36$var$at, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $63c47e8a587a7f36$var$__PRIVATE_targetGetFieldFiltersForPath(e, t)){
        let e = $63c47e8a587a7f36$var$at, t = !0;
        switch(n.op){
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
            case ">" /* Operator.GREATER_THAN */ :
                e = $63c47e8a587a7f36$var$__PRIVATE_valuesGetUpperBound(n.value), t = !1;
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                e = n.value;
                break;
            case "<" /* Operator.LESS_THAN */ :
                e = n.value, t = !1;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                e = $63c47e8a587a7f36$var$at;
        }
        $63c47e8a587a7f36$var$__PRIVATE_upperBoundCompare({
            value: r,
            inclusive: i
        }, {
            value: e,
            inclusive: t
        }) > 0 && (r = e, i = t);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            const e = n.position[s];
            $63c47e8a587a7f36$var$__PRIVATE_upperBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: e,
                inclusive: n.inclusive
            }) > 0 && (r = e, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/** Returns the number of segments of a perfect index for this target. */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Query encapsulates all the query attributes we support in the SDK. It can
 * be run against the LocalStore, as well as be converted to a `Target` to
 * query the RemoteStore results.
 *
 * Visible for testing.
 */ class $63c47e8a587a7f36$var$__PRIVATE_QueryImpl {
    /**
     * Initializes a Query with a path and optional additional query constraints.
     * Path must currently be empty if this is a collection group query.
     */ constructor(e, t = null, n = [], r = [], i = null, s = "F" /* LimitType.First */ , o = null, _ = null){
        this.path = e, this.collectionGroup = t, this.explicitOrderBy = n, this.filters = r, this.limit = i, this.limitType = s, this.startAt = o, this.endAt = _, this.Ie = null, // The corresponding `Target` of this `Query` instance, for use with
        // non-aggregate queries.
        this.Ee = null, // The corresponding `Target` of this `Query` instance, for use with
        // aggregate queries. Unlike targets for non-aggregate queries,
        // aggregate query targets do not contain normalized order-bys, they only
        // contain explicit order-bys.
        this.Re = null, this.startAt, this.endAt;
    }
}
/** Creates a new Query instance with the options provided. */ function $63c47e8a587a7f36$var$__PRIVATE_newQuery(e, t, n, r, i, s, o, _) {
    return new $63c47e8a587a7f36$var$__PRIVATE_QueryImpl(e, t, n, r, i, s, o, _);
}
/** Creates a new Query for a query that matches all documents at `path` */ function $63c47e8a587a7f36$export$a93c5207d687da10(e) {
    return new $63c47e8a587a7f36$var$__PRIVATE_QueryImpl(e);
}
/**
 * Helper to convert a collection group query into a collection query at a
 * specific path. This is used when executing collection group queries, since
 * we have to split the query into a set of collection queries at multiple
 * paths.
 */ /**
 * Returns true if this query does not specify any query constraints that
 * could remove results.
 */ function $63c47e8a587a7f36$var$__PRIVATE_queryMatchesAllDocuments(e) {
    return 0 === e.filters.length && null === e.limit && null == e.startAt && null == e.endAt && (0 === e.explicitOrderBy.length || 1 === e.explicitOrderBy.length && e.explicitOrderBy[0].field.isKeyField());
}
// Returns the sorted set of inequality filter fields used in this query.
/**
 * Returns whether the query matches a single document by path (rather than a
 * collection).
 */ function $63c47e8a587a7f36$export$51b138e5a065c2bb(e) {
    return $63c47e8a587a7f36$export$90a7f3efeed30595.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
}
/**
 * Returns whether the query matches a collection group rather than a specific
 * collection.
 */ function $63c47e8a587a7f36$export$3b14a55fb2447963(e) {
    return null !== e.collectionGroup;
}
/**
 * Returns the normalized order-by constraint that is used to execute the Query,
 * which can be different from the order-by constraints the user provided (e.g.
 * the SDK and backend always orders by `__name__`). The normalized order-by
 * includes implicit order-bys in addition to the explicit user provided
 * order-bys.
 */ function $63c47e8a587a7f36$export$9e5f44173e64f162(e) {
    const t = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    if (null === t.Ie) {
        t.Ie = [];
        const e = new Set;
        // Any explicit order by fields should be added as is.
        for (const n of t.explicitOrderBy)t.Ie.push(n), e.add(n.field.canonicalString());
        // The order of the implicit ordering always matches the last explicit order by.
        const n = t.explicitOrderBy.length > 0 ? t.explicitOrderBy[t.explicitOrderBy.length - 1].dir : "asc" /* Direction.ASCENDING */ , r = function __PRIVATE_getInequalityFilterFields(e) {
            let t = new $63c47e8a587a7f36$var$SortedSet($63c47e8a587a7f36$export$cf2f7c5792f80b46.comparator);
            return e.filters.forEach((e)=>{
                e.getFlattenedFilters().forEach((e)=>{
                    e.isInequality() && (t = t.add(e.field));
                });
            }), t;
        }(t);
        // Any inequality fields not explicitly ordered should be implicitly ordered in a lexicographical
        // order. When there are multiple inequality filters on the same field, the field should be added
        // only once.
        // Note: `SortedSet<FieldPath>` sorts the key field before other fields. However, we want the key
        // field to be sorted last.
        r.forEach((r)=>{
            e.has(r.canonicalString()) || r.isKeyField() || t.Ie.push(new $63c47e8a587a7f36$export$306ddfe3a8403e2(r, n));
        }), // Add the document key field to the last if it is not explicitly ordered.
        e.has($63c47e8a587a7f36$export$cf2f7c5792f80b46.keyField().canonicalString()) || t.Ie.push(new $63c47e8a587a7f36$export$306ddfe3a8403e2($63c47e8a587a7f36$export$cf2f7c5792f80b46.keyField(), n));
    }
    return t.Ie;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation.
 */ function $63c47e8a587a7f36$var$__PRIVATE_queryToTarget(e) {
    const t = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    return t.Ee || (t.Ee = $63c47e8a587a7f36$var$__PRIVATE__queryToTarget(t, $63c47e8a587a7f36$export$9e5f44173e64f162(e))), t.Ee;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation,
 * for use within an aggregate query. Unlike targets for non-aggregate queries,
 * aggregate query targets do not contain normalized order-bys, they only
 * contain explicit order-bys.
 */ function $63c47e8a587a7f36$var$__PRIVATE_queryToAggregateTarget(e) {
    const t = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    return t.Re || // Do not include implicit order-bys for aggregate queries.
    (t.Re = $63c47e8a587a7f36$var$__PRIVATE__queryToTarget(t, e.explicitOrderBy)), t.Re;
}
function $63c47e8a587a7f36$var$__PRIVATE__queryToTarget(e, t) {
    if ("F" /* LimitType.First */  === e.limitType) return $63c47e8a587a7f36$var$__PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, e.startAt, e.endAt);
    {
        // Flip the orderBy directions since we want the last results
        t = t.map((e)=>{
            const t = "desc" /* Direction.DESCENDING */  === e.dir ? "asc" /* Direction.ASCENDING */  : "desc" /* Direction.DESCENDING */ ;
            return new $63c47e8a587a7f36$export$306ddfe3a8403e2(e.field, t);
        });
        // We need to swap the cursors to match the now-flipped query ordering.
        const n = e.endAt ? new $63c47e8a587a7f36$export$625550452a3fa3ec(e.endAt.position, e.endAt.inclusive) : null, r = e.startAt ? new $63c47e8a587a7f36$export$625550452a3fa3ec(e.startAt.position, e.startAt.inclusive) : null;
        // Now return as a LimitType.First query.
        return $63c47e8a587a7f36$var$__PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, n, r);
    }
}
function $63c47e8a587a7f36$export$f1e1789686576879(e, t) {
    const n = e.filters.concat([
        t
    ]);
    return new $63c47e8a587a7f36$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), n, e.limit, e.limitType, e.startAt, e.endAt);
}
function $63c47e8a587a7f36$export$342063e11d6c3cad(e, t) {
    // TODO(dimond): validate that orderBy does not list the same key twice.
    const n = e.explicitOrderBy.concat([
        t
    ]);
    return new $63c47e8a587a7f36$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, n, e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
}
function $63c47e8a587a7f36$export$882b5998b3b9117c(e, t, n) {
    return new $63c47e8a587a7f36$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), t, n, e.startAt, e.endAt);
}
function $63c47e8a587a7f36$export$7ccc53e8f1e7dfc5(e, t) {
    return new $63c47e8a587a7f36$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, t, e.endAt);
}
function $63c47e8a587a7f36$export$ae1af26003f05816(e, t) {
    return new $63c47e8a587a7f36$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, t);
}
function $63c47e8a587a7f36$var$__PRIVATE_queryEquals(e, t) {
    return $63c47e8a587a7f36$var$__PRIVATE_targetEquals($63c47e8a587a7f36$var$__PRIVATE_queryToTarget(e), $63c47e8a587a7f36$var$__PRIVATE_queryToTarget(t)) && e.limitType === t.limitType;
}
// TODO(b/29183165): This is used to get a unique string from a query to, for
// example, use as a dictionary key, but the implementation is subject to
// collisions. Make it collision-free.
function $63c47e8a587a7f36$var$__PRIVATE_canonifyQuery(e) {
    return `${$63c47e8a587a7f36$var$__PRIVATE_canonifyTarget($63c47e8a587a7f36$var$__PRIVATE_queryToTarget(e))}|lt:${e.limitType}`;
}
function $63c47e8a587a7f36$var$__PRIVATE_stringifyQuery(e) {
    return `Query(target=${function __PRIVATE_stringifyTarget(e) {
        let t = e.path.canonicalString();
        return null !== e.collectionGroup && (t += " collectionGroup=" + e.collectionGroup), e.filters.length > 0 && (t += `, filters: [${e.filters.map((e)=>$63c47e8a587a7f36$var$__PRIVATE_stringifyFilter(e)).join(", ")}]`), $63c47e8a587a7f36$var$__PRIVATE_isNullOrUndefined(e.limit) || (t += ", limit: " + e.limit), e.orderBy.length > 0 && (t += `, orderBy: [${e.orderBy.map((e)=>(function __PRIVATE_stringifyOrderBy(e) {
                return `${e.field.canonicalString()} (${e.dir})`;
            })(e)).join(", ")}]`), e.startAt && (t += ", startAt: ", t += e.startAt.inclusive ? "b:" : "a:", t += e.startAt.position.map((e)=>$63c47e8a587a7f36$var$canonicalId(e)).join(",")), e.endAt && (t += ", endAt: ", t += e.endAt.inclusive ? "a:" : "b:", t += e.endAt.position.map((e)=>$63c47e8a587a7f36$var$canonicalId(e)).join(",")), `Target(${t})`;
    }($63c47e8a587a7f36$var$__PRIVATE_queryToTarget(e))}; limitType=${e.limitType})`;
}
/** Returns whether `doc` matches the constraints of `query`. */ function $63c47e8a587a7f36$var$__PRIVATE_queryMatches(e, t) {
    return t.isFoundDocument() && function __PRIVATE_queryMatchesPathAndCollectionGroup(e, t) {
        const n = t.key.path;
        return null !== e.collectionGroup ? t.key.hasCollectionId(e.collectionGroup) && e.path.isPrefixOf(n) : $63c47e8a587a7f36$export$90a7f3efeed30595.isDocumentKey(e.path) ? e.path.isEqual(n) : e.path.isImmediateParentOf(n);
    }(e, t) && function __PRIVATE_queryMatchesOrderBy(e, t) {
        // We must use `queryNormalizedOrderBy()` to get the list of all orderBys (both implicit and explicit).
        // Note that for OR queries, orderBy applies to all disjunction terms and implicit orderBys must
        // be taken into account. For example, the query "a > 1 || b==1" has an implicit "orderBy a" due
        // to the inequality, and is evaluated as "a > 1 orderBy a || b==1 orderBy a".
        // A document with content of {b:1} matches the filters, but does not match the orderBy because
        // it's missing the field 'a'.
        for (const n of $63c47e8a587a7f36$export$9e5f44173e64f162(e))// order-by key always matches
        if (!n.field.isKeyField() && null === t.data.field(n.field)) return !1;
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesFilters(e, t) {
        for (const n of e.filters)if (!n.matches(t)) return !1;
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesBounds(e, t) {
        if (e.startAt && !/**
 * Returns true if a document sorts before a bound using the provided sort
 * order.
 */ function __PRIVATE_boundSortsBeforeDocument(e, t, n) {
            const r = $63c47e8a587a7f36$var$__PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r <= 0 : r < 0;
        }(e.startAt, $63c47e8a587a7f36$export$9e5f44173e64f162(e), t)) return !1;
        if (e.endAt && !function __PRIVATE_boundSortsAfterDocument(e, t, n) {
            const r = $63c47e8a587a7f36$var$__PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r >= 0 : r > 0;
        }(e.endAt, $63c47e8a587a7f36$export$9e5f44173e64f162(e), t)) return !1;
        return !0;
    }(e, t);
}
function $63c47e8a587a7f36$var$__PRIVATE_queryCollectionGroup(e) {
    return e.collectionGroup || (e.path.length % 2 == 1 ? e.path.lastSegment() : e.path.get(e.path.length - 2));
}
/**
 * Returns a new comparator function that can be used to compare two documents
 * based on the Query's ordering constraint.
 */ function $63c47e8a587a7f36$var$__PRIVATE_newQueryComparator(e) {
    return (t, n)=>{
        let r = !1;
        for (const i of $63c47e8a587a7f36$export$9e5f44173e64f162(e)){
            const e = $63c47e8a587a7f36$var$__PRIVATE_compareDocs(i, t, n);
            if (0 !== e) return e;
            r = r || i.field.isKeyField();
        }
        return 0;
    };
}
function $63c47e8a587a7f36$var$__PRIVATE_compareDocs(e, t, n) {
    const r = e.field.isKeyField() ? $63c47e8a587a7f36$export$90a7f3efeed30595.comparator(t.key, n.key) : function __PRIVATE_compareDocumentsByField(e, t, n) {
        const r = t.data.field(e), i = n.data.field(e);
        return null !== r && null !== i ? $63c47e8a587a7f36$var$__PRIVATE_valueCompare(r, i) : $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(42886);
    }(e.field, t, n);
    switch(e.dir){
        case "asc" /* Direction.ASCENDING */ :
            return r;
        case "desc" /* Direction.DESCENDING */ :
            return -1 * r;
        default:
            return $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(19790, {
                direction: e.dir
            });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A map implementation that uses objects as keys. Objects must have an
 * associated equals function and must be immutable. Entries in the map are
 * stored together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */ class $63c47e8a587a7f36$var$ObjectMap {
    constructor(e, t){
        this.mapKeyFn = e, this.equalsFn = t, /**
         * The inner map for a key/value pair. Due to the possibility of collisions we
         * keep a list of entries that we do a linear search through to find an actual
         * match. Note that collisions should be rare, so we still expect near
         * constant time lookups in practice.
         */ this.inner = {}, /** The number of entries stored in the map */ this.innerSize = 0;
    }
    /** Get a value for this key, or undefined if it does not exist. */ get(e) {
        const t = this.mapKeyFn(e), n = this.inner[t];
        if (void 0 !== n) {
            for (const [t, r] of n)if (this.equalsFn(t, e)) return r;
        }
    }
    has(e) {
        return void 0 !== this.get(e);
    }
    /** Put this key and value in the map. */ set(e, t) {
        const n = this.mapKeyFn(e), r = this.inner[n];
        if (void 0 === r) return this.inner[n] = [
            [
                e,
                t
            ]
        ], void this.innerSize++;
        for(let n = 0; n < r.length; n++)if (this.equalsFn(r[n][0], e)) // This is updating an existing entry and does not increase `innerSize`.
        return void (r[n] = [
            e,
            t
        ]);
        r.push([
            e,
            t
        ]), this.innerSize++;
    }
    /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */ delete(e) {
        const t = this.mapKeyFn(e), n = this.inner[t];
        if (void 0 === n) return !1;
        for(let r = 0; r < n.length; r++)if (this.equalsFn(n[r][0], e)) return 1 === n.length ? delete this.inner[t] : n.splice(r, 1), this.innerSize--, !0;
        return !1;
    }
    forEach(e) {
        $63c47e8a587a7f36$var$forEach(this.inner, (t, n)=>{
            for (const [t, r] of n)e(t, r);
        });
    }
    isEmpty() {
        return $63c47e8a587a7f36$var$isEmpty(this.inner);
    }
    size() {
        return this.innerSize;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $63c47e8a587a7f36$var$Pt = new $63c47e8a587a7f36$var$SortedMap($63c47e8a587a7f36$export$90a7f3efeed30595.comparator);
function $63c47e8a587a7f36$var$__PRIVATE_mutableDocumentMap() {
    return $63c47e8a587a7f36$var$Pt;
}
const $63c47e8a587a7f36$var$Tt = new $63c47e8a587a7f36$var$SortedMap($63c47e8a587a7f36$export$90a7f3efeed30595.comparator);
function $63c47e8a587a7f36$var$documentMap(...e) {
    let t = $63c47e8a587a7f36$var$Tt;
    for (const n of e)t = t.insert(n.key, n);
    return t;
}
function $63c47e8a587a7f36$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(e) {
    let t = $63c47e8a587a7f36$var$Tt;
    return e.forEach((e, n)=>t = t.insert(e, n.overlayedDocument)), t;
}
function $63c47e8a587a7f36$var$__PRIVATE_newOverlayMap() {
    return $63c47e8a587a7f36$var$__PRIVATE_newDocumentKeyMap();
}
function $63c47e8a587a7f36$var$__PRIVATE_newMutationMap() {
    return $63c47e8a587a7f36$var$__PRIVATE_newDocumentKeyMap();
}
function $63c47e8a587a7f36$var$__PRIVATE_newDocumentKeyMap() {
    return new $63c47e8a587a7f36$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t));
}
const $63c47e8a587a7f36$var$It = new $63c47e8a587a7f36$var$SortedMap($63c47e8a587a7f36$export$90a7f3efeed30595.comparator);
const $63c47e8a587a7f36$var$Et = new $63c47e8a587a7f36$var$SortedSet($63c47e8a587a7f36$export$90a7f3efeed30595.comparator);
function $63c47e8a587a7f36$export$971d5caa766a69d7(...e) {
    let t = $63c47e8a587a7f36$var$Et;
    for (const n of e)t = t.add(n);
    return t;
}
const $63c47e8a587a7f36$var$Rt = new $63c47e8a587a7f36$var$SortedSet($63c47e8a587a7f36$var$__PRIVATE_primitiveComparator);
function $63c47e8a587a7f36$var$__PRIVATE_targetIdSet() {
    return $63c47e8a587a7f36$var$Rt;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an DoubleValue for `value` that is encoded based the serializer's
 * `useProto3Json` setting.
 */ function $63c47e8a587a7f36$var$__PRIVATE_toDouble(e, t) {
    if (e.useProto3Json) {
        if (isNaN(t)) return {
            doubleValue: "NaN"
        };
        if (t === 1 / 0) return {
            doubleValue: "Infinity"
        };
        if (t === -1 / 0) return {
            doubleValue: "-Infinity"
        };
    }
    return {
        doubleValue: $63c47e8a587a7f36$var$__PRIVATE_isNegativeZero(t) ? "-0" : t
    };
}
/**
 * Returns an IntegerValue for `value`.
 */ function $63c47e8a587a7f36$var$__PRIVATE_toInteger(e) {
    return {
        integerValue: "" + e
    };
}
/**
 * Returns a value for a number that's appropriate to put into a proto.
 * The return value is an IntegerValue if it can safely represent the value,
 * otherwise a DoubleValue is returned.
 */ function $63c47e8a587a7f36$export$b4d5ecaefe2b27f3(e, t) {
    return $63c47e8a587a7f36$var$isSafeInteger(t) ? $63c47e8a587a7f36$var$__PRIVATE_toInteger(t) : $63c47e8a587a7f36$var$__PRIVATE_toDouble(e, t);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Used to represent a field transform on a mutation. */ class $63c47e8a587a7f36$var$TransformOperation {
    constructor(){
        // Make sure that the structural type of `TransformOperation` is unique.
        // See https://github.com/microsoft/TypeScript/issues/5451
        this._ = void 0;
    }
}
/**
 * Computes the local transform result against the provided `previousValue`,
 * optionally using the provided localWriteTime.
 */ function $63c47e8a587a7f36$var$__PRIVATE_applyTransformOperationToLocalView(e, t, n) {
    return e instanceof $63c47e8a587a7f36$var$__PRIVATE_ServerTimestampTransform ? function serverTimestamp$1(e, t) {
        const n = {
            fields: {
                [$63c47e8a587a7f36$var$nt]: {
                    stringValue: $63c47e8a587a7f36$var$tt
                },
                [$63c47e8a587a7f36$var$it]: {
                    timestampValue: {
                        seconds: e.seconds,
                        nanos: e.nanoseconds
                    }
                }
            }
        };
        // We should avoid storing deeply nested server timestamp map values
        // because we never use the intermediate "previous values".
        // For example:
        // previous: 42L, add: t1, result: t1 -> 42L
        // previous: t1,  add: t2, result: t2 -> 42L (NOT t2 -> t1 -> 42L)
        // previous: t2,  add: t3, result: t3 -> 42L (NOT t3 -> t2 -> t1 -> 42L)
        // `getPreviousValue` recursively traverses server timestamps to find the
        // least recent Value.
        return t && $63c47e8a587a7f36$export$2408f22a0fab9ae5(t) && (t = $63c47e8a587a7f36$var$__PRIVATE_getPreviousValue(t)), t && (n.fields[$63c47e8a587a7f36$var$rt] = t), {
            mapValue: n
        };
    }(n, t) : e instanceof $63c47e8a587a7f36$var$__PRIVATE_ArrayUnionTransformOperation ? $63c47e8a587a7f36$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof $63c47e8a587a7f36$var$__PRIVATE_ArrayRemoveTransformOperation ? $63c47e8a587a7f36$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) : function __PRIVATE_applyNumericIncrementTransformOperationToLocalView(e, t) {
        // PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
        // precision and resolves overflows by reducing precision, we do not
        // manually cap overflows at 2^63.
        const n = $63c47e8a587a7f36$var$__PRIVATE_computeTransformOperationBaseValue(e, t), r = $63c47e8a587a7f36$var$asNumber(n) + $63c47e8a587a7f36$var$asNumber(e.Ae);
        return $63c47e8a587a7f36$var$isInteger(n) && $63c47e8a587a7f36$var$isInteger(e.Ae) ? $63c47e8a587a7f36$var$__PRIVATE_toInteger(r) : $63c47e8a587a7f36$var$__PRIVATE_toDouble(e.serializer, r);
    }(e, t);
}
/**
 * Computes a final transform result after the transform has been acknowledged
 * by the server, potentially using the server-provided transformResult.
 */ function $63c47e8a587a7f36$var$__PRIVATE_applyTransformOperationToRemoteDocument(e, t, n) {
    // The server just sends null as the transform result for array operations,
    // so we have to calculate a result the same as we do for local
    // applications.
    return e instanceof $63c47e8a587a7f36$var$__PRIVATE_ArrayUnionTransformOperation ? $63c47e8a587a7f36$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof $63c47e8a587a7f36$var$__PRIVATE_ArrayRemoveTransformOperation ? $63c47e8a587a7f36$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) : n;
}
/**
 * If this transform operation is not idempotent, returns the base value to
 * persist for this transform. If a base value is returned, the transform
 * operation is always applied to this base value, even if document has
 * already been updated.
 *
 * Base values provide consistent behavior for non-idempotent transforms and
 * allow us to return the same latency-compensated value even if the backend
 * has already applied the transform operation. The base value is null for
 * idempotent transforms, as they can be re-played even if the backend has
 * already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent transforms.
 */ function $63c47e8a587a7f36$var$__PRIVATE_computeTransformOperationBaseValue(e, t) {
    return e instanceof $63c47e8a587a7f36$var$__PRIVATE_NumericIncrementTransformOperation ? /** Returns true if `value` is either an IntegerValue or a DoubleValue. */ function __PRIVATE_isNumber(e) {
        return $63c47e8a587a7f36$var$isInteger(e) || function __PRIVATE_isDouble(e) {
            return !!e && "doubleValue" in e;
        }(e);
    }(t) ? t : {
        integerValue: 0
    } : null;
}
/** Transforms a value into a server-generated timestamp. */ class $63c47e8a587a7f36$var$__PRIVATE_ServerTimestampTransform extends $63c47e8a587a7f36$var$TransformOperation {
}
/** Transforms an array value via a union operation. */ class $63c47e8a587a7f36$var$__PRIVATE_ArrayUnionTransformOperation extends $63c47e8a587a7f36$var$TransformOperation {
    constructor(e){
        super(), this.elements = e;
    }
}
function $63c47e8a587a7f36$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) {
    const n = $63c47e8a587a7f36$var$__PRIVATE_coercedFieldValuesArray(t);
    for (const t of e.elements)n.some((e)=>$63c47e8a587a7f36$var$__PRIVATE_valueEquals(e, t)) || n.push(t);
    return {
        arrayValue: {
            values: n
        }
    };
}
/** Transforms an array value via a remove operation. */ class $63c47e8a587a7f36$var$__PRIVATE_ArrayRemoveTransformOperation extends $63c47e8a587a7f36$var$TransformOperation {
    constructor(e){
        super(), this.elements = e;
    }
}
function $63c47e8a587a7f36$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) {
    let n = $63c47e8a587a7f36$var$__PRIVATE_coercedFieldValuesArray(t);
    for (const t of e.elements)n = n.filter((e)=>!$63c47e8a587a7f36$var$__PRIVATE_valueEquals(e, t));
    return {
        arrayValue: {
            values: n
        }
    };
}
/**
 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
 * transforms. Converts all field values to integers or doubles, but unlike the
 * backend does not cap integer values at 2^63. Instead, JavaScript number
 * arithmetic is used and precision loss can occur for values greater than 2^53.
 */ class $63c47e8a587a7f36$var$__PRIVATE_NumericIncrementTransformOperation extends $63c47e8a587a7f36$var$TransformOperation {
    constructor(e, t){
        super(), this.serializer = e, this.Ae = t;
    }
}
function $63c47e8a587a7f36$var$asNumber(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
}
function $63c47e8a587a7f36$var$__PRIVATE_coercedFieldValuesArray(e) {
    return $63c47e8a587a7f36$var$isArray(e) && e.arrayValue.values ? e.arrayValue.values.slice() : [];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A field path and the TransformOperation to perform upon it. */ class $63c47e8a587a7f36$var$FieldTransform {
    constructor(e, t){
        this.field = e, this.transform = t;
    }
}
function $63c47e8a587a7f36$var$__PRIVATE_fieldTransformEquals(e, t) {
    return e.field.isEqual(t.field) && function __PRIVATE_transformOperationEquals(e, t) {
        return e instanceof $63c47e8a587a7f36$var$__PRIVATE_ArrayUnionTransformOperation && t instanceof $63c47e8a587a7f36$var$__PRIVATE_ArrayUnionTransformOperation || e instanceof $63c47e8a587a7f36$var$__PRIVATE_ArrayRemoveTransformOperation && t instanceof $63c47e8a587a7f36$var$__PRIVATE_ArrayRemoveTransformOperation ? $63c47e8a587a7f36$var$__PRIVATE_arrayEquals(e.elements, t.elements, $63c47e8a587a7f36$var$__PRIVATE_valueEquals) : e instanceof $63c47e8a587a7f36$var$__PRIVATE_NumericIncrementTransformOperation && t instanceof $63c47e8a587a7f36$var$__PRIVATE_NumericIncrementTransformOperation ? $63c47e8a587a7f36$var$__PRIVATE_valueEquals(e.Ae, t.Ae) : e instanceof $63c47e8a587a7f36$var$__PRIVATE_ServerTimestampTransform && t instanceof $63c47e8a587a7f36$var$__PRIVATE_ServerTimestampTransform;
    }(e.transform, t.transform);
}
/** The result of successfully applying a mutation to the backend. */ class $63c47e8a587a7f36$var$MutationResult {
    constructor(/**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */ e, /**
     * The resulting fields returned from the backend after a mutation
     * containing field transforms has been committed. Contains one FieldValue
     * for each FieldTransform that was in the mutation.
     *
     * Will be empty if the mutation did not contain any field transforms.
     */ t){
        this.version = e, this.transformResults = t;
    }
}
/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */ class $63c47e8a587a7f36$export$78acf4525d8a74c4 {
    constructor(e, t){
        this.updateTime = e, this.exists = t;
    }
    /** Creates a new empty Precondition. */ static none() {
        return new $63c47e8a587a7f36$export$78acf4525d8a74c4;
    }
    /** Creates a new Precondition with an exists flag. */ static exists(e) {
        return new $63c47e8a587a7f36$export$78acf4525d8a74c4(void 0, e);
    }
    /** Creates a new Precondition based on a version a document exists at. */ static updateTime(e) {
        return new $63c47e8a587a7f36$export$78acf4525d8a74c4(e);
    }
    /** Returns whether this Precondition is empty. */ get isNone() {
        return void 0 === this.updateTime && void 0 === this.exists;
    }
    isEqual(e) {
        return this.exists === e.exists && (this.updateTime ? !!e.updateTime && this.updateTime.isEqual(e.updateTime) : !e.updateTime);
    }
}
/** Returns true if the preconditions is valid for the given document. */ function $63c47e8a587a7f36$var$__PRIVATE_preconditionIsValidForDocument(e, t) {
    return void 0 !== e.updateTime ? t.isFoundDocument() && t.version.isEqual(e.updateTime) : void 0 === e.exists || e.exists === t.isFoundDocument();
}
/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also its version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set and Patch mutations. For Delete mutations, we
 * reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        InvalidDocument(v0)   Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      InvalidDocument(v0)   UnknownDocument(v3)
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     InvalidDocument(v0)   NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set and Patch mutations. As deletes have no
 * explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we transition to an `UnknownDocument` and rely on Watch to send us
 * the updated version.
 *
 * Field transforms are used only with Patch and Set Mutations. We use the
 * `updateTransforms` message to store transforms, rather than the `transforms`s
 * messages.
 *
 * ## Subclassing Notes
 *
 * Every type of mutation needs to implement its own applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document (see `setMutationApplyToRemoteDocument()` for an
 * example).
 */ class $63c47e8a587a7f36$var$Mutation {
}
/**
 * A utility method to calculate a `Mutation` representing the overlay from the
 * final state of the document, and a `FieldMask` representing the fields that
 * are mutated by the local mutations.
 */ function $63c47e8a587a7f36$var$__PRIVATE_calculateOverlayMutation(e, t) {
    if (!e.hasLocalMutations || t && 0 === t.fields.length) return null;
    // mask is null when sets or deletes are applied to the current document.
    if (null === t) return e.isNoDocument() ? new $63c47e8a587a7f36$export$34aec0b863436764(e.key, $63c47e8a587a7f36$export$78acf4525d8a74c4.none()) : new $63c47e8a587a7f36$var$__PRIVATE_SetMutation(e.key, e.data, $63c47e8a587a7f36$export$78acf4525d8a74c4.none());
    {
        const n = e.data, r = $63c47e8a587a7f36$export$c4ce752e73470fba.empty();
        let i = new $63c47e8a587a7f36$var$SortedSet($63c47e8a587a7f36$export$cf2f7c5792f80b46.comparator);
        for (let e of t.fields)if (!i.has(e)) {
            let t = n.field(e);
            // If we are deleting a nested field, we take the immediate parent as
            // the mask used to construct the resulting mutation.
            // Justification: Nested fields can create parent fields implicitly. If
            // only a leaf entry is deleted in later mutations, the parent field
            // should still remain, but we may have lost this information.
            // Consider mutation (foo.bar 1), then mutation (foo.bar delete()).
            // This leaves the final result (foo, {}). Despite the fact that `doc`
            // has the correct result, `foo` is not in `mask`, and the resulting
            // mutation would miss `foo`.
            null === t && e.length > 1 && (e = e.popLast(), t = n.field(e)), null === t ? r.delete(e) : r.set(e, t), i = i.add(e);
        }
        return new $63c47e8a587a7f36$var$__PRIVATE_PatchMutation(e.key, r, new $63c47e8a587a7f36$var$FieldMask(i.toArray()), $63c47e8a587a7f36$export$78acf4525d8a74c4.none());
    }
}
/**
 * Applies this mutation to the given document for the purposes of computing a
 * new remote document. If the input document doesn't match the expected state
 * (e.g. it is invalid or outdated), the document type may transition to
 * unknown.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param mutationResult - The result of applying the mutation from the backend.
 */ function $63c47e8a587a7f36$var$__PRIVATE_mutationApplyToRemoteDocument(e, t, n) {
    e instanceof $63c47e8a587a7f36$var$__PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToRemoteDocument(e, t, n) {
        // Unlike setMutationApplyToLocalView, if we're applying a mutation to a
        // remote document the server has accepted the mutation so the precondition
        // must have held.
        const r = e.value.clone(), i = $63c47e8a587a7f36$var$__PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults);
        r.setAll(i), t.convertToFoundDocument(n.version, r).setHasCommittedMutations();
    }(e, t, n) : e instanceof $63c47e8a587a7f36$var$__PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToRemoteDocument(e, t, n) {
        if (!$63c47e8a587a7f36$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // Since the mutation was not rejected, we know that the precondition
        // matched on the backend. We therefore must not have the expected version
        // of the document in our cache and convert to an UnknownDocument with a
        // known updateTime.
        return void t.convertToUnknownDocument(n.version);
        const r = $63c47e8a587a7f36$var$__PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults), i = t.data;
        i.setAll($63c47e8a587a7f36$var$__PRIVATE_getPatch(e)), i.setAll(r), t.convertToFoundDocument(n.version, i).setHasCommittedMutations();
    }(e, t, n) : function __PRIVATE_deleteMutationApplyToRemoteDocument(e, t, n) {
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        t.convertToNoDocument(n.version).setHasCommittedMutations();
    }(0, t, n);
}
/**
 * Applies this mutation to the given document for the purposes of computing
 * the new local view of a document. If the input document doesn't match the
 * expected state, the document is not modified.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param previousMask - The fields that have been updated before applying this mutation.
 * @param localWriteTime - A timestamp indicating the local write time of the
 *     batch this mutation is a part of.
 * @returns A `FieldMask` representing the fields that are changed by applying this mutation.
 */ function $63c47e8a587a7f36$var$__PRIVATE_mutationApplyToLocalView(e, t, n, r) {
    return e instanceof $63c47e8a587a7f36$var$__PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToLocalView(e, t, n, r) {
        if (!$63c47e8a587a7f36$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // The mutation failed to apply (e.g. a document ID created with add()
        // caused a name collision).
        return n;
        const i = e.value.clone(), s = $63c47e8a587a7f36$var$__PRIVATE_localTransformResults(e.fieldTransforms, r, t);
        return i.setAll(s), t.convertToFoundDocument(t.version, i).setHasLocalMutations(), null;
    // SetMutation overwrites all fields.
    }(e, t, n, r) : e instanceof $63c47e8a587a7f36$var$__PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToLocalView(e, t, n, r) {
        if (!$63c47e8a587a7f36$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return n;
        const i = $63c47e8a587a7f36$var$__PRIVATE_localTransformResults(e.fieldTransforms, r, t), s = t.data;
        if (s.setAll($63c47e8a587a7f36$var$__PRIVATE_getPatch(e)), s.setAll(i), t.convertToFoundDocument(t.version, s).setHasLocalMutations(), null === n) return null;
        return n.unionWith(e.fieldMask.fields).unionWith(e.fieldTransforms.map((e)=>e.field));
    }(e, t, n, r) : function __PRIVATE_deleteMutationApplyToLocalView(e, t, n) {
        if ($63c47e8a587a7f36$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return t.convertToNoDocument(t.version).setHasLocalMutations(), null;
        return n;
    }(e, t, n);
}
/**
 * If this mutation is not idempotent, returns the base value to persist with
 * this mutation. If a base value is returned, the mutation is always applied
 * to this base value, even if document has already been updated.
 *
 * The base value is a sparse object that consists of only the document
 * fields for which this mutation contains a non-idempotent transformation
 * (e.g. a numeric increment). The provided value guarantees consistent
 * behavior for non-idempotent transforms and allow us to return the same
 * latency-compensated value even if the backend has already applied the
 * mutation. The base value is null for idempotent mutations, as they can be
 * re-played even if the backend has already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent mutations.
 */ function $63c47e8a587a7f36$var$__PRIVATE_mutationExtractBaseValue(e, t) {
    let n = null;
    for (const r of e.fieldTransforms){
        const e = t.data.field(r.field), i = $63c47e8a587a7f36$var$__PRIVATE_computeTransformOperationBaseValue(r.transform, e || null);
        null != i && (null === n && (n = $63c47e8a587a7f36$export$c4ce752e73470fba.empty()), n.set(r.field, i));
    }
    return n || null;
}
function $63c47e8a587a7f36$var$__PRIVATE_mutationEquals(e, t) {
    return e.type === t.type && !!e.key.isEqual(t.key) && !!e.precondition.isEqual(t.precondition) && !!function __PRIVATE_fieldTransformsAreEqual(e, t) {
        return void 0 === e && void 0 === t || !(!e || !t) && $63c47e8a587a7f36$var$__PRIVATE_arrayEquals(e, t, (e, t)=>$63c47e8a587a7f36$var$__PRIVATE_fieldTransformEquals(e, t));
    }(e.fieldTransforms, t.fieldTransforms) && (0 /* MutationType.Set */  === e.type ? e.value.isEqual(t.value) : 1 /* MutationType.Patch */  !== e.type || e.data.isEqual(t.data) && e.fieldMask.isEqual(t.fieldMask));
}
/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */ class $63c47e8a587a7f36$var$__PRIVATE_SetMutation extends $63c47e8a587a7f36$var$Mutation {
    constructor(e, t, n, r = []){
        super(), this.key = e, this.value = t, this.precondition = n, this.fieldTransforms = r, this.type = 0 /* MutationType.Set */ ;
    }
    getFieldMask() {
        return null;
    }
}
class $63c47e8a587a7f36$var$__PRIVATE_PatchMutation extends $63c47e8a587a7f36$var$Mutation {
    constructor(e, t, n, r, i = []){
        super(), this.key = e, this.data = t, this.fieldMask = n, this.precondition = r, this.fieldTransforms = i, this.type = 1 /* MutationType.Patch */ ;
    }
    getFieldMask() {
        return this.fieldMask;
    }
}
function $63c47e8a587a7f36$var$__PRIVATE_getPatch(e) {
    const t = new Map;
    return e.fieldMask.fields.forEach((n)=>{
        if (!n.isEmpty()) {
            const r = e.data.field(n);
            t.set(n, r);
        }
    }), t;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use after a mutation
 * containing transforms has been acknowledged by the server.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param mutableDocument - The current state of the document after applying all
 * previous mutations.
 * @param serverTransformResults - The transform results received by the server.
 * @returns The transform results list.
 */ function $63c47e8a587a7f36$var$__PRIVATE_serverTransformResults(e, t, n) {
    const r = new Map;
    $63c47e8a587a7f36$export$c18d01048907ea92(e.length === n.length, 32656, {
        Ve: n.length,
        de: e.length
    });
    for(let i = 0; i < n.length; i++){
        const s = e[i], o = s.transform, _ = t.data.field(s.field);
        r.set(s.field, $63c47e8a587a7f36$var$__PRIVATE_applyTransformOperationToRemoteDocument(o, _, n[i]));
    }
    return r;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use when applying a
 * transform locally.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param localWriteTime - The local time of the mutation (used to
 *     generate ServerTimestampValues).
 * @param mutableDocument - The document to apply transforms on.
 * @returns The transform results list.
 */ function $63c47e8a587a7f36$var$__PRIVATE_localTransformResults(e, t, n) {
    const r = new Map;
    for (const i of e){
        const e = i.transform, s = n.data.field(i.field);
        r.set(i.field, $63c47e8a587a7f36$var$__PRIVATE_applyTransformOperationToLocalView(e, s, t));
    }
    return r;
}
/** A mutation that deletes the document at the given key. */ class $63c47e8a587a7f36$export$34aec0b863436764 extends $63c47e8a587a7f36$var$Mutation {
    constructor(e, t){
        super(), this.key = e, this.precondition = t, this.type = 2 /* MutationType.Delete */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
class $63c47e8a587a7f36$var$__PRIVATE_VerifyMutation extends $63c47e8a587a7f36$var$Mutation {
    constructor(e, t){
        super(), this.key = e, this.precondition = t, this.type = 3 /* MutationType.Verify */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A batch of mutations that will be sent as one unit to the backend.
 */ class $63c47e8a587a7f36$var$MutationBatch {
    /**
     * @param batchId - The unique ID of this mutation batch.
     * @param localWriteTime - The original write time of this mutation.
     * @param baseMutations - Mutations that are used to populate the base
     * values when this mutation is applied locally. This can be used to locally
     * overwrite values that are persisted in the remote document cache. Base
     * mutations are never sent to the backend.
     * @param mutations - The user-provided mutations in this mutation batch.
     * User-provided mutations are applied both locally and remotely on the
     * backend.
     */ constructor(e, t, n, r){
        this.batchId = e, this.localWriteTime = t, this.baseMutations = n, this.mutations = r;
    }
    /**
     * Applies all the mutations in this MutationBatch to the specified document
     * to compute the state of the remote document
     *
     * @param document - The document to apply mutations to.
     * @param batchResult - The result of applying the MutationBatch to the
     * backend.
     */ applyToRemoteDocument(e, t) {
        const n = t.mutationResults;
        for(let t = 0; t < this.mutations.length; t++){
            const r = this.mutations[t];
            if (r.key.isEqual(e.key)) $63c47e8a587a7f36$var$__PRIVATE_mutationApplyToRemoteDocument(r, e, n[t]);
        }
    }
    /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param document - The document to apply mutations to.
     * @param mutatedFields - Fields that have been updated before applying this mutation batch.
     * @returns A `FieldMask` representing all the fields that are mutated.
     */ applyToLocalView(e, t) {
        // First, apply the base state. This allows us to apply non-idempotent
        // transform against a consistent set of values.
        for (const n of this.baseMutations)n.key.isEqual(e.key) && (t = $63c47e8a587a7f36$var$__PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
        // Second, apply all user-provided mutations.
        for (const n of this.mutations)n.key.isEqual(e.key) && (t = $63c47e8a587a7f36$var$__PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
        return t;
    }
    /**
     * Computes the local view for all provided documents given the mutations in
     * this batch. Returns a `DocumentKey` to `Mutation` map which can be used to
     * replace all the mutation applications.
     */ applyToLocalDocumentSet(e, t) {
        // TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
        // directly (as done in `applyToLocalView()`), we can reduce the complexity
        // to O(n).
        const n = $63c47e8a587a7f36$var$__PRIVATE_newMutationMap();
        return this.mutations.forEach((r)=>{
            const i = e.get(r.key), s = i.overlayedDocument;
            // TODO(mutabledocuments): This method should take a MutableDocumentMap
            // and we should remove this cast.
            let o = this.applyToLocalView(s, i.mutatedFields);
            // Set mutatedFields to null if the document is only from local mutations.
            // This creates a Set or Delete mutation, instead of trying to create a
            // patch mutation as the overlay.
            o = t.has(r.key) ? null : o;
            const _ = $63c47e8a587a7f36$var$__PRIVATE_calculateOverlayMutation(s, o);
            null !== _ && n.set(r.key, _), s.isValidDocument() || s.convertToNoDocument($63c47e8a587a7f36$var$SnapshotVersion.min());
        }), n;
    }
    keys() {
        return this.mutations.reduce((e, t)=>e.add(t.key), $63c47e8a587a7f36$export$971d5caa766a69d7());
    }
    isEqual(e) {
        return this.batchId === e.batchId && $63c47e8a587a7f36$var$__PRIVATE_arrayEquals(this.mutations, e.mutations, (e, t)=>$63c47e8a587a7f36$var$__PRIVATE_mutationEquals(e, t)) && $63c47e8a587a7f36$var$__PRIVATE_arrayEquals(this.baseMutations, e.baseMutations, (e, t)=>$63c47e8a587a7f36$var$__PRIVATE_mutationEquals(e, t));
    }
}
/** The result of applying a mutation batch to the backend. */ class $63c47e8a587a7f36$var$MutationBatchResult {
    constructor(e, t, n, /**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */ r){
        this.batch = e, this.commitVersion = t, this.mutationResults = n, this.docVersions = r;
    }
    /**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=&gt;version mapping (docVersions).
     */ static from(e, t, n) {
        $63c47e8a587a7f36$export$c18d01048907ea92(e.mutations.length === n.length, 58842, {
            me: e.mutations.length,
            fe: n.length
        });
        let r = function __PRIVATE_documentVersionMap() {
            return $63c47e8a587a7f36$var$It;
        }();
        const i = e.mutations;
        for(let e = 0; e < i.length; e++)r = r.insert(i[e].key, n[e].version);
        return new $63c47e8a587a7f36$var$MutationBatchResult(e, t, n, r);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Representation of an overlay computed by Firestore.
 *
 * Holds information about a mutation and the largest batch id in Firestore when
 * the mutation was created.
 */ class $63c47e8a587a7f36$var$Overlay {
    constructor(e, t){
        this.largestBatchId = e, this.mutation = t;
    }
    getKey() {
        return this.mutation.key;
    }
    isEqual(e) {
        return null !== e && this.mutation === e.mutation;
    }
    toString() {
        return `Overlay{\n      largestBatchId: ${this.largestBatchId},\n      mutation: ${this.mutation.toString()}\n    }`;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Concrete implementation of the Aggregate type.
 */ class $63c47e8a587a7f36$export$7a38258bbe170828 {
    constructor(e, t, n){
        this.alias = e, this.aggregateType = t, this.fieldPath = n;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $63c47e8a587a7f36$var$ExistenceFilter {
    constructor(e, t){
        this.count = e, this.unchangedNames = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers or change this into a const enum.
 */ var $63c47e8a587a7f36$var$At, $63c47e8a587a7f36$var$Vt;
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */ function $63c47e8a587a7f36$var$__PRIVATE_isPermanentError(e) {
    switch(e){
        case $63c47e8a587a7f36$export$e7094788287c5e9b.OK:
            return $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(64938);
        case $63c47e8a587a7f36$export$e7094788287c5e9b.CANCELLED:
        case $63c47e8a587a7f36$export$e7094788287c5e9b.UNKNOWN:
        case $63c47e8a587a7f36$export$e7094788287c5e9b.DEADLINE_EXCEEDED:
        case $63c47e8a587a7f36$export$e7094788287c5e9b.RESOURCE_EXHAUSTED:
        case $63c47e8a587a7f36$export$e7094788287c5e9b.INTERNAL:
        case $63c47e8a587a7f36$export$e7094788287c5e9b.UNAVAILABLE:
        // Unauthenticated means something went wrong with our token and we need
        // to retry with new credentials which will happen automatically.
        case $63c47e8a587a7f36$export$e7094788287c5e9b.UNAUTHENTICATED:
            return !1;
        case $63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT:
        case $63c47e8a587a7f36$export$e7094788287c5e9b.NOT_FOUND:
        case $63c47e8a587a7f36$export$e7094788287c5e9b.ALREADY_EXISTS:
        case $63c47e8a587a7f36$export$e7094788287c5e9b.PERMISSION_DENIED:
        case $63c47e8a587a7f36$export$e7094788287c5e9b.FAILED_PRECONDITION:
        // Aborted might be retried in some scenarios, but that is dependent on
        // the context and should handled individually by the calling code.
        // See https://cloud.google.com/apis/design/errors.
        case $63c47e8a587a7f36$export$e7094788287c5e9b.ABORTED:
        case $63c47e8a587a7f36$export$e7094788287c5e9b.OUT_OF_RANGE:
        case $63c47e8a587a7f36$export$e7094788287c5e9b.UNIMPLEMENTED:
        case $63c47e8a587a7f36$export$e7094788287c5e9b.DATA_LOSS:
            return !0;
        default:
            return $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(15467, {
                code: e
            });
    }
}
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */ /**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */ function $63c47e8a587a7f36$var$__PRIVATE_mapCodeFromRpcCode(e) {
    if (void 0 === e) // This shouldn't normally happen, but in certain error cases (like trying
    // to send invalid proto messages) we may get an error with no GRPC code.
    return $63c47e8a587a7f36$var$__PRIVATE_logError("GRPC error has no .code"), $63c47e8a587a7f36$export$e7094788287c5e9b.UNKNOWN;
    switch(e){
        case $63c47e8a587a7f36$var$At.OK:
            return $63c47e8a587a7f36$export$e7094788287c5e9b.OK;
        case $63c47e8a587a7f36$var$At.CANCELLED:
            return $63c47e8a587a7f36$export$e7094788287c5e9b.CANCELLED;
        case $63c47e8a587a7f36$var$At.UNKNOWN:
            return $63c47e8a587a7f36$export$e7094788287c5e9b.UNKNOWN;
        case $63c47e8a587a7f36$var$At.DEADLINE_EXCEEDED:
            return $63c47e8a587a7f36$export$e7094788287c5e9b.DEADLINE_EXCEEDED;
        case $63c47e8a587a7f36$var$At.RESOURCE_EXHAUSTED:
            return $63c47e8a587a7f36$export$e7094788287c5e9b.RESOURCE_EXHAUSTED;
        case $63c47e8a587a7f36$var$At.INTERNAL:
            return $63c47e8a587a7f36$export$e7094788287c5e9b.INTERNAL;
        case $63c47e8a587a7f36$var$At.UNAVAILABLE:
            return $63c47e8a587a7f36$export$e7094788287c5e9b.UNAVAILABLE;
        case $63c47e8a587a7f36$var$At.UNAUTHENTICATED:
            return $63c47e8a587a7f36$export$e7094788287c5e9b.UNAUTHENTICATED;
        case $63c47e8a587a7f36$var$At.INVALID_ARGUMENT:
            return $63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT;
        case $63c47e8a587a7f36$var$At.NOT_FOUND:
            return $63c47e8a587a7f36$export$e7094788287c5e9b.NOT_FOUND;
        case $63c47e8a587a7f36$var$At.ALREADY_EXISTS:
            return $63c47e8a587a7f36$export$e7094788287c5e9b.ALREADY_EXISTS;
        case $63c47e8a587a7f36$var$At.PERMISSION_DENIED:
            return $63c47e8a587a7f36$export$e7094788287c5e9b.PERMISSION_DENIED;
        case $63c47e8a587a7f36$var$At.FAILED_PRECONDITION:
            return $63c47e8a587a7f36$export$e7094788287c5e9b.FAILED_PRECONDITION;
        case $63c47e8a587a7f36$var$At.ABORTED:
            return $63c47e8a587a7f36$export$e7094788287c5e9b.ABORTED;
        case $63c47e8a587a7f36$var$At.OUT_OF_RANGE:
            return $63c47e8a587a7f36$export$e7094788287c5e9b.OUT_OF_RANGE;
        case $63c47e8a587a7f36$var$At.UNIMPLEMENTED:
            return $63c47e8a587a7f36$export$e7094788287c5e9b.UNIMPLEMENTED;
        case $63c47e8a587a7f36$var$At.DATA_LOSS:
            return $63c47e8a587a7f36$export$e7094788287c5e9b.DATA_LOSS;
        default:
            return $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(39323, {
                code: e
            });
    }
}
/**
 * Converts an HTTP response's error status to the equivalent error code.
 *
 * @param status - An HTTP error response status ("FAILED_PRECONDITION",
 * "UNKNOWN", etc.)
 * @returns The equivalent Code. Non-matching responses are mapped to
 *     Code.UNKNOWN.
 */ ($63c47e8a587a7f36$var$Vt = $63c47e8a587a7f36$var$At || ($63c47e8a587a7f36$var$At = {}))[$63c47e8a587a7f36$var$Vt.OK = 0] = "OK", $63c47e8a587a7f36$var$Vt[$63c47e8a587a7f36$var$Vt.CANCELLED = 1] = "CANCELLED", $63c47e8a587a7f36$var$Vt[$63c47e8a587a7f36$var$Vt.UNKNOWN = 2] = "UNKNOWN", $63c47e8a587a7f36$var$Vt[$63c47e8a587a7f36$var$Vt.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", $63c47e8a587a7f36$var$Vt[$63c47e8a587a7f36$var$Vt.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", $63c47e8a587a7f36$var$Vt[$63c47e8a587a7f36$var$Vt.NOT_FOUND = 5] = "NOT_FOUND", $63c47e8a587a7f36$var$Vt[$63c47e8a587a7f36$var$Vt.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", $63c47e8a587a7f36$var$Vt[$63c47e8a587a7f36$var$Vt.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", $63c47e8a587a7f36$var$Vt[$63c47e8a587a7f36$var$Vt.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", $63c47e8a587a7f36$var$Vt[$63c47e8a587a7f36$var$Vt.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", $63c47e8a587a7f36$var$Vt[$63c47e8a587a7f36$var$Vt.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", $63c47e8a587a7f36$var$Vt[$63c47e8a587a7f36$var$Vt.ABORTED = 10] = "ABORTED", $63c47e8a587a7f36$var$Vt[$63c47e8a587a7f36$var$Vt.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", $63c47e8a587a7f36$var$Vt[$63c47e8a587a7f36$var$Vt.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", $63c47e8a587a7f36$var$Vt[$63c47e8a587a7f36$var$Vt.INTERNAL = 13] = "INTERNAL", $63c47e8a587a7f36$var$Vt[$63c47e8a587a7f36$var$Vt.UNAVAILABLE = 14] = "UNAVAILABLE", $63c47e8a587a7f36$var$Vt[$63c47e8a587a7f36$var$Vt.DATA_LOSS = 15] = "DATA_LOSS";
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The global, singleton instance of TestingHooksSpi.
 *
 * This variable will be `null` in all cases _except_ when running from
 * integration tests that have registered callbacks to be notified of events
 * that happen during the test execution.
 */ let $63c47e8a587a7f36$var$dt = null;
/**
 * Sets the value of the `testingHooksSpi` object.
 * @param instance - the instance to set.
 */ function $63c47e8a587a7f36$export$1a82df3d29112e01(e) {
    if ($63c47e8a587a7f36$var$dt) throw new Error("a TestingHooksSpi instance is already set");
    $63c47e8a587a7f36$var$dt = e;
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An instance of the Platform's 'TextEncoder' implementation.
 */ function $63c47e8a587a7f36$var$__PRIVATE_newTextEncoder() {
    return new TextEncoder;
}
/**
 * An instance of the Platform's 'TextDecoder' implementation.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $63c47e8a587a7f36$var$mt = new (0, $584ae1ea48b31d46$export$70ffa26850098d01)([
    4294967295,
    4294967295
], 0);
// Hash a string using md5 hashing algorithm.
function $63c47e8a587a7f36$var$__PRIVATE_getMd5HashValue(e) {
    const t = $63c47e8a587a7f36$var$__PRIVATE_newTextEncoder().encode(e), n = new (0, $584ae1ea48b31d46$export$9f5a3dfc7a9f5dd);
    return n.update(t), new Uint8Array(n.digest());
}
// Interpret the 16 bytes array as two 64-bit unsigned integers, encoded using
// 2’s complement using little endian.
function $63c47e8a587a7f36$var$__PRIVATE_get64BitUints(e) {
    const t = new DataView(e.buffer), n = t.getUint32(0, /* littleEndian= */ !0), r = t.getUint32(4, /* littleEndian= */ !0), i = t.getUint32(8, /* littleEndian= */ !0), s = t.getUint32(12, /* littleEndian= */ !0);
    return [
        new (0, $584ae1ea48b31d46$export$70ffa26850098d01)([
            n,
            r
        ], 0),
        new (0, $584ae1ea48b31d46$export$70ffa26850098d01)([
            i,
            s
        ], 0)
    ];
}
class $63c47e8a587a7f36$var$BloomFilter {
    constructor(e, t, n){
        if (this.bitmap = e, this.padding = t, this.hashCount = n, t < 0 || t >= 8) throw new $63c47e8a587a7f36$var$__PRIVATE_BloomFilterError(`Invalid padding: ${t}`);
        if (n < 0) throw new $63c47e8a587a7f36$var$__PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
        if (e.length > 0 && 0 === this.hashCount) // Only empty bloom filter can have 0 hash count.
        throw new $63c47e8a587a7f36$var$__PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
        if (0 === e.length && 0 !== t) // Empty bloom filter should have 0 padding.
        throw new $63c47e8a587a7f36$var$__PRIVATE_BloomFilterError(`Invalid padding when bitmap length is 0: ${t}`);
        this.ge = 8 * e.length - t, // Set the bit count in Integer to avoid repetition in mightContain().
        this.pe = (0, $584ae1ea48b31d46$export$70ffa26850098d01).fromNumber(this.ge);
    }
    // Calculate the ith hash value based on the hashed 64bit integers,
    // and calculate its corresponding bit index in the bitmap to be checked.
    ye(e, t, n) {
        // Calculate hashed value h(i) = h1 + (i * h2).
        let r = e.add(t.multiply((0, $584ae1ea48b31d46$export$70ffa26850098d01).fromNumber(n)));
        // Wrap if hash value overflow 64bit.
        return 1 === r.compare($63c47e8a587a7f36$var$mt) && (r = new (0, $584ae1ea48b31d46$export$70ffa26850098d01)([
            r.getBits(0),
            r.getBits(1)
        ], 0)), r.modulo(this.pe).toNumber();
    }
    // Return whether the bit on the given index in the bitmap is set to 1.
    we(e) {
        return !!(this.bitmap[Math.floor(e / 8)] & 1 << e % 8);
    }
    mightContain(e) {
        // Empty bitmap should always return false on membership check.
        if (0 === this.ge) return !1;
        const t = $63c47e8a587a7f36$var$__PRIVATE_getMd5HashValue(e), [n, r] = $63c47e8a587a7f36$var$__PRIVATE_get64BitUints(t);
        for(let e = 0; e < this.hashCount; e++){
            const t = this.ye(n, r, e);
            if (!this.we(t)) return !1;
        }
        return !0;
    }
    /** Create bloom filter for testing purposes only. */ static create(e, t, n) {
        const r = e % 8 == 0 ? 0 : 8 - e % 8, i = new Uint8Array(Math.ceil(e / 8)), s = new $63c47e8a587a7f36$var$BloomFilter(i, r, t);
        return n.forEach((e)=>s.insert(e)), s;
    }
    insert(e) {
        if (0 === this.ge) return;
        const t = $63c47e8a587a7f36$var$__PRIVATE_getMd5HashValue(e), [n, r] = $63c47e8a587a7f36$var$__PRIVATE_get64BitUints(t);
        for(let e = 0; e < this.hashCount; e++){
            const t = this.ye(n, r, e);
            this.be(t);
        }
    }
    be(e) {
        const t = Math.floor(e / 8), n = e % 8;
        this.bitmap[t] |= 1 << n;
    }
}
class $63c47e8a587a7f36$var$__PRIVATE_BloomFilterError extends Error {
    constructor(){
        super(...arguments), this.name = "BloomFilterError";
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */ class $63c47e8a587a7f36$var$RemoteEvent {
    constructor(/**
     * The snapshot version this event brings us up to, or MIN if not set.
     */ e, /**
     * A map from target to changes to the target. See TargetChange.
     */ t, /**
     * A map of targets that is known to be inconsistent, and the purpose for
     * re-listening. Listens for these targets should be re-established without
     * resume tokens.
     */ n, /**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */ r, /**
     * A set of which document updates are due only to limbo resolution targets.
     */ i){
        this.snapshotVersion = e, this.targetChanges = t, this.targetMismatches = n, this.documentUpdates = r, this.resolvedLimboDocuments = i;
    }
    /**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */ // PORTING NOTE: Multi-tab only
    static createSynthesizedRemoteEventForCurrentChange(e, t, n) {
        const r = new Map;
        return r.set(e, $63c47e8a587a7f36$var$TargetChange.createSynthesizedTargetChangeForCurrentChange(e, t, n)), new $63c47e8a587a7f36$var$RemoteEvent($63c47e8a587a7f36$var$SnapshotVersion.min(), r, new $63c47e8a587a7f36$var$SortedMap($63c47e8a587a7f36$var$__PRIVATE_primitiveComparator), $63c47e8a587a7f36$var$__PRIVATE_mutableDocumentMap(), $63c47e8a587a7f36$export$971d5caa766a69d7());
    }
}
/**
 * A TargetChange specifies the set of changes for a specific target as part of
 * a RemoteEvent. These changes track which documents are added, modified or
 * removed, as well as the target's resume token and whether the target is
 * marked CURRENT.
 * The actual changes *to* documents are not part of the TargetChange since
 * documents may be part of multiple targets.
 */ class $63c47e8a587a7f36$var$TargetChange {
    constructor(/**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */ e, /**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */ t, /**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */ n, /**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */ r, /**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */ i){
        this.resumeToken = e, this.current = t, this.addedDocuments = n, this.modifiedDocuments = r, this.removedDocuments = i;
    }
    /**
     * This method is used to create a synthesized TargetChanges that can be used to
     * apply a CURRENT status change to a View (for queries executed in a different
     * tab) or for new queries (to raise snapshots with correct CURRENT status).
     */ static createSynthesizedTargetChangeForCurrentChange(e, t, n) {
        return new $63c47e8a587a7f36$var$TargetChange(n, t, $63c47e8a587a7f36$export$971d5caa766a69d7(), $63c47e8a587a7f36$export$971d5caa766a69d7(), $63c47e8a587a7f36$export$971d5caa766a69d7());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a changed document and a list of target ids to which this change
 * applies.
 *
 * If document has been deleted NoDocument will be provided.
 */ class $63c47e8a587a7f36$var$__PRIVATE_DocumentWatchChange {
    constructor(/** The new document applies to all of these targets. */ e, /** The new document is removed from all of these targets. */ t, /** The key of the document for this change. */ n, /**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */ r){
        this.Se = e, this.removedTargetIds = t, this.key = n, this.De = r;
    }
}
class $63c47e8a587a7f36$var$__PRIVATE_ExistenceFilterChange {
    constructor(e, t){
        this.targetId = e, this.Ce = t;
    }
}
class $63c47e8a587a7f36$var$__PRIVATE_WatchTargetChange {
    constructor(/** What kind of change occurred to the watch target. */ e, /** The target IDs that were added/removed/set. */ t, /**
     * An opaque, server-assigned token that allows watching a target to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the target. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */ n = $63c47e8a587a7f36$export$9d398bebfec1c039.EMPTY_BYTE_STRING, r = null){
        this.state = e, this.targetIds = t, this.resumeToken = n, this.cause = r;
    }
}
/** Tracks the internal state of a Watch target. */ class $63c47e8a587a7f36$var$__PRIVATE_TargetState {
    constructor(){
        /**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */ this.ve = 0, /**
         * Keeps track of the document changes since the last raised snapshot.
         *
         * These changes are continuously updated as we receive document updates and
         * always reflect the current set of changes against the last issued snapshot.
         */ this.Fe = $63c47e8a587a7f36$var$__PRIVATE_snapshotChangesMap(), /** See public getters for explanations of these fields. */ this.Me = $63c47e8a587a7f36$export$9d398bebfec1c039.EMPTY_BYTE_STRING, this.xe = !1, /**
         * Whether this target state should be included in the next snapshot. We
         * initialize to true so that newly-added targets are included in the next
         * RemoteEvent.
         */ this.Oe = !0;
    }
    /**
     * Whether this target has been marked 'current'.
     *
     * 'Current' has special meaning in the RPC protocol: It implies that the
     * Watch backend has sent us all changes up to the point at which the target
     * was added and that the target is consistent with the rest of the watch
     * stream.
     */ get current() {
        return this.xe;
    }
    /** The last resume token sent to us for this target. */ get resumeToken() {
        return this.Me;
    }
    /** Whether this target has pending target adds or target removes. */ get Ne() {
        return 0 !== this.ve;
    }
    /** Whether we have modified any state that should trigger a snapshot. */ get Be() {
        return this.Oe;
    }
    /**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */ Le(e) {
        e.approximateByteSize() > 0 && (this.Oe = !0, this.Me = e);
    }
    /**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */ ke() {
        let e = $63c47e8a587a7f36$export$971d5caa766a69d7(), t = $63c47e8a587a7f36$export$971d5caa766a69d7(), n = $63c47e8a587a7f36$export$971d5caa766a69d7();
        return this.Fe.forEach((r, i)=>{
            switch(i){
                case 0 /* ChangeType.Added */ :
                    e = e.add(r);
                    break;
                case 2 /* ChangeType.Modified */ :
                    t = t.add(r);
                    break;
                case 1 /* ChangeType.Removed */ :
                    n = n.add(r);
                    break;
                default:
                    $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(38017, {
                        changeType: i
                    });
            }
        }), new $63c47e8a587a7f36$var$TargetChange(this.Me, this.xe, e, t, n);
    }
    /**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */ Ke() {
        this.Oe = !1, this.Fe = $63c47e8a587a7f36$var$__PRIVATE_snapshotChangesMap();
    }
    qe(e, t) {
        this.Oe = !0, this.Fe = this.Fe.insert(e, t);
    }
    Ue(e) {
        this.Oe = !0, this.Fe = this.Fe.remove(e);
    }
    $e() {
        this.ve += 1;
    }
    We() {
        this.ve -= 1, $63c47e8a587a7f36$export$c18d01048907ea92(this.ve >= 0, 3241, {
            ve: this.ve
        });
    }
    Qe() {
        this.Oe = !0, this.xe = !0;
    }
}
/**
 * A helper class to accumulate watch changes into a RemoteEvent.
 */ class $63c47e8a587a7f36$var$__PRIVATE_WatchChangeAggregator {
    constructor(e){
        this.Ge = e, /** The internal state of all tracked targets. */ this.ze = new Map, /** Keeps track of the documents to update since the last raised snapshot. */ this.je = $63c47e8a587a7f36$var$__PRIVATE_mutableDocumentMap(), this.He = $63c47e8a587a7f36$var$__PRIVATE_documentTargetMap(), /** A mapping of document keys to their set of target IDs. */ this.Je = $63c47e8a587a7f36$var$__PRIVATE_documentTargetMap(), /**
         * A map of targets with existence filter mismatches. These targets are
         * known to be inconsistent and their listens needs to be re-established by
         * RemoteStore.
         */ this.Ze = new $63c47e8a587a7f36$var$SortedMap($63c47e8a587a7f36$var$__PRIVATE_primitiveComparator);
    }
    /**
     * Processes and adds the DocumentWatchChange to the current set of changes.
     */ Xe(e) {
        for (const t of e.Se)e.De && e.De.isFoundDocument() ? this.Ye(t, e.De) : this.et(t, e.key, e.De);
        for (const t of e.removedTargetIds)this.et(t, e.key, e.De);
    }
    /** Processes and adds the WatchTargetChange to the current set of changes. */ tt(e) {
        this.forEachTarget(e, (t)=>{
            const n = this.nt(t);
            switch(e.state){
                case 0 /* WatchTargetChangeState.NoChange */ :
                    this.rt(t) && n.Le(e.resumeToken);
                    break;
                case 1 /* WatchTargetChangeState.Added */ :
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.We(), n.Ne || // We have a freshly added target, so we need to reset any state
                    // that we had previously. This can happen e.g. when remove and add
                    // back a target for existence filter mismatches.
                    n.Ke(), n.Le(e.resumeToken);
                    break;
                case 2 /* WatchTargetChangeState.Removed */ :
                    // We need to keep track of removed targets to we can post-filter and
                    // remove any target changes.
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.We(), n.Ne || this.removeTarget(t);
                    break;
                case 3 /* WatchTargetChangeState.Current */ :
                    this.rt(t) && (n.Qe(), n.Le(e.resumeToken));
                    break;
                case 4 /* WatchTargetChangeState.Reset */ :
                    this.rt(t) && // Reset the target and synthesizes removes for all existing
                    // documents. The backend will re-add any documents that still
                    // match the target before it sends the next global snapshot.
                    (this.it(t), n.Le(e.resumeToken));
                    break;
                default:
                    $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(56790, {
                        state: e.state
                    });
            }
        });
    }
    /**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */ forEachTarget(e, t) {
        e.targetIds.length > 0 ? e.targetIds.forEach(t) : this.ze.forEach((e, n)=>{
            this.rt(n) && t(n);
        });
    }
    /**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */ st(e) {
        const t = e.targetId, n = e.Ce.count, r = this.ot(t);
        if (r) {
            const i = r.target;
            if ($63c47e8a587a7f36$var$__PRIVATE_targetIsDocumentTarget(i)) {
                if (0 === n) {
                    // The existence filter told us the document does not exist. We deduce
                    // that this document does not exist and apply a deleted document to
                    // our updates. Without applying this deleted document there might be
                    // another query that will raise this document as part of a snapshot
                    // until it is resolved, essentially exposing inconsistency between
                    // queries.
                    const e = new $63c47e8a587a7f36$export$90a7f3efeed30595(i.path);
                    this.et(t, e, $63c47e8a587a7f36$var$MutableDocument.newNoDocument(e, $63c47e8a587a7f36$var$SnapshotVersion.min()));
                } else $63c47e8a587a7f36$export$c18d01048907ea92(1 === n, 20013, {
                    expectedCount: n
                });
            } else {
                const r = this._t(t);
                // Existence filter mismatch. Mark the documents as being in limbo, and
                // raise a snapshot with `isFromCache:true`.
                if (r !== n) {
                    // Apply bloom filter to identify and mark removed documents.
                    const n = this.ut(e), i = n ? this.ct(n, e, r) : 1 /* BloomFilterApplicationStatus.Skipped */ ;
                    if (0 /* BloomFilterApplicationStatus.Success */  !== i) {
                        // If bloom filter application fails, we reset the mapping and
                        // trigger re-run of the query.
                        this.it(t);
                        const e = 2 /* BloomFilterApplicationStatus.FalsePositive */  === i ? "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */  : "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ ;
                        this.Ze = this.Ze.insert(t, e);
                    }
                    $63c47e8a587a7f36$var$dt?.lt(function __PRIVATE_createExistenceFilterMismatchInfoForTestingHooks(e, t, n, r, i) {
                        const s = {
                            localCacheCount: e,
                            existenceFilterCount: t.count,
                            databaseId: n.database,
                            projectId: n.projectId
                        }, o = t.unchangedNames;
                        o && (s.bloomFilter = {
                            applied: 0 /* BloomFilterApplicationStatus.Success */  === i,
                            hashCount: o?.hashCount ?? 0,
                            bitmapLength: o?.bits?.bitmap?.length ?? 0,
                            padding: o?.bits?.padding ?? 0,
                            mightContain: (e)=>r?.mightContain(e) ?? !1
                        });
                        return s;
                    }(r, e.Ce, this.Ge.ht(), n, i));
                }
            }
        }
    }
    /**
     * Parse the bloom filter from the "unchanged_names" field of an existence
     * filter.
     */ ut(e) {
        const t = e.Ce.unchangedNames;
        if (!t || !t.bits) return null;
        const { bits: { bitmap: n = "", padding: r = 0 }, hashCount: i = 0 } = t;
        let s, o;
        try {
            s = $63c47e8a587a7f36$var$__PRIVATE_normalizeByteString(n).toUint8Array();
        } catch (e) {
            if (e instanceof $63c47e8a587a7f36$var$__PRIVATE_Base64DecodeError) return $63c47e8a587a7f36$export$4c3d22f3d993c33f("Decoding the base64 bloom filter in existence filter failed (" + e.message + "); ignoring the bloom filter and falling back to full re-query."), null;
            throw e;
        }
        try {
            // BloomFilter throws error if the inputs are invalid.
            o = new $63c47e8a587a7f36$var$BloomFilter(s, r, i);
        } catch (e) {
            return $63c47e8a587a7f36$export$4c3d22f3d993c33f(e instanceof $63c47e8a587a7f36$var$__PRIVATE_BloomFilterError ? "BloomFilter error: " : "Applying bloom filter failed: ", e), null;
        }
        return 0 === o.ge ? null : o;
    }
    /**
     * Apply bloom filter to remove the deleted documents, and return the
     * application status.
     */ ct(e, t, n) {
        return t.Ce.count === n - this.Pt(e, t.targetId) ? 0 /* BloomFilterApplicationStatus.Success */  : 2 /* BloomFilterApplicationStatus.FalsePositive */ ;
    }
    /**
     * Filter out removed documents based on bloom filter membership result and
     * return number of documents removed.
     */ Pt(e, t) {
        const n = this.Ge.getRemoteKeysForTarget(t);
        let r = 0;
        return n.forEach((n)=>{
            const i = this.Ge.ht(), s = `projects/${i.projectId}/databases/${i.database}/documents/${n.path.canonicalString()}`;
            e.mightContain(s) || (this.et(t, n, /*updatedDocument=*/ null), r++);
        }), r;
    }
    /**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */ Tt(e) {
        const t = new Map;
        this.ze.forEach((n, r)=>{
            const i = this.ot(r);
            if (i) {
                if (n.current && $63c47e8a587a7f36$var$__PRIVATE_targetIsDocumentTarget(i.target)) {
                    // Document queries for document that don't exist can produce an empty
                    // result set. To update our local cache, we synthesize a document
                    // delete if we have not previously received the document for this
                    // target. This resolves the limbo state of the document, removing it
                    // from limboDocumentRefs.
                    // TODO(dimond): Ideally we would have an explicit lookup target
                    // instead resulting in an explicit delete message and we could
                    // remove this special logic.
                    const t = new $63c47e8a587a7f36$export$90a7f3efeed30595(i.target.path);
                    this.It(t).has(r) || this.Et(r, t) || this.et(r, t, $63c47e8a587a7f36$var$MutableDocument.newNoDocument(t, e));
                }
                n.Be && (t.set(r, n.ke()), n.Ke());
            }
        });
        let n = $63c47e8a587a7f36$export$971d5caa766a69d7();
        // We extract the set of limbo-only document updates as the GC logic
        // special-cases documents that do not appear in the target cache.
        // TODO(gsoltis): Expand on this comment once GC is available in the JS
        // client.
        this.Je.forEach((e, t)=>{
            let r = !0;
            t.forEachWhile((e)=>{
                const t = this.ot(e);
                return !t || "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */  === t.purpose || (r = !1, !1);
            }), r && (n = n.add(e));
        }), this.je.forEach((t, n)=>n.setReadTime(e));
        const r = new $63c47e8a587a7f36$var$RemoteEvent(e, t, this.Ze, this.je, n);
        return this.je = $63c47e8a587a7f36$var$__PRIVATE_mutableDocumentMap(), this.He = $63c47e8a587a7f36$var$__PRIVATE_documentTargetMap(), this.Je = $63c47e8a587a7f36$var$__PRIVATE_documentTargetMap(), this.Ze = new $63c47e8a587a7f36$var$SortedMap($63c47e8a587a7f36$var$__PRIVATE_primitiveComparator), r;
    }
    /**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */ // Visible for testing.
    Ye(e, t) {
        if (!this.rt(e)) return;
        const n = this.Et(e, t.key) ? 2 /* ChangeType.Modified */  : 0 /* ChangeType.Added */ ;
        this.nt(e).qe(t.key, n), this.je = this.je.insert(t.key, t), this.He = this.He.insert(t.key, this.It(t.key).add(e)), this.Je = this.Je.insert(t.key, this.Rt(t.key).add(e));
    }
    /**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */ // Visible for testing.
    et(e, t, n) {
        if (!this.rt(e)) return;
        const r = this.nt(e);
        this.Et(e, t) ? r.qe(t, 1 /* ChangeType.Removed */ ) : // The document may have entered and left the target before we raised a
        // snapshot, so we can just ignore the change.
        r.Ue(t), this.Je = this.Je.insert(t, this.Rt(t).delete(e)), this.Je = this.Je.insert(t, this.Rt(t).add(e)), n && (this.je = this.je.insert(t, n));
    }
    removeTarget(e) {
        this.ze.delete(e);
    }
    /**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */ _t(e) {
        const t = this.nt(e).ke();
        return this.Ge.getRemoteKeysForTarget(e).size + t.addedDocuments.size - t.removedDocuments.size;
    }
    /**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */ $e(e) {
        this.nt(e).$e();
    }
    nt(e) {
        let t = this.ze.get(e);
        return t || (t = new $63c47e8a587a7f36$var$__PRIVATE_TargetState, this.ze.set(e, t)), t;
    }
    Rt(e) {
        let t = this.Je.get(e);
        return t || (t = new $63c47e8a587a7f36$var$SortedSet($63c47e8a587a7f36$var$__PRIVATE_primitiveComparator), this.Je = this.Je.insert(e, t)), t;
    }
    It(e) {
        let t = this.He.get(e);
        return t || (t = new $63c47e8a587a7f36$var$SortedSet($63c47e8a587a7f36$var$__PRIVATE_primitiveComparator), this.He = this.He.insert(e, t)), t;
    }
    /**
     * Verifies that the user is still interested in this target (by calling
     * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */ rt(e) {
        const t = null !== this.ot(e);
        return t || $63c47e8a587a7f36$export$21579262ef46735b("WatchChangeAggregator", "Detected inactive target", e), t;
    }
    /**
     * Returns the TargetData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */ ot(e) {
        const t = this.ze.get(e);
        return t && t.Ne ? null : this.Ge.At(e);
    }
    /**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */ it(e) {
        this.ze.set(e, new $63c47e8a587a7f36$var$__PRIVATE_TargetState);
        this.Ge.getRemoteKeysForTarget(e).forEach((t)=>{
            this.et(e, t, /*updatedDocument=*/ null);
        });
    }
    /**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */ Et(e, t) {
        return this.Ge.getRemoteKeysForTarget(e).has(t);
    }
}
function $63c47e8a587a7f36$var$__PRIVATE_documentTargetMap() {
    return new $63c47e8a587a7f36$var$SortedMap($63c47e8a587a7f36$export$90a7f3efeed30595.comparator);
}
function $63c47e8a587a7f36$var$__PRIVATE_snapshotChangesMap() {
    return new $63c47e8a587a7f36$var$SortedMap($63c47e8a587a7f36$export$90a7f3efeed30595.comparator);
}
const $63c47e8a587a7f36$var$ft = (()=>{
    const e = {
        asc: "ASCENDING",
        desc: "DESCENDING"
    };
    return e;
})(), $63c47e8a587a7f36$var$gt = (()=>{
    const e = {
        "<": "LESS_THAN",
        "<=": "LESS_THAN_OR_EQUAL",
        ">": "GREATER_THAN",
        ">=": "GREATER_THAN_OR_EQUAL",
        "==": "EQUAL",
        "!=": "NOT_EQUAL",
        "array-contains": "ARRAY_CONTAINS",
        in: "IN",
        "not-in": "NOT_IN",
        "array-contains-any": "ARRAY_CONTAINS_ANY"
    };
    return e;
})(), $63c47e8a587a7f36$var$pt = (()=>{
    const e = {
        and: "AND",
        or: "OR"
    };
    return e;
})();
/**
 * This class generates JsonObject values for the Datastore API suitable for
 * sending to either GRPC stub methods or via the JSON/HTTP REST API.
 *
 * The serializer supports both Protobuf.js and Proto3 JSON formats. By
 * setting `useProto3Json` to true, the serializer will use the Proto3 JSON
 * format.
 *
 * For a description of the Proto3 JSON format check
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 *
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */ class $63c47e8a587a7f36$var$JsonProtoSerializer {
    constructor(e, t){
        this.databaseId = e, this.useProto3Json = t;
    }
}
/**
 * Returns a value for a number (or null) that's appropriate to put into
 * a google.protobuf.Int32Value proto.
 * DO NOT USE THIS FOR ANYTHING ELSE.
 * This method cheats. It's typed as returning "number" because that's what
 * our generated proto interfaces say Int32Value must be. But GRPC actually
 * expects a { value: <number> } struct.
 */ function $63c47e8a587a7f36$var$__PRIVATE_toInt32Proto(e, t) {
    return e.useProto3Json || $63c47e8a587a7f36$var$__PRIVATE_isNullOrUndefined(t) ? t : {
        value: t
    };
}
/**
 * Returns a number (or null) from a google.protobuf.Int32Value proto.
 */ /**
 * Returns a value for a Date that's appropriate to put into a proto.
 */ function $63c47e8a587a7f36$var$toTimestamp(e, t) {
    if (e.useProto3Json) return `${new Date(1e3 * t.seconds).toISOString().replace(/\.\d*/, "").replace("Z", "")}.${("000000000" + t.nanoseconds).slice(-9)}Z`;
    return {
        seconds: "" + t.seconds,
        nanos: t.nanoseconds
    };
}
/**
 * Returns a Timestamp typed object given protobuf timestamp value.
 */ /**
 * Returns a value for bytes that's appropriate to put in a proto.
 *
 * Visible for testing.
 */ function $63c47e8a587a7f36$var$__PRIVATE_toBytes(e, t) {
    return e.useProto3Json ? t.toBase64() : t.toUint8Array();
}
/**
 * Returns a ByteString based on the proto string value.
 */ function $63c47e8a587a7f36$var$__PRIVATE_toVersion(e, t) {
    return $63c47e8a587a7f36$var$toTimestamp(e, t.toTimestamp());
}
function $63c47e8a587a7f36$var$__PRIVATE_fromVersion(e) {
    return $63c47e8a587a7f36$export$c18d01048907ea92(!!e, 49232), $63c47e8a587a7f36$var$SnapshotVersion.fromTimestamp(function fromTimestamp(e) {
        const t = $63c47e8a587a7f36$var$__PRIVATE_normalizeTimestamp(e);
        return new $63c47e8a587a7f36$export$3d12bd131bb975d1(t.seconds, t.nanos);
    }(e));
}
function $63c47e8a587a7f36$var$__PRIVATE_toResourceName(e, t) {
    return $63c47e8a587a7f36$var$__PRIVATE_toResourcePath(e, t).canonicalString();
}
function $63c47e8a587a7f36$var$__PRIVATE_toResourcePath(e, t) {
    const n = (function __PRIVATE_fullyQualifiedPrefixPath(e) {
        return new $63c47e8a587a7f36$export$db202ddc8be9136([
            "projects",
            e.projectId,
            "databases",
            e.database
        ]);
    })(e).child("documents");
    return void 0 === t ? n : n.child(t);
}
function $63c47e8a587a7f36$var$__PRIVATE_fromResourceName(e) {
    const t = $63c47e8a587a7f36$export$db202ddc8be9136.fromString(e);
    return $63c47e8a587a7f36$export$c18d01048907ea92($63c47e8a587a7f36$var$__PRIVATE_isValidResourceName(t), 10190, {
        key: t.toString()
    }), t;
}
function $63c47e8a587a7f36$var$__PRIVATE_toName(e, t) {
    return $63c47e8a587a7f36$var$__PRIVATE_toResourceName(e.databaseId, t.path);
}
function $63c47e8a587a7f36$var$fromName(e, t) {
    const n = $63c47e8a587a7f36$var$__PRIVATE_fromResourceName(t);
    if (n.get(1) !== e.databaseId.projectId) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, "Tried to deserialize key from different project: " + n.get(1) + " vs " + e.databaseId.projectId);
    if (n.get(3) !== e.databaseId.database) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, "Tried to deserialize key from different database: " + n.get(3) + " vs " + e.databaseId.database);
    return new $63c47e8a587a7f36$export$90a7f3efeed30595($63c47e8a587a7f36$var$__PRIVATE_extractLocalPathFromResourceName(n));
}
function $63c47e8a587a7f36$var$__PRIVATE_toQueryPath(e, t) {
    return $63c47e8a587a7f36$var$__PRIVATE_toResourceName(e.databaseId, t);
}
function $63c47e8a587a7f36$var$__PRIVATE_fromQueryPath(e) {
    const t = $63c47e8a587a7f36$var$__PRIVATE_fromResourceName(e);
    // In v1beta1 queries for collections at the root did not have a trailing
    // "/documents". In v1 all resource paths contain "/documents". Preserve the
    // ability to read the v1beta1 form for compatibility with queries persisted
    // in the local target cache.
    return 4 === t.length ? $63c47e8a587a7f36$export$db202ddc8be9136.emptyPath() : $63c47e8a587a7f36$var$__PRIVATE_extractLocalPathFromResourceName(t);
}
function $63c47e8a587a7f36$var$__PRIVATE_getEncodedDatabaseId(e) {
    return new $63c47e8a587a7f36$export$db202ddc8be9136([
        "projects",
        e.databaseId.projectId,
        "databases",
        e.databaseId.database
    ]).canonicalString();
}
function $63c47e8a587a7f36$var$__PRIVATE_extractLocalPathFromResourceName(e) {
    return $63c47e8a587a7f36$export$c18d01048907ea92(e.length > 4 && "documents" === e.get(4), 29091, {
        key: e.toString()
    }), e.popFirst(5);
}
/** Creates a Document proto from key and fields (but no create/update time) */ function $63c47e8a587a7f36$var$__PRIVATE_toMutationDocument(e, t, n) {
    return {
        name: $63c47e8a587a7f36$var$__PRIVATE_toName(e, t),
        fields: n.value.mapValue.fields
    };
}
function $63c47e8a587a7f36$var$__PRIVATE_fromPipelineResponse(e, t, n) {
    const r = {};
    t.transaction?.length && (r.transaction = t.transaction);
    const i = t.executionTime ? $63c47e8a587a7f36$var$__PRIVATE_fromVersion(t.executionTime) : void 0;
    return r.executionTime = i, n && (r.key = n.name ? $63c47e8a587a7f36$var$fromName(e, n.name) : void 0, r.fields = new $63c47e8a587a7f36$export$c4ce752e73470fba({
        mapValue: {
            fields: n.fields
        }
    }), r.createTime = n.createTime ? $63c47e8a587a7f36$var$__PRIVATE_fromVersion(n.createTime) : void 0, r.updateTime = n.updateTime ? $63c47e8a587a7f36$var$__PRIVATE_fromVersion(n.updateTime) : void 0), r;
}
function $63c47e8a587a7f36$export$3a1a48c8f6ef640e(e, t, n) {
    const r = $63c47e8a587a7f36$var$fromName(e, t.name), i = $63c47e8a587a7f36$var$__PRIVATE_fromVersion(t.updateTime), s = t.createTime ? $63c47e8a587a7f36$var$__PRIVATE_fromVersion(t.createTime) : $63c47e8a587a7f36$var$SnapshotVersion.min(), o = new $63c47e8a587a7f36$export$c4ce752e73470fba({
        mapValue: {
            fields: t.fields
        }
    }), _ = $63c47e8a587a7f36$var$MutableDocument.newFoundDocument(r, i, s, o);
    return n && _.setHasCommittedMutations(), n ? _.setHasCommittedMutations() : _;
}
function $63c47e8a587a7f36$var$__PRIVATE_fromBatchGetDocumentsResponse(e, t) {
    return "found" in t ? function __PRIVATE_fromFound(e, t) {
        $63c47e8a587a7f36$export$c18d01048907ea92(!!t.found, 43571), t.found.name, t.found.updateTime;
        const n = $63c47e8a587a7f36$var$fromName(e, t.found.name), r = $63c47e8a587a7f36$var$__PRIVATE_fromVersion(t.found.updateTime), i = t.found.createTime ? $63c47e8a587a7f36$var$__PRIVATE_fromVersion(t.found.createTime) : $63c47e8a587a7f36$var$SnapshotVersion.min(), s = new $63c47e8a587a7f36$export$c4ce752e73470fba({
            mapValue: {
                fields: t.found.fields
            }
        });
        return $63c47e8a587a7f36$var$MutableDocument.newFoundDocument(n, r, i, s);
    }(e, t) : "missing" in t ? function __PRIVATE_fromMissing(e, t) {
        $63c47e8a587a7f36$export$c18d01048907ea92(!!t.missing, 3894), $63c47e8a587a7f36$export$c18d01048907ea92(!!t.readTime, 22933);
        const n = $63c47e8a587a7f36$var$fromName(e, t.missing), r = $63c47e8a587a7f36$var$__PRIVATE_fromVersion(t.readTime);
        return $63c47e8a587a7f36$var$MutableDocument.newNoDocument(n, r);
    }(e, t) : $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(7234, {
        result: t
    });
}
function $63c47e8a587a7f36$var$__PRIVATE_fromWatchChange(e, t) {
    let n;
    if ("targetChange" in t) {
        t.targetChange;
        // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
        // if unset
        const r = function __PRIVATE_fromWatchTargetChangeState(e) {
            return "NO_CHANGE" === e ? 0 /* WatchTargetChangeState.NoChange */  : "ADD" === e ? 1 /* WatchTargetChangeState.Added */  : "REMOVE" === e ? 2 /* WatchTargetChangeState.Removed */  : "CURRENT" === e ? 3 /* WatchTargetChangeState.Current */  : "RESET" === e ? 4 /* WatchTargetChangeState.Reset */  : $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(39313, {
                state: e
            });
        }(t.targetChange.targetChangeType || "NO_CHANGE"), i = t.targetChange.targetIds || [], s = function __PRIVATE_fromBytes(e, t) {
            return e.useProto3Json ? ($63c47e8a587a7f36$export$c18d01048907ea92(void 0 === t || "string" == typeof t, 58123), $63c47e8a587a7f36$export$9d398bebfec1c039.fromBase64String(t || "")) : ($63c47e8a587a7f36$export$c18d01048907ea92(void 0 === t || // Check if the value is an instance of both Buffer and Uint8Array,
            // despite the fact that Buffer extends Uint8Array. In some
            // environments, such as jsdom, the prototype chain of Buffer
            // does not indicate that it extends Uint8Array.
            t instanceof $63c47e8a587a7f36$require$Buffer || t instanceof Uint8Array, 16193), $63c47e8a587a7f36$export$9d398bebfec1c039.fromUint8Array(t || new Uint8Array));
        }(e, t.targetChange.resumeToken), o = t.targetChange.cause, _ = o && function __PRIVATE_fromRpcStatus(e) {
            const t = void 0 === e.code ? $63c47e8a587a7f36$export$e7094788287c5e9b.UNKNOWN : $63c47e8a587a7f36$var$__PRIVATE_mapCodeFromRpcCode(e.code);
            return new $63c47e8a587a7f36$export$4368d992c4eafac0(t, e.message || "");
        }(o);
        n = new $63c47e8a587a7f36$var$__PRIVATE_WatchTargetChange(r, i, s, _ || null);
    } else if ("documentChange" in t) {
        t.documentChange;
        const r = t.documentChange;
        r.document, r.document.name, r.document.updateTime;
        const i = $63c47e8a587a7f36$var$fromName(e, r.document.name), s = $63c47e8a587a7f36$var$__PRIVATE_fromVersion(r.document.updateTime), o = r.document.createTime ? $63c47e8a587a7f36$var$__PRIVATE_fromVersion(r.document.createTime) : $63c47e8a587a7f36$var$SnapshotVersion.min(), _ = new $63c47e8a587a7f36$export$c4ce752e73470fba({
            mapValue: {
                fields: r.document.fields
            }
        }), a = $63c47e8a587a7f36$var$MutableDocument.newFoundDocument(i, s, o, _), u = r.targetIds || [], c = r.removedTargetIds || [];
        n = new $63c47e8a587a7f36$var$__PRIVATE_DocumentWatchChange(u, c, a.key, a);
    } else if ("documentDelete" in t) {
        t.documentDelete;
        const r = t.documentDelete;
        r.document;
        const i = $63c47e8a587a7f36$var$fromName(e, r.document), s = r.readTime ? $63c47e8a587a7f36$var$__PRIVATE_fromVersion(r.readTime) : $63c47e8a587a7f36$var$SnapshotVersion.min(), o = $63c47e8a587a7f36$var$MutableDocument.newNoDocument(i, s), _ = r.removedTargetIds || [];
        n = new $63c47e8a587a7f36$var$__PRIVATE_DocumentWatchChange([], _, o.key, o);
    } else if ("documentRemove" in t) {
        t.documentRemove;
        const r = t.documentRemove;
        r.document;
        const i = $63c47e8a587a7f36$var$fromName(e, r.document), s = r.removedTargetIds || [];
        n = new $63c47e8a587a7f36$var$__PRIVATE_DocumentWatchChange([], s, i, null);
    } else {
        if (!("filter" in t)) return $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(11601, {
            Vt: t
        });
        {
            t.filter;
            const e = t.filter;
            e.targetId;
            const { count: r = 0, unchangedNames: i } = e, s = new $63c47e8a587a7f36$var$ExistenceFilter(r, i), o = e.targetId;
            n = new $63c47e8a587a7f36$var$__PRIVATE_ExistenceFilterChange(o, s);
        }
    }
    return n;
}
function $63c47e8a587a7f36$var$toMutation(e, t) {
    let n;
    if (t instanceof $63c47e8a587a7f36$var$__PRIVATE_SetMutation) n = {
        update: $63c47e8a587a7f36$var$__PRIVATE_toMutationDocument(e, t.key, t.value)
    };
    else if (t instanceof $63c47e8a587a7f36$export$34aec0b863436764) n = {
        delete: $63c47e8a587a7f36$var$__PRIVATE_toName(e, t.key)
    };
    else if (t instanceof $63c47e8a587a7f36$var$__PRIVATE_PatchMutation) n = {
        update: $63c47e8a587a7f36$var$__PRIVATE_toMutationDocument(e, t.key, t.data),
        updateMask: $63c47e8a587a7f36$var$__PRIVATE_toDocumentMask(t.fieldMask)
    };
    else {
        if (!(t instanceof $63c47e8a587a7f36$var$__PRIVATE_VerifyMutation)) return $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(16599, {
            dt: t.type
        });
        n = {
            verify: $63c47e8a587a7f36$var$__PRIVATE_toName(e, t.key)
        };
    }
    return t.fieldTransforms.length > 0 && (n.updateTransforms = t.fieldTransforms.map((e)=>(function __PRIVATE_toFieldTransform(e, t) {
            const n = t.transform;
            if (n instanceof $63c47e8a587a7f36$var$__PRIVATE_ServerTimestampTransform) return {
                fieldPath: t.field.canonicalString(),
                setToServerValue: "REQUEST_TIME"
            };
            if (n instanceof $63c47e8a587a7f36$var$__PRIVATE_ArrayUnionTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                appendMissingElements: {
                    values: n.elements
                }
            };
            if (n instanceof $63c47e8a587a7f36$var$__PRIVATE_ArrayRemoveTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                removeAllFromArray: {
                    values: n.elements
                }
            };
            if (n instanceof $63c47e8a587a7f36$var$__PRIVATE_NumericIncrementTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                increment: n.Ae
            };
            throw $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(20930, {
                transform: t.transform
            });
        })(0, e))), t.precondition.isNone || (n.currentDocument = function __PRIVATE_toPrecondition(e, t) {
        return void 0 !== t.updateTime ? {
            updateTime: $63c47e8a587a7f36$var$__PRIVATE_toVersion(e, t.updateTime)
        } : void 0 !== t.exists ? {
            exists: t.exists
        } : $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(27497);
    }(e, t.precondition)), n;
}
function $63c47e8a587a7f36$var$__PRIVATE_fromMutation(e, t) {
    const n = t.currentDocument ? function __PRIVATE_fromPrecondition(e) {
        return void 0 !== e.updateTime ? $63c47e8a587a7f36$export$78acf4525d8a74c4.updateTime($63c47e8a587a7f36$var$__PRIVATE_fromVersion(e.updateTime)) : void 0 !== e.exists ? $63c47e8a587a7f36$export$78acf4525d8a74c4.exists(e.exists) : $63c47e8a587a7f36$export$78acf4525d8a74c4.none();
    }(t.currentDocument) : $63c47e8a587a7f36$export$78acf4525d8a74c4.none(), r = t.updateTransforms ? t.updateTransforms.map((t)=>(function __PRIVATE_fromFieldTransform(e, t) {
            let n = null;
            if ("setToServerValue" in t) $63c47e8a587a7f36$export$c18d01048907ea92("REQUEST_TIME" === t.setToServerValue, 16630, {
                proto: t
            }), n = new $63c47e8a587a7f36$var$__PRIVATE_ServerTimestampTransform;
            else if ("appendMissingElements" in t) {
                const e = t.appendMissingElements.values || [];
                n = new $63c47e8a587a7f36$var$__PRIVATE_ArrayUnionTransformOperation(e);
            } else if ("removeAllFromArray" in t) {
                const e = t.removeAllFromArray.values || [];
                n = new $63c47e8a587a7f36$var$__PRIVATE_ArrayRemoveTransformOperation(e);
            } else "increment" in t ? n = new $63c47e8a587a7f36$var$__PRIVATE_NumericIncrementTransformOperation(e, t.increment) : $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(16584, {
                proto: t
            });
            const r = $63c47e8a587a7f36$export$cf2f7c5792f80b46.fromServerFormat(t.fieldPath);
            return new $63c47e8a587a7f36$var$FieldTransform(r, n);
        })(e, t)) : [];
    if (t.update) {
        t.update.name;
        const i = $63c47e8a587a7f36$var$fromName(e, t.update.name), s = new $63c47e8a587a7f36$export$c4ce752e73470fba({
            mapValue: {
                fields: t.update.fields
            }
        });
        if (t.updateMask) {
            const e = function __PRIVATE_fromDocumentMask(e) {
                const t = e.fieldPaths || [];
                return new $63c47e8a587a7f36$var$FieldMask(t.map((e)=>$63c47e8a587a7f36$export$cf2f7c5792f80b46.fromServerFormat(e)));
            }(t.updateMask);
            return new $63c47e8a587a7f36$var$__PRIVATE_PatchMutation(i, s, e, n, r);
        }
        return new $63c47e8a587a7f36$var$__PRIVATE_SetMutation(i, s, n, r);
    }
    if (t.delete) {
        const r = $63c47e8a587a7f36$var$fromName(e, t.delete);
        return new $63c47e8a587a7f36$export$34aec0b863436764(r, n);
    }
    if (t.verify) {
        const r = $63c47e8a587a7f36$var$fromName(e, t.verify);
        return new $63c47e8a587a7f36$var$__PRIVATE_VerifyMutation(r, n);
    }
    return $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(1463, {
        proto: t
    });
}
function $63c47e8a587a7f36$var$__PRIVATE_fromWriteResults(e, t) {
    return e && e.length > 0 ? ($63c47e8a587a7f36$export$c18d01048907ea92(void 0 !== t, 14353), e.map((e)=>(function __PRIVATE_fromWriteResult(e, t) {
            // NOTE: Deletes don't have an updateTime.
            let n = e.updateTime ? $63c47e8a587a7f36$var$__PRIVATE_fromVersion(e.updateTime) : $63c47e8a587a7f36$var$__PRIVATE_fromVersion(t);
            return n.isEqual($63c47e8a587a7f36$var$SnapshotVersion.min()) && // The Firestore Emulator currently returns an update time of 0 for
            // deletes of non-existing documents (rather than null). This breaks the
            // test "get deleted doc while offline with source=cache" as NoDocuments
            // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
            // TODO(#2149): Remove this when Emulator is fixed
            (n = $63c47e8a587a7f36$var$__PRIVATE_fromVersion(t)), new $63c47e8a587a7f36$var$MutationResult(n, e.transformResults || []);
        })(e, t))) : [];
}
function $63c47e8a587a7f36$var$__PRIVATE_toDocumentsTarget(e, t) {
    return {
        documents: [
            $63c47e8a587a7f36$var$__PRIVATE_toQueryPath(e, t.path)
        ]
    };
}
function $63c47e8a587a7f36$var$__PRIVATE_toQueryTarget(e, t) {
    // Dissect the path into parent, collectionId, and optional key filter.
    const n = {
        structuredQuery: {}
    }, r = t.path;
    let i;
    null !== t.collectionGroup ? (i = r, n.structuredQuery.from = [
        {
            collectionId: t.collectionGroup,
            allDescendants: !0
        }
    ]) : (i = r.popLast(), n.structuredQuery.from = [
        {
            collectionId: r.lastSegment()
        }
    ]), n.parent = $63c47e8a587a7f36$var$__PRIVATE_toQueryPath(e, i);
    const s = function __PRIVATE_toFilters(e) {
        if (0 === e.length) return;
        return $63c47e8a587a7f36$var$__PRIVATE_toFilter($63c47e8a587a7f36$export$35e795649ee09318.create(e, "and" /* CompositeOperator.AND */ ));
    }(t.filters);
    s && (n.structuredQuery.where = s);
    const o = function __PRIVATE_toOrder(e) {
        if (0 === e.length) return;
        return e.map((e)=>// visible for testing
            (function __PRIVATE_toPropertyOrder(e) {
                return {
                    field: $63c47e8a587a7f36$var$__PRIVATE_toFieldPathReference(e.field),
                    direction: $63c47e8a587a7f36$var$__PRIVATE_toDirection(e.dir)
                };
            })(e));
    }(t.orderBy);
    o && (n.structuredQuery.orderBy = o);
    const _ = $63c47e8a587a7f36$var$__PRIVATE_toInt32Proto(e, t.limit);
    return null !== _ && (n.structuredQuery.limit = _), t.startAt && (n.structuredQuery.startAt = function __PRIVATE_toStartAtCursor(e) {
        return {
            before: e.inclusive,
            values: e.position
        };
    }(t.startAt)), t.endAt && (n.structuredQuery.endAt = function __PRIVATE_toEndAtCursor(e) {
        return {
            before: !e.inclusive,
            values: e.position
        };
    }(t.endAt)), {
        ft: n,
        parent: i
    };
}
function $63c47e8a587a7f36$var$__PRIVATE_toRunAggregationQueryRequest(e, t, n, r) {
    const { ft: i, parent: s } = $63c47e8a587a7f36$var$__PRIVATE_toQueryTarget(e, t), o = {}, _ = [];
    let a = 0;
    return n.forEach((e)=>{
        // Map all client-side aliases to a unique short-form
        // alias. This avoids issues with client-side aliases that
        // exceed the 1500-byte string size limit.
        const t = r ? e.alias : "aggregate_" + a++;
        o[t] = e.alias, "count" === e.aggregateType ? _.push({
            alias: t,
            count: {}
        }) : "avg" === e.aggregateType ? _.push({
            alias: t,
            avg: {
                field: $63c47e8a587a7f36$var$__PRIVATE_toFieldPathReference(e.fieldPath)
            }
        }) : "sum" === e.aggregateType && _.push({
            alias: t,
            sum: {
                field: $63c47e8a587a7f36$var$__PRIVATE_toFieldPathReference(e.fieldPath)
            }
        });
    }), {
        request: {
            structuredAggregationQuery: {
                aggregations: _,
                structuredQuery: i.structuredQuery
            },
            parent: i.parent
        },
        gt: o,
        parent: s
    };
}
function $63c47e8a587a7f36$var$__PRIVATE_convertQueryTargetToQuery(e) {
    let t = $63c47e8a587a7f36$var$__PRIVATE_fromQueryPath(e.parent);
    const n = e.structuredQuery, r = n.from ? n.from.length : 0;
    let i = null;
    if (r > 0) {
        $63c47e8a587a7f36$export$c18d01048907ea92(1 === r, 65062);
        const e = n.from[0];
        e.allDescendants ? i = e.collectionId : t = t.child(e.collectionId);
    }
    let s = [];
    n.where && (s = function __PRIVATE_fromFilters(e) {
        const t = $63c47e8a587a7f36$var$__PRIVATE_fromFilter(e);
        if (t instanceof $63c47e8a587a7f36$export$35e795649ee09318 && $63c47e8a587a7f36$var$__PRIVATE_compositeFilterIsFlatConjunction(t)) return t.getFilters();
        return [
            t
        ];
    }(n.where));
    let o = [];
    n.orderBy && (o = function __PRIVATE_fromOrder(e) {
        return e.map((e)=>(function __PRIVATE_fromPropertyOrder(e) {
                return new $63c47e8a587a7f36$export$306ddfe3a8403e2($63c47e8a587a7f36$var$__PRIVATE_fromFieldPathReference(e.field), // visible for testing
                function __PRIVATE_fromDirection(e) {
                    switch(e){
                        case "ASCENDING":
                            return "asc" /* Direction.ASCENDING */ ;
                        case "DESCENDING":
                            return "desc" /* Direction.DESCENDING */ ;
                        default:
                            return;
                    }
                }(e.direction));
            })(e));
    }(n.orderBy));
    let _ = null;
    n.limit && (_ = function __PRIVATE_fromInt32Proto(e) {
        let t;
        return t = "object" == typeof e ? e.value : e, $63c47e8a587a7f36$var$__PRIVATE_isNullOrUndefined(t) ? null : t;
    }(n.limit));
    let a = null;
    n.startAt && (a = function __PRIVATE_fromStartAtCursor(e) {
        const t = !!e.before, n = e.values || [];
        return new $63c47e8a587a7f36$export$625550452a3fa3ec(n, t);
    }(n.startAt));
    let u = null;
    return n.endAt && (u = function __PRIVATE_fromEndAtCursor(e) {
        const t = !e.before, n = e.values || [];
        return new $63c47e8a587a7f36$export$625550452a3fa3ec(n, t);
    }(n.endAt)), $63c47e8a587a7f36$var$__PRIVATE_newQuery(t, i, o, s, _, "F" /* LimitType.First */ , a, u);
}
function $63c47e8a587a7f36$var$__PRIVATE_toListenRequestLabels(e, t) {
    const n = function __PRIVATE_toLabel(e) {
        switch(e){
            case "TargetPurposeListen" /* TargetPurpose.Listen */ :
                return null;
            case "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ :
                return "existence-filter-mismatch";
            case "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */ :
                return "existence-filter-mismatch-bloom";
            case "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ :
                return "limbo-document";
            default:
                return $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(28987, {
                    purpose: e
                });
        }
    }(t.purpose);
    return null == n ? null : {
        "goog-listen-tags": n
    };
}
function $63c47e8a587a7f36$var$__PRIVATE_fromFilter(e) {
    return void 0 !== e.unaryFilter ? function __PRIVATE_fromUnaryFilter(e) {
        switch(e.unaryFilter.op){
            case "IS_NAN":
                const t = $63c47e8a587a7f36$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $63c47e8a587a7f36$export$dda1d9f60106f0e9.create(t, "==" /* Operator.EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NULL":
                const n = $63c47e8a587a7f36$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $63c47e8a587a7f36$export$dda1d9f60106f0e9.create(n, "==" /* Operator.EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            case "IS_NOT_NAN":
                const r = $63c47e8a587a7f36$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $63c47e8a587a7f36$export$dda1d9f60106f0e9.create(r, "!=" /* Operator.NOT_EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NOT_NULL":
                const i = $63c47e8a587a7f36$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $63c47e8a587a7f36$export$dda1d9f60106f0e9.create(i, "!=" /* Operator.NOT_EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            case "OPERATOR_UNSPECIFIED":
                return $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(61313);
            default:
                return $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(60726);
        }
    }(e) : void 0 !== e.fieldFilter ? function __PRIVATE_fromFieldFilter(e) {
        return $63c47e8a587a7f36$export$dda1d9f60106f0e9.create($63c47e8a587a7f36$var$__PRIVATE_fromFieldPathReference(e.fieldFilter.field), function __PRIVATE_fromOperatorName(e) {
            switch(e){
                case "EQUAL":
                    return "==" /* Operator.EQUAL */ ;
                case "NOT_EQUAL":
                    return "!=" /* Operator.NOT_EQUAL */ ;
                case "GREATER_THAN":
                    return ">" /* Operator.GREATER_THAN */ ;
                case "GREATER_THAN_OR_EQUAL":
                    return ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ;
                case "LESS_THAN":
                    return "<" /* Operator.LESS_THAN */ ;
                case "LESS_THAN_OR_EQUAL":
                    return "<=" /* Operator.LESS_THAN_OR_EQUAL */ ;
                case "ARRAY_CONTAINS":
                    return "array-contains" /* Operator.ARRAY_CONTAINS */ ;
                case "IN":
                    return "in" /* Operator.IN */ ;
                case "NOT_IN":
                    return "not-in" /* Operator.NOT_IN */ ;
                case "ARRAY_CONTAINS_ANY":
                    return "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ;
                case "OPERATOR_UNSPECIFIED":
                    return $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(58110);
                default:
                    return $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(50506);
            }
        }(e.fieldFilter.op), e.fieldFilter.value);
    }(e) : void 0 !== e.compositeFilter ? function __PRIVATE_fromCompositeFilter(e) {
        return $63c47e8a587a7f36$export$35e795649ee09318.create(e.compositeFilter.filters.map((e)=>$63c47e8a587a7f36$var$__PRIVATE_fromFilter(e)), function __PRIVATE_fromCompositeOperatorName(e) {
            switch(e){
                case "AND":
                    return "and" /* CompositeOperator.AND */ ;
                case "OR":
                    return "or" /* CompositeOperator.OR */ ;
                default:
                    return $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(1026);
            }
        }(e.compositeFilter.op));
    }(e) : $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(30097, {
        filter: e
    });
}
function $63c47e8a587a7f36$var$__PRIVATE_toDirection(e) {
    return $63c47e8a587a7f36$var$ft[e];
}
function $63c47e8a587a7f36$var$__PRIVATE_toOperatorName(e) {
    return $63c47e8a587a7f36$var$gt[e];
}
function $63c47e8a587a7f36$var$__PRIVATE_toCompositeOperatorName(e) {
    return $63c47e8a587a7f36$var$pt[e];
}
function $63c47e8a587a7f36$var$__PRIVATE_toFieldPathReference(e) {
    return {
        fieldPath: e.canonicalString()
    };
}
function $63c47e8a587a7f36$var$__PRIVATE_fromFieldPathReference(e) {
    return $63c47e8a587a7f36$export$cf2f7c5792f80b46.fromServerFormat(e.fieldPath);
}
function $63c47e8a587a7f36$var$__PRIVATE_toFilter(e) {
    return e instanceof $63c47e8a587a7f36$export$dda1d9f60106f0e9 ? function __PRIVATE_toUnaryOrFieldFilter(e) {
        if ("==" /* Operator.EQUAL */  === e.op) {
            if ($63c47e8a587a7f36$var$__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: $63c47e8a587a7f36$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NAN"
                }
            };
            if ($63c47e8a587a7f36$var$__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: $63c47e8a587a7f36$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NULL"
                }
            };
        } else if ("!=" /* Operator.NOT_EQUAL */  === e.op) {
            if ($63c47e8a587a7f36$var$__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: $63c47e8a587a7f36$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NAN"
                }
            };
            if ($63c47e8a587a7f36$var$__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: $63c47e8a587a7f36$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NULL"
                }
            };
        }
        return {
            fieldFilter: {
                field: $63c47e8a587a7f36$var$__PRIVATE_toFieldPathReference(e.field),
                op: $63c47e8a587a7f36$var$__PRIVATE_toOperatorName(e.op),
                value: e.value
            }
        };
    }(e) : e instanceof $63c47e8a587a7f36$export$35e795649ee09318 ? function __PRIVATE_toCompositeFilter(e) {
        const t = e.getFilters().map((e)=>$63c47e8a587a7f36$var$__PRIVATE_toFilter(e));
        if (1 === t.length) return t[0];
        return {
            compositeFilter: {
                op: $63c47e8a587a7f36$var$__PRIVATE_toCompositeOperatorName(e.op),
                filters: t
            }
        };
    }(e) : $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(54877, {
        filter: e
    });
}
function $63c47e8a587a7f36$var$__PRIVATE_toDocumentMask(e) {
    const t = [];
    return e.fields.forEach((e)=>t.push(e.canonicalString())), {
        fieldPaths: t
    };
}
function $63c47e8a587a7f36$var$__PRIVATE_isValidResourceName(e) {
    // Resource names have at least 4 components (project ID, database ID)
    return e.length >= 4 && "projects" === e.get(0) && "databases" === e.get(2);
}
function $63c47e8a587a7f36$var$__PRIVATE_isProtoValueSerializable(// eslint-disable-next-line @typescript-eslint/no-explicit-any
e) {
    return !!e && "function" == typeof e._toProto && "ProtoValue" === e._protoValueType;
}
function $63c47e8a587a7f36$export$62d08d6fa708df47(e, t) {
    const n = {
        fields: {}
    };
    return t.forEach((t, r)=>{
        if ("string" != typeof r) throw new Error(`Cannot encode map with non-string key: ${r}`);
        n.fields[r] = t._toProto(e);
    }), {
        mapValue: n
    };
}
function $63c47e8a587a7f36$export$ad4aebacdcaf47f8(e) {
    return {
        stringValue: e
    };
}
function $63c47e8a587a7f36$export$5521614468b862fb(e) {
    return {
        pipelineValue: e
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable set of metadata that the local store tracks for each target.
 */ class $63c47e8a587a7f36$var$TargetData {
    constructor(/** The target being listened to. */ e, /**
     * The target ID to which the target corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */ t, /** The purpose of the target. */ n, /**
     * The sequence number of the last transaction during which this target data
     * was modified.
     */ r, /** The latest snapshot version seen for this target. */ i = $63c47e8a587a7f36$var$SnapshotVersion.min(), s = $63c47e8a587a7f36$var$SnapshotVersion.min(), o = $63c47e8a587a7f36$export$9d398bebfec1c039.EMPTY_BYTE_STRING, _ = null){
        this.target = e, this.targetId = t, this.purpose = n, this.sequenceNumber = r, this.snapshotVersion = i, this.lastLimboFreeSnapshotVersion = s, this.resumeToken = o, this.expectedCount = _;
    }
    /** Creates a new target data instance with an updated sequence number. */ withSequenceNumber(e) {
        return new $63c47e8a587a7f36$var$TargetData(this.target, this.targetId, this.purpose, e, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, this.expectedCount);
    }
    /**
     * Creates a new target data instance with an updated resume token and
     * snapshot version.
     */ withResumeToken(e, t) {
        return new $63c47e8a587a7f36$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, t, this.lastLimboFreeSnapshotVersion, e, /* expectedCount= */ null);
    }
    /**
     * Creates a new target data instance with an updated expected count.
     */ withExpectedCount(e) {
        return new $63c47e8a587a7f36$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, e);
    }
    /**
     * Creates a new target data instance with an updated last limbo free
     * snapshot version number.
     */ withLastLimboFreeSnapshotVersion(e) {
        return new $63c47e8a587a7f36$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, e, this.resumeToken, this.expectedCount);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Serializer for values stored in the LocalStore. */ class $63c47e8a587a7f36$var$__PRIVATE_LocalSerializer {
    constructor(e){
        this.yt = e;
    }
}
/** Decodes a remote document from storage locally to a Document. */ function $63c47e8a587a7f36$var$__PRIVATE_fromDbRemoteDocument(e, t) {
    let n;
    if (t.document) n = $63c47e8a587a7f36$export$3a1a48c8f6ef640e(e.yt, t.document, !!t.hasCommittedMutations);
    else if (t.noDocument) {
        const e = $63c47e8a587a7f36$export$90a7f3efeed30595.fromSegments(t.noDocument.path), r = $63c47e8a587a7f36$var$__PRIVATE_fromDbTimestamp(t.noDocument.readTime);
        n = $63c47e8a587a7f36$var$MutableDocument.newNoDocument(e, r), t.hasCommittedMutations && n.setHasCommittedMutations();
    } else {
        if (!t.unknownDocument) return $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(56709);
        {
            const e = $63c47e8a587a7f36$export$90a7f3efeed30595.fromSegments(t.unknownDocument.path), r = $63c47e8a587a7f36$var$__PRIVATE_fromDbTimestamp(t.unknownDocument.version);
            n = $63c47e8a587a7f36$var$MutableDocument.newUnknownDocument(e, r);
        }
    }
    return t.readTime && n.setReadTime(function __PRIVATE_fromDbTimestampKey(e) {
        const t = new $63c47e8a587a7f36$export$3d12bd131bb975d1(e[0], e[1]);
        return $63c47e8a587a7f36$var$SnapshotVersion.fromTimestamp(t);
    }(t.readTime)), n;
}
/** Encodes a document for storage locally. */ function $63c47e8a587a7f36$var$__PRIVATE_toDbRemoteDocument(e, t) {
    const n = t.key, r = {
        prefixPath: n.getCollectionPath().popLast().toArray(),
        collectionGroup: n.collectionGroup,
        documentId: n.path.lastSegment(),
        readTime: $63c47e8a587a7f36$var$__PRIVATE_toDbTimestampKey(t.readTime),
        hasCommittedMutations: t.hasCommittedMutations
    };
    if (t.isFoundDocument()) r.document = function __PRIVATE_toDocument(e, t) {
        return {
            name: $63c47e8a587a7f36$var$__PRIVATE_toName(e, t.key),
            fields: t.data.value.mapValue.fields,
            updateTime: $63c47e8a587a7f36$var$toTimestamp(e, t.version.toTimestamp()),
            createTime: $63c47e8a587a7f36$var$toTimestamp(e, t.createTime.toTimestamp())
        };
    }(e.yt, t);
    else if (t.isNoDocument()) r.noDocument = {
        path: n.path.toArray(),
        readTime: $63c47e8a587a7f36$var$__PRIVATE_toDbTimestamp(t.version)
    };
    else {
        if (!t.isUnknownDocument()) return $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(57904, {
            document: t
        });
        r.unknownDocument = {
            path: n.path.toArray(),
            version: $63c47e8a587a7f36$var$__PRIVATE_toDbTimestamp(t.version)
        };
    }
    return r;
}
function $63c47e8a587a7f36$var$__PRIVATE_toDbTimestampKey(e) {
    const t = e.toTimestamp();
    return [
        t.seconds,
        t.nanoseconds
    ];
}
function $63c47e8a587a7f36$var$__PRIVATE_toDbTimestamp(e) {
    const t = e.toTimestamp();
    return {
        seconds: t.seconds,
        nanoseconds: t.nanoseconds
    };
}
function $63c47e8a587a7f36$var$__PRIVATE_fromDbTimestamp(e) {
    const t = new $63c47e8a587a7f36$export$3d12bd131bb975d1(e.seconds, e.nanoseconds);
    return $63c47e8a587a7f36$var$SnapshotVersion.fromTimestamp(t);
}
/** Encodes a batch of mutations into a DbMutationBatch for local storage. */ /** Decodes a DbMutationBatch into a MutationBatch */ function $63c47e8a587a7f36$var$__PRIVATE_fromDbMutationBatch(e, t) {
    const n = (t.baseMutations || []).map((t)=>$63c47e8a587a7f36$var$__PRIVATE_fromMutation(e.yt, t));
    // Squash old transform mutations into existing patch or set mutations.
    // The replacement of representing `transforms` with `update_transforms`
    // on the SDK means that old `transform` mutations stored in IndexedDB need
    // to be updated to `update_transforms`.
    // TODO(b/174608374): Remove this code once we perform a schema migration.
    for(let e = 0; e < t.mutations.length - 1; ++e){
        const n = t.mutations[e];
        if (e + 1 < t.mutations.length && void 0 !== t.mutations[e + 1].transform) {
            const r = t.mutations[e + 1];
            n.updateTransforms = r.transform.fieldTransforms, t.mutations.splice(e + 1, 1), ++e;
        }
    }
    const r = t.mutations.map((t)=>$63c47e8a587a7f36$var$__PRIVATE_fromMutation(e.yt, t)), i = $63c47e8a587a7f36$export$3d12bd131bb975d1.fromMillis(t.localWriteTimeMs);
    return new $63c47e8a587a7f36$var$MutationBatch(t.batchId, i, n, r);
}
/** Decodes a DbTarget into TargetData */ function $63c47e8a587a7f36$var$__PRIVATE_fromDbTarget(e) {
    const t = $63c47e8a587a7f36$var$__PRIVATE_fromDbTimestamp(e.readTime), n = void 0 !== e.lastLimboFreeSnapshotVersion ? $63c47e8a587a7f36$var$__PRIVATE_fromDbTimestamp(e.lastLimboFreeSnapshotVersion) : $63c47e8a587a7f36$var$SnapshotVersion.min();
    let r;
    return r = /**
 * A helper function for figuring out what kind of query has been stored.
 */ function __PRIVATE_isDocumentQuery(e) {
        return void 0 !== e.documents;
    }(e.query) ? function __PRIVATE_fromDocumentsTarget(e) {
        const t = e.documents.length;
        return $63c47e8a587a7f36$export$c18d01048907ea92(1 === t, 1966, {
            count: t
        }), $63c47e8a587a7f36$var$__PRIVATE_queryToTarget($63c47e8a587a7f36$export$a93c5207d687da10($63c47e8a587a7f36$var$__PRIVATE_fromQueryPath(e.documents[0])));
    }(e.query) : function __PRIVATE_fromQueryTarget(e) {
        return $63c47e8a587a7f36$var$__PRIVATE_queryToTarget($63c47e8a587a7f36$var$__PRIVATE_convertQueryTargetToQuery(e));
    }(e.query), new $63c47e8a587a7f36$var$TargetData(r, e.targetId, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.lastListenSequenceNumber, t, n, $63c47e8a587a7f36$export$9d398bebfec1c039.fromBase64String(e.resumeToken));
}
/** Encodes TargetData into a DbTarget for storage locally. */ function $63c47e8a587a7f36$var$__PRIVATE_toDbTarget(e, t) {
    const n = $63c47e8a587a7f36$var$__PRIVATE_toDbTimestamp(t.snapshotVersion), r = $63c47e8a587a7f36$var$__PRIVATE_toDbTimestamp(t.lastLimboFreeSnapshotVersion);
    let i;
    i = $63c47e8a587a7f36$var$__PRIVATE_targetIsDocumentTarget(t.target) ? $63c47e8a587a7f36$var$__PRIVATE_toDocumentsTarget(e.yt, t.target) : $63c47e8a587a7f36$var$__PRIVATE_toQueryTarget(e.yt, t.target).ft;
    // We can't store the resumeToken as a ByteString in IndexedDb, so we
    // convert it to a base64 string for storage.
    const s = t.resumeToken.toBase64();
    // lastListenSequenceNumber is always 0 until we do real GC.
    return {
        targetId: t.targetId,
        canonicalId: $63c47e8a587a7f36$var$__PRIVATE_canonifyTarget(t.target),
        readTime: n,
        resumeToken: s,
        lastListenSequenceNumber: t.sequenceNumber,
        lastLimboFreeSnapshotVersion: r,
        query: i
    };
}
/**
 * Encodes a `BundledQuery` from bundle proto to a Query object.
 *
 * This reconstructs the original query used to build the bundle being loaded,
 * including features exists only in SDKs (for example: limit-to-last).
 */ function $63c47e8a587a7f36$export$56c0d5a1e737357d(e) {
    const t = $63c47e8a587a7f36$var$__PRIVATE_convertQueryTargetToQuery({
        parent: e.parent,
        structuredQuery: e.structuredQuery
    });
    return "LAST" === e.limitType ? $63c47e8a587a7f36$export$882b5998b3b9117c(t, t.limit, "L" /* LimitType.Last */ ) : t;
}
/** Encodes a NamedQuery proto object to a NamedQuery model object. */ /** Encodes a DbDocumentOverlay object to an Overlay model object. */ function $63c47e8a587a7f36$var$__PRIVATE_fromDbDocumentOverlay(e, t) {
    return new $63c47e8a587a7f36$var$Overlay(t.largestBatchId, $63c47e8a587a7f36$var$__PRIVATE_fromMutation(e.yt, t.overlayMutation));
}
/** Decodes an Overlay model object into a DbDocumentOverlay object. */ /**
 * Returns the DbDocumentOverlayKey corresponding to the given user and
 * document key.
 */ function $63c47e8a587a7f36$var$__PRIVATE_toDbDocumentOverlayKey(e, t) {
    const n = t.path.lastSegment();
    return [
        e,
        $63c47e8a587a7f36$var$__PRIVATE_encodeResourcePath(t.path.popLast()),
        n
    ];
}
function $63c47e8a587a7f36$var$__PRIVATE_toDbIndexState(e, t, n, r) {
    return {
        indexId: e,
        uid: t,
        sequenceNumber: n,
        readTime: $63c47e8a587a7f36$var$__PRIVATE_toDbTimestamp(r.readTime),
        documentKey: $63c47e8a587a7f36$var$__PRIVATE_encodeResourcePath(r.documentKey.path),
        largestBatchId: r.largestBatchId
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $63c47e8a587a7f36$var$__PRIVATE_IndexedDbBundleCache {
    getBundleMetadata(e, t) {
        return $63c47e8a587a7f36$var$__PRIVATE_bundlesStore(e).get(t).next((e)=>{
            if (e) return function __PRIVATE_fromDbBundle(e) {
                return {
                    id: e.bundleId,
                    createTime: $63c47e8a587a7f36$var$__PRIVATE_fromDbTimestamp(e.createTime),
                    version: e.version
                };
            }(e);
        });
    }
    saveBundleMetadata(e, t) {
        return $63c47e8a587a7f36$var$__PRIVATE_bundlesStore(e).put(function __PRIVATE_toDbBundle(e) {
            return {
                bundleId: e.id,
                createTime: $63c47e8a587a7f36$var$__PRIVATE_toDbTimestamp($63c47e8a587a7f36$var$__PRIVATE_fromVersion(e.createTime)),
                version: e.version
            };
        }(t));
    }
    getNamedQuery(e, t) {
        return $63c47e8a587a7f36$var$__PRIVATE_namedQueriesStore(e).get(t).next((e)=>{
            if (e) return function __PRIVATE_fromDbNamedQuery(e) {
                return {
                    name: e.name,
                    query: $63c47e8a587a7f36$export$56c0d5a1e737357d(e.bundledQuery),
                    readTime: $63c47e8a587a7f36$var$__PRIVATE_fromDbTimestamp(e.readTime)
                };
            }(e);
        });
    }
    saveNamedQuery(e, t) {
        return $63c47e8a587a7f36$var$__PRIVATE_namedQueriesStore(e).put(function __PRIVATE_toDbNamedQuery(e) {
            return {
                name: e.name,
                readTime: $63c47e8a587a7f36$var$__PRIVATE_toDbTimestamp($63c47e8a587a7f36$var$__PRIVATE_fromVersion(e.readTime)),
                bundledQuery: e.bundledQuery
            };
        }(t));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the bundles object store.
 */ function $63c47e8a587a7f36$var$__PRIVATE_bundlesStore(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_getStore(e, $63c47e8a587a7f36$var$fe);
}
/**
 * Helper to get a typed SimpleDbStore for the namedQueries object store.
 */ function $63c47e8a587a7f36$var$__PRIVATE_namedQueriesStore(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_getStore(e, $63c47e8a587a7f36$var$pe);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implementation of DocumentOverlayCache using IndexedDb.
 */ class $63c47e8a587a7f36$var$__PRIVATE_IndexedDbDocumentOverlayCache {
    /**
     * @param serializer - The document serializer.
     * @param userId - The userId for which we are accessing overlays.
     */ constructor(e, t){
        this.serializer = e, this.userId = t;
    }
    static wt(e, t) {
        const n = t.uid || "";
        return new $63c47e8a587a7f36$var$__PRIVATE_IndexedDbDocumentOverlayCache(e, n);
    }
    getOverlay(e, t) {
        return $63c47e8a587a7f36$var$__PRIVATE_documentOverlayStore(e).get($63c47e8a587a7f36$var$__PRIVATE_toDbDocumentOverlayKey(this.userId, t)).next((e)=>e ? $63c47e8a587a7f36$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, e) : null);
    }
    getOverlays(e, t) {
        const n = $63c47e8a587a7f36$var$__PRIVATE_newOverlayMap();
        return $63c47e8a587a7f36$var$PersistencePromise.forEach(t, (t)=>this.getOverlay(e, t).next((e)=>{
                null !== e && n.set(t, e);
            })).next(()=>n);
    }
    saveOverlays(e, t, n) {
        const r = [];
        return n.forEach((n, i)=>{
            const s = new $63c47e8a587a7f36$var$Overlay(t, i);
            r.push(this.bt(e, s));
        }), $63c47e8a587a7f36$var$PersistencePromise.waitFor(r);
    }
    removeOverlaysForBatchId(e, t, n) {
        const r = new Set;
        // Get the set of unique collection paths.
        t.forEach((e)=>r.add($63c47e8a587a7f36$var$__PRIVATE_encodeResourcePath(e.getCollectionPath())));
        const i = [];
        return r.forEach((t)=>{
            const r = IDBKeyRange.bound([
                this.userId,
                t,
                n
            ], [
                this.userId,
                t,
                n + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
            i.push($63c47e8a587a7f36$var$__PRIVATE_documentOverlayStore(e).X($63c47e8a587a7f36$var$Ke, r));
        }), $63c47e8a587a7f36$var$PersistencePromise.waitFor(i);
    }
    getOverlaysForCollection(e, t, n) {
        const r = $63c47e8a587a7f36$var$__PRIVATE_newOverlayMap(), i = $63c47e8a587a7f36$var$__PRIVATE_encodeResourcePath(t), s = IDBKeyRange.bound([
            this.userId,
            i,
            n
        ], [
            this.userId,
            i,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $63c47e8a587a7f36$var$__PRIVATE_documentOverlayStore(e).H($63c47e8a587a7f36$var$Ke, s).next((e)=>{
            for (const t of e){
                const e = $63c47e8a587a7f36$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, t);
                r.set(e.getKey(), e);
            }
            return r;
        });
    }
    getOverlaysForCollectionGroup(e, t, n, r) {
        const i = $63c47e8a587a7f36$var$__PRIVATE_newOverlayMap();
        let s;
        // We want batch IDs larger than `sinceBatchId`, and so the lower bound
        // is not inclusive.
        const o = IDBKeyRange.bound([
            this.userId,
            t,
            n
        ], [
            this.userId,
            t,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $63c47e8a587a7f36$var$__PRIVATE_documentOverlayStore(e).ee({
            index: $63c47e8a587a7f36$var$Ue,
            range: o
        }, (e, t, n)=>{
            // We do not want to return partial batch overlays, even if the size
            // of the result set exceeds the given `count` argument. Therefore, we
            // continue to aggregate results even after the result size exceeds
            // `count` if there are more overlays from the `currentBatchId`.
            const o = $63c47e8a587a7f36$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, t);
            i.size() < r || o.largestBatchId === s ? (i.set(o.getKey(), o), s = o.largestBatchId) : n.done();
        }).next(()=>i);
    }
    bt(e, t) {
        return $63c47e8a587a7f36$var$__PRIVATE_documentOverlayStore(e).put(function __PRIVATE_toDbDocumentOverlay(e, t, n) {
            const [r, i, s] = $63c47e8a587a7f36$var$__PRIVATE_toDbDocumentOverlayKey(t, n.mutation.key);
            return {
                userId: t,
                collectionPath: i,
                documentId: s,
                collectionGroup: n.mutation.key.getCollectionGroup(),
                largestBatchId: n.largestBatchId,
                overlayMutation: $63c47e8a587a7f36$var$toMutation(e.yt, n.mutation)
            };
        }(this.serializer, this.userId, t));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the document overlay object store.
 */ function $63c47e8a587a7f36$var$__PRIVATE_documentOverlayStore(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_getStore(e, $63c47e8a587a7f36$var$Le);
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $63c47e8a587a7f36$var$__PRIVATE_IndexedDbGlobalsCache {
    St(e) {
        return $63c47e8a587a7f36$var$__PRIVATE_getStore(e, $63c47e8a587a7f36$var$We);
    }
    getSessionToken(e) {
        return this.St(e).get("sessionToken").next((e)=>{
            const t = e?.value;
            return t ? $63c47e8a587a7f36$export$9d398bebfec1c039.fromUint8Array(t) : $63c47e8a587a7f36$export$9d398bebfec1c039.EMPTY_BYTE_STRING;
        });
    }
    setSessionToken(e, t) {
        return this.St(e).put({
            name: "sessionToken",
            value: t.toUint8Array()
        });
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Note: This code is copied from the backend. Code that is not used by
// Firestore was removed.
/** Firestore index value writer.  */ class $63c47e8a587a7f36$var$__PRIVATE_FirestoreIndexValueWriter {
    constructor(){}
    // The write methods below short-circuit writing terminators for values
    // containing a (terminating) truncated value.
    // As an example, consider the resulting encoding for:
    // ["bar", [2, "foo"]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TERM, TERM, TERM)
    // ["bar", [2, truncated("foo")]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TRUNC)
    // ["bar", truncated(["foo"])] -> (STRING, "bar", TERM, ARRAY. STRING, "foo", TERM, TRUNC)
    /** Writes an index value.  */ Dt(e, t) {
        this.Ct(e, t), // Write separator to split index values
        // (see go/firestore-storage-format#encodings).
        t.vt();
    }
    Ct(e, t) {
        if ("nullValue" in e) this.Ft(t, 5);
        else if ("booleanValue" in e) this.Ft(t, 10), t.Mt(e.booleanValue ? 1 : 0);
        else if ("integerValue" in e) this.Ft(t, 15), t.Mt($63c47e8a587a7f36$var$__PRIVATE_normalizeNumber(e.integerValue));
        else if ("doubleValue" in e) {
            const n = $63c47e8a587a7f36$var$__PRIVATE_normalizeNumber(e.doubleValue);
            isNaN(n) ? this.Ft(t, 13) : (this.Ft(t, 15), $63c47e8a587a7f36$var$__PRIVATE_isNegativeZero(n) ? // -0.0, 0 and 0.0 are all considered the same
            t.Mt(0) : t.Mt(n));
        } else if ("timestampValue" in e) {
            let n = e.timestampValue;
            this.Ft(t, 20), "string" == typeof n && (n = $63c47e8a587a7f36$var$__PRIVATE_normalizeTimestamp(n)), t.xt(`${n.seconds || ""}`), t.Mt(n.nanos || 0);
        } else if ("stringValue" in e) this.Ot(e.stringValue, t), this.Nt(t);
        else if ("bytesValue" in e) this.Ft(t, 30), t.Bt($63c47e8a587a7f36$var$__PRIVATE_normalizeByteString(e.bytesValue)), this.Nt(t);
        else if ("referenceValue" in e) this.Lt(e.referenceValue, t);
        else if ("geoPointValue" in e) {
            const n = e.geoPointValue;
            this.Ft(t, 45), t.Mt(n.latitude || 0), t.Mt(n.longitude || 0);
        } else "mapValue" in e ? $63c47e8a587a7f36$var$__PRIVATE_isMaxValue(e) ? this.Ft(t, Number.MAX_SAFE_INTEGER) : $63c47e8a587a7f36$var$__PRIVATE_isVectorValue(e) ? this.kt(e.mapValue, t) : (this.Kt(e.mapValue, t), this.Nt(t)) : "arrayValue" in e ? (this.qt(e.arrayValue, t), this.Nt(t)) : $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(19022, {
            Ut: e
        });
    }
    Ot(e, t) {
        this.Ft(t, 25), this.$t(e, t);
    }
    $t(e, t) {
        t.xt(e);
    }
    Kt(e, t) {
        const n = e.fields || {};
        this.Ft(t, 55);
        for (const e of Object.keys(n))this.Ot(e, t), this.Ct(n[e], t);
    }
    kt(e, t) {
        const n = e.fields || {};
        this.Ft(t, 53);
        // Vectors sort first by length
        const r = $63c47e8a587a7f36$var$ct, i = n[r].arrayValue?.values?.length || 0;
        this.Ft(t, 15), t.Mt($63c47e8a587a7f36$var$__PRIVATE_normalizeNumber(i)), // Vectors then sort by position value
        this.Ot(r, t), this.Ct(n[r], t);
    }
    qt(e, t) {
        const n = e.values || [];
        this.Ft(t, 50);
        for (const e of n)this.Ct(e, t);
    }
    Lt(e, t) {
        this.Ft(t, 37);
        $63c47e8a587a7f36$export$90a7f3efeed30595.fromName(e).path.forEach((e)=>{
            this.Ft(t, 60), this.$t(e, t);
        });
    }
    Ft(e, t) {
        e.Mt(t);
    }
    Nt(e) {
        // While the SDK does not implement truncation, the truncation marker is
        // used to terminate all variable length values (which are strings, bytes,
        // references, arrays and maps).
        e.Mt(2);
    }
}
$63c47e8a587a7f36$var$__PRIVATE_FirestoreIndexValueWriter.Wt = new $63c47e8a587a7f36$var$__PRIVATE_FirestoreIndexValueWriter;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law | agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES | CONDITIONS OF ANY KIND, either express | implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** These constants are taken from the backend. */ const $63c47e8a587a7f36$var$yt = 255;
/**
 * Counts the number of zeros in a byte.
 *
 * Visible for testing.
 */ function $63c47e8a587a7f36$var$__PRIVATE_numberOfLeadingZerosInByte(e) {
    if (0 === e) return 8;
    let t = 0;
    return e >> 4 || // Test if the first four bits are zero.
    (t += 4, e <<= 4), e >> 6 || // Test if the first two (or next two) bits are zero.
    (t += 2, e <<= 2), e >> 7 || // Test if the remaining bit is zero.
    (t += 1), t;
}
/** Counts the number of leading zeros in the given byte array. */ /**
 * Returns the number of bytes required to store "value". Leading zero bytes
 * are skipped.
 */ function $63c47e8a587a7f36$var$__PRIVATE_unsignedNumLength(e) {
    // This is just the number of bytes for the unsigned representation of the number.
    const t = 64 - function __PRIVATE_numberOfLeadingZeros(e) {
        let t = 0;
        for(let n = 0; n < 8; ++n){
            const r = $63c47e8a587a7f36$var$__PRIVATE_numberOfLeadingZerosInByte(255 & e[n]);
            if (t += r, 8 !== r) break;
        }
        return t;
    }(e);
    return Math.ceil(t / 8);
}
/**
 * OrderedCodeWriter is a minimal-allocation implementation of the writing
 * behavior defined by the backend.
 *
 * The code is ported from its Java counterpart.
 */ class $63c47e8a587a7f36$var$__PRIVATE_OrderedCodeWriter {
    constructor(){
        this.buffer = new Uint8Array(1024), this.position = 0;
    }
    Qt(e) {
        const t = e[Symbol.iterator]();
        let n = t.next();
        for(; !n.done;)this.Gt(n.value), n = t.next();
        this.zt();
    }
    jt(e) {
        const t = e[Symbol.iterator]();
        let n = t.next();
        for(; !n.done;)this.Ht(n.value), n = t.next();
        this.Jt();
    }
    /** Writes utf8 bytes into this byte sequence, ascending. */ Zt(e) {
        for (const t of e){
            const e = t.charCodeAt(0);
            if (e < 128) this.Gt(e);
            else if (e < 2048) this.Gt(960 | e >>> 6), this.Gt(128 | 63 & e);
            else if (t < "\ud800" || "\udbff" < t) this.Gt(480 | e >>> 12), this.Gt(128 | 63 & e >>> 6), this.Gt(128 | 63 & e);
            else {
                const e = t.codePointAt(0);
                this.Gt(240 | e >>> 18), this.Gt(128 | 63 & e >>> 12), this.Gt(128 | 63 & e >>> 6), this.Gt(128 | 63 & e);
            }
        }
        this.zt();
    }
    /** Writes utf8 bytes into this byte sequence, descending */ Xt(e) {
        for (const t of e){
            const e = t.charCodeAt(0);
            if (e < 128) this.Ht(e);
            else if (e < 2048) this.Ht(960 | e >>> 6), this.Ht(128 | 63 & e);
            else if (t < "\ud800" || "\udbff" < t) this.Ht(480 | e >>> 12), this.Ht(128 | 63 & e >>> 6), this.Ht(128 | 63 & e);
            else {
                const e = t.codePointAt(0);
                this.Ht(240 | e >>> 18), this.Ht(128 | 63 & e >>> 12), this.Ht(128 | 63 & e >>> 6), this.Ht(128 | 63 & e);
            }
        }
        this.Jt();
    }
    Yt(e) {
        // Values are encoded with a single byte length prefix, followed by the
        // actual value in big-endian format with leading 0 bytes dropped.
        const t = this.en(e), n = $63c47e8a587a7f36$var$__PRIVATE_unsignedNumLength(t);
        this.tn(1 + n), this.buffer[this.position++] = 255 & n;
        // Write the length
        for(let e = t.length - n; e < t.length; ++e)this.buffer[this.position++] = 255 & t[e];
    }
    nn(e) {
        // Values are encoded with a single byte length prefix, followed by the
        // inverted value in big-endian format with leading 0 bytes dropped.
        const t = this.en(e), n = $63c47e8a587a7f36$var$__PRIVATE_unsignedNumLength(t);
        this.tn(1 + n), this.buffer[this.position++] = ~(255 & n);
        // Write the length
        for(let e = t.length - n; e < t.length; ++e)this.buffer[this.position++] = ~(255 & t[e]);
    }
    /**
     * Writes the "infinity" byte sequence that sorts after all other byte
     * sequences written in ascending order.
     */ rn() {
        this.sn($63c47e8a587a7f36$var$yt), this.sn(255);
    }
    /**
     * Writes the "infinity" byte sequence that sorts before all other byte
     * sequences written in descending order.
     */ _n() {
        this.an($63c47e8a587a7f36$var$yt), this.an(255);
    }
    /**
     * Resets the buffer such that it is the same as when it was newly
     * constructed.
     */ reset() {
        this.position = 0;
    }
    seed(e) {
        this.tn(e.length), this.buffer.set(e, this.position), this.position += e.length;
    }
    /** Makes a copy of the encoded bytes in this buffer.  */ un() {
        return this.buffer.slice(0, this.position);
    }
    /**
     * Encodes `val` into an encoding so that the order matches the IEEE 754
     * floating-point comparison results with the following exceptions:
     *   -0.0 < 0.0
     *   all non-NaN < NaN
     *   NaN = NaN
     */ en(e) {
        const t = /** Converts a JavaScript number to a byte array (using big endian encoding). */ function __PRIVATE_doubleToLongBits(e) {
            const t = new DataView(new ArrayBuffer(8));
            return t.setFloat64(0, e, /* littleEndian= */ !1), new Uint8Array(t.buffer);
        }(e), n = !!(128 & t[0]);
        // Check if the first bit is set. We use a bit mask since value[0] is
        // encoded as a number from 0 to 255.
        // Revert the two complement to get natural ordering
        t[0] ^= n ? 255 : 128;
        for(let e = 1; e < t.length; ++e)t[e] ^= n ? 255 : 0;
        return t;
    }
    /** Writes a single byte ascending to the buffer. */ Gt(e) {
        const t = 255 & e;
        0 === t ? (this.sn(0), this.sn(255)) : t === $63c47e8a587a7f36$var$yt ? (this.sn($63c47e8a587a7f36$var$yt), this.sn(0)) : this.sn(t);
    }
    /** Writes a single byte descending to the buffer.  */ Ht(e) {
        const t = 255 & e;
        0 === t ? (this.an(0), this.an(255)) : t === $63c47e8a587a7f36$var$yt ? (this.an($63c47e8a587a7f36$var$yt), this.an(0)) : this.an(e);
    }
    zt() {
        this.sn(0), this.sn(1);
    }
    Jt() {
        this.an(0), this.an(1);
    }
    sn(e) {
        this.tn(1), this.buffer[this.position++] = e;
    }
    an(e) {
        this.tn(1), this.buffer[this.position++] = ~e;
    }
    tn(e) {
        const t = e + this.position;
        if (t <= this.buffer.length) return;
        // Try doubling.
        let n = 2 * this.buffer.length;
        // Still not big enough? Just allocate the right size.
        n < t && (n = t);
        // Create the new buffer.
        const r = new Uint8Array(n);
        r.set(this.buffer), this.buffer = r;
    }
}
class $63c47e8a587a7f36$var$__PRIVATE_AscendingIndexByteEncoder {
    constructor(e){
        this.cn = e;
    }
    Bt(e) {
        this.cn.Qt(e);
    }
    xt(e) {
        this.cn.Zt(e);
    }
    Mt(e) {
        this.cn.Yt(e);
    }
    vt() {
        this.cn.rn();
    }
}
class $63c47e8a587a7f36$var$__PRIVATE_DescendingIndexByteEncoder {
    constructor(e){
        this.cn = e;
    }
    Bt(e) {
        this.cn.jt(e);
    }
    xt(e) {
        this.cn.Xt(e);
    }
    Mt(e) {
        this.cn.nn(e);
    }
    vt() {
        this.cn._n();
    }
}
/**
 * Implements `DirectionalIndexByteEncoder` using `OrderedCodeWriter` for the
 * actual encoding.
 */ class $63c47e8a587a7f36$var$__PRIVATE_IndexByteEncoder {
    constructor(){
        this.cn = new $63c47e8a587a7f36$var$__PRIVATE_OrderedCodeWriter, this.ascending = new $63c47e8a587a7f36$var$__PRIVATE_AscendingIndexByteEncoder(this.cn), this.descending = new $63c47e8a587a7f36$var$__PRIVATE_DescendingIndexByteEncoder(this.cn);
    }
    seed(e) {
        this.cn.seed(e);
    }
    ln(e) {
        return 0 /* IndexKind.ASCENDING */  === e ? this.ascending : this.descending;
    }
    un() {
        return this.cn.un();
    }
    reset() {
        this.cn.reset();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Represents an index entry saved by the SDK in persisted storage. */ class $63c47e8a587a7f36$var$__PRIVATE_IndexEntry {
    constructor(e, t, n, r){
        this.hn = e, this.Pn = t, this.Tn = n, this.In = r;
    }
    /**
     * Returns an IndexEntry entry that sorts immediately after the current
     * directional value.
     */ En() {
        const e = this.In.length, t = 0 === e || 255 === this.In[e - 1] ? e + 1 : e, n = new Uint8Array(t);
        return n.set(this.In, 0), t !== e ? n.set([
            0
        ], this.In.length) : ++n[n.length - 1], new $63c47e8a587a7f36$var$__PRIVATE_IndexEntry(this.hn, this.Pn, this.Tn, n);
    }
    // Create a representation of the Index Entry as a DbIndexEntry
    Rn(e, t, n) {
        return {
            indexId: this.hn,
            uid: e,
            arrayValue: $63c47e8a587a7f36$var$__PRIVATE_encodeKeySafeBytes(this.Tn),
            directionalValue: $63c47e8a587a7f36$var$__PRIVATE_encodeKeySafeBytes(this.In),
            orderedDocumentKey: $63c47e8a587a7f36$var$__PRIVATE_encodeKeySafeBytes(t),
            documentKey: n.path.toArray()
        };
    }
    // Create a representation of the Index Entry as a DbIndexEntryKey
    An(e, t, n) {
        const r = this.Rn(e, t, n);
        return [
            r.indexId,
            r.uid,
            r.arrayValue,
            r.directionalValue,
            r.orderedDocumentKey,
            r.documentKey
        ];
    }
}
function $63c47e8a587a7f36$var$__PRIVATE_indexEntryComparator(e, t) {
    let n = e.hn - t.hn;
    return 0 !== n ? n : (n = $63c47e8a587a7f36$var$__PRIVATE_compareByteArrays(e.Tn, t.Tn), 0 !== n ? n : (n = $63c47e8a587a7f36$var$__PRIVATE_compareByteArrays(e.In, t.In), 0 !== n ? n : $63c47e8a587a7f36$export$90a7f3efeed30595.comparator(e.Pn, t.Pn)));
}
function $63c47e8a587a7f36$var$__PRIVATE_compareByteArrays(e, t) {
    for(let n = 0; n < e.length && n < t.length; ++n){
        const r = e[n] - t[n];
        if (0 !== r) return r;
    }
    return e.length - t.length;
}
/**
 * Workaround for WebKit bug: https://bugs.webkit.org/show_bug.cgi?id=292721
 * Create a key safe representation of Uint8Array values.
 * If the browser is detected as Safari or WebKit, then
 * the input array will be converted to "sortable byte string".
 * Otherwise, the input array will be returned in its original type.
 */ function $63c47e8a587a7f36$var$__PRIVATE_encodeKeySafeBytes(e) {
    return (0, $3117f6f4eeb4c314$export$ef10bcfb06572016)() ? /**
 * Encodes a Uint8Array into a "sortable byte string".
 * A "sortable byte string" sorts in the same order as the Uint8Array.
 * This works because JS string comparison sorts strings based on code points.
 */ function __PRIVATE_encodeUint8ArrayToSortableString(e) {
        let t = "";
        for(let n = 0; n < e.length; n++)t += String.fromCharCode(e[n]);
        return t;
    }(e) : e;
}
/**
 * Reverts the key safe representation of Uint8Array (created by
 * encodeKeySafeBytes) to a normal Uint8Array.
 */ function $63c47e8a587a7f36$var$__PRIVATE_decodeKeySafeBytes(e) {
    return "string" != typeof e ? e : function __PRIVATE_decodeSortableStringToUint8Array(e) {
        const t = new Uint8Array(e.length);
        for(let n = 0; n < e.length; n++)t[n] = e.charCodeAt(n);
        return t;
    }(e);
}
class $63c47e8a587a7f36$var$__PRIVATE_TargetIndexMatcher {
    constructor(e){
        // The inequality filters of the target (if it exists).
        // Note: The sort on FieldFilters is not required. Using SortedSet here just to utilize the custom
        // comparator.
        this.Vn = new $63c47e8a587a7f36$var$SortedSet((e, t)=>$63c47e8a587a7f36$export$cf2f7c5792f80b46.comparator(e.field, t.field)), this.collectionId = null != e.collectionGroup ? e.collectionGroup : e.path.lastSegment(), this.dn = e.orderBy, this.mn = [];
        for (const t of e.filters){
            const e = t;
            e.isInequality() ? this.Vn = this.Vn.add(e) : this.mn.push(e);
        }
    }
    get fn() {
        return this.Vn.size > 1;
    }
    /**
     * Returns whether the index can be used to serve the TargetIndexMatcher's
     * target.
     *
     * An index is considered capable of serving the target when:
     * - The target uses all index segments for its filters and orderBy clauses.
     *   The target can have additional filter and orderBy clauses, but not
     *   fewer.
     * - If an ArrayContains/ArrayContainsAnyfilter is used, the index must also
     *   have a corresponding `CONTAINS` segment.
     * - All directional index segments can be mapped to the target as a series of
     *   equality filters, a single inequality filter and a series of orderBy
     *   clauses.
     * - The segments that represent the equality filters may appear out of order.
     * - The optional segment for the inequality filter must appear after all
     *   equality segments.
     * - The segments that represent that orderBy clause of the target must appear
     *   in order after all equality and inequality segments. Single orderBy
     *   clauses cannot be skipped, but a continuous orderBy suffix may be
     *   omitted.
     */ gn(e) {
        if ($63c47e8a587a7f36$export$c18d01048907ea92(e.collectionGroup === this.collectionId, 49279), this.fn) // Only single inequality is supported for now.
        // TODO(Add support for multiple inequality query): b/298441043
        return !1;
        // If there is an array element, find a matching filter.
        const t = $63c47e8a587a7f36$var$__PRIVATE_fieldIndexGetArraySegment(e);
        if (void 0 !== t && !this.pn(t)) return !1;
        const n = $63c47e8a587a7f36$var$__PRIVATE_fieldIndexGetDirectionalSegments(e);
        let r = new Set, i = 0, s = 0;
        // Process all equalities first. Equalities can appear out of order.
        for(; i < n.length && this.pn(n[i]); ++i)r = r.add(n[i].fieldPath.canonicalString());
        // If we already have processed all segments, all segments are used to serve
        // the equality filters and we do not need to map any segments to the
        // target's inequality and orderBy clauses.
        if (i === n.length) return !0;
        if (this.Vn.size > 0) {
            // Only a single inequality is currently supported. Get the only entry in the set.
            const e = this.Vn.getIterator().getNext();
            // If there is an inequality filter and the field was not in one of the
            // equality filters above, the next segment must match both the filter
            // and the first orderBy clause.
            if (!r.has(e.field.canonicalString())) {
                const t = n[i];
                if (!this.yn(e, t) || !this.wn(this.dn[s++], t)) return !1;
            }
            ++i;
        }
        // All remaining segments need to represent the prefix of the target's
        // orderBy.
        for(; i < n.length; ++i){
            const e = n[i];
            if (s >= this.dn.length || !this.wn(this.dn[s++], e)) return !1;
        }
        return !0;
    }
    /**
     * Returns a full matched field index for this target. Currently multiple
     * inequality query is not supported so function returns null.
     */ bn() {
        if (this.fn) return null;
        // We want to make sure only one segment created for one field. For example,
        // in case like a == 3 and a > 2, Index {a ASCENDING} will only be created
        // once.
        let e = new $63c47e8a587a7f36$var$SortedSet($63c47e8a587a7f36$export$cf2f7c5792f80b46.comparator);
        const t = [];
        for (const n of this.mn){
            if (n.field.isKeyField()) continue;
            if ("array-contains" /* Operator.ARRAY_CONTAINS */  === n.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === n.op) t.push(new $63c47e8a587a7f36$export$c9170ad7d4cd7e57(n.field, 2 /* IndexKind.CONTAINS */ ));
            else {
                if (e.has(n.field)) continue;
                e = e.add(n.field), t.push(new $63c47e8a587a7f36$export$c9170ad7d4cd7e57(n.field, 0 /* IndexKind.ASCENDING */ ));
            }
        }
        // Note: We do not explicitly check `this.inequalityFilter` but rather rely
        // on the target defining an appropriate "order by" to ensure that the
        // required index segment is added. The query engine would reject a query
        // with an inequality filter that lacks the required order-by clause.
        for (const n of this.dn)// Stop adding more segments if we see a order-by on key. Typically this
        // is the default implicit order-by which is covered in the index_entry
        // table as a separate column. If it is not the default order-by, the
        // generated index will be missing some segments optimized for order-bys,
        // which is probably fine.
        n.field.isKeyField() || e.has(n.field) || (e = e.add(n.field), t.push(new $63c47e8a587a7f36$export$c9170ad7d4cd7e57(n.field, "asc" /* Direction.ASCENDING */  === n.dir ? 0 /* IndexKind.ASCENDING */  : 1 /* IndexKind.DESCENDING */ )));
        return new $63c47e8a587a7f36$export$ee7c8ad385a60b7b($63c47e8a587a7f36$export$ee7c8ad385a60b7b.UNKNOWN_ID, this.collectionId, t, $63c47e8a587a7f36$export$995eb9fca571757.empty());
    }
    pn(e) {
        for (const t of this.mn)if (this.yn(t, e)) return !0;
        return !1;
    }
    yn(e, t) {
        if (void 0 === e || !e.field.isEqual(t.fieldPath)) return !1;
        const n = "array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op;
        return 2 /* IndexKind.CONTAINS */  === t.kind === n;
    }
    wn(e, t) {
        return !!e.field.isEqual(t.fieldPath) && (0 /* IndexKind.ASCENDING */  === t.kind && "asc" /* Direction.ASCENDING */  === e.dir || 1 /* IndexKind.DESCENDING */  === t.kind && "desc" /* Direction.DESCENDING */  === e.dir);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides utility functions that help with boolean logic transformations needed for handling
 * complex filters used in queries.
 */ /**
 * The `in` filter is only a syntactic sugar over a disjunction of equalities. For instance: `a in
 * [1,2,3]` is in fact `a==1 || a==2 || a==3`. This method expands any `in` filter in the given
 * input into a disjunction of equality filters and returns the expanded filter.
 */ function $63c47e8a587a7f36$var$__PRIVATE_computeInExpansion(e) {
    if ($63c47e8a587a7f36$export$c18d01048907ea92(e instanceof $63c47e8a587a7f36$export$dda1d9f60106f0e9 || e instanceof $63c47e8a587a7f36$export$35e795649ee09318, 20012), e instanceof $63c47e8a587a7f36$export$dda1d9f60106f0e9) {
        if (e instanceof $63c47e8a587a7f36$var$__PRIVATE_InFilter) {
            const t = e.value.arrayValue?.values?.map((t)=>$63c47e8a587a7f36$export$dda1d9f60106f0e9.create(e.field, "==" /* Operator.EQUAL */ , t)) || [];
            return $63c47e8a587a7f36$export$35e795649ee09318.create(t, "or" /* CompositeOperator.OR */ );
        }
        // We have reached other kinds of field filters.
        return e;
    }
    // We have a composite filter.
    const t = e.filters.map((e)=>$63c47e8a587a7f36$var$__PRIVATE_computeInExpansion(e));
    return $63c47e8a587a7f36$export$35e795649ee09318.create(t, e.op);
}
/**
 * Given a composite filter, returns the list of terms in its disjunctive normal form.
 *
 * <p>Each element in the return value is one term of the resulting DNF. For instance: For the
 * input: (A || B) && C, the DNF form is: (A && C) || (B && C), and the return value is a list
 * with two elements: a composite filter that performs (A && C), and a composite filter that
 * performs (B && C).
 *
 * @param filter - the composite filter to calculate DNF transform for.
 * @returns the terms in the DNF transform.
 */ function $63c47e8a587a7f36$var$__PRIVATE_getDnfTerms(e) {
    if (0 === e.getFilters().length) return [];
    const t = $63c47e8a587a7f36$var$__PRIVATE_computeDistributedNormalForm($63c47e8a587a7f36$var$__PRIVATE_computeInExpansion(e));
    return $63c47e8a587a7f36$export$c18d01048907ea92($63c47e8a587a7f36$var$__PRIVATE_isDisjunctiveNormalForm(t), 7391), $63c47e8a587a7f36$var$__PRIVATE_isSingleFieldFilter(t) || $63c47e8a587a7f36$var$__PRIVATE_isFlatConjunction(t) ? [
        t
    ] : t.getFilters();
}
/** Returns true if the given filter is a single field filter. e.g. (a == 10). */ function $63c47e8a587a7f36$var$__PRIVATE_isSingleFieldFilter(e) {
    return e instanceof $63c47e8a587a7f36$export$dda1d9f60106f0e9;
}
/**
 * Returns true if the given filter is the conjunction of one or more field filters. e.g. (a == 10
 * && b == 20)
 */ function $63c47e8a587a7f36$var$__PRIVATE_isFlatConjunction(e) {
    return e instanceof $63c47e8a587a7f36$export$35e795649ee09318 && $63c47e8a587a7f36$var$__PRIVATE_compositeFilterIsFlatConjunction(e);
}
/**
 * Returns whether or not the given filter is in disjunctive normal form (DNF).
 *
 * <p>In boolean logic, a disjunctive normal form (DNF) is a canonical normal form of a logical
 * formula consisting of a disjunction of conjunctions; it can also be described as an OR of ANDs.
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Disjunctive_normal_form
 */ function $63c47e8a587a7f36$var$__PRIVATE_isDisjunctiveNormalForm(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_isSingleFieldFilter(e) || $63c47e8a587a7f36$var$__PRIVATE_isFlatConjunction(e) || /**
 * Returns true if the given filter is the disjunction of one or more "flat conjunctions" and
 * field filters. e.g. (a == 10) || (b==20 && c==30)
 */ function __PRIVATE_isDisjunctionOfFieldFiltersAndFlatConjunctions(e) {
        if (e instanceof $63c47e8a587a7f36$export$35e795649ee09318 && $63c47e8a587a7f36$var$__PRIVATE_compositeFilterIsDisjunction(e)) {
            for (const t of e.getFilters())if (!$63c47e8a587a7f36$var$__PRIVATE_isSingleFieldFilter(t) && !$63c47e8a587a7f36$var$__PRIVATE_isFlatConjunction(t)) return !1;
            return !0;
        }
        return !1;
    }(e);
}
function $63c47e8a587a7f36$var$__PRIVATE_computeDistributedNormalForm(e) {
    if ($63c47e8a587a7f36$export$c18d01048907ea92(e instanceof $63c47e8a587a7f36$export$dda1d9f60106f0e9 || e instanceof $63c47e8a587a7f36$export$35e795649ee09318, 34018), e instanceof $63c47e8a587a7f36$export$dda1d9f60106f0e9) return e;
    if (1 === e.filters.length) return $63c47e8a587a7f36$var$__PRIVATE_computeDistributedNormalForm(e.filters[0]);
    // Compute DNF for each of the subfilters first
    const t = e.filters.map((e)=>$63c47e8a587a7f36$var$__PRIVATE_computeDistributedNormalForm(e));
    let n = $63c47e8a587a7f36$export$35e795649ee09318.create(t, e.op);
    return n = $63c47e8a587a7f36$var$__PRIVATE_applyAssociation(n), $63c47e8a587a7f36$var$__PRIVATE_isDisjunctiveNormalForm(n) ? n : ($63c47e8a587a7f36$export$c18d01048907ea92(n instanceof $63c47e8a587a7f36$export$35e795649ee09318, 64498), $63c47e8a587a7f36$export$c18d01048907ea92($63c47e8a587a7f36$var$__PRIVATE_compositeFilterIsConjunction(n), 40251), $63c47e8a587a7f36$export$c18d01048907ea92(n.filters.length > 1, 57927), n.filters.reduce((e, t)=>$63c47e8a587a7f36$var$__PRIVATE_applyDistribution(e, t)));
}
function $63c47e8a587a7f36$var$__PRIVATE_applyDistribution(e, t) {
    let n;
    return $63c47e8a587a7f36$export$c18d01048907ea92(e instanceof $63c47e8a587a7f36$export$dda1d9f60106f0e9 || e instanceof $63c47e8a587a7f36$export$35e795649ee09318, 38388), $63c47e8a587a7f36$export$c18d01048907ea92(t instanceof $63c47e8a587a7f36$export$dda1d9f60106f0e9 || t instanceof $63c47e8a587a7f36$export$35e795649ee09318, 25473), // FieldFilter FieldFilter
    n = e instanceof $63c47e8a587a7f36$export$dda1d9f60106f0e9 ? t instanceof $63c47e8a587a7f36$export$dda1d9f60106f0e9 ? function __PRIVATE_applyDistributionFieldFilters(e, t) {
        // Conjunction distribution for two field filters is the conjunction of them.
        return $63c47e8a587a7f36$export$35e795649ee09318.create([
            e,
            t
        ], "and" /* CompositeOperator.AND */ );
    }(e, t) : $63c47e8a587a7f36$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) : t instanceof $63c47e8a587a7f36$export$dda1d9f60106f0e9 ? $63c47e8a587a7f36$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(t, e) : function __PRIVATE_applyDistributionCompositeFilters(e, t) {
        // There are four cases:
        // (A & B) & (C & D) --> (A & B & C & D)
        // (A & B) & (C | D) --> (A & B & C) | (A & B & D)
        // (A | B) & (C & D) --> (C & D & A) | (C & D & B)
        // (A | B) & (C | D) --> (A & C) | (A & D) | (B & C) | (B & D)
        // Case 1 is a merge.
        if ($63c47e8a587a7f36$export$c18d01048907ea92(e.filters.length > 0 && t.filters.length > 0, 48005), $63c47e8a587a7f36$var$__PRIVATE_compositeFilterIsConjunction(e) && $63c47e8a587a7f36$var$__PRIVATE_compositeFilterIsConjunction(t)) return $63c47e8a587a7f36$var$__PRIVATE_compositeFilterWithAddedFilters(e, t.getFilters());
        // Case 2,3,4 all have at least one side (lhs or rhs) that is a disjunction. In all three cases
        // we should take each element of the disjunction and distribute it over the other side, and
        // return the disjunction of the distribution results.
        const n = $63c47e8a587a7f36$var$__PRIVATE_compositeFilterIsDisjunction(e) ? e : t, r = $63c47e8a587a7f36$var$__PRIVATE_compositeFilterIsDisjunction(e) ? t : e, i = n.filters.map((e)=>$63c47e8a587a7f36$var$__PRIVATE_applyDistribution(e, r));
        return $63c47e8a587a7f36$export$35e795649ee09318.create(i, "or" /* CompositeOperator.OR */ );
    }(e, t), $63c47e8a587a7f36$var$__PRIVATE_applyAssociation(n);
}
function $63c47e8a587a7f36$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) {
    // There are two cases:
    // A & (B & C) --> (A & B & C)
    // A & (B | C) --> (A & B) | (A & C)
    if ($63c47e8a587a7f36$var$__PRIVATE_compositeFilterIsConjunction(t)) // Case 1
    return $63c47e8a587a7f36$var$__PRIVATE_compositeFilterWithAddedFilters(t, e.getFilters());
    {
        // Case 2
        const n = t.filters.map((t)=>$63c47e8a587a7f36$var$__PRIVATE_applyDistribution(e, t));
        return $63c47e8a587a7f36$export$35e795649ee09318.create(n, "or" /* CompositeOperator.OR */ );
    }
}
/**
 * Applies the associativity property to the given filter and returns the resulting filter.
 *
 * <ul>
 *   <li>A | (B | C) == (A | B) | C == (A | B | C)
 *   <li>A & (B & C) == (A & B) & C == (A & B & C)
 * </ul>
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Associative_property#Propositional_logic
 */ function $63c47e8a587a7f36$var$__PRIVATE_applyAssociation(e) {
    if ($63c47e8a587a7f36$export$c18d01048907ea92(e instanceof $63c47e8a587a7f36$export$dda1d9f60106f0e9 || e instanceof $63c47e8a587a7f36$export$35e795649ee09318, 11850), e instanceof $63c47e8a587a7f36$export$dda1d9f60106f0e9) return e;
    const t = e.getFilters();
    // If the composite filter only contains 1 filter, apply associativity to it.
    if (1 === t.length) return $63c47e8a587a7f36$var$__PRIVATE_applyAssociation(t[0]);
    // Associativity applied to a flat composite filter results is itself.
    if ($63c47e8a587a7f36$var$__PRIVATE_compositeFilterIsFlat(e)) return e;
    // First apply associativity to all subfilters. This will in turn recursively apply
    // associativity to all nested composite filters and field filters.
    const n = t.map((e)=>$63c47e8a587a7f36$var$__PRIVATE_applyAssociation(e)), r = [];
    // For composite subfilters that perform the same kind of logical operation as `compositeFilter`
    // take out their filters and add them to `compositeFilter`. For example:
    // compositeFilter = (A | (B | C | D))
    // compositeSubfilter = (B | C | D)
    // Result: (A | B | C | D)
    // Note that the `compositeSubfilter` has been eliminated, and its filters (B, C, D) have been
    // added to the top-level "compositeFilter".
    return n.forEach((t)=>{
        t instanceof $63c47e8a587a7f36$export$dda1d9f60106f0e9 ? r.push(t) : t instanceof $63c47e8a587a7f36$export$35e795649ee09318 && (t.op === e.op ? // compositeFilter: (A | (B | C))
        // compositeSubfilter: (B | C)
        // Result: (A | B | C)
        r.push(...t.filters) : // compositeFilter: (A | (B & C))
        // compositeSubfilter: (B & C)
        // Result: (A | (B & C))
        r.push(t));
    }), 1 === r.length ? r[0] : $63c47e8a587a7f36$export$35e795649ee09318.create(r, e.op);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of IndexManager.
 */ class $63c47e8a587a7f36$var$__PRIVATE_MemoryIndexManager {
    constructor(){
        this.Sn = new $63c47e8a587a7f36$var$__PRIVATE_MemoryCollectionParentIndex;
    }
    addToCollectionParentIndex(e, t) {
        return this.Sn.add(t), $63c47e8a587a7f36$var$PersistencePromise.resolve();
    }
    getCollectionParents(e, t) {
        return $63c47e8a587a7f36$var$PersistencePromise.resolve(this.Sn.getEntries(t));
    }
    addFieldIndex(e, t) {
        // Field indices are not supported with memory persistence.
        return $63c47e8a587a7f36$var$PersistencePromise.resolve();
    }
    deleteFieldIndex(e, t) {
        // Field indices are not supported with memory persistence.
        return $63c47e8a587a7f36$var$PersistencePromise.resolve();
    }
    deleteAllFieldIndexes(e) {
        // Field indices are not supported with memory persistence.
        return $63c47e8a587a7f36$var$PersistencePromise.resolve();
    }
    createTargetIndexes(e, t) {
        // Field indices are not supported with memory persistence.
        return $63c47e8a587a7f36$var$PersistencePromise.resolve();
    }
    getDocumentsMatchingTarget(e, t) {
        // Field indices are not supported with memory persistence.
        return $63c47e8a587a7f36$var$PersistencePromise.resolve(null);
    }
    getIndexType(e, t) {
        // Field indices are not supported with memory persistence.
        return $63c47e8a587a7f36$var$PersistencePromise.resolve(0 /* IndexType.NONE */ );
    }
    getFieldIndexes(e, t) {
        // Field indices are not supported with memory persistence.
        return $63c47e8a587a7f36$var$PersistencePromise.resolve([]);
    }
    getNextCollectionGroupToUpdate(e) {
        // Field indices are not supported with memory persistence.
        return $63c47e8a587a7f36$var$PersistencePromise.resolve(null);
    }
    getMinOffset(e, t) {
        return $63c47e8a587a7f36$var$PersistencePromise.resolve($63c47e8a587a7f36$var$IndexOffset.min());
    }
    getMinOffsetFromCollectionGroup(e, t) {
        return $63c47e8a587a7f36$var$PersistencePromise.resolve($63c47e8a587a7f36$var$IndexOffset.min());
    }
    updateCollectionGroup(e, t, n) {
        // Field indices are not supported with memory persistence.
        return $63c47e8a587a7f36$var$PersistencePromise.resolve();
    }
    updateIndexEntries(e, t) {
        // Field indices are not supported with memory persistence.
        return $63c47e8a587a7f36$var$PersistencePromise.resolve();
    }
}
/**
 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
 * in indexeddb_schema.ts
 */ class $63c47e8a587a7f36$var$__PRIVATE_MemoryCollectionParentIndex {
    constructor(){
        this.index = {};
    }
    // Returns false if the entry already existed.
    add(e) {
        const t = e.lastSegment(), n = e.popLast(), r = this.index[t] || new $63c47e8a587a7f36$var$SortedSet($63c47e8a587a7f36$export$db202ddc8be9136.comparator), i = !r.has(n);
        return this.index[t] = r.add(n), i;
    }
    has(e) {
        const t = e.lastSegment(), n = e.popLast(), r = this.index[t];
        return r && r.has(n);
    }
    getEntries(e) {
        return (this.index[e] || new $63c47e8a587a7f36$var$SortedSet($63c47e8a587a7f36$export$db202ddc8be9136.comparator)).toArray();
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $63c47e8a587a7f36$var$wt = "IndexedDbIndexManager", $63c47e8a587a7f36$var$bt = new Uint8Array(0);
/**
 * A persisted implementation of IndexManager.
 *
 * PORTING NOTE: Unlike iOS and Android, the Web SDK does not memoize index
 * data as it supports multi-tab access.
 */ class $63c47e8a587a7f36$var$__PRIVATE_IndexedDbIndexManager {
    constructor(e, t){
        this.databaseId = t, /**
         * An in-memory copy of the index entries we've already written since the SDK
         * launched. Used to avoid re-writing the same entry repeatedly.
         *
         * This is *NOT* a complete cache of what's in persistence and so can never be
         * used to satisfy reads.
         */ this.Dn = new $63c47e8a587a7f36$var$__PRIVATE_MemoryCollectionParentIndex, /**
         * Maps from a target to its equivalent list of sub-targets. Each sub-target
         * contains only one term from the target's disjunctive normal form (DNF).
         */ this.Cn = new $63c47e8a587a7f36$var$ObjectMap((e)=>$63c47e8a587a7f36$var$__PRIVATE_canonifyTarget(e), (e, t)=>$63c47e8a587a7f36$var$__PRIVATE_targetEquals(e, t)), this.uid = e.uid || "";
    }
    /**
     * Adds a new entry to the collection parent index.
     *
     * Repeated calls for the same collectionPath should be avoided within a
     * transaction as IndexedDbIndexManager only caches writes once a transaction
     * has been committed.
     */ addToCollectionParentIndex(e, t) {
        if (!this.Dn.has(t)) {
            const n = t.lastSegment(), r = t.popLast();
            e.addOnCommittedListener(()=>{
                // Add the collection to the in memory cache only if the transaction was
                // successfully committed.
                this.Dn.add(t);
            });
            const i = {
                collectionId: n,
                parent: $63c47e8a587a7f36$var$__PRIVATE_encodeResourcePath(r)
            };
            return $63c47e8a587a7f36$var$__PRIVATE_collectionParentsStore(e).put(i);
        }
        return $63c47e8a587a7f36$var$PersistencePromise.resolve();
    }
    getCollectionParents(e, t) {
        const n = [], r = IDBKeyRange.bound([
            t,
            ""
        ], [
            $63c47e8a587a7f36$var$__PRIVATE_immediateSuccessor(t),
            ""
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return $63c47e8a587a7f36$var$__PRIVATE_collectionParentsStore(e).H(r).next((e)=>{
            for (const r of e){
                // This collectionId guard shouldn't be necessary (and isn't as long
                // as we're running in a real browser), but there's a bug in
                // indexeddbshim that breaks our range in our tests running in node:
                // https://github.com/axemclion/IndexedDBShim/issues/334
                if (r.collectionId !== t) break;
                n.push($63c47e8a587a7f36$var$__PRIVATE_decodeResourcePath(r.parent));
            }
            return n;
        });
    }
    addFieldIndex(e, t) {
        // TODO(indexing): Verify that the auto-incrementing index ID works in
        // Safari & Firefox.
        const n = $63c47e8a587a7f36$var$__PRIVATE_indexConfigurationStore(e), r = function __PRIVATE_toDbIndexConfiguration(e) {
            return {
                indexId: e.indexId,
                collectionGroup: e.collectionGroup,
                fields: e.fields.map((e)=>[
                        e.fieldPath.canonicalString(),
                        e.kind
                    ])
            };
        }(t);
        delete r.indexId;
        // `indexId` is auto-populated by IndexedDb
        const i = n.add(r);
        if (t.indexState) {
            const n = $63c47e8a587a7f36$var$__PRIVATE_indexStateStore(e);
            return i.next((e)=>{
                n.put($63c47e8a587a7f36$var$__PRIVATE_toDbIndexState(e, this.uid, t.indexState.sequenceNumber, t.indexState.offset));
            });
        }
        return i.next();
    }
    deleteFieldIndex(e, t) {
        const n = $63c47e8a587a7f36$var$__PRIVATE_indexConfigurationStore(e), r = $63c47e8a587a7f36$var$__PRIVATE_indexStateStore(e), i = $63c47e8a587a7f36$var$__PRIVATE_indexEntriesStore(e);
        return n.delete(t.indexId).next(()=>r.delete(IDBKeyRange.bound([
                t.indexId
            ], [
                t.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0))).next(()=>i.delete(IDBKeyRange.bound([
                t.indexId
            ], [
                t.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0)));
    }
    deleteAllFieldIndexes(e) {
        const t = $63c47e8a587a7f36$var$__PRIVATE_indexConfigurationStore(e), n = $63c47e8a587a7f36$var$__PRIVATE_indexEntriesStore(e), r = $63c47e8a587a7f36$var$__PRIVATE_indexStateStore(e);
        return t.X().next(()=>n.X()).next(()=>r.X());
    }
    createTargetIndexes(e, t) {
        return $63c47e8a587a7f36$var$PersistencePromise.forEach(this.vn(t), (t)=>this.getIndexType(e, t).next((n)=>{
                if (0 /* IndexType.NONE */  === n || 1 /* IndexType.PARTIAL */  === n) {
                    const n = new $63c47e8a587a7f36$var$__PRIVATE_TargetIndexMatcher(t).bn();
                    if (null != n) return this.addFieldIndex(e, n);
                }
            }));
    }
    getDocumentsMatchingTarget(e, t) {
        const n = $63c47e8a587a7f36$var$__PRIVATE_indexEntriesStore(e);
        let r = !0;
        const i = new Map;
        return $63c47e8a587a7f36$var$PersistencePromise.forEach(this.vn(t), (t)=>this.Fn(e, t).next((e)=>{
                r && (r = !!e), i.set(t, e);
            })).next(()=>{
            if (r) {
                let e = $63c47e8a587a7f36$export$971d5caa766a69d7();
                const r = [];
                return $63c47e8a587a7f36$var$PersistencePromise.forEach(i, (i, s)=>{
                    $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$wt, `Using index ${function __PRIVATE_fieldIndexToString(e) {
                        return `id=${e.indexId}|cg=${e.collectionGroup}|f=${e.fields.map((e)=>`${e.fieldPath}:${e.kind}`).join(",")}`;
                    }(i)} to execute ${$63c47e8a587a7f36$var$__PRIVATE_canonifyTarget(t)}`);
                    const o = function __PRIVATE_targetGetArrayValues(e, t) {
                        const n = $63c47e8a587a7f36$var$__PRIVATE_fieldIndexGetArraySegment(t);
                        if (void 0 === n) return null;
                        for (const t of $63c47e8a587a7f36$var$__PRIVATE_targetGetFieldFiltersForPath(e, n.fieldPath))switch(t.op){
                            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
                                return t.value.arrayValue.values || [];
                            case "array-contains" /* Operator.ARRAY_CONTAINS */ :
                                return [
                                    t.value
                                ];
                        }
                        return null;
                    }(s, i), _ = function __PRIVATE_targetGetNotInValues(e, t) {
                        const n = new Map;
                        for (const r of $63c47e8a587a7f36$var$__PRIVATE_fieldIndexGetDirectionalSegments(t))for (const t of $63c47e8a587a7f36$var$__PRIVATE_targetGetFieldFiltersForPath(e, r.fieldPath))switch(t.op){
                            case "==" /* Operator.EQUAL */ :
                            case "in" /* Operator.IN */ :
                                // Encode equality prefix, which is encoded in the index value before
                                // the inequality (e.g. `a == 'a' && b != 'b'` is encoded to
                                // `value != 'ab'`).
                                n.set(r.fieldPath.canonicalString(), t.value);
                                break;
                            case "not-in" /* Operator.NOT_IN */ :
                            case "!=" /* Operator.NOT_EQUAL */ :
                                // NotIn/NotEqual is always a suffix. There cannot be any remaining
                                // segments and hence we can return early here.
                                return n.set(r.fieldPath.canonicalString(), t.value), Array.from(n.values());
                        }
                        return null;
                    }(s, i), a = function __PRIVATE_targetGetLowerBound(e, t) {
                        const n = [];
                        let r = !0;
                        // For each segment, retrieve a lower bound if there is a suitable filter or
                        // startAt.
                        for (const i of $63c47e8a587a7f36$var$__PRIVATE_fieldIndexGetDirectionalSegments(t)){
                            const t = 0 /* IndexKind.ASCENDING */  === i.kind ? $63c47e8a587a7f36$var$__PRIVATE_targetGetAscendingBound(e, i.fieldPath, e.startAt) : $63c47e8a587a7f36$var$__PRIVATE_targetGetDescendingBound(e, i.fieldPath, e.startAt);
                            n.push(t.value), r && (r = t.inclusive);
                        }
                        return new $63c47e8a587a7f36$export$625550452a3fa3ec(n, r);
                    }(s, i), u = function __PRIVATE_targetGetUpperBound(e, t) {
                        const n = [];
                        let r = !0;
                        // For each segment, retrieve an upper bound if there is a suitable filter or
                        // endAt.
                        for (const i of $63c47e8a587a7f36$var$__PRIVATE_fieldIndexGetDirectionalSegments(t)){
                            const t = 0 /* IndexKind.ASCENDING */  === i.kind ? $63c47e8a587a7f36$var$__PRIVATE_targetGetDescendingBound(e, i.fieldPath, e.endAt) : $63c47e8a587a7f36$var$__PRIVATE_targetGetAscendingBound(e, i.fieldPath, e.endAt);
                            n.push(t.value), r && (r = t.inclusive);
                        }
                        return new $63c47e8a587a7f36$export$625550452a3fa3ec(n, r);
                    }(s, i), c = this.Mn(i, s, a), l = this.Mn(i, s, u), h = this.xn(i, s, _), P = this.On(i.indexId, o, c, a.inclusive, l, u.inclusive, h);
                    return $63c47e8a587a7f36$var$PersistencePromise.forEach(P, (i)=>n.Z(i, t.limit).next((t)=>{
                            t.forEach((t)=>{
                                const n = $63c47e8a587a7f36$export$90a7f3efeed30595.fromSegments(t.documentKey);
                                e.has(n) || (e = e.add(n), r.push(n));
                            });
                        }));
                }).next(()=>r);
            }
            return $63c47e8a587a7f36$var$PersistencePromise.resolve(null);
        });
    }
    vn(e) {
        let t = this.Cn.get(e);
        if (t) return t;
        if (0 === e.filters.length) t = [
            e
        ];
        else t = $63c47e8a587a7f36$var$__PRIVATE_getDnfTerms($63c47e8a587a7f36$export$35e795649ee09318.create(e.filters, "and" /* CompositeOperator.AND */ )).map((t)=>$63c47e8a587a7f36$var$__PRIVATE_newTarget(e.path, e.collectionGroup, e.orderBy, t.getFilters(), e.limit, e.startAt, e.endAt));
        return this.Cn.set(e, t), t;
    }
    /**
     * Constructs a key range query on `DbIndexEntryStore` that unions all
     * bounds.
     */ On(e, t, n, r, i, s, o) {
        // The number of total index scans we union together. This is similar to a
        // distributed normal form, but adapted for array values. We create a single
        // index range per value in an ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filter
        // combined with the values from the query bounds.
        const _ = (null != t ? t.length : 1) * Math.max(n.length, i.length), a = _ / (null != t ? t.length : 1), u = [];
        for(let c = 0; c < _; ++c){
            const _ = t ? this.Nn(t[c / a]) : $63c47e8a587a7f36$var$bt, l = this.Bn(e, _, n[c % a], r), h = this.Ln(e, _, i[c % a], s), P = o.map((t)=>this.Bn(e, _, t, /* inclusive= */ !0));
            u.push(...this.createRange(l, h, P));
        }
        return u;
    }
    /** Generates the lower bound for `arrayValue` and `directionalValue`. */ Bn(e, t, n, r) {
        const i = new $63c47e8a587a7f36$var$__PRIVATE_IndexEntry(e, $63c47e8a587a7f36$export$90a7f3efeed30595.empty(), t, n);
        return r ? i : i.En();
    }
    /** Generates the upper bound for `arrayValue` and `directionalValue`. */ Ln(e, t, n, r) {
        const i = new $63c47e8a587a7f36$var$__PRIVATE_IndexEntry(e, $63c47e8a587a7f36$export$90a7f3efeed30595.empty(), t, n);
        return r ? i.En() : i;
    }
    Fn(e, t) {
        const n = new $63c47e8a587a7f36$var$__PRIVATE_TargetIndexMatcher(t), r = null != t.collectionGroup ? t.collectionGroup : t.path.lastSegment();
        return this.getFieldIndexes(e, r).next((e)=>{
            // Return the index with the most number of segments.
            let t = null;
            for (const r of e)n.gn(r) && (!t || r.fields.length > t.fields.length) && (t = r);
            return t;
        });
    }
    getIndexType(e, t) {
        let n = 2 /* IndexType.FULL */ ;
        const r = this.vn(t);
        return $63c47e8a587a7f36$var$PersistencePromise.forEach(r, (t)=>this.Fn(e, t).next((e)=>{
                e ? 0 /* IndexType.NONE */  !== n && e.fields.length < function __PRIVATE_targetGetSegmentCount(e) {
                    let t = new $63c47e8a587a7f36$var$SortedSet($63c47e8a587a7f36$export$cf2f7c5792f80b46.comparator), n = !1;
                    for (const r of e.filters)for (const e of r.getFlattenedFilters())// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    e.field.isKeyField() || // ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filters must be counted separately.
                    // For instance, it is possible to have an index for "a ARRAY a ASC". Even
                    // though these are on the same field, they should be counted as two
                    // separate segments in an index.
                    ("array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op ? n = !0 : t = t.add(e.field));
                    for (const n of e.orderBy)// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    n.field.isKeyField() || (t = t.add(n.field));
                    return t.size + (n ? 1 : 0);
                }(t) && (n = 1 /* IndexType.PARTIAL */ ) : n = 0 /* IndexType.NONE */ ;
            })).next(()=>// OR queries have more than one sub-target (one sub-target per DNF term). We currently consider
            // OR queries that have a `limit` to have a partial index. For such queries we perform sorting
            // and apply the limit in memory as a post-processing step.
            (function __PRIVATE_targetHasLimit(e) {
                return null !== e.limit;
            })(t) && r.length > 1 && 2 /* IndexType.FULL */  === n ? 1 /* IndexType.PARTIAL */  : n);
    }
    /**
     * Returns the byte encoded form of the directional values in the field index.
     * Returns `null` if the document does not have all fields specified in the
     * index.
     */ kn(e, t) {
        const n = new $63c47e8a587a7f36$var$__PRIVATE_IndexByteEncoder;
        for (const r of $63c47e8a587a7f36$var$__PRIVATE_fieldIndexGetDirectionalSegments(e)){
            const e = t.data.field(r.fieldPath);
            if (null == e) return null;
            const i = n.ln(r.kind);
            $63c47e8a587a7f36$var$__PRIVATE_FirestoreIndexValueWriter.Wt.Dt(e, i);
        }
        return n.un();
    }
    /** Encodes a single value to the ascending index format. */ Nn(e) {
        const t = new $63c47e8a587a7f36$var$__PRIVATE_IndexByteEncoder;
        return $63c47e8a587a7f36$var$__PRIVATE_FirestoreIndexValueWriter.Wt.Dt(e, t.ln(0 /* IndexKind.ASCENDING */ )), t.un();
    }
    /**
     * Returns an encoded form of the document key that sorts based on the key
     * ordering of the field index.
     */ Kn(e, t) {
        const n = new $63c47e8a587a7f36$var$__PRIVATE_IndexByteEncoder;
        return $63c47e8a587a7f36$var$__PRIVATE_FirestoreIndexValueWriter.Wt.Dt($63c47e8a587a7f36$export$43caf9889c228507(this.databaseId, t), n.ln(function __PRIVATE_fieldIndexGetKeyOrder(e) {
            const t = $63c47e8a587a7f36$var$__PRIVATE_fieldIndexGetDirectionalSegments(e);
            return 0 === t.length ? 0 /* IndexKind.ASCENDING */  : t[t.length - 1].kind;
        }(e))), n.un();
    }
    /**
     * Encodes the given field values according to the specification in `target`.
     * For IN queries, a list of possible values is returned.
     */ xn(e, t, n) {
        if (null === n) return [];
        let r = [];
        r.push(new $63c47e8a587a7f36$var$__PRIVATE_IndexByteEncoder);
        let i = 0;
        for (const s of $63c47e8a587a7f36$var$__PRIVATE_fieldIndexGetDirectionalSegments(e)){
            const e = n[i++];
            for (const n of r)if (this.qn(t, s.fieldPath) && $63c47e8a587a7f36$var$isArray(e)) r = this.Un(r, s, e);
            else {
                const t = n.ln(s.kind);
                $63c47e8a587a7f36$var$__PRIVATE_FirestoreIndexValueWriter.Wt.Dt(e, t);
            }
        }
        return this.$n(r);
    }
    /**
     * Encodes the given bounds according to the specification in `target`. For IN
     * queries, a list of possible values is returned.
     */ Mn(e, t, n) {
        return this.xn(e, t, n.position);
    }
    /** Returns the byte representation for the provided encoders. */ $n(e) {
        const t = [];
        for(let n = 0; n < e.length; ++n)t[n] = e[n].un();
        return t;
    }
    /**
     * Creates a separate encoder for each element of an array.
     *
     * The method appends each value to all existing encoders (e.g. filter("a",
     * "==", "a1").filter("b", "in", ["b1", "b2"]) becomes ["a1,b1", "a1,b2"]). A
     * list of new encoders is returned.
     */ Un(e, t, n) {
        const r = [
            ...e
        ], i = [];
        for (const e of n.arrayValue.values || [])for (const n of r){
            const r = new $63c47e8a587a7f36$var$__PRIVATE_IndexByteEncoder;
            r.seed(n.un()), $63c47e8a587a7f36$var$__PRIVATE_FirestoreIndexValueWriter.Wt.Dt(e, r.ln(t.kind)), i.push(r);
        }
        return i;
    }
    qn(e, t) {
        return !!e.filters.find((e)=>e instanceof $63c47e8a587a7f36$export$dda1d9f60106f0e9 && e.field.isEqual(t) && ("in" /* Operator.IN */  === e.op || "not-in" /* Operator.NOT_IN */  === e.op));
    }
    getFieldIndexes(e, t) {
        const n = $63c47e8a587a7f36$var$__PRIVATE_indexConfigurationStore(e), r = $63c47e8a587a7f36$var$__PRIVATE_indexStateStore(e);
        return (t ? n.H($63c47e8a587a7f36$var$Se, IDBKeyRange.bound(t, t)) : n.H()).next((e)=>{
            const t = [];
            return $63c47e8a587a7f36$var$PersistencePromise.forEach(e, (e)=>r.get([
                    e.indexId,
                    this.uid
                ]).next((n)=>{
                    t.push(function __PRIVATE_fromDbIndexConfiguration(e, t) {
                        const n = t ? new $63c47e8a587a7f36$export$995eb9fca571757(t.sequenceNumber, new $63c47e8a587a7f36$var$IndexOffset($63c47e8a587a7f36$var$__PRIVATE_fromDbTimestamp(t.readTime), new $63c47e8a587a7f36$export$90a7f3efeed30595($63c47e8a587a7f36$var$__PRIVATE_decodeResourcePath(t.documentKey)), t.largestBatchId)) : $63c47e8a587a7f36$export$995eb9fca571757.empty(), r = e.fields.map(([e, t])=>new $63c47e8a587a7f36$export$c9170ad7d4cd7e57($63c47e8a587a7f36$export$cf2f7c5792f80b46.fromServerFormat(e), t));
                        return new $63c47e8a587a7f36$export$ee7c8ad385a60b7b(e.indexId, e.collectionGroup, r, n);
                    }(e, n));
                })).next(()=>t);
        });
    }
    getNextCollectionGroupToUpdate(e) {
        return this.getFieldIndexes(e).next((e)=>0 === e.length ? null : (e.sort((e, t)=>{
                const n = e.indexState.sequenceNumber - t.indexState.sequenceNumber;
                return 0 !== n ? n : $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
            }), e[0].collectionGroup));
    }
    updateCollectionGroup(e, t, n) {
        const r = $63c47e8a587a7f36$var$__PRIVATE_indexConfigurationStore(e), i = $63c47e8a587a7f36$var$__PRIVATE_indexStateStore(e);
        return this.Wn(e).next((e)=>r.H($63c47e8a587a7f36$var$Se, IDBKeyRange.bound(t, t)).next((t)=>$63c47e8a587a7f36$var$PersistencePromise.forEach(t, (t)=>i.put($63c47e8a587a7f36$var$__PRIVATE_toDbIndexState(t.indexId, this.uid, e, n)))));
    }
    updateIndexEntries(e, t) {
        // Porting Note: `getFieldIndexes()` on Web does not cache index lookups as
        // it could be used across different IndexedDB transactions. As any cached
        // data might be invalidated by other multi-tab clients, we can only trust
        // data within a single IndexedDB transaction. We therefore add a cache
        // here.
        const n = new Map;
        return $63c47e8a587a7f36$var$PersistencePromise.forEach(t, (t, r)=>{
            const i = n.get(t.collectionGroup);
            return (i ? $63c47e8a587a7f36$var$PersistencePromise.resolve(i) : this.getFieldIndexes(e, t.collectionGroup)).next((i)=>(n.set(t.collectionGroup, i), $63c47e8a587a7f36$var$PersistencePromise.forEach(i, (n)=>this.Qn(e, t, n).next((t)=>{
                        const i = this.Gn(r, n);
                        return t.isEqual(i) ? $63c47e8a587a7f36$var$PersistencePromise.resolve() : this.zn(e, r, n, t, i);
                    }))));
        });
    }
    jn(e, t, n, r) {
        return $63c47e8a587a7f36$var$__PRIVATE_indexEntriesStore(e).put(r.Rn(this.uid, this.Kn(n, t.key), t.key));
    }
    Hn(e, t, n, r) {
        return $63c47e8a587a7f36$var$__PRIVATE_indexEntriesStore(e).delete(r.An(this.uid, this.Kn(n, t.key), t.key));
    }
    Qn(e, t, n) {
        const r = $63c47e8a587a7f36$var$__PRIVATE_indexEntriesStore(e);
        let i = new $63c47e8a587a7f36$var$SortedSet($63c47e8a587a7f36$var$__PRIVATE_indexEntryComparator);
        return r.ee({
            index: $63c47e8a587a7f36$var$Ne,
            range: IDBKeyRange.only([
                n.indexId,
                this.uid,
                $63c47e8a587a7f36$var$__PRIVATE_encodeKeySafeBytes(this.Kn(n, t))
            ])
        }, (e, r)=>{
            i = i.add(new $63c47e8a587a7f36$var$__PRIVATE_IndexEntry(n.indexId, t, $63c47e8a587a7f36$var$__PRIVATE_decodeKeySafeBytes(r.arrayValue), $63c47e8a587a7f36$var$__PRIVATE_decodeKeySafeBytes(r.directionalValue)));
        }).next(()=>i);
    }
    /** Creates the index entries for the given document. */ Gn(e, t) {
        let n = new $63c47e8a587a7f36$var$SortedSet($63c47e8a587a7f36$var$__PRIVATE_indexEntryComparator);
        const r = this.kn(t, e);
        if (null == r) return n;
        const i = $63c47e8a587a7f36$var$__PRIVATE_fieldIndexGetArraySegment(t);
        if (null != i) {
            const s = e.data.field(i.fieldPath);
            if ($63c47e8a587a7f36$var$isArray(s)) for (const i of s.arrayValue.values || [])n = n.add(new $63c47e8a587a7f36$var$__PRIVATE_IndexEntry(t.indexId, e.key, this.Nn(i), r));
        } else n = n.add(new $63c47e8a587a7f36$var$__PRIVATE_IndexEntry(t.indexId, e.key, $63c47e8a587a7f36$var$bt, r));
        return n;
    }
    /**
     * Updates the index entries for the provided document by deleting entries
     * that are no longer referenced in `newEntries` and adding all newly added
     * entries.
     */ zn(e, t, n, r, i) {
        $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$wt, "Updating index entries for document '%s'", t.key);
        const s = [];
        return function __PRIVATE_diffSortedSets(e, t, n, r, i) {
            const s = e.getIterator(), o = t.getIterator();
            let _ = $63c47e8a587a7f36$var$__PRIVATE_advanceIterator(s), a = $63c47e8a587a7f36$var$__PRIVATE_advanceIterator(o);
            // Walk through the two sets at the same time, using the ordering defined by
            // `comparator`.
            for(; _ || a;){
                let e = !1, t = !1;
                if (_ && a) {
                    const r = n(_, a);
                    r < 0 ? // The element was removed if the next element in our ordered
                    // walkthrough is only in `before`.
                    t = !0 : r > 0 && // The element was added if the next element in our ordered walkthrough
                    // is only in `after`.
                    (e = !0);
                } else null != _ ? t = !0 : e = !0;
                e ? (r(a), a = $63c47e8a587a7f36$var$__PRIVATE_advanceIterator(o)) : t ? (i(_), _ = $63c47e8a587a7f36$var$__PRIVATE_advanceIterator(s)) : (_ = $63c47e8a587a7f36$var$__PRIVATE_advanceIterator(s), a = $63c47e8a587a7f36$var$__PRIVATE_advanceIterator(o));
            }
        }(r, i, $63c47e8a587a7f36$var$__PRIVATE_indexEntryComparator, /* onAdd= */ (r)=>{
            s.push(this.jn(e, t, n, r));
        }, /* onRemove= */ (r)=>{
            s.push(this.Hn(e, t, n, r));
        }), $63c47e8a587a7f36$var$PersistencePromise.waitFor(s);
    }
    Wn(e) {
        let t = 1;
        return $63c47e8a587a7f36$var$__PRIVATE_indexStateStore(e).ee({
            index: $63c47e8a587a7f36$var$Fe,
            reverse: !0,
            range: IDBKeyRange.upperBound([
                this.uid,
                Number.MAX_SAFE_INTEGER
            ])
        }, (e, n, r)=>{
            r.done(), t = n.sequenceNumber + 1;
        }).next(()=>t);
    }
    /**
     * Returns a new set of IDB ranges that splits the existing range and excludes
     * any values that match the `notInValue` from these ranges. As an example,
     * '[foo > 2 && foo != 3]` becomes  `[foo > 2 && < 3, foo > 3]`.
     */ createRange(e, t, n) {
        // The notIn values need to be sorted and unique so that we can return a
        // sorted set of non-overlapping ranges.
        n = n.sort((e, t)=>$63c47e8a587a7f36$var$__PRIVATE_indexEntryComparator(e, t)).filter((e, t, n)=>!t || 0 !== $63c47e8a587a7f36$var$__PRIVATE_indexEntryComparator(e, n[t - 1]));
        const r = [];
        r.push(e);
        for (const i of n){
            const n = $63c47e8a587a7f36$var$__PRIVATE_indexEntryComparator(i, e), s = $63c47e8a587a7f36$var$__PRIVATE_indexEntryComparator(i, t);
            if (0 === n) // `notInValue` is the lower bound. We therefore need to raise the bound
            // to the next value.
            r[0] = e.En();
            else if (n > 0 && s < 0) // `notInValue` is in the middle of the range
            r.push(i), r.push(i.En());
            else if (s > 0) break;
        }
        r.push(t);
        const i = [];
        for(let e = 0; e < r.length; e += 2){
            // If we encounter two bounds that will create an unmatchable key range,
            // then we return an empty set of key ranges.
            if (this.Jn(r[e], r[e + 1])) return [];
            const t = r[e].An(this.uid, $63c47e8a587a7f36$var$bt, $63c47e8a587a7f36$export$90a7f3efeed30595.empty()), n = r[e + 1].An(this.uid, $63c47e8a587a7f36$var$bt, $63c47e8a587a7f36$export$90a7f3efeed30595.empty());
            i.push(IDBKeyRange.bound(t, n));
        }
        return i;
    }
    Jn(e, t) {
        // If lower bound is greater than the upper bound, then the key
        // range can never be matched.
        return $63c47e8a587a7f36$var$__PRIVATE_indexEntryComparator(e, t) > 0;
    }
    getMinOffsetFromCollectionGroup(e, t) {
        return this.getFieldIndexes(e, t).next($63c47e8a587a7f36$var$__PRIVATE_getMinOffsetFromFieldIndexes);
    }
    getMinOffset(e, t) {
        return $63c47e8a587a7f36$var$PersistencePromise.mapArray(this.vn(t), (t)=>this.Fn(e, t).next((e)=>e || $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(44426))).next($63c47e8a587a7f36$var$__PRIVATE_getMinOffsetFromFieldIndexes);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the collectionParents
 * document store.
 */ function $63c47e8a587a7f36$var$__PRIVATE_collectionParentsStore(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_getStore(e, $63c47e8a587a7f36$var$Ae);
}
/**
 * Helper to get a typed SimpleDbStore for the index entry object store.
 */ function $63c47e8a587a7f36$var$__PRIVATE_indexEntriesStore(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_getStore(e, $63c47e8a587a7f36$var$xe);
}
/**
 * Helper to get a typed SimpleDbStore for the index configuration object store.
 */ function $63c47e8a587a7f36$var$__PRIVATE_indexConfigurationStore(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_getStore(e, $63c47e8a587a7f36$var$we);
}
/**
 * Helper to get a typed SimpleDbStore for the index state object store.
 */ function $63c47e8a587a7f36$var$__PRIVATE_indexStateStore(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_getStore(e, $63c47e8a587a7f36$var$Ce);
}
function $63c47e8a587a7f36$var$__PRIVATE_getMinOffsetFromFieldIndexes(e) {
    $63c47e8a587a7f36$export$c18d01048907ea92(0 !== e.length, 28825);
    let t = e[0].indexState.offset, n = t.largestBatchId;
    for(let r = 1; r < e.length; r++){
        const i = e[r].indexState.offset;
        $63c47e8a587a7f36$var$__PRIVATE_indexOffsetComparator(i, t) < 0 && (t = i), n < i.largestBatchId && (n = i.largestBatchId);
    }
    return new $63c47e8a587a7f36$var$IndexOffset(t.readTime, t.documentKey, n);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $63c47e8a587a7f36$var$St = {
    didRun: !1,
    sequenceNumbersCollected: 0,
    targetsRemoved: 0,
    documentsRemoved: 0
}, $63c47e8a587a7f36$var$Dt = 41943040;
class $63c47e8a587a7f36$var$LruParams {
    static withCacheSize(e) {
        return new $63c47e8a587a7f36$var$LruParams(e, $63c47e8a587a7f36$var$LruParams.DEFAULT_COLLECTION_PERCENTILE, $63c47e8a587a7f36$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
    }
    constructor(// When we attempt to collect, we will only do so if the cache size is greater than this
    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
    e, // The percentage of sequence numbers that we will attempt to collect
    t, // A cap on the total number of sequence numbers that will be collected. This prevents
    // us from collecting a huge number of sequence numbers if the cache has grown very large.
    n){
        this.cacheSizeCollectionThreshold = e, this.percentileToCollect = t, this.maximumSequenceNumbersToCollect = n;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Delete a mutation batch and the associated document mutations.
 * @returns A PersistencePromise of the document mutations that were removed.
 */ function $63c47e8a587a7f36$var$removeMutationBatch(e, t, n) {
    const r = e.store($63c47e8a587a7f36$var$H), i = e.store($63c47e8a587a7f36$var$ee), s = [], o = IDBKeyRange.only(n.batchId);
    let _ = 0;
    const a = r.ee({
        range: o
    }, (e, t, n)=>(_++, n.delete()));
    s.push(a.next(()=>{
        $63c47e8a587a7f36$export$c18d01048907ea92(1 === _, 47070, {
            batchId: n.batchId
        });
    }));
    const u = [];
    for (const e of n.mutations){
        const r = $63c47e8a587a7f36$var$__PRIVATE_newDbDocumentMutationKey(t, e.key.path, n.batchId);
        s.push(i.delete(r)), u.push(e.key);
    }
    return $63c47e8a587a7f36$var$PersistencePromise.waitFor(s).next(()=>u);
}
/**
 * Returns an approximate size for the given document.
 */ function $63c47e8a587a7f36$var$__PRIVATE_dbDocumentSize(e) {
    if (!e) return 0;
    let t;
    if (e.document) t = e.document;
    else if (e.unknownDocument) t = e.unknownDocument;
    else {
        if (!e.noDocument) throw $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(14731);
        t = e.noDocument;
    }
    return JSON.stringify(t).length;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A mutation queue for a specific user, backed by IndexedDB. */ $63c47e8a587a7f36$var$LruParams.DEFAULT_COLLECTION_PERCENTILE = 10, $63c47e8a587a7f36$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1e3, $63c47e8a587a7f36$var$LruParams.DEFAULT = new $63c47e8a587a7f36$var$LruParams($63c47e8a587a7f36$var$Dt, $63c47e8a587a7f36$var$LruParams.DEFAULT_COLLECTION_PERCENTILE, $63c47e8a587a7f36$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT), $63c47e8a587a7f36$var$LruParams.DISABLED = new $63c47e8a587a7f36$var$LruParams(-1, 0, 0);
class $63c47e8a587a7f36$var$__PRIVATE_IndexedDbMutationQueue {
    constructor(/**
     * The normalized userId (e.g. null UID => "" userId) used to store /
     * retrieve mutations.
     */ e, t, n, r){
        this.userId = e, this.serializer = t, this.indexManager = n, this.referenceDelegate = r, /**
         * Caches the document keys for pending mutation batches. If the mutation
         * has been removed from IndexedDb, the cached value may continue to
         * be used to retrieve the batch's document keys. To remove a cached value
         * locally, `removeCachedMutationKeys()` should be invoked either directly
         * or through `removeMutationBatches()`.
         *
         * With multi-tab, when the primary client acknowledges or rejects a mutation,
         * this cache is used by secondary clients to invalidate the local
         * view of the documents that were previously affected by the mutation.
         */ // PORTING NOTE: Multi-tab only.
        this.Zn = {};
    }
    /**
     * Creates a new mutation queue for the given user.
     * @param user - The user for which to create a mutation queue.
     * @param serializer - The serializer to use when persisting to IndexedDb.
     */ static wt(e, t, n, r) {
        // TODO(mcg): Figure out what constraints there are on userIDs
        // In particular, are there any reserved characters? are empty ids allowed?
        // For the moment store these together in the same mutations table assuming
        // that empty userIDs aren't allowed.
        $63c47e8a587a7f36$export$c18d01048907ea92("" !== e.uid, 64387);
        const i = e.isAuthenticated() ? e.uid : "";
        return new $63c47e8a587a7f36$var$__PRIVATE_IndexedDbMutationQueue(i, t, n, r);
    }
    checkEmpty(e) {
        let t = !0;
        const n = IDBKeyRange.bound([
            this.userId,
            Number.NEGATIVE_INFINITY
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $63c47e8a587a7f36$var$__PRIVATE_mutationsStore(e).ee({
            index: $63c47e8a587a7f36$var$Z,
            range: n
        }, (e, n, r)=>{
            t = !1, r.done();
        }).next(()=>t);
    }
    addMutationBatch(e, t, n, r) {
        const i = $63c47e8a587a7f36$var$__PRIVATE_documentMutationsStore(e), s = $63c47e8a587a7f36$var$__PRIVATE_mutationsStore(e);
        // The IndexedDb implementation in Chrome (and Firefox) does not handle
        // compound indices that include auto-generated keys correctly. To ensure
        // that the index entry is added correctly in all browsers, we perform two
        // writes: The first write is used to retrieve the next auto-generated Batch
        // ID, and the second write populates the index and stores the actual
        // mutation batch.
        // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
        // We write an empty object to obtain key
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return s.add({}).next((o)=>{
            $63c47e8a587a7f36$export$c18d01048907ea92("number" == typeof o, 49019);
            const _ = new $63c47e8a587a7f36$var$MutationBatch(o, t, n, r), a = function __PRIVATE_toDbMutationBatch(e, t, n) {
                const r = n.baseMutations.map((t)=>$63c47e8a587a7f36$var$toMutation(e.yt, t)), i = n.mutations.map((t)=>$63c47e8a587a7f36$var$toMutation(e.yt, t));
                return {
                    userId: t,
                    batchId: n.batchId,
                    localWriteTimeMs: n.localWriteTime.toMillis(),
                    baseMutations: r,
                    mutations: i
                };
            }(this.serializer, this.userId, _), u = [];
            let c = new $63c47e8a587a7f36$var$SortedSet((e, t)=>$63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString()));
            for (const e of r){
                const t = $63c47e8a587a7f36$var$__PRIVATE_newDbDocumentMutationKey(this.userId, e.key.path, o);
                c = c.add(e.key.path.popLast()), u.push(s.put(a)), u.push(i.put(t, $63c47e8a587a7f36$var$Y));
            }
            return c.forEach((t)=>{
                u.push(this.indexManager.addToCollectionParentIndex(e, t));
            }), e.addOnCommittedListener(()=>{
                this.Zn[o] = _.keys();
            }), $63c47e8a587a7f36$var$PersistencePromise.waitFor(u).next(()=>_);
        });
    }
    lookupMutationBatch(e, t) {
        return $63c47e8a587a7f36$var$__PRIVATE_mutationsStore(e).get(t).next((e)=>e ? ($63c47e8a587a7f36$export$c18d01048907ea92(e.userId === this.userId, 48, "Unexpected user for mutation batch", {
                userId: e.userId,
                batchId: t
            }), $63c47e8a587a7f36$var$__PRIVATE_fromDbMutationBatch(this.serializer, e)) : null);
    }
    /**
     * Returns the document keys for the mutation batch with the given batchId.
     * For primary clients, this method returns `null` after
     * `removeMutationBatches()` has been called. Secondary clients return a
     * cached result until `removeCachedMutationKeys()` is invoked.
     */ // PORTING NOTE: Multi-tab only.
    Xn(e, t) {
        return this.Zn[t] ? $63c47e8a587a7f36$var$PersistencePromise.resolve(this.Zn[t]) : this.lookupMutationBatch(e, t).next((e)=>{
            if (e) {
                const n = e.keys();
                return this.Zn[t] = n, n;
            }
            return null;
        });
    }
    getNextMutationBatchAfterBatchId(e, t) {
        const n = t + 1, r = IDBKeyRange.lowerBound([
            this.userId,
            n
        ]);
        let i = null;
        return $63c47e8a587a7f36$var$__PRIVATE_mutationsStore(e).ee({
            index: $63c47e8a587a7f36$var$Z,
            range: r
        }, (e, t, r)=>{
            t.userId === this.userId && ($63c47e8a587a7f36$export$c18d01048907ea92(t.batchId >= n, 47524, {
                Yn: n
            }), i = $63c47e8a587a7f36$var$__PRIVATE_fromDbMutationBatch(this.serializer, t)), r.done();
        }).next(()=>i);
    }
    getHighestUnacknowledgedBatchId(e) {
        const t = IDBKeyRange.upperBound([
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        let n = $63c47e8a587a7f36$var$U;
        return $63c47e8a587a7f36$var$__PRIVATE_mutationsStore(e).ee({
            index: $63c47e8a587a7f36$var$Z,
            range: t,
            reverse: !0
        }, (e, t, r)=>{
            n = t.batchId, r.done();
        }).next(()=>n);
    }
    getAllMutationBatches(e) {
        const t = IDBKeyRange.bound([
            this.userId,
            $63c47e8a587a7f36$var$U
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $63c47e8a587a7f36$var$__PRIVATE_mutationsStore(e).H($63c47e8a587a7f36$var$Z, t).next((e)=>e.map((e)=>$63c47e8a587a7f36$var$__PRIVATE_fromDbMutationBatch(this.serializer, e)));
    }
    getAllMutationBatchesAffectingDocumentKey(e, t) {
        // Scan the document-mutation index starting with a prefix starting with
        // the given documentKey.
        const n = $63c47e8a587a7f36$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), r = IDBKeyRange.lowerBound(n), i = [];
        return $63c47e8a587a7f36$var$__PRIVATE_documentMutationsStore(e).ee({
            range: r
        }, (n, r, s)=>{
            const [o, _, a] = n, u = $63c47e8a587a7f36$var$__PRIVATE_decodeResourcePath(_);
            // Only consider rows matching exactly the specific key of
            // interest. Note that because we order by path first, and we
            // order terminators before path separators, we'll encounter all
            // the index rows for documentKey contiguously. In particular, all
            // the rows for documentKey will occur before any rows for
            // documents nested in a subcollection beneath documentKey so we
            // can stop as soon as we hit any such row.
            if (o === this.userId && t.path.isEqual(u)) // Look up the mutation batch in the store.
            return $63c47e8a587a7f36$var$__PRIVATE_mutationsStore(e).get(a).next((e)=>{
                if (!e) throw $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(61480, {
                    er: n,
                    batchId: a
                });
                $63c47e8a587a7f36$export$c18d01048907ea92(e.userId === this.userId, 10503, "Unexpected user for mutation batch", {
                    userId: e.userId,
                    batchId: a
                }), i.push($63c47e8a587a7f36$var$__PRIVATE_fromDbMutationBatch(this.serializer, e));
            });
            s.done();
        }).next(()=>i);
    }
    getAllMutationBatchesAffectingDocumentKeys(e, t) {
        let n = new $63c47e8a587a7f36$var$SortedSet($63c47e8a587a7f36$var$__PRIVATE_primitiveComparator);
        const r = [];
        return t.forEach((t)=>{
            const i = $63c47e8a587a7f36$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), s = IDBKeyRange.lowerBound(i), o = $63c47e8a587a7f36$var$__PRIVATE_documentMutationsStore(e).ee({
                range: s
            }, (e, r, i)=>{
                const [s, o, _] = e, a = $63c47e8a587a7f36$var$__PRIVATE_decodeResourcePath(o);
                // Only consider rows matching exactly the specific key of
                // interest. Note that because we order by path first, and we
                // order terminators before path separators, we'll encounter all
                // the index rows for documentKey contiguously. In particular, all
                // the rows for documentKey will occur before any rows for
                // documents nested in a subcollection beneath documentKey so we
                // can stop as soon as we hit any such row.
                s === this.userId && t.path.isEqual(a) ? n = n.add(_) : i.done();
            });
            r.push(o);
        }), $63c47e8a587a7f36$var$PersistencePromise.waitFor(r).next(()=>this.tr(e, n));
    }
    getAllMutationBatchesAffectingQuery(e, t) {
        const n = t.path, r = n.length + 1, i = $63c47e8a587a7f36$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, n), s = IDBKeyRange.lowerBound(i);
        // Collect up unique batchIDs encountered during a scan of the index. Use a
        // SortedSet to accumulate batch IDs so they can be traversed in order in a
        // scan of the main table.
        let o = new $63c47e8a587a7f36$var$SortedSet($63c47e8a587a7f36$var$__PRIVATE_primitiveComparator);
        return $63c47e8a587a7f36$var$__PRIVATE_documentMutationsStore(e).ee({
            range: s
        }, (e, t, i)=>{
            const [s, _, a] = e, u = $63c47e8a587a7f36$var$__PRIVATE_decodeResourcePath(_);
            s === this.userId && n.isPrefixOf(u) ? // Rows with document keys more than one segment longer than the
            // query path can't be matches. For example, a query on 'rooms'
            // can't match the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            u.length === r && (o = o.add(a)) : i.done();
        }).next(()=>this.tr(e, o));
    }
    tr(e, t) {
        const n = [], r = [];
        // TODO(rockwood): Implement this using iterate.
        return t.forEach((t)=>{
            r.push($63c47e8a587a7f36$var$__PRIVATE_mutationsStore(e).get(t).next((e)=>{
                if (null === e) throw $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(35274, {
                    batchId: t
                });
                $63c47e8a587a7f36$export$c18d01048907ea92(e.userId === this.userId, 9748, "Unexpected user for mutation batch", {
                    userId: e.userId,
                    batchId: t
                }), n.push($63c47e8a587a7f36$var$__PRIVATE_fromDbMutationBatch(this.serializer, e));
            }));
        }), $63c47e8a587a7f36$var$PersistencePromise.waitFor(r).next(()=>n);
    }
    removeMutationBatch(e, t) {
        return $63c47e8a587a7f36$var$removeMutationBatch(e.le, this.userId, t).next((n)=>(e.addOnCommittedListener(()=>{
                this.nr(t.batchId);
            }), $63c47e8a587a7f36$var$PersistencePromise.forEach(n, (t)=>this.referenceDelegate.markPotentiallyOrphaned(e, t))));
    }
    /**
     * Clears the cached keys for a mutation batch. This method should be
     * called by secondary clients after they process mutation updates.
     *
     * Note that this method does not have to be called from primary clients as
     * the corresponding cache entries are cleared when an acknowledged or
     * rejected batch is removed from the mutation queue.
     */ // PORTING NOTE: Multi-tab only
    nr(e) {
        delete this.Zn[e];
    }
    performConsistencyCheck(e) {
        return this.checkEmpty(e).next((t)=>{
            if (!t) return $63c47e8a587a7f36$var$PersistencePromise.resolve();
            // Verify that there are no entries in the documentMutations index if
            // the queue is empty.
            const n = IDBKeyRange.lowerBound(/**
 * Creates a [userId] key for use in the DbDocumentMutations index to iterate
 * over all of a user's document mutations.
 */ function __PRIVATE_newDbDocumentMutationPrefixForUser(e) {
                return [
                    e
                ];
            }(this.userId)), r = [];
            return $63c47e8a587a7f36$var$__PRIVATE_documentMutationsStore(e).ee({
                range: n
            }, (e, t, n)=>{
                if (e[0] === this.userId) {
                    const t = $63c47e8a587a7f36$var$__PRIVATE_decodeResourcePath(e[1]);
                    r.push(t);
                } else n.done();
            }).next(()=>{
                $63c47e8a587a7f36$export$c18d01048907ea92(0 === r.length, 56720, {
                    rr: r.map((e)=>e.canonicalString())
                });
            });
        });
    }
    containsKey(e, t) {
        return $63c47e8a587a7f36$var$__PRIVATE_mutationQueueContainsKey(e, this.userId, t);
    }
    // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
    /** Returns the mutation queue's metadata from IndexedDb. */ ir(e) {
        return $63c47e8a587a7f36$var$__PRIVATE_mutationQueuesStore(e).get(this.userId).next((e)=>e || {
                userId: this.userId,
                lastAcknowledgedBatchId: $63c47e8a587a7f36$var$U,
                lastStreamToken: ""
            });
    }
}
/**
 * @returns true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */ function $63c47e8a587a7f36$var$__PRIVATE_mutationQueueContainsKey(e, t, n) {
    const r = $63c47e8a587a7f36$var$__PRIVATE_newDbDocumentMutationPrefixForPath(t, n.path), i = r[1], s = IDBKeyRange.lowerBound(r);
    let o = !1;
    return $63c47e8a587a7f36$var$__PRIVATE_documentMutationsStore(e).ee({
        range: s,
        Y: !0
    }, (e, n, r)=>{
        const [s, _, /*batchID*/ a] = e;
        s === t && _ === i && (o = !0), r.done();
    }).next(()=>o);
}
/** Returns true if any mutation queue contains the given document. */ /**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */ function $63c47e8a587a7f36$var$__PRIVATE_mutationsStore(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_getStore(e, $63c47e8a587a7f36$var$H);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $63c47e8a587a7f36$var$__PRIVATE_documentMutationsStore(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_getStore(e, $63c47e8a587a7f36$var$ee);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $63c47e8a587a7f36$var$__PRIVATE_mutationQueuesStore(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_getStore(e, $63c47e8a587a7f36$var$z);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Offset to ensure non-overlapping target ids. */ /**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the target cache, and one for
 * for the sync engine (to generate limbo documents targets). These
 * generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */ class $63c47e8a587a7f36$var$__PRIVATE_TargetIdGenerator {
    constructor(e){
        this.sr = e;
    }
    next() {
        return this.sr += 2, this.sr;
    }
    static _r() {
        // The target cache generator must return '2' in its first call to `next()`
        // as there is no differentiation in the protocol layer between an unset
        // number and the number '0'. If we were to sent a target with target ID
        // '0', the backend would consider it unset and replace it with its own ID.
        return new $63c47e8a587a7f36$var$__PRIVATE_TargetIdGenerator(0);
    }
    static ar() {
        // Sync engine assigns target IDs for limbo document detection.
        return new $63c47e8a587a7f36$var$__PRIVATE_TargetIdGenerator(-1);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $63c47e8a587a7f36$var$__PRIVATE_IndexedDbTargetCache {
    constructor(e, t){
        this.referenceDelegate = e, this.serializer = t;
    }
    // PORTING NOTE: We don't cache global metadata for the target cache, since
    // some of it (in particular `highestTargetId`) can be modified by secondary
    // tabs. We could perhaps be more granular (and e.g. still cache
    // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
    // to IndexedDb whenever we need to read metadata. We can revisit if it turns
    // out to have a meaningful performance impact.
    allocateTargetId(e) {
        return this.ur(e).next((t)=>{
            const n = new $63c47e8a587a7f36$var$__PRIVATE_TargetIdGenerator(t.highestTargetId);
            return t.highestTargetId = n.next(), this.cr(e, t).next(()=>t.highestTargetId);
        });
    }
    getLastRemoteSnapshotVersion(e) {
        return this.ur(e).next((e)=>$63c47e8a587a7f36$var$SnapshotVersion.fromTimestamp(new $63c47e8a587a7f36$export$3d12bd131bb975d1(e.lastRemoteSnapshotVersion.seconds, e.lastRemoteSnapshotVersion.nanoseconds)));
    }
    getHighestSequenceNumber(e) {
        return this.ur(e).next((e)=>e.highestListenSequenceNumber);
    }
    setTargetsMetadata(e, t, n) {
        return this.ur(e).next((r)=>(r.highestListenSequenceNumber = t, n && (r.lastRemoteSnapshotVersion = n.toTimestamp()), t > r.highestListenSequenceNumber && (r.highestListenSequenceNumber = t), this.cr(e, r)));
    }
    addTargetData(e, t) {
        return this.lr(e, t).next(()=>this.ur(e).next((n)=>(n.targetCount += 1, this.hr(t, n), this.cr(e, n))));
    }
    updateTargetData(e, t) {
        return this.lr(e, t);
    }
    removeTargetData(e, t) {
        return this.removeMatchingKeysForTargetId(e, t.targetId).next(()=>$63c47e8a587a7f36$var$__PRIVATE_targetsStore(e).delete(t.targetId)).next(()=>this.ur(e)).next((t)=>($63c47e8a587a7f36$export$c18d01048907ea92(t.targetCount > 0, 8065), t.targetCount -= 1, this.cr(e, t)));
    }
    /**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */ removeTargets(e, t, n) {
        let r = 0;
        const i = [];
        return $63c47e8a587a7f36$var$__PRIVATE_targetsStore(e).ee((s, o)=>{
            const _ = $63c47e8a587a7f36$var$__PRIVATE_fromDbTarget(o);
            _.sequenceNumber <= t && null === n.get(_.targetId) && (r++, i.push(this.removeTargetData(e, _)));
        }).next(()=>$63c47e8a587a7f36$var$PersistencePromise.waitFor(i)).next(()=>r);
    }
    /**
     * Call provided function with each `TargetData` that we have cached.
     */ forEachTarget(e, t) {
        return $63c47e8a587a7f36$var$__PRIVATE_targetsStore(e).ee((e, n)=>{
            const r = $63c47e8a587a7f36$var$__PRIVATE_fromDbTarget(n);
            t(r);
        });
    }
    ur(e) {
        return $63c47e8a587a7f36$var$__PRIVATE_globalTargetStore(e).get($63c47e8a587a7f36$var$Ee).next((e)=>($63c47e8a587a7f36$export$c18d01048907ea92(null !== e, 2888), e));
    }
    cr(e, t) {
        return $63c47e8a587a7f36$var$__PRIVATE_globalTargetStore(e).put($63c47e8a587a7f36$var$Ee, t);
    }
    lr(e, t) {
        return $63c47e8a587a7f36$var$__PRIVATE_targetsStore(e).put($63c47e8a587a7f36$var$__PRIVATE_toDbTarget(this.serializer, t));
    }
    /**
     * In-place updates the provided metadata to account for values in the given
     * TargetData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */ hr(e, t) {
        let n = !1;
        return e.targetId > t.highestTargetId && (t.highestTargetId = e.targetId, n = !0), e.sequenceNumber > t.highestListenSequenceNumber && (t.highestListenSequenceNumber = e.sequenceNumber, n = !0), n;
    }
    getTargetCount(e) {
        return this.ur(e).next((e)=>e.targetCount);
    }
    getTargetData(e, t) {
        // Iterating by the canonicalId may yield more than one result because
        // canonicalId values are not required to be unique per target. This query
        // depends on the queryTargets index to be efficient.
        const n = $63c47e8a587a7f36$var$__PRIVATE_canonifyTarget(t), r = IDBKeyRange.bound([
            n,
            Number.NEGATIVE_INFINITY
        ], [
            n,
            Number.POSITIVE_INFINITY
        ]);
        let i = null;
        return $63c47e8a587a7f36$var$__PRIVATE_targetsStore(e).ee({
            range: r,
            index: $63c47e8a587a7f36$var$ce
        }, (e, n, r)=>{
            const s = $63c47e8a587a7f36$var$__PRIVATE_fromDbTarget(n);
            // After finding a potential match, check that the target is
            // actually equal to the requested target.
            $63c47e8a587a7f36$var$__PRIVATE_targetEquals(t, s.target) && (i = s, r.done());
        }).next(()=>i);
    }
    addMatchingKeys(e, t, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const r = [], i = $63c47e8a587a7f36$var$__PRIVATE_documentTargetStore(e);
        return t.forEach((t)=>{
            const s = $63c47e8a587a7f36$var$__PRIVATE_encodeResourcePath(t.path);
            r.push(i.put({
                targetId: n,
                path: s
            })), r.push(this.referenceDelegate.addReference(e, n, t));
        }), $63c47e8a587a7f36$var$PersistencePromise.waitFor(r);
    }
    removeMatchingKeys(e, t, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const r = $63c47e8a587a7f36$var$__PRIVATE_documentTargetStore(e);
        return $63c47e8a587a7f36$var$PersistencePromise.forEach(t, (t)=>{
            const i = $63c47e8a587a7f36$var$__PRIVATE_encodeResourcePath(t.path);
            return $63c47e8a587a7f36$var$PersistencePromise.waitFor([
                r.delete([
                    n,
                    i
                ]),
                this.referenceDelegate.removeReference(e, n, t)
            ]);
        });
    }
    removeMatchingKeysForTargetId(e, t) {
        const n = $63c47e8a587a7f36$var$__PRIVATE_documentTargetStore(e), r = IDBKeyRange.bound([
            t
        ], [
            t + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return n.delete(r);
    }
    getMatchingKeysForTargetId(e, t) {
        const n = IDBKeyRange.bound([
            t
        ], [
            t + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0), r = $63c47e8a587a7f36$var$__PRIVATE_documentTargetStore(e);
        let i = $63c47e8a587a7f36$export$971d5caa766a69d7();
        return r.ee({
            range: n,
            Y: !0
        }, (e, t, n)=>{
            const r = $63c47e8a587a7f36$var$__PRIVATE_decodeResourcePath(e[1]), s = new $63c47e8a587a7f36$export$90a7f3efeed30595(r);
            i = i.add(s);
        }).next(()=>i);
    }
    containsKey(e, t) {
        const n = $63c47e8a587a7f36$var$__PRIVATE_encodeResourcePath(t.path), r = IDBKeyRange.bound([
            n
        ], [
            $63c47e8a587a7f36$var$__PRIVATE_immediateSuccessor(n)
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        let i = 0;
        return $63c47e8a587a7f36$var$__PRIVATE_documentTargetStore(e).ee({
            index: $63c47e8a587a7f36$var$Te,
            Y: !0,
            range: r
        }, ([e, t], n, r)=>{
            // Having a sentinel row for a document does not count as containing that document;
            // For the target cache, containing the document means the document is part of some
            // target.
            0 !== e && (i++, r.done());
        }).next(()=>i > 0);
    }
    /**
     * Looks up a TargetData entry by target ID.
     *
     * @param targetId - The target ID of the TargetData entry to look up.
     * @returns The cached TargetData entry, or null if the cache has no entry for
     * the target.
     */ // PORTING NOTE: Multi-tab only.
    At(e, t) {
        return $63c47e8a587a7f36$var$__PRIVATE_targetsStore(e).get(t).next((e)=>e ? $63c47e8a587a7f36$var$__PRIVATE_fromDbTarget(e) : null);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */ function $63c47e8a587a7f36$var$__PRIVATE_targetsStore(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_getStore(e, $63c47e8a587a7f36$var$ue);
}
/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */ function $63c47e8a587a7f36$var$__PRIVATE_globalTargetStore(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_getStore(e, $63c47e8a587a7f36$var$Re);
}
/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */ function $63c47e8a587a7f36$var$__PRIVATE_documentTargetStore(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_getStore(e, $63c47e8a587a7f36$var$he);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $63c47e8a587a7f36$var$Ct = "LruGarbageCollector", $63c47e8a587a7f36$var$vt = 1048576;
function $63c47e8a587a7f36$var$__PRIVATE_bufferEntryComparator([e, t], [n, r]) {
    const i = $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(e, n);
    return 0 === i ? $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(t, r) : i;
}
/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */ class $63c47e8a587a7f36$var$__PRIVATE_RollingSequenceNumberBuffer {
    constructor(e){
        this.Pr = e, this.buffer = new $63c47e8a587a7f36$var$SortedSet($63c47e8a587a7f36$var$__PRIVATE_bufferEntryComparator), this.Tr = 0;
    }
    Ir() {
        return ++this.Tr;
    }
    Er(e) {
        const t = [
            e,
            this.Ir()
        ];
        if (this.buffer.size < this.Pr) this.buffer = this.buffer.add(t);
        else {
            const e = this.buffer.last();
            $63c47e8a587a7f36$var$__PRIVATE_bufferEntryComparator(t, e) < 0 && (this.buffer = this.buffer.delete(e).add(t));
        }
    }
    get maxValue() {
        // Guaranteed to be non-empty. If we decide we are not collecting any
        // sequence numbers, nthSequenceNumber below short-circuits. If we have
        // decided that we are collecting n sequence numbers, it's because n is some
        // percentage of the existing sequence numbers. That means we should never
        // be in a situation where we are collecting sequence numbers but don't
        // actually have any.
        return this.buffer.last()[0];
    }
}
/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */ class $63c47e8a587a7f36$var$__PRIVATE_LruScheduler {
    constructor(e, t, n){
        this.garbageCollector = e, this.asyncQueue = t, this.localStore = n, this.Rr = null;
    }
    start() {
        -1 !== this.garbageCollector.params.cacheSizeCollectionThreshold && this.Ar(6e4);
    }
    stop() {
        this.Rr && (this.Rr.cancel(), this.Rr = null);
    }
    get started() {
        return null !== this.Rr;
    }
    Ar(e) {
        $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Ct, `Garbage collection scheduled in ${e}ms`), this.Rr = this.asyncQueue.enqueueAfterDelay("lru_garbage_collection" /* TimerId.LruGarbageCollection */ , e, async ()=>{
            this.Rr = null;
            try {
                await this.localStore.collectGarbage(this.garbageCollector);
            } catch (e) {
                $63c47e8a587a7f36$var$__PRIVATE_isIndexedDbTransactionError(e) ? $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Ct, "Ignoring IndexedDB error during garbage collection: ", e) : await $63c47e8a587a7f36$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
            }
            await this.Ar(3e5);
        });
    }
}
/**
 * Implements the steps for LRU garbage collection.
 */ class $63c47e8a587a7f36$var$__PRIVATE_LruGarbageCollectorImpl {
    constructor(e, t){
        this.Vr = e, this.params = t;
    }
    calculateTargetCount(e, t) {
        return this.Vr.dr(e).next((e)=>Math.floor(t / 100 * e));
    }
    nthSequenceNumber(e, t) {
        if (0 === t) return $63c47e8a587a7f36$var$PersistencePromise.resolve($63c47e8a587a7f36$var$__PRIVATE_ListenSequence.ce);
        const n = new $63c47e8a587a7f36$var$__PRIVATE_RollingSequenceNumberBuffer(t);
        return this.Vr.forEachTarget(e, (e)=>n.Er(e.sequenceNumber)).next(()=>this.Vr.mr(e, (e)=>n.Er(e))).next(()=>n.maxValue);
    }
    removeTargets(e, t, n) {
        return this.Vr.removeTargets(e, t, n);
    }
    removeOrphanedDocuments(e, t) {
        return this.Vr.removeOrphanedDocuments(e, t);
    }
    collect(e, t) {
        return -1 === this.params.cacheSizeCollectionThreshold ? ($63c47e8a587a7f36$export$21579262ef46735b("LruGarbageCollector", "Garbage collection skipped; disabled"), $63c47e8a587a7f36$var$PersistencePromise.resolve($63c47e8a587a7f36$var$St)) : this.getCacheSize(e).next((n)=>n < this.params.cacheSizeCollectionThreshold ? ($63c47e8a587a7f36$export$21579262ef46735b("LruGarbageCollector", `Garbage collection skipped; Cache size ${n} is lower than threshold ${this.params.cacheSizeCollectionThreshold}`), $63c47e8a587a7f36$var$St) : this.gr(e, t));
    }
    getCacheSize(e) {
        return this.Vr.getCacheSize(e);
    }
    gr(e, t) {
        let n, r, i, s, o, _, a;
        const u = Date.now();
        return this.calculateTargetCount(e, this.params.percentileToCollect).next((t)=>// Cap at the configured max
            (t > this.params.maximumSequenceNumbersToCollect ? ($63c47e8a587a7f36$export$21579262ef46735b("LruGarbageCollector", `Capping sequence numbers to collect down to the maximum of ${this.params.maximumSequenceNumbersToCollect} from ${t}`), r = this.params.maximumSequenceNumbersToCollect) : r = t, s = Date.now(), this.nthSequenceNumber(e, r))).next((r)=>(n = r, o = Date.now(), this.removeTargets(e, n, t))).next((t)=>(i = t, _ = Date.now(), this.removeOrphanedDocuments(e, n))).next((e)=>{
            if (a = Date.now(), $63c47e8a587a7f36$var$__PRIVATE_getLogLevel() <= (0, $6640afd658bf2724$export$243e62d78d3b544d).DEBUG) $63c47e8a587a7f36$export$21579262ef46735b("LruGarbageCollector", `LRU Garbage Collection\n\tCounted targets in ${s - u}ms\n\tDetermined least recently used ${r} in ` + (o - s) + "ms\n" + `\tRemoved ${i} targets in ` + (_ - o) + "ms\n" + `\tRemoved ${e} documents in ` + (a - _) + "ms\n" + `Total Duration: ${a - u}ms`);
            return $63c47e8a587a7f36$var$PersistencePromise.resolve({
                didRun: !0,
                sequenceNumbersCollected: r,
                targetsRemoved: i,
                documentsRemoved: e
            });
        });
    }
}
function $63c47e8a587a7f36$var$__PRIVATE_newLruGarbageCollector(e, t) {
    return new $63c47e8a587a7f36$var$__PRIVATE_LruGarbageCollectorImpl(e, t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Provides LRU functionality for IndexedDB persistence. */ class $63c47e8a587a7f36$var$__PRIVATE_IndexedDbLruDelegateImpl {
    constructor(e, t){
        this.db = e, this.garbageCollector = $63c47e8a587a7f36$var$__PRIVATE_newLruGarbageCollector(this, t);
    }
    dr(e) {
        const t = this.pr(e);
        return this.db.getTargetCache().getTargetCount(e).next((e)=>t.next((t)=>e + t));
    }
    pr(e) {
        let t = 0;
        return this.mr(e, (e)=>{
            t++;
        }).next(()=>t);
    }
    forEachTarget(e, t) {
        return this.db.getTargetCache().forEachTarget(e, t);
    }
    mr(e, t) {
        return this.yr(e, (e, n)=>t(n));
    }
    addReference(e, t, n) {
        return $63c47e8a587a7f36$var$__PRIVATE_writeSentinelKey(e, n);
    }
    removeReference(e, t, n) {
        return $63c47e8a587a7f36$var$__PRIVATE_writeSentinelKey(e, n);
    }
    removeTargets(e, t, n) {
        return this.db.getTargetCache().removeTargets(e, t, n);
    }
    markPotentiallyOrphaned(e, t) {
        return $63c47e8a587a7f36$var$__PRIVATE_writeSentinelKey(e, t);
    }
    /**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */ wr(e, t) {
        return function __PRIVATE_mutationQueuesContainKey(e, t) {
            let n = !1;
            return $63c47e8a587a7f36$var$__PRIVATE_mutationQueuesStore(e).te((r)=>$63c47e8a587a7f36$var$__PRIVATE_mutationQueueContainsKey(e, r, t).next((e)=>(e && (n = !0), $63c47e8a587a7f36$var$PersistencePromise.resolve(!e)))).next(()=>n);
        }(e, t);
    }
    removeOrphanedDocuments(e, t) {
        const n = this.db.getRemoteDocumentCache().newChangeBuffer(), r = [];
        let i = 0;
        return this.yr(e, (s, o)=>{
            if (o <= t) {
                const t = this.wr(e, s).next((t)=>{
                    if (!t) // Our size accounting requires us to read all documents before
                    // removing them.
                    return i++, n.getEntry(e, s).next(()=>(n.removeEntry(s, $63c47e8a587a7f36$var$SnapshotVersion.min()), $63c47e8a587a7f36$var$__PRIVATE_documentTargetStore(e).delete(function __PRIVATE_sentinelKey$1(e) {
                            return [
                                0,
                                $63c47e8a587a7f36$var$__PRIVATE_encodeResourcePath(e.path)
                            ];
                        }(s))));
                });
                r.push(t);
            }
        }).next(()=>$63c47e8a587a7f36$var$PersistencePromise.waitFor(r)).next(()=>n.apply(e)).next(()=>i);
    }
    removeTarget(e, t) {
        const n = t.withSequenceNumber(e.currentSequenceNumber);
        return this.db.getTargetCache().updateTargetData(e, n);
    }
    updateLimboDocument(e, t) {
        return $63c47e8a587a7f36$var$__PRIVATE_writeSentinelKey(e, t);
    }
    /**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */ yr(e, t) {
        const n = $63c47e8a587a7f36$var$__PRIVATE_documentTargetStore(e);
        let r, i = $63c47e8a587a7f36$var$__PRIVATE_ListenSequence.ce;
        return n.ee({
            index: $63c47e8a587a7f36$var$Te
        }, ([e, n], { path: s, sequenceNumber: o })=>{
            0 === e ? // if nextToReport is valid, report it, this is a new key so the
            // last one must not be a member of any targets.
            (i !== $63c47e8a587a7f36$var$__PRIVATE_ListenSequence.ce && t(new $63c47e8a587a7f36$export$90a7f3efeed30595($63c47e8a587a7f36$var$__PRIVATE_decodeResourcePath(r)), i), // set nextToReport to be this sequence number. It's the next one we
            // might report, if we don't find any targets for this document.
            // Note that the sequence number must be defined when the targetId
            // is 0.
            i = o, r = s) : // set nextToReport to be invalid, we know we don't need to report
            // this one since we found a target for it.
            i = $63c47e8a587a7f36$var$__PRIVATE_ListenSequence.ce;
        }).next(()=>{
            // Since we report sequence numbers after getting to the next key, we
            // need to check if the last key we iterated over was an orphaned
            // document and report it.
            i !== $63c47e8a587a7f36$var$__PRIVATE_ListenSequence.ce && t(new $63c47e8a587a7f36$export$90a7f3efeed30595($63c47e8a587a7f36$var$__PRIVATE_decodeResourcePath(r)), i);
        });
    }
    getCacheSize(e) {
        return this.db.getRemoteDocumentCache().getSize(e);
    }
}
function $63c47e8a587a7f36$var$__PRIVATE_writeSentinelKey(e, t) {
    return $63c47e8a587a7f36$var$__PRIVATE_documentTargetStore(e).put(function __PRIVATE_sentinelRow(e, t) {
        return {
            targetId: 0,
            path: $63c47e8a587a7f36$var$__PRIVATE_encodeResourcePath(e.path),
            sequenceNumber: t
        };
    }(t, e.currentSequenceNumber));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * Entries added to the cache *must* be read first. This is to facilitate
 * calculating the size delta of the pending changes.
 *
 * PORTING NOTE: This class was implemented then removed from other platforms.
 * If byte-counting ends up being needed on the other platforms, consider
 * porting this class as part of that implementation work.
 */ class $63c47e8a587a7f36$var$RemoteDocumentChangeBuffer {
    constructor(){
        // A mapping of document key to the new cache entry that should be written.
        this.changes = new $63c47e8a587a7f36$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t)), this.changesApplied = !1;
    }
    /**
     * Buffers a `RemoteDocumentCache.addEntry()` call.
     *
     * You can only modify documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ addEntry(e) {
        this.assertNotApplied(), this.changes.set(e.key, e);
    }
    /**
     * Buffers a `RemoteDocumentCache.removeEntry()` call.
     *
     * You can only remove documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ removeEntry(e, t) {
        this.assertNotApplied(), this.changes.set(e, $63c47e8a587a7f36$var$MutableDocument.newInvalidDocument(e).setReadTime(t));
    }
    /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document or an invalid document if we have nothing
     * cached.
     */ getEntry(e, t) {
        this.assertNotApplied();
        const n = this.changes.get(t);
        return void 0 !== n ? $63c47e8a587a7f36$var$PersistencePromise.resolve(n) : this.getFromCache(e, t);
    }
    /**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys - The keys of the entries to look up.
     * @returns A map of cached documents, indexed by key. If an entry cannot be
     *     found, the corresponding key will be mapped to an invalid document.
     */ getEntries(e, t) {
        return this.getAllFromCache(e, t);
    }
    /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */ apply(e) {
        return this.assertNotApplied(), this.changesApplied = !0, this.applyChanges(e);
    }
    /** Helper to assert this.changes is not null  */ assertNotApplied() {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newIndexedDbRemoteDocumentCache()`.
 */ class $63c47e8a587a7f36$var$__PRIVATE_IndexedDbRemoteDocumentCacheImpl {
    constructor(e){
        this.serializer = e;
    }
    setIndexManager(e) {
        this.indexManager = e;
    }
    /**
     * Adds the supplied entries to the cache.
     *
     * All calls of `addEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ addEntry(e, t, n) {
        return $63c47e8a587a7f36$var$__PRIVATE_remoteDocumentsStore(e).put(n);
    }
    /**
     * Removes a document from the cache.
     *
     * All calls of `removeEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ removeEntry(e, t, n) {
        return $63c47e8a587a7f36$var$__PRIVATE_remoteDocumentsStore(e).delete(/**
 * Returns a key that can be used for document lookups via the primary key of
 * the DbRemoteDocument object store.
 */ function __PRIVATE_dbReadTimeKey(e, t) {
            const n = e.path.toArray();
            return [
                /* prefix path */ n.slice(0, n.length - 2),
                /* collection id */ n[n.length - 2],
                $63c47e8a587a7f36$var$__PRIVATE_toDbTimestampKey(t),
                /* document id */ n[n.length - 1]
            ];
        }(t, n));
    }
    /**
     * Updates the current cache size.
     *
     * Callers to `addEntry()` and `removeEntry()` *must* call this afterwards to update the
     * cache's metadata.
     */ updateMetadata(e, t) {
        return this.getMetadata(e).next((n)=>(n.byteSize += t, this.br(e, n)));
    }
    getEntry(e, t) {
        let n = $63c47e8a587a7f36$var$MutableDocument.newInvalidDocument(t);
        return $63c47e8a587a7f36$var$__PRIVATE_remoteDocumentsStore(e).ee({
            index: $63c47e8a587a7f36$var$re,
            range: IDBKeyRange.only($63c47e8a587a7f36$var$__PRIVATE_dbKey(t))
        }, (e, r)=>{
            n = this.Sr(t, r);
        }).next(()=>n);
    }
    /**
     * Looks up an entry in the cache.
     *
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document entry and its size.
     */ Dr(e, t) {
        let n = {
            size: 0,
            document: $63c47e8a587a7f36$var$MutableDocument.newInvalidDocument(t)
        };
        return $63c47e8a587a7f36$var$__PRIVATE_remoteDocumentsStore(e).ee({
            index: $63c47e8a587a7f36$var$re,
            range: IDBKeyRange.only($63c47e8a587a7f36$var$__PRIVATE_dbKey(t))
        }, (e, r)=>{
            n = {
                document: this.Sr(t, r),
                size: $63c47e8a587a7f36$var$__PRIVATE_dbDocumentSize(r)
            };
        }).next(()=>n);
    }
    getEntries(e, t) {
        let n = $63c47e8a587a7f36$var$__PRIVATE_mutableDocumentMap();
        return this.Cr(e, t, (e, t)=>{
            const r = this.Sr(e, t);
            n = n.insert(e, r);
        }).next(()=>n);
    }
    /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys - The set of keys entries to look up.
     * @returns A map of documents indexed by key and a map of sizes indexed by
     *     key (zero if the document does not exist).
     */ vr(e, t) {
        let n = $63c47e8a587a7f36$var$__PRIVATE_mutableDocumentMap(), r = new $63c47e8a587a7f36$var$SortedMap($63c47e8a587a7f36$export$90a7f3efeed30595.comparator);
        return this.Cr(e, t, (e, t)=>{
            const i = this.Sr(e, t);
            n = n.insert(e, i), r = r.insert(e, $63c47e8a587a7f36$var$__PRIVATE_dbDocumentSize(t));
        }).next(()=>({
                documents: n,
                Fr: r
            }));
    }
    Cr(e, t, n) {
        if (t.isEmpty()) return $63c47e8a587a7f36$var$PersistencePromise.resolve();
        let r = new $63c47e8a587a7f36$var$SortedSet($63c47e8a587a7f36$var$__PRIVATE_dbKeyComparator);
        t.forEach((e)=>r = r.add(e));
        const i = IDBKeyRange.bound($63c47e8a587a7f36$var$__PRIVATE_dbKey(r.first()), $63c47e8a587a7f36$var$__PRIVATE_dbKey(r.last())), s = r.getIterator();
        let o = s.getNext();
        return $63c47e8a587a7f36$var$__PRIVATE_remoteDocumentsStore(e).ee({
            index: $63c47e8a587a7f36$var$re,
            range: i
        }, (e, t, r)=>{
            const i = $63c47e8a587a7f36$export$90a7f3efeed30595.fromSegments([
                ...t.prefixPath,
                t.collectionGroup,
                t.documentId
            ]);
            // Go through keys not found in cache.
            for(; o && $63c47e8a587a7f36$var$__PRIVATE_dbKeyComparator(o, i) < 0;)n(o, null), o = s.getNext();
            o && o.isEqual(i) && // Key found in cache.
            (n(o, t), o = s.hasNext() ? s.getNext() : null), // Skip to the next key (if there is one).
            o ? r.j($63c47e8a587a7f36$var$__PRIVATE_dbKey(o)) : r.done();
        }).next(()=>{
            // The rest of the keys are not in the cache. One case where `iterate`
            // above won't go through them is when the cache is empty.
            for(; o;)n(o, null), o = s.hasNext() ? s.getNext() : null;
        });
    }
    getDocumentsMatchingQuery(e, t, n, r, i) {
        const s = t.path, o = [
            s.popLast().toArray(),
            s.lastSegment(),
            $63c47e8a587a7f36$var$__PRIVATE_toDbTimestampKey(n.readTime),
            n.documentKey.path.isEmpty() ? "" : n.documentKey.path.lastSegment()
        ], _ = [
            s.popLast().toArray(),
            s.lastSegment(),
            [
                Number.MAX_SAFE_INTEGER,
                Number.MAX_SAFE_INTEGER
            ],
            ""
        ];
        return $63c47e8a587a7f36$var$__PRIVATE_remoteDocumentsStore(e).H(IDBKeyRange.bound(o, _, !0)).next((e)=>{
            i?.incrementDocumentReadCount(e.length);
            let n = $63c47e8a587a7f36$var$__PRIVATE_mutableDocumentMap();
            for (const i of e){
                const e = this.Sr($63c47e8a587a7f36$export$90a7f3efeed30595.fromSegments(i.prefixPath.concat(i.collectionGroup, i.documentId)), i);
                e.isFoundDocument() && ($63c47e8a587a7f36$var$__PRIVATE_queryMatches(t, e) || r.has(e.key)) && // Either the document matches the given query, or it is mutated.
                (n = n.insert(e.key, e));
            }
            return n;
        });
    }
    getAllFromCollectionGroup(e, t, n, r) {
        let i = $63c47e8a587a7f36$var$__PRIVATE_mutableDocumentMap();
        const s = $63c47e8a587a7f36$var$__PRIVATE_dbCollectionGroupKey(t, n), o = $63c47e8a587a7f36$var$__PRIVATE_dbCollectionGroupKey(t, $63c47e8a587a7f36$var$IndexOffset.max());
        return $63c47e8a587a7f36$var$__PRIVATE_remoteDocumentsStore(e).ee({
            index: $63c47e8a587a7f36$var$se,
            range: IDBKeyRange.bound(s, o, !0)
        }, (e, t, n)=>{
            const s = this.Sr($63c47e8a587a7f36$export$90a7f3efeed30595.fromSegments(t.prefixPath.concat(t.collectionGroup, t.documentId)), t);
            i = i.insert(s.key, s), i.size === r && n.done();
        }).next(()=>i);
    }
    newChangeBuffer(e) {
        return new $63c47e8a587a7f36$var$__PRIVATE_IndexedDbRemoteDocumentChangeBuffer(this, !!e && e.trackRemovals);
    }
    getSize(e) {
        return this.getMetadata(e).next((e)=>e.byteSize);
    }
    getMetadata(e) {
        return $63c47e8a587a7f36$var$__PRIVATE_documentGlobalStore(e).get($63c47e8a587a7f36$var$ae).next((e)=>($63c47e8a587a7f36$export$c18d01048907ea92(!!e, 20021), e));
    }
    br(e, t) {
        return $63c47e8a587a7f36$var$__PRIVATE_documentGlobalStore(e).put($63c47e8a587a7f36$var$ae, t);
    }
    /**
     * Decodes `dbRemoteDoc` and returns the document (or an invalid document if
     * the document corresponds to the format used for sentinel deletes).
     */ Sr(e, t) {
        if (t) {
            const e = $63c47e8a587a7f36$var$__PRIVATE_fromDbRemoteDocument(this.serializer, t);
            // Whether the document is a sentinel removal and should only be used in the
            // `getNewDocumentChanges()`
            if (!(e.isNoDocument() && e.version.isEqual($63c47e8a587a7f36$var$SnapshotVersion.min()))) return e;
        }
        return $63c47e8a587a7f36$var$MutableDocument.newInvalidDocument(e);
    }
}
/** Creates a new IndexedDbRemoteDocumentCache. */ function $63c47e8a587a7f36$var$__PRIVATE_newIndexedDbRemoteDocumentCache(e) {
    return new $63c47e8a587a7f36$var$__PRIVATE_IndexedDbRemoteDocumentCacheImpl(e);
}
/**
 * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache.
 *
 * Unlike the MemoryRemoteDocumentChangeBuffer, the IndexedDb implementation computes the size
 * delta for all submitted changes. This avoids having to re-read all documents from IndexedDb
 * when we apply the changes.
 */ class $63c47e8a587a7f36$var$__PRIVATE_IndexedDbRemoteDocumentChangeBuffer extends $63c47e8a587a7f36$var$RemoteDocumentChangeBuffer {
    /**
     * @param documentCache - The IndexedDbRemoteDocumentCache to apply the changes to.
     * @param trackRemovals - Whether to create sentinel deletes that can be tracked by
     * `getNewDocumentChanges()`.
     */ constructor(e, t){
        super(), this.Mr = e, this.trackRemovals = t, // A map of document sizes and read times prior to applying the changes in
        // this buffer.
        this.Or = new $63c47e8a587a7f36$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t));
    }
    applyChanges(e) {
        const t = [];
        let n = 0, r = new $63c47e8a587a7f36$var$SortedSet((e, t)=>$63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString()));
        return this.changes.forEach((i, s)=>{
            const o = this.Or.get(i);
            if (t.push(this.Mr.removeEntry(e, i, o.readTime)), s.isValidDocument()) {
                const _ = $63c47e8a587a7f36$var$__PRIVATE_toDbRemoteDocument(this.Mr.serializer, s);
                r = r.add(i.path.popLast());
                const a = $63c47e8a587a7f36$var$__PRIVATE_dbDocumentSize(_);
                n += a - o.size, t.push(this.Mr.addEntry(e, i, _));
            } else if (n -= o.size, this.trackRemovals) {
                // In order to track removals, we store a "sentinel delete" in the
                // RemoteDocumentCache. This entry is represented by a NoDocument
                // with a version of 0 and ignored by `maybeDecodeDocument()` but
                // preserved in `getNewDocumentChanges()`.
                const n = $63c47e8a587a7f36$var$__PRIVATE_toDbRemoteDocument(this.Mr.serializer, s.convertToNoDocument($63c47e8a587a7f36$var$SnapshotVersion.min()));
                t.push(this.Mr.addEntry(e, i, n));
            }
        }), r.forEach((n)=>{
            t.push(this.Mr.indexManager.addToCollectionParentIndex(e, n));
        }), t.push(this.Mr.updateMetadata(e, n)), $63c47e8a587a7f36$var$PersistencePromise.waitFor(t);
    }
    getFromCache(e, t) {
        // Record the size of everything we load from the cache so we can compute a delta later.
        return this.Mr.Dr(e, t).next((e)=>(this.Or.set(t, {
                size: e.size,
                readTime: e.document.readTime
            }), e.document));
    }
    getAllFromCache(e, t) {
        // Record the size of everything we load from the cache so we can compute
        // a delta later.
        return this.Mr.vr(e, t).next(({ documents: e, Fr: t })=>// Note: `getAllFromCache` returns two maps instead of a single map from
            // keys to `DocumentSizeEntry`s. This is to allow returning the
            // `MutableDocumentMap` directly, without a conversion.
            (t.forEach((t, n)=>{
                this.Or.set(t, {
                    size: n,
                    readTime: e.get(t).readTime
                });
            }), e));
    }
}
function $63c47e8a587a7f36$var$__PRIVATE_documentGlobalStore(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_getStore(e, $63c47e8a587a7f36$var$_e);
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */ function $63c47e8a587a7f36$var$__PRIVATE_remoteDocumentsStore(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_getStore(e, $63c47e8a587a7f36$var$te);
}
/**
 * Returns a key that can be used for document lookups on the
 * `DbRemoteDocumentDocumentKeyIndex` index.
 */ function $63c47e8a587a7f36$var$__PRIVATE_dbKey(e) {
    const t = e.path.toArray();
    return [
        /* prefix path */ t.slice(0, t.length - 2),
        /* collection id */ t[t.length - 2],
        /* document id */ t[t.length - 1]
    ];
}
function $63c47e8a587a7f36$var$__PRIVATE_dbCollectionGroupKey(e, t) {
    const n = t.documentKey.path.toArray();
    return [
        /* collection id */ e,
        $63c47e8a587a7f36$var$__PRIVATE_toDbTimestampKey(t.readTime),
        /* prefix path */ n.slice(0, n.length - 2),
        /* document id */ n.length > 0 ? n[n.length - 1] : ""
    ];
}
/**
 * Comparator that compares document keys according to the primary key sorting
 * used by the `DbRemoteDocumentDocument` store (by prefix path, collection id
 * and then document ID).
 *
 * Visible for testing.
 */ function $63c47e8a587a7f36$var$__PRIVATE_dbKeyComparator(e, t) {
    const n = e.path.toArray(), r = t.path.toArray();
    // The ordering is based on https://chromium.googlesource.com/chromium/blink/+/fe5c21fef94dae71c1c3344775b8d8a7f7e6d9ec/Source/modules/indexeddb/IDBKey.cpp#74
    let i = 0;
    for(let e = 0; e < n.length - 2 && e < r.length - 2; ++e)if (i = $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(n[e], r[e]), i) return i;
    return i = $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(n.length, r.length), i || (i = $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(n[n.length - 2], r[r.length - 2]), i || $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(n[n.length - 1], r[r.length - 1]));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Schema Version for the Web client:
 * 1.  Initial version including Mutation Queue, Query Cache, and Remote
 *     Document Cache
 * 2.  Used to ensure a targetGlobal object exists and add targetCount to it. No
 *     longer required because migration 3 unconditionally clears it.
 * 3.  Dropped and re-created Query Cache to deal with cache corruption related
 *     to limbo resolution. Addresses
 *     https://github.com/firebase/firebase-ios-sdk/issues/1548
 * 4.  Multi-Tab Support.
 * 5.  Removal of held write acks.
 * 6.  Create document global for tracking document cache size.
 * 7.  Ensure every cached document has a sentinel row with a sequence number.
 * 8.  Add collection-parent index for Collection Group queries.
 * 9.  Change RemoteDocumentChanges store to be keyed by readTime rather than
 *     an auto-incrementing ID. This is required for Index-Free queries.
 * 10. Rewrite the canonical IDs to the explicit Protobuf-based format.
 * 11. Add bundles and named_queries for bundle support.
 * 12. Add document overlays.
 * 13. Rewrite the keys of the remote document cache to allow for efficient
 *     document lookup via `getAll()`.
 * 14. Add overlays.
 * 15. Add indexing support.
 * 16. Parse timestamp strings before creating index entries.
 * 17. TODO(tomandersen)
 * 18. Encode key safe representations of IndexEntry in DbIndexEntryStore.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a local view (overlay) of a document, and the fields that are
 * locally mutated.
 */ class $63c47e8a587a7f36$var$OverlayedDocument {
    constructor(e, /**
     * The fields that are locally mutated by patch mutations.
     *
     * If the overlayed	document is from set or delete mutations, this is `null`.
     * If there is no overlay (mutation) for the document, this is an empty `FieldMask`.
     */ t){
        this.overlayedDocument = e, this.mutatedFields = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */ class $63c47e8a587a7f36$var$LocalDocumentsView {
    constructor(e, t, n, r){
        this.remoteDocumentCache = e, this.mutationQueue = t, this.documentOverlayCache = n, this.indexManager = r;
    }
    /**
     * Get the local view of the document identified by `key`.
     *
     * @returns Local view of the document or null if we don't have any cached
     * state for it.
     */ getDocument(e, t) {
        let n = null;
        return this.documentOverlayCache.getOverlay(e, t).next((r)=>(n = r, this.remoteDocumentCache.getEntry(e, t))).next((e)=>(null !== n && $63c47e8a587a7f36$var$__PRIVATE_mutationApplyToLocalView(n.mutation, e, $63c47e8a587a7f36$var$FieldMask.empty(), $63c47e8a587a7f36$export$3d12bd131bb975d1.now()), e));
    }
    /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */ getDocuments(e, t) {
        return this.remoteDocumentCache.getEntries(e, t).next((t)=>this.getLocalViewOfDocuments(e, t, $63c47e8a587a7f36$export$971d5caa766a69d7()).next(()=>t));
    }
    /**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     *
     * @param transaction - The transaction this operation is scoped to.
     * @param docs - The documents to apply local mutations to get the local views.
     * @param existenceStateChanged - The set of document keys whose existence state
     *   is changed. This is useful to determine if some documents overlay needs
     *   to be recalculated.
     */ getLocalViewOfDocuments(e, t, n = $63c47e8a587a7f36$export$971d5caa766a69d7()) {
        const r = $63c47e8a587a7f36$var$__PRIVATE_newOverlayMap();
        return this.populateOverlays(e, r, t).next(()=>this.computeViews(e, t, r, n).next((e)=>{
                let t = $63c47e8a587a7f36$var$documentMap();
                return e.forEach((e, n)=>{
                    t = t.insert(e, n.overlayedDocument);
                }), t;
            }));
    }
    /**
     * Gets the overlayed documents for the given document map, which will include
     * the local view of those documents and a `FieldMask` indicating which fields
     * are mutated locally, `null` if overlay is a Set or Delete mutation.
     */ getOverlayedDocuments(e, t) {
        const n = $63c47e8a587a7f36$var$__PRIVATE_newOverlayMap();
        return this.populateOverlays(e, n, t).next(()=>this.computeViews(e, t, n, $63c47e8a587a7f36$export$971d5caa766a69d7()));
    }
    /**
     * Fetches the overlays for {@code docs} and adds them to provided overlay map
     * if the map does not already contain an entry for the given document key.
     */ populateOverlays(e, t, n) {
        const r = [];
        return n.forEach((e)=>{
            t.has(e) || r.push(e);
        }), this.documentOverlayCache.getOverlays(e, r).next((e)=>{
            e.forEach((e, n)=>{
                t.set(e, n);
            });
        });
    }
    /**
     * Computes the local view for the given documents.
     *
     * @param docs - The documents to compute views for. It also has the base
     *   version of the documents.
     * @param overlays - The overlays that need to be applied to the given base
     *   version of the documents.
     * @param existenceStateChanged - A set of documents whose existence states
     *   might have changed. This is used to determine if we need to re-calculate
     *   overlays from mutation queues.
     * @returns A map represents the local documents view.
     */ computeViews(e, t, n, r) {
        let i = $63c47e8a587a7f36$var$__PRIVATE_mutableDocumentMap();
        const s = $63c47e8a587a7f36$var$__PRIVATE_newDocumentKeyMap(), o = function __PRIVATE_newOverlayedDocumentMap() {
            return $63c47e8a587a7f36$var$__PRIVATE_newDocumentKeyMap();
        }();
        return t.forEach((e, t)=>{
            const o = n.get(t.key);
            // Recalculate an overlay if the document's existence state changed due to
            // a remote event *and* the overlay is a PatchMutation. This is because
            // document existence state can change if some patch mutation's
            // preconditions are met.
            // NOTE: we recalculate when `overlay` is undefined as well, because there
            // might be a patch mutation whose precondition does not match before the
            // change (hence overlay is undefined), but would now match.
            r.has(t.key) && (void 0 === o || o.mutation instanceof $63c47e8a587a7f36$var$__PRIVATE_PatchMutation) ? i = i.insert(t.key, t) : void 0 !== o ? (s.set(t.key, o.mutation.getFieldMask()), $63c47e8a587a7f36$var$__PRIVATE_mutationApplyToLocalView(o.mutation, t, o.mutation.getFieldMask(), $63c47e8a587a7f36$export$3d12bd131bb975d1.now())) : // no overlay exists
            // Using EMPTY to indicate there is no overlay for the document.
            s.set(t.key, $63c47e8a587a7f36$var$FieldMask.empty());
        }), this.recalculateAndSaveOverlays(e, i).next((e)=>(e.forEach((e, t)=>s.set(e, t)), t.forEach((e, t)=>o.set(e, new $63c47e8a587a7f36$var$OverlayedDocument(t, s.get(e) ?? null))), o));
    }
    recalculateAndSaveOverlays(e, t) {
        const n = $63c47e8a587a7f36$var$__PRIVATE_newDocumentKeyMap();
        // A reverse lookup map from batch id to the documents within that batch.
        let r = new $63c47e8a587a7f36$var$SortedMap((e, t)=>e - t), i = $63c47e8a587a7f36$export$971d5caa766a69d7();
        return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(e, t).next((e)=>{
            for (const i of e)i.keys().forEach((e)=>{
                const s = t.get(e);
                if (null === s) return;
                let o = n.get(e) || $63c47e8a587a7f36$var$FieldMask.empty();
                o = i.applyToLocalView(s, o), n.set(e, o);
                const _ = (r.get(i.batchId) || $63c47e8a587a7f36$export$971d5caa766a69d7()).add(e);
                r = r.insert(i.batchId, _);
            });
        }).next(()=>{
            const s = [], o = r.getReverseIterator();
            // Iterate in descending order of batch IDs, and skip documents that are
            // already saved.
            for(; o.hasNext();){
                const r = o.getNext(), _ = r.key, a = r.value, u = $63c47e8a587a7f36$var$__PRIVATE_newMutationMap();
                a.forEach((e)=>{
                    if (!i.has(e)) {
                        const r = $63c47e8a587a7f36$var$__PRIVATE_calculateOverlayMutation(t.get(e), n.get(e));
                        null !== r && u.set(e, r), i = i.add(e);
                    }
                }), s.push(this.documentOverlayCache.saveOverlays(e, _, u));
            }
            return $63c47e8a587a7f36$var$PersistencePromise.waitFor(s);
        }).next(()=>n);
    }
    /**
     * Recalculates overlays by reading the documents from remote document cache
     * first, and saves them after they are calculated.
     */ recalculateAndSaveOverlaysForDocumentKeys(e, t) {
        return this.remoteDocumentCache.getEntries(e, t).next((t)=>this.recalculateAndSaveOverlays(e, t));
    }
    /**
     * Performs a query against the local view of all documents.
     *
     * @param transaction - The persistence transaction.
     * @param query - The query to match documents against.
     * @param offset - Read time and key to start scanning by (exclusive).
     * @param context - A optional tracker to keep a record of important details
     *   during database local query execution.
     */ getDocumentsMatchingQuery(e, t, n, r) {
        return $63c47e8a587a7f36$export$51b138e5a065c2bb(t) ? this.getDocumentsMatchingDocumentQuery(e, t.path) : $63c47e8a587a7f36$export$3b14a55fb2447963(t) ? this.getDocumentsMatchingCollectionGroupQuery(e, t, n, r) : this.getDocumentsMatchingCollectionQuery(e, t, n, r);
    }
    /**
     * Given a collection group, returns the next documents that follow the provided offset, along
     * with an updated batch ID.
     *
     * <p>The documents returned by this method are ordered by remote version from the provided
     * offset. If there are no more remote documents after the provided offset, documents with
     * mutations in order of batch id from the offset are returned. Since all documents in a batch are
     * returned together, the total number of documents returned can exceed {@code count}.
     *
     * @param transaction
     * @param collectionGroup - The collection group for the documents.
     * @param offset - The offset to index into.
     * @param count - The number of documents to return
     * @returns A LocalWriteResult with the documents that follow the provided offset and the last processed batch id.
     */ getNextDocuments(e, t, n, r) {
        return this.remoteDocumentCache.getAllFromCollectionGroup(e, t, n, r).next((i)=>{
            const s = r - i.size > 0 ? this.documentOverlayCache.getOverlaysForCollectionGroup(e, t, n.largestBatchId, r - i.size) : $63c47e8a587a7f36$var$PersistencePromise.resolve($63c47e8a587a7f36$var$__PRIVATE_newOverlayMap());
            // The callsite will use the largest batch ID together with the latest read time to create
            // a new index offset. Since we only process batch IDs if all remote documents have been read,
            // no overlay will increase the overall read time. This is why we only need to special case
            // the batch id.
            let o = $63c47e8a587a7f36$var$B, _ = i;
            return s.next((t)=>$63c47e8a587a7f36$var$PersistencePromise.forEach(t, (t, n)=>(o < n.largestBatchId && (o = n.largestBatchId), i.get(t) ? $63c47e8a587a7f36$var$PersistencePromise.resolve() : this.remoteDocumentCache.getEntry(e, t).next((e)=>{
                        _ = _.insert(t, e);
                    }))).next(()=>this.populateOverlays(e, t, i)).next(()=>this.computeViews(e, _, t, $63c47e8a587a7f36$export$971d5caa766a69d7())).next((e)=>({
                        batchId: o,
                        changes: $63c47e8a587a7f36$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(e)
                    })));
        });
    }
    getDocumentsMatchingDocumentQuery(e, t) {
        // Just do a simple document lookup.
        return this.getDocument(e, new $63c47e8a587a7f36$export$90a7f3efeed30595(t)).next((e)=>{
            let t = $63c47e8a587a7f36$var$documentMap();
            return e.isFoundDocument() && (t = t.insert(e.key, e)), t;
        });
    }
    getDocumentsMatchingCollectionGroupQuery(e, t, n, r) {
        const i = t.collectionGroup;
        let s = $63c47e8a587a7f36$var$documentMap();
        return this.indexManager.getCollectionParents(e, i).next((o)=>$63c47e8a587a7f36$var$PersistencePromise.forEach(o, (o)=>{
                const _ = function __PRIVATE_asCollectionQueryAtPath(e, t) {
                    return new $63c47e8a587a7f36$var$__PRIVATE_QueryImpl(t, /*collectionGroup=*/ null, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
                }(t, o.child(i));
                return this.getDocumentsMatchingCollectionQuery(e, _, n, r).next((e)=>{
                    e.forEach((e, t)=>{
                        s = s.insert(e, t);
                    });
                });
            }).next(()=>s));
    }
    getDocumentsMatchingCollectionQuery(e, t, n, r) {
        // Query the remote documents and overlay mutations.
        let i;
        return this.documentOverlayCache.getOverlaysForCollection(e, t.path, n.largestBatchId).next((s)=>(i = s, this.remoteDocumentCache.getDocumentsMatchingQuery(e, t, n, i, r))).next((e)=>{
            // As documents might match the query because of their overlay we need to
            // include documents for all overlays in the initial document set.
            i.forEach((t, n)=>{
                const r = n.getKey();
                null === e.get(r) && (e = e.insert(r, $63c47e8a587a7f36$var$MutableDocument.newInvalidDocument(r)));
            });
            // Apply the overlays and match against the query.
            let n = $63c47e8a587a7f36$var$documentMap();
            return e.forEach((e, r)=>{
                const s = i.get(e);
                void 0 !== s && $63c47e8a587a7f36$var$__PRIVATE_mutationApplyToLocalView(s.mutation, r, $63c47e8a587a7f36$var$FieldMask.empty(), $63c47e8a587a7f36$export$3d12bd131bb975d1.now()), // Finally, insert the documents that still match the query
                $63c47e8a587a7f36$var$__PRIVATE_queryMatches(t, r) && (n = n.insert(e, r));
            }), n;
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $63c47e8a587a7f36$var$__PRIVATE_MemoryBundleCache {
    constructor(e){
        this.serializer = e, this.Nr = new Map, this.Br = new Map;
    }
    getBundleMetadata(e, t) {
        return $63c47e8a587a7f36$var$PersistencePromise.resolve(this.Nr.get(t));
    }
    saveBundleMetadata(e, t) {
        return this.Nr.set(t.id, /** Decodes a BundleMetadata proto into a BundleMetadata object. */ function __PRIVATE_fromBundleMetadata(e) {
            return {
                id: e.id,
                version: e.version,
                createTime: $63c47e8a587a7f36$var$__PRIVATE_fromVersion(e.createTime)
            };
        }(t)), $63c47e8a587a7f36$var$PersistencePromise.resolve();
    }
    getNamedQuery(e, t) {
        return $63c47e8a587a7f36$var$PersistencePromise.resolve(this.Br.get(t));
    }
    saveNamedQuery(e, t) {
        return this.Br.set(t.name, function __PRIVATE_fromProtoNamedQuery(e) {
            return {
                name: e.name,
                query: $63c47e8a587a7f36$export$56c0d5a1e737357d(e.bundledQuery),
                readTime: $63c47e8a587a7f36$var$__PRIVATE_fromVersion(e.readTime)
            };
        }(t)), $63c47e8a587a7f36$var$PersistencePromise.resolve();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of DocumentOverlayCache.
 */ class $63c47e8a587a7f36$var$__PRIVATE_MemoryDocumentOverlayCache {
    constructor(){
        // A map sorted by DocumentKey, whose value is a pair of the largest batch id
        // for the overlay and the overlay itself.
        this.overlays = new $63c47e8a587a7f36$var$SortedMap($63c47e8a587a7f36$export$90a7f3efeed30595.comparator), this.Lr = new Map;
    }
    getOverlay(e, t) {
        return $63c47e8a587a7f36$var$PersistencePromise.resolve(this.overlays.get(t));
    }
    getOverlays(e, t) {
        const n = $63c47e8a587a7f36$var$__PRIVATE_newOverlayMap();
        return $63c47e8a587a7f36$var$PersistencePromise.forEach(t, (t)=>this.getOverlay(e, t).next((e)=>{
                null !== e && n.set(t, e);
            })).next(()=>n);
    }
    saveOverlays(e, t, n) {
        return n.forEach((n, r)=>{
            this.bt(e, t, r);
        }), $63c47e8a587a7f36$var$PersistencePromise.resolve();
    }
    removeOverlaysForBatchId(e, t, n) {
        const r = this.Lr.get(n);
        return void 0 !== r && (r.forEach((e)=>this.overlays = this.overlays.remove(e)), this.Lr.delete(n)), $63c47e8a587a7f36$var$PersistencePromise.resolve();
    }
    getOverlaysForCollection(e, t, n) {
        const r = $63c47e8a587a7f36$var$__PRIVATE_newOverlayMap(), i = t.length + 1, s = new $63c47e8a587a7f36$export$90a7f3efeed30595(t.child("")), o = this.overlays.getIteratorFrom(s);
        for(; o.hasNext();){
            const e = o.getNext().value, s = e.getKey();
            if (!t.isPrefixOf(s.path)) break;
            // Documents from sub-collections
            s.path.length === i && e.largestBatchId > n && r.set(e.getKey(), e);
        }
        return $63c47e8a587a7f36$var$PersistencePromise.resolve(r);
    }
    getOverlaysForCollectionGroup(e, t, n, r) {
        let i = new $63c47e8a587a7f36$var$SortedMap((e, t)=>e - t);
        const s = this.overlays.getIterator();
        for(; s.hasNext();){
            const e = s.getNext().value;
            if (e.getKey().getCollectionGroup() === t && e.largestBatchId > n) {
                let t = i.get(e.largestBatchId);
                null === t && (t = $63c47e8a587a7f36$var$__PRIVATE_newOverlayMap(), i = i.insert(e.largestBatchId, t)), t.set(e.getKey(), e);
            }
        }
        const o = $63c47e8a587a7f36$var$__PRIVATE_newOverlayMap(), _ = i.getIterator();
        for(; _.hasNext();){
            if (_.getNext().value.forEach((e, t)=>o.set(e, t)), o.size() >= r) break;
        }
        return $63c47e8a587a7f36$var$PersistencePromise.resolve(o);
    }
    bt(e, t, n) {
        // Remove the association of the overlay to its batch id.
        const r = this.overlays.get(n.key);
        if (null !== r) {
            const e = this.Lr.get(r.largestBatchId).delete(n.key);
            this.Lr.set(r.largestBatchId, e);
        }
        this.overlays = this.overlays.insert(n.key, new $63c47e8a587a7f36$var$Overlay(t, n));
        // Create the association of this overlay to the given largestBatchId.
        let i = this.Lr.get(t);
        void 0 === i && (i = $63c47e8a587a7f36$export$971d5caa766a69d7(), this.Lr.set(t, i)), this.Lr.set(t, i.add(n.key));
    }
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $63c47e8a587a7f36$var$__PRIVATE_MemoryGlobalsCache {
    constructor(){
        this.sessionToken = $63c47e8a587a7f36$export$9d398bebfec1c039.EMPTY_BYTE_STRING;
    }
    getSessionToken(e) {
        return $63c47e8a587a7f36$var$PersistencePromise.resolve(this.sessionToken);
    }
    setSessionToken(e, t) {
        return this.sessionToken = t, $63c47e8a587a7f36$var$PersistencePromise.resolve();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */ class $63c47e8a587a7f36$var$__PRIVATE_ReferenceSet {
    constructor(){
        // A set of outstanding references to a document sorted by key.
        this.kr = new $63c47e8a587a7f36$var$SortedSet($63c47e8a587a7f36$var$__PRIVATE_DocReference.Kr), // A set of outstanding references to a document sorted by target id.
        this.qr = new $63c47e8a587a7f36$var$SortedSet($63c47e8a587a7f36$var$__PRIVATE_DocReference.Ur);
    }
    /** Returns true if the reference set contains no references. */ isEmpty() {
        return this.kr.isEmpty();
    }
    /** Adds a reference to the given document key for the given ID. */ addReference(e, t) {
        const n = new $63c47e8a587a7f36$var$__PRIVATE_DocReference(e, t);
        this.kr = this.kr.add(n), this.qr = this.qr.add(n);
    }
    /** Add references to the given document keys for the given ID. */ $r(e, t) {
        e.forEach((e)=>this.addReference(e, t));
    }
    /**
     * Removes a reference to the given document key for the given
     * ID.
     */ removeReference(e, t) {
        this.Wr(new $63c47e8a587a7f36$var$__PRIVATE_DocReference(e, t));
    }
    Qr(e, t) {
        e.forEach((e)=>this.removeReference(e, t));
    }
    /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */ Gr(e) {
        const t = new $63c47e8a587a7f36$export$90a7f3efeed30595(new $63c47e8a587a7f36$export$db202ddc8be9136([])), n = new $63c47e8a587a7f36$var$__PRIVATE_DocReference(t, e), r = new $63c47e8a587a7f36$var$__PRIVATE_DocReference(t, e + 1), i = [];
        return this.qr.forEachInRange([
            n,
            r
        ], (e)=>{
            this.Wr(e), i.push(e.key);
        }), i;
    }
    zr() {
        this.kr.forEach((e)=>this.Wr(e));
    }
    Wr(e) {
        this.kr = this.kr.delete(e), this.qr = this.qr.delete(e);
    }
    jr(e) {
        const t = new $63c47e8a587a7f36$export$90a7f3efeed30595(new $63c47e8a587a7f36$export$db202ddc8be9136([])), n = new $63c47e8a587a7f36$var$__PRIVATE_DocReference(t, e), r = new $63c47e8a587a7f36$var$__PRIVATE_DocReference(t, e + 1);
        let i = $63c47e8a587a7f36$export$971d5caa766a69d7();
        return this.qr.forEachInRange([
            n,
            r
        ], (e)=>{
            i = i.add(e.key);
        }), i;
    }
    containsKey(e) {
        const t = new $63c47e8a587a7f36$var$__PRIVATE_DocReference(e, 0), n = this.kr.firstAfterOrEqual(t);
        return null !== n && e.isEqual(n.key);
    }
}
class $63c47e8a587a7f36$var$__PRIVATE_DocReference {
    constructor(e, t){
        this.key = e, this.Hr = t;
    }
    /** Compare by key then by ID */ static Kr(e, t) {
        return $63c47e8a587a7f36$export$90a7f3efeed30595.comparator(e.key, t.key) || $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(e.Hr, t.Hr);
    }
    /** Compare by ID then by key */ static Ur(e, t) {
        return $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(e.Hr, t.Hr) || $63c47e8a587a7f36$export$90a7f3efeed30595.comparator(e.key, t.key);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $63c47e8a587a7f36$var$__PRIVATE_MemoryMutationQueue {
    constructor(e, t){
        this.indexManager = e, this.referenceDelegate = t, /**
         * The set of all mutations that have been sent but not yet been applied to
         * the backend.
         */ this.mutationQueue = [], /** Next value to use when assigning sequential IDs to each mutation batch. */ this.Yn = 1, /** An ordered mapping between documents and the mutations batch IDs. */ this.Jr = new $63c47e8a587a7f36$var$SortedSet($63c47e8a587a7f36$var$__PRIVATE_DocReference.Kr);
    }
    checkEmpty(e) {
        return $63c47e8a587a7f36$var$PersistencePromise.resolve(0 === this.mutationQueue.length);
    }
    addMutationBatch(e, t, n, r) {
        const i = this.Yn;
        this.Yn++, this.mutationQueue.length > 0 && this.mutationQueue[this.mutationQueue.length - 1];
        const s = new $63c47e8a587a7f36$var$MutationBatch(i, t, n, r);
        this.mutationQueue.push(s);
        // Track references by document key and index collection parents.
        for (const t of r)this.Jr = this.Jr.add(new $63c47e8a587a7f36$var$__PRIVATE_DocReference(t.key, i)), this.indexManager.addToCollectionParentIndex(e, t.key.path.popLast());
        return $63c47e8a587a7f36$var$PersistencePromise.resolve(s);
    }
    lookupMutationBatch(e, t) {
        return $63c47e8a587a7f36$var$PersistencePromise.resolve(this.Zr(t));
    }
    getNextMutationBatchAfterBatchId(e, t) {
        const n = t + 1, r = this.Xr(n), i = r < 0 ? 0 : r;
        // The requested batchId may still be out of range so normalize it to the
        // start of the queue.
        return $63c47e8a587a7f36$var$PersistencePromise.resolve(this.mutationQueue.length > i ? this.mutationQueue[i] : null);
    }
    getHighestUnacknowledgedBatchId() {
        return $63c47e8a587a7f36$var$PersistencePromise.resolve(0 === this.mutationQueue.length ? $63c47e8a587a7f36$var$U : this.Yn - 1);
    }
    getAllMutationBatches(e) {
        return $63c47e8a587a7f36$var$PersistencePromise.resolve(this.mutationQueue.slice());
    }
    getAllMutationBatchesAffectingDocumentKey(e, t) {
        const n = new $63c47e8a587a7f36$var$__PRIVATE_DocReference(t, 0), r = new $63c47e8a587a7f36$var$__PRIVATE_DocReference(t, Number.POSITIVE_INFINITY), i = [];
        return this.Jr.forEachInRange([
            n,
            r
        ], (e)=>{
            const t = this.Zr(e.Hr);
            i.push(t);
        }), $63c47e8a587a7f36$var$PersistencePromise.resolve(i);
    }
    getAllMutationBatchesAffectingDocumentKeys(e, t) {
        let n = new $63c47e8a587a7f36$var$SortedSet($63c47e8a587a7f36$var$__PRIVATE_primitiveComparator);
        return t.forEach((e)=>{
            const t = new $63c47e8a587a7f36$var$__PRIVATE_DocReference(e, 0), r = new $63c47e8a587a7f36$var$__PRIVATE_DocReference(e, Number.POSITIVE_INFINITY);
            this.Jr.forEachInRange([
                t,
                r
            ], (e)=>{
                n = n.add(e.Hr);
            });
        }), $63c47e8a587a7f36$var$PersistencePromise.resolve(this.Yr(n));
    }
    getAllMutationBatchesAffectingQuery(e, t) {
        // Use the query path as a prefix for testing if a document matches the
        // query.
        const n = t.path, r = n.length + 1;
        // Construct a document reference for actually scanning the index. Unlike
        // the prefix the document key in this reference must have an even number of
        // segments. The empty segment can be used a suffix of the query path
        // because it precedes all other segments in an ordered traversal.
        let i = n;
        $63c47e8a587a7f36$export$90a7f3efeed30595.isDocumentKey(i) || (i = i.child(""));
        const s = new $63c47e8a587a7f36$var$__PRIVATE_DocReference(new $63c47e8a587a7f36$export$90a7f3efeed30595(i), 0);
        // Find unique batchIDs referenced by all documents potentially matching the
        // query.
        let o = new $63c47e8a587a7f36$var$SortedSet($63c47e8a587a7f36$var$__PRIVATE_primitiveComparator);
        return this.Jr.forEachWhile((e)=>{
            const t = e.key.path;
            return !!n.isPrefixOf(t) && // Rows with document keys more than one segment longer than the query
            // path can't be matches. For example, a query on 'rooms' can't match
            // the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            (t.length === r && (o = o.add(e.Hr)), !0);
        }, s), $63c47e8a587a7f36$var$PersistencePromise.resolve(this.Yr(o));
    }
    Yr(e) {
        // Construct an array of matching batches, sorted by batchID to ensure that
        // multiple mutations affecting the same document key are applied in order.
        const t = [];
        return e.forEach((e)=>{
            const n = this.Zr(e);
            null !== n && t.push(n);
        }), t;
    }
    removeMutationBatch(e, t) {
        $63c47e8a587a7f36$export$c18d01048907ea92(0 === this.ei(t.batchId, "removed"), 55003), this.mutationQueue.shift();
        let n = this.Jr;
        return $63c47e8a587a7f36$var$PersistencePromise.forEach(t.mutations, (r)=>{
            const i = new $63c47e8a587a7f36$var$__PRIVATE_DocReference(r.key, t.batchId);
            return n = n.delete(i), this.referenceDelegate.markPotentiallyOrphaned(e, r.key);
        }).next(()=>{
            this.Jr = n;
        });
    }
    nr(e) {
    // No-op since the memory mutation queue does not maintain a separate cache.
    }
    containsKey(e, t) {
        const n = new $63c47e8a587a7f36$var$__PRIVATE_DocReference(t, 0), r = this.Jr.firstAfterOrEqual(n);
        return $63c47e8a587a7f36$var$PersistencePromise.resolve(t.isEqual(r && r.key));
    }
    performConsistencyCheck(e) {
        return this.mutationQueue.length, $63c47e8a587a7f36$var$PersistencePromise.resolve();
    }
    /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId - The batchId to search for
     * @param action - A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */ ei(e, t) {
        return this.Xr(e);
    }
    /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @returns The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been removed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */ Xr(e) {
        if (0 === this.mutationQueue.length) // As an index this is past the end of the queue
        return 0;
        // Examine the front of the queue to figure out the difference between the
        // batchId and indexes in the array. Note that since the queue is ordered
        // by batchId, if the first batch has a larger batchId then the requested
        // batchId doesn't exist in the queue.
        return e - this.mutationQueue[0].batchId;
    }
    /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficient.
     */ Zr(e) {
        const t = this.Xr(e);
        if (t < 0 || t >= this.mutationQueue.length) return null;
        return this.mutationQueue[t];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The smallest value representable by a 64-bit signed integer (long).
 */ /**
 * The memory-only RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newMemoryRemoteDocumentCache()`.
 */ class $63c47e8a587a7f36$var$__PRIVATE_MemoryRemoteDocumentCacheImpl {
    /**
     * @param sizer - Used to assess the size of a document. For eager GC, this is
     * expected to just return 0 to avoid unnecessarily doing the work of
     * calculating the size.
     */ constructor(e){
        this.ti = e, /** Underlying cache of documents and their read times. */ this.docs = function __PRIVATE_documentEntryMap() {
            return new $63c47e8a587a7f36$var$SortedMap($63c47e8a587a7f36$export$90a7f3efeed30595.comparator);
        }(), /** Size of all cached documents. */ this.size = 0;
    }
    setIndexManager(e) {
        this.indexManager = e;
    }
    /**
     * Adds the supplied entry to the cache and updates the cache size as appropriate.
     *
     * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ addEntry(e, t) {
        const n = t.key, r = this.docs.get(n), i = r ? r.size : 0, s = this.ti(t);
        return this.docs = this.docs.insert(n, {
            document: t.mutableCopy(),
            size: s
        }), this.size += s - i, this.indexManager.addToCollectionParentIndex(e, n.path.popLast());
    }
    /**
     * Removes the specified entry from the cache and updates the cache size as appropriate.
     *
     * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ removeEntry(e) {
        const t = this.docs.get(e);
        t && (this.docs = this.docs.remove(e), this.size -= t.size);
    }
    getEntry(e, t) {
        const n = this.docs.get(t);
        return $63c47e8a587a7f36$var$PersistencePromise.resolve(n ? n.document.mutableCopy() : $63c47e8a587a7f36$var$MutableDocument.newInvalidDocument(t));
    }
    getEntries(e, t) {
        let n = $63c47e8a587a7f36$var$__PRIVATE_mutableDocumentMap();
        return t.forEach((e)=>{
            const t = this.docs.get(e);
            n = n.insert(e, t ? t.document.mutableCopy() : $63c47e8a587a7f36$var$MutableDocument.newInvalidDocument(e));
        }), $63c47e8a587a7f36$var$PersistencePromise.resolve(n);
    }
    getDocumentsMatchingQuery(e, t, n, r) {
        let i = $63c47e8a587a7f36$var$__PRIVATE_mutableDocumentMap();
        // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        const s = t.path, o = new $63c47e8a587a7f36$export$90a7f3efeed30595(s.child("__id-9223372036854775808__")), _ = this.docs.getIteratorFrom(o);
        // Document keys are ordered first by numeric value ("__id<Long>__"),
        // then lexicographically by string value. Start the iterator at the minimum
        // possible Document key value.
        for(; _.hasNext();){
            const { key: e, value: { document: o } } = _.getNext();
            if (!s.isPrefixOf(e.path)) break;
            e.path.length > s.length + 1 || $63c47e8a587a7f36$var$__PRIVATE_indexOffsetComparator($63c47e8a587a7f36$var$__PRIVATE_newIndexOffsetFromDocument(o), n) <= 0 || (r.has(o.key) || $63c47e8a587a7f36$var$__PRIVATE_queryMatches(t, o)) && (i = i.insert(o.key, o.mutableCopy()));
        }
        return $63c47e8a587a7f36$var$PersistencePromise.resolve(i);
    }
    getAllFromCollectionGroup(e, t, n, r) {
        // This method should only be called from the IndexBackfiller if persistence
        // is enabled.
        $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(9500);
    }
    ni(e, t) {
        return $63c47e8a587a7f36$var$PersistencePromise.forEach(this.docs, (e)=>t(e));
    }
    newChangeBuffer(e) {
        // `trackRemovals` is ignores since the MemoryRemoteDocumentCache keeps
        // a separate changelog and does not need special handling for removals.
        return new $63c47e8a587a7f36$var$__PRIVATE_MemoryRemoteDocumentChangeBuffer(this);
    }
    getSize(e) {
        return $63c47e8a587a7f36$var$PersistencePromise.resolve(this.size);
    }
}
/**
 * Creates a new memory-only RemoteDocumentCache.
 *
 * @param sizer - Used to assess the size of a document. For eager GC, this is
 * expected to just return 0 to avoid unnecessarily doing the work of
 * calculating the size.
 */ /**
 * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
 */ class $63c47e8a587a7f36$var$__PRIVATE_MemoryRemoteDocumentChangeBuffer extends $63c47e8a587a7f36$var$RemoteDocumentChangeBuffer {
    constructor(e){
        super(), this.Mr = e;
    }
    applyChanges(e) {
        const t = [];
        return this.changes.forEach((n, r)=>{
            r.isValidDocument() ? t.push(this.Mr.addEntry(e, r)) : this.Mr.removeEntry(n);
        }), $63c47e8a587a7f36$var$PersistencePromise.waitFor(t);
    }
    getFromCache(e, t) {
        return this.Mr.getEntry(e, t);
    }
    getAllFromCache(e, t) {
        return this.Mr.getEntries(e, t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $63c47e8a587a7f36$var$__PRIVATE_MemoryTargetCache {
    constructor(e){
        this.persistence = e, /**
         * Maps a target to the data about that target
         */ this.ri = new $63c47e8a587a7f36$var$ObjectMap((e)=>$63c47e8a587a7f36$var$__PRIVATE_canonifyTarget(e), $63c47e8a587a7f36$var$__PRIVATE_targetEquals), /** The last received snapshot version. */ this.lastRemoteSnapshotVersion = $63c47e8a587a7f36$var$SnapshotVersion.min(), /** The highest numbered target ID encountered. */ this.highestTargetId = 0, /** The highest sequence number encountered. */ this.ii = 0, /**
         * A ordered bidirectional mapping between documents and the remote target
         * IDs.
         */ this.si = new $63c47e8a587a7f36$var$__PRIVATE_ReferenceSet, this.targetCount = 0, this.oi = $63c47e8a587a7f36$var$__PRIVATE_TargetIdGenerator._r();
    }
    forEachTarget(e, t) {
        return this.ri.forEach((e, n)=>t(n)), $63c47e8a587a7f36$var$PersistencePromise.resolve();
    }
    getLastRemoteSnapshotVersion(e) {
        return $63c47e8a587a7f36$var$PersistencePromise.resolve(this.lastRemoteSnapshotVersion);
    }
    getHighestSequenceNumber(e) {
        return $63c47e8a587a7f36$var$PersistencePromise.resolve(this.ii);
    }
    allocateTargetId(e) {
        return this.highestTargetId = this.oi.next(), $63c47e8a587a7f36$var$PersistencePromise.resolve(this.highestTargetId);
    }
    setTargetsMetadata(e, t, n) {
        return n && (this.lastRemoteSnapshotVersion = n), t > this.ii && (this.ii = t), $63c47e8a587a7f36$var$PersistencePromise.resolve();
    }
    lr(e) {
        this.ri.set(e.target, e);
        const t = e.targetId;
        t > this.highestTargetId && (this.oi = new $63c47e8a587a7f36$var$__PRIVATE_TargetIdGenerator(t), this.highestTargetId = t), e.sequenceNumber > this.ii && (this.ii = e.sequenceNumber);
    }
    addTargetData(e, t) {
        return this.lr(t), this.targetCount += 1, $63c47e8a587a7f36$var$PersistencePromise.resolve();
    }
    updateTargetData(e, t) {
        return this.lr(t), $63c47e8a587a7f36$var$PersistencePromise.resolve();
    }
    removeTargetData(e, t) {
        return this.ri.delete(t.target), this.si.Gr(t.targetId), this.targetCount -= 1, $63c47e8a587a7f36$var$PersistencePromise.resolve();
    }
    removeTargets(e, t, n) {
        let r = 0;
        const i = [];
        return this.ri.forEach((s, o)=>{
            o.sequenceNumber <= t && null === n.get(o.targetId) && (this.ri.delete(s), i.push(this.removeMatchingKeysForTargetId(e, o.targetId)), r++);
        }), $63c47e8a587a7f36$var$PersistencePromise.waitFor(i).next(()=>r);
    }
    getTargetCount(e) {
        return $63c47e8a587a7f36$var$PersistencePromise.resolve(this.targetCount);
    }
    getTargetData(e, t) {
        const n = this.ri.get(t) || null;
        return $63c47e8a587a7f36$var$PersistencePromise.resolve(n);
    }
    addMatchingKeys(e, t, n) {
        return this.si.$r(t, n), $63c47e8a587a7f36$var$PersistencePromise.resolve();
    }
    removeMatchingKeys(e, t, n) {
        this.si.Qr(t, n);
        const r = this.persistence.referenceDelegate, i = [];
        return r && t.forEach((t)=>{
            i.push(r.markPotentiallyOrphaned(e, t));
        }), $63c47e8a587a7f36$var$PersistencePromise.waitFor(i);
    }
    removeMatchingKeysForTargetId(e, t) {
        return this.si.Gr(t), $63c47e8a587a7f36$var$PersistencePromise.resolve();
    }
    getMatchingKeysForTargetId(e, t) {
        const n = this.si.jr(t);
        return $63c47e8a587a7f36$var$PersistencePromise.resolve(n);
    }
    containsKey(e, t) {
        return $63c47e8a587a7f36$var$PersistencePromise.resolve(this.si.containsKey(t));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */ class $63c47e8a587a7f36$var$__PRIVATE_MemoryPersistence {
    /**
     * The constructor accepts a factory for creating a reference delegate. This
     * allows both the delegate and this instance to have strong references to
     * each other without having nullable fields that would then need to be
     * checked or asserted on every access.
     */ constructor(e, t){
        this._i = {}, this.overlays = {}, this.ai = new $63c47e8a587a7f36$var$__PRIVATE_ListenSequence(0), this.ui = !1, this.ui = !0, this.ci = new $63c47e8a587a7f36$var$__PRIVATE_MemoryGlobalsCache, this.referenceDelegate = e(this), this.li = new $63c47e8a587a7f36$var$__PRIVATE_MemoryTargetCache(this);
        this.indexManager = new $63c47e8a587a7f36$var$__PRIVATE_MemoryIndexManager, this.remoteDocumentCache = function __PRIVATE_newMemoryRemoteDocumentCache(e) {
            return new $63c47e8a587a7f36$var$__PRIVATE_MemoryRemoteDocumentCacheImpl(e);
        }((e)=>this.referenceDelegate.hi(e)), this.serializer = new $63c47e8a587a7f36$var$__PRIVATE_LocalSerializer(t), this.Pi = new $63c47e8a587a7f36$var$__PRIVATE_MemoryBundleCache(this.serializer);
    }
    start() {
        return Promise.resolve();
    }
    shutdown() {
        // No durable state to ensure is closed on shutdown.
        return this.ui = !1, Promise.resolve();
    }
    get started() {
        return this.ui;
    }
    setDatabaseDeletedListener() {
    // No op.
    }
    setNetworkEnabled() {
    // No op.
    }
    getIndexManager(e) {
        // We do not currently support indices for memory persistence, so we can
        // return the same shared instance of the memory index manager.
        return this.indexManager;
    }
    getDocumentOverlayCache(e) {
        let t = this.overlays[e.toKey()];
        return t || (t = new $63c47e8a587a7f36$var$__PRIVATE_MemoryDocumentOverlayCache, this.overlays[e.toKey()] = t), t;
    }
    getMutationQueue(e, t) {
        let n = this._i[e.toKey()];
        return n || (n = new $63c47e8a587a7f36$var$__PRIVATE_MemoryMutationQueue(t, this.referenceDelegate), this._i[e.toKey()] = n), n;
    }
    getGlobalsCache() {
        return this.ci;
    }
    getTargetCache() {
        return this.li;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getBundleCache() {
        return this.Pi;
    }
    runTransaction(e, t, n) {
        $63c47e8a587a7f36$export$21579262ef46735b("MemoryPersistence", "Starting transaction:", e);
        const r = new $63c47e8a587a7f36$var$__PRIVATE_MemoryTransaction(this.ai.next());
        return this.referenceDelegate.Ti(), n(r).next((e)=>this.referenceDelegate.Ii(r).next(()=>e)).toPromise().then((e)=>(r.raiseOnCommittedEvent(), e));
    }
    Ei(e, t) {
        return $63c47e8a587a7f36$var$PersistencePromise.or(Object.values(this._i).map((n)=>()=>n.containsKey(e, t)));
    }
}
/**
 * Memory persistence is not actually transactional, but future implementations
 * may have transaction-scoped state.
 */ class $63c47e8a587a7f36$var$__PRIVATE_MemoryTransaction extends $63c47e8a587a7f36$var$PersistenceTransaction {
    constructor(e){
        super(), this.currentSequenceNumber = e;
    }
}
class $63c47e8a587a7f36$var$__PRIVATE_MemoryEagerDelegate {
    constructor(e){
        this.persistence = e, /** Tracks all documents that are active in Query views. */ this.Ri = new $63c47e8a587a7f36$var$__PRIVATE_ReferenceSet, /** The list of documents that are potentially GCed after each transaction. */ this.Ai = null;
    }
    static Vi(e) {
        return new $63c47e8a587a7f36$var$__PRIVATE_MemoryEagerDelegate(e);
    }
    get di() {
        if (this.Ai) return this.Ai;
        throw $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(60996);
    }
    addReference(e, t, n) {
        return this.Ri.addReference(n, t), this.di.delete(n.toString()), $63c47e8a587a7f36$var$PersistencePromise.resolve();
    }
    removeReference(e, t, n) {
        return this.Ri.removeReference(n, t), this.di.add(n.toString()), $63c47e8a587a7f36$var$PersistencePromise.resolve();
    }
    markPotentiallyOrphaned(e, t) {
        return this.di.add(t.toString()), $63c47e8a587a7f36$var$PersistencePromise.resolve();
    }
    removeTarget(e, t) {
        this.Ri.Gr(t.targetId).forEach((e)=>this.di.add(e.toString()));
        const n = this.persistence.getTargetCache();
        return n.getMatchingKeysForTargetId(e, t.targetId).next((e)=>{
            e.forEach((e)=>this.di.add(e.toString()));
        }).next(()=>n.removeTargetData(e, t));
    }
    Ti() {
        this.Ai = new Set;
    }
    Ii(e) {
        // Remove newly orphaned documents.
        const t = this.persistence.getRemoteDocumentCache().newChangeBuffer();
        return $63c47e8a587a7f36$var$PersistencePromise.forEach(this.di, (n)=>{
            const r = $63c47e8a587a7f36$export$90a7f3efeed30595.fromPath(n);
            return this.mi(e, r).next((e)=>{
                e || t.removeEntry(r, $63c47e8a587a7f36$var$SnapshotVersion.min());
            });
        }).next(()=>(this.Ai = null, t.apply(e)));
    }
    updateLimboDocument(e, t) {
        return this.mi(e, t).next((e)=>{
            e ? this.di.delete(t.toString()) : this.di.add(t.toString());
        });
    }
    hi(e) {
        // For eager GC, we don't care about the document size, there are no size thresholds.
        return 0;
    }
    mi(e, t) {
        return $63c47e8a587a7f36$var$PersistencePromise.or([
            ()=>$63c47e8a587a7f36$var$PersistencePromise.resolve(this.Ri.containsKey(t)),
            ()=>this.persistence.getTargetCache().containsKey(e, t),
            ()=>this.persistence.Ei(e, t)
        ]);
    }
}
class $63c47e8a587a7f36$var$__PRIVATE_MemoryLruDelegate {
    constructor(e, t){
        this.persistence = e, this.fi = new $63c47e8a587a7f36$var$ObjectMap((e)=>$63c47e8a587a7f36$var$__PRIVATE_encodeResourcePath(e.path), (e, t)=>e.isEqual(t)), this.garbageCollector = $63c47e8a587a7f36$var$__PRIVATE_newLruGarbageCollector(this, t);
    }
    static Vi(e, t) {
        return new $63c47e8a587a7f36$var$__PRIVATE_MemoryLruDelegate(e, t);
    }
    // No-ops, present so memory persistence doesn't have to care which delegate
    // it has.
    Ti() {}
    Ii(e) {
        return $63c47e8a587a7f36$var$PersistencePromise.resolve();
    }
    forEachTarget(e, t) {
        return this.persistence.getTargetCache().forEachTarget(e, t);
    }
    dr(e) {
        const t = this.pr(e);
        return this.persistence.getTargetCache().getTargetCount(e).next((e)=>t.next((t)=>e + t));
    }
    pr(e) {
        let t = 0;
        return this.mr(e, (e)=>{
            t++;
        }).next(()=>t);
    }
    mr(e, t) {
        return $63c47e8a587a7f36$var$PersistencePromise.forEach(this.fi, (n, r)=>this.wr(e, n, r).next((e)=>e ? $63c47e8a587a7f36$var$PersistencePromise.resolve() : t(r)));
    }
    removeTargets(e, t, n) {
        return this.persistence.getTargetCache().removeTargets(e, t, n);
    }
    removeOrphanedDocuments(e, t) {
        let n = 0;
        const r = this.persistence.getRemoteDocumentCache(), i = r.newChangeBuffer();
        return r.ni(e, (r)=>this.wr(e, r, t).next((e)=>{
                e || (n++, i.removeEntry(r, $63c47e8a587a7f36$var$SnapshotVersion.min()));
            })).next(()=>i.apply(e)).next(()=>n);
    }
    markPotentiallyOrphaned(e, t) {
        return this.fi.set(t, e.currentSequenceNumber), $63c47e8a587a7f36$var$PersistencePromise.resolve();
    }
    removeTarget(e, t) {
        const n = t.withSequenceNumber(e.currentSequenceNumber);
        return this.persistence.getTargetCache().updateTargetData(e, n);
    }
    addReference(e, t, n) {
        return this.fi.set(n, e.currentSequenceNumber), $63c47e8a587a7f36$var$PersistencePromise.resolve();
    }
    removeReference(e, t, n) {
        return this.fi.set(n, e.currentSequenceNumber), $63c47e8a587a7f36$var$PersistencePromise.resolve();
    }
    updateLimboDocument(e, t) {
        return this.fi.set(t, e.currentSequenceNumber), $63c47e8a587a7f36$var$PersistencePromise.resolve();
    }
    hi(e) {
        let t = e.key.toString().length;
        return e.isFoundDocument() && (t += $63c47e8a587a7f36$var$__PRIVATE_estimateByteSize(e.data.value)), t;
    }
    wr(e, t, n) {
        return $63c47e8a587a7f36$var$PersistencePromise.or([
            ()=>this.persistence.Ei(e, t),
            ()=>this.persistence.getTargetCache().containsKey(e, t),
            ()=>{
                const e = this.fi.get(t);
                return $63c47e8a587a7f36$var$PersistencePromise.resolve(void 0 !== e && e > n);
            }
        ]);
    }
    getCacheSize(e) {
        return this.persistence.getRemoteDocumentCache().getSize(e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Performs database creation and schema upgrades. */ class $63c47e8a587a7f36$var$__PRIVATE_SchemaConverter {
    constructor(e){
        this.serializer = e;
    }
    /**
     * Performs database creation and schema upgrades.
     *
     * Note that in production, this method is only ever used to upgrade the schema
     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
     * and local feature development.
     */ k(e, t, n, r) {
        const i = new $63c47e8a587a7f36$var$__PRIVATE_SimpleDbTransaction("createOrUpgrade", t);
        n < 1 && r >= 1 && (!function __PRIVATE_createPrimaryClientStore(e) {
            e.createObjectStore($63c47e8a587a7f36$var$Q);
        }(e), function __PRIVATE_createMutationQueue(e) {
            e.createObjectStore($63c47e8a587a7f36$var$z, {
                keyPath: $63c47e8a587a7f36$var$j
            });
            const t = e.createObjectStore($63c47e8a587a7f36$var$H, {
                keyPath: $63c47e8a587a7f36$var$J,
                autoIncrement: !0
            });
            t.createIndex($63c47e8a587a7f36$var$Z, $63c47e8a587a7f36$var$X, {
                unique: !0
            }), e.createObjectStore($63c47e8a587a7f36$var$ee);
        }(e), $63c47e8a587a7f36$var$__PRIVATE_createQueryCache(e), function __PRIVATE_createLegacyRemoteDocumentCache(e) {
            e.createObjectStore($63c47e8a587a7f36$var$W);
        }(e));
        // Migration 2 to populate the targetGlobal object no longer needed since
        // migration 3 unconditionally clears it.
        let s = $63c47e8a587a7f36$var$PersistencePromise.resolve();
        return n < 3 && r >= 3 && // Brand new clients don't need to drop and recreate--only clients that
        // potentially have corrupt data.
        (0 !== n && (!function __PRIVATE_dropQueryCache(e) {
            e.deleteObjectStore($63c47e8a587a7f36$var$he), e.deleteObjectStore($63c47e8a587a7f36$var$ue), e.deleteObjectStore($63c47e8a587a7f36$var$Re);
        }(e), $63c47e8a587a7f36$var$__PRIVATE_createQueryCache(e)), s = s.next(()=>/**
 * Creates the target global singleton row.
 *
 * @param txn - The version upgrade transaction for indexeddb
 */ (function __PRIVATE_writeEmptyTargetGlobalEntry(e) {
                const t = e.store($63c47e8a587a7f36$var$Re), n = {
                    highestTargetId: 0,
                    highestListenSequenceNumber: 0,
                    lastRemoteSnapshotVersion: $63c47e8a587a7f36$var$SnapshotVersion.min().toTimestamp(),
                    targetCount: 0
                };
                return t.put($63c47e8a587a7f36$var$Ee, n);
            })(i))), n < 4 && r >= 4 && (0 !== n && // Schema version 3 uses auto-generated keys to generate globally unique
        // mutation batch IDs (this was previously ensured internally by the
        // client). To migrate to the new schema, we have to read all mutations
        // and write them back out. We preserve the existing batch IDs to guarantee
        // consistency with other object stores. Any further mutation batch IDs will
        // be auto-generated.
        (s = s.next(()=>(function __PRIVATE_upgradeMutationBatchSchemaAndMigrateData(e, t) {
                const n = t.store($63c47e8a587a7f36$var$H);
                return n.H().next((n)=>{
                    e.deleteObjectStore($63c47e8a587a7f36$var$H);
                    e.createObjectStore($63c47e8a587a7f36$var$H, {
                        keyPath: $63c47e8a587a7f36$var$J,
                        autoIncrement: !0
                    }).createIndex($63c47e8a587a7f36$var$Z, $63c47e8a587a7f36$var$X, {
                        unique: !0
                    });
                    const r = t.store($63c47e8a587a7f36$var$H), i = n.map((e)=>r.put(e));
                    return $63c47e8a587a7f36$var$PersistencePromise.waitFor(i);
                });
            })(e, i))), s = s.next(()=>{
            !function __PRIVATE_createClientMetadataStore(e) {
                e.createObjectStore($63c47e8a587a7f36$var$de, {
                    keyPath: $63c47e8a587a7f36$var$me
                });
            }(e);
        })), n < 5 && r >= 5 && (s = s.next(()=>this.gi(i))), n < 6 && r >= 6 && (s = s.next(()=>((function __PRIVATE_createDocumentGlobalStore(e) {
                e.createObjectStore($63c47e8a587a7f36$var$_e);
            })(e), this.pi(i)))), n < 7 && r >= 7 && (s = s.next(()=>this.yi(i))), n < 8 && r >= 8 && (s = s.next(()=>this.wi(e, i))), n < 9 && r >= 9 && (s = s.next(()=>{
            // Multi-Tab used to manage its own changelog, but this has been moved
            // to the DbRemoteDocument object store itself. Since the previous change
            // log only contained transient data, we can drop its object store.
            !function __PRIVATE_dropRemoteDocumentChangesStore(e) {
                e.objectStoreNames.contains("remoteDocumentChanges") && e.deleteObjectStore("remoteDocumentChanges");
            }(e);
        // Note: Schema version 9 used to create a read time index for the
        // RemoteDocumentCache. This is now done with schema version 13.
        })), n < 10 && r >= 10 && (s = s.next(()=>this.bi(i))), n < 11 && r >= 11 && (s = s.next(()=>{
            !function __PRIVATE_createBundlesStore(e) {
                e.createObjectStore($63c47e8a587a7f36$var$fe, {
                    keyPath: $63c47e8a587a7f36$var$ge
                });
            }(e), function __PRIVATE_createNamedQueriesStore(e) {
                e.createObjectStore($63c47e8a587a7f36$var$pe, {
                    keyPath: $63c47e8a587a7f36$var$ye
                });
            }(e);
        })), n < 12 && r >= 12 && (s = s.next(()=>{
            !function __PRIVATE_createDocumentOverlayStore(e) {
                const t = e.createObjectStore($63c47e8a587a7f36$var$Le, {
                    keyPath: $63c47e8a587a7f36$var$ke
                });
                t.createIndex($63c47e8a587a7f36$var$Ke, $63c47e8a587a7f36$var$qe, {
                    unique: !1
                }), t.createIndex($63c47e8a587a7f36$var$Ue, $63c47e8a587a7f36$var$$e, {
                    unique: !1
                });
            }(e);
        })), n < 13 && r >= 13 && (s = s.next(()=>(function __PRIVATE_createRemoteDocumentCache(e) {
                const t = e.createObjectStore($63c47e8a587a7f36$var$te, {
                    keyPath: $63c47e8a587a7f36$var$ne
                });
                t.createIndex($63c47e8a587a7f36$var$re, $63c47e8a587a7f36$var$ie), t.createIndex($63c47e8a587a7f36$var$se, $63c47e8a587a7f36$var$oe);
            })(e)).next(()=>this.Si(e, i)).next(()=>e.deleteObjectStore($63c47e8a587a7f36$var$W))), n < 14 && r >= 14 && (s = s.next(()=>this.Di(e, i))), n < 15 && r >= 15 && (s = s.next(()=>(function __PRIVATE_createFieldIndex(e) {
                const t = e.createObjectStore($63c47e8a587a7f36$var$we, {
                    keyPath: $63c47e8a587a7f36$var$be,
                    autoIncrement: !0
                });
                t.createIndex($63c47e8a587a7f36$var$Se, $63c47e8a587a7f36$var$De, {
                    unique: !1
                });
                const n = e.createObjectStore($63c47e8a587a7f36$var$Ce, {
                    keyPath: $63c47e8a587a7f36$var$ve
                });
                n.createIndex($63c47e8a587a7f36$var$Fe, $63c47e8a587a7f36$var$Me, {
                    unique: !1
                });
                const r = e.createObjectStore($63c47e8a587a7f36$var$xe, {
                    keyPath: $63c47e8a587a7f36$var$Oe
                });
                r.createIndex($63c47e8a587a7f36$var$Ne, $63c47e8a587a7f36$var$Be, {
                    unique: !1
                });
            })(e))), n < 16 && r >= 16 && // Clear the object stores to remove possibly corrupted index entries
        (s = s.next(()=>{
            t.objectStore($63c47e8a587a7f36$var$Ce).clear();
        }).next(()=>{
            t.objectStore($63c47e8a587a7f36$var$xe).clear();
        })), n < 17 && r >= 17 && (s = s.next(()=>{
            !function __PRIVATE_createGlobalsStore(e) {
                e.createObjectStore($63c47e8a587a7f36$var$We, {
                    keyPath: $63c47e8a587a7f36$var$Qe
                });
            }(e);
        })), n < 18 && r >= 18 && (0, $3117f6f4eeb4c314$export$ef10bcfb06572016)() && (s = s.next(()=>{
            t.objectStore($63c47e8a587a7f36$var$Ce).clear();
        }).next(()=>{
            t.objectStore($63c47e8a587a7f36$var$xe).clear();
        })), s;
    }
    pi(e) {
        let t = 0;
        return e.store($63c47e8a587a7f36$var$W).ee((e, n)=>{
            t += $63c47e8a587a7f36$var$__PRIVATE_dbDocumentSize(n);
        }).next(()=>{
            const n = {
                byteSize: t
            };
            return e.store($63c47e8a587a7f36$var$_e).put($63c47e8a587a7f36$var$ae, n);
        });
    }
    gi(e) {
        const t = e.store($63c47e8a587a7f36$var$z), n = e.store($63c47e8a587a7f36$var$H);
        return t.H().next((t)=>$63c47e8a587a7f36$var$PersistencePromise.forEach(t, (t)=>{
                const r = IDBKeyRange.bound([
                    t.userId,
                    $63c47e8a587a7f36$var$U
                ], [
                    t.userId,
                    t.lastAcknowledgedBatchId
                ]);
                return n.H($63c47e8a587a7f36$var$Z, r).next((n)=>$63c47e8a587a7f36$var$PersistencePromise.forEach(n, (n)=>{
                        $63c47e8a587a7f36$export$c18d01048907ea92(n.userId === t.userId, 18650, "Cannot process batch from unexpected user", {
                            batchId: n.batchId
                        });
                        const r = $63c47e8a587a7f36$var$__PRIVATE_fromDbMutationBatch(this.serializer, n);
                        return $63c47e8a587a7f36$var$removeMutationBatch(e, t.userId, r).next(()=>{});
                    }));
            }));
    }
    /**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */ yi(e) {
        const t = e.store($63c47e8a587a7f36$var$he), n = e.store($63c47e8a587a7f36$var$W);
        return e.store($63c47e8a587a7f36$var$Re).get($63c47e8a587a7f36$var$Ee).next((e)=>{
            const r = [];
            return n.ee((n, i)=>{
                const s = new $63c47e8a587a7f36$export$db202ddc8be9136(n), o = function __PRIVATE_sentinelKey(e) {
                    return [
                        0,
                        $63c47e8a587a7f36$var$__PRIVATE_encodeResourcePath(e)
                    ];
                }(s);
                r.push(t.get(o).next((n)=>n ? $63c47e8a587a7f36$var$PersistencePromise.resolve() : ((n)=>t.put({
                            targetId: 0,
                            path: $63c47e8a587a7f36$var$__PRIVATE_encodeResourcePath(n),
                            sequenceNumber: e.highestListenSequenceNumber
                        }))(s)));
            }).next(()=>$63c47e8a587a7f36$var$PersistencePromise.waitFor(r));
        });
    }
    wi(e, t) {
        // Create the index.
        e.createObjectStore($63c47e8a587a7f36$var$Ae, {
            keyPath: $63c47e8a587a7f36$var$Ve
        });
        const n = t.store($63c47e8a587a7f36$var$Ae), r = new $63c47e8a587a7f36$var$__PRIVATE_MemoryCollectionParentIndex, addEntry = (e)=>{
            if (r.add(e)) {
                const t = e.lastSegment(), r = e.popLast();
                return n.put({
                    collectionId: t,
                    parent: $63c47e8a587a7f36$var$__PRIVATE_encodeResourcePath(r)
                });
            }
        };
        // Helper to add an index entry iff we haven't already written it.
        // Index existing remote documents.
        return t.store($63c47e8a587a7f36$var$W).ee({
            Y: !0
        }, (e, t)=>{
            const n = new $63c47e8a587a7f36$export$db202ddc8be9136(e);
            return addEntry(n.popLast());
        }).next(()=>t.store($63c47e8a587a7f36$var$ee).ee({
                Y: !0
            }, ([e, t, n], r)=>{
                const i = $63c47e8a587a7f36$var$__PRIVATE_decodeResourcePath(t);
                return addEntry(i.popLast());
            }));
    }
    bi(e) {
        const t = e.store($63c47e8a587a7f36$var$ue);
        return t.ee((e, n)=>{
            const r = $63c47e8a587a7f36$var$__PRIVATE_fromDbTarget(n), i = $63c47e8a587a7f36$var$__PRIVATE_toDbTarget(this.serializer, r);
            return t.put(i);
        });
    }
    Si(e, t) {
        const n = t.store($63c47e8a587a7f36$var$W), r = [];
        return n.ee((e, n)=>{
            const i = t.store($63c47e8a587a7f36$var$te), s = (function __PRIVATE_extractKey(e) {
                return e.document ? new $63c47e8a587a7f36$export$90a7f3efeed30595($63c47e8a587a7f36$export$db202ddc8be9136.fromString(e.document.name).popFirst(5)) : e.noDocument ? $63c47e8a587a7f36$export$90a7f3efeed30595.fromSegments(e.noDocument.path) : e.unknownDocument ? $63c47e8a587a7f36$export$90a7f3efeed30595.fromSegments(e.unknownDocument.path) : $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(36783);
            })(n).path.toArray(), o = {
                prefixPath: s.slice(0, s.length - 2),
                collectionGroup: s[s.length - 2],
                documentId: s[s.length - 1],
                readTime: n.readTime || [
                    0,
                    0
                ],
                unknownDocument: n.unknownDocument,
                noDocument: n.noDocument,
                document: n.document,
                hasCommittedMutations: !!n.hasCommittedMutations
            };
            r.push(i.put(o));
        }).next(()=>$63c47e8a587a7f36$var$PersistencePromise.waitFor(r));
    }
    Di(e, t) {
        const n = t.store($63c47e8a587a7f36$var$H), r = $63c47e8a587a7f36$var$__PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), i = new $63c47e8a587a7f36$var$__PRIVATE_MemoryPersistence($63c47e8a587a7f36$var$__PRIVATE_MemoryEagerDelegate.Vi, this.serializer.yt);
        return n.H().next((e)=>{
            const n = new Map;
            return e.forEach((e)=>{
                let t = n.get(e.userId) ?? $63c47e8a587a7f36$export$971d5caa766a69d7();
                $63c47e8a587a7f36$var$__PRIVATE_fromDbMutationBatch(this.serializer, e).keys().forEach((e)=>t = t.add(e)), n.set(e.userId, t);
            }), $63c47e8a587a7f36$var$PersistencePromise.forEach(n, (e, n)=>{
                const s = new $63c47e8a587a7f36$var$User(n), o = $63c47e8a587a7f36$var$__PRIVATE_IndexedDbDocumentOverlayCache.wt(this.serializer, s), _ = i.getIndexManager(s), a = $63c47e8a587a7f36$var$__PRIVATE_IndexedDbMutationQueue.wt(s, this.serializer, _, i.referenceDelegate);
                return new $63c47e8a587a7f36$var$LocalDocumentsView(r, a, o, _).recalculateAndSaveOverlaysForDocumentKeys(new $63c47e8a587a7f36$var$__PRIVATE_IndexedDbTransaction(t, $63c47e8a587a7f36$var$__PRIVATE_ListenSequence.ce), e).next();
            });
        });
    }
}
function $63c47e8a587a7f36$var$__PRIVATE_createQueryCache(e) {
    e.createObjectStore($63c47e8a587a7f36$var$he, {
        keyPath: $63c47e8a587a7f36$var$Pe
    }).createIndex($63c47e8a587a7f36$var$Te, $63c47e8a587a7f36$var$Ie, {
        unique: !0
    });
    // NOTE: This is unique only because the TargetId is the suffix.
    e.createObjectStore($63c47e8a587a7f36$var$ue, {
        keyPath: "targetId"
    }).createIndex($63c47e8a587a7f36$var$ce, $63c47e8a587a7f36$var$le, {
        unique: !0
    }), e.createObjectStore($63c47e8a587a7f36$var$Re);
}
const $63c47e8a587a7f36$var$Ft = "IndexedDbPersistence", $63c47e8a587a7f36$var$Mt = 18e5, $63c47e8a587a7f36$var$xt = 5e3, $63c47e8a587a7f36$var$Ot = "Failed to obtain exclusive access to the persistence layer. To allow shared access, multi-tab synchronization has to be enabled in all tabs. If you are using `experimentalForceOwningTab:true`, make sure that only one tab has persistence enabled at any given time.", $63c47e8a587a7f36$var$Nt = "main";
/**
 * Oldest acceptable age in milliseconds for client metadata before the client
 * is considered inactive and its associated data is garbage collected.
 */ /**
 * An IndexedDB-backed instance of Persistence. Data is stored persistently
 * across sessions.
 *
 * On Web only, the Firestore SDKs support shared access to its persistence
 * layer. This allows multiple browser tabs to read and write to IndexedDb and
 * to synchronize state even without network connectivity. Shared access is
 * currently optional and not enabled unless all clients invoke
 * `enablePersistence()` with `{synchronizeTabs:true}`.
 *
 * In multi-tab mode, if multiple clients are active at the same time, the SDK
 * will designate one client as the "primary client". An effort is made to pick
 * a visible, network-connected and active client, and this client is
 * responsible for letting other clients know about its presence. The primary
 * client writes a unique client-generated identifier (the client ID) to
 * IndexedDb’s "owner" store every 4 seconds. If the primary client fails to
 * update this entry, another client can acquire the lease and take over as
 * primary.
 *
 * Some persistence operations in the SDK are designated as primary-client only
 * operations. This includes the acknowledgment of mutations and all updates of
 * remote documents. The effects of these operations are written to persistence
 * and then broadcast to other tabs via LocalStorage (see
 * `WebStorageSharedClientState`), which then refresh their state from
 * persistence.
 *
 * Similarly, the primary client listens to notifications sent by secondary
 * clients to discover persistence changes written by secondary clients, such as
 * the addition of new mutations and query targets.
 *
 * If multi-tab is not enabled and another tab already obtained the primary
 * lease, IndexedDbPersistence enters a failed state and all subsequent
 * operations will automatically fail.
 *
 * Additionally, there is an optimization so that when a tab is closed, the
 * primary lease is released immediately (this is especially important to make
 * sure that a refreshed tab is able to immediately re-acquire the primary
 * lease). Unfortunately, IndexedDB cannot be reliably used in window.unload
 * since it is an asynchronous API. So in addition to attempting to give up the
 * lease, the leaseholder writes its client ID to a "zombiedClient" entry in
 * LocalStorage which acts as an indicator that another tab should go ahead and
 * take the primary lease immediately regardless of the current lease timestamp.
 *
 * TODO(b/114226234): Remove `synchronizeTabs` section when multi-tab is no
 * longer optional.
 */ class $63c47e8a587a7f36$var$__PRIVATE_IndexedDbPersistence {
    constructor(/**
     * Whether to synchronize the in-memory state of multiple tabs and share
     * access to local persistence.
     */ e, t, n, r, i, s, o, _, a, /**
     * If set to true, forcefully obtains database access. Existing tabs will
     * no longer be able to access IndexedDB.
     */ u, c = 18){
        if (this.allowTabSynchronization = e, this.persistenceKey = t, this.clientId = n, this.Ci = i, this.window = s, this.document = o, this.Fi = a, this.Mi = u, this.xi = c, this.ai = null, this.ui = !1, this.isPrimary = !1, this.networkEnabled = !0, /** Our window.unload handler, if registered. */ this.Oi = null, this.inForeground = !1, /** Our 'visibilitychange' listener if registered. */ this.Ni = null, /** The client metadata refresh task. */ this.Bi = null, /** The last time we garbage collected the client metadata object store. */ this.Li = Number.NEGATIVE_INFINITY, /** A listener to notify on primary state changes. */ this.ki = (e)=>Promise.resolve(), !$63c47e8a587a7f36$var$__PRIVATE_IndexedDbPersistence.v()) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.UNIMPLEMENTED, "This platform is either missing IndexedDB or is known to have an incomplete implementation. Offline persistence has been disabled.");
        this.referenceDelegate = new $63c47e8a587a7f36$var$__PRIVATE_IndexedDbLruDelegateImpl(this, r), this.Ki = t + $63c47e8a587a7f36$var$Nt, this.serializer = new $63c47e8a587a7f36$var$__PRIVATE_LocalSerializer(_), this.qi = new $63c47e8a587a7f36$var$__PRIVATE_SimpleDb(this.Ki, this.xi, new $63c47e8a587a7f36$var$__PRIVATE_SchemaConverter(this.serializer)), this.ci = new $63c47e8a587a7f36$var$__PRIVATE_IndexedDbGlobalsCache, this.li = new $63c47e8a587a7f36$var$__PRIVATE_IndexedDbTargetCache(this.referenceDelegate, this.serializer), this.remoteDocumentCache = $63c47e8a587a7f36$var$__PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), this.Pi = new $63c47e8a587a7f36$var$__PRIVATE_IndexedDbBundleCache, this.window && this.window.localStorage ? this.Ui = this.window.localStorage : (this.Ui = null, !1 === u && $63c47e8a587a7f36$var$__PRIVATE_logError($63c47e8a587a7f36$var$Ft, "LocalStorage is unavailable. As a result, persistence may not work reliably. In particular enablePersistence() could fail immediately after refreshing the page."));
    }
    /**
     * Attempt to start IndexedDb persistence.
     *
     * @returns Whether persistence was enabled.
     */ start() {
        // NOTE: This is expected to fail sometimes (in the case of another tab
        // already having the persistence lock), so it's the first thing we should
        // do.
        return this.$i().then(()=>{
            if (!this.isPrimary && !this.allowTabSynchronization) // Fail `start()` if `synchronizeTabs` is disabled and we cannot
            // obtain the primary lease.
            throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.FAILED_PRECONDITION, $63c47e8a587a7f36$var$Ot);
            return this.Wi(), this.Qi(), this.Gi(), this.runTransaction("getHighestListenSequenceNumber", "readonly", (e)=>this.li.getHighestSequenceNumber(e));
        }).then((e)=>{
            this.ai = new $63c47e8a587a7f36$var$__PRIVATE_ListenSequence(e, this.Fi);
        }).then(()=>{
            this.ui = !0;
        }).catch((e)=>(this.qi && this.qi.close(), Promise.reject(e)));
    }
    /**
     * Registers a listener that gets called when the primary state of the
     * instance changes. Upon registering, this listener is invoked immediately
     * with the current primary state.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ zi(e) {
        return this.ki = async (t)=>{
            if (this.started) return e(t);
        }, e(this.isPrimary);
    }
    /**
     * Registers a listener that gets called when the database receives a
     * version change event indicating that it has deleted.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setDatabaseDeletedListener(e) {
        this.qi.q(async (t)=>{
            // Check if an attempt is made to delete IndexedDB.
            null === t.newVersion && await e();
        });
    }
    /**
     * Adjusts the current network state in the client's metadata, potentially
     * affecting the primary lease.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setNetworkEnabled(e) {
        this.networkEnabled !== e && (this.networkEnabled = e, // Schedule a primary lease refresh for immediate execution. The eventual
        // lease update will be propagated via `primaryStateListener`.
        this.Ci.enqueueAndForget(async ()=>{
            this.started && await this.$i();
        }));
    }
    /**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */ $i() {
        return this.runTransaction("updateClientMetadataAndTryBecomePrimary", "readwrite", (e)=>$63c47e8a587a7f36$var$__PRIVATE_clientMetadataStore(e).put({
                clientId: this.clientId,
                updateTimeMs: Date.now(),
                networkEnabled: this.networkEnabled,
                inForeground: this.inForeground
            }).next(()=>{
                if (this.isPrimary) return this.ji(e).next((e)=>{
                    e || (this.isPrimary = !1, this.Ci.enqueueRetryable(()=>this.ki(!1)));
                });
            }).next(()=>this.Hi(e)).next((t)=>this.isPrimary && !t ? this.Ji(e).next(()=>!1) : !!t && this.Zi(e).next(()=>!0))).catch((e)=>{
            if ($63c47e8a587a7f36$var$__PRIVATE_isIndexedDbTransactionError(e)) // Proceed with the existing state. Any subsequent access to
            // IndexedDB will verify the lease.
            return $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Ft, "Failed to extend owner lease: ", e), this.isPrimary;
            if (!this.allowTabSynchronization) throw e;
            return $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Ft, "Releasing owner lease after error during lease refresh", e), /* isPrimary= */ !1;
        }).then((e)=>{
            this.isPrimary !== e && this.Ci.enqueueRetryable(()=>this.ki(e)), this.isPrimary = e;
        });
    }
    ji(e) {
        return $63c47e8a587a7f36$var$__PRIVATE_primaryClientStore(e).get($63c47e8a587a7f36$var$G).next((e)=>$63c47e8a587a7f36$var$PersistencePromise.resolve(this.Xi(e)));
    }
    Yi(e) {
        return $63c47e8a587a7f36$var$__PRIVATE_clientMetadataStore(e).delete(this.clientId);
    }
    /**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */ async es() {
        if (this.isPrimary && !this.ts(this.Li, $63c47e8a587a7f36$var$Mt)) {
            this.Li = Date.now();
            const e = await this.runTransaction("maybeGarbageCollectMultiClientState", "readwrite-primary", (e)=>{
                const t = $63c47e8a587a7f36$var$__PRIVATE_getStore(e, $63c47e8a587a7f36$var$de);
                return t.H().next((e)=>{
                    const n = this.ns(e, $63c47e8a587a7f36$var$Mt), r = e.filter((e)=>-1 === n.indexOf(e));
                    // Delete metadata for clients that are no longer considered active.
                    return $63c47e8a587a7f36$var$PersistencePromise.forEach(r, (e)=>t.delete(e.clientId)).next(()=>r);
                });
            }).catch(()=>[]);
            // Delete potential leftover entries that may continue to mark the
            // inactive clients as zombied in LocalStorage.
            // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
            // the client atomically, but we can't. So we opt to delete the IndexedDb
            // entries first to avoid potentially reviving a zombied client.
            if (this.Ui) for (const t of e)this.Ui.removeItem(this.rs(t.clientId));
        }
    }
    /**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */ Gi() {
        this.Bi = this.Ci.enqueueAfterDelay("client_metadata_refresh" /* TimerId.ClientMetadataRefresh */ , 4e3, ()=>this.$i().then(()=>this.es()).then(()=>this.Gi()));
    }
    /** Checks whether `client` is the local client. */ Xi(e) {
        return !!e && e.ownerId === this.clientId;
    }
    /**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */ Hi(e) {
        if (this.Mi) return $63c47e8a587a7f36$var$PersistencePromise.resolve(!0);
        return $63c47e8a587a7f36$var$__PRIVATE_primaryClientStore(e).get($63c47e8a587a7f36$var$G).next((t)=>{
            // A client is eligible for the primary lease if:
            // - its network is enabled and the client's tab is in the foreground.
            // - its network is enabled and no other client's tab is in the
            //   foreground.
            // - every clients network is disabled and the client's tab is in the
            //   foreground.
            // - every clients network is disabled and no other client's tab is in
            //   the foreground.
            // - the `forceOwningTab` setting was passed in.
            if (null !== t && this.ts(t.leaseTimestampMs, $63c47e8a587a7f36$var$xt) && !this.ss(t.ownerId)) {
                if (this.Xi(t) && this.networkEnabled) return !0;
                if (!this.Xi(t)) {
                    if (!t.allowTabSynchronization) // Fail the `canActAsPrimary` check if the current leaseholder has
                    // not opted into multi-tab synchronization. If this happens at
                    // client startup, we reject the Promise returned by
                    // `enablePersistence()` and the user can continue to use Firestore
                    // with in-memory persistence.
                    // If this fails during a lease refresh, we will instead block the
                    // AsyncQueue from executing further operations. Note that this is
                    // acceptable since mixing & matching different `synchronizeTabs`
                    // settings is not supported.
                    // TODO(b/114226234): Remove this check when `synchronizeTabs` can
                    // no longer be turned off.
                    throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.FAILED_PRECONDITION, $63c47e8a587a7f36$var$Ot);
                    return !1;
                }
            }
            return !(!this.networkEnabled || !this.inForeground) || $63c47e8a587a7f36$var$__PRIVATE_clientMetadataStore(e).H().next((e)=>void 0 === this.ns(e, $63c47e8a587a7f36$var$xt).find((e)=>{
                    if (this.clientId !== e.clientId) {
                        const t = !this.networkEnabled && e.networkEnabled, n = !this.inForeground && e.inForeground, r = this.networkEnabled === e.networkEnabled;
                        if (t || n && r) return !0;
                    }
                    return !1;
                }));
        }).next((e)=>(this.isPrimary !== e && $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Ft, `Client ${e ? "is" : "is not"} eligible for a primary lease.`), e));
    }
    async shutdown() {
        // The shutdown() operations are idempotent and can be called even when
        // start() aborted (e.g. because it couldn't acquire the persistence lease).
        this.ui = !1, this._s(), this.Bi && (this.Bi.cancel(), this.Bi = null), this.us(), this.cs(), // Use `SimpleDb.runTransaction` directly to avoid failing if another tab
        // has obtained the primary lease.
        await this.qi.runTransaction("shutdown", "readwrite", [
            $63c47e8a587a7f36$var$Q,
            $63c47e8a587a7f36$var$de
        ], (e)=>{
            const t = new $63c47e8a587a7f36$var$__PRIVATE_IndexedDbTransaction(e, $63c47e8a587a7f36$var$__PRIVATE_ListenSequence.ce);
            return this.Ji(t).next(()=>this.Yi(t));
        }), this.qi.close(), // Remove the entry marking the client as zombied from LocalStorage since
        // we successfully deleted its metadata from IndexedDb.
        this.ls();
    }
    /**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */ ns(e, t) {
        return e.filter((e)=>this.ts(e.updateTimeMs, t) && !this.ss(e.clientId));
    }
    /**
     * Returns the IDs of the clients that are currently active. If multi-tab
     * is not supported, returns an array that only contains the local client's
     * ID.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ hs() {
        return this.runTransaction("getActiveClients", "readonly", (e)=>$63c47e8a587a7f36$var$__PRIVATE_clientMetadataStore(e).H().next((e)=>this.ns(e, $63c47e8a587a7f36$var$Mt).map((e)=>e.clientId)));
    }
    get started() {
        return this.ui;
    }
    getGlobalsCache() {
        return this.ci;
    }
    getMutationQueue(e, t) {
        return $63c47e8a587a7f36$var$__PRIVATE_IndexedDbMutationQueue.wt(e, this.serializer, t, this.referenceDelegate);
    }
    getTargetCache() {
        return this.li;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getIndexManager(e) {
        return new $63c47e8a587a7f36$var$__PRIVATE_IndexedDbIndexManager(e, this.serializer.yt.databaseId);
    }
    getDocumentOverlayCache(e) {
        return $63c47e8a587a7f36$var$__PRIVATE_IndexedDbDocumentOverlayCache.wt(this.serializer, e);
    }
    getBundleCache() {
        return this.Pi;
    }
    runTransaction(e, t, n) {
        $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Ft, "Starting transaction:", e);
        const r = "readonly" === t ? "readonly" : "readwrite", i = /** Returns the object stores for the provided schema. */ function __PRIVATE_getObjectStores(e) {
            return 18 === e ? $63c47e8a587a7f36$var$Ye : 17 === e ? $63c47e8a587a7f36$var$Xe : 16 === e ? $63c47e8a587a7f36$var$Ze : 15 === e ? $63c47e8a587a7f36$var$Je : 14 === e ? $63c47e8a587a7f36$var$He : 13 === e ? $63c47e8a587a7f36$var$je : 12 === e ? $63c47e8a587a7f36$var$ze : 11 === e ? $63c47e8a587a7f36$var$Ge : void $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(60245);
        }(this.xi);
        let s;
        // Do all transactions as readwrite against all object stores, since we
        // are the only reader/writer.
        return this.qi.runTransaction(e, r, i, (r)=>(s = new $63c47e8a587a7f36$var$__PRIVATE_IndexedDbTransaction(r, this.ai ? this.ai.next() : $63c47e8a587a7f36$var$__PRIVATE_ListenSequence.ce), "readwrite-primary" === t ? this.ji(s).next((e)=>!!e || this.Hi(s)).next((t)=>{
                if (!t) throw $63c47e8a587a7f36$var$__PRIVATE_logError(`Failed to obtain primary lease for action '${e}'.`), this.isPrimary = !1, this.Ci.enqueueRetryable(()=>this.ki(!1)), new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.FAILED_PRECONDITION, $63c47e8a587a7f36$var$L);
                return n(s);
            }).next((e)=>this.Zi(s).next(()=>e)) : this.Ps(s).next(()=>n(s)))).then((e)=>(s.raiseOnCommittedEvent(), e));
    }
    /**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */ // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
    // be turned off.
    Ps(e) {
        return $63c47e8a587a7f36$var$__PRIVATE_primaryClientStore(e).get($63c47e8a587a7f36$var$G).next((e)=>{
            if (null !== e && this.ts(e.leaseTimestampMs, $63c47e8a587a7f36$var$xt) && !this.ss(e.ownerId) && !this.Xi(e) && !(this.Mi || this.allowTabSynchronization && e.allowTabSynchronization)) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.FAILED_PRECONDITION, $63c47e8a587a7f36$var$Ot);
        });
    }
    /**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */ Zi(e) {
        const t = {
            ownerId: this.clientId,
            allowTabSynchronization: this.allowTabSynchronization,
            leaseTimestampMs: Date.now()
        };
        return $63c47e8a587a7f36$var$__PRIVATE_primaryClientStore(e).put($63c47e8a587a7f36$var$G, t);
    }
    static v() {
        return $63c47e8a587a7f36$var$__PRIVATE_SimpleDb.v();
    }
    /** Checks the primary lease and removes it if we are the current primary. */ Ji(e) {
        const t = $63c47e8a587a7f36$var$__PRIVATE_primaryClientStore(e);
        return t.get($63c47e8a587a7f36$var$G).next((e)=>this.Xi(e) ? ($63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Ft, "Releasing primary lease."), t.delete($63c47e8a587a7f36$var$G)) : $63c47e8a587a7f36$var$PersistencePromise.resolve());
    }
    /** Verifies that `updateTimeMs` is within `maxAgeMs`. */ ts(e, t) {
        const n = Date.now();
        return !(e < n - t) && (!(e > n) || ($63c47e8a587a7f36$var$__PRIVATE_logError(`Detected an update time that is in the future: ${e} > ${n}`), !1));
    }
    Wi() {
        null !== this.document && "function" == typeof this.document.addEventListener && (this.Ni = ()=>{
            this.Ci.enqueueAndForget(()=>(this.inForeground = "visible" === this.document.visibilityState, this.$i()));
        }, this.document.addEventListener("visibilitychange", this.Ni), this.inForeground = "visible" === this.document.visibilityState);
    }
    us() {
        this.Ni && (this.document.removeEventListener("visibilitychange", this.Ni), this.Ni = null);
    }
    /**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */ Qi() {
        "function" == typeof this.window?.addEventListener && (this.Oi = ()=>{
            // Note: In theory, this should be scheduled on the AsyncQueue since it
            // accesses internal state. We execute this code directly during shutdown
            // to make sure it gets a chance to run.
            this._s();
            const e = /(?:Version|Mobile)\/1[456]/;
            (0, $3117f6f4eeb4c314$export$95df08bae54cb4df)() && (navigator.appVersion.match(e) || navigator.userAgent.match(e)) && // On Safari 14, 15, and 16, we do not run any cleanup actions as it might
            // trigger a bug that prevents Safari from re-opening IndexedDB during
            // the next page load.
            // See https://bugs.webkit.org/show_bug.cgi?id=226547
            this.Ci.enterRestrictedMode(/* purgeExistingTasks= */ !0), this.Ci.enqueueAndForget(()=>this.shutdown());
        }, this.window.addEventListener("pagehide", this.Oi));
    }
    cs() {
        this.Oi && (this.window.removeEventListener("pagehide", this.Oi), this.Oi = null);
    }
    /**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */ ss(e) {
        try {
            const t = null !== this.Ui?.getItem(this.rs(e));
            return $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Ft, `Client '${e}' ${t ? "is" : "is not"} zombied in LocalStorage`), t;
        } catch (e) {
            // Gracefully handle if LocalStorage isn't working.
            return $63c47e8a587a7f36$var$__PRIVATE_logError($63c47e8a587a7f36$var$Ft, "Failed to get zombied client id.", e), !1;
        }
    }
    /**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */ _s() {
        if (this.Ui) try {
            this.Ui.setItem(this.rs(this.clientId), String(Date.now()));
        } catch (e) {
            // Gracefully handle if LocalStorage isn't available / working.
            $63c47e8a587a7f36$var$__PRIVATE_logError("Failed to set zombie client id.", e);
        }
    }
    /** Removes the zombied client entry if it exists. */ ls() {
        if (this.Ui) try {
            this.Ui.removeItem(this.rs(this.clientId));
        } catch (e) {
        // Ignore
        }
    }
    rs(e) {
        return `firestore_zombie_${this.persistenceKey}_${e}`;
    }
}
/**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */ function $63c47e8a587a7f36$var$__PRIVATE_primaryClientStore(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_getStore(e, $63c47e8a587a7f36$var$Q);
}
/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */ function $63c47e8a587a7f36$var$__PRIVATE_clientMetadataStore(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_getStore(e, $63c47e8a587a7f36$var$de);
}
/**
 * Generates a string used as a prefix when storing data in IndexedDB and
 * LocalStorage.
 */ function $63c47e8a587a7f36$var$__PRIVATE_indexedDbStoragePrefix(e, t) {
    // Use two different prefix formats:
    //   * firestore / persistenceKey / projectID . databaseID / ...
    //   * firestore / persistenceKey / projectID / ...
    // projectIDs are DNS-compatible names and cannot contain dots
    // so there's no danger of collisions.
    let n = e.projectId;
    return e.isDefaultDatabase || (n += "." + e.database), "firestore/" + t + "/" + n + "/";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A set of changes to what documents are currently in view and out of view for
 * a given query. These changes are sent to the LocalStore by the View (via
 * the SyncEngine) and are used to pin / unpin documents as appropriate.
 */ class $63c47e8a587a7f36$var$__PRIVATE_LocalViewChanges {
    constructor(e, t, n, r){
        this.targetId = e, this.fromCache = t, this.Ts = n, this.Is = r;
    }
    static Es(e, t) {
        let n = $63c47e8a587a7f36$export$971d5caa766a69d7(), r = $63c47e8a587a7f36$export$971d5caa766a69d7();
        for (const e of t.docChanges)switch(e.type){
            case 0 /* ChangeType.Added */ :
                n = n.add(e.doc.key);
                break;
            case 1 /* ChangeType.Removed */ :
                r = r.add(e.doc.key);
        }
        return new $63c47e8a587a7f36$var$__PRIVATE_LocalViewChanges(e, t.fromCache, n, r);
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A tracker to keep a record of important details during database local query
 * execution.
 */ class $63c47e8a587a7f36$var$QueryContext {
    constructor(){
        /**
         * Counts the number of documents passed through during local query execution.
         */ this._documentReadCount = 0;
    }
    get documentReadCount() {
        return this._documentReadCount;
    }
    incrementDocumentReadCount(e) {
        this._documentReadCount += e;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The Firestore query engine.
 *
 * Firestore queries can be executed in three modes. The Query Engine determines
 * what mode to use based on what data is persisted. The mode only determines
 * the runtime complexity of the query - the result set is equivalent across all
 * implementations.
 *
 * The Query engine will use indexed-based execution if a user has configured
 * any index that can be used to execute query (via `setIndexConfiguration()`).
 * Otherwise, the engine will try to optimize the query by re-using a previously
 * persisted query result. If that is not possible, the query will be executed
 * via a full collection scan.
 *
 * Index-based execution is the default when available. The query engine
 * supports partial indexed execution and merges the result from the index
 * lookup with documents that have not yet been indexed. The index evaluation
 * matches the backend's format and as such, the SDK can use indexing for all
 * queries that the backend supports.
 *
 * If no index exists, the query engine tries to take advantage of the target
 * document mapping in the TargetCache. These mappings exists for all queries
 * that have been synced with the backend at least once and allow the query
 * engine to only read documents that previously matched a query plus any
 * documents that were edited after the query was last listened to.
 *
 * There are some cases when this optimization is not guaranteed to produce
 * the same results as full collection scans. In these cases, query
 * processing falls back to full scans. These cases are:
 *
 * - Limit queries where a document that matched the query previously no longer
 *   matches the query.
 *
 * - Limit queries where a document edit may cause the document to sort below
 *   another document that is in the local cache.
 *
 * - Queries that have never been CURRENT or free of limbo documents.
 */ class $63c47e8a587a7f36$var$__PRIVATE_QueryEngine {
    constructor(){
        this.Rs = !1, this.As = !1, /**
         * SDK only decides whether it should create index when collection size is
         * larger than this.
         */ this.Vs = 100, this.ds = /**
 * This cost represents the evaluation result of
 * (([index, docKey] + [docKey, docContent]) per document in the result set)
 * / ([docKey, docContent] per documents in full collection scan) coming from
 * experiment [enter PR experiment URL here].
 */ function __PRIVATE_getDefaultRelativeIndexReadCostPerDocument() {
            // These values were derived from an experiment where several members of the
            // Firestore SDK team ran a performance test in various environments.
            // Googlers can see b/299284287 for details.
            return (0, $3117f6f4eeb4c314$export$95df08bae54cb4df)() ? 8 : $63c47e8a587a7f36$var$__PRIVATE_getAndroidVersion((0, $3117f6f4eeb4c314$export$c36915b22ce77c19)()) > 0 ? 6 : 4;
        }();
    }
    /** Sets the document view to query against. */ initialize(e, t) {
        this.fs = e, this.indexManager = t, this.Rs = !0;
    }
    /** Returns all local documents matching the specified query. */ getDocumentsMatchingQuery(e, t, n, r) {
        // Stores the result from executing the query; using this object is more
        // convenient than passing the result between steps of the persistence
        // transaction and improves readability comparatively.
        const i = {
            result: null
        };
        return this.gs(e, t).next((e)=>{
            i.result = e;
        }).next(()=>{
            if (!i.result) return this.ps(e, t, r, n).next((e)=>{
                i.result = e;
            });
        }).next(()=>{
            if (i.result) return;
            const n = new $63c47e8a587a7f36$var$QueryContext;
            return this.ys(e, t, n).next((r)=>{
                if (i.result = r, this.As) return this.ws(e, t, n, r.size);
            });
        }).next(()=>i.result);
    }
    ws(e, t, n, r) {
        return n.documentReadCount < this.Vs ? ($63c47e8a587a7f36$var$__PRIVATE_getLogLevel() <= (0, $6640afd658bf2724$export$243e62d78d3b544d).DEBUG && $63c47e8a587a7f36$export$21579262ef46735b("QueryEngine", "SDK will not create cache indexes for query:", $63c47e8a587a7f36$var$__PRIVATE_stringifyQuery(t), "since it only creates cache indexes for collection contains", "more than or equal to", this.Vs, "documents"), $63c47e8a587a7f36$var$PersistencePromise.resolve()) : ($63c47e8a587a7f36$var$__PRIVATE_getLogLevel() <= (0, $6640afd658bf2724$export$243e62d78d3b544d).DEBUG && $63c47e8a587a7f36$export$21579262ef46735b("QueryEngine", "Query:", $63c47e8a587a7f36$var$__PRIVATE_stringifyQuery(t), "scans", n.documentReadCount, "local documents and returns", r, "documents as results."), n.documentReadCount > this.ds * r ? ($63c47e8a587a7f36$var$__PRIVATE_getLogLevel() <= (0, $6640afd658bf2724$export$243e62d78d3b544d).DEBUG && $63c47e8a587a7f36$export$21579262ef46735b("QueryEngine", "The SDK decides to create cache indexes for query:", $63c47e8a587a7f36$var$__PRIVATE_stringifyQuery(t), "as using cache indexes may help improve performance."), this.indexManager.createTargetIndexes(e, $63c47e8a587a7f36$var$__PRIVATE_queryToTarget(t))) : $63c47e8a587a7f36$var$PersistencePromise.resolve());
    }
    /**
     * Performs an indexed query that evaluates the query based on a collection's
     * persisted index values. Returns `null` if an index is not available.
     */ gs(e, t) {
        if ($63c47e8a587a7f36$var$__PRIVATE_queryMatchesAllDocuments(t)) // Queries that match all documents don't benefit from using
        // key-based lookups. It is more efficient to scan all documents in a
        // collection, rather than to perform individual lookups.
        return $63c47e8a587a7f36$var$PersistencePromise.resolve(null);
        let n = $63c47e8a587a7f36$var$__PRIVATE_queryToTarget(t);
        return this.indexManager.getIndexType(e, n).next((r)=>0 /* IndexType.NONE */  === r ? null : (null !== t.limit && 1 /* IndexType.PARTIAL */  === r && // We cannot apply a limit for targets that are served using a partial
            // index. If a partial index will be used to serve the target, the
            // query may return a superset of documents that match the target
            // (e.g. if the index doesn't include all the target's filters), or
            // may return the correct set of documents in the wrong order (e.g. if
            // the index doesn't include a segment for one of the orderBys).
            // Therefore, a limit should not be applied in such cases.
            (t = $63c47e8a587a7f36$export$882b5998b3b9117c(t, null, "F" /* LimitType.First */ ), n = $63c47e8a587a7f36$var$__PRIVATE_queryToTarget(t)), this.indexManager.getDocumentsMatchingTarget(e, n).next((r)=>{
                const i = $63c47e8a587a7f36$export$971d5caa766a69d7(...r);
                return this.fs.getDocuments(e, i).next((r)=>this.indexManager.getMinOffset(e, n).next((n)=>{
                        const s = this.bs(t, r);
                        return this.Ss(t, s, i, n.readTime) ? this.gs(e, $63c47e8a587a7f36$export$882b5998b3b9117c(t, null, "F" /* LimitType.First */ )) : this.Ds(e, s, t, n);
                    }));
            })));
    }
    /**
     * Performs a query based on the target's persisted query mapping. Returns
     * `null` if the mapping is not available or cannot be used.
     */ ps(e, t, n, r) {
        return $63c47e8a587a7f36$var$__PRIVATE_queryMatchesAllDocuments(t) || r.isEqual($63c47e8a587a7f36$var$SnapshotVersion.min()) ? $63c47e8a587a7f36$var$PersistencePromise.resolve(null) : this.fs.getDocuments(e, n).next((i)=>{
            const s = this.bs(t, i);
            return this.Ss(t, s, n, r) ? $63c47e8a587a7f36$var$PersistencePromise.resolve(null) : ($63c47e8a587a7f36$var$__PRIVATE_getLogLevel() <= (0, $6640afd658bf2724$export$243e62d78d3b544d).DEBUG && $63c47e8a587a7f36$export$21579262ef46735b("QueryEngine", "Re-using previous result from %s to execute query: %s", r.toString(), $63c47e8a587a7f36$var$__PRIVATE_stringifyQuery(t)), this.Ds(e, s, t, $63c47e8a587a7f36$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(r, $63c47e8a587a7f36$var$B)).next((e)=>e));
        });
    // Queries that have never seen a snapshot without limbo free documents
    // should also be run as a full collection scan.
    }
    /** Applies the query filter and sorting to the provided documents.  */ bs(e, t) {
        // Sort the documents and re-apply the query filter since previously
        // matching documents do not necessarily still match the query.
        let n = new $63c47e8a587a7f36$var$SortedSet($63c47e8a587a7f36$var$__PRIVATE_newQueryComparator(e));
        return t.forEach((t, r)=>{
            $63c47e8a587a7f36$var$__PRIVATE_queryMatches(e, r) && (n = n.add(r));
        }), n;
    }
    /**
     * Determines if a limit query needs to be refilled from cache, making it
     * ineligible for index-free execution.
     *
     * @param query - The query.
     * @param sortedPreviousResults - The documents that matched the query when it
     * was last synchronized, sorted by the query's comparator.
     * @param remoteKeys - The document keys that matched the query at the last
     * snapshot.
     * @param limboFreeSnapshotVersion - The version of the snapshot when the
     * query was last synchronized.
     */ Ss(e, t, n, r) {
        if (null === e.limit) // Queries without limits do not need to be refilled.
        return !1;
        if (n.size !== t.size) // The query needs to be refilled if a previously matching document no
        // longer matches.
        return !0;
        // Limit queries are not eligible for index-free query execution if there is
        // a potential that an older document from cache now sorts before a document
        // that was previously part of the limit. This, however, can only happen if
        // the document at the edge of the limit goes out of limit.
        // If a document that is not the limit boundary sorts differently,
        // the boundary of the limit itself did not change and documents from cache
        // will continue to be "rejected" by this boundary. Therefore, we can ignore
        // any modifications that don't affect the last document.
        const i = "F" /* LimitType.First */  === e.limitType ? t.last() : t.first();
        return !!i && (i.hasPendingWrites || i.version.compareTo(r) > 0);
    }
    ys(e, t, n) {
        return $63c47e8a587a7f36$var$__PRIVATE_getLogLevel() <= (0, $6640afd658bf2724$export$243e62d78d3b544d).DEBUG && $63c47e8a587a7f36$export$21579262ef46735b("QueryEngine", "Using full collection scan to execute query:", $63c47e8a587a7f36$var$__PRIVATE_stringifyQuery(t)), this.fs.getDocumentsMatchingQuery(e, t, $63c47e8a587a7f36$var$IndexOffset.min(), n);
    }
    /**
     * Combines the results from an indexed execution with the remaining documents
     * that have not yet been indexed.
     */ Ds(e, t, n, r) {
        // Retrieve all results for documents that were updated since the offset.
        return this.fs.getDocumentsMatchingQuery(e, n, r).next((e)=>// Merge with existing results
            (t.forEach((t)=>{
                e = e.insert(t.key, t);
            }), e));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $63c47e8a587a7f36$var$Bt = "LocalStore", $63c47e8a587a7f36$var$Lt = 3e8;
/**
 * The maximum time to leave a resume token buffered without writing it out.
 * This value is arbitrary: it's long enough to avoid several writes
 * (possibly indefinitely if updates come more frequently than this) but
 * short enough that restarting after crashing will still have a pretty
 * recent resume token.
 */ /**
 * Implements `LocalStore` interface.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $63c47e8a587a7f36$var$__PRIVATE_LocalStoreImpl {
    constructor(/** Manages our in-memory or durable persistence. */ e, t, n, r){
        this.persistence = e, this.Cs = t, this.serializer = r, /**
         * Maps a targetID to data about its target.
         *
         * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
         * of `applyRemoteEvent()` idempotent.
         */ this.vs = new $63c47e8a587a7f36$var$SortedMap($63c47e8a587a7f36$var$__PRIVATE_primitiveComparator), /** Maps a target to its targetID. */ // TODO(wuandy): Evaluate if TargetId can be part of Target.
        this.Fs = new $63c47e8a587a7f36$var$ObjectMap((e)=>$63c47e8a587a7f36$var$__PRIVATE_canonifyTarget(e), $63c47e8a587a7f36$var$__PRIVATE_targetEquals), /**
         * A per collection group index of the last read time processed by
         * `getNewDocumentChanges()`.
         *
         * PORTING NOTE: This is only used for multi-tab synchronization.
         */ this.Ms = new Map, this.xs = e.getRemoteDocumentCache(), this.li = e.getTargetCache(), this.Pi = e.getBundleCache(), this.Os(n);
    }
    Os(e) {
        // TODO(indexing): Add spec tests that test these components change after a
        // user change
        this.documentOverlayCache = this.persistence.getDocumentOverlayCache(e), this.indexManager = this.persistence.getIndexManager(e), this.mutationQueue = this.persistence.getMutationQueue(e, this.indexManager), this.localDocuments = new $63c47e8a587a7f36$var$LocalDocumentsView(this.xs, this.mutationQueue, this.documentOverlayCache, this.indexManager), this.xs.setIndexManager(this.indexManager), this.Cs.initialize(this.localDocuments, this.indexManager);
    }
    collectGarbage(e) {
        return this.persistence.runTransaction("Collect garbage", "readwrite-primary", (t)=>e.collect(t, this.vs));
    }
}
function $63c47e8a587a7f36$var$__PRIVATE_newLocalStore(/** Manages our in-memory or durable persistence. */ e, t, n, r) {
    return new $63c47e8a587a7f36$var$__PRIVATE_LocalStoreImpl(e, t, n, r);
}
/**
 * Tells the LocalStore that the currently authenticated user has changed.
 *
 * In response the local store switches the mutation queue to the new user and
 * returns any resulting document changes.
 */ // PORTING NOTE: Android and iOS only return the documents affected by the
// change.
async function $63c47e8a587a7f36$var$__PRIVATE_localStoreHandleUserChange(e, t) {
    const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    return await n.persistence.runTransaction("Handle user change", "readonly", (e)=>{
        // Swap out the mutation queue, grabbing the pending mutation batches
        // before and after.
        let r;
        return n.mutationQueue.getAllMutationBatches(e).next((i)=>(r = i, n.Os(t), n.mutationQueue.getAllMutationBatches(e))).next((t)=>{
            const i = [], s = [];
            // Union the old/new changed keys.
            let o = $63c47e8a587a7f36$export$971d5caa766a69d7();
            for (const e of r){
                i.push(e.batchId);
                for (const t of e.mutations)o = o.add(t.key);
            }
            for (const e of t){
                s.push(e.batchId);
                for (const t of e.mutations)o = o.add(t.key);
            }
            // Return the set of all (potentially) changed documents and the list
            // of mutation batch IDs that were affected by change.
            return n.localDocuments.getDocuments(e, o).next((e)=>({
                    Ns: e,
                    removedBatchIds: i,
                    addedBatchIds: s
                }));
        });
    });
}
/* Accepts locally generated Mutations and commit them to storage. */ /**
 * Acknowledges the given batch.
 *
 * On the happy path when a batch is acknowledged, the local store will
 *
 *  + remove the batch from the mutation queue;
 *  + apply the changes to the remote document cache;
 *  + recalculate the latency compensated view implied by those changes (there
 *    may be mutations in the queue that affect the documents but haven't been
 *    acknowledged yet); and
 *  + give the changed documents back the sync engine
 *
 * @returns The resulting (modified) documents.
 */ function $63c47e8a587a7f36$var$__PRIVATE_localStoreAcknowledgeBatch(e, t) {
    const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Acknowledge batch", "readwrite-primary", (e)=>{
        const r = t.batch.keys(), i = n.xs.newChangeBuffer({
            trackRemovals: !0
        });
        return (function __PRIVATE_applyWriteToRemoteDocuments(e, t, n, r) {
            const i = n.batch, s = i.keys();
            let o = $63c47e8a587a7f36$var$PersistencePromise.resolve();
            return s.forEach((e)=>{
                o = o.next(()=>r.getEntry(t, e)).next((t)=>{
                    const s = n.docVersions.get(e);
                    $63c47e8a587a7f36$export$c18d01048907ea92(null !== s, 48541), t.version.compareTo(s) < 0 && (i.applyToRemoteDocument(t, n), t.isValidDocument() && // We use the commitVersion as the readTime rather than the
                    // document's updateTime since the updateTime is not advanced
                    // for updates that do not modify the underlying document.
                    (t.setReadTime(n.commitVersion), r.addEntry(t)));
                });
            }), o.next(()=>e.mutationQueue.removeMutationBatch(t, i));
        })(n, e, t, i).next(()=>i.apply(e)).next(()=>n.mutationQueue.performConsistencyCheck(e)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(e, r, t.batch.batchId)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, function __PRIVATE_getKeysWithTransformResults(e) {
                let t = $63c47e8a587a7f36$export$971d5caa766a69d7();
                for(let n = 0; n < e.mutationResults.length; ++n)e.mutationResults[n].transformResults.length > 0 && (t = t.add(e.batch.mutations[n].key));
                return t;
            }(t))).next(()=>n.localDocuments.getDocuments(e, r));
    });
}
/**
 * Returns the last consistent snapshot processed (used by the RemoteStore to
 * determine whether to buffer incoming snapshots from the backend).
 */ function $63c47e8a587a7f36$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e) {
    const t = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    return t.persistence.runTransaction("Get last remote snapshot version", "readonly", (e)=>t.li.getLastRemoteSnapshotVersion(e));
}
/**
 * Updates the "ground-state" (remote) documents. We assume that the remote
 * event reflects any write batches that have been acknowledged or rejected
 * (i.e. we do not re-apply local mutations to updates from this event).
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ function $63c47e8a587a7f36$var$__PRIVATE_localStoreApplyRemoteEventToLocalCache(e, t) {
    const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e), r = t.snapshotVersion;
    let i = n.vs;
    return n.persistence.runTransaction("Apply remote event", "readwrite-primary", (e)=>{
        const s = n.xs.newChangeBuffer({
            trackRemovals: !0
        });
        // Reset newTargetDataByTargetMap in case this transaction gets re-run.
        i = n.vs;
        const o = [];
        t.targetChanges.forEach((s, _)=>{
            const a = i.get(_);
            if (!a) return;
            // Only update the remote keys if the target is still active. This
            // ensures that we can persist the updated target data along with
            // the updated assignment.
            o.push(n.li.removeMatchingKeys(e, s.removedDocuments, _).next(()=>n.li.addMatchingKeys(e, s.addedDocuments, _)));
            let u = a.withSequenceNumber(e.currentSequenceNumber);
            null !== t.targetMismatches.get(_) ? u = u.withResumeToken($63c47e8a587a7f36$export$9d398bebfec1c039.EMPTY_BYTE_STRING, $63c47e8a587a7f36$var$SnapshotVersion.min()).withLastLimboFreeSnapshotVersion($63c47e8a587a7f36$var$SnapshotVersion.min()) : s.resumeToken.approximateByteSize() > 0 && (u = u.withResumeToken(s.resumeToken, r)), i = i.insert(_, u), // Update the target data if there are target changes (or if
            // sufficient time has passed since the last update).
            /**
 * Returns true if the newTargetData should be persisted during an update of
 * an active target. TargetData should always be persisted when a target is
 * being released and should not call this function.
 *
 * While the target is active, TargetData updates can be omitted when nothing
 * about the target has changed except metadata like the resume token or
 * snapshot version. Occasionally it's worth the extra write to prevent these
 * values from getting too stale after a crash, but this doesn't have to be
 * too frequent.
 */ function __PRIVATE_shouldPersistTargetData(e, t, n) {
                // Always persist target data if we don't already have a resume token.
                if (0 === e.resumeToken.approximateByteSize()) return !0;
                // Don't allow resume token changes to be buffered indefinitely. This
                // allows us to be reasonably up-to-date after a crash and avoids needing
                // to loop over all active queries on shutdown. Especially in the browser
                // we may not get time to do anything interesting while the current tab is
                // closing.
                const r = t.snapshotVersion.toMicroseconds() - e.snapshotVersion.toMicroseconds();
                if (r >= $63c47e8a587a7f36$var$Lt) return !0;
                // Otherwise if the only thing that has changed about a target is its resume
                // token it's not worth persisting. Note that the RemoteStore keeps an
                // in-memory view of the currently active targets which includes the current
                // resume token, so stream failure or user changes will still use an
                // up-to-date resume token regardless of what we do here.
                const i = n.addedDocuments.size + n.modifiedDocuments.size + n.removedDocuments.size;
                return i > 0;
            }(a, u, s) && o.push(n.li.updateTargetData(e, u));
        });
        let _ = $63c47e8a587a7f36$var$__PRIVATE_mutableDocumentMap(), a = $63c47e8a587a7f36$export$971d5caa766a69d7();
        // HACK: The only reason we allow a null snapshot version is so that we
        // can synthesize remote events when we get permission denied errors while
        // trying to resolve the state of a locally cached document that is in
        // limbo.
        if (t.documentUpdates.forEach((r)=>{
            t.resolvedLimboDocuments.has(r) && o.push(n.persistence.referenceDelegate.updateLimboDocument(e, r));
        }), // Each loop iteration only affects its "own" doc, so it's safe to get all
        // the remote documents in advance in a single call.
        o.push($63c47e8a587a7f36$var$__PRIVATE_populateDocumentChangeBuffer(e, s, t.documentUpdates).next((e)=>{
            _ = e.Bs, a = e.Ls;
        })), !r.isEqual($63c47e8a587a7f36$var$SnapshotVersion.min())) {
            const t = n.li.getLastRemoteSnapshotVersion(e).next((t)=>n.li.setTargetsMetadata(e, e.currentSequenceNumber, r));
            o.push(t);
        }
        return $63c47e8a587a7f36$var$PersistencePromise.waitFor(o).next(()=>s.apply(e)).next(()=>n.localDocuments.getLocalViewOfDocuments(e, _, a)).next(()=>_);
    }).then((e)=>(n.vs = i, e));
}
/**
 * Populates document change buffer with documents from backend or a bundle.
 * Returns the document changes resulting from applying those documents, and
 * also a set of documents whose existence state are changed as a result.
 *
 * @param txn - Transaction to use to read existing documents from storage.
 * @param documentBuffer - Document buffer to collect the resulted changes to be
 *        applied to storage.
 * @param documents - Documents to be applied.
 */ function $63c47e8a587a7f36$var$__PRIVATE_populateDocumentChangeBuffer(e, t, n) {
    let r = $63c47e8a587a7f36$export$971d5caa766a69d7(), i = $63c47e8a587a7f36$export$971d5caa766a69d7();
    return n.forEach((e)=>r = r.add(e)), t.getEntries(e, r).next((e)=>{
        let r = $63c47e8a587a7f36$var$__PRIVATE_mutableDocumentMap();
        return n.forEach((n, s)=>{
            const o = e.get(n);
            // Check if see if there is a existence state change for this document.
            s.isFoundDocument() !== o.isFoundDocument() && (i = i.add(n)), // Note: The order of the steps below is important, since we want
            // to ensure that rejected limbo resolutions (which fabricate
            // NoDocuments with SnapshotVersion.min()) never add documents to
            // cache.
            s.isNoDocument() && s.version.isEqual($63c47e8a587a7f36$var$SnapshotVersion.min()) ? // NoDocuments with SnapshotVersion.min() are used in manufactured
            // events. We remove these documents from cache since we lost
            // access.
            (t.removeEntry(n, s.readTime), r = r.insert(n, s)) : !o.isValidDocument() || s.version.compareTo(o.version) > 0 || 0 === s.version.compareTo(o.version) && o.hasPendingWrites ? (t.addEntry(s), r = r.insert(n, s)) : $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Bt, "Ignoring outdated watch update for ", n, ". Current version:", o.version, " Watch version:", s.version);
        }), {
            Bs: r,
            Ls: i
        };
    });
}
/**
 * Gets the mutation batch after the passed in batchId in the mutation queue
 * or null if empty.
 * @param afterBatchId - If provided, the batch to search after.
 * @returns The next mutation or null if there wasn't one.
 */ function $63c47e8a587a7f36$var$__PRIVATE_localStoreGetNextMutationBatch(e, t) {
    const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Get next mutation batch", "readonly", (e)=>(void 0 === t && (t = $63c47e8a587a7f36$var$U), n.mutationQueue.getNextMutationBatchAfterBatchId(e, t)));
}
/**
 * Reads the current value of a Document with a given key or null if not
 * found - used for testing.
 */ /**
 * Assigns the given target an internal ID so that its results can be pinned so
 * they don't get GC'd. A target must be allocated in the local store before
 * the store can be used to manage its view.
 *
 * Allocating an already allocated `Target` will return the existing `TargetData`
 * for that `Target`.
 */ function $63c47e8a587a7f36$var$__PRIVATE_localStoreAllocateTarget(e, t) {
    const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Allocate target", "readwrite", (e)=>{
        let r;
        return n.li.getTargetData(e, t).next((i)=>i ? // This target has been listened to previously, so reuse the
            // previous targetID.
            // TODO(mcg): freshen last accessed date?
            (r = i, $63c47e8a587a7f36$var$PersistencePromise.resolve(r)) : n.li.allocateTargetId(e).next((i)=>(r = new $63c47e8a587a7f36$var$TargetData(t, i, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.currentSequenceNumber), n.li.addTargetData(e, r).next(()=>r))));
    }).then((e)=>{
        // If Multi-Tab is enabled, the existing target data may be newer than
        // the in-memory data
        const r = n.vs.get(e.targetId);
        return (null === r || e.snapshotVersion.compareTo(r.snapshotVersion) > 0) && (n.vs = n.vs.insert(e.targetId, e), n.Fs.set(t, e.targetId)), e;
    });
}
/**
 * Returns the TargetData as seen by the LocalStore, including updates that may
 * have not yet been persisted to the TargetCache.
 */ // Visible for testing.
/**
 * Unpins all the documents associated with the given target. If
 * `keepPersistedTargetData` is set to false and Eager GC enabled, the method
 * directly removes the associated target data from the target cache.
 *
 * Releasing a non-existing `Target` is a no-op.
 */ // PORTING NOTE: `keepPersistedTargetData` is multi-tab only.
async function $63c47e8a587a7f36$var$__PRIVATE_localStoreReleaseTarget(e, t, n) {
    const r = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e), i = r.vs.get(t), s = n ? "readwrite" : "readwrite-primary";
    try {
        n || await r.persistence.runTransaction("Release target", s, (e)=>r.persistence.referenceDelegate.removeTarget(e, i));
    } catch (e) {
        if (!$63c47e8a587a7f36$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
        // All `releaseTarget` does is record the final metadata state for the
        // target, but we've been recording this periodically during target
        // activity. If we lose this write this could cause a very slight
        // difference in the order of target deletion during GC, but we
        // don't define exact LRU semantics so this is acceptable.
        $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Bt, `Failed to update sequence numbers for target ${t}: ${e}`);
    }
    r.vs = r.vs.remove(t), r.Fs.delete(i.target);
}
/**
 * Runs the specified query against the local store and returns the results,
 * potentially taking advantage of query data from previous executions (such
 * as the set of remote keys).
 *
 * @param usePreviousResults - Whether results from previous executions can
 * be used to optimize this query execution.
 */ function $63c47e8a587a7f36$var$__PRIVATE_localStoreExecuteQuery(e, t, n) {
    const r = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    let i = $63c47e8a587a7f36$var$SnapshotVersion.min(), s = $63c47e8a587a7f36$export$971d5caa766a69d7();
    return r.persistence.runTransaction("Execute query", "readwrite", // Use readwrite instead of readonly so indexes can be created
    (e)=>(function __PRIVATE_localStoreGetTargetData(e, t, n) {
            const r = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e), i = r.Fs.get(n);
            return void 0 !== i ? $63c47e8a587a7f36$var$PersistencePromise.resolve(r.vs.get(i)) : r.li.getTargetData(t, n);
        })(r, e, $63c47e8a587a7f36$var$__PRIVATE_queryToTarget(t)).next((t)=>{
            if (t) return i = t.lastLimboFreeSnapshotVersion, r.li.getMatchingKeysForTargetId(e, t.targetId).next((e)=>{
                s = e;
            });
        }).next(()=>r.Cs.getDocumentsMatchingQuery(e, t, n ? i : $63c47e8a587a7f36$var$SnapshotVersion.min(), n ? s : $63c47e8a587a7f36$export$971d5caa766a69d7())).next((e)=>($63c47e8a587a7f36$var$__PRIVATE_setMaxReadTime(r, $63c47e8a587a7f36$var$__PRIVATE_queryCollectionGroup(t), e), {
                documents: e,
                ks: s
            })));
}
// PORTING NOTE: Multi-Tab only.
function $63c47e8a587a7f36$var$__PRIVATE_localStoreGetCachedTarget(e, t) {
    const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e), r = $63c47e8a587a7f36$var$__PRIVATE_debugCast(n.li), i = n.vs.get(t);
    return i ? Promise.resolve(i.target) : n.persistence.runTransaction("Get target data", "readonly", (e)=>r.At(e, t).next((e)=>e ? e.target : null));
}
/**
 * Returns the set of documents that have been updated since the last call.
 * If this is the first call, returns the set of changes since client
 * initialization. Further invocations will return document that have changed
 * since the prior call.
 */ // PORTING NOTE: Multi-Tab only.
function $63c47e8a587a7f36$var$__PRIVATE_localStoreGetNewDocumentChanges(e, t) {
    const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e), r = n.Ms.get(t) || $63c47e8a587a7f36$var$SnapshotVersion.min();
    // Get the current maximum read time for the collection. This should always
    // exist, but to reduce the chance for regressions we default to
    // SnapshotVersion.Min()
    // TODO(indexing): Consider removing the default value.
    return n.persistence.runTransaction("Get new document changes", "readonly", (e)=>n.xs.getAllFromCollectionGroup(e, t, $63c47e8a587a7f36$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(r, $63c47e8a587a7f36$var$B), /* limit= */ Number.MAX_SAFE_INTEGER)).then((e)=>($63c47e8a587a7f36$var$__PRIVATE_setMaxReadTime(n, t, e), e));
}
/** Sets the collection group's maximum read time from the given documents. */ // PORTING NOTE: Multi-Tab only.
function $63c47e8a587a7f36$var$__PRIVATE_setMaxReadTime(e, t, n) {
    let r = e.Ms.get(t) || $63c47e8a587a7f36$var$SnapshotVersion.min();
    n.forEach((e, t)=>{
        t.readTime.compareTo(r) > 0 && (r = t.readTime);
    }), e.Ms.set(t, r);
}
/**
 * Creates a new target using the given bundle name, which will be used to
 * hold the keys of all documents from the bundle in query-document mappings.
 * This ensures that the loaded documents do not get garbage collected
 * right away.
 */ /**
 * Applies the documents from a bundle to the "ground-state" (remote)
 * documents.
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ async function $63c47e8a587a7f36$var$__PRIVATE_localStoreApplyBundledDocuments(e, t, n, r) {
    const i = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    let s = $63c47e8a587a7f36$export$971d5caa766a69d7(), o = $63c47e8a587a7f36$var$__PRIVATE_mutableDocumentMap();
    for (const e of n){
        const n = t.Ks(e.metadata.name);
        e.document && (s = s.add(n));
        const r = t.qs(e);
        r.setReadTime(t.Us(e.metadata.readTime)), o = o.insert(n, r);
    }
    const _ = i.xs.newChangeBuffer({
        trackRemovals: !0
    }), a = await $63c47e8a587a7f36$var$__PRIVATE_localStoreAllocateTarget(i, function __PRIVATE_umbrellaTarget(e) {
        // It is OK that the path used for the query is not valid, because this will
        // not be read and queried.
        return $63c47e8a587a7f36$var$__PRIVATE_queryToTarget($63c47e8a587a7f36$export$a93c5207d687da10($63c47e8a587a7f36$export$db202ddc8be9136.fromString(`__bundle__/docs/${e}`)));
    }(r));
    // Allocates a target to hold all document keys from the bundle, such that
    // they will not get garbage collected right away.
    return i.persistence.runTransaction("Apply bundle documents", "readwrite", (e)=>$63c47e8a587a7f36$var$__PRIVATE_populateDocumentChangeBuffer(e, _, o).next((t)=>(_.apply(e), t)).next((t)=>i.li.removeMatchingKeysForTargetId(e, a.targetId).next(()=>i.li.addMatchingKeys(e, s, a.targetId)).next(()=>i.localDocuments.getLocalViewOfDocuments(e, t.Bs, t.Ls)).next(()=>t.Bs)));
}
/**
 * Returns a promise of a boolean to indicate if the given bundle has already
 * been loaded and the create time is newer than the current loading bundle.
 */ /**
 * Saves the given `NamedQuery` to local persistence.
 */ async function $63c47e8a587a7f36$var$__PRIVATE_localStoreSaveNamedQuery(e, t, n = $63c47e8a587a7f36$export$971d5caa766a69d7()) {
    // Allocate a target for the named query such that it can be resumed
    // from associated read time if users use it to listen.
    // NOTE: this also means if no corresponding target exists, the new target
    // will remain active and will not get collected, unless users happen to
    // unlisten the query somehow.
    const r = await $63c47e8a587a7f36$var$__PRIVATE_localStoreAllocateTarget(e, $63c47e8a587a7f36$var$__PRIVATE_queryToTarget($63c47e8a587a7f36$export$56c0d5a1e737357d(t.bundledQuery))), i = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    return i.persistence.runTransaction("Save named query", "readwrite", (e)=>{
        const s = $63c47e8a587a7f36$var$__PRIVATE_fromVersion(t.readTime);
        // Simply save the query itself if it is older than what the SDK already
        // has.
        if (r.snapshotVersion.compareTo(s) >= 0) return i.Pi.saveNamedQuery(e, t);
        // Update existing target data because the query from the bundle is newer.
        const o = r.withResumeToken($63c47e8a587a7f36$export$9d398bebfec1c039.EMPTY_BYTE_STRING, s);
        return i.vs = i.vs.insert(o.targetId, o), i.li.updateTargetData(e, o).next(()=>i.li.removeMatchingKeysForTargetId(e, r.targetId)).next(()=>i.li.addMatchingKeys(e, n, r.targetId)).next(()=>i.Pi.saveNamedQuery(e, t));
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The format of the LocalStorage key that stores the client state is:
//     firestore_clients_<persistence_prefix>_<instance_key>
const $63c47e8a587a7f36$var$kt = "firestore_clients";
/** Assembles the key for a client state in WebStorage */ function $63c47e8a587a7f36$var$createWebStorageClientStateKey(e, t) {
    return `${$63c47e8a587a7f36$var$kt}_${e}_${t}`;
}
// The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.
const $63c47e8a587a7f36$var$Kt = "firestore_mutations";
/** Assembles the key for a mutation batch in WebStorage */ function $63c47e8a587a7f36$var$createWebStorageMutationBatchKey(e, t, n) {
    let r = `${$63c47e8a587a7f36$var$Kt}_${e}_${n}`;
    return t.isAuthenticated() && (r += `_${t.uid}`), r;
}
// The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>
const $63c47e8a587a7f36$var$qt = "firestore_targets";
/** Assembles the key for a query state in WebStorage */ function $63c47e8a587a7f36$var$createWebStorageQueryTargetMetadataKey(e, t) {
    return `${$63c47e8a587a7f36$var$qt}_${e}_${t}`;
}
// The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $63c47e8a587a7f36$var$Ut = "SharedClientState";
/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */ // Visible for testing
class $63c47e8a587a7f36$var$__PRIVATE_MutationMetadata {
    constructor(e, t, n, r){
        this.user = e, this.batchId = t, this.state = n, this.error = r;
    }
    /**
     * Parses a MutationMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static $s(e, t, n) {
        const r = JSON.parse(n);
        let i, s = "object" == typeof r && -1 !== [
            "pending",
            "acknowledged",
            "rejected"
        ].indexOf(r.state) && (void 0 === r.error || "object" == typeof r.error);
        return s && r.error && (s = "string" == typeof r.error.message && "string" == typeof r.error.code, s && (i = new $63c47e8a587a7f36$export$4368d992c4eafac0(r.error.code, r.error.message))), s ? new $63c47e8a587a7f36$var$__PRIVATE_MutationMetadata(e, t, r.state, i) : ($63c47e8a587a7f36$var$__PRIVATE_logError($63c47e8a587a7f36$var$Ut, `Failed to parse mutation state for ID '${t}': ${n}`), null);
    }
    Ws() {
        const e = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(e);
    }
}
/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */ // Visible for testing
class $63c47e8a587a7f36$var$__PRIVATE_QueryTargetMetadata {
    constructor(e, t, n){
        this.targetId = e, this.state = t, this.error = n;
    }
    /**
     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static $s(e, t) {
        const n = JSON.parse(t);
        let r, i = "object" == typeof n && -1 !== [
            "not-current",
            "current",
            "rejected"
        ].indexOf(n.state) && (void 0 === n.error || "object" == typeof n.error);
        return i && n.error && (i = "string" == typeof n.error.message && "string" == typeof n.error.code, i && (r = new $63c47e8a587a7f36$export$4368d992c4eafac0(n.error.code, n.error.message))), i ? new $63c47e8a587a7f36$var$__PRIVATE_QueryTargetMetadata(e, n.state, r) : ($63c47e8a587a7f36$var$__PRIVATE_logError($63c47e8a587a7f36$var$Ut, `Failed to parse target state for ID '${e}': ${t}`), null);
    }
    Ws() {
        const e = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(e);
    }
}
/**
 * This class represents the immutable ClientState for a client read from
 * WebStorage, containing the list of active query targets.
 */ class $63c47e8a587a7f36$var$__PRIVATE_RemoteClientState {
    constructor(e, t){
        this.clientId = e, this.activeTargetIds = t;
    }
    /**
     * Parses a RemoteClientState from the JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static $s(e, t) {
        const n = JSON.parse(t);
        let r = "object" == typeof n && n.activeTargetIds instanceof Array, i = $63c47e8a587a7f36$var$__PRIVATE_targetIdSet();
        for(let e = 0; r && e < n.activeTargetIds.length; ++e)r = $63c47e8a587a7f36$var$isSafeInteger(n.activeTargetIds[e]), i = i.add(n.activeTargetIds[e]);
        return r ? new $63c47e8a587a7f36$var$__PRIVATE_RemoteClientState(e, i) : ($63c47e8a587a7f36$var$__PRIVATE_logError($63c47e8a587a7f36$var$Ut, `Failed to parse client data for instance '${e}': ${t}`), null);
    }
}
/**
 * This class represents the online state for all clients participating in
 * multi-tab. The online state is only written to by the primary client, and
 * used in secondary clients to update their query views.
 */ class $63c47e8a587a7f36$var$__PRIVATE_SharedOnlineState {
    constructor(e, t){
        this.clientId = e, this.onlineState = t;
    }
    /**
     * Parses a SharedOnlineState from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static $s(e) {
        const t = JSON.parse(e);
        return "object" == typeof t && -1 !== [
            "Unknown",
            "Online",
            "Offline"
        ].indexOf(t.onlineState) && "string" == typeof t.clientId ? new $63c47e8a587a7f36$var$__PRIVATE_SharedOnlineState(t.clientId, t.onlineState) : ($63c47e8a587a7f36$var$__PRIVATE_logError($63c47e8a587a7f36$var$Ut, `Failed to parse online state: ${e}`), null);
    }
}
/**
 * Metadata state of the local client. Unlike `RemoteClientState`, this class is
 * mutable and keeps track of all pending mutations, which allows us to
 * update the range of pending mutation batch IDs as new mutations are added or
 * removed.
 *
 * The data in `LocalClientState` is not read from WebStorage and instead
 * updated via its instance methods. The updated state can be serialized via
 * `toWebStorageJSON()`.
 */ // Visible for testing.
class $63c47e8a587a7f36$var$__PRIVATE_LocalClientState {
    constructor(){
        this.activeTargetIds = $63c47e8a587a7f36$var$__PRIVATE_targetIdSet();
    }
    Qs(e) {
        this.activeTargetIds = this.activeTargetIds.add(e);
    }
    Gs(e) {
        this.activeTargetIds = this.activeTargetIds.delete(e);
    }
    /**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */ Ws() {
        const e = {
            activeTargetIds: this.activeTargetIds.toArray(),
            updateTimeMs: Date.now()
        };
        return JSON.stringify(e);
    }
}
/**
 * `WebStorageSharedClientState` uses WebStorage (window.localStorage) as the
 * backing store for the SharedClientState. It keeps track of all active
 * clients and supports modifications of the local client's data.
 */ class $63c47e8a587a7f36$var$__PRIVATE_WebStorageSharedClientState {
    constructor(e, t, n, r, i){
        this.window = e, this.Ci = t, this.persistenceKey = n, this.zs = r, this.syncEngine = null, this.onlineStateHandler = null, this.sequenceNumberHandler = null, this.js = this.Hs.bind(this), this.Js = new $63c47e8a587a7f36$var$SortedMap($63c47e8a587a7f36$var$__PRIVATE_primitiveComparator), this.started = !1, /**
         * Captures WebStorage events that occur before `start()` is called. These
         * events are replayed once `WebStorageSharedClientState` is started.
         */ this.Zs = [];
        // Escape the special characters mentioned here:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
        const s = n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        this.storage = this.window.localStorage, this.currentUser = i, this.Xs = $63c47e8a587a7f36$var$createWebStorageClientStateKey(this.persistenceKey, this.zs), this.Ys = /** Assembles the key for the current sequence number. */ function createWebStorageSequenceNumberKey(e) {
            return `firestore_sequence_number_${e}`;
        }(this.persistenceKey), this.Js = this.Js.insert(this.zs, new $63c47e8a587a7f36$var$__PRIVATE_LocalClientState), this.eo = new RegExp(`^${$63c47e8a587a7f36$var$kt}_${s}_([^_]*)$`), this.no = new RegExp(`^${$63c47e8a587a7f36$var$Kt}_${s}_(\\d+)(?:_(.*))?$`), this.ro = new RegExp(`^${$63c47e8a587a7f36$var$qt}_${s}_(\\d+)$`), this.io = /** Assembles the key for the online state of the primary tab. */ function createWebStorageOnlineStateKey(e) {
            return `firestore_online_state_${e}`;
        }(this.persistenceKey), this.so = function createBundleLoadedKey(e) {
            return `firestore_bundle_loaded_v2_${e}`;
        }(this.persistenceKey), // Rather than adding the storage observer during start(), we add the
        // storage observer during initialization. This ensures that we collect
        // events before other components populate their initial state (during their
        // respective start() calls). Otherwise, we might for example miss a
        // mutation that is added after LocalStore's start() processed the existing
        // mutations but before we observe WebStorage events.
        this.window.addEventListener("storage", this.js);
    }
    /** Returns 'true' if WebStorage is available in the current environment. */ static v(e) {
        return !(!e || !e.localStorage);
    }
    async start() {
        // Retrieve the list of existing clients to backfill the data in
        // SharedClientState.
        const e = await this.syncEngine.hs();
        for (const t of e){
            if (t === this.zs) continue;
            const e = this.getItem($63c47e8a587a7f36$var$createWebStorageClientStateKey(this.persistenceKey, t));
            if (e) {
                const n = $63c47e8a587a7f36$var$__PRIVATE_RemoteClientState.$s(t, e);
                n && (this.Js = this.Js.insert(n.clientId, n));
            }
        }
        this.oo();
        // Check if there is an existing online state and call the callback handler
        // if applicable.
        const t = this.storage.getItem(this.io);
        if (t) {
            const e = this._o(t);
            e && this.ao(e);
        }
        for (const e of this.Zs)this.Hs(e);
        this.Zs = [], // Register a window unload hook to remove the client metadata entry from
        // WebStorage even if `shutdown()` was not called.
        this.window.addEventListener("pagehide", ()=>this.shutdown()), this.started = !0;
    }
    writeSequenceNumber(e) {
        this.setItem(this.Ys, JSON.stringify(e));
    }
    getAllActiveQueryTargets() {
        return this.uo(this.Js);
    }
    isActiveQueryTarget(e) {
        let t = !1;
        return this.Js.forEach((n, r)=>{
            r.activeTargetIds.has(e) && (t = !0);
        }), t;
    }
    addPendingMutation(e) {
        this.co(e, "pending");
    }
    updateMutationState(e, t, n) {
        this.co(e, t, n), // Once a final mutation result is observed by other clients, they no longer
        // access the mutation's metadata entry. Since WebStorage replays events
        // in order, it is safe to delete the entry right after updating it.
        this.lo(e);
    }
    addLocalQueryTarget(e, t = !0) {
        let n = "not-current";
        // Lookup an existing query state if the target ID was already registered
        // by another tab
        if (this.isActiveQueryTarget(e)) {
            const t = this.storage.getItem($63c47e8a587a7f36$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
            if (t) {
                const r = $63c47e8a587a7f36$var$__PRIVATE_QueryTargetMetadata.$s(e, t);
                r && (n = r.state);
            }
        }
        // If the query is listening to cache only, the target ID should not be registered with the
        // local Firestore client as an active watch target.
        return t && this.ho.Qs(e), this.oo(), n;
    }
    removeLocalQueryTarget(e) {
        this.ho.Gs(e), this.oo();
    }
    isLocalQueryTarget(e) {
        return this.ho.activeTargetIds.has(e);
    }
    clearQueryState(e) {
        this.removeItem($63c47e8a587a7f36$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
    }
    updateQueryState(e, t, n) {
        this.Po(e, t, n);
    }
    handleUserChange(e, t, n) {
        t.forEach((e)=>{
            this.lo(e);
        }), this.currentUser = e, n.forEach((e)=>{
            this.addPendingMutation(e);
        });
    }
    setOnlineState(e) {
        this.To(e);
    }
    notifyBundleLoaded(e) {
        this.Io(e);
    }
    shutdown() {
        this.started && (this.window.removeEventListener("storage", this.js), this.removeItem(this.Xs), this.started = !1);
    }
    getItem(e) {
        const t = this.storage.getItem(e);
        return $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Ut, "READ", e, t), t;
    }
    setItem(e, t) {
        $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Ut, "SET", e, t), this.storage.setItem(e, t);
    }
    removeItem(e) {
        $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Ut, "REMOVE", e), this.storage.removeItem(e);
    }
    Hs(e) {
        // Note: The function is typed to take Event to be interface-compatible with
        // `Window.addEventListener`.
        const t = e;
        if (t.storageArea === this.storage) {
            if ($63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Ut, "EVENT", t.key, t.newValue), t.key === this.Xs) return void $63c47e8a587a7f36$var$__PRIVATE_logError("Received WebStorage notification for local change. Another client might have garbage-collected our state");
            this.Ci.enqueueRetryable(async ()=>{
                if (this.started) {
                    if (null !== t.key) {
                        if (this.eo.test(t.key)) {
                            if (null == t.newValue) {
                                const e = this.Eo(t.key);
                                return this.Ro(e, null);
                            }
                            {
                                const e = this.Ao(t.key, t.newValue);
                                if (e) return this.Ro(e.clientId, e);
                            }
                        } else if (this.no.test(t.key)) {
                            if (null !== t.newValue) {
                                const e = this.Vo(t.key, t.newValue);
                                if (e) return this.mo(e);
                            }
                        } else if (this.ro.test(t.key)) {
                            if (null !== t.newValue) {
                                const e = this.fo(t.key, t.newValue);
                                if (e) return this.po(e);
                            }
                        } else if (t.key === this.io) {
                            if (null !== t.newValue) {
                                const e = this._o(t.newValue);
                                if (e) return this.ao(e);
                            }
                        } else if (t.key === this.Ys) {
                            const e = function __PRIVATE_fromWebStorageSequenceNumber(e) {
                                let t = $63c47e8a587a7f36$var$__PRIVATE_ListenSequence.ce;
                                if (null != e) try {
                                    const n = JSON.parse(e);
                                    $63c47e8a587a7f36$export$c18d01048907ea92("number" == typeof n, 30636, {
                                        yo: e
                                    }), t = n;
                                } catch (e) {
                                    $63c47e8a587a7f36$var$__PRIVATE_logError($63c47e8a587a7f36$var$Ut, "Failed to read sequence number from WebStorage", e);
                                }
                                return t;
                            }(t.newValue);
                            e !== $63c47e8a587a7f36$var$__PRIVATE_ListenSequence.ce && this.sequenceNumberHandler(e);
                        } else if (t.key === this.so) {
                            const e = this.wo(t.newValue);
                            await Promise.all(e.map((e)=>this.syncEngine.bo(e)));
                        }
                    }
                } else this.Zs.push(t);
            });
        }
    }
    get ho() {
        return this.Js.get(this.zs);
    }
    oo() {
        this.setItem(this.Xs, this.ho.Ws());
    }
    co(e, t, n) {
        const r = new $63c47e8a587a7f36$var$__PRIVATE_MutationMetadata(this.currentUser, e, t, n), i = $63c47e8a587a7f36$var$createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
        this.setItem(i, r.Ws());
    }
    lo(e) {
        const t = $63c47e8a587a7f36$var$createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
        this.removeItem(t);
    }
    To(e) {
        const t = {
            clientId: this.zs,
            onlineState: e
        };
        this.storage.setItem(this.io, JSON.stringify(t));
    }
    Po(e, t, n) {
        const r = $63c47e8a587a7f36$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e), i = new $63c47e8a587a7f36$var$__PRIVATE_QueryTargetMetadata(e, t, n);
        this.setItem(r, i.Ws());
    }
    Io(e) {
        const t = JSON.stringify(Array.from(e));
        this.setItem(this.so, t);
    }
    /**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */ Eo(e) {
        const t = this.eo.exec(e);
        return t ? t[1] : null;
    }
    /**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */ Ao(e, t) {
        const n = this.Eo(e);
        return $63c47e8a587a7f36$var$__PRIVATE_RemoteClientState.$s(n, t);
    }
    /**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ Vo(e, t) {
        const n = this.no.exec(e), r = Number(n[1]), i = void 0 !== n[2] ? n[2] : null;
        return $63c47e8a587a7f36$var$__PRIVATE_MutationMetadata.$s(new $63c47e8a587a7f36$var$User(i), r, t);
    }
    /**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ fo(e, t) {
        const n = this.ro.exec(e), r = Number(n[1]);
        return $63c47e8a587a7f36$var$__PRIVATE_QueryTargetMetadata.$s(r, t);
    }
    /**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ _o(e) {
        return $63c47e8a587a7f36$var$__PRIVATE_SharedOnlineState.$s(e);
    }
    wo(e) {
        return JSON.parse(e);
    }
    async mo(e) {
        if (e.user.uid === this.currentUser.uid) return this.syncEngine.So(e.batchId, e.state, e.error);
        $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Ut, `Ignoring mutation for non-active user ${e.user.uid}`);
    }
    po(e) {
        return this.syncEngine.Do(e.targetId, e.state, e.error);
    }
    Ro(e, t) {
        const n = t ? this.Js.insert(e, t) : this.Js.remove(e), r = this.uo(this.Js), i = this.uo(n), s = [], o = [];
        return i.forEach((e)=>{
            r.has(e) || s.push(e);
        }), r.forEach((e)=>{
            i.has(e) || o.push(e);
        }), this.syncEngine.Co(s, o).then(()=>{
            this.Js = n;
        });
    }
    ao(e) {
        // We check whether the client that wrote this online state is still active
        // by comparing its client ID to the list of clients kept active in
        // IndexedDb. If a client does not update their IndexedDb client state
        // within 5 seconds, it is considered inactive and we don't emit an online
        // state event.
        this.Js.get(e.clientId) && this.onlineStateHandler(e.onlineState);
    }
    uo(e) {
        let t = $63c47e8a587a7f36$var$__PRIVATE_targetIdSet();
        return e.forEach((e, n)=>{
            t = t.unionWith(n.activeTargetIds);
        }), t;
    }
}
class $63c47e8a587a7f36$var$__PRIVATE_MemorySharedClientState {
    constructor(){
        this.vo = new $63c47e8a587a7f36$var$__PRIVATE_LocalClientState, this.Fo = {}, this.onlineStateHandler = null, this.sequenceNumberHandler = null;
    }
    addPendingMutation(e) {
    // No op.
    }
    updateMutationState(e, t, n) {
    // No op.
    }
    addLocalQueryTarget(e, t = !0) {
        return t && this.vo.Qs(e), this.Fo[e] || "not-current";
    }
    updateQueryState(e, t, n) {
        this.Fo[e] = t;
    }
    removeLocalQueryTarget(e) {
        this.vo.Gs(e);
    }
    isLocalQueryTarget(e) {
        return this.vo.activeTargetIds.has(e);
    }
    clearQueryState(e) {
        delete this.Fo[e];
    }
    getAllActiveQueryTargets() {
        return this.vo.activeTargetIds;
    }
    isActiveQueryTarget(e) {
        return this.vo.activeTargetIds.has(e);
    }
    start() {
        return this.vo = new $63c47e8a587a7f36$var$__PRIVATE_LocalClientState, Promise.resolve();
    }
    handleUserChange(e, t, n) {
    // No op.
    }
    setOnlineState(e) {
    // No op.
    }
    shutdown() {}
    writeSequenceNumber(e) {}
    notifyBundleLoaded(e) {
    // No op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $63c47e8a587a7f36$var$__PRIVATE_NoopConnectivityMonitor {
    Mo(e) {
    // No-op.
    }
    shutdown() {
    // No-op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by BrowserConnectivityMonitor.isAvailable()
/* eslint-disable no-restricted-globals */ const $63c47e8a587a7f36$var$$t = "ConnectivityMonitor";
/**
 * Browser implementation of ConnectivityMonitor.
 */ class $63c47e8a587a7f36$var$__PRIVATE_BrowserConnectivityMonitor {
    constructor(){
        this.xo = ()=>this.Oo(), this.No = ()=>this.Bo(), this.Lo = [], this.ko();
    }
    Mo(e) {
        this.Lo.push(e);
    }
    shutdown() {
        window.removeEventListener("online", this.xo), window.removeEventListener("offline", this.No);
    }
    ko() {
        window.addEventListener("online", this.xo), window.addEventListener("offline", this.No);
    }
    Oo() {
        $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$$t, "Network connectivity changed: AVAILABLE");
        for (const e of this.Lo)e(0 /* NetworkStatus.AVAILABLE */ );
    }
    Bo() {
        $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$$t, "Network connectivity changed: UNAVAILABLE");
        for (const e of this.Lo)e(1 /* NetworkStatus.UNAVAILABLE */ );
    }
    // TODO(chenbrian): Consider passing in window either into this component or
    // here for testing via FakeWindow.
    /** Checks that all used attributes of window are available. */ static v() {
        return "undefined" != typeof window && void 0 !== window.addEventListener && void 0 !== window.removeEventListener;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The value returned from the most recent invocation of
 * `generateUniqueDebugId()`, or null if it has never been invoked.
 */ let $63c47e8a587a7f36$var$Wt = null;
/**
 * Generates and returns an initial value for `lastUniqueDebugId`.
 *
 * The returned value is randomly selected from a range of integers that are
 * represented as 8 hexadecimal digits. This means that (within reason) any
 * numbers generated by incrementing the returned number by 1 will also be
 * represented by 8 hexadecimal digits. This leads to all "IDs" having the same
 * length when converted to a hexadecimal string, making reading logs containing
 * these IDs easier to follow. And since the return value is randomly selected
 * it will help to differentiate between logs from different executions.
 */ /**
 * Generates and returns a unique ID as a hexadecimal string.
 *
 * The returned ID is intended to be used in debug logging messages to help
 * correlate log messages that may be spatially separated in the logs, but
 * logically related. For example, a network connection could include the same
 * "debug ID" string in all of its log messages to help trace a specific
 * connection over time.
 *
 * @returns the 10-character generated ID (e.g. "0xa1b2c3d4").
 */ function $63c47e8a587a7f36$var$__PRIVATE_generateUniqueDebugId() {
    return null === $63c47e8a587a7f36$var$Wt ? $63c47e8a587a7f36$var$Wt = function __PRIVATE_generateInitialUniqueDebugId() {
        return 268435456 + Math.round(2147483648 * Math.random());
    }() : $63c47e8a587a7f36$var$Wt++, "0x" + $63c47e8a587a7f36$var$Wt.toString(16);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $63c47e8a587a7f36$var$Qt = "RestConnection", $63c47e8a587a7f36$var$Gt = {
    BatchGetDocuments: "batchGet",
    Commit: "commit",
    RunQuery: "runQuery",
    RunAggregationQuery: "runAggregationQuery",
    ExecutePipeline: "executePipeline"
};
/**
 * Maps RPC names to the corresponding REST endpoint name.
 *
 * We use array notation to avoid mangling.
 */ /**
 * Base class for all Rest-based connections to the backend (WebChannel and
 * HTTP).
 */ class $63c47e8a587a7f36$var$__PRIVATE_RestConnection {
    get Ko() {
        // Both `invokeRPC()` and `invokeStreamingRPC()` use their `path` arguments to determine
        // where to run the query, and expect the `request` to NOT specify the "path".
        return !1;
    }
    constructor(e){
        this.databaseInfo = e, this.databaseId = e.databaseId;
        const t = e.ssl ? "https" : "http", n = encodeURIComponent(this.databaseId.projectId), r = encodeURIComponent(this.databaseId.database);
        this.qo = t + "://" + e.host, this.Uo = `projects/${n}/databases/${r}`, this.$o = this.databaseId.database === $63c47e8a587a7f36$var$st ? `project_id=${n}` : `project_id=${n}&database_id=${r}`;
    }
    Wo(e, t, n, r, i) {
        const s = $63c47e8a587a7f36$var$__PRIVATE_generateUniqueDebugId(), o = this.Qo(e, t.toUriEncodedString());
        $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Qt, `Sending RPC '${e}' ${s}:`, o, n);
        const _ = {
            "google-cloud-resource-prefix": this.Uo,
            "x-goog-request-params": this.$o
        };
        this.Go(_, r, i);
        const { host: a } = new URL(o), c = (0, $3117f6f4eeb4c314$export$5b4d24b45140ad90)(a);
        return this.zo(e, o, _, n, c).then((t)=>($63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Qt, `Received RPC '${e}' ${s}: `, t), t), (t)=>{
            throw $63c47e8a587a7f36$export$4c3d22f3d993c33f($63c47e8a587a7f36$var$Qt, `RPC '${e}' ${s} failed with error: `, t, "url: ", o, "request:", n), t;
        });
    }
    jo(e, t, n, r, i, s) {
        // The REST API automatically aggregates all of the streamed results, so we
        // can just use the normal invoke() method.
        return this.Wo(e, t, n, r, i);
    }
    /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */ Go(e, t, n) {
        e["X-Goog-Api-Client"] = // SDK_VERSION is updated to different value at runtime depending on the entry point,
        // so we need to get its value when we need it in a function.
        function __PRIVATE_getGoogApiClientValue() {
            return "gl-js/ fire/" + $63c47e8a587a7f36$var$S;
        }(), // Content-Type: text/plain will avoid preflight requests which might
        // mess with CORS and redirects by proxies. If we add custom headers
        // we will need to change this code to potentially use the $httpOverwrite
        // parameter supported by ESF to avoid triggering preflight requests.
        e["Content-Type"] = "text/plain", this.databaseInfo.appId && (e["X-Firebase-GMPID"] = this.databaseInfo.appId), t && t.headers.forEach((t, n)=>e[n] = t), n && n.headers.forEach((t, n)=>e[n] = t);
    }
    Qo(e, t) {
        const n = $63c47e8a587a7f36$var$Gt[e];
        let r = `${this.qo}/v1/${t}:${n}`;
        return this.databaseInfo.apiKey && (r = `${r}?key=${encodeURIComponent(this.databaseInfo.apiKey)}`), r;
    }
    /**
     * Closes and cleans up any resources associated with the connection. This
     * implementation is a no-op because there are no resources associated
     * with the RestConnection that need to be cleaned up.
     */ terminate() {
    // No-op
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a simple helper class that implements the Stream interface to
 * bridge to other implementations that are streams but do not implement the
 * interface. The stream callbacks are invoked with the callOn... methods.
 */ class $63c47e8a587a7f36$var$__PRIVATE_StreamBridge {
    constructor(e){
        this.Ho = e.Ho, this.Jo = e.Jo;
    }
    Zo(e) {
        this.Xo = e;
    }
    Yo(e) {
        this.e_ = e;
    }
    t_(e) {
        this.n_ = e;
    }
    onMessage(e) {
        this.r_ = e;
    }
    close() {
        this.Jo();
    }
    send(e) {
        this.Ho(e);
    }
    i_() {
        this.Xo();
    }
    s_() {
        this.e_();
    }
    o_(e) {
        this.n_(e);
    }
    __(e) {
        this.r_(e);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $63c47e8a587a7f36$var$zt = "WebChannelConnection", $63c47e8a587a7f36$var$__PRIVATE_unguardedEventListen = (e, t, n)=>{
    // TODO(dimond): closure typing seems broken because WebChannel does
    // not implement goog.events.Listenable
    e.listen(t, (e)=>{
        try {
            n(e);
        } catch (e) {
            setTimeout(()=>{
                throw e;
            }, 0);
        }
    });
};
class $63c47e8a587a7f36$var$__PRIVATE_WebChannelConnection extends $63c47e8a587a7f36$var$__PRIVATE_RestConnection {
    constructor(e){
        super(e), /** A collection of open WebChannel instances */ this.a_ = [], this.forceLongPolling = e.forceLongPolling, this.autoDetectLongPolling = e.autoDetectLongPolling, this.useFetchStreams = e.useFetchStreams, this.longPollingOptions = e.longPollingOptions;
    }
    /**
     * Initialize STAT_EVENT listener once. Subsequent calls are a no-op.
     * getStatEventTarget() returns the same target every time.
     */ static u_() {
        if (!$63c47e8a587a7f36$var$__PRIVATE_WebChannelConnection.c_) {
            const e = (0, $87c0e2812a00f0b8$export$888d0d9ab79d08fc)();
            $63c47e8a587a7f36$var$__PRIVATE_unguardedEventListen(e, (0, $87c0e2812a00f0b8$export$d61e24a684f9e51).STAT_EVENT, (e)=>{
                e.stat === (0, $87c0e2812a00f0b8$export$cbbc350c1dfc80cb).PROXY ? $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$zt, "STAT_EVENT: detected buffering proxy") : e.stat === (0, $87c0e2812a00f0b8$export$cbbc350c1dfc80cb).NOPROXY && $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$zt, "STAT_EVENT: detected no buffering proxy");
            }), $63c47e8a587a7f36$var$__PRIVATE_WebChannelConnection.c_ = !0;
        }
    }
    zo(e, t, n, r, i) {
        const s = $63c47e8a587a7f36$var$__PRIVATE_generateUniqueDebugId();
        return new Promise((i, o)=>{
            const _ = new (0, $87c0e2812a00f0b8$export$26404658cda3ee02);
            _.setWithCredentials(!0), _.listenOnce((0, $87c0e2812a00f0b8$export$3d7865934588d77e).COMPLETE, ()=>{
                try {
                    switch(_.getLastErrorCode()){
                        case (0, $87c0e2812a00f0b8$export$d4e71bc0b80dc0fb).NO_ERROR:
                            const t = _.getResponseJson();
                            $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$zt, `XHR for RPC '${e}' ${s} received:`, JSON.stringify(t)), i(t);
                            break;
                        case (0, $87c0e2812a00f0b8$export$d4e71bc0b80dc0fb).TIMEOUT:
                            $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$zt, `RPC '${e}' ${s} timed out`), o(new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.DEADLINE_EXCEEDED, "Request time out"));
                            break;
                        case (0, $87c0e2812a00f0b8$export$d4e71bc0b80dc0fb).HTTP_ERROR:
                            const n = _.getStatus();
                            if ($63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$zt, `RPC '${e}' ${s} failed with status:`, n, "response text:", _.getResponseText()), n > 0) {
                                let e = _.getResponseJson();
                                Array.isArray(e) && (e = e[0]);
                                const t = e?.error;
                                if (t && t.status && t.message) {
                                    const e = function __PRIVATE_mapCodeFromHttpResponseErrorStatus(e) {
                                        const t = e.toLowerCase().replace(/_/g, "-");
                                        return Object.values($63c47e8a587a7f36$export$e7094788287c5e9b).indexOf(t) >= 0 ? t : $63c47e8a587a7f36$export$e7094788287c5e9b.UNKNOWN;
                                    }(t.status);
                                    o(new $63c47e8a587a7f36$export$4368d992c4eafac0(e, t.message));
                                } else o(new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.UNKNOWN, "Server responded with status " + _.getStatus()));
                            } else // If we received an HTTP_ERROR but there's no status code,
                            // it's most probably a connection issue
                            o(new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.UNAVAILABLE, "Connection failed."));
                            break;
                        default:
                            $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(9055, {
                                l_: e,
                                streamId: s,
                                h_: _.getLastErrorCode(),
                                P_: _.getLastError()
                            });
                    }
                } finally{
                    $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$zt, `RPC '${e}' ${s} completed.`);
                }
            });
            const a = JSON.stringify(r);
            $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$zt, `RPC '${e}' ${s} sending request:`, r), _.send(t, "POST", a, n, 15);
        });
    }
    T_(e, t, n) {
        const r = $63c47e8a587a7f36$var$__PRIVATE_generateUniqueDebugId(), i = [
            this.qo,
            "/",
            "google.firestore.v1.Firestore",
            "/",
            e,
            "/channel"
        ], s = this.createWebChannelTransport(), o = {
            // Required for backend stickiness, routing behavior is based on this
            // parameter.
            httpSessionIdParam: "gsessionid",
            initMessageHeaders: {},
            messageUrlParams: {
                // This param is used to improve routing and project isolation by the
                // backend and must be included in every request.
                database: `projects/${this.databaseId.projectId}/databases/${this.databaseId.database}`
            },
            sendRawJson: !0,
            supportsCrossDomainXhr: !0,
            internalChannelParams: {
                // Override the default timeout (randomized between 10-20 seconds) since
                // a large write batch on a slow internet connection may take a long
                // time to send to the backend. Rather than have WebChannel impose a
                // tight timeout which could lead to infinite timeouts and retries, we
                // set it very large (5-10 minutes) and rely on the browser's builtin
                // timeouts to kick in if the request isn't working.
                forwardChannelRequestTimeoutMs: 6e5
            },
            forceLongPolling: this.forceLongPolling,
            detectBufferingProxy: this.autoDetectLongPolling
        }, _ = this.longPollingOptions.timeoutSeconds;
        void 0 !== _ && (o.longPollingTimeout = Math.round(1e3 * _)), this.useFetchStreams && (o.useFetchStreams = !0), this.Go(o.initMessageHeaders, t, n), // Sending the custom headers we just added to request.initMessageHeaders
        // (Authorization, etc.) will trigger the browser to make a CORS preflight
        // request because the XHR will no longer meet the criteria for a "simple"
        // CORS request:
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
        // Therefore to avoid the CORS preflight request (an extra network
        // roundtrip), we use the encodeInitMessageHeaders option to specify that
        // the headers should instead be encoded in the request's POST payload,
        // which is recognized by the webchannel backend.
        o.encodeInitMessageHeaders = !0;
        const a = i.join("");
        $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$zt, `Creating RPC '${e}' stream ${r}: ${a}`, o);
        const u = s.createWebChannel(a, o);
        this.I_(u);
        // WebChannel supports sending the first message with the handshake - saving
        // a network round trip. However, it will have to call send in the same
        // JS event loop as open. In order to enforce this, we delay actually
        // opening the WebChannel until send is called. Whether we have called
        // open is tracked with this variable.
        let c = !1, l = !1;
        // A flag to determine whether the stream was closed (by us or through an
        // error/close event) to avoid delivering multiple close events or sending
        // on a closed stream
        const h = new $63c47e8a587a7f36$var$__PRIVATE_StreamBridge({
            Ho: (t)=>{
                l ? $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$zt, `Not sending because RPC '${e}' stream ${r} is closed:`, t) : (c || ($63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$zt, `Opening RPC '${e}' stream ${r} transport.`), u.open(), c = !0), $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$zt, `RPC '${e}' stream ${r} sending:`, t), u.send(t));
            },
            Jo: ()=>u.close()
        });
        return $63c47e8a587a7f36$var$__PRIVATE_unguardedEventListen(u, (0, $87c0e2812a00f0b8$export$aa726fb96ad3e039).EventType.OPEN, ()=>{
            l || ($63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$zt, `RPC '${e}' stream ${r} transport opened.`), h.i_());
        }), $63c47e8a587a7f36$var$__PRIVATE_unguardedEventListen(u, (0, $87c0e2812a00f0b8$export$aa726fb96ad3e039).EventType.CLOSE, ()=>{
            l || (l = !0, $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$zt, `RPC '${e}' stream ${r} transport closed`), h.o_(), this.E_(u));
        }), $63c47e8a587a7f36$var$__PRIVATE_unguardedEventListen(u, (0, $87c0e2812a00f0b8$export$aa726fb96ad3e039).EventType.ERROR, (t)=>{
            l || (l = !0, $63c47e8a587a7f36$export$4c3d22f3d993c33f($63c47e8a587a7f36$var$zt, `RPC '${e}' stream ${r} transport errored. Name:`, t.name, "Message:", t.message), h.o_(new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.UNAVAILABLE, "The operation could not be completed")));
        }), $63c47e8a587a7f36$var$__PRIVATE_unguardedEventListen(u, (0, $87c0e2812a00f0b8$export$aa726fb96ad3e039).EventType.MESSAGE, (t)=>{
            if (!l) {
                const n = t.data[0];
                $63c47e8a587a7f36$export$c18d01048907ea92(!!n, 16349);
                // TODO(b/35143891): There is a bug in One Platform that caused errors
                // (and only errors) to be wrapped in an extra array. To be forward
                // compatible with the bug we need to check either condition. The latter
                // can be removed once the fix has been rolled out.
                // Use any because msgData.error is not typed.
                const i = n, s = i?.error || i[0]?.error;
                if (s) {
                    $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$zt, `RPC '${e}' stream ${r} received error:`, s);
                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
                    const t = s.status;
                    let n = /**
 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
 *
 * @returns The Code equivalent to the given status string or undefined if
 *     there is no match.
 */ function __PRIVATE_mapCodeFromRpcStatus(e) {
                        // lookup by string
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const t = $63c47e8a587a7f36$var$At[e];
                        if (void 0 !== t) return $63c47e8a587a7f36$var$__PRIVATE_mapCodeFromRpcCode(t);
                    }(t), i = s.message;
                    "NOT_FOUND" === t && i.includes("database") && i.includes("does not exist") && i.includes(this.databaseId.database) && $63c47e8a587a7f36$export$4c3d22f3d993c33f(`Database '${this.databaseId.database}' not found. Please check your project configuration.`), void 0 === n && (n = $63c47e8a587a7f36$export$e7094788287c5e9b.INTERNAL, i = "Unknown error status: " + t + " with message " + s.message), // Mark closed so no further events are propagated
                    l = !0, h.o_(new $63c47e8a587a7f36$export$4368d992c4eafac0(n, i)), u.close();
                } else $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$zt, `RPC '${e}' stream ${r} received:`, n), h.__(n);
            }
        }), // Ensure that event listeners are configured for STAT_EVENTs.
        $63c47e8a587a7f36$var$__PRIVATE_WebChannelConnection.u_(), setTimeout(()=>{
            // Technically we could/should wait for the WebChannel opened event,
            // but because we want to send the first message with the WebChannel
            // handshake we pretend the channel opened here (asynchronously), and
            // then delay the actual open until the first message is sent.
            h.s_();
        }, 0), h;
    }
    /**
     * Closes and cleans up any resources associated with the connection.
     */ terminate() {
        // If the Firestore instance is terminated, we will explicitly
        // close any remaining open WebChannel instances.
        this.a_.forEach((e)=>e.close()), this.a_ = [];
    }
    /**
     * Add a WebChannel instance to the collection of open instances.
     * @param webChannel
     */ I_(e) {
        this.a_.push(e);
    }
    /**
     * Remove a WebChannel instance from the collection of open instances.
     * @param webChannel
     */ E_(e) {
        this.a_ = this.a_.filter((t)=>t === e);
    }
    /**
     * Modifies the headers for a request, adding the api key if present,
     * and then calling super.modifyHeadersForRequest
     */ Go(e, t, n) {
        super.Go(e, t, n), // For web channel streams, we want to send the api key in the headers.
        this.databaseInfo.apiKey && (e["x-goog-api-key"] = this.databaseInfo.apiKey);
    }
    /**
     * Wrapped for mocking.
     * @protected
     */ createWebChannelTransport() {
        return (0, $87c0e2812a00f0b8$export$66869136fc133c3a)();
    }
}
/**
 * Track if the STAT_EVENT listener has been initialized.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Initializes the WebChannelConnection for the browser. */ function $63c47e8a587a7f36$var$__PRIVATE_newConnection(e) {
    return new $63c47e8a587a7f36$var$__PRIVATE_WebChannelConnection(e);
}
/** Return the Platform-specific connectivity monitor. */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The Platform's 'window' implementation or null if not available. */ function $63c47e8a587a7f36$var$__PRIVATE_getWindow() {
    // `window` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof window ? window : null;
}
/** The Platform's 'document' implementation or null if not available. */ function $63c47e8a587a7f36$var$getDocument() {
    // `document` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof document ? document : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $63c47e8a587a7f36$export$b4171a6734a65d42(e) {
    return new $63c47e8a587a7f36$var$JsonProtoSerializer(e, /* useProto3Json= */ !0);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $63c47e8a587a7f36$var$__PRIVATE_WebChannelConnection.c_ = !1;
/**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */ class $63c47e8a587a7f36$var$__PRIVATE_ExponentialBackoff {
    constructor(/**
     * The AsyncQueue to run backoff operations on.
     */ e, /**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */ t, /**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */ n = 1e3, r = 1.5, i = 6e4){
        this.Ci = e, this.timerId = t, this.R_ = n, this.A_ = r, this.V_ = i, this.d_ = 0, this.m_ = null, /** The last backoff attempt, as epoch milliseconds. */ this.f_ = Date.now(), this.reset();
    }
    /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */ reset() {
        this.d_ = 0;
    }
    /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */ g_() {
        this.d_ = this.V_;
    }
    /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */ p_(e) {
        // Cancel any pending backoff operation.
        this.cancel();
        // First schedule using the current base (which may be 0 and should be
        // honored as such).
        const t = Math.floor(this.d_ + this.y_()), n = Math.max(0, Date.now() - this.f_), r = Math.max(0, t - n);
        // Guard against lastAttemptTime being in the future due to a clock change.
        r > 0 && $63c47e8a587a7f36$export$21579262ef46735b("ExponentialBackoff", `Backing off for ${r} ms (base delay: ${this.d_} ms, delay with jitter: ${t} ms, last attempt: ${n} ms ago)`), this.m_ = this.Ci.enqueueAfterDelay(this.timerId, r, ()=>(this.f_ = Date.now(), e())), // Apply backoff factor to determine next delay and ensure it is within
        // bounds.
        this.d_ *= this.A_, this.d_ < this.R_ && (this.d_ = this.R_), this.d_ > this.V_ && (this.d_ = this.V_);
    }
    w_() {
        null !== this.m_ && (this.m_.skipDelay(), this.m_ = null);
    }
    cancel() {
        null !== this.m_ && (this.m_.cancel(), this.m_ = null);
    }
    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */ y_() {
        return (Math.random() - .5) * this.d_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $63c47e8a587a7f36$var$jt = "PersistentStream";
/** The time a stream stays open after it is marked idle. */ /**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */ class $63c47e8a587a7f36$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s, o, _){
        this.Ci = e, this.b_ = n, this.S_ = r, this.connection = i, this.authCredentialsProvider = s, this.appCheckCredentialsProvider = o, this.listener = _, this.state = 0 /* PersistentStreamState.Initial */ , /**
         * A close count that's incremented every time the stream is closed; used by
         * getCloseGuardedDispatcher() to invalidate callbacks that happen after
         * close.
         */ this.D_ = 0, this.C_ = null, this.v_ = null, this.stream = null, /**
         * Count of response messages received.
         */ this.F_ = 0, this.M_ = new $63c47e8a587a7f36$var$__PRIVATE_ExponentialBackoff(e, t);
    }
    /**
     * Returns true if start() has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use isOpen() to determine if the stream is open and ready for
     * outbound requests.
     */ x_() {
        return 1 /* PersistentStreamState.Starting */  === this.state || 5 /* PersistentStreamState.Backoff */  === this.state || this.O_();
    }
    /**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */ O_() {
        return 2 /* PersistentStreamState.Open */  === this.state || 3 /* PersistentStreamState.Healthy */  === this.state;
    }
    /**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */ start() {
        this.F_ = 0, 4 /* PersistentStreamState.Error */  !== this.state ? this.auth() : this.N_();
    }
    /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */ async stop() {
        this.x_() && await this.close(0 /* PersistentStreamState.Initial */ );
    }
    /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */ B_() {
        this.state = 0 /* PersistentStreamState.Initial */ , this.M_.reset();
    }
    /**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */ L_() {
        // Starts the idle time if we are in state 'Open' and are not yet already
        // running a timer (in which case the previous idle timeout still applies).
        this.O_() && null === this.C_ && (this.C_ = this.Ci.enqueueAfterDelay(this.b_, 6e4, ()=>this.k_()));
    }
    /** Sends a message to the underlying stream. */ K_(e) {
        this.q_(), this.stream.send(e);
    }
    /** Called by the idle timer when the stream should close due to inactivity. */ async k_() {
        if (this.O_()) // When timing out an idle stream there's no reason to force the stream into backoff when
        // it restarts so set the stream state to Initial instead of Error.
        return this.close(0 /* PersistentStreamState.Initial */ );
    }
    /** Marks the stream as active again. */ q_() {
        this.C_ && (this.C_.cancel(), this.C_ = null);
    }
    /** Cancels the health check delayed operation. */ U_() {
        this.v_ && (this.v_.cancel(), this.v_ = null);
    }
    /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState - the intended state of the stream after closing.
     * @param error - the error the connection was closed with.
     */ async close(e, t) {
        // Cancel any outstanding timers (they're guaranteed not to execute).
        this.q_(), this.U_(), this.M_.cancel(), // Invalidates any stream-related callbacks (e.g. from auth or the
        // underlying stream), guaranteeing they won't execute.
        this.D_++, 4 /* PersistentStreamState.Error */  !== e ? // If this is an intentional close ensure we don't delay our next connection attempt.
        this.M_.reset() : t && t.code === $63c47e8a587a7f36$export$e7094788287c5e9b.RESOURCE_EXHAUSTED ? // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
        ($63c47e8a587a7f36$var$__PRIVATE_logError(t.toString()), $63c47e8a587a7f36$var$__PRIVATE_logError("Using maximum backoff delay to prevent overloading the backend."), this.M_.g_()) : t && t.code === $63c47e8a587a7f36$export$e7094788287c5e9b.UNAUTHENTICATED && 3 /* PersistentStreamState.Healthy */  !== this.state && // "unauthenticated" error means the token was rejected. This should rarely
        // happen since both Auth and AppCheck ensure a sufficient TTL when we
        // request a token. If a user manually resets their system clock this can
        // fail, however. In this case, we should get a Code.UNAUTHENTICATED error
        // before we received the first message and we need to invalidate the token
        // to ensure that we fetch a new token.
        (this.authCredentialsProvider.invalidateToken(), this.appCheckCredentialsProvider.invalidateToken()), // Clean up the underlying stream because we are no longer interested in events.
        null !== this.stream && (this.W_(), this.stream.close(), this.stream = null), // This state must be assigned before calling onClose() to allow the callback to
        // inhibit backoff or otherwise manipulate the state in its non-started state.
        this.state = e, // Notify the listener that the stream closed.
        await this.listener.t_(t);
    }
    /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */ W_() {}
    auth() {
        this.state = 1 /* PersistentStreamState.Starting */ ;
        const e = this.Q_(this.D_), t = this.D_;
        // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
        Promise.all([
            this.authCredentialsProvider.getToken(),
            this.appCheckCredentialsProvider.getToken()
        ]).then(([e, n])=>{
            // Stream can be stopped while waiting for authentication.
            // TODO(mikelehen): We really should just use dispatchIfNotClosed
            // and let this dispatch onto the queue, but that opened a spec test can
            // of worms that I don't want to deal with in this PR.
            this.D_ === t && // Normally we'd have to schedule the callback on the AsyncQueue.
            // However, the following calls are safe to be called outside the
            // AsyncQueue since they don't chain asynchronous calls
            this.G_(e, n);
        }, (t)=>{
            e(()=>{
                const e = new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.UNKNOWN, "Fetching auth token failed: " + t.message);
                return this.z_(e);
            });
        });
    }
    G_(e, t) {
        const n = this.Q_(this.D_);
        this.stream = this.j_(e, t), this.stream.Zo(()=>{
            n(()=>this.listener.Zo());
        }), this.stream.Yo(()=>{
            n(()=>(this.state = 2 /* PersistentStreamState.Open */ , this.v_ = this.Ci.enqueueAfterDelay(this.S_, 1e4, ()=>(this.O_() && (this.state = 3 /* PersistentStreamState.Healthy */ ), Promise.resolve())), this.listener.Yo()));
        }), this.stream.t_((e)=>{
            n(()=>this.z_(e));
        }), this.stream.onMessage((e)=>{
            n(()=>1 == ++this.F_ ? this.H_(e) : this.onNext(e));
        });
    }
    N_() {
        this.state = 5 /* PersistentStreamState.Backoff */ , this.M_.p_(async ()=>{
            this.state = 0 /* PersistentStreamState.Initial */ , this.start();
        });
    }
    // Visible for tests
    z_(e) {
        // In theory the stream could close cleanly, however, in our current model
        // we never expect this to happen because if we stop a stream ourselves,
        // this callback will never be called. To prevent cases where we retry
        // without a backoff accidentally, we set the stream to error in all cases.
        return $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$jt, `close with error: ${e}`), this.stream = null, this.close(4 /* PersistentStreamState.Error */ , e);
    }
    /**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */ Q_(e) {
        return (t)=>{
            this.Ci.enqueueAndForget(()=>this.D_ === e ? t() : ($63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$jt, "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve()));
        };
    }
}
/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the onOpen() listener, any number of
 * listen() and unlisten() calls can be made to control what changes will be
 * sent from the server for ListenResponses.
 */ class $63c47e8a587a7f36$var$__PRIVATE_PersistentListenStream extends $63c47e8a587a7f36$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s){
        super(e, "listen_stream_connection_backoff" /* TimerId.ListenStreamConnectionBackoff */ , "listen_stream_idle" /* TimerId.ListenStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), this.serializer = i;
    }
    j_(e, t) {
        return this.connection.T_("Listen", e, t);
    }
    H_(e) {
        return this.onNext(e);
    }
    onNext(e) {
        // A successful response means the stream is healthy
        this.M_.reset();
        const t = $63c47e8a587a7f36$var$__PRIVATE_fromWatchChange(this.serializer, e), n = function __PRIVATE_versionFromListenResponse(e) {
            // We have only reached a consistent snapshot for the entire stream if there
            // is a read_time set and it applies to all targets (i.e. the list of
            // targets is empty). The backend is guaranteed to send such responses.
            if (!("targetChange" in e)) return $63c47e8a587a7f36$var$SnapshotVersion.min();
            const t = e.targetChange;
            return t.targetIds && t.targetIds.length ? $63c47e8a587a7f36$var$SnapshotVersion.min() : t.readTime ? $63c47e8a587a7f36$var$__PRIVATE_fromVersion(t.readTime) : $63c47e8a587a7f36$var$SnapshotVersion.min();
        }(e);
        return this.listener.J_(t, n);
    }
    /**
     * Registers interest in the results of the given target. If the target
     * includes a resumeToken it will be included in the request. Results that
     * affect the target will be streamed back as WatchChange messages that
     * reference the targetId.
     */ Z_(e) {
        const t = {};
        t.database = $63c47e8a587a7f36$var$__PRIVATE_getEncodedDatabaseId(this.serializer), t.addTarget = function __PRIVATE_toTarget(e, t) {
            let n;
            const r = t.target;
            if (n = $63c47e8a587a7f36$var$__PRIVATE_targetIsDocumentTarget(r) ? {
                documents: $63c47e8a587a7f36$var$__PRIVATE_toDocumentsTarget(e, r)
            } : {
                query: $63c47e8a587a7f36$var$__PRIVATE_toQueryTarget(e, r).ft
            }, n.targetId = t.targetId, t.resumeToken.approximateByteSize() > 0) {
                n.resumeToken = $63c47e8a587a7f36$var$__PRIVATE_toBytes(e, t.resumeToken);
                const r = $63c47e8a587a7f36$var$__PRIVATE_toInt32Proto(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
            } else if (t.snapshotVersion.compareTo($63c47e8a587a7f36$var$SnapshotVersion.min()) > 0) {
                // TODO(wuandy): Consider removing above check because it is most likely true.
                // Right now, many tests depend on this behaviour though (leaving min() out
                // of serialization).
                n.readTime = $63c47e8a587a7f36$var$toTimestamp(e, t.snapshotVersion.toTimestamp());
                const r = $63c47e8a587a7f36$var$__PRIVATE_toInt32Proto(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
            }
            return n;
        }(this.serializer, e);
        const n = $63c47e8a587a7f36$var$__PRIVATE_toListenRequestLabels(this.serializer, e);
        n && (t.labels = n), this.K_(t);
    }
    /**
     * Unregisters interest in the results of the target associated with the
     * given targetId.
     */ X_(e) {
        const t = {};
        t.database = $63c47e8a587a7f36$var$__PRIVATE_getEncodedDatabaseId(this.serializer), t.removeTarget = e, this.K_(t);
    }
}
/**
 * A Stream that implements the Write RPC.
 *
 * The Write RPC requires the caller to maintain special streamToken
 * state in between calls, to help the server understand which responses the
 * client has processed by the time the next request is made. Every response
 * will contain a streamToken; this value must be passed to the next
 * request.
 *
 * After calling start() on this stream, the next request must be a handshake,
 * containing whatever streamToken is on hand. Once a response to this
 * request is received, all pending mutations may be submitted. When
 * submitting multiple batches of mutations at the same time, it's
 * okay to use the same streamToken for the calls to writeMutations.
 *
 * TODO(b/33271235): Use proto types
 */ class $63c47e8a587a7f36$var$__PRIVATE_PersistentWriteStream extends $63c47e8a587a7f36$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s){
        super(e, "write_stream_connection_backoff" /* TimerId.WriteStreamConnectionBackoff */ , "write_stream_idle" /* TimerId.WriteStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), this.serializer = i;
    }
    /**
     * Tracks whether or not a handshake has been successfully exchanged and
     * the stream is ready to accept mutations.
     */ get Y_() {
        return this.F_ > 0;
    }
    // Override of PersistentStream.start
    start() {
        this.lastStreamToken = void 0, super.start();
    }
    W_() {
        this.Y_ && this.ea([]);
    }
    j_(e, t) {
        return this.connection.T_("Write", e, t);
    }
    H_(e) {
        // Always capture the last stream token.
        return $63c47e8a587a7f36$export$c18d01048907ea92(!!e.streamToken, 31322), this.lastStreamToken = e.streamToken, // The first response is always the handshake response
        $63c47e8a587a7f36$export$c18d01048907ea92(!e.writeResults || 0 === e.writeResults.length, 55816), this.listener.ta();
    }
    onNext(e) {
        // Always capture the last stream token.
        $63c47e8a587a7f36$export$c18d01048907ea92(!!e.streamToken, 12678), this.lastStreamToken = e.streamToken, // A successful first write response means the stream is healthy,
        // Note, that we could consider a successful handshake healthy, however,
        // the write itself might be causing an error we want to back off from.
        this.M_.reset();
        const t = $63c47e8a587a7f36$var$__PRIVATE_fromWriteResults(e.writeResults, e.commitTime), n = $63c47e8a587a7f36$var$__PRIVATE_fromVersion(e.commitTime);
        return this.listener.na(n, t);
    }
    /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */ ra() {
        // TODO(dimond): Support stream resumption. We intentionally do not set the
        // stream token on the handshake, ignoring any stream token we might have.
        const e = {};
        e.database = $63c47e8a587a7f36$var$__PRIVATE_getEncodedDatabaseId(this.serializer), this.K_(e);
    }
    /** Sends a group of mutations to the Firestore backend to apply. */ ea(e) {
        const t = {
            streamToken: this.lastStreamToken,
            writes: e.map((e)=>$63c47e8a587a7f36$var$toMutation(this.serializer, e))
        };
        this.K_(t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Datastore and its related methods are a wrapper around the external Google
 * Cloud Datastore grpc API, which provides an interface that is more convenient
 * for the rest of the client SDK architecture to consume.
 */ class $63c47e8a587a7f36$var$Datastore {
}
/**
 * An implementation of Datastore that exposes additional state for internal
 * consumption.
 */ class $63c47e8a587a7f36$var$__PRIVATE_DatastoreImpl extends $63c47e8a587a7f36$var$Datastore {
    constructor(e, t, n, r){
        super(), this.authCredentials = e, this.appCheckCredentials = t, this.connection = n, this.serializer = r, this.ia = !1;
    }
    sa() {
        if (this.ia) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.FAILED_PRECONDITION, "The client has already been terminated.");
    }
    /** Invokes the provided RPC with auth and AppCheck tokens. */ Wo(e, t, n, r) {
        return this.sa(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([i, s])=>this.connection.Wo(e, $63c47e8a587a7f36$var$__PRIVATE_toResourcePath(t, n), r, i, s)).catch((e)=>{
            throw "FirebaseError" === e.name ? (e.code === $63c47e8a587a7f36$export$e7094788287c5e9b.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.UNKNOWN, e.toString());
        });
    }
    /** Invokes the provided RPC with streamed results with auth and AppCheck tokens. */ jo(e, t, n, r, i) {
        return this.sa(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([s, o])=>this.connection.jo(e, $63c47e8a587a7f36$var$__PRIVATE_toResourcePath(t, n), r, s, o, i)).catch((e)=>{
            throw "FirebaseError" === e.name ? (e.code === $63c47e8a587a7f36$export$e7094788287c5e9b.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.UNKNOWN, e.toString());
        });
    }
    terminate() {
        this.ia = !0, this.connection.terminate();
    }
}
// TODO(firestorexp): Make sure there is only one Datastore instance per
// firestore-exp client.
function $63c47e8a587a7f36$var$__PRIVATE_newDatastore(e, t, n, r) {
    return new $63c47e8a587a7f36$var$__PRIVATE_DatastoreImpl(e, t, n, r);
}
/**
 * A component used by the RemoteStore to track the OnlineState (that is,
 * whether or not the client as a whole should be considered to be online or
 * offline), implementing the appropriate heuristics.
 *
 * In particular, when the client is trying to connect to the backend, we
 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
 * a connection to succeed. If we have too many failures or the timeout elapses,
 * then we set the OnlineState to Offline, and the client will behave as if
 * it is offline (get()s will return cached data, etc.).
 */ class $63c47e8a587a7f36$var$__PRIVATE_OnlineStateTracker {
    constructor(e, t){
        this.asyncQueue = e, this.onlineStateHandler = t, /** The current OnlineState. */ this.state = "Unknown" /* OnlineState.Unknown */ , /**
         * A count of consecutive failures to open the stream. If it reaches the
         * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
         * Offline.
         */ this.oa = 0, /**
         * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
         * transition from OnlineState.Unknown to OnlineState.Offline without waiting
         * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
         */ this._a = null, /**
         * Whether the client should log a warning message if it fails to connect to
         * the backend (initially true, cleared after a successful stream, or if we've
         * logged the message already).
         */ this.aa = !0;
    }
    /**
     * Called by RemoteStore when a watch stream is started (including on each
     * backoff attempt).
     *
     * If this is the first attempt, it sets the OnlineState to Unknown and starts
     * the onlineStateTimer.
     */ ua() {
        0 === this.oa && (this.ca("Unknown" /* OnlineState.Unknown */ ), this._a = this.asyncQueue.enqueueAfterDelay("online_state_timeout" /* TimerId.OnlineStateTimeout */ , 1e4, ()=>(this._a = null, this.la("Backend didn't respond within 10 seconds."), this.ca("Offline" /* OnlineState.Offline */ ), Promise.resolve())));
    }
    /**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */ ha(e) {
        "Online" /* OnlineState.Online */  === this.state ? this.ca("Unknown" /* OnlineState.Unknown */ ) : (this.oa++, this.oa >= 1 && (this.Pa(), this.la(`Connection failed 1 times. Most recent error: ${e.toString()}`), this.ca("Offline" /* OnlineState.Offline */ )));
    }
    /**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */ set(e) {
        this.Pa(), this.oa = 0, "Online" /* OnlineState.Online */  === e && // We've connected to watch at least once. Don't warn the developer
        // about being offline going forward.
        (this.aa = !1), this.ca(e);
    }
    ca(e) {
        e !== this.state && (this.state = e, this.onlineStateHandler(e));
    }
    la(e) {
        const t = `Could not reach Cloud Firestore backend. ${e}\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.`;
        this.aa ? ($63c47e8a587a7f36$var$__PRIVATE_logError(t), this.aa = !1) : $63c47e8a587a7f36$export$21579262ef46735b("OnlineStateTracker", t);
    }
    Pa() {
        null !== this._a && (this._a.cancel(), this._a = null);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $63c47e8a587a7f36$var$Ht = "RemoteStore";
// TODO(b/35853402): Negotiate this with the stream.
class $63c47e8a587a7f36$var$__PRIVATE_RemoteStoreImpl {
    constructor(/**
     * The local store, used to fill the write pipeline with outbound mutations.
     */ e, /** The client-side proxy for interacting with the backend. */ t, n, r, i){
        this.localStore = e, this.datastore = t, this.asyncQueue = n, this.remoteSyncer = {}, /**
         * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
         * LocalStore via fillWritePipeline() and have or will send to the write
         * stream.
         *
         * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
         * restart the write stream. When the stream is established the writes in the
         * pipeline will be sent in order.
         *
         * Writes remain in writePipeline until they are acknowledged by the backend
         * and thus will automatically be re-sent if the stream is interrupted /
         * restarted before they're acknowledged.
         *
         * Write responses from the backend are linked to their originating request
         * purely based on order, and so we can just shift() writes from the front of
         * the writePipeline as we receive responses.
         */ this.Ta = [], /**
         * A mapping of watched targets that the client cares about tracking and the
         * user has explicitly called a 'listen' for this target.
         *
         * These targets may or may not have been sent to or acknowledged by the
         * server. On re-establishing the listen stream, these targets should be sent
         * to the server. The targets removed with unlistens are removed eagerly
         * without waiting for confirmation from the listen stream.
         */ this.Ia = new Map, /**
         * A set of reasons for why the RemoteStore may be offline. If empty, the
         * RemoteStore may start its network connections.
         */ this.Ea = new Set, /**
         * Event handlers that get called when the network is disabled or enabled.
         *
         * PORTING NOTE: These functions are used on the Web client to create the
         * underlying streams (to support tree-shakeable streams). On Android and iOS,
         * the streams are created during construction of RemoteStore.
         */ this.Ra = [], this.Aa = i, this.Aa.Mo((e)=>{
            n.enqueueAndForget(async ()=>{
                // Porting Note: Unlike iOS, `restartNetwork()` is called even when the
                // network becomes unreachable as we don't have any other way to tear
                // down our streams.
                $63c47e8a587a7f36$var$__PRIVATE_canUseNetwork(this) && ($63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Ht, "Restarting streams for network reachability change."), await async function __PRIVATE_restartNetwork(e) {
                    const t = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
                    t.Ea.add(4 /* OfflineCause.ConnectivityChange */ ), await $63c47e8a587a7f36$var$__PRIVATE_disableNetworkInternal(t), t.Va.set("Unknown" /* OnlineState.Unknown */ ), t.Ea.delete(4 /* OfflineCause.ConnectivityChange */ ), await $63c47e8a587a7f36$var$__PRIVATE_enableNetworkInternal(t);
                }(this));
            });
        }), this.Va = new $63c47e8a587a7f36$var$__PRIVATE_OnlineStateTracker(n, r);
    }
}
async function $63c47e8a587a7f36$var$__PRIVATE_enableNetworkInternal(e) {
    if ($63c47e8a587a7f36$var$__PRIVATE_canUseNetwork(e)) for (const t of e.Ra)await t(/* enabled= */ !0);
}
/**
 * Temporarily disables the network. The network can be re-enabled using
 * enableNetwork().
 */ async function $63c47e8a587a7f36$var$__PRIVATE_disableNetworkInternal(e) {
    for (const t of e.Ra)await t(/* enabled= */ !1);
}
/**
 * Starts new listen for the given target. Uses resume token if provided. It
 * is a no-op if the target of given `TargetData` is already being listened to.
 */ function $63c47e8a587a7f36$var$__PRIVATE_remoteStoreListen(e, t) {
    const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    n.Ia.has(t.targetId) || // Mark this as something the client is currently listening for.
    (n.Ia.set(t.targetId, t), $63c47e8a587a7f36$var$__PRIVATE_shouldStartWatchStream(n) ? // The listen will be sent in onWatchStreamOpen
    $63c47e8a587a7f36$var$__PRIVATE_startWatchStream(n) : $63c47e8a587a7f36$var$__PRIVATE_ensureWatchStream(n).O_() && $63c47e8a587a7f36$var$__PRIVATE_sendWatchRequest(n, t));
}
/**
 * Removes the listen from server. It is a no-op if the given target id is
 * not being listened to.
 */ function $63c47e8a587a7f36$var$__PRIVATE_remoteStoreUnlisten(e, t) {
    const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e), r = $63c47e8a587a7f36$var$__PRIVATE_ensureWatchStream(n);
    n.Ia.delete(t), r.O_() && $63c47e8a587a7f36$var$__PRIVATE_sendUnwatchRequest(n, t), 0 === n.Ia.size && (r.O_() ? r.L_() : $63c47e8a587a7f36$var$__PRIVATE_canUseNetwork(n) && // Revert to OnlineState.Unknown if the watch stream is not open and we
    // have no listeners, since without any listens to send we cannot
    // confirm if the stream is healthy and upgrade to OnlineState.Online.
    n.Va.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the ack to process any messages from this target.
 */ function $63c47e8a587a7f36$var$__PRIVATE_sendWatchRequest(e, t) {
    if (e.da.$e(t.targetId), t.resumeToken.approximateByteSize() > 0 || t.snapshotVersion.compareTo($63c47e8a587a7f36$var$SnapshotVersion.min()) > 0) {
        const n = e.remoteSyncer.getRemoteKeysForTarget(t.targetId).size;
        t = t.withExpectedCount(n);
    }
    $63c47e8a587a7f36$var$__PRIVATE_ensureWatchStream(e).Z_(t);
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the removal on the server before we process any
 * messages from this target.
 */ function $63c47e8a587a7f36$var$__PRIVATE_sendUnwatchRequest(e, t) {
    e.da.$e(t), $63c47e8a587a7f36$var$__PRIVATE_ensureWatchStream(e).X_(t);
}
function $63c47e8a587a7f36$var$__PRIVATE_startWatchStream(e) {
    e.da = new $63c47e8a587a7f36$var$__PRIVATE_WatchChangeAggregator({
        getRemoteKeysForTarget: (t)=>e.remoteSyncer.getRemoteKeysForTarget(t),
        At: (t)=>e.Ia.get(t) || null,
        ht: ()=>e.datastore.serializer.databaseId
    }), $63c47e8a587a7f36$var$__PRIVATE_ensureWatchStream(e).start(), e.Va.ua();
}
/**
 * Returns whether the watch stream should be started because it's necessary
 * and has not yet been started.
 */ function $63c47e8a587a7f36$var$__PRIVATE_shouldStartWatchStream(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_canUseNetwork(e) && !$63c47e8a587a7f36$var$__PRIVATE_ensureWatchStream(e).x_() && e.Ia.size > 0;
}
function $63c47e8a587a7f36$var$__PRIVATE_canUseNetwork(e) {
    return 0 === $63c47e8a587a7f36$var$__PRIVATE_debugCast(e).Ea.size;
}
function $63c47e8a587a7f36$var$__PRIVATE_cleanUpWatchStreamState(e) {
    e.da = void 0;
}
async function $63c47e8a587a7f36$var$__PRIVATE_onWatchStreamConnected(e) {
    // Mark the client as online since we got a "connected" notification.
    e.Va.set("Online" /* OnlineState.Online */ );
}
async function $63c47e8a587a7f36$var$__PRIVATE_onWatchStreamOpen(e) {
    e.Ia.forEach((t, n)=>{
        $63c47e8a587a7f36$var$__PRIVATE_sendWatchRequest(e, t);
    });
}
async function $63c47e8a587a7f36$var$__PRIVATE_onWatchStreamClose(e, t) {
    $63c47e8a587a7f36$var$__PRIVATE_cleanUpWatchStreamState(e), // If we still need the watch stream, retry the connection.
    $63c47e8a587a7f36$var$__PRIVATE_shouldStartWatchStream(e) ? (e.Va.ha(t), $63c47e8a587a7f36$var$__PRIVATE_startWatchStream(e)) : // No need to restart watch stream because there are no active targets.
    // The online state is set to unknown because there is no active attempt
    // at establishing a connection
    e.Va.set("Unknown" /* OnlineState.Unknown */ );
}
async function $63c47e8a587a7f36$var$__PRIVATE_onWatchStreamChange(e, t, n) {
    if (// Mark the client as online since we got a message from the server
    e.Va.set("Online" /* OnlineState.Online */ ), t instanceof $63c47e8a587a7f36$var$__PRIVATE_WatchTargetChange && 2 /* WatchTargetChangeState.Removed */  === t.state && t.cause) // There was an error on a target, don't wait for a consistent snapshot
    // to raise events
    try {
        /** Handles an error on a target */ await async function __PRIVATE_handleTargetError(e, t) {
            const n = t.cause;
            for (const r of t.targetIds)// A watched target might have been removed already.
            e.Ia.has(r) && (await e.remoteSyncer.rejectListen(r, n), e.Ia.delete(r), e.da.removeTarget(r));
        }(e, t);
    } catch (n) {
        $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Ht, "Failed to remove targets %s: %s ", t.targetIds.join(","), n), await $63c47e8a587a7f36$var$__PRIVATE_disableNetworkUntilRecovery(e, n);
    }
    else if (t instanceof $63c47e8a587a7f36$var$__PRIVATE_DocumentWatchChange ? e.da.Xe(t) : t instanceof $63c47e8a587a7f36$var$__PRIVATE_ExistenceFilterChange ? e.da.st(t) : e.da.tt(t), !n.isEqual($63c47e8a587a7f36$var$SnapshotVersion.min())) try {
        const t = await $63c47e8a587a7f36$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore);
        n.compareTo(t) >= 0 && // We have received a target change with a global snapshot if the snapshot
        // version is not equal to SnapshotVersion.min().
        /**
 * Takes a batch of changes from the Datastore, repackages them as a
 * RemoteEvent, and passes that on to the listener, which is typically the
 * SyncEngine.
 */ await function __PRIVATE_raiseWatchSnapshot(e, t) {
            const n = e.da.Tt(t);
            // Update in-memory resume tokens. LocalStore will update the
            // persistent view of these when applying the completed RemoteEvent.
            return n.targetChanges.forEach((n, r)=>{
                if (n.resumeToken.approximateByteSize() > 0) {
                    const i = e.Ia.get(r);
                    // A watched target might have been removed already.
                    i && e.Ia.set(r, i.withResumeToken(n.resumeToken, t));
                }
            }), // Re-establish listens for the targets that have been invalidated by
            // existence filter mismatches.
            n.targetMismatches.forEach((t, n)=>{
                const r = e.Ia.get(t);
                if (!r) // A watched target might have been removed already.
                return;
                // Clear the resume token for the target, since we're in a known mismatch
                // state.
                e.Ia.set(t, r.withResumeToken($63c47e8a587a7f36$export$9d398bebfec1c039.EMPTY_BYTE_STRING, r.snapshotVersion)), // Cause a hard reset by unwatching and rewatching immediately, but
                // deliberately don't send a resume token so that we get a full update.
                $63c47e8a587a7f36$var$__PRIVATE_sendUnwatchRequest(e, t);
                // Mark the target we send as being on behalf of an existence filter
                // mismatch, but don't actually retain that in listenTargets. This ensures
                // that we flag the first re-listen this way without impacting future
                // listens of this target (that might happen e.g. on reconnect).
                const i = new $63c47e8a587a7f36$var$TargetData(r.target, t, n, r.sequenceNumber);
                $63c47e8a587a7f36$var$__PRIVATE_sendWatchRequest(e, i);
            }), e.remoteSyncer.applyRemoteEvent(n);
        }(e, n);
    } catch (t) {
        $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Ht, "Failed to raise snapshot:", t), await $63c47e8a587a7f36$var$__PRIVATE_disableNetworkUntilRecovery(e, t);
    }
}
/**
 * Recovery logic for IndexedDB errors that takes the network offline until
 * `op` succeeds. Retries are scheduled with backoff using
 * `enqueueRetryable()`. If `op()` is not provided, IndexedDB access is
 * validated via a generic operation.
 *
 * The returned Promise is resolved once the network is disabled and before
 * any retry attempt.
 */ async function $63c47e8a587a7f36$var$__PRIVATE_disableNetworkUntilRecovery(e, t, n) {
    if (!$63c47e8a587a7f36$var$__PRIVATE_isIndexedDbTransactionError(t)) throw t;
    e.Ea.add(1 /* OfflineCause.IndexedDbFailed */ ), // Disable network and raise offline snapshots
    await $63c47e8a587a7f36$var$__PRIVATE_disableNetworkInternal(e), e.Va.set("Offline" /* OnlineState.Offline */ ), n || // Use a simple read operation to determine if IndexedDB recovered.
    // Ideally, we would expose a health check directly on SimpleDb, but
    // RemoteStore only has access to persistence through LocalStore.
    (n = ()=>$63c47e8a587a7f36$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore)), // Probe IndexedDB periodically and re-enable network
    e.asyncQueue.enqueueRetryable(async ()=>{
        $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Ht, "Retrying IndexedDB access"), await n(), e.Ea.delete(1 /* OfflineCause.IndexedDbFailed */ ), await $63c47e8a587a7f36$var$__PRIVATE_enableNetworkInternal(e);
    });
}
/**
 * Executes `op`. If `op` fails, takes the network offline until `op`
 * succeeds. Returns after the first attempt.
 */ function $63c47e8a587a7f36$var$__PRIVATE_executeWithRecovery(e, t) {
    return t().catch((n)=>$63c47e8a587a7f36$var$__PRIVATE_disableNetworkUntilRecovery(e, n, t));
}
async function $63c47e8a587a7f36$var$__PRIVATE_fillWritePipeline(e) {
    const t = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e), n = $63c47e8a587a7f36$var$__PRIVATE_ensureWriteStream(t);
    let r = t.Ta.length > 0 ? t.Ta[t.Ta.length - 1].batchId : $63c47e8a587a7f36$var$U;
    for(; $63c47e8a587a7f36$var$__PRIVATE_canAddToWritePipeline(t);)try {
        const e = await $63c47e8a587a7f36$var$__PRIVATE_localStoreGetNextMutationBatch(t.localStore, r);
        if (null === e) {
            0 === t.Ta.length && n.L_();
            break;
        }
        r = e.batchId, $63c47e8a587a7f36$var$__PRIVATE_addToWritePipeline(t, e);
    } catch (e) {
        await $63c47e8a587a7f36$var$__PRIVATE_disableNetworkUntilRecovery(t, e);
    }
    $63c47e8a587a7f36$var$__PRIVATE_shouldStartWriteStream(t) && $63c47e8a587a7f36$var$__PRIVATE_startWriteStream(t);
}
/**
 * Returns true if we can add to the write pipeline (i.e. the network is
 * enabled and the write pipeline is not full).
 */ function $63c47e8a587a7f36$var$__PRIVATE_canAddToWritePipeline(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_canUseNetwork(e) && e.Ta.length < 10;
}
/**
 * Queues additional writes to be sent to the write stream, sending them
 * immediately if the write stream is established.
 */ function $63c47e8a587a7f36$var$__PRIVATE_addToWritePipeline(e, t) {
    e.Ta.push(t);
    const n = $63c47e8a587a7f36$var$__PRIVATE_ensureWriteStream(e);
    n.O_() && n.Y_ && n.ea(t.mutations);
}
function $63c47e8a587a7f36$var$__PRIVATE_shouldStartWriteStream(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_canUseNetwork(e) && !$63c47e8a587a7f36$var$__PRIVATE_ensureWriteStream(e).x_() && e.Ta.length > 0;
}
function $63c47e8a587a7f36$var$__PRIVATE_startWriteStream(e) {
    $63c47e8a587a7f36$var$__PRIVATE_ensureWriteStream(e).start();
}
async function $63c47e8a587a7f36$var$__PRIVATE_onWriteStreamOpen(e) {
    $63c47e8a587a7f36$var$__PRIVATE_ensureWriteStream(e).ra();
}
async function $63c47e8a587a7f36$var$__PRIVATE_onWriteHandshakeComplete(e) {
    const t = $63c47e8a587a7f36$var$__PRIVATE_ensureWriteStream(e);
    // Send the write pipeline now that the stream is established.
    for (const n of e.Ta)t.ea(n.mutations);
}
async function $63c47e8a587a7f36$var$__PRIVATE_onMutationResult(e, t, n) {
    const r = e.Ta.shift(), i = $63c47e8a587a7f36$var$MutationBatchResult.from(r, t, n);
    await $63c47e8a587a7f36$var$__PRIVATE_executeWithRecovery(e, ()=>e.remoteSyncer.applySuccessfulWrite(i)), // It's possible that with the completion of this mutation another
    // slot has freed up.
    await $63c47e8a587a7f36$var$__PRIVATE_fillWritePipeline(e);
}
async function $63c47e8a587a7f36$var$__PRIVATE_onWriteStreamClose(e, t) {
    // If the write stream closed after the write handshake completes, a write
    // operation failed and we fail the pending operation.
    t && $63c47e8a587a7f36$var$__PRIVATE_ensureWriteStream(e).Y_ && // This error affects the actual write.
    await async function __PRIVATE_handleWriteError(e, t) {
        // Only handle permanent errors here. If it's transient, just let the retry
        // logic kick in.
        if (function __PRIVATE_isPermanentWriteError(e) {
            return $63c47e8a587a7f36$var$__PRIVATE_isPermanentError(e) && e !== $63c47e8a587a7f36$export$e7094788287c5e9b.ABORTED;
        }(t.code)) {
            // This was a permanent error, the request itself was the problem
            // so it's not going to succeed if we resend it.
            const n = e.Ta.shift();
            // In this case it's also unlikely that the server itself is melting
            // down -- this was just a bad request so inhibit backoff on the next
            // restart.
            $63c47e8a587a7f36$var$__PRIVATE_ensureWriteStream(e).B_(), await $63c47e8a587a7f36$var$__PRIVATE_executeWithRecovery(e, ()=>e.remoteSyncer.rejectFailedWrite(n.batchId, t)), // It's possible that with the completion of this mutation
            // another slot has freed up.
            await $63c47e8a587a7f36$var$__PRIVATE_fillWritePipeline(e);
        }
    }(e, t), // The write stream might have been started by refilling the write
    // pipeline for failed writes
    $63c47e8a587a7f36$var$__PRIVATE_shouldStartWriteStream(e) && $63c47e8a587a7f36$var$__PRIVATE_startWriteStream(e);
}
async function $63c47e8a587a7f36$var$__PRIVATE_remoteStoreHandleCredentialChange(e, t) {
    const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    n.asyncQueue.verifyOperationInProgress(), $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Ht, "RemoteStore received new credentials");
    const r = $63c47e8a587a7f36$var$__PRIVATE_canUseNetwork(n);
    // Tear down and re-create our network streams. This will ensure we get a
    // fresh auth token for the new user and re-fill the write pipeline with
    // new mutations from the LocalStore (since mutations are per-user).
    n.Ea.add(3 /* OfflineCause.CredentialChange */ ), await $63c47e8a587a7f36$var$__PRIVATE_disableNetworkInternal(n), r && // Don't set the network status to Unknown if we are offline.
    n.Va.set("Unknown" /* OnlineState.Unknown */ ), await n.remoteSyncer.handleCredentialChange(t), n.Ea.delete(3 /* OfflineCause.CredentialChange */ ), await $63c47e8a587a7f36$var$__PRIVATE_enableNetworkInternal(n);
}
/**
 * Toggles the network state when the client gains or loses its primary lease.
 */ async function $63c47e8a587a7f36$var$__PRIVATE_remoteStoreApplyPrimaryState(e, t) {
    const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    t ? (n.Ea.delete(2 /* OfflineCause.IsSecondary */ ), await $63c47e8a587a7f36$var$__PRIVATE_enableNetworkInternal(n)) : t || (n.Ea.add(2 /* OfflineCause.IsSecondary */ ), await $63c47e8a587a7f36$var$__PRIVATE_disableNetworkInternal(n), n.Va.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * If not yet initialized, registers the WatchStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WatchStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $63c47e8a587a7f36$var$__PRIVATE_ensureWatchStream(e) {
    return e.ma || // Create stream (but note that it is not started yet).
    (e.ma = function __PRIVATE_newPersistentWatchStream(e, t, n) {
        const r = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
        return r.sa(), new $63c47e8a587a7f36$var$__PRIVATE_PersistentListenStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        Zo: $63c47e8a587a7f36$var$__PRIVATE_onWatchStreamConnected.bind(null, e),
        Yo: $63c47e8a587a7f36$var$__PRIVATE_onWatchStreamOpen.bind(null, e),
        t_: $63c47e8a587a7f36$var$__PRIVATE_onWatchStreamClose.bind(null, e),
        J_: $63c47e8a587a7f36$var$__PRIVATE_onWatchStreamChange.bind(null, e)
    }), e.Ra.push(async (t)=>{
        t ? (e.ma.B_(), $63c47e8a587a7f36$var$__PRIVATE_shouldStartWatchStream(e) ? $63c47e8a587a7f36$var$__PRIVATE_startWatchStream(e) : e.Va.set("Unknown" /* OnlineState.Unknown */ )) : (await e.ma.stop(), $63c47e8a587a7f36$var$__PRIVATE_cleanUpWatchStreamState(e));
    })), e.ma;
}
/**
 * If not yet initialized, registers the WriteStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WriteStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $63c47e8a587a7f36$var$__PRIVATE_ensureWriteStream(e) {
    return e.fa || // Create stream (but note that it is not started yet).
    (e.fa = function __PRIVATE_newPersistentWriteStream(e, t, n) {
        const r = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
        return r.sa(), new $63c47e8a587a7f36$var$__PRIVATE_PersistentWriteStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        Zo: ()=>Promise.resolve(),
        Yo: $63c47e8a587a7f36$var$__PRIVATE_onWriteStreamOpen.bind(null, e),
        t_: $63c47e8a587a7f36$var$__PRIVATE_onWriteStreamClose.bind(null, e),
        ta: $63c47e8a587a7f36$var$__PRIVATE_onWriteHandshakeComplete.bind(null, e),
        na: $63c47e8a587a7f36$var$__PRIVATE_onMutationResult.bind(null, e)
    }), e.Ra.push(async (t)=>{
        t ? (e.fa.B_(), // This will start the write stream if necessary.
        await $63c47e8a587a7f36$var$__PRIVATE_fillWritePipeline(e)) : (await e.fa.stop(), e.Ta.length > 0 && ($63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Ht, `Stopping write stream with ${e.Ta.length} pending writes`), e.Ta = []));
    })), e.fa;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 *
 * Note: We implement `PromiseLike` instead of `Promise`, as the `Promise` type
 * in newer versions of TypeScript defines `finally`, which is not available in
 * IE.
 */ class $63c47e8a587a7f36$var$DelayedOperation {
    constructor(e, t, n, r, i){
        this.asyncQueue = e, this.timerId = t, this.targetTimeMs = n, this.op = r, this.removalCallback = i, this.deferred = new $63c47e8a587a7f36$var$__PRIVATE_Deferred, this.then = this.deferred.promise.then.bind(this.deferred.promise), // It's normal for the deferred promise to be canceled (due to cancellation)
        // and so we attach a dummy catch callback to avoid
        // 'UnhandledPromiseRejectionWarning' log spam.
        this.deferred.promise.catch((e)=>{});
    }
    get promise() {
        return this.deferred.promise;
    }
    /**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue - The queue to schedule the operation on.
     * @param id - A Timer ID identifying the type of operation this is.
     * @param delayMs - The delay (ms) before the operation should be scheduled.
     * @param op - The operation to run.
     * @param removalCallback - A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */ static createAndSchedule(e, t, n, r, i) {
        const s = Date.now() + n, o = new $63c47e8a587a7f36$var$DelayedOperation(e, t, s, r, i);
        return o.start(n), o;
    }
    /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */ start(e) {
        this.timerHandle = setTimeout(()=>this.handleDelayElapsed(), e);
    }
    /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */ skipDelay() {
        return this.handleDelayElapsed();
    }
    /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */ cancel(e) {
        null !== this.timerHandle && (this.clearTimeout(), this.deferred.reject(new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.CANCELLED, "Operation cancelled" + (e ? ": " + e : ""))));
    }
    handleDelayElapsed() {
        this.asyncQueue.enqueueAndForget(()=>null !== this.timerHandle ? (this.clearTimeout(), this.op().then((e)=>this.deferred.resolve(e))) : Promise.resolve());
    }
    clearTimeout() {
        null !== this.timerHandle && (this.removalCallback(this), clearTimeout(this.timerHandle), this.timerHandle = null);
    }
}
/**
 * Returns a FirestoreError that can be surfaced to the user if the provided
 * error is an IndexedDbTransactionError. Re-throws the error otherwise.
 */ function $63c47e8a587a7f36$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, t) {
    if ($63c47e8a587a7f36$var$__PRIVATE_logError("AsyncQueue", `${t}: ${e}`), $63c47e8a587a7f36$var$__PRIVATE_isIndexedDbTransactionError(e)) return new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.UNAVAILABLE, `${t}: ${e}`);
    throw e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */ class $63c47e8a587a7f36$export$25ce5a424b770e84 {
    /**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */ static emptySet(e) {
        return new $63c47e8a587a7f36$export$25ce5a424b770e84(e.comparator);
    }
    /** The default ordering is by key if the comparator is omitted */ constructor(e){
        // We are adding document key comparator to the end as it's the only
        // guaranteed unique property of a document.
        this.comparator = e ? (t, n)=>e(t, n) || $63c47e8a587a7f36$export$90a7f3efeed30595.comparator(t.key, n.key) : (e, t)=>$63c47e8a587a7f36$export$90a7f3efeed30595.comparator(e.key, t.key), this.keyedMap = $63c47e8a587a7f36$var$documentMap(), this.sortedSet = new $63c47e8a587a7f36$var$SortedMap(this.comparator);
    }
    has(e) {
        return null != this.keyedMap.get(e);
    }
    get(e) {
        return this.keyedMap.get(e);
    }
    first() {
        return this.sortedSet.minKey();
    }
    last() {
        return this.sortedSet.maxKey();
    }
    isEmpty() {
        return this.sortedSet.isEmpty();
    }
    /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */ indexOf(e) {
        const t = this.keyedMap.get(e);
        return t ? this.sortedSet.indexOf(t) : -1;
    }
    get size() {
        return this.sortedSet.size;
    }
    /** Iterates documents in order defined by "comparator" */ forEach(e) {
        this.sortedSet.inorderTraversal((t, n)=>(e(t), !1));
    }
    /** Inserts or updates a document with the same key */ add(e) {
        // First remove the element if we have it.
        const t = this.delete(e.key);
        return t.copy(t.keyedMap.insert(e.key, e), t.sortedSet.insert(e, null));
    }
    /** Deletes a document with a given key */ delete(e) {
        const t = this.get(e);
        return t ? this.copy(this.keyedMap.remove(e), this.sortedSet.remove(t)) : this;
    }
    isEqual(e) {
        if (!(e instanceof $63c47e8a587a7f36$export$25ce5a424b770e84)) return !1;
        if (this.size !== e.size) return !1;
        const t = this.sortedSet.getIterator(), n = e.sortedSet.getIterator();
        for(; t.hasNext();){
            const e = t.getNext().key, r = n.getNext().key;
            if (!e.isEqual(r)) return !1;
        }
        return !0;
    }
    toString() {
        const e = [];
        return this.forEach((t)=>{
            e.push(t.toString());
        }), 0 === e.length ? "DocumentSet ()" : "DocumentSet (\n  " + e.join("  \n") + "\n)";
    }
    copy(e, t) {
        const n = new $63c47e8a587a7f36$export$25ce5a424b770e84;
        return n.comparator = this.comparator, n.keyedMap = e, n.sortedSet = t, n;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */ class $63c47e8a587a7f36$var$__PRIVATE_DocumentChangeSet {
    constructor(){
        this.ga = new $63c47e8a587a7f36$var$SortedMap($63c47e8a587a7f36$export$90a7f3efeed30595.comparator);
    }
    track(e) {
        const t = e.doc.key, n = this.ga.get(t);
        n ? // Merge the new change with the existing change.
        0 /* ChangeType.Added */  !== e.type && 3 /* ChangeType.Metadata */  === n.type ? this.ga = this.ga.insert(t, e) : 3 /* ChangeType.Metadata */  === e.type && 1 /* ChangeType.Removed */  !== n.type ? this.ga = this.ga.insert(t, {
            type: n.type,
            doc: e.doc
        }) : 2 /* ChangeType.Modified */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.ga = this.ga.insert(t, {
            type: 2 /* ChangeType.Modified */ ,
            doc: e.doc
        }) : 2 /* ChangeType.Modified */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.ga = this.ga.insert(t, {
            type: 0 /* ChangeType.Added */ ,
            doc: e.doc
        }) : 1 /* ChangeType.Removed */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.ga = this.ga.remove(t) : 1 /* ChangeType.Removed */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.ga = this.ga.insert(t, {
            type: 1 /* ChangeType.Removed */ ,
            doc: n.doc
        }) : 0 /* ChangeType.Added */  === e.type && 1 /* ChangeType.Removed */  === n.type ? this.ga = this.ga.insert(t, {
            type: 2 /* ChangeType.Modified */ ,
            doc: e.doc
        }) : // This includes these cases, which don't make sense:
        // Added->Added
        // Removed->Removed
        // Modified->Added
        // Removed->Modified
        // Metadata->Added
        // Removed->Metadata
        $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(63341, {
            Vt: e,
            pa: n
        }) : this.ga = this.ga.insert(t, e);
    }
    ya() {
        const e = [];
        return this.ga.inorderTraversal((t, n)=>{
            e.push(n);
        }), e;
    }
}
class $63c47e8a587a7f36$export$e7c866399fa523f5 {
    constructor(e, t, n, r, i, s, o, _, a){
        this.query = e, this.docs = t, this.oldDocs = n, this.docChanges = r, this.mutatedKeys = i, this.fromCache = s, this.syncStateChanged = o, this.excludesMetadataChanges = _, this.hasCachedResults = a;
    }
    /** Returns a view snapshot as if all documents in the snapshot were added. */ static fromInitialDocuments(e, t, n, r, i) {
        const s = [];
        return t.forEach((e)=>{
            s.push({
                type: 0 /* ChangeType.Added */ ,
                doc: e
            });
        }), new $63c47e8a587a7f36$export$e7c866399fa523f5(e, t, $63c47e8a587a7f36$export$25ce5a424b770e84.emptySet(t), s, n, r, /* syncStateChanged= */ !0, /* excludesMetadataChanges= */ !1, i);
    }
    get hasPendingWrites() {
        return !this.mutatedKeys.isEmpty();
    }
    isEqual(e) {
        if (!(this.fromCache === e.fromCache && this.hasCachedResults === e.hasCachedResults && this.syncStateChanged === e.syncStateChanged && this.mutatedKeys.isEqual(e.mutatedKeys) && $63c47e8a587a7f36$var$__PRIVATE_queryEquals(this.query, e.query) && this.docs.isEqual(e.docs) && this.oldDocs.isEqual(e.oldDocs))) return !1;
        const t = this.docChanges, n = e.docChanges;
        if (t.length !== n.length) return !1;
        for(let e = 0; e < t.length; e++)if (t[e].type !== n[e].type || !t[e].doc.isEqual(n[e].doc)) return !1;
        return !0;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Holds the listeners and the last received ViewSnapshot for a query being
 * tracked by EventManager.
 */ class $63c47e8a587a7f36$var$__PRIVATE_QueryListenersInfo {
    constructor(){
        this.wa = void 0, this.ba = [];
    }
    // Helper methods that checks if the query has listeners that listening to remote store
    Sa() {
        return this.ba.some((e)=>e.Da());
    }
}
class $63c47e8a587a7f36$var$__PRIVATE_EventManagerImpl {
    constructor(){
        this.queries = $63c47e8a587a7f36$var$__PRIVATE_newQueriesObjectMap(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.Ca = new Set;
    }
    terminate() {
        !function __PRIVATE_errorAllTargets(e, t) {
            const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e), r = n.queries;
            // Prevent further access by clearing ObjectMap.
            n.queries = $63c47e8a587a7f36$var$__PRIVATE_newQueriesObjectMap(), r.forEach((e, n)=>{
                for (const e of n.ba)e.onError(t);
            });
        }(this, new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.ABORTED, "Firestore shutting down"));
    }
}
function $63c47e8a587a7f36$var$__PRIVATE_newQueriesObjectMap() {
    return new $63c47e8a587a7f36$var$ObjectMap((e)=>$63c47e8a587a7f36$var$__PRIVATE_canonifyQuery(e), $63c47e8a587a7f36$var$__PRIVATE_queryEquals);
}
async function $63c47e8a587a7f36$var$__PRIVATE_eventManagerListen(e, t) {
    const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    let r = 3 /* ListenerSetupAction.NoActionRequired */ ;
    const i = t.query;
    let s = n.queries.get(i);
    s ? !s.Sa() && t.Da() && // Query has been listening to local cache, and tries to add a new listener sourced from watch.
    (r = 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ ) : (s = new $63c47e8a587a7f36$var$__PRIVATE_QueryListenersInfo, r = t.Da() ? 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */  : 1 /* ListenerSetupAction.InitializeLocalListenOnly */ );
    try {
        switch(r){
            case 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */ :
                s.wa = await n.onListen(i, /** enableRemoteListen= */ !0);
                break;
            case 1 /* ListenerSetupAction.InitializeLocalListenOnly */ :
                s.wa = await n.onListen(i, /** enableRemoteListen= */ !1);
                break;
            case 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ :
                await n.onFirstRemoteStoreListen(i);
        }
    } catch (e) {
        const n = $63c47e8a587a7f36$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Initialization of query '${$63c47e8a587a7f36$var$__PRIVATE_stringifyQuery(t.query)}' failed`);
        return void t.onError(n);
    }
    if (n.queries.set(i, s), s.ba.push(t), // Run global snapshot listeners if a consistent snapshot has been emitted.
    t.va(n.onlineState), s.wa) t.Fa(s.wa) && $63c47e8a587a7f36$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
}
async function $63c47e8a587a7f36$var$__PRIVATE_eventManagerUnlisten(e, t) {
    const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e), r = t.query;
    let i = 3 /* ListenerRemovalAction.NoActionRequired */ ;
    const s = n.queries.get(r);
    if (s) {
        const e = s.ba.indexOf(t);
        e >= 0 && (s.ba.splice(e, 1), 0 === s.ba.length ? i = t.Da() ? 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */  : 1 /* ListenerRemovalAction.TerminateLocalListenOnly */  : !s.Sa() && t.Da() && // The removed listener is the last one that sourced from watch.
        (i = 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ ));
    }
    switch(i){
        case 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */ :
            return n.queries.delete(r), n.onUnlisten(r, /** disableRemoteListen= */ !0);
        case 1 /* ListenerRemovalAction.TerminateLocalListenOnly */ :
            return n.queries.delete(r), n.onUnlisten(r, /** disableRemoteListen= */ !1);
        case 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ :
            return n.onLastRemoteStoreUnlisten(r);
        default:
            return;
    }
}
function $63c47e8a587a7f36$var$__PRIVATE_eventManagerOnWatchChange(e, t) {
    const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    let r = !1;
    for (const e of t){
        const t = e.query, i = n.queries.get(t);
        if (i) {
            for (const t of i.ba)t.Fa(e) && (r = !0);
            i.wa = e;
        }
    }
    r && $63c47e8a587a7f36$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
}
function $63c47e8a587a7f36$var$__PRIVATE_eventManagerOnWatchError(e, t, n) {
    const r = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e), i = r.queries.get(t);
    if (i) for (const e of i.ba)e.onError(n);
    // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
    // after an error.
    r.queries.delete(t);
}
function $63c47e8a587a7f36$var$__PRIVATE_raiseSnapshotsInSyncEvent(e) {
    e.Ca.forEach((e)=>{
        e.next();
    });
}
var $63c47e8a587a7f36$var$Jt, $63c47e8a587a7f36$var$Zt;
/** Listen to both cache and server changes */ ($63c47e8a587a7f36$var$Zt = $63c47e8a587a7f36$var$Jt || ($63c47e8a587a7f36$var$Jt = {})).Ma = "default", /** Listen to changes in cache only */ $63c47e8a587a7f36$var$Zt.Cache = "cache";
/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */ class $63c47e8a587a7f36$var$__PRIVATE_QueryListener {
    constructor(e, t, n){
        this.query = e, this.xa = t, /**
         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
         * observer. This flag is set to true once we've actually raised an event.
         */ this.Oa = !1, this.Na = null, this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.options = n || {};
    }
    /**
     * Applies the new ViewSnapshot to this listener, raising a user-facing event
     * if applicable (depending on what changed, whether the user has opted into
     * metadata-only changes, etc.). Returns true if a user-facing event was
     * indeed raised.
     */ Fa(e) {
        if (!this.options.includeMetadataChanges) {
            // Remove the metadata only changes.
            const t = [];
            for (const n of e.docChanges)3 /* ChangeType.Metadata */  !== n.type && t.push(n);
            e = new $63c47e8a587a7f36$export$e7c866399fa523f5(e.query, e.docs, e.oldDocs, t, e.mutatedKeys, e.fromCache, e.syncStateChanged, /* excludesMetadataChanges= */ !0, e.hasCachedResults);
        }
        let t = !1;
        return this.Oa ? this.Ba(e) && (this.xa.next(e), t = !0) : this.La(e, this.onlineState) && (this.ka(e), t = !0), this.Na = e, t;
    }
    onError(e) {
        this.xa.error(e);
    }
    /** Returns whether a snapshot was raised. */ va(e) {
        this.onlineState = e;
        let t = !1;
        return this.Na && !this.Oa && this.La(this.Na, e) && (this.ka(this.Na), t = !0), t;
    }
    La(e, t) {
        // Always raise the first event when we're synced
        if (!e.fromCache) return !0;
        // Always raise event if listening to cache
        if (!this.Da()) return !0;
        // NOTE: We consider OnlineState.Unknown as online (it should become Offline
        // or Online if we wait long enough).
        const n = "Offline" /* OnlineState.Offline */  !== t;
        // Don't raise the event if we're online, aren't synced yet (checked
        // above) and are waiting for a sync.
        return (!this.options.Ka || !n) && (!e.docs.isEmpty() || e.hasCachedResults || "Offline" /* OnlineState.Offline */  === t);
    // Raise data from cache if we have any documents, have cached results before,
    // or we are offline.
    }
    Ba(e) {
        // We don't need to handle includeDocumentMetadataChanges here because
        // the Metadata only changes have already been stripped out if needed.
        // At this point the only changes we will see are the ones we should
        // propagate.
        if (e.docChanges.length > 0) return !0;
        const t = this.Na && this.Na.hasPendingWrites !== e.hasPendingWrites;
        return !(!e.syncStateChanged && !t) && !0 === this.options.includeMetadataChanges;
    // Generally we should have hit one of the cases above, but it's possible
    // to get here if there were only metadata docChanges and they got
    // stripped out.
    }
    ka(e) {
        e = $63c47e8a587a7f36$export$e7c866399fa523f5.fromInitialDocuments(e.query, e.docs, e.mutatedKeys, e.fromCache, e.hasCachedResults), this.Oa = !0, this.xa.next(e);
    }
    Da() {
        return this.options.source !== $63c47e8a587a7f36$var$Jt.Cache;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A complete element in the bundle stream, together with the byte length it
 * occupies in the stream.
 */ class $63c47e8a587a7f36$var$__PRIVATE_SizedBundleElement {
    constructor(e, // How many bytes this element takes to store in the bundle.
    t){
        this.qa = e, this.byteLength = t;
    }
    Ua() {
        return "metadata" in this.qa;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to convert objects from bundles to model objects in the SDK.
 */ class $63c47e8a587a7f36$var$__PRIVATE_BundleConverterImpl {
    constructor(e){
        this.serializer = e;
    }
    Ks(e) {
        return $63c47e8a587a7f36$var$fromName(this.serializer, e);
    }
    /**
     * Converts a BundleDocument to a MutableDocument.
     */ qs(e) {
        return e.metadata.exists ? $63c47e8a587a7f36$export$3a1a48c8f6ef640e(this.serializer, e.document, !1) : $63c47e8a587a7f36$var$MutableDocument.newNoDocument(this.Ks(e.metadata.name), this.Us(e.metadata.readTime));
    }
    Us(e) {
        return $63c47e8a587a7f36$var$__PRIVATE_fromVersion(e);
    }
}
/**
 * A class to process the elements from a bundle, and optionally load them into local
 * storage and provide progress update while loading.
 */ class $63c47e8a587a7f36$export$61196ced6d74a310 {
    constructor(e, t){
        this.$a = e, this.serializer = t, /** Batched queries to be saved into storage */ this.Wa = [], /** Batched documents to be saved into storage */ this.Qa = [], /** The collection groups affected by this bundle. */ this.collectionGroups = new Set, this.progress = $63c47e8a587a7f36$var$__PRIVATE_bundleInitialProgress(e);
    }
    /**
     * Returns the named queries that have been parsed from the SizeBundleElements added by
     * calling {@link adSizedElement}.
     */ get queries() {
        return this.Wa;
    }
    /**
     * Returns the BundledDocuments that have been parsed from the SizeBundleElements added by
     * calling {@link addSizedElement}.
     */ get documents() {
        return this.Qa;
    }
    /**
     * Adds an element from the bundle to the loader.
     *
     * Returns a new progress if adding the element leads to a new progress,
     * otherwise returns null.
     */ Ga(e) {
        this.progress.bytesLoaded += e.byteLength;
        let t = this.progress.documentsLoaded;
        if (e.qa.namedQuery) this.Wa.push(e.qa.namedQuery);
        else if (e.qa.documentMetadata) {
            this.Qa.push({
                metadata: e.qa.documentMetadata
            }), e.qa.documentMetadata.exists || ++t;
            const n = $63c47e8a587a7f36$export$db202ddc8be9136.fromString(e.qa.documentMetadata.name);
            this.collectionGroups.add(n.get(n.length - 2));
        } else e.qa.document && (this.Qa[this.Qa.length - 1].document = e.qa.document, ++t);
        return t !== this.progress.documentsLoaded ? (this.progress.documentsLoaded = t, {
            ...this.progress
        }) : null;
    }
    za(e) {
        const t = new Map, n = new $63c47e8a587a7f36$var$__PRIVATE_BundleConverterImpl(this.serializer);
        for (const r of e)if (r.metadata.queries) {
            const e = n.Ks(r.metadata.name);
            for (const n of r.metadata.queries){
                const r = (t.get(n) || $63c47e8a587a7f36$export$971d5caa766a69d7()).add(e);
                t.set(n, r);
            }
        }
        return t;
    }
    /**
     * Update the progress to 'Success' and return the updated progress.
     */ async ja(e) {
        const t = await $63c47e8a587a7f36$var$__PRIVATE_localStoreApplyBundledDocuments(e, new $63c47e8a587a7f36$var$__PRIVATE_BundleConverterImpl(this.serializer), this.Qa, this.$a.id), n = this.za(this.documents);
        for (const t of this.Wa)await $63c47e8a587a7f36$var$__PRIVATE_localStoreSaveNamedQuery(e, t, n.get(t.name));
        return this.progress.taskState = "Success", {
            progress: this.progress,
            Ha: this.collectionGroups,
            Ja: t
        };
    }
}
/**
 * Returns a `LoadBundleTaskProgress` representing the initial progress of
 * loading a bundle.
 */ function $63c47e8a587a7f36$var$__PRIVATE_bundleInitialProgress(e) {
    return {
        taskState: "Running",
        documentsLoaded: 0,
        bytesLoaded: 0,
        totalDocuments: e.totalDocuments,
        totalBytes: e.totalBytes
    };
}
/**
 * Returns a `LoadBundleTaskProgress` representing the progress that the loading
 * has succeeded.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $63c47e8a587a7f36$var$__PRIVATE_AddedLimboDocument {
    constructor(e){
        this.key = e;
    }
}
class $63c47e8a587a7f36$var$__PRIVATE_RemovedLimboDocument {
    constructor(e){
        this.key = e;
    }
}
/**
 * View is responsible for computing the final merged truth of what docs are in
 * a query. It gets notified of local and remote changes to docs, and applies
 * the query filters and limits to determine the most correct possible results.
 */ class $63c47e8a587a7f36$var$__PRIVATE_View {
    constructor(e, /** Documents included in the remote target */ t){
        this.query = e, this.Za = t, this.Xa = null, this.hasCachedResults = !1, /**
         * A flag whether the view is current with the backend. A view is considered
         * current after it has seen the current flag from the backend and did not
         * lose consistency within the watch stream (e.g. because of an existence
         * filter mismatch).
         */ this.current = !1, /** Documents in the view but not in the remote target */ this.Ya = $63c47e8a587a7f36$export$971d5caa766a69d7(), /** Document Keys that have local changes */ this.mutatedKeys = $63c47e8a587a7f36$export$971d5caa766a69d7(), this.eu = $63c47e8a587a7f36$var$__PRIVATE_newQueryComparator(e), this.tu = new $63c47e8a587a7f36$export$25ce5a424b770e84(this.eu);
    }
    /**
     * The set of remote documents that the server has told us belongs to the target associated with
     * this view.
     */ get nu() {
        return this.Za;
    }
    /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges - The doc changes to apply to this view.
     * @param previousChanges - If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @returns a new set of docs, changes, and refill flag.
     */ ru(e, t) {
        const n = t ? t.iu : new $63c47e8a587a7f36$var$__PRIVATE_DocumentChangeSet, r = t ? t.tu : this.tu;
        let i = t ? t.mutatedKeys : this.mutatedKeys, s = r, o = !1;
        // Track the last doc in a (full) limit. This is necessary, because some
        // update (a delete, or an update moving a doc past the old limit) might
        // mean there is some other document in the local cache that either should
        // come (1) between the old last limit doc and the new last document, in the
        // case of updates, or (2) after the new last document, in the case of
        // deletes. So we keep this doc at the old limit to compare the updates to.
        // Note that this should never get used in a refill (when previousChanges is
        // set), because there will only be adds -- no deletes or updates.
        const _ = "F" /* LimitType.First */  === this.query.limitType && r.size === this.query.limit ? r.last() : null, a = "L" /* LimitType.Last */  === this.query.limitType && r.size === this.query.limit ? r.first() : null;
        // Drop documents out to meet limit/limitToLast requirement.
        if (e.inorderTraversal((e, t)=>{
            const u = r.get(e), c = $63c47e8a587a7f36$var$__PRIVATE_queryMatches(this.query, t) ? t : null, l = !!u && this.mutatedKeys.has(u.key), h = !!c && (c.hasLocalMutations || // We only consider committed mutations for documents that were
            // mutated during the lifetime of the view.
            this.mutatedKeys.has(c.key) && c.hasCommittedMutations);
            let P = !1;
            // Calculate change
            if (u && c) u.data.isEqual(c.data) ? l !== h && (n.track({
                type: 3 /* ChangeType.Metadata */ ,
                doc: c
            }), P = !0) : this.su(u, c) || (n.track({
                type: 2 /* ChangeType.Modified */ ,
                doc: c
            }), P = !0, (_ && this.eu(c, _) > 0 || a && this.eu(c, a) < 0) && // This doc moved from inside the limit to outside the limit.
            // That means there may be some other doc in the local cache
            // that should be included instead.
            (o = !0));
            else !u && c ? (n.track({
                type: 0 /* ChangeType.Added */ ,
                doc: c
            }), P = !0) : u && !c && (n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: u
            }), P = !0, (_ || a) && // A doc was removed from a full limit query. We'll need to
            // requery from the local cache to see if we know about some other
            // doc that should be in the results.
            (o = !0));
            P && (c ? (s = s.add(c), i = h ? i.add(e) : i.delete(e)) : (s = s.delete(e), i = i.delete(e)));
        }), null !== this.query.limit) for(; s.size > this.query.limit;){
            const e = "F" /* LimitType.First */  === this.query.limitType ? s.last() : s.first();
            s = s.delete(e.key), i = i.delete(e.key), n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: e
            });
        }
        return {
            tu: s,
            iu: n,
            Ss: o,
            mutatedKeys: i
        };
    }
    su(e, t) {
        // We suppress the initial change event for documents that were modified as
        // part of a write acknowledgment (e.g. when the value of a server transform
        // is applied) as Watch will send us the same document again.
        // By suppressing the event, we only raise two user visible events (one with
        // `hasPendingWrites` and the final state of the document) instead of three
        // (one with `hasPendingWrites`, the modified document with
        // `hasPendingWrites` and the final state of the document).
        return e.hasLocalMutations && t.hasCommittedMutations && !t.hasLocalMutations;
    }
    /**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges - The set of changes to make to the view's docs.
     * @param limboResolutionEnabled - Whether to update limbo documents based on
     *        this change.
     * @param targetChange - A target change to apply for computing limbo docs and
     *        sync state.
     * @param targetIsPendingReset - Whether the target is pending to reset due to
     *        existence filter mismatch. If not explicitly specified, it is treated
     *        equivalently to `false`.
     * @returns A new ViewChange with the given docs, changes, and sync state.
     */ // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
    applyChanges(e, t, n, r) {
        const i = this.tu;
        this.tu = e.tu, this.mutatedKeys = e.mutatedKeys;
        // Sort changes based on type and query comparator
        const s = e.iu.ya();
        s.sort((e, t)=>(function __PRIVATE_compareChangeType(e, t) {
                const order = (e)=>{
                    switch(e){
                        case 0 /* ChangeType.Added */ :
                            return 1;
                        case 2 /* ChangeType.Modified */ :
                        case 3 /* ChangeType.Metadata */ :
                            // A metadata change is converted to a modified change at the public
                            // api layer.  Since we sort by document key and then change type,
                            // metadata and modified changes must be sorted equivalently.
                            return 2;
                        case 1 /* ChangeType.Removed */ :
                            return 0;
                        default:
                            return $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(20277, {
                                Vt: e
                            });
                    }
                };
                return order(e) - order(t);
            })(e.type, t.type) || this.eu(e.doc, t.doc)), this.ou(n), r = r ?? !1;
        const o = t && !r ? this._u() : [], _ = 0 === this.Ya.size && this.current && !r ? 1 /* SyncState.Synced */  : 0 /* SyncState.Local */ , a = _ !== this.Xa;
        // We are at synced state if there is no limbo docs are waiting to be resolved, view is current
        // with the backend, and the query is not pending to reset due to existence filter mismatch.
        if (this.Xa = _, 0 !== s.length || a) return {
            snapshot: new $63c47e8a587a7f36$export$e7c866399fa523f5(this.query, e.tu, i, s, e.mutatedKeys, 0 /* SyncState.Local */  === _, a, /* excludesMetadataChanges= */ !1, !!n && n.resumeToken.approximateByteSize() > 0),
            au: o
        };
        // no changes
        return {
            au: o
        };
    }
    /**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */ va(e) {
        return this.current && "Offline" /* OnlineState.Offline */  === e ? // If we're offline, set `current` to false and then call applyChanges()
        // to refresh our syncState and generate a ViewChange as appropriate. We
        // are guaranteed to get a new TargetChange that sets `current` back to
        // true once the client is back online.
        (this.current = !1, this.applyChanges({
            tu: this.tu,
            iu: new $63c47e8a587a7f36$var$__PRIVATE_DocumentChangeSet,
            mutatedKeys: this.mutatedKeys,
            Ss: !1
        }, /* limboResolutionEnabled= */ !1)) : {
            au: []
        };
    }
    /**
     * Returns whether the doc for the given key should be in limbo.
     */ uu(e) {
        // If the remote end says it's part of this query, it's not in limbo.
        return !this.Za.has(e) && // The local store doesn't think it's a result, so it shouldn't be in limbo.
        !!this.tu.has(e) && !this.tu.get(e).hasLocalMutations;
    }
    /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */ ou(e) {
        e && (e.addedDocuments.forEach((e)=>this.Za = this.Za.add(e)), e.modifiedDocuments.forEach((e)=>{}), e.removedDocuments.forEach((e)=>this.Za = this.Za.delete(e)), this.current = e.current);
    }
    _u() {
        // We can only determine limbo documents when we're in-sync with the server.
        if (!this.current) return [];
        // TODO(klimt): Do this incrementally so that it's not quadratic when
        // updating many documents.
        const e = this.Ya;
        this.Ya = $63c47e8a587a7f36$export$971d5caa766a69d7(), this.tu.forEach((e)=>{
            this.uu(e.key) && (this.Ya = this.Ya.add(e.key));
        });
        // Diff the new limbo docs with the old limbo docs.
        const t = [];
        return e.forEach((e)=>{
            this.Ya.has(e) || t.push(new $63c47e8a587a7f36$var$__PRIVATE_RemovedLimboDocument(e));
        }), this.Ya.forEach((n)=>{
            e.has(n) || t.push(new $63c47e8a587a7f36$var$__PRIVATE_AddedLimboDocument(n));
        }), t;
    }
    /**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param queryResult.documents - The documents that match the query according
     * to the LocalStore.
     * @param queryResult.remoteKeys - The keys of the documents that match the
     * query according to the backend.
     *
     * @returns The ViewChange that resulted from this synchronization.
     */ // PORTING NOTE: Multi-tab only.
    cu(e) {
        this.Za = e.ks, this.Ya = $63c47e8a587a7f36$export$971d5caa766a69d7();
        const t = this.ru(e.documents);
        return this.applyChanges(t, /* limboResolutionEnabled= */ !0);
    }
    /**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */ // PORTING NOTE: Multi-tab only.
    lu() {
        return $63c47e8a587a7f36$export$e7c866399fa523f5.fromInitialDocuments(this.query, this.tu, this.mutatedKeys, 0 /* SyncState.Local */  === this.Xa, this.hasCachedResults);
    }
}
const $63c47e8a587a7f36$var$Xt = "SyncEngine";
/**
 * QueryView contains all of the data that SyncEngine needs to keep track of for
 * a particular query.
 */ class $63c47e8a587a7f36$var$__PRIVATE_QueryView {
    constructor(/**
     * The query itself.
     */ e, /**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */ t, /**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */ n){
        this.query = e, this.targetId = t, this.view = n;
    }
}
/** Tracks a limbo resolution. */ class $63c47e8a587a7f36$var$LimboResolution {
    constructor(e){
        this.key = e, /**
         * Set to true once we've received a document. This is used in
         * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
         * decide whether it needs to manufacture a delete event for the target once
         * the target is CURRENT.
         */ this.hu = !1;
    }
}
/**
 * An implementation of `SyncEngine` coordinating with other parts of SDK.
 *
 * The parts of SyncEngine that act as a callback to RemoteStore need to be
 * registered individually. This is done in `syncEngineWrite()` and
 * `syncEngineListen()` (as well as `applyPrimaryState()`) as these methods
 * serve as entry points to RemoteStore's functionality.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $63c47e8a587a7f36$var$__PRIVATE_SyncEngineImpl {
    constructor(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
    r, i, s){
        this.localStore = e, this.remoteStore = t, this.eventManager = n, this.sharedClientState = r, this.currentUser = i, this.maxConcurrentLimboResolutions = s, this.Pu = {}, this.Tu = new $63c47e8a587a7f36$var$ObjectMap((e)=>$63c47e8a587a7f36$var$__PRIVATE_canonifyQuery(e), $63c47e8a587a7f36$var$__PRIVATE_queryEquals), this.Iu = new Map, /**
         * The keys of documents that are in limbo for which we haven't yet started a
         * limbo resolution query. The strings in this set are the result of calling
         * `key.path.canonicalString()` where `key` is a `DocumentKey` object.
         *
         * The `Set` type was chosen because it provides efficient lookup and removal
         * of arbitrary elements and it also maintains insertion order, providing the
         * desired queue-like FIFO semantics.
         */ this.Eu = new Set, /**
         * Keeps track of the target ID for each document that is in limbo with an
         * active target.
         */ this.Ru = new $63c47e8a587a7f36$var$SortedMap($63c47e8a587a7f36$export$90a7f3efeed30595.comparator), /**
         * Keeps track of the information about an active limbo resolution for each
         * active target ID that was started for the purpose of limbo resolution.
         */ this.Au = new Map, this.Vu = new $63c47e8a587a7f36$var$__PRIVATE_ReferenceSet, /** Stores user completion handlers, indexed by User and BatchId. */ this.du = {}, /** Stores user callbacks waiting for all pending writes to be acknowledged. */ this.mu = new Map, this.fu = $63c47e8a587a7f36$var$__PRIVATE_TargetIdGenerator.ar(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , // The primary state is set to `true` or `false` immediately after Firestore
        // startup. In the interim, a client should only be considered primary if
        // `isPrimary` is true.
        this.gu = void 0;
    }
    get isPrimaryClient() {
        return !0 === this.gu;
    }
}
/**
 * Initiates the new listen, resolves promise when listen enqueued to the
 * server. All the subsequent view snapshots or errors are sent to the
 * subscribed handlers. Returns the initial snapshot.
 */ async function $63c47e8a587a7f36$var$__PRIVATE_syncEngineListen(e, t, n = !0) {
    const r = $63c47e8a587a7f36$var$__PRIVATE_ensureWatchCallbacks(e);
    let i;
    const s = r.Tu.get(t);
    return s ? // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
    // already exists when EventManager calls us for the first time. This
    // happens when the primary tab is already listening to this query on
    // behalf of another tab and the user of the primary also starts listening
    // to the query. EventManager will not have an assigned target ID in this
    // case and calls `listen` to obtain this ID.
    (r.sharedClientState.addLocalQueryTarget(s.targetId), i = s.view.lu()) : i = await $63c47e8a587a7f36$var$__PRIVATE_allocateTargetAndMaybeListen(r, t, n, /** shouldInitializeView= */ !0), i;
}
/** Query has been listening to the cache, and tries to initiate the remote store listen */ async function $63c47e8a587a7f36$var$__PRIVATE_triggerRemoteStoreListen(e, t) {
    const n = $63c47e8a587a7f36$var$__PRIVATE_ensureWatchCallbacks(e);
    await $63c47e8a587a7f36$var$__PRIVATE_allocateTargetAndMaybeListen(n, t, /** shouldListenToRemote= */ !0, /** shouldInitializeView= */ !1);
}
async function $63c47e8a587a7f36$var$__PRIVATE_allocateTargetAndMaybeListen(e, t, n, r) {
    const i = await $63c47e8a587a7f36$var$__PRIVATE_localStoreAllocateTarget(e.localStore, $63c47e8a587a7f36$var$__PRIVATE_queryToTarget(t)), s = i.targetId, o = e.sharedClientState.addLocalQueryTarget(s, n);
    let _;
    return r && (_ = await $63c47e8a587a7f36$var$__PRIVATE_initializeViewAndComputeSnapshot(e, t, s, "current" === o, i.resumeToken)), e.isPrimaryClient && n && $63c47e8a587a7f36$var$__PRIVATE_remoteStoreListen(e.remoteStore, i), _;
}
/**
 * Registers a view for a previously unknown query and computes its initial
 * snapshot.
 */ async function $63c47e8a587a7f36$var$__PRIVATE_initializeViewAndComputeSnapshot(e, t, n, r, i) {
    // PORTING NOTE: On Web only, we inject the code that registers new Limbo
    // targets based on view changes. This allows us to only depend on Limbo
    // changes when user code includes queries.
    e.pu = (t, n, r)=>(async function __PRIVATE_applyDocChanges(e, t, n, r) {
            let i = t.view.ru(n);
            i.Ss && // The query has a limit and some docs were removed, so we need
            // to re-run the query against the local store to make sure we
            // didn't lose any good docs that had been past the limit.
            (i = await $63c47e8a587a7f36$var$__PRIVATE_localStoreExecuteQuery(e.localStore, t.query, /* usePreviousResults= */ !1).then(({ documents: e })=>t.view.ru(e, i)));
            const s = r && r.targetChanges.get(t.targetId), o = r && null != r.targetMismatches.get(t.targetId), _ = t.view.applyChanges(i, /* limboResolutionEnabled= */ e.isPrimaryClient, s, o);
            return $63c47e8a587a7f36$var$__PRIVATE_updateTrackedLimbos(e, t.targetId, _.au), _.snapshot;
        })(e, t, n, r);
    const s = await $63c47e8a587a7f36$var$__PRIVATE_localStoreExecuteQuery(e.localStore, t, /* usePreviousResults= */ !0), o = new $63c47e8a587a7f36$var$__PRIVATE_View(t, s.ks), _ = o.ru(s.documents), a = $63c47e8a587a7f36$var$TargetChange.createSynthesizedTargetChangeForCurrentChange(n, r && "Offline" /* OnlineState.Offline */  !== e.onlineState, i), u = o.applyChanges(_, /* limboResolutionEnabled= */ e.isPrimaryClient, a);
    $63c47e8a587a7f36$var$__PRIVATE_updateTrackedLimbos(e, n, u.au);
    const c = new $63c47e8a587a7f36$var$__PRIVATE_QueryView(t, n, o);
    return e.Tu.set(t, c), e.Iu.has(n) ? e.Iu.get(n).push(t) : e.Iu.set(n, [
        t
    ]), u.snapshot;
}
/** Stops listening to the query. */ async function $63c47e8a587a7f36$var$__PRIVATE_syncEngineUnlisten(e, t, n) {
    const r = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e), i = r.Tu.get(t), s = r.Iu.get(i.targetId);
    if (s.length > 1) return r.Iu.set(i.targetId, s.filter((e)=>!$63c47e8a587a7f36$var$__PRIVATE_queryEquals(e, t))), void r.Tu.delete(t);
    // No other queries are mapped to the target, clean up the query and the target.
    if (r.isPrimaryClient) {
        // We need to remove the local query target first to allow us to verify
        // whether any other client is still interested in this target.
        r.sharedClientState.removeLocalQueryTarget(i.targetId);
        r.sharedClientState.isActiveQueryTarget(i.targetId) || await $63c47e8a587a7f36$var$__PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, /*keepPersistedTargetData=*/ !1).then(()=>{
            r.sharedClientState.clearQueryState(i.targetId), n && $63c47e8a587a7f36$var$__PRIVATE_remoteStoreUnlisten(r.remoteStore, i.targetId), $63c47e8a587a7f36$var$__PRIVATE_removeAndCleanupTarget(r, i.targetId);
        }).catch($63c47e8a587a7f36$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
    } else $63c47e8a587a7f36$var$__PRIVATE_removeAndCleanupTarget(r, i.targetId), await $63c47e8a587a7f36$var$__PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, /*keepPersistedTargetData=*/ !0);
}
/** Unlistens to the remote store while still listening to the cache. */ async function $63c47e8a587a7f36$var$__PRIVATE_triggerRemoteStoreUnlisten(e, t) {
    const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e), r = n.Tu.get(t), i = n.Iu.get(r.targetId);
    n.isPrimaryClient && 1 === i.length && // PORTING NOTE: Unregister the target ID with local Firestore client as
    // watch target.
    (n.sharedClientState.removeLocalQueryTarget(r.targetId), $63c47e8a587a7f36$var$__PRIVATE_remoteStoreUnlisten(n.remoteStore, r.targetId));
}
/**
 * Initiates the write of local mutation batch which involves adding the
 * writes to the mutation queue, notifying the remote store about new
 * mutations and raising events for any changes this write caused.
 *
 * The promise returned by this call is resolved when the above steps
 * have completed, *not* when the write was acked by the backend. The
 * userCallback is resolved once the write was acked/rejected by the
 * backend (or failed locally for any other reason).
 */ async function $63c47e8a587a7f36$var$__PRIVATE_syncEngineWrite(e, t, n) {
    const r = $63c47e8a587a7f36$var$__PRIVATE_syncEngineEnsureWriteCallbacks(e);
    try {
        const e = await function __PRIVATE_localStoreWriteLocally(e, t) {
            const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e), r = $63c47e8a587a7f36$export$3d12bd131bb975d1.now(), i = t.reduce((e, t)=>e.add(t.key), $63c47e8a587a7f36$export$971d5caa766a69d7());
            let s, o;
            return n.persistence.runTransaction("Locally write mutations", "readwrite", (e)=>{
                // Figure out which keys do not have a remote version in the cache, this
                // is needed to create the right overlay mutation: if no remote version
                // presents, we do not need to create overlays as patch mutations.
                // TODO(Overlay): Is there a better way to determine this? Using the
                //  document version does not work because local mutations set them back
                //  to 0.
                let _ = $63c47e8a587a7f36$var$__PRIVATE_mutableDocumentMap(), a = $63c47e8a587a7f36$export$971d5caa766a69d7();
                return n.xs.getEntries(e, i).next((e)=>{
                    _ = e, _.forEach((e, t)=>{
                        t.isValidDocument() || (a = a.add(e));
                    });
                }).next(()=>n.localDocuments.getOverlayedDocuments(e, _)).next((i)=>{
                    s = i;
                    // For non-idempotent mutations (such as `FieldValue.increment()`),
                    // we record the base state in a separate patch mutation. This is
                    // later used to guarantee consistent values and prevents flicker
                    // even if the backend sends us an update that already includes our
                    // transform.
                    const o = [];
                    for (const e of t){
                        const t = $63c47e8a587a7f36$var$__PRIVATE_mutationExtractBaseValue(e, s.get(e.key).overlayedDocument);
                        null != t && // NOTE: The base state should only be applied if there's some
                        // existing document to override, so use a Precondition of
                        // exists=true
                        o.push(new $63c47e8a587a7f36$var$__PRIVATE_PatchMutation(e.key, t, $63c47e8a587a7f36$var$__PRIVATE_extractFieldMask(t.value.mapValue), $63c47e8a587a7f36$export$78acf4525d8a74c4.exists(!0)));
                    }
                    return n.mutationQueue.addMutationBatch(e, r, o, t);
                }).next((t)=>{
                    o = t;
                    const r = t.applyToLocalDocumentSet(s, a);
                    return n.documentOverlayCache.saveOverlays(e, t.batchId, r);
                });
            }).then(()=>({
                    batchId: o.batchId,
                    changes: $63c47e8a587a7f36$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(s)
                }));
        }(r.localStore, t);
        r.sharedClientState.addPendingMutation(e.batchId), function __PRIVATE_addMutationCallback(e, t, n) {
            let r = e.du[e.currentUser.toKey()];
            r || (r = new $63c47e8a587a7f36$var$SortedMap($63c47e8a587a7f36$var$__PRIVATE_primitiveComparator));
            r = r.insert(t, n), e.du[e.currentUser.toKey()] = r;
        }(r, e.batchId, n), await $63c47e8a587a7f36$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, e.changes), await $63c47e8a587a7f36$var$__PRIVATE_fillWritePipeline(r.remoteStore);
    } catch (e) {
        // If we can't persist the mutation, we reject the user callback and
        // don't send the mutation. The user can then retry the write.
        const t = $63c47e8a587a7f36$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, "Failed to persist write");
        n.reject(t);
    }
}
/**
 * Applies one remote event to the sync engine, notifying any views of the
 * changes, and releasing any pending mutation batches that would become
 * visible because of the snapshot version the remote event contains.
 */ async function $63c47e8a587a7f36$var$__PRIVATE_syncEngineApplyRemoteEvent(e, t) {
    const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    try {
        const e = await $63c47e8a587a7f36$var$__PRIVATE_localStoreApplyRemoteEventToLocalCache(n.localStore, t);
        // Update `receivedDocument` as appropriate for any limbo targets.
        t.targetChanges.forEach((e, t)=>{
            const r = n.Au.get(t);
            r && // Since this is a limbo resolution lookup, it's for a single document
            // and it could be added, modified, or removed, but not a combination.
            ($63c47e8a587a7f36$export$c18d01048907ea92(e.addedDocuments.size + e.modifiedDocuments.size + e.removedDocuments.size <= 1, 22616), e.addedDocuments.size > 0 ? r.hu = !0 : e.modifiedDocuments.size > 0 ? $63c47e8a587a7f36$export$c18d01048907ea92(r.hu, 14607) : e.removedDocuments.size > 0 && ($63c47e8a587a7f36$export$c18d01048907ea92(r.hu, 42227), r.hu = !1));
        }), await $63c47e8a587a7f36$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e, t);
    } catch (e) {
        await $63c47e8a587a7f36$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
    }
}
/**
 * Applies an OnlineState change to the sync engine and notifies any views of
 * the change.
 */ function $63c47e8a587a7f36$var$__PRIVATE_syncEngineApplyOnlineStateChange(e, t, n) {
    const r = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    // If we are the secondary client, we explicitly ignore the remote store's
    // online state (the local client may go offline, even though the primary
    // tab remains online) and only apply the primary tab's online state from
    // SharedClientState.
    if (r.isPrimaryClient && 0 /* OnlineStateSource.RemoteStore */  === n || !r.isPrimaryClient && 1 /* OnlineStateSource.SharedClientState */  === n) {
        const e = [];
        r.Tu.forEach((n, r)=>{
            const i = r.view.va(t);
            i.snapshot && e.push(i.snapshot);
        }), function __PRIVATE_eventManagerOnOnlineStateChange(e, t) {
            const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
            n.onlineState = t;
            let r = !1;
            n.queries.forEach((e, n)=>{
                for (const e of n.ba)// Run global snapshot listeners if a consistent snapshot has been emitted.
                e.va(t) && (r = !0);
            }), r && $63c47e8a587a7f36$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
        }(r.eventManager, t), e.length && r.Pu.J_(e), r.onlineState = t, r.isPrimaryClient && r.sharedClientState.setOnlineState(t);
    }
}
/**
 * Rejects the listen for the given targetID. This can be triggered by the
 * backend for any active target.
 *
 * @param syncEngine - The sync engine implementation.
 * @param targetId - The targetID corresponds to one previously initiated by the
 * user as part of TargetData passed to listen() on RemoteStore.
 * @param err - A description of the condition that has forced the rejection.
 * Nearly always this will be an indication that the user is no longer
 * authorized to see the data matching the target.
 */ async function $63c47e8a587a7f36$var$__PRIVATE_syncEngineRejectListen(e, t, n) {
    const r = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    // PORTING NOTE: Multi-tab only.
    r.sharedClientState.updateQueryState(t, "rejected", n);
    const i = r.Au.get(t), s = i && i.key;
    if (s) {
        // TODO(klimt): We really only should do the following on permission
        // denied errors, but we don't have the cause code here.
        // It's a limbo doc. Create a synthetic event saying it was deleted.
        // This is kind of a hack. Ideally, we would have a method in the local
        // store to purge a document. However, it would be tricky to keep all of
        // the local store's invariants with another method.
        let e = new $63c47e8a587a7f36$var$SortedMap($63c47e8a587a7f36$export$90a7f3efeed30595.comparator);
        // TODO(b/217189216): This limbo document should ideally have a read time,
        // so that it is picked up by any read-time based scans. The backend,
        // however, does not send a read time for target removals.
        e = e.insert(s, $63c47e8a587a7f36$var$MutableDocument.newNoDocument(s, $63c47e8a587a7f36$var$SnapshotVersion.min()));
        const n = $63c47e8a587a7f36$export$971d5caa766a69d7().add(s), i = new $63c47e8a587a7f36$var$RemoteEvent($63c47e8a587a7f36$var$SnapshotVersion.min(), /* targetChanges= */ new Map, /* targetMismatches= */ new $63c47e8a587a7f36$var$SortedMap($63c47e8a587a7f36$var$__PRIVATE_primitiveComparator), e, n);
        await $63c47e8a587a7f36$var$__PRIVATE_syncEngineApplyRemoteEvent(r, i), // Since this query failed, we won't want to manually unlisten to it.
        // We only remove it from bookkeeping after we successfully applied the
        // RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
        // this query when the RemoteStore restarts the Watch stream, which should
        // re-trigger the target failure.
        r.Ru = r.Ru.remove(s), r.Au.delete(t), $63c47e8a587a7f36$var$__PRIVATE_pumpEnqueuedLimboResolutions(r);
    } else await $63c47e8a587a7f36$var$__PRIVATE_localStoreReleaseTarget(r.localStore, t, /* keepPersistedTargetData */ !1).then(()=>$63c47e8a587a7f36$var$__PRIVATE_removeAndCleanupTarget(r, t, n)).catch($63c47e8a587a7f36$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
}
async function $63c47e8a587a7f36$var$__PRIVATE_syncEngineApplySuccessfulWrite(e, t) {
    const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e), r = t.batch.batchId;
    try {
        const e = await $63c47e8a587a7f36$var$__PRIVATE_localStoreAcknowledgeBatch(n.localStore, t);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught
        // up), so we raise user callbacks first so that they consistently happen
        // before listen events.
        $63c47e8a587a7f36$var$__PRIVATE_processUserCallback(n, r, /*error=*/ null), $63c47e8a587a7f36$var$__PRIVATE_triggerPendingWritesCallbacks(n, r), n.sharedClientState.updateMutationState(r, "acknowledged"), await $63c47e8a587a7f36$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e);
    } catch (e) {
        await $63c47e8a587a7f36$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
    }
}
async function $63c47e8a587a7f36$var$__PRIVATE_syncEngineRejectFailedWrite(e, t, n) {
    const r = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    try {
        const e = await function __PRIVATE_localStoreRejectBatch(e, t) {
            const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
            return n.persistence.runTransaction("Reject batch", "readwrite-primary", (e)=>{
                let r;
                return n.mutationQueue.lookupMutationBatch(e, t).next((t)=>($63c47e8a587a7f36$export$c18d01048907ea92(null !== t, 37113), r = t.keys(), n.mutationQueue.removeMutationBatch(e, t))).next(()=>n.mutationQueue.performConsistencyCheck(e)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(e, r, t)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, r)).next(()=>n.localDocuments.getDocuments(e, r));
            });
        }(r.localStore, t);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught up),
        // so we raise user callbacks first so that they consistently happen before
        // listen events.
        $63c47e8a587a7f36$var$__PRIVATE_processUserCallback(r, t, n), $63c47e8a587a7f36$var$__PRIVATE_triggerPendingWritesCallbacks(r, t), r.sharedClientState.updateMutationState(t, "rejected", n), await $63c47e8a587a7f36$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, e);
    } catch (n) {
        await $63c47e8a587a7f36$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(n);
    }
}
/**
 * Registers a user callback that resolves when all pending mutations at the moment of calling
 * are acknowledged .
 */ async function $63c47e8a587a7f36$var$__PRIVATE_syncEngineRegisterPendingWritesCallback(e, t) {
    const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    $63c47e8a587a7f36$var$__PRIVATE_canUseNetwork(n.remoteStore) || $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Xt, "The network is disabled. The task returned by 'awaitPendingWrites()' will not complete until the network is enabled.");
    try {
        const e = await function __PRIVATE_localStoreGetHighestUnacknowledgedBatchId(e) {
            const t = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
            return t.persistence.runTransaction("Get highest unacknowledged batch id", "readonly", (e)=>t.mutationQueue.getHighestUnacknowledgedBatchId(e));
        }(n.localStore);
        if (e === $63c47e8a587a7f36$var$U) // Trigger the callback right away if there is no pending writes at the moment.
        return void t.resolve();
        const r = n.mu.get(e) || [];
        r.push(t), n.mu.set(e, r);
    } catch (e) {
        const n = $63c47e8a587a7f36$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, "Initialization of waitForPendingWrites() operation failed");
        t.reject(n);
    }
}
/**
 * Triggers the callbacks that are waiting for this batch id to get acknowledged by server,
 * if there are any.
 */ function $63c47e8a587a7f36$var$__PRIVATE_triggerPendingWritesCallbacks(e, t) {
    (e.mu.get(t) || []).forEach((e)=>{
        e.resolve();
    }), e.mu.delete(t);
}
/** Reject all outstanding callbacks waiting for pending writes to complete. */ function $63c47e8a587a7f36$var$__PRIVATE_processUserCallback(e, t, n) {
    const r = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    let i = r.du[r.currentUser.toKey()];
    // NOTE: Mutations restored from persistence won't have callbacks, so it's
    // okay for there to be no callback for this ID.
    if (i) {
        const e = i.get(t);
        e && (n ? e.reject(n) : e.resolve(), i = i.remove(t)), r.du[r.currentUser.toKey()] = i;
    }
}
function $63c47e8a587a7f36$var$__PRIVATE_removeAndCleanupTarget(e, t, n = null) {
    e.sharedClientState.removeLocalQueryTarget(t);
    for (const r of e.Iu.get(t))e.Tu.delete(r), n && e.Pu.yu(r, n);
    if (e.Iu.delete(t), e.isPrimaryClient) e.Vu.Gr(t).forEach((t)=>{
        e.Vu.containsKey(t) || // We removed the last reference for this key
        $63c47e8a587a7f36$var$__PRIVATE_removeLimboTarget(e, t);
    });
}
function $63c47e8a587a7f36$var$__PRIVATE_removeLimboTarget(e, t) {
    e.Eu.delete(t.path.canonicalString());
    // It's possible that the target already got removed because the query failed. In that case,
    // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
    const n = e.Ru.get(t);
    null !== n && ($63c47e8a587a7f36$var$__PRIVATE_remoteStoreUnlisten(e.remoteStore, n), e.Ru = e.Ru.remove(t), e.Au.delete(n), $63c47e8a587a7f36$var$__PRIVATE_pumpEnqueuedLimboResolutions(e));
}
function $63c47e8a587a7f36$var$__PRIVATE_updateTrackedLimbos(e, t, n) {
    for (const r of n)if (r instanceof $63c47e8a587a7f36$var$__PRIVATE_AddedLimboDocument) e.Vu.addReference(r.key, t), $63c47e8a587a7f36$var$__PRIVATE_trackLimboChange(e, r);
    else if (r instanceof $63c47e8a587a7f36$var$__PRIVATE_RemovedLimboDocument) {
        $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Xt, "Document no longer in limbo: " + r.key), e.Vu.removeReference(r.key, t);
        e.Vu.containsKey(r.key) || // We removed the last reference for this key
        $63c47e8a587a7f36$var$__PRIVATE_removeLimboTarget(e, r.key);
    } else $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(19791, {
        wu: r
    });
}
function $63c47e8a587a7f36$var$__PRIVATE_trackLimboChange(e, t) {
    const n = t.key, r = n.path.canonicalString();
    e.Ru.get(n) || e.Eu.has(r) || ($63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Xt, "New document in limbo: " + n), e.Eu.add(r), $63c47e8a587a7f36$var$__PRIVATE_pumpEnqueuedLimboResolutions(e));
}
/**
 * Starts listens for documents in limbo that are enqueued for resolution,
 * subject to a maximum number of concurrent resolutions.
 *
 * Without bounding the number of concurrent resolutions, the server can fail
 * with "resource exhausted" errors which can lead to pathological client
 * behavior as seen in https://github.com/firebase/firebase-js-sdk/issues/2683.
 */ function $63c47e8a587a7f36$var$__PRIVATE_pumpEnqueuedLimboResolutions(e) {
    for(; e.Eu.size > 0 && e.Ru.size < e.maxConcurrentLimboResolutions;){
        const t = e.Eu.values().next().value;
        e.Eu.delete(t);
        const n = new $63c47e8a587a7f36$export$90a7f3efeed30595($63c47e8a587a7f36$export$db202ddc8be9136.fromString(t)), r = e.fu.next();
        e.Au.set(r, new $63c47e8a587a7f36$var$LimboResolution(n)), e.Ru = e.Ru.insert(n, r), $63c47e8a587a7f36$var$__PRIVATE_remoteStoreListen(e.remoteStore, new $63c47e8a587a7f36$var$TargetData($63c47e8a587a7f36$var$__PRIVATE_queryToTarget($63c47e8a587a7f36$export$a93c5207d687da10(n.path)), r, "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ , $63c47e8a587a7f36$var$__PRIVATE_ListenSequence.ce));
    }
}
async function $63c47e8a587a7f36$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, t, n) {
    const r = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e), i = [], s = [], o = [];
    r.Tu.isEmpty() || (r.Tu.forEach((e, _)=>{
        o.push(r.pu(_, t, n).then((e)=>{
            // If there are changes, or we are handling a global snapshot, notify
            // secondary clients to update query state.
            if ((e || n) && r.isPrimaryClient) {
                // Query state is set to `current` if:
                // - There is a view change and it is up-to-date, or,
                // - There is a global snapshot, the Target is current, and no changes to be resolved
                const t = e ? !e.fromCache : n?.targetChanges.get(_.targetId)?.current;
                r.sharedClientState.updateQueryState(_.targetId, t ? "current" : "not-current");
            }
            // Update views if there are actual changes.
            if (e) {
                i.push(e);
                const t = $63c47e8a587a7f36$var$__PRIVATE_LocalViewChanges.Es(_.targetId, e);
                s.push(t);
            }
        }));
    }), await Promise.all(o), r.Pu.J_(i), await async function __PRIVATE_localStoreNotifyLocalViewChanges(e, t) {
        const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
        try {
            await n.persistence.runTransaction("notifyLocalViewChanges", "readwrite", (e)=>$63c47e8a587a7f36$var$PersistencePromise.forEach(t, (t)=>$63c47e8a587a7f36$var$PersistencePromise.forEach(t.Ts, (r)=>n.persistence.referenceDelegate.addReference(e, t.targetId, r)).next(()=>$63c47e8a587a7f36$var$PersistencePromise.forEach(t.Is, (r)=>n.persistence.referenceDelegate.removeReference(e, t.targetId, r)))));
        } catch (e) {
            if (!$63c47e8a587a7f36$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
            // If `notifyLocalViewChanges` fails, we did not advance the sequence
            // number for the documents that were included in this transaction.
            // This might trigger them to be deleted earlier than they otherwise
            // would have, but it should not invalidate the integrity of the data.
            $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Bt, "Failed to update sequence numbers: " + e);
        }
        for (const e of t){
            const t = e.targetId;
            if (!e.fromCache) {
                const e = n.vs.get(t), r = e.snapshotVersion, i = e.withLastLimboFreeSnapshotVersion(r);
                // Advance the last limbo free snapshot version
                n.vs = n.vs.insert(t, i);
            }
        }
    }(r.localStore, s));
}
async function $63c47e8a587a7f36$var$__PRIVATE_syncEngineHandleCredentialChange(e, t) {
    const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    if (!n.currentUser.isEqual(t)) {
        $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Xt, "User change. New user:", t.toKey());
        const e = await $63c47e8a587a7f36$var$__PRIVATE_localStoreHandleUserChange(n.localStore, t);
        n.currentUser = t, // Fails tasks waiting for pending writes requested by previous user.
        function __PRIVATE_rejectOutstandingPendingWritesCallbacks(e, t) {
            e.mu.forEach((e)=>{
                e.forEach((e)=>{
                    e.reject(new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.CANCELLED, t));
                });
            }), e.mu.clear();
        }(n, "'waitForPendingWrites' promise is rejected due to a user change."), // TODO(b/114226417): Consider calling this only in the primary tab.
        n.sharedClientState.handleUserChange(t, e.removedBatchIds, e.addedBatchIds), await $63c47e8a587a7f36$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e.Ns);
    }
}
function $63c47e8a587a7f36$var$__PRIVATE_syncEngineGetRemoteKeysForTarget(e, t) {
    const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e), r = n.Au.get(t);
    if (r && r.hu) return $63c47e8a587a7f36$export$971d5caa766a69d7().add(r.key);
    {
        let e = $63c47e8a587a7f36$export$971d5caa766a69d7();
        const r = n.Iu.get(t);
        if (!r) return e;
        for (const t of r){
            const r = n.Tu.get(t);
            e = e.unionWith(r.view.nu);
        }
        return e;
    }
}
/**
 * Reconcile the list of synced documents in an existing view with those
 * from persistence.
 */ async function $63c47e8a587a7f36$var$__PRIVATE_synchronizeViewAndComputeSnapshot(e, t) {
    const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e), r = await $63c47e8a587a7f36$var$__PRIVATE_localStoreExecuteQuery(n.localStore, t.query, /* usePreviousResults= */ !0), i = t.view.cu(r);
    return n.isPrimaryClient && $63c47e8a587a7f36$var$__PRIVATE_updateTrackedLimbos(n, t.targetId, i.au), i;
}
/**
 * Retrieves newly changed documents from remote document cache and raises
 * snapshots if needed.
 */ // PORTING NOTE: Multi-Tab only.
async function $63c47e8a587a7f36$var$__PRIVATE_syncEngineSynchronizeWithChangedDocuments(e, t) {
    const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    return $63c47e8a587a7f36$var$__PRIVATE_localStoreGetNewDocumentChanges(n.localStore, t).then((e)=>$63c47e8a587a7f36$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e));
}
/** Applies a mutation state to an existing batch.  */ // PORTING NOTE: Multi-Tab only.
async function $63c47e8a587a7f36$var$__PRIVATE_syncEngineApplyBatchState(e, t, n, r) {
    const i = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e), s = await function __PRIVATE_localStoreLookupMutationDocuments(e, t) {
        const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e), r = $63c47e8a587a7f36$var$__PRIVATE_debugCast(n.mutationQueue);
        return n.persistence.runTransaction("Lookup mutation documents", "readonly", (e)=>r.Xn(e, t).next((t)=>t ? n.localDocuments.getDocuments(e, t) : $63c47e8a587a7f36$var$PersistencePromise.resolve(null)));
    }(i.localStore, t);
    null !== s ? ("pending" === n ? // If we are the primary client, we need to send this write to the
    // backend. Secondary clients will ignore these writes since their remote
    // connection is disabled.
    await $63c47e8a587a7f36$var$__PRIVATE_fillWritePipeline(i.remoteStore) : "acknowledged" === n || "rejected" === n ? // NOTE: Both these methods are no-ops for batches that originated from
    // other clients.
    ($63c47e8a587a7f36$var$__PRIVATE_processUserCallback(i, t, r || null), $63c47e8a587a7f36$var$__PRIVATE_triggerPendingWritesCallbacks(i, t), function __PRIVATE_localStoreRemoveCachedMutationBatchMetadata(e, t) {
        $63c47e8a587a7f36$var$__PRIVATE_debugCast($63c47e8a587a7f36$var$__PRIVATE_debugCast(e).mutationQueue).nr(t);
    }(i.localStore, t)) : $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(6720, "Unknown batchState", {
        bu: n
    }), await $63c47e8a587a7f36$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, s)) : // A throttled tab may not have seen the mutation before it was completed
    // and removed from the mutation queue, in which case we won't have cached
    // the affected documents. In this case we can safely ignore the update
    // since that means we didn't apply the mutation locally at all (if we
    // had, we would have cached the affected documents), and so we will just
    // see any resulting document changes via normal remote document updates
    // as applicable.
    $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Xt, "Cannot apply mutation batch with id: " + t);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $63c47e8a587a7f36$var$__PRIVATE_syncEngineApplyPrimaryState(e, t) {
    const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    if ($63c47e8a587a7f36$var$__PRIVATE_ensureWatchCallbacks(n), $63c47e8a587a7f36$var$__PRIVATE_syncEngineEnsureWriteCallbacks(n), !0 === t && !0 !== n.gu) {
        // Secondary tabs only maintain Views for their local listeners and the
        // Views internal state may not be 100% populated (in particular
        // secondary tabs don't track syncedDocuments, the set of documents the
        // server considers to be in the target). So when a secondary becomes
        // primary, we need to need to make sure that all views for all targets
        // match the state on disk.
        const e = n.sharedClientState.getAllActiveQueryTargets(), t = await $63c47e8a587a7f36$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, e.toArray());
        n.gu = !0, await $63c47e8a587a7f36$var$__PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !0);
        for (const e of t)$63c47e8a587a7f36$var$__PRIVATE_remoteStoreListen(n.remoteStore, e);
    } else if (!1 === t && !1 !== n.gu) {
        const e = [];
        let t = Promise.resolve();
        n.Iu.forEach((r, i)=>{
            n.sharedClientState.isLocalQueryTarget(i) ? e.push(i) : t = t.then(()=>($63c47e8a587a7f36$var$__PRIVATE_removeAndCleanupTarget(n, i), $63c47e8a587a7f36$var$__PRIVATE_localStoreReleaseTarget(n.localStore, i, /*keepPersistedTargetData=*/ !0))), $63c47e8a587a7f36$var$__PRIVATE_remoteStoreUnlisten(n.remoteStore, i);
        }), await t, await $63c47e8a587a7f36$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, e), // PORTING NOTE: Multi-Tab only.
        function __PRIVATE_resetLimboDocuments(e) {
            const t = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
            t.Au.forEach((e, n)=>{
                $63c47e8a587a7f36$var$__PRIVATE_remoteStoreUnlisten(t.remoteStore, n);
            }), t.Vu.zr(), t.Au = new Map, t.Ru = new $63c47e8a587a7f36$var$SortedMap($63c47e8a587a7f36$export$90a7f3efeed30595.comparator);
        }(n), n.gu = !1, await $63c47e8a587a7f36$var$__PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !1);
    }
}
async function $63c47e8a587a7f36$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(e, t, n) {
    const r = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e), i = [], s = [];
    for (const e of t){
        let t;
        const n = r.Iu.get(e);
        if (n && 0 !== n.length) {
            // For queries that have a local View, we fetch their current state
            // from LocalStore (as the resume token and the snapshot version
            // might have changed) and reconcile their views with the persisted
            // state (the list of syncedDocuments may have gotten out of sync).
            t = await $63c47e8a587a7f36$var$__PRIVATE_localStoreAllocateTarget(r.localStore, $63c47e8a587a7f36$var$__PRIVATE_queryToTarget(n[0]));
            for (const e of n){
                const t = r.Tu.get(e), n = await $63c47e8a587a7f36$var$__PRIVATE_synchronizeViewAndComputeSnapshot(r, t);
                n.snapshot && s.push(n.snapshot);
            }
        } else {
            // For queries that never executed on this client, we need to
            // allocate the target in LocalStore and initialize a new View.
            const n = await $63c47e8a587a7f36$var$__PRIVATE_localStoreGetCachedTarget(r.localStore, e);
            t = await $63c47e8a587a7f36$var$__PRIVATE_localStoreAllocateTarget(r.localStore, n), await $63c47e8a587a7f36$var$__PRIVATE_initializeViewAndComputeSnapshot(r, $63c47e8a587a7f36$var$__PRIVATE_synthesizeTargetToQuery(n), e, /*current=*/ !1, t.resumeToken);
        }
        i.push(t);
    }
    return r.Pu.J_(s), i;
}
/**
 * Creates a `Query` object from the specified `Target`. There is no way to
 * obtain the original `Query`, so we synthesize a `Query` from the `Target`
 * object.
 *
 * The synthesized result might be different from the original `Query`, but
 * since the synthesized `Query` should return the same results as the
 * original one (only the presentation of results might differ), the potential
 * difference will not cause issues.
 */ // PORTING NOTE: Multi-Tab only.
function $63c47e8a587a7f36$var$__PRIVATE_synthesizeTargetToQuery(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_newQuery(e.path, e.collectionGroup, e.orderBy, e.filters, e.limit, "F" /* LimitType.First */ , e.startAt, e.endAt);
}
/** Returns the IDs of the clients that are currently active. */ // PORTING NOTE: Multi-Tab only.
function $63c47e8a587a7f36$var$__PRIVATE_syncEngineGetActiveClients(e) {
    return function __PRIVATE_localStoreGetActiveClients(e) {
        return $63c47e8a587a7f36$var$__PRIVATE_debugCast($63c47e8a587a7f36$var$__PRIVATE_debugCast(e).persistence).hs();
    }($63c47e8a587a7f36$var$__PRIVATE_debugCast(e).localStore);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $63c47e8a587a7f36$var$__PRIVATE_syncEngineApplyTargetState(e, t, n, r) {
    const i = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    if (i.gu) // If we receive a target state notification via WebStorage, we are
    // either already secondary or another tab has taken the primary lease.
    return void $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Xt, "Ignoring unexpected query state notification.");
    const s = i.Iu.get(t);
    if (s && s.length > 0) switch(n){
        case "current":
        case "not-current":
            {
                const e = await $63c47e8a587a7f36$var$__PRIVATE_localStoreGetNewDocumentChanges(i.localStore, $63c47e8a587a7f36$var$__PRIVATE_queryCollectionGroup(s[0])), r = $63c47e8a587a7f36$var$RemoteEvent.createSynthesizedRemoteEventForCurrentChange(t, "current" === n, $63c47e8a587a7f36$export$9d398bebfec1c039.EMPTY_BYTE_STRING);
                await $63c47e8a587a7f36$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, e, r);
                break;
            }
        case "rejected":
            await $63c47e8a587a7f36$var$__PRIVATE_localStoreReleaseTarget(i.localStore, t, /* keepPersistedTargetData */ !0), $63c47e8a587a7f36$var$__PRIVATE_removeAndCleanupTarget(i, t, r);
            break;
        default:
            $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(64155, n);
    }
}
/** Adds or removes Watch targets for queries from different tabs. */ async function $63c47e8a587a7f36$var$__PRIVATE_syncEngineApplyActiveTargetsChange(e, t, n) {
    const r = $63c47e8a587a7f36$var$__PRIVATE_ensureWatchCallbacks(e);
    if (r.gu) {
        for (const e of t){
            if (r.Iu.has(e) && r.sharedClientState.isActiveQueryTarget(e)) {
                $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Xt, "Adding an already active target " + e);
                continue;
            }
            const t = await $63c47e8a587a7f36$var$__PRIVATE_localStoreGetCachedTarget(r.localStore, e), n = await $63c47e8a587a7f36$var$__PRIVATE_localStoreAllocateTarget(r.localStore, t);
            await $63c47e8a587a7f36$var$__PRIVATE_initializeViewAndComputeSnapshot(r, $63c47e8a587a7f36$var$__PRIVATE_synthesizeTargetToQuery(t), n.targetId, /*current=*/ !1, n.resumeToken), $63c47e8a587a7f36$var$__PRIVATE_remoteStoreListen(r.remoteStore, n);
        }
        for (const e of n)// Check that the target is still active since the target might have been
        // removed if it has been rejected by the backend.
        r.Iu.has(e) && // Release queries that are still active.
        await $63c47e8a587a7f36$var$__PRIVATE_localStoreReleaseTarget(r.localStore, e, /* keepPersistedTargetData */ !1).then(()=>{
            $63c47e8a587a7f36$var$__PRIVATE_remoteStoreUnlisten(r.remoteStore, e), $63c47e8a587a7f36$var$__PRIVATE_removeAndCleanupTarget(r, e);
        }).catch($63c47e8a587a7f36$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
    }
}
function $63c47e8a587a7f36$var$__PRIVATE_ensureWatchCallbacks(e) {
    const t = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applyRemoteEvent = $63c47e8a587a7f36$var$__PRIVATE_syncEngineApplyRemoteEvent.bind(null, t), t.remoteStore.remoteSyncer.getRemoteKeysForTarget = $63c47e8a587a7f36$var$__PRIVATE_syncEngineGetRemoteKeysForTarget.bind(null, t), t.remoteStore.remoteSyncer.rejectListen = $63c47e8a587a7f36$var$__PRIVATE_syncEngineRejectListen.bind(null, t), t.Pu.J_ = $63c47e8a587a7f36$var$__PRIVATE_eventManagerOnWatchChange.bind(null, t.eventManager), t.Pu.yu = $63c47e8a587a7f36$var$__PRIVATE_eventManagerOnWatchError.bind(null, t.eventManager), t;
}
function $63c47e8a587a7f36$var$__PRIVATE_syncEngineEnsureWriteCallbacks(e) {
    const t = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applySuccessfulWrite = $63c47e8a587a7f36$var$__PRIVATE_syncEngineApplySuccessfulWrite.bind(null, t), t.remoteStore.remoteSyncer.rejectFailedWrite = $63c47e8a587a7f36$var$__PRIVATE_syncEngineRejectFailedWrite.bind(null, t), t;
}
/**
 * Loads a Firestore bundle into the SDK. The returned promise resolves when
 * the bundle finished loading.
 *
 * @param syncEngine - SyncEngine to use.
 * @param bundleReader - Bundle to load into the SDK.
 * @param task - LoadBundleTask used to update the loading progress to public API.
 */ function $63c47e8a587a7f36$var$__PRIVATE_syncEngineLoadBundle(e, t, n) {
    const r = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    /** Loads a bundle and returns the list of affected collection groups. */ (async function __PRIVATE_loadBundleImpl(e, t, n) {
        try {
            const r = await t.getMetadata();
            if (await function __PRIVATE_localStoreHasNewerBundle(e, t) {
                const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e), r = $63c47e8a587a7f36$var$__PRIVATE_fromVersion(t.createTime);
                return n.persistence.runTransaction("hasNewerBundle", "readonly", (e)=>n.Pi.getBundleMetadata(e, t.id)).then((e)=>!!e && e.createTime.compareTo(r) >= 0);
            }(e.localStore, r)) return await t.close(), n._completeWith(function __PRIVATE_bundleSuccessProgress(e) {
                return {
                    taskState: "Success",
                    documentsLoaded: e.totalDocuments,
                    bytesLoaded: e.totalBytes,
                    totalDocuments: e.totalDocuments,
                    totalBytes: e.totalBytes
                };
            }(r)), Promise.resolve(new Set);
            n._updateProgress($63c47e8a587a7f36$var$__PRIVATE_bundleInitialProgress(r));
            const i = new $63c47e8a587a7f36$export$61196ced6d74a310(r, t.serializer);
            let s = await t.Su();
            for(; s;){
                const e = await i.Ga(s);
                e && n._updateProgress(e), s = await t.Su();
            }
            const o = await i.ja(e.localStore);
            return await $63c47e8a587a7f36$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, o.Ja, /* remoteEvent */ void 0), // Save metadata, so loading the same bundle will skip.
            await function __PRIVATE_localStoreSaveBundle(e, t) {
                const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
                return n.persistence.runTransaction("Save bundle", "readwrite", (e)=>n.Pi.saveBundleMetadata(e, t));
            }(e.localStore, r), n._completeWith(o.progress), Promise.resolve(o.Ha);
        } catch (e) {
            return $63c47e8a587a7f36$export$4c3d22f3d993c33f($63c47e8a587a7f36$var$Xt, `Loading bundle failed with ${e}`), n._failWith(e), Promise.resolve(new Set);
        }
    })(r, t, n).then((e)=>{
        r.sharedClientState.notifyBundleLoaded(e);
    });
}
class $63c47e8a587a7f36$export$d24c54395ce0c509 {
    constructor(){
        this.kind = "memory", this.synchronizeTabs = !1;
    }
    async initialize(e) {
        this.serializer = $63c47e8a587a7f36$export$b4171a6734a65d42(e.databaseInfo.databaseId), this.sharedClientState = this.Du(e), this.persistence = this.Cu(e), await this.persistence.start(), this.localStore = this.vu(e), this.gcScheduler = this.Fu(e, this.localStore), this.indexBackfillerScheduler = this.Mu(e, this.localStore);
    }
    Fu(e, t) {
        return null;
    }
    Mu(e, t) {
        return null;
    }
    vu(e) {
        return $63c47e8a587a7f36$var$__PRIVATE_newLocalStore(this.persistence, new $63c47e8a587a7f36$var$__PRIVATE_QueryEngine, e.initialUser, this.serializer);
    }
    Cu(e) {
        return new $63c47e8a587a7f36$var$__PRIVATE_MemoryPersistence($63c47e8a587a7f36$var$__PRIVATE_MemoryEagerDelegate.Vi, this.serializer);
    }
    Du(e) {
        return new $63c47e8a587a7f36$var$__PRIVATE_MemorySharedClientState;
    }
    async terminate() {
        this.gcScheduler?.stop(), this.indexBackfillerScheduler?.stop(), this.sharedClientState.shutdown(), await this.persistence.shutdown();
    }
}
$63c47e8a587a7f36$export$d24c54395ce0c509.provider = {
    build: ()=>new $63c47e8a587a7f36$export$d24c54395ce0c509
};
class $63c47e8a587a7f36$export$8a5498727ef6be21 extends $63c47e8a587a7f36$export$d24c54395ce0c509 {
    constructor(e){
        super(), this.cacheSizeBytes = e;
    }
    Fu(e, t) {
        $63c47e8a587a7f36$export$c18d01048907ea92(this.persistence.referenceDelegate instanceof $63c47e8a587a7f36$var$__PRIVATE_MemoryLruDelegate, 46915);
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $63c47e8a587a7f36$var$__PRIVATE_LruScheduler(n, e.asyncQueue, t);
    }
    Cu(e) {
        const t = void 0 !== this.cacheSizeBytes ? $63c47e8a587a7f36$var$LruParams.withCacheSize(this.cacheSizeBytes) : $63c47e8a587a7f36$var$LruParams.DEFAULT;
        return new $63c47e8a587a7f36$var$__PRIVATE_MemoryPersistence((e)=>$63c47e8a587a7f36$var$__PRIVATE_MemoryLruDelegate.Vi(e, t), this.serializer);
    }
}
/**
 * Provides all components needed for Firestore with IndexedDB persistence.
 */ class $63c47e8a587a7f36$export$6554612db691658e extends $63c47e8a587a7f36$export$d24c54395ce0c509 {
    constructor(e, t, n){
        super(), this.xu = e, this.cacheSizeBytes = t, this.forceOwnership = n, this.kind = "persistent", this.synchronizeTabs = !1;
    }
    async initialize(e) {
        await super.initialize(e), await this.xu.initialize(this, e), // Enqueue writes from a previous session
        await $63c47e8a587a7f36$var$__PRIVATE_syncEngineEnsureWriteCallbacks(this.xu.syncEngine), await $63c47e8a587a7f36$var$__PRIVATE_fillWritePipeline(this.xu.remoteStore), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.zi(()=>(this.gcScheduler && !this.gcScheduler.started && this.gcScheduler.start(), this.indexBackfillerScheduler && !this.indexBackfillerScheduler.started && this.indexBackfillerScheduler.start(), Promise.resolve()));
    }
    vu(e) {
        return $63c47e8a587a7f36$var$__PRIVATE_newLocalStore(this.persistence, new $63c47e8a587a7f36$var$__PRIVATE_QueryEngine, e.initialUser, this.serializer);
    }
    Fu(e, t) {
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $63c47e8a587a7f36$var$__PRIVATE_LruScheduler(n, e.asyncQueue, t);
    }
    Mu(e, t) {
        const n = new $63c47e8a587a7f36$var$__PRIVATE_IndexBackfiller(t, this.persistence);
        return new $63c47e8a587a7f36$var$__PRIVATE_IndexBackfillerScheduler(e.asyncQueue, n);
    }
    Cu(e) {
        const t = $63c47e8a587a7f36$var$__PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey), n = void 0 !== this.cacheSizeBytes ? $63c47e8a587a7f36$var$LruParams.withCacheSize(this.cacheSizeBytes) : $63c47e8a587a7f36$var$LruParams.DEFAULT;
        return new $63c47e8a587a7f36$var$__PRIVATE_IndexedDbPersistence(this.synchronizeTabs, t, e.clientId, n, e.asyncQueue, $63c47e8a587a7f36$var$__PRIVATE_getWindow(), $63c47e8a587a7f36$var$getDocument(), this.serializer, this.sharedClientState, !!this.forceOwnership);
    }
    Du(e) {
        return new $63c47e8a587a7f36$var$__PRIVATE_MemorySharedClientState;
    }
}
/**
 * Provides all components needed for Firestore with multi-tab IndexedDB
 * persistence.
 *
 * In the legacy client, this provider is used to provide both multi-tab and
 * non-multi-tab persistence since we cannot tell at build time whether
 * `synchronizeTabs` will be enabled.
 */ class $63c47e8a587a7f36$export$493d36ec626b6698 extends $63c47e8a587a7f36$export$6554612db691658e {
    constructor(e, t){
        super(e, t, /* forceOwnership= */ !1), this.xu = e, this.cacheSizeBytes = t, this.synchronizeTabs = !0;
    }
    async initialize(e) {
        await super.initialize(e);
        const t = this.xu.syncEngine;
        this.sharedClientState instanceof $63c47e8a587a7f36$var$__PRIVATE_WebStorageSharedClientState && (this.sharedClientState.syncEngine = {
            So: $63c47e8a587a7f36$var$__PRIVATE_syncEngineApplyBatchState.bind(null, t),
            Do: $63c47e8a587a7f36$var$__PRIVATE_syncEngineApplyTargetState.bind(null, t),
            Co: $63c47e8a587a7f36$var$__PRIVATE_syncEngineApplyActiveTargetsChange.bind(null, t),
            hs: $63c47e8a587a7f36$var$__PRIVATE_syncEngineGetActiveClients.bind(null, t),
            bo: $63c47e8a587a7f36$var$__PRIVATE_syncEngineSynchronizeWithChangedDocuments.bind(null, t)
        }, await this.sharedClientState.start()), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.zi(async (e)=>{
            await $63c47e8a587a7f36$var$__PRIVATE_syncEngineApplyPrimaryState(this.xu.syncEngine, e), this.gcScheduler && (e && !this.gcScheduler.started ? this.gcScheduler.start() : e || this.gcScheduler.stop()), this.indexBackfillerScheduler && (e && !this.indexBackfillerScheduler.started ? this.indexBackfillerScheduler.start() : e || this.indexBackfillerScheduler.stop());
        });
    }
    Du(e) {
        const t = $63c47e8a587a7f36$var$__PRIVATE_getWindow();
        if (!$63c47e8a587a7f36$var$__PRIVATE_WebStorageSharedClientState.v(t)) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
        const n = $63c47e8a587a7f36$var$__PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey);
        return new $63c47e8a587a7f36$var$__PRIVATE_WebStorageSharedClientState(t, e.asyncQueue, n, e.clientId, e.initialUser);
    }
}
/**
 * Initializes and wires the components that are needed to interface with the
 * network.
 */ class $63c47e8a587a7f36$export$2f6ca3d3b1f80bf5 {
    async initialize(e, t) {
        this.localStore || (this.localStore = e.localStore, this.sharedClientState = e.sharedClientState, this.datastore = this.createDatastore(t), this.remoteStore = this.createRemoteStore(t), this.eventManager = this.createEventManager(t), this.syncEngine = this.createSyncEngine(t, /* startAsPrimary=*/ !e.synchronizeTabs), this.sharedClientState.onlineStateHandler = (e)=>$63c47e8a587a7f36$var$__PRIVATE_syncEngineApplyOnlineStateChange(this.syncEngine, e, 1 /* OnlineStateSource.SharedClientState */ ), this.remoteStore.remoteSyncer.handleCredentialChange = $63c47e8a587a7f36$var$__PRIVATE_syncEngineHandleCredentialChange.bind(null, this.syncEngine), await $63c47e8a587a7f36$var$__PRIVATE_remoteStoreApplyPrimaryState(this.remoteStore, this.syncEngine.isPrimaryClient));
    }
    createEventManager(e) {
        return function __PRIVATE_newEventManager() {
            return new $63c47e8a587a7f36$var$__PRIVATE_EventManagerImpl;
        }();
    }
    createDatastore(e) {
        const t = $63c47e8a587a7f36$export$b4171a6734a65d42(e.databaseInfo.databaseId), n = $63c47e8a587a7f36$var$__PRIVATE_newConnection(e.databaseInfo);
        return $63c47e8a587a7f36$var$__PRIVATE_newDatastore(e.authCredentials, e.appCheckCredentials, n, t);
    }
    createRemoteStore(e) {
        return function __PRIVATE_newRemoteStore(e, t, n, r, i) {
            return new $63c47e8a587a7f36$var$__PRIVATE_RemoteStoreImpl(e, t, n, r, i);
        }(this.localStore, this.datastore, e.asyncQueue, (e)=>$63c47e8a587a7f36$var$__PRIVATE_syncEngineApplyOnlineStateChange(this.syncEngine, e, 0 /* OnlineStateSource.RemoteStore */ ), function __PRIVATE_newConnectivityMonitor() {
            return $63c47e8a587a7f36$var$__PRIVATE_BrowserConnectivityMonitor.v() ? new $63c47e8a587a7f36$var$__PRIVATE_BrowserConnectivityMonitor : new $63c47e8a587a7f36$var$__PRIVATE_NoopConnectivityMonitor;
        }());
    }
    createSyncEngine(e, t) {
        return function __PRIVATE_newSyncEngine(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
        r, i, s, o) {
            const _ = new $63c47e8a587a7f36$var$__PRIVATE_SyncEngineImpl(e, t, n, r, i, s);
            return o && (_.gu = !0), _;
        }(this.localStore, this.remoteStore, this.eventManager, this.sharedClientState, e.initialUser, e.maxConcurrentLimboResolutions, t);
    }
    async terminate() {
        await async function __PRIVATE_remoteStoreShutdown(e) {
            const t = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
            $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Ht, "RemoteStore shutting down."), t.Ea.add(5 /* OfflineCause.Shutdown */ ), await $63c47e8a587a7f36$var$__PRIVATE_disableNetworkInternal(t), t.Aa.shutdown(), // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
            // triggering spurious listener events with cached data, etc.
            t.Va.set("Unknown" /* OnlineState.Unknown */ );
        }(this.remoteStore), this.datastore?.terminate(), this.eventManager?.terminate();
    }
}
$63c47e8a587a7f36$export$2f6ca3d3b1f80bf5.provider = {
    build: ()=>new $63c47e8a587a7f36$export$2f6ca3d3b1f80bf5
};
/**
 * Builds a `ByteStreamReader` from a UInt8Array.
 * @param source - The data source to use.
 * @param bytesPerRead - How many bytes each `read()` from the returned reader
 *        will read.
 */ function $63c47e8a587a7f36$var$__PRIVATE_toByteStreamReaderHelper(e, t = 10240) {
    let n = 0;
    // The TypeScript definition for ReadableStreamReader changed. We use
    // `any` here to allow this code to compile with different versions.
    // See https://github.com/microsoft/TypeScript/issues/42970
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        async read () {
            if (n < e.byteLength) {
                const r = {
                    value: e.slice(n, n + t),
                    done: !1
                };
                return n += t, r;
            }
            return {
                done: !0
            };
        },
        async cancel () {},
        releaseLock () {},
        closed: Promise.resolve()
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * On web, a `ReadableStream` is wrapped around by a `ByteStreamReader`.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */ class $63c47e8a587a7f36$var$__PRIVATE_AsyncObserver {
    constructor(e){
        this.observer = e, /**
         * When set to true, will not raise future events. Necessary to deal with
         * async detachment of listener.
         */ this.muted = !1;
    }
    next(e) {
        this.muted || this.observer.next && this.Ou(this.observer.next, e);
    }
    error(e) {
        this.muted || (this.observer.error ? this.Ou(this.observer.error, e) : $63c47e8a587a7f36$var$__PRIVATE_logError("Uncaught Error in snapshot listener:", e.toString()));
    }
    Nu() {
        this.muted = !0;
    }
    Ou(e, t) {
        setTimeout(()=>{
            this.muted || e(t);
        }, 0);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class representing a bundle.
 *
 * Takes a bundle stream or buffer, and presents abstractions to read bundled
 * elements out of the underlying content.
 */ class $63c47e8a587a7f36$var$__PRIVATE_BundleReaderImpl {
    constructor(/** The reader to read from underlying binary bundle data source. */ e, t){
        this.Bu = e, this.serializer = t, /** Cached bundle metadata. */ this.metadata = new $63c47e8a587a7f36$var$__PRIVATE_Deferred, /**
         * Internal buffer to hold bundle content, accumulating incomplete element
         * content.
         */ this.buffer = new Uint8Array, this.Lu = function __PRIVATE_newTextDecoder() {
            return new TextDecoder("utf-8");
        }(), // Read the metadata (which is the first element).
        this.ku().then((e)=>{
            e && e.Ua() ? this.metadata.resolve(e.qa.metadata) : this.metadata.reject(new Error(`The first element of the bundle is not a metadata, it is\n             ${JSON.stringify(e?.qa)}`));
        }, (e)=>this.metadata.reject(e));
    }
    close() {
        return this.Bu.cancel();
    }
    async getMetadata() {
        return this.metadata.promise;
    }
    async Su() {
        // Makes sure metadata is read before proceeding.
        return await this.getMetadata(), this.ku();
    }
    /**
     * Reads from the head of internal buffer, and pulling more data from
     * underlying stream if a complete element cannot be found, until an
     * element(including the prefixed length and the JSON string) is found.
     *
     * Once a complete element is read, it is dropped from internal buffer.
     *
     * Returns either the bundled element, or null if we have reached the end of
     * the stream.
     */ async ku() {
        const e = await this.Ku();
        if (null === e) return null;
        const t = this.Lu.decode(e), n = Number(t);
        isNaN(n) && this.qu(`length string (${t}) is not valid number`);
        const r = await this.Uu(n);
        return new $63c47e8a587a7f36$var$__PRIVATE_SizedBundleElement(JSON.parse(r), e.length + n);
    }
    /** First index of '{' from the underlying buffer. */ $u() {
        return this.buffer.findIndex((e)=>e === "{".charCodeAt(0));
    }
    /**
     * Reads from the beginning of the internal buffer, until the first '{', and
     * return the content.
     *
     * If reached end of the stream, returns a null.
     */ async Ku() {
        for(; this.$u() < 0;){
            if (await this.Wu()) break;
        }
        // Broke out of the loop because underlying stream is closed, and there
        // happens to be no more data to process.
        if (0 === this.buffer.length) return null;
        const e = this.$u();
        // Broke out of the loop because underlying stream is closed, but still
        // cannot find an open bracket.
        e < 0 && this.qu("Reached the end of bundle when a length string is expected.");
        const t = this.buffer.slice(0, e);
        // Update the internal buffer to drop the read length.
        return this.buffer = this.buffer.slice(e), t;
    }
    /**
     * Reads from a specified position from the internal buffer, for a specified
     * number of bytes, pulling more data from the underlying stream if needed.
     *
     * Returns a string decoded from the read bytes.
     */ async Uu(e) {
        for(; this.buffer.length < e;)await this.Wu() && this.qu("Reached the end of bundle when more is expected.");
        const t = this.Lu.decode(this.buffer.slice(0, e));
        // Update the internal buffer to drop the read json string.
        return this.buffer = this.buffer.slice(e), t;
    }
    qu(e) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        throw this.Bu.cancel(), new Error(`Invalid bundle format: ${e}`);
    }
    /**
     * Pulls more data from underlying stream to internal buffer.
     * Returns a boolean indicating whether the stream is finished.
     */ async Wu() {
        const e = await this.Bu.read();
        if (!e.done) {
            const t = new Uint8Array(this.buffer.length + e.value.length);
            t.set(this.buffer), t.set(e.value, this.buffer.length), this.buffer = t;
        }
        return e.done;
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class that can parse a bundle form the string serialization of a bundle.
 */ class $63c47e8a587a7f36$var$__PRIVATE_BundleReaderSyncImpl {
    constructor(e, t){
        this.bundleData = e, this.serializer = t, this.cursor = 0, this.elements = [];
        let n = this.Su();
        if (!n || !n.Ua()) throw new Error(`The first element of the bundle is not a metadata object, it is\n         ${JSON.stringify(n?.qa)}`);
        this.metadata = n;
        do n = this.Su(), null !== n && this.elements.push(n);
        while (null !== n);
    }
    /* Returns the parsed metadata of the bundle. */ getMetadata() {
        return this.metadata;
    }
    /* Returns the DocumentSnapshot or NamedQuery elements of the bundle. */ Qu() {
        return this.elements;
    }
    /**
     * Parses the next element of the bundle.
     *
     * @returns a SizedBundleElement representation of the next element in the bundle, or null if
     * no more elements exist.
     */ Su() {
        if (this.cursor === this.bundleData.length) return null;
        const e = this.Ku(), t = this.Uu(e);
        return new $63c47e8a587a7f36$var$__PRIVATE_SizedBundleElement(JSON.parse(t), e);
    }
    /**
     * Reads from a specified position from the bundleData string, for a specified
     * number of bytes.
     *
     * @param length - how many characters to read.
     * @returns a string parsed from the bundle.
     */ Uu(e) {
        if (this.cursor + e > this.bundleData.length) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INTERNAL, "Reached the end of bundle when more is expected.");
        return this.bundleData.slice(this.cursor, this.cursor += e);
    }
    /**
     * Reads from the current cursor until the first '{'.
     *
     * @returns  A string to integer represention of the parsed value.
     * @throws An {@link Error} if the cursor has reached the end of the stream, since lengths
     * prefix bundle objects.
     */ Ku() {
        const e = this.cursor;
        let t = this.cursor;
        for(; t < this.bundleData.length;){
            if ("{" === this.bundleData[t]) {
                if (t === e) throw new Error("First character is a bracket and not a number");
                return this.cursor = t, Number(this.bundleData.slice(e, t));
            }
            t++;
        }
        throw new Error("Reached the end of bundle when more is expected.");
    }
}
/**
 *  Creates an instance of BundleReader without exposing the BundleReaderSyncImpl class type.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */ class $63c47e8a587a7f36$var$Transaction {
    constructor(e){
        this.datastore = e, // The version of each document that was read during this transaction.
        this.readVersions = new Map, this.mutations = [], this.committed = !1, /**
         * A deferred usage error that occurred previously in this transaction that
         * will cause the transaction to fail once it actually commits.
         */ this.lastTransactionError = null, /**
         * Set of documents that have been written in the transaction.
         *
         * When there's more than one write to the same key in a transaction, any
         * writes after the first are handled differently.
         */ this.writtenDocs = new Set;
    }
    async lookup(e) {
        if (this.ensureCommitNotCalled(), this.mutations.length > 0) throw this.lastTransactionError = new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, "Firestore transactions require all reads to be executed before all writes."), this.lastTransactionError;
        const t = await async function __PRIVATE_invokeBatchGetDocumentsRpc(e, t) {
            const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e), r = {
                documents: t.map((e)=>$63c47e8a587a7f36$var$__PRIVATE_toName(n.serializer, e))
            }, i = await n.jo("BatchGetDocuments", n.serializer.databaseId, $63c47e8a587a7f36$export$db202ddc8be9136.emptyPath(), r, t.length), s = new Map;
            i.forEach((e)=>{
                const t = $63c47e8a587a7f36$var$__PRIVATE_fromBatchGetDocumentsResponse(n.serializer, e);
                s.set(t.key.toString(), t);
            });
            const o = [];
            return t.forEach((e)=>{
                const t = s.get(e.toString());
                $63c47e8a587a7f36$export$c18d01048907ea92(!!t, 55234, {
                    key: e
                }), o.push(t);
            }), o;
        }(this.datastore, e);
        return t.forEach((e)=>this.recordVersion(e)), t;
    }
    set(e, t) {
        this.write(t.toMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
    }
    update(e, t) {
        try {
            this.write(t.toMutation(e, this.preconditionForUpdate(e)));
        } catch (e) {
            this.lastTransactionError = e;
        }
        this.writtenDocs.add(e.toString());
    }
    delete(e) {
        this.write(new $63c47e8a587a7f36$export$34aec0b863436764(e, this.precondition(e))), this.writtenDocs.add(e.toString());
    }
    async commit() {
        if (this.ensureCommitNotCalled(), this.lastTransactionError) throw this.lastTransactionError;
        const e = this.readVersions;
        // For each mutation, note that the doc was written.
        this.mutations.forEach((t)=>{
            e.delete(t.key.toString());
        }), // For each document that was read but not written to, we want to perform
        // a `verify` operation.
        e.forEach((e, t)=>{
            const n = $63c47e8a587a7f36$export$90a7f3efeed30595.fromPath(t);
            this.mutations.push(new $63c47e8a587a7f36$var$__PRIVATE_VerifyMutation(n, this.precondition(n)));
        }), await async function __PRIVATE_invokeCommitRpc(e, t) {
            const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e), r = {
                writes: t.map((e)=>$63c47e8a587a7f36$var$toMutation(n.serializer, e))
            };
            await n.Wo("Commit", n.serializer.databaseId, $63c47e8a587a7f36$export$db202ddc8be9136.emptyPath(), r);
        }(this.datastore, this.mutations), this.committed = !0;
    }
    recordVersion(e) {
        let t;
        if (e.isFoundDocument()) t = e.version;
        else {
            if (!e.isNoDocument()) throw $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(50498, {
                Gu: e.constructor.name
            });
            // Represent a deleted doc using SnapshotVersion.min().
            t = $63c47e8a587a7f36$var$SnapshotVersion.min();
        }
        const n = this.readVersions.get(e.key.toString());
        if (n) {
            if (!t.isEqual(n)) // This transaction will fail no matter what.
            throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.ABORTED, "Document version changed between two reads.");
        } else this.readVersions.set(e.key.toString(), t);
    }
    /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */ precondition(e) {
        const t = this.readVersions.get(e.toString());
        return !this.writtenDocs.has(e.toString()) && t ? t.isEqual($63c47e8a587a7f36$var$SnapshotVersion.min()) ? $63c47e8a587a7f36$export$78acf4525d8a74c4.exists(!1) : $63c47e8a587a7f36$export$78acf4525d8a74c4.updateTime(t) : $63c47e8a587a7f36$export$78acf4525d8a74c4.none();
    }
    /**
     * Returns the precondition for a document if the operation is an update.
     */ preconditionForUpdate(e) {
        const t = this.readVersions.get(e.toString());
        // The first time a document is written, we want to take into account the
        // read time and existence
        if (!this.writtenDocs.has(e.toString()) && t) {
            if (t.isEqual($63c47e8a587a7f36$var$SnapshotVersion.min())) // The document doesn't exist, so fail the transaction.
            // This has to be validated locally because you can't send a
            // precondition that a document does not exist without changing the
            // semantics of the backend write to be an insert. This is the reverse
            // of what we want, since we want to assert that the document doesn't
            // exist but then send the update and have it fail. Since we can't
            // express that to the backend, we have to validate locally.
            // Note: this can change once we can send separate verify writes in the
            // transaction.
            throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
            // Document exists, base precondition on document update time.
            return $63c47e8a587a7f36$export$78acf4525d8a74c4.updateTime(t);
        }
        // Document was not read, so we just use the preconditions for a blind
        // update.
        return $63c47e8a587a7f36$export$78acf4525d8a74c4.exists(!0);
    }
    write(e) {
        this.ensureCommitNotCalled(), this.mutations.push(e);
    }
    ensureCommitNotCalled() {}
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * TransactionRunner encapsulates the logic needed to run and retry transactions
 * with backoff.
 */ class $63c47e8a587a7f36$var$__PRIVATE_TransactionRunner {
    constructor(e, t, n, r, i){
        this.asyncQueue = e, this.datastore = t, this.options = n, this.updateFunction = r, this.deferred = i, this.zu = n.maxAttempts, this.M_ = new $63c47e8a587a7f36$var$__PRIVATE_ExponentialBackoff(this.asyncQueue, "transaction_retry" /* TimerId.TransactionRetry */ );
    }
    /** Runs the transaction and sets the result on deferred. */ ju() {
        this.zu -= 1, this.Hu();
    }
    Hu() {
        this.M_.p_(async ()=>{
            const e = new $63c47e8a587a7f36$var$Transaction(this.datastore), t = this.Ju(e);
            t && t.then((t)=>{
                this.asyncQueue.enqueueAndForget(()=>e.commit().then(()=>{
                        this.deferred.resolve(t);
                    }).catch((e)=>{
                        this.Zu(e);
                    }));
            }).catch((e)=>{
                this.Zu(e);
            });
        });
    }
    Ju(e) {
        try {
            const t = this.updateFunction(e);
            return !$63c47e8a587a7f36$var$__PRIVATE_isNullOrUndefined(t) && t.catch && t.then ? t : (this.deferred.reject(Error("Transaction callback must return a Promise")), null);
        } catch (e) {
            // Do not retry errors thrown by user provided updateFunction.
            return this.deferred.reject(e), null;
        }
    }
    Zu(e) {
        this.zu > 0 && this.Xu(e) ? (this.zu -= 1, this.asyncQueue.enqueueAndForget(()=>(this.Hu(), Promise.resolve()))) : this.deferred.reject(e);
    }
    Xu(e) {
        if ("FirebaseError" === e?.name) {
            // In transactions, the backend will fail outdated reads with FAILED_PRECONDITION and
            // non-matching document versions with ABORTED. These errors should be retried.
            const t = e.code;
            return "aborted" === t || "failed-precondition" === t || "already-exists" === t || !$63c47e8a587a7f36$var$__PRIVATE_isPermanentError(t);
        }
        return !1;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $63c47e8a587a7f36$var$Yt = "FirestoreClient";
/**
 * FirestoreClient is a top-level class that constructs and owns all of the //
 * pieces of the client SDK architecture. It is responsible for creating the //
 * async queue that is shared by all of the other components in the system. //
 */ class $63c47e8a587a7f36$var$FirestoreClient {
    constructor(e, t, /**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */ n, /**
     * Exposed for testing
     */ r, i){
        this.authCredentials = e, this.appCheckCredentials = t, this.asyncQueue = n, this._databaseInfo = r, this.user = $63c47e8a587a7f36$var$User.UNAUTHENTICATED, this.clientId = $63c47e8a587a7f36$export$a07804094c3ecf2d.newId(), this.authCredentialListener = ()=>Promise.resolve(), this.appCheckCredentialListener = ()=>Promise.resolve(), this._uninitializedComponentsProvider = i, this.authCredentials.start(n, async (e)=>{
            $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Yt, "Received user=", e.uid), await this.authCredentialListener(e), this.user = e;
        }), this.appCheckCredentials.start(n, (e)=>($63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Yt, "Received new app check token=", e), this.appCheckCredentialListener(e, this.user)));
    }
    get configuration() {
        return {
            asyncQueue: this.asyncQueue,
            databaseInfo: this._databaseInfo,
            clientId: this.clientId,
            authCredentials: this.authCredentials,
            appCheckCredentials: this.appCheckCredentials,
            initialUser: this.user,
            maxConcurrentLimboResolutions: 100
        };
    }
    setCredentialChangeListener(e) {
        this.authCredentialListener = e;
    }
    setAppCheckTokenChangeListener(e) {
        this.appCheckCredentialListener = e;
    }
    terminate() {
        this.asyncQueue.enterRestrictedMode();
        const e = new $63c47e8a587a7f36$var$__PRIVATE_Deferred;
        return this.asyncQueue.enqueueAndForgetEvenWhileRestricted(async ()=>{
            try {
                this._onlineComponents && await this._onlineComponents.terminate(), this._offlineComponents && await this._offlineComponents.terminate(), // The credentials provider must be terminated after shutting down the
                // RemoteStore as it will prevent the RemoteStore from retrieving auth
                // tokens.
                this.authCredentials.shutdown(), this.appCheckCredentials.shutdown(), e.resolve();
            } catch (t) {
                const n = $63c47e8a587a7f36$var$__PRIVATE_wrapInUserErrorIfRecoverable(t, "Failed to shutdown persistence");
                e.reject(n);
            }
        }), e.promise;
    }
}
async function $63c47e8a587a7f36$var$__PRIVATE_setOfflineComponentProvider(e, t) {
    e.asyncQueue.verifyOperationInProgress(), $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Yt, "Initializing OfflineComponentProvider");
    const n = e.configuration;
    await t.initialize(n);
    let r = n.initialUser;
    e.setCredentialChangeListener(async (e)=>{
        r.isEqual(e) || (await $63c47e8a587a7f36$var$__PRIVATE_localStoreHandleUserChange(t.localStore, e), r = e);
    }), // When a user calls clearPersistence() in one client, all other clients
    // need to be terminated to allow the delete to succeed.
    t.persistence.setDatabaseDeletedListener(()=>e.terminate()), e._offlineComponents = t;
}
async function $63c47e8a587a7f36$var$__PRIVATE_setOnlineComponentProvider(e, t) {
    e.asyncQueue.verifyOperationInProgress();
    const n = await $63c47e8a587a7f36$var$__PRIVATE_ensureOfflineComponents(e);
    $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Yt, "Initializing OnlineComponentProvider"), await t.initialize(n, e.configuration), // The CredentialChangeListener of the online component provider takes
    // precedence over the offline component provider.
    e.setCredentialChangeListener((e)=>$63c47e8a587a7f36$var$__PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, e)), e.setAppCheckTokenChangeListener((e, n)=>$63c47e8a587a7f36$var$__PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, n)), e._onlineComponents = t;
}
/**
 * Decides whether the provided error allows us to gracefully disable
 * persistence (as opposed to crashing the client).
 */ async function $63c47e8a587a7f36$var$__PRIVATE_ensureOfflineComponents(e) {
    if (!e._offlineComponents) {
        if (e._uninitializedComponentsProvider) {
            $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Yt, "Using user provided OfflineComponentProvider");
            try {
                await $63c47e8a587a7f36$var$__PRIVATE_setOfflineComponentProvider(e, e._uninitializedComponentsProvider._offline);
            } catch (t) {
                const n = t;
                if (!function __PRIVATE_canFallbackFromIndexedDbError(e) {
                    return "FirebaseError" === e.name ? e.code === $63c47e8a587a7f36$export$e7094788287c5e9b.FAILED_PRECONDITION || e.code === $63c47e8a587a7f36$export$e7094788287c5e9b.UNIMPLEMENTED : !("undefined" != typeof DOMException && e instanceof DOMException) || // When the browser is out of quota we could get either quota exceeded
                    // or an aborted error depending on whether the error happened during
                    // schema migration.
                    22 === e.code || 20 === e.code || // Firefox Private Browsing mode disables IndexedDb and returns
                    // INVALID_STATE for any usage.
                    11 === e.code;
                }(n)) throw n;
                $63c47e8a587a7f36$export$4c3d22f3d993c33f("Error using user provided cache. Falling back to memory cache: " + n), await $63c47e8a587a7f36$var$__PRIVATE_setOfflineComponentProvider(e, new $63c47e8a587a7f36$export$d24c54395ce0c509);
            }
        } else $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Yt, "Using default OfflineComponentProvider"), await $63c47e8a587a7f36$var$__PRIVATE_setOfflineComponentProvider(e, new $63c47e8a587a7f36$export$8a5498727ef6be21(void 0));
    }
    return e._offlineComponents;
}
async function $63c47e8a587a7f36$var$__PRIVATE_ensureOnlineComponents(e) {
    return e._onlineComponents || (e._uninitializedComponentsProvider ? ($63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Yt, "Using user provided OnlineComponentProvider"), await $63c47e8a587a7f36$var$__PRIVATE_setOnlineComponentProvider(e, e._uninitializedComponentsProvider._online)) : ($63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$Yt, "Using default OnlineComponentProvider"), await $63c47e8a587a7f36$var$__PRIVATE_setOnlineComponentProvider(e, new $63c47e8a587a7f36$export$2f6ca3d3b1f80bf5))), e._onlineComponents;
}
function $63c47e8a587a7f36$var$__PRIVATE_getPersistence(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_ensureOfflineComponents(e).then((e)=>e.persistence);
}
function $63c47e8a587a7f36$var$__PRIVATE_getLocalStore(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_ensureOfflineComponents(e).then((e)=>e.localStore);
}
function $63c47e8a587a7f36$var$__PRIVATE_getRemoteStore(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.remoteStore);
}
function $63c47e8a587a7f36$var$__PRIVATE_getSyncEngine(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.syncEngine);
}
function $63c47e8a587a7f36$var$__PRIVATE_getDatastore$1(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.datastore);
}
async function $63c47e8a587a7f36$var$__PRIVATE_getEventManager(e) {
    const t = await $63c47e8a587a7f36$var$__PRIVATE_ensureOnlineComponents(e), n = t.eventManager;
    return n.onListen = $63c47e8a587a7f36$var$__PRIVATE_syncEngineListen.bind(null, t.syncEngine), n.onUnlisten = $63c47e8a587a7f36$var$__PRIVATE_syncEngineUnlisten.bind(null, t.syncEngine), n.onFirstRemoteStoreListen = $63c47e8a587a7f36$var$__PRIVATE_triggerRemoteStoreListen.bind(null, t.syncEngine), n.onLastRemoteStoreUnlisten = $63c47e8a587a7f36$var$__PRIVATE_triggerRemoteStoreUnlisten.bind(null, t.syncEngine), n;
}
/** Enables the network connection and re-enqueues all pending operations. */ function $63c47e8a587a7f36$var$__PRIVATE_firestoreClientEnableNetwork(e) {
    return e.asyncQueue.enqueue(async ()=>{
        const t = await $63c47e8a587a7f36$var$__PRIVATE_getPersistence(e), n = await $63c47e8a587a7f36$var$__PRIVATE_getRemoteStore(e);
        return t.setNetworkEnabled(!0), function __PRIVATE_remoteStoreEnableNetwork(e) {
            const t = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
            return t.Ea.delete(0 /* OfflineCause.UserDisabled */ ), $63c47e8a587a7f36$var$__PRIVATE_enableNetworkInternal(t);
        }(n);
    });
}
/** Disables the network connection. Pending operations will not complete. */ function $63c47e8a587a7f36$var$__PRIVATE_firestoreClientDisableNetwork(e) {
    return e.asyncQueue.enqueue(async ()=>{
        const t = await $63c47e8a587a7f36$var$__PRIVATE_getPersistence(e), n = await $63c47e8a587a7f36$var$__PRIVATE_getRemoteStore(e);
        return t.setNetworkEnabled(!1), async function __PRIVATE_remoteStoreDisableNetwork(e) {
            const t = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
            t.Ea.add(0 /* OfflineCause.UserDisabled */ ), await $63c47e8a587a7f36$var$__PRIVATE_disableNetworkInternal(t), // Set the OnlineState to Offline so get()s return from cache, etc.
            t.Va.set("Offline" /* OnlineState.Offline */ );
        }(n);
    });
}
/**
 * Returns a Promise that resolves when all writes that were pending at the time
 * this method was called received server acknowledgement. An acknowledgement
 * can be either acceptance or rejection.
 */ function $63c47e8a587a7f36$export$c3950d9923825c02(e, t, n, r) {
    const i = new $63c47e8a587a7f36$var$__PRIVATE_AsyncObserver(r), s = new $63c47e8a587a7f36$var$__PRIVATE_QueryListener(t, i, n);
    return e.asyncQueue.enqueueAndForget(async ()=>$63c47e8a587a7f36$var$__PRIVATE_eventManagerListen(await $63c47e8a587a7f36$var$__PRIVATE_getEventManager(e), s)), ()=>{
        i.Nu(), e.asyncQueue.enqueueAndForget(async ()=>$63c47e8a587a7f36$var$__PRIVATE_eventManagerUnlisten(await $63c47e8a587a7f36$var$__PRIVATE_getEventManager(e), s));
    };
}
function $63c47e8a587a7f36$export$6559d589eb85fbb6(e, t) {
    const n = new $63c47e8a587a7f36$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(async function __PRIVATE_readDocumentFromCache(e, t, n) {
            try {
                const r = await function __PRIVATE_localStoreReadDocument(e, t) {
                    const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
                    return n.persistence.runTransaction("read document", "readonly", (e)=>n.localDocuments.getDocument(e, t));
                }(e, t);
                r.isFoundDocument() ? n.resolve(r) : r.isNoDocument() ? n.resolve(null) : n.reject(new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.UNAVAILABLE, "Failed to get document from cache. (However, this document may exist on the server. Run again without setting 'source' in the GetOptions to attempt to retrieve the document from the server.)"));
            } catch (e) {
                const r = $63c47e8a587a7f36$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Failed to get document '${t} from cache`);
                n.reject(r);
            }
        })(await $63c47e8a587a7f36$var$__PRIVATE_getLocalStore(e), t, n)), n.promise;
}
function $63c47e8a587a7f36$export$ce26c07117d59d6a(e, t, n = {}) {
    const r = new $63c47e8a587a7f36$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_readDocumentViaSnapshotListener(e, t, n, r, i) {
            const s = new $63c47e8a587a7f36$var$__PRIVATE_AsyncObserver({
                next: (_)=>{
                    // Mute and remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    s.Nu(), t.enqueueAndForget(()=>$63c47e8a587a7f36$var$__PRIVATE_eventManagerUnlisten(e, o));
                    const a = _.docs.has(n);
                    !a && _.fromCache ? // TODO(dimond): If we're online and the document doesn't
                    // exist then we resolve with a doc.exists set to false. If
                    // we're offline however, we reject the Promise in this
                    // case. Two options: 1) Cache the negative response from
                    // the server so we can deliver that even when you're
                    // offline 2) Actually reject the Promise in the online case
                    // if the document doesn't exist.
                    i.reject(new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.UNAVAILABLE, "Failed to get document because the client is offline.")) : a && _.fromCache && r && "server" === r.source ? i.reject(new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : i.resolve(_);
                },
                error: (e)=>i.reject(e)
            }), o = new $63c47e8a587a7f36$var$__PRIVATE_QueryListener($63c47e8a587a7f36$export$a93c5207d687da10(n.path), s, {
                includeMetadataChanges: !0,
                Ka: !0
            });
            return $63c47e8a587a7f36$var$__PRIVATE_eventManagerListen(e, o);
        })(await $63c47e8a587a7f36$var$__PRIVATE_getEventManager(e), e.asyncQueue, t, n, r)), r.promise;
}
function $63c47e8a587a7f36$export$a8550f7dbe79f93a(e, t) {
    const n = new $63c47e8a587a7f36$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(async function __PRIVATE_executeQueryFromCache(e, t, n) {
            try {
                const r = await $63c47e8a587a7f36$var$__PRIVATE_localStoreExecuteQuery(e, t, /* usePreviousResults= */ !0), i = new $63c47e8a587a7f36$var$__PRIVATE_View(t, r.ks), s = i.ru(r.documents), o = i.applyChanges(s, /* limboResolutionEnabled= */ !1);
                n.resolve(o.snapshot);
            } catch (e) {
                const r = $63c47e8a587a7f36$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Failed to execute query '${t} against cache`);
                n.reject(r);
            }
        })(await $63c47e8a587a7f36$var$__PRIVATE_getLocalStore(e), t, n)), n.promise;
}
function $63c47e8a587a7f36$export$efca4cbe5dd06740(e, t, n = {}) {
    const r = new $63c47e8a587a7f36$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_executeQueryViaSnapshotListener(e, t, n, r, i) {
            const s = new $63c47e8a587a7f36$var$__PRIVATE_AsyncObserver({
                next: (n)=>{
                    // Mute and remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    s.Nu(), t.enqueueAndForget(()=>$63c47e8a587a7f36$var$__PRIVATE_eventManagerUnlisten(e, o)), n.fromCache && "server" === r.source ? i.reject(new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : i.resolve(n);
                },
                error: (e)=>i.reject(e)
            }), o = new $63c47e8a587a7f36$var$__PRIVATE_QueryListener(n, s, {
                includeMetadataChanges: !0,
                Ka: !0
            });
            return $63c47e8a587a7f36$var$__PRIVATE_eventManagerListen(e, o);
        })(await $63c47e8a587a7f36$var$__PRIVATE_getEventManager(e), e.asyncQueue, t, n, r)), r.promise;
}
function $63c47e8a587a7f36$export$2329c99376c9d0a4(e, t, n) {
    const r = new $63c47e8a587a7f36$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>{
        // Implement and call executeAggregateQueryViaSnapshotListener, similar
        // to the implementation in firestoreClientGetDocumentsViaSnapshotListener
        // above
        try {
            // TODO(b/277628384): check `canUseNetwork()` and handle multi-tab.
            const i = await $63c47e8a587a7f36$var$__PRIVATE_getDatastore$1(e);
            r.resolve(async function __PRIVATE_invokeRunAggregationQueryRpc(e, t, n) {
                const r = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e), { request: i, gt: s, parent: o } = $63c47e8a587a7f36$var$__PRIVATE_toRunAggregationQueryRequest(r.serializer, $63c47e8a587a7f36$var$__PRIVATE_queryToAggregateTarget(t), n);
                r.connection.Ko || delete i.parent;
                const _ = (await r.jo("RunAggregationQuery", r.serializer.databaseId, o, i, /*expectedResponseCount=*/ 1)).filter((e)=>!!e.result);
                // Omit RunAggregationQueryResponse that only contain readTimes.
                $63c47e8a587a7f36$export$c18d01048907ea92(1 === _.length, 64727);
                // Remap the short-form aliases that were sent to the server
                // to the client-side aliases. Users will access the results
                // using the client-side alias.
                const a = _[0].result?.aggregateFields;
                return Object.keys(a).reduce((e, t)=>(e[s[t]] = a[t], e), {});
            }(i, t, n));
        } catch (e) {
            r.reject(e);
        }
    }), r.promise;
}
function $63c47e8a587a7f36$export$d22783b3c2400a3a(e, t) {
    const n = new $63c47e8a587a7f36$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>{
        try {
            const r = await $63c47e8a587a7f36$var$__PRIVATE_getDatastore$1(e);
            n.resolve(async function __PRIVATE_invokeExecutePipeline(e, t) {
                const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e), r = {
                    database: $63c47e8a587a7f36$var$__PRIVATE_getEncodedDatabaseId(n.serializer),
                    structuredPipeline: t._toProto(n.serializer)
                }, i = await n.jo("ExecutePipeline", n.serializer.databaseId, $63c47e8a587a7f36$export$db202ddc8be9136.emptyPath(), r), s = [];
                return i.forEach((e)=>{
                    if (e.results && 0 !== e.results.length) return e.results.forEach((t)=>s.push($63c47e8a587a7f36$var$__PRIVATE_fromPipelineResponse(n.serializer, e, t)));
                    s.push($63c47e8a587a7f36$var$__PRIVATE_fromPipelineResponse(n.serializer, e));
                }), s;
            }(r, t));
        } catch (e) {
            n.reject(e);
        }
    }), n.promise;
}
function $63c47e8a587a7f36$export$2219238a014317b0(e, t) {
    const n = new $63c47e8a587a7f36$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>$63c47e8a587a7f36$var$__PRIVATE_syncEngineWrite(await $63c47e8a587a7f36$var$__PRIVATE_getSyncEngine(e), t, n)), n.promise;
}
function $63c47e8a587a7f36$export$555508cbc6add439(e, t) {
    const n = new $63c47e8a587a7f36$var$__PRIVATE_AsyncObserver(t);
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_addSnapshotsInSyncListener(e, t) {
            $63c47e8a587a7f36$var$__PRIVATE_debugCast(e).Ca.add(t), // Immediately fire an initial event, indicating all existing listeners
            // are in-sync.
            t.next();
        })(await $63c47e8a587a7f36$var$__PRIVATE_getEventManager(e), n)), ()=>{
        n.Nu(), e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_removeSnapshotsInSyncListener(e, t) {
                $63c47e8a587a7f36$var$__PRIVATE_debugCast(e).Ca.delete(t);
            })(await $63c47e8a587a7f36$var$__PRIVATE_getEventManager(e), n));
    };
}
/**
 * Takes an updateFunction in which a set of reads and writes can be performed
 * atomically. In the updateFunction, the client can read and write values
 * using the supplied transaction object. After the updateFunction, all
 * changes will be committed. If a retryable error occurs (ex: some other
 * client has changed any of the data referenced), then the updateFunction
 * will be called again after a backoff. If the updateFunction still fails
 * after all retries, then the transaction will be rejected.
 *
 * The transaction object passed to the updateFunction contains methods for
 * accessing documents and collections. Unlike other datastore access, data
 * accessed with the transaction will not reflect local changes that have not
 * been committed. For this reason, it is required that all reads are
 * performed before any writes. Transactions must be performed while online.
 */ function $63c47e8a587a7f36$export$3c2fa207a37baaea(e, t, n) {
    const r = new $63c47e8a587a7f36$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>{
        const i = await $63c47e8a587a7f36$var$__PRIVATE_getDatastore$1(e);
        new $63c47e8a587a7f36$var$__PRIVATE_TransactionRunner(e.asyncQueue, i, n, t, r).ju();
    }), r.promise;
}
function $63c47e8a587a7f36$var$__PRIVATE_firestoreClientLoadBundle(e, t, n, r) {
    const i = function __PRIVATE_createBundleReader(e, t) {
        let n;
        n = "string" == typeof e ? $63c47e8a587a7f36$var$__PRIVATE_newTextEncoder().encode(e) : e;
        return function __PRIVATE_newBundleReader(e, t) {
            return new $63c47e8a587a7f36$var$__PRIVATE_BundleReaderImpl(e, t);
        }(function __PRIVATE_toByteStreamReader(e, t) {
            if (e instanceof Uint8Array) return $63c47e8a587a7f36$var$__PRIVATE_toByteStreamReaderHelper(e, t);
            if (e instanceof ArrayBuffer) return $63c47e8a587a7f36$var$__PRIVATE_toByteStreamReaderHelper(new Uint8Array(e), t);
            if (e instanceof ReadableStream) return e.getReader();
            throw new Error("Source of `toByteStreamReader` has to be a ArrayBuffer or ReadableStream");
        }(n), t);
    }(n, $63c47e8a587a7f36$export$b4171a6734a65d42(t));
    e.asyncQueue.enqueueAndForget(async ()=>{
        $63c47e8a587a7f36$var$__PRIVATE_syncEngineLoadBundle(await $63c47e8a587a7f36$var$__PRIVATE_getSyncEngine(e), i, r);
    });
}
function $63c47e8a587a7f36$var$__PRIVATE_firestoreClientGetNamedQuery(e, t) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreGetNamedQuery(e, t) {
            const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e);
            return n.persistence.runTransaction("Get named query", "readonly", (e)=>n.Pi.getNamedQuery(e, t));
        })(await $63c47e8a587a7f36$var$__PRIVATE_getLocalStore(e), t));
}
function $63c47e8a587a7f36$export$3466f893ebf79586(e, t) {
    return function __PRIVATE_newBundleReaderSync(e, t) {
        return new $63c47e8a587a7f36$var$__PRIVATE_BundleReaderSyncImpl(e, t);
    }(e, t);
}
function $63c47e8a587a7f36$export$f38c853ae54ed474(e, t) {
    return e.asyncQueue.enqueue(async ()=>(async function __PRIVATE_localStoreConfigureFieldIndexes(e, t) {
            const n = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e), r = n.indexManager, i = [];
            return n.persistence.runTransaction("Configure indexes", "readwrite", (e)=>r.getFieldIndexes(e).next((n)=>/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two array for equality using comparator. The method computes the
 * intersection and invokes `onAdd` for every element that is in `after` but not
 * `before`. `onRemove` is invoked for every element in `before` but missing
 * from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original array.
 * @param after - The elements to diff against the original array.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ (function __PRIVATE_diffArrays(e, t, n, r, i) {
                        e = [
                            ...e
                        ], t = [
                            ...t
                        ], e.sort(n), t.sort(n);
                        const s = e.length, o = t.length;
                        let _ = 0, a = 0;
                        for(; _ < o && a < s;){
                            const s = n(e[a], t[_]);
                            s < 0 ? // The element was removed if the next element in our ordered
                            // walkthrough is only in `before`.
                            i(e[a++]) : s > 0 ? // The element was added if the next element in our ordered walkthrough
                            // is only in `after`.
                            r(t[_++]) : (_++, a++);
                        }
                        for(; _ < o;)r(t[_++]);
                        for(; a < s;)i(e[a++]);
                    })(n, t, $63c47e8a587a7f36$var$__PRIVATE_fieldIndexSemanticComparator, (t)=>{
                        i.push(r.addFieldIndex(e, t));
                    }, (t)=>{
                        i.push(r.deleteFieldIndex(e, t));
                    })).next(()=>$63c47e8a587a7f36$var$PersistencePromise.waitFor(i)));
        })(await $63c47e8a587a7f36$var$__PRIVATE_getLocalStore(e), t));
}
function $63c47e8a587a7f36$export$ab83b03e4111b1d0(e, t) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreSetIndexAutoCreationEnabled(e, t) {
            $63c47e8a587a7f36$var$__PRIVATE_debugCast(e).Cs.As = t;
        })(await $63c47e8a587a7f36$var$__PRIVATE_getLocalStore(e), t));
}
function $63c47e8a587a7f36$export$3b513254972cfc9c(e) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreDeleteAllFieldIndexes(e) {
            const t = $63c47e8a587a7f36$var$__PRIVATE_debugCast(e), n = t.indexManager;
            return t.persistence.runTransaction("Delete All Indexes", "readwrite", (e)=>n.deleteAllFieldIndexes(e));
        })(await $63c47e8a587a7f36$var$__PRIVATE_getLocalStore(e)));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two `ExperimentalLongPollingOptions` objects for equality.
 */ /**
 * Creates and returns a new `ExperimentalLongPollingOptions` with the same
 * option values as the given instance.
 */ function $63c47e8a587a7f36$var$__PRIVATE_cloneLongPollingOptions(e) {
    const t = {};
    return void 0 !== e.timeoutSeconds && (t.timeoutSeconds = e.timeoutSeconds), t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $63c47e8a587a7f36$var$en = "ComponentProvider", $63c47e8a587a7f36$var$tn = new Map;
/**
 * An instance map that ensures only one Datastore exists per Firestore
 * instance.
 */ function $63c47e8a587a7f36$var$__PRIVATE_makeDatabaseInfo(e, t, n, r, i) {
    return new $63c47e8a587a7f36$var$DatabaseInfo(e, t, n, i.host, i.ssl, i.experimentalForceLongPolling, i.experimentalAutoDetectLongPolling, $63c47e8a587a7f36$var$__PRIVATE_cloneLongPollingOptions(i.experimentalLongPollingOptions), i.useFetchStreams, i.isUsingEmulator, r);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // settings() defaults:
const $63c47e8a587a7f36$var$nn = "firestore.googleapis.com", $63c47e8a587a7f36$var$rn = !0;
/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied `FirestoreSettings` object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */ class $63c47e8a587a7f36$var$FirestoreSettingsImpl {
    constructor(e){
        if (void 0 === e.host) {
            if (void 0 !== e.ssl) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            this.host = $63c47e8a587a7f36$var$nn, this.ssl = $63c47e8a587a7f36$var$rn;
        } else this.host = e.host, this.ssl = e.ssl ?? $63c47e8a587a7f36$var$rn;
        if (this.isUsingEmulator = void 0 !== e.emulatorOptions, this.credentials = e.credentials, this.ignoreUndefinedProperties = !!e.ignoreUndefinedProperties, this.localCache = e.localCache, void 0 === e.cacheSizeBytes) this.cacheSizeBytes = $63c47e8a587a7f36$var$Dt;
        else {
            if (-1 !== e.cacheSizeBytes && e.cacheSizeBytes < $63c47e8a587a7f36$var$vt) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
            this.cacheSizeBytes = e.cacheSizeBytes;
        }
        $63c47e8a587a7f36$export$23ebac1979863676("experimentalForceLongPolling", e.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", e.experimentalAutoDetectLongPolling), this.experimentalForceLongPolling = !!e.experimentalForceLongPolling, this.experimentalForceLongPolling ? this.experimentalAutoDetectLongPolling = !1 : void 0 === e.experimentalAutoDetectLongPolling ? this.experimentalAutoDetectLongPolling = true : // For backwards compatibility, coerce the value to boolean even though
        // the TypeScript compiler has narrowed the type to boolean already.
        // noinspection PointlessBooleanExpressionJS
        this.experimentalAutoDetectLongPolling = !!e.experimentalAutoDetectLongPolling, this.experimentalLongPollingOptions = $63c47e8a587a7f36$var$__PRIVATE_cloneLongPollingOptions(e.experimentalLongPollingOptions ?? {}), function __PRIVATE_validateLongPollingOptions(e) {
            if (void 0 !== e.timeoutSeconds) {
                if (isNaN(e.timeoutSeconds)) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (must not be NaN)`);
                if (e.timeoutSeconds < 5) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (minimum allowed value is 5)`);
                if (e.timeoutSeconds > 30) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (maximum allowed value is 30)`);
            }
        }(this.experimentalLongPollingOptions), this.useFetchStreams = !!e.useFetchStreams;
    }
    isEqual(e) {
        return this.host === e.host && this.ssl === e.ssl && this.credentials === e.credentials && this.cacheSizeBytes === e.cacheSizeBytes && this.experimentalForceLongPolling === e.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === e.experimentalAutoDetectLongPolling && function __PRIVATE_longPollingOptionsEqual(e, t) {
            return e.timeoutSeconds === t.timeoutSeconds;
        }(this.experimentalLongPollingOptions, e.experimentalLongPollingOptions) && this.ignoreUndefinedProperties === e.ignoreUndefinedProperties && this.useFetchStreams === e.useFetchStreams;
    }
}
class $63c47e8a587a7f36$var$Firestore$1 {
    /** @hideconstructor */ constructor(e, t, n, r){
        this._authCredentials = e, this._appCheckCredentials = t, this._databaseId = n, this._app = r, /**
         * Whether it's a Firestore or Firestore Lite instance.
         */ this.type = "firestore-lite", this._persistenceKey = "(lite)", this._settings = new $63c47e8a587a7f36$var$FirestoreSettingsImpl({}), this._settingsFrozen = !1, this._emulatorOptions = {}, // A task that is assigned when the terminate() is invoked and resolved when
        // all components have shut down. Otherwise, Firestore is not terminated,
        // which can mean either the FirestoreClient is in the process of starting,
        // or restarting.
        this._terminateTask = "notTerminated";
    }
    /**
     * The {@link @firebase/app#FirebaseApp} associated with this `Firestore` service
     * instance.
     */ get app() {
        if (!this._app) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
        return this._app;
    }
    get _initialized() {
        return this._settingsFrozen;
    }
    get _terminated() {
        return "notTerminated" !== this._terminateTask;
    }
    _setSettings(e) {
        if (this._settingsFrozen) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
        this._settings = new $63c47e8a587a7f36$var$FirestoreSettingsImpl(e), this._emulatorOptions = e.emulatorOptions || {}, void 0 !== e.credentials && (this._authCredentials = function __PRIVATE_makeAuthCredentialsProvider(e) {
            if (!e) return new $63c47e8a587a7f36$export$158acd800e1ef08b;
            switch(e.type){
                case "firstParty":
                    return new $63c47e8a587a7f36$var$__PRIVATE_FirstPartyAuthCredentialsProvider(e.sessionIndex || "0", e.iamToken || null, e.authTokenFactory || null);
                case "provider":
                    return e.client;
                default:
                    throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, "makeAuthCredentialsProvider failed due to invalid credential type");
            }
        }(e.credentials));
    }
    _getSettings() {
        return this._settings;
    }
    _getEmulatorOptions() {
        return this._emulatorOptions;
    }
    _freezeSettings() {
        return this._settingsFrozen = !0, this._settings;
    }
    _delete() {
        // The `_terminateTask` must be assigned future that completes when
        // terminate is complete. The existence of this future puts SDK in state
        // that will not accept further API interaction.
        return "notTerminated" === this._terminateTask && (this._terminateTask = this._terminate()), this._terminateTask;
    }
    async _restart() {
        // The `_terminateTask` must equal 'notTerminated' after restart to
        // signal that client is in a state that accepts API calls.
        "notTerminated" === this._terminateTask ? await this._terminate() : this._terminateTask = "notTerminated";
    }
    /** Returns a JSON-serializable representation of this `Firestore` instance. */ toJSON() {
        return {
            app: this._app,
            databaseId: this._databaseId,
            settings: this._settings
        };
    }
    /**
     * Terminates all components used by this client. Subclasses can override
     * this method to clean up their own dependencies, but must also call this
     * method.
     *
     * Only ever called once.
     */ _terminate() {
        /**
 * Removes all components associated with the provided instance. Must be called
 * when the `Firestore` instance is terminated.
 */ return function __PRIVATE_removeComponents(e) {
            const t = $63c47e8a587a7f36$var$tn.get(e);
            t && ($63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$en, "Removing Datastore"), $63c47e8a587a7f36$var$tn.delete(e), t.terminate());
        }(this), Promise.resolve();
    }
}
/**
 * Modify this instance to communicate with the Cloud Firestore emulator.
 *
 * Note: This must be called before this instance has been used to do any
 * operations.
 *
 * @param firestore - The `Firestore` instance to configure to connect to the
 * emulator.
 * @param host - the emulator host (ex: localhost).
 * @param port - the emulator port (ex: 9000).
 * @param options.mockUserToken - the mock auth token to use for unit testing
 * Security Rules.
 */ function $63c47e8a587a7f36$export$f96d196f7728bb5(e, t, n, r = {}) {
    e = $63c47e8a587a7f36$export$4a5767248b18ef41(e, $63c47e8a587a7f36$var$Firestore$1);
    const i = (0, $3117f6f4eeb4c314$export$5b4d24b45140ad90)(t), s = e._getSettings(), o = {
        ...s,
        emulatorOptions: e._getEmulatorOptions()
    }, _ = `${t}:${n}`;
    i && ((0, $3117f6f4eeb4c314$export$c0f0d0ce4283a937)(`https://${_}`), (0, $3117f6f4eeb4c314$export$fd3d2954543183b1)("Firestore", !0)), s.host !== $63c47e8a587a7f36$var$nn && s.host !== _ && $63c47e8a587a7f36$export$4c3d22f3d993c33f("Host has been set in both settings() and connectFirestoreEmulator(), emulator host will be used.");
    const a = {
        ...s,
        host: _,
        ssl: i,
        emulatorOptions: r
    };
    // No-op if the new configuration matches the current configuration. This supports SSR
    // enviornments which might call `connectFirestoreEmulator` multiple times as a standard practice.
    if (!(0, $3117f6f4eeb4c314$export$9cb4719e2e525b7a)(a, o) && (e._setSettings(a), r.mockUserToken)) {
        let t, n;
        if ("string" == typeof r.mockUserToken) t = r.mockUserToken, n = $63c47e8a587a7f36$var$User.MOCK_USER;
        else {
            // Let createMockUserToken validate first (catches common mistakes like
            // invalid field "uid" and missing field "sub" / "user_id".)
            t = (0, $3117f6f4eeb4c314$export$367bf224123348f1)(r.mockUserToken, e._app?.options.projectId);
            const i = r.mockUserToken.sub || r.mockUserToken.user_id;
            if (!i) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, "mockUserToken must contain 'sub' or 'user_id' field!");
            n = new $63c47e8a587a7f36$var$User(i);
        }
        e._authCredentials = new $63c47e8a587a7f36$var$__PRIVATE_EmulatorAuthCredentialsProvider(new $63c47e8a587a7f36$var$__PRIVATE_OAuthToken(t, n));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `Query` refers to a query which you can read or listen to. You can also
 * construct refined `Query` objects by adding filters and ordering.
 */ class $63c47e8a587a7f36$export$3722cfe417b6ed86 {
    // This is the lite version of the Query class in the main SDK.
    /** @hideconstructor protected */ constructor(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n){
        this.converter = t, this._query = n, /** The type of this Firestore reference. */ this.type = "query", this.firestore = e;
    }
    withConverter(e) {
        return new $63c47e8a587a7f36$export$3722cfe417b6ed86(this.firestore, e, this._query);
    }
}
/**
 * A `DocumentReference` refers to a document location in a Firestore database
 * and can be used to write, read, or listen to the location. The document at
 * the referenced location may or may not exist.
 */ class $63c47e8a587a7f36$export$96f57966bedc81b4 {
    /** @hideconstructor */ constructor(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n){
        this.converter = t, this._key = n, /** The type of this Firestore reference. */ this.type = "document", this.firestore = e;
    }
    get _path() {
        return this._key.path;
    }
    /**
     * The document's identifier within its collection.
     */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced document (relative
     * to the root of the database).
     */ get path() {
        return this._key.path.canonicalString();
    }
    /**
     * The collection this `DocumentReference` belongs to.
     */ get parent() {
        return new $63c47e8a587a7f36$export$d66dc83d8cfc8dd(this.firestore, this.converter, this._key.path.popLast());
    }
    withConverter(e) {
        return new $63c47e8a587a7f36$export$96f57966bedc81b4(this.firestore, e, this._key);
    }
    /**
     * Returns a JSON-serializable representation of this `DocumentReference` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            type: $63c47e8a587a7f36$export$96f57966bedc81b4._jsonSchemaVersion,
            referencePath: this._key.toString()
        };
    }
    static fromJSON(e, t, n) {
        if ($63c47e8a587a7f36$export$9bb611d729802a56(t, $63c47e8a587a7f36$export$96f57966bedc81b4._jsonSchema)) return new $63c47e8a587a7f36$export$96f57966bedc81b4(e, n || null, new $63c47e8a587a7f36$export$90a7f3efeed30595($63c47e8a587a7f36$export$db202ddc8be9136.fromString(t.referencePath)));
    }
}
$63c47e8a587a7f36$export$96f57966bedc81b4._jsonSchemaVersion = "firestore/documentReference/1.0", $63c47e8a587a7f36$export$96f57966bedc81b4._jsonSchema = {
    type: $63c47e8a587a7f36$export$ffb5f4729a158638("string", $63c47e8a587a7f36$export$96f57966bedc81b4._jsonSchemaVersion),
    referencePath: $63c47e8a587a7f36$export$ffb5f4729a158638("string")
};
/**
 * A `CollectionReference` object can be used for adding documents, getting
 * document references, and querying for documents (using {@link (query:1)}).
 */ class $63c47e8a587a7f36$export$d66dc83d8cfc8dd extends $63c47e8a587a7f36$export$3722cfe417b6ed86 {
    /** @hideconstructor */ constructor(e, t, n){
        super(e, t, $63c47e8a587a7f36$export$a93c5207d687da10(n)), this._path = n, /** The type of this Firestore reference. */ this.type = "collection";
    }
    /** The collection's identifier. */ get id() {
        return this._query.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced collection (relative
     * to the root of the database).
     */ get path() {
        return this._query.path.canonicalString();
    }
    /**
     * A reference to the containing `DocumentReference` if this is a
     * subcollection. If this isn't a subcollection, the reference is null.
     */ get parent() {
        const e = this._path.popLast();
        return e.isEmpty() ? null : new $63c47e8a587a7f36$export$96f57966bedc81b4(this.firestore, /* converter= */ null, new $63c47e8a587a7f36$export$90a7f3efeed30595(e));
    }
    withConverter(e) {
        return new $63c47e8a587a7f36$export$d66dc83d8cfc8dd(this.firestore, e, this._path);
    }
}
function $63c47e8a587a7f36$export$4ae495d48253603d(e) {
    return e instanceof $63c47e8a587a7f36$export$d66dc83d8cfc8dd;
}
function $63c47e8a587a7f36$export$c03999cb2f36933f(e, t, ...n) {
    if (e = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(e), $63c47e8a587a7f36$var$__PRIVATE_validateNonEmptyArgument("collection", "path", t), e instanceof $63c47e8a587a7f36$var$Firestore$1) {
        const r = $63c47e8a587a7f36$export$db202ddc8be9136.fromString(t, ...n);
        return $63c47e8a587a7f36$var$__PRIVATE_validateCollectionPath(r), new $63c47e8a587a7f36$export$d66dc83d8cfc8dd(e, /* converter= */ null, r);
    }
    {
        if (!(e instanceof $63c47e8a587a7f36$export$96f57966bedc81b4 || e instanceof $63c47e8a587a7f36$export$d66dc83d8cfc8dd)) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const r = e._path.child($63c47e8a587a7f36$export$db202ddc8be9136.fromString(t, ...n));
        return $63c47e8a587a7f36$var$__PRIVATE_validateCollectionPath(r), new $63c47e8a587a7f36$export$d66dc83d8cfc8dd(e.firestore, /* converter= */ null, r);
    }
}
// TODO(firestorelite): Consider using ErrorFactory -
// https://github.com/firebase/firebase-js-sdk/blob/0131e1f/packages/util/src/errors.ts#L106
/**
 * Creates and returns a new `Query` instance that includes all documents in the
 * database that are contained in a collection or subcollection with the
 * given `collectionId`.
 *
 * @param firestore - A reference to the root `Firestore` instance.
 * @param collectionId - Identifies the collections to query over. Every
 * collection or subcollection with this ID as the last segment of its path
 * will be included. Cannot contain a slash.
 * @returns The created `Query`.
 */ function $63c47e8a587a7f36$export$2ed0fc6709e59212(e, t) {
    if (e = $63c47e8a587a7f36$export$4a5767248b18ef41(e, $63c47e8a587a7f36$var$Firestore$1), $63c47e8a587a7f36$var$__PRIVATE_validateNonEmptyArgument("collectionGroup", "collection id", t), t.indexOf("/") >= 0) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, `Invalid collection ID '${t}' passed to function collectionGroup(). Collection IDs must not contain '/'.`);
    return new $63c47e8a587a7f36$export$3722cfe417b6ed86(e, /* converter= */ null, function __PRIVATE_newQueryForCollectionGroup(e) {
        return new $63c47e8a587a7f36$var$__PRIVATE_QueryImpl($63c47e8a587a7f36$export$db202ddc8be9136.emptyPath(), e);
    }(t));
}
function $63c47e8a587a7f36$export$2e2af4578d910ddf(e, t, ...n) {
    if (e = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(e), // We allow omission of 'pathString' but explicitly prohibit passing in both
    // 'undefined' and 'null'.
    1 === arguments.length && (t = $63c47e8a587a7f36$export$a07804094c3ecf2d.newId()), $63c47e8a587a7f36$var$__PRIVATE_validateNonEmptyArgument("doc", "path", t), e instanceof $63c47e8a587a7f36$var$Firestore$1) {
        const r = $63c47e8a587a7f36$export$db202ddc8be9136.fromString(t, ...n);
        return $63c47e8a587a7f36$var$__PRIVATE_validateDocumentPath(r), new $63c47e8a587a7f36$export$96f57966bedc81b4(e, /* converter= */ null, new $63c47e8a587a7f36$export$90a7f3efeed30595(r));
    }
    {
        if (!(e instanceof $63c47e8a587a7f36$export$96f57966bedc81b4 || e instanceof $63c47e8a587a7f36$export$d66dc83d8cfc8dd)) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, "Expected first argument to doc() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const r = e._path.child($63c47e8a587a7f36$export$db202ddc8be9136.fromString(t, ...n));
        return $63c47e8a587a7f36$var$__PRIVATE_validateDocumentPath(r), new $63c47e8a587a7f36$export$96f57966bedc81b4(e.firestore, e instanceof $63c47e8a587a7f36$export$d66dc83d8cfc8dd ? e.converter : null, new $63c47e8a587a7f36$export$90a7f3efeed30595(r));
    }
}
/**
 * Returns true if the provided references are equal.
 *
 * @param left - A reference to compare.
 * @param right - A reference to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $63c47e8a587a7f36$export$a17c37559e1db147(e, t) {
    return e = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(e), t = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(t), (e instanceof $63c47e8a587a7f36$export$96f57966bedc81b4 || e instanceof $63c47e8a587a7f36$export$d66dc83d8cfc8dd) && (t instanceof $63c47e8a587a7f36$export$96f57966bedc81b4 || t instanceof $63c47e8a587a7f36$export$d66dc83d8cfc8dd) && e.firestore === t.firestore && e.path === t.path && e.converter === t.converter;
}
/**
 * Returns true if the provided queries point to the same collection and apply
 * the same constraints.
 *
 * @param left - A `Query` to compare.
 * @param right - A `Query` to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $63c47e8a587a7f36$export$d141bba7fdc215a3(e, t) {
    return e = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(e), t = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(t), e instanceof $63c47e8a587a7f36$export$3722cfe417b6ed86 && t instanceof $63c47e8a587a7f36$export$3722cfe417b6ed86 && e.firestore === t.firestore && $63c47e8a587a7f36$var$__PRIVATE_queryEquals(e._query, t._query) && e.converter === t.converter;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $63c47e8a587a7f36$var$sn = "AsyncQueue";
class $63c47e8a587a7f36$var$__PRIVATE_AsyncQueueImpl {
    constructor(e = Promise.resolve()){
        // A list of retryable operations. Retryable operations are run in order and
        // retried with backoff.
        this.Yu = [], // Is this AsyncQueue being shut down? Once it is set to true, it will not
        // be changed again.
        this.ec = !1, // Operations scheduled to be queued in the future. Operations are
        // automatically removed after they are run or canceled.
        this.tc = [], // visible for testing
        this.nc = null, // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.rc = !1, // Enabled during shutdown on Safari to prevent future access to IndexedDB.
        this.sc = !1, // List of TimerIds to fast-forward delays for.
        this.oc = [], // Backoff timer used to schedule retries for retryable operations
        this.M_ = new $63c47e8a587a7f36$var$__PRIVATE_ExponentialBackoff(this, "async_queue_retry" /* TimerId.AsyncQueueRetry */ ), // Visibility handler that triggers an immediate retry of all retryable
        // operations. Meant to speed up recovery when we regain file system access
        // after page comes into foreground.
        this._c = ()=>{
            const e = $63c47e8a587a7f36$var$getDocument();
            e && $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$sn, "Visibility state changed to " + e.visibilityState), this.M_.w_();
        }, this.ac = e;
        const t = $63c47e8a587a7f36$var$getDocument();
        t && "function" == typeof t.addEventListener && t.addEventListener("visibilitychange", this._c);
    }
    get isShuttingDown() {
        return this.ec;
    }
    /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */ enqueueAndForget(e) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.enqueue(e);
    }
    enqueueAndForgetEvenWhileRestricted(e) {
        this.uc(), // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.cc(e);
    }
    enterRestrictedMode(e) {
        if (!this.ec) {
            this.ec = !0, this.sc = e || !1;
            const t = $63c47e8a587a7f36$var$getDocument();
            t && "function" == typeof t.removeEventListener && t.removeEventListener("visibilitychange", this._c);
        }
    }
    enqueue(e) {
        if (this.uc(), this.ec) // Return a Promise which never resolves.
        return new Promise(()=>{});
        // Create a deferred Promise that we can return to the callee. This
        // allows us to return a "hanging Promise" only to the callee and still
        // advance the queue even when the operation is not run.
        const t = new $63c47e8a587a7f36$var$__PRIVATE_Deferred;
        return this.cc(()=>this.ec && this.sc ? Promise.resolve() : (e().then(t.resolve, t.reject), t.promise)).then(()=>t.promise);
    }
    enqueueRetryable(e) {
        this.enqueueAndForget(()=>(this.Yu.push(e), this.lc()));
    }
    /**
     * Runs the next operation from the retryable queue. If the operation fails,
     * reschedules with backoff.
     */ async lc() {
        if (0 !== this.Yu.length) {
            try {
                await this.Yu[0](), this.Yu.shift(), this.M_.reset();
            } catch (e) {
                if (!$63c47e8a587a7f36$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
                // Failure will be handled by AsyncQueue
                $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$sn, "Operation failed with retryable error: " + e);
            }
            this.Yu.length > 0 && // If there are additional operations, we re-schedule `retryNextOp()`.
            // This is necessary to run retryable operations that failed during
            // their initial attempt since we don't know whether they are already
            // enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
            // needs to  be re-run, we will run `op1`, `op1`, `op2` using the
            // already enqueued calls to `retryNextOp()`. `op3()` will then run in the
            // call scheduled here.
            // Since `backoffAndRun()` cancels an existing backoff and schedules a
            // new backoff on every call, there is only ever a single additional
            // operation in the queue.
            this.M_.p_(()=>this.lc());
        }
    }
    cc(e) {
        const t = this.ac.then(()=>(this.rc = !0, e().catch((e)=>{
                this.nc = e, this.rc = !1;
                // Re-throw the error so that this.tail becomes a rejected Promise and
                // all further attempts to chain (via .then) will just short-circuit
                // and return the rejected Promise.
                throw $63c47e8a587a7f36$var$__PRIVATE_logError("INTERNAL UNHANDLED ERROR: ", $63c47e8a587a7f36$var$__PRIVATE_getMessageOrStack(e)), e;
            }).then((e)=>(this.rc = !1, e))));
        return this.ac = t, t;
    }
    enqueueAfterDelay(e, t, n) {
        this.uc(), // Fast-forward delays for timerIds that have been overridden.
        this.oc.indexOf(e) > -1 && (t = 0);
        const r = $63c47e8a587a7f36$var$DelayedOperation.createAndSchedule(this, e, t, n, (e)=>this.hc(e));
        return this.tc.push(r), r;
    }
    uc() {
        this.nc && $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(47125, {
            Pc: $63c47e8a587a7f36$var$__PRIVATE_getMessageOrStack(this.nc)
        });
    }
    verifyOperationInProgress() {}
    /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */ async Tc() {
        // Operations in the queue prior to draining may have enqueued additional
        // operations. Keep draining the queue until the tail is no longer advanced,
        // which indicates that no more new operations were enqueued and that all
        // operations were executed.
        let e;
        do e = this.ac, await e;
        while (e !== this.ac);
    }
    /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */ Ic(e) {
        for (const t of this.tc)if (t.timerId === e) return !0;
        return !1;
    }
    /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId - Delayed operations up to and including this TimerId
     * will be drained. Pass TimerId.All to run all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */ Ec(e) {
        // Note that draining may generate more delayed ops, so we do that first.
        return this.Tc().then(()=>{
            // Run ops in the same order they'd run if they ran naturally.
            /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ this.tc.sort((e, t)=>e.targetTimeMs - t.targetTimeMs);
            for (const t of this.tc)if (t.skipDelay(), "all" /* TimerId.All */  !== e && t.timerId === e) break;
            return this.Tc();
        });
    }
    /**
     * For Tests: Skip all subsequent delays for a timer id.
     */ Rc(e) {
        this.oc.push(e);
    }
    /** Called once a DelayedOperation is run or canceled. */ hc(e) {
        // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
        const t = this.tc.indexOf(e);
        /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ this.tc.splice(t, 1);
    }
}
/**
 * Chrome includes Error.message in Error.stack. Other browsers do not.
 * This returns expected output of message + stack when available.
 * @param error - Error or FirestoreError
 */ function $63c47e8a587a7f36$var$__PRIVATE_getMessageOrStack(e) {
    let t = e.message || "";
    return e.stack && (t = e.stack.includes(e.message) ? e.stack : e.message + "\n" + e.stack), t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the task of loading a Firestore bundle. It provides progress of bundle
 * loading, as well as task completion and error events.
 *
 * The API is compatible with `Promise<LoadBundleTaskProgress>`.
 */ class $63c47e8a587a7f36$export$28f7fcd39efa255 {
    constructor(){
        this._progressObserver = {}, this._taskCompletionResolver = new $63c47e8a587a7f36$var$__PRIVATE_Deferred, this._lastProgress = {
            taskState: "Running",
            totalBytes: 0,
            totalDocuments: 0,
            bytesLoaded: 0,
            documentsLoaded: 0
        };
    }
    /**
     * Registers functions to listen to bundle loading progress events.
     * @param next - Called when there is a progress update from bundle loading. Typically `next` calls occur
     *   each time a Firestore document is loaded from the bundle.
     * @param error - Called when an error occurs during bundle loading. The task aborts after reporting the
     *   error, and there should be no more updates after this.
     * @param complete - Called when the loading task is complete.
     */ onProgress(e, t, n) {
        this._progressObserver = {
            next: e,
            error: t,
            complete: n
        };
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.catch` interface.
     *
     * @param onRejected - Called when an error occurs during bundle loading.
     */ catch(e) {
        return this._taskCompletionResolver.promise.catch(e);
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.then` interface.
     *
     * @param onFulfilled - Called on the completion of the loading task with a final `LoadBundleTaskProgress` update.
     *   The update will always have its `taskState` set to `"Success"`.
     * @param onRejected - Called when an error occurs during bundle loading.
     */ then(e, t) {
        return this._taskCompletionResolver.promise.then(e, t);
    }
    /**
     * Notifies all observers that bundle loading has completed, with a provided
     * `LoadBundleTaskProgress` object.
     *
     * @private
     */ _completeWith(e) {
        this._updateProgress(e), this._progressObserver.complete && this._progressObserver.complete(), this._taskCompletionResolver.resolve(e);
    }
    /**
     * Notifies all observers that bundle loading has failed, with a provided
     * `Error` as the reason.
     *
     * @private
     */ _failWith(e) {
        this._lastProgress.taskState = "Error", this._progressObserver.next && this._progressObserver.next(this._lastProgress), this._progressObserver.error && this._progressObserver.error(e), this._taskCompletionResolver.reject(e);
    }
    /**
     * Notifies a progress update of loading a bundle.
     * @param progress - The new progress.
     *
     * @private
     */ _updateProgress(e) {
        this._lastProgress = e, this._progressObserver.next && this._progressObserver.next(e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Constant used to indicate the LRU garbage collection should be disabled.
 * Set this value as the `cacheSizeBytes` on the settings passed to the
 * {@link Firestore} instance.
 */ const $63c47e8a587a7f36$export$1fbe638ecf81657e = -1;
/**
 * The Cloud Firestore service interface.
 *
 * Do not call this constructor directly. Instead, use {@link (getFirestore:1)}.
 */ class $63c47e8a587a7f36$export$d66501df72047452 extends $63c47e8a587a7f36$var$Firestore$1 {
    /** @hideconstructor */ constructor(e, t, n, r){
        super(e, t, n, r), /**
         * Whether it's a {@link Firestore} or Firestore Lite instance.
         */ this.type = "firestore", this._queue = new $63c47e8a587a7f36$var$__PRIVATE_AsyncQueueImpl, this._persistenceKey = r?.name || "[DEFAULT]";
    }
    async _terminate() {
        if (this._firestoreClient) {
            const e = this._firestoreClient.terminate();
            this._queue = new $63c47e8a587a7f36$var$__PRIVATE_AsyncQueueImpl(e), this._firestoreClient = void 0, await e;
        }
    }
}
/**
 * Initializes a new instance of {@link Firestore} with the provided settings.
 * Can only be called before any other function, including
 * {@link (getFirestore:1)}. If the custom settings are empty, this function is
 * equivalent to calling {@link (getFirestore:1)}.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} with which the {@link Firestore} instance will
 * be associated.
 * @param settings - A settings object to configure the {@link Firestore} instance.
 * @param databaseId - The name of the database.
 * @returns A newly initialized {@link Firestore} instance.
 */ function $63c47e8a587a7f36$export$527e9aa3390079e9(e, t, n) {
    n || (n = $63c47e8a587a7f36$var$st);
    const r = (0, $0c1331d0a001f5bc$export$fa0d6da0f5838f50)(e, "firestore");
    if (r.isInitialized(n)) {
        const e = r.getImmediate({
            identifier: n
        }), i = r.getOptions(n);
        if ((0, $3117f6f4eeb4c314$export$9cb4719e2e525b7a)(i, t)) return e;
        throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.FAILED_PRECONDITION, "initializeFirestore() has already been called with different options. To avoid this error, call initializeFirestore() with the same options as when it was originally called, or call getFirestore() to return the already initialized instance.");
    }
    if (void 0 !== t.cacheSizeBytes && void 0 !== t.localCache) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, "cache and cacheSizeBytes cannot be specified at the same time as cacheSizeBytes willbe deprecated. Instead, specify the cache size in the cache object");
    if (void 0 !== t.cacheSizeBytes && -1 !== t.cacheSizeBytes && t.cacheSizeBytes < $63c47e8a587a7f36$var$vt) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
    // Workaround to get cookies in Firebase Studio
    return t.host && (0, $3117f6f4eeb4c314$export$5b4d24b45140ad90)(t.host) && (0, $3117f6f4eeb4c314$export$c0f0d0ce4283a937)(t.host), r.initialize({
        options: t,
        instanceIdentifier: n
    });
}
function $63c47e8a587a7f36$export$1a8f5705751d8277(e, n) {
    const r = "object" == typeof e ? e : (0, $0c1331d0a001f5bc$export$f9962582c9e66d99)(), i = "string" == typeof e ? e : n || $63c47e8a587a7f36$var$st, s = (0, $0c1331d0a001f5bc$export$fa0d6da0f5838f50)(r, "firestore").getImmediate({
        identifier: i
    });
    if (!s._initialized) {
        const e = (0, $3117f6f4eeb4c314$export$a3febcf1f14a3a0c)("firestore");
        e && $63c47e8a587a7f36$export$f96d196f7728bb5(s, ...e);
    }
    return s;
}
/**
 * @internal
 */ function $63c47e8a587a7f36$export$df995fae86a55f06(e) {
    if (e._terminated) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.FAILED_PRECONDITION, "The client has already been terminated.");
    return e._firestoreClient || $63c47e8a587a7f36$var$__PRIVATE_configureFirestore(e), e._firestoreClient;
}
function $63c47e8a587a7f36$var$__PRIVATE_configureFirestore(e) {
    const t = e._freezeSettings(), n = $63c47e8a587a7f36$var$__PRIVATE_makeDatabaseInfo(e._databaseId, e._app?.options.appId || "", e._persistenceKey, e._app?.options.apiKey, t);
    e._componentsProvider || t.localCache?._offlineComponentProvider && t.localCache?._onlineComponentProvider && (e._componentsProvider = {
        _offline: t.localCache._offlineComponentProvider,
        _online: t.localCache._onlineComponentProvider
    }), e._firestoreClient = new $63c47e8a587a7f36$var$FirestoreClient(e._authCredentials, e._appCheckCredentials, e._queue, n, e._componentsProvider && function __PRIVATE_buildComponentProvider(e) {
        const t = e?._online.build();
        return {
            _offline: e?._offline.build(t),
            _online: t
        };
    }(e._componentsProvider));
}
function $63c47e8a587a7f36$export$317a3d46287192d8(e, t) {
    $63c47e8a587a7f36$export$4c3d22f3d993c33f("enableIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const n = e._freezeSettings();
    return $63c47e8a587a7f36$var$__PRIVATE_setPersistenceProviders(e, $63c47e8a587a7f36$export$2f6ca3d3b1f80bf5.provider, {
        build: (e)=>new $63c47e8a587a7f36$export$6554612db691658e(e, n.cacheSizeBytes, t?.forceOwnership)
    }), Promise.resolve();
}
/**
 * Attempts to enable multi-tab persistent storage, if possible. If enabled
 * across all tabs, all operations share access to local persistence, including
 * shared execution of queries and latency-compensated local document updates
 * across all connected instances.
 *
 * On failure, `enableMultiTabIndexedDbPersistence()` will reject the promise or
 * throw an exception. There are several reasons why this can fail, which can be
 * identified by the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab and
 *     multi-tab is not enabled.
 *   * unimplemented: The browser is incompatible with the offline persistence
 *     implementation.
 *
 * Note that even after a failure, the {@link Firestore} instance will remain
 * usable, however offline persistence will be disabled.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @returns A `Promise` that represents successfully enabling persistent
 * storage.
 * @deprecated This function will be removed in a future major release. Instead, set
 * `FirestoreSettings.localCache` to an instance of `PersistentLocalCache` to
 * turn on indexeddb cache. Calling this function when `FirestoreSettings.localCache`
 * is already specified will throw an exception.
 */ async function $63c47e8a587a7f36$export$1ee57be6f6687d2c(e) {
    $63c47e8a587a7f36$export$4c3d22f3d993c33f("enableMultiTabIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const t = e._freezeSettings();
    $63c47e8a587a7f36$var$__PRIVATE_setPersistenceProviders(e, $63c47e8a587a7f36$export$2f6ca3d3b1f80bf5.provider, {
        build: (e)=>new $63c47e8a587a7f36$export$493d36ec626b6698(e, t.cacheSizeBytes)
    });
}
/**
 * Registers both the `OfflineComponentProvider` and `OnlineComponentProvider`.
 * If the operation fails with a recoverable error (see
 * `canRecoverFromIndexedDbError()` below), the returned Promise is rejected
 * but the client remains usable.
 */ function $63c47e8a587a7f36$var$__PRIVATE_setPersistenceProviders(e, t, n) {
    if ((e = $63c47e8a587a7f36$export$4a5767248b18ef41(e, $63c47e8a587a7f36$export$d66501df72047452))._firestoreClient || e._terminated) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.FAILED_PRECONDITION, "Firestore has already been started and persistence can no longer be enabled. You can only enable persistence before calling any other methods on a Firestore object.");
    if (e._componentsProvider || e._getSettings().localCache) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.FAILED_PRECONDITION, "SDK cache is already specified.");
    e._componentsProvider = {
        _online: t,
        _offline: n
    }, $63c47e8a587a7f36$var$__PRIVATE_configureFirestore(e);
}
/**
 * Clears the persistent storage. This includes pending writes and cached
 * documents.
 *
 * Must be called while the {@link Firestore} instance is not started (after the app is
 * terminated or when the app is first initialized). On startup, this function
 * must be called before other functions (other than {@link
 * initializeFirestore} or {@link (getFirestore:1)})). If the {@link Firestore}
 * instance is still running, the promise will be rejected with the error code
 * of `failed-precondition`.
 *
 * Note: `clearIndexedDbPersistence()` is primarily intended to help write
 * reliable tests that use Cloud Firestore. It uses an efficient mechanism for
 * dropping existing data but does not attempt to securely overwrite or
 * otherwise make cached data unrecoverable. For applications that are sensitive
 * to the disclosure of cached data in between user sessions, we strongly
 * recommend not enabling persistence at all.
 *
 * @param firestore - The {@link Firestore} instance to clear persistence for.
 * @returns A `Promise` that is resolved when the persistent storage is
 * cleared. Otherwise, the promise is rejected with an error.
 */ function $63c47e8a587a7f36$export$faec65b429be379(e) {
    if (e._initialized && !e._terminated) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.FAILED_PRECONDITION, "Persistence can only be cleared before a Firestore instance is initialized or after it is terminated.");
    const t = new $63c47e8a587a7f36$var$__PRIVATE_Deferred;
    return e._queue.enqueueAndForgetEvenWhileRestricted(async ()=>{
        try {
            await async function __PRIVATE_indexedDbClearPersistence(e) {
                if (!$63c47e8a587a7f36$var$__PRIVATE_SimpleDb.v()) return Promise.resolve();
                const t = e + $63c47e8a587a7f36$var$Nt;
                await $63c47e8a587a7f36$var$__PRIVATE_SimpleDb.delete(t);
            }($63c47e8a587a7f36$var$__PRIVATE_indexedDbStoragePrefix(e._databaseId, e._persistenceKey)), t.resolve();
        } catch (e) {
            t.reject(e);
        }
    }), t.promise;
}
/**
 * Waits until all currently pending writes for the active user have been
 * acknowledged by the backend.
 *
 * The returned promise resolves immediately if there are no outstanding writes.
 * Otherwise, the promise waits for all previously issued writes (including
 * those written in a previous app session), but it does not wait for writes
 * that were added after the function is called. If you want to wait for
 * additional writes, call `waitForPendingWrites()` again.
 *
 * Any outstanding `waitForPendingWrites()` promises are rejected during user
 * changes.
 *
 * @returns A `Promise` which resolves when all currently pending writes have been
 * acknowledged by the backend.
 */ function $63c47e8a587a7f36$export$53c86fa97d611818(e) {
    return function __PRIVATE_firestoreClientWaitForPendingWrites(e) {
        const t = new $63c47e8a587a7f36$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>$63c47e8a587a7f36$var$__PRIVATE_syncEngineRegisterPendingWritesCallback(await $63c47e8a587a7f36$var$__PRIVATE_getSyncEngine(e), t)), t.promise;
    }($63c47e8a587a7f36$export$df995fae86a55f06(e = $63c47e8a587a7f36$export$4a5767248b18ef41(e, $63c47e8a587a7f36$export$d66501df72047452)));
}
/**
 * Re-enables use of the network for this {@link Firestore} instance after a prior
 * call to {@link disableNetwork}.
 *
 * @returns A `Promise` that is resolved once the network has been enabled.
 */ function $63c47e8a587a7f36$export$9d0e2d13d04f7070(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_firestoreClientEnableNetwork($63c47e8a587a7f36$export$df995fae86a55f06(e = $63c47e8a587a7f36$export$4a5767248b18ef41(e, $63c47e8a587a7f36$export$d66501df72047452)));
}
/**
 * Disables network usage for this instance. It can be re-enabled via {@link
 * enableNetwork}. While the network is disabled, any snapshot listeners,
 * `getDoc()` or `getDocs()` calls will return results from cache, and any write
 * operations will be queued until the network is restored.
 *
 * @returns A `Promise` that is resolved once the network has been disabled.
 */ function $63c47e8a587a7f36$export$d377dcb2b61d6c4e(e) {
    return $63c47e8a587a7f36$var$__PRIVATE_firestoreClientDisableNetwork($63c47e8a587a7f36$export$df995fae86a55f06(e = $63c47e8a587a7f36$export$4a5767248b18ef41(e, $63c47e8a587a7f36$export$d66501df72047452)));
}
/**
 * Terminates the provided {@link Firestore} instance.
 *
 * After calling `terminate()` only the `clearIndexedDbPersistence()` function
 * may be used. Any other function will throw a `FirestoreError`.
 *
 * To restart after termination, create a new instance of FirebaseFirestore with
 * {@link (getFirestore:1)}.
 *
 * Termination does not cancel any pending writes, and any promises that are
 * awaiting a response from the server will not be resolved. If you have
 * persistence enabled, the next time you start this instance, it will resume
 * sending these writes to the server.
 *
 * Note: Under normal circumstances, calling `terminate()` is not required. This
 * function is useful only when you want to force this instance to release all
 * of its resources or in combination with `clearIndexedDbPersistence()` to
 * ensure that all local state is destroyed between test runs.
 *
 * @returns A `Promise` that is resolved when the instance has been successfully
 * terminated.
 */ function $63c47e8a587a7f36$export$d29e374196577086(e) {
    return (0, $0c1331d0a001f5bc$export$48d18de2ff1c45a5)(e.app, "firestore", e._databaseId.database), e._delete();
}
/**
 * Loads a Firestore bundle into the local cache.
 *
 * @param firestore - The {@link Firestore} instance to load bundles for.
 * @param bundleData - An object representing the bundle to be loaded. Valid
 * objects are `ArrayBuffer`, `ReadableStream<Uint8Array>` or `string`.
 *
 * @returns A `LoadBundleTask` object, which notifies callers with progress
 * updates, and completion or error events. It can be used as a
 * `Promise<LoadBundleTaskProgress>`.
 */ function $63c47e8a587a7f36$export$a9c996f45e5784d0(e, t) {
    const n = $63c47e8a587a7f36$export$df995fae86a55f06(e = $63c47e8a587a7f36$export$4a5767248b18ef41(e, $63c47e8a587a7f36$export$d66501df72047452)), r = new $63c47e8a587a7f36$export$28f7fcd39efa255;
    return $63c47e8a587a7f36$var$__PRIVATE_firestoreClientLoadBundle(n, e._databaseId, t, r), r;
}
/**
 * Reads a Firestore {@link Query} from local cache, identified by the given
 * name.
 *
 * The named queries are packaged  into bundles on the server side (along
 * with resulting documents), and loaded to local cache using `loadBundle`. Once
 * in local cache, use this method to extract a {@link Query} by name.
 *
 * @param firestore - The {@link Firestore} instance to read the query from.
 * @param name - The name of the query.
 * @returns A `Promise` that is resolved with the Query or `null`.
 */ function $63c47e8a587a7f36$export$7910e0436ed8d1de(e, t) {
    return $63c47e8a587a7f36$var$__PRIVATE_firestoreClientGetNamedQuery($63c47e8a587a7f36$export$df995fae86a55f06(e = $63c47e8a587a7f36$export$4a5767248b18ef41(e, $63c47e8a587a7f36$export$d66501df72047452)), t).then((t)=>t ? new $63c47e8a587a7f36$export$3722cfe417b6ed86(e, null, t.query) : null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing an array of bytes.
 */ class $63c47e8a587a7f36$export$ef35774e6d314e91 {
    /** @hideconstructor */ constructor(e){
        this._byteString = e;
    }
    /**
     * Creates a new `Bytes` object from the given Base64 string, converting it to
     * bytes.
     *
     * @param base64 - The Base64 string used to create the `Bytes` object.
     */ static fromBase64String(e) {
        try {
            return new $63c47e8a587a7f36$export$ef35774e6d314e91($63c47e8a587a7f36$export$9d398bebfec1c039.fromBase64String(e));
        } catch (e) {
            throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + e);
        }
    }
    /**
     * Creates a new `Bytes` object from the given Uint8Array.
     *
     * @param array - The Uint8Array used to create the `Bytes` object.
     */ static fromUint8Array(e) {
        return new $63c47e8a587a7f36$export$ef35774e6d314e91($63c47e8a587a7f36$export$9d398bebfec1c039.fromUint8Array(e));
    }
    /**
     * Returns the underlying bytes as a Base64-encoded string.
     *
     * @returns The Base64-encoded string created from the `Bytes` object.
     */ toBase64() {
        return this._byteString.toBase64();
    }
    /**
     * Returns the underlying bytes in a new `Uint8Array`.
     *
     * @returns The Uint8Array created from the `Bytes` object.
     */ toUint8Array() {
        return this._byteString.toUint8Array();
    }
    /**
     * Returns a string representation of the `Bytes` object.
     *
     * @returns A string representation of the `Bytes` object.
     */ toString() {
        return "Bytes(base64: " + this.toBase64() + ")";
    }
    /**
     * Returns true if this `Bytes` object is equal to the provided one.
     *
     * @param other - The `Bytes` object to compare against.
     * @returns true if this `Bytes` object is equal to the provided one.
     */ isEqual(e) {
        return this._byteString.isEqual(e._byteString);
    }
    /**
     * Returns a JSON-serializable representation of this `Bytes` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            type: $63c47e8a587a7f36$export$ef35774e6d314e91._jsonSchemaVersion,
            bytes: this.toBase64()
        };
    }
    /**
     * Builds a `Bytes` instance from a JSON object created by {@link Bytes.toJSON}.
     *
     * @param json - a JSON object represention of a `Bytes` instance
     * @returns an instance of {@link Bytes} if the JSON object could be parsed. Throws a
     * {@link FirestoreError} if an error occurs.
     */ static fromJSON(e) {
        if ($63c47e8a587a7f36$export$9bb611d729802a56(e, $63c47e8a587a7f36$export$ef35774e6d314e91._jsonSchema)) return $63c47e8a587a7f36$export$ef35774e6d314e91.fromBase64String(e.bytes);
    }
}
$63c47e8a587a7f36$export$ef35774e6d314e91._jsonSchemaVersion = "firestore/bytes/1.0", $63c47e8a587a7f36$export$ef35774e6d314e91._jsonSchema = {
    type: $63c47e8a587a7f36$export$ffb5f4729a158638("string", $63c47e8a587a7f36$export$ef35774e6d314e91._jsonSchemaVersion),
    bytes: $63c47e8a587a7f36$export$ffb5f4729a158638("string")
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `FieldPath` refers to a field in a document. The path may consist of a
 * single field name (referring to a top-level field in the document), or a
 * list of field names (referring to a nested field in the document).
 *
 * Create a `FieldPath` by providing field names. If more than one field
 * name is provided, the path will point to a nested field in a document.
 */ class $63c47e8a587a7f36$export$8743009a87fcb00f {
    /**
     * Creates a `FieldPath` from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames - A list of field names.
     */ constructor(...e){
        for(let t = 0; t < e.length; ++t)if (0 === e[t].length) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
        this._internalPath = new $63c47e8a587a7f36$export$cf2f7c5792f80b46(e);
    }
    /**
     * Returns true if this `FieldPath` is equal to the provided one.
     *
     * @param other - The `FieldPath` to compare against.
     * @returns true if this `FieldPath` is equal to the provided one.
     */ isEqual(e) {
        return this._internalPath.isEqual(e._internalPath);
    }
}
/**
 * Returns a special sentinel `FieldPath` to refer to the ID of a document.
 * It can be used in queries to sort or filter by the document ID.
 */ function $63c47e8a587a7f36$export$667d3bf0c5f83305() {
    return new $63c47e8a587a7f36$export$8743009a87fcb00f($63c47e8a587a7f36$export$7a0bdf7d4a91ea88);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sentinel values that can be used when writing document fields with `set()`
 * or `update()`.
 */ class $63c47e8a587a7f36$export$92108d983e8ee699 {
    /**
     * @param _methodName - The public API endpoint that returns this class.
     * @hideconstructor
     */ constructor(e){
        this._methodName = e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing a geographic location in Firestore. The
 * location is represented as latitude/longitude pair.
 *
 * Latitude values are in the range of [-90, 90].
 * Longitude values are in the range of [-180, 180].
 */ class $63c47e8a587a7f36$export$9fa96a7d116ea3ce {
    /**
     * Creates a new immutable `GeoPoint` object with the provided latitude and
     * longitude values.
     * @param latitude - The latitude as number between -90 and 90.
     * @param longitude - The longitude as number between -180 and 180.
     */ constructor(e, t){
        if (!isFinite(e) || e < -90 || e > 90) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + e);
        if (!isFinite(t) || t < -180 || t > 180) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + t);
        this._lat = e, this._long = t;
    }
    /**
     * The latitude of this `GeoPoint` instance.
     */ get latitude() {
        return this._lat;
    }
    /**
     * The longitude of this `GeoPoint` instance.
     */ get longitude() {
        return this._long;
    }
    /**
     * Returns true if this `GeoPoint` is equal to the provided one.
     *
     * @param other - The `GeoPoint` to compare against.
     * @returns true if this `GeoPoint` is equal to the provided one.
     */ isEqual(e) {
        return this._lat === e._lat && this._long === e._long;
    }
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */ _compareTo(e) {
        return $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(this._lat, e._lat) || $63c47e8a587a7f36$var$__PRIVATE_primitiveComparator(this._long, e._long);
    }
    /**
     * Returns a JSON-serializable representation of this `GeoPoint` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            latitude: this._lat,
            longitude: this._long,
            type: $63c47e8a587a7f36$export$9fa96a7d116ea3ce._jsonSchemaVersion
        };
    }
    /**
     * Builds a `GeoPoint` instance from a JSON object created by {@link GeoPoint.toJSON}.
     *
     * @param json - a JSON object represention of a `GeoPoint` instance
     * @returns an instance of {@link GeoPoint} if the JSON object could be parsed. Throws a
     * {@link FirestoreError} if an error occurs.
     */ static fromJSON(e) {
        if ($63c47e8a587a7f36$export$9bb611d729802a56(e, $63c47e8a587a7f36$export$9fa96a7d116ea3ce._jsonSchema)) return new $63c47e8a587a7f36$export$9fa96a7d116ea3ce(e.latitude, e.longitude);
    }
}
$63c47e8a587a7f36$export$9fa96a7d116ea3ce._jsonSchemaVersion = "firestore/geoPoint/1.0", $63c47e8a587a7f36$export$9fa96a7d116ea3ce._jsonSchema = {
    type: $63c47e8a587a7f36$export$ffb5f4729a158638("string", $63c47e8a587a7f36$export$9fa96a7d116ea3ce._jsonSchemaVersion),
    latitude: $63c47e8a587a7f36$export$ffb5f4729a158638("number"),
    longitude: $63c47e8a587a7f36$export$ffb5f4729a158638("number")
};
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a vector type in Firestore documents.
 * Create an instance with <code>{@link vector}</code>.
 */ class $63c47e8a587a7f36$export$91c6e00c14e7e6fd {
    /**
     * @private
     * @internal
     */ constructor(e){
        // Making a copy of the parameter.
        this._values = (e || []).map((e)=>e);
    }
    /**
     * Returns a copy of the raw number array form of the vector.
     */ toArray() {
        return this._values.map((e)=>e);
    }
    /**
     * Returns `true` if the two `VectorValue` values have the same raw number arrays, returns `false` otherwise.
     */ isEqual(e) {
        return function __PRIVATE_isPrimitiveArrayEqual(e, t) {
            if (e.length !== t.length) return !1;
            for(let n = 0; n < e.length; ++n)if (e[n] !== t[n]) return !1;
            return !0;
        }(this._values, e._values);
    }
    /**
     * Returns a JSON-serializable representation of this `VectorValue` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            type: $63c47e8a587a7f36$export$91c6e00c14e7e6fd._jsonSchemaVersion,
            vectorValues: this._values
        };
    }
    /**
     * Builds a `VectorValue` instance from a JSON object created by {@link VectorValue.toJSON}.
     *
     * @param json - a JSON object represention of a `VectorValue` instance.
     * @returns an instance of {@link VectorValue} if the JSON object could be parsed. Throws a
     * {@link FirestoreError} if an error occurs.
     */ static fromJSON(e) {
        if ($63c47e8a587a7f36$export$9bb611d729802a56(e, $63c47e8a587a7f36$export$91c6e00c14e7e6fd._jsonSchema)) {
            if (Array.isArray(e.vectorValues) && e.vectorValues.every((e)=>"number" == typeof e)) return new $63c47e8a587a7f36$export$91c6e00c14e7e6fd(e.vectorValues);
            throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, "Expected 'vectorValues' field to be a number array");
        }
    }
}
$63c47e8a587a7f36$export$91c6e00c14e7e6fd._jsonSchemaVersion = "firestore/vectorValue/1.0", $63c47e8a587a7f36$export$91c6e00c14e7e6fd._jsonSchema = {
    type: $63c47e8a587a7f36$export$ffb5f4729a158638("string", $63c47e8a587a7f36$export$91c6e00c14e7e6fd._jsonSchemaVersion),
    vectorValues: $63c47e8a587a7f36$export$ffb5f4729a158638("object")
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $63c47e8a587a7f36$var$_n = /^__.*__$/;
/** The result of parsing document data (e.g. for a setData call). */ class $63c47e8a587a7f36$var$ParsedSetData {
    constructor(e, t, n){
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    toMutation(e, t) {
        return null !== this.fieldMask ? new $63c47e8a587a7f36$var$__PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms) : new $63c47e8a587a7f36$var$__PRIVATE_SetMutation(e, this.data, t, this.fieldTransforms);
    }
}
/** The result of parsing "update" data (i.e. for an updateData call). */ class $63c47e8a587a7f36$var$ParsedUpdateData {
    constructor(e, // The fieldMask does not include document transforms.
    t, n){
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    toMutation(e, t) {
        return new $63c47e8a587a7f36$var$__PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms);
    }
}
function $63c47e8a587a7f36$var$__PRIVATE_isWrite(e) {
    switch(e){
        case 0 /* UserDataSource.Set */ :
        // fall through
        case 2 /* UserDataSource.MergeSet */ :
        // fall through
        case 1 /* UserDataSource.Update */ :
            return !0;
        case 3 /* UserDataSource.Argument */ :
        case 4 /* UserDataSource.ArrayArgument */ :
            return !1;
        default:
            throw $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(40011, {
                dataSource: e
            });
    }
}
/** A "context" object passed around while parsing user data. */ class $63c47e8a587a7f36$var$ParseContextImpl {
    /**
     * Initializes a ParseContext with the given source and path.
     *
     * @param settings - The settings for the parser.
     * @param databaseId - The database ID of the Firestore instance.
     * @param serializer - The serializer to use to generate the Value proto.
     * @param ignoreUndefinedProperties - Whether to ignore undefined properties
     * rather than throw.
     * @param fieldTransforms - A mutable list of field transforms encountered
     * while parsing the data.
     * @param fieldMask - A mutable list of field paths encountered while parsing
     * the data.
     *
     * TODO(b/34871131): We don't support array paths right now, so path can be
     * null to indicate the context represents any location within an array (in
     * which case certain features will not work and errors will be somewhat
     * compromised).
     */ constructor(e, t, n, r, i, s){
        this.settings = e, this.databaseId = t, this.serializer = n, this.ignoreUndefinedProperties = r, // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        void 0 === i && this.validatePath(), this.fieldTransforms = i || [], this.fieldMask = s || [];
    }
    get path() {
        return this.settings.path;
    }
    get dataSource() {
        return this.settings.dataSource;
    }
    /** Returns a new context with the specified settings overwritten. */ contextWith(e) {
        return new $63c47e8a587a7f36$var$ParseContextImpl({
            ...this.settings,
            ...e
        }, this.databaseId, this.serializer, this.ignoreUndefinedProperties, this.fieldTransforms, this.fieldMask);
    }
    childContextForField(e) {
        const t = this.path?.child(e), n = this.contextWith({
            path: t,
            arrayElement: !1
        });
        return n.validatePathSegment(e), n;
    }
    childContextForFieldPath(e) {
        const t = this.path?.child(e), n = this.contextWith({
            path: t,
            arrayElement: !1
        });
        return n.validatePath(), n;
    }
    childContextForArray(e) {
        // TODO(b/34871131): We don't support array paths right now; so make path
        // undefined.
        return this.contextWith({
            path: void 0,
            arrayElement: !0
        });
    }
    createError(e) {
        return $63c47e8a587a7f36$var$createError(e, this.settings.methodName, this.settings.hasConverter || !1, this.path, this.settings.targetDoc);
    }
    /** Returns 'true' if 'fieldPath' was traversed when creating this context. */ contains(e) {
        return void 0 !== this.fieldMask.find((t)=>e.isPrefixOf(t)) || void 0 !== this.fieldTransforms.find((t)=>e.isPrefixOf(t.field));
    }
    validatePath() {
        // TODO(b/34871131): Remove null check once we have proper paths for fields
        // within arrays.
        if (this.path) for(let e = 0; e < this.path.length; e++)this.validatePathSegment(this.path.get(e));
    }
    validatePathSegment(e) {
        if (0 === e.length) throw this.createError("Document fields must not be empty");
        if ($63c47e8a587a7f36$var$__PRIVATE_isWrite(this.dataSource) && $63c47e8a587a7f36$var$_n.test(e)) throw this.createError('Document fields cannot begin and end with "__"');
    }
}
/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */ class $63c47e8a587a7f36$export$c5d1328b37d47994 {
    constructor(e, t, n){
        this.databaseId = e, this.ignoreUndefinedProperties = t, this.serializer = n || $63c47e8a587a7f36$export$b4171a6734a65d42(e);
    }
    /** Creates a new top-level parse context. */ createContext(e, t, n, r = !1) {
        return new $63c47e8a587a7f36$var$ParseContextImpl({
            dataSource: e,
            methodName: t,
            targetDoc: n,
            path: $63c47e8a587a7f36$export$cf2f7c5792f80b46.emptyPath(),
            arrayElement: !1,
            hasConverter: r
        }, this.databaseId, this.serializer, this.ignoreUndefinedProperties);
    }
}
function $63c47e8a587a7f36$export$2d1720544b23b823(e) {
    const t = e._freezeSettings(), n = $63c47e8a587a7f36$export$b4171a6734a65d42(e._databaseId);
    return new $63c47e8a587a7f36$export$c5d1328b37d47994(e._databaseId, !!t.ignoreUndefinedProperties, n);
}
/** Parse document data from a set() call. */ function $63c47e8a587a7f36$export$71cec2538cb2c617(e, t, n, r, i, s = {}) {
    const o = e.createContext(s.merge || s.mergeFields ? 2 /* UserDataSource.MergeSet */  : 0 /* UserDataSource.Set */ , t, n, i);
    $63c47e8a587a7f36$var$__PRIVATE_validatePlainObject("Data must be an object, but it was:", o, r);
    const _ = $63c47e8a587a7f36$var$__PRIVATE_parseObject(r, o);
    let a, u;
    if (s.merge) a = new $63c47e8a587a7f36$var$FieldMask(o.fieldMask), u = o.fieldTransforms;
    else if (s.mergeFields) {
        const e = [];
        for (const r of s.mergeFields){
            const i = $63c47e8a587a7f36$export$23f2a1d2818174ef(t, r, n);
            if (!o.contains(i)) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, `Field '${i}' is specified in your field mask but missing from your input data.`);
            $63c47e8a587a7f36$var$__PRIVATE_fieldMaskContains(e, i) || e.push(i);
        }
        a = new $63c47e8a587a7f36$var$FieldMask(e), u = o.fieldTransforms.filter((e)=>a.covers(e.field));
    } else a = null, u = o.fieldTransforms;
    return new $63c47e8a587a7f36$var$ParsedSetData(new $63c47e8a587a7f36$export$c4ce752e73470fba(_), a, u);
}
class $63c47e8a587a7f36$var$__PRIVATE_DeleteFieldValueImpl extends $63c47e8a587a7f36$export$92108d983e8ee699 {
    _toFieldTransform(e) {
        if (2 /* UserDataSource.MergeSet */  !== e.dataSource) throw 1 /* UserDataSource.Update */  === e.dataSource ? e.createError(`${this._methodName}() can only appear at the top level of your update data`) : e.createError(`${this._methodName}() cannot be used with set() unless you pass {merge:true}`);
        // No transform to add for a delete, but we need to add it to our
        // fieldMask so it gets deleted.
        return e.fieldMask.push(e.path), null;
    }
    isEqual(e) {
        return e instanceof $63c47e8a587a7f36$var$__PRIVATE_DeleteFieldValueImpl;
    }
}
/**
 * Creates a child context for parsing SerializableFieldValues.
 *
 * This is different than calling `ParseContext.contextWith` because it keeps
 * the fieldTransforms and fieldMask separate.
 *
 * The created context has its `dataSource` set to `UserDataSource.Argument`.
 * Although these values are used with writes, any elements in these FieldValues
 * are not considered writes since they cannot contain any FieldValue sentinels,
 * etc.
 *
 * @param fieldValue - The sentinel FieldValue for which to create a child
 *     context.
 * @param context - The parent context.
 * @param arrayElement - Whether or not the FieldValue has an array.
 */ function $63c47e8a587a7f36$var$__PRIVATE_createSentinelChildContext(e, t, n) {
    return new $63c47e8a587a7f36$var$ParseContextImpl({
        dataSource: 3 /* UserDataSource.Argument */ ,
        targetDoc: t.settings.targetDoc,
        methodName: e._methodName,
        arrayElement: n
    }, t.databaseId, t.serializer, t.ignoreUndefinedProperties);
}
class $63c47e8a587a7f36$var$__PRIVATE_ServerTimestampFieldValueImpl extends $63c47e8a587a7f36$export$92108d983e8ee699 {
    _toFieldTransform(e) {
        return new $63c47e8a587a7f36$var$FieldTransform(e.path, new $63c47e8a587a7f36$var$__PRIVATE_ServerTimestampTransform);
    }
    isEqual(e) {
        return e instanceof $63c47e8a587a7f36$var$__PRIVATE_ServerTimestampFieldValueImpl;
    }
}
class $63c47e8a587a7f36$var$__PRIVATE_ArrayUnionFieldValueImpl extends $63c47e8a587a7f36$export$92108d983e8ee699 {
    constructor(e, t){
        super(e), this.Ac = t;
    }
    _toFieldTransform(e) {
        const t = $63c47e8a587a7f36$var$__PRIVATE_createSentinelChildContext(this, e, /*array=*/ !0), n = this.Ac.map((e)=>$63c47e8a587a7f36$export$f074adc9fbd50943(e, t)), r = new $63c47e8a587a7f36$var$__PRIVATE_ArrayUnionTransformOperation(n);
        return new $63c47e8a587a7f36$var$FieldTransform(e.path, r);
    }
    isEqual(e) {
        return e instanceof $63c47e8a587a7f36$var$__PRIVATE_ArrayUnionFieldValueImpl && (0, $3117f6f4eeb4c314$export$9cb4719e2e525b7a)(this.Ac, e.Ac);
    }
}
class $63c47e8a587a7f36$var$__PRIVATE_ArrayRemoveFieldValueImpl extends $63c47e8a587a7f36$export$92108d983e8ee699 {
    constructor(e, t){
        super(e), this.Ac = t;
    }
    _toFieldTransform(e) {
        const t = $63c47e8a587a7f36$var$__PRIVATE_createSentinelChildContext(this, e, /*array=*/ !0), n = this.Ac.map((e)=>$63c47e8a587a7f36$export$f074adc9fbd50943(e, t)), r = new $63c47e8a587a7f36$var$__PRIVATE_ArrayRemoveTransformOperation(n);
        return new $63c47e8a587a7f36$var$FieldTransform(e.path, r);
    }
    isEqual(e) {
        return e instanceof $63c47e8a587a7f36$var$__PRIVATE_ArrayRemoveFieldValueImpl && (0, $3117f6f4eeb4c314$export$9cb4719e2e525b7a)(this.Ac, e.Ac);
    }
}
class $63c47e8a587a7f36$var$__PRIVATE_NumericIncrementFieldValueImpl extends $63c47e8a587a7f36$export$92108d983e8ee699 {
    constructor(e, t){
        super(e), this.Vc = t;
    }
    _toFieldTransform(e) {
        const t = new $63c47e8a587a7f36$var$__PRIVATE_NumericIncrementTransformOperation(e.serializer, $63c47e8a587a7f36$export$b4d5ecaefe2b27f3(e.serializer, this.Vc));
        return new $63c47e8a587a7f36$var$FieldTransform(e.path, t);
    }
    isEqual(e) {
        return e instanceof $63c47e8a587a7f36$var$__PRIVATE_NumericIncrementFieldValueImpl && this.Vc === e.Vc;
    }
}
/** Parse update data from an update() call. */ function $63c47e8a587a7f36$export$3d8c2f653ac9d0b9(e, t, n, r) {
    const i = e.createContext(1 /* UserDataSource.Update */ , t, n);
    $63c47e8a587a7f36$var$__PRIVATE_validatePlainObject("Data must be an object, but it was:", i, r);
    const s = [], o = $63c47e8a587a7f36$export$c4ce752e73470fba.empty();
    $63c47e8a587a7f36$var$forEach(r, (e, r)=>{
        const _ = $63c47e8a587a7f36$export$f787f51d84a910ad(t, e, n);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        r = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(r);
        const a = i.childContextForFieldPath(_);
        if (r instanceof $63c47e8a587a7f36$var$__PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        s.push(_);
        else {
            const e = $63c47e8a587a7f36$export$f074adc9fbd50943(r, a);
            null != e && (s.push(_), o.set(_, e));
        }
    });
    const _ = new $63c47e8a587a7f36$var$FieldMask(s);
    return new $63c47e8a587a7f36$var$ParsedUpdateData(o, _, i.fieldTransforms);
}
/** Parse update data from a list of field/value arguments. */ function $63c47e8a587a7f36$export$dc98b0b04f4c7758(e, t, n, r, i, s) {
    const o = e.createContext(1 /* UserDataSource.Update */ , t, n), _ = [
        $63c47e8a587a7f36$export$23f2a1d2818174ef(t, r, n)
    ], a = [
        i
    ];
    if (s.length % 2 != 0) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, `Function ${t}() needs to be called with an even number of arguments that alternate between field names and values.`);
    for(let e = 0; e < s.length; e += 2)_.push($63c47e8a587a7f36$export$23f2a1d2818174ef(t, s[e])), a.push(s[e + 1]);
    const u = [], c = $63c47e8a587a7f36$export$c4ce752e73470fba.empty();
    // We iterate in reverse order to pick the last value for a field if the
    // user specified the field multiple times.
    for(let e = _.length - 1; e >= 0; --e)if (!$63c47e8a587a7f36$var$__PRIVATE_fieldMaskContains(u, _[e])) {
        const t = _[e];
        let n = a[e];
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        n = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(n);
        const r = o.childContextForFieldPath(t);
        if (n instanceof $63c47e8a587a7f36$var$__PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        u.push(t);
        else {
            const e = $63c47e8a587a7f36$export$f074adc9fbd50943(n, r);
            null != e && (u.push(t), c.set(t, e));
        }
    }
    const l = new $63c47e8a587a7f36$var$FieldMask(u);
    return new $63c47e8a587a7f36$var$ParsedUpdateData(c, l, o.fieldTransforms);
}
/**
 * Parse a "query value" (e.g. value in a where filter or a value in a cursor
 * bound).
 *
 * @param allowArrays - Whether the query value is an array that may directly
 * contain additional arrays (e.g. the operand of an `in` query).
 */ function $63c47e8a587a7f36$export$39b482c5e57630a8(e, t, n, r = !1) {
    return $63c47e8a587a7f36$export$f074adc9fbd50943(n, e.createContext(r ? 4 /* UserDataSource.ArrayArgument */  : 3 /* UserDataSource.Argument */ , t));
}
/**
 * Parses user data to Protobuf Values.
 *
 * @param input - Data to be parsed.
 * @param context - A context object representing the current path being parsed,
 * the source of the data being parsed, etc.
 * @returns The parsed value, or null if the value was a FieldValue sentinel
 * that should not be included in the resulting parsed data.
 */ function $63c47e8a587a7f36$export$f074adc9fbd50943(e, t) {
    if ($63c47e8a587a7f36$var$__PRIVATE_looksLikeJsonObject(// Unwrap the API type from the Compat SDK. This will return the API type
    // from firestore-exp.
    e = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(e))) return $63c47e8a587a7f36$var$__PRIVATE_validatePlainObject("Unsupported field value:", t, e), $63c47e8a587a7f36$var$__PRIVATE_parseObject(e, t);
    if (e instanceof $63c47e8a587a7f36$export$92108d983e8ee699) // FieldValues usually parse into transforms (except deleteField())
    // in which case we do not want to include this field in our parsed data
    // (as doing so will overwrite the field directly prior to the transform
    // trying to transform it). So we don't add this location to
    // context.fieldMask and we return null as our parsing result.
    /**
 * "Parses" the provided FieldValueImpl, adding any necessary transforms to
 * context.fieldTransforms.
 */ return function __PRIVATE_parseSentinelFieldValue(e, t) {
        // Sentinels are only supported with writes, and not within arrays.
        if (!$63c47e8a587a7f36$var$__PRIVATE_isWrite(t.dataSource)) throw t.createError(`${e._methodName}() can only be used with update() and set()`);
        if (!t.path) throw t.createError(`${e._methodName}() is not currently supported inside arrays`);
        const n = e._toFieldTransform(t);
        n && t.fieldTransforms.push(n);
    }(e, t), null;
    if (void 0 === e && t.ignoreUndefinedProperties) // If the input is undefined it can never participate in the fieldMask, so
    // don't handle this below. If `ignoreUndefinedProperties` is false,
    // `parseScalarValue` will reject an undefined value.
    return null;
    if (// If context.path is null we are inside an array and we don't support
    // field mask paths more granular than the top-level array.
    t.path && t.fieldMask.push(t.path), e instanceof Array) {
        // TODO(b/34871131): Include the path containing the array in the error
        // message.
        // In the case of IN queries, the parsed data is an array (representing
        // the set of values to be included for the IN query) that may directly
        // contain additional arrays (each representing an individual field
        // value), so we disable this validation.
        if (t.settings.arrayElement && 4 /* UserDataSource.ArrayArgument */  !== t.dataSource) throw t.createError("Nested arrays are not supported");
        return function __PRIVATE_parseArray(e, t) {
            const n = [];
            let r = 0;
            for (const i of e){
                let e = $63c47e8a587a7f36$export$f074adc9fbd50943(i, t.childContextForArray(r));
                null == e && // Just include nulls in the array for fields being replaced with a
                // sentinel.
                (e = {
                    nullValue: "NULL_VALUE"
                }), n.push(e), r++;
            }
            return {
                arrayValue: {
                    values: n
                }
            };
        }(e, t);
    }
    return function __PRIVATE_parseScalarValue(e, t) {
        if (null === (e = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(e))) return {
            nullValue: "NULL_VALUE"
        };
        if ("number" == typeof e) return $63c47e8a587a7f36$export$b4d5ecaefe2b27f3(t.serializer, e);
        if ("boolean" == typeof e) return {
            booleanValue: e
        };
        if ("string" == typeof e) return {
            stringValue: e
        };
        if (e instanceof Date) {
            const n = $63c47e8a587a7f36$export$3d12bd131bb975d1.fromDate(e);
            return {
                timestampValue: $63c47e8a587a7f36$var$toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof $63c47e8a587a7f36$export$3d12bd131bb975d1) {
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            const n = new $63c47e8a587a7f36$export$3d12bd131bb975d1(e.seconds, 1e3 * Math.floor(e.nanoseconds / 1e3));
            return {
                timestampValue: $63c47e8a587a7f36$var$toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof $63c47e8a587a7f36$export$9fa96a7d116ea3ce) return {
            geoPointValue: {
                latitude: e.latitude,
                longitude: e.longitude
            }
        };
        if (e instanceof $63c47e8a587a7f36$export$ef35774e6d314e91) return {
            bytesValue: $63c47e8a587a7f36$var$__PRIVATE_toBytes(t.serializer, e._byteString)
        };
        if (e instanceof $63c47e8a587a7f36$export$96f57966bedc81b4) {
            const n = t.databaseId, r = e.firestore._databaseId;
            if (!r.isEqual(n)) throw t.createError(`Document reference is for database ${r.projectId}/${r.database} but should be for database ${n.projectId}/${n.database}`);
            return {
                referenceValue: $63c47e8a587a7f36$var$__PRIVATE_toResourceName(e.firestore._databaseId || t.databaseId, e._key.path)
            };
        }
        if (e instanceof $63c47e8a587a7f36$export$91c6e00c14e7e6fd) /**
 * Creates a new VectorValue proto value (using the internal format).
 */ return function __PRIVATE_parseVectorValue(e, t) {
            const n = e instanceof $63c47e8a587a7f36$export$91c6e00c14e7e6fd ? e.toArray() : e, r = {
                fields: {
                    [$63c47e8a587a7f36$var$ot]: {
                        stringValue: $63c47e8a587a7f36$var$ut
                    },
                    [$63c47e8a587a7f36$var$ct]: {
                        arrayValue: {
                            values: n.map((e)=>{
                                if ("number" != typeof e) throw t.createError("VectorValues must only contain numeric values.");
                                return $63c47e8a587a7f36$var$__PRIVATE_toDouble(t.serializer, e);
                            })
                        }
                    }
                }
            };
            return {
                mapValue: r
            };
        }(e, t);
        if ($63c47e8a587a7f36$var$__PRIVATE_isProtoValueSerializable(e)) return e._toProto(t.serializer);
        throw t.createError(`Unsupported field value: ${$63c47e8a587a7f36$export$efccba1c4a2ef57b(e)}`);
    }(e, t);
}
function $63c47e8a587a7f36$var$__PRIVATE_parseObject(e, t) {
    const n = {};
    return $63c47e8a587a7f36$var$isEmpty(e) ? // If we encounter an empty object, we explicitly add it to the update
    // mask to ensure that the server creates a map entry.
    t.path && t.path.length > 0 && t.fieldMask.push(t.path) : $63c47e8a587a7f36$var$forEach(e, (e, r)=>{
        const i = $63c47e8a587a7f36$export$f074adc9fbd50943(r, t.childContextForField(e));
        null != i && (n[e] = i);
    }), {
        mapValue: {
            fields: n
        }
    };
}
function $63c47e8a587a7f36$var$__PRIVATE_looksLikeJsonObject(e) {
    return !("object" != typeof e || null === e || e instanceof Array || e instanceof Date || e instanceof $63c47e8a587a7f36$export$3d12bd131bb975d1 || e instanceof $63c47e8a587a7f36$export$9fa96a7d116ea3ce || e instanceof $63c47e8a587a7f36$export$ef35774e6d314e91 || e instanceof $63c47e8a587a7f36$export$96f57966bedc81b4 || e instanceof $63c47e8a587a7f36$export$92108d983e8ee699 || e instanceof $63c47e8a587a7f36$export$91c6e00c14e7e6fd || $63c47e8a587a7f36$var$__PRIVATE_isProtoValueSerializable(e));
}
function $63c47e8a587a7f36$var$__PRIVATE_validatePlainObject(e, t, n) {
    if (!$63c47e8a587a7f36$var$__PRIVATE_looksLikeJsonObject(n) || !$63c47e8a587a7f36$export$7f557e5eb95176c2(n)) {
        const r = $63c47e8a587a7f36$export$efccba1c4a2ef57b(n);
        throw "an object" === r ? t.createError(e + " a custom object") : t.createError(e + " " + r);
    }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */ function $63c47e8a587a7f36$export$23f2a1d2818174ef(e, t, n) {
    if (// If required, replace the FieldPath Compat class with the firestore-exp
    // FieldPath.
    (t = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(t)) instanceof $63c47e8a587a7f36$export$8743009a87fcb00f) return t._internalPath;
    if ("string" == typeof t) return $63c47e8a587a7f36$export$f787f51d84a910ad(e, t);
    throw $63c47e8a587a7f36$var$createError("Field path arguments must be of type string or ", e, /* hasConverter= */ !1, /* path= */ void 0, n);
}
/**
 * Matches any characters in a field path string that are reserved.
 */ const $63c47e8a587a7f36$var$an = new RegExp("[~\\*/\\[\\]]");
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName - The publicly visible method name
 * @param path - The dot-separated string form of a field path which will be
 * split on dots.
 * @param targetDoc - The document against which the field path will be
 * evaluated.
 */ function $63c47e8a587a7f36$export$f787f51d84a910ad(e, t, n) {
    if (t.search($63c47e8a587a7f36$var$an) >= 0) throw $63c47e8a587a7f36$var$createError(`Invalid field path (${t}). Paths must not contain '~', '*', '/', '[', or ']'`, e, /* hasConverter= */ !1, /* path= */ void 0, n);
    try {
        return new $63c47e8a587a7f36$export$8743009a87fcb00f(...t.split("."))._internalPath;
    } catch (r) {
        throw $63c47e8a587a7f36$var$createError(`Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`, e, /* hasConverter= */ !1, /* path= */ void 0, n);
    }
}
function $63c47e8a587a7f36$var$createError(e, t, n, r, i) {
    const s = r && !r.isEmpty(), o = void 0 !== i;
    let _ = `Function ${t}() called with invalid data`;
    n && (_ += " (via `toFirestore()`)"), _ += ". ";
    let a = "";
    return (s || o) && (a += " (found", s && (a += ` in field ${r}`), o && (a += ` in document ${i}`), a += ")"), new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.INVALID_ARGUMENT, _ + e + a);
}
/** Checks `haystack` if FieldPath `needle` is present. Runs in O(n). */ function $63c47e8a587a7f36$var$__PRIVATE_fieldMaskContains(e, t) {
    return e.some((e)=>e.isEqual(t));
}
function $63c47e8a587a7f36$export$a36fb7d24305ed9d(e) {
    return "function" == typeof e._readUserData;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts Firestore's internal types to the JavaScript types that we expose
 * to the user.
 *
 * @internal
 */ class $63c47e8a587a7f36$export$ebd11618f299a286 {
    convertValue(e, t = "none") {
        switch($63c47e8a587a7f36$var$__PRIVATE_typeOrder(e)){
            case 0 /* TypeOrder.NullValue */ :
                return null;
            case 1 /* TypeOrder.BooleanValue */ :
                return e.booleanValue;
            case 2 /* TypeOrder.NumberValue */ :
                return $63c47e8a587a7f36$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
            case 3 /* TypeOrder.TimestampValue */ :
                return this.convertTimestamp(e.timestampValue);
            case 4 /* TypeOrder.ServerTimestampValue */ :
                return this.convertServerTimestamp(e, t);
            case 5 /* TypeOrder.StringValue */ :
                return e.stringValue;
            case 6 /* TypeOrder.BlobValue */ :
                return this.convertBytes($63c47e8a587a7f36$var$__PRIVATE_normalizeByteString(e.bytesValue));
            case 7 /* TypeOrder.RefValue */ :
                return this.convertReference(e.referenceValue);
            case 8 /* TypeOrder.GeoPointValue */ :
                return this.convertGeoPoint(e.geoPointValue);
            case 9 /* TypeOrder.ArrayValue */ :
                return this.convertArray(e.arrayValue, t);
            case 11 /* TypeOrder.ObjectValue */ :
                return this.convertObject(e.mapValue, t);
            case 10 /* TypeOrder.VectorValue */ :
                return this.convertVectorValue(e.mapValue);
            default:
                throw $63c47e8a587a7f36$export$3a6d5c9ae78a2c08(62114, {
                    value: e
                });
        }
    }
    convertObject(e, t) {
        return this.convertObjectMap(e.fields, t);
    }
    /**
     * @internal
     */ convertObjectMap(e, t = "none") {
        const n = {};
        return $63c47e8a587a7f36$var$forEach(e, (e, r)=>{
            n[e] = this.convertValue(r, t);
        }), n;
    }
    /**
     * @internal
     */ convertVectorValue(e) {
        const t = e.fields?.[$63c47e8a587a7f36$var$ct].arrayValue?.values?.map((e)=>$63c47e8a587a7f36$var$__PRIVATE_normalizeNumber(e.doubleValue));
        return new $63c47e8a587a7f36$export$91c6e00c14e7e6fd(t);
    }
    convertGeoPoint(e) {
        return new $63c47e8a587a7f36$export$9fa96a7d116ea3ce($63c47e8a587a7f36$var$__PRIVATE_normalizeNumber(e.latitude), $63c47e8a587a7f36$var$__PRIVATE_normalizeNumber(e.longitude));
    }
    convertArray(e, t) {
        return (e.values || []).map((e)=>this.convertValue(e, t));
    }
    convertServerTimestamp(e, t) {
        switch(t){
            case "previous":
                const n = $63c47e8a587a7f36$var$__PRIVATE_getPreviousValue(e);
                return null == n ? null : this.convertValue(n, t);
            case "estimate":
                return this.convertTimestamp($63c47e8a587a7f36$var$__PRIVATE_getLocalWriteTime(e));
            default:
                return null;
        }
    }
    convertTimestamp(e) {
        const t = $63c47e8a587a7f36$var$__PRIVATE_normalizeTimestamp(e);
        return new $63c47e8a587a7f36$export$3d12bd131bb975d1(t.seconds, t.nanos);
    }
    convertDocumentKey(e, t) {
        const n = $63c47e8a587a7f36$export$db202ddc8be9136.fromString(e);
        $63c47e8a587a7f36$export$c18d01048907ea92($63c47e8a587a7f36$var$__PRIVATE_isValidResourceName(n), 9688, {
            name: e
        });
        const r = new $63c47e8a587a7f36$export$890c4ad488842ce7(n.get(1), n.get(3)), i = new $63c47e8a587a7f36$export$90a7f3efeed30595(n.popFirst(5));
        return r.isEqual(t) || // TODO(b/64130202): Somehow support foreign references.
        $63c47e8a587a7f36$var$__PRIVATE_logError(`Document ${i} contains a document reference within a different database (${r.projectId}/${r.database}) which is not supported. It will be treated as a reference in the current database (${t.projectId}/${t.database}) instead.`), i;
    }
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $63c47e8a587a7f36$export$7f8ddf7c7c20b3cd extends $63c47e8a587a7f36$export$ebd11618f299a286 {
    constructor(e){
        super(), this.firestore = e;
    }
    convertBytes(e) {
        return new $63c47e8a587a7f36$export$ef35774e6d314e91(e);
    }
    convertReference(e) {
        const t = this.convertDocumentKey(e, this.firestore._databaseId);
        return new $63c47e8a587a7f36$export$96f57966bedc81b4(this.firestore, /* converter= */ null, t);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a sentinel for use with {@link @firebase/firestore/lite#(updateDoc:1)} or
 * {@link @firebase/firestore/lite#(setDoc:1)} with `{merge: true}` to mark a field for deletion.
 */ function $63c47e8a587a7f36$export$738ab4df8bf92ae9() {
    return new $63c47e8a587a7f36$var$__PRIVATE_DeleteFieldValueImpl("deleteField");
}
/**
 * Returns a sentinel used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link @firebase/firestore/lite#(updateDoc:1)} to
 * include a server-generated timestamp in the written data.
 */ function $63c47e8a587a7f36$export$fef3dfd9bad05307() {
    return new $63c47e8a587a7f36$var$__PRIVATE_ServerTimestampFieldValueImpl("serverTimestamp");
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to union the given elements with any array
 * value that already exists on the server. Each specified element that doesn't
 * already exist in the array will be added to the end. If the field being
 * modified is not already an array it will be overwritten with an array
 * containing exactly the specified elements.
 *
 * @param elements - The elements to union into the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`.
 */ function $63c47e8a587a7f36$export$9f4f30ee63539e24(...e) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $63c47e8a587a7f36$var$__PRIVATE_ArrayUnionFieldValueImpl("arrayUnion", e);
}
/**
 * Returns a special value that can be used with {@link (setDoc:1)} or {@link
 * updateDoc:1} that tells the server to remove the given elements from any
 * array value that already exists on the server. All instances of each element
 * specified will be removed from the array. If the field being modified is not
 * already an array it will be overwritten with an empty array.
 *
 * @param elements - The elements to remove from the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $63c47e8a587a7f36$export$91477dc880baac21(...e) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $63c47e8a587a7f36$var$__PRIVATE_ArrayRemoveFieldValueImpl("arrayRemove", e);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to increment the field's current value by
 * the given value.
 *
 * If either the operand or the current field value uses floating point
 * precision, all arithmetic follows IEEE 754 semantics. If both values are
 * integers, values outside of JavaScript's safe number range
 * (`Number.MIN_SAFE_INTEGER` to `Number.MAX_SAFE_INTEGER`) are also subject to
 * precision loss. Furthermore, once processed by the Firestore backend, all
 * integer operations are capped between -2^63 and 2^63-1.
 *
 * If the current field value is not of type `number`, or if the field does not
 * yet exist, the transformation sets the field to the given value.
 *
 * @param n - The value to increment by.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $63c47e8a587a7f36$export$e171bab687b50e0(e) {
    return new $63c47e8a587a7f36$var$__PRIVATE_NumericIncrementFieldValueImpl("increment", e);
}
/**
 * Creates a new `VectorValue` constructed with a copy of the given array of numbers.
 *
 * @param values - Create a `VectorValue` instance with a copy of this array of numbers.
 *
 * @returns A new `VectorValue` constructed with a copy of the given array of numbers.
 */ function $63c47e8a587a7f36$export$2ec5befb9e6c97d4(e) {
    return new $63c47e8a587a7f36$export$91c6e00c14e7e6fd(e);
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $63c47e8a587a7f36$export$151db275011178c4 {
    constructor(e){
        this.optionDefinitions = e;
    }
    _getKnownOptions(e, t) {
        const n = $63c47e8a587a7f36$export$c4ce752e73470fba.empty();
        // SERIALIZE KNOWN OPTIONS
        for(const r in this.optionDefinitions)if (this.optionDefinitions.hasOwnProperty(r)) {
            const i = this.optionDefinitions[r];
            if (r in e) {
                const s = e[r];
                let o;
                if (i.nestedOptions && $63c47e8a587a7f36$export$7f557e5eb95176c2(s)) o = {
                    mapValue: {
                        fields: new $63c47e8a587a7f36$export$151db275011178c4(i.nestedOptions).getOptionsProto(t, s)
                    }
                };
                else s && (o = $63c47e8a587a7f36$export$f074adc9fbd50943(s, t) ?? void 0);
                o && n.set($63c47e8a587a7f36$export$cf2f7c5792f80b46.fromServerFormat(i.serverName), o);
            }
        }
        return n;
    }
    getOptionsProto(e, t, n) {
        const r = this._getKnownOptions(t, e);
        // APPLY OPTIONS OVERRIDES
        if (n) {
            const t = new Map($63c47e8a587a7f36$export$a9c23c6ac3fc3eca(n, (t, n)=>[
                    $63c47e8a587a7f36$export$cf2f7c5792f80b46.fromServerFormat(n),
                    void 0 !== t ? $63c47e8a587a7f36$export$f074adc9fbd50943(t, e) : null
                ]));
            r.setAll(t);
        }
        // Return MapValue from `result` or empty map value
        return r.value.mapValue.fields ?? {};
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $63c47e8a587a7f36$export$31e67cf12fc9668 {
    constructor(e = {}, t = {}){
        this.dc = e, this.mc = t, this.fc = new $63c47e8a587a7f36$export$151db275011178c4({
            indexMode: {
                serverName: "index_mode"
            }
        });
    }
    _readUserData(e) {
        this.proto = this.fc.getOptionsProto(e, this.dc, this.mc);
    }
}
class $63c47e8a587a7f36$export$55ff3cc1821e8445 {
    constructor(e, t){
        this.pipeline = e, this.options = t;
    }
    _toProto(e) {
        return {
            pipeline: this.pipeline._toProto(e),
            options: this.options.proto
        };
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns the `QueryTarget` representation of the given query. Returns `null`
 * if the Firestore client associated with the given query has not been
 * initialized or has been terminated.
 *
 * @param query - The Query to convert to proto representation.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $63c47e8a587a7f36$export$b9a6b53f9be3734(e) {
    const t = $63c47e8a587a7f36$export$df995fae86a55f06($63c47e8a587a7f36$export$4a5767248b18ef41(e.firestore, $63c47e8a587a7f36$export$d66501df72047452)), n = t._onlineComponents?.datastore.serializer;
    return void 0 === n ? null : $63c47e8a587a7f36$var$__PRIVATE_toQueryTarget(n, $63c47e8a587a7f36$var$__PRIVATE_queryToTarget(e._query)).ft;
}
/**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns `RunAggregationQueryRequest` which contains the proto representation
 * of the given aggregation query request. Returns null if the Firestore client
 * associated with the given query has not been initialized or has been
 * terminated.
 *
 * @param query - The Query to convert to proto representation.
 * @param aggregateSpec - The set of aggregations and their aliases.
 */ function $63c47e8a587a7f36$export$a33b77bbdbb8366c(e, t) {
    const n = $63c47e8a587a7f36$export$a9c23c6ac3fc3eca(t, (e, t)=>new $63c47e8a587a7f36$export$7a38258bbe170828(t, e.aggregateType, e._internalFieldPath)), r = $63c47e8a587a7f36$export$df995fae86a55f06($63c47e8a587a7f36$export$4a5767248b18ef41(e.firestore, $63c47e8a587a7f36$export$d66501df72047452)), i = r._onlineComponents?.datastore.serializer;
    return void 0 === i ? null : $63c47e8a587a7f36$var$__PRIVATE_toRunAggregationQueryRequest(i, $63c47e8a587a7f36$var$__PRIVATE_queryToAggregateTarget(e._query), n, /* skipAliasing= */ !0).request;
}
/**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns the `ExecutePipelineRequest` representation of the given query.
 * Returns `null` if the Firestore client associated with the given query has
 * not been initialized or has been terminated.
 *
 * @param pipeline - The Pipeline to convert to proto representation.
 */ function $63c47e8a587a7f36$export$acf3ba20e47771d(e) {
    const t = /**
 * Returns an initialized and started Datastore for the given Firestore
 * instance. Callers must invoke removeComponents() when the Firestore
 * instance is terminated.
 */ function __PRIVATE_getDatastore(e) {
        if (e._terminated) throw new $63c47e8a587a7f36$export$4368d992c4eafac0($63c47e8a587a7f36$export$e7094788287c5e9b.FAILED_PRECONDITION, "The client has already been terminated.");
        if (!$63c47e8a587a7f36$var$tn.has(e)) {
            $63c47e8a587a7f36$export$21579262ef46735b($63c47e8a587a7f36$var$en, "Initializing Datastore");
            const t = $63c47e8a587a7f36$var$__PRIVATE_newConnection($63c47e8a587a7f36$var$__PRIVATE_makeDatabaseInfo(e._databaseId, e.app.options.appId || "", e._persistenceKey, e.app.options.apiKey, e._freezeSettings())), n = $63c47e8a587a7f36$export$b4171a6734a65d42(e._databaseId), r = $63c47e8a587a7f36$var$__PRIVATE_newDatastore(e._authCredentials, e._appCheckCredentials, t, n);
            $63c47e8a587a7f36$var$tn.set(e, r);
        }
        return $63c47e8a587a7f36$var$tn.get(e);
    }($63c47e8a587a7f36$export$4a5767248b18ef41(e._db, $63c47e8a587a7f36$export$d66501df72047452)), n = t.serializer;
    if (void 0 === n) return null;
    const r = new $63c47e8a587a7f36$export$55ff3cc1821e8445(e, new $63c47e8a587a7f36$export$31e67cf12fc9668);
    return {
        database: $63c47e8a587a7f36$var$__PRIVATE_getEncodedDatabaseId(n),
        structuredPipeline: r._toProto(n)
    };
}






const $811ad1659062a8d4$var$Ut = "@firebase/firestore", $811ad1659062a8d4$var$Ht = "4.12.0";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $811ad1659062a8d4$var$__PRIVATE_isPartialObserver(t) {
    /**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */ return function __PRIVATE_implementsAnyMethods(t, e) {
        if ("object" != typeof t || null === t) return !1;
        const n = t;
        for (const t of e)if (t in n && "function" == typeof n[t]) return !0;
        return !1;
    }(t, [
        "next",
        "error",
        "complete"
    ]);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an aggregation that can be performed by Firestore.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
class $811ad1659062a8d4$export$fada2345be8928cf {
    /**
     * Create a new AggregateField<T>
     * @param aggregateType - Specifies the type of aggregation operation to perform.
     * @param _internalFieldPath - Optionally specifies the field that is aggregated.
     * @internal
     */ constructor(t = "count", e){
        this._internalFieldPath = e, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateField", this.aggregateType = t;
    }
}
/**
 * The results of executing an aggregation query.
 */ class $811ad1659062a8d4$export$40257fef64be808b {
    /** @hideconstructor */ constructor(t, e, n){
        this._userDataWriter = e, this._data = n, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateQuerySnapshot", this.query = t;
    }
    /**
     * Returns the results of the aggregations performed over the underlying
     * query.
     *
     * The keys of the returned object will be the same as those of the
     * `AggregateSpec` object specified to the aggregation method, and the values
     * will be the corresponding aggregation result.
     *
     * @returns The results of the aggregations performed over the underlying
     * query.
     */ data() {
        return this._userDataWriter.convertObjectMap(this._data);
    }
    /**
     * @internal
     * @private
     *
     * Retrieves all fields in the snapshot as a proto value.
     *
     * @returns An `Object` containing all fields in the snapshot.
     */ _fieldsProto() {
        // Return the cloned value to prevent manipulation of the Snapshot's data
        return new (0, $63c47e8a587a7f36$export$c4ce752e73470fba)({
            mapValue: {
                fields: this._data
            }
        }).clone().value.mapValue.fields;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $811ad1659062a8d4$var$DocumentSnapshot$1 {
    // Note: This class is stripped down version of the DocumentSnapshot in
    // the legacy SDK. The changes are:
    // - No support for SnapshotMetadata.
    // - No support for SnapshotOptions.
    /** @hideconstructor protected */ constructor(t, e, n, r, s){
        this._firestore = t, this._userDataWriter = e, this._key = n, this._document = r, this._converter = s;
    }
    /** Property of the `DocumentSnapshot` that provides the document's ID. */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * The `DocumentReference` for the document included in the `DocumentSnapshot`.
     */ get ref() {
        return new (0, $63c47e8a587a7f36$export$96f57966bedc81b4)(this._firestore, this._converter, this._key);
    }
    /**
     * Signals whether or not the document at the snapshot's location exists.
     *
     * @returns true if the document exists.
     */ exists() {
        return null !== this._document;
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */ data() {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const t = new $811ad1659062a8d4$var$QueryDocumentSnapshot$1(this._firestore, this._userDataWriter, this._key, this._document, /* converter= */ null);
                return this._converter.fromFirestore(t);
            }
            return this._userDataWriter.convertValue(this._document.data.value);
        }
    }
    /**
     * @internal
     * @private
     *
     * Retrieves all fields in the document as a proto Value. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */ _fieldsProto() {
        // Return a cloned value to prevent manipulation of the Snapshot's data
        return this._document?.data.clone().value.mapValue.fields ?? void 0;
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(t) {
        if (this._document) {
            const e = this._document.data.field((0, $63c47e8a587a7f36$export$23f2a1d2818174ef)("DocumentSnapshot.get", t));
            if (null !== e) return this._userDataWriter.convertValue(e);
        }
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ class $811ad1659062a8d4$var$QueryDocumentSnapshot$1 extends $811ad1659062a8d4$var$DocumentSnapshot$1 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * @override
     * @returns An `Object` containing all fields in the document.
     */ data() {
        return super.data();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $811ad1659062a8d4$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(t) {
    if ("L" /* LimitType.Last */  === t.limitType && 0 === t.explicitOrderBy.length) throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
}
/**
 * An `AppliableConstraint` is an abstraction of a constraint that can be applied
 * to a Firestore query.
 */ class $811ad1659062a8d4$var$AppliableConstraint {
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Firestore query. `QueryConstraint`s are created by invoking {@link where},
 * {@link orderBy}, {@link (startAt:1)}, {@link (startAfter:1)}, {@link
 * (endBefore:1)}, {@link (endAt:1)}, {@link limit}, {@link limitToLast} and
 * can then be passed to {@link (query:1)} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ class $811ad1659062a8d4$export$b0e86f2c7431df4e extends $811ad1659062a8d4$var$AppliableConstraint {
}
function $811ad1659062a8d4$export$2fa187e846a241c4(t, e, ...n) {
    let r = [];
    e instanceof $811ad1659062a8d4$var$AppliableConstraint && r.push(e), r = r.concat(n), function __PRIVATE_validateQueryConstraintArray(t) {
        const e = t.filter((t)=>t instanceof $811ad1659062a8d4$export$6bbc7aef0717f3d2).length, n = t.filter((t)=>t instanceof $811ad1659062a8d4$export$f765fc5789dfd439).length;
        if (e > 1 || e > 0 && n > 0) throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).INVALID_ARGUMENT, "InvalidQuery. When using composite filters, you cannot use more than one filter at the top level. Consider nesting the multiple filters within an `and(...)` statement. For example: change `query(query, where(...), or(...))` to `query(query, and(where(...), or(...)))`.");
    }(r);
    for (const e of r)t = e._apply(t);
    return t;
}
/**
 * A `QueryFieldFilterConstraint` is used to narrow the set of documents returned by
 * a Firestore query by filtering on one or more document fields.
 * `QueryFieldFilterConstraint`s are created by invoking {@link where} and can then
 * be passed to {@link (query:1)} to create a new query instance that also contains
 * this `QueryFieldFilterConstraint`.
 */ class $811ad1659062a8d4$export$f765fc5789dfd439 extends $811ad1659062a8d4$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(t, e, n){
        super(), this._field = t, this._op = e, this._value = n, /** The type of this query constraint */ this.type = "where";
    }
    static _create(t, e, n) {
        return new $811ad1659062a8d4$export$f765fc5789dfd439(t, e, n);
    }
    _apply(t) {
        const e = this._parse(t);
        return $811ad1659062a8d4$var$__PRIVATE_validateNewFieldFilter(t._query, e), new (0, $63c47e8a587a7f36$export$3722cfe417b6ed86)(t.firestore, t.converter, (0, $63c47e8a587a7f36$export$f1e1789686576879)(t._query, e));
    }
    _parse(t) {
        const e = (0, $63c47e8a587a7f36$export$2d1720544b23b823)(t.firestore), n = function __PRIVATE_newQueryFilter(t, e, n, r, s, a, o) {
            let i;
            if (s.isKeyField()) {
                if ("array-contains" /* Operator.ARRAY_CONTAINS */  === a || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === a) throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).INVALID_ARGUMENT, `Invalid Query. You can't perform '${a}' queries on documentId().`);
                if ("in" /* Operator.IN */  === a || "not-in" /* Operator.NOT_IN */  === a) {
                    $811ad1659062a8d4$var$__PRIVATE_validateDisjunctiveFilterElements(o, a);
                    const e = [];
                    for (const n of o)e.push($811ad1659062a8d4$var$__PRIVATE_parseDocumentIdValue(r, t, n));
                    i = {
                        arrayValue: {
                            values: e
                        }
                    };
                } else i = $811ad1659062a8d4$var$__PRIVATE_parseDocumentIdValue(r, t, o);
            } else "in" /* Operator.IN */  !== a && "not-in" /* Operator.NOT_IN */  !== a && "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  !== a || $811ad1659062a8d4$var$__PRIVATE_validateDisjunctiveFilterElements(o, a), i = (0, $63c47e8a587a7f36$export$39b482c5e57630a8)(n, e, o, /* allowArrays= */ "in" /* Operator.IN */  === a || "not-in" /* Operator.NOT_IN */  === a);
            const u = (0, $63c47e8a587a7f36$export$dda1d9f60106f0e9).create(s, a, i);
            return u;
        }(t._query, "where", e, t.firestore._databaseId, this._field, this._op, this._value);
        return n;
    }
}
/**
 * Creates a {@link QueryFieldFilterConstraint} that enforces that documents
 * must contain the specified field and that the value should satisfy the
 * relation constraint provided.
 *
 * @param fieldPath - The path to compare
 * @param opStr - The operation string (e.g "&lt;", "&lt;=", "==", "&lt;",
 *   "&lt;=", "!=").
 * @param value - The value for comparison
 * @returns The created {@link QueryFieldFilterConstraint}.
 */ function $811ad1659062a8d4$export$9c59b80dda569a6e(t, e, n) {
    const r = e, s = (0, $63c47e8a587a7f36$export$23f2a1d2818174ef)("where", t);
    return $811ad1659062a8d4$export$f765fc5789dfd439._create(s, r, n);
}
/**
 * A `QueryCompositeFilterConstraint` is used to narrow the set of documents
 * returned by a Firestore query by performing the logical OR or AND of multiple
 * {@link QueryFieldFilterConstraint}s or {@link QueryCompositeFilterConstraint}s.
 * `QueryCompositeFilterConstraint`s are created by invoking {@link or} or
 * {@link and} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains the `QueryCompositeFilterConstraint`.
 */ class $811ad1659062a8d4$export$6bbc7aef0717f3d2 extends $811ad1659062a8d4$var$AppliableConstraint {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e){
        super(), this.type = t, this._queryConstraints = e;
    }
    static _create(t, e) {
        return new $811ad1659062a8d4$export$6bbc7aef0717f3d2(t, e);
    }
    _parse(t) {
        const e = this._queryConstraints.map((e)=>e._parse(t)).filter((t)=>t.getFilters().length > 0);
        return 1 === e.length ? e[0] : (0, $63c47e8a587a7f36$export$35e795649ee09318).create(e, this._getOperator());
    }
    _apply(t) {
        const e = this._parse(t);
        return 0 === e.getFilters().length ? t : (function __PRIVATE_validateNewFilter(t, e) {
            let n = t;
            const r = e.getFlattenedFilters();
            for (const t of r)$811ad1659062a8d4$var$__PRIVATE_validateNewFieldFilter(n, t), n = (0, $63c47e8a587a7f36$export$f1e1789686576879)(n, t);
        }(t._query, e), new (0, $63c47e8a587a7f36$export$3722cfe417b6ed86)(t.firestore, t.converter, (0, $63c47e8a587a7f36$export$f1e1789686576879)(t._query, e)));
    }
    _getQueryConstraints() {
        return this._queryConstraints;
    }
    _getOperator() {
        return "and" === this.type ? "and" /* CompositeOperator.AND */  : "or" /* CompositeOperator.OR */ ;
    }
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a disjunction of
 * the given filter constraints. A disjunction filter includes a document if it
 * satisfies any of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a disjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $811ad1659062a8d4$export$252bb8b3bbdf6749(...t) {
    // Only support QueryFilterConstraints
    return t.forEach((t)=>$811ad1659062a8d4$var$__PRIVATE_validateQueryFilterConstraint("or", t)), $811ad1659062a8d4$export$6bbc7aef0717f3d2._create("or" /* CompositeOperator.OR */ , t);
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a conjunction of
 * the given filter constraints. A conjunction filter includes a document if it
 * satisfies all of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a conjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $811ad1659062a8d4$export$21c0ac7fe1cef1b8(...t) {
    // Only support QueryFilterConstraints
    return t.forEach((t)=>$811ad1659062a8d4$var$__PRIVATE_validateQueryFilterConstraint("and", t)), $811ad1659062a8d4$export$6bbc7aef0717f3d2._create("and" /* CompositeOperator.AND */ , t);
}
/**
 * A `QueryOrderByConstraint` is used to sort the set of documents returned by a
 * Firestore query. `QueryOrderByConstraint`s are created by invoking
 * {@link orderBy} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains this `QueryOrderByConstraint`.
 *
 * Note: Documents that do not contain the orderBy field will not be present in
 * the query result.
 */ class $811ad1659062a8d4$export$65a9ba8bbd6ed9e3 extends $811ad1659062a8d4$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(t, e){
        super(), this._field = t, this._direction = e, /** The type of this query constraint */ this.type = "orderBy";
    }
    static _create(t, e) {
        return new $811ad1659062a8d4$export$65a9ba8bbd6ed9e3(t, e);
    }
    _apply(t) {
        const e = function __PRIVATE_newQueryOrderBy(t, e, n) {
            if (null !== t.startAt) throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).INVALID_ARGUMENT, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
            if (null !== t.endAt) throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).INVALID_ARGUMENT, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
            const r = new (0, $63c47e8a587a7f36$export$306ddfe3a8403e2)(e, n);
            return r;
        }(t._query, this._field, this._direction);
        return new (0, $63c47e8a587a7f36$export$3722cfe417b6ed86)(t.firestore, t.converter, (0, $63c47e8a587a7f36$export$342063e11d6c3cad)(t._query, e));
    }
}
/**
 * Creates a {@link QueryOrderByConstraint} that sorts the query result by the
 * specified field, optionally in descending order instead of ascending.
 *
 * Note: Documents that do not contain the specified field will not be present
 * in the query result.
 *
 * @param fieldPath - The field to sort by.
 * @param directionStr - Optional direction to sort by ('asc' or 'desc'). If
 * not specified, order will be ascending.
 * @returns The created {@link QueryOrderByConstraint}.
 */ function $811ad1659062a8d4$export$f18af21d6f4dafd8(t, e = "asc") {
    const n = e, r = (0, $63c47e8a587a7f36$export$23f2a1d2818174ef)("orderBy", t);
    return $811ad1659062a8d4$export$65a9ba8bbd6ed9e3._create(r, n);
}
/**
 * A `QueryLimitConstraint` is used to limit the number of documents returned by
 * a Firestore query.
 * `QueryLimitConstraint`s are created by invoking {@link limit} or
 * {@link limitToLast} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryLimitConstraint`.
 */ class $811ad1659062a8d4$export$49bb5356ca788047 extends $811ad1659062a8d4$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e, n){
        super(), this.type = t, this._limit = e, this._limitType = n;
    }
    static _create(t, e, n) {
        return new $811ad1659062a8d4$export$49bb5356ca788047(t, e, n);
    }
    _apply(t) {
        return new (0, $63c47e8a587a7f36$export$3722cfe417b6ed86)(t.firestore, t.converter, (0, $63c47e8a587a7f36$export$882b5998b3b9117c)(t._query, this._limit, this._limitType));
    }
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the first matching
 * documents.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $811ad1659062a8d4$export$ee37e834aaad6f7e(t) {
    return (0, $63c47e8a587a7f36$export$953cecd6e717a553)("limit", t), $811ad1659062a8d4$export$49bb5356ca788047._create("limit", t, "F" /* LimitType.First */ );
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the last matching
 * documents.
 *
 * You must specify at least one `orderBy` clause for `limitToLast` queries,
 * otherwise an exception will be thrown during execution.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $811ad1659062a8d4$export$f823b3589f69d3b8(t) {
    return (0, $63c47e8a587a7f36$export$953cecd6e717a553)("limitToLast", t), $811ad1659062a8d4$export$49bb5356ca788047._create("limitToLast", t, "L" /* LimitType.Last */ );
}
/**
 * A `QueryStartAtConstraint` is used to exclude documents from the start of a
 * result set returned by a Firestore query.
 * `QueryStartAtConstraint`s are created by invoking {@link (startAt:1)} or
 * {@link (startAfter:1)} and can then be passed to {@link (query:1)} to create a
 * new query instance that also contains this `QueryStartAtConstraint`.
 */ class $811ad1659062a8d4$export$d92e2830aca1d816 extends $811ad1659062a8d4$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e, n){
        super(), this.type = t, this._docOrFields = e, this._inclusive = n;
    }
    static _create(t, e, n) {
        return new $811ad1659062a8d4$export$d92e2830aca1d816(t, e, n);
    }
    _apply(t) {
        const e = $811ad1659062a8d4$var$__PRIVATE_newQueryBoundFromDocOrFields(t, this.type, this._docOrFields, this._inclusive);
        return new (0, $63c47e8a587a7f36$export$3722cfe417b6ed86)(t.firestore, t.converter, (0, $63c47e8a587a7f36$export$7ccc53e8f1e7dfc5)(t._query, e));
    }
}
function $811ad1659062a8d4$export$859941c5fc8eba6b(...t) {
    return $811ad1659062a8d4$export$d92e2830aca1d816._create("startAt", t, /*inclusive=*/ !0);
}
function $811ad1659062a8d4$export$dd8dee5f7b804673(...t) {
    return $811ad1659062a8d4$export$d92e2830aca1d816._create("startAfter", t, /*inclusive=*/ !1);
}
/**
 * A `QueryEndAtConstraint` is used to exclude documents from the end of a
 * result set returned by a Firestore query.
 * `QueryEndAtConstraint`s are created by invoking {@link (endAt:1)} or
 * {@link (endBefore:1)} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryEndAtConstraint`.
 */ class $811ad1659062a8d4$export$fd1782fd870d1e06 extends $811ad1659062a8d4$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e, n){
        super(), this.type = t, this._docOrFields = e, this._inclusive = n;
    }
    static _create(t, e, n) {
        return new $811ad1659062a8d4$export$fd1782fd870d1e06(t, e, n);
    }
    _apply(t) {
        const e = $811ad1659062a8d4$var$__PRIVATE_newQueryBoundFromDocOrFields(t, this.type, this._docOrFields, this._inclusive);
        return new (0, $63c47e8a587a7f36$export$3722cfe417b6ed86)(t.firestore, t.converter, (0, $63c47e8a587a7f36$export$ae1af26003f05816)(t._query, e));
    }
}
function $811ad1659062a8d4$export$57203950645b8b11(...t) {
    return $811ad1659062a8d4$export$fd1782fd870d1e06._create("endBefore", t, /*inclusive=*/ !1);
}
function $811ad1659062a8d4$export$28ec54a8428bdb3f(...t) {
    return $811ad1659062a8d4$export$fd1782fd870d1e06._create("endAt", t, /*inclusive=*/ !0);
}
/** Helper function to create a bound from a document or fields */ function $811ad1659062a8d4$var$__PRIVATE_newQueryBoundFromDocOrFields(t, e, n, r) {
    if (n[0] = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(n[0]), n[0] instanceof $811ad1659062a8d4$var$DocumentSnapshot$1) return function __PRIVATE_newQueryBoundFromDocument(t, e, n, r, s) {
        if (!r) throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).NOT_FOUND, `Can't use a DocumentSnapshot that doesn't exist for ${n}().`);
        const a = [];
        // Because people expect to continue/end a query at the exact document
        // provided, we need to use the implicit sort order rather than the explicit
        // sort order, because it's guaranteed to contain the document key. That way
        // the position becomes unambiguous and the query continues/ends exactly at
        // the provided document. Without the key (by using the explicit sort
        // orders), multiple documents could match the position, yielding duplicate
        // results.
        for (const n of (0, $63c47e8a587a7f36$export$9e5f44173e64f162)(t))if (n.field.isKeyField()) a.push((0, $63c47e8a587a7f36$export$43caf9889c228507)(e, r.key));
        else {
            const t = r.data.field(n.field);
            if ((0, $63c47e8a587a7f36$export$2408f22a0fab9ae5)(t)) throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + n.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');
            if (null === t) {
                const t = n.field.canonicalString();
                throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).INVALID_ARGUMENT, `Invalid query. You are trying to start or end a query using a document for which the field '${t}' (used as the orderBy) does not exist.`);
            }
            a.push(t);
        }
        return new (0, $63c47e8a587a7f36$export$625550452a3fa3ec)(a, s);
    }(t._query, t.firestore._databaseId, e, n[0]._document, r);
    {
        const s = (0, $63c47e8a587a7f36$export$2d1720544b23b823)(t.firestore);
        return function __PRIVATE_newQueryBoundFromFields(t, e, n, r, s, a) {
            // Use explicit order by's because it has to match the query the user made
            const o = t.explicitOrderBy;
            if (s.length > o.length) throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).INVALID_ARGUMENT, `Too many arguments provided to ${r}(). The number of arguments must be less than or equal to the number of orderBy() clauses`);
            const i = [];
            for(let a = 0; a < s.length; a++){
                const u = s[a];
                if (o[a].field.isKeyField()) {
                    if ("string" != typeof u) throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).INVALID_ARGUMENT, `Invalid query. Expected a string for document ID in ${r}(), but got a ${typeof u}`);
                    if (!(0, $63c47e8a587a7f36$export$3b14a55fb2447963)(t) && -1 !== u.indexOf("/")) throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).INVALID_ARGUMENT, `Invalid query. When querying a collection and ordering by documentId(), the value passed to ${r}() must be a plain document ID, but '${u}' contains a slash.`);
                    const n = t.path.child((0, $63c47e8a587a7f36$export$db202ddc8be9136).fromString(u));
                    if (!(0, $63c47e8a587a7f36$export$90a7f3efeed30595).isDocumentKey(n)) throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).INVALID_ARGUMENT, `Invalid query. When querying a collection group and ordering by documentId(), the value passed to ${r}() must result in a valid document path, but '${n}' is not because it contains an odd number of segments.`);
                    const s = new (0, $63c47e8a587a7f36$export$90a7f3efeed30595)(n);
                    i.push((0, $63c47e8a587a7f36$export$43caf9889c228507)(e, s));
                } else {
                    const t = (0, $63c47e8a587a7f36$export$39b482c5e57630a8)(n, r, u);
                    i.push(t);
                }
            }
            return new (0, $63c47e8a587a7f36$export$625550452a3fa3ec)(i, a);
        }(t._query, t.firestore._databaseId, s, e, n, r);
    }
}
function $811ad1659062a8d4$var$__PRIVATE_parseDocumentIdValue(t, e, n) {
    if ("string" == typeof (n = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(n))) {
        if ("" === n) throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid document ID, but it was an empty string.");
        if (!(0, $63c47e8a587a7f36$export$3b14a55fb2447963)(e) && -1 !== n.indexOf("/")) throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).INVALID_ARGUMENT, `Invalid query. When querying a collection by documentId(), you must provide a plain document ID, but '${n}' contains a '/' character.`);
        const r = e.path.child((0, $63c47e8a587a7f36$export$db202ddc8be9136).fromString(n));
        if (!(0, $63c47e8a587a7f36$export$90a7f3efeed30595).isDocumentKey(r)) throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).INVALID_ARGUMENT, `Invalid query. When querying a collection group by documentId(), the value provided must result in a valid document path, but '${r}' is not because it has an odd number of segments (${r.length}).`);
        return (0, $63c47e8a587a7f36$export$43caf9889c228507)(t, new (0, $63c47e8a587a7f36$export$90a7f3efeed30595)(r));
    }
    if (n instanceof (0, $63c47e8a587a7f36$export$96f57966bedc81b4)) return (0, $63c47e8a587a7f36$export$43caf9889c228507)(t, n._key);
    throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).INVALID_ARGUMENT, `Invalid query. When querying with documentId(), you must provide a valid string or a DocumentReference, but it was: ${(0, $63c47e8a587a7f36$export$efccba1c4a2ef57b)(n)}.`);
}
/**
 * Validates that the value passed into a disjunctive filter satisfies all
 * array requirements.
 */ function $811ad1659062a8d4$var$__PRIVATE_validateDisjunctiveFilterElements(t, e) {
    if (!Array.isArray(t) || 0 === t.length) throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).INVALID_ARGUMENT, `Invalid Query. A non-empty array is required for '${e.toString()}' filters.`);
}
/**
 * Given an operator, returns the set of operators that cannot be used with it.
 *
 * This is not a comprehensive check, and this function should be removed in the
 * long term. Validations should occur in the Firestore backend.
 *
 * Operators in a query must adhere to the following set of rules:
 * 1. Only one inequality per query.
 * 2. `NOT_IN` cannot be used with array, disjunctive, or `NOT_EQUAL` operators.
 */ function $811ad1659062a8d4$var$__PRIVATE_validateNewFieldFilter(t, e) {
    const n = function __PRIVATE_findOpInsideFilters(t, e) {
        for (const n of t)for (const t of n.getFlattenedFilters())if (e.indexOf(t.op) >= 0) return t.op;
        return null;
    }(t.filters, function __PRIVATE_conflictingOps(t) {
        switch(t){
            case "!=" /* Operator.NOT_EQUAL */ :
                return [
                    "!=" /* Operator.NOT_EQUAL */ ,
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
            case "in" /* Operator.IN */ :
                return [
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "not-in" /* Operator.NOT_IN */ :
                return [
                    "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ,
                    "in" /* Operator.IN */ ,
                    "not-in" /* Operator.NOT_IN */ ,
                    "!=" /* Operator.NOT_EQUAL */ 
                ];
            default:
                return [];
        }
    }(e.op));
    if (null !== n) // Special case when it's a duplicate op to give a slightly clearer error message.
    throw n === e.op ? new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).INVALID_ARGUMENT, `Invalid query. You cannot use more than one '${e.op.toString()}' filter.`) : new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).INVALID_ARGUMENT, `Invalid query. You cannot use '${e.op.toString()}' filters with '${n.toString()}' filters.`);
}
function $811ad1659062a8d4$var$__PRIVATE_validateQueryFilterConstraint(t, e) {
    if (!(e instanceof $811ad1659062a8d4$export$f765fc5789dfd439 || e instanceof $811ad1659062a8d4$export$6bbc7aef0717f3d2)) throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).INVALID_ARGUMENT, `Function ${t}() requires AppliableConstraints created with a call to 'where(...)', 'or(...)', or 'and(...)'.`);
}
function $811ad1659062a8d4$var$__PRIVATE_applyFirestoreDataConverter(t, e, n) {
    let r;
    // Cast to `any` in order to satisfy the union type constraint on
    // toFirestore().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return r = t ? n && (n.merge || n.mergeFields) ? t.toFirestore(e, n) : t.toFirestore(e) : e, r;
}
class $811ad1659062a8d4$var$__PRIVATE_LiteUserDataWriter extends (0, $63c47e8a587a7f36$export$ebd11618f299a286) {
    constructor(t){
        super(), this.firestore = t;
    }
    convertBytes(t) {
        return new (0, $63c47e8a587a7f36$export$ef35774e6d314e91)(t);
    }
    convertReference(t) {
        const e = this.convertDocumentKey(t, this.firestore._databaseId);
        return new (0, $63c47e8a587a7f36$export$96f57966bedc81b4)(this.firestore, /* converter= */ null, e);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Create an AggregateField object that can be used to compute the sum of
 * a specified field over a range of documents in the result set of a query.
 * @param field - Specifies the field to sum across the result set.
 */ function $811ad1659062a8d4$export$8a63f25cc62965f1(t) {
    return new $811ad1659062a8d4$export$fada2345be8928cf("sum", (0, $63c47e8a587a7f36$export$23f2a1d2818174ef)("sum", t));
}
/**
 * Create an AggregateField object that can be used to compute the average of
 * a specified field over a range of documents in the result set of a query.
 * @param field - Specifies the field to average across the result set.
 */ function $811ad1659062a8d4$export$cc6710ee5f037d57(t) {
    return new $811ad1659062a8d4$export$fada2345be8928cf("avg", (0, $63c47e8a587a7f36$export$23f2a1d2818174ef)("average", t));
}
/**
 * Create an AggregateField object that can be used to compute the count of
 * documents in the result set of a query.
 */ function $811ad1659062a8d4$export$85b9a36db797e02b() {
    return new $811ad1659062a8d4$export$fada2345be8928cf("count");
}
/**
 * Compares two 'AggregateField` instances for equality.
 *
 * @param left - Compare this AggregateField to the `right`.
 * @param right - Compare this AggregateField to the `left`.
 */ function $811ad1659062a8d4$export$31fa8ec66e0239ad(t, e) {
    return t instanceof $811ad1659062a8d4$export$fada2345be8928cf && e instanceof $811ad1659062a8d4$export$fada2345be8928cf && t.aggregateType === e.aggregateType && t._internalFieldPath?.canonicalString() === e._internalFieldPath?.canonicalString();
}
/**
 * Compares two `AggregateQuerySnapshot` instances for equality.
 *
 * Two `AggregateQuerySnapshot` instances are considered "equal" if they have
 * underlying queries that compare equal, and the same data.
 *
 * @param left - The first `AggregateQuerySnapshot` to compare.
 * @param right - The second `AggregateQuerySnapshot` to compare.
 *
 * @returns `true` if the objects are "equal", as defined above, or `false`
 * otherwise.
 */ function $811ad1659062a8d4$export$104f59389a332076(t, e) {
    return (0, $63c47e8a587a7f36$export$d141bba7fdc215a3)(t.query, e.query) && (0, $3117f6f4eeb4c314$export$9cb4719e2e525b7a)(t.data(), e.data());
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the number of documents in the result set of the given query
 * without actually downloading the documents.
 *
 * Using this function to count the documents is efficient because only the
 * final count, not the documents' data, is downloaded. This function can
 * count the documents in cases where the result set is prohibitively large to
 * download entirely (thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used. Every invocation of this function necessarily involves a round trip to
 * the server.
 *
 * @param query - The query whose result set size is calculated.
 * @returns A Promise that will be resolved with the count; the count can be
 * retrieved from `snapshot.data().count`, where `snapshot` is the
 * `AggregateQuerySnapshot` to which the returned Promise resolves.
 */ function $811ad1659062a8d4$export$b1de1b12889d0afb(t) {
    return $811ad1659062a8d4$export$a51511de2fae49b3(t, {
        count: $811ad1659062a8d4$export$85b9a36db797e02b()
    });
}
/**
 * Calculates the specified aggregations over the documents in the result
 * set of the given query without actually downloading the documents.
 *
 * Using this function to perform aggregations is efficient because only the
 * final aggregation values, not the documents' data, are downloaded. This
 * function can perform aggregations of the documents in cases where the result
 * set is prohibitively large to download entirely (thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used. Every invocation of this function necessarily involves a round trip to
 * the server.
 *
 * @param query - The query whose result set is aggregated over.
 * @param aggregateSpec - An `AggregateSpec` object that specifies the aggregates
 * to perform over the result set. The AggregateSpec specifies aliases for each
 * aggregate, which can be used to retrieve the aggregate result.
 * @example
 * ```typescript
 * const aggregateSnapshot = await getAggregateFromServer(query, {
 *   countOfDocs: count(),
 *   totalHours: sum('hours'),
 *   averageScore: average('score')
 * });
 *
 * const countOfDocs: number = aggregateSnapshot.data().countOfDocs;
 * const totalHours: number = aggregateSnapshot.data().totalHours;
 * const averageScore: number | null = aggregateSnapshot.data().averageScore;
 * ```
 */ function $811ad1659062a8d4$export$a51511de2fae49b3(t, e) {
    const n = (0, $63c47e8a587a7f36$export$4a5767248b18ef41)(t.firestore, (0, $63c47e8a587a7f36$export$d66501df72047452)), r = (0, $63c47e8a587a7f36$export$df995fae86a55f06)(n), s = (0, $63c47e8a587a7f36$export$a9c23c6ac3fc3eca)(e, (t, e)=>new (0, $63c47e8a587a7f36$export$7a38258bbe170828)(e, t.aggregateType, t._internalFieldPath));
    // Run the aggregation and convert the results
    return (0, $63c47e8a587a7f36$export$2329c99376c9d0a4)(r, t._query, s).then((e)=>/**
 * Converts the core aggregation result to an `AggregateQuerySnapshot`
 * that can be returned to the consumer.
 * @param query
 * @param aggregateResult - Core aggregation result
 * @internal
 */ (function __PRIVATE_convertToAggregateQuerySnapshot(t, e, n) {
            const r = new (0, $63c47e8a587a7f36$export$7f8ddf7c7c20b3cd)(t), s = new $811ad1659062a8d4$export$40257fef64be808b(e, r, n);
            return s;
        })(n, t, e));
}
class $811ad1659062a8d4$var$__PRIVATE_MemoryLocalCacheImpl {
    constructor(t){
        this.kind = "memory", this._onlineComponentProvider = (0, $63c47e8a587a7f36$export$2f6ca3d3b1f80bf5).provider, this._offlineComponentProvider = t?.garbageCollector ? t.garbageCollector._offlineComponentProvider : {
            build: ()=>new (0, $63c47e8a587a7f36$export$8a5498727ef6be21)(void 0)
        };
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $811ad1659062a8d4$var$__PRIVATE_PersistentLocalCacheImpl {
    constructor(t){
        let e;
        this.kind = "persistent", t?.tabManager ? (t.tabManager._initialize(t), e = t.tabManager) : (e = $811ad1659062a8d4$export$d5f96a3c009e86ac(void 0), e._initialize(t)), this._onlineComponentProvider = e._onlineComponentProvider, this._offlineComponentProvider = e._offlineComponentProvider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $811ad1659062a8d4$var$__PRIVATE_MemoryEagerGarbageCollectorImpl {
    constructor(){
        this.kind = "memoryEager", this._offlineComponentProvider = (0, $63c47e8a587a7f36$export$d24c54395ce0c509).provider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $811ad1659062a8d4$var$__PRIVATE_MemoryLruGarbageCollectorImpl {
    constructor(t){
        this.kind = "memoryLru", this._offlineComponentProvider = {
            build: ()=>new (0, $63c47e8a587a7f36$export$8a5498727ef6be21)(t)
        };
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
/**
 * Creates an instance of `MemoryEagerGarbageCollector`. This is also the
 * default garbage collector unless it is explicitly specified otherwise.
 */ function $811ad1659062a8d4$export$574728f3be606189() {
    return new $811ad1659062a8d4$var$__PRIVATE_MemoryEagerGarbageCollectorImpl;
}
/**
 * Creates an instance of `MemoryLruGarbageCollector`.
 *
 * A target size can be specified as part of the setting parameter. The
 * collector will start deleting documents once the cache size exceeds
 * the given size. The default cache size is 40MB (40 * 1024 * 1024 bytes).
 */ function $811ad1659062a8d4$export$2340f88905cc0c23(t) {
    return new $811ad1659062a8d4$var$__PRIVATE_MemoryLruGarbageCollectorImpl(t?.cacheSizeBytes);
}
/**
 * Creates an instance of `MemoryLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 */ function $811ad1659062a8d4$export$72ef71adb739a32c(t) {
    return new $811ad1659062a8d4$var$__PRIVATE_MemoryLocalCacheImpl(t);
}
/**
 * Creates an instance of `PersistentLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 *
 * Persistent cache cannot be used in a Node.js environment.
 */ function $811ad1659062a8d4$export$51b321e43d5331d5(t) {
    return new $811ad1659062a8d4$var$__PRIVATE_PersistentLocalCacheImpl(t);
}
class $811ad1659062a8d4$var$__PRIVATE_SingleTabManagerImpl {
    constructor(t){
        this.forceOwnership = t, this.kind = "persistentSingleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(t) {
        this._onlineComponentProvider = (0, $63c47e8a587a7f36$export$2f6ca3d3b1f80bf5).provider, this._offlineComponentProvider = {
            build: (e)=>new (0, $63c47e8a587a7f36$export$6554612db691658e)(e, t?.cacheSizeBytes, this.forceOwnership)
        };
    }
}
class $811ad1659062a8d4$var$__PRIVATE_MultiTabManagerImpl {
    constructor(){
        this.kind = "PersistentMultipleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(t) {
        this._onlineComponentProvider = (0, $63c47e8a587a7f36$export$2f6ca3d3b1f80bf5).provider, this._offlineComponentProvider = {
            build: (e)=>new (0, $63c47e8a587a7f36$export$493d36ec626b6698)(e, t?.cacheSizeBytes)
        };
    }
}
/**
 * Creates an instance of `PersistentSingleTabManager`.
 *
 * @param settings - Configures the created tab manager.
 */ function $811ad1659062a8d4$export$d5f96a3c009e86ac(t) {
    return new $811ad1659062a8d4$var$__PRIVATE_SingleTabManagerImpl(t?.forceOwnership);
}
/**
 * Creates an instance of `PersistentMultipleTabManager`.
 */ function $811ad1659062a8d4$export$57e9d290b0b4dc04() {
    return new $811ad1659062a8d4$var$__PRIVATE_MultiTabManagerImpl;
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $811ad1659062a8d4$var$zt = "NOT SUPPORTED";
/**
 * Metadata about a snapshot, describing the state of the snapshot.
 */ class $811ad1659062a8d4$export$99d61448206ab5cd {
    /** @hideconstructor */ constructor(t, e){
        this.hasPendingWrites = t, this.fromCache = e;
    }
    /**
     * Returns true if this `SnapshotMetadata` is equal to the provided one.
     *
     * @param other - The `SnapshotMetadata` to compare against.
     * @returns true if this `SnapshotMetadata` is equal to the provided one.
     */ isEqual(t) {
        return this.hasPendingWrites === t.hasPendingWrites && this.fromCache === t.fromCache;
    }
}
/**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $811ad1659062a8d4$export$acab0e6ef25eb301 extends $811ad1659062a8d4$var$DocumentSnapshot$1 {
    /** @hideconstructor protected */ constructor(t, e, n, r, s, a){
        super(t, e, n, r, a), this._firestore = t, this._firestoreImpl = t, this.metadata = s;
    }
    /**
     * Returns whether or not the data exists. True if the document exists.
     */ exists() {
        return super.exists();
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document or `undefined` if
     * the document doesn't exist.
     */ data(t = {}) {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const e = new $811ad1659062a8d4$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, this._key, this._document, this.metadata, /* converter= */ null);
                return this._converter.fromFirestore(e, t);
            }
            return this._userDataWriter.convertValue(this._document.data.value, t.serverTimestamps);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * By default, a `serverTimestamp()` that has not yet been set to
     * its final value will be returned as `null`. You can override this by
     * passing an options object.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @param options - An options object to configure how the field is retrieved
     * from the snapshot (for example the desired behavior for server timestamps
     * that have not yet been set to their final value).
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(t, e = {}) {
        if (this._document) {
            const n = this._document.data.field((0, $63c47e8a587a7f36$export$23f2a1d2818174ef)("DocumentSnapshot.get", t));
            if (null !== n) return this._userDataWriter.convertValue(n, e.serverTimestamps);
        }
    }
    /**
     * Returns a JSON-serializable representation of this `DocumentSnapshot` instance.
     *
     * @returns a JSON representation of this object.  Throws a {@link FirestoreError} if this
     * `DocumentSnapshot` has pending writes.
     */ toJSON() {
        if (this.metadata.hasPendingWrites) throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).FAILED_PRECONDITION, "DocumentSnapshot.toJSON() attempted to serialize a document with pending writes. Await waitForPendingWrites() before invoking toJSON().");
        const t = this._document, e = {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (e.type = $811ad1659062a8d4$export$acab0e6ef25eb301._jsonSchemaVersion, e.bundle = "", e.bundleSource = "DocumentSnapshot", e.bundleName = this._key.toString(), !t || !t.isValidDocument() || !t.isFoundDocument()) return e;
        this._userDataWriter.convertObjectMap(t.data.value.mapValue.fields, "previous");
        return e.bundle = (this._firestore, this.ref.path, "NOT SUPPORTED"), e;
    }
}
function $811ad1659062a8d4$export$bbac1bdeb8972634(t, e, n) {
    if ((0, $63c47e8a587a7f36$export$9bb611d729802a56)(e, $811ad1659062a8d4$export$acab0e6ef25eb301._jsonSchema)) {
        if (e.bundle === $811ad1659062a8d4$var$zt) throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).INVALID_ARGUMENT, "The provided JSON object was created in a client environment, which is not supported.");
        // Parse the bundle data.
        const r = (0, $63c47e8a587a7f36$export$b4171a6734a65d42)(t._databaseId), s = (0, $63c47e8a587a7f36$export$3466f893ebf79586)(e.bundle, r), a = s.t(), o = new (0, $63c47e8a587a7f36$export$61196ced6d74a310)(s.getMetadata(), r);
        for (const t of a)o.o(t);
        // Ensure that we have the correct number of documents in the bundle.
        const i = o.documents;
        if (1 !== i.length) throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).INVALID_ARGUMENT, `Expected bundle data to contain 1 document, but it contains ${i.length} documents.`);
        // Build out the internal document data.
        const u = (0, $63c47e8a587a7f36$export$3a1a48c8f6ef640e)(r, i[0].document), c = new (0, $63c47e8a587a7f36$export$90a7f3efeed30595)((0, $63c47e8a587a7f36$export$db202ddc8be9136).fromString(e.bundleName));
        // Return the external facing DocumentSnapshot.
        return new $811ad1659062a8d4$export$acab0e6ef25eb301(t, new $811ad1659062a8d4$var$__PRIVATE_LiteUserDataWriter(t), c, u, new $811ad1659062a8d4$export$99d61448206ab5cd(/* hasPendingWrites= */ !1, /* fromCache= */ !1), n || null);
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ $811ad1659062a8d4$export$acab0e6ef25eb301._jsonSchemaVersion = "firestore/documentSnapshot/1.0", $811ad1659062a8d4$export$acab0e6ef25eb301._jsonSchema = {
    type: (0, $63c47e8a587a7f36$export$ffb5f4729a158638)("string", $811ad1659062a8d4$export$acab0e6ef25eb301._jsonSchemaVersion),
    bundleSource: (0, $63c47e8a587a7f36$export$ffb5f4729a158638)("string", "DocumentSnapshot"),
    bundleName: (0, $63c47e8a587a7f36$export$ffb5f4729a158638)("string"),
    bundle: (0, $63c47e8a587a7f36$export$ffb5f4729a158638)("string")
};
class $811ad1659062a8d4$export$6d4d04e42af6b03c extends $811ad1659062a8d4$export$acab0e6ef25eb301 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @override
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document.
     */ data(t = {}) {
        return super.data(t);
    }
}
/**
 * A `QuerySnapshot` contains zero or more `DocumentSnapshot` objects
 * representing the results of a query. The documents can be accessed as an
 * array via the `docs` property or enumerated using the `forEach` method. The
 * number of documents can be determined via the `empty` and `size`
 * properties.
 */ class $811ad1659062a8d4$export$8f21149d8133945c {
    /** @hideconstructor */ constructor(t, e, n, r){
        this._firestore = t, this._userDataWriter = e, this._snapshot = r, this.metadata = new $811ad1659062a8d4$export$99d61448206ab5cd(r.hasPendingWrites, r.fromCache), this.query = n;
    }
    /** An array of all the documents in the `QuerySnapshot`. */ get docs() {
        const t = [];
        return this.forEach((e)=>t.push(e)), t;
    }
    /** The number of documents in the `QuerySnapshot`. */ get size() {
        return this._snapshot.docs.size;
    }
    /** True if there are no documents in the `QuerySnapshot`. */ get empty() {
        return 0 === this.size;
    }
    /**
     * Enumerates all of the documents in the `QuerySnapshot`.
     *
     * @param callback - A callback to be called with a `QueryDocumentSnapshot` for
     * each document in the snapshot.
     * @param thisArg - The `this` binding for the callback.
     */ forEach(t, e) {
        this._snapshot.docs.forEach((n)=>{
            t.call(e, new $811ad1659062a8d4$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, n.key, n, new $811ad1659062a8d4$export$99d61448206ab5cd(this._snapshot.mutatedKeys.has(n.key), this._snapshot.fromCache), this.query.converter));
        });
    }
    /**
     * Returns an array of the documents changes since the last snapshot. If this
     * is the first snapshot, all documents will be in the list as 'added'
     * changes.
     *
     * @param options - `SnapshotListenOptions` that control whether metadata-only
     * changes (i.e. only `DocumentSnapshot.metadata` changed) should trigger
     * snapshot events.
     */ docChanges(t = {}) {
        const e = !!t.includeMetadataChanges;
        if (e && this._snapshot.excludesMetadataChanges) throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
        return this._cachedChanges && this._cachedChangesIncludeMetadataChanges === e || (this._cachedChanges = /** Calculates the array of `DocumentChange`s for a given `ViewSnapshot`. */ function __PRIVATE_changesFromSnapshot(t, e) {
            if (t._snapshot.oldDocs.isEmpty()) {
                let e = 0;
                return t._snapshot.docChanges.map((n)=>{
                    const r = new $811ad1659062a8d4$export$6d4d04e42af6b03c(t._firestore, t._userDataWriter, n.doc.key, n.doc, new $811ad1659062a8d4$export$99d61448206ab5cd(t._snapshot.mutatedKeys.has(n.doc.key), t._snapshot.fromCache), t.query.converter);
                    return n.doc, {
                        type: "added",
                        doc: r,
                        oldIndex: -1,
                        newIndex: e++
                    };
                });
            }
            {
                // A `DocumentSet` that is updated incrementally as changes are applied to use
                // to lookup the index of a document.
                let n = t._snapshot.oldDocs;
                return t._snapshot.docChanges.filter((t)=>e || 3 /* ChangeType.Metadata */  !== t.type).map((e)=>{
                    const r = new $811ad1659062a8d4$export$6d4d04e42af6b03c(t._firestore, t._userDataWriter, e.doc.key, e.doc, new $811ad1659062a8d4$export$99d61448206ab5cd(t._snapshot.mutatedKeys.has(e.doc.key), t._snapshot.fromCache), t.query.converter);
                    let s = -1, a = -1;
                    return 0 /* ChangeType.Added */  !== e.type && (s = n.indexOf(e.doc.key), n = n.delete(e.doc.key)), 1 /* ChangeType.Removed */  !== e.type && (n = n.add(e.doc), a = n.indexOf(e.doc.key)), {
                        type: $811ad1659062a8d4$var$__PRIVATE_resultChangeType(e.type),
                        doc: r,
                        oldIndex: s,
                        newIndex: a
                    };
                });
            }
        }(this, e), this._cachedChangesIncludeMetadataChanges = e), this._cachedChanges;
    }
    /**
     * Returns a JSON-serializable representation of this `QuerySnapshot` instance.
     *
     * @returns a JSON representation of this object. Throws a {@link FirestoreError} if this
     * `QuerySnapshot` has pending writes.
     */ toJSON() {
        if (this.metadata.hasPendingWrites) throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).FAILED_PRECONDITION, "QuerySnapshot.toJSON() attempted to serialize a document with pending writes. Await waitForPendingWrites() before invoking toJSON().");
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const t = {};
        t.type = $811ad1659062a8d4$export$8f21149d8133945c._jsonSchemaVersion, t.bundleSource = "QuerySnapshot", t.bundleName = (0, $63c47e8a587a7f36$export$a07804094c3ecf2d).newId(), this._firestore._databaseId.database, this._firestore._databaseId.projectId;
        const e = [], n = [], r = [];
        return this.docs.forEach((t)=>{
            null !== t._document && (e.push(t._document), n.push(this._userDataWriter.convertObjectMap(t._document.data.value.mapValue.fields, "previous")), r.push(t.ref.path));
        }), t.bundle = (this._firestore, this.query._query, t.bundleName, "NOT SUPPORTED"), t;
    }
}
function $811ad1659062a8d4$export$5bed7af38da9d026(t, e, n) {
    if ((0, $63c47e8a587a7f36$export$9bb611d729802a56)(e, $811ad1659062a8d4$export$8f21149d8133945c._jsonSchema)) {
        if (e.bundle === $811ad1659062a8d4$var$zt) throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).INVALID_ARGUMENT, "The provided JSON object was created in a client environment, which is not supported.");
        // Parse the bundle data.
        const r = (0, $63c47e8a587a7f36$export$b4171a6734a65d42)(t._databaseId), s = (0, $63c47e8a587a7f36$export$3466f893ebf79586)(e.bundle, r), a = s.t(), o = new (0, $63c47e8a587a7f36$export$61196ced6d74a310)(s.getMetadata(), r);
        for (const t of a)o.o(t);
        if (1 !== o.queries.length) throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).INVALID_ARGUMENT, `Snapshot data expected 1 query but found ${o.queries.length} queries.`);
        // Create an internal Query object from the named query in the bundle.
        const i = (0, $63c47e8a587a7f36$export$56c0d5a1e737357d)(o.queries[0].bundledQuery), u = o.documents;
        // Construct the arrays of document data for the query.
        let c = new (0, $63c47e8a587a7f36$export$25ce5a424b770e84);
        u.map((t)=>{
            const e = (0, $63c47e8a587a7f36$export$3a1a48c8f6ef640e)(r, t.document);
            c = c.add(e);
        });
        // Create a view snapshot of the query and documents.
        const l = (0, $63c47e8a587a7f36$export$e7c866399fa523f5).fromInitialDocuments(i, c, (0, $63c47e8a587a7f36$export$971d5caa766a69d7)(), /* fromCache= */ !1, /* hasCachedResults= */ !1), h = new (0, $63c47e8a587a7f36$export$3722cfe417b6ed86)(t, n || null, i);
        // Create an external Query object, required to construct the QuerySnapshot.
        // Return a new QuerySnapshot with all of the collected data.
        return new $811ad1659062a8d4$export$8f21149d8133945c(t, new $811ad1659062a8d4$var$__PRIVATE_LiteUserDataWriter(t), h, l);
    }
}
function $811ad1659062a8d4$var$__PRIVATE_resultChangeType(t) {
    switch(t){
        case 0 /* ChangeType.Added */ :
            return "added";
        case 2 /* ChangeType.Modified */ :
        case 3 /* ChangeType.Metadata */ :
            return "modified";
        case 1 /* ChangeType.Removed */ :
            return "removed";
        default:
            return (0, $63c47e8a587a7f36$export$3a6d5c9ae78a2c08)(61501, {
                type: t
            });
    }
}
// TODO(firestoreexp): Add tests for snapshotEqual with different snapshot
// metadata
/**
 * Returns true if the provided snapshots are equal.
 *
 * @param left - A snapshot to compare.
 * @param right - A snapshot to compare.
 * @returns true if the snapshots are equal.
 */ function $811ad1659062a8d4$export$f243a5d948512846(t, e) {
    return t instanceof $811ad1659062a8d4$export$acab0e6ef25eb301 && e instanceof $811ad1659062a8d4$export$acab0e6ef25eb301 ? t._firestore === e._firestore && t._key.isEqual(e._key) && (null === t._document ? null === e._document : t._document.isEqual(e._document)) && t._converter === e._converter : t instanceof $811ad1659062a8d4$export$8f21149d8133945c && e instanceof $811ad1659062a8d4$export$8f21149d8133945c && t._firestore === e._firestore && (0, $63c47e8a587a7f36$export$d141bba7fdc215a3)(t.query, e.query) && t.metadata.isEqual(e.metadata) && t._snapshot.isEqual(e._snapshot);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $811ad1659062a8d4$export$8f21149d8133945c._jsonSchemaVersion = "firestore/querySnapshot/1.0", $811ad1659062a8d4$export$8f21149d8133945c._jsonSchema = {
    type: (0, $63c47e8a587a7f36$export$ffb5f4729a158638)("string", $811ad1659062a8d4$export$8f21149d8133945c._jsonSchemaVersion),
    bundleSource: (0, $63c47e8a587a7f36$export$ffb5f4729a158638)("string", "QuerySnapshot"),
    bundleName: (0, $63c47e8a587a7f36$export$ffb5f4729a158638)("string"),
    bundle: (0, $63c47e8a587a7f36$export$ffb5f4729a158638)("string")
};
const $811ad1659062a8d4$var$Yt = {
    maxAttempts: 5
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A write batch, used to perform multiple writes as a single atomic unit.
 *
 * A `WriteBatch` object can be acquired by calling {@link writeBatch}. It
 * provides methods for adding writes to the write batch. None of the writes
 * will be committed (or visible locally) until {@link WriteBatch.commit} is
 * called.
 */ class $811ad1659062a8d4$export$d94ed661b1cfd435 {
    /** @hideconstructor */ constructor(t, e){
        this._firestore = t, this._commitHandler = e, this._mutations = [], this._committed = !1, this._dataReader = (0, $63c47e8a587a7f36$export$2d1720544b23b823)(t);
    }
    set(t, e, n) {
        this._verifyNotCommitted();
        const r = $811ad1659062a8d4$var$__PRIVATE_validateReference(t, this._firestore), s = $811ad1659062a8d4$var$__PRIVATE_applyFirestoreDataConverter(r.converter, e, n), a = (0, $63c47e8a587a7f36$export$71cec2538cb2c617)(this._dataReader, "WriteBatch.set", r._key, s, null !== r.converter, n);
        return this._mutations.push(a.toMutation(r._key, (0, $63c47e8a587a7f36$export$78acf4525d8a74c4).none())), this;
    }
    update(t, e, n, ...r) {
        this._verifyNotCommitted();
        const s = $811ad1659062a8d4$var$__PRIVATE_validateReference(t, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let a;
        return a = "string" == typeof (e = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(e)) || e instanceof (0, $63c47e8a587a7f36$export$8743009a87fcb00f) ? (0, $63c47e8a587a7f36$export$dc98b0b04f4c7758)(this._dataReader, "WriteBatch.update", s._key, e, n, r) : (0, $63c47e8a587a7f36$export$3d8c2f653ac9d0b9)(this._dataReader, "WriteBatch.update", s._key, e), this._mutations.push(a.toMutation(s._key, (0, $63c47e8a587a7f36$export$78acf4525d8a74c4).exists(!0))), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `WriteBatch` instance. Used for chaining method calls.
     */ delete(t) {
        this._verifyNotCommitted();
        const e = $811ad1659062a8d4$var$__PRIVATE_validateReference(t, this._firestore);
        return this._mutations = this._mutations.concat(new (0, $63c47e8a587a7f36$export$34aec0b863436764)(e._key, (0, $63c47e8a587a7f36$export$78acf4525d8a74c4).none())), this;
    }
    /**
     * Commits all of the writes in this write batch as a single atomic unit.
     *
     * The result of these writes will only be reflected in document reads that
     * occur after the returned promise resolves. If the client is offline, the
     * write fails. If you would like to see local modifications or buffer writes
     * until the client is online, use the full Firestore SDK.
     *
     * @returns A `Promise` resolved once all of the writes in the batch have been
     * successfully written to the backend as an atomic unit (note that it won't
     * resolve while you're offline).
     */ commit() {
        return this._verifyNotCommitted(), this._committed = !0, this._mutations.length > 0 ? this._commitHandler(this._mutations) : Promise.resolve();
    }
    _verifyNotCommitted() {
        if (this._committed) throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).FAILED_PRECONDITION, "A write batch can no longer be used after commit() has been called.");
    }
}
function $811ad1659062a8d4$var$__PRIVATE_validateReference(t, e) {
    if ((t = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(t)).firestore !== e) throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).INVALID_ARGUMENT, "Provided document reference is from a different Firestore instance.");
    return t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO(mrschmidt) Consider using `BaseTransaction` as the base class in the
// legacy SDK.
/**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ class $811ad1659062a8d4$var$Transaction$1 {
    /** @hideconstructor */ constructor(t, e){
        this._firestore = t, this._transaction = e, this._dataReader = (0, $63c47e8a587a7f36$export$2d1720544b23b823)(t);
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(t) {
        const e = $811ad1659062a8d4$var$__PRIVATE_validateReference(t, this._firestore), n = new $811ad1659062a8d4$var$__PRIVATE_LiteUserDataWriter(this._firestore);
        return this._transaction.lookup([
            e._key
        ]).then((t)=>{
            if (!t || 1 !== t.length) return (0, $63c47e8a587a7f36$export$3a6d5c9ae78a2c08)(24041);
            const r = t[0];
            if (r.isFoundDocument()) return new $811ad1659062a8d4$var$DocumentSnapshot$1(this._firestore, n, r.key, r, e.converter);
            if (r.isNoDocument()) return new $811ad1659062a8d4$var$DocumentSnapshot$1(this._firestore, n, e._key, null, e.converter);
            throw (0, $63c47e8a587a7f36$export$3a6d5c9ae78a2c08)(18433, {
                doc: r
            });
        });
    }
    set(t, e, n) {
        const r = $811ad1659062a8d4$var$__PRIVATE_validateReference(t, this._firestore), s = $811ad1659062a8d4$var$__PRIVATE_applyFirestoreDataConverter(r.converter, e, n), a = (0, $63c47e8a587a7f36$export$71cec2538cb2c617)(this._dataReader, "Transaction.set", r._key, s, null !== r.converter, n);
        return this._transaction.set(r._key, a), this;
    }
    update(t, e, n, ...r) {
        const s = $811ad1659062a8d4$var$__PRIVATE_validateReference(t, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let a;
        return a = "string" == typeof (e = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(e)) || e instanceof (0, $63c47e8a587a7f36$export$8743009a87fcb00f) ? (0, $63c47e8a587a7f36$export$dc98b0b04f4c7758)(this._dataReader, "Transaction.update", s._key, e, n, r) : (0, $63c47e8a587a7f36$export$3d8c2f653ac9d0b9)(this._dataReader, "Transaction.update", s._key, e), this._transaction.update(s._key, a), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `Transaction` instance. Used for chaining method calls.
     */ delete(t) {
        const e = $811ad1659062a8d4$var$__PRIVATE_validateReference(t, this._firestore);
        return this._transaction.delete(e._key), this;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ class $811ad1659062a8d4$export$febc5573c75cefb0 extends $811ad1659062a8d4$var$Transaction$1 {
    // This class implements the same logic as the Transaction API in the Lite SDK
    // but is subclassed in order to return its own DocumentSnapshot types.
    /** @hideconstructor */ constructor(t, e){
        super(t, e), this._firestore = t;
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(t) {
        const e = $811ad1659062a8d4$var$__PRIVATE_validateReference(t, this._firestore), n = new (0, $63c47e8a587a7f36$export$7f8ddf7c7c20b3cd)(this._firestore);
        return super.get(t).then((t)=>new $811ad1659062a8d4$export$acab0e6ef25eb301(this._firestore, n, e._key, t._document, new $811ad1659062a8d4$export$99d61448206ab5cd(/* hasPendingWrites= */ !1, /* fromCache= */ !1), e.converter));
    }
}
/**
 * Executes the given `updateFunction` and then attempts to commit the changes
 * applied within the transaction. If any document read within the transaction
 * has changed, Cloud Firestore retries the `updateFunction`. If it fails to
 * commit after 5 attempts, the transaction fails.
 *
 * The maximum number of writes allowed in a single transaction is 500.
 *
 * @param firestore - A reference to the Firestore database to run this
 * transaction against.
 * @param updateFunction - The function to execute within the transaction
 * context.
 * @param options - An options object to configure maximum number of attempts to
 * commit.
 * @returns If the transaction completed successfully or was explicitly aborted
 * (the `updateFunction` returned a failed promise), the promise returned by the
 * `updateFunction `is returned here. Otherwise, if the transaction failed, a
 * rejected promise with the corresponding failure error is returned.
 */ function $811ad1659062a8d4$export$3c54e006bf9c93b7(t, e, n) {
    t = (0, $63c47e8a587a7f36$export$4a5767248b18ef41)(t, (0, $63c47e8a587a7f36$export$d66501df72047452));
    const r = {
        ...$811ad1659062a8d4$var$Yt,
        ...n
    };
    !function __PRIVATE_validateTransactionOptions(t) {
        if (t.maxAttempts < 1) throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).INVALID_ARGUMENT, "Max attempts must be at least 1");
    }(r);
    const s = (0, $63c47e8a587a7f36$export$df995fae86a55f06)(t);
    return (0, $63c47e8a587a7f36$export$3c2fa207a37baaea)(s, (n)=>e(new $811ad1659062a8d4$export$febc5573c75cefb0(t, n)), r);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Reads the document referred to by this `DocumentReference`.
 *
 * Note: `getDoc()` attempts to provide up-to-date data when possible by waiting
 * for data from the server, but it may return cached data or fail if you are
 * offline and the server cannot be reached. To specify this behavior, invoke
 * {@link getDocFromCache} or {@link getDocFromServer}.
 *
 * @param reference - The reference of the document to fetch.
 * @returns A Promise resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $811ad1659062a8d4$export$11eb3b5ef9574821(t) {
    t = (0, $63c47e8a587a7f36$export$4a5767248b18ef41)(t, (0, $63c47e8a587a7f36$export$96f57966bedc81b4));
    const e = (0, $63c47e8a587a7f36$export$4a5767248b18ef41)(t.firestore, (0, $63c47e8a587a7f36$export$d66501df72047452)), n = (0, $63c47e8a587a7f36$export$df995fae86a55f06)(e);
    return (0, $63c47e8a587a7f36$export$ce26c07117d59d6a)(n, t._key).then((n)=>$811ad1659062a8d4$var$__PRIVATE_convertToDocSnapshot(e, t, n));
}
/**
 * Reads the document referred to by this `DocumentReference` from cache.
 * Returns an error if the document is not currently cached.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $811ad1659062a8d4$export$a58bd92642f7fb58(t) {
    t = (0, $63c47e8a587a7f36$export$4a5767248b18ef41)(t, (0, $63c47e8a587a7f36$export$96f57966bedc81b4));
    const e = (0, $63c47e8a587a7f36$export$4a5767248b18ef41)(t.firestore, (0, $63c47e8a587a7f36$export$d66501df72047452)), n = (0, $63c47e8a587a7f36$export$df995fae86a55f06)(e), r = new (0, $63c47e8a587a7f36$export$7f8ddf7c7c20b3cd)(e);
    return (0, $63c47e8a587a7f36$export$6559d589eb85fbb6)(n, t._key).then((n)=>new $811ad1659062a8d4$export$acab0e6ef25eb301(e, r, t._key, n, new $811ad1659062a8d4$export$99d61448206ab5cd(null !== n && n.hasLocalMutations, /* fromCache= */ !0), t.converter));
}
/**
 * Reads the document referred to by this `DocumentReference` from the server.
 * Returns an error if the network is not available.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $811ad1659062a8d4$export$35dd759aed9686b4(t) {
    t = (0, $63c47e8a587a7f36$export$4a5767248b18ef41)(t, (0, $63c47e8a587a7f36$export$96f57966bedc81b4));
    const e = (0, $63c47e8a587a7f36$export$4a5767248b18ef41)(t.firestore, (0, $63c47e8a587a7f36$export$d66501df72047452)), n = (0, $63c47e8a587a7f36$export$df995fae86a55f06)(e);
    return (0, $63c47e8a587a7f36$export$ce26c07117d59d6a)(n, t._key, {
        source: "server"
    }).then((n)=>$811ad1659062a8d4$var$__PRIVATE_convertToDocSnapshot(e, t, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot`.
 *
 * Note: `getDocs()` attempts to provide up-to-date data when possible by
 * waiting for data from the server, but it may return cached data or fail if
 * you are offline and the server cannot be reached. To specify this behavior,
 * invoke {@link getDocsFromCache} or {@link getDocsFromServer}.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $811ad1659062a8d4$export$81d3477bd73c86ef(t) {
    t = (0, $63c47e8a587a7f36$export$4a5767248b18ef41)(t, (0, $63c47e8a587a7f36$export$3722cfe417b6ed86));
    const e = (0, $63c47e8a587a7f36$export$4a5767248b18ef41)(t.firestore, (0, $63c47e8a587a7f36$export$d66501df72047452)), n = (0, $63c47e8a587a7f36$export$df995fae86a55f06)(e), r = new (0, $63c47e8a587a7f36$export$7f8ddf7c7c20b3cd)(e);
    return $811ad1659062a8d4$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(t._query), (0, $63c47e8a587a7f36$export$efca4cbe5dd06740)(n, t._query).then((n)=>new $811ad1659062a8d4$export$8f21149d8133945c(e, r, t, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from cache.
 * Returns an empty result set if no documents matching the query are currently
 * cached.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $811ad1659062a8d4$export$3fd010f18eac1dd(t) {
    t = (0, $63c47e8a587a7f36$export$4a5767248b18ef41)(t, (0, $63c47e8a587a7f36$export$3722cfe417b6ed86));
    const e = (0, $63c47e8a587a7f36$export$4a5767248b18ef41)(t.firestore, (0, $63c47e8a587a7f36$export$d66501df72047452)), n = (0, $63c47e8a587a7f36$export$df995fae86a55f06)(e), r = new (0, $63c47e8a587a7f36$export$7f8ddf7c7c20b3cd)(e);
    return (0, $63c47e8a587a7f36$export$a8550f7dbe79f93a)(n, t._query).then((n)=>new $811ad1659062a8d4$export$8f21149d8133945c(e, r, t, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from the
 * server. Returns an error if the network is not available.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $811ad1659062a8d4$export$ec7d9e44f349c77b(t) {
    t = (0, $63c47e8a587a7f36$export$4a5767248b18ef41)(t, (0, $63c47e8a587a7f36$export$3722cfe417b6ed86));
    const e = (0, $63c47e8a587a7f36$export$4a5767248b18ef41)(t.firestore, (0, $63c47e8a587a7f36$export$d66501df72047452)), n = (0, $63c47e8a587a7f36$export$df995fae86a55f06)(e), r = new (0, $63c47e8a587a7f36$export$7f8ddf7c7c20b3cd)(e);
    return (0, $63c47e8a587a7f36$export$efca4cbe5dd06740)(n, t._query, {
        source: "server"
    }).then((n)=>new $811ad1659062a8d4$export$8f21149d8133945c(e, r, t, n));
}
function $811ad1659062a8d4$export$5ff77ddaff3c9e12(t, e, n) {
    t = (0, $63c47e8a587a7f36$export$4a5767248b18ef41)(t, (0, $63c47e8a587a7f36$export$96f57966bedc81b4));
    const r = (0, $63c47e8a587a7f36$export$4a5767248b18ef41)(t.firestore, (0, $63c47e8a587a7f36$export$d66501df72047452)), s = $811ad1659062a8d4$var$__PRIVATE_applyFirestoreDataConverter(t.converter, e, n), o = (0, $63c47e8a587a7f36$export$2d1720544b23b823)(r);
    return $811ad1659062a8d4$export$1945f8fec9dda613(r, [
        (0, $63c47e8a587a7f36$export$71cec2538cb2c617)(o, "setDoc", t._key, s, null !== t.converter, n).toMutation(t._key, (0, $63c47e8a587a7f36$export$78acf4525d8a74c4).none())
    ]);
}
function $811ad1659062a8d4$export$22d1fdd1e73faff2(t, e, n, ...r) {
    t = (0, $63c47e8a587a7f36$export$4a5767248b18ef41)(t, (0, $63c47e8a587a7f36$export$96f57966bedc81b4));
    const s = (0, $63c47e8a587a7f36$export$4a5767248b18ef41)(t.firestore, (0, $63c47e8a587a7f36$export$d66501df72047452)), o = (0, $63c47e8a587a7f36$export$2d1720544b23b823)(s);
    let i;
    i = "string" == typeof // For Compat types, we have to "extract" the underlying types before
    // performing validation.
    (e = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(e)) || e instanceof (0, $63c47e8a587a7f36$export$8743009a87fcb00f) ? (0, $63c47e8a587a7f36$export$dc98b0b04f4c7758)(o, "updateDoc", t._key, e, n, r) : (0, $63c47e8a587a7f36$export$3d8c2f653ac9d0b9)(o, "updateDoc", t._key, e);
    return $811ad1659062a8d4$export$1945f8fec9dda613(s, [
        i.toMutation(t._key, (0, $63c47e8a587a7f36$export$78acf4525d8a74c4).exists(!0))
    ]);
}
/**
 * Deletes the document referred to by the specified `DocumentReference`.
 *
 * @param reference - A reference to the document to delete.
 * @returns A Promise resolved once the document has been successfully
 * deleted from the backend (note that it won't resolve while you're offline).
 */ function $811ad1659062a8d4$export$a4f20481fae8f78b(t) {
    return $811ad1659062a8d4$export$1945f8fec9dda613((0, $63c47e8a587a7f36$export$4a5767248b18ef41)(t.firestore, (0, $63c47e8a587a7f36$export$d66501df72047452)), [
        new (0, $63c47e8a587a7f36$export$34aec0b863436764)(t._key, (0, $63c47e8a587a7f36$export$78acf4525d8a74c4).none())
    ]);
}
/**
 * Add a new document to specified `CollectionReference` with the given data,
 * assigning it a document ID automatically.
 *
 * @param reference - A reference to the collection to add this document to.
 * @param data - An Object containing the data for the new document.
 * @returns A `Promise` resolved with a `DocumentReference` pointing to the
 * newly created document after it has been written to the backend (Note that it
 * won't resolve while you're offline).
 */ function $811ad1659062a8d4$export$a13890143fb1c2dd(t, e) {
    const n = (0, $63c47e8a587a7f36$export$4a5767248b18ef41)(t.firestore, (0, $63c47e8a587a7f36$export$d66501df72047452)), r = (0, $63c47e8a587a7f36$export$2e2af4578d910ddf)(t), s = $811ad1659062a8d4$var$__PRIVATE_applyFirestoreDataConverter(t.converter, e), o = (0, $63c47e8a587a7f36$export$2d1720544b23b823)(t.firestore);
    return $811ad1659062a8d4$export$1945f8fec9dda613(n, [
        (0, $63c47e8a587a7f36$export$71cec2538cb2c617)(o, "addDoc", r._key, s, null !== t.converter, {}).toMutation(r._key, (0, $63c47e8a587a7f36$export$78acf4525d8a74c4).exists(!1))
    ]).then(()=>r);
}
function $811ad1659062a8d4$export$d36370812fb26935(t, ...e) {
    // onSnapshot for Query or Document.
    t = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(t);
    let n = {
        includeMetadataChanges: !1,
        source: "default"
    }, r = 0;
    "object" != typeof e[r] || $811ad1659062a8d4$var$__PRIVATE_isPartialObserver(e[r]) || (n = e[r++]);
    const s = {
        includeMetadataChanges: n.includeMetadataChanges,
        source: n.source
    };
    if ($811ad1659062a8d4$var$__PRIVATE_isPartialObserver(e[r])) {
        const t = e[r];
        e[r] = t.next?.bind(t), e[r + 1] = t.error?.bind(t), e[r + 2] = t.complete?.bind(t);
    }
    let o, i, u;
    if (t instanceof (0, $63c47e8a587a7f36$export$96f57966bedc81b4)) i = (0, $63c47e8a587a7f36$export$4a5767248b18ef41)(t.firestore, (0, $63c47e8a587a7f36$export$d66501df72047452)), u = (0, $63c47e8a587a7f36$export$a93c5207d687da10)(t._key.path), o = {
        next: (n)=>{
            e[r] && e[r]($811ad1659062a8d4$var$__PRIVATE_convertToDocSnapshot(i, t, n));
        },
        error: e[r + 1],
        complete: e[r + 2]
    };
    else {
        const n = (0, $63c47e8a587a7f36$export$4a5767248b18ef41)(t, (0, $63c47e8a587a7f36$export$3722cfe417b6ed86));
        i = (0, $63c47e8a587a7f36$export$4a5767248b18ef41)(n.firestore, (0, $63c47e8a587a7f36$export$d66501df72047452)), u = n._query;
        const s = new (0, $63c47e8a587a7f36$export$7f8ddf7c7c20b3cd)(i);
        o = {
            next: (t)=>{
                e[r] && e[r](new $811ad1659062a8d4$export$8f21149d8133945c(i, s, n, t));
            },
            error: e[r + 1],
            complete: e[r + 2]
        }, $811ad1659062a8d4$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(t._query);
    }
    const c = (0, $63c47e8a587a7f36$export$df995fae86a55f06)(i);
    return (0, $63c47e8a587a7f36$export$c3950d9923825c02)(c, u, s, o);
}
function $811ad1659062a8d4$export$a1ef90ed3b4a87fa(t, e, ...n) {
    const r = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(t), s = /**
 * Ensures the data required to construct an {@link onSnapshot} listener exist in a `snapshotJson`
 * object that originates from {@link DocumentSnapshot.toJSON} or {@link Querysnapshot.toJSON}. The
 * data is normalized into a typed object.
 *
 * @param snapshotJson - The JSON object that the app provided to {@link onSnapshot}.
 * @returns A normalized object that contains all of the required bundle JSON fields. If
 * {@link snapshotJson} doesn't contain the required fields, or if the fields exist as empty
 * strings, then the {@link snapshotJson.error} field will be a non empty string.
 *
 * @internal
 */ function __PRIVATE_normalizeSnapshotJsonFields(t) {
        const e = {
            bundle: "",
            bundleName: "",
            bundleSource: ""
        }, n = [
            "bundle",
            "bundleName",
            "bundleSource"
        ];
        for (const r of n){
            if (!(r in t)) {
                e.error = `snapshotJson missing required field: ${r}`;
                break;
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const n = t[r];
            if ("string" != typeof n) {
                e.error = `snapshotJson field '${r}' must be a string.`;
                break;
            }
            if (0 === n.length) {
                e.error = `snapshotJson field '${r}' cannot be an empty string.`;
                break;
            }
            "bundle" === r ? e.bundle = n : "bundleName" === r ? e.bundleName = n : "bundleSource" === r && (e.bundleSource = n);
        }
        return e;
    }(e);
    if (s.error) throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).INVALID_ARGUMENT, s.error);
    let a, o = 0;
    if ("object" != typeof n[o] || $811ad1659062a8d4$var$__PRIVATE_isPartialObserver(n[o]) || (a = n[o++]), "QuerySnapshot" === s.bundleSource) {
        let t = null;
        if ("object" == typeof n[o] && $811ad1659062a8d4$var$__PRIVATE_isPartialObserver(n[o])) {
            const e = n[o++];
            t = {
                next: e.next,
                error: e.error,
                complete: e.complete
            };
        } else t = {
            next: n[o++],
            error: n[o++],
            complete: n[o++]
        };
        /**
 * Loads the bundle in a separate task and then invokes {@link onSnapshot} with a
 * {@link Query} that represents the Query in the bundle.
 *
 * @param firestore - The {@link Firestore} instance for the {@link onSnapshot} operation request.
 * @param json - The JSON bundle to load, produced by {@link QuerySnapshot.toJSON}.
 * @param options - Options controlling the listen behavior.
 * @param observer - A single object containing `next` and `error` callbacks.
 * @param converter - An optional object that converts objects from Firestore before the onNext
 * listener is invoked.
 * @returns An unsubscribe function that can be called to cancel the snapshot
 * listener.
 *
 * @internal
 */ return function __PRIVATE_onSnapshotQuerySnapshotBundle(t, e, n, r, s) {
            let a, o = !1;
            const i = (0, $63c47e8a587a7f36$export$a9c996f45e5784d0)(t, e.bundle);
            return i.then(()=>(0, $63c47e8a587a7f36$export$7910e0436ed8d1de)(t, e.bundleName)).then((t)=>{
                if (t && !o) s && t.withConverter(s), a = $811ad1659062a8d4$export$d36370812fb26935(t, n || {}, r);
            }).catch((t)=>(r.error && r.error(t), ()=>{})), ()=>{
                o || (o = !0, a && a());
            };
        }(r, s, a, t, n[o]);
    }
    if ("DocumentSnapshot" === s.bundleSource) {
        let t = null;
        if ("object" == typeof n[o] && $811ad1659062a8d4$var$__PRIVATE_isPartialObserver(n[o])) {
            const e = n[o++];
            t = {
                next: e.next,
                error: e.error,
                complete: e.complete
            };
        } else t = {
            next: n[o++],
            error: n[o++],
            complete: n[o++]
        };
        return function __PRIVATE_onSnapshotDocumentSnapshotBundle(t, e, n, r, s) {
            let a, o = !1;
            const i = (0, $63c47e8a587a7f36$export$a9c996f45e5784d0)(t, e.bundle);
            return i.then(()=>{
                if (!o) {
                    const o = new (0, $63c47e8a587a7f36$export$96f57966bedc81b4)(t, s || null, (0, $63c47e8a587a7f36$export$90a7f3efeed30595).fromPath(e.bundleName));
                    a = $811ad1659062a8d4$export$d36370812fb26935(o, n || {}, r);
                }
            }).catch((t)=>(r.error && r.error(t), ()=>{})), ()=>{
                o || (o = !0, a && a());
            };
        }(r, s, a, t, n[o]);
    }
    throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).INVALID_ARGUMENT, `unsupported bundle source: ${s.bundleSource}`);
}
function $811ad1659062a8d4$export$9dff4f5aba83e348(t, e) {
    t = (0, $63c47e8a587a7f36$export$4a5767248b18ef41)(t, (0, $63c47e8a587a7f36$export$d66501df72047452));
    const n = (0, $63c47e8a587a7f36$export$df995fae86a55f06)(t), r = $811ad1659062a8d4$var$__PRIVATE_isPartialObserver(e) ? e : {
        next: e
    };
    return (0, $63c47e8a587a7f36$export$555508cbc6add439)(n, r);
}
/**
 * Locally writes `mutations` on the async queue.
 * @internal
 */ function $811ad1659062a8d4$export$1945f8fec9dda613(t, e) {
    const n = (0, $63c47e8a587a7f36$export$df995fae86a55f06)(t);
    return (0, $63c47e8a587a7f36$export$2219238a014317b0)(n, e);
}
/**
 * Converts a {@link ViewSnapshot} that contains the single document specified by `ref`
 * to a {@link DocumentSnapshot}.
 */ function $811ad1659062a8d4$var$__PRIVATE_convertToDocSnapshot(t, e, n) {
    const r = n.docs.get(e._key), s = new (0, $63c47e8a587a7f36$export$7f8ddf7c7c20b3cd)(t);
    return new $811ad1659062a8d4$export$acab0e6ef25eb301(t, s, e._key, r, new $811ad1659062a8d4$export$99d61448206ab5cd(n.hasPendingWrites, n.fromCache), e.converter);
}
function $811ad1659062a8d4$export$44cd1c9d57edd9b1(t) {
    return t = (0, $63c47e8a587a7f36$export$4a5767248b18ef41)(t, (0, $63c47e8a587a7f36$export$d66501df72047452)), (0, $63c47e8a587a7f36$export$df995fae86a55f06)(t), new $811ad1659062a8d4$export$d94ed661b1cfd435(t, (e)=>$811ad1659062a8d4$export$1945f8fec9dda613(t, e));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $811ad1659062a8d4$export$ff1663c0c1304f1a(t, e) {
    t = (0, $63c47e8a587a7f36$export$4a5767248b18ef41)(t, (0, $63c47e8a587a7f36$export$d66501df72047452));
    const n = (0, $63c47e8a587a7f36$export$df995fae86a55f06)(t);
    if (!n._uninitializedComponentsProvider || "memory" === n._uninitializedComponentsProvider._offline.kind) // PORTING NOTE: We don't return an error if the user has not enabled
    // persistence since `enableIndexeddbPersistence()` can fail on the Web.
    return (0, $63c47e8a587a7f36$export$4c3d22f3d993c33f)("Cannot enable indexes when persistence is disabled"), Promise.resolve();
    const r = function __PRIVATE_parseIndexes(t) {
        const e = "string" == typeof t ? function __PRIVATE_tryParseJson(t) {
            try {
                return JSON.parse(t);
            } catch (t) {
                throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).INVALID_ARGUMENT, "Failed to parse JSON: " + t?.message);
            }
        }(t) : t, n = [];
        if (Array.isArray(e.indexes)) for (const t of e.indexes){
            const e = $811ad1659062a8d4$var$__PRIVATE_tryGetString(t, "collectionGroup"), r = [];
            if (Array.isArray(t.fields)) for (const e of t.fields){
                const t = $811ad1659062a8d4$var$__PRIVATE_tryGetString(e, "fieldPath"), n = (0, $63c47e8a587a7f36$export$f787f51d84a910ad)("setIndexConfiguration", t);
                "CONTAINS" === e.arrayConfig ? r.push(new (0, $63c47e8a587a7f36$export$c9170ad7d4cd7e57)(n, 2 /* IndexKind.CONTAINS */ )) : "ASCENDING" === e.order ? r.push(new (0, $63c47e8a587a7f36$export$c9170ad7d4cd7e57)(n, 0 /* IndexKind.ASCENDING */ )) : "DESCENDING" === e.order && r.push(new (0, $63c47e8a587a7f36$export$c9170ad7d4cd7e57)(n, 1 /* IndexKind.DESCENDING */ ));
            }
            n.push(new (0, $63c47e8a587a7f36$export$ee7c8ad385a60b7b)((0, $63c47e8a587a7f36$export$ee7c8ad385a60b7b).UNKNOWN_ID, e, r, (0, $63c47e8a587a7f36$export$995eb9fca571757).empty()));
        }
        return n;
    }(e);
    return (0, $63c47e8a587a7f36$export$f38c853ae54ed474)(n, r);
}
function $811ad1659062a8d4$var$__PRIVATE_tryGetString(t, e) {
    if ("string" != typeof t[e]) throw new (0, $63c47e8a587a7f36$export$4368d992c4eafac0)((0, $63c47e8a587a7f36$export$e7094788287c5e9b).INVALID_ARGUMENT, "Missing string value for: " + e);
    return t[e];
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `PersistentCacheIndexManager` for configuring persistent cache indexes used
 * for local query execution.
 *
 * To use, call `getPersistentCacheIndexManager()` to get an instance.
 */ class $811ad1659062a8d4$export$cf4db3c220e88bd8 {
    /** @hideconstructor */ constructor(t){
        this._firestore = t, /** A type string to uniquely identify instances of this class. */ this.type = "PersistentCacheIndexManager";
    }
}
/**
 * Returns the PersistentCache Index Manager used by the given `Firestore`
 * object.
 *
 * @returns The `PersistentCacheIndexManager` instance, or `null` if local
 * persistent storage is not in use.
 */ function $811ad1659062a8d4$export$61c6347b57bdfa06(t) {
    t = (0, $63c47e8a587a7f36$export$4a5767248b18ef41)(t, (0, $63c47e8a587a7f36$export$d66501df72047452));
    const e = $811ad1659062a8d4$var$Kt.get(t);
    if (e) return e;
    const n = (0, $63c47e8a587a7f36$export$df995fae86a55f06)(t);
    if ("persistent" !== n._uninitializedComponentsProvider?._offline.kind) return null;
    const r = new $811ad1659062a8d4$export$cf4db3c220e88bd8(t);
    return $811ad1659062a8d4$var$Kt.set(t, r), r;
}
/**
 * Enables the SDK to create persistent cache indexes automatically for local
 * query execution when the SDK believes cache indexes can help improve
 * performance.
 *
 * This feature is disabled by default.
 */ function $811ad1659062a8d4$export$9b2c0a7aacbcd151(t) {
    $811ad1659062a8d4$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(t, !0);
}
/**
 * Stops creating persistent cache indexes automatically for local query
 * execution. The indexes which have been created by calling
 * `enablePersistentCacheIndexAutoCreation()` still take effect.
 */ function $811ad1659062a8d4$export$5b460d5f48076743(t) {
    $811ad1659062a8d4$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(t, !1);
}
/**
 * Removes all persistent cache indexes.
 *
 * Please note this function will also deletes indexes generated by
 * `setIndexConfiguration()`, which is deprecated.
 */ function $811ad1659062a8d4$export$72809fc2fc5083d5(t) {
    const e = (0, $63c47e8a587a7f36$export$df995fae86a55f06)(t._firestore);
    (0, $63c47e8a587a7f36$export$3b513254972cfc9c)(e).then((t)=>(0, $63c47e8a587a7f36$export$21579262ef46735b)("deleting all persistent cache indexes succeeded")).catch((t)=>(0, $63c47e8a587a7f36$export$4c3d22f3d993c33f)("deleting all persistent cache indexes failed", t));
}
function $811ad1659062a8d4$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(t, e) {
    const n = (0, $63c47e8a587a7f36$export$df995fae86a55f06)(t._firestore);
    (0, $63c47e8a587a7f36$export$ab83b03e4111b1d0)(n, e).then((t)=>(0, $63c47e8a587a7f36$export$21579262ef46735b)(`setting persistent cache index auto creation isEnabled=${e} succeeded`)).catch((t)=>(0, $63c47e8a587a7f36$export$4c3d22f3d993c33f)(`setting persistent cache index auto creation isEnabled=${e} failed`, t));
}
/**
 * Maps `Firestore` instances to their corresponding
 * `PersistentCacheIndexManager` instances.
 *
 * Use a `WeakMap` so that the mapping will be automatically dropped when the
 * `Firestore` instance is garbage collected. This emulates a private member
 * as described in https://goo.gle/454yvug.
 */ const $811ad1659062a8d4$var$Kt = new WeakMap;
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Testing hooks for use by Firestore's integration test suite to reach into the
 * SDK internals to validate logic and behavior that is not visible from the
 * public API surface.
 *
 * @internal
 */ class $811ad1659062a8d4$export$3ab3ff3652492b82 {
    constructor(){
        throw new Error("instances of this class should not be created");
    }
    /**
     * Registers a callback to be notified when an existence filter mismatch
     * occurs in the Watch listen stream.
     *
     * The relative order in which callbacks are notified is unspecified; do not
     * rely on any particular ordering. If a given callback is registered multiple
     * times then it will be notified multiple times, once per registration.
     *
     * @param callback - the callback to invoke upon existence filter mismatch.
     *
     * @returns a function that, when called, unregisters the given callback; only
     * the first invocation of the returned function does anything; all subsequent
     * invocations do nothing.
     */ static onExistenceFilterMismatch(t) {
        return $811ad1659062a8d4$var$__PRIVATE_TestingHooksSpiImpl.instance.onExistenceFilterMismatch(t);
    }
}
/**
 * The implementation of `TestingHooksSpi`.
 */ class $811ad1659062a8d4$var$__PRIVATE_TestingHooksSpiImpl {
    constructor(){
        this.i = new Map;
    }
    static get instance() {
        return $811ad1659062a8d4$var$Xt || ($811ad1659062a8d4$var$Xt = new $811ad1659062a8d4$var$__PRIVATE_TestingHooksSpiImpl, (0, $63c47e8a587a7f36$export$1a82df3d29112e01)($811ad1659062a8d4$var$Xt)), $811ad1659062a8d4$var$Xt;
    }
    u(t) {
        this.i.forEach((e)=>e(t));
    }
    onExistenceFilterMismatch(t) {
        const e = Symbol(), n = this.i;
        return n.set(e, t), ()=>n.delete(e);
    }
}
let $811ad1659062a8d4$var$Xt = null;
/**
 * Cloud Firestore
 *
 * @packageDocumentation
 */ !function __PRIVATE_registerFirestore(u, l = !0) {
    (0, $63c47e8a587a7f36$export$71511d61b312f219)((0, $0c1331d0a001f5bc$export$31499a9cd224b78c)), (0, $0c1331d0a001f5bc$export$c930050e7bb63965)(new (0, $ad76b76e741ec0c7$export$16fa2f45be04daa8)("firestore", (t, { instanceIdentifier: e, options: n })=>{
        const r = t.getProvider("app").getImmediate(), s = new (0, $63c47e8a587a7f36$export$d66501df72047452)(new (0, $63c47e8a587a7f36$export$407448d2b89b1813)(t.getProvider("auth-internal")), new (0, $63c47e8a587a7f36$export$8b22cf2602fb60ce)(r, t.getProvider("app-check-internal")), (0, $63c47e8a587a7f36$export$db3b6bfb95261072)(r, e), r);
        return n = {
            useFetchStreams: l,
            ...n
        }, s._setSettings(n), s;
    }, "PUBLIC").setMultipleInstances(!0)), (0, $0c1331d0a001f5bc$export$d29d5299a7137abc)($811ad1659062a8d4$var$Ut, $811ad1659062a8d4$var$Ht, u), // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    (0, $0c1331d0a001f5bc$export$d29d5299a7137abc)($811ad1659062a8d4$var$Ut, $811ad1659062a8d4$var$Ht, "esm2020");
}();




const $220c2d58964ba595$var$utils = {};
let $220c2d58964ba595$export$fcc0626890c55730 = window.firebaseConfig;
$220c2d58964ba595$var$utils.ReatimeDbUtils = function() {
    this.init();
    window.realtimeUtils = this;
};
$220c2d58964ba595$var$utils.ReatimeDbUtils.prototype = {
    init: function() {
        (0, $42ddf94e6f3c0a26$export$2e2bcd8739ae039).initializeApp($220c2d58964ba595$export$fcc0626890c55730);
        (0, $42ddf94e6f3c0a26$export$2e2bcd8739ae039).auth();
    },
    createDoc: function(docType, id, initData) {
        return (0, $42ddf94e6f3c0a26$export$2e2bcd8739ae039).database().ref(docType + "/" + id).set(initData);
    },
    addCollaborativeUser: function(docType, docId, user) {
        return (0, $42ddf94e6f3c0a26$export$2e2bcd8739ae039).database().ref(docType + "/" + docId + "/users/" + user.uid).set(user);
    },
    removeCollaborativeUser: function(docType, docId, user) {
        return user ? (0, $42ddf94e6f3c0a26$export$2e2bcd8739ae039).database().ref(docType + "/" + docId + "/users/" + user.uid).remove() : null;
    },
    getCollaborativeListUser: function(docType, docId) {
        return (0, $42ddf94e6f3c0a26$export$2e2bcd8739ae039).database().ref(docType + "/" + docId + "/users");
    },
    getDoc: function(docType, docId) {
        return (0, $42ddf94e6f3c0a26$export$2e2bcd8739ae039).database().ref(docType + "/" + docId);
    },
    getListDocs: function(user) {}
};
const $220c2d58964ba595$export$ecf541e09a511845 = function(urlParam) {
    // This handles parsing URLs like /type/id/section
    let path = window.location.pathname.split('/');
    let match = null;
    if (path.length > 3 && 'section' === urlParam) match = path[3];
    else if (path.length >= 2 && 'id' === urlParam) match = path[2];
    else if (path.length >= 1 && 'type' === urlParam) {
        match = path[1];
        if ('unit-organizer' === match) match = 'unit-org-2';
    }
    return match;
};
var $220c2d58964ba595$export$2e2bcd8739ae039 = $220c2d58964ba595$var$utils;








/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ const $9bd0e0ec09375082$export$d66501df72047452 = {
    /** Phone as second factor */ PHONE: 'phone',
    TOTP: 'totp'
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ const $9bd0e0ec09375082$export$9e5f44173e64f162 = {
    /** Facebook provider ID */ FACEBOOK: 'facebook.com',
    /** GitHub provider ID */ GITHUB: 'github.com',
    /** Google provider ID */ GOOGLE: 'google.com',
    /** Password provider */ PASSWORD: 'password',
    /** Phone provider */ PHONE: 'phone',
    /** Twitter provider ID */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ const $9bd0e0ec09375082$export$25ce5a424b770e84 = {
    /** Email link sign in method */ EMAIL_LINK: 'emailLink',
    /** Email/password sign in method */ EMAIL_PASSWORD: 'password',
    /** Facebook sign in method */ FACEBOOK: 'facebook.com',
    /** GitHub sign in method */ GITHUB: 'github.com',
    /** Google sign in method */ GOOGLE: 'google.com',
    /** Phone sign in method */ PHONE: 'phone',
    /** Twitter sign in method */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ const $9bd0e0ec09375082$export$c4ce752e73470fba = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: 'link',
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: 'reauthenticate',
    /** Operation involving signing in a user. */ SIGN_IN: 'signIn'
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ const $9bd0e0ec09375082$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: 'EMAIL_SIGNIN',
    /** The password reset action. */ PASSWORD_RESET: 'PASSWORD_RESET',
    /** The email revocation action. */ RECOVER_EMAIL: 'RECOVER_EMAIL',
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: 'REVERT_SECOND_FACTOR_ADDITION',
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: 'VERIFY_AND_CHANGE_EMAIL',
    /** The email verification action. */ VERIFY_EMAIL: 'VERIFY_EMAIL'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9bd0e0ec09375082$var$_debugErrorMap() {
    return {
        ["admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ]: 'This operation is restricted to administrators only.',
        ["argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ ]: '',
        ["app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ ]: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        ["app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ ]: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        ["captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ ]: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        ["code-expired" /* AuthErrorCode.CODE_EXPIRED */ ]: "The SMS code has expired. Please re-send the verification code to try again.",
        ["cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ ]: 'Cordova framework is not ready.',
        ["cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ ]: 'This browser is not supported.',
        ["credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ]: 'This credential is already associated with a different user account.',
        ["custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ]: 'The custom token corresponds to a different audience.',
        ["requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
        ["dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ ]: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        ["email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ ]: 'Multi-factor users must always have a verified email.',
        ["email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ]: 'The email address is already in use by another account.',
        ["emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ ]: 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.',
        ["expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ]: 'The action code has expired.',
        ["cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ]: 'This operation has been cancelled due to another conflicting popup being opened.',
        ["internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ]: 'An internal AuthError has occurred.',
        ["invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ ]: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        ["invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ ]: 'The mobile app identifier is not registered for the current project.',
        ["invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ]: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        ["invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ]: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        ["invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ ]: 'The continue URL provided in the request is invalid.',
        ["invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ ]: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        ["invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ ]: 'The custom token format is incorrect. Please check the documentation.',
        ["invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ ]: 'The provided dynamic link domain is not configured or authorized for the current project.',
        ["invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ]: 'The email address is badly formatted.',
        ["invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ ]: 'Emulator URL must start with a valid scheme (http:// or https://).',
        ["invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ ]: 'Your API key is invalid, please check you have copied it correctly.',
        ["invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ ]: 'The SHA-1 certificate hash provided is invalid.',
        ["invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ]: 'The supplied auth credential is incorrect, malformed or has expired.',
        ["invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ ]: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ]: 'The request does not contain a valid proof of first factor successful sign-in.',
        ["invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ ]: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        ["invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ]: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        ["unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ ]: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        ["invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ]: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        ["wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ]: 'The password is invalid or the user does not have a password.',
        ["invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ ]: 'The specified persistence type is invalid. It can only be local, session or none.',
        ["invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ ]: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        ["invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ ]: 'The specified provider ID is invalid.',
        ["invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ ]: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        ["invalid-sender" /* AuthErrorCode.INVALID_SENDER */ ]: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ]: 'The verification ID used to create the phone auth credential is invalid.',
        ["invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ ]: "The Auth instance's tenant ID is invalid.",
        ["login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ ]: 'Login blocked by user-provided method: {$originalMessage}',
        ["missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ]: 'An Android Package Name must be provided if the Android App is required to be installed.',
        ["auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ ]: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        ["missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ ]: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        ["missing-verification-code" /* AuthErrorCode.MISSING_CODE */ ]: 'The phone auth credential was created with an empty SMS verification code.',
        ["missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ ]: 'A continue URL must be provided in the request.',
        ["missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ ]: 'An internal AuthError has occurred.',
        ["missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ ]: 'An iOS Bundle ID must be provided if an App Store ID is provided.',
        ["missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ ]: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        ["missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ]: 'A non-empty password must be provided',
        ["missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ]: 'No second factor identifier is provided.',
        ["missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ]: 'The request is missing proof of first factor successful sign-in.',
        ["missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ ]: 'To send verification codes, provide a phone number for the recipient.',
        ["missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ]: 'The phone auth credential was created with an empty verification ID.',
        ["app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ ]: 'This instance of FirebaseApp has been deleted.',
        ["multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ]: 'The user does not have a second factor matching the identifier provided.',
        ["multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ]: 'Proof of ownership of a second factor is required to complete sign-in.',
        ["account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ ]: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        ["network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ]: 'A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.',
        ["no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ]: 'User was not linked to an account with the given provider.',
        ["null-user" /* AuthErrorCode.NULL_USER */ ]: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        ["operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ]: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        ["operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ]: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        ["popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ ]: 'Unable to establish a connection with the popup. It may have been blocked by the browser.',
        ["popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ]: 'The popup has been closed by the user before finalizing the operation.',
        ["provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ ]: 'User can only be linked to one identity for the given provider.',
        ["quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ ]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ ]: 'The redirect operation has been cancelled by the user before finalizing.',
        ["redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ ]: 'A redirect sign-in operation is already pending.',
        ["rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ ]: 'The request contains malformed or mismatching credentials.',
        ["second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ]: 'The second factor is already enrolled on this account.',
        ["maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: 'The maximum allowed number of second factors on a user has been exceeded.',
        ["tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ ]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* AuthErrorCode.TIMEOUT */ ]: 'The operation has timed out.',
        ["user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "We have blocked all requests from this device due to unusual activity. Try again later.",
        ["unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ]: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        ["unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ ]: 'Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.',
        ["unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ ]: 'The current environment does not support the specified persistence type.',
        ["unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ ]: 'This operation is not supported in a multi-tenant context.',
        ["unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ ]: 'The operation requires a verified email.',
        ["user-cancelled" /* AuthErrorCode.USER_CANCELLED */ ]: 'The user did not grant your application the permissions it requested.',
        ["user-not-found" /* AuthErrorCode.USER_DELETED */ ]: "There is no user record corresponding to this identifier. The user may have been deleted.",
        ["user-disabled" /* AuthErrorCode.USER_DISABLED */ ]: 'The user account has been disabled by an administrator.',
        ["user-mismatch" /* AuthErrorCode.USER_MISMATCH */ ]: 'The supplied credentials do not correspond to the previously signed in user.',
        ["user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ ]: '',
        ["weak-password" /* AuthErrorCode.WEAK_PASSWORD */ ]: 'The password must be 6 characters long or more.',
        ["web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ]: 'This browser is not supported or 3rd party cookies and data may be disabled.',
        ["already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ ]: "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance.",
        ["missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is missing when sending request to the backend.',
        ["invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is invalid when sending request to the backend.',
        ["invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ]: 'The reCAPTCHA action is invalid when sending request to the backend.',
        ["recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ]: 'reCAPTCHA Enterprise integration is not enabled for this project.',
        ["missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ]: 'The reCAPTCHA client type is missing when sending request to the backend.',
        ["missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is missing when sending request to the backend.',
        ["invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ]: 'Invalid request parameters.',
        ["invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is invalid when sending request to the backend.',
        ["unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ ]: 'The password policy received from the backend uses a schema version that is not supported by this version of the Firebase SDK.',
        ["password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: 'The password does not meet the requirements.',
        ["invalid-hosting-link-domain" /* AuthErrorCode.INVALID_HOSTING_LINK_DOMAIN */ ]: "The provided Hosting link domain is not configured in Firebase Hosting or is not owned by the current project. This cannot be a default Hosting domain (`web.app` or `firebaseapp.com`)."
    };
}
function $9bd0e0ec09375082$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $9bd0e0ec09375082$export$7f8ddf7c7c20b3cd = $9bd0e0ec09375082$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $9bd0e0ec09375082$export$9bb611d729802a56 = $9bd0e0ec09375082$var$_prodErrorMap;
const $9bd0e0ec09375082$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $3117f6f4eeb4c314$export$3fa6e1b18a3b2d40)('auth', 'Firebase', $9bd0e0ec09375082$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ const $9bd0e0ec09375082$export$b4171a6734a65d42 = {
    ADMIN_ONLY_OPERATION: 'auth/admin-restricted-operation',
    ARGUMENT_ERROR: 'auth/argument-error',
    APP_NOT_AUTHORIZED: 'auth/app-not-authorized',
    APP_NOT_INSTALLED: 'auth/app-not-installed',
    CAPTCHA_CHECK_FAILED: 'auth/captcha-check-failed',
    CODE_EXPIRED: 'auth/code-expired',
    CORDOVA_NOT_READY: 'auth/cordova-not-ready',
    CORS_UNSUPPORTED: 'auth/cors-unsupported',
    CREDENTIAL_ALREADY_IN_USE: 'auth/credential-already-in-use',
    CREDENTIAL_MISMATCH: 'auth/custom-token-mismatch',
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: 'auth/requires-recent-login',
    DEPENDENT_SDK_INIT_BEFORE_AUTH: 'auth/dependent-sdk-initialized-before-auth',
    DYNAMIC_LINK_NOT_ACTIVATED: 'auth/dynamic-link-not-activated',
    EMAIL_CHANGE_NEEDS_VERIFICATION: 'auth/email-change-needs-verification',
    EMAIL_EXISTS: 'auth/email-already-in-use',
    EMULATOR_CONFIG_FAILED: 'auth/emulator-config-failed',
    EXPIRED_OOB_CODE: 'auth/expired-action-code',
    EXPIRED_POPUP_REQUEST: 'auth/cancelled-popup-request',
    INTERNAL_ERROR: 'auth/internal-error',
    INVALID_API_KEY: 'auth/invalid-api-key',
    INVALID_APP_CREDENTIAL: 'auth/invalid-app-credential',
    INVALID_APP_ID: 'auth/invalid-app-id',
    INVALID_AUTH: 'auth/invalid-user-token',
    INVALID_AUTH_EVENT: 'auth/invalid-auth-event',
    INVALID_CERT_HASH: 'auth/invalid-cert-hash',
    INVALID_CODE: 'auth/invalid-verification-code',
    INVALID_CONTINUE_URI: 'auth/invalid-continue-uri',
    INVALID_CORDOVA_CONFIGURATION: 'auth/invalid-cordova-configuration',
    INVALID_CUSTOM_TOKEN: 'auth/invalid-custom-token',
    INVALID_DYNAMIC_LINK_DOMAIN: 'auth/invalid-dynamic-link-domain',
    INVALID_EMAIL: 'auth/invalid-email',
    INVALID_EMULATOR_SCHEME: 'auth/invalid-emulator-scheme',
    INVALID_IDP_RESPONSE: 'auth/invalid-credential',
    INVALID_LOGIN_CREDENTIALS: 'auth/invalid-credential',
    INVALID_MESSAGE_PAYLOAD: 'auth/invalid-message-payload',
    INVALID_MFA_SESSION: 'auth/invalid-multi-factor-session',
    INVALID_OAUTH_CLIENT_ID: 'auth/invalid-oauth-client-id',
    INVALID_OAUTH_PROVIDER: 'auth/invalid-oauth-provider',
    INVALID_OOB_CODE: 'auth/invalid-action-code',
    INVALID_ORIGIN: 'auth/unauthorized-domain',
    INVALID_PASSWORD: 'auth/wrong-password',
    INVALID_PERSISTENCE: 'auth/invalid-persistence-type',
    INVALID_PHONE_NUMBER: 'auth/invalid-phone-number',
    INVALID_PROVIDER_ID: 'auth/invalid-provider-id',
    INVALID_RECIPIENT_EMAIL: 'auth/invalid-recipient-email',
    INVALID_SENDER: 'auth/invalid-sender',
    INVALID_SESSION_INFO: 'auth/invalid-verification-id',
    INVALID_TENANT_ID: 'auth/invalid-tenant-id',
    MFA_INFO_NOT_FOUND: 'auth/multi-factor-info-not-found',
    MFA_REQUIRED: 'auth/multi-factor-auth-required',
    MISSING_ANDROID_PACKAGE_NAME: 'auth/missing-android-pkg-name',
    MISSING_APP_CREDENTIAL: 'auth/missing-app-credential',
    MISSING_AUTH_DOMAIN: 'auth/auth-domain-config-required',
    MISSING_CODE: 'auth/missing-verification-code',
    MISSING_CONTINUE_URI: 'auth/missing-continue-uri',
    MISSING_IFRAME_START: 'auth/missing-iframe-start',
    MISSING_IOS_BUNDLE_ID: 'auth/missing-ios-bundle-id',
    MISSING_OR_INVALID_NONCE: 'auth/missing-or-invalid-nonce',
    MISSING_MFA_INFO: 'auth/missing-multi-factor-info',
    MISSING_MFA_SESSION: 'auth/missing-multi-factor-session',
    MISSING_PHONE_NUMBER: 'auth/missing-phone-number',
    MISSING_PASSWORD: 'auth/missing-password',
    MISSING_SESSION_INFO: 'auth/missing-verification-id',
    MODULE_DESTROYED: 'auth/app-deleted',
    NEED_CONFIRMATION: 'auth/account-exists-with-different-credential',
    NETWORK_REQUEST_FAILED: 'auth/network-request-failed',
    NULL_USER: 'auth/null-user',
    NO_AUTH_EVENT: 'auth/no-auth-event',
    NO_SUCH_PROVIDER: 'auth/no-such-provider',
    OPERATION_NOT_ALLOWED: 'auth/operation-not-allowed',
    OPERATION_NOT_SUPPORTED: 'auth/operation-not-supported-in-this-environment',
    POPUP_BLOCKED: 'auth/popup-blocked',
    POPUP_CLOSED_BY_USER: 'auth/popup-closed-by-user',
    PROVIDER_ALREADY_LINKED: 'auth/provider-already-linked',
    QUOTA_EXCEEDED: 'auth/quota-exceeded',
    REDIRECT_CANCELLED_BY_USER: 'auth/redirect-cancelled-by-user',
    REDIRECT_OPERATION_PENDING: 'auth/redirect-operation-pending',
    REJECTED_CREDENTIAL: 'auth/rejected-credential',
    SECOND_FACTOR_ALREADY_ENROLLED: 'auth/second-factor-already-in-use',
    SECOND_FACTOR_LIMIT_EXCEEDED: 'auth/maximum-second-factor-count-exceeded',
    TENANT_ID_MISMATCH: 'auth/tenant-id-mismatch',
    TIMEOUT: 'auth/timeout',
    TOKEN_EXPIRED: 'auth/user-token-expired',
    TOO_MANY_ATTEMPTS_TRY_LATER: 'auth/too-many-requests',
    UNAUTHORIZED_DOMAIN: 'auth/unauthorized-continue-uri',
    UNSUPPORTED_FIRST_FACTOR: 'auth/unsupported-first-factor',
    UNSUPPORTED_PERSISTENCE: 'auth/unsupported-persistence-type',
    UNSUPPORTED_TENANT_OPERATION: 'auth/unsupported-tenant-operation',
    UNVERIFIED_EMAIL: 'auth/unverified-email',
    USER_CANCELLED: 'auth/user-cancelled',
    USER_DELETED: 'auth/user-not-found',
    USER_DISABLED: 'auth/user-disabled',
    USER_MISMATCH: 'auth/user-mismatch',
    USER_SIGNED_OUT: 'auth/user-signed-out',
    WEAK_PASSWORD: 'auth/weak-password',
    WEB_STORAGE_UNSUPPORTED: 'auth/web-storage-unsupported',
    ALREADY_INITIALIZED: 'auth/already-initialized',
    RECAPTCHA_NOT_ENABLED: 'auth/recaptcha-not-enabled',
    MISSING_RECAPTCHA_TOKEN: 'auth/missing-recaptcha-token',
    INVALID_RECAPTCHA_TOKEN: 'auth/invalid-recaptcha-token',
    INVALID_RECAPTCHA_ACTION: 'auth/invalid-recaptcha-action',
    MISSING_CLIENT_TYPE: 'auth/missing-client-type',
    MISSING_RECAPTCHA_VERSION: 'auth/missing-recaptcha-version',
    INVALID_RECAPTCHA_VERSION: 'auth/invalid-recaptcha-version',
    INVALID_REQ_TYPE: 'auth/invalid-req-type',
    INVALID_HOSTING_LINK_DOMAIN: 'auth/invalid-hosting-link-domain'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9bd0e0ec09375082$var$logClient = new (0, $6640afd658bf2724$export$efa9a398d6368992)('@firebase/auth');
function $9bd0e0ec09375082$var$_logWarn(msg, ...args) {
    if ($9bd0e0ec09375082$var$logClient.logLevel <= (0, $6640afd658bf2724$export$243e62d78d3b544d).WARN) $9bd0e0ec09375082$var$logClient.warn(`Auth (${(0, $0c1331d0a001f5bc$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
function $9bd0e0ec09375082$var$_logError(msg, ...args) {
    if ($9bd0e0ec09375082$var$logClient.logLevel <= (0, $6640afd658bf2724$export$243e62d78d3b544d).ERROR) $9bd0e0ec09375082$var$logClient.error(`Auth (${(0, $0c1331d0a001f5bc$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9bd0e0ec09375082$export$28f7fcd39efa255(authOrCode, ...rest) {
    throw $9bd0e0ec09375082$var$createErrorInternal(authOrCode, ...rest);
}
function $9bd0e0ec09375082$export$890c4ad488842ce7(authOrCode, ...rest) {
    return $9bd0e0ec09375082$var$createErrorInternal(authOrCode, ...rest);
}
function $9bd0e0ec09375082$var$_errorWithCustomMessage(auth, code, message) {
    const errorMap = {
        ...$9bd0e0ec09375082$export$9bb611d729802a56(),
        [code]: message
    };
    const factory = new (0, $3117f6f4eeb4c314$export$3fa6e1b18a3b2d40)('auth', 'Firebase', errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $9bd0e0ec09375082$var$_serverAppCurrentUserOperationNotSupportedError(auth) {
    return $9bd0e0ec09375082$var$_errorWithCustomMessage(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ , 'Operations that alter the current user are not supported in conjunction with FirebaseServerApp');
}
function $9bd0e0ec09375082$var$_assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $9bd0e0ec09375082$export$28f7fcd39efa255(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw $9bd0e0ec09375082$var$_errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , `Type of ${object.constructor.name} does not match expected instance.` + `Did you pass a reference from a different Auth SDK?`);
    }
}
function $9bd0e0ec09375082$var$createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== 'string') {
        const code = rest[0];
        const fullParams = [
            ...rest.slice(1)
        ];
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return $9bd0e0ec09375082$var$_DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function $9bd0e0ec09375082$export$24baa2b76016ce0e(assertion, authOrCode, ...rest) {
    if (!assertion) throw $9bd0e0ec09375082$var$createErrorInternal(authOrCode, ...rest);
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $9bd0e0ec09375082$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    $9bd0e0ec09375082$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $9bd0e0ec09375082$export$d66dc83d8cfc8dd(assertion, message) {
    if (!assertion) $9bd0e0ec09375082$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9bd0e0ec09375082$var$_getCurrentUrl() {
    return typeof self !== 'undefined' && self.location?.href || '';
}
function $9bd0e0ec09375082$var$_isHttpOrHttps() {
    return $9bd0e0ec09375082$var$_getCurrentScheme() === 'http:' || $9bd0e0ec09375082$var$_getCurrentScheme() === 'https:';
}
function $9bd0e0ec09375082$var$_getCurrentScheme() {
    return typeof self !== 'undefined' && self.location?.protocol || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $9bd0e0ec09375082$var$_isOnline() {
    if (typeof navigator !== 'undefined' && navigator && 'onLine' in navigator && typeof navigator.onLine === 'boolean' && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($9bd0e0ec09375082$var$_isHttpOrHttps() || (0, $3117f6f4eeb4c314$export$caa8774a9107a58e)() || 'connection' in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $9bd0e0ec09375082$var$_getUserLanguage() {
    if (typeof navigator === 'undefined') return null;
    const navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ class $9bd0e0ec09375082$var$Delay {
    constructor(shortDelay, longDelay){
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $9bd0e0ec09375082$export$d66dc83d8cfc8dd(longDelay > shortDelay, 'Short delay should be less than long delay!');
        this.isMobile = (0, $3117f6f4eeb4c314$export$872f8323f01d7ae0)() || (0, $3117f6f4eeb4c314$export$f7a1e23e542d38e3)();
    }
    get() {
        if (!$9bd0e0ec09375082$var$_isOnline()) // Pick the shorter timeout.
        return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9bd0e0ec09375082$var$_emulatorUrl(config, path) {
    $9bd0e0ec09375082$export$d66dc83d8cfc8dd(config.emulator, 'Emulator should always be set here');
    const { url: url } = config.emulator;
    if (!path) return url;
    return `${url}${path.startsWith('/') ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9bd0e0ec09375082$export$f96d196f7728bb5 {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) this.headersImpl = headersImpl;
        if (responseImpl) this.responseImpl = responseImpl;
    }
    static fetch() {
        if (this.fetchImpl) return this.fetchImpl;
        if (typeof self !== 'undefined' && 'fetch' in self) return self.fetch;
        if (typeof globalThis !== 'undefined' && globalThis.fetch) return globalThis.fetch;
        if (typeof fetch !== 'undefined') return fetch;
        $9bd0e0ec09375082$var$debugFail('Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static headers() {
        if (this.headersImpl) return this.headersImpl;
        if (typeof self !== 'undefined' && 'Headers' in self) return self.Headers;
        if (typeof globalThis !== 'undefined' && globalThis.Headers) return globalThis.Headers;
        if (typeof Headers !== 'undefined') return Headers;
        $9bd0e0ec09375082$var$debugFail('Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static response() {
        if (this.responseImpl) return this.responseImpl;
        if (typeof self !== 'undefined' && 'Response' in self) return self.Response;
        if (typeof globalThis !== 'undefined' && globalThis.Response) return globalThis.Response;
        if (typeof Response !== 'undefined') return Response;
        $9bd0e0ec09375082$var$debugFail('Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ const $9bd0e0ec09375082$var$SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ ]: "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ ]: "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ ]: "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ ]: "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ,
    // Thrown if Email Enumeration Protection is enabled in the project and the email or password is
    // invalid.
    ["INVALID_LOGIN_CREDENTIALS" /* ServerError.INVALID_LOGIN_CREDENTIALS */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ]: "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ,
    ["PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ ]: "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ]: "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ ,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ ]: "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ,
    ["INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ ]: "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ,
    ["INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ ]: "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ,
    ["TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["PASSWORD_DOES_NOT_MEET_REQUIREMENTS" /* ServerError.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ,
    // Phone Auth related errors.
    ["INVALID_CODE" /* ServerError.INVALID_CODE */ ]: "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ,
    ["INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ ]: "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ,
    ["INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ ]: "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ,
    ["SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ ]: "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ ]: "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ,
    ["UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ ]: "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ ]: "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ ]: "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ ]: "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ,
    ["MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ ]: "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ,
    ["MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ ]: "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ ]: "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ,
    ["SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ ]: "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Recaptcha related errors.
    ["RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ ]: "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ,
    ["MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ ]: "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ ]: "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ ]: "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ,
    ["MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ ]: "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ,
    ["MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ ]: "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ,
    ["INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ ]: "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ,
    ["INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ ]: "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ 
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9bd0e0ec09375082$var$CookieAuthProxiedEndpoints = [
    "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ ,
    "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ ,
    "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ ,
    "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ ,
    "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ ,
    "/v1/token" /* Endpoint.TOKEN */ 
];
const $9bd0e0ec09375082$var$DEFAULT_API_TIMEOUT_MS = new $9bd0e0ec09375082$var$Delay(30000, 60000);
function $9bd0e0ec09375082$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return {
        ...request,
        tenantId: auth.tenantId
    };
    return request;
}
async function $9bd0e0ec09375082$var$_performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return $9bd0e0ec09375082$var$_performFetchWithErrorHandling(auth, customErrorMap, async ()=>{
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* HttpMethod.GET */ ) params = request;
            else body = {
                body: JSON.stringify(request)
            };
        }
        const query = (0, $3117f6f4eeb4c314$export$ac4103b836844853)({
            key: auth.config.apiKey,
            ...params
        }).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/json';
        if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
        const fetchArgs = {
            method: method,
            headers: headers,
            ...body
        };
        /* Security-conscious server-side frameworks tend to have built in mitigations for referrer
           problems". See the Cloudflare GitHub issue #487: Error: The 'referrerPolicy' field on
           'RequestInitializerDict' is not implemented."
           https://github.com/cloudflare/next-on-pages/issues/487 */ if (!(0, $3117f6f4eeb4c314$export$ad9e9b75cb9fb797)()) fetchArgs.referrerPolicy = 'no-referrer';
        if (auth.emulatorConfig && (0, $3117f6f4eeb4c314$export$5b4d24b45140ad90)(auth.emulatorConfig.host)) fetchArgs.credentials = 'include';
        return $9bd0e0ec09375082$export$f96d196f7728bb5.fetch()(await $9bd0e0ec09375082$var$_getFinalTarget(auth, auth.config.apiHost, path, query), fetchArgs);
    });
}
async function $9bd0e0ec09375082$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = {
        ...$9bd0e0ec09375082$var$SERVER_ERROR_MAP,
        ...customErrorMap
    };
    try {
        const networkTimeout = new $9bd0e0ec09375082$var$NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ('needConfirmation' in json) throw $9bd0e0ec09375082$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
        if (response.ok && !('errorMessage' in json)) return json;
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(' : ');
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $9bd0e0ec09375082$var$_makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
            else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw $9bd0e0ec09375082$var$_makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
            else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw $9bd0e0ec09375082$var$_makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
            const authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, '-');
            if (serverErrorMessage) throw $9bd0e0ec09375082$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
            else $9bd0e0ec09375082$export$28f7fcd39efa255(auth, authError);
        }
    } catch (e) {
        if (e instanceof (0, $3117f6f4eeb4c314$export$dd24e9cd51226c56)) throw e;
        // Changing this to a different error code will log user out when there is a network error
        // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
        // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
        $9bd0e0ec09375082$export$28f7fcd39efa255(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
            'message': String(e)
        });
    }
}
async function $9bd0e0ec09375082$var$_performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = await $9bd0e0ec09375082$var$_performApiRequest(auth, method, path, request, customErrorMap);
    if ('mfaPendingCredential' in serverResponse) $9bd0e0ec09375082$export$28f7fcd39efa255(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
        _serverResponse: serverResponse
    });
    return serverResponse;
}
async function $9bd0e0ec09375082$var$_getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    const authInternal = auth;
    const finalTarget = authInternal.config.emulator ? $9bd0e0ec09375082$var$_emulatorUrl(auth.config, base) : `${auth.config.apiScheme}://${base}`;
    // Cookie auth works by MiTMing the signIn and token endpoints from the developer's backend,
    // saving the idToken and refreshToken into cookies, and then redacting the refreshToken
    // from the response
    if ($9bd0e0ec09375082$var$CookieAuthProxiedEndpoints.includes(path)) {
        // Persistence manager is async, we need to await it. We can't just wait for auth initialized
        // here since auth initialization calls this function.
        await authInternal._persistenceManagerAvailable;
        if (authInternal._getPersistenceType() === "COOKIE" /* PersistenceType.COOKIE */ ) {
            const cookiePersistence = authInternal._getPersistence();
            return cookiePersistence._getFinalTarget(finalTarget).toString();
        }
    }
    return finalTarget;
}
function $9bd0e0ec09375082$var$_parseEnforcementState(enforcementStateStr) {
    switch(enforcementStateStr){
        case 'ENFORCE':
            return "ENFORCE" /* EnforcementState.ENFORCE */ ;
        case 'AUDIT':
            return "AUDIT" /* EnforcementState.AUDIT */ ;
        case 'OFF':
            return "OFF" /* EnforcementState.OFF */ ;
        default:
            return "ENFORCEMENT_STATE_UNSPECIFIED" /* EnforcementState.ENFORCEMENT_STATE_UNSPECIFIED */ ;
    }
}
class $9bd0e0ec09375082$var$NetworkTimeout {
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
    constructor(auth){
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject)=>{
            this.timer = setTimeout(()=>{
                return reject($9bd0e0ec09375082$export$890c4ad488842ce7(this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $9bd0e0ec09375082$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
}
function $9bd0e0ec09375082$var$_makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    const error = $9bd0e0ec09375082$export$890c4ad488842ce7(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9bd0e0ec09375082$var$isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function $9bd0e0ec09375082$var$isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
class $9bd0e0ec09375082$var$RecaptchaConfig {
    constructor(response){
        /**
         * The reCAPTCHA site key.
         */ this.siteKey = '';
        /**
         * The list of providers and their enablement status for reCAPTCHA Enterprise.
         */ this.recaptchaEnforcementState = [];
        if (response.recaptchaKey === undefined) throw new Error('recaptchaKey undefined');
        // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
        this.siteKey = response.recaptchaKey.split('/')[3];
        this.recaptchaEnforcementState = response.recaptchaEnforcementState;
    }
    /**
     * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
     *
     * @param providerStr - The provider whose enforcement state is to be returned.
     * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
     */ getProviderEnforcementState(providerStr) {
        if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0) return null;
        for (const recaptchaEnforcementState of this.recaptchaEnforcementState){
            if (recaptchaEnforcementState.provider && recaptchaEnforcementState.provider === providerStr) return $9bd0e0ec09375082$var$_parseEnforcementState(recaptchaEnforcementState.enforcementState);
        }
        return null;
    }
    /**
     * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
     *
     * @param providerStr - The provider whose enablement state is to be returned.
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
     */ isProviderEnabled(providerStr) {
        return this.getProviderEnforcementState(providerStr) === "ENFORCE" /* EnforcementState.ENFORCE */  || this.getProviderEnforcementState(providerStr) === "AUDIT" /* EnforcementState.AUDIT */ ;
    }
    /**
     * Returns true if reCAPTCHA Enterprise protection is enabled in at least one provider, otherwise
     * returns false.
     *
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for at least one provider.
     */ isAnyProviderEnabled() {
        return this.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ ) || this.isProviderEnabled("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9bd0e0ec09375082$var$getRecaptchaParams(auth) {
    return (await $9bd0e0ec09375082$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )).recaptchaSiteKey || '';
}
async function $9bd0e0ec09375082$var$getRecaptchaConfig(auth, request) {
    return $9bd0e0ec09375082$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , $9bd0e0ec09375082$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9bd0e0ec09375082$var$deleteAccount(auth, request) {
    return $9bd0e0ec09375082$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request);
}
async function $9bd0e0ec09375082$var$deleteLinkedAccounts(auth, request) {
    return $9bd0e0ec09375082$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function $9bd0e0ec09375082$var$getAccountInfo(auth, request) {
    return $9bd0e0ec09375082$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9bd0e0ec09375082$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $9bd0e0ec09375082$export$7a38258bbe170828(user, forceRefresh = false) {
    return (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $9bd0e0ec09375082$export$2f6ca3d3b1f80bf5(user, forceRefresh = false) {
    const userInternal = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = $9bd0e0ec09375082$var$_parseToken(token);
    $9bd0e0ec09375082$export$24baa2b76016ce0e(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const firebase = typeof claims.firebase === 'object' ? claims.firebase : undefined;
    const signInProvider = firebase?.['sign_in_provider'];
    return {
        claims: claims,
        token: token,
        authTime: $9bd0e0ec09375082$var$utcTimestampToDateString($9bd0e0ec09375082$var$secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: $9bd0e0ec09375082$var$utcTimestampToDateString($9bd0e0ec09375082$var$secondsStringToMilliseconds(claims.iat)),
        expirationTime: $9bd0e0ec09375082$var$utcTimestampToDateString($9bd0e0ec09375082$var$secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: firebase?.['sign_in_second_factor'] || null
    };
}
function $9bd0e0ec09375082$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $9bd0e0ec09375082$var$_parseToken(token) {
    const [algorithm, payload, signature] = token.split('.');
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $9bd0e0ec09375082$var$_logError('JWT malformed, contained fewer than 3 sections');
        return null;
    }
    try {
        const decoded = (0, $3117f6f4eeb4c314$export$c62426fdd000a97e)(payload);
        if (!decoded) {
            $9bd0e0ec09375082$var$_logError('Failed to decode base64 JWT payload');
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $9bd0e0ec09375082$var$_logError('Caught error parsing JWT payload as JSON', e?.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $9bd0e0ec09375082$var$_tokenExpiresIn(token) {
    const parsedToken = $9bd0e0ec09375082$var$_parseToken(token);
    $9bd0e0ec09375082$export$24baa2b76016ce0e(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $9bd0e0ec09375082$export$24baa2b76016ce0e(typeof parsedToken.exp !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $9bd0e0ec09375082$export$24baa2b76016ce0e(typeof parsedToken.iat !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9bd0e0ec09375082$var$_logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) return promise;
    try {
        return await promise;
    } catch (e) {
        if (e instanceof (0, $3117f6f4eeb4c314$export$dd24e9cd51226c56) && $9bd0e0ec09375082$var$isUserInvalidated(e)) {
            if (user.auth.currentUser === user) await user.auth.signOut();
        }
        throw e;
    }
}
function $9bd0e0ec09375082$var$isUserInvalidated({ code: code }) {
    return code === `auth/${"user-disabled" /* AuthErrorCode.USER_DISABLED */ }` || code === `auth/${"user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ }`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9bd0e0ec09375082$var$ProactiveRefresh {
    constructor(user){
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    _start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        if (this.timerId !== null) clearTimeout(this.timerId);
    }
    getInterval(wasError) {
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
            return interval;
        } else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
            const expTime = this.user.stsTokenManager.expirationTime ?? 0;
            const interval = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) // Just in case...
        return;
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async ()=>{
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        } catch (e) {
            // Only retry on network errors
            if (e?.code === `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) this.schedule(/* wasError */ true);
            return;
        }
        this.schedule();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9bd0e0ec09375082$var$UserMetadata {
    constructor(createdAt, lastLoginAt){
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = $9bd0e0ec09375082$var$utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = $9bd0e0ec09375082$var$utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9bd0e0ec09375082$var$_reloadWithoutSaving(user) {
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await $9bd0e0ec09375082$var$_logoutIfInvalidated(user, $9bd0e0ec09375082$var$getAccountInfo(auth, {
        idToken: idToken
    }));
    $9bd0e0ec09375082$export$24baa2b76016ce0e(response?.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = coreAccount.providerUserInfo?.length ? $9bd0e0ec09375082$var$extractProviderData(coreAccount.providerUserInfo) : [];
    const providerData = $9bd0e0ec09375082$var$mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !providerData?.length;
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData: providerData,
        metadata: new $9bd0e0ec09375082$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous: isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ async function $9bd0e0ec09375082$export$6554612db691658e(user) {
    const userInternal = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(user);
    await $9bd0e0ec09375082$var$_reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function $9bd0e0ec09375082$var$mergeProviderData(original, newData) {
    const deduped = original.filter((o)=>!newData.some((n)=>n.providerId === o.providerId));
    return [
        ...deduped,
        ...newData
    ];
}
function $9bd0e0ec09375082$var$extractProviderData(providers) {
    return providers.map(({ providerId: providerId, ...provider })=>{
        return {
            providerId: providerId,
            uid: provider.rawId || '',
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9bd0e0ec09375082$var$requestStsToken(auth, refreshToken) {
    const response = await $9bd0e0ec09375082$var$_performFetchWithErrorHandling(auth, {}, async ()=>{
        const body = (0, $3117f6f4eeb4c314$export$ac4103b836844853)({
            'grant_type': 'refresh_token',
            'refresh_token': refreshToken
        }).slice(1);
        const { tokenApiHost: tokenApiHost, apiKey: apiKey } = auth.config;
        const url = await $9bd0e0ec09375082$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/x-www-form-urlencoded';
        const options = {
            method: "POST" /* HttpMethod.POST */ ,
            headers: headers,
            body: body
        };
        if (auth.emulatorConfig && (0, $3117f6f4eeb4c314$export$5b4d24b45140ad90)(auth.emulatorConfig.host)) options.credentials = 'include';
        return $9bd0e0ec09375082$export$f96d196f7728bb5.fetch()(url, options);
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}
async function $9bd0e0ec09375082$var$revokeToken(auth, request) {
    return $9bd0e0ec09375082$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts:revokeToken" /* Endpoint.REVOKE_TOKEN */ , $9bd0e0ec09375082$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ class $9bd0e0ec09375082$var$StsTokenManager {
    constructor(){
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
    }
    updateFromServerResponse(response) {
        $9bd0e0ec09375082$export$24baa2b76016ce0e(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $9bd0e0ec09375082$export$24baa2b76016ce0e(typeof response.idToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $9bd0e0ec09375082$export$24baa2b76016ce0e(typeof response.refreshToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = 'expiresIn' in response && typeof response.expiresIn !== 'undefined' ? Number(response.expiresIn) : $9bd0e0ec09375082$var$_tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    updateFromIdToken(idToken) {
        $9bd0e0ec09375082$export$24baa2b76016ce0e(idToken.length !== 0, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = $9bd0e0ec09375082$var$_tokenExpiresIn(idToken);
        this.updateTokensAndExpiration(idToken, null, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        if (!forceRefresh && this.accessToken && !this.isExpired) return this.accessToken;
        $9bd0e0ec09375082$export$24baa2b76016ce0e(this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken: accessToken, refreshToken: refreshToken, expiresIn: expiresIn } = await $9bd0e0ec09375082$var$requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken: refreshToken, accessToken: accessToken, expirationTime: expirationTime } = object;
        const manager = new $9bd0e0ec09375082$var$StsTokenManager();
        if (refreshToken) {
            $9bd0e0ec09375082$export$24baa2b76016ce0e(typeof refreshToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            $9bd0e0ec09375082$export$24baa2b76016ce0e(typeof accessToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            $9bd0e0ec09375082$export$24baa2b76016ce0e(typeof expirationTime === 'number', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new $9bd0e0ec09375082$var$StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return $9bd0e0ec09375082$var$debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9bd0e0ec09375082$var$assertStringOrUndefined(assertion, appName) {
    $9bd0e0ec09375082$export$24baa2b76016ce0e(typeof assertion === 'string' || typeof assertion === 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName: appName
    });
}
class $9bd0e0ec09375082$export$91477dc880baac21 {
    constructor({ uid: uid, auth: auth, stsTokenManager: stsTokenManager, ...opt }){
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new $9bd0e0ec09375082$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [
            ...opt.providerData
        ] : [];
        this.metadata = new $9bd0e0ec09375082$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await $9bd0e0ec09375082$var$_logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        $9bd0e0ec09375082$export$24baa2b76016ce0e(accessToken, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return $9bd0e0ec09375082$export$2f6ca3d3b1f80bf5(this, forceRefresh);
    }
    reload() {
        return $9bd0e0ec09375082$export$6554612db691658e(this);
    }
    _assign(user) {
        if (this === user) return;
        $9bd0e0ec09375082$export$24baa2b76016ce0e(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map((userInfo)=>({
                ...userInfo
            }));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        const newUser = new $9bd0e0ec09375082$export$91477dc880baac21({
            ...this,
            auth: auth,
            stsTokenManager: this.stsTokenManager._clone()
        });
        newUser.metadata._copy(this.metadata);
        return newUser;
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        $9bd0e0ec09375082$export$24baa2b76016ce0e(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) this.reloadListener(userInfo);
        else // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) await $9bd0e0ec09375082$var$_reloadWithoutSaving(this);
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) this.auth._notifyListenersIfCurrent(this);
    }
    async delete() {
        if ((0, $0c1331d0a001f5bc$export$643c8bc6c389f34e)(this.auth.app)) return Promise.reject($9bd0e0ec09375082$var$_serverAppCurrentUserOperationNotSupportedError(this.auth));
        const idToken = await this.getIdToken();
        await $9bd0e0ec09375082$var$_logoutIfInvalidated(this, $9bd0e0ec09375082$var$deleteAccount(this.auth, {
            idToken: idToken
        }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return {
            uid: this.uid,
            email: this.email || undefined,
            emailVerified: this.emailVerified,
            displayName: this.displayName || undefined,
            isAnonymous: this.isAnonymous,
            photoURL: this.photoURL || undefined,
            phoneNumber: this.phoneNumber || undefined,
            tenantId: this.tenantId || undefined,
            providerData: this.providerData.map((userInfo)=>({
                    ...userInfo
                })),
            stsTokenManager: this.stsTokenManager.toJSON(),
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId,
            ...this.metadata.toJSON(),
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey,
            appName: this.auth.name
        };
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || '';
    }
    static _fromJSON(auth, object) {
        const displayName = object.displayName ?? undefined;
        const email = object.email ?? undefined;
        const phoneNumber = object.phoneNumber ?? undefined;
        const photoURL = object.photoURL ?? undefined;
        const tenantId = object.tenantId ?? undefined;
        const _redirectEventId = object._redirectEventId ?? undefined;
        const createdAt = object.createdAt ?? undefined;
        const lastLoginAt = object.lastLoginAt ?? undefined;
        const { uid: uid, emailVerified: emailVerified, isAnonymous: isAnonymous, providerData: providerData, stsTokenManager: plainObjectTokenManager } = object;
        $9bd0e0ec09375082$export$24baa2b76016ce0e(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const stsTokenManager = $9bd0e0ec09375082$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        $9bd0e0ec09375082$export$24baa2b76016ce0e(typeof uid === 'string', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $9bd0e0ec09375082$var$assertStringOrUndefined(displayName, auth.name);
        $9bd0e0ec09375082$var$assertStringOrUndefined(email, auth.name);
        $9bd0e0ec09375082$export$24baa2b76016ce0e(typeof emailVerified === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $9bd0e0ec09375082$export$24baa2b76016ce0e(typeof isAnonymous === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $9bd0e0ec09375082$var$assertStringOrUndefined(phoneNumber, auth.name);
        $9bd0e0ec09375082$var$assertStringOrUndefined(photoURL, auth.name);
        $9bd0e0ec09375082$var$assertStringOrUndefined(tenantId, auth.name);
        $9bd0e0ec09375082$var$assertStringOrUndefined(_redirectEventId, auth.name);
        $9bd0e0ec09375082$var$assertStringOrUndefined(createdAt, auth.name);
        $9bd0e0ec09375082$var$assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new $9bd0e0ec09375082$export$91477dc880baac21({
            uid: uid,
            auth: auth,
            email: email,
            emailVerified: emailVerified,
            displayName: displayName,
            isAnonymous: isAnonymous,
            photoURL: photoURL,
            phoneNumber: phoneNumber,
            tenantId: tenantId,
            stsTokenManager: stsTokenManager,
            createdAt: createdAt,
            lastLoginAt: lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) user.providerData = providerData.map((userInfo)=>({
                ...userInfo
            }));
        if (_redirectEventId) user._redirectEventId = _redirectEventId;
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new $9bd0e0ec09375082$var$StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new $9bd0e0ec09375082$export$91477dc880baac21({
            uid: idTokenResponse.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await $9bd0e0ec09375082$var$_reloadWithoutSaving(user);
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromGetAccountInfoResponse(auth, response, idToken) {
        const coreAccount = response.users[0];
        $9bd0e0ec09375082$export$24baa2b76016ce0e(coreAccount.localId !== undefined, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const providerData = coreAccount.providerUserInfo !== undefined ? $9bd0e0ec09375082$var$extractProviderData(coreAccount.providerUserInfo) : [];
        const isAnonymous = !(coreAccount.email && coreAccount.passwordHash) && !providerData?.length;
        const stsTokenManager = new $9bd0e0ec09375082$var$StsTokenManager();
        stsTokenManager.updateFromIdToken(idToken);
        // Initialize the Firebase Auth user.
        const user = new $9bd0e0ec09375082$export$91477dc880baac21({
            uid: coreAccount.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // update the user with data from the GetAccountInfo response.
        const updates = {
            uid: coreAccount.localId,
            displayName: coreAccount.displayName || null,
            photoURL: coreAccount.photoUrl || null,
            email: coreAccount.email || null,
            emailVerified: coreAccount.emailVerified || false,
            phoneNumber: coreAccount.phoneNumber || null,
            tenantId: coreAccount.tenantId || null,
            providerData: providerData,
            metadata: new $9bd0e0ec09375082$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
            isAnonymous: !(coreAccount.email && coreAccount.passwordHash) && !providerData?.length
        };
        Object.assign(user, updates);
        return user;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9bd0e0ec09375082$var$instanceCache = new Map();
function $9bd0e0ec09375082$export$cf2f7c5792f80b46(cls) {
    $9bd0e0ec09375082$export$d66dc83d8cfc8dd(cls instanceof Function, 'Expected a class definition');
    let instance = $9bd0e0ec09375082$var$instanceCache.get(cls);
    if (instance) {
        $9bd0e0ec09375082$export$d66dc83d8cfc8dd(instance instanceof cls, 'Instance stored in cache mismatched with class');
        return instance;
    }
    instance = new cls();
    $9bd0e0ec09375082$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9bd0e0ec09375082$var$InMemoryPersistence {
    constructor(){
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
$9bd0e0ec09375082$var$InMemoryPersistence.type = 'NONE';
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ const $9bd0e0ec09375082$export$e7c866399fa523f5 = $9bd0e0ec09375082$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9bd0e0ec09375082$export$53a70dd1ebbae346(key, apiKey, appName) {
    return `${"firebase" /* Namespace.PERSISTENCE */ }:${key}:${apiKey}:${appName}`;
}
class $9bd0e0ec09375082$var$PersistenceUserManager {
    constructor(persistence, auth, userKey){
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config: config, name: name } = this.auth;
        this.fullUserKey = $9bd0e0ec09375082$export$53a70dd1ebbae346(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $9bd0e0ec09375082$export$53a70dd1ebbae346("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        if (!blob) return null;
        if (typeof blob === 'string') {
            const response = await $9bd0e0ec09375082$var$getAccountInfo(this.auth, {
                idToken: blob
            }).catch(()=>undefined);
            if (!response) return null;
            return $9bd0e0ec09375082$export$91477dc880baac21._fromGetAccountInfoResponse(this.auth, response, blob);
        }
        return $9bd0e0ec09375082$export$91477dc880baac21._fromJSON(this.auth, blob);
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) return;
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) return this.setCurrentUser(currentUser);
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* KeyName.AUTH_USER */ ) {
        if (!persistenceHierarchy.length) return new $9bd0e0ec09375082$var$PersistenceUserManager($9bd0e0ec09375082$export$cf2f7c5792f80b46($9bd0e0ec09375082$export$e7c866399fa523f5), auth, userKey);
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (await persistence._isAvailable()) return persistence;
            return undefined;
        }))).filter((persistence)=>persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] || $9bd0e0ec09375082$export$cf2f7c5792f80b46($9bd0e0ec09375082$export$e7c866399fa523f5);
        const key = $9bd0e0ec09375082$export$53a70dd1ebbae346(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy)try {
            const blob = await persistence._get(key);
            if (blob) {
                let user;
                if (typeof blob === 'string') {
                    const response = await $9bd0e0ec09375082$var$getAccountInfo(auth, {
                        idToken: blob
                    }).catch(()=>undefined);
                    if (!response) break;
                    user = await $9bd0e0ec09375082$export$91477dc880baac21._fromGetAccountInfoResponse(auth, response, blob);
                } else user = $9bd0e0ec09375082$export$91477dc880baac21._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                if (persistence !== selectedPersistence) userToMigrate = user;
                selectedPersistence = persistence;
                break;
            }
        } catch  {}
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter((p)=>p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return new $9bd0e0ec09375082$var$PersistenceUserManager(selectedPersistence, auth, userKey);
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
        // we'll just let it bubble to surface the error.
        await selectedPersistence._set(key, userToMigrate.toJSON());
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (persistence !== selectedPersistence) try {
                await persistence._remove(key);
            } catch  {}
        }));
        return new $9bd0e0ec09375082$var$PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $9bd0e0ec09375082$var$_getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes('opera/') || ua.includes('opr/') || ua.includes('opios/')) return "Opera" /* BrowserName.OPERA */ ;
    else if ($9bd0e0ec09375082$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes('msie') || ua.includes('trident/')) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes('edge/')) return "Edge" /* BrowserName.EDGE */ ;
    else if ($9bd0e0ec09375082$var$_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes('silk/')) return "Silk" /* BrowserName.SILK */ ;
    else if ($9bd0e0ec09375082$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if ($9bd0e0ec09375082$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if ($9bd0e0ec09375082$var$_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes('chrome/') || $9bd0e0ec09375082$var$_isChromeIOS(ua)) && !ua.includes('edge/')) return "Chrome" /* BrowserName.CHROME */ ;
    else if ($9bd0e0ec09375082$export$9fa96a7d116ea3ce(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if (matches?.length === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function $9bd0e0ec09375082$var$_isFirefox(ua = (0, $3117f6f4eeb4c314$export$c36915b22ce77c19)()) {
    return /firefox\//i.test(ua);
}
function $9bd0e0ec09375082$var$_isSafari(userAgent = (0, $3117f6f4eeb4c314$export$c36915b22ce77c19)()) {
    const ua = userAgent.toLowerCase();
    return ua.includes('safari/') && !ua.includes('chrome/') && !ua.includes('crios/') && !ua.includes('android');
}
function $9bd0e0ec09375082$var$_isChromeIOS(ua = (0, $3117f6f4eeb4c314$export$c36915b22ce77c19)()) {
    return /crios\//i.test(ua);
}
function $9bd0e0ec09375082$var$_isIEMobile(ua = (0, $3117f6f4eeb4c314$export$c36915b22ce77c19)()) {
    return /iemobile/i.test(ua);
}
function $9bd0e0ec09375082$export$9fa96a7d116ea3ce(ua = (0, $3117f6f4eeb4c314$export$c36915b22ce77c19)()) {
    return /android/i.test(ua);
}
function $9bd0e0ec09375082$var$_isBlackBerry(ua = (0, $3117f6f4eeb4c314$export$c36915b22ce77c19)()) {
    return /blackberry/i.test(ua);
}
function $9bd0e0ec09375082$var$_isWebOS(ua = (0, $3117f6f4eeb4c314$export$c36915b22ce77c19)()) {
    return /webos/i.test(ua);
}
function $9bd0e0ec09375082$export$92108d983e8ee699(ua = (0, $3117f6f4eeb4c314$export$c36915b22ce77c19)()) {
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function $9bd0e0ec09375082$export$9d398bebfec1c039(ua = (0, $3117f6f4eeb4c314$export$c36915b22ce77c19)()) {
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $9bd0e0ec09375082$var$_isIOSStandalone(ua = (0, $3117f6f4eeb4c314$export$c36915b22ce77c19)()) {
    return $9bd0e0ec09375082$export$92108d983e8ee699(ua) && !!window.navigator?.standalone;
}
function $9bd0e0ec09375082$var$_isIE10() {
    return (0, $3117f6f4eeb4c314$export$7e7b1a9668aaed8)() && document.documentMode === 10;
}
function $9bd0e0ec09375082$var$_isMobileBrowser(ua = (0, $3117f6f4eeb4c314$export$c36915b22ce77c19)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return $9bd0e0ec09375082$export$92108d983e8ee699(ua) || $9bd0e0ec09375082$export$9fa96a7d116ea3ce(ua) || $9bd0e0ec09375082$var$_isWebOS(ua) || $9bd0e0ec09375082$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $9bd0e0ec09375082$var$_isIEMobile(ua);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $9bd0e0ec09375082$export$faec65b429be379(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $9bd0e0ec09375082$var$_getBrowserName((0, $3117f6f4eeb4c314$export$c36915b22ce77c19)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${$9bd0e0ec09375082$var$_getBrowserName((0, $3117f6f4eeb4c314$export$c36915b22ce77c19)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length ? frameworks.join(',') : 'FirebaseCore-web'; /* default value if no other framework is used */ 
    return `${reportedPlatform}/${"JsCore" /* ClientImplementation.CORE */ }/${0, $0c1331d0a001f5bc$export$31499a9cd224b78c}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9bd0e0ec09375082$var$AuthMiddlewareQueue {
    constructor(auth){
        this.auth = auth;
        this.queue = [];
    }
    pushCallback(callback, onAbort) {
        // The callback could be sync or async. Wrap it into a
        // function that is always async.
        const wrappedCallback = (user)=>new Promise((resolve, reject)=>{
                try {
                    const result = callback(user);
                    // Either resolve with existing promise or wrap a non-promise
                    // return value into a promise.
                    resolve(result);
                } catch (e) {
                    // Sync callback throws.
                    reject(e);
                }
            });
        // Attach the onAbort if present
        wrappedCallback.onAbort = onAbort;
        this.queue.push(wrappedCallback);
        const index = this.queue.length - 1;
        return ()=>{
            // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
            // indexing of other elements.
            this.queue[index] = ()=>Promise.resolve();
        };
    }
    async runMiddleware(nextUser) {
        if (this.auth.currentUser === nextUser) return;
        // While running the middleware, build a temporary stack of onAbort
        // callbacks to call if one middleware callback rejects.
        const onAbortStack = [];
        try {
            for (const beforeStateCallback of this.queue){
                await beforeStateCallback(nextUser);
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
            }
        } catch (e) {
            // Run all onAbort, with separate try/catch to ignore any errors and
            // continue
            onAbortStack.reverse();
            for (const onAbort of onAbortStack)try {
                onAbort();
            } catch (_) {
            /* swallow error */ }
            throw this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                originalMessage: e?.message
            });
        }
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Fetches the password policy for the currently set tenant or the project if no tenant is set.
 *
 * @param auth Auth object.
 * @param request Password policy request.
 * @returns Password policy response.
 */ async function $9bd0e0ec09375082$var$_getPasswordPolicy(auth, request = {}) {
    return $9bd0e0ec09375082$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/passwordPolicy" /* Endpoint.GET_PASSWORD_POLICY */ , $9bd0e0ec09375082$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Minimum min password length enforced by the backend, even if no minimum length is set.
const $9bd0e0ec09375082$var$MINIMUM_MIN_PASSWORD_LENGTH = 6;
/**
 * Stores password policy requirements and provides password validation against the policy.
 *
 * @internal
 */ class $9bd0e0ec09375082$var$PasswordPolicyImpl {
    constructor(response){
        // Only include custom strength options defined in the response.
        const responseOptions = response.customStrengthOptions;
        this.customStrengthOptions = {};
        // TODO: Remove once the backend is updated to include the minimum min password length instead of undefined when there is no minimum length set.
        this.customStrengthOptions.minPasswordLength = responseOptions.minPasswordLength ?? $9bd0e0ec09375082$var$MINIMUM_MIN_PASSWORD_LENGTH;
        if (responseOptions.maxPasswordLength) this.customStrengthOptions.maxPasswordLength = responseOptions.maxPasswordLength;
        if (responseOptions.containsLowercaseCharacter !== undefined) this.customStrengthOptions.containsLowercaseLetter = responseOptions.containsLowercaseCharacter;
        if (responseOptions.containsUppercaseCharacter !== undefined) this.customStrengthOptions.containsUppercaseLetter = responseOptions.containsUppercaseCharacter;
        if (responseOptions.containsNumericCharacter !== undefined) this.customStrengthOptions.containsNumericCharacter = responseOptions.containsNumericCharacter;
        if (responseOptions.containsNonAlphanumericCharacter !== undefined) this.customStrengthOptions.containsNonAlphanumericCharacter = responseOptions.containsNonAlphanumericCharacter;
        this.enforcementState = response.enforcementState;
        if (this.enforcementState === 'ENFORCEMENT_STATE_UNSPECIFIED') this.enforcementState = 'OFF';
        // Use an empty string if no non-alphanumeric characters are specified in the response.
        this.allowedNonAlphanumericCharacters = response.allowedNonAlphanumericCharacters?.join('') ?? '';
        this.forceUpgradeOnSignin = response.forceUpgradeOnSignin ?? false;
        this.schemaVersion = response.schemaVersion;
    }
    validatePassword(password) {
        const status = {
            isValid: true,
            passwordPolicy: this
        };
        // Check the password length and character options.
        this.validatePasswordLengthOptions(password, status);
        this.validatePasswordCharacterOptions(password, status);
        // Combine the status into single isValid property.
        status.isValid && (status.isValid = status.meetsMinPasswordLength ?? true);
        status.isValid && (status.isValid = status.meetsMaxPasswordLength ?? true);
        status.isValid && (status.isValid = status.containsLowercaseLetter ?? true);
        status.isValid && (status.isValid = status.containsUppercaseLetter ?? true);
        status.isValid && (status.isValid = status.containsNumericCharacter ?? true);
        status.isValid && (status.isValid = status.containsNonAlphanumericCharacter ?? true);
        return status;
    }
    /**
     * Validates that the password meets the length options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordLengthOptions(password, status) {
        const minPasswordLength = this.customStrengthOptions.minPasswordLength;
        const maxPasswordLength = this.customStrengthOptions.maxPasswordLength;
        if (minPasswordLength) status.meetsMinPasswordLength = password.length >= minPasswordLength;
        if (maxPasswordLength) status.meetsMaxPasswordLength = password.length <= maxPasswordLength;
    }
    /**
     * Validates that the password meets the character options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordCharacterOptions(password, status) {
        // Assign statuses for requirements even if the password is an empty string.
        this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ false, /* containsUppercaseCharacter= */ false, /* containsNumericCharacter= */ false, /* containsNonAlphanumericCharacter= */ false);
        let passwordChar;
        for(let i = 0; i < password.length; i++){
            passwordChar = password.charAt(i);
            this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ passwordChar >= 'a' && passwordChar <= 'z', /* containsUppercaseCharacter= */ passwordChar >= 'A' && passwordChar <= 'Z', /* containsNumericCharacter= */ passwordChar >= '0' && passwordChar <= '9', /* containsNonAlphanumericCharacter= */ this.allowedNonAlphanumericCharacters.includes(passwordChar));
        }
    }
    /**
     * Updates the running validation status with the statuses for the character options.
     * Expected to be called each time a character is processed to update each option status
     * based on the current character.
     *
     * @param status Validation status.
     * @param containsLowercaseCharacter Whether the character is a lowercase letter.
     * @param containsUppercaseCharacter Whether the character is an uppercase letter.
     * @param containsNumericCharacter Whether the character is a numeric character.
     * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
     */ updatePasswordCharacterOptionsStatuses(status, containsLowercaseCharacter, containsUppercaseCharacter, containsNumericCharacter, containsNonAlphanumericCharacter) {
        if (this.customStrengthOptions.containsLowercaseLetter) status.containsLowercaseLetter || (status.containsLowercaseLetter = containsLowercaseCharacter);
        if (this.customStrengthOptions.containsUppercaseLetter) status.containsUppercaseLetter || (status.containsUppercaseLetter = containsUppercaseCharacter);
        if (this.customStrengthOptions.containsNumericCharacter) status.containsNumericCharacter || (status.containsNumericCharacter = containsNumericCharacter);
        if (this.customStrengthOptions.containsNonAlphanumericCharacter) status.containsNonAlphanumericCharacter || (status.containsNonAlphanumericCharacter = containsNonAlphanumericCharacter);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9bd0e0ec09375082$export$9f4f30ee63539e24 {
    constructor(app, heartbeatServiceProvider, appCheckServiceProvider, config){
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $9bd0e0ec09375082$var$Subscription(this);
        this.idTokenSubscription = new $9bd0e0ec09375082$var$Subscription(this);
        this.beforeStateQueue = new $9bd0e0ec09375082$var$AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $9bd0e0ec09375082$var$_DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        this._projectPasswordPolicy = null;
        this._tenantPasswordPolicies = {};
        this._resolvePersistenceManagerAvailable = undefined;
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
        // TODO(jamesdaniels) explore less hacky way to do this, cookie authentication needs
        // persistenceMananger to be available. see _getFinalTarget for more context
        this._persistenceManagerAvailable = new Promise((resolve)=>this._resolvePersistenceManagerAvailable = resolve);
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) this._popupRedirectResolver = $9bd0e0ec09375082$export$cf2f7c5792f80b46(popupRedirectResolver);
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async ()=>{
            if (this._deleted) return;
            this.persistenceManager = await $9bd0e0ec09375082$var$PersistenceUserManager.create(this, persistenceHierarchy);
            this._resolvePersistenceManagerAvailable?.();
            if (this._deleted) return;
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if (this._popupRedirectResolver?._shouldInitProactively) // If this fails, don't halt auth loading
            try {
                await this._popupRedirectResolver._initialize(this);
            } catch (e) {
            /* Ignore the error */ }
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = this.currentUser?.uid || null;
            if (this._deleted) return;
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */ async _onStorageEvent() {
        if (this._deleted) return;
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
        return;
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        // Skip blocking callbacks, they should not apply to a change in another tab.
        await this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true);
    }
    async initializeCurrentUserFromIdToken(idToken) {
        try {
            const response = await $9bd0e0ec09375082$var$getAccountInfo(this, {
                idToken: idToken
            });
            const user = await $9bd0e0ec09375082$export$91477dc880baac21._fromGetAccountInfoResponse(this, response, idToken);
            await this.directlySetCurrentUser(user);
        } catch (err) {
            console.warn('FirebaseServerApp could not login user with provided authIdToken: ', err);
            await this.directlySetCurrentUser(null);
        }
    }
    async initializeCurrentUser(popupRedirectResolver) {
        if ((0, $0c1331d0a001f5bc$export$643c8bc6c389f34e)(this.app)) {
            const idToken = this.app.settings.authIdToken;
            if (idToken) // Start the auth operation in the next tick to allow a moment for the customer's app to
            // attach an emulator, if desired.
            return new Promise((resolve)=>{
                setTimeout(()=>this.initializeCurrentUserFromIdToken(idToken).then(resolve, resolve));
            });
            else return this.directlySetCurrentUser(null);
        }
        // First check to see if we have a pending redirect event.
        const previouslyStoredUser = await this.assertedPersistence.getCurrentUser();
        let futureCurrentUser = previouslyStoredUser;
        let needsTocheckMiddleware = false;
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = this.redirectUser?._redirectEventId;
            const storedUserEventId = futureCurrentUser?._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && result?.user) {
                futureCurrentUser = result.user;
                needsTocheckMiddleware = true;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!futureCurrentUser) return this.directlySetCurrentUser(null);
        if (!futureCurrentUser._redirectEventId) {
            // This isn't a redirect link operation, we can reload and bail.
            // First though, ensure that we check the middleware is happy.
            if (needsTocheckMiddleware) try {
                await this.beforeStateQueue.runMiddleware(futureCurrentUser);
            } catch (e) {
                futureCurrentUser = previouslyStoredUser;
                // We know this is available since the bit is only set when the
                // resolver is available
                this._popupRedirectResolver._overrideRedirectResult(this, ()=>Promise.reject(e));
            }
            if (futureCurrentUser) return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
            else return this.directlySetCurrentUser(null);
        }
        $9bd0e0ec09375082$export$24baa2b76016ce0e(this._popupRedirectResolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return this.directlySetCurrentUser(futureCurrentUser);
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        } catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await $9bd0e0ec09375082$var$_reloadWithoutSaving(user);
        } catch (e) {
            if (e?.code !== `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) // Something's wrong with the user's token. Log them out and remove
            // them from storage
            return this.directlySetCurrentUser(null);
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = $9bd0e0ec09375082$var$_getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        if ((0, $0c1331d0a001f5bc$export$643c8bc6c389f34e)(this.app)) return Promise.reject($9bd0e0ec09375082$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern ? (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(userExtern) : null;
        if (user) $9bd0e0ec09375082$export$24baa2b76016ce0e(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
        if (this._deleted) return;
        if (user) $9bd0e0ec09375082$export$24baa2b76016ce0e(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
        if (!skipBeforeStateCallbacks) await this.beforeStateQueue.runMiddleware(user);
        return this.queue(async ()=>{
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        if ((0, $0c1331d0a001f5bc$export$643c8bc6c389f34e)(this.app)) return Promise.reject($9bd0e0ec09375082$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // Run first, to block _setRedirectUser() if any callbacks fail.
        await this.beforeStateQueue.runMiddleware(null);
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) await this._setRedirectUser(null);
        // Prevent callbacks from being called again in _updateCurrentUser, as
        // they were already called in the first line.
        return this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true);
    }
    setPersistence(persistence) {
        if ((0, $0c1331d0a001f5bc$export$643c8bc6c389f34e)(this.app)) return Promise.reject($9bd0e0ec09375082$var$_serverAppCurrentUserOperationNotSupportedError(this));
        return this.queue(async ()=>{
            await this.assertedPersistence.setPersistence($9bd0e0ec09375082$export$cf2f7c5792f80b46(persistence));
        });
    }
    _getRecaptchaConfig() {
        if (this.tenantId == null) return this._agentRecaptchaConfig;
        else return this._tenantRecaptchaConfigs[this.tenantId];
    }
    async validatePassword(password) {
        if (!this._getPasswordPolicyInternal()) await this._updatePasswordPolicy();
        // Password policy will be defined after fetching.
        const passwordPolicy = this._getPasswordPolicyInternal();
        // Check that the policy schema version is supported by the SDK.
        // TODO: Update this logic to use a max supported policy schema version once we have multiple schema versions.
        if (passwordPolicy.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION) return Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , {}));
        return passwordPolicy.validatePassword(password);
    }
    _getPasswordPolicyInternal() {
        if (this.tenantId === null) return this._projectPasswordPolicy;
        else return this._tenantPasswordPolicies[this.tenantId];
    }
    async _updatePasswordPolicy() {
        const response = await $9bd0e0ec09375082$var$_getPasswordPolicy(this);
        const passwordPolicy = new $9bd0e0ec09375082$var$PasswordPolicyImpl(response);
        if (this.tenantId === null) this._projectPasswordPolicy = passwordPolicy;
        else this._tenantPasswordPolicies[this.tenantId] = passwordPolicy;
    }
    _getPersistenceType() {
        return this.assertedPersistence.persistence.type;
    }
    _getPersistence() {
        return this.assertedPersistence.persistence;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new (0, $3117f6f4eeb4c314$export$3fa6e1b18a3b2d40)('auth', 'Firebase', errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    beforeAuthStateChanged(callback, onAbort) {
        return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    authStateReady() {
        return new Promise((resolve, reject)=>{
            if (this.currentUser) resolve();
            else {
                const unsubscribe = this.onAuthStateChanged(()=>{
                    unsubscribe();
                    resolve();
                }, reject);
            }
        });
    }
    /**
     * Revokes the given access token. Currently only supports Apple OAuth access tokens.
     */ async revokeAccessToken(token) {
        if (this.currentUser) {
            const idToken = await this.currentUser.getIdToken();
            // Generalize this to accept other providers once supported.
            const request = {
                providerId: 'apple.com',
                tokenType: "ACCESS_TOKEN" /* TokenType.ACCESS_TOKEN */ ,
                token: token,
                idToken: idToken
            };
            if (this.tenantId != null) request.tenantId = this.tenantId;
            await $9bd0e0ec09375082$var$revokeToken(this, request);
        }
    }
    toJSON() {
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: this._currentUser?.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = popupRedirectResolver && $9bd0e0ec09375082$export$cf2f7c5792f80b46(popupRedirectResolver) || this._popupRedirectResolver;
            $9bd0e0ec09375082$export$24baa2b76016ce0e(resolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            this.redirectPersistenceManager = await $9bd0e0ec09375082$var$PersistenceUserManager.create(this, [
                $9bd0e0ec09375082$export$cf2f7c5792f80b46(resolver._redirectPersistence)
            ], "redirectUser" /* KeyName.REDIRECT_USER */ );
            this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) await this.queue(async ()=>{});
        if (this._currentUser?._redirectEventId === id) return this._currentUser;
        if (this.redirectUser?._redirectEventId === id) return this.redirectUser;
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(user));
    }
    /** Notifies listeners only if the user is current */ _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) this.notifyAuthListeners();
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) this._currentUser._startProactiveRefresh();
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) this._currentUser._stopProactiveRefresh();
    }
    /** Returns the current user cast as the internal type */ get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        if (!this._isInitialized) return;
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = this.currentUser?.uid ?? null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) return ()=>{};
        const cb = typeof nextOrObserver === 'function' ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
        let isUnsubscribed = false;
        const promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
        $9bd0e0ec09375082$export$24baa2b76016ce0e(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(()=>{
            if (isUnsubscribed) return;
            cb(this.currentUser);
        });
        if (typeof nextOrObserver === 'function') {
            const unsubscribe = subscription.addObserver(nextOrObserver, error, completed);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        } else {
            const unsubscribe = subscription.addObserver(nextOrObserver);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        }
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) this._currentUser._stopProactiveRefresh();
        if (user && this.isProactiveRefreshEnabled) user._startProactiveRefresh();
        this.currentUser = user;
        if (user) await this.assertedPersistence.setCurrentUser(user);
        else await this.assertedPersistence.removeCurrentUser();
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        $9bd0e0ec09375082$export$24baa2b76016ce0e(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) return;
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = $9bd0e0ec09375082$export$faec65b429be379(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ ]: this.clientVersion
        };
        if (this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = this.app.options.appId;
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await this.heartbeatServiceProvider.getImmediate({
            optional: true
        })?.getHeartbeatsHeader();
        if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
        // If the App Check service exists, add the App Check token in the headers
        const appCheckToken = await this._getAppCheckToken();
        if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
        return headers;
    }
    async _getAppCheckToken() {
        if ((0, $0c1331d0a001f5bc$export$643c8bc6c389f34e)(this.app) && this.app.settings.appCheckToken) return this.app.settings.appCheckToken;
        const appCheckTokenResult = await this.appCheckServiceProvider.getImmediate({
            optional: true
        })?.getToken();
        if (appCheckTokenResult?.error) // Context: appCheck.getToken() will never throw even if an error happened.
        // In the error case, a dummy token will be returned along with an error field describing
        // the error. In general, we shouldn't care about the error condition and just use
        // the token (actual or dummy) to send requests.
        $9bd0e0ec09375082$var$_logWarn(`Error while retrieving App Check token: ${appCheckTokenResult.error}`);
        return appCheckTokenResult?.token;
    }
}
/**
 * Method to be used to cast down to our private implementation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $9bd0e0ec09375082$export$23ebac1979863676(auth) {
    return (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(auth);
}
/** Helper class to wrap subscriber logic */ class $9bd0e0ec09375082$var$Subscription {
    constructor(auth){
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $3117f6f4eeb4c314$export$364097d812234b3f)((observer)=>this.observer = observer);
    }
    get next() {
        $9bd0e0ec09375082$export$24baa2b76016ce0e(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.observer.next.bind(this.observer);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $9bd0e0ec09375082$var$externalJSProvider = {
    async loadJS () {
        throw new Error('Unable to load external scripts');
    },
    recaptchaV2Script: '',
    recaptchaEnterpriseScript: '',
    gapiScript: ''
};
function $9bd0e0ec09375082$var$_setExternalJSProvider(p) {
    $9bd0e0ec09375082$var$externalJSProvider = p;
}
function $9bd0e0ec09375082$var$_loadJS(url) {
    return $9bd0e0ec09375082$var$externalJSProvider.loadJS(url);
}
function $9bd0e0ec09375082$var$_recaptchaV2ScriptUrl() {
    return $9bd0e0ec09375082$var$externalJSProvider.recaptchaV2Script;
}
function $9bd0e0ec09375082$var$_recaptchaEnterpriseScriptUrl() {
    return $9bd0e0ec09375082$var$externalJSProvider.recaptchaEnterpriseScript;
}
function $9bd0e0ec09375082$var$_gapiScriptUrl() {
    return $9bd0e0ec09375082$var$externalJSProvider.gapiScript;
}
function $9bd0e0ec09375082$var$_generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9bd0e0ec09375082$var$_SOLVE_TIME_MS = 500;
const $9bd0e0ec09375082$var$_EXPIRATION_TIME_MS = 60000;
const $9bd0e0ec09375082$var$_WIDGET_ID_START = 1000000000000;
class $9bd0e0ec09375082$var$MockReCaptcha {
    constructor(auth){
        this.auth = auth;
        this.counter = $9bd0e0ec09375082$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new $9bd0e0ec09375082$var$MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        const id = optWidgetId || $9bd0e0ec09375082$var$_WIDGET_ID_START;
        this._widgets.get(id)?.delete();
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        const id = optWidgetId || $9bd0e0ec09375082$var$_WIDGET_ID_START;
        return this._widgets.get(id)?.getResponse() || '';
    }
    async execute(optWidgetId) {
        const id = optWidgetId || $9bd0e0ec09375082$var$_WIDGET_ID_START;
        this._widgets.get(id)?.execute();
        return '';
    }
}
class $9bd0e0ec09375082$var$MockGreCAPTCHATopLevel {
    constructor(){
        this.enterprise = new $9bd0e0ec09375082$var$MockGreCAPTCHA();
    }
    ready(callback) {
        callback();
    }
    execute(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _siteKey, _options) {
        return Promise.resolve('token');
    }
    render(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _container, _parameters) {
        return '';
    }
}
class $9bd0e0ec09375082$var$MockGreCAPTCHA {
    ready(callback) {
        callback();
    }
    execute(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _siteKey, _options) {
        return Promise.resolve('token');
    }
    render(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _container, _parameters) {
        return '';
    }
}
class $9bd0e0ec09375082$var$MockWidget {
    constructor(containerOrId, appName, params){
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = ()=>{
            this.execute();
        };
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        $9bd0e0ec09375082$export$24baa2b76016ce0e(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== 'invisible';
        if (this.isVisible) this.execute();
        else this.container.addEventListener('click', this.clickHandler);
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener('click', this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) return;
        this.timerId = window.setTimeout(()=>{
            this.responseToken = $9bd0e0ec09375082$var$generateRandomAlphaNumericString(50);
            const { callback: callback, 'expired-callback': expiredCallback } = this.params;
            if (callback) try {
                callback(this.responseToken);
            } catch (e) {}
            this.timerId = window.setTimeout(()=>{
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) try {
                    expiredCallback();
                } catch (e) {}
                if (this.isVisible) this.execute();
            }, $9bd0e0ec09375082$var$_EXPIRATION_TIME_MS);
        }, $9bd0e0ec09375082$var$_SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) throw new Error('reCAPTCHA mock was already deleted!');
    }
}
function $9bd0e0ec09375082$var$generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for(let i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join('');
}
/* eslint-disable @typescript-eslint/no-require-imports */ const $9bd0e0ec09375082$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = 'recaptcha-enterprise';
const $9bd0e0ec09375082$var$FAKE_TOKEN = 'NO_RECAPTCHA';
class $9bd0e0ec09375082$var$RecaptchaEnterpriseVerifier {
    /**
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     */ constructor(authExtern){
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = $9bd0e0ec09375082$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = $9bd0e0ec09375082$export$23ebac1979863676(authExtern);
    }
    /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ async verify(action = 'verify', forceRefresh = false) {
        async function retrieveSiteKey(auth) {
            if (!forceRefresh) {
                if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return auth._agentRecaptchaConfig.siteKey;
                if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return auth._tenantRecaptchaConfigs[auth.tenantId].siteKey;
            }
            return new Promise(async (resolve, reject)=>{
                $9bd0e0ec09375082$var$getRecaptchaConfig(auth, {
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }).then((response)=>{
                    if (response.recaptchaKey === undefined) reject(new Error('recaptcha Enterprise site key undefined'));
                    else {
                        const config = new $9bd0e0ec09375082$var$RecaptchaConfig(response);
                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                        return resolve(config.siteKey);
                    }
                }).catch((error)=>{
                    reject(error);
                });
            });
        }
        function retrieveRecaptchaToken(siteKey, resolve, reject) {
            const grecaptcha = window.grecaptcha;
            if ($9bd0e0ec09375082$var$isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(()=>{
                grecaptcha.enterprise.execute(siteKey, {
                    action: action
                }).then((token)=>{
                    resolve(token);
                }).catch(()=>{
                    resolve($9bd0e0ec09375082$var$FAKE_TOKEN);
                });
            });
            else reject(Error('No reCAPTCHA enterprise script loaded.'));
        }
        // Returns Promise for a mock token when appVerificationDisabledForTesting is true.
        if (this.auth.settings.appVerificationDisabledForTesting) {
            const mockRecaptcha = new $9bd0e0ec09375082$var$MockGreCAPTCHATopLevel();
            return mockRecaptcha.execute('siteKey', {
                action: 'verify'
            });
        }
        return new Promise((resolve, reject)=>{
            retrieveSiteKey(this.auth).then((siteKey)=>{
                if (!forceRefresh && $9bd0e0ec09375082$var$isEnterprise(window.grecaptcha)) retrieveRecaptchaToken(siteKey, resolve, reject);
                else {
                    if (typeof window === 'undefined') {
                        reject(new Error('RecaptchaVerifier is only supported in browser'));
                        return;
                    }
                    let url = $9bd0e0ec09375082$var$_recaptchaEnterpriseScriptUrl();
                    if (url.length !== 0) url += siteKey;
                    $9bd0e0ec09375082$var$_loadJS(url).then(()=>{
                        retrieveRecaptchaToken(siteKey, resolve, reject);
                    }).catch((error)=>{
                        reject(error);
                    });
                }
            }).catch((error)=>{
                reject(error);
            });
        });
    }
}
async function $9bd0e0ec09375082$var$injectRecaptchaFields(auth, request, action, isCaptchaResp = false, isFakeToken = false) {
    const verifier = new $9bd0e0ec09375082$var$RecaptchaEnterpriseVerifier(auth);
    let captchaResponse;
    if (isFakeToken) captchaResponse = $9bd0e0ec09375082$var$FAKE_TOKEN;
    else try {
        captchaResponse = await verifier.verify(action);
    } catch (error) {
        captchaResponse = await verifier.verify(action, true);
    }
    const newRequest = {
        ...request
    };
    if (action === "mfaSmsEnrollment" /* RecaptchaActionName.MFA_SMS_ENROLLMENT */  || action === "mfaSmsSignIn" /* RecaptchaActionName.MFA_SMS_SIGNIN */ ) {
        if ('phoneEnrollmentInfo' in newRequest) {
            const phoneNumber = newRequest.phoneEnrollmentInfo.phoneNumber;
            const recaptchaToken = newRequest.phoneEnrollmentInfo.recaptchaToken;
            Object.assign(newRequest, {
                'phoneEnrollmentInfo': {
                    phoneNumber: phoneNumber,
                    recaptchaToken: recaptchaToken,
                    captchaResponse: captchaResponse,
                    'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }
            });
        } else if ('phoneSignInInfo' in newRequest) {
            const recaptchaToken = newRequest.phoneSignInInfo.recaptchaToken;
            Object.assign(newRequest, {
                'phoneSignInInfo': {
                    recaptchaToken: recaptchaToken,
                    captchaResponse: captchaResponse,
                    'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }
            });
        }
        return newRequest;
    }
    if (!isCaptchaResp) Object.assign(newRequest, {
        captchaResponse: captchaResponse
    });
    else Object.assign(newRequest, {
        'captchaResp': captchaResponse
    });
    Object.assign(newRequest, {
        'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    });
    Object.assign(newRequest, {
        'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    return newRequest;
}
async function $9bd0e0ec09375082$var$handleRecaptchaFlow(authInstance, request, actionName, actionMethod, recaptchaAuthProvider) {
    if (recaptchaAuthProvider === "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ ) {
        if (authInstance._getRecaptchaConfig()?.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ )) {
            const requestWithRecaptcha = await $9bd0e0ec09375082$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
            return actionMethod(authInstance, requestWithRecaptcha);
        } else return actionMethod(authInstance, request).catch(async (error)=>{
            if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
                console.log(`${actionName} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`);
                const requestWithRecaptcha = await $9bd0e0ec09375082$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
                return actionMethod(authInstance, requestWithRecaptcha);
            } else return Promise.reject(error);
        });
    } else if (recaptchaAuthProvider === "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ ) {
        if (authInstance._getRecaptchaConfig()?.isProviderEnabled("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ )) {
            const requestWithRecaptcha = await $9bd0e0ec09375082$var$injectRecaptchaFields(authInstance, request, actionName);
            return actionMethod(authInstance, requestWithRecaptcha).catch(async (error)=>{
                if (authInstance._getRecaptchaConfig()?.getProviderEnforcementState("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ ) === "AUDIT" /* EnforcementState.AUDIT */ ) // AUDIT mode
                {
                    if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }` || error.code === `auth/${"invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ }`) {
                        console.log(`Failed to verify with reCAPTCHA Enterprise. Automatically triggering the reCAPTCHA v2 flow to complete the ${actionName} flow.`);
                        // reCAPTCHA Enterprise token is missing or reCAPTCHA Enterprise token
                        // check fails.
                        // Fallback to reCAPTCHA v2 flow.
                        const requestWithRecaptchaFields = await $9bd0e0ec09375082$var$injectRecaptchaFields(authInstance, request, actionName, false, true // isFakeToken
                        );
                        // This will call the PhoneApiCaller to fetch and inject reCAPTCHA v2 token.
                        return actionMethod(authInstance, requestWithRecaptchaFields);
                    }
                }
                // ENFORCE mode or AUDIT mode with any other error.
                return Promise.reject(error);
            });
        } else {
            // Do reCAPTCHA v2 flow.
            const requestWithRecaptchaFields = await $9bd0e0ec09375082$var$injectRecaptchaFields(authInstance, request, actionName, false, true // isFakeToken
            );
            // This will call the PhoneApiCaller to fetch and inject v2 token.
            return actionMethod(authInstance, requestWithRecaptchaFields);
        }
    } else return Promise.reject(recaptchaAuthProvider + ' provider is not supported.');
}
async function $9bd0e0ec09375082$var$_initializeRecaptchaConfig(auth) {
    const authInternal = $9bd0e0ec09375082$export$23ebac1979863676(auth);
    const response = await $9bd0e0ec09375082$var$getRecaptchaConfig(authInternal, {
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
        version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    const config = new $9bd0e0ec09375082$var$RecaptchaConfig(response);
    if (authInternal.tenantId == null) authInternal._agentRecaptchaConfig = config;
    else authInternal._tenantRecaptchaConfigs[authInternal.tenantId] = config;
    if (config.isAnyProviderEnabled()) {
        const verifier = new $9bd0e0ec09375082$var$RecaptchaEnterpriseVerifier(authInternal);
        verifier.verify();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $9bd0e0ec09375082$export$3466f893ebf79586(app, deps) {
    const provider = (0, $0c1331d0a001f5bc$export$fa0d6da0f5838f50)(app, 'auth');
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0, $3117f6f4eeb4c314$export$9cb4719e2e525b7a)(initialOptions, deps ?? {})) return auth;
        else $9bd0e0ec09375082$export$28f7fcd39efa255(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    const auth = provider.initialize({
        options: deps
    });
    return auth;
}
function $9bd0e0ec09375082$var$_initializeAuthInstance(auth, deps) {
    const persistence = deps?.persistence || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($9bd0e0ec09375082$export$cf2f7c5792f80b46);
    if (deps?.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps?.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $9bd0e0ec09375082$export$61196ced6d74a310(auth, url, options) {
    const authInternal = $9bd0e0ec09375082$export$23ebac1979863676(auth);
    $9bd0e0ec09375082$export$24baa2b76016ce0e(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    const disableWarnings = !!options?.disableWarnings;
    const protocol = $9bd0e0ec09375082$var$extractProtocol(url);
    const { host: host, port: port } = $9bd0e0ec09375082$var$extractHostAndPort(url);
    const portStr = port === null ? '' : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    const emulator = {
        url: `${protocol}//${host}${portStr}/`
    };
    const emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(':', ''),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    // There are a few scenarios to guard against if the Auth instance has already started:
    if (!authInternal._canInitEmulator) {
        // Applications may not initialize the emulator for the first time if Auth has already started
        // to make network requests.
        $9bd0e0ec09375082$export$24baa2b76016ce0e(authInternal.config.emulator && authInternal.emulatorConfig, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
        // Applications may not alter the configuration of the emulator (aka pass a different config)
        // once Auth has started to make network requests.
        $9bd0e0ec09375082$export$24baa2b76016ce0e((0, $3117f6f4eeb4c314$export$9cb4719e2e525b7a)(emulator, authInternal.config.emulator) && (0, $3117f6f4eeb4c314$export$9cb4719e2e525b7a)(emulatorConfig, authInternal.emulatorConfig), authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
        // It's valid, however, to invoke connectAuthEmulator() after Auth has started making
        // connections, so long as the config matches the existing config. This results in a no-op.
        return;
    }
    authInternal.config.emulator = emulator;
    authInternal.emulatorConfig = emulatorConfig;
    authInternal.settings.appVerificationDisabledForTesting = true;
    // Workaround to get cookies in Firebase Studio
    if ((0, $3117f6f4eeb4c314$export$5b4d24b45140ad90)(host)) {
        (0, $3117f6f4eeb4c314$export$c0f0d0ce4283a937)(`${protocol}//${host}${portStr}`);
        (0, $3117f6f4eeb4c314$export$fd3d2954543183b1)('Auth', true);
    } else if (!disableWarnings) $9bd0e0ec09375082$var$emitEmulatorWarning();
}
function $9bd0e0ec09375082$var$extractProtocol(url) {
    const protocolEnd = url.indexOf(':');
    return protocolEnd < 0 ? '' : url.substr(0, protocolEnd + 1);
}
function $9bd0e0ec09375082$var$extractHostAndPort(url) {
    const protocol = $9bd0e0ec09375082$var$extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: '',
        port: null
    };
    const hostAndPort = authority[2].split('@').pop() || ''; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return {
            host: host,
            port: $9bd0e0ec09375082$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        const [host, port] = hostAndPort.split(':');
        return {
            host: host,
            port: $9bd0e0ec09375082$var$parsePort(port)
        };
    }
}
function $9bd0e0ec09375082$var$parsePort(portStr) {
    if (!portStr) return null;
    const port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $9bd0e0ec09375082$var$emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement('p');
        const sty = el.style;
        el.innerText = 'Running in emulator mode. Do not use with production credentials.';
        sty.position = 'fixed';
        sty.width = '100%';
        sty.backgroundColor = '#ffffff';
        sty.border = '.1em solid #000000';
        sty.color = '#b50000';
        sty.bottom = '0px';
        sty.left = '0px';
        sty.margin = '0px';
        sty.zIndex = '10000';
        sty.textAlign = 'center';
        el.classList.add('firebase-emulator-warning');
        document.body.appendChild(el);
    }
    if (typeof console !== 'undefined' && typeof console.info === 'function') console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $9bd0e0ec09375082$export$3a1a48c8f6ef640e {
    /** @internal */ constructor(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod){
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ toJSON() {
        return $9bd0e0ec09375082$var$debugFail('not implemented');
    }
    /** @internal */ _getIdTokenResponse(_auth) {
        return $9bd0e0ec09375082$var$debugFail('not implemented');
    }
    /** @internal */ _linkToIdToken(_auth, _idToken) {
        return $9bd0e0ec09375082$var$debugFail('not implemented');
    }
    /** @internal */ _getReauthenticationResolver(_auth) {
        return $9bd0e0ec09375082$var$debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9bd0e0ec09375082$var$resetPassword(auth, request) {
    return $9bd0e0ec09375082$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , $9bd0e0ec09375082$var$_addTidIfNecessary(auth, request));
}
async function $9bd0e0ec09375082$var$updateEmailPassword(auth, request) {
    return $9bd0e0ec09375082$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
// Used for linking an email/password account to an existing idToken. Uses the same request/response
// format as updateEmailPassword.
async function $9bd0e0ec09375082$var$linkEmailPassword(auth, request) {
    return $9bd0e0ec09375082$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , request);
}
async function $9bd0e0ec09375082$var$applyActionCode$1(auth, request) {
    return $9bd0e0ec09375082$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , $9bd0e0ec09375082$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9bd0e0ec09375082$var$signInWithPassword(auth, request) {
    return $9bd0e0ec09375082$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , $9bd0e0ec09375082$var$_addTidIfNecessary(auth, request));
}
async function $9bd0e0ec09375082$var$sendOobCode(auth, request) {
    return $9bd0e0ec09375082$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , $9bd0e0ec09375082$var$_addTidIfNecessary(auth, request));
}
async function $9bd0e0ec09375082$var$sendEmailVerification$1(auth, request) {
    return $9bd0e0ec09375082$var$sendOobCode(auth, request);
}
async function $9bd0e0ec09375082$var$sendPasswordResetEmail$1(auth, request) {
    return $9bd0e0ec09375082$var$sendOobCode(auth, request);
}
async function $9bd0e0ec09375082$var$sendSignInLinkToEmail$1(auth, request) {
    return $9bd0e0ec09375082$var$sendOobCode(auth, request);
}
async function $9bd0e0ec09375082$var$verifyAndChangeEmail(auth, request) {
    return $9bd0e0ec09375082$var$sendOobCode(auth, request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9bd0e0ec09375082$var$signInWithEmailLink$1(auth, request) {
    return $9bd0e0ec09375082$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $9bd0e0ec09375082$var$_addTidIfNecessary(auth, request));
}
async function $9bd0e0ec09375082$var$signInWithEmailLinkForLinking(auth, request) {
    return $9bd0e0ec09375082$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $9bd0e0ec09375082$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ class $9bd0e0ec09375082$export$a07804094c3ecf2d extends $9bd0e0ec09375082$export$3a1a48c8f6ef640e {
    /** @internal */ constructor(/** @internal */ _email, /** @internal */ _password, signInMethod, /** @internal */ _tenantId = null){
        super("password" /* ProviderId.PASSWORD */ , signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */ static _fromEmailAndPassword(email, password) {
        return new $9bd0e0ec09375082$export$a07804094c3ecf2d(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
    }
    /** @internal */ static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new $9bd0e0ec09375082$export$a07804094c3ecf2d(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        if (obj?.email && obj?.password) {
            if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
            else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
        return null;
    }
    /** @internal */ async _getIdTokenResponse(auth) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $9bd0e0ec09375082$var$handleRecaptchaFlow(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ , $9bd0e0ec09375082$var$signInWithPassword, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $9bd0e0ec09375082$var$signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $9bd0e0ec09375082$export$28f7fcd39efa255(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ async _linkToIdToken(auth, idToken) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    idToken: idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $9bd0e0ec09375082$var$handleRecaptchaFlow(auth, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $9bd0e0ec09375082$var$linkEmailPassword, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $9bd0e0ec09375082$var$signInWithEmailLinkForLinking(auth, {
                    idToken: idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $9bd0e0ec09375082$export$28f7fcd39efa255(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9bd0e0ec09375082$var$signInWithIdp(auth, request) {
    return $9bd0e0ec09375082$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , $9bd0e0ec09375082$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9bd0e0ec09375082$var$IDP_REQUEST_URI$1 = 'http://localhost';
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $9bd0e0ec09375082$export$3722cfe417b6ed86 extends $9bd0e0ec09375082$export$3a1a48c8f6ef640e {
    constructor(){
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */ static _fromParams(params) {
        const cred = new $9bd0e0ec09375082$export$3722cfe417b6ed86(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) cred.idToken = params.idToken;
            if (params.accessToken) cred.accessToken = params.accessToken;
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
            if (params.pendingToken) cred.pendingToken = params.pendingToken;
        } else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        } else $9bd0e0ec09375082$export$28f7fcd39efa255("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, ...rest } = obj;
        if (!providerId || !signInMethod) return null;
        const cred = new $9bd0e0ec09375082$export$3722cfe417b6ed86(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $9bd0e0ec09375082$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $9bd0e0ec09375082$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $9bd0e0ec09375082$var$signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: $9bd0e0ec09375082$var$IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) request.pendingToken = this.pendingToken;
        else {
            const postBody = {};
            if (this.idToken) postBody['id_token'] = this.idToken;
            if (this.accessToken) postBody['access_token'] = this.accessToken;
            if (this.secret) postBody['oauth_token_secret'] = this.secret;
            postBody['providerId'] = this.providerId;
            if (this.nonce && !this.pendingToken) postBody['nonce'] = this.nonce;
            request.postBody = (0, $3117f6f4eeb4c314$export$ac4103b836844853)(postBody);
        }
        return request;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9bd0e0ec09375082$var$sendPhoneVerificationCode(auth, request) {
    return $9bd0e0ec09375082$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , $9bd0e0ec09375082$var$_addTidIfNecessary(auth, request));
}
async function $9bd0e0ec09375082$var$signInWithPhoneNumber$1(auth, request) {
    return $9bd0e0ec09375082$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $9bd0e0ec09375082$var$_addTidIfNecessary(auth, request));
}
async function $9bd0e0ec09375082$var$linkWithPhoneNumber$1(auth, request) {
    const response = await $9bd0e0ec09375082$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $9bd0e0ec09375082$var$_addTidIfNecessary(auth, request));
    if (response.temporaryProof) throw $9bd0e0ec09375082$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
    return response;
}
const $9bd0e0ec09375082$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ 
};
async function $9bd0e0ec09375082$var$verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = {
        ...request,
        operation: 'REAUTH'
    };
    return $9bd0e0ec09375082$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $9bd0e0ec09375082$var$_addTidIfNecessary(auth, apiRequest), $9bd0e0ec09375082$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ class $9bd0e0ec09375082$export$3a6d5c9ae78a2c08 extends $9bd0e0ec09375082$export$3a1a48c8f6ef640e {
    constructor(params){
        super("phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        this.params = params;
    }
    /** @internal */ static _fromVerification(verificationId, verificationCode) {
        return new $9bd0e0ec09375082$export$3a6d5c9ae78a2c08({
            verificationId: verificationId,
            verificationCode: verificationCode
        });
    }
    /** @internal */ static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new $9bd0e0ec09375082$export$3a6d5c9ae78a2c08({
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
    /** @internal */ _getIdTokenResponse(auth) {
        return $9bd0e0ec09375082$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        return $9bd0e0ec09375082$var$linkWithPhoneNumber$1(auth, {
            idToken: idToken,
            ...this._makeVerificationRequest()
        });
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return $9bd0e0ec09375082$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */ _makeVerificationRequest() {
        const { temporaryProof: temporaryProof, phoneNumber: phoneNumber, verificationId: verificationId, verificationCode: verificationCode } = this.params;
        if (temporaryProof && phoneNumber) return {
            temporaryProof: temporaryProof,
            phoneNumber: phoneNumber
        };
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
        if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
        if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
        if (this.params.verificationId) obj.verificationId = this.params.verificationId;
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */ static fromJSON(json) {
        if (typeof json === 'string') json = JSON.parse(json);
        const { verificationId: verificationId, verificationCode: verificationCode, phoneNumber: phoneNumber, temporaryProof: temporaryProof } = json;
        if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
        return new $9bd0e0ec09375082$export$3a6d5c9ae78a2c08({
            verificationId: verificationId,
            verificationCode: verificationCode,
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $9bd0e0ec09375082$var$parseMode(mode) {
    switch(mode){
        case 'recoverEmail':
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case 'resetPassword':
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case 'signIn':
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case 'verifyEmail':
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case 'verifyAndChangeEmail':
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case 'revertSecondFactorAddition':
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $9bd0e0ec09375082$var$parseDeepLink(url) {
    const link = (0, $3117f6f4eeb4c314$export$c1271ca4c8a70741)((0, $3117f6f4eeb4c314$export$1a8408415472d8ed)(url))['link'];
    // Double link case (automatic redirect).
    const doubleDeepLink = link ? (0, $3117f6f4eeb4c314$export$c1271ca4c8a70741)((0, $3117f6f4eeb4c314$export$1a8408415472d8ed)(link))['deep_link_id'] : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0, $3117f6f4eeb4c314$export$c1271ca4c8a70741)((0, $3117f6f4eeb4c314$export$1a8408415472d8ed)(url))['deep_link_id'];
    const iOSDoubleDeepLink = iOSDeepLink ? (0, $3117f6f4eeb4c314$export$c1271ca4c8a70741)((0, $3117f6f4eeb4c314$export$1a8408415472d8ed)(iOSDeepLink))['link'] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ class $9bd0e0ec09375082$export$3b513254972cfc9c {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */ constructor(actionLink){
        const searchParams = (0, $3117f6f4eeb4c314$export$c1271ca4c8a70741)((0, $3117f6f4eeb4c314$export$1a8408415472d8ed)(actionLink));
        const apiKey = searchParams["apiKey" /* QueryField.API_KEY */ ] ?? null;
        const code = searchParams["oobCode" /* QueryField.CODE */ ] ?? null;
        const operation = $9bd0e0ec09375082$var$parseMode(searchParams["mode" /* QueryField.MODE */ ] ?? null);
        // Validate API key, code and mode.
        $9bd0e0ec09375082$export$24baa2b76016ce0e(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ] ?? null;
        this.languageCode = searchParams["lang" /* QueryField.LANGUAGE_CODE */ ] ?? null;
        this.tenantId = searchParams["tenantId" /* QueryField.TENANT_ID */ ] ?? null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ static parseLink(link) {
        const actionLink = $9bd0e0ec09375082$var$parseDeepLink(link);
        try {
            return new $9bd0e0ec09375082$export$3b513254972cfc9c(actionLink);
        } catch  {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $9bd0e0ec09375082$export$21579262ef46735b(link) {
    return $9bd0e0ec09375082$export$3b513254972cfc9c.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ class $9bd0e0ec09375082$export$71cec2538cb2c617 {
    constructor(){
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = $9bd0e0ec09375082$export$71cec2538cb2c617.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ static credential(email, password) {
        return $9bd0e0ec09375082$export$a07804094c3ecf2d._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ static credentialWithLink(email, emailLink) {
        const actionCodeUrl = $9bd0e0ec09375082$export$3b513254972cfc9c.parseLink(emailLink);
        $9bd0e0ec09375082$export$24baa2b76016ce0e(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $9bd0e0ec09375082$export$a07804094c3ecf2d._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $9bd0e0ec09375082$export$71cec2538cb2c617.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $9bd0e0ec09375082$export$71cec2538cb2c617.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $9bd0e0ec09375082$export$71cec2538cb2c617.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ class $9bd0e0ec09375082$var$FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */ constructor(providerId){
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */ getCustomParameters() {
        return this.customParameters;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ class $9bd0e0ec09375082$var$BaseOAuthProvider extends $9bd0e0ec09375082$var$FederatedAuthProvider {
    constructor(){
        super(...arguments);
        /** @internal */ this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) this.scopes.push(scope);
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */ getScopes() {
        return [
            ...this.scopes
        ];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $9bd0e0ec09375082$export$71511d61b312f219 extends $9bd0e0ec09375082$var$BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        $9bd0e0ec09375082$export$24baa2b76016ce0e('providerId' in obj && 'signInMethod' in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $9bd0e0ec09375082$export$3722cfe417b6ed86._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ credential(params) {
        return this._credential({
            ...params,
            nonce: params.rawNonce
        });
    }
    /** An internal credential method that accepts more permissive options */ _credential(params) {
        $9bd0e0ec09375082$export$24baa2b76016ce0e(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        // For OAuthCredential, sign in method is same as providerId.
        return $9bd0e0ec09375082$export$3722cfe417b6ed86._fromParams({
            ...params,
            providerId: this.providerId,
            signInMethod: this.providerId
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $9bd0e0ec09375082$export$71511d61b312f219.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $9bd0e0ec09375082$export$71511d61b312f219.oauthCredentialFromTaggedObject(error.customData || {});
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret, pendingToken: pendingToken, nonce: nonce, providerId: providerId } = tokenResponse;
        if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
        if (!providerId) return null;
        try {
            return new $9bd0e0ec09375082$export$71511d61b312f219(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce: nonce,
                pendingToken: pendingToken
            });
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $9bd0e0ec09375082$export$78acf4525d8a74c4 extends $9bd0e0ec09375082$var$BaseOAuthProvider {
    constructor(){
        super("facebook.com" /* ProviderId.FACEBOOK */ );
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ static credential(accessToken) {
        return $9bd0e0ec09375082$export$3722cfe417b6ed86._fromParams({
            providerId: $9bd0e0ec09375082$export$78acf4525d8a74c4.PROVIDER_ID,
            signInMethod: $9bd0e0ec09375082$export$78acf4525d8a74c4.FACEBOOK_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $9bd0e0ec09375082$export$78acf4525d8a74c4.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $9bd0e0ec09375082$export$78acf4525d8a74c4.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $9bd0e0ec09375082$export$78acf4525d8a74c4.credential(tokenResponse.oauthAccessToken);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */ $9bd0e0ec09375082$export$78acf4525d8a74c4.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $9bd0e0ec09375082$export$78acf4525d8a74c4.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $9bd0e0ec09375082$export$8743009a87fcb00f extends $9bd0e0ec09375082$var$BaseOAuthProvider {
    constructor(){
        super("google.com" /* ProviderId.GOOGLE */ );
        this.addScope('profile');
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ static credential(idToken, accessToken) {
        return $9bd0e0ec09375082$export$3722cfe417b6ed86._fromParams({
            providerId: $9bd0e0ec09375082$export$8743009a87fcb00f.PROVIDER_ID,
            signInMethod: $9bd0e0ec09375082$export$8743009a87fcb00f.GOOGLE_SIGN_IN_METHOD,
            idToken: idToken,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $9bd0e0ec09375082$export$8743009a87fcb00f.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $9bd0e0ec09375082$export$8743009a87fcb00f.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
        return null;
        try {
            return $9bd0e0ec09375082$export$8743009a87fcb00f.credential(oauthIdToken, oauthAccessToken);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */ $9bd0e0ec09375082$export$8743009a87fcb00f.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $9bd0e0ec09375082$export$8743009a87fcb00f.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a GitHub Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a GitHub Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $9bd0e0ec09375082$export$dc98b0b04f4c7758 extends $9bd0e0ec09375082$var$BaseOAuthProvider {
    constructor(){
        super("github.com" /* ProviderId.GITHUB */ );
    }
    /**
     * Creates a credential for GitHub.
     *
     * @param accessToken - GitHub access token.
     */ static credential(accessToken) {
        return $9bd0e0ec09375082$export$3722cfe417b6ed86._fromParams({
            providerId: $9bd0e0ec09375082$export$dc98b0b04f4c7758.PROVIDER_ID,
            signInMethod: $9bd0e0ec09375082$export$dc98b0b04f4c7758.GITHUB_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $9bd0e0ec09375082$export$dc98b0b04f4c7758.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $9bd0e0ec09375082$export$dc98b0b04f4c7758.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $9bd0e0ec09375082$export$dc98b0b04f4c7758.credential(tokenResponse.oauthAccessToken);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */ $9bd0e0ec09375082$export$dc98b0b04f4c7758.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $9bd0e0ec09375082$export$dc98b0b04f4c7758.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9bd0e0ec09375082$var$IDP_REQUEST_URI = 'http://localhost';
/**
 * @public
 */ class $9bd0e0ec09375082$export$738ab4df8bf92ae9 extends $9bd0e0ec09375082$export$3a1a48c8f6ef640e {
    /** @internal */ constructor(providerId, pendingToken){
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $9bd0e0ec09375082$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $9bd0e0ec09375082$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $9bd0e0ec09375082$var$signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, pendingToken: pendingToken } = obj;
        if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
        return new $9bd0e0ec09375082$export$738ab4df8bf92ae9(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ static _create(providerId, pendingToken) {
        return new $9bd0e0ec09375082$export$738ab4df8bf92ae9(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: $9bd0e0ec09375082$var$IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9bd0e0ec09375082$var$SAML_PROVIDER_PREFIX = 'saml.';
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ class $9bd0e0ec09375082$export$3d8c2f653ac9d0b9 extends $9bd0e0ec09375082$var$FederatedAuthProvider {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */ constructor(providerId){
        $9bd0e0ec09375082$export$24baa2b76016ce0e(providerId.startsWith($9bd0e0ec09375082$var$SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $9bd0e0ec09375082$export$3d8c2f653ac9d0b9.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $9bd0e0ec09375082$export$3d8c2f653ac9d0b9.samlCredentialFromTaggedObject(error.customData || {});
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const credential = $9bd0e0ec09375082$export$738ab4df8bf92ae9.fromJSON(json);
        $9bd0e0ec09375082$export$24baa2b76016ce0e(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { pendingToken: pendingToken, providerId: providerId } = tokenResponse;
        if (!pendingToken || !providerId) return null;
        try {
            return $9bd0e0ec09375082$export$738ab4df8bf92ae9._create(providerId, pendingToken);
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ class $9bd0e0ec09375082$export$34aec0b863436764 extends $9bd0e0ec09375082$var$BaseOAuthProvider {
    constructor(){
        super("twitter.com" /* ProviderId.TWITTER */ );
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ static credential(token, secret) {
        return $9bd0e0ec09375082$export$3722cfe417b6ed86._fromParams({
            providerId: $9bd0e0ec09375082$export$34aec0b863436764.PROVIDER_ID,
            signInMethod: $9bd0e0ec09375082$export$34aec0b863436764.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $9bd0e0ec09375082$export$34aec0b863436764.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $9bd0e0ec09375082$export$34aec0b863436764.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) return null;
        try {
            return $9bd0e0ec09375082$export$34aec0b863436764.credential(oauthAccessToken, oauthTokenSecret);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */ $9bd0e0ec09375082$export$34aec0b863436764.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $9bd0e0ec09375082$export$34aec0b863436764.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9bd0e0ec09375082$var$signUp(auth, request) {
    return $9bd0e0ec09375082$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , $9bd0e0ec09375082$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9bd0e0ec09375082$var$UserCredentialImpl {
    constructor(params){
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await $9bd0e0ec09375082$export$91477dc880baac21._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = $9bd0e0ec09375082$var$providerIdForResponse(idTokenResponse);
        const userCred = new $9bd0e0ec09375082$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: idTokenResponse,
            operationType: operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = $9bd0e0ec09375082$var$providerIdForResponse(response);
        return new $9bd0e0ec09375082$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: response,
            operationType: operationType
        });
    }
}
function $9bd0e0ec09375082$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ('phoneNumber' in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ async function $9bd0e0ec09375082$export$3c2fa207a37baaea(auth) {
    if ((0, $0c1331d0a001f5bc$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($9bd0e0ec09375082$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $9bd0e0ec09375082$export$23ebac1979863676(auth);
    await authInternal._initializationPromise;
    if (authInternal.currentUser?.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
    return new $9bd0e0ec09375082$var$UserCredentialImpl({
        user: authInternal.currentUser,
        providerId: null,
        operationType: "signIn" /* OperationType.SIGN_IN */ 
    });
    const response = await $9bd0e0ec09375082$var$signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await $9bd0e0ec09375082$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9bd0e0ec09375082$var$MultiFactorError extends (0, $3117f6f4eeb4c314$export$dd24e9cd51226c56) {
    constructor(auth, error, operationType, user){
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $9bd0e0ec09375082$var$MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: auth.tenantId ?? undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new $9bd0e0ec09375082$var$MultiFactorError(auth, error, operationType, user);
    }
}
function $9bd0e0ec09375082$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch((error)=>{
        if (error.code === `auth/${"multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ }`) throw $9bd0e0ec09375082$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $9bd0e0ec09375082$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(({ providerId: providerId })=>providerId).filter((pid)=>!!pid));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ async function $9bd0e0ec09375082$export$8a5498727ef6be21(user, providerId) {
    const userInternal = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(user);
    await $9bd0e0ec09375082$var$_assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo: providerUserInfo } = await $9bd0e0ec09375082$var$deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [
            providerId
        ]
    });
    const providersLeft = $9bd0e0ec09375082$var$providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter((pd)=>providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function $9bd0e0ec09375082$var$_link$1(user, credential, bypassAuthState = false) {
    const response = await $9bd0e0ec09375082$var$_logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return $9bd0e0ec09375082$var$UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response);
}
async function $9bd0e0ec09375082$var$_assertLinkedStatus(expected, user, provider) {
    await $9bd0e0ec09375082$var$_reloadWithoutSaving(user);
    const providerIds = $9bd0e0ec09375082$var$providerDataAsNames(user.providerData);
    const code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
    $9bd0e0ec09375082$export$24baa2b76016ce0e(providerIds.has(provider) === expected, user.auth, code);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9bd0e0ec09375082$var$_reauthenticate(user, credential, bypassAuthState = false) {
    const { auth: auth } = user;
    if ((0, $0c1331d0a001f5bc$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($9bd0e0ec09375082$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
    try {
        const response = await $9bd0e0ec09375082$var$_logoutIfInvalidated(user, $9bd0e0ec09375082$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        $9bd0e0ec09375082$export$24baa2b76016ce0e(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const parsed = $9bd0e0ec09375082$var$_parseToken(response.idToken);
        $9bd0e0ec09375082$export$24baa2b76016ce0e(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const { sub: localId } = parsed;
        $9bd0e0ec09375082$export$24baa2b76016ce0e(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        return $9bd0e0ec09375082$var$UserCredentialImpl._forOperation(user, operationType, response);
    } catch (e) {
        // Convert user deleted error into user mismatch
        if (e?.code === `auth/${"user-not-found" /* AuthErrorCode.USER_DELETED */ }`) $9bd0e0ec09375082$export$28f7fcd39efa255(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        throw e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9bd0e0ec09375082$var$_signInWithCredential(auth, credential, bypassAuthState = false) {
    if ((0, $0c1331d0a001f5bc$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($9bd0e0ec09375082$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "signIn" /* OperationType.SIGN_IN */ ;
    const response = await $9bd0e0ec09375082$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await $9bd0e0ec09375082$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) await auth._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $9bd0e0ec09375082$export$ce26c07117d59d6a(auth, credential) {
    return $9bd0e0ec09375082$var$_signInWithCredential($9bd0e0ec09375082$export$23ebac1979863676(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $9bd0e0ec09375082$export$6559d589eb85fbb6(user, credential) {
    const userInternal = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(user);
    await $9bd0e0ec09375082$var$_assertLinkedStatus(false, userInternal, credential.providerId);
    return $9bd0e0ec09375082$var$_link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $9bd0e0ec09375082$export$efca4cbe5dd06740(user, credential) {
    return $9bd0e0ec09375082$var$_reauthenticate((0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9bd0e0ec09375082$var$signInWithCustomToken$1(auth, request) {
    return $9bd0e0ec09375082$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , $9bd0e0ec09375082$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ async function $9bd0e0ec09375082$export$a8550f7dbe79f93a(auth, customToken) {
    if ((0, $0c1331d0a001f5bc$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($9bd0e0ec09375082$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $9bd0e0ec09375082$export$23ebac1979863676(auth);
    const response = await $9bd0e0ec09375082$var$signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await $9bd0e0ec09375082$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9bd0e0ec09375082$var$MultiFactorInfoImpl {
    constructor(factorId, response){
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ('phoneInfo' in enrollment) return $9bd0e0ec09375082$var$PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        else if ('totpInfo' in enrollment) return $9bd0e0ec09375082$var$TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        return $9bd0e0ec09375082$export$28f7fcd39efa255(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
}
class $9bd0e0ec09375082$var$PhoneMultiFactorInfoImpl extends $9bd0e0ec09375082$var$MultiFactorInfoImpl {
    constructor(response){
        super("phone" /* FactorId.PHONE */ , response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $9bd0e0ec09375082$var$PhoneMultiFactorInfoImpl(enrollment);
    }
}
class $9bd0e0ec09375082$var$TotpMultiFactorInfoImpl extends $9bd0e0ec09375082$var$MultiFactorInfoImpl {
    constructor(response){
        super("totp" /* FactorId.TOTP */ , response);
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $9bd0e0ec09375082$var$TotpMultiFactorInfoImpl(enrollment);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9bd0e0ec09375082$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    $9bd0e0ec09375082$export$24baa2b76016ce0e(actionCodeSettings.url?.length > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    $9bd0e0ec09375082$export$24baa2b76016ce0e(typeof actionCodeSettings.dynamicLinkDomain === 'undefined' || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    $9bd0e0ec09375082$export$24baa2b76016ce0e(typeof actionCodeSettings.linkDomain === 'undefined' || actionCodeSettings.linkDomain.length > 0, auth, "invalid-hosting-link-domain" /* AuthErrorCode.INVALID_HOSTING_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.linkDomain = actionCodeSettings.linkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $9bd0e0ec09375082$export$24baa2b76016ce0e(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $9bd0e0ec09375082$export$24baa2b76016ce0e(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates the password policy cached in the {@link Auth} instance if a policy is already
 * cached for the project or tenant.
 *
 * @remarks
 * We only fetch the password policy if the password did not meet policy requirements and
 * there is an existing policy cached. A developer must call validatePassword at least
 * once for the cache to be automatically updated.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @private
 */ async function $9bd0e0ec09375082$var$recachePasswordPolicy(auth) {
    const authInternal = $9bd0e0ec09375082$export$23ebac1979863676(auth);
    if (authInternal._getPasswordPolicyInternal()) await authInternal._updatePasswordPolicy();
}
/**
 * Sends a password reset email to the given email address. This method does not throw an error when
 * there's no user account with the given email address and
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $9bd0e0ec09375082$export$2e2af4578d910ddf(auth, email, actionCodeSettings) {
    const authInternal = $9bd0e0ec09375082$export$23ebac1979863676(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    if (actionCodeSettings) $9bd0e0ec09375082$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    await $9bd0e0ec09375082$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $9bd0e0ec09375082$var$sendPasswordResetEmail$1, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ async function $9bd0e0ec09375082$export$a93c5207d687da10(auth, oobCode, newPassword) {
    await $9bd0e0ec09375082$var$resetPassword((0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode,
        newPassword: newPassword
    }).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $9bd0e0ec09375082$var$recachePasswordPolicy(auth);
        throw error;
    });
// Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $9bd0e0ec09375082$export$c3950d9923825c02(auth, oobCode) {
    await $9bd0e0ec09375082$var$applyActionCode$1((0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode
    });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $9bd0e0ec09375082$export$a9c996f45e5784d0(auth, oobCode) {
    const authModular = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(auth);
    const response = await $9bd0e0ec09375082$var$resetPassword(authModular, {
        oobCode: oobCode
    });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    $9bd0e0ec09375082$export$24baa2b76016ce0e(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    switch(operation){
        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
            $9bd0e0ec09375082$export$24baa2b76016ce0e(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
            $9bd0e0ec09375082$export$24baa2b76016ce0e(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // fall through
        default:
            $9bd0e0ec09375082$export$24baa2b76016ce0e(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) multiFactorInfo = $9bd0e0ec09375082$var$MultiFactorInfoImpl._fromServerResponse($9bd0e0ec09375082$export$23ebac1979863676(authModular), response.mfaInfo);
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
            multiFactorInfo: multiFactorInfo
        },
        operation: operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ async function $9bd0e0ec09375082$export$7910e0436ed8d1de(auth, code) {
    const { data: data } = await $9bd0e0ec09375082$export$a9c996f45e5784d0((0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ async function $9bd0e0ec09375082$export$555508cbc6add439(auth, email, password) {
    if ((0, $0c1331d0a001f5bc$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($9bd0e0ec09375082$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $9bd0e0ec09375082$export$23ebac1979863676(auth);
    const request = {
        returnSecureToken: true,
        email: email,
        password: password,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    const signUpResponse = $9bd0e0ec09375082$var$handleRecaptchaFlow(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $9bd0e0ec09375082$var$signUp, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
    const response = await signUpResponse.catch((error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $9bd0e0ec09375082$var$recachePasswordPolicy(auth);
        throw error;
    });
    const userCredential = await $9bd0e0ec09375082$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match. When
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, this method fails with "auth/invalid-credential" in case of an invalid
 * email/password.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $9bd0e0ec09375082$export$2219238a014317b0(auth, email, password) {
    if ((0, $0c1331d0a001f5bc$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($9bd0e0ec09375082$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    return $9bd0e0ec09375082$export$ce26c07117d59d6a((0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(auth), $9bd0e0ec09375082$export$71cec2538cb2c617.credential(email, password)).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $9bd0e0ec09375082$var$recachePasswordPolicy(auth);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $9bd0e0ec09375082$export$4c3d22f3d993c33f(auth, email, actionCodeSettings) {
    const authInternal = $9bd0e0ec09375082$export$23ebac1979863676(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    function setActionCodeSettings(request, actionCodeSettings) {
        $9bd0e0ec09375082$export$24baa2b76016ce0e(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (actionCodeSettings) $9bd0e0ec09375082$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    }
    setActionCodeSettings(request, actionCodeSettings);
    await $9bd0e0ec09375082$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $9bd0e0ec09375082$var$sendSignInLinkToEmail$1, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $9bd0e0ec09375082$export$f787f51d84a910ad(auth, emailLink) {
    const actionCodeUrl = $9bd0e0ec09375082$export$3b513254972cfc9c.parseLink(emailLink);
    return actionCodeUrl?.operation === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ async function $9bd0e0ec09375082$export$c9170ad7d4cd7e57(auth, email, emailLink) {
    if ((0, $0c1331d0a001f5bc$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($9bd0e0ec09375082$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authModular = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(auth);
    const credential = $9bd0e0ec09375082$export$71cec2538cb2c617.credentialWithLink(email, emailLink || $9bd0e0ec09375082$var$_getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    $9bd0e0ec09375082$export$24baa2b76016ce0e(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
    return $9bd0e0ec09375082$export$ce26c07117d59d6a(authModular, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9bd0e0ec09375082$var$createAuthUri(auth, request) {
    return $9bd0e0ec09375082$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , $9bd0e0ec09375082$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address. This method returns an
 * empty list when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, irrespective of the number of authentication methods available for the given email.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * Deprecated. Migrating off of this method is recommended as a security best-practice.
 * Learn more in the Identity Platform documentation for
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}.
 * @public
 */ async function $9bd0e0ec09375082$export$ee7c8ad385a60b7b(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = $9bd0e0ec09375082$var$_isHttpOrHttps() ? $9bd0e0ec09375082$var$_getCurrentUrl() : 'http://localhost';
    const request = {
        identifier: email,
        continueUri: continueUri
    };
    const { signinMethods: signinMethods } = await $9bd0e0ec09375082$var$createAuthUri((0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $9bd0e0ec09375082$export$995eb9fca571757(user, actionCodeSettings) {
    const userInternal = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
        idToken: idToken
    };
    if (actionCodeSettings) $9bd0e0ec09375082$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $9bd0e0ec09375082$var$sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) await user.reload();
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $9bd0e0ec09375082$export$f38c853ae54ed474(user, newEmail, actionCodeSettings) {
    const userInternal = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
        idToken: idToken,
        newEmail: newEmail
    };
    if (actionCodeSettings) $9bd0e0ec09375082$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $9bd0e0ec09375082$var$verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) // If the local copy of the email on user is outdated, reload the
    // user.
    await user.reload();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9bd0e0ec09375082$var$updateProfile$1(auth, request) {
    return $9bd0e0ec09375082$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ async function $9bd0e0ec09375082$export$ab83b03e4111b1d0(user, { displayName: displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) return;
    const userInternal = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken: idToken,
        displayName: displayName,
        photoUrl: photoUrl,
        returnSecureToken: true
    };
    const response = await $9bd0e0ec09375082$var$_logoutIfInvalidated(userInternal, $9bd0e0ec09375082$var$updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId: providerId })=>providerId === "password" /* ProviderId.PASSWORD */ );
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * Throws "auth/operation-not-allowed" error when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 * Deprecated - Use {@link verifyBeforeUpdateEmail} instead.
 *
 * @public
 */ function $9bd0e0ec09375082$export$1a82df3d29112e01(user, newEmail) {
    const userInternal = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(user);
    if ((0, $0c1331d0a001f5bc$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($9bd0e0ec09375082$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    return $9bd0e0ec09375082$var$updateEmailOrPassword(userInternal, newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $9bd0e0ec09375082$export$306ddfe3a8403e2(user, newPassword) {
    return $9bd0e0ec09375082$var$updateEmailOrPassword((0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(user), null, newPassword);
}
async function $9bd0e0ec09375082$var$updateEmailOrPassword(user, email, password) {
    const { auth: auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken: idToken,
        returnSecureToken: true
    };
    if (email) request.email = email;
    if (password) request.password = password;
    const response = await $9bd0e0ec09375082$var$_logoutIfInvalidated(user, $9bd0e0ec09375082$var$updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $9bd0e0ec09375082$var$_fromIdTokenResponse(idTokenResponse) {
    if (!idTokenResponse) return null;
    const { providerId: providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    const isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && idTokenResponse?.idToken) {
        const signInProvider = $9bd0e0ec09375082$var$_parseToken(idTokenResponse.idToken)?.firebase?.['sign_in_provider'];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $9bd0e0ec09375082$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new $9bd0e0ec09375082$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new $9bd0e0ec09375082$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new $9bd0e0ec09375082$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new $9bd0e0ec09375082$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new $9bd0e0ec09375082$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $9bd0e0ec09375082$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class $9bd0e0ec09375082$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}){
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class $9bd0e0ec09375082$var$FederatedAdditionalUserInfoWithUsername extends $9bd0e0ec09375082$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile, username){
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class $9bd0e0ec09375082$var$FacebookAdditionalUserInfo extends $9bd0e0ec09375082$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
}
class $9bd0e0ec09375082$var$GithubAdditionalUserInfo extends $9bd0e0ec09375082$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile){
        super(isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof profile?.login === 'string' ? profile?.login : null);
    }
}
class $9bd0e0ec09375082$var$GoogleAdditionalUserInfo extends $9bd0e0ec09375082$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
}
class $9bd0e0ec09375082$var$TwitterAdditionalUserInfo extends $9bd0e0ec09375082$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile, screenName){
        super(isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $9bd0e0ec09375082$export$d24c54395ce0c509(userCredential) {
    const { user: user, _tokenResponse: _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $9bd0e0ec09375082$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $9bd0e0ec09375082$export$625550452a3fa3ec(auth, persistence) {
    return (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $9bd0e0ec09375082$export$90a7f3efeed30595(auth) {
    return $9bd0e0ec09375082$var$_initializeRecaptchaConfig(auth);
}
/**
 * Validates the password against the password policy configured for the project or tenant.
 *
 * @remarks
 * If no tenant ID is set on the `Auth` instance, then this method will use the password
 * policy configured for the project. Otherwise, this method will use the policy configured
 * for the tenant. If a password policy has not been configured, then the default policy
 * configured for all projects will be used.
 *
 * If an auth flow fails because a submitted password does not meet the password policy
 * requirements and this method has previously been called, then this method will use the
 * most recent policy available when called again.
 *
 * @example
 * ```javascript
 * validatePassword(auth, 'some-password');
 * ```
 *
 * @param auth The {@link Auth} instance.
 * @param password The password to validate.
 *
 * @public
 */ async function $9bd0e0ec09375082$export$efccba1c4a2ef57b(auth, password) {
    const authInternal = $9bd0e0ec09375082$export$23ebac1979863676(auth);
    return authInternal.validatePassword(password);
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $9bd0e0ec09375082$export$d141bba7fdc215a3(auth, nextOrObserver, error, completed) {
    return (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function $9bd0e0ec09375082$export$4a5767248b18ef41(auth, callback, onAbort) {
    return (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $9bd0e0ec09375082$export$df995fae86a55f06(auth, nextOrObserver, error, completed) {
    return (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $9bd0e0ec09375082$export$ef35774e6d314e91(auth) {
    (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $9bd0e0ec09375082$export$e7094788287c5e9b(auth, user) {
    return (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @remarks
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $9bd0e0ec09375082$export$96f57966bedc81b4(auth) {
    return (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(auth).signOut();
}
/**
 * Revokes the given access token. Currently only supports Apple OAuth access tokens.
 *
 * @param auth - The {@link Auth} instance.
 * @param token - The Apple OAuth access token.
 *
 * @public
 */ function $9bd0e0ec09375082$export$a9c23c6ac3fc3eca(auth, token) {
    const authInternal = $9bd0e0ec09375082$export$23ebac1979863676(auth);
    return authInternal.revokeAccessToken(token);
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ async function $9bd0e0ec09375082$export$2329c99376c9d0a4(user) {
    return (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(user).delete();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9bd0e0ec09375082$var$MultiFactorSessionImpl {
    constructor(type, credential, user){
        this.type = type;
        this.credential = credential;
        this.user = user;
    }
    static _fromIdtoken(idToken, user) {
        return new $9bd0e0ec09375082$var$MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, user);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new $9bd0e0ec09375082$var$MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? 'idToken' : 'pendingCredential';
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        if (obj?.multiFactorSession) {
            if (obj.multiFactorSession?.pendingCredential) return $9bd0e0ec09375082$var$MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            else if (obj.multiFactorSession?.idToken) return $9bd0e0ec09375082$var$MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9bd0e0ec09375082$var$MultiFactorResolverImpl {
    constructor(session, hints, signInResolver){
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */ static _fromError(authExtern, error) {
        const auth = $9bd0e0ec09375082$export$23ebac1979863676(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map((enrollment)=>$9bd0e0ec09375082$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        $9bd0e0ec09375082$export$24baa2b76016ce0e(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const session = $9bd0e0ec09375082$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new $9bd0e0ec09375082$var$MultiFactorResolverImpl(session, hints, async (assertion)=>{
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = {
                ...serverResponse,
                idToken: mfaResponse.idToken,
                refreshToken: mfaResponse.refreshToken
            };
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch(error.operationType){
                case "signIn" /* OperationType.SIGN_IN */ :
                    const userCredential = await $9bd0e0ec09375082$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                    $9bd0e0ec09375082$export$24baa2b76016ce0e(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return $9bd0e0ec09375082$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    $9bd0e0ec09375082$export$28f7fcd39efa255(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $9bd0e0ec09375082$export$493d36ec626b6698(auth, error) {
    const authModular = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(auth);
    const errorInternal = error;
    $9bd0e0ec09375082$export$24baa2b76016ce0e(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    $9bd0e0ec09375082$export$24baa2b76016ce0e(errorInternal.customData._serverResponse?.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return $9bd0e0ec09375082$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9bd0e0ec09375082$var$startEnrollPhoneMfa(auth, request) {
    return $9bd0e0ec09375082$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $9bd0e0ec09375082$var$_addTidIfNecessary(auth, request));
}
function $9bd0e0ec09375082$var$finalizeEnrollPhoneMfa(auth, request) {
    return $9bd0e0ec09375082$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $9bd0e0ec09375082$var$_addTidIfNecessary(auth, request));
}
function $9bd0e0ec09375082$var$startEnrollTotpMfa(auth, request) {
    return $9bd0e0ec09375082$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $9bd0e0ec09375082$var$_addTidIfNecessary(auth, request));
}
function $9bd0e0ec09375082$var$finalizeEnrollTotpMfa(auth, request) {
    return $9bd0e0ec09375082$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $9bd0e0ec09375082$var$_addTidIfNecessary(auth, request));
}
function $9bd0e0ec09375082$var$withdrawMfa(auth, request) {
    return $9bd0e0ec09375082$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , $9bd0e0ec09375082$var$_addTidIfNecessary(auth, request));
}
class $9bd0e0ec09375082$var$MultiFactorUserImpl {
    constructor(user){
        this.user = user;
        this.enrolledFactors = [];
        user._onReload((userInfo)=>{
            if (userInfo.mfaInfo) this.enrolledFactors = userInfo.mfaInfo.map((enrollment)=>$9bd0e0ec09375082$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
        });
    }
    static _fromUser(user) {
        return new $9bd0e0ec09375082$var$MultiFactorUserImpl(user);
    }
    async getSession() {
        return $9bd0e0ec09375082$var$MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken(), this.user);
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = await this.getSession();
        const finalizeMfaResponse = await $9bd0e0ec09375082$var$_logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === 'string' ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        try {
            const idTokenResponse = await $9bd0e0ec09375082$var$_logoutIfInvalidated(this.user, $9bd0e0ec09375082$var$withdrawMfa(this.user.auth, {
                idToken: idToken,
                mfaEnrollmentId: mfaEnrollmentId
            }));
            // Remove the second factor from the user's list.
            this.enrolledFactors = this.enrolledFactors.filter(({ uid: uid })=>uid !== mfaEnrollmentId);
            // Depending on whether the backend decided to revoke the user's session,
            // the tokenResponse may be empty. If the tokens were not updated (and they
            // are now invalid), reloading the user will discover this and invalidate
            // the user's state accordingly.
            await this.user._updateTokensIfNecessary(idTokenResponse);
            await this.user.reload();
        } catch (e) {
            throw e;
        }
    }
}
const $9bd0e0ec09375082$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $9bd0e0ec09375082$export$1fbe638ecf81657e(user) {
    const userModular = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(user);
    if (!$9bd0e0ec09375082$var$multiFactorUserCache.has(userModular)) $9bd0e0ec09375082$var$multiFactorUserCache.set(userModular, $9bd0e0ec09375082$var$MultiFactorUserImpl._fromUser(userModular));
    return $9bd0e0ec09375082$var$multiFactorUserCache.get(userModular);
}
const $9bd0e0ec09375082$var$STORAGE_AVAILABLE_KEY = '__sak';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class $9bd0e0ec09375082$var$BrowserPersistenceClass {
    constructor(storageRetriever, type){
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) return Promise.resolve(false);
            this.storage.setItem($9bd0e0ec09375082$var$STORAGE_AVAILABLE_KEY, '1');
            this.storage.removeItem($9bd0e0ec09375082$var$STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        } catch  {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The polling period in case events are not supported
const $9bd0e0ec09375082$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const $9bd0e0ec09375082$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class $9bd0e0ec09375082$var$BrowserLocalPersistence extends $9bd0e0ec09375082$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.localStorage, "LOCAL" /* PersistenceType.LOCAL */ );
        this.boundEventHandler = (event, poll)=>this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = $9bd0e0ec09375082$var$_isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)){
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) cb(key, oldValue, newValue);
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue)=>{
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
        else // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
        const triggerListeners = ()=>{
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
            // This seems to trigger in some IE browsers for some reason.
            return;
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if ($9bd0e0ec09375082$var$_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, $9bd0e0ec09375082$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
        else triggerListeners();
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(value ? JSON.parse(value) : value);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(()=>{
            this.forAllChangedKeys((key, oldValue, newValue)=>{
                this.onStorageEvent(new StorageEvent('storage', {
                    key: key,
                    oldValue: oldValue,
                    newValue: newValue
                }), /* poll */ true);
            });
        }, $9bd0e0ec09375082$var$_POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener('storage', this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener('storage', this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) this.startPolling();
            else this.attachListener();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
$9bd0e0ec09375082$var$BrowserLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ const $9bd0e0ec09375082$export$8b22cf2602fb60ce = $9bd0e0ec09375082$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9bd0e0ec09375082$var$POLLING_INTERVAL_MS = 1000;
// Pull a cookie value from document.cookie
function $9bd0e0ec09375082$var$getDocumentCookie(name) {
    const escapedName = name.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&');
    const matcher = RegExp(`${escapedName}=([^;]+)`);
    return document.cookie.match(matcher)?.[1] ?? null;
}
// Produce a sanitized cookie name from the persistence key
function $9bd0e0ec09375082$var$getCookieName(key) {
    // __HOST- doesn't work in localhost https://issues.chromium.org/issues/40196122 but it has
    // desirable security properties, so lets use a different cookie name while in dev-mode.
    // Already checked isSecureContext in _isAvailable, so if it's http we're hitting local.
    const isDevMode = window.location.protocol === 'http:';
    return `${isDevMode ? '__dev_' : '__HOST-'}FIREBASE_${key.split(':')[3]}`;
}
class $9bd0e0ec09375082$var$CookiePersistence {
    constructor(){
        this.type = "COOKIE" /* PersistenceType.COOKIE */ ;
        this.listenerUnsubscribes = new Map();
    }
    // used to get the URL to the backend to proxy to
    _getFinalTarget(originalUrl) {
        const url = new URL(`${window.location.origin}/__cookies__`);
        url.searchParams.set('finalTarget', originalUrl);
        return url;
    }
    // To be a usable persistence method in a chain browserCookiePersistence ensures that
    // prerequisites have been met, namely that we're in a secureContext, navigator and document are
    // available and cookies are enabled. Not all UAs support these method, so fallback accordingly.
    async _isAvailable() {
        if (typeof isSecureContext === 'boolean' && !isSecureContext) return false;
        if (typeof navigator === 'undefined' || typeof document === 'undefined') return false;
        return navigator.cookieEnabled ?? true;
    }
    // Set should be a noop as we expect middleware to handle this
    async _set(_key, _value) {
        return;
    }
    // Attempt to get the cookie from cookieStore, fallback to document.cookie
    async _get(key) {
        if (!this._isAvailable()) return null;
        const name = $9bd0e0ec09375082$var$getCookieName(key);
        if (window.cookieStore) {
            const cookie = await window.cookieStore.get(name);
            return cookie?.value;
        }
        return $9bd0e0ec09375082$var$getDocumentCookie(name);
    }
    // Log out by overriding the idToken with a sentinel value of ""
    async _remove(key) {
        if (!this._isAvailable()) return;
        // To make sure we don't hit signout over and over again, only do this operation if we need to
        // with the logout sentinel value of "" this can cause race conditions. Unnecessary set-cookie
        // headers will reduce CDN hit rates too.
        const existingValue = await this._get(key);
        if (!existingValue) return;
        const name = $9bd0e0ec09375082$var$getCookieName(key);
        document.cookie = `${name}=;Max-Age=34560000;Partitioned;Secure;SameSite=Strict;Path=/;Priority=High`;
        await fetch(`/__cookies__`, {
            method: 'DELETE'
        }).catch(()=>undefined);
    }
    // Listen for cookie changes, both cookieStore and fallback to polling document.cookie
    _addListener(key, listener) {
        if (!this._isAvailable()) return;
        const name = $9bd0e0ec09375082$var$getCookieName(key);
        if (window.cookieStore) {
            const cb = (event)=>{
                const changedCookie = event.changed.find((change)=>change.name === name);
                if (changedCookie) listener(changedCookie.value);
                const deletedCookie = event.deleted.find((change)=>change.name === name);
                if (deletedCookie) listener(null);
            };
            const unsubscribe = ()=>window.cookieStore.removeEventListener('change', cb);
            this.listenerUnsubscribes.set(listener, unsubscribe);
            return window.cookieStore.addEventListener('change', cb);
        }
        let lastValue = $9bd0e0ec09375082$var$getDocumentCookie(name);
        const interval = setInterval(()=>{
            const currentValue = $9bd0e0ec09375082$var$getDocumentCookie(name);
            if (currentValue !== lastValue) {
                listener(currentValue);
                lastValue = currentValue;
            }
        }, $9bd0e0ec09375082$var$POLLING_INTERVAL_MS);
        const unsubscribe = ()=>clearInterval(interval);
        this.listenerUnsubscribes.set(listener, unsubscribe);
    }
    _removeListener(_key, listener) {
        const unsubscribe = this.listenerUnsubscribes.get(listener);
        if (!unsubscribe) return;
        unsubscribe();
        this.listenerUnsubscribes.delete(listener);
    }
}
$9bd0e0ec09375082$var$CookiePersistence.type = 'COOKIE';
/**
 * An implementation of {@link Persistence} of type `COOKIE`, for use on the client side in
 * applications leveraging hybrid rendering and middleware.
 *
 * @remarks This persistence method requires companion middleware to function, such as that provided
 * by {@link https://firebaseopensource.com/projects/firebaseextended/reactfire/ | ReactFire} for
 * NextJS.
 * @beta
 */ const $9bd0e0ec09375082$export$407448d2b89b1813 = $9bd0e0ec09375082$var$CookiePersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9bd0e0ec09375082$var$BrowserSessionPersistence extends $9bd0e0ec09375082$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.sessionStorage, "SESSION" /* PersistenceType.SESSION */ );
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
$9bd0e0ec09375082$var$BrowserSessionPersistence.type = 'SESSION';
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ const $9bd0e0ec09375082$export$db3b6bfb95261072 = $9bd0e0ec09375082$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $9bd0e0ec09375082$var$_allSettled(promises) {
    return Promise.all(promises.map(async (promise)=>{
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value: value
            };
        } catch (reason) {
            return {
                fulfilled: false,
                reason: reason
            };
        }
    }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ class $9bd0e0ec09375082$var$Receiver {
    constructor(eventTarget){
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find((receiver)=>receiver.isListeningto(eventTarget));
        if (existingInstance) return existingInstance;
        const newInstance = new $9bd0e0ec09375082$var$Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ async handleEvent(event) {
        const messageEvent = event;
        const { eventId: eventId, eventType: eventType, data: data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!handlers?.size) return;
        messageEvent.ports[0].postMessage({
            status: "ack" /* _Status.ACK */ ,
            eventId: eventId,
            eventType: eventType
        });
        const promises = Array.from(handlers).map(async (handler)=>handler(messageEvent.origin, data));
        const response = await $9bd0e0ec09375082$var$_allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* _Status.DONE */ ,
            eventId: eventId,
            eventType: eventType,
            response: response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener('message', this.boundEventHandler);
        if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optional event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
        if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener('message', this.boundEventHandler);
    }
}
$9bd0e0ec09375082$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9bd0e0ec09375082$export$c03999cb2f36933f(prefix = '', digits = 10) {
    let random = '';
    for(let i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ class $9bd0e0ec09375082$var$Sender {
    constructor(target){
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener('message', handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ async _send(eventType, data, timeout = 50 /* _TimeoutDuration.ACK */ ) {
        const messageChannel = typeof MessageChannel !== 'undefined' ? new MessageChannel() : null;
        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject)=>{
            const eventId = $9bd0e0ec09375082$export$c03999cb2f36933f('', 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(()=>{
                reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
            }, timeout);
            handler = {
                messageChannel: messageChannel,
                onMessage (event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) return;
                    switch(messageEvent.data.status){
                        case "ack" /* _Status.ACK */ :
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(()=>{
                                reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                            }, 3000 /* _TimeoutDuration.COMPLETION */ );
                            break;
                        case "done" /* _Status.DONE */ :
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener('message', handler.onMessage);
            this.target.postMessage({
                eventType: eventType,
                eventId: eventId,
                data: data
            }, [
                messageChannel.port2
            ]);
        }).finally(()=>{
            if (handler) this.removeMessageHandler(handler);
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $9bd0e0ec09375082$var$_window() {
    return window;
}
function $9bd0e0ec09375082$var$_setWindowLocation(url) {
    $9bd0e0ec09375082$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9bd0e0ec09375082$var$_isWorker() {
    return typeof $9bd0e0ec09375082$var$_window()['WorkerGlobalScope'] !== 'undefined' && typeof $9bd0e0ec09375082$var$_window()['importScripts'] === 'function';
}
async function $9bd0e0ec09375082$var$_getActiveServiceWorker() {
    if (!navigator?.serviceWorker) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    } catch  {
        return null;
    }
}
function $9bd0e0ec09375082$var$_getServiceWorkerController() {
    return navigator?.serviceWorker?.controller || null;
}
function $9bd0e0ec09375082$var$_getWorkerGlobalScope() {
    return $9bd0e0ec09375082$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9bd0e0ec09375082$var$DB_NAME = 'firebaseLocalStorageDb';
const $9bd0e0ec09375082$var$DB_VERSION = 1;
const $9bd0e0ec09375082$var$DB_OBJECTSTORE_NAME = 'firebaseLocalStorage';
const $9bd0e0ec09375082$var$DB_DATA_KEYPATH = 'fbase_key';
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ class $9bd0e0ec09375082$var$DBPromise {
    constructor(request){
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject)=>{
            this.request.addEventListener('success', ()=>{
                resolve(this.request.result);
            });
            this.request.addEventListener('error', ()=>{
                reject(this.request.error);
            });
        });
    }
}
function $9bd0e0ec09375082$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $9bd0e0ec09375082$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? 'readwrite' : 'readonly').objectStore($9bd0e0ec09375082$var$DB_OBJECTSTORE_NAME);
}
function $9bd0e0ec09375082$var$_deleteDatabase() {
    const request = indexedDB.deleteDatabase($9bd0e0ec09375082$var$DB_NAME);
    return new $9bd0e0ec09375082$var$DBPromise(request).toPromise();
}
function $9bd0e0ec09375082$var$_openDatabase() {
    const request = indexedDB.open($9bd0e0ec09375082$var$DB_NAME, $9bd0e0ec09375082$var$DB_VERSION);
    return new Promise((resolve, reject)=>{
        request.addEventListener('error', ()=>{
            reject(request.error);
        });
        request.addEventListener('upgradeneeded', ()=>{
            const db = request.result;
            try {
                db.createObjectStore($9bd0e0ec09375082$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $9bd0e0ec09375082$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener('success', async ()=>{
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains($9bd0e0ec09375082$var$DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await $9bd0e0ec09375082$var$_deleteDatabase();
                resolve(await $9bd0e0ec09375082$var$_openDatabase());
            } else resolve(db);
        });
    });
}
async function $9bd0e0ec09375082$var$_putObject(db, key, value) {
    const request = $9bd0e0ec09375082$var$getObjectStore(db, true).put({
        [$9bd0e0ec09375082$var$DB_DATA_KEYPATH]: key,
        value: value
    });
    return new $9bd0e0ec09375082$var$DBPromise(request).toPromise();
}
async function $9bd0e0ec09375082$var$getObject(db, key) {
    const request = $9bd0e0ec09375082$var$getObjectStore(db, false).get(key);
    const data = await new $9bd0e0ec09375082$var$DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function $9bd0e0ec09375082$var$_deleteObject(db, key) {
    const request = $9bd0e0ec09375082$var$getObjectStore(db, true).delete(key);
    return new $9bd0e0ec09375082$var$DBPromise(request).toPromise();
}
const $9bd0e0ec09375082$var$_POLLING_INTERVAL_MS = 800;
const $9bd0e0ec09375082$var$_TRANSACTION_RETRY_COUNT = 3;
class $9bd0e0ec09375082$var$IndexedDBLocalPersistence {
    constructor(){
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
    }
    async _openDb() {
        if (this.db) return this.db;
        this.db = await $9bd0e0ec09375082$var$_openDatabase();
        return this.db;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while(true)try {
            const db = await this._openDb();
            return await op(db);
        } catch (e) {
            if (numAttempts++ > $9bd0e0ec09375082$var$_TRANSACTION_RETRY_COUNT) throw e;
            if (this.db) {
                this.db.close();
                this.db = undefined;
            }
        // TODO: consider adding exponential backoff
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ async initializeServiceWorkerMessaging() {
        return $9bd0e0ec09375082$var$_isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */ async initializeReceiver() {
        this.receiver = $9bd0e0ec09375082$var$Receiver._getInstance($9bd0e0ec09375082$var$_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , async (_origin, data)=>{
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* _EventType.PING */ , async (_origin, _data)=>{
            return [
                "keyChanged" /* _EventType.KEY_CHANGED */ 
            ];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ async initializeSender() {
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await $9bd0e0ec09375082$var$_getActiveServiceWorker();
        if (!this.activeServiceWorker) return;
        this.sender = new $9bd0e0ec09375082$var$Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ );
        if (!results) return;
        if (results[0]?.fulfilled && results[0]?.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ )) this.serviceWorkerReceiverAvailable = true;
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ async notifyServiceWorker(key) {
        if (!this.sender || !this.activeServiceWorker || $9bd0e0ec09375082$var$_getServiceWorkerController() !== this.activeServiceWorker) return;
        try {
            await this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                key: key
            }, // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ );
        } catch  {
        // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) return false;
            const db = await $9bd0e0ec09375082$var$_openDatabase();
            await $9bd0e0ec09375082$var$_putObject(db, $9bd0e0ec09375082$var$STORAGE_AVAILABLE_KEY, '1');
            await $9bd0e0ec09375082$var$_deleteObject(db, $9bd0e0ec09375082$var$STORAGE_AVAILABLE_KEY);
            return true;
        } catch  {}
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        } finally{
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$9bd0e0ec09375082$var$_putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = await this._withRetries((db)=>$9bd0e0ec09375082$var$getObject(db, key));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$9bd0e0ec09375082$var$_deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        // TODO: check if we need to fallback if getAll is not supported
        const result = await this._withRetries((db)=>{
            const getAllRequest = $9bd0e0ec09375082$var$getObjectStore(db, false).getAll();
            return new $9bd0e0ec09375082$var$DBPromise(getAllRequest).toPromise();
        });
        if (!result) return [];
        // If we have pending writes in progress abort, we'll get picked up on the next poll
        if (this.pendingWrites !== 0) return [];
        const keys = [];
        const keysInResult = new Set();
        if (result.length !== 0) for (const { fbase_key: key, value: value } of result){
            keysInResult.add(key);
            if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                this.notifyListeners(key, value);
                keys.push(key);
            }
        }
        for (const localKey of Object.keys(this.localCache))if (this.localCache[localKey] && !keysInResult.has(localKey)) {
            // Deleted
            this.notifyListeners(localKey, null);
            keys.push(localKey);
        }
        return keys;
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(newValue);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async ()=>this._poll(), $9bd0e0ec09375082$var$_POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) this.startPolling();
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) this.stopPolling();
    }
}
$9bd0e0ec09375082$var$IndexedDBLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ const $9bd0e0ec09375082$export$23f2a1d2818174ef = $9bd0e0ec09375082$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9bd0e0ec09375082$var$startSignInPhoneMfa(auth, request) {
    return $9bd0e0ec09375082$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , $9bd0e0ec09375082$var$_addTidIfNecessary(auth, request));
}
function $9bd0e0ec09375082$var$finalizeSignInPhoneMfa(auth, request) {
    return $9bd0e0ec09375082$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $9bd0e0ec09375082$var$_addTidIfNecessary(auth, request));
}
function $9bd0e0ec09375082$var$finalizeSignInTotpMfa(auth, request) {
    return $9bd0e0ec09375082$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $9bd0e0ec09375082$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const $9bd0e0ec09375082$var$_JSLOAD_CALLBACK = $9bd0e0ec09375082$var$_generateCallbackName('rcb');
const $9bd0e0ec09375082$var$NETWORK_TIMEOUT_DELAY = new $9bd0e0ec09375082$var$Delay(30000, 60000);
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ class $9bd0e0ec09375082$var$ReCaptchaLoaderImpl {
    constructor(){
        this.hostLanguage = '';
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!$9bd0e0ec09375082$var$_window().grecaptcha?.render;
    }
    load(auth, hl = '') {
        $9bd0e0ec09375082$export$24baa2b76016ce0e($9bd0e0ec09375082$var$isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (this.shouldResolveImmediately(hl) && $9bd0e0ec09375082$var$isV2($9bd0e0ec09375082$var$_window().grecaptcha)) return Promise.resolve($9bd0e0ec09375082$var$_window().grecaptcha);
        return new Promise((resolve, reject)=>{
            const networkTimeout = $9bd0e0ec09375082$var$_window().setTimeout(()=>{
                reject($9bd0e0ec09375082$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $9bd0e0ec09375082$var$NETWORK_TIMEOUT_DELAY.get());
            $9bd0e0ec09375082$var$_window()[$9bd0e0ec09375082$var$_JSLOAD_CALLBACK] = ()=>{
                $9bd0e0ec09375082$var$_window().clearTimeout(networkTimeout);
                delete $9bd0e0ec09375082$var$_window()[$9bd0e0ec09375082$var$_JSLOAD_CALLBACK];
                const recaptcha = $9bd0e0ec09375082$var$_window().grecaptcha;
                if (!recaptcha || !$9bd0e0ec09375082$var$isV2(recaptcha)) {
                    reject($9bd0e0ec09375082$export$890c4ad488842ce7(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    return;
                }
                // Wrap the recaptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params)=>{
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${$9bd0e0ec09375082$var$_recaptchaV2ScriptUrl()}?${(0, $3117f6f4eeb4c314$export$ac4103b836844853)({
                onload: $9bd0e0ec09375082$var$_JSLOAD_CALLBACK,
                render: 'explicit',
                hl: hl
            })}`;
            $9bd0e0ec09375082$var$_loadJS(url).catch(()=>{
                clearTimeout(networkTimeout);
                reject($9bd0e0ec09375082$export$890c4ad488842ce7(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return !!$9bd0e0ec09375082$var$_window().grecaptcha?.render && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
}
function $9bd0e0ec09375082$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class $9bd0e0ec09375082$var$MockReCaptchaLoaderImpl {
    async load(auth) {
        return new $9bd0e0ec09375082$var$MockReCaptcha(auth);
    }
    clearedOneInstance() {}
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9bd0e0ec09375082$var$RECAPTCHA_VERIFIER_TYPE = 'recaptcha';
const $9bd0e0ec09375082$var$DEFAULT_PARAMS = {
    theme: 'light',
    type: 'image'
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @remarks
 * `RecaptchaVerifier` does not work in a Node.js environment.
 *
 * @public
 */ class $9bd0e0ec09375082$export$db202ddc8be9136 {
    /**
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     */ constructor(authExtern, containerOrId, parameters = {
        ...$9bd0e0ec09375082$var$DEFAULT_PARAMS
    }){
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $9bd0e0ec09375082$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $9bd0e0ec09375082$export$23ebac1979863676(authExtern);
        this.isInvisible = this.parameters.size === 'invisible';
        $9bd0e0ec09375082$export$24baa2b76016ce0e(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        $9bd0e0ec09375082$export$24baa2b76016ce0e(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $9bd0e0ec09375082$var$MockReCaptchaLoaderImpl() : new $9bd0e0ec09375082$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) return response;
        return new Promise((resolve)=>{
            const tokenChange = (token)=>{
                if (!token) return; // Ignore token expirations.
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) recaptcha.execute(id);
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ render() {
        try {
            this.assertNotDestroyed();
        } catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) return this.renderPromise;
        this.renderPromise = this.makeRenderPromise().catch((e)=>{
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */ _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) this.container.childNodes.forEach((node)=>{
            this.container.removeChild(node);
        });
    }
    validateStartingState() {
        $9bd0e0ec09375082$export$24baa2b76016ce0e(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $9bd0e0ec09375082$export$24baa2b76016ce0e(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $9bd0e0ec09375082$export$24baa2b76016ce0e(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    }
    makeTokenCallback(existing) {
        return (token)=>{
            this.tokenChangeListeners.forEach((listener)=>listener(token));
            if (typeof existing === 'function') existing(token);
            else if (typeof existing === 'string') {
                const globalFunc = $9bd0e0ec09375082$var$_window()[existing];
                if (typeof globalFunc === 'function') globalFunc(token);
            }
        };
    }
    assertNotDestroyed() {
        $9bd0e0ec09375082$export$24baa2b76016ce0e(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement('div');
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        $9bd0e0ec09375082$export$24baa2b76016ce0e($9bd0e0ec09375082$var$_isHttpOrHttps() && !$9bd0e0ec09375082$var$_isWorker(), this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        await $9bd0e0ec09375082$var$domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await $9bd0e0ec09375082$var$getRecaptchaParams(this.auth);
        $9bd0e0ec09375082$export$24baa2b76016ce0e(siteKey, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        $9bd0e0ec09375082$export$24baa2b76016ce0e(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.recaptcha;
    }
}
function $9bd0e0ec09375082$var$domReady() {
    let resolver = null;
    return new Promise((resolve)=>{
        if (document.readyState === 'complete') {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = ()=>resolve();
        window.addEventListener('load', resolver);
    }).catch((e)=>{
        if (resolver) window.removeEventListener('load', resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9bd0e0ec09375082$var$ConfirmationResultImpl {
    constructor(verificationId, onConfirmation){
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = $9bd0e0ec09375082$export$3a6d5c9ae78a2c08._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method requires a {@link ApplicationVerifier}.
 * This SDK includes an implementation based on reCAPTCHA v2, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * If you've enabled project-level reCAPTCHA Enterprise bot protection in
 * Enforce mode, you can omit the {@link ApplicationVerifier}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $9bd0e0ec09375082$export$2408f22a0fab9ae5(auth, phoneNumber, appVerifier) {
    if ((0, $0c1331d0a001f5bc$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($9bd0e0ec09375082$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $9bd0e0ec09375082$export$23ebac1979863676(auth);
    const verificationId = await $9bd0e0ec09375082$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(appVerifier));
    return new $9bd0e0ec09375082$var$ConfirmationResultImpl(verificationId, (cred)=>$9bd0e0ec09375082$export$ce26c07117d59d6a(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $9bd0e0ec09375082$export$882b5998b3b9117c(user, phoneNumber, appVerifier) {
    const userInternal = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(user);
    await $9bd0e0ec09375082$var$_assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ );
    const verificationId = await $9bd0e0ec09375082$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(appVerifier));
    return new $9bd0e0ec09375082$var$ConfirmationResultImpl(verificationId, (cred)=>$9bd0e0ec09375082$export$6559d589eb85fbb6(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $9bd0e0ec09375082$export$43caf9889c228507(user, phoneNumber, appVerifier) {
    const userInternal = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(user);
    if ((0, $0c1331d0a001f5bc$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($9bd0e0ec09375082$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    const verificationId = await $9bd0e0ec09375082$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(appVerifier));
    return new $9bd0e0ec09375082$var$ConfirmationResultImpl(verificationId, (cred)=>$9bd0e0ec09375082$export$efca4cbe5dd06740(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ async function $9bd0e0ec09375082$var$_verifyPhoneNumber(auth, options, verifier) {
    if (!auth._getRecaptchaConfig()) try {
        await $9bd0e0ec09375082$var$_initializeRecaptchaConfig(auth);
    } catch (error) {
        // If an error occurs while fetching the config, there is no way to know the enablement state
        // of Phone provider, so we proceed with recaptcha V2 verification.
        // The error is likely "recaptchaKey undefined", as reCAPTCHA Enterprise is not
        // enabled for any provider.
        console.log('Failed to initialize reCAPTCHA Enterprise config. Triggering the reCAPTCHA v2 verification.');
    }
    try {
        let phoneInfoOptions;
        if (typeof options === 'string') phoneInfoOptions = {
            phoneNumber: options
        };
        else phoneInfoOptions = options;
        if ('session' in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ('phoneNumber' in phoneInfoOptions) {
                $9bd0e0ec09375082$export$24baa2b76016ce0e(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const startPhoneMfaEnrollmentRequest = {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    }
                };
                const startEnrollPhoneMfaActionCallback = async (authInstance, request)=>{
                    // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                    if (request.phoneEnrollmentInfo.captchaResponse === $9bd0e0ec09375082$var$FAKE_TOKEN) {
                        $9bd0e0ec09375082$export$24baa2b76016ce0e(verifier?.type === $9bd0e0ec09375082$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        const requestWithRecaptchaV2 = await $9bd0e0ec09375082$var$injectRecaptchaV2Token(authInstance, request, verifier);
                        return $9bd0e0ec09375082$var$startEnrollPhoneMfa(authInstance, requestWithRecaptchaV2);
                    }
                    return $9bd0e0ec09375082$var$startEnrollPhoneMfa(authInstance, request);
                };
                const startPhoneMfaEnrollmentResponse = $9bd0e0ec09375082$var$handleRecaptchaFlow(auth, startPhoneMfaEnrollmentRequest, "mfaSmsEnrollment" /* RecaptchaActionName.MFA_SMS_ENROLLMENT */ , startEnrollPhoneMfaActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
                const response = await startPhoneMfaEnrollmentResponse.catch((error)=>{
                    return Promise.reject(error);
                });
                return response.phoneSessionInfo.sessionInfo;
            } else {
                $9bd0e0ec09375082$export$24baa2b76016ce0e(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const mfaEnrollmentId = phoneInfoOptions.multiFactorHint?.uid || phoneInfoOptions.multiFactorUid;
                $9bd0e0ec09375082$export$24baa2b76016ce0e(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                const startPhoneMfaSignInRequest = {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId: mfaEnrollmentId,
                    phoneSignInInfo: {
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    }
                };
                const startSignInPhoneMfaActionCallback = async (authInstance, request)=>{
                    // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                    if (request.phoneSignInInfo.captchaResponse === $9bd0e0ec09375082$var$FAKE_TOKEN) {
                        $9bd0e0ec09375082$export$24baa2b76016ce0e(verifier?.type === $9bd0e0ec09375082$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        const requestWithRecaptchaV2 = await $9bd0e0ec09375082$var$injectRecaptchaV2Token(authInstance, request, verifier);
                        return $9bd0e0ec09375082$var$startSignInPhoneMfa(authInstance, requestWithRecaptchaV2);
                    }
                    return $9bd0e0ec09375082$var$startSignInPhoneMfa(authInstance, request);
                };
                const startPhoneMfaSignInResponse = $9bd0e0ec09375082$var$handleRecaptchaFlow(auth, startPhoneMfaSignInRequest, "mfaSmsSignIn" /* RecaptchaActionName.MFA_SMS_SIGNIN */ , startSignInPhoneMfaActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
                const response = await startPhoneMfaSignInResponse.catch((error)=>{
                    return Promise.reject(error);
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        } else {
            const sendPhoneVerificationCodeRequest = {
                phoneNumber: phoneInfoOptions.phoneNumber,
                clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
            };
            const sendPhoneVerificationCodeActionCallback = async (authInstance, request)=>{
                // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                if (request.captchaResponse === $9bd0e0ec09375082$var$FAKE_TOKEN) {
                    $9bd0e0ec09375082$export$24baa2b76016ce0e(verifier?.type === $9bd0e0ec09375082$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                    const requestWithRecaptchaV2 = await $9bd0e0ec09375082$var$injectRecaptchaV2Token(authInstance, request, verifier);
                    return $9bd0e0ec09375082$var$sendPhoneVerificationCode(authInstance, requestWithRecaptchaV2);
                }
                return $9bd0e0ec09375082$var$sendPhoneVerificationCode(authInstance, request);
            };
            const sendPhoneVerificationCodeResponse = $9bd0e0ec09375082$var$handleRecaptchaFlow(auth, sendPhoneVerificationCodeRequest, "sendVerificationCode" /* RecaptchaActionName.SEND_VERIFICATION_CODE */ , sendPhoneVerificationCodeActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
            const response = await sendPhoneVerificationCodeResponse.catch((error)=>{
                return Promise.reject(error);
            });
            return response.sessionInfo;
        }
    } finally{
        verifier?._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ async function $9bd0e0ec09375082$export$3b14a55fb2447963(user, credential) {
    const userInternal = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(user);
    if ((0, $0c1331d0a001f5bc$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($9bd0e0ec09375082$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    await $9bd0e0ec09375082$var$_link$1(userInternal, credential);
}
// Helper function that fetches and injects a reCAPTCHA v2 token into the request.
async function $9bd0e0ec09375082$var$injectRecaptchaV2Token(auth, request, recaptchaV2Verifier) {
    $9bd0e0ec09375082$export$24baa2b76016ce0e(recaptchaV2Verifier.type === $9bd0e0ec09375082$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    const recaptchaV2Token = await recaptchaV2Verifier.verify();
    $9bd0e0ec09375082$export$24baa2b76016ce0e(typeof recaptchaV2Token === 'string', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    const newRequest = {
        ...request
    };
    if ('phoneEnrollmentInfo' in newRequest) {
        const phoneNumber = newRequest.phoneEnrollmentInfo.phoneNumber;
        const captchaResponse = newRequest.phoneEnrollmentInfo.captchaResponse;
        const clientType = newRequest.phoneEnrollmentInfo.clientType;
        const recaptchaVersion = newRequest.phoneEnrollmentInfo.recaptchaVersion;
        Object.assign(newRequest, {
            'phoneEnrollmentInfo': {
                phoneNumber: phoneNumber,
                recaptchaToken: recaptchaV2Token,
                captchaResponse: captchaResponse,
                clientType: clientType,
                recaptchaVersion: recaptchaVersion
            }
        });
        return newRequest;
    } else if ('phoneSignInInfo' in newRequest) {
        const captchaResponse = newRequest.phoneSignInInfo.captchaResponse;
        const clientType = newRequest.phoneSignInInfo.clientType;
        const recaptchaVersion = newRequest.phoneSignInInfo.recaptchaVersion;
        Object.assign(newRequest, {
            'phoneSignInInfo': {
                recaptchaToken: recaptchaV2Token,
                captchaResponse: captchaResponse,
                clientType: clientType,
                recaptchaVersion: recaptchaVersion
            }
        });
        return newRequest;
    } else {
        Object.assign(newRequest, {
            'recaptchaToken': recaptchaV2Token
        });
        return newRequest;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @remarks
 * `PhoneAuthProvider` does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ class $9bd0e0ec09375082$export$56c0d5a1e737357d {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */ constructor(auth){
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = $9bd0e0ec09375082$export$56c0d5a1e737357d.PROVIDER_ID;
        this.auth = $9bd0e0ec09375082$export$23ebac1979863676(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - An {@link ApplicationVerifier}, which prevents
     * requests from unauthorized clients. This SDK includes an implementation
     * based on reCAPTCHA v2, {@link RecaptchaVerifier}. If you've enabled
     * reCAPTCHA Enterprise bot protection in Enforce mode, this parameter is
     * optional; in all other configurations, the parameter is required.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow.
     */ verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return $9bd0e0ec09375082$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ static credential(verificationId, verificationCode) {
        return $9bd0e0ec09375082$export$3a6d5c9ae78a2c08._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        const credential = userCredential;
        return $9bd0e0ec09375082$export$56c0d5a1e737357d.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ static credentialFromError(error) {
        return $9bd0e0ec09375082$export$56c0d5a1e737357d.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { phoneNumber: phoneNumber, temporaryProof: temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) return $9bd0e0ec09375082$export$3a6d5c9ae78a2c08._fromTokenResponse(phoneNumber, temporaryProof);
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */ $9bd0e0ec09375082$export$56c0d5a1e737357d.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $9bd0e0ec09375082$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $9bd0e0ec09375082$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $9bd0e0ec09375082$export$cf2f7c5792f80b46(resolverOverride);
    $9bd0e0ec09375082$export$24baa2b76016ce0e(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9bd0e0ec09375082$var$IdpCredential extends $9bd0e0ec09375082$export$3a1a48c8f6ef640e {
    constructor(params){
        super("custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return $9bd0e0ec09375082$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return $9bd0e0ec09375082$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return $9bd0e0ec09375082$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) request.idToken = idToken;
        return request;
    }
}
function $9bd0e0ec09375082$var$_signIn(params) {
    return $9bd0e0ec09375082$var$_signInWithCredential(params.auth, new $9bd0e0ec09375082$var$IdpCredential(params), params.bypassAuthState);
}
function $9bd0e0ec09375082$var$_reauth(params) {
    const { auth: auth, user: user } = params;
    $9bd0e0ec09375082$export$24baa2b76016ce0e(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $9bd0e0ec09375082$var$_reauthenticate(user, new $9bd0e0ec09375082$var$IdpCredential(params), params.bypassAuthState);
}
async function $9bd0e0ec09375082$var$_link(params) {
    const { auth: auth, user: user } = params;
    $9bd0e0ec09375082$export$24baa2b76016ce0e(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $9bd0e0ec09375082$var$_link$1(user, new $9bd0e0ec09375082$var$IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ class $9bd0e0ec09375082$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false){
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    execute() {
        return new Promise(async (resolve, reject)=>{
            this.pendingPromise = {
                resolve: resolve,
                reject: reject
            };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            } catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse: urlResponse, sessionId: sessionId, postBody: postBody, tenantId: tenantId, error: error, type: type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        } catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch(type){
            case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
            case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                return $9bd0e0ec09375082$var$_signIn;
            case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
            case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                return $9bd0e0ec09375082$var$_link;
            case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
            case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                return $9bd0e0ec09375082$var$_reauth;
            default:
                $9bd0e0ec09375082$export$28f7fcd39efa255(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    resolve(cred) {
        $9bd0e0ec09375082$export$d66dc83d8cfc8dd(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        $9bd0e0ec09375082$export$d66dc83d8cfc8dd(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) this.eventManager.unregisterConsumer(this);
        this.pendingPromise = null;
        this.cleanUp();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9bd0e0ec09375082$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $9bd0e0ec09375082$var$Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $9bd0e0ec09375082$export$4368d992c4eafac0(auth, provider, resolver) {
    if ((0, $0c1331d0a001f5bc$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($9bd0e0ec09375082$export$890c4ad488842ce7(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    const authInternal = $9bd0e0ec09375082$export$23ebac1979863676(auth);
    $9bd0e0ec09375082$var$_assertInstanceOf(auth, provider, $9bd0e0ec09375082$var$FederatedAuthProvider);
    const resolverInternal = $9bd0e0ec09375082$var$_withDefaultResolver(authInternal, resolver);
    const action = new $9bd0e0ec09375082$var$PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $9bd0e0ec09375082$export$2d1720544b23b823(user, provider, resolver) {
    const userInternal = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(user);
    if ((0, $0c1331d0a001f5bc$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($9bd0e0ec09375082$export$890c4ad488842ce7(userInternal.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    $9bd0e0ec09375082$var$_assertInstanceOf(userInternal.auth, provider, $9bd0e0ec09375082$var$FederatedAuthProvider);
    const resolverInternal = $9bd0e0ec09375082$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $9bd0e0ec09375082$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $9bd0e0ec09375082$export$f1e1789686576879(user, provider, resolver) {
    const userInternal = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(user);
    $9bd0e0ec09375082$var$_assertInstanceOf(userInternal.auth, provider, $9bd0e0ec09375082$var$FederatedAuthProvider);
    const resolverInternal = $9bd0e0ec09375082$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $9bd0e0ec09375082$var$PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ class $9bd0e0ec09375082$var$PopupOperation extends $9bd0e0ec09375082$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user){
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if ($9bd0e0ec09375082$var$PopupOperation.currentPopupAction) $9bd0e0ec09375082$var$PopupOperation.currentPopupAction.cancel();
        $9bd0e0ec09375082$var$PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        $9bd0e0ec09375082$export$24baa2b76016ce0e(result, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return result;
    }
    async onExecution() {
        $9bd0e0ec09375082$export$d66dc83d8cfc8dd(this.filter.length === 1, 'Popup operations only handle one event');
        const eventId = $9bd0e0ec09375082$export$c03999cb2f36933f();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch((e)=>{
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, (isSupported)=>{
            if (!isSupported) this.reject($9bd0e0ec09375082$export$890c4ad488842ce7(this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        return this.authWindow?.associatedEvent || null;
    }
    cancel() {
        this.reject($9bd0e0ec09375082$export$890c4ad488842ce7(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
    }
    cleanUp() {
        if (this.authWindow) this.authWindow.close();
        if (this.pollId) window.clearTimeout(this.pollId);
        this.authWindow = null;
        this.pollId = null;
        $9bd0e0ec09375082$var$PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = ()=>{
            if (this.authWindow?.window?.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight. This is specifically true for
                // Firefox or if the opener is in an iframe, in which case the oauth
                // helper closes the popup.
                this.pollId = window.setTimeout(()=>{
                    this.pollId = null;
                    this.reject($9bd0e0ec09375082$export$890c4ad488842ce7(this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                }, 8000 /* _Timeout.AUTH_EVENT */ );
                return;
            }
            this.pollId = window.setTimeout(poll, $9bd0e0ec09375082$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$9bd0e0ec09375082$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9bd0e0ec09375082$var$PENDING_REDIRECT_KEY = 'pendingRedirect';
// We only get one redirect outcome for any one auth, so just store it
// in here.
const $9bd0e0ec09375082$var$redirectOutcomeMap = new Map();
class $9bd0e0ec09375082$var$RedirectAction extends $9bd0e0ec09375082$var$AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false){
        super(auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ async execute() {
        let readyOutcome = $9bd0e0ec09375082$var$redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await $9bd0e0ec09375082$var$_getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = ()=>Promise.resolve(result);
            } catch (e) {
                readyOutcome = ()=>Promise.reject(e);
            }
            $9bd0e0ec09375082$var$redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) $9bd0e0ec09375082$var$redirectOutcomeMap.set(this.auth._key(), ()=>Promise.resolve(null));
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return super.onAuthEvent(event);
        else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            } else this.resolve(null);
        }
    }
    async onExecution() {}
    cleanUp() {}
}
async function $9bd0e0ec09375082$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    const key = $9bd0e0ec09375082$var$pendingRedirectKey(auth);
    const persistence = $9bd0e0ec09375082$var$resolverPersistence(resolver);
    if (!await persistence._isAvailable()) return false;
    const hasPendingRedirect = await persistence._get(key) === 'true';
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function $9bd0e0ec09375082$var$_setPendingRedirectStatus(resolver, auth) {
    return $9bd0e0ec09375082$var$resolverPersistence(resolver)._set($9bd0e0ec09375082$var$pendingRedirectKey(auth), 'true');
}
function $9bd0e0ec09375082$export$a05254e7c3aeba6e() {
    $9bd0e0ec09375082$var$redirectOutcomeMap.clear();
}
function $9bd0e0ec09375082$export$b9a6b53f9be3734(auth, result) {
    $9bd0e0ec09375082$var$redirectOutcomeMap.set(auth._key(), result);
}
function $9bd0e0ec09375082$var$resolverPersistence(resolver) {
    return $9bd0e0ec09375082$export$cf2f7c5792f80b46(resolver._redirectPersistence);
}
function $9bd0e0ec09375082$var$pendingRedirectKey(auth) {
    return $9bd0e0ec09375082$export$53a70dd1ebbae346($9bd0e0ec09375082$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $9bd0e0ec09375082$export$39b482c5e57630a8(auth, provider, resolver) {
    return $9bd0e0ec09375082$var$_signInWithRedirect(auth, provider, resolver);
}
async function $9bd0e0ec09375082$var$_signInWithRedirect(auth, provider, resolver) {
    if ((0, $0c1331d0a001f5bc$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($9bd0e0ec09375082$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $9bd0e0ec09375082$export$23ebac1979863676(auth);
    $9bd0e0ec09375082$var$_assertInstanceOf(auth, provider, $9bd0e0ec09375082$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await authInternal._initializationPromise;
    const resolverInternal = $9bd0e0ec09375082$var$_withDefaultResolver(authInternal, resolver);
    await $9bd0e0ec09375082$var$_setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ );
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $9bd0e0ec09375082$export$35e795649ee09318(user, provider, resolver) {
    return $9bd0e0ec09375082$var$_reauthenticateWithRedirect(user, provider, resolver);
}
async function $9bd0e0ec09375082$var$_reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(user);
    $9bd0e0ec09375082$var$_assertInstanceOf(userInternal.auth, provider, $9bd0e0ec09375082$var$FederatedAuthProvider);
    if ((0, $0c1331d0a001f5bc$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($9bd0e0ec09375082$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $9bd0e0ec09375082$var$_withDefaultResolver(userInternal.auth, resolver);
    await $9bd0e0ec09375082$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $9bd0e0ec09375082$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $9bd0e0ec09375082$export$dda1d9f60106f0e9(user, provider, resolver) {
    return $9bd0e0ec09375082$var$_linkWithRedirect(user, provider, resolver);
}
async function $9bd0e0ec09375082$var$_linkWithRedirect(user, provider, resolver) {
    const userInternal = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(user);
    $9bd0e0ec09375082$var$_assertInstanceOf(userInternal.auth, provider, $9bd0e0ec09375082$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $9bd0e0ec09375082$var$_withDefaultResolver(userInternal.auth, resolver);
    await $9bd0e0ec09375082$var$_assertLinkedStatus(false, userInternal, provider.providerId);
    await $9bd0e0ec09375082$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $9bd0e0ec09375082$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $9bd0e0ec09375082$export$342063e11d6c3cad(auth, resolver) {
    await $9bd0e0ec09375082$export$23ebac1979863676(auth)._initializationPromise;
    return $9bd0e0ec09375082$export$a33b77bbdbb8366c(auth, resolver, false);
}
async function $9bd0e0ec09375082$export$a33b77bbdbb8366c(auth, resolverExtern, bypassAuthState = false) {
    if ((0, $0c1331d0a001f5bc$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($9bd0e0ec09375082$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $9bd0e0ec09375082$export$23ebac1979863676(auth);
    const resolver = $9bd0e0ec09375082$var$_withDefaultResolver(authInternal, resolverExtern);
    const action = new $9bd0e0ec09375082$var$RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function $9bd0e0ec09375082$var$prepareUserForRedirect(user) {
    const eventId = $9bd0e0ec09375082$export$c03999cb2f36933f(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const $9bd0e0ec09375082$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
class $9bd0e0ec09375082$export$158acd800e1ef08b {
    constructor(auth){
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) return false;
        let handled = false;
        this.consumers.forEach((consumer)=>{
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !$9bd0e0ec09375082$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        if (event.error && !$9bd0e0ec09375082$var$isNullRedirectEvent(event)) {
            const code = event.error.code?.split('auth/')[1] || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
            consumer.onError($9bd0e0ec09375082$export$890c4ad488842ce7(this.auth, code));
        } else consumer.onAuthEvent(event);
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >= $9bd0e0ec09375082$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
        return this.cachedEventUids.has($9bd0e0ec09375082$var$eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add($9bd0e0ec09375082$var$eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function $9bd0e0ec09375082$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter((v)=>v).join('-');
}
function $9bd0e0ec09375082$var$isNullRedirectEvent({ type: type, error: error }) {
    return type === "unknown" /* AuthEventType.UNKNOWN */  && error?.code === `auth/${"no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ }`;
}
function $9bd0e0ec09375082$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return $9bd0e0ec09375082$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $9bd0e0ec09375082$export$91c6e00c14e7e6fd(auth, request = {}) {
    return $9bd0e0ec09375082$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9bd0e0ec09375082$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const $9bd0e0ec09375082$var$HTTP_REGEX = /^https?/;
async function $9bd0e0ec09375082$var$_validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) return;
    const { authorizedDomains: authorizedDomains } = await $9bd0e0ec09375082$export$91c6e00c14e7e6fd(auth);
    for (const domain of authorizedDomains)try {
        if ($9bd0e0ec09375082$var$matchDomain(domain)) return;
    } catch  {
    // Do nothing if there's a URL error; just continue searching
    }
    // In the old SDK, this error also provides helpful messages.
    $9bd0e0ec09375082$export$28f7fcd39efa255(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
}
function $9bd0e0ec09375082$var$matchDomain(expected) {
    const currentUrl = $9bd0e0ec09375082$var$_getCurrentUrl();
    const { protocol: protocol, hostname: hostname } = new URL(currentUrl);
    if (expected.startsWith('chrome-extension://')) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === '' && hostname === '') // For some reason we're not parsing chrome URLs properly
        return protocol === 'chrome-extension:' && expected.replace('chrome-extension://', '') === currentUrl.replace('chrome-extension://', '');
        return protocol === 'chrome-extension:' && ceUrl.hostname === hostname;
    }
    if (!$9bd0e0ec09375082$var$HTTP_REGEX.test(protocol)) return false;
    if ($9bd0e0ec09375082$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, '\\.');
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp('^(.+\\.' + escapedDomainPattern + '|' + escapedDomainPattern + ')$', 'i');
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9bd0e0ec09375082$var$NETWORK_TIMEOUT = new $9bd0e0ec09375082$var$Delay(30000, 60000);
/**
 * Reset unloaded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $9bd0e0ec09375082$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = $9bd0e0ec09375082$var$_window().___jsl;
    // Get current hint.
    if (beacon?.H) // Get gapi hint.
    for (const hint of Object.keys(beacon.H)){
        // Requested modules.
        beacon.H[hint].r = beacon.H[hint].r || [];
        // Loaded modules.
        beacon.H[hint].L = beacon.H[hint].L || [];
        // Set requested modules to a copy of the loaded modules.
        beacon.H[hint].r = [
            ...beacon.H[hint].L
        ];
        // Clear pending callbacks.
        if (beacon.CP) for(let i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
        beacon.CP[i] = null;
    }
}
function $9bd0e0ec09375082$var$loadGapi(auth) {
    return new Promise((resolve, reject)=>{
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $9bd0e0ec09375082$var$resetUnloadedGapiModules();
            gapi.load('gapi.iframes', {
                callback: ()=>{
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: ()=>{
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $9bd0e0ec09375082$var$resetUnloadedGapiModules();
                    reject($9bd0e0ec09375082$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $9bd0e0ec09375082$var$NETWORK_TIMEOUT.get()
            });
        }
        if ($9bd0e0ec09375082$var$_window().gapi?.iframes?.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!$9bd0e0ec09375082$var$_window().gapi?.load) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = $9bd0e0ec09375082$var$_generateCallbackName('iframefcb');
            // GApi loader not available, dynamically load platform.js.
            $9bd0e0ec09375082$var$_window()[cbName] = ()=>{
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($9bd0e0ec09375082$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $9bd0e0ec09375082$var$_loadJS(`${$9bd0e0ec09375082$var$_gapiScriptUrl()}?onload=${cbName}`).catch((e)=>reject(e));
        }
    }).catch((error)=>{
        // Reset cached promise to allow for retrial.
        $9bd0e0ec09375082$var$cachedGApiLoader = null;
        throw error;
    });
}
let $9bd0e0ec09375082$var$cachedGApiLoader = null;
function $9bd0e0ec09375082$var$_loadGapi(auth) {
    $9bd0e0ec09375082$var$cachedGApiLoader = $9bd0e0ec09375082$var$cachedGApiLoader || $9bd0e0ec09375082$var$loadGapi(auth);
    return $9bd0e0ec09375082$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9bd0e0ec09375082$var$PING_TIMEOUT = new $9bd0e0ec09375082$var$Delay(5000, 15000);
const $9bd0e0ec09375082$var$IFRAME_PATH = '__/auth/iframe';
const $9bd0e0ec09375082$var$EMULATED_IFRAME_PATH = 'emulator/auth/iframe';
const $9bd0e0ec09375082$var$IFRAME_ATTRIBUTES = {
    style: {
        position: 'absolute',
        top: '-100px',
        width: '1px',
        height: '1px'
    },
    'aria-hidden': 'true',
    tabindex: '-1'
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const $9bd0e0ec09375082$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        'p'
    ],
    [
        'staging-identitytoolkit.sandbox.googleapis.com',
        's'
    ],
    [
        'test-identitytoolkit.sandbox.googleapis.com',
        't'
    ] // test
]);
function $9bd0e0ec09375082$var$getIframeUrl(auth) {
    const config = auth.config;
    $9bd0e0ec09375082$export$24baa2b76016ce0e(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    const url = config.emulator ? $9bd0e0ec09375082$var$_emulatorUrl(config, $9bd0e0ec09375082$var$EMULATED_IFRAME_PATH) : `https://${auth.config.authDomain}/${$9bd0e0ec09375082$var$IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $0c1331d0a001f5bc$export$31499a9cd224b78c)
    };
    const eid = $9bd0e0ec09375082$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    const frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(',');
    return `${url}?${(0, $3117f6f4eeb4c314$export$ac4103b836844853)(params).slice(1)}`;
}
async function $9bd0e0ec09375082$var$_openIframe(auth) {
    const context = await $9bd0e0ec09375082$var$_loadGapi(auth);
    const gapi1 = $9bd0e0ec09375082$var$_window().gapi;
    $9bd0e0ec09375082$export$24baa2b76016ce0e(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return context.open({
        where: document.body,
        url: $9bd0e0ec09375082$var$getIframeUrl(auth),
        messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: $9bd0e0ec09375082$var$IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe)=>new Promise(async (resolve, reject)=>{
            await iframe.restyle({
                // Prevent iframe from closing on mouse out.
                setHideOnLeave: false
            });
            const networkError = $9bd0e0ec09375082$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
            // Confirm iframe is correctly loaded.
            // To fallback on failure, set a timeout.
            const networkErrorTimer = $9bd0e0ec09375082$var$_window().setTimeout(()=>{
                reject(networkError);
            }, $9bd0e0ec09375082$var$PING_TIMEOUT.get());
            // Clear timer and resolve pending iframe ready promise.
            function clearTimerAndResolve() {
                $9bd0e0ec09375082$var$_window().clearTimeout(networkErrorTimer);
                resolve(iframe);
            }
            // This returns an IThenable. However the reject part does not call
            // when the iframe is not loaded.
            iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, ()=>{
                reject(networkError);
            });
        }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9bd0e0ec09375082$var$BASE_POPUP_OPTIONS = {
    location: 'yes',
    resizable: 'yes',
    statusbar: 'yes',
    toolbar: 'no'
};
const $9bd0e0ec09375082$var$DEFAULT_WIDTH = 500;
const $9bd0e0ec09375082$var$DEFAULT_HEIGHT = 600;
const $9bd0e0ec09375082$var$TARGET_BLANK = '_blank';
const $9bd0e0ec09375082$var$FIREFOX_EMPTY_URL = 'http://localhost';
class $9bd0e0ec09375082$export$2ed0fc6709e59212 {
    constructor(window1){
        this.window = window1;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) try {
            this.window.close();
        } catch (e) {}
    }
}
function $9bd0e0ec09375082$var$_open(auth, url, name, width = $9bd0e0ec09375082$var$DEFAULT_WIDTH, height = $9bd0e0ec09375082$var$DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = '';
    const options = {
        ...$9bd0e0ec09375082$var$BASE_POPUP_OPTIONS,
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    };
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0, $3117f6f4eeb4c314$export$c36915b22ce77c19)().toLowerCase();
    if (name) target = $9bd0e0ec09375082$var$_isChromeIOS(ua) ? $9bd0e0ec09375082$var$TARGET_BLANK : name;
    if ($9bd0e0ec09375082$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $9bd0e0ec09375082$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = 'yes';
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value])=>`${accum}${key}=${value},`, '');
    if ($9bd0e0ec09375082$var$_isIOSStandalone(ua) && target !== '_self') {
        $9bd0e0ec09375082$var$openAsNewWindowIOS(url || '', target);
        return new $9bd0e0ec09375082$export$2ed0fc6709e59212(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || '', target, optionsString);
    $9bd0e0ec09375082$export$24baa2b76016ce0e(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $9bd0e0ec09375082$export$2ed0fc6709e59212(newWin);
}
function $9bd0e0ec09375082$var$openAsNewWindowIOS(url, target) {
    const el = document.createElement('a');
    el.href = url;
    el.target = target;
    const click = document.createEvent('MouseEvent');
    click.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ const $9bd0e0ec09375082$var$WIDGET_PATH = '__/auth/handler';
/**
 * URL for emulated environment
 *
 * @internal
 */ const $9bd0e0ec09375082$var$EMULATOR_WIDGET_PATH = 'emulator/auth/handler';
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ const $9bd0e0ec09375082$var$FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent('fac');
async function $9bd0e0ec09375082$export$3d12bd131bb975d1(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    $9bd0e0ec09375082$export$24baa2b76016ce0e(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    $9bd0e0ec09375082$export$24baa2b76016ce0e(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType: authType,
        redirectUrl: redirectUrl,
        v: (0, $0c1331d0a001f5bc$export$31499a9cd224b78c),
        eventId: eventId
    };
    if (provider instanceof $9bd0e0ec09375082$var$FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || '';
        if (!(0, $3117f6f4eeb4c314$export$dd1bc94b04021eeb)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {}))params[key] = value;
    }
    if (provider instanceof $9bd0e0ec09375082$var$BaseOAuthProvider) {
        const scopes = provider.getScopes().filter((scope)=>scope !== '');
        if (scopes.length > 0) params.scopes = scopes.join(',');
    }
    if (auth.tenantId) params.tid = auth.tenantId;
    // TODO: maybe set eid as endpointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict))if (paramsDict[key] === undefined) delete paramsDict[key];
    // Sets the App Check token to pass to the widget
    const appCheckToken = await auth._getAppCheckToken();
    const appCheckTokenFragment = appCheckToken ? `#${$9bd0e0ec09375082$var$FIREBASE_APP_CHECK_FRAGMENT_ID}=${encodeURIComponent(appCheckToken)}` : '';
    // Start at index 1 to skip the leading '&' in the query string
    return `${$9bd0e0ec09375082$var$getHandlerBase(auth)}?${(0, $3117f6f4eeb4c314$export$ac4103b836844853)(paramsDict).slice(1)}${appCheckTokenFragment}`;
}
function $9bd0e0ec09375082$var$getHandlerBase({ config: config }) {
    if (!config.emulator) return `https://${config.authDomain}/${$9bd0e0ec09375082$var$WIDGET_PATH}`;
    return $9bd0e0ec09375082$var$_emulatorUrl(config, $9bd0e0ec09375082$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ const $9bd0e0ec09375082$var$WEB_STORAGE_SUPPORT_KEY = 'webStorageSupport';
class $9bd0e0ec09375082$var$BrowserPopupRedirectResolver {
    constructor(){
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $9bd0e0ec09375082$export$db3b6bfb95261072;
        this._completeRedirectFn = $9bd0e0ec09375082$export$a33b77bbdbb8366c;
        this._overrideRedirectResult = $9bd0e0ec09375082$export$b9a6b53f9be3734;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        $9bd0e0ec09375082$export$d66dc83d8cfc8dd(this.eventManagers[auth._key()]?.manager, '_initialize() not called before _openPopup()');
        const url = await $9bd0e0ec09375082$export$3d12bd131bb975d1(auth, provider, authType, $9bd0e0ec09375082$var$_getCurrentUrl(), eventId);
        return $9bd0e0ec09375082$var$_open(auth, url, $9bd0e0ec09375082$export$c03999cb2f36933f());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        const url = await $9bd0e0ec09375082$export$3d12bd131bb975d1(auth, provider, authType, $9bd0e0ec09375082$var$_getCurrentUrl(), eventId);
        $9bd0e0ec09375082$var$_setWindowLocation(url);
        return new Promise(()=>{});
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager: manager, promise: promise } = this.eventManagers[key];
            if (manager) return Promise.resolve(manager);
            else {
                $9bd0e0ec09375082$export$d66dc83d8cfc8dd(promise, 'If manager is not set, promise should be');
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = {
            promise: promise
        };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(()=>{
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await $9bd0e0ec09375082$var$_openIframe(auth);
        const manager = new $9bd0e0ec09375082$export$158acd800e1ef08b(auth);
        iframe.register('authEvent', (iframeEvent)=>{
            $9bd0e0ec09375082$export$24baa2b76016ce0e(iframeEvent?.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return {
                status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
            };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = {
            manager: manager
        };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send($9bd0e0ec09375082$var$WEB_STORAGE_SUPPORT_KEY, {
            type: $9bd0e0ec09375082$var$WEB_STORAGE_SUPPORT_KEY
        }, (result)=>{
            const isSupported = result?.[0]?.[$9bd0e0ec09375082$var$WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) cb(!!isSupported);
            $9bd0e0ec09375082$export$28f7fcd39efa255(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $9bd0e0ec09375082$var$_validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return $9bd0e0ec09375082$var$_isMobileBrowser() || $9bd0e0ec09375082$var$_isSafari() || $9bd0e0ec09375082$export$92108d983e8ee699();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @public
 */ const $9bd0e0ec09375082$export$953cecd6e717a553 = $9bd0e0ec09375082$var$BrowserPopupRedirectResolver;
class $9bd0e0ec09375082$var$MultiFactorAssertionImpl {
    constructor(factorId){
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch(session.type){
            case "enroll" /* MultiFactorSessionType.ENROLL */ :
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                return this._finalizeSignIn(auth, session.credential);
            default:
                return $9bd0e0ec09375082$var$debugFail('unexpected MultiFactorSessionType');
        }
    }
}
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ class $9bd0e0ec09375082$var$PhoneMultiFactorAssertionImpl extends $9bd0e0ec09375082$var$MultiFactorAssertionImpl {
    constructor(credential){
        super("phone" /* FactorId.PHONE */ );
        this.credential = credential;
    }
    /** @internal */ static _fromCredential(credential) {
        return new $9bd0e0ec09375082$var$PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */ _finalizeEnroll(auth, idToken, displayName) {
        return $9bd0e0ec09375082$var$finalizeEnrollPhoneMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */ _finalizeSignIn(auth, mfaPendingCredential) {
        return $9bd0e0ec09375082$var$finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ class $9bd0e0ec09375082$export$7ccc53e8f1e7dfc5 {
    constructor(){}
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @remarks
     * This method does not work in a Node.js environment.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ static assertion(credential) {
        return $9bd0e0ec09375082$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */ $9bd0e0ec09375082$export$7ccc53e8f1e7dfc5.FACTOR_ID = 'phone';
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ class $9bd0e0ec09375082$export$971d5caa766a69d7 {
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ static assertionForEnrollment(secret, oneTimePassword) {
        return $9bd0e0ec09375082$var$TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
    }
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ static assertionForSignIn(enrollmentId, oneTimePassword) {
        return $9bd0e0ec09375082$var$TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
    }
    /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ static async generateSecret(session) {
        const mfaSession = session;
        $9bd0e0ec09375082$export$24baa2b76016ce0e(typeof mfaSession.user?.auth !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const response = await $9bd0e0ec09375082$var$startEnrollTotpMfa(mfaSession.user.auth, {
            idToken: mfaSession.credential,
            totpEnrollmentInfo: {}
        });
        return $9bd0e0ec09375082$export$ae1af26003f05816._fromStartTotpMfaEnrollmentResponse(response, mfaSession.user.auth);
    }
}
/**
 * The identifier of the TOTP second factor: `totp`.
 */ $9bd0e0ec09375082$export$971d5caa766a69d7.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
class $9bd0e0ec09375082$var$TotpMultiFactorAssertionImpl extends $9bd0e0ec09375082$var$MultiFactorAssertionImpl {
    constructor(otp, enrollmentId, secret){
        super("totp" /* FactorId.TOTP */ );
        this.otp = otp;
        this.enrollmentId = enrollmentId;
        this.secret = secret;
    }
    /** @internal */ static _fromSecret(secret, otp) {
        return new $9bd0e0ec09375082$var$TotpMultiFactorAssertionImpl(otp, undefined, secret);
    }
    /** @internal */ static _fromEnrollmentId(enrollmentId, otp) {
        return new $9bd0e0ec09375082$var$TotpMultiFactorAssertionImpl(otp, enrollmentId);
    }
    /** @internal */ async _finalizeEnroll(auth, idToken, displayName) {
        $9bd0e0ec09375082$export$24baa2b76016ce0e(typeof this.secret !== 'undefined', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $9bd0e0ec09375082$var$finalizeEnrollTotpMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
        });
    }
    /** @internal */ async _finalizeSignIn(auth, mfaPendingCredential) {
        $9bd0e0ec09375082$export$24baa2b76016ce0e(this.enrollmentId !== undefined && this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        const totpVerificationInfo = {
            verificationCode: this.otp
        };
        return $9bd0e0ec09375082$var$finalizeSignInTotpMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            mfaEnrollmentId: this.enrollmentId,
            totpVerificationInfo: totpVerificationInfo
        });
    }
}
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ class $9bd0e0ec09375082$export$ae1af26003f05816 {
    // The public members are declared outside the constructor so the docs can be generated.
    constructor(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth){
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    /** @internal */ static _fromStartTotpMfaEnrollmentResponse(response, auth) {
        return new $9bd0e0ec09375082$export$ae1af26003f05816(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
    }
    /** @internal */ _makeTotpVerificationInfo(otp) {
        return {
            sessionInfo: this.sessionInfo,
            verificationCode: otp
        };
    }
    /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ generateQrCodeUrl(accountName, issuer) {
        let useDefaults = false;
        if ($9bd0e0ec09375082$var$_isEmptyString(accountName) || $9bd0e0ec09375082$var$_isEmptyString(issuer)) useDefaults = true;
        if (useDefaults) {
            if ($9bd0e0ec09375082$var$_isEmptyString(accountName)) accountName = this.auth.currentUser?.email || 'unknownuser';
            if ($9bd0e0ec09375082$var$_isEmptyString(issuer)) issuer = this.auth.name;
        }
        return `otpauth://totp/${issuer}:${accountName}?secret=${this.secretKey}&issuer=${issuer}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
    }
}
/** @internal */ function $9bd0e0ec09375082$var$_isEmptyString(input) {
    return typeof input === 'undefined' || input?.length === 0;
}
var $9bd0e0ec09375082$var$name = "@firebase/auth";
var $9bd0e0ec09375082$var$version = "1.12.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9bd0e0ec09375082$var$AuthInterop {
    constructor(auth){
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        this.assertAuthConfigured();
        return this.auth.currentUser?.uid || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) return null;
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return {
            accessToken: accessToken
        };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) return;
        const unsubscribe = this.auth.onIdTokenChanged((user)=>{
            listener(user?.stsTokenManager.accessToken || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) return;
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        $9bd0e0ec09375082$export$24baa2b76016ce0e(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
        else this.auth._stopProactiveRefresh();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9bd0e0ec09375082$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return 'node';
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return 'rn';
        case "Worker" /* ClientPlatform.WORKER */ :
            return 'webworker';
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return 'cordova';
        case "WebExtension" /* ClientPlatform.WEB_EXTENSION */ :
            return 'web-extension';
        default:
            return undefined;
    }
}
/** @internal */ function $9bd0e0ec09375082$var$registerAuth(clientPlatform) {
    (0, $0c1331d0a001f5bc$export$c930050e7bb63965)(new (0, $ad76b76e741ec0c7$export$16fa2f45be04daa8)("auth" /* _ComponentName.AUTH */ , (container, { options: deps })=>{
        const app = container.getProvider('app').getImmediate();
        const heartbeatServiceProvider = container.getProvider('heartbeat');
        const appCheckServiceProvider = container.getProvider('app-check-internal');
        const { apiKey: apiKey, authDomain: authDomain } = app.options;
        $9bd0e0ec09375082$export$24baa2b76016ce0e(apiKey && !apiKey.includes(':'), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        const config = {
            apiKey: apiKey,
            authDomain: authDomain,
            clientPlatform: clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: $9bd0e0ec09375082$export$faec65b429be379(clientPlatform)
        };
        const authInstance = new $9bd0e0ec09375082$export$9f4f30ee63539e24(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        $9bd0e0ec09375082$var$_initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback((container, _instanceIdentifier, _instance)=>{
        const authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $0c1331d0a001f5bc$export$c930050e7bb63965)(new (0, $ad76b76e741ec0c7$export$16fa2f45be04daa8)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , (container)=>{
        const auth = $9bd0e0ec09375082$export$23ebac1979863676(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return ((auth)=>new $9bd0e0ec09375082$var$AuthInterop(auth))(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, $0c1331d0a001f5bc$export$d29d5299a7137abc)($9bd0e0ec09375082$var$name, $9bd0e0ec09375082$var$version, $9bd0e0ec09375082$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    (0, $0c1331d0a001f5bc$export$d29d5299a7137abc)($9bd0e0ec09375082$var$name, $9bd0e0ec09375082$var$version, 'esm2020');
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9bd0e0ec09375082$var$DEFAULT_ID_TOKEN_MAX_AGE = 300;
const $9bd0e0ec09375082$var$authIdTokenMaxAge = (0, $3117f6f4eeb4c314$export$5539a1a3afe87d6)('authIdTokenMaxAge') || $9bd0e0ec09375082$var$DEFAULT_ID_TOKEN_MAX_AGE;
let $9bd0e0ec09375082$var$lastPostedIdToken = null;
const $9bd0e0ec09375082$var$mintCookieFactory = (url)=>async (user)=>{
        const idTokenResult = user && await user.getIdTokenResult();
        const idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
        if (idTokenAge && idTokenAge > $9bd0e0ec09375082$var$authIdTokenMaxAge) return;
        // Specifically trip null => undefined when logged out, to delete any existing cookie
        const idToken = idTokenResult?.token;
        if ($9bd0e0ec09375082$var$lastPostedIdToken === idToken) return;
        $9bd0e0ec09375082$var$lastPostedIdToken = idToken;
        await fetch(url, {
            method: idToken ? 'POST' : 'DELETE',
            headers: idToken ? {
                'Authorization': `Bearer ${idToken}`
            } : {}
        });
    };
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $9bd0e0ec09375082$export$ffb5f4729a158638(app = (0, $0c1331d0a001f5bc$export$f9962582c9e66d99)()) {
    const provider = (0, $0c1331d0a001f5bc$export$fa0d6da0f5838f50)(app, 'auth');
    if (provider.isInitialized()) return provider.getImmediate();
    const auth = $9bd0e0ec09375082$export$3466f893ebf79586(app, {
        popupRedirectResolver: $9bd0e0ec09375082$export$953cecd6e717a553,
        persistence: [
            $9bd0e0ec09375082$export$23f2a1d2818174ef,
            $9bd0e0ec09375082$export$8b22cf2602fb60ce,
            $9bd0e0ec09375082$export$db3b6bfb95261072
        ]
    });
    const authTokenSyncPath = (0, $3117f6f4eeb4c314$export$5539a1a3afe87d6)('authTokenSyncURL');
    // Only do the Cookie exchange in a secure context
    if (authTokenSyncPath && typeof isSecureContext === 'boolean' && isSecureContext) {
        // Don't allow urls (XSS possibility), only paths on the same domain
        const authTokenSyncUrl = new URL(authTokenSyncPath, location.origin);
        if (location.origin === authTokenSyncUrl.origin) {
            const mintCookie = $9bd0e0ec09375082$var$mintCookieFactory(authTokenSyncUrl.toString());
            $9bd0e0ec09375082$export$4a5767248b18ef41(auth, mintCookie, ()=>mintCookie(auth.currentUser));
            $9bd0e0ec09375082$export$d141bba7fdc215a3(auth, (user)=>mintCookie(user));
        }
    }
    const authEmulatorHost = (0, $3117f6f4eeb4c314$export$9c11895284c8adad)('auth');
    if (authEmulatorHost) $9bd0e0ec09375082$export$61196ced6d74a310(auth, `http://${authEmulatorHost}`);
    return auth;
}
function $9bd0e0ec09375082$var$getScriptParentElement() {
    return document.getElementsByTagName('head')?.[0] ?? document;
}
$9bd0e0ec09375082$var$_setExternalJSProvider({
    loadJS (url) {
        // TODO: consider adding timeout support & cancellation
        return new Promise((resolve, reject)=>{
            const el = document.createElement('script');
            el.setAttribute('src', url);
            el.onload = resolve;
            el.onerror = (e)=>{
                const error = $9bd0e0ec09375082$export$890c4ad488842ce7("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                error.customData = e;
                reject(error);
            };
            el.type = 'text/javascript';
            el.charset = 'UTF-8';
            $9bd0e0ec09375082$var$getScriptParentElement().appendChild(el);
        });
    },
    gapiScript: 'https://apis.google.com/js/api.js',
    recaptchaV2Script: 'https://www.google.com/recaptcha/api.js',
    recaptchaEnterpriseScript: 'https://www.google.com/recaptcha/enterprise.js?render='
});
$9bd0e0ec09375082$var$registerAuth("Browser" /* ClientPlatform.BROWSER */ );






/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $fc85e1a138086dd4$var$_cordovaWindow() {
    return window;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * How long to wait after the app comes back into focus before concluding that
 * the user closed the sign in tab.
 */ const $fc85e1a138086dd4$var$REDIRECT_TIMEOUT_MS = 2000;
/**
 * Generates the URL for the OAuth handler.
 */ async function $fc85e1a138086dd4$var$_generateHandlerUrl(auth, event, provider) {
    // Get the cordova plugins
    const { BuildInfo: BuildInfo } = $fc85e1a138086dd4$var$_cordovaWindow();
    (0, $9bd0e0ec09375082$export$d66dc83d8cfc8dd)(event.sessionId, 'AuthEvent did not contain a session ID');
    const sessionDigest = await $fc85e1a138086dd4$var$computeSha256(event.sessionId);
    const additionalParams = {};
    if ((0, $9bd0e0ec09375082$export$92108d983e8ee699)()) // iOS app identifier
    additionalParams['ibi'] = BuildInfo.packageName;
    else if ((0, $9bd0e0ec09375082$export$9fa96a7d116ea3ce)()) // Android app identifier
    additionalParams['apn'] = BuildInfo.packageName;
    else (0, $9bd0e0ec09375082$export$28f7fcd39efa255)(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    // Add the display name if available
    if (BuildInfo.displayName) additionalParams['appDisplayName'] = BuildInfo.displayName;
    // Attached the hashed session ID
    additionalParams['sessionId'] = sessionDigest;
    return (0, $9bd0e0ec09375082$export$3d12bd131bb975d1)(auth, provider, event.type, undefined, event.eventId ?? undefined, additionalParams);
}
/**
 * Validates that this app is valid for this project configuration
 */ async function $fc85e1a138086dd4$var$_validateOrigin(auth) {
    const { BuildInfo: BuildInfo } = $fc85e1a138086dd4$var$_cordovaWindow();
    const request = {};
    if ((0, $9bd0e0ec09375082$export$92108d983e8ee699)()) request.iosBundleId = BuildInfo.packageName;
    else if ((0, $9bd0e0ec09375082$export$9fa96a7d116ea3ce)()) request.androidPackageName = BuildInfo.packageName;
    else (0, $9bd0e0ec09375082$export$28f7fcd39efa255)(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    // Will fail automatically if package name is not authorized
    await (0, $9bd0e0ec09375082$export$91c6e00c14e7e6fd)(auth, request);
}
function $fc85e1a138086dd4$var$_performRedirect(handlerUrl) {
    // Get the cordova plugins
    const { cordova: cordova } = $fc85e1a138086dd4$var$_cordovaWindow();
    return new Promise((resolve)=>{
        cordova.plugins.browsertab.isAvailable((browserTabIsAvailable)=>{
            let iabRef = null;
            if (browserTabIsAvailable) cordova.plugins.browsertab.openUrl(handlerUrl);
            else // TODO: Return the inappbrowser ref that's returned from the open call
            iabRef = cordova.InAppBrowser.open(handlerUrl, (0, $9bd0e0ec09375082$export$9d398bebfec1c039)() ? '_blank' : '_system', 'location=yes');
            resolve(iabRef);
        });
    });
}
/**
 * This function waits for app activity to be seen before resolving. It does
 * this by attaching listeners to various dom events. Once the app is determined
 * to be visible, this promise resolves. AFTER that resolution, the listeners
 * are detached and any browser tabs left open will be closed.
 */ async function $fc85e1a138086dd4$var$_waitForAppResume(auth, eventListener, iabRef) {
    // Get the cordova plugins
    const { cordova: cordova } = $fc85e1a138086dd4$var$_cordovaWindow();
    let cleanup = ()=>{};
    try {
        await new Promise((resolve, reject)=>{
            let onCloseTimer = null;
            // DEFINE ALL THE CALLBACKS =====
            function authEventSeen() {
                // Auth event was detected. Resolve this promise and close the extra
                // window if it's still open.
                resolve();
                const closeBrowserTab = cordova.plugins.browsertab?.close;
                if (typeof closeBrowserTab === 'function') closeBrowserTab();
                // Close inappbrowser embedded webview in iOS7 and 8 case if still
                // open.
                if (typeof iabRef?.close === 'function') iabRef.close();
            }
            function resumed() {
                if (onCloseTimer) // This code already ran; do not rerun.
                return;
                onCloseTimer = window.setTimeout(()=>{
                    // Wait two seconds after resume then reject.
                    reject((0, $9bd0e0ec09375082$export$890c4ad488842ce7)(auth, "redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ ));
                }, $fc85e1a138086dd4$var$REDIRECT_TIMEOUT_MS);
            }
            function visibilityChanged() {
                if (document?.visibilityState === 'visible') resumed();
            }
            // ATTACH ALL THE LISTENERS =====
            // Listen for the auth event
            eventListener.addPassiveListener(authEventSeen);
            // Listen for resume and visibility events
            document.addEventListener('resume', resumed, false);
            if ((0, $9bd0e0ec09375082$export$9fa96a7d116ea3ce)()) document.addEventListener('visibilitychange', visibilityChanged, false);
            // SETUP THE CLEANUP FUNCTION =====
            cleanup = ()=>{
                eventListener.removePassiveListener(authEventSeen);
                document.removeEventListener('resume', resumed, false);
                document.removeEventListener('visibilitychange', visibilityChanged, false);
                if (onCloseTimer) window.clearTimeout(onCloseTimer);
            };
        });
    } finally{
        cleanup();
    }
}
/**
 * Checks the configuration of the Cordova environment. This has no side effect
 * if the configuration is correct; otherwise it throws an error with the
 * missing plugin.
 */ function $fc85e1a138086dd4$var$_checkCordovaConfiguration(auth) {
    const win = $fc85e1a138086dd4$var$_cordovaWindow();
    // Check all dependencies installed.
    // https://github.com/nordnet/cordova-universal-links-plugin
    // Note that cordova-universal-links-plugin has been abandoned.
    // A fork with latest fixes is available at:
    // https://www.npmjs.com/package/cordova-universal-links-plugin-fix
    (0, $9bd0e0ec09375082$export$24baa2b76016ce0e)(typeof win?.universalLinks?.subscribe === 'function', auth, "invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ , {
        missingPlugin: 'cordova-universal-links-plugin-fix'
    });
    // https://www.npmjs.com/package/cordova-plugin-buildinfo
    (0, $9bd0e0ec09375082$export$24baa2b76016ce0e)(typeof win?.BuildInfo?.packageName !== 'undefined', auth, "invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ , {
        missingPlugin: 'cordova-plugin-buildInfo'
    });
    // https://github.com/google/cordova-plugin-browsertab
    (0, $9bd0e0ec09375082$export$24baa2b76016ce0e)(typeof win?.cordova?.plugins?.browsertab?.openUrl === 'function', auth, "invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ , {
        missingPlugin: 'cordova-plugin-browsertab'
    });
    (0, $9bd0e0ec09375082$export$24baa2b76016ce0e)(typeof win?.cordova?.plugins?.browsertab?.isAvailable === 'function', auth, "invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ , {
        missingPlugin: 'cordova-plugin-browsertab'
    });
    // https://cordova.apache.org/docs/en/latest/reference/cordova-plugin-inappbrowser/
    (0, $9bd0e0ec09375082$export$24baa2b76016ce0e)(typeof win?.cordova?.InAppBrowser?.open === 'function', auth, "invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ , {
        missingPlugin: 'cordova-plugin-inappbrowser'
    });
}
/**
 * Computes the SHA-256 of a session ID. The SubtleCrypto interface is only
 * available in "secure" contexts, which covers Cordova (which is served on a file
 * protocol).
 */ async function $fc85e1a138086dd4$var$computeSha256(sessionId) {
    const bytes = $fc85e1a138086dd4$var$stringToArrayBuffer(sessionId);
    // TODO: For IE11 crypto has a different name and this operation comes back
    //       as an object, not a promise. This is the old proposed standard that
    //       is used by IE11:
    // https://www.w3.org/TR/2013/WD-WebCryptoAPI-20130108/#cryptooperation-interface
    const buf = await crypto.subtle.digest('SHA-256', bytes);
    const arr = Array.from(new Uint8Array(buf));
    return arr.map((num)=>num.toString(16).padStart(2, '0')).join('');
}
function $fc85e1a138086dd4$var$stringToArrayBuffer(str) {
    // This function is only meant to deal with an ASCII charset and makes
    // certain simplifying assumptions.
    (0, $9bd0e0ec09375082$export$d66dc83d8cfc8dd)(/[0-9a-zA-Z]+/.test(str), 'Can only convert alpha-numeric strings');
    if (typeof TextEncoder !== 'undefined') return new TextEncoder().encode(str);
    const buff = new ArrayBuffer(str.length);
    const view = new Uint8Array(buff);
    for(let i = 0; i < str.length; i++)view[i] = str.charCodeAt(i);
    return view;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fc85e1a138086dd4$var$SESSION_ID_LENGTH = 20;
/** Custom AuthEventManager that adds passive listeners to events */ class $fc85e1a138086dd4$var$CordovaAuthEventManager extends (0, $9bd0e0ec09375082$export$158acd800e1ef08b) {
    constructor(){
        super(...arguments);
        this.passiveListeners = new Set();
        this.initPromise = new Promise((resolve)=>{
            this.resolveInitialized = resolve;
        });
    }
    addPassiveListener(cb) {
        this.passiveListeners.add(cb);
    }
    removePassiveListener(cb) {
        this.passiveListeners.delete(cb);
    }
    // In a Cordova environment, this manager can live through multiple redirect
    // operations
    resetRedirect() {
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
    }
    /** Override the onEvent method */ onEvent(event) {
        this.resolveInitialized();
        this.passiveListeners.forEach((cb)=>cb(event));
        return super.onEvent(event);
    }
    async initialized() {
        await this.initPromise;
    }
}
/**
 * Generates a (partial) {@link AuthEvent}.
 */ function $fc85e1a138086dd4$var$_generateNewEvent(auth, type, eventId = null) {
    return {
        type: type,
        eventId: eventId,
        urlResponse: null,
        sessionId: $fc85e1a138086dd4$var$generateSessionId(),
        postBody: null,
        tenantId: auth.tenantId,
        error: (0, $9bd0e0ec09375082$export$890c4ad488842ce7)(auth, "no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ )
    };
}
function $fc85e1a138086dd4$var$_savePartialEvent(auth, event) {
    return $fc85e1a138086dd4$var$storage()._set($fc85e1a138086dd4$var$persistenceKey(auth), event);
}
async function $fc85e1a138086dd4$var$_getAndRemoveEvent(auth) {
    const event = await $fc85e1a138086dd4$var$storage()._get($fc85e1a138086dd4$var$persistenceKey(auth));
    if (event) await $fc85e1a138086dd4$var$storage()._remove($fc85e1a138086dd4$var$persistenceKey(auth));
    return event;
}
function $fc85e1a138086dd4$var$_eventFromPartialAndUrl(partialEvent, url) {
    // Parse the deep link within the dynamic link URL.
    const callbackUrl = $fc85e1a138086dd4$var$_getDeepLinkFromCallback(url);
    // Confirm it is actually a callback URL.
    // Currently the universal link will be of this format:
    // https://<AUTH_DOMAIN>/__/auth/callback<OAUTH_RESPONSE>
    // This is a fake URL but is not intended to take the user anywhere
    // and just redirect to the app.
    if (callbackUrl.includes('/__/auth/callback')) {
        // Check if there is an error in the URL.
        // This mechanism is also used to pass errors back to the app:
        // https://<AUTH_DOMAIN>/__/auth/callback?firebaseError=<STRINGIFIED_ERROR>
        const params = $fc85e1a138086dd4$var$searchParamsOrEmpty(callbackUrl);
        // Get the error object corresponding to the stringified error if found.
        const errorObject = params['firebaseError'] ? $fc85e1a138086dd4$var$parseJsonOrNull(decodeURIComponent(params['firebaseError'])) : null;
        const code = errorObject?.['code']?.split('auth/')?.[1];
        const error = code ? (0, $9bd0e0ec09375082$export$890c4ad488842ce7)(code) : null;
        if (error) return {
            type: partialEvent.type,
            eventId: partialEvent.eventId,
            tenantId: partialEvent.tenantId,
            error: error,
            urlResponse: null,
            sessionId: null,
            postBody: null
        };
        else return {
            type: partialEvent.type,
            eventId: partialEvent.eventId,
            tenantId: partialEvent.tenantId,
            sessionId: partialEvent.sessionId,
            urlResponse: callbackUrl,
            postBody: null
        };
    }
    return null;
}
function $fc85e1a138086dd4$var$generateSessionId() {
    const chars = [];
    const allowedChars = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for(let i = 0; i < $fc85e1a138086dd4$var$SESSION_ID_LENGTH; i++){
        const idx = Math.floor(Math.random() * allowedChars.length);
        chars.push(allowedChars.charAt(idx));
    }
    return chars.join('');
}
function $fc85e1a138086dd4$var$storage() {
    return (0, $9bd0e0ec09375082$export$cf2f7c5792f80b46)((0, $9bd0e0ec09375082$export$8b22cf2602fb60ce));
}
function $fc85e1a138086dd4$var$persistenceKey(auth) {
    return (0, $9bd0e0ec09375082$export$53a70dd1ebbae346)("authEvent" /* KeyName.AUTH_EVENT */ , auth.config.apiKey, auth.name);
}
function $fc85e1a138086dd4$var$parseJsonOrNull(json) {
    try {
        return JSON.parse(json);
    } catch (e) {
        return null;
    }
}
// Exported for testing
function $fc85e1a138086dd4$var$_getDeepLinkFromCallback(url) {
    const params = $fc85e1a138086dd4$var$searchParamsOrEmpty(url);
    const link = params['link'] ? decodeURIComponent(params['link']) : undefined;
    // Double link case (automatic redirect)
    const doubleDeepLink = $fc85e1a138086dd4$var$searchParamsOrEmpty(link)['link'];
    // iOS custom scheme links.
    const iOSDeepLink = params['deep_link_id'] ? decodeURIComponent(params['deep_link_id']) : undefined;
    const iOSDoubleDeepLink = $fc85e1a138086dd4$var$searchParamsOrEmpty(iOSDeepLink)['link'];
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * Optimistically tries to get search params from a string, or else returns an
 * empty search params object.
 */ function $fc85e1a138086dd4$var$searchParamsOrEmpty(url) {
    if (!url?.includes('?')) return {};
    const [_, ...rest] = url.split('?');
    return (0, $3117f6f4eeb4c314$export$c1271ca4c8a70741)(rest.join('?'));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * How long to wait for the initial auth event before concluding no
 * redirect pending
 */ const $fc85e1a138086dd4$var$INITIAL_EVENT_TIMEOUT_MS = 500;
class $fc85e1a138086dd4$var$CordovaPopupRedirectResolver {
    constructor(){
        this._redirectPersistence = (0, $9bd0e0ec09375082$export$db3b6bfb95261072);
        this._shouldInitProactively = true; // This is lightweight for Cordova
        this.eventManagers = new Map();
        this.originValidationPromises = {};
        this._completeRedirectFn = (0, $9bd0e0ec09375082$export$a33b77bbdbb8366c);
        this._overrideRedirectResult = (0, $9bd0e0ec09375082$export$b9a6b53f9be3734);
    }
    async _initialize(auth) {
        const key = auth._key();
        let manager = this.eventManagers.get(key);
        if (!manager) {
            manager = new $fc85e1a138086dd4$var$CordovaAuthEventManager(auth);
            this.eventManagers.set(key, manager);
            this.attachCallbackListeners(auth, manager);
        }
        return manager;
    }
    _openPopup(auth) {
        (0, $9bd0e0ec09375082$export$28f7fcd39efa255)(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    }
    async _openRedirect(auth, provider, authType, eventId) {
        $fc85e1a138086dd4$var$_checkCordovaConfiguration(auth);
        const manager = await this._initialize(auth);
        await manager.initialized();
        // Reset the persisted redirect states. This does not matter on Web where
        // the redirect always blows away application state entirely. On Cordova,
        // the app maintains control flow through the redirect.
        manager.resetRedirect();
        (0, $9bd0e0ec09375082$export$a05254e7c3aeba6e)();
        await this._originValidation(auth);
        const event = $fc85e1a138086dd4$var$_generateNewEvent(auth, authType, eventId);
        await $fc85e1a138086dd4$var$_savePartialEvent(auth, event);
        const url = await $fc85e1a138086dd4$var$_generateHandlerUrl(auth, event, provider);
        const iabRef = await $fc85e1a138086dd4$var$_performRedirect(url);
        return $fc85e1a138086dd4$var$_waitForAppResume(auth, manager, iabRef);
    }
    _isIframeWebStorageSupported(_auth, _cb) {
        throw new Error('Method not implemented.');
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $fc85e1a138086dd4$var$_validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    attachCallbackListeners(auth, manager) {
        // Get the global plugins
        const { universalLinks: universalLinks, handleOpenURL: handleOpenURL, BuildInfo: BuildInfo } = $fc85e1a138086dd4$var$_cordovaWindow();
        const noEventTimeout = setTimeout(async ()=>{
            // We didn't see that initial event. Clear any pending object and
            // dispatch no event
            await $fc85e1a138086dd4$var$_getAndRemoveEvent(auth);
            manager.onEvent($fc85e1a138086dd4$var$generateNoEvent());
        }, $fc85e1a138086dd4$var$INITIAL_EVENT_TIMEOUT_MS);
        const universalLinksCb = async (eventData)=>{
            // We have an event so we can clear the no event timeout
            clearTimeout(noEventTimeout);
            const partialEvent = await $fc85e1a138086dd4$var$_getAndRemoveEvent(auth);
            let finalEvent = null;
            if (partialEvent && eventData?.['url']) finalEvent = $fc85e1a138086dd4$var$_eventFromPartialAndUrl(partialEvent, eventData['url']);
            // If finalEvent is never filled, trigger with no event
            manager.onEvent(finalEvent || $fc85e1a138086dd4$var$generateNoEvent());
        };
        // Universal links subscriber doesn't exist for iOS, so we need to check
        if (typeof universalLinks !== 'undefined' && typeof universalLinks.subscribe === 'function') universalLinks.subscribe(null, universalLinksCb);
        // iOS 7 or 8 custom URL schemes.
        // This is also the current default behavior for iOS 9+.
        // For this to work, cordova-plugin-customurlscheme needs to be installed.
        // https://github.com/EddyVerbruggen/Custom-URL-scheme
        // Do not overwrite the existing developer's URL handler.
        const existingHandleOpenURL = handleOpenURL;
        const packagePrefix = `${BuildInfo.packageName.toLowerCase()}://`;
        $fc85e1a138086dd4$var$_cordovaWindow().handleOpenURL = async (url)=>{
            if (url.toLowerCase().startsWith(packagePrefix)) // We want this intentionally to float
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            universalLinksCb({
                url: url
            });
            // Call the developer's handler if it is present.
            if (typeof existingHandleOpenURL === 'function') try {
                existingHandleOpenURL(url);
            } catch (e) {
                // This is a developer error. Don't stop the flow of the SDK.
                console.error(e);
            }
        };
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for Cordova
 * based applications.
 *
 * @public
 */ const $fc85e1a138086dd4$export$2528817c27f24e17 = $fc85e1a138086dd4$var$CordovaPopupRedirectResolver;
function $fc85e1a138086dd4$var$generateNoEvent() {
    return {
        type: "unknown" /* AuthEventType.UNKNOWN */ ,
        eventId: null,
        sessionId: null,
        urlResponse: null,
        postBody: null,
        tenantId: null,
        error: (0, $9bd0e0ec09375082$export$890c4ad488842ce7)("no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ )
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // This function should only be called by frameworks (e.g. FirebaseUI-web) to log their usage.
// It is not intended for direct use by developer apps. NO jsdoc here to intentionally leave it out
// of autogenerated documentation pages to reduce accidental misuse.
function $fc85e1a138086dd4$export$f469bed1b0fbb94f(auth, framework) {
    (0, $9bd0e0ec09375082$export$23ebac1979863676)(auth)._logFramework(framework);
}




var $20cfeacc59c741d8$var$name = "@firebase/auth-compat";
var $20cfeacc59c741d8$var$version = "0.6.3";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $20cfeacc59c741d8$var$CORDOVA_ONDEVICEREADY_TIMEOUT_MS = 1000;
function $20cfeacc59c741d8$var$_getCurrentScheme() {
    return self?.location?.protocol || null;
}
/**
 * @return {boolean} Whether the current environment is http or https.
 */ function $20cfeacc59c741d8$var$_isHttpOrHttps() {
    return $20cfeacc59c741d8$var$_getCurrentScheme() === 'http:' || $20cfeacc59c741d8$var$_getCurrentScheme() === 'https:';
}
/**
 * @param {?string=} ua The user agent.
 * @return {boolean} Whether the app is rendered in a mobile iOS or Android
 *     Cordova environment.
 */ function $20cfeacc59c741d8$var$_isAndroidOrIosCordovaScheme(ua = (0, $3117f6f4eeb4c314$export$c36915b22ce77c19)()) {
    return !!(($20cfeacc59c741d8$var$_getCurrentScheme() === 'file:' || $20cfeacc59c741d8$var$_getCurrentScheme() === 'ionic:' || $20cfeacc59c741d8$var$_getCurrentScheme() === 'capacitor:') && ua.toLowerCase().match(/iphone|ipad|ipod|android/));
}
/**
 * @return {boolean} Whether the environment is a native environment, where
 *     CORS checks do not apply.
 */ function $20cfeacc59c741d8$var$_isNativeEnvironment() {
    return (0, $3117f6f4eeb4c314$export$f7a1e23e542d38e3)() || (0, $3117f6f4eeb4c314$export$8ee0fc9ee280b4ee)();
}
/**
 * Checks whether the user agent is IE11.
 * @return {boolean} True if it is IE11.
 */ function $20cfeacc59c741d8$var$_isIe11() {
    return (0, $3117f6f4eeb4c314$export$7e7b1a9668aaed8)() && document?.documentMode === 11;
}
/**
 * Checks whether the user agent is Edge.
 * @param {string} userAgent The browser user agent string.
 * @return {boolean} True if it is Edge.
 */ function $20cfeacc59c741d8$var$_isEdge(ua = (0, $3117f6f4eeb4c314$export$c36915b22ce77c19)()) {
    return /Edge\/\d+/.test(ua);
}
/**
 * @param {?string=} opt_userAgent The navigator user agent.
 * @return {boolean} Whether local storage is not synchronized between an iframe
 *     and a popup of the same domain.
 */ function $20cfeacc59c741d8$var$_isLocalStorageNotSynchronized(ua = (0, $3117f6f4eeb4c314$export$c36915b22ce77c19)()) {
    return $20cfeacc59c741d8$var$_isIe11() || $20cfeacc59c741d8$var$_isEdge(ua);
}
/** @return {boolean} Whether web storage is supported. */ function $20cfeacc59c741d8$var$_isWebStorageSupported() {
    try {
        const storage = self.localStorage;
        const key = $9bd0e0ec09375082$export$c03999cb2f36933f();
        if (storage) {
            // setItem will throw an exception if we cannot access WebStorage (e.g.,
            // Safari in private mode).
            storage['setItem'](key, '1');
            storage['removeItem'](key);
            // For browsers where iframe web storage does not synchronize with a popup
            // of the same domain, indexedDB is used for persistent storage. These
            // browsers include IE11 and Edge.
            // Make sure it is supported (IE11 and Edge private mode does not support
            // that).
            if ($20cfeacc59c741d8$var$_isLocalStorageNotSynchronized()) // In such browsers, if indexedDB is not supported, an iframe cannot be
            // notified of the popup sign in result.
            return (0, $3117f6f4eeb4c314$export$3865db50535c2055)();
            return true;
        }
    } catch (e) {
        // localStorage is not available from a worker. Test availability of
        // indexedDB.
        return $20cfeacc59c741d8$var$_isWorker() && (0, $3117f6f4eeb4c314$export$3865db50535c2055)();
    }
    return false;
}
/**
 * @param {?Object=} global The optional global scope.
 * @return {boolean} Whether current environment is a worker.
 */ function $20cfeacc59c741d8$var$_isWorker() {
    // WorkerGlobalScope only defined in worker environment.
    return typeof $parcel$global !== 'undefined' && 'WorkerGlobalScope' in $parcel$global && 'importScripts' in $parcel$global;
}
function $20cfeacc59c741d8$var$_isPopupRedirectSupported() {
    return ($20cfeacc59c741d8$var$_isHttpOrHttps() || (0, $3117f6f4eeb4c314$export$caa8774a9107a58e)() || $20cfeacc59c741d8$var$_isAndroidOrIosCordovaScheme()) && // React Native with remote debugging reports its location.protocol as
    // http.
    !$20cfeacc59c741d8$var$_isNativeEnvironment() && // Local storage has to be supported for browser popup and redirect
    // operations to work.
    $20cfeacc59c741d8$var$_isWebStorageSupported() && // DOM, popups and redirects are not supported within a worker.
    !$20cfeacc59c741d8$var$_isWorker();
}
/** Quick check that indicates the platform *may* be Cordova */ function $20cfeacc59c741d8$var$_isLikelyCordova() {
    return $20cfeacc59c741d8$var$_isAndroidOrIosCordovaScheme() && typeof document !== 'undefined';
}
async function $20cfeacc59c741d8$var$_isCordova() {
    if (!$20cfeacc59c741d8$var$_isLikelyCordova()) return false;
    return new Promise((resolve)=>{
        const timeoutId = setTimeout(()=>{
            // We've waited long enough; the telltale Cordova event didn't happen
            resolve(false);
        }, $20cfeacc59c741d8$var$CORDOVA_ONDEVICEREADY_TIMEOUT_MS);
        document.addEventListener('deviceready', ()=>{
            clearTimeout(timeoutId);
            resolve(true);
        });
    });
}
function $20cfeacc59c741d8$var$_getSelfWindow() {
    return typeof window !== 'undefined' ? window : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $20cfeacc59c741d8$var$Persistence = {
    LOCAL: 'local',
    NONE: 'none',
    SESSION: 'session'
};
const $20cfeacc59c741d8$var$_assert$3 = $9bd0e0ec09375082$export$24baa2b76016ce0e;
const $20cfeacc59c741d8$var$PERSISTENCE_KEY = 'persistence';
/**
 * Validates that an argument is a valid persistence value. If an invalid type
 * is specified, an error is thrown synchronously.
 */ function $20cfeacc59c741d8$var$_validatePersistenceArgument(auth, persistence) {
    $20cfeacc59c741d8$var$_assert$3(Object.values($20cfeacc59c741d8$var$Persistence).includes(persistence), auth, "invalid-persistence-type" /* exp.AuthErrorCode.INVALID_PERSISTENCE */ );
    // Validate if the specified type is supported in the current environment.
    if ((0, $3117f6f4eeb4c314$export$f7a1e23e542d38e3)()) {
        // This is only supported in a browser.
        $20cfeacc59c741d8$var$_assert$3(persistence !== $20cfeacc59c741d8$var$Persistence.SESSION, auth, "unsupported-persistence-type" /* exp.AuthErrorCode.UNSUPPORTED_PERSISTENCE */ );
        return;
    }
    if ((0, $3117f6f4eeb4c314$export$8ee0fc9ee280b4ee)()) {
        // Only none is supported in Node.js.
        $20cfeacc59c741d8$var$_assert$3(persistence === $20cfeacc59c741d8$var$Persistence.NONE, auth, "unsupported-persistence-type" /* exp.AuthErrorCode.UNSUPPORTED_PERSISTENCE */ );
        return;
    }
    if ($20cfeacc59c741d8$var$_isWorker()) {
        // In a worker environment, either LOCAL or NONE are supported.
        // If indexedDB not supported and LOCAL provided, throw an error
        $20cfeacc59c741d8$var$_assert$3(persistence === $20cfeacc59c741d8$var$Persistence.NONE || persistence === $20cfeacc59c741d8$var$Persistence.LOCAL && (0, $3117f6f4eeb4c314$export$3865db50535c2055)(), auth, "unsupported-persistence-type" /* exp.AuthErrorCode.UNSUPPORTED_PERSISTENCE */ );
        return;
    }
    // This is restricted by what the browser supports.
    $20cfeacc59c741d8$var$_assert$3(persistence === $20cfeacc59c741d8$var$Persistence.NONE || $20cfeacc59c741d8$var$_isWebStorageSupported(), auth, "unsupported-persistence-type" /* exp.AuthErrorCode.UNSUPPORTED_PERSISTENCE */ );
}
async function $20cfeacc59c741d8$var$_savePersistenceForRedirect(auth) {
    await auth._initializationPromise;
    const session = $20cfeacc59c741d8$var$getSessionStorageIfAvailable();
    const key = $9bd0e0ec09375082$export$53a70dd1ebbae346($20cfeacc59c741d8$var$PERSISTENCE_KEY, auth.config.apiKey, auth.name);
    if (session) session.setItem(key, auth._getPersistenceType());
}
function $20cfeacc59c741d8$var$_getPersistencesFromRedirect(apiKey, appName) {
    const session = $20cfeacc59c741d8$var$getSessionStorageIfAvailable();
    if (!session) return [];
    const key = $9bd0e0ec09375082$export$53a70dd1ebbae346($20cfeacc59c741d8$var$PERSISTENCE_KEY, apiKey, appName);
    const persistence = session.getItem(key);
    switch(persistence){
        case $20cfeacc59c741d8$var$Persistence.NONE:
            return [
                $9bd0e0ec09375082$export$e7c866399fa523f5
            ];
        case $20cfeacc59c741d8$var$Persistence.LOCAL:
            return [
                $9bd0e0ec09375082$export$23f2a1d2818174ef,
                $9bd0e0ec09375082$export$db3b6bfb95261072
            ];
        case $20cfeacc59c741d8$var$Persistence.SESSION:
            return [
                $9bd0e0ec09375082$export$db3b6bfb95261072
            ];
        default:
            return [];
    }
}
/** Returns session storage, or null if the property access errors */ function $20cfeacc59c741d8$var$getSessionStorageIfAvailable() {
    try {
        return $20cfeacc59c741d8$var$_getSelfWindow()?.sessionStorage || null;
    } catch (e) {
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $20cfeacc59c741d8$var$_assert$2 = $9bd0e0ec09375082$export$24baa2b76016ce0e;
/** Platform-agnostic popup-redirect resolver */ class $20cfeacc59c741d8$var$CompatPopupRedirectResolver {
    constructor(){
        // Create both resolvers for dynamic resolution later
        this.browserResolver = $9bd0e0ec09375082$export$cf2f7c5792f80b46($9bd0e0ec09375082$export$953cecd6e717a553);
        this.cordovaResolver = $9bd0e0ec09375082$export$cf2f7c5792f80b46($fc85e1a138086dd4$export$2528817c27f24e17);
        // The actual resolver in use: either browserResolver or cordovaResolver.
        this.underlyingResolver = null;
        this._redirectPersistence = $9bd0e0ec09375082$export$db3b6bfb95261072;
        this._completeRedirectFn = $9bd0e0ec09375082$export$a33b77bbdbb8366c;
        this._overrideRedirectResult = $9bd0e0ec09375082$export$b9a6b53f9be3734;
    }
    async _initialize(auth) {
        await this.selectUnderlyingResolver();
        return this.assertedUnderlyingResolver._initialize(auth);
    }
    async _openPopup(auth, provider, authType, eventId) {
        await this.selectUnderlyingResolver();
        return this.assertedUnderlyingResolver._openPopup(auth, provider, authType, eventId);
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this.selectUnderlyingResolver();
        return this.assertedUnderlyingResolver._openRedirect(auth, provider, authType, eventId);
    }
    _isIframeWebStorageSupported(auth, cb) {
        this.assertedUnderlyingResolver._isIframeWebStorageSupported(auth, cb);
    }
    _originValidation(auth) {
        return this.assertedUnderlyingResolver._originValidation(auth);
    }
    get _shouldInitProactively() {
        return $20cfeacc59c741d8$var$_isLikelyCordova() || this.browserResolver._shouldInitProactively;
    }
    get assertedUnderlyingResolver() {
        $20cfeacc59c741d8$var$_assert$2(this.underlyingResolver, "internal-error" /* exp.AuthErrorCode.INTERNAL_ERROR */ );
        return this.underlyingResolver;
    }
    async selectUnderlyingResolver() {
        if (this.underlyingResolver) return;
        // We haven't yet determined whether or not we're in Cordova; go ahead
        // and determine that state now.
        const isCordova = await $20cfeacc59c741d8$var$_isCordova();
        this.underlyingResolver = isCordova ? this.cordovaResolver : this.browserResolver;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $20cfeacc59c741d8$var$unwrap(object) {
    return object.unwrap();
}
function $20cfeacc59c741d8$var$wrapped(object) {
    return object.wrapped();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $20cfeacc59c741d8$var$credentialFromResponse(userCredential) {
    return $20cfeacc59c741d8$var$credentialFromObject(userCredential);
}
function $20cfeacc59c741d8$var$attachExtraErrorFields(auth, e) {
    // The response contains all fields from the server which may or may not
    // actually match the underlying type
    const response = e.customData?._tokenResponse;
    if (e?.code === 'auth/multi-factor-auth-required') {
        const mfaErr = e;
        mfaErr.resolver = new $20cfeacc59c741d8$var$MultiFactorResolver(auth, $9bd0e0ec09375082$export$493d36ec626b6698(auth, e));
    } else if (response) {
        const credential = $20cfeacc59c741d8$var$credentialFromObject(e);
        const credErr = e;
        if (credential) {
            credErr.credential = credential;
            credErr.tenantId = response.tenantId || undefined;
            credErr.email = response.email || undefined;
            credErr.phoneNumber = response.phoneNumber || undefined;
        }
    }
}
function $20cfeacc59c741d8$var$credentialFromObject(object) {
    const { _tokenResponse: _tokenResponse } = object instanceof (0, $3117f6f4eeb4c314$export$dd24e9cd51226c56) ? object.customData : object;
    if (!_tokenResponse) return null;
    // Handle phone Auth credential responses, as they have a different format
    // from other backend responses (i.e. no providerId). This is also only the
    // case for user credentials (does not work for errors).
    if (!(object instanceof (0, $3117f6f4eeb4c314$export$dd24e9cd51226c56))) {
        if ('temporaryProof' in _tokenResponse && 'phoneNumber' in _tokenResponse) return $9bd0e0ec09375082$export$56c0d5a1e737357d.credentialFromResult(object);
    }
    const providerId = _tokenResponse.providerId;
    // Email and password is not supported as there is no situation where the
    // server would return the password to the client.
    if (!providerId || providerId === $9bd0e0ec09375082$export$9e5f44173e64f162.PASSWORD) return null;
    let provider;
    switch(providerId){
        case $9bd0e0ec09375082$export$9e5f44173e64f162.GOOGLE:
            provider = $9bd0e0ec09375082$export$8743009a87fcb00f;
            break;
        case $9bd0e0ec09375082$export$9e5f44173e64f162.FACEBOOK:
            provider = $9bd0e0ec09375082$export$78acf4525d8a74c4;
            break;
        case $9bd0e0ec09375082$export$9e5f44173e64f162.GITHUB:
            provider = $9bd0e0ec09375082$export$dc98b0b04f4c7758;
            break;
        case $9bd0e0ec09375082$export$9e5f44173e64f162.TWITTER:
            provider = $9bd0e0ec09375082$export$34aec0b863436764;
            break;
        default:
            const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret, pendingToken: pendingToken, nonce: nonce } = _tokenResponse;
            if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
            // TODO(avolkovi): uncomment this and get it working with SAML & OIDC
            if (pendingToken) {
                if (providerId.startsWith('saml.')) return $9bd0e0ec09375082$export$738ab4df8bf92ae9._create(providerId, pendingToken);
                else // OIDC and non-default providers excluding Twitter.
                return $9bd0e0ec09375082$export$3722cfe417b6ed86._fromParams({
                    providerId: providerId,
                    signInMethod: providerId,
                    pendingToken: pendingToken,
                    idToken: oauthIdToken,
                    accessToken: oauthAccessToken
                });
            }
            return new $9bd0e0ec09375082$export$71511d61b312f219(providerId).credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                rawNonce: nonce
            });
    }
    return object instanceof (0, $3117f6f4eeb4c314$export$dd24e9cd51226c56) ? provider.credentialFromError(object) : provider.credentialFromResult(object);
}
function $20cfeacc59c741d8$var$convertCredential(auth, credentialPromise) {
    return credentialPromise.catch((e)=>{
        if (e instanceof (0, $3117f6f4eeb4c314$export$dd24e9cd51226c56)) $20cfeacc59c741d8$var$attachExtraErrorFields(auth, e);
        throw e;
    }).then((credential)=>{
        const operationType = credential.operationType;
        const user = credential.user;
        return {
            operationType: operationType,
            credential: $20cfeacc59c741d8$var$credentialFromResponse(credential),
            additionalUserInfo: $9bd0e0ec09375082$export$d24c54395ce0c509(credential),
            user: $20cfeacc59c741d8$var$User.getOrCreate(user)
        };
    });
}
async function $20cfeacc59c741d8$var$convertConfirmationResult(auth, confirmationResultPromise) {
    const confirmationResultExp = await confirmationResultPromise;
    return {
        verificationId: confirmationResultExp.verificationId,
        confirm: (verificationCode)=>$20cfeacc59c741d8$var$convertCredential(auth, confirmationResultExp.confirm(verificationCode))
    };
}
class $20cfeacc59c741d8$var$MultiFactorResolver {
    constructor(auth, resolver){
        this.resolver = resolver;
        this.auth = $20cfeacc59c741d8$var$wrapped(auth);
    }
    get session() {
        return this.resolver.session;
    }
    get hints() {
        return this.resolver.hints;
    }
    resolveSignIn(assertion) {
        return $20cfeacc59c741d8$var$convertCredential($20cfeacc59c741d8$var$unwrap(this.auth), this.resolver.resolveSignIn(assertion));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $20cfeacc59c741d8$var$User {
    constructor(_delegate){
        this._delegate = _delegate;
        this.multiFactor = $9bd0e0ec09375082$export$1fbe638ecf81657e(_delegate);
    }
    static getOrCreate(user) {
        if (!$20cfeacc59c741d8$var$User.USER_MAP.has(user)) $20cfeacc59c741d8$var$User.USER_MAP.set(user, new $20cfeacc59c741d8$var$User(user));
        return $20cfeacc59c741d8$var$User.USER_MAP.get(user);
    }
    delete() {
        return this._delegate.delete();
    }
    reload() {
        return this._delegate.reload();
    }
    toJSON() {
        return this._delegate.toJSON();
    }
    getIdTokenResult(forceRefresh) {
        return this._delegate.getIdTokenResult(forceRefresh);
    }
    getIdToken(forceRefresh) {
        return this._delegate.getIdToken(forceRefresh);
    }
    linkAndRetrieveDataWithCredential(credential) {
        return this.linkWithCredential(credential);
    }
    async linkWithCredential(credential) {
        return $20cfeacc59c741d8$var$convertCredential(this.auth, $9bd0e0ec09375082$export$6559d589eb85fbb6(this._delegate, credential));
    }
    async linkWithPhoneNumber(phoneNumber, applicationVerifier) {
        return $20cfeacc59c741d8$var$convertConfirmationResult(this.auth, $9bd0e0ec09375082$export$882b5998b3b9117c(this._delegate, phoneNumber, applicationVerifier));
    }
    async linkWithPopup(provider) {
        return $20cfeacc59c741d8$var$convertCredential(this.auth, $9bd0e0ec09375082$export$f1e1789686576879(this._delegate, provider, $20cfeacc59c741d8$var$CompatPopupRedirectResolver));
    }
    async linkWithRedirect(provider) {
        await $20cfeacc59c741d8$var$_savePersistenceForRedirect($9bd0e0ec09375082$export$23ebac1979863676(this.auth));
        return $9bd0e0ec09375082$export$dda1d9f60106f0e9(this._delegate, provider, $20cfeacc59c741d8$var$CompatPopupRedirectResolver);
    }
    reauthenticateAndRetrieveDataWithCredential(credential) {
        return this.reauthenticateWithCredential(credential);
    }
    async reauthenticateWithCredential(credential) {
        return $20cfeacc59c741d8$var$convertCredential(this.auth, $9bd0e0ec09375082$export$efca4cbe5dd06740(this._delegate, credential));
    }
    reauthenticateWithPhoneNumber(phoneNumber, applicationVerifier) {
        return $20cfeacc59c741d8$var$convertConfirmationResult(this.auth, $9bd0e0ec09375082$export$43caf9889c228507(this._delegate, phoneNumber, applicationVerifier));
    }
    reauthenticateWithPopup(provider) {
        return $20cfeacc59c741d8$var$convertCredential(this.auth, $9bd0e0ec09375082$export$2d1720544b23b823(this._delegate, provider, $20cfeacc59c741d8$var$CompatPopupRedirectResolver));
    }
    async reauthenticateWithRedirect(provider) {
        await $20cfeacc59c741d8$var$_savePersistenceForRedirect($9bd0e0ec09375082$export$23ebac1979863676(this.auth));
        return $9bd0e0ec09375082$export$35e795649ee09318(this._delegate, provider, $20cfeacc59c741d8$var$CompatPopupRedirectResolver);
    }
    sendEmailVerification(actionCodeSettings) {
        return $9bd0e0ec09375082$export$995eb9fca571757(this._delegate, actionCodeSettings);
    }
    async unlink(providerId) {
        await $9bd0e0ec09375082$export$8a5498727ef6be21(this._delegate, providerId);
        return this;
    }
    updateEmail(newEmail) {
        return $9bd0e0ec09375082$export$1a82df3d29112e01(this._delegate, newEmail);
    }
    updatePassword(newPassword) {
        return $9bd0e0ec09375082$export$306ddfe3a8403e2(this._delegate, newPassword);
    }
    updatePhoneNumber(phoneCredential) {
        return $9bd0e0ec09375082$export$3b14a55fb2447963(this._delegate, phoneCredential);
    }
    updateProfile(profile) {
        return $9bd0e0ec09375082$export$ab83b03e4111b1d0(this._delegate, profile);
    }
    verifyBeforeUpdateEmail(newEmail, actionCodeSettings) {
        return $9bd0e0ec09375082$export$f38c853ae54ed474(this._delegate, newEmail, actionCodeSettings);
    }
    get emailVerified() {
        return this._delegate.emailVerified;
    }
    get isAnonymous() {
        return this._delegate.isAnonymous;
    }
    get metadata() {
        return this._delegate.metadata;
    }
    get phoneNumber() {
        return this._delegate.phoneNumber;
    }
    get providerData() {
        return this._delegate.providerData;
    }
    get refreshToken() {
        return this._delegate.refreshToken;
    }
    get tenantId() {
        return this._delegate.tenantId;
    }
    get displayName() {
        return this._delegate.displayName;
    }
    get email() {
        return this._delegate.email;
    }
    get photoURL() {
        return this._delegate.photoURL;
    }
    get providerId() {
        return this._delegate.providerId;
    }
    get uid() {
        return this._delegate.uid;
    }
    get auth() {
        return this._delegate.auth;
    }
}
// Maintain a map so that there's always a 1:1 mapping between new User and
// legacy compat users
$20cfeacc59c741d8$var$User.USER_MAP = new WeakMap();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $20cfeacc59c741d8$var$_assert$1 = $9bd0e0ec09375082$export$24baa2b76016ce0e;
class $20cfeacc59c741d8$var$Auth {
    constructor(app, provider){
        this.app = app;
        if (provider.isInitialized()) {
            this._delegate = provider.getImmediate();
            this.linkUnderlyingAuth();
            return;
        }
        const { apiKey: apiKey } = app.options;
        // TODO: platform needs to be determined using heuristics
        $20cfeacc59c741d8$var$_assert$1(apiKey, "invalid-api-key" /* exp.AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        // TODO: platform needs to be determined using heuristics
        $20cfeacc59c741d8$var$_assert$1(apiKey, "invalid-api-key" /* exp.AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        // Only use a popup/redirect resolver in browser environments
        const resolver = typeof window !== 'undefined' ? $20cfeacc59c741d8$var$CompatPopupRedirectResolver : undefined;
        this._delegate = provider.initialize({
            options: {
                persistence: $20cfeacc59c741d8$var$buildPersistenceHierarchy(apiKey, app.name),
                popupRedirectResolver: resolver
            }
        });
        this._delegate._updateErrorMap($9bd0e0ec09375082$export$7f8ddf7c7c20b3cd);
        this.linkUnderlyingAuth();
    }
    get emulatorConfig() {
        return this._delegate.emulatorConfig;
    }
    get currentUser() {
        if (!this._delegate.currentUser) return null;
        return $20cfeacc59c741d8$var$User.getOrCreate(this._delegate.currentUser);
    }
    get languageCode() {
        return this._delegate.languageCode;
    }
    set languageCode(languageCode) {
        this._delegate.languageCode = languageCode;
    }
    get settings() {
        return this._delegate.settings;
    }
    get tenantId() {
        return this._delegate.tenantId;
    }
    set tenantId(tid) {
        this._delegate.tenantId = tid;
    }
    useDeviceLanguage() {
        this._delegate.useDeviceLanguage();
    }
    signOut() {
        return this._delegate.signOut();
    }
    useEmulator(url, options) {
        $9bd0e0ec09375082$export$61196ced6d74a310(this._delegate, url, options);
    }
    applyActionCode(code) {
        return $9bd0e0ec09375082$export$c3950d9923825c02(this._delegate, code);
    }
    checkActionCode(code) {
        return $9bd0e0ec09375082$export$a9c996f45e5784d0(this._delegate, code);
    }
    confirmPasswordReset(code, newPassword) {
        return $9bd0e0ec09375082$export$a93c5207d687da10(this._delegate, code, newPassword);
    }
    async createUserWithEmailAndPassword(email, password) {
        return $20cfeacc59c741d8$var$convertCredential(this._delegate, $9bd0e0ec09375082$export$555508cbc6add439(this._delegate, email, password));
    }
    fetchProvidersForEmail(email) {
        return this.fetchSignInMethodsForEmail(email);
    }
    fetchSignInMethodsForEmail(email) {
        return $9bd0e0ec09375082$export$ee7c8ad385a60b7b(this._delegate, email);
    }
    isSignInWithEmailLink(emailLink) {
        return $9bd0e0ec09375082$export$f787f51d84a910ad(this._delegate, emailLink);
    }
    async getRedirectResult() {
        $20cfeacc59c741d8$var$_assert$1($20cfeacc59c741d8$var$_isPopupRedirectSupported(), this._delegate, "operation-not-supported-in-this-environment" /* exp.AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        const credential = await $9bd0e0ec09375082$export$342063e11d6c3cad(this._delegate, $20cfeacc59c741d8$var$CompatPopupRedirectResolver);
        if (!credential) return {
            credential: null,
            user: null
        };
        return $20cfeacc59c741d8$var$convertCredential(this._delegate, Promise.resolve(credential));
    }
    // This function should only be called by frameworks (e.g. FirebaseUI-web) to log their usage.
    // It is not intended for direct use by developer apps. NO jsdoc here to intentionally leave it
    // out of autogenerated documentation pages to reduce accidental misuse.
    addFrameworkForLogging(framework) {
        $fc85e1a138086dd4$export$f469bed1b0fbb94f(this._delegate, framework);
    }
    onAuthStateChanged(nextOrObserver, errorFn, completed) {
        const { next: next, error: error, complete: complete } = $20cfeacc59c741d8$var$wrapObservers(nextOrObserver, errorFn, completed);
        return this._delegate.onAuthStateChanged(next, error, complete);
    }
    onIdTokenChanged(nextOrObserver, errorFn, completed) {
        const { next: next, error: error, complete: complete } = $20cfeacc59c741d8$var$wrapObservers(nextOrObserver, errorFn, completed);
        return this._delegate.onIdTokenChanged(next, error, complete);
    }
    sendSignInLinkToEmail(email, actionCodeSettings) {
        return $9bd0e0ec09375082$export$4c3d22f3d993c33f(this._delegate, email, actionCodeSettings);
    }
    sendPasswordResetEmail(email, actionCodeSettings) {
        return $9bd0e0ec09375082$export$2e2af4578d910ddf(this._delegate, email, actionCodeSettings || undefined);
    }
    async setPersistence(persistence) {
        $20cfeacc59c741d8$var$_validatePersistenceArgument(this._delegate, persistence);
        let converted;
        switch(persistence){
            case $20cfeacc59c741d8$var$Persistence.SESSION:
                converted = $9bd0e0ec09375082$export$db3b6bfb95261072;
                break;
            case $20cfeacc59c741d8$var$Persistence.LOCAL:
                // Not using isIndexedDBAvailable() since it only checks if indexedDB is defined.
                const isIndexedDBFullySupported = await $9bd0e0ec09375082$export$cf2f7c5792f80b46($9bd0e0ec09375082$export$23f2a1d2818174ef)._isAvailable();
                converted = isIndexedDBFullySupported ? $9bd0e0ec09375082$export$23f2a1d2818174ef : $9bd0e0ec09375082$export$8b22cf2602fb60ce;
                break;
            case $20cfeacc59c741d8$var$Persistence.NONE:
                converted = $9bd0e0ec09375082$export$e7c866399fa523f5;
                break;
            default:
                return $9bd0e0ec09375082$export$28f7fcd39efa255("argument-error" /* exp.AuthErrorCode.ARGUMENT_ERROR */ , {
                    appName: this._delegate.name
                });
        }
        return this._delegate.setPersistence(converted);
    }
    signInAndRetrieveDataWithCredential(credential) {
        return this.signInWithCredential(credential);
    }
    signInAnonymously() {
        return $20cfeacc59c741d8$var$convertCredential(this._delegate, $9bd0e0ec09375082$export$3c2fa207a37baaea(this._delegate));
    }
    signInWithCredential(credential) {
        return $20cfeacc59c741d8$var$convertCredential(this._delegate, $9bd0e0ec09375082$export$ce26c07117d59d6a(this._delegate, credential));
    }
    signInWithCustomToken(token) {
        return $20cfeacc59c741d8$var$convertCredential(this._delegate, $9bd0e0ec09375082$export$a8550f7dbe79f93a(this._delegate, token));
    }
    signInWithEmailAndPassword(email, password) {
        return $20cfeacc59c741d8$var$convertCredential(this._delegate, $9bd0e0ec09375082$export$2219238a014317b0(this._delegate, email, password));
    }
    signInWithEmailLink(email, emailLink) {
        return $20cfeacc59c741d8$var$convertCredential(this._delegate, $9bd0e0ec09375082$export$c9170ad7d4cd7e57(this._delegate, email, emailLink));
    }
    signInWithPhoneNumber(phoneNumber, applicationVerifier) {
        return $20cfeacc59c741d8$var$convertConfirmationResult(this._delegate, $9bd0e0ec09375082$export$2408f22a0fab9ae5(this._delegate, phoneNumber, applicationVerifier));
    }
    async signInWithPopup(provider) {
        $20cfeacc59c741d8$var$_assert$1($20cfeacc59c741d8$var$_isPopupRedirectSupported(), this._delegate, "operation-not-supported-in-this-environment" /* exp.AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        return $20cfeacc59c741d8$var$convertCredential(this._delegate, $9bd0e0ec09375082$export$4368d992c4eafac0(this._delegate, provider, $20cfeacc59c741d8$var$CompatPopupRedirectResolver));
    }
    async signInWithRedirect(provider) {
        $20cfeacc59c741d8$var$_assert$1($20cfeacc59c741d8$var$_isPopupRedirectSupported(), this._delegate, "operation-not-supported-in-this-environment" /* exp.AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        await $20cfeacc59c741d8$var$_savePersistenceForRedirect(this._delegate);
        return $9bd0e0ec09375082$export$39b482c5e57630a8(this._delegate, provider, $20cfeacc59c741d8$var$CompatPopupRedirectResolver);
    }
    updateCurrentUser(user) {
        // remove ts-ignore once overloads are defined for exp functions to accept compat objects
        // @ts-ignore
        return this._delegate.updateCurrentUser(user);
    }
    verifyPasswordResetCode(code) {
        return $9bd0e0ec09375082$export$7910e0436ed8d1de(this._delegate, code);
    }
    unwrap() {
        return this._delegate;
    }
    _delete() {
        return this._delegate._delete();
    }
    linkUnderlyingAuth() {
        this._delegate.wrapped = ()=>this;
    }
}
$20cfeacc59c741d8$var$Auth.Persistence = $20cfeacc59c741d8$var$Persistence;
function $20cfeacc59c741d8$var$wrapObservers(nextOrObserver, error, complete) {
    let next = nextOrObserver;
    if (typeof nextOrObserver !== 'function') ({ next: next, error: error, complete: complete } = nextOrObserver);
    // We know 'next' is now a function
    const oldNext = next;
    const newNext = (user)=>oldNext(user && $20cfeacc59c741d8$var$User.getOrCreate(user));
    return {
        next: newNext,
        error: error,
        complete: complete
    };
}
function $20cfeacc59c741d8$var$buildPersistenceHierarchy(apiKey, appName) {
    // Note this is slightly different behavior: in this case, the stored
    // persistence is checked *first* rather than last. This is because we want
    // to prefer stored persistence type in the hierarchy. This is an empty
    // array if window is not available or there is no pending redirect
    const persistences = $20cfeacc59c741d8$var$_getPersistencesFromRedirect(apiKey, appName);
    // If "self" is available, add indexedDB
    if (typeof self !== 'undefined' && !persistences.includes($9bd0e0ec09375082$export$23f2a1d2818174ef)) persistences.push($9bd0e0ec09375082$export$23f2a1d2818174ef);
    // If "window" is available, add HTML Storage persistences
    if (typeof window !== 'undefined') {
        for (const persistence of [
            $9bd0e0ec09375082$export$8b22cf2602fb60ce,
            $9bd0e0ec09375082$export$db3b6bfb95261072
        ])if (!persistences.includes(persistence)) persistences.push(persistence);
    }
    // Add in-memory as a final fallback
    if (!persistences.includes($9bd0e0ec09375082$export$e7c866399fa523f5)) persistences.push($9bd0e0ec09375082$export$e7c866399fa523f5);
    return persistences;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $20cfeacc59c741d8$var$PhoneAuthProvider {
    static credential(verificationId, verificationCode) {
        return $9bd0e0ec09375082$export$56c0d5a1e737357d.credential(verificationId, verificationCode);
    }
    constructor(){
        this.providerId = 'phone';
        // TODO: remove ts-ignore when moving types from auth-types to auth-compat
        // @ts-ignore
        this._delegate = new $9bd0e0ec09375082$export$56c0d5a1e737357d($20cfeacc59c741d8$var$unwrap((0, $42ddf94e6f3c0a26$export$2e2bcd8739ae039).auth()));
    }
    verifyPhoneNumber(phoneInfoOptions, applicationVerifier) {
        return this._delegate.verifyPhoneNumber(// The implementation matches but the types are subtly incompatible
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        phoneInfoOptions, applicationVerifier);
    }
    unwrap() {
        return this._delegate;
    }
}
$20cfeacc59c741d8$var$PhoneAuthProvider.PHONE_SIGN_IN_METHOD = $9bd0e0ec09375082$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD;
$20cfeacc59c741d8$var$PhoneAuthProvider.PROVIDER_ID = $9bd0e0ec09375082$export$56c0d5a1e737357d.PROVIDER_ID;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $20cfeacc59c741d8$var$_assert = $9bd0e0ec09375082$export$24baa2b76016ce0e;
class $20cfeacc59c741d8$var$RecaptchaVerifier {
    constructor(container, parameters, app = (0, $42ddf94e6f3c0a26$export$2e2bcd8739ae039).app()){
        // API key is required for web client RPC calls.
        $20cfeacc59c741d8$var$_assert(app.options?.apiKey, "invalid-api-key" /* exp.AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        this._delegate = new $9bd0e0ec09375082$export$db202ddc8be9136(// TODO: remove ts-ignore when moving types from auth-types to auth-compat
        // @ts-ignore
        app.auth(), container, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        parameters);
        this.type = this._delegate.type;
    }
    clear() {
        this._delegate.clear();
    }
    render() {
        return this._delegate.render();
    }
    verify() {
        return this._delegate.verify();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $20cfeacc59c741d8$var$AUTH_TYPE = 'auth-compat';
// Create auth components to register with firebase.
// Provides Auth public APIs.
function $20cfeacc59c741d8$var$registerAuthCompat(instance) {
    instance.INTERNAL.registerComponent(new (0, $ad76b76e741ec0c7$export$16fa2f45be04daa8)($20cfeacc59c741d8$var$AUTH_TYPE, (container)=>{
        // getImmediate for FirebaseApp will always succeed
        const app = container.getProvider('app-compat').getImmediate();
        const authProvider = container.getProvider('auth');
        return new $20cfeacc59c741d8$var$Auth(app, authProvider);
    }, "PUBLIC" /* ComponentType.PUBLIC */ ).setServiceProps({
        ActionCodeInfo: {
            Operation: {
                EMAIL_SIGNIN: $9bd0e0ec09375082$export$ebd11618f299a286.EMAIL_SIGNIN,
                PASSWORD_RESET: $9bd0e0ec09375082$export$ebd11618f299a286.PASSWORD_RESET,
                RECOVER_EMAIL: $9bd0e0ec09375082$export$ebd11618f299a286.RECOVER_EMAIL,
                REVERT_SECOND_FACTOR_ADDITION: $9bd0e0ec09375082$export$ebd11618f299a286.REVERT_SECOND_FACTOR_ADDITION,
                VERIFY_AND_CHANGE_EMAIL: $9bd0e0ec09375082$export$ebd11618f299a286.VERIFY_AND_CHANGE_EMAIL,
                VERIFY_EMAIL: $9bd0e0ec09375082$export$ebd11618f299a286.VERIFY_EMAIL
            }
        },
        EmailAuthProvider: $9bd0e0ec09375082$export$71cec2538cb2c617,
        FacebookAuthProvider: $9bd0e0ec09375082$export$78acf4525d8a74c4,
        GithubAuthProvider: $9bd0e0ec09375082$export$dc98b0b04f4c7758,
        GoogleAuthProvider: $9bd0e0ec09375082$export$8743009a87fcb00f,
        OAuthProvider: $9bd0e0ec09375082$export$71511d61b312f219,
        SAMLAuthProvider: $9bd0e0ec09375082$export$3d8c2f653ac9d0b9,
        PhoneAuthProvider: $20cfeacc59c741d8$var$PhoneAuthProvider,
        PhoneMultiFactorGenerator: $9bd0e0ec09375082$export$7ccc53e8f1e7dfc5,
        RecaptchaVerifier: $20cfeacc59c741d8$var$RecaptchaVerifier,
        TwitterAuthProvider: $9bd0e0ec09375082$export$34aec0b863436764,
        Auth: $20cfeacc59c741d8$var$Auth,
        AuthCredential: $9bd0e0ec09375082$export$3a1a48c8f6ef640e,
        Error: (0, $3117f6f4eeb4c314$export$dd24e9cd51226c56)
    }).setInstantiationMode("LAZY" /* InstantiationMode.LAZY */ ).setMultipleInstances(false));
    instance.registerVersion($20cfeacc59c741d8$var$name, $20cfeacc59c741d8$var$version);
}
$20cfeacc59c741d8$var$registerAuthCompat((0, $42ddf94e6f3c0a26$export$2e2bcd8739ae039));











var $lsQhA = parcelRequire("lsQhA");
const $9cf0852385f62d16$var$name = "@firebase/database";
const $9cf0852385f62d16$var$version = "1.1.1";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The semver (www.semver.org) version of the SDK. */ let $9cf0852385f62d16$var$SDK_VERSION = '';
/**
 * SDK_VERSION should be set before any database instance is created
 * @internal
 */ function $9cf0852385f62d16$export$c9fb972242fcb3c4(version) {
    $9cf0852385f62d16$var$SDK_VERSION = version;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Wraps a DOM Storage object and:
 * - automatically encode objects as JSON strings before storing them to allow us to store arbitrary types.
 * - prefixes names with "firebase:" to avoid collisions with app data.
 *
 * We automatically (see storage.js) create two such wrappers, one for sessionStorage,
 * and one for localStorage.
 *
 */ class $9cf0852385f62d16$var$DOMStorageWrapper {
    /**
     * @param domStorage_ - The underlying storage object (e.g. localStorage or sessionStorage)
     */ constructor(domStorage_){
        this.domStorage_ = domStorage_;
        // Use a prefix to avoid collisions with other stuff saved by the app.
        this.prefix_ = 'firebase:';
    }
    /**
     * @param key - The key to save the value under
     * @param value - The value being stored, or null to remove the key.
     */ set(key, value) {
        if (value == null) this.domStorage_.removeItem(this.prefixedName_(key));
        else this.domStorage_.setItem(this.prefixedName_(key), (0, $3117f6f4eeb4c314$export$fac44ee5b035f737)(value));
    }
    /**
     * @returns The value that was stored under this key, or null
     */ get(key) {
        const storedVal = this.domStorage_.getItem(this.prefixedName_(key));
        if (storedVal == null) return null;
        else return (0, $3117f6f4eeb4c314$export$c5a53ce6a17cf18d)(storedVal);
    }
    remove(key) {
        this.domStorage_.removeItem(this.prefixedName_(key));
    }
    prefixedName_(name) {
        return this.prefix_ + name;
    }
    toString() {
        return this.domStorage_.toString();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory storage implementation that matches the API of DOMStorageWrapper
 * (TODO: create interface for both to implement).
 */ class $9cf0852385f62d16$var$MemoryStorage {
    constructor(){
        this.cache_ = {};
        this.isInMemoryStorage = true;
    }
    set(key, value) {
        if (value == null) delete this.cache_[key];
        else this.cache_[key] = value;
    }
    get(key) {
        if ((0, $3117f6f4eeb4c314$export$2344b14b097df817)(this.cache_, key)) return this.cache_[key];
        return null;
    }
    remove(key) {
        delete this.cache_[key];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to create a DOMStorageWrapper or else fall back to MemoryStorage.
 * TODO: Once MemoryStorage and DOMStorageWrapper have a shared interface this method annotation should change
 * to reflect this type
 *
 * @param domStorageName - Name of the underlying storage object
 *   (e.g. 'localStorage' or 'sessionStorage').
 * @returns Turning off type information until a common interface is defined.
 */ const $9cf0852385f62d16$var$createStoragefor = function(domStorageName) {
    try {
        // NOTE: just accessing "localStorage" or "window['localStorage']" may throw a security exception,
        // so it must be inside the try/catch.
        if (typeof window !== 'undefined' && typeof window[domStorageName] !== 'undefined') {
            // Need to test cache. Just because it's here doesn't mean it works
            const domStorage = window[domStorageName];
            domStorage.setItem('firebase:sentinel', 'cache');
            domStorage.removeItem('firebase:sentinel');
            return new $9cf0852385f62d16$var$DOMStorageWrapper(domStorage);
        }
    } catch (e) {}
    // Failed to create wrapper.  Just return in-memory storage.
    // TODO: log?
    return new $9cf0852385f62d16$var$MemoryStorage();
};
/** A storage object that lasts across sessions */ const $9cf0852385f62d16$var$PersistentStorage = $9cf0852385f62d16$var$createStoragefor('localStorage');
/** A storage object that only lasts one session */ const $9cf0852385f62d16$var$SessionStorage = $9cf0852385f62d16$var$createStoragefor('sessionStorage');
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9cf0852385f62d16$var$logClient = new (0, $6640afd658bf2724$export$efa9a398d6368992)('@firebase/database');
/**
 * Returns a locally-unique ID (generated by just incrementing up from 0 each time its called).
 */ const $9cf0852385f62d16$var$LUIDGenerator = function() {
    let id = 1;
    return function() {
        return id++;
    };
}();
/**
 * Sha1 hash of the input string
 * @param str - The string to hash
 * @returns {!string} The resulting hash
 */ const $9cf0852385f62d16$var$sha1 = function(str) {
    const utf8Bytes = (0, $3117f6f4eeb4c314$export$655666783217a925)(str);
    const sha1 = new (0, $3117f6f4eeb4c314$export$c85d589bf4e25fef)();
    sha1.update(utf8Bytes);
    const sha1Bytes = sha1.digest();
    return (0, $3117f6f4eeb4c314$export$b3b2de96497acc47).encodeByteArray(sha1Bytes);
};
const $9cf0852385f62d16$var$buildLogMessage_ = function(...varArgs) {
    let message = '';
    for(let i = 0; i < varArgs.length; i++){
        const arg = varArgs[i];
        if (Array.isArray(arg) || arg && typeof arg === 'object' && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        typeof arg.length === 'number') message += $9cf0852385f62d16$var$buildLogMessage_.apply(null, arg);
        else if (typeof arg === 'object') message += (0, $3117f6f4eeb4c314$export$fac44ee5b035f737)(arg);
        else message += arg;
        message += ' ';
    }
    return message;
};
/**
 * Use this for all debug messages in Firebase.
 */ let $9cf0852385f62d16$var$logger = null;
/**
 * Flag to check for log availability on first log message
 */ let $9cf0852385f62d16$var$firstLog_ = true;
/**
 * The implementation of Firebase.enableLogging (defined here to break dependencies)
 * @param logger_ - A flag to turn on logging, or a custom logger
 * @param persistent - Whether or not to persist logging settings across refreshes
 */ const $9cf0852385f62d16$var$enableLogging$1 = function(logger_, persistent) {
    (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(!persistent || logger_ === true || logger_ === false, "Can't turn on custom loggers persistently.");
    if (logger_ === true) {
        $9cf0852385f62d16$var$logClient.logLevel = (0, $6640afd658bf2724$export$243e62d78d3b544d).VERBOSE;
        $9cf0852385f62d16$var$logger = $9cf0852385f62d16$var$logClient.log.bind($9cf0852385f62d16$var$logClient);
        if (persistent) $9cf0852385f62d16$var$SessionStorage.set('logging_enabled', true);
    } else if (typeof logger_ === 'function') $9cf0852385f62d16$var$logger = logger_;
    else {
        $9cf0852385f62d16$var$logger = null;
        $9cf0852385f62d16$var$SessionStorage.remove('logging_enabled');
    }
};
const $9cf0852385f62d16$var$log = function(...varArgs) {
    if ($9cf0852385f62d16$var$firstLog_ === true) {
        $9cf0852385f62d16$var$firstLog_ = false;
        if ($9cf0852385f62d16$var$logger === null && $9cf0852385f62d16$var$SessionStorage.get('logging_enabled') === true) $9cf0852385f62d16$var$enableLogging$1(true);
    }
    if ($9cf0852385f62d16$var$logger) {
        const message = $9cf0852385f62d16$var$buildLogMessage_.apply(null, varArgs);
        $9cf0852385f62d16$var$logger(message);
    }
};
const $9cf0852385f62d16$var$logWrapper = function(prefix) {
    return function(...varArgs) {
        $9cf0852385f62d16$var$log(prefix, ...varArgs);
    };
};
const $9cf0852385f62d16$var$error = function(...varArgs) {
    const message = 'FIREBASE INTERNAL ERROR: ' + $9cf0852385f62d16$var$buildLogMessage_(...varArgs);
    $9cf0852385f62d16$var$logClient.error(message);
};
const $9cf0852385f62d16$var$fatal = function(...varArgs) {
    const message = `FIREBASE FATAL ERROR: ${$9cf0852385f62d16$var$buildLogMessage_(...varArgs)}`;
    $9cf0852385f62d16$var$logClient.error(message);
    throw new Error(message);
};
const $9cf0852385f62d16$var$warn = function(...varArgs) {
    const message = 'FIREBASE WARNING: ' + $9cf0852385f62d16$var$buildLogMessage_(...varArgs);
    $9cf0852385f62d16$var$logClient.warn(message);
};
/**
 * Logs a warning if the containing page uses https. Called when a call to new Firebase
 * does not use https.
 */ const $9cf0852385f62d16$var$warnIfPageIsSecure = function() {
    // Be very careful accessing browser globals. Who knows what may or may not exist.
    if (typeof window !== 'undefined' && window.location && window.location.protocol && window.location.protocol.indexOf('https:') !== -1) $9cf0852385f62d16$var$warn("Insecure Firebase access from a secure page. Please use https in calls to new Firebase().");
};
/**
 * Returns true if data is NaN, or +/- Infinity.
 */ const $9cf0852385f62d16$var$isInvalidJSONNumber = function(data) {
    return typeof data === 'number' && (data !== data || // NaN
    data === Number.POSITIVE_INFINITY || data === Number.NEGATIVE_INFINITY);
};
const $9cf0852385f62d16$var$executeWhenDOMReady = function(fn) {
    if ((0, $3117f6f4eeb4c314$export$5d1d834fbbf8bab7)() || document.readyState === 'complete') fn();
    else {
        // Modeled after jQuery. Try DOMContentLoaded and onreadystatechange (which
        // fire before onload), but fall back to onload.
        let called = false;
        const wrappedFn = function() {
            if (!document.body) {
                setTimeout(wrappedFn, Math.floor(10));
                return;
            }
            if (!called) {
                called = true;
                fn();
            }
        };
        if (document.addEventListener) {
            document.addEventListener('DOMContentLoaded', wrappedFn, false);
            // fallback to onload.
            window.addEventListener('load', wrappedFn, false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } else if (document.attachEvent) {
            // IE.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            document.attachEvent('onreadystatechange', ()=>{
                if (document.readyState === 'complete') wrappedFn();
            });
            // fallback to onload.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            window.attachEvent('onload', wrappedFn);
        // jQuery has an extra hack for IE that we could employ (based on
        // http://javascript.nwbox.com/IEContentLoaded/) But it looks really old.
        // I'm hoping we don't need it.
        }
    }
};
/**
 * Minimum key name. Invalid for actual data, used as a marker to sort before any valid names
 */ const $9cf0852385f62d16$var$MIN_NAME = '[MIN_NAME]';
/**
 * Maximum key name. Invalid for actual data, used as a marker to sort above any valid names
 */ const $9cf0852385f62d16$var$MAX_NAME = '[MAX_NAME]';
/**
 * Compares valid Firebase key names, plus min and max name
 */ const $9cf0852385f62d16$var$nameCompare = function(a, b) {
    if (a === b) return 0;
    else if (a === $9cf0852385f62d16$var$MIN_NAME || b === $9cf0852385f62d16$var$MAX_NAME) return -1;
    else if (b === $9cf0852385f62d16$var$MIN_NAME || a === $9cf0852385f62d16$var$MAX_NAME) return 1;
    else {
        const aAsInt = $9cf0852385f62d16$var$tryParseInt(a), bAsInt = $9cf0852385f62d16$var$tryParseInt(b);
        if (aAsInt !== null) {
            if (bAsInt !== null) return aAsInt - bAsInt === 0 ? a.length - b.length : aAsInt - bAsInt;
            else return -1;
        } else if (bAsInt !== null) return 1;
        else return a < b ? -1 : 1;
    }
};
/**
 * @returns {!number} comparison result.
 */ const $9cf0852385f62d16$var$stringCompare = function(a, b) {
    if (a === b) return 0;
    else if (a < b) return -1;
    else return 1;
};
const $9cf0852385f62d16$var$requireKey = function(key, obj) {
    if (obj && key in obj) return obj[key];
    else throw new Error('Missing required key (' + key + ') in object: ' + (0, $3117f6f4eeb4c314$export$fac44ee5b035f737)(obj));
};
const $9cf0852385f62d16$var$ObjectToUniqueKey = function(obj) {
    if (typeof obj !== 'object' || obj === null) return (0, $3117f6f4eeb4c314$export$fac44ee5b035f737)(obj);
    const keys = [];
    // eslint-disable-next-line guard-for-in
    for(const k in obj)keys.push(k);
    // Export as json, but with the keys sorted.
    keys.sort();
    let key = '{';
    for(let i = 0; i < keys.length; i++){
        if (i !== 0) key += ',';
        key += (0, $3117f6f4eeb4c314$export$fac44ee5b035f737)(keys[i]);
        key += ':';
        key += $9cf0852385f62d16$var$ObjectToUniqueKey(obj[keys[i]]);
    }
    key += '}';
    return key;
};
/**
 * Splits a string into a number of smaller segments of maximum size
 * @param str - The string
 * @param segsize - The maximum number of chars in the string.
 * @returns The string, split into appropriately-sized chunks
 */ const $9cf0852385f62d16$var$splitStringBySize = function(str, segsize) {
    const len = str.length;
    if (len <= segsize) return [
        str
    ];
    const dataSegs = [];
    for(let c = 0; c < len; c += segsize)if (c + segsize > len) dataSegs.push(str.substring(c, len));
    else dataSegs.push(str.substring(c, c + segsize));
    return dataSegs;
};
/**
 * Apply a function to each (key, value) pair in an object or
 * apply a function to each (index, value) pair in an array
 * @param obj - The object or array to iterate over
 * @param fn - The function to apply
 */ function $9cf0852385f62d16$var$each(obj, fn) {
    for(const key in obj)if (obj.hasOwnProperty(key)) fn(key, obj[key]);
}
/**
 * Borrowed from http://hg.secondlife.com/llsd/src/tip/js/typedarray.js (MIT License)
 * I made one modification at the end and removed the NaN / Infinity
 * handling (since it seemed broken [caused an overflow] and we don't need it).  See MJL comments.
 * @param v - A double
 *
 */ const $9cf0852385f62d16$var$doubleToIEEE754String = function(v) {
    (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(!$9cf0852385f62d16$var$isInvalidJSONNumber(v), 'Invalid JSON number'); // MJL
    const ebits = 11, fbits = 52;
    const bias = (1 << ebits - 1) - 1;
    let s, e, f, ln, i;
    // Compute sign, exponent, fraction
    // Skip NaN / Infinity handling --MJL.
    if (v === 0) {
        e = 0;
        f = 0;
        s = 1 / v === -Infinity ? 1 : 0;
    } else {
        s = v < 0;
        v = Math.abs(v);
        if (v >= Math.pow(2, 1 - bias)) {
            // Normalized
            ln = Math.min(Math.floor(Math.log(v) / Math.LN2), bias);
            e = ln + bias;
            f = Math.round(v * Math.pow(2, fbits - ln) - Math.pow(2, fbits));
        } else {
            // Denormalized
            e = 0;
            f = Math.round(v / Math.pow(2, 1 - bias - fbits));
        }
    }
    // Pack sign, exponent, fraction
    const bits = [];
    for(i = fbits; i; i -= 1){
        bits.push(f % 2 ? 1 : 0);
        f = Math.floor(f / 2);
    }
    for(i = ebits; i; i -= 1){
        bits.push(e % 2 ? 1 : 0);
        e = Math.floor(e / 2);
    }
    bits.push(s ? 1 : 0);
    bits.reverse();
    const str = bits.join('');
    // Return the data as a hex string. --MJL
    let hexByteString = '';
    for(i = 0; i < 64; i += 8){
        let hexByte = parseInt(str.substr(i, 8), 2).toString(16);
        if (hexByte.length === 1) hexByte = '0' + hexByte;
        hexByteString = hexByteString + hexByte;
    }
    return hexByteString.toLowerCase();
};
/**
 * Used to detect if we're in a Chrome content script (which executes in an
 * isolated environment where long-polling doesn't work).
 */ const $9cf0852385f62d16$var$isChromeExtensionContentScript = function() {
    return !!(typeof window === 'object' && window['chrome'] && window['chrome']['extension'] && !/^chrome/.test(window.location.href));
};
/**
 * Used to detect if we're in a Windows 8 Store app.
 */ const $9cf0852385f62d16$var$isWindowsStoreApp = function() {
    // Check for the presence of a couple WinRT globals
    return typeof Windows === 'object' && typeof Windows.UI === 'object';
};
/**
 * Converts a server error code to a JavaScript Error
 */ function $9cf0852385f62d16$var$errorForServerCode(code, query) {
    let reason = 'Unknown Error';
    if (code === 'too_big') reason = "The data requested exceeds the maximum size that can be accessed with a single request.";
    else if (code === 'permission_denied') reason = "Client doesn't have permission to access the desired data.";
    else if (code === 'unavailable') reason = 'The service is unavailable';
    const error = new Error(code + ' at ' + query._path.toString() + ': ' + reason);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error.code = code.toUpperCase();
    return error;
}
/**
 * Used to test for integer-looking strings
 */ const $9cf0852385f62d16$var$INTEGER_REGEXP_ = new RegExp('^-?(0*)\\d{1,10}$');
/**
 * For use in keys, the minimum possible 32-bit integer.
 */ const $9cf0852385f62d16$var$INTEGER_32_MIN = -2147483648;
/**
 * For use in keys, the maximum possible 32-bit integer.
 */ const $9cf0852385f62d16$var$INTEGER_32_MAX = 2147483647;
/**
 * If the string contains a 32-bit integer, return it.  Else return null.
 */ const $9cf0852385f62d16$var$tryParseInt = function(str) {
    if ($9cf0852385f62d16$var$INTEGER_REGEXP_.test(str)) {
        const intVal = Number(str);
        if (intVal >= $9cf0852385f62d16$var$INTEGER_32_MIN && intVal <= $9cf0852385f62d16$var$INTEGER_32_MAX) return intVal;
    }
    return null;
};
/**
 * Helper to run some code but catch any exceptions and re-throw them later.
 * Useful for preventing user callbacks from breaking internal code.
 *
 * Re-throwing the exception from a setTimeout is a little evil, but it's very
 * convenient (we don't have to try to figure out when is a safe point to
 * re-throw it), and the behavior seems reasonable:
 *
 * * If you aren't pausing on exceptions, you get an error in the console with
 *   the correct stack trace.
 * * If you're pausing on all exceptions, the debugger will pause on your
 *   exception and then again when we rethrow it.
 * * If you're only pausing on uncaught exceptions, the debugger will only pause
 *   on us re-throwing it.
 *
 * @param fn - The code to guard.
 */ const $9cf0852385f62d16$var$exceptionGuard = function(fn) {
    try {
        fn();
    } catch (e) {
        // Re-throw exception when it's safe.
        setTimeout(()=>{
            // It used to be that "throw e" would result in a good console error with
            // relevant context, but as of Chrome 39, you just get the firebase.js
            // file/line number where we re-throw it, which is useless. So we log
            // e.stack explicitly.
            const stack = e.stack || '';
            $9cf0852385f62d16$var$warn('Exception was thrown by user callback.', stack);
            throw e;
        }, Math.floor(0));
    }
};
/**
 * @returns {boolean} true if we think we're currently being crawled.
 */ const $9cf0852385f62d16$var$beingCrawled = function() {
    const userAgent = typeof window === 'object' && window['navigator'] && window['navigator']['userAgent'] || '';
    // For now we whitelist the most popular crawlers.  We should refine this to be the set of crawlers we
    // believe to support JavaScript/AJAX rendering.
    // NOTE: Google Webmaster Tools doesn't really belong, but their "This is how a visitor to your website
    // would have seen the page" is flaky if we don't treat it as a crawler.
    return userAgent.search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0;
};
/**
 * Same as setTimeout() except on Node.JS it will /not/ prevent the process from exiting.
 *
 * It is removed with clearTimeout() as normal.
 *
 * @param fn - Function to run.
 * @param time - Milliseconds to wait before running.
 * @returns The setTimeout() return value.
 */ const $9cf0852385f62d16$var$setTimeoutNonBlocking = function(fn, time) {
    const timeout = setTimeout(fn, time);
    // Note: at the time of this comment, unrefTimer is under the unstable set of APIs. Run with --unstable to enable the API.
    if (typeof timeout === 'number' && // @ts-ignore Is only defined in Deno environments.
    typeof Deno !== 'undefined' && // @ts-ignore Deno and unrefTimer are only defined in Deno environments.
    Deno['unrefTimer']) // @ts-ignore Deno and unrefTimer are only defined in Deno environments.
    Deno.unrefTimer(timeout);
    else if (typeof timeout === 'object' && timeout['unref']) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    timeout['unref']();
    return timeout;
};
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Abstraction around AppCheck's token fetching capabilities.
 */ class $9cf0852385f62d16$var$AppCheckTokenProvider {
    constructor(app, appCheckProvider){
        this.appCheckProvider = appCheckProvider;
        this.appName = app.name;
        if ((0, $0c1331d0a001f5bc$export$643c8bc6c389f34e)(app) && app.settings.appCheckToken) this.serverAppAppCheckToken = app.settings.appCheckToken;
        this.appCheck = appCheckProvider?.getImmediate({
            optional: true
        });
        if (!this.appCheck) appCheckProvider?.get().then((appCheck)=>this.appCheck = appCheck);
    }
    getToken(forceRefresh) {
        if (this.serverAppAppCheckToken) {
            if (forceRefresh) throw new Error('Attempted reuse of `FirebaseServerApp.appCheckToken` after previous usage failed.');
            return Promise.resolve({
                token: this.serverAppAppCheckToken
            });
        }
        if (!this.appCheck) return new Promise((resolve, reject)=>{
            // Support delayed initialization of FirebaseAppCheck. This allows our
            // customers to initialize the RTDB SDK before initializing Firebase
            // AppCheck and ensures that all requests are authenticated if a token
            // becomes available before the timeout below expires.
            setTimeout(()=>{
                if (this.appCheck) this.getToken(forceRefresh).then(resolve, reject);
                else resolve(null);
            }, 0);
        });
        return this.appCheck.getToken(forceRefresh);
    }
    addTokenChangeListener(listener) {
        this.appCheckProvider?.get().then((appCheck)=>appCheck.addTokenListener(listener));
    }
    notifyForInvalidToken() {
        $9cf0852385f62d16$var$warn(`Provided AppCheck credentials for the app named "${this.appName}" ` + 'are invalid. This usually indicates your app was not initialized correctly.');
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Abstraction around FirebaseApp's token fetching capabilities.
 */ class $9cf0852385f62d16$var$FirebaseAuthTokenProvider {
    constructor(appName_, firebaseOptions_, authProvider_){
        this.appName_ = appName_;
        this.firebaseOptions_ = firebaseOptions_;
        this.authProvider_ = authProvider_;
        this.auth_ = null;
        this.auth_ = authProvider_.getImmediate({
            optional: true
        });
        if (!this.auth_) authProvider_.onInit((auth)=>this.auth_ = auth);
    }
    getToken(forceRefresh) {
        if (!this.auth_) return new Promise((resolve, reject)=>{
            // Support delayed initialization of FirebaseAuth. This allows our
            // customers to initialize the RTDB SDK before initializing Firebase
            // Auth and ensures that all requests are authenticated if a token
            // becomes available before the timeout below expires.
            setTimeout(()=>{
                if (this.auth_) this.getToken(forceRefresh).then(resolve, reject);
                else resolve(null);
            }, 0);
        });
        return this.auth_.getToken(forceRefresh).catch((error)=>{
            // TODO: Need to figure out all the cases this is raised and whether
            // this makes sense.
            if (error && error.code === 'auth/token-not-initialized') {
                $9cf0852385f62d16$var$log('Got auth/token-not-initialized error.  Treating as null token.');
                return null;
            } else return Promise.reject(error);
        });
    }
    addTokenChangeListener(listener) {
        // TODO: We might want to wrap the listener and call it with no args to
        // avoid a leaky abstraction, but that makes removing the listener harder.
        if (this.auth_) this.auth_.addAuthTokenListener(listener);
        else this.authProvider_.get().then((auth)=>auth.addAuthTokenListener(listener));
    }
    removeTokenChangeListener(listener) {
        this.authProvider_.get().then((auth)=>auth.removeAuthTokenListener(listener));
    }
    notifyForInvalidToken() {
        let errorMessage = 'Provided authentication credentials for the app named "' + this.appName_ + '" are invalid. This usually indicates your app was not ' + 'initialized correctly. ';
        if ('credential' in this.firebaseOptions_) errorMessage += 'Make sure the "credential" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.';
        else if ('serviceAccount' in this.firebaseOptions_) errorMessage += 'Make sure the "serviceAccount" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.';
        else errorMessage += 'Make sure the "apiKey" and "databaseURL" properties provided to initializeApp() match the values provided for your app at https://console.firebase.google.com/.';
        $9cf0852385f62d16$var$warn(errorMessage);
    }
}
/* AuthTokenProvider that supplies a constant token. Used by Admin SDK or mockUserToken with emulators. */ class $9cf0852385f62d16$var$EmulatorTokenProvider {
    constructor(accessToken){
        this.accessToken = accessToken;
    }
    getToken(forceRefresh) {
        return Promise.resolve({
            accessToken: this.accessToken
        });
    }
    addTokenChangeListener(listener) {
        // Invoke the listener immediately to match the behavior in Firebase Auth
        // (see packages/auth/src/auth.js#L1807)
        listener(this.accessToken);
    }
    removeTokenChangeListener(listener) {}
    notifyForInvalidToken() {}
}
/** A string that is treated as an admin access token by the RTDB emulator. Used by Admin SDK. */ $9cf0852385f62d16$var$EmulatorTokenProvider.OWNER = 'owner';
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9cf0852385f62d16$var$PROTOCOL_VERSION = '5';
const $9cf0852385f62d16$var$VERSION_PARAM = 'v';
const $9cf0852385f62d16$var$TRANSPORT_SESSION_PARAM = 's';
const $9cf0852385f62d16$var$REFERER_PARAM = 'r';
const $9cf0852385f62d16$var$FORGE_REF = 'f';
// Matches console.firebase.google.com, firebase-console-*.corp.google.com and
// firebase.corp.google.com
const $9cf0852385f62d16$var$FORGE_DOMAIN_RE = /(console\.firebase|firebase-console-\w+\.corp|firebase\.corp)\.google\.com/;
const $9cf0852385f62d16$var$LAST_SESSION_PARAM = 'ls';
const $9cf0852385f62d16$var$APPLICATION_ID_PARAM = 'p';
const $9cf0852385f62d16$var$APP_CHECK_TOKEN_PARAM = 'ac';
const $9cf0852385f62d16$var$WEBSOCKET = 'websocket';
const $9cf0852385f62d16$var$LONG_POLLING = 'long_polling';
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class that holds metadata about a Repo object
 */ class $9cf0852385f62d16$var$RepoInfo {
    /**
     * @param host - Hostname portion of the url for the repo
     * @param secure - Whether or not this repo is accessed over ssl
     * @param namespace - The namespace represented by the repo
     * @param webSocketOnly - Whether to prefer websockets over all other transports (used by Nest).
     * @param nodeAdmin - Whether this instance uses Admin SDK credentials
     * @param persistenceKey - Override the default session persistence storage key
     */ constructor(host, secure, namespace, webSocketOnly, nodeAdmin = false, persistenceKey = '', includeNamespaceInQueryParams = false, isUsingEmulator = false, emulatorOptions = null){
        this.secure = secure;
        this.namespace = namespace;
        this.webSocketOnly = webSocketOnly;
        this.nodeAdmin = nodeAdmin;
        this.persistenceKey = persistenceKey;
        this.includeNamespaceInQueryParams = includeNamespaceInQueryParams;
        this.isUsingEmulator = isUsingEmulator;
        this.emulatorOptions = emulatorOptions;
        this._host = host.toLowerCase();
        this._domain = this._host.substr(this._host.indexOf('.') + 1);
        this.internalHost = $9cf0852385f62d16$var$PersistentStorage.get('host:' + host) || this._host;
    }
    isCacheableHost() {
        return this.internalHost.substr(0, 2) === 's-';
    }
    isCustomHost() {
        return this._domain !== 'firebaseio.com' && this._domain !== 'firebaseio-demo.com';
    }
    get host() {
        return this._host;
    }
    set host(newHost) {
        if (newHost !== this.internalHost) {
            this.internalHost = newHost;
            if (this.isCacheableHost()) $9cf0852385f62d16$var$PersistentStorage.set('host:' + this._host, this.internalHost);
        }
    }
    toString() {
        let str = this.toURLString();
        if (this.persistenceKey) str += '<' + this.persistenceKey + '>';
        return str;
    }
    toURLString() {
        const protocol = this.secure ? 'https://' : 'http://';
        const query = this.includeNamespaceInQueryParams ? `?ns=${this.namespace}` : '';
        return `${protocol}${this.host}/${query}`;
    }
}
function $9cf0852385f62d16$var$repoInfoNeedsQueryParam(repoInfo) {
    return repoInfo.host !== repoInfo.internalHost || repoInfo.isCustomHost() || repoInfo.includeNamespaceInQueryParams;
}
/**
 * Returns the websocket URL for this repo
 * @param repoInfo - RepoInfo object
 * @param type - of connection
 * @param params - list
 * @returns The URL for this repo
 */ function $9cf0852385f62d16$var$repoInfoConnectionURL(repoInfo, type, params) {
    (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(typeof type === 'string', 'typeof type must == string');
    (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(typeof params === 'object', 'typeof params must == object');
    let connURL;
    if (type === $9cf0852385f62d16$var$WEBSOCKET) connURL = (repoInfo.secure ? 'wss://' : 'ws://') + repoInfo.internalHost + '/.ws?';
    else if (type === $9cf0852385f62d16$var$LONG_POLLING) connURL = (repoInfo.secure ? 'https://' : 'http://') + repoInfo.internalHost + '/.lp?';
    else throw new Error('Unknown connection type: ' + type);
    if ($9cf0852385f62d16$var$repoInfoNeedsQueryParam(repoInfo)) params['ns'] = repoInfo.namespace;
    const pairs = [];
    $9cf0852385f62d16$var$each(params, (key, value)=>{
        pairs.push(key + '=' + value);
    });
    return connURL + pairs.join('&');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Tracks a collection of stats.
 */ class $9cf0852385f62d16$var$StatsCollection {
    constructor(){
        this.counters_ = {};
    }
    incrementCounter(name, amount = 1) {
        if (!(0, $3117f6f4eeb4c314$export$2344b14b097df817)(this.counters_, name)) this.counters_[name] = 0;
        this.counters_[name] += amount;
    }
    get() {
        return (0, $3117f6f4eeb4c314$export$6c40052bed430212)(this.counters_);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9cf0852385f62d16$var$collections = {};
const $9cf0852385f62d16$var$reporters = {};
function $9cf0852385f62d16$var$statsManagerGetCollection(repoInfo) {
    const hashString = repoInfo.toString();
    if (!$9cf0852385f62d16$var$collections[hashString]) $9cf0852385f62d16$var$collections[hashString] = new $9cf0852385f62d16$var$StatsCollection();
    return $9cf0852385f62d16$var$collections[hashString];
}
function $9cf0852385f62d16$var$statsManagerGetOrCreateReporter(repoInfo, creatorFunction) {
    const hashString = repoInfo.toString();
    if (!$9cf0852385f62d16$var$reporters[hashString]) $9cf0852385f62d16$var$reporters[hashString] = creatorFunction();
    return $9cf0852385f62d16$var$reporters[hashString];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class ensures the packets from the server arrive in order
 * This class takes data from the server and ensures it gets passed into the callbacks in order.
 */ class $9cf0852385f62d16$var$PacketReceiver {
    /**
     * @param onMessage_
     */ constructor(onMessage_){
        this.onMessage_ = onMessage_;
        this.pendingResponses = [];
        this.currentResponseNum = 0;
        this.closeAfterResponse = -1;
        this.onClose = null;
    }
    closeAfter(responseNum, callback) {
        this.closeAfterResponse = responseNum;
        this.onClose = callback;
        if (this.closeAfterResponse < this.currentResponseNum) {
            this.onClose();
            this.onClose = null;
        }
    }
    /**
     * Each message from the server comes with a response number, and an array of data. The responseNumber
     * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
     * browsers will respond in the same order as the requests we sent
     */ handleResponse(requestNum, data) {
        this.pendingResponses[requestNum] = data;
        while(this.pendingResponses[this.currentResponseNum]){
            const toProcess = this.pendingResponses[this.currentResponseNum];
            delete this.pendingResponses[this.currentResponseNum];
            for(let i = 0; i < toProcess.length; ++i)if (toProcess[i]) $9cf0852385f62d16$var$exceptionGuard(()=>{
                this.onMessage_(toProcess[i]);
            });
            if (this.currentResponseNum === this.closeAfterResponse) {
                if (this.onClose) {
                    this.onClose();
                    this.onClose = null;
                }
                break;
            }
            this.currentResponseNum++;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // URL query parameters associated with longpolling
const $9cf0852385f62d16$var$FIREBASE_LONGPOLL_START_PARAM = 'start';
const $9cf0852385f62d16$var$FIREBASE_LONGPOLL_CLOSE_COMMAND = 'close';
const $9cf0852385f62d16$var$FIREBASE_LONGPOLL_COMMAND_CB_NAME = 'pLPCommand';
const $9cf0852385f62d16$var$FIREBASE_LONGPOLL_DATA_CB_NAME = 'pRTLPCB';
const $9cf0852385f62d16$var$FIREBASE_LONGPOLL_ID_PARAM = 'id';
const $9cf0852385f62d16$var$FIREBASE_LONGPOLL_PW_PARAM = 'pw';
const $9cf0852385f62d16$var$FIREBASE_LONGPOLL_SERIAL_PARAM = 'ser';
const $9cf0852385f62d16$var$FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = 'cb';
const $9cf0852385f62d16$var$FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = 'seg';
const $9cf0852385f62d16$var$FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = 'ts';
const $9cf0852385f62d16$var$FIREBASE_LONGPOLL_DATA_PARAM = 'd';
const $9cf0852385f62d16$var$FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = 'dframe';
//Data size constants.
//TODO: Perf: the maximum length actually differs from browser to browser.
// We should check what browser we're on and set accordingly.
const $9cf0852385f62d16$var$MAX_URL_DATA_SIZE = 1870;
const $9cf0852385f62d16$var$SEG_HEADER_SIZE = 30; //ie: &seg=8299234&ts=982389123&d=
const $9cf0852385f62d16$var$MAX_PAYLOAD_SIZE = $9cf0852385f62d16$var$MAX_URL_DATA_SIZE - $9cf0852385f62d16$var$SEG_HEADER_SIZE;
/**
 * Keepalive period
 * send a fresh request at minimum every 25 seconds. Opera has a maximum request
 * length of 30 seconds that we can't exceed.
 */ const $9cf0852385f62d16$var$KEEPALIVE_REQUEST_INTERVAL = 25000;
/**
 * How long to wait before aborting a long-polling connection attempt.
 */ const $9cf0852385f62d16$var$LP_CONNECT_TIMEOUT = 30000;
/**
 * This class manages a single long-polling connection.
 */ class $9cf0852385f62d16$var$BrowserPollConnection {
    /**
     * @param connId An identifier for this connection, used for logging
     * @param repoInfo The info for the endpoint to send data to.
     * @param applicationId The Firebase App ID for this project.
     * @param appCheckToken The AppCheck token for this client.
     * @param authToken The AuthToken to use for this connection.
     * @param transportSessionId Optional transportSessionid if we are
     * reconnecting for an existing transport session
     * @param lastSessionId Optional lastSessionId if the PersistentConnection has
     * already created a connection previously
     */ constructor(connId, repoInfo, applicationId, appCheckToken, authToken, transportSessionId, lastSessionId){
        this.connId = connId;
        this.repoInfo = repoInfo;
        this.applicationId = applicationId;
        this.appCheckToken = appCheckToken;
        this.authToken = authToken;
        this.transportSessionId = transportSessionId;
        this.lastSessionId = lastSessionId;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.everConnected_ = false;
        this.log_ = $9cf0852385f62d16$var$logWrapper(connId);
        this.stats_ = $9cf0852385f62d16$var$statsManagerGetCollection(repoInfo);
        this.urlFn = (params)=>{
            // Always add the token if we have one.
            if (this.appCheckToken) params[$9cf0852385f62d16$var$APP_CHECK_TOKEN_PARAM] = this.appCheckToken;
            return $9cf0852385f62d16$var$repoInfoConnectionURL(repoInfo, $9cf0852385f62d16$var$LONG_POLLING, params);
        };
    }
    /**
     * @param onMessage - Callback when messages arrive
     * @param onDisconnect - Callback with connection lost.
     */ open(onMessage, onDisconnect) {
        this.curSegmentNum = 0;
        this.onDisconnect_ = onDisconnect;
        this.myPacketOrderer = new $9cf0852385f62d16$var$PacketReceiver(onMessage);
        this.isClosed_ = false;
        this.connectTimeoutTimer_ = setTimeout(()=>{
            this.log_('Timed out trying to connect.');
            // Make sure we clear the host cache
            this.onClosed_();
            this.connectTimeoutTimer_ = null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor($9cf0852385f62d16$var$LP_CONNECT_TIMEOUT));
        // Ensure we delay the creation of the iframe until the DOM is loaded.
        $9cf0852385f62d16$var$executeWhenDOMReady(()=>{
            if (this.isClosed_) return;
            //Set up a callback that gets triggered once a connection is set up.
            this.scriptTagHolder = new $9cf0852385f62d16$var$FirebaseIFrameScriptHolder((...args)=>{
                const [command, arg1, arg2, arg3, arg4] = args;
                this.incrementIncomingBytes_(args);
                if (!this.scriptTagHolder) return; // we closed the connection.
                if (this.connectTimeoutTimer_) {
                    clearTimeout(this.connectTimeoutTimer_);
                    this.connectTimeoutTimer_ = null;
                }
                this.everConnected_ = true;
                if (command === $9cf0852385f62d16$var$FIREBASE_LONGPOLL_START_PARAM) {
                    this.id = arg1;
                    this.password = arg2;
                } else if (command === $9cf0852385f62d16$var$FIREBASE_LONGPOLL_CLOSE_COMMAND) {
                    // Don't clear the host cache. We got a response from the server, so we know it's reachable
                    if (arg1) {
                        // We aren't expecting any more data (other than what the server's already in the process of sending us
                        // through our already open polls), so don't send any more.
                        this.scriptTagHolder.sendNewPolls = false;
                        // arg1 in this case is the last response number sent by the server. We should try to receive
                        // all of the responses up to this one before closing
                        this.myPacketOrderer.closeAfter(arg1, ()=>{
                            this.onClosed_();
                        });
                    } else this.onClosed_();
                } else throw new Error('Unrecognized command received: ' + command);
            }, (...args)=>{
                const [pN, data] = args;
                this.incrementIncomingBytes_(args);
                this.myPacketOrderer.handleResponse(pN, data);
            }, ()=>{
                this.onClosed_();
            }, this.urlFn);
            //Send the initial request to connect. The serial number is simply to keep the browser from pulling previous results
            //from cache.
            const urlParams = {};
            urlParams[$9cf0852385f62d16$var$FIREBASE_LONGPOLL_START_PARAM] = 't';
            urlParams[$9cf0852385f62d16$var$FIREBASE_LONGPOLL_SERIAL_PARAM] = Math.floor(Math.random() * 100000000);
            if (this.scriptTagHolder.uniqueCallbackIdentifier) urlParams[$9cf0852385f62d16$var$FIREBASE_LONGPOLL_CALLBACK_ID_PARAM] = this.scriptTagHolder.uniqueCallbackIdentifier;
            urlParams[$9cf0852385f62d16$var$VERSION_PARAM] = $9cf0852385f62d16$var$PROTOCOL_VERSION;
            if (this.transportSessionId) urlParams[$9cf0852385f62d16$var$TRANSPORT_SESSION_PARAM] = this.transportSessionId;
            if (this.lastSessionId) urlParams[$9cf0852385f62d16$var$LAST_SESSION_PARAM] = this.lastSessionId;
            if (this.applicationId) urlParams[$9cf0852385f62d16$var$APPLICATION_ID_PARAM] = this.applicationId;
            if (this.appCheckToken) urlParams[$9cf0852385f62d16$var$APP_CHECK_TOKEN_PARAM] = this.appCheckToken;
            if (typeof location !== 'undefined' && location.hostname && $9cf0852385f62d16$var$FORGE_DOMAIN_RE.test(location.hostname)) urlParams[$9cf0852385f62d16$var$REFERER_PARAM] = $9cf0852385f62d16$var$FORGE_REF;
            const connectURL = this.urlFn(urlParams);
            this.log_('Connecting via long-poll to ' + connectURL);
            this.scriptTagHolder.addTag(connectURL, ()=>{
            /* do nothing */ });
        });
    }
    /**
     * Call this when a handshake has completed successfully and we want to consider the connection established
     */ start() {
        this.scriptTagHolder.startLongPoll(this.id, this.password);
        this.addDisconnectPingFrame(this.id, this.password);
    }
    /**
     * Forces long polling to be considered as a potential transport
     */ static forceAllow() {
        $9cf0852385f62d16$var$BrowserPollConnection.forceAllow_ = true;
    }
    /**
     * Forces longpolling to not be considered as a potential transport
     */ static forceDisallow() {
        $9cf0852385f62d16$var$BrowserPollConnection.forceDisallow_ = true;
    }
    // Static method, use string literal so it can be accessed in a generic way
    static isAvailable() {
        if ((0, $3117f6f4eeb4c314$export$5d1d834fbbf8bab7)()) return false;
        else if ($9cf0852385f62d16$var$BrowserPollConnection.forceAllow_) return true;
        else // NOTE: In React-Native there's normally no 'document', but if you debug a React-Native app in
        // the Chrome debugger, 'document' is defined, but document.createElement is null (2015/06/08).
        return !$9cf0852385f62d16$var$BrowserPollConnection.forceDisallow_ && typeof document !== 'undefined' && document.createElement != null && !$9cf0852385f62d16$var$isChromeExtensionContentScript() && !$9cf0852385f62d16$var$isWindowsStoreApp();
    }
    /**
     * No-op for polling
     */ markConnectionHealthy() {}
    /**
     * Stops polling and cleans up the iframe
     */ shutdown_() {
        this.isClosed_ = true;
        if (this.scriptTagHolder) {
            this.scriptTagHolder.close();
            this.scriptTagHolder = null;
        }
        //remove the disconnect frame, which will trigger an XHR call to the server to tell it we're leaving.
        if (this.myDisconnFrame) {
            document.body.removeChild(this.myDisconnFrame);
            this.myDisconnFrame = null;
        }
        if (this.connectTimeoutTimer_) {
            clearTimeout(this.connectTimeoutTimer_);
            this.connectTimeoutTimer_ = null;
        }
    }
    /**
     * Triggered when this transport is closed
     */ onClosed_() {
        if (!this.isClosed_) {
            this.log_('Longpoll is closing itself');
            this.shutdown_();
            if (this.onDisconnect_) {
                this.onDisconnect_(this.everConnected_);
                this.onDisconnect_ = null;
            }
        }
    }
    /**
     * External-facing close handler. RealTime has requested we shut down. Kill our connection and tell the server
     * that we've left.
     */ close() {
        if (!this.isClosed_) {
            this.log_('Longpoll is being closed.');
            this.shutdown_();
        }
    }
    /**
     * Send the JSON object down to the server. It will need to be stringified, base64 encoded, and then
     * broken into chunks (since URLs have a small maximum length).
     * @param data - The JSON data to transmit.
     */ send(data) {
        const dataStr = (0, $3117f6f4eeb4c314$export$fac44ee5b035f737)(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //first, lets get the base64-encoded data
        const base64data = (0, $3117f6f4eeb4c314$export$e510a73ee562749)(dataStr);
        //We can only fit a certain amount in each URL, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        const dataSegs = $9cf0852385f62d16$var$splitStringBySize(base64data, $9cf0852385f62d16$var$MAX_PAYLOAD_SIZE);
        //Enqueue each segment for transmission. We assign each chunk a sequential ID and a total number
        //of segments so that we can reassemble the packet on the server.
        for(let i = 0; i < dataSegs.length; i++){
            this.scriptTagHolder.enqueueSegment(this.curSegmentNum, dataSegs.length, dataSegs[i]);
            this.curSegmentNum++;
        }
    }
    /**
     * This is how we notify the server that we're leaving.
     * We aren't able to send requests with DHTML on a window close event, but we can
     * trigger XHR requests in some browsers (everything but Opera basically).
     */ addDisconnectPingFrame(id, pw) {
        if ((0, $3117f6f4eeb4c314$export$5d1d834fbbf8bab7)()) return;
        this.myDisconnFrame = document.createElement('iframe');
        const urlParams = {};
        urlParams[$9cf0852385f62d16$var$FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM] = 't';
        urlParams[$9cf0852385f62d16$var$FIREBASE_LONGPOLL_ID_PARAM] = id;
        urlParams[$9cf0852385f62d16$var$FIREBASE_LONGPOLL_PW_PARAM] = pw;
        this.myDisconnFrame.src = this.urlFn(urlParams);
        this.myDisconnFrame.style.display = 'none';
        document.body.appendChild(this.myDisconnFrame);
    }
    /**
     * Used to track the bytes received by this client
     */ incrementIncomingBytes_(args) {
        // TODO: This is an annoying perf hit just to track the number of incoming bytes.  Maybe it should be opt-in.
        const bytesReceived = (0, $3117f6f4eeb4c314$export$fac44ee5b035f737)(args).length;
        this.bytesReceived += bytesReceived;
        this.stats_.incrementCounter('bytes_received', bytesReceived);
    }
}
/*********************************************************************************************
 * A wrapper around an iframe that is used as a long-polling script holder.
 *********************************************************************************************/ class $9cf0852385f62d16$var$FirebaseIFrameScriptHolder {
    /**
     * @param commandCB - The callback to be called when control commands are received from the server.
     * @param onMessageCB - The callback to be triggered when responses arrive from the server.
     * @param onDisconnect - The callback to be triggered when this tag holder is closed
     * @param urlFn - A function that provides the URL of the endpoint to send data to.
     */ constructor(commandCB, onMessageCB, onDisconnect, urlFn){
        this.onDisconnect = onDisconnect;
        this.urlFn = urlFn;
        //We maintain a count of all of the outstanding requests, because if we have too many active at once it can cause
        //problems in some browsers.
        this.outstandingRequests = new Set();
        //A queue of the pending segments waiting for transmission to the server.
        this.pendingSegs = [];
        //A serial number. We use this for two things:
        // 1) A way to ensure the browser doesn't cache responses to polls
        // 2) A way to make the server aware when long-polls arrive in a different order than we started them. The
        //    server needs to release both polls in this case or it will cause problems in Opera since Opera can only execute
        //    JSONP code in the order it was added to the iframe.
        this.currentSerial = Math.floor(Math.random() * 100000000);
        // This gets set to false when we're "closing down" the connection (e.g. we're switching transports but there's still
        // incoming data from the server that we're waiting for).
        this.sendNewPolls = true;
        if (!(0, $3117f6f4eeb4c314$export$5d1d834fbbf8bab7)()) {
            //Each script holder registers a couple of uniquely named callbacks with the window. These are called from the
            //iframes where we put the long-polling script tags. We have two callbacks:
            //   1) Command Callback - Triggered for control issues, like starting a connection.
            //   2) Message Callback - Triggered when new data arrives.
            this.uniqueCallbackIdentifier = $9cf0852385f62d16$var$LUIDGenerator();
            window[$9cf0852385f62d16$var$FIREBASE_LONGPOLL_COMMAND_CB_NAME + this.uniqueCallbackIdentifier] = commandCB;
            window[$9cf0852385f62d16$var$FIREBASE_LONGPOLL_DATA_CB_NAME + this.uniqueCallbackIdentifier] = onMessageCB;
            //Create an iframe for us to add script tags to.
            this.myIFrame = $9cf0852385f62d16$var$FirebaseIFrameScriptHolder.createIFrame_();
            // Set the iframe's contents.
            let script = '';
            // if we set a javascript url, it's IE and we need to set the document domain. The javascript url is sufficient
            // for ie9, but ie8 needs to do it again in the document itself.
            if (this.myIFrame.src && this.myIFrame.src.substr(0, 11) === 'javascript:') {
                const currentDomain = document.domain;
                script = '<script>document.domain="' + currentDomain + '";</script>';
            }
            const iframeContents = '<html><body>' + script + '</body></html>';
            try {
                this.myIFrame.doc.open();
                this.myIFrame.doc.write(iframeContents);
                this.myIFrame.doc.close();
            } catch (e) {
                $9cf0852385f62d16$var$log('frame writing exception');
                if (e.stack) $9cf0852385f62d16$var$log(e.stack);
                $9cf0852385f62d16$var$log(e);
            }
        } else {
            this.commandCB = commandCB;
            this.onMessageCB = onMessageCB;
        }
    }
    /**
     * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
     * actually use.
     */ static createIFrame_() {
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        // This is necessary in order to initialize the document inside the iframe
        if (document.body) {
            document.body.appendChild(iframe);
            try {
                // If document.domain has been modified in IE, this will throw an error, and we need to set the
                // domain of the iframe's document manually. We can do this via a javascript: url as the src attribute
                // Also note that we must do this *after* the iframe has been appended to the page. Otherwise it doesn't work.
                const a = iframe.contentWindow.document;
                if (!a) // Apologies for the log-spam, I need to do something to keep closure from optimizing out the assignment above.
                $9cf0852385f62d16$var$log('No IE domain setting required');
            } catch (e) {
                const domain = document.domain;
                iframe.src = "javascript:void((function(){document.open();document.domain='" + domain + "';document.close();})())";
            }
        } else // LongPollConnection attempts to delay initialization until the document is ready, so hopefully this
        // never gets hit.
        throw 'Document body has not initialized. Wait to initialize Firebase until after the document is ready.';
        // Get the document of the iframe in a browser-specific way.
        if (iframe.contentDocument) iframe.doc = iframe.contentDocument; // Firefox, Opera, Safari
        else if (iframe.contentWindow) iframe.doc = iframe.contentWindow.document; // Internet Explorer
        else if (iframe.document) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        iframe.doc = iframe.document; //others?
        return iframe;
    }
    /**
     * Cancel all outstanding queries and remove the frame.
     */ close() {
        //Mark this iframe as dead, so no new requests are sent.
        this.alive = false;
        if (this.myIFrame) {
            //We have to actually remove all of the html inside this iframe before removing it from the
            //window, or IE will continue loading and executing the script tags we've already added, which
            //can lead to some errors being thrown. Setting textContent seems to be the safest way to do this.
            this.myIFrame.doc.body.textContent = '';
            setTimeout(()=>{
                if (this.myIFrame !== null) {
                    document.body.removeChild(this.myIFrame);
                    this.myIFrame = null;
                }
            }, Math.floor(0));
        }
        // Protect from being called recursively.
        const onDisconnect = this.onDisconnect;
        if (onDisconnect) {
            this.onDisconnect = null;
            onDisconnect();
        }
    }
    /**
     * Actually start the long-polling session by adding the first script tag(s) to the iframe.
     * @param id - The ID of this connection
     * @param pw - The password for this connection
     */ startLongPoll(id, pw) {
        this.myID = id;
        this.myPW = pw;
        this.alive = true;
        //send the initial request. If there are requests queued, make sure that we transmit as many as we are currently able to.
        while(this.newRequest_());
    }
    /**
     * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
     * too many outstanding requests and we are still alive.
     *
     * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
     * needed.
     */ newRequest_() {
        // We keep one outstanding request open all the time to receive data, but if we need to send data
        // (pendingSegs.length > 0) then we create a new request to send the data.  The server will automatically
        // close the old request.
        if (this.alive && this.sendNewPolls && this.outstandingRequests.size < (this.pendingSegs.length > 0 ? 2 : 1)) {
            //construct our url
            this.currentSerial++;
            const urlParams = {};
            urlParams[$9cf0852385f62d16$var$FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
            urlParams[$9cf0852385f62d16$var$FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
            urlParams[$9cf0852385f62d16$var$FIREBASE_LONGPOLL_SERIAL_PARAM] = this.currentSerial;
            let theURL = this.urlFn(urlParams);
            //Now add as much data as we can.
            let curDataString = '';
            let i = 0;
            while(this.pendingSegs.length > 0){
                //first, lets see if the next segment will fit.
                const nextSeg = this.pendingSegs[0];
                if (nextSeg.d.length + $9cf0852385f62d16$var$SEG_HEADER_SIZE + curDataString.length <= $9cf0852385f62d16$var$MAX_URL_DATA_SIZE) {
                    //great, the segment will fit. Lets append it.
                    const theSeg = this.pendingSegs.shift();
                    curDataString = curDataString + '&' + $9cf0852385f62d16$var$FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM + i + '=' + theSeg.seg + '&' + $9cf0852385f62d16$var$FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET + i + '=' + theSeg.ts + '&' + $9cf0852385f62d16$var$FIREBASE_LONGPOLL_DATA_PARAM + i + '=' + theSeg.d;
                    i++;
                } else break;
            }
            theURL = theURL + curDataString;
            this.addLongPollTag_(theURL, this.currentSerial);
            return true;
        } else return false;
    }
    /**
     * Queue a packet for transmission to the server.
     * @param segnum - A sequential id for this packet segment used for reassembly
     * @param totalsegs - The total number of segments in this packet
     * @param data - The data for this segment.
     */ enqueueSegment(segnum, totalsegs, data) {
        //add this to the queue of segments to send.
        this.pendingSegs.push({
            seg: segnum,
            ts: totalsegs,
            d: data
        });
        //send the data immediately if there isn't already data being transmitted, unless
        //startLongPoll hasn't been called yet.
        if (this.alive) this.newRequest_();
    }
    /**
     * Add a script tag for a regular long-poll request.
     * @param url - The URL of the script tag.
     * @param serial - The serial number of the request.
     */ addLongPollTag_(url, serial) {
        //remember that we sent this request.
        this.outstandingRequests.add(serial);
        const doNewRequest = ()=>{
            this.outstandingRequests.delete(serial);
            this.newRequest_();
        };
        // If this request doesn't return on its own accord (by the server sending us some data), we'll
        // create a new one after the KEEPALIVE interval to make sure we always keep a fresh request open.
        const keepaliveTimeout = setTimeout(doNewRequest, Math.floor($9cf0852385f62d16$var$KEEPALIVE_REQUEST_INTERVAL));
        const readyStateCB = ()=>{
            // Request completed.  Cancel the keepalive.
            clearTimeout(keepaliveTimeout);
            // Trigger a new request so we can continue receiving data.
            doNewRequest();
        };
        this.addTag(url, readyStateCB);
    }
    /**
     * Add an arbitrary script tag to the iframe.
     * @param url - The URL for the script tag source.
     * @param loadCB - A callback to be triggered once the script has loaded.
     */ addTag(url, loadCB) {
        if ((0, $3117f6f4eeb4c314$export$5d1d834fbbf8bab7)()) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.doNodeLongPoll(url, loadCB);
        else setTimeout(()=>{
            try {
                // if we're already closed, don't add this poll
                if (!this.sendNewPolls) return;
                const newScript = this.myIFrame.doc.createElement('script');
                newScript.type = 'text/javascript';
                newScript.async = true;
                newScript.src = url;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                newScript.onload = newScript.onreadystatechange = function() {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const rstate = newScript.readyState;
                    if (!rstate || rstate === 'loaded' || rstate === 'complete') {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        newScript.onload = newScript.onreadystatechange = null;
                        if (newScript.parentNode) newScript.parentNode.removeChild(newScript);
                        loadCB();
                    }
                };
                newScript.onerror = ()=>{
                    $9cf0852385f62d16$var$log('Long-poll script failed to load: ' + url);
                    this.sendNewPolls = false;
                    this.close();
                };
                this.myIFrame.doc.body.appendChild(newScript);
            } catch (e) {
            // TODO: we should make this error visible somehow
            }
        }, Math.floor(1));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9cf0852385f62d16$var$WEBSOCKET_MAX_FRAME_SIZE = 16384;
const $9cf0852385f62d16$var$WEBSOCKET_KEEPALIVE_INTERVAL = 45000;
let $9cf0852385f62d16$var$WebSocketImpl = null;
if (typeof MozWebSocket !== 'undefined') $9cf0852385f62d16$var$WebSocketImpl = MozWebSocket;
else if (typeof WebSocket !== 'undefined') $9cf0852385f62d16$var$WebSocketImpl = WebSocket;
/**
 * Create a new websocket connection with the given callbacks.
 */ class $9cf0852385f62d16$var$WebSocketConnection {
    /**
     * @param connId identifier for this transport
     * @param repoInfo The info for the websocket endpoint.
     * @param applicationId The Firebase App ID for this project.
     * @param appCheckToken The App Check Token for this client.
     * @param authToken The Auth Token for this client.
     * @param transportSessionId Optional transportSessionId if this is connecting
     * to an existing transport session
     * @param lastSessionId Optional lastSessionId if there was a previous
     * connection
     */ constructor(connId, repoInfo, applicationId, appCheckToken, authToken, transportSessionId, lastSessionId){
        this.connId = connId;
        this.applicationId = applicationId;
        this.appCheckToken = appCheckToken;
        this.authToken = authToken;
        this.keepaliveTimer = null;
        this.frames = null;
        this.totalFrames = 0;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.log_ = $9cf0852385f62d16$var$logWrapper(this.connId);
        this.stats_ = $9cf0852385f62d16$var$statsManagerGetCollection(repoInfo);
        this.connURL = $9cf0852385f62d16$var$WebSocketConnection.connectionURL_(repoInfo, transportSessionId, lastSessionId, appCheckToken, applicationId);
        this.nodeAdmin = repoInfo.nodeAdmin;
    }
    /**
     * @param repoInfo - The info for the websocket endpoint.
     * @param transportSessionId - Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param lastSessionId - Optional lastSessionId if there was a previous connection
     * @returns connection url
     */ static connectionURL_(repoInfo, transportSessionId, lastSessionId, appCheckToken, applicationId) {
        const urlParams = {};
        urlParams[$9cf0852385f62d16$var$VERSION_PARAM] = $9cf0852385f62d16$var$PROTOCOL_VERSION;
        if (!(0, $3117f6f4eeb4c314$export$5d1d834fbbf8bab7)() && typeof location !== 'undefined' && location.hostname && $9cf0852385f62d16$var$FORGE_DOMAIN_RE.test(location.hostname)) urlParams[$9cf0852385f62d16$var$REFERER_PARAM] = $9cf0852385f62d16$var$FORGE_REF;
        if (transportSessionId) urlParams[$9cf0852385f62d16$var$TRANSPORT_SESSION_PARAM] = transportSessionId;
        if (lastSessionId) urlParams[$9cf0852385f62d16$var$LAST_SESSION_PARAM] = lastSessionId;
        if (appCheckToken) urlParams[$9cf0852385f62d16$var$APP_CHECK_TOKEN_PARAM] = appCheckToken;
        if (applicationId) urlParams[$9cf0852385f62d16$var$APPLICATION_ID_PARAM] = applicationId;
        return $9cf0852385f62d16$var$repoInfoConnectionURL(repoInfo, $9cf0852385f62d16$var$WEBSOCKET, urlParams);
    }
    /**
     * @param onMessage - Callback when messages arrive
     * @param onDisconnect - Callback with connection lost.
     */ open(onMessage, onDisconnect) {
        this.onDisconnect = onDisconnect;
        this.onMessage = onMessage;
        this.log_('Websocket connecting to ' + this.connURL);
        this.everConnected_ = false;
        // Assume failure until proven otherwise.
        $9cf0852385f62d16$var$PersistentStorage.set('previous_websocket_failure', true);
        try {
            let options;
            if ((0, $3117f6f4eeb4c314$export$5d1d834fbbf8bab7)()) {
                const device = this.nodeAdmin ? 'AdminNode' : 'Node';
                // UA Format: Firebase/<wire_protocol>/<sdk_version>/<platform>/<device>
                options = {
                    headers: {
                        'User-Agent': `Firebase/${$9cf0852385f62d16$var$PROTOCOL_VERSION}/${$9cf0852385f62d16$var$SDK_VERSION}/${$lsQhA.platform}/${device}`,
                        'X-Firebase-GMPID': this.applicationId || ''
                    }
                };
                // If using Node with admin creds, AppCheck-related checks are unnecessary.
                // Note that we send the credentials here even if they aren't admin credentials, which is
                // not a problem.
                // Note that this header is just used to bypass appcheck, and the token should still be sent
                // through the websocket connection once it is established.
                if (this.authToken) options.headers['Authorization'] = `Bearer ${this.authToken}`;
                if (this.appCheckToken) options.headers['X-Firebase-AppCheck'] = this.appCheckToken;
                // Plumb appropriate http_proxy environment variable into faye-websocket if it exists.
                const env = {};
                const proxy = this.connURL.indexOf('wss://') === 0 ? env['HTTPS_PROXY'] || env['https_proxy'] : env['HTTP_PROXY'] || env['http_proxy'];
                if (proxy) options['proxy'] = {
                    origin: proxy
                };
            }
            this.mySock = new $9cf0852385f62d16$var$WebSocketImpl(this.connURL, [], options);
        } catch (e) {
            this.log_('Error instantiating WebSocket.');
            const error = e.message || e.data;
            if (error) this.log_(error);
            this.onClosed_();
            return;
        }
        this.mySock.onopen = ()=>{
            this.log_('Websocket connected.');
            this.everConnected_ = true;
        };
        this.mySock.onclose = ()=>{
            this.log_('Websocket connection was disconnected.');
            this.mySock = null;
            this.onClosed_();
        };
        this.mySock.onmessage = (m)=>{
            this.handleIncomingFrame(m);
        };
        this.mySock.onerror = (e)=>{
            this.log_('WebSocket error.  Closing connection.');
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const error = e.message || e.data;
            if (error) this.log_(error);
            this.onClosed_();
        };
    }
    /**
     * No-op for websockets, we don't need to do anything once the connection is confirmed as open
     */ start() {}
    static forceDisallow() {
        $9cf0852385f62d16$var$WebSocketConnection.forceDisallow_ = true;
    }
    static isAvailable() {
        let isOldAndroid = false;
        if (typeof navigator !== 'undefined' && navigator.userAgent) {
            const oldAndroidRegex = /Android ([0-9]{0,}\.[0-9]{0,})/;
            const oldAndroidMatch = navigator.userAgent.match(oldAndroidRegex);
            if (oldAndroidMatch && oldAndroidMatch.length > 1) {
                if (parseFloat(oldAndroidMatch[1]) < 4.4) isOldAndroid = true;
            }
        }
        return !isOldAndroid && $9cf0852385f62d16$var$WebSocketImpl !== null && !$9cf0852385f62d16$var$WebSocketConnection.forceDisallow_;
    }
    /**
     * Returns true if we previously failed to connect with this transport.
     */ static previouslyFailed() {
        // If our persistent storage is actually only in-memory storage,
        // we default to assuming that it previously failed to be safe.
        return $9cf0852385f62d16$var$PersistentStorage.isInMemoryStorage || $9cf0852385f62d16$var$PersistentStorage.get('previous_websocket_failure') === true;
    }
    markConnectionHealthy() {
        $9cf0852385f62d16$var$PersistentStorage.remove('previous_websocket_failure');
    }
    appendFrame_(data) {
        this.frames.push(data);
        if (this.frames.length === this.totalFrames) {
            const fullMess = this.frames.join('');
            this.frames = null;
            const jsonMess = (0, $3117f6f4eeb4c314$export$c5a53ce6a17cf18d)(fullMess);
            //handle the message
            this.onMessage(jsonMess);
        }
    }
    /**
     * @param frameCount - The number of frames we are expecting from the server
     */ handleNewFrameCount_(frameCount) {
        this.totalFrames = frameCount;
        this.frames = [];
    }
    /**
     * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
     * @returns Any remaining data to be process, or null if there is none
     */ extractFrameCount_(data) {
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(this.frames === null, 'We already have a frame buffer');
        // TODO: The server is only supposed to send up to 9999 frames (i.e. length <= 4), but that isn't being enforced
        // currently.  So allowing larger frame counts (length <= 6).  See https://app.asana.com/0/search/8688598998380/8237608042508
        if (data.length <= 6) {
            const frameCount = Number(data);
            if (!isNaN(frameCount)) {
                this.handleNewFrameCount_(frameCount);
                return null;
            }
        }
        this.handleNewFrameCount_(1);
        return data;
    }
    /**
     * Process a websocket frame that has arrived from the server.
     * @param mess - The frame data
     */ handleIncomingFrame(mess) {
        if (this.mySock === null) return; // Chrome apparently delivers incoming packets even after we .close() the connection sometimes.
        const data = mess['data'];
        this.bytesReceived += data.length;
        this.stats_.incrementCounter('bytes_received', data.length);
        this.resetKeepAlive();
        if (this.frames !== null) // we're buffering
        this.appendFrame_(data);
        else {
            // try to parse out a frame count, otherwise, assume 1 and process it
            const remainingData = this.extractFrameCount_(data);
            if (remainingData !== null) this.appendFrame_(remainingData);
        }
    }
    /**
     * Send a message to the server
     * @param data - The JSON object to transmit
     */ send(data) {
        this.resetKeepAlive();
        const dataStr = (0, $3117f6f4eeb4c314$export$fac44ee5b035f737)(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //We can only fit a certain amount in each websocket frame, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        const dataSegs = $9cf0852385f62d16$var$splitStringBySize(dataStr, $9cf0852385f62d16$var$WEBSOCKET_MAX_FRAME_SIZE);
        //Send the length header
        if (dataSegs.length > 1) this.sendString_(String(dataSegs.length));
        //Send the actual data in segments.
        for(let i = 0; i < dataSegs.length; i++)this.sendString_(dataSegs[i]);
    }
    shutdown_() {
        this.isClosed_ = true;
        if (this.keepaliveTimer) {
            clearInterval(this.keepaliveTimer);
            this.keepaliveTimer = null;
        }
        if (this.mySock) {
            this.mySock.close();
            this.mySock = null;
        }
    }
    onClosed_() {
        if (!this.isClosed_) {
            this.log_('WebSocket is closing itself');
            this.shutdown_();
            // since this is an internal close, trigger the close listener
            if (this.onDisconnect) {
                this.onDisconnect(this.everConnected_);
                this.onDisconnect = null;
            }
        }
    }
    /**
     * External-facing close handler.
     * Close the websocket and kill the connection.
     */ close() {
        if (!this.isClosed_) {
            this.log_('WebSocket is being closed');
            this.shutdown_();
        }
    }
    /**
     * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
     * the last activity.
     */ resetKeepAlive() {
        clearInterval(this.keepaliveTimer);
        this.keepaliveTimer = setInterval(()=>{
            //If there has been no websocket activity for a while, send a no-op
            if (this.mySock) this.sendString_('0');
            this.resetKeepAlive();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor($9cf0852385f62d16$var$WEBSOCKET_KEEPALIVE_INTERVAL));
    }
    /**
     * Send a string over the websocket.
     *
     * @param str - String to send.
     */ sendString_(str) {
        // Firefox seems to sometimes throw exceptions (NS_ERROR_UNEXPECTED) from websocket .send()
        // calls for some unknown reason.  We treat these as an error and disconnect.
        // See https://app.asana.com/0/58926111402292/68021340250410
        try {
            this.mySock.send(str);
        } catch (e) {
            this.log_('Exception thrown from WebSocket.send():', e.message || e.data, 'Closing connection.');
            setTimeout(this.onClosed_.bind(this), 0);
        }
    }
}
/**
 * Number of response before we consider the connection "healthy."
 */ $9cf0852385f62d16$var$WebSocketConnection.responsesRequiredToBeHealthy = 2;
/**
 * Time to wait for the connection te become healthy before giving up.
 */ $9cf0852385f62d16$var$WebSocketConnection.healthyTimeout = 30000;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Currently simplistic, this class manages what transport a Connection should use at various stages of its
 * lifecycle.
 *
 * It starts with longpolling in a browser, and httppolling on node. It then upgrades to websockets if
 * they are available.
 */ class $9cf0852385f62d16$var$TransportManager {
    static get ALL_TRANSPORTS() {
        return [
            $9cf0852385f62d16$var$BrowserPollConnection,
            $9cf0852385f62d16$var$WebSocketConnection
        ];
    }
    /**
     * Returns whether transport has been selected to ensure WebSocketConnection or BrowserPollConnection are not called after
     * TransportManager has already set up transports_
     */ static get IS_TRANSPORT_INITIALIZED() {
        return this.globalTransportInitialized_;
    }
    /**
     * @param repoInfo - Metadata around the namespace we're connecting to
     */ constructor(repoInfo){
        this.initTransports_(repoInfo);
    }
    initTransports_(repoInfo) {
        const isWebSocketsAvailable = $9cf0852385f62d16$var$WebSocketConnection && $9cf0852385f62d16$var$WebSocketConnection['isAvailable']();
        let isSkipPollConnection = isWebSocketsAvailable && !$9cf0852385f62d16$var$WebSocketConnection.previouslyFailed();
        if (repoInfo.webSocketOnly) {
            if (!isWebSocketsAvailable) $9cf0852385f62d16$var$warn("wss:// URL used, but browser isn't known to support websockets.  Trying anyway.");
            isSkipPollConnection = true;
        }
        if (isSkipPollConnection) this.transports_ = [
            $9cf0852385f62d16$var$WebSocketConnection
        ];
        else {
            const transports = this.transports_ = [];
            for (const transport of $9cf0852385f62d16$var$TransportManager.ALL_TRANSPORTS)if (transport && transport['isAvailable']()) transports.push(transport);
            $9cf0852385f62d16$var$TransportManager.globalTransportInitialized_ = true;
        }
    }
    /**
     * @returns The constructor for the initial transport to use
     */ initialTransport() {
        if (this.transports_.length > 0) return this.transports_[0];
        else throw new Error('No transports available');
    }
    /**
     * @returns The constructor for the next transport, or null
     */ upgradeTransport() {
        if (this.transports_.length > 1) return this.transports_[1];
        else return null;
    }
}
// Keeps track of whether the TransportManager has already chosen a transport to use
$9cf0852385f62d16$var$TransportManager.globalTransportInitialized_ = false;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Abort upgrade attempt if it takes longer than 60s.
const $9cf0852385f62d16$var$UPGRADE_TIMEOUT = 60000;
// For some transports (WebSockets), we need to "validate" the transport by exchanging a few requests and responses.
// If we haven't sent enough requests within 5s, we'll start sending noop ping requests.
const $9cf0852385f62d16$var$DELAY_BEFORE_SENDING_EXTRA_REQUESTS = 5000;
// If the initial data sent triggers a lot of bandwidth (i.e. it's a large put or a listen for a large amount of data)
// then we may not be able to exchange our ping/pong requests within the healthy timeout.  So if we reach the timeout
// but we've sent/received enough bytes, we don't cancel the connection.
const $9cf0852385f62d16$var$BYTES_SENT_HEALTHY_OVERRIDE = 10240;
const $9cf0852385f62d16$var$BYTES_RECEIVED_HEALTHY_OVERRIDE = 102400;
const $9cf0852385f62d16$var$MESSAGE_TYPE = 't';
const $9cf0852385f62d16$var$MESSAGE_DATA = 'd';
const $9cf0852385f62d16$var$CONTROL_SHUTDOWN = 's';
const $9cf0852385f62d16$var$CONTROL_RESET = 'r';
const $9cf0852385f62d16$var$CONTROL_ERROR = 'e';
const $9cf0852385f62d16$var$CONTROL_PONG = 'o';
const $9cf0852385f62d16$var$SWITCH_ACK = 'a';
const $9cf0852385f62d16$var$END_TRANSMISSION = 'n';
const $9cf0852385f62d16$var$PING = 'p';
const $9cf0852385f62d16$var$SERVER_HELLO = 'h';
/**
 * Creates a new real-time connection to the server using whichever method works
 * best in the current browser.
 */ class $9cf0852385f62d16$var$Connection {
    /**
     * @param id - an id for this connection
     * @param repoInfo_ - the info for the endpoint to connect to
     * @param applicationId_ - the Firebase App ID for this project
     * @param appCheckToken_ - The App Check Token for this device.
     * @param authToken_ - The auth token for this session.
     * @param onMessage_ - the callback to be triggered when a server-push message arrives
     * @param onReady_ - the callback to be triggered when this connection is ready to send messages.
     * @param onDisconnect_ - the callback to be triggered when a connection was lost
     * @param onKill_ - the callback to be triggered when this connection has permanently shut down.
     * @param lastSessionId - last session id in persistent connection. is used to clean up old session in real-time server
     */ constructor(id, repoInfo_, applicationId_, appCheckToken_, authToken_, onMessage_, onReady_, onDisconnect_, onKill_, lastSessionId){
        this.id = id;
        this.repoInfo_ = repoInfo_;
        this.applicationId_ = applicationId_;
        this.appCheckToken_ = appCheckToken_;
        this.authToken_ = authToken_;
        this.onMessage_ = onMessage_;
        this.onReady_ = onReady_;
        this.onDisconnect_ = onDisconnect_;
        this.onKill_ = onKill_;
        this.lastSessionId = lastSessionId;
        this.connectionCount = 0;
        this.pendingDataMessages = [];
        this.state_ = 0 /* RealtimeState.CONNECTING */ ;
        this.log_ = $9cf0852385f62d16$var$logWrapper('c:' + this.id + ':');
        this.transportManager_ = new $9cf0852385f62d16$var$TransportManager(repoInfo_);
        this.log_('Connection created');
        this.start_();
    }
    /**
     * Starts a connection attempt
     */ start_() {
        const conn = this.transportManager_.initialTransport();
        this.conn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, null, this.lastSessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.primaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
        const onMessageReceived = this.connReceiver_(this.conn_);
        const onConnectionLost = this.disconnReceiver_(this.conn_);
        this.tx_ = this.conn_;
        this.rx_ = this.conn_;
        this.secondaryConn_ = null;
        this.isHealthy_ = false;
        /*
         * Firefox doesn't like when code from one iframe tries to create another iframe by way of the parent frame.
         * This can occur in the case of a redirect, i.e. we guessed wrong on what server to connect to and received a reset.
         * Somehow, setTimeout seems to make this ok. That doesn't make sense from a security perspective, since you should
         * still have the context of your originating frame.
         */ setTimeout(()=>{
            // this.conn_ gets set to null in some of the tests. Check to make sure it still exists before using it
            this.conn_ && this.conn_.open(onMessageReceived, onConnectionLost);
        }, Math.floor(0));
        const healthyTimeoutMS = conn['healthyTimeout'] || 0;
        if (healthyTimeoutMS > 0) this.healthyTimeout_ = $9cf0852385f62d16$var$setTimeoutNonBlocking(()=>{
            this.healthyTimeout_ = null;
            if (!this.isHealthy_) {
                if (this.conn_ && this.conn_.bytesReceived > $9cf0852385f62d16$var$BYTES_RECEIVED_HEALTHY_OVERRIDE) {
                    this.log_('Connection exceeded healthy timeout but has received ' + this.conn_.bytesReceived + ' bytes.  Marking connection healthy.');
                    this.isHealthy_ = true;
                    this.conn_.markConnectionHealthy();
                } else if (this.conn_ && this.conn_.bytesSent > $9cf0852385f62d16$var$BYTES_SENT_HEALTHY_OVERRIDE) this.log_('Connection exceeded healthy timeout but has sent ' + this.conn_.bytesSent + ' bytes.  Leaving connection alive.');
                else {
                    this.log_('Closing unhealthy connection after timeout.');
                    this.close();
                }
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor(healthyTimeoutMS));
    }
    nextTransportId_() {
        return 'c:' + this.id + ':' + this.connectionCount++;
    }
    disconnReceiver_(conn) {
        return (everConnected)=>{
            if (conn === this.conn_) this.onConnectionLost_(everConnected);
            else if (conn === this.secondaryConn_) {
                this.log_('Secondary connection lost.');
                this.onSecondaryConnectionLost_();
            } else this.log_('closing an old connection');
        };
    }
    connReceiver_(conn) {
        return (message)=>{
            if (this.state_ !== 2 /* RealtimeState.DISCONNECTED */ ) {
                if (conn === this.rx_) this.onPrimaryMessageReceived_(message);
                else if (conn === this.secondaryConn_) this.onSecondaryMessageReceived_(message);
                else this.log_('message on old connection');
            }
        };
    }
    /**
     * @param dataMsg - An arbitrary data message to be sent to the server
     */ sendRequest(dataMsg) {
        // wrap in a data message envelope and send it on
        const msg = {
            t: 'd',
            d: dataMsg
        };
        this.sendData_(msg);
    }
    tryCleanupConnection() {
        if (this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_) {
            this.log_('cleaning up and promoting a connection: ' + this.secondaryConn_.connId);
            this.conn_ = this.secondaryConn_;
            this.secondaryConn_ = null;
        // the server will shutdown the old connection
        }
    }
    onSecondaryControl_(controlData) {
        if ($9cf0852385f62d16$var$MESSAGE_TYPE in controlData) {
            const cmd = controlData[$9cf0852385f62d16$var$MESSAGE_TYPE];
            if (cmd === $9cf0852385f62d16$var$SWITCH_ACK) this.upgradeIfSecondaryHealthy_();
            else if (cmd === $9cf0852385f62d16$var$CONTROL_RESET) {
                // Most likely the session wasn't valid. Abandon the switch attempt
                this.log_('Got a reset on secondary, closing it');
                this.secondaryConn_.close();
                // If we were already using this connection for something, than we need to fully close
                if (this.tx_ === this.secondaryConn_ || this.rx_ === this.secondaryConn_) this.close();
            } else if (cmd === $9cf0852385f62d16$var$CONTROL_PONG) {
                this.log_('got pong on secondary.');
                this.secondaryResponsesRequired_--;
                this.upgradeIfSecondaryHealthy_();
            }
        }
    }
    onSecondaryMessageReceived_(parsedData) {
        const layer = $9cf0852385f62d16$var$requireKey('t', parsedData);
        const data = $9cf0852385f62d16$var$requireKey('d', parsedData);
        if (layer === 'c') this.onSecondaryControl_(data);
        else if (layer === 'd') // got a data message, but we're still second connection. Need to buffer it up
        this.pendingDataMessages.push(data);
        else throw new Error('Unknown protocol layer: ' + layer);
    }
    upgradeIfSecondaryHealthy_() {
        if (this.secondaryResponsesRequired_ <= 0) {
            this.log_('Secondary connection is healthy.');
            this.isHealthy_ = true;
            this.secondaryConn_.markConnectionHealthy();
            this.proceedWithUpgrade_();
        } else {
            // Send a ping to make sure the connection is healthy.
            this.log_('sending ping on secondary.');
            this.secondaryConn_.send({
                t: 'c',
                d: {
                    t: $9cf0852385f62d16$var$PING,
                    d: {}
                }
            });
        }
    }
    proceedWithUpgrade_() {
        // tell this connection to consider itself open
        this.secondaryConn_.start();
        // send ack
        this.log_('sending client ack on secondary');
        this.secondaryConn_.send({
            t: 'c',
            d: {
                t: $9cf0852385f62d16$var$SWITCH_ACK,
                d: {}
            }
        });
        // send end packet on primary transport, switch to sending on this one
        // can receive on this one, buffer responses until end received on primary transport
        this.log_('Ending transmission on primary');
        this.conn_.send({
            t: 'c',
            d: {
                t: $9cf0852385f62d16$var$END_TRANSMISSION,
                d: {}
            }
        });
        this.tx_ = this.secondaryConn_;
        this.tryCleanupConnection();
    }
    onPrimaryMessageReceived_(parsedData) {
        // Must refer to parsedData properties in quotes, so closure doesn't touch them.
        const layer = $9cf0852385f62d16$var$requireKey('t', parsedData);
        const data = $9cf0852385f62d16$var$requireKey('d', parsedData);
        if (layer === 'c') this.onControl_(data);
        else if (layer === 'd') this.onDataMessage_(data);
    }
    onDataMessage_(message) {
        this.onPrimaryResponse_();
        // We don't do anything with data messages, just kick them up a level
        this.onMessage_(message);
    }
    onPrimaryResponse_() {
        if (!this.isHealthy_) {
            this.primaryResponsesRequired_--;
            if (this.primaryResponsesRequired_ <= 0) {
                this.log_('Primary connection is healthy.');
                this.isHealthy_ = true;
                this.conn_.markConnectionHealthy();
            }
        }
    }
    onControl_(controlData) {
        const cmd = $9cf0852385f62d16$var$requireKey($9cf0852385f62d16$var$MESSAGE_TYPE, controlData);
        if ($9cf0852385f62d16$var$MESSAGE_DATA in controlData) {
            const payload = controlData[$9cf0852385f62d16$var$MESSAGE_DATA];
            if (cmd === $9cf0852385f62d16$var$SERVER_HELLO) {
                const handshakePayload = {
                    ...payload
                };
                if (this.repoInfo_.isUsingEmulator) // Upon connecting, the emulator will pass the hostname that it's aware of, but we prefer the user's set hostname via `connectDatabaseEmulator` over what the emulator passes.
                handshakePayload.h = this.repoInfo_.host;
                this.onHandshake_(handshakePayload);
            } else if (cmd === $9cf0852385f62d16$var$END_TRANSMISSION) {
                this.log_('recvd end transmission on primary');
                this.rx_ = this.secondaryConn_;
                for(let i = 0; i < this.pendingDataMessages.length; ++i)this.onDataMessage_(this.pendingDataMessages[i]);
                this.pendingDataMessages = [];
                this.tryCleanupConnection();
            } else if (cmd === $9cf0852385f62d16$var$CONTROL_SHUTDOWN) // This was previously the 'onKill' callback passed to the lower-level connection
            // payload in this case is the reason for the shutdown. Generally a human-readable error
            this.onConnectionShutdown_(payload);
            else if (cmd === $9cf0852385f62d16$var$CONTROL_RESET) // payload in this case is the host we should contact
            this.onReset_(payload);
            else if (cmd === $9cf0852385f62d16$var$CONTROL_ERROR) $9cf0852385f62d16$var$error('Server Error: ' + payload);
            else if (cmd === $9cf0852385f62d16$var$CONTROL_PONG) {
                this.log_('got pong on primary.');
                this.onPrimaryResponse_();
                this.sendPingOnPrimaryIfNecessary_();
            } else $9cf0852385f62d16$var$error('Unknown control packet command: ' + cmd);
        }
    }
    /**
     * @param handshake - The handshake data returned from the server
     */ onHandshake_(handshake) {
        const timestamp = handshake.ts;
        const version = handshake.v;
        const host = handshake.h;
        this.sessionId = handshake.s;
        this.repoInfo_.host = host;
        // if we've already closed the connection, then don't bother trying to progress further
        if (this.state_ === 0 /* RealtimeState.CONNECTING */ ) {
            this.conn_.start();
            this.onConnectionEstablished_(this.conn_, timestamp);
            if ($9cf0852385f62d16$var$PROTOCOL_VERSION !== version) $9cf0852385f62d16$var$warn('Protocol version mismatch detected');
            // TODO: do we want to upgrade? when? maybe a delay?
            this.tryStartUpgrade_();
        }
    }
    tryStartUpgrade_() {
        const conn = this.transportManager_.upgradeTransport();
        if (conn) this.startUpgrade_(conn);
    }
    startUpgrade_(conn) {
        this.secondaryConn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, this.sessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.secondaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
        const onMessage = this.connReceiver_(this.secondaryConn_);
        const onDisconnect = this.disconnReceiver_(this.secondaryConn_);
        this.secondaryConn_.open(onMessage, onDisconnect);
        // If we haven't successfully upgraded after UPGRADE_TIMEOUT, give up and kill the secondary.
        $9cf0852385f62d16$var$setTimeoutNonBlocking(()=>{
            if (this.secondaryConn_) {
                this.log_('Timed out trying to upgrade.');
                this.secondaryConn_.close();
            }
        }, Math.floor($9cf0852385f62d16$var$UPGRADE_TIMEOUT));
    }
    onReset_(host) {
        this.log_('Reset packet received.  New host: ' + host);
        this.repoInfo_.host = host;
        // TODO: if we're already "connected", we need to trigger a disconnect at the next layer up.
        // We don't currently support resets after the connection has already been established
        if (this.state_ === 1 /* RealtimeState.CONNECTED */ ) this.close();
        else {
            // Close whatever connections we have open and start again.
            this.closeConnections_();
            this.start_();
        }
    }
    onConnectionEstablished_(conn, timestamp) {
        this.log_('Realtime connection established.');
        this.conn_ = conn;
        this.state_ = 1 /* RealtimeState.CONNECTED */ ;
        if (this.onReady_) {
            this.onReady_(timestamp, this.sessionId);
            this.onReady_ = null;
        }
        // If after 5 seconds we haven't sent enough requests to the server to get the connection healthy,
        // send some pings.
        if (this.primaryResponsesRequired_ === 0) {
            this.log_('Primary connection is healthy.');
            this.isHealthy_ = true;
        } else $9cf0852385f62d16$var$setTimeoutNonBlocking(()=>{
            this.sendPingOnPrimaryIfNecessary_();
        }, Math.floor($9cf0852385f62d16$var$DELAY_BEFORE_SENDING_EXTRA_REQUESTS));
    }
    sendPingOnPrimaryIfNecessary_() {
        // If the connection isn't considered healthy yet, we'll send a noop ping packet request.
        if (!this.isHealthy_ && this.state_ === 1 /* RealtimeState.CONNECTED */ ) {
            this.log_('sending ping on primary.');
            this.sendData_({
                t: 'c',
                d: {
                    t: $9cf0852385f62d16$var$PING,
                    d: {}
                }
            });
        }
    }
    onSecondaryConnectionLost_() {
        const conn = this.secondaryConn_;
        this.secondaryConn_ = null;
        if (this.tx_ === conn || this.rx_ === conn) // we are relying on this connection already in some capacity. Therefore, a failure is real
        this.close();
    }
    /**
     * @param everConnected - Whether or not the connection ever reached a server. Used to determine if
     * we should flush the host cache
     */ onConnectionLost_(everConnected) {
        this.conn_ = null;
        // NOTE: IF you're seeing a Firefox error for this line, I think it might be because it's getting
        // called on window close and RealtimeState.CONNECTING is no longer defined.  Just a guess.
        if (!everConnected && this.state_ === 0 /* RealtimeState.CONNECTING */ ) {
            this.log_('Realtime connection failed.');
            // Since we failed to connect at all, clear any cached entry for this namespace in case the machine went away
            if (this.repoInfo_.isCacheableHost()) {
                $9cf0852385f62d16$var$PersistentStorage.remove('host:' + this.repoInfo_.host);
                // reset the internal host to what we would show the user, i.e. <ns>.firebaseio.com
                this.repoInfo_.internalHost = this.repoInfo_.host;
            }
        } else if (this.state_ === 1 /* RealtimeState.CONNECTED */ ) this.log_('Realtime connection lost.');
        this.close();
    }
    onConnectionShutdown_(reason) {
        this.log_('Connection shutdown command received. Shutting down...');
        if (this.onKill_) {
            this.onKill_(reason);
            this.onKill_ = null;
        }
        // We intentionally don't want to fire onDisconnect (kill is a different case),
        // so clear the callback.
        this.onDisconnect_ = null;
        this.close();
    }
    sendData_(data) {
        if (this.state_ !== 1 /* RealtimeState.CONNECTED */ ) throw 'Connection is not connected';
        else this.tx_.send(data);
    }
    /**
     * Cleans up this connection, calling the appropriate callbacks
     */ close() {
        if (this.state_ !== 2 /* RealtimeState.DISCONNECTED */ ) {
            this.log_('Closing realtime connection.');
            this.state_ = 2 /* RealtimeState.DISCONNECTED */ ;
            this.closeConnections_();
            if (this.onDisconnect_) {
                this.onDisconnect_();
                this.onDisconnect_ = null;
            }
        }
    }
    closeConnections_() {
        this.log_('Shutting down all connections');
        if (this.conn_) {
            this.conn_.close();
            this.conn_ = null;
        }
        if (this.secondaryConn_) {
            this.secondaryConn_.close();
            this.secondaryConn_ = null;
        }
        if (this.healthyTimeout_) {
            clearTimeout(this.healthyTimeout_);
            this.healthyTimeout_ = null;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface defining the set of actions that can be performed against the Firebase server
 * (basically corresponds to our wire protocol).
 *
 * @interface
 */ class $9cf0852385f62d16$var$ServerActions {
    put(pathString, data, onComplete, hash) {}
    merge(pathString, data, onComplete, hash) {}
    /**
     * Refreshes the auth token for the current connection.
     * @param token - The authentication token
     */ refreshAuthToken(token) {}
    /**
     * Refreshes the app check token for the current connection.
     * @param token The app check token
     */ refreshAppCheckToken(token) {}
    onDisconnectPut(pathString, data, onComplete) {}
    onDisconnectMerge(pathString, data, onComplete) {}
    onDisconnectCancel(pathString, onComplete) {}
    reportStats(stats) {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Base class to be used if you want to emit events. Call the constructor with
 * the set of allowed event names.
 */ class $9cf0852385f62d16$var$EventEmitter {
    constructor(allowedEvents_){
        this.allowedEvents_ = allowedEvents_;
        this.listeners_ = {};
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(Array.isArray(allowedEvents_) && allowedEvents_.length > 0, 'Requires a non-empty array');
    }
    /**
     * To be called by derived classes to trigger events.
     */ trigger(eventType, ...varArgs) {
        if (Array.isArray(this.listeners_[eventType])) {
            // Clone the list, since callbacks could add/remove listeners.
            const listeners = [
                ...this.listeners_[eventType]
            ];
            for(let i = 0; i < listeners.length; i++)listeners[i].callback.apply(listeners[i].context, varArgs);
        }
    }
    on(eventType, callback, context) {
        this.validateEventType_(eventType);
        this.listeners_[eventType] = this.listeners_[eventType] || [];
        this.listeners_[eventType].push({
            callback: callback,
            context: context
        });
        const eventData = this.getInitialEvent(eventType);
        if (eventData) callback.apply(context, eventData);
    }
    off(eventType, callback, context) {
        this.validateEventType_(eventType);
        const listeners = this.listeners_[eventType] || [];
        for(let i = 0; i < listeners.length; i++)if (listeners[i].callback === callback && (!context || context === listeners[i].context)) {
            listeners.splice(i, 1);
            return;
        }
    }
    validateEventType_(eventType) {
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(this.allowedEvents_.find((et)=>{
            return et === eventType;
        }), 'Unknown event: ' + eventType);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Monitors online state (as reported by window.online/offline events).
 *
 * The expectation is that this could have many false positives (thinks we are online
 * when we're not), but no false negatives.  So we can safely use it to determine when
 * we definitely cannot reach the internet.
 */ class $9cf0852385f62d16$var$OnlineMonitor extends $9cf0852385f62d16$var$EventEmitter {
    static getInstance() {
        return new $9cf0852385f62d16$var$OnlineMonitor();
    }
    constructor(){
        super([
            'online'
        ]);
        this.online_ = true;
        // We've had repeated complaints that Cordova apps can get stuck "offline", e.g.
        // https://forum.ionicframework.com/t/firebase-connection-is-lost-and-never-come-back/43810
        // It would seem that the 'online' event does not always fire consistently. So we disable it
        // for Cordova.
        if (typeof window !== 'undefined' && typeof window.addEventListener !== 'undefined' && !(0, $3117f6f4eeb4c314$export$872f8323f01d7ae0)()) {
            window.addEventListener('online', ()=>{
                if (!this.online_) {
                    this.online_ = true;
                    this.trigger('online', true);
                }
            }, false);
            window.addEventListener('offline', ()=>{
                if (this.online_) {
                    this.online_ = false;
                    this.trigger('online', false);
                }
            }, false);
        }
    }
    getInitialEvent(eventType) {
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(eventType === 'online', 'Unknown event type: ' + eventType);
        return [
            this.online_
        ];
    }
    currentlyOnline() {
        return this.online_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Maximum key depth. */ const $9cf0852385f62d16$var$MAX_PATH_DEPTH = 32;
/** Maximum number of (UTF8) bytes in a Firebase path. */ const $9cf0852385f62d16$var$MAX_PATH_LENGTH_BYTES = 768;
/**
 * An immutable object representing a parsed path.  It's immutable so that you
 * can pass them around to other functions without worrying about them changing
 * it.
 */ class $9cf0852385f62d16$var$Path {
    /**
     * @param pathOrString - Path string to parse, or another path, or the raw
     * tokens array
     */ constructor(pathOrString, pieceNum){
        if (pieceNum === void 0) {
            this.pieces_ = pathOrString.split('/');
            // Remove empty pieces.
            let copyTo = 0;
            for(let i = 0; i < this.pieces_.length; i++)if (this.pieces_[i].length > 0) {
                this.pieces_[copyTo] = this.pieces_[i];
                copyTo++;
            }
            this.pieces_.length = copyTo;
            this.pieceNum_ = 0;
        } else {
            this.pieces_ = pathOrString;
            this.pieceNum_ = pieceNum;
        }
    }
    toString() {
        let pathString = '';
        for(let i = this.pieceNum_; i < this.pieces_.length; i++)if (this.pieces_[i] !== '') pathString += '/' + this.pieces_[i];
        return pathString || '/';
    }
}
function $9cf0852385f62d16$var$newEmptyPath() {
    return new $9cf0852385f62d16$var$Path('');
}
function $9cf0852385f62d16$var$pathGetFront(path) {
    if (path.pieceNum_ >= path.pieces_.length) return null;
    return path.pieces_[path.pieceNum_];
}
/**
 * @returns The number of segments in this path
 */ function $9cf0852385f62d16$var$pathGetLength(path) {
    return path.pieces_.length - path.pieceNum_;
}
function $9cf0852385f62d16$var$pathPopFront(path) {
    let pieceNum = path.pieceNum_;
    if (pieceNum < path.pieces_.length) pieceNum++;
    return new $9cf0852385f62d16$var$Path(path.pieces_, pieceNum);
}
function $9cf0852385f62d16$var$pathGetBack(path) {
    if (path.pieceNum_ < path.pieces_.length) return path.pieces_[path.pieces_.length - 1];
    return null;
}
function $9cf0852385f62d16$var$pathToUrlEncodedString(path) {
    let pathString = '';
    for(let i = path.pieceNum_; i < path.pieces_.length; i++)if (path.pieces_[i] !== '') pathString += '/' + encodeURIComponent(String(path.pieces_[i]));
    return pathString || '/';
}
/**
 * Shallow copy of the parts of the path.
 *
 */ function $9cf0852385f62d16$var$pathSlice(path, begin = 0) {
    return path.pieces_.slice(path.pieceNum_ + begin);
}
function $9cf0852385f62d16$var$pathParent(path) {
    if (path.pieceNum_ >= path.pieces_.length) return null;
    const pieces = [];
    for(let i = path.pieceNum_; i < path.pieces_.length - 1; i++)pieces.push(path.pieces_[i]);
    return new $9cf0852385f62d16$var$Path(pieces, 0);
}
function $9cf0852385f62d16$var$pathChild(path, childPathObj) {
    const pieces = [];
    for(let i = path.pieceNum_; i < path.pieces_.length; i++)pieces.push(path.pieces_[i]);
    if (childPathObj instanceof $9cf0852385f62d16$var$Path) for(let i = childPathObj.pieceNum_; i < childPathObj.pieces_.length; i++)pieces.push(childPathObj.pieces_[i]);
    else {
        const childPieces = childPathObj.split('/');
        for(let i = 0; i < childPieces.length; i++)if (childPieces[i].length > 0) pieces.push(childPieces[i]);
    }
    return new $9cf0852385f62d16$var$Path(pieces, 0);
}
/**
 * @returns True if there are no segments in this path
 */ function $9cf0852385f62d16$var$pathIsEmpty(path) {
    return path.pieceNum_ >= path.pieces_.length;
}
/**
 * @returns The path from outerPath to innerPath
 */ function $9cf0852385f62d16$var$newRelativePath(outerPath, innerPath) {
    const outer = $9cf0852385f62d16$var$pathGetFront(outerPath), inner = $9cf0852385f62d16$var$pathGetFront(innerPath);
    if (outer === null) return innerPath;
    else if (outer === inner) return $9cf0852385f62d16$var$newRelativePath($9cf0852385f62d16$var$pathPopFront(outerPath), $9cf0852385f62d16$var$pathPopFront(innerPath));
    else throw new Error('INTERNAL ERROR: innerPath (' + innerPath + ') is not within ' + 'outerPath (' + outerPath + ')');
}
/**
 * @returns -1, 0, 1 if left is less, equal, or greater than the right.
 */ function $9cf0852385f62d16$var$pathCompare(left, right) {
    const leftKeys = $9cf0852385f62d16$var$pathSlice(left, 0);
    const rightKeys = $9cf0852385f62d16$var$pathSlice(right, 0);
    for(let i = 0; i < leftKeys.length && i < rightKeys.length; i++){
        const cmp = $9cf0852385f62d16$var$nameCompare(leftKeys[i], rightKeys[i]);
        if (cmp !== 0) return cmp;
    }
    if (leftKeys.length === rightKeys.length) return 0;
    return leftKeys.length < rightKeys.length ? -1 : 1;
}
/**
 * @returns true if paths are the same.
 */ function $9cf0852385f62d16$var$pathEquals(path, other) {
    if ($9cf0852385f62d16$var$pathGetLength(path) !== $9cf0852385f62d16$var$pathGetLength(other)) return false;
    for(let i = path.pieceNum_, j = other.pieceNum_; i <= path.pieces_.length; i++, j++){
        if (path.pieces_[i] !== other.pieces_[j]) return false;
    }
    return true;
}
/**
 * @returns True if this path is a parent of (or the same as) other
 */ function $9cf0852385f62d16$var$pathContains(path, other) {
    let i = path.pieceNum_;
    let j = other.pieceNum_;
    if ($9cf0852385f62d16$var$pathGetLength(path) > $9cf0852385f62d16$var$pathGetLength(other)) return false;
    while(i < path.pieces_.length){
        if (path.pieces_[i] !== other.pieces_[j]) return false;
        ++i;
        ++j;
    }
    return true;
}
/**
 * Dynamic (mutable) path used to count path lengths.
 *
 * This class is used to efficiently check paths for valid
 * length (in UTF8 bytes) and depth (used in path validation).
 *
 * Throws Error exception if path is ever invalid.
 *
 * The definition of a path always begins with '/'.
 */ class $9cf0852385f62d16$var$ValidationPath {
    /**
     * @param path - Initial Path.
     * @param errorPrefix_ - Prefix for any error messages.
     */ constructor(path, errorPrefix_){
        this.errorPrefix_ = errorPrefix_;
        this.parts_ = $9cf0852385f62d16$var$pathSlice(path, 0);
        /** Initialize to number of '/' chars needed in path. */ this.byteLength_ = Math.max(1, this.parts_.length);
        for(let i = 0; i < this.parts_.length; i++)this.byteLength_ += (0, $3117f6f4eeb4c314$export$9536dc0a75b20bf9)(this.parts_[i]);
        $9cf0852385f62d16$var$validationPathCheckValid(this);
    }
}
function $9cf0852385f62d16$var$validationPathPush(validationPath, child) {
    // Count the needed '/'
    if (validationPath.parts_.length > 0) validationPath.byteLength_ += 1;
    validationPath.parts_.push(child);
    validationPath.byteLength_ += (0, $3117f6f4eeb4c314$export$9536dc0a75b20bf9)(child);
    $9cf0852385f62d16$var$validationPathCheckValid(validationPath);
}
function $9cf0852385f62d16$var$validationPathPop(validationPath) {
    const last = validationPath.parts_.pop();
    validationPath.byteLength_ -= (0, $3117f6f4eeb4c314$export$9536dc0a75b20bf9)(last);
    // Un-count the previous '/'
    if (validationPath.parts_.length > 0) validationPath.byteLength_ -= 1;
}
function $9cf0852385f62d16$var$validationPathCheckValid(validationPath) {
    if (validationPath.byteLength_ > $9cf0852385f62d16$var$MAX_PATH_LENGTH_BYTES) throw new Error(validationPath.errorPrefix_ + 'has a key path longer than ' + $9cf0852385f62d16$var$MAX_PATH_LENGTH_BYTES + ' bytes (' + validationPath.byteLength_ + ').');
    if (validationPath.parts_.length > $9cf0852385f62d16$var$MAX_PATH_DEPTH) throw new Error(validationPath.errorPrefix_ + 'path specified exceeds the maximum depth that can be written (' + $9cf0852385f62d16$var$MAX_PATH_DEPTH + ') or object contains a cycle ' + $9cf0852385f62d16$var$validationPathToErrorString(validationPath));
}
/**
 * String for use in error messages - uses '.' notation for path.
 */ function $9cf0852385f62d16$var$validationPathToErrorString(validationPath) {
    if (validationPath.parts_.length === 0) return '';
    return "in property '" + validationPath.parts_.join('.') + "'";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9cf0852385f62d16$var$VisibilityMonitor extends $9cf0852385f62d16$var$EventEmitter {
    static getInstance() {
        return new $9cf0852385f62d16$var$VisibilityMonitor();
    }
    constructor(){
        super([
            'visible'
        ]);
        let hidden;
        let visibilityChange;
        if (typeof document !== 'undefined' && typeof document.addEventListener !== 'undefined') {
            if (typeof document['hidden'] !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                visibilityChange = 'visibilitychange';
                hidden = 'hidden';
            } else if (typeof document['mozHidden'] !== 'undefined') {
                visibilityChange = 'mozvisibilitychange';
                hidden = 'mozHidden';
            } else if (typeof document['msHidden'] !== 'undefined') {
                visibilityChange = 'msvisibilitychange';
                hidden = 'msHidden';
            } else if (typeof document['webkitHidden'] !== 'undefined') {
                visibilityChange = 'webkitvisibilitychange';
                hidden = 'webkitHidden';
            }
        }
        // Initially, we always assume we are visible. This ensures that in browsers
        // without page visibility support or in cases where we are never visible
        // (e.g. chrome extension), we act as if we are visible, i.e. don't delay
        // reconnects
        this.visible_ = true;
        if (visibilityChange) document.addEventListener(visibilityChange, ()=>{
            const visible = !document[hidden];
            if (visible !== this.visible_) {
                this.visible_ = visible;
                this.trigger('visible', visible);
            }
        }, false);
    }
    getInitialEvent(eventType) {
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(eventType === 'visible', 'Unknown event type: ' + eventType);
        return [
            this.visible_
        ];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9cf0852385f62d16$var$RECONNECT_MIN_DELAY = 1000;
const $9cf0852385f62d16$var$RECONNECT_MAX_DELAY_DEFAULT = 300000; // 5 minutes in milliseconds (Case: 1858)
const $9cf0852385f62d16$var$RECONNECT_MAX_DELAY_FOR_ADMINS = 30000; // 30 seconds for admin clients (likely to be a backend server)
const $9cf0852385f62d16$var$RECONNECT_DELAY_MULTIPLIER = 1.3;
const $9cf0852385f62d16$var$RECONNECT_DELAY_RESET_TIMEOUT = 30000; // Reset delay back to MIN_DELAY after being connected for 30sec.
const $9cf0852385f62d16$var$SERVER_KILL_INTERRUPT_REASON = 'server_kill';
// If auth fails repeatedly, we'll assume something is wrong and log a warning / back off.
const $9cf0852385f62d16$var$INVALID_TOKEN_THRESHOLD = 3;
/**
 * Firebase connection.  Abstracts wire protocol and handles reconnecting.
 *
 * NOTE: All JSON objects sent to the realtime connection must have property names enclosed
 * in quotes to make sure the closure compiler does not minify them.
 */ class $9cf0852385f62d16$var$PersistentConnection extends $9cf0852385f62d16$var$ServerActions {
    /**
     * @param repoInfo_ - Data about the namespace we are connecting to
     * @param applicationId_ - The Firebase App ID for this project
     * @param onDataUpdate_ - A callback for new data from the server
     */ constructor(repoInfo_, applicationId_, onDataUpdate_, onConnectStatus_, onServerInfoUpdate_, authTokenProvider_, appCheckTokenProvider_, authOverride_){
        super();
        this.repoInfo_ = repoInfo_;
        this.applicationId_ = applicationId_;
        this.onDataUpdate_ = onDataUpdate_;
        this.onConnectStatus_ = onConnectStatus_;
        this.onServerInfoUpdate_ = onServerInfoUpdate_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckTokenProvider_ = appCheckTokenProvider_;
        this.authOverride_ = authOverride_;
        // Used for diagnostic logging.
        this.id = $9cf0852385f62d16$var$PersistentConnection.nextPersistentConnectionId_++;
        this.log_ = $9cf0852385f62d16$var$logWrapper('p:' + this.id + ':');
        this.interruptReasons_ = {};
        this.listens = new Map();
        this.outstandingPuts_ = [];
        this.outstandingGets_ = [];
        this.outstandingPutCount_ = 0;
        this.outstandingGetCount_ = 0;
        this.onDisconnectRequestQueue_ = [];
        this.connected_ = false;
        this.reconnectDelay_ = $9cf0852385f62d16$var$RECONNECT_MIN_DELAY;
        this.maxReconnectDelay_ = $9cf0852385f62d16$var$RECONNECT_MAX_DELAY_DEFAULT;
        this.securityDebugCallback_ = null;
        this.lastSessionId = null;
        this.establishConnectionTimer_ = null;
        this.visible_ = false;
        // Before we get connected, we keep a queue of pending messages to send.
        this.requestCBHash_ = {};
        this.requestNumber_ = 0;
        this.realtime_ = null;
        this.authToken_ = null;
        this.appCheckToken_ = null;
        this.forceTokenRefresh_ = false;
        this.invalidAuthTokenCount_ = 0;
        this.invalidAppCheckTokenCount_ = 0;
        this.firstConnection_ = true;
        this.lastConnectionAttemptTime_ = null;
        this.lastConnectionEstablishedTime_ = null;
        if (authOverride_ && !(0, $3117f6f4eeb4c314$export$5d1d834fbbf8bab7)()) throw new Error('Auth override specified in options, but not supported on non Node.js platforms');
        $9cf0852385f62d16$var$VisibilityMonitor.getInstance().on('visible', this.onVisible_, this);
        if (repoInfo_.host.indexOf('fblocal') === -1) $9cf0852385f62d16$var$OnlineMonitor.getInstance().on('online', this.onOnline_, this);
    }
    sendRequest(action, body, onResponse) {
        const curReqNum = ++this.requestNumber_;
        const msg = {
            r: curReqNum,
            a: action,
            b: body
        };
        this.log_((0, $3117f6f4eeb4c314$export$fac44ee5b035f737)(msg));
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(this.connected_, "sendRequest call when we're not connected not allowed.");
        this.realtime_.sendRequest(msg);
        if (onResponse) this.requestCBHash_[curReqNum] = onResponse;
    }
    get(query) {
        this.initConnection_();
        const deferred = new (0, $3117f6f4eeb4c314$export$85f6557964517f1a)();
        const request = {
            p: query._path.toString(),
            q: query._queryObject
        };
        const outstandingGet = {
            action: 'g',
            request: request,
            onComplete: (message)=>{
                const payload = message['d'];
                if (message['s'] === 'ok') deferred.resolve(payload);
                else deferred.reject(payload);
            }
        };
        this.outstandingGets_.push(outstandingGet);
        this.outstandingGetCount_++;
        const index = this.outstandingGets_.length - 1;
        if (this.connected_) this.sendGet_(index);
        return deferred.promise;
    }
    listen(query, currentHashFn, tag, onComplete) {
        this.initConnection_();
        const queryId = query._queryIdentifier;
        const pathString = query._path.toString();
        this.log_('Listen called for ' + pathString + ' ' + queryId);
        if (!this.listens.has(pathString)) this.listens.set(pathString, new Map());
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(query._queryParams.isDefault() || !query._queryParams.loadsAllData(), 'listen() called for non-default but complete query');
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(!this.listens.get(pathString).has(queryId), `listen() called twice for same path/queryId.`);
        const listenSpec = {
            onComplete: onComplete,
            hashFn: currentHashFn,
            query: query,
            tag: tag
        };
        this.listens.get(pathString).set(queryId, listenSpec);
        if (this.connected_) this.sendListen_(listenSpec);
    }
    sendGet_(index) {
        const get = this.outstandingGets_[index];
        this.sendRequest('g', get.request, (message)=>{
            delete this.outstandingGets_[index];
            this.outstandingGetCount_--;
            if (this.outstandingGetCount_ === 0) this.outstandingGets_ = [];
            if (get.onComplete) get.onComplete(message);
        });
    }
    sendListen_(listenSpec) {
        const query = listenSpec.query;
        const pathString = query._path.toString();
        const queryId = query._queryIdentifier;
        this.log_('Listen on ' + pathString + ' for ' + queryId);
        const req = {
            p: pathString
        };
        const action = 'q';
        // Only bother to send query if it's non-default.
        if (listenSpec.tag) {
            req['q'] = query._queryObject;
            req['t'] = listenSpec.tag;
        }
        req[/*hash*/ 'h'] = listenSpec.hashFn();
        this.sendRequest(action, req, (message)=>{
            const payload = message[/*data*/ 'd'];
            const status = message[/*status*/ 's'];
            // print warnings in any case...
            $9cf0852385f62d16$var$PersistentConnection.warnOnListenWarnings_(payload, query);
            const currentListenSpec = this.listens.get(pathString) && this.listens.get(pathString).get(queryId);
            // only trigger actions if the listen hasn't been removed and readded
            if (currentListenSpec === listenSpec) {
                this.log_('listen response', message);
                if (status !== 'ok') this.removeListen_(pathString, queryId);
                if (listenSpec.onComplete) listenSpec.onComplete(status, payload);
            }
        });
    }
    static warnOnListenWarnings_(payload, query) {
        if (payload && typeof payload === 'object' && (0, $3117f6f4eeb4c314$export$2344b14b097df817)(payload, 'w')) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const warnings = (0, $3117f6f4eeb4c314$export$e51ae4db7b428f67)(payload, 'w');
            if (Array.isArray(warnings) && ~warnings.indexOf('no_index')) {
                const indexSpec = '".indexOn": "' + query._queryParams.getIndex().toString() + '"';
                const indexPath = query._path.toString();
                $9cf0852385f62d16$var$warn(`Using an unspecified index. Your data will be downloaded and ` + `filtered on the client. Consider adding ${indexSpec} at ` + `${indexPath} to your security rules for better performance.`);
            }
        }
    }
    refreshAuthToken(token) {
        this.authToken_ = token;
        this.log_('Auth token refreshed');
        if (this.authToken_) this.tryAuth();
        else //If we're connected we want to let the server know to unauthenticate us. If we're not connected, simply delete
        //the credential so we dont become authenticated next time we connect.
        if (this.connected_) this.sendRequest('unauth', {}, ()=>{});
        this.reduceReconnectDelayIfAdminCredential_(token);
    }
    reduceReconnectDelayIfAdminCredential_(credential) {
        // NOTE: This isn't intended to be bulletproof (a malicious developer can always just modify the client).
        // Additionally, we don't bother resetting the max delay back to the default if auth fails / expires.
        const isFirebaseSecret = credential && credential.length === 40;
        if (isFirebaseSecret || (0, $3117f6f4eeb4c314$export$fc970ed23da99565)(credential)) {
            this.log_('Admin auth credential detected.  Reducing max reconnect time.');
            this.maxReconnectDelay_ = $9cf0852385f62d16$var$RECONNECT_MAX_DELAY_FOR_ADMINS;
        }
    }
    refreshAppCheckToken(token) {
        this.appCheckToken_ = token;
        this.log_('App check token refreshed');
        if (this.appCheckToken_) this.tryAppCheck();
        else //If we're connected we want to let the server know to unauthenticate us.
        //If we're not connected, simply delete the credential so we dont become
        // authenticated next time we connect.
        if (this.connected_) this.sendRequest('unappeck', {}, ()=>{});
    }
    /**
     * Attempts to authenticate with the given credentials. If the authentication attempt fails, it's triggered like
     * a auth revoked (the connection is closed).
     */ tryAuth() {
        if (this.connected_ && this.authToken_) {
            const token = this.authToken_;
            const authMethod = (0, $3117f6f4eeb4c314$export$9565ca3d387f8aa0)(token) ? 'auth' : 'gauth';
            const requestData = {
                cred: token
            };
            if (this.authOverride_ === null) requestData['noauth'] = true;
            else if (typeof this.authOverride_ === 'object') requestData['authvar'] = this.authOverride_;
            this.sendRequest(authMethod, requestData, (res)=>{
                const status = res[/*status*/ 's'];
                const data = res[/*data*/ 'd'] || 'error';
                if (this.authToken_ === token) {
                    if (status === 'ok') this.invalidAuthTokenCount_ = 0;
                    else // Triggers reconnect and force refresh for auth token
                    this.onAuthRevoked_(status, data);
                }
            });
        }
    }
    /**
     * Attempts to authenticate with the given token. If the authentication
     * attempt fails, it's triggered like the token was revoked (the connection is
     * closed).
     */ tryAppCheck() {
        if (this.connected_ && this.appCheckToken_) this.sendRequest('appcheck', {
            'token': this.appCheckToken_
        }, (res)=>{
            const status = res[/*status*/ 's'];
            const data = res[/*data*/ 'd'] || 'error';
            if (status === 'ok') this.invalidAppCheckTokenCount_ = 0;
            else this.onAppCheckRevoked_(status, data);
        });
    }
    /**
     * @inheritDoc
     */ unlisten(query, tag) {
        const pathString = query._path.toString();
        const queryId = query._queryIdentifier;
        this.log_('Unlisten called for ' + pathString + ' ' + queryId);
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(query._queryParams.isDefault() || !query._queryParams.loadsAllData(), 'unlisten() called for non-default but complete query');
        const listen = this.removeListen_(pathString, queryId);
        if (listen && this.connected_) this.sendUnlisten_(pathString, queryId, query._queryObject, tag);
    }
    sendUnlisten_(pathString, queryId, queryObj, tag) {
        this.log_('Unlisten on ' + pathString + ' for ' + queryId);
        const req = {
            p: pathString
        };
        const action = 'n';
        // Only bother sending queryId if it's non-default.
        if (tag) {
            req['q'] = queryObj;
            req['t'] = tag;
        }
        this.sendRequest(action, req);
    }
    onDisconnectPut(pathString, data, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_('o', pathString, data, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: 'o',
            data: data,
            onComplete: onComplete
        });
    }
    onDisconnectMerge(pathString, data, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_('om', pathString, data, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: 'om',
            data: data,
            onComplete: onComplete
        });
    }
    onDisconnectCancel(pathString, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_('oc', pathString, null, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: 'oc',
            data: null,
            onComplete: onComplete
        });
    }
    sendOnDisconnect_(action, pathString, data, onComplete) {
        const request = {
            p: pathString,
            /*data*/ d: data
        };
        this.log_('onDisconnect ' + action, request);
        this.sendRequest(action, request, (response)=>{
            if (onComplete) setTimeout(()=>{
                onComplete(response[/*status*/ 's'], response[/* data */ 'd']);
            }, Math.floor(0));
        });
    }
    put(pathString, data, onComplete, hash) {
        this.putInternal('p', pathString, data, onComplete, hash);
    }
    merge(pathString, data, onComplete, hash) {
        this.putInternal('m', pathString, data, onComplete, hash);
    }
    putInternal(action, pathString, data, onComplete, hash) {
        this.initConnection_();
        const request = {
            /*path*/ p: pathString,
            /*data*/ d: data
        };
        if (hash !== undefined) request[/*hash*/ 'h'] = hash;
        // TODO: Only keep track of the most recent put for a given path?
        this.outstandingPuts_.push({
            action: action,
            request: request,
            onComplete: onComplete
        });
        this.outstandingPutCount_++;
        const index = this.outstandingPuts_.length - 1;
        if (this.connected_) this.sendPut_(index);
        else this.log_('Buffering put: ' + pathString);
    }
    sendPut_(index) {
        const action = this.outstandingPuts_[index].action;
        const request = this.outstandingPuts_[index].request;
        const onComplete = this.outstandingPuts_[index].onComplete;
        this.outstandingPuts_[index].queued = this.connected_;
        this.sendRequest(action, request, (message)=>{
            this.log_(action + ' response', message);
            delete this.outstandingPuts_[index];
            this.outstandingPutCount_--;
            // Clean up array occasionally.
            if (this.outstandingPutCount_ === 0) this.outstandingPuts_ = [];
            if (onComplete) onComplete(message[/*status*/ 's'], message[/* data */ 'd']);
        });
    }
    reportStats(stats) {
        // If we're not connected, we just drop the stats.
        if (this.connected_) {
            const request = {
                c: stats
            };
            this.log_('reportStats', request);
            this.sendRequest(/*stats*/ 's', request, (result)=>{
                const status = result[/*status*/ 's'];
                if (status !== 'ok') {
                    const errorReason = result[/* data */ 'd'];
                    this.log_('reportStats', 'Error sending stats: ' + errorReason);
                }
            });
        }
    }
    onDataMessage_(message) {
        if ('r' in message) {
            // this is a response
            this.log_('from server: ' + (0, $3117f6f4eeb4c314$export$fac44ee5b035f737)(message));
            const reqNum = message['r'];
            const onResponse = this.requestCBHash_[reqNum];
            if (onResponse) {
                delete this.requestCBHash_[reqNum];
                onResponse(message[/*body*/ 'b']);
            }
        } else if ('error' in message) throw 'A server-side error has occurred: ' + message['error'];
        else if ('a' in message) // a and b are action and body, respectively
        this.onDataPush_(message['a'], message['b']);
    }
    onDataPush_(action, body) {
        this.log_('handleServerMessage', action, body);
        if (action === 'd') this.onDataUpdate_(body[/*path*/ 'p'], body[/*data*/ 'd'], /*isMerge*/ false, body['t']);
        else if (action === 'm') this.onDataUpdate_(body[/*path*/ 'p'], body[/*data*/ 'd'], /*isMerge=*/ true, body['t']);
        else if (action === 'c') this.onListenRevoked_(body[/*path*/ 'p'], body[/*query*/ 'q']);
        else if (action === 'ac') this.onAuthRevoked_(body[/*status code*/ 's'], body[/* explanation */ 'd']);
        else if (action === 'apc') this.onAppCheckRevoked_(body[/*status code*/ 's'], body[/* explanation */ 'd']);
        else if (action === 'sd') this.onSecurityDebugPacket_(body);
        else $9cf0852385f62d16$var$error('Unrecognized action received from server: ' + (0, $3117f6f4eeb4c314$export$fac44ee5b035f737)(action) + '\nAre you using the latest client?');
    }
    onReady_(timestamp, sessionId) {
        this.log_('connection ready');
        this.connected_ = true;
        this.lastConnectionEstablishedTime_ = new Date().getTime();
        this.handleTimestamp_(timestamp);
        this.lastSessionId = sessionId;
        if (this.firstConnection_) this.sendConnectStats_();
        this.restoreState_();
        this.firstConnection_ = false;
        this.onConnectStatus_(true);
    }
    scheduleConnect_(timeout) {
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(!this.realtime_, "Scheduling a connect when we're already connected/ing?");
        if (this.establishConnectionTimer_) clearTimeout(this.establishConnectionTimer_);
        // NOTE: Even when timeout is 0, it's important to do a setTimeout to work around an infuriating "Security Error" in
        // Firefox when trying to write to our long-polling iframe in some scenarios (e.g. Forge or our unit tests).
        this.establishConnectionTimer_ = setTimeout(()=>{
            this.establishConnectionTimer_ = null;
            this.establishConnection_();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor(timeout));
    }
    initConnection_() {
        if (!this.realtime_ && this.firstConnection_) this.scheduleConnect_(0);
    }
    onVisible_(visible) {
        // NOTE: Tabbing away and back to a window will defeat our reconnect backoff, but I think that's fine.
        if (visible && !this.visible_ && this.reconnectDelay_ === this.maxReconnectDelay_) {
            this.log_('Window became visible.  Reducing delay.');
            this.reconnectDelay_ = $9cf0852385f62d16$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        }
        this.visible_ = visible;
    }
    onOnline_(online) {
        if (online) {
            this.log_('Browser went online.');
            this.reconnectDelay_ = $9cf0852385f62d16$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        } else {
            this.log_('Browser went offline.  Killing connection.');
            if (this.realtime_) this.realtime_.close();
        }
    }
    onRealtimeDisconnect_() {
        this.log_('data client disconnected');
        this.connected_ = false;
        this.realtime_ = null;
        // Since we don't know if our sent transactions succeeded or not, we need to cancel them.
        this.cancelSentTransactions_();
        // Clear out the pending requests.
        this.requestCBHash_ = {};
        if (this.shouldReconnect_()) {
            if (!this.visible_) {
                this.log_("Window isn't visible.  Delaying reconnect.");
                this.reconnectDelay_ = this.maxReconnectDelay_;
                this.lastConnectionAttemptTime_ = new Date().getTime();
            } else if (this.lastConnectionEstablishedTime_) {
                // If we've been connected long enough, reset reconnect delay to minimum.
                const timeSinceLastConnectSucceeded = new Date().getTime() - this.lastConnectionEstablishedTime_;
                if (timeSinceLastConnectSucceeded > $9cf0852385f62d16$var$RECONNECT_DELAY_RESET_TIMEOUT) this.reconnectDelay_ = $9cf0852385f62d16$var$RECONNECT_MIN_DELAY;
                this.lastConnectionEstablishedTime_ = null;
            }
            const timeSinceLastConnectAttempt = Math.max(0, new Date().getTime() - this.lastConnectionAttemptTime_);
            let reconnectDelay = Math.max(0, this.reconnectDelay_ - timeSinceLastConnectAttempt);
            reconnectDelay = Math.random() * reconnectDelay;
            this.log_('Trying to reconnect in ' + reconnectDelay + 'ms');
            this.scheduleConnect_(reconnectDelay);
            // Adjust reconnect delay for next time.
            this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * $9cf0852385f62d16$var$RECONNECT_DELAY_MULTIPLIER);
        }
        this.onConnectStatus_(false);
    }
    async establishConnection_() {
        if (this.shouldReconnect_()) {
            this.log_('Making a connection attempt');
            this.lastConnectionAttemptTime_ = new Date().getTime();
            this.lastConnectionEstablishedTime_ = null;
            const onDataMessage = this.onDataMessage_.bind(this);
            const onReady = this.onReady_.bind(this);
            const onDisconnect = this.onRealtimeDisconnect_.bind(this);
            const connId = this.id + ':' + $9cf0852385f62d16$var$PersistentConnection.nextConnectionId_++;
            const lastSessionId = this.lastSessionId;
            let canceled = false;
            let connection = null;
            const closeFn = function() {
                if (connection) connection.close();
                else {
                    canceled = true;
                    onDisconnect();
                }
            };
            const sendRequestFn = function(msg) {
                (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(connection, "sendRequest call when we're not connected not allowed.");
                connection.sendRequest(msg);
            };
            this.realtime_ = {
                close: closeFn,
                sendRequest: sendRequestFn
            };
            const forceRefresh = this.forceTokenRefresh_;
            this.forceTokenRefresh_ = false;
            try {
                // First fetch auth and app check token, and establish connection after
                // fetching the token was successful
                const [authToken, appCheckToken] = await Promise.all([
                    this.authTokenProvider_.getToken(forceRefresh),
                    this.appCheckTokenProvider_.getToken(forceRefresh)
                ]);
                if (!canceled) {
                    $9cf0852385f62d16$var$log('getToken() completed. Creating connection.');
                    this.authToken_ = authToken && authToken.accessToken;
                    this.appCheckToken_ = appCheckToken && appCheckToken.token;
                    connection = new $9cf0852385f62d16$var$Connection(connId, this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, onDataMessage, onReady, onDisconnect, /* onKill= */ (reason)=>{
                        $9cf0852385f62d16$var$warn(reason + ' (' + this.repoInfo_.toString() + ')');
                        this.interrupt($9cf0852385f62d16$var$SERVER_KILL_INTERRUPT_REASON);
                    }, lastSessionId);
                } else $9cf0852385f62d16$var$log('getToken() completed but was canceled');
            } catch (error) {
                this.log_('Failed to get token: ' + error);
                if (!canceled) {
                    if (this.repoInfo_.nodeAdmin) // This may be a critical error for the Admin Node.js SDK, so log a warning.
                    // But getToken() may also just have temporarily failed, so we still want to
                    // continue retrying.
                    $9cf0852385f62d16$var$warn(error);
                    closeFn();
                }
            }
        }
    }
    interrupt(reason) {
        $9cf0852385f62d16$var$log('Interrupting connection for reason: ' + reason);
        this.interruptReasons_[reason] = true;
        if (this.realtime_) this.realtime_.close();
        else {
            if (this.establishConnectionTimer_) {
                clearTimeout(this.establishConnectionTimer_);
                this.establishConnectionTimer_ = null;
            }
            if (this.connected_) this.onRealtimeDisconnect_();
        }
    }
    resume(reason) {
        $9cf0852385f62d16$var$log('Resuming connection for reason: ' + reason);
        delete this.interruptReasons_[reason];
        if ((0, $3117f6f4eeb4c314$export$dd1bc94b04021eeb)(this.interruptReasons_)) {
            this.reconnectDelay_ = $9cf0852385f62d16$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        }
    }
    handleTimestamp_(timestamp) {
        const delta = timestamp - new Date().getTime();
        this.onServerInfoUpdate_({
            serverTimeOffset: delta
        });
    }
    cancelSentTransactions_() {
        for(let i = 0; i < this.outstandingPuts_.length; i++){
            const put = this.outstandingPuts_[i];
            if (put && /*hash*/ 'h' in put.request && put.queued) {
                if (put.onComplete) put.onComplete('disconnect');
                delete this.outstandingPuts_[i];
                this.outstandingPutCount_--;
            }
        }
        // Clean up array occasionally.
        if (this.outstandingPutCount_ === 0) this.outstandingPuts_ = [];
    }
    onListenRevoked_(pathString, query) {
        // Remove the listen and manufacture a "permission_denied" error for the failed listen.
        let queryId;
        if (!query) queryId = 'default';
        else queryId = query.map((q)=>$9cf0852385f62d16$var$ObjectToUniqueKey(q)).join('$');
        const listen = this.removeListen_(pathString, queryId);
        if (listen && listen.onComplete) listen.onComplete('permission_denied');
    }
    removeListen_(pathString, queryId) {
        const normalizedPathString = new $9cf0852385f62d16$var$Path(pathString).toString(); // normalize path.
        let listen;
        if (this.listens.has(normalizedPathString)) {
            const map = this.listens.get(normalizedPathString);
            listen = map.get(queryId);
            map.delete(queryId);
            if (map.size === 0) this.listens.delete(normalizedPathString);
        } else // all listens for this path has already been removed
        listen = undefined;
        return listen;
    }
    onAuthRevoked_(statusCode, explanation) {
        $9cf0852385f62d16$var$log('Auth token revoked: ' + statusCode + '/' + explanation);
        this.authToken_ = null;
        this.forceTokenRefresh_ = true;
        this.realtime_.close();
        if (statusCode === 'invalid_token' || statusCode === 'permission_denied') {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAuthTokenCount_++;
            if (this.invalidAuthTokenCount_ >= $9cf0852385f62d16$var$INVALID_TOKEN_THRESHOLD) {
                // Set a long reconnect delay because recovery is unlikely
                this.reconnectDelay_ = $9cf0852385f62d16$var$RECONNECT_MAX_DELAY_FOR_ADMINS;
                // Notify the auth token provider that the token is invalid, which will log
                // a warning
                this.authTokenProvider_.notifyForInvalidToken();
            }
        }
    }
    onAppCheckRevoked_(statusCode, explanation) {
        $9cf0852385f62d16$var$log('App check token revoked: ' + statusCode + '/' + explanation);
        this.appCheckToken_ = null;
        this.forceTokenRefresh_ = true;
        // Note: We don't close the connection as the developer may not have
        // enforcement enabled. The backend closes connections with enforcements.
        if (statusCode === 'invalid_token' || statusCode === 'permission_denied') {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAppCheckTokenCount_++;
            if (this.invalidAppCheckTokenCount_ >= $9cf0852385f62d16$var$INVALID_TOKEN_THRESHOLD) this.appCheckTokenProvider_.notifyForInvalidToken();
        }
    }
    onSecurityDebugPacket_(body) {
        if (this.securityDebugCallback_) this.securityDebugCallback_(body);
        else if ('msg' in body) console.log('FIREBASE: ' + body['msg'].replace('\n', '\nFIREBASE: '));
    }
    restoreState_() {
        //Re-authenticate ourselves if we have a credential stored.
        this.tryAuth();
        this.tryAppCheck();
        // Puts depend on having received the corresponding data update from the server before they complete, so we must
        // make sure to send listens before puts.
        for (const queries of this.listens.values())for (const listenSpec of queries.values())this.sendListen_(listenSpec);
        for(let i = 0; i < this.outstandingPuts_.length; i++)if (this.outstandingPuts_[i]) this.sendPut_(i);
        while(this.onDisconnectRequestQueue_.length){
            const request = this.onDisconnectRequestQueue_.shift();
            this.sendOnDisconnect_(request.action, request.pathString, request.data, request.onComplete);
        }
        for(let i = 0; i < this.outstandingGets_.length; i++)if (this.outstandingGets_[i]) this.sendGet_(i);
    }
    /**
     * Sends client stats for first connection
     */ sendConnectStats_() {
        const stats = {};
        let clientName = 'js';
        if ((0, $3117f6f4eeb4c314$export$5d1d834fbbf8bab7)()) {
            if (this.repoInfo_.nodeAdmin) clientName = 'admin_node';
            else clientName = 'node';
        }
        stats['sdk.' + clientName + '.' + $9cf0852385f62d16$var$SDK_VERSION.replace(/\./g, '-')] = 1;
        if ((0, $3117f6f4eeb4c314$export$872f8323f01d7ae0)()) stats['framework.cordova'] = 1;
        else if ((0, $3117f6f4eeb4c314$export$f7a1e23e542d38e3)()) stats['framework.reactnative'] = 1;
        this.reportStats(stats);
    }
    shouldReconnect_() {
        const online = $9cf0852385f62d16$var$OnlineMonitor.getInstance().currentlyOnline();
        return (0, $3117f6f4eeb4c314$export$dd1bc94b04021eeb)(this.interruptReasons_) && online;
    }
}
$9cf0852385f62d16$var$PersistentConnection.nextPersistentConnectionId_ = 0;
/**
 * Counter for number of connections created. Mainly used for tagging in the logs
 */ $9cf0852385f62d16$var$PersistentConnection.nextConnectionId_ = 0;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9cf0852385f62d16$var$NamedNode {
    constructor(name, node){
        this.name = name;
        this.node = node;
    }
    static Wrap(name, node) {
        return new $9cf0852385f62d16$var$NamedNode(name, node);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9cf0852385f62d16$var$Index {
    /**
     * @returns A standalone comparison function for
     * this index
     */ getCompare() {
        return this.compare.bind(this);
    }
    /**
     * Given a before and after value for a node, determine if the indexed value has changed. Even if they are different,
     * it's possible that the changes are isolated to parts of the snapshot that are not indexed.
     *
     *
     * @returns True if the portion of the snapshot being indexed changed between oldNode and newNode
     */ indexedValueChanged(oldNode, newNode) {
        const oldWrapped = new $9cf0852385f62d16$var$NamedNode($9cf0852385f62d16$var$MIN_NAME, oldNode);
        const newWrapped = new $9cf0852385f62d16$var$NamedNode($9cf0852385f62d16$var$MIN_NAME, newNode);
        return this.compare(oldWrapped, newWrapped) !== 0;
    }
    /**
     * @returns a node wrapper that will sort equal to or less than
     * any other node wrapper, using this index
     */ minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $9cf0852385f62d16$var$NamedNode.MIN;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $9cf0852385f62d16$var$__EMPTY_NODE;
class $9cf0852385f62d16$var$KeyIndex extends $9cf0852385f62d16$var$Index {
    static get __EMPTY_NODE() {
        return $9cf0852385f62d16$var$__EMPTY_NODE;
    }
    static set __EMPTY_NODE(val) {
        $9cf0852385f62d16$var$__EMPTY_NODE = val;
    }
    compare(a, b) {
        return $9cf0852385f62d16$var$nameCompare(a.name, b.name);
    }
    isDefinedOn(node) {
        // We could probably return true here (since every node has a key), but it's never called
        // so just leaving unimplemented for now.
        throw (0, $3117f6f4eeb4c314$export$a39cad550e7ab28a)('KeyIndex.isDefinedOn not expected to be called.');
    }
    indexedValueChanged(oldNode, newNode) {
        return false; // The key for a node never changes.
    }
    minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $9cf0852385f62d16$var$NamedNode.MIN;
    }
    maxPost() {
        // TODO: This should really be created once and cached in a static property, but
        // NamedNode isn't defined yet, so I can't use it in a static.  Bleh.
        return new $9cf0852385f62d16$var$NamedNode($9cf0852385f62d16$var$MAX_NAME, $9cf0852385f62d16$var$__EMPTY_NODE);
    }
    makePost(indexValue, name) {
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(typeof indexValue === 'string', 'KeyIndex indexValue must always be a string.');
        // We just use empty node, but it'll never be compared, since our comparator only looks at name.
        return new $9cf0852385f62d16$var$NamedNode(indexValue, $9cf0852385f62d16$var$__EMPTY_NODE);
    }
    /**
     * @returns String representation for inclusion in a query spec
     */ toString() {
        return '.key';
    }
}
const $9cf0852385f62d16$var$KEY_INDEX = new $9cf0852385f62d16$var$KeyIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An iterator over an LLRBNode.
 */ class $9cf0852385f62d16$var$SortedMapIterator {
    /**
     * @param node - Node to iterate.
     * @param isReverse_ - Whether or not to iterate in reverse
     */ constructor(node, startKey, comparator, isReverse_, resultGenerator_ = null){
        this.isReverse_ = isReverse_;
        this.resultGenerator_ = resultGenerator_;
        this.nodeStack_ = [];
        let cmp = 1;
        while(!node.isEmpty()){
            node;
            cmp = startKey ? comparator(node.key, startKey) : 1;
            // flip the comparison if we're going in reverse
            if (isReverse_) cmp *= -1;
            if (cmp < 0) {
                // This node is less than our start key. ignore it
                if (this.isReverse_) node = node.left;
                else node = node.right;
            } else if (cmp === 0) {
                // This node is exactly equal to our start key. Push it on the stack, but stop iterating;
                this.nodeStack_.push(node);
                break;
            } else {
                // This node is greater than our start key, add it to the stack and move to the next one
                this.nodeStack_.push(node);
                if (this.isReverse_) node = node.right;
                else node = node.left;
            }
        }
    }
    getNext() {
        if (this.nodeStack_.length === 0) return null;
        let node = this.nodeStack_.pop();
        let result;
        if (this.resultGenerator_) result = this.resultGenerator_(node.key, node.value);
        else result = {
            key: node.key,
            value: node.value
        };
        if (this.isReverse_) {
            node = node.left;
            while(!node.isEmpty()){
                this.nodeStack_.push(node);
                node = node.right;
            }
        } else {
            node = node.right;
            while(!node.isEmpty()){
                this.nodeStack_.push(node);
                node = node.left;
            }
        }
        return result;
    }
    hasNext() {
        return this.nodeStack_.length > 0;
    }
    peek() {
        if (this.nodeStack_.length === 0) return null;
        const node = this.nodeStack_[this.nodeStack_.length - 1];
        if (this.resultGenerator_) return this.resultGenerator_(node.key, node.value);
        else return {
            key: node.key,
            value: node.value
        };
    }
}
/**
 * Represents a node in a Left-leaning Red-Black tree.
 */ class $9cf0852385f62d16$var$LLRBNode {
    /**
     * @param key - Key associated with this node.
     * @param value - Value associated with this node.
     * @param color - Whether this node is red.
     * @param left - Left child.
     * @param right - Right child.
     */ constructor(key, value, color, left, right){
        this.key = key;
        this.value = value;
        this.color = color != null ? color : $9cf0852385f62d16$var$LLRBNode.RED;
        this.left = left != null ? left : $9cf0852385f62d16$var$SortedMap.EMPTY_NODE;
        this.right = right != null ? right : $9cf0852385f62d16$var$SortedMap.EMPTY_NODE;
    }
    /**
     * Returns a copy of the current node, optionally replacing pieces of it.
     *
     * @param key - New key for the node, or null.
     * @param value - New value for the node, or null.
     * @param color - New color for the node, or null.
     * @param left - New left child for the node, or null.
     * @param right - New right child for the node, or null.
     * @returns The node copy.
     */ copy(key, value, color, left, right) {
        return new $9cf0852385f62d16$var$LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
    }
    /**
     * @returns The total number of nodes in the tree.
     */ count() {
        return this.left.count() + 1 + this.right.count();
    }
    /**
     * @returns True if the tree is empty.
     */ isEmpty() {
        return false;
    }
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     *   node.  If it returns true, traversal is aborted.
     * @returns The first truthy value returned by action, or the last falsey
     *   value returned by action
     */ inorderTraversal(action) {
        return this.left.inorderTraversal(action) || !!action(this.key, this.value) || this.right.inorderTraversal(action);
    }
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ reverseTraversal(action) {
        return this.right.reverseTraversal(action) || action(this.key, this.value) || this.left.reverseTraversal(action);
    }
    /**
     * @returns The minimum node in the tree.
     */ min_() {
        if (this.left.isEmpty()) return this;
        else return this.left.min_();
    }
    /**
     * @returns The maximum key in the tree.
     */ minKey() {
        return this.min_().key;
    }
    /**
     * @returns The maximum key in the tree.
     */ maxKey() {
        if (this.right.isEmpty()) return this.key;
        else return this.right.maxKey();
    }
    /**
     * @param key - Key to insert.
     * @param value - Value to insert.
     * @param comparator - Comparator.
     * @returns New tree, with the key/value added.
     */ insert(key, value, comparator) {
        let n = this;
        const cmp = comparator(key, n.key);
        if (cmp < 0) n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
        else if (cmp === 0) n = n.copy(null, value, null, null, null);
        else n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
        return n.fixUp_();
    }
    /**
     * @returns New tree, with the minimum key removed.
     */ removeMin_() {
        if (this.left.isEmpty()) return $9cf0852385f62d16$var$SortedMap.EMPTY_NODE;
        let n = this;
        if (!n.left.isRed_() && !n.left.left.isRed_()) n = n.moveRedLeft_();
        n = n.copy(null, null, null, n.left.removeMin_(), null);
        return n.fixUp_();
    }
    /**
     * @param key - The key of the item to remove.
     * @param comparator - Comparator.
     * @returns New tree, with the specified item removed.
     */ remove(key, comparator) {
        let n, smallest;
        n = this;
        if (comparator(key, n.key) < 0) {
            if (!n.left.isEmpty() && !n.left.isRed_() && !n.left.left.isRed_()) n = n.moveRedLeft_();
            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
        } else {
            if (n.left.isRed_()) n = n.rotateRight_();
            if (!n.right.isEmpty() && !n.right.isRed_() && !n.right.left.isRed_()) n = n.moveRedRight_();
            if (comparator(key, n.key) === 0) {
                if (n.right.isEmpty()) return $9cf0852385f62d16$var$SortedMap.EMPTY_NODE;
                else {
                    smallest = n.right.min_();
                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin_());
                }
            }
            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
        }
        return n.fixUp_();
    }
    /**
     * @returns Whether this is a RED node.
     */ isRed_() {
        return this.color;
    }
    /**
     * @returns New tree after performing any needed rotations.
     */ fixUp_() {
        let n = this;
        if (n.right.isRed_() && !n.left.isRed_()) n = n.rotateLeft_();
        if (n.left.isRed_() && n.left.left.isRed_()) n = n.rotateRight_();
        if (n.left.isRed_() && n.right.isRed_()) n = n.colorFlip_();
        return n;
    }
    /**
     * @returns New tree, after moveRedLeft.
     */ moveRedLeft_() {
        let n = this.colorFlip_();
        if (n.right.left.isRed_()) {
            n = n.copy(null, null, null, null, n.right.rotateRight_());
            n = n.rotateLeft_();
            n = n.colorFlip_();
        }
        return n;
    }
    /**
     * @returns New tree, after moveRedRight.
     */ moveRedRight_() {
        let n = this.colorFlip_();
        if (n.left.left.isRed_()) {
            n = n.rotateRight_();
            n = n.colorFlip_();
        }
        return n;
    }
    /**
     * @returns New tree, after rotateLeft.
     */ rotateLeft_() {
        const nl = this.copy(null, null, $9cf0852385f62d16$var$LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, nl, null);
    }
    /**
     * @returns New tree, after rotateRight.
     */ rotateRight_() {
        const nr = this.copy(null, null, $9cf0852385f62d16$var$LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, nr);
    }
    /**
     * @returns Newt ree, after colorFlip.
     */ colorFlip_() {
        const left = this.left.copy(null, null, !this.left.color, null, null);
        const right = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, left, right);
    }
    /**
     * For testing.
     *
     * @returns True if all is well.
     */ checkMaxDepth_() {
        const blackDepth = this.check_();
        return Math.pow(2.0, blackDepth) <= this.count() + 1;
    }
    check_() {
        if (this.isRed_() && this.left.isRed_()) throw new Error('Red node has red child(' + this.key + ',' + this.value + ')');
        if (this.right.isRed_()) throw new Error('Right child of (' + this.key + ',' + this.value + ') is red');
        const blackDepth = this.left.check_();
        if (blackDepth !== this.right.check_()) throw new Error('Black depths differ');
        else return blackDepth + (this.isRed_() ? 0 : 1);
    }
}
$9cf0852385f62d16$var$LLRBNode.RED = true;
$9cf0852385f62d16$var$LLRBNode.BLACK = false;
/**
 * Represents an empty node (a leaf node in the Red-Black Tree).
 */ class $9cf0852385f62d16$var$LLRBEmptyNode {
    /**
     * Returns a copy of the current node.
     *
     * @returns The node copy.
     */ copy(key, value, color, left, right) {
        return this;
    }
    /**
     * Returns a copy of the tree, with the specified key/value added.
     *
     * @param key - Key to be added.
     * @param value - Value to be added.
     * @param comparator - Comparator.
     * @returns New tree, with item added.
     */ insert(key, value, comparator) {
        return new $9cf0852385f62d16$var$LLRBNode(key, value, null);
    }
    /**
     * Returns a copy of the tree, with the specified key removed.
     *
     * @param key - The key to remove.
     * @param comparator - Comparator.
     * @returns New tree, with item removed.
     */ remove(key, comparator) {
        return this;
    }
    /**
     * @returns The total number of nodes in the tree.
     */ count() {
        return 0;
    }
    /**
     * @returns True if the tree is empty.
     */ isEmpty() {
        return true;
    }
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ inorderTraversal(action) {
        return false;
    }
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ reverseTraversal(action) {
        return false;
    }
    minKey() {
        return null;
    }
    maxKey() {
        return null;
    }
    check_() {
        return 0;
    }
    /**
     * @returns Whether this node is red.
     */ isRed_() {
        return false;
    }
}
/**
 * An immutable sorted map implementation, based on a Left-leaning Red-Black
 * tree.
 */ class $9cf0852385f62d16$var$SortedMap {
    /**
     * @param comparator_ - Key comparator.
     * @param root_ - Optional root node for the map.
     */ constructor(comparator_, root_ = $9cf0852385f62d16$var$SortedMap.EMPTY_NODE){
        this.comparator_ = comparator_;
        this.root_ = root_;
    }
    /**
     * Returns a copy of the map, with the specified key/value added or replaced.
     * (TODO: We should perhaps rename this method to 'put')
     *
     * @param key - Key to be added.
     * @param value - Value to be added.
     * @returns New map, with item added.
     */ insert(key, value) {
        return new $9cf0852385f62d16$var$SortedMap(this.comparator_, this.root_.insert(key, value, this.comparator_).copy(null, null, $9cf0852385f62d16$var$LLRBNode.BLACK, null, null));
    }
    /**
     * Returns a copy of the map, with the specified key removed.
     *
     * @param key - The key to remove.
     * @returns New map, with item removed.
     */ remove(key) {
        return new $9cf0852385f62d16$var$SortedMap(this.comparator_, this.root_.remove(key, this.comparator_).copy(null, null, $9cf0852385f62d16$var$LLRBNode.BLACK, null, null));
    }
    /**
     * Returns the value of the node with the given key, or null.
     *
     * @param key - The key to look up.
     * @returns The value of the node with the given key, or null if the
     * key doesn't exist.
     */ get(key) {
        let cmp;
        let node = this.root_;
        while(!node.isEmpty()){
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) return node.value;
            else if (cmp < 0) node = node.left;
            else if (cmp > 0) node = node.right;
        }
        return null;
    }
    /**
     * Returns the key of the item *before* the specified key, or null if key is the first item.
     * @param key - The key to find the predecessor of
     * @returns The predecessor key.
     */ getPredecessorKey(key) {
        let cmp, node = this.root_, rightParent = null;
        while(!node.isEmpty()){
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                if (!node.left.isEmpty()) {
                    node = node.left;
                    while(!node.right.isEmpty())node = node.right;
                    return node.key;
                } else if (rightParent) return rightParent.key;
                else return null; // first item.
            } else if (cmp < 0) node = node.left;
            else if (cmp > 0) {
                rightParent = node;
                node = node.right;
            }
        }
        throw new Error('Attempted to find predecessor key for a nonexistent key.  What gives?');
    }
    /**
     * @returns True if the map is empty.
     */ isEmpty() {
        return this.root_.isEmpty();
    }
    /**
     * @returns The total number of nodes in the map.
     */ count() {
        return this.root_.count();
    }
    /**
     * @returns The minimum key in the map.
     */ minKey() {
        return this.root_.minKey();
    }
    /**
     * @returns The maximum key in the map.
     */ maxKey() {
        return this.root_.maxKey();
    }
    /**
     * Traverses the map in key order and calls the specified action function
     * for each key/value pair.
     *
     * @param action - Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @returns The first truthy value returned by action, or the last falsey
     *   value returned by action
     */ inorderTraversal(action) {
        return this.root_.inorderTraversal(action);
    }
    /**
     * Traverses the map in reverse key order and calls the specified action function
     * for each key/value pair.
     *
     * @param action - Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @returns True if the traversal was aborted.
     */ reverseTraversal(action) {
        return this.root_.reverseTraversal(action);
    }
    /**
     * Returns an iterator over the SortedMap.
     * @returns The iterator.
     */ getIterator(resultGenerator) {
        return new $9cf0852385f62d16$var$SortedMapIterator(this.root_, null, this.comparator_, false, resultGenerator);
    }
    getIteratorFrom(key, resultGenerator) {
        return new $9cf0852385f62d16$var$SortedMapIterator(this.root_, key, this.comparator_, false, resultGenerator);
    }
    getReverseIteratorFrom(key, resultGenerator) {
        return new $9cf0852385f62d16$var$SortedMapIterator(this.root_, key, this.comparator_, true, resultGenerator);
    }
    getReverseIterator(resultGenerator) {
        return new $9cf0852385f62d16$var$SortedMapIterator(this.root_, null, this.comparator_, true, resultGenerator);
    }
}
/**
 * Always use the same empty node, to reduce memory.
 */ $9cf0852385f62d16$var$SortedMap.EMPTY_NODE = new $9cf0852385f62d16$var$LLRBEmptyNode();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9cf0852385f62d16$var$NAME_ONLY_COMPARATOR(left, right) {
    return $9cf0852385f62d16$var$nameCompare(left.name, right.name);
}
function $9cf0852385f62d16$var$NAME_COMPARATOR(left, right) {
    return $9cf0852385f62d16$var$nameCompare(left, right);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $9cf0852385f62d16$var$MAX_NODE$2;
function $9cf0852385f62d16$var$setMaxNode$1(val) {
    $9cf0852385f62d16$var$MAX_NODE$2 = val;
}
const $9cf0852385f62d16$var$priorityHashText = function(priority) {
    if (typeof priority === 'number') return 'number:' + $9cf0852385f62d16$var$doubleToIEEE754String(priority);
    else return 'string:' + priority;
};
/**
 * Validates that a priority snapshot Node is valid.
 */ const $9cf0852385f62d16$var$validatePriorityNode = function(priorityNode) {
    if (priorityNode.isLeafNode()) {
        const val = priorityNode.val();
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(typeof val === 'string' || typeof val === 'number' || typeof val === 'object' && (0, $3117f6f4eeb4c314$export$2344b14b097df817)(val, '.sv'), 'Priority must be a string or number.');
    } else (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(priorityNode === $9cf0852385f62d16$var$MAX_NODE$2 || priorityNode.isEmpty(), 'priority of unexpected type.');
    // Don't call getPriority() on MAX_NODE to avoid hitting assertion.
    (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(priorityNode === $9cf0852385f62d16$var$MAX_NODE$2 || priorityNode.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $9cf0852385f62d16$var$__childrenNodeConstructor;
/**
 * LeafNode is a class for storing leaf nodes in a DataSnapshot.  It
 * implements Node and stores the value of the node (a string,
 * number, or boolean) accessible via getValue().
 */ class $9cf0852385f62d16$var$LeafNode {
    static set __childrenNodeConstructor(val) {
        $9cf0852385f62d16$var$__childrenNodeConstructor = val;
    }
    static get __childrenNodeConstructor() {
        return $9cf0852385f62d16$var$__childrenNodeConstructor;
    }
    /**
     * @param value_ - The value to store in this leaf node. The object type is
     * possible in the event of a deferred value
     * @param priorityNode_ - The priority of this node.
     */ constructor(value_, priorityNode_ = $9cf0852385f62d16$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE){
        this.value_ = value_;
        this.priorityNode_ = priorityNode_;
        this.lazyHash_ = null;
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(this.value_ !== undefined && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value.");
        $9cf0852385f62d16$var$validatePriorityNode(this.priorityNode_);
    }
    /** @inheritDoc */ isLeafNode() {
        return true;
    }
    /** @inheritDoc */ getPriority() {
        return this.priorityNode_;
    }
    /** @inheritDoc */ updatePriority(newPriorityNode) {
        return new $9cf0852385f62d16$var$LeafNode(this.value_, newPriorityNode);
    }
    /** @inheritDoc */ getImmediateChild(childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') return this.priorityNode_;
        else return $9cf0852385f62d16$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE;
    }
    /** @inheritDoc */ getChild(path) {
        if ($9cf0852385f62d16$var$pathIsEmpty(path)) return this;
        else if ($9cf0852385f62d16$var$pathGetFront(path) === '.priority') return this.priorityNode_;
        else return $9cf0852385f62d16$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE;
    }
    hasChild() {
        return false;
    }
    /** @inheritDoc */ getPredecessorChildName(childName, childNode) {
        return null;
    }
    /** @inheritDoc */ updateImmediateChild(childName, newChildNode) {
        if (childName === '.priority') return this.updatePriority(newChildNode);
        else if (newChildNode.isEmpty() && childName !== '.priority') return this;
        else return $9cf0852385f62d16$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(childName, newChildNode).updatePriority(this.priorityNode_);
    }
    /** @inheritDoc */ updateChild(path, newChildNode) {
        const front = $9cf0852385f62d16$var$pathGetFront(path);
        if (front === null) return newChildNode;
        else if (newChildNode.isEmpty() && front !== '.priority') return this;
        else {
            (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(front !== '.priority' || $9cf0852385f62d16$var$pathGetLength(path) === 1, '.priority must be the last token in a path');
            return this.updateImmediateChild(front, $9cf0852385f62d16$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateChild($9cf0852385f62d16$var$pathPopFront(path), newChildNode));
        }
    }
    /** @inheritDoc */ isEmpty() {
        return false;
    }
    /** @inheritDoc */ numChildren() {
        return 0;
    }
    /** @inheritDoc */ forEachChild(index, action) {
        return false;
    }
    val(exportFormat) {
        if (exportFormat && !this.getPriority().isEmpty()) return {
            '.value': this.getValue(),
            '.priority': this.getPriority().val()
        };
        else return this.getValue();
    }
    /** @inheritDoc */ hash() {
        if (this.lazyHash_ === null) {
            let toHash = '';
            if (!this.priorityNode_.isEmpty()) toHash += 'priority:' + $9cf0852385f62d16$var$priorityHashText(this.priorityNode_.val()) + ':';
            const type = typeof this.value_;
            toHash += type + ':';
            if (type === 'number') toHash += $9cf0852385f62d16$var$doubleToIEEE754String(this.value_);
            else toHash += this.value_;
            this.lazyHash_ = $9cf0852385f62d16$var$sha1(toHash);
        }
        return this.lazyHash_;
    }
    /**
     * Returns the value of the leaf node.
     * @returns The value of the node.
     */ getValue() {
        return this.value_;
    }
    compareTo(other) {
        if (other === $9cf0852385f62d16$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE) return 1;
        else if (other instanceof $9cf0852385f62d16$var$LeafNode.__childrenNodeConstructor) return -1;
        else {
            (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(other.isLeafNode(), 'Unknown node type');
            return this.compareToLeafNode_(other);
        }
    }
    /**
     * Comparison specifically for two leaf nodes
     */ compareToLeafNode_(otherLeaf) {
        const otherLeafType = typeof otherLeaf.value_;
        const thisLeafType = typeof this.value_;
        const otherIndex = $9cf0852385f62d16$var$LeafNode.VALUE_TYPE_ORDER.indexOf(otherLeafType);
        const thisIndex = $9cf0852385f62d16$var$LeafNode.VALUE_TYPE_ORDER.indexOf(thisLeafType);
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(otherIndex >= 0, 'Unknown leaf type: ' + otherLeafType);
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(thisIndex >= 0, 'Unknown leaf type: ' + thisLeafType);
        if (otherIndex === thisIndex) {
            // Same type, compare values
            if (thisLeafType === 'object') // Deferred value nodes are all equal, but we should also never get to this point...
            return 0;
            else {
                // Note that this works because true > false, all others are number or string comparisons
                if (this.value_ < otherLeaf.value_) return -1;
                else if (this.value_ === otherLeaf.value_) return 0;
                else return 1;
            }
        } else return thisIndex - otherIndex;
    }
    withIndex() {
        return this;
    }
    isIndexed() {
        return true;
    }
    equals(other) {
        if (other === this) return true;
        else if (other.isLeafNode()) {
            const otherLeaf = other;
            return this.value_ === otherLeaf.value_ && this.priorityNode_.equals(otherLeaf.priorityNode_);
        } else return false;
    }
}
/**
 * The sort order for comparing leaf nodes of different types. If two leaf nodes have
 * the same type, the comparison falls back to their value
 */ $9cf0852385f62d16$var$LeafNode.VALUE_TYPE_ORDER = [
    'object',
    'boolean',
    'number',
    'string'
];
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $9cf0852385f62d16$var$nodeFromJSON$1;
let $9cf0852385f62d16$var$MAX_NODE$1;
function $9cf0852385f62d16$var$setNodeFromJSON(val) {
    $9cf0852385f62d16$var$nodeFromJSON$1 = val;
}
function $9cf0852385f62d16$var$setMaxNode(val) {
    $9cf0852385f62d16$var$MAX_NODE$1 = val;
}
class $9cf0852385f62d16$var$PriorityIndex extends $9cf0852385f62d16$var$Index {
    compare(a, b) {
        const aPriority = a.node.getPriority();
        const bPriority = b.node.getPriority();
        const indexCmp = aPriority.compareTo(bPriority);
        if (indexCmp === 0) return $9cf0852385f62d16$var$nameCompare(a.name, b.name);
        else return indexCmp;
    }
    isDefinedOn(node) {
        return !node.getPriority().isEmpty();
    }
    indexedValueChanged(oldNode, newNode) {
        return !oldNode.getPriority().equals(newNode.getPriority());
    }
    minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $9cf0852385f62d16$var$NamedNode.MIN;
    }
    maxPost() {
        return new $9cf0852385f62d16$var$NamedNode($9cf0852385f62d16$var$MAX_NAME, new $9cf0852385f62d16$var$LeafNode('[PRIORITY-POST]', $9cf0852385f62d16$var$MAX_NODE$1));
    }
    makePost(indexValue, name) {
        const priorityNode = $9cf0852385f62d16$var$nodeFromJSON$1(indexValue);
        return new $9cf0852385f62d16$var$NamedNode(name, new $9cf0852385f62d16$var$LeafNode('[PRIORITY-POST]', priorityNode));
    }
    /**
     * @returns String representation for inclusion in a query spec
     */ toString() {
        return '.priority';
    }
}
const $9cf0852385f62d16$var$PRIORITY_INDEX = new $9cf0852385f62d16$var$PriorityIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9cf0852385f62d16$var$LOG_2 = Math.log(2);
class $9cf0852385f62d16$var$Base12Num {
    constructor(length){
        const logBase2 = (num)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            parseInt(Math.log(num) / $9cf0852385f62d16$var$LOG_2, 10);
        const bitMask = (bits)=>parseInt(Array(bits + 1).join('1'), 2);
        this.count = logBase2(length + 1);
        this.current_ = this.count - 1;
        const mask = bitMask(this.count);
        this.bits_ = length + 1 & mask;
    }
    nextBitIsOne() {
        //noinspection JSBitwiseOperatorUsage
        const result = !(this.bits_ & 0x1 << this.current_);
        this.current_--;
        return result;
    }
}
/**
 * Takes a list of child nodes and constructs a SortedSet using the given comparison
 * function
 *
 * Uses the algorithm described in the paper linked here:
 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.46.1458
 *
 * @param childList - Unsorted list of children
 * @param cmp - The comparison method to be used
 * @param keyFn - An optional function to extract K from a node wrapper, if K's
 * type is not NamedNode
 * @param mapSortFn - An optional override for comparator used by the generated sorted map
 */ const $9cf0852385f62d16$var$buildChildSet = function(childList, cmp, keyFn, mapSortFn) {
    childList.sort(cmp);
    const buildBalancedTree = function(low, high) {
        const length = high - low;
        let namedNode;
        let key;
        if (length === 0) return null;
        else if (length === 1) {
            namedNode = childList[low];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new $9cf0852385f62d16$var$LLRBNode(key, namedNode.node, $9cf0852385f62d16$var$LLRBNode.BLACK, null, null);
        } else {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const middle = parseInt(length / 2, 10) + low;
            const left = buildBalancedTree(low, middle);
            const right = buildBalancedTree(middle + 1, high);
            namedNode = childList[middle];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new $9cf0852385f62d16$var$LLRBNode(key, namedNode.node, $9cf0852385f62d16$var$LLRBNode.BLACK, left, right);
        }
    };
    const buildFrom12Array = function(base12) {
        let node = null;
        let root = null;
        let index = childList.length;
        const buildPennant = function(chunkSize, color) {
            const low = index - chunkSize;
            const high = index;
            index -= chunkSize;
            const childTree = buildBalancedTree(low + 1, high);
            const namedNode = childList[low];
            const key = keyFn ? keyFn(namedNode) : namedNode;
            attachPennant(new $9cf0852385f62d16$var$LLRBNode(key, namedNode.node, color, null, childTree));
        };
        const attachPennant = function(pennant) {
            if (node) {
                node.left = pennant;
                node = pennant;
            } else {
                root = pennant;
                node = pennant;
            }
        };
        for(let i = 0; i < base12.count; ++i){
            const isOne = base12.nextBitIsOne();
            // The number of nodes taken in each slice is 2^(arr.length - (i + 1))
            const chunkSize = Math.pow(2, base12.count - (i + 1));
            if (isOne) buildPennant(chunkSize, $9cf0852385f62d16$var$LLRBNode.BLACK);
            else {
                // current == 2
                buildPennant(chunkSize, $9cf0852385f62d16$var$LLRBNode.BLACK);
                buildPennant(chunkSize, $9cf0852385f62d16$var$LLRBNode.RED);
            }
        }
        return root;
    };
    const base12 = new $9cf0852385f62d16$var$Base12Num(childList.length);
    const root = buildFrom12Array(base12);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new $9cf0852385f62d16$var$SortedMap(mapSortFn || cmp, root);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $9cf0852385f62d16$var$_defaultIndexMap;
const $9cf0852385f62d16$var$fallbackObject = {};
class $9cf0852385f62d16$var$IndexMap {
    /**
     * The default IndexMap for nodes without a priority
     */ static get Default() {
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)($9cf0852385f62d16$var$fallbackObject && $9cf0852385f62d16$var$PRIORITY_INDEX, 'ChildrenNode.ts has not been loaded');
        $9cf0852385f62d16$var$_defaultIndexMap = $9cf0852385f62d16$var$_defaultIndexMap || new $9cf0852385f62d16$var$IndexMap({
            '.priority': $9cf0852385f62d16$var$fallbackObject
        }, {
            '.priority': $9cf0852385f62d16$var$PRIORITY_INDEX
        });
        return $9cf0852385f62d16$var$_defaultIndexMap;
    }
    constructor(indexes_, indexSet_){
        this.indexes_ = indexes_;
        this.indexSet_ = indexSet_;
    }
    get(indexKey) {
        const sortedMap = (0, $3117f6f4eeb4c314$export$e51ae4db7b428f67)(this.indexes_, indexKey);
        if (!sortedMap) throw new Error('No index defined for ' + indexKey);
        if (sortedMap instanceof $9cf0852385f62d16$var$SortedMap) return sortedMap;
        else // The index exists, but it falls back to just name comparison. Return null so that the calling code uses the
        // regular child map
        return null;
    }
    hasIndex(indexDefinition) {
        return (0, $3117f6f4eeb4c314$export$2344b14b097df817)(this.indexSet_, indexDefinition.toString());
    }
    addIndex(indexDefinition, existingChildren) {
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(indexDefinition !== $9cf0852385f62d16$var$KEY_INDEX, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
        const childList = [];
        let sawIndexedValue = false;
        const iter = existingChildren.getIterator($9cf0852385f62d16$var$NamedNode.Wrap);
        let next = iter.getNext();
        while(next){
            sawIndexedValue = sawIndexedValue || indexDefinition.isDefinedOn(next.node);
            childList.push(next);
            next = iter.getNext();
        }
        let newIndex;
        if (sawIndexedValue) newIndex = $9cf0852385f62d16$var$buildChildSet(childList, indexDefinition.getCompare());
        else newIndex = $9cf0852385f62d16$var$fallbackObject;
        const indexName = indexDefinition.toString();
        const newIndexSet = {
            ...this.indexSet_
        };
        newIndexSet[indexName] = indexDefinition;
        const newIndexes = {
            ...this.indexes_
        };
        newIndexes[indexName] = newIndex;
        return new $9cf0852385f62d16$var$IndexMap(newIndexes, newIndexSet);
    }
    /**
     * Ensure that this node is properly tracked in any indexes that we're maintaining
     */ addToIndexes(namedNode, existingChildren) {
        const newIndexes = (0, $3117f6f4eeb4c314$export$871de8747c9eaa88)(this.indexes_, (indexedChildren, indexName)=>{
            const index = (0, $3117f6f4eeb4c314$export$e51ae4db7b428f67)(this.indexSet_, indexName);
            (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(index, 'Missing index implementation for ' + indexName);
            if (indexedChildren === $9cf0852385f62d16$var$fallbackObject) {
                // Check to see if we need to index everything
                if (index.isDefinedOn(namedNode.node)) {
                    // We need to build this index
                    const childList = [];
                    const iter = existingChildren.getIterator($9cf0852385f62d16$var$NamedNode.Wrap);
                    let next = iter.getNext();
                    while(next){
                        if (next.name !== namedNode.name) childList.push(next);
                        next = iter.getNext();
                    }
                    childList.push(namedNode);
                    return $9cf0852385f62d16$var$buildChildSet(childList, index.getCompare());
                } else // No change, this remains a fallback
                return $9cf0852385f62d16$var$fallbackObject;
            } else {
                const existingSnap = existingChildren.get(namedNode.name);
                let newChildren = indexedChildren;
                if (existingSnap) newChildren = newChildren.remove(new $9cf0852385f62d16$var$NamedNode(namedNode.name, existingSnap));
                return newChildren.insert(namedNode, namedNode.node);
            }
        });
        return new $9cf0852385f62d16$var$IndexMap(newIndexes, this.indexSet_);
    }
    /**
     * Create a new IndexMap instance with the given value removed
     */ removeFromIndexes(namedNode, existingChildren) {
        const newIndexes = (0, $3117f6f4eeb4c314$export$871de8747c9eaa88)(this.indexes_, (indexedChildren)=>{
            if (indexedChildren === $9cf0852385f62d16$var$fallbackObject) // This is the fallback. Just return it, nothing to do in this case
            return indexedChildren;
            else {
                const existingSnap = existingChildren.get(namedNode.name);
                if (existingSnap) return indexedChildren.remove(new $9cf0852385f62d16$var$NamedNode(namedNode.name, existingSnap));
                else // No record of this child
                return indexedChildren;
            }
        });
        return new $9cf0852385f62d16$var$IndexMap(newIndexes, this.indexSet_);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO: For memory savings, don't store priorityNode_ if it's empty.
let $9cf0852385f62d16$var$EMPTY_NODE;
/**
 * ChildrenNode is a class for storing internal nodes in a DataSnapshot
 * (i.e. nodes with children).  It implements Node and stores the
 * list of children in the children property, sorted by child name.
 */ class $9cf0852385f62d16$var$ChildrenNode {
    static get EMPTY_NODE() {
        return $9cf0852385f62d16$var$EMPTY_NODE || ($9cf0852385f62d16$var$EMPTY_NODE = new $9cf0852385f62d16$var$ChildrenNode(new $9cf0852385f62d16$var$SortedMap($9cf0852385f62d16$var$NAME_COMPARATOR), null, $9cf0852385f62d16$var$IndexMap.Default));
    }
    /**
     * @param children_ - List of children of this node..
     * @param priorityNode_ - The priority of this node (as a snapshot node).
     */ constructor(children_, priorityNode_, indexMap_){
        this.children_ = children_;
        this.priorityNode_ = priorityNode_;
        this.indexMap_ = indexMap_;
        this.lazyHash_ = null;
        /**
         * Note: The only reason we allow null priority is for EMPTY_NODE, since we can't use
         * EMPTY_NODE as the priority of EMPTY_NODE.  We might want to consider making EMPTY_NODE its own
         * class instead of an empty ChildrenNode.
         */ if (this.priorityNode_) $9cf0852385f62d16$var$validatePriorityNode(this.priorityNode_);
        if (this.children_.isEmpty()) (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(!this.priorityNode_ || this.priorityNode_.isEmpty(), 'An empty node cannot have a priority');
    }
    /** @inheritDoc */ isLeafNode() {
        return false;
    }
    /** @inheritDoc */ getPriority() {
        return this.priorityNode_ || $9cf0852385f62d16$var$EMPTY_NODE;
    }
    /** @inheritDoc */ updatePriority(newPriorityNode) {
        if (this.children_.isEmpty()) // Don't allow priorities on empty nodes
        return this;
        else return new $9cf0852385f62d16$var$ChildrenNode(this.children_, newPriorityNode, this.indexMap_);
    }
    /** @inheritDoc */ getImmediateChild(childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') return this.getPriority();
        else {
            const child = this.children_.get(childName);
            return child === null ? $9cf0852385f62d16$var$EMPTY_NODE : child;
        }
    }
    /** @inheritDoc */ getChild(path) {
        const front = $9cf0852385f62d16$var$pathGetFront(path);
        if (front === null) return this;
        return this.getImmediateChild(front).getChild($9cf0852385f62d16$var$pathPopFront(path));
    }
    /** @inheritDoc */ hasChild(childName) {
        return this.children_.get(childName) !== null;
    }
    /** @inheritDoc */ updateImmediateChild(childName, newChildNode) {
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(newChildNode, 'We should always be passing snapshot nodes');
        if (childName === '.priority') return this.updatePriority(newChildNode);
        else {
            const namedNode = new $9cf0852385f62d16$var$NamedNode(childName, newChildNode);
            let newChildren, newIndexMap;
            if (newChildNode.isEmpty()) {
                newChildren = this.children_.remove(childName);
                newIndexMap = this.indexMap_.removeFromIndexes(namedNode, this.children_);
            } else {
                newChildren = this.children_.insert(childName, newChildNode);
                newIndexMap = this.indexMap_.addToIndexes(namedNode, this.children_);
            }
            const newPriority = newChildren.isEmpty() ? $9cf0852385f62d16$var$EMPTY_NODE : this.priorityNode_;
            return new $9cf0852385f62d16$var$ChildrenNode(newChildren, newPriority, newIndexMap);
        }
    }
    /** @inheritDoc */ updateChild(path, newChildNode) {
        const front = $9cf0852385f62d16$var$pathGetFront(path);
        if (front === null) return newChildNode;
        else {
            (0, $3117f6f4eeb4c314$export$a7a9523472993e97)($9cf0852385f62d16$var$pathGetFront(path) !== '.priority' || $9cf0852385f62d16$var$pathGetLength(path) === 1, '.priority must be the last token in a path');
            const newImmediateChild = this.getImmediateChild(front).updateChild($9cf0852385f62d16$var$pathPopFront(path), newChildNode);
            return this.updateImmediateChild(front, newImmediateChild);
        }
    }
    /** @inheritDoc */ isEmpty() {
        return this.children_.isEmpty();
    }
    /** @inheritDoc */ numChildren() {
        return this.children_.count();
    }
    /** @inheritDoc */ val(exportFormat) {
        if (this.isEmpty()) return null;
        const obj = {};
        let numKeys = 0, maxKey = 0, allIntegerKeys = true;
        this.forEachChild($9cf0852385f62d16$var$PRIORITY_INDEX, (key, childNode)=>{
            obj[key] = childNode.val(exportFormat);
            numKeys++;
            if (allIntegerKeys && $9cf0852385f62d16$var$ChildrenNode.INTEGER_REGEXP_.test(key)) maxKey = Math.max(maxKey, Number(key));
            else allIntegerKeys = false;
        });
        if (!exportFormat && allIntegerKeys && maxKey < 2 * numKeys) {
            // convert to array.
            const array = [];
            // eslint-disable-next-line guard-for-in
            for(const key in obj)array[key] = obj[key];
            return array;
        } else {
            if (exportFormat && !this.getPriority().isEmpty()) obj['.priority'] = this.getPriority().val();
            return obj;
        }
    }
    /** @inheritDoc */ hash() {
        if (this.lazyHash_ === null) {
            let toHash = '';
            if (!this.getPriority().isEmpty()) toHash += 'priority:' + $9cf0852385f62d16$var$priorityHashText(this.getPriority().val()) + ':';
            this.forEachChild($9cf0852385f62d16$var$PRIORITY_INDEX, (key, childNode)=>{
                const childHash = childNode.hash();
                if (childHash !== '') toHash += ':' + key + ':' + childHash;
            });
            this.lazyHash_ = toHash === '' ? '' : $9cf0852385f62d16$var$sha1(toHash);
        }
        return this.lazyHash_;
    }
    /** @inheritDoc */ getPredecessorChildName(childName, childNode, index) {
        const idx = this.resolveIndex_(index);
        if (idx) {
            const predecessor = idx.getPredecessorKey(new $9cf0852385f62d16$var$NamedNode(childName, childNode));
            return predecessor ? predecessor.name : null;
        } else return this.children_.getPredecessorKey(childName);
    }
    getFirstChildName(indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            const minKey = idx.minKey();
            return minKey && minKey.name;
        } else return this.children_.minKey();
    }
    getFirstChild(indexDefinition) {
        const minKey = this.getFirstChildName(indexDefinition);
        if (minKey) return new $9cf0852385f62d16$var$NamedNode(minKey, this.children_.get(minKey));
        else return null;
    }
    /**
     * Given an index, return the key name of the largest value we have, according to that index
     */ getLastChildName(indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            const maxKey = idx.maxKey();
            return maxKey && maxKey.name;
        } else return this.children_.maxKey();
    }
    getLastChild(indexDefinition) {
        const maxKey = this.getLastChildName(indexDefinition);
        if (maxKey) return new $9cf0852385f62d16$var$NamedNode(maxKey, this.children_.get(maxKey));
        else return null;
    }
    forEachChild(index, action) {
        const idx = this.resolveIndex_(index);
        if (idx) return idx.inorderTraversal((wrappedNode)=>{
            return action(wrappedNode.name, wrappedNode.node);
        });
        else return this.children_.inorderTraversal(action);
    }
    getIterator(indexDefinition) {
        return this.getIteratorFrom(indexDefinition.minPost(), indexDefinition);
    }
    getIteratorFrom(startPost, indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) return idx.getIteratorFrom(startPost, (key)=>key);
        else {
            const iterator = this.children_.getIteratorFrom(startPost.name, $9cf0852385f62d16$var$NamedNode.Wrap);
            let next = iterator.peek();
            while(next != null && indexDefinition.compare(next, startPost) < 0){
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    }
    getReverseIterator(indexDefinition) {
        return this.getReverseIteratorFrom(indexDefinition.maxPost(), indexDefinition);
    }
    getReverseIteratorFrom(endPost, indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) return idx.getReverseIteratorFrom(endPost, (key)=>{
            return key;
        });
        else {
            const iterator = this.children_.getReverseIteratorFrom(endPost.name, $9cf0852385f62d16$var$NamedNode.Wrap);
            let next = iterator.peek();
            while(next != null && indexDefinition.compare(next, endPost) > 0){
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    }
    compareTo(other) {
        if (this.isEmpty()) {
            if (other.isEmpty()) return 0;
            else return -1;
        } else if (other.isLeafNode() || other.isEmpty()) return 1;
        else if (other === $9cf0852385f62d16$var$MAX_NODE) return -1;
        else // Must be another node with children.
        return 0;
    }
    withIndex(indexDefinition) {
        if (indexDefinition === $9cf0852385f62d16$var$KEY_INDEX || this.indexMap_.hasIndex(indexDefinition)) return this;
        else {
            const newIndexMap = this.indexMap_.addIndex(indexDefinition, this.children_);
            return new $9cf0852385f62d16$var$ChildrenNode(this.children_, this.priorityNode_, newIndexMap);
        }
    }
    isIndexed(index) {
        return index === $9cf0852385f62d16$var$KEY_INDEX || this.indexMap_.hasIndex(index);
    }
    equals(other) {
        if (other === this) return true;
        else if (other.isLeafNode()) return false;
        else {
            const otherChildrenNode = other;
            if (!this.getPriority().equals(otherChildrenNode.getPriority())) return false;
            else if (this.children_.count() === otherChildrenNode.children_.count()) {
                const thisIter = this.getIterator($9cf0852385f62d16$var$PRIORITY_INDEX);
                const otherIter = otherChildrenNode.getIterator($9cf0852385f62d16$var$PRIORITY_INDEX);
                let thisCurrent = thisIter.getNext();
                let otherCurrent = otherIter.getNext();
                while(thisCurrent && otherCurrent){
                    if (thisCurrent.name !== otherCurrent.name || !thisCurrent.node.equals(otherCurrent.node)) return false;
                    thisCurrent = thisIter.getNext();
                    otherCurrent = otherIter.getNext();
                }
                return thisCurrent === null && otherCurrent === null;
            } else return false;
        }
    }
    /**
     * Returns a SortedMap ordered by index, or null if the default (by-key) ordering can be used
     * instead.
     *
     */ resolveIndex_(indexDefinition) {
        if (indexDefinition === $9cf0852385f62d16$var$KEY_INDEX) return null;
        else return this.indexMap_.get(indexDefinition.toString());
    }
}
$9cf0852385f62d16$var$ChildrenNode.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
class $9cf0852385f62d16$var$MaxNode extends $9cf0852385f62d16$var$ChildrenNode {
    constructor(){
        super(new $9cf0852385f62d16$var$SortedMap($9cf0852385f62d16$var$NAME_COMPARATOR), $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE, $9cf0852385f62d16$var$IndexMap.Default);
    }
    compareTo(other) {
        if (other === this) return 0;
        else return 1;
    }
    equals(other) {
        // Not that we every compare it, but MAX_NODE is only ever equal to itself
        return other === this;
    }
    getPriority() {
        return this;
    }
    getImmediateChild(childName) {
        return $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE;
    }
    isEmpty() {
        return false;
    }
}
/**
 * Marker that will sort higher than any other snapshot.
 */ const $9cf0852385f62d16$var$MAX_NODE = new $9cf0852385f62d16$var$MaxNode();
Object.defineProperties($9cf0852385f62d16$var$NamedNode, {
    MIN: {
        value: new $9cf0852385f62d16$var$NamedNode($9cf0852385f62d16$var$MIN_NAME, $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE)
    },
    MAX: {
        value: new $9cf0852385f62d16$var$NamedNode($9cf0852385f62d16$var$MAX_NAME, $9cf0852385f62d16$var$MAX_NODE)
    }
});
/**
 * Reference Extensions
 */ $9cf0852385f62d16$var$KeyIndex.__EMPTY_NODE = $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE;
$9cf0852385f62d16$var$LeafNode.__childrenNodeConstructor = $9cf0852385f62d16$var$ChildrenNode;
$9cf0852385f62d16$var$setMaxNode$1($9cf0852385f62d16$var$MAX_NODE);
$9cf0852385f62d16$var$setMaxNode($9cf0852385f62d16$var$MAX_NODE);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9cf0852385f62d16$var$USE_HINZE = true;
/**
 * Constructs a snapshot node representing the passed JSON and returns it.
 * @param json - JSON to create a node for.
 * @param priority - Optional priority to use.  This will be ignored if the
 * passed JSON contains a .priority property.
 */ function $9cf0852385f62d16$var$nodeFromJSON(json, priority = null) {
    if (json === null) return $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE;
    if (typeof json === 'object' && '.priority' in json) priority = json['.priority'];
    (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(priority === null || typeof priority === 'string' || typeof priority === 'number' || typeof priority === 'object' && '.sv' in priority, 'Invalid priority type found: ' + typeof priority);
    if (typeof json === 'object' && '.value' in json && json['.value'] !== null) json = json['.value'];
    // Valid leaf nodes include non-objects or server-value wrapper objects
    if (typeof json !== 'object' || '.sv' in json) {
        const jsonLeaf = json;
        return new $9cf0852385f62d16$var$LeafNode(jsonLeaf, $9cf0852385f62d16$var$nodeFromJSON(priority));
    }
    if (!(json instanceof Array) && $9cf0852385f62d16$var$USE_HINZE) {
        const children = [];
        let childrenHavePriority = false;
        const hinzeJsonObj = json;
        $9cf0852385f62d16$var$each(hinzeJsonObj, (key, child)=>{
            if (key.substring(0, 1) !== '.') {
                // Ignore metadata nodes
                const childNode = $9cf0852385f62d16$var$nodeFromJSON(child);
                if (!childNode.isEmpty()) {
                    childrenHavePriority = childrenHavePriority || !childNode.getPriority().isEmpty();
                    children.push(new $9cf0852385f62d16$var$NamedNode(key, childNode));
                }
            }
        });
        if (children.length === 0) return $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE;
        const childSet = $9cf0852385f62d16$var$buildChildSet(children, $9cf0852385f62d16$var$NAME_ONLY_COMPARATOR, (namedNode)=>namedNode.name, $9cf0852385f62d16$var$NAME_COMPARATOR);
        if (childrenHavePriority) {
            const sortedChildSet = $9cf0852385f62d16$var$buildChildSet(children, $9cf0852385f62d16$var$PRIORITY_INDEX.getCompare());
            return new $9cf0852385f62d16$var$ChildrenNode(childSet, $9cf0852385f62d16$var$nodeFromJSON(priority), new $9cf0852385f62d16$var$IndexMap({
                '.priority': sortedChildSet
            }, {
                '.priority': $9cf0852385f62d16$var$PRIORITY_INDEX
            }));
        } else return new $9cf0852385f62d16$var$ChildrenNode(childSet, $9cf0852385f62d16$var$nodeFromJSON(priority), $9cf0852385f62d16$var$IndexMap.Default);
    } else {
        let node = $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE;
        $9cf0852385f62d16$var$each(json, (key, childData)=>{
            if ((0, $3117f6f4eeb4c314$export$2344b14b097df817)(json, key)) {
                if (key.substring(0, 1) !== '.') {
                    // ignore metadata nodes.
                    const childNode = $9cf0852385f62d16$var$nodeFromJSON(childData);
                    if (childNode.isLeafNode() || !childNode.isEmpty()) node = node.updateImmediateChild(key, childNode);
                }
            }
        });
        return node.updatePriority($9cf0852385f62d16$var$nodeFromJSON(priority));
    }
}
$9cf0852385f62d16$var$setNodeFromJSON($9cf0852385f62d16$var$nodeFromJSON);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9cf0852385f62d16$var$PathIndex extends $9cf0852385f62d16$var$Index {
    constructor(indexPath_){
        super();
        this.indexPath_ = indexPath_;
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(!$9cf0852385f62d16$var$pathIsEmpty(indexPath_) && $9cf0852385f62d16$var$pathGetFront(indexPath_) !== '.priority', "Can't create PathIndex with empty path or .priority key");
    }
    extractChild(snap) {
        return snap.getChild(this.indexPath_);
    }
    isDefinedOn(node) {
        return !node.getChild(this.indexPath_).isEmpty();
    }
    compare(a, b) {
        const aChild = this.extractChild(a.node);
        const bChild = this.extractChild(b.node);
        const indexCmp = aChild.compareTo(bChild);
        if (indexCmp === 0) return $9cf0852385f62d16$var$nameCompare(a.name, b.name);
        else return indexCmp;
    }
    makePost(indexValue, name) {
        const valueNode = $9cf0852385f62d16$var$nodeFromJSON(indexValue);
        const node = $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, valueNode);
        return new $9cf0852385f62d16$var$NamedNode(name, node);
    }
    maxPost() {
        const node = $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, $9cf0852385f62d16$var$MAX_NODE);
        return new $9cf0852385f62d16$var$NamedNode($9cf0852385f62d16$var$MAX_NAME, node);
    }
    toString() {
        return $9cf0852385f62d16$var$pathSlice(this.indexPath_, 0).join('/');
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9cf0852385f62d16$var$ValueIndex extends $9cf0852385f62d16$var$Index {
    compare(a, b) {
        const indexCmp = a.node.compareTo(b.node);
        if (indexCmp === 0) return $9cf0852385f62d16$var$nameCompare(a.name, b.name);
        else return indexCmp;
    }
    isDefinedOn(node) {
        return true;
    }
    indexedValueChanged(oldNode, newNode) {
        return !oldNode.equals(newNode);
    }
    minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $9cf0852385f62d16$var$NamedNode.MIN;
    }
    maxPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $9cf0852385f62d16$var$NamedNode.MAX;
    }
    makePost(indexValue, name) {
        const valueNode = $9cf0852385f62d16$var$nodeFromJSON(indexValue);
        return new $9cf0852385f62d16$var$NamedNode(name, valueNode);
    }
    /**
     * @returns String representation for inclusion in a query spec
     */ toString() {
        return '.value';
    }
}
const $9cf0852385f62d16$var$VALUE_INDEX = new $9cf0852385f62d16$var$ValueIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9cf0852385f62d16$var$changeValue(snapshotNode) {
    return {
        type: "value" /* ChangeType.VALUE */ ,
        snapshotNode: snapshotNode
    };
}
function $9cf0852385f62d16$var$changeChildAdded(childName, snapshotNode) {
    return {
        type: "child_added" /* ChangeType.CHILD_ADDED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
function $9cf0852385f62d16$var$changeChildRemoved(childName, snapshotNode) {
    return {
        type: "child_removed" /* ChangeType.CHILD_REMOVED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
function $9cf0852385f62d16$var$changeChildChanged(childName, snapshotNode, oldSnap) {
    return {
        type: "child_changed" /* ChangeType.CHILD_CHANGED */ ,
        snapshotNode: snapshotNode,
        childName: childName,
        oldSnap: oldSnap
    };
}
function $9cf0852385f62d16$var$changeChildMoved(childName, snapshotNode) {
    return {
        type: "child_moved" /* ChangeType.CHILD_MOVED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Doesn't really filter nodes but applies an index to the node and keeps track of any changes
 */ class $9cf0852385f62d16$var$IndexedFilter {
    constructor(index_){
        this.index_ = index_;
    }
    updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(snap.isIndexed(this.index_), 'A node must be indexed if only a child is updated');
        const oldChild = snap.getImmediateChild(key);
        // Check if anything actually changed.
        if (oldChild.getChild(affectedPath).equals(newChild.getChild(affectedPath))) {
            // There's an edge case where a child can enter or leave the view because affectedPath was set to null.
            // In this case, affectedPath will appear null in both the old and new snapshots.  So we need
            // to avoid treating these cases as "nothing changed."
            if (oldChild.isEmpty() === newChild.isEmpty()) // Nothing changed.
            // This assert should be valid, but it's expensive (can dominate perf testing) so don't actually do it.
            //assert(oldChild.equals(newChild), 'Old and new snapshots should be equal.');
            return snap;
        }
        if (optChangeAccumulator != null) {
            if (newChild.isEmpty()) {
                if (snap.hasChild(key)) optChangeAccumulator.trackChildChange($9cf0852385f62d16$var$changeChildRemoved(key, oldChild));
                else (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(snap.isLeafNode(), 'A child remove without an old child only makes sense on a leaf node');
            } else if (oldChild.isEmpty()) optChangeAccumulator.trackChildChange($9cf0852385f62d16$var$changeChildAdded(key, newChild));
            else optChangeAccumulator.trackChildChange($9cf0852385f62d16$var$changeChildChanged(key, newChild, oldChild));
        }
        if (snap.isLeafNode() && newChild.isEmpty()) return snap;
        else // Make sure the node is indexed
        return snap.updateImmediateChild(key, newChild).withIndex(this.index_);
    }
    updateFullNode(oldSnap, newSnap, optChangeAccumulator) {
        if (optChangeAccumulator != null) {
            if (!oldSnap.isLeafNode()) oldSnap.forEachChild($9cf0852385f62d16$var$PRIORITY_INDEX, (key, childNode)=>{
                if (!newSnap.hasChild(key)) optChangeAccumulator.trackChildChange($9cf0852385f62d16$var$changeChildRemoved(key, childNode));
            });
            if (!newSnap.isLeafNode()) newSnap.forEachChild($9cf0852385f62d16$var$PRIORITY_INDEX, (key, childNode)=>{
                if (oldSnap.hasChild(key)) {
                    const oldChild = oldSnap.getImmediateChild(key);
                    if (!oldChild.equals(childNode)) optChangeAccumulator.trackChildChange($9cf0852385f62d16$var$changeChildChanged(key, childNode, oldChild));
                } else optChangeAccumulator.trackChildChange($9cf0852385f62d16$var$changeChildAdded(key, childNode));
            });
        }
        return newSnap.withIndex(this.index_);
    }
    updatePriority(oldSnap, newPriority) {
        if (oldSnap.isEmpty()) return $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE;
        else return oldSnap.updatePriority(newPriority);
    }
    filtersNodes() {
        return false;
    }
    getIndexedFilter() {
        return this;
    }
    getIndex() {
        return this.index_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Filters nodes by range and uses an IndexFilter to track any changes after filtering the node
 */ class $9cf0852385f62d16$var$RangedFilter {
    constructor(params){
        this.indexedFilter_ = new $9cf0852385f62d16$var$IndexedFilter(params.getIndex());
        this.index_ = params.getIndex();
        this.startPost_ = $9cf0852385f62d16$var$RangedFilter.getStartPost_(params);
        this.endPost_ = $9cf0852385f62d16$var$RangedFilter.getEndPost_(params);
        this.startIsInclusive_ = !params.startAfterSet_;
        this.endIsInclusive_ = !params.endBeforeSet_;
    }
    getStartPost() {
        return this.startPost_;
    }
    getEndPost() {
        return this.endPost_;
    }
    matches(node) {
        const isWithinStart = this.startIsInclusive_ ? this.index_.compare(this.getStartPost(), node) <= 0 : this.index_.compare(this.getStartPost(), node) < 0;
        const isWithinEnd = this.endIsInclusive_ ? this.index_.compare(node, this.getEndPost()) <= 0 : this.index_.compare(node, this.getEndPost()) < 0;
        return isWithinStart && isWithinEnd;
    }
    updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.matches(new $9cf0852385f62d16$var$NamedNode(key, newChild))) newChild = $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE;
        return this.indexedFilter_.updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
    }
    updateFullNode(oldSnap, newSnap, optChangeAccumulator) {
        if (newSnap.isLeafNode()) // Make sure we have a children node with the correct index, not a leaf node;
        newSnap = $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE;
        let filtered = newSnap.withIndex(this.index_);
        // Don't support priorities on queries
        filtered = filtered.updatePriority($9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE);
        const self = this;
        newSnap.forEachChild($9cf0852385f62d16$var$PRIORITY_INDEX, (key, childNode)=>{
            if (!self.matches(new $9cf0852385f62d16$var$NamedNode(key, childNode))) filtered = filtered.updateImmediateChild(key, $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE);
        });
        return this.indexedFilter_.updateFullNode(oldSnap, filtered, optChangeAccumulator);
    }
    updatePriority(oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    }
    filtersNodes() {
        return true;
    }
    getIndexedFilter() {
        return this.indexedFilter_;
    }
    getIndex() {
        return this.index_;
    }
    static getStartPost_(params) {
        if (params.hasStart()) {
            const startName = params.getIndexStartName();
            return params.getIndex().makePost(params.getIndexStartValue(), startName);
        } else return params.getIndex().minPost();
    }
    static getEndPost_(params) {
        if (params.hasEnd()) {
            const endName = params.getIndexEndName();
            return params.getIndex().makePost(params.getIndexEndValue(), endName);
        } else return params.getIndex().maxPost();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Applies a limit and a range to a node and uses RangedFilter to do the heavy lifting where possible
 */ class $9cf0852385f62d16$var$LimitedFilter {
    constructor(params){
        this.withinDirectionalStart = (node)=>this.reverse_ ? this.withinEndPost(node) : this.withinStartPost(node);
        this.withinDirectionalEnd = (node)=>this.reverse_ ? this.withinStartPost(node) : this.withinEndPost(node);
        this.withinStartPost = (node)=>{
            const compareRes = this.index_.compare(this.rangedFilter_.getStartPost(), node);
            return this.startIsInclusive_ ? compareRes <= 0 : compareRes < 0;
        };
        this.withinEndPost = (node)=>{
            const compareRes = this.index_.compare(node, this.rangedFilter_.getEndPost());
            return this.endIsInclusive_ ? compareRes <= 0 : compareRes < 0;
        };
        this.rangedFilter_ = new $9cf0852385f62d16$var$RangedFilter(params);
        this.index_ = params.getIndex();
        this.limit_ = params.getLimit();
        this.reverse_ = !params.isViewFromLeft();
        this.startIsInclusive_ = !params.startAfterSet_;
        this.endIsInclusive_ = !params.endBeforeSet_;
    }
    updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.rangedFilter_.matches(new $9cf0852385f62d16$var$NamedNode(key, newChild))) newChild = $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE;
        if (snap.getImmediateChild(key).equals(newChild)) // No change
        return snap;
        else if (snap.numChildren() < this.limit_) return this.rangedFilter_.getIndexedFilter().updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
        else return this.fullLimitUpdateChild_(snap, key, newChild, source, optChangeAccumulator);
    }
    updateFullNode(oldSnap, newSnap, optChangeAccumulator) {
        let filtered;
        if (newSnap.isLeafNode() || newSnap.isEmpty()) // Make sure we have a children node with the correct index, not a leaf node;
        filtered = $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE.withIndex(this.index_);
        else if (this.limit_ * 2 < newSnap.numChildren() && newSnap.isIndexed(this.index_)) {
            // Easier to build up a snapshot, since what we're given has more than twice the elements we want
            filtered = $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE.withIndex(this.index_);
            // anchor to the startPost, endPost, or last element as appropriate
            let iterator;
            if (this.reverse_) iterator = newSnap.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_);
            else iterator = newSnap.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
            let count = 0;
            while(iterator.hasNext() && count < this.limit_){
                const next = iterator.getNext();
                if (!this.withinDirectionalStart(next)) continue;
                else if (!this.withinDirectionalEnd(next)) break;
                else {
                    filtered = filtered.updateImmediateChild(next.name, next.node);
                    count++;
                }
            }
        } else {
            // The snap contains less than twice the limit. Faster to delete from the snap than build up a new one
            filtered = newSnap.withIndex(this.index_);
            // Don't support priorities on queries
            filtered = filtered.updatePriority($9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE);
            let iterator;
            if (this.reverse_) iterator = filtered.getReverseIterator(this.index_);
            else iterator = filtered.getIterator(this.index_);
            let count = 0;
            while(iterator.hasNext()){
                const next = iterator.getNext();
                const inRange = count < this.limit_ && this.withinDirectionalStart(next) && this.withinDirectionalEnd(next);
                if (inRange) count++;
                else filtered = filtered.updateImmediateChild(next.name, $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE);
            }
        }
        return this.rangedFilter_.getIndexedFilter().updateFullNode(oldSnap, filtered, optChangeAccumulator);
    }
    updatePriority(oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    }
    filtersNodes() {
        return true;
    }
    getIndexedFilter() {
        return this.rangedFilter_.getIndexedFilter();
    }
    getIndex() {
        return this.index_;
    }
    fullLimitUpdateChild_(snap, childKey, childSnap, source, changeAccumulator) {
        // TODO: rename all cache stuff etc to general snap terminology
        let cmp;
        if (this.reverse_) {
            const indexCmp = this.index_.getCompare();
            cmp = (a, b)=>indexCmp(b, a);
        } else cmp = this.index_.getCompare();
        const oldEventCache = snap;
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(oldEventCache.numChildren() === this.limit_, '');
        const newChildNamedNode = new $9cf0852385f62d16$var$NamedNode(childKey, childSnap);
        const windowBoundary = this.reverse_ ? oldEventCache.getFirstChild(this.index_) : oldEventCache.getLastChild(this.index_);
        const inRange = this.rangedFilter_.matches(newChildNamedNode);
        if (oldEventCache.hasChild(childKey)) {
            const oldChildSnap = oldEventCache.getImmediateChild(childKey);
            let nextChild = source.getChildAfterChild(this.index_, windowBoundary, this.reverse_);
            while(nextChild != null && (nextChild.name === childKey || oldEventCache.hasChild(nextChild.name)))// There is a weird edge case where a node is updated as part of a merge in the write tree, but hasn't
            // been applied to the limited filter yet. Ignore this next child which will be updated later in
            // the limited filter...
            nextChild = source.getChildAfterChild(this.index_, nextChild, this.reverse_);
            const compareNext = nextChild == null ? 1 : cmp(nextChild, newChildNamedNode);
            const remainsInWindow = inRange && !childSnap.isEmpty() && compareNext >= 0;
            if (remainsInWindow) {
                if (changeAccumulator != null) changeAccumulator.trackChildChange($9cf0852385f62d16$var$changeChildChanged(childKey, childSnap, oldChildSnap));
                return oldEventCache.updateImmediateChild(childKey, childSnap);
            } else {
                if (changeAccumulator != null) changeAccumulator.trackChildChange($9cf0852385f62d16$var$changeChildRemoved(childKey, oldChildSnap));
                const newEventCache = oldEventCache.updateImmediateChild(childKey, $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE);
                const nextChildInRange = nextChild != null && this.rangedFilter_.matches(nextChild);
                if (nextChildInRange) {
                    if (changeAccumulator != null) changeAccumulator.trackChildChange($9cf0852385f62d16$var$changeChildAdded(nextChild.name, nextChild.node));
                    return newEventCache.updateImmediateChild(nextChild.name, nextChild.node);
                } else return newEventCache;
            }
        } else if (childSnap.isEmpty()) // we're deleting a node, but it was not in the window, so ignore it
        return snap;
        else if (inRange) {
            if (cmp(windowBoundary, newChildNamedNode) >= 0) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange($9cf0852385f62d16$var$changeChildRemoved(windowBoundary.name, windowBoundary.node));
                    changeAccumulator.trackChildChange($9cf0852385f62d16$var$changeChildAdded(childKey, childSnap));
                }
                return oldEventCache.updateImmediateChild(childKey, childSnap).updateImmediateChild(windowBoundary.name, $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE);
            } else return snap;
        } else return snap;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class is an immutable-from-the-public-api struct containing a set of query parameters defining a
 * range to be returned for a particular location. It is assumed that validation of parameters is done at the
 * user-facing API level, so it is not done here.
 *
 * @internal
 */ class $9cf0852385f62d16$export$7ba287e361c94330 {
    constructor(){
        this.limitSet_ = false;
        this.startSet_ = false;
        this.startNameSet_ = false;
        this.startAfterSet_ = false; // can only be true if startSet_ is true
        this.endSet_ = false;
        this.endNameSet_ = false;
        this.endBeforeSet_ = false; // can only be true if endSet_ is true
        this.limit_ = 0;
        this.viewFrom_ = '';
        this.indexStartValue_ = null;
        this.indexStartName_ = '';
        this.indexEndValue_ = null;
        this.indexEndName_ = '';
        this.index_ = $9cf0852385f62d16$var$PRIORITY_INDEX;
    }
    hasStart() {
        return this.startSet_;
    }
    /**
     * @returns True if it would return from left.
     */ isViewFromLeft() {
        if (this.viewFrom_ === '') // limit(), rather than limitToFirst or limitToLast was called.
        // This means that only one of startSet_ and endSet_ is true. Use them
        // to calculate which side of the view to anchor to. If neither is set,
        // anchor to the end.
        return this.startSet_;
        else return this.viewFrom_ === "l" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT */ ;
    }
    /**
     * Only valid to call if hasStart() returns true
     */ getIndexStartValue() {
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(this.startSet_, 'Only valid if start has been set');
        return this.indexStartValue_;
    }
    /**
     * Only valid to call if hasStart() returns true.
     * Returns the starting key name for the range defined by these query parameters
     */ getIndexStartName() {
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(this.startSet_, 'Only valid if start has been set');
        if (this.startNameSet_) return this.indexStartName_;
        else return $9cf0852385f62d16$var$MIN_NAME;
    }
    hasEnd() {
        return this.endSet_;
    }
    /**
     * Only valid to call if hasEnd() returns true.
     */ getIndexEndValue() {
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(this.endSet_, 'Only valid if end has been set');
        return this.indexEndValue_;
    }
    /**
     * Only valid to call if hasEnd() returns true.
     * Returns the end key name for the range defined by these query parameters
     */ getIndexEndName() {
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(this.endSet_, 'Only valid if end has been set');
        if (this.endNameSet_) return this.indexEndName_;
        else return $9cf0852385f62d16$var$MAX_NAME;
    }
    hasLimit() {
        return this.limitSet_;
    }
    /**
     * @returns True if a limit has been set and it has been explicitly anchored
     */ hasAnchoredLimit() {
        return this.limitSet_ && this.viewFrom_ !== '';
    }
    /**
     * Only valid to call if hasLimit() returns true
     */ getLimit() {
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(this.limitSet_, 'Only valid if limit has been set');
        return this.limit_;
    }
    getIndex() {
        return this.index_;
    }
    loadsAllData() {
        return !(this.startSet_ || this.endSet_ || this.limitSet_);
    }
    isDefault() {
        return this.loadsAllData() && this.index_ === $9cf0852385f62d16$var$PRIORITY_INDEX;
    }
    copy() {
        const copy = new $9cf0852385f62d16$export$7ba287e361c94330();
        copy.limitSet_ = this.limitSet_;
        copy.limit_ = this.limit_;
        copy.startSet_ = this.startSet_;
        copy.startAfterSet_ = this.startAfterSet_;
        copy.indexStartValue_ = this.indexStartValue_;
        copy.startNameSet_ = this.startNameSet_;
        copy.indexStartName_ = this.indexStartName_;
        copy.endSet_ = this.endSet_;
        copy.endBeforeSet_ = this.endBeforeSet_;
        copy.indexEndValue_ = this.indexEndValue_;
        copy.endNameSet_ = this.endNameSet_;
        copy.indexEndName_ = this.indexEndName_;
        copy.index_ = this.index_;
        copy.viewFrom_ = this.viewFrom_;
        return copy;
    }
}
function $9cf0852385f62d16$var$queryParamsGetNodeFilter(queryParams) {
    if (queryParams.loadsAllData()) return new $9cf0852385f62d16$var$IndexedFilter(queryParams.getIndex());
    else if (queryParams.hasLimit()) return new $9cf0852385f62d16$var$LimitedFilter(queryParams);
    else return new $9cf0852385f62d16$var$RangedFilter(queryParams);
}
function $9cf0852385f62d16$var$queryParamsLimitToFirst(queryParams, newLimit) {
    const newParams = queryParams.copy();
    newParams.limitSet_ = true;
    newParams.limit_ = newLimit;
    newParams.viewFrom_ = "l" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT */ ;
    return newParams;
}
function $9cf0852385f62d16$var$queryParamsLimitToLast(queryParams, newLimit) {
    const newParams = queryParams.copy();
    newParams.limitSet_ = true;
    newParams.limit_ = newLimit;
    newParams.viewFrom_ = "r" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT */ ;
    return newParams;
}
function $9cf0852385f62d16$var$queryParamsStartAt(queryParams, indexValue, key) {
    const newParams = queryParams.copy();
    newParams.startSet_ = true;
    if (indexValue === undefined) indexValue = null;
    newParams.indexStartValue_ = indexValue;
    if (key != null) {
        newParams.startNameSet_ = true;
        newParams.indexStartName_ = key;
    } else {
        newParams.startNameSet_ = false;
        newParams.indexStartName_ = '';
    }
    return newParams;
}
function $9cf0852385f62d16$var$queryParamsStartAfter(queryParams, indexValue, key) {
    let params;
    if (queryParams.index_ === $9cf0852385f62d16$var$KEY_INDEX || !!key) params = $9cf0852385f62d16$var$queryParamsStartAt(queryParams, indexValue, key);
    else params = $9cf0852385f62d16$var$queryParamsStartAt(queryParams, indexValue, $9cf0852385f62d16$var$MAX_NAME);
    params.startAfterSet_ = true;
    return params;
}
function $9cf0852385f62d16$var$queryParamsEndAt(queryParams, indexValue, key) {
    const newParams = queryParams.copy();
    newParams.endSet_ = true;
    if (indexValue === undefined) indexValue = null;
    newParams.indexEndValue_ = indexValue;
    if (key !== undefined) {
        newParams.endNameSet_ = true;
        newParams.indexEndName_ = key;
    } else {
        newParams.endNameSet_ = false;
        newParams.indexEndName_ = '';
    }
    return newParams;
}
function $9cf0852385f62d16$var$queryParamsEndBefore(queryParams, indexValue, key) {
    let params;
    if (queryParams.index_ === $9cf0852385f62d16$var$KEY_INDEX || !!key) params = $9cf0852385f62d16$var$queryParamsEndAt(queryParams, indexValue, key);
    else params = $9cf0852385f62d16$var$queryParamsEndAt(queryParams, indexValue, $9cf0852385f62d16$var$MIN_NAME);
    params.endBeforeSet_ = true;
    return params;
}
function $9cf0852385f62d16$var$queryParamsOrderBy(queryParams, index) {
    const newParams = queryParams.copy();
    newParams.index_ = index;
    return newParams;
}
/**
 * Returns a set of REST query string parameters representing this query.
 *
 * @returns query string parameters
 */ function $9cf0852385f62d16$var$queryParamsToRestQueryStringParameters(queryParams) {
    const qs = {};
    if (queryParams.isDefault()) return qs;
    let orderBy;
    if (queryParams.index_ === $9cf0852385f62d16$var$PRIORITY_INDEX) orderBy = "$priority" /* REST_QUERY_CONSTANTS.PRIORITY_INDEX */ ;
    else if (queryParams.index_ === $9cf0852385f62d16$var$VALUE_INDEX) orderBy = "$value" /* REST_QUERY_CONSTANTS.VALUE_INDEX */ ;
    else if (queryParams.index_ === $9cf0852385f62d16$var$KEY_INDEX) orderBy = "$key" /* REST_QUERY_CONSTANTS.KEY_INDEX */ ;
    else {
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(queryParams.index_ instanceof $9cf0852385f62d16$var$PathIndex, 'Unrecognized index type!');
        orderBy = queryParams.index_.toString();
    }
    qs["orderBy" /* REST_QUERY_CONSTANTS.ORDER_BY */ ] = (0, $3117f6f4eeb4c314$export$fac44ee5b035f737)(orderBy);
    if (queryParams.startSet_) {
        const startParam = queryParams.startAfterSet_ ? "startAfter" /* REST_QUERY_CONSTANTS.START_AFTER */  : "startAt" /* REST_QUERY_CONSTANTS.START_AT */ ;
        qs[startParam] = (0, $3117f6f4eeb4c314$export$fac44ee5b035f737)(queryParams.indexStartValue_);
        if (queryParams.startNameSet_) qs[startParam] += ',' + (0, $3117f6f4eeb4c314$export$fac44ee5b035f737)(queryParams.indexStartName_);
    }
    if (queryParams.endSet_) {
        const endParam = queryParams.endBeforeSet_ ? "endBefore" /* REST_QUERY_CONSTANTS.END_BEFORE */  : "endAt" /* REST_QUERY_CONSTANTS.END_AT */ ;
        qs[endParam] = (0, $3117f6f4eeb4c314$export$fac44ee5b035f737)(queryParams.indexEndValue_);
        if (queryParams.endNameSet_) qs[endParam] += ',' + (0, $3117f6f4eeb4c314$export$fac44ee5b035f737)(queryParams.indexEndName_);
    }
    if (queryParams.limitSet_) {
        if (queryParams.isViewFromLeft()) qs["limitToFirst" /* REST_QUERY_CONSTANTS.LIMIT_TO_FIRST */ ] = queryParams.limit_;
        else qs["limitToLast" /* REST_QUERY_CONSTANTS.LIMIT_TO_LAST */ ] = queryParams.limit_;
    }
    return qs;
}
function $9cf0852385f62d16$var$queryParamsGetQueryObject(queryParams) {
    const obj = {};
    if (queryParams.startSet_) {
        obj["sp" /* WIRE_PROTOCOL_CONSTANTS.INDEX_START_VALUE */ ] = queryParams.indexStartValue_;
        if (queryParams.startNameSet_) obj["sn" /* WIRE_PROTOCOL_CONSTANTS.INDEX_START_NAME */ ] = queryParams.indexStartName_;
        obj["sin" /* WIRE_PROTOCOL_CONSTANTS.INDEX_START_IS_INCLUSIVE */ ] = !queryParams.startAfterSet_;
    }
    if (queryParams.endSet_) {
        obj["ep" /* WIRE_PROTOCOL_CONSTANTS.INDEX_END_VALUE */ ] = queryParams.indexEndValue_;
        if (queryParams.endNameSet_) obj["en" /* WIRE_PROTOCOL_CONSTANTS.INDEX_END_NAME */ ] = queryParams.indexEndName_;
        obj["ein" /* WIRE_PROTOCOL_CONSTANTS.INDEX_END_IS_INCLUSIVE */ ] = !queryParams.endBeforeSet_;
    }
    if (queryParams.limitSet_) {
        obj["l" /* WIRE_PROTOCOL_CONSTANTS.LIMIT */ ] = queryParams.limit_;
        let viewFrom = queryParams.viewFrom_;
        if (viewFrom === '') {
            if (queryParams.isViewFromLeft()) viewFrom = "l" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT */ ;
            else viewFrom = "r" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT */ ;
        }
        obj["vf" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM */ ] = viewFrom;
    }
    // For now, priority index is the default, so we only specify if it's some other index
    if (queryParams.index_ !== $9cf0852385f62d16$var$PRIORITY_INDEX) obj["i" /* WIRE_PROTOCOL_CONSTANTS.INDEX */ ] = queryParams.index_.toString();
    return obj;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An implementation of ServerActions that communicates with the server via REST requests.
 * This is mostly useful for compatibility with crawlers, where we don't want to spin up a full
 * persistent connection (using WebSockets or long-polling)
 */ class $9cf0852385f62d16$var$ReadonlyRestClient extends $9cf0852385f62d16$var$ServerActions {
    reportStats(stats) {
        throw new Error('Method not implemented.');
    }
    static getListenId_(query, tag) {
        if (tag !== undefined) return 'tag$' + tag;
        else {
            (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(query._queryParams.isDefault(), "should have a tag if it's not a default query.");
            return query._path.toString();
        }
    }
    /**
     * @param repoInfo_ - Data about the namespace we are connecting to
     * @param onDataUpdate_ - A callback for new data from the server
     */ constructor(repoInfo_, onDataUpdate_, authTokenProvider_, appCheckTokenProvider_){
        super();
        this.repoInfo_ = repoInfo_;
        this.onDataUpdate_ = onDataUpdate_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckTokenProvider_ = appCheckTokenProvider_;
        /** @private {function(...[*])} */ this.log_ = $9cf0852385f62d16$var$logWrapper('p:rest:');
        /**
         * We don't actually need to track listens, except to prevent us calling an onComplete for a listen
         * that's been removed. :-/
         */ this.listens_ = {};
    }
    /** @inheritDoc */ listen(query, currentHashFn, tag, onComplete) {
        const pathString = query._path.toString();
        this.log_('Listen called for ' + pathString + ' ' + query._queryIdentifier);
        // Mark this listener so we can tell if it's removed.
        const listenId = $9cf0852385f62d16$var$ReadonlyRestClient.getListenId_(query, tag);
        const thisListen = {};
        this.listens_[listenId] = thisListen;
        const queryStringParameters = $9cf0852385f62d16$var$queryParamsToRestQueryStringParameters(query._queryParams);
        this.restRequest_(pathString + '.json', queryStringParameters, (error, result)=>{
            let data = result;
            if (error === 404) {
                data = null;
                error = null;
            }
            if (error === null) this.onDataUpdate_(pathString, data, /*isMerge=*/ false, tag);
            if ((0, $3117f6f4eeb4c314$export$e51ae4db7b428f67)(this.listens_, listenId) === thisListen) {
                let status;
                if (!error) status = 'ok';
                else if (error === 401) status = 'permission_denied';
                else status = 'rest_error:' + error;
                onComplete(status, null);
            }
        });
    }
    /** @inheritDoc */ unlisten(query, tag) {
        const listenId = $9cf0852385f62d16$var$ReadonlyRestClient.getListenId_(query, tag);
        delete this.listens_[listenId];
    }
    get(query) {
        const queryStringParameters = $9cf0852385f62d16$var$queryParamsToRestQueryStringParameters(query._queryParams);
        const pathString = query._path.toString();
        const deferred = new (0, $3117f6f4eeb4c314$export$85f6557964517f1a)();
        this.restRequest_(pathString + '.json', queryStringParameters, (error, result)=>{
            let data = result;
            if (error === 404) {
                data = null;
                error = null;
            }
            if (error === null) {
                this.onDataUpdate_(pathString, data, /*isMerge=*/ false, /*tag=*/ null);
                deferred.resolve(data);
            } else deferred.reject(new Error(data));
        });
        return deferred.promise;
    }
    /** @inheritDoc */ refreshAuthToken(token) {
    // no-op since we just always call getToken.
    }
    /**
     * Performs a REST request to the given path, with the provided query string parameters,
     * and any auth credentials we have.
     */ restRequest_(pathString, queryStringParameters = {}, callback) {
        queryStringParameters['format'] = 'export';
        return Promise.all([
            this.authTokenProvider_.getToken(/*forceRefresh=*/ false),
            this.appCheckTokenProvider_.getToken(/*forceRefresh=*/ false)
        ]).then(([authToken, appCheckToken])=>{
            if (authToken && authToken.accessToken) queryStringParameters['auth'] = authToken.accessToken;
            if (appCheckToken && appCheckToken.token) queryStringParameters['ac'] = appCheckToken.token;
            const url = (this.repoInfo_.secure ? 'https://' : 'http://') + this.repoInfo_.host + pathString + '?' + 'ns=' + this.repoInfo_.namespace + (0, $3117f6f4eeb4c314$export$ac4103b836844853)(queryStringParameters);
            this.log_('Sending REST request for ' + url);
            const xhr = new XMLHttpRequest();
            xhr.onreadystatechange = ()=>{
                if (callback && xhr.readyState === 4) {
                    this.log_('REST Response for ' + url + ' received. status:', xhr.status, 'response:', xhr.responseText);
                    let res = null;
                    if (xhr.status >= 200 && xhr.status < 300) {
                        try {
                            res = (0, $3117f6f4eeb4c314$export$c5a53ce6a17cf18d)(xhr.responseText);
                        } catch (e) {
                            $9cf0852385f62d16$var$warn('Failed to parse JSON response for ' + url + ': ' + xhr.responseText);
                        }
                        callback(null, res);
                    } else {
                        // 401 and 404 are expected.
                        if (xhr.status !== 401 && xhr.status !== 404) $9cf0852385f62d16$var$warn('Got unsuccessful REST response for ' + url + ' Status: ' + xhr.status);
                        callback(xhr.status);
                    }
                    callback = null;
                }
            };
            xhr.open('GET', url, /*asynchronous=*/ true);
            xhr.send();
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Mutable object which basically just stores a reference to the "latest" immutable snapshot.
 */ class $9cf0852385f62d16$var$SnapshotHolder {
    constructor(){
        this.rootNode_ = $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE;
    }
    getNode(path) {
        return this.rootNode_.getChild(path);
    }
    updateSnapshot(path, newSnapshotNode) {
        this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9cf0852385f62d16$var$newSparseSnapshotTree() {
    return {
        value: null,
        children: new Map()
    };
}
/**
 * Stores the given node at the specified path. If there is already a node
 * at a shallower path, it merges the new data into that snapshot node.
 *
 * @param path - Path to look up snapshot for.
 * @param data - The new data, or null.
 */ function $9cf0852385f62d16$var$sparseSnapshotTreeRemember(sparseSnapshotTree, path, data) {
    if ($9cf0852385f62d16$var$pathIsEmpty(path)) {
        sparseSnapshotTree.value = data;
        sparseSnapshotTree.children.clear();
    } else if (sparseSnapshotTree.value !== null) sparseSnapshotTree.value = sparseSnapshotTree.value.updateChild(path, data);
    else {
        const childKey = $9cf0852385f62d16$var$pathGetFront(path);
        if (!sparseSnapshotTree.children.has(childKey)) sparseSnapshotTree.children.set(childKey, $9cf0852385f62d16$var$newSparseSnapshotTree());
        const child = sparseSnapshotTree.children.get(childKey);
        path = $9cf0852385f62d16$var$pathPopFront(path);
        $9cf0852385f62d16$var$sparseSnapshotTreeRemember(child, path, data);
    }
}
/**
 * Purge the data at path from the cache.
 *
 * @param path - Path to look up snapshot for.
 * @returns True if this node should now be removed.
 */ function $9cf0852385f62d16$var$sparseSnapshotTreeForget(sparseSnapshotTree, path) {
    if ($9cf0852385f62d16$var$pathIsEmpty(path)) {
        sparseSnapshotTree.value = null;
        sparseSnapshotTree.children.clear();
        return true;
    } else {
        if (sparseSnapshotTree.value !== null) {
            if (sparseSnapshotTree.value.isLeafNode()) // We're trying to forget a node that doesn't exist
            return false;
            else {
                const value = sparseSnapshotTree.value;
                sparseSnapshotTree.value = null;
                value.forEachChild($9cf0852385f62d16$var$PRIORITY_INDEX, (key, tree)=>{
                    $9cf0852385f62d16$var$sparseSnapshotTreeRemember(sparseSnapshotTree, new $9cf0852385f62d16$var$Path(key), tree);
                });
                return $9cf0852385f62d16$var$sparseSnapshotTreeForget(sparseSnapshotTree, path);
            }
        } else if (sparseSnapshotTree.children.size > 0) {
            const childKey = $9cf0852385f62d16$var$pathGetFront(path);
            path = $9cf0852385f62d16$var$pathPopFront(path);
            if (sparseSnapshotTree.children.has(childKey)) {
                const safeToRemove = $9cf0852385f62d16$var$sparseSnapshotTreeForget(sparseSnapshotTree.children.get(childKey), path);
                if (safeToRemove) sparseSnapshotTree.children.delete(childKey);
            }
            return sparseSnapshotTree.children.size === 0;
        } else return true;
    }
}
/**
 * Recursively iterates through all of the stored tree and calls the
 * callback on each one.
 *
 * @param prefixPath - Path to look up node for.
 * @param func - The function to invoke for each tree.
 */ function $9cf0852385f62d16$var$sparseSnapshotTreeForEachTree(sparseSnapshotTree, prefixPath, func) {
    if (sparseSnapshotTree.value !== null) func(prefixPath, sparseSnapshotTree.value);
    else $9cf0852385f62d16$var$sparseSnapshotTreeForEachChild(sparseSnapshotTree, (key, tree)=>{
        const path = new $9cf0852385f62d16$var$Path(prefixPath.toString() + '/' + key);
        $9cf0852385f62d16$var$sparseSnapshotTreeForEachTree(tree, path, func);
    });
}
/**
 * Iterates through each immediate child and triggers the callback.
 * Only seems to be used in tests.
 *
 * @param func - The function to invoke for each child.
 */ function $9cf0852385f62d16$var$sparseSnapshotTreeForEachChild(sparseSnapshotTree, func) {
    sparseSnapshotTree.children.forEach((tree, key)=>{
        func(key, tree);
    });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the delta from the previous call to get stats.
 *
 * @param collection_ - The collection to "listen" to.
 */ class $9cf0852385f62d16$var$StatsListener {
    constructor(collection_){
        this.collection_ = collection_;
        this.last_ = null;
    }
    get() {
        const newStats = this.collection_.get();
        const delta = {
            ...newStats
        };
        if (this.last_) $9cf0852385f62d16$var$each(this.last_, (stat, value)=>{
            delta[stat] = delta[stat] - value;
        });
        this.last_ = newStats;
        return delta;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Assuming some apps may have a short amount of time on page, and a bulk of firebase operations probably
// happen on page load, we try to report our first set of stats pretty quickly, but we wait at least 10
// seconds to try to ensure the Firebase connection is established / settled.
const $9cf0852385f62d16$var$FIRST_STATS_MIN_TIME = 10000;
const $9cf0852385f62d16$var$FIRST_STATS_MAX_TIME = 30000;
// We'll continue to report stats on average every 5 minutes.
const $9cf0852385f62d16$var$REPORT_STATS_INTERVAL = 300000;
class $9cf0852385f62d16$var$StatsReporter {
    constructor(collection, server_){
        this.server_ = server_;
        this.statsToReport_ = {};
        this.statsListener_ = new $9cf0852385f62d16$var$StatsListener(collection);
        const timeout = $9cf0852385f62d16$var$FIRST_STATS_MIN_TIME + ($9cf0852385f62d16$var$FIRST_STATS_MAX_TIME - $9cf0852385f62d16$var$FIRST_STATS_MIN_TIME) * Math.random();
        $9cf0852385f62d16$var$setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(timeout));
    }
    reportStats_() {
        const stats = this.statsListener_.get();
        const reportedStats = {};
        let haveStatsToReport = false;
        $9cf0852385f62d16$var$each(stats, (stat, value)=>{
            if (value > 0 && (0, $3117f6f4eeb4c314$export$2344b14b097df817)(this.statsToReport_, stat)) {
                reportedStats[stat] = value;
                haveStatsToReport = true;
            }
        });
        if (haveStatsToReport) this.server_.reportStats(reportedStats);
        // queue our next run.
        $9cf0852385f62d16$var$setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * $9cf0852385f62d16$var$REPORT_STATS_INTERVAL));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 *
 * @enum
 */ var $9cf0852385f62d16$var$OperationType;
(function(OperationType) {
    OperationType[OperationType["OVERWRITE"] = 0] = "OVERWRITE";
    OperationType[OperationType["MERGE"] = 1] = "MERGE";
    OperationType[OperationType["ACK_USER_WRITE"] = 2] = "ACK_USER_WRITE";
    OperationType[OperationType["LISTEN_COMPLETE"] = 3] = "LISTEN_COMPLETE";
})($9cf0852385f62d16$var$OperationType || ($9cf0852385f62d16$var$OperationType = {}));
function $9cf0852385f62d16$var$newOperationSourceUser() {
    return {
        fromUser: true,
        fromServer: false,
        queryId: null,
        tagged: false
    };
}
function $9cf0852385f62d16$var$newOperationSourceServer() {
    return {
        fromUser: false,
        fromServer: true,
        queryId: null,
        tagged: false
    };
}
function $9cf0852385f62d16$var$newOperationSourceServerTaggedQuery(queryId) {
    return {
        fromUser: false,
        fromServer: true,
        queryId: queryId,
        tagged: true
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9cf0852385f62d16$var$AckUserWrite {
    /**
     * @param affectedTree - A tree containing true for each affected path. Affected paths can't overlap.
     */ constructor(/** @inheritDoc */ path, /** @inheritDoc */ affectedTree, /** @inheritDoc */ revert){
        this.path = path;
        this.affectedTree = affectedTree;
        this.revert = revert;
        /** @inheritDoc */ this.type = $9cf0852385f62d16$var$OperationType.ACK_USER_WRITE;
        /** @inheritDoc */ this.source = $9cf0852385f62d16$var$newOperationSourceUser();
    }
    operationForChild(childName) {
        if (!$9cf0852385f62d16$var$pathIsEmpty(this.path)) {
            (0, $3117f6f4eeb4c314$export$a7a9523472993e97)($9cf0852385f62d16$var$pathGetFront(this.path) === childName, 'operationForChild called for unrelated child.');
            return new $9cf0852385f62d16$var$AckUserWrite($9cf0852385f62d16$var$pathPopFront(this.path), this.affectedTree, this.revert);
        } else if (this.affectedTree.value != null) {
            (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(this.affectedTree.children.isEmpty(), 'affectedTree should not have overlapping affected paths.');
            // All child locations are affected as well; just return same operation.
            return this;
        } else {
            const childTree = this.affectedTree.subtree(new $9cf0852385f62d16$var$Path(childName));
            return new $9cf0852385f62d16$var$AckUserWrite($9cf0852385f62d16$var$newEmptyPath(), childTree, this.revert);
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9cf0852385f62d16$var$ListenComplete {
    constructor(source, path){
        this.source = source;
        this.path = path;
        /** @inheritDoc */ this.type = $9cf0852385f62d16$var$OperationType.LISTEN_COMPLETE;
    }
    operationForChild(childName) {
        if ($9cf0852385f62d16$var$pathIsEmpty(this.path)) return new $9cf0852385f62d16$var$ListenComplete(this.source, $9cf0852385f62d16$var$newEmptyPath());
        else return new $9cf0852385f62d16$var$ListenComplete(this.source, $9cf0852385f62d16$var$pathPopFront(this.path));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9cf0852385f62d16$var$Overwrite {
    constructor(source, path, snap){
        this.source = source;
        this.path = path;
        this.snap = snap;
        /** @inheritDoc */ this.type = $9cf0852385f62d16$var$OperationType.OVERWRITE;
    }
    operationForChild(childName) {
        if ($9cf0852385f62d16$var$pathIsEmpty(this.path)) return new $9cf0852385f62d16$var$Overwrite(this.source, $9cf0852385f62d16$var$newEmptyPath(), this.snap.getImmediateChild(childName));
        else return new $9cf0852385f62d16$var$Overwrite(this.source, $9cf0852385f62d16$var$pathPopFront(this.path), this.snap);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9cf0852385f62d16$var$Merge {
    constructor(/** @inheritDoc */ source, /** @inheritDoc */ path, /** @inheritDoc */ children){
        this.source = source;
        this.path = path;
        this.children = children;
        /** @inheritDoc */ this.type = $9cf0852385f62d16$var$OperationType.MERGE;
    }
    operationForChild(childName) {
        if ($9cf0852385f62d16$var$pathIsEmpty(this.path)) {
            const childTree = this.children.subtree(new $9cf0852385f62d16$var$Path(childName));
            if (childTree.isEmpty()) // This child is unaffected
            return null;
            else if (childTree.value) // We have a snapshot for the child in question.  This becomes an overwrite of the child.
            return new $9cf0852385f62d16$var$Overwrite(this.source, $9cf0852385f62d16$var$newEmptyPath(), childTree.value);
            else // This is a merge at a deeper level
            return new $9cf0852385f62d16$var$Merge(this.source, $9cf0852385f62d16$var$newEmptyPath(), childTree);
        } else {
            (0, $3117f6f4eeb4c314$export$a7a9523472993e97)($9cf0852385f62d16$var$pathGetFront(this.path) === childName, "Can't get a merge for a child not on the path of the operation");
            return new $9cf0852385f62d16$var$Merge(this.source, $9cf0852385f62d16$var$pathPopFront(this.path), this.children);
        }
    }
    toString() {
        return 'Operation(' + this.path + ': ' + this.source.toString() + ' merge: ' + this.children.toString() + ')';
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A cache node only stores complete children. Additionally it holds a flag whether the node can be considered fully
 * initialized in the sense that we know at one point in time this represented a valid state of the world, e.g.
 * initialized with data from the server, or a complete overwrite by the client. The filtered flag also tracks
 * whether a node potentially had children removed due to a filter.
 */ class $9cf0852385f62d16$var$CacheNode {
    constructor(node_, fullyInitialized_, filtered_){
        this.node_ = node_;
        this.fullyInitialized_ = fullyInitialized_;
        this.filtered_ = filtered_;
    }
    /**
     * Returns whether this node was fully initialized with either server data or a complete overwrite by the client
     */ isFullyInitialized() {
        return this.fullyInitialized_;
    }
    /**
     * Returns whether this node is potentially missing children due to a filter applied to the node
     */ isFiltered() {
        return this.filtered_;
    }
    isCompleteForPath(path) {
        if ($9cf0852385f62d16$var$pathIsEmpty(path)) return this.isFullyInitialized() && !this.filtered_;
        const childKey = $9cf0852385f62d16$var$pathGetFront(path);
        return this.isCompleteForChild(childKey);
    }
    isCompleteForChild(key) {
        return this.isFullyInitialized() && !this.filtered_ || this.node_.hasChild(key);
    }
    getNode() {
        return this.node_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An EventGenerator is used to convert "raw" changes (Change) as computed by the
 * CacheDiffer into actual events (Event) that can be raised.  See generateEventsForChanges()
 * for details.
 *
 */ class $9cf0852385f62d16$var$EventGenerator {
    constructor(query_){
        this.query_ = query_;
        this.index_ = this.query_._queryParams.getIndex();
    }
}
/**
 * Given a set of raw changes (no moved events and prevName not specified yet), and a set of
 * EventRegistrations that should be notified of these changes, generate the actual events to be raised.
 *
 * Notes:
 *  - child_moved events will be synthesized at this time for any child_changed events that affect
 *    our index.
 *  - prevName will be calculated based on the index ordering.
 */ function $9cf0852385f62d16$var$eventGeneratorGenerateEventsForChanges(eventGenerator, changes, eventCache, eventRegistrations) {
    const events = [];
    const moves = [];
    changes.forEach((change)=>{
        if (change.type === "child_changed" /* ChangeType.CHILD_CHANGED */  && eventGenerator.index_.indexedValueChanged(change.oldSnap, change.snapshotNode)) moves.push($9cf0852385f62d16$var$changeChildMoved(change.childName, change.snapshotNode));
    });
    $9cf0852385f62d16$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_removed" /* ChangeType.CHILD_REMOVED */ , changes, eventRegistrations, eventCache);
    $9cf0852385f62d16$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_added" /* ChangeType.CHILD_ADDED */ , changes, eventRegistrations, eventCache);
    $9cf0852385f62d16$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_moved" /* ChangeType.CHILD_MOVED */ , moves, eventRegistrations, eventCache);
    $9cf0852385f62d16$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_changed" /* ChangeType.CHILD_CHANGED */ , changes, eventRegistrations, eventCache);
    $9cf0852385f62d16$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "value" /* ChangeType.VALUE */ , changes, eventRegistrations, eventCache);
    return events;
}
/**
 * Given changes of a single change type, generate the corresponding events.
 */ function $9cf0852385f62d16$var$eventGeneratorGenerateEventsForType(eventGenerator, events, eventType, changes, registrations, eventCache) {
    const filteredChanges = changes.filter((change)=>change.type === eventType);
    filteredChanges.sort((a, b)=>$9cf0852385f62d16$var$eventGeneratorCompareChanges(eventGenerator, a, b));
    filteredChanges.forEach((change)=>{
        const materializedChange = $9cf0852385f62d16$var$eventGeneratorMaterializeSingleChange(eventGenerator, change, eventCache);
        registrations.forEach((registration)=>{
            if (registration.respondsTo(change.type)) events.push(registration.createEvent(materializedChange, eventGenerator.query_));
        });
    });
}
function $9cf0852385f62d16$var$eventGeneratorMaterializeSingleChange(eventGenerator, change, eventCache) {
    if (change.type === 'value' || change.type === 'child_removed') return change;
    else {
        change.prevName = eventCache.getPredecessorChildName(change.childName, change.snapshotNode, eventGenerator.index_);
        return change;
    }
}
function $9cf0852385f62d16$var$eventGeneratorCompareChanges(eventGenerator, a, b) {
    if (a.childName == null || b.childName == null) throw (0, $3117f6f4eeb4c314$export$a39cad550e7ab28a)('Should only compare child_ events.');
    const aWrapped = new $9cf0852385f62d16$var$NamedNode(a.childName, a.snapshotNode);
    const bWrapped = new $9cf0852385f62d16$var$NamedNode(b.childName, b.snapshotNode);
    return eventGenerator.index_.compare(aWrapped, bWrapped);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9cf0852385f62d16$var$newViewCache(eventCache, serverCache) {
    return {
        eventCache: eventCache,
        serverCache: serverCache
    };
}
function $9cf0852385f62d16$var$viewCacheUpdateEventSnap(viewCache, eventSnap, complete, filtered) {
    return $9cf0852385f62d16$var$newViewCache(new $9cf0852385f62d16$var$CacheNode(eventSnap, complete, filtered), viewCache.serverCache);
}
function $9cf0852385f62d16$var$viewCacheUpdateServerSnap(viewCache, serverSnap, complete, filtered) {
    return $9cf0852385f62d16$var$newViewCache(viewCache.eventCache, new $9cf0852385f62d16$var$CacheNode(serverSnap, complete, filtered));
}
function $9cf0852385f62d16$var$viewCacheGetCompleteEventSnap(viewCache) {
    return viewCache.eventCache.isFullyInitialized() ? viewCache.eventCache.getNode() : null;
}
function $9cf0852385f62d16$var$viewCacheGetCompleteServerSnap(viewCache) {
    return viewCache.serverCache.isFullyInitialized() ? viewCache.serverCache.getNode() : null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $9cf0852385f62d16$var$emptyChildrenSingleton;
/**
 * Singleton empty children collection.
 *
 */ const $9cf0852385f62d16$var$EmptyChildren = ()=>{
    if (!$9cf0852385f62d16$var$emptyChildrenSingleton) $9cf0852385f62d16$var$emptyChildrenSingleton = new $9cf0852385f62d16$var$SortedMap($9cf0852385f62d16$var$stringCompare);
    return $9cf0852385f62d16$var$emptyChildrenSingleton;
};
/**
 * A tree with immutable elements.
 */ class $9cf0852385f62d16$var$ImmutableTree {
    static fromObject(obj) {
        let tree = new $9cf0852385f62d16$var$ImmutableTree(null);
        $9cf0852385f62d16$var$each(obj, (childPath, childSnap)=>{
            tree = tree.set(new $9cf0852385f62d16$var$Path(childPath), childSnap);
        });
        return tree;
    }
    constructor(value, children = $9cf0852385f62d16$var$EmptyChildren()){
        this.value = value;
        this.children = children;
    }
    /**
     * True if the value is empty and there are no children
     */ isEmpty() {
        return this.value === null && this.children.isEmpty();
    }
    /**
     * Given a path and predicate, return the first node and the path to that node
     * where the predicate returns true.
     *
     * TODO Do a perf test -- If we're creating a bunch of `{path: value:}`
     * objects on the way back out, it may be better to pass down a pathSoFar obj.
     *
     * @param relativePath - The remainder of the path
     * @param predicate - The predicate to satisfy to return a node
     */ findRootMostMatchingPathAndValue(relativePath, predicate) {
        if (this.value != null && predicate(this.value)) return {
            path: $9cf0852385f62d16$var$newEmptyPath(),
            value: this.value
        };
        else {
            if ($9cf0852385f62d16$var$pathIsEmpty(relativePath)) return null;
            else {
                const front = $9cf0852385f62d16$var$pathGetFront(relativePath);
                const child = this.children.get(front);
                if (child !== null) {
                    const childExistingPathAndValue = child.findRootMostMatchingPathAndValue($9cf0852385f62d16$var$pathPopFront(relativePath), predicate);
                    if (childExistingPathAndValue != null) {
                        const fullPath = $9cf0852385f62d16$var$pathChild(new $9cf0852385f62d16$var$Path(front), childExistingPathAndValue.path);
                        return {
                            path: fullPath,
                            value: childExistingPathAndValue.value
                        };
                    } else return null;
                } else return null;
            }
        }
    }
    /**
     * Find, if it exists, the shortest subpath of the given path that points a defined
     * value in the tree
     */ findRootMostValueAndPath(relativePath) {
        return this.findRootMostMatchingPathAndValue(relativePath, ()=>true);
    }
    /**
     * @returns The subtree at the given path
     */ subtree(relativePath) {
        if ($9cf0852385f62d16$var$pathIsEmpty(relativePath)) return this;
        else {
            const front = $9cf0852385f62d16$var$pathGetFront(relativePath);
            const childTree = this.children.get(front);
            if (childTree !== null) return childTree.subtree($9cf0852385f62d16$var$pathPopFront(relativePath));
            else return new $9cf0852385f62d16$var$ImmutableTree(null);
        }
    }
    /**
     * Sets a value at the specified path.
     *
     * @param relativePath - Path to set value at.
     * @param toSet - Value to set.
     * @returns Resulting tree.
     */ set(relativePath, toSet) {
        if ($9cf0852385f62d16$var$pathIsEmpty(relativePath)) return new $9cf0852385f62d16$var$ImmutableTree(toSet, this.children);
        else {
            const front = $9cf0852385f62d16$var$pathGetFront(relativePath);
            const child = this.children.get(front) || new $9cf0852385f62d16$var$ImmutableTree(null);
            const newChild = child.set($9cf0852385f62d16$var$pathPopFront(relativePath), toSet);
            const newChildren = this.children.insert(front, newChild);
            return new $9cf0852385f62d16$var$ImmutableTree(this.value, newChildren);
        }
    }
    /**
     * Removes the value at the specified path.
     *
     * @param relativePath - Path to value to remove.
     * @returns Resulting tree.
     */ remove(relativePath) {
        if ($9cf0852385f62d16$var$pathIsEmpty(relativePath)) {
            if (this.children.isEmpty()) return new $9cf0852385f62d16$var$ImmutableTree(null);
            else return new $9cf0852385f62d16$var$ImmutableTree(null, this.children);
        } else {
            const front = $9cf0852385f62d16$var$pathGetFront(relativePath);
            const child = this.children.get(front);
            if (child) {
                const newChild = child.remove($9cf0852385f62d16$var$pathPopFront(relativePath));
                let newChildren;
                if (newChild.isEmpty()) newChildren = this.children.remove(front);
                else newChildren = this.children.insert(front, newChild);
                if (this.value === null && newChildren.isEmpty()) return new $9cf0852385f62d16$var$ImmutableTree(null);
                else return new $9cf0852385f62d16$var$ImmutableTree(this.value, newChildren);
            } else return this;
        }
    }
    /**
     * Gets a value from the tree.
     *
     * @param relativePath - Path to get value for.
     * @returns Value at path, or null.
     */ get(relativePath) {
        if ($9cf0852385f62d16$var$pathIsEmpty(relativePath)) return this.value;
        else {
            const front = $9cf0852385f62d16$var$pathGetFront(relativePath);
            const child = this.children.get(front);
            if (child) return child.get($9cf0852385f62d16$var$pathPopFront(relativePath));
            else return null;
        }
    }
    /**
     * Replace the subtree at the specified path with the given new tree.
     *
     * @param relativePath - Path to replace subtree for.
     * @param newTree - New tree.
     * @returns Resulting tree.
     */ setTree(relativePath, newTree) {
        if ($9cf0852385f62d16$var$pathIsEmpty(relativePath)) return newTree;
        else {
            const front = $9cf0852385f62d16$var$pathGetFront(relativePath);
            const child = this.children.get(front) || new $9cf0852385f62d16$var$ImmutableTree(null);
            const newChild = child.setTree($9cf0852385f62d16$var$pathPopFront(relativePath), newTree);
            let newChildren;
            if (newChild.isEmpty()) newChildren = this.children.remove(front);
            else newChildren = this.children.insert(front, newChild);
            return new $9cf0852385f62d16$var$ImmutableTree(this.value, newChildren);
        }
    }
    /**
     * Performs a depth first fold on this tree. Transforms a tree into a single
     * value, given a function that operates on the path to a node, an optional
     * current value, and a map of child names to folded subtrees
     */ fold(fn) {
        return this.fold_($9cf0852385f62d16$var$newEmptyPath(), fn);
    }
    /**
     * Recursive helper for public-facing fold() method
     */ fold_(pathSoFar, fn) {
        const accum = {};
        this.children.inorderTraversal((childKey, childTree)=>{
            accum[childKey] = childTree.fold_($9cf0852385f62d16$var$pathChild(pathSoFar, childKey), fn);
        });
        return fn(pathSoFar, this.value, accum);
    }
    /**
     * Find the first matching value on the given path. Return the result of applying f to it.
     */ findOnPath(path, f) {
        return this.findOnPath_(path, $9cf0852385f62d16$var$newEmptyPath(), f);
    }
    findOnPath_(pathToFollow, pathSoFar, f) {
        const result = this.value ? f(pathSoFar, this.value) : false;
        if (result) return result;
        else {
            if ($9cf0852385f62d16$var$pathIsEmpty(pathToFollow)) return null;
            else {
                const front = $9cf0852385f62d16$var$pathGetFront(pathToFollow);
                const nextChild = this.children.get(front);
                if (nextChild) return nextChild.findOnPath_($9cf0852385f62d16$var$pathPopFront(pathToFollow), $9cf0852385f62d16$var$pathChild(pathSoFar, front), f);
                else return null;
            }
        }
    }
    foreachOnPath(path, f) {
        return this.foreachOnPath_(path, $9cf0852385f62d16$var$newEmptyPath(), f);
    }
    foreachOnPath_(pathToFollow, currentRelativePath, f) {
        if ($9cf0852385f62d16$var$pathIsEmpty(pathToFollow)) return this;
        else {
            if (this.value) f(currentRelativePath, this.value);
            const front = $9cf0852385f62d16$var$pathGetFront(pathToFollow);
            const nextChild = this.children.get(front);
            if (nextChild) return nextChild.foreachOnPath_($9cf0852385f62d16$var$pathPopFront(pathToFollow), $9cf0852385f62d16$var$pathChild(currentRelativePath, front), f);
            else return new $9cf0852385f62d16$var$ImmutableTree(null);
        }
    }
    /**
     * Calls the given function for each node in the tree that has a value.
     *
     * @param f - A function to be called with the path from the root of the tree to
     * a node, and the value at that node. Called in depth-first order.
     */ foreach(f) {
        this.foreach_($9cf0852385f62d16$var$newEmptyPath(), f);
    }
    foreach_(currentRelativePath, f) {
        this.children.inorderTraversal((childName, childTree)=>{
            childTree.foreach_($9cf0852385f62d16$var$pathChild(currentRelativePath, childName), f);
        });
        if (this.value) f(currentRelativePath, this.value);
    }
    foreachChild(f) {
        this.children.inorderTraversal((childName, childTree)=>{
            if (childTree.value) f(childName, childTree.value);
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class holds a collection of writes that can be applied to nodes in unison. It abstracts away the logic with
 * dealing with priority writes and multiple nested writes. At any given path there is only allowed to be one write
 * modifying that path. Any write to an existing path or shadowing an existing path will modify that existing write
 * to reflect the write added.
 */ class $9cf0852385f62d16$var$CompoundWrite {
    constructor(writeTree_){
        this.writeTree_ = writeTree_;
    }
    static empty() {
        return new $9cf0852385f62d16$var$CompoundWrite(new $9cf0852385f62d16$var$ImmutableTree(null));
    }
}
function $9cf0852385f62d16$var$compoundWriteAddWrite(compoundWrite, path, node) {
    if ($9cf0852385f62d16$var$pathIsEmpty(path)) return new $9cf0852385f62d16$var$CompoundWrite(new $9cf0852385f62d16$var$ImmutableTree(node));
    else {
        const rootmost = compoundWrite.writeTree_.findRootMostValueAndPath(path);
        if (rootmost != null) {
            const rootMostPath = rootmost.path;
            let value = rootmost.value;
            const relativePath = $9cf0852385f62d16$var$newRelativePath(rootMostPath, path);
            value = value.updateChild(relativePath, node);
            return new $9cf0852385f62d16$var$CompoundWrite(compoundWrite.writeTree_.set(rootMostPath, value));
        } else {
            const subtree = new $9cf0852385f62d16$var$ImmutableTree(node);
            const newWriteTree = compoundWrite.writeTree_.setTree(path, subtree);
            return new $9cf0852385f62d16$var$CompoundWrite(newWriteTree);
        }
    }
}
function $9cf0852385f62d16$var$compoundWriteAddWrites(compoundWrite, path, updates) {
    let newWrite = compoundWrite;
    $9cf0852385f62d16$var$each(updates, (childKey, node)=>{
        newWrite = $9cf0852385f62d16$var$compoundWriteAddWrite(newWrite, $9cf0852385f62d16$var$pathChild(path, childKey), node);
    });
    return newWrite;
}
/**
 * Will remove a write at the given path and deeper paths. This will <em>not</em> modify a write at a higher
 * location, which must be removed by calling this method with that path.
 *
 * @param compoundWrite - The CompoundWrite to remove.
 * @param path - The path at which a write and all deeper writes should be removed
 * @returns The new CompoundWrite with the removed path
 */ function $9cf0852385f62d16$var$compoundWriteRemoveWrite(compoundWrite, path) {
    if ($9cf0852385f62d16$var$pathIsEmpty(path)) return $9cf0852385f62d16$var$CompoundWrite.empty();
    else {
        const newWriteTree = compoundWrite.writeTree_.setTree(path, new $9cf0852385f62d16$var$ImmutableTree(null));
        return new $9cf0852385f62d16$var$CompoundWrite(newWriteTree);
    }
}
/**
 * Returns whether this CompoundWrite will fully overwrite a node at a given location and can therefore be
 * considered "complete".
 *
 * @param compoundWrite - The CompoundWrite to check.
 * @param path - The path to check for
 * @returns Whether there is a complete write at that path
 */ function $9cf0852385f62d16$var$compoundWriteHasCompleteWrite(compoundWrite, path) {
    return $9cf0852385f62d16$var$compoundWriteGetCompleteNode(compoundWrite, path) != null;
}
/**
 * Returns a node for a path if and only if the node is a "complete" overwrite at that path. This will not aggregate
 * writes from deeper paths, but will return child nodes from a more shallow path.
 *
 * @param compoundWrite - The CompoundWrite to get the node from.
 * @param path - The path to get a complete write
 * @returns The node if complete at that path, or null otherwise.
 */ function $9cf0852385f62d16$var$compoundWriteGetCompleteNode(compoundWrite, path) {
    const rootmost = compoundWrite.writeTree_.findRootMostValueAndPath(path);
    if (rootmost != null) return compoundWrite.writeTree_.get(rootmost.path).getChild($9cf0852385f62d16$var$newRelativePath(rootmost.path, path));
    else return null;
}
/**
 * Returns all children that are guaranteed to be a complete overwrite.
 *
 * @param compoundWrite - The CompoundWrite to get children from.
 * @returns A list of all complete children.
 */ function $9cf0852385f62d16$var$compoundWriteGetCompleteChildren(compoundWrite) {
    const children = [];
    const node = compoundWrite.writeTree_.value;
    if (node != null) // If it's a leaf node, it has no children; so nothing to do.
    {
        if (!node.isLeafNode()) node.forEachChild($9cf0852385f62d16$var$PRIORITY_INDEX, (childName, childNode)=>{
            children.push(new $9cf0852385f62d16$var$NamedNode(childName, childNode));
        });
    } else compoundWrite.writeTree_.children.inorderTraversal((childName, childTree)=>{
        if (childTree.value != null) children.push(new $9cf0852385f62d16$var$NamedNode(childName, childTree.value));
    });
    return children;
}
function $9cf0852385f62d16$var$compoundWriteChildCompoundWrite(compoundWrite, path) {
    if ($9cf0852385f62d16$var$pathIsEmpty(path)) return compoundWrite;
    else {
        const shadowingNode = $9cf0852385f62d16$var$compoundWriteGetCompleteNode(compoundWrite, path);
        if (shadowingNode != null) return new $9cf0852385f62d16$var$CompoundWrite(new $9cf0852385f62d16$var$ImmutableTree(shadowingNode));
        else return new $9cf0852385f62d16$var$CompoundWrite(compoundWrite.writeTree_.subtree(path));
    }
}
/**
 * Returns true if this CompoundWrite is empty and therefore does not modify any nodes.
 * @returns Whether this CompoundWrite is empty
 */ function $9cf0852385f62d16$var$compoundWriteIsEmpty(compoundWrite) {
    return compoundWrite.writeTree_.isEmpty();
}
/**
 * Applies this CompoundWrite to a node. The node is returned with all writes from this CompoundWrite applied to the
 * node
 * @param node - The node to apply this CompoundWrite to
 * @returns The node with all writes applied
 */ function $9cf0852385f62d16$var$compoundWriteApply(compoundWrite, node) {
    return $9cf0852385f62d16$var$applySubtreeWrite($9cf0852385f62d16$var$newEmptyPath(), compoundWrite.writeTree_, node);
}
function $9cf0852385f62d16$var$applySubtreeWrite(relativePath, writeTree, node) {
    if (writeTree.value != null) // Since there a write is always a leaf, we're done here
    return node.updateChild(relativePath, writeTree.value);
    else {
        let priorityWrite = null;
        writeTree.children.inorderTraversal((childKey, childTree)=>{
            if (childKey === '.priority') {
                // Apply priorities at the end so we don't update priorities for either empty nodes or forget
                // to apply priorities to empty nodes that are later filled
                (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(childTree.value !== null, 'Priority writes must always be leaf nodes');
                priorityWrite = childTree.value;
            } else node = $9cf0852385f62d16$var$applySubtreeWrite($9cf0852385f62d16$var$pathChild(relativePath, childKey), childTree, node);
        });
        // If there was a priority write, we only apply it if the node is not empty
        if (!node.getChild(relativePath).isEmpty() && priorityWrite !== null) node = node.updateChild($9cf0852385f62d16$var$pathChild(relativePath, '.priority'), priorityWrite);
        return node;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Create a new WriteTreeRef for the given path. For use with a new sync point at the given path.
 *
 */ function $9cf0852385f62d16$var$writeTreeChildWrites(writeTree, path) {
    return $9cf0852385f62d16$var$newWriteTreeRef(path, writeTree);
}
/**
 * Record a new overwrite from user code.
 *
 * @param visible - This is set to false by some transactions. It should be excluded from event caches
 */ function $9cf0852385f62d16$var$writeTreeAddOverwrite(writeTree, path, snap, writeId, visible) {
    (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(writeId > writeTree.lastWriteId, 'Stacking an older write on top of newer ones');
    if (visible === undefined) visible = true;
    writeTree.allWrites.push({
        path: path,
        snap: snap,
        writeId: writeId,
        visible: visible
    });
    if (visible) writeTree.visibleWrites = $9cf0852385f62d16$var$compoundWriteAddWrite(writeTree.visibleWrites, path, snap);
    writeTree.lastWriteId = writeId;
}
/**
 * Record a new merge from user code.
 */ function $9cf0852385f62d16$var$writeTreeAddMerge(writeTree, path, changedChildren, writeId) {
    (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(writeId > writeTree.lastWriteId, 'Stacking an older merge on top of newer ones');
    writeTree.allWrites.push({
        path: path,
        children: changedChildren,
        writeId: writeId,
        visible: true
    });
    writeTree.visibleWrites = $9cf0852385f62d16$var$compoundWriteAddWrites(writeTree.visibleWrites, path, changedChildren);
    writeTree.lastWriteId = writeId;
}
function $9cf0852385f62d16$var$writeTreeGetWrite(writeTree, writeId) {
    for(let i = 0; i < writeTree.allWrites.length; i++){
        const record = writeTree.allWrites[i];
        if (record.writeId === writeId) return record;
    }
    return null;
}
/**
 * Remove a write (either an overwrite or merge) that has been successfully acknowledge by the server. Recalculates
 * the tree if necessary.  We return true if it may have been visible, meaning views need to reevaluate.
 *
 * @returns true if the write may have been visible (meaning we'll need to reevaluate / raise
 * events as a result).
 */ function $9cf0852385f62d16$var$writeTreeRemoveWrite(writeTree, writeId) {
    // Note: disabling this check. It could be a transaction that preempted another transaction, and thus was applied
    // out of order.
    //const validClear = revert || this.allWrites_.length === 0 || writeId <= this.allWrites_[0].writeId;
    //assert(validClear, "Either we don't have this write, or it's the first one in the queue");
    const idx = writeTree.allWrites.findIndex((s)=>{
        return s.writeId === writeId;
    });
    (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(idx >= 0, 'removeWrite called with nonexistent writeId.');
    const writeToRemove = writeTree.allWrites[idx];
    writeTree.allWrites.splice(idx, 1);
    let removedWriteWasVisible = writeToRemove.visible;
    let removedWriteOverlapsWithOtherWrites = false;
    let i = writeTree.allWrites.length - 1;
    while(removedWriteWasVisible && i >= 0){
        const currentWrite = writeTree.allWrites[i];
        if (currentWrite.visible) {
            if (i >= idx && $9cf0852385f62d16$var$writeTreeRecordContainsPath_(currentWrite, writeToRemove.path)) // The removed write was completely shadowed by a subsequent write.
            removedWriteWasVisible = false;
            else if ($9cf0852385f62d16$var$pathContains(writeToRemove.path, currentWrite.path)) // Either we're covering some writes or they're covering part of us (depending on which came first).
            removedWriteOverlapsWithOtherWrites = true;
        }
        i--;
    }
    if (!removedWriteWasVisible) return false;
    else if (removedWriteOverlapsWithOtherWrites) {
        // There's some shadowing going on. Just rebuild the visible writes from scratch.
        $9cf0852385f62d16$var$writeTreeResetTree_(writeTree);
        return true;
    } else {
        // There's no shadowing.  We can safely just remove the write(s) from visibleWrites.
        if (writeToRemove.snap) writeTree.visibleWrites = $9cf0852385f62d16$var$compoundWriteRemoveWrite(writeTree.visibleWrites, writeToRemove.path);
        else {
            const children = writeToRemove.children;
            $9cf0852385f62d16$var$each(children, (childName)=>{
                writeTree.visibleWrites = $9cf0852385f62d16$var$compoundWriteRemoveWrite(writeTree.visibleWrites, $9cf0852385f62d16$var$pathChild(writeToRemove.path, childName));
            });
        }
        return true;
    }
}
function $9cf0852385f62d16$var$writeTreeRecordContainsPath_(writeRecord, path) {
    if (writeRecord.snap) return $9cf0852385f62d16$var$pathContains(writeRecord.path, path);
    else {
        for(const childName in writeRecord.children){
            if (writeRecord.children.hasOwnProperty(childName) && $9cf0852385f62d16$var$pathContains($9cf0852385f62d16$var$pathChild(writeRecord.path, childName), path)) return true;
        }
        return false;
    }
}
/**
 * Re-layer the writes and merges into a tree so we can efficiently calculate event snapshots
 */ function $9cf0852385f62d16$var$writeTreeResetTree_(writeTree) {
    writeTree.visibleWrites = $9cf0852385f62d16$var$writeTreeLayerTree_(writeTree.allWrites, $9cf0852385f62d16$var$writeTreeDefaultFilter_, $9cf0852385f62d16$var$newEmptyPath());
    if (writeTree.allWrites.length > 0) writeTree.lastWriteId = writeTree.allWrites[writeTree.allWrites.length - 1].writeId;
    else writeTree.lastWriteId = -1;
}
/**
 * The default filter used when constructing the tree. Keep everything that's visible.
 */ function $9cf0852385f62d16$var$writeTreeDefaultFilter_(write) {
    return write.visible;
}
/**
 * Static method. Given an array of WriteRecords, a filter for which ones to include, and a path, construct the tree of
 * event data at that path.
 */ function $9cf0852385f62d16$var$writeTreeLayerTree_(writes, filter, treeRoot) {
    let compoundWrite = $9cf0852385f62d16$var$CompoundWrite.empty();
    for(let i = 0; i < writes.length; ++i){
        const write = writes[i];
        // Theory, a later set will either:
        // a) abort a relevant transaction, so no need to worry about excluding it from calculating that transaction
        // b) not be relevant to a transaction (separate branch), so again will not affect the data for that transaction
        if (filter(write)) {
            const writePath = write.path;
            let relativePath;
            if (write.snap) {
                if ($9cf0852385f62d16$var$pathContains(treeRoot, writePath)) {
                    relativePath = $9cf0852385f62d16$var$newRelativePath(treeRoot, writePath);
                    compoundWrite = $9cf0852385f62d16$var$compoundWriteAddWrite(compoundWrite, relativePath, write.snap);
                } else if ($9cf0852385f62d16$var$pathContains(writePath, treeRoot)) {
                    relativePath = $9cf0852385f62d16$var$newRelativePath(writePath, treeRoot);
                    compoundWrite = $9cf0852385f62d16$var$compoundWriteAddWrite(compoundWrite, $9cf0852385f62d16$var$newEmptyPath(), write.snap.getChild(relativePath));
                }
            } else if (write.children) {
                if ($9cf0852385f62d16$var$pathContains(treeRoot, writePath)) {
                    relativePath = $9cf0852385f62d16$var$newRelativePath(treeRoot, writePath);
                    compoundWrite = $9cf0852385f62d16$var$compoundWriteAddWrites(compoundWrite, relativePath, write.children);
                } else if ($9cf0852385f62d16$var$pathContains(writePath, treeRoot)) {
                    relativePath = $9cf0852385f62d16$var$newRelativePath(writePath, treeRoot);
                    if ($9cf0852385f62d16$var$pathIsEmpty(relativePath)) compoundWrite = $9cf0852385f62d16$var$compoundWriteAddWrites(compoundWrite, $9cf0852385f62d16$var$newEmptyPath(), write.children);
                    else {
                        const child = (0, $3117f6f4eeb4c314$export$e51ae4db7b428f67)(write.children, $9cf0852385f62d16$var$pathGetFront(relativePath));
                        if (child) {
                            // There exists a child in this node that matches the root path
                            const deepNode = child.getChild($9cf0852385f62d16$var$pathPopFront(relativePath));
                            compoundWrite = $9cf0852385f62d16$var$compoundWriteAddWrite(compoundWrite, $9cf0852385f62d16$var$newEmptyPath(), deepNode);
                        }
                    }
                }
            } else throw (0, $3117f6f4eeb4c314$export$a39cad550e7ab28a)('WriteRecord should have .snap or .children');
        }
    }
    return compoundWrite;
}
/**
 * Given optional, underlying server data, and an optional set of constraints (exclude some sets, include hidden
 * writes), attempt to calculate a complete snapshot for the given path
 *
 * @param writeIdsToExclude - An optional set to be excluded
 * @param includeHiddenWrites - Defaults to false, whether or not to layer on writes with visible set to false
 */ function $9cf0852385f62d16$var$writeTreeCalcCompleteEventCache(writeTree, treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
    if (!writeIdsToExclude && !includeHiddenWrites) {
        const shadowingNode = $9cf0852385f62d16$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, treePath);
        if (shadowingNode != null) return shadowingNode;
        else {
            const subMerge = $9cf0852385f62d16$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
            if ($9cf0852385f62d16$var$compoundWriteIsEmpty(subMerge)) return completeServerCache;
            else if (completeServerCache == null && !$9cf0852385f62d16$var$compoundWriteHasCompleteWrite(subMerge, $9cf0852385f62d16$var$newEmptyPath())) // We wouldn't have a complete snapshot, since there's no underlying data and no complete shadow
            return null;
            else {
                const layeredCache = completeServerCache || $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE;
                return $9cf0852385f62d16$var$compoundWriteApply(subMerge, layeredCache);
            }
        }
    } else {
        const merge = $9cf0852385f62d16$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        if (!includeHiddenWrites && $9cf0852385f62d16$var$compoundWriteIsEmpty(merge)) return completeServerCache;
        else {
            // If the server cache is null, and we don't have a complete cache, we need to return null
            if (!includeHiddenWrites && completeServerCache == null && !$9cf0852385f62d16$var$compoundWriteHasCompleteWrite(merge, $9cf0852385f62d16$var$newEmptyPath())) return null;
            else {
                const filter = function(write) {
                    return (write.visible || includeHiddenWrites) && (!writeIdsToExclude || !~writeIdsToExclude.indexOf(write.writeId)) && ($9cf0852385f62d16$var$pathContains(write.path, treePath) || $9cf0852385f62d16$var$pathContains(treePath, write.path));
                };
                const mergeAtPath = $9cf0852385f62d16$var$writeTreeLayerTree_(writeTree.allWrites, filter, treePath);
                const layeredCache = completeServerCache || $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE;
                return $9cf0852385f62d16$var$compoundWriteApply(mergeAtPath, layeredCache);
            }
        }
    }
}
/**
 * With optional, underlying server data, attempt to return a children node of children that we have complete data for.
 * Used when creating new views, to pre-fill their complete event children snapshot.
 */ function $9cf0852385f62d16$var$writeTreeCalcCompleteEventChildren(writeTree, treePath, completeServerChildren) {
    let completeChildren = $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE;
    const topLevelSet = $9cf0852385f62d16$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, treePath);
    if (topLevelSet) {
        if (!topLevelSet.isLeafNode()) // we're shadowing everything. Return the children.
        topLevelSet.forEachChild($9cf0852385f62d16$var$PRIORITY_INDEX, (childName, childSnap)=>{
            completeChildren = completeChildren.updateImmediateChild(childName, childSnap);
        });
        return completeChildren;
    } else if (completeServerChildren) {
        // Layer any children we have on top of this
        // We know we don't have a top-level set, so just enumerate existing children
        const merge = $9cf0852385f62d16$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        completeServerChildren.forEachChild($9cf0852385f62d16$var$PRIORITY_INDEX, (childName, childNode)=>{
            const node = $9cf0852385f62d16$var$compoundWriteApply($9cf0852385f62d16$var$compoundWriteChildCompoundWrite(merge, new $9cf0852385f62d16$var$Path(childName)), childNode);
            completeChildren = completeChildren.updateImmediateChild(childName, node);
        });
        // Add any complete children we have from the set
        $9cf0852385f62d16$var$compoundWriteGetCompleteChildren(merge).forEach((namedNode)=>{
            completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
        });
        return completeChildren;
    } else {
        // We don't have anything to layer on top of. Layer on any children we have
        // Note that we can return an empty snap if we have a defined delete
        const merge = $9cf0852385f62d16$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        $9cf0852385f62d16$var$compoundWriteGetCompleteChildren(merge).forEach((namedNode)=>{
            completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
        });
        return completeChildren;
    }
}
/**
 * Given that the underlying server data has updated, determine what, if anything, needs to be
 * applied to the event cache.
 *
 * Possibilities:
 *
 * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
 *
 * 2. Some write is completely shadowing. No events to be raised
 *
 * 3. Is partially shadowed. Events
 *
 * Either existingEventSnap or existingServerSnap must exist
 */ function $9cf0852385f62d16$var$writeTreeCalcEventCacheAfterServerOverwrite(writeTree, treePath, childPath, existingEventSnap, existingServerSnap) {
    (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(existingEventSnap || existingServerSnap, 'Either existingEventSnap or existingServerSnap must exist');
    const path = $9cf0852385f62d16$var$pathChild(treePath, childPath);
    if ($9cf0852385f62d16$var$compoundWriteHasCompleteWrite(writeTree.visibleWrites, path)) // At this point we can probably guarantee that we're in case 2, meaning no events
    // May need to check visibility while doing the findRootMostValueAndPath call
    return null;
    else {
        // No complete shadowing. We're either partially shadowing or not shadowing at all.
        const childMerge = $9cf0852385f62d16$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, path);
        if ($9cf0852385f62d16$var$compoundWriteIsEmpty(childMerge)) // We're not shadowing at all. Case 1
        return existingServerSnap.getChild(childPath);
        else // This could be more efficient if the serverNode + updates doesn't change the eventSnap
        // However this is tricky to find out, since user updates don't necessary change the server
        // snap, e.g. priority updates on empty nodes, or deep deletes. Another special case is if the server
        // adds nodes, but doesn't change any existing writes. It is therefore not enough to
        // only check if the updates change the serverNode.
        // Maybe check if the merge tree contains these special cases and only do a full overwrite in that case?
        return $9cf0852385f62d16$var$compoundWriteApply(childMerge, existingServerSnap.getChild(childPath));
    }
}
/**
 * Returns a complete child for a given server snap after applying all user writes or null if there is no
 * complete child for this ChildKey.
 */ function $9cf0852385f62d16$var$writeTreeCalcCompleteChild(writeTree, treePath, childKey, existingServerSnap) {
    const path = $9cf0852385f62d16$var$pathChild(treePath, childKey);
    const shadowingNode = $9cf0852385f62d16$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, path);
    if (shadowingNode != null) return shadowingNode;
    else {
        if (existingServerSnap.isCompleteForChild(childKey)) {
            const childMerge = $9cf0852385f62d16$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, path);
            return $9cf0852385f62d16$var$compoundWriteApply(childMerge, existingServerSnap.getNode().getImmediateChild(childKey));
        } else return null;
    }
}
/**
 * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
 * a higher path, this will return the child of that write relative to the write and this path.
 * Returns null if there is no write at this path.
 */ function $9cf0852385f62d16$var$writeTreeShadowingWrite(writeTree, path) {
    return $9cf0852385f62d16$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, path);
}
/**
 * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
 * the window, but may now be in the window.
 */ function $9cf0852385f62d16$var$writeTreeCalcIndexedSlice(writeTree, treePath, completeServerData, startPost, count, reverse, index) {
    let toIterate;
    const merge = $9cf0852385f62d16$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
    const shadowingNode = $9cf0852385f62d16$var$compoundWriteGetCompleteNode(merge, $9cf0852385f62d16$var$newEmptyPath());
    if (shadowingNode != null) toIterate = shadowingNode;
    else if (completeServerData != null) toIterate = $9cf0852385f62d16$var$compoundWriteApply(merge, completeServerData);
    else // no children to iterate on
    return [];
    toIterate = toIterate.withIndex(index);
    if (!toIterate.isEmpty() && !toIterate.isLeafNode()) {
        const nodes = [];
        const cmp = index.getCompare();
        const iter = reverse ? toIterate.getReverseIteratorFrom(startPost, index) : toIterate.getIteratorFrom(startPost, index);
        let next = iter.getNext();
        while(next && nodes.length < count){
            if (cmp(next, startPost) !== 0) nodes.push(next);
            next = iter.getNext();
        }
        return nodes;
    } else return [];
}
function $9cf0852385f62d16$var$newWriteTree() {
    return {
        visibleWrites: $9cf0852385f62d16$var$CompoundWrite.empty(),
        allWrites: [],
        lastWriteId: -1
    };
}
/**
 * If possible, returns a complete event cache, using the underlying server data if possible. In addition, can be used
 * to get a cache that includes hidden writes, and excludes arbitrary writes. Note that customizing the returned node
 * can lead to a more expensive calculation.
 *
 * @param writeIdsToExclude - Optional writes to exclude.
 * @param includeHiddenWrites - Defaults to false, whether or not to layer on writes with visible set to false
 */ function $9cf0852385f62d16$var$writeTreeRefCalcCompleteEventCache(writeTreeRef, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
    return $9cf0852385f62d16$var$writeTreeCalcCompleteEventCache(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites);
}
/**
 * If possible, returns a children node containing all of the complete children we have data for. The returned data is a
 * mix of the given server data and write data.
 *
 */ function $9cf0852385f62d16$var$writeTreeRefCalcCompleteEventChildren(writeTreeRef, completeServerChildren) {
    return $9cf0852385f62d16$var$writeTreeCalcCompleteEventChildren(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerChildren);
}
/**
 * Given that either the underlying server data has updated or the outstanding writes have updated, determine what,
 * if anything, needs to be applied to the event cache.
 *
 * Possibilities:
 *
 * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
 *
 * 2. Some write is completely shadowing. No events to be raised
 *
 * 3. Is partially shadowed. Events should be raised
 *
 * Either existingEventSnap or existingServerSnap must exist, this is validated via an assert
 *
 *
 */ function $9cf0852385f62d16$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writeTreeRef, path, existingEventSnap, existingServerSnap) {
    return $9cf0852385f62d16$var$writeTreeCalcEventCacheAfterServerOverwrite(writeTreeRef.writeTree, writeTreeRef.treePath, path, existingEventSnap, existingServerSnap);
}
/**
 * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
 * a higher path, this will return the child of that write relative to the write and this path.
 * Returns null if there is no write at this path.
 *
 */ function $9cf0852385f62d16$var$writeTreeRefShadowingWrite(writeTreeRef, path) {
    return $9cf0852385f62d16$var$writeTreeShadowingWrite(writeTreeRef.writeTree, $9cf0852385f62d16$var$pathChild(writeTreeRef.treePath, path));
}
/**
 * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
 * the window, but may now be in the window
 */ function $9cf0852385f62d16$var$writeTreeRefCalcIndexedSlice(writeTreeRef, completeServerData, startPost, count, reverse, index) {
    return $9cf0852385f62d16$var$writeTreeCalcIndexedSlice(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerData, startPost, count, reverse, index);
}
/**
 * Returns a complete child for a given server snap after applying all user writes or null if there is no
 * complete child for this ChildKey.
 */ function $9cf0852385f62d16$var$writeTreeRefCalcCompleteChild(writeTreeRef, childKey, existingServerCache) {
    return $9cf0852385f62d16$var$writeTreeCalcCompleteChild(writeTreeRef.writeTree, writeTreeRef.treePath, childKey, existingServerCache);
}
/**
 * Return a WriteTreeRef for a child.
 */ function $9cf0852385f62d16$var$writeTreeRefChild(writeTreeRef, childName) {
    return $9cf0852385f62d16$var$newWriteTreeRef($9cf0852385f62d16$var$pathChild(writeTreeRef.treePath, childName), writeTreeRef.writeTree);
}
function $9cf0852385f62d16$var$newWriteTreeRef(path, writeTree) {
    return {
        treePath: path,
        writeTree: writeTree
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9cf0852385f62d16$var$ChildChangeAccumulator {
    constructor(){
        this.changeMap = new Map();
    }
    trackChildChange(change) {
        const type = change.type;
        const childKey = change.childName;
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(type === "child_added" /* ChangeType.CHILD_ADDED */  || type === "child_changed" /* ChangeType.CHILD_CHANGED */  || type === "child_removed" /* ChangeType.CHILD_REMOVED */ , 'Only child changes supported for tracking');
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(childKey !== '.priority', 'Only non-priority child changes can be tracked.');
        const oldChange = this.changeMap.get(childKey);
        if (oldChange) {
            const oldType = oldChange.type;
            if (type === "child_added" /* ChangeType.CHILD_ADDED */  && oldType === "child_removed" /* ChangeType.CHILD_REMOVED */ ) this.changeMap.set(childKey, $9cf0852385f62d16$var$changeChildChanged(childKey, change.snapshotNode, oldChange.snapshotNode));
            else if (type === "child_removed" /* ChangeType.CHILD_REMOVED */  && oldType === "child_added" /* ChangeType.CHILD_ADDED */ ) this.changeMap.delete(childKey);
            else if (type === "child_removed" /* ChangeType.CHILD_REMOVED */  && oldType === "child_changed" /* ChangeType.CHILD_CHANGED */ ) this.changeMap.set(childKey, $9cf0852385f62d16$var$changeChildRemoved(childKey, oldChange.oldSnap));
            else if (type === "child_changed" /* ChangeType.CHILD_CHANGED */  && oldType === "child_added" /* ChangeType.CHILD_ADDED */ ) this.changeMap.set(childKey, $9cf0852385f62d16$var$changeChildAdded(childKey, change.snapshotNode));
            else if (type === "child_changed" /* ChangeType.CHILD_CHANGED */  && oldType === "child_changed" /* ChangeType.CHILD_CHANGED */ ) this.changeMap.set(childKey, $9cf0852385f62d16$var$changeChildChanged(childKey, change.snapshotNode, oldChange.oldSnap));
            else throw (0, $3117f6f4eeb4c314$export$a39cad550e7ab28a)('Illegal combination of changes: ' + change + ' occurred after ' + oldChange);
        } else this.changeMap.set(childKey, change);
    }
    getChanges() {
        return Array.from(this.changeMap.values());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An implementation of CompleteChildSource that never returns any additional children
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
class $9cf0852385f62d16$var$NoCompleteChildSource_ {
    getCompleteChild(childKey) {
        return null;
    }
    getChildAfterChild(index, child, reverse) {
        return null;
    }
}
/**
 * Singleton instance.
 */ const $9cf0852385f62d16$var$NO_COMPLETE_CHILD_SOURCE = new $9cf0852385f62d16$var$NoCompleteChildSource_();
/**
 * An implementation of CompleteChildSource that uses a WriteTree in addition to any other server data or
 * old event caches available to calculate complete children.
 */ class $9cf0852385f62d16$var$WriteTreeCompleteChildSource {
    constructor(writes_, viewCache_, optCompleteServerCache_ = null){
        this.writes_ = writes_;
        this.viewCache_ = viewCache_;
        this.optCompleteServerCache_ = optCompleteServerCache_;
    }
    getCompleteChild(childKey) {
        const node = this.viewCache_.eventCache;
        if (node.isCompleteForChild(childKey)) return node.getNode().getImmediateChild(childKey);
        else {
            const serverNode = this.optCompleteServerCache_ != null ? new $9cf0852385f62d16$var$CacheNode(this.optCompleteServerCache_, true, false) : this.viewCache_.serverCache;
            return $9cf0852385f62d16$var$writeTreeRefCalcCompleteChild(this.writes_, childKey, serverNode);
        }
    }
    getChildAfterChild(index, child, reverse) {
        const completeServerData = this.optCompleteServerCache_ != null ? this.optCompleteServerCache_ : $9cf0852385f62d16$var$viewCacheGetCompleteServerSnap(this.viewCache_);
        const nodes = $9cf0852385f62d16$var$writeTreeRefCalcIndexedSlice(this.writes_, completeServerData, child, 1, reverse, index);
        if (nodes.length === 0) return null;
        else return nodes[0];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9cf0852385f62d16$var$newViewProcessor(filter) {
    return {
        filter: filter
    };
}
function $9cf0852385f62d16$var$viewProcessorAssertIndexed(viewProcessor, viewCache) {
    (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(viewCache.eventCache.getNode().isIndexed(viewProcessor.filter.getIndex()), 'Event snap not indexed');
    (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(viewCache.serverCache.getNode().isIndexed(viewProcessor.filter.getIndex()), 'Server snap not indexed');
}
function $9cf0852385f62d16$var$viewProcessorApplyOperation(viewProcessor, oldViewCache, operation, writesCache, completeCache) {
    const accumulator = new $9cf0852385f62d16$var$ChildChangeAccumulator();
    let newViewCache, filterServerNode;
    if (operation.type === $9cf0852385f62d16$var$OperationType.OVERWRITE) {
        const overwrite = operation;
        if (overwrite.source.fromUser) newViewCache = $9cf0852385f62d16$var$viewProcessorApplyUserOverwrite(viewProcessor, oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, accumulator);
        else {
            (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(overwrite.source.fromServer, 'Unknown source.');
            // We filter the node if it's a tagged update or the node has been previously filtered  and the
            // update is not at the root in which case it is ok (and necessary) to mark the node unfiltered
            // again
            filterServerNode = overwrite.source.tagged || oldViewCache.serverCache.isFiltered() && !$9cf0852385f62d16$var$pathIsEmpty(overwrite.path);
            newViewCache = $9cf0852385f62d16$var$viewProcessorApplyServerOverwrite(viewProcessor, oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, filterServerNode, accumulator);
        }
    } else if (operation.type === $9cf0852385f62d16$var$OperationType.MERGE) {
        const merge = operation;
        if (merge.source.fromUser) newViewCache = $9cf0852385f62d16$var$viewProcessorApplyUserMerge(viewProcessor, oldViewCache, merge.path, merge.children, writesCache, completeCache, accumulator);
        else {
            (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(merge.source.fromServer, 'Unknown source.');
            // We filter the node if it's a tagged update or the node has been previously filtered
            filterServerNode = merge.source.tagged || oldViewCache.serverCache.isFiltered();
            newViewCache = $9cf0852385f62d16$var$viewProcessorApplyServerMerge(viewProcessor, oldViewCache, merge.path, merge.children, writesCache, completeCache, filterServerNode, accumulator);
        }
    } else if (operation.type === $9cf0852385f62d16$var$OperationType.ACK_USER_WRITE) {
        const ackUserWrite = operation;
        if (!ackUserWrite.revert) newViewCache = $9cf0852385f62d16$var$viewProcessorAckUserWrite(viewProcessor, oldViewCache, ackUserWrite.path, ackUserWrite.affectedTree, writesCache, completeCache, accumulator);
        else newViewCache = $9cf0852385f62d16$var$viewProcessorRevertUserWrite(viewProcessor, oldViewCache, ackUserWrite.path, writesCache, completeCache, accumulator);
    } else if (operation.type === $9cf0852385f62d16$var$OperationType.LISTEN_COMPLETE) newViewCache = $9cf0852385f62d16$var$viewProcessorListenComplete(viewProcessor, oldViewCache, operation.path, writesCache, accumulator);
    else throw (0, $3117f6f4eeb4c314$export$a39cad550e7ab28a)('Unknown operation type: ' + operation.type);
    const changes = accumulator.getChanges();
    $9cf0852385f62d16$var$viewProcessorMaybeAddValueEvent(oldViewCache, newViewCache, changes);
    return {
        viewCache: newViewCache,
        changes: changes
    };
}
function $9cf0852385f62d16$var$viewProcessorMaybeAddValueEvent(oldViewCache, newViewCache, accumulator) {
    const eventSnap = newViewCache.eventCache;
    if (eventSnap.isFullyInitialized()) {
        const isLeafOrEmpty = eventSnap.getNode().isLeafNode() || eventSnap.getNode().isEmpty();
        const oldCompleteSnap = $9cf0852385f62d16$var$viewCacheGetCompleteEventSnap(oldViewCache);
        if (accumulator.length > 0 || !oldViewCache.eventCache.isFullyInitialized() || isLeafOrEmpty && !eventSnap.getNode().equals(oldCompleteSnap) || !eventSnap.getNode().getPriority().equals(oldCompleteSnap.getPriority())) accumulator.push($9cf0852385f62d16$var$changeValue($9cf0852385f62d16$var$viewCacheGetCompleteEventSnap(newViewCache)));
    }
}
function $9cf0852385f62d16$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, viewCache, changePath, writesCache, source, accumulator) {
    const oldEventSnap = viewCache.eventCache;
    if ($9cf0852385f62d16$var$writeTreeRefShadowingWrite(writesCache, changePath) != null) // we have a shadowing write, ignore changes
    return viewCache;
    else {
        let newEventCache, serverNode;
        if ($9cf0852385f62d16$var$pathIsEmpty(changePath)) {
            // TODO: figure out how this plays with "sliding ack windows"
            (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(viewCache.serverCache.isFullyInitialized(), 'If change path is empty, we must have complete server data');
            if (viewCache.serverCache.isFiltered()) {
                // We need to special case this, because we need to only apply writes to complete children, or
                // we might end up raising events for incomplete children. If the server data is filtered deep
                // writes cannot be guaranteed to be complete
                const serverCache = $9cf0852385f62d16$var$viewCacheGetCompleteServerSnap(viewCache);
                const completeChildren = serverCache instanceof $9cf0852385f62d16$var$ChildrenNode ? serverCache : $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE;
                const completeEventChildren = $9cf0852385f62d16$var$writeTreeRefCalcCompleteEventChildren(writesCache, completeChildren);
                newEventCache = viewProcessor.filter.updateFullNode(viewCache.eventCache.getNode(), completeEventChildren, accumulator);
            } else {
                const completeNode = $9cf0852385f62d16$var$writeTreeRefCalcCompleteEventCache(writesCache, $9cf0852385f62d16$var$viewCacheGetCompleteServerSnap(viewCache));
                newEventCache = viewProcessor.filter.updateFullNode(viewCache.eventCache.getNode(), completeNode, accumulator);
            }
        } else {
            const childKey = $9cf0852385f62d16$var$pathGetFront(changePath);
            if (childKey === '.priority') {
                (0, $3117f6f4eeb4c314$export$a7a9523472993e97)($9cf0852385f62d16$var$pathGetLength(changePath) === 1, "Can't have a priority with additional path components");
                const oldEventNode = oldEventSnap.getNode();
                serverNode = viewCache.serverCache.getNode();
                // we might have overwrites for this priority
                const updatedPriority = $9cf0852385f62d16$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writesCache, changePath, oldEventNode, serverNode);
                if (updatedPriority != null) newEventCache = viewProcessor.filter.updatePriority(oldEventNode, updatedPriority);
                else // priority didn't change, keep old node
                newEventCache = oldEventSnap.getNode();
            } else {
                const childChangePath = $9cf0852385f62d16$var$pathPopFront(changePath);
                // update child
                let newEventChild;
                if (oldEventSnap.isCompleteForChild(childKey)) {
                    serverNode = viewCache.serverCache.getNode();
                    const eventChildUpdate = $9cf0852385f62d16$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writesCache, changePath, oldEventSnap.getNode(), serverNode);
                    if (eventChildUpdate != null) newEventChild = oldEventSnap.getNode().getImmediateChild(childKey).updateChild(childChangePath, eventChildUpdate);
                    else // Nothing changed, just keep the old child
                    newEventChild = oldEventSnap.getNode().getImmediateChild(childKey);
                } else newEventChild = $9cf0852385f62d16$var$writeTreeRefCalcCompleteChild(writesCache, childKey, viewCache.serverCache);
                if (newEventChild != null) newEventCache = viewProcessor.filter.updateChild(oldEventSnap.getNode(), childKey, newEventChild, childChangePath, source, accumulator);
                else // no complete child available or no change
                newEventCache = oldEventSnap.getNode();
            }
        }
        return $9cf0852385f62d16$var$viewCacheUpdateEventSnap(viewCache, newEventCache, oldEventSnap.isFullyInitialized() || $9cf0852385f62d16$var$pathIsEmpty(changePath), viewProcessor.filter.filtersNodes());
    }
}
function $9cf0852385f62d16$var$viewProcessorApplyServerOverwrite(viewProcessor, oldViewCache, changePath, changedSnap, writesCache, completeCache, filterServerNode, accumulator) {
    const oldServerSnap = oldViewCache.serverCache;
    let newServerCache;
    const serverFilter = filterServerNode ? viewProcessor.filter : viewProcessor.filter.getIndexedFilter();
    if ($9cf0852385f62d16$var$pathIsEmpty(changePath)) newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), changedSnap, null);
    else if (serverFilter.filtersNodes() && !oldServerSnap.isFiltered()) {
        // we want to filter the server node, but we didn't filter the server node yet, so simulate a full update
        const newServerNode = oldServerSnap.getNode().updateChild(changePath, changedSnap);
        newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), newServerNode, null);
    } else {
        const childKey = $9cf0852385f62d16$var$pathGetFront(changePath);
        if (!oldServerSnap.isCompleteForPath(changePath) && $9cf0852385f62d16$var$pathGetLength(changePath) > 1) // We don't update incomplete nodes with updates intended for other listeners
        return oldViewCache;
        const childChangePath = $9cf0852385f62d16$var$pathPopFront(changePath);
        const childNode = oldServerSnap.getNode().getImmediateChild(childKey);
        const newChildNode = childNode.updateChild(childChangePath, changedSnap);
        if (childKey === '.priority') newServerCache = serverFilter.updatePriority(oldServerSnap.getNode(), newChildNode);
        else newServerCache = serverFilter.updateChild(oldServerSnap.getNode(), childKey, newChildNode, childChangePath, $9cf0852385f62d16$var$NO_COMPLETE_CHILD_SOURCE, null);
    }
    const newViewCache = $9cf0852385f62d16$var$viewCacheUpdateServerSnap(oldViewCache, newServerCache, oldServerSnap.isFullyInitialized() || $9cf0852385f62d16$var$pathIsEmpty(changePath), serverFilter.filtersNodes());
    const source = new $9cf0852385f62d16$var$WriteTreeCompleteChildSource(writesCache, newViewCache, completeCache);
    return $9cf0852385f62d16$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, newViewCache, changePath, writesCache, source, accumulator);
}
function $9cf0852385f62d16$var$viewProcessorApplyUserOverwrite(viewProcessor, oldViewCache, changePath, changedSnap, writesCache, completeCache, accumulator) {
    const oldEventSnap = oldViewCache.eventCache;
    let newViewCache, newEventCache;
    const source = new $9cf0852385f62d16$var$WriteTreeCompleteChildSource(writesCache, oldViewCache, completeCache);
    if ($9cf0852385f62d16$var$pathIsEmpty(changePath)) {
        newEventCache = viewProcessor.filter.updateFullNode(oldViewCache.eventCache.getNode(), changedSnap, accumulator);
        newViewCache = $9cf0852385f62d16$var$viewCacheUpdateEventSnap(oldViewCache, newEventCache, true, viewProcessor.filter.filtersNodes());
    } else {
        const childKey = $9cf0852385f62d16$var$pathGetFront(changePath);
        if (childKey === '.priority') {
            newEventCache = viewProcessor.filter.updatePriority(oldViewCache.eventCache.getNode(), changedSnap);
            newViewCache = $9cf0852385f62d16$var$viewCacheUpdateEventSnap(oldViewCache, newEventCache, oldEventSnap.isFullyInitialized(), oldEventSnap.isFiltered());
        } else {
            const childChangePath = $9cf0852385f62d16$var$pathPopFront(changePath);
            const oldChild = oldEventSnap.getNode().getImmediateChild(childKey);
            let newChild;
            if ($9cf0852385f62d16$var$pathIsEmpty(childChangePath)) // Child overwrite, we can replace the child
            newChild = changedSnap;
            else {
                const childNode = source.getCompleteChild(childKey);
                if (childNode != null) {
                    if ($9cf0852385f62d16$var$pathGetBack(childChangePath) === '.priority' && childNode.getChild($9cf0852385f62d16$var$pathParent(childChangePath)).isEmpty()) // This is a priority update on an empty node. If this node exists on the server, the
                    // server will send down the priority in the update, so ignore for now
                    newChild = childNode;
                    else newChild = childNode.updateChild(childChangePath, changedSnap);
                } else // There is no complete child node available
                newChild = $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE;
            }
            if (!oldChild.equals(newChild)) {
                const newEventSnap = viewProcessor.filter.updateChild(oldEventSnap.getNode(), childKey, newChild, childChangePath, source, accumulator);
                newViewCache = $9cf0852385f62d16$var$viewCacheUpdateEventSnap(oldViewCache, newEventSnap, oldEventSnap.isFullyInitialized(), viewProcessor.filter.filtersNodes());
            } else newViewCache = oldViewCache;
        }
    }
    return newViewCache;
}
function $9cf0852385f62d16$var$viewProcessorCacheHasChild(viewCache, childKey) {
    return viewCache.eventCache.isCompleteForChild(childKey);
}
function $9cf0852385f62d16$var$viewProcessorApplyUserMerge(viewProcessor, viewCache, path, changedChildren, writesCache, serverCache, accumulator) {
    // HACK: In the case of a limit query, there may be some changes that bump things out of the
    // window leaving room for new items.  It's important we process these changes first, so we
    // iterate the changes twice, first processing any that affect items currently in view.
    // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
    // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
    // not the other.
    let curViewCache = viewCache;
    changedChildren.foreach((relativePath, childNode)=>{
        const writePath = $9cf0852385f62d16$var$pathChild(path, relativePath);
        if ($9cf0852385f62d16$var$viewProcessorCacheHasChild(viewCache, $9cf0852385f62d16$var$pathGetFront(writePath))) curViewCache = $9cf0852385f62d16$var$viewProcessorApplyUserOverwrite(viewProcessor, curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
    });
    changedChildren.foreach((relativePath, childNode)=>{
        const writePath = $9cf0852385f62d16$var$pathChild(path, relativePath);
        if (!$9cf0852385f62d16$var$viewProcessorCacheHasChild(viewCache, $9cf0852385f62d16$var$pathGetFront(writePath))) curViewCache = $9cf0852385f62d16$var$viewProcessorApplyUserOverwrite(viewProcessor, curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
    });
    return curViewCache;
}
function $9cf0852385f62d16$var$viewProcessorApplyMerge(viewProcessor, node, merge) {
    merge.foreach((relativePath, childNode)=>{
        node = node.updateChild(relativePath, childNode);
    });
    return node;
}
function $9cf0852385f62d16$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, path, changedChildren, writesCache, serverCache, filterServerNode, accumulator) {
    // If we don't have a cache yet, this merge was intended for a previously listen in the same location. Ignore it and
    // wait for the complete data update coming soon.
    if (viewCache.serverCache.getNode().isEmpty() && !viewCache.serverCache.isFullyInitialized()) return viewCache;
    // HACK: In the case of a limit query, there may be some changes that bump things out of the
    // window leaving room for new items.  It's important we process these changes first, so we
    // iterate the changes twice, first processing any that affect items currently in view.
    // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
    // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
    // not the other.
    let curViewCache = viewCache;
    let viewMergeTree;
    if ($9cf0852385f62d16$var$pathIsEmpty(path)) viewMergeTree = changedChildren;
    else viewMergeTree = new $9cf0852385f62d16$var$ImmutableTree(null).setTree(path, changedChildren);
    const serverNode = viewCache.serverCache.getNode();
    viewMergeTree.children.inorderTraversal((childKey, childTree)=>{
        if (serverNode.hasChild(childKey)) {
            const serverChild = viewCache.serverCache.getNode().getImmediateChild(childKey);
            const newChild = $9cf0852385f62d16$var$viewProcessorApplyMerge(viewProcessor, serverChild, childTree);
            curViewCache = $9cf0852385f62d16$var$viewProcessorApplyServerOverwrite(viewProcessor, curViewCache, new $9cf0852385f62d16$var$Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
        }
    });
    viewMergeTree.children.inorderTraversal((childKey, childMergeTree)=>{
        const isUnknownDeepMerge = !viewCache.serverCache.isCompleteForChild(childKey) && childMergeTree.value === null;
        if (!serverNode.hasChild(childKey) && !isUnknownDeepMerge) {
            const serverChild = viewCache.serverCache.getNode().getImmediateChild(childKey);
            const newChild = $9cf0852385f62d16$var$viewProcessorApplyMerge(viewProcessor, serverChild, childMergeTree);
            curViewCache = $9cf0852385f62d16$var$viewProcessorApplyServerOverwrite(viewProcessor, curViewCache, new $9cf0852385f62d16$var$Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
        }
    });
    return curViewCache;
}
function $9cf0852385f62d16$var$viewProcessorAckUserWrite(viewProcessor, viewCache, ackPath, affectedTree, writesCache, completeCache, accumulator) {
    if ($9cf0852385f62d16$var$writeTreeRefShadowingWrite(writesCache, ackPath) != null) return viewCache;
    // Only filter server node if it is currently filtered
    const filterServerNode = viewCache.serverCache.isFiltered();
    // Essentially we'll just get our existing server cache for the affected paths and re-apply it as a server update
    // now that it won't be shadowed.
    const serverCache = viewCache.serverCache;
    if (affectedTree.value != null) {
        // This is an overwrite.
        if ($9cf0852385f62d16$var$pathIsEmpty(ackPath) && serverCache.isFullyInitialized() || serverCache.isCompleteForPath(ackPath)) return $9cf0852385f62d16$var$viewProcessorApplyServerOverwrite(viewProcessor, viewCache, ackPath, serverCache.getNode().getChild(ackPath), writesCache, completeCache, filterServerNode, accumulator);
        else if ($9cf0852385f62d16$var$pathIsEmpty(ackPath)) {
            // This is a goofy edge case where we are acking data at this location but don't have full data.  We
            // should just re-apply whatever we have in our cache as a merge.
            let changedChildren = new $9cf0852385f62d16$var$ImmutableTree(null);
            serverCache.getNode().forEachChild($9cf0852385f62d16$var$KEY_INDEX, (name, node)=>{
                changedChildren = changedChildren.set(new $9cf0852385f62d16$var$Path(name), node);
            });
            return $9cf0852385f62d16$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, ackPath, changedChildren, writesCache, completeCache, filterServerNode, accumulator);
        } else return viewCache;
    } else {
        // This is a merge.
        let changedChildren = new $9cf0852385f62d16$var$ImmutableTree(null);
        affectedTree.foreach((mergePath, value)=>{
            const serverCachePath = $9cf0852385f62d16$var$pathChild(ackPath, mergePath);
            if (serverCache.isCompleteForPath(serverCachePath)) changedChildren = changedChildren.set(mergePath, serverCache.getNode().getChild(serverCachePath));
        });
        return $9cf0852385f62d16$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, ackPath, changedChildren, writesCache, completeCache, filterServerNode, accumulator);
    }
}
function $9cf0852385f62d16$var$viewProcessorListenComplete(viewProcessor, viewCache, path, writesCache, accumulator) {
    const oldServerNode = viewCache.serverCache;
    const newViewCache = $9cf0852385f62d16$var$viewCacheUpdateServerSnap(viewCache, oldServerNode.getNode(), oldServerNode.isFullyInitialized() || $9cf0852385f62d16$var$pathIsEmpty(path), oldServerNode.isFiltered());
    return $9cf0852385f62d16$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, newViewCache, path, writesCache, $9cf0852385f62d16$var$NO_COMPLETE_CHILD_SOURCE, accumulator);
}
function $9cf0852385f62d16$var$viewProcessorRevertUserWrite(viewProcessor, viewCache, path, writesCache, completeServerCache, accumulator) {
    let complete;
    if ($9cf0852385f62d16$var$writeTreeRefShadowingWrite(writesCache, path) != null) return viewCache;
    else {
        const source = new $9cf0852385f62d16$var$WriteTreeCompleteChildSource(writesCache, viewCache, completeServerCache);
        const oldEventCache = viewCache.eventCache.getNode();
        let newEventCache;
        if ($9cf0852385f62d16$var$pathIsEmpty(path) || $9cf0852385f62d16$var$pathGetFront(path) === '.priority') {
            let newNode;
            if (viewCache.serverCache.isFullyInitialized()) newNode = $9cf0852385f62d16$var$writeTreeRefCalcCompleteEventCache(writesCache, $9cf0852385f62d16$var$viewCacheGetCompleteServerSnap(viewCache));
            else {
                const serverChildren = viewCache.serverCache.getNode();
                (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(serverChildren instanceof $9cf0852385f62d16$var$ChildrenNode, 'serverChildren would be complete if leaf node');
                newNode = $9cf0852385f62d16$var$writeTreeRefCalcCompleteEventChildren(writesCache, serverChildren);
            }
            newNode;
            newEventCache = viewProcessor.filter.updateFullNode(oldEventCache, newNode, accumulator);
        } else {
            const childKey = $9cf0852385f62d16$var$pathGetFront(path);
            let newChild = $9cf0852385f62d16$var$writeTreeRefCalcCompleteChild(writesCache, childKey, viewCache.serverCache);
            if (newChild == null && viewCache.serverCache.isCompleteForChild(childKey)) newChild = oldEventCache.getImmediateChild(childKey);
            if (newChild != null) newEventCache = viewProcessor.filter.updateChild(oldEventCache, childKey, newChild, $9cf0852385f62d16$var$pathPopFront(path), source, accumulator);
            else if (viewCache.eventCache.getNode().hasChild(childKey)) // No complete child available, delete the existing one, if any
            newEventCache = viewProcessor.filter.updateChild(oldEventCache, childKey, $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE, $9cf0852385f62d16$var$pathPopFront(path), source, accumulator);
            else newEventCache = oldEventCache;
            if (newEventCache.isEmpty() && viewCache.serverCache.isFullyInitialized()) {
                // We might have reverted all child writes. Maybe the old event was a leaf node
                complete = $9cf0852385f62d16$var$writeTreeRefCalcCompleteEventCache(writesCache, $9cf0852385f62d16$var$viewCacheGetCompleteServerSnap(viewCache));
                if (complete.isLeafNode()) newEventCache = viewProcessor.filter.updateFullNode(newEventCache, complete, accumulator);
            }
        }
        complete = viewCache.serverCache.isFullyInitialized() || $9cf0852385f62d16$var$writeTreeRefShadowingWrite(writesCache, $9cf0852385f62d16$var$newEmptyPath()) != null;
        return $9cf0852385f62d16$var$viewCacheUpdateEventSnap(viewCache, newEventCache, complete, viewProcessor.filter.filtersNodes());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A view represents a specific location and query that has 1 or more event registrations.
 *
 * It does several things:
 *  - Maintains the list of event registrations for this location/query.
 *  - Maintains a cache of the data visible for this location/query.
 *  - Applies new operations (via applyOperation), updates the cache, and based on the event
 *    registrations returns the set of events to be raised.
 */ class $9cf0852385f62d16$var$View {
    constructor(query_, initialViewCache){
        this.query_ = query_;
        this.eventRegistrations_ = [];
        const params = this.query_._queryParams;
        const indexFilter = new $9cf0852385f62d16$var$IndexedFilter(params.getIndex());
        const filter = $9cf0852385f62d16$var$queryParamsGetNodeFilter(params);
        this.processor_ = $9cf0852385f62d16$var$newViewProcessor(filter);
        const initialServerCache = initialViewCache.serverCache;
        const initialEventCache = initialViewCache.eventCache;
        // Don't filter server node with other filter than index, wait for tagged listen
        const serverSnap = indexFilter.updateFullNode($9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE, initialServerCache.getNode(), null);
        const eventSnap = filter.updateFullNode($9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE, initialEventCache.getNode(), null);
        const newServerCache = new $9cf0852385f62d16$var$CacheNode(serverSnap, initialServerCache.isFullyInitialized(), indexFilter.filtersNodes());
        const newEventCache = new $9cf0852385f62d16$var$CacheNode(eventSnap, initialEventCache.isFullyInitialized(), filter.filtersNodes());
        this.viewCache_ = $9cf0852385f62d16$var$newViewCache(newEventCache, newServerCache);
        this.eventGenerator_ = new $9cf0852385f62d16$var$EventGenerator(this.query_);
    }
    get query() {
        return this.query_;
    }
}
function $9cf0852385f62d16$var$viewGetServerCache(view) {
    return view.viewCache_.serverCache.getNode();
}
function $9cf0852385f62d16$var$viewGetCompleteNode(view) {
    return $9cf0852385f62d16$var$viewCacheGetCompleteEventSnap(view.viewCache_);
}
function $9cf0852385f62d16$var$viewGetCompleteServerCache(view, path) {
    const cache = $9cf0852385f62d16$var$viewCacheGetCompleteServerSnap(view.viewCache_);
    if (cache) {
        // If this isn't a "loadsAllData" view, then cache isn't actually a complete cache and
        // we need to see if it contains the child we're interested in.
        if (view.query._queryParams.loadsAllData() || !$9cf0852385f62d16$var$pathIsEmpty(path) && !cache.getImmediateChild($9cf0852385f62d16$var$pathGetFront(path)).isEmpty()) return cache.getChild(path);
    }
    return null;
}
function $9cf0852385f62d16$var$viewIsEmpty(view) {
    return view.eventRegistrations_.length === 0;
}
function $9cf0852385f62d16$var$viewAddEventRegistration(view, eventRegistration) {
    view.eventRegistrations_.push(eventRegistration);
}
/**
 * @param eventRegistration - If null, remove all callbacks.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @returns Cancel events, if cancelError was provided.
 */ function $9cf0852385f62d16$var$viewRemoveEventRegistration(view, eventRegistration, cancelError) {
    const cancelEvents = [];
    if (cancelError) {
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(eventRegistration == null, 'A cancel should cancel all event registrations.');
        const path = view.query._path;
        view.eventRegistrations_.forEach((registration)=>{
            const maybeEvent = registration.createCancelEvent(cancelError, path);
            if (maybeEvent) cancelEvents.push(maybeEvent);
        });
    }
    if (eventRegistration) {
        let remaining = [];
        for(let i = 0; i < view.eventRegistrations_.length; ++i){
            const existing = view.eventRegistrations_[i];
            if (!existing.matches(eventRegistration)) remaining.push(existing);
            else if (eventRegistration.hasAnyCallback()) {
                // We're removing just this one
                remaining = remaining.concat(view.eventRegistrations_.slice(i + 1));
                break;
            }
        }
        view.eventRegistrations_ = remaining;
    } else view.eventRegistrations_ = [];
    return cancelEvents;
}
/**
 * Applies the given Operation, updates our cache, and returns the appropriate events.
 */ function $9cf0852385f62d16$var$viewApplyOperation(view, operation, writesCache, completeServerCache) {
    if (operation.type === $9cf0852385f62d16$var$OperationType.MERGE && operation.source.queryId !== null) {
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)($9cf0852385f62d16$var$viewCacheGetCompleteServerSnap(view.viewCache_), 'We should always have a full cache before handling merges');
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)($9cf0852385f62d16$var$viewCacheGetCompleteEventSnap(view.viewCache_), 'Missing event cache, even though we have a server cache');
    }
    const oldViewCache = view.viewCache_;
    const result = $9cf0852385f62d16$var$viewProcessorApplyOperation(view.processor_, oldViewCache, operation, writesCache, completeServerCache);
    $9cf0852385f62d16$var$viewProcessorAssertIndexed(view.processor_, result.viewCache);
    (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(result.viewCache.serverCache.isFullyInitialized() || !oldViewCache.serverCache.isFullyInitialized(), 'Once a server snap is complete, it should never go back');
    view.viewCache_ = result.viewCache;
    return $9cf0852385f62d16$var$viewGenerateEventsForChanges_(view, result.changes, result.viewCache.eventCache.getNode(), null);
}
function $9cf0852385f62d16$var$viewGetInitialEvents(view, registration) {
    const eventSnap = view.viewCache_.eventCache;
    const initialChanges = [];
    if (!eventSnap.getNode().isLeafNode()) {
        const eventNode = eventSnap.getNode();
        eventNode.forEachChild($9cf0852385f62d16$var$PRIORITY_INDEX, (key, childNode)=>{
            initialChanges.push($9cf0852385f62d16$var$changeChildAdded(key, childNode));
        });
    }
    if (eventSnap.isFullyInitialized()) initialChanges.push($9cf0852385f62d16$var$changeValue(eventSnap.getNode()));
    return $9cf0852385f62d16$var$viewGenerateEventsForChanges_(view, initialChanges, eventSnap.getNode(), registration);
}
function $9cf0852385f62d16$var$viewGenerateEventsForChanges_(view, changes, eventCache, eventRegistration) {
    const registrations = eventRegistration ? [
        eventRegistration
    ] : view.eventRegistrations_;
    return $9cf0852385f62d16$var$eventGeneratorGenerateEventsForChanges(view.eventGenerator_, changes, eventCache, registrations);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $9cf0852385f62d16$var$referenceConstructor$1;
/**
 * SyncPoint represents a single location in a SyncTree with 1 or more event registrations, meaning we need to
 * maintain 1 or more Views at this location to cache server data and raise appropriate events for server changes
 * and user writes (set, transaction, update).
 *
 * It's responsible for:
 *  - Maintaining the set of 1 or more views necessary at this location (a SyncPoint with 0 views should be removed).
 *  - Proxying user / server operations to the views as appropriate (i.e. applyServerOverwrite,
 *    applyUserOverwrite, etc.)
 */ class $9cf0852385f62d16$var$SyncPoint {
    constructor(){
        /**
         * The Views being tracked at this location in the tree, stored as a map where the key is a
         * queryId and the value is the View for that query.
         *
         * NOTE: This list will be quite small (usually 1, but perhaps 2 or 3; any more is an odd use case).
         */ this.views = new Map();
    }
}
function $9cf0852385f62d16$var$syncPointSetReferenceConstructor(val) {
    (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(!$9cf0852385f62d16$var$referenceConstructor$1, '__referenceConstructor has already been defined');
    $9cf0852385f62d16$var$referenceConstructor$1 = val;
}
function $9cf0852385f62d16$var$syncPointGetReferenceConstructor() {
    (0, $3117f6f4eeb4c314$export$a7a9523472993e97)($9cf0852385f62d16$var$referenceConstructor$1, 'Reference.ts has not been loaded');
    return $9cf0852385f62d16$var$referenceConstructor$1;
}
function $9cf0852385f62d16$var$syncPointIsEmpty(syncPoint) {
    return syncPoint.views.size === 0;
}
function $9cf0852385f62d16$var$syncPointApplyOperation(syncPoint, operation, writesCache, optCompleteServerCache) {
    const queryId = operation.source.queryId;
    if (queryId !== null) {
        const view = syncPoint.views.get(queryId);
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(view != null, 'SyncTree gave us an op for an invalid query.');
        return $9cf0852385f62d16$var$viewApplyOperation(view, operation, writesCache, optCompleteServerCache);
    } else {
        let events = [];
        for (const view of syncPoint.views.values())events = events.concat($9cf0852385f62d16$var$viewApplyOperation(view, operation, writesCache, optCompleteServerCache));
        return events;
    }
}
/**
 * Get a view for the specified query.
 *
 * @param query - The query to return a view for
 * @param writesCache
 * @param serverCache
 * @param serverCacheComplete
 * @returns Events to raise.
 */ function $9cf0852385f62d16$var$syncPointGetView(syncPoint, query, writesCache, serverCache, serverCacheComplete) {
    const queryId = query._queryIdentifier;
    const view = syncPoint.views.get(queryId);
    if (!view) {
        // TODO: make writesCache take flag for complete server node
        let eventCache = $9cf0852385f62d16$var$writeTreeRefCalcCompleteEventCache(writesCache, serverCacheComplete ? serverCache : null);
        let eventCacheComplete = false;
        if (eventCache) eventCacheComplete = true;
        else if (serverCache instanceof $9cf0852385f62d16$var$ChildrenNode) {
            eventCache = $9cf0852385f62d16$var$writeTreeRefCalcCompleteEventChildren(writesCache, serverCache);
            eventCacheComplete = false;
        } else {
            eventCache = $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE;
            eventCacheComplete = false;
        }
        const viewCache = $9cf0852385f62d16$var$newViewCache(new $9cf0852385f62d16$var$CacheNode(eventCache, eventCacheComplete, false), new $9cf0852385f62d16$var$CacheNode(serverCache, serverCacheComplete, false));
        return new $9cf0852385f62d16$var$View(query, viewCache);
    }
    return view;
}
/**
 * Add an event callback for the specified query.
 *
 * @param query
 * @param eventRegistration
 * @param writesCache
 * @param serverCache - Complete server cache, if we have it.
 * @param serverCacheComplete
 * @returns Events to raise.
 */ function $9cf0852385f62d16$var$syncPointAddEventRegistration(syncPoint, query, eventRegistration, writesCache, serverCache, serverCacheComplete) {
    const view = $9cf0852385f62d16$var$syncPointGetView(syncPoint, query, writesCache, serverCache, serverCacheComplete);
    if (!syncPoint.views.has(query._queryIdentifier)) syncPoint.views.set(query._queryIdentifier, view);
    // This is guaranteed to exist now, we just created anything that was missing
    $9cf0852385f62d16$var$viewAddEventRegistration(view, eventRegistration);
    return $9cf0852385f62d16$var$viewGetInitialEvents(view, eventRegistration);
}
/**
 * Remove event callback(s).  Return cancelEvents if a cancelError is specified.
 *
 * If query is the default query, we'll check all views for the specified eventRegistration.
 * If eventRegistration is null, we'll remove all callbacks for the specified view(s).
 *
 * @param eventRegistration - If null, remove all callbacks.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @returns removed queries and any cancel events
 */ function $9cf0852385f62d16$var$syncPointRemoveEventRegistration(syncPoint, query, eventRegistration, cancelError) {
    const queryId = query._queryIdentifier;
    const removed = [];
    let cancelEvents = [];
    const hadCompleteView = $9cf0852385f62d16$var$syncPointHasCompleteView(syncPoint);
    if (queryId === 'default') // When you do ref.off(...), we search all views for the registration to remove.
    for (const [viewQueryId, view] of syncPoint.views.entries()){
        cancelEvents = cancelEvents.concat($9cf0852385f62d16$var$viewRemoveEventRegistration(view, eventRegistration, cancelError));
        if ($9cf0852385f62d16$var$viewIsEmpty(view)) {
            syncPoint.views.delete(viewQueryId);
            // We'll deal with complete views later.
            if (!view.query._queryParams.loadsAllData()) removed.push(view.query);
        }
    }
    else {
        // remove the callback from the specific view.
        const view = syncPoint.views.get(queryId);
        if (view) {
            cancelEvents = cancelEvents.concat($9cf0852385f62d16$var$viewRemoveEventRegistration(view, eventRegistration, cancelError));
            if ($9cf0852385f62d16$var$viewIsEmpty(view)) {
                syncPoint.views.delete(queryId);
                // We'll deal with complete views later.
                if (!view.query._queryParams.loadsAllData()) removed.push(view.query);
            }
        }
    }
    if (hadCompleteView && !$9cf0852385f62d16$var$syncPointHasCompleteView(syncPoint)) // We removed our last complete view.
    removed.push(new ($9cf0852385f62d16$var$syncPointGetReferenceConstructor())(query._repo, query._path));
    return {
        removed: removed,
        events: cancelEvents
    };
}
function $9cf0852385f62d16$var$syncPointGetQueryViews(syncPoint) {
    const result = [];
    for (const view of syncPoint.views.values())if (!view.query._queryParams.loadsAllData()) result.push(view);
    return result;
}
/**
 * @param path - The path to the desired complete snapshot
 * @returns A complete cache, if it exists
 */ function $9cf0852385f62d16$var$syncPointGetCompleteServerCache(syncPoint, path) {
    let serverCache = null;
    for (const view of syncPoint.views.values())serverCache = serverCache || $9cf0852385f62d16$var$viewGetCompleteServerCache(view, path);
    return serverCache;
}
function $9cf0852385f62d16$var$syncPointViewForQuery(syncPoint, query) {
    const params = query._queryParams;
    if (params.loadsAllData()) return $9cf0852385f62d16$var$syncPointGetCompleteView(syncPoint);
    else {
        const queryId = query._queryIdentifier;
        return syncPoint.views.get(queryId);
    }
}
function $9cf0852385f62d16$var$syncPointViewExistsForQuery(syncPoint, query) {
    return $9cf0852385f62d16$var$syncPointViewForQuery(syncPoint, query) != null;
}
function $9cf0852385f62d16$var$syncPointHasCompleteView(syncPoint) {
    return $9cf0852385f62d16$var$syncPointGetCompleteView(syncPoint) != null;
}
function $9cf0852385f62d16$var$syncPointGetCompleteView(syncPoint) {
    for (const view of syncPoint.views.values()){
        if (view.query._queryParams.loadsAllData()) return view;
    }
    return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $9cf0852385f62d16$var$referenceConstructor;
function $9cf0852385f62d16$var$syncTreeSetReferenceConstructor(val) {
    (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(!$9cf0852385f62d16$var$referenceConstructor, '__referenceConstructor has already been defined');
    $9cf0852385f62d16$var$referenceConstructor = val;
}
function $9cf0852385f62d16$var$syncTreeGetReferenceConstructor() {
    (0, $3117f6f4eeb4c314$export$a7a9523472993e97)($9cf0852385f62d16$var$referenceConstructor, 'Reference.ts has not been loaded');
    return $9cf0852385f62d16$var$referenceConstructor;
}
/**
 * Static tracker for next query tag.
 */ let $9cf0852385f62d16$var$syncTreeNextQueryTag_ = 1;
/**
 * SyncTree is the central class for managing event callback registration, data caching, views
 * (query processing), and event generation.  There are typically two SyncTree instances for
 * each Repo, one for the normal Firebase data, and one for the .info data.
 *
 * It has a number of responsibilities, including:
 *  - Tracking all user event callbacks (registered via addEventRegistration() and removeEventRegistration()).
 *  - Applying and caching data changes for user set(), transaction(), and update() calls
 *    (applyUserOverwrite(), applyUserMerge()).
 *  - Applying and caching data changes for server data changes (applyServerOverwrite(),
 *    applyServerMerge()).
 *  - Generating user-facing events for server and user changes (all of the apply* methods
 *    return the set of events that need to be raised as a result).
 *  - Maintaining the appropriate set of server listens to ensure we are always subscribed
 *    to the correct set of paths and queries to satisfy the current set of user event
 *    callbacks (listens are started/stopped using the provided listenProvider).
 *
 * NOTE: Although SyncTree tracks event callbacks and calculates events to raise, the actual
 * events are returned to the caller rather than raised synchronously.
 *
 */ class $9cf0852385f62d16$var$SyncTree {
    /**
     * @param listenProvider_ - Used by SyncTree to start / stop listening
     *   to server data.
     */ constructor(listenProvider_){
        this.listenProvider_ = listenProvider_;
        /**
         * Tree of SyncPoints.  There's a SyncPoint at any location that has 1 or more views.
         */ this.syncPointTree_ = new $9cf0852385f62d16$var$ImmutableTree(null);
        /**
         * A tree of all pending user writes (user-initiated set()'s, transaction()'s, update()'s, etc.).
         */ this.pendingWriteTree_ = $9cf0852385f62d16$var$newWriteTree();
        this.tagToQueryMap = new Map();
        this.queryToTagMap = new Map();
    }
}
/**
 * Apply the data changes for a user-generated set() or transaction() call.
 *
 * @returns Events to raise.
 */ function $9cf0852385f62d16$var$syncTreeApplyUserOverwrite(syncTree, path, newData, writeId, visible) {
    // Record pending write.
    $9cf0852385f62d16$var$writeTreeAddOverwrite(syncTree.pendingWriteTree_, path, newData, writeId, visible);
    if (!visible) return [];
    else return $9cf0852385f62d16$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $9cf0852385f62d16$var$Overwrite($9cf0852385f62d16$var$newOperationSourceUser(), path, newData));
}
/**
 * Apply the data from a user-generated update() call
 *
 * @returns Events to raise.
 */ function $9cf0852385f62d16$var$syncTreeApplyUserMerge(syncTree, path, changedChildren, writeId) {
    // Record pending merge.
    $9cf0852385f62d16$var$writeTreeAddMerge(syncTree.pendingWriteTree_, path, changedChildren, writeId);
    const changeTree = $9cf0852385f62d16$var$ImmutableTree.fromObject(changedChildren);
    return $9cf0852385f62d16$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $9cf0852385f62d16$var$Merge($9cf0852385f62d16$var$newOperationSourceUser(), path, changeTree));
}
/**
 * Acknowledge a pending user write that was previously registered with applyUserOverwrite() or applyUserMerge().
 *
 * @param revert - True if the given write failed and needs to be reverted
 * @returns Events to raise.
 */ function $9cf0852385f62d16$var$syncTreeAckUserWrite(syncTree, writeId, revert = false) {
    const write = $9cf0852385f62d16$var$writeTreeGetWrite(syncTree.pendingWriteTree_, writeId);
    const needToReevaluate = $9cf0852385f62d16$var$writeTreeRemoveWrite(syncTree.pendingWriteTree_, writeId);
    if (!needToReevaluate) return [];
    else {
        let affectedTree = new $9cf0852385f62d16$var$ImmutableTree(null);
        if (write.snap != null) // overwrite
        affectedTree = affectedTree.set($9cf0852385f62d16$var$newEmptyPath(), true);
        else $9cf0852385f62d16$var$each(write.children, (pathString)=>{
            affectedTree = affectedTree.set(new $9cf0852385f62d16$var$Path(pathString), true);
        });
        return $9cf0852385f62d16$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $9cf0852385f62d16$var$AckUserWrite(write.path, affectedTree, revert));
    }
}
/**
 * Apply new server data for the specified path..
 *
 * @returns Events to raise.
 */ function $9cf0852385f62d16$var$syncTreeApplyServerOverwrite(syncTree, path, newData) {
    return $9cf0852385f62d16$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $9cf0852385f62d16$var$Overwrite($9cf0852385f62d16$var$newOperationSourceServer(), path, newData));
}
/**
 * Apply new server data to be merged in at the specified path.
 *
 * @returns Events to raise.
 */ function $9cf0852385f62d16$var$syncTreeApplyServerMerge(syncTree, path, changedChildren) {
    const changeTree = $9cf0852385f62d16$var$ImmutableTree.fromObject(changedChildren);
    return $9cf0852385f62d16$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $9cf0852385f62d16$var$Merge($9cf0852385f62d16$var$newOperationSourceServer(), path, changeTree));
}
/**
 * Apply a listen complete for a query
 *
 * @returns Events to raise.
 */ function $9cf0852385f62d16$var$syncTreeApplyListenComplete(syncTree, path) {
    return $9cf0852385f62d16$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $9cf0852385f62d16$var$ListenComplete($9cf0852385f62d16$var$newOperationSourceServer(), path));
}
/**
 * Apply a listen complete for a tagged query
 *
 * @returns Events to raise.
 */ function $9cf0852385f62d16$var$syncTreeApplyTaggedListenComplete(syncTree, path, tag) {
    const queryKey = $9cf0852385f62d16$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey) {
        const r = $9cf0852385f62d16$var$syncTreeParseQueryKey_(queryKey);
        const queryPath = r.path, queryId = r.queryId;
        const relativePath = $9cf0852385f62d16$var$newRelativePath(queryPath, path);
        const op = new $9cf0852385f62d16$var$ListenComplete($9cf0852385f62d16$var$newOperationSourceServerTaggedQuery(queryId), relativePath);
        return $9cf0852385f62d16$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // We've already removed the query. No big deal, ignore the update
    return [];
}
/**
 * Remove event callback(s).
 *
 * If query is the default query, we'll check all queries for the specified eventRegistration.
 * If eventRegistration is null, we'll remove all callbacks for the specified query/queries.
 *
 * @param eventRegistration - If null, all callbacks are removed.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @param skipListenerDedup - When performing a `get()`, we don't add any new listeners, so no
 *  deduping needs to take place. This flag allows toggling of that behavior
 * @returns Cancel events, if cancelError was provided.
 */ function $9cf0852385f62d16$var$syncTreeRemoveEventRegistration(syncTree, query, eventRegistration, cancelError, skipListenerDedup = false) {
    // Find the syncPoint first. Then deal with whether or not it has matching listeners
    const path = query._path;
    const maybeSyncPoint = syncTree.syncPointTree_.get(path);
    let cancelEvents = [];
    // A removal on a default query affects all queries at that location. A removal on an indexed query, even one without
    // other query constraints, does *not* affect all queries at that location. So this check must be for 'default', and
    // not loadsAllData().
    if (maybeSyncPoint && (query._queryIdentifier === 'default' || $9cf0852385f62d16$var$syncPointViewExistsForQuery(maybeSyncPoint, query))) {
        const removedAndEvents = $9cf0852385f62d16$var$syncPointRemoveEventRegistration(maybeSyncPoint, query, eventRegistration, cancelError);
        if ($9cf0852385f62d16$var$syncPointIsEmpty(maybeSyncPoint)) syncTree.syncPointTree_ = syncTree.syncPointTree_.remove(path);
        const removed = removedAndEvents.removed;
        cancelEvents = removedAndEvents.events;
        if (!skipListenerDedup) {
            /**
             * We may have just removed one of many listeners and can short-circuit this whole process
             * We may also not have removed a default listener, in which case all of the descendant listeners should already be
             * properly set up.
             */ // Since indexed queries can shadow if they don't have other query constraints, check for loadsAllData(), instead of
            // queryId === 'default'
            const removingDefault = -1 !== removed.findIndex((query)=>{
                return query._queryParams.loadsAllData();
            });
            const covered = syncTree.syncPointTree_.findOnPath(path, (relativePath, parentSyncPoint)=>$9cf0852385f62d16$var$syncPointHasCompleteView(parentSyncPoint));
            if (removingDefault && !covered) {
                const subtree = syncTree.syncPointTree_.subtree(path);
                // There are potentially child listeners. Determine what if any listens we need to send before executing the
                // removal
                if (!subtree.isEmpty()) {
                    // We need to fold over our subtree and collect the listeners to send
                    const newViews = $9cf0852385f62d16$var$syncTreeCollectDistinctViewsForSubTree_(subtree);
                    // Ok, we've collected all the listens we need. Set them up.
                    for(let i = 0; i < newViews.length; ++i){
                        const view = newViews[i], newQuery = view.query;
                        const listener = $9cf0852385f62d16$var$syncTreeCreateListenerForView_(syncTree, view);
                        syncTree.listenProvider_.startListening($9cf0852385f62d16$var$syncTreeQueryForListening_(newQuery), $9cf0852385f62d16$var$syncTreeTagForQuery(syncTree, newQuery), listener.hashFn, listener.onComplete);
                    }
                }
            // Otherwise there's nothing below us, so nothing we need to start listening on
            }
            // If we removed anything and we're not covered by a higher up listen, we need to stop listening on this query
            // The above block has us covered in terms of making sure we're set up on listens lower in the tree.
            // Also, note that if we have a cancelError, it's already been removed at the provider level.
            if (!covered && removed.length > 0 && !cancelError) {
                // If we removed a default, then we weren't listening on any of the other queries here. Just cancel the one
                // default. Otherwise, we need to iterate through and cancel each individual query
                if (removingDefault) {
                    // We don't tag default listeners
                    const defaultTag = null;
                    syncTree.listenProvider_.stopListening($9cf0852385f62d16$var$syncTreeQueryForListening_(query), defaultTag);
                } else removed.forEach((queryToRemove)=>{
                    const tagToRemove = syncTree.queryToTagMap.get($9cf0852385f62d16$var$syncTreeMakeQueryKey_(queryToRemove));
                    syncTree.listenProvider_.stopListening($9cf0852385f62d16$var$syncTreeQueryForListening_(queryToRemove), tagToRemove);
                });
            }
        }
        // Now, clear all of the tags we're tracking for the removed listens
        $9cf0852385f62d16$var$syncTreeRemoveTags_(syncTree, removed);
    }
    return cancelEvents;
}
/**
 * Apply new server data for the specified tagged query.
 *
 * @returns Events to raise.
 */ function $9cf0852385f62d16$var$syncTreeApplyTaggedQueryOverwrite(syncTree, path, snap, tag) {
    const queryKey = $9cf0852385f62d16$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey != null) {
        const r = $9cf0852385f62d16$var$syncTreeParseQueryKey_(queryKey);
        const queryPath = r.path, queryId = r.queryId;
        const relativePath = $9cf0852385f62d16$var$newRelativePath(queryPath, path);
        const op = new $9cf0852385f62d16$var$Overwrite($9cf0852385f62d16$var$newOperationSourceServerTaggedQuery(queryId), relativePath, snap);
        return $9cf0852385f62d16$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // Query must have been removed already
    return [];
}
/**
 * Apply server data to be merged in for the specified tagged query.
 *
 * @returns Events to raise.
 */ function $9cf0852385f62d16$var$syncTreeApplyTaggedQueryMerge(syncTree, path, changedChildren, tag) {
    const queryKey = $9cf0852385f62d16$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey) {
        const r = $9cf0852385f62d16$var$syncTreeParseQueryKey_(queryKey);
        const queryPath = r.path, queryId = r.queryId;
        const relativePath = $9cf0852385f62d16$var$newRelativePath(queryPath, path);
        const changeTree = $9cf0852385f62d16$var$ImmutableTree.fromObject(changedChildren);
        const op = new $9cf0852385f62d16$var$Merge($9cf0852385f62d16$var$newOperationSourceServerTaggedQuery(queryId), relativePath, changeTree);
        return $9cf0852385f62d16$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // We've already removed the query. No big deal, ignore the update
    return [];
}
/**
 * Add an event callback for the specified query.
 *
 * @returns Events to raise.
 */ function $9cf0852385f62d16$var$syncTreeAddEventRegistration(syncTree, query, eventRegistration, skipSetupListener = false) {
    const path = query._path;
    let serverCache = null;
    let foundAncestorDefaultView = false;
    // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
    // Consider optimizing this once there's a better understanding of what actual behavior will be.
    syncTree.syncPointTree_.foreachOnPath(path, (pathToSyncPoint, sp)=>{
        const relativePath = $9cf0852385f62d16$var$newRelativePath(pathToSyncPoint, path);
        serverCache = serverCache || $9cf0852385f62d16$var$syncPointGetCompleteServerCache(sp, relativePath);
        foundAncestorDefaultView = foundAncestorDefaultView || $9cf0852385f62d16$var$syncPointHasCompleteView(sp);
    });
    let syncPoint = syncTree.syncPointTree_.get(path);
    if (!syncPoint) {
        syncPoint = new $9cf0852385f62d16$var$SyncPoint();
        syncTree.syncPointTree_ = syncTree.syncPointTree_.set(path, syncPoint);
    } else {
        foundAncestorDefaultView = foundAncestorDefaultView || $9cf0852385f62d16$var$syncPointHasCompleteView(syncPoint);
        serverCache = serverCache || $9cf0852385f62d16$var$syncPointGetCompleteServerCache(syncPoint, $9cf0852385f62d16$var$newEmptyPath());
    }
    let serverCacheComplete;
    if (serverCache != null) serverCacheComplete = true;
    else {
        serverCacheComplete = false;
        serverCache = $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE;
        const subtree = syncTree.syncPointTree_.subtree(path);
        subtree.foreachChild((childName, childSyncPoint)=>{
            const completeCache = $9cf0852385f62d16$var$syncPointGetCompleteServerCache(childSyncPoint, $9cf0852385f62d16$var$newEmptyPath());
            if (completeCache) serverCache = serverCache.updateImmediateChild(childName, completeCache);
        });
    }
    const viewAlreadyExists = $9cf0852385f62d16$var$syncPointViewExistsForQuery(syncPoint, query);
    if (!viewAlreadyExists && !query._queryParams.loadsAllData()) {
        // We need to track a tag for this query
        const queryKey = $9cf0852385f62d16$var$syncTreeMakeQueryKey_(query);
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(!syncTree.queryToTagMap.has(queryKey), 'View does not exist, but we have a tag');
        const tag = $9cf0852385f62d16$var$syncTreeGetNextQueryTag_();
        syncTree.queryToTagMap.set(queryKey, tag);
        syncTree.tagToQueryMap.set(tag, queryKey);
    }
    const writesCache = $9cf0852385f62d16$var$writeTreeChildWrites(syncTree.pendingWriteTree_, path);
    let events = $9cf0852385f62d16$var$syncPointAddEventRegistration(syncPoint, query, eventRegistration, writesCache, serverCache, serverCacheComplete);
    if (!viewAlreadyExists && !foundAncestorDefaultView && !skipSetupListener) {
        const view = $9cf0852385f62d16$var$syncPointViewForQuery(syncPoint, query);
        events = events.concat($9cf0852385f62d16$var$syncTreeSetupListener_(syncTree, query, view));
    }
    return events;
}
/**
 * Returns a complete cache, if we have one, of the data at a particular path. If the location does not have a
 * listener above it, we will get a false "null". This shouldn't be a problem because transactions will always
 * have a listener above, and atomic operations would correctly show a jitter of <increment value> ->
 *     <incremented total> as the write is applied locally and then acknowledged at the server.
 *
 * Note: this method will *include* hidden writes from transaction with applyLocally set to false.
 *
 * @param path - The path to the data we want
 * @param writeIdsToExclude - A specific set to be excluded
 */ function $9cf0852385f62d16$var$syncTreeCalcCompleteEventCache(syncTree, path, writeIdsToExclude) {
    const includeHiddenSets = true;
    const writeTree = syncTree.pendingWriteTree_;
    const serverCache = syncTree.syncPointTree_.findOnPath(path, (pathSoFar, syncPoint)=>{
        const relativePath = $9cf0852385f62d16$var$newRelativePath(pathSoFar, path);
        const serverCache = $9cf0852385f62d16$var$syncPointGetCompleteServerCache(syncPoint, relativePath);
        if (serverCache) return serverCache;
    });
    return $9cf0852385f62d16$var$writeTreeCalcCompleteEventCache(writeTree, path, serverCache, writeIdsToExclude, includeHiddenSets);
}
function $9cf0852385f62d16$var$syncTreeGetServerValue(syncTree, query) {
    const path = query._path;
    let serverCache = null;
    // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
    // Consider optimizing this once there's a better understanding of what actual behavior will be.
    syncTree.syncPointTree_.foreachOnPath(path, (pathToSyncPoint, sp)=>{
        const relativePath = $9cf0852385f62d16$var$newRelativePath(pathToSyncPoint, path);
        serverCache = serverCache || $9cf0852385f62d16$var$syncPointGetCompleteServerCache(sp, relativePath);
    });
    let syncPoint = syncTree.syncPointTree_.get(path);
    if (!syncPoint) {
        syncPoint = new $9cf0852385f62d16$var$SyncPoint();
        syncTree.syncPointTree_ = syncTree.syncPointTree_.set(path, syncPoint);
    } else serverCache = serverCache || $9cf0852385f62d16$var$syncPointGetCompleteServerCache(syncPoint, $9cf0852385f62d16$var$newEmptyPath());
    const serverCacheComplete = serverCache != null;
    const serverCacheNode = serverCacheComplete ? new $9cf0852385f62d16$var$CacheNode(serverCache, true, false) : null;
    const writesCache = $9cf0852385f62d16$var$writeTreeChildWrites(syncTree.pendingWriteTree_, query._path);
    const view = $9cf0852385f62d16$var$syncPointGetView(syncPoint, query, writesCache, serverCacheComplete ? serverCacheNode.getNode() : $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE, serverCacheComplete);
    return $9cf0852385f62d16$var$viewGetCompleteNode(view);
}
/**
 * A helper method that visits all descendant and ancestor SyncPoints, applying the operation.
 *
 * NOTES:
 * - Descendant SyncPoints will be visited first (since we raise events depth-first).
 *
 * - We call applyOperation() on each SyncPoint passing three things:
 *   1. A version of the Operation that has been made relative to the SyncPoint location.
 *   2. A WriteTreeRef of any writes we have cached at the SyncPoint location.
 *   3. A snapshot Node with cached server data, if we have it.
 *
 * - We concatenate all of the events returned by each SyncPoint and return the result.
 */ function $9cf0852385f62d16$var$syncTreeApplyOperationToSyncPoints_(syncTree, operation) {
    return $9cf0852385f62d16$var$syncTreeApplyOperationHelper_(operation, syncTree.syncPointTree_, /*serverCache=*/ null, $9cf0852385f62d16$var$writeTreeChildWrites(syncTree.pendingWriteTree_, $9cf0852385f62d16$var$newEmptyPath()));
}
/**
 * Recursive helper for applyOperationToSyncPoints_
 */ function $9cf0852385f62d16$var$syncTreeApplyOperationHelper_(operation, syncPointTree, serverCache, writesCache) {
    if ($9cf0852385f62d16$var$pathIsEmpty(operation.path)) return $9cf0852385f62d16$var$syncTreeApplyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache);
    else {
        const syncPoint = syncPointTree.get($9cf0852385f62d16$var$newEmptyPath());
        // If we don't have cached server data, see if we can get it from this SyncPoint.
        if (serverCache == null && syncPoint != null) serverCache = $9cf0852385f62d16$var$syncPointGetCompleteServerCache(syncPoint, $9cf0852385f62d16$var$newEmptyPath());
        let events = [];
        const childName = $9cf0852385f62d16$var$pathGetFront(operation.path);
        const childOperation = operation.operationForChild(childName);
        const childTree = syncPointTree.children.get(childName);
        if (childTree && childOperation) {
            const childServerCache = serverCache ? serverCache.getImmediateChild(childName) : null;
            const childWritesCache = $9cf0852385f62d16$var$writeTreeRefChild(writesCache, childName);
            events = events.concat($9cf0852385f62d16$var$syncTreeApplyOperationHelper_(childOperation, childTree, childServerCache, childWritesCache));
        }
        if (syncPoint) events = events.concat($9cf0852385f62d16$var$syncPointApplyOperation(syncPoint, operation, writesCache, serverCache));
        return events;
    }
}
/**
 * Recursive helper for applyOperationToSyncPoints_
 */ function $9cf0852385f62d16$var$syncTreeApplyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache) {
    const syncPoint = syncPointTree.get($9cf0852385f62d16$var$newEmptyPath());
    // If we don't have cached server data, see if we can get it from this SyncPoint.
    if (serverCache == null && syncPoint != null) serverCache = $9cf0852385f62d16$var$syncPointGetCompleteServerCache(syncPoint, $9cf0852385f62d16$var$newEmptyPath());
    let events = [];
    syncPointTree.children.inorderTraversal((childName, childTree)=>{
        const childServerCache = serverCache ? serverCache.getImmediateChild(childName) : null;
        const childWritesCache = $9cf0852385f62d16$var$writeTreeRefChild(writesCache, childName);
        const childOperation = operation.operationForChild(childName);
        if (childOperation) events = events.concat($9cf0852385f62d16$var$syncTreeApplyOperationDescendantsHelper_(childOperation, childTree, childServerCache, childWritesCache));
    });
    if (syncPoint) events = events.concat($9cf0852385f62d16$var$syncPointApplyOperation(syncPoint, operation, writesCache, serverCache));
    return events;
}
function $9cf0852385f62d16$var$syncTreeCreateListenerForView_(syncTree, view) {
    const query = view.query;
    const tag = $9cf0852385f62d16$var$syncTreeTagForQuery(syncTree, query);
    return {
        hashFn: ()=>{
            const cache = $9cf0852385f62d16$var$viewGetServerCache(view) || $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE;
            return cache.hash();
        },
        onComplete: (status)=>{
            if (status === 'ok') {
                if (tag) return $9cf0852385f62d16$var$syncTreeApplyTaggedListenComplete(syncTree, query._path, tag);
                else return $9cf0852385f62d16$var$syncTreeApplyListenComplete(syncTree, query._path);
            } else {
                // If a listen failed, kill all of the listeners here, not just the one that triggered the error.
                // Note that this may need to be scoped to just this listener if we change permissions on filtered children
                const error = $9cf0852385f62d16$var$errorForServerCode(status, query);
                return $9cf0852385f62d16$var$syncTreeRemoveEventRegistration(syncTree, query, /*eventRegistration*/ null, error);
            }
        }
    };
}
/**
 * Return the tag associated with the given query.
 */ function $9cf0852385f62d16$var$syncTreeTagForQuery(syncTree, query) {
    const queryKey = $9cf0852385f62d16$var$syncTreeMakeQueryKey_(query);
    return syncTree.queryToTagMap.get(queryKey);
}
/**
 * Given a query, computes a "queryKey" suitable for use in our queryToTagMap_.
 */ function $9cf0852385f62d16$var$syncTreeMakeQueryKey_(query) {
    return query._path.toString() + '$' + query._queryIdentifier;
}
/**
 * Return the query associated with the given tag, if we have one
 */ function $9cf0852385f62d16$var$syncTreeQueryKeyForTag_(syncTree, tag) {
    return syncTree.tagToQueryMap.get(tag);
}
/**
 * Given a queryKey (created by makeQueryKey), parse it back into a path and queryId.
 */ function $9cf0852385f62d16$var$syncTreeParseQueryKey_(queryKey) {
    const splitIndex = queryKey.indexOf('$');
    (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(splitIndex !== -1 && splitIndex < queryKey.length - 1, 'Bad queryKey.');
    return {
        queryId: queryKey.substr(splitIndex + 1),
        path: new $9cf0852385f62d16$var$Path(queryKey.substr(0, splitIndex))
    };
}
/**
 * A helper method to apply tagged operations
 */ function $9cf0852385f62d16$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, operation) {
    const syncPoint = syncTree.syncPointTree_.get(queryPath);
    (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(syncPoint, "Missing sync point for query tag that we're tracking");
    const writesCache = $9cf0852385f62d16$var$writeTreeChildWrites(syncTree.pendingWriteTree_, queryPath);
    return $9cf0852385f62d16$var$syncPointApplyOperation(syncPoint, operation, writesCache, null);
}
/**
 * This collapses multiple unfiltered views into a single view, since we only need a single
 * listener for them.
 */ function $9cf0852385f62d16$var$syncTreeCollectDistinctViewsForSubTree_(subtree) {
    return subtree.fold((relativePath, maybeChildSyncPoint, childMap)=>{
        if (maybeChildSyncPoint && $9cf0852385f62d16$var$syncPointHasCompleteView(maybeChildSyncPoint)) {
            const completeView = $9cf0852385f62d16$var$syncPointGetCompleteView(maybeChildSyncPoint);
            return [
                completeView
            ];
        } else {
            // No complete view here, flatten any deeper listens into an array
            let views = [];
            if (maybeChildSyncPoint) views = $9cf0852385f62d16$var$syncPointGetQueryViews(maybeChildSyncPoint);
            $9cf0852385f62d16$var$each(childMap, (_key, childViews)=>{
                views = views.concat(childViews);
            });
            return views;
        }
    });
}
/**
 * Normalizes a query to a query we send the server for listening
 *
 * @returns The normalized query
 */ function $9cf0852385f62d16$var$syncTreeQueryForListening_(query) {
    if (query._queryParams.loadsAllData() && !query._queryParams.isDefault()) // We treat queries that load all data as default queries
    // Cast is necessary because ref() technically returns Firebase which is actually fb.api.Firebase which inherits
    // from Query
    return new ($9cf0852385f62d16$var$syncTreeGetReferenceConstructor())(query._repo, query._path);
    else return query;
}
function $9cf0852385f62d16$var$syncTreeRemoveTags_(syncTree, queries) {
    for(let j = 0; j < queries.length; ++j){
        const removedQuery = queries[j];
        if (!removedQuery._queryParams.loadsAllData()) {
            // We should have a tag for this
            const removedQueryKey = $9cf0852385f62d16$var$syncTreeMakeQueryKey_(removedQuery);
            const removedQueryTag = syncTree.queryToTagMap.get(removedQueryKey);
            syncTree.queryToTagMap.delete(removedQueryKey);
            syncTree.tagToQueryMap.delete(removedQueryTag);
        }
    }
}
/**
 * Static accessor for query tags.
 */ function $9cf0852385f62d16$var$syncTreeGetNextQueryTag_() {
    return $9cf0852385f62d16$var$syncTreeNextQueryTag_++;
}
/**
 * For a given new listen, manage the de-duplication of outstanding subscriptions.
 *
 * @returns This method can return events to support synchronous data sources
 */ function $9cf0852385f62d16$var$syncTreeSetupListener_(syncTree, query, view) {
    const path = query._path;
    const tag = $9cf0852385f62d16$var$syncTreeTagForQuery(syncTree, query);
    const listener = $9cf0852385f62d16$var$syncTreeCreateListenerForView_(syncTree, view);
    const events = syncTree.listenProvider_.startListening($9cf0852385f62d16$var$syncTreeQueryForListening_(query), tag, listener.hashFn, listener.onComplete);
    const subtree = syncTree.syncPointTree_.subtree(path);
    // The root of this subtree has our query. We're here because we definitely need to send a listen for that, but we
    // may need to shadow other listens as well.
    if (tag) (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(!$9cf0852385f62d16$var$syncPointHasCompleteView(subtree.value), "If we're adding a query, it shouldn't be shadowed");
    else {
        // Shadow everything at or below this location, this is a default listener.
        const queriesToStop = subtree.fold((relativePath, maybeChildSyncPoint, childMap)=>{
            if (!$9cf0852385f62d16$var$pathIsEmpty(relativePath) && maybeChildSyncPoint && $9cf0852385f62d16$var$syncPointHasCompleteView(maybeChildSyncPoint)) return [
                $9cf0852385f62d16$var$syncPointGetCompleteView(maybeChildSyncPoint).query
            ];
            else {
                // No default listener here, flatten any deeper queries into an array
                let queries = [];
                if (maybeChildSyncPoint) queries = queries.concat($9cf0852385f62d16$var$syncPointGetQueryViews(maybeChildSyncPoint).map((view)=>view.query));
                $9cf0852385f62d16$var$each(childMap, (_key, childQueries)=>{
                    queries = queries.concat(childQueries);
                });
                return queries;
            }
        });
        for(let i = 0; i < queriesToStop.length; ++i){
            const queryToStop = queriesToStop[i];
            syncTree.listenProvider_.stopListening($9cf0852385f62d16$var$syncTreeQueryForListening_(queryToStop), $9cf0852385f62d16$var$syncTreeTagForQuery(syncTree, queryToStop));
        }
    }
    return events;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9cf0852385f62d16$var$ExistingValueProvider {
    constructor(node_){
        this.node_ = node_;
    }
    getImmediateChild(childName) {
        const child = this.node_.getImmediateChild(childName);
        return new $9cf0852385f62d16$var$ExistingValueProvider(child);
    }
    node() {
        return this.node_;
    }
}
class $9cf0852385f62d16$var$DeferredValueProvider {
    constructor(syncTree, path){
        this.syncTree_ = syncTree;
        this.path_ = path;
    }
    getImmediateChild(childName) {
        const childPath = $9cf0852385f62d16$var$pathChild(this.path_, childName);
        return new $9cf0852385f62d16$var$DeferredValueProvider(this.syncTree_, childPath);
    }
    node() {
        return $9cf0852385f62d16$var$syncTreeCalcCompleteEventCache(this.syncTree_, this.path_);
    }
}
/**
 * Generate placeholders for deferred values.
 */ const $9cf0852385f62d16$var$generateWithValues = function(values) {
    values = values || {};
    values['timestamp'] = values['timestamp'] || new Date().getTime();
    return values;
};
/**
 * Value to use when firing local events. When writing server values, fire
 * local events with an approximate value, otherwise return value as-is.
 */ const $9cf0852385f62d16$var$resolveDeferredLeafValue = function(value, existingVal, serverValues) {
    if (!value || typeof value !== 'object') return value;
    (0, $3117f6f4eeb4c314$export$a7a9523472993e97)('.sv' in value, 'Unexpected leaf node or priority contents');
    if (typeof value['.sv'] === 'string') return $9cf0852385f62d16$var$resolveScalarDeferredValue(value['.sv'], existingVal, serverValues);
    else if (typeof value['.sv'] === 'object') return $9cf0852385f62d16$var$resolveComplexDeferredValue(value['.sv'], existingVal);
    else (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(false, 'Unexpected server value: ' + JSON.stringify(value, null, 2));
};
const $9cf0852385f62d16$var$resolveScalarDeferredValue = function(op, existing, serverValues) {
    switch(op){
        case 'timestamp':
            return serverValues['timestamp'];
        default:
            (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(false, 'Unexpected server value: ' + op);
    }
};
const $9cf0852385f62d16$var$resolveComplexDeferredValue = function(op, existing, unused) {
    if (!op.hasOwnProperty('increment')) (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(false, 'Unexpected server value: ' + JSON.stringify(op, null, 2));
    const delta = op['increment'];
    if (typeof delta !== 'number') (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(false, 'Unexpected increment value: ' + delta);
    const existingNode = existing.node();
    (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(existingNode !== null && typeof existingNode !== 'undefined', 'Expected ChildrenNode.EMPTY_NODE for nulls');
    // Incrementing a non-number sets the value to the incremented amount
    if (!existingNode.isLeafNode()) return delta;
    const leaf = existingNode;
    const existingVal = leaf.getValue();
    if (typeof existingVal !== 'number') return delta;
    // No need to do over/underflow arithmetic here because JS only handles floats under the covers
    return existingVal + delta;
};
/**
 * Recursively replace all deferred values and priorities in the tree with the
 * specified generated replacement values.
 * @param path - path to which write is relative
 * @param node - new data written at path
 * @param syncTree - current data
 */ const $9cf0852385f62d16$var$resolveDeferredValueTree = function(path, node, syncTree, serverValues) {
    return $9cf0852385f62d16$var$resolveDeferredValue(node, new $9cf0852385f62d16$var$DeferredValueProvider(syncTree, path), serverValues);
};
/**
 * Recursively replace all deferred values and priorities in the node with the
 * specified generated replacement values.  If there are no server values in the node,
 * it'll be returned as-is.
 */ const $9cf0852385f62d16$var$resolveDeferredValueSnapshot = function(node, existing, serverValues) {
    return $9cf0852385f62d16$var$resolveDeferredValue(node, new $9cf0852385f62d16$var$ExistingValueProvider(existing), serverValues);
};
function $9cf0852385f62d16$var$resolveDeferredValue(node, existingVal, serverValues) {
    const rawPri = node.getPriority().val();
    const priority = $9cf0852385f62d16$var$resolveDeferredLeafValue(rawPri, existingVal.getImmediateChild('.priority'), serverValues);
    let newNode;
    if (node.isLeafNode()) {
        const leafNode = node;
        const value = $9cf0852385f62d16$var$resolveDeferredLeafValue(leafNode.getValue(), existingVal, serverValues);
        if (value !== leafNode.getValue() || priority !== leafNode.getPriority().val()) return new $9cf0852385f62d16$var$LeafNode(value, $9cf0852385f62d16$var$nodeFromJSON(priority));
        else return node;
    } else {
        const childrenNode = node;
        newNode = childrenNode;
        if (priority !== childrenNode.getPriority().val()) newNode = newNode.updatePriority(new $9cf0852385f62d16$var$LeafNode(priority));
        childrenNode.forEachChild($9cf0852385f62d16$var$PRIORITY_INDEX, (childName, childNode)=>{
            const newChildNode = $9cf0852385f62d16$var$resolveDeferredValue(childNode, existingVal.getImmediateChild(childName), serverValues);
            if (newChildNode !== childNode) newNode = newNode.updateImmediateChild(childName, newChildNode);
        });
        return newNode;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A light-weight tree, traversable by path.  Nodes can have both values and children.
 * Nodes are not enumerated (by forEachChild) unless they have a value or non-empty
 * children.
 */ class $9cf0852385f62d16$var$Tree {
    /**
     * @param name - Optional name of the node.
     * @param parent - Optional parent node.
     * @param node - Optional node to wrap.
     */ constructor(name = '', parent = null, node = {
        children: {},
        childCount: 0
    }){
        this.name = name;
        this.parent = parent;
        this.node = node;
    }
}
/**
 * Returns a sub-Tree for the given path.
 *
 * @param pathObj - Path to look up.
 * @returns Tree for path.
 */ function $9cf0852385f62d16$var$treeSubTree(tree, pathObj) {
    // TODO: Require pathObj to be Path?
    let path = pathObj instanceof $9cf0852385f62d16$var$Path ? pathObj : new $9cf0852385f62d16$var$Path(pathObj);
    let child = tree, next = $9cf0852385f62d16$var$pathGetFront(path);
    while(next !== null){
        const childNode = (0, $3117f6f4eeb4c314$export$e51ae4db7b428f67)(child.node.children, next) || {
            children: {},
            childCount: 0
        };
        child = new $9cf0852385f62d16$var$Tree(next, child, childNode);
        path = $9cf0852385f62d16$var$pathPopFront(path);
        next = $9cf0852385f62d16$var$pathGetFront(path);
    }
    return child;
}
/**
 * Returns the data associated with this tree node.
 *
 * @returns The data or null if no data exists.
 */ function $9cf0852385f62d16$var$treeGetValue(tree) {
    return tree.node.value;
}
/**
 * Sets data to this tree node.
 *
 * @param value - Value to set.
 */ function $9cf0852385f62d16$var$treeSetValue(tree, value) {
    tree.node.value = value;
    $9cf0852385f62d16$var$treeUpdateParents(tree);
}
/**
 * @returns Whether the tree has any children.
 */ function $9cf0852385f62d16$var$treeHasChildren(tree) {
    return tree.node.childCount > 0;
}
/**
 * @returns Whether the tree is empty (no value or children).
 */ function $9cf0852385f62d16$var$treeIsEmpty(tree) {
    return $9cf0852385f62d16$var$treeGetValue(tree) === undefined && !$9cf0852385f62d16$var$treeHasChildren(tree);
}
/**
 * Calls action for each child of this tree node.
 *
 * @param action - Action to be called for each child.
 */ function $9cf0852385f62d16$var$treeForEachChild(tree, action) {
    $9cf0852385f62d16$var$each(tree.node.children, (child, childTree)=>{
        action(new $9cf0852385f62d16$var$Tree(child, tree, childTree));
    });
}
/**
 * Does a depth-first traversal of this node's descendants, calling action for each one.
 *
 * @param action - Action to be called for each child.
 * @param includeSelf - Whether to call action on this node as well. Defaults to
 *   false.
 * @param childrenFirst - Whether to call action on children before calling it on
 *   parent.
 */ function $9cf0852385f62d16$var$treeForEachDescendant(tree, action, includeSelf, childrenFirst) {
    if (includeSelf && !childrenFirst) action(tree);
    $9cf0852385f62d16$var$treeForEachChild(tree, (child)=>{
        $9cf0852385f62d16$var$treeForEachDescendant(child, action, true, childrenFirst);
    });
    if (includeSelf && childrenFirst) action(tree);
}
/**
 * Calls action on each ancestor node.
 *
 * @param action - Action to be called on each parent; return
 *   true to abort.
 * @param includeSelf - Whether to call action on this node as well.
 * @returns true if the action callback returned true.
 */ function $9cf0852385f62d16$var$treeForEachAncestor(tree, action, includeSelf) {
    let node = includeSelf ? tree : tree.parent;
    while(node !== null){
        if (action(node)) return true;
        node = node.parent;
    }
    return false;
}
/**
 * @returns The path of this tree node, as a Path.
 */ function $9cf0852385f62d16$var$treeGetPath(tree) {
    return new $9cf0852385f62d16$var$Path(tree.parent === null ? tree.name : $9cf0852385f62d16$var$treeGetPath(tree.parent) + '/' + tree.name);
}
/**
 * Adds or removes this child from its parent based on whether it's empty or not.
 */ function $9cf0852385f62d16$var$treeUpdateParents(tree) {
    if (tree.parent !== null) $9cf0852385f62d16$var$treeUpdateChild(tree.parent, tree.name, tree);
}
/**
 * Adds or removes the passed child to this tree node, depending on whether it's empty.
 *
 * @param childName - The name of the child to update.
 * @param child - The child to update.
 */ function $9cf0852385f62d16$var$treeUpdateChild(tree, childName, child) {
    const childEmpty = $9cf0852385f62d16$var$treeIsEmpty(child);
    const childExists = (0, $3117f6f4eeb4c314$export$2344b14b097df817)(tree.node.children, childName);
    if (childEmpty && childExists) {
        delete tree.node.children[childName];
        tree.node.childCount--;
        $9cf0852385f62d16$var$treeUpdateParents(tree);
    } else if (!childEmpty && !childExists) {
        tree.node.children[childName] = child.node;
        tree.node.childCount++;
        $9cf0852385f62d16$var$treeUpdateParents(tree);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * True for invalid Firebase keys
 */ const $9cf0852385f62d16$var$INVALID_KEY_REGEX_ = /[\[\].#$\/\u0000-\u001F\u007F]/;
/**
 * True for invalid Firebase paths.
 * Allows '/' in paths.
 */ const $9cf0852385f62d16$var$INVALID_PATH_REGEX_ = /[\[\].#$\u0000-\u001F\u007F]/;
/**
 * Maximum number of characters to allow in leaf value
 */ const $9cf0852385f62d16$var$MAX_LEAF_SIZE_ = 10485760;
const $9cf0852385f62d16$var$isValidKey = function(key) {
    return typeof key === 'string' && key.length !== 0 && !$9cf0852385f62d16$var$INVALID_KEY_REGEX_.test(key);
};
const $9cf0852385f62d16$var$isValidPathString = function(pathString) {
    return typeof pathString === 'string' && pathString.length !== 0 && !$9cf0852385f62d16$var$INVALID_PATH_REGEX_.test(pathString);
};
const $9cf0852385f62d16$var$isValidRootPathString = function(pathString) {
    if (pathString) // Allow '/.info/' at the beginning.
    pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    return $9cf0852385f62d16$var$isValidPathString(pathString);
};
const $9cf0852385f62d16$var$isValidPriority = function(priority) {
    return priority === null || typeof priority === 'string' || typeof priority === 'number' && !$9cf0852385f62d16$var$isInvalidJSONNumber(priority) || priority && typeof priority === 'object' && // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $3117f6f4eeb4c314$export$2344b14b097df817)(priority, '.sv');
};
/**
 * Pre-validate a datum passed as an argument to Firebase function.
 */ const $9cf0852385f62d16$var$validateFirebaseDataArg = function(fnName, value, path, optional) {
    if (optional && value === undefined) return;
    $9cf0852385f62d16$var$validateFirebaseData((0, $3117f6f4eeb4c314$export$adea4917e02d93dc)(fnName, 'value'), value, path);
};
/**
 * Validate a data object client-side before sending to server.
 */ const $9cf0852385f62d16$var$validateFirebaseData = function(errorPrefix, data, path_) {
    const path = path_ instanceof $9cf0852385f62d16$var$Path ? new $9cf0852385f62d16$var$ValidationPath(path_, errorPrefix) : path_;
    if (data === undefined) throw new Error(errorPrefix + 'contains undefined ' + $9cf0852385f62d16$var$validationPathToErrorString(path));
    if (typeof data === 'function') throw new Error(errorPrefix + 'contains a function ' + $9cf0852385f62d16$var$validationPathToErrorString(path) + ' with contents = ' + data.toString());
    if ($9cf0852385f62d16$var$isInvalidJSONNumber(data)) throw new Error(errorPrefix + 'contains ' + data.toString() + ' ' + $9cf0852385f62d16$var$validationPathToErrorString(path));
    // Check max leaf size, but try to avoid the utf8 conversion if we can.
    if (typeof data === 'string' && data.length > $9cf0852385f62d16$var$MAX_LEAF_SIZE_ / 3 && (0, $3117f6f4eeb4c314$export$9536dc0a75b20bf9)(data) > $9cf0852385f62d16$var$MAX_LEAF_SIZE_) throw new Error(errorPrefix + 'contains a string greater than ' + $9cf0852385f62d16$var$MAX_LEAF_SIZE_ + ' utf8 bytes ' + $9cf0852385f62d16$var$validationPathToErrorString(path) + " ('" + data.substring(0, 50) + "...')");
    // TODO = Perf = Consider combining the recursive validation of keys into NodeFromJSON
    // to save extra walking of large objects.
    if (data && typeof data === 'object') {
        let hasDotValue = false;
        let hasActualChild = false;
        $9cf0852385f62d16$var$each(data, (key, value)=>{
            if (key === '.value') hasDotValue = true;
            else if (key !== '.priority' && key !== '.sv') {
                hasActualChild = true;
                if (!$9cf0852385f62d16$var$isValidKey(key)) throw new Error(errorPrefix + ' contains an invalid key (' + key + ') ' + $9cf0852385f62d16$var$validationPathToErrorString(path) + '.  Keys must be non-empty strings ' + 'and can\'t contain ".", "#", "$", "/", "[", or "]"');
            }
            $9cf0852385f62d16$var$validationPathPush(path, key);
            $9cf0852385f62d16$var$validateFirebaseData(errorPrefix, value, path);
            $9cf0852385f62d16$var$validationPathPop(path);
        });
        if (hasDotValue && hasActualChild) throw new Error(errorPrefix + ' contains ".value" child ' + $9cf0852385f62d16$var$validationPathToErrorString(path) + ' in addition to actual children.');
    }
};
/**
 * Pre-validate paths passed in the firebase function.
 */ const $9cf0852385f62d16$var$validateFirebaseMergePaths = function(errorPrefix, mergePaths) {
    let i, curPath;
    for(i = 0; i < mergePaths.length; i++){
        curPath = mergePaths[i];
        const keys = $9cf0852385f62d16$var$pathSlice(curPath);
        for(let j = 0; j < keys.length; j++){
            if (keys[j] === '.priority' && j === keys.length - 1) ;
            else if (!$9cf0852385f62d16$var$isValidKey(keys[j])) throw new Error(errorPrefix + 'contains an invalid key (' + keys[j] + ') in path ' + curPath.toString() + '. Keys must be non-empty strings ' + 'and can\'t contain ".", "#", "$", "/", "[", or "]"');
        }
    }
    // Check that update keys are not descendants of each other.
    // We rely on the property that sorting guarantees that ancestors come
    // right before descendants.
    mergePaths.sort($9cf0852385f62d16$var$pathCompare);
    let prevPath = null;
    for(i = 0; i < mergePaths.length; i++){
        curPath = mergePaths[i];
        if (prevPath !== null && $9cf0852385f62d16$var$pathContains(prevPath, curPath)) throw new Error(errorPrefix + 'contains a path ' + prevPath.toString() + ' that is ancestor of another path ' + curPath.toString());
        prevPath = curPath;
    }
};
/**
 * pre-validate an object passed as an argument to firebase function (
 * must be an object - e.g. for firebase.update()).
 */ const $9cf0852385f62d16$var$validateFirebaseMergeDataArg = function(fnName, data, path, optional) {
    if (optional && data === undefined) return;
    const errorPrefix$1 = (0, $3117f6f4eeb4c314$export$adea4917e02d93dc)(fnName, 'values');
    if (!(data && typeof data === 'object') || Array.isArray(data)) throw new Error(errorPrefix$1 + ' must be an object containing the children to replace.');
    const mergePaths = [];
    $9cf0852385f62d16$var$each(data, (key, value)=>{
        const curPath = new $9cf0852385f62d16$var$Path(key);
        $9cf0852385f62d16$var$validateFirebaseData(errorPrefix$1, value, $9cf0852385f62d16$var$pathChild(path, curPath));
        if ($9cf0852385f62d16$var$pathGetBack(curPath) === '.priority') {
            if (!$9cf0852385f62d16$var$isValidPriority(value)) throw new Error(errorPrefix$1 + "contains an invalid value for '" + curPath.toString() + "', which must be a valid " + 'Firebase priority (a string, finite number, server value, or null).');
        }
        mergePaths.push(curPath);
    });
    $9cf0852385f62d16$var$validateFirebaseMergePaths(errorPrefix$1, mergePaths);
};
const $9cf0852385f62d16$var$validatePriority = function(fnName, priority, optional) {
    if (optional && priority === undefined) return;
    if ($9cf0852385f62d16$var$isInvalidJSONNumber(priority)) throw new Error((0, $3117f6f4eeb4c314$export$adea4917e02d93dc)(fnName, 'priority') + 'is ' + priority.toString() + ', but must be a valid Firebase priority (a string, finite number, ' + 'server value, or null).');
    // Special case to allow importing data with a .sv.
    if (!$9cf0852385f62d16$var$isValidPriority(priority)) throw new Error((0, $3117f6f4eeb4c314$export$adea4917e02d93dc)(fnName, 'priority') + 'must be a valid Firebase priority ' + '(a string, finite number, server value, or null).');
};
const $9cf0852385f62d16$var$validateKey = function(fnName, argumentName, key, optional) {
    if (optional && key === undefined) return;
    if (!$9cf0852385f62d16$var$isValidKey(key)) throw new Error((0, $3117f6f4eeb4c314$export$adea4917e02d93dc)(fnName, argumentName) + 'was an invalid key = "' + key + '".  Firebase keys must be non-empty strings and ' + 'can\'t contain ".", "#", "$", "/", "[", or "]").');
};
/**
 * @internal
 */ const $9cf0852385f62d16$export$8637b026ace8abb1 = function(fnName, argumentName, pathString, optional) {
    if (optional && pathString === undefined) return;
    if (!$9cf0852385f62d16$var$isValidPathString(pathString)) throw new Error((0, $3117f6f4eeb4c314$export$adea4917e02d93dc)(fnName, argumentName) + 'was an invalid path = "' + pathString + '". Paths must be non-empty strings and ' + 'can\'t contain ".", "#", "$", "[", or "]"');
};
const $9cf0852385f62d16$var$validateRootPathString = function(fnName, argumentName, pathString, optional) {
    if (pathString) // Allow '/.info/' at the beginning.
    pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    $9cf0852385f62d16$export$8637b026ace8abb1(fnName, argumentName, pathString, optional);
};
/**
 * @internal
 */ const $9cf0852385f62d16$export$8d83036122ae444e = function(fnName, path) {
    if ($9cf0852385f62d16$var$pathGetFront(path) === '.info') throw new Error(fnName + " failed = Can't modify data under /.info/");
};
const $9cf0852385f62d16$var$validateUrl = function(fnName, parsedUrl) {
    // TODO = Validate server better.
    const pathString = parsedUrl.path.toString();
    if (!(typeof parsedUrl.repoInfo.host === 'string') || parsedUrl.repoInfo.host.length === 0 || !$9cf0852385f62d16$var$isValidKey(parsedUrl.repoInfo.namespace) && parsedUrl.repoInfo.host.split(':')[0] !== 'localhost' || pathString.length !== 0 && !$9cf0852385f62d16$var$isValidRootPathString(pathString)) throw new Error((0, $3117f6f4eeb4c314$export$adea4917e02d93dc)(fnName, 'url') + 'must be a valid firebase URL and ' + 'the path can\'t contain ".", "#", "$", "[", or "]".');
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The event queue serves a few purposes:
 * 1. It ensures we maintain event order in the face of event callbacks doing operations that result in more
 *    events being queued.
 * 2. raiseQueuedEvents() handles being called reentrantly nicely.  That is, if in the course of raising events,
 *    raiseQueuedEvents() is called again, the "inner" call will pick up raising events where the "outer" call
 *    left off, ensuring that the events are still raised synchronously and in order.
 * 3. You can use raiseEventsAtPath and raiseEventsForChangedPath to ensure only relevant previously-queued
 *    events are raised synchronously.
 *
 * NOTE: This can all go away if/when we move to async events.
 *
 */ class $9cf0852385f62d16$var$EventQueue {
    constructor(){
        this.eventLists_ = [];
        /**
         * Tracks recursion depth of raiseQueuedEvents_, for debugging purposes.
         */ this.recursionDepth_ = 0;
    }
}
/**
 * @param eventDataList - The new events to queue.
 */ function $9cf0852385f62d16$var$eventQueueQueueEvents(eventQueue, eventDataList) {
    // We group events by path, storing them in a single EventList, to make it easier to skip over them quickly.
    let currList = null;
    for(let i = 0; i < eventDataList.length; i++){
        const data = eventDataList[i];
        const path = data.getPath();
        if (currList !== null && !$9cf0852385f62d16$var$pathEquals(path, currList.path)) {
            eventQueue.eventLists_.push(currList);
            currList = null;
        }
        if (currList === null) currList = {
            events: [],
            path: path
        };
        currList.events.push(data);
    }
    if (currList) eventQueue.eventLists_.push(currList);
}
/**
 * Queues the specified events and synchronously raises all events (including previously queued ones)
 * for the specified path.
 *
 * It is assumed that the new events are all for the specified path.
 *
 * @param path - The path to raise events for.
 * @param eventDataList - The new events to raise.
 */ function $9cf0852385f62d16$var$eventQueueRaiseEventsAtPath(eventQueue, path, eventDataList) {
    $9cf0852385f62d16$var$eventQueueQueueEvents(eventQueue, eventDataList);
    $9cf0852385f62d16$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, (eventPath)=>$9cf0852385f62d16$var$pathEquals(eventPath, path));
}
/**
 * Queues the specified events and synchronously raises all events (including previously queued ones) for
 * locations related to the specified change path (i.e. all ancestors and descendants).
 *
 * It is assumed that the new events are all related (ancestor or descendant) to the specified path.
 *
 * @param changedPath - The path to raise events for.
 * @param eventDataList - The events to raise
 */ function $9cf0852385f62d16$var$eventQueueRaiseEventsForChangedPath(eventQueue, changedPath, eventDataList) {
    $9cf0852385f62d16$var$eventQueueQueueEvents(eventQueue, eventDataList);
    $9cf0852385f62d16$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, (eventPath)=>$9cf0852385f62d16$var$pathContains(eventPath, changedPath) || $9cf0852385f62d16$var$pathContains(changedPath, eventPath));
}
function $9cf0852385f62d16$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, predicate) {
    eventQueue.recursionDepth_++;
    let sentAll = true;
    for(let i = 0; i < eventQueue.eventLists_.length; i++){
        const eventList = eventQueue.eventLists_[i];
        if (eventList) {
            const eventPath = eventList.path;
            if (predicate(eventPath)) {
                $9cf0852385f62d16$var$eventListRaise(eventQueue.eventLists_[i]);
                eventQueue.eventLists_[i] = null;
            } else sentAll = false;
        }
    }
    if (sentAll) eventQueue.eventLists_ = [];
    eventQueue.recursionDepth_--;
}
/**
 * Iterates through the list and raises each event
 */ function $9cf0852385f62d16$var$eventListRaise(eventList) {
    for(let i = 0; i < eventList.events.length; i++){
        const eventData = eventList.events[i];
        if (eventData !== null) {
            eventList.events[i] = null;
            const eventFn = eventData.getEventRunner();
            if ($9cf0852385f62d16$var$logger) $9cf0852385f62d16$var$log('event: ' + eventData.toString());
            $9cf0852385f62d16$var$exceptionGuard(eventFn);
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9cf0852385f62d16$var$INTERRUPT_REASON = 'repo_interrupt';
/**
 * If a transaction does not succeed after 25 retries, we abort it. Among other
 * things this ensure that if there's ever a bug causing a mismatch between
 * client / server hashes for some data, we won't retry indefinitely.
 */ const $9cf0852385f62d16$var$MAX_TRANSACTION_RETRIES = 25;
/**
 * A connection to a single data repository.
 */ class $9cf0852385f62d16$var$Repo {
    constructor(repoInfo_, forceRestClient_, authTokenProvider_, appCheckProvider_){
        this.repoInfo_ = repoInfo_;
        this.forceRestClient_ = forceRestClient_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckProvider_ = appCheckProvider_;
        this.dataUpdateCount = 0;
        this.statsListener_ = null;
        this.eventQueue_ = new $9cf0852385f62d16$var$EventQueue();
        this.nextWriteId_ = 1;
        this.interceptServerDataCallback_ = null;
        /** A list of data pieces and paths to be set when this client disconnects. */ this.onDisconnect_ = $9cf0852385f62d16$var$newSparseSnapshotTree();
        /** Stores queues of outstanding transactions for Firebase locations. */ this.transactionQueueTree_ = new $9cf0852385f62d16$var$Tree();
        // TODO: This should be @private but it's used by test_access.js and internal.js
        this.persistentConnection_ = null;
        // This key is intentionally not updated if RepoInfo is later changed or replaced
        this.key = this.repoInfo_.toURLString();
    }
    /**
     * @returns The URL corresponding to the root of this Firebase.
     */ toString() {
        return (this.repoInfo_.secure ? 'https://' : 'http://') + this.repoInfo_.host;
    }
}
function $9cf0852385f62d16$var$repoStart(repo, appId, authOverride) {
    repo.stats_ = $9cf0852385f62d16$var$statsManagerGetCollection(repo.repoInfo_);
    if (repo.forceRestClient_ || $9cf0852385f62d16$var$beingCrawled()) {
        repo.server_ = new $9cf0852385f62d16$var$ReadonlyRestClient(repo.repoInfo_, (pathString, data, isMerge, tag)=>{
            $9cf0852385f62d16$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag);
        }, repo.authTokenProvider_, repo.appCheckProvider_);
        // Minor hack: Fire onConnect immediately, since there's no actual connection.
        setTimeout(()=>$9cf0852385f62d16$var$repoOnConnectStatus(repo, /* connectStatus= */ true), 0);
    } else {
        // Validate authOverride
        if (typeof authOverride !== 'undefined' && authOverride !== null) {
            if (typeof authOverride !== 'object') throw new Error('Only objects are supported for option databaseAuthVariableOverride');
            try {
                (0, $3117f6f4eeb4c314$export$fac44ee5b035f737)(authOverride);
            } catch (e) {
                throw new Error('Invalid authOverride provided: ' + e);
            }
        }
        repo.persistentConnection_ = new $9cf0852385f62d16$var$PersistentConnection(repo.repoInfo_, appId, (pathString, data, isMerge, tag)=>{
            $9cf0852385f62d16$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag);
        }, (connectStatus)=>{
            $9cf0852385f62d16$var$repoOnConnectStatus(repo, connectStatus);
        }, (updates)=>{
            $9cf0852385f62d16$var$repoOnServerInfoUpdate(repo, updates);
        }, repo.authTokenProvider_, repo.appCheckProvider_, authOverride);
        repo.server_ = repo.persistentConnection_;
    }
    repo.authTokenProvider_.addTokenChangeListener((token)=>{
        repo.server_.refreshAuthToken(token);
    });
    repo.appCheckProvider_.addTokenChangeListener((result)=>{
        repo.server_.refreshAppCheckToken(result.token);
    });
    // In the case of multiple Repos for the same repoInfo (i.e. there are multiple Firebase.Contexts being used),
    // we only want to create one StatsReporter.  As such, we'll report stats over the first Repo created.
    repo.statsReporter_ = $9cf0852385f62d16$var$statsManagerGetOrCreateReporter(repo.repoInfo_, ()=>new $9cf0852385f62d16$var$StatsReporter(repo.stats_, repo.server_));
    // Used for .info.
    repo.infoData_ = new $9cf0852385f62d16$var$SnapshotHolder();
    repo.infoSyncTree_ = new $9cf0852385f62d16$var$SyncTree({
        startListening: (query, tag, currentHashFn, onComplete)=>{
            let infoEvents = [];
            const node = repo.infoData_.getNode(query._path);
            // This is possibly a hack, but we have different semantics for .info endpoints. We don't raise null events
            // on initial data...
            if (!node.isEmpty()) {
                infoEvents = $9cf0852385f62d16$var$syncTreeApplyServerOverwrite(repo.infoSyncTree_, query._path, node);
                setTimeout(()=>{
                    onComplete('ok');
                }, 0);
            }
            return infoEvents;
        },
        stopListening: ()=>{}
    });
    $9cf0852385f62d16$var$repoUpdateInfo(repo, 'connected', false);
    repo.serverSyncTree_ = new $9cf0852385f62d16$var$SyncTree({
        startListening: (query, tag, currentHashFn, onComplete)=>{
            repo.server_.listen(query, currentHashFn, tag, (status, data)=>{
                const events = onComplete(status, data);
                $9cf0852385f62d16$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, query._path, events);
            });
            // No synchronous events for network-backed sync trees
            return [];
        },
        stopListening: (query, tag)=>{
            repo.server_.unlisten(query, tag);
        }
    });
}
/**
 * @returns The time in milliseconds, taking the server offset into account if we have one.
 */ function $9cf0852385f62d16$var$repoServerTime(repo) {
    const offsetNode = repo.infoData_.getNode(new $9cf0852385f62d16$var$Path('.info/serverTimeOffset'));
    const offset = offsetNode.val() || 0;
    return new Date().getTime() + offset;
}
/**
 * Generate ServerValues using some variables from the repo object.
 */ function $9cf0852385f62d16$var$repoGenerateServerValues(repo) {
    return $9cf0852385f62d16$var$generateWithValues({
        timestamp: $9cf0852385f62d16$var$repoServerTime(repo)
    });
}
/**
 * Called by realtime when we get new messages from the server.
 */ function $9cf0852385f62d16$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag) {
    // For testing.
    repo.dataUpdateCount++;
    const path = new $9cf0852385f62d16$var$Path(pathString);
    data = repo.interceptServerDataCallback_ ? repo.interceptServerDataCallback_(pathString, data) : data;
    let events = [];
    if (tag) {
        if (isMerge) {
            const taggedChildren = (0, $3117f6f4eeb4c314$export$871de8747c9eaa88)(data, (raw)=>$9cf0852385f62d16$var$nodeFromJSON(raw));
            events = $9cf0852385f62d16$var$syncTreeApplyTaggedQueryMerge(repo.serverSyncTree_, path, taggedChildren, tag);
        } else {
            const taggedSnap = $9cf0852385f62d16$var$nodeFromJSON(data);
            events = $9cf0852385f62d16$var$syncTreeApplyTaggedQueryOverwrite(repo.serverSyncTree_, path, taggedSnap, tag);
        }
    } else if (isMerge) {
        const changedChildren = (0, $3117f6f4eeb4c314$export$871de8747c9eaa88)(data, (raw)=>$9cf0852385f62d16$var$nodeFromJSON(raw));
        events = $9cf0852385f62d16$var$syncTreeApplyServerMerge(repo.serverSyncTree_, path, changedChildren);
    } else {
        const snap = $9cf0852385f62d16$var$nodeFromJSON(data);
        events = $9cf0852385f62d16$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, path, snap);
    }
    let affectedPath = path;
    if (events.length > 0) // Since we have a listener outstanding for each transaction, receiving any events
    // is a proxy for some change having occurred.
    affectedPath = $9cf0852385f62d16$var$repoRerunTransactions(repo, path);
    $9cf0852385f62d16$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, events);
}
function $9cf0852385f62d16$var$repoOnConnectStatus(repo, connectStatus) {
    $9cf0852385f62d16$var$repoUpdateInfo(repo, 'connected', connectStatus);
    if (connectStatus === false) $9cf0852385f62d16$var$repoRunOnDisconnectEvents(repo);
}
function $9cf0852385f62d16$var$repoOnServerInfoUpdate(repo, updates) {
    $9cf0852385f62d16$var$each(updates, (key, value)=>{
        $9cf0852385f62d16$var$repoUpdateInfo(repo, key, value);
    });
}
function $9cf0852385f62d16$var$repoUpdateInfo(repo, pathString, value) {
    const path = new $9cf0852385f62d16$var$Path('/.info/' + pathString);
    const newNode = $9cf0852385f62d16$var$nodeFromJSON(value);
    repo.infoData_.updateSnapshot(path, newNode);
    const events = $9cf0852385f62d16$var$syncTreeApplyServerOverwrite(repo.infoSyncTree_, path, newNode);
    $9cf0852385f62d16$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
}
function $9cf0852385f62d16$var$repoGetNextWriteId(repo) {
    return repo.nextWriteId_++;
}
/**
 * The purpose of `getValue` is to return the latest known value
 * satisfying `query`.
 *
 * This method will first check for in-memory cached values
 * belonging to active listeners. If they are found, such values
 * are considered to be the most up-to-date.
 *
 * If the client is not connected, this method will wait until the
 *  repo has established a connection and then request the value for `query`.
 * If the client is not able to retrieve the query result for another reason,
 * it reports an error.
 *
 * @param query - The query to surface a value for.
 */ function $9cf0852385f62d16$var$repoGetValue(repo, query, eventRegistration) {
    // Only active queries are cached. There is no persisted cache.
    const cached = $9cf0852385f62d16$var$syncTreeGetServerValue(repo.serverSyncTree_, query);
    if (cached != null) return Promise.resolve(cached);
    return repo.server_.get(query).then((payload)=>{
        const node = $9cf0852385f62d16$var$nodeFromJSON(payload).withIndex(query._queryParams.getIndex());
        /**
         * Below we simulate the actions of an `onlyOnce` `onValue()` event where:
         * Add an event registration,
         * Update data at the path,
         * Raise any events,
         * Cleanup the SyncTree
         */ $9cf0852385f62d16$var$syncTreeAddEventRegistration(repo.serverSyncTree_, query, eventRegistration, true);
        let events;
        if (query._queryParams.loadsAllData()) events = $9cf0852385f62d16$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, query._path, node);
        else {
            const tag = $9cf0852385f62d16$var$syncTreeTagForQuery(repo.serverSyncTree_, query);
            events = $9cf0852385f62d16$var$syncTreeApplyTaggedQueryOverwrite(repo.serverSyncTree_, query._path, node, tag);
        }
        /*
         * We need to raise events in the scenario where `get()` is called at a parent path, and
         * while the `get()` is pending, `onValue` is called at a child location. While get() is waiting
         * for the data, `onValue` will register a new event. Then, get() will come back, and update the syncTree
         * and its corresponding serverCache, including the child location where `onValue` is called. Then,
         * `onValue` will receive the event from the server, but look at the syncTree and see that the data received
         * from the server is already at the SyncPoint, and so the `onValue` callback will never get fired.
         * Calling `eventQueueRaiseEventsForChangedPath()` is the correct way to propagate the events and
         * ensure the corresponding child events will get fired.
         */ $9cf0852385f62d16$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, query._path, events);
        $9cf0852385f62d16$var$syncTreeRemoveEventRegistration(repo.serverSyncTree_, query, eventRegistration, null, true);
        return node;
    }, (err)=>{
        $9cf0852385f62d16$var$repoLog(repo, 'get for query ' + (0, $3117f6f4eeb4c314$export$fac44ee5b035f737)(query) + ' failed: ' + err);
        return Promise.reject(new Error(err));
    });
}
function $9cf0852385f62d16$var$repoSetWithPriority(repo, path, newVal, newPriority, onComplete) {
    $9cf0852385f62d16$var$repoLog(repo, 'set', {
        path: path.toString(),
        value: newVal,
        priority: newPriority
    });
    // TODO: Optimize this behavior to either (a) store flag to skip resolving where possible and / or
    // (b) store unresolved paths on JSON parse
    const serverValues = $9cf0852385f62d16$var$repoGenerateServerValues(repo);
    const newNodeUnresolved = $9cf0852385f62d16$var$nodeFromJSON(newVal, newPriority);
    const existing = $9cf0852385f62d16$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path);
    const newNode = $9cf0852385f62d16$var$resolveDeferredValueSnapshot(newNodeUnresolved, existing, serverValues);
    const writeId = $9cf0852385f62d16$var$repoGetNextWriteId(repo);
    const events = $9cf0852385f62d16$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, path, newNode, writeId, true);
    $9cf0852385f62d16$var$eventQueueQueueEvents(repo.eventQueue_, events);
    repo.server_.put(path.toString(), newNodeUnresolved.val(/*export=*/ true), (status, errorReason)=>{
        const success = status === 'ok';
        if (!success) $9cf0852385f62d16$var$warn('set at ' + path + ' failed: ' + status);
        const clearEvents = $9cf0852385f62d16$var$syncTreeAckUserWrite(repo.serverSyncTree_, writeId, !success);
        $9cf0852385f62d16$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, clearEvents);
        $9cf0852385f62d16$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
    const affectedPath = $9cf0852385f62d16$var$repoAbortTransactions(repo, path);
    $9cf0852385f62d16$var$repoRerunTransactions(repo, affectedPath);
    // We queued the events above, so just flush the queue here
    $9cf0852385f62d16$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, []);
}
function $9cf0852385f62d16$var$repoUpdate(repo, path, childrenToMerge, onComplete) {
    $9cf0852385f62d16$var$repoLog(repo, 'update', {
        path: path.toString(),
        value: childrenToMerge
    });
    // Start with our existing data and merge each child into it.
    let empty = true;
    const serverValues = $9cf0852385f62d16$var$repoGenerateServerValues(repo);
    const changedChildren = {};
    $9cf0852385f62d16$var$each(childrenToMerge, (changedKey, changedValue)=>{
        empty = false;
        changedChildren[changedKey] = $9cf0852385f62d16$var$resolveDeferredValueTree($9cf0852385f62d16$var$pathChild(path, changedKey), $9cf0852385f62d16$var$nodeFromJSON(changedValue), repo.serverSyncTree_, serverValues);
    });
    if (!empty) {
        const writeId = $9cf0852385f62d16$var$repoGetNextWriteId(repo);
        const events = $9cf0852385f62d16$var$syncTreeApplyUserMerge(repo.serverSyncTree_, path, changedChildren, writeId);
        $9cf0852385f62d16$var$eventQueueQueueEvents(repo.eventQueue_, events);
        repo.server_.merge(path.toString(), childrenToMerge, (status, errorReason)=>{
            const success = status === 'ok';
            if (!success) $9cf0852385f62d16$var$warn('update at ' + path + ' failed: ' + status);
            const clearEvents = $9cf0852385f62d16$var$syncTreeAckUserWrite(repo.serverSyncTree_, writeId, !success);
            const affectedPath = clearEvents.length > 0 ? $9cf0852385f62d16$var$repoRerunTransactions(repo, path) : path;
            $9cf0852385f62d16$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, clearEvents);
            $9cf0852385f62d16$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
        });
        $9cf0852385f62d16$var$each(childrenToMerge, (changedPath)=>{
            const affectedPath = $9cf0852385f62d16$var$repoAbortTransactions(repo, $9cf0852385f62d16$var$pathChild(path, changedPath));
            $9cf0852385f62d16$var$repoRerunTransactions(repo, affectedPath);
        });
        // We queued the events above, so just flush the queue here
        $9cf0852385f62d16$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, []);
    } else {
        $9cf0852385f62d16$var$log("update() called with empty data.  Don't do anything.");
        $9cf0852385f62d16$var$repoCallOnCompleteCallback(repo, onComplete, 'ok', undefined);
    }
}
/**
 * Applies all of the changes stored up in the onDisconnect_ tree.
 */ function $9cf0852385f62d16$var$repoRunOnDisconnectEvents(repo) {
    $9cf0852385f62d16$var$repoLog(repo, 'onDisconnectEvents');
    const serverValues = $9cf0852385f62d16$var$repoGenerateServerValues(repo);
    const resolvedOnDisconnectTree = $9cf0852385f62d16$var$newSparseSnapshotTree();
    $9cf0852385f62d16$var$sparseSnapshotTreeForEachTree(repo.onDisconnect_, $9cf0852385f62d16$var$newEmptyPath(), (path, node)=>{
        const resolved = $9cf0852385f62d16$var$resolveDeferredValueTree(path, node, repo.serverSyncTree_, serverValues);
        $9cf0852385f62d16$var$sparseSnapshotTreeRemember(resolvedOnDisconnectTree, path, resolved);
    });
    let events = [];
    $9cf0852385f62d16$var$sparseSnapshotTreeForEachTree(resolvedOnDisconnectTree, $9cf0852385f62d16$var$newEmptyPath(), (path, snap)=>{
        events = events.concat($9cf0852385f62d16$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, path, snap));
        const affectedPath = $9cf0852385f62d16$var$repoAbortTransactions(repo, path);
        $9cf0852385f62d16$var$repoRerunTransactions(repo, affectedPath);
    });
    repo.onDisconnect_ = $9cf0852385f62d16$var$newSparseSnapshotTree();
    $9cf0852385f62d16$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, $9cf0852385f62d16$var$newEmptyPath(), events);
}
function $9cf0852385f62d16$var$repoOnDisconnectCancel(repo, path, onComplete) {
    repo.server_.onDisconnectCancel(path.toString(), (status, errorReason)=>{
        if (status === 'ok') $9cf0852385f62d16$var$sparseSnapshotTreeForget(repo.onDisconnect_, path);
        $9cf0852385f62d16$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $9cf0852385f62d16$var$repoOnDisconnectSet(repo, path, value, onComplete) {
    const newNode = $9cf0852385f62d16$var$nodeFromJSON(value);
    repo.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), (status, errorReason)=>{
        if (status === 'ok') $9cf0852385f62d16$var$sparseSnapshotTreeRemember(repo.onDisconnect_, path, newNode);
        $9cf0852385f62d16$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $9cf0852385f62d16$var$repoOnDisconnectSetWithPriority(repo, path, value, priority, onComplete) {
    const newNode = $9cf0852385f62d16$var$nodeFromJSON(value, priority);
    repo.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), (status, errorReason)=>{
        if (status === 'ok') $9cf0852385f62d16$var$sparseSnapshotTreeRemember(repo.onDisconnect_, path, newNode);
        $9cf0852385f62d16$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $9cf0852385f62d16$var$repoOnDisconnectUpdate(repo, path, childrenToMerge, onComplete) {
    if ((0, $3117f6f4eeb4c314$export$dd1bc94b04021eeb)(childrenToMerge)) {
        $9cf0852385f62d16$var$log("onDisconnect().update() called with empty data.  Don't do anything.");
        $9cf0852385f62d16$var$repoCallOnCompleteCallback(repo, onComplete, 'ok', undefined);
        return;
    }
    repo.server_.onDisconnectMerge(path.toString(), childrenToMerge, (status, errorReason)=>{
        if (status === 'ok') $9cf0852385f62d16$var$each(childrenToMerge, (childName, childNode)=>{
            const newChildNode = $9cf0852385f62d16$var$nodeFromJSON(childNode);
            $9cf0852385f62d16$var$sparseSnapshotTreeRemember(repo.onDisconnect_, $9cf0852385f62d16$var$pathChild(path, childName), newChildNode);
        });
        $9cf0852385f62d16$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $9cf0852385f62d16$var$repoAddEventCallbackForQuery(repo, query, eventRegistration) {
    let events;
    if ($9cf0852385f62d16$var$pathGetFront(query._path) === '.info') events = $9cf0852385f62d16$var$syncTreeAddEventRegistration(repo.infoSyncTree_, query, eventRegistration);
    else events = $9cf0852385f62d16$var$syncTreeAddEventRegistration(repo.serverSyncTree_, query, eventRegistration);
    $9cf0852385f62d16$var$eventQueueRaiseEventsAtPath(repo.eventQueue_, query._path, events);
}
function $9cf0852385f62d16$var$repoRemoveEventCallbackForQuery(repo, query, eventRegistration) {
    // These are guaranteed not to raise events, since we're not passing in a cancelError. However, we can future-proof
    // a little bit by handling the return values anyways.
    let events;
    if ($9cf0852385f62d16$var$pathGetFront(query._path) === '.info') events = $9cf0852385f62d16$var$syncTreeRemoveEventRegistration(repo.infoSyncTree_, query, eventRegistration);
    else events = $9cf0852385f62d16$var$syncTreeRemoveEventRegistration(repo.serverSyncTree_, query, eventRegistration);
    $9cf0852385f62d16$var$eventQueueRaiseEventsAtPath(repo.eventQueue_, query._path, events);
}
function $9cf0852385f62d16$var$repoInterrupt(repo) {
    if (repo.persistentConnection_) repo.persistentConnection_.interrupt($9cf0852385f62d16$var$INTERRUPT_REASON);
}
function $9cf0852385f62d16$var$repoResume(repo) {
    if (repo.persistentConnection_) repo.persistentConnection_.resume($9cf0852385f62d16$var$INTERRUPT_REASON);
}
function $9cf0852385f62d16$var$repoLog(repo, ...varArgs) {
    let prefix = '';
    if (repo.persistentConnection_) prefix = repo.persistentConnection_.id + ':';
    $9cf0852385f62d16$var$log(prefix, ...varArgs);
}
function $9cf0852385f62d16$var$repoCallOnCompleteCallback(repo, callback, status, errorReason) {
    if (callback) $9cf0852385f62d16$var$exceptionGuard(()=>{
        if (status === 'ok') callback(null);
        else {
            const code = (status || 'error').toUpperCase();
            let message = code;
            if (errorReason) message += ': ' + errorReason;
            const error = new Error(message);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            error.code = code;
            callback(error);
        }
    });
}
/**
 * Creates a new transaction, adds it to the transactions we're tracking, and
 * sends it to the server if possible.
 *
 * @param path - Path at which to do transaction.
 * @param transactionUpdate - Update callback.
 * @param onComplete - Completion callback.
 * @param unwatcher - Function that will be called when the transaction no longer
 * need data updates for `path`.
 * @param applyLocally - Whether or not to make intermediate results visible
 */ function $9cf0852385f62d16$var$repoStartTransaction(repo, path, transactionUpdate, onComplete, unwatcher, applyLocally) {
    $9cf0852385f62d16$var$repoLog(repo, 'transaction on ' + path);
    // Initialize transaction.
    const transaction = {
        path: path,
        update: transactionUpdate,
        onComplete: onComplete,
        // One of TransactionStatus enums.
        status: null,
        // Used when combining transactions at different locations to figure out
        // which one goes first.
        order: $9cf0852385f62d16$var$LUIDGenerator(),
        applyLocally: // Whether to raise local events for this transaction.
        applyLocally,
        // Count of how many times we've retried the transaction.
        retryCount: 0,
        unwatcher: // Function to call to clean up our .on() listener.
        unwatcher,
        // Stores why a transaction was aborted.
        abortReason: null,
        currentWriteId: null,
        currentInputSnapshot: null,
        currentOutputSnapshotRaw: null,
        currentOutputSnapshotResolved: null
    };
    // Run transaction initially.
    const currentState = $9cf0852385f62d16$var$repoGetLatestState(repo, path, undefined);
    transaction.currentInputSnapshot = currentState;
    const newVal = transaction.update(currentState.val());
    if (newVal === undefined) {
        // Abort transaction.
        transaction.unwatcher();
        transaction.currentOutputSnapshotRaw = null;
        transaction.currentOutputSnapshotResolved = null;
        if (transaction.onComplete) transaction.onComplete(null, false, transaction.currentInputSnapshot);
    } else {
        $9cf0852385f62d16$var$validateFirebaseData('transaction failed: Data returned ', newVal, transaction.path);
        // Mark as run and add to our queue.
        transaction.status = 0 /* TransactionStatus.RUN */ ;
        const queueNode = $9cf0852385f62d16$var$treeSubTree(repo.transactionQueueTree_, path);
        const nodeQueue = $9cf0852385f62d16$var$treeGetValue(queueNode) || [];
        nodeQueue.push(transaction);
        $9cf0852385f62d16$var$treeSetValue(queueNode, nodeQueue);
        // Update visibleData and raise events
        // Note: We intentionally raise events after updating all of our
        // transaction state, since the user could start new transactions from the
        // event callbacks.
        let priorityForNode;
        if (typeof newVal === 'object' && newVal !== null && (0, $3117f6f4eeb4c314$export$2344b14b097df817)(newVal, '.priority')) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            priorityForNode = (0, $3117f6f4eeb4c314$export$e51ae4db7b428f67)(newVal, '.priority');
            (0, $3117f6f4eeb4c314$export$a7a9523472993e97)($9cf0852385f62d16$var$isValidPriority(priorityForNode), "Invalid priority returned by transaction. Priority must be a valid string, finite number, server value, or null.");
        } else {
            const currentNode = $9cf0852385f62d16$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path) || $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE;
            priorityForNode = currentNode.getPriority().val();
        }
        const serverValues = $9cf0852385f62d16$var$repoGenerateServerValues(repo);
        const newNodeUnresolved = $9cf0852385f62d16$var$nodeFromJSON(newVal, priorityForNode);
        const newNode = $9cf0852385f62d16$var$resolveDeferredValueSnapshot(newNodeUnresolved, currentState, serverValues);
        transaction.currentOutputSnapshotRaw = newNodeUnresolved;
        transaction.currentOutputSnapshotResolved = newNode;
        transaction.currentWriteId = $9cf0852385f62d16$var$repoGetNextWriteId(repo);
        const events = $9cf0852385f62d16$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, path, newNode, transaction.currentWriteId, transaction.applyLocally);
        $9cf0852385f62d16$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
        $9cf0852385f62d16$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
    }
}
/**
 * @param excludeSets - A specific set to exclude
 */ function $9cf0852385f62d16$var$repoGetLatestState(repo, path, excludeSets) {
    return $9cf0852385f62d16$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path, excludeSets) || $9cf0852385f62d16$var$ChildrenNode.EMPTY_NODE;
}
/**
 * Sends any already-run transactions that aren't waiting for outstanding
 * transactions to complete.
 *
 * Externally it's called with no arguments, but it calls itself recursively
 * with a particular transactionQueueTree node to recurse through the tree.
 *
 * @param node - transactionQueueTree node to start at.
 */ function $9cf0852385f62d16$var$repoSendReadyTransactions(repo, node = repo.transactionQueueTree_) {
    // Before recursing, make sure any completed transactions are removed.
    if (!node) $9cf0852385f62d16$var$repoPruneCompletedTransactionsBelowNode(repo, node);
    if ($9cf0852385f62d16$var$treeGetValue(node)) {
        const queue = $9cf0852385f62d16$var$repoBuildTransactionQueue(repo, node);
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(queue.length > 0, 'Sending zero length transaction queue');
        const allRun = queue.every((transaction)=>transaction.status === 0 /* TransactionStatus.RUN */ );
        // If they're all run (and not sent), we can send them.  Else, we must wait.
        if (allRun) $9cf0852385f62d16$var$repoSendTransactionQueue(repo, $9cf0852385f62d16$var$treeGetPath(node), queue);
    } else if ($9cf0852385f62d16$var$treeHasChildren(node)) $9cf0852385f62d16$var$treeForEachChild(node, (childNode)=>{
        $9cf0852385f62d16$var$repoSendReadyTransactions(repo, childNode);
    });
}
/**
 * Given a list of run transactions, send them to the server and then handle
 * the result (success or failure).
 *
 * @param path - The location of the queue.
 * @param queue - Queue of transactions under the specified location.
 */ function $9cf0852385f62d16$var$repoSendTransactionQueue(repo, path, queue) {
    // Mark transactions as sent and increment retry count!
    const setsToIgnore = queue.map((txn)=>{
        return txn.currentWriteId;
    });
    const latestState = $9cf0852385f62d16$var$repoGetLatestState(repo, path, setsToIgnore);
    let snapToSend = latestState;
    const latestHash = latestState.hash();
    for(let i = 0; i < queue.length; i++){
        const txn = queue[i];
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(txn.status === 0 /* TransactionStatus.RUN */ , 'tryToSendTransactionQueue_: items in queue should all be run.');
        txn.status = 1 /* TransactionStatus.SENT */ ;
        txn.retryCount++;
        const relativePath = $9cf0852385f62d16$var$newRelativePath(path, txn.path);
        // If we've gotten to this point, the output snapshot must be defined.
        snapToSend = snapToSend.updateChild(relativePath /** @type {!Node} */ , txn.currentOutputSnapshotRaw);
    }
    const dataToSend = snapToSend.val(true);
    const pathToSend = path;
    // Send the put.
    repo.server_.put(pathToSend.toString(), dataToSend, (status)=>{
        $9cf0852385f62d16$var$repoLog(repo, 'transaction put response', {
            path: pathToSend.toString(),
            status: status
        });
        let events = [];
        if (status === 'ok') {
            // Queue up the callbacks and fire them after cleaning up all of our
            // transaction state, since the callback could trigger more
            // transactions or sets.
            const callbacks = [];
            for(let i = 0; i < queue.length; i++){
                queue[i].status = 2 /* TransactionStatus.COMPLETED */ ;
                events = events.concat($9cf0852385f62d16$var$syncTreeAckUserWrite(repo.serverSyncTree_, queue[i].currentWriteId));
                if (queue[i].onComplete) // We never unset the output snapshot, and given that this
                // transaction is complete, it should be set
                callbacks.push(()=>queue[i].onComplete(null, true, queue[i].currentOutputSnapshotResolved));
                queue[i].unwatcher();
            }
            // Now remove the completed transactions.
            $9cf0852385f62d16$var$repoPruneCompletedTransactionsBelowNode(repo, $9cf0852385f62d16$var$treeSubTree(repo.transactionQueueTree_, path));
            // There may be pending transactions that we can now send.
            $9cf0852385f62d16$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
            $9cf0852385f62d16$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
            // Finally, trigger onComplete callbacks.
            for(let i = 0; i < callbacks.length; i++)$9cf0852385f62d16$var$exceptionGuard(callbacks[i]);
        } else {
            // transactions are no longer sent.  Update their status appropriately.
            if (status === 'datastale') {
                for(let i = 0; i < queue.length; i++)if (queue[i].status === 3 /* TransactionStatus.SENT_NEEDS_ABORT */ ) queue[i].status = 4 /* TransactionStatus.NEEDS_ABORT */ ;
                else queue[i].status = 0 /* TransactionStatus.RUN */ ;
            } else {
                $9cf0852385f62d16$var$warn('transaction at ' + pathToSend.toString() + ' failed: ' + status);
                for(let i = 0; i < queue.length; i++){
                    queue[i].status = 4 /* TransactionStatus.NEEDS_ABORT */ ;
                    queue[i].abortReason = status;
                }
            }
            $9cf0852385f62d16$var$repoRerunTransactions(repo, path);
        }
    }, latestHash);
}
/**
 * Finds all transactions dependent on the data at changedPath and reruns them.
 *
 * Should be called any time cached data changes.
 *
 * Return the highest path that was affected by rerunning transactions. This
 * is the path at which events need to be raised for.
 *
 * @param changedPath - The path in mergedData that changed.
 * @returns The rootmost path that was affected by rerunning transactions.
 */ function $9cf0852385f62d16$var$repoRerunTransactions(repo, changedPath) {
    const rootMostTransactionNode = $9cf0852385f62d16$var$repoGetAncestorTransactionNode(repo, changedPath);
    const path = $9cf0852385f62d16$var$treeGetPath(rootMostTransactionNode);
    const queue = $9cf0852385f62d16$var$repoBuildTransactionQueue(repo, rootMostTransactionNode);
    $9cf0852385f62d16$var$repoRerunTransactionQueue(repo, queue, path);
    return path;
}
/**
 * Does all the work of rerunning transactions (as well as cleans up aborted
 * transactions and whatnot).
 *
 * @param queue - The queue of transactions to run.
 * @param path - The path the queue is for.
 */ function $9cf0852385f62d16$var$repoRerunTransactionQueue(repo, queue, path) {
    if (queue.length === 0) return; // Nothing to do!
    // Queue up the callbacks and fire them after cleaning up all of our
    // transaction state, since the callback could trigger more transactions or
    // sets.
    const callbacks = [];
    let events = [];
    // Ignore all of the sets we're going to re-run.
    const txnsToRerun = queue.filter((q)=>{
        return q.status === 0 /* TransactionStatus.RUN */ ;
    });
    const setsToIgnore = txnsToRerun.map((q)=>{
        return q.currentWriteId;
    });
    for(let i = 0; i < queue.length; i++){
        const transaction = queue[i];
        const relativePath = $9cf0852385f62d16$var$newRelativePath(path, transaction.path);
        let abortTransaction = false, abortReason;
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(relativePath !== null, 'rerunTransactionsUnderNode_: relativePath should not be null.');
        if (transaction.status === 4 /* TransactionStatus.NEEDS_ABORT */ ) {
            abortTransaction = true;
            abortReason = transaction.abortReason;
            events = events.concat($9cf0852385f62d16$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
        } else if (transaction.status === 0 /* TransactionStatus.RUN */ ) {
            if (transaction.retryCount >= $9cf0852385f62d16$var$MAX_TRANSACTION_RETRIES) {
                abortTransaction = true;
                abortReason = 'maxretry';
                events = events.concat($9cf0852385f62d16$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
            } else {
                // This code reruns a transaction
                const currentNode = $9cf0852385f62d16$var$repoGetLatestState(repo, transaction.path, setsToIgnore);
                transaction.currentInputSnapshot = currentNode;
                const newData = queue[i].update(currentNode.val());
                if (newData !== undefined) {
                    $9cf0852385f62d16$var$validateFirebaseData('transaction failed: Data returned ', newData, transaction.path);
                    let newDataNode = $9cf0852385f62d16$var$nodeFromJSON(newData);
                    const hasExplicitPriority = typeof newData === 'object' && newData != null && (0, $3117f6f4eeb4c314$export$2344b14b097df817)(newData, '.priority');
                    if (!hasExplicitPriority) // Keep the old priority if there wasn't a priority explicitly specified.
                    newDataNode = newDataNode.updatePriority(currentNode.getPriority());
                    const oldWriteId = transaction.currentWriteId;
                    const serverValues = $9cf0852385f62d16$var$repoGenerateServerValues(repo);
                    const newNodeResolved = $9cf0852385f62d16$var$resolveDeferredValueSnapshot(newDataNode, currentNode, serverValues);
                    transaction.currentOutputSnapshotRaw = newDataNode;
                    transaction.currentOutputSnapshotResolved = newNodeResolved;
                    transaction.currentWriteId = $9cf0852385f62d16$var$repoGetNextWriteId(repo);
                    // Mutates setsToIgnore in place
                    setsToIgnore.splice(setsToIgnore.indexOf(oldWriteId), 1);
                    events = events.concat($9cf0852385f62d16$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, transaction.path, newNodeResolved, transaction.currentWriteId, transaction.applyLocally));
                    events = events.concat($9cf0852385f62d16$var$syncTreeAckUserWrite(repo.serverSyncTree_, oldWriteId, true));
                } else {
                    abortTransaction = true;
                    abortReason = 'nodata';
                    events = events.concat($9cf0852385f62d16$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
                }
            }
        }
        $9cf0852385f62d16$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
        events = [];
        if (abortTransaction) {
            // Abort.
            queue[i].status = 2 /* TransactionStatus.COMPLETED */ ;
            // Removing a listener can trigger pruning which can muck with
            // mergedData/visibleData (as it prunes data). So defer the unwatcher
            // until we're done.
            (function(unwatcher) {
                setTimeout(unwatcher, Math.floor(0));
            })(queue[i].unwatcher);
            if (queue[i].onComplete) {
                if (abortReason === 'nodata') callbacks.push(()=>queue[i].onComplete(null, false, queue[i].currentInputSnapshot));
                else callbacks.push(()=>queue[i].onComplete(new Error(abortReason), false, null));
            }
        }
    }
    // Clean up completed transactions.
    $9cf0852385f62d16$var$repoPruneCompletedTransactionsBelowNode(repo, repo.transactionQueueTree_);
    // Now fire callbacks, now that we're in a good, known state.
    for(let i = 0; i < callbacks.length; i++)$9cf0852385f62d16$var$exceptionGuard(callbacks[i]);
    // Try to send the transaction result to the server.
    $9cf0852385f62d16$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
}
/**
 * Returns the rootmost ancestor node of the specified path that has a pending
 * transaction on it, or just returns the node for the given path if there are
 * no pending transactions on any ancestor.
 *
 * @param path - The location to start at.
 * @returns The rootmost node with a transaction.
 */ function $9cf0852385f62d16$var$repoGetAncestorTransactionNode(repo, path) {
    let front;
    // Start at the root and walk deeper into the tree towards path until we
    // find a node with pending transactions.
    let transactionNode = repo.transactionQueueTree_;
    front = $9cf0852385f62d16$var$pathGetFront(path);
    while(front !== null && $9cf0852385f62d16$var$treeGetValue(transactionNode) === undefined){
        transactionNode = $9cf0852385f62d16$var$treeSubTree(transactionNode, front);
        path = $9cf0852385f62d16$var$pathPopFront(path);
        front = $9cf0852385f62d16$var$pathGetFront(path);
    }
    return transactionNode;
}
/**
 * Builds the queue of all transactions at or below the specified
 * transactionNode.
 *
 * @param transactionNode
 * @returns The generated queue.
 */ function $9cf0852385f62d16$var$repoBuildTransactionQueue(repo, transactionNode) {
    // Walk any child transaction queues and aggregate them into a single queue.
    const transactionQueue = [];
    $9cf0852385f62d16$var$repoAggregateTransactionQueuesForNode(repo, transactionNode, transactionQueue);
    // Sort them by the order the transactions were created.
    transactionQueue.sort((a, b)=>a.order - b.order);
    return transactionQueue;
}
function $9cf0852385f62d16$var$repoAggregateTransactionQueuesForNode(repo, node, queue) {
    const nodeQueue = $9cf0852385f62d16$var$treeGetValue(node);
    if (nodeQueue) for(let i = 0; i < nodeQueue.length; i++)queue.push(nodeQueue[i]);
    $9cf0852385f62d16$var$treeForEachChild(node, (child)=>{
        $9cf0852385f62d16$var$repoAggregateTransactionQueuesForNode(repo, child, queue);
    });
}
/**
 * Remove COMPLETED transactions at or below this node in the transactionQueueTree_.
 */ function $9cf0852385f62d16$var$repoPruneCompletedTransactionsBelowNode(repo, node) {
    const queue = $9cf0852385f62d16$var$treeGetValue(node);
    if (queue) {
        let to = 0;
        for(let from = 0; from < queue.length; from++)if (queue[from].status !== 2 /* TransactionStatus.COMPLETED */ ) {
            queue[to] = queue[from];
            to++;
        }
        queue.length = to;
        $9cf0852385f62d16$var$treeSetValue(node, queue.length > 0 ? queue : undefined);
    }
    $9cf0852385f62d16$var$treeForEachChild(node, (childNode)=>{
        $9cf0852385f62d16$var$repoPruneCompletedTransactionsBelowNode(repo, childNode);
    });
}
/**
 * Aborts all transactions on ancestors or descendants of the specified path.
 * Called when doing a set() or update() since we consider them incompatible
 * with transactions.
 *
 * @param path - Path for which we want to abort related transactions.
 */ function $9cf0852385f62d16$var$repoAbortTransactions(repo, path) {
    const affectedPath = $9cf0852385f62d16$var$treeGetPath($9cf0852385f62d16$var$repoGetAncestorTransactionNode(repo, path));
    const transactionNode = $9cf0852385f62d16$var$treeSubTree(repo.transactionQueueTree_, path);
    $9cf0852385f62d16$var$treeForEachAncestor(transactionNode, (node)=>{
        $9cf0852385f62d16$var$repoAbortTransactionsOnNode(repo, node);
    });
    $9cf0852385f62d16$var$repoAbortTransactionsOnNode(repo, transactionNode);
    $9cf0852385f62d16$var$treeForEachDescendant(transactionNode, (node)=>{
        $9cf0852385f62d16$var$repoAbortTransactionsOnNode(repo, node);
    });
    return affectedPath;
}
/**
 * Abort transactions stored in this transaction queue node.
 *
 * @param node - Node to abort transactions for.
 */ function $9cf0852385f62d16$var$repoAbortTransactionsOnNode(repo, node) {
    const queue = $9cf0852385f62d16$var$treeGetValue(node);
    if (queue) {
        // Queue up the callbacks and fire them after cleaning up all of our
        // transaction state, since the callback could trigger more transactions
        // or sets.
        const callbacks = [];
        // Go through queue.  Any already-sent transactions must be marked for
        // abort, while the unsent ones can be immediately aborted and removed.
        let events = [];
        let lastSent = -1;
        for(let i = 0; i < queue.length; i++){
            if (queue[i].status === 3 /* TransactionStatus.SENT_NEEDS_ABORT */ ) ;
            else if (queue[i].status === 1 /* TransactionStatus.SENT */ ) {
                (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(lastSent === i - 1, 'All SENT items should be at beginning of queue.');
                lastSent = i;
                // Mark transaction for abort when it comes back.
                queue[i].status = 3 /* TransactionStatus.SENT_NEEDS_ABORT */ ;
                queue[i].abortReason = 'set';
            } else {
                (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(queue[i].status === 0 /* TransactionStatus.RUN */ , 'Unexpected transaction status in abort');
                // We can abort it immediately.
                queue[i].unwatcher();
                events = events.concat($9cf0852385f62d16$var$syncTreeAckUserWrite(repo.serverSyncTree_, queue[i].currentWriteId, true));
                if (queue[i].onComplete) callbacks.push(queue[i].onComplete.bind(null, new Error('set'), false, null));
            }
        }
        if (lastSent === -1) // We're not waiting for any sent transactions.  We can clear the queue.
        $9cf0852385f62d16$var$treeSetValue(node, undefined);
        else // Remove the transactions we aborted.
        queue.length = lastSent + 1;
        // Now fire the callbacks.
        $9cf0852385f62d16$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, $9cf0852385f62d16$var$treeGetPath(node), events);
        for(let i = 0; i < callbacks.length; i++)$9cf0852385f62d16$var$exceptionGuard(callbacks[i]);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9cf0852385f62d16$var$decodePath(pathString) {
    let pathStringDecoded = '';
    const pieces = pathString.split('/');
    for(let i = 0; i < pieces.length; i++)if (pieces[i].length > 0) {
        let piece = pieces[i];
        try {
            piece = decodeURIComponent(piece.replace(/\+/g, ' '));
        } catch (e) {}
        pathStringDecoded += '/' + piece;
    }
    return pathStringDecoded;
}
/**
 * @returns key value hash
 */ function $9cf0852385f62d16$var$decodeQuery(queryString) {
    const results = {};
    if (queryString.charAt(0) === '?') queryString = queryString.substring(1);
    for (const segment of queryString.split('&')){
        if (segment.length === 0) continue;
        const kv = segment.split('=');
        if (kv.length === 2) results[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
        else $9cf0852385f62d16$var$warn(`Invalid query segment '${segment}' in query '${queryString}'`);
    }
    return results;
}
const $9cf0852385f62d16$var$parseRepoInfo = function(dataURL, nodeAdmin) {
    const parsedUrl = $9cf0852385f62d16$var$parseDatabaseURL(dataURL), namespace = parsedUrl.namespace;
    if (parsedUrl.domain === 'firebase.com') $9cf0852385f62d16$var$fatal(parsedUrl.host + ' is no longer supported. ' + 'Please use <YOUR FIREBASE>.firebaseio.com instead');
    // Catch common error of uninitialized namespace value.
    if ((!namespace || namespace === 'undefined') && parsedUrl.domain !== 'localhost') $9cf0852385f62d16$var$fatal('Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com');
    if (!parsedUrl.secure) $9cf0852385f62d16$var$warnIfPageIsSecure();
    const webSocketOnly = parsedUrl.scheme === 'ws' || parsedUrl.scheme === 'wss';
    return {
        repoInfo: new $9cf0852385f62d16$var$RepoInfo(parsedUrl.host, parsedUrl.secure, namespace, webSocketOnly, nodeAdmin, /*persistenceKey=*/ '', /*includeNamespaceInQueryParams=*/ namespace !== parsedUrl.subdomain),
        path: new $9cf0852385f62d16$var$Path(parsedUrl.pathString)
    };
};
const $9cf0852385f62d16$var$parseDatabaseURL = function(dataURL) {
    // Default to empty strings in the event of a malformed string.
    let host = '', domain = '', subdomain = '', pathString = '', namespace = '';
    // Always default to SSL, unless otherwise specified.
    let secure = true, scheme = 'https', port = 443;
    // Don't do any validation here. The caller is responsible for validating the result of parsing.
    if (typeof dataURL === 'string') {
        // Parse scheme.
        let colonInd = dataURL.indexOf('//');
        if (colonInd >= 0) {
            scheme = dataURL.substring(0, colonInd - 1);
            dataURL = dataURL.substring(colonInd + 2);
        }
        // Parse host, path, and query string.
        let slashInd = dataURL.indexOf('/');
        if (slashInd === -1) slashInd = dataURL.length;
        let questionMarkInd = dataURL.indexOf('?');
        if (questionMarkInd === -1) questionMarkInd = dataURL.length;
        host = dataURL.substring(0, Math.min(slashInd, questionMarkInd));
        if (slashInd < questionMarkInd) // For pathString, questionMarkInd will always come after slashInd
        pathString = $9cf0852385f62d16$var$decodePath(dataURL.substring(slashInd, questionMarkInd));
        const queryParams = $9cf0852385f62d16$var$decodeQuery(dataURL.substring(Math.min(dataURL.length, questionMarkInd)));
        // If we have a port, use scheme for determining if it's secure.
        colonInd = host.indexOf(':');
        if (colonInd >= 0) {
            secure = scheme === 'https' || scheme === 'wss';
            port = parseInt(host.substring(colonInd + 1), 10);
        } else colonInd = host.length;
        const hostWithoutPort = host.slice(0, colonInd);
        if (hostWithoutPort.toLowerCase() === 'localhost') domain = 'localhost';
        else if (hostWithoutPort.split('.').length <= 2) domain = hostWithoutPort;
        else {
            // Interpret the subdomain of a 3 or more component URL as the namespace name.
            const dotInd = host.indexOf('.');
            subdomain = host.substring(0, dotInd).toLowerCase();
            domain = host.substring(dotInd + 1);
            // Normalize namespaces to lowercase to share storage / connection.
            namespace = subdomain;
        }
        // Always treat the value of the `ns` as the namespace name if it is present.
        if ('ns' in queryParams) namespace = queryParams['ns'];
    }
    return {
        host: host,
        port: port,
        domain: domain,
        subdomain: subdomain,
        secure: secure,
        scheme: scheme,
        pathString: pathString,
        namespace: namespace
    };
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Modeled after base64 web-safe chars, but ordered by ASCII.
const $9cf0852385f62d16$var$PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
/**
 * Fancy ID generator that creates 20-character string identifiers with the
 * following properties:
 *
 * 1. They're based on timestamp so that they sort *after* any existing ids.
 * 2. They contain 72-bits of random data after the timestamp so that IDs won't
 *    collide with other clients' IDs.
 * 3. They sort *lexicographically* (so the timestamp is converted to characters
 *    that will sort properly).
 * 4. They're monotonically increasing. Even if you generate more than one in
 *    the same timestamp, the latter ones will sort after the former ones. We do
 *    this by using the previous random bits but "incrementing" them by 1 (only
 *    in the case of a timestamp collision).
 */ const $9cf0852385f62d16$var$nextPushId = function() {
    // Timestamp of last push, used to prevent local collisions if you push twice
    // in one ms.
    let lastPushTime = 0;
    // We generate 72-bits of randomness which get turned into 12 characters and
    // appended to the timestamp to prevent collisions with other clients. We
    // store the last characters we generated because in the event of a collision,
    // we'll use those same characters except "incremented" by one.
    const lastRandChars = [];
    return function(now) {
        const duplicateTime = now === lastPushTime;
        lastPushTime = now;
        let i;
        const timeStampChars = new Array(8);
        for(i = 7; i >= 0; i--){
            timeStampChars[i] = $9cf0852385f62d16$var$PUSH_CHARS.charAt(now % 64);
            // NOTE: Can't use << here because javascript will convert to int and lose
            // the upper bits.
            now = Math.floor(now / 64);
        }
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(now === 0, 'Cannot push at time == 0');
        let id = timeStampChars.join('');
        if (!duplicateTime) for(i = 0; i < 12; i++)lastRandChars[i] = Math.floor(Math.random() * 64);
        else {
            // If the timestamp hasn't changed since last push, use the same random
            // number, except incremented by 1.
            for(i = 11; i >= 0 && lastRandChars[i] === 63; i--)lastRandChars[i] = 0;
            lastRandChars[i]++;
        }
        for(i = 0; i < 12; i++)id += $9cf0852385f62d16$var$PUSH_CHARS.charAt(lastRandChars[i]);
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(id.length === 20, 'nextPushId: Length should be 20.');
        return id;
    };
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Encapsulates the data needed to raise an event
 */ class $9cf0852385f62d16$var$DataEvent {
    /**
     * @param eventType - One of: value, child_added, child_changed, child_moved, child_removed
     * @param eventRegistration - The function to call to with the event data. User provided
     * @param snapshot - The data backing the event
     * @param prevName - Optional, the name of the previous child for child_* events.
     */ constructor(eventType, eventRegistration, snapshot, prevName){
        this.eventType = eventType;
        this.eventRegistration = eventRegistration;
        this.snapshot = snapshot;
        this.prevName = prevName;
    }
    getPath() {
        const ref = this.snapshot.ref;
        if (this.eventType === 'value') return ref._path;
        else return ref.parent._path;
    }
    getEventType() {
        return this.eventType;
    }
    getEventRunner() {
        return this.eventRegistration.getEventRunner(this);
    }
    toString() {
        return this.getPath().toString() + ':' + this.eventType + ':' + (0, $3117f6f4eeb4c314$export$fac44ee5b035f737)(this.snapshot.exportVal());
    }
}
class $9cf0852385f62d16$var$CancelEvent {
    constructor(eventRegistration, error, path){
        this.eventRegistration = eventRegistration;
        this.error = error;
        this.path = path;
    }
    getPath() {
        return this.path;
    }
    getEventType() {
        return 'cancel';
    }
    getEventRunner() {
        return this.eventRegistration.getEventRunner(this);
    }
    toString() {
        return this.path.toString() + ':cancel';
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A wrapper class that converts events from the database@exp SDK to the legacy
 * Database SDK. Events are not converted directly as event registration relies
 * on reference comparison of the original user callback (see `matches()`) and
 * relies on equality of the legacy SDK's `context` object.
 */ class $9cf0852385f62d16$var$CallbackContext {
    constructor(snapshotCallback, cancelCallback){
        this.snapshotCallback = snapshotCallback;
        this.cancelCallback = cancelCallback;
    }
    onValue(expDataSnapshot, previousChildName) {
        this.snapshotCallback.call(null, expDataSnapshot, previousChildName);
    }
    onCancel(error) {
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(this.hasCancelCallback, 'Raising a cancel event on a listener with no cancel callback');
        return this.cancelCallback.call(null, error);
    }
    get hasCancelCallback() {
        return !!this.cancelCallback;
    }
    matches(other) {
        return this.snapshotCallback === other.snapshotCallback || this.snapshotCallback.userCallback !== undefined && this.snapshotCallback.userCallback === other.snapshotCallback.userCallback && this.snapshotCallback.context === other.snapshotCallback.context;
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The `onDisconnect` class allows you to write or clear data when your client
 * disconnects from the Database server. These updates occur whether your
 * client disconnects cleanly or not, so you can rely on them to clean up data
 * even if a connection is dropped or a client crashes.
 *
 * The `onDisconnect` class is most commonly used to manage presence in
 * applications where it is useful to detect how many clients are connected and
 * when other clients disconnect. See
 * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
 * for more information.
 *
 * To avoid problems when a connection is dropped before the requests can be
 * transferred to the Database server, these functions should be called before
 * writing any data.
 *
 * Note that `onDisconnect` operations are only triggered once. If you want an
 * operation to occur each time a disconnect occurs, you'll need to re-establish
 * the `onDisconnect` operations each time you reconnect.
 */ class $9cf0852385f62d16$export$95b7818b4ee6c2af {
    /** @hideconstructor */ constructor(_repo, _path){
        this._repo = _repo;
        this._path = _path;
    }
    /**
     * Cancels all previously queued `onDisconnect()` set or update events for this
     * location and all children.
     *
     * If a write has been queued for this location via a `set()` or `update()` at a
     * parent location, the write at this location will be canceled, though writes
     * to sibling locations will still occur.
     *
     * @returns Resolves when synchronization to the server is complete.
     */ cancel() {
        const deferred = new (0, $3117f6f4eeb4c314$export$85f6557964517f1a)();
        $9cf0852385f62d16$var$repoOnDisconnectCancel(this._repo, this._path, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Ensures the data at this location is deleted when the client is disconnected
     * (due to closing the browser, navigating to a new page, or network issues).
     *
     * @returns Resolves when synchronization to the server is complete.
     */ remove() {
        $9cf0852385f62d16$export$8d83036122ae444e('OnDisconnect.remove', this._path);
        const deferred = new (0, $3117f6f4eeb4c314$export$85f6557964517f1a)();
        $9cf0852385f62d16$var$repoOnDisconnectSet(this._repo, this._path, null, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Ensures the data at this location is set to the specified value when the
     * client is disconnected (due to closing the browser, navigating to a new page,
     * or network issues).
     *
     * `set()` is especially useful for implementing "presence" systems, where a
     * value should be changed or cleared when a user disconnects so that they
     * appear "offline" to other users. See
     * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
     * for more information.
     *
     * Note that `onDisconnect` operations are only triggered once. If you want an
     * operation to occur each time a disconnect occurs, you'll need to re-establish
     * the `onDisconnect` operations each time.
     *
     * @param value - The value to be written to this location on disconnect (can
     * be an object, array, string, number, boolean, or null).
     * @returns Resolves when synchronization to the Database is complete.
     */ set(value) {
        $9cf0852385f62d16$export$8d83036122ae444e('OnDisconnect.set', this._path);
        $9cf0852385f62d16$var$validateFirebaseDataArg('OnDisconnect.set', value, this._path, false);
        const deferred = new (0, $3117f6f4eeb4c314$export$85f6557964517f1a)();
        $9cf0852385f62d16$var$repoOnDisconnectSet(this._repo, this._path, value, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Ensures the data at this location is set to the specified value and priority
     * when the client is disconnected (due to closing the browser, navigating to a
     * new page, or network issues).
     *
     * @param value - The value to be written to this location on disconnect (can
     * be an object, array, string, number, boolean, or null).
     * @param priority - The priority to be written (string, number, or null).
     * @returns Resolves when synchronization to the Database is complete.
     */ setWithPriority(value, priority) {
        $9cf0852385f62d16$export$8d83036122ae444e('OnDisconnect.setWithPriority', this._path);
        $9cf0852385f62d16$var$validateFirebaseDataArg('OnDisconnect.setWithPriority', value, this._path, false);
        $9cf0852385f62d16$var$validatePriority('OnDisconnect.setWithPriority', priority, false);
        const deferred = new (0, $3117f6f4eeb4c314$export$85f6557964517f1a)();
        $9cf0852385f62d16$var$repoOnDisconnectSetWithPriority(this._repo, this._path, value, priority, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Writes multiple values at this location when the client is disconnected (due
     * to closing the browser, navigating to a new page, or network issues).
     *
     * The `values` argument contains multiple property-value pairs that will be
     * written to the Database together. Each child property can either be a simple
     * property (for example, "name") or a relative path (for example, "name/first")
     * from the current location to the data to update.
     *
     * As opposed to the `set()` method, `update()` can be use to selectively update
     * only the referenced properties at the current location (instead of replacing
     * all the child properties at the current location).
     *
     * @param values - Object containing multiple values.
     * @returns Resolves when synchronization to the Database is complete.
     */ update(values) {
        $9cf0852385f62d16$export$8d83036122ae444e('OnDisconnect.update', this._path);
        $9cf0852385f62d16$var$validateFirebaseMergeDataArg('OnDisconnect.update', values, this._path, false);
        const deferred = new (0, $3117f6f4eeb4c314$export$85f6557964517f1a)();
        $9cf0852385f62d16$var$repoOnDisconnectUpdate(this._repo, this._path, values, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ class $9cf0852385f62d16$export$e79c8d837d2220a8 {
    /**
     * @hideconstructor
     */ constructor(_repo, _path, _queryParams, _orderByCalled){
        this._repo = _repo;
        this._path = _path;
        this._queryParams = _queryParams;
        this._orderByCalled = _orderByCalled;
    }
    get key() {
        if ($9cf0852385f62d16$var$pathIsEmpty(this._path)) return null;
        else return $9cf0852385f62d16$var$pathGetBack(this._path);
    }
    get ref() {
        return new $9cf0852385f62d16$export$35c3a5e7c9d1033c(this._repo, this._path);
    }
    get _queryIdentifier() {
        const obj = $9cf0852385f62d16$var$queryParamsGetQueryObject(this._queryParams);
        const id = $9cf0852385f62d16$var$ObjectToUniqueKey(obj);
        return id === '{}' ? 'default' : id;
    }
    /**
     * An object representation of the query parameters used by this Query.
     */ get _queryObject() {
        return $9cf0852385f62d16$var$queryParamsGetQueryObject(this._queryParams);
    }
    isEqual(other) {
        other = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(other);
        if (!(other instanceof $9cf0852385f62d16$export$e79c8d837d2220a8)) return false;
        const sameRepo = this._repo === other._repo;
        const samePath = $9cf0852385f62d16$var$pathEquals(this._path, other._path);
        const sameQueryIdentifier = this._queryIdentifier === other._queryIdentifier;
        return sameRepo && samePath && sameQueryIdentifier;
    }
    toJSON() {
        return this.toString();
    }
    toString() {
        return this._repo.toString() + $9cf0852385f62d16$var$pathToUrlEncodedString(this._path);
    }
}
/**
 * Validates that no other order by call has been made
 */ function $9cf0852385f62d16$var$validateNoPreviousOrderByCall(query, fnName) {
    if (query._orderByCalled === true) throw new Error(fnName + ": You can't combine multiple orderBy calls.");
}
/**
 * Validates start/end values for queries.
 */ function $9cf0852385f62d16$var$validateQueryEndpoints(params) {
    let startNode = null;
    let endNode = null;
    if (params.hasStart()) startNode = params.getIndexStartValue();
    if (params.hasEnd()) endNode = params.getIndexEndValue();
    if (params.getIndex() === $9cf0852385f62d16$var$KEY_INDEX) {
        const tooManyArgsError = "Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().";
        const wrongArgTypeError = "Query: When ordering by key, the argument passed to startAt(), startAfter(), endAt(), endBefore(), or equalTo() must be a string.";
        if (params.hasStart()) {
            const startName = params.getIndexStartName();
            if (startName !== $9cf0852385f62d16$var$MIN_NAME) throw new Error(tooManyArgsError);
            else if (typeof startNode !== 'string') throw new Error(wrongArgTypeError);
        }
        if (params.hasEnd()) {
            const endName = params.getIndexEndName();
            if (endName !== $9cf0852385f62d16$var$MAX_NAME) throw new Error(tooManyArgsError);
            else if (typeof endNode !== 'string') throw new Error(wrongArgTypeError);
        }
    } else if (params.getIndex() === $9cf0852385f62d16$var$PRIORITY_INDEX) {
        if (startNode != null && !$9cf0852385f62d16$var$isValidPriority(startNode) || endNode != null && !$9cf0852385f62d16$var$isValidPriority(endNode)) throw new Error("Query: When ordering by priority, the first argument passed to startAt(), startAfter() endAt(), endBefore(), or equalTo() must be a valid priority value (null, a number, or a string).");
    } else {
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(params.getIndex() instanceof $9cf0852385f62d16$var$PathIndex || params.getIndex() === $9cf0852385f62d16$var$VALUE_INDEX, 'unknown index type.');
        if (startNode != null && typeof startNode === 'object' || endNode != null && typeof endNode === 'object') throw new Error("Query: First argument passed to startAt(), startAfter(), endAt(), endBefore(), or equalTo() cannot be an object.");
    }
}
/**
 * Validates that limit* has been called with the correct combination of parameters
 */ function $9cf0852385f62d16$var$validateLimit(params) {
    if (params.hasStart() && params.hasEnd() && params.hasLimit() && !params.hasAnchoredLimit()) throw new Error("Query: Can't combine startAt(), startAfter(), endAt(), endBefore(), and limit(). Use limitToFirst() or limitToLast() instead.");
}
/**
 * @internal
 */ class $9cf0852385f62d16$export$35c3a5e7c9d1033c extends $9cf0852385f62d16$export$e79c8d837d2220a8 {
    /** @hideconstructor */ constructor(repo, path){
        super(repo, path, new $9cf0852385f62d16$export$7ba287e361c94330(), false);
    }
    get parent() {
        const parentPath = $9cf0852385f62d16$var$pathParent(this._path);
        return parentPath === null ? null : new $9cf0852385f62d16$export$35c3a5e7c9d1033c(this._repo, parentPath);
    }
    get root() {
        let ref = this;
        while(ref.parent !== null)ref = ref.parent;
        return ref;
    }
}
/**
 * A `DataSnapshot` contains data from a Database location.
 *
 * Any time you read data from the Database, you receive the data as a
 * `DataSnapshot`. A `DataSnapshot` is passed to the event callbacks you attach
 * with `on()` or `once()`. You can extract the contents of the snapshot as a
 * JavaScript object by calling the `val()` method. Alternatively, you can
 * traverse into the snapshot by calling `child()` to return child snapshots
 * (which you could then call `val()` on).
 *
 * A `DataSnapshot` is an efficiently generated, immutable copy of the data at
 * a Database location. It cannot be modified and will never change (to modify
 * data, you always call the `set()` method on a `Reference` directly).
 */ class $9cf0852385f62d16$export$80b98bcbc246c942 {
    /**
     * @param _node - A SnapshotNode to wrap.
     * @param ref - The location this snapshot came from.
     * @param _index - The iteration order for this snapshot
     * @hideconstructor
     */ constructor(_node, /**
     * The location of this DataSnapshot.
     */ ref, _index){
        this._node = _node;
        this.ref = ref;
        this._index = _index;
    }
    /**
     * Gets the priority value of the data in this `DataSnapshot`.
     *
     * Applications need not use priority but can order collections by
     * ordinary properties (see
     * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data |Sorting and filtering data}
     * ).
     */ get priority() {
        // typecast here because we never return deferred values or internal priorities (MAX_PRIORITY)
        return this._node.getPriority().val();
    }
    /**
     * The key (last part of the path) of the location of this `DataSnapshot`.
     *
     * The last token in a Database location is considered its key. For example,
     * "ada" is the key for the /users/ada/ node. Accessing the key on any
     * `DataSnapshot` will return the key for the location that generated it.
     * However, accessing the key on the root URL of a Database will return
     * `null`.
     */ get key() {
        return this.ref.key;
    }
    /** Returns the number of child properties of this `DataSnapshot`. */ get size() {
        return this._node.numChildren();
    }
    /**
     * Gets another `DataSnapshot` for the location at the specified relative path.
     *
     * Passing a relative path to the `child()` method of a DataSnapshot returns
     * another `DataSnapshot` for the location at the specified relative path. The
     * relative path can either be a simple child name (for example, "ada") or a
     * deeper, slash-separated path (for example, "ada/name/first"). If the child
     * location has no data, an empty `DataSnapshot` (that is, a `DataSnapshot`
     * whose value is `null`) is returned.
     *
     * @param path - A relative path to the location of child data.
     */ child(path) {
        const childPath = new $9cf0852385f62d16$var$Path(path);
        const childRef = $9cf0852385f62d16$export$f9574b70e1d95d9d(this.ref, path);
        return new $9cf0852385f62d16$export$80b98bcbc246c942(this._node.getChild(childPath), childRef, $9cf0852385f62d16$var$PRIORITY_INDEX);
    }
    /**
     * Returns true if this `DataSnapshot` contains any data. It is slightly more
     * efficient than using `snapshot.val() !== null`.
     */ exists() {
        return !this._node.isEmpty();
    }
    /**
     * Exports the entire contents of the DataSnapshot as a JavaScript object.
     *
     * The `exportVal()` method is similar to `val()`, except priority information
     * is included (if available), making it suitable for backing up your data.
     *
     * @returns The DataSnapshot's contents as a JavaScript value (Object,
     *   Array, string, number, boolean, or `null`).
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    exportVal() {
        return this._node.val(true);
    }
    /**
     * Enumerates the top-level children in the `IteratedDataSnapshot`.
     *
     * Because of the way JavaScript objects work, the ordering of data in the
     * JavaScript object returned by `val()` is not guaranteed to match the
     * ordering on the server nor the ordering of `onChildAdded()` events. That is
     * where `forEach()` comes in handy. It guarantees the children of a
     * `DataSnapshot` will be iterated in their query order.
     *
     * If no explicit `orderBy*()` method is used, results are returned
     * ordered by key (unless priorities are used, in which case, results are
     * returned by priority).
     *
     * @param action - A function that will be called for each child DataSnapshot.
     * The callback can return true to cancel further enumeration.
     * @returns true if enumeration was canceled due to your callback returning
     * true.
     */ forEach(action) {
        if (this._node.isLeafNode()) return false;
        const childrenNode = this._node;
        // Sanitize the return value to a boolean. ChildrenNode.forEachChild has a weird return type...
        return !!childrenNode.forEachChild(this._index, (key, node)=>{
            return action(new $9cf0852385f62d16$export$80b98bcbc246c942(node, $9cf0852385f62d16$export$f9574b70e1d95d9d(this.ref, key), $9cf0852385f62d16$var$PRIORITY_INDEX));
        });
    }
    /**
     * Returns true if the specified child path has (non-null) data.
     *
     * @param path - A relative path to the location of a potential child.
     * @returns `true` if data exists at the specified child path; else
     *  `false`.
     */ hasChild(path) {
        const childPath = new $9cf0852385f62d16$var$Path(path);
        return !this._node.getChild(childPath).isEmpty();
    }
    /**
     * Returns whether or not the `DataSnapshot` has any non-`null` child
     * properties.
     *
     * You can use `hasChildren()` to determine if a `DataSnapshot` has any
     * children. If it does, you can enumerate them using `forEach()`. If it
     * doesn't, then either this snapshot contains a primitive value (which can be
     * retrieved with `val()`) or it is empty (in which case, `val()` will return
     * `null`).
     *
     * @returns true if this snapshot has any children; else false.
     */ hasChildren() {
        if (this._node.isLeafNode()) return false;
        else return !this._node.isEmpty();
    }
    /**
     * Returns a JSON-serializable representation of this object.
     */ toJSON() {
        return this.exportVal();
    }
    /**
     * Extracts a JavaScript value from a `DataSnapshot`.
     *
     * Depending on the data in a `DataSnapshot`, the `val()` method may return a
     * scalar type (string, number, or boolean), an array, or an object. It may
     * also return null, indicating that the `DataSnapshot` is empty (contains no
     * data).
     *
     * @returns The DataSnapshot's contents as a JavaScript value (Object,
     *   Array, string, number, boolean, or `null`).
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    val() {
        return this._node.val();
    }
}
/**
 *
 * Returns a `Reference` representing the location in the Database
 * corresponding to the provided path. If no path is provided, the `Reference`
 * will point to the root of the Database.
 *
 * @param db - The database instance to obtain a reference for.
 * @param path - Optional path representing the location the returned
 *   `Reference` will point. If not provided, the returned `Reference` will
 *   point to the root of the Database.
 * @returns If a path is provided, a `Reference`
 *   pointing to the provided path. Otherwise, a `Reference` pointing to the
 *   root of the Database.
 */ function $9cf0852385f62d16$export$eff4d24c3ff7876e(db, path) {
    db = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted('ref');
    return path !== undefined ? $9cf0852385f62d16$export$f9574b70e1d95d9d(db._root, path) : db._root;
}
/**
 * Returns a `Reference` representing the location in the Database
 * corresponding to the provided Firebase URL.
 *
 * An exception is thrown if the URL is not a valid Firebase Database URL or it
 * has a different domain than the current `Database` instance.
 *
 * Note that all query parameters (`orderBy`, `limitToLast`, etc.) are ignored
 * and are not applied to the returned `Reference`.
 *
 * @param db - The database instance to obtain a reference for.
 * @param url - The Firebase URL at which the returned `Reference` will
 *   point.
 * @returns A `Reference` pointing to the provided
 *   Firebase URL.
 */ function $9cf0852385f62d16$export$291fc3c05735451(db, url) {
    db = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted('refFromURL');
    const parsedURL = $9cf0852385f62d16$var$parseRepoInfo(url, db._repo.repoInfo_.nodeAdmin);
    $9cf0852385f62d16$var$validateUrl('refFromURL', parsedURL);
    const repoInfo = parsedURL.repoInfo;
    if (!db._repo.repoInfo_.isCustomHost() && repoInfo.host !== db._repo.repoInfo_.host) $9cf0852385f62d16$var$fatal("refFromURL: Host name does not match the current database: (found " + repoInfo.host + ' but expected ' + db._repo.repoInfo_.host + ')');
    return $9cf0852385f62d16$export$eff4d24c3ff7876e(db, parsedURL.path.toString());
}
/**
 * Gets a `Reference` for the location at the specified relative path.
 *
 * The relative path can either be a simple child name (for example, "ada") or
 * a deeper slash-separated path (for example, "ada/name/first").
 *
 * @param parent - The parent location.
 * @param path - A relative path from this location to the desired child
 *   location.
 * @returns The specified child location.
 */ function $9cf0852385f62d16$export$f9574b70e1d95d9d(parent, path) {
    parent = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(parent);
    if ($9cf0852385f62d16$var$pathGetFront(parent._path) === null) $9cf0852385f62d16$var$validateRootPathString('child', 'path', path, false);
    else $9cf0852385f62d16$export$8637b026ace8abb1('child', 'path', path, false);
    return new $9cf0852385f62d16$export$35c3a5e7c9d1033c(parent._repo, $9cf0852385f62d16$var$pathChild(parent._path, path));
}
/**
 * Returns an `OnDisconnect` object - see
 * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
 * for more information on how to use it.
 *
 * @param ref - The reference to add OnDisconnect triggers for.
 */ function $9cf0852385f62d16$export$b61bdcd0bdb4f86a(ref) {
    ref = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(ref);
    return new $9cf0852385f62d16$export$95b7818b4ee6c2af(ref._repo, ref._path);
}
/**
 * Generates a new child location using a unique key and returns its
 * `Reference`.
 *
 * This is the most common pattern for adding data to a collection of items.
 *
 * If you provide a value to `push()`, the value is written to the
 * generated location. If you don't pass a value, nothing is written to the
 * database and the child remains empty (but you can use the `Reference`
 * elsewhere).
 *
 * The unique keys generated by `push()` are ordered by the current time, so the
 * resulting list of items is chronologically sorted. The keys are also
 * designed to be unguessable (they contain 72 random bits of entropy).
 *
 * See {@link https://firebase.google.com/docs/database/web/lists-of-data#append_to_a_list_of_data | Append to a list of data}.
 * See {@link https://firebase.googleblog.com/2015/02/the-2120-ways-to-ensure-unique_68.html | The 2^120 Ways to Ensure Unique Identifiers}.
 *
 * @param parent - The parent location.
 * @param value - Optional value to be written at the generated location.
 * @returns Combined `Promise` and `Reference`; resolves when write is complete,
 * but can be used immediately as the `Reference` to the child location.
 */ function $9cf0852385f62d16$export$4cbf152802aa238(parent, value) {
    parent = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(parent);
    $9cf0852385f62d16$export$8d83036122ae444e('push', parent._path);
    $9cf0852385f62d16$var$validateFirebaseDataArg('push', value, parent._path, true);
    const now = $9cf0852385f62d16$var$repoServerTime(parent._repo);
    const name = $9cf0852385f62d16$var$nextPushId(now);
    // push() returns a ThennableReference whose promise is fulfilled with a
    // regular Reference. We use child() to create handles to two different
    // references. The first is turned into a ThennableReference below by adding
    // then() and catch() methods and is used as the return value of push(). The
    // second remains a regular Reference and is used as the fulfilled value of
    // the first ThennableReference.
    const thenablePushRef = $9cf0852385f62d16$export$f9574b70e1d95d9d(parent, name);
    const pushRef = $9cf0852385f62d16$export$f9574b70e1d95d9d(parent, name);
    let promise;
    if (value != null) promise = $9cf0852385f62d16$export$adaa4cf7ef1b65be(pushRef, value).then(()=>pushRef);
    else promise = Promise.resolve(pushRef);
    thenablePushRef.then = promise.then.bind(promise);
    thenablePushRef.catch = promise.then.bind(promise, undefined);
    return thenablePushRef;
}
/**
 * Removes the data at this Database location.
 *
 * Any data at child locations will also be deleted.
 *
 * The effect of the remove will be visible immediately and the corresponding
 * event 'value' will be triggered. Synchronization of the remove to the
 * Firebase servers will also be started, and the returned Promise will resolve
 * when complete. If provided, the onComplete callback will be called
 * asynchronously after synchronization has finished.
 *
 * @param ref - The location to remove.
 * @returns Resolves when remove on server is complete.
 */ function $9cf0852385f62d16$export$cd7f480d6b8286c3(ref) {
    $9cf0852385f62d16$export$8d83036122ae444e('remove', ref._path);
    return $9cf0852385f62d16$export$adaa4cf7ef1b65be(ref, null);
}
/**
 * Writes data to this Database location.
 *
 * This will overwrite any data at this location and all child locations.
 *
 * The effect of the write will be visible immediately, and the corresponding
 * events ("value", "child_added", etc.) will be triggered. Synchronization of
 * the data to the Firebase servers will also be started, and the returned
 * Promise will resolve when complete. If provided, the `onComplete` callback
 * will be called asynchronously after synchronization has finished.
 *
 * Passing `null` for the new value is equivalent to calling `remove()`; namely,
 * all data at this location and all child locations will be deleted.
 *
 * `set()` will remove any priority stored at this location, so if priority is
 * meant to be preserved, you need to use `setWithPriority()` instead.
 *
 * Note that modifying data with `set()` will cancel any pending transactions
 * at that location, so extreme care should be taken if mixing `set()` and
 * `transaction()` to modify the same data.
 *
 * A single `set()` will generate a single "value" event at the location where
 * the `set()` was performed.
 *
 * @param ref - The location to write to.
 * @param value - The value to be written (string, number, boolean, object,
 *   array, or null).
 * @returns Resolves when write to server is complete.
 */ function $9cf0852385f62d16$export$adaa4cf7ef1b65be(ref, value) {
    ref = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(ref);
    $9cf0852385f62d16$export$8d83036122ae444e('set', ref._path);
    $9cf0852385f62d16$var$validateFirebaseDataArg('set', value, ref._path, false);
    const deferred = new (0, $3117f6f4eeb4c314$export$85f6557964517f1a)();
    $9cf0852385f62d16$var$repoSetWithPriority(ref._repo, ref._path, value, /*priority=*/ null, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Sets a priority for the data at this Database location.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data | Sorting and filtering data}
 * ).
 *
 * @param ref - The location to write to.
 * @param priority - The priority to be written (string, number, or null).
 * @returns Resolves when write to server is complete.
 */ function $9cf0852385f62d16$export$313bf5dbe7a1196e(ref, priority) {
    ref = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(ref);
    $9cf0852385f62d16$export$8d83036122ae444e('setPriority', ref._path);
    $9cf0852385f62d16$var$validatePriority('setPriority', priority, false);
    const deferred = new (0, $3117f6f4eeb4c314$export$85f6557964517f1a)();
    $9cf0852385f62d16$var$repoSetWithPriority(ref._repo, $9cf0852385f62d16$var$pathChild(ref._path, '.priority'), priority, null, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Writes data the Database location. Like `set()` but also specifies the
 * priority for that data.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data | Sorting and filtering data}
 * ).
 *
 * @param ref - The location to write to.
 * @param value - The value to be written (string, number, boolean, object,
 *   array, or null).
 * @param priority - The priority to be written (string, number, or null).
 * @returns Resolves when write to server is complete.
 */ function $9cf0852385f62d16$export$1fa5d5bf488088f3(ref, value, priority) {
    $9cf0852385f62d16$export$8d83036122ae444e('setWithPriority', ref._path);
    $9cf0852385f62d16$var$validateFirebaseDataArg('setWithPriority', value, ref._path, false);
    $9cf0852385f62d16$var$validatePriority('setWithPriority', priority, false);
    if (ref.key === '.length' || ref.key === '.keys') throw 'setWithPriority failed: ' + ref.key + ' is a read-only object.';
    const deferred = new (0, $3117f6f4eeb4c314$export$85f6557964517f1a)();
    $9cf0852385f62d16$var$repoSetWithPriority(ref._repo, ref._path, value, priority, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Writes multiple values to the Database at once.
 *
 * The `values` argument contains multiple property-value pairs that will be
 * written to the Database together. Each child property can either be a simple
 * property (for example, "name") or a relative path (for example,
 * "name/first") from the current location to the data to update.
 *
 * As opposed to the `set()` method, `update()` can be use to selectively update
 * only the referenced properties at the current location (instead of replacing
 * all the child properties at the current location).
 *
 * The effect of the write will be visible immediately, and the corresponding
 * events ('value', 'child_added', etc.) will be triggered. Synchronization of
 * the data to the Firebase servers will also be started, and the returned
 * Promise will resolve when complete. If provided, the `onComplete` callback
 * will be called asynchronously after synchronization has finished.
 *
 * A single `update()` will generate a single "value" event at the location
 * where the `update()` was performed, regardless of how many children were
 * modified.
 *
 * Note that modifying data with `update()` will cancel any pending
 * transactions at that location, so extreme care should be taken if mixing
 * `update()` and `transaction()` to modify the same data.
 *
 * Passing `null` to `update()` will remove the data at this location.
 *
 * See
 * {@link https://firebase.googleblog.com/2015/09/introducing-multi-location-updates-and_86.html | Introducing multi-location updates and more}.
 *
 * @param ref - The location to write to.
 * @param values - Object containing multiple values.
 * @returns Resolves when update on server is complete.
 */ function $9cf0852385f62d16$export$722fbec263ad908a(ref, values) {
    $9cf0852385f62d16$var$validateFirebaseMergeDataArg('update', values, ref._path, false);
    const deferred = new (0, $3117f6f4eeb4c314$export$85f6557964517f1a)();
    $9cf0852385f62d16$var$repoUpdate(ref._repo, ref._path, values, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Gets the most up-to-date result for this query.
 *
 * @param query - The query to run.
 * @returns A `Promise` which resolves to the resulting DataSnapshot if a value is
 * available, or rejects if the client is unable to return a value (e.g., if the
 * server is unreachable and there is nothing cached).
 */ function $9cf0852385f62d16$export$3988ae62b71be9a3(query) {
    query = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(query);
    const callbackContext = new $9cf0852385f62d16$var$CallbackContext(()=>{});
    const container = new $9cf0852385f62d16$var$ValueEventRegistration(callbackContext);
    return $9cf0852385f62d16$var$repoGetValue(query._repo, query, container).then((node)=>{
        return new $9cf0852385f62d16$export$80b98bcbc246c942(node, new $9cf0852385f62d16$export$35c3a5e7c9d1033c(query._repo, query._path), query._queryParams.getIndex());
    });
}
/**
 * Represents registration for 'value' events.
 */ class $9cf0852385f62d16$var$ValueEventRegistration {
    constructor(callbackContext){
        this.callbackContext = callbackContext;
    }
    respondsTo(eventType) {
        return eventType === 'value';
    }
    createEvent(change, query) {
        const index = query._queryParams.getIndex();
        return new $9cf0852385f62d16$var$DataEvent('value', this, new $9cf0852385f62d16$export$80b98bcbc246c942(change.snapshotNode, new $9cf0852385f62d16$export$35c3a5e7c9d1033c(query._repo, query._path), index));
    }
    getEventRunner(eventData) {
        if (eventData.getEventType() === 'cancel') return ()=>this.callbackContext.onCancel(eventData.error);
        else return ()=>this.callbackContext.onValue(eventData.snapshot, null);
    }
    createCancelEvent(error, path) {
        if (this.callbackContext.hasCancelCallback) return new $9cf0852385f62d16$var$CancelEvent(this, error, path);
        else return null;
    }
    matches(other) {
        if (!(other instanceof $9cf0852385f62d16$var$ValueEventRegistration)) return false;
        else if (!other.callbackContext || !this.callbackContext) // If no callback specified, we consider it to match any callback.
        return true;
        else return other.callbackContext.matches(this.callbackContext);
    }
    hasAnyCallback() {
        return this.callbackContext !== null;
    }
}
/**
 * Represents the registration of a child_x event.
 */ class $9cf0852385f62d16$var$ChildEventRegistration {
    constructor(eventType, callbackContext){
        this.eventType = eventType;
        this.callbackContext = callbackContext;
    }
    respondsTo(eventType) {
        let eventToCheck = eventType === 'children_added' ? 'child_added' : eventType;
        eventToCheck = eventToCheck === 'children_removed' ? 'child_removed' : eventToCheck;
        return this.eventType === eventToCheck;
    }
    createCancelEvent(error, path) {
        if (this.callbackContext.hasCancelCallback) return new $9cf0852385f62d16$var$CancelEvent(this, error, path);
        else return null;
    }
    createEvent(change, query) {
        (0, $3117f6f4eeb4c314$export$a7a9523472993e97)(change.childName != null, 'Child events should have a childName.');
        const childRef = $9cf0852385f62d16$export$f9574b70e1d95d9d(new $9cf0852385f62d16$export$35c3a5e7c9d1033c(query._repo, query._path), change.childName);
        const index = query._queryParams.getIndex();
        return new $9cf0852385f62d16$var$DataEvent(change.type, this, new $9cf0852385f62d16$export$80b98bcbc246c942(change.snapshotNode, childRef, index), change.prevName);
    }
    getEventRunner(eventData) {
        if (eventData.getEventType() === 'cancel') return ()=>this.callbackContext.onCancel(eventData.error);
        else return ()=>this.callbackContext.onValue(eventData.snapshot, eventData.prevName);
    }
    matches(other) {
        if (other instanceof $9cf0852385f62d16$var$ChildEventRegistration) return this.eventType === other.eventType && (!this.callbackContext || !other.callbackContext || this.callbackContext.matches(other.callbackContext));
        return false;
    }
    hasAnyCallback() {
        return !!this.callbackContext;
    }
}
function $9cf0852385f62d16$var$addEventListener(query, eventType, callback, cancelCallbackOrListenOptions, options) {
    let cancelCallback;
    if (typeof cancelCallbackOrListenOptions === 'object') {
        cancelCallback = undefined;
        options = cancelCallbackOrListenOptions;
    }
    if (typeof cancelCallbackOrListenOptions === 'function') cancelCallback = cancelCallbackOrListenOptions;
    if (options && options.onlyOnce) {
        const userCallback = callback;
        const onceCallback = (dataSnapshot, previousChildName)=>{
            $9cf0852385f62d16$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
            userCallback(dataSnapshot, previousChildName);
        };
        onceCallback.userCallback = callback.userCallback;
        onceCallback.context = callback.context;
        callback = onceCallback;
    }
    const callbackContext = new $9cf0852385f62d16$var$CallbackContext(callback, cancelCallback || undefined);
    const container = eventType === 'value' ? new $9cf0852385f62d16$var$ValueEventRegistration(callbackContext) : new $9cf0852385f62d16$var$ChildEventRegistration(eventType, callbackContext);
    $9cf0852385f62d16$var$repoAddEventCallbackForQuery(query._repo, query, container);
    return ()=>$9cf0852385f62d16$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
}
function $9cf0852385f62d16$export$ad30f661f41f4d90(query, callback, cancelCallbackOrListenOptions, options) {
    return $9cf0852385f62d16$var$addEventListener(query, 'value', callback, cancelCallbackOrListenOptions, options);
}
function $9cf0852385f62d16$export$fdc3e67b2775c753(query, callback, cancelCallbackOrListenOptions, options) {
    return $9cf0852385f62d16$var$addEventListener(query, 'child_added', callback, cancelCallbackOrListenOptions, options);
}
function $9cf0852385f62d16$export$a3fdf31223dcb03(query, callback, cancelCallbackOrListenOptions, options) {
    return $9cf0852385f62d16$var$addEventListener(query, 'child_changed', callback, cancelCallbackOrListenOptions, options);
}
function $9cf0852385f62d16$export$1b001b15904d2a7f(query, callback, cancelCallbackOrListenOptions, options) {
    return $9cf0852385f62d16$var$addEventListener(query, 'child_moved', callback, cancelCallbackOrListenOptions, options);
}
function $9cf0852385f62d16$export$8362b530316d1aba(query, callback, cancelCallbackOrListenOptions, options) {
    return $9cf0852385f62d16$var$addEventListener(query, 'child_removed', callback, cancelCallbackOrListenOptions, options);
}
/**
 * Detaches a callback previously attached with the corresponding `on*()` (`onValue`, `onChildAdded`) listener.
 * Note: This is not the recommended way to remove a listener. Instead, please use the returned callback function from
 * the respective `on*` callbacks.
 *
 * Detach a callback previously attached with `on*()`. Calling `off()` on a parent listener
 * will not automatically remove listeners registered on child nodes, `off()`
 * must also be called on any child listeners to remove the callback.
 *
 * If a callback is not specified, all callbacks for the specified eventType
 * will be removed. Similarly, if no eventType is specified, all callbacks
 * for the `Reference` will be removed.
 *
 * Individual listeners can also be removed by invoking their unsubscribe
 * callbacks.
 *
 * @param query - The query that the listener was registered with.
 * @param eventType - One of the following strings: "value", "child_added",
 * "child_changed", "child_removed", or "child_moved." If omitted, all callbacks
 * for the `Reference` will be removed.
 * @param callback - The callback function that was passed to `on()` or
 * `undefined` to remove all callbacks.
 */ function $9cf0852385f62d16$export$8c8705df4a2dcec9(query, eventType, callback) {
    let container = null;
    const expCallback = callback ? new $9cf0852385f62d16$var$CallbackContext(callback) : null;
    if (eventType === 'value') container = new $9cf0852385f62d16$var$ValueEventRegistration(expCallback);
    else if (eventType) container = new $9cf0852385f62d16$var$ChildEventRegistration(eventType, expCallback);
    $9cf0852385f62d16$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Database query. `QueryConstraint`s are created by invoking {@link endAt},
 * {@link endBefore}, {@link startAt}, {@link startAfter}, {@link
 * limitToFirst}, {@link limitToLast}, {@link orderByChild},
 * {@link orderByChild}, {@link orderByKey} , {@link orderByPriority} ,
 * {@link orderByValue}  or {@link equalTo} and
 * can then be passed to {@link query} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ class $9cf0852385f62d16$export$b0e86f2c7431df4e {
}
class $9cf0852385f62d16$var$QueryEndAtConstraint extends $9cf0852385f62d16$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'endAt';
    }
    _apply(query) {
        $9cf0852385f62d16$var$validateFirebaseDataArg('endAt', this._value, query._path, true);
        const newParams = $9cf0852385f62d16$var$queryParamsEndAt(query._queryParams, this._value, this._key);
        $9cf0852385f62d16$var$validateLimit(newParams);
        $9cf0852385f62d16$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasEnd()) throw new Error("endAt: Starting point was already set (by another call to endAt, endBefore or equalTo).");
        return new $9cf0852385f62d16$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified ending point.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The ending point is inclusive, so children with exactly the specified value
 * will be included in the query. The optional key argument can be used to
 * further limit the range of the query. If it is specified, then children that
 * have exactly the specified value must also have a key name less than or equal
 * to the specified key.
 *
 * You can read more about `endAt()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to end at. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to end at, among the children with the previously
 * specified priority. This argument is only allowed if ordering by child,
 * value, or priority.
 */ function $9cf0852385f62d16$export$28ec54a8428bdb3f(value, key) {
    $9cf0852385f62d16$var$validateKey('endAt', 'key', key, true);
    return new $9cf0852385f62d16$var$QueryEndAtConstraint(value, key);
}
class $9cf0852385f62d16$var$QueryEndBeforeConstraint extends $9cf0852385f62d16$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'endBefore';
    }
    _apply(query) {
        $9cf0852385f62d16$var$validateFirebaseDataArg('endBefore', this._value, query._path, false);
        const newParams = $9cf0852385f62d16$var$queryParamsEndBefore(query._queryParams, this._value, this._key);
        $9cf0852385f62d16$var$validateLimit(newParams);
        $9cf0852385f62d16$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasEnd()) throw new Error("endBefore: Starting point was already set (by another call to endAt, endBefore or equalTo).");
        return new $9cf0852385f62d16$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified ending point (exclusive).
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The ending point is exclusive. If only a value is provided, children
 * with a value less than the specified value will be included in the query.
 * If a key is specified, then children must have a value less than or equal
 * to the specified value and a key name less than the specified key.
 *
 * @param value - The value to end before. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to end before, among the children with the
 * previously specified priority. This argument is only allowed if ordering by
 * child, value, or priority.
 */ function $9cf0852385f62d16$export$57203950645b8b11(value, key) {
    $9cf0852385f62d16$var$validateKey('endBefore', 'key', key, true);
    return new $9cf0852385f62d16$var$QueryEndBeforeConstraint(value, key);
}
class $9cf0852385f62d16$var$QueryStartAtConstraint extends $9cf0852385f62d16$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'startAt';
    }
    _apply(query) {
        $9cf0852385f62d16$var$validateFirebaseDataArg('startAt', this._value, query._path, true);
        const newParams = $9cf0852385f62d16$var$queryParamsStartAt(query._queryParams, this._value, this._key);
        $9cf0852385f62d16$var$validateLimit(newParams);
        $9cf0852385f62d16$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasStart()) throw new Error("startAt: Starting point was already set (by another call to startAt, startBefore or equalTo).");
        return new $9cf0852385f62d16$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified starting point.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The starting point is inclusive, so children with exactly the specified value
 * will be included in the query. The optional key argument can be used to
 * further limit the range of the query. If it is specified, then children that
 * have exactly the specified value must also have a key name greater than or
 * equal to the specified key.
 *
 * You can read more about `startAt()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to start at. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start at. This argument is only allowed if
 * ordering by child, value, or priority.
 */ function $9cf0852385f62d16$export$859941c5fc8eba6b(value = null, key) {
    $9cf0852385f62d16$var$validateKey('startAt', 'key', key, true);
    return new $9cf0852385f62d16$var$QueryStartAtConstraint(value, key);
}
class $9cf0852385f62d16$var$QueryStartAfterConstraint extends $9cf0852385f62d16$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'startAfter';
    }
    _apply(query) {
        $9cf0852385f62d16$var$validateFirebaseDataArg('startAfter', this._value, query._path, false);
        const newParams = $9cf0852385f62d16$var$queryParamsStartAfter(query._queryParams, this._value, this._key);
        $9cf0852385f62d16$var$validateLimit(newParams);
        $9cf0852385f62d16$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasStart()) throw new Error("startAfter: Starting point was already set (by another call to startAt, startAfter, or equalTo).");
        return new $9cf0852385f62d16$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified starting point (exclusive).
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The starting point is exclusive. If only a value is provided, children
 * with a value greater than the specified value will be included in the query.
 * If a key is specified, then children must have a value greater than or equal
 * to the specified value and a a key name greater than the specified key.
 *
 * @param value - The value to start after. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start after. This argument is only allowed if
 * ordering by child, value, or priority.
 */ function $9cf0852385f62d16$export$dd8dee5f7b804673(value, key) {
    $9cf0852385f62d16$var$validateKey('startAfter', 'key', key, true);
    return new $9cf0852385f62d16$var$QueryStartAfterConstraint(value, key);
}
class $9cf0852385f62d16$var$QueryLimitToFirstConstraint extends $9cf0852385f62d16$export$b0e86f2c7431df4e {
    constructor(_limit){
        super();
        this._limit = _limit;
        this.type = 'limitToFirst';
    }
    _apply(query) {
        if (query._queryParams.hasLimit()) throw new Error("limitToFirst: Limit was already set (by another call to limitToFirst or limitToLast).");
        return new $9cf0852385f62d16$export$e79c8d837d2220a8(query._repo, query._path, $9cf0852385f62d16$var$queryParamsLimitToFirst(query._queryParams, this._limit), query._orderByCalled);
    }
}
/**
 * Creates a new `QueryConstraint` that if limited to the first specific number
 * of children.
 *
 * The `limitToFirst()` method is used to set a maximum number of children to be
 * synced for a given callback. If we set a limit of 100, we will initially only
 * receive up to 100 `child_added` events. If we have fewer than 100 messages
 * stored in our Database, a `child_added` event will fire for each message.
 * However, if we have over 100 messages, we will only receive a `child_added`
 * event for the first 100 ordered messages. As items change, we will receive
 * `child_removed` events for each item that drops out of the active list so
 * that the total number stays at 100.
 *
 * You can read more about `limitToFirst()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param limit - The maximum number of nodes to include in this query.
 */ function $9cf0852385f62d16$export$9d02e839f813b99d(limit) {
    if (typeof limit !== 'number' || Math.floor(limit) !== limit || limit <= 0) throw new Error('limitToFirst: First argument must be a positive integer.');
    return new $9cf0852385f62d16$var$QueryLimitToFirstConstraint(limit);
}
class $9cf0852385f62d16$var$QueryLimitToLastConstraint extends $9cf0852385f62d16$export$b0e86f2c7431df4e {
    constructor(_limit){
        super();
        this._limit = _limit;
        this.type = 'limitToLast';
    }
    _apply(query) {
        if (query._queryParams.hasLimit()) throw new Error("limitToLast: Limit was already set (by another call to limitToFirst or limitToLast).");
        return new $9cf0852385f62d16$export$e79c8d837d2220a8(query._repo, query._path, $9cf0852385f62d16$var$queryParamsLimitToLast(query._queryParams, this._limit), query._orderByCalled);
    }
}
/**
 * Creates a new `QueryConstraint` that is limited to return only the last
 * specified number of children.
 *
 * The `limitToLast()` method is used to set a maximum number of children to be
 * synced for a given callback. If we set a limit of 100, we will initially only
 * receive up to 100 `child_added` events. If we have fewer than 100 messages
 * stored in our Database, a `child_added` event will fire for each message.
 * However, if we have over 100 messages, we will only receive a `child_added`
 * event for the last 100 ordered messages. As items change, we will receive
 * `child_removed` events for each item that drops out of the active list so
 * that the total number stays at 100.
 *
 * You can read more about `limitToLast()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param limit - The maximum number of nodes to include in this query.
 */ function $9cf0852385f62d16$export$f823b3589f69d3b8(limit) {
    if (typeof limit !== 'number' || Math.floor(limit) !== limit || limit <= 0) throw new Error('limitToLast: First argument must be a positive integer.');
    return new $9cf0852385f62d16$var$QueryLimitToLastConstraint(limit);
}
class $9cf0852385f62d16$var$QueryOrderByChildConstraint extends $9cf0852385f62d16$export$b0e86f2c7431df4e {
    constructor(_path){
        super();
        this._path = _path;
        this.type = 'orderByChild';
    }
    _apply(query) {
        $9cf0852385f62d16$var$validateNoPreviousOrderByCall(query, 'orderByChild');
        const parsedPath = new $9cf0852385f62d16$var$Path(this._path);
        if ($9cf0852385f62d16$var$pathIsEmpty(parsedPath)) throw new Error('orderByChild: cannot pass in empty path. Use orderByValue() instead.');
        const index = new $9cf0852385f62d16$var$PathIndex(parsedPath);
        const newParams = $9cf0852385f62d16$var$queryParamsOrderBy(query._queryParams, index);
        $9cf0852385f62d16$var$validateQueryEndpoints(newParams);
        return new $9cf0852385f62d16$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by the specified child key.
 *
 * Queries can only order by one key at a time. Calling `orderByChild()`
 * multiple times on the same query is an error.
 *
 * Firebase queries allow you to order your data by any child key on the fly.
 * However, if you know in advance what your indexes will be, you can define
 * them via the .indexOn rule in your Security Rules for better performance. See
 * the{@link https://firebase.google.com/docs/database/security/indexing-data}
 * rule for more information.
 *
 * You can read more about `orderByChild()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 *
 * @param path - The path to order by.
 */ function $9cf0852385f62d16$export$5162bd9025f8e144(path) {
    if (path === '$key') throw new Error('orderByChild: "$key" is invalid.  Use orderByKey() instead.');
    else if (path === '$priority') throw new Error('orderByChild: "$priority" is invalid.  Use orderByPriority() instead.');
    else if (path === '$value') throw new Error('orderByChild: "$value" is invalid.  Use orderByValue() instead.');
    $9cf0852385f62d16$export$8637b026ace8abb1('orderByChild', 'path', path, false);
    return new $9cf0852385f62d16$var$QueryOrderByChildConstraint(path);
}
class $9cf0852385f62d16$var$QueryOrderByKeyConstraint extends $9cf0852385f62d16$export$b0e86f2c7431df4e {
    constructor(){
        super(...arguments);
        this.type = 'orderByKey';
    }
    _apply(query) {
        $9cf0852385f62d16$var$validateNoPreviousOrderByCall(query, 'orderByKey');
        const newParams = $9cf0852385f62d16$var$queryParamsOrderBy(query._queryParams, $9cf0852385f62d16$var$KEY_INDEX);
        $9cf0852385f62d16$var$validateQueryEndpoints(newParams);
        return new $9cf0852385f62d16$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by the key.
 *
 * Sorts the results of a query by their (ascending) key values.
 *
 * You can read more about `orderByKey()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 */ function $9cf0852385f62d16$export$d5ab8b3bbd8afbf8() {
    return new $9cf0852385f62d16$var$QueryOrderByKeyConstraint();
}
class $9cf0852385f62d16$var$QueryOrderByPriorityConstraint extends $9cf0852385f62d16$export$b0e86f2c7431df4e {
    constructor(){
        super(...arguments);
        this.type = 'orderByPriority';
    }
    _apply(query) {
        $9cf0852385f62d16$var$validateNoPreviousOrderByCall(query, 'orderByPriority');
        const newParams = $9cf0852385f62d16$var$queryParamsOrderBy(query._queryParams, $9cf0852385f62d16$var$PRIORITY_INDEX);
        $9cf0852385f62d16$var$validateQueryEndpoints(newParams);
        return new $9cf0852385f62d16$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by priority.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}
 * for alternatives to priority.
 */ function $9cf0852385f62d16$export$19e8ae5500cf2e55() {
    return new $9cf0852385f62d16$var$QueryOrderByPriorityConstraint();
}
class $9cf0852385f62d16$var$QueryOrderByValueConstraint extends $9cf0852385f62d16$export$b0e86f2c7431df4e {
    constructor(){
        super(...arguments);
        this.type = 'orderByValue';
    }
    _apply(query) {
        $9cf0852385f62d16$var$validateNoPreviousOrderByCall(query, 'orderByValue');
        const newParams = $9cf0852385f62d16$var$queryParamsOrderBy(query._queryParams, $9cf0852385f62d16$var$VALUE_INDEX);
        $9cf0852385f62d16$var$validateQueryEndpoints(newParams);
        return new $9cf0852385f62d16$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by value.
 *
 * If the children of a query are all scalar values (string, number, or
 * boolean), you can order the results by their (ascending) values.
 *
 * You can read more about `orderByValue()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 */ function $9cf0852385f62d16$export$7f2f62793c39d0c0() {
    return new $9cf0852385f62d16$var$QueryOrderByValueConstraint();
}
class $9cf0852385f62d16$var$QueryEqualToValueConstraint extends $9cf0852385f62d16$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'equalTo';
    }
    _apply(query) {
        $9cf0852385f62d16$var$validateFirebaseDataArg('equalTo', this._value, query._path, false);
        if (query._queryParams.hasStart()) throw new Error("equalTo: Starting point was already set (by another call to startAt/startAfter or equalTo).");
        if (query._queryParams.hasEnd()) throw new Error("equalTo: Ending point was already set (by another call to endAt/endBefore or equalTo).");
        return new $9cf0852385f62d16$var$QueryEndAtConstraint(this._value, this._key)._apply(new $9cf0852385f62d16$var$QueryStartAtConstraint(this._value, this._key)._apply(query));
    }
}
/**
 * Creates a `QueryConstraint` that includes children that match the specified
 * value.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The optional key argument can be used to further limit the range of the
 * query. If it is specified, then children that have exactly the specified
 * value must also have exactly the specified key as their key name. This can be
 * used to filter result sets with many matches for the same value.
 *
 * You can read more about `equalTo()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to match for. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start at, among the children with the
 * previously specified priority. This argument is only allowed if ordering by
 * child, value, or priority.
 */ function $9cf0852385f62d16$export$bdcdec1f91f16dff(value, key) {
    $9cf0852385f62d16$var$validateKey('equalTo', 'key', key, true);
    return new $9cf0852385f62d16$var$QueryEqualToValueConstraint(value, key);
}
/**
 * Creates a new immutable instance of `Query` that is extended to also include
 * additional query constraints.
 *
 * @param query - The Query instance to use as a base for the new constraints.
 * @param queryConstraints - The list of `QueryConstraint`s to apply.
 * @throws if any of the provided query constraints cannot be combined with the
 * existing or new constraints.
 */ function $9cf0852385f62d16$export$2fa187e846a241c4(query1, ...queryConstraints) {
    let queryImpl = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(query1);
    for (const constraint of queryConstraints)queryImpl = constraint._apply(queryImpl);
    return queryImpl;
}
/**
 * Define reference constructor in various modules
 *
 * We are doing this here to avoid several circular
 * dependency issues
 */ $9cf0852385f62d16$var$syncPointSetReferenceConstructor($9cf0852385f62d16$export$35c3a5e7c9d1033c);
$9cf0852385f62d16$var$syncTreeSetReferenceConstructor($9cf0852385f62d16$export$35c3a5e7c9d1033c);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This variable is also defined in the firebase Node.js Admin SDK. Before
 * modifying this definition, consult the definition in:
 *
 * https://github.com/firebase/firebase-admin-node
 *
 * and make sure the two are consistent.
 */ const $9cf0852385f62d16$var$FIREBASE_DATABASE_EMULATOR_HOST_VAR = 'FIREBASE_DATABASE_EMULATOR_HOST';
/**
 * Creates and caches `Repo` instances.
 */ const $9cf0852385f62d16$var$repos = {};
/**
 * If true, any new `Repo` will be created to use `ReadonlyRestClient` (for testing purposes).
 */ let $9cf0852385f62d16$var$useRestClient = false;
/**
 * Update an existing `Repo` in place to point to a new host/port.
 */ function $9cf0852385f62d16$var$repoManagerApplyEmulatorSettings(repo, hostAndPort, emulatorOptions, tokenProvider) {
    const portIndex = hostAndPort.lastIndexOf(':');
    const host = hostAndPort.substring(0, portIndex);
    const useSsl = (0, $3117f6f4eeb4c314$export$5b4d24b45140ad90)(host);
    repo.repoInfo_ = new $9cf0852385f62d16$var$RepoInfo(hostAndPort, /* secure= */ useSsl, repo.repoInfo_.namespace, repo.repoInfo_.webSocketOnly, repo.repoInfo_.nodeAdmin, repo.repoInfo_.persistenceKey, repo.repoInfo_.includeNamespaceInQueryParams, /*isUsingEmulator=*/ true, emulatorOptions);
    if (tokenProvider) repo.authTokenProvider_ = tokenProvider;
}
/**
 * This function should only ever be called to CREATE a new database instance.
 * @internal
 */ function $9cf0852385f62d16$export$a248c1d2ea757674(app, authProvider, appCheckProvider, url, nodeAdmin) {
    let dbUrl = url || app.options.databaseURL;
    if (dbUrl === undefined) {
        if (!app.options.projectId) $9cf0852385f62d16$var$fatal("Can't determine Firebase Database URL. Be sure to include  a Project ID when calling firebase.initializeApp().");
        $9cf0852385f62d16$var$log('Using default host for project ', app.options.projectId);
        dbUrl = `${app.options.projectId}-default-rtdb.firebaseio.com`;
    }
    let parsedUrl = $9cf0852385f62d16$var$parseRepoInfo(dbUrl, nodeAdmin);
    let repoInfo = parsedUrl.repoInfo;
    let isEmulator;
    let dbEmulatorHost = undefined;
    if (dbEmulatorHost) {
        isEmulator = true;
        dbUrl = `http://${dbEmulatorHost}?ns=${repoInfo.namespace}`;
        parsedUrl = $9cf0852385f62d16$var$parseRepoInfo(dbUrl, nodeAdmin);
        repoInfo = parsedUrl.repoInfo;
    } else isEmulator = !parsedUrl.repoInfo.secure;
    const authTokenProvider = nodeAdmin && isEmulator ? new $9cf0852385f62d16$var$EmulatorTokenProvider($9cf0852385f62d16$var$EmulatorTokenProvider.OWNER) : new $9cf0852385f62d16$var$FirebaseAuthTokenProvider(app.name, app.options, authProvider);
    $9cf0852385f62d16$var$validateUrl('Invalid Firebase Database URL', parsedUrl);
    if (!$9cf0852385f62d16$var$pathIsEmpty(parsedUrl.path)) $9cf0852385f62d16$var$fatal("Database URL must point to the root of a Firebase Database (not including a child path).");
    const repo = $9cf0852385f62d16$var$repoManagerCreateRepo(repoInfo, app, authTokenProvider, new $9cf0852385f62d16$var$AppCheckTokenProvider(app, appCheckProvider));
    return new $9cf0852385f62d16$export$6feb5ea51a7b0b47(repo, app);
}
/**
 * Remove the repo and make sure it is disconnected.
 *
 */ function $9cf0852385f62d16$var$repoManagerDeleteRepo(repo, appName) {
    const appRepos = $9cf0852385f62d16$var$repos[appName];
    // This should never happen...
    if (!appRepos || appRepos[repo.key] !== repo) $9cf0852385f62d16$var$fatal(`Database ${appName}(${repo.repoInfo_}) has already been deleted.`);
    $9cf0852385f62d16$var$repoInterrupt(repo);
    delete appRepos[repo.key];
}
/**
 * Ensures a repo doesn't already exist and then creates one using the
 * provided app.
 *
 * @param repoInfo - The metadata about the Repo
 * @returns The Repo object for the specified server / repoName.
 */ function $9cf0852385f62d16$var$repoManagerCreateRepo(repoInfo, app, authTokenProvider, appCheckProvider) {
    let appRepos = $9cf0852385f62d16$var$repos[app.name];
    if (!appRepos) {
        appRepos = {};
        $9cf0852385f62d16$var$repos[app.name] = appRepos;
    }
    let repo = appRepos[repoInfo.toURLString()];
    if (repo) $9cf0852385f62d16$var$fatal('Database initialized multiple times. Please make sure the format of the database URL matches with each database() call.');
    repo = new $9cf0852385f62d16$var$Repo(repoInfo, $9cf0852385f62d16$var$useRestClient, authTokenProvider, appCheckProvider);
    appRepos[repoInfo.toURLString()] = repo;
    return repo;
}
/**
 * Forces us to use ReadonlyRestClient instead of PersistentConnection for new Repos.
 */ function $9cf0852385f62d16$var$repoManagerForceRestClient(forceRestClient) {
    $9cf0852385f62d16$var$useRestClient = forceRestClient;
}
/**
 * Class representing a Firebase Realtime Database.
 */ class $9cf0852385f62d16$export$6feb5ea51a7b0b47 {
    /** @hideconstructor */ constructor(_repoInternal, /** The {@link @firebase/app#FirebaseApp} associated with this Realtime Database instance. */ app){
        this._repoInternal = _repoInternal;
        this.app = app;
        /** Represents a `Database` instance. */ this['type'] = 'database';
        /** Track if the instance has been used (root or repo accessed) */ this._instanceStarted = false;
    }
    get _repo() {
        if (!this._instanceStarted) {
            $9cf0852385f62d16$var$repoStart(this._repoInternal, this.app.options.appId, this.app.options['databaseAuthVariableOverride']);
            this._instanceStarted = true;
        }
        return this._repoInternal;
    }
    get _root() {
        if (!this._rootInternal) this._rootInternal = new $9cf0852385f62d16$export$35c3a5e7c9d1033c(this._repo, $9cf0852385f62d16$var$newEmptyPath());
        return this._rootInternal;
    }
    _delete() {
        if (this._rootInternal !== null) {
            $9cf0852385f62d16$var$repoManagerDeleteRepo(this._repo, this.app.name);
            this._repoInternal = null;
            this._rootInternal = null;
        }
        return Promise.resolve();
    }
    _checkNotDeleted(apiName) {
        if (this._rootInternal === null) $9cf0852385f62d16$var$fatal('Cannot call ' + apiName + ' on a deleted database.');
    }
}
function $9cf0852385f62d16$var$checkTransportInit() {
    if ($9cf0852385f62d16$var$TransportManager.IS_TRANSPORT_INITIALIZED) $9cf0852385f62d16$var$warn('Transport has already been initialized. Please call this function before calling ref or setting up a listener');
}
/**
 * Force the use of websockets instead of longPolling.
 */ function $9cf0852385f62d16$export$752b38c15a5377b6() {
    $9cf0852385f62d16$var$checkTransportInit();
    $9cf0852385f62d16$var$BrowserPollConnection.forceDisallow();
}
/**
 * Force the use of longPolling instead of websockets. This will be ignored if websocket protocol is used in databaseURL.
 */ function $9cf0852385f62d16$export$387cff57f2608869() {
    $9cf0852385f62d16$var$checkTransportInit();
    $9cf0852385f62d16$var$WebSocketConnection.forceDisallow();
    $9cf0852385f62d16$var$BrowserPollConnection.forceAllow();
}
/**
 * Returns the instance of the Realtime Database SDK that is associated with the provided
 * {@link @firebase/app#FirebaseApp}. Initializes a new instance with default settings if
 * no instance exists or if the existing instance uses a custom database URL.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} instance that the returned Realtime
 * Database instance is associated with.
 * @param url - The URL of the Realtime Database instance to connect to. If not
 * provided, the SDK connects to the default instance of the Firebase App.
 * @returns The `Database` instance of the provided app.
 */ function $9cf0852385f62d16$export$d0dd861204d0bf72(app = (0, $0c1331d0a001f5bc$export$f9962582c9e66d99)(), url) {
    const db = (0, $0c1331d0a001f5bc$export$fa0d6da0f5838f50)(app, 'database').getImmediate({
        identifier: url
    });
    if (!db._instanceStarted) {
        const emulator = (0, $3117f6f4eeb4c314$export$a3febcf1f14a3a0c)('database');
        if (emulator) $9cf0852385f62d16$export$87f3cfc4a2e3958d(db, ...emulator);
    }
    return db;
}
/**
 * Modify the provided instance to communicate with the Realtime Database
 * emulator.
 *
 * <p>Note: This method must be called before performing any other operation.
 *
 * @param db - The instance to modify.
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 8080)
 * @param options.mockUserToken - the mock auth token to use for unit testing Security Rules
 */ function $9cf0852385f62d16$export$87f3cfc4a2e3958d(db, host, port, options = {}) {
    db = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted('useEmulator');
    const hostAndPort = `${host}:${port}`;
    const repo = db._repoInternal;
    if (db._instanceStarted) {
        // If the instance has already been started, then silenty fail if this function is called again
        // with the same parameters. If the parameters differ then assert.
        if (hostAndPort === db._repoInternal.repoInfo_.host && (0, $3117f6f4eeb4c314$export$9cb4719e2e525b7a)(options, repo.repoInfo_.emulatorOptions)) return;
        $9cf0852385f62d16$var$fatal('connectDatabaseEmulator() cannot initialize or alter the emulator configuration after the database instance has started.');
    }
    let tokenProvider = undefined;
    if (repo.repoInfo_.nodeAdmin) {
        if (options.mockUserToken) $9cf0852385f62d16$var$fatal('mockUserToken is not supported by the Admin SDK. For client access with mock users, please use the "firebase" package instead of "firebase-admin".');
        tokenProvider = new $9cf0852385f62d16$var$EmulatorTokenProvider($9cf0852385f62d16$var$EmulatorTokenProvider.OWNER);
    } else if (options.mockUserToken) {
        const token = typeof options.mockUserToken === 'string' ? options.mockUserToken : (0, $3117f6f4eeb4c314$export$367bf224123348f1)(options.mockUserToken, db.app.options.projectId);
        tokenProvider = new $9cf0852385f62d16$var$EmulatorTokenProvider(token);
    }
    // Workaround to get cookies in Firebase Studio
    if ((0, $3117f6f4eeb4c314$export$5b4d24b45140ad90)(host)) {
        (0, $3117f6f4eeb4c314$export$c0f0d0ce4283a937)(host);
        (0, $3117f6f4eeb4c314$export$fd3d2954543183b1)('Database', true);
    }
    // Modify the repo to apply emulator settings
    $9cf0852385f62d16$var$repoManagerApplyEmulatorSettings(repo, hostAndPort, options, tokenProvider);
}
/**
 * Disconnects from the server (all Database operations will be completed
 * offline).
 *
 * The client automatically maintains a persistent connection to the Database
 * server, which will remain active indefinitely and reconnect when
 * disconnected. However, the `goOffline()` and `goOnline()` methods may be used
 * to control the client connection in cases where a persistent connection is
 * undesirable.
 *
 * While offline, the client will no longer receive data updates from the
 * Database. However, all Database operations performed locally will continue to
 * immediately fire events, allowing your application to continue behaving
 * normally. Additionally, each operation performed locally will automatically
 * be queued and retried upon reconnection to the Database server.
 *
 * To reconnect to the Database and begin receiving remote events, see
 * `goOnline()`.
 *
 * @param db - The instance to disconnect.
 */ function $9cf0852385f62d16$export$bee838355d017f0a(db) {
    db = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted('goOffline');
    $9cf0852385f62d16$var$repoInterrupt(db._repo);
}
/**
 * Reconnects to the server and synchronizes the offline Database state
 * with the server state.
 *
 * This method should be used after disabling the active connection with
 * `goOffline()`. Once reconnected, the client will transmit the proper data
 * and fire the appropriate events so that your client "catches up"
 * automatically.
 *
 * @param db - The instance to reconnect.
 */ function $9cf0852385f62d16$export$e0eecaabee32dd(db) {
    db = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted('goOnline');
    $9cf0852385f62d16$var$repoResume(db._repo);
}
function $9cf0852385f62d16$export$4e1d237eb9e560af(logger, persistent) {
    $9cf0852385f62d16$var$enableLogging$1(logger, persistent);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9cf0852385f62d16$var$registerDatabase(variant) {
    $9cf0852385f62d16$export$c9fb972242fcb3c4((0, $0c1331d0a001f5bc$export$31499a9cd224b78c));
    (0, $0c1331d0a001f5bc$export$c930050e7bb63965)(new (0, $ad76b76e741ec0c7$export$16fa2f45be04daa8)('database', (container, { instanceIdentifier: url })=>{
        const app = container.getProvider('app').getImmediate();
        const authProvider = container.getProvider('auth-internal');
        const appCheckProvider = container.getProvider('app-check-internal');
        return $9cf0852385f62d16$export$a248c1d2ea757674(app, authProvider, appCheckProvider, url);
    }, "PUBLIC" /* ComponentType.PUBLIC */ ).setMultipleInstances(true));
    (0, $0c1331d0a001f5bc$export$d29d5299a7137abc)($9cf0852385f62d16$var$name, $9cf0852385f62d16$var$version, variant);
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    (0, $0c1331d0a001f5bc$export$d29d5299a7137abc)($9cf0852385f62d16$var$name, $9cf0852385f62d16$var$version, 'esm2020');
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9cf0852385f62d16$var$SERVER_TIMESTAMP = {
    '.sv': 'timestamp'
};
/**
 * Returns a placeholder value for auto-populating the current timestamp (time
 * since the Unix epoch, in milliseconds) as determined by the Firebase
 * servers.
 */ function $9cf0852385f62d16$export$3ff8e7e00c3264b7() {
    return $9cf0852385f62d16$var$SERVER_TIMESTAMP;
}
/**
 * Returns a placeholder value that can be used to atomically increment the
 * current database value by the provided delta.
 *
 * @param delta - the amount to modify the current value atomically.
 * @returns A placeholder value for modifying data atomically server-side.
 */ function $9cf0852385f62d16$export$a2647aa13413c947(delta) {
    return {
        '.sv': {
            'increment': delta
        }
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A type for the resolve value of {@link runTransaction}.
 */ class $9cf0852385f62d16$export$7a6f238067628c6b {
    /** @hideconstructor */ constructor(/** Whether the transaction was successfully committed. */ committed, /** The resulting data snapshot. */ snapshot){
        this.committed = committed;
        this.snapshot = snapshot;
    }
    /** Returns a JSON-serializable representation of this object. */ toJSON() {
        return {
            committed: this.committed,
            snapshot: this.snapshot.toJSON()
        };
    }
}
/**
 * Atomically modifies the data at this location.
 *
 * Atomically modify the data at this location. Unlike a normal `set()`, which
 * just overwrites the data regardless of its previous value, `runTransaction()` is
 * used to modify the existing value to a new value, ensuring there are no
 * conflicts with other clients writing to the same location at the same time.
 *
 * To accomplish this, you pass `runTransaction()` an update function which is
 * used to transform the current value into a new value. If another client
 * writes to the location before your new value is successfully written, your
 * update function will be called again with the new current value, and the
 * write will be retried. This will happen repeatedly until your write succeeds
 * without conflict or you abort the transaction by not returning a value from
 * your update function.
 *
 * Note: Modifying data with `set()` will cancel any pending transactions at
 * that location, so extreme care should be taken if mixing `set()` and
 * `runTransaction()` to update the same data.
 *
 * Note: When using transactions with Security and Firebase Rules in place, be
 * aware that a client needs `.read` access in addition to `.write` access in
 * order to perform a transaction. This is because the client-side nature of
 * transactions requires the client to read the data in order to transactionally
 * update it.
 *
 * @param ref - The location to atomically modify.
 * @param transactionUpdate - A developer-supplied function which will be passed
 * the current data stored at this location (as a JavaScript object). The
 * function should return the new value it would like written (as a JavaScript
 * object). If `undefined` is returned (i.e. you return with no arguments) the
 * transaction will be aborted and the data at this location will not be
 * modified.
 * @param options - An options object to configure transactions.
 * @returns A `Promise` that can optionally be used instead of the `onComplete`
 * callback to handle success and failure.
 */ function $9cf0852385f62d16$export$3c54e006bf9c93b7(ref, // eslint-disable-next-line @typescript-eslint/no-explicit-any
transactionUpdate, options) {
    ref = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(ref);
    $9cf0852385f62d16$export$8d83036122ae444e('Reference.transaction', ref._path);
    if (ref.key === '.length' || ref.key === '.keys') throw 'Reference.transaction failed: ' + ref.key + ' is a read-only object.';
    const applyLocally = options?.applyLocally ?? true;
    const deferred = new (0, $3117f6f4eeb4c314$export$85f6557964517f1a)();
    const promiseComplete = (error, committed, node)=>{
        let dataSnapshot = null;
        if (error) deferred.reject(error);
        else {
            dataSnapshot = new $9cf0852385f62d16$export$80b98bcbc246c942(node, new $9cf0852385f62d16$export$35c3a5e7c9d1033c(ref._repo, ref._path), $9cf0852385f62d16$var$PRIORITY_INDEX);
            deferred.resolve(new $9cf0852385f62d16$export$7a6f238067628c6b(committed, dataSnapshot));
        }
    };
    // Add a watch to make sure we get server updates.
    const unwatcher = $9cf0852385f62d16$export$ad30f661f41f4d90(ref, ()=>{});
    $9cf0852385f62d16$var$repoStartTransaction(ref._repo, ref._path, transactionUpdate, promiseComplete, unwatcher, applyLocally);
    return deferred.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $9cf0852385f62d16$var$PersistentConnection;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$9cf0852385f62d16$var$PersistentConnection.prototype.simpleListen = function(pathString, onComplete) {
    this.sendRequest('q', {
        p: pathString
    }, onComplete);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$9cf0852385f62d16$var$PersistentConnection.prototype.echo = function(data, onEcho) {
    this.sendRequest('echo', {
        d: data
    }, onEcho);
};
// RealTimeConnection properties that we use in tests.
$9cf0852385f62d16$var$Connection;
/**
 * @internal
 */ const $9cf0852385f62d16$export$3f9782a4529ff160 = function(newHash) {
    const oldPut = $9cf0852385f62d16$var$PersistentConnection.prototype.put;
    $9cf0852385f62d16$var$PersistentConnection.prototype.put = function(pathString, data, onComplete, hash) {
        if (hash !== undefined) hash = newHash();
        oldPut.call(this, pathString, data, onComplete, hash);
    };
    return function() {
        $9cf0852385f62d16$var$PersistentConnection.prototype.put = oldPut;
    };
};
$9cf0852385f62d16$var$RepoInfo;
/**
 * Forces the RepoManager to create Repos that use ReadonlyRestClient instead of PersistentConnection.
 * @internal
 */ const $9cf0852385f62d16$export$868c9f20a76f0839 = function(forceRestClient) {
    $9cf0852385f62d16$var$repoManagerForceRestClient(forceRestClient);
};
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Used by console to create a database based on the app,
 * passed database URL and a custom auth implementation.
 * @internal
 * @param app - A valid FirebaseApp-like object
 * @param url - A valid Firebase databaseURL
 * @param version - custom version e.g. firebase-admin version
 * @param customAppCheckImpl - custom app check implementation
 * @param customAuthImpl - custom auth implementation
 */ function $9cf0852385f62d16$export$8efb8ed30f837963({ app: app, url: url, version: version, customAuthImpl: customAuthImpl, customAppCheckImpl: customAppCheckImpl, nodeAdmin: nodeAdmin = false }) {
    $9cf0852385f62d16$export$c9fb972242fcb3c4(version);
    /**
     * ComponentContainer('database-standalone') is just a placeholder that doesn't perform
     * any actual function.
     */ const componentContainer = new (0, $ad76b76e741ec0c7$export$436a80eea5d5c0c5)('database-standalone');
    const authProvider = new (0, $ad76b76e741ec0c7$export$2881499e37b75b9a)('auth-internal', componentContainer);
    let appCheckProvider;
    if (customAppCheckImpl) {
        appCheckProvider = new (0, $ad76b76e741ec0c7$export$2881499e37b75b9a)('app-check-internal', componentContainer);
        appCheckProvider.setComponent(new (0, $ad76b76e741ec0c7$export$16fa2f45be04daa8)('app-check-internal', ()=>customAppCheckImpl, "PRIVATE" /* ComponentType.PRIVATE */ ));
    }
    authProvider.setComponent(new (0, $ad76b76e741ec0c7$export$16fa2f45be04daa8)('auth-internal', ()=>customAuthImpl, "PRIVATE" /* ComponentType.PRIVATE */ ));
    return $9cf0852385f62d16$export$a248c1d2ea757674(app, authProvider, appCheckProvider, url, nodeAdmin);
}
/**
 * Firebase Realtime Database
 *
 * @packageDocumentation
 */ $9cf0852385f62d16$var$registerDatabase();




const $407d7e9e8165099c$var$name = "@firebase/database-compat";
const $407d7e9e8165099c$var$version = "2.1.1";
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $407d7e9e8165099c$var$logClient = new (0, $6640afd658bf2724$export$efa9a398d6368992)('@firebase/database-compat');
const $407d7e9e8165099c$var$warn = function(msg) {
    const message = 'FIREBASE WARNING: ' + msg;
    $407d7e9e8165099c$var$logClient.warn(message);
};
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $407d7e9e8165099c$var$validateBoolean = function(fnName, argumentName, bool, optional) {
    if (optional && bool === undefined) return;
    if (typeof bool !== 'boolean') throw new Error((0, $3117f6f4eeb4c314$export$adea4917e02d93dc)(fnName, argumentName) + 'must be a boolean.');
};
const $407d7e9e8165099c$var$validateEventType = function(fnName, eventType, optional) {
    if (optional && eventType === undefined) return;
    switch(eventType){
        case 'value':
        case 'child_added':
        case 'child_removed':
        case 'child_changed':
        case 'child_moved':
            break;
        default:
            throw new Error((0, $3117f6f4eeb4c314$export$adea4917e02d93dc)(fnName, 'eventType') + 'must be a valid event type = "value", "child_added", "child_removed", ' + '"child_changed", or "child_moved".');
    }
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $407d7e9e8165099c$var$OnDisconnect {
    constructor(_delegate){
        this._delegate = _delegate;
    }
    cancel(onComplete) {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('OnDisconnect.cancel', 0, 1, arguments.length);
        (0, $3117f6f4eeb4c314$export$5bcd2a2eb6640dfa)('OnDisconnect.cancel', 'onComplete', onComplete, true);
        const result = this._delegate.cancel();
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    remove(onComplete) {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('OnDisconnect.remove', 0, 1, arguments.length);
        (0, $3117f6f4eeb4c314$export$5bcd2a2eb6640dfa)('OnDisconnect.remove', 'onComplete', onComplete, true);
        const result = this._delegate.remove();
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    set(value, onComplete) {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('OnDisconnect.set', 1, 2, arguments.length);
        (0, $3117f6f4eeb4c314$export$5bcd2a2eb6640dfa)('OnDisconnect.set', 'onComplete', onComplete, true);
        const result = this._delegate.set(value);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    setWithPriority(value, priority, onComplete) {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('OnDisconnect.setWithPriority', 2, 3, arguments.length);
        (0, $3117f6f4eeb4c314$export$5bcd2a2eb6640dfa)('OnDisconnect.setWithPriority', 'onComplete', onComplete, true);
        const result = this._delegate.setWithPriority(value, priority);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    update(objectToMerge, onComplete) {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('OnDisconnect.update', 1, 2, arguments.length);
        if (Array.isArray(objectToMerge)) {
            const newObjectToMerge = {};
            for(let i = 0; i < objectToMerge.length; ++i)newObjectToMerge['' + i] = objectToMerge[i];
            objectToMerge = newObjectToMerge;
            $407d7e9e8165099c$var$warn("Passing an Array to firebase.database.onDisconnect().update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.");
        }
        (0, $3117f6f4eeb4c314$export$5bcd2a2eb6640dfa)('OnDisconnect.update', 'onComplete', onComplete, true);
        const result = this._delegate.update(objectToMerge);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $407d7e9e8165099c$var$TransactionResult {
    /**
     * A type for the resolve value of Firebase.transaction.
     */ constructor(committed, snapshot){
        this.committed = committed;
        this.snapshot = snapshot;
    }
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    toJSON() {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('TransactionResult.toJSON', 0, 1, arguments.length);
        return {
            committed: this.committed,
            snapshot: this.snapshot.toJSON()
        };
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Class representing a firebase data snapshot.  It wraps a SnapshotNode and
 * surfaces the public methods (val, forEach, etc.) we want to expose.
 */ class $407d7e9e8165099c$var$DataSnapshot {
    constructor(_database, _delegate){
        this._database = _database;
        this._delegate = _delegate;
    }
    /**
     * Retrieves the snapshot contents as JSON.  Returns null if the snapshot is
     * empty.
     *
     * @returns JSON representation of the DataSnapshot contents, or null if empty.
     */ val() {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('DataSnapshot.val', 0, 0, arguments.length);
        return this._delegate.val();
    }
    /**
     * Returns the snapshot contents as JSON, including priorities of node.  Suitable for exporting
     * the entire node contents.
     * @returns JSON representation of the DataSnapshot contents, or null if empty.
     */ exportVal() {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('DataSnapshot.exportVal', 0, 0, arguments.length);
        return this._delegate.exportVal();
    }
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    toJSON() {
        // Optional spacer argument is unnecessary because we're depending on recursion rather than stringifying the content
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('DataSnapshot.toJSON', 0, 1, arguments.length);
        return this._delegate.toJSON();
    }
    /**
     * Returns whether the snapshot contains a non-null value.
     *
     * @returns Whether the snapshot contains a non-null value, or is empty.
     */ exists() {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('DataSnapshot.exists', 0, 0, arguments.length);
        return this._delegate.exists();
    }
    /**
     * Returns a DataSnapshot of the specified child node's contents.
     *
     * @param path - Path to a child.
     * @returns DataSnapshot for child node.
     */ child(path) {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('DataSnapshot.child', 0, 1, arguments.length);
        // Ensure the childPath is a string (can be a number)
        path = String(path);
        (0, $9cf0852385f62d16$export$8637b026ace8abb1)('DataSnapshot.child', 'path', path, false);
        return new $407d7e9e8165099c$var$DataSnapshot(this._database, this._delegate.child(path));
    }
    /**
     * Returns whether the snapshot contains a child at the specified path.
     *
     * @param path - Path to a child.
     * @returns Whether the child exists.
     */ hasChild(path) {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('DataSnapshot.hasChild', 1, 1, arguments.length);
        (0, $9cf0852385f62d16$export$8637b026ace8abb1)('DataSnapshot.hasChild', 'path', path, false);
        return this._delegate.hasChild(path);
    }
    /**
     * Returns the priority of the object, or null if no priority was set.
     *
     * @returns The priority.
     */ getPriority() {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('DataSnapshot.getPriority', 0, 0, arguments.length);
        return this._delegate.priority;
    }
    /**
     * Iterates through child nodes and calls the specified action for each one.
     *
     * @param action - Callback function to be called
     * for each child.
     * @returns True if forEach was canceled by action returning true for
     * one of the child nodes.
     */ forEach(action) {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('DataSnapshot.forEach', 1, 1, arguments.length);
        (0, $3117f6f4eeb4c314$export$5bcd2a2eb6640dfa)('DataSnapshot.forEach', 'action', action, false);
        return this._delegate.forEach((expDataSnapshot)=>action(new $407d7e9e8165099c$var$DataSnapshot(this._database, expDataSnapshot)));
    }
    /**
     * Returns whether this DataSnapshot has children.
     * @returns True if the DataSnapshot contains 1 or more child nodes.
     */ hasChildren() {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('DataSnapshot.hasChildren', 0, 0, arguments.length);
        return this._delegate.hasChildren();
    }
    get key() {
        return this._delegate.key;
    }
    /**
     * Returns the number of children for this DataSnapshot.
     * @returns The number of children that this DataSnapshot contains.
     */ numChildren() {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('DataSnapshot.numChildren', 0, 0, arguments.length);
        return this._delegate.size;
    }
    /**
     * @returns The Firebase reference for the location this snapshot's data came
     * from.
     */ getRef() {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('DataSnapshot.ref', 0, 0, arguments.length);
        return new $407d7e9e8165099c$var$Reference(this._database, this._delegate.ref);
    }
    get ref() {
        return this.getRef();
    }
}
/**
 * A Query represents a filter to be applied to a firebase location.  This object purely represents the
 * query expression (and exposes our public API to build the query).  The actual query logic is in ViewBase.js.
 *
 * Since every Firebase reference is a query, Firebase inherits from this object.
 */ class $407d7e9e8165099c$var$Query {
    constructor(database, _delegate){
        this.database = database;
        this._delegate = _delegate;
    }
    on(eventType, callback, cancelCallbackOrContext, context) {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('Query.on', 2, 4, arguments.length);
        (0, $3117f6f4eeb4c314$export$5bcd2a2eb6640dfa)('Query.on', 'callback', callback, false);
        const ret = $407d7e9e8165099c$var$Query.getCancelAndContextArgs_('Query.on', cancelCallbackOrContext, context);
        const valueCallback = (expSnapshot, previousChildName)=>{
            callback.call(ret.context, new $407d7e9e8165099c$var$DataSnapshot(this.database, expSnapshot), previousChildName);
        };
        valueCallback.userCallback = callback;
        valueCallback.context = ret.context;
        const cancelCallback = ret.cancel?.bind(ret.context);
        switch(eventType){
            case 'value':
                (0, $9cf0852385f62d16$export$ad30f661f41f4d90)(this._delegate, valueCallback, cancelCallback);
                return callback;
            case 'child_added':
                (0, $9cf0852385f62d16$export$fdc3e67b2775c753)(this._delegate, valueCallback, cancelCallback);
                return callback;
            case 'child_removed':
                (0, $9cf0852385f62d16$export$8362b530316d1aba)(this._delegate, valueCallback, cancelCallback);
                return callback;
            case 'child_changed':
                (0, $9cf0852385f62d16$export$a3fdf31223dcb03)(this._delegate, valueCallback, cancelCallback);
                return callback;
            case 'child_moved':
                (0, $9cf0852385f62d16$export$1b001b15904d2a7f)(this._delegate, valueCallback, cancelCallback);
                return callback;
            default:
                throw new Error((0, $3117f6f4eeb4c314$export$adea4917e02d93dc)('Query.on', 'eventType') + 'must be a valid event type = "value", "child_added", "child_removed", ' + '"child_changed", or "child_moved".');
        }
    }
    off(eventType, callback, context) {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('Query.off', 0, 3, arguments.length);
        $407d7e9e8165099c$var$validateEventType('Query.off', eventType, true);
        (0, $3117f6f4eeb4c314$export$5bcd2a2eb6640dfa)('Query.off', 'callback', callback, true);
        (0, $3117f6f4eeb4c314$export$df77539402cfb523)('Query.off', 'context', context, true);
        if (callback) {
            const valueCallback = ()=>{};
            valueCallback.userCallback = callback;
            valueCallback.context = context;
            (0, $9cf0852385f62d16$export$8c8705df4a2dcec9)(this._delegate, eventType, valueCallback);
        } else (0, $9cf0852385f62d16$export$8c8705df4a2dcec9)(this._delegate, eventType);
    }
    /**
     * Get the server-value for this query, or return a cached value if not connected.
     */ get() {
        return (0, $9cf0852385f62d16$export$3988ae62b71be9a3)(this._delegate).then((expSnapshot)=>{
            return new $407d7e9e8165099c$var$DataSnapshot(this.database, expSnapshot);
        });
    }
    /**
     * Attaches a listener, waits for the first event, and then removes the listener
     */ once(eventType, callback, failureCallbackOrContext, context) {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('Query.once', 1, 4, arguments.length);
        (0, $3117f6f4eeb4c314$export$5bcd2a2eb6640dfa)('Query.once', 'callback', callback, true);
        const ret = $407d7e9e8165099c$var$Query.getCancelAndContextArgs_('Query.once', failureCallbackOrContext, context);
        const deferred = new (0, $3117f6f4eeb4c314$export$85f6557964517f1a)();
        const valueCallback = (expSnapshot, previousChildName)=>{
            const result = new $407d7e9e8165099c$var$DataSnapshot(this.database, expSnapshot);
            if (callback) callback.call(ret.context, result, previousChildName);
            deferred.resolve(result);
        };
        valueCallback.userCallback = callback;
        valueCallback.context = ret.context;
        const cancelCallback = (error)=>{
            if (ret.cancel) ret.cancel.call(ret.context, error);
            deferred.reject(error);
        };
        switch(eventType){
            case 'value':
                (0, $9cf0852385f62d16$export$ad30f661f41f4d90)(this._delegate, valueCallback, cancelCallback, {
                    onlyOnce: true
                });
                break;
            case 'child_added':
                (0, $9cf0852385f62d16$export$fdc3e67b2775c753)(this._delegate, valueCallback, cancelCallback, {
                    onlyOnce: true
                });
                break;
            case 'child_removed':
                (0, $9cf0852385f62d16$export$8362b530316d1aba)(this._delegate, valueCallback, cancelCallback, {
                    onlyOnce: true
                });
                break;
            case 'child_changed':
                (0, $9cf0852385f62d16$export$a3fdf31223dcb03)(this._delegate, valueCallback, cancelCallback, {
                    onlyOnce: true
                });
                break;
            case 'child_moved':
                (0, $9cf0852385f62d16$export$1b001b15904d2a7f)(this._delegate, valueCallback, cancelCallback, {
                    onlyOnce: true
                });
                break;
            default:
                throw new Error((0, $3117f6f4eeb4c314$export$adea4917e02d93dc)('Query.once', 'eventType') + 'must be a valid event type = "value", "child_added", "child_removed", ' + '"child_changed", or "child_moved".');
        }
        return deferred.promise;
    }
    /**
     * Set a limit and anchor it to the start of the window.
     */ limitToFirst(limit) {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('Query.limitToFirst', 1, 1, arguments.length);
        return new $407d7e9e8165099c$var$Query(this.database, (0, $9cf0852385f62d16$export$2fa187e846a241c4)(this._delegate, (0, $9cf0852385f62d16$export$9d02e839f813b99d)(limit)));
    }
    /**
     * Set a limit and anchor it to the end of the window.
     */ limitToLast(limit) {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('Query.limitToLast', 1, 1, arguments.length);
        return new $407d7e9e8165099c$var$Query(this.database, (0, $9cf0852385f62d16$export$2fa187e846a241c4)(this._delegate, (0, $9cf0852385f62d16$export$f823b3589f69d3b8)(limit)));
    }
    /**
     * Given a child path, return a new query ordered by the specified grandchild path.
     */ orderByChild(path) {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('Query.orderByChild', 1, 1, arguments.length);
        return new $407d7e9e8165099c$var$Query(this.database, (0, $9cf0852385f62d16$export$2fa187e846a241c4)(this._delegate, (0, $9cf0852385f62d16$export$5162bd9025f8e144)(path)));
    }
    /**
     * Return a new query ordered by the KeyIndex
     */ orderByKey() {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('Query.orderByKey', 0, 0, arguments.length);
        return new $407d7e9e8165099c$var$Query(this.database, (0, $9cf0852385f62d16$export$2fa187e846a241c4)(this._delegate, (0, $9cf0852385f62d16$export$d5ab8b3bbd8afbf8)()));
    }
    /**
     * Return a new query ordered by the PriorityIndex
     */ orderByPriority() {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('Query.orderByPriority', 0, 0, arguments.length);
        return new $407d7e9e8165099c$var$Query(this.database, (0, $9cf0852385f62d16$export$2fa187e846a241c4)(this._delegate, (0, $9cf0852385f62d16$export$19e8ae5500cf2e55)()));
    }
    /**
     * Return a new query ordered by the ValueIndex
     */ orderByValue() {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('Query.orderByValue', 0, 0, arguments.length);
        return new $407d7e9e8165099c$var$Query(this.database, (0, $9cf0852385f62d16$export$2fa187e846a241c4)(this._delegate, (0, $9cf0852385f62d16$export$7f2f62793c39d0c0)()));
    }
    startAt(value = null, name) {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('Query.startAt', 0, 2, arguments.length);
        return new $407d7e9e8165099c$var$Query(this.database, (0, $9cf0852385f62d16$export$2fa187e846a241c4)(this._delegate, (0, $9cf0852385f62d16$export$859941c5fc8eba6b)(value, name)));
    }
    startAfter(value = null, name) {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('Query.startAfter', 0, 2, arguments.length);
        return new $407d7e9e8165099c$var$Query(this.database, (0, $9cf0852385f62d16$export$2fa187e846a241c4)(this._delegate, (0, $9cf0852385f62d16$export$dd8dee5f7b804673)(value, name)));
    }
    endAt(value = null, name) {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('Query.endAt', 0, 2, arguments.length);
        return new $407d7e9e8165099c$var$Query(this.database, (0, $9cf0852385f62d16$export$2fa187e846a241c4)(this._delegate, (0, $9cf0852385f62d16$export$28ec54a8428bdb3f)(value, name)));
    }
    endBefore(value = null, name) {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('Query.endBefore', 0, 2, arguments.length);
        return new $407d7e9e8165099c$var$Query(this.database, (0, $9cf0852385f62d16$export$2fa187e846a241c4)(this._delegate, (0, $9cf0852385f62d16$export$57203950645b8b11)(value, name)));
    }
    /**
     * Load the selection of children with exactly the specified value, and, optionally,
     * the specified name.
     */ equalTo(value, name) {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('Query.equalTo', 1, 2, arguments.length);
        return new $407d7e9e8165099c$var$Query(this.database, (0, $9cf0852385f62d16$export$2fa187e846a241c4)(this._delegate, (0, $9cf0852385f62d16$export$bdcdec1f91f16dff)(value, name)));
    }
    /**
     * @returns URL for this location.
     */ toString() {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('Query.toString', 0, 0, arguments.length);
        return this._delegate.toString();
    }
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users.
    toJSON() {
        // An optional spacer argument is unnecessary for a string.
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('Query.toJSON', 0, 1, arguments.length);
        return this._delegate.toJSON();
    }
    /**
     * Return true if this query and the provided query are equivalent; otherwise, return false.
     */ isEqual(other) {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('Query.isEqual', 1, 1, arguments.length);
        if (!(other instanceof $407d7e9e8165099c$var$Query)) {
            const error = 'Query.isEqual failed: First argument must be an instance of firebase.database.Query.';
            throw new Error(error);
        }
        return this._delegate.isEqual(other._delegate);
    }
    /**
     * Helper used by .on and .once to extract the context and or cancel arguments.
     * @param fnName - The function name (on or once)
     *
     */ static getCancelAndContextArgs_(fnName, cancelOrContext, context) {
        const ret = {
            cancel: undefined,
            context: undefined
        };
        if (cancelOrContext && context) {
            ret.cancel = cancelOrContext;
            (0, $3117f6f4eeb4c314$export$5bcd2a2eb6640dfa)(fnName, 'cancel', ret.cancel, true);
            ret.context = context;
            (0, $3117f6f4eeb4c314$export$df77539402cfb523)(fnName, 'context', ret.context, true);
        } else if (cancelOrContext) {
            // we have either a cancel callback or a context.
            if (typeof cancelOrContext === 'object' && cancelOrContext !== null) // it's a context!
            ret.context = cancelOrContext;
            else if (typeof cancelOrContext === 'function') ret.cancel = cancelOrContext;
            else throw new Error((0, $3117f6f4eeb4c314$export$adea4917e02d93dc)(fnName, 'cancelOrContext') + ' must either be a cancel callback or a context object.');
        }
        return ret;
    }
    get ref() {
        return new $407d7e9e8165099c$var$Reference(this.database, new (0, $9cf0852385f62d16$export$35c3a5e7c9d1033c)(this._delegate._repo, this._delegate._path));
    }
}
class $407d7e9e8165099c$var$Reference extends $407d7e9e8165099c$var$Query {
    /**
     * Call options:
     *   new Reference(Repo, Path) or
     *   new Reference(url: string, string|RepoManager)
     *
     * Externally - this is the firebase.database.Reference type.
     */ constructor(database, _delegate){
        super(database, new (0, $9cf0852385f62d16$export$e79c8d837d2220a8)(_delegate._repo, _delegate._path, new (0, $9cf0852385f62d16$export$7ba287e361c94330)(), false));
        this.database = database;
        this._delegate = _delegate;
    }
    /** @returns {?string} */ getKey() {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('Reference.key', 0, 0, arguments.length);
        return this._delegate.key;
    }
    child(pathString) {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('Reference.child', 1, 1, arguments.length);
        if (typeof pathString === 'number') pathString = String(pathString);
        return new $407d7e9e8165099c$var$Reference(this.database, (0, $9cf0852385f62d16$export$f9574b70e1d95d9d)(this._delegate, pathString));
    }
    /** @returns {?Reference} */ getParent() {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('Reference.parent', 0, 0, arguments.length);
        const parent = this._delegate.parent;
        return parent ? new $407d7e9e8165099c$var$Reference(this.database, parent) : null;
    }
    /** @returns {!Reference} */ getRoot() {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('Reference.root', 0, 0, arguments.length);
        return new $407d7e9e8165099c$var$Reference(this.database, this._delegate.root);
    }
    set(newVal, onComplete) {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('Reference.set', 1, 2, arguments.length);
        (0, $3117f6f4eeb4c314$export$5bcd2a2eb6640dfa)('Reference.set', 'onComplete', onComplete, true);
        const result = (0, $9cf0852385f62d16$export$adaa4cf7ef1b65be)(this._delegate, newVal);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    update(values, onComplete) {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('Reference.update', 1, 2, arguments.length);
        if (Array.isArray(values)) {
            const newObjectToMerge = {};
            for(let i = 0; i < values.length; ++i)newObjectToMerge['' + i] = values[i];
            values = newObjectToMerge;
            $407d7e9e8165099c$var$warn("Passing an Array to Firebase.update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.");
        }
        (0, $9cf0852385f62d16$export$8d83036122ae444e)('Reference.update', this._delegate._path);
        (0, $3117f6f4eeb4c314$export$5bcd2a2eb6640dfa)('Reference.update', 'onComplete', onComplete, true);
        const result = (0, $9cf0852385f62d16$export$722fbec263ad908a)(this._delegate, values);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    setWithPriority(newVal, newPriority, onComplete) {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('Reference.setWithPriority', 2, 3, arguments.length);
        (0, $3117f6f4eeb4c314$export$5bcd2a2eb6640dfa)('Reference.setWithPriority', 'onComplete', onComplete, true);
        const result = (0, $9cf0852385f62d16$export$1fa5d5bf488088f3)(this._delegate, newVal, newPriority);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    remove(onComplete) {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('Reference.remove', 0, 1, arguments.length);
        (0, $3117f6f4eeb4c314$export$5bcd2a2eb6640dfa)('Reference.remove', 'onComplete', onComplete, true);
        const result = (0, $9cf0852385f62d16$export$cd7f480d6b8286c3)(this._delegate);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    transaction(transactionUpdate, onComplete, applyLocally) {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('Reference.transaction', 1, 3, arguments.length);
        (0, $3117f6f4eeb4c314$export$5bcd2a2eb6640dfa)('Reference.transaction', 'transactionUpdate', transactionUpdate, false);
        (0, $3117f6f4eeb4c314$export$5bcd2a2eb6640dfa)('Reference.transaction', 'onComplete', onComplete, true);
        $407d7e9e8165099c$var$validateBoolean('Reference.transaction', 'applyLocally', applyLocally, true);
        const result = (0, $9cf0852385f62d16$export$3c54e006bf9c93b7)(this._delegate, transactionUpdate, {
            applyLocally: applyLocally
        }).then((transactionResult)=>new $407d7e9e8165099c$var$TransactionResult(transactionResult.committed, new $407d7e9e8165099c$var$DataSnapshot(this.database, transactionResult.snapshot)));
        if (onComplete) result.then((transactionResult)=>onComplete(null, transactionResult.committed, transactionResult.snapshot), (error)=>onComplete(error, false, null));
        return result;
    }
    setPriority(priority, onComplete) {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('Reference.setPriority', 1, 2, arguments.length);
        (0, $3117f6f4eeb4c314$export$5bcd2a2eb6640dfa)('Reference.setPriority', 'onComplete', onComplete, true);
        const result = (0, $9cf0852385f62d16$export$313bf5dbe7a1196e)(this._delegate, priority);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    push(value, onComplete) {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('Reference.push', 0, 2, arguments.length);
        (0, $3117f6f4eeb4c314$export$5bcd2a2eb6640dfa)('Reference.push', 'onComplete', onComplete, true);
        const expPromise = (0, $9cf0852385f62d16$export$4cbf152802aa238)(this._delegate, value);
        const promise = expPromise.then((expRef)=>new $407d7e9e8165099c$var$Reference(this.database, expRef));
        if (onComplete) promise.then(()=>onComplete(null), (error)=>onComplete(error));
        const result = new $407d7e9e8165099c$var$Reference(this.database, expPromise);
        result.then = promise.then.bind(promise);
        result.catch = promise.catch.bind(promise, undefined);
        return result;
    }
    onDisconnect() {
        (0, $9cf0852385f62d16$export$8d83036122ae444e)('Reference.onDisconnect', this._delegate._path);
        return new $407d7e9e8165099c$var$OnDisconnect(new (0, $9cf0852385f62d16$export$95b7818b4ee6c2af)(this._delegate._repo, this._delegate._path));
    }
    get key() {
        return this.getKey();
    }
    get parent() {
        return this.getParent();
    }
    get root() {
        return this.getRoot();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Class representing a firebase database.
 */ class $407d7e9e8165099c$var$Database {
    /**
     * The constructor should not be called by users of our public API.
     */ constructor(_delegate, app){
        this._delegate = _delegate;
        this.app = app;
        this.INTERNAL = {
            delete: ()=>this._delegate._delete(),
            forceWebSockets: $9cf0852385f62d16$export$752b38c15a5377b6,
            forceLongPolling: $9cf0852385f62d16$export$387cff57f2608869
        };
    }
    /**
     * Modify this instance to communicate with the Realtime Database emulator.
     *
     * <p>Note: This method must be called before performing any other operation.
     *
     * @param host - the emulator host (ex: localhost)
     * @param port - the emulator port (ex: 8080)
     * @param options.mockUserToken - the mock auth token to use for unit testing Security Rules
     */ useEmulator(host, port, options = {}) {
        (0, $9cf0852385f62d16$export$87f3cfc4a2e3958d)(this._delegate, host, port, options);
    }
    ref(path) {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('database.ref', 0, 1, arguments.length);
        if (path instanceof $407d7e9e8165099c$var$Reference) {
            const childRef = (0, $9cf0852385f62d16$export$291fc3c05735451)(this._delegate, path.toString());
            return new $407d7e9e8165099c$var$Reference(this, childRef);
        } else {
            const childRef = (0, $9cf0852385f62d16$export$eff4d24c3ff7876e)(this._delegate, path);
            return new $407d7e9e8165099c$var$Reference(this, childRef);
        }
    }
    /**
     * Returns a reference to the root or the path specified in url.
     * We throw a exception if the url is not in the same domain as the
     * current repo.
     * @returns Firebase reference.
     */ refFromURL(url) {
        const apiName = 'database.refFromURL';
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)(apiName, 1, 1, arguments.length);
        const childRef = (0, $9cf0852385f62d16$export$291fc3c05735451)(this._delegate, url);
        return new $407d7e9e8165099c$var$Reference(this, childRef);
    }
    // Make individual repo go offline.
    goOffline() {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('database.goOffline', 0, 0, arguments.length);
        return (0, $9cf0852385f62d16$export$bee838355d017f0a)(this._delegate);
    }
    goOnline() {
        (0, $3117f6f4eeb4c314$export$20164226a0ed35c3)('database.goOnline', 0, 0, arguments.length);
        return (0, $9cf0852385f62d16$export$e0eecaabee32dd)(this._delegate);
    }
}
$407d7e9e8165099c$var$Database.ServerValue = {
    TIMESTAMP: (0, $9cf0852385f62d16$export$3ff8e7e00c3264b7)(),
    increment: (delta)=>(0, $9cf0852385f62d16$export$a2647aa13413c947)(delta)
};
/**
 * Used by console to create a database based on the app,
 * passed database URL and a custom auth implementation.
 *
 * @param app - A valid FirebaseApp-like object
 * @param url - A valid Firebase databaseURL
 * @param version - custom version e.g. firebase-admin version
 * @param customAuthImpl - custom auth implementation
 */ function $407d7e9e8165099c$var$initStandalone({ app: app, url: url, version: version, customAuthImpl: customAuthImpl, customAppCheckImpl: customAppCheckImpl, namespace: namespace, nodeAdmin: nodeAdmin = false }) {
    (0, $9cf0852385f62d16$export$c9fb972242fcb3c4)(version);
    const container = new (0, $ad76b76e741ec0c7$export$436a80eea5d5c0c5)('database-standalone');
    /**
     * ComponentContainer('database-standalone') is just a placeholder that doesn't perform
     * any actual function.
     */ const authProvider = new (0, $ad76b76e741ec0c7$export$2881499e37b75b9a)('auth-internal', container);
    authProvider.setComponent(new (0, $ad76b76e741ec0c7$export$16fa2f45be04daa8)('auth-internal', ()=>customAuthImpl, "PRIVATE" /* ComponentType.PRIVATE */ ));
    let appCheckProvider = undefined;
    if (customAppCheckImpl) {
        appCheckProvider = new (0, $ad76b76e741ec0c7$export$2881499e37b75b9a)('app-check-internal', container);
        appCheckProvider.setComponent(new (0, $ad76b76e741ec0c7$export$16fa2f45be04daa8)('app-check-internal', ()=>customAppCheckImpl, "PRIVATE" /* ComponentType.PRIVATE */ ));
    }
    return {
        instance: new $407d7e9e8165099c$var$Database((0, $9cf0852385f62d16$export$a248c1d2ea757674)(app, authProvider, appCheckProvider, url, nodeAdmin), app),
        namespace: namespace
    };
}
var $407d7e9e8165099c$var$INTERNAL = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    initStandalone: $407d7e9e8165099c$var$initStandalone
});
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $407d7e9e8165099c$var$ServerValue = $407d7e9e8165099c$var$Database.ServerValue;
function $407d7e9e8165099c$export$44894f2caba7dc4c(instance) {
    // Register the Database Service with the 'firebase' namespace.
    instance.INTERNAL.registerComponent(new (0, $ad76b76e741ec0c7$export$16fa2f45be04daa8)('database-compat', (container, { instanceIdentifier: url })=>{
        /* Dependencies */ // getImmediate for FirebaseApp will always succeed
        const app = container.getProvider('app-compat').getImmediate();
        const databaseExp = container.getProvider('database').getImmediate({
            identifier: url
        });
        return new $407d7e9e8165099c$var$Database(databaseExp, app);
    }, "PUBLIC" /* ComponentType.PUBLIC */ ).setServiceProps(// firebase.database namespace properties
    {
        Reference: $407d7e9e8165099c$var$Reference,
        Query: $407d7e9e8165099c$var$Query,
        Database: $407d7e9e8165099c$var$Database,
        DataSnapshot: $407d7e9e8165099c$var$DataSnapshot,
        enableLogging: $9cf0852385f62d16$export$4e1d237eb9e560af,
        INTERNAL: $407d7e9e8165099c$var$INTERNAL,
        ServerValue: $407d7e9e8165099c$var$ServerValue
    }).setMultipleInstances(true));
    instance.registerVersion($407d7e9e8165099c$var$name, $407d7e9e8165099c$var$version);
}
$407d7e9e8165099c$export$44894f2caba7dc4c((0, $42ddf94e6f3c0a26$export$2e2bcd8739ae039));




/* Speech to text handler object.
 * Wraps the browser's SpeechRecognition with some useful methods. */ class $bb4d3f4172bdb318$export$2e2bcd8739ae039 {
    constructor(){
        this.recognition = $bb4d3f4172bdb318$export$2e2bcd8739ae039.getBrowserSpeechRecognitionObject();
        this.listening = false;
        this.resultListener = null;
        this.endListener = null;
        this.isSupported = this.isSupported.bind(this);
        this.startListening = this.startListening.bind(this);
        this.internalStartListening = this.internalStartListening.bind(this);
        this.stopListening = this.stopListening.bind(this);
        this.resultHandler = this.resultHandler.bind(this);
        this.endHandler = this.endHandler.bind(this);
        if (this.recognition) {
            this.recognition.onresult = this.resultHandler;
            this.recognition.onend = this.endHandler;
        }
    }
    isSupported() {
        return this.recognition !== null;
    }
    static getBrowserSpeechRecognitionObject() {
        const SpeechRec = typeof window !== 'undefined' && (window.SpeechRecognition || window.webkitSpeechRecognition || window.mozSpeechRecognition || window.msSpeechRecognition || window.oSpeechRecognition);
        // Consider as unavailable for Chrome on Android and iOS as it does not work through browser.
        // The system based STT has preference.
        const chromeMobile = navigator.userAgent.indexOf('Chrome') !== -1 && navigator.userAgent.indexOf('Android') !== -1 && !navigator.userAgent.match(/iPhone|iPod|iPad/);
        if (SpeechRec && !chromeMobile) {
            var recognition = new SpeechRec();
            recognition.continuous = true;
            recognition.interimResults = true;
            return recognition;
        } else {
            console.warn('SpeechRecognition is not supported by this browser.');
            return null;
        }
    }
    startListening(resultListener, endListener) {
        if (this.listening) {
            // If already listening, have to call stop, and then only start the new listener after we've received
            // confirmation that the previous listening session is actually stopped.
            console.log("Restarting STT in another place");
            this.recognition.onend = (event)=>{
                this.endHandler(event);
                this.internalStartListening(resultListener, endListener);
                this.recognition.onend = this.endHandler;
            };
            this.recognition.stop();
        } else {
            console.log("Starting STT");
            // clean start
            this.internalStartListening(resultListener, endListener);
        }
    }
    internalStartListening(resultListener, endListener) {
        this.listening = true;
        this.resultListener = resultListener;
        this.endListener = endListener;
        this.recognition.start();
    }
    stopListening() {
        console.log("Stopping STT");
        this.recognition.stop();
    }
    quit() {
        if (this.listening) {
            this.recognition.abort();
            this.listening = false;
        }
    }
    resultHandler(event) {
        if (this.resultListener) this.resultListener(event);
    }
    endHandler(event) {
        if (this.endListener) this.endListener(event);
        this.endListener = null;
        this.listening = false;
    }
}


var $9beff9bd740cb2a0$exports = {};
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof $9beff9bd740cb2a0$exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    $9beff9bd740cb2a0$exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : $9beff9bd740cb2a0$exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});


window.jQuery = window.$ = (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)));
/*!
 * Figuration (v4.4.1)
 * https://figuration.org
 * Copyright 2013-2024 CAST, Inc.
 * Licensed under MIT (https://github.com/cast-org/figuration/blob/master/LICENSE)
 * -----
 * Portions Copyright 2011-2024 The Bootstrap Authors
 * Used under MIT License (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */ if (typeof jQuery === 'undefined') throw new Error('CAST Figuration\'s JavaScript requires jQuery');
(function($) {
    var version = $.fn.jquery.split(' ')[0].split('.');
    if (version[0] < 2 && version[1] < 9 || version[0] == 1 && version[1] == 9 && version[2] < 1 || version[0] >= 4) throw new Error('CAST Figuration\'s JavaScript requires at least jQuery v1.9.1 but less than v4.0.0');
})(jQuery);
/**
 * --------------------------------------------------------------------------
 * Figuration (v4.4.1): util/backdrop.js
 * Licensed under MIT (https://github.com/cast-org/figuration/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ (function($) {
    'use strict';
    var CFW_Util_Backdrop = function(options) {
        this.element = null;
        this.isAppended = false;
        this.settings = $.extend({}, CFW_Util_Backdrop.DEFAULTS, options);
        this._init();
    };
    CFW_Util_Backdrop.DEFAULTS = {
        className: 'modal-backdrop',
        isVisible: true,
        isAnimated: false,
        rootElement: 'body',
        clickCallback: null
    };
    CFW_Util_Backdrop.prototype = {
        _init: function() {
            // Update rootElement in case of DOM change
            this.settings.rootElement = $.CFW_getElement(this.settings.rootElement);
        },
        show: function(callback) {
            var $selfRef = this;
            if (!this.settings.isVisible) {
                this._execute(callback);
                return;
            }
            this._append();
            if (this.settings.isAnimated) $.CFW_reflow(this.element); // Reflow for transition
            this.element.classList.add('in');
            var complete = function() {
                $selfRef._execute(callback);
            };
            $(this.element).CFW_transition(null, complete);
        },
        hide: function(callback) {
            var $selfRef = this;
            if (!this.settings.isVisible) {
                this._execute(callback);
                return;
            }
            this._getBackdrop().classList.remove('in');
            var complete = function() {
                $selfRef.dispose();
                $selfRef._execute(callback);
            };
            $(this.element).CFW_transition(null, complete);
        },
        dispose: function() {
            if (!this.isAppended) return;
            $(this.element).off('mousedown.cfw.backdrop');
            $(this.element).remove();
            this.isAppended = false;
        },
        _getBackdrop: function() {
            if (!this.element) {
                var backdrop = document.createElement('div');
                backdrop.className = this.settings.className;
                if (this.settings.isAnimated) backdrop.classList.add('fade');
                this.element = backdrop;
            }
            return this.element;
        },
        _append: function() {
            var $selfRef = this;
            if (this.isAppended) return;
            $(this.settings.rootElement).append(this._getBackdrop());
            $(this._getBackdrop()).on('mousedown.cfw.backdrop', function() {
                $selfRef._execute($selfRef.settings.clickCallback);
            });
            this.isAppended = true;
        },
        _execute: function(callback) {
            if (typeof callback === 'function') callback();
        }
    };
    window.CFW_Backdrop = CFW_Util_Backdrop;
})(jQuery);
/**
 * --------------------------------------------------------------------------
 * Figuration (v4.4.1): util/focuser.js
 * Licensed under MIT (https://github.com/cast-org/figuration/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ (function($) {
    'use strict';
    var KEYCODE_TAB = 9;
    var NAV_DIR_FORWARD = 'forward';
    var NAV_DIR_BACKWARD = 'backward';
    var CFW_Util_Focuser = function(options) {
        this._instance = null;
        this._isActive = false;
        this._lastNavDirection = null;
        this.settings = $.extend({}, CFW_Util_Focuser.DEFAULTS, options);
        this._init();
    };
    CFW_Util_Focuser.DEFAULTS = {
        element: null,
        autoFocus: true,
        flowElement: null,
        flowFocus: false
    };
    CFW_Util_Focuser.prototype = {
        _init: function() {
            this._instance = $(this.settings.element).CFW_getID('cfw-focuser');
        },
        activate: function() {
            if (this._isActive) return;
            if (this.settings.autoFocus) this.settings.element.focus();
            this._eventsOff();
            $(this.settings.element).on('keydown.cfw.focuser.' + this._instance, this._handleKeydown.bind(this));
            $(document).on('focusin.cfw.focuser.' + this._instance, this._focusInvoke.bind(this));
            if (this.settings.flowFocus) {
                $(this.settings.flowElement).on('keydown.cfw.focuser.' + this._instance, this._handleFlowElement.bind(this));
                $(this.settings.flowElement).on('focusin.cfw.focuser.' + this._instance, this._handleFlowElement.bind(this));
            }
            this._isActive = true;
        },
        deactivate: function() {
            if (!this._isActive) return;
            this._isActive = false;
            this._eventsOff();
        },
        _eventsOff: function() {
            $(document).off('.cfw.focuser.' + this._instance);
            $(this.settings.element).off('.cfw.focuser.' + this._instance);
            if (this.settings.flowFocus) $(this.settings.flowElement).off('.cfw.focuser.' + this._instance);
        },
        _focusInvoke: function(event) {
            if (this.settings.flowFocus) this._focusFlow(event);
            else this._focusTrap(event);
        },
        _focusFlow: function(event) {
            var target = event.target;
            var element = this.settings.element;
            var flowElement = this.settings.flowElement;
            var isBackward = this._lastNavDirection === NAV_DIR_BACKWARD;
            if (event.type === 'focusin' && (target === document || target === element || element.contains(target))) return;
            var itemsRaw = $.CFW_getFocusable(element);
            var items = $.CFW_slimRadioInput(itemsRaw, isBackward);
            if (items.length === 0) // Dialog container
            element.focus();
            else if (event.type === 'keydown') {
                if (target === items[0] && isBackward) {
                    // Trigger element
                    event.preventDefault();
                    flowElement.focus();
                } else if ((target === items[items.length - 1] || target === itemsRaw[itemsRaw.length - 1]) && !isBackward) {
                    // Focusable elements after trigger
                    event.preventDefault();
                    var extItems = $.CFW_getFocusable(document.body);
                    // Remove items from inside element
                    extItems = extItems.filter(function(extItem) {
                        return !element.contains(extItem);
                    });
                    // 'Trim' radio inputs
                    extItems = $.CFW_slimRadioInput(extItems, false);
                    $.CFW_getNextActiveElement(extItems, flowElement, true, true, false).focus();
                }
            }
        },
        _focusTrap: function(event) {
            var target = event.target;
            var element = this.settings.element;
            var isBackward = this._lastNavDirection === NAV_DIR_BACKWARD;
            if (event.type === 'focusin' && (target === document || target === element || element.contains(target))) return;
            var itemsRaw = $.CFW_getFocusable(element);
            var items = $.CFW_slimRadioInput(itemsRaw, isBackward);
            if (items.length === 0) element.focus();
            else if (event.type === 'keydown') {
                if (target === items[0] && isBackward) {
                    event.preventDefault();
                    items[items.length - 1].focus();
                } else if ((target === items[items.length - 1] || target === itemsRaw[itemsRaw.length - 1]) && !isBackward) {
                    event.preventDefault();
                    items[0].focus();
                }
            } else $.CFW_getNextActiveElement(items, target, !isBackward, true, true).focus();
        },
        _handleKeydown: function(event) {
            if (event.which !== KEYCODE_TAB) return;
            this._lastNavDirection = event.shiftKey ? NAV_DIR_BACKWARD : NAV_DIR_FORWARD;
            // Possibly intercept the keypress to stop from leaving document
            this._focusInvoke(event);
        },
        _handleFlowElement: function(event) {
            var element = this.settings.element;
            var items = $.CFW_getFocusable(element);
            if (event.type === 'keydown') {
                if (event.which === KEYCODE_TAB && !event.shiftKey) {
                    event.preventDefault();
                    items = $.CFW_slimRadioInput(items, false);
                    if (items.length === 0) element.focus();
                    else items[0].focus();
                }
            } else {
                var prevNode = event.relatedTarget || null;
                // Edge case: if coming from another tooltip/popover
                if ($(prevNode).closest('.tooltip, .popover').length) prevNode = null;
                if (prevNode) {
                    // If navigating backwards onto trigger (flowElement), try to focus at end of element
                    var docItems = $.CFW_getFocusable(document.body);
                    if (docItems.indexOf(this.settings.flowElement) < docItems.indexOf(prevNode)) {
                        items = $.CFW_slimRadioInput(items, true);
                        if (items.length === 0) element.focus();
                        else $.CFW_getNextActiveElement(items, items[0], false, true, true).focus();
                    }
                }
            }
        }
    };
    window.CFW_Focuser = CFW_Util_Focuser;
})(jQuery);
/**
 * --------------------------------------------------------------------------
 * Figuration (v4.4.1): util/scrollbar.js
 * Licensed under MIT (https://github.com/cast-org/figuration/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ (function($) {
    'use strict';
    var SELECTOR_CONTENT_FIXED = '.fixed-top, .fixed-bottom, .is-fixed';
    var SELECTOR_CONTENT_STICKY = '.sticky-top, .sticky-bottom, .is-sticky';
    var SELECTOR_CONTENT_SHARED = [
        SELECTOR_CONTENT_FIXED,
        SELECTOR_CONTENT_STICKY
    ].join(', ');
    var CFW_Util_Scrollbar = function(options) {
        this.element = null;
        this._isActive = false;
        this.scrollbarWidth = null;
        this.settings = $.extend({}, CFW_Util_Scrollbar.DEFAULTS, options);
        this._init();
    };
    CFW_Util_Scrollbar.DEFAULTS = {
        rootElement: 'body'
    };
    CFW_Util_Scrollbar.prototype = {
        _init: function() {
            this.element = $.CFW_getElement(this.settings.rootElement);
        },
        getContainerWidth: function() {
            // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
            if (this.element === document.body) return window.innerWidth;
            // Subtract border width from element
            var borderStart = parseFloat(window.getComputedStyle(this.element).getPropertyValue('border-left-width'));
            var borderEnd = parseFloat(window.getComputedStyle(this.element).getPropertyValue('border-right-width'));
            return this.element.offsetWidth - borderStart - borderEnd;
        },
        getContentWidth: function() {
            return this.element === document.body ? document.documentElement.clientWidth : this.element.clientWidth;
        },
        getScrollbarWidth: function() {
            return Math.abs(this.getContainerWidth() - this.getContentWidth());
        },
        getScrollbarSide: function() {
            // Unable to detect side when 0-width scrollbars (such as mobile)
            // are found.  So we use 'right` side as default (more common case).
            var isHTML = this.element === document.documentElement;
            var isEdge = /edge\/\d+/i.test(navigator.userAgent);
            var isIE = /(msie|trident)/i.test(navigator.userAgent);
            if (!isHTML || isEdge || isIE) return $.CFW_isRTL(this.element) ? 'left' : 'right';
            return 'right';
        },
        isOverflowing: function() {
            return this.getScrollbarWidth() > 0;
        },
        disable: function() {
            if (this._isActive) return;
            var $selfRef = this;
            this.scrollbarWidth = this.getScrollbarWidth();
            var paddingCalc = function(calculatedVal) {
                var newWidth = parseFloat(calculatedVal) + $selfRef.scrollbarWidth;
                return newWidth + 'px';
            };
            var marginCalc = function(calculatedVal) {
                var newWidth = parseFloat(calculatedVal) - $selfRef.scrollbarWidth;
                return newWidth + 'px';
            };
            var side = this.getScrollbarSide();
            // Update rootElement overflow and padding
            this._disableOverflow();
            this._setScrollbarAdjustment(this.element, 'padding-' + side, paddingCalc);
            // Update fixed/sticky positioned element padding
            $(this.element).find(SELECTOR_CONTENT_SHARED).each(function() {
                if ($selfRef._isFixed(this) || $selfRef._isSticky(this)) $selfRef._setScrollbarAdjustment(this, 'padding-' + side, paddingCalc);
            });
            // Update sticky positioned element margin
            $(this.element).find(SELECTOR_CONTENT_STICKY).each(function() {
                if ($selfRef._isSticky(this)) $selfRef._setScrollbarAdjustment(this, 'margin-' + side, marginCalc);
            });
            this._isActive = true;
        },
        reset: function() {
            if (!this._isActive) return;
            var $selfRef = this;
            var side = this.getScrollbarSide();
            this._resetScrollbarAdjustment(this.element, 'overflow');
            this._resetScrollbarAdjustment(this.element, 'overflow-y');
            this._resetScrollbarAdjustment(this.element, 'overflow-x');
            this._resetScrollbarAdjustment(this.element, 'padding-' + side);
            $(this.element).find(SELECTOR_CONTENT_SHARED).each(function() {
                $selfRef._resetScrollbarAdjustment(this, 'padding-' + side);
            });
            $(this.element).find(SELECTOR_CONTENT_STICKY).each(function() {
                $selfRef._resetScrollbarAdjustment(this, 'margin-' + side);
            });
            this.scrollbarWidth = null;
            this._isActive = false;
        },
        _saveInitialAttribute: function(node, property) {
            var actualVal = node.style.getPropertyValue(property);
            if (actualVal) node.setAttribute('data-cfw-' + property, actualVal);
        },
        _setScrollbarAdjustment: function(node, property, callback) {
            if (node !== this.element && this.getContainerWidth() > node.clientWidth + this.scrollbarWidth) return;
            this._saveInitialAttribute(node, property);
            var calculatedVal = window.getComputedStyle(node).getPropertyValue(property);
            node.style.setProperty(property, typeof callback === 'function' ? callback(calculatedVal) : callback);
        },
        _resetScrollbarAdjustment: function(node, property) {
            var savedVal = this._normalizeData(node.getAttribute('data-cfw-' + property));
            if (savedVal === null) node.style.removeProperty(property);
            node.removeAttribute('data-cfw-' + property);
            node.style.setProperty(property, savedVal);
        },
        _disableOverflow: function() {
            this._saveInitialAttribute(this.element, 'overflow');
            this._saveInitialAttribute(this.element, 'overflow-y');
            this._saveInitialAttribute(this.element, 'overflow-x');
            this.element.style.overflow = 'hidden';
        },
        _isFixed: function(node) {
            return Boolean(window.getComputedStyle(node).position === 'fixed');
        },
        _isSticky: function(node) {
            return Boolean(window.getComputedStyle(node).position === 'sticky');
        },
        _normalizeData: function(val) {
            if (val === 'true') return true;
            if (val === 'false') return false;
            if (val === Number(val).toString()) return Number(val);
            if (val === '' || val === 'null') return null;
            return val;
        }
    };
    window.CFW_Scrollbar = CFW_Util_Scrollbar;
})(jQuery);
/**
 * --------------------------------------------------------------------------
 * Figuration (v4.4.1): util.js
 * Licensed under MIT (https://github.com/cast-org/figuration/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ (function($) {
    'use strict';
    // =====
    // Private util helpers
    // =====
    /* eslint-disable-next-line no-extend-native */ String.prototype.capitalize = function() {
        return this.charAt(0).toUpperCase() + this.slice(1);
    };
    var doCallback = function(callback) {
        if (callback) callback();
    };
    // =====
    // TransitionEnd support/emulation
    // =====
    var transition = false;
    var TRANSITION_END = 'cfwTransitionEnd';
    var CFW_transitionEndTest = function() {
        var div = document.createElement('div');
        var transitionEndEvents = {
            transition: 'transitionend',
            MozTransition: 'transitionend',
            OTransition: 'oTransitionEnd otransitionend',
            WebkitTransition: 'webkitTransitionEnd'
        };
        // Test for browser specific event name to bind
        for(var eventName in transitionEndEvents){
            if (typeof div.style[eventName] !== 'undefined') return {
                end: transitionEndEvents[eventName]
            };
        }
        // No browser transitionEnd support - use custom event name
        return {
            end: TRANSITION_END
        };
    };
    // Get longest CSS transition duration
    var CFW_transitionCssDuration = function($node) {
        var timeArray = [
            0
        ]; // Set a min value -- otherwise get `Infinity`
        var MILLISECONDS_MULTIPLIER = 1000;
        var DURATION_PRECISION = 2;
        $node.each(function() {
            var $this = $(this);
            var transitionDuration = $this.css('transition-duration');
            var transitionDelay = $this.css('transition-delay');
            if (transitionDuration && transitionDelay) {
                var durations = transitionDuration.split(',');
                var delays = transitionDelay.split(',');
                for(var i = durations.length; i--;)timeArray = timeArray.concat(parseFloat(durations[i]) + parseFloat(delays[i]));
            }
        });
        var duration = Math.max.apply(Math, timeArray); // http://stackoverflow.com/a/1379560
        return duration.toPrecision(DURATION_PRECISION) * MILLISECONDS_MULTIPLIER; // convert to milliseconds
    };
    var CFW_transitionEndEmulate = function(start, complete) {
        var duration = CFW_transitionCssDuration(this);
        if (duration) {
            var called = false;
            this.one(TRANSITION_END, function() {
                if (!called) {
                    called = true;
                    doCallback(complete);
                }
            });
            // Set timeout as fallback for instances where transitionEnd is not called.
            // This way the complete callback is always executed.
            setTimeout(function() {
                if (!called) {
                    called = true;
                    doCallback(complete);
                }
            }, duration);
            doCallback(start);
        } else {
            doCallback(start);
            doCallback(complete);
        }
        return this;
    };
    var CFW_transitionEndSpecial = function() {
        return {
            bindType: transition.end,
            delegateType: transition.end,
            handle: function(e) {
                if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments);
                return undefined; /* eslint-disable-line no-undefined */ 
            }
        };
    };
    transition = CFW_transitionEndTest();
    $.fn.CFW_transitionDuration = CFW_transitionCssDuration;
    $.fn.CFW_transition = CFW_transitionEndEmulate;
    $.event.special[TRANSITION_END] = CFW_transitionEndSpecial();
    // =====
    // Touch Detection
    // =====
    // Includes touch recognition fix for IE11
    // Partially from: https://github.com/Modernizr/Modernizr/blob/master/feature-detects/touchevents.js
    /* global DocumentTouch */ var msTouch = typeof window.navigator.msMaxTouchPoints === 'undefined' ? false : window.navigator.msMaxTouchPoints;
    var isTouch = false;
    if ('ontouchstart' in window || msTouch || window.DocumentTouch && document instanceof DocumentTouch) isTouch = true;
    $.CFW_isTouch = isTouch;
    // =====
    // Mutation Helper
    // =====
    // Not available in IE 10-, need a polyfill
    var CFW_MutationObserverTest = function() {
        return 'MutationObserver' in window ? window.MutationObserver : false;
    }();
    var CFW_mutationObserver = CFW_MutationObserverTest;
    var CFW_mutationObserved = function(records, $node) {
        if (!MutationObserver) return;
        var $target = $(records[0].target);
        if ($target.is($node)) return;
         // Ignore elements own mutation
        var $parent = $target.parents('[data-cfw-mutate]').first();
        $parent.triggerHandler('mutate.cfw.mutate');
    };
    $.fn.CFW_mutateTrigger = function() {
        this.find('[data-cfw-mutate]').each(function() {
            $(this).triggerHandler('mutate.cfw.mutate');
        });
        return this;
    };
    $.fn.CFW_mutationIgnore = function() {
        if (!CFW_mutationObserver) return this;
        this.each(function() {
            var elmObserver = $(this).data('cfw-mutationobserver');
            if (typeof elmObserver !== 'undefined') elmObserver.disconnect();
            $(this).removeData('cfw-mutationobserver').off('mutated.cfw.mutate');
        });
        return this;
    };
    $.fn.CFW_mutationListen = function() {
        if (!CFW_mutationObserver) return this;
        this.CFW_mutationIgnore();
        this.each(function() {
            var $node = this;
            var elmObserver = new MutationObserver(function(records) {
                CFW_mutationObserved(records, $node);
            });
            elmObserver.observe(this, {
                attributes: true,
                childList: true,
                characterData: false,
                subtree: true,
                attributeFilter: [
                    'style',
                    'class'
                ]
            });
            // Don't pass node so that this can force a mutation observation
            $(this).data('cfw-mutationobserver', elmObserver).on('mutated.cfw.mutate', CFW_mutationObserved);
        /*
                .on('mutated.cfw.mutate', function(e) {
                    CFW_mutationObserved(e, $node);
                });
            */ });
        return this;
    };
    // =====
    // Image Loaded Detection
    // =====
    // Execute a callback when an image has been loaded
    $.CFW_imageLoaded = function($img, instance, callback) {
        var img = $img[0];
        var proxyImg = new Image();
        var $proxyImg = $(proxyImg);
        if (typeof instance === 'undefined') instance = '';
        else instance = '.' + instance;
        var _doCallback = function() {
            $proxyImg.off('load.cfw.imageLoaded' + instance).remove();
            callback();
        };
        var _isImageComplete = function() {
            return img.complete && typeof img.naturalWidth !== 'undefined';
        };
        // Firefox reports img.naturalWidth=0 for SVG
        // Also currently borked in most browsers: https://github.com/whatwg/html/issues/3510
        // if (_isImageComplete() && img.naturalWidth !== 0) {
        if (_isImageComplete()) {
            _doCallback();
            return;
        }
        $proxyImg.off('load.cfw.imageLoaded' + instance).one('load.cfw.imageLoaded' + instance, _doCallback);
        proxyImg.src = img.src;
    };
    // =====
    // Public Utils
    // =====
    $.fn.CFW_getID = function(prefix) {
        var $node = $(this);
        var nodeID = $node.attr('id');
        var MAX_ID = 1000000;
        if (typeof nodeID === 'undefined') {
            do /* eslint-disable-next-line no-bitwise */ nodeID = prefix + '-' + ~~(Math.random() * MAX_ID); // "~~" acts like a faster Math.floor() here
            while (document.getElementById(nodeID));
            $node.attr('id', nodeID);
        }
        return nodeID;
    };
    $.fn.CFW_trigger = function(eventName, extraData) {
        var e = $.Event(eventName);
        if ($.isPlainObject(extraData)) e = $.extend({}, e, extraData);
        $(this).trigger(e);
        if (e.isDefaultPrevented()) return false;
        return true;
    };
    $.fn.CFW_parseData = function(name, object) {
        var parsedData = {};
        var $node = $(this);
        var data = $node.data();
        name = name.capitalize();
        for(var prop in object)if (Object.prototype.hasOwnProperty.call(object, prop)) {
            var propName = prop.capitalize();
            if (typeof data['cfw' + name + propName] !== 'undefined') parsedData[prop] = data['cfw' + name + propName];
        }
        return parsedData;
    };
    $.fn.CFW_getSelectorFromElement = function(name) {
        var selector = this[0].getAttribute('data-cfw-' + name + '-target');
        if (!selector || selector === '#') selector = this[0].getAttribute('href') || '';
        try {
            return document.querySelector(selector) ? selector : null;
        } catch (error) {
            return null;
        }
    };
    $.fn.CFW_getSelectorFromChain = function(name, setting) {
        var $node = $(this);
        if (!setting || setting === '#') return $node.CFW_getSelectorFromElement();
        try {
            return document.querySelector(setting) ? setting : null;
        } catch (error) {
            return null;
        }
    };
    $.CFW_isRTL = function(element) {
        if (typeof element === 'undefined') element = document.documentElement;
        var directionVal = window.getComputedStyle(element, null).getPropertyValue('direction').toLowerCase();
        return Boolean(directionVal === 'rtl');
    };
    $.fn.CFW_getScrollbarSide = function() {
        // Unable to detect side when 0-width scrollbars (such as mobile)
        // are found.  So we use 'right` side as default (more common case).
        // Hacky support for IE/Edge and their placment of scrollbar on window
        // for 'rtl' mode.
        var $node = $(this);
        if ($node.is($('html'))) {
            var browser = {
                msedge: /edge\/\d+/i.test(navigator.userAgent),
                msie: /(msie|trident)/i.test(navigator.userAgent)
            };
            if ($.CFW_isRTL($node[0]) && (browser.msedge || browser.msie)) return 'left';
            return 'right';
        }
        var scrollDiv = document.createElement('div');
        scrollDiv.setAttribute('style', 'overflow-y: scroll;');
        var scrollP = document.createElement('p');
        $(scrollDiv).append(scrollP);
        $node.append(scrollDiv);
        var scrollbarWidth = $.CFW_measureScrollbar();
        var posLeft = scrollP.getBoundingClientRect().left;
        $node[0].removeChild(scrollDiv);
        return posLeft < scrollbarWidth ? 'right' : 'left';
    };
    $.fn.CFW_findShadowRoot = function(element) {
        if (!document.documentElement.attachShadow) return null;
        // Can find the shadow root otherwise it'll return the document
        if (typeof element.getRootNode === 'function') {
            var root = element.getRootNode();
            return root instanceof ShadowRoot ? root : null;
        }
        if (element instanceof ShadowRoot) return element;
        // when we don't find a shadow root
        if (!element.parentNode) return null;
        return null;
    };
    $.CFW_throttle = function(fn, threshhold, scope) {
        /* From: http://remysharp.com/2010/07/21/throttling-function-calls/ */ var THRESHHOLD_DEFAULT = 250;
        if (typeof threshhold === 'undefined') threshhold = THRESHHOLD_DEFAULT;
        var last;
        var deferTimer;
        return function() {
            var context = scope || this;
            var now = Number(new Date());
            var args = arguments;
            if (last && now < last + threshhold) {
                // hold on to it
                clearTimeout(deferTimer);
                deferTimer = setTimeout(function() {
                    last = now;
                    fn.apply(context, args);
                }, threshhold);
            } else {
                last = now;
                fn.apply(context, args);
            }
        };
    };
    $.CFW_measureScrollbar = function() {
        var scrollDiv = document.createElement('div');
        scrollDiv.setAttribute('style', ' position: absolute; top: -9999px; width: 50px; height: 50px; overflow: scroll;');
        document.body.appendChild(scrollDiv);
        var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);
        return scrollbarWidth;
    };
    $.CFW_reflow = function(element) {
        if (element instanceof jQuery) element = element[0];
        return element.offsetHeight;
    };
    $.CFW_controlEnable = function(element) {
        $(element).removeClass('disabled').removeAttr('tabindex').removeAttr('disabled').closest('label').removeClass('disabled');
    };
    $.CFW_controlDisable = function(element) {
        var $control = $(element);
        if ($control.length && /button|fieldset|input|optgroup|option|select|textarea/i.test($control[0].tagName)) {
            $control.prop('disabled', true);
            $control.closest('label').addClass('disabled');
        } else $control.addClass('disabled').attr('tabindex', -1);
    };
    $.CFW_isDisabled = function(element) {
        if (element instanceof jQuery) element = element[0];
        if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
        if (/^(button|input|select|textarea)$/i.test(element.nodeName)) {
            var fieldset = $(element).closest('fieldset')[0];
            if (fieldset && fieldset.disabled) return true;
        }
        if (element.classList.contains('disabled')) return true;
        if (typeof element.disabled === 'boolean') return element.disabled;
        return element.hasAttribute('disabled');
    };
    $.CFW_isVisible = function(element) {
        if (element instanceof jQuery) element = element[0];
        if (!$.CFW_isElement(element) || element.getClientRects().length === 0) return false;
        var elementIsVisible = window.getComputedStyle(element).getPropertyValue('visibility') === 'visible';
        // Handle 'details' elements, as content may falsie appear visible when closed
        var detailsClosed = $(element).closest('details:not([open])').get(0);
        if (typeof detailsClosed === 'undefined') detailsClosed = null;
        if (!detailsClosed) return elementIsVisible;
        if (detailsClosed !== element) {
            var summary = $(element).closest('summary').get(0);
            if (typeof summary === 'undefined') summary = null;
            if (summary && summary.parentNode !== detailsClosed) return false;
            if (summary === null) return false;
        }
        return elementIsVisible;
    };
    $.CFW_isFocusable = function(element) {
        // This is only a cursory check - mostly to be used with `$.CFW_getFocusable()`
        // Many elements will pass this test if they do not explicitly fail
        // the conditions below.  For example, passing `<div></div>` through
        // this method will return true, but the `<div>` is not actually focusable.
        if (element instanceof jQuery) element = element[0];
        var tabindex = null;
        if (element.hasAttribute('tabindex')) tabindex = element.getAttribute('tabindex');
        if (tabindex !== null) {
            if (isNaN(tabindex) || tabindex < 0) return false;
        }
        return !$.CFW_isDisabled(element) && $.CFW_isVisible(element);
    };
    $.CFW_getFocusable = function(element, allowed) {
        if (typeof allowed === 'undefined') allowed = [
            'a',
            'button',
            'details',
            'input',
            'select',
            'textarea',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map(function(selector) {
            return selector + ':not([tabindex^="-"])';
        }).join(', ');
        var items = element.querySelectorAll(allowed);
        var focusables = [];
        for(var i = 0; i < items.length; i++)if ($.CFW_isFocusable(items[i])) focusables.push(items[i]);
        return focusables;
    };
    $.CFW_isElement = function(object) {
        if (!object || typeof object !== 'object') return false;
        if (typeof object.jquery !== 'undefined') object = object[0];
        return typeof object.nodeType !== 'undefined';
    };
    $.CFW_getElement = function(object) {
        // Check for jQuery object or a node element
        if ($.CFW_isElement(object)) return object.jquery ? object[0] : object;
        if (typeof object === 'string' && object.length > 0) return document.querySelector(object);
        return null;
    };
    $.CFW_slimRadioInput = function(items, isBackward) {
        // For a given set of focusable items, reduce each set of named radio inputs
        // to a single item based on navigation direction
        // Use checked input if one exists, otherwise:
        // Forward movement - set first item
        // Backward movement - set last item
        isBackward = typeof isBackward === 'undefined' ? false : isBackward;
        var output = [];
        var item = null;
        var radioName = null;
        var radioHold = null;
        var radioHasActive = false;
        for(var i = 0; i < items.length; i++){
            item = items[i];
            if (item.nodeName === 'INPUT' && item.getAttribute('type') !== null && item.getAttribute('type').toLowerCase() === 'radio') {
                if (radioName && item.getAttribute('name') !== null && radioName === item.getAttribute('name').toLowerCase()) {
                    if (item.checked) {
                        // Hold checked radio
                        radioHold = item;
                        radioHasActive = true;
                    } else if (!radioHasActive && isBackward) // Hold last radio
                    radioHold = item;
                } else {
                    // Hold first radio
                    radioName = item.getAttribute('name').toLowerCase();
                    radioHold = item;
                    radioHasActive = false;
                }
                continue;
            }
            if (radioHold) {
                output.push(radioHold);
                radioName = null;
                radioHold = null;
                radioHasActive = false;
            }
            output.push(item);
        }
        if (radioHold) output.push(radioHold);
        return output;
    };
    $.CFW_getNextActiveElement = function(list, activeElement, doIncrement, allowLoop, allowStartEnd) {
        var index = list.indexOf(activeElement);
        var listLength = list.length;
        if (typeof allowLoop === 'undefined') allowLoop = false;
        if (typeof allowStartEnd === 'undefined') allowStartEnd = false;
        // If currently actve element does not exist in the list
        // return an element depending on the direction and if starting at the end is allowed
        if (index === -1) return list[!doIncrement && allowStartEnd ? listLength - 1 : 0];
        index += doIncrement ? 1 : -1;
        if (allowLoop) index = (index + listLength) % listLength;
        return list[Math.max(0, Math.min(index, listLength - 1))];
    };
    $.CFW_enableDismissControl = function(name, method) {
        if (typeof CFW_API !== 'undefined' && CFW_API === false) return;
        if (typeof method === 'undefined') method = 'hide';
        var widget = 'CFW_' + name.capitalize();
        var eventName = 'click.dismiss.cfw.' + name;
        $(document).on(eventName, '[data-cfw-dismiss="' + name + '"]', function(event) {
            if (/a|area/i.test(this.tagName)) event.preventDefault();
            if ($.CFW_isDisabled(this)) return;
            var selector = $(this).CFW_getSelectorFromElement(name);
            var $elm = selector ? $(selector) : $(this).closest('.' + name);
            if ($elm.length) $elm[widget](method, event);
        });
    };
})(jQuery);
/**
 * --------------------------------------------------------------------------
 * Figuration (v4.4.1): drag.js
 * Licensed under MIT (https://github.com/cast-org/figuration/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ (function($) {
    'use strict';
    var CFW_Widget_Drag = function(element, options) {
        this.$element = $(element);
        this.dragging = false;
        this.dragdata = {};
        this.instance = null;
        this.settings = $.extend({}, CFW_Widget_Drag.DEFAULTS, options);
        this._init();
    };
    CFW_Widget_Drag.DEFAULTS = {
        handle: null // selector for handle target elements
    };
    CFW_Widget_Drag.prototype = {
        _init: function() {
            this.instance = $('<div/>').CFW_getID('cfw-drag');
            this._reset();
            this._dragStartOn();
            this.$element.CFW_trigger('init.cfw.drag');
        },
        dispose: function() {
            if (this.$element[0].detachEvent) this.$element[0].detachEvent('ondragstart', this._dontStart);
            this._dragStartOff();
            this.$element.removeData('cfw.drag');
            this.$element = null;
            this.dragging = null;
            this.dragdata = null;
            this.instance = null;
            this.settings = null;
        },
        _dragStartOn: function() {
            this.$element.on('mousedown.cfw.dragstart touchstart.cfw.dragstart MSPointerDown.cfw.dragstart', this._dragStart.bind(this));
            // prevent image dragging in IE...
            if (this.$element[0].attachEvent) this.$element[0].attachEvent('ondragstart', this._dontStart);
        },
        _dragStartOff: function(e) {
            if (e) e.preventDefault();
            $(document).off('.cfw.dragin.' + this.instance);
            this.$element.off('.cfw.dragstart');
        },
        _dragStart: function(e) {
            var $selfRef = this;
            // ignore potential disabled handle
            if ($.CFW_isDisabled(e.target)) return;
            // check for handle selector
            if (this.settings.handle) {
                var $handle = this.$element[0].querySelector(this.settings.handle);
                if (!$handle.contains(e.target)) return;
            }
            // check for disabled element
            if ($.CFW_isDisabled(this.$element)) return;
            this._dragStartOff(e);
            this.dragging = true;
            $(document).on('mousemove.cfw.dragin.' + this.instance + ' touchmove.cfw.dragin.' + this.instance + ' MSPointerMove.cfw.dragin.' + this.instance, function(e) {
                $selfRef._drag(e);
            }).on('mouseup.cfw.dragin.' + this.instance + ' touchend.cfw.dragin.' + this.instance + ' MSPointerUp.cfw.dragin.' + this.instance + ' MSPointerCancel.cfw.dragin.' + this.instance, function() {
                $selfRef._dragEnd(e);
            });
            var coord = this._coordinates(e);
            this.dragdata = coord;
            this.dragdata.originalX = e.currentTarget.offsetLeft;
            this.dragdata.originalY = e.currentTarget.offsetTop;
            var props = this._properties(coord, this.dragdata);
            this.$element.CFW_trigger('dragStart.cfw.drag', props);
        },
        _drag: function(e) {
            if (!this.dragging) return;
            e.preventDefault();
            var coord = this._coordinates(e);
            var props = this._properties(coord, this.dragdata);
            this.$element.CFW_trigger('drag.cfw.drag', props);
        },
        _dragEnd: function(e) {
            e.preventDefault();
            this.dragging = false;
            this.dragStart = null;
            $(document).off('.cfw.dragin.' + this.instance);
            var coord = this._coordinates(e);
            var props = this._properties(coord, this.dragdata);
            this.$element.CFW_trigger('dragEnd.cfw.drag', props);
            this._reset();
            this._dragStartOn();
        },
        _reset: function() {
            this.dragging = false;
            this.dragdata.pageX = null;
            this.dragdata.pageY = null;
        },
        _coordinates: function(e) {
            var coord = {};
            if (e.originalEvent) e = e.originalEvent;
            var touches = e.touches;
            coord.pageX = touches ? touches[0].pageX : e.pageX;
            coord.pageY = touches ? touches[0].pageY : e.pageY;
            return coord;
        },
        _properties: function(coord, dd) {
            var p = {};
            // starting position
            p.startX = dd.pageX;
            p.startY = dd.pageY;
            // pass-thru page position
            p.pageX = coord.pageX;
            p.pageY = coord.pageY;
            // distance dragged
            p.deltaX = coord.pageX - dd.pageX;
            p.deltaY = coord.pageY - dd.pageY;
            // original element position
            p.originalX = dd.originalX;
            p.originalY = dd.originalY;
            // adjusted element position
            p.offsetX = p.originalX + p.deltaX;
            p.offsetY = p.originalY + p.deltaY;
            return p;
        },
        _dontStart: function() {
            return false;
        }
    };
    var Plugin = function(option) {
        var args = [].splice.call(arguments, 1);
        return this.each(function() {
            var $this = $(this);
            var data = $this.data('cfw.drag');
            var options = typeof option === 'object' && option;
            if (!data && /dispose/.test(option)) return;
            if (!data) $this.data('cfw.drag', data = new CFW_Widget_Drag(this, options));
            if (typeof option === 'string') data[option].apply(data, args);
        });
    };
    $.fn.CFW_Drag = Plugin;
    $.fn.CFW_Drag.Constructor = CFW_Widget_Drag;
})(jQuery);
/**
 * --------------------------------------------------------------------------
 * Figuration (v4.4.1): collapse.js
 * Licensed under MIT (https://github.com/cast-org/figuration/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ (function($) {
    'use strict';
    var CFW_Widget_Collapse = function(element, options) {
        this.$element = $(element);
        this.$target = null;
        this.$triggers = null;
        this.inTransition = false;
        var parsedData = this.$element.CFW_parseData('collapse', CFW_Widget_Collapse.DEFAULTS);
        this.settings = $.extend({}, CFW_Widget_Collapse.DEFAULTS, parsedData, options);
        this._init();
    };
    CFW_Widget_Collapse.DEFAULTS = {
        target: null,
        animate: true,
        follow: false,
        horizontal: false // If collapse should transition horizontal (vertical is default)
    };
    CFW_Widget_Collapse.prototype = {
        _init: function() {
            var selector = this.$element.CFW_getSelectorFromChain('collapse', this.settings.target);
            if (!selector) return;
            this.$target = $(selector);
            this.$element.attr({
                'data-cfw': 'collapse',
                'data-cfw-collapse-target': selector
            });
            // Build trigger collection
            this.$triggers = $('[data-cfw="collapse"][data-cfw-collapse-target="' + selector + '"],' + '[data-cfw="collapse"][href="' + selector + '"]');
            // Check for presence of trigger id - set if not present
            // var triggerID = this.$element.CFW_getID('cfw-collapse');
            // A button can control multiple boxes so we need to id each on box individually
            var targetList = '';
            this.$target.each(function() {
                var tempID = $(this).CFW_getID('cfw-collapse');
                targetList += tempID + ' ';
            });
            // Set ARIA on trigger
            this.$triggers.attr('aria-controls', $.trim(targetList));
            // Determine default state
            var dimension = this.dimension();
            if (this.$triggers.hasClass('open')) {
                this.$triggers.attr('aria-expanded', 'true');
                this.$target.addClass('collapse in')[dimension]('');
            } else {
                this.$triggers.attr('aria-expanded', 'false');
                this.$target.addClass('collapse');
            }
            if (this.settings.horizontal) this.$target.addClass('width');
            // Bind click handler
            this.$element.on('click.cfw.collapse', this.toggle.bind(this)).CFW_trigger('init.cfw.collapse');
        },
        toggle: function(e) {
            // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
            if (e.target.tagName === 'A' || e.delegateTarget && e.delegateTarget.tagName === 'A') e.preventDefault();
            if (this.$element.hasClass('open') || this.$target.hasClass('in')) this.hide();
            else this.show();
        },
        dimension: function() {
            var hasWidth = this.$target.hasClass('width');
            if (hasWidth || this.settings.horizontal) return 'width';
            return 'height';
        },
        show: function(follow) {
            var $selfRef = this;
            if (typeof follow === 'undefined') follow = this.settings.follow;
            // Bail if transition in progress
            if (this.inTransition || this.$target.hasClass('in')) return;
            // Start open transition
            if (!this.$element.CFW_trigger('beforeShow.cfw.collapse')) return;
            var dimension = this.dimension();
            this.inTransition = true;
            this.$triggers.addClass('open');
            this.$target.removeClass('collapse')[dimension](0);
            if (this.settings.animate) this.$target.addClass('collapsing');
            var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
            var scrollSize = 'scroll' + capitalizedDimension;
            // Determine/set dimension size for each target (triggers the transition)
            var start = function() {
                $selfRef.$target.each(function() {
                    $(this)[dimension]($(this)[0][scrollSize]);
                });
            };
            var complete = function() {
                $selfRef.$triggers.attr('aria-expanded', 'true');
                $selfRef.$target.removeClass('collapsing')[dimension]('');
                $selfRef.$target.addClass('collapse in');
                $selfRef.$target.CFW_mutateTrigger();
                $selfRef.inTransition = false;
                if (follow) {
                    if (typeof $selfRef.$target.first().attr('tabindex') === 'undefined') $selfRef.$target.first().attr('tabindex', '-1');
                    $selfRef.$target.eq(0).trigger('focus');
                }
                $selfRef.$element.CFW_trigger('afterShow.cfw.collapse');
            };
            // Bind transition callback to first target
            this.$target.eq(0).CFW_transition(start, complete);
        },
        hide: function(follow) {
            var $selfRef = this;
            if (typeof follow === 'undefined') follow = this.settings.follow;
            // Bail if transition in progress
            if (this.inTransition || !this.$target.hasClass('in')) return;
            // Start close transition
            if (!this.$element.CFW_trigger('beforeHide.cfw.collapse')) return;
            var dimension = this.dimension();
            this.inTransition = true;
            this.$triggers.removeClass('open');
            // Set dimension size and reflow before class changes for Chrome/Webkit or no animation occurs
            this.$target.each(function() {
                var $this = $(this);
                return $this[dimension]($this[dimension]())[0].offsetHeight;
            });
            this.$target.removeClass('collapse in');
            if (this.settings.animate) this.$target.addClass('collapsing');
            // Determine/unset dimension size for each target (triggers the transition)
            var start = function() {
                $selfRef.$target[dimension]('');
            };
            var complete = function() {
                $selfRef.$triggers.attr('aria-expanded', 'false');
                $selfRef.$target.removeClass('collapsing in').addClass('collapse').CFW_mutateTrigger();
                $selfRef.inTransition = false;
                if (follow) $selfRef.$element.trigger('focus');
                $selfRef.$element.CFW_trigger('afterHide.cfw.collapse');
            };
            // Bind transition callback to first target
            this.$target.eq(0).CFW_transition(start, complete);
        },
        animDisable: function() {
            this.settings.animate = false;
        },
        animEnable: function() {
            this.settings.animate = true;
        },
        dispose: function() {
            this.$element.off('.cfw.collapse').removeData('cfw.collapse');
            this.$element = null;
            this.$target = null;
            this.$triggers = null;
            this.inTransition = null;
            this.settings = null;
        }
    };
    var Plugin = function(option) {
        var args = [].splice.call(arguments, 1);
        return this.each(function() {
            var $this = $(this);
            var data = $this.data('cfw.collapse');
            var options = typeof option === 'object' && option;
            if (!data) $this.data('cfw.collapse', data = new CFW_Widget_Collapse(this, options));
            if (typeof option === 'string') data[option].apply(data, args);
        });
    };
    $.fn.CFW_Collapse = Plugin;
    $.fn.CFW_Collapse.Constructor = CFW_Widget_Collapse;
})(jQuery);
/**
 * --------------------------------------------------------------------------
 * Figuration (v4.4.1): dropdown.js
 * Licensed under MIT (https://github.com/cast-org/figuration/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ (function($) {
    'use strict';
    var CFW_Widget_Dropdown = function(element, options) {
        this.$element = $(element);
        this.$target = null;
        this.instance = null;
        this.timerHide = null;
        this.hasContainer = {
            helper: null,
            parent: null,
            previous: null
        };
        this.inNavbar = this._insideNavbar();
        this.popper = null;
        var parsedData = this.$element.CFW_parseData('dropdown', CFW_Widget_Dropdown.DEFAULTS);
        this.settings = $.extend({}, CFW_Widget_Dropdown.DEFAULTS, parsedData, options);
        this.c = CFW_Widget_Dropdown.CLASSES;
        this._init();
    };
    CFW_Widget_Dropdown.CLASSES = {
        // Class names
        isMenu: 'dropdown-menu',
        hasSubMenu: 'dropdown-submenu',
        showSubMenu: 'show-menu',
        backLink: 'dropdown-back',
        hover: 'dropdown-hover'
    };
    CFW_Widget_Dropdown.DEFAULTS = {
        target: null,
        isSubmenu: false,
        delay: 350,
        hover: false,
        backlink: false,
        backtop: false,
        backtext: 'Back',
        container: false,
        reference: 'toggle',
        boundary: 'scrollParent',
        flip: true,
        display: 'dynamic',
        popperConfig: null,
        autoClose: true,
        loop: true,
        startEnd: true // Up arrow from control starts at last menu item
    };
    /* eslint-disable complexity */ var clearMenus = function(e) {
        if (e) {
            // Ignore right-click
            var RIGHT_MOUSE_BUTTON_WHICH = 3; // MouseEvent.which value for the right button (assuming a right-handed mouse)
            if (e.which === RIGHT_MOUSE_BUTTON_WHICH) return;
            // Ignore tab key event
            var KEYCODE_TAB = 9; // Tab
            if (e.type === 'keyup' && e.which !== KEYCODE_TAB) return;
            // Ignore input areas
            if (/label|input|textarea|select/i.test(e.target.tagName)) return;
        }
        var $items = $('[data-cfw="dropdown"].open');
        // Do menu items in reverse to close from bottom up
        for(var i = $items.length; i--;){
            var $trigger = $($items[i]);
            var itemData = $trigger.data('cfw.dropdown');
            if (!itemData) continue;
            var $itemMenu = itemData.$target;
            if ($itemMenu === null) continue;
            if (e) {
                // Ignore clicks on trigger or child of trigger
                if (itemData.$element[0] === e.target || itemData.$element[0].contains(e.target)) continue;
                // Auto close determination
                if (itemData.settings.autoClose === false) continue;
                var isMenuTarget = itemData.$target[0] === e.target || itemData.$target[0].contains(e.target);
                if (itemData.settings.autoClose === 'inside' && !isMenuTarget || itemData.settings.autoClose === 'outside' && isMenuTarget) continue;
                // Ignore clicks for
                // - menu triggers
                // - 'back' buttons
                if (e.type === 'click') {
                    if (this === e.target || $(e.target).is('[data-cfw="dropdown"]') && $itemMenu[0].contains(e.target) || $(e.target).closest('.dropdown-back').length) continue;
                }
                // Ignore if hover/mouse
                // - if still inside menu
                if (e.type === 'mouseenter') {
                    if (this === e.target || $itemMenu[0].contains(e.target)) continue;
                }
            }
            var eventProperties = {
                relatedTarget: $trigger[0]
            };
            if (e && e.type === 'click') eventProperties.clickEvent = e;
            if (!$trigger.CFW_trigger('beforeHide.cfw.dropdown', eventProperties)) continue;
            $trigger.CFW_Dropdown('_hideComplete', eventProperties);
        }
    };
    /* eslint-enable complexity */ CFW_Widget_Dropdown.prototype = {
        _init: function() {
            var $selfRef = this;
            if (typeof this.settings.reference === 'object' && !this._isElement(this.settings.reference) && typeof this.settings.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
            throw new Error('CFW_Dropdown: Option "reference" provided type "object" without a required "getBoundingClientRect" method.');
            // Get target menu
            var selector = this.$element.CFW_getSelectorFromChain('dropdown', this.settings.target);
            var $target = $(selector);
            // Target by next sibling class
            if (!$target.length) $target = $(this.$element.next('.dropdown-menu, ul, ol')[0]);
            if (!$target.length) return;
            this.$target = $target;
            // Get previous sibling to menu if container is to be used
            if (this._useContainer()) this.hasContainer = {
                parent: this.$target.parent(),
                previous: this.$target.prev()
            };
            this.$element.attr('data-cfw', 'dropdown');
            // Get `id`s
            this.instance = this.$element.CFW_getID('cfw-dropdown');
            this.$target.CFW_getID('cfw-dropdown');
            // Set default ARIA and class
            this.$element.attr('aria-expanded', 'false');
            this.$target.attr('aria-labelledby', this.instance).addClass(this.c.isMenu);
            // Toggle on the trigger
            this.$element.on('click.cfw.dropdown', function(e) {
                e.preventDefault();
                $selfRef.toggle(e);
            });
            // Add 'Back' links
            this._addBacklink();
            // Find submenu items
            var $subToggle = this.$target.children('li').children('ul, ol').parent();
            $subToggle.each(function() {
                var $this = $(this);
                var $subElement = $this.children('a, button').eq(0);
                var $subTarget = $this.children('ul, ol').eq(0);
                var subOptions = {};
                if ($subElement.length && $subTarget.length) {
                    $this.addClass($selfRef.c.hasSubMenu);
                    if ($subElement[0].nodeName === 'A') $subElement.attr('role', 'button');
                    // Pass parent settings, with some overrides
                    // then add dropdown functionality to submenu
                    subOptions = {
                        isSubmenu: true,
                        target: $subTarget.CFW_getID('cfw-dropdown')
                    };
                    subOptions = $.extend({}, $selfRef.settings, subOptions);
                    $subElement.CFW_Dropdown(subOptions);
                }
                // Manipulate directions of submenus
                var $dirNode = $subTarget.closest('.dropreverse, .dropend, .dropstart');
                if ($dirNode.hasClass('dropreverse') || $dirNode.hasClass('dropstart')) $subTarget.addClass('dropdown-subalign-reverse');
                else $subTarget.addClass('dropdown-subalign-forward');
            });
            // Set role on dividers
            this.$target.find('.dropdown-divider').attr('role', 'separator');
            // Add keyboard navigation
            this._navEnableKeyboard();
            // Touch OFF - Hover mode
            if (!$.CFW_isTouch && this.settings.hover) this._navEnableHover();
            this.$element.CFW_trigger('init.cfw.dropdown');
        },
        _findMenuItems: function() {
            var showing = this.$target.hasClass('open');
            var $menu = this.$target;
            if (!showing && this.settings.isSubmenu) $menu = this.$element.closest('.dropdown-menu');
            var $items = $menu.children('li').find('a, .dropdown-item, button, input, textarea, select');
            $items = $items.filter(':not(:has(input)):not(:has(textarea):not(:has(select))');
            $items = $items.filter(function() {
                return $.CFW_isFocusable(this);
            });
            return $items;
        },
        _addBacklink: function() {
            var $selfRef = this;
            if (this.settings.backlink && this.settings.backtop && !this.settings.isSubmenu || this.settings.backlink && this.settings.isSubmenu) {
                var $backItem = $('<li class="' + this.c.backLink + '"><button type="button" class="dropdown-item">' + this.settings.backtext + '</button></li>').prependTo(this.$target);
                $backItem.children('button').on('click.cfw.dropdown.modeClick', function() {
                    $selfRef.hide();
                    $selfRef.$element.focus();
                });
            }
        },
        _navEnableKeyboard: function() {
            var $selfRef = this;
            $.each([
                this.$element,
                this.$target
            ], function() {
                $(this).on('keydown.cfw.dropdown', function(e) {
                    $selfRef._actionsKeydown(e);
                });
            });
        },
        /* eslint-disable complexity */ _actionsKeydown: function(e) {
            var showing = this.$target.hasClass('open');
            var KEYCODE_UP = 38; // Arrow up
            var KEYCODE_RIGHT = 39; // Arrow right
            var KEYCODE_DOWN = 40; // Arrow down
            var KEYCODE_LEFT = 37; // Arrow left
            var KEYCODE_ESC = 27; // Escape
            var KEYCODE_SPACE = 32; // Space
            var KEYCODE_TAB = 9; // Tab
            var REGEX_KEYS = new RegExp('^(' + KEYCODE_UP + '|' + KEYCODE_RIGHT + '|' + KEYCODE_DOWN + '|' + KEYCODE_LEFT + '|' + KEYCODE_ESC + '|' + KEYCODE_SPACE + '|' + KEYCODE_TAB + ')$');
            var REGEX_ARROWS = new RegExp('^(' + KEYCODE_UP + '|' + KEYCODE_RIGHT + '|' + KEYCODE_DOWN + '|' + KEYCODE_LEFT + ')$');
            var isInput = /input|textarea|select/i.test(e.target.tagName);
            var isCheck = isInput && /checkbox|radio/i.test($(e.target).prop('type'));
            var isRealButton = /button/i.test(e.target.tagName);
            var isRoleButton = /button/i.test($(e.target).attr('role'));
            if (!REGEX_KEYS.test(e.which)) return;
            // Ignore space in inputs and buttons
            if ((isInput || isRealButton) && e.which === KEYCODE_SPACE) return;
            // Ignore arrows in inputs, except for checkbox/radio
            if (isInput && !isCheck && REGEX_ARROWS.test(e.which)) return;
            // Allow ESC and LEFT to propagate if menu is closed
            if (!showing && (e.which === KEYCODE_ESC || e.which === KEYCODE_LEFT) && $(e.target).is(this.$element)) return;
            var $items = null;
            var index = -1;
            // Handle TAB if using a container
            if (e.which === KEYCODE_TAB) {
                if (this.hasContainer.helper !== null) {
                    $items = this._findMenuItems();
                    if (!$items.length) return;
                    // Find current focused menu item
                    index = $items.index(document.activeElement);
                    if (index < 0 && isCheck) index = $items.index($(e.target).closest('.dropdown-item')[0]);
                    if (showing && $(e.target).is(this.$element) && !e.shiftKey) e.which = KEYCODE_DOWN;
                    else if (e.shiftKey && index === 0) {
                        this.$element.trigger('focus');
                        e.preventDefault();
                        return;
                    } else if (!e.shiftKey && index === $items.length - 1) {
                        this.$element.trigger('focus');
                        return;
                    } else return;
                } else return;
            }
            e.preventDefault();
            e.stopPropagation();
            // Close current focused menu with ESC
            if (e.which === KEYCODE_ESC) {
                this.hide();
                this.$element.trigger('focus');
                return;
            }
            // Ignore disabled items
            if ($.CFW_isDisabled(this.$element)) return;
            // Emulate button behavior
            if (isRoleButton && e.which === KEYCODE_SPACE) {
                this.toggle(e);
                return;
            }
            // Open/close menus
            if (e.which === KEYCODE_UP || e.which === KEYCODE_DOWN) // Open menu if top level
            {
                if (!showing && !this.settings.isSubmenu) this.show();
            }
            // Right
            if (e.which === KEYCODE_RIGHT) {
                if (!showing && this.settings.isSubmenu) this.show();
            }
            // Left
            if (e.which === KEYCODE_LEFT && this.settings.isSubmenu) {
                this.hide();
                this.$element.trigger('focus');
                return;
            }
            // Focus control
            $items = this._findMenuItems();
            if (!$items.length) return;
            // Find current focused menu item
            index = $items.index(document.activeElement);
            if (index < 0 && isCheck) index = $items.index($(e.target).closest('.dropdown-item')[0]);
            var nextItem = $items[index];
            var doIncrement = e.which === KEYCODE_DOWN || e.which === KEYCODE_RIGHT;
            nextItem = $.CFW_getNextActiveElement($items.toArray(), $items[index], doIncrement, this.settings.loop, this.settings.startEnd && !this.settings.subMenu);
            $(nextItem).trigger('focus');
        },
        /* eslint-enable complexity */ _navEnableHover: function() {
            var $selfRef = this;
            if (!$.CFW_isTouch) $.each([
                this.$element,
                this.$target
            ], function() {
                $(this).on('mouseenter.cfw.dropdown.modeHover', function(e) {
                    $selfRef._actionsHoverEnter(e);
                });
                $(this).on('mouseleave.cfw.dropdown.modeHover', function(e) {
                    $selfRef._actionsHoverLeave(e);
                });
            });
        },
        _navDisableHover: function() {
            this.$element.off('.cfw.dropdown.modeHover');
            this.$target.off('.cfw.dropdown.modeHover');
        },
        _actionsHoverEnter: function(e) {
            clearTimeout(this.timerHide);
            clearMenus(e);
            this.show();
        },
        _actionsHoverLeave: function(e) {
            var $selfRef = this;
            var $node = $(e.target);
            clearTimeout(this.timerHide);
            if ($node.is(this.$element) || $node.is(this.$target) || this.$target[0].contains($node[0])) this.timerHide = setTimeout(function() {
                $selfRef.timerHide = null;
                $selfRef.hide();
            }, this.settings.delay);
        },
        _insideNavbar: function() {
            return this.$element.closest('.navbar-collapse').length > 0;
        },
        _useContainer: function() {
            // return !this.settings.isSubmenu && this.settings.container && !this.inNavbar;
            return !this.settings.isSubmenu && this.settings.container;
        },
        _containerPlacement: function() {
            var elRect = this.$element[0].getBoundingClientRect();
            elRect = $.extend({}, elRect, this.$element.offset());
            this.hasContainer.helper.css({
                top: elRect.top,
                left: elRect.left,
                width: elRect.width,
                height: elRect.height
            });
        },
        _containerSet: function() {
            if (this._useContainer()) {
                this.hasContainer.helper = $(document.createElement('div'));
                this.hasContainer.helper.appendTo(this.settings.container).append(this.$target).addClass('dropdown-container');
                $(window).on('resize.cfw.dropdown.' + this.instance, this._containerPlacement.bind(this));
                this._containerPlacement();
            }
        },
        containerReset: function() {
            if (this._useContainer()) {
                $(window).off('resize.cfw.dropdown.' + this.instance);
                if (this.hasContainer.previous.length) this.$target.insertAfter($(this.hasContainer.previous));
                else this.$target.appendTo($(this.hasContainer.parent));
                if (this.hasContainer.helper !== null) {
                    this.hasContainer.helper.off('keydown.cfw.dropdown').off('focusout.cfw.dropdown');
                    this.hasContainer.helper.remove();
                }
                this.hasContainer.helper = null;
            }
        },
        _isElement: function(node) {
            return (node[0] || node).nodeType;
        },
        _getReference: function() {
            var reference = this.$element[0];
            if (this.hasContainer.helper !== null) reference = this.hasContainer.helper;
            if (this.settings.reference === 'parent') reference = this.$element.parent().get(0);
            else if (this._isElement(this.settings.reference)) {
                reference = this.settings.reference;
                // Check for jQuery element
                if (typeof this.settings.reference.jquery !== 'undefined') reference = this.settings.reference[0];
            } else if (typeof this.settings.reference === 'object') reference = this.settings.reference;
            return reference;
        },
        /* eslint-disable complexity */ _getPlacement: function() {
            var isRTL = $.CFW_isRTL(this.$element[0]);
            var attachmentMap = {
                AUTO: 'auto',
                TOP: isRTL ? 'top-end' : 'top-start',
                TOPEND: isRTL ? 'top-start' : 'top-end',
                FORWARD: isRTL ? 'left-start' : 'right-start',
                FORWARDEND: isRTL ? 'left-end' : 'right-end',
                BOTTOM: isRTL ? 'bottom-end' : 'bottom-start',
                BOTTOMEND: isRTL ? 'bottom-start' : 'bottom-end',
                REVERSE: isRTL ? 'right-start' : 'left-start',
                REVERSEEND: isRTL ? 'right-end' : 'left-end',
                TOPCENTER: 'top',
                BOTTOMCENTER: 'bottom',
                FORWARDMIDDLE: isRTL ? 'left' : 'right',
                REVERSEMIDDLE: isRTL ? 'right' : 'left'
            };
            var $dirNode = this.$target.closest('.dropup, .dropreverse, .dropstart, .dropend, .dropcenter, .dropmiddle');
            var dirV = $dirNode.hasClass('dropup') ? 'TOP' : 'BOTTOM';
            var appendV = $dirNode.hasClass('dropreverse') ? 'END' : '';
            var dirH = $dirNode.hasClass('dropstart') || $dirNode.hasClass('dropreverse') ? 'REVERSE' : 'FORWARD';
            var appendH = $dirNode.hasClass('dropup') ? 'END' : '';
            if ($dirNode.hasClass('dropcenter')) appendV = 'CENTER';
            if ($dirNode.hasClass('dropmiddle')) appendH = 'MIDDLE';
            var placement = attachmentMap[dirV + appendV];
            if ($dirNode.hasClass('dropstart') || $dirNode.hasClass('dropend')) placement = attachmentMap[dirH + appendH];
            if (this.settings.isSubmenu) placement = attachmentMap[dirH + appendH];
            return placement;
        },
        /* eslint-enable complexity */ _getPopperConfig: function() {
            var defaultConfig = {
                placement: this._getPlacement(),
                modifiers: {
                    flip: {
                        enabled: this.settings.flip,
                        behavior: 'flip'
                    },
                    preventOverflow: {
                        boundariesElement: this.settings.boundary
                    }
                }
            };
            // Use deep merge
            var returnConfig = $.extend(true, defaultConfig, this.settings.popperConfig);
            return returnConfig;
        },
        popperReset: function() {
            if (this.popper) this.popper.destroy();
        },
        _popperLocate: function() {
            var isStatic = Boolean(window.getComputedStyle(this.$target[0], null).getPropertyValue('position').toLowerCase() === 'static');
            if (this.settings.display !== 'dynamic') return;
            if (isStatic) return;
            if (typeof Popper === 'undefined') throw new TypeError('Figurations\'s Dropdown widget requires Popper (https://popper.js.org)');
            this.popper = new Popper(this._getReference(), this.$target[0], this._getPopperConfig());
        },
        toggle: function(e) {
            if (e) e.preventDefault();
            if ($.CFW_isDisabled(this.$element)) return;
            var showing = this.$target.hasClass('open');
            if (showing) this.hide();
            else {
                clearMenus(e);
                this.show();
            }
        },
        show: function() {
            var $selfRef = this;
            if ($.CFW_isDisabled(this.$element) || this.$target.hasClass('open')) return;
            var eventProperties = {
                relatedTarget: this.$element[0]
            };
            if (!this.$element.CFW_trigger('beforeShow.cfw.dropdown', eventProperties)) return;
            // Move root menu if container is to be used
            this._containerSet();
            this.$element.attr('aria-expanded', 'true').addClass('open');
            this.$target.addClass('open');
            // Handle loss of focus
            $(document).on('focusin.cfw.dropdown.' + this.instance, function(e) {
                if ($selfRef.$element[0] !== e.target && !$selfRef.$target.has(e.target).length) {
                    var isMenuTarget = $selfRef.$target[0] === e.target || $selfRef.$target[0].contains(e.target);
                    if ($selfRef.settings.autoClose === false) return;
                    if ($selfRef.settings.autoClose === 'inside' && !isMenuTarget || $selfRef.settings.autoClose === 'outside' && isMenuTarget) return;
                    $selfRef.hide();
                }
            });
            // Add empty function for mouseover listeners on immediate
            // children of `<body>` due to missing event delegation on iOS
            // Allows 'click' event to bubble up in Safari
            // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
            if (!this.settings.isSubmenu && $.CFW_isTouch) $('body').children().on('mouseover.cfw.dropdown', $.noop);
            this._popperLocate();
            this.$element.CFW_trigger('afterShow.cfw.dropdown', eventProperties);
        },
        hide: function() {
            var eventProperties = {
                relatedTarget: this.$element[0]
            };
            if ($.CFW_isDisabled(this.$element) || !this.$target.hasClass('open')) return;
            if (!this.$element.CFW_trigger('beforeHide.cfw.dropdown', eventProperties)) return;
            // Close any open nested menus - in reverse to close from bottom up
            var $items = this.$target.find('[data-cfw="dropdown"].open');
            for(var i = $items.length; i--;){
                var $trigger = $($items[i]);
                var itemData = $trigger.data('cfw.dropdown');
                if (!itemData) continue;
                $trigger.CFW_Dropdown('_hideComplete');
            }
            this._hideComplete(eventProperties);
        },
        _hideComplete: function(eventProperties) {
            $(document).off('focusin.cfw.dropdown.' + this.instance);
            // Remove empty mouseover listener for iOS work-around
            if (!this.settings.isSubmenu && $.CFW_isTouch) $('body').children().off('mouseover.cfw.dropdown');
            this.$target.removeClass('open');
            this.containerReset();
            this.popperReset();
            this.$element.attr('aria-expanded', 'false').removeClass('open').CFW_trigger('afterHide.cfw.dropdown', eventProperties);
        },
        dispose: function() {
            var $subToggle = this.$target.children('li').children('ul, ol').children('a');
            // Do menu items in reverse to dispose from bottom up
            for(var i = $subToggle.length; i--;)$subToggle[i].eq(0).CFW_Dropdown('dispose');
            this._navDisableHover();
            this.hide();
            $(document).off('.cfw.dropdown.' + this.instance);
            $(window).off('.cfw.dropdown.' + this.instance);
            this.$target.find('.' + this.c.backLink).remove();
            this.$target.off('.cfw.dropdown');
            this.$element.off('.cfw.dropdown').removeData('cfw.dropdown');
            this.$element = null;
            this.$target = null;
            this.instance = null;
            this.timerHide = null;
            this.hasContainer = null;
            this.inNavbar = null;
            this.settings = null;
            if (this.popper) this.popper.destroy();
            this.popper = null;
        }
    };
    var Plugin = function(option) {
        var args = [].splice.call(arguments, 1);
        return this.each(function() {
            var $this = $(this);
            var data = $this.data('cfw.dropdown');
            var options = typeof option === 'object' && option;
            if (!data) $this.data('cfw.dropdown', data = new CFW_Widget_Dropdown(this, options));
            if (typeof option === 'string') data[option].apply(data, args);
        });
    };
    $.fn.CFW_Dropdown = Plugin;
    $.fn.CFW_Dropdown.Constructor = CFW_Widget_Dropdown;
    // Handle closing menu when clicked outside of menu area
    $(window).ready(function() {
        $(document).on('click', clearMenus);
    });
})(jQuery);
/**
 * --------------------------------------------------------------------------
 * Figuration (v4.4.1): tab.js
 * Licensed under MIT (https://github.com/cast-org/figuration/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ (function($) {
    'use strict';
    var CFW_Widget_Tab = function(element, options) {
        this.$element = $(element);
        this.$target = null;
        this.$navElm = null;
        var parsedData = this.$element.CFW_parseData('tab', CFW_Widget_Tab.DEFAULTS);
        this.settings = $.extend({}, CFW_Widget_Tab.DEFAULTS, parsedData, options);
        this._init();
    };
    CFW_Widget_Tab.DEFAULTS = {
        target: null,
        animate: true // If tabs should be allowed fade in and out
    };
    CFW_Widget_Tab.prototype = {
        _init: function() {
            var $selfRef = this;
            // Find nav and target elements
            this.$navElm = this.$element.closest('ul, ol, nav, .nav, .list, .btn-group, .is-tablist');
            if (this.$navElm.length && this.$navElm[0].nodeName.toLowerCase() !== 'nav') this.$navElm.attr('role', 'tablist');
            var $selector = $(this.settings.target);
            if (!$selector.length) $selector = $(this.$element.attr('href'));
            this.$target = $($selector);
            if (!this.$target.length) return;
            this.$element.attr('data-cfw', 'tab');
            // Check for presence of trigger id - set if not present
            var triggerID = this.$element.CFW_getID('cfw-tab');
            // Target should have id already - set ARIA attributes
            this.$target.attr({
                'tabindex': 0,
                'role': 'tabpanel',
                'aria-labelledby': triggerID
            });
            if (this.settings.animate) this.animEnable();
            else this.animDisable();
            // Set ARIA attributes on trigger
            this.$element.attr({
                'tabindex': -1,
                'role': 'tab',
                'aria-selected': 'false',
                'aria-controls': this.$target.attr('id')
            });
            this.$element.parent('li').attr('role', 'presentation');
            // Bind click handler
            this.$element.on('click.cfw.tab', function(e) {
                e.preventDefault();
                $selfRef.show(e);
            });
            // Bind key handler
            this.$element.on('keydown.cfw.tab', function(e) {
                $selfRef._actionsKeydown(e, this);
            });
            // Display panel if trigger is marked active
            if (this.$element.hasClass('active')) {
                this.$element.attr({
                    'tabindex': 0,
                    'aria-selected': 'true'
                });
                this.$target.addClass('active');
                if (this.settings.animate) this.$target.addClass('in');
            }
            // Check to see if there is an active element defined - if not set current one as active
            if (this.$navElm.find('.active').length <= 0) {
                this.$element.addClass('active');
                this.$element.attr({
                    'tabindex': 0,
                    'aria-selected': 'true'
                });
                this.$target.addClass('active');
                if (this.settings.animate) this.$target.addClass('in');
            }
            this.$element.CFW_trigger('init.cfw.tab');
        },
        show: function(e) {
            if (e) e.preventDefault();
            if ($.CFW_isDisabled(this.$element) || this.$element.hasClass('active')) return;
            var $previous = this.$navElm.find('.active');
            var eventHideResult;
            var eventShowResult;
            if ($previous.length) eventHideResult = $previous.last().CFW_trigger('beforeHide.cfw.tab', {
                relatedTarget: this.$element[0]
            });
            eventShowResult = this.$element.CFW_trigger('beforeShow.cfw.tab', {
                relatedTarget: $previous.last()[0]
            });
            if (!eventHideResult || !eventShowResult) return;
            if ($previous.length) $previous.attr({
                'tabindex': -1,
                'aria-selected': 'false'
            });
            this.$element.attr({
                'tabindex': 0,
                'aria-selected': 'true'
            });
            this._activateTab();
        },
        animEnable: function() {
            this.$target.addClass('fade');
            if (this.$target.hasClass('active')) this.$target.addClass('in');
            this.settings.animate = true;
        },
        animDisable: function() {
            this.$target.removeClass('fade in');
            this.settings.animate = false;
        },
        _actionsKeydown: function(e, node) {
            var KEYCODE_UP = 38; // Arrow up
            var KEYCODE_RIGHT = 39; // Arrow right
            var KEYCODE_DOWN = 40; // Arrow down
            var KEYCODE_LEFT = 37; // Arrow left
            var REGEX_KEYS = new RegExp('^(' + KEYCODE_UP + '|' + KEYCODE_RIGHT + '|' + KEYCODE_DOWN + '|' + KEYCODE_LEFT + ')$');
            if (!REGEX_KEYS.test(e.which)) return;
            e.stopPropagation();
            e.preventDefault();
            var $node = $(node);
            var $list = $node.closest('[role="tablist"]');
            var $items = $list.find('[role="tab"]');
            $items = $items.filter(function() {
                return !$.CFW_isDisabled(this) && $.CFW_isVisible(this);
            });
            var index = $items.index($items.filter('[aria-selected="true"]'));
            var doIncrement = e.which === KEYCODE_RIGHT || e.which === KEYCODE_DOWN;
            var $nextTab = $($.CFW_getNextActiveElement($items.toArray(), $items[index], doIncrement, false));
            $nextTab.CFW_Tab('show').trigger('focus');
        },
        _activateTab: function() {
            var $selfRef = this;
            var $items = this.$navElm.find('[role="tab"]');
            var $previous = this.$navElm.find('[role="tab"].active');
            $items.removeClass('active');
            $items.each(function() {
                var $pane = $(this).data('cfw.tab').$target;
                $pane.removeClass('active in');
            });
            if (this.settings.animate) this.animEnable();
            else this.animDisable();
            this.$element.addClass('active');
            this.$target.addClass('active');
            var complete = function() {
                $previous.last().CFW_trigger('afterHide.cfw.tab', {
                    relatedTarget: $selfRef.$element[0]
                });
                $selfRef.$element.CFW_trigger('afterShow.cfw.tab', {
                    relatedTarget: $previous.last()[0]
                });
                $selfRef.$element.CFW_mutateTrigger();
                $selfRef.$target.CFW_mutateTrigger();
            };
            if (this.settings.animate) {
                this.$target.CFW_transition(null, complete);
                $.CFW_reflow(this.$target); // Reflow for transition
                this.$target.addClass('in');
            } else complete();
        },
        dispose: function() {
            this.$element.off('.cfw.tab').removeData('cfw.tab');
            this.$element = null;
            this.$target = null;
            this.$navElm = null;
            this.settings = null;
        }
    };
    var Plugin = function(option) {
        var args = [].splice.call(arguments, 1);
        return this.each(function() {
            var $this = $(this);
            var data = $this.data('cfw.tab');
            var options = typeof option === 'object' && option;
            if (!data) $this.data('cfw.tab', data = new CFW_Widget_Tab(this, options));
            if (typeof option === 'string') data[option].apply(data, args);
        });
    };
    $.fn.CFW_Tab = Plugin;
    $.fn.CFW_Tab.Constructor = CFW_Widget_Tab;
})(jQuery);
/**
 * --------------------------------------------------------------------------
 * Figuration (v4.4.1): affix.js
 * Licensed under MIT (https://github.com/cast-org/figuration/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ (function($) {
    'use strict';
    var CFW_Widget_Affix = function(element, options) {
        this.$element = $(element);
        this.$target = null;
        this.affixed = null;
        this.unpin = null;
        this.pinnedOffset = null;
        var parsedData = this.$element.CFW_parseData('affix', CFW_Widget_Affix.DEFAULTS);
        this.settings = $.extend({}, CFW_Widget_Affix.DEFAULTS, parsedData, options);
        this._init();
    };
    CFW_Widget_Affix.RESET = 'affix affix-top affix-bottom';
    CFW_Widget_Affix.DEFAULTS = {
        target: window,
        top: 0,
        bottom: 0
    };
    CFW_Widget_Affix.prototype = {
        _init: function() {
            this.$element.attr('data-cfw', 'affix');
            // Bind events
            this.$target = $(this.settings.target).on('scroll.cfw.affix', this.checkPosition.bind(this)).on('click.cfw.affix', this.checkPositionDelayed.bind(this));
            this.$element.CFW_trigger('init.cfw.affix');
            this.checkPosition();
        },
        getState: function(scrollHeight, height, offsetTop, offsetBottom) {
            var scrollTop = this.$target.scrollTop();
            var position = this.$element.offset();
            var targetHeight = this.$target.height();
            if (offsetTop !== null && this.affixed === 'top') return scrollTop < offsetTop ? 'top' : false;
            if (this.affixed === 'bottom') {
                if (offsetTop !== null) return scrollTop + this.unpin <= position.top ? false : 'bottom';
                return scrollTop + targetHeight <= scrollHeight - offsetBottom ? false : 'bottom';
            }
            var initializing = this.affixed === null;
            var colliderTop = initializing ? scrollTop : position.top;
            var colliderHeight = initializing ? targetHeight : height;
            if (offsetTop !== null && scrollTop <= offsetTop) return 'top';
            if (offsetBottom !== null && colliderTop + colliderHeight >= scrollHeight - offsetBottom) return 'bottom';
            return false;
        },
        getPinnedOffset: function() {
            if (this.pinnedOffset) return this.pinnedOffset;
            this.$element.removeClass(CFW_Widget_Affix.RESET).addClass('affix');
            var scrollTop = this.$target.scrollTop();
            var position = this.$element.offset();
            this.pinnedOffset = position.top - scrollTop;
            return this.pinnedOffset;
        },
        checkPositionDelayed: function() {
            setTimeout(this.checkPosition.bind(this), 1);
        },
        checkPosition: function() {
            if (!$.CFW_isVisible(this.$element[0])) return;
            var height = this.$element.height();
            var offsetTop = this.settings.top;
            var offsetBottom = this.settings.bottom;
            var scrollHeight = Math.max($(document).height(), $(document.body).height());
            if (typeof offsetTop === 'function') offsetTop = offsetTop(this.$element);
            if (typeof offsetBottom === 'function') offsetBottom = offsetBottom(this.$element);
            var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom);
            if (this.affixed !== affix) {
                if (this.unpin !== null) this.$element.css({
                    top: '',
                    position: ''
                });
                var affixType = 'affix' + (affix ? '-' + affix : '');
                var eventName = affixType + '.cfw.affix';
                if (!this.$element.CFW_trigger(eventName)) return;
                this.affixed = affix;
                this.unpin = affix === 'bottom' ? this.getPinnedOffset() : null;
                this.$element.removeClass(CFW_Widget_Affix.RESET).addClass(affixType).CFW_trigger(eventName.replace('affix', 'affixed'));
            }
            if (affix === 'bottom') this.$element.offset({
                top: scrollHeight - height - offsetBottom
            });
        },
        dispose: function() {
            this.$target.off('.cfw.affix');
            this.$element.removeClass(CFW_Widget_Affix.RESET).removeData('cfw.affix');
            this.$element = null;
            this.$target = null;
            this.affixed = null;
            this.unpin = null;
            this.pinnedOffset = null;
            this.settings = null;
        }
    };
    var Plugin = function(option) {
        var args = [].splice.call(arguments, 1);
        return this.each(function() {
            var $this = $(this);
            var data = $this.data('cfw.affix');
            var options = typeof option === 'object' && option;
            if (!data) $this.data('cfw.affix', data = new CFW_Widget_Affix(this, options));
            if (typeof option === 'string') data[option].apply(data, args);
        });
    };
    $.fn.CFW_Affix = Plugin;
    $.fn.CFW_Affix.Constructor = CFW_Widget_Affix;
})(jQuery);
/**
 * --------------------------------------------------------------------------
 * Figuration (v4.4.1): tooltip.js
 * Licensed under MIT (https://github.com/cast-org/figuration/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ /* global CFW_Focuser */ (function($) {
    'use strict';
    var CFW_Widget_Tooltip = function(element, options) {
        this._init('tooltip', element, options);
    };
    CFW_Widget_Tooltip.DEFAULTS = {
        target: false,
        placement: 'top',
        trigger: 'hover focus',
        display: 'block',
        animate: true,
        delay: {
            show: 0,
            hide: 100 // Delay for hiding tooltip (milliseconds)
        },
        container: false,
        viewport: 'scrollParent',
        padding: 0,
        html: false,
        closetext: '<span aria-hidden="true">&times;</span>',
        closesrtext: 'Close',
        title: '',
        customClass: '',
        show: false,
        unlink: false,
        dispose: false,
        template: '<div class="tooltip"><div class="tooltip-body"></div><div class="tooltip-arrow"></div></div>',
        gpuAcceleration: true,
        popperConfig: null
    };
    CFW_Widget_Tooltip.prototype = {
        _init: function(type, element, options) {
            if (typeof Popper === 'undefined') throw new TypeError('Figurations\'s Tooltip widget requires Popper (https://popper.js.org)');
            this.type = type;
            this.$element = $(element);
            this.$target = null;
            this.$arrow = null;
            this._focuser = null;
            this.instance = null;
            this.isDialog = false;
            this.follow = false;
            this.eventTypes = null;
            this.delayTimer = null;
            this.inTransition = null;
            this.closeAdded = false;
            this.activate = false;
            this.hoverState = null;
            this.dynamicTip = false;
            this.inserted = false;
            this.popper = null;
            this.settings = this.getSettings(options);
            this.inState = {
                click: false,
                hover: false,
                focus: false
            };
            this.disposeOnHide = this.settings.dispose;
            this.unlinkOnHide = this.settings.unlink;
            this.$element.attr('data-cfw', this.type);
            var selector = this.$element.CFW_getSelectorFromChain(this.type, this.settings.target);
            if (selector !== null) this.$target = $(selector);
            else this.fixTitle();
            if (this.settings.show && this.settings.trigger !== 'manual') this.settings.trigger = 'click';
            // Bind events
            this.eventTypes = this.settings.trigger.split(' ');
            this.bindTip(true);
            if (this.$target) this.$target.data('cfw.' + this.type, this);
            if (this.settings.show) {
                this.activate = true;
                this.inState.click = true;
                this.show();
            }
            this.$element.CFW_trigger('init.cfw.' + this.type);
        },
        getDefaults: function() {
            return CFW_Widget_Tooltip.DEFAULTS;
        },
        getSettings: function(options) {
            var parsedData = this.$element.CFW_parseData(this.type, this.getDefaults());
            var settings = $.extend({}, this.getDefaults(), parsedData, options);
            if (settings.delay && typeof settings.delay === 'number') settings.delay = {
                show: settings.delay,
                hide: settings.delay
            };
            return settings;
        },
        createTip: function() {
            var $tip = $(this.settings.template);
            return $tip;
        },
        fixTitle: function() {
            var $e = this.$element;
            var title = typeof $e.attr('title') !== 'undefined' ? $e.attr('title') : null;
            if (title || typeof $e.attr('data-cfw-' + this.type + '-original-title') !== 'string') {
                $e.attr('data-cfw-' + this.type + '-original-title', title || '');
                if (title && typeof $e.attr('aria-label') === 'undefined' && !$e[0].textContent.trim()) $e.attr('aria-label', title || '');
                $e.removeAttr('title');
            }
        },
        getTitle: function() {
            var $e = this.$element;
            var s = this.settings;
            var title = typeof s.title === 'function' ? s.title.call($e[0]) : s.title || $e.attr('data-cfw-' + this.type + '-original-title');
            return title;
        },
        _hasContent: function() {
            return Boolean(this.getTitle());
        },
        setContent: function() {
            var $tip = this.$target;
            var $inner = $tip.find('.tooltip-body');
            if (this.dynamicTip) {
                var title = this.getTitle();
                if (this.settings.html) $inner.html(title);
                else $inner.text(title);
            }
            $tip.removeClass('fade in');
        },
        linkTip: function() {
            // Check for presence of trigger and target ids - set if not present
            this.instance = this.$element.CFW_getID('cfw-' + this.type);
            this.targetID = this.$target.CFW_getID('cfw-' + this.type);
            var attrRole = 'tooltip';
            if (this.type !== 'tooltip' && this.isDialog) attrRole = 'dialog';
            // Set ARIA attributes on target
            this.$target.attr({
                'role': attrRole,
                'aria-hidden': 'true',
                'tabindex': -1
            });
        },
        bindTip: function(modeInit) {
            for(var i = this.eventTypes.length; i--;){
                var eventType = this.eventTypes[i];
                if (eventType === 'click' || eventType === 'manual') this.isDialog = true;
                if (eventType === 'click') {
                    // Click events
                    this.$element.off('click.cfw.' + this.type).on('click.cfw.' + this.type, this.toggle.bind(this));
                    // Inject close button
                    if (this.$target !== null && !this.closeAdded) // Check for pre-existing close buttons
                    {
                        if (!this.$target.find('[data-cfw-dismiss="' + this.type + '"]').length) {
                            var $close = $('<button type="button" class="close" data-cfw-dismiss="' + this.type + '" aria-label="' + this.settings.closesrtext + '">' + this.settings.closetext + '</button>');
                            $close.prependTo(this.$target);
                            this.closeAdded = true;
                        }
                    }
                } else if (eventType !== 'manual') {
                    // Hover/focus events
                    var eventIn = eventType === 'hover' ? 'mouseenter' : 'focusin';
                    var eventOut = eventType === 'hover' ? 'mouseleave' : 'focusout';
                    if (modeInit) {
                        this.$element.on(eventIn + '.cfw.' + this.type, this.enter.bind(this));
                        this.$element.on(eventOut + '.cfw.' + this.type, this.leave.bind(this));
                    } else {
                        this.$target.off('.cfw.' + this.type);
                        this.$target.on(eventIn + '.cfw.' + this.type, this.enter.bind(this));
                        this.$target.on(eventOut + '.cfw.' + this.type, this.leave.bind(this));
                    }
                }
            }
            // Key handling for closing
            this._escape(this.$element);
            this._escape(this.$target);
        },
        _escape: function($elm) {
            var $selfRef = this;
            var KEYCODE_ESC = 27;
            if (!$elm) return;
            $elm.off('keydown.cfw.' + this.type + '.close').on('keydown.cfw.' + this.type + '.close', function(e) {
                if (e.which === KEYCODE_ESC) {
                    // Allow esc to propagate from trigger if tooltip is not showing
                    if ($selfRef.$target && ($elm === $selfRef.$target || $selfRef.$target.hasClass('in'))) e.stopPropagation();
                    $selfRef.dismiss();
                }
            });
        },
        toggle: function(e) {
            if (e) {
                e.preventDefault();
                this.inState.click = !this.inState.click;
                this.follow = true;
                if (this._isInState()) this.enter();
                else this.leave();
            } else {
                // Disable delay when toggle programatically invoked
                var holdDelay = this.settings.delay;
                if (this.$target && this.$target.hasClass('in')) {
                    this.settings.delay.hide = 0;
                    this.leave();
                } else {
                    this.settings.delay.show = 0;
                    this.enter();
                }
                this.settings.delay = holdDelay;
            }
        },
        enter: function(e) {
            if (e) this.inState[e.type === 'focusin' ? 'focus' : 'hover'] = true;
            if (this.$target && this.$target.hasClass('in') || this.hoverState === 'in') {
                this.hoverState = 'in';
                return;
            }
            clearTimeout(this.delayTimer);
            this.hoverState = 'in';
            if (!this.settings.delay.show) {
                this.show();
                return;
            }
            var $selfRef = this;
            this.delayTimer = setTimeout(function() {
                if ($selfRef.hoverState === 'in') $selfRef.show();
            }, this.settings.delay.show);
        },
        leave: function(e) {
            if (e) this.inState[e.type === 'focusout' ? 'focus' : 'hover'] = false;
            if (this._isInState()) return;
            clearTimeout(this.delayTimer);
            this.hoverState = 'out';
            if (!this.settings.delay.hide) {
                this.hide();
                return;
            }
            var $selfRef = this;
            this.delayTimer = setTimeout(function() {
                if ($selfRef.hoverState === 'out') $selfRef.hide();
            }, this.settings.delay.hide);
        },
        show: function() {
            clearTimeout(this.delayTimer);
            if (!this._hasContent() && !this.$target) return;
            // Bail if transition in progress or already shown
            if (this.inTransition) return;
            if (this.$target && this.$target.hasClass('in')) return;
            if (!this.activate) {
                // Start show transition
                if (!this.$element.CFW_trigger('beforeShow.cfw.' + this.type)) return;
            }
            this.inTransition = true;
            // Create/link the tooltip container
            if (!this.$target) {
                var target = this.createTip();
                if (target.length <= 0) return;
                this.dynamicTip = true;
                this.$target = target;
            }
            if (this.$target.length !== 1) throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!');
            this.$target.data('cfw.' + this.type, this);
            this.linkTip();
            this.bindTip(false);
            this.setContent();
            this.$target.css('display', this.settings.display);
            if (this.settings.animate) this.$target.addClass('fade');
            var customClass = typeof this.settings.customClass === 'function' ? this.settings.customClass() : this.settings.customClass;
            if (customClass) this.$target.addClass(customClass);
            this.locateTip();
            // Additional tab/focus handlers for non-inline items
            if (this.settings.container && this.isDialog) {
                this._focuser = new CFW_Focuser({
                    element: this.$target[0],
                    autoFocus: false,
                    flowElement: this.$element[0],
                    flowFocus: true
                });
                this._focuser.activate();
            }
            if ($.CFW_isTouch) // Add empty function for mouseover listeners on immediate
            // children of `<body>` due to missing event delegation on iOS
            // Allows 'click' event to bubble up in Safari
            // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
            $('body').children().on('mouseover', null, $.noop);
            this.$target.CFW_transition(null, this._showComplete.bind(this));
        },
        dismiss: function() {
            this.follow = true;
            this.hide();
        },
        hide: function(force) {
            clearTimeout(this.delayTimer);
            // Handle delayed show and target not created
            if (!this.$target) return;
            if (typeof force === 'undefined') force = false;
            if (force) {
                this._hideComplete();
                return;
            }
            // Bail if transition in progress or already hidden
            if (this.inTransition || !this.$target.hasClass('in')) return;
            // Start hide transition
            if (!this.$element.CFW_trigger('beforeHide.cfw.' + this.type)) return;
            this.inTransition = true;
            this.$target.removeClass('in');
            this.$target.CFW_transition(null, this._hideComplete.bind(this));
        },
        unlink: function(force) {
            var $selfRef = this;
            if (typeof force === 'undefined') force = false;
            clearTimeout(this.delayTimer);
            this.$element.CFW_trigger('beforeUnlink.cfw.' + this.type);
            if (this.$target && this.$target.hasClass('in')) {
                this.$element.one('afterHide.cfw.' + this.type, function() {
                    $selfRef._unlinkComplete();
                });
                this.hide(force);
            } else this._unlinkComplete();
        },
        _unlinkComplete: function() {
            var $element = this.$element;
            var type = this.type;
            // TODO: Change original title to use internal variable instead of data attribute
            var originalTtle = this.$element.attr('data-cfw-' + this.type + '-original-title');
            if (typeof originalTtle !== 'undefined' && originalTtle.length > 0) this.$element.attr('title', originalTtle);
            this.$element.removeAttr('data-cfw-' + this.type + '-original-title');
            if (this.$target) this.$target.off('.cfw.' + this.type).removeData('cfw.' + this.type);
            this.$element.off('.cfw.' + this.type).removeAttr('data-cfw').removeData('cfw.' + this.type);
            this.$element = null;
            this.$target = null;
            this.$arrow = null;
            this._focuser = null;
            this.instance = null;
            this.settings = null;
            this.type = null;
            this.isDialog = null;
            this.follow = null;
            this.eventTypes = null;
            this.delayTimer = null;
            this.inTransition = null;
            this.closeAdded = null;
            this.activate = null;
            this.hoverState = null;
            this.inState = null;
            this.dynamicTip = null;
            this.inserted = null;
            if (this.popper) this.popper.destroy();
            this.popper = null;
            this._unlinkCompleteExt();
            $element.CFW_trigger('afterUnlink.cfw.' + type);
        },
        _unlinkCompleteExt: function() {
        // intentionally empty - unlink complete extend
        },
        dispose: function() {
            var type = this.type;
            var $element = this.$element;
            var $target = this.$target;
            $(document).one('afterUnlink.cfw.' + this.type, this.$element, function() {
                if ($target) $target.remove();
                $element.CFW_trigger('dispose.cfw.' + type, {
                    relatedTarget: $target
                });
            });
            this.unlink();
        },
        _insertTip: function(placement) {
            if (this.inserted) return;
            var $tip = this.$target;
            $tip.detach();
            var shadowRoot = $().CFW_findShadowRoot(this.$element[0]);
            if (shadowRoot !== null && !this.settings.container) this.settings.container = 'body';
            if (typeof placement === 'object') {
                // Custom placement
                this.settings.container = 'body';
                $tip.appendTo(this.settings.container);
            }
            if (this.settings.container) // Container placement
            $tip.appendTo(this.settings.container);
            else // Default placement
            $tip.insertAfter(this.$element);
            this.inserted = true;
            this.$element.CFW_trigger('inserted.cfw.' + this.type);
        },
        locateUpdate: function() {
            if (this.popper !== null) this.popper.scheduleUpdate();
        },
        locateTip: function() {
            var placement = typeof this.settings.placement === 'function' ? this.settings.placement.call(this, this.$target[0], this.$element[0]) : this.settings.placement;
            this._insertTip(placement);
            if (typeof placement === 'object') {
                // Custom placement
                this.$target.offset(placement);
                this.$target.addClass('in');
                return;
            }
            // Standard Placement
            var autoToken = /\s?auto?\s?/i;
            var autoFlip = autoToken.test(this.settings.placement);
            placement = this.settings.placement.replace(autoToken, '');
            // Allow for 'auto' placement
            if (!placement.trim().length) placement = 'auto';
            var attachment = this._getAttachment(placement);
            this._addAttachmentClass(attachment);
            this.$target.addClass('in');
            this.popper = new Popper(this.$element[0], this.$target[0], this._getPopperConfig(attachment, autoFlip));
        },
        _showComplete: function() {
            var $selfRef = this;
            var prevHoverState = this.hoverState;
            this.hoverState = null;
            // this.$target.addClass('in')
            this.$target.removeAttr('aria-hidden').CFW_mutateTrigger();
            // Mutation handlers
            this.$target.attr('data-cfw-mutate', '').CFW_mutationListen().on('mutate.cfw.mutate', function() {
                $selfRef.locateUpdate();
            });
            this.$element.attr('data-cfw-mutate', '').CFW_mutationListen().on('mutate.cfw.mutate', function() {
                if ($(this).is(':hidden')) $selfRef.hide(true);
            });
            if (this.isDialog && this.follow) {
                this.$target.trigger('focus');
                this.follow = false;
            }
            this.inTransition = false;
            // Handle case of immediate dispose after show
            if ($selfRef.$element) $selfRef.$element.attr('aria-describedby', $selfRef.targetID);
            this._showExt();
            if (!this.activate) this.$element.CFW_trigger('afterShow.cfw.' + this.type);
            this.activate = false;
            if (prevHoverState === 'out') this.leave();
        },
        _showExt: function() {
        // intentionally empty - show complete extend
        },
        _hideComplete: function() {
            this._cleanTipClass();
            this.$element.off('.cfw.' + this.type + '.focusStart').off('mutate.cfw.mutate').removeAttr('aria-describedby').removeAttr('data-cfw-mutate').CFW_mutationIgnore();
            this.$target.css('display', 'none').off('.cfw.' + this.type).off('mutate.cfw.mutate').removeClass('in').attr('aria-hidden', true).removeAttr('data-cfw-mutate').CFW_mutationIgnore();
            if (this._focuser) {
                this._focuser.deactivate();
                this._focuser = null;
            }
            if ($.CFW_isTouch) // Remove empty mouseover listener for iOS work-around
            $('body').children().off('mouseover', null, $.noop);
            $(document).off('.cfw.' + this.type + '.' + this.instance);
            $(window).off('.cfw.' + this.type + '.' + this.instance);
            this.inState = {
                click: false,
                hover: false,
                focus: false
            };
            this.hoverState = null;
            this.inTransition = false;
            if (this.isDialog) {
                this.$target.attr('tabindex', -1);
                if (this.follow) this.$element.trigger('focus');
            }
            this.follow = false;
            // Only remove dynamically created tips
            if (this.hoverState !== 'in' && this.dynamicTip) this._removeDynamicTip();
            if (this.popper) this.popper.destroy();
            this._hideExt();
            this.$element.CFW_trigger('afterHide.cfw.' + this.type);
            if (this.disposeOnHide) this.dispose();
            else if (this.unlinkOnHide) this.unlink();
        },
        _hideExt: function() {
        // intentionally empty - hide complete extend
        },
        _removeDynamicTip: function() {
            this._removeDynamicTipExt();
            this.dynamicTip = false;
            this.inserted = false;
            this.closeAdded = false;
            this.$arrow = null;
        },
        _removeDynamicTipExt: function() {
            // remove dynamic tip extend
            this.$target.remove();
            this.$target = null;
        },
        _cleanTipClass: function() {
            var regex = new RegExp('(^|\\s)cfw-' + this.type + '\\S+', 'g');
            if (this.$target) {
                var items = this.$target[0].className.match(regex);
                if (items !== null) for(var i = items.length; i--;)this.$target[0].classList.remove(items[i].trim());
            }
        },
        _handlePopperPlacementChange: function(popperData) {
            this._cleanTipClass();
            this._addAttachmentClass(this._getAttachment(popperData.placement));
        },
        _addAttachmentClass: function(attachment) {
            if (this.$target) this.$target.addClass('cfw-' + this.type + '-' + attachment);
        },
        _isElement: function(node) {
            return (node[0] || node).nodeType;
        },
        _getViewport: function() {
            var viewport = this.settings.viewport;
            if (typeof viewport === 'function') viewport = this.settings.viewport.call(this, this.$element);
            var $viewportElm = $(viewport);
            if (this._isElement($viewportElm)) viewport = $viewportElm[0];
            return viewport;
        },
        _getAttachment: function(placement) {
            if (this.$element) {
                var isRTL = $.CFW_isRTL(this.$element[0]);
                var attachmentMap = {
                    AUTO: 'auto',
                    TOP: 'top',
                    FORWARD: isRTL ? 'left' : 'right',
                    RIGHT: 'right',
                    BOTTOM: 'bottom',
                    REVERSE: isRTL ? 'right' : 'left',
                    LEFT: 'left'
                };
                return attachmentMap[placement.toUpperCase()];
            }
            return CFW_Widget_Tooltip.DEFAULTS.placement;
        },
        _getPopperConfig: function(attachment, autoFlip) {
            var $selfRef = this;
            var defaultConfig = {
                placement: attachment,
                modifiers: {
                    flip: {
                        enabled: autoFlip,
                        behavior: 'flip'
                    },
                    arrow: {
                        element: '.' + this.type + '-arrow'
                    },
                    preventOverflow: {
                        padding: this.settings.padding,
                        boundariesElement: this._getViewport()
                    },
                    computeStyle: {
                        gpuAcceleration: this.settings.gpuAcceleration
                    }
                },
                onCreate: function(data) {
                    if (data.originalPlacement !== data.placement) $selfRef._handlePopperPlacementChange(data);
                },
                onUpdate: function(data) {
                    $selfRef._handlePopperPlacementChange(data);
                }
            };
            // Use deep merge
            var returnConfig = $.extend(true, defaultConfig, this.settings.popperConfig);
            return returnConfig;
        },
        _isInState: function() {
            for(var key in this.inState){
                if (this.inState[key]) return true;
            }
            return false;
        }
    };
    var Plugin = function(option) {
        var args = [].splice.call(arguments, 1);
        return this.each(function() {
            var $this = $(this);
            var data = $this.data('cfw.tooltip');
            var options = typeof option === 'object' && option;
            if (!data && /unlink|dispose|hide/.test(option)) return;
            if (!data) $this.data('cfw.tooltip', data = new CFW_Widget_Tooltip(this, options));
            if (typeof option === 'string') data[option].apply(data, args);
        });
    };
    $.fn.CFW_Tooltip = Plugin;
    $.fn.CFW_Tooltip.Constructor = CFW_Widget_Tooltip;
    $.CFW_enableDismissControl('tooltip', 'dismiss');
})(jQuery);
/**
 * --------------------------------------------------------------------------
 * Figuration (v4.4.1): popover.js
 * Licensed under MIT (https://github.com/cast-org/figuration/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ (function($) {
    'use strict';
    if (typeof $.fn.CFW_Tooltip === 'undefined') throw new Error('CFW_Popover requires CFW_Tooltip');
    var CFW_Widget_Popover = function(element, options) {
        this.dragAdded = false;
        this.keyTimer = null;
        this.keyDelay = 750;
        this._init('popover', element, options);
    };
    CFW_Widget_Popover.DEFAULTS = $.extend({}, $.fn.CFW_Tooltip.Constructor.DEFAULTS, {
        placement: 'top',
        trigger: 'click',
        content: '',
        drag: false,
        dragtext: '<span aria-hidden="true">+</span>',
        dragsrtext: 'Drag',
        dragstep: 10,
        template: '<div class="popover"><h3 class="popover-header"></h3><div class="popover-body"></div><div class="popover-arrow"></div></div>'
    });
    CFW_Widget_Popover.prototype = $.extend({}, $.fn.CFW_Tooltip.Constructor.prototype);
    CFW_Widget_Popover.prototype.constructor = CFW_Widget_Popover;
    CFW_Widget_Popover.prototype.getDefaults = function() {
        return CFW_Widget_Popover.DEFAULTS;
    };
    CFW_Widget_Popover.prototype.createTip = function() {
        var $tip = $(this.settings.template);
        return $tip;
    };
    CFW_Widget_Popover.prototype._hasContent = function() {
        return Boolean(this.getTitle() || this.getContent());
    };
    CFW_Widget_Popover.prototype.setContent = function() {
        var $tip = this.$target;
        var $title = $tip.find('.popover-header');
        var $content = $tip.find('.popover-body');
        if (this.dynamicTip) {
            var title = this.getTitle();
            var content = this.getContent();
            if (this.settings.html) {
                $title.html(title);
                if (typeof content === 'string') $content.html(content);
                else $content.empty().append(content); // Use append for objects to keep js events
            } else {
                $title.text(title);
                $content.text(content);
            }
        // Header gets hidden by :empty CSS rule
        // if (!title && $title) {
        //     $title.remove();
        // }
        }
        // Use '.popover-header' for labelledby
        if ($title.length) {
            var labelledby = $title.eq(0).CFW_getID('cfw-popover');
            this.$target.attr('aria-labelledby', labelledby);
        }
        if (this.settings.drag && !this.dragAdded) {
            if (this.$target.find('[data-cfw-drag="' + this.type + '"]').length <= 0) {
                var $drag = $('<span role="button" tabindex="0" class="drag" data-cfw-drag="' + this.type + '" aria-label="' + this.settings.dragsrtext + '">' + this.settings.dragtext + '</span>');
                $drag.insertAfter(this.$target.find('.close').eq(0));
                this.dragAdded = true;
            }
        }
        if (this.$target.find('[data-cfw-drag="' + this.type + '"]').length) {
            this.$target.addClass('draggable');
            // Force settings
            if (this.settings.trigger !== 'manual') this.settings.trigger = 'click';
            this.settings.container = 'body';
            // Enable drag handlers
            this.enableDrag();
        }
    };
    CFW_Widget_Popover.prototype.getContent = function() {
        var content;
        var $e = this.$element;
        var s = this.settings;
        content = typeof s.content === 'function' ? s.content.call($e[0]) : s.content;
        return content;
    };
    CFW_Widget_Popover.prototype.enableDrag = function() {
        var $selfRef = this;
        var dragOpt = {
            handle: '[data-cfw-drag="' + this.type + '"]'
        };
        // Remove mutation handler and replace resize location handler
        this.$element.on('afterShow.cfw.' + this.type, function() {
            if ($selfRef.popper !== null) $selfRef.popper.disableEventListeners();
            $selfRef.$target.off('mutate.cfw.mutate').removeAttr('data-cfw-mutate').CFW_mutationIgnore();
            $(window).off('resize.cfw.' + $selfRef.type + '.' + $selfRef.instance).on('resize.cfw.' + $selfRef.type + '.' + $selfRef.instance, function() {
                var offset = $selfRef.$target.offset();
                if ($selfRef._isFixed()) {
                    var compStyle = window.getComputedStyle($selfRef.$target[0]);
                    offset.top = parseInt(compStyle.top, 10);
                    offset.left = parseInt(compStyle.left, 10);
                }
                $selfRef.locateDragTip(offset.top, offset.left);
            });
        });
        // Use top/left instead of transforms to position popover
        this.settings.gpuAcceleration = false;
        // Unset any previous drag events
        this.$target.off('.cfw.drag');
        this.$target.on('dragStart.cfw.drag', function(e) {
            if (e.namespace !== 'cfw.drag') return;
            $selfRef._updateZ();
            $selfRef.$element.CFW_trigger('dragStart.cfw.' + $selfRef.type);
        }).on('drag.cfw.drag', function(e) {
            if (e.namespace !== 'cfw.drag') return;
            $selfRef.locateDragTip(e.offsetY, e.offsetX);
        }).on('dragEnd.cfw.drag', function(e) {
            if (e.namespace !== 'cfw.drag') return;
            $selfRef.$element.CFW_trigger('dragEnd.cfw.' + $selfRef.type);
        }).on('keydown.cfw.drag', '[data-cfw-drag="' + this.type + '"]', function(e) {
            var KEYCODE_UP = 38; // Arrow up
            var KEYCODE_RIGHT = 39; // Arrow right
            var KEYCODE_DOWN = 40; // Arrow down
            var KEYCODE_LEFT = 37; // Arrow left
            var REGEX_KEYS = new RegExp('^(' + KEYCODE_UP + '|' + KEYCODE_RIGHT + '|' + KEYCODE_DOWN + '|' + KEYCODE_LEFT + ')$');
            if (!REGEX_KEYS.test(e.which)) return;
            if (e) {
                e.stopPropagation();
                e.preventDefault();
            }
            if (!$selfRef.keyTimer) $selfRef.$element.CFW_trigger('dragStart.cfw.' + $selfRef.type);
            clearTimeout($selfRef.keyTimer);
            // Mitigate most of 'slippage' by rounding offsets
            var nodeOffset = $selfRef.$target.offset();
            var offsetY = Math.round(nodeOffset.top);
            var offsetX = Math.round(nodeOffset.left);
            // If popover is 'fixed' position, use the current coords
            if ($selfRef._isFixed()) {
                var compStyle = window.getComputedStyle($selfRef.$target[0]);
                offsetY = parseInt(compStyle.top, 10);
                offsetX = parseInt(compStyle.left, 10);
            }
            // Revise offset
            var step = $selfRef.settings.dragstep;
            switch(e.which){
                case KEYCODE_LEFT:
                    offsetX -= step;
                    break;
                case KEYCODE_UP:
                    offsetY -= step;
                    break;
                case KEYCODE_RIGHT:
                    offsetX += step;
                    break;
                case KEYCODE_DOWN:
                    offsetY += step;
                    break;
                default:
            }
            // Move it
            $selfRef.locateDragTip(offsetY, offsetX);
            $selfRef.keyTimer = setTimeout(function() {
                $selfRef.$element.CFW_trigger('dragEnd.cfw.' + $selfRef.type);
                $selfRef.keyTimer = null;
            }, $selfRef.keyDelay);
        });
        this.$target.CFW_Drag(dragOpt);
    };
    CFW_Widget_Popover.prototype.getParentNode = function(element) {
        if (element.nodeName === 'HTML') return element;
        return element.parentNode || element.host;
    };
    CFW_Widget_Popover.prototype.getScrollParent = function(element) {
        if (!element) return document.body;
        switch(element.nodeName){
            case 'HTML':
            case 'BODY':
                return element.ownerDocument.body;
            case '#document':
                return element.body;
            default:
        }
        var compStyle = window.getComputedStyle(element);
        if (/^(auto|scroll|overlay)$/.test(compStyle.overflow + compStyle.overflowX + compStyle.overflowY)) return element;
        return this.getScrollParent(this.getParentNode(element));
    };
    CFW_Widget_Popover.prototype.getOwnerBody = function(element) {
        var ownerDocument = element.ownerDocument;
        return ownerDocument ? ownerDocument.body : document.body;
    };
    CFW_Widget_Popover.prototype.viewportDragLimit = function() {
        var limit = {};
        var $viewport = this._getDragViewport();
        var scrollbarWidth = this.viewportScrollbarWidth($viewport);
        limit = $viewport.offset();
        // If popover is 'fixed' position
        if (this._isFixed()) {
            var rect = $viewport[0].getBoundingClientRect();
            limit.top = rect.top;
            limit.bottom = rect.bottom;
            // Use window and update limits if drag viewport is body
            if ($viewport.is('body')) {
                $viewport = $(window);
                limit.top = rect.top + window.pageYOffset;
                limit.left = rect.left + window.pageXOffset;
            }
        }
        limit.bottom = limit.top + $viewport.outerHeight();
        limit.right = limit.left + $viewport.outerWidth() - scrollbarWidth;
        // Allow dragging around entire window if body is smaller than window
        if ($viewport.is('body')) {
            if (document.body.clientHeight < window.innerHeight) limit.bottom = window.innerHeight;
            if (document.body.clientWidth < window.innerWidth) limit.right = window.innerWidth - scrollbarWidth;
        }
        return limit;
    };
    CFW_Widget_Popover.prototype.viewportScrollbarWidth = function($viewport) {
        // Check to see if a scrollbar is possible
        var compStyle = window.getComputedStyle($viewport[0]);
        var hasScrollY = /^(visible|auto|scroll)$/.test(compStyle.overflow) || /^(visible|auto|scroll)$/.test(compStyle.overflowY);
        var scrollHeight = $viewport[0].scrollHeight;
        // Return width of scrollbar if there seems to be one
        if ($viewport.is('body') && hasScrollY && scrollHeight > window.innerHeight) return $.CFW_measureScrollbar();
        else if (hasScrollY && scrollHeight > $viewport[0].clientHeight) return $.CFW_measureScrollbar();
        return 0;
    };
    CFW_Widget_Popover.prototype.locateDragTip = function(offsetY, offsetX) {
        var $tip = this.$target;
        var limit = this.viewportDragLimit();
        var viewportPadding = this.settings.padding;
        $tip.css({
            top: Math.min(limit.bottom - viewportPadding - $tip.outerHeight(), Math.max(limit.top + viewportPadding, offsetY)),
            left: Math.min(limit.right - viewportPadding - $tip.outerWidth(), Math.max(limit.left + viewportPadding, offsetX))
        });
    };
    CFW_Widget_Popover.prototype.hide = function(force) {
        // Fire key drag end if needed
        if (this.keyTimer) {
            this.$element.CFW_trigger('dragEnd.cfw.' + this.type);
            clearTimeout(this.keyTimer);
        }
        // Reset z-index
        this._resetZ(this.$target);
        // Call tooltip hide
        $.fn.CFW_Tooltip.Constructor.prototype.hide.call(this, force);
    };
    CFW_Widget_Popover.prototype._showExt = function() {
        if (this.$target.find('[data-cfw-drag="' + this.type + '"]').length && this._isFixed()) this._handleFixedDragScroll();
    };
    CFW_Widget_Popover.prototype._hideExt = function() {
        $(window).off('resize.cfw.' + this.type + '.' + this.instance).off('scroll.cfw.' + this.type + '.' + this.instance);
    };
    CFW_Widget_Popover.prototype._removeDynamicTipExt = function() {
        this.$target.remove();
        this.$target = null;
        this.dragAdded = false;
    };
    CFW_Widget_Popover.prototype._resetZ = function($item) {
        // Reset z-index if one is already stored
        var savedVal = $item.attr('data-cfw-zindex');
        if (typeof savedVal !== 'undefined') {
            $item.removeAttr('data-cfw-zindex');
            $item[0].style.removeProperty('z-index');
        }
    };
    CFW_Widget_Popover.prototype._updateZ = function() {
        var $selfRef = this;
        // Find highest z-indexed visible popover
        var zMax = 0;
        var $zObj = null;
        $('.popover:visible').each(function() {
            var $item = $(this);
            // Reset z-index
            $selfRef._resetZ($item);
            var zCurr = parseInt($item.css('z-index'), 10);
            if (isNaN(zCurr)) zCurr = 0;
            if (zCurr >= zMax) {
                zMax = zCurr;
                $zObj = $item;
            }
        });
        // Only increase if not highest
        if ($zObj && this.$target[0] !== $zObj[0]) {
            // Store
            var actualVal = this.$target.css('z-index');
            this.$target.attr('data-cfw-zindex', actualVal);
            // Update
            this.$target.css('z-index', parseInt(actualVal, 10) + 1);
        }
    };
    CFW_Widget_Popover.prototype._arrow = function() {
        if (!this.$arrow) this.$arrow = this.$target.find('.arrow, .popover-arrow');
        return this.$arrow;
    };
    CFW_Widget_Popover.prototype._unlinkCompleteExt = function() {
        this.dragAdded = null;
        this.keyTimer = null;
        this.keyDelay = null;
    };
    CFW_Widget_Popover.prototype._getDragViewport = function() {
        var viewport = this._getViewport();
        var $viewport = null;
        if (viewport === 'scrollParent') viewport = this.getScrollParent(this.$target[0]);
        if (viewport === 'window' || viewport === window) viewport = this.getOwnerBody(this.$target[0]);
        $viewport = $(viewport);
        if (!$viewport.length) $viewport = $(document.body);
        return $viewport;
    };
    CFW_Widget_Popover.prototype._isFixed = function() {
        var compStyle = window.getComputedStyle(this.$target[0]);
        return /^(fixed)$/.test(compStyle.position);
    };
    CFW_Widget_Popover.prototype._doFixedDragScroll = function() {
        var offset = {};
        var compStyle = window.getComputedStyle(this.$target[0]);
        offset.top = parseInt(compStyle.top, 10);
        offset.left = parseInt(compStyle.left, 10);
        this.locateDragTip(offset.top, offset.left);
    };
    CFW_Widget_Popover.prototype._handleFixedDragScroll = function() {
        var $viewport = this._getDragViewport();
        $(window).off('scroll.cfw.' + this.type + '.' + this.instance);
        if (!$viewport.is('body')) $(window).on('scroll.cfw.' + this.type + '.' + this.instance, this._doFixedDragScroll.bind(this));
    };
    var Plugin = function(option) {
        var args = [].splice.call(arguments, 1);
        return this.each(function() {
            var $this = $(this);
            var data = $this.data('cfw.popover');
            var options = typeof option === 'object' && option;
            if (!data && /unlink|dispose|hide/.test(option)) return;
            if (!data) $this.data('cfw.popover', data = new CFW_Widget_Popover(this, options));
            if (typeof option === 'string') data[option].apply(data, args);
        });
    };
    $.fn.CFW_Popover = Plugin;
    $.fn.CFW_Popover.Constructor = CFW_Widget_Popover;
    $.CFW_enableDismissControl('popover', 'dismiss');
})(jQuery);
/**
 * --------------------------------------------------------------------------
 * Figuration (v4.4.1): offcanvas.js
 * Licensed under MIT (https://github.com/cast-org/figuration/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ /* global CFW_Backdrop, CFW_Focuser, CFW_Scrollbar */ (function($) {
    'use strict';
    var CFW_Widget_Offcanvas = function(element, options) {
        this.$rootElement = null;
        this.$element = $(element);
        this.$target = null;
        this._backdrop = null;
        this._focuser = null;
        this._scrollbar = null;
        this.isShown = null;
        this.fixedContent = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
        this.stickyContent = '.sticky-top';
        var parsedData = this.$element.CFW_parseData('offcanvas', CFW_Widget_Offcanvas.DEFAULTS);
        this.settings = $.extend({}, CFW_Widget_Offcanvas.DEFAULTS, parsedData, options);
        this._init();
    };
    CFW_Widget_Offcanvas.DEFAULTS = {
        target: false,
        animate: true,
        backdrop: true,
        keyboard: true,
        scroll: false,
        focus: true,
        manual: false,
        rootElement: 'body'
    };
    CFW_Widget_Offcanvas.prototype = {
        _init: function() {
            this.$rootElement = $(this.settings.rootElement);
            if (!this.$rootElement) return;
            var selector = this.$element.CFW_getSelectorFromChain('offcanvas', this.settings.target);
            if (!selector) return;
            this.$target = $(selector);
            this._backdrop = this._initializeBackdrop();
            this._focuser = new CFW_Focuser({
                element: this.$target[0]
            });
            this._scrollbar = new CFW_Scrollbar({
                rootElement: this.settings.rootElement
            });
            this.$element.attr('data-cfw', 'offcanvas');
            // Check for presence of ids - set if not present
            var targetID = this.$target.CFW_getID('cfw-offcanvas');
            // Set ARIA attributes on trigger
            this.$element.attr('aria-controls', targetID);
            // Use '.offcanvas-title' for labelledby
            var $title = this.$target.find('.offcanvas-title');
            if ($title.length) {
                var labelledby = $title.eq(0).CFW_getID('cfw-offcanvas');
                this.$target.attr('aria-labelledby', labelledby);
            }
            this.$target.attr('tabindex', -1);
            // Bind click handler
            if (!this.settings.manual) this.$element.on('click.cfw.offcanvas', this.toggle.bind(this));
            this.$target.data('cfw.offcanvas', this);
            this.$element.CFW_trigger('init.cfw.offcanvas');
        },
        toggle: function(e) {
            if (/a|area/i.test(e.target.tagName)) e.preventDefault();
            if ($.CFW_isDisabled(e.target)) return;
            // Close any other open offcanvas to avoid conflicts
            var offcanvasShow = document.querySelector('[class*=offcanvas].in');
            if (offcanvasShow && offcanvasShow !== this.$target[0]) $(offcanvasShow).CFW_Offcanvas('hide');
            if (this.isShown) this.hide();
            else this.show();
        },
        show: function() {
            var $selfRef = this;
            // Bail if already showing
            if (this.isShown) return;
            // Start open transition
            if (!this.$element.CFW_trigger('beforeShow.cfw.offcanvas')) return;
            this.isShown = true;
            this._backdrop.show();
            if (this._disableScrollbar()) this._scrollbar.disable();
            this.$rootElement.addClass('offcanvas-open');
            this._escape();
            this.$target.attr('aria-modal', true).attr('role', 'dialog');
            if (this.settings.animate) this.$target.addClass('showing');
            this.$target.data('cfw.offcanvas', this);
            $(window).on('resize.cfw.offcanvas', this._handleResize.bind(this));
            var complete = function() {
                $selfRef.$target.addClass('in').removeClass('showing');
                if (!$selfRef.settings.scroll) $selfRef._focuser.activate();
                $selfRef.$element.CFW_trigger('afterShow.cfw.offcanvas');
            };
            this.$target.data('cfw.offcanvas', this);
            this.$target.CFW_transition(null, complete);
        },
        hide: function() {
            var $selfRef = this;
            // Bail if not showing
            if (!this.isShown) return;
            // Start close transition
            if (!this.$element.CFW_trigger('beforeHide.cfw.offcanvas')) return;
            this._focuser.deactivate();
            $(window).off('resize.cfw.offcanvas');
            this.$target.off('.dismiss.cfw.offcanvas').trigger('blur');
            this.isShown = false;
            if (this.settings.animate) this.$target.addClass('hiding');
            this._backdrop.hide();
            var complete = function() {
                $selfRef.$target.removeClass('in hiding').removeAttr('aria-modal role');
                $selfRef.$rootElement.removeClass('offcanvas-open');
                $selfRef._scrollbar.reset();
                $selfRef.$element.CFW_trigger('afterHide.cfw.offcanvas');
                if ($.CFW_isVisible($selfRef.$element) && !$selfRef.settings.manual) $selfRef.$element.trigger('focus');
            };
            this.$target.CFW_transition(null, complete);
        },
        dispose: function() {
            this._backdrop.dispose();
            this._focuser.deactivate();
            this._scrollbar.reset();
            $(window).off('resize.cfw.offcanvas');
            this.$target.off('.cfw.offcanvas').removeData('cfw.offcanvas');
            this.$element.off('.cfw.offcanvas').removeData('cfw.offcanvas');
            this.$rootElement = null;
            this.$element = null;
            this.$target = null;
            this._backdrop = null;
            this._focuser = null;
            this._scrollbar = null;
            this.isShown = null;
            this.settings = null;
        },
        _initializeBackdrop: function() {
            var $selfRef = this;
            return new CFW_Backdrop({
                className: 'offcanvas-backdrop',
                isVisible: Boolean(this.settings.backdrop),
                isAnimated: this.settings.animate,
                rootElement: this.$target.parent(),
                clickCallback: function() {
                    if ($selfRef.settings.backdrop === 'static') $selfRef._hideBlocked();
                    else $selfRef.hide();
                }
            });
        },
        _escape: function() {
            var $selfRef = this;
            var KEYCODE_ESC = 27;
            if (this.isShown) this.$target.on('keydown.dismiss.cfw.offcanvas', function(e) {
                if (e.which === KEYCODE_ESC) {
                    if ($selfRef.settings.keyboard) $selfRef.hide();
                    else $selfRef._hideBlocked();
                }
            });
        },
        _hideBlocked: function() {
            var $selfRef = this;
            if (!this.$target.CFW_trigger('beforeHide.cfw.offcanvas')) return;
            var complete = function() {
                $selfRef.$target.trigger('focus');
                $selfRef.$target.removeClass('offcanvas-blocked');
            };
            this.$target.addClass('offcanvas-blocked');
            this.$target.CFW_transition(null, complete);
        },
        _disableScrollbar: function() {
            var rootWidth = this.$rootElement[0] === document.body ? document.body.offsetWidth : this.$rootElement[0].offsetWidth;
            var rootHeight = this.$rootElement[0] === document.body ? window.innerHeight : this.$rootElement[0].offsetHeight;
            return !this.settings.scroll || this.$target[0].offsetWidth >= rootWidth && this.$target[0].offsetHeight >= rootHeight;
        },
        _isPositioned: function() {
            var position = window.getComputedStyle(this.$target[0], null).getPropertyValue('position');
            return /(fixed|absolute)/i.test(position);
        },
        _handleResize: function() {
            if (!this.isShown) return;
            if (!this._isPositioned()) {
                this.hide();
                return;
            }
            if (this._disableScrollbar()) this._scrollbar.disable();
            else this._scrollbar.reset();
        }
    };
    var Plugin = function(option) {
        var args = [].splice.call(arguments, 1);
        return this.each(function() {
            var $this = $(this);
            var data = $this.data('cfw.offcanvas');
            var options = typeof option === 'object' && option;
            if (!data && /unlink|dispose/.test(option)) return;
            if (!data) $this.data('cfw.offcanvas', data = new CFW_Widget_Offcanvas(this, options));
            if (typeof option === 'string') data[option].apply(data, args);
        });
    };
    $.fn.CFW_Offcanvas = Plugin;
    $.fn.CFW_Offcanvas.Constructor = CFW_Widget_Offcanvas;
    $.CFW_enableDismissControl('offcanvas', 'hide');
})(jQuery);
/**
 * --------------------------------------------------------------------------
 * Figuration (v4.4.1): modal.js
 * Licensed under MIT (https://github.com/cast-org/figuration/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ /* global CFW_Backdrop, CFW_Focuser, CFW_Scrollbar */ (function($) {
    'use strict';
    var CFW_Widget_Modal = function(element, options) {
        this.$rootElement = null;
        this.$element = $(element);
        this.$target = null;
        this.$dialog = null;
        this._backdrop = null;
        this._focuser = null;
        this._scrollbar = null;
        this.isShown = null;
        this.fixedContent = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
        this.stickyContent = '.sticky-top';
        this.ignoreBackdropClick = false;
        var parsedData = this.$element.CFW_parseData('modal', CFW_Widget_Modal.DEFAULTS);
        this.settings = $.extend({}, CFW_Widget_Modal.DEFAULTS, parsedData, options);
        this._init();
    };
    CFW_Widget_Modal.DEFAULTS = {
        target: false,
        animate: true,
        unlink: false,
        dispose: false,
        backdrop: true,
        keyboard: true,
        manual: false,
        show: false,
        focus: true,
        rootElement: 'body'
    };
    CFW_Widget_Modal.prototype = {
        _init: function() {
            this.$rootElement = $(this.settings.rootElement);
            if (!this.$rootElement) return;
            var selector = this.$element.CFW_getSelectorFromChain('modal', this.settings.target);
            if (!selector) return;
            this.$target = $(selector);
            this.$dialog = this.$target.find('.modal-dialog');
            this._backdrop = this._initializeBackdrop();
            this._focuser = new CFW_Focuser({
                element: this.$target[0]
            });
            this._scrollbar = new CFW_Scrollbar({
                rootElement: this.settings.rootElement
            });
            this.$element.attr('data-cfw', 'modal');
            this.disposeOnHide = this.settings.dispose;
            this.unlinkOnHide = this.settings.unlink;
            // Check for presence of ids - set if not present
            // var triggerID = this.$element.CFW_getID('cfw-modal');
            var targetID = this.$target.CFW_getID('cfw-modal');
            // Set ARIA attributes on trigger
            this.$element.attr('aria-controls', targetID);
            // Use '.modal-title' for labelledby
            var $title = this.$target.find('.modal-title');
            if ($title.length) {
                var labelledby = $title.eq(0).CFW_getID('cfw-modal');
                this.$target.attr('aria-labelledby', labelledby);
            }
            // Set ARIA attributes on target
            this.$target.attr({
                'role': 'dialog',
                'aria-hidden': 'true',
                'tabindex': -1
            });
            // Bind click handler
            if (!this.settings.manual) this.$element.on('click.cfw.modal', this.toggle.bind(this));
            this.$target.data('cfw.modal', this);
            this.$target.CFW_trigger('init.cfw.modal');
            if (this.settings.show) this.show();
        },
        toggle: function(e) {
            if (e) e.preventDefault();
            if (this.isShown) this.hide();
            else this.show();
        },
        show: function() {
            var $selfRef = this;
            // Bail if already showing
            if (this.isShown) return;
            // Start open transition
            if (!this.$target.CFW_trigger('beforeShow.cfw.modal')) return;
            this.isShown = true;
            this._scrollbar.disable();
            this.$target.CFW_trigger('scrollbarSet.cfw.modal');
            this.$rootElement.addClass('modal-open');
            this.escape();
            this.resize();
            this.$target.data('cfw.modal', this);
            // Chained modals
            this.$target.on('click.chain.cfw.modal', '[data-cfw-modal-chain]', function(e) {
                if (e) {
                    e.stopImmediatePropagation();
                    e.preventDefault();
                }
                $selfRef.chain(e.currentTarget.getAttribute('data-cfw-modal-chain'));
            }).find('[data-cfw-modal-chain]').each(function() {
                var $dest = $(this.getAttribute('data-cfw-modal-chain'));
                if (!$dest.length) return;
                $dest.one('beforeShow.cfw.modal', function(e) {
                    e.preventDefault();
                });
            });
            this.$dialog.on('mousedown.dismiss.cfw.modal', function() {
                $selfRef.$target.one('mouseup.dismiss.cfw.modal', function(e) {
                    if ($(e.target).is($selfRef.$target)) $selfRef.ignoreBackdropClick = true;
                });
            });
            this.backdrop(function() {
                $selfRef._showComplete();
            });
        },
        hide: function() {
            // Bail if not showing
            if (!this.isShown) return;
            // Start close transition
            if (!this.$target.CFW_trigger('beforeHide.cfw.modal')) return;
            this.isShown = false;
            this._focuser.deactivate();
            this.$target.removeClass('in').attr('aria-hidden', true).removeAttr('aria-modal').off('.dismiss.cfw.modal').off('.chain.cfw.modal');
            // Unset chained override
            this.$target.find('[data-cfw-modal-chain]').each(function() {
                var $dest = $(this.getAttribute('data-cfw-modal-chain'));
                if (!$dest.length) return;
                $dest.off('beforeShow.cfw.modal');
            });
            this.$dialog.off('mousedown.dismiss.cfw.modal');
            // Use modal dialog, not modal container, since
            // that is where the animation happens
            this.$dialog.CFW_transition(null, this._hideComplete.bind(this));
        },
        _showComplete: function() {
            var $selfRef = this;
            var $modalBody = this.$dialog.find('.modal-body');
            if (this.settings.animate) this.$target.addClass('fade');
            if (!this.$target.parent().length) // Don't move modals dom position
            this.$target.appendTo(this.$rootElement);
            this.$target.css('display', 'block');
            if ($modalBody.length) $modalBody.scrollTop(0); // scrollable body variant
            this.$dialog.scrollTop(0); // fullscreen variant
            this.$target.scrollTop(0);
            this.adjustDialog();
            $.CFW_reflow(this.$target[0]); // Force Reflow
            this.$target.addClass('in').removeAttr('aria-hidden').attr('aria-modal', true);
            // Mutation handler
            this.$target.attr('data-cfw-mutate', '')// If enabled will cause infinite loop of updates
            // .CFW_mutationListen()
            .on('mutate.cfw.mutate', function() {
                $selfRef.handleUpdate();
            });
            if (this.settings.focus) this._focuser.activate();
            var complete = function() {
                $selfRef.$target.CFW_mutateTrigger().CFW_trigger('afterShow.cfw.modal');
            };
            // Use modal dialog, not modal container, since
            // that is where the animation happens
            this.$dialog.CFW_transition(null, complete);
        },
        _hideComplete: function() {
            var $selfRef = this;
            this.escape();
            this.resize();
            this.$target.off('mutate.cfw.mutate').removeAttr('data-cfw-mutate').CFW_mutationIgnore().css('display', 'none');
            if (!this.settings.manual) this.$element.trigger('focus');
            this.backdrop(function() {
                $selfRef.$rootElement.removeClass('modal-open');
                $selfRef.resetAdjustments();
                $selfRef._scrollbar.reset();
                $selfRef.$target.CFW_trigger('scrollbarReset.cfw.modal');
                $selfRef.$target.CFW_mutateTrigger().CFW_trigger('afterHide.cfw.modal');
                if ($selfRef.disposeOnHide) $selfRef.dispose();
                else if ($selfRef.unlinkOnHide) $selfRef.unlink();
            });
        },
        handleHide: function(e) {
            if (e.currentTarget === this.$parent[0]) return;
            if (!$.CFW_isDisabled(e.currentTarget)) this.close();
        },
        chain: function(selector) {
            var $dest = $(selector);
            if (!$dest.length) return;
            if (this.isShown) {
                this.$target.one('afterHide.cfw.modal', function() {
                    $dest.CFW_Modal('show');
                });
                this.hide();
            } else $dest.CFW_Modal('show');
        },
        escape: function() {
            var $selfRef = this;
            var KEYCODE_ESC = 27;
            if (!this.isShown) this.$target.off('keydown.dismiss.cfw.modal');
            if (this.isShown) this.$target.on('keydown.dismiss.cfw.modal', function(e) {
                if (e.which === KEYCODE_ESC) {
                    if ($selfRef.settings.keyboard) $selfRef.hide();
                    else $selfRef.hideBlocked();
                }
            });
        },
        resize: function() {
            if (this.isShown) $(window).on('resize.cfw.modal', this.handleUpdate.bind(this));
            else $(window).off('resize.cfw.modal');
        },
        // these following methods are used to handle overflowing modals
        handleUpdate: function() {
            this.adjustDialog();
        },
        adjustDialog: function() {
            var modalIsOverflowing = this.$target[0].scrollHeight > document.documentElement.clientHeight;
            var scrollbarWidth = this._scrollbar.getScrollbarWidth();
            var bodyIsOverflowing = this._scrollbar.isOverflowing();
            this.$target.css({
                paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? scrollbarWidth : '',
                paddingRight: bodyIsOverflowing && !modalIsOverflowing ? scrollbarWidth : ''
            });
        },
        resetAdjustments: function() {
            this.$target.css({
                paddingLeft: '',
                paddingRight: ''
            });
        },
        _initializeBackdrop: function() {
            return new CFW_Backdrop({
                isVisible: Boolean(this.settings.backdrop),
                isAnimated: this.settings.animate,
                rootElement: this.settings.rootElement
            });
        },
        backdrop: function(callback) {
            var $selfRef = this;
            if (this.isShown && this.settings.backdrop) {
                this.$target.on('click.dismiss.cfw.modal', function(e) {
                    if ($selfRef.ignoreBackdropClick) {
                        $selfRef.ignoreBackdropClick = false;
                        return;
                    }
                    if (e.target !== e.currentTarget) return;
                    if ($selfRef.settings.backdrop === 'static') $selfRef.hideBlocked();
                    else $selfRef.hide();
                });
                this._backdrop.show(callback);
            } else if (!this.isShown && this._backdrop) this._backdrop.hide(callback);
            else if (callback) callback();
        },
        hideBlocked: function() {
            var $selfRef = this;
            if (!this.$target.CFW_trigger('beforeHide.cfw.modal')) return;
            var complete = function() {
                $selfRef.$target.trigger('focus');
                $selfRef.$target.removeClass('modal-blocked');
            };
            this.$target.addClass('modal-blocked');
            this.$dialog.CFW_transition(null, complete);
        },
        unlink: function() {
            var $selfRef = this;
            this.$target.CFW_trigger('beforeUnlink.cfw.modal');
            if (this.isShown) {
                this.$target.one('afterHide.cfw.modal', function() {
                    $selfRef._unlinkComplete();
                });
                this.hide();
            } else this._unlinkComplete();
        },
        _unlinkComplete: function() {
            var $target = this.$target;
            this.$target.off('.cfw.modal').removeAttr('aria-labelledby').removeData('cfw.modal');
            this.$element.off('.cfw.modal').removeAttr('data-cfw aria-controls').removeData('cfw.modal');
            this.$rootElement = null;
            this.$element = null;
            this.$target = null;
            this.$dialog = null;
            this._backdrop = null;
            this._focustrsp = null;
            this._scrollbar = null;
            this.isShown = null;
            this.fixedContent = null;
            this.ignoreBackdropClick = null;
            this.settings = null;
            $target.CFW_trigger('afterUnlink.cfw.modal');
        },
        dispose: function() {
            $(document).one('afterUnlink.cfw.modal', this.$target, function(e) {
                var $this = $(e.target);
                $this.CFW_trigger('dispose.cfw.modal');
                $this.remove();
            });
            this._backdrop.dispose();
            this._focuser.deactivate();
            this.unlink();
        }
    };
    var Plugin = function(option) {
        var args = [].splice.call(arguments, 1);
        return this.each(function() {
            var $this = $(this);
            var data = $this.data('cfw.modal');
            var options = typeof option === 'object' && option;
            if (!data && /unlink|dispose/.test(option)) return;
            if (!data) $this.data('cfw.modal', data = new CFW_Widget_Modal(this, options));
            if (typeof option === 'string') data[option].apply(data, args);
        });
    };
    $.fn.CFW_Modal = Plugin;
    $.fn.CFW_Modal.Constructor = CFW_Widget_Modal;
    $.CFW_enableDismissControl('modal', 'hide');
})(jQuery);
/**
 * --------------------------------------------------------------------------
 * Figuration (v4.4.1): accordion.js
 * Licensed under MIT (https://github.com/cast-org/figuration/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ (function($) {
    'use strict';
    if (typeof $.fn.CFW_Collapse === 'undefined') throw new Error('CFW_Accordion requires CFW_Collapse');
    var CFW_Widget_Accordion = function(element) {
        this.$element = $(element);
        this._init();
    };
    CFW_Widget_Accordion.prototype = {
        _init: function() {
            var $selfRef = this;
            this.$element.attr('data-cfw', 'accordion').on('beforeShow.cfw.collapse', function(e) {
                if (e.isDefaultPrevented()) return;
                $selfRef._update(e);
            }).CFW_trigger('init.cfw.accordion');
        },
        _update: function(e) {
            var inTransition = false;
            var $current = $(e.target);
            var $collapse = this.$element.find('[data-cfw="collapse"]');
            $collapse.each(function() {
                if ($(this).data('cfw.collapse').inTransition === 1) inTransition = true;
            });
            if (inTransition) {
                e.preventDefault();
                return;
            }
            $collapse.not($current).CFW_Collapse('hide');
        },
        dispose: function() {
            this.$element.off('.cfw.collapse').removeData('cfw.accordion');
            this.$element = null;
        }
    };
    var Plugin = function(option) {
        var args = [].splice.call(arguments, 1);
        return this.each(function() {
            var $this = $(this);
            var data = $this.data('cfw.accordion');
            if (!data) $this.data('cfw.accordion', data = new CFW_Widget_Accordion(this));
            if (typeof option === 'string') data[option].apply(data, args);
        });
    };
    $.fn.CFW_Accordion = Plugin;
    $.fn.CFW_Accordion.Constructor = CFW_Widget_Accordion;
})(jQuery);
/**
 * --------------------------------------------------------------------------
 * Figuration (v4.4.1): tab-responsive.js
 * Licensed under MIT (https://github.com/cast-org/figuration/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ (function($) {
    'use strict';
    if (typeof $.fn.CFW_Tab === 'undefined') throw new Error('CFW_TabResponsive requires CFW_Tab');
    if (typeof $.fn.CFW_Collapse === 'undefined') throw new Error('CFW_TabResponsive requires CFW_Collapse');
    var CFW_Widget_TabResponsive = function(element) {
        this.$element = $(element);
        this._init();
    };
    CFW_Widget_TabResponsive.prototype = {
        _init: function() {
            var $selfRef = this;
            this.$element.attr('data-cfw', 'tabResponsive');
            // Set tab -> collapse
            this.$element.on('beforeShow.cfw.tab', function(e) {
                if (e.isDefaultPrevented()) return;
                $selfRef.updateCollapse(e.target);
            });
            // Set collapse -> tab
            this.$element.on('beforeShow.cfw.collapse', function(e) {
                if (e.isDefaultPrevented()) return;
                $selfRef.updateTab(e.target);
            });
            // Remove animations (needs to be revisited)
            this.$element.find('[data-cfw="tab"]').CFW_Tab('animDisable');
            this.$element.find('[data-cfw="collapse"]').CFW_Collapse('animDisable');
            var active = this.$element.find('[data-cfw="tab"].active');
            this.updateCollapse(active);
            this.$element.CFW_trigger('init.cfw.tabResponsive');
        },
        // Open the collapse element in the active panel
        // Closes all related collapse items first
        updateCollapse: function(node) {
            var $activeTab = $(node);
            var data = $($activeTab).data('cfw.tab');
            if (data) {
                var $activePane = data.$target;
                var $paneContainer = $activePane.closest('.tab-content');
                $paneContainer.find('[data-cfw="collapse"]').each(function() {
                    $(this).one('afterHide.cfw.collapse', function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                    }).CFW_Collapse('hide');
                });
                var $collapseItem = $activePane.find('[data-cfw="collapse"]');
                $collapseItem.one('afterShow.cfw.collapse', function(e) {
                    e.stopPropagation();
                    e.preventDefault();
                }).CFW_Collapse('show');
            }
        },
        // Set parent panel to active when collapse called
        // Close all other collapse items
        updateTab: function(node) {
            var $activeCollapse = $(node);
            var $paneParent = $activeCollapse.closest('.tab-pane');
            var $paneID = $paneParent.attr('id');
            var $paneContainer = $activeCollapse.closest('.tab-content');
            $paneContainer.find('[data-cfw="collapse"]').each(function() {
                var $this = $(this);
                if ($this[0] === $activeCollapse[0]) return;
                $this.CFW_Collapse('hide');
            });
            var $tabList = this.$element.find('[data-cfw="tab"]');
            $tabList.each(function() {
                var $this = $(this);
                var selector = $this.attr('data-cfw-tab-target');
                if (!selector) selector = $this.attr('href');
                selector = selector.replace(/^#/, '');
                if (selector === $paneID) $this.one('beforeShow.cfw.tab', function(e) {
                    e.stopPropagation();
                }).CFW_Tab('show');
            });
        },
        dispose: function() {
            this.$element.off('.cfw.tab .cfw.collapse').removeData('cfw.tabResponsive');
            this.$element = null;
            this.settings = null;
        }
    };
    var Plugin = function(option) {
        var args = [].splice.call(arguments, 1);
        return this.each(function() {
            var $this = $(this);
            var data = $this.data('cfw.tabResponsive');
            if (!data) $this.data('cfw.tabResponsive', data = new CFW_Widget_TabResponsive(this));
            if (typeof option === 'string') data[option].apply(data, args);
        });
    };
    $.fn.CFW_TabResponsive = Plugin;
    $.fn.CFW_TabResponsive.Constructor = CFW_Widget_TabResponsive;
})(jQuery);
/**
 * --------------------------------------------------------------------------
 * Figuration (v4.4.1): slideshow.js
 * Licensed under MIT (https://github.com/cast-org/figuration/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ (function($) {
    'use strict';
    if (typeof $.fn.CFW_Tab === 'undefined') throw new Error('CFW_Slideshow requires CFW_Tab');
    var CFW_Widget_Slideshow = function(element, options) {
        this.$element = $(element);
        this.$navPrev = this.$element.find('[data-cfw-slideshow-nav="prev"]');
        this.$navNext = this.$element.find('[data-cfw-slideshow-nav="next"]');
        var parsedData = this.$element.CFW_parseData('slideshow', CFW_Widget_Slideshow.DEFAULTS);
        this.settings = $.extend({}, CFW_Widget_Slideshow.DEFAULTS, parsedData, options);
        this._init();
    };
    CFW_Widget_Slideshow.DEFAULTS = {
        loop: false
    };
    CFW_Widget_Slideshow.prototype = {
        _init: function() {
            var $selfRef = this;
            this.$element.attr('data-cfw', 'slideshow');
            // All tabs - regardless of state
            var $tabs = this.$element.find('[role="tab"]');
            if (!$tabs.length) return;
            // Listen for tabs
            this.$element.on('afterShow.cfw.tab', function() {
                $selfRef.update();
            });
            // Bind nav
            this.$navPrev.on('click.cfw.slideshow', function(e) {
                e.preventDefault();
                if (!$.CFW_isDisabled(e.target)) $selfRef.prev();
            });
            this.$navNext.on('click.cfw.slideshow', function(e) {
                e.preventDefault();
                if (!$.CFW_isDisabled(e.target)) $selfRef.next();
            });
            // Replace keydown handler to handle loop
            $tabs.off('keydown.cfw.tab').add(this.$navPrev).add(this.$navNext).on('keydown.cfw.slideshow', function(e) {
                $selfRef._actionsKeydown(e);
            });
            this.update();
            this.$element.CFW_trigger('init.cfw.slideshow');
        },
        prev: function() {
            var $tabs = this._getTabs();
            var currIndex = this._currIndex($tabs);
            var $newTab = $($.CFW_getNextActiveElement($tabs.toArray(), $tabs[currIndex], false, this.settings.loop));
            if ($newTab.length) {
                this.$element.CFW_trigger('prev.cfw.slideshow');
                $newTab.CFW_Tab('show');
            }
        },
        next: function() {
            var $tabs = this._getTabs();
            var currIndex = this._currIndex($tabs);
            var $newTab = $($.CFW_getNextActiveElement($tabs.toArray(), $tabs[currIndex], true, this.settings.loop));
            if ($newTab.length) {
                this.$element.CFW_trigger('next.cfw.slideshow');
                $newTab.CFW_Tab('show');
            }
        },
        update: function() {
            $.CFW_controlEnable(this.$navPrev);
            $.CFW_controlEnable(this.$navNext);
            var $tabs = this._getTabs();
            var currIndex = this._currIndex($tabs);
            if (currIndex <= 0 && !this.settings.loop) $.CFW_controlDisable(this.$navPrev);
            if (currIndex >= $tabs.length - 1 && !this.settings.loop) $.CFW_controlDisable(this.$navNext);
            this.$element.CFW_trigger('update.cfw.slideshow');
        },
        _getTabs: function() {
            var $items = this.$element.find('[role="tab"]');
            $items = $items.filter(function() {
                return !$.CFW_isDisabled(this) && $.CFW_isVisible(this);
            });
            return $items;
        },
        _currIndex: function($tabs) {
            var $node = $tabs.filter('.active');
            return $tabs.index($node);
        },
        _actionsKeydown: function(e) {
            var KEYCODE_UP = 38; // Arrow up
            var KEYCODE_RIGHT = 39; // Arrow right
            var KEYCODE_DOWN = 40; // Arrow down
            var KEYCODE_LEFT = 37; // Arrow left
            var REGEX_KEYS = new RegExp(KEYCODE_UP + '|' + KEYCODE_RIGHT + '|' + KEYCODE_DOWN + '|' + KEYCODE_LEFT);
            if (!REGEX_KEYS.test(e.which)) return;
            e.preventDefault();
            if (e.which === KEYCODE_UP || e.which === KEYCODE_LEFT) this.prev();
            if (e.which === KEYCODE_DOWN || e.which === KEYCODE_RIGHT) this.next();
            if (e.currentTarget !== this.$navPrev[0] && e.currentTarget !== this.$navNext[0]) {
                var $tabs = this._getTabs();
                var currIndex = this._currIndex($tabs);
                $tabs.eq(currIndex).trigger('focus');
            }
        },
        dispose: function() {
            if (this.settings.loop) {
                var $tabs = this.$element.find('[role="tab"]');
                $tabs.off('keydown.cfw.tab');
            }
            this.$navPrev.off('.cfw.slideshow');
            this.$navNext.off('.cfw.slideshow');
            this.$element.off('.cfw.tab').removeData('cfw.slideshow');
            this.$element = null;
            this.$navPrev = null;
            this.$navNext = null;
            this.settings = null;
        }
    };
    var Plugin = function(option) {
        var args = [].splice.call(arguments, 1);
        return this.each(function() {
            var $this = $(this);
            var data = $this.data('cfw.Slideshow');
            var options = typeof option === 'object' && option;
            if (!data) $this.data('cfw.Slideshow', data = new CFW_Widget_Slideshow(this, options));
            if (typeof option === 'string') data[option].apply(data, args);
        });
    };
    $.fn.CFW_Slideshow = Plugin;
    $.fn.CFW_Slideshow.Constructor = CFW_Widget_Slideshow;
})(jQuery);
/**
 * --------------------------------------------------------------------------
 * Figuration (v4.4.1): scrollspy.js
 * Licensed under MIT (https://github.com/cast-org/figuration/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ (function($) {
    'use strict';
    var CFW_Widget_Scrollspy = function(element, options) {
        this.$body = $('body');
        this.$element = $(element);
        this.$scrollElement = this.$element.is('body') ? $(window) : this.$element;
        this.selector = null;
        this.offsets = [];
        this.targets = [];
        this.activeTarget = null;
        this.scrollHeight = 0;
        var parsedData = this.$element.CFW_parseData('scrollspy', CFW_Widget_Scrollspy.DEFAULTS);
        this.settings = $.extend({}, CFW_Widget_Scrollspy.DEFAULTS, parsedData, options);
        this._init();
    };
    CFW_Widget_Scrollspy.DEFAULTS = {
        target: null,
        offset: 10,
        nested: true,
        throttle: 100
    };
    CFW_Widget_Scrollspy.prototype = {
        _init: function() {
            if (this.$element[0] !== this.$body[0]) this.$element.attr('tabindex', 0);
            this.$scrollElement.on('scroll.cfw.scrollspy', $.CFW_throttle(this.process.bind(this), this.settings.throttle));
            this.selector = (this.settings.target || '') + ' a, ' + (this.settings.target || '') + ' [data-cfw-scrollspy-target]';
            this.$scrollElement.CFW_trigger('init.cfw.scrollspy');
            this.refresh();
            this.process();
        },
        getScrollHeight: function() {
            return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight);
        },
        refresh: function() {
            var $selfRef = this;
            var offsetMethod = 'offset';
            var offsetBase = 0;
            if (this.$scrollElement[0] !== null && this.$scrollElement[0] !== this.$scrollElement[0].window) {
                offsetMethod = 'position';
                offsetBase = this.$scrollElement.scrollTop();
            }
            this.offsets = [];
            this.targets = [];
            this.scrollHeight = this.getScrollHeight();
            this.$body.find(this.selector).map(function() {
                var $el = $(this);
                var href = $el.attr('data-cfw-scrollspy-target') || $el.attr('href');
                var $href = /^#./.test(href) && $(href);
                return $href && $href.length && $href.is(':visible') && // && $el.is(':visible') &&
                [
                    [
                        $href[offsetMethod]().top + offsetBase,
                        href
                    ]
                ] || null;
            }).sort(function(a, b) {
                return a[0] - b[0];
            }).each(function() {
                $selfRef.offsets.push(this[0]);
                $selfRef.targets.push(this[1]);
            });
        },
        process: function() {
            var scrollTop = this.$scrollElement.scrollTop() + this.settings.offset;
            var scrollHeight = this.getScrollHeight();
            var maxScroll = this.settings.offset + scrollHeight - this.$scrollElement.height();
            var offsets = this.offsets;
            var targets = this.targets;
            var activeTarget = this.activeTarget;
            var i;
            if (this.scrollHeight !== scrollHeight) this.refresh();
            if (scrollTop >= maxScroll) {
                var target = targets[targets.length - 1];
                if (activeTarget !== target) this.activate(target);
                return;
            }
            if (activeTarget && scrollTop < offsets[0] && offsets[0] > 0) {
                this.activeTarget = null;
                this.clear();
                return;
            }
            for(i = offsets.length; i--;){
                var isActiveTarget = activeTarget !== targets[i] && scrollTop >= offsets[i] && (typeof offsets[i + 1] === 'undefined' || scrollTop < offsets[i + 1]);
                if (isActiveTarget) this.activate(targets[i]);
            }
        },
        activate: function(target) {
            this.activeTarget = target;
            this.clear();
            var selector = this.settings.target + ' [href="' + target + '"],' + this.settings.target + ' [data-cfw-scrollspy-target="' + target + '"]';
            var $active = $(selector).addClass('active');
            var doNestedDropdown = this.settings.nested === true || typeof this.settings.nested === 'string';
            if ($active.closest('.dropdown-menu').length && doNestedDropdown) $active = $active.closest('.dropdown').find('[data-cfw="dropdown"]').addClass('active');
            else if (this.settings.nested === true) // Set parents as active
            $active.parents('ul, ol, nav').prev('li, a').addClass('active');
            $active.CFW_trigger('activate.cfw.scrollspy');
        },
        clear: function() {
            $(this.selector).filter('.active').removeClass('active');
        },
        dispose: function() {
            this.$scrollElement.off('.cfw.scrollspy');
            this.$element.removeData('cfw.scrollspy');
            this.$body = null;
            this.$element = null;
            this.$scrollElement = null;
            this.selector = null;
            this.offsets = null;
            this.targets = null;
            this.activeTarget = null;
            this.scrollHeight = null;
            this.settings = null;
        }
    };
    var Plugin = function(option) {
        var args = [].splice.call(arguments, 1);
        return this.each(function() {
            var $this = $(this);
            var data = $this.data('cfw.scrollspy');
            var options = typeof option === 'object' && option;
            if (!data) $this.data('cfw.scrollspy', data = new CFW_Widget_Scrollspy(this, options));
            if (typeof option === 'string') data[option].apply(data, args);
        });
    };
    $.fn.CFW_Scrollspy = Plugin;
    $.fn.CFW_Scrollspy.Constructor = CFW_Widget_Scrollspy;
})(jQuery);
/**
 * --------------------------------------------------------------------------
 * Figuration (v4.4.1): alert.js
 * Licensed under MIT (https://github.com/cast-org/figuration/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ (function($) {
    'use strict';
    var CFW_Widget_Alert = function(element, options) {
        this.$element = $(element);
        this.$parent = null;
        this.inTransition = null;
        var parsedData = this.$element.CFW_parseData('alert', CFW_Widget_Alert.DEFAULTS);
        this.settings = $.extend({}, CFW_Widget_Alert.DEFAULTS, parsedData, options);
        this._init();
    };
    CFW_Widget_Alert.DEFAULTS = {
        target: null,
        animate: true // If alert targets should fade out
    };
    CFW_Widget_Alert.prototype = {
        _init: function() {
            var $selfRef = this;
            this.findParent();
            this.$element.data('cfw.alert', this).on('click.cfw.alert', function(e) {
                $selfRef.close(e);
            });
            this.$parent.CFW_trigger('init.cfw.alert');
        },
        handleClose: function(e) {
            if (e.currentTarget === this.$parent[0]) return;
            // Update settings from the trigger data
            var parsedData = $(e.currentTarget).CFW_parseData('alert', CFW_Widget_Alert.DEFAULTS);
            this.settings = $.extend({}, CFW_Widget_Alert.DEFAULTS, parsedData);
            this.findParent();
            this.close(e);
        },
        close: function(e) {
            var $selfRef = this;
            if (e && $.CFW_isDisabled(e.currentTarget)) return;
            if (this.inTransition) return;
            if (!this.$parent.CFW_trigger('beforeClose.cfw.alert')) return;
            if (this.settings.animate) this.$parent.addClass('fade in');
            this.inTransition = 1;
            var removeElement = function() {
                // Detach from parent, fire event then clean up data
                $selfRef.$parent.detach().CFW_trigger('afterClose.cfw.alert');
                $selfRef.$parent.remove();
                $selfRef.inTransition = 0;
            };
            this.$parent.removeClass('in').CFW_mutateTrigger().CFW_transition(null, removeElement);
        },
        findParent: function() {
            var selector = this.$element.CFW_getSelectorFromChain('alert', this.settings.target);
            if (selector) this.$parent = $(selector);
            else this.$parent = this.$element.closest('.alert');
        },
        dispose: function() {
            this.$element.off('.cfw.alert').removeData('cfw.alert');
            this.$element = null;
            this.$parent = null;
            this.inTransition = null;
            this.settings = null;
        }
    };
    var Plugin = function(option) {
        var args = [].splice.call(arguments, 1);
        return this.each(function() {
            var $this = $(this);
            var data = $this.data('cfw.alert');
            var options = typeof option === 'object' && option;
            if (!data) $this.data('cfw.alert', data = new CFW_Widget_Alert(this, options));
            if (typeof option === 'string') data[option].apply(data, args);
        });
    };
    $.fn.CFW_Alert = Plugin;
    $.fn.CFW_Alert.Constructor = CFW_Widget_Alert;
    $.CFW_enableDismissControl('alert', 'handleClose');
})(jQuery);
/**
 * --------------------------------------------------------------------------
 * Figuration (v4.4.1): lazy.js
 * Licensed under MIT (https://github.com/cast-org/figuration/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ (function($) {
    'use strict';
    var CFW_Widget_Lazy = function(element, options) {
        this.$element = $(element);
        this.$window = $(window);
        this.instance = null;
        this.inTransition = null;
        var parsedData = this.$element.CFW_parseData('lazy', CFW_Widget_Lazy.DEFAULTS);
        this.settings = $.extend({}, CFW_Widget_Lazy.DEFAULTS, parsedData, options);
        this._init();
    };
    CFW_Widget_Lazy.DEFAULTS = {
        src: '',
        throttle: 250,
        trigger: 'scroll resize mutate',
        delay: 0,
        animate: false,
        threshold: 0,
        container: window,
        invisible: false,
        placeholder: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
    };
    CFW_Widget_Lazy.prototype = {
        _init: function() {
            var checkInitViewport = false;
            this.$element.attr('data-cfw', 'lazy');
            this.settings.delay = parseInt(this.settings.delay, 10);
            if (isNaN(this.settings.delay) || this.settings.delay < 0) this.settings.delay = CFW_Widget_Lazy.DEFAULTS.delay;
            // Add placeholder if src is not defined
            if (this.$element.attr('src') === '' || typeof this.$element.attr('src') === 'undefined' || this.$element.attr('src') === false) {
                if (this.$element.is('img')) this.$element.attr('src', this.settings.placeholder);
            }
            this.instance = this.$element.CFW_getID('cfw-lazy');
            // Bind events
            var eventTypes = this.settings.trigger.split(' ');
            for(var i = eventTypes.length; i--;){
                var eventType = eventTypes[i];
                if (eventType === 'scroll' || eventType === 'resize') {
                    $(this.settings.container).on(eventType + '.cfw.lazy.' + this.instance, $.CFW_throttle(this._handleTrigger.bind(this), this.settings.throttle));
                    checkInitViewport = true;
                } else if (eventType === 'mutate') this.$element.attr('data-cfw-mutate', '').on('mutate.cfw.mutate', this._handleTrigger.bind(this));
                else this.$element.on(eventType + '.cfw.lazy', this.show.bind(this));
            }
            this.$element.CFW_trigger('init.cfw.lazy');
            if (checkInitViewport && this.inViewport()) this.show();
        },
        inViewport: function() {
            if (!this.settings.invisible && !$.CFW_isVisible(this.$element)) return false;
            return !this.belowFold() && !this.afterRight() && !this.aboveTop() && !this.beforeLeft();
        },
        belowFold: function() {
            var fold;
            if (this.settings.container === window) fold = (window.innerHeight ? window.innerHeight : this.$window.height()) + this.$window.scrollTop();
            else fold = $(this.settings.container).offset().top + $(this.settings.container).height();
            return fold <= this.$element.offset().top - this.settings.threshold;
        },
        afterRight: function() {
            var fold;
            if (this.settings.container === window) fold = this.$window.width() + this.$window.scrollLeft();
            else fold = $(this.settings.container).offset().left + $(this.settings.container).width();
            return fold <= this.$element.offset().left - this.settings.threshold;
        },
        aboveTop: function() {
            var fold;
            if (this.settings.container === window) fold = this.$window.scrollTop();
            else fold = $(this.settings.container).offset().top;
            return fold >= this.$element.offset().top + this.settings.threshold + this.$element.height();
        },
        beforeLeft: function() {
            var fold;
            if (this.settings.container === window) fold = this.$window.scrollLeft();
            else fold = $(this.settings.container).offset().left;
            return fold >= this.$element.offset().left + this.settings.threshold + this.$element.width();
        },
        loadSrc: function() {
            var $selfRef = this;
            this.$element.attr('src', this.settings.src);
            $.CFW_imageLoaded(this.$element, this.instance, function() {
                var complete = function() {
                    $selfRef.$element.removeClass('lazy in');
                    $selfRef.$element.CFW_trigger('afterShow.cfw.lazy');
                    $selfRef.dispose();
                };
                // Use slight delay when setting `.in` so animation occurs
                var DELAY_ANIMATION = 15;
                if ($selfRef.settings.animate) $selfRef.$element.addClass('lazy');
                setTimeout(function() {
                    $selfRef.$element.addClass('in').CFW_transition(null, complete);
                }, DELAY_ANIMATION);
            });
        },
        show: function() {
            var $selfRef = this;
            if (this.inTransition) return;
            if (!this.$element.CFW_trigger('beforeShow.cfw.lazy')) return;
            this.inTransition = true;
            setTimeout(function() {
                $selfRef.loadSrc();
            }, $selfRef.settings.delay);
        },
        _handleTrigger: function() {
            // Handle delayed event calls by checking for null
            if (this.$element !== null) {
                if (this.inViewport()) this.show();
            }
        },
        dispose: function() {
            $(this.settings.container).off('.cfw.lazy.' + this.instance);
            this.$element.off('.cfw.lazy').off('load.cfw.imageLoaded.' + this.instance).off('.cfw.mutate').removeData('cfw.lazy').removeAttr('data-cfw').removeAttr('data-cfw-mutate');
            this.$element = null;
            this.$window = null;
            this.instance = null;
            this.inTransition = null;
            this.settings = null;
        }
    };
    var Plugin = function(option) {
        var args = [].splice.call(arguments, 1);
        return this.each(function() {
            var $this = $(this);
            var data = $this.data('cfw.lazy');
            var options = typeof option === 'object' && option;
            if (!data) $this.data('cfw.lazy', data = new CFW_Widget_Lazy(this, options));
            if (typeof option === 'string') data[option].apply(data, args);
        });
    };
    $.fn.CFW_Lazy = Plugin;
    $.fn.CFW_Lazy.Constructor = CFW_Widget_Lazy;
})(jQuery);
/**
 * --------------------------------------------------------------------------
 * Figuration (v4.4.1): equalize.js
 * Licensed under MIT (https://github.com/cast-org/figuration/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ (function($) {
    'use strict';
    var CFW_Widget_Equalize = function(element, options) {
        this.$element = $(element);
        this.$target = null;
        this.$window = $(window);
        this.instance = '';
        var parsedData = this.$element.CFW_parseData('equalize', CFW_Widget_Equalize.DEFAULTS);
        this.settings = $.extend({}, CFW_Widget_Equalize.DEFAULTS, parsedData, options);
        this._init();
    };
    CFW_Widget_Equalize.DEFAULTS = {
        target: '',
        throttle: 250,
        stack: false,
        row: false,
        minimum: false // Use minimum height
    };
    CFW_Widget_Equalize.prototype = {
        _init: function() {
            var $selfRef = this;
            // Get group ID
            var groupID = this.settings.target;
            if (typeof groupID === 'undefined' || groupID.length <= 0) return;
            // Find target by id/css selector
            this.$target = $(groupID, this.$element);
            if (!this.$target.length) // Get group items
            this.$target = $('[data-cfw-equalize-group="' + groupID + '"]', this.$element);
            if (!this.$target.length) return;
            this.instance = $('<div/>').CFW_getID('cfw-equalize');
            if (this._hasNested()) this.$element.on('afterEqual.cfw.equalize', function(e) {
                if (e.target !== $selfRef.$element[0]) $selfRef._equalize();
            });
            this.$target.CFW_mutationListen();
            this.$element.attr('data-cfw-mutate', '').on('mutate.cfw.mutate', this._equalize.bind(this));
            this.$window.on('resize.cfw.equalize.' + this.instance, $.CFW_throttle(this._equalize.bind(this), this.settings.throttle));
            this.$element.attr('data-cfw', 'equalize');
            this.$element.CFW_trigger('init.cfw.equalize');
            this.update();
        },
        _hasNested: function() {
            return this.$element.find('[data-cfw="equalize"]').length > 0;
        },
        _isNested: function() {
            return this.$element.parentsUntil(document.body, '[data-cfw="equalize"]').length > 0;
        },
        _isStacked: function($targetElm) {
            if (!$targetElm[0] || !$targetElm[1]) return false;
            return $targetElm[0].getBoundingClientRect().top !== $targetElm[1].getBoundingClientRect().top;
        },
        _equalize: function() {
            var $targetElm = this.$target.filter(':visible');
            if (!$targetElm.length) return;
            if (!this.$element.CFW_trigger('beforeEqual.cfw.equalize')) return;
            this._equalizeGroup($targetElm);
            this.$element.CFW_trigger('afterEqual.cfw.equalize');
        },
        _equalizeGroup: function($targetElm) {
            // Stop mutation listener to stop possible infinite loop
            this.$target.CFW_mutationIgnore();
            $targetElm.height('');
            if (!this.settings.row && !this.settings.stack) {
                this._applyHeight($targetElm);
                return;
            }
            if (!this.settings.stack && this._isStacked($targetElm)) return;
            if (this.settings.row) this._equalizeByRow($targetElm);
            else this._applyHeight($targetElm);
        },
        _equalizeByRow: function($targetElm) {
            var $selfRef = this;
            var total = $targetElm.length;
            var topOffset = $targetElm.first().offset().top;
            var rowOffset = 0;
            var $rowElm = $();
            $targetElm.each(function(count) {
                var $node = $(this);
                rowOffset = $node.offset().top;
                if (rowOffset !== topOffset) {
                    // Update current row
                    if ($rowElm.length > 1) $selfRef._applyHeight($rowElm);
                    // Start new row and get revised offset
                    $rowElm = $();
                    topOffset = $node.offset().top;
                }
                // Continue on row
                $rowElm = $rowElm.add($node);
                // If last element - update remaining heights
                if (count === total - 1) $selfRef._applyHeight($rowElm);
            });
        },
        _applyHeight: function($nodes, callback) {
            var heights = $nodes.map(function() {
                return $(this).outerHeight(false);
            }).get();
            var newHeight = this.settings.minimum ? Math.min.apply(null, heights) : Math.max.apply(null, heights);
            $nodes.css('height', newHeight);
            // Restart mutation listeners that were stopped at start of `_equalize()`
            this.$target.CFW_mutationListen();
            if (!callback) return;
            callback();
        },
        update: function() {
            var $selfRef = this;
            var $images = this.$element.find('img');
            if (!$images.length) $images.each(function() {
                $.CFW_imageLoaded($(this), $selfRef.instance, function() {
                    $selfRef._equalize();
                });
            });
            this._equalize();
        },
        dispose: function() {
            this.$window.off('.cfw.equalize.' + this.instance);
            this.$element.off('mutate.cfw.mutate').removeAttr('data-cfw-mutate').removeData('cfw.equalize').find('img').off('load.cfw.imageLoaded.' + this.instance);
            this.$target.CFW_mutationIgnore();
            this.$element = null;
            this.$target = null;
            this.$window = null;
            this.instance = null;
            this.settings = null;
        }
    };
    var Plugin = function(option) {
        var args = [].splice.call(arguments, 1);
        return this.each(function() {
            var $this = $(this);
            var data = $this.data('cfw.equalize');
            var options = typeof option === 'object' && option;
            if (!data) $this.data('cfw.equalize', data = new CFW_Widget_Equalize(this, options));
            if (typeof option === 'string') data[option].apply(data, args);
        });
    };
    $.fn.CFW_Equalize = Plugin;
    $.fn.CFW_Equalize.Constructor = CFW_Widget_Equalize;
})(jQuery);
/* eslint-disable no-magic-numbers */ /**
 * --------------------------------------------------------------------------
 * Figuration (v4.4.1): player.js
 * Licensed under MIT (https://github.com/cast-org/figuration/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ (function($) {
    'use strict';
    // Borrowed on 12/05/2014 from: https://github.com/Modernizr/Modernizr/blob/master/feature-detects/audio.js
    var audioTest = function() {
        var elem = document.createElement('audio');
        var bool = false;
        /* eslint-disable no-cond-assign, no-implicit-coercion, no-new-wrappers */ try {
            if (bool = !!elem.canPlayType) {
                bool = new Boolean(bool);
                bool.ogg = elem.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, '');
                bool.mp3 = elem.canPlayType('audio/mpeg;').replace(/^no$/, '');
                bool.opus = elem.canPlayType('audio/ogg; codecs="opus"') || elem.canPlayType('audio/webm; codecs="opus"').replace(/^no$/, '');
                // Mimetypes accepted:
                // http://developer.mozilla.org/En/Media_formats_supported_by_the_audio_and_video_elements
                // http://bit.ly/iphoneoscodecs
                bool.wav = elem.canPlayType('audio/wav; codecs="1"').replace(/^no$/, '');
                bool.m4a = (elem.canPlayType('audio/x-m4a;') || elem.canPlayType('audio/aac;')).replace(/^no$/, '');
            }
        } catch (e) {}
        /* eslint-enable no-cond-assign, no-implicit-coercion, no-new-wrappers */ return bool;
    };
    // Borrowed on 12/05/2014 from: https://github.com/Modernizr/Modernizr/blob/master/feature-detects/video.js
    var videoTest = function() {
        var elem = document.createElement('video');
        var bool = false;
        /* eslint-disable no-cond-assign, no-implicit-coercion, no-new-wrappers */ try {
            if (bool = !!elem.canPlayType) {
                bool = new Boolean(bool);
                bool.ogg = elem.canPlayType('video/ogg; codecs="theora"').replace(/^no$/, '');
                // Without QuickTime, this value will be `undefined`. github.com/Modernizr/Modernizr/issues/546
                bool.h264 = elem.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/, '');
                bool.webm = elem.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/, '');
                bool.vp9 = elem.canPlayType('video/webm; codecs="vp9"').replace(/^no$/, '');
                bool.hls = elem.canPlayType('application/x-mpegURL; codecs="avc1.42E01E"').replace(/^no$/, '');
            }
        } catch (e) {}
        /* eslint-enable no-cond-assign, no-implicit-coercion, no-new-wrappers */ return bool;
    };
    var html5 = {
        audio: null,
        video: null
    };
    html5.audio = audioTest();
    html5.video = videoTest();
    var CFW_Widget_Player = function(element, options) {
        this.$element = $(element);
        this.type = 'audio';
        this.$media = null;
        this.media = null;
        this.$player = null;
        this.$focus = null;
        this.$sources = null;
        this.$sliderSeek = null;
        this.$volSeek = null;
        this.activity = null;
        this.over = null;
        this.userActive = true;
        this.activityTimer = null;
        this.mouseActivity = null;
        this.played = false;
        this.status = {
            duration: 0,
            currentTime: 0,
            remaining: 0
        };
        this.support = {
            mute: true,
            volume: true
        };
        this.trackValid = [];
        this.trackCurrent = -1;
        this.$captionWrapper = null;
        // Transcript
        this.$scriptElm = null;
        this.scriptCurrent = -1;
        this.scriptCues = null;
        this.seekPoint = '.player-transcript-seekpoint, .player-description-seekpoint';
        // Description for transcript
        this.descCurrent = -1;
        this.descCues = null;
        // Text-based description for screen reader
        this.trackDescription = [];
        this.$textDescribeElm = null;
        this.textDescribeCurrent = -1;
        this.textDescribeCues = null;
        var parsedData = this.$element.CFW_parseData('player', CFW_Widget_Player.DEFAULTS);
        this.settings = $.extend({}, CFW_Widget_Player.DEFAULTS, parsedData, options);
        this._init();
    };
    CFW_Widget_Player.DEFAULTS = {
        mediaDescribe: false,
        textDescribe: -1,
        textDescribeAnnounce: false,
        textDescribeVisible: true,
        transcript: -1,
        transcriptScroll: true,
        transcriptDescribe: true,
        transcriptOption: true // Show transcript options
    };
    CFW_Widget_Player.prototype = {
        _init: function() {
            this.$media = this.$element.find('audio, video');
            this.media = this.$media[0];
            if (typeof this.media === 'undefined') return;
            if (this.media.nodeName.toLowerCase() === 'video') this.type = 'video';
            if (this.type === 'audio' && !html5.audio || this.type === 'video' && !html5.video) {
                this.$media.CFW_trigger('noSupport.cfw.player');
                return;
            }
            // Save source items for later use
            this.$sources = this.$media.find('source');
            if (!this.$sources.length) return;
            // Also set data attr for original source
            this.$sources.each(function() {
                $(this).attr('data-src-orig', $(this).attr('src'));
            });
            this.$element.attr('data-cfw', 'player').addClass('player-unstarted');
            this.$player = this.$element.find('[data-cfw-player="player"]');
            if (this.$player.length > 0) // Hide browsers default player
            this.media.controls = false;
            // Swap to description media
            if (this.settings.mediaDescribe) this.description();
            // Check if loaded
            // this.loadCheck();
            this.loadComplete();
        },
        insertPlayer: function() {
            var $newPlayer = $(document.createElement('div')).addClass('player');
            // Insert player
            this.$media.after($newPlayer);
        },
        loadCheck: function() {
            /* Need better method - do not use for now - assume media loads fine */ var $selfRef = this;
            var timeout = 0;
            // Work around some players wehre track is not loaded until played
            try {
                this.media.play();
                this.media.pause();
            } catch (e) {
                this.error();
                return;
            }
            var isLoaded = setInterval(function() {
                var NETWORK_NO_SOURCE = 3;
                var TIMEOUT_MAX_COUNT = 75;
                if ($selfRef.media.readyState > 0) {
                    clearInterval(isLoaded);
                    $selfRef.loadComplete();
                    return;
                }
                if ($selfRef.media.networkState === NETWORK_NO_SOURCE || timeout === TIMEOUT_MAX_COUNT) {
                    clearInterval(isLoaded);
                    $selfRef.error();
                    return;
                }
                timeout++;
            }, 50);
        },
        loadComplete: function() {
            var $selfRef = this;
            // Attach event handlers
            this.$media.on('error', function() {
                $selfRef.error();
            });
            this.$media.on('play canplay pause', function() {
                $selfRef.controlStatus();
                $selfRef.playedStatus();
            });
            this.$media.on('loadedmetadata loadeddata progress canplay canplaythrough timeupdate durationchange', function() {
                $selfRef.playedStatus();
                $selfRef.timeStatus();
                $selfRef.seekStatus();
            });
            this.$media.on('ended', function() {
                $selfRef.seekReset();
            });
            this.$media.on('volumechange', function() {
                $selfRef.muteStatus();
                $selfRef.volumeStatus();
            });
            if (this.type === 'video') {
                // http://stackoverflow.com/questions/9621499/fullscreen-api-which-events-are-fired
                $(document).on('webkitfullscreenchange mozfullscreenchange MSFullscreenChange fullscreenchange', function() {
                    $selfRef.fullscreenStatus();
                });
                this.$player.on('mouseenter mouseleave', function(e) {
                    $selfRef.activity = true;
                    /* eslint-disable default-case */ switch(e.type){
                        case 'mouseenter':
                            $selfRef.over = true;
                            break;
                        case 'mouseleave':
                            $selfRef.over = false;
                            break;
                    }
                /* eslint-enable default-case */ });
                this.$element.on('mousemove mousedown mouseup keydown keyup touchmove touchstart touchend', function(e) {
                    $selfRef.activity = true;
                    /* eslint-disable default-case */ switch(e.type){
                        case 'mousedown':
                        case 'touchstart':
                            clearInterval($selfRef.mouseActivity);
                            $selfRef.mouseActivity = setInterval(function() {
                                $selfRef.activity = true;
                            }, 250);
                            break;
                        case 'mouseup':
                        case 'touchend':
                            clearInterval($selfRef.mouseActivity);
                            break;
                    }
                /* eslint-enable default-case */ });
                this.$media.on('click', function() {
                    $selfRef.toggle();
                    $selfRef._focusHelper();
                });
                this.activityInit();
            }
            // Link controls
            this.$player.on('click', '[data-cfw-player="play"]', function(e) {
                e.preventDefault();
                $selfRef.media.play();
                $selfRef._focusControl($selfRef.$player.find('[data-cfw-player="pause"]')[0]);
            });
            this.$player.on('click', '[data-cfw-player="pause"]', function(e) {
                e.preventDefault();
                $selfRef.media.pause();
                $selfRef._focusControl($selfRef.$player.find('[data-cfw-player="play"]')[0]);
            });
            this.$player.on('click', '[data-cfw-player="stop"]', function(e) {
                e.preventDefault();
                $selfRef.stop();
                $selfRef._focusControl(this);
            });
            this.$player.on('click', '[data-cfw-player="mute"]', function(e) {
                e.preventDefault();
                $selfRef.mute();
                $selfRef._focusControl(this);
            });
            this.$player.on('click', '[data-cfw-player="loop"]', function(e) {
                e.preventDefault();
                $selfRef.loop();
                $selfRef._focusControl(this);
            });
            this.$player.on('click', '[data-cfw-player="fullscreen"]', function(e) {
                e.preventDefault();
                $selfRef.fullscreen();
                $selfRef._focusControl(this);
            });
            this.$player.on('click', '[data-cfw-player="description"]', function(e) {
                e.preventDefault();
                $selfRef.description();
                $selfRef._focusControl(this);
            });
            // Key handler
            this.$element.on('keydown', function(e) {
                $selfRef._actionsKeydown(e);
            });
            // Update indicators
            this.controlStatus();
            this.volumeSupport();
            this.timeStatus();
            this.seekStatus();
            this.muteStatus();
            this.volumeStatus();
            this.loopStatus();
            // Check for caption container {
            var $captionWrapper = this.$element.find('[data-cfw-player="caption-display"]');
            if ($captionWrapper.length) {
                this.$captionWrapper = $captionWrapper;
                // Hide wrapper to start
                this.captionDisplayUpdate(null);
            }
            this.trackList();
            this.trackInit();
            this.scriptInit();
            this.textDescriptionInit();
            this.$player.addClass('ready');
            // Inject focus helper item
            var focusDiv = document.createElement('div');
            focusDiv.className = 'player-focus sr-only';
            focusDiv.tabIndex = '-1';
            this.$focus = $(focusDiv);
            this.$element.prepend(this.$focus);
            this.$media.CFW_trigger('ready.cfw.player');
            // Handle element attributes
            if (this.media.autoplay) this.media.play();
            // Mutation handlers
            this.$element.attr('data-cfw-mutate', '').CFW_mutationListen().on('mutate.cfw.mutate', function() {
                if ($(this).is(':hidden')) $selfRef.media.pause();
            });
        },
        error: function() {
            this.$media.CFW_trigger('error.cfw.player');
        },
        toggle: function() {
            if (this.media.paused) {
                this.playedStatus(true);
                this.media.play();
            } else this.media.pause();
        },
        play: function() {
            this.playedStatus(true);
            this.media.play();
        },
        pause: function() {
            this.media.pause();
        },
        stop: function() {
            this.media.pause();
            this.seekTo(0.0);
        },
        controlStatus: function() {
            var $ctlElm = this.$player.find('[data-cfw-player="control"]');
            var $playElm = this.$player.find('[data-cfw-player="play"]');
            var $pauseElm = this.$player.find('[data-cfw-player="pause"]');
            $ctlElm.removeClass('pause play');
            $playElm.add($pauseElm).removeClass('on off').addClass('off');
            if (this.media.paused) {
                // Paused/stopped
                $ctlElm.addClass('pause');
                $playElm.removeClass('off').addClass('on');
                this.$element.addClass('player-paused');
            } else {
                // Playing
                $ctlElm.addClass('play');
                $pauseElm.removeClass('off').addClass('on');
                this.$element.removeClass('player-paused');
            }
        },
        playedStatus: function(force) {
            if (typeof force === 'undefined') force = false;
            if (!this.played) {
                if (force || this.media.played.length > 0) {
                    this.played = true;
                    this.$element.removeClass('player-unstarted');
                }
            }
        },
        timeStatus: function() {
            this.status.duration = this.media.duration;
            this.status.currentTime = this.media.currentTime;
            this.status.remaining = this.status.duration - this.status.currentTime;
            if (this.status.remaining < 0) this.status.remaining = 0;
            var $durElm = this.$player.find('[data-cfw-player="time-duration"]');
            var $curElm = this.$player.find('[data-cfw-player="time-current"]');
            var $remElm = this.$player.find('[data-cfw-player="time-remainder"]');
            if (this.status.duration > 0) this.$player.removeClass('player-notime');
            else this.$player.addClass('player-notime');
            if (this.status.duration === Infinity) this.$player.addClass('player-live');
            else this.$player.removeClass('player-live');
            $durElm.html(this.timeSplit(this.status.duration));
            $curElm.html(this.timeSplit(this.status.currentTime));
            $remElm.html(this.timeSplit(this.status.remaining));
        },
        timeSplit: function(t) {
            if (isNaN(t) || t === Infinity) t = 0;
            var hours = Math.floor(t / 3600);
            var minutes = Math.floor(t / 60) - hours * 60;
            var seconds = Math.floor(t) - hours * 3600 - minutes * 60;
            var timeStr = this.timeDigits(minutes) + ':' + this.timeDigits(seconds);
            if (hours > 0) timeStr = hours + ':' + timeStr;
            if (timeStr.indexOf('0') === 0) timeStr = timeStr.substr(1);
            return timeStr;
        },
        timeDigits: function(t) {
            return ('0' + t).slice(-2);
        },
        seekStatus: function() {
            var $seekElm = this.$player.find('[data-cfw-player="seek"]');
            if ($seekElm.find('input[type="range"]').length) this.seekRange();
            else this.seekProgress();
        },
        seekRange: function() {
            var $selfRef = this;
            if (isNaN(this.media.duration) || this.media.duration === Infinity) return;
            var $seekElm = this.$player.find('[data-cfw-player="seek"]');
            var $inputElm = $seekElm.find('input[type="range"]').eq(0);
            if (this.$sliderSeek === null) {
                this.$sliderSeek = $inputElm;
                $inputElm.prop({
                    min: 0,
                    max: this.media.duration,
                    step: 1 // 1-second step
                });
                // Update on both `onchange` and `oninput` events. Seems to
                // help with jumping back to previous timestamp.
                $inputElm.on('change input', function() {
                    var newTime = parseFloat($inputElm.val());
                    // Pause/resume when changing
                    var isPaused = $selfRef.media.paused;
                    $selfRef.media.pause();
                    $selfRef.seekTo(newTime);
                    if (!isPaused) $selfRef.media.play();
                });
                // Allow keyboard to do the proper thing here
                $inputElm.on('keydown', function(e) {
                    if (e.type === 'keydown') e.stopPropagation();
                    $(this).off('keyup.cfw.playerSeek');
                    $(this).one('keyup.cfw.playerSeek', function(e) {
                        if (e.type === 'keyup') e.stopPropagation();
                    });
                });
            }
            $inputElm.val(this.media.currentTime);
            // Output a more meaningful description text
            var timeText = this.timeSplit(this.media.currentTime) + ' / ' + this.timeSplit(this.media.duration);
            $inputElm.attr('aria-valuetext', timeText);
        },
        seekProgress: function() {
            if (isNaN(this.media.duration) || this.media.duration === Infinity) return;
            var $curElm = this.$player.find('[data-cfw-player="seek-current"]');
            // Handle legacy and revised (v4.4.1+) progress bar
            // - determine if '.progress-bar' element is child or current element
            var $barElm = $curElm.children('.progress-bar').length > 0 ? $curElm.children('.progress-bar').first() : $curElm;
            var cp = this.media.currentTime / this.media.duration * 100;
            if (cp > 100) cp = 100;
            $curElm.attr({
                'role': 'progressbar',
                'aria-label': 'Playback progress',
                'aria-valuemin': 0,
                'aria-valuemax': 100,
                'aria-valuenow': cp
            });
            $barElm.css('width', cp + '%');
        },
        seekReset: function() {
            if (!this.media.loop) this.media.pause();
            else this.media.play();
        },
        seekIncrement: function(delta) {
            var time = this.media.currentTime + delta;
            if (time < 0) time = 0;
            if (time > this.media.duration) time = this.media.duration;
            this.seekTo(time);
        },
        seekTo: function(timestamp) {
            var seekable = this.media.seekable;
            if (seekable.length > 0 && timestamp >= seekable.start(0) && timestamp <= seekable.end(0)) this.media.currentTime = timestamp;
        },
        mute: function() {
            this.media.muted = !this.media.muted;
            this.muteStatus();
            this.volumeStatus();
        },
        muteStatus: function() {
            var $muteElm = this.$player.find('[data-cfw-player="mute"]');
            if (!this.support.mute) $.CFW_controlDisable($muteElm);
            else if (this.media.muted) $muteElm.addClass('active');
            else $muteElm.removeClass('active');
        },
        volumeSupport: function() {
            var muted = this.media.muted;
            var holdVol = this.media.volume;
            var testVol = 0.5;
            if (this.media.volume === 0.5) testVol = 0.25;
            this.media.volume = testVol;
            if (this.media.volume !== testVol) {
                this.support.mute = false;
                this.support.volume = false;
            }
            this.media.volume = holdVol;
            this.media.muted = muted;
        },
        volumeStatus: function() {
            var $volElm = this.$player.find('[data-cfw-player="volume"]');
            if ($volElm.find('input[type="range"]').length) this.volumeRange();
        },
        volumeRange: function() {
            var $selfRef = this;
            var $volElm = this.$player.find('[data-cfw-player="volume"]');
            if (!this.support.mute) {
                $.CFW_controlDisable($volElm);
                return;
            }
            var $inputElm = $volElm.find('input[type="range"]').eq(0);
            if (this.$volSeek === null) {
                this.$volSeek = $inputElm;
                $inputElm.prop({
                    min: 0,
                    max: 1,
                    step: 0.05 // 5% increment
                });
                // Update on both `onchange` and `oninput` events.
                $inputElm.on('change input', function() {
                    var newVol = parseFloat($inputElm.val());
                    if (newVol === 0) $selfRef.media.muted = true;
                    else {
                        $selfRef.media.muted = false;
                        $selfRef.media.volume = newVol;
                    }
                });
                // Allow keyboard to do the proper thing here
                $inputElm.on('keydown', function(e) {
                    if (e.type === 'keydown') e.stopPropagation();
                    $(this).off('keyup.cfw.playerSeek');
                    $(this).one('keyup.cfw.playerSeek', function(e) {
                        if (e.type === 'keyup') e.stopPropagation();
                    });
                });
            }
            // Update range value and output text to percentage
            if (!this.media.muted) {
                $inputElm.val(this.media.volume);
                var level = parseInt(this.media.volume * 100, 10);
                $inputElm.attr('aria-valuetext', level + '%');
            } else {
                $inputElm.val(0);
                $inputElm.attr('aria-valuetext', '0%');
            }
        },
        volumeIncrement: function(delta) {
            var vol = this.media.volume * 100 + delta;
            if (vol < 0) vol = 0;
            if (vol > 100) vol = 100;
            this.media.volume = parseInt(vol, 10) / 100;
        },
        loop: function(setting) {
            if (typeof setting !== 'undefined') // set on/off
            this.media.loop = setting;
            else // toggle
            this.media.loop = !this.media.loop;
            this.loopStatus();
        },
        speed: function(setting) {
            if (typeof setting !== 'undefined') this.media.playbackRate = setting;
        },
        loopStatus: function() {
            var $loopElm = this.$player.find('[data-cfw-player="loop"]');
            if (this.media.loop) {
                $loopElm.addClass('active');
                this._pressedState($loopElm, true);
            } else {
                $loopElm.removeClass('active');
                this._pressedState($loopElm, false);
            }
        },
        // Fullscreen concepts from:
        // https://github.com/iandevlin/iandevlin.github.io/blob/master/mdn/video-player-with-captions/js/video-player.js
        isFullScreen: function() {
            // Checks if the player instance is currently in fullscreen mode
            // eslint-disable-next-line compat/compat
            var $fsNode = $(document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement);
            return $fsNode.is(this.$element);
        },
        fullscreen: function() {
            if (this.type === 'audio') return;
            if (this.isFullScreen()) {
                // Exit fullscreen
                if (document.exitFullscreen) document.exitFullscreen();
                else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
                else if (document.webkitCancelFullScreen) document.webkitCancelFullScreen();
                else if (document.msExitFullscreen) document.msExitFullscreen();
            } else {
                // Go fullscreen
                // (Note: can be called on document, but here the specific element is used as it will also ensure that the element's children, e.g. the custom controls, go fullscreen also)
                var videoContainer = this.$element[0];
                if (videoContainer.requestFullscreen) videoContainer.requestFullscreen();
                else if (videoContainer.mozRequestFullScreen) videoContainer.mozRequestFullScreen();
                else if (videoContainer.webkitRequestFullScreen) videoContainer.webkitRequestFullScreen();
                else if (videoContainer.msRequestFullscreen) videoContainer.msRequestFullscreen();
            }
        },
        fullscreenStatus: function() {
            var $fullElm = this.$player.find('[data-cfw-player="fullscreen"]');
            if (this.isFullScreen()) {
                $fullElm.addClass('active');
                this.$element.addClass('player-fulldisplay');
                this.$media.CFW_trigger('enterFullscreen.cfw.player');
            } else {
                $fullElm.removeClass('active');
                this.$element.removeClass('player-fulldisplay');
                this.$media.CFW_trigger('exitFullscreen.cfw.player');
            }
        },
        _srcHasAlternate: function(name) {
            return this.$sources[0].hasAttribute('data-src-' + name);
        },
        _srcIsAlternate: function(name) {
            return this.$sources.first().attr('data-src-' + name) === this.$sources.first().attr('src');
        },
        _srcLoadAlternate: function(name) {
            var $selfRef = this;
            var currTime = this.media.currentTime;
            var isPaused = this.media.paused;
            this.$sources.each(function() {
                $(this).attr('src', $(this).attr('data-src-' + name));
            });
            // Reload the source, skip ahead, and resume playing
            this.$media.one('loadeddata', function() {
                $selfRef.seekTo(currTime);
                if (!isPaused) $selfRef.media.play();
            });
            this.media.load();
        },
        description: function() {
            if (this._srcHasAlternate('describe')) {
                var $descElm = this.$player.find('[data-cfw-player="description"]');
                if (this._srcIsAlternate('describe')) {
                    // Reset to original source
                    this._srcLoadAlternate('orig');
                    $descElm.removeClass('active');
                } else {
                    // Load description source
                    this._srcLoadAlternate('describe');
                    $descElm.addClass('active');
                }
            }
        },
        trackList: function() {
            var $selfRef = this;
            var tracks = this.media.textTracks;
            if (tracks.length <= 0) return;
            var validTracks = [];
            var descTracks = [];
            for(var i = 0; i < tracks.length; i++){
                if (tracks[i].kind === 'captions' || tracks[i].kind === 'subtitles') validTracks.push(i);
                if (tracks[i].kind === 'descriptions') descTracks.push(i);
            }
            this.trackValid = validTracks;
            this.trackDescription = descTracks;
            /* not fully supported by any browser?
                 - only fires once for some reason from browser default controls
            */ this.media.textTracks.addEventListener('change', function() {
                $selfRef.trackStatus();
            });
        },
        trackInit: function() {
            var $selfRef = this;
            var $captionElm = this.$player.find('[data-cfw-player="caption"]');
            if ($captionElm.length <= 0) return;
            if (this.trackValid.length <= 0) {
                $.CFW_controlDisable($captionElm);
                return;
            }
            if (this.trackValid.length === 1) {
                // Use toggle style
                this.$player.on('click', '[data-cfw-player="caption"]', function(e) {
                    e.preventDefault();
                    if ($captionElm.hasClass('active')) $selfRef.trackSet(-1);
                    else $selfRef.trackSet(0);
                    $selfRef._focusControl(this);
                });
                if (this.media.textTracks[0].mode === 'showing') this.trackSet(0);
            } else {
                // Build menu
                var wrapper = '<span class="player-caption-wrapper"></span>';
                var $menu = $('<ul class="player-caption-menu dropdown-menu"></ul>');
                $captionElm.wrap(wrapper);
                var $wrapper = $captionElm.parent(); /* Because $().wrap() clones element */ 
                $wrapper.append($menu);
                var menuID = $menu.CFW_getID('cfw-player');
                var $menuItem = $('<li class="player-caption-off"><button type="button" class="dropdown-item" data-cfw-player-track="-1">Off</button></li>');
                $menu.append($menuItem);
                var tracks = this.media.textTracks;
                for(var j = 0; j < tracks.length; j++)if (tracks[j].mode === 'showing') this.trackSet(j);
                for(var i = 0; i < this.trackValid.length; i++){
                    var trackID = this.trackValid[i];
                    $menuItem = $('<li><button type="button" class="dropdown-item" data-cfw-player-track="' + trackID + '">' + tracks[trackID].label + '</button></li>');
                    $menu.append($menuItem);
                }
                this.$player.on('click', '[data-cfw-player-track]', function(e) {
                    e.preventDefault();
                    var $this = $(this);
                    var num = $this.attr('data-cfw-player-track');
                    $selfRef.trackSet(num);
                });
                $captionElm.CFW_Dropdown({
                    target: '#' + menuID
                });
            }
            this.trackStatus();
        },
        trackSet: function(trackID) {
            trackID = parseInt(trackID, 10);
            var tracks = this.media.textTracks;
            if (tracks.length <= 0) return;
            // Disable any previous cuechange handling
            if (this.trackCurrent !== -1) this._cuechangeDisable(this.trackCurrent, 'captionDisplay');
            this.trackCurrent = trackID;
            for(var i = 0; i < tracks.length; i++){
                if (tracks[i].mode === 'showing') tracks[i].mode = 'hidden';
                if (i === trackID) // tracks[i].mode = 'showing';
                tracks[i].mode = this.$captionWrapper !== null ? 'hidden' : 'showing';
            }
            // Hook in cuechange handler if using custom captions
            if (this.trackCurrent !== -1 && this.$captionWrapper !== null) this._cuechangeEnable(this.trackCurrent, 'captionDisplay', this.captionDisplayUpdate);
            this.trackStatus();
        },
        trackStatus: function() {
            var tracks = this.media.textTracks;
            if (tracks.length <= 0) return;
            var $captionElm = this.$player.find('[data-cfw-player="caption"]');
            if ($captionElm.length <= 0) return;
            if (this.trackValid.length === 1) {
                // Toggle style
                if (this.trackCurrent === -1) {
                    $captionElm.removeClass('active');
                    this._pressedState($captionElm, false);
                } else {
                    $captionElm.addClass('active');
                    this._pressedState($captionElm, true);
                }
            } else {
                // Menu style
                var $captionPar = $captionElm.parent();
                $captionElm.removeClass('active');
                $captionPar.removeClass('active');
                $captionPar.find('[data-cfw-player-track]').removeClass('active').removeAttr('aria-pressed');
                for(var i = 0; i < tracks.length; i++)if (i === this.trackCurrent) {
                    $captionElm.addClass('active');
                    $captionPar.addClass('active');
                    $captionPar.find('[data-cfw-player-track="' + i + '"]').addClass('active').attr('aria-pressed', 'true');
                }
            }
        },
        scriptInit: function() {
            var $selfRef = this;
            var $tsElm = this.$player.find('[data-cfw-player="transcript"]');
            if ($tsElm.length <= 0) return;
            if (this.trackValid.length <= 0) {
                $.CFW_controlDisable($tsElm);
                return;
            }
            if (this.trackValid.length === 1 && !this.settings.transcriptOption) {
                // Use toggle style
                $tsElm.removeClass('active');
                this._pressedState($tsElm, false);
                $tsElm.on('click', function(e) {
                    e.preventDefault();
                    if ($tsElm.hasClass('active')) $selfRef.scriptSet(-1);
                    else $selfRef.scriptSet(0);
                    $selfRef._focusControl(this);
                });
            } else {
                // Build menu
                var wrapper = '<span class="player-script-wrapper"></span>';
                var $menu = $('<ul class="player-script-menu dropdown-menu"></ul>');
                $tsElm.wrap(wrapper);
                var $wrapper = $tsElm.parent(); /* Because $().wrap() clones element */ 
                $wrapper.append($menu);
                var menuID = $menu.CFW_getID('cfw-player');
                var $menuItem = $('<li class="player-script-off"><button type="button" class="dropdown-item" data-cfw-player-script="-1">Off</button></li>');
                $menu.append($menuItem);
                var tracks = this.media.textTracks;
                for(var i = 0; i < this.trackValid.length; i++){
                    var trackID = this.trackValid[i];
                    $menuItem = $('<li><button type="button" class="dropdown-item" data-cfw-player-script="' + trackID + '">' + tracks[trackID].label + '</a></li>');
                    $menu.append($menuItem);
                }
                if (this.settings.transcriptOption) {
                    $menuItem = $('<li class="dropdown-divider"></li>');
                    $menu.append($menuItem);
                    // Add scroll toggle
                    var scrollCheck = this.settings.transcriptScroll ? 'checked' : '';
                    var scrollID = 'transcriptScroll-' + menuID;
                    $menuItem = $('<li class="dropdown-text"><div class="form-check"><input type="checkbox" data-cfw-player-script-scroll class="form-check-input" ' + scrollCheck + ' id="' + scrollID + '"> <label class="form-check-label" for="' + scrollID + '">Auto-scroll</label></div></li>');
                    $menu.append($menuItem);
                    // Add description toggle
                    var descCheck = this.settings.transcriptDescribe ? 'checked' : '';
                    var descID = 'transcriptDescribe-' + menuID;
                    $menuItem = $('<li class="dropdown-text"><div class="form-check"><input type="checkbox" data-cfw-player-script-describe class="form-check-input" ' + descCheck + ' id="' + descID + '"> <label class="form-check-label" for="' + descID + '">Show Description</label></div></li>');
                    $menu.append($menuItem);
                }
                // Event handlers
                this.$player.on('click', '[data-cfw-player-script]', function(e) {
                    e.preventDefault();
                    var $this = $(this);
                    var num = $this.attr('data-cfw-player-script');
                    $selfRef.scriptSet(num);
                });
                if (this.settings.transcriptOption) {
                    this.$player.on('click', '[data-cfw-player-script-scroll]', function() {
                        $selfRef.settings.transcriptScroll = !$selfRef.settings.transcriptScroll;
                        $(this).prop('checked', $selfRef.settings.transcriptScroll);
                    });
                    this.$player.on('click', '[data-cfw-player-script-describe]', function(e) {
                        if (!$.CFW_isDisabled(e.target)) {
                            $selfRef.settings.transcriptDescribe = !$selfRef.settings.transcriptDescribe;
                            $(this).prop('checked', $selfRef.settings.transcriptDescribe);
                            $selfRef.scriptLoad();
                        }
                    });
                }
                $tsElm.CFW_Dropdown({
                    target: '#' + menuID
                });
            }
            // Show transcript if set
            if (this.settings.transcript !== -1) this.scriptSet(this.settings.transcript);
        },
        scriptSet: function(trackID) {
            trackID = parseInt(trackID, 10);
            if (this.trackValid.length <= 0) return;
            if (this.trackValid.indexOf(trackID) === -1 && trackID !== -1) return;
            // No update if same track is selected
            if (trackID === this.scriptCurrent) return;
            if (trackID === -1 && this.$scriptElm !== null) {
                if (!this.$media.CFW_trigger('beforeTranscriptHide.cfw.player')) return;
            }
            if (!this.$media.CFW_trigger('beforeTranscriptShow.cfw.player')) return;
            var $tsElm = this.$player.find('[data-cfw-player="transcript"]');
            if (this.$scriptElm !== null) {
                this.$scriptElm.remove();
                this.$scriptElm = null;
            }
            this.$element.removeClass('player-scriptshow');
            if ($tsElm.length) {
                if (this.trackValid.length === 1 && !this.settings.transcriptOption) {
                    // Update toggle
                    $tsElm.removeClass('active');
                    this._pressedState($tsElm, false);
                } else {
                    // Update menu
                    var $tsPar = $tsElm.parent();
                    $tsElm.removeClass('active');
                    $tsPar.removeClass('active');
                    $tsPar.find('[data-cfw-player-script]').removeClass('active').removeAttr('aria-pressed');
                }
            }
            // Disable any previous cuechange handling
            if (this.scriptCurrent !== -1) this._cuechangeDisable(this.scriptCurrent, 'transcript');
            this.scriptCurrent = trackID;
            if (trackID === -1) {
                this.scriptCues = null;
                this.descCues = null;
                this.$media.CFW_trigger('afterTranscriptHide.cfw.player');
            } else this.scriptLoad();
        },
        scriptLoad: function(forced) {
            var $selfRef = this;
            if (typeof forced === 'undefined') forced = false;
            this.$media.off('loadeddata.cfw.player.script');
            var tracks = this.media.textTracks;
            var tracksLength = tracks.length;
            if (tracksLength <= 0) {
                this.scriptCues = null;
                this.descCurrent = -1;
                this.descCues = null;
            }
            // Preload all tracks to stop future `load` event triggers on transcript change
            var hold = this.trackCurrent === -1 ? null : tracks[this.trackCurrent].mode;
            for(var i = 0; i < tracksLength; i++)tracks[i].mode = 'hidden';
            // reset the caption track state
            if (hold !== null) tracks[this.trackCurrent].mode = hold;
            // Find description track
            var descAvailable = false;
            this.descCurrent = -1;
            this.descCues = null;
            if (this.scriptCurrent !== -1) {
                var descLang = tracks[this.scriptCurrent].language;
                for(var j = 0; j < tracksLength; j++)if (descLang === tracks[j].language && tracks[j].kind === 'descriptions') {
                    if ($selfRef.settings.transcriptDescribe) $selfRef.descCurrent = j;
                    descAvailable = true;
                }
            }
            var $descControl = this.$player.find('[data-cfw-player-script-describe]');
            if (!descAvailable) $.CFW_controlDisable($descControl);
            else $.CFW_controlEnable($descControl);
            // Test again for text-based description
            var textDescAvailable = false;
            for(var k = 0; k < tracksLength; k++)if (tracks[k].kind === 'descriptions') textDescAvailable = true;
            var $textDescControl = this.$player.find('[data-cfw-player="textdescription"]');
            if (!textDescAvailable) $.CFW_controlDisable($textDescControl);
            else $.CFW_controlEnable($textDescControl);
            var scriptLoad2 = function(forced) {
                var tracks = $selfRef.media.textTracks; // Reload object to get update
                var cues = $selfRef.scriptCurrent === -1 ? null : tracks[$selfRef.scriptCurrent].cues;
                var descCues = $selfRef.descCurrent === -1 ? null : tracks[$selfRef.descCurrent].cues;
                var textDescCues = $selfRef.textDescribeCurrent === -1 ? null : tracks[$selfRef.textDescribeCurrent].cues;
                if (cues && cues.length <= 0 && !forced) {
                    // Force media to load
                    $selfRef.$media.one('loadeddata.cfw.player.script', function() {
                        $selfRef.scriptLoad(true);
                    });
                    $selfRef.$media.trigger('load');
                    return;
                }
                $selfRef.scriptCues = cues;
                $selfRef.descCues = descCues;
                $selfRef.textDescribeCues = textDescCues;
                $selfRef.scriptProcess();
            };
            // Short delay to next part
            setTimeout(function() {
                scriptLoad2(forced);
            }, 100);
        },
        scriptProcess: function() {
            var $selfRef = this;
            if (this.scriptCues === null && this.descCues === null) return;
            var addCaption = function($div, cap) {
                var $capSpan = $('<span class="player-transcript-seekpoint player-transcript-caption"></span>');
                var capHTML = cap.getCueAsHTML();
                $capSpan.append(capHTML);
                $capSpan.attr({
                    'data-start': cap.startTime.toString(),
                    'data-end': cap.endTime.toString()
                });
                $div.append($capSpan);
                $div.append('\n');
            };
            var addDescription = function($div, desc) {
                var $descDiv = $('<div class="player-description"></div>');
                $descDiv.append('<span class="sr-only">Description: </span>');
                var $descSpan = $('<span class="player-description-seekpoint player-description-caption"></span>');
                var descHTML = desc.getCueAsHTML();
                $descSpan.append(descHTML);
                $descSpan.attr({
                    'data-start': desc.startTime.toString(),
                    'data-end': desc.endTime.toString()
                });
                $descDiv.append($descSpan);
                $div.append($descDiv);
                $div.append('\n');
            };
            var $tsElm = this.$player.find('[data-cfw-player="transcript"]');
            this.$element.addClass('player-scriptshow');
            if (this.trackValid.length === 1 && !this.settings.transcriptOption) {
                // Update toggle state
                $tsElm.addClass('active');
                this._pressedState($tsElm, true);
            } else if ($tsElm.length) {
                // Update transcript menu
                var $tsPar = $tsElm.parent();
                $tsElm.addClass('active');
                $tsPar.addClass('active');
                $tsPar.find('[data-cfw-player-script="' + this.scriptCurrent + '"]').addClass('active').attr('aria-pressed', 'true');
            }
            // Remove any existing transcript container
            this.$element.find('.player-transcript').remove();
            // Insert transcript container
            var $newElm = $('<div class="player-transcript"></div>');
            this.$element.append($newElm);
            this.$scriptElm = this.$element.find('.player-transcript');
            // Loop through all captions/descriptions and add to transcript container
            var captions = this.scriptCues || [];
            var descriptions = this.descCues || [];
            var capIdx = 0;
            var descIdx = 0;
            var timeStamp = null;
            while(capIdx < captions.length || descIdx < descriptions.length){
                if (descIdx < descriptions.length && capIdx < captions.length) // Both descriptions and captions have content
                timeStamp = Math.min(descriptions[descIdx].startTime, captions[capIdx].startTime);
                else // Only one item has content
                timeStamp = null;
                if (timeStamp !== null) {
                    if (typeof descriptions[descIdx] !== 'undefined' && descriptions[descIdx].startTime === timeStamp) {
                        addDescription(this.$scriptElm, descriptions[descIdx]);
                        descIdx += 1;
                    } else {
                        addCaption(this.$scriptElm, captions[capIdx]);
                        capIdx += 1;
                    }
                } else if (descIdx < descriptions.length) {
                    addDescription(this.$scriptElm, descriptions[descIdx]);
                    descIdx += 1;
                } else if (capIdx < captions.length) {
                    addCaption(this.$scriptElm, captions[capIdx]);
                    capIdx += 1;
                }
            }
            // Hook in cuechange handler
            this._cuechangeEnable(this.scriptCurrent, 'transcript', this.scriptHighlight);
            // Seekpoint event handlers
            $(this.seekPoint, this.$scriptElm).off('click.cfw.player.scriptseek').on('click.cfw.player.scriptseek', function() {
                var spanStart = parseFloat($(this).attr('data-start'));
                $selfRef.scriptSeek(spanStart);
            });
            this.$media.CFW_trigger('afterTranscriptShow.cfw.player');
        },
        scriptHighlight: function(activeCues) {
            // Remove any active highlights
            $('.player-transcript-active', this.$scriptElm).removeClass('player-transcript-active');
            if (activeCues.length <= 0) return;
            var cueStart = activeCues[0].startTime;
            var $matchCap = $('.player-transcript-caption[data-start="' + cueStart + '"]', this.$scriptElm);
            $matchCap.addClass('player-transcript-active');
            if (this.settings.transcriptScroll) {
                var tsScroll = this.$scriptElm.scrollTop();
                var tsMid = this.$scriptElm.innerHeight() / 2;
                var mcTop = $matchCap.position().top;
                var mcMid = $matchCap.height() / 2;
                var newTop = Math.floor(tsScroll + mcTop - tsMid + mcMid);
                if (newTop !== Math.floor(tsScroll)) this.$scriptElm.scrollTop(newTop);
            }
        },
        scriptSeek: function(timestamp) {
            var $selfRef = this;
            timestamp += 0.01; // pad timestamp to put 'inside' the cue
            if (this.media.readyState < 2) {
                this.$media.one('canplay', function() {
                    $selfRef.seekTo(timestamp);
                });
                this.$media.trigger('load');
            } else this.seekTo(timestamp);
        },
        textDescriptionInit: function() {
            var $selfRef = this;
            var $tdElm = this.$player.find('[data-cfw-player="textdescription"]');
            if ($tdElm.length <= 0) return;
            if (this.trackDescription.length <= 0) {
                $.CFW_controlDisable($tdElm);
                return;
            }
            // Build menu
            var wrapper = '<span class="player-text-describe-wrapper"></span>';
            var $menu = $('<ul class="player-text-describe-menu dropdown-menu"></ul>');
            $tdElm.wrap(wrapper);
            var $wrapper = $tdElm.parent(); /* Because $().wrap() clones element */ 
            $wrapper.append($menu);
            var menuID = $menu.CFW_getID('cfw-player');
            var $menuItem = $('<li class="player-text-describe-off"><button type="button" class="dropdown-item" data-cfw-player-text-describe="-1">Off</button></li>');
            $menu.append($menuItem);
            var tracks = this.media.textTracks;
            for(var i = 0; i < this.trackDescription.length; i++){
                var trackID = this.trackDescription[i];
                $menuItem = $('<li><button type="button" class="dropdown-item" data-cfw-player-text-describe="' + trackID + '">' + tracks[trackID].label + '</a></li>');
                $menu.append($menuItem);
            }
            if (this.settings.transcriptOption) {
                $menuItem = $('<li class="dropdown-divider"></li>');
                $menu.append($menuItem);
                // Add announce toggle
                var announceCheck = this.settings.textDescribeAnnounce ? 'checked' : '';
                var announceID = 'textDescribeAnnounce-' + menuID;
                $menuItem = $('<li class="dropdown-text"><div class="form-check"><input type="checkbox" data-cfw-player-text-describe-announce class="form-check-input" ' + announceCheck + ' id="' + announceID + '"> <label class="form-check-label" for="' + announceID + '">Announce with Screen Reader</label></div></li>');
                $menu.append($menuItem);
                // Add visibility toggle
                var visibleCheck = this.settings.textDescribeVisible ? 'checked' : '';
                var visibleID = 'textDescribeVisible-' + menuID;
                $menuItem = $('<li class="dropdown-text"><div class="form-check"><input type="checkbox" data-cfw-player-text-describe-visible class="form-check-input" ' + visibleCheck + ' id="' + visibleID + '"> <label class="form-check-label" for="' + visibleID + '">Visible Description</label></div></li>');
                $menu.append($menuItem);
            }
            // Event handlers
            this.$player.on('click', '[data-cfw-player-text-describe]', function(e) {
                e.preventDefault();
                var $this = $(this);
                var num = $this.attr('data-cfw-player-text-describe');
                $selfRef.textDescriptionSet(num);
            });
            if (this.settings.transcriptOption) {
                this.$player.on('click', '[data-cfw-player-text-describe-announce]', function() {
                    $selfRef.settings.textDescribeAnnounce = !$selfRef.settings.textDescribeAnnounce;
                    $(this).prop('checked', $selfRef.settings.textDescribeAnnounce);
                    $selfRef.textDescriptionSet($selfRef.textDescribeCurrent);
                });
                this.$player.on('click', '[data-cfw-player-text-describe-visible]', function(e) {
                    if (!$.CFW_isDisabled(e.target)) {
                        $selfRef.settings.textDescribeVisible = !$selfRef.settings.textDescribeVisible;
                        $(this).prop('checked', $selfRef.settings.textDescribeVisible);
                        $selfRef.textDescriptionSet($selfRef.textDescribeCurrent);
                    }
                });
            }
            $tdElm.CFW_Dropdown({
                target: '#' + menuID
            });
            this.textDescriptionSet(this.settings.textDescribe);
        },
        textDescriptionSet: function(trackID) {
            trackID = parseInt(trackID, 10);
            if (this.trackDescription.length <= 0) return;
            if (this.trackDescription.indexOf(trackID) === -1 && trackID !== -1) return;
            if (trackID === -1 && this.$textDescribeElm !== null) {
                if (!this.$media.CFW_trigger('beforeTextDescriptionHide.cfw.player')) return;
            } else if (!this.$media.CFW_trigger('beforeTextDescriptionShow.cfw.player')) return;
            if (this.$textDescribeElm !== null) {
                this.$textDescribeElm.remove();
                this.$textDescribeElm = null;
            }
            this.$element.removeClass('player-textdescshow');
            // Remove any existing text description containers
            this.$element.find('.player-textdesc-announce').remove();
            this.$element.find('.player-textdesc-visible').remove();
            var $tdElm = this.$player.find('[data-cfw-player="textdescription"]');
            if ($tdElm.length) {
                // Update menu
                var $tdPar = $tdElm.parent();
                $tdElm.removeClass('active');
                $tdPar.removeClass('active');
                $tdPar.find('[data-cfw-player-text-describe]').removeClass('active').removeAttr('aria-pressed');
                if (trackID !== -1) {
                    $tdElm.addClass('active');
                    $tdPar.addClass('active');
                    $tdPar.find('[data-cfw-player-text-describe="' + trackID + '"]').addClass('active').attr('aria-pressed', 'true');
                }
            }
            // Disable any previous cuechange handling
            if (this.textDescribeCurrent !== -1) this._cuechangeDisable(this.textDescribeCurrent, 'textdescribe');
            this.textDescribeCurrent = trackID;
            if (trackID === -1) {
                this.textDescribeCues = null;
                this.$media.CFW_trigger('afterTextDescriptionHide.cfw.player');
            } else this.scriptLoad();
            if (trackID !== -1) {
                // Insert new text description container
                var $newElm = $('<div class="player-textdesc"></div>');
                var trackLang = this.media.textTracks[trackID].language;
                if (trackLang.length) $newElm.attr('lang', trackLang);
                if (this.settings.textDescribeAnnounce) $newElm.attr({
                    'aria-live': 'assertive',
                    'aria-atomic': 'true'
                });
                if (!this.settings.textDescribeVisible) $newElm.addClass('sr-only');
                this.$element.append($newElm);
                this.$textDescribeElm = this.$element.find('.player-textdesc');
                // Hook in cuechange handler
                this._cuechangeEnable(this.textDescribeCurrent, 'textdescribe', this.textDescribeUpdate);
                this.$media.CFW_trigger('afterTextDescriptionShow.cfw.player');
            }
        },
        textDescribeUpdate: function(activeCues) {
            if (activeCues === null || activeCues.length <= 0) this.$textDescribeElm.empty();
            else {
                // Show caption area and update caption
                var $tmp = $(document.createElement('div'));
                $tmp.append(activeCues[0].getCueAsHTML());
                var cueHTML = $tmp.html().replace('\n', '<br>');
                this.$textDescribeElm.append(cueHTML);
            }
        },
        activityInit: function() {
            var $selfRef = this;
            setInterval(function() {
                if ($selfRef.activity && !$selfRef.over) {
                    $selfRef.activity = false;
                    clearTimeout($selfRef.activityTimer);
                    $selfRef.activityStatus(true);
                    $selfRef.activityTimer = setTimeout(function() {
                        if (!$selfRef.activity) $selfRef.activityStatus(false);
                    }, 1000);
                }
            }, 250);
        },
        activityStatus: function(bool) {
            if (bool !== this.userActive) {
                this.userActive = bool;
                if (bool) {
                    this.activity = true;
                    this.$element.removeClass('player-inactive');
                } else {
                    this.activity = false;
                    // Stop pointer change from triggering false mousemove event when changing pointers
                    this.$element.one('mousemove', function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                    });
                    this.$element.addClass('player-inactive');
                }
            }
        },
        captionDisplayUpdate: function(activeCues) {
            if (this.$captionWrapper === null) return;
            if (this.trackCurrent === -1 || activeCues === null || activeCues.length <= 0) // Clear and hide caption area - nothing to show
            this.$captionWrapper.attr('aria-hidden', 'true').css('display', 'none').empty();
            else {
                // Show caption area and update caption
                var $tmp = $(document.createElement('div'));
                $tmp.append(activeCues[0].getCueAsHTML());
                var cueHTML = $tmp.html().replace('\n', '<br>');
                this.$captionWrapper.removeAttr('aria-hidden').css('display', '').append(cueHTML);
            }
        },
        _actionsKeydown: function(e) {
            // 32-space, 33-pgup, 34-pgdn, 35-end, 36-home, 37-left, 38-up, 39-right, 40-down, 70-f/F, 77-m/M
            if (!/(32|33|34|35|36|37|38|39|40|70|77)/.test(e.which)) return;
            // Ignore space use on button/role="button" items
            if (e.which === 32 || e.target.tagName === 'button' || $(e.target).attr('role') === 'button') return;
            e.stopPropagation();
            e.preventDefault();
            switch(e.which){
                case 32:
                    if (this.media.paused) // Paused/stopped
                    this.media.play();
                    else // Playing
                    this.media.pause();
                    this._focusHelper();
                    break;
                case 38:
                    this.volumeIncrement(5);
                    break;
                case 40:
                    this.volumeIncrement(-5);
                    break;
                case 36:
                    this.seekTo(0.0);
                    break;
                case 35:
                    this.seekTo(this.media.duration);
                    break;
                case 37:
                    this.seekIncrement(-5);
                    break;
                case 39:
                    this.seekIncrement(5);
                    break;
                case 33:
                    this.seekIncrement(this.status.duration / 5);
                    break;
                case 34:
                    this.seekIncrement(this.status.duration / -5);
                    break;
                case 70:
                    this.fullscreen();
                    break;
                case 77:
                    this.mute();
                    break;
                default:
            }
        },
        _pressedState: function($node, state) {
            if ($node.length <= 0) return;
            // True button
            var nodeName = $node.get(0).nodeName.toLowerCase();
            // role="button"
            var nodeRole = $node.attr('role');
            if (nodeName === 'button' || nodeRole === 'button') $node.attr('aria-pressed', state);
        },
        _focusControl: function(control) {
            var $control = $(control);
            if ($control.length <= 0) return;
            setTimeout(function() {
                if ($control.is('a, button')) $control.trigger('focus');
                else $control.find('a:visible, button:visible').eq(0).trigger('focus');
            }, 150);
        },
        _focusHelper: function() {
            var $selfRef = this;
            var $focusCurr = $(document.activeElement);
            setTimeout(function() {
                if (!$focusCurr.is(':visible')) $selfRef.$focus.trigger('focus');
            }, 10);
        },
        _cuechangeEnable: function(trackID, namespace, callback) {
            var $selfRef = this;
            if (typeof this.media.textTracks[trackID].oncuechange !== 'undefined') $(this.media.textTracks[trackID]).on('cuechange.cfw.player.' + namespace, function() {
                callback.call($selfRef, this.activeCues);
            });
            else // Firefox does not currently support oncuechange event
            this.$media.on('timeupdate.cfw.player.' + namespace, function() {
                var activeCues = $selfRef.media.textTracks[trackID].activeCues;
                callback.call($selfRef, activeCues);
            });
            // Artificially trigger a cuechange - in case already in middle of a cue
            var cueEvent;
            if (typeof this.media.textTracks[trackID].oncuechange !== 'undefined') {
                cueEvent = $.Event('cuechange');
                $(this.media.textTracks[trackID]).trigger(cueEvent);
            } else {
                // Firefox
                cueEvent = $.Event('timeupdate');
                this.$media.trigger(cueEvent);
            }
        },
        _cuechangeDisable: function(trackID, namespace) {
            $(this.media.textTracks[trackID]).off('cuechange.cfw.player.' + namespace);
            this.$media.off('timeupdate.cfw.player.' + namespace);
        },
        dispose: function() {
            clearTimeout(this.activityTimer);
            if (this.$scriptElm) {
                $(this.seekPoint, this.$scriptElm).off('.cfw.player.seekpoint');
                this.$scriptElm.remove();
            }
            if (this.$sliderSeek) this.$sliderSeek.off();
            if (this.$volSeek) this.$volSeek.off();
            if ($.hasData(this.$player.find('[data-cfw-player="caption"]'))) this.$player.find('[data-cfw-player="caption"]').CFW_Dropdown('dispose');
            if ($.hasData(this.$player.find('[data-cfw-player="transcript"]'))) this.$player.find('[data-cfw-player="transcript"]').CFW_Dropdown('dispose');
            this.$player.off();
            this.$media.off();
            this.$element.off().removeData('cfw.player');
            this.$element = null;
            this.type = null;
            this.$media = null;
            this.media = null;
            this.$player = null;
            this.$sources = null;
            this.$focus = null;
            this.$sliderSeek = null;
            this.$volSeek = null;
            this.activity = null;
            this.over = null;
            this.userActive = null;
            this.activityTimer = null;
            this.mouseActivity = null;
            this.played = null;
            this.status = null;
            this.support = null;
            this.trackValid = null;
            this.trackCurrent = null;
            this.$captionWrapper = null;
            this.$scriptElm = null;
            this.scriptCurrent = null;
            this.scriptCues = null;
            this.descCues = null;
            this.trackDescription = null;
            this.$textDescribeElm = null;
            this.textDescribeCurrent = null;
            this.textDescribeCues = null;
            this.settings = null;
        }
    };
    var Plugin = function(option) {
        var args = [].splice.call(arguments, 1);
        return this.each(function() {
            var $this = $(this);
            var data = $this.data('cfw.player');
            var options = typeof option === 'object' && option;
            if (!data) $this.data('cfw.player', data = new CFW_Widget_Player(this, options));
            if (typeof option === 'string') data[option].apply(data, args);
        });
    };
    $.fn.CFW_Player = Plugin;
    $.fn.CFW_Player.Constructor = CFW_Widget_Player;
})(jQuery);
/**
 * --------------------------------------------------------------------------
 * Figuration (v4.4.1): common.js
 * Licensed under MIT (https://github.com/cast-org/figuration/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ (function($) {
    'use strict';
    var cfwList = {
        '[data-cfw="collapse"]': 'CFW_Collapse',
        '[data-cfw="dropdown"]': 'CFW_Dropdown',
        '[data-cfw="tab"]': 'CFW_Tab',
        '[data-cfw="tooltip"]': 'CFW_Tooltip',
        '[data-cfw="popover"]': 'CFW_Popover',
        '[data-cfw="offcanvas"]': 'CFW_Offcanvas',
        '[data-cfw="modal"]': 'CFW_Modal',
        '[data-cfw="affix"]': 'CFW_Affix',
        '[data-cfw="tabResponsive"]': 'CFW_TabResponsive',
        '[data-cfw="accordion"]': 'CFW_Accordion',
        '[data-cfw="slideshow"]': 'CFW_Slideshow',
        '[data-cfw="scrollspy"]': 'CFW_Scrollspy',
        '[data-cfw="lazy"]': 'CFW_Lazy',
        '[data-cfw="equalize"]': 'CFW_Equalize',
        '[data-cfw="player"]': 'CFW_Player'
    };
    $.fn.CFW_Init = function() {
        var $scope = $(this);
        if (!$scope.length) $scope = $(document.body);
        for(var key in cfwList)if (typeof $.fn[cfwList[key]] === 'function') /* eslint-disable-next-line no-loop-func */ $scope.find(key).add($scope.filter(key)).each(function() {
            $(this)[cfwList[key]]();
        });
        return this;
    };
    $.fn.CFW_Dispose = function() {
        var $scope = $(this);
        if (!$scope.length) $scope = $(document.body);
        for(var key in cfwList)if (typeof $.fn[cfwList[key]] === 'function') /* eslint-disable-next-line no-loop-func */ $scope.find(key).add($scope.filter(key)).each(function() {
            $(this)[cfwList[key]]('dispose');
        });
        return this;
    };
    $(window).ready(function() {
        if (typeof CFW_API === 'undefined' || CFW_API !== false) $(document.body).CFW_Init();
    });
})(jQuery);


function $2c839b9f78572b9b$export$2e2bcd8739ae039() {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))(document).CFW_Init) (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))(document).CFW_Init();
}
// Refresh any CodeMirror instances in a modal after it is shown.
(0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('body').on('afterShow.cfw.modal', '.modal', function(e) {
    (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))(this).find('.CodeMirror').each(function(e) {
        this.CodeMirror.refresh();
    });
});
// Adjust positioning of some elements when window scrollbar updated for modal/offcanvas
(0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))(document).on('beforeShow.cfw.modal beforeShow.cfw.offcanvas', function() {
    var rect = document.body.getBoundingClientRect();
    var bodyIsOverflowing = Math.round(rect.left + rect.right) < window.innerWidth;
    var scrollbarWidth = (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports))).CFW_measureScrollbar();
    var $tts = (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('.header-tts');
    var $tour = (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('.footer-pages-tour');
    if ($tts.length) {
        var ttsTransform = $tts.css('transform');
        if (bodyIsOverflowing && window.innerWidth < 1600) $tts.data('corgi.transform', ttsTransform).css('transform', ttsTransform + ' translateX(-' + scrollbarWidth / 2 + 'px)');
    }
    if ($tour.length) {
        var tourMargin = $tour.css('margin-right');
        var tourComputed = parseFloat(window.getComputedStyle($tour[0]).getPropertyValue('margin-right'));
        if (bodyIsOverflowing && window.innerWidth < 1600) $tour.data('corgi.margin', tourMargin).css('margin-right', tourComputed + scrollbarWidth + 'px');
    }
}).on('afterHide.cfw.modal afterHide.cfw.offcanvas', function() {
    var $tts = (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('.header-tts');
    var $tour = (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('.footer-pages-tour');
    if ($tts.length) {
        var ttsTransform = $tts.data('corgi.transform');
        if (typeof ttsTransform !== 'undefined') {
            $tts.css('transform', ttsTransform);
            $tts.removeData('corgi.transform');
        }
    }
    if ($tour.length) {
        $tour.css('margin-right', '');
        $tour.removeData('corgi.margin');
    }
});


var $a5ab67d0bda3ecfd$exports = {};




(function() {
    var crypt = (parcelRequire("g1Jo8")), utf8 = (parcelRequire("kIiXo")).utf8, isBuffer = (parcelRequire("166vg")), bin = (parcelRequire("kIiXo")).bin, // The core
    md5 = function(message, options) {
        // Convert to byte array
        if (message.constructor == String) {
            if (options && options.encoding === 'binary') message = bin.stringToBytes(message);
            else message = utf8.stringToBytes(message);
        } else if (isBuffer(message)) message = Array.prototype.slice.call(message, 0);
        else if (!Array.isArray(message) && message.constructor !== Uint8Array) message = message.toString();
        // else, assume byte array already
        var m = crypt.bytesToWords(message), l = message.length * 8, a = 1732584193, b = -271733879, c = -1732584194, d = 271733878;
        // Swap endian
        for(var i = 0; i < m.length; i++)m[i] = (m[i] << 8 | m[i] >>> 24) & 0x00FF00FF | (m[i] << 24 | m[i] >>> 8) & 0xFF00FF00;
        // Padding
        m[l >>> 5] |= 0x80 << l % 32;
        m[(l + 64 >>> 9 << 4) + 14] = l;
        // Method shortcuts
        var FF = md5._ff, GG = md5._gg, HH = md5._hh, II = md5._ii;
        for(var i = 0; i < m.length; i += 16){
            var aa = a, bb = b, cc = c, dd = d;
            a = FF(a, b, c, d, m[i + 0], 7, -680876936);
            d = FF(d, a, b, c, m[i + 1], 12, -389564586);
            c = FF(c, d, a, b, m[i + 2], 17, 606105819);
            b = FF(b, c, d, a, m[i + 3], 22, -1044525330);
            a = FF(a, b, c, d, m[i + 4], 7, -176418897);
            d = FF(d, a, b, c, m[i + 5], 12, 1200080426);
            c = FF(c, d, a, b, m[i + 6], 17, -1473231341);
            b = FF(b, c, d, a, m[i + 7], 22, -45705983);
            a = FF(a, b, c, d, m[i + 8], 7, 1770035416);
            d = FF(d, a, b, c, m[i + 9], 12, -1958414417);
            c = FF(c, d, a, b, m[i + 10], 17, -42063);
            b = FF(b, c, d, a, m[i + 11], 22, -1990404162);
            a = FF(a, b, c, d, m[i + 12], 7, 1804603682);
            d = FF(d, a, b, c, m[i + 13], 12, -40341101);
            c = FF(c, d, a, b, m[i + 14], 17, -1502002290);
            b = FF(b, c, d, a, m[i + 15], 22, 1236535329);
            a = GG(a, b, c, d, m[i + 1], 5, -165796510);
            d = GG(d, a, b, c, m[i + 6], 9, -1069501632);
            c = GG(c, d, a, b, m[i + 11], 14, 643717713);
            b = GG(b, c, d, a, m[i + 0], 20, -373897302);
            a = GG(a, b, c, d, m[i + 5], 5, -701558691);
            d = GG(d, a, b, c, m[i + 10], 9, 38016083);
            c = GG(c, d, a, b, m[i + 15], 14, -660478335);
            b = GG(b, c, d, a, m[i + 4], 20, -405537848);
            a = GG(a, b, c, d, m[i + 9], 5, 568446438);
            d = GG(d, a, b, c, m[i + 14], 9, -1019803690);
            c = GG(c, d, a, b, m[i + 3], 14, -187363961);
            b = GG(b, c, d, a, m[i + 8], 20, 1163531501);
            a = GG(a, b, c, d, m[i + 13], 5, -1444681467);
            d = GG(d, a, b, c, m[i + 2], 9, -51403784);
            c = GG(c, d, a, b, m[i + 7], 14, 1735328473);
            b = GG(b, c, d, a, m[i + 12], 20, -1926607734);
            a = HH(a, b, c, d, m[i + 5], 4, -378558);
            d = HH(d, a, b, c, m[i + 8], 11, -2022574463);
            c = HH(c, d, a, b, m[i + 11], 16, 1839030562);
            b = HH(b, c, d, a, m[i + 14], 23, -35309556);
            a = HH(a, b, c, d, m[i + 1], 4, -1530992060);
            d = HH(d, a, b, c, m[i + 4], 11, 1272893353);
            c = HH(c, d, a, b, m[i + 7], 16, -155497632);
            b = HH(b, c, d, a, m[i + 10], 23, -1094730640);
            a = HH(a, b, c, d, m[i + 13], 4, 681279174);
            d = HH(d, a, b, c, m[i + 0], 11, -358537222);
            c = HH(c, d, a, b, m[i + 3], 16, -722521979);
            b = HH(b, c, d, a, m[i + 6], 23, 76029189);
            a = HH(a, b, c, d, m[i + 9], 4, -640364487);
            d = HH(d, a, b, c, m[i + 12], 11, -421815835);
            c = HH(c, d, a, b, m[i + 15], 16, 530742520);
            b = HH(b, c, d, a, m[i + 2], 23, -995338651);
            a = II(a, b, c, d, m[i + 0], 6, -198630844);
            d = II(d, a, b, c, m[i + 7], 10, 1126891415);
            c = II(c, d, a, b, m[i + 14], 15, -1416354905);
            b = II(b, c, d, a, m[i + 5], 21, -57434055);
            a = II(a, b, c, d, m[i + 12], 6, 1700485571);
            d = II(d, a, b, c, m[i + 3], 10, -1894986606);
            c = II(c, d, a, b, m[i + 10], 15, -1051523);
            b = II(b, c, d, a, m[i + 1], 21, -2054922799);
            a = II(a, b, c, d, m[i + 8], 6, 1873313359);
            d = II(d, a, b, c, m[i + 15], 10, -30611744);
            c = II(c, d, a, b, m[i + 6], 15, -1560198380);
            b = II(b, c, d, a, m[i + 13], 21, 1309151649);
            a = II(a, b, c, d, m[i + 4], 6, -145523070);
            d = II(d, a, b, c, m[i + 11], 10, -1120210379);
            c = II(c, d, a, b, m[i + 2], 15, 718787259);
            b = II(b, c, d, a, m[i + 9], 21, -343485551);
            a = a + aa >>> 0;
            b = b + bb >>> 0;
            c = c + cc >>> 0;
            d = d + dd >>> 0;
        }
        return crypt.endian([
            a,
            b,
            c,
            d
        ]);
    };
    // Auxiliary functions
    md5._ff = function(a, b, c, d, x, s, t) {
        var n = a + (b & c | ~b & d) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    md5._gg = function(a, b, c, d, x, s, t) {
        var n = a + (b & d | c & ~d) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    md5._hh = function(a, b, c, d, x, s, t) {
        var n = a + (b ^ c ^ d) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    md5._ii = function(a, b, c, d, x, s, t) {
        var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    // Package private blocksize
    md5._blocksize = 16;
    md5._digestsize = 16;
    $a5ab67d0bda3ecfd$exports = function(message, options) {
        if (message === undefined || message === null) throw new Error('Illegal argument ' + message);
        var digestbytes = crypt.wordsToBytes(md5(message, options));
        return options && options.asBytes ? digestbytes : options && options.asString ? bin.bytesToString(digestbytes) : crypt.bytesToHex(digestbytes);
    };
})();


let $5198a75994f13aea$var$_paq = [];
window._paq = $5198a75994f13aea$var$_paq;
class $5198a75994f13aea$export$2e2bcd8739ae039 {
    constructor(){
        var _paq = window._paq || [];
        // tracker methods like "setCustomDimension" should be called before "trackPageView"
        _paq.push([
            'trackPageView'
        ]);
        _paq.push([
            'enableLinkTracking'
        ]);
        // accurately measure the time spent on the last pageview of a visit
        _paq.push([
            'enableHeartBeatTimer'
        ]);
        ((u, id)=>{
            _paq.push([
                'setTrackerUrl',
                u + 'matomo.php'
            ]);
            _paq.push([
                'setSiteId',
                id
            ]);
            var d = window.document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
            g.type = 'text/javascript';
            g.async = true;
            g.src = u + 'matomo.js';
            s.parentNode.insertBefore(g, s);
        })(window.matomoUrl, window.matomoSiteId);
        this.trackEvent = this.trackEvent.bind(this);
        this.trackPageView = this.trackPageView.bind(this);
        console.log('Initialized tracker; url=', window.matomoUrl, ', siteId=', window.matomoSiteId);
    }
    trackEvent(category, action, name) {
        console.log("TrackEvent with: category = " + category + ", action = " + action + ", name = " + name);
        window._paq.push([
            'trackEvent',
            category,
            action,
            name
        ]);
    }
    trackPageView(user, pageTitle) {
        var user_id = (0, (/*@__PURE__*/$parcel$interopDefault($a5ab67d0bda3ecfd$exports)))(user.emailAddress);
        console.log("Track PageView: " + user_id + " / " + pageTitle);
        window._paq.push([
            'setUserId',
            user_id
        ]); // Must be set for every page view
        window._paq.push([
            'setCustomDimension',
            1,
            user.role
        ]);
        window._paq.push([
            'setDocumentTitle',
            pageTitle
        ]);
        window._paq.push([
            'setCustomUrl',
            window.location.pathname
        ]);
        window._paq.push([
            'trackPageView'
        ]);
    }
}


// eslint-disable-next-line

var $6wXVr = parcelRequire("6wXVr");

// CORGI-104 pre-login
// Authorize button launches the Google login popup



var $6wXVr = parcelRequire("6wXVr");

class $be83f2d5d13e3a7b$export$c43bfb5198aa7b21 extends (0, $d8775d5311bbf499$export$2e2bcd8739ae039) {
    componentDidMount() {
        if (window.google) this.initGSI();
        else document.getElementById("gsiClientScript").addEventListener("load", ()=>{
            this.initGSI();
        });
    }
    initGSI() {
        window.google.accounts.id.initialize({
            client_id: (0, $220c2d58964ba595$export$fcc0626890c55730).clientId,
            callback: this.props.authorizeMethod
        });
        //
        window.google.accounts.id.renderButton(document.getElementById("loginButton"), {
            theme: "filled_blue"
        } // customization attributes
        );
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "loginButton"
        });
    }
}
$be83f2d5d13e3a7b$export$c43bfb5198aa7b21.propTypes = {
    authorizeMethod: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).func.isRequired
};



var $6wXVr = parcelRequire("6wXVr");


const $540ee614c8ab8fe3$export$2b16136333e16b91 = undefined !== (0, $220c2d58964ba595$export$fcc0626890c55730) && undefined !== (0, $220c2d58964ba595$export$fcc0626890c55730).hosting ? (0, $220c2d58964ba595$export$fcc0626890c55730).hosting : null;
const $540ee614c8ab8fe3$export$46abdfa6346e2c9b = undefined !== (0, $220c2d58964ba595$export$fcc0626890c55730) && undefined !== (0, $220c2d58964ba595$export$fcc0626890c55730).hosting ? (0, $220c2d58964ba595$export$fcc0626890c55730).hosting : undefined;





var $6wXVr = parcelRequire("6wXVr");


var $6wXVr = parcelRequire("6wXVr");
var $2c44bd8359d60808$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2c44bd8359d60808$var$ReactIs, $2c44bd8359d60808$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$2c44bd8359d60808$exports = (parcelRequire("5K180"))();



var $6wXVr = parcelRequire("6wXVr");
var $65665b05cec8ca18$exports = {};
'use strict';
// do not edit .js files directly - edit src/index.jst
$65665b05cec8ca18$exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};


var $642c3542c0520d1e$exports = {};
'use strict';
Object.defineProperty($642c3542c0520d1e$exports, "__esModule", {
    value: true
});
var $642c3542c0520d1e$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $c35de003786b0b99$exports = {};
'use strict';
var $c35de003786b0b99$var$Sister;
/**
* @link https://github.com/gajus/sister for the canonical source repository
* @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
*/ $c35de003786b0b99$var$Sister = function() {
    var sister = {}, events = {};
    /**
     * @name handler
     * @function
     * @param {Object} data Event data.
     */ /**
     * @param {String} name Event name.
     * @param {handler} handler
     * @return {listener}
     */ sister.on = function(name, handler) {
        var listener = {
            name: name,
            handler: handler
        };
        events[name] = events[name] || [];
        events[name].unshift(listener);
        return listener;
    };
    /**
     * @param {listener}
     */ sister.off = function(listener) {
        var index = events[listener.name].indexOf(listener);
        if (index !== -1) events[listener.name].splice(index, 1);
    };
    /**
     * @param {String} name Event name.
     * @param {Object} data Event data.
     */ sister.trigger = function(name, data) {
        var listeners = events[name], i;
        if (listeners) {
            i = listeners.length;
            while(i--)listeners[i].handler(data);
        }
    };
    return sister;
};
$c35de003786b0b99$exports = $c35de003786b0b99$var$Sister;


var $642c3542c0520d1e$var$_sister2 = $642c3542c0520d1e$var$_interopRequireDefault($c35de003786b0b99$exports);
var $2d0b43248f792f0b$exports = {};
'use strict';
Object.defineProperty($2d0b43248f792f0b$exports, "__esModule", {
    value: true
});
var $97fdae29859220f3$exports = {};
$97fdae29859220f3$exports = function load(src, opts, cb) {
    var head = document.head || document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    if (typeof opts === 'function') {
        cb = opts;
        opts = {};
    }
    opts = opts || {};
    cb = cb || function() {};
    script.type = opts.type || 'text/javascript';
    script.charset = opts.charset || 'utf8';
    script.async = 'async' in opts ? !!opts.async : true;
    script.src = src;
    if (opts.attrs) $97fdae29859220f3$var$setAttributes(script, opts.attrs);
    if (opts.text) script.text = '' + opts.text;
    var onend = 'onload' in script ? $97fdae29859220f3$var$stdOnEnd : $97fdae29859220f3$var$ieOnEnd;
    onend(script, cb);
    // some good legacy browsers (firefox) fail the 'in' detection above
    // so as a fallback we always set onload
    // old IE will ignore this and new IE will set onload
    if (!script.onload) $97fdae29859220f3$var$stdOnEnd(script, cb);
    head.appendChild(script);
};
function $97fdae29859220f3$var$setAttributes(script, attrs) {
    for(var attr in attrs)script.setAttribute(attr, attrs[attr]);
}
function $97fdae29859220f3$var$stdOnEnd(script, cb) {
    script.onload = function() {
        this.onerror = this.onload = null;
        cb(null, script);
    };
    script.onerror = function() {
        // this.onload = null here is necessary
        // because even IE9 works not like others
        this.onerror = this.onload = null;
        cb(new Error('Failed to load ' + this.src), script);
    };
}
function $97fdae29859220f3$var$ieOnEnd(script, cb) {
    script.onreadystatechange = function() {
        if (this.readyState != 'complete' && this.readyState != 'loaded') return;
        this.onreadystatechange = null;
        cb(null, script) // there is no way to catch loading errors in IE8
        ;
    };
}


var $2d0b43248f792f0b$var$_loadScript2 = $2d0b43248f792f0b$var$_interopRequireDefault($97fdae29859220f3$exports);
function $2d0b43248f792f0b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$2d0b43248f792f0b$exports.default = function(emitter) {
    /**
   * A promise that is resolved when window.onYouTubeIframeAPIReady is called.
   * The promise is resolved with a reference to window.YT object.
   */ var iframeAPIReady = new Promise(function(resolve) {
        if (window.YT && window.YT.Player && window.YT.Player instanceof Function) {
            resolve(window.YT);
            return;
        } else {
            var protocol = window.location.protocol === 'http:' ? 'http:' : 'https:';
            (0, $2d0b43248f792f0b$var$_loadScript2.default)(protocol + '//www.youtube.com/iframe_api', function(error) {
                if (error) emitter.trigger('error', error);
            });
        }
        var previous = window.onYouTubeIframeAPIReady;
        // The API will call this function when page has finished downloading
        // the JavaScript for the player API.
        window.onYouTubeIframeAPIReady = function() {
            if (previous) previous();
            resolve(window.YT);
        };
    });
    return iframeAPIReady;
};
$2d0b43248f792f0b$exports = $2d0b43248f792f0b$exports['default'];


var $642c3542c0520d1e$var$_loadYouTubeIframeApi2 = $642c3542c0520d1e$var$_interopRequireDefault($2d0b43248f792f0b$exports);
var $aa1f5dc7c420454b$exports = {};
'use strict';
Object.defineProperty($aa1f5dc7c420454b$exports, "__esModule", {
    value: true
});

var $iBItf = parcelRequire("iBItf");
var $aa1f5dc7c420454b$var$_debug2 = $aa1f5dc7c420454b$var$_interopRequireDefault($iBItf);
var $2ff6f7ab5159a6a9$exports = {};
'use strict';
Object.defineProperty($2ff6f7ab5159a6a9$exports, "__esModule", {
    value: true
});
/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Functions
 */ $2ff6f7ab5159a6a9$exports.default = [
    'cueVideoById',
    'loadVideoById',
    'cueVideoByUrl',
    'loadVideoByUrl',
    'playVideo',
    'pauseVideo',
    'stopVideo',
    'getVideoLoadedFraction',
    'cuePlaylist',
    'loadPlaylist',
    'nextVideo',
    'previousVideo',
    'playVideoAt',
    'setShuffle',
    'setLoop',
    'getPlaylist',
    'getPlaylistIndex',
    'setOption',
    'mute',
    'unMute',
    'isMuted',
    'setVolume',
    'getVolume',
    'seekTo',
    'getPlayerState',
    'getPlaybackRate',
    'setPlaybackRate',
    'getAvailablePlaybackRates',
    'getPlaybackQuality',
    'setPlaybackQuality',
    'getAvailableQualityLevels',
    'getCurrentTime',
    'getDuration',
    'removeEventListener',
    'getVideoUrl',
    'getVideoEmbedCode',
    'getOptions',
    'getOption',
    'addEventListener',
    'destroy',
    'setSize',
    'getIframe'
];
$2ff6f7ab5159a6a9$exports = $2ff6f7ab5159a6a9$exports['default'];


var $aa1f5dc7c420454b$var$_functionNames2 = $aa1f5dc7c420454b$var$_interopRequireDefault($2ff6f7ab5159a6a9$exports);
var $69c655b6bd11006d$exports = {};
'use strict';
Object.defineProperty($69c655b6bd11006d$exports, "__esModule", {
    value: true
});
/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 * `volumeChange` is not officially supported but seems to work
 * it emits an object: `{volume: 82.6923076923077, muted: false}`
 */ $69c655b6bd11006d$exports.default = [
    'ready',
    'stateChange',
    'playbackQualityChange',
    'playbackRateChange',
    'error',
    'apiChange',
    'volumeChange'
];
$69c655b6bd11006d$exports = $69c655b6bd11006d$exports['default'];


var $aa1f5dc7c420454b$var$_eventNames2 = $aa1f5dc7c420454b$var$_interopRequireDefault($69c655b6bd11006d$exports);
var $f896271dbae81712$exports = {};
'use strict';
Object.defineProperty($f896271dbae81712$exports, "__esModule", {
    value: true
});
var $59df0f51c3cb57ac$exports = {};
"use strict";
Object.defineProperty($59df0f51c3cb57ac$exports, "__esModule", {
    value: true
});
$59df0f51c3cb57ac$exports.default = {
    BUFFERING: 3,
    ENDED: 0,
    PAUSED: 2,
    PLAYING: 1,
    UNSTARTED: -1,
    VIDEO_CUED: 5
};
$59df0f51c3cb57ac$exports = $59df0f51c3cb57ac$exports["default"];


var $f896271dbae81712$var$_PlayerStates2 = $f896271dbae81712$var$_interopRequireDefault($59df0f51c3cb57ac$exports);
function $f896271dbae81712$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$f896271dbae81712$exports.default = {
    pauseVideo: {
        acceptableStates: [
            $f896271dbae81712$var$_PlayerStates2.default.ENDED,
            $f896271dbae81712$var$_PlayerStates2.default.PAUSED
        ],
        stateChangeRequired: false
    },
    playVideo: {
        acceptableStates: [
            $f896271dbae81712$var$_PlayerStates2.default.ENDED,
            $f896271dbae81712$var$_PlayerStates2.default.PLAYING
        ],
        stateChangeRequired: false
    },
    seekTo: {
        acceptableStates: [
            $f896271dbae81712$var$_PlayerStates2.default.ENDED,
            $f896271dbae81712$var$_PlayerStates2.default.PLAYING,
            $f896271dbae81712$var$_PlayerStates2.default.PAUSED
        ],
        stateChangeRequired: true,
        // TRICKY: `seekTo` may not cause a state change if no buffering is
        // required.
        timeout: 3000
    }
};
$f896271dbae81712$exports = $f896271dbae81712$exports['default'];


var $aa1f5dc7c420454b$var$_FunctionStateMap2 = $aa1f5dc7c420454b$var$_interopRequireDefault($f896271dbae81712$exports);
function $aa1f5dc7c420454b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint-disable promise/prefer-await-to-then */ var $aa1f5dc7c420454b$var$debug = (0, $aa1f5dc7c420454b$var$_debug2.default)('youtube-player');
var $aa1f5dc7c420454b$var$YouTubePlayer = {};
/**
 * Construct an object that defines an event handler for all of the YouTube
 * player events. Proxy captured events through an event emitter.
 *
 * @todo Capture event parameters.
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 */ $aa1f5dc7c420454b$var$YouTubePlayer.proxyEvents = function(emitter) {
    var events = {};
    var _loop = function _loop(eventName) {
        var onEventName = 'on' + eventName.slice(0, 1).toUpperCase() + eventName.slice(1);
        events[onEventName] = function(event) {
            $aa1f5dc7c420454b$var$debug('event "%s"', onEventName, event);
            emitter.trigger(eventName, event);
        };
    };
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        for(var _iterator = $aa1f5dc7c420454b$var$_eventNames2.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var eventName = _step.value;
            _loop(eventName);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
    return events;
};
/**
 * Delays player API method execution until player state is ready.
 *
 * @todo Proxy all of the methods using Object.keys.
 * @todo See TRICKY below.
 * @param playerAPIReady Promise that resolves when player is ready.
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions.
 * @returns {Object}
 */ $aa1f5dc7c420454b$var$YouTubePlayer.promisifyPlayer = function(playerAPIReady) {
    var strictState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var functions = {};
    var _loop2 = function _loop2(functionName) {
        if (strictState && $aa1f5dc7c420454b$var$_FunctionStateMap2.default[functionName]) functions[functionName] = function() {
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return playerAPIReady.then(function(player) {
                var stateInfo = $aa1f5dc7c420454b$var$_FunctionStateMap2.default[functionName];
                var playerState = player.getPlayerState();
                // eslint-disable-next-line no-warning-comments
                // TODO: Just spread the args into the function once Babel is fixed:
                // https://github.com/babel/babel/issues/4270
                //
                // eslint-disable-next-line prefer-spread
                var value = player[functionName].apply(player, args);
                // TRICKY: For functions like `seekTo`, a change in state must be
                // triggered given that the resulting state could match the initial
                // state.
                if (stateInfo.stateChangeRequired || // eslint-disable-next-line no-extra-parens
                Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerState) === -1) return new Promise(function(resolve) {
                    var onPlayerStateChange = function onPlayerStateChange() {
                        var playerStateAfterChange = player.getPlayerState();
                        var timeout = void 0;
                        if (typeof stateInfo.timeout === 'number') timeout = setTimeout(function() {
                            player.removeEventListener('onStateChange', onPlayerStateChange);
                            resolve();
                        }, stateInfo.timeout);
                        if (Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerStateAfterChange) !== -1) {
                            player.removeEventListener('onStateChange', onPlayerStateChange);
                            clearTimeout(timeout);
                            resolve();
                        }
                    };
                    player.addEventListener('onStateChange', onPlayerStateChange);
                }).then(function() {
                    return value;
                });
                return value;
            });
        };
        else functions[functionName] = function() {
            for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return playerAPIReady.then(function(player) {
                // eslint-disable-next-line no-warning-comments
                // TODO: Just spread the args into the function once Babel is fixed:
                // https://github.com/babel/babel/issues/4270
                //
                // eslint-disable-next-line prefer-spread
                return player[functionName].apply(player, args);
            });
        };
    };
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;
    try {
        for(var _iterator2 = $aa1f5dc7c420454b$var$_functionNames2.default[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var functionName = _step2.value;
            _loop2(functionName);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
        } finally{
            if (_didIteratorError2) throw _iteratorError2;
        }
    }
    return functions;
};
$aa1f5dc7c420454b$exports.default = $aa1f5dc7c420454b$var$YouTubePlayer;
$aa1f5dc7c420454b$exports = $aa1f5dc7c420454b$exports['default'];


var $642c3542c0520d1e$var$_YouTubePlayer2 = $642c3542c0520d1e$var$_interopRequireDefault($aa1f5dc7c420454b$exports);
function $642c3542c0520d1e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @typedef YT.Player
 * @see https://developers.google.com/youtube/iframe_api_reference
 * */ /**
 * @see https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
 */ var $642c3542c0520d1e$var$youtubeIframeAPI = void 0;
/**
 * A factory function used to produce an instance of YT.Player and queue function calls and proxy events of the resulting object.
 *
 * @param maybeElementId Either An existing YT.Player instance,
 * the DOM element or the id of the HTML element where the API will insert an <iframe>.
 * @param options See `options` (Ignored when using an existing YT.Player instance).
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions. Default: `false`.
 * See `FunctionStateMap.js` for supported functions and acceptable states.
 */ $642c3542c0520d1e$exports.default = function(maybeElementId) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var strictState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var emitter = (0, $642c3542c0520d1e$var$_sister2.default)();
    if (!$642c3542c0520d1e$var$youtubeIframeAPI) $642c3542c0520d1e$var$youtubeIframeAPI = (0, $642c3542c0520d1e$var$_loadYouTubeIframeApi2.default)(emitter);
    if (options.events) throw new Error('Event handlers cannot be overwritten.');
    if (typeof maybeElementId === 'string' && !document.getElementById(maybeElementId)) throw new Error('Element "' + maybeElementId + '" does not exist.');
    options.events = $642c3542c0520d1e$var$_YouTubePlayer2.default.proxyEvents(emitter);
    var playerAPIReady = new Promise(function(resolve) {
        if ((typeof maybeElementId === 'undefined' ? 'undefined' : $642c3542c0520d1e$var$_typeof(maybeElementId)) === 'object' && maybeElementId.playVideo instanceof Function) {
            var player = maybeElementId;
            resolve(player);
        } else // asume maybeElementId can be rendered inside
        // eslint-disable-next-line promise/catch-or-return
        $642c3542c0520d1e$var$youtubeIframeAPI.then(function(YT) {
            // eslint-disable-line promise/prefer-await-to-then
            var player = new YT.Player(maybeElementId, options);
            emitter.on('ready', function() {
                resolve(player);
            });
            return null;
        });
    });
    var playerApi = $642c3542c0520d1e$var$_YouTubePlayer2.default.promisifyPlayer(playerAPIReady, strictState);
    playerApi.on = emitter.on;
    playerApi.off = emitter.off;
    return playerApi;
};
$642c3542c0520d1e$exports = $642c3542c0520d1e$exports['default'];


function $866058b3dedaea2b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $866058b3dedaea2b$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $866058b3dedaea2b$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $866058b3dedaea2b$var$_typeof(obj);
}
function $866058b3dedaea2b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $866058b3dedaea2b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $866058b3dedaea2b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $866058b3dedaea2b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $866058b3dedaea2b$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $866058b3dedaea2b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $866058b3dedaea2b$var$_setPrototypeOf(subClass, superClass);
}
function $866058b3dedaea2b$var$_setPrototypeOf(o, p) {
    $866058b3dedaea2b$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $866058b3dedaea2b$var$_setPrototypeOf(o, p);
}
function $866058b3dedaea2b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $866058b3dedaea2b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $866058b3dedaea2b$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $866058b3dedaea2b$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $866058b3dedaea2b$var$_possibleConstructorReturn(this, result);
    };
}
function $866058b3dedaea2b$var$_possibleConstructorReturn(self, call) {
    if (call && ($866058b3dedaea2b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $866058b3dedaea2b$var$_assertThisInitialized(self);
}
function $866058b3dedaea2b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $866058b3dedaea2b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $866058b3dedaea2b$var$_getPrototypeOf(o) {
    $866058b3dedaea2b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $866058b3dedaea2b$var$_getPrototypeOf(o);
}
function $866058b3dedaea2b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $866058b3dedaea2b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $866058b3dedaea2b$var$ownKeys(Object(source), true).forEach(function(key) {
            $866058b3dedaea2b$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $866058b3dedaea2b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $866058b3dedaea2b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * Check whether a `props` change should result in the video being updated.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */ function $866058b3dedaea2b$var$shouldUpdateVideo(prevProps, props) {
    // A changing video should always trigger an update
    if (prevProps.videoId !== props.videoId) return true;
     // Otherwise, a change in the start/end time playerVars also requires a player
    // update.
    var prevVars = prevProps.opts.playerVars || {};
    var vars = props.opts.playerVars || {};
    return prevVars.start !== vars.start || prevVars.end !== vars.end;
}
/**
 * Neutralize API options that only require a video update, leaving only options
 * that require a player reset. The results can then be compared to see if a
 * player reset is necessary.
 *
 * @param {Object} opts
 */ function $866058b3dedaea2b$var$filterResetOptions(opts) {
    return $866058b3dedaea2b$var$_objectSpread($866058b3dedaea2b$var$_objectSpread({}, opts), {}, {
        height: 0,
        width: 0,
        playerVars: $866058b3dedaea2b$var$_objectSpread($866058b3dedaea2b$var$_objectSpread({}, opts.playerVars), {}, {
            autoplay: 0,
            start: 0,
            end: 0
        })
    });
}
/**
 * Check whether a `props` change should result in the player being reset.
 * The player is reset when the `props.opts` change, except if the only change
 * is in the `start` and `end` playerVars, because a video update can deal with
 * those.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */ function $866058b3dedaea2b$var$shouldResetPlayer(prevProps, props) {
    return prevProps.videoId !== props.videoId || !(0, (/*@__PURE__*/$parcel$interopDefault($65665b05cec8ca18$exports)))($866058b3dedaea2b$var$filterResetOptions(prevProps.opts), $866058b3dedaea2b$var$filterResetOptions(props.opts));
}
/**
 * Check whether a props change should result in an id or className update.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */ function $866058b3dedaea2b$var$shouldUpdatePlayer(prevProps, props) {
    return prevProps.id !== props.id || prevProps.className !== props.className || prevProps.opts.width !== props.opts.width || prevProps.opts.height !== props.opts.height || prevProps.title !== props.title;
}
var $866058b3dedaea2b$var$YouTube = /*#__PURE__*/ function(_React$Component) {
    $866058b3dedaea2b$var$_inherits(YouTube, _React$Component);
    var _super = $866058b3dedaea2b$var$_createSuper(YouTube);
    /**
   * Expose PlayerState constants for convenience. These constants can also be
   * accessed through the global YT object after the YouTube IFrame API is instantiated.
   * https://developers.google.com/youtube/iframe_api_reference#onStateChange
   */ function YouTube(props) {
        var _this;
        $866058b3dedaea2b$var$_classCallCheck(this, YouTube);
        _this = _super.call(this, props);
        $866058b3dedaea2b$var$_defineProperty($866058b3dedaea2b$var$_assertThisInitialized(_this), "onPlayerReady", function(event) {
            return _this.props.onReady(event);
        });
        $866058b3dedaea2b$var$_defineProperty($866058b3dedaea2b$var$_assertThisInitialized(_this), "onPlayerError", function(event) {
            return _this.props.onError(event);
        });
        $866058b3dedaea2b$var$_defineProperty($866058b3dedaea2b$var$_assertThisInitialized(_this), "onPlayerStateChange", function(event) {
            _this.props.onStateChange(event);
            switch(event.data){
                case YouTube.PlayerState.ENDED:
                    _this.props.onEnd(event);
                    break;
                case YouTube.PlayerState.PLAYING:
                    _this.props.onPlay(event);
                    break;
                case YouTube.PlayerState.PAUSED:
                    _this.props.onPause(event);
                    break;
                default:
            }
        });
        $866058b3dedaea2b$var$_defineProperty($866058b3dedaea2b$var$_assertThisInitialized(_this), "onPlayerPlaybackRateChange", function(event) {
            return _this.props.onPlaybackRateChange(event);
        });
        $866058b3dedaea2b$var$_defineProperty($866058b3dedaea2b$var$_assertThisInitialized(_this), "onPlayerPlaybackQualityChange", function(event) {
            return _this.props.onPlaybackQualityChange(event);
        });
        $866058b3dedaea2b$var$_defineProperty($866058b3dedaea2b$var$_assertThisInitialized(_this), "createPlayer", function() {
            // do not attempt to create a player server-side, it won't work
            if (typeof document === 'undefined') return; // create player
            var playerOpts = $866058b3dedaea2b$var$_objectSpread($866058b3dedaea2b$var$_objectSpread({}, _this.props.opts), {}, {
                // preload the `videoId` video if one is already given
                videoId: _this.props.videoId
            });
            _this.internalPlayer = (0, (/*@__PURE__*/$parcel$interopDefault($642c3542c0520d1e$exports)))(_this.container, playerOpts); // attach event handlers
            _this.internalPlayer.on('ready', _this.onPlayerReady);
            _this.internalPlayer.on('error', _this.onPlayerError);
            _this.internalPlayer.on('stateChange', _this.onPlayerStateChange);
            _this.internalPlayer.on('playbackRateChange', _this.onPlayerPlaybackRateChange);
            _this.internalPlayer.on('playbackQualityChange', _this.onPlayerPlaybackQualityChange);
        });
        $866058b3dedaea2b$var$_defineProperty($866058b3dedaea2b$var$_assertThisInitialized(_this), "resetPlayer", function() {
            return _this.internalPlayer.destroy().then(_this.createPlayer);
        });
        $866058b3dedaea2b$var$_defineProperty($866058b3dedaea2b$var$_assertThisInitialized(_this), "updatePlayer", function() {
            _this.internalPlayer.getIframe().then(function(iframe) {
                if (_this.props.id) iframe.setAttribute('id', _this.props.id);
                else iframe.removeAttribute('id');
                if (_this.props.className) iframe.setAttribute('class', _this.props.className);
                else iframe.removeAttribute('class');
                if (_this.props.opts && _this.props.opts.width) iframe.setAttribute('width', _this.props.opts.width);
                else iframe.removeAttribute('width');
                if (_this.props.opts && _this.props.opts.height) iframe.setAttribute('height', _this.props.opts.height);
                else iframe.removeAttribute('height');
                if (typeof _this.props.title === 'string') iframe.setAttribute('title', _this.props.title);
                else iframe.setAttribute('title', 'YouTube video player');
            });
        });
        $866058b3dedaea2b$var$_defineProperty($866058b3dedaea2b$var$_assertThisInitialized(_this), "getInternalPlayer", function() {
            return _this.internalPlayer;
        });
        $866058b3dedaea2b$var$_defineProperty($866058b3dedaea2b$var$_assertThisInitialized(_this), "updateVideo", function() {
            if (typeof _this.props.videoId === 'undefined' || _this.props.videoId === null) {
                _this.internalPlayer.stopVideo();
                return;
            } // set queueing options
            var autoplay = false;
            var opts = {
                videoId: _this.props.videoId
            };
            if ('playerVars' in _this.props.opts) {
                autoplay = _this.props.opts.playerVars.autoplay === 1;
                if ('start' in _this.props.opts.playerVars) opts.startSeconds = _this.props.opts.playerVars.start;
                if ('end' in _this.props.opts.playerVars) opts.endSeconds = _this.props.opts.playerVars.end;
            } // if autoplay is enabled loadVideoById
            if (autoplay) {
                _this.internalPlayer.loadVideoById(opts);
                return;
            } // default behaviour just cues the video
            _this.internalPlayer.cueVideoById(opts);
        });
        $866058b3dedaea2b$var$_defineProperty($866058b3dedaea2b$var$_assertThisInitialized(_this), "refContainer", function(container) {
            _this.container = container;
        });
        _this.container = null;
        _this.internalPlayer = null;
        return _this;
    }
    $866058b3dedaea2b$var$_createClass(YouTube, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.createPlayer();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if ($866058b3dedaea2b$var$shouldUpdatePlayer(prevProps, this.props)) this.updatePlayer();
                if ($866058b3dedaea2b$var$shouldResetPlayer(prevProps, this.props)) this.resetPlayer();
                if ($866058b3dedaea2b$var$shouldUpdateVideo(prevProps, this.props)) this.updateVideo();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                /**
       * Note: The `youtube-player` package that is used promisifies all YouTube
       * Player API calls, which introduces a delay of a tick before it actually
       * gets destroyed. Since React attempts to remove the element instantly
       * this method isn't quick enough to reset the container element.
       */ this.internalPlayer.destroy();
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                    className: this.props.containerClassName
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                    id: this.props.id,
                    className: this.props.className,
                    ref: this.refContainer,
                    loading: this.props.loading
                }));
            }
        }
    ]);
    return YouTube;
}((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component);
$866058b3dedaea2b$var$_defineProperty($866058b3dedaea2b$var$YouTube, "PlayerState", {
    UNSTARTED: -1,
    ENDED: 0,
    PLAYING: 1,
    PAUSED: 2,
    BUFFERING: 3,
    CUED: 5
});
$866058b3dedaea2b$var$YouTube.propTypes = {
    videoId: (0, (/*@__PURE__*/$parcel$interopDefault($2c44bd8359d60808$exports))).string,
    // custom ID for player element
    id: (0, (/*@__PURE__*/$parcel$interopDefault($2c44bd8359d60808$exports))).string,
    // custom class name for player element
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2c44bd8359d60808$exports))).string,
    // custom class name for player container element
    containerClassName: (0, (/*@__PURE__*/$parcel$interopDefault($2c44bd8359d60808$exports))).string,
    // custom title for the iFrame, see https://www.w3.org/TR/WCAG20-TECHS/H64.html
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2c44bd8359d60808$exports))).string,
    // custom loading for player element
    loading: (0, (/*@__PURE__*/$parcel$interopDefault($2c44bd8359d60808$exports))).oneOf([
        'lazy',
        'eager',
        'auto'
    ]),
    // https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
    opts: (0, (/*@__PURE__*/$parcel$interopDefault($2c44bd8359d60808$exports))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2c44bd8359d60808$exports))).any),
    // event subscriptions
    onReady: (0, (/*@__PURE__*/$parcel$interopDefault($2c44bd8359d60808$exports))).func,
    onError: (0, (/*@__PURE__*/$parcel$interopDefault($2c44bd8359d60808$exports))).func,
    onPlay: (0, (/*@__PURE__*/$parcel$interopDefault($2c44bd8359d60808$exports))).func,
    onPause: (0, (/*@__PURE__*/$parcel$interopDefault($2c44bd8359d60808$exports))).func,
    onEnd: (0, (/*@__PURE__*/$parcel$interopDefault($2c44bd8359d60808$exports))).func,
    onStateChange: (0, (/*@__PURE__*/$parcel$interopDefault($2c44bd8359d60808$exports))).func,
    onPlaybackRateChange: (0, (/*@__PURE__*/$parcel$interopDefault($2c44bd8359d60808$exports))).func,
    onPlaybackQualityChange: (0, (/*@__PURE__*/$parcel$interopDefault($2c44bd8359d60808$exports))).func
};
$866058b3dedaea2b$var$YouTube.defaultProps = {
    videoId: null,
    id: null,
    className: null,
    loading: null,
    opts: {},
    containerClassName: '',
    onReady: function onReady() {},
    onError: function onError() {},
    onPlay: function onPlay() {},
    onPause: function onPause() {},
    onEnd: function onEnd() {},
    onStateChange: function onStateChange() {},
    onPlaybackRateChange: function onPlaybackRateChange() {},
    onPlaybackQualityChange: function onPlaybackQualityChange() {},
    title: null
};
var $866058b3dedaea2b$export$2e2bcd8739ae039 = $866058b3dedaea2b$var$YouTube;


class $5b2aaa3e3aa41ef7$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    constructor(props, context){
        super(props, context);
        this.onPlayerStateChange = this.onPlayerStateChange.bind(this);
    }
    onPlayerStateChange(event) {
        let videoName = this.props.video_name;
        // https://developers.google.com/youtube/iframe_api_reference
        // 1 = playing
        if (event.data === 1) {
            if (videoName === null) videoName = this.player.getVideoData().title;
            window.tracker.trackEvent("Video", "play video", videoName);
        }
    }
    render() {
        const YouTubeOpts = {
            height: '100%',
            width: '100%'
        };
        // Note `react-youtube` component is much older than the current documentation to support React v16
        // See the older `README.md` for correct info:
        // https://github.com/tjallingt/react-youtube/blob/v7.14.0/README.md
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $866058b3dedaea2b$export$2e2bcd8739ae039), {
            containerClassName: "embed-fluid",
            opts: YouTubeOpts,
            videoId: this.props.video_id,
            title: "YouTube Video: " + this.props.video_name,
            onStateChange: this.onPlayerStateChange
        });
    }
}


class $f292990dd0e2c7b0$export$3e41ac2ae5cf26a1 extends (0, $6wXVr.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $5b2aaa3e3aa41ef7$export$2e2bcd8739ae039), {
            video_id: this.props.item.video,
            video_name: this.props.item.name
        }), this.props.item.hasOwnProperty('transcript') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "/transcripts/" + this.props.item.transcript
        }, this.props.item.name, " - Video Transcript") : this.props.item.description);
    }
}
class $f292990dd0e2c7b0$export$9422f5e44a619a3a extends (0, $6wXVr.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: this.props.item.link,
            className: "link-icon",
            target: "_blank",
            rel: "noopener noreferrer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            className: "img-fluid border",
            src: (0, $540ee614c8ab8fe3$export$46abdfa6346e2c9b) + '/img/' + this.props.item.thumbnail,
            alt: "",
            role: "presentation"
        }), this.props.item.description, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fas fa-external-link-alt",
            title: "(external site)"
        })));
    }
}


class $025921cd7b8246a8$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    static howtos = [
        {
            id: 1,
            name: 'Authorizing Corgi with Google',
            link: 'https://docs.google.com/document/d/1lxgWSJ9yo6bK5kw_P37eK0N3oQ-hI70OUj6g2QqxApw/edit',
            thumbnail: 'how-to-authorize.png',
            description: 'Authorizing Corgi with Google (Doc)'
        },
        {
            id: 2,
            name: 'What\'s in every Corgi Guide?',
            link: 'https://docs.google.com/document/d/1navsFRuY7f1T5zAfsV7GgYgjHLtqMoXXF7JHPrJQrCg/edit',
            thumbnail: 'whats-in-every-guide.png',
            description: 'What\'s in every Corgi Guide? (Doc)'
        },
        {
            id: 3,
            name: 'Sharing a Corgi guide',
            link: 'https://docs.google.com/document/d/1HVu5boJEvz_Q8pM8cOXFtw3u6-N8EB6zfP62jGsgtmw/edit',
            thumbnail: 'sharing-a-corgi-guide.png',
            description: 'Sharing a Corgi guide (Doc)'
        }
    ];
    componentDidMount() {
        (0, $2c839b9f78572b9b$export$2e2bcd8739ae039)();
    }
    render() {
        let howtoHtml = [];
        for(let n = 0; n < $025921cd7b8246a8$export$2e2bcd8739ae039.howtos.length; n++){
            const item = $025921cd7b8246a8$export$2e2bcd8739ae039.howtos[n];
            if (item.hasOwnProperty('video')) howtoHtml.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $f292990dd0e2c7b0$export$3e41ac2ae5cf26a1), {
                key: n,
                item: item
            }));
            else howtoHtml.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $f292990dd0e2c7b0$export$9422f5e44a619a3a), {
                key: n,
                item: item
            }));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "page-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "content",
            className: "content row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "content-main col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "content-main-inner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("main", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "login-splash"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "login-splash-overlay"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "container-fluid"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("nav", {
            className: "navbar navbar-expand-md login-splash-nav"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "btn btn-icon btn-link text-dark d-md-none",
            title: "Toggle page menu",
            "data-cfw": "collapse",
            "data-cfw-collapse-target": "#loginNavbar"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-bars",
            "aria-hidden": "true"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "navbar-collapse collapse",
            id: "loginNavbar"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", {
            className: "navbar-nav"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "nav-item dropdown"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "nav-link",
            "data-cfw": "dropdown"
        }, "About Corgi", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "caret ms-0_25",
            "aria-hidden": "true"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", {
            className: "dropdown-menu"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e10f0f56b55cf4b2$export$2e2bcd8739ae039), {
            page: "about",
            hash: "#why"
        }, "Why Corgi works")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e10f0f56b55cf4b2$export$2e2bcd8739ae039), {
            page: "about",
            hash: "#research"
        }, "Research")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e10f0f56b55cf4b2$export$2e2bcd8739ae039), {
            page: "about",
            hash: "#technology"
        }, "Technology")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e10f0f56b55cf4b2$export$2e2bcd8739ae039), {
            page: "about",
            hash: "#features"
        }, "Key features")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "nav-item dropdown"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "nav-link",
            "data-cfw": "dropdown"
        }, "Teach with Corgi", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "caret ms-0_25",
            "aria-hidden": "true"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", {
            className: "dropdown-menu"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "/sample/annotated/comparison"
        }, "Sample Guide")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://docs.google.com/document/d/1dAB-lNMeE-E38YOxARfWgHytGgQ0Jq9f0H16WyvXqw8/edit",
            target: "_blank",
            rel: "noopener noreferrer"
        }, "Sample Lesson")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e10f0f56b55cf4b2$export$2e2bcd8739ae039), {
            page: "support",
            hash: "#video"
        }, "How to Videos")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e10f0f56b55cf4b2$export$2e2bcd8739ae039), {
            page: "support",
            hash: "#pl"
        }, "P.L. Resources")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "nav-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e10f0f56b55cf4b2$export$2e2bcd8739ae039), {
            page: "faq",
            className: "nav-link"
        }, "FAQ"))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-7"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h1", {
            className: "login-splash-logo",
            id: "main_container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, $540ee614c8ab8fe3$export$46abdfa6346e2c9b) + "/img/mark.svg",
            className: "login-splash-logo-img",
            alt: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "login-splash-logo-text"
        }, "Corgi")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "login-splash-lead"
        }, "Digital graphic organizers for building higher-order thinking skills"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "login",
            className: "lead font-weight-bold"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "pe-0_25"
        }, "Corgi is ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("em", null, "free!")), " Sign up to get started:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $be83f2d5d13e3a7b$export$c43bfb5198aa7b21), {
            authorizeMethod: this.props.authorizeMethod
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "fs-small"
        }, "Don't have a Google account? ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://mail.google.com/",
            className: "link-icon"
        }, "Create a free ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            "aria-hidden": "true"
        }, "one"), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Google account"), " here", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fas fa-external-link-alt",
            title: "(external site)"
        }))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "container px-0 px-md-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row px-1 px-md-0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6 pt-1 py-md-1_5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "embed-fluid embed-fluid-16x9"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("iframe", {
            src: "https://www.youtube-nocookie.com/embed/Qz0T8C57fl0?enablejsapi=1",
            frameBorder: "0",
            title: "Youtube Video",
            "aria-label": "Youtube Video: Corgi: Graphic organizers transformed",
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowFullScreen: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "/transcripts/short-transformed.html"
        }, "Corgi: Graphic organizers transformed - Video Transcript")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6 pt-1 py-md-1_5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            className: "h1"
        }, "Meet Corgi"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", {
            className: "lead"
        }, "Learn how Corgi transforms traditional graphic organizers into flexible, accessible digital tools for learning."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "pb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            className: "h1"
        }, "Research with us!"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, "We're looking for research partners to try out Corgi in the classroom.", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "mailto:corgi@cast.org"
        }, "Contact us"), " to learn more.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "py-1 py-md-1_5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            id: "get-started",
            className: "h1"
        }, "Ready to begin using Corgi?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", {
            className: "lead"
        }, "Our quick how-tos will help you get started"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, "If you are new to Corgi, check out our series of self-guided tutorials to learn more about Corgi\u2019s innovative features, connecting Corgi to your Google account, using Corgi with Google Classroom, and more!"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row row-cols-1 row-cols-md-2 row-cols-lg-3"
        }, howtoHtml), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e10f0f56b55cf4b2$export$2e2bcd8739ae039), {
            page: "support",
            className: "link-icon"
        }, "Find more on how to use Corgi", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fas fa-arrow-right"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bg-active text-white py-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "container"
        }, "Looking for the previous version of Corgi? ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://corgi1.cast.org",
            className: "text-white link-icon"
        }, "Login ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "to the previous Corgi site"), " here", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fas fa-arrow-right",
            title: "(external site)"
        })))))))));
    }
}





var $6wXVr = parcelRequire("6wXVr");

var $6wXVr = parcelRequire("6wXVr");
class $508248f6f0651524$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    render() {
        var children = null;
        if (this.props.children) children = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "breadcrumb-item active",
            "aria-current": "page"
        }, this.props.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("nav", {
            "aria-label": "breadcrumb"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ol", {
            className: "breadcrumb breadcrumb-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "breadcrumb-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "/"
        }, "Home")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "breadcrumb-item"
        }, this.props.name), children));
    }
}



const $01b9ff3914809222$var$imagesLoaded = (callback)=>{
    // https://stackoverflow.com/questions/11071314/javascript-execute-after-all-images-have-loaded
    Promise.all(Array.from(document.images).map((img)=>{
        if (img.complete) return Promise.resolve(img.naturalHeight !== 'undefined');
        return new Promise((resolve)=>{
            img.addEventListener('load', ()=>resolve(true));
            img.addEventListener('error', ()=>resolve(false));
        });
    })).then((results)=>{
        if (results.every((res)=>res)) //console.log('all images loaded successfully');
        {
            if (typeof callback === 'function') callback();
            else //console.log('some images failed to load, all finished loading');
            if (typeof callback === 'function') callback();
        }
    });
};
const $01b9ff3914809222$export$f21eb943f370a62a = ()=>{
    return document.getElementById(window.location.hash.substring(1));
};
const $01b9ff3914809222$var$scrollToElement = (element)=>{
    element.scrollIntoView({
        block: 'start'
    });
    // Scroll down to get item below header bar
    const offsetVar = getComputedStyle(document.documentElement).getPropertyValue('--header-offset');
    const offsetPx = Math.floor(parseFloat(offsetVar) * 16) * -1;
    window.scrollBy(0, offsetPx);
};
const $01b9ff3914809222$export$be2be31541771141 = ()=>{
    const element = $01b9ff3914809222$export$f21eb943f370a62a();
    if (element) $01b9ff3914809222$var$imagesLoaded(()=>{
        $01b9ff3914809222$var$scrollToElement(element);
    });
};



class $ca8a14d60dfe4182$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    // Some of these are videos, and some are links to slide presentations.
    static shorts = [
        {
            id: 1,
            name: 'Corgi: Graphic organizers transformed',
            video: 'Qz0T8C57fl0',
            description: 'Corgi: Graphic organizers transformed (video)',
            transcript: "short-transformed.html"
        },
        {
            id: 2,
            name: 'Corgi: Empowering Students to Think',
            video: 'wvjWh-1Xxw0',
            description: 'Corgi: Empowering Students to Think (video)',
            transcript: "short-empowering.html"
        }
    ];
    static howtos = [
        {
            id: 1,
            name: 'How to use Google Classroom with Corgi',
            video: '1TvTdI3bB90',
            description: 'How to use Google Classroom with Corgi (video)'
        },
        {
            id: 2,
            name: 'Introduction to Corgi\'s features',
            link: 'https://docs.google.com/presentation/d/1nC7AWtgtuWJDStX02Goy8Va0eswfKZtIlS3KKuq-RI4/present',
            thumbnail: 'intro-to-corgi-features.png',
            description: 'Introduction to Corgi\'s features (slide deck)'
        },
        {
            id: 3,
            name: 'What\'s in every Corgi Guide?',
            link: 'https://docs.google.com/document/d/1navsFRuY7f1T5zAfsV7GgYgjHLtqMoXXF7JHPrJQrCg/edit',
            thumbnail: 'whats-in-every-guide.png',
            description: 'What\'s in every Corgi Guide? (document)'
        },
        {
            id: 4,
            name: 'Sharing a Corgi guide',
            link: 'https://docs.google.com/presentation/d/1F3emK3ptsRgIDSn23pd-EcbOwlW8Rx1dvqBMkCP5VZM/present',
            thumbnail: 'sharing-a-corgi-guide.png',
            description: 'How to share a Corgi guide (slide deck)'
        },
        {
            id: 5,
            name: 'Sharing a Corgi guide',
            link: 'https://docs.google.com/document/d/1HVu5boJEvz_Q8pM8cOXFtw3u6-N8EB6zfP62jGsgtmw/edit',
            thumbnail: 'sharing-a-corgi-guide.png',
            description: 'How to share a Corgi guide (document)'
        },
        {
            id: 6,
            name: 'Authorizing Corgi with Google',
            link: 'https://docs.google.com/presentation/d/1z9TaKCdRZ5E5TuVvbLuBl_D-g15qaP3-_kGEy3lEZZU/present',
            thumbnail: 'how-to-authorize.png',
            description: 'How to authorize Corgi to work with your Google account (slide deck)'
        },
        {
            id: 7,
            name: 'Authorizing Corgi with Google',
            link: 'https://docs.google.com/document/d/1lxgWSJ9yo6bK5kw_P37eK0N3oQ-hI70OUj6g2QqxApw/edit',
            thumbnail: 'how-to-authorize.png',
            description: 'How to authorize Corgi to work with your Google account (document)'
        },
        {
            id: 8,
            name: 'Student Demo',
            link: 'https://docs.google.com/presentation/d/1bzyvi2lm435I7T9gX3cRtwV4dd64eo7jev5G-MbZWFQ/present',
            thumbnail: 'how-to-student-demo.png',
            description: 'Learn with Corgi - Student Demo (video)'
        }
    ];
    static plSeries = [
        {
            id: 1,
            name: 'Teaching with Corgi',
            link: 'https://docs.google.com/document/d/1ytgJ3pLu-MCOFfnGNdavmsU2LjiDNUMvKxrLKpmP-xo/edit',
            thumbnail: 'teaching-with-corgi.png',
            description: 'Teaching with Corgi (document)'
        },
        {
            id: 2,
            name: 'Corgi Tips for Teachers',
            link: 'https://docs.google.com/document/d/180wQ7OW6GgIcOLKEehAFzeUa_GJNZP3UmyjHQ051wFI/edit',
            thumbnail: 'tips-for-teachers.png',
            description: 'Corgi Tips for Teachers (document)'
        },
        {
            id: 3,
            name: 'Ten Ways Corgi Supports Quality Instruction',
            link: 'https://docs.google.com/document/d/1pIX3OFUszss_ZG5OgLFKkPICm_aKbh6ylb2Ne2PPnwY/edit',
            thumbnail: 'quality_instruction.png',
            description: 'Ten Ways Corgi Supports Quality Instruction (document)'
        },
        {
            id: 4,
            name: 'UDL + Corgi',
            link: 'https://docs.google.com/presentation/d/15yKlMbd2iGtlQIyYd1cYFlqKzT67ymV9hG1KI5y58ZE/present',
            thumbnail: 'udl_corgi.png',
            description: 'UDL + Corgi (slide deck)'
        },
        {
            id: 5,
            name: 'UDL + Corgi',
            link: 'https://docs.google.com/document/d/1RY-S60SMC00d1Watfr7afQNrcQY3Qrld0hsPqFyNxWY/edit',
            thumbnail: 'udl_corgi.png',
            description: 'UDL + Corgi (document)'
        },
        {
            id: 6,
            name: 'Determining Which Guide to Use',
            link: 'https://docs.google.com/document/d/1MY9NnRZwCYQKaeJ0-MG2ckFbieZGtxGa4k9LdhzGnU8/edit',
            thumbnail: 'determining_guide.png',
            description: 'Determining Which Guide to Use (document)'
        },
        {
            id: 7,
            name: 'Using Corgi in Different Contexts',
            link: 'https://docs.google.com/document/d/1zFdQQ0F2BcRNPMoPFHWHWI4QXJs2AKwTCoeBrAp5dNU/edit',
            thumbnail: 'different_contexts.png',
            description: 'Using Corgi in Different Contexts (document)'
        },
        {
            id: 8,
            name: 'Reviewing Corgi Guides',
            link: 'https://docs.google.com/document/d/13Xs-Ynkc9tR1E0sqT5rSWhnYUn2L8QbDvkEMx1ZZSKM/edit',
            thumbnail: 'reviewing-guides.png',
            description: 'Reviewing Corgi Guides (document)'
        }
    ];
    componentDidMount() {
        if (this.context.currentUser !== null) window.tracker.trackPageView(this.context.currentUser, 'user-support');
        (0, $01b9ff3914809222$export$be2be31541771141)();
    }
    render() {
        let shortsHtml = [];
        for(let n = 0; n < $ca8a14d60dfe4182$export$2e2bcd8739ae039.shorts.length; n++){
            const item = $ca8a14d60dfe4182$export$2e2bcd8739ae039.shorts[n];
            if (item.hasOwnProperty('video')) shortsHtml.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $f292990dd0e2c7b0$export$3e41ac2ae5cf26a1), {
                key: n,
                item: item
            }));
            else shortsHtml.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $f292990dd0e2c7b0$export$9422f5e44a619a3a), {
                key: n,
                item: item
            }));
        }
        let howtoHtml = [];
        for(let n = 0; n < $ca8a14d60dfe4182$export$2e2bcd8739ae039.howtos.length; n++){
            const item = $ca8a14d60dfe4182$export$2e2bcd8739ae039.howtos[n];
            if (item.hasOwnProperty('video')) howtoHtml.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $f292990dd0e2c7b0$export$3e41ac2ae5cf26a1), {
                key: n,
                item: item
            }));
            else howtoHtml.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $f292990dd0e2c7b0$export$9422f5e44a619a3a), {
                key: n,
                item: item
            }));
        }
        let plHtml = [];
        for(let n = 0; n < $ca8a14d60dfe4182$export$2e2bcd8739ae039.plSeries.length; n++){
            const item = $ca8a14d60dfe4182$export$2e2bcd8739ae039.plSeries[n];
            if (item.hasOwnProperty('video')) plHtml.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $f292990dd0e2c7b0$export$3e41ac2ae5cf26a1), {
                key: n,
                item: item
            }));
            else plHtml.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $f292990dd0e2c7b0$export$9422f5e44a619a3a), {
                key: n,
                item: item
            }));
        }
        // let resourcesHtml = [];
        // for (let n=0; n < UserSupport.resources.length; n++) {
        //     const item = UserSupport.resources[n];
        //     resourcesHtml.push(<ImageLink key={n} item={item} />);
        // }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "page-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "content",
            className: "content row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "content-main col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "content-main-inner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $508248f6f0651524$export$2e2bcd8739ae039), {
            name: "How to use Corgi"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("main", {
            id: "main_container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h1", null, "How to use Corgi"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, "Google slide decks can present accessibility barriers. To reduce barriers Corgi has provided a matching Google doc as an alternative option for viewing."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "section section-border-top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            id: "video"
        }, "Corgi shorts"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row row-cols-1 row-cols-md-2 row-cols-lg-3"
        }, shortsHtml)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "section section-border-top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            id: "video"
        }, "How to series"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row row-cols-1 row-cols-md-2 row-cols-lg-3"
        }, howtoHtml)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "section section-border-top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            id: "pl"
        }, "Corgi professional learning series"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row row-cols-1 row-cols-md-2 row-cols-lg-3"
        }, plHtml)))))));
    }
}



var $6wXVr = parcelRequire("6wXVr");



class $b75f94629b84f075$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    //constructor(props) {
    //    super(props);
    //}
    render() {
        if (this.context.newFileId) {
            var newUrl = "/" + this.props.docType + "/" + this.context.newFileId;
            console.log("Redirecting to new file: " + newUrl);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$2d8d895a0a0f636e), {
                to: newUrl
            });
        }
        if (this.props.copyPending && this.props.copyDone) {
            let newUrl = "/" + this.props.docType + "/" + this.props.copyPending;
            console.log("Redirecting to copied file: " + newUrl);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$2d8d895a0a0f636e), {
                to: newUrl
            });
        }
        let message = "Creating new document...";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("main", {
            id: "main_container",
            className: "container-fluid"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col text-center mt-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h1", {
            className: "h4 text-body mb-2"
        }, message)))));
    }
}
$b75f94629b84f075$export$2e2bcd8739ae039.propTypes = {
    docType: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired
};



var $6wXVr = parcelRequire("6wXVr");


class $f1c014113ae1c484$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        props.copyDocMethod();
    }
    render() {
        if (this.context.newFileId) {
            let url = "/" + this.context.fileType + "/" + this.context.newFileId;
            console.log("New file is ready, redirecting to ", url);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$2d8d895a0a0f636e), {
                to: url
            });
        }
        let message = "Copying document...";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("main", {
            id: "main_container",
            className: "container-fluid"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col text-center mt-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h1", {
            className: "h4 text-body mb-2"
        }, message)))));
    }
}



var $6wXVr = parcelRequire("6wXVr");



var $6wXVr = parcelRequire("6wXVr");
const $89f750eb5858fa5b$var$survey = "https://forms.gle/2nQVchy3Wpao3Rxv6";
class $89f750eb5858fa5b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    render() {
        return null;
    }
}



var $6wXVr = parcelRequire("6wXVr");


var $6wXVr = parcelRequire("6wXVr");
const $2ba741e120c3b9dd$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $2ba741e120c3b9dd$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $2ba741e120c3b9dd$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};


function $06c5405421478517$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


const $5765345ca758d050$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $5765345ca758d050$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $5765345ca758d050$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $5765345ca758d050$export$cbf60ecb96cbb82f = {
    date: (0, $06c5405421478517$export$38e44e97ce4dbb7d)({
        formats: $5765345ca758d050$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $06c5405421478517$export$38e44e97ce4dbb7d)({
        formats: $5765345ca758d050$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $06c5405421478517$export$38e44e97ce4dbb7d)({
        formats: $5765345ca758d050$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $450a2274fc36fa1b$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $450a2274fc36fa1b$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$450a2274fc36fa1b$var$formatRelativeLocale[token];


/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $6abd96d6a6e1b146$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


const $fe139f8517b78979$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $fe139f8517b78979$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $fe139f8517b78979$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $fe139f8517b78979$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $fe139f8517b78979$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $fe139f8517b78979$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $fe139f8517b78979$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $fe139f8517b78979$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $fe139f8517b78979$var$ordinalNumber,
    era: (0, $6abd96d6a6e1b146$export$63596d6ee8878b25)({
        values: $fe139f8517b78979$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $6abd96d6a6e1b146$export$63596d6ee8878b25)({
        values: $fe139f8517b78979$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $6abd96d6a6e1b146$export$63596d6ee8878b25)({
        values: $fe139f8517b78979$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $6abd96d6a6e1b146$export$63596d6ee8878b25)({
        values: $fe139f8517b78979$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $6abd96d6a6e1b146$export$63596d6ee8878b25)({
        values: $fe139f8517b78979$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $fe139f8517b78979$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


function $b86f91431484e43a$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $b86f91431484e43a$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $b86f91431484e43a$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $b86f91431484e43a$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $b86f91431484e43a$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $820df7e0af6ce5cc$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


const $c1b78f7d2b61e85e$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $c1b78f7d2b61e85e$var$parseOrdinalNumberPattern = /\d+/i;
const $c1b78f7d2b61e85e$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $c1b78f7d2b61e85e$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $c1b78f7d2b61e85e$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $c1b78f7d2b61e85e$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $c1b78f7d2b61e85e$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $c1b78f7d2b61e85e$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $c1b78f7d2b61e85e$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $c1b78f7d2b61e85e$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $c1b78f7d2b61e85e$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $c1b78f7d2b61e85e$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $c1b78f7d2b61e85e$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $820df7e0af6ce5cc$export$fdaf2fd6d7edde95)({
        matchPattern: $c1b78f7d2b61e85e$var$matchOrdinalNumberPattern,
        parsePattern: $c1b78f7d2b61e85e$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $b86f91431484e43a$export$1430a0f35710914d)({
        matchPatterns: $c1b78f7d2b61e85e$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c1b78f7d2b61e85e$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $b86f91431484e43a$export$1430a0f35710914d)({
        matchPatterns: $c1b78f7d2b61e85e$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c1b78f7d2b61e85e$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $b86f91431484e43a$export$1430a0f35710914d)({
        matchPatterns: $c1b78f7d2b61e85e$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c1b78f7d2b61e85e$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $b86f91431484e43a$export$1430a0f35710914d)({
        matchPatterns: $c1b78f7d2b61e85e$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c1b78f7d2b61e85e$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $b86f91431484e43a$export$1430a0f35710914d)({
        matchPatterns: $c1b78f7d2b61e85e$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $c1b78f7d2b61e85e$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $408358fcfe846371$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $2ba741e120c3b9dd$export$2c14ff85d6318973),
    formatLong: (0, $5765345ca758d050$export$cbf60ecb96cbb82f),
    formatRelative: (0, $450a2274fc36fa1b$export$8fbbfd65594f46a0),
    localize: (0, $fe139f8517b78979$export$b3bd0bc58e36cd63),
    match: (0, $c1b78f7d2b61e85e$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$408358fcfe846371$export$2e2bcd8739ae039 = $408358fcfe846371$export$137380d9ce54f7f;


let $8b4f0cac13ec5e83$var$defaultOptions = {};
function $8b4f0cac13ec5e83$export$430a3269e24b912e() {
    return $8b4f0cac13ec5e83$var$defaultOptions;
}
function $8b4f0cac13ec5e83$export$95365be1b0704abc(newOptions) {
    $8b4f0cac13ec5e83$var$defaultOptions = newOptions;
}


/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $9de04c5ea6f5cdac$export$dfd9b671c89acc8e = 7;
const $9de04c5ea6f5cdac$export$3913210603d8e9ae = 365.2425;
const $9de04c5ea6f5cdac$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $9de04c5ea6f5cdac$export$4dec998e48f9c246 = -$9de04c5ea6f5cdac$export$81caae6e1cc7a622;
const $9de04c5ea6f5cdac$export$4fad13613e88edc8 = 604800000;
const $9de04c5ea6f5cdac$export$b76b1809a2898f9a = 86400000;
const $9de04c5ea6f5cdac$export$91246f0b9bd9beff = 60000;
const $9de04c5ea6f5cdac$export$7f72910d6dfd237a = 3600000;
const $9de04c5ea6f5cdac$export$397c2d5776aa9055 = 1000;
const $9de04c5ea6f5cdac$export$3633035e63cee86a = 525600;
const $9de04c5ea6f5cdac$export$ab7da2ccd1075c38 = 43200;
const $9de04c5ea6f5cdac$export$2423174df8cd3cd2 = 1440;
const $9de04c5ea6f5cdac$export$f2f5ae5a8e2d8f9f = 60;
const $9de04c5ea6f5cdac$export$3c58128db900d44e = 3;
const $9de04c5ea6f5cdac$export$80d7e435f744f319 = 12;
const $9de04c5ea6f5cdac$export$4db7641526e3241f = 4;
const $9de04c5ea6f5cdac$export$698aec755e92c695 = 3600;
const $9de04c5ea6f5cdac$export$a77c1a7ebebe2a5a = 60;
const $9de04c5ea6f5cdac$export$815a9362476d2fe3 = $9de04c5ea6f5cdac$export$698aec755e92c695 * 24;
const $9de04c5ea6f5cdac$export$34804a017b31e2fe = $9de04c5ea6f5cdac$export$815a9362476d2fe3 * 7;
const $9de04c5ea6f5cdac$export$7271e9e3478110d1 = $9de04c5ea6f5cdac$export$815a9362476d2fe3 * $9de04c5ea6f5cdac$export$3913210603d8e9ae;
const $9de04c5ea6f5cdac$export$8e6600bbdee7dabb = $9de04c5ea6f5cdac$export$7271e9e3478110d1 / 12;
const $9de04c5ea6f5cdac$export$be1dccf2de902d31 = $9de04c5ea6f5cdac$export$8e6600bbdee7dabb * 3;
const $9de04c5ea6f5cdac$export$2a7b97929c48d47d = Symbol.for("constructDateFrom");


function $fb871a4fb4a4b210$export$ead8a1812b171991(date, value) {
    if (typeof date === "function") return date(value);
    if (date && typeof date === "object" && (0, $9de04c5ea6f5cdac$export$2a7b97929c48d47d) in date) return date[0, $9de04c5ea6f5cdac$export$2a7b97929c48d47d](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
var // Fallback for modularized imports:
$fb871a4fb4a4b210$export$2e2bcd8739ae039 = $fb871a4fb4a4b210$export$ead8a1812b171991;


function $334f6e435d87df08$export$9f53b88e82f64d8d(context, ...dates) {
    const normalize = (0, $fb871a4fb4a4b210$export$ead8a1812b171991).bind(null, context || dates.find((date)=>typeof date === "object"));
    return dates.map(normalize);
}



function $15df6500c83ad252$export$e67a095c620b86fe(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, $fb871a4fb4a4b210$export$ead8a1812b171991)(context || argument, argument);
}
var // Fallback for modularized imports:
$15df6500c83ad252$export$2e2bcd8739ae039 = $15df6500c83ad252$export$e67a095c620b86fe;


function $5a2e006a994236d3$export$113002b5eff6e430(date) {
    const _date = (0, $15df6500c83ad252$export$e67a095c620b86fe)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}





function $3210c0687bf841a3$export$63fa379ae8a9ba2(date, options) {
    const _date = (0, $15df6500c83ad252$export$e67a095c620b86fe)(date, options?.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$3210c0687bf841a3$export$2e2bcd8739ae039 = $3210c0687bf841a3$export$63fa379ae8a9ba2;


function $312f4a140ae7cdf9$export$4a02e9c37dab4871(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $334f6e435d87df08$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const laterStartOfDay = (0, $3210c0687bf841a3$export$63fa379ae8a9ba2)(laterDate_);
    const earlierStartOfDay = (0, $3210c0687bf841a3$export$63fa379ae8a9ba2)(earlierDate_);
    const laterTimestamp = +laterStartOfDay - (0, $5a2e006a994236d3$export$113002b5eff6e430)(laterStartOfDay);
    const earlierTimestamp = +earlierStartOfDay - (0, $5a2e006a994236d3$export$113002b5eff6e430)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, $9de04c5ea6f5cdac$export$b76b1809a2898f9a));
}
var // Fallback for modularized imports:
$312f4a140ae7cdf9$export$2e2bcd8739ae039 = $312f4a140ae7cdf9$export$4a02e9c37dab4871;






function $c14c754360ab5ed4$export$f91e89d3d0406102(date, options) {
    const date_ = (0, $15df6500c83ad252$export$e67a095c620b86fe)(date, options?.in);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
var // Fallback for modularized imports:
$c14c754360ab5ed4$export$2e2bcd8739ae039 = $c14c754360ab5ed4$export$f91e89d3d0406102;



function $43ea1e259dbd49d4$export$d3b42cd8452deec(date, options) {
    const _date = (0, $15df6500c83ad252$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $312f4a140ae7cdf9$export$4a02e9c37dab4871)(_date, (0, $c14c754360ab5ed4$export$f91e89d3d0406102)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$43ea1e259dbd49d4$export$2e2bcd8739ae039 = $43ea1e259dbd49d4$export$d3b42cd8452deec;





function $868e8182777e11e1$export$42c81a444fbfb5d4(date, options) {
    const defaultOptions = (0, $8b4f0cac13ec5e83$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $15df6500c83ad252$export$e67a095c620b86fe)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$868e8182777e11e1$export$2e2bcd8739ae039 = $868e8182777e11e1$export$42c81a444fbfb5d4;


function $e075b9be8fdea1c2$export$6173213f95a4431e(date, options) {
    return (0, $868e8182777e11e1$export$42c81a444fbfb5d4)(date, {
        ...options,
        weekStartsOn: 1
    });
}
var // Fallback for modularized imports:
$e075b9be8fdea1c2$export$2e2bcd8739ae039 = $e075b9be8fdea1c2$export$6173213f95a4431e;






function $defae4072e9814b0$export$3dbc52535f6f8fcc(date, options) {
    const _date = (0, $15df6500c83ad252$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $fb871a4fb4a4b210$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $e075b9be8fdea1c2$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $fb871a4fb4a4b210$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $e075b9be8fdea1c2$export$6173213f95a4431e)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$defae4072e9814b0$export$2e2bcd8739ae039 = $defae4072e9814b0$export$3dbc52535f6f8fcc;



function $faa7074cde427e18$export$236bdfa374eb69a9(date, options) {
    const year = (0, $defae4072e9814b0$export$3dbc52535f6f8fcc)(date, options);
    const fourthOfJanuary = (0, $fb871a4fb4a4b210$export$ead8a1812b171991)(options?.in || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $e075b9be8fdea1c2$export$6173213f95a4431e)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$faa7074cde427e18$export$2e2bcd8739ae039 = $faa7074cde427e18$export$236bdfa374eb69a9;



function $7f2f4c23b7f95276$export$7cabdc5698b63e2f(date, options) {
    const _date = (0, $15df6500c83ad252$export$e67a095c620b86fe)(date, options?.in);
    const diff = +(0, $e075b9be8fdea1c2$export$6173213f95a4431e)(_date) - +(0, $faa7074cde427e18$export$236bdfa374eb69a9)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $9de04c5ea6f5cdac$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$7f2f4c23b7f95276$export$2e2bcd8739ae039 = $7f2f4c23b7f95276$export$7cabdc5698b63e2f;











function $bdf4a8cc5505dfd8$export$12d572480ceb6e58(date, options) {
    const _date = (0, $15df6500c83ad252$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const defaultOptions = (0, $8b4f0cac13ec5e83$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $fb871a4fb4a4b210$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $868e8182777e11e1$export$42c81a444fbfb5d4)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $fb871a4fb4a4b210$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $868e8182777e11e1$export$42c81a444fbfb5d4)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$bdf4a8cc5505dfd8$export$2e2bcd8739ae039 = $bdf4a8cc5505dfd8$export$12d572480ceb6e58;



function $de3f19e356cd8ce7$export$bb7b45bb8e74da0f(date, options) {
    const defaultOptions = (0, $8b4f0cac13ec5e83$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $bdf4a8cc5505dfd8$export$12d572480ceb6e58)(date, options);
    const firstWeek = (0, $fb871a4fb4a4b210$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $868e8182777e11e1$export$42c81a444fbfb5d4)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$de3f19e356cd8ce7$export$2e2bcd8739ae039 = $de3f19e356cd8ce7$export$bb7b45bb8e74da0f;



function $66f8b87cdd458f61$export$efe19b760242b2fc(date, options) {
    const _date = (0, $15df6500c83ad252$export$e67a095c620b86fe)(date, options?.in);
    const diff = +(0, $868e8182777e11e1$export$42c81a444fbfb5d4)(_date, options) - +(0, $de3f19e356cd8ce7$export$bb7b45bb8e74da0f)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $9de04c5ea6f5cdac$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$66f8b87cdd458f61$export$2e2bcd8739ae039 = $66f8b87cdd458f61$export$efe19b760242b2fc;



function $b716e21c13ba1bd7$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}



const $edfb9add8304c281$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $b716e21c13ba1bd7$export$c8306e720e213c0f)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $b716e21c13ba1bd7$export$c8306e720e213c0f)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $b716e21c13ba1bd7$export$c8306e720e213c0f)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $b716e21c13ba1bd7$export$c8306e720e213c0f)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $b716e21c13ba1bd7$export$c8306e720e213c0f)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $b716e21c13ba1bd7$export$c8306e720e213c0f)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $b716e21c13ba1bd7$export$c8306e720e213c0f)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $b716e21c13ba1bd7$export$c8306e720e213c0f)(fractionalSeconds, token.length);
    }
};


const $a136943f2aa06c95$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const $a136943f2aa06c95$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $edfb9add8304c281$export$b0d4b338e1516f13).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $bdf4a8cc5505dfd8$export$12d572480ceb6e58)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $b716e21c13ba1bd7$export$c8306e720e213c0f)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $b716e21c13ba1bd7$export$c8306e720e213c0f)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $defae4072e9814b0$export$3dbc52535f6f8fcc)(date);
        // Padding
        return (0, $b716e21c13ba1bd7$export$c8306e720e213c0f)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $b716e21c13ba1bd7$export$c8306e720e213c0f)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $b716e21c13ba1bd7$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $b716e21c13ba1bd7$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $edfb9add8304c281$export$b0d4b338e1516f13).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $b716e21c13ba1bd7$export$c8306e720e213c0f)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $66f8b87cdd458f61$export$efe19b760242b2fc)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $b716e21c13ba1bd7$export$c8306e720e213c0f)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $7f2f4c23b7f95276$export$7cabdc5698b63e2f)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $b716e21c13ba1bd7$export$c8306e720e213c0f)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $edfb9add8304c281$export$b0d4b338e1516f13).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $43ea1e259dbd49d4$export$d3b42cd8452deec)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $b716e21c13ba1bd7$export$c8306e720e213c0f)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $b716e21c13ba1bd7$export$c8306e720e213c0f)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $b716e21c13ba1bd7$export$c8306e720e213c0f)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $b716e21c13ba1bd7$export$c8306e720e213c0f)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $a136943f2aa06c95$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $a136943f2aa06c95$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $a136943f2aa06c95$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $a136943f2aa06c95$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $a136943f2aa06c95$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $a136943f2aa06c95$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $edfb9add8304c281$export$b0d4b338e1516f13).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $edfb9add8304c281$export$b0d4b338e1516f13).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $b716e21c13ba1bd7$export$c8306e720e213c0f)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $b716e21c13ba1bd7$export$c8306e720e213c0f)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $edfb9add8304c281$export$b0d4b338e1516f13).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $edfb9add8304c281$export$b0d4b338e1516f13).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $edfb9add8304c281$export$b0d4b338e1516f13).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $a136943f2aa06c95$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $a136943f2aa06c95$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $a136943f2aa06c95$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $a136943f2aa06c95$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $a136943f2aa06c95$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $a136943f2aa06c95$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $a136943f2aa06c95$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $a136943f2aa06c95$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $a136943f2aa06c95$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $a136943f2aa06c95$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(+date / 1000);
        return (0, $b716e21c13ba1bd7$export$c8306e720e213c0f)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        return (0, $b716e21c13ba1bd7$export$c8306e720e213c0f)(+date, token.length);
    }
};
function $a136943f2aa06c95$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $b716e21c13ba1bd7$export$c8306e720e213c0f)(minutes, 2);
}
function $a136943f2aa06c95$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $b716e21c13ba1bd7$export$c8306e720e213c0f)(Math.abs(offset) / 60, 2);
    }
    return $a136943f2aa06c95$var$formatTimezone(offset, delimiter);
}
function $a136943f2aa06c95$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $b716e21c13ba1bd7$export$c8306e720e213c0f)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $b716e21c13ba1bd7$export$c8306e720e213c0f)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}


const $b4d819b58fa10348$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $b4d819b58fa10348$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $b4d819b58fa10348$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $b4d819b58fa10348$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $b4d819b58fa10348$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $b4d819b58fa10348$var$timeLongFormatter(timePattern, formatLong));
};
const $b4d819b58fa10348$export$70cc8fd02856fd58 = {
    p: $b4d819b58fa10348$var$timeLongFormatter,
    P: $b4d819b58fa10348$var$dateTimeLongFormatter
};


const $261154dc94e203e4$var$dayOfYearTokenRE = /^D+$/;
const $261154dc94e203e4$var$weekYearTokenRE = /^Y+$/;
const $261154dc94e203e4$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $261154dc94e203e4$export$c6cc36aa33304772(token) {
    return $261154dc94e203e4$var$dayOfYearTokenRE.test(token);
}
function $261154dc94e203e4$export$c6b49d6dceb604a1(token) {
    return $261154dc94e203e4$var$weekYearTokenRE.test(token);
}
function $261154dc94e203e4$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $261154dc94e203e4$var$message(token, format, input);
    console.warn(_message);
    if ($261154dc94e203e4$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $261154dc94e203e4$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $36326953478de942$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$36326953478de942$export$2e2bcd8739ae039 = $36326953478de942$export$871608497c498473;



function $8c64acb37c060c90$export$1ea939691cdc45b8(date) {
    return !(!(0, $36326953478de942$export$871608497c498473)(date) && typeof date !== "number" || isNaN(+(0, $15df6500c83ad252$export$e67a095c620b86fe)(date)));
}
var // Fallback for modularized imports:
$8c64acb37c060c90$export$2e2bcd8739ae039 = $8c64acb37c060c90$export$1ea939691cdc45b8;



// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $b19ddff91dc25d3e$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $b19ddff91dc25d3e$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $b19ddff91dc25d3e$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $b19ddff91dc25d3e$var$doubleQuoteRegExp = /''/g;
const $b19ddff91dc25d3e$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $b19ddff91dc25d3e$export$d9468344d3651243(date, formatStr, options) {
    const defaultOptions = (0, $8b4f0cac13ec5e83$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $408358fcfe846371$export$137380d9ce54f7f);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $15df6500c83ad252$export$e67a095c620b86fe)(date, options?.in);
    if (!(0, $8c64acb37c060c90$export$1ea939691cdc45b8)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($b19ddff91dc25d3e$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, $b4d819b58fa10348$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($b19ddff91dc25d3e$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $b19ddff91dc25d3e$var$cleanEscapedString(substring)
        };
        if ((0, $a136943f2aa06c95$export$fe98a034cfb96d55)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($b19ddff91dc25d3e$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $261154dc94e203e4$export$c6b49d6dceb604a1)(token) || !options?.useAdditionalDayOfYearTokens && (0, $261154dc94e203e4$export$c6cc36aa33304772)(token)) (0, $261154dc94e203e4$export$f5f38f90ecaaf879)(token, formatStr, String(date));
        const formatter = (0, $a136943f2aa06c95$export$fe98a034cfb96d55)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $b19ddff91dc25d3e$var$cleanEscapedString(input) {
    const matched = input.match($b19ddff91dc25d3e$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($b19ddff91dc25d3e$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$b19ddff91dc25d3e$export$2e2bcd8739ae039 = $b19ddff91dc25d3e$export$d9468344d3651243;


function $7f44af15c54aee83$export$8fbbfd65594f46a0(date, baseDate, options) {
    const [date_, baseDate_] = (0, $334f6e435d87df08$export$9f53b88e82f64d8d)(options?.in, date, baseDate);
    const defaultOptions = (0, $8b4f0cac13ec5e83$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $408358fcfe846371$export$137380d9ce54f7f);
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const diff = (0, $312f4a140ae7cdf9$export$4a02e9c37dab4871)(date_, baseDate_);
    if (isNaN(diff)) throw new RangeError("Invalid time value");
    let token;
    if (diff < -6) token = "other";
    else if (diff < -1) token = "lastWeek";
    else if (diff < 0) token = "yesterday";
    else if (diff < 1) token = "today";
    else if (diff < 2) token = "tomorrow";
    else if (diff < 7) token = "nextWeek";
    else token = "other";
    const formatStr = locale.formatRelative(token, date_, baseDate_, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    return (0, $b19ddff91dc25d3e$export$d9468344d3651243)(date_, formatStr, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
}
var // Fallback for modularized imports:
$7f44af15c54aee83$export$2e2bcd8739ae039 = $7f44af15c54aee83$export$8fbbfd65594f46a0;

var $400372a6d3069f68$exports = {};
$parcel$export($400372a6d3069f68$exports, "formatters", function () { return $a136943f2aa06c95$export$fe98a034cfb96d55; });
$parcel$export($400372a6d3069f68$exports, "longFormatters", function () { return $b4d819b58fa10348$export$70cc8fd02856fd58; });
$parcel$export($400372a6d3069f68$exports, "formatRelative", function () { return $7f44af15c54aee83$export$8fbbfd65594f46a0; });
$parcel$export($400372a6d3069f68$exports, "longFormatters", function () { return $b4d819b58fa10348$export$70cc8fd02856fd58; });
$parcel$export($400372a6d3069f68$exports, "parseISO", function () { return $1e6c68bbe2e44be7$export$4393d2ccbbedb219; });
// This file is generated automatically by `scripts/build/indices.ts`. Please, don't change it.






















































































































































































function $e9fb2e83f460512a$export$430a3269e24b912e() {
    return Object.assign({}, (0, $8b4f0cac13ec5e83$export$430a3269e24b912e)());
}
var // Fallback for modularized imports:
$e9fb2e83f460512a$export$2e2bcd8739ae039 = $e9fb2e83f460512a$export$430a3269e24b912e;





function $3e677244fd044b9d$export$9cb09a71b7d66923(date, constructor) {
    const date_ = $3e677244fd044b9d$var$isConstructor(constructor) ? new constructor(0) : (0, $fb871a4fb4a4b210$export$ead8a1812b171991)(constructor, 0);
    date_.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    date_.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    return date_;
}
function $3e677244fd044b9d$var$isConstructor(constructor) {
    return typeof constructor === "function" && constructor.prototype?.constructor === constructor;
}
var // Fallback for modularized imports:
$3e677244fd044b9d$export$2e2bcd8739ae039 = $3e677244fd044b9d$export$9cb09a71b7d66923;


const $b3b6eb4d636a248a$var$TIMEZONE_UNIT_PRIORITY = 10;
class $b3b6eb4d636a248a$export$81d53e3678089a6 {
    subPriority = 0;
    validate(_utcDate, _options) {
        return true;
    }
}
class $b3b6eb4d636a248a$export$9a09e32dd4990fd5 extends $b3b6eb4d636a248a$export$81d53e3678089a6 {
    constructor(value, validateValue, setValue, priority, subPriority){
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;
        if (subPriority) this.subPriority = subPriority;
    }
    validate(date, options) {
        return this.validateValue(date, this.value, options);
    }
    set(date, flags, options) {
        return this.setValue(date, flags, this.value, options);
    }
}
class $b3b6eb4d636a248a$export$8be15fe85ad72f86 extends $b3b6eb4d636a248a$export$81d53e3678089a6 {
    priority = $b3b6eb4d636a248a$var$TIMEZONE_UNIT_PRIORITY;
    subPriority = -1;
    constructor(context, reference){
        super();
        this.context = context || ((date)=>(0, $fb871a4fb4a4b210$export$ead8a1812b171991)(reference, date));
    }
    set(date, flags) {
        if (flags.timestampIsSet) return date;
        return (0, $fb871a4fb4a4b210$export$ead8a1812b171991)(date, (0, $3e677244fd044b9d$export$9cb09a71b7d66923)(date, this.context));
    }
}



class $73c1a8a5b88d22ad$export$7acfa6ed01010e37 {
    run(dateString, token, match, options) {
        const result = this.parse(dateString, token, match, options);
        if (!result) return null;
        return {
            setter: new (0, $b3b6eb4d636a248a$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
        };
    }
    validate(_utcDate, _value, _options) {
        return true;
    }
}


class $8d0a188e614bc59f$export$8e5a1d3f85a9688 extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    priority = 140;
    parse(dateString, token, match) {
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
            // A, B
            case "GGGGG":
                return match.era(dateString, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return match.era(dateString, {
                    width: "wide"
                }) || match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
        }
    }
    set(date, flags, value) {
        flags.era = value;
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "R",
        "u",
        "t",
        "T"
    ];
}




const $d2ae5bee1a6d44fa$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
const $d2ae5bee1a6d44fa$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $0586aff3b490a147$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $0586aff3b490a147$export$cc7cc9e2a3ff9388(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $0586aff3b490a147$export$6497f4c0ecdfba8e(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    const sign = matchResult[1] === "+" ? 1 : -1;
    const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $9de04c5ea6f5cdac$export$7f72910d6dfd237a) + minutes * (0, $9de04c5ea6f5cdac$export$91246f0b9bd9beff) + seconds * (0, $9de04c5ea6f5cdac$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $0586aff3b490a147$export$d931c43c4608a164(dateString) {
    return $0586aff3b490a147$export$cc7cc9e2a3ff9388((0, $d2ae5bee1a6d44fa$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $0586aff3b490a147$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $0586aff3b490a147$export$cc7cc9e2a3ff9388((0, $d2ae5bee1a6d44fa$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $0586aff3b490a147$export$cc7cc9e2a3ff9388((0, $d2ae5bee1a6d44fa$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $0586aff3b490a147$export$cc7cc9e2a3ff9388((0, $d2ae5bee1a6d44fa$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $0586aff3b490a147$export$cc7cc9e2a3ff9388((0, $d2ae5bee1a6d44fa$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $0586aff3b490a147$export$cc7cc9e2a3ff9388(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $0586aff3b490a147$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $0586aff3b490a147$export$cc7cc9e2a3ff9388((0, $d2ae5bee1a6d44fa$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $0586aff3b490a147$export$cc7cc9e2a3ff9388((0, $d2ae5bee1a6d44fa$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $0586aff3b490a147$export$cc7cc9e2a3ff9388((0, $d2ae5bee1a6d44fa$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $0586aff3b490a147$export$cc7cc9e2a3ff9388((0, $d2ae5bee1a6d44fa$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $0586aff3b490a147$export$cc7cc9e2a3ff9388(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $0586aff3b490a147$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $0586aff3b490a147$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    const isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    let result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        const rangeEnd = absCurrentYear + 50;
        const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $0586aff3b490a147$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


class $b24806326e91ca65$export$48d352de7cd4a988 extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    priority = 130;
    incompatibleTokens = [
        "Y",
        "R",
        "u",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "yy"
            });
        switch(token){
            case "y":
                return (0, $0586aff3b490a147$export$4f84e3a82c7b538)((0, $0586aff3b490a147$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "yo":
                return (0, $0586aff3b490a147$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $0586aff3b490a147$export$4f84e3a82c7b538)((0, $0586aff3b490a147$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value) {
        const currentYear = date.getFullYear();
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $0586aff3b490a147$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}






class $85b993e165e96c1a$export$b8ef38dfcf05d5db extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "YY"
            });
        switch(token){
            case "Y":
                return (0, $0586aff3b490a147$export$4f84e3a82c7b538)((0, $0586aff3b490a147$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "Yo":
                return (0, $0586aff3b490a147$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $0586aff3b490a147$export$4f84e3a82c7b538)((0, $0586aff3b490a147$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value, options) {
        const currentYear = (0, $bdf4a8cc5505dfd8$export$12d572480ceb6e58)(date, options);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $0586aff3b490a147$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setHours(0, 0, 0, 0);
            return (0, $868e8182777e11e1$export$42c81a444fbfb5d4)(date, options);
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, options.firstWeekContainsDate);
        date.setHours(0, 0, 0, 0);
        return (0, $868e8182777e11e1$export$42c81a444fbfb5d4)(date, options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}






class $161d4d257b73f385$export$951d1df011fde06f extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token) {
        if (token === "R") return (0, $0586aff3b490a147$export$2c9307b2e29c533c)(4, dateString);
        return (0, $0586aff3b490a147$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        const firstWeekOfYear = (0, $fb871a4fb4a4b210$export$ead8a1812b171991)(date, 0);
        firstWeekOfYear.setFullYear(value, 0, 4);
        firstWeekOfYear.setHours(0, 0, 0, 0);
        return (0, $e075b9be8fdea1c2$export$6173213f95a4431e)(firstWeekOfYear);
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $a5b7c6e040f81990$export$bad9d2ea38e8f1a extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token) {
        if (token === "u") return (0, $0586aff3b490a147$export$2c9307b2e29c533c)(4, dateString);
        return (0, $0586aff3b490a147$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "R",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $848c763725012987$export$5cb0f701186dde1d extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
                return (0, $0586aff3b490a147$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $56d8e746e3a70306$export$300c0c2990e20e6d extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "q":
            case "qq":
                return (0, $0586aff3b490a147$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $bbc8699c0ace4602$export$400dd8b40ef138a3 extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "L",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "M":
                return (0, $0586aff3b490a147$export$4f84e3a82c7b538)((0, $0586aff3b490a147$export$cc7cc9e2a3ff9388)((0, $d2ae5bee1a6d44fa$export$c123ee06d9da8480).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "MM":
                return (0, $0586aff3b490a147$export$4f84e3a82c7b538)((0, $0586aff3b490a147$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return (0, $0586aff3b490a147$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "MMM":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}





class $9d6f10d134bfc2c6$export$1d7eaa53eaa5deba extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return (0, $0586aff3b490a147$export$4f84e3a82c7b538)((0, $0586aff3b490a147$export$cc7cc9e2a3ff9388)((0, $d2ae5bee1a6d44fa$export$c123ee06d9da8480).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "LL":
                return (0, $0586aff3b490a147$export$4f84e3a82c7b538)((0, $0586aff3b490a147$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return (0, $0586aff3b490a147$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "LLL":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}




function $4a1eebf97fb2c11a$export$4b3066ce4afafd88(date, week, options) {
    const date_ = (0, $15df6500c83ad252$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $66f8b87cdd458f61$export$efe19b760242b2fc)(date_, options) - week;
    date_.setDate(date_.getDate() - diff * 7);
    return (0, $15df6500c83ad252$export$e67a095c620b86fe)(date_, options?.in);
}
var // Fallback for modularized imports:
$4a1eebf97fb2c11a$export$2e2bcd8739ae039 = $4a1eebf97fb2c11a$export$4b3066ce4afafd88;






class $6ea6f9f9edb17d96$export$c4005ffc174e07c0 extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "w":
                return (0, $0586aff3b490a147$export$cc7cc9e2a3ff9388)((0, $d2ae5bee1a6d44fa$export$c123ee06d9da8480).week, dateString);
            case "wo":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $0586aff3b490a147$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value, options) {
        return (0, $868e8182777e11e1$export$42c81a444fbfb5d4)((0, $4a1eebf97fb2c11a$export$4b3066ce4afafd88)(date, value, options), options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}




function $44f236620ecb16be$export$6542bebf6be94082(date, week, options) {
    const _date = (0, $15df6500c83ad252$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $7f2f4c23b7f95276$export$7cabdc5698b63e2f)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}
var // Fallback for modularized imports:
$44f236620ecb16be$export$2e2bcd8739ae039 = $44f236620ecb16be$export$6542bebf6be94082;






class $73c2c3553e2d10ea$export$6fc8dbedd560a6af extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "I":
                return (0, $0586aff3b490a147$export$cc7cc9e2a3ff9388)((0, $d2ae5bee1a6d44fa$export$c123ee06d9da8480).week, dateString);
            case "Io":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $0586aff3b490a147$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value) {
        return (0, $e075b9be8fdea1c2$export$6173213f95a4431e)((0, $44f236620ecb16be$export$6542bebf6be94082)(date, value));
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}





const $a4172a8678fa0644$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $a4172a8678fa0644$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
class $a4172a8678fa0644$export$e8d4b28a20981dd2 extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    priority = 90;
    subPriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "d":
                return (0, $0586aff3b490a147$export$cc7cc9e2a3ff9388)((0, $d2ae5bee1a6d44fa$export$c123ee06d9da8480).date, dateString);
            case "do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $0586aff3b490a147$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $0586aff3b490a147$export$3d50627710b84d75)(year);
        const month = date.getMonth();
        if (isLeapYear) return value >= 1 && value <= $a4172a8678fa0644$var$DAYS_IN_MONTH_LEAP_YEAR[month];
        else return value >= 1 && value <= $a4172a8678fa0644$var$DAYS_IN_MONTH[month];
    }
    set(date, _flags, value) {
        date.setDate(value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $d56aa2839458db93$export$6cfe0d613455f615 extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    priority = 90;
    subpriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "D":
            case "DD":
                return (0, $0586aff3b490a147$export$cc7cc9e2a3ff9388)((0, $d2ae5bee1a6d44fa$export$c123ee06d9da8480).dayOfYear, dateString);
            case "Do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $0586aff3b490a147$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $0586aff3b490a147$export$3d50627710b84d75)(year);
        if (isLeapYear) return value >= 1 && value <= 366;
        else return value >= 1 && value <= 365;
    }
    set(date, _flags, value) {
        date.setMonth(0, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "E",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





function $24c0d1c4634d4a5d$export$dd412b56f1e4d8aa(date, amount, options) {
    const _date = (0, $15df6500c83ad252$export$e67a095c620b86fe)(date, options?.in);
    if (isNaN(amount)) return (0, $fb871a4fb4a4b210$export$ead8a1812b171991)(options?.in || date, NaN);
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    if (!amount) return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}
var // Fallback for modularized imports:
$24c0d1c4634d4a5d$export$2e2bcd8739ae039 = $24c0d1c4634d4a5d$export$dd412b56f1e4d8aa;



function $2bd59487d24e9045$export$b04fdcda82decc6c(date, day, options) {
    const defaultOptions = (0, $8b4f0cac13ec5e83$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const date_ = (0, $15df6500c83ad252$export$e67a095c620b86fe)(date, options?.in);
    const currentDay = date_.getDay();
    const remainder = day % 7;
    const dayIndex = (remainder + 7) % 7;
    const delta = 7 - weekStartsOn;
    const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $24c0d1c4634d4a5d$export$dd412b56f1e4d8aa)(date_, diff, options);
}
var // Fallback for modularized imports:
$2bd59487d24e9045$export$2e2bcd8739ae039 = $2bd59487d24e9045$export$b04fdcda82decc6c;



class $6ffd990d848cceed$export$1b03c8b76262f7bd extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match) {
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $2bd59487d24e9045$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $a51f40d4d0c6cced$export$44d1c127ab42c480 extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "e":
            case "ee":
                return (0, $0586aff3b490a147$export$4f84e3a82c7b538)((0, $0586aff3b490a147$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "eo":
                return (0, $0586aff3b490a147$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "eee":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $2bd59487d24e9045$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "c",
        "t",
        "T"
    ];
}





class $a22546bbf73ebb30$export$e447a647caaaec1d extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "c":
            case "cc":
                return (0, $0586aff3b490a147$export$4f84e3a82c7b538)((0, $0586aff3b490a147$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "co":
                return (0, $0586aff3b490a147$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "ccc":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $2bd59487d24e9045$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "e",
        "t",
        "T"
    ];
}




function $a40e61a339ee3b87$export$c514f4c1a8ed5e9e(date, options) {
    const day = (0, $15df6500c83ad252$export$e67a095c620b86fe)(date, options?.in).getDay();
    return day === 0 ? 7 : day;
}
var // Fallback for modularized imports:
$a40e61a339ee3b87$export$2e2bcd8739ae039 = $a40e61a339ee3b87$export$c514f4c1a8ed5e9e;



function $476a2a0b9e018227$export$1fd9df65adb0d1aa(date, day, options) {
    const date_ = (0, $15df6500c83ad252$export$e67a095c620b86fe)(date, options?.in);
    const currentDay = (0, $a40e61a339ee3b87$export$c514f4c1a8ed5e9e)(date_, options);
    const diff = day - currentDay;
    return (0, $24c0d1c4634d4a5d$export$dd412b56f1e4d8aa)(date_, diff, options);
}
var // Fallback for modularized imports:
$476a2a0b9e018227$export$2e2bcd8739ae039 = $476a2a0b9e018227$export$1fd9df65adb0d1aa;




class $892a7ca3ab0d873f$export$693fb1e525095b2a extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match) {
        const valueCallback = (value)=>{
            if (value === 0) return 7;
            return value;
        };
        switch(token){
            // 2
            case "i":
            case "ii":
                return (0, $0586aff3b490a147$export$513bb01536146ab6)(token.length, dateString);
            // 2nd
            case "io":
                return match.ordinalNumber(dateString, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return (0, $0586aff3b490a147$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // T
            case "iiiii":
                return (0, $0586aff3b490a147$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tu
            case "iiiiii":
                return (0, $0586aff3b490a147$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tuesday
            case "iiii":
            default:
                return (0, $0586aff3b490a147$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 7;
    }
    set(date, _flags, value) {
        date = (0, $476a2a0b9e018227$export$1fd9df65adb0d1aa)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "E",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $035e16996e108311$export$8d1e08492351df91 extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaaa":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $0586aff3b490a147$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "b",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}




class $903c2173ba2ccecc$export$73ca2bd0a17d273 extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbbb":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $0586aff3b490a147$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}




class $aca935ba2c6f1c47$export$bb9212adf05373db extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBBB":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $0586aff3b490a147$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "t",
        "T"
    ];
}





class $9e370a4d8efb7a79$export$8a04050a727a1756 extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "h":
                return (0, $0586aff3b490a147$export$cc7cc9e2a3ff9388)((0, $d2ae5bee1a6d44fa$export$c123ee06d9da8480).hour12h, dateString);
            case "ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $0586aff3b490a147$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 12;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "H",
        "K",
        "k",
        "t",
        "T"
    ];
}





class $1661ae966fb26c95$export$e56f4dea2c3e56dd extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "H":
                return (0, $0586aff3b490a147$export$cc7cc9e2a3ff9388)((0, $d2ae5bee1a6d44fa$export$c123ee06d9da8480).hour23h, dateString);
            case "Ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $0586aff3b490a147$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 23;
    }
    set(date, _flags, value) {
        date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "K",
        "k",
        "t",
        "T"
    ];
}





class $bde1e32422b5dac7$export$cbbe855312f87d77 extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "K":
                return (0, $0586aff3b490a147$export$cc7cc9e2a3ff9388)((0, $d2ae5bee1a6d44fa$export$c123ee06d9da8480).hour11h, dateString);
            case "Ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $0586aff3b490a147$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "h",
        "H",
        "k",
        "t",
        "T"
    ];
}





class $d9bf1bd38986f311$export$6008046d2b34b6a5 extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "k":
                return (0, $0586aff3b490a147$export$cc7cc9e2a3ff9388)((0, $d2ae5bee1a6d44fa$export$c123ee06d9da8480).hour24h, dateString);
            case "ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $0586aff3b490a147$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 24;
    }
    set(date, _flags, value) {
        const hours = value <= 24 ? value % 24 : value;
        date.setHours(hours, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "H",
        "K",
        "t",
        "T"
    ];
}





class $3bab4a0583bdf146$export$2b52670d9e2be53 extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    priority = 60;
    parse(dateString, token, match) {
        switch(token){
            case "m":
                return (0, $0586aff3b490a147$export$cc7cc9e2a3ff9388)((0, $d2ae5bee1a6d44fa$export$c123ee06d9da8480).minute, dateString);
            case "mo":
                return match.ordinalNumber(dateString, {
                    unit: "minute"
                });
            default:
                return (0, $0586aff3b490a147$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setMinutes(value, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}





class $20b97912d9aa6533$export$94d46d540cf1366a extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    priority = 50;
    parse(dateString, token, match) {
        switch(token){
            case "s":
                return (0, $0586aff3b490a147$export$cc7cc9e2a3ff9388)((0, $d2ae5bee1a6d44fa$export$c123ee06d9da8480).second, dateString);
            case "so":
                return match.ordinalNumber(dateString, {
                    unit: "second"
                });
            default:
                return (0, $0586aff3b490a147$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setSeconds(value, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}




class $4888cc1e32648915$export$b8e6f8b2d70893b1 extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    priority = 30;
    parse(dateString, token) {
        const valueCallback = (value)=>Math.trunc(value * Math.pow(10, -token.length + 3));
        return (0, $0586aff3b490a147$export$4f84e3a82c7b538)((0, $0586aff3b490a147$export$513bb01536146ab6)(token.length, dateString), valueCallback);
    }
    set(date, _flags, value) {
        date.setMilliseconds(value);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}







class $453e9a48bacc215b$export$104d901d49fea29b extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "X":
                return (0, $0586aff3b490a147$export$6497f4c0ecdfba8e)((0, $d2ae5bee1a6d44fa$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
            case "XX":
                return (0, $0586aff3b490a147$export$6497f4c0ecdfba8e)((0, $d2ae5bee1a6d44fa$export$a7ee192b982af9c1).basic, dateString);
            case "XXXX":
                return (0, $0586aff3b490a147$export$6497f4c0ecdfba8e)((0, $d2ae5bee1a6d44fa$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
            case "XXXXX":
                return (0, $0586aff3b490a147$export$6497f4c0ecdfba8e)((0, $d2ae5bee1a6d44fa$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
            case "XXX":
            default:
                return (0, $0586aff3b490a147$export$6497f4c0ecdfba8e)((0, $d2ae5bee1a6d44fa$export$a7ee192b982af9c1).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $fb871a4fb4a4b210$export$ead8a1812b171991)(date, date.getTime() - (0, $5a2e006a994236d3$export$113002b5eff6e430)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "x"
    ];
}







class $067b4bfd7923e12f$export$12910e5204b52b9 extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "x":
                return (0, $0586aff3b490a147$export$6497f4c0ecdfba8e)((0, $d2ae5bee1a6d44fa$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
            case "xx":
                return (0, $0586aff3b490a147$export$6497f4c0ecdfba8e)((0, $d2ae5bee1a6d44fa$export$a7ee192b982af9c1).basic, dateString);
            case "xxxx":
                return (0, $0586aff3b490a147$export$6497f4c0ecdfba8e)((0, $d2ae5bee1a6d44fa$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
            case "xxxxx":
                return (0, $0586aff3b490a147$export$6497f4c0ecdfba8e)((0, $d2ae5bee1a6d44fa$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
            case "xxx":
            default:
                return (0, $0586aff3b490a147$export$6497f4c0ecdfba8e)((0, $d2ae5bee1a6d44fa$export$a7ee192b982af9c1).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $fb871a4fb4a4b210$export$ead8a1812b171991)(date, date.getTime() - (0, $5a2e006a994236d3$export$113002b5eff6e430)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "X"
    ];
}





class $5b7770b076c7806f$export$2cd8bf877a05e96 extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    priority = 40;
    parse(dateString) {
        return (0, $0586aff3b490a147$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $fb871a4fb4a4b210$export$ead8a1812b171991)(date, value * 1000),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}





class $6f1f7850a12f2750$export$6d8f69c6906d6368 extends (0, $73c1a8a5b88d22ad$export$7acfa6ed01010e37) {
    priority = 20;
    parse(dateString) {
        return (0, $0586aff3b490a147$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $fb871a4fb4a4b210$export$ead8a1812b171991)(date, value),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}


const $8c1a6dc3ae38c0aa$export$19131010e7fd8373 = {
    G: new (0, $8d0a188e614bc59f$export$8e5a1d3f85a9688)(),
    y: new (0, $b24806326e91ca65$export$48d352de7cd4a988)(),
    Y: new (0, $85b993e165e96c1a$export$b8ef38dfcf05d5db)(),
    R: new (0, $161d4d257b73f385$export$951d1df011fde06f)(),
    u: new (0, $a5b7c6e040f81990$export$bad9d2ea38e8f1a)(),
    Q: new (0, $848c763725012987$export$5cb0f701186dde1d)(),
    q: new (0, $56d8e746e3a70306$export$300c0c2990e20e6d)(),
    M: new (0, $bbc8699c0ace4602$export$400dd8b40ef138a3)(),
    L: new (0, $9d6f10d134bfc2c6$export$1d7eaa53eaa5deba)(),
    w: new (0, $6ea6f9f9edb17d96$export$c4005ffc174e07c0)(),
    I: new (0, $73c2c3553e2d10ea$export$6fc8dbedd560a6af)(),
    d: new (0, $a4172a8678fa0644$export$e8d4b28a20981dd2)(),
    D: new (0, $d56aa2839458db93$export$6cfe0d613455f615)(),
    E: new (0, $6ffd990d848cceed$export$1b03c8b76262f7bd)(),
    e: new (0, $a51f40d4d0c6cced$export$44d1c127ab42c480)(),
    c: new (0, $a22546bbf73ebb30$export$e447a647caaaec1d)(),
    i: new (0, $892a7ca3ab0d873f$export$693fb1e525095b2a)(),
    a: new (0, $035e16996e108311$export$8d1e08492351df91)(),
    b: new (0, $903c2173ba2ccecc$export$73ca2bd0a17d273)(),
    B: new (0, $aca935ba2c6f1c47$export$bb9212adf05373db)(),
    h: new (0, $9e370a4d8efb7a79$export$8a04050a727a1756)(),
    H: new (0, $1661ae966fb26c95$export$e56f4dea2c3e56dd)(),
    K: new (0, $bde1e32422b5dac7$export$cbbe855312f87d77)(),
    k: new (0, $d9bf1bd38986f311$export$6008046d2b34b6a5)(),
    m: new (0, $3bab4a0583bdf146$export$2b52670d9e2be53)(),
    s: new (0, $20b97912d9aa6533$export$94d46d540cf1366a)(),
    S: new (0, $4888cc1e32648915$export$b8e6f8b2d70893b1)(),
    X: new (0, $453e9a48bacc215b$export$104d901d49fea29b)(),
    x: new (0, $067b4bfd7923e12f$export$12910e5204b52b9)(),
    t: new (0, $5b7770b076c7806f$export$2cd8bf877a05e96)(),
    T: new (0, $6f1f7850a12f2750$export$6d8f69c6906d6368)()
};


/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $304bac3700c3c8dc$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $304bac3700c3c8dc$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $304bac3700c3c8dc$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $304bac3700c3c8dc$var$doubleQuoteRegExp = /''/g;
const $304bac3700c3c8dc$var$notWhitespaceRegExp = /\S/;
const $304bac3700c3c8dc$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $304bac3700c3c8dc$export$98e6a39c04603d36(dateStr, formatStr, referenceDate, options) {
    const invalidDate = ()=>(0, $fb871a4fb4a4b210$export$ead8a1812b171991)(options?.in || referenceDate, NaN);
    const defaultOptions = (0, $e9fb2e83f460512a$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $408358fcfe846371$export$137380d9ce54f7f);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    if (!formatStr) return dateStr ? invalidDate() : (0, $15df6500c83ad252$export$e67a095c620b86fe)(referenceDate, options?.in);
    const subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will try to use the context or
    // the reference date and fallback to the system time zone.
    const setters = [
        new (0, $b3b6eb4d636a248a$export$8be15fe85ad72f86)(options?.in, referenceDate)
    ];
    const tokens = formatStr.match($304bac3700c3c8dc$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter in (0, $b4d819b58fa10348$export$70cc8fd02856fd58)) {
            const longFormatter = (0, $b4d819b58fa10348$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($304bac3700c3c8dc$var$formattingTokensRegExp);
    const usedTokens = [];
    for (let token of tokens){
        if (!options?.useAdditionalWeekYearTokens && (0, $261154dc94e203e4$export$c6b49d6dceb604a1)(token)) (0, $261154dc94e203e4$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        if (!options?.useAdditionalDayOfYearTokens && (0, $261154dc94e203e4$export$c6cc36aa33304772)(token)) (0, $261154dc94e203e4$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        const firstCharacter = token[0];
        const parser = (0, $8c1a6dc3ae38c0aa$export$19131010e7fd8373)[firstCharacter];
        if (parser) {
            const { incompatibleTokens: incompatibleTokens } = parser;
            if (Array.isArray(incompatibleTokens)) {
                const incompatibleToken = usedTokens.find((usedToken)=>incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
                if (incompatibleToken) throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
            } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
            if (!parseResult) return invalidDate();
            setters.push(parseResult.setter);
            dateStr = parseResult.rest;
        } else {
            if (firstCharacter.match($304bac3700c3c8dc$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $304bac3700c3c8dc$var$cleanEscapedString(token);
            // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
            else return invalidDate();
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && $304bac3700c3c8dc$var$notWhitespaceRegExp.test(dateStr)) return invalidDate();
    const uniquePrioritySetters = setters.map((setter)=>setter.priority).sort((a, b)=>b - a).filter((priority, index, array)=>array.indexOf(priority) === index).map((priority)=>setters.filter((setter)=>setter.priority === priority).sort((a, b)=>b.subPriority - a.subPriority)).map((setterArray)=>setterArray[0]);
    let date = (0, $15df6500c83ad252$export$e67a095c620b86fe)(referenceDate, options?.in);
    if (isNaN(+date)) return invalidDate();
    const flags = {};
    for (const setter of uniquePrioritySetters){
        if (!setter.validate(date, subFnOptions)) return invalidDate();
        const result = setter.set(date, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
            date = result[0];
            Object.assign(flags, result[1]);
        // Result is date
        } else date = result;
    }
    return date;
}
function $304bac3700c3c8dc$var$cleanEscapedString(input) {
    return input.match($304bac3700c3c8dc$var$escapedStringRegExp)[1].replace($304bac3700c3c8dc$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$304bac3700c3c8dc$export$2e2bcd8739ae039 = $304bac3700c3c8dc$export$98e6a39c04603d36;





function $1e6c68bbe2e44be7$export$4393d2ccbbedb219(argument, options) {
    const invalidDate = ()=>(0, $fb871a4fb4a4b210$export$ead8a1812b171991)(options?.in, NaN);
    const additionalDigits = options?.additionalDigits ?? 2;
    const dateStrings = $1e6c68bbe2e44be7$var$splitDateString(argument);
    let date;
    if (dateStrings.date) {
        const parseYearResult = $1e6c68bbe2e44be7$var$parseYear(dateStrings.date, additionalDigits);
        date = $1e6c68bbe2e44be7$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(+date)) return invalidDate();
    const timestamp = +date;
    let time = 0;
    let offset;
    if (dateStrings.time) {
        time = $1e6c68bbe2e44be7$var$parseTime(dateStrings.time);
        if (isNaN(time)) return invalidDate();
    }
    if (dateStrings.timezone) {
        offset = $1e6c68bbe2e44be7$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return invalidDate();
    } else {
        const tmpDate = new Date(timestamp + time);
        const result = (0, $15df6500c83ad252$export$e67a095c620b86fe)(0, options?.in);
        result.setFullYear(tmpDate.getUTCFullYear(), tmpDate.getUTCMonth(), tmpDate.getUTCDate());
        result.setHours(tmpDate.getUTCHours(), tmpDate.getUTCMinutes(), tmpDate.getUTCSeconds(), tmpDate.getUTCMilliseconds());
        return result;
    }
    return (0, $15df6500c83ad252$export$e67a095c620b86fe)(timestamp + time + offset, options?.in);
}
const $1e6c68bbe2e44be7$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
const $1e6c68bbe2e44be7$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const $1e6c68bbe2e44be7$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const $1e6c68bbe2e44be7$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $1e6c68bbe2e44be7$var$splitDateString(dateString) {
    const dateStrings = {};
    const array = dateString.split($1e6c68bbe2e44be7$var$patterns.dateTimeDelimiter);
    let timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($1e6c68bbe2e44be7$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($1e6c68bbe2e44be7$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        const token = $1e6c68bbe2e44be7$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $1e6c68bbe2e44be7$var$parseYear(dateString, additionalDigits) {
    const regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    const captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    const year = captures[1] ? parseInt(captures[1]) : null;
    const century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $1e6c68bbe2e44be7$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    const captures = dateString.match($1e6c68bbe2e44be7$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    const isWeekDate = !!captures[4];
    const dayOfYear = $1e6c68bbe2e44be7$var$parseDateUnit(captures[1]);
    const month = $1e6c68bbe2e44be7$var$parseDateUnit(captures[2]) - 1;
    const day = $1e6c68bbe2e44be7$var$parseDateUnit(captures[3]);
    const week = $1e6c68bbe2e44be7$var$parseDateUnit(captures[4]);
    const dayOfWeek = $1e6c68bbe2e44be7$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$1e6c68bbe2e44be7$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $1e6c68bbe2e44be7$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        const date = new Date(0);
        if (!$1e6c68bbe2e44be7$var$validateDate(year, month, day) || !$1e6c68bbe2e44be7$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $1e6c68bbe2e44be7$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $1e6c68bbe2e44be7$var$parseTime(timeString) {
    const captures = timeString.match($1e6c68bbe2e44be7$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    const hours = $1e6c68bbe2e44be7$var$parseTimeUnit(captures[1]);
    const minutes = $1e6c68bbe2e44be7$var$parseTimeUnit(captures[2]);
    const seconds = $1e6c68bbe2e44be7$var$parseTimeUnit(captures[3]);
    if (!$1e6c68bbe2e44be7$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $9de04c5ea6f5cdac$export$7f72910d6dfd237a) + minutes * (0, $9de04c5ea6f5cdac$export$91246f0b9bd9beff) + seconds * 1000;
}
function $1e6c68bbe2e44be7$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $1e6c68bbe2e44be7$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    const captures = timezoneString.match($1e6c68bbe2e44be7$var$timezoneRegex);
    if (!captures) return 0;
    const sign = captures[1] === "+" ? -1 : 1;
    const hours = parseInt(captures[2]);
    const minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$1e6c68bbe2e44be7$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $9de04c5ea6f5cdac$export$7f72910d6dfd237a) + minutes * (0, $9de04c5ea6f5cdac$export$91246f0b9bd9beff));
}
function $1e6c68bbe2e44be7$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
const $1e6c68bbe2e44be7$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $1e6c68bbe2e44be7$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $1e6c68bbe2e44be7$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($1e6c68bbe2e44be7$var$daysInMonths[month] || ($1e6c68bbe2e44be7$var$isLeapYearIndex(year) ? 29 : 28));
}
function $1e6c68bbe2e44be7$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($1e6c68bbe2e44be7$var$isLeapYearIndex(year) ? 366 : 365);
}
function $1e6c68bbe2e44be7$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $1e6c68bbe2e44be7$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $1e6c68bbe2e44be7$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}
var // Fallback for modularized imports:
$1e6c68bbe2e44be7$export$2e2bcd8739ae039 = $1e6c68bbe2e44be7$export$4393d2ccbbedb219;










































































const $59ce42ad19f47745$var$FORCE_BUNDLE = [
    (0, $a136943f2aa06c95$export$fe98a034cfb96d55),
    (0, $b4d819b58fa10348$export$70cc8fd02856fd58)
];
class $59ce42ad19f47745$export$2e2bcd8739ae039 extends (0, $d8775d5311bbf499$export$2e2bcd8739ae039) {
    constructor(props){
        super(props);
        this.edited = this.edited.bind(this);
    }
    edited(m) {
        const i = (0, $1e6c68bbe2e44be7$export$4393d2ccbbedb219)(m);
        return i ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", {
            className: "card-text"
        }, "Last edited: ", (0, $7f44af15c54aee83$export$8fbbfd65594f46a0)(i, new Date())) : "";
    }
    render() {
        if (!this.props.document.properties) {
            console.log("Document has no properties: ", this.props.document);
            return null;
        }
        const t = (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(this.props.document.properties.type + ".title");
        const modified = this.edited(this.props.document.modifiedTime);
        const doc = {
            type: this.props.document.properties.type,
            id: this.props.document.id,
            section: 'toc'
        };
        if (t && this.props.document.id && this.props.document.name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card card-recent"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card-header"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(this.props.document.properties.type + ".title")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $7a6def086ebe18be$export$2e2bcd8739ae039), {
            to: (0, $37ba0e6d5a59440b$export$2c618a4308a30424)(doc.type, doc.id, doc.section)
        }, this.props.document.name)), modified)));
        return null;
    }
}




var $6wXVr = parcelRequire("6wXVr");


var $33d51a3862e796d0$exports = {};
'use strict';
Object.defineProperty($33d51a3862e796d0$exports, "__esModule", {
    value: true
});
var $33d51a3862e796d0$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $6wXVr = parcelRequire("6wXVr");
var $33d51a3862e796d0$var$_react2 = $33d51a3862e796d0$var$_interopRequireDefault($6wXVr);

var $33d51a3862e796d0$var$_propTypes2 = $33d51a3862e796d0$var$_interopRequireDefault($c83591d04bda8b2b$exports);

var $33d51a3862e796d0$var$_loadScript2 = $33d51a3862e796d0$var$_interopRequireDefault($97fdae29859220f3$exports);
function $33d51a3862e796d0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $33d51a3862e796d0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $33d51a3862e796d0$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $33d51a3862e796d0$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $33d51a3862e796d0$var$GOOGLE_SDK_URL = 'https://apis.google.com/js/api.js';
var $33d51a3862e796d0$var$scriptLoadingStarted = false;
var $33d51a3862e796d0$var$GoogleChooser = function(_React$Component) {
    $33d51a3862e796d0$var$_inherits(GoogleChooser, _React$Component);
    function GoogleChooser(props) {
        $33d51a3862e796d0$var$_classCallCheck(this, GoogleChooser);
        var _this = $33d51a3862e796d0$var$_possibleConstructorReturn(this, (GoogleChooser.__proto__ || Object.getPrototypeOf(GoogleChooser)).call(this, props));
        _this.onApiLoad = _this.onApiLoad.bind(_this);
        _this.onChoose = _this.onChoose.bind(_this);
        return _this;
    }
    $33d51a3862e796d0$var$_createClass(GoogleChooser, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (this.isGoogleReady()) // google api is already exists
                // init immediately
                this.onApiLoad();
                else if (!$33d51a3862e796d0$var$scriptLoadingStarted) {
                    // load google api and the init
                    $33d51a3862e796d0$var$scriptLoadingStarted = true;
                    (0, $33d51a3862e796d0$var$_loadScript2.default)($33d51a3862e796d0$var$GOOGLE_SDK_URL, this.onApiLoad);
                }
            }
        },
        {
            key: 'isGoogleReady',
            value: function isGoogleReady() {
                return !!window.gapi;
            }
        },
        {
            key: 'isGoogleAuthReady',
            value: function isGoogleAuthReady() {
                return !!window.gapi.auth;
            }
        },
        {
            key: 'isGooglePickerReady',
            value: function isGooglePickerReady() {
                return !!window.google.picker;
            }
        },
        {
            key: 'onApiLoad',
            value: function onApiLoad() {
                window.gapi.load('auth');
                window.gapi.load('picker');
            }
        },
        {
            key: 'doAuth',
            value: function doAuth(callback) {
                window.gapi.auth.authorize({
                    client_id: this.props.clientId,
                    scope: this.props.scope,
                    immediate: this.props.authImmediate
                }, callback);
            }
        },
        {
            key: 'onChoose',
            value: function onChoose() {
                var _this2 = this;
                if (!this.isGoogleReady() || !this.isGoogleAuthReady() || !this.isGooglePickerReady() || this.props.disabled) return null;
                var token = window.gapi.auth.getToken();
                var oauthToken = token && token.access_token;
                if (oauthToken) this.createPicker(oauthToken);
                else this.doAuth(function(response) {
                    if (response.access_token) _this2.createPicker(response.access_token);
                    else _this2.props.onAuthFailed(response);
                });
            }
        },
        {
            key: 'createPicker',
            value: function createPicker(oauthToken) {
                this.props.onAuthenticate(oauthToken);
                if (this.props.createPicker) return this.props.createPicker(google, oauthToken);
                var googleViewId = google.picker.ViewId[this.props.viewId];
                var view = new window.google.picker.View(googleViewId);
                if (this.props.mimeTypes) view.setMimeTypes(this.props.mimeTypes.join(','));
                if (this.props.query) view.setQuery(this.props.query);
                if (!view) throw new Error('Can\'t find view by viewId');
                var picker = new window.google.picker.PickerBuilder().addView(view).setOAuthToken(oauthToken).setDeveloperKey(this.props.developerKey).setCallback(this.props.onChange);
                if (this.props.origin) picker.setOrigin(this.props.origin);
                if (this.props.navHidden) picker.enableFeature(window.google.picker.Feature.NAV_HIDDEN);
                if (this.props.multiselect) picker.enableFeature(window.google.picker.Feature.MULTISELECT_ENABLED);
                picker.build().setVisible(true);
            }
        },
        {
            key: 'render',
            value: function render() {
                return $33d51a3862e796d0$var$_react2.default.createElement('div', {
                    onClick: this.onChoose
                }, this.props.children ? this.props.children : $33d51a3862e796d0$var$_react2.default.createElement('button', null, 'Open google chooser'));
            }
        }
    ]);
    return GoogleChooser;
}($33d51a3862e796d0$var$_react2.default.Component);
$33d51a3862e796d0$var$GoogleChooser.propTypes = {
    children: $33d51a3862e796d0$var$_propTypes2.default.node,
    clientId: $33d51a3862e796d0$var$_propTypes2.default.string.isRequired,
    developerKey: $33d51a3862e796d0$var$_propTypes2.default.string,
    scope: $33d51a3862e796d0$var$_propTypes2.default.array,
    viewId: $33d51a3862e796d0$var$_propTypes2.default.string,
    authImmediate: $33d51a3862e796d0$var$_propTypes2.default.bool,
    origin: $33d51a3862e796d0$var$_propTypes2.default.string,
    onChange: $33d51a3862e796d0$var$_propTypes2.default.func,
    onAuthenticate: $33d51a3862e796d0$var$_propTypes2.default.func,
    onAuthFailed: $33d51a3862e796d0$var$_propTypes2.default.func,
    createPicker: $33d51a3862e796d0$var$_propTypes2.default.func,
    multiselect: $33d51a3862e796d0$var$_propTypes2.default.bool,
    navHidden: $33d51a3862e796d0$var$_propTypes2.default.bool,
    disabled: $33d51a3862e796d0$var$_propTypes2.default.bool
};
$33d51a3862e796d0$var$GoogleChooser.defaultProps = {
    onChange: function onChange() {},
    onAuthenticate: function onAuthenticate() {},
    onAuthFailed: function onAuthFailed() {},
    scope: [
        'https://www.googleapis.com/auth/drive.readonly'
    ],
    viewId: 'DOCS',
    authImmediate: false,
    multiselect: false,
    navHidden: false,
    disabled: false
};
$33d51a3862e796d0$exports.default = $33d51a3862e796d0$var$GoogleChooser;






var $3UKyI = parcelRequire("3UKyI");
class $38ad88dfeba90e3e$export$2e2bcd8739ae039 extends (0, $d8775d5311bbf499$export$2e2bcd8739ae039) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    // Type of the selected file is recognized by scanning for these keywords in the description.
    // FIXME replace this method with something more robust and straightforward.
    static supportedDocTypes = [
        {
            key: 'comparison',
            display: 'Comparison'
        },
        {
            key: 'cause-effect',
            display: 'Cause & Effect Guide'
        },
        {
            key: 'question-exp',
            display: 'Question Exploration'
        },
        {
            key: 'cera',
            display: 'Claim, Evidence, Reasoning Guide'
        }
    ];
    constructor(props){
        super(props);
        this.picked = this.picked.bind(this);
    }
    picked(data) {
        let doc = this.context;
        var location = {
            pathname: "/docs"
        };
        if ('picked' === data.action) {
            $38ad88dfeba90e3e$export$2e2bcd8739ae039.supportedDocTypes.some(function(docType, index, _arr) {
                if (data.docs[0].description.includes(docType.display)) {
                    doc.fileIdLoaded = false; // ???
                    location = (0, $37ba0e6d5a59440b$export$2c618a4308a30424)(docType.key, data.docs[0].id, 'toc');
                    return true; // break
                }
                return false;
            });
            if ('/docs' === location.pathname) console.warn('picker returned ' + data.docs[0].description);
            console.log("picker redirect to " + $3UKyI.inspect(location));
            // this.context.router.history.push(docId);
            return window.location = location.pathname;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$2d8d895a0a0f636e), {
            to: location,
            push: true
        });
    }
    render() {
        //const appName = window.appName? window.appName: 'CORGI';
        //const desktop = "&fd=true";
        let appId = (0, $220c2d58964ba595$export$fcc0626890c55730) ? (0, $220c2d58964ba595$export$fcc0626890c55730).clientId.split('-')[0] : "42"; // for OrganizerChoice test
        let corgi_mimeType = 'application/vnd.google-apps.drive-sdk.' + appId;
        let clientId = (0, $220c2d58964ba595$export$fcc0626890c55730) ? (0, $220c2d58964ba595$export$fcc0626890c55730).clientId : '42';
        let apiKey = (0, $220c2d58964ba595$export$fcc0626890c55730) ? (0, $220c2d58964ba595$export$fcc0626890c55730).apiKey : '42';
        let scopes = (0, $220c2d58964ba595$export$fcc0626890c55730) ? (0, $220c2d58964ba595$export$fcc0626890c55730).scopes : [];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($33d51a3862e796d0$exports))), {
            id: "picker",
            clientId: clientId,
            developerKey: apiKey,
            scope: scopes,
            onChange: (data)=>this.picked(data),
            onAuthFailed: (data)=>console.log('on auth failed:', data),
            onAuthenticate: (token)=>this.context.checkAccessTokenBeforeInitGooglePicker(token),
            multiselect: false,
            // navHidden={false}
            authImmediate: false,
            mimeTypes: [
                corgi_mimeType
            ],
            // DOCS_IMAGES_AND_VIDEOS?
            viewId: 'DOCS'
        }, this.props.children);
    }
}




class $7f0c60140e4aae6b$export$2e2bcd8739ae039 extends (0, $d8775d5311bbf499$export$2e2bcd8739ae039) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.state = {
            orderBy: "modifiedByMeTime"
        };
        this.getDocuments = this.getDocuments.bind(this);
        this.getCards = this.getCards.bind(this);
        this.changeOrderByOption = this.changeOrderByOption.bind(this);
    }
    // List the current users Google Drive CORGI app documents and runs the given callback with the result
    getDocuments(type) {
        let appId = (0, $220c2d58964ba595$export$fcc0626890c55730) ? (0, $220c2d58964ba595$export$fcc0626890c55730).clientId.split('-')[0] : "42"; // for OrganizerChoice test
        let m = "mimeType = 'application/vnd.google-apps.drive-sdk." + appId + "'";
        let t = "trashed = false";
        // let mod = "modifiedTime >= '"+subDays(new Date(),30).toISOString()+"'"; // check definition of recent
        return new Promise((resolve)=>{
            let criteria = {
                fields: "files(id,name,mimeType,properties/type,modifiedTime,trashed,description,parents)",
                orderBy: this.state.orderBy + " desc",
                pageSize: 3,
                q: t + " and " + m //, +" and "+mod,
            };
            if (type) criteria.type = type;
            if (undefined !== window.gapi) window.gapi.client.request({
                path: "https://www.googleapis.com/drive/v3/files",
                method: "GET",
                params: criteria
            }).then((response)=>{
                this.setState({
                    documents: response.result.files
                });
                resolve(response.result.files);
            }, (err_reason)=>{
                console.log("Could not get Drive Documents: " + err_reason.result.error.message);
                this.setState({
                    error: 1
                });
                if (err_reason.result.error.code === 401) this.context.handleAccessTokenExpired();
            });
            else {
                console.error('undefined window.gapi');
                this.setState({
                    error: 1
                });
            }
        });
    }
    getCards(documents) {
        if (Array.isArray(documents)) {
            if (documents.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, "You have no recent guides. To get started, create a new Corgi Guide below!");
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                className: "row row-cols-1 row-cols-md-2 row-cols-lg-3"
            }, " ", documents.map((doc)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $59ce42ad19f47745$export$2e2bcd8739ae039), {
                    key: doc.id,
                    document: doc
                })), " ");
        } else console.error("documents is not array");
    }
    changeOrderByOption(event) {
        this.state.orderBy = event.target.value;
        this.getDocuments(null).then(()=>{
            this.setState({
                cards: this.getCards(this.state.documents)
            });
        });
    }
    componentWillMount() {
        this.getDocuments(null).then(()=>{
            this.setState({
                cards: this.getCards(this.state.documents)
            });
        });
    }
    render() {
        let docSection;
        if (this.state.documents != null && this.state.documents.length !== 0) docSection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "My-Documents",
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            className: "pt-2"
        }, "My Recent Corgi Guides"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("form", {
            className: "form-inline"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("label", {
            htmlFor: "display",
            className: "form-label me-0_25"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Display:")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("select", {
            id: "display",
            className: "form-control d-inline-block",
            value: this.state.orderBy,
            onChange: this.changeOrderByOption
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("option", {
            value: "modifiedByMeTime"
        }, "Last modified by me"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("option", {
            value: "viewedByMeTime"
        }, "Last opened by me"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("option", {
            value: "modifiedTime"
        }, "Last modified")))), this.state.cards, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "d-flex flex-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $38ad88dfeba90e3e$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            className: "btn btn-primary text-right"
        }, "See all Guides in my Google Drive", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "pages-next-icon fa fa-chevron-right",
            "aria-hidden": "true"
        })))));
        else docSection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            className: "pt-2"
        }, "Get Started"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, "It looks like you\u2019re new here. Check out these quick how-to guides to help you get started using Corgi:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row flex-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-12 col-sm-6 col-lg-4 mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://docs.google.com/presentation/d/1nC7AWtgtuWJDStX02Goy8Va0eswfKZtIlS3KKuq-RI4/present",
            target: "_blank",
            rel: "noopener noreferrer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            className: "img-fluid border",
            src: (0, $540ee614c8ab8fe3$export$46abdfa6346e2c9b) + '/img/intro-to-corgi-features.png',
            alt: "Introduction to Corgi's features"
        }), "Introduction to Corgi\u2019s features", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fas fa-external-link-alt ms-0_25",
            title: "(external site)"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-12 col-sm-6 col-lg-4 mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://docs.google.com/presentation/d/1F3emK3ptsRgIDSn23pd-EcbOwlW8Rx1dvqBMkCP5VZM/present",
            target: "_blank",
            rel: "noopener noreferrer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            className: "img-fluid border",
            src: (0, $540ee614c8ab8fe3$export$46abdfa6346e2c9b) + '/img/sharing-a-corgi-guide.png',
            alt: "Sharing a Corgi guide"
        }), "Sharing a Corgi guide", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fas fa-external-link-alt ms-0_25",
            title: "(external site)"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-12 col-sm-6 col-lg-4 mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "player",
            className: "embed-fluid embed-fluid-16x9"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("iframe", {
            id: "ytPlayer",
            src: "https://www.youtube-nocookie.com/embed/1TvTdI3bB90?enablejsapi=1",
            frameBorder: "0",
            title: "Youtube Video",
            "aria-label": "YouTube Video: How to use Google Classroom with Corgi",
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowFullScreen: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://youtu.be/1TvTdI3bB90",
            target: "_blank",
            rel: "noopener noreferrer"
        }, "How to use Google Classroom with Corgi", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fas fa-external-link-alt ms-0_25",
            title: "(external site)"
        })))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "doctitle"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h1", {
            id: "content"
        }, "Welcome, ", this.context.currentUser.displayName)), docSection);
    }
}



var $6wXVr = parcelRequire("6wXVr");



var $6wXVr = parcelRequire("6wXVr");

var $6wXVr = parcelRequire("6wXVr");


var $6wXVr = parcelRequire("6wXVr");


var $6wXVr = parcelRequire("6wXVr");

class $d376992b5e3fea66$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    constructor(){
        super();
        this.onPlay = this.onPlay.bind(this);
    }
    render() {
        const ccURL = this.props.ccURL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("track", {
            src: this.props.ccURL,
            label: "English Subtitles",
            kind: "subtitles",
            srcLang: "en",
            default: true
        }) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            "data-cfw": "player",
            className: "video-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "embed-fluid"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("video", {
            onPlay: this.onPlay,
            poster: this.props.posterURL,
            controls: true,
            crossOrigin: "anonymous"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("source", {
            src: this.props.videoURL,
            type: "video/mp4"
        }), ccURL, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, "HTML5 video not supported"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "player-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "player",
            role: "region",
            "aria-label": "video player",
            "data-cfw-player": "player"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "player-control ",
            "data-cfw-player": "control"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "btn btn-icon",
            "data-cfw-player": "play",
            title: "Play",
            "aria-label": "Play"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-fw fa-play",
            "aria-hidden": "true"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "btn btn-icon",
            "data-cfw-player": "pause",
            title: "Pause",
            "aria-label": "Pause"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-fw fa-pause",
            "aria-hidden": "true"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "btn btn-icon",
            "data-cfw-player": "stop",
            title: "Stop",
            "aria-label": "Stop"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-fw fa-stop",
            "aria-hidden": "true"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "player-time",
            "data-cfw-player": "time"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "player-time-current",
            "data-cfw-player": "time-current"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "player-seek",
            "data-cfw-player": "seek"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("input", {
            type: "range",
            className: "form-range",
            "aria-label": "Seek"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "player-time-duration",
            "data-cfw-player": "time-duration"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "btn btn-icon",
            "data-cfw-player": "caption",
            title: "Closed captions",
            "aria-label": "Closed captions"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-fw fa-closed-captioning",
            "aria-hidden": "true"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "player-fullscreen",
            "data-cfw-player": "fullscreen"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "btn btn-icon player-fullscreen-on",
            title: "Exit fullscreen",
            "aria-label": "Exit fullscreen"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-fw fa-compress-arrows-alt",
            "aria-hidden": "true"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "btn btn-icon player-fullscreen-off",
            title: "Fullscreen",
            "aria-label": "Fullscreen"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-fw fa-expand-arrows-alt",
            "aria-hidden": "true"
        }))))));
    }
    onPlay(event) {
        // window.tracker.trackEvent("video-player", "play", this.props.video);
        window.tracker.trackEvent("Video", "play video", this.props.video);
    }
}
$d376992b5e3fea66$export$2e2bcd8739ae039.propTypes = {
    videoURL: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    posterURL: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    ccURL: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired
};



class $2ad616e66927b31b$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    constructor(){
        super();
        this.onPlay = this.onPlay.bind(this);
    }
    render() {
        const videoURL = (0, $540ee614c8ab8fe3$export$46abdfa6346e2c9b) + "/video/" + this.props.video + ".mp4";
        const ccURL = videoURL.replace("mp4", "vtt");
        const posterURL = videoURL.replace("mp4", "jpg");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $d376992b5e3fea66$export$2e2bcd8739ae039), {
            posterURL: posterURL,
            ccURL: ccURL,
            videoURL: videoURL
        });
    }
    onPlay(event) {
        // window.tracker.trackEvent("video-player", "play", this.props.video);
        window.tracker.trackEvent("Video", "play video", this.props.video);
    }
}
$2ad616e66927b31b$export$2e2bcd8739ae039.propTypes = {
    video: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired
};




// Simple utility to generate IDs that are unique to the page.
// From http://stackoverflow.com/questions/29420835/how-to-generate-unique-ids-for-form-labels-in-react
let $3e353bdb6bbe6e31$var$lastId = 0;
function $3e353bdb6bbe6e31$export$2e2bcd8739ae039(prefix = 'id') {
    $3e353bdb6bbe6e31$var$lastId++;
    return `${prefix}${$3e353bdb6bbe6e31$var$lastId}`;
}



class $ff4f4fd575640ac6$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    constructor(props){
        super(props);
        this.videoButtonId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
    }
    componentDidMount() {
        // ensure modal wiring
        const button = (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#' + this.videoButtonId);
        if (button.CFW_Modal) button.CFW_Modal();
    }
    render() {
        const caption = (0, $21f9ebdc444decaf$export$6e22c362a0406a2c)(this.props.caption) ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", null, this.props.caption);
        const posterURL = (0, $540ee614c8ab8fe3$export$46abdfa6346e2c9b) + "/video/" + this.props.video + "-lg.jpg";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "p-1 modal-open"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            id: this.videoButtonId,
            type: "button",
            className: "btn link-video",
            "data-cfw": "modal",
            "data-cfw-modal-target": "#" + this.props.video
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: posterURL,
            alt: "Watch video",
            className: "img-fluid card-img-top"
        })), caption, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: this.props.video,
            className: "modal video-modal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-dialog modal-dialog-centered"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            className: "modal-title"
        }, "Video player"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "close",
            "data-cfw-dismiss": "modal",
            "aria-label": "Close"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-times",
            "aria-hidden": "true"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $2ad616e66927b31b$export$2e2bcd8739ae039), {
            video: this.props.video
        }))))));
    }
}
$ff4f4fd575640ac6$export$2e2bcd8739ae039.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    video: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    caption: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired
};




class $33c53f2912681500$export$2e2bcd8739ae039 extends (0, $d8775d5311bbf499$export$2e2bcd8739ae039) {
    constructor(props){
        super(props);
        this.cfwInit = this.cfwInit.bind(this);
    }
    componentDidMount() {
        super.componentDidMount();
        this.cfwInit();
    }
    componentDidUpdate() {
        super.componentDidUpdate();
        this.cfwInit();
    }
    cfwInit() {
        (0, $2c839b9f78572b9b$export$2e2bcd8739ae039)();
    }
}


var $ed24a019e76c73ec$exports = {};
var $49667bca3d030a62$exports = {};
$49667bca3d030a62$exports = $parcel$resolve("6HS2M");


var $2b6e8a859723eaa3$exports = {};
$2b6e8a859723eaa3$exports = $parcel$resolve("jMbat");


var $e2cd7380f54c5f37$exports = {};
$e2cd7380f54c5f37$exports = $parcel$resolve("gyh7g");


var $732598ae78161c2f$exports = {};
$732598ae78161c2f$exports = $parcel$resolve("2Jugt");


$ed24a019e76c73ec$exports = {
    "CEG_flowChart": $49667bca3d030a62$exports,
    "CERA_flowChart": $2b6e8a859723eaa3$exports,
    "CT_flowChart": $e2cd7380f54c5f37$exports,
    "QEG_flowChart": $732598ae78161c2f$exports
};


class $c89051fe5c1840c7$export$2e2bcd8739ae039 extends (0, $33c53f2912681500$export$2e2bcd8739ae039) {
    render() {
        const abbr = (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(this.props.docType + ".abbr");
        // Unused
        //const tour = this.props.docType === "question-exp"? "question-exploration-tour": this.props.docType+"-tour";
        //const mp4 = tour === "unit-org-2-tour"? null: tour; // "/video/"+tour+".mp4";
        //const example = this.props.docType === "unit-org-2"? null: "/example/"+abbr+"_Sci.pdf";
        const flowChart = this.props.docType === "unit-org-2" ? null : $ed24a019e76c73ec$exports[abbr + "_flowChart"];
        const blurb = (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(this.props.docType + ".blurb");
        const title = (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(this.props.docType + ".title");
        // TODO: make /:docType/new work
        const newDocType = "#new" + this.props.docType.charAt(0).toUpperCase() + this.props.docType.slice(1);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card card-newguide"
        }, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card-img"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: flowChart,
            className: "img-fluid",
            alt: title + " flowchart"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: newDocType,
            onClick: this.props.creator
        }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", {
            className: "card-text"
        }, blurb), null)));
    }
    static exampleLink(example) {
        return example ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", {
            className: "card-text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: example,
            target: "_blank",
            rel: "noopener noreferrer",
            className: "link-chevron"
        }, "See preview")) : null;
    }
    static videoLink(title, mp4) {
        return mp4 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $ff4f4fd575640ac6$export$2e2bcd8739ae039), {
            title: title,
            video: mp4,
            caption: "",
            label: ""
        }) : null;
    }
}




class $92ddb1911be1e346$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(){
        super();
        this.createUO = this.createUO.bind(this);
        this.createCET = this.createCET.bind(this);
        this.createQEG = this.createQEG.bind(this);
        this.createCT = this.createCT.bind(this);
        this.createCERA = this.createCERA.bind(this);
    }
    render() {
        console.log(this.context);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "new",
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            className: "pt-1 mb-1"
        }, "Create a New Corgi Guide"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row row-cols-1 row-cols-md-2 row-cols-lg-3"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $c89051fe5c1840c7$export$2e2bcd8739ae039), {
            docType: "cause-effect",
            creator: this.createCET
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $c89051fe5c1840c7$export$2e2bcd8739ae039), {
            docType: "question-exp",
            creator: this.createQEG
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $c89051fe5c1840c7$export$2e2bcd8739ae039), {
            docType: "comparison",
            creator: this.createCT
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $c89051fe5c1840c7$export$2e2bcd8739ae039), {
            docType: "cera",
            creator: this.createCERA
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "modalPrivacy",
            className: "modal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-dialog modal-dialog-centered"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "modal-title"
        }, "Authorizing Corgi with Google")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "player",
            className: "embed-fluid embed-fluid-16x9 mt-0_25"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("iframe", {
            id: "ytPlayer",
            src: 'https://www.youtube-nocookie.com/embed/9pw40R1l50g?enablejsapi=1',
            frameBorder: "0",
            title: "Youtube Video",
            "aria-label": 'YouTube Video: Authorizing Corgi to work with your Google account',
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowFullScreen: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, "Visit ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e10f0f56b55cf4b2$export$2e2bcd8739ae039), {
            page: "support"
        }, "How to Use Corgi"), " for more help getting started.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-footer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "text-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "btn btn-success",
            "data-cfw-dismiss": "modal"
        }, "Close")))))));
    }
    createCET(event) {
        return this.props.newDocButtonMethod("cause-effect");
    }
    createQEG() {
        return this.props.newDocButtonMethod("question-exp");
    }
    createCT() {
        return this.props.newDocButtonMethod("comparison");
    }
    createUO() {
        return this.props.newDocButtonMethod("unit-org-2");
    }
    createCERA() {
        return this.props.newDocButtonMethod("cera");
    }
}
$92ddb1911be1e346$export$2e2bcd8739ae039.propTypes = {
    newDocButtonMethod: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).func.isRequired
};





class $32c97e6ff3e15def$export$2e2bcd8739ae039 extends (0, $d8775d5311bbf499$export$2e2bcd8739ae039) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(){
        super();
        this.typeChosen = false;
    }
    render() {
        if (this.context.createPending) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $bc34d6c4fed03120$export$de73cf9e66f7476e), {
            loading: true
        });
        let info = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "text-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e10f0f56b55cf4b2$export$2e2bcd8739ae039), {
            page: "support",
            className: "btn btn-success mx-0_5"
        }, "How to use Corgi"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e10f0f56b55cf4b2$export$2e2bcd8739ae039), {
            page: "library",
            className: "btn btn-success"
        }, "Lesson Library"));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "page-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "content row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "content-main col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "content-main-inner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("main", {
            id: "main_container",
            className: "main"
        }, info, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $89f750eb5858fa5b$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $7f0c60140e4aae6b$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $92ddb1911be1e346$export$2e2bcd8739ae039), {
            newDocButtonMethod: this.props.newDocButtonMethod,
            authorizeWithPopUp: this.props.authorizeWithPopUp
        }))))));
    }
    componentDidMount() {
        super.componentDidMount();
        window.tracker.trackPageView(this.context.currentUser, 'home');
    }
}
$32c97e6ff3e15def$export$2e2bcd8739ae039.propTypes = {
    newDocButtonMethod: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).func.isRequired
};



var $6wXVr = parcelRequire("6wXVr");


class $ba8dff0eeb9aa11c$export$2e2bcd8739ae039 extends (0, $d8775d5311bbf499$export$2e2bcd8739ae039) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("main", {
            id: "main_container",
            className: "container-fluid"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col text-center my-lg-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h1", {
            className: "h2 text-body my-lg-2"
        }, "Sorry, this document type is no longer supported"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e10f0f56b55cf4b2$export$2e2bcd8739ae039), {
            page: "docs",
            hash: '#CERs',
            className: "link-add",
            role: "button"
        }, "New document")))));
    }
}



var $6wXVr = parcelRequire("6wXVr");

var $6wXVr = parcelRequire("6wXVr");
var $8a34fb1098450c8d$exports = {};
'use strict';

$8a34fb1098450c8d$exports = (parcelRequire("dUzj6"));




var $6wXVr = parcelRequire("6wXVr");

class $618116693e1a0bce$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.domId = this.props.domId;
        this.wrapperClassName = "stt-wrapper";
        this.size = this.props.size ? this.props.size : "lg";
        this.inputType = this.props.inputType ? this.props.inputType + " " : "";
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: this.wrapperClassName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: this.inputType + "firepad-form form-control form-control-" + this.size,
            id: this.domId,
            autoComplete: "off"
        }), undefined !== this.props.button ? this.props.button() : "");
    }
}


function $6a59b1cc78a70843$export$36a6d360a8c4e160(readOnly, placeholder) {
    return {
        readOnly: readOnly,
        tabMode: "default",
        scrollbarStyle: "null",
        height: "auto",
        lineWrapping: true,
        viewportMargin: Infinity,
        placeholder: placeholder,
        screenReaderLabel: placeholder,
        inputStyle: "contenteditable",
        spellcheck: true,
        extraKeys: {
            "Tab": false,
            "Shift-Tab": false
        }
    };
}
function $6a59b1cc78a70843$export$83e157e498e502fc(readOnly, placeholder) {
    return {
        readOnly: readOnly,
        tabMode: "default",
        extraKeys: {
            "Enter": function(editor) {
                editor.replaceSelection("");
            },
            "Tab": false,
            "Shift-Tab": false
        },
        scrollbarStyle: "null",
        placeholder: placeholder,
        screenReaderLabel: placeholder,
        inputStyle: "contenteditable",
        spellcheck: true
    };
}



var $6wXVr = parcelRequire("6wXVr");

// FIXME: temporarily remove Info, per AMK CORGI-276

var $6wXVr = parcelRequire("6wXVr");





class $d41fdfe829c9167f$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    componentWillMount() {
        this.buttonId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.popoverId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
    }
    render() {
        const docType = this.props.docType ? this.props.docType : this.context.fileType;
        let identifier = this.props.identifier.toLowerCase();
        const example = null;
        const characteristics = /^characteristics/i;
        const concepts = /^concepts/i;
        identifier = identifier.replace(characteristics, 'characteristics1');
        identifier = identifier.replace(concepts, 'concept1');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "print-none"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "btn btn-info btn-xsmall btn-light",
            title: "More Information",
            "data-cfw": "popover",
            "data-cfw-popover-target": "#" + this.popoverId,
            "data-cfw-popover-placement": "auto top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-info text-primary",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "More Information")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "popover info-popover",
            id: this.popoverId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "close",
            title: "Close",
            "data-cfw-dismiss": "popover"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            "aria-hidden": "true"
        }, "x")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "popover-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $d6bad315ad35dae0$export$2e2bcd8739ae039), {
            type: docType,
            identifier: identifier,
            item: 'singleLabel'
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "popover-body"
        }, example, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $d6bad315ad35dae0$export$2e2bcd8739ae039), {
            tag: "p",
            type: docType,
            identifier: identifier,
            item: "help"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "popover-arrow"
        })));
    }
    componentDidMount() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))(document).CFW_Popover) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#' + this.buttonId).CFW_Popover({
                placement: "bottom auto",
                title: "More Information",
                container: "body",
                toggle: "#" + this.popoverId
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))(`#${this.buttonId}`).on('afterShow.cfw.popover', ()=>{
                // window.tracker.trackEvent(this.props.docType, "Info Box", `${this.props.identifier}`);
                window.tracker.trackEvent("Support", "info button", `${this.props.identifier}`);
            });
        }
    }
}
$d41fdfe829c9167f$export$2e2bcd8739ae039.propTypes = {
    identifier: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired
};





class $176e033a80de7861$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    render() {
        const type = !(0, $21f9ebdc444decaf$export$6e22c362a0406a2c)(this.context.fileType) ? this.context.fileType : this.props.docType;
        //const number = <span className="hnum">{this.props.stepnum}</span>
        const numberHeaderSep = ". ";
        const header = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $d6bad315ad35dae0$export$2e2bcd8739ae039), {
            type: type,
            identifier: this.props.identifier,
            item: 'label'
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            className: "h2"
        }, this.props.stepnum, numberHeaderSep, header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $d41fdfe829c9167f$export$2e2bcd8739ae039), {
            docType: type,
            identifier: this.props.identifier
        }));
    }
}
$176e033a80de7861$export$2e2bcd8739ae039.propTypes = {
    stepnum: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    identifier: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired
};





var $6wXVr = parcelRequire("6wXVr");


var $6wXVr = parcelRequire("6wXVr");


class $c0ad353fe5b45e03$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    render() {
        const src = this.props.video.src;
        if (src) {
            // Regex to match YouTube ID string: https://stackoverflow.com/a/27728417
            // Value is in [1]
            const regexExtractId = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/)|(?:(?:watch)?\?v(?:i)?=|&v(?:i)?=))([^#&?]*).*/;
            const idString = src.match(regexExtractId)[1];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                className: this.props.containerClassName ? this.props.containerClassName : "attachment-media flex-grow"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $5b2aaa3e3aa41ef7$export$2e2bcd8739ae039), {
                video_id: idString
            }));
        } else return null;
    }
}
$c0ad353fe5b45e03$export$2e2bcd8739ae039.propTypes = {
    video: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).object.isRequired,
    containerClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string
};



var $6wXVr = parcelRequire("6wXVr");
class $fc0b0a5053906ff1$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    render() {
        const fileName = this.props.fileName;
        const url = this.props.file.src;
        return fileName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: this.props.containerClassName ? this.props.containerClassName : "attachment-media"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: url,
            target: "_blank",
            rel: "noopener noreferrer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fab fa-fw fa-google-drive me-0_25",
            "aria-hidden": "true"
        }), fileName)) : null;
    }
}


var $a783ecc6f0cf5b99$exports = {};
'use strict';
Object.defineProperty($a783ecc6f0cf5b99$exports, "__esModule", {
    value: true
});
var $1b94a8eb2566f866$exports = {};
'use strict';
Object.defineProperty($1b94a8eb2566f866$exports, "__esModule", {
    value: true
});
var $1b94a8eb2566f866$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $6wXVr = parcelRequire("6wXVr");
var $1b94a8eb2566f866$var$React = $1b94a8eb2566f866$var$_interopRequireWildcard($6wXVr);
var $6762c072bedada23$exports = {};
'use strict';
Object.defineProperty($6762c072bedada23$exports, "__esModule", {
    value: true
});

var $6wXVr = parcelRequire("6wXVr");
var $6762c072bedada23$var$React = $6762c072bedada23$var$_interopRequireWildcard($6wXVr);
function $6762c072bedada23$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
$6762c072bedada23$exports.default = function(decoratedHref, decoratedText, key) {
    return $6762c072bedada23$var$React.createElement('a', {
        href: decoratedHref,
        key: key
    }, decoratedText);
};


var $1b94a8eb2566f866$var$_defaultComponentDecorator2 = $1b94a8eb2566f866$var$_interopRequireDefault($6762c072bedada23$exports);
var $bb74a5411764e109$exports = {};
"use strict";
Object.defineProperty($bb74a5411764e109$exports, "__esModule", {
    value: true
});
$bb74a5411764e109$exports.default = function(href) {
    return href;
};


var $1b94a8eb2566f866$var$_defaultHrefDecorator2 = $1b94a8eb2566f866$var$_interopRequireDefault($bb74a5411764e109$exports);
var $0baf830180ba2086$exports = {};
'use strict';
Object.defineProperty($0baf830180ba2086$exports, "__esModule", {
    value: true
});
var $d016293f2845a102$exports = {};
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $d016293f2845a102$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $d016293f2845a102$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $d016293f2845a102$var$isString(obj) {
    return $d016293f2845a102$var$_class(obj) === '[object String]';
}
function $d016293f2845a102$var$isObject(obj) {
    return $d016293f2845a102$var$_class(obj) === '[object Object]';
}
function $d016293f2845a102$var$isRegExp(obj) {
    return $d016293f2845a102$var$_class(obj) === '[object RegExp]';
}
function $d016293f2845a102$var$isFunction(obj) {
    return $d016293f2845a102$var$_class(obj) === '[object Function]';
}
function $d016293f2845a102$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $d016293f2845a102$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $d016293f2845a102$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $d016293f2845a102$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $d016293f2845a102$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $d016293f2845a102$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $d016293f2845a102$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $d016293f2845a102$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $d016293f2845a102$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $d016293f2845a102$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $d016293f2845a102$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("djpOD"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($d016293f2845a102$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($d016293f2845a102$var$isObject(val)) {
            if ($d016293f2845a102$var$isRegExp(val.validate)) compiled.validate = $d016293f2845a102$var$createValidator(val.validate);
            else if ($d016293f2845a102$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($d016293f2845a102$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $d016293f2845a102$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($d016293f2845a102$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $d016293f2845a102$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($d016293f2845a102$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $d016293f2845a102$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $d016293f2845a102$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $d016293f2845a102$var$createMatch(self, shift) {
    var match = new $d016293f2845a102$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $d016293f2845a102$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $d016293f2845a102$var$LinkifyIt)) return new $d016293f2845a102$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($d016293f2845a102$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $d016293f2845a102$var$assign({}, $d016293f2845a102$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $d016293f2845a102$var$assign({}, $d016293f2845a102$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $d016293f2845a102$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $d016293f2845a102$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $d016293f2845a102$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $d016293f2845a102$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $d016293f2845a102$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $d016293f2845a102$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $d016293f2845a102$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $d016293f2845a102$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $d016293f2845a102$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $d016293f2845a102$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($d016293f2845a102$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($d016293f2845a102$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $d016293f2845a102$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $d016293f2845a102$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $d016293f2845a102$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $d016293f2845a102$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $d016293f2845a102$var$LinkifyIt.prototype.onCompile = function onCompile() {};
$d016293f2845a102$exports = $d016293f2845a102$var$LinkifyIt;


var $0baf830180ba2086$var$_linkifyIt2 = $0baf830180ba2086$var$_interopRequireDefault($d016293f2845a102$exports);
var $ab2b695499141a08$exports = {};
$ab2b695499141a08$exports = JSON.parse('["aaa","aarp","abb","abbott","abbvie","abc","able","abogado","abudhabi","ac","academy","accenture","accountant","accountants","aco","actor","ad","ads","adult","ae","aeg","aero","aetna","af","afl","africa","ag","agakhan","agency","ai","aig","airbus","airforce","airtel","akdn","al","alibaba","alipay","allfinanz","allstate","ally","alsace","alstom","am","amazon","americanexpress","americanfamily","amex","amfam","amica","amsterdam","analytics","android","anquan","anz","ao","aol","apartments","app","apple","aq","aquarelle","ar","arab","aramco","archi","army","arpa","art","arte","as","asda","asia","associates","at","athleta","attorney","au","auction","audi","audible","audio","auspost","author","auto","autos","aw","aws","ax","axa","az","azure","ba","baby","baidu","banamex","band","bank","bar","barcelona","barclaycard","barclays","barefoot","bargains","baseball","basketball","bauhaus","bayern","bb","bbc","bbt","bbva","bcg","bcn","bd","be","beats","beauty","beer","berlin","best","bestbuy","bet","bf","bg","bh","bharti","bi","bible","bid","bike","bing","bingo","bio","biz","bj","black","blackfriday","blockbuster","blog","bloomberg","blue","bm","bms","bmw","bn","bnpparibas","bo","boats","boehringer","bofa","bom","bond","boo","book","booking","bosch","bostik","boston","bot","boutique","box","br","bradesco","bridgestone","broadway","broker","brother","brussels","bs","bt","build","builders","business","buy","buzz","bv","bw","by","bz","bzh","ca","cab","cafe","cal","call","calvinklein","cam","camera","camp","canon","capetown","capital","capitalone","car","caravan","cards","care","career","careers","cars","casa","case","cash","casino","cat","catering","catholic","cba","cbn","cbre","cc","cd","center","ceo","cern","cf","cfa","cfd","cg","ch","chanel","channel","charity","chase","chat","cheap","chintai","christmas","chrome","church","ci","cipriani","circle","cisco","citadel","citi","citic","city","ck","cl","claims","cleaning","click","clinic","clinique","clothing","cloud","club","clubmed","cm","cn","co","coach","codes","coffee","college","cologne","com","commbank","community","company","compare","computer","comsec","condos","construction","consulting","contact","contractors","cooking","cool","coop","corsica","country","coupon","coupons","courses","cpa","cr","credit","creditcard","creditunion","cricket","crown","crs","cruise","cruises","cu","cuisinella","cv","cw","cx","cy","cymru","cyou","cz","dad","dance","data","date","dating","datsun","day","dclk","dds","de","deal","dealer","deals","degree","delivery","dell","deloitte","delta","democrat","dental","dentist","desi","design","dev","dhl","diamonds","diet","digital","direct","directory","discount","discover","dish","diy","dj","dk","dm","dnp","do","docs","doctor","dog","domains","dot","download","drive","dtv","dubai","dupont","durban","dvag","dvr","dz","earth","eat","ec","eco","edeka","edu","education","ee","eg","email","emerck","energy","engineer","engineering","enterprises","epson","equipment","er","ericsson","erni","es","esq","estate","et","eu","eurovision","eus","events","exchange","expert","exposed","express","extraspace","fage","fail","fairwinds","faith","family","fan","fans","farm","farmers","fashion","fast","fedex","feedback","ferrari","ferrero","fi","fidelity","fido","film","final","finance","financial","fire","firestone","firmdale","fish","fishing","fit","fitness","fj","fk","flickr","flights","flir","florist","flowers","fly","fm","fo","foo","food","football","ford","forex","forsale","forum","foundation","fox","fr","free","fresenius","frl","frogans","frontier","ftr","fujitsu","fun","fund","furniture","futbol","fyi","ga","gal","gallery","gallo","gallup","game","games","gap","garden","gay","gb","gbiz","gd","gdn","ge","gea","gent","genting","george","gf","gg","ggee","gh","gi","gift","gifts","gives","giving","gl","glass","gle","global","globo","gm","gmail","gmbh","gmo","gmx","gn","godaddy","gold","goldpoint","golf","goo","goodyear","goog","google","gop","got","gov","gp","gq","gr","grainger","graphics","gratis","green","gripe","grocery","group","gs","gt","gu","gucci","guge","guide","guitars","guru","gw","gy","hair","hamburg","hangout","haus","hbo","hdfc","hdfcbank","health","healthcare","help","helsinki","here","hermes","hiphop","hisamitsu","hitachi","hiv","hk","hkt","hm","hn","hockey","holdings","holiday","homedepot","homegoods","homes","homesense","honda","horse","hospital","host","hosting","hot","hotels","hotmail","house","how","hr","hsbc","ht","hu","hughes","hyatt","hyundai","ibm","icbc","ice","icu","id","ie","ieee","ifm","ikano","il","im","imamat","imdb","immo","immobilien","in","inc","industries","infiniti","info","ing","ink","institute","insurance","insure","int","international","intuit","investments","io","ipiranga","iq","ir","irish","is","ismaili","ist","istanbul","it","itau","itv","jaguar","java","jcb","je","jeep","jetzt","jewelry","jio","jll","jm","jmp","jnj","jo","jobs","joburg","jot","joy","jp","jpmorgan","jprs","juegos","juniper","kaufen","kddi","ke","kerryhotels","kerryproperties","kfh","kg","kh","ki","kia","kids","kim","kindle","kitchen","kiwi","km","kn","koeln","komatsu","kosher","kp","kpmg","kpn","kr","krd","kred","kuokgroup","kw","ky","kyoto","kz","la","lacaixa","lamborghini","lamer","land","landrover","lanxess","lasalle","lat","latino","latrobe","law","lawyer","lb","lc","lds","lease","leclerc","lefrak","legal","lego","lexus","lgbt","li","lidl","life","lifeinsurance","lifestyle","lighting","like","lilly","limited","limo","lincoln","link","live","living","lk","llc","llp","loan","loans","locker","locus","lol","london","lotte","lotto","love","lpl","lplfinancial","lr","ls","lt","ltd","ltda","lu","lundbeck","luxe","luxury","lv","ly","ma","madrid","maif","maison","makeup","man","management","mango","map","market","marketing","markets","marriott","marshalls","mattel","mba","mc","mckinsey","md","me","med","media","meet","melbourne","meme","memorial","men","menu","merckmsd","mg","mh","miami","microsoft","mil","mini","mint","mit","mitsubishi","mk","ml","mlb","mls","mm","mma","mn","mo","mobi","mobile","moda","moe","moi","mom","monash","money","monster","mormon","mortgage","moscow","moto","motorcycles","mov","movie","mp","mq","mr","ms","msd","mt","mtn","mtr","mu","museum","music","mv","mw","mx","my","mz","na","nab","nagoya","name","navy","nba","nc","ne","nec","net","netbank","netflix","network","neustar","new","news","next","nextdirect","nexus","nf","nfl","ng","ngo","nhk","ni","nico","nike","nikon","ninja","nissan","nissay","nl","no","nokia","norton","now","nowruz","nowtv","np","nr","nra","nrw","ntt","nu","nyc","nz","obi","observer","office","okinawa","olayan","olayangroup","ollo","om","omega","one","ong","onl","online","ooo","open","oracle","orange","org","organic","origins","osaka","otsuka","ott","ovh","pa","page","panasonic","paris","pars","partners","parts","party","pay","pccw","pe","pet","pf","pfizer","pg","ph","pharmacy","phd","philips","phone","photo","photography","photos","physio","pics","pictet","pictures","pid","pin","ping","pink","pioneer","pizza","pk","pl","place","play","playstation","plumbing","plus","pm","pn","pnc","pohl","poker","politie","porn","post","pr","praxi","press","prime","pro","prod","productions","prof","progressive","promo","properties","property","protection","pru","prudential","ps","pt","pub","pw","pwc","py","qa","qpon","quebec","quest","racing","radio","re","read","realestate","realtor","realty","recipes","red","redumbrella","rehab","reise","reisen","reit","reliance","ren","rent","rentals","repair","report","republican","rest","restaurant","review","reviews","rexroth","rich","richardli","ricoh","ril","rio","rip","ro","rocks","rodeo","rogers","room","rs","rsvp","ru","rugby","ruhr","run","rw","rwe","ryukyu","sa","saarland","safe","safety","sakura","sale","salon","samsclub","samsung","sandvik","sandvikcoromant","sanofi","sap","sarl","sas","save","saxo","sb","sbi","sbs","sc","scb","schaeffler","schmidt","scholarships","school","schule","schwarz","science","scot","sd","se","search","seat","secure","security","seek","select","sener","services","seven","sew","sex","sexy","sfr","sg","sh","shangrila","sharp","shell","shia","shiksha","shoes","shop","shopping","shouji","show","si","silk","sina","singles","site","sj","sk","ski","skin","sky","skype","sl","sling","sm","smart","smile","sn","sncf","so","soccer","social","softbank","software","sohu","solar","solutions","song","sony","soy","spa","space","sport","spot","sr","srl","ss","st","stada","staples","star","statebank","statefarm","stc","stcgroup","stockholm","storage","store","stream","studio","study","style","su","sucks","supplies","supply","support","surf","surgery","suzuki","sv","swatch","swiss","sx","sy","sydney","systems","sz","tab","taipei","talk","taobao","target","tatamotors","tatar","tattoo","tax","taxi","tc","tci","td","tdk","team","tech","technology","tel","temasek","tennis","teva","tf","tg","th","thd","theater","theatre","tiaa","tickets","tienda","tips","tires","tirol","tj","tjmaxx","tjx","tk","tkmaxx","tl","tm","tmall","tn","to","today","tokyo","tools","top","toray","toshiba","total","tours","town","toyota","toys","tr","trade","trading","training","travel","travelers","travelersinsurance","trust","trv","tt","tube","tui","tunes","tushu","tv","tvs","tw","tz","ua","ubank","ubs","ug","uk","unicom","university","uno","uol","ups","us","uy","uz","va","vacations","vana","vanguard","vc","ve","vegas","ventures","verisign","verm\xf6gensberater","verm\xf6gensberatung","versicherung","vet","vg","vi","viajes","video","vig","viking","villas","vin","vip","virgin","visa","vision","viva","vivo","vlaanderen","vn","vodka","volvo","vote","voting","voto","voyage","vu","wales","walmart","walter","wang","wanggou","watch","watches","weather","weatherchannel","webcam","weber","website","wed","wedding","weibo","weir","wf","whoswho","wien","wiki","williamhill","win","windows","wine","winners","wme","wolterskluwer","woodside","work","works","world","wow","ws","wtc","wtf","xbox","xerox","xihuan","xin","xxx","xyz","yachts","yahoo","yamaxun","yandex","ye","yodobashi","yoga","yokohama","you","youtube","yt","yun","za","zappos","zara","zero","zip","zm","zone","zuerich","zw","\u03B5\u03BB","\u03B5\u03C5","\u0431\u0433","\u0431\u0435\u043B","\u0434\u0435\u0442\u0438","\u0435\u044E","\u043A\u0430\u0442\u043E\u043B\u0438\u043A","\u043A\u043E\u043C","\u043C\u043A\u0434","\u043C\u043E\u043D","\u043C\u043E\u0441\u043A\u0432\u0430","\u043E\u043D\u043B\u0430\u0439\u043D","\u043E\u0440\u0433","\u0440\u0443\u0441","\u0440\u0444","\u0441\u0430\u0439\u0442","\u0441\u0440\u0431","\u0443\u043A\u0440","\u049B\u0430\u0437","\u0570\u0561\u0575","\u05D9\u05E9\u05E8\u05D0\u05DC","\u05E7\u05D5\u05DD","\u0627\u0628\u0648\u0638\u0628\u064A","\u0627\u0631\u0627\u0645\u0643\u0648","\u0627\u0644\u0627\u0631\u062F\u0646","\u0627\u0644\u0628\u062D\u0631\u064A\u0646","\u0627\u0644\u062C\u0632\u0627\u0626\u0631","\u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629","\u0627\u0644\u0639\u0644\u064A\u0627\u0646","\u0627\u0644\u0645\u063A\u0631\u0628","\u0627\u0645\u0627\u0631\u0627\u062A","\u0627\u06CC\u0631\u0627\u0646","\u0628\u0627\u0631\u062A","\u0628\u0627\u0632\u0627\u0631","\u0628\u064A\u062A\u0643","\u0628\u06BE\u0627\u0631\u062A","\u062A\u0648\u0646\u0633","\u0633\u0648\u062F\u0627\u0646","\u0633\u0648\u0631\u064A\u0629","\u0634\u0628\u0643\u0629","\u0639\u0631\u0627\u0642","\u0639\u0631\u0628","\u0639\u0645\u0627\u0646","\u0641\u0644\u0633\u0637\u064A\u0646","\u0642\u0637\u0631","\u0643\u0627\u062B\u0648\u0644\u064A\u0643","\u0643\u0648\u0645","\u0645\u0635\u0631","\u0645\u0644\u064A\u0633\u064A\u0627","\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627","\u0645\u0648\u0642\u0639","\u0647\u0645\u0631\u0627\u0647","\u067E\u0627\u06A9\u0633\u062A\u0627\u0646","\u0680\u0627\u0631\u062A","\u0915\u0949\u092E","\u0928\u0947\u091F","\u092D\u093E\u0930\u0924","\u092D\u093E\u0930\u0924\u092E\u094D","\u092D\u093E\u0930\u094B\u0924","\u0938\u0902\u0917\u0920\u0928","\u09AC\u09BE\u0982\u09B2\u09BE","\u09AD\u09BE\u09B0\u09A4","\u09AD\u09BE\u09F0\u09A4","\u0A2D\u0A3E\u0A30\u0A24","\u0AAD\u0ABE\u0AB0\u0AA4","\u0B2D\u0B3E\u0B30\u0B24","\u0B87\u0BA8\u0BCD\u0BA4\u0BBF\u0BAF\u0BBE","\u0B87\u0BB2\u0B99\u0BCD\u0B95\u0BC8","\u0B9A\u0BBF\u0B99\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0BC2\u0BB0\u0BCD","\u0C2D\u0C3E\u0C30\u0C24\u0C4D","\u0CAD\u0CBE\u0CB0\u0CA4","\u0D2D\u0D3E\u0D30\u0D24\u0D02","\u0DBD\u0D82\u0D9A\u0DCF","\u0E04\u0E2D\u0E21","\u0E44\u0E17\u0E22","\u0EA5\u0EB2\u0EA7","\u10D2\u10D4","\u307F\u3093\u306A","\u30A2\u30DE\u30BE\u30F3","\u30AF\u30E9\u30A6\u30C9","\u30B0\u30FC\u30B0\u30EB","\u30B3\u30E0","\u30B9\u30C8\u30A2","\u30BB\u30FC\u30EB","\u30D5\u30A1\u30C3\u30B7\u30E7\u30F3","\u30DD\u30A4\u30F3\u30C8","\u4E16\u754C","\u4E2D\u4FE1","\u4E2D\u56FD","\u4E2D\u570B","\u4E2D\u6587\u7F51","\u4E9A\u9A6C\u900A","\u4F01\u4E1A","\u4F5B\u5C71","\u4FE1\u606F","\u5065\u5EB7","\u516B\u5366","\u516C\u53F8","\u516C\u76CA","\u53F0\u6E7E","\u53F0\u7063","\u5546\u57CE","\u5546\u5E97","\u5546\u6807","\u5609\u91CC","\u5609\u91CC\u5927\u9152\u5E97","\u5728\u7EBF","\u5927\u62FF","\u5929\u4E3B\u6559","\u5A31\u4E50","\u5BB6\u96FB","\u5E7F\u4E1C","\u5FAE\u535A","\u6148\u5584","\u6211\u7231\u4F60","\u624B\u673A","\u62DB\u8058","\u653F\u52A1","\u653F\u5E9C","\u65B0\u52A0\u5761","\u65B0\u95FB","\u65F6\u5C1A","\u66F8\u7C4D","\u673A\u6784","\u6DE1\u9A6C\u9521","\u6E38\u620F","\u6FB3\u9580","\u70B9\u770B","\u79FB\u52A8","\u7EC4\u7EC7\u673A\u6784","\u7F51\u5740","\u7F51\u5E97","\u7F51\u7AD9","\u7F51\u7EDC","\u8054\u901A","\u8C37\u6B4C","\u8D2D\u7269","\u901A\u8CA9","\u96C6\u56E2","\u96FB\u8A0A\u76C8\u79D1","\u98DE\u5229\u6D66","\u98DF\u54C1","\u9910\u5385","\u9999\u683C\u91CC\u62C9","\u9999\u6E2F","\uB2F7\uB137","\uB2F7\uCEF4","\uC0BC\uC131","\uD55C\uAD6D"]');


var $0baf830180ba2086$var$_tlds2 = $0baf830180ba2086$var$_interopRequireDefault($ab2b695499141a08$exports);
function $0baf830180ba2086$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0baf830180ba2086$var$linkify = new $0baf830180ba2086$var$_linkifyIt2.default();
$0baf830180ba2086$var$linkify.tlds($0baf830180ba2086$var$_tlds2.default);
$0baf830180ba2086$exports.default = function(text) {
    return $0baf830180ba2086$var$linkify.match(text);
};


var $1b94a8eb2566f866$var$_defaultMatchDecorator2 = $1b94a8eb2566f866$var$_interopRequireDefault($0baf830180ba2086$exports);
var $1bd13ad8cd9db4c4$exports = {};
"use strict";
Object.defineProperty($1bd13ad8cd9db4c4$exports, "__esModule", {
    value: true
});
$1bd13ad8cd9db4c4$exports.default = function(text) {
    return text;
};


var $1b94a8eb2566f866$var$_defaultTextDecorator2 = $1b94a8eb2566f866$var$_interopRequireDefault($1bd13ad8cd9db4c4$exports);
function $1b94a8eb2566f866$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1b94a8eb2566f866$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $1b94a8eb2566f866$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1b94a8eb2566f866$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $1b94a8eb2566f866$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $1b94a8eb2566f866$var$Linkify = function(_React$Component) {
    $1b94a8eb2566f866$var$_inherits(Linkify, _React$Component);
    function Linkify() {
        $1b94a8eb2566f866$var$_classCallCheck(this, Linkify);
        return $1b94a8eb2566f866$var$_possibleConstructorReturn(this, (Linkify.__proto__ || Object.getPrototypeOf(Linkify)).apply(this, arguments));
    }
    $1b94a8eb2566f866$var$_createClass(Linkify, [
        {
            key: 'parseString',
            value: function parseString(string) {
                var _this2 = this;
                if (string === '') return string;
                var matches = this.props.matchDecorator(string);
                if (!matches) return string;
                var elements = [];
                var lastIndex = 0;
                matches.forEach(function(match, i) {
                    // Push preceding text if there is any
                    if (match.index > lastIndex) elements.push(string.substring(lastIndex, match.index));
                    var decoratedHref = _this2.props.hrefDecorator(match.url);
                    var decoratedText = _this2.props.textDecorator(match.text);
                    var decoratedComponent = _this2.props.componentDecorator(decoratedHref, decoratedText, i);
                    elements.push(decoratedComponent);
                    lastIndex = match.lastIndex;
                });
                // Push remaining text if there is any
                if (string.length > lastIndex) elements.push(string.substring(lastIndex));
                return elements.length === 1 ? elements[0] : elements;
            }
        },
        {
            key: 'parse',
            value: function parse(children) {
                var _this3 = this;
                var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                if (typeof children === 'string') return this.parseString(children);
                else if ($1b94a8eb2566f866$var$React.isValidElement(children) && children.type !== 'a' && children.type !== 'button') return $1b94a8eb2566f866$var$React.cloneElement(children, {
                    key: key
                }, this.parse(children.props.children));
                else if (Array.isArray(children)) return children.map(function(child, i) {
                    return _this3.parse(child, i);
                });
                return children;
            }
        },
        {
            key: 'render',
            value: function render() {
                return $1b94a8eb2566f866$var$React.createElement($1b94a8eb2566f866$var$React.Fragment, null, this.parse(this.props.children));
            }
        }
    ]);
    return Linkify;
}($1b94a8eb2566f866$var$React.Component);
$1b94a8eb2566f866$var$Linkify.defaultProps = {
    componentDecorator: $1b94a8eb2566f866$var$_defaultComponentDecorator2.default,
    hrefDecorator: $1b94a8eb2566f866$var$_defaultHrefDecorator2.default,
    matchDecorator: $1b94a8eb2566f866$var$_defaultMatchDecorator2.default,
    textDecorator: $1b94a8eb2566f866$var$_defaultTextDecorator2.default
};
$1b94a8eb2566f866$exports.default = $1b94a8eb2566f866$var$Linkify;


var $a783ecc6f0cf5b99$var$_Linkify2 = $a783ecc6f0cf5b99$var$_interopRequireDefault($1b94a8eb2566f866$exports);
function $a783ecc6f0cf5b99$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$a783ecc6f0cf5b99$exports.default = $a783ecc6f0cf5b99$var$_Linkify2.default;


class $b9bd18905366e6a9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.getRef = this.getRef.bind(this);
        this.dbRef = null;
        this.headless = null;
        this.state = {
            text: null,
            fileName: null
        };
    }
    render() {
        let cn = this.props.className;
        let txt = this.state.text;
        let isVideo = false;
        if (txt !== null) isVideo = txt.includes("youtube.com/embed");
        let isFileAttack = false;
        if (this.state.fileName !== null && this.state.fileName !== "") isFileAttack = true;
        let mediaObj = {
            src: this.state.text
        };
        return this.props.identifier.includes('/image') ? this.state.text ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, isFileAttack ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc0b0a5053906ff1$export$2e2bcd8739ae039), {
            containerClassName: "col",
            file: mediaObj,
            fileName: this.state.fileName
        }) : isVideo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $c0ad353fe5b45e03$export$2e2bcd8739ae039), {
            containerClassName: "col",
            video: mediaObj
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: this.props.className
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            className: "img-fluid",
            src: this.state.text,
            alt: ""
        }))) : null : cn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: cn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a783ecc6f0cf5b99$exports))), null, txt), this.props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a783ecc6f0cf5b99$exports))), null, txt), this.props.children);
    }
    componentDidMount() {
        this.dbRef = this.getRef(this.props.identifier);
        if (this.props.identifier.includes("/image")) {
            this.dbRef.once("value").then((data)=>{
                const dataVal = data.val();
                if (this.state.text !== dataVal) this.setState({
                    text: dataVal
                });
            });
            this.callback = this.dbRef.on('value', (data)=>{
                const dataVal = data.val();
                if (this.state.text !== dataVal) this.setState({
                    text: dataVal
                });
            });
            let fileNamePath = this.props.identifier.replace("/image", "/fileName");
            this.fileNameRef = this.getRef(fileNamePath);
            this.fileNameRef.once("value").then((data)=>{
                const dataVal = data.val();
                if (this.state.fileName !== dataVal) this.setState({
                    fileName: dataVal
                });
            });
            this.callbackFileName = this.fileNameRef.on('value', (data)=>{
                const dataVal = data.val();
                if (this.state.fileName !== dataVal) this.setState({
                    fileName: dataVal
                });
            });
        } else this.callback = this.dbRef.on('value', ()=>{
            if (null === this.headless) this.headless = new window.Firepad.Headless(this.dbRef);
            this.headless.getText((text)=>{
                if (this.state.text !== text) this.setState({
                    text: text.trim()
                });
            });
        });
    }
    componentWillUnmount() {
        if (this.headless) {
            this.headless.dispose();
            this.headless = null;
        }
        if (this.callback) {
            this.dbRef.off('value', this.callback);
            this.callback = null;
        }
        if (this.callbackFileName) {
            this.fileNameRef.off('value', this.callbackFileName);
            this.callbackFileName = null;
        }
    }
    getRef(identifier) {
        let path = this.context.fileType + "/" + this.context.fileId + "/" + identifier;
        return window.firebase.database().ref(path);
    }
}




var $6wXVr = parcelRequire("6wXVr");

var $6wXVr = parcelRequire("6wXVr");


function $e1cee4d396a9c536$export$2e2bcd8739ae039(props) {
    const src = props.image.src && props.image.src.startsWith('/img') ? (0, $540ee614c8ab8fe3$export$46abdfa6346e2c9b) + props.image.src : props.image.src;
    return props.image.src ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: props.containerClassName ? props.containerClassName : "attachment-media"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
        className: "img-fluid",
        src: src,
        alt: props.image.alt
    })) : null;
}
$e1cee4d396a9c536$export$2e2bcd8739ae039.propTypes = {
    image: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).object.isRequired
};





var $6wXVr = parcelRequire("6wXVr");



class $56e0ce693a0f3e79$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    constructor(props){
        super(props);
        this.buttonId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.state = {
            value: ''
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    componentWillMount() {
        this.buttonId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.modalId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
    }
    handleChange(event) {
        this.setState({
            value: event.target.src
        });
    }
    handleSubmit(event) {
        event.preventDefault();
        this.setState({
            value: event.target.src
        });
        this.props.removeMethod();
        (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#' + this.buttonId).CFW_Modal('hide');
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "attachment-action"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            id: this.buttonId,
            type: "button",
            className: "btn btn-icon btn-link",
            title: "Remove media",
            onClick: this.props.removeMethod
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-trash-alt",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Remove media")));
    }
}
$56e0ce693a0f3e79$export$2e2bcd8739ae039.propTypes = {
    removeMethod: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).func.isRequired
};



var $6wXVr = parcelRequire("6wXVr");



var $6wXVr = parcelRequire("6wXVr");






var $3UKyI = parcelRequire("3UKyI");
class $a802362149caebe3$export$2e2bcd8739ae039 extends (0, $d8775d5311bbf499$export$2e2bcd8739ae039) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.picked = this.picked.bind(this);
        this.img = {
            src: "",
            id: "",
            alt: ""
        }; // TODO: store and use id and alt
    }
    picked(data) {
        if ('picked' === data.action) {
            if (data.docs[0].type === "photo") {
                this.img = data.docs[0];
                const alt = data.docs[0].description;
                if (!(0, $21f9ebdc444decaf$export$6e22c362a0406a2c)(alt)) this.img.alt = alt;
                else this.img.alt = "no image description :(";
                this.img.id = data.docs[0].id; // needed for download
                //this.img.name = data.docs[0].name; // needed for upload
                //this.image.mimeType = data.docs[0].mimeType; // needed for upload
                // this.img.src = "https://drive.google.com/a/domain.com/thumbnail?id="+this.img.id; //+"&sz=w320-h240";
                this.img.src = "https://drive.google.com/uc?export=view&id=" + this.img.id;
            } else console.warn('picker returned ' + data.docs[0].type);
            console.log("picker selected " + $3UKyI.inspect(this.img));
            // this.context.router.history.push(docId);
            // what if src null?
            if (this.img.id) {
                let sizeBytes = this.img.sizeBytes;
                let sizeMB = sizeBytes / 1024 / 1024;
                if (sizeMB < 50) this.props.saveMethod(this.img);
                else console.log("Image too big");
            }
        }
    // return this.img.id? this.props.saveMethod(this.img): null;
    }
    render() {
        // let doc = this.context;
        let clientId = (0, $220c2d58964ba595$export$fcc0626890c55730) ? (0, $220c2d58964ba595$export$fcc0626890c55730).clientId : '42';
        let apiKey = (0, $220c2d58964ba595$export$fcc0626890c55730) ? (0, $220c2d58964ba595$export$fcc0626890c55730).apiKey : '42';
        // let scopes = firebaseConfig ? firebaseConfig.scopes : [];
        let scopes = [
            'https://www.googleapis.com/auth/drive.readonly'
        ];
        //let oauthToken = this.context.currentUser.getAuthResponse().id_token;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($33d51a3862e796d0$exports))), {
            id: "picker",
            clientId: clientId,
            createPicker: (google, oauthToken)=>{
                const apiKey = (0, $220c2d58964ba595$export$fcc0626890c55730) ? (0, $220c2d58964ba595$export$fcc0626890c55730).apiKey : '42';
                const mimeTypes = "image/png, image/jpeg, image/gif";
                const docsView = new google.picker.DocsView(google.picker.ViewId.DOCS_IMAGES).setParent('root').setIncludeFolders(true).setMimeTypes(mimeTypes).setMode(google.picker.DocsViewMode.GRID);
                const image_for = this.props.identifier ? ' for ' + this.props.identifier : "";
                const picker = new window.google.picker.PickerBuilder().setSelectableMimeTypes(mimeTypes).setTitle('Select an image' + image_for).addView(docsView).setOAuthToken(oauthToken).setDeveloperKey(apiKey).setCallback(this.picked);
                /*
                              if (doc.parentFolderId) {
                                  docsView.setParent(doc.parentFolderId);
                                  docsView.setSelectFolderEnabled(true);
                              }
                              */ picker.build().setVisible(true);
            },
            developerKey: apiKey,
            scope: scopes,
            onChange: (data)=>this.picked(data),
            onAuthenticate: (token)=>this.context.checkAccessTokenBeforeInitGooglePicker(token),
            onAuthFailed: (data)=>console.log('picker auth failed:', data),
            multiselect: false,
            navHidden: false,
            authImmediate: false
        }, this.props.children);
    }
}



var $6wXVr = parcelRequire("6wXVr");




class $b9a61e383f054a92$export$2e2bcd8739ae039 extends (0, $d8775d5311bbf499$export$2e2bcd8739ae039) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.picked = this.picked.bind(this);
        this.file = {
            src: "",
            id: "",
            name: ""
        };
    }
    picked(data) {
        if ('picked' === data.action) {
            console.log(data);
            this.file.name = data.docs[0].name;
            this.file.id = data.docs[0].id;
            this.file.src = data.docs[0].url;
            if (this.file.id) this.props.saveMethod(this.file);
        }
    }
    render() {
        let clientId = (0, $220c2d58964ba595$export$fcc0626890c55730) ? (0, $220c2d58964ba595$export$fcc0626890c55730).clientId : '42';
        let apiKey = (0, $220c2d58964ba595$export$fcc0626890c55730) ? (0, $220c2d58964ba595$export$fcc0626890c55730).apiKey : '42';
        let scopes = (0, $220c2d58964ba595$export$fcc0626890c55730) ? (0, $220c2d58964ba595$export$fcc0626890c55730).scopes : [];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($33d51a3862e796d0$exports))), {
            id: "picker",
            clientId: clientId,
            developerKey: apiKey,
            scope: scopes,
            onChange: (data)=>this.picked(data),
            onAuthFailed: (data)=>console.log('on auth failed:', data),
            onAuthenticate: (token)=>this.context.checkAccessTokenBeforeInitGooglePicker(token),
            multiselect: false,
            authImmediate: false,
            mimeTypes: [],
            viewId: 'DOCS'
        }, this.props.children);
    }
}





const $dd5e776bec3d0164$var$noImage = {
    src: '',
    alt: ''
};
const $dd5e776bec3d0164$var$maxMB = 50;
const $dd5e776bec3d0164$var$maxResolution = 25; //megapixels
class $dd5e776bec3d0164$export$2e2bcd8739ae039 extends (0, $33c53f2912681500$export$2e2bcd8739ae039) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.state = {
            image: $dd5e776bec3d0164$var$noImage
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.process = this.process.bind(this);
        this.handleSaveVideo = this.handleSaveVideo.bind(this);
        this.alt = this.alt.bind(this);
        this.child = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createRef();
    }
    componentWillMount() {
        this.addImageButtonId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.menuId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.uploadImageInputId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.addImageSearchButtonId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.addImageUrlButtonId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.addImgUrlInputId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.addYouTubeUrlButtonId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
    }
    handleSubmit(event) {
        // only image Enter URL
        event.preventDefault();
        let target = event.target;
        if (undefined === target.src && target[0]) target = event.target[0];
        this.process(target);
    }
    alt(image) {
        if (image.alt) return image.alt;
        let alt = image.description;
        if ((0, $21f9ebdc444decaf$export$6e22c362a0406a2c)(alt)) alt = "no image description :(";
        return alt;
    }
    process(target) {
        let image = target.src;
        if ("" === image && undefined !== target.files) {
            // image file upload
            image = target.files[0];
            image.src = URL.createObjectURL(image);
            image.mimeType = image.type;
            image.alt = this.alt(image);
        }
        let mImage = new Image();
        mImage.src = image.src;
        let self = this;
        mImage.onload = function() {
            let resolution = mImage.width * mImage.height / 1000000;
            let fileSize = image.size / 1024 / 1024;
            if (fileSize < $dd5e776bec3d0164$var$maxMB && resolution < $dd5e776bec3d0164$var$maxResolution) self.props.saveMethod(image);
            else console.log("Image size too big");
        };
    }
    handleSaveVideo(url) {
        console.log('handleSaveVideo', url, this.props.saveMethod);
        this.props.saveMethod(url);
        window.tracker.trackEvent("Content", "add video", url);
    }
    render() {
        const saveUpload = this.handleSubmit;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "dropdown"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            id: this.addImageButtonId,
            type: "button",
            className: "btn btn-primary",
            "data-cfw": "dropdown",
            onSubmit: (e)=>this.handleSubmit(e)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-plus text-primary me-0_25",
            "aria-hidden": "true"
        }), "Add Media"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", {
            id: this.menuId,
            className: "dropdown-menu"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "# "
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-image text-primary me-0_25",
            "aria-hidden": "true"
        }), " Add image"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("input", {
            id: this.uploadImageInputId,
            type: "file",
            accept: "image/gif,image/jpeg,image/png",
            name: "myFile",
            className: "form-file-dropdown",
            onChange: (event)=>{
                saveUpload(event);
            },
            onClick: (event)=>{
                event.target.value = null;
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            className: "dropdown-item",
            onClick: ()=>{
                document.getElementById(this.uploadImageInputId).click();
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-fw fa-upload me-0_25",
            "aria-hidden": "true"
        }), "Upload from device")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            id: this.addImageSearchButtonId,
            type: "button",
            className: "dropdown-item",
            onClick: (e)=>{
                this.context.openSearchWebModal(this.addImageSearchButtonId, this.props.saveMethod);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-fw fa-search me-0_25",
            "aria-hidden": "true"
        }), "Search the web")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            id: this.addImageUrlButtonId,
            type: "button",
            className: "dropdown-item",
            onClick: (e)=>{
                this.context.openEnterURLModal(this.addImageUrlButtonId, this.props.saveMethod);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-fw fa-link me-0_25",
            "aria-hidden": "true"
        }), "Enter a URL")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a802362149caebe3$export$2e2bcd8739ae039), {
            saveMethod: this.props.saveMethod
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "dropdown-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fab fa-fw fa-google-drive me-0_25",
            "aria-hidden": "true"
        }), "Insert from Drive"))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            id: this.addYouTubeUrlButtonId,
            type: "button",
            className: "dropdown-item",
            onClick: (e)=>{
                this.context.openYouTubeModal(this.addYouTubeUrlButtonId, this.handleSaveVideo);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fab fa-youtube me-0_25",
            "aria-hidden": "true"
        }), "Embed YouTube Video")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9a61e383f054a92$export$2e2bcd8739ae039), {
            saveMethod: this.props.saveFile
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "dropdown-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fab fa-fw fa-google-drive me-0_25",
            "aria-hidden": "true"
        }), "Link file from Drive"))))));
    }
}
$dd5e776bec3d0164$export$2e2bcd8739ae039.propTypes = {
    saveMethod: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).func.isRequired
};



var $6wXVr = parcelRequire("6wXVr");


const $4d4f206cc2e474fe$export$136d1ce139fe0e5d = '/';
function $4d4f206cc2e474fe$export$f7e2c8231c57a8bd(parent, child) {
    return [
        parent,
        child
    ].join($4d4f206cc2e474fe$export$136d1ce139fe0e5d);
}
function $4d4f206cc2e474fe$export$2e2bcd8739ae039(props) {
    const doc = (0, $6wXVr.useContext)((0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039));
    //const {id,setId} = useState(props.id);
    let path = null;
    if (doc.fileType && doc.fileId && props.identifier) {
        path = $4d4f206cc2e474fe$export$136d1ce139fe0e5d + $4d4f206cc2e474fe$export$f7e2c8231c57a8bd(doc.fileType, doc.fileId);
        return $4d4f206cc2e474fe$export$f7e2c8231c57a8bd(path, props.identifier);
    } else console.log("dataPath called with no context");
    return path;
}
function $4d4f206cc2e474fe$export$44082e4fe926f94a(identifier) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8a34fb1098450c8d$exports))).renderToString(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($4d4f206cc2e474fe$export$2e2bcd8739ae039, {
        identifier: identifier
    }));
}










/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Constants used in the Firebase Storage library.
 */ /**
 * Domain name for firebase storage.
 */ const $81ded97e27414374$var$DEFAULT_HOST = 'firebasestorage.googleapis.com';
/**
 * The key in Firebase config json for the storage bucket.
 */ const $81ded97e27414374$var$CONFIG_STORAGE_BUCKET_KEY = 'storageBucket';
/**
 * 2 minutes
 *
 * The timeout for all operations except upload.
 */ const $81ded97e27414374$var$DEFAULT_MAX_OPERATION_RETRY_TIME = 120000;
/**
 * 10 minutes
 *
 * The timeout for upload.
 */ const $81ded97e27414374$var$DEFAULT_MAX_UPLOAD_RETRY_TIME = 600000;
/**
 * 1 second
 */ const $81ded97e27414374$var$DEFAULT_MIN_SLEEP_TIME_MILLIS = 1000;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error returned by the Firebase Storage SDK.
 * @public
 */ class $81ded97e27414374$export$697502632950e9d3 extends (0, $3117f6f4eeb4c314$export$dd24e9cd51226c56) {
    /**
     * @param code - A `StorageErrorCode` string to be prefixed with 'storage/' and
     *  added to the end of the message.
     * @param message  - Error message.
     * @param status_ - Corresponding HTTP Status Code
     */ constructor(code, message, status_ = 0){
        super($81ded97e27414374$var$prependCode(code), `Firebase Storage: ${message} (${$81ded97e27414374$var$prependCode(code)})`);
        this.status_ = status_;
        /**
         * Stores custom error data unique to the `StorageError`.
         */ this.customData = {
            serverResponse: null
        };
        this._baseMessage = this.message;
        // Without this, `instanceof StorageError`, in tests for example,
        // returns false.
        Object.setPrototypeOf(this, $81ded97e27414374$export$697502632950e9d3.prototype);
    }
    get status() {
        return this.status_;
    }
    set status(status) {
        this.status_ = status;
    }
    /**
     * Compares a `StorageErrorCode` against this error's code, filtering out the prefix.
     */ _codeEquals(code) {
        return $81ded97e27414374$var$prependCode(code) === this.code;
    }
    /**
     * Optional response message that was added by the server.
     */ get serverResponse() {
        return this.customData.serverResponse;
    }
    set serverResponse(serverResponse) {
        this.customData.serverResponse = serverResponse;
        if (this.customData.serverResponse) this.message = `${this._baseMessage}\n${this.customData.serverResponse}`;
        else this.message = this._baseMessage;
    }
}
/**
 * @public
 * Error codes that can be attached to `StorageError` objects.
 */ var $81ded97e27414374$export$54592d666d6ce114;
(function(StorageErrorCode) {
    // Shared between all platforms
    StorageErrorCode["UNKNOWN"] = "unknown";
    StorageErrorCode["OBJECT_NOT_FOUND"] = "object-not-found";
    StorageErrorCode["BUCKET_NOT_FOUND"] = "bucket-not-found";
    StorageErrorCode["PROJECT_NOT_FOUND"] = "project-not-found";
    StorageErrorCode["QUOTA_EXCEEDED"] = "quota-exceeded";
    StorageErrorCode["UNAUTHENTICATED"] = "unauthenticated";
    StorageErrorCode["UNAUTHORIZED"] = "unauthorized";
    StorageErrorCode["UNAUTHORIZED_APP"] = "unauthorized-app";
    StorageErrorCode["RETRY_LIMIT_EXCEEDED"] = "retry-limit-exceeded";
    StorageErrorCode["INVALID_CHECKSUM"] = "invalid-checksum";
    StorageErrorCode["CANCELED"] = "canceled";
    // JS specific
    StorageErrorCode["INVALID_EVENT_NAME"] = "invalid-event-name";
    StorageErrorCode["INVALID_URL"] = "invalid-url";
    StorageErrorCode["INVALID_DEFAULT_BUCKET"] = "invalid-default-bucket";
    StorageErrorCode["NO_DEFAULT_BUCKET"] = "no-default-bucket";
    StorageErrorCode["CANNOT_SLICE_BLOB"] = "cannot-slice-blob";
    StorageErrorCode["SERVER_FILE_WRONG_SIZE"] = "server-file-wrong-size";
    StorageErrorCode["NO_DOWNLOAD_URL"] = "no-download-url";
    StorageErrorCode["INVALID_ARGUMENT"] = "invalid-argument";
    StorageErrorCode["INVALID_ARGUMENT_COUNT"] = "invalid-argument-count";
    StorageErrorCode["APP_DELETED"] = "app-deleted";
    StorageErrorCode["INVALID_ROOT_OPERATION"] = "invalid-root-operation";
    StorageErrorCode["INVALID_FORMAT"] = "invalid-format";
    StorageErrorCode["INTERNAL_ERROR"] = "internal-error";
    StorageErrorCode["UNSUPPORTED_ENVIRONMENT"] = "unsupported-environment";
})($81ded97e27414374$export$54592d666d6ce114 || ($81ded97e27414374$export$54592d666d6ce114 = {}));
function $81ded97e27414374$var$prependCode(code) {
    return 'storage/' + code;
}
function $81ded97e27414374$var$unknown() {
    const message = "An unknown error occurred, please check the error payload for server response.";
    return new $81ded97e27414374$export$697502632950e9d3($81ded97e27414374$export$54592d666d6ce114.UNKNOWN, message);
}
function $81ded97e27414374$var$objectNotFound(path) {
    return new $81ded97e27414374$export$697502632950e9d3($81ded97e27414374$export$54592d666d6ce114.OBJECT_NOT_FOUND, "Object '" + path + "' does not exist.");
}
function $81ded97e27414374$var$quotaExceeded(bucket) {
    return new $81ded97e27414374$export$697502632950e9d3($81ded97e27414374$export$54592d666d6ce114.QUOTA_EXCEEDED, "Quota for bucket '" + bucket + "' exceeded, please view quota on " + 'https://firebase.google.com/pricing/.');
}
function $81ded97e27414374$var$unauthenticated() {
    const message = "User is not authenticated, please authenticate using Firebase Authentication and try again.";
    return new $81ded97e27414374$export$697502632950e9d3($81ded97e27414374$export$54592d666d6ce114.UNAUTHENTICATED, message);
}
function $81ded97e27414374$var$unauthorizedApp() {
    return new $81ded97e27414374$export$697502632950e9d3($81ded97e27414374$export$54592d666d6ce114.UNAUTHORIZED_APP, 'This app does not have permission to access Firebase Storage on this project.');
}
function $81ded97e27414374$var$unauthorized(path) {
    return new $81ded97e27414374$export$697502632950e9d3($81ded97e27414374$export$54592d666d6ce114.UNAUTHORIZED, "User does not have permission to access '" + path + "'.");
}
function $81ded97e27414374$var$retryLimitExceeded() {
    return new $81ded97e27414374$export$697502632950e9d3($81ded97e27414374$export$54592d666d6ce114.RETRY_LIMIT_EXCEEDED, 'Max retry time for operation exceeded, please try again.');
}
function $81ded97e27414374$var$canceled() {
    return new $81ded97e27414374$export$697502632950e9d3($81ded97e27414374$export$54592d666d6ce114.CANCELED, 'User canceled the upload/download.');
}
function $81ded97e27414374$var$invalidUrl(url) {
    return new $81ded97e27414374$export$697502632950e9d3($81ded97e27414374$export$54592d666d6ce114.INVALID_URL, "Invalid URL '" + url + "'.");
}
function $81ded97e27414374$var$invalidDefaultBucket(bucket) {
    return new $81ded97e27414374$export$697502632950e9d3($81ded97e27414374$export$54592d666d6ce114.INVALID_DEFAULT_BUCKET, "Invalid default bucket '" + bucket + "'.");
}
function $81ded97e27414374$var$noDefaultBucket() {
    return new $81ded97e27414374$export$697502632950e9d3($81ded97e27414374$export$54592d666d6ce114.NO_DEFAULT_BUCKET, "No default bucket found. Did you set the '" + $81ded97e27414374$var$CONFIG_STORAGE_BUCKET_KEY + "' property when initializing the app?");
}
function $81ded97e27414374$var$cannotSliceBlob() {
    return new $81ded97e27414374$export$697502632950e9d3($81ded97e27414374$export$54592d666d6ce114.CANNOT_SLICE_BLOB, 'Cannot slice blob for upload. Please retry the upload.');
}
function $81ded97e27414374$var$serverFileWrongSize() {
    return new $81ded97e27414374$export$697502632950e9d3($81ded97e27414374$export$54592d666d6ce114.SERVER_FILE_WRONG_SIZE, 'Server recorded incorrect upload file size, please retry the upload.');
}
function $81ded97e27414374$var$noDownloadURL() {
    return new $81ded97e27414374$export$697502632950e9d3($81ded97e27414374$export$54592d666d6ce114.NO_DOWNLOAD_URL, 'The given file does not have any download URLs.');
}
function $81ded97e27414374$var$missingPolyFill(polyFill) {
    return new $81ded97e27414374$export$697502632950e9d3($81ded97e27414374$export$54592d666d6ce114.UNSUPPORTED_ENVIRONMENT, `${polyFill} is missing. Make sure to install the required polyfills. See https://firebase.google.com/docs/web/environments-js-sdk#polyfills for more information.`);
}
/**
 * @internal
 */ function $81ded97e27414374$export$8f74d9881d1936fd(message) {
    return new $81ded97e27414374$export$697502632950e9d3($81ded97e27414374$export$54592d666d6ce114.INVALID_ARGUMENT, message);
}
function $81ded97e27414374$var$appDeleted() {
    return new $81ded97e27414374$export$697502632950e9d3($81ded97e27414374$export$54592d666d6ce114.APP_DELETED, 'The Firebase app was deleted.');
}
/**
 * @param name - The name of the operation that was invalid.
 *
 * @internal
 */ function $81ded97e27414374$export$61f54cdc36500ad(name) {
    return new $81ded97e27414374$export$697502632950e9d3($81ded97e27414374$export$54592d666d6ce114.INVALID_ROOT_OPERATION, "The operation '" + name + "' cannot be performed on a root reference, create a non-root " + "reference using child, such as .child('file.png').");
}
/**
 * @param format - The format that was not valid.
 * @param message - A message describing the format violation.
 */ function $81ded97e27414374$var$invalidFormat(format, message) {
    return new $81ded97e27414374$export$697502632950e9d3($81ded97e27414374$export$54592d666d6ce114.INVALID_FORMAT, "String does not match format '" + format + "': " + message);
}
/**
 * @param message - A message describing the internal error.
 */ function $81ded97e27414374$var$internalError(message) {
    throw new $81ded97e27414374$export$697502632950e9d3($81ded97e27414374$export$54592d666d6ce114.INTERNAL_ERROR, 'Internal error: ' + message);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Firebase Storage location data.
 *
 * @internal
 */ class $81ded97e27414374$export$adb98fff6714334 {
    constructor(bucket, path){
        this.bucket = bucket;
        this.path_ = path;
    }
    get path() {
        return this.path_;
    }
    get isRoot() {
        return this.path.length === 0;
    }
    fullServerUrl() {
        const encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o/' + encode(this.path);
    }
    bucketOnlyServerUrl() {
        const encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o';
    }
    static makeFromBucketSpec(bucketString, host) {
        let bucketLocation;
        try {
            bucketLocation = $81ded97e27414374$export$adb98fff6714334.makeFromUrl(bucketString, host);
        } catch (e) {
            // Not valid URL, use as-is. This lets you put bare bucket names in
            // config.
            return new $81ded97e27414374$export$adb98fff6714334(bucketString, '');
        }
        if (bucketLocation.path === '') return bucketLocation;
        else throw $81ded97e27414374$var$invalidDefaultBucket(bucketString);
    }
    static makeFromUrl(url, host) {
        let location = null;
        const bucketDomain = '([A-Za-z0-9.\\-_]+)';
        function gsModify(loc) {
            if (loc.path.charAt(loc.path.length - 1) === '/') loc.path_ = loc.path_.slice(0, -1);
        }
        const gsPath = '(/(.*))?$';
        const gsRegex = new RegExp('^gs://' + bucketDomain + gsPath, 'i');
        const gsIndices = {
            bucket: 1,
            path: 3
        };
        function httpModify(loc) {
            loc.path_ = decodeURIComponent(loc.path);
        }
        const version = 'v[A-Za-z0-9_]+';
        const firebaseStorageHost = host.replace(/[.]/g, '\\.');
        const firebaseStoragePath = '(/([^?#]*).*)?$';
        const firebaseStorageRegExp = new RegExp(`^https?://${firebaseStorageHost}/${version}/b/${bucketDomain}/o${firebaseStoragePath}`, 'i');
        const firebaseStorageIndices = {
            bucket: 1,
            path: 3
        };
        const cloudStorageHost = host === $81ded97e27414374$var$DEFAULT_HOST ? '(?:storage.googleapis.com|storage.cloud.google.com)' : host;
        const cloudStoragePath = '([^?#]*)';
        const cloudStorageRegExp = new RegExp(`^https?://${cloudStorageHost}/${bucketDomain}/${cloudStoragePath}`, 'i');
        const cloudStorageIndices = {
            bucket: 1,
            path: 2
        };
        const groups = [
            {
                regex: gsRegex,
                indices: gsIndices,
                postModify: gsModify
            },
            {
                regex: firebaseStorageRegExp,
                indices: firebaseStorageIndices,
                postModify: httpModify
            },
            {
                regex: cloudStorageRegExp,
                indices: cloudStorageIndices,
                postModify: httpModify
            }
        ];
        for(let i = 0; i < groups.length; i++){
            const group = groups[i];
            const captures = group.regex.exec(url);
            if (captures) {
                const bucketValue = captures[group.indices.bucket];
                let pathValue = captures[group.indices.path];
                if (!pathValue) pathValue = '';
                location = new $81ded97e27414374$export$adb98fff6714334(bucketValue, pathValue);
                group.postModify(location);
                break;
            }
        }
        if (location == null) throw $81ded97e27414374$var$invalidUrl(url);
        return location;
    }
}
/**
 * A request whose promise always fails.
 */ class $81ded97e27414374$var$FailRequest {
    constructor(error){
        this.promise_ = Promise.reject(error);
    }
    /** @inheritDoc */ getPromise() {
        return this.promise_;
    }
    /** @inheritDoc */ cancel(_appDelete = false) {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Accepts a callback for an action to perform (`doRequest`),
 * and then a callback for when the backoff has completed (`backoffCompleteCb`).
 * The callback sent to start requires an argument to call (`onRequestComplete`).
 * When `start` calls `doRequest`, it passes a callback for when the request has
 * completed, `onRequestComplete`. Based on this, the backoff continues, with
 * another call to `doRequest` and the above loop continues until the timeout
 * is hit, or a successful response occurs.
 * @description
 * @param doRequest Callback to perform request
 * @param backoffCompleteCb Callback to call when backoff has been completed
 */ function $81ded97e27414374$var$start(doRequest, // eslint-disable-next-line @typescript-eslint/no-explicit-any
backoffCompleteCb, timeout) {
    // TODO(andysoto): make this code cleaner (probably refactor into an actual
    // type instead of a bunch of functions with state shared in the closure)
    let waitSeconds = 1;
    // Would type this as "number" but that doesn't work for Node so ¯\_(ツ)_/¯
    // TODO: find a way to exclude Node type definition for storage because storage only works in browser
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let retryTimeoutId = null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let globalTimeoutId = null;
    let hitTimeout = false;
    let cancelState = 0;
    function canceled() {
        return cancelState === 2;
    }
    let triggeredCallback = false;
    function triggerCallback(...args) {
        if (!triggeredCallback) {
            triggeredCallback = true;
            backoffCompleteCb.apply(null, args);
        }
    }
    function callWithDelay(millis) {
        retryTimeoutId = setTimeout(()=>{
            retryTimeoutId = null;
            doRequest(responseHandler, canceled());
        }, millis);
    }
    function clearGlobalTimeout() {
        if (globalTimeoutId) clearTimeout(globalTimeoutId);
    }
    function responseHandler(success, ...args) {
        if (triggeredCallback) {
            clearGlobalTimeout();
            return;
        }
        if (success) {
            clearGlobalTimeout();
            triggerCallback.call(null, success, ...args);
            return;
        }
        const mustStop = canceled() || hitTimeout;
        if (mustStop) {
            clearGlobalTimeout();
            triggerCallback.call(null, success, ...args);
            return;
        }
        if (waitSeconds < 64) /* TODO(andysoto): don't back off so quickly if we know we're offline. */ waitSeconds *= 2;
        let waitMillis;
        if (cancelState === 1) {
            cancelState = 2;
            waitMillis = 0;
        } else waitMillis = (waitSeconds + Math.random()) * 1000;
        callWithDelay(waitMillis);
    }
    let stopped = false;
    function stop(wasTimeout) {
        if (stopped) return;
        stopped = true;
        clearGlobalTimeout();
        if (triggeredCallback) return;
        if (retryTimeoutId !== null) {
            if (!wasTimeout) cancelState = 2;
            clearTimeout(retryTimeoutId);
            callWithDelay(0);
        } else if (!wasTimeout) cancelState = 1;
    }
    callWithDelay(0);
    globalTimeoutId = setTimeout(()=>{
        hitTimeout = true;
        stop(true);
    }, timeout);
    return stop;
}
/**
 * Stops the retry loop from repeating.
 * If the function is currently "in between" retries, it is invoked immediately
 * with the second parameter as "true". Otherwise, it will be invoked once more
 * after the current invocation finishes iff the current invocation would have
 * triggered another retry.
 */ function $81ded97e27414374$var$stop(id) {
    id(false);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $81ded97e27414374$var$isJustDef(p) {
    return p !== void 0;
}
// eslint-disable-next-line @typescript-eslint/ban-types
function $81ded97e27414374$var$isFunction(p) {
    return typeof p === 'function';
}
function $81ded97e27414374$var$isNonArrayObject(p) {
    return typeof p === 'object' && !Array.isArray(p);
}
function $81ded97e27414374$var$isString(p) {
    return typeof p === 'string' || p instanceof String;
}
function $81ded97e27414374$var$isNativeBlob(p) {
    return $81ded97e27414374$var$isNativeBlobDefined() && p instanceof Blob;
}
function $81ded97e27414374$var$isNativeBlobDefined() {
    return typeof Blob !== 'undefined';
}
function $81ded97e27414374$var$validateNumber(argument, minValue, maxValue, value) {
    if (value < minValue) throw $81ded97e27414374$export$8f74d9881d1936fd(`Invalid value for '${argument}'. Expected ${minValue} or greater.`);
    if (value > maxValue) throw $81ded97e27414374$export$8f74d9881d1936fd(`Invalid value for '${argument}'. Expected ${maxValue} or less.`);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $81ded97e27414374$var$makeUrl(urlPart, host, protocol) {
    let origin = host;
    if (protocol == null) origin = `https://${host}`;
    return `${protocol}://${origin}/v0${urlPart}`;
}
function $81ded97e27414374$var$makeQueryString(params) {
    const encode = encodeURIComponent;
    let queryPart = '?';
    for(const key in params)if (params.hasOwnProperty(key)) {
        const nextPart = encode(key) + '=' + encode(params[key]);
        queryPart = queryPart + nextPart + '&';
    }
    // Chop off the extra '&' or '?' on the end
    queryPart = queryPart.slice(0, -1);
    return queryPart;
}
/**
 * Error codes for requests made by the XhrIo wrapper.
 */ var $81ded97e27414374$var$ErrorCode;
(function(ErrorCode) {
    ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
    ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
    ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
})($81ded97e27414374$var$ErrorCode || ($81ded97e27414374$var$ErrorCode = {}));
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks the status code to see if the action should be retried.
 *
 * @param status Current HTTP status code returned by server.
 * @param additionalRetryCodes additional retry codes to check against
 */ function $81ded97e27414374$var$isRetryStatusCode(status, additionalRetryCodes) {
    // The codes for which to retry came from this page:
    // https://cloud.google.com/storage/docs/exponential-backoff
    const isFiveHundredCode = status >= 500 && status < 600;
    const extraRetryCodes = [
        // Request Timeout: web server didn't receive full request in time.
        408,
        // Too Many Requests: you're getting rate-limited, basically.
        429
    ];
    const isExtraRetryCode = extraRetryCodes.indexOf(status) !== -1;
    const isAdditionalRetryCode = additionalRetryCodes.indexOf(status) !== -1;
    return isFiveHundredCode || isExtraRetryCode || isAdditionalRetryCode;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Handles network logic for all Storage Requests, including error reporting and
 * retries with backoff.
 *
 * @param I - the type of the backend's network response.
 * @param - O the output type used by the rest of the SDK. The conversion
 * happens in the specified `callback_`.
 */ class $81ded97e27414374$var$NetworkRequest {
    constructor(url_, method_, headers_, body_, successCodes_, additionalRetryCodes_, callback_, errorCallback_, timeout_, progressCallback_, connectionFactory_, retry = true, isUsingEmulator = false){
        this.url_ = url_;
        this.method_ = method_;
        this.headers_ = headers_;
        this.body_ = body_;
        this.successCodes_ = successCodes_;
        this.additionalRetryCodes_ = additionalRetryCodes_;
        this.callback_ = callback_;
        this.errorCallback_ = errorCallback_;
        this.timeout_ = timeout_;
        this.progressCallback_ = progressCallback_;
        this.connectionFactory_ = connectionFactory_;
        this.retry = retry;
        this.isUsingEmulator = isUsingEmulator;
        this.pendingConnection_ = null;
        this.backoffId_ = null;
        this.canceled_ = false;
        this.appDelete_ = false;
        this.promise_ = new Promise((resolve, reject)=>{
            this.resolve_ = resolve;
            this.reject_ = reject;
            this.start_();
        });
    }
    /**
     * Actually starts the retry loop.
     */ start_() {
        const doTheRequest = (backoffCallback, canceled)=>{
            if (canceled) {
                backoffCallback(false, new $81ded97e27414374$var$RequestEndStatus(false, null, true));
                return;
            }
            const connection = this.connectionFactory_();
            this.pendingConnection_ = connection;
            const progressListener = (progressEvent)=>{
                const loaded = progressEvent.loaded;
                const total = progressEvent.lengthComputable ? progressEvent.total : -1;
                if (this.progressCallback_ !== null) this.progressCallback_(loaded, total);
            };
            if (this.progressCallback_ !== null) connection.addUploadProgressListener(progressListener);
            // connection.send() never rejects, so we don't need to have a error handler or use catch on the returned promise.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            connection.send(this.url_, this.method_, this.isUsingEmulator, this.body_, this.headers_).then(()=>{
                if (this.progressCallback_ !== null) connection.removeUploadProgressListener(progressListener);
                this.pendingConnection_ = null;
                const hitServer = connection.getErrorCode() === $81ded97e27414374$var$ErrorCode.NO_ERROR;
                const status = connection.getStatus();
                if (!hitServer || $81ded97e27414374$var$isRetryStatusCode(status, this.additionalRetryCodes_) && this.retry) {
                    const wasCanceled = connection.getErrorCode() === $81ded97e27414374$var$ErrorCode.ABORT;
                    backoffCallback(false, new $81ded97e27414374$var$RequestEndStatus(false, null, wasCanceled));
                    return;
                }
                const successCode = this.successCodes_.indexOf(status) !== -1;
                backoffCallback(true, new $81ded97e27414374$var$RequestEndStatus(successCode, connection));
            });
        };
        /**
         * @param requestWentThrough - True if the request eventually went
         *     through, false if it hit the retry limit or was canceled.
         */ const backoffDone = (requestWentThrough, status)=>{
            const resolve = this.resolve_;
            const reject = this.reject_;
            const connection = status.connection;
            if (status.wasSuccessCode) try {
                const result = this.callback_(connection, connection.getResponse());
                if ($81ded97e27414374$var$isJustDef(result)) resolve(result);
                else resolve();
            } catch (e) {
                reject(e);
            }
            else {
                if (connection !== null) {
                    const err = $81ded97e27414374$var$unknown();
                    err.serverResponse = connection.getErrorText();
                    if (this.errorCallback_) reject(this.errorCallback_(connection, err));
                    else reject(err);
                } else if (status.canceled) {
                    const err = this.appDelete_ ? $81ded97e27414374$var$appDeleted() : $81ded97e27414374$var$canceled();
                    reject(err);
                } else {
                    const err = $81ded97e27414374$var$retryLimitExceeded();
                    reject(err);
                }
            }
        };
        if (this.canceled_) backoffDone(false, new $81ded97e27414374$var$RequestEndStatus(false, null, true));
        else this.backoffId_ = $81ded97e27414374$var$start(doTheRequest, backoffDone, this.timeout_);
    }
    /** @inheritDoc */ getPromise() {
        return this.promise_;
    }
    /** @inheritDoc */ cancel(appDelete) {
        this.canceled_ = true;
        this.appDelete_ = appDelete || false;
        if (this.backoffId_ !== null) $81ded97e27414374$var$stop(this.backoffId_);
        if (this.pendingConnection_ !== null) this.pendingConnection_.abort();
    }
}
/**
 * A collection of information about the result of a network request.
 * @param opt_canceled - Defaults to false.
 */ class $81ded97e27414374$var$RequestEndStatus {
    constructor(wasSuccessCode, connection, canceled){
        this.wasSuccessCode = wasSuccessCode;
        this.connection = connection;
        this.canceled = !!canceled;
    }
}
function $81ded97e27414374$var$addAuthHeader_(headers, authToken) {
    if (authToken !== null && authToken.length > 0) headers['Authorization'] = 'Firebase ' + authToken;
}
function $81ded97e27414374$var$addVersionHeader_(headers, firebaseVersion) {
    headers['X-Firebase-Storage-Version'] = 'webjs/' + (firebaseVersion ?? 'AppManager');
}
function $81ded97e27414374$var$addGmpidHeader_(headers, appId) {
    if (appId) headers['X-Firebase-GMPID'] = appId;
}
function $81ded97e27414374$var$addAppCheckHeader_(headers, appCheckToken) {
    if (appCheckToken !== null) headers['X-Firebase-AppCheck'] = appCheckToken;
}
function $81ded97e27414374$var$makeRequest(requestInfo, appId, authToken, appCheckToken, requestFactory, firebaseVersion, retry = true, isUsingEmulator = false) {
    const queryPart = $81ded97e27414374$var$makeQueryString(requestInfo.urlParams);
    const url = requestInfo.url + queryPart;
    const headers = Object.assign({}, requestInfo.headers);
    $81ded97e27414374$var$addGmpidHeader_(headers, appId);
    $81ded97e27414374$var$addAuthHeader_(headers, authToken);
    $81ded97e27414374$var$addVersionHeader_(headers, firebaseVersion);
    $81ded97e27414374$var$addAppCheckHeader_(headers, appCheckToken);
    return new $81ded97e27414374$var$NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, requestFactory, retry, isUsingEmulator);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $81ded97e27414374$var$getBlobBuilder() {
    if (typeof BlobBuilder !== 'undefined') return BlobBuilder;
    else if (typeof WebKitBlobBuilder !== 'undefined') return WebKitBlobBuilder;
    else return undefined;
}
/**
 * Concatenates one or more values together and converts them to a Blob.
 *
 * @param args The values that will make up the resulting blob.
 * @return The blob.
 */ function $81ded97e27414374$var$getBlob$1(...args) {
    const BlobBuilder1 = $81ded97e27414374$var$getBlobBuilder();
    if (BlobBuilder1 !== undefined) {
        const bb = new BlobBuilder1();
        for(let i = 0; i < args.length; i++)bb.append(args[i]);
        return bb.getBlob();
    } else {
        if ($81ded97e27414374$var$isNativeBlobDefined()) return new Blob(args);
        else throw new $81ded97e27414374$export$697502632950e9d3($81ded97e27414374$export$54592d666d6ce114.UNSUPPORTED_ENVIRONMENT, "This browser doesn't seem to support creating Blobs");
    }
}
/**
 * Slices the blob. The returned blob contains data from the start byte
 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
 *
 * @param blob The blob to be sliced.
 * @param start Index of the starting byte.
 * @param end Index of the ending byte.
 * @return The blob slice or null if not supported.
 */ function $81ded97e27414374$var$sliceBlob(blob, start, end) {
    if (blob.webkitSlice) return blob.webkitSlice(start, end);
    else if (blob.mozSlice) return blob.mozSlice(start, end);
    else if (blob.slice) return blob.slice(start, end);
    return null;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ function $81ded97e27414374$var$decodeBase64(encoded) {
    if (typeof atob === 'undefined') throw $81ded97e27414374$var$missingPolyFill('base-64');
    return atob(encoded);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enumeration of the possible string formats for upload.
 * @public
 */ const $81ded97e27414374$export$f22e7fe56db8ae03 = {
    /**
     * Indicates the string should be interpreted "raw", that is, as normal text.
     * The string will be interpreted as UTF-16, then uploaded as a UTF-8 byte
     * sequence.
     * Example: The string 'Hello! \\ud83d\\ude0a' becomes the byte sequence
     * 48 65 6c 6c 6f 21 20 f0 9f 98 8a
     */ RAW: 'raw',
    /**
     * Indicates the string should be interpreted as base64-encoded data.
     * Padding characters (trailing '='s) are optional.
     * Example: The string 'rWmO++E6t7/rlw==' becomes the byte sequence
     * ad 69 8e fb e1 3a b7 bf eb 97
     */ BASE64: 'base64',
    /**
     * Indicates the string should be interpreted as base64url-encoded data.
     * Padding characters (trailing '='s) are optional.
     * Example: The string 'rWmO--E6t7_rlw==' becomes the byte sequence
     * ad 69 8e fb e1 3a b7 bf eb 97
     */ BASE64URL: 'base64url',
    /**
     * Indicates the string is a data URL, such as one obtained from
     * canvas.toDataURL().
     * Example: the string 'data:application/octet-stream;base64,aaaa'
     * becomes the byte sequence
     * 69 a6 9a
     * (the content-type "application/octet-stream" is also applied, but can
     * be overridden in the metadata object).
     */ DATA_URL: 'data_url'
};
class $81ded97e27414374$var$StringData {
    constructor(data, contentType){
        this.data = data;
        this.contentType = contentType || null;
    }
}
/**
 * @internal
 */ function $81ded97e27414374$export$d80b9b5a2ccdd3e0(format, stringData) {
    switch(format){
        case $81ded97e27414374$export$f22e7fe56db8ae03.RAW:
            return new $81ded97e27414374$var$StringData($81ded97e27414374$var$utf8Bytes_(stringData));
        case $81ded97e27414374$export$f22e7fe56db8ae03.BASE64:
        case $81ded97e27414374$export$f22e7fe56db8ae03.BASE64URL:
            return new $81ded97e27414374$var$StringData($81ded97e27414374$var$base64Bytes_(format, stringData));
        case $81ded97e27414374$export$f22e7fe56db8ae03.DATA_URL:
            return new $81ded97e27414374$var$StringData($81ded97e27414374$var$dataURLBytes_(stringData), $81ded97e27414374$var$dataURLContentType_(stringData));
    }
    // assert(false);
    throw $81ded97e27414374$var$unknown();
}
function $81ded97e27414374$var$utf8Bytes_(value) {
    const b = [];
    for(let i = 0; i < value.length; i++){
        let c = value.charCodeAt(i);
        if (c <= 127) b.push(c);
        else if (c <= 2047) b.push(192 | c >> 6, 128 | c & 63);
        else {
            if ((c & 64512) === 55296) {
                // The start of a surrogate pair.
                const valid = i < value.length - 1 && (value.charCodeAt(i + 1) & 64512) === 56320;
                if (!valid) // The second surrogate wasn't there.
                b.push(239, 191, 189);
                else {
                    const hi = c;
                    const lo = value.charCodeAt(++i);
                    c = 65536 | (hi & 1023) << 10 | lo & 1023;
                    b.push(240 | c >> 18, 128 | c >> 12 & 63, 128 | c >> 6 & 63, 128 | c & 63);
                }
            } else if ((c & 64512) === 56320) // Invalid low surrogate.
            b.push(239, 191, 189);
            else b.push(224 | c >> 12, 128 | c >> 6 & 63, 128 | c & 63);
        }
    }
    return new Uint8Array(b);
}
function $81ded97e27414374$var$percentEncodedBytes_(value) {
    let decoded;
    try {
        decoded = decodeURIComponent(value);
    } catch (e) {
        throw $81ded97e27414374$var$invalidFormat($81ded97e27414374$export$f22e7fe56db8ae03.DATA_URL, 'Malformed data URL.');
    }
    return $81ded97e27414374$var$utf8Bytes_(decoded);
}
function $81ded97e27414374$var$base64Bytes_(format, value) {
    switch(format){
        case $81ded97e27414374$export$f22e7fe56db8ae03.BASE64:
            {
                const hasMinus = value.indexOf('-') !== -1;
                const hasUnder = value.indexOf('_') !== -1;
                if (hasMinus || hasUnder) {
                    const invalidChar = hasMinus ? '-' : '_';
                    throw $81ded97e27414374$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64url encoded?");
                }
                break;
            }
        case $81ded97e27414374$export$f22e7fe56db8ae03.BASE64URL:
            {
                const hasPlus = value.indexOf('+') !== -1;
                const hasSlash = value.indexOf('/') !== -1;
                if (hasPlus || hasSlash) {
                    const invalidChar = hasPlus ? '+' : '/';
                    throw $81ded97e27414374$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64 encoded?");
                }
                value = value.replace(/-/g, '+').replace(/_/g, '/');
                break;
            }
    }
    let bytes;
    try {
        bytes = $81ded97e27414374$var$decodeBase64(value);
    } catch (e) {
        if (e.message.includes('polyfill')) throw e;
        throw $81ded97e27414374$var$invalidFormat(format, 'Invalid character found');
    }
    const array = new Uint8Array(bytes.length);
    for(let i = 0; i < bytes.length; i++)array[i] = bytes.charCodeAt(i);
    return array;
}
class $81ded97e27414374$var$DataURLParts {
    constructor(dataURL){
        this.base64 = false;
        this.contentType = null;
        const matches = dataURL.match(/^data:([^,]+)?,/);
        if (matches === null) throw $81ded97e27414374$var$invalidFormat($81ded97e27414374$export$f22e7fe56db8ae03.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
        const middle = matches[1] || null;
        if (middle != null) {
            this.base64 = $81ded97e27414374$var$endsWith(middle, ';base64');
            this.contentType = this.base64 ? middle.substring(0, middle.length - 7) : middle;
        }
        this.rest = dataURL.substring(dataURL.indexOf(',') + 1);
    }
}
function $81ded97e27414374$var$dataURLBytes_(dataUrl) {
    const parts = new $81ded97e27414374$var$DataURLParts(dataUrl);
    if (parts.base64) return $81ded97e27414374$var$base64Bytes_($81ded97e27414374$export$f22e7fe56db8ae03.BASE64, parts.rest);
    else return $81ded97e27414374$var$percentEncodedBytes_(parts.rest);
}
function $81ded97e27414374$var$dataURLContentType_(dataUrl) {
    const parts = new $81ded97e27414374$var$DataURLParts(dataUrl);
    return parts.contentType;
}
function $81ded97e27414374$var$endsWith(s, end) {
    const longEnough = s.length >= end.length;
    if (!longEnough) return false;
    return s.substring(s.length - end.length) === end;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param opt_elideCopy - If true, doesn't copy mutable input data
 *     (e.g. Uint8Arrays). Pass true only if you know the objects will not be
 *     modified after this blob's construction.
 *
 * @internal
 */ class $81ded97e27414374$export$8deea8629ff0b8a7 {
    constructor(data, elideCopy){
        let size = 0;
        let blobType = '';
        if ($81ded97e27414374$var$isNativeBlob(data)) {
            this.data_ = data;
            size = data.size;
            blobType = data.type;
        } else if (data instanceof ArrayBuffer) {
            if (elideCopy) this.data_ = new Uint8Array(data);
            else {
                this.data_ = new Uint8Array(data.byteLength);
                this.data_.set(new Uint8Array(data));
            }
            size = this.data_.length;
        } else if (data instanceof Uint8Array) {
            if (elideCopy) this.data_ = data;
            else {
                this.data_ = new Uint8Array(data.length);
                this.data_.set(data);
            }
            size = data.length;
        }
        this.size_ = size;
        this.type_ = blobType;
    }
    size() {
        return this.size_;
    }
    type() {
        return this.type_;
    }
    slice(startByte, endByte) {
        if ($81ded97e27414374$var$isNativeBlob(this.data_)) {
            const realBlob = this.data_;
            const sliced = $81ded97e27414374$var$sliceBlob(realBlob, startByte, endByte);
            if (sliced === null) return null;
            return new $81ded97e27414374$export$8deea8629ff0b8a7(sliced);
        } else {
            const slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
            return new $81ded97e27414374$export$8deea8629ff0b8a7(slice, true);
        }
    }
    static getBlob(...args) {
        if ($81ded97e27414374$var$isNativeBlobDefined()) {
            const blobby = args.map((val)=>{
                if (val instanceof $81ded97e27414374$export$8deea8629ff0b8a7) return val.data_;
                else return val;
            });
            return new $81ded97e27414374$export$8deea8629ff0b8a7($81ded97e27414374$var$getBlob$1.apply(null, blobby));
        } else {
            const uint8Arrays = args.map((val)=>{
                if ($81ded97e27414374$var$isString(val)) return $81ded97e27414374$export$d80b9b5a2ccdd3e0($81ded97e27414374$export$f22e7fe56db8ae03.RAW, val).data;
                else // Blobs don't exist, so this has to be a Uint8Array.
                return val.data_;
            });
            let finalLength = 0;
            uint8Arrays.forEach((array)=>{
                finalLength += array.byteLength;
            });
            const merged = new Uint8Array(finalLength);
            let index = 0;
            uint8Arrays.forEach((array)=>{
                for(let i = 0; i < array.length; i++)merged[index++] = array[i];
            });
            return new $81ded97e27414374$export$8deea8629ff0b8a7(merged, true);
        }
    }
    uploadData() {
        return this.data_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the Object resulting from parsing the given JSON, or null if the
 * given string does not represent a JSON object.
 */ function $81ded97e27414374$var$jsonObjectOrNull(s) {
    let obj;
    try {
        obj = JSON.parse(s);
    } catch (e) {
        return null;
    }
    if ($81ded97e27414374$var$isNonArrayObject(obj)) return obj;
    else return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Contains helper methods for manipulating paths.
 */ /**
 * @return Null if the path is already at the root.
 */ function $81ded97e27414374$var$parent(path) {
    if (path.length === 0) return null;
    const index = path.lastIndexOf('/');
    if (index === -1) return '';
    const newPath = path.slice(0, index);
    return newPath;
}
function $81ded97e27414374$var$child(path, childPath) {
    const canonicalChildPath = childPath.split('/').filter((component)=>component.length > 0).join('/');
    if (path.length === 0) return canonicalChildPath;
    else return path + '/' + canonicalChildPath;
}
/**
 * Returns the last component of a path.
 * '/foo/bar' -> 'bar'
 * '/foo/bar/baz/' -> 'baz/'
 * '/a' -> 'a'
 */ function $81ded97e27414374$var$lastComponent(path) {
    const index = path.lastIndexOf('/', path.length - 2);
    if (index === -1) return path;
    else return path.slice(index + 1);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $81ded97e27414374$var$noXform_(metadata, value) {
    return value;
}
class $81ded97e27414374$var$Mapping {
    constructor(server, local, writable, xform){
        this.server = server;
        this.local = local || server;
        this.writable = !!writable;
        this.xform = xform || $81ded97e27414374$var$noXform_;
    }
}
let $81ded97e27414374$var$mappings_ = null;
function $81ded97e27414374$var$xformPath(fullPath) {
    if (!$81ded97e27414374$var$isString(fullPath) || fullPath.length < 2) return fullPath;
    else return $81ded97e27414374$var$lastComponent(fullPath);
}
function $81ded97e27414374$var$getMappings() {
    if ($81ded97e27414374$var$mappings_) return $81ded97e27414374$var$mappings_;
    const mappings = [];
    mappings.push(new $81ded97e27414374$var$Mapping('bucket'));
    mappings.push(new $81ded97e27414374$var$Mapping('generation'));
    mappings.push(new $81ded97e27414374$var$Mapping('metageneration'));
    mappings.push(new $81ded97e27414374$var$Mapping('name', 'fullPath', true));
    function mappingsXformPath(_metadata, fullPath) {
        return $81ded97e27414374$var$xformPath(fullPath);
    }
    const nameMapping = new $81ded97e27414374$var$Mapping('name');
    nameMapping.xform = mappingsXformPath;
    mappings.push(nameMapping);
    /**
     * Coerces the second param to a number, if it is defined.
     */ function xformSize(_metadata, size) {
        if (size !== undefined) return Number(size);
        else return size;
    }
    const sizeMapping = new $81ded97e27414374$var$Mapping('size');
    sizeMapping.xform = xformSize;
    mappings.push(sizeMapping);
    mappings.push(new $81ded97e27414374$var$Mapping('timeCreated'));
    mappings.push(new $81ded97e27414374$var$Mapping('updated'));
    mappings.push(new $81ded97e27414374$var$Mapping('md5Hash', null, true));
    mappings.push(new $81ded97e27414374$var$Mapping('cacheControl', null, true));
    mappings.push(new $81ded97e27414374$var$Mapping('contentDisposition', null, true));
    mappings.push(new $81ded97e27414374$var$Mapping('contentEncoding', null, true));
    mappings.push(new $81ded97e27414374$var$Mapping('contentLanguage', null, true));
    mappings.push(new $81ded97e27414374$var$Mapping('contentType', null, true));
    mappings.push(new $81ded97e27414374$var$Mapping('metadata', 'customMetadata', true));
    $81ded97e27414374$var$mappings_ = mappings;
    return $81ded97e27414374$var$mappings_;
}
function $81ded97e27414374$var$addRef(metadata, service) {
    function generateRef() {
        const bucket = metadata['bucket'];
        const path = metadata['fullPath'];
        const loc = new $81ded97e27414374$export$adb98fff6714334(bucket, path);
        return service._makeStorageReference(loc);
    }
    Object.defineProperty(metadata, 'ref', {
        get: generateRef
    });
}
function $81ded97e27414374$var$fromResource(service, resource, mappings) {
    const metadata = {};
    metadata['type'] = 'file';
    const len = mappings.length;
    for(let i = 0; i < len; i++){
        const mapping = mappings[i];
        metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
    }
    $81ded97e27414374$var$addRef(metadata, service);
    return metadata;
}
function $81ded97e27414374$var$fromResourceString(service, resourceString, mappings) {
    const obj = $81ded97e27414374$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    const resource = obj;
    return $81ded97e27414374$var$fromResource(service, resource, mappings);
}
function $81ded97e27414374$var$downloadUrlFromResourceString(metadata, resourceString, host, protocol) {
    const obj = $81ded97e27414374$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    if (!$81ded97e27414374$var$isString(obj['downloadTokens'])) // This can happen if objects are uploaded through GCS and retrieved
    // through list, so we don't want to throw an Error.
    return null;
    const tokens = obj['downloadTokens'];
    if (tokens.length === 0) return null;
    const encode = encodeURIComponent;
    const tokensList = tokens.split(',');
    const urls = tokensList.map((token)=>{
        const bucket = metadata['bucket'];
        const path = metadata['fullPath'];
        const urlPart = '/b/' + encode(bucket) + '/o/' + encode(path);
        const base = $81ded97e27414374$var$makeUrl(urlPart, host, protocol);
        const queryString = $81ded97e27414374$var$makeQueryString({
            alt: 'media',
            token: token
        });
        return base + queryString;
    });
    return urls[0];
}
function $81ded97e27414374$var$toResourceString(metadata, mappings) {
    const resource = {};
    const len = mappings.length;
    for(let i = 0; i < len; i++){
        const mapping = mappings[i];
        if (mapping.writable) resource[mapping.server] = metadata[mapping.local];
    }
    return JSON.stringify(resource);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $81ded97e27414374$var$PREFIXES_KEY = 'prefixes';
const $81ded97e27414374$var$ITEMS_KEY = 'items';
function $81ded97e27414374$var$fromBackendResponse(service, bucket, resource) {
    const listResult = {
        prefixes: [],
        items: [],
        nextPageToken: resource['nextPageToken']
    };
    if (resource[$81ded97e27414374$var$PREFIXES_KEY]) for (const path of resource[$81ded97e27414374$var$PREFIXES_KEY]){
        const pathWithoutTrailingSlash = path.replace(/\/$/, '');
        const reference = service._makeStorageReference(new $81ded97e27414374$export$adb98fff6714334(bucket, pathWithoutTrailingSlash));
        listResult.prefixes.push(reference);
    }
    if (resource[$81ded97e27414374$var$ITEMS_KEY]) for (const item of resource[$81ded97e27414374$var$ITEMS_KEY]){
        const reference = service._makeStorageReference(new $81ded97e27414374$export$adb98fff6714334(bucket, item['name']));
        listResult.items.push(reference);
    }
    return listResult;
}
function $81ded97e27414374$var$fromResponseString(service, bucket, resourceString) {
    const obj = $81ded97e27414374$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    const resource = obj;
    return $81ded97e27414374$var$fromBackendResponse(service, bucket, resource);
}
/**
 * Contains a fully specified request.
 *
 * @param I - the type of the backend's network response.
 * @param O - the output response type used by the rest of the SDK.
 */ class $81ded97e27414374$var$RequestInfo {
    constructor(url, method, /**
     * Returns the value with which to resolve the request's promise. Only called
     * if the request is successful. Throw from this function to reject the
     * returned Request's promise with the thrown error.
     * Note: The XhrIo passed to this function may be reused after this callback
     * returns. Do not keep a reference to it in any way.
     */ handler, timeout){
        this.url = url;
        this.method = method;
        this.handler = handler;
        this.timeout = timeout;
        this.urlParams = {};
        this.headers = {};
        this.body = null;
        this.errorHandler = null;
        /**
         * Called with the current number of bytes uploaded and total size (-1 if not
         * computable) of the request body (i.e. used to report upload progress).
         */ this.progressCallback = null;
        this.successCodes = [
            200
        ];
        this.additionalRetryCodes = [];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws the UNKNOWN StorageError if cndn is false.
 */ function $81ded97e27414374$var$handlerCheck(cndn) {
    if (!cndn) throw $81ded97e27414374$var$unknown();
}
function $81ded97e27414374$var$metadataHandler(service, mappings) {
    function handler(xhr, text) {
        const metadata = $81ded97e27414374$var$fromResourceString(service, text, mappings);
        $81ded97e27414374$var$handlerCheck(metadata !== null);
        return metadata;
    }
    return handler;
}
function $81ded97e27414374$var$listHandler(service, bucket) {
    function handler(xhr, text) {
        const listResult = $81ded97e27414374$var$fromResponseString(service, bucket, text);
        $81ded97e27414374$var$handlerCheck(listResult !== null);
        return listResult;
    }
    return handler;
}
function $81ded97e27414374$var$downloadUrlHandler(service, mappings) {
    function handler(xhr, text) {
        const metadata = $81ded97e27414374$var$fromResourceString(service, text, mappings);
        $81ded97e27414374$var$handlerCheck(metadata !== null);
        return $81ded97e27414374$var$downloadUrlFromResourceString(metadata, text, service.host, service._protocol);
    }
    return handler;
}
function $81ded97e27414374$var$sharedErrorHandler(location) {
    function errorHandler(xhr, err) {
        let newErr;
        if (xhr.getStatus() === 401) {
            if (// This exact message string is the only consistent part of the
            // server's error response that identifies it as an App Check error.
            xhr.getErrorText().includes('Firebase App Check token is invalid')) newErr = $81ded97e27414374$var$unauthorizedApp();
            else newErr = $81ded97e27414374$var$unauthenticated();
        } else {
            if (xhr.getStatus() === 402) newErr = $81ded97e27414374$var$quotaExceeded(location.bucket);
            else if (xhr.getStatus() === 403) newErr = $81ded97e27414374$var$unauthorized(location.path);
            else newErr = err;
        }
        newErr.status = xhr.getStatus();
        newErr.serverResponse = err.serverResponse;
        return newErr;
    }
    return errorHandler;
}
function $81ded97e27414374$var$objectErrorHandler(location) {
    const shared = $81ded97e27414374$var$sharedErrorHandler(location);
    function errorHandler(xhr, err) {
        let newErr = shared(xhr, err);
        if (xhr.getStatus() === 404) newErr = $81ded97e27414374$var$objectNotFound(location.path);
        newErr.serverResponse = err.serverResponse;
        return newErr;
    }
    return errorHandler;
}
function $81ded97e27414374$var$getMetadata$2(service, location, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $81ded97e27414374$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $81ded97e27414374$var$RequestInfo(url, method, $81ded97e27414374$var$metadataHandler(service, mappings), timeout);
    requestInfo.errorHandler = $81ded97e27414374$var$objectErrorHandler(location);
    return requestInfo;
}
function $81ded97e27414374$var$list$2(service, location, delimiter, pageToken, maxResults) {
    const urlParams = {};
    if (location.isRoot) urlParams['prefix'] = '';
    else urlParams['prefix'] = location.path + '/';
    if (delimiter && delimiter.length > 0) urlParams['delimiter'] = delimiter;
    if (pageToken) urlParams['pageToken'] = pageToken;
    if (maxResults) urlParams['maxResults'] = maxResults;
    const urlPart = location.bucketOnlyServerUrl();
    const url = $81ded97e27414374$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $81ded97e27414374$var$RequestInfo(url, method, $81ded97e27414374$var$listHandler(service, location.bucket), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.errorHandler = $81ded97e27414374$var$sharedErrorHandler(location);
    return requestInfo;
}
function $81ded97e27414374$var$getBytes$1(service, location, maxDownloadSizeBytes) {
    const urlPart = location.fullServerUrl();
    const url = $81ded97e27414374$var$makeUrl(urlPart, service.host, service._protocol) + '?alt=media';
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $81ded97e27414374$var$RequestInfo(url, method, (_, data)=>data, timeout);
    requestInfo.errorHandler = $81ded97e27414374$var$objectErrorHandler(location);
    if (maxDownloadSizeBytes !== undefined) {
        requestInfo.headers['Range'] = `bytes=0-${maxDownloadSizeBytes}`;
        requestInfo.successCodes = [
            200 /* OK */ ,
            206 /* Partial Content */ 
        ];
    }
    return requestInfo;
}
function $81ded97e27414374$var$getDownloadUrl(service, location, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $81ded97e27414374$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $81ded97e27414374$var$RequestInfo(url, method, $81ded97e27414374$var$downloadUrlHandler(service, mappings), timeout);
    requestInfo.errorHandler = $81ded97e27414374$var$objectErrorHandler(location);
    return requestInfo;
}
function $81ded97e27414374$var$updateMetadata$2(service, location, metadata, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $81ded97e27414374$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'PATCH';
    const body = $81ded97e27414374$var$toResourceString(metadata, mappings);
    const headers = {
        'Content-Type': 'application/json; charset=utf-8'
    };
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $81ded97e27414374$var$RequestInfo(url, method, $81ded97e27414374$var$metadataHandler(service, mappings), timeout);
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $81ded97e27414374$var$objectErrorHandler(location);
    return requestInfo;
}
function $81ded97e27414374$var$deleteObject$2(service, location) {
    const urlPart = location.fullServerUrl();
    const url = $81ded97e27414374$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'DELETE';
    const timeout = service.maxOperationRetryTime;
    function handler(_xhr, _text) {}
    const requestInfo = new $81ded97e27414374$var$RequestInfo(url, method, handler, timeout);
    requestInfo.successCodes = [
        200,
        204
    ];
    requestInfo.errorHandler = $81ded97e27414374$var$objectErrorHandler(location);
    return requestInfo;
}
function $81ded97e27414374$var$determineContentType_(metadata, blob) {
    return metadata && metadata['contentType'] || blob && blob.type() || 'application/octet-stream';
}
function $81ded97e27414374$var$metadataForUpload_(location, blob, metadata) {
    const metadataClone = Object.assign({}, metadata);
    metadataClone['fullPath'] = location.path;
    metadataClone['size'] = blob.size();
    if (!metadataClone['contentType']) metadataClone['contentType'] = $81ded97e27414374$var$determineContentType_(null, blob);
    return metadataClone;
}
/**
 * Prepare RequestInfo for uploads as Content-Type: multipart.
 */ function $81ded97e27414374$var$multipartUpload(service, location, mappings, blob, metadata) {
    const urlPart = location.bucketOnlyServerUrl();
    const headers = {
        'X-Goog-Upload-Protocol': 'multipart'
    };
    function genBoundary() {
        let str = '';
        for(let i = 0; i < 2; i++)str = str + Math.random().toString().slice(2);
        return str;
    }
    const boundary = genBoundary();
    headers['Content-Type'] = 'multipart/related; boundary=' + boundary;
    const metadata_ = $81ded97e27414374$var$metadataForUpload_(location, blob, metadata);
    const metadataString = $81ded97e27414374$var$toResourceString(metadata_, mappings);
    const preBlobPart = '--' + boundary + '\r\n' + 'Content-Type: application/json; charset=utf-8\r\n\r\n' + metadataString + '\r\n--' + boundary + '\r\n' + 'Content-Type: ' + metadata_['contentType'] + '\r\n\r\n';
    const postBlobPart = '\r\n--' + boundary + '--';
    const body = $81ded97e27414374$export$8deea8629ff0b8a7.getBlob(preBlobPart, blob, postBlobPart);
    if (body === null) throw $81ded97e27414374$var$cannotSliceBlob();
    const urlParams = {
        name: metadata_['fullPath']
    };
    const url = $81ded97e27414374$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'POST';
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $81ded97e27414374$var$RequestInfo(url, method, $81ded97e27414374$var$metadataHandler(service, mappings), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.errorHandler = $81ded97e27414374$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param current The number of bytes that have been uploaded so far.
 * @param total The total number of bytes in the upload.
 * @param opt_finalized True if the server has finished the upload.
 * @param opt_metadata The upload metadata, should
 *     only be passed if opt_finalized is true.
 */ class $81ded97e27414374$var$ResumableUploadStatus {
    constructor(current, total, finalized, metadata){
        this.current = current;
        this.total = total;
        this.finalized = !!finalized;
        this.metadata = metadata || null;
    }
}
function $81ded97e27414374$var$checkResumeHeader_(xhr, allowed) {
    let status = null;
    try {
        status = xhr.getResponseHeader('X-Goog-Upload-Status');
    } catch (e) {
        $81ded97e27414374$var$handlerCheck(false);
    }
    const allowedStatus = allowed || [
        'active'
    ];
    $81ded97e27414374$var$handlerCheck(!!status && allowedStatus.indexOf(status) !== -1);
    return status;
}
function $81ded97e27414374$var$createResumableUpload(service, location, mappings, blob, metadata) {
    const urlPart = location.bucketOnlyServerUrl();
    const metadataForUpload = $81ded97e27414374$var$metadataForUpload_(location, blob, metadata);
    const urlParams = {
        name: metadataForUpload['fullPath']
    };
    const url = $81ded97e27414374$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'POST';
    const headers = {
        'X-Goog-Upload-Protocol': 'resumable',
        'X-Goog-Upload-Command': 'start',
        'X-Goog-Upload-Header-Content-Length': `${blob.size()}`,
        'X-Goog-Upload-Header-Content-Type': metadataForUpload['contentType'],
        'Content-Type': 'application/json; charset=utf-8'
    };
    const body = $81ded97e27414374$var$toResourceString(metadataForUpload, mappings);
    const timeout = service.maxUploadRetryTime;
    function handler(xhr) {
        $81ded97e27414374$var$checkResumeHeader_(xhr);
        let url;
        try {
            url = xhr.getResponseHeader('X-Goog-Upload-URL');
        } catch (e) {
            $81ded97e27414374$var$handlerCheck(false);
        }
        $81ded97e27414374$var$handlerCheck($81ded97e27414374$var$isString(url));
        return url;
    }
    const requestInfo = new $81ded97e27414374$var$RequestInfo(url, method, handler, timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $81ded97e27414374$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 */ function $81ded97e27414374$var$getResumableUploadStatus(service, location, url, blob) {
    const headers = {
        'X-Goog-Upload-Command': 'query'
    };
    function handler(xhr) {
        const status = $81ded97e27414374$var$checkResumeHeader_(xhr, [
            'active',
            'final'
        ]);
        let sizeString = null;
        try {
            sizeString = xhr.getResponseHeader('X-Goog-Upload-Size-Received');
        } catch (e) {
            $81ded97e27414374$var$handlerCheck(false);
        }
        if (!sizeString) // null or empty string
        $81ded97e27414374$var$handlerCheck(false);
        const size = Number(sizeString);
        $81ded97e27414374$var$handlerCheck(!isNaN(size));
        return new $81ded97e27414374$var$ResumableUploadStatus(size, blob.size(), status === 'final');
    }
    const method = 'POST';
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $81ded97e27414374$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.errorHandler = $81ded97e27414374$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * Any uploads via the resumable upload API must transfer a number of bytes
 * that is a multiple of this number.
 */ const $81ded97e27414374$var$RESUMABLE_UPLOAD_CHUNK_SIZE = 262144;
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 * @param chunkSize Number of bytes to upload.
 * @param status The previous status.
 *     If not passed or null, we start from the beginning.
 * @throws fbs.Error If the upload is already complete, the passed in status
 *     has a final size inconsistent with the blob, or the blob cannot be sliced
 *     for upload.
 */ function $81ded97e27414374$var$continueResumableUpload(location, service, url, blob, chunkSize, mappings, status, progressCallback) {
    // TODO(andysoto): standardize on internal asserts
    // assert(!(opt_status && opt_status.finalized));
    const status_ = new $81ded97e27414374$var$ResumableUploadStatus(0, 0);
    if (status) {
        status_.current = status.current;
        status_.total = status.total;
    } else {
        status_.current = 0;
        status_.total = blob.size();
    }
    if (blob.size() !== status_.total) throw $81ded97e27414374$var$serverFileWrongSize();
    const bytesLeft = status_.total - status_.current;
    let bytesToUpload = bytesLeft;
    if (chunkSize > 0) bytesToUpload = Math.min(bytesToUpload, chunkSize);
    const startByte = status_.current;
    const endByte = startByte + bytesToUpload;
    let uploadCommand = '';
    if (bytesToUpload === 0) uploadCommand = 'finalize';
    else if (bytesLeft === bytesToUpload) uploadCommand = 'upload, finalize';
    else uploadCommand = 'upload';
    const headers = {
        'X-Goog-Upload-Command': uploadCommand,
        'X-Goog-Upload-Offset': `${status_.current}`
    };
    const body = blob.slice(startByte, endByte);
    if (body === null) throw $81ded97e27414374$var$cannotSliceBlob();
    function handler(xhr, text) {
        // TODO(andysoto): Verify the MD5 of each uploaded range:
        // the 'x-range-md5' header comes back with status code 308 responses.
        // We'll only be able to bail out though, because you can't re-upload a
        // range that you previously uploaded.
        const uploadStatus = $81ded97e27414374$var$checkResumeHeader_(xhr, [
            'active',
            'final'
        ]);
        const newCurrent = status_.current + bytesToUpload;
        const size = blob.size();
        let metadata;
        if (uploadStatus === 'final') metadata = $81ded97e27414374$var$metadataHandler(service, mappings)(xhr, text);
        else metadata = null;
        return new $81ded97e27414374$var$ResumableUploadStatus(newCurrent, size, uploadStatus === 'final', metadata);
    }
    const method = 'POST';
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $81ded97e27414374$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.progressCallback = progressCallback || null;
    requestInfo.errorHandler = $81ded97e27414374$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event that is triggered on a task.
 * @internal
 */ const $81ded97e27414374$export$2cf04e0422ce9b07 = {
    /**
     * For this event,
     * <ul>
     *   <li>The `next` function is triggered on progress updates and when the
     *       task is paused/resumed with an `UploadTaskSnapshot` as the first
     *       argument.</li>
     *   <li>The `error` function is triggered if the upload is canceled or fails
     *       for another reason.</li>
     *   <li>The `complete` function is triggered if the upload completes
     *       successfully.</li>
     * </ul>
     */ STATE_CHANGED: 'state_changed'
};
// type keys = keyof TaskState
/**
 * Represents the current state of a running upload.
 * @internal
 */ const $81ded97e27414374$export$9dc4203728a9a7c9 = {
    /** The task is currently transferring data. */ RUNNING: 'running',
    /** The task was paused by the user. */ PAUSED: 'paused',
    /** The task completed successfully. */ SUCCESS: 'success',
    /** The task was canceled. */ CANCELED: 'canceled',
    /** The task failed with an error. */ ERROR: 'error'
};
function $81ded97e27414374$var$taskStateFromInternalTaskState(state) {
    switch(state){
        case "running" /* InternalTaskState.RUNNING */ :
        case "pausing" /* InternalTaskState.PAUSING */ :
        case "canceling" /* InternalTaskState.CANCELING */ :
            return $81ded97e27414374$export$9dc4203728a9a7c9.RUNNING;
        case "paused" /* InternalTaskState.PAUSED */ :
            return $81ded97e27414374$export$9dc4203728a9a7c9.PAUSED;
        case "success" /* InternalTaskState.SUCCESS */ :
            return $81ded97e27414374$export$9dc4203728a9a7c9.SUCCESS;
        case "canceled" /* InternalTaskState.CANCELED */ :
            return $81ded97e27414374$export$9dc4203728a9a7c9.CANCELED;
        case "error" /* InternalTaskState.ERROR */ :
            return $81ded97e27414374$export$9dc4203728a9a7c9.ERROR;
        default:
            // TODO(andysoto): assert(false);
            return $81ded97e27414374$export$9dc4203728a9a7c9.ERROR;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $81ded97e27414374$var$Observer {
    constructor(nextOrObserver, error, complete){
        const asFunctions = $81ded97e27414374$var$isFunction(nextOrObserver) || error != null || complete != null;
        if (asFunctions) {
            this.next = nextOrObserver;
            this.error = error ?? undefined;
            this.complete = complete ?? undefined;
        } else {
            const observer = nextOrObserver;
            this.next = observer.next;
            this.error = observer.error;
            this.complete = observer.complete;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a function that invokes f with its arguments asynchronously as a
 * microtask, i.e. as soon as possible after the current script returns back
 * into browser code.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $81ded97e27414374$var$async(f) {
    return (...argsToForward)=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.resolve().then(()=>f(...argsToForward));
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** An override for the text-based Connection. Used in tests. */ let $81ded97e27414374$var$textFactoryOverride = null;
/**
 * Network layer for browsers. We use this instead of goog.net.XhrIo because
 * goog.net.XhrIo is hyuuuuge and doesn't work in React Native on Android.
 */ class $81ded97e27414374$var$XhrConnection {
    constructor(){
        this.sent_ = false;
        this.xhr_ = new XMLHttpRequest();
        this.initXhr();
        this.errorCode_ = $81ded97e27414374$var$ErrorCode.NO_ERROR;
        this.sendPromise_ = new Promise((resolve)=>{
            this.xhr_.addEventListener('abort', ()=>{
                this.errorCode_ = $81ded97e27414374$var$ErrorCode.ABORT;
                resolve();
            });
            this.xhr_.addEventListener('error', ()=>{
                this.errorCode_ = $81ded97e27414374$var$ErrorCode.NETWORK_ERROR;
                resolve();
            });
            this.xhr_.addEventListener('load', ()=>{
                resolve();
            });
        });
    }
    send(url, method, isUsingEmulator, body, headers) {
        if (this.sent_) throw $81ded97e27414374$var$internalError('cannot .send() more than once');
        if ((0, $3117f6f4eeb4c314$export$5b4d24b45140ad90)(url) && isUsingEmulator) this.xhr_.withCredentials = true;
        this.sent_ = true;
        this.xhr_.open(method, url, true);
        if (headers !== undefined) {
            for(const key in headers)if (headers.hasOwnProperty(key)) this.xhr_.setRequestHeader(key, headers[key].toString());
        }
        if (body !== undefined) this.xhr_.send(body);
        else this.xhr_.send();
        return this.sendPromise_;
    }
    getErrorCode() {
        if (!this.sent_) throw $81ded97e27414374$var$internalError('cannot .getErrorCode() before sending');
        return this.errorCode_;
    }
    getStatus() {
        if (!this.sent_) throw $81ded97e27414374$var$internalError('cannot .getStatus() before sending');
        try {
            return this.xhr_.status;
        } catch (e) {
            return -1;
        }
    }
    getResponse() {
        if (!this.sent_) throw $81ded97e27414374$var$internalError('cannot .getResponse() before sending');
        return this.xhr_.response;
    }
    getErrorText() {
        if (!this.sent_) throw $81ded97e27414374$var$internalError('cannot .getErrorText() before sending');
        return this.xhr_.statusText;
    }
    /** Aborts the request. */ abort() {
        this.xhr_.abort();
    }
    getResponseHeader(header) {
        return this.xhr_.getResponseHeader(header);
    }
    addUploadProgressListener(listener) {
        if (this.xhr_.upload != null) this.xhr_.upload.addEventListener('progress', listener);
    }
    removeUploadProgressListener(listener) {
        if (this.xhr_.upload != null) this.xhr_.upload.removeEventListener('progress', listener);
    }
}
class $81ded97e27414374$var$XhrTextConnection extends $81ded97e27414374$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = 'text';
    }
}
function $81ded97e27414374$var$newTextConnection() {
    return $81ded97e27414374$var$textFactoryOverride ? $81ded97e27414374$var$textFactoryOverride() : new $81ded97e27414374$var$XhrTextConnection();
}
class $81ded97e27414374$var$XhrBytesConnection extends $81ded97e27414374$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = 'arraybuffer';
    }
}
function $81ded97e27414374$var$newBytesConnection() {
    return new $81ded97e27414374$var$XhrBytesConnection();
}
class $81ded97e27414374$var$XhrBlobConnection extends $81ded97e27414374$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = 'blob';
    }
}
function $81ded97e27414374$var$newBlobConnection() {
    return new $81ded97e27414374$var$XhrBlobConnection();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a blob being uploaded. Can be used to pause/resume/cancel the
 * upload and manage callbacks for various events.
 * @internal
 */ class $81ded97e27414374$export$86a2a9b92406a048 {
    isExponentialBackoffExpired() {
        return this.sleepTime > this.maxSleepTime;
    }
    /**
     * @param ref - The firebaseStorage.Reference object this task came
     *     from, untyped to avoid cyclic dependencies.
     * @param blob - The blob to upload.
     */ constructor(ref, blob, metadata = null){
        /**
         * Number of bytes transferred so far.
         */ this._transferred = 0;
        this._needToFetchStatus = false;
        this._needToFetchMetadata = false;
        this._observers = [];
        this._error = undefined;
        this._uploadUrl = undefined;
        this._request = undefined;
        this._chunkMultiplier = 1;
        this._resolve = undefined;
        this._reject = undefined;
        this._ref = ref;
        this._blob = blob;
        this._metadata = metadata;
        this._mappings = $81ded97e27414374$var$getMappings();
        this._resumable = this._shouldDoResumable(this._blob);
        this._state = "running" /* InternalTaskState.RUNNING */ ;
        this._errorHandler = (error)=>{
            this._request = undefined;
            this._chunkMultiplier = 1;
            if (error._codeEquals($81ded97e27414374$export$54592d666d6ce114.CANCELED)) {
                this._needToFetchStatus = true;
                this.completeTransitions_();
            } else {
                const backoffExpired = this.isExponentialBackoffExpired();
                if ($81ded97e27414374$var$isRetryStatusCode(error.status, [])) {
                    if (backoffExpired) error = $81ded97e27414374$var$retryLimitExceeded();
                    else {
                        this.sleepTime = Math.max(this.sleepTime * 2, $81ded97e27414374$var$DEFAULT_MIN_SLEEP_TIME_MILLIS);
                        this._needToFetchStatus = true;
                        this.completeTransitions_();
                        return;
                    }
                }
                this._error = error;
                this._transition("error" /* InternalTaskState.ERROR */ );
            }
        };
        this._metadataErrorHandler = (error)=>{
            this._request = undefined;
            if (error._codeEquals($81ded97e27414374$export$54592d666d6ce114.CANCELED)) this.completeTransitions_();
            else {
                this._error = error;
                this._transition("error" /* InternalTaskState.ERROR */ );
            }
        };
        this.sleepTime = 0;
        this.maxSleepTime = this._ref.storage.maxUploadRetryTime;
        this._promise = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
            this._start();
        });
        // Prevent uncaught rejections on the internal promise from bubbling out
        // to the top level with a dummy handler.
        this._promise.then(null, ()=>{});
    }
    _makeProgressCallback() {
        const sizeBefore = this._transferred;
        return (loaded)=>this._updateProgress(sizeBefore + loaded);
    }
    _shouldDoResumable(blob) {
        return blob.size() > 262144;
    }
    _start() {
        if (this._state !== "running" /* InternalTaskState.RUNNING */ ) // This can happen if someone pauses us in a resume callback, for example.
        return;
        if (this._request !== undefined) return;
        if (this._resumable) {
            if (this._uploadUrl === undefined) this._createResumable();
            else {
                if (this._needToFetchStatus) this._fetchStatus();
                else if (this._needToFetchMetadata) // Happens if we miss the metadata on upload completion.
                this._fetchMetadata();
                else this.pendingTimeout = setTimeout(()=>{
                    this.pendingTimeout = undefined;
                    this._continueUpload();
                }, this.sleepTime);
            }
        } else this._oneShotUpload();
    }
    _resolveToken(callback) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.all([
            this._ref.storage._getAuthToken(),
            this._ref.storage._getAppCheckToken()
        ]).then(([authToken, appCheckToken])=>{
            switch(this._state){
                case "running" /* InternalTaskState.RUNNING */ :
                    callback(authToken, appCheckToken);
                    break;
                case "canceling" /* InternalTaskState.CANCELING */ :
                    this._transition("canceled" /* InternalTaskState.CANCELED */ );
                    break;
                case "pausing" /* InternalTaskState.PAUSING */ :
                    this._transition("paused" /* InternalTaskState.PAUSED */ );
                    break;
            }
        });
    }
    // TODO(andysoto): assert false
    _createResumable() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $81ded97e27414374$var$createResumableUpload(this._ref.storage, this._ref._location, this._mappings, this._blob, this._metadata);
            const createRequest = this._ref.storage._makeRequest(requestInfo, $81ded97e27414374$var$newTextConnection, authToken, appCheckToken);
            this._request = createRequest;
            createRequest.getPromise().then((url)=>{
                this._request = undefined;
                this._uploadUrl = url;
                this._needToFetchStatus = false;
                this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _fetchStatus() {
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        const url = this._uploadUrl;
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $81ded97e27414374$var$getResumableUploadStatus(this._ref.storage, this._ref._location, url, this._blob);
            const statusRequest = this._ref.storage._makeRequest(requestInfo, $81ded97e27414374$var$newTextConnection, authToken, appCheckToken);
            this._request = statusRequest;
            statusRequest.getPromise().then((status)=>{
                status;
                this._request = undefined;
                this._updateProgress(status.current);
                this._needToFetchStatus = false;
                if (status.finalized) this._needToFetchMetadata = true;
                this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _continueUpload() {
        const chunkSize = $81ded97e27414374$var$RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
        const status = new $81ded97e27414374$var$ResumableUploadStatus(this._transferred, this._blob.size());
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        const url = this._uploadUrl;
        this._resolveToken((authToken, appCheckToken)=>{
            let requestInfo;
            try {
                requestInfo = $81ded97e27414374$var$continueResumableUpload(this._ref._location, this._ref.storage, url, this._blob, chunkSize, this._mappings, status, this._makeProgressCallback());
            } catch (e) {
                this._error = e;
                this._transition("error" /* InternalTaskState.ERROR */ );
                return;
            }
            const uploadRequest = this._ref.storage._makeRequest(requestInfo, $81ded97e27414374$var$newTextConnection, authToken, appCheckToken, /*retry=*/ false // Upload requests should not be retried as each retry should be preceded by another query request. Which is handled in this file.
            );
            this._request = uploadRequest;
            uploadRequest.getPromise().then((newStatus)=>{
                this._increaseMultiplier();
                this._request = undefined;
                this._updateProgress(newStatus.current);
                if (newStatus.finalized) {
                    this._metadata = newStatus.metadata;
                    this._transition("success" /* InternalTaskState.SUCCESS */ );
                } else this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _increaseMultiplier() {
        const currentSize = $81ded97e27414374$var$RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
        // Max chunk size is 32M.
        if (currentSize * 2 < 33554432) this._chunkMultiplier *= 2;
    }
    _fetchMetadata() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $81ded97e27414374$var$getMetadata$2(this._ref.storage, this._ref._location, this._mappings);
            const metadataRequest = this._ref.storage._makeRequest(requestInfo, $81ded97e27414374$var$newTextConnection, authToken, appCheckToken);
            this._request = metadataRequest;
            metadataRequest.getPromise().then((metadata)=>{
                this._request = undefined;
                this._metadata = metadata;
                this._transition("success" /* InternalTaskState.SUCCESS */ );
            }, this._metadataErrorHandler);
        });
    }
    _oneShotUpload() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $81ded97e27414374$var$multipartUpload(this._ref.storage, this._ref._location, this._mappings, this._blob, this._metadata);
            const multipartRequest = this._ref.storage._makeRequest(requestInfo, $81ded97e27414374$var$newTextConnection, authToken, appCheckToken);
            this._request = multipartRequest;
            multipartRequest.getPromise().then((metadata)=>{
                this._request = undefined;
                this._metadata = metadata;
                this._updateProgress(this._blob.size());
                this._transition("success" /* InternalTaskState.SUCCESS */ );
            }, this._errorHandler);
        });
    }
    _updateProgress(transferred) {
        const old = this._transferred;
        this._transferred = transferred;
        // A progress update can make the "transferred" value smaller (e.g. a
        // partial upload not completed by server, after which the "transferred"
        // value may reset to the value at the beginning of the request).
        if (this._transferred !== old) this._notifyObservers();
    }
    _transition(state) {
        if (this._state === state) return;
        switch(state){
            case "canceling" /* InternalTaskState.CANCELING */ :
            case "pausing" /* InternalTaskState.PAUSING */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING);
                this._state = state;
                if (this._request !== undefined) this._request.cancel();
                else if (this.pendingTimeout) {
                    clearTimeout(this.pendingTimeout);
                    this.pendingTimeout = undefined;
                    this.completeTransitions_();
                }
                break;
            case "running" /* InternalTaskState.RUNNING */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.PAUSING);
                const wasPaused = this._state === "paused" /* InternalTaskState.PAUSED */ ;
                this._state = state;
                if (wasPaused) {
                    this._notifyObservers();
                    this._start();
                }
                break;
            case "paused" /* InternalTaskState.PAUSED */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSING);
                this._state = state;
                this._notifyObservers();
                break;
            case "canceled" /* InternalTaskState.CANCELED */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._error = $81ded97e27414374$var$canceled();
                this._state = state;
                this._notifyObservers();
                break;
            case "error" /* InternalTaskState.ERROR */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._state = state;
                this._notifyObservers();
                break;
            case "success" /* InternalTaskState.SUCCESS */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._state = state;
                this._notifyObservers();
                break;
        }
    }
    completeTransitions_() {
        switch(this._state){
            case "pausing" /* InternalTaskState.PAUSING */ :
                this._transition("paused" /* InternalTaskState.PAUSED */ );
                break;
            case "canceling" /* InternalTaskState.CANCELING */ :
                this._transition("canceled" /* InternalTaskState.CANCELED */ );
                break;
            case "running" /* InternalTaskState.RUNNING */ :
                this._start();
                break;
        }
    }
    /**
     * A snapshot of the current task state.
     */ get snapshot() {
        const externalState = $81ded97e27414374$var$taskStateFromInternalTaskState(this._state);
        return {
            bytesTransferred: this._transferred,
            totalBytes: this._blob.size(),
            state: externalState,
            metadata: this._metadata,
            task: this,
            ref: this._ref
        };
    }
    /**
     * Adds a callback for an event.
     * @param type - The type of event to listen for.
     * @param nextOrObserver -
     *     The `next` function, which gets called for each item in
     *     the event stream, or an observer object with some or all of these three
     *     properties (`next`, `error`, `complete`).
     * @param error - A function that gets called with a `StorageError`
     *     if the event stream ends due to an error.
     * @param completed - A function that gets called if the
     *     event stream ends normally.
     * @returns
     *     If only the event argument is passed, returns a function you can use to
     *     add callbacks (see the examples above). If more than just the event
     *     argument is passed, returns a function you can call to unregister the
     *     callbacks.
     */ on(type, nextOrObserver, error, completed) {
        // Note: `type` isn't being used. Its type is also incorrect. TaskEvent should not be a string.
        const observer = new $81ded97e27414374$var$Observer(nextOrObserver || undefined, error || undefined, completed || undefined);
        this._addObserver(observer);
        return ()=>{
            this._removeObserver(observer);
        };
    }
    /**
     * This object behaves like a Promise, and resolves with its snapshot data
     * when the upload completes.
     * @param onFulfilled - The fulfillment callback. Promise chaining works as normal.
     * @param onRejected - The rejection callback.
     */ then(onFulfilled, onRejected) {
        // These casts are needed so that TypeScript can infer the types of the
        // resulting Promise.
        return this._promise.then(onFulfilled, onRejected);
    }
    /**
     * Equivalent to calling `then(null, onRejected)`.
     */ catch(onRejected) {
        return this.then(null, onRejected);
    }
    /**
     * Adds the given observer.
     */ _addObserver(observer) {
        this._observers.push(observer);
        this._notifyObserver(observer);
    }
    /**
     * Removes the given observer.
     */ _removeObserver(observer) {
        const i = this._observers.indexOf(observer);
        if (i !== -1) this._observers.splice(i, 1);
    }
    _notifyObservers() {
        this._finishPromise();
        const observers = this._observers.slice();
        observers.forEach((observer)=>{
            this._notifyObserver(observer);
        });
    }
    _finishPromise() {
        if (this._resolve !== undefined) {
            let triggered = true;
            switch($81ded97e27414374$var$taskStateFromInternalTaskState(this._state)){
                case $81ded97e27414374$export$9dc4203728a9a7c9.SUCCESS:
                    $81ded97e27414374$var$async(this._resolve.bind(null, this.snapshot))();
                    break;
                case $81ded97e27414374$export$9dc4203728a9a7c9.CANCELED:
                case $81ded97e27414374$export$9dc4203728a9a7c9.ERROR:
                    const toCall = this._reject;
                    $81ded97e27414374$var$async(toCall.bind(null, this._error))();
                    break;
                default:
                    triggered = false;
                    break;
            }
            if (triggered) {
                this._resolve = undefined;
                this._reject = undefined;
            }
        }
    }
    _notifyObserver(observer) {
        const externalState = $81ded97e27414374$var$taskStateFromInternalTaskState(this._state);
        switch(externalState){
            case $81ded97e27414374$export$9dc4203728a9a7c9.RUNNING:
            case $81ded97e27414374$export$9dc4203728a9a7c9.PAUSED:
                if (observer.next) $81ded97e27414374$var$async(observer.next.bind(observer, this.snapshot))();
                break;
            case $81ded97e27414374$export$9dc4203728a9a7c9.SUCCESS:
                if (observer.complete) $81ded97e27414374$var$async(observer.complete.bind(observer))();
                break;
            case $81ded97e27414374$export$9dc4203728a9a7c9.CANCELED:
            case $81ded97e27414374$export$9dc4203728a9a7c9.ERROR:
                if (observer.error) $81ded97e27414374$var$async(observer.error.bind(observer, this._error))();
                break;
            default:
                // TODO(andysoto): assert(false);
                if (observer.error) $81ded97e27414374$var$async(observer.error.bind(observer, this._error))();
        }
    }
    /**
     * Resumes a paused task. Has no effect on a currently running or failed task.
     * @returns True if the operation took effect, false if ignored.
     */ resume() {
        const valid = this._state === "paused" /* InternalTaskState.PAUSED */  || this._state === "pausing" /* InternalTaskState.PAUSING */ ;
        if (valid) this._transition("running" /* InternalTaskState.RUNNING */ );
        return valid;
    }
    /**
     * Pauses a currently running task. Has no effect on a paused or failed task.
     * @returns True if the operation took effect, false if ignored.
     */ pause() {
        const valid = this._state === "running" /* InternalTaskState.RUNNING */ ;
        if (valid) this._transition("pausing" /* InternalTaskState.PAUSING */ );
        return valid;
    }
    /**
     * Cancels a currently running or paused task. Has no effect on a complete or
     * failed task.
     * @returns True if the operation took effect, false if ignored.
     */ cancel() {
        const valid = this._state === "running" /* InternalTaskState.RUNNING */  || this._state === "pausing" /* InternalTaskState.PAUSING */ ;
        if (valid) this._transition("canceling" /* InternalTaskState.CANCELING */ );
        return valid;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides methods to interact with a bucket in the Firebase Storage service.
 * @internal
 * @param _location - An fbs.location, or the URL at
 *     which to base this object, in one of the following forms:
 *         gs://<bucket>/<object-path>
 *         http[s]://firebasestorage.googleapis.com/
 *                     <api-version>/b/<bucket>/o/<object-path>
 *     Any query or fragment strings will be ignored in the http[s]
 *     format. If no value is passed, the storage object will use a URL based on
 *     the project ID of the base firebase.App instance.
 */ class $81ded97e27414374$var$Reference {
    constructor(_service, location){
        this._service = _service;
        if (location instanceof $81ded97e27414374$export$adb98fff6714334) this._location = location;
        else this._location = $81ded97e27414374$export$adb98fff6714334.makeFromUrl(location, _service.host);
    }
    /**
     * Returns the URL for the bucket and path this object references,
     *     in the form gs://<bucket>/<object-path>
     * @override
     */ toString() {
        return 'gs://' + this._location.bucket + '/' + this._location.path;
    }
    _newRef(service, location) {
        return new $81ded97e27414374$var$Reference(service, location);
    }
    /**
     * A reference to the root of this object's bucket.
     */ get root() {
        const location = new $81ded97e27414374$export$adb98fff6714334(this._location.bucket, '');
        return this._newRef(this._service, location);
    }
    /**
     * The name of the bucket containing this reference's object.
     */ get bucket() {
        return this._location.bucket;
    }
    /**
     * The full path of this object.
     */ get fullPath() {
        return this._location.path;
    }
    /**
     * The short name of this object, which is the last component of the full path.
     * For example, if fullPath is 'full/path/image.png', name is 'image.png'.
     */ get name() {
        return $81ded97e27414374$var$lastComponent(this._location.path);
    }
    /**
     * The `StorageService` instance this `StorageReference` is associated with.
     */ get storage() {
        return this._service;
    }
    /**
     * A `StorageReference` pointing to the parent location of this `StorageReference`, or null if
     * this reference is the root.
     */ get parent() {
        const newPath = $81ded97e27414374$var$parent(this._location.path);
        if (newPath === null) return null;
        const location = new $81ded97e27414374$export$adb98fff6714334(this._location.bucket, newPath);
        return new $81ded97e27414374$var$Reference(this._service, location);
    }
    /**
     * Utility function to throw an error in methods that do not accept a root reference.
     */ _throwIfRoot(name) {
        if (this._location.path === '') throw $81ded97e27414374$export$61f54cdc36500ad(name);
    }
}
/**
 * Download the bytes at the object's location.
 * @returns A Promise containing the downloaded bytes.
 */ function $81ded97e27414374$var$getBytesInternal(ref, maxDownloadSizeBytes) {
    ref._throwIfRoot('getBytes');
    const requestInfo = $81ded97e27414374$var$getBytes$1(ref.storage, ref._location, maxDownloadSizeBytes);
    return ref.storage.makeRequestWithTokens(requestInfo, $81ded97e27414374$var$newBytesConnection).then((bytes)=>maxDownloadSizeBytes !== undefined ? bytes.slice(0, maxDownloadSizeBytes) : bytes);
}
/**
 * Download the bytes at the object's location.
 * @returns A Promise containing the downloaded blob.
 */ function $81ded97e27414374$var$getBlobInternal(ref, maxDownloadSizeBytes) {
    ref._throwIfRoot('getBlob');
    const requestInfo = $81ded97e27414374$var$getBytes$1(ref.storage, ref._location, maxDownloadSizeBytes);
    return ref.storage.makeRequestWithTokens(requestInfo, $81ded97e27414374$var$newBlobConnection).then((blob)=>maxDownloadSizeBytes !== undefined ? blob.slice(0, maxDownloadSizeBytes) : blob);
}
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 *
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns A Promise containing an UploadResult
 */ function $81ded97e27414374$var$uploadBytes$1(ref, data, metadata) {
    ref._throwIfRoot('uploadBytes');
    const requestInfo = $81ded97e27414374$var$multipartUpload(ref.storage, ref._location, $81ded97e27414374$var$getMappings(), new $81ded97e27414374$export$8deea8629ff0b8a7(data, true), metadata);
    return ref.storage.makeRequestWithTokens(requestInfo, $81ded97e27414374$var$newTextConnection).then((finalMetadata)=>{
        return {
            metadata: finalMetadata,
            ref: ref
        };
    });
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns An UploadTask
 */ function $81ded97e27414374$var$uploadBytesResumable$1(ref, data, metadata) {
    ref._throwIfRoot('uploadBytesResumable');
    return new $81ded97e27414374$export$86a2a9b92406a048(ref, new $81ded97e27414374$export$8deea8629ff0b8a7(data), metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - StorageReference where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the newly uploaded string.
 * @returns A Promise containing an UploadResult
 */ function $81ded97e27414374$var$uploadString$1(ref, value, format = $81ded97e27414374$export$f22e7fe56db8ae03.RAW, metadata) {
    ref._throwIfRoot('uploadString');
    const data = $81ded97e27414374$export$d80b9b5a2ccdd3e0(format, value);
    const metadataClone = {
        ...metadata
    };
    if (metadataClone['contentType'] == null && data.contentType != null) metadataClone['contentType'] = data.contentType;
    return $81ded97e27414374$var$uploadBytes$1(ref, data.data, metadataClone);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: listAll may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - StorageReference to get list from.
 *
 * @returns A Promise that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */ function $81ded97e27414374$var$listAll$1(ref) {
    const accumulator = {
        prefixes: [],
        items: []
    };
    return $81ded97e27414374$var$listAllHelper(ref, accumulator).then(()=>accumulator);
}
/**
 * Separated from listAll because async functions can't use "arguments".
 * @param ref
 * @param accumulator
 * @param pageToken
 */ async function $81ded97e27414374$var$listAllHelper(ref, accumulator, pageToken) {
    const opt = {
        pageToken: // maxResults is 1000 by default.
        pageToken
    };
    const nextPage = await $81ded97e27414374$var$list$1(ref, opt);
    accumulator.prefixes.push(...nextPage.prefixes);
    accumulator.items.push(...nextPage.items);
    if (nextPage.nextPageToken != null) await $81ded97e27414374$var$listAllHelper(ref, accumulator, nextPage.nextPageToken);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - StorageReference to get list from.
 * @param options - See ListOptions for details.
 * @returns A Promise that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */ function $81ded97e27414374$var$list$1(ref, options) {
    if (options != null) {
        if (typeof options.maxResults === 'number') $81ded97e27414374$var$validateNumber('options.maxResults', /* minValue= */ 1, /* maxValue= */ 1000, options.maxResults);
    }
    const op = options || {};
    const requestInfo = $81ded97e27414374$var$list$2(ref.storage, ref._location, /*delimiter= */ '/', op.pageToken, op.maxResults);
    return ref.storage.makeRequestWithTokens(requestInfo, $81ded97e27414374$var$newTextConnection);
}
/**
 * A `Promise` that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retrieved, the promise is
 * rejected.
 * @public
 * @param ref - StorageReference to get metadata from.
 */ function $81ded97e27414374$var$getMetadata$1(ref) {
    ref._throwIfRoot('getMetadata');
    const requestInfo = $81ded97e27414374$var$getMetadata$2(ref.storage, ref._location, $81ded97e27414374$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $81ded97e27414374$var$newTextConnection);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - StorageReference to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A `Promise` that resolves
 *     with the new metadata for this object.
 *     See `firebaseStorage.Reference.prototype.getMetadata`
 */ function $81ded97e27414374$var$updateMetadata$1(ref, metadata) {
    ref._throwIfRoot('updateMetadata');
    const requestInfo = $81ded97e27414374$var$updateMetadata$2(ref.storage, ref._location, metadata, $81ded97e27414374$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $81ded97e27414374$var$newTextConnection);
}
/**
 * Returns the download URL for the given Reference.
 * @public
 * @returns A `Promise` that resolves with the download
 *     URL for this object.
 */ function $81ded97e27414374$var$getDownloadURL$1(ref) {
    ref._throwIfRoot('getDownloadURL');
    const requestInfo = $81ded97e27414374$var$getDownloadUrl(ref.storage, ref._location, $81ded97e27414374$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $81ded97e27414374$var$newTextConnection).then((url)=>{
        if (url === null) throw $81ded97e27414374$var$noDownloadURL();
        return url;
    });
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - StorageReference for object to delete.
 * @returns A `Promise` that resolves if the deletion succeeds.
 */ function $81ded97e27414374$var$deleteObject$1(ref) {
    ref._throwIfRoot('deleteObject');
    const requestInfo = $81ded97e27414374$var$deleteObject$2(ref.storage, ref._location);
    return ref.storage.makeRequestWithTokens(requestInfo, $81ded97e27414374$var$newTextConnection);
}
/**
 * Returns reference for object obtained by appending `childPath` to `ref`.
 *
 * @param ref - StorageReference to get child of.
 * @param childPath - Child path from provided ref.
 * @returns A reference to the object obtained by
 * appending childPath, removing any duplicate, beginning, or trailing
 * slashes.
 *
 */ function $81ded97e27414374$var$_getChild$1(ref, childPath) {
    const newPath = $81ded97e27414374$var$child(ref._location.path, childPath);
    const location = new $81ded97e27414374$export$adb98fff6714334(ref._location.bucket, newPath);
    return new $81ded97e27414374$var$Reference(ref.storage, location);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $81ded97e27414374$var$isUrl(path) {
    return /^[A-Za-z]+:\/\//.test(path);
}
/**
 * Returns a firebaseStorage.Reference for the given url.
 */ function $81ded97e27414374$var$refFromURL(service, url) {
    return new $81ded97e27414374$var$Reference(service, url);
}
/**
 * Returns a firebaseStorage.Reference for the given path in the default
 * bucket.
 */ function $81ded97e27414374$var$refFromPath(ref, path) {
    if (ref instanceof $81ded97e27414374$var$FirebaseStorageImpl) {
        const service = ref;
        if (service._bucket == null) throw $81ded97e27414374$var$noDefaultBucket();
        const reference = new $81ded97e27414374$var$Reference(service, service._bucket);
        if (path != null) return $81ded97e27414374$var$refFromPath(reference, path);
        else return reference;
    } else {
        // ref is a Reference
        if (path !== undefined) return $81ded97e27414374$var$_getChild$1(ref, path);
        else return ref;
    }
}
function $81ded97e27414374$var$ref$1(serviceOrRef, pathOrUrl) {
    if (pathOrUrl && $81ded97e27414374$var$isUrl(pathOrUrl)) {
        if (serviceOrRef instanceof $81ded97e27414374$var$FirebaseStorageImpl) return $81ded97e27414374$var$refFromURL(serviceOrRef, pathOrUrl);
        else throw $81ded97e27414374$export$8f74d9881d1936fd('To use ref(service, url), the first argument must be a Storage instance.');
    } else return $81ded97e27414374$var$refFromPath(serviceOrRef, pathOrUrl);
}
function $81ded97e27414374$var$extractBucket(host, config) {
    const bucketString = config?.[$81ded97e27414374$var$CONFIG_STORAGE_BUCKET_KEY];
    if (bucketString == null) return null;
    return $81ded97e27414374$export$adb98fff6714334.makeFromBucketSpec(bucketString, host);
}
function $81ded97e27414374$var$connectStorageEmulator$1(storage, host, port, options = {}) {
    storage.host = `${host}:${port}`;
    const useSsl = (0, $3117f6f4eeb4c314$export$5b4d24b45140ad90)(host);
    // Workaround to get cookies in Firebase Studio
    if (useSsl) {
        (0, $3117f6f4eeb4c314$export$c0f0d0ce4283a937)(`https://${storage.host}/b`);
        (0, $3117f6f4eeb4c314$export$fd3d2954543183b1)('Storage', true);
    }
    storage._isUsingEmulator = true;
    storage._protocol = useSsl ? 'https' : 'http';
    const { mockUserToken: mockUserToken } = options;
    if (mockUserToken) storage._overrideAuthToken = typeof mockUserToken === 'string' ? mockUserToken : (0, $3117f6f4eeb4c314$export$367bf224123348f1)(mockUserToken, storage.app.options.projectId);
}
/**
 * A service that provides Firebase Storage Reference instances.
 * @param opt_url - gs:// url to a custom Storage Bucket
 *
 * @internal
 */ class $81ded97e27414374$var$FirebaseStorageImpl {
    constructor(/**
     * FirebaseApp associated with this StorageService instance.
     */ app, _authProvider, /**
     * @internal
     */ _appCheckProvider, /**
     * @internal
     */ _url, _firebaseVersion, _isUsingEmulator = false){
        this.app = app;
        this._authProvider = _authProvider;
        this._appCheckProvider = _appCheckProvider;
        this._url = _url;
        this._firebaseVersion = _firebaseVersion;
        this._isUsingEmulator = _isUsingEmulator;
        this._bucket = null;
        /**
         * This string can be in the formats:
         * - host
         * - host:port
         */ this._host = $81ded97e27414374$var$DEFAULT_HOST;
        this._protocol = 'https';
        this._appId = null;
        this._deleted = false;
        this._maxOperationRetryTime = $81ded97e27414374$var$DEFAULT_MAX_OPERATION_RETRY_TIME;
        this._maxUploadRetryTime = $81ded97e27414374$var$DEFAULT_MAX_UPLOAD_RETRY_TIME;
        this._requests = new Set();
        if (_url != null) this._bucket = $81ded97e27414374$export$adb98fff6714334.makeFromBucketSpec(_url, this._host);
        else this._bucket = $81ded97e27414374$var$extractBucket(this._host, this.app.options);
    }
    /**
     * The host string for this service, in the form of `host` or
     * `host:port`.
     */ get host() {
        return this._host;
    }
    set host(host) {
        this._host = host;
        if (this._url != null) this._bucket = $81ded97e27414374$export$adb98fff6714334.makeFromBucketSpec(this._url, host);
        else this._bucket = $81ded97e27414374$var$extractBucket(host, this.app.options);
    }
    /**
     * The maximum time to retry uploads in milliseconds.
     */ get maxUploadRetryTime() {
        return this._maxUploadRetryTime;
    }
    set maxUploadRetryTime(time) {
        $81ded97e27414374$var$validateNumber('time', /* minValue=*/ 0, /* maxValue= */ Number.POSITIVE_INFINITY, time);
        this._maxUploadRetryTime = time;
    }
    /**
     * The maximum time to retry operations other than uploads or downloads in
     * milliseconds.
     */ get maxOperationRetryTime() {
        return this._maxOperationRetryTime;
    }
    set maxOperationRetryTime(time) {
        $81ded97e27414374$var$validateNumber('time', /* minValue=*/ 0, /* maxValue= */ Number.POSITIVE_INFINITY, time);
        this._maxOperationRetryTime = time;
    }
    async _getAuthToken() {
        if (this._overrideAuthToken) return this._overrideAuthToken;
        const auth = this._authProvider.getImmediate({
            optional: true
        });
        if (auth) {
            const tokenData = await auth.getToken();
            if (tokenData !== null) return tokenData.accessToken;
        }
        return null;
    }
    async _getAppCheckToken() {
        if ((0, $0c1331d0a001f5bc$export$643c8bc6c389f34e)(this.app) && this.app.settings.appCheckToken) return this.app.settings.appCheckToken;
        const appCheck = this._appCheckProvider.getImmediate({
            optional: true
        });
        if (appCheck) {
            const result = await appCheck.getToken();
            // TODO: What do we want to do if there is an error getting the token?
            // Context: appCheck.getToken() will never throw even if an error happened. In the error case, a dummy token will be
            // returned along with an error field describing the error. In general, we shouldn't care about the error condition and just use
            // the token (actual or dummy) to send requests.
            return result.token;
        }
        return null;
    }
    /**
     * Stop running requests and prevent more from being created.
     */ _delete() {
        if (!this._deleted) {
            this._deleted = true;
            this._requests.forEach((request)=>request.cancel());
            this._requests.clear();
        }
        return Promise.resolve();
    }
    /**
     * Returns a new firebaseStorage.Reference object referencing this StorageService
     * at the given Location.
     */ _makeStorageReference(loc) {
        return new $81ded97e27414374$var$Reference(this, loc);
    }
    /**
     * @param requestInfo - HTTP RequestInfo object
     * @param authToken - Firebase auth token
     */ _makeRequest(requestInfo, requestFactory, authToken, appCheckToken, retry = true) {
        if (!this._deleted) {
            const request = $81ded97e27414374$var$makeRequest(requestInfo, this._appId, authToken, appCheckToken, requestFactory, this._firebaseVersion, retry, this._isUsingEmulator);
            this._requests.add(request);
            // Request removes itself from set when complete.
            request.getPromise().then(()=>this._requests.delete(request), ()=>this._requests.delete(request));
            return request;
        } else return new $81ded97e27414374$var$FailRequest($81ded97e27414374$var$appDeleted());
    }
    async makeRequestWithTokens(requestInfo, requestFactory) {
        const [authToken, appCheckToken] = await Promise.all([
            this._getAuthToken(),
            this._getAppCheckToken()
        ]);
        return this._makeRequest(requestInfo, requestFactory, authToken, appCheckToken).getPromise();
    }
}
const $81ded97e27414374$var$name = "@firebase/storage";
const $81ded97e27414374$var$version = "0.14.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Storage.
 */ const $81ded97e27414374$var$STORAGE_TYPE = 'storage';
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Downloads the data at the object's location. Returns an error if the object
 * is not found.
 *
 * To use this functionality, you have to whitelist your app's origin in your
 * Cloud Storage bucket. See also
 * https://cloud.google.com/storage/docs/configuring-cors
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A Promise containing the object's bytes
 */ function $81ded97e27414374$export$a3521add2594f3c8(ref, maxDownloadSizeBytes) {
    ref = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(ref);
    return $81ded97e27414374$var$getBytesInternal(ref, maxDownloadSizeBytes);
}
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - {@link StorageReference} where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns A Promise containing an UploadResult
 */ function $81ded97e27414374$export$ac40f56b52f99dd1(ref, data, metadata) {
    ref = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(ref);
    return $81ded97e27414374$var$uploadBytes$1(ref, data, metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - {@link StorageReference} where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the string to upload.
 * @returns A Promise containing an UploadResult
 */ function $81ded97e27414374$export$d885b2eb178808b3(ref, value, format, metadata) {
    ref = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(ref);
    return $81ded97e27414374$var$uploadString$1(ref, value, format, metadata);
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - {@link StorageReference} where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns An UploadTask
 */ function $81ded97e27414374$export$3895d39eb7ac9b25(ref, data, metadata) {
    ref = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(ref);
    return $81ded97e27414374$var$uploadBytesResumable$1(ref, data, metadata);
}
/**
 * A `Promise` that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retrieved, the promise is
 * rejected.
 * @public
 * @param ref - {@link StorageReference} to get metadata from.
 */ function $81ded97e27414374$export$8548546c0aa631e6(ref) {
    ref = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(ref);
    return $81ded97e27414374$var$getMetadata$1(ref);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - {@link StorageReference} to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A `Promise` that resolves with the new metadata for this object.
 */ function $81ded97e27414374$export$f64791b2d30456a0(ref, metadata) {
    ref = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(ref);
    return $81ded97e27414374$var$updateMetadata$1(ref, metadata);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - {@link StorageReference} to get list from.
 * @param options - See {@link ListOptions} for details.
 * @returns A `Promise` that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */ function $81ded97e27414374$export$8837f4fc672e936d(ref, options) {
    ref = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(ref);
    return $81ded97e27414374$var$list$1(ref, options);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: `listAll` may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - {@link StorageReference} to get list from.
 *
 * @returns A `Promise` that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */ function $81ded97e27414374$export$6a265a7d315dec03(ref) {
    ref = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(ref);
    return $81ded97e27414374$var$listAll$1(ref);
}
/**
 * Returns the download URL for the given {@link StorageReference}.
 * @public
 * @param ref - {@link StorageReference} to get the download URL for.
 * @returns A `Promise` that resolves with the download
 *     URL for this object.
 */ function $81ded97e27414374$export$c8bf645a0c2a7d9f(ref) {
    ref = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(ref);
    return $81ded97e27414374$var$getDownloadURL$1(ref);
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - {@link StorageReference} for object to delete.
 * @returns A `Promise` that resolves if the deletion succeeds.
 */ function $81ded97e27414374$export$39c5ed4ec960eade(ref) {
    ref = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(ref);
    return $81ded97e27414374$var$deleteObject$1(ref);
}
function $81ded97e27414374$export$eff4d24c3ff7876e(serviceOrRef, pathOrUrl) {
    serviceOrRef = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(serviceOrRef);
    return $81ded97e27414374$var$ref$1(serviceOrRef, pathOrUrl);
}
/**
 * @internal
 */ function $81ded97e27414374$export$9acd24c0fce96a85(ref, childPath) {
    return $81ded97e27414374$var$_getChild$1(ref, childPath);
}
/**
 * Gets a {@link FirebaseStorage} instance for the given Firebase app.
 * @public
 * @param app - Firebase app to get {@link FirebaseStorage} instance for.
 * @param bucketUrl - The gs:// url to your Firebase Storage Bucket.
 * If not passed, uses the app's default Storage Bucket.
 * @returns A {@link FirebaseStorage} instance.
 */ function $81ded97e27414374$export$fbd9b57a66480737(app = (0, $0c1331d0a001f5bc$export$f9962582c9e66d99)(), bucketUrl) {
    app = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(app);
    const storageProvider = (0, $0c1331d0a001f5bc$export$fa0d6da0f5838f50)(app, $81ded97e27414374$var$STORAGE_TYPE);
    const storageInstance = storageProvider.getImmediate({
        identifier: bucketUrl
    });
    const emulator = (0, $3117f6f4eeb4c314$export$a3febcf1f14a3a0c)('storage');
    if (emulator) $81ded97e27414374$export$9850e656f954b889(storageInstance, ...emulator);
    return storageInstance;
}
/**
 * Modify this {@link FirebaseStorage} instance to communicate with the Cloud Storage emulator.
 *
 * @param storage - The {@link FirebaseStorage} instance
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 5001)
 * @param options - Emulator options. `options.mockUserToken` is the mock auth
 * token to use for unit testing Security Rules.
 * @public
 */ function $81ded97e27414374$export$9850e656f954b889(storage, host, port, options = {}) {
    $81ded97e27414374$var$connectStorageEmulator$1(storage, host, port, options);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Downloads the data at the object's location. Returns an error if the object
 * is not found.
 *
 * To use this functionality, you have to whitelist your app's origin in your
 * Cloud Storage bucket. See also
 * https://cloud.google.com/storage/docs/configuring-cors
 *
 * This API is not available in Node.
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A Promise that resolves with a Blob containing the object's bytes
 */ function $81ded97e27414374$export$37610328929d7521(ref, maxDownloadSizeBytes) {
    ref = (0, $3117f6f4eeb4c314$export$4befe9b5fa509a1b)(ref);
    return $81ded97e27414374$var$getBlobInternal(ref, maxDownloadSizeBytes);
}
/**
 * Downloads the data at the object's location. Raises an error event if the
 * object is not found.
 *
 * This API is only available in Node.
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A stream with the object's data as bytes
 */ function $81ded97e27414374$export$747191980cdf43e8(ref, maxDownloadSizeBytes) {
    throw new Error('getStream() is only supported by NodeJS builds');
}
/**
 * Cloud Storage for Firebase
 *
 * @packageDocumentation
 */ function $81ded97e27414374$var$factory(container, { instanceIdentifier: url }) {
    const app = container.getProvider('app').getImmediate();
    const authProvider = container.getProvider('auth-internal');
    const appCheckProvider = container.getProvider('app-check-internal');
    return new $81ded97e27414374$var$FirebaseStorageImpl(app, authProvider, appCheckProvider, url, (0, $0c1331d0a001f5bc$export$31499a9cd224b78c));
}
function $81ded97e27414374$var$registerStorage() {
    (0, $0c1331d0a001f5bc$export$c930050e7bb63965)(new (0, $ad76b76e741ec0c7$export$16fa2f45be04daa8)($81ded97e27414374$var$STORAGE_TYPE, $81ded97e27414374$var$factory, "PUBLIC" /* ComponentType.PUBLIC */ ).setMultipleInstances(true));
    //RUNTIME_ENV will be replaced during the compilation to "node" for nodejs and an empty string for browser
    (0, $0c1331d0a001f5bc$export$d29d5299a7137abc)($81ded97e27414374$var$name, $81ded97e27414374$var$version, '');
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    (0, $0c1331d0a001f5bc$export$d29d5299a7137abc)($81ded97e27414374$var$name, $81ded97e27414374$var$version, 'esm2020');
}
$81ded97e27414374$var$registerStorage();



/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $63e774032d00835e$var$UploadTaskSnapshotCompat {
    constructor(_delegate, task, ref){
        this._delegate = _delegate;
        this.task = task;
        this.ref = ref;
    }
    get bytesTransferred() {
        return this._delegate.bytesTransferred;
    }
    get metadata() {
        return this._delegate.metadata;
    }
    get state() {
        return this._delegate.state;
    }
    get totalBytes() {
        return this._delegate.totalBytes;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $63e774032d00835e$var$UploadTaskCompat {
    constructor(_delegate, _ref){
        this._delegate = _delegate;
        this._ref = _ref;
        this.cancel = this._delegate.cancel.bind(this._delegate);
        this.catch = this._delegate.catch.bind(this._delegate);
        this.pause = this._delegate.pause.bind(this._delegate);
        this.resume = this._delegate.resume.bind(this._delegate);
    }
    get snapshot() {
        return new $63e774032d00835e$var$UploadTaskSnapshotCompat(this._delegate.snapshot, this, this._ref);
    }
    then(onFulfilled, onRejected) {
        return this._delegate.then((snapshot)=>{
            if (onFulfilled) return onFulfilled(new $63e774032d00835e$var$UploadTaskSnapshotCompat(snapshot, this, this._ref));
        }, onRejected);
    }
    on(type, nextOrObserver, error, completed) {
        let wrappedNextOrObserver = undefined;
        if (!!nextOrObserver) {
            if (typeof nextOrObserver === 'function') wrappedNextOrObserver = (taskSnapshot)=>nextOrObserver(new $63e774032d00835e$var$UploadTaskSnapshotCompat(taskSnapshot, this, this._ref));
            else wrappedNextOrObserver = {
                next: !!nextOrObserver.next ? (taskSnapshot)=>nextOrObserver.next(new $63e774032d00835e$var$UploadTaskSnapshotCompat(taskSnapshot, this, this._ref)) : undefined,
                complete: nextOrObserver.complete || undefined,
                error: nextOrObserver.error || undefined
            };
        }
        return this._delegate.on(type, wrappedNextOrObserver, error || undefined, completed || undefined);
    }
}
class $63e774032d00835e$var$ListResultCompat {
    constructor(_delegate, _service){
        this._delegate = _delegate;
        this._service = _service;
    }
    get prefixes() {
        return this._delegate.prefixes.map((ref)=>new $63e774032d00835e$var$ReferenceCompat(ref, this._service));
    }
    get items() {
        return this._delegate.items.map((ref)=>new $63e774032d00835e$var$ReferenceCompat(ref, this._service));
    }
    get nextPageToken() {
        return this._delegate.nextPageToken || null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $63e774032d00835e$var$ReferenceCompat {
    constructor(_delegate, storage){
        this._delegate = _delegate;
        this.storage = storage;
    }
    get name() {
        return this._delegate.name;
    }
    get bucket() {
        return this._delegate.bucket;
    }
    get fullPath() {
        return this._delegate.fullPath;
    }
    toString() {
        return this._delegate.toString();
    }
    /**
     * @returns A reference to the object obtained by
     * appending childPath, removing any duplicate, beginning, or trailing
     * slashes.
     */ child(childPath) {
        const reference = (0, $81ded97e27414374$export$9acd24c0fce96a85)(this._delegate, childPath);
        return new $63e774032d00835e$var$ReferenceCompat(reference, this.storage);
    }
    get root() {
        return new $63e774032d00835e$var$ReferenceCompat(this._delegate.root, this.storage);
    }
    /**
     * @returns A reference to the parent of the
     * current object, or null if the current object is the root.
     */ get parent() {
        const reference = this._delegate.parent;
        if (reference == null) return null;
        return new $63e774032d00835e$var$ReferenceCompat(reference, this.storage);
    }
    /**
     * Uploads a blob to this object's location.
     * @param data - The blob to upload.
     * @returns An UploadTask that lets you control and
     * observe the upload.
     */ put(data, metadata) {
        this._throwIfRoot('put');
        return new $63e774032d00835e$var$UploadTaskCompat((0, $81ded97e27414374$export$3895d39eb7ac9b25)(this._delegate, data, metadata), this);
    }
    /**
     * Uploads a string to this object's location.
     * @param value - The string to upload.
     * @param format - The format of the string to upload.
     * @returns An UploadTask that lets you control and
     * observe the upload.
     */ putString(value, format = (0, $81ded97e27414374$export$f22e7fe56db8ae03).RAW, metadata) {
        this._throwIfRoot('putString');
        const data = (0, $81ded97e27414374$export$d80b9b5a2ccdd3e0)(format, value);
        const metadataClone = {
            ...metadata
        };
        if (metadataClone['contentType'] == null && data.contentType != null) metadataClone['contentType'] = data.contentType;
        return new $63e774032d00835e$var$UploadTaskCompat(new (0, $81ded97e27414374$export$86a2a9b92406a048)(this._delegate, new (0, $81ded97e27414374$export$8deea8629ff0b8a7)(data.data, true), metadataClone), this);
    }
    /**
     * List all items (files) and prefixes (folders) under this storage reference.
     *
     * This is a helper method for calling list() repeatedly until there are
     * no more results. The default pagination size is 1000.
     *
     * Note: The results may not be consistent if objects are changed while this
     * operation is running.
     *
     * Warning: listAll may potentially consume too many resources if there are
     * too many results.
     *
     * @returns A Promise that resolves with all the items and prefixes under
     *  the current storage reference. `prefixes` contains references to
     *  sub-directories and `items` contains references to objects in this
     *  folder. `nextPageToken` is never returned.
     */ listAll() {
        return (0, $81ded97e27414374$export$6a265a7d315dec03)(this._delegate).then((r)=>new $63e774032d00835e$var$ListResultCompat(r, this.storage));
    }
    /**
     * List items (files) and prefixes (folders) under this storage reference.
     *
     * List API is only available for Firebase Rules Version 2.
     *
     * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
     * delimited folder structure. Refer to GCS's List API if you want to learn more.
     *
     * To adhere to Firebase Rules's Semantics, Firebase Storage does not
     * support objects whose paths end with "/" or contain two consecutive
     * "/"s. Firebase Storage List API will filter these unsupported objects.
     * list() may fail if there are too many unsupported objects in the bucket.
     *
     * @param options - See ListOptions for details.
     * @returns A Promise that resolves with the items and prefixes.
     * `prefixes` contains references to sub-folders and `items`
     * contains references to objects in this folder. `nextPageToken`
     * can be used to get the rest of the results.
     */ list(options) {
        return (0, $81ded97e27414374$export$8837f4fc672e936d)(this._delegate, options || undefined).then((r)=>new $63e774032d00835e$var$ListResultCompat(r, this.storage));
    }
    /**
     * A `Promise` that resolves with the metadata for this object. If this
     * object doesn't exist or metadata cannot be retrieved, the promise is
     * rejected.
     */ getMetadata() {
        return (0, $81ded97e27414374$export$8548546c0aa631e6)(this._delegate);
    }
    /**
     * Updates the metadata for this object.
     * @param metadata - The new metadata for the object.
     * Only values that have been explicitly set will be changed. Explicitly
     * setting a value to null will remove the metadata.
     * @returns A `Promise` that resolves
     * with the new metadata for this object.
     * @see firebaseStorage.Reference.prototype.getMetadata
     */ updateMetadata(metadata) {
        return (0, $81ded97e27414374$export$f64791b2d30456a0)(this._delegate, metadata);
    }
    /**
     * @returns A `Promise` that resolves with the download
     * URL for this object.
     */ getDownloadURL() {
        return (0, $81ded97e27414374$export$c8bf645a0c2a7d9f)(this._delegate);
    }
    /**
     * Deletes the object at this location.
     * @returns A `Promise` that resolves if the deletion succeeds.
     */ delete() {
        this._throwIfRoot('delete');
        return (0, $81ded97e27414374$export$39c5ed4ec960eade)(this._delegate);
    }
    _throwIfRoot(name) {
        if (this._delegate._location.path === '') throw (0, $81ded97e27414374$export$61f54cdc36500ad)(name);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A service that provides firebaseStorage.Reference instances.
 * @param opt_url gs:// url to a custom Storage Bucket
 */ class $63e774032d00835e$var$StorageServiceCompat {
    constructor(app, _delegate){
        this.app = app;
        this._delegate = _delegate;
    }
    get maxOperationRetryTime() {
        return this._delegate.maxOperationRetryTime;
    }
    get maxUploadRetryTime() {
        return this._delegate.maxUploadRetryTime;
    }
    /**
     * Returns a firebaseStorage.Reference for the given path in the default
     * bucket.
     */ ref(path) {
        if ($63e774032d00835e$var$isUrl(path)) throw (0, $81ded97e27414374$export$8f74d9881d1936fd)('ref() expected a child path but got a URL, use refFromURL instead.');
        return new $63e774032d00835e$var$ReferenceCompat((0, $81ded97e27414374$export$eff4d24c3ff7876e)(this._delegate, path), this);
    }
    /**
     * Returns a firebaseStorage.Reference object for the given absolute URL,
     * which must be a gs:// or http[s]:// URL.
     */ refFromURL(url) {
        if (!$63e774032d00835e$var$isUrl(url)) throw (0, $81ded97e27414374$export$8f74d9881d1936fd)('refFromURL() expected a full URL but got a child path, use ref() instead.');
        try {
            (0, $81ded97e27414374$export$adb98fff6714334).makeFromUrl(url, this._delegate.host);
        } catch (e) {
            throw (0, $81ded97e27414374$export$8f74d9881d1936fd)('refFromUrl() expected a valid full URL but got an invalid one.');
        }
        return new $63e774032d00835e$var$ReferenceCompat((0, $81ded97e27414374$export$eff4d24c3ff7876e)(this._delegate, url), this);
    }
    setMaxUploadRetryTime(time) {
        this._delegate.maxUploadRetryTime = time;
    }
    setMaxOperationRetryTime(time) {
        this._delegate.maxOperationRetryTime = time;
    }
    useEmulator(host, port, options = {}) {
        (0, $81ded97e27414374$export$9850e656f954b889)(this._delegate, host, port, options);
    }
}
function $63e774032d00835e$var$isUrl(path) {
    return /^[A-Za-z]+:\/\//.test(path);
}
const $63e774032d00835e$var$name = "@firebase/storage-compat";
const $63e774032d00835e$var$version = "0.4.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Storage.
 */ const $63e774032d00835e$var$STORAGE_TYPE = 'storage-compat';
function $63e774032d00835e$var$factory(container, { instanceIdentifier: url }) {
    // Dependencies
    const app = container.getProvider('app-compat').getImmediate();
    const storageExp = container.getProvider('storage').getImmediate({
        identifier: url
    });
    const storageServiceCompat = new $63e774032d00835e$var$StorageServiceCompat(app, storageExp);
    return storageServiceCompat;
}
function $63e774032d00835e$export$ba90a1fa1905b39e(instance) {
    const namespaceExports = {
        // no-inline
        TaskState: (0, $81ded97e27414374$export$9dc4203728a9a7c9),
        TaskEvent: (0, $81ded97e27414374$export$2cf04e0422ce9b07),
        StringFormat: $81ded97e27414374$export$f22e7fe56db8ae03,
        Storage: $63e774032d00835e$var$StorageServiceCompat,
        Reference: $63e774032d00835e$var$ReferenceCompat
    };
    instance.INTERNAL.registerComponent(new (0, $ad76b76e741ec0c7$export$16fa2f45be04daa8)($63e774032d00835e$var$STORAGE_TYPE, $63e774032d00835e$var$factory, "PUBLIC" /* ComponentType.PUBLIC */ ).setServiceProps(namespaceExports).setMultipleInstances(true));
    instance.registerVersion($63e774032d00835e$var$name, $63e774032d00835e$var$version);
}
$63e774032d00835e$export$ba90a1fa1905b39e((0, $42ddf94e6f3c0a26$export$2e2bcd8739ae039));





var $e75727477720e2d0$require$Buffer = $9efcfb26a96dcb10$export$a143d493d941bafc;

var $k0VX2 = parcelRequire("k0VX2");
class $e75727477720e2d0$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.noImage = {
            src: ""
        };
        this.state = {
            image: this.noImage,
            fileName: ""
        };
        this.remove = this.remove.bind(this);
        this.persist = this.persist.bind(this);
        this.storeDriveImage = this.storeDriveImage.bind(this);
        this.storeUploadedImage = this.storeUploadedImage.bind(this);
        this.upload = this.upload.bind(this);
        this.isDrive = this.isDrive.bind(this);
        this.isLocal = this.isLocal.bind(this);
        this.isStored = this.isStored.bind(this);
        this.isRemoved = this.isRemoved.bind(this);
        this.isStored = this.isStored.bind(this);
        this.getMetadata = this.getMetadata.bind(this);
        this.saveFile = this.saveFile.bind(this);
        this.imagePath = null;
        this.imageRef = null;
        this.fileNameRef = null;
        this.altPath = null;
        this.altRef = null;
        this.storageRef = null;
        this.updateContent = this.props.updateContent;
    }
    componentWillMount() {
        if (!this.imagePath) {
            const doc = this.context;
            const dp = doc.fileType ? [
                "",
                doc.fileType,
                doc.fileId,
                this.props.identifier
            ].join((0, $4d4f206cc2e474fe$export$136d1ce139fe0e5d)) : null;
            this.imagePath = dp ? (0, $4d4f206cc2e474fe$export$f7e2c8231c57a8bd)(dp, "image") : null; // id?
            this.imageRef = window.firebase.database().ref(this.imagePath);
            let fileNamePath = dp ? (0, $4d4f206cc2e474fe$export$f7e2c8231c57a8bd)(dp, "fileName") : null;
            this.fileNameRef = window.firebase.database().ref(fileNamePath);
            this.storageRef = window.firebase.storage().ref();
            this.imageWatcher = this.imageRef.on('value', (snapshot)=>{
                var value = snapshot.val();
                if (this.state.image.src !== value) // TODO: also set alt text metadata on uploaded file
                this.setState({
                    image: {
                        src: value
                    }
                });
            });
            this.fileNameWatcher = this.fileNameRef.on('value', (snapshot)=>{
                var value = snapshot.val();
                if (null !== value && undefined !== value) this.setState({
                    fileName: value
                });
            });
        }
    }
    componentWillUnmount() {
        this.imageRef.off('value', this.imageWatcher);
        this.fileNameRef.off('value', this.fileNameWatcher);
    }
    getMetadata(image) {
        return {
            contentType: image.mimeType,
            contentEncoding: 'binary',
            contentDisposition: "inline; filename*=binary''" + image.name,
            customMetadata: {
                original: image.src,
                description: image.description
            }
        };
    }
    upload(image) {
        let storedImage = image;
        const imageRef = this.imageRef;
        const userImage = "uc/" + this.context.currentUser.uid + "/" + image.name;
        const storedImageRef = this.storageRef.child(userImage);
        const storedMeta = this.getMetadata(image);
        return new Promise((resolve)=>{
            // Important! must to pass ArrayBuffer or resulting image is corrupted
            storedImageRef.put(image, storedMeta).then(function(fileSnapshot) {
                // 3 - Generate a public URL for the file.
                return fileSnapshot.ref.getDownloadURL().then((url)=>{
                    storedImage.src = url;
                    console.log('Image %s upload Done', storedImage.name);
                    window.tracker.trackEvent("Content", "add image", "upload");
                    imageRef.set(url);
                    resolve(storedImage);
                });
            });
        });
    }
    storeUploadedImage(image) {
        this.upload(image);
    }
    storeDriveImage(image) {
        let storedImage = image;
        const imageRef = this.imageRef;
        const userImage = "uc/" + this.context.currentUser.uid + "/" + storedImage.name;
        const storedImageRef = this.storageRef.child(userImage);
        const storedMeta = this.getMetadata(image);
        // download image from Drive
        return new Promise((resolve)=>{
            window.gapi.client.drive.files.get({
                fileId: image.id,
                responseType: 'bytearray',
                alt: 'media'
            }).then((response)=>{
                console.debug('drive file data is array %s, buffer %s, length %s, UTF8 %s', Array.isArray(response.body), $e75727477720e2d0$require$Buffer.isBuffer(response.body), response.body.length, $k0VX2(response.body));
                let buf = $e75727477720e2d0$require$Buffer.from(response.body, 'binary');
                console.debug('Image %s download %d Done - buf[1] = 0x%s, buf[%d] = 0x%s', image.mimeType, buf.length, buf.slice(1, 2).toString('hex').toUpperCase(), buf.length - 1, buf.slice(buf.length - 1, buf.length).toString('hex').toUpperCase());
                // Important! must to pass ArrayBuffer or resulting image is corrupted
                storedImageRef.put(buf.buffer, storedMeta).then(function(fileSnapshot) {
                    // 3 - Generate a public URL for the file.
                    return fileSnapshot.ref.getDownloadURL().then((url)=>{
                        storedImage.src = url;
                        console.log('Image %s upload Done', storedImage.name);
                        window.tracker.trackEvent("Content", "add image", "drive");
                        imageRef.set(url);
                        resolve(storedImage);
                    });
                });
            }, (err_reason)=>{
                const err = "Could not get Drive Image: " + err_reason.result.error.message;
                console.log(err);
                alert(err);
                resolve(storedImage);
            });
        });
    }
    isLocal(image) {
        return image.src.startsWith("blob:");
    }
    isDrive(image) {
        return image.src.includes('drive.google.com');
    }
    isStored(image) {
        return image.src.includes((0, $540ee614c8ab8fe3$export$2b16136333e16b91));
    }
    isRemoved(image) {
        return this.noImage === image;
    }
    isFileAttack(fileName) {
        if (fileName !== null && fileName !== "") return true;
        else return false;
    }
    isExternal(image) {
        let url = null;
        try {
            url = new URL(image.src);
        } catch (e) {
            if (null === url) return false;
        }
        return !this.isDrive(image) && !this.isLocal(image) && !this.isStored(image) && !this.isRemoved(image);
    }
    saveFile(file) {
        console.log(file);
        let image = this.state.image;
        let imageRef = this.imageRef;
        let fileNameRef = this.fileNameRef;
        if (null === this.imagePath || null === this.imageRef) return null;
        if (null != file && image.src !== file.src) image = file;
        imageRef.set(image.src);
        if (image.src === "") fileNameRef.set("");
        if (null !== file.name && undefined !== file.name) fileNameRef.set(file.name);
        this.context.contentUpdated();
        if (undefined !== this.updateContent) this.updateContent();
        return image;
    }
    persist(newImage) {
        console.log(newImage);
        let image = this.state.image;
        let imageRef = this.imageRef;
        let fileNameRef = this.fileNameRef;
        if (null === this.imagePath || null === this.imageRef) return null;
        if (null != newImage && image.src !== newImage.src) {
            image = newImage;
            if (this.isDrive(image)) this.storeDriveImage(image).then((storedImage)=>{
                image = storedImage;
            });
            else if (this.isLocal(image)) this.upload(image).then((storedImage)=>{
                image = storedImage;
                URL.revokeObjectURL(image.src); // allow browser to free File
            });
        }
        if (this.isStored(image) || this.isExternal(image) || this.isRemoved(image)) {
            imageRef.set(image.src);
            if (image.src === "") fileNameRef.set("");
        }
        this.context.contentUpdated();
        if (undefined !== this.updateContent) this.updateContent();
        return image;
    }
    remove() {
        const type = $e75727477720e2d0$export$a1dfc7488e2b0185(this.state.image.src) ? "video" : "image";
        console.debug("Remove " + type);
        window.tracker.trackEvent("Content", "remove " + type, "");
        if (undefined !== this.updateContent) this.updateContent();
        this.persist(this.noImage);
    }
    render() {
        const image = this.state.image;
        const fileName = this.state.fileName;
        const isYoutubeVideo = $e75727477720e2d0$export$a1dfc7488e2b0185(image.src);
        const isFileAttack = this.isFileAttack(fileName);
        return null === image || undefined === image.src || null === image.src || "" === image.src || image.src instanceof Object ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $dd5e776bec3d0164$export$2e2bcd8739ae039), {
            identifier: this.imagePath,
            saveMethod: this.persist,
            saveFile: this.saveFile
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "attachment"
        }, !isFileAttack ? isYoutubeVideo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $c0ad353fe5b45e03$export$2e2bcd8739ae039), {
            video: image
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e1cee4d396a9c536$export$2e2bcd8739ae039), {
            image: image
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc0b0a5053906ff1$export$2e2bcd8739ae039), {
            file: image,
            fileName: fileName
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $56e0ce693a0f3e79$export$2e2bcd8739ae039), {
            identifier: this.imagePath,
            saveMethod: this.persist,
            removeMethod: this.remove
        })), isFileAttack ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "directions"
        }, "Make sure your file is shared") : null);
    }
}
function $e75727477720e2d0$export$a1dfc7488e2b0185(image) {
    if (image !== null) return image.includes("youtube.com/embed");
    else return false;
}


class $8685bff03fd3636e$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.addImage = undefined !== this.props.addImage ? this.props.addImage : false;
        this.showTourGuide = undefined !== this.props.showTourGuide ? this.props.showTourGuide : false;
        this.formClassName = "form-group";
        this.domId = undefined !== this.props.domId ? this.props.domId : (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.buttonId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.buttonClassName = "stt-btn";
        this.iconClassName = "fa fa-microphone";
        this.screenReaderText = "Use Speech to Text";
        this.labelClassName = this.props.labelClassName ? this.props.labelClassName : "sr-only";
        this.inputClassName = this.props.inputClassName ? this.props.inputClassName : "box bg-primary";
        this.state = {
            editing: true,
            listening: false
        };
        this.getText = this.getText.bind(this);
        this.setText = this.setText.bind(this);
        this.toggleListen = this.toggleListen.bind(this);
        this.handleListen = this.handleListen.bind(this);
        this.handleResult = this.handleResult.bind(this);
        this.handleStopped = this.handleStopped.bind(this);
        this.sttButton = null;
        this.firepad = null;
        this.updateContent = this.props.updateContent;
    }
    componentWillUnmount() {
        this.context.recognition.quit();
    }
    render() {
        this.fileType = this.context.fileType;
        this.fileId = this.context.fileId;
        this.id = undefined !== this.identifier ? this.identifier : this.props.identifier;
        let canEdit = this.context.canEdit;
        const label = undefined !== this.props.label ? this.props.label : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $d6bad315ad35dae0$export$2e2bcd8739ae039), {
            type: this.fileType,
            identifier: this.id ? this.id.split('/').join('.') : 'dummy',
            item: "label"
        });
        const directions = this.props.directions ? this.props.directions : null;
        this.sttButton = ()=>{
            return this.context.recognition && this.context.recognition.isSupported() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
                onClick: this.toggleListen,
                id: this.buttonId,
                type: "button",
                className: `${this.buttonClassName} enabled ${this.state.listening ? 'active' : ''}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
                className: this.iconClassName,
                "aria-hidden": "true"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
                className: "sr-only"
            }, this.screenReaderText)) : null;
        };
        const textInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $618116693e1a0bce$export$2e2bcd8739ae039), {
            domId: this.domId,
            type: this.fileType,
            ...this.props,
            button: this.sttButton
        });
        return canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, this.renderLabel(label, this.fileType), directions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, "directions") : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: this.formClassName
        }, textInput), this.addImage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e75727477720e2d0$export$2e2bcd8739ae039), {
            updateContent: this.updateContent,
            identifier: this.id
        }) : null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.id,
            className: "grouping-text"
        }), !this.addImage ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.id + "/image",
            className: "img"
        }))));
    }
    renderLabel(label, type) {
        // May need to wrap this in <div className="hinline" in some cases, not sure if that ever occurs in the new design.
        return this.props.stepnum && '0' < this.props.stepnum ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $176e033a80de7861$export$2e2bcd8739ae039), {
            stepnum: this.props.stepnum,
            type: type,
            identifier: this.id
        }) : label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("label", {
            htmlFor: this.domId,
            className: this.labelClassName
        }, label) : "";
    }
    getIdentifier() {
        return !(0, $21f9ebdc444decaf$export$6e22c362a0406a2c)(this.identifier) ? this.identifier : this.props.identifier;
    }
    getCurrentNode() {
        let parentNode = undefined !== this.props.parentNode ? this.props.parentNode : this.fileType + "/" + this.fileId;
        return parentNode + "/" + this.getIdentifier();
    }
    lookup(type, identifier, item) {
        const key = [
            type,
            identifier,
            item
        ].join('.');
        let value = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $d6bad315ad35dae0$export$2e2bcd8739ae039), {
            type: type,
            identifier: identifier,
            item: item
        });
        return value === key ? "" : (0, (/*@__PURE__*/$parcel$interopDefault($8a34fb1098450c8d$exports))).renderToString(value);
    }
    componentDidMount() {
        if (this.context.canEdit) {
            const placeholder = (0, $21f9ebdc444decaf$export$6e22c362a0406a2c)(this.props.placeholder) ? this.lookup(this.fileType, this.getIdentifier(), 'placeholder') : this.props.placeholder;
            let firepadRef = window.firebase.database().ref(this.getCurrentNode());
            this.codeMirror = window.CodeMirror(document.getElementById(this.domId), this.props.singleLine ? (0, $6a59b1cc78a70843$export$83e157e498e502fc)(!this.state.editing, placeholder ? placeholder : "") : (0, $6a59b1cc78a70843$export$36a6d360a8c4e160)(!this.state.editing, placeholder ? placeholder : ""));
            this.firepad = window.Firepad.fromCodeMirror(firepadRef, this.codeMirror, {
                richTextShortcuts: false,
                richTextToolbar: false
            });
            if (this.props.onReady) {
                this.firepad.on("ready", ()=>this.props.onReady(this.firepad));
                this.currentText = this.firepad.getText();
            }
            this.firepad.on("ready", ()=>{
                let text = this.firepad.getText();
                if (null !== text) {
                    let trimText = text.trim();
                    if (trimText !== text) this.firepad.setText(text);
                }
            });
            this.firepad.on("synced", ()=>{
                this.context.contentUpdated();
                if (undefined !== this.updateContent) this.updateContent();
            });
        }
    }
    getText() {
        if (!this.firepad) return "";
        return this.firepad.getText();
    }
    setText(output) {
        return this.firepad.setText(output);
    }
    toggleListen() {
        if (this.state.listening) this.context.recognition.stopListening();
        else this.setState({
            listening: true
        }, this.handleListen);
    }
    handleListen() {
        this.currentText = this.getText();
        this.finalTranscript = '';
        this.context.recognition.startListening(this.handleResult, this.handleStopped);
    }
    handleStopped() {
        this.setState({
            listening: false
        });
    }
    handleResult(event) {
        if (!this.state.listening) return;
        let interimTranscript = '';
        for(let i = event.resultIndex; i < event.results.length; ++i)if (event.results[i].isFinal) this.finalTranscript += event.results[i][0].transcript;
        else interimTranscript += event.results[i][0].transcript;
        let output = this.currentText + this.finalTranscript + interimTranscript;
        this.setText(output);
    }
}




var $6wXVr = parcelRequire("6wXVr");

var $6wXVr = parcelRequire("6wXVr");

var $6wXVr = parcelRequire("6wXVr");
function $e11e58ed847fc0be$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "text-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
        id: "buttonKeyTerms",
        type: "button",
        onClick: ()=>{
            window.tracker.trackEvent("Interface", "open key terms", "button");
        },
        className: "btn btn-primary mb-1",
        "data-cfw": "modal",
        "data-cfw-modal-target": "#modalKeyTerms"
    }, "Key Terms"));
}





class $b5ffa3f136ed406e$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.headerId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.openKeyTermModal = this.openKeyTermModal.bind(this);
        this.logLink = this.logLink.bind(this);
    }
    openKeyTermModal() {
        window.tracker.trackEvent("Interface", "open key terms", "link");
        (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#buttonKeyTerms').click();
    }
    logLink(name) {
        window.tracker.trackEvent("Navigation", "sample link", 'sample ' + this.context.fileType);
    }
    componentDidMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#' + this.headerId).on('afterShow.cfw.tooltip', function(e) {
            window.tracker.trackEvent("Support", "glossary", e.target.text);
        });
    }
    render() {
        const editing = undefined === this.props.editing || this.props.editing;
        const defineKeyTerm = undefined !== this.props.defineKeyTerm ? this.props.defineKeyTerm : false;
        const tooltipTitle = undefined !== this.props.tooltipTitle ? this.props.tooltipTitle : false;
        const title = this.props.section.stepnum ? this.props.section.stepnum + ". " + this.props.section.title : this.props.section.title ? this.props.section.title : this.props.section.label;
        const terms = "Key Terms" !== this.props.section.label && "terms" !== this.props.section.key ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e11e58ed847fc0be$export$2e2bcd8739ae039), {
            editing: editing
        }) : null;
        let mTitle = "";
        if (tooltipTitle) {
            let key = this.props.section.tooltip.key;
            let splitArray = this.props.section.title.match('(.*)' + key + '(.*)');
            let prefix = "";
            let subfix = "";
            if (null !== splitArray && splitArray.length >= 2) {
                prefix = splitArray[1];
                subfix = splitArray[2];
            }
            mTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h1", null, this.props.section.stepnum, ". ", prefix, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
                href: "# ",
                role: "button",
                className: "vocab-word",
                "data-cfw": "tooltip",
                "data-cfw-tooltip-trigger": "click",
                "data-cfw-tooltip-placement": "bottom auto",
                "data-cfw-tooltip-custom-class": "vocab-tooltip",
                title: this.props.section.tooltip.definition
            }, key), " ", subfix);
        }
        // We link to the sample guides from each numbered step (not TOC, Review, or Share).
        const showSampleLink = !!this.props.section.stepnum;
        const sampleStyle = this.context.currentUser.role === 'teacher' ? 'annotated' : 'plain';
        let sampleUrl = showSampleLink ? '/sample/' + sampleStyle + '/' + this.context.fileType + '#sec_' + this.props.section.key : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: this.headerId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "hinline"
        }, !tooltipTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h1", null, title), tooltipTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, mTitle)), editing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", {
            className: "directions"
        }, this.props.section.description, defineKeyTerm ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, " Define your ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "# ",
            onClick: this.openKeyTermModal
        }, "Key Terms")) : null), showSampleLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: sampleUrl,
            onClick: this.logLink
        }, "Sample guide")) : null, terms) : null);
    }
}



class $c2973624e295a266$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.identifier = "question";
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b5ffa3f136ed406e$export$2e2bcd8739ae039), {
            doc: this.props.doc,
            section: this.props.section,
            tooltipTitle: true,
            editing: true
        }), this.context.canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            ...this.props,
            inputType: "text-area",
            identifier: "topic",
            addImage: false,
            singleLine: false
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            ...this.props,
            inputType: "text-area",
            identifier: this.identifier,
            addImage: true,
            singleLine: false
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "topic",
            className: "box bg-autofill"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.identifier,
            className: "grouping-text"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.identifier + "/image",
            className: "grouping-img"
        })))));
    }
}




var $6wXVr = parcelRequire("6wXVr");

class $a1ef86ca5ed11266$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    constructor(props){
        super(props);
        this.identifier = "answer";
    }
    render() {
        const noImage = [
            'print'
        ].includes(this.props.doc.section);
        return this.props.editing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            ...this.props,
            identifier: this.identifier,
            addImage: true,
            inputType: "text-area",
            singleLine: false
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping grouping-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.identifier,
            className: 'grouping-text'
        }), noImage ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.identifier + "/image",
            className: 'grouping-img'
        })))));
    }
}



var $6wXVr = parcelRequire("6wXVr");

var $6wXVr = parcelRequire("6wXVr");



var $6wXVr = parcelRequire("6wXVr");


class $69a989a347225ce6$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    render() {
        const list = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $d6bad315ad35dae0$export$2e2bcd8739ae039), {
            identifier: "mnemonicSteps",
            ...this.props
        });
        if (!list) return null;
        let steps = [];
        for(let i = 0; i < list.length; i++){
            const initial = list[i].charAt(0);
            steps.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
                key: i
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("strong", null, initial), " \u2013 ", list[i]));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "/",
            "data-cfw": "modal",
            "data-cfw-modal-toggle": "#linkingsteps"
        }, "Linking steps: ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $d6bad315ad35dae0$export$2e2bcd8739ae039), {
            type: this.props.fileType,
            identifier: "mnemonic"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal",
            id: "linkingsteps"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-dialog modal-lg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "modal-close close",
            "data-cfw-dismiss": "modal",
            "aria-label": "Close"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-close",
            "aria-hidden": "true"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Linking Steps"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", {
            style: {
                listStyleType: 'none',
                paddingLeft: '0'
            }
        }, steps))))));
    }
}
$69a989a347225ce6$export$2e2bcd8739ae039.propTypes = {
    fileType: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired
};




class $af02febc6c5650c1$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    example(pdf, topic) {
        return pdf ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            target: "_blank",
            rel: "noopener noreferrer",
            href: "undefined/example/" + pdf
        }, "Example: " + topic)) : null;
    }
    render() {
        const type = this.context.fileType ? this.context.fileType : this.props.docType;
        // Do we have a video and examples to show?
        let row;
        if (undefined !== type && null != this.props.video) row = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-sm-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).p, {
            text: {
                key: type + ".blurb"
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $69a989a347225ce6$export$2e2bcd8739ae039), {
            fileType: type
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-6 col-sm-3"
        }, this.props.video ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $ff4f4fd575640ac6$export$2e2bcd8739ae039), {
            video: this.props.video,
            title: "Overview video",
            label: "Overview video",
            caption: "Overview video"
        }) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-6 col-sm-3"
        }, this.example(this.props.sciExample, "Science"), this.example(this.props.socExample, "Social Studies")));
        else // No video or examples, just text.
        row = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).p, {
            text: {
                key: type + ".blurb"
            }
        })));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "popover popover-header",
            id: "PageInfoPopover"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "popover-close close",
            title: "Close",
            "data-cfw-dismiss": "popover"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-close",
            "aria-hidden": "true"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "popover-title mb-0_25"
        }, "About the ", (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(type + '.title')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "popover-content pt-0"
        }, row), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "popover-arrow"
        }));
    }
    componentDidMount() {
        // Show the popover if this is the first time this user has seen this document type.
        // Once shown, indicate this fact in localStorage so it won't be shown again (on this client)
        const type = this.context.fileType;
        const key = type + '.popoverShown';
        // debugger;
        var popover = document.getElementById("PageInfoPopoverButton"); // this is null in PageInfoPopover.test
        if (window.localStorage && window.localStorage[key] !== 'yes' && null != popover && popover.CFW_Popover) {
            popover.CFW_Popover('show');
            window.localStorage.setItem(key, 'yes');
        }
    }
}
$af02febc6c5650c1$export$2e2bcd8739ae039.propTypes = {
    video: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string,
    sciExample: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string,
    socExample: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string
};



var $6wXVr = parcelRequire("6wXVr");


const $2f05acbc3da55feb$export$236eb756c096e00e = (name)=>{
    return name && 0 < name.trim().length;
};
class $2f05acbc3da55feb$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.setEditTitle = this.setEditTitle.bind(this);
        this.unsetEditTitle = this.unsetEditTitle.bind(this);
        this.saveTitle = this.saveTitle.bind(this);
        this.state = {
            editTitle: false
        };
    }
    render() {
        const editing = this.context.canEdit && this.state.editTitle;
        return !editing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", null, this.context.fileName), this.context.canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "#rename",
            className: "fs-small ms-0_25",
            onClick: this.setEditTitle
        }, "rename") : null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($2f05acbc3da55feb$var$TitleForm, {
            cancelMethod: this.unsetEditTitle,
            saveMethod: this.saveTitle
        });
    }
    setEditTitle() {
        this.setState({
            editTitle: true
        });
    }
    unsetEditTitle() {
        this.setState({
            editTitle: false
        });
    }
    saveTitle(newName) {
        const name = newName.trim();
        if ($2f05acbc3da55feb$export$236eb756c096e00e(name)) this.props.renameDocMethod(newName).then(()=>{
            this.setState({
                editTitle: false
            });
            this.context.updateFileName(newName);
        }, ()=>{
            alert('Rename failed');
        });
        else alert('An empty guide name is not allowed.  Please name the guide.');
    }
}
$2f05acbc3da55feb$export$2e2bcd8739ae039.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    renameDocMethod: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).func.isRequired
};
class $2f05acbc3da55feb$var$TitleForm extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.state = {
            value: ''
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    componentDidMount() {
        //document.getElementById('save').disabled = ! isValidTitle(this.context.fileName);
        this.setState({
            value: this.context.fileName
        });
    }
    handleChange(event) {
        //document.getElementById('save').disabled = ! isValidTitle(event.target.value);
        this.setState({
            value: event.target.value
        });
    }
    handleSubmit(event) {
        event.preventDefault();
        this.props.saveMethod(this.state.value);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("form", {
            onSubmit: this.handleSubmit,
            className: "row gx-0_5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("input", {
            id: "filename",
            value: this.state.value,
            onChange: this.handleChange,
            type: "text",
            className: "form-control"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-sm-auto mt-0_5 mt-sm-0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            id: "save",
            onClick: this.handleSubmit,
            type: "submit",
            className: "btn btn-success me-0_5"
        }, "Save"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            onClick: this.props.cancelMethod,
            type: "button",
            className: "btn btn-light"
        }, "Cancel")));
    }
}







var $6wXVr = parcelRequire("6wXVr");



class $6e7539b03a30b35c$export$2e2bcd8739ae039 extends (0, $33c53f2912681500$export$2e2bcd8739ae039) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(){
        super();
        this.complete = this.complete.bind(this);
        this.trackEvent = this.trackEvent.bind(this);
    }
    trackEvent(step) {
        window.speechstream.speechTools.stop();
        window.tracker.trackEvent("Navigation", "toc link", step);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h1", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-list-ol me-0_25",
            "aria-hidden": "true"
        }), " ", this.props.steps[0].title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ol", {
            className: "toc"
        }, this.props.steps.slice(1, this.props.steps.length).map((step, i)=>{
            const key = step.key;
            const value = step.title;
            const complete = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
                className: "fa fa-table me-0_25",
                "aria-hidden": "true"
            });
            const createShare = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
                className: "fa fa-file-export me-0_25",
                "aria-hidden": "true"
            });
            return !this.complete(key) && !this.isCreateShare(key) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
                key: key
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $7a6def086ebe18be$export$2e2bcd8739ae039), {
                section: key,
                onClick: ()=>this.trackEvent(i + 1)
            }, value)) : this.complete(key) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
                key: key,
                className: "list-nostyle mx-0"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $7a6def086ebe18be$export$2e2bcd8739ae039), {
                section: key,
                onClick: ()=>this.trackEvent('review')
            }, complete, value)) : this.isCreateShare(key) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
                key: key,
                className: "list-nostyle mx-0"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $7a6def086ebe18be$export$2e2bcd8739ae039), {
                section: key,
                onClick: ()=>this.trackEvent('create-share')
            }, createShare, value)) : null;
        })));
    }
    complete(stepKey) {
        return stepKey === "complete" ? true : false;
    }
    isCreateShare(stepKey) {
        return stepKey === "create-share" ? true : false;
    }
}
$6e7539b03a30b35c$export$2e2bcd8739ae039.propTypes = {
    doc: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).object.isRequired,
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).array.isRequired
};






var $6wXVr = parcelRequire("6wXVr");


var $6wXVr = parcelRequire("6wXVr");


var $6wXVr = parcelRequire("6wXVr");



class $c01ab3c338b52a54$export$2e2bcd8739ae039 extends (0, $d8775d5311bbf499$export$2e2bcd8739ae039) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        // Set to false if at least one list element is required.
        this.canBeEmpty = undefined !== this.props.canBeEmpty ? this.props.canBeEmpty : true;
        this.state = {
            canDelete: false,
            items: {} // List of item
        };
        this.listItemRefs = null;
        this.allowUpdateContent = false; // This gets set to true after the mount process is done.
        this.handleAddItem = this.handleAddItem.bind(this);
        this.getContentList = this.getContentList.bind(this);
        this.handleDeleteItem = this.handleDeleteItem.bind(this);
        this.checkDeleteLegality = this.checkDeleteLegality.bind(this);
    }
    componentDidMount() {
        super.componentDidMount();
        this.listItemRefs = window.firebase.database().ref(this.getCurrentNode());
        this.addWatcher = this.listItemRefs.on('child_added', (data)=>{
            let currentItems = this.state.items;
            currentItems[data.key] = data.val();
            this.setState({
                items: currentItems,
                canDelete: this.checkDeleteLegality(currentItems)
            });
        });
        this.removeWatcher = this.listItemRefs.on('child_removed', (data)=>{
            let currentItems = this.state.items;
            delete currentItems[data.key];
            this.setState({
                items: currentItems,
                canDelete: this.checkDeleteLegality(currentItems)
            });
        });
        if (!this.props.secondary) {
            if (!this.canBeEmpty) // Check whether list is empty, if so add an initial item.
            this.valueWatcher = this.listItemRefs.once('value', (data)=>{
                if (!data.exists() || Object.keys(data.val()).length === 0) {
                    console.debug(this.getCurrentNode(), ' is empty, adding a list item');
                    this.handleAddItem();
                }
                this.allowUpdateContent = true;
            });
            else // List can be empty, no check needed.
            this.allowUpdateContent = true;
        }
    }
    getMapValues() {
        return new Promise((resolve, reject)=>{
            const itemList = this.getContentList();
            if (itemList) {
                let keys = [];
                let promises = [];
                for(let key in itemList)if (itemList.hasOwnProperty(key)) {
                    let path = this.getValuePath(key);
                    keys.push(key);
                    promises.push(this.getFirepadTextPromise(path));
                }
                Promise.all(promises).then((values)=>{
                    let map = new Map();
                    for(let i = 0; i < keys.length; i++)map.set(keys[i], values[i]);
                    resolve(map);
                });
            }
        });
    }
    getMapImages() {
        return new Promise((resolve, reject)=>{
            const itemList = this.getContentList();
            if (itemList) {
                let keys = [];
                let promises = [];
                for(let key in itemList)if (itemList.hasOwnProperty(key)) {
                    let path = this.getImagePath(key);
                    keys.push(key);
                    promises.push(this.getImageUrlPromise(path));
                }
                Promise.all(promises).then((values)=>{
                    let map = new Map();
                    for(let i = 0; i < keys.length; i++)map.set(keys[i], values[i]);
                    resolve(map);
                });
            }
        });
    }
    getMapItems() {
        let proms = [
            this.getMapValues(),
            this.getMapImages()
        ];
        return Promise.all(proms).then((maps)=>{
            return {
                'mapText': maps[0],
                'mapImage': maps[1]
            };
        });
    }
    removeEmptyItem() {
        this.getMapItems().then((maps)=>{
            if (maps != null) {
                let numberItems = Object.keys(this.getContentList()).length;
                let mapText = maps["mapText"];
                let mapImage = maps["mapImage"];
                mapText.forEach((value, key)=>{
                    let imageUrl = mapImage.get(key);
                    if (!this.hasContent(value) && !this.hasContent(imageUrl)) {
                        if (numberItems > 1) {
                            this.handleDeleteItem(key);
                            numberItems = numberItems - 1;
                        }
                    }
                });
            }
        });
    }
    hasContent(text) {
        return undefined !== text && null !== text && text.trim();
    }
    componentWillUnmount() {
        this.listItemRefs.off('child_added', this.addWatcher);
        this.listItemRefs.off('child_removed', this.removeWatcher);
        this.removeEmptyItem();
    }
    componentDidUpdate(prevProps, prevState) {
        if (Object.keys(this.state.items).length !== Object.keys(prevState.items).length) this.setState({
            canDelete: this.checkDeleteLegality(this.state.items)
        });
    }
    // Create a new item add add it to the list
    handleAddItem() {
        if (!this.context.canEdit) return;
        console.debug("ListComponent.handleAddItem");
        if (this.allowUpdateContent) this.context.contentUpdated();
        this.newItem();
        window.tracker.trackEvent("Content", "add item", this.identifier);
    }
    handleDeleteItem(id) {
        if (!this.state.canDelete) {
            console.log("Cannot delete, would make list empty");
            return;
        }
        this.context.contentUpdated();
        window.speechstream.speechTools.stop();
        window.firebase.database().ref(this.getCurrentNode() + "/" + id).remove();
        window.tracker.trackEvent("Content", "remove item", this.identifier);
    }
    // Determine whether delete buttons should be active; return as a boolean value.
    checkDeleteLegality(items) {
        if (!this.context.canEdit || !items) return false;
        if (this.canBeEmpty) return true;
        return Object.keys(items).length > 1;
    }
    // Get content list and listen to change
    getContentList() {
        return this.state.items;
    }
    getRef(path) {
        return window.firebase.database().ref(path);
    }
    getFirepadTextPromise(path) {
        return new Promise((resolve, reject)=>{
            let firepadHeadless = new window.Firepad.Headless(this.getRef(path));
            firepadHeadless.getText((text)=>{
                firepadHeadless.dispose();
                resolve(text);
            });
        });
    }
    getImageUrlPromise(path) {
        if (this.hasContent(path)) return this.getRef(path).once("value").then((data)=>{
            return data.val();
        });
        else return new Promise((resolve, reject)=>{
            resolve("");
        });
    }
}








var $6wXVr = parcelRequire("6wXVr");

class $cc5d5838c074a4ab$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    constructor(props){
        super(props);
        this.yes = this.props.yes ? this.props.yes : "Yes, Delete";
    }
    closeModal() {
        window.speechstream.speechTools.stop();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: this.props.id,
            className: "modal confirm-modal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-dialog modal-dialog-centered"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            className: "h1 modal-title"
        }, this.props.text)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "text-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, this.props.instructions), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "submit",
            onClick: this.props.method,
            "data-cfw-dismiss": "modal",
            className: "btn btn-danger me-0_5"
        }, this.yes), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            "data-cfw-dismiss": "modal",
            className: "btn btn-secondary ms-0_5",
            onClick: ()=>this.closeModal()
        }, "No, Cancel"))))));
    }
}
$cc5d5838c074a4ab$export$2e2bcd8739ae039.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    text: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    // instructions: PropTypes.string.isRequired,
    yes: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string,
    method: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).func.isRequired
};



var $6wXVr = parcelRequire("6wXVr");



class $c8db36dd985f35f1$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    render() {
        this.id = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        let icon = this.props.icon ? this.props.icon : "fa-trash-o";
        return this.props.canDelete ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            id: this.id,
            type: "button",
            className: "btn btn-icon btn-link",
            title: this.props.tooltip,
            "data-cfw": "modal",
            "data-cfw-modal-target": '#' + this.props.modalId,
            disabled: !this.props.canDelete
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa " + icon,
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, this.props.tooltip)) : null;
    }
    componentDidMount() {
        const button = (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#' + this.id);
        if (button.CFW_Modal) button.CFW_Modal();
    }
}
$c8db36dd985f35f1$export$2e2bcd8739ae039.propTypes = {
    modalId: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    canDelete: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).bool.isRequired
};



var $hObpn = parcelRequire("hObpn");
class $8928b35984758c11$export$2e2bcd8739ae039 extends (0, $c01ab3c338b52a54$export$2e2bcd8739ae039) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.identifier = this.props.identifier;
        $hObpn([
            'characteristics1',
            'characteristics2'
        ].includes(this.identifier));
        this.identifierRef = null;
        this.newItem = this.newItem.bind(this);
        this.getCurrentNode = this.getCurrentNode.bind(this);
    }
    render() {
        const editing = undefined !== this.props.editing ? this.props.editing : true;
        const itemList = this.getContentList();
        let itemsHTML = [];
        if (itemList) {
            for(let key in itemList)if (itemList.hasOwnProperty(key)) itemsHTML.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($8928b35984758c11$var$CharItem, {
                key: key,
                id: key,
                identifier: this.identifier,
                doc: this.props.doc,
                parentNode: this.getCurrentNode(),
                deleteMethod: this.handleDeleteItem,
                canDelete: editing && this.state.canDelete,
                editing: editing,
                data: this.props.data
            }));
        }
        const addButton = editing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            onClick: this.handleAddItem,
            type: "button",
            className: "btn btn-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-plus me-0_25",
            "aria-hidden": "true"
        }), "Add Characteristic") : null;
        return this.context.canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, itemsHTML, addButton) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, itemsHTML);
    }
    getCurrentNode() {
        return this.context.fileType + "/" + this.context.fileId + "/" + this.identifier;
    }
    newItem() {
        window.firebase.database().ref(this.getCurrentNode()).push().set({
            text: "",
            status: ""
        });
    }
    getValuePath(key) {
        let path = this.context.fileType + "/" + this.context.fileId + "/" + this.identifier + "/" + key + "/text";
        return path;
    }
    getImagePath(key) {
        let path = this.context.fileType + "/" + this.context.fileId + "/" + this.identifier + "/" + key + "/text/image";
        return path;
    }
}
/**
 *  Component for single characteristic item (text + optional image)
 */ class $8928b35984758c11$var$CharItem extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.state = {
            status: ""
        };
        this.statusRef = null;
        this.pairedStatusRef = null;
        this.pairRef = null;
        this.id = props.id;
        this.list = props.identifier;
        this.which = this.list.substr(this.list.length - 1, 1); // last char "1" or "2"
        this.deleteButtonId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.deleteModalId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.handleDeleteButton = this.handleDeleteButton.bind(this);
        this.isPaired = this.isPaired.bind(this);
        this.getPairedId = this.getPairedId.bind(this);
        this.getPairKey = this.getPairKey.bind(this);
        this.unpair = this.unpair.bind(this);
        this.getBaseNode = this.getBaseNode.bind(this);
    }
    componentWillUnmount() {
        this.statusRef.off('value', this.statusWatcher);
    }
    componentDidMount() {
        const status = [
            this.getBaseNode(),
            this.list,
            this.id,
            "status"
        ].join("/");
        this.statusRef = window.firebase.database().ref(status);
        this.statusWatcher = this.statusRef.on("value", (data)=>{
            this.setState({
                "status": data.val()
            });
        });
    }
    getBaseNode() {
        return this.props.doc.type + "/" + this.props.doc.id;
    }
    isPaired() {
        return undefined !== this.props.data && "" !== this.state.status;
    }
    unpair() {
        if (this.isPaired()) {
            const pairedId = this.getPairedId();
            const pairedList = "characteristics1" === this.list ? "characteristics2" : "characteristics1";
            const pairedStatus = [
                this.getBaseNode(),
                pairedList,
                pairedId,
                "status"
            ].join("/");
            this.pairedStatusRef = window.firebase.database().ref(pairedStatus);
            if (null !== pairedId) {
                const pairKey = this.getPairKey(this.state.status, this.list, this.id);
                this.pairRef = window.firebase.database().ref(this.getBaseNode() + "/pairs/" + this.state.status + "characteristics/" + pairKey);
                //Set status values to empty and delete pairs database entry in realtimedb
                this.statusRef.set("", ()=>{
                    this.pairedStatusRef.set("", ()=>{
                        this.pairRef.remove();
                    });
                });
            }
        }
    // TODO: also remove from PairedCharacterictics state.pairedItems?
    }
    getPairKey(status, list, id) {
        if (this.isPaired() && undefined !== this.props.data.likePairedCharacteristics && undefined !== this.props.data.unlikePairedCharacteristics) {
            const pairedCharacteristics = "unlike" === status ? this.props.data.unlikePairedCharacteristics : this.props.data.likePairedCharacteristics;
            const pairKeys = Object.keys(pairedCharacteristics);
            let found = pairKeys.find((key)=>pairedCharacteristics[key]["characteristic" + this.which] === id);
            if (undefined !== found) return found;
        }
        return null;
    }
    getPairedId() {
        if (!this.isPaired()) return null;
        else {
            const status = this.state.status;
            const pairKey = this.getPairKey(status, this.list, this.id);
            const which = "1" === this.which ? "2" : "1";
            const pairs = this.props.data[status + "PairedCharacteristics"];
            const pair = undefined !== pairs && null !== pairKey ? pairs[pairKey] : null;
            const other = null !== pair ? pair["characteristic" + which] : null;
            return other;
        }
    }
    render() {
        const characteristic = this.list + "/" + this.id + "/text";
        // CORGI-414 check if paired on delete
        const deletePairWarning = "The characteristic has been paired. Deleting it will undo the pair. Do you want to delete this characteristic?";
        const deleteMessage = this.isPaired() ? deletePairWarning : (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(this.props.doc.type + "." + this.list + ".delete");
        const deleteModal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $cc5d5838c074a4ab$export$2e2bcd8739ae039), {
            id: this.deleteModalId,
            method: this.handleDeleteButton,
            text: deleteMessage,
            yes: "Remove Item"
        });
        const deleteIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $c8db36dd985f35f1$export$2e2bcd8739ae039), {
            icon: "fa-times",
            tooltip: "Remove item",
            modalId: this.deleteModalId,
            canDelete: this.props.canDelete
        });
        return this.props.editing && this.context.canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-primary"
        }, this.props.canDelete ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box-row-close"
        }, deleteModal, deleteIcon) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "form-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            addImage: true,
            placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(this.props.doc.type + "." + this.list + ".placeholder"),
            identifier: characteristic
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: characteristic,
            className: "grouping-text"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: characteristic + "/image",
            className: "grouping-img"
        })));
    }
    handleDeleteButton() {
        this.unpair(); // CORGI-414 unpair before delete
        this.props.deleteMethod(this.id);
    }
}
$8928b35984758c11$var$CharItem.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    identifier: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    doc: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).object.isRequired,
    data: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).object.isRequired,
    canDelete: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).bool.isRequired,
    deleteMethod: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).func.isRequired,
    parentNode: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired
};



var $6wXVr = parcelRequire("6wXVr");



var $6wXVr = parcelRequire("6wXVr");









class $6f8c9e29208a5ee0$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.state = {
            findButtonsActive: false,
            pairButtonActive: false,
            checkedA: null,
            checkedB: null,
            pairedItems: {},
            characteristics1: {},
            characteristics2: {}
        };
        this.canBeEmpty = true;
        this.sourceA = "characteristics1";
        this.sourceB = "characteristics2";
        this.buttonId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.modalId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.handleOpen = this.handleOpen.bind(this);
        this.handleChangeA = this.handleChangeA.bind(this);
        this.handleChangeB = this.handleChangeB.bind(this);
        this.isPairingPossible = this.isPairingPossible.bind(this);
        this.checkPairButton = this.checkPairButton.bind(this);
        this.handlePair = this.handlePair.bind(this);
        this.makePair = this.makePair.bind(this);
        this.getCurrentNode = this.getCurrentNode.bind(this);
        this.getBaseNode = this.getBaseNode.bind(this);
    }
    componentWillMount() {}
    componentDidMount() {
        this.changeMakePairStatus();
    }
    changeMakePairStatus = ()=>{
        this.setState({
            findButtonsActive: this.isPairingPossible()
        });
    };
    render() {
        const wantEditing = undefined !== this.props.editing ? this.props.editing : true;
        const editing = this.context.canEdit && wantEditing;
        const listA = this.props.unpairedCharacteristics1;
        const listB = this.props.unpairedCharacteristics2;
        const listPairedItems = this.props.pairedCharacteristics;
        let pairedItems = [], modalItemsA = [], modalItemsB = [];
        const showCategory = undefined !== this.props.showCategory && this.props.showCategory;
        const showLabel = undefined !== this.props.showLabel && this.props.showLabel;
        const label = this.props.label ? this.props.label : null;
        const header = this.props.header ? this.props.header : null;
        const pairButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            id: this.buttonId,
            type: "button",
            className: "btn btn-primary",
            onClick: this.handleOpen,
            "data-cfw": "modal",
            "data-cfw-modal-target": '#' + this.modalId,
            disabled: !this.state.findButtonsActive
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-plus me-0_25",
            "aria-hidden": "true"
        }), "\xa0", (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(this.buttonTextKey));
        // CORGI-330 add unpaired lists
        let unpairedItemsA = [];
        let unpairedItemsB = [];
        if (listPairedItems instanceof Object) {
            for(let key in listPairedItems)if (listPairedItems.hasOwnProperty(key)) {
                let pairedItem = listPairedItems[key];
                pairedItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($6f8c9e29208a5ee0$var$CharPair, {
                    key: key,
                    doc: this.props.doc,
                    printing: 'print' === this.props.doc.section,
                    pairedID: key,
                    idA: pairedItem["characteristic1"],
                    idB: pairedItem["characteristic2"],
                    showBoth: this.showBoth,
                    catIdentifier: this.catIdentifier,
                    charIdentifier: this.charIdentifier,
                    fileType: this.context.docType,
                    fileId: this.context.docId,
                    showCategory: showCategory,
                    showLabel: showLabel,
                    editing: editing,
                    label: label,
                    header: header && Object.keys(pairedItems).length === 0 ? header : null
                }));
            }
        }
        if (listA) {
            for(let key in listA)if (listA.hasOwnProperty(key)) {
                unpairedItemsA.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($6f8c9e29208a5ee0$var$UnpairedItem, {
                    key: key,
                    id: key,
                    parentNode: this.getBaseNode() + "/" + this.sourceA
                }));
                modalItemsA.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($6f8c9e29208a5ee0$var$CharOption, {
                    key: key,
                    id: key,
                    group: "groupA",
                    parentNode: this.getBaseNode() + "/" + this.sourceA,
                    checked: this.state.checkedA,
                    change: this.handleChangeA
                }));
            }
        }
        if (listB) {
            for(let key in listB)if (listB.hasOwnProperty(key)) {
                unpairedItemsB.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($6f8c9e29208a5ee0$var$UnpairedItem, {
                    key: key,
                    id: key,
                    parentNode: this.getBaseNode() + "/" + this.sourceB
                }));
                modalItemsB.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($6f8c9e29208a5ee0$var$CharOption, {
                    key: key,
                    id: key,
                    group: "groupB",
                    parentNode: this.getBaseNode() + "/" + this.sourceB,
                    checked: this.state.checkedB,
                    change: this.handleChangeB
                }));
            }
        }
        const unpaired = unpairedItemsA.length !== 0 || unpairedItemsB.length !== 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Characteristics of Concept A"), unpairedItemsA), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Characteristics of Concept B"), unpairedItemsB)) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, pairedItems, pairedItems.length === 0 && showCategory && editing && this.catIdentifier === "likecategories" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", {
            className: "directions text-center"
        }, "There are no similar pairs to categorize") : null, pairedItems.length === 0 && showCategory && editing && this.catIdentifier === "unlikecategories" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", {
            className: "directions text-center"
        }, "There are no different pairs to categorize") : null, editing && !showCategory ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, unpaired, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "text-center"
        }, !this.state.findButtonsActive && this.charIdentifier === "likecharacteristics" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", {
            className: "directions text-center my-0_25"
        }, "There are no similar pairs to categorize") : null, !this.state.findButtonsActive && this.charIdentifier === "unlikecharacteristics" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", {
            className: "directions text-center my-0_25"
        }, "There are no different pairs to categorize") : null, pairButton, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: this.modalId,
            className: "modal pair-modal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-dialog modal-dialog-centered"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            className: "h1 modal-title"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(this.modalTitleKey)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "close",
            "data-cfw-dismiss": "modal",
            "aria-label": "Close"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-times",
            "aria-hidden": "true"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", {
            className: "directions"
        }, this.props.directions), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("form", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md mb-1 mb-md-0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("fieldset", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("legend", {
            className: "h2"
        }, "Concept A"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "concept1",
            className: "box bg-autofill"
        }), modalItemsA)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("fieldset", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("legend", {
            className: "h2"
        }, "Concept B"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "concept2",
            className: "box bg-autofill"
        }), modalItemsB))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "text-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "btn btn-link",
            "data-cfw-dismiss": "modal"
        }, "Cancel"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            onClick: this.handlePair,
            disabled: !this.state.pairButtonActive,
            className: "btn btn-primary"
        }, "Add Pair"))))))))) : null);
    }
    // Check whether the conditions are met for the "Pair" button to be active.
    // True if there is at least one non-blank, non-paired item in each column.
    isPairingPossible() {
        const listA = this.props.unpairedCharacteristics1;
        const listB = this.props.unpairedCharacteristics2;
        var checkA = false;
        var checkB = false;
        if (listA) {
            for(let key in listA)if (listA.hasOwnProperty(key)) checkA = true;
        }
        if (listB) {
            for(let key in listB)if (listB.hasOwnProperty(key)) checkB = true;
        }
        console.log("CheckA = " + checkA + "-> CheckB = " + checkB);
        if (checkA === true && checkB === true) return true;
        else return false;
    }
    handleOpen() {
        this.setState({
            pairButtonActive: false,
            checkedA: null,
            checkedB: null
        });
    }
    handleChangeA(event) {
        if (event != null) {
            const a = event.target.value;
            this.setState({
                checkedA: a
            });
            this.checkPairButton(a, this.state.checkedB);
        }
    }
    handleChangeB(event) {
        if (event != null) {
            const b = event.target.value;
            this.setState({
                checkedB: b
            });
            this.checkPairButton(this.state.checkedA, b);
        }
    }
    checkPairButton(a, b) {
        if (a != null && b != null && !this.state.pairButtonActive) this.setState({
            pairButtonActive: true
        });
    }
    handlePair() {
        const idA = this.state.checkedA, idB = this.state.checkedB;
        if (idA === null || idB === null) return;
        this.makePair(idA, idB);
        (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#' + this.buttonId).CFW_Modal('hide');
        this.setState({
            pairButtonActive: false,
            checkedA: null,
            checkedB: null
        });
    }
    makePair(idA, idB) {
        console.log("make Pair");
        this.context.contentUpdated();
        // this.listA.remove(idA);
        let characteristic1Ref = window.firebase.database().ref(this.getBaseNode() + "/characteristics1/" + idA);
        let characteristic2Ref = window.firebase.database().ref(this.getBaseNode() + "/characteristics2/" + idB);
        characteristic1Ref.update({
            status: this.myStatus
        }, ()=>{
            characteristic2Ref.update({
                status: this.myStatus
            }, ()=>{
                let pairsRef = window.firebase.database().ref(this.getCurrentNode()).push();
                pairsRef.set({
                    "characteristic1": idA,
                    "characteristic2": idB
                });
            });
        });
        window.tracker.trackEvent("Content", "make pair", "");
    }
    getCurrentNode() {
        return this.context.fileType + "/" + this.context.fileId + "/pairs/" + this.charIdentifier;
    }
    getBaseNode() {
        return this.context.fileType + "/" + this.context.fileId;
    }
}
class $6f8c9e29208a5ee0$var$UnpairedItem extends (0, $6wXVr.Component) {
    constructor(props){
        super(props);
        this.getCurrentNode = this.getCurrentNode.bind(this);
        this.state = {
            text: ""
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, this.state.text);
    }
    getCurrentNode() {
        return this.props.parentNode + "/" + this.props.id + "/text";
    }
    componentWillUnmount() {
        this.ref.off('value', this.watcher);
    }
    componentDidMount() {
        this.ref = window.firebase.database().ref(this.getCurrentNode());
        this.watcher = this.ref.on('value', ()=>{
            let firepadHeadless = new window.Firepad.Headless(this.ref);
            firepadHeadless.getText((text)=>{
                if (this.state.text !== text) this.setState({
                    text: text
                });
                firepadHeadless.dispose();
            });
        });
    }
}
/**
 * A single row in the (Un)like Characteristics listing,
 * consisting of the (read-only) characteristic and an editable Category text box,
 * with a "delete" button that just unpairs the items.
 */ class $6f8c9e29208a5ee0$var$CharPair extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.handleUnpair = this.handleUnpair.bind(this);
        this.getBaseNode = this.getBaseNode.bind(this);
        this.textFieldId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.deleteModalId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.state = {
            textA: "",
            textB: ""
        };
    }
    render() {
        const type = "comparison"; // Only comparison has PairedCharacteristics
        const eq_icon = this.props.charIdentifier.includes("unlike") ? "fa-not-equal" : "fa-equals";
        const eq_text = this.props.charIdentifier.includes("unlike") ? "is different from" : "is similar to";
        const category = "characteristics1/" + this.props.idA + "/category";
        const bgClass = !this.props.editing ? this.props.printing ? "pairing print-nobreak" : "mb-2" : !this.props.showCategory ? "bg-autofill box" : "";
        const nonEditCategory = this.props.showCategory ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, this.props.label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(type + "." + this.props.catIdentifier + ".singleLabel")) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: category,
            className: "grouping-text"
        }), this.props.printing ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: category + "/image",
            className: "grouping-img"
        }))))) : null;
        const imageA = null;
        const imageB = null;
        const printHeaderA = this.props.printing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "concept1",
            className: ""
        })) : null;
        const printHeaderB = this.props.printing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "concept2",
            className: ""
        })) : null;
        const textA = this.props.editing ? this.state.textA : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, printHeaderA, this.state.textA), imageA);
        const textB = this.props.editing ? this.state.textB : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, printHeaderB, this.state.textB), imageB);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: bgClass
        }, this.props.editing && !this.props.showCategory ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box-row-close"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $c8db36dd985f35f1$export$2e2bcd8739ae039), {
            tooltip: "Remove pair",
            modalId: this.deleteModalId,
            icon: "fa-times",
            canDelete: this.props.editing
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $cc5d5838c074a4ab$export$2e2bcd8739ae039), {
            id: this.deleteModalId,
            method: this.handleUnpair,
            text: (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(type + "." + this.props.charIdentifier + ".delete"),
            instructions: (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(type + "." + this.props.charIdentifier + ".deleteInstructions"),
            yes: "Unpair"
        })) : null, this.props.header, this.props.label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "h6"
        }, this.props.label) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping grouping-2 grouping-match"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, this.props.showLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("label", {
            className: "sr-only-md-up"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(type + "." + this.props.charIdentifier + ".singleLabel")) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bg-autofill box"
        }, textA)), !this.props.editing || !this.props.showCategory ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-icon"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa " + eq_icon,
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, eq_text)) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, this.props.showLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("label", {
            className: "sr-only-md-up"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(type + "." + this.props.charIdentifier + ".singleLabel")) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bg-autofill box"
        }, textB))), this.props.showCategory ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket bracket-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-arrow-vertical"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-start"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-arrow"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-end"
        })), this.props.editing && this.props.showLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("label", {
            htmlFor: this.textFieldId,
            className: "sr-only-md-up"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(type + "." + this.props.catIdentifier + ".singleLabel")) : null, this.props.editing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            labelClassName: "sr-only-md-up",
            label: null,
            addImage: true,
            domId: this.textFieldId,
            inputType: "text-area",
            ...this.props,
            identifier: category,
            placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(this.context.fileType + "." + this.props.catIdentifier + ".placeholder")
        })) : nonEditCategory) : null));
    }
    getBaseNode() {
        return this.context.fileType + "/" + this.context.fileId;
    }
    componentWillUnmount() {
        if (this.ARef) this.ARef.off('value', this.AWatcher);
        if (this.BRef) this.BRef.off('value', this.BWatcher);
    }
    componentDidMount() {
        if ('empty' !== this.props.pairedID) {
            this.ARef = window.firebase.database().ref(this.getBaseNode() + "/characteristics1/" + this.props.idA + "/text");
            this.BRef = window.firebase.database().ref(this.getBaseNode() + "/characteristics2/" + this.props.idB + "/text");
            this.AWatcher = this.ARef.on("value", ()=>{
                let firepadHeadlessA = new window.Firepad.Headless(this.ARef);
                firepadHeadlessA.getText((text)=>{
                    if (this.state && this.state.textA !== text) this.setState({
                        textA: text
                    });
                    firepadHeadlessA.dispose();
                });
            });
            this.BWatcher = this.BRef.on("value", ()=>{
                let firepadHeadlessB = new window.Firepad.Headless(this.BRef);
                firepadHeadlessB.getText((text)=>{
                    if (this.state && this.state.textB !== text) this.setState({
                        textB: text
                    });
                    firepadHeadlessB.dispose();
                });
            });
        }
    }
    handleUnpair() {
        console.log("Unpair");
        this.context.contentUpdated();
        // remove category, if any
        window.firebase.database().ref(this.getBaseNode() + "/characteristics1/" + this.props.idA + "/category").remove();
        //Set status value to empty and delete pairs database in realtimedb
        window.firebase.database().ref(this.getBaseNode() + "/characteristics1/" + this.props.idA + "/status").set("", ()=>{
            window.firebase.database().ref(this.getBaseNode() + "/characteristics2/" + this.props.idB + "/status").set("", ()=>{
                window.firebase.database().ref(this.getBaseNode() + "/pairs/" + this.props.charIdentifier + "/" + this.props.pairedID).remove();
            });
        });
        window.tracker.trackEvent("Content", "unpair", "");
    }
}
$6f8c9e29208a5ee0$var$CharPair.propTypes = {
    idA: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    idB: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    pairedID: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    showBoth: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).bool.isRequired,
    charIdentifier: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    catIdentifier: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    showCategory: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).bool
};
/**
 * A radio-button option in the modal window for choosing a pair of items.
 */ class $6f8c9e29208a5ee0$var$CharOption extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.getCurrentNode = this.getCurrentNode.bind(this);
        this.onChange = this.onChange.bind(this);
        this.state = {
            text: ""
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "form-check form-checkradio"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("input", {
            id: this.props.id,
            className: "form-check-input",
            type: "radio",
            name: this.props.group,
            value: this.props.id,
            onChange: this.onChange,
            checked: this.props.id === this.props.checked
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("label", {
            className: "form-check-label",
            htmlFor: this.props.id
        }, this.state.text));
    }
    onChange(event) {
        if (this.state.text === null || this.state.text === "") event = null;
        this.props.change(event);
    }
    getCurrentNode() {
        return this.props.parentNode + "/" + this.props.id + "/text";
    }
    componentWillUnmount() {
        this.ref.off('value', this.watcher);
    }
    componentDidMount() {
        this.ref = window.firebase.database().ref(this.getCurrentNode());
        this.watcher = this.ref.on("value", ()=>{
            let firepadHeadless = new window.Firepad.Headless(this.ref);
            firepadHeadless.getText((text)=>{
                if (this.state.text !== text) this.setState({
                    text: text
                });
                firepadHeadless.dispose();
            });
        });
    }
}
$6f8c9e29208a5ee0$var$CharOption.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    checked: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string,
    group: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    parentNode: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired
};


class $7de4a7f2df2e31a1$export$2e2bcd8739ae039 extends (0, $6f8c9e29208a5ee0$export$2e2bcd8739ae039) {
    constructor(props){
        super(props);
        this.charIdentifier = "likecharacteristics";
        this.catIdentifier = "likecategories";
        this.myStatus = "like";
        this.buttonTextKey = "comparison.likecharacteristics.buttonText";
        this.modalTitleKey = "comparison.likecharacteristics.modalTitle";
        this.showBoth = undefined !== props.showBoth ? props.showBoth : false;
        this.showLabel = undefined !== props.showLabel ? props.showLabel : true;
    }
}


class $7c272f631773d5f7$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    constructor(props){
        super(props);
        this.sourceA = "characteristics1";
        this.sourceB = "characteristics2";
        this.showLabel = undefined !== this.props.showLabel ? this.props.showLabel : false;
        this.childRef1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createRef();
    }
    changeMakePairStatus = ()=>{
        this.childRef1.current.changeMakePairStatus();
    };
    render() {
        const doc = this.props.doc;
        const label = 'print' !== doc.section && undefined !== this.props.section.likeLabel ? this.props.section.likeLabel : null;
        const showCategory = undefined !== this.props.showCategory && this.props.showCategory;
        const like = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $7de4a7f2df2e31a1$export$2e2bcd8739ae039), {
            ref: this.childRef1,
            doc: doc,
            showCategory: showCategory,
            showBoth: true,
            showLabel: this.showLabel,
            editing: this.props.editing,
            label: label,
            header: undefined !== this.props.header ? this.props.header : null,
            directions: this.props.editing ? this.props.section.description : null,
            unpairedCharacteristics1: this.props.data.unpairedCharacteristics1,
            unpairedCharacteristics2: this.props.data.unpairedCharacteristics2,
            pairedCharacteristics: this.props.data.likePairedCharacteristics
        });
        return 'complete' !== this.props.section.key && 'create-share' !== this.props.section.key ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b5ffa3f136ed406e$export$2e2bcd8739ae039), {
            tooltipTitle: true,
            section: this.props.section,
            editing: this.props.editing
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Essential Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "essentialquestion",
            className: "box bg-autofill"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Concept A"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "concept1",
            className: "box bg-autofill"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Concept B"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "concept2",
            className: "box bg-autofill"
        }))), like) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, like);
    }
}




var $6wXVr = parcelRequire("6wXVr");



class $2d6900c09dba55af$export$2e2bcd8739ae039 extends (0, $6f8c9e29208a5ee0$export$2e2bcd8739ae039) {
    constructor(props){
        super(props);
        this.charIdentifier = "unlikecharacteristics";
        this.catIdentifier = "unlikecategories";
        this.myStatus = "unlike";
        this.buttonTextKey = "comparison.unlikecharacteristics.buttonText";
        this.modalTitleKey = "comparison.unlikecharacteristics.modalTitle";
        this.showBoth = undefined !== props.showBoth ? props.showBoth : false;
        this.showLabel = undefined !== props.showLabel ? props.showLabel : true;
    }
}


class $58d7ead67a01a33a$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    constructor(props){
        super(props);
        this.sourceA = "characteristics1";
        this.sourceB = "characteristics2";
        this.showLabel = undefined !== this.props.showLabel ? this.props.showLabel : false;
        this.childRef1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createRef();
    }
    changeMakePairStatus = ()=>{
        this.childRef1.current.changeMakePairStatus();
    };
    render() {
        const doc = this.props.doc;
        const label = 'print' !== doc.section && undefined !== this.props.section.unlikeLabel ? this.props.section.unlikeLabel : null;
        const showCategory = undefined !== this.props.showCategory && this.props.showCategory;
        const unlike = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $2d6900c09dba55af$export$2e2bcd8739ae039), {
            ref: this.childRef1,
            doc: doc,
            showCategory: showCategory,
            showBoth: true,
            showLabel: this.showLabel,
            editing: this.props.editing,
            label: label,
            header: undefined !== this.props.header ? this.props.header : null,
            directions: this.props.editing ? this.props.section.description : null,
            unpairedCharacteristics1: this.props.data.unpairedCharacteristics1,
            unpairedCharacteristics2: this.props.data.unpairedCharacteristics2,
            pairedCharacteristics: this.props.data.unlikePairedCharacteristics
        });
        return 'complete' !== this.props.section.key && 'create-share' !== this.props.section.key ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b5ffa3f136ed406e$export$2e2bcd8739ae039), {
            tooltipTitle: true,
            section: this.props.section,
            editing: this.props.editing
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Essential Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "essentialquestion",
            className: "box bg-autofill flex-grow-1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Concept A"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "concept1",
            className: "box bg-autofill"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Concept B"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "concept2",
            className: "box bg-autofill"
        }))), unlike) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, unlike);
    }
}




var $6wXVr = parcelRequire("6wXVr");

class $1290cbb92ac2986c$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    getRef(identifier) {
        let path = this.context.fileType + "/" + this.context.fileId + "/" + identifier;
        return window.firebase.database().ref(path);
    }
    getValuePromise(path) {
        return this.getRef(path).once("value");
    }
    getFirepadTextPromise(path) {
        return new Promise((resolve, reject)=>{
            let firepadHeadless = new window.Firepad.Headless(this.getRef(path));
            firepadHeadless.getText((text)=>{
                firepadHeadless.dispose();
                resolve(text);
            });
        });
    }
    getFirepadMapPromise(path, key) {
        return new Promise((resolve, reject)=>{
            let ref = this.getRef(path);
            ref.once("value").then((list)=>{
                let keys = [];
                let promises = [];
                list.forEach((item)=>{
                    keys.push(item.key);
                    promises.push(this.getFirepadTextPromise(path + '/' + item.key + '/' + key));
                });
                Promise.all(promises).then((values)=>{
                    let map = new Map();
                    for(let i = 0; i < keys.length; i++)map.set(keys[i], values[i]);
                    resolve(map);
                });
            });
        });
    }
    getTextMapPromise(path, key) {
        return new Promise((resolve, reject)=>{
            let ref = this.getRef(path);
            ref.once("value").then((list)=>{
                let keys = [];
                let promises = [];
                list.forEach((item)=>{
                    keys.push(item.key);
                    promises.push(this.getValuePromise(path + '/' + item.key + '/' + key));
                });
                Promise.all(promises).then((values)=>{
                    let map = new Map();
                    for(let i = 0; i < keys.length; i++)map.set(keys[i], values[i].val());
                    resolve(map);
                });
            });
        });
    }
    mapHasContent(map) {
        if (map == null) return false;
        var found = false;
        map.forEach((value, key)=>{
            if (this.hasContent(value)) found = true;
        });
        return found;
    }
    allMapHasContent(map) {
        if (map == null) return false;
        var found = true;
        map.forEach((value, key)=>{
            if (!this.hasContent(value)) found = false;
        });
        return found;
    }
    hasContent(text) {
        // Return a true value if text is not null and contains something other than whitespace.
        return undefined !== text && null !== text && text.trim();
    }
}



var $6wXVr = parcelRequire("6wXVr");










class $b230fd9af7e1399f$export$2e2bcd8739ae039 extends (0, $c01ab3c338b52a54$export$2e2bcd8739ae039) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.canBeEmpty = false;
        this.editing = this.props.editing;
        this.fileType = !(0, $21f9ebdc444decaf$export$6e22c362a0406a2c)(this.props.docType) ? this.props.docType : null;
        this.fileId = !(0, $21f9ebdc444decaf$export$6e22c362a0406a2c)(this.props.docId) ? this.props.docId : null;
        this.identifier = "terms";
        this.newItem = this.newItem.bind(this);
        this.getCurrentNode = this.getCurrentNode.bind(this);
    }
    componentDidMount() {
        super.componentDidMount();
        (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#modalKeyTerms').on('afterHide.cfw.modal', ()=>{
            window.tracker.trackEvent("Interface", "close key terms", "");
        });
    }
    closeKeyTermsModal() {
        window.speechstream.speechTools.stop();
    }
    render() {
        let canEdit = this.context.canEdit;
        let printing = undefined !== this.props.printing ? this.props.printing : false;
        const termList = this.getContentList();
        const section = (0, $198066ba87364cec$export$2e2bcd8739ae039)[this.context.fileType].terms;
        if (!this.fileType) this.fileType = this.context.fileType;
        if (!this.fileId) this.fileId = this.context.fileId;
        let termsHTML = [];
        if (termList) {
            if (this.context.canEdit) {
                for(let key in termList)if (termList.hasOwnProperty(key)) termsHTML.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($b230fd9af7e1399f$var$Term, {
                    key: key,
                    id: key,
                    deleteMethod: this.handleDeleteItem,
                    canDelete: this.state.canDelete,
                    fileType: this.fileType,
                    fileId: this.fileId,
                    editing: this.editing,
                    section: section
                }));
            } else {
                for(let key in termList)if (termList.hasOwnProperty(key)) termsHTML.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($b230fd9af7e1399f$var$Term, {
                    key: key,
                    id: key,
                    deleteMethod: this.handleDeleteItem,
                    canDelete: false,
                    fileType: this.fileType,
                    fileId: this.fileId,
                    editing: false,
                    section: section
                }));
            }
        }
        const addButton = this.editing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            onClick: this.handleAddItem,
            className: "btn btn-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-plus me-0_25",
            "aria-hidden": "true"
        }), "Add Key Term"))) : null;
        const termLabel = section.term ? section.term.label : "Word or Phrase";
        const defLabel = section.def ? section.def.label : "Definition";
        const title = section.title ? section.title : section.label;
        return canEdit ? this.editing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "modalKeyTerms",
            className: "modal keyterm-modal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-dialog"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            className: "h1 modal-title"
        }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "close",
            "data-cfw-dismiss": "modal",
            "aria-label": "Close",
            onClick: ()=>this.closeKeyTermsModal()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-times",
            "aria-hidden": "true"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row d-sm-down-none",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "h2"
        }, termLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "h2"
        }, defLabel))), termsHTML, addButton)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row d-sm-down-none",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "h3"
        }, termLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "h3"
        }, defLabel))), termsHTML) : this.editing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "modalKeyTerms",
            className: "modal keyterm-modal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-dialog"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "close",
            "data-cfw-dismiss": "modal",
            "aria-label": "Close"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-times",
            "aria-hidden": "true"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b5ffa3f136ed406e$export$2e2bcd8739ae039), {
            section: section,
            editing: this.editing,
            isInModal: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "h2"
        }, termLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "h2"
        }, defLabel))), termsHTML)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", null, !printing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row d-sm-down-none",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "h3"
        }, termLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "h3"
        }, defLabel))) : null, termsHTML);
    }
    getCurrentNode() {
        return this.fileType + "/" + this.fileId + "/" + this.identifier;
    }
    newItem() {
        window.firebase.database().ref(this.getCurrentNode()).push().set({
            term: "",
            def: ""
        });
    }
    getValuePath(key) {
        let path = this.context.fileType + "/" + this.context.fileId + "/" + this.identifier + "/" + key + "/term";
        return path;
    }
    getImagePath(key) {
        return "";
    }
}
$b230fd9af7e1399f$export$2e2bcd8739ae039.propTypes = {
    stepnum: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string
};
/**
 *  Component for single Term-Definition pair
 */ class $b230fd9af7e1399f$var$Term extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.deleteModalId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.termId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.defId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.handleDeleteButton = this.handleDeleteButton.bind(this);
    }
    render() {
        return this.props.editing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            role: "group",
            "aria-label": "Vocabulary item"
        }, this.props.canDelete ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box-row-close"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "btn btn-icon btn-link",
            "aria-label": "Remove key term",
            onClick: this.handleDeleteButton
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-times text-primary",
            "aria-hidden": "true"
        }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            addImage: false,
            inputClassName: " ",
            inputType: "text-area",
            domId: this.termId,
            ...this.props,
            label: "term",
            placeholder: this.props.section.term.placeholder,
            identifier: "terms/" + this.props.id + "/term"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            addImage: false,
            inputClassName: " ",
            inputType: "text-area",
            domId: this.defId,
            ...this.props,
            label: "definition",
            placeholder: this.props.section.def.placeholder,
            identifier: "terms/" + this.props.id + "/def"
        }))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row",
            role: "group",
            "aria-label": "Vocabulary item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "terms/" + this.props.id + "/term"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "terms/" + this.props.id + "/def"
        }))));
    }
    handleDeleteButton(event) {
        if (!this.props.canDelete) window.alert("There must be at least one entry in this list");
        else if (window.confirm("Really delete this term and definition?")) this.props.deleteMethod(this.props.id);
    // this.props.deleteMethod(this.props.id+"/image");
    }
}
$b230fd9af7e1399f$var$Term.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    canDelete: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).bool.isRequired,
    deleteMethod: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).func.isRequired
};





var $6wXVr = parcelRequire("6wXVr");


class $a70f4f4581e3fd55$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    render() {
        let langKey = this.context.fileType + "." + this.props.identifier + ".empty";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: this.props.className
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", {
            className: "mb-0 font-italic"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(langKey))));
    }
}


const $7dcc312e8f17de56$var$similarHeader = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Similar Characteristics & Categories");
const $7dcc312e8f17de56$var$dissimilarHeader = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Different Characteristics & Categories");
const $7dcc312e8f17de56$var$complete = (0, $198066ba87364cec$export$2e2bcd8739ae039).comparison.sections[(0, $198066ba87364cec$export$2e2bcd8739ae039).comparison.sections.length - 1];
const $7dcc312e8f17de56$export$7b34c17ec45b7fc7 = (doc, fieldStatus, inCompleteStep)=>{
    const cssSticky = inCompleteStep ? "content-main-sticky-top" : "content-sidebar-sticky-top";
    const question = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "essentialquestion",
        className: "grouping-text"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "essentialquestion/image",
        className: "grouping-img"
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Essential Question"), !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, question) : fieldStatus.hasEssentialQuestion ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, question) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "essentialquestion",
        className: "box bg-unfilled"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: cssSticky
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Concepts"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "col-md-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $d6bad315ad35dae0$export$2e2bcd8739ae039), {
        type: doc.type,
        identifier: "concept1",
        item: "label"
    })), !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "concept1",
        className: 'box bg-autofill'
    }) : fieldStatus.hasConcept1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "concept1",
        className: 'box bg-autofill'
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "concept1",
        className: "box bg-unfilled"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "col-md-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $d6bad315ad35dae0$export$2e2bcd8739ae039), {
        type: doc.type,
        identifier: "concept2",
        item: "label"
    })), !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "concept2",
        className: 'box bg-autofill'
    }) : fieldStatus.hasConcept2 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "concept2",
        className: 'box bg-autofill'
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "concept2",
        className: "box bg-unfilled"
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "col-md-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", null, "Description of Concept A"), !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "description1",
        className: "grouping-text"
    }), 'print' === doc.section ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "description1/image",
        className: "grouping-img"
    }))) : fieldStatus.hasDescription1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "description1",
        className: "grouping-text"
    }), 'print' === doc.section ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "description1/image",
        className: "grouping-img"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "description1",
        className: "box bg-unfilled"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "col-md-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", null, "Description of Concept B"), !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "description2",
        className: "grouping-text"
    }), 'print' === doc.section ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "description2/image",
        className: "grouping-img"
    }))) : fieldStatus.hasDescription2 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "description2",
        className: "grouping-text"
    }), 'print' === doc.section ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "description2/image",
        className: "grouping-img"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "description2",
        className: "box bg-unfilled"
    })))));
};
const $7dcc312e8f17de56$export$76951ff45a6df488 = (doc, fieldStatus, inCompleteStep)=>{
    const catBox = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "grouping grouping-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "grouping-title"
    }, "Overall Concept"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "grouping-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box box-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "overall",
        className: "grouping-text"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "overall/image",
        className: "grouping-img"
    }))))));
    const overall = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "grouping grouping-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "grouping-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "grouping-item-title"
    }, "Concept A"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "concept1",
        className: "grouping-text"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "grouping-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "grouping-item-title"
    }, "Concept B"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "concept2",
        className: "grouping-text"
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket bracket-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-arrow-vertical"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-bar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-arrow"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-bar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-end"
    })), catBox);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Overall Concept"), !inCompleteStep || fieldStatus.hasOverall ? overall : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "overall",
        className: "box bg-unfilled"
    }));
};
const $7dcc312e8f17de56$export$e50c38059db6188a = (doc, characteristicsData, fieldStatus, inCompleteStep)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Characteristics"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "col-md-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", null, "Characteristics of Concept A"), !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8928b35984758c11$export$2e2bcd8739ae039), {
        doc: doc,
        identifier: "characteristics1",
        editing: false,
        data: characteristicsData
    }) : fieldStatus.hasCharacteristics1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8928b35984758c11$export$2e2bcd8739ae039), {
        doc: doc,
        identifier: "characteristics1",
        editing: false,
        data: characteristicsData
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "characteristics1",
        className: "box bg-unfilled"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "col-md-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", null, "Characteristics of Concept B"), !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8928b35984758c11$export$2e2bcd8739ae039), {
        doc: doc,
        identifier: "characteristics2",
        editing: false,
        data: characteristicsData
    }) : fieldStatus.hasCharacteristics2 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8928b35984758c11$export$2e2bcd8739ae039), {
        doc: doc,
        identifier: "characteristics2",
        editing: false,
        data: characteristicsData
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "characteristics2",
        className: "box bg-unfilled"
    }))));
};
const $7dcc312e8f17de56$export$16021e7ac45ef24f = (doc, characteristicsData, fieldStatus, inCompleteStep)=>{
    const showLabel = false;
    return !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $7c272f631773d5f7$export$2e2bcd8739ae039), {
        editing: false,
        showBoth: true,
        showCategory: true,
        showLabel: showLabel,
        header: $7dcc312e8f17de56$var$similarHeader,
        doc: doc,
        section: $7dcc312e8f17de56$var$complete,
        data: characteristicsData
    })) : fieldStatus.hasSimilarCharacteristics ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $7c272f631773d5f7$export$2e2bcd8739ae039), {
        editing: false,
        showBoth: true,
        showCategory: true,
        showLabel: showLabel,
        header: $7dcc312e8f17de56$var$similarHeader,
        doc: doc,
        section: $7dcc312e8f17de56$var$complete,
        data: characteristicsData
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, $7dcc312e8f17de56$var$similarHeader, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "likecharacteristics",
        className: "box bg-unfilled"
    }));
};
const $7dcc312e8f17de56$export$ec010b194f5eafb = (doc, characteristicsData, fieldStatus, inCompleteStep)=>{
    const showLabel = false;
    return !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $58d7ead67a01a33a$export$2e2bcd8739ae039), {
        editing: false,
        showBoth: true,
        showCategory: true,
        showLabel: showLabel,
        header: $7dcc312e8f17de56$var$dissimilarHeader,
        doc: doc,
        section: $7dcc312e8f17de56$var$complete,
        data: characteristicsData
    })) : fieldStatus.hasDifferentCharacteristics ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $58d7ead67a01a33a$export$2e2bcd8739ae039), {
        editing: false,
        showBoth: true,
        showCategory: true,
        showLabel: showLabel,
        header: $7dcc312e8f17de56$var$dissimilarHeader,
        doc: doc,
        section: $7dcc312e8f17de56$var$complete,
        data: characteristicsData
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, $7dcc312e8f17de56$var$dissimilarHeader, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "unlikecharacteristics",
        className: "box bg-unfilled"
    }));
};
const $7dcc312e8f17de56$export$9a2dbef7a17e2e58 = (doc, fieldStatus, inCompleteStep)=>{
    const sum = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "summary",
        className: "grouping-text"
    }), 'print' === doc.section ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "summary/image",
        className: "grouping-img"
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("section", {
        className: "section mb-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
        className: "h2"
    }, "Summary"), !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, sum) : fieldStatus.hasSummary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, sum) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "summary",
        className: "box bg-unfilled"
    }));
};
const $7dcc312e8f17de56$export$cc3e2d3244e01b7f = (doc, fieldStatus, inCompleteStep)=>{
    const ext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "extensions",
        className: "grouping-text"
    }), 'print' === doc.section ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "extensions/image",
        className: "grouping-img"
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
        className: "h2"
    }, "Extensions"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, ext));
};
const $7dcc312e8f17de56$export$eb632fcff23bdc70 = (doc, fieldStatus, inCompleteStep)=>{
    const section = (0, $198066ba87364cec$export$2e2bcd8739ae039)[doc.type].terms;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("section", {
        className: "section mb-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, section.title ? section.title : section.label), !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b230fd9af7e1399f$export$2e2bcd8739ae039), {
        doc: doc,
        section: section,
        editing: false,
        secondary: true
    }) : fieldStatus.hasKeyTerms ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b230fd9af7e1399f$export$2e2bcd8739ae039), {
        doc: doc,
        section: section,
        editing: false,
        secondary: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "terms",
        className: "box bg-unfilled"
    }));
};
const $7dcc312e8f17de56$export$1f1d0ed2d2d34eef = (doc, fieldStatus, closeChecklist, onClickFunc)=>{
    return fieldStatus.display ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("section", {
        className: "section-step"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "h3"
    }, "Review Checklist"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box box-unfilled"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box-row-close"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
        type: "button",
        className: "btn btn-icon btn-link",
        "aria-label": "Remove key term",
        title: "Remove Checklist",
        onClick: closeChecklist
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
        className: "fa fa-times text-primary",
        "aria-hidden": "true"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", null, !fieldStatus.hasEssentialQuestion ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not entered an ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Essential Question"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "essentialquestion",
        onClick: ()=>onClickFunc(1)
    }, "Step 1"), " to complete the section.") : null, !fieldStatus.hasKeyTerms ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not entered any ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Key Terms"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "terms",
        onClick: ()=>onClickFunc(2)
    }, "Step 2"), " to define Key Terms") : null, !fieldStatus.hasConcept1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not entered an ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Concept A"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "concepts",
        onClick: ()=>onClickFunc(3)
    }, "Step 3"), " to complete the section.") : null, !fieldStatus.hasConcept2 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not entered an ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Concept B"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "concepts",
        onClick: ()=>onClickFunc(3)
    }, "Step 3"), " to complete the section.") : null, !fieldStatus.hasDescription1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not entered an ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Description of Concept A"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "concepts",
        onClick: ()=>onClickFunc(3)
    }, "Step 3"), " to complete the section.") : null, !fieldStatus.hasDescription2 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not entered an ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Description of Concept B"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "concepts",
        onClick: ()=>onClickFunc(3)
    }, "Step 3"), " to complete the section.") : null, !fieldStatus.hasOverall ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not entered an ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Overall Concept"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "overall",
        onClick: ()=>onClickFunc(4)
    }, "Step 4"), " to complete the section.") : null, !fieldStatus.hasCharacteristics1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not entered any ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Characteristics of Concept A"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "characteristics",
        onClick: ()=>onClickFunc(5)
    }, "Step 5"), " to complete the section.") : null, !fieldStatus.hasCharacteristics2 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not entered any ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Characteristics of Concept B"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "characteristics",
        onClick: ()=>onClickFunc(5)
    }, "Step 5"), " to complete the section.") : null, !fieldStatus.hasSimilarCharacteristics ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not entered any ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Similar Characteristics"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "likeCharacteristics",
        onClick: ()=>onClickFunc(6)
    }, "Step 6"), " to complete the section.") : null, !fieldStatus.hasDifferentCharacteristics ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not entered any ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Different Characteristics"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "unlikeCharacteristics",
        onClick: ()=>onClickFunc(8)
    }, "Step 8"), " to complete the section.") : null, !fieldStatus.hasSummary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not entered a ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Summary"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "summary",
        onClick: ()=>onClickFunc(10)
    }, "Step 10"), " to complete the section.") : null))) : null;
};
class $7dcc312e8f17de56$export$2e2bcd8739ae039 extends (0, $1290cbb92ac2986c$export$2e2bcd8739ae039) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.state = {
            display: false,
            hasEssentialQuestion: false,
            hasConcept1: false,
            hasConcept2: false,
            hasDescription1: false,
            hasDescription2: false,
            hasKeyTerms: false,
            hasOverall: false,
            hasCharacteristics1: false,
            hasCharacteristics2: false,
            hasSimilarCharacteristics: false,
            hasDifferentCharacteristics: false,
            hasSummary: false
        };
        this.closeChecklist = this.closeChecklist.bind(this);
        this.checkEmptyList = this.checkEmptyList.bind(this);
        this.mapHasContent = this.mapHasContent.bind(this);
        this.onClickFunc = this.onClickFunc.bind(this);
    }
    closeChecklist() {
        this.setState({
            display: false
        });
    }
    checkPairCharacteristics(type) {
        let path = "pairs/" + type;
        let ref = this.getRef(path);
        ref.once("value").then((list)=>{
            let pairedItems = list.val();
            let haveContent = pairedItems != null ? true : false;
            if ("likecharacteristics" === type) this.setState({
                hasSimilarCharacteristics: haveContent
            });
            if ("unlikecharacteristics" === type) this.setState({
                hasDifferentCharacteristics: haveContent
            });
        });
    }
    getComparisonMapsPromise() {
        let proms = [
            this.getFirepadMapPromise('terms', 'def'),
            this.getFirepadMapPromise('terms', 'term'),
            this.getFirepadMapPromise('characteristics1', 'text'),
            this.getFirepadMapPromise('characteristics2', 'text')
        ];
        return Promise.all(proms).then((maps)=>{
            return {
                'termsdef': maps[0],
                'termsword': maps[1],
                'characteristics1': maps[2],
                'characteristics2': maps[3]
            };
        });
    }
    checkEmptyList() {
        this.getComparisonMapsPromise().then((valueMaps)=>{
            if (valueMaps != null) {
                var hasTermOrDef = this.mapHasContent(valueMaps['termsword']) || this.mapHasContent(valueMaps['termsdef']);
                let update = {
                    hasKeyTerms: hasTermOrDef,
                    hasCharacteristics1: this.mapHasContent(valueMaps['characteristics1']),
                    hasCharacteristics2: this.mapHasContent(valueMaps['characteristics2'])
                };
                this.setState(update);
                this.updateChecklist();
            }
        });
    }
    updateChecklist() {
        let showChecklist = false;
        if (!this.state.hasEssentialQuestion) showChecklist = true;
        if (!this.state.hasConcept1) showChecklist = true;
        if (!this.state.hasConcept2) showChecklist = true;
        if (!this.state.hasDescription1) showChecklist = true;
        if (!this.state.hasDescription2) showChecklist = true;
        if (!this.state.hasKeyTerms) showChecklist = true;
        if (!this.state.hasOverall) showChecklist = true;
        if (!this.state.hasCharacteristics1) showChecklist = true;
        if (!this.state.hasCharacteristics2) showChecklist = true;
        if (!this.state.hasSimilarCharacteristics) showChecklist = true;
        if (!this.state.hasDifferentCharacteristics) showChecklist = true;
        if (!this.state.hasSummary) showChecklist = true;
        this.setState({
            display: showChecklist
        });
    }
    checkEmptyField(field) {
        this.getFirepadTextPromise(field).then((data)=>{
            let hasContent = this.hasContent(data);
            if ("essentialquestion" === field) this.setState({
                hasEssentialQuestion: hasContent
            });
            if ("concept1" === field) this.setState({
                hasConcept1: hasContent
            });
            if ("concept2" === field) this.setState({
                hasConcept2: hasContent
            });
            if ("description1" === field) this.setState({
                hasDescription1: hasContent
            });
            if ("description2" === field) this.setState({
                hasDescription2: hasContent
            });
            if ("overall" === field) this.setState({
                hasOverall: hasContent
            });
            if ("summary" === field) this.setState({
                hasSummary: hasContent
            });
            this.updateChecklist();
        });
    }
    componentDidMount() {
        for (let field of [
            'essentialquestion',
            'concept1',
            'concept2',
            'description1',
            'description2',
            'overall',
            'summary',
            'extensions'
        ])this.checkEmptyField(field);
        for (let field of [
            'likecharacteristics',
            'unlikecharacteristics'
        ])this.checkPairCharacteristics(field);
        this.checkEmptyList();
    }
    onClickFunc(step) {
        window.tracker.trackEvent("Navigation", "checklist link", step);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, this.props.inCompleteStep && this.context.canEdit ? $7dcc312e8f17de56$export$1f1d0ed2d2d34eef(this.props.doc, this.state, this.closeChecklist, this.onClickFunc) : null, $7dcc312e8f17de56$export$7b34c17ec45b7fc7(this.props.doc, this.state, this.props.inCompleteStep), $7dcc312e8f17de56$export$eb632fcff23bdc70(this.props.doc, this.state, this.props.inCompleteStep), $7dcc312e8f17de56$export$76951ff45a6df488(this.props.doc, this.state, this.props.inCompleteStep), $7dcc312e8f17de56$export$e50c38059db6188a(this.props.doc, this.props.data, this.state, this.props.inCompleteStep), $7dcc312e8f17de56$export$16021e7ac45ef24f(this.props.doc, this.props.data, this.state, this.props.inCompleteStep), $7dcc312e8f17de56$export$ec010b194f5eafb(this.props.doc, this.props.data, this.state, this.props.inCompleteStep), $7dcc312e8f17de56$export$9a2dbef7a17e2e58(this.props.doc, this.state, this.props.inCompleteStep), $7dcc312e8f17de56$export$cc3e2d3244e01b7f(this.props.doc, this.state, this.props.inCompleteStep));
    }
}



var $6wXVr = parcelRequire("6wXVr");


var $6wXVr = parcelRequire("6wXVr");



var $6wXVr = parcelRequire("6wXVr");








class $ac47d1ce47424d67$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.deleteModalId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.deleteButtonId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.handleDeleteButton = this.handleDeleteButton.bind(this);
    }
    render() {
        const cause = this.props.identifier + "/" + this.props.id + "/text";
        const canEdit = this.context.canEdit;
        const deleteMessage = "Do you really want to delete this cause?";
        const deleteModal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $cc5d5838c074a4ab$export$2e2bcd8739ae039), {
            id: this.deleteModalId,
            method: this.handleDeleteButton,
            text: deleteMessage,
            yes: "Remove"
        });
        const deleteIcon = this.context.canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $c8db36dd985f35f1$export$2e2bcd8739ae039), {
            icon: "fa-times",
            tooltip: "Remove Cause",
            modalId: this.deleteModalId,
            canDelete: this.props.canDelete
        }) : null;
        return this.props.editing && canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-primary"
        }, this.props.canDelete ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box-row-close"
        }, deleteModal, deleteIcon) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "form-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            addImage: true,
            placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(this.props.type + "." + this.props.identifier + ".placeholder"),
            identifier: cause
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: cause,
            className: "grouping-text"
        }), !this.props.noImage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: cause + "/image",
            className: "grouping-img"
        }) : null)));
    }
    handleDeleteButton() {
        this.props.deleteMethod(this.props.id);
    }
}
$ac47d1ce47424d67$export$2e2bcd8739ae039.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    canDelete: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).bool.isRequired,
    deleteMethod: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).func.isRequired
};


class $350b7e542abac766$export$2e2bcd8739ae039 extends (0, $c01ab3c338b52a54$export$2e2bcd8739ae039) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.identifier = "cause";
        this.canBeEmpty = false;
        this.newItem = this.newItem.bind(this);
        this.getCurrentNode = this.getCurrentNode.bind(this);
    }
    render() {
        const editing = undefined !== this.props.editing ? this.props.editing : true;
        const noImage = undefined !== this.props.noImage ? this.props.noImage : false;
        const inRoutine = undefined !== this.props.inRoutine ? this.props.inRoutine : false;
        const itemList = this.getContentList();
        const groupingCount = Object.keys(itemList).length ? Object.keys(itemList).length : 1;
        const disabled = 4 <= Object.keys(itemList).length;
        let addButton = editing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            onClick: this.handleAddItem,
            type: "button",
            className: "btn btn-primary",
            disabled: disabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-plus me-0_25",
            "aria-hidden": "true"
        }), "Add Cause") : null;
        if (!this.context.canEdit) addButton = null;
        let itemsHTML = [];
        let i = 1;
        const last = Object.keys(itemList).length;
        if (itemList) {
            for(const key in itemList)if (itemList.hasOwnProperty(key)) {
                itemsHTML.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $ac47d1ce47424d67$export$2e2bcd8739ae039), {
                    key: key,
                    id: key,
                    type: this.context.fileType,
                    identifier: this.identifier,
                    parentNode: this.getCurrentNode(),
                    deleteMethod: this.handleDeleteItem,
                    canDelete: editing && this.state.canDelete,
                    editing: editing,
                    noImage: noImage,
                    inRoutine: inRoutine
                }));
                if (this.props.editing && i < last) itemsHTML.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                    key: i,
                    className: "bracket bracket-short"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                    className: "bracket-bar-vertical"
                })));
                i = i + 1;
            }
        }
        const bracket = ()=>{
            if (this.props.editing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                className: "bracket bracket-tall"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                className: "bracket-action"
            }, addButton), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                className: "bracket-arrow-vertical"
            }));
            switch(groupingCount){
                case 4:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket bracket-4"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-arrow-vertical"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-start"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-bar"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-bar-start"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-bar"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-arrow"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-bar"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-bar-end"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-bar"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-end"
                    }));
                case 3:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket bracket-3"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-arrow-vertical"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-start"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-bar"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-bar-start"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-bar"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-arrow"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-bar"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-end"
                    }));
                case 2:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket bracket-2"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-arrow-vertical"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-start"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-bar"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-arrow"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-bar"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-end"
                    }));
                case 1:
                default:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-arrow-vertical"
                    }));
            }
        };
        return this.props.editing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, itemsHTML, bracket(), this.props.children) : this.props.inSteps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, itemsHTML, this.props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping grouping-" + groupingCount
        }, itemsHTML), bracket(), this.props.children);
    }
    getCurrentNode() {
        return this.context.fileType + "/" + this.context.fileId + "/" + this.identifier;
    }
    newItem() {
        window.firebase.database().ref(this.getCurrentNode()).push().set({
            text: "",
            status: ""
        });
    }
    getValuePath(key) {
        let path = this.context.fileType + "/" + this.context.fileId + "/" + this.identifier + "/" + key + "/text";
        return path;
    }
    getImagePath(key) {
        let path = this.context.fileType + "/" + this.context.fileId + "/" + this.identifier + "/" + key + "/text/image";
        return path;
    }
}



var $6wXVr = parcelRequire("6wXVr");









class $fe63405f1ce595c9$export$2e2bcd8739ae039 extends (0, $c01ab3c338b52a54$export$2e2bcd8739ae039) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.identifier = "effect";
        this.canBeEmpty = false;
        this.newItem = this.newItem.bind(this);
        this.getCurrentNode = this.getCurrentNode.bind(this);
    }
    render() {
        const editing = undefined !== this.props.editing ? this.props.editing : true;
        const inRoutine = undefined !== this.props.inRoutine ? this.props.inRoutine : false;
        const itemList = this.getContentList();
        const groupingCount = Object.keys(itemList).length ? Object.keys(itemList).length : 1;
        let itemsHTML = [];
        let i = 1;
        const last = Object.keys(itemList).length;
        if (itemList) {
            for(let key in itemList)if (itemList.hasOwnProperty(key)) {
                itemsHTML.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($fe63405f1ce595c9$var$EffectItem, {
                    key: key,
                    id: key,
                    type: this.context.fileType,
                    identifier: this.identifier,
                    parentNode: this.getCurrentNode(),
                    deleteMethod: this.handleDeleteItem,
                    canDelete: editing && this.state.canDelete,
                    editing: editing,
                    noImage: this.props.noImage,
                    inRoutine: inRoutine,
                    canEdit: this.context.canEdit
                }));
                if (editing && i < last) itemsHTML.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                    key: i,
                    className: "bracket bracket-short"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                    className: "bracket-bar-vertical"
                })));
                i = i + 1;
            }
        }
        const disabled = 4 <= Object.keys(itemList).length;
        let addButton = editing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            onClick: this.handleAddItem,
            type: "button",
            className: "btn btn-primary mb-1",
            disabled: disabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-plus me-0_25",
            "aria-hidden": "true"
        }), "Add Effect") : null;
        if (!this.context.canEdit) addButton = null;
        const bracket = ()=>{
            if (this.props.editing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                className: "bracket bracket-short"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                className: "bracket-arrow-vertical"
            }));
            switch(groupingCount){
                case 4:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket bracket-down bracket-4"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-arrow-vertical"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-start"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-bar"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-bar-start"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-bar"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-arrow"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-bar"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-bar-end"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-bar"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-end"
                    }));
                case 3:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket bracket-down bracket-3"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-arrow-vertical"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-start"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-bar"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-bar-start"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-bar"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-arrow"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-bar"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-end"
                    }));
                case 2:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket bracket-down bracket-2"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-arrow-vertical"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-start"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-bar"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-arrow"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-bar"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-end"
                    }));
                case 1:
                default:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket bracket-down"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "bracket-arrow-vertical"
                    }));
            }
        };
        return this.props.editing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, this.props.children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            className: "grouping-title mt-n1_5 pt-0_25"
        }, "Effects of the Main event"), itemsHTML, addButton) : this.props.inSteps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, this.props.children, this.props.children ? bracket() : null, itemsHTML) : this.props.printing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, this.props.children, bracket(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping grouping-end grouping-" + groupingCount
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "h2 grouping-title"
        }, "Effects and Connections of the Main Event or Idea"), itemsHTML)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, this.props.children, this.props.children ? bracket() : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping grouping-end grouping-" + groupingCount
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            className: "grouping-title"
        }, "Effects of the Main event"), itemsHTML), addButton);
    }
    getCurrentNode() {
        return this.context.fileType + "/" + this.context.fileId + "/" + this.identifier;
    }
    newItem() {
        window.firebase.database().ref(this.getCurrentNode()).push().set({
            text: "",
            status: ""
        });
    }
    getValuePath(key) {
        let path = this.context.fileType + "/" + this.context.fileId + "/" + this.identifier + "/" + key + "/text";
        return path;
    }
    getImagePath(key) {
        let path = this.context.fileType + "/" + this.context.fileId + "/" + this.identifier + "/" + key + "/text/image";
        return path;
    }
}
/**
 *  Component for single Effect item
 */ class $fe63405f1ce595c9$var$EffectItem extends (0, $6wXVr.Component) {
    constructor(props){
        super(props);
        this.deleteModalId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.deleteButtonId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.handleDeleteButton = this.handleDeleteButton.bind(this);
    }
    render() {
        const effect = this.props.identifier + "/" + this.props.id + "/text";
        const deleteMessage = "Do you really want to delete this effect?";
        const deleteModal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $cc5d5838c074a4ab$export$2e2bcd8739ae039), {
            id: this.deleteModalId,
            method: this.handleDeleteButton,
            text: deleteMessage,
            yes: "Remove"
        });
        const deleteIcon = this.props.canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $c8db36dd985f35f1$export$2e2bcd8739ae039), {
            icon: "fa-times",
            tooltip: "Remove Effect",
            modalId: this.deleteModalId,
            canDelete: this.props.canDelete
        }) : null;
        return this.props.editing && this.props.canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-primary"
        }, this.props.canDelete ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box-row-close"
        }, deleteModal, deleteIcon) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "form-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            addImage: true,
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(this.props.type + ".effect.label"),
            placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(this.props.type + "." + this.props.identifier + ".placeholder"),
            identifier: effect
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: effect,
            className: 'grouping-text'
        }), this.props.noImage ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: effect + "/image",
            className: 'grouping-img'
        }))));
    }
    handleDeleteButton() {
        this.props.deleteMethod(this.props.id);
    }
}
$fe63405f1ce595c9$var$EffectItem.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    canDelete: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).bool.isRequired,
    deleteMethod: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).func.isRequired,
    parentNode: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired
};






var $6wXVr = parcelRequire("6wXVr");



class $a79b556df0a54813$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.identifier = "event";
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, this.props.editing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b5ffa3f136ed406e$export$2e2bcd8739ae039), {
            section: this.props.section,
            editing: true,
            tooltipTitle: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Essential Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "question",
            className: "box bg-autofill"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Main event"), this.context.canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            ...this.props,
            identifier: this.identifier,
            addImage: true,
            inputType: "text-area",
            singleLine: false
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.identifier,
            className: "grouping-text"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.identifier + "/image",
            className: "grouping-img"
        }))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.identifier,
            className: "grouping-text"
        }), !this.props.noImage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.identifier + "/image",
            className: "grouping-img"
        }) : null))));
    }
}



var $6wXVr = parcelRequire("6wXVr");

class $c0e31515b414b5e0$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.getRef = this.getRef.bind(this);
        this.dbRef = null;
        this.state = {
            text: null
        };
    }
    render() {
        // CORGI-481 Review step
        let cn = this.props.className;
        let txt = this.state.text;
        /*
        let id = this.props.identifier.split('/')[0];
        if (empty(txt)) {
            cn = cn.replace("autofill","unfilled");
            txt = <GetText type={this.context.fileType} identifier={id} item={"empty"} />;
        }
         */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: cn
        }, txt, this.props.children);
    }
    componentDidMount() {
        this.dbRef = this.getRef(this.props.identifier);
        this.watcher = this.dbRef.on("value", (data)=>{
            if (this.state.text !== data.val()) this.setState({
                text: data.val()
            });
        });
    }
    componentWillUnmount() {
        this.dbRef.off('value', this.watcher);
    }
    getRef(identifier) {
        let path = this.context.fileType + "/" + this.context.fileId + "/" + identifier;
        return window.firebase.database().ref(path);
    }
}







const $f3232c19cf166e20$export$db9f06b5d27d15d8 = (doc, fieldStatus, inCompleteStep)=>{
    const routineText = (0, $198066ba87364cec$export$2e2bcd8739ae039)[doc.type];
    const noImage = [
        'print'
    ].includes(doc.section);
    const section = routineText.question;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Topic"), !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "topic",
        className: "box box-autofill"
    }) : fieldStatus.hasTopic ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "topic",
        className: "box box-autofill"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "topic",
        className: "box box-unfilled"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, section.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "grouping grouping-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "grouping-item"
    }, !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box box-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "question",
        className: 'grouping-text'
    }), noImage ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "question/image",
        className: 'grouping-img'
    }))) : fieldStatus.hasEssentialQuestion ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box box-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "question",
        className: 'grouping-text'
    }), noImage ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "question/image",
        className: 'grouping-img'
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "question",
        className: "box bg-unfilled"
    })))));
};
const $f3232c19cf166e20$export$9a1a1b426ea23eb9 = (doc, fieldStatus, inCompleteStep)=>{
    const routineText = (0, $198066ba87364cec$export$2e2bcd8739ae039)[doc.type];
    const noImage = [
        'print'
    ].includes(doc.section);
    const noStepNum = [
        'complete',
        'print'
    ].includes(doc.section);
    const section = noStepNum ? routineText.cause : routineText.sections[4];
    const causeGrouping = fieldStatus.hasCauses ? fieldStatus.numberCauses : 1;
    const effectGrouping = fieldStatus.hasEffects ? fieldStatus.numberEffects : 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Causes, Main Event, & Effects"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "grouping grouping-" + causeGrouping
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "grouping-title"
    }, "Causes of the Main Event"), !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $350b7e542abac766$export$2e2bcd8739ae039), {
        doc: doc,
        section: section,
        editing: false,
        noImage: noImage,
        inSteps: true
    }) : fieldStatus.hasCauses ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $350b7e542abac766$export$2e2bcd8739ae039), {
        doc: doc,
        section: section,
        editing: false,
        noImage: noImage,
        inSteps: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "grouping-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "cause",
        className: "box box-unfilled"
    }))), !fieldStatus.hasCauses ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-arrow-vertical"
    })) : null, fieldStatus.hasCauses && fieldStatus.numberCauses === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-arrow-vertical"
    })) : null, fieldStatus.hasCauses && fieldStatus.numberCauses === 2 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket bracket-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-arrow-vertical"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-bar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-arrow"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-bar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-end"
    })) : null, fieldStatus.hasCauses && fieldStatus.numberCauses === 3 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket bracket-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-arrow-vertical"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-bar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-bar-start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-bar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-arrow"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-bar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-end"
    })) : null, fieldStatus.hasCauses && fieldStatus.numberCauses === 4 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket bracket-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-arrow-vertical"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-bar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-bar-start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-bar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-arrow"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-bar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-bar-end"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-bar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-end"
    })) : null, !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $c0e31515b414b5e0$export$2e2bcd8739ae039), {
        identifier: "causes-event/connector",
        className: "box connector box-autofill"
    }) : fieldStatus.hasCauseEventConnector ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $c0e31515b414b5e0$export$2e2bcd8739ae039), {
        identifier: "causes-event/connector",
        className: "box connector box-autofill"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "causes-event",
        className: "box connector box-unfilled"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-arrow-vertical"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "grouping grouping-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "grouping-title"
    }, "The Main Event"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "grouping-item"
    }, !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a79b556df0a54813$export$2e2bcd8739ae039), {
        doc: doc,
        section: routineText.event,
        editing: false,
        noImage: noImage
    }) : fieldStatus.hasEvent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a79b556df0a54813$export$2e2bcd8739ae039), {
        doc: doc,
        section: routineText.event,
        editing: false,
        noImage: noImage
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "event",
        className: "box box-unfilled"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-arrow-vertical"
    })), !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $c0e31515b414b5e0$export$2e2bcd8739ae039), {
        identifier: "event-effects/connector",
        className: "box connector box-autofill"
    }) : fieldStatus.hasEffectEventConnector ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $c0e31515b414b5e0$export$2e2bcd8739ae039), {
        identifier: "event-effects/connector",
        className: "box connector box-autofill"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "event-effects",
        className: "box connector box-unfilled"
    }), !fieldStatus.hasEffects ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-arrow-vertical"
    })) : null, fieldStatus.hasEffects && fieldStatus.numberEffects === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-arrow-vertical"
    })) : null, fieldStatus.hasEffects && fieldStatus.numberEffects === 2 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket bracket-down bracket-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-arrow-vertical"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-bar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-arrow"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-bar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-end"
    })) : null, fieldStatus.hasEffects && fieldStatus.numberEffects === 3 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket bracket-down bracket-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-arrow-vertical"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-bar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-bar-start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-bar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-arrow"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-bar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-end"
    })) : null, fieldStatus.hasEffects && fieldStatus.numberEffects === 4 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket bracket-down bracket-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-arrow-vertical"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-bar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-bar-start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-bar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-arrow"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-bar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-bar-end"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-bar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-end"
    })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "grouping grouping-" + effectGrouping
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "grouping-title"
    }, "Effects of the Main Event"), !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fe63405f1ce595c9$export$2e2bcd8739ae039), {
        doc: doc,
        section: routineText.effect,
        editing: false,
        noImage: noImage,
        inSteps: true
    }) : fieldStatus.hasEffects ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fe63405f1ce595c9$export$2e2bcd8739ae039), {
        doc: doc,
        section: routineText.effect,
        editing: false,
        noImage: noImage,
        inSteps: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "grouping-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "effect",
        className: "box box-unfilled"
    }))));
};
const $f3232c19cf166e20$export$50a780d71cf22a88 = (doc, fieldStatus, inCompleteStep)=>{
    const routineText = (0, $198066ba87364cec$export$2e2bcd8739ae039)[doc.type];
    const noStepNum = [
        'complete',
        'print'
    ].includes(doc.section);
    const section = noStepNum ? routineText.answer : routineText.sections[7];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
        className: "h2"
    }, "Summary"), !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a1ef86ca5ed11266$export$2e2bcd8739ae039), {
        doc: doc,
        section: section,
        editing: false
    }) : fieldStatus.hasAnswer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a1ef86ca5ed11266$export$2e2bcd8739ae039), {
        doc: doc,
        section: section,
        editing: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "answer",
        className: "box bg-unfilled"
    }));
};
const $f3232c19cf166e20$export$cc3e2d3244e01b7f = (doc)=>{
    const ext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box box-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "extensions",
        className: "grouping-text"
    }), 'print' === doc.section ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "extensions/image",
        className: "grouping-img"
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
        className: "h2"
    }, "Extensions"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, ext));
};
const $f3232c19cf166e20$export$eb632fcff23bdc70 = (doc, fieldStatus, inCompleteStep)=>{
    const section = (0, $198066ba87364cec$export$2e2bcd8739ae039)[doc.type].terms;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, section.title ? section.title : section.label), !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b230fd9af7e1399f$export$2e2bcd8739ae039), {
        doc: doc,
        section: section,
        editing: false,
        secondary: true
    }) : fieldStatus.hasKeyTerms ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b230fd9af7e1399f$export$2e2bcd8739ae039), {
        doc: doc,
        section: section,
        editing: false,
        secondary: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "terms",
        className: "box bg-unfilled"
    }));
};
const $f3232c19cf166e20$export$1f1d0ed2d2d34eef = (doc, fieldStatus, closeChecklist, onClickFunc)=>{
    return fieldStatus.display ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "h3"
    }, "Review Checklist"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box box-unfilled"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box-row-close"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
        type: "button",
        className: "btn btn-icon btn-link",
        "aria-label": "Remove key term",
        title: "Remove Checklist",
        onClick: closeChecklist
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
        className: "fa fa-times text-primary",
        "aria-hidden": "true"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", null, !fieldStatus.hasTopic ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not entered a ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Topic"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "question",
        onClick: ()=>onClickFunc(1)
    }, "Step 1"), " to complete the section.") : null, !fieldStatus.hasEssentialQuestion ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not entered an ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Essential Question"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "question",
        onClick: ()=>onClickFunc(1)
    }, "Step 1"), " to complete the section.") : null, !fieldStatus.hasKeyTerms ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not entered any ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Key Terms"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "terms",
        onClick: ()=>onClickFunc(2)
    }, "Step 2"), " to define Key Terms") : null, !fieldStatus.hasEvent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not entered a ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Main Event"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "event",
        onClick: ()=>onClickFunc(3)
    }, "Step 3"), " to complete the section.") : null, !fieldStatus.hasCauses ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not entered any ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Causes of the Main Event"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "causes",
        onClick: ()=>onClickFunc(4)
    }, "Step 4"), " to complete the section.") : null, !fieldStatus.hasCauseEventConnector ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not entered a ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Relationship"), " between the Cause and the Main Event. Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "causes-event",
        onClick: ()=>onClickFunc(5)
    }, "Step 5"), " to complete the section.") : null, !fieldStatus.hasEffects ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not entered any ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Effects of the Main Event"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "effects",
        onClick: ()=>onClickFunc(6)
    }, "Step 6"), " to complete the section.") : null, !fieldStatus.hasEffectEventConnector ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not entered a ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Relationship"), " between the Main Event and the Effects. Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "event-effects",
        onClick: ()=>onClickFunc(7)
    }, "Step 7"), " to complete the section.") : null, !fieldStatus.hasAnswer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not entered a ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Summary"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "summary",
        onClick: ()=>onClickFunc(8)
    }, "Step 8"), " to complete the section.") : null))) : null;
};
class $f3232c19cf166e20$export$2e2bcd8739ae039 extends (0, $1290cbb92ac2986c$export$2e2bcd8739ae039) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.state = {
            display: false,
            hasTopic: false,
            hasEssentialQuestion: false,
            hasKeyTerms: false,
            hasMainEvent: false,
            hasCauses: false,
            hasCauseEventConnector: false,
            hasEffects: false,
            hasEffectEventConnector: false,
            hasAnswer: false,
            numberCauses: 0,
            numberEffects: 0
        };
        this.closeChecklist = this.closeChecklist.bind(this);
        this.checkEmptyList = this.checkEmptyList.bind(this);
        this.mapHasContent = this.mapHasContent.bind(this);
    }
    closeChecklist() {
        this.setState({
            display: false
        });
    }
    checkEmptyField(field) {
        this.getFirepadTextPromise(field).then((data)=>{
            let hasContent = this.hasContent(data);
            if ("topic" === field) this.setState({
                hasTopic: hasContent
            });
            if ("question" === field) this.setState({
                hasEssentialQuestion: hasContent
            });
            if ("event" === field) this.setState({
                hasEvent: hasContent
            });
            if ("answer" === field) this.setState({
                hasAnswer: hasContent
            });
            this.updateChecklist();
        });
    }
    updateChecklist() {
        let showChecklist = false;
        if (!this.state.hasTopic) showChecklist = true;
        if (!this.state.hasEssentialQuestion) showChecklist = true;
        if (!this.state.hasKeyTerms) showChecklist = true;
        if (!this.state.hasEvent) showChecklist = true;
        if (!this.state.hasCauses) showChecklist = true;
        if (!this.state.hasCauseEventConnector) showChecklist = true;
        if (!this.state.hasEffects) showChecklist = true;
        if (!this.state.hasEffectEventConnector) showChecklist = true;
        if (!this.state.hasAnswer) showChecklist = true;
        this.setState({
            display: showChecklist
        });
    }
    checkEmptyConnector(field) {
        this.getValuePromise(field + "/connector").then((data)=>{
            let hasContent = this.hasContent(data.val());
            if ("causes-event" === field) this.setState({
                hasCauseEventConnector: hasContent
            });
            if ("event-effects" === field) this.setState({
                hasEffectEventConnector: hasContent
            });
            this.updateChecklist();
        });
    }
    getCauseEffectMapsPromise() {
        let proms = [
            this.getFirepadMapPromise('terms', 'def'),
            this.getFirepadMapPromise('terms', 'term'),
            this.getFirepadMapPromise('cause', 'text'),
            this.getFirepadMapPromise('effect', 'text')
        ];
        return Promise.all(proms).then((maps)=>{
            return {
                'termsdef': maps[0],
                'termsword': maps[1],
                'cause': maps[2],
                'effect': maps[3]
            };
        });
    }
    checkEmptyList() {
        this.getCauseEffectMapsPromise().then((valueMaps)=>{
            if (valueMaps != null) {
                var hasTermOrDef = this.mapHasContent(valueMaps['termsword']) || this.mapHasContent(valueMaps['termsdef']);
                let update = {
                    hasKeyTerms: hasTermOrDef,
                    hasCauses: this.mapHasContent(valueMaps['cause']),
                    hasEffects: this.mapHasContent(valueMaps['effect']),
                    numberCauses: valueMaps['cause'].size,
                    numberEffects: valueMaps['effect'].size
                };
                this.setState(update);
                this.updateChecklist();
            }
        });
    }
    componentDidMount() {
        for (let field of [
            'topic',
            'question',
            'event',
            'answer'
        ])this.checkEmptyField(field);
        for (let field of [
            'causes-event',
            'event-effects'
        ])this.checkEmptyConnector(field);
        this.checkEmptyList();
    }
    onClickFunc(step) {
        window.tracker.trackEvent("Navigation", "checklist link", step);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, this.props.inCompleteStep && this.context.canEdit ? $f3232c19cf166e20$export$1f1d0ed2d2d34eef(this.props.doc, this.state, this.closeChecklist, this.onClickFunc) : null, $f3232c19cf166e20$export$db9f06b5d27d15d8(this.props.doc, this.state, this.props.inCompleteStep), $f3232c19cf166e20$export$eb632fcff23bdc70(this.props.doc, this.state, this.props.inCompleteStep), $f3232c19cf166e20$export$9a1a1b426ea23eb9(this.props.doc, this.state, this.props.inCompleteStep), $f3232c19cf166e20$export$50a780d71cf22a88(this.props.doc, this.state, this.props.inCompleteStep), $f3232c19cf166e20$export$cc3e2d3244e01b7f(this.props.doc));
    }
}



var $6wXVr = parcelRequire("6wXVr");



var $6wXVr = parcelRequire("6wXVr");









class $015518484befd1f6$export$2e2bcd8739ae039 extends (0, $c01ab3c338b52a54$export$2e2bcd8739ae039) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.identifier = this.props.identifier;
        this.identifierRef = null;
        this.newItem = this.newItem.bind(this);
        this.getCurrentNode = this.getCurrentNode.bind(this);
    }
    render() {
        const editing = undefined !== this.props.editing ? this.props.editing : true;
        const print = undefined !== this.props.print ? this.props.print : false;
        const haveResponse = undefined !== this.props.haveResponse ? this.props.haveResponse : false;
        const itemList = this.getContentList();
        let itemsHTML = [];
        if (itemList) {
            for(let key in itemList)if (itemList.hasOwnProperty(key)) itemsHTML.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($015518484befd1f6$var$Question, {
                key: key,
                id: key,
                identifier: this.identifier,
                doc: this.props.doc,
                deleteMethod: this.handleDeleteItem,
                canDelete: editing && this.state.canDelete,
                editing: editing,
                print: print,
                haveResponse: haveResponse,
                data: this.props.data
            }));
        }
        let addButton = editing && !haveResponse ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            onClick: this.handleAddItem,
            type: "button",
            className: "btn btn-primary mb-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-plus me-0_25",
            "aria-hidden": "true"
        }), "Add Question") : null;
        if (!this.context.canEdit) addButton = null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, itemsHTML, addButton);
    }
    getCurrentNode() {
        return this.context.fileType + "/" + this.context.fileId + "/" + this.identifier;
    }
    newItem() {
        window.firebase.database().ref(this.getCurrentNode()).push().set({
            question: "",
            answer: ""
        });
    }
    getValuePath(key) {
        let path = this.context.fileType + "/" + this.context.fileId + "/" + this.identifier + "/" + key + "/question";
        return path;
    }
    getImagePath(key) {
        let path = this.context.fileType + "/" + this.context.fileId + "/" + this.identifier + "/" + key + "/question/image";
        return path;
    }
}
class $015518484befd1f6$var$Question extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.id = props.id;
        this.identifier = props.identifier;
        this.deleteButtonId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.deleteModalId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.getBaseNode = this.getBaseNode.bind(this);
        this.handleDeleteButton = this.handleDeleteButton.bind(this);
    }
    getBaseNode() {
        return this.props.doc.type + "/" + this.props.doc.id;
    }
    render() {
        const mquestion = this.identifier + "/" + this.id + "/question";
        const manswer = this.identifier + "/" + this.id + "/answer";
        const deleteMessage = "Do you want to delete question?";
        const deleteModal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $cc5d5838c074a4ab$export$2e2bcd8739ae039), {
            id: this.deleteModalId,
            method: this.handleDeleteButton,
            text: deleteMessage,
            yes: "Remove"
        });
        const deleteIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $c8db36dd985f35f1$export$2e2bcd8739ae039), {
            icon: "fa-times",
            tooltip: "Remove Question",
            modalId: this.deleteModalId,
            canDelete: this.props.canDelete
        });
        return this.props.editing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, !this.props.haveResponse ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, this.context.canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-primary"
        }, this.props.canDelete ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box-row-close"
        }, deleteModal, deleteIcon) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "form-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            ...this.props,
            inputType: "text-area",
            placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(this.props.doc.type + "." + this.identifier + ".placeholder"),
            identifier: mquestion,
            addImage: true,
            singleLine: false
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: mquestion,
            className: "grouping-text"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: mquestion + "/image",
            className: "grouping-img"
        }))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: mquestion,
            className: "box bg-autofill"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, this.context.canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "form-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            ...this.props,
            inputType: "text-area",
            placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(this.props.doc.type + ".relatedquestionresponse.placeholder"),
            identifier: manswer,
            addImage: true,
            singleLine: false
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: manswer,
            className: "grouping-text"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: manswer + "/image",
            className: "grouping-img"
        })))))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: mquestion,
            className: "grouping-text"
        }), !this.props.print ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: mquestion + "/image",
            className: "grouping-img"
        }) : null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: manswer,
            className: "grouping-text"
        }), !this.props.print ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: manswer + "/image",
            className: "grouping-img"
        }) : null)))));
    }
    handleDeleteButton() {
        this.props.deleteMethod(this.id);
    }
}
$015518484befd1f6$var$Question.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    identifier: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    doc: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).object.isRequired,
    canDelete: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).bool.isRequired,
    deleteMethod: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).func.isRequired
};








const $28deb6bab6448c06$export$b957c2b0fcc9ce3c = (doc, fieldStatus, inCompleteStep)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Topic"), !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "topic",
        className: "box bg-autofill"
    }) : fieldStatus.hasTopic ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "topic",
        className: "box bg-autofill"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "topic",
        className: "box bg-unfilled"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate("question-exp.essentialquestion.title")), !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "essentialquestion",
        className: "grouping-text"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "essentialquestion/image",
        className: "grouping-img"
    }))) : fieldStatus.hasEssentialQuestion ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "essentialquestion",
        className: "grouping-text"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "essentialquestion/image",
        className: "grouping-img"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "essentialquestion",
        className: "box bg-unfilled"
    })));
};
const $28deb6bab6448c06$export$eb632fcff23bdc70 = (doc, fieldStatus, inCompleteStep)=>{
    const section = (0, $198066ba87364cec$export$2e2bcd8739ae039)[doc.type].terms;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, section.title ? section.title : section.label), !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b230fd9af7e1399f$export$2e2bcd8739ae039), {
        doc: doc,
        section: section,
        editing: false,
        secondary: true
    }) : fieldStatus.hasKeyTerms ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b230fd9af7e1399f$export$2e2bcd8739ae039), {
        doc: doc,
        section: section,
        editing: false,
        secondary: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "terms",
        className: "box bg-unfilled"
    }));
};
const $28deb6bab6448c06$export$1377f94a785e2021 = (doc, fieldStatus, inCompleteStep)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate("question-exp.relatedquestion.toptitle")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row d-sm-down-none",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "col-md-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).div, {
        text: {
            key: "question-exp.relatedquestion.title"
        },
        className: "h3"
    }), inCompleteStep && !fieldStatus.hasRelatedQuestion && !fieldStatus.hasRelatedQuestionAnswer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "relatedquestion",
        className: "box bg-unfilled"
    }) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "col-md-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).div, {
        text: {
            key: "question-exp.relatedquestionresponse.title"
        },
        className: "h3"
    }), inCompleteStep && !fieldStatus.hasRelatedQuestionAnswer && !fieldStatus.hasRelatedQuestion ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "relatedquestionresponse",
        className: "box bg-unfilled"
    }) : null)), !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $015518484befd1f6$export$2e2bcd8739ae039), {
        doc: doc,
        identifier: "relatedquestion",
        haveResponse: true,
        editing: false,
        canBeEmpty: false
    }) : fieldStatus.hasRelatedQuestion || fieldStatus.hasRelatedQuestionAnswer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $015518484befd1f6$export$2e2bcd8739ae039), {
        doc: doc,
        identifier: "relatedquestion",
        haveResponse: true,
        editing: false,
        canBeEmpty: false
    }) : null);
};
const $28deb6bab6448c06$export$4e0821a92f84a654 = (doc, fieldStatus, inCompleteStep)=>{
    const eqResponse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "essentialquestionresponse",
        className: "grouping-text"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "essentialquestionresponse/image",
        className: "grouping-img"
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate("question-exp.essentialquestionresponse.title")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row gx-0_5 mt-0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "col-sm-12 mt-0"
    }, !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, eqResponse) : fieldStatus.hasEssentialQuestionResponse ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, eqResponse) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "essentialquestionresponse",
        className: "box bg-unfilled"
    }))));
};
const $28deb6bab6448c06$export$4b75041566a1e95a = (doc, fieldStatus, inCompleteStep)=>{
    const contextResponse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "contextresponse",
        className: "grouping-text"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "contextresponse/image",
        className: "grouping-img"
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate("question-exp.contextresponse.title")), !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, contextResponse) : fieldStatus.hasContextResponse ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, contextResponse) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "contextresponse",
        className: "box bg-unfilled"
    }));
};
const $28deb6bab6448c06$export$cc3e2d3244e01b7f = (doc, fieldStatus, inCompleteStep)=>{
    const ext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "extensions",
        className: "grouping-text"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "extensions/image",
        className: "grouping-img"
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate("question-exp.extensions.title")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, ext));
};
const $28deb6bab6448c06$export$1f1d0ed2d2d34eef = (doc, fieldStatus, closeChecklist, onClickFunc)=>{
    return fieldStatus.display ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
        className: "h3"
    }, "Review Checklist"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box box-unfilled"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box-row-close"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
        type: "button",
        className: "btn btn-icon btn-link",
        "aria-label": "Remove key term",
        title: "Remove Checklist",
        onClick: closeChecklist
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
        className: "fa fa-times text-primary",
        "aria-hidden": "true"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", null, !fieldStatus.hasTopic ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not yet entered a ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Topic"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "essentialquestion",
        onClick: ()=>onClickFunc(1)
    }, "Step 1"), " to complete the section.") : null, !fieldStatus.hasEssentialQuestion ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not yet entered an ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Essential Question"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "essentialquestion",
        onClick: ()=>onClickFunc(1)
    }, "Step 1"), " to complete the section.") : null, !fieldStatus.hasKeyTerms ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not entered any ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Key Terms"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "terms",
        onClick: ()=>onClickFunc(2)
    }, "Step 2"), " to define Key Terms") : null, !fieldStatus.hasRelatedQuestion ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not entered any ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Supporting Questions"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "relatedquestion",
        onClick: ()=>onClickFunc(3)
    }, "Step 3"), " to complete the section.") : null, !fieldStatus.hasRelatedQuestionAnswer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not entered any ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Supporting Question Responses"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "relatedquestionresponse",
        onClick: ()=>onClickFunc(4)
    }, "Step 4"), " to complete the section.") : null, !fieldStatus.hasEssentialQuestionResponse ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not entered an ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Essential Question Response"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "essentialquestionresponse",
        onClick: ()=>onClickFunc(5)
    }, "Step 5"), " to complete the section.") : null, !fieldStatus.hasContextResponse ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not entered an ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Real-world Context"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "contextresponse",
        onClick: ()=>onClickFunc(6)
    }, "Step 6"), " to complete the section.") : null))) : null;
};
class $28deb6bab6448c06$export$2e2bcd8739ae039 extends (0, $1290cbb92ac2986c$export$2e2bcd8739ae039) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.state = {
            display: false,
            hasTopic: false,
            hasEssentialQuestion: false,
            hasKeyTerms: false,
            hasEssentialQuestionResponse: false,
            hasContextResponse: false,
            hasRelatedQuestion: false,
            hasRelatedQuestionAnswer: false
        };
        this.closeChecklist = this.closeChecklist.bind(this);
        this.checkEmptyList = this.checkEmptyList.bind(this);
        this.mapHasContent = this.mapHasContent.bind(this);
    }
    closeChecklist() {
        this.setState({
            display: false
        });
    }
    checkEmptyField(field) {
        this.getFirepadTextPromise(field).then((data)=>{
            let hasContent = this.hasContent(data);
            if ("topic" === field) this.setState({
                hasTopic: hasContent
            });
            if ("essentialquestion" === field) this.setState({
                hasEssentialQuestion: hasContent
            });
            if ("essentialquestionresponse" === field) this.setState({
                hasEssentialQuestionResponse: hasContent
            });
            if ("contextresponse" === field) this.setState({
                hasContextResponse: hasContent
            });
            this.updateChecklist();
        });
    }
    updateChecklist() {
        let showChecklist = false;
        if (!this.state.hasTopic) showChecklist = true;
        if (!this.state.hasEssentialQuestion) showChecklist = true;
        if (!this.state.hasKeyTerms) showChecklist = true;
        if (!this.state.hasEssentialQuestionResponse) showChecklist = true;
        if (!this.state.hasContextResponse) showChecklist = true;
        if (!this.state.hasRelatedQuestion) showChecklist = true;
        if (!this.state.hasRelatedQuestionAnswer) showChecklist = true;
        this.setState({
            display: showChecklist
        });
    }
    componentDidMount() {
        for (let field of [
            'topic',
            'essentialquestion',
            'essentialquestionresponse',
            'contextresponse',
            'extensions'
        ])this.checkEmptyField(field);
        this.checkEmptyList();
    }
    getQuestionExpMapsPromise() {
        let proms = [
            this.getFirepadMapPromise('terms', 'def'),
            this.getFirepadMapPromise('terms', 'term'),
            this.getFirepadMapPromise('relatedquestion', 'question'),
            this.getFirepadMapPromise('relatedquestion', 'answer')
        ];
        return Promise.all(proms).then((maps)=>{
            return {
                'termsdef': maps[0],
                'termsword': maps[1],
                'relatedQuesion': maps[2],
                'relatedQuesionAnswer': maps[3]
            };
        });
    }
    checkEmptyList() {
        this.getQuestionExpMapsPromise().then((valueMaps)=>{
            if (valueMaps != null) {
                console.log(valueMaps);
                var hasTermOrDef = this.mapHasContent(valueMaps['termsword']) || this.mapHasContent(valueMaps['termsdef']);
                let update = {
                    hasKeyTerms: hasTermOrDef,
                    hasRelatedQuestion: this.mapHasContent(valueMaps['relatedQuesion']),
                    hasRelatedQuestionAnswer: this.mapHasContent(valueMaps['relatedQuesionAnswer'])
                };
                this.setState(update);
                this.updateChecklist();
            }
        });
    }
    onClickFunc(step) {
        window.tracker.trackEvent("Navigation", "checklist link", step);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, this.props.inCompleteStep && this.context.canEdit ? $28deb6bab6448c06$export$1f1d0ed2d2d34eef(this.props.doc, this.state, this.closeChecklist, this.onClickFunc) : null, $28deb6bab6448c06$export$b957c2b0fcc9ce3c(this.props.doc, this.state, this.props.inCompleteStep), $28deb6bab6448c06$export$eb632fcff23bdc70(this.props.doc, this.state, this.props.inCompleteStep), $28deb6bab6448c06$export$1377f94a785e2021(this.props.doc, this.state, this.props.inCompleteStep), $28deb6bab6448c06$export$4e0821a92f84a654(this.props.doc, this.state, this.props.inCompleteStep), $28deb6bab6448c06$export$4b75041566a1e95a(this.props.doc, this.state, this.props.inCompleteStep), $28deb6bab6448c06$export$cc3e2d3244e01b7f(this.props.doc, this.state, this.props.inCompleteStep));
    }
}



var $6wXVr = parcelRequire("6wXVr");








var $6wXVr = parcelRequire("6wXVr");










var $6wXVr = parcelRequire("6wXVr");


var $6wXVr = parcelRequire("6wXVr");






class $92db7a2df6c79520$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.domId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        // CSS class that will be set for the component's label
        this.labelClassName = "sr-only";
        // CSS class for the component's form group
        this.formClassName = "form-group";
        //this.onChangeHandle = this.onChangeHandle.bind(this);
        this.renderHeader = this.renderHeader.bind(this);
        this.firepad = null;
        this.codeMirror = null;
        this.id = "";
    }
    render() {
        const label = (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(this.context.fileType + '.' + this.id + '.label');
        this.id = undefined !== this.identifier ? this.identifier : this.props.identifier;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", null, this.renderHeader(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: this.formClassName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("label", {
            htmlFor: this.domId,
            className: this.labelClassName
        }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "stt-wrapper"
        }, this.renderInput(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "stt-btn",
            "data-cast": "stt",
            "data-target": "#resq"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-microphone",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Use Speech to Text")))));
    }
    componentDidMount() {
        const placeholder = (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(this.context.fileType + '.' + this.id + '.placeholder');
        let firepadRef = window.firebase.database().ref(this.getCurrentNode());
        this.codeMirror = window.CodeMirror(document.getElementById(this.domId), (0, $6a59b1cc78a70843$export$36a6d360a8c4e160)(!this.context.canEdit, placeholder));
        this.firepad = window.Firepad.fromCodeMirror(firepadRef, this.codeMirror, {
            richTextShortcuts: false,
            richTextToolbar: false
        });
    }
    renderHeader() {
        const type = this.context.fileType ? this.context.fileType : this.props.docType;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $176e033a80de7861$export$2e2bcd8739ae039), {
            stepnum: this.props.stepnum,
            type: type,
            identifier: this.id
        });
    }
    renderInput() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: this.domId,
            className: "text-area firepad-form form-control form-control-lg"
        });
    }
}
$92db7a2df6c79520$export$2e2bcd8739ae039.propTypes = {
    stepnum: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    //    identifier: PropTypes.string.isRequired,
    focused: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).bool,
    labelClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string
};


var $de94eb3bd11c0cfb$exports = {};
'use strict';
var $de94eb3bd11c0cfb$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $de94eb3bd11c0cfb$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $de94eb3bd11c0cfb$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $de94eb3bd11c0cfb$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $de94eb3bd11c0cfb$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $6wXVr = parcelRequire("6wXVr");


var $de94eb3bd11c0cfb$var$findDOMNode = $39d800d77e473b3f$exports.findDOMNode;
var $ee1a51e4530f19b1$exports = {};

$ee1a51e4530f19b1$exports = (parcelRequire("iKZi9"));


var $de94eb3bd11c0cfb$var$IMPERATIVE_API = [
    'blur',
    'checkValidity',
    'click',
    'focus',
    'select',
    'setCustomValidity',
    'setSelectionRange',
    'setRangeText'
];
function $de94eb3bd11c0cfb$var$getScrollOffset() {
    return {
        x: window.pageXOffset !== undefined ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft,
        y: window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop
    };
}
var $de94eb3bd11c0cfb$var$Autocomplete = function(_React$Component) {
    $de94eb3bd11c0cfb$var$_inherits(Autocomplete, _React$Component);
    function Autocomplete(props) {
        $de94eb3bd11c0cfb$var$_classCallCheck(this, Autocomplete);
        var _this = $de94eb3bd11c0cfb$var$_possibleConstructorReturn(this, (Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete)).call(this, props));
        _this.state = {
            isOpen: false,
            highlightedIndex: null
        };
        _this._debugStates = [];
        _this.ensureHighlightedIndex = _this.ensureHighlightedIndex.bind(_this);
        _this.exposeAPI = _this.exposeAPI.bind(_this);
        _this.handleInputFocus = _this.handleInputFocus.bind(_this);
        _this.handleInputBlur = _this.handleInputBlur.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        _this.handleInputClick = _this.handleInputClick.bind(_this);
        _this.maybeAutoCompleteText = _this.maybeAutoCompleteText.bind(_this);
        return _this;
    }
    $de94eb3bd11c0cfb$var$_createClass(Autocomplete, [
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                // this.refs is frozen, so we need to assign a new object to it
                this.refs = {};
                this._ignoreBlur = false;
                this._ignoreFocus = false;
                this._scrollOffset = null;
                this._scrollTimer = null;
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                clearTimeout(this._scrollTimer);
                this._scrollTimer = null;
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if (this.state.highlightedIndex !== null) this.setState(this.ensureHighlightedIndex);
                if (nextProps.autoHighlight && (this.props.value !== nextProps.value || this.state.highlightedIndex === null)) this.setState(this.maybeAutoCompleteText);
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (this.isOpen()) this.setMenuPositions();
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.state.isOpen && !prevState.isOpen || 'open' in this.props && this.props.open && !prevProps.open) this.setMenuPositions();
                this.maybeScrollItemIntoView();
                if (prevState.isOpen !== this.state.isOpen) this.props.onMenuVisibilityChange(this.state.isOpen);
            }
        },
        {
            key: 'exposeAPI',
            value: function exposeAPI(el) {
                var _this2 = this;
                this.refs.input = el;
                $de94eb3bd11c0cfb$var$IMPERATIVE_API.forEach(function(ev) {
                    return _this2[ev] = el && el[ev] && el[ev].bind(el);
                });
            }
        },
        {
            key: 'maybeScrollItemIntoView',
            value: function maybeScrollItemIntoView() {
                if (this.isOpen() && this.state.highlightedIndex !== null) {
                    var itemNode = this.refs['item-' + this.state.highlightedIndex];
                    var menuNode = this.refs.menu;
                    $ee1a51e4530f19b1$exports($de94eb3bd11c0cfb$var$findDOMNode(itemNode), $de94eb3bd11c0cfb$var$findDOMNode(menuNode), {
                        onlyScrollIfNeeded: true
                    });
                }
            }
        },
        {
            key: 'handleKeyDown',
            value: function handleKeyDown(event) {
                if (Autocomplete.keyDownHandlers[event.key]) Autocomplete.keyDownHandlers[event.key].call(this, event);
                else if (!this.isOpen()) this.setState({
                    isOpen: true
                });
            }
        },
        {
            key: 'handleChange',
            value: function handleChange(event) {
                this.props.onChange(event, event.target.value);
            }
        },
        {
            key: 'getFilteredItems',
            value: function getFilteredItems(props) {
                var items = props.items;
                if (props.shouldItemRender) items = items.filter(function(item) {
                    return props.shouldItemRender(item, props.value);
                });
                if (props.sortItems) items.sort(function(a, b) {
                    return props.sortItems(a, b, props.value);
                });
                return items;
            }
        },
        {
            key: 'maybeAutoCompleteText',
            value: function maybeAutoCompleteText(state, props) {
                var highlightedIndex = state.highlightedIndex;
                var value = props.value, getItemValue = props.getItemValue;
                var index = highlightedIndex === null ? 0 : highlightedIndex;
                var items = this.getFilteredItems(props);
                for(var i = 0; i < items.length; i++){
                    if (props.isItemSelectable(items[index])) break;
                    index = (index + 1) % items.length;
                }
                var matchedItem = items[index] && props.isItemSelectable(items[index]) ? items[index] : null;
                if (value !== '' && matchedItem) {
                    var itemValue = getItemValue(matchedItem);
                    var itemValueDoesMatch = itemValue.toLowerCase().indexOf(value.toLowerCase()) === 0;
                    if (itemValueDoesMatch) return {
                        highlightedIndex: index
                    };
                }
                return {
                    highlightedIndex: null
                };
            }
        },
        {
            key: 'ensureHighlightedIndex',
            value: function ensureHighlightedIndex(state, props) {
                if (state.highlightedIndex >= this.getFilteredItems(props).length) return {
                    highlightedIndex: null
                };
            }
        },
        {
            key: 'setMenuPositions',
            value: function setMenuPositions() {
                var node = this.refs.input;
                var rect = node.getBoundingClientRect();
                var computedStyle = $parcel$global.window.getComputedStyle(node);
                var marginBottom = parseInt(computedStyle.marginBottom, 10) || 0;
                var marginLeft = parseInt(computedStyle.marginLeft, 10) || 0;
                var marginRight = parseInt(computedStyle.marginRight, 10) || 0;
                this.setState({
                    menuTop: rect.bottom + marginBottom,
                    menuLeft: rect.left + marginLeft,
                    menuWidth: rect.width + marginLeft + marginRight
                });
            }
        },
        {
            key: 'highlightItemFromMouse',
            value: function highlightItemFromMouse(index) {
                this.setState({
                    highlightedIndex: index
                });
            }
        },
        {
            key: 'selectItemFromMouse',
            value: function selectItemFromMouse(item) {
                var _this3 = this;
                var value = this.props.getItemValue(item);
                // The menu will de-render before a mouseLeave event
                // happens. Clear the flag to release control over focus
                this.setIgnoreBlur(false);
                this.setState({
                    isOpen: false,
                    highlightedIndex: null
                }, function() {
                    _this3.props.onSelect(value, item);
                });
            }
        },
        {
            key: 'setIgnoreBlur',
            value: function setIgnoreBlur(ignore) {
                this._ignoreBlur = ignore;
            }
        },
        {
            key: 'renderMenu',
            value: function renderMenu() {
                var _this4 = this;
                var items = this.getFilteredItems(this.props).map(function(item, index) {
                    var element = _this4.props.renderItem(item, _this4.state.highlightedIndex === index, {
                        cursor: 'default'
                    });
                    return $6wXVr.cloneElement(element, {
                        onMouseEnter: _this4.props.isItemSelectable(item) ? function() {
                            return _this4.highlightItemFromMouse(index);
                        } : null,
                        onClick: _this4.props.isItemSelectable(item) ? function() {
                            return _this4.selectItemFromMouse(item);
                        } : null,
                        ref: function ref(e) {
                            return _this4.refs['item-' + index] = e;
                        }
                    });
                });
                var style = {
                    left: this.state.menuLeft,
                    top: this.state.menuTop,
                    minWidth: this.state.menuWidth
                };
                var menu = this.props.renderMenu(items, this.props.value, style);
                return $6wXVr.cloneElement(menu, {
                    ref: function ref(e) {
                        return _this4.refs.menu = e;
                    },
                    // Ignore blur to prevent menu from de-rendering before we can process click
                    onTouchStart: function onTouchStart() {
                        return _this4.setIgnoreBlur(true);
                    },
                    onMouseEnter: function onMouseEnter() {
                        return _this4.setIgnoreBlur(true);
                    },
                    onMouseLeave: function onMouseLeave() {
                        return _this4.setIgnoreBlur(false);
                    }
                });
            }
        },
        {
            key: 'handleInputBlur',
            value: function handleInputBlur(event) {
                var _this5 = this;
                if (this._ignoreBlur) {
                    this._ignoreFocus = true;
                    this._scrollOffset = $de94eb3bd11c0cfb$var$getScrollOffset();
                    this.refs.input.focus();
                    return;
                }
                var setStateCallback = void 0;
                var highlightedIndex = this.state.highlightedIndex;
                if (this.props.selectOnBlur && highlightedIndex !== null) {
                    var items = this.getFilteredItems(this.props);
                    var item = items[highlightedIndex];
                    var value = this.props.getItemValue(item);
                    setStateCallback = function setStateCallback() {
                        return _this5.props.onSelect(value, item);
                    };
                }
                this.setState({
                    isOpen: false,
                    highlightedIndex: null
                }, setStateCallback);
                var onBlur = this.props.inputProps.onBlur;
                if (onBlur) onBlur(event);
            }
        },
        {
            key: 'handleInputFocus',
            value: function handleInputFocus(event) {
                var _this6 = this;
                if (this._ignoreFocus) {
                    this._ignoreFocus = false;
                    var _scrollOffset = this._scrollOffset, x = _scrollOffset.x, y = _scrollOffset.y;
                    this._scrollOffset = null;
                    // Focus will cause the browser to scroll the <input> into view.
                    // This can cause the mouse coords to change, which in turn
                    // could cause a new highlight to happen, cancelling the click
                    // event (when selecting with the mouse)
                    window.scrollTo(x, y);
                    // Some browsers wait until all focus event handlers have been
                    // processed before scrolling the <input> into view, so let's
                    // scroll again on the next tick to ensure we're back to where
                    // the user was before focus was lost. We could do the deferred
                    // scroll only, but that causes a jarring split second jump in
                    // some browsers that scroll before the focus event handlers
                    // are triggered.
                    clearTimeout(this._scrollTimer);
                    this._scrollTimer = setTimeout(function() {
                        _this6._scrollTimer = null;
                        window.scrollTo(x, y);
                    }, 0);
                    return;
                }
                this.setState({
                    isOpen: true
                });
                var onFocus = this.props.inputProps.onFocus;
                if (onFocus) onFocus(event);
            }
        },
        {
            key: 'isInputFocused',
            value: function isInputFocused() {
                var el = this.refs.input;
                return el.ownerDocument && el === el.ownerDocument.activeElement;
            }
        },
        {
            key: 'handleInputClick',
            value: function handleInputClick() {
                // Input will not be focused if it's disabled
                if (this.isInputFocused() && !this.isOpen()) this.setState({
                    isOpen: true
                });
            }
        },
        {
            key: 'composeEventHandlers',
            value: function composeEventHandlers(internal, external) {
                return external ? function(e) {
                    internal(e);
                    external(e);
                } : internal;
            }
        },
        {
            key: 'isOpen',
            value: function isOpen() {
                return 'open' in this.props ? this.props.open : this.state.isOpen;
            }
        },
        {
            key: 'render',
            value: function render() {
                if (this.props.debug) // you don't like it, you love it
                this._debugStates.push({
                    id: this._debugStates.length,
                    state: this.state
                });
                var inputProps = this.props.inputProps;
                var open = this.isOpen();
                return $6wXVr.createElement('div', $de94eb3bd11c0cfb$var$_extends({
                    style: $de94eb3bd11c0cfb$var$_extends({}, this.props.wrapperStyle)
                }, this.props.wrapperProps), this.props.renderInput($de94eb3bd11c0cfb$var$_extends({}, inputProps, {
                    role: 'combobox',
                    'aria-autocomplete': 'list',
                    'aria-expanded': open,
                    autoComplete: 'off',
                    ref: this.exposeAPI,
                    onFocus: this.handleInputFocus,
                    onBlur: this.handleInputBlur,
                    onChange: this.handleChange,
                    onKeyDown: this.composeEventHandlers(this.handleKeyDown, inputProps.onKeyDown),
                    onClick: this.composeEventHandlers(this.handleInputClick, inputProps.onClick),
                    value: this.props.value
                })), open && this.renderMenu(), this.props.debug && $6wXVr.createElement('pre', {
                    style: {
                        marginLeft: 300
                    }
                }, JSON.stringify(this._debugStates.slice(Math.max(0, this._debugStates.length - 5), this._debugStates.length), null, 2)));
            }
        }
    ]);
    return Autocomplete;
}($6wXVr.Component);
$de94eb3bd11c0cfb$var$Autocomplete.propTypes = {
    /**
   * The items to display in the dropdown menu
   */ items: $c83591d04bda8b2b$exports.array.isRequired,
    /**
   * The value to display in the input field
   */ value: $c83591d04bda8b2b$exports.any,
    /**
   * Arguments: `event: Event, value: String`
   *
   * Invoked every time the user changes the input's value.
   */ onChange: $c83591d04bda8b2b$exports.func,
    /**
   * Arguments: `value: String, item: Any`
   *
   * Invoked when the user selects an item from the dropdown menu.
   */ onSelect: $c83591d04bda8b2b$exports.func,
    /**
   * Arguments: `item: Any, value: String`
   *
   * Invoked for each entry in `items` and its return value is used to
   * determine whether or not it should be displayed in the dropdown menu.
   * By default all items are always rendered.
   */ shouldItemRender: $c83591d04bda8b2b$exports.func,
    /**
   * Arguments: `item: Any`
   *
   * Invoked when attempting to select an item. The return value is used to
   * determine whether the item should be selectable or not.
   * By default all items are selectable.
   */ isItemSelectable: $c83591d04bda8b2b$exports.func,
    /**
   * Arguments: `itemA: Any, itemB: Any, value: String`
   *
   * The function which is used to sort `items` before display.
   */ sortItems: $c83591d04bda8b2b$exports.func,
    /**
   * Arguments: `item: Any`
   *
   * Used to read the display value from each entry in `items`.
   */ getItemValue: $c83591d04bda8b2b$exports.func.isRequired,
    /**
   * Arguments: `item: Any, isHighlighted: Boolean, styles: Object`
   *
   * Invoked for each entry in `items` that also passes `shouldItemRender` to
   * generate the render tree for each item in the dropdown menu. `styles` is
   * an optional set of styles that can be applied to improve the look/feel
   * of the items in the dropdown menu.
   */ renderItem: $c83591d04bda8b2b$exports.func.isRequired,
    /**
   * Arguments: `items: Array<Any>, value: String, styles: Object`
   *
   * Invoked to generate the render tree for the dropdown menu. Ensure the
   * returned tree includes every entry in `items` or else the highlight order
   * and keyboard navigation logic will break. `styles` will contain
   * { top, left, minWidth } which are the coordinates of the top-left corner
   * and the width of the dropdown menu.
   */ renderMenu: $c83591d04bda8b2b$exports.func,
    /**
   * Styles that are applied to the dropdown menu in the default `renderMenu`
   * implementation. If you override `renderMenu` and you want to use
   * `menuStyle` you must manually apply them (`this.props.menuStyle`).
   */ menuStyle: $c83591d04bda8b2b$exports.object,
    /**
   * Arguments: `props: Object`
   *
   * Invoked to generate the input element. The `props` argument is the result
   * of merging `props.inputProps` with a selection of props that are required
   * both for functionality and accessibility. At the very least you need to
   * apply `props.ref` and all `props.on<event>` event handlers. Failing to do
   * this will cause `Autocomplete` to behave unexpectedly.
   */ renderInput: $c83591d04bda8b2b$exports.func,
    /**
   * Props passed to `props.renderInput`. By default these props will be
   * applied to the `<input />` element rendered by `Autocomplete`, unless you
   * have specified a custom value for `props.renderInput`. Any properties
   * supported by `HTMLInputElement` can be specified, apart from the
   * following which are set by `Autocomplete`: value, autoComplete, role,
   * aria-autocomplete. `inputProps` is commonly used for (but not limited to)
   * placeholder, event handlers (onFocus, onBlur, etc.), autoFocus, etc..
   */ inputProps: $c83591d04bda8b2b$exports.object,
    /**
   * Props that are applied to the element which wraps the `<input />` and
   * dropdown menu elements rendered by `Autocomplete`.
   */ wrapperProps: $c83591d04bda8b2b$exports.object,
    /**
   * This is a shorthand for `wrapperProps={{ style: <your styles> }}`.
   * Note that `wrapperStyle` is applied before `wrapperProps`, so the latter
   * will win if it contains a `style` entry.
   */ wrapperStyle: $c83591d04bda8b2b$exports.object,
    /**
   * Whether or not to automatically highlight the top match in the dropdown
   * menu.
   */ autoHighlight: $c83591d04bda8b2b$exports.bool,
    /**
   * Whether or not to automatically select the highlighted item when the
   * `<input>` loses focus.
   */ selectOnBlur: $c83591d04bda8b2b$exports.bool,
    /**
   * Arguments: `isOpen: Boolean`
   *
   * Invoked every time the dropdown menu's visibility changes (i.e. every
   * time it is displayed/hidden).
   */ onMenuVisibilityChange: $c83591d04bda8b2b$exports.func,
    /**
   * Used to override the internal logic which displays/hides the dropdown
   * menu. This is useful if you want to force a certain state based on your
   * UX/business logic. Use it together with `onMenuVisibilityChange` for
   * fine-grained control over the dropdown menu dynamics.
   */ open: $c83591d04bda8b2b$exports.bool,
    debug: $c83591d04bda8b2b$exports.bool
};
$de94eb3bd11c0cfb$var$Autocomplete.defaultProps = {
    value: '',
    wrapperProps: {},
    wrapperStyle: {
        display: 'inline-block'
    },
    inputProps: {},
    renderInput: function renderInput(props) {
        return $6wXVr.createElement('input', props);
    },
    onChange: function onChange() {},
    onSelect: function onSelect() {},
    isItemSelectable: function isItemSelectable() {
        return true;
    },
    renderMenu: function renderMenu(items, value, style) {
        return $6wXVr.createElement('div', {
            style: $de94eb3bd11c0cfb$var$_extends({}, style, this.menuStyle),
            children: items
        });
    },
    menuStyle: {
        borderRadius: '3px',
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
        background: 'rgba(255, 255, 255, 0.9)',
        padding: '2px 0',
        fontSize: '90%',
        position: 'fixed',
        overflow: 'auto',
        maxHeight: '50%'
    },
    autoHighlight: true,
    selectOnBlur: false,
    onMenuVisibilityChange: function onMenuVisibilityChange() {}
};
$de94eb3bd11c0cfb$var$Autocomplete.keyDownHandlers = {
    ArrowDown: function ArrowDown(event) {
        event.preventDefault();
        var items = this.getFilteredItems(this.props);
        if (!items.length) return;
        var highlightedIndex = this.state.highlightedIndex;
        var index = highlightedIndex === null ? -1 : highlightedIndex;
        for(var i = 0; i < items.length; i++){
            var p = (index + i + 1) % items.length;
            if (this.props.isItemSelectable(items[p])) {
                index = p;
                break;
            }
        }
        if (index > -1 && index !== highlightedIndex) this.setState({
            highlightedIndex: index,
            isOpen: true
        });
    },
    ArrowUp: function ArrowUp(event) {
        event.preventDefault();
        var items = this.getFilteredItems(this.props);
        if (!items.length) return;
        var highlightedIndex = this.state.highlightedIndex;
        var index = highlightedIndex === null ? items.length : highlightedIndex;
        for(var i = 0; i < items.length; i++){
            var p = (index - (1 + i) + items.length) % items.length;
            if (this.props.isItemSelectable(items[p])) {
                index = p;
                break;
            }
        }
        if (index !== items.length) this.setState({
            highlightedIndex: index,
            isOpen: true
        });
    },
    Enter: function Enter(event) {
        var _this7 = this;
        // Key code 229 is used for selecting items from character selectors (Pinyin, Kana, etc)
        if (event.keyCode !== 13) return;
        // In case the user is currently hovering over the menu
        this.setIgnoreBlur(false);
        if (!this.isOpen()) // menu is closed so there is no selection to accept -> do nothing
        return;
        else if (this.state.highlightedIndex == null) // input has focus but no menu item is selected + enter is hit -> close the menu, highlight whatever's in input
        this.setState({
            isOpen: false
        }, function() {
            _this7.refs.input.select();
        });
        else {
            // text entered + menu item has been highlighted + enter is hit -> update value to that of selected menu item, close the menu
            event.preventDefault();
            var item = this.getFilteredItems(this.props)[this.state.highlightedIndex];
            var value = this.props.getItemValue(item);
            this.setState({
                isOpen: false,
                highlightedIndex: null
            }, function() {
                //this.refs.input.focus() // TODO: file issue
                _this7.refs.input.setSelectionRange(value.length, value.length);
                _this7.props.onSelect(value, item);
            });
        }
    },
    Escape: function Escape() {
        // In case the user is currently hovering over the menu
        this.setIgnoreBlur(false);
        this.setState({
            highlightedIndex: null,
            isOpen: false
        });
    },
    Tab: function Tab() {
        // In case the user is currently hovering over the menu
        this.setIgnoreBlur(false);
    }
};
$de94eb3bd11c0cfb$exports = $de94eb3bd11c0cfb$var$Autocomplete;


class $3d246ea7b59b7507$export$2e2bcd8739ae039 extends (0, $92db7a2df6c79520$export$2e2bcd8739ae039) {
    constructor(props){
        super(props);
        this.identifier = props.identifier;
        this.className = props.className || "col-md-1_5 col-arrow";
        this.state = {
            value: ''
        };
        this.handleRTUpdate = this.handleRTUpdate.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.getCurrentNode = this.getCurrentNode.bind(this);
    }
    isPartiallyInViewport(element) {
        const rect = element.getBoundingClientRect();
        return rect.top + rect.height >= 0 && rect.left + rect.width >= 0 && rect.bottom - rect.height <= (window.innerHeight || document.documentElement.clientHeight) && rect.right - rect.width <= (window.innerWidth + rect.width || document.documentElement.clientWidth);
    }
    scrollListener = ()=>{
        const input = document.querySelector('#' + this.domId);
        if (!input) return;
        const menu = input.nextElementSibling;
        if (menu && !this.isPartiallyInViewport(menu)) {
            this.setState({
                optionOpen: false
            });
            input.blur();
        }
    };
    componentDidMount() {
        // Simply listen for change events and set state from them.
        this.connectorRef = window.firebase.database().ref(this.getCurrentNode());
        this.callbackConnector = this.connectorRef.on("value", (data)=>{
            const val = data.val();
            if (null !== val && val !== this.state.value) this.setState({
                value: val
            });
        });
    }
    componentWillUnmount() {
        if (this.callbackConnector) {
            this.connectorRef.off('value', this.callbackConnector);
            this.callbackConnector = null;
        }
    }
    handleRTUpdate(event) {
        // Update state based on RT updates.
        this.setState({
            value: event.target.text
        }, ()=>{
            this.connectorRef.set(event.target.text);
        });
    }
    handleChange(event, value) {
        // Update state and RT view based on local change.
        this.setState({
            value: value
        }, ()=>{
            this.connectorRef.set(value);
        });
    }
    onVisChange(isOpen) {
        window.removeEventListener("scroll", this.scrollListener);
        if (isOpen) window.addEventListener("scroll", this.scrollListener, true);
    }
    render() {
        const menuStyle = {
            zIndex: "1000",
            borderRadius: '3px',
            boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
            background: 'rgba(255, 255, 255, 0.9)',
            padding: '2px 0',
            fontSize: '90%',
            position: 'absolute',
            top: '2rem',
            left: 0,
            overflow: 'auto'
        };
        const defaultItemStyle = {
            padding: '2px 6px',
            cursor: 'default'
        };
        const highlightItemStyle = {
            color: 'white',
            background: 'hsl(200, 50%, 50%)',
            padding: '2px 6px',
            cursor: 'default'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: this.className
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("label", {
            htmlFor: this.domId,
            className: "sr-only"
        }, this.props.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($de94eb3bd11c0cfb$exports))), {
            items: this.props.autocompleteOptions,
            wrapperProps: {
                className: "form-arrow mb-0_5 position-relative",
                style: null
            },
            inputProps: {
                id: this.domId,
                className: "form-control",
                placeholder: this.props.placeholder
            },
            menuStyle: menuStyle,
            getItemValue: (item)=>item,
            renderItem: (item, isHighlighted)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                    style: isHighlighted ? highlightItemStyle : defaultItemStyle,
                    key: item
                }, item),
            onSelect: (value)=>{
                this.setState({
                    value: value
                }, ()=>this.connectorRef.set(value));
            },
            value: this.state.value,
            onChange: this.handleChange,
            onMenuVisibilityChange: (isOpen)=>{
                this.onVisChange(isOpen);
            }
        }));
    }
    getCurrentNode() {
        return this.props.parentNode + "/" + this.identifier;
    }
    renderHeader() {
        return null;
    }
}
$3d246ea7b59b7507$export$2e2bcd8739ae039.propTypes = {
    identifier: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    autocompleteOptions: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).array.isRequired
};




class $78739bc7dc9cfb57$export$2e2bcd8739ae039 extends (0, $c01ab3c338b52a54$export$2e2bcd8739ae039) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.identifier = this.props.identifier;
        this.identifierRef = null;
        this.newItem = this.newItem.bind(this);
        this.getCurrentNode = this.getCurrentNode.bind(this);
    }
    render() {
        const editing = undefined !== this.props.editing ? this.props.editing : true;
        const qualityStep = undefined !== this.props.qualityStep ? this.props.qualityStep : false;
        const inCompleteStep = undefined !== this.props.inCompleteStep ? this.props.inCompleteStep : false;
        const qualityTypeMaps = undefined !== this.props.qualityTypeMaps ? this.props.qualityTypeMaps : null;
        const qualityNoteMaps = undefined !== this.props.qualityNoteMaps ? this.props.qualityNoteMaps : null;
        const print = undefined !== this.props.print ? this.props.print : false;
        const itemList = this.getContentList();
        let itemsHTML = [];
        let itemCount = 0;
        if (itemList) {
            for(let key in itemList)if (itemList.hasOwnProperty(key)) {
                itemCount++;
                itemsHTML.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($78739bc7dc9cfb57$var$Evidence, {
                    key: key,
                    id: key,
                    itemCount: itemCount,
                    hLevel: this.props.hLevel,
                    hClassName: this.props.hClassName,
                    identifier: this.identifier,
                    doc: this.props.doc,
                    deleteMethod: this.handleDeleteItem,
                    canDelete: editing,
                    editing: editing,
                    qualityStep: qualityStep,
                    print: print,
                    data: this.props.data,
                    inCompleteStep: inCompleteStep,
                    qualityTypeMaps: qualityTypeMaps,
                    qualityNoteMaps: qualityNoteMaps
                }));
            }
        }
        let addButton = editing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            onClick: this.handleAddItem,
            type: "button",
            className: "btn btn-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-plus me-0_25",
            "aria-hidden": "true"
        }), "Add evidence") : null;
        if (!this.context.canEdit) addButton = null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", null, itemsHTML, !qualityStep ? addButton : null);
    }
    getCurrentNode() {
        return this.context.fileType + "/" + this.context.fileId + "/" + this.identifier;
    }
    newItem() {
        window.firebase.database().ref(this.getCurrentNode()).push().set({
            evidence: "",
            citation: "",
            qualitytype: "",
            qualitynote: ""
        });
    }
    getValuePath(key) {
        let path = this.context.fileType + "/" + this.context.fileId + "/" + this.identifier + "/" + key + "/evidence";
        return path;
    }
    getImagePath(key) {
        let path = this.context.fileType + "/" + this.context.fileId + "/" + this.identifier + "/" + key + "/evidence/image";
        return path;
    }
}
class $78739bc7dc9cfb57$var$Evidence extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.id = props.id;
        this.identifier = props.identifier;
        this.deleteButtonId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.deleteModalId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.getBaseNode = this.getBaseNode.bind(this);
        this.handleDeleteButton = this.handleDeleteButton.bind(this);
    }
    getBaseNode() {
        return this.props.doc.type + "/" + this.props.doc.id;
    }
    hasContent(text) {
        return undefined !== text && null !== text && text.trim();
    }
    render() {
        const fileType = this.context.fileType;
        const fileId = this.context.fileId;
        const mevidence = this.identifier + "/" + this.id + "/evidence";
        const mcitation = this.identifier + "/" + this.id + "/citation";
        const mqualityTypeParentNote = fileType + "/" + fileId + "/" + this.identifier + "/" + this.id;
        const mqualitytype = this.identifier + "/" + this.id + "/qualitytype";
        const mqualitynote = this.identifier + "/" + this.id + "/qualitynote";
        const deleteMessage = "Do you want to delete evidence?";
        const deleteModal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $cc5d5838c074a4ab$export$2e2bcd8739ae039), {
            id: this.deleteModalId,
            method: this.handleDeleteButton,
            text: deleteMessage,
            yes: "Remove"
        });
        const deleteIcon = this.context.canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $c8db36dd985f35f1$export$2e2bcd8739ae039), {
            icon: "fa-times",
            tooltip: "Remove Evidence",
            modalId: this.deleteModalId,
            canDelete: this.props.canDelete
        }) : null;
        const inCompleteStep = undefined !== this.props.inCompleteStep ? this.props.inCompleteStep : false;
        const qualityTypeMaps = undefined !== this.props.qualityTypeMaps ? this.props.qualityTypeMaps : null;
        const qualityNoteMaps = undefined !== this.props.qualityNoteMaps ? this.props.qualityNoteMaps : null;
        let hasQuality = false;
        if (qualityTypeMaps !== null && qualityNoteMaps !== null) {
            if (this.hasContent(qualityTypeMaps.get(this.id)) && this.hasContent(qualityNoteMaps.get(this.id))) hasQuality = true;
        }
        const evidenceTypeCount = `${this.identifier === 'evidencesupport' ? 'Supporting' : 'Opposing'} Evidence ${this.props.itemCount}`;
        let evidenceHeading = undefined;
        let HeadingTag = `div`;
        let SubHeadingTag = `div`;
        if (this.props.hLevel !== undefined) {
            const hLevel = parseInt(this.props.hLevel, 10);
            HeadingTag = `h${hLevel}`;
            SubHeadingTag = `h${hLevel + 1}`;
            evidenceHeading = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement(HeadingTag, {
                className: this.props.hClassName
            }, evidenceTypeCount);
        }
        const qualityTypeHtml = this.context.canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $3d246ea7b59b7507$export$2e2bcd8739ae039), {
            className: "pb-0",
            identifier: "qualitytype",
            parentNode: mqualityTypeParentNote,
            placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(this.props.doc.type + ".qualitytype.placeholder"),
            label: "Evidence Quality",
            autocompleteOptions: [
                'The quality of the evidence is strong',
                'The quality of the evidence is weak'
            ]
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill mt-0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $c0e31515b414b5e0$export$2e2bcd8739ae039), {
            identifier: mqualitytype,
            className: "col"
        })));
        return this.props.editing && this.context.canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, !this.props.qualityStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box-row-close"
        }, deleteModal, deleteIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "form-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            ...this.props,
            inputType: "text-area",
            placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(this.props.doc.type + "." + this.identifier + ".placeholder"),
            identifier: mevidence,
            addImage: true,
            singleLine: false
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "form-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            ...this.props,
            inputType: "text-area",
            placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(this.props.doc.type + ".citation.placeholder"),
            identifier: mcitation,
            addImage: false,
            singleLine: false
        }))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: mevidence,
            className: "grouping-text"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: mevidence + "/image",
            className: "grouping-img"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: mcitation,
            className: "box bg-autofill mb-0_5"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "form-group"
        }, qualityTypeHtml), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mt-0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            ...this.props,
            inputType: "text-area",
            inputClassName: "",
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(this.props.doc.type + '.qualitynote.label'),
            placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(this.props.doc.type + '.qualitynote.placeholder'),
            identifier: mqualitynote,
            addImage: false,
            singleLine: false
        })))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, evidenceHeading, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: mevidence,
            className: "grouping-text"
        }), !this.props.print ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: mevidence + "/image",
            className: "grouping-img"
        }) : null), !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement(SubHeadingTag, {
            className: "h3 mb-0"
        }, "Strength of Evidence"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $c0e31515b414b5e0$export$2e2bcd8739ae039), {
            identifier: mqualitytype
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement(SubHeadingTag, {
            className: "h3 mb-0"
        }, "Rationale"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: mqualitynote
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, hasQuality ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement(SubHeadingTag, {
            className: "h3 mb-0"
        }, "Strength of Evidence"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $c0e31515b414b5e0$export$2e2bcd8739ae039), {
            identifier: mqualitytype
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement(SubHeadingTag, {
            className: "h3 mb-0"
        }, "Rationale"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: mqualitynote
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
            identifier: "qualitynote",
            className: "box bg-unfilled"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement(SubHeadingTag, {
            className: "h3 mb-0"
        }, "Source"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: mcitation,
            className: "grouping-text"
        }))));
    }
    handleDeleteButton() {
        this.props.deleteMethod(this.id);
    }
}
$78739bc7dc9cfb57$var$Evidence.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    identifier: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    doc: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).object.isRequired,
    canDelete: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).bool.isRequired,
    deleteMethod: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).func.isRequired
};




const $24aeae23f2f5fcfb$export$8b7da65a69e41fc9 = (doc, fieldStatus, inCompleteStep)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Topic"), !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "topic",
        className: "box bg-autofill"
    }) : fieldStatus.hasTopic ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "topic",
        className: "box bg-autofill"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "topic",
        className: "box bg-unfilled"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate("question-exp.essentialquestion.title")), !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "essentialquestion",
        className: "grouping-text"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "essentialquestion/image",
        className: "grouping-img"
    }))) : fieldStatus.hasEssentialQuestion ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "essentialquestion",
        className: "grouping-text"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "essentialquestion/image",
        className: "grouping-img"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "essentialquestion",
        className: "box bg-unfilled"
    })));
};
const $24aeae23f2f5fcfb$export$eb632fcff23bdc70 = (doc, fieldStatus, inCompleteStep)=>{
    const section = (0, $198066ba87364cec$export$2e2bcd8739ae039)[doc.type].terms;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, section.title ? section.title : section.label), !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b230fd9af7e1399f$export$2e2bcd8739ae039), {
        doc: doc,
        section: section,
        editing: false,
        secondary: true
    }) : fieldStatus.hasKeyTerms ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b230fd9af7e1399f$export$2e2bcd8739ae039), {
        doc: doc,
        section: section,
        editing: false,
        secondary: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "terms",
        className: "box bg-unfilled"
    }));
};
const $24aeae23f2f5fcfb$export$1c192b3501b2d95a = (doc, fieldStatus, inCompleteStep)=>{
    // const section = texts[doc.type].terms;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Evidence"), !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $78739bc7dc9cfb57$export$2e2bcd8739ae039), {
        doc: doc,
        editing: false,
        identifier: "evidencesupport",
        canBeEmpty: false
    }) : fieldStatus.hasEvidenceSupport ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $78739bc7dc9cfb57$export$2e2bcd8739ae039), {
        doc: doc,
        inCompleteStep: inCompleteStep,
        qualityTypeMaps: fieldStatus.valueMaps['supportqualitytype'],
        qualityNoteMaps: fieldStatus.valueMaps['supportqualitynote'],
        editing: false,
        identifier: "evidencesupport",
        canBeEmpty: false,
        hLevel: 3
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "evidencesupport",
        className: "box bg-unfilled"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("hr", null), !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $78739bc7dc9cfb57$export$2e2bcd8739ae039), {
        doc: doc,
        editing: false,
        identifier: "evidenceopposes",
        canBeEmpty: false
    }) : fieldStatus.hasEvidenceOpposes ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $78739bc7dc9cfb57$export$2e2bcd8739ae039), {
        doc: doc,
        inCompleteStep: inCompleteStep,
        qualityTypeMaps: fieldStatus.valueMaps['opposesqualitytype'],
        qualityNoteMaps: fieldStatus.valueMaps['opposesqualitynote'],
        editing: false,
        identifier: "evidenceopposes",
        canBeEmpty: false,
        hLevel: 3
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "evidenceopposes",
        className: "box bg-unfilled"
    }));
};
const $24aeae23f2f5fcfb$export$bdfcb0d111d3627c = (doc, fieldStatus, inCompleteStep)=>{
    const reasoningHtml = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $c0e31515b414b5e0$export$2e2bcd8739ae039), {
        identifier: "reasoningtype",
        className: "grouping-text"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "reasoningnote",
        className: "grouping-text"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "reasoningnote/image",
        className: "grouping-img"
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Reasoning"), !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, reasoningHtml) : fieldStatus.hasReasoning ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, reasoningHtml) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "reasoningnote",
        className: "box bg-unfilled"
    }));
};
const $24aeae23f2f5fcfb$export$dac5a380ed022e46 = (doc, fieldStatus, inCompleteStep)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, !inCompleteStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Claim"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "claim",
        className: "box bg-autofill"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "claimcontext",
        className: "grouping-text"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "claimcontext/image",
        className: "grouping-img"
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Claim"), fieldStatus.hasClaim ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "claim",
        className: "box bg-autofill"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "claim",
        className: "box bg-unfilled"
    }), fieldStatus.hasClaimContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "claimcontext",
        className: "grouping-text"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "claimcontext/image",
        className: "grouping-img"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a70f4f4581e3fd55$export$2e2bcd8739ae039), {
        identifier: "claimcontext",
        className: "box bg-unfilled"
    })));
};
const $24aeae23f2f5fcfb$export$1f1d0ed2d2d34eef = (doc, fieldStatus, closeChecklist, onClickFunc)=>{
    return fieldStatus.display ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "h3"
    }, "Review Checklist"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box box-unfilled"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box-row-close"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
        type: "button",
        className: "btn btn-icon btn-link",
        "aria-label": "Remove key term",
        title: "Remove Checklist",
        onClick: closeChecklist
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
        className: "fa fa-times text-primary",
        "aria-hidden": "true"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", null, !fieldStatus.hasTopic ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not yet entered a ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Topic"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "essentialquestion",
        onClick: ()=>onClickFunc(1)
    }, "Step 1"), " to complete the section.") : null, !fieldStatus.hasEssentialQuestion ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not yet entered an ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Essential Question"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "essentialquestion",
        onClick: ()=>onClickFunc(1)
    }, "Step 1"), " to complete the section.") : null, !fieldStatus.hasKeyTerms ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not entered any ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Key Terms"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "terms",
        onClick: ()=>onClickFunc(2)
    }, "Step 2"), " to define Key Terms") : null, !fieldStatus.hasClaim ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not yet entered a ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Claim"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "claim",
        onClick: ()=>onClickFunc(3)
    }, "Step 3"), " to complete the section.") : null, !fieldStatus.hasClaimContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not yet entered a ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Claim Background/Context"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "claim",
        onClick: ()=>onClickFunc(3)
    }, "Step 3"), " to complete the section.") : null, !fieldStatus.hasEvidenceSupport ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not yet entered any ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Supporting Evidence"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "evidencesupport",
        onClick: ()=>onClickFunc(4)
    }, "Step 4"), "  to complete the section.") : null, !fieldStatus.hasEvidenceOpposes ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not yet entered any ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Opposing Evidence"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "evidenceopposes",
        onClick: ()=>onClickFunc(5)
    }, "Step 5"), "  to complete the section.") : null, !fieldStatus.hasEvidenceQuality ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not entered the ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Evidence Quality"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "evidencequality",
        onClick: ()=>onClickFunc(6)
    }, "Step 6"), "  to complete the section.") : null, !fieldStatus.hasReasoning ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "You have not entered the ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("b", null, "Reasoning"), ". Go to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$a6c7ac8248d6e38a), {
        to: "reasoning",
        onClick: ()=>onClickFunc(7)
    }, "Step 7"), " to complete the section.") : null))) : null;
};
class $24aeae23f2f5fcfb$export$2e2bcd8739ae039 extends (0, $1290cbb92ac2986c$export$2e2bcd8739ae039) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.state = {
            display: false,
            hasEssentialQuestion: false,
            hasTopic: false,
            hasKeyTerms: false,
            hasClaim: false,
            hasClaimContext: false,
            hasEvidenceSupport: false,
            hasEvidenceOpposes: false,
            hasEvidenceQuality: false,
            hasReasoning: false,
            valueMaps: null
        };
        this.closeChecklist = this.closeChecklist.bind(this);
        this.checkEmptyList = this.checkEmptyList.bind(this);
        this.mapHasContent = this.mapHasContent.bind(this);
    }
    closeChecklist() {
        this.setState({
            display: false
        });
    }
    checkEmptyField(field) {
        this.getFirepadTextPromise(field).then((data)=>{
            let hasContent = this.hasContent(data);
            if ("essentialquestion" === field) this.setState({
                hasEssentialQuestion: hasContent
            });
            if ("topic" === field) this.setState({
                hasTopic: hasContent
            });
            if ("claim" === field) this.setState({
                hasClaim: hasContent
            });
            if ("claimcontext" === field) this.setState({
                hasClaimContext: hasContent
            });
            if ("reasoningnote" === field) this.setState({
                hasReasoning: hasContent
            });
            this.updateChecklist();
        });
    }
    updateChecklist() {
        let showChecklist = false;
        if (!this.state.hasTopic) showChecklist = true;
        if (!this.state.hasEssentialQuestion) showChecklist = true;
        if (!this.state.hasKeyTerms) showChecklist = true;
        if (!this.state.hasClaim) showChecklist = true;
        if (!this.state.hasClaimContext) showChecklist = true;
        if (!this.state.hasEvidenceSupport) showChecklist = true;
        if (!this.state.hasEvidenceOpposes) showChecklist = true;
        if (!this.state.hasEvidenceQuality) showChecklist = true;
        if (!this.state.hasReasoning) showChecklist = true;
        this.setState({
            display: showChecklist
        });
    }
    componentDidMount() {
        for (let field of [
            'topic',
            'essentialquestion',
            'claim',
            'claimcontext',
            'reasoningnote'
        ])this.checkEmptyField(field);
        this.checkEmptyList();
    }
    getCERGuideMapsPromise() {
        let proms = [
            this.getFirepadMapPromise('terms', 'def'),
            this.getFirepadMapPromise('terms', 'term'),
            this.getFirepadMapPromise('evidencesupport', 'evidence'),
            this.getFirepadMapPromise('evidencesupport', 'citation'),
            this.getTextMapPromise('evidencesupport', 'qualitytype'),
            this.getFirepadMapPromise('evidencesupport', 'qualitynote'),
            this.getFirepadMapPromise('evidenceopposes', 'evidence'),
            this.getFirepadMapPromise('evidenceopposes', 'citation'),
            this.getTextMapPromise('evidenceopposes', 'qualitytype'),
            this.getFirepadMapPromise('evidenceopposes', 'qualitynote')
        ];
        return Promise.all(proms).then((maps)=>{
            return {
                'termsdef': maps[0],
                'termsword': maps[1],
                'supportevidence': maps[2],
                'supportcitation': maps[3],
                'supportqualitytype': maps[4],
                'supportqualitynote': maps[5],
                'opposesevidence': maps[6],
                'opposescitation': maps[7],
                'opposesqualitytype': maps[8],
                'opposesqualitynote': maps[9]
            };
        });
    }
    checkEmptyList() {
        this.getCERGuideMapsPromise().then((valueMaps)=>{
            if (valueMaps != null) {
                console.log(valueMaps);
                var hasTermOrDef = this.mapHasContent(valueMaps['termsword']) || this.mapHasContent(valueMaps['termsdef']);
                var hasEvidenceSupport = this.mapHasContent(valueMaps['supportevidence']);
                var hasEvidenceOpposes = this.mapHasContent(valueMaps['opposesevidence']);
                var supportQuality = this.allMapHasContent(valueMaps['supportqualitytype']) && this.allMapHasContent(valueMaps['supportqualitynote']);
                var opposesQuality = this.allMapHasContent(valueMaps['opposesqualitytype']) && this.allMapHasContent(valueMaps['opposesqualitynote']);
                console.log("supportQuality = " + supportQuality + ", opposesQuality = " + opposesQuality);
                var hasEvidenceQuality = supportQuality && opposesQuality;
                let update = {
                    hasKeyTerms: hasTermOrDef,
                    hasEvidenceSupport: hasEvidenceSupport,
                    hasEvidenceOpposes: hasEvidenceOpposes,
                    hasEvidenceQuality: hasEvidenceQuality,
                    valueMaps: valueMaps
                };
                this.setState(update);
                this.updateChecklist();
            }
        });
    }
    onClickFunc(step) {
        window.tracker.trackEvent("Navigation", "checklist link", step);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, this.props.inCompleteStep && this.context.canEdit ? $24aeae23f2f5fcfb$export$1f1d0ed2d2d34eef(this.props.doc, this.state, this.closeChecklist, this.onClickFunc) : null, $24aeae23f2f5fcfb$export$8b7da65a69e41fc9(this.props.doc, this.state, this.props.inCompleteStep), $24aeae23f2f5fcfb$export$dac5a380ed022e46(this.props.doc, this.state, this.props.inCompleteStep), $24aeae23f2f5fcfb$export$eb632fcff23bdc70(this.props.doc, this.state, this.props.inCompleteStep), $24aeae23f2f5fcfb$export$1c192b3501b2d95a(this.props.doc, this.state, this.props.inCompleteStep), $24aeae23f2f5fcfb$export$bdfcb0d111d3627c(this.props.doc, this.state, this.props.inCompleteStep));
    }
}




var $6wXVr = parcelRequire("6wXVr");
function $7584d0f0d61537f7$export$2e2bcd8739ae039(props) {
    const title = props.title;
    console.log("Title: level %s " + title, props.headerLevel);
    return undefined !== props.headerLevel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h1", {
        className: props.headerLevel
    }, title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, title);
}



// Direction for video player dropdown menus
(0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))(document, '[data-cfw="player"]').on('ready.cfw.player', function(e) {
    // 'use strict';
    (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))(e.target).closest('[data-cfw="player"]').find('.player-caption-wrapper').addClass('dropup dropend');
    (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))(e.target).closest('[data-cfw="player"]').find('.player-script-wrapper').addClass('dropup dropend');
});
// Stick pagination nav to top of footer when it is reached,
// otherwise fix at bottom of viewport
var $364b9cc7d9afdbb5$var$paginationAffix = function() {
    // 'use strict';
    var $affix = (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('.footer-pages');
    $affix.CFW_Affix({
        top: 0,
        bottom: function() {
            // TODO: Why is px adjustment needed?
            return (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('footer').outerHeight() + $affix.innerHeight() - 34;
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))(window).on('resize', function() {
        $affix.CFW_Affix('checkPosition');
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))(window).scroll();
};
var $364b9cc7d9afdbb5$var$playerHideStop = function() {
    // 'use strict';
    (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))(document).on('afterHide.cfw.modal afterHide.cfw.popover', function(e) {
        var $node = (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))(e.target);
        $node.find('[data-cfw="player"]').CFW_Player('pause');
    });
};
// Various supplemental functionality due to BPV sidebar
var $364b9cc7d9afdbb5$var$bpvAsidePos = function() {
    //'use strict';
    var $aside = (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('.bpv-side');
    var bpMd = getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-md');
    var bpMdpx = Math.floor(parseFloat(bpMd) * 16);
    var w1 = window.innerWidth;
    var h1 = (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('.header-main').outerHeight();
    var h2 = (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('.footer-pages').outerHeight();
    var $topbar = (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('.alert-topbar');
    var isMd = w1 >= bpMdpx;
    h1 = typeof h1 === 'undefined' ? 0 : h1;
    h2 = typeof h2 === 'undefined' ? 0 : h2;
    // If portion of `.alert.topbar` is showing below header, adjust top point
    if ($topbar.length) {
        var h3 = $topbar.offset().top + $topbar.outerHeight() - window.pageYOffset;
        h1 = h3 > h1 ? h3 : h1;
    }
    $aside.removeClass('width').css({
        'top': '',
        'bottom': '',
        'max-height': ''
    });
    if (isMd) $aside.addClass('width').css({
        'top': h1 + 'px',
        'bottom': h2 + 'px',
        'max-height': 'calc(100vh - ' + parseInt(h1 + h2, 10) + 'px)'
    });
};
const $364b9cc7d9afdbb5$export$cb8f6cc068188a8f = function() {
    // 'use strict';
    var $aside = (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('.bpv-side');
    var $main = (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('main').first();
    var $container = (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('.container').first();
    $main.removeClass('has-aside');
    $container.removeClass('has-aside');
    if ($aside.hasClass('in')) {
        $main.addClass('has-aside');
        $container.addClass('has-aside');
    }
};
const $364b9cc7d9afdbb5$export$b289503821e8656d = function() {
    // 'use strict';
    var $affix = (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('.footer-pages');
    (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('.bpv-side-toggle').on('afterHide.cfw.collapse afterShow.cfw.collapse', function() {
        // TODO: Any way to eliminate this double call?
        // Double call due to not always updating correctly on afterShow
        $affix.CFW_Affix('checkPosition');
        setTimeout(function() {
            $affix.CFW_Affix('checkPosition');
        }, 10);
        $364b9cc7d9afdbb5$export$cb8f6cc068188a8f();
    }).on('beforeShow.cfw.collapse', function() {
        $364b9cc7d9afdbb5$var$bpvAsidePos();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('.alert-topbar').on('afterClose.cfw.alert', function() {
        $364b9cc7d9afdbb5$var$bpvAsidePos();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))(window).on('resize', function() {
        $364b9cc7d9afdbb5$var$bpvAsidePos();
    });
    $364b9cc7d9afdbb5$var$bpvAsidePos();
    $364b9cc7d9afdbb5$export$cb8f6cc068188a8f();
};
(0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))(window).ready(function() {
    // 'use strict';
    $364b9cc7d9afdbb5$var$paginationAffix();
    $364b9cc7d9afdbb5$var$playerHideStop();
// Need to be called from `componentDidMount()`
// bpvAside();
}); // module.exports = bpvAside;
 // exports.bpvAside = bpvAside;
 // export default bpvAside;


class $4ba48d123e66d691$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    review(doc) {
        const textSections = (0, $198066ba87364cec$export$2e2bcd8739ae039)[doc.type].sections;
        const last = textSections.length - 2;
        const section = textSections[last];
        return "complete" === doc.section ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $7584d0f0d61537f7$export$2e2bcd8739ae039), {
            headerLevel: "h1",
            title: section.title
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, section.description)) : null;
    }
    render() {
        const doc = {
            title: this.context.fileName,
            section: this.props.section,
            type: this.context.fileType,
            id: this.context.fileId,
            editing: this.context.canEdit
        };
        const content = "comparison" === doc.type ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $7dcc312e8f17de56$export$2e2bcd8739ae039), {
            ...this.props,
            doc: doc,
            editing: false,
            inCompleteStep: true
        }) : "cause-effect" === doc.type ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $f3232c19cf166e20$export$2e2bcd8739ae039), {
            ...this.props,
            doc: doc,
            editing: false,
            inCompleteStep: true
        }) : "question-exp" === doc.type ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $28deb6bab6448c06$export$2e2bcd8739ae039), {
            ...this.props,
            doc: doc,
            editing: false,
            inCompleteStep: true
        }) : "cera" === doc.type ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $24aeae23f2f5fcfb$export$2e2bcd8739ae039), {
            ...this.props,
            doc: doc,
            editing: false,
            inCompleteStep: true
        }) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("main", {
            id: "main_container",
            className: "main"
        }, this.review(doc), content), this.props.children);
    }
    componentDidMount() {
        // Check/reset class on 'main'
        (0, $364b9cc7d9afdbb5$export$cb8f6cc068188a8f)();
    }
}



var $6wXVr = parcelRequire("6wXVr");






var $6wXVr = parcelRequire("6wXVr");



class $88346cb943f9fb99$export$2e2bcd8739ae039 extends (0, $1290cbb92ac2986c$export$2e2bcd8739ae039) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.identifier = this.props.identifier;
        this.placeholder = "Additional content for this step";
        this.state = {
            id: 0,
            firstUseTourGuide: true,
            hasInstruction: false
        };
        this.updateInstruction = this.updateInstruction.bind(this);
        this.teacherInfo = null;
        this.hasInstructionText = false;
        this.hasInstructionImage = false;
        this.hasInstructionFileName = false;
        this._isMounted = false;
    }
    componentDidMount() {
        this._isMounted = true;
        this.teacherRef = this.getRef(this.identifier + "/teacher");
        this.teacherRef.once("value", (data)=>{
            if (data.val() !== null) this.teacherInfo = data.val();
        });
        for (let field of [
            this.identifier,
            this.identifier + "/image"
        ])this.checkHasInstruction(field);
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    updateInstruction() {
        if (undefined === this.lastUpdateTime || null === this.lastUpdateTime) {
            this.doUpdateInstruction();
            this.lastUpdateTime = new Date().getTime();
        } else {
            let diffTime = new Date().getTime() - this.lastUpdateTime;
            if (diffTime > 60000) {
                this.doUpdateInstruction();
                this.lastUpdateTime = new Date().getTime();
            }
        }
    }
    doUpdateInstruction() {
        console.log("Update Instruction");
        this.teacherInfo = this.context.currentUser;
        this.setState({
            id: this.state.id + 1
        }); // re-render to show who is editing
        this.getRef(this.identifier + "/teacher").set(this.context.currentUser);
    }
    checkHasInstruction(field) {
        if (field.includes("/image")) {
            let dbRef = this.getRef(this.props.identifier);
            dbRef.once("value").then((data)=>{
                let dataVal = data.val();
                this.hasInstructionImage = dataVal && dataVal.image ? this.hasContent(dataVal.image) ? true : false : false;
                this.hasInstructionFileName = dataVal && dataVal.fileName ? this.hasContent(dataVal.fileName) ? true : false : false;
                this.updateHasInstruction();
            });
        } else this.getFirepadTextPromise(field).then((data)=>{
            this.hasInstructionText = this.hasContent(data) ? true : false;
            this.updateHasInstruction();
        });
    }
    updateHasInstruction() {
        if (!this._isMounted) return;
        this.setState({
            hasInstruction: this.hasInstructionText || this.hasInstructionImage || this.hasInstructionFileName
        });
    }
    render() {
        const isTeacher = this.context.currentUser.role === 'teacher';
        const canEdit = this.context.canEdit;
        if (isTeacher && canEdit) // Teacher with editing permission: show the editable version of the instruction area.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, this.teacherInfo !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "instruction-user"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media flex-items-center fs-small"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "collab-img me-0_5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: this.teacherInfo.photoURL,
            className: "img-fluid collab-img",
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media-body"
        }, "Last edited by ", this.teacherInfo.displayName))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Provide instruction/resources for learners"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "directions"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, "Augment this step with additional directions, cues, or media.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "form-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            updateContent: this.updateInstruction,
            placeholder: this.placeholder,
            ...this.props,
            inputType: "text-area",
            identifier: this.identifier,
            addImage: true,
            singleLine: false,
            label: "Additional content for this step"
        }))));
        else // Show read-only version
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, this.state.hasInstruction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, this.teacherInfo.displayName, " says:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.identifier,
            className: "mb-1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.identifier + "/image",
            className: "attachment"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, "Optional teacher instruction not included."));
    }
}





var $6wXVr = parcelRequire("6wXVr");


const $7dfc83116dbc3695$export$48467d32fd6a02db = (selector)=>{
    if (selector) {
        var tip_control = (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))(selector);
        var tip_placement = tip_control.attr('data-cfw-popover-placement');
        tip_control.CFW_Popover({
            container: '#onboarding',
            viewport: 'window',
            trigger: 'manual',
            placement: tip_placement ? tip_placement : 'bottom auto',
            popperConfig: {
                positionFixed: true
            }
        });
        tip_control.on('afterShow.cfw.popover', function() {
            tip_control[0].scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "center"
            });
        });
    }
};
const $7dfc83116dbc3695$export$ad3602d7a7ff9789 = (uid)=>{
    console.log("in openTourGuide uid = " + uid);
    var $curr = (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))(document).find('.onboard-popover:visible');
    var selector = "#onboard0";
    var $next = (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))(selector);
    if ($curr.length) // Wait until hide animation is complete before calling show
    $curr.CFW_Popover('hide').CFW_transition(null, function() {
        $next.CFW_Popover('show');
        $next[0].focus();
    });
    else {
        $next.CFW_Popover('show');
        $next[0].focus();
    }
    var userNode = "user/" + uid;
    let userRef = window.firebase.database().ref(userNode);
    userRef.update({
        viewTourGuide: "true"
    }, ()=>{
        console.debug('Update user set viewTourGuide is true');
    });
    return false;
};
class $7dfc83116dbc3695$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.state = {
            recognitionSupported: true
        };
    }
    onboardStt(selector) {
        var $btnStt = (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('.stt-btn');
        var $btnSttFirst = (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('.stt-btn').first();
        $btnStt.each(function() {
            var $this = (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))(this);
            if (!$this.data('cfw.popover')) return;
            $this.removeAttr('data-cfw-popover-target');
        });
        $btnSttFirst.attr('data-cfw-popover-target', selector);
        $7dfc83116dbc3695$export$48467d32fd6a02db($btnSttFirst);
        this.onboardChain(selector);
    }
    onboardChain(selector) {
        window.speechstream.speechTools.stop();
        var $curr = (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))(document).find('.onboard-popover:visible');
        var $next = (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))(selector);
        if ($curr.length) // Wait until hide animation is complete before callling show
        $curr.CFW_Popover('hide').CFW_transition(null, function() {
            $next.CFW_Popover('show');
            $next[0].focus();
        });
        else {
            $next.CFW_Popover('show');
            $next[0].focus();
        }
        return false;
    }
    componentDidMount() {
        var recognitionSupported = this.context.recognition && this.context.recognition.isSupported();
        console.log("recognitionSupported = " + recognitionSupported);
        this.setState({
            recognitionSupported: recognitionSupported
        });
    }
    render() {
        let canEdit = this.context.canEdit;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "onboard0",
            className: "popover onboard-popover has-corgi"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "close",
            "data-cfw-dismiss": "popover",
            "aria-label": "Close"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            "aria-hidden": "true"
        }, "\xd7")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "popover-header"
        }, "Welcome to Corgi!"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "popover-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, "Every Corgi Guide has lots of built-in tools. Want to check some out?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "corgi-offset"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row flex-between flex-items-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "btn btn-link font-weight-normal",
            "data-cfw-dismiss": "popover"
        }, "Not now")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-6 text-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            onClick: this.onboardChain.bind(this, "#onboard1"),
            type: "button",
            className: "btn btn-light"
        }, "Next ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-chevron-right",
            "aria-hidden": "true"
        })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "popover-arrow"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "onboard1",
            className: "popover onboard-popover"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "close",
            "data-cfw-dismiss": "popover",
            "aria-label": "Close"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            "aria-hidden": "true"
        }, "\xd7")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "popover-header"
        }, "Texthelp Toolbar"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "popover-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, "The TextHelp Toolbar lets you:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", {
            className: "list-unstyled mt-n1 mb-0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa-stack-custom",
            role: "img",
            title: "play button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-circle fa-stack-1x text-active",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-play fa-stack-sm text-white",
            "aria-hidden": "true"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa-stack-custom",
            role: "img",
            "aria-label": "stop button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-circle fa-stack-1x text-active",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-stop fa-stack-sm text-white",
            "aria-hidden": "true"
        })), "hear text read aloud"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa-stack-custom",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa-stack-custom",
            role: "img",
            "aria-label": "dictionary button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-circle fa-stack-1x text-active",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-book fa-stack-sm text-white",
            "aria-hidden": "true"
        })), "look up words with the dictionary"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa-stack-custom",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa-stack-custom",
            role: "img",
            "aria-label": "translate button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-circle fa-stack-1x text-active",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-language fa-stack-sm text-white",
            "aria-hidden": "true"
        })), "translate text into Spanish")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("em", null, "Highlight some text to try it out!")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row flex-between flex-items-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-4"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            onClick: this.onboardChain.bind(this, "#onboard0"),
            type: "button",
            className: "btn btn-link font-weight-normal ms-n0_5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            "aria-hidden": "true"
        }, "<"), "Previous")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-4 text-center onboard-dots",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-circle active"
        }), "\xa0", this.state.recognitionSupported && canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-circle"
        }, "\xa0") : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-circle"
        }), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-circle"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-4 text-end"
        }, this.state.recognitionSupported && canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            onClick: this.onboardStt.bind(this, "#onboard2"),
            type: "button",
            className: "btn btn-light"
        }, "Next ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-chevron-right",
            "aria-hidden": "true"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            onClick: this.onboardChain.bind(this, "#onboard3"),
            type: "button",
            className: "btn btn-light"
        }, "Next ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-chevron-right",
            "aria-hidden": "true"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "popover-arrow"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "onboard2",
            className: "popover onboard-popover"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "close",
            "data-cfw-dismiss": "popover",
            "aria-label": "Close"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            "aria-hidden": "true"
        }, "\xd7")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "popover-header"
        }, "Speech to Text"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "popover-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, "You can speak your response directly into a text box.", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("em", null, "Select the microphone \xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-microphone text-primary",
            role: "img",
            "aria-label": "microphone button"
        }), "\xa0 to give it a try!")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row flex-between flex-items-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-4"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            onClick: this.onboardChain.bind(this, "#onboard1"),
            type: "button",
            className: "btn btn-link font-weight-normal ms-n0_5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            "aria-hidden": "true"
        }, "<"), "Previous")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-4 text-center onboard-dots",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-circle"
        }), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-circle active"
        }), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-circle"
        }), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-circle"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-4 text-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            onClick: this.onboardChain.bind(this, "#onboard3"),
            type: "button",
            className: "btn btn-light"
        }, "Next ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-chevron-right",
            "aria-hidden": "true"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "popover-arrow"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "onboard3",
            className: "popover onboard-popover"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "close",
            "data-cfw-dismiss": "popover",
            "aria-label": "Close"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            "aria-hidden": "true"
        }, "\xd7")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "popover-header"
        }, "Full Guide View"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "popover-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, "Expand the panel to review the entire guide or hide it to focus on one step at a time.", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("em", null, "Press the \xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "d-inline-block btn btn-light py-0 px-0_25 pe-none",
            role: "img",
            "aria-label": "full routine button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-angle-double-right text-primary font-size-small",
            "aria-hidden": "true"
        })), "\xa0 button to try it out!")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row flex-between flex-items-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-4"
        }, this.state.recognitionSupported && canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            onClick: this.onboardStt.bind(this, "#onboard2"),
            type: "button",
            className: "btn btn-link font-weight-normal ms-n0_5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            "aria-hidden": "true"
        }, "<"), "Previous") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            onClick: this.onboardChain.bind(this, "#onboard1"),
            type: "button",
            className: "btn btn-link font-weight-normal ms-n0_5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            "aria-hidden": "true"
        }, "<"), "Previous")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-4 text-center onboard-dots",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-circle"
        }), "\xa0", this.state.recognitionSupported && canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-circle"
        }, "\xa0") : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-circle active"
        }), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-circle"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-4 text-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            onClick: this.onboardChain.bind(this, "#onboard4"),
            type: "button",
            className: "btn btn-light"
        }, "Next ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-chevron-right",
            "aria-hidden": "true"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "popover-arrow"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "onboard4",
            className: "popover onboard-popover"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "close",
            "data-cfw-dismiss": "popover",
            "aria-label": "Close"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            "aria-hidden": "true"
        }, "\xd7")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "popover-header"
        }, "Share or Copy"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "popover-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, "Use the menu to share, copy, or print your Guide.  You can also locate your Guide in your Google Drive.", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("em", null, "Select the \xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-bars fs-large",
            role: "img",
            "aria-label": "menu button"
        }), "\xa0 button to see your options!")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row flex-between flex-items-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-4"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            onClick: this.onboardChain.bind(this, "#onboard3"),
            className: "btn btn-link font-weight-normal ms-n0_5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            "aria-hidden": "true"
        }, "<"), "Previous")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-4 text-center onboard-dots",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-circle"
        }), "\xa0", this.state.recognitionSupported && canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-circle"
        }, "\xa0") : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-circle"
        }), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-circle active"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-4 text-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            onClick: this.onboardChain.bind(this, "#onboard5"),
            className: "btn btn-light"
        }, "Next ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-chevron-right",
            "aria-hidden": "true"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "popover-arrow"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "onboard5",
            className: "popover onboard-popover"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "close",
            "data-cfw-dismiss": "popover",
            "aria-label": "Close"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            "aria-hidden": "true"
        }, "\xd7")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "popover-header"
        }, "We're here for you!"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "popover-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, "Retake the tour anytime by pressing the paw. Visit ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "/support"
        }, "How to use Corgi"), " for more help."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row flex-between flex-items-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            onClick: this.onboardChain.bind(this, "#onboard4"),
            className: "btn btn-link font-weight-normal ms-n0_5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            "aria-hidden": "true"
        }, "<"), "Previous")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-6 text-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "btn btn-light",
            "data-cfw-dismiss": "popover"
        }, "End")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "popover-arrow"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "onboarding",
            className: "onboarding",
            "aria-live": "assertive",
            "aria-atomic": "false"
        }));
    }
}



class $3cb3a35442296e71$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.state = {
            asideExpand: false
        };
    }
    componentDidMount() {
        (0, $364b9cc7d9afdbb5$export$b289503821e8656d)();
        if (this.context.asideOpen) (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#asideButton').CFW_Collapse('show');
        (0, $7dfc83116dbc3695$export$48467d32fd6a02db)("#asideGuideId");
    }
    handleClick() {
        if (this.context.asideOpen) {
            window.speechstream.speechTools.stop();
            window.tracker.trackEvent("Interface", "close sidebar", "");
        } else window.tracker.trackEvent("Interface", "open sidebar", "");
        this.context.toggleAside();
    }
    sidebarHide() {
        this.props.setSidebarOpen(false);
        this.props.setSidebarExpand(false);
        this.props.setSidebarTab(null);
        this.setState({
            asideExpand: false
        });
        return false;
    }
    sidebarOpen(name) {
        var isExpanded = this.state.asideExpand;
        this.sidebarHide();
        if (isExpanded) this.sidebarExpand();
        else this.props.setSidebarOpen(true);
        this.props.setSidebarTab(name);
        return false;
    }
    sidebarExpand() {
        this.props.setSidebarOpen(false);
        this.props.setSidebarExpand(true);
        this.setState({
            asideExpand: true
        });
        return false;
    }
    sidebarCollapse() {
        this.props.setSidebarOpen(true);
        this.props.setSidebarExpand(false);
        this.setState({
            asideExpand: false
        });
        return false;
    }
    sidebarKeyDown(event) {
        const REGEX_KEYS = new RegExp('^Arrow(Up|Down|Left|Right)$');
        if (!REGEX_KEYS.test(event.key)) return;
        event.stopPropagation();
        event.preventDefault();
        const list = event.target.closest('[role="tablist"]');
        const items = list.querySelectorAll('[role="tab"]');
        const itemActive = list.querySelector('[aria-selected="true"]');
        const doIncrement = event.key === 'ArrowRight' || event.key === 'ArrowDown';
        const nextTab = this.getNextActiveElement([
            ...items
        ], itemActive, doIncrement, false);
        nextTab.click();
        nextTab.focus();
    }
    getNextActiveElement(list, activeElement, doIncrement, allowLoop, allowStartEnd) {
        var index = list.indexOf(activeElement);
        var listLength = list.length;
        if (typeof allowLoop === 'undefined') allowLoop = false;
        if (typeof allowStartEnd === 'undefined') allowStartEnd = false;
        // If currently actve element does not exist in the list
        // return an element depending on the direction and if starting at the end is allowed
        if (index === -1) return list[!doIncrement && allowStartEnd ? listLength - 1 : 0];
        index += doIncrement ? 1 : -1;
        if (allowLoop) index = (index + listLength) % listLength;
        return list[Math.max(0, Math.min(index, listLength - 1))];
    }
    render() {
        const doc = {
            title: this.context.fileName,
            section: this.context.fileSection,
            type: this.context.fileType,
            id: this.context.fileId,
            editing: false
        };
        const content = "comparison" === doc.type ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $7dcc312e8f17de56$export$2e2bcd8739ae039), {
            doc: doc,
            editing: false,
            data: this.props.data,
            inCompleteStep: false
        }) : "cause-effect" === doc.type ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $f3232c19cf166e20$export$2e2bcd8739ae039), {
            doc: doc,
            editing: false,
            data: this.props.data,
            inCompleteStep: false
        }) : "question-exp" === doc.type ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $28deb6bab6448c06$export$2e2bcd8739ae039), {
            doc: doc,
            editing: false,
            data: this.props.data,
            inCompleteStep: false
        }) : "cera" === doc.type ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $24aeae23f2f5fcfb$export$2e2bcd8739ae039), {
            doc: doc,
            editing: false,
            data: this.props.data,
            inCompleteStep: false
        }) : null;
        let section = this.props.section;
        let instructionTab = this.props.instructionTab;
        let organizerTab = this.props.organizerTab;
        let isOpen = this.props.organizerTab || this.props.instructionTab;
        let instruction = "instructions/" + section;
        let showInstruction = true;
        if ("print" === section || "complete" === section || "create-share" === section) showInstruction = false;
        const isTeacher = this.context.currentUser.role === 'teacher';
        const canEdit = this.context.canEdit;
        let disableInstructionBtn = !this.props.hasInstruction && !(isTeacher && canEdit);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("aside", {
            className: "content-sidebar col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", {
            className: "nav nav-tabs",
            role: "tablist"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "nav-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            className: `nav-link ${instructionTab ? 'active' : ''}`,
            id: "sidebarTabInstruction",
            onClick: ()=>this.sidebarOpen('Instruction'),
            onKeyDown: (event)=>this.sidebarKeyDown(event),
            role: "tab",
            "aria-selected": `${instructionTab ? 'true' : 'false'}`,
            tabIndex: `${isOpen && !instructionTab ? '-1' : '0'}`,
            "aria-controls": "sidebarPanelInstruction"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-fw fa-chalkboard-user nav-link-icon",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "nav-link-txt"
        }, "Instruction"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "nav-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            className: `nav-link ${organizerTab ? 'active' : ''}`,
            id: "sidebarTabOrganizer",
            onClick: ()=>this.sidebarOpen('Organizer'),
            onKeyDown: (event)=>this.sidebarKeyDown(event),
            role: "tab",
            "aria-selected": `${organizerTab ? 'true' : 'false'}`,
            tabIndex: `${isOpen && !organizerTab ? '-1' : '0'}`,
            "aria-controls": "sidebarPanelOrganizer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-fw fa-table nav-link-icon",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "nav-link-txt"
        }, "Organizer")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "contentSidebarPanel",
            className: "content-sidebar-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "content-sidebar-action"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            className: "btn btn-link",
            onClick: ()=>this.sidebarHide()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-arrow-left me-0_25",
            "aria-hidden": "true"
        }), "Hide", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "sidebar")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            id: "sidebarActionExpand",
            className: "btn btn-link",
            onClick: ()=>this.sidebarExpand()
        }, "Expand", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "sidebar"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-angles-right ms-0_25",
            "aria-hidden": "true"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            id: "sidebarActionCollapse",
            className: "btn btn-link",
            onClick: ()=>this.sidebarCollapse()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-angles-left me-0_25",
            "aria-hidden": "true"
        }), "Collapse", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "sidebar"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sidebarPanelInstruction",
            className: `content-sidebar-panel ${instructionTab ? 'in' : ''}`,
            role: "tabpanel",
            tabIndex: "0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "content-sidebar-inner"
        }, showInstruction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $88346cb943f9fb99$export$2e2bcd8739ae039), {
            key: instruction,
            identifier: instruction
        }) : null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sidebarPanelOrganizer",
            className: `content-sidebar-panel ${organizerTab ? 'in' : ''}`,
            role: "tabpanel",
            tabIndex: "0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "content-sidebar-inner"
        }, content))));
    }
}



var $6wXVr = parcelRequire("6wXVr");

var $6wXVr = parcelRequire("6wXVr");






var $0262580dba0432ba$exports = {};
$0262580dba0432ba$exports = $parcel$resolve("3v8yC");


const $227d7992b9b4512c$var$similarHeader = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
    id: "step4-5",
    className: "h2"
}, "Similar Characteristics & Categories");
const $227d7992b9b4512c$var$dissimilarHeader = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
    id: "step6-7",
    className: "h2"
}, "Different Characteristics & Categories");
const $227d7992b9b4512c$var$complete = (0, $198066ba87364cec$export$2e2bcd8739ae039).comparison.sections[(0, $198066ba87364cec$export$2e2bcd8739ae039).comparison.sections.length - 1];
const $227d7992b9b4512c$export$db7796b9f3470f90 = (doc)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
        className: "h1 text-center"
    }, "Snapshot"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "h2"
    }, "Essential Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "essentialquestion",
        className: "col"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "h2"
    }, "Summary"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "summary",
        className: "col"
    })))));
};
const $227d7992b9b4512c$export$538da33b76847511 = (doc, characteristicsData)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section section-border-top-dashed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
        className: "h1 text-center"
    }, "Comparison Process")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "h2"
    }, "Concepts & Overall Concept"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "grouping grouping-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "grouping-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h4", {
        className: "h3 grouping-item-title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "concept1",
        className: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "description1",
        className: "col"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "grouping-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h4", {
        className: "h3 grouping-item-title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "concept2",
        className: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "description2",
        className: "col"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket bracket-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-arrow-vertical"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-bar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-arrow"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-bar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-end"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket bracket-print"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
        className: "img-fluid",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($0262580dba0432ba$exports))),
        width: "274",
        height: "66",
        alt: "pairing bracket image",
        "aria-hidden": "true"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "grouping grouping-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h4", {
        className: "h3 grouping-title"
    }, "Overall Concept"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "grouping-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "overall",
        className: "col"
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "h2"
    }, "Key Terms"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b230fd9af7e1399f$export$2e2bcd8739ae039), {
        doc: doc,
        editing: false,
        printing: true,
        secondary: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $7c272f631773d5f7$export$2e2bcd8739ae039), {
        editing: false,
        showBoth: true,
        showCategory: true,
        showLabel: false,
        header: $227d7992b9b4512c$var$similarHeader,
        doc: doc,
        section: $227d7992b9b4512c$var$complete,
        data: characteristicsData
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $58d7ead67a01a33a$export$2e2bcd8739ae039), {
        editing: false,
        showBoth: true,
        showCategory: true,
        showLabel: false,
        header: $227d7992b9b4512c$var$dissimilarHeader,
        doc: doc,
        section: $227d7992b9b4512c$var$complete,
        data: characteristicsData
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "h2"
    }, "Extensions"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "extensions",
        className: "col"
    }))));
};
class $227d7992b9b4512c$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.getRef = this.getRef.bind(this);
        this.dbRef1 = null;
        this.headless1 = null;
        this.dbRef2 = null;
        this.headless2 = null;
        this.state = {
            concept1: "",
            concept2: ""
        };
    }
    componentDidMount() {
        this.dbRef1 = this.getRef("concept1");
        this.callback1 = this.dbRef1.on('value', ()=>{
            if (null === this.headless1) this.headless1 = new window.Firepad.Headless(this.dbRef1);
            this.headless1.getText((text)=>{
                if (this.state.concept1 !== text) this.setState({
                    concept1: text
                });
            });
        });
        this.dbRef2 = this.getRef("concept2");
        this.callback2 = this.dbRef2.on('value', ()=>{
            if (null === this.headless2) this.headless2 = new window.Firepad.Headless(this.dbRef2);
            this.headless2.getText((text)=>{
                if (this.state.concept2 !== text) this.setState({
                    concept2: text
                });
            });
        });
    }
    componentWillUnmount() {
        if (this.headless1) {
            this.headless1.dispose();
            this.headless1 = null;
        }
        if (this.callback1) {
            this.dbRef1.off('value', this.callback1);
            this.callback1 = null;
        }
        if (this.headless2) {
            this.headless2.dispose();
            this.headless2 = null;
        }
        if (this.callback2) {
            this.dbRef2.off('value', this.callback2);
            this.callback2 = null;
        }
    }
    getRef(identifier) {
        let path = this.context.fileType + "/" + this.context.fileId + "/" + identifier;
        return window.firebase.database().ref(path);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h1", {
            className: "h3"
        }, this.state.concept1, " vs ", this.state.concept2));
    }
}



var $6wXVr = parcelRequire("6wXVr");







const $f3bebf7fd877e8a2$export$2cab33a2852e2ade = (doc)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h1", {
        className: "text-center"
    }, "Snapshot")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "h2"
    }, "Essential Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "question",
        className: "col"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "h2"
    }, "Summary"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "answer",
        className: "col"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "h2"
    }, "Extensions"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "extensions",
        className: "col"
    }))));
};
const $f3bebf7fd877e8a2$export$33072de14fdc16c6 = (doc)=>{
    const routineText = (0, $198066ba87364cec$export$2e2bcd8739ae039)[doc.type];
    const section = routineText.cause;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section section-border-top-dashed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
        className: "h1 text-center"
    }, "Cause & Effect Process")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "h2"
    }, "Key Terms"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b230fd9af7e1399f$export$2e2bcd8739ae039), {
        doc: doc,
        editing: false,
        printing: true,
        secondary: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "h2"
    }, "Causes and Connections of the Main Event or Idea"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $350b7e542abac766$export$2e2bcd8739ae039), {
        doc: doc,
        section: section,
        editing: false,
        noImage: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $c0e31515b414b5e0$export$2e2bcd8739ae039), {
        identifier: "causes-event/connector",
        className: "box connector box-autofill"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-arrow-vertical"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "grouping grouping-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "h2 grouping-title"
    }, "Main Event or Idea"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "grouping-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a79b556df0a54813$export$2e2bcd8739ae039), {
        doc: doc,
        section: routineText.event,
        editing: false,
        noImage: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-arrow-vertical"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $c0e31515b414b5e0$export$2e2bcd8739ae039), {
        identifier: "event-effects/connector",
        className: "box connector bg-autofill"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fe63405f1ce595c9$export$2e2bcd8739ae039), {
        doc: doc,
        section: routineText.effect,
        editing: false,
        noImage: true,
        printing: true
    })));
};



var $6wXVr = parcelRequire("6wXVr");




const $558525861a8cc459$export$bba982c19f6738b0 = (doc)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h1", {
        className: "h3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "topic"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
        className: "h1 text-center"
    }, "Snapshot")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "h2"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate("question-exp.essentialquestion.title")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "essentialquestion"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "h2"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate("question-exp.essentialquestionresponse.title")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "essentialquestionresponse"
    }))));
};
const $558525861a8cc459$export$d56d431d6f8ab58c = (doc)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section section-border-top-dashed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
        className: "h1 text-center"
    }, "Question Exploration Process")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "h2"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate("question-exp.terms.label")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b230fd9af7e1399f$export$2e2bcd8739ae039), {
        doc: doc,
        editing: false,
        printing: true,
        secondary: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "h2"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate("question-exp.relatedquestion.toptitle")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row d-sm-down-none",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "col-md-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).div, {
        text: {
            key: "question-exp.relatedquestion.title"
        },
        className: "h3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "col-md-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).div, {
        text: {
            key: "question-exp.relatedquestionresponse.title"
        },
        className: "h3"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $015518484befd1f6$export$2e2bcd8739ae039), {
        doc: doc,
        identifier: "relatedquestion",
        haveResponse: true,
        editing: false,
        print: true,
        canBeEmpty: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "h2"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate("question-exp.contextresponse.title")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "contextresponse",
        className: "col"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "h2"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate("question-exp.extensions.title")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "extensions",
        className: "col"
    }))));
};



var $6wXVr = parcelRequire("6wXVr");




const $56498632ee49f9a6$export$77eb13ace475c998 = (doc)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h1", {
        className: "h3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "topic",
        className: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
        className: "h1 text-center"
    }, "Snapshot")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section print-nobreak"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "h2"
    }, "Claim"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "claim",
        className: ""
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section print-nobreak"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "h2"
    }, "Reasoning"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $c0e31515b414b5e0$export$2e2bcd8739ae039), {
        identifier: "reasoningtype",
        className: "box bg-autofill"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "reasoningnote",
        className: ""
    }))));
};
const $56498632ee49f9a6$export$82b51061fb4dba4d = (doc)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section section-border-top-dashed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
        className: "h1 text-center"
    }, "Claim, Evidence, Reasoning Process")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section print-nobreak"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "h2"
    }, "Essential Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "essentialquestion",
        className: ""
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section print-nobreak"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "col-sm-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "h2"
    }, "Claim"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "claim",
        className: ""
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "col-sm-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "h2"
    }, "Backround"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "claimcontext",
        className: ""
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section print-nobreak"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "h2"
    }, "Key Terms"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b230fd9af7e1399f$export$2e2bcd8739ae039), {
        doc: doc,
        editing: false,
        printing: true,
        secondary: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section print-nobreak"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "h2"
    }, "Supporting Evidence"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $78739bc7dc9cfb57$export$2e2bcd8739ae039), {
        doc: doc,
        editing: false,
        identifier: "evidencesupport",
        canBeEmpty: false,
        print: true,
        hLevel: 4,
        hClassName: "h3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section print-nobreak"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "h2"
    }, "Opposing Evidence"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $78739bc7dc9cfb57$export$2e2bcd8739ae039), {
        doc: doc,
        editing: false,
        identifier: "evidenceopposes",
        canBeEmpty: false,
        print: true,
        hLevel: 4,
        hClassName: "h3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "section print-nobreak"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
        className: "h2"
    }, "Reasoning"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $c0e31515b414b5e0$export$2e2bcd8739ae039), {
        identifier: "reasoningtype",
        className: "box bg-autofill"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "box bg-autofill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "reasoningnote",
        className: "col"
    }))));
};





class $4697c200a6a70c90$export$2e2bcd8739ae039 extends (0, $33c53f2912681500$export$2e2bcd8739ae039) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    componentDidMount() {
        (0, $2c839b9f78572b9b$export$2e2bcd8739ae039)();
    }
    render() {
        const doc = this.props.doc;
        const user = this.context.currentUser;
        let displayName = user !== null ? user.displayName : "";
        const content = "comparison" === doc.type ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "h1"
        }, displayName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $227d7992b9b4512c$export$2e2bcd8739ae039), null), (0, $227d7992b9b4512c$export$db7796b9f3470f90)(doc), (0, $227d7992b9b4512c$export$538da33b76847511)(doc, this.props.data)) : "cause-effect" === doc.type ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "h1"
        }, displayName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "h3"
        }, this.context.fileName), (0, $f3bebf7fd877e8a2$export$2cab33a2852e2ade)(doc), (0, $f3bebf7fd877e8a2$export$33072de14fdc16c6)(doc)) : "question-exp" === doc.type ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "h1"
        }, displayName), (0, $558525861a8cc459$export$bba982c19f6738b0)(doc), (0, $558525861a8cc459$export$d56d431d6f8ab58c)(doc)) : "cera" === doc.type ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "h1"
        }, displayName), (0, $56498632ee49f9a6$export$77eb13ace475c998)(doc), (0, $56498632ee49f9a6$export$82b51061fb4dba4d)(doc)) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("main", {
            id: "main_container",
            className: "main"
        }, content);
    }
}



function $88834a74988764c3$export$1fda4540c4ae66e3(context, path) {
    return new Promise((resolve)=>{
        let firepadHeadless = new window.Firepad.Headless($88834a74988764c3$export$f0c653cfd7dea798(context, path));
        firepadHeadless.getText((text)=>{
            firepadHeadless.dispose();
            resolve(text);
        });
    });
}
function $88834a74988764c3$export$f0c653cfd7dea798(context, identifier) {
    let path = context.fileType + "/" + context.fileId + "/" + identifier;
    return window.firebase.database().ref(path);
}





var $6wXVr = parcelRequire("6wXVr");


var $abf3404b78497405$exports = {};
$abf3404b78497405$exports = $parcel$resolve("gxB9R");


var $a4bf360e0f41e297$exports = {};
$a4bf360e0f41e297$exports = $parcel$resolve("8xEjf");


var $eac6d5070a1e648c$exports = {};
$eac6d5070a1e648c$exports = $parcel$resolve("971mb");


var $f0b101fd7316e88c$exports = {};
$f0b101fd7316e88c$exports = $parcel$resolve("7znd4");


var $6f9c8596e6a0245d$exports = {};
$6f9c8596e6a0245d$exports = $parcel$resolve("6PUeY");


const $e903eab575986f51$var$TEACHER_RATING_QUESTIONS = [
    "Corgi is easy for my students to use.",
    "Corgi is easy for me to use.",
    "Corgi helps my students learn.",
    "My students like learning more when they use Corgi."
];
const $e903eab575986f51$var$STUDENT_RATING_QUESTIONS = [
    "Corgi is easy for me to use.",
    "Corgi helps me learn.",
    "I like learning more when I use Corgi."
];
const $e903eab575986f51$var$RATES = [
    'never',
    'sometimes',
    'usually',
    'always',
    'idk'
];
class $e903eab575986f51$export$2e2bcd8739ae039 extends (0, $d8775d5311bbf499$export$2e2bcd8739ae039) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.state = {
            currentStatementNo: 0
        };
    }
    stopReadingModal() {
        window.speechstream.speechTools.stop();
    }
    render() {
        this.statements = this.context.currentUser.role === 'teacher' ? $e903eab575986f51$var$TEACHER_RATING_QUESTIONS : $e903eab575986f51$var$STUDENT_RATING_QUESTIONS;
        let statement = this.statements[this.state.currentStatementNo];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            style: {
                display: "none"
            },
            "data-cfw": "modal",
            "data-cfw-modal-target": "#modalRating"
        }, "Rate Corgi"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "modalRating",
            className: "modal create-modal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-dialog modal-dialog-centered"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            className: "h1 modal-title"
        }, "Tell us how it is going!"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "close",
            "data-cfw-dismiss": "modal",
            "aria-label": "Close",
            onClick: ()=>this.stopReadingModal()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-times",
            "aria-hidden": "true"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, statement), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row rating"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("label", {
            className: "rating-label"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("input", {
            id: "rating-1",
            className: "rating-check",
            type: "radio",
            onClick: ()=>this.selectRate(1, statement),
            name: "rating0",
            value: "1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "rating-img"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($abf3404b78497405$exports))),
            className: "img-fluid",
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "rating-txt"
        }, "Never true"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("label", {
            className: "rating-label"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("input", {
            id: "rating-2",
            className: "rating-check",
            type: "radio",
            onClick: ()=>this.selectRate(2, statement),
            name: "rating0",
            value: "2"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "rating-img"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($a4bf360e0f41e297$exports))),
            className: "img-fluid",
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "rating-txt"
        }, "Sometimes true"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("label", {
            className: "rating-label"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("input", {
            id: "rating-3",
            className: "rating-check",
            type: "radio",
            onClick: ()=>this.selectRate(3, statement),
            name: "rating0",
            value: "3"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "rating-img"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($eac6d5070a1e648c$exports))),
            className: "img-fluid",
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "rating-txt"
        }, "Usually true"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("label", {
            className: "rating-label"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("input", {
            id: "rating-4",
            className: "rating-check",
            type: "radio",
            onClick: ()=>this.selectRate(4, statement),
            name: "rating0",
            value: "4"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "rating-img"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($f0b101fd7316e88c$exports))),
            className: "img-fluid",
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "rating-txt"
        }, "Always true"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("label", {
            className: "rating-label"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("input", {
            id: "rating-5",
            className: "rating-check",
            type: "radio",
            onClick: ()=>this.selectRate(5, statement),
            name: "rating0",
            value: "5"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "rating-img"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($6f9c8596e6a0245d$exports))),
            className: "img-fluid",
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "rating-txt"
        }, "I don\u2019t know")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "d-flex flex-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "btn btn-link",
            onClick: ()=>this.markDontShowAgain()
        }, "Don\u2019t show this again")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "btn btn-link",
            "data-cfw-dismiss": "modal",
            onClick: ()=>this.markShowLater()
        }, "Maybe later"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "btn btn-primary",
            onClick: ()=>this.nextStatement()
        }, "Next", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "pages-next-icon fa fa-chevron-right ms-0_25",
            "aria-hidden": "true"
        })))))))));
    }
    selectRate(rateNumber, statement) {
        window.tracker.trackEvent("Rating", $e903eab575986f51$var$RATES[rateNumber - 1], statement);
        let userRef = window.firebase.database().ref("user/" + this.context.currentUser.uid);
        userRef.update({
            answeredRatingModal: true
        });
    }
    markDontShowAgain() {
        window.tracker.trackEvent("Rating", 'don\'t show again');
        let userRef = window.firebase.database().ref("user/" + this.context.currentUser.uid);
        userRef.update({
            dontShowRatingModalAgain: true
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#modalRating').CFW_Modal("hide");
        this.stopReadingModal();
    }
    markShowLater() {
        window.tracker.trackEvent("Rating", 'later');
        (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#modalRating').CFW_Modal("hide");
        this.stopReadingModal();
    }
    nextStatement() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#modalRating').find('input.rating-check').each((index, element)=>{
            element.checked = false;
        });
        this.stopReadingModal();
        if (this.state.currentStatementNo < this.statements.length - 1) this.setState({
            currentStatementNo: this.state.currentStatementNo + 1
        });
        else {
            this.setState({
                currentStatementNo: 0
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#modalRating').CFW_Modal("hide");
        }
    }
}



var $hObpn = parcelRequire("hObpn");
class $cc8ee9c202478e66$export$2e2bcd8739ae039 extends (0, $33c53f2912681500$export$2e2bcd8739ae039) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.getMain = this.getMain.bind(this);
        this.props.loadDocMethod();
        this.focused = this.focused.bind(this);
        this.content = null; // specify content in parent
        this.section = props.doc.section;
        this.state = {
            firstUseTourGuide: true,
            sidebarOpen: false,
            sidebarExpand: false,
            instructionTab: false,
            organizerTab: false,
            hasInstruction: false
        };
        this.hasInstructionText = false;
        this.hasInstructionImage = false;
        this.hasInstructionFileName = false;
        this._isMounted = false;
        if (this.props.doc.section !== "print") document.body.classList.add("has-bottomnav");
    }
    componentDidMount() {
        super.componentDidMount();
        this._isMounted = true;
        if (this.context.copyPending && this.context.copyDone) console.log("Should reset state");
        var section = this.props.doc.section;
        // Open TourGuide if user has not already seen it.
        // Disabled for now since it needs updating. CORGI-1108
        // if("toc" !== section && "print" !== section && "complete" !== section && "create-share" !==  section){
        //     var userNode = "user/" + this.context.currentUser.uid ;
        //     let userRef = window.firebase.database().ref(userNode);
        //     let self = this;
        //     userRef.once('value', function(snapshot) {
        //         if(snapshot.exists()){
        //             if(null !== snapshot.val().viewTourGuide && undefined !== snapshot.val().viewTourGuide)
        //                 self.setState({firstUseTourGuide:false});
        //             if(self.state.firstUseTourGuide) openTourGuide(self.context.currentUser.uid);
        //         }
        //     });
        // }
        this.onChangeSection(section);
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    componentDidUpdate() {
        super.componentDidUpdate();
        if ($cc8ee9c202478e66$var$isCompletedSection(this.props.doc.section) && this.context.canEdit) {
            let userRef = window.firebase.database().ref("user/" + this.context.currentUser.uid);
            userRef.once('value', function(snapshot) {
                if (snapshot.exists()) {
                    const val = snapshot.val();
                    if (true !== val.dontShowRatingModalAgain && true !== val.answeredRatingModal) (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#modalRating').CFW_Modal("show");
                }
            });
        }
    }
    focused(section) {
        return !(0, $21f9ebdc444decaf$export$6e22c362a0406a2c)(section) && 'complete' !== section;
    }
    focused1(section) {
        return !(0, $21f9ebdc444decaf$export$6e22c362a0406a2c)(section);
    }
    render() {
        if (!this.context.fileIdLoaded) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", null, "Loading file...");
        const doc = {
            title: this.context.fileName,
            section: this.section,
            type: this.context.fileType,
            id: this.context.fileId,
            editing: this.context.canEdit
        };
        const sections = (0, $198066ba87364cec$export$2e2bcd8739ae039)[doc.type].sections;
        $hObpn(undefined !== sections && 0 < sections.length);
        this.toc = this.focused(doc.section) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: sections[0].toc,
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6e7539b03a30b35c$export$2e2bcd8739ae039), {
            doc: doc,
            steps: sections
        })) : "";
        return this.getMain(this.props.content); // specify content in parent
    }
    setSidebarOpen = (flg)=>{
        this.setState({
            sidebarOpen: flg
        });
    };
    setSidebarExpand = (flg)=>{
        this.setState({
            sidebarExpand: flg
        });
    };
    setSidebarTab = (tabName)=>{
        this.setState({
            instructionTab: tabName === "Instruction",
            organizerTab: tabName === "Organizer"
        });
    };
    hasContent(text) {
        // Return a true value if text is not null and contains something other than whitespace.
        return undefined !== text && null !== text && text.trim();
    }
    onChangeSection = (section)=>{
        this.hasInstructionText = false;
        this.hasInstructionImage = false;
        this.hasInstructionFileName = false;
        (0, $88834a74988764c3$export$1fda4540c4ae66e3)(this.context, "instructions/" + section).then((instructionContent)=>{
            this.hasInstructionText = this.hasContent(instructionContent) ? true : false;
            this.changeSectionUpdate();
        });
        let dbRef = (0, $88834a74988764c3$export$f0c653cfd7dea798)(this.context, "instructions/" + section);
        dbRef.once("value").then((data)=>{
            let dataVal = data.val();
            this.hasInstructionImage = dataVal && dataVal.image ? this.hasContent(dataVal.image) ? true : false : false;
            this.hasInstructionFileName = dataVal && dataVal.fileName ? this.hasContent(dataVal.fileName) ? true : false : false;
            this.changeSectionUpdate();
        });
    };
    changeSectionUpdate = ()=>{
        if (this.hasInstructionText || this.hasInstructionImage || this.hasInstructionFileName) {
            this.setState({
                sidebarExpand: false,
                sidebarOpen: true,
                instructionTab: true,
                organizerTab: false,
                hasInstruction: true
            });
            // Due to the sideBar status changing from closed to be open
            // The input text will be changed from display: none to display: block
            // we need to invoke the CodeMirror.refresh() function to make the text content appear and display properly
            const codeMirrorInputText = document.getElementById("sidebarPanelInstruction").querySelector('.CodeMirror');
            if (codeMirrorInputText) codeMirrorInputText.CodeMirror.refresh();
        } else if (this._isMounted) this.setState({
            sidebarExpand: false,
            hasInstruction: false
        });
    };
    getMain(content) {
        let doc = this.props.doc;
        doc.editing = true;
        const titleLabel = (0, $198066ba87364cec$export$2e2bcd8739ae039)[doc.type].title; // ReactDOMServer.renderToString(<GetText type={doc.type} item={"title"}/>);
        const title = this.focused1(doc.section) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $2f05acbc3da55feb$export$2e2bcd8739ae039), {
            id: "title",
            label: titleLabel,
            placeholder: "Untitled " + titleLabel,
            renameDocMethod: this.props.renameDocMethod
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h1", {
            className: "h2"
        }, titleLabel);
        const info = this.focused(doc.section) ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $af02febc6c5650c1$export$2e2bcd8739ae039), {
            video: "comparison-tour",
            socExample: "CT_Soc.pdf",
            sciExample: "CT_Sci.pdf",
            doc: doc
        });
        const sections = (0, $198066ba87364cec$export$2e2bcd8739ae039)[doc.type].sections;
        const last = sections.length - 2;
        const nav = //<React.Fragment>
        // {'toc' === doc.section
        // ?     <ForwardLink doc={doc}/>
        // :     null}
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($cc8ee9c202478e66$var$Nav, {
            doc: doc,
            steps: sections.slice(1, last),
            onChangeSection: this.onChangeSection
        });
        //</React.Fragment>
        if (!content && this.toc) content = this.toc;
        return 'print' === doc.section ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "page-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "content row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "content-main col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "content-main-inner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $508248f6f0651524$export$2e2bcd8739ae039), {
            name: (0, $198066ba87364cec$export$2e2bcd8739ae039)[doc.type].title
        }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $4697c200a6a70c90$export$2e2bcd8739ae039), {
            doc: doc,
            section: "print",
            data: this.props.data
        }))))), nav) : this.focused(doc.section) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "page-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "content",
            className: `content row has-sidebar ${this.state.sidebarOpen ? 'has-sidebar-open' : ''} ${this.state.sidebarExpand ? 'has-sidebar-expand' : ''}`
        }, "create-share" !== doc.section ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $3cb3a35442296e71$export$2e2bcd8739ae039), {
            instructionTab: this.state.instructionTab,
            organizerTab: this.state.organizerTab,
            setSidebarTab: this.setSidebarTab,
            setSidebarOpen: this.setSidebarOpen,
            setSidebarExpand: this.setSidebarExpand,
            section: doc.section,
            data: this.props.data,
            hasInstruction: this.state.hasInstruction
        }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "content-main col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "content-main-inner"
        }, info, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $508248f6f0651524$export$2e2bcd8739ae039), {
            name: (0, $198066ba87364cec$export$2e2bcd8739ae039)[doc.type].title
        }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("main", {
            id: "main_container",
            className: "main"
        }, content)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b230fd9af7e1399f$export$2e2bcd8739ae039), {
            editing: doc.editing
        })), nav) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "page-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "content row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "content-main col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "content-main-inner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $508248f6f0651524$export$2e2bcd8739ae039), {
            name: (0, $198066ba87364cec$export$2e2bcd8739ae039)[doc.type].title
        }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $4ba48d123e66d691$export$2e2bcd8739ae039), {
            section: "complete",
            data: this.props.data
        }, nav))))));
    }
}
class $cc8ee9c202478e66$var$Nav extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.trackEvent = this.trackEvent.bind(this);
    }
    // `step` are the step number except for the case of `toc`, `create-share` and `review`
    trackEvent(step) {
        window.speechstream.speechTools.stop();
        window.tracker.trackEvent("Navigation", "footer link", step);
        if (step === 'toc' || step === 'create-share' || step === 'review') this.props.onChangeSection(step);
        else {
            const sections = (0, $198066ba87364cec$export$2e2bcd8739ae039)[this.props.doc.type].sections;
            const newSection = sections.find((section)=>step === section.stepnum);
            if (newSection) this.props.onChangeSection(newSection.key);
        }
    }
    render() {
        const sections = (0, $198066ba87364cec$export$2e2bcd8739ae039)[this.props.doc.type].sections;
        const current = this.props.doc.section;
        let currentIndex = sections.findIndex((section)=>current === section.key);
        let nextIndex = currentIndex + 1;
        let prevIndex = currentIndex - 1;
        if (nextIndex === sections.length) nextIndex = -1;
        let prevlink = prevIndex >= 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $7a6def086ebe18be$export$2e2bcd8739ae039), {
            section: sections[prevIndex].key,
            className: "page-link",
            onClick: ()=>this.trackEvent(prevIndex)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "pages-prev-icon fa fa-chevron-left",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only-xs-down"
        }, "Previous")) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "page-link disabled",
            "aria-disabled": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "pages-prev-icon fa fa-chevron-left",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only-xs-down"
        }, "Previous"));
        let nextlink = nextIndex >= 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $7a6def086ebe18be$export$2e2bcd8739ae039), {
            section: sections[nextIndex].key,
            className: "page-link",
            onClick: ()=>this.trackEvent(nextIndex)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only-xs-down"
        }, "Next"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "pages-next-icon fa fa-chevron-right",
            "aria-hidden": "true"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "page-link disabled",
            "aria-disabled": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only-xs-down"
        }, "Next"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "pages-next-icon fa fa-chevron-right",
            "aria-hidden": "true"
        }));
        const toc_class = current === 'toc' ? " active" : "";
        const complete_class = current === 'complete' ? " active" : "";
        const create_share_class = current === 'create-share' ? " active" : "";
        // Temporarily turned off: CORGI-1108
        const showTourGuide = false;
        //const showTourGuide = (current !== 'toc' && current !== 'complete' && current !== 'create-share');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("nav", {
            className: "footer-pages is-fixed",
            "aria-label": "pages"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "pagination pagination-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "pages-prev page-item"
        }, prevlink)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", {
            className: "pages-num pagination pagination-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "pages-toc page-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $7a6def086ebe18be$export$2e2bcd8739ae039), {
            className: "page-link" + toc_class,
            section: 'toc',
            onClick: ()=>this.trackEvent("toc")
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-list-ol",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Table of Content"))), this.props.steps.map((step, i)=>{
            const key = step.key;
            if (key === current) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
                key: key,
                className: "pages-active page-item"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
                className: "page-link active",
                "aria-current": "page"
            }, i + 1));
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
                key: key,
                className: "page-item"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $7a6def086ebe18be$export$2e2bcd8739ae039), {
                className: "page-link",
                section: key,
                onClick: ()=>this.trackEvent(i + 1)
            }, i + 1));
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "pages-bpv page-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $7a6def086ebe18be$export$2e2bcd8739ae039), {
            className: "page-link" + complete_class,
            section: 'complete',
            onClick: ()=>this.trackEvent("review")
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-table",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, sections[sections.length - 2].title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "page-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $7a6def086ebe18be$export$2e2bcd8739ae039), {
            className: "page-link" + create_share_class,
            section: 'create-share',
            onClick: ()=>this.trackEvent("create-share")
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-file-export",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Create & Share")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "pagination pagination-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "pages-next page-item"
        }, nextlink)), showTourGuide ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "end-tour-guide",
            "data-cfw": "popover",
            "data-cfw-popover-target": "#onboard5",
            "data-cfw-popover-placement": "top"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "footer-pages-tour"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "btn btn-round btn-tts pages-onboard d-sm-down-none",
            "data-cfw": "popover",
            "data-cfw-popover-target": "#onboard0",
            title: "Start Corgi Tools Tour"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-paw fs-2xlarge",
            "aria-hidden": "true"
        })))) : null), $cc8ee9c202478e66$var$isCompletedSection(current) && this.context.canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e903eab575986f51$export$2e2bcd8739ae039), null)) : null);
    }
}
class $cc8ee9c202478e66$var$ForwardLink extends (0, $6wXVr.Component) {
    constructor(props){
        super(props);
        this.trackEvent = this.trackEvent.bind(this);
    }
    render() {
        const sections = (0, $198066ba87364cec$export$2e2bcd8739ae039)[this.props.doc.type].sections;
        const current = this.props.doc.section;
        const currentIndex = sections.findIndex((section)=>current === section.key);
        const nextIndex = currentIndex + 1;
        const section = sections[nextIndex];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "text-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $7a6def086ebe18be$export$2e2bcd8739ae039), {
            section: section.key,
            className: "btn btn-primary",
            onClick: ()=>this.trackEvent()
        }, "Get Started", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "ms-0_5 fa fa-arrow-right",
            "aria-hidden": "true"
        })));
    }
    trackEvent() {
        window.tracker.trackEvent("Navigation", "get started", "");
    }
}
function $cc8ee9c202478e66$var$isCompletedSection(section) {
    return "complete" === section || "review" === section;
}







var $6wXVr = parcelRequire("6wXVr");




class $323c988398378e89$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(){
        super();
        this.identifier = "extensions";
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b5ffa3f136ed406e$export$2e2bcd8739ae039), {
            section: this.props.section
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Summary"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "answer",
            className: "box bg-autofill"
        }), this.context.canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            ...this.props,
            inputType: "text-area",
            identifier: this.identifier,
            addImage: true,
            singleLine: false
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.identifier,
            className: "grouping-text"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.identifier + "/image",
            className: "grouping-img"
        })))));
    }
}








var $6wXVr = parcelRequire("6wXVr");



var $6wXVr = parcelRequire("6wXVr");



var $9bfae0a1a4fe450e$var$dist = {};
var $9bfae0a1a4fe450e$var$hasRequiredDist;
function $9bfae0a1a4fe450e$var$requireDist() {
    if ($9bfae0a1a4fe450e$var$hasRequiredDist) return $9bfae0a1a4fe450e$var$dist;
    $9bfae0a1a4fe450e$var$hasRequiredDist = 1;
    Object.defineProperty($9bfae0a1a4fe450e$var$dist, "__esModule", {
        value: true
    });
    $9bfae0a1a4fe450e$var$dist.parse = parse;
    $9bfae0a1a4fe450e$var$dist.serialize = serialize;
    /**
	 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
	 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
	 * which has been replaced by the token definition in RFC 7230 appendix B.
	 *
	 * cookie-name       = token
	 * token             = 1*tchar
	 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
	 *                     "*" / "+" / "-" / "." / "^" / "_" /
	 *                     "`" / "|" / "~" / DIGIT / ALPHA
	 *
	 * Note: Allowing more characters - https://github.com/jshttp/cookie/issues/191
	 * Allow same range as cookie value, except `=`, which delimits end of name.
	 */ const cookieNameRegExp = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/;
    /**
	 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
	 *
	 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
	 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
	 *                     ; US-ASCII characters excluding CTLs,
	 *                     ; whitespace DQUOTE, comma, semicolon,
	 *                     ; and backslash
	 *
	 * Allowing more characters: https://github.com/jshttp/cookie/issues/191
	 * Comma, backslash, and DQUOTE are not part of the parsing algorithm.
	 */ const cookieValueRegExp = /^[\u0021-\u003A\u003C-\u007E]*$/;
    /**
	 * RegExp to match domain-value in RFC 6265 sec 4.1.1
	 *
	 * domain-value      = <subdomain>
	 *                     ; defined in [RFC1034], Section 3.5, as
	 *                     ; enhanced by [RFC1123], Section 2.1
	 * <subdomain>       = <label> | <subdomain> "." <label>
	 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
	 *                     Labels must be 63 characters or less.
	 *                     'let-dig' not 'letter' in the first char, per RFC1123
	 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
	 * <let-dig-hyp>     = <let-dig> | "-"
	 * <let-dig>         = <letter> | <digit>
	 * <letter>          = any one of the 52 alphabetic characters A through Z in
	 *                     upper case and a through z in lower case
	 * <digit>           = any one of the ten digits 0 through 9
	 *
	 * Keep support for leading dot: https://github.com/jshttp/cookie/issues/173
	 *
	 * > (Note that a leading %x2E ("."), if present, is ignored even though that
	 * character is not permitted, but a trailing %x2E ("."), if present, will
	 * cause the user agent to ignore the attribute.)
	 */ const domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
    /**
	 * RegExp to match path-value in RFC 6265 sec 4.1.1
	 *
	 * path-value        = <any CHAR except CTLs or ";">
	 * CHAR              = %x01-7F
	 *                     ; defined in RFC 5234 appendix B.1
	 */ const pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
    const __toString = Object.prototype.toString;
    const NullObject = /* @__PURE__ */ (()=>{
        const C = function() {};
        C.prototype = Object.create(null);
        return C;
    })();
    /**
	 * Parse a cookie header.
	 *
	 * Parse the given cookie header string into an object
	 * The object has the various cookies as keys(names) => values
	 */ function parse(str, options) {
        const obj = new NullObject();
        const len = str.length;
        // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
        if (len < 2) return obj;
        const dec = options?.decode || decode;
        let index = 0;
        do {
            const eqIdx = str.indexOf("=", index);
            if (eqIdx === -1) break; // No more cookie pairs.
            const colonIdx = str.indexOf(";", index);
            const endIdx = colonIdx === -1 ? len : colonIdx;
            if (eqIdx > endIdx) {
                // backtrack on prior semicolon
                index = str.lastIndexOf(";", eqIdx - 1) + 1;
                continue;
            }
            const keyStartIdx = startIndex(str, index, eqIdx);
            const keyEndIdx = endIndex(str, eqIdx, keyStartIdx);
            const key = str.slice(keyStartIdx, keyEndIdx);
            // only assign once
            if (obj[key] === undefined) {
                let valStartIdx = startIndex(str, eqIdx + 1, endIdx);
                let valEndIdx = endIndex(str, endIdx, valStartIdx);
                const value = dec(str.slice(valStartIdx, valEndIdx));
                obj[key] = value;
            }
            index = endIdx + 1;
        }while (index < len);
        return obj;
    }
    function startIndex(str, index, max) {
        do {
            const code = str.charCodeAt(index);
            if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index;
        }while (++index < max);
        return max;
    }
    function endIndex(str, index, min) {
        while(index > min){
            const code = str.charCodeAt(--index);
            if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index + 1;
        }
        return min;
    }
    /**
	 * Serialize data into a cookie header.
	 *
	 * Serialize a name value pair into a cookie string suitable for
	 * http headers. An optional options object specifies cookie parameters.
	 *
	 * serialize('foo', 'bar', { httpOnly: true })
	 *   => "foo=bar; httpOnly"
	 */ function serialize(name, val, options) {
        const enc = options?.encode || encodeURIComponent;
        if (!cookieNameRegExp.test(name)) throw new TypeError(`argument name is invalid: ${name}`);
        const value = enc(val);
        if (!cookieValueRegExp.test(value)) throw new TypeError(`argument val is invalid: ${val}`);
        let str = name + "=" + value;
        if (!options) return str;
        if (options.maxAge !== undefined) {
            if (!Number.isInteger(options.maxAge)) throw new TypeError(`option maxAge is invalid: ${options.maxAge}`);
            str += "; Max-Age=" + options.maxAge;
        }
        if (options.domain) {
            if (!domainValueRegExp.test(options.domain)) throw new TypeError(`option domain is invalid: ${options.domain}`);
            str += "; Domain=" + options.domain;
        }
        if (options.path) {
            if (!pathValueRegExp.test(options.path)) throw new TypeError(`option path is invalid: ${options.path}`);
            str += "; Path=" + options.path;
        }
        if (options.expires) {
            if (!isDate(options.expires) || !Number.isFinite(options.expires.valueOf())) throw new TypeError(`option expires is invalid: ${options.expires}`);
            str += "; Expires=" + options.expires.toUTCString();
        }
        if (options.httpOnly) str += "; HttpOnly";
        if (options.secure) str += "; Secure";
        if (options.partitioned) str += "; Partitioned";
        if (options.priority) {
            const priority = typeof options.priority === "string" ? options.priority.toLowerCase() : undefined;
            switch(priority){
                case "low":
                    str += "; Priority=Low";
                    break;
                case "medium":
                    str += "; Priority=Medium";
                    break;
                case "high":
                    str += "; Priority=High";
                    break;
                default:
                    throw new TypeError(`option priority is invalid: ${options.priority}`);
            }
        }
        if (options.sameSite) {
            const sameSite = typeof options.sameSite === "string" ? options.sameSite.toLowerCase() : options.sameSite;
            switch(sameSite){
                case true:
                case "strict":
                    str += "; SameSite=Strict";
                    break;
                case "lax":
                    str += "; SameSite=Lax";
                    break;
                case "none":
                    str += "; SameSite=None";
                    break;
                default:
                    throw new TypeError(`option sameSite is invalid: ${options.sameSite}`);
            }
        }
        return str;
    }
    /**
	 * URL-decode string value. Optimized to skip native call when no %.
	 */ function decode(str) {
        if (str.indexOf("%") === -1) return str;
        try {
            return decodeURIComponent(str);
        } catch (e) {
            return str;
        }
    }
    /**
	 * Determine if value is a Date.
	 */ function isDate(val) {
        return __toString.call(val) === "[object Date]";
    }
    return $9bfae0a1a4fe450e$var$dist;
}
var $9bfae0a1a4fe450e$var$distExports = $9bfae0a1a4fe450e$var$requireDist();
function $9bfae0a1a4fe450e$var$hasDocumentCookie() {
    const testingValue = typeof $parcel$global === 'undefined' ? undefined : $parcel$global.TEST_HAS_DOCUMENT_COOKIE;
    if (typeof testingValue === 'boolean') return testingValue;
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function $9bfae0a1a4fe450e$var$parseCookies(cookies) {
    if (typeof cookies === 'string') return $9bfae0a1a4fe450e$var$distExports.parse(cookies);
    else if (typeof cookies === 'object' && cookies !== null) return cookies;
    else return {};
}
function $9bfae0a1a4fe450e$var$readCookie(value, options = {}) {
    const cleanValue = $9bfae0a1a4fe450e$var$cleanupCookieValue(value);
    if (!options.doNotParse) try {
        return JSON.parse(cleanValue);
    } catch (e) {
    // At least we tried
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function $9bfae0a1a4fe450e$var$cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') return value.substr(2);
    return value;
}
class $9bfae0a1a4fe450e$export$2e2bcd8739ae039 {
    constructor(cookies, defaultSetOptions = {}){
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.update = ()=>{
            if (!this.HAS_DOCUMENT_COOKIE) return;
            const previousCookies = this.cookies;
            this.cookies = $9bfae0a1a4fe450e$var$distExports.parse(document.cookie);
            this._checkChanges(previousCookies);
        };
        const domCookies = typeof document === 'undefined' ? '' : document.cookie;
        this.cookies = $9bfae0a1a4fe450e$var$parseCookies(cookies || domCookies);
        this.defaultSetOptions = defaultSetOptions;
        this.HAS_DOCUMENT_COOKIE = $9bfae0a1a4fe450e$var$hasDocumentCookie();
    }
    _emitChange(params) {
        for(let i = 0; i < this.changeListeners.length; ++i)this.changeListeners[i](params);
    }
    _checkChanges(previousCookies) {
        const names = new Set(Object.keys(previousCookies).concat(Object.keys(this.cookies)));
        names.forEach((name)=>{
            if (previousCookies[name] !== this.cookies[name]) this._emitChange({
                name: name,
                value: $9bfae0a1a4fe450e$var$readCookie(this.cookies[name])
            });
        });
    }
    _startPolling() {
        this.pollingInterval = setInterval(this.update, 300);
    }
    _stopPolling() {
        if (this.pollingInterval) clearInterval(this.pollingInterval);
    }
    get(name, options = {}) {
        if (!options.doNotUpdate) this.update();
        return $9bfae0a1a4fe450e$var$readCookie(this.cookies[name], options);
    }
    getAll(options = {}) {
        if (!options.doNotUpdate) this.update();
        const result = {};
        for(let name in this.cookies)result[name] = $9bfae0a1a4fe450e$var$readCookie(this.cookies[name], options);
        return result;
    }
    set(name, value, options) {
        if (options) options = Object.assign(Object.assign({}, this.defaultSetOptions), options);
        else options = this.defaultSetOptions;
        const stringValue = typeof value === 'string' ? value : JSON.stringify(value);
        this.cookies = Object.assign(Object.assign({}, this.cookies), {
            [name]: stringValue
        });
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $9bfae0a1a4fe450e$var$distExports.serialize(name, stringValue, options);
        this._emitChange({
            name: name,
            value: value,
            options: options
        });
    }
    remove(name, options) {
        const finalOptions = options = Object.assign(Object.assign(Object.assign({}, this.defaultSetOptions), options), {
            expires: new Date(1970, 1, 1, 0, 0, 1),
            maxAge: 0
        });
        this.cookies = Object.assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $9bfae0a1a4fe450e$var$distExports.serialize(name, '', finalOptions);
        this._emitChange({
            name: name,
            value: undefined,
            options: options
        });
    }
    addChangeListener(callback) {
        this.changeListeners.push(callback);
        if (this.HAS_DOCUMENT_COOKIE && this.changeListeners.length === 1) {
            if (typeof window === 'object' && 'cookieStore' in window) window.cookieStore.addEventListener('change', this.update);
            else this._startPolling();
        }
    }
    removeChangeListener(callback) {
        const idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) this.changeListeners.splice(idx, 1);
        if (this.HAS_DOCUMENT_COOKIE && this.changeListeners.length === 0) {
            if (typeof window === 'object' && 'cookieStore' in window) window.cookieStore.removeEventListener('change', this.update);
            else this._stopPolling();
        }
    }
    removeAllChangeListeners() {
        while(this.changeListeners.length > 0)this.removeChangeListener(this.changeListeners[0]);
    }
}


// Portions from:
// https://github.com/googleworkspace/md2googleslides
// https://github.com/googleworkspace/md2googleslides/blob/main/src/layout/presentation_helpers.ts
// https://github.com/googleworkspace/md2googleslides/blob/main/src/layout/generic_layout.ts
// Typescript has been removed or converted from source
/**
 * Locates a page by ID
 *
 * @param presentation
 * @param {string} pageId Object ID of page to find
 * @returns {Object} Page or null if not found
 */ function $3e6b71d5149b495c$export$e592b69f6a7a6e8b(presentation, pageId) {
    if (!presentation.slides) return undefined;
    return presentation.slides.find(function(p) {
        return p.objectId === pageId;
    });
}
function $3e6b71d5149b495c$export$a88fcc58b7536171(presentation, pageId, name) {
    const page = $3e6b71d5149b495c$export$e592b69f6a7a6e8b(presentation, pageId);
    if (!page) throw new Error(`Can't find page ${pageId}`);
    const placeholders = [];
    if (!page.pageElements) return undefined;
    for (const element of page.pageElements)if (element.shape && element.shape.placeholder && name === element.shape.placeholder.type) placeholders.push(element);
    if (placeholders.length) return placeholders;
    return undefined;
}
function $3e6b71d5149b495c$export$7954bd8cceb5e7bf(presentation, pageId, name) {
    let pages = [];
    const placeholders = [];
    if (pageId !== null) {
        const page = $3e6b71d5149b495c$export$e592b69f6a7a6e8b(presentation, pageId);
        if (!page) throw new Error(`Can't find page ${pageId}`);
        pages.push(page);
    } else pages = presentation.slides;
    for(let i = 0; i < pages.length; i++)if (pages[i].pageElements.length) {
        let page = pages[i];
        for(let j = 0; j < page.pageElements.length; j++){
            let pageElement = page.pageElements[j];
            if (pageElement.shape && pageElement.shape.text && pageElement.shape.text.textElements && pageElement.shape.text.textElements.length) for(let k = 0; k < pageElement.shape.text.textElements.length; k++){
                let textElement = pageElement.shape.text.textElements[k];
                if (textElement.textRun && textElement.textRun.content && textElement.textRun.content.includes(name)) placeholders.push({
                    slideId: page.objectId,
                    pageElement: pageElement
                });
            }
        }
    }
    if (!placeholders.length > 0) return undefined;
    return placeholders;
}
function $3e6b71d5149b495c$export$de6b0f050df2591d(element) {
    const height = element.size.height.magnitude;
    const width = element.size.width.magnitude;
    const scaleX = element.transform && element.transform.scaleX ? element.transform.scaleX : 1;
    const scaleY = element.transform && element.transform.scaleY ? element.transform.scaleY : 1;
    const shearX = element.transform && element.transform.shearX ? element.transform.shearX : 0;
    const shearY = element.transform && element.transform.shearY ? element.transform.shearY : 0;
    return {
        width: scaleX * width + shearX * height,
        height: scaleY * height + shearY * width,
        x: element.transform && element.transform.translateX ? element.transform.translateX : 0,
        y: element.transform && element.transform.translateY ? element.transform.translateY : 0
    };
}
function $3e6b71d5149b495c$export$6b6c32ecec8120f4(videoId, slideId, placeholderElm) {
    const requests = [];
    const videoWidth = 640;
    const videoHeight = 360; // 16:9 aspect
    const box = $3e6b71d5149b495c$export$de6b0f050df2591d(placeholderElm);
    const scaleRatio = Math.min(box.width / videoWidth, box.height / videoHeight);
    const scaledWidth = videoWidth * scaleRatio;
    const scaledHeight = videoHeight * scaleRatio;
    const translateX = box.x + (box.width - scaledWidth) / 2;
    const translateY = box.y + (box.height - scaledHeight) / 2;
    const objectId = String(Date.now());
    requests.push({
        createVideo: {
            source: 'YOUTUBE',
            objectId: objectId,
            id: videoId,
            elementProperties: {
                pageObjectId: slideId,
                size: {
                    height: {
                        magnitude: scaledHeight,
                        unit: 'EMU'
                    },
                    width: {
                        magnitude: scaledWidth,
                        unit: 'EMU'
                    }
                },
                transform: {
                    scaleX: 1,
                    scaleY: 1,
                    translateX: translateX,
                    translateY: translateY,
                    shearX: 0,
                    shearY: 0,
                    unit: 'EMU'
                }
            }
        }
    });
    requests.push({
        updateVideoProperties: {
            objectId: objectId,
            fields: 'autoPlay',
            videoProperties: {
                autoPlay: false
            }
        }
    });
    return requests;
}


var $23fd61df7769cbf8$exports = {};
$23fd61df7769cbf8$exports = $parcel$resolve("b73Vi");


var $65feaaa7f002847f$exports = {};
$65feaaa7f002847f$exports = $parcel$resolve("ijK7G");


const $d87331de16c3b7f3$var$cookies = new (0, $9bfae0a1a4fe450e$export$2e2bcd8739ae039)();
class $d87331de16c3b7f3$var$SlidesButton extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.state = {
            building: false
        };
        this.doc = this.props.doc;
        this.identifier = "slide";
    }
    getMapsPromise(docType) {
        if ("comparison" === docType) return this.getCharMapsPromise();
        if ("cause-effect" === docType) return this.getCauseEffectMapsPromise();
        if ("question-exp" === docType) return this.getQuestionExpMapsPromise();
        if ("cera" === docType) return this.getCERGuideMapsPromise();
    }
    processCERGuideMapsPromise(valueMaps) {
        var promises = [];
        promises.push(this.getCommandsForTextItem('topic', 'topic'));
        promises.push(this.getCommandsForTextItem('claim', 'claim'));
        for (let f of [
            'essentialquestion',
            'claimcontext',
            'reasoningnote'
        ]){
            promises.push(this.getCommandsForTextItem(f, f));
            promises.push(this.getCommandsForImage(f));
        }
        promises.push(this.getCommandsForTerms(valueMaps));
        promises.push(this.getCommandsSupportEvidence(valueMaps, this.config.supportsEvidencePageId));
        promises.push(this.getCommandsSupportEvidenceQuality(valueMaps, this.config.supportsEvidenceQualityPageId));
        promises.push(this.getCommandsOpposesEvidence(valueMaps, this.config.opposesEvidencePageId));
        promises.push(this.getCommandsOpposesEvidenceQuality(valueMaps, this.config.opposesEvidenceQualityPageId));
        promises.push(this.getCommandsForQualityType('reasoningtype', 'reasoningtype'));
        return promises;
    }
    processComparisonMapsPromise(valueMaps) {
        console.log(this.config);
        var promises = [];
        for (let f of [
            'concept1',
            'concept2',
            'description1',
            'description2',
            'overall',
            'summary',
            'essentialquestion'
        ]){
            promises.push(this.getCommandsForTextItem(f, f));
            promises.push(this.getCommandsForImage(f));
        }
        promises.push(this.getCommandsForTerms(valueMaps));
        promises.push(this.getCommandsForCharacteristics(valueMaps));
        promises.push(this.getCommandsForDeletableTextItem('extensions', 'extensions', this.config.extensionsPageId));
        promises.push(this.getCommandsForImage('extensions'));
        promises.push(this.getCommandsForPairs('like', this.config.likePairsPageId, valueMaps));
        promises.push(this.getCommandsForPairs('unlike', this.config.unlikePairsPageId, valueMaps));
        return promises;
    }
    processQuestionExpMapsPromise(valueMaps) {
        var promises = [];
        promises.push(this.getCommandsForTextItem('topic', 'topic'));
        for (let f of [
            'essentialquestion',
            'essentialquestionresponse',
            'contextresponse',
            'extensions'
        ]){
            promises.push(this.getCommandsForTextItem(f, f));
            promises.push(this.getCommandsForImage(f));
        }
        promises.push(this.getCommandsForTerms(valueMaps));
        promises.push(this.getCommandsRelatedQuestion(valueMaps, this.config.relatedQuestionPageId));
        return promises;
    }
    processCauseEffectMapsPromise(valueMaps) {
        var promises = [];
        promises.push(this.getCommandsForTextItem('topic', 'topic'));
        for (let f of [
            'question',
            'event',
            'answer',
            'extensions'
        ]){
            promises.push(this.getCommandsForTextItem(f, f));
            promises.push(this.getCommandsForImage(f));
        }
        promises.push(this.getCommandsForTerms(valueMaps));
        promises.push(this.getCommandsForCauses(valueMaps, this.config.causePageId));
        promises.push(this.getCommandsForArrow('arrow_cause', 'causes-event/connector'));
        promises.push(this.getCommandsForArrow('effect_arrow', 'event-effects/connector'));
        promises.push(this.getCommandsForEffect(valueMaps, this.config.effectPageId));
        return promises;
    }
    checkScope() {
        let scope = "https://www.googleapis.com/auth/drive.readonly";
        const grantedScopes = $d87331de16c3b7f3$var$cookies.get("corgi_granted_scopes");
        if (grantedScopes.includes(scope)) this.doExportSlide();
        else {
            (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#modalWaiting').CFW_Modal('hide');
            this.context.addGoogleScope(scope, (succeed)=>{
                if (succeed) {
                    console.log("Add more scope success");
                    this.doExportSlide();
                } else console.log("Add more scope fail");
            });
        }
    }
    doExportSlide() {
        var docType = this.context.fileType;
        window.tracker.trackEvent("Guide", "create presentation", "");
        if ("comparison" === docType) this.config = window.slideExportConfig.comparison;
        if ("cause-effect" === docType) this.config = window.slideExportConfig.causeEffect;
        if ("question-exp" === docType) this.config = window.slideExportConfig.questionExp;
        if ("cera" === docType) this.config = window.slideExportConfig.cerGuide;
        if (this.state.building) console.log('Already building, ignored.');
        this.setState({
            building: true
        });
        let valueMaps = null;
        let presentationCopyId = null;
        let webViewLink = null;
        let slideId = null;
        let request = {
            name: this.context.fileName,
            parents: [
                'root'
            ]
        };
        let textCommands = [];
        let imageCommands = [];
        let videoCommands = [];
        window.gapi.client.drive.files.copy({
            fileId: this.config.templateId,
            resource: request,
            fields: 'id,webViewLink'
        }).then((driveResponse)=>{
            presentationCopyId = driveResponse.result.id;
            webViewLink = driveResponse.result.webViewLink;
            slideId = driveResponse.result.id;
            return window.gapi.client.load('slides', 'v1');
        }, (e)=>{
            console.error("Error copying slideshow template:", e);
            alert("Error copying slide export template");
            this.setState({
                building: false
            });
        }).then((r)=>{
            return this.getMapsPromise(docType);
        }, (e)=>{
            console.error("Error loading presenation: API", e);
            alert("Error loading presentation API");
            this.setState({
                building: false
            });
        }).then((r)=>{
            valueMaps = r;
            var promises = [];
            if ("cera" === docType) promises = this.processCERGuideMapsPromise(valueMaps);
            if ("comparison" === docType) promises = this.processComparisonMapsPromise(valueMaps);
            if ("cause-effect" === docType) promises = this.processCauseEffectMapsPromise(valueMaps);
            if ("question-exp" === docType) promises = this.processQuestionExpMapsPromise(valueMaps);
            return Promise.all(promises);
        }, (e)=>{
            console.error("Error building characteristic maps:", e);
            alert("Error while calculating Slides content");
            this.setState({
                building: false
            });
            return false;
        }).then(async (values)=>{
            console.log(values);
            let requests = values.reduce((accum, val)=>{
                return accum.concat(val);
            }, []);
            requests.push(this.makeReplaceTextCommand('currentUserName', this.context.currentUser.displayName));
            console.debug('Slides update commands: ', requests);
            for (let req of requests){
                if (req.replaceAllShapesWithImage !== null && req.replaceAllShapesWithImage !== undefined) {
                    const isValidImage = await this.checkValidImage(req.replaceAllShapesWithImage.imageUrl);
                    if (isValidImage) imageCommands.push(req);
                    else textCommands.push(this.makeReplaceTextCommand(req.replaceAllShapesWithImage.containsText.text.replaceAll("{{", "").replaceAll("}}", ""), "Image " + req.replaceAllShapesWithImage.imageUrl + " not found"));
                } else if (req.createVideoCorgi !== null && req.createVideoCorgi !== undefined) {
                    const isValidVideo = await this.checkValidVideo(req.createVideoCorgi.videoId);
                    if (isValidVideo) videoCommands.push(req);
                    else textCommands.push(this.makeReplaceTextCommand(req.videoCommands.objectId.replaceAll("{{", "").replaceAll("}}", ""), "Video " + $d87331de16c3b7f3$var$transformEmbeddedYouTubeURLIntoWatchURL(req.createVideoCorgi.videoId) + " not found"));
                } else textCommands.push(req);
            }
            return window.gapi.client.slides.presentations.batchUpdate({
                presentationId: presentationCopyId,
                requests: textCommands
            });
        }, (e)=>{
            console.error("Error while building batch update list:", e);
            alert("Error while determining Slides content");
            this.setState({
                building: false
            });
            return false;
        }).then(()=>{
            if (imageCommands.length > 0) return window.gapi.client.slides.presentations.batchUpdate({
                presentationId: presentationCopyId,
                requests: imageCommands
            });
        }, (e)=>{
            console.error("BatchUpdate text of presentation failed:", e);
            alert("Error while filling text in Slides content");
            this.setState({
                building: false
            });
            return false;
        }).then(async ()=>{
            if (videoCommands.length > 0) {
                let currPresentation = await window.gapi.client.slides.presentations.get({
                    presentationId: presentationCopyId
                });
                let presentation = currPresentation.result;
                for(let i = 0; i < videoCommands.length; i++){
                    let placeholderElm = null;
                    let requestsVideo = [];
                    // Find placeholder element
                    let placeholder = videoCommands[i].createVideoCorgi.placeholder;
                    let pageId = videoCommands[i].createVideoCorgi.page;
                    let placeholderItems = (0, $3e6b71d5149b495c$export$7954bd8cceb5e7bf)(presentation, pageId, placeholder);
                    // Should only be one result - pick first one if multiple
                    if (placeholderItems.length > 0) placeholderElm = placeholderItems[0];
                    if (placeholderElm !== null) {
                        requestsVideo = (0, $3e6b71d5149b495c$export$6b6c32ecec8120f4)(videoCommands[i].createVideoCorgi.videoId, placeholderElm.slideId, placeholderElm.pageElement);
                        if (requestsVideo.length > 0) requestsVideo.push(this.makeDeleteObjectCommand(placeholderElm.pageElement.objectId));
                    }
                    if (requestsVideo.length > 0) return window.gapi.client.slides.presentations.batchUpdate({
                        presentationId: presentationCopyId,
                        requests: requestsVideo
                    });
                }
            }
        }, (e)=>{
            console.error("Filling images error", e);
            alert("There was a problem adding images to your slide presentation. Your images were unable to be inserted.");
            window.tracker.trackEvent("Error", "create presentation", "image insertion failed");
            this.setState({
                building: false
            });
            return false;
        }).then(()=>{
            // Redirect
            console.debug('replacement done, redirecting to ' + webViewLink);
            this.getRef(this.identifier).push().set({
                id: slideId,
                url: webViewLink
            });
            window.location = webViewLink;
            return true;
        }, (e)=>{
            //console.log(e.message);
            //console.log(e.stack);
            console.error("Filling videos error -> do nothing", e);
            this.getRef(this.identifier).push().set({
                id: slideId,
                url: webViewLink
            });
            alert("There was a problem adding videos to your slide presentation. Your videos were unable to be inserted.");
            window.tracker.trackEvent("Error", "create presentation", "video insertion failed");
            window.location = webViewLink;
            return true;
        });
    }
    checkValidImage(imageURL) {
        return new Promise((resolve)=>{
            const image = new Image();
            image.src = imageURL;
            image.addEventListener('load', ()=>{
                resolve(true);
            });
            image.addEventListener('error', ()=>{
                resolve(false);
            });
        });
    }
    async checkValidVideo(videoId) {
        const imageUrl = 'https://i.ytimg.com/vi/' + videoId + '/default.jpg';
        const isValid = await this.checkValidImage(imageUrl);
        return isValid;
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            onClick: (evt)=>this.checkScope(),
            className: "btn btn-large btn-create",
            "data-cfw": "modal",
            "data-cfw-modal-target": "#modalWaiting",
            "data-cfw-modal-backdrop": "static"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "btn-create-img"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($23fd61df7769cbf8$exports))),
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "sr-only"
        }, "Create a Slide Presentation")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "modalWaiting",
            className: "modal confirm-modal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-dialog modal-dialog-centered"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row flex-items-center gx-0_5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-3"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            className: "img-fluid",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($65feaaa7f002847f$exports))),
            alt: "Panting corgi..."
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-9 text-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            className: "modal-title h3"
        }, "We're creating your presentation!"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, "You are now leaving Corgi.", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("br", null), "Your presentation will open in Google Slides."))))))));
    }
    //
    // Simple Data Access Methods
    //
    getRef(path) {
        let fullPath = this.context.fileType + "/" + this.context.fileId + "/" + path;
        return window.firebase.database().ref(fullPath);
    }
    // A Promise that will resolve to a DataSnapshot for the given database location.
    getValuePromise(path) {
        return this.getRef(path).once("value");
    }
    // Return a promise for the value of a Firepad text field
    getFirepadTextPromise(path) {
        return new Promise((resolve, reject)=>{
            let firepadHeadless = new window.Firepad.Headless(this.getRef(path));
            firepadHeadless.getText((text)=>{
                firepadHeadless.dispose();
                resolve(text);
            });
        });
    }
    // Given a PATH that points to a list of data, with string values at the KEY within each
    // list item, return a Promise that will resolve to a map of keys to the string values.
    getTextMapPromise(path, key) {
        return this.getRef(path).once("value").then((list)=>{
            let map = new Map();
            list.forEach((item)=>{
                let value = item.child(key).val();
                map.set(item.key, value);
            });
            return map;
        });
    }
    // Given a PATH that points to a list of data, with Firepad values at the KEY within each
    // list item, return a Promise that will resolve to a map of keys to the editor contents.
    getFirepadMapPromise(path, key) {
        return new Promise((resolve, reject)=>{
            let ref = this.getRef(path);
            ref.once("value").then((list)=>{
                let keys = [];
                let promises = [];
                list.forEach((item)=>{
                    keys.push(item.key);
                    promises.push(this.getFirepadTextPromise(path + '/' + item.key + '/' + key));
                });
                Promise.all(promises).then((values)=>{
                    let map = new Map();
                    for(let i = 0; i < keys.length; i++)map.set(keys[i], values[i]);
                    resolve(map);
                });
            });
        });
    }
    // A Promise that will return the "characteristic" and "categories" maps.
    getCharMapsPromise() {
        let proms = [
            this.getFirepadMapPromise('characteristics1', 'text'),
            this.getFirepadMapPromise('characteristics2', 'text'),
            this.getFirepadMapPromise('characteristics1', 'category'),
            this.getTextMapPromise('characteristics1', 'text/image'),
            this.getTextMapPromise('characteristics2', 'text/image'),
            this.getTextMapPromise('characteristics1', 'category/image'),
            this.getFirepadMapPromise('terms', 'def'),
            this.getFirepadMapPromise('terms', 'term')
        ];
        return Promise.all(proms).then((maps)=>{
            return {
                'characteristics1': maps[0],
                'characteristics2': maps[1],
                'categories': maps[2],
                'char1images': maps[3],
                'char2images': maps[4],
                'categoryimages': maps[5],
                'termsdef': maps[6],
                'termsword': maps[7]
            };
        });
    }
    //
    // Methods that build single commands for BatchUpdate
    //
    makeReplaceTextCommand(from, to, page = null) {
        let request = {
            replaceAllText: {
                containsText: {
                    text: '{{' + from + '}}',
                    matchCase: true
                },
                replaceText: to
            }
        };
        if (page) request['replaceAllText']['pageObjectIds'] = [
            page
        ];
        return request;
    }
    makeReplaceMediaCommand(id, url, page = null) {
        let placeholder = id + '/image';
        let isImage = false;
        let urlMatch = url ? url.toLowerCase() : url;
        if (url && (urlMatch.includes(".jpg") || urlMatch.includes(".jpeg") || urlMatch.includes(".gif") || urlMatch.includes(".png"))) isImage = true;
        if (url && !url.startsWith('data:') && isImage) {
            let request = {
                replaceAllShapesWithImage: {
                    containsText: {
                        text: '{{' + placeholder + '}}',
                        matchCase: true
                    },
                    "imageUrl": url
                }
            };
            if (page) request['replaceAllShapesWithImage']['pageObjectIds'] = [
                page
            ];
            return request;
        } else if ((0, $e75727477720e2d0$export$a1dfc7488e2b0185)(url)) {
            // Create a custom create video request - similar, but different to Google SLides API's createVideoRequest
            // https://developers.google.com/slides/api/reference/rest/v1/presentations/request#createvideorequest
            let request = {
                createVideoCorgi: {
                    "placeholder": '{{' + placeholder + '}}',
                    "page": page ? page : null,
                    "source": "YOUTUBE",
                    "videoId": $d87331de16c3b7f3$var$transformEmbeddedYouTubeURLIntoId(url)
                }
            };
            return request;
        } else // No media, instead remove the placeholder.
        return this.makeReplaceTextCommand(placeholder, '', page);
    }
    makeDeleteObjectCommand(objectId) {
        return {
            deleteObject: {
                objectId: objectId
            }
        };
    }
    makeDuplicatePageCommand(oldid, newid) {
        let id_replacement = {};
        id_replacement[oldid] = newid;
        return {
            duplicateObject: {
                objectId: oldid,
                objectIds: id_replacement
            }
        };
    }
    //
    // Methods that return lists commands for BatchUpdate
    //
    // Replace text placeholder with Firepad text
    getCommandsForTextItem(from, path) {
        return this.getFirepadTextPromise(path).then((text)=>{
            return [
                this.makeReplaceTextCommand(from, text)
            ];
        });
    }
    // Replace text placeholder with Firepad text, or delete the given object if there's no text
    getCommandsForDeletableTextItem(from, path, pageId) {
        return this.getFirepadTextPromise(path).then((text)=>{
            if (text) return [
                this.makeReplaceTextCommand(from, text)
            ];
            else return [
                this.makeDeleteObjectCommand(pageId)
            ];
        });
    }
    // Replace image placeholder with image
    getCommandsForImage(path, page = null) {
        return this.getValuePromise(path + '/image').then((data)=>{
            return [
                this.makeReplaceMediaCommand(path, data.val(), page)
            ];
        });
    }
    // Returns all the commands to build the like and unlike pairs slides
    getCommandsForPairs(which, main_page_id, charMaps) {
        return this.getValuePromise('pairs/' + which + 'characteristics').then((data)=>{
            let allRequests = [];
            let pairCount = data.numChildren();
            if (pairCount === 0) allRequests.push(this.makeDeleteObjectCommand(main_page_id));
            else {
                let i = 0, page_id = '';
                data.forEach((pairData)=>{
                    let pair = pairData.val();
                    let pageRequests = [];
                    if (i === 0) page_id = main_page_id;
                    else {
                        // Make a new page for each pair after the first
                        page_id = data.key + "_" + i;
                        pageRequests.push(this.makeDuplicatePageCommand(main_page_id, page_id));
                    }
                    // Header info
                    pageRequests.push(this.makeReplaceTextCommand('pairPage', String(i + 1), page_id));
                    pageRequests.push(this.makeReplaceTextCommand('totalPairPages', String(pairCount), page_id));
                    // Text info
                    pageRequests.push(this.makeReplaceTextCommand('characteristic1', charMaps['characteristics1'].get(pair.characteristic1), page_id));
                    pageRequests.push(this.makeReplaceTextCommand('characteristic2', charMaps['characteristics2'].get(pair.characteristic2), page_id));
                    pageRequests.push(this.makeReplaceTextCommand('category', charMaps['categories'].get(pair.characteristic1), page_id));
                    // Images
                    pageRequests.push(this.makeReplaceMediaCommand('characteristic1', charMaps['char1images'].get(pair.characteristic1), page_id));
                    pageRequests.push(this.makeReplaceMediaCommand('characteristic2', charMaps['char2images'].get(pair.characteristic2), page_id));
                    pageRequests.push(this.makeReplaceMediaCommand('category', charMaps['categoryimages'].get(pair.characteristic1), page_id));
                    // Add the requests for this page to the _beginning_ of the list of requests.
                    // Since each duplicate page is inserted directly after the original, we have to create
                    // them starting with the last and working backward.
                    allRequests = pageRequests.concat(allRequests);
                    i++;
                });
            }
            return allRequests;
        });
    }
    // Get Cause Effect Maps proimse
    getCauseEffectMapsPromise() {
        let proms = [
            this.getFirepadMapPromise('terms', 'def'),
            this.getFirepadMapPromise('terms', 'term'),
            this.getFirepadMapPromise('cause', 'text'),
            this.getFirepadMapPromise('effect', 'text'),
            this.getTextMapPromise('cause', 'text/image'),
            this.getTextMapPromise('effect', 'text/image')
        ];
        return Promise.all(proms).then((maps)=>{
            console.log(maps);
            return {
                'termsdef': maps[0],
                'termsword': maps[1],
                'cause': maps[2],
                'effect': maps[3],
                'causeimages': maps[4],
                'effectimages': maps[5]
            };
        });
    }
    getCommandsForCharacteristics(valueMaps) {
        let pageRequests = [];
        if (valueMaps['characteristics1'] != null) {
            let listTerm = [];
            valueMaps['characteristics1'].forEach((value)=>{
                listTerm.push(value);
            });
            pageRequests.push(this.makeReplaceTextCommand('characteristics1', listTerm.join('\n')));
        }
        if (valueMaps['characteristics2'] != null) {
            let listTerm = [];
            valueMaps['characteristics2'].forEach((value)=>{
                listTerm.push(value);
            });
            pageRequests.push(this.makeReplaceTextCommand('characteristics2', listTerm.join('\n')));
        }
        return pageRequests;
    }
    getCommandsForTerms(valueMaps) {
        let pageRequests = [];
        if (valueMaps['termsword'] != null) {
            let listTerm = [];
            valueMaps['termsword'].forEach((value, key)=>{
                let termDef = "";
                let term = "";
                if (valueMaps['termsdef'] != null) termDef = valueMaps['termsdef'].get(key);
                if (termDef !== "") term = value + " : " + termDef;
                listTerm.push(term);
            });
            let strval = listTerm.join('\n');
            pageRequests.push(this.makeReplaceTextCommand('term', strval));
        }
        return pageRequests;
    }
    getCommandsForCauses(valueMaps, mainPageId) {
        let allRequests = [];
        if (valueMaps['cause'] != null) {
            let index = 0;
            let pageId = "";
            valueMaps['cause'].forEach((value, key)=>{
                let causeImg = "";
                if (valueMaps['causeimages'] != null) causeImg = valueMaps['causeimages'].get(key);
                let pageRequests = [];
                if (index === 0) pageId = mainPageId;
                else {
                    pageId = mainPageId + "_" + index;
                    pageRequests.push(this.makeDuplicatePageCommand(mainPageId, pageId));
                }
                pageRequests.push(this.makeReplaceTextCommand('causeIndex', String(index + 1), pageId));
                pageRequests.push(this.makeReplaceTextCommand('cause', value, pageId));
                pageRequests.push(this.makeReplaceMediaCommand('cause', causeImg, pageId));
                allRequests = pageRequests.concat(allRequests);
                index++;
            });
        }
        return allRequests;
    }
    getCommandsForEffect(valueMaps, mainPageId) {
        let allRequests = [];
        if (valueMaps['effect'] != null) {
            let index = 0;
            let pageId = "";
            valueMaps['effect'].forEach((value, key)=>{
                let effectImg = "";
                if (valueMaps['effectimages'] != null) effectImg = valueMaps['effectimages'].get(key);
                let pageRequests = [];
                if (index === 0) pageId = mainPageId;
                else {
                    pageId = mainPageId + "_" + index;
                    pageRequests.push(this.makeDuplicatePageCommand(mainPageId, pageId));
                }
                pageRequests.push(this.makeReplaceTextCommand('effectIndex', String(index + 1), pageId));
                pageRequests.push(this.makeReplaceTextCommand('effect', value, pageId));
                pageRequests.push(this.makeReplaceMediaCommand('effect', effectImg, pageId));
                allRequests = pageRequests.concat(allRequests);
                index++;
            });
        }
        return allRequests;
    }
    getCommandsForArrow(from, path) {
        return this.getValuePromise(path).then((data)=>{
            return [
                this.makeReplaceTextCommand(from, data.val())
            ];
        });
    }
    // Question Exp
    getQuestionExpMapsPromise() {
        let proms = [
            this.getFirepadMapPromise('terms', 'def'),
            this.getFirepadMapPromise('terms', 'term'),
            this.getFirepadMapPromise('relatedquestion', 'question'),
            this.getFirepadMapPromise('relatedquestion', 'answer'),
            this.getTextMapPromise('relatedquestion', 'question/image'),
            this.getTextMapPromise('relatedquestion', 'answer/image')
        ];
        return Promise.all(proms).then((maps)=>{
            console.log(maps);
            return {
                'termsdef': maps[0],
                'termsword': maps[1],
                'question': maps[2],
                'answer': maps[3],
                'questionimages': maps[4],
                'answerimages': maps[5]
            };
        });
    }
    getCommandsRelatedQuestion(valueMaps, mainPageId) {
        let allRequests = [];
        if (valueMaps['question'] != null) {
            let index = 0;
            let pageId = "";
            valueMaps['question'].forEach((value, key)=>{
                let questionImg = "";
                if (valueMaps['questionimages'] != null) questionImg = valueMaps['questionimages'].get(key);
                let pageRequests = [];
                if (index === 0) pageId = mainPageId;
                else {
                    pageId = mainPageId + "_" + index;
                    pageRequests.push(this.makeDuplicatePageCommand(mainPageId, pageId));
                }
                pageRequests.push(this.makeReplaceTextCommand('question', value, pageId));
                pageRequests.push(this.makeReplaceMediaCommand('question', questionImg, pageId));
                if (valueMaps['answer'] != null) {
                    let mAnswer = "";
                    let mAnswerImage = "";
                    if (valueMaps['answer'].get(key) != null) mAnswer = valueMaps['answer'].get(key);
                    if (valueMaps['answerimages'] != null) mAnswerImage = valueMaps['answerimages'].get(key);
                    pageRequests.push(this.makeReplaceTextCommand('answer', mAnswer, pageId));
                    pageRequests.push(this.makeReplaceMediaCommand('answer', mAnswerImage, pageId));
                }
                allRequests = pageRequests.concat(allRequests);
                index++;
            });
        }
        return allRequests;
    }
    // Get CERGuide Maps proimse
    getCERGuideMapsPromise() {
        let proms = [
            this.getFirepadMapPromise('terms', 'def'),
            this.getFirepadMapPromise('terms', 'term'),
            this.getFirepadMapPromise('evidencesupport', 'evidence'),
            this.getFirepadMapPromise('evidencesupport', 'citation'),
            this.getTextMapPromise('evidencesupport', 'qualitytype'),
            this.getFirepadMapPromise('evidencesupport', 'qualitynote'),
            this.getFirepadMapPromise('evidenceopposes', 'evidence'),
            this.getFirepadMapPromise('evidenceopposes', 'citation'),
            this.getTextMapPromise('evidenceopposes', 'qualitytype'),
            this.getFirepadMapPromise('evidenceopposes', 'qualitynote'),
            this.getTextMapPromise('evidencesupport', 'evidence/image'),
            this.getTextMapPromise('evidenceopposes', 'evidence/image')
        ];
        return Promise.all(proms).then((maps)=>{
            console.log(maps);
            return {
                'termsdef': maps[0],
                'termsword': maps[1],
                'supportevidence': maps[2],
                'supportcitation': maps[3],
                'supportqualitytype': maps[4],
                'supportqualitynote': maps[5],
                'opposesevidence': maps[6],
                'opposescitation': maps[7],
                'opposesqualitytype': maps[8],
                'opposesqualitynote': maps[9],
                'supportevidenceimages': maps[10],
                'opposesevidenceimages': maps[11]
            };
        });
    }
    getCommandsSupportEvidence(valueMaps, mainPageId) {
        let allRequests = [];
        if (valueMaps['supportevidence'] != null) {
            let index = 0;
            let pageId = "";
            valueMaps['supportevidence'].forEach((value, key)=>{
                let evidenceImg = "";
                if (valueMaps['supportevidenceimages'] != null) evidenceImg = valueMaps['supportevidenceimages'].get(key);
                let evidenceCiation = "";
                if (valueMaps['supportcitation'] != null) evidenceCiation = valueMaps['supportcitation'].get(key);
                let pageRequests = [];
                if (index === 0) pageId = mainPageId;
                else {
                    pageId = mainPageId + "_" + index;
                    pageRequests.push(this.makeDuplicatePageCommand(mainPageId, pageId));
                }
                pageRequests.push(this.makeReplaceTextCommand('supportIndex', String(index + 1), pageId));
                pageRequests.push(this.makeReplaceTextCommand('supportevidence', value, pageId));
                pageRequests.push(this.makeReplaceTextCommand('supportcitation', evidenceCiation, pageId));
                pageRequests.push(this.makeReplaceMediaCommand('supportevidence', evidenceImg, pageId));
                allRequests = pageRequests.concat(allRequests);
                index++;
            });
        }
        return allRequests;
    }
    getCommandsSupportEvidenceQuality(valueMaps, mainPageId) {
        let allRequests = [];
        if (valueMaps['supportqualitynote'] != null) {
            let index = 0;
            let pageId = "";
            valueMaps['supportqualitynote'].forEach((value, key)=>{
                let qualityType = "";
                if (valueMaps['supportqualitytype'] != null) qualityType = valueMaps['supportqualitytype'].get(key);
                let evidenceCiation = "";
                if (valueMaps['supportcitation'] != null) evidenceCiation = valueMaps['supportcitation'].get(key);
                let supportEvidence = "";
                if (valueMaps['supportevidence'] != null) supportEvidence = valueMaps['supportevidence'].get(key);
                let pageRequests = [];
                if (index === 0) pageId = mainPageId;
                else {
                    pageId = mainPageId + "_" + index;
                    pageRequests.push(this.makeDuplicatePageCommand(mainPageId, pageId));
                }
                pageRequests.push(this.makeReplaceTextCommand('supportQualityIndex', String(index + 1), pageId));
                pageRequests.push(this.makeReplaceTextCommand('supportevidence', supportEvidence, pageId));
                pageRequests.push(this.makeReplaceTextCommand('supportcitation', evidenceCiation, pageId));
                pageRequests.push(this.makeReplaceTextCommand('qualitytype', qualityType, pageId));
                pageRequests.push(this.makeReplaceTextCommand('qualitynote', value, pageId));
                allRequests = pageRequests.concat(allRequests);
                index++;
            });
        }
        return allRequests;
    }
    getCommandsOpposesEvidence(valueMaps, mainPageId) {
        let allRequests = [];
        if (valueMaps['opposesevidence'] != null) {
            let index = 0;
            let pageId = "";
            valueMaps['opposesevidence'].forEach((value, key)=>{
                let evidenceImg = "";
                if (valueMaps['opposesevidenceimages'] != null) evidenceImg = valueMaps['opposesevidenceimages'].get(key);
                let evidenceCiation = "";
                if (valueMaps['opposescitation'] != null) evidenceCiation = valueMaps['opposescitation'].get(key);
                let pageRequests = [];
                if (index === 0) pageId = mainPageId;
                else {
                    pageId = mainPageId + "_" + index;
                    pageRequests.push(this.makeDuplicatePageCommand(mainPageId, pageId));
                }
                pageRequests.push(this.makeReplaceTextCommand('opposesIndex', String(index + 1), pageId));
                pageRequests.push(this.makeReplaceTextCommand('opposesevidence', value, pageId));
                pageRequests.push(this.makeReplaceTextCommand('opposescitation', evidenceCiation, pageId));
                pageRequests.push(this.makeReplaceMediaCommand('opposesevidence', evidenceImg, pageId));
                allRequests = pageRequests.concat(allRequests);
                index++;
            });
        }
        return allRequests;
    }
    getCommandsOpposesEvidenceQuality(valueMaps, mainPageId) {
        let allRequests = [];
        if (valueMaps['opposesqualitynote'] != null) {
            let index = 0;
            let pageId = "";
            valueMaps['opposesqualitynote'].forEach((value, key)=>{
                let qualityType = "";
                if (valueMaps['opposesqualitytype'] != null) qualityType = valueMaps['opposesqualitytype'].get(key);
                let evidenceCiation = "";
                if (valueMaps['opposescitation'] != null) evidenceCiation = valueMaps['opposescitation'].get(key);
                let opposesEvidence = "";
                if (valueMaps['opposesevidence'] != null) opposesEvidence = valueMaps['opposesevidence'].get(key);
                let pageRequests = [];
                if (index === 0) pageId = mainPageId;
                else {
                    pageId = mainPageId + "_" + index;
                    pageRequests.push(this.makeDuplicatePageCommand(mainPageId, pageId));
                }
                pageRequests.push(this.makeReplaceTextCommand('opposesQualityIndex', String(index + 1), pageId));
                pageRequests.push(this.makeReplaceTextCommand('opposesevidence', opposesEvidence, pageId));
                pageRequests.push(this.makeReplaceTextCommand('opposescitation', evidenceCiation, pageId));
                pageRequests.push(this.makeReplaceTextCommand('qualitytype', qualityType, pageId));
                pageRequests.push(this.makeReplaceTextCommand('qualitynote', value, pageId));
                allRequests = pageRequests.concat(allRequests);
                index++;
            });
        }
        return allRequests;
    }
    getCommandsForQualityType(from, path) {
        return this.getValuePromise(path).then((data)=>{
            return [
                this.makeReplaceTextCommand(from, data.val())
            ];
        });
    }
}
function $d87331de16c3b7f3$var$transformYouTubeIdIntoWatchURL(videoId) {
    return "https://www.youtube.com/watch?v=" + videoId;
}
function $d87331de16c3b7f3$var$transformEmbeddedYouTubeURLIntoId(url) {
    const regExp = /^https:\/\/www\.youtube\.com\/embed\/((\w|-){11})(?:\S+)?$/;
    return url.match(regExp)[1];
}
function $d87331de16c3b7f3$var$transformEmbeddedYouTubeURLIntoWatchURL(url) {
    const regExp = /^https:\/\/www\.youtube\.com\/embed\/((\w|-){11})(?:\S+)?$/;
    if (url.match(regExp)) {
        const videoId = url.match(regExp)[1];
        return $d87331de16c3b7f3$var$transformYouTubeIdIntoWatchURL(videoId);
    }
    // If the transformation failed, return the original URL
    return url;
}
var $d87331de16c3b7f3$export$2e2bcd8739ae039 = $d87331de16c3b7f3$var$SlidesButton;


var $0ce221e0b8a4cdb9$exports = {};
$0ce221e0b8a4cdb9$exports = $parcel$resolve("jQ7Bt");


var $0a48f718d0852d91$exports = {};
$0a48f718d0852d91$exports = $parcel$resolve("9zUDe");


class $002e046ed3b7cd22$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.state = {
            slides: {}
        };
        this.slideRef = null;
    }
    getRef(identifier) {
        let path = this.context.fileType + "/" + this.context.fileId + "/" + identifier;
        return window.firebase.database().ref(path);
    }
    openClassroomWindow = ()=>{
        // See: https://developers.google.com/classroom/guides/sharebutton#customization
        const driveUrl = 'https://drive.google.com/file/d/' + this.context.fileId + '/view';
        const classroomShare = "https://classroom.google.com/share?url=" + encodeURI(driveUrl);
        window.open(classroomShare, "Popup", "noopener, noreferrer, popup=yes, toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=400, top=50, left=50");
    };
    render() {
        const printUrl = [
            "",
            this.context.fileType,
            this.context.fileId,
            "print"
        ].join("/");
        let slideList = this.state.slides;
        const slideItems = [];
        if (slideList) {
            for(let key in slideList)if (slideList.hasOwnProperty(key)) slideItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($002e046ed3b7cd22$var$Slide, {
                key: key,
                url: slideList[key].url,
                id: slideList[key].id
            }));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("main", {
            id: "main_container",
            className: "main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h1", {
            id: "content",
            className: "h1"
        }, "Create & Share"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, "When your Corgi Guide is complete, present, print, save, or share it."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row row-cols-2 row-cols-md-4"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col text-center mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $d87331de16c3b7f3$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "h2"
        }, "Create a Slide Presentation")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col text-center mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "#share",
            onClick: this.props.shareMethod,
            className: "btn btn-large btn-create"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "btn-create-img"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-share-square",
            "aria-hidden": "true"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "sr-only"
        }, "Share this Guide")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "h2"
        }, "Share this Guide")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col text-center mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: printUrl,
            className: "btn btn-large btn-create"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "btn-create-img"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-print",
            style: {
                marginRight: '.125rem'
            },
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-file-pdf",
            style: {
                marginLeft: '.125rem'
            },
            "aria-hidden": "true"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "sr-only"
        }, "Print / Save to PDF")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "h2"
        }, "Print / Save to PDF")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col text-center mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            className: "btn btn-create",
            onClick: this.openClassroomWindow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "btn-create-img"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($0ce221e0b8a4cdb9$exports))),
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "sr-only"
        }, "Post to Google Classroom")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "h2"
        }, "Post to Google Classroom")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "section section-border-top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Slide Presentations you have created:"), this.state.slides != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", {
            className: "list-unstyled"
        }, slideItems) : null))));
    }
    componentDidMount() {
        (0, $364b9cc7d9afdbb5$export$cb8f6cc068188a8f)();
        const driveUrl = 'https://drive.google.com/file/d/' + this.context.fileId + '/view';
        window.gapi.sharetoclassroom.render('gcPostButton', {
            'url': driveUrl,
            'title': this.context.fileName,
            'size': 80
        });
        this.slideRef = this.getRef("slide");
        this.slideRef.once('value', (data)=>{
            if (data.exists()) this.setState({
                slides: data.val()
            });
        });
    }
}
class $002e046ed3b7cd22$var$Slide extends (0, $6wXVr.Component) {
    constructor(props){
        super(props);
        this.state = {
            slideId: this.props.id,
            fileName: null,
            lastModified: null,
            fileError: false
        };
    }
    componentDidMount() {
        this.loadFile(this.state.slideId);
    }
    loadFile(id) {
        this.getMetadata(id).then((metadata)=>{
            if (null !== metadata && undefined !== metadata) {
                let mTime = new Date(metadata.modifiedTime).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit'
                });
                this.setState({
                    fileName: metadata.name,
                    lastModified: mTime
                });
            }
        });
    }
    getMetadata(id) {
        return new Promise((resolve)=>{
            window.gapi.client.request({
                path: "https://www.googleapis.com/drive/v3/files/" + id,
                method: "GET",
                params: {
                    fields: "id, name, modifiedTime"
                }
            }).then((response)=>{
                resolve(response.result);
            }, (err_reason)=>{
                if (err_reason.result && err_reason.result.error) console.warn("Could not get file metadata: " + err_reason.result.error.message);
                else console.info("Could not get file metadata: ", err_reason);
                this.setState({
                    fileError: true
                });
                if (err_reason.result.error.code === 401) this.context.handleAccessTokenExpired();
            });
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, !this.state.fileError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "media mb-0_25"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "slide-img me-0_5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($0a48f718d0852d91$exports))),
            alt: "Google Slide document"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "hinline"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "h6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: this.props.url
        }, this.state.fileName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fs-small"
        }, "last modified ", this.state.lastModified)))) : null);
    }
}






var $6wXVr = parcelRequire("6wXVr");







class $8385a289acdc9680$export$2e2bcd8739ae039 extends (0, $c01ab3c338b52a54$export$2e2bcd8739ae039) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.canBeEmpty = false;
        this.editing = this.props.editing;
        this.fileType = !(0, $21f9ebdc444decaf$export$6e22c362a0406a2c)(this.props.docType) ? this.props.docType : null;
        this.fileId = !(0, $21f9ebdc444decaf$export$6e22c362a0406a2c)(this.props.docId) ? this.props.docId : null;
        this.tooltipTitle = undefined !== this.props.tooltipTitle ? this.props.tooltipTitle : false;
        this.identifier = "terms";
        this.newItem = this.newItem.bind(this);
        this.getCurrentNode = this.getCurrentNode.bind(this);
    }
    render() {
        const termList = this.getContentList();
        const section = this.props.section;
        if (!this.fileType) this.fileType = this.context.fileType;
        if (!this.fileId) this.fileId = this.context.fileId;
        let termsHTML = [];
        if (termList) {
            for(let key in termList)if (termList.hasOwnProperty(key)) termsHTML.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($8385a289acdc9680$var$Term, {
                key: key,
                id: key,
                deleteMethod: this.handleDeleteItem,
                canDelete: this.state.canDelete,
                fileType: this.fileType,
                fileId: this.fileId,
                editing: true,
                section: section
            }));
        }
        const addButton = this.context.canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-12"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            onClick: this.handleAddItem,
            className: "btn btn-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-plus me-0_25",
            "aria-hidden": "true"
        }), "Add Key Term"))) : null;
        const termLabel = section.term ? section.term.label : "Word or Phrase";
        const defLabel = section.def ? section.def.label : "Definition";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b5ffa3f136ed406e$export$2e2bcd8739ae039), {
            section: section,
            tooltipTitle: this.tooltipTitle
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "h2"
        }, termLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "h2"
        }, defLabel))), termsHTML, addButton);
    }
    getCurrentNode() {
        return this.fileType + "/" + this.fileId + "/" + this.identifier;
    }
    newItem() {
        window.firebase.database().ref(this.getCurrentNode()).push().set({
            term: "",
            def: ""
        });
    }
    getValuePath(key) {
        let path = this.context.fileType + "/" + this.context.fileId + "/" + this.identifier + "/" + key + "/term";
        return path;
    }
    getImagePath(key) {
        return "";
    }
}
$8385a289acdc9680$export$2e2bcd8739ae039.propTypes = {
    stepnum: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string
};
/**
 *  Component for single Term-Definition pair
 */ class $8385a289acdc9680$var$Term extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.deleteModalId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.termId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.defId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.handleDeleteButton = this.handleDeleteButton.bind(this);
    }
    render() {
        let canEdit = this.context.canEdit;
        let boxCss = canEdit ? "box bg-primary" : "";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: boxCss
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            role: "group",
            "aria-label": "Vocabulary item"
        }, this.props.canDelete ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box-row-close"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "btn btn-icon btn-link",
            "aria-label": "Remove key term",
            onClick: this.handleDeleteButton
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-times text-primary",
            "aria-hidden": "true"
        }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            addImage: false,
            domId: this.termId,
            ...this.props,
            inputClassName: " ",
            inputType: "text-area",
            label: "term",
            placeholder: this.props.section.term.placeholder,
            identifier: "terms/" + this.props.id + "/term"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            addImage: false,
            domId: this.defId,
            ...this.props,
            inputClassName: " ",
            inputType: "text-area",
            label: "definition",
            placeholder: this.props.section.def.placeholder,
            identifier: "terms/" + this.props.id + "/def"
        })))));
    }
    handleDeleteButton(event) {
        if (!this.props.canDelete) window.alert("There must be at least one entry in this list");
        else if (window.confirm("Really delete this term and definition?")) this.props.deleteMethod(this.props.id);
    // this.props.deleteMethod(this.props.id+"/image");
    }
}
$8385a289acdc9680$var$Term.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).string.isRequired,
    canDelete: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).bool.isRequired,
    deleteMethod: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).func.isRequired
};


function $371547c8f062a939$var$trackPageView(context, section) {
    if ('toc' === section) window.tracker.trackPageView(context.currentUser, 'cause-effect:toc');
    if ('question' === section) window.tracker.trackPageView(context.currentUser, 'cause-effect:1');
    if ('terms' === section) window.tracker.trackPageView(context.currentUser, 'cause-effect:2');
    if ('event' === section) window.tracker.trackPageView(context.currentUser, 'cause-effect:3');
    if ('causes' === section) window.tracker.trackPageView(context.currentUser, 'cause-effect:4');
    if ('causes-event' === section) window.tracker.trackPageView(context.currentUser, 'cause-effect:5');
    if ('effects' === section) window.tracker.trackPageView(context.currentUser, 'cause-effect:6');
    if ('event-effects' === section) window.tracker.trackPageView(context.currentUser, 'cause-effect:7');
    if ('summary' === section) window.tracker.trackPageView(context.currentUser, 'cause-effect:8');
    if ('complete' === section) window.tracker.trackPageView(context.currentUser, 'cause-effect:review');
    if ('print' === section) window.tracker.trackPageView(context.currentUser, 'cause-effect:print-preview');
    if ('create-share' === section) window.tracker.trackPageView(context.currentUser, 'cause-effect:create-share');
}
function $371547c8f062a939$export$2e2bcd8739ae039(props) {
    const context = (0, $6wXVr.useContext)((0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039));
    const textSection = (0, $198066ba87364cec$export$2e2bcd8739ae039)["cause-effect"].sections;
    const question = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("section", {
        className: "section-step"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $c2973624e295a266$export$2e2bcd8739ae039), {
        doc: props.doc,
        section: textSection[1],
        editing: true
    }));
    const events = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("section", {
        className: "section-step"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a79b556df0a54813$export$2e2bcd8739ae039), {
        doc: props.doc,
        section: textSection[3],
        editing: true
    }));
    const causes = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b5ffa3f136ed406e$export$2e2bcd8739ae039), {
        key: (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)(),
        section: textSection[4],
        editing: true,
        tooltipTitle: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Essential Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "question",
        className: "box box-autofill"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Causes of the Main event"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $350b7e542abac766$export$2e2bcd8739ae039), {
        doc: props.doc,
        editing: true,
        section: textSection[4]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "grouping grouping-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
        className: "grouping-title"
    }, "The Main Event"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "grouping-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "event",
        className: "box box-autofill"
    })))));
    const cause_connector = (doc, canEdit)=>{
        const path = [
            "",
            doc.type,
            doc.id,
            doc.section
        ].join((0, $4d4f206cc2e474fe$export$136d1ce139fe0e5d));
        return canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-primary connector"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $3d246ea7b59b7507$export$2e2bcd8739ae039 // className="col-md-4 pb-0_5"
        ), {
            identifier: "connector",
            placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(doc.type + ".connector.placeholder"),
            parentNode: path,
            label: "Relationship",
            autocompleteOptions: [
                'caused',
                'aligned with',
                'associated with',
                'contributed to',
                'resulted in',
                'lead to',
                'produced'
            ]
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-arrow-vertical"
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $c0e31515b414b5e0$export$2e2bcd8739ae039), {
            identifier: "causes-event/connector",
            className: "box connector box-autofill"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-arrow-vertical"
        })));
    };
    const effect_connector = (doc, canEdit)=>{
        const path = [
            "",
            doc.type,
            doc.id,
            doc.section
        ].join((0, $4d4f206cc2e474fe$export$136d1ce139fe0e5d));
        return canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-primary connector"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $3d246ea7b59b7507$export$2e2bcd8739ae039 // className="col-md-4 pb-0_5"
        ), {
            identifier: "connector",
            placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(doc.type + ".connector.placeholder"),
            parentNode: path,
            label: "Relationship",
            autocompleteOptions: [
                'aligned with',
                'associated with',
                'contributed to',
                'resulted in',
                'lead to',
                'produced'
            ]
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $c0e31515b414b5e0$export$2e2bcd8739ae039), {
            identifier: "event-effects/connector",
            className: "box connector box-autofill"
        }));
    };
    const causes_event = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b5ffa3f136ed406e$export$2e2bcd8739ae039), {
        key: (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)(),
        section: textSection[5],
        editing: true,
        tooltipTitle: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Essential Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "question",
        className: "box box-autofill"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Causes of the Main event"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $350b7e542abac766$export$2e2bcd8739ae039), {
        inRoutine: true,
        doc: props.doc,
        editing: false,
        section: textSection[4]
    }, cause_connector(props.doc, props.canEdit), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "grouping grouping-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
        className: "grouping-title"
    }, "The Main Event"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "grouping-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "event",
        className: "box box-autofill"
    })))));
    const effects = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b5ffa3f136ed406e$export$2e2bcd8739ae039), {
        key: (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)(),
        section: textSection[6],
        editing: true,
        tooltipTitle: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Essential Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "question",
        className: "box box-autofill"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fe63405f1ce595c9$export$2e2bcd8739ae039), {
        doc: props.doc,
        section: textSection[6],
        editing: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "grouping grouping-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
        className: "grouping-title"
    }, "The Main Event"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "grouping-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "event",
        className: "box box-autofill"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-arrow-vertical"
    }))));
    const event_effects = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b5ffa3f136ed406e$export$2e2bcd8739ae039), {
        key: (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)(),
        section: textSection[7],
        editing: true,
        tooltipTitle: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Essential Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "question",
        className: "box box-autofill"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fe63405f1ce595c9$export$2e2bcd8739ae039), {
        inRoutine: true,
        doc: props.doc,
        editing: false,
        section: textSection[4]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "grouping grouping-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
        className: "grouping-title"
    }, "The Main Event"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "grouping-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "event",
        className: "box box-autofill"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "bracket-arrow-vertical"
    })), effect_connector(props.doc, props.canEdit)));
    const answer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b5ffa3f136ed406e$export$2e2bcd8739ae039), {
        key: (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)(),
        section: textSection[8],
        editing: true,
        tooltipTitle: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Essential Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
        identifier: "question",
        className: "box box-autofill"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: props.canEdit ? "box bg-primary" : ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a1ef86ca5ed11266$export$2e2bcd8739ae039), {
        doc: props.doc,
        section: textSection[8],
        editing: true
    })));
    const extensions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $323c988398378e89$export$2e2bcd8739ae039), {
        doc: props.doc,
        section: textSection[9]
    });
    const createShare = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $002e046ed3b7cd22$export$2e2bcd8739ae039), {
        shareMethod: props.shareMethod
    });
    const terms = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8385a289acdc9680$export$2e2bcd8739ae039), {
        doc: props.doc,
        section: textSection[2],
        tooltipTitle: true
    });
    const section = props.doc.section;
    $371547c8f062a939$var$trackPageView(context, section);
    const content = 'question' === section ? question : 'terms' === section ? terms : 'event' === section ? events : 'causes' === section ? causes : 'causes-event' === section ? causes_event : 'effects' === section ? effects : 'event-effects' === section ? event_effects : 'summary' === section ? answer : 'extensions' === section ? extensions : 'create-share' === section ? createShare : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $cc8ee9c202478e66$export$2e2bcd8739ae039), {
        content: content,
        ...props
    });
}



var $6wXVr = parcelRequire("6wXVr");


var $6wXVr = parcelRequire("6wXVr");



class $149fbb0f12d27fb4$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(){
        super();
        this.identifier = "summary";
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b5ffa3f136ed406e$export$2e2bcd8739ae039), {
            tooltipTitle: true,
            section: this.props.section
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Essential Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "essentialquestion",
            className: "box bg-autofill"
        }), this.context.canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            ...this.props,
            inputType: "text-area",
            identifier: this.identifier,
            addImage: true,
            singleLine: false
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.identifier,
            className: "grouping-text"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.identifier + "/image",
            className: "grouping-img"
        })))));
    }
}








var $6wXVr = parcelRequire("6wXVr");


var $6wXVr = parcelRequire("6wXVr");

class $daeff9e3580cc956$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "form-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            identifier: this.props.identifier,
            inputType: "text-area",
            addImage: true
        }));
    }
}





class $83eb865cd48a85bd$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b5ffa3f136ed406e$export$2e2bcd8739ae039), {
            tooltipTitle: true,
            section: this.props.section
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Essential Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "essentialquestion",
            className: "box bg-autofill"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Concept A"), this.context.canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            identifier: "concept1",
            inputType: "text-area"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $daeff9e3580cc956$export$2e2bcd8739ae039), {
            identifier: "description1"
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "concept1",
            className: "box bg-autofill"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "description1",
            className: "grouping-text"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "description1/image",
            className: "grouping-img"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Concept B"), this.context.canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            identifier: "concept2",
            inputType: "text-area"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $daeff9e3580cc956$export$2e2bcd8739ae039), {
            identifier: "description2"
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "concept2",
            className: "box bg-autofill"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "description2",
            className: "grouping-text"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "description2/image",
            className: "grouping-img"
        })))))));
    }
}



var $6wXVr = parcelRequire("6wXVr");



var $6wXVr = parcelRequire("6wXVr");
class $efdf97115c0b990f$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    constructor(){
        super();
        this.identifier = "overall";
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            addImage: true,
            inputType: "text-area",
            identifier: this.identifier
        });
    }
}




class $9c683f33ac1b0759$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b5ffa3f136ed406e$export$2e2bcd8739ae039), {
            tooltipTitle: true,
            section: this.props.section
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Essential Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "essentialquestion",
            className: "box bg-autofill"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping grouping-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            className: "grouping-item-title"
        }, "Concept A"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "concept1",
            className: "box bg-autofill"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            className: "grouping-item-title"
        }, "Concept B"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "concept2",
            className: "box bg-autofill"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket bracket-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-arrow-vertical"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-start"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-arrow"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-end"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping grouping-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, this.context.canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "form-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $efdf97115c0b990f$export$2e2bcd8739ae039), null)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "overall",
            className: "grouping-text"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "overall/image",
            className: "grouping-img"
        })))))));
    }
}



var $6wXVr = parcelRequire("6wXVr");




class $46c9ea439613aa96$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    render() {
        // maybe more than 2 concepts in future?
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b5ffa3f136ed406e$export$2e2bcd8739ae039), {
            tooltipTitle: "{true}",
            section: this.props.section,
            defineKeyTerm: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Essential Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "essentialquestion",
            className: "box bg-autofill"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Concept A"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "concept1",
            className: "box bg-autofill"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8928b35984758c11$export$2e2bcd8739ae039), {
            doc: this.props.doc,
            identifier: "characteristics1",
            canBeEmpty: false,
            data: this.props.data
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Concept B"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "concept2",
            className: "box bg-autofill"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8928b35984758c11$export$2e2bcd8739ae039), {
            doc: this.props.doc,
            identifier: "characteristics2",
            canBeEmpty: false,
            data: this.props.data
        }))));
    }
}





var $6wXVr = parcelRequire("6wXVr");

class $158f9c4c7cb73f26$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $7c272f631773d5f7$export$2e2bcd8739ae039), {
            showCategory: true,
            ...this.props
        });
    }
}



var $6wXVr = parcelRequire("6wXVr");

class $cdb4f5b9df6b26c7$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $58d7ead67a01a33a$export$2e2bcd8739ae039), {
            showCategory: true,
            ...this.props
        });
    }
}





var $6wXVr = parcelRequire("6wXVr");


class $9e8fa687f5977758$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(){
        super();
        this.identifier = "essentialquestion";
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b5ffa3f136ed406e$export$2e2bcd8739ae039), {
            section: this.props.section,
            tooltipTitle: true
        }), this.context.canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            ...this.props,
            inputType: "text-area",
            identifier: this.identifier,
            addImage: true,
            singleLine: false
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.identifier,
            className: "grouping-text"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.identifier + "/image",
            className: "grouping-img"
        })))));
    }
}






var $6wXVr = parcelRequire("6wXVr");




class $bd0f039907c547a8$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(){
        super();
        this.identifier = "extensions";
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b5ffa3f136ed406e$export$2e2bcd8739ae039), {
            section: this.props.section
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Essential Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "essentialquestion",
            className: "box bg-autofill"
        }), this.context.canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            ...this.props,
            inputType: "text-area",
            identifier: this.identifier,
            addImage: true,
            singleLine: false
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.identifier,
            className: "grouping-text"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.identifier + "/image",
            className: "grouping-img"
        })))));
    }
}





var $hObpn = parcelRequire("hObpn");

var $3UKyI = parcelRequire("3UKyI");
class $26adb41fc1bc483a$export$2e2bcd8739ae039 extends (0, $33c53f2912681500$export$2e2bcd8739ae039) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.emptyState = {
            baseNode: null,
            concepts: [],
            overall: {},
            characteristicsData: {
                unlikePairedCharacteristics: {},
                likePairedCharacteristics: {},
                pairedCharacteristics1: {},
                pairedCharacteristics2: {},
                unpairedCharacteristics1: {},
                unpairedCharacteristics2: {}
            }
        };
        this.props.loadDocMethod();
        this.focused = this.focused.bind(this);
        this.state = this.emptyState;
        this.childRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createRef();
    }
    componentWillUnmount() {
        if (null !== this.state.baseNode) {
            // Don't need to track every listener and detach separately since there should never be more than
            // one of this type of component - it's the whole page.
            let db = window.firebase.database();
            if (this.state.baseNode) db.ref(this.state.baseNode).off();
            if (this.char1BaseRef) db.ref(this.char1BaseRef).off();
            if (this.char2BaseRef) db.ref(this.char2BaseRef).off();
            if (this.likeRef) db.ref(this.likeRef).off();
            if (this.unlikeRef) db.ref(this.unlikeRef).off();
        }
    }
    componentDidMount() {
        super.componentDidMount();
        if (this.context.copyPending && this.context.copyDone) {
            console.log("Should reset state");
            this.restart();
        }
        if (null === this.context.fileType || null === this.context.fileId) console.error("Comparison mounted with no doc context");
        else {
            const baseNode = this.context.fileType + "/" + this.context.fileId;
            this.setState({
                baseNode: baseNode
            });
            // listen for characteristics data
            this.sourceA = "characteristics1";
            this.sourceB = "characteristics2";
            this.char1BaseRef = baseNode + "/" + this.sourceA;
            this.char2BaseRef = baseNode + "/" + this.sourceB;
            this.likeRef = baseNode + "/pairs/likecharacteristics";
            this.unlikeRef = baseNode + "/pairs/unlikecharacteristics";
            this.fetchAndListenUnPairedItems(this.char1BaseRef, "unpairedCharacteristics1");
            this.fetchAndListenUnPairedItems(this.char2BaseRef, "unpairedCharacteristics2");
            this.fetchAndListenPairedItems(this.likeRef, "likePairedCharacteristics");
            this.fetchAndListenPairedItems(this.unlikeRef, "unlikePairedCharacteristics");
        }
    }
    fetchAndListenPairedItems(baseRef, typePair) {
        let pairedNodes = window.firebase.database().ref(baseRef);
        pairedNodes.on("value", (pairList)=>{
            const pairedItems = pairList.val();
            if (pairedItems !== this.state.characteristicsData[typePair]) {
                let newState = this.state;
                newState.characteristicsData[typePair] = pairedItems;
                console.debug("fetchAndListenPairedItems " + typePair + ": %s", $3UKyI.inspect(pairedItems));
                this.setState(newState);
            }
        });
        pairedNodes.on("child_added", (data)=>{
            let pairedKey = data.key;
            let pairedVal = data.val();
            let char1Ref = this.char1BaseRef + "/" + pairedVal["characteristic1"];
            if ("empty" === pairedKey) console.error("empty characteristics pair key was added to db");
            window.firebase.database().ref(char1Ref).once("value", (data)=>{
                let charA = data.val();
                let keyA = data.key;
                let char2Ref = this.char2BaseRef + "/" + pairedVal["characteristic2"];
                if ("" === keyA) console.error("empty paired characteristic1 key found in db");
                window.firebase.database().ref(char2Ref).once("value", (data)=>{
                    let charB = data.val();
                    let keyB = data.key;
                    let cd = this.state.characteristicsData;
                    if ("" === keyB) console.error("empty paired characteristic2 key found in db");
                    if (!cd.hasOwnProperty(typePair) || cd[typePair] === null) cd[typePair] = {};
                    cd[typePair][pairedKey] = pairedVal;
                    cd.pairedCharacteristics1[keyA] = charA;
                    cd.pairedCharacteristics2[keyB] = charB;
                    this.setState({
                        'characteristicsData': cd
                    });
                });
            });
        });
        pairedNodes.on("child_removed", (data)=>{
            let pairedKey = data.key;
            let pairedVal = data.val();
            let char1Ref = this.char1BaseRef + "/" + pairedVal["characteristic1"];
            if ("empty" === pairedKey) console.error("empty characteristics pair key had child removed in db");
            window.firebase.database().ref(char1Ref).once("value", (data)=>{
                let keyA = data.key;
                let char2Ref = this.char2BaseRef + "/" + pairedVal["characteristic2"];
                window.firebase.database().ref(char2Ref).once("value", (data)=>{
                    let keyB = data.key;
                    let newState = this.state;
                    delete newState.characteristicsData[typePair][pairedKey];
                    delete newState.characteristicsData.pairedCharacteristics1[keyA];
                    delete newState.characteristicsData.pairedCharacteristics2[keyB];
                    this.setState(newState);
                });
            });
        });
    }
    fetchAndListenUnPairedItems(baseRef, typeCharacter) {
        let listItemRefs = window.firebase.database().ref(baseRef).orderByChild("status").endAt("");
        listItemRefs.on("child_added", (data)=>{
            let newState = this.state;
            newState.characteristicsData[typeCharacter][data.key] = data.val();
            this.setState(newState);
            if ('likeCharacteristics' === this.props.fileSection || 'unlikeCharacteristics' === this.props.fileSection) this.childRef.current.changeMakePairStatus();
        });
        listItemRefs.on("child_removed", (data)=>{
            let newState = this.state;
            delete newState.characteristicsData[typeCharacter][data.key];
            this.setState(newState);
            if ('likeCharacteristics' === this.props.fileSection || 'unlikeCharacteristics' === this.props.fileSection) this.childRef.current.changeMakePairStatus();
        });
        listItemRefs.on("child_changed", (data)=>{
            let newState = this.state;
            newState.characteristicsData[typeCharacter][data.key] = data.val();
            this.setState(newState);
            if ('likeCharacteristics' === this.props.fileSection || 'unlikeCharacteristics' === this.props.fileSection) this.childRef.current.changeMakePairStatus();
        });
    }
    focused(section) {
        return !(0, $21f9ebdc444decaf$export$6e22c362a0406a2c)(section) && 'complete' !== section;
    }
    trackPageView(section) {
        if ('toc' === section) window.tracker.trackPageView(this.context.currentUser, 'comparison:toc');
        if ('essentialquestion' === section) window.tracker.trackPageView(this.context.currentUser, 'comparison:1');
        if ('terms' === section) window.tracker.trackPageView(this.context.currentUser, 'comparison:2');
        if ('concepts' === section) window.tracker.trackPageView(this.context.currentUser, 'comparison:3');
        if ('overall' === section) window.tracker.trackPageView(this.context.currentUser, 'comparison:4');
        if ('characteristics' === section) window.tracker.trackPageView(this.context.currentUser, 'comparison:5');
        if ('likeCharacteristics' === section) window.tracker.trackPageView(this.context.currentUser, 'comparison:6');
        if ('likeCategories' === section) window.tracker.trackPageView(this.context.currentUser, 'comparison:7');
        if ('unlikeCharacteristics' === section) window.tracker.trackPageView(this.context.currentUser, 'comparison:8');
        if ('unlikeCategories' === section) window.tracker.trackPageView(this.context.currentUser, 'comparison:9');
        if ('summary' === section) window.tracker.trackPageView(this.context.currentUser, 'comparison:10');
        if ('extensions' === section) window.tracker.trackPageView(this.context.currentUser, 'comparison:11');
        if ('complete' === section) window.tracker.trackPageView(this.context.currentUser, 'comparison:review');
        if ('print' === section) window.tracker.trackPageView(this.context.currentUser, 'comparison:print-preview');
        if ('create-share' === section) window.tracker.trackPageView(this.context.currentUser, 'comparison:create-share');
    }
    render() {
        if (!this.context.fileIdLoaded || null === this.state.baseNode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", null, "Loading file...");
        // else {console.debug(util.inspect(this.state));}
        const section = this.props.fileSection;
        const doc = {
            section: section,
            type: this.context.fileType,
            id: this.context.fileId,
            title: this.context.fileName,
            editing: this.context.canEdit
        };
        // assert("comparison" === doc.type);
        const sections = (0, $198066ba87364cec$export$2e2bcd8739ae039)[doc.type].sections;
        $hObpn(undefined !== sections && 0 < sections.length);
        const toc = this.focused(doc.section) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: sections[0].toc,
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6e7539b03a30b35c$export$2e2bcd8739ae039), {
            doc: doc,
            steps: sections
        })) : "";
        const essential_question = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $9e8fa687f5977758$export$2e2bcd8739ae039), {
            doc: doc,
            section: (0, $198066ba87364cec$export$2e2bcd8739ae039).comparison.sections[1]
        });
        const concepts = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $83eb865cd48a85bd$export$2e2bcd8739ae039), {
            stepnum: "1",
            doc: doc,
            section: (0, $198066ba87364cec$export$2e2bcd8739ae039).comparison.sections[3]
        }));
        const overall = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "step2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $9c683f33ac1b0759$export$2e2bcd8739ae039), {
            doc: doc,
            section: (0, $198066ba87364cec$export$2e2bcd8739ae039).comparison.sections[4]
        }));
        const characteristics = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $46c9ea439613aa96$export$2e2bcd8739ae039), {
            doc: doc,
            section: (0, $198066ba87364cec$export$2e2bcd8739ae039).comparison.sections[5],
            data: this.state.characteristicsData
        });
        const like_characteristics = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $7c272f631773d5f7$export$2e2bcd8739ae039), {
            ref: this.childRef,
            doc: doc,
            section: (0, $198066ba87364cec$export$2e2bcd8739ae039).comparison.sections[6],
            data: this.state.characteristicsData
        });
        const unlike_characteristics = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $58d7ead67a01a33a$export$2e2bcd8739ae039), {
            ref: this.childRef,
            doc: doc,
            section: (0, $198066ba87364cec$export$2e2bcd8739ae039).comparison.sections[8],
            data: this.state.characteristicsData
        });
        const like_categories = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $158f9c4c7cb73f26$export$2e2bcd8739ae039), {
            doc: doc,
            section: (0, $198066ba87364cec$export$2e2bcd8739ae039).comparison.sections[7],
            data: this.state.characteristicsData
        });
        const unlike_categories = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $cdb4f5b9df6b26c7$export$2e2bcd8739ae039), {
            doc: doc,
            section: (0, $198066ba87364cec$export$2e2bcd8739ae039).comparison.sections[9],
            data: this.state.characteristicsData
        });
        const summary = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $149fbb0f12d27fb4$export$2e2bcd8739ae039), {
            doc: doc,
            section: (0, $198066ba87364cec$export$2e2bcd8739ae039).comparison.sections[10]
        });
        const extensions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $bd0f039907c547a8$export$2e2bcd8739ae039), {
            doc: doc,
            section: (0, $198066ba87364cec$export$2e2bcd8739ae039).comparison.sections[11]
        });
        const print_preview = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $4697c200a6a70c90$export$2e2bcd8739ae039), {
            doc: doc,
            section: "print",
            data: this.state.characteristicsData
        });
        const createShare = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $002e046ed3b7cd22$export$2e2bcd8739ae039), {
            shareMethod: this.props.shareMethod
        });
        const terms = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8385a289acdc9680$export$2e2bcd8739ae039), {
            doc: doc,
            tooltipTitle: true,
            section: (0, $198066ba87364cec$export$2e2bcd8739ae039).comparison.sections[2]
        });
        this.trackPageView(section);
        const content = this.focused(section) ? 'toc' === section ? toc : 'essentialquestion' === section ? essential_question : 'terms' === section ? terms : 'concepts' === section ? concepts : 'overall' === section ? overall : 'characteristics' === section ? characteristics : 'likeCharacteristics' === section ? like_characteristics : 'likeCategories' === section ? like_categories : 'unlikeCharacteristics' === section ? unlike_characteristics : 'unlikeCategories' === section ? unlike_categories : 'summary' === section ? summary : 'extensions' === section ? extensions : 'complete' === section ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $4ba48d123e66d691$export$2e2bcd8739ae039), {
            section: section,
            data: this.state.characteristicsData,
            editing: false
        }) : 'print' === section ? print_preview : 'create-share' === section ? createShare : toc : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $4ba48d123e66d691$export$2e2bcd8739ae039), {
            section: "complete",
            data: this.state.characteristicsData,
            editing: false
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $cc8ee9c202478e66$export$2e2bcd8739ae039), {
            content: content,
            doc: doc,
            data: this.state.characteristicsData,
            ...this.props
        });
    }
}



var $6wXVr = parcelRequire("6wXVr");











var $6wXVr = parcelRequire("6wXVr");


class $b225382ba32fbadb$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.identifier = "essentialquestion";
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b5ffa3f136ed406e$export$2e2bcd8739ae039), {
            section: this.props.section,
            tooltipTitle: true
        }), this.context.canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            ...this.props,
            inputType: "text-area",
            identifier: "topic",
            addImage: false,
            singleLine: false
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            ...this.props,
            inputType: "text-area",
            identifier: this.identifier,
            addImage: true,
            singleLine: false
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "topic",
            className: "box bg-autofill"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.identifier,
            className: "grouping-text"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.identifier + "/image",
            className: "grouping-img"
        })))));
    }
}




var $6wXVr = parcelRequire("6wXVr");


class $e9bcffaa96ccb1e5$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    constructor(props){
        super(props);
        this.identifier = "relatedquestion";
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b5ffa3f136ed406e$export$2e2bcd8739ae039), {
            section: this.props.section,
            tooltipTitle: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Essential Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "essentialquestion",
            className: "box bg-autofill flex-grow-1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $015518484befd1f6$export$2e2bcd8739ae039), {
            doc: this.props.doc,
            identifier: "relatedquestion",
            canBeEmpty: false,
            data: this.props.data
        }));
    }
}




var $6wXVr = parcelRequire("6wXVr");


class $f8eb7c40efdf3072$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    constructor(props){
        super(props);
        this.identifier = "relatedquestionresponse";
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b5ffa3f136ed406e$export$2e2bcd8739ae039), {
            section: this.props.section
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Essential Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "essentialquestion",
            className: "box bg-autofill"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $015518484befd1f6$export$2e2bcd8739ae039), {
            doc: this.props.doc,
            identifier: "relatedquestion",
            haveResponse: true,
            canBeEmpty: false,
            data: this.props.data
        }));
    }
}




var $6wXVr = parcelRequire("6wXVr");



class $8784b31277c8c86f$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.identifier = "essentialquestionresponse";
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b5ffa3f136ed406e$export$2e2bcd8739ae039), {
            section: this.props.section,
            tooltipTitle: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Essential Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "essentialquestion",
            className: "box bg-autofill"
        }), this.context.canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            ...this.props,
            inputType: "text-area",
            identifier: this.identifier,
            addImage: true,
            singleLine: false
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.identifier,
            className: "grouping-text"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.identifier + "/image",
            className: "grouping-img"
        })))));
    }
}




var $6wXVr = parcelRequire("6wXVr");



class $99df80ec070d9fff$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.identifier = "contextresponse";
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b5ffa3f136ed406e$export$2e2bcd8739ae039), {
            section: this.props.section
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Response to Essential Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "essentialquestionresponse",
            className: "box bg-autofill"
        }), this.context.canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            ...this.props,
            inputType: "text-area",
            identifier: this.identifier,
            addImage: true,
            singleLine: false
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.identifier,
            className: "grouping-text"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.identifier + "/image",
            className: "grouping-img"
        })))));
    }
}




var $6wXVr = parcelRequire("6wXVr");



class $40073e33c38cc018$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.identifier = "extensions";
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b5ffa3f136ed406e$export$2e2bcd8739ae039), {
            section: this.props.section
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Response to Essential Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "essentialquestionresponse",
            className: "box bg-autofill"
        }), this.context.canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            ...this.props,
            inputType: "text-area",
            identifier: this.identifier,
            addImage: true,
            singleLine: false
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.identifier,
            className: "grouping-text"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.identifier + "/image",
            className: "grouping-img"
        })))));
    }
}





var $hObpn = parcelRequire("hObpn");
class $aa8819596c1d14e9$export$2e2bcd8739ae039 extends (0, $33c53f2912681500$export$2e2bcd8739ae039) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.emptyState = {};
        this.props.loadDocMethod();
        this.focused = this.focused.bind(this);
        this.state = this.emptyState;
    }
    trackPageView(section) {
        if ('toc' === section) window.tracker.trackPageView(this.context.currentUser, 'question-exp:toc');
        if ('essentialquestion' === section) window.tracker.trackPageView(this.context.currentUser, 'question-exp:1');
        if ('terms' === section) window.tracker.trackPageView(this.context.currentUser, 'question-exp:2');
        if ('relatedquestion' === section) window.tracker.trackPageView(this.context.currentUser, 'question-exp:3');
        if ('relatedquestionresponse' === section) window.tracker.trackPageView(this.context.currentUser, 'question-exp:4');
        if ('essentialquestionresponse' === section) window.tracker.trackPageView(this.context.currentUser, 'question-exp:5');
        if ('contextresponse' === section) window.tracker.trackPageView(this.context.currentUser, 'question-exp:6');
        if ('extensions' === section) window.tracker.trackPageView(this.context.currentUser, 'question-exp:7');
        if ('complete' === section) window.tracker.trackPageView(this.context.currentUser, 'question-exp:review');
        if ('print' === section) window.tracker.trackPageView(this.context.currentUser, 'question-exp:print-preview');
        if ('create-share' === section) window.tracker.trackPageView(this.context.currentUser, 'question-exp:create-share');
    }
    render() {
        if (!this.context.fileIdLoaded || null === this.state.baseNode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", null, "Loading file...");
        // console.log(this.props);
        const section = this.props.fileSection;
        const doc = {
            section: section,
            type: this.context.fileType,
            id: this.context.fileId,
            title: this.context.fileName,
            editing: this.context.canEdit
        };
        const sections = (0, $198066ba87364cec$export$2e2bcd8739ae039)[doc.type].sections;
        $hObpn(undefined !== sections && 0 < sections.length);
        const toc = this.focused(doc.section) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: sections[0].toc,
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6e7539b03a30b35c$export$2e2bcd8739ae039), {
            doc: doc,
            steps: sections
        })) : "";
        const essential_question = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b225382ba32fbadb$export$2e2bcd8739ae039), {
            doc: doc,
            section: (0, $198066ba87364cec$export$2e2bcd8739ae039)["question-exp"].sections[1]
        });
        const related_question = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e9bcffaa96ccb1e5$export$2e2bcd8739ae039), {
            doc: doc,
            section: (0, $198066ba87364cec$export$2e2bcd8739ae039)["question-exp"].sections[3]
        });
        const related_question_response = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $f8eb7c40efdf3072$export$2e2bcd8739ae039), {
            doc: doc,
            section: (0, $198066ba87364cec$export$2e2bcd8739ae039)["question-exp"].sections[4]
        });
        const essential_question_response = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8784b31277c8c86f$export$2e2bcd8739ae039), {
            doc: doc,
            section: (0, $198066ba87364cec$export$2e2bcd8739ae039)["question-exp"].sections[5]
        });
        const context_response = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $99df80ec070d9fff$export$2e2bcd8739ae039), {
            doc: doc,
            section: (0, $198066ba87364cec$export$2e2bcd8739ae039)["question-exp"].sections[6]
        });
        const extensions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $40073e33c38cc018$export$2e2bcd8739ae039), {
            doc: doc,
            section: (0, $198066ba87364cec$export$2e2bcd8739ae039)["question-exp"].sections[7]
        });
        const print_preview = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $4697c200a6a70c90$export$2e2bcd8739ae039), {
            doc: doc,
            section: "print",
            data: this.state.characteristicsData
        });
        const createShare = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $002e046ed3b7cd22$export$2e2bcd8739ae039), {
            shareMethod: this.props.shareMethod
        });
        const terms = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8385a289acdc9680$export$2e2bcd8739ae039), {
            doc: doc,
            section: (0, $198066ba87364cec$export$2e2bcd8739ae039)["question-exp"].sections[2],
            tooltipTitle: true
        });
        this.trackPageView(section);
        const content = this.focused(section) ? 'toc' === section ? toc : 'essentialquestion' === section ? essential_question : 'terms' === section ? terms : 'relatedquestion' === section ? related_question : 'relatedquestionresponse' === section ? related_question_response : 'essentialquestionresponse' === section ? essential_question_response : 'contextresponse' === section ? context_response : 'extensions' === section ? extensions : 'complete' === section ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $4ba48d123e66d691$export$2e2bcd8739ae039), {
            section: section,
            data: this.state.characteristicsData,
            editing: false
        }) : 'print' === section ? print_preview : 'create-share' === section ? createShare : toc : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $4ba48d123e66d691$export$2e2bcd8739ae039), {
            section: "complete",
            data: this.state.characteristicsData,
            editing: false
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $cc8ee9c202478e66$export$2e2bcd8739ae039), {
            content: content,
            doc: doc,
            data: this.state.characteristicsData,
            ...this.props
        });
    }
    focused(section) {
        return !(0, $21f9ebdc444decaf$export$6e22c362a0406a2c)(section) && 'complete' !== section;
    }
}



var $6wXVr = parcelRequire("6wXVr");











var $6wXVr = parcelRequire("6wXVr");


class $4be2a7bf46a21677$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.identifier = "essentialquestion";
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b5ffa3f136ed406e$export$2e2bcd8739ae039), {
            section: this.props.section,
            tooltipTitle: true
        }), this.context.canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            ...this.props,
            inputType: "text-area",
            identifier: "topic",
            addImage: false,
            singleLine: false
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            ...this.props,
            inputType: "text-area",
            identifier: this.identifier,
            addImage: true,
            singleLine: false
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "topic",
            className: "box bg-autofill"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.identifier,
            className: "grouping-text"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.identifier + "/image",
            className: "grouping-img"
        })))));
    }
}




var $6wXVr = parcelRequire("6wXVr");



class $a20a2606f130a15a$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.identifier = "claim";
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b5ffa3f136ed406e$export$2e2bcd8739ae039), {
            section: this.props.section,
            tooltipTitle: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Essential Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "essentialquestion",
            className: "box bg-autofill"
        }), this.context.canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            ...this.props,
            inputType: "text-area",
            identifier: this.identifier,
            addImage: false,
            singleLine: false
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            ...this.props,
            inputType: "text-area",
            identifier: "claimcontext",
            addImage: true,
            singleLine: false
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: this.identifier,
            className: "box bg-autofill"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "claimcontext",
            className: "grouping-text"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "claimcontext/image",
            className: "grouping-img"
        })))));
    }
}




var $6wXVr = parcelRequire("6wXVr");



class $e909cd50cb01ca2f$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    constructor(props){
        super(props);
        this.identifier = "evidencesupport";
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b5ffa3f136ed406e$export$2e2bcd8739ae039), {
            section: this.props.section,
            tooltipTitle: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Claim"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "claim",
            className: "box bg-autofill"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $78739bc7dc9cfb57$export$2e2bcd8739ae039), {
            doc: this.props.doc,
            identifier: "evidencesupport",
            canBeEmpty: false,
            data: this.props.data,
            hLevel: 2,
            hClassName: "h3"
        }));
    }
}



var $6wXVr = parcelRequire("6wXVr");



class $8fc52642dabed99d$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    constructor(props){
        super(props);
        this.identifier = "evidenceopposes";
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b5ffa3f136ed406e$export$2e2bcd8739ae039), {
            section: this.props.section,
            tooltipTitle: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Claim"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "claim",
            className: "box bg-autofill"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $78739bc7dc9cfb57$export$2e2bcd8739ae039), {
            doc: this.props.doc,
            identifier: "evidenceopposes",
            canBeEmpty: false,
            data: this.props.data,
            hLevel: 2,
            hClassName: "h3"
        }));
    }
}



var $6wXVr = parcelRequire("6wXVr");


class $e8c35c01fee865c1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    constructor(props){
        super(props);
        this.identifier = "evidencequality";
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b5ffa3f136ed406e$export$2e2bcd8739ae039), {
            section: this.props.section
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Supporting Evidence"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $78739bc7dc9cfb57$export$2e2bcd8739ae039), {
            doc: this.props.doc,
            identifier: "evidencesupport",
            qualityStep: true,
            canBeEmpty: false,
            data: this.props.data,
            hLevel: 3
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("hr", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Opposing Evidence"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $78739bc7dc9cfb57$export$2e2bcd8739ae039), {
            doc: this.props.doc,
            identifier: "evidenceopposes",
            qualityStep: true,
            canBeEmpty: false,
            data: this.props.data,
            hLevel: 3
        }));
    }
}




var $6wXVr = parcelRequire("6wXVr");






class $d20964560c6e7674$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.identifier = "reasoningnote";
    }
    getParentNode() {
        let parentNode = this.context.fileType + "/" + this.context.fileId;
        return parentNode;
    }
    render() {
        const reasoningtype = this.context.canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "form-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $3d246ea7b59b7507$export$2e2bcd8739ae039), {
            identifier: "reasoningtype",
            parentNode: this.getParentNode(),
            placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(this.props.doc.type + ".reasoningtype.placeholder"),
            label: "Evidence Quality",
            autocompleteOptions: [
                'This evidence supports the claim because...',
                'This evidence does not support the claim because...',
                "Based on the evidence, I conclude that\u2026"
            ]
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $c0e31515b414b5e0$export$2e2bcd8739ae039), {
            identifier: "reasoningtype",
            className: "col"
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b5ffa3f136ed406e$export$2e2bcd8739ae039), {
            section: this.props.section,
            tooltipTitle: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Claim"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b9bd18905366e6a9$export$2e2bcd8739ae039), {
            identifier: "claim",
            className: "box bg-autofill"
        }), this.context.canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-primary"
        }, reasoningtype, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            ...this.props,
            inputType: "text-area",
            identifier: this.identifier,
            addImage: true,
            singleLine: false
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, reasoningtype, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8685bff03fd3636e$export$2e2bcd8739ae039), {
            ...this.props,
            inputType: "text-area",
            identifier: this.identifier,
            addImage: true,
            singleLine: false
        })));
    }
}



var $hObpn = parcelRequire("hObpn");
class $0ebe11f4812031c8$export$2e2bcd8739ae039 extends (0, $33c53f2912681500$export$2e2bcd8739ae039) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.emptyState = {};
        this.props.loadDocMethod();
        this.focused = this.focused.bind(this);
        this.state = this.emptyState;
    }
    trackPageView(section) {
        if ('toc' === section) window.tracker.trackPageView(this.context.currentUser, 'cera:toc');
        if ('essentialquestion' === section) window.tracker.trackPageView(this.context.currentUser, 'cera:1');
        if ('terms' === section) window.tracker.trackPageView(this.context.currentUser, 'cera:2');
        if ('claim' === section) window.tracker.trackPageView(this.context.currentUser, 'cera:3');
        if ('evidencesupport' === section) window.tracker.trackPageView(this.context.currentUser, 'cera:4');
        if ('evidenceopposes' === section) window.tracker.trackPageView(this.context.currentUser, 'cera:5');
        if ('evidencequality' === section) window.tracker.trackPageView(this.context.currentUser, 'cera:6');
        if ('reasoning' === section) window.tracker.trackPageView(this.context.currentUser, 'cera:7');
        if ('complete' === section) window.tracker.trackPageView(this.context.currentUser, 'cera:review');
        if ('print' === section) window.tracker.trackPageView(this.context.currentUser, 'cera:print-preview');
        if ('create-share' === section) window.tracker.trackPageView(this.context.currentUser, 'cera:create-share');
    }
    render() {
        if (!this.context.fileIdLoaded || null === this.state.baseNode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", null, "Loading file...");
        // console.log(this.props);
        const section = this.props.fileSection;
        const doc = {
            section: section,
            type: this.context.fileType,
            id: this.context.fileId,
            title: this.context.fileName,
            editing: this.context.canEdit
        };
        const sections = (0, $198066ba87364cec$export$2e2bcd8739ae039)[doc.type].sections;
        $hObpn(undefined !== sections && 0 < sections.length);
        const toc = this.focused(doc.section) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: sections[0].toc,
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6e7539b03a30b35c$export$2e2bcd8739ae039), {
            doc: doc,
            steps: sections
        })) : "";
        const essential_question = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $4be2a7bf46a21677$export$2e2bcd8739ae039), {
            doc: doc,
            section: (0, $198066ba87364cec$export$2e2bcd8739ae039)["cera"].sections[1]
        });
        const terms = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8385a289acdc9680$export$2e2bcd8739ae039), {
            doc: doc,
            tooltipTitle: true,
            section: (0, $198066ba87364cec$export$2e2bcd8739ae039)["cera"].sections[2]
        });
        const claim = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a20a2606f130a15a$export$2e2bcd8739ae039), {
            doc: doc,
            section: (0, $198066ba87364cec$export$2e2bcd8739ae039)["cera"].sections[3]
        });
        const evidence_support = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e909cd50cb01ca2f$export$2e2bcd8739ae039), {
            doc: doc,
            section: (0, $198066ba87364cec$export$2e2bcd8739ae039)["cera"].sections[4]
        });
        const evidence_opposes = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $8fc52642dabed99d$export$2e2bcd8739ae039), {
            doc: doc,
            section: (0, $198066ba87364cec$export$2e2bcd8739ae039)["cera"].sections[5]
        });
        const evidence_quality = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e8c35c01fee865c1$export$2e2bcd8739ae039), {
            doc: doc,
            section: (0, $198066ba87364cec$export$2e2bcd8739ae039)["cera"].sections[6]
        });
        const reasoning = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $d20964560c6e7674$export$2e2bcd8739ae039), {
            doc: doc,
            section: (0, $198066ba87364cec$export$2e2bcd8739ae039)["cera"].sections[7]
        });
        const createShare = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $002e046ed3b7cd22$export$2e2bcd8739ae039), {
            shareMethod: this.props.shareMethod
        });
        this.trackPageView(section);
        const content = this.focused(section) ? 'toc' === section ? toc : 'essentialquestion' === section ? essential_question : 'terms' === section ? terms : 'claim' === section ? claim : 'evidencesupport' === section ? evidence_support : 'evidenceopposes' === section ? evidence_opposes : 'evidencequality' === section ? evidence_quality : 'reasoning' === section ? reasoning : 'create-share' === section ? createShare : toc : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $4ba48d123e66d691$export$2e2bcd8739ae039), {
            section: "complete",
            editing: false
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $cc8ee9c202478e66$export$2e2bcd8739ae039), {
            content: content,
            doc: doc,
            ...this.props
        });
    }
    focused(section) {
        return !(0, $21f9ebdc444decaf$export$6e22c362a0406a2c)(section) && 'complete' !== section;
    }
}



var $6wXVr = parcelRequire("6wXVr");
var $d201f1860da572dc$exports = {};
$d201f1860da572dc$exports = $parcel$resolve("8GOmI");


class $fca58f9f96fb5ae5$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "container-max"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "page-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "content",
            className: "content row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "content-main col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "content-main-inner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("main", {
            id: "main_container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "text-center pt-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h1", null, "Ruh-roh!"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($d201f1860da572dc$exports))),
            className: "img-fluid mt-1 mb-2",
            alt: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "We couldn't find that page!"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", null, "To open a recent guide of begin a new one, go ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "/"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-home me-0_25",
            "aria-hidden": "true"
        }), "home")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", null, "Need help? Visit ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "/support"
        }, "user support"), " or contact ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "mailto:corgi@cast.org"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-envelope me-0_25",
            "aria-hidden": "true"
        }), "corgi@cast.org")))))))));
    }
}



var $6wXVr = parcelRequire("6wXVr");



class $36cff33fa1941399$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    componentDidMount() {
        window.tracker.trackPageView(this.context.currentUser, 'attributions');
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "container-max"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "page-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "content",
            className: "content row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "content-main col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "content-main-inner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $508248f6f0651524$export$2e2bcd8739ae039), {
            name: "Attributions"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("main", {
            id: "main_container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h1", {
            id: "content"
        }, "Attributions"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            className: "h3"
        }, "Corgi Application"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).p, {
            text: {
                key: "utility.footer"
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            className: "h3"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate("cause-effect.title")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).p, {
            text: {
                key: "cause-effect.footer"
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            className: "h3"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate("question-exp.title")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).p, {
            text: {
                key: "question-exp.footer"
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            className: "h3"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate("comparison.title")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).p, {
            text: {
                key: "comparison.footer"
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            className: "h3"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate("cera.title")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).p, {
            text: {
                key: "cera.footer"
            }
        })))))));
    }
}



var $6wXVr = parcelRequire("6wXVr");



var $6wXVr = parcelRequire("6wXVr");

var $5ea553454ac89254$exports = {};
$5ea553454ac89254$exports = $parcel$resolve("8Gots");


var $6a74d9a109b0485e$exports = {};
$6a74d9a109b0485e$exports = $parcel$resolve("ihElY");


var $b726331d4e0d352e$exports = {};
$b726331d4e0d352e$exports = $parcel$resolve("8Sr3O");


var $3a319692a31e83ea$exports = {};
$3a319692a31e83ea$exports = $parcel$resolve("eyv73");


var $01c80a944239f525$exports = {};
$01c80a944239f525$exports = $parcel$resolve("b8Bh1");


var $dd9d691be85efee9$exports = {};
$dd9d691be85efee9$exports = $parcel$resolve("46wHe");


var $48d0b1eed08491ac$exports = {};
$48d0b1eed08491ac$exports = $parcel$resolve("8gH0P");


var $a60c65c26f5eefe6$exports = {};
$a60c65c26f5eefe6$exports = $parcel$resolve("gqrtm");


var $b64d017e53142668$exports = {};
$b64d017e53142668$exports = $parcel$resolve("f9MzL");


var $107b00f4e56b8b52$exports = {};
$107b00f4e56b8b52$exports = $parcel$resolve("d5GJj");


var $79f2c59a4e9b9d62$exports = {};
$79f2c59a4e9b9d62$exports = $parcel$resolve("3utiB");


var $ca0bf9254a5712d2$exports = {};
$ca0bf9254a5712d2$exports = $parcel$resolve("5uvCa");


class $824ff2f055cf4673$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill pt-1 py-md-1_5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "container px-0 px-md-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "px-1 px-md-0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            id: "why",
            className: "h1"
        }, "Why Corgi Works"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", {
            className: "lead"
        }, "The Corgi process supports students to develop content-specific practices and habits of mind")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row gx-0",
            "data-cfw": "slideshow"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-4"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("nav", {
            "aria-label": "slides"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "list list-spaced mb-0 px-1 px-md-0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "list-item list-item-action font-weight-bold",
            "data-cfw": "tab",
            "data-cfw-tab-target": "#loginWhy0"
        }, "Explore"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "list-item list-item-action font-weight-bold",
            "data-cfw": "tab",
            "data-cfw-tab-target": "#loginWhy1"
        }, "Organize"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "list-item list-item-action font-weight-bold",
            "data-cfw": "tab",
            "data-cfw-tab-target": "#loginWhy2"
        }, "Synthesize"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "list-item list-item-action font-weight-bold",
            "data-cfw": "tab",
            "data-cfw-tab-target": "#loginWhy3"
        }, "Share")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "tab-content login-slides"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "btn btn-link btn-icon fs-3xlarge login-slides-prev",
            "data-cfw-slideshow-nav": "prev"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fas fa-fw fa-chevron-left",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Previous Slide")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "btn btn-link btn-icon fs-3xlarge login-slides-next",
            "data-cfw-slideshow-nav": "next"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fas fa-fw fa-chevron-right",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Next Slide")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "tab-pane",
            id: "loginWhy0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($5ea553454ac89254$exports))),
            className: "img-fluid",
            alt: "A student and teacher smiling while they work together at a computer"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "login-slide-text"
        }, "Explore a topic guided by your essential question")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "tab-pane",
            id: "loginWhy1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($6a74d9a109b0485e$exports))),
            className: "img-fluid",
            alt: "A student filling out a Corgi guide on a laptop"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "login-slide-text"
        }, "Organize your information with the Corgi guide, step by step")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "tab-pane",
            id: "loginWhy2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($b726331d4e0d352e$exports))),
            className: "img-fluid",
            alt: "A young student looking engaged while working on a laptop"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "login-slide-text"
        }, "Dig deep into the information and make sense of your learning")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "tab-pane",
            id: "loginWhy3"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($3a319692a31e83ea$exports))),
            className: "img-fluid",
            alt: "A student presenting at a whiteboard in front of his class while his teacher looks on"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "login-slide-text"
        }, "Share your learning through a variety of output options"))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "pt-1 py-md-1_5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "container px-0 px-md-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row gx-0 gx-md-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6 px-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            id: "research",
            className: "h1"
        }, "Research shows Corgi helps students learn"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", {
            className: "lead"
        }, "Corgi is an effective tool for learning"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, "Students, including those with learning disabilities, made significant gains learning science and U.S. history content when using Corgi."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e10f0f56b55cf4b2$export$2e2bcd8739ae039), {
            page: "faq",
            hash: "#faq05",
            className: "link-icon"
        }, "Learn about our studies and evaluations", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fas fa-arrow-right",
            title: "(external site)"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", null, "Research with us!"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, "We're looking for research partners to try out Corgi in the classroom.", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "mailto:corgi@cast.org"
        }, "Contact us"), " to learn more.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6 order-md-first"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($01c80a944239f525$exports))),
            className: "img-fluid",
            alt: "Two people working on computers in a classroom"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill pt-1 py-md-1_5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            id: "features",
            className: "h1"
        }, "What makes Corgi different?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", {
            className: "lead"
        }, "These are just some of the key features that set Corgi apart:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row row-cols-1 row-cols-sm-2 row-cols-md-3 gx-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col d-flex"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card login-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($dd9d691be85efee9$exports))),
            className: "img-fluid card-img-top",
            alt: "Google Drive and Google Classroom logos"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card-body"
        }, "Integrates with Google Drive and Classroom"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card-footer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "#technology",
            className: "link-icon"
        }, "Learn how Corgi works with Google apps", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fas fa-arrow-right",
            title: "(external site)"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col d-flex"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card login-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($48d0b1eed08491ac$exports))),
            className: "img-fluid card-img-top",
            alt: "Three users working together on one idea"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card-body"
        }, "Supports real-time collaboration"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card-footer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://youtu.be/L2JDv-T-td0",
            className: "link-icon"
        }, "Watch a remote learning demo", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fas fa-arrow-right",
            title: "(external site)"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col d-flex"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card login-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($a60c65c26f5eefe6$exports))),
            className: "img-fluid card-img-top",
            alt: "Three regions of the brain that are activated by Universal Design for Learning: representation, engagement, and action & expression"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card-body"
        }, "Embeds Universal Design for Learning (UDL) to reduce barriers and increase access"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card-footer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://youtu.be/YSN4stu6ZgY",
            className: "link-icon"
        }, "See a walkthrough of our support features", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fas fa-arrow-right",
            title: "(external site)"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col d-flex"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card login-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($b64d017e53142668$exports))),
            className: "img-fluid card-img-top",
            alt: "Next Generation Science Standards logo"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card-body"
        }, "Aligns with Next Generation Science Standards"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card-footer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://docs.google.com/document/d/1dAB-lNMeE-E38YOxARfWgHytGgQ0Jq9f0H16WyvXqw8/edit",
            className: "link-icon",
            target: "_blank",
            rel: "noopener noreferrer"
        }, "Check out a science lesson", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fas fa-arrow-right",
            title: "(external site)"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col d-flex"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card login-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($107b00f4e56b8b52$exports))),
            className: "img-fluid card-img-top",
            alt: "Strategic Instruction Model logo"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card-body"
        }, "Builds upon the learning strategies developed by SIM"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card-footer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e10f0f56b55cf4b2$export$2e2bcd8739ae039), {
            page: "faq",
            hash: "#faq08",
            className: "link-icon"
        }, "Learn how Corgi and SIM work together", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fas fa-arrow-right",
            title: "(external site)"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col d-flex"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card login-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($79f2c59a4e9b9d62$exports))),
            className: "img-fluid card-img-top",
            alt: "Google Slides and PDF logos"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card-body"
        }, "Provides multiple options for learners to interact with, express, and present their learning"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card-footer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://youtu.be/L2JDv-T-td0?t=655",
            className: "link-icon"
        }, "Check out the presentation builder in Corgi", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fas fa-arrow-right",
            title: "(external site)"
        })))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "pt-1 py-md-1_5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "container px-0 px-md-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row gx-0 gx-md-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6 px-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            id: "teach",
            className: "h1"
        }, "Teach with Corgi in your classroom"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", {
            className: "lead"
        }, "Lessons created for teachers, by teachers"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, "The Corgi application includes an ever growing library of community sourced units and lessons for educators to use and adapt. So take, remix and use any unit or lesson you find, then add your own learning materials and help grow the Corgi community!"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://docs.google.com/document/d/1dAB-lNMeE-E38YOxARfWgHytGgQ0Jq9f0H16WyvXqw8/edit",
            target: "_blank",
            rel: "noopener noreferrer"
        }, "Preview a sample lesson"), " or ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "/"
        }, "create an account"), " to explore the lesson library.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6 order-md-first"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($ca0bf9254a5712d2$exports))),
            className: "img-fluid",
            alt: "Laptop with Corgi\u2019s teacher version showing onscreen"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill pt-1 py-md-1_5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            id: "technology",
            className: "h1"
        }, "Corgi ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "far fa-heart",
            "aria-label": "loves"
        }), " Google"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", {
            className: "lead"
        }, "Corgi is built with Google technology."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row row-cols-1 row-cols-sm-2 gx-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col d-flex"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card login-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media login-media"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fab fa-google-drive fa-fw login-media-icon",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media-body"
        }, "Login with your Google account. Corgi will save your work directly to your Google Drive."))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col d-flex"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card login-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media login-media"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fas fa-users fa-fw login-media-icon",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media-body"
        }, "Just like Google apps, multiple users can co-edit a Corgi Guide together."))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col d-flex"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card login-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media login-media"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fas fa-desktop fa-fw login-media-icon",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media-body"
        }, "Use Google Classroom? Corgi connects directly to Classroom so teachers can create assignments and students can submit their work right in the app."))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col d-flex"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card login-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media login-media"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fas fa-chalkboard-teacher fa-fw login-media-icon",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media-body"
        }, "Learners can transform their completed Corgi Guides into Google Slides presentations automatically.")))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "py-1 border-t"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "container fs-xsmall"
        }, "Image attributions:", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", {
            className: "list-unstyled mb-0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, '"collaborative idea" by Tomas Knopp from the Noun Project'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, '"Monitor" by karacis studio from the Noun Project'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, '"presentation" by Calvin Goodman from the Noun Project')))));
    }
}





class $a9ec8f7c5798b893$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    componentDidMount() {
        (0, $2c839b9f78572b9b$export$2e2bcd8739ae039)();
        (0, $01b9ff3914809222$export$be2be31541771141)();
    }
    render() {
        let playlist = [
            {
                id: 1,
                name: 'An introduction to Project Corgi',
                video: 'wsuItKMaEBY',
                poster: 'user-support-video-poster-intro.png',
                description: 'Jamie Basham and Jose Blackorby discuss the origin and evolution of the Corgi tool.'
            },
            {
                id: 2,
                name: 'Meet Corgi',
                video: 'ViQjOM3NK7c',
                poster: 'user-support-video-poster-meet.png',
                description: 'Corgi is a set of digital graphic organizers that helps you co-organize your learning.'
            }
        ];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "page-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "content",
            className: "content row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "content-main col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "content-main-inner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $508248f6f0651524$export$2e2bcd8739ae039), {
            name: "About Corgi"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("main", {
            id: "main_container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h1", null, "Corgi: Co-organize your learning"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", {
            className: "list-unstyled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item mb-0_5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "#background"
        }, "Background")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item mb-0_5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "#why"
        }, "The Corgi Process")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item mb-0_5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "#research"
        }, "Research")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item mb-0_5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "#features"
        }, "Key Features")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item mb-0_5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "#teach"
        }, "Teach with Corgi")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item mb-0_5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "#technology"
        }, "Technology"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "pt-1 py-md-1_5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            id: "background",
            className: "h1"
        }, "Background"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "container px-0 px-md-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row gx-0 gx-md-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6 px-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $5b2aaa3e3aa41ef7$export$2e2bcd8739ae039), {
            video_id: playlist[0].video,
            name: playlist[0].name
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            className: "link-icon",
            target: "_blank",
            href: "https://youtu.be/" + playlist[0].video,
            rel: "noopener noreferrer"
        }, playlist[0].description, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fas fa-external-link-alt",
            title: "(external site)"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6 px-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $5b2aaa3e3aa41ef7$export$2e2bcd8739ae039), {
            video_id: playlist[1].video,
            name: playlist[1].name
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            className: "link-icon",
            target: "_blank",
            href: "https://youtu.be/" + playlist[1].video,
            rel: "noopener noreferrer"
        }, playlist[1].description, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fas fa-external-link-alt",
            title: "(external site)"
        })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $824ff2f055cf4673$export$2e2bcd8739ae039), null))))));
    }
}



var $6wXVr = parcelRequire("6wXVr");





window.jQuery = window.$ = (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)));
class $772d297780303d52$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Component {
    componentDidMount() {
        const element = (0, $01b9ff3914809222$export$f21eb943f370a62a)();
        (0, $01b9ff3914809222$export$be2be31541771141)();
        // Open faq item
        if (element && element.matches('[data-cfw="collapse"]')) {
            const $element = (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))(element);
            $element.one('init.cfw.collapse', function() {
                $element.CFW_Collapse('show');
            });
        }
        (0, $2c839b9f78572b9b$export$2e2bcd8739ae039)();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "page-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "content",
            className: "content row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "content-main col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "content-main-inner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $508248f6f0651524$export$2e2bcd8739ae039), {
            name: "Corgi FAQ"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("main", {
            id: "main_container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h1", null, "Find answers to frequently asked questions"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "#faq00-answer",
            id: "faq00",
            "data-cfw": "collapse"
        }, "What's the goal of Corgi?", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "caret ms-0_25"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "faq00-answer",
            className: "collapse"
        }, "Corgi is designed to support middle school learners to develop higher-order reasoning skills and engage in challenging ways of thinking and doing. By bringing graphic organizers to a flexible, accessible online environment, we aim to reduce barriers and support all students to develop as expert learners.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "#faq01-answer",
            id: "faq01",
            "data-cfw": "collapse"
        }, "Why was Corgi developed?", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "caret ms-0_25"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "faq01-answer",
            className: "collapse"
        }, "Research reveals that students with learning disabilities have lower rates of participation and achievement in science courses. Further, students with learning disabilities are less likely to pursue STEM degrees and STEM careers. Corgi was developed to address these barriers to STEM participation for students with and without disabilities.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "#faq02-answer",
            id: "faq02",
            "data-cfw": "collapse"
        }, "Who is Corgi for?", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "caret ms-0_25"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "faq02-answer",
            className: "collapse"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, "Corgi is designed to support the learning of all middle and high school students. Corgi embeds a range of options and supports such as a read aloud function, a dictionary, translation tools, and speech-to-text. These features reduce barriers and increase access for students with and without disabilities."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, "So far, our research has focused on using Corgi in middle and high school settings, but we see potential for Corgi in elementary school and college settings as well. Further, while our research has focused on using Corgi in STEM and Social Studies classrooms, there are applications for Corgi in a range of other content areas."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "#faq03-answer",
            id: "faq03",
            "data-cfw": "collapse"
        }, "Is Corgi free?", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "caret ms-0_25"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "faq03-answer",
            className: "collapse"
        }, "Corgi is supported by grants from the National Science Foundation and the Office of Special Education Programs. Corgi is free for users.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "#faq04-answer",
            id: "faq04",
            "data-cfw": "collapse"
        }, "In what kinds of teaching environments can Corgi be used?", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "caret ms-0_25"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "faq04-answer",
            className: "collapse"
        }, "Corgi can be used in nearly any classroom\u2014online, in-person, or hybrid settings.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "#faq05-answer",
            id: "faq05",
            "data-cfw": "collapse"
        }, "What is the research basis for Corgi?", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "caret ms-0_25"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "faq05-answer",
            className: "collapse"
        }, "Research shows that Corgi works. Both our pilot study and independent evaluation of the Corgi app showed very positive results: Students made significant gains learning science and U.S. history content when using Corgi. Encouragingly, students with disabilities made substantial improvements in the independent evaluation. We\u2019re excited Corgi helps students learn.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "#faq06-answer",
            id: "faq06",
            "data-cfw": "collapse"
        }, "Where was Corgi tested?", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "caret ms-0_25"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "faq06-answer",
            className: "collapse"
        }, "Corgi has been piloted in middle school and high school classrooms in California and Virginia.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "#faq07-answer",
            id: "faq07",
            "data-cfw": "collapse"
        }, "How can Corgi support me to connect to the Next Generation Science Standards (NGSS)?", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "caret ms-0_25"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "faq07-answer",
            className: "collapse"
        }, "Corgi can be used to reduce barriers and increase access to the Next Generation Science Standards. Once you identify the Standard and the learning goal of the lesson or unit, you can select the Corgi guide or guides that best align. Here is an example of a middle school science unit plan, ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://docs.google.com/document/d/1dAB-lNMeE-E38YOxARfWgHytGgQ0Jq9f0H16WyvXqw8/edit"
        }, "\u201CEarth\u2019s Place in the Universe,\u201D"), " that we have developed around one Standard.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "#faq08-answer",
            id: "faq08",
            "data-cfw": "collapse"
        }, "How does Corgi relate to the Content Enhancement Routines from the Strategic Instruction Model?", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "caret ms-0_25"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "faq08-answer",
            className: "collapse"
        }, "Corgi builds upon the research of the ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://sim.ku.edu/sim-content-enhancement-routines"
        }, "Content Enhancement Routines"), " from ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://sim.ku.edu/"
        }, "Strategic Instruction Model"), ", developed by the ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://kucrl.ku.edu/"
        }, "University of Kansas Center for Research on Learning"), ". Many of the guides used in Corgi are aligned to the ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://sim.ku.edu/hotr-routines"
        }, "Higher Order Thinking and Reasoning Routines"), " from SIM.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e10f0f56b55cf4b2$export$2e2bcd8739ae039), {
            page: "support"
        }, "Are there resources/supports to help me get started with using Corgi?")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "#faq09-answer",
            id: "faq09",
            "data-cfw": "collapse"
        }, "Why does Corgi ask permission to access your Google Drive?", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "caret ms-0_25"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "faq09-answer",
            className: "collapse"
        }, "Corgi saves all of your work directly to your Google Drive, so you can access it from any device with an internet connection. Google requires Corgi users to provide authorization to link up your account. Feel free to check out our how-to:", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://docs.google.com/presentation/d/1z9TaKCdRZ5E5TuVvbLuBl_D-g15qaP3-_kGEy3lEZZU/present?slide=id.g110fcc7702b_0_0"
        }, "How to authorize Corgi to work with your Google Account"), ' ', "to take you through the process!")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "#faq10-answer",
            id: "faq10",
            "data-cfw": "collapse"
        }, "What permissions do I need to select when getting started?", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "caret ms-0_25"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "faq10-answer",
            className: "collapse"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, "When setting up your account, Google will ask you to give Corgi permission to work with your Google account. It is important that you select these permissions for Corgi to run smoothly! Here are the three permissions to select:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ol", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "See and download all your Google Drive files"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "Connect itself to your Google Drive"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "See, edit, create, and delete only the specific Google Drive files you use with this app")), "Feel free to check out our how-to:", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://docs.google.com/presentation/d/1z9TaKCdRZ5E5TuVvbLuBl_D-g15qaP3-_kGEy3lEZZU/present?slide=id.g110fcc7702b_0_0"
        }, "How to authorize Corgi to work with your Google Account"), ' ', "to take you through the process!")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "#faq11-answer",
            id: "faq11",
            "data-cfw": "collapse"
        }, "What do I do if I receive an error message?", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "caret ms-0_25"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "faq11-answer",
            className: "collapse"
        }, "Corgi works with third party companies such as Google, Texthelp, and CAST. It is possible that these websites could be updating. We recommend refreshing your browser and trying again.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "#faq13-answer",
            id: "faq13",
            "data-cfw": "collapse"
        }, "What do I do if I am not able to share or open a Corgi guide?", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "caret ms-0_25"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "faq13-answer",
            className: "collapse"
        }, "First, we recommend refreshing your browser and trying again. If that does not work then log out of your Google account and make sure you only logged into the Google account associated with Corgi. Also, please allow for third party cookies and popups.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "#faq12-answer",
            id: "faq12",
            "data-cfw": "collapse"
        }, "Want to work with us?", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "caret ms-0_25"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "faq12-answer",
            className: "collapse"
        }, "We are recruiting teachers to pilot Corgi in their classrooms. ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "mailto:corgi@cast.org"
        }, "Email us"), " to learn more about this opportunity.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("strong", null, "Still have questions? Get in touch! Email our team: ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "mailto:corgi@cast.org"
        }, "corgi@cast.org")))))));
    }
}



var $6wXVr = parcelRequire("6wXVr");



var $98ea1d84673d2968$exports = {};
$98ea1d84673d2968$exports = $parcel$resolve("5zxoH");


var $c011367757a9d439$exports = {};
$c011367757a9d439$exports = $parcel$resolve("dlxz7");


var $b384bded347bd4be$exports = {};
$b384bded347bd4be$exports = $parcel$resolve("ecV3l");


var $03fa5ad81c96b44b$exports = {};
$03fa5ad81c96b44b$exports = $parcel$resolve("azyQv");


class $5c8466e29cd6f69b$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    render() {
        let units = [];
        let unitList = (0, $198066ba87364cec$export$2e2bcd8739ae039)['library'];
        console.log(unitList);
        for(let u in unitList)if (unitList.hasOwnProperty(u)) units.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($5c8466e29cd6f69b$var$UnitCard, {
            key: u,
            data: unitList[u]
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "page-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "content",
            className: "content row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "content-main col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "content-main-inner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("nav", {
            "aria-label": "breadcrumb"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", {
            className: "breadcrumb"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "breadcrumb-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e10f0f56b55cf4b2$export$2e2bcd8739ae039), {
            page: "docs"
        }, "Home")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "breadcrumb-item active",
            "aria-current": "page"
        }, "Lesson Library"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("main", {
            id: "main_container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h1", null, "Lesson Library"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, "Corgi can be used to reduce barriers and increase access to the Next Generation Science Standards (NGSS). Once you identify the Standard and the learning goal of the lesson or unit, you can select the Corgi guide or guides that best align. Here are some sample Units that are connected to the NGGS. The units are not encompassing of every option, but examples of options. We invite teachers to use all of the units or parts of the units and to customize according to their unique goals and contexts."), units)))));
    }
}
class $5c8466e29cd6f69b$var$UnitCard extends (0, $6wXVr.Component) {
    render() {
        let u = this.props.data;
        let tags = u.tags;
        let tagHtml = [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($5c8466e29cd6f69b$var$Badge, {
                key: "level",
                text: u.level
            })
        ];
        for(let t in tags)if (tags.hasOwnProperty(t)) tagHtml.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($5c8466e29cd6f69b$var$Badge, {
            key: t,
            text: tags[t]
        }));
        let lessons = u.lessons;
        let lessonHtml = [];
        for(let l in lessons)if (lessons.hasOwnProperty(l)) lessonHtml.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($5c8466e29cd6f69b$var$Lesson, {
            key: l,
            data: lessons[l]
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card card-library"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card-title"
        }, "Unit plan")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($5c8466e29cd6f69b$var$LibraryIcons, {
            lessons: lessons
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "card-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "h-inline"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            className: "d-inline"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: u.overview
        }, u.title), ' '), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fs-small text-muted"
        }, "(Google Docs)")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, u.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0"
        }, "Lesson topics"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", {
            className: "list list-unstyled"
        }, lessonHtml), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, tagHtml)));
    }
}
class $5c8466e29cd6f69b$var$LibraryIcons extends (0, $6wXVr.Component) {
    render() {
        let types = [];
        for(let l in this.props.lessons){
            if (this.props.lessons.hasOwnProperty(l)) {
                if (!types.includes(this.props.lessons[l]['type'])) types.push(this.props.lessons[l]['type']);
            }
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "library-icons"
        }, types.includes('cause-effect') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "library-icon",
            tabIndex: "0",
            title: "Cause and Effect",
            "data-cfw": "tooltip",
            "data-cfw-tooltip-container": "body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($98ea1d84673d2968$exports))),
            className: "img-fluid",
            alt: "Cause and Effect"
        })), types.includes('question-exp') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "library-icon",
            tabIndex: "0",
            title: "Question Exploration",
            "data-cfw": "tooltip",
            "data-cfw-tooltip-container": "body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($c011367757a9d439$exports))),
            className: "img-fluid",
            alt: "Question Exploration"
        })), types.includes('comparison') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "library-icon",
            tabIndex: "0",
            title: "Comparison",
            "data-cfw": "tooltip",
            "data-cfw-tooltip-container": "body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($b384bded347bd4be$exports))),
            className: "img-fluid",
            alt: "Comparison"
        })), types.includes('cera') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "library-icon",
            tabIndex: "0",
            title: "Claim, Evidence, Reasoning",
            "data-cfw": "tooltip",
            "data-cfw-tooltip-container": "body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($03fa5ad81c96b44b$exports))),
            className: "img-fluid",
            alt: "Claim, Evidence, Reasoning"
        })));
    }
}
class $5c8466e29cd6f69b$var$Lesson extends (0, $6wXVr.Component) {
    render() {
        let data = this.props.data;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item"
        }, data.title, " - ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            target: data.id,
            href: 'https://corgi2.cast.org/' + data.type + '/' + data.id + '/toc'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, data.title), (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(data.type + '.title')));
    }
}
class $5c8466e29cd6f69b$var$Badge extends (0, $6wXVr.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "badge badge-tag"
        }, this.props.text), ' ');
    }
}



var $6wXVr = parcelRequire("6wXVr");




class $cbe45c7348b137e7$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    componentDidMount() {
        // We actually want to trust the anchor for this page, and center it.
        const element = document.getElementById(window.location.hash.substring(1));
        if (element) element.scrollIntoView({
            block: 'center'
        });
    }
    render() {
        let annotated = this.props.style === 'annotated';
        let guideContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, "Unknown guide");
        if (this.props.type === 'cause-effect') guideContent = this.causeEffect();
        if (this.props.type === 'comparison') guideContent = this.comparison();
        if (this.props.type === 'cera') guideContent = this.cera();
        if (this.props.type === 'question-exp') guideContent = this.questionExp();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "page-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "content",
            className: "content row" + (annotated ? " annoview" : "")
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "content-main col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "content-main-inner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("nav", {
            "aria-label": "breadcrumb"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", {
            className: "breadcrumb"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "breadcrumb-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e10f0f56b55cf4b2$export$2e2bcd8739ae039), {
            page: "docs"
        }, "Home")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "breadcrumb-item"
        }, "Sample"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "breadcrumb-item active",
            "aria-current": "page"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).span, {
            text: {
                key: this.props.type + ".title"
            }
        })))), guideContent))));
    }
    causeEffect() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("main", {
            id: "main_container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h1", null, "Sample Guide"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Topic"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, "Changes in the Ocean Tides")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_question",
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Essential Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "How do gravitational forces influence Earth's ocean tides?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-unfilled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0_25"
        }, "How this step supports student thinking"), "An essential question supports students to engage with their existing knowledge base and draw new patterns between ideas. Essential questions help students develop the thinking tools to question their surroundings and make connections with real world events.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_terms",
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Key Terms"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row d-sm-down-none",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "h3"
        }, "Word or Phrase")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "h3"
        }, "Definition"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Word or Phrase"), "Gravity")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Definition"), "The force by which a planet or other body draws objects toward its center. It is one major force that causes tides."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Word or Phrase"), "Inertia")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Definition"), "A force that causes something to resist change in speed or direction."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Word or Phrase"), "Orbit")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Definition"), "The curved path of an object around a star, planet, or moon. The moon orbits the Earth, and the Earth orbits the Sun."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Word or Phrase"), "High tide")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Definition"), "When water advances to its furthest extent onto the shoreline."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Word or Phrase"), "Low tide")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Definition"), "When the water retreats to its lowest level, moving away from the shoreline.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-unfilled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0_25"
        }, "How this step supports student thinking"), "Key terms can be preloaded by the teacher to highlight unique vocabulary specific to the lesson or unit. Key terms can also be added by students which allows learners to highlight words that are unfamiliar to them or hold specific importance. Oftentimes, discipline-specific terms can present barriers to students. Defining the key terms can help to reduce these barriers and support students to make meaning of the content.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Causes, Main Event, & Effects"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_causes",
            className: "grouping grouping-4"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "grouping-title"
        }, "Causes of the Main Event"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "As the Earth rotates on its axis, the moon orbits the Earth."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, $540ee614c8ab8fe3$export$46abdfa6346e2c9b) + '/example/cause-effect/cause-effect-1.jpg',
            className: "img-fluid",
            alt: ""
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "The side of the Earth that is closest to the moon experiences a pull, which is the gravitational attraction between the Earth and the moon."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "The water on the side of the Earth that is closest to the moon is pulled toward it, creating a bulge of water on that side."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "On the side of the Earth that is opposite the moon, inertia creates a pull in the opposite direction, so a bulge is also created on the side farthest from the moon."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, $540ee614c8ab8fe3$export$46abdfa6346e2c9b) + '/example/cause-effect/cause-effect-2.gif',
            className: "img-fluid",
            alt: ""
        }))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-unfilled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0_25"
        }, "How this step supports student thinking"), "Identifying causes of the main event provides students with an opportunity to establish a clear relationship between factors that contribute to the main event, and the event itself."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket bracket-4"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-arrow-vertical"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-start"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar-start"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-arrow"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar-end"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-end"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_causes-event",
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar-vertical-stretch"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill connector"
        }, "which results in"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-unfilled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0_25"
        }, "How this step supports student thinking"), "This step helps students use reasoning to explain the relationship between the causes and the main event. Students analyze and explain how the causes result in, produce, or contribute to the main event."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-arrow-vertical"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_event",
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar-vertical-stretch"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping grouping-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "grouping-title"
        }, "The Main event"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "Two high tides occur simultaneously on Earth; one on the side closest to the moon, and the other on the opposite side of Earth farthest from the moon."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, $540ee614c8ab8fe3$export$46abdfa6346e2c9b) + '/example/cause-effect/cause-effect-3.jpg',
            className: "img-fluid",
            alt: ""
        })))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-unfilled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0_25"
        }, "How this step supports student thinking"), "Describing the main event helps students understand a specific phenomenon or occurrence. Explaining the event can help students distinguish the event from its contributing causes and the effects it may create."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-arrow-vertical"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_event-effects",
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar-vertical-stretch"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill connector"
        }, "which leads to"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-unfilled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0_25"
        }, "How this step supports student thinking"), "This step helps students use reasoning skills to explain the relationship between the main event and the effects. Students analyze effects to determine the impact of the main event."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket bracket-down bracket-3"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-arrow-vertical"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-start"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar-start"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-arrow"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-end"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_effects",
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping grouping-start grouping-3"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "grouping-title"
        }, "Effects of the Main Event"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "Areas of the Earth that are not closest to the moon or opposite the closest side experience lower tides."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, $540ee614c8ab8fe3$export$46abdfa6346e2c9b) + '/example/cause-effect/cause-effect-4.jpg',
            className: "img-fluid",
            alt: ""
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "As the Earth orbits, tides get higher and lower as different parts of the Earth come closest to or opposite the moon."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "High and low tides happen twice daily in most coastal areas."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-unfilled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0_25"
        }, "How this step supports student thinking"), "Identifying the effects prompts students to analyze the main event, and use reasoning skills to explain events that happen as a result. This step gives students the opportunity to both apply their knowledge of the main event, and justify how it connects to other events that occur as a result.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_summary",
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Summary"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "The moon orbits the Earth as the Earth rotates on its axis. Because the moon is so close to the Earth, its gravitational pull on the Earth creates a bulge of water on the side closest to the moon. Inertia is the force that causes water to change direction. When water is pulled toward the moon on one side of the Earth, inertia pulls in the opposite direction, creating a pull on the opposite side of the Earth. These two bulges result in two high tides in coastal areas per day. The areas between the bulges experience lower tides, which get higher and lower as the Earth orbits."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, $540ee614c8ab8fe3$export$46abdfa6346e2c9b) + '/example/cause-effect/cause-effect-5.jpg',
            className: "img-fluid",
            alt: ""
        })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-unfilled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0_25"
        }, "How this step supports student thinking"), "The summary offers students the opportunity to return to the essential question. Students synthesize how the causes and effects are related to the main event.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Extensions"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, "Why are some tides higher than others? How does extreme weather affect water levels?")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }))));
    }
    cera() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("main", {
            id: "main_container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h1", null, "Sample Guide"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Topic"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, "Nonrenewable Resources")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_essentialquestion",
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Essential Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "Should humans use nonrenewable resources for energy?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-unfilled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0_25"
        }, "How this step supports student thinking"), "An essential question supports students to engage with their existing knowledge base and draw new patterns between ideas. Essential questions help students develop the thinking tools to question their surroundings and make connections with real world events.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_claim",
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Claim"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "Humans should decrease their use of nonrenewable resources because they are not sustainable and are harmful to the planet."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "Nonrenewable energy sources have a limited supply, and cannot be replenished. When we run out, we run out! Right now approximately 80 percent of the energy used on the planet comes from fossil fuels."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "embed-fluid embed-fluid-16x9"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("iframe", {
            src: "https://www.youtube.com/embed/zaXBVYr9Ij0?enablejsapi=1",
            type: "text/html",
            title: "Fossil Fuels 101",
            allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowFullScreen: "",
            frameBorder: "0"
        }))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-unfilled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0_25"
        }, "How this step supports student thinking"), "The claim is what students hinge the skills of analysis, reasoning, and evidence collection on for the topic. The claim, while arguable, should be rooted in logic and evidence. The claim is important in establishing the reasoning cycle that the rest of the Corgi guide will employ. The claim step supports students to develop the higher order skills of reasoning and comprehension.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_terms",
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Key Terms"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row d-sm-down-none",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "h3"
        }, "Word or Phrase")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "h3"
        }, "Definition"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Word or Phrase"), "Natural resource")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Definition"), "A material from nature that people use."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Word or Phrase"), "Nonrenewable resource")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Definition"), "A resource that cannot be replaced or replenished in a reasonable amount of time. The four main types are coal, oil, natural gas, and nuclear energy."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Word or Phrase"), "Renewable resource")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Definition"), "A resource that can replenish itself at a similar rate to its use by people. These resources produce clean energy, which produces less pollution and harmful emissions."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Word or Phrase"), "Fossil fuels")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Definition"), "Oil, natural gas, and coal are fossil fuels. They were formed within the Earth from dead plants and animals over millions of years.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-unfilled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0_25"
        }, "How this step supports student thinking"), "Key terms can be preloaded by the teacher to highlight unique vocabulary specific to the lesson or unit. Key terms can also be added by students which allows learners to highlight words that are unfamiliar to them or hold specific importance. Oftentimes, discipline-specific terms can present barriers to students. Defining the key terms can help to reduce these barriers and support students to make meaning of the content.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            id: "sec_evidencesupport"
        }, "Supporting Evidence"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", null, "Supporting Evidence 1"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mb-1"
        }, "Nonrenewable resources are limited in supply and cannot be used in a sustainable way."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_evidencequality",
            className: "mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h4", {
            className: "h3 mb-0"
        }, "Strength of Evidence"), "The quality of the evidence is strong"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h4", {
            className: "h3 mb-0"
        }, "Rationale"), "The evidence is strong because it is from a credible source which explains the impact of using nonrenewable resources."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h4", {
            className: "h3 mb-0_25"
        }, "Source"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://education.nationalgeographic.org/resource/nonrenewable-resources"
        }, "https://education.nationalgeographic.org/resource/nonrenewable-resources"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", null, "Supporting Evidence 2"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mb-1"
        }, "When fossil fuels are burned they release carbon dioxide into the atmosphere, which contributes to global warming."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_evidencequality",
            className: "mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h4", {
            className: "h3 mb-0"
        }, "Strength of Evidence"), "The quality of the evidence is strong"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h4", {
            className: "h3 mb-0"
        }, "Rationale"), "The evidence is strong because it is from a credible source and uses current data to explain the impact of fossil fuels."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h4", {
            className: "h3 mb-0"
        }, "Source"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://education.nationalgeographic.org/resource/fossil-fuels"
        }, "https://education.nationalgeographic.org/resource/fossil-fuels"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", null, "Supporting Evidence 3"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mb-1"
        }, "Humans will most likely run out of oil in the next 40-50 years by some estimates."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_evidencequality",
            className: "mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h4", {
            className: "h3 mb-0"
        }, "Strength of Evidence"), "The quality of the evidence is weak"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h4", {
            className: "h3 mb-0"
        }, "Rationale"), "Although this website has a lot of important information, it is unclear where this estimate comes from. Also, many factors will affect this estimate."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h4", {
            className: "h3 mb-0"
        }, "Source"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://sustainability-success.com/10-examples-of-non-renewable-resources/"
        }, "https://sustainability-success.com/10-examples-of-non-renewable-resources/")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-unfilled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0_25"
        }, "How this step supports student thinking"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, "Exploring the evidence that supports the claim helps students to develop connections to the claim that can be logically reasoned and observed. The supporting evidence step helps students to practice the higher order skills of analyzing, reasoning, and comprehension."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, "Evaluation of evidence is a crucial step in the CER process. It supports learners to construct clearly explained, well-reasoned support for their claim in the reasoning step. The key component in this evaluation is the rationale of why evidence is weak or strong. The evaluation of evidence supports students to develop the higher order thinking skills of evaluation, synthesizing, application and analysis.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("hr", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            id: "sec_evidenceopposes"
        }, "Opposing Evidence"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", null, "Opposing Evidence 1"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mb-1"
        }, "Nonrenewable resources have their problems, but they are inexpensive to process, and rich in energy."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_evidencequality",
            className: "mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h4", {
            className: "h3 mb-0"
        }, "Strength of Evidence"), "The quality of the evidence is strong"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h4", {
            className: "h3 mb-0"
        }, "Rationale"), "The evidence is strong, but it doesn't convince me that the benefits are worth the risks that nonrenewable resources pose."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h4", {
            className: "h3 mb-0"
        }, "Source"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "https://education.nationalgeographic.org/resource/nonrenewable-resources"
        }, "https://education.nationalgeographic.org/resource/nonrenewable-resources")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-unfilled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0_25"
        }, "How this step supports student thinking"), "Exploring the opposing evidence helps students to consider differing perspectives and deepen their knowledge of the topic through further analysis. The opposing evidence step supports students to develop the higher order skills of analyzing, reasoning, synthesizing, and evaluating.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_reasoning",
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Reasoning"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "Based on the evidence, I conclude that\u2026"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "nonrenewable resources have more risks than benefits. Even though they are less expensive to process and rich sources of energy, the effects of using nonrenewable resources will have many negative effects down the road. At some point, we will run out of nonrenewable resources. In addition, when nonrenewable resources are burned there are harmful emissions that contribute to climate change."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-unfilled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0_25"
        }, "How this step supports student thinking"), "Evaluating both the supporting and opposing evidence and determining if, how, and why the evidence supports the claim engages students in a challenging thought process. Students are analyzing information, weighing evidence, and synthesizing information to craft an informed determination. The reasoning step supports students to develop the higher order skills of synthesizing, analyzing, reasoning, comprehending, application, and evaluation.")))));
    }
    questionExp() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("main", {
            id: "main_container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h1", null, "Sample Guide"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Topic"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, "Energy")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_essentialquestion",
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Essential Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "How does energy move and change?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "embed-fluid embed-fluid-16x9"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("iframe", {
            src: "https://www.youtube.com/embed/gEzvfE8xxNI?enablejsapi=1",
            type: "text/html",
            title: "Energy Transfer and Transformation",
            allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowFullScreen: "",
            frameBorder: "0"
        }))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-unfilled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0_25"
        }, "How this step supports student thinking"), "An essential question supports students to engage with their existing knowledge base and draw new patterns between ideas. Essential questions help students develop the thinking tools to question their surroundings and make connections with real world events.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_terms",
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Key Terms"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row d-sm-down-none",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "h3"
        }, "Word or Phrase")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "h3"
        }, "Definition"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Word or Phrase"), "Energy transfer")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Definition"), "A movement of energy from one place or object to another."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Word or Phrase"), "Energy transformation")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Definition"), "When energy changes from one form to another."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Word or Phrase"), "Thermal Energy")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Definition"), "A type of energy that moves between objects with different temperatures; heat."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Word or Phrase"), "Sound")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Definition"), "A type of energy that moves in vibrations; it is produced when a force makes an object or substance vibrate."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Word or Phrase"), "Light")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Definition"), "A type of energy that travels in waves and is produced by vibrations of electrically charged particles."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Word or Phrase"), "Mechanical energy")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Definition"), "A type of energy that is stored in the movement of objects; motion."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Word or Phrase"), "Kinetic energy")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Definition"), "A form of energy, this is the power or force an object has because of its motion."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Word or Phrase"), "Potential energy")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Definition"), "A form of energy, this is the stored force or power an object has because of its position or state.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-unfilled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0_25"
        }, "How this step supports student thinking"), "Key terms can be preloaded by the teacher to highlight unique vocabulary specific to the lesson or unit. Key terms can also be added by students which allows learners to highlight words that are unfamiliar to them or hold specific importance. Oftentimes, discipline-specific terms can present barriers to students. Defining the key terms can help to reduce these barriers and support students to make meaning of the content.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Supporting Questions & Responses"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row d-sm-down-none",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "h3"
        }, "Question")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "h3"
        }, "Responses"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_relatedquestion",
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "How does energy change to benefit living things?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "embed-fluid embed-fluid-16x9"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("iframe", {
            src: "https://www.youtube.com/embed/dD0ycPpUyM4?enablejsapi=1",
            type: "text/html",
            title: "Heat and Light from the Sun",
            allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowFullScreen: "",
            frameBorder: "0"
        })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_relatedquestionresponse",
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Response"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "Energy from the sun comes as light and heat. These help plants grow and create oxygen, which humans breathe. The sun's heat also warms the Earth and living and non-living things on it. Changes in energy help humans live their daily lives by growing and preparing food, lighting up our spaces so we can move through the world, and powering the tools we need to live. Humans use the food we eat and grow and that becomes energy for our movement."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, $540ee614c8ab8fe3$export$46abdfa6346e2c9b) + '/example/question-exp/question-exp-1.jpg',
            className: "img-fluid",
            alt: ""
        })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "What is the difference between kinetic and potential energy?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "embed-fluid embed-fluid-16x9"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("iframe", {
            src: "https://www.youtube.com/embed/zCKeniklH_c?enablejsapi=1",
            type: "text/html",
            title: '"Our World: Potential and Kinetic Energy" by Adventure Academy',
            allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowFullScreen: "",
            frameBorder: "0"
        })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Response"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "Potential energy is the energy an object has because of its position or the state it is in, and kinetic energy is the energy an object has because of its motion. For example, in a roller coaster, potential energy at the top of a hill changes to kinetic energy as the cars rush down."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, $540ee614c8ab8fe3$export$46abdfa6346e2c9b) + '/example/question-exp/question-exp-2.jpg',
            className: "img-fluid",
            alt: ""
        })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "What is the law of conservation of energy?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "embed-fluid embed-fluid-16x9"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("iframe", {
            src: "https://www.youtube.com/embed/kP7q28wQ2P8?enablejsapi=1",
            title: "TESTED! Conservation Of Energy Principle | Earth Lab",
            allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowFullScreen: "",
            frameBorder: "0"
        })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Response"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "The law of conservation of energy states that energy cannot be created or destroyed, it can only change form."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, $540ee614c8ab8fe3$export$46abdfa6346e2c9b) + '/example/question-exp/question-exp-3.jpg',
            className: "img-fluid",
            alt: ""
        })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "What are familiar examples of how energy changes form?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, $540ee614c8ab8fe3$export$46abdfa6346e2c9b) + '/example/question-exp/question-exp-4.png',
            className: "img-fluid",
            alt: ""
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Response"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "Energy changes form all the time in our daily lives. We eat and change chemical energy in food into mechanical energy so we can move. The sun shines on Earth and changes solar energy into light and heat."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, $540ee614c8ab8fe3$export$46abdfa6346e2c9b) + '/example/question-exp/question-exp-5.jpg',
            className: "img-fluid",
            alt: ""
        }))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-unfilled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0_25"
        }, "How this step supports student thinking"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, "The process of breaking the essential question into smaller, more focused supporting questions (questions that usually begin with \u2018what\u2019, \u2018who\u2019, or \u2018where\u2019) helps students explore their curiosities and practice generating questions."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, "Responding to the supporting questions helps students to explore new information and make meaning of the topic."))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_essentialquestionresponse",
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Response to Essential Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "Energy is transferred and transformed all the time. When energy moves from one place to another it is transferred. When it changes form it is an energy transformation. Energy can be transferred and transformed through light, heat, sound, and motion. It changes from potential to kinetic energy and back again. Even though energy changes and moves, it cannot be created or destroyed. This is known as the law of conservation of energy."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-unfilled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0_25"
        }, "How this step supports student thinking"), "Drawing from their responses to the supporting questions to develop a response to the essential question helps students to practice synthesizing information and articulating a main idea.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_contextresponse",
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Context for Response"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "Everything we do requires and uses energy. It's really interesting to think about the energy at an amusement park, and how much the designers would have had to think about potential and kinetic energy when making roller coasters. I also think about the energy I need to ride my bike up a hill, and how I can get some of that energy from eating food. It's amazing to think about how different forms of energy work together to make our daily lives possible."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-unfilled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0_25"
        }, "How this step supports student thinking"), "Applying what they have learned in this exploration to the real world supports students to discover authentic connections to their own lives and communities.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_extensions",
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Extensions"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, "Energy is never produced or lost. It just changes form or is transferred. I would like to know more about sound energy. I play the piano and I would like to learn more about where loud and soft sounds come from, and what is involved in that transfer of energy.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-unfilled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0_25"
        }, "How this step supports student thinking"), "Providing opportunities for students to document additional questions to explore supports students to continue to develop their curiosity around the topic and surfaces future areas of study that feel relevant and engaging to learners.")))));
    }
    comparison() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("main", {
            id: "main_container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h1", null, "Sample Guide"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_essentialquestion",
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Essential Question"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "How do the processes of weathering and erosion affect the Earth's surface?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "embed-fluid embed-fluid-16x9"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("iframe", {
            src: "https://www.youtube.com/embed/QJUs4e2X5Uo?enablejsapi=1",
            type: "text/html",
            title: "Weathering and Erosion | What Is the Difference between Weathering and Erosion?",
            allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowFullScreen: "",
            frameBorder: "0"
        }))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-unfilled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0_25"
        }, "How this step supports student thinking"), "An essential question supports students to engage with their existing knowledge base and draw new patterns between ideas. Essential questions help students develop the thinking tools to question their surroundings and make connections with real world events.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_concepts",
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Concepts"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", null, "Concept A"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, "Weathering")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", null, "Concept B"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, "Erosion"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", null, "Description of Concept A"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "The breaking down of rocks on Earth\u2019s surface into smaller pieces."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "embed-fluid embed-fluid-16x9"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("iframe", {
            src: "https://www.youtube.com/embed/mQAOe-0vxdc?enablejsapi=1",
            type: "text/html",
            title: "Weathering for Kids | What Is Weathering? Fun Introduction to Weathering for Kids",
            allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowFullScreen: "",
            frameBorder: "0"
        })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", null, "Description of Concept B"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "The movement of rocks or sediment from one place to another."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "embed-fluid embed-fluid-16x9"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("iframe", {
            src: "https://www.youtube.com/embed/qqsTS67BKmA?enablejsapi=1",
            type: "text/html",
            title: "The Power of Water for Kids: How Erosion by Water Shapes Landforms for Children - FreeSchool",
            allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowFullScreen: "",
            frameBorder: "0"
        })))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-unfilled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0_25"
        }, "How this step supports student thinking"), "The two topics for comparison fall under the umbrella of the overall concept. These concepts will share some similarities, but students will also have the opportunity to distinguish differences. Developing an understanding of one concept can help students better define and understand the other.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_terms",
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Key Terms"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row d-sm-down-none",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "h3"
        }, "Word or Phrase")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "h3"
        }, "Definition"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Word or Phrase"), "Weathering")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Definition"), "The process of breaking down or dissolving rocks on Earth\u2019s surface."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Word or Phrase"), "Erosion")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Definition"), "The process of water moving rocks or sediment from one place to another, and resulting in changes to Earth\u2019s surface."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Word or Phrase"), "Mechanical (physical) weathering")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Definition"), "When larger rocks break into smaller pieces, but no chemical change takes place. Water is a main cause of mechanical weathering."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Word or Phrase"), "Deposition")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Definition"), "When water drops sediment carried by erosion processes in a new location.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-unfilled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0_25"
        }, "How this step supports student thinking"), "Key terms can be preloaded by the teacher to highlight unique vocabulary specific to the lesson or unit. Key terms can also be added by students which allows learners to highlight words that are unfamiliar to them or hold specific importance. Oftentimes, discipline-specific terms can present barriers to students. Defining the key terms can help to reduce these barriers and support students to make meaning of the content.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_overall",
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Overall Concept"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping grouping-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "grouping-item-title"
        }, "Concept A"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "Weathering"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "grouping-item-title"
        }, "Concept B"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "Erosion"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket bracket-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-arrow-vertical"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-start"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-arrow"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-end"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping grouping-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "grouping-item-title"
        }, "Overall Concept"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "Weathering and erosion are two processes that explain how the forces of water, ice, and wind can break down and transport rock and minerals over time to reshape the landscape."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-unfilled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0_25"
        }, "How this step supports student thinking"), "The process of considering the overall concept supports learners to practice the skill of categorization.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_characteristics",
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Characteristics"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", null, "Characteristics of Concept A"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, "Does not involve movement of rock"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, "Water, wind, and ice cause weathering by breaking down rock into smaller pieces"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, "Three different types: chemical, mechanical, and biological"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, "Happens gradually over time"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, "Can result in the creation or destruction of landforms")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-md-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", null, "Characteristics of Concept B"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, "Involves movement of rock"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, "Water, wind, and ice erode the earth's surface by moving pieces of rock to a new location"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, "Two main types: chemical and physical"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, "Can happen gradually over time or somewhat quickly"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, "Can result in the creation or destruction of landforms")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-unfilled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0_25"
        }, "How this step supports student thinking"), "Identifying key characteristics supports learners to articulate features of a concept that make it distinct. Discovering and documenting the defining characteristics will help prepare students to think more critically about each characteristic in the next steps.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_likeCharacteristics",
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Similar Characteristics & Categories"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main d-flex flex-column"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping grouping-2 grouping-match"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "Water, wind, and ice cause weathering by breaking down rock into smaller pieces"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-icon"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-equals",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "is similar to")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "Water, wind, and ice erode the earth's surface by moving pieces of rock to a new location"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket bracket-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-arrow-vertical"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-start"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-arrow"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-end"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar-vertical-stretch"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-unfilled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0_25"
        }, "How this step supports student thinking"), "Learners can practice analyzing characteristics for similarities, and use this analysis to create pairs of characteristics across the two concepts. Engaging in this analysis will help students recognize points of similarity between the two concepts, although the pairs do not have to be exactly the same."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_likeCategories",
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping grouping-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, "Can be cause by wind, water, and ice")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-unfilled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0_25"
        }, "How this step supports student thinking"), "After identifying similar characteristics across each concept, learners can classify similarities they have identified by creating a category that describes the relationships between similar pairs. Creating pairs and categories help learners understand what aspects of their concepts are comparable and provides an organizing system for the comparison process."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping grouping-2 grouping-match"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "Can result in the creation or destruction of landforms"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-icon"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-equals",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "is similar to")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "Can result in the creation or destruction of landforms"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket bracket-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-arrow-vertical"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-start"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-arrow"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-end"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping grouping-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, "Results of the process")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_unlikeCharacteristics",
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Different Characteristics & Categories"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main d-flex flex-column"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping grouping-2 grouping-match"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "Does not involve movement of rock"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-icon"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-not-equal",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "is different from")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "Involves movement of rock"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket bracket-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-arrow-vertical"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-start"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-arrow"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-end"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar-vertical-stretch"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-unfilled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0_25"
        }, "How this step supports student thinking"), "Learners will also be able to recognize that some characteristics are not part of a pair. This will help them surface points of contrast between the two concepts, where features or traits diverge."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_unlikeCategories",
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping grouping-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, "Movement")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-unfilled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0_25"
        }, "How this step supports student thinking"), "Even though the characteristics are different, learners can deepen their thinking by classifying the differences into overarching categories. Creating contrasting pairs and categories supports learners to understand what aspects of their concepts are different and continues to offer an organizing system for the comparison process."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping grouping-2 grouping-match"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "Three different types: chemical, mechanical, and biological"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-icon"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-not-equal",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "is different from")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "Two main types: chemical and physical"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket bracket-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-arrow-vertical"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-start"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-arrow"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-end"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping grouping-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, "Types"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping grouping-2 grouping-match"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "Happens gradually over time"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-icon"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-not-equal",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "is different from")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "Can happen gradually over time or somewhat quickly"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket bracket-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-arrow-vertical"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-start"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-arrow"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-bar"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "bracket-end"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping grouping-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, "How long it takes")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_summary",
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Summary"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-text"
        }, "Weathering and erosion are two of the main processes that shape the surface of the Earth. These processes work together. Weathering from water, wind, and ice breaks down rock into smaller pieces. Erosion, also caused by wind, water, and ice, moves those pieces to new places and deposits them. Over time, this causes changes in the shapes of rivers, mountains, and coastlines. It can take many years for weathering to occur. Erosion can take a long time, but it can also happen quickly from things like floods or extreme winds. Weathering can be physical, chemical, or biological, depending on how the rock changes as it is broken down. Erosion can be physical or chemical. Landforms on the Earth are constantly changing because of the processes of weathering and erosion."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "grouping-img"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, $540ee614c8ab8fe3$export$46abdfa6346e2c9b) + '/example/comparison/comparison-1.jpg',
            className: "img-fluid",
            alt: ""
        })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-unfilled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h3", {
            className: "mb-0_25"
        }, "How this step supports student thinking"), "The summary offers learners the opportunity to return to the essential question and synthesize what they\u2019ve learned about the topic in terms of comparing and contrasting aspects of the overall concept.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "sec_extensions",
            className: "section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", null, "Extensions"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "box box-autofill"
        }, "I wonder what some examples of weathering and erosion are in my area. For example, the rocks at the beach are always being hit by the waves. How will the shape and structure of the nearby beaches change over time? How long will these changes take before they are noticeable to people who live here and visit here?")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "review-anno"
        }))));
    }
}


class $bc34d6c4fed03120$export$2e2bcd8739ae039 extends (0, $d8775d5311bbf499$export$2e2bcd8739ae039) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.doDocs = this.doDocs.bind(this);
        this.doDocType = this.doDocType.bind(this);
        this.doCreate = this.doCreate.bind(this);
        this.createDocument = this.createDocument.bind(this);
    }
    render() {
        // const doc = this.context;
        if (this.props.hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h1", null, "Something went wrong.");
        if (this.context.loading && !this.context.loginRequired) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($bc34d6c4fed03120$export$de73cf9e66f7476e, {
            loading: true
        });
        if (this.context.authorized) {
            // Routes available to logged-in users.
            if (this.context.fileIdLoaded) // Routes available when doc loaded
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$b5d5cf8927ab7262), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$e7b0ac011bb776c6), {
                path: "/support"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $ca8a14d60dfe4182$export$2e2bcd8739ae039), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$e7b0ac011bb776c6), {
                path: "/about"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a9ec8f7c5798b893$export$2e2bcd8739ae039), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$e7b0ac011bb776c6), {
                path: "/faq"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $772d297780303d52$export$2e2bcd8739ae039), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$e7b0ac011bb776c6), {
                path: "/attributions"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $36cff33fa1941399$export$2e2bcd8739ae039), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$e7b0ac011bb776c6), {
                path: "/sample/:style/:type",
                component: this.doSample
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$e7b0ac011bb776c6), {
                path: "/docs",
                component: this.doDocs
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$e7b0ac011bb776c6), {
                path: "/copy"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $f1c014113ae1c484$export$2e2bcd8739ae039), {
                copyDocMethod: this.props.copyDocMethod
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$e7b0ac011bb776c6), {
                path: "/create",
                component: this.createDocument
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$e7b0ac011bb776c6), {
                path: "/:docType/:docId/:section",
                component: this.doDocType
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$2d8d895a0a0f636e), {
                from: "/:docType/:docId",
                to: "/:docType/:docId/toc"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$2d8d895a0a0f636e), {
                to: "/docs"
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$b5d5cf8927ab7262), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$e7b0ac011bb776c6), {
                path: "/support"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $ca8a14d60dfe4182$export$2e2bcd8739ae039), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$e7b0ac011bb776c6), {
                path: "/about"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a9ec8f7c5798b893$export$2e2bcd8739ae039), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$e7b0ac011bb776c6), {
                path: "/faq"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $772d297780303d52$export$2e2bcd8739ae039), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$e7b0ac011bb776c6), {
                path: "/attributions"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $36cff33fa1941399$export$2e2bcd8739ae039), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$e7b0ac011bb776c6), {
                path: "/library"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $5c8466e29cd6f69b$export$2e2bcd8739ae039), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$e7b0ac011bb776c6), {
                path: "/sample/:style/:type",
                component: this.doSample
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$e7b0ac011bb776c6), {
                path: "/docs",
                component: this.doDocs
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$e7b0ac011bb776c6), {
                path: "/copy"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $f1c014113ae1c484$export$2e2bcd8739ae039), {
                copyDocMethod: this.props.copyDocMethod
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$e7b0ac011bb776c6), {
                path: "/:docType/:docId/:section"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($bc34d6c4fed03120$export$de73cf9e66f7476e, {
                loading: this.context.loading,
                doCreate: this.doCreate,
                context: this.context,
                ...this.props
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$2d8d895a0a0f636e), {
                from: "/:docType/:docId",
                to: "/:docType/:docId/toc"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$2d8d895a0a0f636e), {
                to: "/docs"
            }));
        } else // Routes available before login.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$b5d5cf8927ab7262), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$e7b0ac011bb776c6), {
            path: "/support"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $ca8a14d60dfe4182$export$2e2bcd8739ae039), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$e7b0ac011bb776c6), {
            path: "/about"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a9ec8f7c5798b893$export$2e2bcd8739ae039), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$e7b0ac011bb776c6), {
            path: "/faq"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $772d297780303d52$export$2e2bcd8739ae039), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$e7b0ac011bb776c6), {
            path: "/attributions"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $36cff33fa1941399$export$2e2bcd8739ae039), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$e7b0ac011bb776c6), {
            path: "/library"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $5c8466e29cd6f69b$export$2e2bcd8739ae039), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$e7b0ac011bb776c6), {
            path: "/sample/:style/:type",
            component: this.doSample
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$e7b0ac011bb776c6), {
            path: "/login"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $025921cd7b8246a8$export$2e2bcd8739ae039), {
            authorizeMethod: this.props.authorizeWithPopUp
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$2d8d895a0a0f636e), {
            to: "/login"
        }));
    }
    doSample() {
        let params = (0, $fc353641e976e80e$export$99eaa27ddbbb95ef)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $cbe45c7348b137e7$export$2e2bcd8739ae039), {
            type: params.type,
            style: params.style
        });
    }
    doDocType() {
        let params = (0, $fc353641e976e80e$export$99eaa27ddbbb95ef)();
        const doc = {
            type: params.docType,
            id: params.docId,
            section: params.section
        };
        console.debug("MainContent.doDocType " + doc.type + " section: " + doc.section);
        if (this.context.copyPending) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$2d8d895a0a0f636e), {
            to: "/copy"
        });
        else if (this.context.createPending) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$2d8d895a0a0f636e), {
            to: "/create"
        });
        else if ("comparison" === doc.type) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $26adb41fc1bc483a$export$2e2bcd8739ae039), {
            fileSection: params.section,
            loadDocMethod: this.props.loadDocMethod,
            renameDocMethod: this.props.renameDocMethod,
            shareMethod: this.props.shareMethod
        });
        else if ("cause-effect" === doc.type) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $371547c8f062a939$export$2e2bcd8739ae039), {
            doc: doc,
            canEdit: this.context.canEdit,
            loadDocMethod: this.props.loadDocMethod,
            renameDocMethod: this.props.renameDocMethod,
            shareMethod: this.props.shareMethod
        });
        else if ("question-exp" === doc.type) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $aa8819596c1d14e9$export$2e2bcd8739ae039), {
            fileSection: params.section,
            loadDocMethod: this.props.loadDocMethod,
            renameDocMethod: this.props.renameDocMethod,
            shareMethod: this.props.shareMethod
        });
        else if ("cera" === doc.type) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $0ebe11f4812031c8$export$2e2bcd8739ae039), {
            fileSection: params.section,
            loadDocMethod: this.props.loadDocMethod,
            renameDocMethod: this.props.renameDocMethod,
            shareMethod: this.props.shareMethod
        });
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $ba8dff0eeb9aa11c$export$2e2bcd8739ae039), null);
    }
    createDocument() {
        const type = this.context.fileType;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b75f94629b84f075$export$2e2bcd8739ae039), {
            docType: type,
            createDocMethod: this.props.createDocMethod
        });
    }
    doDocs() {
        let location = (0, $fc353641e976e80e$export$45d76561a5302f2b)();
        if (location.hash.startsWith('#new')) {
            const type = location.hash.substr(4).toLowerCase();
            if (0 < type.length) return this.doCreate(type);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $32c97e6ff3e15def$export$2e2bcd8739ae039), {
            newDocButtonMethod: this.props.newDocButtonMethod,
            authorizeWithPopUp: this.props.authorizeWithPopUp
        });
    }
    doCreate(type) {
        /*
        let params = useParams();
        let location = useLocation();
        if (params) {
            // console.log(util.inspect(params));
        }
        if (location) {
            // console.log(util.inspect(location));
        }
         */ console.debug("MainContent.doCreate " + type);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b75f94629b84f075$export$2e2bcd8739ae039), {
            docType: type,
            createDocMethod: this.props.createDocMethod
        });
    }
}
function $bc34d6c4fed03120$export$de73cf9e66f7476e(props) {
    let doc = (0, $6wXVr.useContext)((0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039));
    let params = (0, $fc353641e976e80e$export$99eaa27ddbbb95ef)();
    if (!doc.loading && params.docId && doc.error !== 1) {
        console.log("Wait: calling loadDocMethod");
        props.loadDocMethod();
    }
    if (props.copyPending && props.copyDone) {
        let newUrl = "/" + doc.fileType + "/" + doc.copyPending;
        console.log("Redirecting to copied file: " + newUrl);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fc353641e976e80e$export$2d8d895a0a0f636e), {
            to: newUrl
        });
    }
    let message = (doc.copyPending ? "Copying document" : doc.createPending ? "Creating document" : "Loading") + "...";
    return doc.error === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $fca58f9f96fb5ae5$export$2e2bcd8739ae039), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("main", {
        id: "main_container",
        className: "container-fluid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "col text-center mt-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h1", {
        className: "h4 text-body mb-2"
    }, message)))));
}



var $6wXVr = parcelRequire("6wXVr");
class $0893f709ff34df68$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("main", {
            id: "main_container",
            className: "container-fluid"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col text-center mt-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h1", {
            className: "h4 text-body mb-2"
        }, "System error"), this.props.children)));
    }
}



var $6wXVr = parcelRequire("6wXVr");

var $6wXVr = parcelRequire("6wXVr");

var $6wXVr = parcelRequire("6wXVr");


var $343309d9bae86498$exports = {};
$343309d9bae86498$exports = $parcel$resolve("bAICM");


const $7389ab5c64e1a271$export$205c036ea3c15f0f = "navMenu";
const $7389ab5c64e1a271$export$45cc0b4819403c41 = "offcanvasNavbar";
class $7389ab5c64e1a271$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "navbar"
        }, this.context.currentUser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            id: $7389ab5c64e1a271$export$205c036ea3c15f0f,
            type: "button",
            className: "btn btn-icon btn-link header-menu-btn",
            title: "Toggle menu",
            "data-cfw-offcanvas-target": "#" + $7389ab5c64e1a271$export$45cc0b4819403c41
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-fw fa-bars",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "Toggle menu")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            "data-cfw": "popover",
            "data-cfw-popover-target": "#onboard4",
            "data-cfw-popover-placement": "bottom"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "/",
            className: "header-brand"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($343309d9bae86498$exports))),
            className: "header-logo",
            alt: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "header-title sr-only-xs-down"
        }, "Corgi"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "header-tagline sr-only-sm-down"
        }, "Co-organize your learning")));
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        this.initButton();
    }
    componentDidMount() {
        this.initButton();
    }
    initButton() {
        const button = (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#' + $7389ab5c64e1a271$export$205c036ea3c15f0f);
        if (button) button.CFW_Offcanvas();
    }
}





var $6wXVr = parcelRequire("6wXVr");



function $6dd726c1929cb4bf$export$2e2bcd8739ae039(props) {
    const doc = (0, $6wXVr.useContext)((0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039));
    const [parentFolder, setParentFolder] = (0, $6wXVr.useState)(null);
    (0, $6wXVr.useEffect)(()=>{
        if (doc.parentFolderId && !parentFolder) setParentFolder("https://drive.google.com/drive/folders/" + doc.parentFolderId);
        if (!doc.parentFolderId && doc.fileId && !parentFolder) {
            const url = "https://www.googleapis.com/drive/v2/files/" + doc.fileId + "/parents";
            window.gapi.client.request({
                path: url,
                method: "GET",
                fields: "parents"
            }).then((driveResponse)=>{
                if (undefined !== driveResponse.result.items && 0 < driveResponse.result.items.length) {
                    const folderId = driveResponse.result.items[0].id;
                    doc["parentFolderId"] = folderId;
                    setParentFolder("https://drive.google.com/drive/folders/" + folderId);
                } else console.log("%d, failed to GET %s", driveResponse.status, url);
            }, (err_reason)=>{
                if (err_reason.result.error.code === 401) this.context.handleAccessTokenExpired();
            });
        }
    }, [
        doc,
        parentFolder
    ]);
    return parentFolder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
        href: parentFolder,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: (evt)=>(0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#' + (0, $7389ab5c64e1a271$export$45cc0b4819403c41)).CFW_Offcanvas('hide')
    }, props.children) : null;
}




class $62dd19b433ee653f$export$2e2bcd8739ae039 extends (0, $d8775d5311bbf499$export$2e2bcd8739ae039) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(){
        super();
        this.createComparison = this.createComparison.bind(this);
        this.createCauseEffect = this.createCauseEffect.bind(this);
        this.createQuestionExp = this.createQuestionExp.bind(this);
        this.createCERGuide = this.createCERGuide.bind(this);
        this.resetData = this.resetData.bind(this);
    }
    componentDidUpdate() {
        super.componentDidUpdate();
        if (this.context.fileId) {
            const driveUrl = 'https://drive.google.com/file/d/' + this.context.fileId + '/view';
            window.gapi.sharetoclassroom.render('gcAssignButton', {
                'url': driveUrl,
                'title': this.context.fileName,
                'size': 32
            });
        }
        // Dispose and re-initialize the collapse item, otherwise it can be instantiated multiple times
        (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#collapseBeginNewBtn').CFW_Collapse('dispose').CFW_Collapse();
    }
    createCauseEffect() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#' + (0, $7389ab5c64e1a271$export$45cc0b4819403c41)).CFW_Offcanvas('hide');
        return this.props.newDocButtonMethod("cause-effect", false);
    }
    createQuestionExp() {
        return this.props.newDocButtonMethod("question-exp", false);
    }
    createComparison() {
        return this.props.newDocButtonMethod("comparison", false);
    }
    createCERGuide() {
        return this.props.newDocButtonMethod("cera", false);
    }
    closeSidebarOffcanvas() {
        window.speechstream.speechTools.stop();
    }
    resetData() {
        let userRef = window.firebase.database().ref("user/" + this.context.currentUser.uid);
        userRef.remove();
        alert('User data cleared.');
    }
    render() {
        var currentGuide = null;
        if (this.context.fileId) {
            const share = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
                href: "#share",
                onClick: this.props.shareMethod
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
                className: "fa fa-fw fa-share-square",
                "aria-hidden": "true"
            }), "Share this guide"));
            const printUrl = [
                "",
                this.context.fileType,
                this.context.fileId,
                "print"
            ].join("/");
            const print = document.location.pathname.endsWith('print') ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
                href: printUrl,
                onClick: (evt)=>{
                    (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#' + (0, $7389ab5c64e1a271$export$45cc0b4819403c41)).CFW_Offcanvas('hide');
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
                className: "fa fa-fw fa-print",
                "aria-hidden": "true"
            }), "Print preview"));
            const googleClassroom = this.context.metadata && this.context.metadata.capabilities.canShare ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, "Post to:", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                id: "gcAssignButton",
                className: "g-sharetoclassroom"
            }), "\xa0Google Classroom") : null;
            currentGuide = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
                className: "list-item py-0_5"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                className: "h5"
            }, "Current Guide"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", {
                className: "list-unstyled"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
                href: "#copy",
                onClick: this.props.copyButtonMethod
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
                className: "fa fa-fw fa-copy",
                "aria-hidden": "true"
            }), "Make editable copy")), share, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6dd726c1929cb4bf$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
                className: "fab fa-fw fa-google-drive",
                "aria-hidden": "true"
            }), "Show location in Drive")), print, googleClassroom));
        }
        const resetItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item py-0_5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "#reset",
            onClick: this.resetData
        }, "Reset user data"));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: (0, $7389ab5c64e1a271$export$45cc0b4819403c41),
            className: "offcanvas offcanvas-start"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "offcanvas-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h1", {
            className: "offcanvas-title"
        }, "Menu"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "close",
            "data-cfw-dismiss": "offcanvas",
            "aria-label": "Close"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-times",
            "aria-hidden": "true"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "offcanvas-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", {
            className: "list list-divided"
        }, currentGuide, this.context.currentUser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item py-0_5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", {
            className: "list-unstyled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "#collapseBeginNew",
            id: "collapseBeginNewBtn",
            role: "button"
        }, "Begin a new guide", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "caret ps-0_25"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "collapseBeginNew",
            className: "collapse"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", {
            className: "ps-2 py-0_5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "#newCause-effect",
            onClick: this.createCauseEffect
        }, "Cause & Effect Guide")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "#newQuestion-exp",
            onClick: this.createQuestionExp
        }, "Question Exploration Guide")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "#newComparison",
            onClick: this.createComparison
        }, "Comparison Guide")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "#newCera",
            onClick: this.createCERGuide
        }, "Claim, Evidence, Reasoning Guide"))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e10f0f56b55cf4b2$export$2e2bcd8739ae039), {
            page: "docs"
        }, "My recent guides")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item py-0_5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", {
            className: "list-unstyled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($62dd19b433ee653f$var$ConditionalLink, {
            page: "about",
            text: "About Corgi"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($62dd19b433ee653f$var$ConditionalLink, {
            page: "support",
            text: "How to use Corgi"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($62dd19b433ee653f$var$ConditionalLink, {
            page: "faq",
            text: "Corgi FAQ"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($62dd19b433ee653f$var$ConditionalLink, {
            page: "attributions",
            text: "Attributions"
        }))), window.developmentTools && resetItem)));
    }
}
class $62dd19b433ee653f$var$ConditionalLink extends (0, $6wXVr.Component) {
    render() {
        if (document.location.pathname === '/' + this.props.page) return null;
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e10f0f56b55cf4b2$export$2e2bcd8739ae039), {
            page: this.props.page,
            rel: "noopener noreferrer"
        }, this.props.text));
    }
}



var $6wXVr = parcelRequire("6wXVr");


var $6wXVr = parcelRequire("6wXVr");




const $c45153d1b11eaaab$var$cookies = new (0, $9bfae0a1a4fe450e$export$2e2bcd8739ae039)();
class $c45153d1b11eaaab$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.state = {
            fileId: null,
            watchRef: null,
            collaborators: null
        };
        this.updateWatcher = this.updateWatcher.bind(this);
    }
    render() {
        if ("print" === this.context.fileSection) return null;
        else {
            let userDropdown = null;
            let collabDropdown = null;
            if (this.context.currentUser) {
                userDropdown = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                    className: "header-user"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
                    type: "button",
                    className: "btn btn-link btn-round",
                    "data-cfw": "dropdown",
                    "data-cfw-dropdown-target": "#dropdownUser",
                    title: "Account: " + this.context.currentUser.displayName,
                    "aria-label": "Account: " + this.context.currentUser.displayName
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
                    src: this.context.currentUser.photoURL,
                    className: "img-fluid",
                    alt: "",
                    role: "presentation"
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", {
                    id: "dropdownUser",
                    className: "dropdown-menu dropreverse"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
                    className: "dropdown-text"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                    className: "h1"
                }, "My Account"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($c45153d1b11eaaab$var$CollaboratorIcon, {
                    key: this.context.currentUser.uid,
                    collab: this.context.currentUser,
                    email: true,
                    wrap: false,
                    isHeaderUser: true
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
                    className: "dropdown-divider",
                    role: "separator"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
                    href: "/login",
                    onClick: this.logout,
                    className: "dropdown-item"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
                    className: "fa fa-sign-out-alt me-0_25",
                    "aria-hidden": "true"
                }), "Sign out"))));
                const collaborators = this.state.collaborators;
                if (collaborators) {
                    let icons = [];
                    let lastestEmail = "";
                    for(let key in collaborators)if (collaborators.hasOwnProperty(key)) {
                        const c = collaborators[key];
                        lastestEmail = c.emailAddress;
                        icons.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement($c45153d1b11eaaab$var$CollaboratorIcon, {
                            key: c.uid,
                            collab: c,
                            wrap: false
                        }));
                    }
                    let numberUser = icons.length;
                    collabDropdown = numberUser > 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "header-collab"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
                        type: "button",
                        className: "btn btn-link btn-collab btn-round",
                        "data-cfw": "dropdown",
                        "data-cfw-dropdown-target": "#dropdownCollab",
                        title: "Collaborators",
                        "aria-label": "Collaborators"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
                        className: "fa fa-fw fa-users",
                        "aria-hidden": "true"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
                        className: "sr-only"
                    }, numberUser, " Collaborators")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
                        className: "header-collab-count",
                        "aria-hidden": "true"
                    }, "\xd7 ", numberUser), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("ul", {
                        id: "dropdownCollab",
                        className: "dropdown-menu dropreverse"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("li", {
                        className: "dropdown-text"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "h6"
                    }, "Collaborators"), icons))) : lastestEmail === this.context.currentUser.emailAddress ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                        className: "header-collab"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
                        className: "d-inline-block",
                        tabIndex: "0",
                        "data-cfw": "tooltip",
                        "data-cfw-tooltip-placement": "bottom",
                        title: "No Collaborators"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
                        type: "button",
                        className: "btn btn-link btn-collab btn-round",
                        disabled: true
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
                        className: "fa fa-fw fa-users",
                        "aria-hidden": "true"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
                        className: "sr-only"
                    }, "No Collaborators")))) : null;
                }
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, collabDropdown, userDropdown);
        }
    }
    componentDidUpdate() {
        if (this.state.fileId !== this.context.fileId) this.updateWatcher();
    }
    logout() {
        $c45153d1b11eaaab$var$cookies.remove("corgi_id_token", {
            path: '/',
            sameSite: 'strict'
        });
        $c45153d1b11eaaab$var$cookies.remove("corgi_firebase_uid", {
            path: '/',
            sameSite: 'strict'
        });
        $c45153d1b11eaaab$var$cookies.remove("corgi_access_token", {
            path: '/',
            sameSite: 'strict'
        });
        $c45153d1b11eaaab$var$cookies.remove("corgi_granted_scopes", {
            path: '/',
            sameSite: 'strict'
        });
        if (typeof window.history.pushState !== 'function') window.history.pushState(null, "", window.location.href);
        try {
            window.location.replace = '/login';
        } catch (e) {
            window.location = '/login';
        }
    }
    // Called whenever fileId changes.
    updateWatcher() {
        if (this.state.watchRef) this.state.watchRef.off('value');
        let fileId = this.context.fileId;
        if (fileId) {
            const collaborativeListUsersRef = window.realtimeUtils.getCollaborativeListUser(this.context.fileType, fileId);
            collaborativeListUsersRef.on('value', (data)=>{
                const collaborators = data.val();
                this.setState({
                    fileId: fileId,
                    watchRef: collaborativeListUsersRef,
                    collaborators: collaborators
                }, ()=>(0, $2c839b9f78572b9b$export$2e2bcd8739ae039)());
            });
        } else // Nothing to watch right now
        this.setState({
            fileId: null,
            watchRef: null,
            collaborators: null
        });
    }
    componentWillUnmount() {
        if (this.state.watchRef) this.state.watchRef.off('value');
    }
}
// Display for one collaborator.
// If wrap=false, returns just an avatar image.  If true, returns an <li> with image and name.
class $c45153d1b11eaaab$var$CollaboratorIcon extends (0, $6wXVr.Component) {
    render() {
        const email = this.props.email ? this.props.collab.emailAddress : null;
        const isHeaderUser = this.props.isHeaderUser ? this.props.isHeaderUser : false;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "collab-img me-0_5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: this.props.collab.photoURL,
            className: "avatar-img",
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "media-body"
        }, this.props.collab.displayName, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("br", null), email, isHeaderUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "account-change btn btn-link btn-small px-0",
            "data-cfw": "modal",
            "data-cfw-modal-target": "#modalUserType1"
        }, "Change account type")) : null));
    }
}
$c45153d1b11eaaab$var$CollaboratorIcon.propTypes = {
    collab: (0, (/*@__PURE__*/$parcel$interopDefault($c83591d04bda8b2b$exports))).object.isRequired
};



var $6wXVr = parcelRequire("6wXVr");

function $ff5d619fd518c35a$export$2e2bcd8739ae039(props) {
    const doc = (0, $6wXVr.useContext)((0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039));
    const btnClass = props.buttonClassName ? props.buttonClassName : "btn btn-primary btn-small";
    const closeClass = props.closeClassName ? props.closeClassName : "btn btn-link me-0_25";
    return "print" !== doc.fileSection ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "header-btns"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
        type: "button",
        className: closeClass,
        onClick: (event)=>{
            window.history.back();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
        className: "fa fa-xmark me-0_25 fs-xlarge valign-middle",
        "aria-hidden": "true"
    }), "Close"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
        type: "button",
        className: btnClass,
        onClick: (event)=>{
            window.print();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
        className: "fa fa-print me-0_25",
        "aria-hidden": "true"
    }), "Print"));
}


function $0daa70a15a5cde6e$export$2e2bcd8739ae039(props) {
    (0, $6wXVr.useEffect)(()=>{
        (0, $2c839b9f78572b9b$export$2e2bcd8739ae039)();
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("header", {
        className: "site-header"
    }, props.children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
        className: "site-header-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $ff5d619fd518c35a$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $c45153d1b11eaaab$export$2e2bcd8739ae039), null)));
}





var $6wXVr = parcelRequire("6wXVr");


let $3759188b1291e350$var$storedRange = {
    collapsed: true
};
let $3759188b1291e350$var$timerRef = null;
function $3759188b1291e350$var$debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}
class $3759188b1291e350$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        this.state = {
            playing: false
        };
        this.ttsPlay = this.ttsPlay.bind(this);
        this.ttsStop = this.ttsStop.bind(this);
        this.ttsIsPlaying = this.ttsIsPlaying.bind(this);
        this.ttsIsPaused = this.ttsIsPaused.bind(this);
        this.ttsDictionary = this.ttsDictionary.bind(this);
        this.ttsTranslate = this.ttsTranslate.bind(this);
        this.ttsCheckForPause = this.ttsCheckForPause.bind(this);
        this.handleSelectionEnd = this.handleSelectionEnd.bind(this);
    }
    componentDidMount() {
        (0, $7dfc83116dbc3695$export$48467d32fd6a02db)("#ttsId");
        //document.addEventListener('ttsDoStart', this.ttsIsPlaying);
        document.addEventListener('ttsDoEnd', this.ttsIsPaused);
        this.startSelectListen();
    }
    componentWillUnmount() {
        this.endSelectListen();
    }
    startSelectListen() {
        document.addEventListener('selectionchange', this.handleSelectionChange);
        document.addEventListener('selectionEnd', this.handleSelectionEnd); // Custom event
    }
    endSelectListen() {
        document.removeEventListener('selectionchange', this.handleSelectionChange);
        document.removeEventListener('selectionEnd', this.handleSelectionEnd); // Custom event
        $3759188b1291e350$var$timerRef = null;
    }
    handleSelectionChange() {
        // Delay after the last selection change event
        if ($3759188b1291e350$var$timerRef) clearTimeout($3759188b1291e350$var$timerRef);
        $3759188b1291e350$var$timerRef = setTimeout(function() {
            const eventSelectionEnd = new Event('selectionEnd');
            document.dispatchEvent(eventSelectionEnd);
        }, 100);
    }
    handleSelectionEnd() {
        $3759188b1291e350$var$timerRef = null;
        if (window.getSelection().rangeCount) $3759188b1291e350$var$storedRange = window.getSelection().getRangeAt(0);
        else this.resetStoredRange();
    }
    render() {
        const doc = this.context;
        return "print" === doc.fileSection ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: `header-tts ${this.state.playing ? 'playing' : ''}`,
            role: "region",
            "aria-label": "Read Aloud Toolbar"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            onClick: this.ttsPlay,
            type: "button",
            className: "btn btn-round btn-tts",
            title: "Play/Pause"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-fw fa-play tts-play",
            "aria-hidden": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-fw fa-pause tts-pause",
            "aria-hidden": "true"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            onClick: this.ttsStop,
            type: "button",
            className: "btn btn-round btn-tts",
            title: "Stop"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-fw fa-stop tts-stop",
            "aria-hidden": "true"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            id: "ttsId",
            "data-cfw-popover-placement": "bottom",
            "data-cfw-popover-target": "#onboard1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            id: "ttsGlossaryBtn",
            onClick: this.ttsDictionary,
            type: "button",
            className: "btn btn-round btn-tts",
            title: "Select a word to lookup definition"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-fw fa-book tts-glossary",
            "aria-hidden": "true"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            id: "ttsTranslateBtn",
            onClick: this.ttsTranslate,
            type: "button",
            className: "btn btn-round btn-tts",
            title: "Select a word/phrase to translate"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-fw fa-language tts-translate",
            "aria-hidden": "true"
        })));
    }
    isIOS() {
        // Second test is needed for iOS 13+
        return navigator.userAgent.match(/iPhone|iPad|iPod/i) != null || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
    }
    resetStoredRange() {
        $3759188b1291e350$var$storedRange = {
            collapsed: true
        };
    }
    recreateSelectionFromRange() {
        const selectionReset = document.getSelection();
        selectionReset.addRange($3759188b1291e350$var$storedRange);
        this.resetStoredRange();
        document.addEventListener('selectionEnd', this.handleSelectionEnd);
    }
    recreateSelection() {
        var that = this;
        return new Promise((resolve)=>{
            if (this.isIOS() && !$3759188b1291e350$var$storedRange.collapsed) {
                document.removeEventListener('selectionEnd', this.handleSelectionEnd);
                const selectionReset = document.getSelection();
                selectionReset.removeAllRanges();
                clearTimeout($3759188b1291e350$var$timerRef);
                setTimeout(function() {
                    that.recreateSelectionFromRange();
                    resolve();
                }, 10);
            } else resolve();
        });
    }
    async hasSelection() {
        clearTimeout($3759188b1291e350$var$timerRef);
        await this.recreateSelection();
        let selection = window.getSelection();
        return !(selection.type === 'None' || selection.type === 'Caret');
    }
    async ttsPlay() {
        // Check for a visible modal - borrowed from jQuery's `:visible` pseudo-selector
        let modalVis = [
            ...document.querySelectorAll('.modal')
        ].filter((elem)=>{
            return !!((elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length) && window.getComputedStyle(elem).visibility !== "hidden");
        });
        let offcanvasVis = [
            ...document.querySelectorAll('.offcanvas')
        ].filter((elem)=>{
            return !!((elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length) && window.getComputedStyle(elem).visibility !== "hidden");
        });
        window.speechstream.speechTools.setSpeechRenderedCallback(this.ttsCheckForPause);
        if (window.speechstream.speechTools.isPaused()) {
            console.debug('Speechstream is paused: resuming');
            window.speechstream.speechTools.pause();
            this.ttsIsPlaying();
            return;
        }
        if (window.speechstream.speechTools.isSpeaking()) {
            console.debug('Speechstream is playing: pause');
            window.speechstream.speechTools.pause();
            this.ttsIsPaused();
            return;
        }
        let action;
        if (await this.hasSelection()) {
            action = 'read selection';
            window.speechstream.speechTools.play();
        } else if (modalVis.length) {
            action = 'read modal';
            window.speechstream.speechTools.speakElement(modalVis[0], false);
        } else if (offcanvasVis.length) {
            action = 'read offcanvas';
            window.speechstream.speechTools.speakElement(offcanvasVis[0], false);
        } else {
            action = 'read page';
            let mainContainer = document.querySelector('#content');
            if (mainContainer) window.speechstream.speechTools.speakElement(mainContainer, false);
            else window.speechstream.speechTools.play();
        }
        console.debug('Speechstream starting: ', action);
        window.tracker.trackEvent('Support', 'read aloud', action);
        this.ttsIsPlaying();
    }
    ttsStop() {
        window.speechstream.speechTools.stop();
    }
    async ttsDictionary() {
        if (await this.hasSelection()) {
            window.tracker.trackEvent('Support', 'dictionary');
            window.speechstream.textTools.dictionaryLookup();
        } else {
            window.tracker.trackEvent('Support', 'dictionary', 'no selection');
            alert('Select a word then click this button to look it up');
        }
    }
    async ttsTranslate() {
        if (await this.hasSelection()) {
            window.tracker.trackEvent('Support', 'translate');
            window.speechstream.textTools.translate();
        } else {
            alert('Select a word then click this button to see the Spanish translation');
            window.tracker.trackEvent('Support', 'translate', 'no selection');
        }
    }
    ttsIsPlaying() {
        this.setState({
            playing: true
        });
    }
    ttsIsPaused() {
        this.setState({
            playing: false
        });
    }
    ttsCheckForPause = $3759188b1291e350$var$debounce(function() {
        // Check for user clicking pause when moving between passages
        if (!this.state.playing && window.speechstream.speechTools.isSpeaking()) {
            console.log('Speechstream: queued pause');
            window.speechstream.speechTools.pause();
        }
    }, 200);
}



var $6wXVr = parcelRequire("6wXVr");

class $e44b5e8bac417196$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    render() {
        let canEdit = this.context.canEdit;
        let fileId = this.context.fileId;
        return fileId != null && !canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "alert alert-topbar alert-view print-none",
            role: "alert"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-eye me-0_25",
            "aria-hidden": "true"
        }), "This Corgi Guide is ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("strong", null, "view only"), ".  To edit, ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "# ",
            onClick: this.props.copyButtonMethod
        }, "make a copy"), ".", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "close",
            "data-cfw-dismiss": "alert",
            "aria-label": "Close"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-times",
            "aria-hidden": "true"
        }))) : null;
    }
}



function $02aae4bdeb427b3e$export$2e2bcd8739ae039(props) {
    (0, $6wXVr.useEffect)(()=>{
        (0, $2c839b9f78572b9b$export$2e2bcd8739ae039)();
    });
    const header = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $0daa70a15a5cde6e$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $7389ab5c64e1a271$export$2e2bcd8739ae039), null));
    const tts = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $3759188b1291e350$export$2e2bcd8739ae039), null);
    const nav = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $62dd19b433ee653f$export$2e2bcd8739ae039), {
        copyButtonMethod: props.copyButtonMethod,
        shareMethod: props.shareMethod,
        newDocButtonMethod: props.newDocButtonMethod
    });
    const viewOnlyNotice = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e44b5e8bac417196$export$2e2bcd8739ae039), {
        copyButtonMethod: props.copyButtonMethod
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $7dfc83116dbc3695$export$2e2bcd8739ae039), null), header, tts, viewOnlyNotice, props.main, props.footer, nav);
}




var $6wXVr = parcelRequire("6wXVr");

function $164886e74c3a88c8$export$2e2bcd8739ae039() {
    const { pathname: pathname } = (0, $fc353641e976e80e$export$45d76561a5302f2b)();
    (0, $6wXVr.useEffect)(()=>{
        window.scrollTo(0, 0);
    }, [
        pathname
    ]);
    return null;
}




var $6wXVr = parcelRequire("6wXVr");


class $f33014965c9c8d29$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    static contextType = (0, $0f09ddde1e7ea4cb$export$2e2bcd8739ae039);
    constructor(props){
        super(props);
        let role = this.props.currentUser !== null ? this.props.currentUser.role : "student";
        this.state = {
            role: role,
            showEmailLink: false
        };
        this.handleContinue = this.handleContinue.bind(this);
        this.updateUserRole = this.updateUserRole.bind(this);
        this.changeUserRole = this.changeUserRole.bind(this);
        this.resetUserRole = this.resetUserRole.bind(this);
    }
    handleContinue(event) {
        if (this.state.showEmailLink) {
            // Email tab was showing
            this.closeModal();
            this.setState({
                showEmailLink: false
            });
        } else {
            // Role-choice tab was displaying
            this.context.updateAccountType(this.state.role);
            if (this.state.role === 'teacher') // Teacher -> ask about email before closing
            this.setState({
                showEmailLink: true
            });
            else this.closeModal();
        }
    }
    changeUserRole(event) {
        // Change the local state of which radio button is checked
        console.debug('changeUserRole', event, event.target, event.target.value);
        let role = event.target.value;
        this.setState({
            role: role
        });
    }
    updateUserRole() {
        // Actually change the user's role in the database
        this.context.updateAccountType(this.state.role);
        this.closeModal();
    }
    updateRole(role) {
        this.setState({
            role: role
        });
    }
    resetUserRole() {
        let role = this.props.currentUser !== null ? this.props.currentUser.role : "student";
        this.setState({
            role: role
        });
    }
    closeModal() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#modalUserType0').CFW_Modal('hide');
        (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#modalUserType1').CFW_Modal('hide');
    }
    render() {
        let currentUser = this.props.currentUser;
        let displayName = currentUser !== null ? currentUser.displayName : "";
        let roleChoiceBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("fieldset", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("legend", {
            className: "form-label font-weight-bold"
        }, "Are you a student or a teacher?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            onChange: this.changeUserRole
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "form-check form-checkradio"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("input", {
            className: "form-check-input",
            type: "radio",
            id: "level0-0",
            value: "student",
            defaultChecked: this.state.role === "student",
            name: "level0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("label", {
            className: "form-check-label font-weight-bold",
            htmlFor: "level0-0"
        }, "Student")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "form-check form-checkradio"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("input", {
            className: "form-check-input",
            type: "radio",
            id: "level0-1",
            value: "teacher",
            defaultChecked: this.state.role === "teacher",
            name: "level0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("label", {
            className: "form-check-label font-weight-bold",
            htmlFor: "level0-1"
        }, "Teacher")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "text-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "submit",
            className: "btn btn-success",
            disabled: this.state.role === '',
            onClick: this.handleContinue
        }, "Continue")));
        let emailBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", null, "Join our mailing list for occasional updates to the Corgi platform."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            onClick: this.closeModal,
            href: "http://eepurl.com/h_p6J1",
            target: "_blank",
            rel: "noopener noreferrer",
            className: "btn btn-primary"
        }, "Sign up"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "text-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "btn btn-success",
            onClick: this.closeModal
        }, "No thanks")));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "btn d-none",
            "data-cfw": "modal",
            "data-cfw-modal-target": "#modalUserType0",
            "data-cfw-modal-backdrop": "static"
        }, "Acct Type - Corgi"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "modalUserType0",
            className: "modal atype-modal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-dialog modal-dialog-centered"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            className: "h3 modal-title"
        }, "Welcome to Corgi, ", displayName, "!")), this.state.showEmailLink ? emailBody : roleChoiceBody))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: "modalUserType1",
            className: "modal atype-modal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-dialog modal-dialog-centered"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            className: "h1 modal-title"
        }, "Change account type?")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("fieldset", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("legend", {
            className: "form-label"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("strong", null, "Are you a student or a teacher?")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "form-check form-checkradio"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("input", {
            className: "form-check-input",
            type: "radio",
            id: "level1-0",
            checked: this.state.role === "student",
            onChange: this.changeUserRole,
            value: "student",
            name: "level1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("label", {
            className: "form-check-label",
            htmlFor: "level1-0"
        }, "Student")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "form-check form-checkradio"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("input", {
            className: "form-check-input",
            type: "radio",
            id: "level1-1",
            checked: this.state.role === "teacher",
            onChange: this.changeUserRole,
            value: "teacher",
            name: "level1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("label", {
            className: "form-check-label",
            htmlFor: "level1-1"
        }, "Teacher")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "text-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "btn btn-link",
            "data-cfw-dismiss": "modal",
            onClick: this.resetUserRole
        }, "Cancel"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "submit",
            className: "btn btn-primary",
            disabled: this.state.role === '',
            onClick: this.updateUserRole
        }, "Continue")))))));
    }
}


// Show 'rotate to landsacpe' image for 'mobile' devices when in portait mode

var $6wXVr = parcelRequire("6wXVr");


var $1afa2a8537b28513$exports = {};
$1afa2a8537b28513$exports = $parcel$resolve("bA5u8");


function $19a2c46de016b524$var$debounce(fn, ms) {
    let timer;
    return ()=>{
        clearTimeout(timer);
        timer = setTimeout(()=>{
            timer = null;
            fn.apply(this, arguments);
        }, ms);
    };
}
class $19a2c46de016b524$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    constructor(props){
        super(props);
        this.isMobilePortrait = this.isMobilePortrait.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.debouncedHandleResize = $19a2c46de016b524$var$debounce(this.handleResize, 150);
    }
    componentWillMount() {
        this.modalId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.buttonId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
    }
    isMobilePortrait() {
        const breakpointSm = getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-sm');
        const isMobile = window.matchMedia('(max-width: ' + breakpointSm + ')').matches;
        return isMobile && window.matchMedia("screen").matches && window.matchMedia("(orientation: portrait)").matches;
    }
    handleResize() {
        if (this.isMobilePortrait()) {
            const $openModal = (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('.modal:visible:not("#' + this.modalId + '")');
            const btnId = this.buttonId;
            var showModal = function() {
                $openModal.off('afterHide.cfw.modal.rotate');
                (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#' + btnId).CFW_Modal('show');
            };
            if ($openModal.length > 0) {
                $openModal.on('afterHide.cfw.modal.rotate', showModal);
                $openModal.CFW_Modal('hide');
            } else showModal();
        } else (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#' + this.modalId).CFW_Modal('hide');
    }
    componentDidMount() {
        window.addEventListener('resize', this.debouncedHandleResize);
        this.handleResize();
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.debouncedHandleResize);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $6wXVr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            id: this.buttonId,
            type: "button",
            className: "btn d-none",
            "data-cfw": "modal",
            "data-cfw-modal-target": "#" + this.modalId,
            "data-cfw-modal-backdrop": "static"
        }, "Rotate message dialog"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: this.modalId,
            className: "modal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-dialog modal-dialog-centered"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-body text-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-title text-center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row mt-0_5 mb-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-6 offset-3"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($1afa2a8537b28513$exports))),
            className: "img-fluid",
            alt: "Rotating a mobile device"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("strong", null, "Rotate your device ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "sr-only"
        }, "to landscape orientation"))))))));
    }
}





var $6wXVr = parcelRequire("6wXVr");


async function $a9fae44aeb551fe1$var$validEmbedYouTubeUrl(url) {
    console.debug('Testing youtube url: ', url);
    let urlLink = url.href;
    var regExp = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
    let videoId = null;
    if (urlLink.match(regExp)) {
        videoId = urlLink.match(regExp)[1];
        let embedUrl = "https://www.youtube.com/embed/" + videoId + "?enablejsapi=1";
        return await $a9fae44aeb551fe1$var$checkVideo(embedUrl, videoId);
    }
    return false;
}
function $a9fae44aeb551fe1$var$checkVideo(url, videoId) {
    console.debug('checking: ', url);
    return new Promise((resolve)=>{
        const image = new Image();
        image.addEventListener('load', ()=>{
            console.debug('loaded', image, image.width);
            //if the video does not exist(therefore thumbnail don't exist), a default thumbnail of 120 width is returned.
            if (image.width !== 120) resolve(url);
            else resolve(false);
        });
        image.addEventListener('error', ()=>{
            console.debug('errored');
            resolve(false);
        });
        image.src = "https://img.youtube.com/vi/" + videoId + "/mqdefault.jpg";
    });
}
class $a9fae44aeb551fe1$export$2e2bcd8739ae039 extends (0, $d8775d5311bbf499$export$2e2bcd8739ae039) {
    constructor(props){
        super(props);
        this.state = {
            'video': null,
            'error': null
        };
        this.resetInput = this.resetInput.bind(this);
    }
    componentWillMount() {
        this.addImgUrlInputId = 'addyoutubemodalinput';
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: this.props.id,
            className: "modal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-dialog modal-dialog-centered"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            className: "h1 modal-title"
        }, "Embed a YouTube Video"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "close",
            "data-cfw-dismiss": "modal",
            "aria-label": "Close",
            onClick: (event)=>{
                event.preventDefault();
                this.resetInput();
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-times",
            "aria-hidden": "true"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("form", {
            className: "row gx-0_5",
            role: "search",
            onSubmit: (event)=>{
                event.preventDefault();
                try {
                    let url = new URL(event.target[0].value);
                    $a9fae44aeb551fe1$var$validEmbedYouTubeUrl(url).then((value)=>{
                        if (!value) this.setState({
                            'error': 'YouTube Video not found or not supported.',
                            'video': null
                        });
                        else this.setState({
                            'error': null,
                            'video': value
                        });
                    });
                } catch (e) {
                    this.setState({
                        'error': "Sorry, " + e.message,
                        'video': null
                    });
                }
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("label", {
            htmlFor: this.addImgUrlInputId,
            className: "fs-small sr-only"
        }, "YouTube URL"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("input", {
            id: this.addImgUrlInputId,
            type: "url",
            className: "form-control",
            placeholder: "Paste a YouTube URL here",
            required: true,
            onClick: (event)=>{
                event.target.value = null;
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-sm-auto mt-0_5 mt-sm-0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "submit",
            className: "btn btn-primary"
        }, "Preview"))), this.state.error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mt-1 font-weight-bold"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-exclamation-circle text-danger fs-xlarge me-0_25",
            "aria-hidden": "true"
        }), ' ', " ", this.state.error) : null, this.state.video ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "attachment mt-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $c0ad353fe5b45e03$export$2e2bcd8739ae039), {
            video: {
                'src': this.state.video
            }
        })) : null), this.state.video ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-footer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "btn btn-link",
            "data-cfw-dismiss": "modal",
            onClick: (event)=>{
                event.preventDefault();
                this.resetInput();
            }
        }, "Cancel"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "btn btn-primary",
            onClick: (event)=>{
                event.preventDefault();
                this.props.saveMethod({
                    'src': this.state.video
                });
                this.resetInput();
            }
        }, "Add Video")) : null)));
    }
    resetInput() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#' + this.addImgUrlInputId).val(null);
        this.setState({
            'error': null,
            'video': null
        });
    }
}


// Google Custom Search Engine configured for full web safe image search

var $6wXVr = parcelRequire("6wXVr");




var $3UKyI = parcelRequire("3UKyI");


const $e9bcbf5b98dbad96$var$DEFAULT_REQUEST_IMAGE_COUNT = 9; // 10 is api default/max, but we want three rows
const $e9bcbf5b98dbad96$var$GOOGLE_SEARCH_BASE_URL = "https://www.googleapis.com/customsearch/v1";
const $e9bcbf5b98dbad96$var$emptySearch = {
    error: null,
    terms: "",
    preSearchTerms: "",
    start: 1,
    results: [],
    allFetchedImages: [],
    totalImg: 0
};
const $e9bcbf5b98dbad96$var$noImage = {
    src: '',
    alt: ''
};
const $e9bcbf5b98dbad96$var$maxMB = 50;
const $e9bcbf5b98dbad96$var$max_start = 190; // errors after this?
const $e9bcbf5b98dbad96$var$maxResolution = 25; //megapixels
function $e9bcbf5b98dbad96$var$validImage(url) {
    // TODO: actually try to fetch?
    return [
        "http:",
        "https:"
    ].includes(url.protocol) && url.toString().length <= 2048 && url.hostname !== 'lookaside.fbsbx.com';
}
function $e9bcbf5b98dbad96$var$alt(image) {
    if (image.alt) return image.alt;
    let alt = image.description;
    if ((0, $21f9ebdc444decaf$export$6e22c362a0406a2c)(alt)) alt = "no image description :(";
    return alt;
}
class $e9bcbf5b98dbad96$export$2e2bcd8739ae039 extends (0, $d8775d5311bbf499$export$2e2bcd8739ae039) {
    constructor(props){
        super(props);
        this.fetchSearchResults = this.fetchSearchResults.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.previousPage = this.previousPage.bind(this);
        this.resetInput = this.resetInput.bind(this);
        this.handleSearchSelect = this.handleSearchSelect.bind(this);
        this.addImage = this.addImage.bind(this);
        this.requestedImagesCount = this.props.count ? this.props.count : $e9bcbf5b98dbad96$var$DEFAULT_REQUEST_IMAGE_COUNT;
        this.setSearchResults = (results, extendResult, isNewSearch, searchTerm)=>{
            if (isNewSearch) this.setState({
                search: {
                    results: [],
                    allFetchedResults: [],
                    totalImg: 0,
                    start: 1
                }
            });
            let allFetchedResults = this.state.search.allFetchedResults;
            if (extendResult) allFetchedResults = this.state.search.allFetchedResults.concat(results);
            let totalImg = allFetchedResults.length;
            let startIndex = totalImg - results.length + 1;
            this.setState({
                search: {
                    results: results,
                    allFetchedResults: allFetchedResults,
                    start: startIndex,
                    totalImg: totalImg,
                    preSearchTerms: searchTerm
                }
            });
        };
        this.state = {
            error: {
                message: null
            },
            image: $e9bcbf5b98dbad96$var$noImage,
            search: $e9bcbf5b98dbad96$var$emptySearch
        };
    }
    componentWillMount() {
        this.modalImageSearchButtonId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
        this.addImageSearchId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
    }
    resetInput() {
        this.setState({
            search: $e9bcbf5b98dbad96$var$emptySearch,
            error: null
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#' + this.addImageSearchId).val($e9bcbf5b98dbad96$var$emptySearch.terms);
    }
    fetchSearchResults(isNewSearch) {
        return new Promise((resolve, reject)=>{
            const apiKey = (0, $220c2d58964ba595$export$fcc0626890c55730) ? (0, $220c2d58964ba595$export$fcc0626890c55730).apiKey : '42';
            const cx = (0, $220c2d58964ba595$export$fcc0626890c55730) ? (0, $220c2d58964ba595$export$fcc0626890c55730).cx : '002858309614930574590:4aiyhkyi_1g';
            let termSearch = this.state.search.terms;
            let start;
            if (isNewSearch) {
                this.setState({
                    search: $e9bcbf5b98dbad96$var$emptySearch,
                    error: null
                });
                start = 1;
            } else {
                start = 0 === this.state.search.results.length ? this.state.search.start : (this.state.search.start + this.requestedImagesCount) % $e9bcbf5b98dbad96$var$max_start;
                const term = this.state.search.preSearchTerms;
                if (term !== null) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#' + this.addImageSearchId).val(term);
                    termSearch = term;
                }
            }
            const params = {
                key: apiKey,
                cx: cx,
                searchType: "image",
                q: termSearch,
                start: start,
                num: this.requestedImagesCount
            };
            let url = $e9bcbf5b98dbad96$var$GOOGLE_SEARCH_BASE_URL;
            const query = Object.keys(params).map((k)=>{
                if (Array.isArray(params[k])) return params[k].map((val)=>`${encodeURIComponent(k)}[]=${encodeURIComponent(val)}`).join('&');
                return `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`;
            }).join('&');
            url += `?${query}`;
            const listMime = [
                "image/jpeg",
                "image/png",
                "image/gif"
            ];
            fetch(url).then((res)=>res.json()).then((response)=>{
                console.log(response);
                if (!parseInt(response.searchInformation.totalResults, 10) > 0) {
                    this.setState({
                        error: {
                            message: "No images found."
                        }
                    });
                    reject("No images found.");
                    return;
                }
                let results = [];
                const images = response.items.filter((image)=>{
                    console.log(image);
                    return listMime.includes(image.mime);
                });
                images.forEach((img)=>{
                    if ($e9bcbf5b98dbad96$var$validImage(new URL(img.link))) {
                        let imageSize = img.image.byteSize / 1024 / 1024;
                        let resolution = img.image.width * img.image.height / 1000000;
                        if (imageSize < $e9bcbf5b98dbad96$var$maxMB && resolution < $e9bcbf5b98dbad96$var$maxResolution) results.push({
                            src: img.link,
                            mimeType: img.mime,
                            description: img.title
                        });
                        else console.log("Image size too big --> don't use");
                    } else console.log("Image Search ignoring invalid %s", img.link.substr(0, 20));
                });
                const newSearch = {
                    ...this.state.search,
                    preSearchTerms: termSearch,
                    results: results,
                    start: params.start
                };
                const newState = {
                    ...this.state,
                    search: newSearch
                };
                this.setState(newState, ()=>{
                    console.log("%d results for %s image search with start %d", this.state.search.results.length, termSearch, this.state.search.start);
                });
                this.setSearchResults(results, true, isNewSearch, termSearch);
                resolve(results);
            }, (err_reason)=>{
                console.log("Could not get image search results: " + err_reason.error.message);
                this.setState({
                    error: {
                        message: "Could not get image search results"
                    }
                });
                reject(err_reason);
            });
        });
    }
    nextPage(event) {
        let nextStartIndex = this.state.search.start + $e9bcbf5b98dbad96$var$DEFAULT_REQUEST_IMAGE_COUNT;
        let allFetchedResults = this.state.search.allFetchedResults;
        event.preventDefault();
        if (nextStartIndex < allFetchedResults.length) {
            let listImages = [];
            for(let i = nextStartIndex - 1; i < nextStartIndex + $e9bcbf5b98dbad96$var$DEFAULT_REQUEST_IMAGE_COUNT - 1; i++)if (i < allFetchedResults.length) listImages.push(this.state.search.allFetchedResults[i]);
            this.setState({
                search: {
                    ...this.state.search,
                    results: listImages,
                    allFetchedResults: allFetchedResults,
                    start: nextStartIndex,
                    totalImg: allFetchedResults.length
                }
            });
        } else {
            console.log("from = " + nextStartIndex + ",totalImg = " + allFetchedResults.length);
            this.fetchSearchResults(false).then((r)=>console.log(r));
        }
    }
    previousPage(event) {
        let previousStartIndex = this.state.search.start - $e9bcbf5b98dbad96$var$DEFAULT_REQUEST_IMAGE_COUNT;
        if (previousStartIndex < 1) previousStartIndex = 1;
        let totalImg = this.state.search.allFetchedResults.length;
        event.preventDefault();
        let listImages = [];
        for(let i = previousStartIndex - 1; i < previousStartIndex + $e9bcbf5b98dbad96$var$DEFAULT_REQUEST_IMAGE_COUNT - 1; i++)if (i >= 0) listImages.push(this.state.search.allFetchedResults[i]);
        this.setState({
            search: {
                ...this.state.search,
                results: listImages,
                allFetchedResults: this.state.search.allFetchedResults,
                start: previousStartIndex,
                totalImg: totalImg
            }
        });
    }
    handleSearchSelect(e) {
        let img = e.target.nextElementSibling.firstChild;
        let src = img.getAttribute('src');
        let alt = img.getAttribute('alt');
        if (this.validImage(new URL(src))) // TODO: remove query?
        this.setState({
            image: {
                src: src,
                alt: alt ? alt : ""
            }
        }, ()=>console.log('selected image %s', (0, (/*@__PURE__*/$parcel$interopDefault($3UKyI))).inspect(this.state.image)));
        else {
            e.preventDefault();
            console.log('skipping invalid URL %s', src);
        }
    }
    validImage(url) {
        // TODO: actually try to fetch?
        return [
            "http:",
            "https:"
        ].includes(url.protocol) && url.toString().length <= 2048 && url.hostname !== 'lookaside.fbsbx.com';
    }
    addImage() {
        console.log("save selected web image: %s", (0, (/*@__PURE__*/$parcel$interopDefault($3UKyI))).inspect(this.state.image));
        this.props.saveMethod(this.state.image);
        this.resetInput();
        window.tracker.trackEvent("Content", "add image", "search");
    }
    render() {
        const disableSearch = !(undefined !== this.state.search.terms && 0 < this.state.search.terms.length);
        let searchButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            id: this.modalImageSearchButtonId,
            type: "button",
            className: "btn btn-primary",
            disabled: disableSearch,
            onClick: ()=>{
                this.fetchSearchResults(true).then((r)=>console.log(r), ()=>{});
            }
        }, "Search");
        let resultImages = [];
        for (const [index, value] of this.state.search.results.entries()){
            let id = (0, (/*@__PURE__*/$parcel$interopDefault($3UKyI))).inspect(index);
            resultImages.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                key: index,
                className: "col mb-1"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
                className: "form-check form-checkradio addimg-radio"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("input", {
                id: "addimg2-" + id,
                name: "addimg2",
                className: "form-check-input",
                type: "radio",
                onClick: (event)=>{
                    this.handleSearchSelect(event);
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("label", {
                htmlFor: "addimg2-" + id,
                className: "form-check-label"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("img", {
                src: value.src,
                className: "img-fluid",
                alt: $e9bcbf5b98dbad96$var$alt(value),
                onError: (err)=>{
                    const message = "AddImageButton onError img " + index.toString() + " " + err.currentTarget.currentSrc;
                    console.log(message);
                    // err.target.style.visibility = "hidden";
                    let results = this.state.search.results;
                    results.splice(index, 1);
                    this.setSearchResults(results, false);
                }
            })))));
        }
        let saveSearchButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "btn btn-primary",
            disabled: '' === this.state.image.src,
            onClick: ()=>{
                this.addImage();
            }
        }, "Add Image");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: this.props.id,
            className: "modal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-dialog modal-dialog-centered modal-dialog-scrollable",
            role: "document"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            className: "h1 modal-title"
        }, "Search for images"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "close",
            "data-cfw-dismiss": "modal",
            "aria-label": "Close",
            onClick: (event)=>{
                event.preventDefault();
                this.resetInput();
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-times",
            "aria-hidden": "true"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-extra"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("form", {
            className: "row gx-0_5",
            role: "search"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("label", {
            htmlFor: this.addImageSearchId,
            className: "fs-small sr-only"
        }, "Search term"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("input", {
            id: this.addImageSearchId,
            type: "search",
            className: "form-control",
            placeholder: "Enter a search term",
            onClick: ()=>{
            // event.target.value = null; // no, per BG edit existing
            },
            onKeyPress: (event)=>{
                if (event.key === "Enter") {
                    event.preventDefault();
                    // Trigger the search button element with a click
                    (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#' + this.modalImageSearchButtonId).click();
                }
            },
            onInput: (event)=>{
                const searchTerms = event.target.value;
                const preSearchTerms = this.state.search.preSearchTerms;
                try {
                    this.setState({
                        search: {
                            terms: searchTerms,
                            preSearchTerms: preSearchTerms,
                            start: this.state.search.start,
                            results: this.state.search.results
                        }
                    });
                } catch (e) {
                    this.setState({
                        error: {
                            message: "Sorry, " + e.message
                        }
                    });
                }
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-sm-auto mt-0_5 mt-sm-0"
        }, searchButton))), this.state.error && this.state.error.message ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-body pt-0_25"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-exclamation-circle text-danger fs-xlarge me-0_25",
            "aria-hidden": "true"
        }), this.state.error.message) : null, !this.state.search.results.length ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-body bg-autofill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "row row-cols-2 row-cols-md-3 gx-1"
        }, resultImages), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "text-center"
        }, this.state.search.start === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "text-muted"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            "aria-hidden": "true"
        }, "<"), " Previous") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "# ",
            onClick: this.previousPage
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            "aria-hidden": "true"
        }, "<"), "Previous"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("strong", {
            className: "ps-1"
        }, "Results "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("strong", null, this.state.search.start), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("strong", null, "-"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("strong", {
            className: "pe-1"
        }, this.state.search.start + this.state.search.results.length - 1), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("a", {
            href: "# ",
            onClick: this.nextPage
        }, "Next ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            "aria-hidden": "true"
        }, ">")))), !this.state.search.results.length ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-footer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "btn btn-link",
            "data-cfw-dismiss": "modal",
            onClick: (event)=>{
                event.preventDefault();
                this.resetInput();
            }
        }, "Cancel"), saveSearchButton))));
    }
}





var $6wXVr = parcelRequire("6wXVr");


const $b33ca804eb3e243c$var$noImage = {
    src: '',
    alt: ''
};
const $b33ca804eb3e243c$var$maxMB = 50;
const $b33ca804eb3e243c$var$maxResolution = 25; //megapixels
class $b33ca804eb3e243c$export$2e2bcd8739ae039 extends (0, $d8775d5311bbf499$export$2e2bcd8739ae039) {
    constructor(props){
        super(props);
        this.state = {
            image: $b33ca804eb3e243c$var$noImage
        };
        this.imageError = this.imageError.bind(this);
        this.resetInput = this.resetInput.bind(this);
        this.addImage = this.addImage.bind(this);
    }
    componentWillMount() {
        this.addImgUrlInputId = (0, $3e353bdb6bbe6e31$export$2e2bcd8739ae039)();
    }
    imageError() {
        return undefined !== this.state.image.error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "mt-1 font-weight-bold"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-exclamation-circle text-danger fs-xlarge me-0_25",
            "aria-hidden": "true"
        }), 0 < this.state.image.error.trim().length ? this.state.image.error : "There is an issue accessing this image.") : null;
    }
    resetInput() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#' + this.addImgUrlInputId).val(null);
        this.setState({
            image: $b33ca804eb3e243c$var$noImage
        });
    }
    addImage() {
        this.props.saveMethod(this.state.image);
        window.tracker.trackEvent("Content", "add image", "url");
        this.resetInput();
    }
    render() {
        let saveExternalButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "btn btn-primary",
            disabled: '' === this.state.image.src,
            onClick: (event)=>{
                event.preventDefault();
                this.addImage();
            }
        }, "Add Image");
        let errorMessage = null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            id: this.props.id,
            className: "modal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-dialog modal-dialog-centered"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("h2", {
            className: "h1 modal-title"
        }, "Enter an image URL"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "close",
            "data-cfw-dismiss": "modal",
            "aria-label": "Close",
            onClick: (event)=>{
                event.preventDefault();
                this.resetInput();
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("span", {
            className: "fa fa-times",
            "aria-hidden": "true"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("p", {
            className: "directions"
        }, "Supported filetypes: gif, jpg, png. Max filesize: 25mb."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("form", {
            className: "row gx-0_5",
            role: "search",
            onSubmit: (event)=>{
                event.preventDefault();
                let url = "invalid";
                try {
                    url = new URL(event.target[0].value);
                    $b33ca804eb3e243c$var$validUrlImage(url).then((value)=>{
                        if (!value) errorMessage = "Image not found or not supported.";
                        const image = errorMessage ? {
                            src: '',
                            error: errorMessage
                        } : {
                            src: url.toString(),
                            name: url.pathname.split('/').pop()
                        };
                        this.setState({
                            image: image
                        });
                    });
                } catch (e) {
                    errorMessage = "Sorry, " + e.message;
                }
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("label", {
            htmlFor: this.addImgUrlInputId,
            className: "fs-small sr-only"
        }, "Image url"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("input", {
            id: this.addImgUrlInputId,
            type: "url",
            className: "form-control",
            placeholder: "Paste an image URL here",
            required: true,
            onClick: (event)=>{
                event.target.value = null;
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "col-sm-auto mt-0_5 mt-sm-0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "submit",
            className: "btn btn-primary"
        }, "Preview"))), this.imageError(), !this.state.image.error && this.state.image.src ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "attachment mt-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "attachment-media"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e1cee4d396a9c536$export$2e2bcd8739ae039), {
            containerClassName: "none",
            image: this.state.image
        }))) : null), !this.state.image.error && this.state.image.src ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("div", {
            className: "modal-footer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement("button", {
            type: "button",
            className: "btn btn-link",
            "data-cfw-dismiss": "modal",
            onClick: (event)=>{
                event.preventDefault();
                this.resetInput();
            }
        }, "Cancel"), saveExternalButton) : null)));
    }
}
async function $b33ca804eb3e243c$var$validUrlImage(url) {
    let pathname = url.pathname;
    let fileType = pathname.split('.').pop();
    let listImageType = [
        "jpg",
        "jpeg",
        "gif",
        "png"
    ];
    if (!listImageType.includes(fileType.toLowerCase())) return false;
    if (url.href.startsWith('data:')) return false;
    else return await $b33ca804eb3e243c$var$loadImage(url);
}
function $b33ca804eb3e243c$var$loadImage(url) {
    return new Promise((resolve)=>{
        const image = new Image();
        image.addEventListener('load', ()=>{
            let fileSize = $b33ca804eb3e243c$var$getImageSizeInBytes(url);
            let fileSizeMB = fileSize / 1024 / 1024;
            let resolution = image.width * image.height / 1000000;
            if (fileSizeMB > 0 && fileSizeMB < $b33ca804eb3e243c$var$maxMB && resolution < $b33ca804eb3e243c$var$maxResolution) resolve(true);
            else resolve(false);
        });
        image.addEventListener('error', ()=>{
            resolve(false);
        });
        image.src = url;
    });
}
function $b33ca804eb3e243c$var$getImageSizeInBytes(imgURL) {
    try {
        const request = new XMLHttpRequest();
        request.open("HEAD", imgURL, false);
        request.send(null);
        const headerText = request.getAllResponseHeaders();
        const re = /Content-Length\s*:\s*(\d+)/i;
        re.exec(headerText);
        return parseInt(RegExp.$1);
    } catch (e) {
        return 1;
    }
}



var $6wXVr = parcelRequire("6wXVr");
for(var $17a7e6a65f1eecc1$var$n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", $17a7e6a65f1eecc1$var$t = new Map, $17a7e6a65f1eecc1$var$o = 0; $17a7e6a65f1eecc1$var$o < $17a7e6a65f1eecc1$var$n.length; $17a7e6a65f1eecc1$var$o++){
    var $17a7e6a65f1eecc1$var$a = $17a7e6a65f1eecc1$var$o.toString(2);
    $17a7e6a65f1eecc1$var$a = "0".repeat(6 - $17a7e6a65f1eecc1$var$a.length) + $17a7e6a65f1eecc1$var$a, $17a7e6a65f1eecc1$var$t.set($17a7e6a65f1eecc1$var$n.charCodeAt($17a7e6a65f1eecc1$var$o), $17a7e6a65f1eecc1$var$a);
}
function $17a7e6a65f1eecc1$export$4b61618bdb99cb7e(e) {
    try {
        if ("string" != typeof e || 3 !== e.split(".").length) return null;
        var r = function(e) {
            for(var r, n = "", t = e.length, o = 0; o < t; o++)r = e[o], n += String.fromCodePoint(r > 251 && r < 254 && o + 5 < t ? 1073741824 * (r - 252) + (e[++o] - 128 << 24) + (e[++o] - 128 << 18) + (e[++o] - 128 << 12) + (e[++o] - 128 << 6) + e[++o] - 128 : r > 247 && r < 252 && o + 4 < t ? (r - 248 << 24) + (e[++o] - 128 << 18) + (e[++o] - 128 << 12) + (e[++o] - 128 << 6) + e[++o] - 128 : r > 239 && r < 248 && o + 3 < t ? (r - 240 << 18) + (e[++o] - 128 << 12) + (e[++o] - 128 << 6) + e[++o] - 128 : r > 223 && r < 240 && o + 2 < t ? (r - 224 << 12) + (e[++o] - 128 << 6) + e[++o] - 128 : r > 191 && r < 224 && o + 1 < t ? (r - 192 << 6) + e[++o] - 128 : r);
            return n;
        }((function(e) {
            for(var r = "", n = 0; n < e.length; n++)r += $17a7e6a65f1eecc1$var$t.get(e.charCodeAt(n));
            r = r.slice(0, r.length - r.length % 8);
            for(var o = [], a = 0; a < r.length / 8; a++)o.push(r.slice(8 * a, 8 * a + 8));
            return o;
        })(e.split(".")[1].replaceAll("=", "").replaceAll("-", "+").replaceAll("_", "/")).map(function(e) {
            return parseInt(e, 2);
        }));
        return JSON.parse(r);
    } catch (e) {
        return console.error("There was an error decoding token: ", e), null;
    }
}
function $17a7e6a65f1eecc1$export$57947cfd429801a2(e) {
    var r = $17a7e6a65f1eecc1$export$4b61618bdb99cb7e(e), n = !0;
    if (r && r.exp) {
        var t = new Date(0);
        t.setUTCSeconds(r.exp), n = t.valueOf() < (new Date).valueOf();
    }
    return n;
}
function $17a7e6a65f1eecc1$export$d6bec79f7474bc9f(n) {
    var t = (0, $6wXVr.useState)(!1), o = t[0], a = t[1], u = (0, $6wXVr.useState)(null), c = u[0], f = u[1];
    (0, $6wXVr.useEffect)(function() {
        p(n);
    }, [
        n
    ]);
    var p = function(e) {
        f($17a7e6a65f1eecc1$export$4b61618bdb99cb7e(e)), a($17a7e6a65f1eecc1$export$57947cfd429801a2(e));
    };
    return {
        isExpired: o,
        decodedToken: c,
        reEvaluateToken: p
    };
}



'use strict';
function $163d80cd77f686d0$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $6e454158db471ce9$var$toString } = Object.prototype;
const { getPrototypeOf: $6e454158db471ce9$var$getPrototypeOf } = Object;
const { iterator: $6e454158db471ce9$var$iterator, toStringTag: $6e454158db471ce9$var$toStringTag } = Symbol;
const $6e454158db471ce9$var$kindOf = ((cache)=>(thing)=>{
        const str = $6e454158db471ce9$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $6e454158db471ce9$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$6e454158db471ce9$var$kindOf(thing) === type;
};
const $6e454158db471ce9$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $6e454158db471ce9$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $6e454158db471ce9$var$isUndefined = $6e454158db471ce9$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $6e454158db471ce9$var$isBuffer(val) {
    return val !== null && !$6e454158db471ce9$var$isUndefined(val) && val.constructor !== null && !$6e454158db471ce9$var$isUndefined(val.constructor) && $6e454158db471ce9$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $6e454158db471ce9$var$isArrayBuffer = $6e454158db471ce9$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $6e454158db471ce9$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $6e454158db471ce9$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $6e454158db471ce9$var$isString = $6e454158db471ce9$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $6e454158db471ce9$var$isFunction = $6e454158db471ce9$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $6e454158db471ce9$var$isNumber = $6e454158db471ce9$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $6e454158db471ce9$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $6e454158db471ce9$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $6e454158db471ce9$var$isPlainObject = (val)=>{
    if ($6e454158db471ce9$var$kindOf(val) !== 'object') return false;
    const prototype = $6e454158db471ce9$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($6e454158db471ce9$var$toStringTag in val) && !($6e454158db471ce9$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $6e454158db471ce9$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$6e454158db471ce9$var$isObject(val) || $6e454158db471ce9$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $6e454158db471ce9$var$isDate = $6e454158db471ce9$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $6e454158db471ce9$var$isFile = $6e454158db471ce9$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 * 
 * @param {*} value The value to test
 * 
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $6e454158db471ce9$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 * 
 * @param {*} formData The formData to test
 * 
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $6e454158db471ce9$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $6e454158db471ce9$var$isBlob = $6e454158db471ce9$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $6e454158db471ce9$var$isFileList = $6e454158db471ce9$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $6e454158db471ce9$var$isStream = (val)=>$6e454158db471ce9$var$isObject(val) && $6e454158db471ce9$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $6e454158db471ce9$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $6e454158db471ce9$var$G = $6e454158db471ce9$var$getGlobal();
const $6e454158db471ce9$var$FormDataCtor = typeof $6e454158db471ce9$var$G.FormData !== 'undefined' ? $6e454158db471ce9$var$G.FormData : undefined;
const $6e454158db471ce9$var$isFormData = (thing)=>{
    let kind;
    return thing && ($6e454158db471ce9$var$FormDataCtor && thing instanceof $6e454158db471ce9$var$FormDataCtor || $6e454158db471ce9$var$isFunction(thing.append) && ((kind = $6e454158db471ce9$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $6e454158db471ce9$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $6e454158db471ce9$var$isURLSearchParams = $6e454158db471ce9$var$kindOfTest('URLSearchParams');
const [$6e454158db471ce9$var$isReadableStream, $6e454158db471ce9$var$isRequest, $6e454158db471ce9$var$isResponse, $6e454158db471ce9$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($6e454158db471ce9$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $6e454158db471ce9$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $6e454158db471ce9$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($6e454158db471ce9$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($6e454158db471ce9$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $6e454158db471ce9$var$findKey(obj, key) {
    if ($6e454158db471ce9$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $6e454158db471ce9$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $6e454158db471ce9$var$isContextDefined = (context)=>!$6e454158db471ce9$var$isUndefined(context) && context !== $6e454158db471ce9$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $6e454158db471ce9$var$merge() {
    const { caseless: caseless, skipUndefined: skipUndefined } = $6e454158db471ce9$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        const targetKey = caseless && $6e454158db471ce9$var$findKey(result, key) || key;
        if ($6e454158db471ce9$var$isPlainObject(result[targetKey]) && $6e454158db471ce9$var$isPlainObject(val)) result[targetKey] = $6e454158db471ce9$var$merge(result[targetKey], val);
        else if ($6e454158db471ce9$var$isPlainObject(val)) result[targetKey] = $6e454158db471ce9$var$merge({}, val);
        else if ($6e454158db471ce9$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$6e454158db471ce9$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $6e454158db471ce9$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $6e454158db471ce9$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $6e454158db471ce9$var$forEach(b, (val, key)=>{
        if (thisArg && $6e454158db471ce9$var$isFunction(val)) Object.defineProperty(a, key, {
            value: (0, $163d80cd77f686d0$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $6e454158db471ce9$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $6e454158db471ce9$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $6e454158db471ce9$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $6e454158db471ce9$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $6e454158db471ce9$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $6e454158db471ce9$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($6e454158db471ce9$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$6e454158db471ce9$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $6e454158db471ce9$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $6e454158db471ce9$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $6e454158db471ce9$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$6e454158db471ce9$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $6e454158db471ce9$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $6e454158db471ce9$var$isHTMLForm = $6e454158db471ce9$var$kindOfTest('HTMLFormElement');
const $6e454158db471ce9$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $6e454158db471ce9$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $6e454158db471ce9$var$isRegExp = $6e454158db471ce9$var$kindOfTest('RegExp');
const $6e454158db471ce9$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $6e454158db471ce9$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $6e454158db471ce9$var$freezeMethods = (obj)=>{
    $6e454158db471ce9$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($6e454158db471ce9$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$6e454158db471ce9$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $6e454158db471ce9$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $6e454158db471ce9$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $6e454158db471ce9$var$noop = ()=>{};
const $6e454158db471ce9$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $6e454158db471ce9$var$isSpecCompliantForm(thing) {
    return !!(thing && $6e454158db471ce9$var$isFunction(thing.append) && thing[$6e454158db471ce9$var$toStringTag] === 'FormData' && thing[$6e454158db471ce9$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $6e454158db471ce9$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($6e454158db471ce9$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            //Buffer check
            if ($6e454158db471ce9$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $6e454158db471ce9$var$isArray(source) ? [] : {};
                $6e454158db471ce9$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$6e454158db471ce9$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $6e454158db471ce9$var$isAsyncFn = $6e454158db471ce9$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $6e454158db471ce9$var$isThenable = (thing)=>thing && ($6e454158db471ce9$var$isObject(thing) || $6e454158db471ce9$var$isFunction(thing)) && $6e454158db471ce9$var$isFunction(thing.then) && $6e454158db471ce9$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $6e454158db471ce9$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $6e454158db471ce9$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $6e454158db471ce9$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $6e454158db471ce9$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $6e454158db471ce9$var$isFunction($6e454158db471ce9$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $6e454158db471ce9$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($6e454158db471ce9$var$_global) : $6e454158db471ce9$var$_setImmediate;
// *********************
const $6e454158db471ce9$var$isIterable = (thing)=>thing != null && $6e454158db471ce9$var$isFunction(thing[$6e454158db471ce9$var$iterator]);
var $6e454158db471ce9$export$2e2bcd8739ae039 = {
    isArray: $6e454158db471ce9$var$isArray,
    isArrayBuffer: $6e454158db471ce9$var$isArrayBuffer,
    isBuffer: $6e454158db471ce9$var$isBuffer,
    isFormData: $6e454158db471ce9$var$isFormData,
    isArrayBufferView: $6e454158db471ce9$var$isArrayBufferView,
    isString: $6e454158db471ce9$var$isString,
    isNumber: $6e454158db471ce9$var$isNumber,
    isBoolean: $6e454158db471ce9$var$isBoolean,
    isObject: $6e454158db471ce9$var$isObject,
    isPlainObject: $6e454158db471ce9$var$isPlainObject,
    isEmptyObject: $6e454158db471ce9$var$isEmptyObject,
    isReadableStream: $6e454158db471ce9$var$isReadableStream,
    isRequest: $6e454158db471ce9$var$isRequest,
    isResponse: $6e454158db471ce9$var$isResponse,
    isHeaders: $6e454158db471ce9$var$isHeaders,
    isUndefined: $6e454158db471ce9$var$isUndefined,
    isDate: $6e454158db471ce9$var$isDate,
    isFile: $6e454158db471ce9$var$isFile,
    isReactNativeBlob: $6e454158db471ce9$var$isReactNativeBlob,
    isReactNative: $6e454158db471ce9$var$isReactNative,
    isBlob: $6e454158db471ce9$var$isBlob,
    isRegExp: $6e454158db471ce9$var$isRegExp,
    isFunction: $6e454158db471ce9$var$isFunction,
    isStream: $6e454158db471ce9$var$isStream,
    isURLSearchParams: $6e454158db471ce9$var$isURLSearchParams,
    isTypedArray: $6e454158db471ce9$var$isTypedArray,
    isFileList: $6e454158db471ce9$var$isFileList,
    forEach: $6e454158db471ce9$var$forEach,
    merge: $6e454158db471ce9$var$merge,
    extend: $6e454158db471ce9$var$extend,
    trim: $6e454158db471ce9$var$trim,
    stripBOM: $6e454158db471ce9$var$stripBOM,
    inherits: $6e454158db471ce9$var$inherits,
    toFlatObject: $6e454158db471ce9$var$toFlatObject,
    kindOf: $6e454158db471ce9$var$kindOf,
    kindOfTest: $6e454158db471ce9$var$kindOfTest,
    endsWith: $6e454158db471ce9$var$endsWith,
    toArray: $6e454158db471ce9$var$toArray,
    forEachEntry: $6e454158db471ce9$var$forEachEntry,
    matchAll: $6e454158db471ce9$var$matchAll,
    isHTMLForm: $6e454158db471ce9$var$isHTMLForm,
    hasOwnProperty: $6e454158db471ce9$var$hasOwnProperty,
    hasOwnProp: $6e454158db471ce9$var$hasOwnProperty,
    reduceDescriptors: $6e454158db471ce9$var$reduceDescriptors,
    freezeMethods: $6e454158db471ce9$var$freezeMethods,
    toObjectSet: $6e454158db471ce9$var$toObjectSet,
    toCamelCase: $6e454158db471ce9$var$toCamelCase,
    noop: $6e454158db471ce9$var$noop,
    toFiniteNumber: $6e454158db471ce9$var$toFiniteNumber,
    findKey: $6e454158db471ce9$var$findKey,
    global: $6e454158db471ce9$var$_global,
    isContextDefined: $6e454158db471ce9$var$isContextDefined,
    isSpecCompliantForm: $6e454158db471ce9$var$isSpecCompliantForm,
    toJSONObject: $6e454158db471ce9$var$toJSONObject,
    isAsyncFn: $6e454158db471ce9$var$isAsyncFn,
    isThenable: $6e454158db471ce9$var$isThenable,
    setImmediate: $6e454158db471ce9$var$_setImmediate,
    asap: $6e454158db471ce9$var$asap,
    isIterable: $6e454158db471ce9$var$isIterable
};







'use strict';
class $528f4e1b21ef21f8$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new $528f4e1b21ef21f8$var$AxiosError(error.message, code || error.code, config, request, response);
        axiosError.cause = error;
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
     * Create an Error with the specified message, config, error code, request and response.
     *
     * @param {string} message The error message.
     * @param {string} [code] The error code (for example, 'ECONNABORTED').
     * @param {Object} [config] The config.
     * @param {Object} [request] The request.
     * @param {Object} [response] The response.
     *
     * @returns {Error} The created error.
     */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $6e454158db471ce9$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$528f4e1b21ef21f8$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$528f4e1b21ef21f8$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$528f4e1b21ef21f8$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$528f4e1b21ef21f8$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$528f4e1b21ef21f8$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$528f4e1b21ef21f8$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$528f4e1b21ef21f8$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$528f4e1b21ef21f8$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$528f4e1b21ef21f8$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$528f4e1b21ef21f8$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$528f4e1b21ef21f8$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$528f4e1b21ef21f8$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
var $528f4e1b21ef21f8$export$2e2bcd8739ae039 = $528f4e1b21ef21f8$var$AxiosError;


// eslint-disable-next-line strict
var $cf0749c38147a168$export$2e2bcd8739ae039 = null;



var $5fbcb9a9d643ea96$require$Buffer = $9efcfb26a96dcb10$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $5fbcb9a9d643ea96$var$isVisitable(thing) {
    return (0, $6e454158db471ce9$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $6e454158db471ce9$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $5fbcb9a9d643ea96$var$removeBrackets(key) {
    return (0, $6e454158db471ce9$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $5fbcb9a9d643ea96$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $5fbcb9a9d643ea96$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $5fbcb9a9d643ea96$var$isFlatArray(arr) {
    return (0, $6e454158db471ce9$export$2e2bcd8739ae039).isArray(arr) && !arr.some($5fbcb9a9d643ea96$var$isVisitable);
}
const $5fbcb9a9d643ea96$var$predicates = (0, $6e454158db471ce9$export$2e2bcd8739ae039).toFlatObject((0, $6e454158db471ce9$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $5fbcb9a9d643ea96$var$toFormData(obj, formData, options) {
    if (!(0, $6e454158db471ce9$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $cf0749c38147a168$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $6e454158db471ce9$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $6e454158db471ce9$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $6e454158db471ce9$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $6e454158db471ce9$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $6e454158db471ce9$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $6e454158db471ce9$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $5fbcb9a9d643ea96$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isReactNative(formData) && (0, $6e454158db471ce9$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($5fbcb9a9d643ea96$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isArray(value) && $5fbcb9a9d643ea96$var$isFlatArray(value) || ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isFileList(value) || (0, $6e454158db471ce9$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $6e454158db471ce9$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $5fbcb9a9d643ea96$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $6e454158db471ce9$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $5fbcb9a9d643ea96$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($5fbcb9a9d643ea96$var$isVisitable(value)) return true;
        formData.append($5fbcb9a9d643ea96$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($5fbcb9a9d643ea96$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $5fbcb9a9d643ea96$var$isVisitable
    });
    function build(value, path) {
        if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $6e454158db471ce9$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $6e454158db471ce9$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $6e454158db471ce9$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $6e454158db471ce9$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $5fbcb9a9d643ea96$export$2e2bcd8739ae039 = $5fbcb9a9d643ea96$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $0ba68b34c3b0f2e9$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $0ba68b34c3b0f2e9$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $5fbcb9a9d643ea96$export$2e2bcd8739ae039)(params, this, options);
}
const $0ba68b34c3b0f2e9$var$prototype = $0ba68b34c3b0f2e9$var$AxiosURLSearchParams.prototype;
$0ba68b34c3b0f2e9$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$0ba68b34c3b0f2e9$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $0ba68b34c3b0f2e9$var$encode);
    } : $0ba68b34c3b0f2e9$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $0ba68b34c3b0f2e9$export$2e2bcd8739ae039 = $0ba68b34c3b0f2e9$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $3647fc9ca1c77752$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $3647fc9ca1c77752$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    const _encode = options && options.encode || $3647fc9ca1c77752$var$encode;
    const _options = (0, $6e454158db471ce9$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    const serializeFn = _options && _options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $6e454158db471ce9$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $0ba68b34c3b0f2e9$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $66dd02769d59d78e$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $6e454158db471ce9$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $66dd02769d59d78e$export$2e2bcd8739ae039 = $66dd02769d59d78e$var$InterceptorManager;





'use strict';
var $14704af7d8a8eb83$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true
};






'use strict';
var $7b17784777ae56e2$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $0ba68b34c3b0f2e9$export$2e2bcd8739ae039);


'use strict';
var $3c122265351aa242$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $426d1cd6603005c8$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $7b213dcf2d752ce9$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $7b17784777ae56e2$export$2e2bcd8739ae039,
        FormData: $3c122265351aa242$export$2e2bcd8739ae039,
        Blob: $426d1cd6603005c8$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $949c32247a2a8434$exports = {};

$parcel$export($949c32247a2a8434$exports, "hasBrowserEnv", function () { return $949c32247a2a8434$export$c4996c4b7b93b0bf; });
$parcel$export($949c32247a2a8434$exports, "navigator", function () { return $949c32247a2a8434$export$ec7c8efa7f5790ae; });
$parcel$export($949c32247a2a8434$exports, "hasStandardBrowserEnv", function () { return $949c32247a2a8434$export$c0bcc9250309d66; });
$parcel$export($949c32247a2a8434$exports, "hasStandardBrowserWebWorkerEnv", function () { return $949c32247a2a8434$export$c81692cf5af97dac; });
$parcel$export($949c32247a2a8434$exports, "origin", function () { return $949c32247a2a8434$export$f710a83a91838a36; });
const $949c32247a2a8434$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $949c32247a2a8434$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $949c32247a2a8434$export$c0bcc9250309d66 = $949c32247a2a8434$export$c4996c4b7b93b0bf && (!$949c32247a2a8434$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($949c32247a2a8434$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $949c32247a2a8434$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $949c32247a2a8434$export$f710a83a91838a36 = $949c32247a2a8434$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $85b94d3eeda6d2ef$export$2e2bcd8739ae039 = {
    ...$949c32247a2a8434$exports,
    ...(0, $7b213dcf2d752ce9$export$2e2bcd8739ae039)
};


'use strict';
function $89721f165cb2cafe$export$2e2bcd8739ae039(data, options) {
    return (0, $5fbcb9a9d643ea96$export$2e2bcd8739ae039)(data, new (0, $85b94d3eeda6d2ef$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $85b94d3eeda6d2ef$export$2e2bcd8739ae039).isNode && (0, $6e454158db471ce9$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $aa9d2acf40fd8d1e$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $6e454158db471ce9$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $aa9d2acf40fd8d1e$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $aa9d2acf40fd8d1e$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $6e454158db471ce9$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $6e454158db471ce9$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $6e454158db471ce9$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $aa9d2acf40fd8d1e$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isFormData(formData) && (0, $6e454158db471ce9$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $6e454158db471ce9$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($aa9d2acf40fd8d1e$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $aa9d2acf40fd8d1e$export$2e2bcd8739ae039 = $aa9d2acf40fd8d1e$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $25556dd75ba8b2d4$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $6e454158db471ce9$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $25556dd75ba8b2d4$var$defaults = {
    transitional: (0, $14704af7d8a8eb83$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $6e454158db471ce9$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $6e454158db471ce9$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $6e454158db471ce9$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $aa9d2acf40fd8d1e$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $6e454158db471ce9$export$2e2bcd8739ae039).isBuffer(data) || (0, $6e454158db471ce9$export$2e2bcd8739ae039).isStream(data) || (0, $6e454158db471ce9$export$2e2bcd8739ae039).isFile(data) || (0, $6e454158db471ce9$export$2e2bcd8739ae039).isBlob(data) || (0, $6e454158db471ce9$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $89721f165cb2cafe$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $6e454158db471ce9$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $5fbcb9a9d643ea96$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $25556dd75ba8b2d4$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $25556dd75ba8b2d4$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isResponse(data) || (0, $6e454158db471ce9$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $6e454158db471ce9$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, this.parseReviver);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039).from(e, (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $85b94d3eeda6d2ef$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $85b94d3eeda6d2ef$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $6e454158db471ce9$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $25556dd75ba8b2d4$var$defaults.headers[method] = {};
});
var $25556dd75ba8b2d4$export$2e2bcd8739ae039 = $25556dd75ba8b2d4$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $b1505b45ad4ba0ec$var$ignoreDuplicateOf = (0, $6e454158db471ce9$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $b1505b45ad4ba0ec$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $b1505b45ad4ba0ec$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $b445c26a535e8877$var$$internals = Symbol('internals');
function $b445c26a535e8877$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $b445c26a535e8877$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $6e454158db471ce9$export$2e2bcd8739ae039).isArray(value) ? value.map($b445c26a535e8877$var$normalizeValue) : String(value);
}
function $b445c26a535e8877$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $b445c26a535e8877$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $b445c26a535e8877$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $6e454158db471ce9$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $b445c26a535e8877$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $b445c26a535e8877$var$buildAccessors(obj, header) {
    const accessorName = (0, $6e454158db471ce9$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $b445c26a535e8877$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $b445c26a535e8877$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $6e454158db471ce9$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $b445c26a535e8877$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $6e454158db471ce9$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$b445c26a535e8877$var$isValidHeaderName(header)) setHeaders((0, $b1505b45ad4ba0ec$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isObject(header) && (0, $6e454158db471ce9$export$2e2bcd8739ae039).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $6e454158db471ce9$export$2e2bcd8739ae039).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $6e454158db471ce9$export$2e2bcd8739ae039).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $b445c26a535e8877$var$normalizeHeader(header);
        if (header) {
            const key = (0, $6e454158db471ce9$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $b445c26a535e8877$var$parseTokens(value);
                if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $b445c26a535e8877$var$normalizeHeader(header);
        if (header) {
            const key = (0, $6e454158db471ce9$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $b445c26a535e8877$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $b445c26a535e8877$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $6e454158db471ce9$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $b445c26a535e8877$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $b445c26a535e8877$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $6e454158db471ce9$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $6e454158db471ce9$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $b445c26a535e8877$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $b445c26a535e8877$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $b445c26a535e8877$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $6e454158db471ce9$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $6e454158db471ce9$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get('set-cookie') || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$b445c26a535e8877$var$$internals] = this[$b445c26a535e8877$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $b445c26a535e8877$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $b445c26a535e8877$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $6e454158db471ce9$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$b445c26a535e8877$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $6e454158db471ce9$export$2e2bcd8739ae039).reduceDescriptors($b445c26a535e8877$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $6e454158db471ce9$export$2e2bcd8739ae039).freezeMethods($b445c26a535e8877$var$AxiosHeaders);
var $b445c26a535e8877$export$2e2bcd8739ae039 = $b445c26a535e8877$var$AxiosHeaders;


'use strict';
function $bb597ba9c19e457a$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $25556dd75ba8b2d4$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $b445c26a535e8877$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $6e454158db471ce9$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $37e28ceb02584abc$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $e7ac5dd876786d33$var$CanceledError extends (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $e7ac5dd876786d33$export$2e2bcd8739ae039 = $e7ac5dd876786d33$var$CanceledError;







'use strict';
function $cae0ad9f4b14f523$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $06662f3185e8ed62$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4b27da4899a838b4$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4b27da4899a838b4$export$2e2bcd8739ae039 = $4b27da4899a838b4$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $2183b775d1ca1112$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $2183b775d1ca1112$export$2e2bcd8739ae039 = $2183b775d1ca1112$var$throttle;



const $bb2f7919b7832d38$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $4b27da4899a838b4$export$2e2bcd8739ae039)(50, 250);
    return (0, $2183b775d1ca1112$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $bb2f7919b7832d38$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $bb2f7919b7832d38$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $6e454158db471ce9$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $5f13cbfe29caebb7$export$2e2bcd8739ae039 = (0, $85b94d3eeda6d2ef$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $85b94d3eeda6d2ef$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $85b94d3eeda6d2ef$export$2e2bcd8739ae039).origin), (0, $85b94d3eeda6d2ef$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $85b94d3eeda6d2ef$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $b911d388c4316ed5$export$2e2bcd8739ae039 = (0, $85b94d3eeda6d2ef$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $ca64df1cc24a0991$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $eb6206838128b5bd$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $fb21bc98e4f4cd9a$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $ca64df1cc24a0991$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $eb6206838128b5bd$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $f454cd19e378751a$var$headersToObject = (thing)=>thing instanceof (0, $b445c26a535e8877$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $f454cd19e378751a$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isPlainObject(target) && (0, $6e454158db471ce9$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $6e454158db471ce9$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $6e454158db471ce9$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $6e454158db471ce9$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $6e454158db471ce9$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $6e454158db471ce9$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $6e454158db471ce9$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $6e454158db471ce9$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($f454cd19e378751a$var$headersToObject(a), $f454cd19e378751a$var$headersToObject(b), prop, true)
    };
    (0, $6e454158db471ce9$export$2e2bcd8739ae039).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $6e454158db471ce9$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $6e454158db471ce9$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $509a9dede668c67f$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $f454cd19e378751a$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $b445c26a535e8877$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $3647fc9ca1c77752$export$2e2bcd8739ae039)((0, $fb21bc98e4f4cd9a$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $85b94d3eeda6d2ef$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $85b94d3eeda6d2ef$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isFunction(data.getHeaders)) {
            // Node.js FormData (like form-data package)
            const formHeaders = data.getHeaders();
            // Only set safe headers to avoid overwriting security headers
            const allowedHeaders = [
                'content-type',
                'content-length'
            ];
            Object.entries(formHeaders).forEach(([key, val])=>{
                if (allowedHeaders.includes(key.toLowerCase())) headers.set(key, val);
            });
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $85b94d3eeda6d2ef$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $6e454158db471ce9$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $5f13cbfe29caebb7$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $b911d388c4316ed5$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $d46ba95e2bb1593b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $d46ba95e2bb1593b$export$2e2bcd8739ae039 = $d46ba95e2bb1593b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $509a9dede668c67f$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $b445c26a535e8877$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $b445c26a535e8877$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $cae0ad9f4b14f523$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039)('Request aborted', (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039)(msg, (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $14704af7d8a8eb83$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039).ETIMEDOUT : (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $6e454158db471ce9$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $6e454158db471ce9$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $bb2f7919b7832d38$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $bb2f7919b7832d38$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $e7ac5dd876786d33$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $06662f3185e8ed62$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $85b94d3eeda6d2ef$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $78a87257978dcd08$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039) ? err : new (0, $e7ac5dd876786d33$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $6e454158db471ce9$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $78a87257978dcd08$export$2e2bcd8739ae039 = $78a87257978dcd08$var$composeSignals;


const $f17ecc4ee4c21557$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $f17ecc4ee4c21557$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $f17ecc4ee4c21557$var$readStream(iterable))yield* $f17ecc4ee4c21557$export$71b051935044bd5d(chunk, chunkSize);
};
const $f17ecc4ee4c21557$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $f17ecc4ee4c21557$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $f17ecc4ee4c21557$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $78fe913d3d06ad40$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $78fe913d3d06ad40$var$isFunction } = (0, $6e454158db471ce9$export$2e2bcd8739ae039);
const $78fe913d3d06ad40$var$globalFetchAPI = (({ Request: Request, Response: Response })=>({
        Request: Request,
        Response: Response
    }))((0, $6e454158db471ce9$export$2e2bcd8739ae039).global);
const { ReadableStream: $78fe913d3d06ad40$var$ReadableStream, TextEncoder: $78fe913d3d06ad40$var$TextEncoder } = (0, $6e454158db471ce9$export$2e2bcd8739ae039).global;
const $78fe913d3d06ad40$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $78fe913d3d06ad40$var$factory = (env)=>{
    env = (0, $6e454158db471ce9$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, $78fe913d3d06ad40$var$globalFetchAPI, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $78fe913d3d06ad40$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $78fe913d3d06ad40$var$isFunction(Request);
    const isResponseSupported = $78fe913d3d06ad40$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $78fe913d3d06ad40$var$isFunction($78fe913d3d06ad40$var$ReadableStream);
    const encodeText = isFetchSupported && (typeof $78fe913d3d06ad40$var$TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new $78fe913d3d06ad40$var$TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $78fe913d3d06ad40$var$test(()=>{
        let duplexAccessed = false;
        const hasContentType = new Request((0, $85b94d3eeda6d2ef$export$2e2bcd8739ae039).origin, {
            body: new $78fe913d3d06ad40$var$ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        }).headers.has('Content-Type');
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $78fe913d3d06ad40$var$test(()=>(0, $6e454158db471ce9$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $85b94d3eeda6d2ef$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $6e454158db471ce9$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $6e454158db471ce9$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $509a9dede668c67f$export$2e2bcd8739ae039)(config);
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $78a87257978dcd08$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: 'half'
                });
                let contentTypeHeader;
                if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $bb2f7919b7832d38$export$d9fadd12586c18d6)(requestContentLength, (0, $bb2f7919b7832d38$export$c1b28109d46c3592)((0, $bb2f7919b7832d38$export$5d35863c355a22a9)(onUploadProgress)));
                    data = (0, $f17ecc4ee4c21557$export$b0119225647bd83)(_request.body, $78fe913d3d06ad40$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $6e454158db471ce9$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: headers.normalize().toJSON(),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $6e454158db471ce9$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, $bb2f7919b7832d38$export$d9fadd12586c18d6)(responseContentLength, (0, $bb2f7919b7832d38$export$c1b28109d46c3592)((0, $bb2f7919b7832d38$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                response = new Response((0, $f17ecc4ee4c21557$export$b0119225647bd83)(response.body, $78fe913d3d06ad40$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $6e454158db471ce9$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $cae0ad9f4b14f523$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $b445c26a535e8877$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039)('Network Error', (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response), {
                cause: err.cause || err
            });
            throw (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $78fe913d3d06ad40$var$seedCache = new Map();
const $78fe913d3d06ad40$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $78fe913d3d06ad40$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $78fe913d3d06ad40$var$factory(env));
        map = target;
    }
    return target;
};
const $78fe913d3d06ad40$var$adapter = $78fe913d3d06ad40$export$3105c6651375d4fa();
var $78fe913d3d06ad40$export$2e2bcd8739ae039 = $78fe913d3d06ad40$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $8672a5f34d527753$var$knownAdapters = {
    http: (0, $cf0749c38147a168$export$2e2bcd8739ae039),
    xhr: (0, $d46ba95e2bb1593b$export$2e2bcd8739ae039),
    fetch: {
        get: $78fe913d3d06ad40$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $6e454158db471ce9$export$2e2bcd8739ae039).forEach($8672a5f34d527753$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $8672a5f34d527753$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $8672a5f34d527753$var$isResolvedHandle = (adapter)=>(0, $6e454158db471ce9$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $8672a5f34d527753$var$getAdapter(adapters, config) {
    adapters = (0, $6e454158db471ce9$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$8672a5f34d527753$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $8672a5f34d527753$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($8672a5f34d527753$var$renderReason).join('\n') : ' ' + $8672a5f34d527753$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $8672a5f34d527753$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $8672a5f34d527753$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $8672a5f34d527753$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $28737f8a760fbe55$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $e7ac5dd876786d33$export$2e2bcd8739ae039)(null, config);
}
function $28737f8a760fbe55$export$2e2bcd8739ae039(config) {
    $28737f8a760fbe55$var$throwIfCancellationRequested(config);
    config.headers = (0, $b445c26a535e8877$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $bb597ba9c19e457a$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $8672a5f34d527753$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $25556dd75ba8b2d4$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $28737f8a760fbe55$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $bb597ba9c19e457a$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $b445c26a535e8877$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $37e28ceb02584abc$export$2e2bcd8739ae039)(reason)) {
            $28737f8a760fbe55$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $bb597ba9c19e457a$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $b445c26a535e8877$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $987ab8839cd227d6$export$a4ad2735b021c132 = "1.13.6";



'use strict';
const $2c3df7f59d81a456$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $2c3df7f59d81a456$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $2c3df7f59d81a456$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $2c3df7f59d81a456$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $987ab8839cd227d6$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$2c3df7f59d81a456$var$deprecatedWarnings[opt]) {
            $2c3df7f59d81a456$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$2c3df7f59d81a456$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $2c3df7f59d81a456$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039)('options must be an object', (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $2c3df7f59d81a456$export$2e2bcd8739ae039 = {
    assertOptions: $2c3df7f59d81a456$var$assertOptions,
    validators: $2c3df7f59d81a456$var$validators
};




'use strict';
const $5809f0c6f08a0a8e$var$validators = (0, $2c3df7f59d81a456$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $5809f0c6f08a0a8e$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $66dd02769d59d78e$export$2e2bcd8739ae039)(),
            response: new (0, $66dd02769d59d78e$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $f454cd19e378751a$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $2c3df7f59d81a456$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $5809f0c6f08a0a8e$var$validators.transitional($5809f0c6f08a0a8e$var$validators.boolean),
            forcedJSONParsing: $5809f0c6f08a0a8e$var$validators.transitional($5809f0c6f08a0a8e$var$validators.boolean),
            clarifyTimeoutError: $5809f0c6f08a0a8e$var$validators.transitional($5809f0c6f08a0a8e$var$validators.boolean),
            legacyInterceptorReqResOrdering: $5809f0c6f08a0a8e$var$validators.transitional($5809f0c6f08a0a8e$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $6e454158db471ce9$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $2c3df7f59d81a456$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $5809f0c6f08a0a8e$var$validators.function,
                serialize: $5809f0c6f08a0a8e$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $2c3df7f59d81a456$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $5809f0c6f08a0a8e$var$validators.spelling('baseURL'),
            withXsrfToken: $5809f0c6f08a0a8e$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $6e454158db471ce9$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $6e454158db471ce9$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $b445c26a535e8877$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $14704af7d8a8eb83$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $28737f8a760fbe55$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $28737f8a760fbe55$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $f454cd19e378751a$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $fb21bc98e4f4cd9a$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $3647fc9ca1c77752$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $6e454158db471ce9$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $5809f0c6f08a0a8e$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $f454cd19e378751a$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $6e454158db471ce9$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $f454cd19e378751a$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $5809f0c6f08a0a8e$var$Axios.prototype[method] = generateHTTPMethod();
    $5809f0c6f08a0a8e$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $5809f0c6f08a0a8e$export$2e2bcd8739ae039 = $5809f0c6f08a0a8e$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $4c55165022e579fa$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $e7ac5dd876786d33$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $4c55165022e579fa$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $4c55165022e579fa$export$2e2bcd8739ae039 = $4c55165022e579fa$var$CancelToken;






'use strict';
function $c048caf796d65d06$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $19d2bdba5ca17407$export$2e2bcd8739ae039(payload) {
    return (0, $6e454158db471ce9$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $15c6332904457810$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($15c6332904457810$var$HttpStatusCode).forEach(([key, value])=>{
    $15c6332904457810$var$HttpStatusCode[value] = key;
});
var $15c6332904457810$export$2e2bcd8739ae039 = $15c6332904457810$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $c45ae7d48e64ecd8$var$createInstance(defaultConfig) {
    const context = new (0, $5809f0c6f08a0a8e$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $163d80cd77f686d0$export$2e2bcd8739ae039)((0, $5809f0c6f08a0a8e$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $6e454158db471ce9$export$2e2bcd8739ae039).extend(instance, (0, $5809f0c6f08a0a8e$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $6e454158db471ce9$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $c45ae7d48e64ecd8$var$createInstance((0, $f454cd19e378751a$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $c45ae7d48e64ecd8$var$axios = $c45ae7d48e64ecd8$var$createInstance((0, $25556dd75ba8b2d4$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$c45ae7d48e64ecd8$var$axios.Axios = (0, $5809f0c6f08a0a8e$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$c45ae7d48e64ecd8$var$axios.CanceledError = (0, $e7ac5dd876786d33$export$2e2bcd8739ae039);
$c45ae7d48e64ecd8$var$axios.CancelToken = (0, $4c55165022e579fa$export$2e2bcd8739ae039);
$c45ae7d48e64ecd8$var$axios.isCancel = (0, $37e28ceb02584abc$export$2e2bcd8739ae039);
$c45ae7d48e64ecd8$var$axios.VERSION = (0, $987ab8839cd227d6$export$a4ad2735b021c132);
$c45ae7d48e64ecd8$var$axios.toFormData = (0, $5fbcb9a9d643ea96$export$2e2bcd8739ae039);
// Expose AxiosError class
$c45ae7d48e64ecd8$var$axios.AxiosError = (0, $528f4e1b21ef21f8$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$c45ae7d48e64ecd8$var$axios.Cancel = $c45ae7d48e64ecd8$var$axios.CanceledError;
// Expose all/spread
$c45ae7d48e64ecd8$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$c45ae7d48e64ecd8$var$axios.spread = (0, $c048caf796d65d06$export$2e2bcd8739ae039);
// Expose isAxiosError
$c45ae7d48e64ecd8$var$axios.isAxiosError = (0, $19d2bdba5ca17407$export$2e2bcd8739ae039);
// Expose mergeConfig
$c45ae7d48e64ecd8$var$axios.mergeConfig = (0, $f454cd19e378751a$export$2e2bcd8739ae039);
$c45ae7d48e64ecd8$var$axios.AxiosHeaders = (0, $b445c26a535e8877$export$2e2bcd8739ae039);
$c45ae7d48e64ecd8$var$axios.formToJSON = (thing)=>(0, $aa9d2acf40fd8d1e$export$2e2bcd8739ae039)((0, $6e454158db471ce9$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$c45ae7d48e64ecd8$var$axios.getAdapter = (0, $8672a5f34d527753$export$2e2bcd8739ae039).getAdapter;
$c45ae7d48e64ecd8$var$axios.HttpStatusCode = (0, $15c6332904457810$export$2e2bcd8739ae039);
$c45ae7d48e64ecd8$var$axios.default = $c45ae7d48e64ecd8$var$axios;
var // this module should only have a default export
$c45ae7d48e64ecd8$export$2e2bcd8739ae039 = $c45ae7d48e64ecd8$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $7f884d13070a8f14$export$1c00760e9e5a4e95, AxiosError: $7f884d13070a8f14$export$c1fbed17c2f6a328, CanceledError: $7f884d13070a8f14$export$1ab0c6b20d94fa14, isCancel: $7f884d13070a8f14$export$3b22524397b493c6, CancelToken: $7f884d13070a8f14$export$fd08e3cb425f0d61, VERSION: $7f884d13070a8f14$export$a4ad2735b021c132, all: $7f884d13070a8f14$export$84bf76cd7afc7469, Cancel: $7f884d13070a8f14$export$848c9b7ead0df967, isAxiosError: $7f884d13070a8f14$export$fbafdbe06a5b5a9a, spread: $7f884d13070a8f14$export$3ae0fd4797ed47c8, toFormData: $7f884d13070a8f14$export$10ae0d317ea97f8b, AxiosHeaders: $7f884d13070a8f14$export$4e7d6ff0f3e6520, HttpStatusCode: $7f884d13070a8f14$export$a972f69c851492b3, formToJSON: $7f884d13070a8f14$export$86d7c59254d6a2c9, getAdapter: $7f884d13070a8f14$export$17ddc20a97d669e2, mergeConfig: $7f884d13070a8f14$export$7ec1ebcfa9d8bd6a } = (0, $c45ae7d48e64ecd8$export$2e2bcd8739ae039);


/* Concept borrowed from:
 * https://dev.to/rajeshroyal/reactjs-disable-consolelog-in-production-and-staging-3l38
*/ const $0951650939e65d98$export$e7d6ca579af3977d = function() {
    var savedConsole = console;
    /**
  * @param {boolean} isDisabled
  * @param {boolean} suppressAll
  */ return function(isDisabled, suppressAll) {
        var suppress = suppressAll || true;
        if (isDisabled === true) {
            // supress the default console functionality
            console = {};
            console.log = function() {};
            // supress all type of consoles
            if (suppress) {
                console.info = function() {};
                console.warn = function() {};
                console.error = function() {};
                console.debug = function() {};
            } else {
                console.info = savedConsole.info;
                console.warn = savedConsole.warn;
                console.error = savedConsole.error;
                console.debug = savedConsole.debug;
            }
        } else console = savedConsole;
    };
}();


/*!
 * Firepad is an open-source, collaborative code and text editor. It was designed
 * to be embedded inside larger applications. Since it uses Firebase as a backend,
 * it requires no server-side code and can be added to any web app simply by
 * including a couple JavaScript files.
 *
 * http://www.firepad.io/
 * License: MIT
 * Copyright: 2014 Firebase
 * With code from ot.js (Copyright 2012-2013 Tim Baumann)
 */ const $5df98098fdb33638$export$eab97d15b1788b8d = {};
$5df98098fdb33638$export$eab97d15b1788b8d.makeEventEmitter = function(clazz, opt_allowedEVents) {
    clazz.prototype.allowedEvents_ = opt_allowedEVents;
    clazz.prototype.on = function(eventType, callback, context) {
        this.validateEventType_(eventType);
        this.eventListeners_ = this.eventListeners_ || {};
        this.eventListeners_[eventType] = this.eventListeners_[eventType] || [];
        this.eventListeners_[eventType].push({
            callback: callback,
            context: context
        });
    };
    clazz.prototype.off = function(eventType, callback) {
        this.validateEventType_(eventType);
        this.eventListeners_ = this.eventListeners_ || {};
        var listeners = this.eventListeners_[eventType] || [];
        for(var i = 0; i < listeners.length; i++)if (listeners[i].callback === callback) {
            listeners.splice(i, 1);
            return;
        }
    };
    clazz.prototype.trigger = function(eventType /*, args ... */ ) {
        this.eventListeners_ = this.eventListeners_ || {};
        var listeners = this.eventListeners_[eventType] || [];
        for(var i = 0; i < listeners.length; i++)listeners[i].callback.apply(listeners[i].context, Array.prototype.slice.call(arguments, 1));
    };
    clazz.prototype.validateEventType_ = function(eventType) {
        if (this.allowedEvents_) {
            var allowed = false;
            for(var i = 0; i < this.allowedEvents_.length; i++)if (this.allowedEvents_[i] === eventType) {
                allowed = true;
                break;
            }
            if (!allowed) throw new Error('Unknown event "' + eventType + '"');
        }
    };
};
$5df98098fdb33638$export$eab97d15b1788b8d.elt = function(tag, content, attrs) {
    var e = document.createElement(tag);
    if (typeof content === "string") $5df98098fdb33638$export$eab97d15b1788b8d.setTextContent(e, content);
    else if (content) for(var i = 0; i < content.length; ++i)e.appendChild(content[i]);
    for(var attr in attrs || {})e.setAttribute(attr, attrs[attr]);
    return e;
};
$5df98098fdb33638$export$eab97d15b1788b8d.setTextContent = function(e, str) {
    e.innerHTML = "";
    e.appendChild(document.createTextNode(str));
};
$5df98098fdb33638$export$eab97d15b1788b8d.on = function(emitter, type, f, capture) {
    if (emitter.addEventListener) emitter.addEventListener(type, f, capture || false);
    else if (emitter.attachEvent) emitter.attachEvent("on" + type, f);
};
$5df98098fdb33638$export$eab97d15b1788b8d.off = function(emitter, type, f, capture) {
    if (emitter.removeEventListener) emitter.removeEventListener(type, f, capture || false);
    else if (emitter.detachEvent) emitter.detachEvent("on" + type, f);
};
$5df98098fdb33638$export$eab97d15b1788b8d.preventDefault = function(e) {
    if (e.preventDefault) e.preventDefault();
    else e.returnValue = false;
};
$5df98098fdb33638$export$eab97d15b1788b8d.stopPropagation = function(e) {
    if (e.stopPropagation) e.stopPropagation();
    else e.cancelBubble = true;
};
$5df98098fdb33638$export$eab97d15b1788b8d.stopEvent = function(e) {
    $5df98098fdb33638$export$eab97d15b1788b8d.preventDefault(e);
    $5df98098fdb33638$export$eab97d15b1788b8d.stopPropagation(e);
};
$5df98098fdb33638$export$eab97d15b1788b8d.stopEventAnd = function(fn) {
    return function(e) {
        fn(e);
        $5df98098fdb33638$export$eab97d15b1788b8d.stopEvent(e);
        return false;
    };
};
$5df98098fdb33638$export$eab97d15b1788b8d.trim = function(str) {
    return str.replace(/^\s+/g, "").replace(/\s+$/g, "");
};
$5df98098fdb33638$export$eab97d15b1788b8d.stringEndsWith = function(str, suffix) {
    var list = typeof suffix == "string" ? [
        suffix
    ] : suffix;
    for(var i = 0; i < list.length; i++){
        var suffix = list[i];
        if (str.indexOf(suffix, str.length - suffix.length) !== -1) return true;
    }
    return false;
};
$5df98098fdb33638$export$eab97d15b1788b8d.assert = function assert(b, msg) {
    if (!b) throw new Error(msg || "assertion error");
};
$5df98098fdb33638$export$eab97d15b1788b8d.log = function() {
    if (typeof console !== "undefined" && typeof console.log !== "undefined") {
        var args = [
            "Firepad:"
        ];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        console.log.apply(console, args);
    }
};



const $ab98ee380c7ac8a1$export$ca875bc28cbbddb1 = function() {
    // Operation are essentially lists of ops. There are three types of ops:
    //
    // * Retain ops: Advance the cursor position by a given number of characters.
    //   Represented by positive ints.
    // * Insert ops: Insert a given string at the current cursor position.
    //   Represented by strings.
    // * Delete ops: Delete the next n characters. Represented by negative ints.
    function TextOp(type) {
        this.type = type;
        this.chars = null;
        this.text = null;
        this.attributes = null;
        if (type === "insert") {
            this.text = arguments[1];
            (0, $5df98098fdb33638$export$eab97d15b1788b8d).assert(typeof this.text === "string");
            this.attributes = arguments[2] || {};
            (0, $5df98098fdb33638$export$eab97d15b1788b8d).assert(typeof this.attributes === "object");
        } else if (type === "delete") {
            this.chars = arguments[1];
            (0, $5df98098fdb33638$export$eab97d15b1788b8d).assert(typeof this.chars === "number");
        } else if (type === "retain") {
            this.chars = arguments[1];
            (0, $5df98098fdb33638$export$eab97d15b1788b8d).assert(typeof this.chars === "number");
            this.attributes = arguments[2] || {};
            (0, $5df98098fdb33638$export$eab97d15b1788b8d).assert(typeof this.attributes === "object");
        }
    }
    TextOp.prototype.isInsert = function() {
        return this.type === "insert";
    };
    TextOp.prototype.isDelete = function() {
        return this.type === "delete";
    };
    TextOp.prototype.isRetain = function() {
        return this.type === "retain";
    };
    TextOp.prototype.equals = function(other) {
        return this.type === other.type && this.text === other.text && this.chars === other.chars && this.attributesEqual(other.attributes);
    };
    TextOp.prototype.attributesEqual = function(otherAttributes) {
        for(var attr in this.attributes){
            if (this.attributes[attr] !== otherAttributes[attr]) return false;
        }
        for(attr in otherAttributes){
            if (this.attributes[attr] !== otherAttributes[attr]) return false;
        }
        return true;
    };
    TextOp.prototype.hasEmptyAttributes = function() {
        var empty = true;
        for(var attr in this.attributes){
            empty = false;
            break;
        }
        return empty;
    };
    return TextOp;
}();


const $8c3149d24978582c$export$b3669f5ec3045f43 = function() {
    "use strict";
    // Constructor for new operations.
    function TextOperation() {
        if (!this || this.constructor !== TextOperation) // => function was called without 'new'
        return new TextOperation();
        // When an operation is applied to an input string, you can think of this as
        // if an imaginary cursor runs over the entire string and skips over some
        // parts, deletes some parts and inserts characters at some positions. These
        // actions (skip/delete/insert) are stored as an array in the "ops" property.
        this.ops = [];
        // An operation's baseLength is the length of every string the operation
        // can be applied to.
        this.baseLength = 0;
        // The targetLength is the length of every string that results from applying
        // the operation on a valid input string.
        this.targetLength = 0;
    }
    TextOperation.prototype.equals = function(other) {
        if (this.baseLength !== other.baseLength) return false;
        if (this.targetLength !== other.targetLength) return false;
        if (this.ops.length !== other.ops.length) return false;
        for(var i = 0; i < this.ops.length; i++){
            if (!this.ops[i].equals(other.ops[i])) return false;
        }
        return true;
    };
    // After an operation is constructed, the user of the library can specify the
    // actions of an operation (skip/insert/delete) with these three builder
    // methods. They all return the operation for convenient chaining.
    // Skip over a given number of characters.
    TextOperation.prototype.retain = function(n, attributes) {
        if (typeof n !== "number" || n < 0) throw new Error("retain expects a positive integer.");
        if (n === 0) return this;
        this.baseLength += n;
        this.targetLength += n;
        attributes = attributes || {};
        var prevOp = this.ops.length > 0 ? this.ops[this.ops.length - 1] : null;
        if (prevOp && prevOp.isRetain() && prevOp.attributesEqual(attributes)) // The last op is a retain op with the same attributes => we can merge them into one op.
        prevOp.chars += n;
        else // Create a new op.
        this.ops.push(new (0, $ab98ee380c7ac8a1$export$ca875bc28cbbddb1)("retain", n, attributes));
        return this;
    };
    // Insert a string at the current position.
    TextOperation.prototype.insert = function(str, attributes) {
        if (typeof str !== "string") throw new Error("insert expects a string");
        if (str === "") return this;
        attributes = attributes || {};
        this.targetLength += str.length;
        var prevOp = this.ops.length > 0 ? this.ops[this.ops.length - 1] : null;
        var prevPrevOp = this.ops.length > 1 ? this.ops[this.ops.length - 2] : null;
        if (prevOp && prevOp.isInsert() && prevOp.attributesEqual(attributes)) // Merge insert op.
        prevOp.text += str;
        else if (prevOp && prevOp.isDelete()) {
            // It doesn't matter when an operation is applied whether the operation
            // is delete(3), insert("something") or insert("something"), delete(3).
            // Here we enforce that in this case, the insert op always comes first.
            // This makes all operations that have the same effect when applied to
            // a document of the right length equal in respect to the `equals` method.
            if (prevPrevOp && prevPrevOp.isInsert() && prevPrevOp.attributesEqual(attributes)) prevPrevOp.text += str;
            else {
                this.ops[this.ops.length - 1] = new (0, $ab98ee380c7ac8a1$export$ca875bc28cbbddb1)("insert", str, attributes);
                this.ops.push(prevOp);
            }
        } else this.ops.push(new (0, $ab98ee380c7ac8a1$export$ca875bc28cbbddb1)("insert", str, attributes));
        return this;
    };
    // Delete a string at the current position.
    TextOperation.prototype["delete"] = function(n) {
        if (typeof n === "string") n = n.length;
        if (typeof n !== "number" || n < 0) throw new Error("delete expects a positive integer or a string");
        if (n === 0) return this;
        this.baseLength += n;
        var prevOp = this.ops.length > 0 ? this.ops[this.ops.length - 1] : null;
        if (prevOp && prevOp.isDelete()) prevOp.chars += n;
        else this.ops.push(new (0, $ab98ee380c7ac8a1$export$ca875bc28cbbddb1)("delete", n));
        return this;
    };
    // Tests whether this operation has no effect.
    TextOperation.prototype.isNoop = function() {
        return this.ops.length === 0 || this.ops.length === 1 && this.ops[0].isRetain() && this.ops[0].hasEmptyAttributes();
    };
    TextOperation.prototype.clone = function() {
        var clone = new TextOperation();
        for(var i = 0; i < this.ops.length; i++){
            if (this.ops[i].isRetain()) clone.retain(this.ops[i].chars, this.ops[i].attributes);
            else if (this.ops[i].isInsert()) clone.insert(this.ops[i].text, this.ops[i].attributes);
            else clone["delete"](this.ops[i].chars);
        }
        return clone;
    };
    // Pretty printing.
    TextOperation.prototype.toString = function() {
        // map: build a new array by applying a function to every element in an old
        // array.
        var map = Array.prototype.map || function(fn) {
            var arr = this;
            var newArr = [];
            for(var i = 0, l = arr.length; i < l; i++)newArr[i] = fn(arr[i]);
            return newArr;
        };
        return map.call(this.ops, function(op) {
            if (op.isRetain()) return "retain " + op.chars;
            else if (op.isInsert()) return "insert '" + op.text + "'";
            else return "delete " + op.chars;
        }).join(", ");
    };
    // Converts operation into a JSON value.
    TextOperation.prototype.toJSON = function() {
        var ops = [];
        for(var i = 0; i < this.ops.length; i++){
            // We prefix ops with their attributes if non-empty.
            if (!this.ops[i].hasEmptyAttributes()) ops.push(this.ops[i].attributes);
            if (this.ops[i].type === "retain") ops.push(this.ops[i].chars);
            else if (this.ops[i].type === "insert") ops.push(this.ops[i].text);
            else if (this.ops[i].type === "delete") ops.push(-this.ops[i].chars);
        }
        // Return an array with /something/ in it, since an empty array will be treated as null by Firebase.
        if (ops.length === 0) ops.push(0);
        return ops;
    };
    // Converts a plain JS object into an operation and validates it.
    TextOperation.fromJSON = function(ops) {
        var o = new TextOperation();
        for(var i = 0, l = ops.length; i < l; i++){
            var op = ops[i];
            var attributes = {};
            if (typeof op === "object") {
                attributes = op;
                i++;
                op = ops[i];
            }
            if (typeof op === "number") {
                if (op > 0) o.retain(op, attributes);
                else o["delete"](-op);
            } else {
                (0, $5df98098fdb33638$export$eab97d15b1788b8d).assert(typeof op === "string");
                o.insert(op, attributes);
            }
        }
        return o;
    };
    // Apply an operation to a string, returning a new string. Throws an error if
    // there's a mismatch between the input string and the operation.
    TextOperation.prototype.apply = function(str, oldAttributes, newAttributes) {
        var operation = this;
        oldAttributes = oldAttributes || [];
        newAttributes = newAttributes || [];
        if (str.length !== operation.baseLength) throw new Error("The operation's base length must be equal to the string's length.");
        var newStringParts = [], j = 0, k, attr;
        var oldIndex = 0;
        var ops = this.ops;
        for(var i = 0, l = ops.length; i < l; i++){
            var op = ops[i];
            if (op.isRetain()) {
                if (oldIndex + op.chars > str.length) throw new Error("Operation can't retain more characters than are left in the string.");
                // Copy skipped part of the retained string.
                newStringParts[j++] = str.slice(oldIndex, oldIndex + op.chars);
                // Copy (and potentially update) attributes for each char in retained string.
                for(k = 0; k < op.chars; k++){
                    var currAttributes = oldAttributes[oldIndex + k] || {}, updatedAttributes = {};
                    for(attr in currAttributes){
                        updatedAttributes[attr] = currAttributes[attr];
                        (0, $5df98098fdb33638$export$eab97d15b1788b8d).assert(updatedAttributes[attr] !== false);
                    }
                    for(attr in op.attributes){
                        if (op.attributes[attr] === false) delete updatedAttributes[attr];
                        else updatedAttributes[attr] = op.attributes[attr];
                        (0, $5df98098fdb33638$export$eab97d15b1788b8d).assert(updatedAttributes[attr] !== false);
                    }
                    newAttributes.push(updatedAttributes);
                }
                oldIndex += op.chars;
            } else if (op.isInsert()) {
                // Insert string.
                newStringParts[j++] = op.text;
                // Insert attributes for each char.
                for(k = 0; k < op.text.length; k++){
                    var insertedAttributes = {};
                    for(attr in op.attributes){
                        insertedAttributes[attr] = op.attributes[attr];
                        (0, $5df98098fdb33638$export$eab97d15b1788b8d).assert(insertedAttributes[attr] !== false);
                    }
                    newAttributes.push(insertedAttributes);
                }
            } else // delete op
            oldIndex += op.chars;
        }
        if (oldIndex !== str.length) throw new Error("The operation didn't operate on the whole string.");
        var newString = newStringParts.join("");
        (0, $5df98098fdb33638$export$eab97d15b1788b8d).assert(newString.length === newAttributes.length);
        return newString;
    };
    // Computes the inverse of an operation. The inverse of an operation is the
    // operation that reverts the effects of the operation, e.g. when you have an
    // operation 'insert("hello "); skip(6);' then the inverse is 'delete("hello ");
    // skip(6);'. The inverse should be used for implementing undo.
    TextOperation.prototype.invert = function(str) {
        var strIndex = 0;
        var inverse = new TextOperation();
        var ops = this.ops;
        for(var i = 0, l = ops.length; i < l; i++){
            var op = ops[i];
            if (op.isRetain()) {
                inverse.retain(op.chars);
                strIndex += op.chars;
            } else if (op.isInsert()) inverse["delete"](op.text.length);
            else {
                // delete op
                inverse.insert(str.slice(strIndex, strIndex + op.chars));
                strIndex += op.chars;
            }
        }
        return inverse;
    };
    // Compose merges two consecutive operations into one operation, that
    // preserves the changes of both. Or, in other words, for each input string S
    // and a pair of consecutive operations A and B,
    // apply(apply(S, A), B) = apply(S, compose(A, B)) must hold.
    TextOperation.prototype.compose = function(operation2) {
        var operation1 = this;
        if (operation1.targetLength !== operation2.baseLength) throw new Error("The base length of the second operation has to be the target length of the first operation");
        function composeAttributes(first, second, firstOpIsInsert) {
            var merged = {}, attr;
            for(attr in first)merged[attr] = first[attr];
            for(attr in second)if (firstOpIsInsert && second[attr] === false) delete merged[attr];
            else merged[attr] = second[attr];
            return merged;
        }
        var operation = new TextOperation() // the combined operation
        ;
        var ops1 = operation1.clone().ops, ops2 = operation2.clone().ops;
        var i1 = 0, i2 = 0 // current index into ops1 respectively ops2
        ;
        var op1 = ops1[i1++], op2 = ops2[i2++] // current ops
        ;
        var attributes;
        while(true){
            // Dispatch on the type of op1 and op2
            if (typeof op1 === "undefined" && typeof op2 === "undefined") break;
            if (op1 && op1.isDelete()) {
                operation["delete"](op1.chars);
                op1 = ops1[i1++];
                continue;
            }
            if (op2 && op2.isInsert()) {
                operation.insert(op2.text, op2.attributes);
                op2 = ops2[i2++];
                continue;
            }
            if (typeof op1 === "undefined") throw new Error("Cannot compose operations: first operation is too short.");
            if (typeof op2 === "undefined") throw new Error("Cannot compose operations: first operation is too long.");
            if (op1.isRetain() && op2.isRetain()) {
                attributes = composeAttributes(op1.attributes, op2.attributes);
                if (op1.chars > op2.chars) {
                    operation.retain(op2.chars, attributes);
                    op1.chars -= op2.chars;
                    op2 = ops2[i2++];
                } else if (op1.chars === op2.chars) {
                    operation.retain(op1.chars, attributes);
                    op1 = ops1[i1++];
                    op2 = ops2[i2++];
                } else {
                    operation.retain(op1.chars, attributes);
                    op2.chars -= op1.chars;
                    op1 = ops1[i1++];
                }
            } else if (op1.isInsert() && op2.isDelete()) {
                if (op1.text.length > op2.chars) {
                    op1.text = op1.text.slice(op2.chars);
                    op2 = ops2[i2++];
                } else if (op1.text.length === op2.chars) {
                    op1 = ops1[i1++];
                    op2 = ops2[i2++];
                } else {
                    op2.chars -= op1.text.length;
                    op1 = ops1[i1++];
                }
            } else if (op1.isInsert() && op2.isRetain()) {
                attributes = composeAttributes(op1.attributes, op2.attributes, /*firstOpIsInsert=*/ true);
                if (op1.text.length > op2.chars) {
                    operation.insert(op1.text.slice(0, op2.chars), attributes);
                    op1.text = op1.text.slice(op2.chars);
                    op2 = ops2[i2++];
                } else if (op1.text.length === op2.chars) {
                    operation.insert(op1.text, attributes);
                    op1 = ops1[i1++];
                    op2 = ops2[i2++];
                } else {
                    operation.insert(op1.text, attributes);
                    op2.chars -= op1.text.length;
                    op1 = ops1[i1++];
                }
            } else if (op1.isRetain() && op2.isDelete()) {
                if (op1.chars > op2.chars) {
                    operation["delete"](op2.chars);
                    op1.chars -= op2.chars;
                    op2 = ops2[i2++];
                } else if (op1.chars === op2.chars) {
                    operation["delete"](op2.chars);
                    op1 = ops1[i1++];
                    op2 = ops2[i2++];
                } else {
                    operation["delete"](op1.chars);
                    op2.chars -= op1.chars;
                    op1 = ops1[i1++];
                }
            } else throw new Error("This shouldn't happen: op1: " + JSON.stringify(op1) + ", op2: " + JSON.stringify(op2));
        }
        return operation;
    };
    function getSimpleOp(operation) {
        var ops = operation.ops;
        switch(ops.length){
            case 1:
                return ops[0];
            case 2:
                return ops[0].isRetain() ? ops[1] : ops[1].isRetain() ? ops[0] : null;
            case 3:
                if (ops[0].isRetain() && ops[2].isRetain()) return ops[1];
        }
        return null;
    }
    function getStartIndex(operation) {
        if (operation.ops[0].isRetain()) return operation.ops[0].chars;
        return 0;
    }
    // When you use ctrl-z to undo your latest changes, you expect the program not
    // to undo every single keystroke but to undo your last sentence you wrote at
    // a stretch or the deletion you did by holding the backspace key down. This
    // This can be implemented by composing operations on the undo stack. This
    // method can help decide whether two operations should be composed. It
    // returns true if the operations are consecutive insert operations or both
    // operations delete text at the same position. You may want to include other
    // factors like the time since the last change in your decision.
    TextOperation.prototype.shouldBeComposedWith = function(other) {
        if (this.isNoop() || other.isNoop()) return true;
        var startA = getStartIndex(this), startB = getStartIndex(other);
        var simpleA = getSimpleOp(this), simpleB = getSimpleOp(other);
        if (!simpleA || !simpleB) return false;
        if (simpleA.isInsert() && simpleB.isInsert()) return startA + simpleA.text.length === startB;
        if (simpleA.isDelete() && simpleB.isDelete()) // there are two possibilities to delete: with backspace and with the
        // delete key.
        return startB + simpleB.chars === startA || startA === startB;
        return false;
    };
    // Decides whether two operations should be composed with each other
    // if they were inverted, that is
    // `shouldBeComposedWith(a, b) = shouldBeComposedWithInverted(b^{-1}, a^{-1})`.
    TextOperation.prototype.shouldBeComposedWithInverted = function(other) {
        if (this.isNoop() || other.isNoop()) return true;
        var startA = getStartIndex(this), startB = getStartIndex(other);
        var simpleA = getSimpleOp(this), simpleB = getSimpleOp(other);
        if (!simpleA || !simpleB) return false;
        if (simpleA.isInsert() && simpleB.isInsert()) return startA + simpleA.text.length === startB || startA === startB;
        if (simpleA.isDelete() && simpleB.isDelete()) return startB + simpleB.chars === startA;
        return false;
    };
    TextOperation.transformAttributes = function(attributes1, attributes2) {
        var attributes1prime = {}, attributes2prime = {};
        var attr, allAttrs = {};
        for(attr in attributes1)allAttrs[attr] = true;
        for(attr in attributes2)allAttrs[attr] = true;
        for(attr in allAttrs){
            var attr1 = attributes1[attr], attr2 = attributes2[attr];
            (0, $5df98098fdb33638$export$eab97d15b1788b8d).assert(attr1 != null || attr2 != null);
            if (attr1 == null) // Only modified by attributes2; keep it.
            attributes2prime[attr] = attr2;
            else if (attr2 == null) // only modified by attributes1; keep it
            attributes1prime[attr] = attr1;
            else if (attr1 === attr2) ;
            else // attr1 and attr2 are different. Prefer attr1.
            attributes1prime[attr] = attr1;
        }
        return [
            attributes1prime,
            attributes2prime
        ];
    };
    // Transform takes two operations A and B that happened concurrently and
    // produces two operations A' and B' (in an array) such that
    // `apply(apply(S, A), B') = apply(apply(S, B), A')`. This function is the
    // heart of OT.
    TextOperation.transform = function(operation1, operation2) {
        if (operation1.baseLength !== operation2.baseLength) throw new Error("Both operations have to have the same base length");
        var operation1prime = new TextOperation();
        var operation2prime = new TextOperation();
        var ops1 = operation1.clone().ops, ops2 = operation2.clone().ops;
        var i1 = 0, i2 = 0;
        var op1 = ops1[i1++], op2 = ops2[i2++];
        while(true){
            // At every iteration of the loop, the imaginary cursor that both
            // operation1 and operation2 have that operates on the input string must
            // have the same position in the input string.
            if (typeof op1 === "undefined" && typeof op2 === "undefined") break;
            // next two cases: one or both ops are insert ops
            // => insert the string in the corresponding prime operation, skip it in
            // the other one. If both op1 and op2 are insert ops, prefer op1.
            if (op1 && op1.isInsert()) {
                operation1prime.insert(op1.text, op1.attributes);
                operation2prime.retain(op1.text.length);
                op1 = ops1[i1++];
                continue;
            }
            if (op2 && op2.isInsert()) {
                operation1prime.retain(op2.text.length);
                operation2prime.insert(op2.text, op2.attributes);
                op2 = ops2[i2++];
                continue;
            }
            if (typeof op1 === "undefined") throw new Error("Cannot transform operations: first operation is too short.");
            if (typeof op2 === "undefined") throw new Error("Cannot transform operations: first operation is too long.");
            var minl;
            if (op1.isRetain() && op2.isRetain()) {
                // Simple case: retain/retain
                var attributesPrime = TextOperation.transformAttributes(op1.attributes, op2.attributes);
                if (op1.chars > op2.chars) {
                    minl = op2.chars;
                    op1.chars -= op2.chars;
                    op2 = ops2[i2++];
                } else if (op1.chars === op2.chars) {
                    minl = op2.chars;
                    op1 = ops1[i1++];
                    op2 = ops2[i2++];
                } else {
                    minl = op1.chars;
                    op2.chars -= op1.chars;
                    op1 = ops1[i1++];
                }
                operation1prime.retain(minl, attributesPrime[0]);
                operation2prime.retain(minl, attributesPrime[1]);
            } else if (op1.isDelete() && op2.isDelete()) {
                // Both operations delete the same string at the same position. We don't
                // need to produce any operations, we just skip over the delete ops and
                // handle the case that one operation deletes more than the other.
                if (op1.chars > op2.chars) {
                    op1.chars -= op2.chars;
                    op2 = ops2[i2++];
                } else if (op1.chars === op2.chars) {
                    op1 = ops1[i1++];
                    op2 = ops2[i2++];
                } else {
                    op2.chars -= op1.chars;
                    op1 = ops1[i1++];
                }
            // next two cases: delete/retain and retain/delete
            } else if (op1.isDelete() && op2.isRetain()) {
                if (op1.chars > op2.chars) {
                    minl = op2.chars;
                    op1.chars -= op2.chars;
                    op2 = ops2[i2++];
                } else if (op1.chars === op2.chars) {
                    minl = op2.chars;
                    op1 = ops1[i1++];
                    op2 = ops2[i2++];
                } else {
                    minl = op1.chars;
                    op2.chars -= op1.chars;
                    op1 = ops1[i1++];
                }
                operation1prime["delete"](minl);
            } else if (op1.isRetain() && op2.isDelete()) {
                if (op1.chars > op2.chars) {
                    minl = op2.chars;
                    op1.chars -= op2.chars;
                    op2 = ops2[i2++];
                } else if (op1.chars === op2.chars) {
                    minl = op1.chars;
                    op1 = ops1[i1++];
                    op2 = ops2[i2++];
                } else {
                    minl = op1.chars;
                    op2.chars -= op1.chars;
                    op1 = ops1[i1++];
                }
                operation2prime["delete"](minl);
            } else throw new Error("The two operations aren't compatible");
        }
        return [
            operation1prime,
            operation2prime
        ];
    };
    // convenience method to write transform(a, b) as a.transform(b)
    TextOperation.prototype.transform = function(other) {
        return TextOperation.transform(this, other);
    };
    return TextOperation;
}();






const $0ff6f7b2241dad9a$export$79ad5a80dedb955b = function(global) {
    /*
  if (typeof firebase === "undefined" && typeof require === 'function' && typeof Firebase !== 'function') {
	  firebase = require('firebase/app');
	  require('firebase/database');
  }*/ // Save a checkpoint every 100 edits.
    var CHECKPOINT_FREQUENCY = 100;
    function FirebaseAdapter(ref, userId, userColor) {
        this.ref_ = ref;
        this.ready_ = false;
        this.firebaseCallbacks_ = [];
        this.zombie_ = false;
        // We store the current document state as a TextOperation so we can write checkpoints to Firebase occasionally.
        // TODO: Consider more efficient ways to do this. (composing text operations is ~linear in the length of the document).
        this.document_ = new (0, $8c3149d24978582c$export$b3669f5ec3045f43)();
        // The next expected revision.
        this.revision_ = 0;
        // This is used for two purposes:
        // 1) On initialization, we fill this with the latest checkpoint and any subsequent operations and then
        //      process them all together.
        // 2) If we ever receive revisions out-of-order (e.g. rev 5 before rev 4), we queue them here until it's time
        //    for them to be handled. [this should never happen with well-behaved clients; but if it /does/ happen we want
        //    to handle it gracefully.]
        this.pendingReceivedRevisions_ = {};
        var self = this;
        if (userId) {
            this.setUserId(userId);
            this.setColor(userColor);
            var connectedRef = ref.root.child(".info/connected");
            this.firebaseOn_(connectedRef, "value", function(snapshot) {
                if (snapshot.val() === true) self.initializeUserData_();
            }, this);
            // Once we're initialized, start tracking users' cursors.
            this.on("ready", function() {
                self.monitorCursors_();
            });
        } else this.userId_ = ref.push().key;
        // Avoid triggering any events until our callers have had a chance to attach their listeners.
        setTimeout(function() {
            self.monitorHistory_();
        }, 0);
    }
    (0, $5df98098fdb33638$export$eab97d15b1788b8d).makeEventEmitter(FirebaseAdapter, [
        "ready",
        "cursor",
        "operation",
        "ack",
        "retry"
    ]);
    FirebaseAdapter.prototype.dispose = function() {
        var self = this;
        this.removeFirebaseCallbacks_();
        this.handleInitialRevisions_ = ()=>{};
        if (!this.ready_) {
            this.on("ready", function() {
                self.dispose();
            });
            return;
        }
        if (this.userRef_) {
            this.userRef_.child("cursor").remove();
            this.userRef_.child("color").remove();
        }
        this.ref_ = null;
        this.document_ = null;
        this.zombie_ = true;
    };
    FirebaseAdapter.prototype.setUserId = function(userId) {
        if (this.userRef_) {
            // Clean up existing data.  Avoid nuking another user's data
            // (if a future user takes our old name).
            this.userRef_.child("cursor").remove();
            this.userRef_.child("cursor").onDisconnect().cancel();
            this.userRef_.child("color").remove();
            this.userRef_.child("color").onDisconnect().cancel();
        }
        this.userId_ = userId;
        this.userRef_ = this.ref_.child("users").child(userId);
        this.initializeUserData_();
    };
    FirebaseAdapter.prototype.isHistoryEmpty = function() {
        assert(this.ready_, "Not ready yet.");
        return this.revision_ === 0;
    };
    /*
   * Send operation, retrying on connection failure. Takes an optional callback with signature:
   * function(error, committed).
   * An exception will be thrown on transaction failure, which should only happen on
   * catastrophic failure like a security rule violation.
   */ FirebaseAdapter.prototype.sendOperation = function(operation, callback) {
        var self = this;
        // If we're not ready yet, do nothing right now, and trigger a retry when we're ready.
        if (!this.ready_) {
            this.on("ready", function() {
                self.trigger("retry");
            });
            return;
        }
        // Sanity check that this operation is valid.
        assert(this.document_.targetLength === operation.baseLength, "sendOperation() called with invalid operation.");
        // Convert revision into an id that will sort properly lexicographically.
        var revisionId = revisionToId(this.revision_);
        function doTransaction(revisionId, revisionData) {
            self.ref_.child("history").child(revisionId).transaction(function(current) {
                if (current === null) return revisionData;
            }, function(error, committed, snapshot) {
                if (error) {
                    if (error.message === "disconnect") {
                        if (self.sent_ && self.sent_.id === revisionId) // We haven't seen our transaction succeed or fail.  Send it again.
                        setTimeout(function() {
                            doTransaction(revisionId, revisionData);
                        }, 0);
                        else if (callback) callback(error, false);
                    } else {
                        (0, $5df98098fdb33638$export$eab97d15b1788b8d).log("Transaction failure!", error);
                        throw error;
                    }
                } else if (callback) callback(null, committed);
            }, /*applyLocally=*/ false);
        }
        this.sent_ = {
            id: revisionId,
            op: operation
        };
        doTransaction(revisionId, {
            a: self.userId_,
            o: operation.toJSON(),
            t: (0, $42ddf94e6f3c0a26$export$2e2bcd8739ae039).database.ServerValue.TIMESTAMP
        });
    };
    FirebaseAdapter.prototype.sendCursor = function(obj) {
        this.userRef_.child("cursor").set(obj);
        this.cursor_ = obj;
    };
    FirebaseAdapter.prototype.setColor = function(color) {
        this.userRef_.child("color").set(color);
        this.color_ = color;
    };
    FirebaseAdapter.prototype.getDocument = function() {
        return this.document_;
    };
    FirebaseAdapter.prototype.registerCallbacks = function(callbacks) {
        for(var eventType in callbacks)this.on(eventType, callbacks[eventType]);
    };
    FirebaseAdapter.prototype.initializeUserData_ = function() {
        this.userRef_.child("cursor").onDisconnect().remove();
        this.userRef_.child("color").onDisconnect().remove();
        this.sendCursor(this.cursor_ || null);
        this.setColor(this.color_ || null);
    };
    FirebaseAdapter.prototype.monitorCursors_ = function() {
        var usersRef = this.ref_.child("users"), self = this;
        function childChanged(childSnap) {
            var userId = childSnap.key;
            var userData = childSnap.val();
            self.trigger("cursor", userId, userData.cursor, userData.color);
        }
        this.firebaseOn_(usersRef, "child_added", childChanged);
        this.firebaseOn_(usersRef, "child_changed", childChanged);
        this.firebaseOn_(usersRef, "child_removed", function(childSnap) {
            var userId = childSnap.key;
            self.trigger("cursor", userId, null);
        });
    };
    FirebaseAdapter.prototype.monitorHistory_ = function() {
        var self = this;
        // Get the latest checkpoint as a starting point so we don't have to re-play entire history.
        this.ref_.child("checkpoint").once("value", function(s) {
            if (self.zombie_) return;
             // just in case we were cleaned up before we got the checkpoint data.
            var revisionId = s.child("id").val(), op = s.child("o").val(), author = s.child("a").val();
            if (op != null && revisionId != null && author !== null) {
                self.pendingReceivedRevisions_[revisionId] = {
                    o: op,
                    a: author
                };
                self.checkpointRevision_ = revisionFromId(revisionId);
                self.monitorHistoryStartingAt_(self.checkpointRevision_ + 1);
            } else {
                self.checkpointRevision_ = 0;
                self.monitorHistoryStartingAt_(self.checkpointRevision_);
            }
        });
    };
    FirebaseAdapter.prototype.monitorHistoryStartingAt_ = function(revision) {
        var historyRef = this.ref_.child("history").startAt(null, revisionToId(revision));
        var self = this;
        setTimeout(function() {
            self.firebaseOn_(historyRef, "child_added", function(revisionSnapshot) {
                var revisionId = revisionSnapshot.key;
                self.pendingReceivedRevisions_[revisionId] = revisionSnapshot.val();
                if (self.ready_) self.handlePendingReceivedRevisions_();
            });
            historyRef.once("value", function() {
                self.handleInitialRevisions_();
            });
        }, 0);
    };
    FirebaseAdapter.prototype.handleInitialRevisions_ = function() {
        assert(!this.ready_, "Should not be called multiple times.");
        // Compose the checkpoint and all subsequent revisions into a single operation to apply at once.
        this.revision_ = this.checkpointRevision_;
        var revisionId = revisionToId(this.revision_), pending = this.pendingReceivedRevisions_;
        while(pending[revisionId] != null){
            var revision = this.parseRevision_(pending[revisionId]);
            if (!revision) // If a misbehaved client adds a bad operation, just ignore it.
            (0, $5df98098fdb33638$export$eab97d15b1788b8d).log("Invalid operation.", this.ref_.toString(), revisionId, pending[revisionId]);
            else this.document_ = this.document_.compose(revision.operation);
            delete pending[revisionId];
            this.revision_++;
            revisionId = revisionToId(this.revision_);
        }
        this.trigger("operation", this.document_);
        this.ready_ = true;
        var self = this;
        setTimeout(function() {
            self.trigger("ready");
        }, 0);
    };
    FirebaseAdapter.prototype.handlePendingReceivedRevisions_ = function() {
        var pending = this.pendingReceivedRevisions_;
        var revisionId = revisionToId(this.revision_);
        var triggerRetry = false;
        while(pending[revisionId] != null){
            this.revision_++;
            var revision = this.parseRevision_(pending[revisionId]);
            if (!revision) // If a misbehaved client adds a bad operation, just ignore it.
            (0, $5df98098fdb33638$export$eab97d15b1788b8d).log("Invalid operation.", this.ref_.toString(), revisionId, pending[revisionId]);
            else {
                this.document_ = this.document_.compose(revision.operation);
                if (this.sent_ && revisionId === this.sent_.id) {
                    // We have an outstanding change at this revision id.
                    if (this.sent_.op.equals(revision.operation) && revision.author === this.userId_) {
                        // This is our change; it succeeded.
                        if (this.revision_ % CHECKPOINT_FREQUENCY === 0) this.saveCheckpoint_();
                        this.sent_ = null;
                        this.trigger("ack");
                    } else {
                        // our op failed.  Trigger a retry after we're done catching up on any incoming ops.
                        triggerRetry = true;
                        this.trigger("operation", revision.operation);
                    }
                } else this.trigger("operation", revision.operation);
            }
            delete pending[revisionId];
            revisionId = revisionToId(this.revision_);
        }
        if (triggerRetry) {
            this.sent_ = null;
            this.trigger("retry");
        }
    };
    FirebaseAdapter.prototype.parseRevision_ = function(data) {
        // We could do some of this validation via security rules.  But it's nice to be robust, just in case.
        if (typeof data !== "object") return null;
        if (typeof data.a !== "string" || typeof data.o !== "object") return null;
        var op = null;
        try {
            op = (0, $8c3149d24978582c$export$b3669f5ec3045f43).fromJSON(data.o);
        } catch (e) {
            return null;
        }
        if (op.baseLength !== this.document_.targetLength) return null;
        return {
            author: data.a,
            operation: op
        };
    };
    FirebaseAdapter.prototype.saveCheckpoint_ = function() {
        this.ref_.child("checkpoint").set({
            a: this.userId_,
            o: this.document_.toJSON(),
            id: revisionToId(this.revision_ - 1)
        });
    };
    FirebaseAdapter.prototype.firebaseOn_ = function(ref, eventType, callback, context) {
        this.firebaseCallbacks_.push({
            ref: ref,
            eventType: eventType,
            callback: callback,
            context: context
        });
        ref.on(eventType, callback, context);
        return callback;
    };
    FirebaseAdapter.prototype.firebaseOff_ = function(ref, eventType, callback, context) {
        ref.off(eventType, callback, context);
        for(var i = 0; i < this.firebaseCallbacks_.length; i++){
            var l = this.firebaseCallbacks_[i];
            if (l.ref === ref && l.eventType === eventType && l.callback === callback && l.context === context) {
                this.firebaseCallbacks_.splice(i, 1);
                break;
            }
        }
    };
    FirebaseAdapter.prototype.removeFirebaseCallbacks_ = function() {
        for(var i = 0; i < this.firebaseCallbacks_.length; i++){
            var l = this.firebaseCallbacks_[i];
            l.ref.off(l.eventType, l.callback, l.context);
        }
        this.firebaseCallbacks_ = [];
    };
    // Throws an error if the first argument is falsy. Useful for debugging.
    function assert(b, msg) {
        if (!b) throw new Error(msg || "assertion error");
    }
    // Based off ideas from http://www.zanopha.com/docs/elen.pdf
    var characters = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    function revisionToId(revision) {
        if (revision === 0) return "A0";
        var str = "";
        while(revision > 0){
            var digit = revision % characters.length;
            str = characters[digit] + str;
            revision -= digit;
            revision /= characters.length;
        }
        // Prefix with length (starting at 'A' for length 1) to ensure the id's sort lexicographically.
        var prefix = characters[str.length + 9];
        return prefix + str;
    }
    function revisionFromId(revisionId) {
        assert(revisionId.length > 0 && revisionId[0] === characters[revisionId.length + 8]);
        var revision = 0;
        for(var i = 1; i < revisionId.length; i++){
            revision *= characters.length;
            revision += characters.indexOf(revisionId[i]);
        }
        return revision;
    }
    return FirebaseAdapter;
}();



const $92ae9a1f0d0fdb02$export$d1932274993801ff = {
    BOLD: "b",
    ITALIC: "i",
    UNDERLINE: "u",
    STRIKE: "s",
    FONT: "f",
    FONT_SIZE: "fs",
    COLOR: "c",
    BACKGROUND_COLOR: "bc",
    ENTITY_SENTINEL: "ent",
    // Line Attributes
    LINE_SENTINEL: "l",
    LINE_INDENT: "li",
    LINE_ALIGN: "la",
    LIST_TYPE: "lt"
};
const $92ae9a1f0d0fdb02$export$b0a31bc53419a761 = {
    // A special character we insert at the beginning of lines so we can attach attributes to it to represent
    // "line attributes."  E000 is from the unicode "private use" range.
    LINE_SENTINEL_CHARACTER: "\uE000",
    // A special character used to represent any "entity" inserted into the document (e.g. an image).
    ENTITY_SENTINEL_CHARACTER: "\uE001"
};


const $1d816419b17b92b4$export$bc644a473284d944 = function() {
    var SENTINEL = (0, $92ae9a1f0d0fdb02$export$d1932274993801ff).ENTITY_SENTINEL;
    var PREFIX = SENTINEL + "_";
    function Entity(type, info) {
        // Allow calling without new.
        if (!(this instanceof Entity)) return new Entity(type, info);
        this.type = type;
        this.info = info || {};
    }
    Entity.prototype.toAttributes = function() {
        var attrs = {};
        attrs[SENTINEL] = this.type;
        for(var attr in this.info)attrs[PREFIX + attr] = this.info[attr];
        return attrs;
    };
    Entity.fromAttributes = function(attributes) {
        var type = attributes[SENTINEL];
        var info = {};
        for(var attr in attributes)if (attr.indexOf(PREFIX) === 0) info[attr.substr(PREFIX.length)] = attributes[attr];
        return new Entity(type, info);
    };
    return Entity;
}();


let $c52e54ea9957251e$var$fDocument = null;
const $c52e54ea9957251e$export$f65ca476c09acec0 = ()=>$c52e54ea9957251e$var$fDocument || window.document;
const $c52e54ea9957251e$export$65af85b1e66fbfaf = (document)=>$c52e54ea9957251e$var$fDocument = document;


const $ba56c4a0d7a50403$export$c7b7134fd828a5 = function() {
    function EntityManager() {
        this.entities_ = {};
        var attrs = [
            "src",
            "alt",
            "width",
            "height",
            "style",
            "class"
        ];
        this.register("img", {
            render: function(info) {
                (0, $5df98098fdb33638$export$eab97d15b1788b8d).assert(info.src, "image entity should have 'src'!");
                var attrs = [
                    "src",
                    "alt",
                    "width",
                    "height",
                    "style",
                    "class"
                ];
                var html = "<img ";
                for(var i = 0; i < attrs.length; i++){
                    var attr = attrs[i];
                    if (attr in info) html += " " + attr + '="' + info[attr] + '"';
                }
                html += ">";
                return html;
            },
            fromElement: function(element) {
                var info = {};
                for(var i = 0; i < attrs.length; i++){
                    var attr = attrs[i];
                    if (element.hasAttribute(attr)) info[attr] = element.getAttribute(attr);
                }
                return info;
            }
        });
    }
    EntityManager.prototype.register = function(type, options) {
        (0, $5df98098fdb33638$export$eab97d15b1788b8d).assert(options.render, "Entity options should include a 'render' function!");
        (0, $5df98098fdb33638$export$eab97d15b1788b8d).assert(options.fromElement, "Entity options should include a 'fromElement' function!");
        this.entities_[type] = options;
    };
    EntityManager.prototype.renderToElement = function(entity, entityHandle) {
        return this.tryRenderToElement_(entity, "render", entityHandle);
    };
    EntityManager.prototype.exportToElement = function(entity) {
        // Turns out 'export' is a reserved keyword, so 'getHtml' is preferable.
        var elt = this.tryRenderToElement_(entity, "export") || this.tryRenderToElement_(entity, "getHtml") || this.tryRenderToElement_(entity, "render");
        elt.setAttribute("data-firepad-entity", entity.type);
        return elt;
    };
    /* Updates a DOM element to reflect the given entity.
     If the entity doesn't support the update method, it is fully
     re-rendered.
  */ EntityManager.prototype.updateElement = function(entity, element) {
        var type = entity.type;
        var info = entity.info;
        if (this.entities_[type] && typeof this.entities_[type].update != "undefined") this.entities_[type].update(info, element);
    };
    EntityManager.prototype.fromElement = function(element) {
        var type = element.getAttribute("data-firepad-entity");
        // HACK.  This should be configurable through entity registration.
        if (!type) type = element.nodeName.toLowerCase();
        if (type && this.entities_[type]) {
            var info = this.entities_[type].fromElement(element);
            return new (0, $1d816419b17b92b4$export$bc644a473284d944)(type, info);
        }
    };
    EntityManager.prototype.tryRenderToElement_ = function(entity, renderFn, entityHandle) {
        var type = entity.type, info = entity.info;
        if (this.entities_[type] && this.entities_[type][renderFn]) {
            var windowDocument = (0, $c52e54ea9957251e$export$f65ca476c09acec0)();
            var res = this.entities_[type][renderFn](info, entityHandle, windowDocument);
            if (res) {
                if (typeof res === "string") {
                    var div = (0, $c52e54ea9957251e$export$f65ca476c09acec0)().createElement("div");
                    div.innerHTML = res;
                    return div.childNodes[0];
                } else if (typeof res === "object") {
                    (0, $5df98098fdb33638$export$eab97d15b1788b8d).assert(typeof res.nodeType !== "undefined", "Error rendering " + type + " entity.  render() function" + " must return an html string or a DOM element.");
                    return res;
                }
            }
        }
    };
    EntityManager.prototype.entitySupportsUpdate = function(entityType) {
        return this.entities_[entityType] && this.entities_[entityType]["update"];
    };
    return EntityManager;
}();





const $63b49bdfe1946b13$export$c991cff49f3b4249 = function() {
    function LineFormatting(attributes) {
        // Allow calling without new.
        if (!(this instanceof LineFormatting)) return new LineFormatting(attributes);
        this.attributes = attributes || {};
        this.attributes[(0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_SENTINEL] = true;
    }
    LineFormatting.LIST_TYPE = {
        NONE: false,
        ORDERED: "o",
        UNORDERED: "u",
        TODO: "t",
        TODOCHECKED: "tc"
    };
    LineFormatting.prototype.cloneWithNewAttribute_ = function(attribute, value) {
        var attributes = {};
        // Copy existing.
        for(var attr in this.attributes)attributes[attr] = this.attributes[attr];
        // Add new one.
        if (value === false) delete attributes[attribute];
        else attributes[attribute] = value;
        return new LineFormatting(attributes);
    };
    LineFormatting.prototype.indent = function(indent) {
        return this.cloneWithNewAttribute_((0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_INDENT, indent);
    };
    LineFormatting.prototype.align = function(align) {
        return this.cloneWithNewAttribute_((0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_ALIGN, align);
    };
    LineFormatting.prototype.listItem = function(val) {
        (0, $5df98098fdb33638$export$eab97d15b1788b8d).assert(val === false || val === "u" || val === "o" || val === "t" || val === "tc");
        return this.cloneWithNewAttribute_((0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LIST_TYPE, val);
    };
    LineFormatting.prototype.getIndent = function() {
        return this.attributes[(0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_INDENT] || 0;
    };
    LineFormatting.prototype.getAlign = function() {
        return this.attributes[(0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_ALIGN] || 0;
    };
    LineFormatting.prototype.getListItem = function() {
        return this.attributes[(0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LIST_TYPE] || false;
    };
    return LineFormatting;
}();




const $cd3ebf067d86332d$export$5bb3fe2f313a36ca = function() {
    function Formatting(attributes) {
        // Allow calling without new.
        if (!(this instanceof Formatting)) return new Formatting(attributes);
        this.attributes = attributes || {};
    }
    Formatting.prototype.cloneWithNewAttribute_ = function(attribute, value) {
        var attributes = {};
        // Copy existing.
        for(var attr in this.attributes)attributes[attr] = this.attributes[attr];
        // Add new one.
        if (value === false) delete attributes[attribute];
        else attributes[attribute] = value;
        return new Formatting(attributes);
    };
    Formatting.prototype.bold = function(val) {
        return this.cloneWithNewAttribute_((0, $92ae9a1f0d0fdb02$export$d1932274993801ff).BOLD, val);
    };
    Formatting.prototype.italic = function(val) {
        return this.cloneWithNewAttribute_((0, $92ae9a1f0d0fdb02$export$d1932274993801ff).ITALIC, val);
    };
    Formatting.prototype.underline = function(val) {
        return this.cloneWithNewAttribute_((0, $92ae9a1f0d0fdb02$export$d1932274993801ff).UNDERLINE, val);
    };
    Formatting.prototype.strike = function(val) {
        return this.cloneWithNewAttribute_((0, $92ae9a1f0d0fdb02$export$d1932274993801ff).STRIKE, val);
    };
    Formatting.prototype.font = function(font) {
        return this.cloneWithNewAttribute_((0, $92ae9a1f0d0fdb02$export$d1932274993801ff).FONT, font);
    };
    Formatting.prototype.fontSize = function(size) {
        return this.cloneWithNewAttribute_((0, $92ae9a1f0d0fdb02$export$d1932274993801ff).FONT_SIZE, size);
    };
    Formatting.prototype.color = function(color) {
        return this.cloneWithNewAttribute_((0, $92ae9a1f0d0fdb02$export$d1932274993801ff).COLOR, color);
    };
    Formatting.prototype.backgroundColor = function(color) {
        return this.cloneWithNewAttribute_((0, $92ae9a1f0d0fdb02$export$d1932274993801ff).BACKGROUND_COLOR, color);
    };
    return Formatting;
}();


const $91f3c0029e0bc586$export$5f1af8db9871e1d6 = function() {
    function Text(text, formatting) {
        // Allow calling without new.
        if (!(this instanceof Text)) return new Text(text, formatting);
        this.text = text;
        this.formatting = formatting || (0, $cd3ebf067d86332d$export$5bb3fe2f313a36ca)();
    }
    return Text;
}();





const $602b0556d8a1c74a$export$17d680238e50603e = function() {
    function Line(textPieces, formatting) {
        // Allow calling without new.
        if (!(this instanceof Line)) return new Line(textPieces, formatting);
        if (Object.prototype.toString.call(textPieces) !== "[object Array]") {
            if (typeof textPieces === "undefined") textPieces = [];
            else textPieces = [
                textPieces
            ];
        }
        this.textPieces = textPieces;
        this.formatting = formatting || (0, $63b49bdfe1946b13$export$c991cff49f3b4249)();
    }
    return Line;
}();


const $0e7c7a2651049be8$export$f6e976a3dcab89f5 = function() {
    var { LIST_TYPE: LIST_TYPE } = (0, $63b49bdfe1946b13$export$c991cff49f3b4249);
    /**
   * Represents the current parse state as an immutable structure.  To create a new ParseState, use
   * the withXXX methods.
   *
   * @param opt_listType
   * @param opt_lineFormatting
   * @param opt_textFormatting
   * @constructor
   */ function ParseState(opt_listType, opt_lineFormatting, opt_textFormatting) {
        this.listType = opt_listType || LIST_TYPE.UNORDERED;
        this.lineFormatting = opt_lineFormatting || (0, $63b49bdfe1946b13$export$c991cff49f3b4249)();
        this.textFormatting = opt_textFormatting || (0, $cd3ebf067d86332d$export$5bb3fe2f313a36ca)();
    }
    ParseState.prototype.withTextFormatting = function(textFormatting) {
        return new ParseState(this.listType, this.lineFormatting, textFormatting);
    };
    ParseState.prototype.withLineFormatting = function(lineFormatting) {
        return new ParseState(this.listType, lineFormatting, this.textFormatting);
    };
    ParseState.prototype.withListType = function(listType) {
        return new ParseState(listType, this.lineFormatting, this.textFormatting);
    };
    ParseState.prototype.withIncreasedIndent = function() {
        var lineFormatting = this.lineFormatting.indent(this.lineFormatting.getIndent() + 1);
        return new ParseState(this.listType, lineFormatting, this.textFormatting);
    };
    ParseState.prototype.withAlign = function(align) {
        var lineFormatting = this.lineFormatting.align(align);
        return new ParseState(this.listType, lineFormatting, this.textFormatting);
    };
    /**
   * Mutable structure representing the current parse output.
   * @constructor
   */ function ParseOutput() {
        this.lines = [];
        this.currentLine = [];
        this.currentLineListItemType = null;
    }
    ParseOutput.prototype.newlineIfNonEmpty = function(state) {
        this.cleanLine_();
        if (this.currentLine.length > 0) this.newline(state);
    };
    ParseOutput.prototype.newlineIfNonEmptyOrListItem = function(state) {
        this.cleanLine_();
        if (this.currentLine.length > 0 || this.currentLineListItemType !== null) this.newline(state);
    };
    ParseOutput.prototype.newline = function(state) {
        this.cleanLine_();
        var lineFormatting = state.lineFormatting;
        if (this.currentLineListItemType !== null) {
            lineFormatting = lineFormatting.listItem(this.currentLineListItemType);
            this.currentLineListItemType = null;
        }
        this.lines.push((0, $602b0556d8a1c74a$export$17d680238e50603e)(this.currentLine, lineFormatting));
        this.currentLine = [];
    };
    ParseOutput.prototype.makeListItem = function(type) {
        this.currentLineListItemType = type;
    };
    ParseOutput.prototype.cleanLine_ = function() {
        // Kinda' a hack, but we remove leading and trailing spaces (since these aren't significant in html) and
        // replaces nbsp's with normal spaces.
        if (this.currentLine.length > 0) {
            var last = this.currentLine.length - 1;
            this.currentLine[0].text = this.currentLine[0].text.replace(/^ +/, "");
            this.currentLine[last].text = this.currentLine[last].text.replace(/ +$/g, "");
            for(var i = 0; i < this.currentLine.length; i++)this.currentLine[i].text = this.currentLine[i].text.replace(/\u00a0/g, " ");
        }
        // If after stripping trailing whitespace, there's nothing left, clear currentLine out.
        if (this.currentLine.length === 1 && this.currentLine[0].text === "") this.currentLine = [];
    };
    var entityManager_;
    function parseHtml(html, entityManager) {
        // Create DIV with HTML (as a convenient way to parse it).
        var div = (0, $c52e54ea9957251e$export$f65ca476c09acec0)().createElement("div");
        div.innerHTML = html;
        // HACK until I refactor this.
        entityManager_ = entityManager;
        var output = new ParseOutput();
        var state = new ParseState();
        parseNode(div, state, output);
        return output.lines;
    }
    // Fix IE8.
    var Node = Node || {
        ELEMENT_NODE: 1,
        TEXT_NODE: 3
    };
    function parseNode(node, state, output) {
        // Give entity manager first crack at it.
        if (node.nodeType === Node.ELEMENT_NODE) {
            var entity = entityManager_.fromElement(node);
            if (entity) {
                output.currentLine.push(new (0, $91f3c0029e0bc586$export$5f1af8db9871e1d6)((0, $92ae9a1f0d0fdb02$export$b0a31bc53419a761).ENTITY_SENTINEL_CHARACTER, new (0, $cd3ebf067d86332d$export$5bb3fe2f313a36ca)(entity.toAttributes())));
                return;
            }
        }
        switch(node.nodeType){
            case Node.TEXT_NODE:
                // This probably isn't exactly right, but mostly works...
                var text = node.nodeValue.replace(/[ \n\t]+/g, " ");
                output.currentLine.push((0, $91f3c0029e0bc586$export$5f1af8db9871e1d6)(text, state.textFormatting));
                break;
            case Node.ELEMENT_NODE:
                var style = node.getAttribute("style") || "";
                state = parseStyle(state, style);
                switch(node.nodeName.toLowerCase()){
                    case "div":
                    case "h1":
                    case "h2":
                    case "h3":
                    case "p":
                        output.newlineIfNonEmpty(state);
                        parseChildren(node, state, output);
                        output.newlineIfNonEmpty(state);
                        break;
                    case "center":
                        state = state.withAlign("center");
                        output.newlineIfNonEmpty(state);
                        parseChildren(node, state.withAlign("center"), output);
                        output.newlineIfNonEmpty(state);
                        break;
                    case "b":
                    case "strong":
                        parseChildren(node, state.withTextFormatting(state.textFormatting.bold(true)), output);
                        break;
                    case "u":
                        parseChildren(node, state.withTextFormatting(state.textFormatting.underline(true)), output);
                        break;
                    case "i":
                    case "em":
                        parseChildren(node, state.withTextFormatting(state.textFormatting.italic(true)), output);
                        break;
                    case "s":
                        parseChildren(node, state.withTextFormatting(state.textFormatting.strike(true)), output);
                        break;
                    case "font":
                        var face = node.getAttribute("face");
                        var color = node.getAttribute("color");
                        var size = parseInt(node.getAttribute("size"));
                        if (face) state = state.withTextFormatting(state.textFormatting.font(face));
                        if (color) state = state.withTextFormatting(state.textFormatting.color(color));
                        if (size) state = state.withTextFormatting(state.textFormatting.fontSize(size));
                        parseChildren(node, state, output);
                        break;
                    case "br":
                        output.newline(state);
                        break;
                    case "ul":
                        output.newlineIfNonEmptyOrListItem(state);
                        var listType = node.getAttribute("class") === "firepad-todo" ? LIST_TYPE.TODO : LIST_TYPE.UNORDERED;
                        parseChildren(node, state.withListType(listType).withIncreasedIndent(), output);
                        output.newlineIfNonEmpty(state);
                        break;
                    case "ol":
                        output.newlineIfNonEmptyOrListItem(state);
                        parseChildren(node, state.withListType(LIST_TYPE.ORDERED).withIncreasedIndent(), output);
                        output.newlineIfNonEmpty(state);
                        break;
                    case "li":
                        parseListItem(node, state, output);
                        break;
                    case "style":
                        break;
                    default:
                        parseChildren(node, state, output);
                        break;
                }
                break;
            default:
                break;
        }
    }
    function parseChildren(node, state, output) {
        if (node.hasChildNodes()) for(var i = 0; i < node.childNodes.length; i++)parseNode(node.childNodes[i], state, output);
    }
    function parseListItem(node, state, output) {
        // Note: <li> is weird:
        // * Only the first line in the <li> tag should be a list item (i.e. with a bullet or number next to it).
        // * <li></li> should create an empty list item line; <li><ol><li></li></ol></li> should create two.
        output.newlineIfNonEmptyOrListItem(state);
        var listType = node.getAttribute("class") === "firepad-checked" ? LIST_TYPE.TODOCHECKED : state.listType;
        output.makeListItem(listType);
        var oldLine = output.currentLine;
        parseChildren(node, state, output);
        if (oldLine === output.currentLine || output.currentLine.length > 0) output.newline(state);
    }
    function parseStyle(state, styleString) {
        var textFormatting = state.textFormatting;
        var lineFormatting = state.lineFormatting;
        var styles = styleString.split(";");
        for(var i = 0; i < styles.length; i++){
            var stylePieces = styles[i].split(":");
            if (stylePieces.length !== 2) continue;
            var prop = (0, $5df98098fdb33638$export$eab97d15b1788b8d).trim(stylePieces[0]).toLowerCase();
            var val = (0, $5df98098fdb33638$export$eab97d15b1788b8d).trim(stylePieces[1]).toLowerCase();
            switch(prop){
                case "text-decoration":
                    var underline = val.indexOf("underline") >= 0;
                    var strike = val.indexOf("line-through") >= 0;
                    textFormatting = textFormatting.underline(underline).strike(strike);
                    break;
                case "font-weight":
                    var bold = val === "bold" || parseInt(val) >= 600;
                    textFormatting = textFormatting.bold(bold);
                    break;
                case "font-style":
                    var italic = val === "italic" || val === "oblique";
                    textFormatting = textFormatting.italic(italic);
                    break;
                case "color":
                    textFormatting = textFormatting.color(val);
                    break;
                case "background-color":
                    textFormatting = textFormatting.backgroundColor(val);
                    break;
                case "text-align":
                    lineFormatting = lineFormatting.align(val);
                    break;
                case "font-size":
                    var size = null;
                    var allowedValues = [
                        "px",
                        "pt",
                        "%",
                        "em",
                        "xx-small",
                        "x-small",
                        "small",
                        "medium",
                        "large",
                        "x-large",
                        "xx-large",
                        "smaller",
                        "larger"
                    ];
                    if ((0, $5df98098fdb33638$export$eab97d15b1788b8d).stringEndsWith(val, allowedValues)) size = val;
                    else if (parseInt(val)) size = parseInt(val) + "px";
                    if (size) textFormatting = textFormatting.fontSize(size);
                    break;
                case "font-family":
                    var font = (0, $5df98098fdb33638$export$eab97d15b1788b8d).trim(val.split(",")[0]) // get first font.
                    ;
                    font = font.replace(/['"]/g, "") // remove quotes.
                    ;
                    font = font.replace(/\w\S*/g, function(txt) {
                        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                    });
                    textFormatting = textFormatting.font(font);
                    break;
            }
        }
        return state.withLineFormatting(lineFormatting).withTextFormatting(textFormatting);
    }
    return parseHtml;
}();









const $e87cd51840064746$export$84445af632c3c500 = function() {
    var { LIST_TYPE: LIST_TYPE } = (0, $63b49bdfe1946b13$export$c991cff49f3b4249);
    var TODO_STYLE = '<style>ul.firepad-todo { list-style: none; margin-left: 0; padding-left: 0; } ul.firepad-todo > li { padding-left: 1em; text-indent: -1em; } ul.firepad-todo > li:before { content: "\\2610"; padding-right: 5px; } ul.firepad-todo > li.firepad-checked:before { content: "\\2611"; padding-right: 5px; }</style>\n';
    function open(listType) {
        return listType === LIST_TYPE.ORDERED ? "<ol>" : listType === LIST_TYPE.UNORDERED ? "<ul>" : '<ul class="firepad-todo">';
    }
    function close(listType) {
        return listType === LIST_TYPE.ORDERED ? "</ol>" : "</ul>";
    }
    function compatibleListType(l1, l2) {
        return l1 === l2 || l1 === LIST_TYPE.TODO && l2 === LIST_TYPE.TODOCHECKED || l1 === LIST_TYPE.TODOCHECKED && l2 === LIST_TYPE.TODO;
    }
    function textToHtml(text) {
        return text.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\u00a0/g, "&nbsp;");
    }
    function serializeHtml(doc, entityManager) {
        var html = "";
        var newLine = true;
        var listTypeStack = [];
        var inListItem = false;
        var firstLine = true;
        var emptyLine = true;
        var i = 0, op = doc.ops[i];
        var usesTodo = false;
        while(op){
            (0, $5df98098fdb33638$export$eab97d15b1788b8d).assert(op.isInsert());
            var attrs = op.attributes;
            if (newLine) {
                newLine = false;
                var indent = 0, listType = null, lineAlign = "left";
                if ((0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_SENTINEL in attrs) {
                    indent = attrs[(0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_INDENT] || 0;
                    listType = attrs[(0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LIST_TYPE] || null;
                    lineAlign = attrs[(0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_ALIGN] || "left";
                }
                if (listType) indent = indent || 1 // lists are automatically indented at least 1.
                ;
                if (inListItem) {
                    html += "</li>";
                    inListItem = false;
                } else if (!firstLine) {
                    if (emptyLine) html += "<br/>";
                    html += "</div>";
                }
                firstLine = false;
                // Close any extra lists.
                (0, $5df98098fdb33638$export$eab97d15b1788b8d).assert(indent >= 0, "Indent must not be negative.");
                while(listTypeStack.length > indent || indent === listTypeStack.length && listType !== null && !compatibleListType(listType, listTypeStack[listTypeStack.length - 1]))html += close(listTypeStack.pop());
                // Open any needed lists.
                while(listTypeStack.length < indent){
                    var toOpen = listType || LIST_TYPE.UNORDERED // default to unordered lists for indenting non-list-item lines.
                    ;
                    usesTodo = listType == LIST_TYPE.TODO || listType == LIST_TYPE.TODOCHECKED || usesTodo;
                    html += open(toOpen);
                    listTypeStack.push(toOpen);
                }
                var style = lineAlign !== "left" ? ' style="text-align:' + lineAlign + '"' : "";
                if (listType) {
                    var clazz = "";
                    switch(listType){
                        case LIST_TYPE.TODOCHECKED:
                            clazz = ' class="firepad-checked"';
                            break;
                        case LIST_TYPE.TODO:
                            clazz = ' class="firepad-unchecked"';
                            break;
                    }
                    html += "<li" + clazz + style + ">";
                    inListItem = true;
                } else // start line div.
                html += "<div" + style + ">";
                emptyLine = true;
            }
            if ((0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_SENTINEL in attrs) {
                op = doc.ops[++i];
                continue;
            }
            if ((0, $92ae9a1f0d0fdb02$export$d1932274993801ff).ENTITY_SENTINEL in attrs) {
                for(var j = 0; j < op.text.length; j++){
                    var entity = (0, $1d816419b17b92b4$export$bc644a473284d944).fromAttributes(attrs);
                    var element = entityManager.exportToElement(entity);
                    html += element.outerHTML;
                }
                op = doc.ops[++i];
                continue;
            }
            var prefix = "", suffix = "";
            for(var attr in attrs){
                var value = attrs[attr];
                var start, end;
                if (attr === (0, $92ae9a1f0d0fdb02$export$d1932274993801ff).BOLD || attr === (0, $92ae9a1f0d0fdb02$export$d1932274993801ff).ITALIC || attr === (0, $92ae9a1f0d0fdb02$export$d1932274993801ff).UNDERLINE || attr === (0, $92ae9a1f0d0fdb02$export$d1932274993801ff).STRIKE) {
                    (0, $5df98098fdb33638$export$eab97d15b1788b8d).assert(value === true);
                    start = end = attr;
                } else if (attr === (0, $92ae9a1f0d0fdb02$export$d1932274993801ff).FONT_SIZE) {
                    start = 'span style="font-size: ' + value;
                    start += typeof value !== "string" || value.indexOf("px", value.length - 2) === -1 ? 'px"' : '"';
                    end = "span";
                } else if (attr === (0, $92ae9a1f0d0fdb02$export$d1932274993801ff).FONT) {
                    start = 'span style="font-family: ' + value + '"';
                    end = "span";
                } else if (attr === (0, $92ae9a1f0d0fdb02$export$d1932274993801ff).COLOR) {
                    start = 'span style="color: ' + value + '"';
                    end = "span";
                } else if (attr === (0, $92ae9a1f0d0fdb02$export$d1932274993801ff).BACKGROUND_COLOR) {
                    start = 'span style="background-color: ' + value + '"';
                    end = "span";
                } else (0, $5df98098fdb33638$export$eab97d15b1788b8d).log(false, "Encountered unknown attribute while rendering html: " + attr);
                if (start) prefix += "<" + start + ">";
                if (end) suffix = "</" + end + ">" + suffix;
            }
            var text = op.text;
            var newLineIndex = text.indexOf("\n");
            if (newLineIndex >= 0) {
                newLine = true;
                if (newLineIndex < text.length - 1) // split op.
                op = new (0, $ab98ee380c7ac8a1$export$ca875bc28cbbddb1)("insert", text.substr(newLineIndex + 1), attrs);
                else op = doc.ops[++i];
                text = text.substr(0, newLineIndex);
            } else op = doc.ops[++i];
            // Replace leading, trailing, and consecutive spaces with nbsp's to make sure they're preserved.
            text = text.replace(/  +/g, function(str) {
                return new Array(str.length + 1).join("\u00a0");
            }).replace(/^ /, "\u00a0").replace(/ $/, "\u00a0");
            if (text.length > 0) emptyLine = false;
            html += prefix + textToHtml(text) + suffix;
        }
        if (inListItem) html += "</li>";
        else if (!firstLine) {
            if (emptyLine) html += "&nbsp;";
            html += "</div>";
        }
        // Close any extra lists.
        while(listTypeStack.length > 0)html += close(listTypeStack.pop());
        if (usesTodo) html = TODO_STYLE + html;
        return html;
    }
    return serializeHtml;
}();






const $ffe3e1aa8856b10b$export$74debc3f43f46569 = function(atNewLine, textPieces) {
    var inserts = [];
    function insert(string, attributes) {
        if (string instanceof (0, $91f3c0029e0bc586$export$5f1af8db9871e1d6)) {
            attributes = string.formatting.attributes;
            string = string.text;
        }
        inserts.push({
            string: string,
            attributes: attributes
        });
        atNewLine = string[string.length - 1] === "\n";
    }
    function insertLine(line, withNewline) {
        // HACK: We should probably force a newline if there isn't one already.  But due to
        // the way this is used for inserting HTML, we end up inserting a "line" in the middle
        // of text, in which case we don't want to actually insert a newline.
        if (atNewLine) insert((0, $92ae9a1f0d0fdb02$export$b0a31bc53419a761).LINE_SENTINEL_CHARACTER, line.formatting.attributes);
        for(var i = 0; i < line.textPieces.length; i++)insert(line.textPieces[i]);
        if (withNewline) insert("\n");
    }
    for(var i = 0; i < textPieces.length; i++)if (textPieces[i] instanceof (0, $602b0556d8a1c74a$export$17d680238e50603e)) insertLine(textPieces[i], i < textPieces.length - 1);
    else insert(textPieces[i]);
    return inserts;
};



const $b1bab01e82df7ca2$export$b6a79797ad180576 = function() {
    "use strict";
    // A cursor has a `position` and a `selectionEnd`. Both are zero-based indexes
    // into the document. When nothing is selected, `selectionEnd` is equal to
    // `position`. When there is a selection, `position` is always the side of the
    // selection that would move if you pressed an arrow key.
    function Cursor(position, selectionEnd) {
        this.position = position;
        this.selectionEnd = selectionEnd;
    }
    Cursor.fromJSON = function(obj) {
        return new Cursor(obj.position, obj.selectionEnd);
    };
    Cursor.prototype.equals = function(other) {
        return this.position === other.position && this.selectionEnd === other.selectionEnd;
    };
    // Return the more current cursor information.
    Cursor.prototype.compose = function(other) {
        return other;
    };
    // Update the cursor with respect to an operation.
    Cursor.prototype.transform = function(other) {
        function transformIndex(index) {
            var newIndex = index;
            var ops = other.ops;
            for(var i = 0, l = other.ops.length; i < l; i++){
                if (ops[i].isRetain()) index -= ops[i].chars;
                else if (ops[i].isInsert()) newIndex += ops[i].text.length;
                else {
                    newIndex -= Math.min(index, ops[i].chars);
                    index -= ops[i].chars;
                }
                if (index < 0) break;
            }
            return newIndex;
        }
        var newPosition = transformIndex(this.position);
        if (this.position === this.selectionEnd) return new Cursor(newPosition, newPosition);
        return new Cursor(newPosition, transformIndex(this.selectionEnd));
    };
    return Cursor;
}();


const $6760987d7dd3f622$export$1f2bb630327ac4b6 = function() {
    "use strict";
    // Client constructor
    function Client() {
        this.state = synchronized_ // start state
        ;
    }
    Client.prototype.setState = function(state) {
        this.state = state;
    };
    // Call this method when the user changes the document.
    Client.prototype.applyClient = function(operation) {
        this.setState(this.state.applyClient(this, operation));
    };
    // Call this method with a new operation from the server
    Client.prototype.applyServer = function(operation) {
        this.setState(this.state.applyServer(this, operation));
    };
    Client.prototype.serverAck = function() {
        this.setState(this.state.serverAck(this));
    };
    Client.prototype.serverRetry = function() {
        this.setState(this.state.serverRetry(this));
    };
    // Override this method.
    Client.prototype.sendOperation = function(operation) {
        throw new Error("sendOperation must be defined in child class");
    };
    // Override this method.
    Client.prototype.applyOperation = function(operation) {
        throw new Error("applyOperation must be defined in child class");
    };
    // In the 'Synchronized' state, there is no pending operation that the client
    // has sent to the server.
    function Synchronized() {}
    Client.Synchronized = Synchronized;
    Synchronized.prototype.applyClient = function(client, operation) {
        // When the user makes an edit, send the operation to the server and
        // switch to the 'AwaitingConfirm' state
        client.sendOperation(operation);
        return new AwaitingConfirm(operation);
    };
    Synchronized.prototype.applyServer = function(client, operation) {
        // When we receive a new operation from the server, the operation can be
        // simply applied to the current document
        client.applyOperation(operation);
        return this;
    };
    Synchronized.prototype.serverAck = function(client) {
        throw new Error("There is no pending operation.");
    };
    Synchronized.prototype.serverRetry = function(client) {
        throw new Error("There is no pending operation.");
    };
    // Singleton
    var synchronized_ = new Synchronized();
    // In the 'AwaitingConfirm' state, there's one operation the client has sent
    // to the server and is still waiting for an acknowledgement.
    function AwaitingConfirm(outstanding) {
        // Save the pending operation
        this.outstanding = outstanding;
    }
    Client.AwaitingConfirm = AwaitingConfirm;
    AwaitingConfirm.prototype.applyClient = function(client, operation) {
        // When the user makes an edit, don't send the operation immediately,
        // instead switch to 'AwaitingWithBuffer' state
        return new AwaitingWithBuffer(this.outstanding, operation);
    };
    AwaitingConfirm.prototype.applyServer = function(client, operation) {
        // This is another client's operation. Visualization:
        //
        //                   /\
        // this.outstanding /  \ operation
        //                 /    \
        //                 \    /
        //  pair[1]         \  / pair[0] (new outstanding)
        //  (can be applied  \/
        //  to the client's
        //  current document)
        var pair = this.outstanding.transform(operation);
        client.applyOperation(pair[1]);
        return new AwaitingConfirm(pair[0]);
    };
    AwaitingConfirm.prototype.serverAck = function(client) {
        // The client's operation has been acknowledged
        // => switch to synchronized state
        return synchronized_;
    };
    AwaitingConfirm.prototype.serverRetry = function(client) {
        client.sendOperation(this.outstanding);
        return this;
    };
    // In the 'AwaitingWithBuffer' state, the client is waiting for an operation
    // to be acknowledged by the server while buffering the edits the user makes
    function AwaitingWithBuffer(outstanding, buffer) {
        // Save the pending operation and the user's edits since then
        this.outstanding = outstanding;
        this.buffer = buffer;
    }
    Client.AwaitingWithBuffer = AwaitingWithBuffer;
    AwaitingWithBuffer.prototype.applyClient = function(client, operation) {
        // Compose the user's changes onto the buffer
        var newBuffer = this.buffer.compose(operation);
        return new AwaitingWithBuffer(this.outstanding, newBuffer);
    };
    AwaitingWithBuffer.prototype.applyServer = function(client, operation) {
        // Operation comes from another client
        //
        //                       /\
        //     this.outstanding /  \ operation
        //                     /    \
        //                    /\    /
        //       this.buffer /  \* / pair1[0] (new outstanding)
        //                  /    \/
        //                  \    /
        //          pair2[1] \  / pair2[0] (new buffer)
        // the transformed    \/
        // operation -- can
        // be applied to the
        // client's current
        // document
        //
        // * pair1[1]
        var pair1 = this.outstanding.transform(operation);
        var pair2 = this.buffer.transform(pair1[1]);
        client.applyOperation(pair2[1]);
        return new AwaitingWithBuffer(pair1[0], pair2[0]);
    };
    AwaitingWithBuffer.prototype.serverRetry = function(client) {
        // Merge with our buffer and resend.
        var outstanding = this.outstanding.compose(this.buffer);
        client.sendOperation(outstanding);
        return new AwaitingConfirm(outstanding);
    };
    AwaitingWithBuffer.prototype.serverAck = function(client) {
        // The pending operation has been acknowledged
        // => send buffer
        client.sendOperation(this.buffer);
        return new AwaitingConfirm(this.buffer);
    };
    return Client;
}();


const $a1153763a08bad2a$export$932a3f9a7e88971c = function() {
    "use strict";
    var NORMAL_STATE = "normal";
    var UNDOING_STATE = "undoing";
    var REDOING_STATE = "redoing";
    // Create a new UndoManager with an optional maximum history size.
    function UndoManager(maxItems) {
        this.maxItems = maxItems || 50;
        this.state = NORMAL_STATE;
        this.dontCompose = false;
        this.undoStack = [];
        this.redoStack = [];
    }
    // Add an operation to the undo or redo stack, depending on the current state
    // of the UndoManager. The operation added must be the inverse of the last
    // edit. When `compose` is true, compose the operation with the last operation
    // unless the last operation was alread pushed on the redo stack or was hidden
    // by a newer operation on the undo stack.
    UndoManager.prototype.add = function(operation, compose) {
        if (this.state === UNDOING_STATE) {
            this.redoStack.push(operation);
            this.dontCompose = true;
        } else if (this.state === REDOING_STATE) {
            this.undoStack.push(operation);
            this.dontCompose = true;
        } else {
            var undoStack = this.undoStack;
            if (!this.dontCompose && compose && undoStack.length > 0) undoStack.push(operation.compose(undoStack.pop()));
            else {
                undoStack.push(operation);
                if (undoStack.length > this.maxItems) undoStack.shift();
            }
            this.dontCompose = false;
            this.redoStack = [];
        }
    };
    function transformStack(stack, operation) {
        var newStack = [];
        var Operation = operation.constructor;
        for(var i = stack.length - 1; i >= 0; i--){
            var pair = Operation.transform(stack[i], operation);
            if (typeof pair[0].isNoop !== "function" || !pair[0].isNoop()) newStack.push(pair[0]);
            operation = pair[1];
        }
        return newStack.reverse();
    }
    // Transform the undo and redo stacks against a operation by another client.
    UndoManager.prototype.transform = function(operation) {
        this.undoStack = transformStack(this.undoStack, operation);
        this.redoStack = transformStack(this.redoStack, operation);
    };
    // Perform an undo by calling a function with the latest operation on the undo
    // stack. The function is expected to call the `add` method with the inverse
    // of the operation, which pushes the inverse on the redo stack.
    UndoManager.prototype.performUndo = function(fn) {
        this.state = UNDOING_STATE;
        if (this.undoStack.length === 0) throw new Error("undo not possible");
        fn(this.undoStack.pop());
        this.state = NORMAL_STATE;
    };
    // The inverse of `performUndo`.
    UndoManager.prototype.performRedo = function(fn) {
        this.state = REDOING_STATE;
        if (this.redoStack.length === 0) throw new Error("redo not possible");
        fn(this.redoStack.pop());
        this.state = NORMAL_STATE;
    };
    // Is the undo stack not empty?
    UndoManager.prototype.canUndo = function() {
        return this.undoStack.length !== 0;
    };
    // Is the redo stack not empty?
    UndoManager.prototype.canRedo = function() {
        return this.redoStack.length !== 0;
    };
    // Whether the UndoManager is currently performing an undo.
    UndoManager.prototype.isUndoing = function() {
        return this.state === UNDOING_STATE;
    };
    // Whether the UndoManager is currently performing a redo.
    UndoManager.prototype.isRedoing = function() {
        return this.state === REDOING_STATE;
    };
    return UndoManager;
}();


const $061c8e407d4012d9$export$44b9cd6bf5dc48fb = function(global) {
    "use strict";
    // A WrappedOperation contains an operation and corresponing metadata.
    function WrappedOperation(operation, meta) {
        this.wrapped = operation;
        this.meta = meta;
    }
    WrappedOperation.prototype.apply = function() {
        return this.wrapped.apply.apply(this.wrapped, arguments);
    };
    WrappedOperation.prototype.invert = function() {
        var meta = this.meta;
        return new WrappedOperation(this.wrapped.invert.apply(this.wrapped, arguments), meta && typeof meta === "object" && typeof meta.invert === "function" ? meta.invert.apply(meta, arguments) : meta);
    };
    // Copy all properties from source to target.
    function copy(source, target) {
        for(var key in source)if (source.hasOwnProperty(key)) target[key] = source[key];
    }
    function composeMeta(a, b) {
        if (a && typeof a === "object") {
            if (typeof a.compose === "function") return a.compose(b);
            var meta = {};
            copy(a, meta);
            copy(b, meta);
            return meta;
        }
        return b;
    }
    WrappedOperation.prototype.compose = function(other) {
        return new WrappedOperation(this.wrapped.compose(other.wrapped), composeMeta(this.meta, other.meta));
    };
    function transformMeta(meta, operation) {
        if (meta && typeof meta === "object") {
            if (typeof meta.transform === "function") return meta.transform(operation);
        }
        return meta;
    }
    WrappedOperation.transform = function(a, b) {
        var pair = a.wrapped.transform(b.wrapped);
        return [
            new WrappedOperation(pair[0], transformMeta(a.meta, b.wrapped)),
            new WrappedOperation(pair[1], transformMeta(b.meta, a.wrapped))
        ];
    };
    // convenience method to write transform(a, b) as a.transform(b)
    WrappedOperation.prototype.transform = function(other) {
        return WrappedOperation.transform(this, other);
    };
    return WrappedOperation;
}();


const $9697d3dc5736b1f3$export$74e430f5ecc76f59 = function() {
    "use strict";
    function SelfMeta(cursorBefore, cursorAfter) {
        this.cursorBefore = cursorBefore;
        this.cursorAfter = cursorAfter;
    }
    SelfMeta.prototype.invert = function() {
        return new SelfMeta(this.cursorAfter, this.cursorBefore);
    };
    SelfMeta.prototype.compose = function(other) {
        return new SelfMeta(this.cursorBefore, other.cursorAfter);
    };
    SelfMeta.prototype.transform = function(operation) {
        return new SelfMeta(this.cursorBefore ? this.cursorBefore.transform(operation) : null, this.cursorAfter ? this.cursorAfter.transform(operation) : null);
    };
    function OtherClient(id, editorAdapter) {
        this.id = id;
        this.editorAdapter = editorAdapter;
    }
    OtherClient.prototype.setColor = function(color) {
        this.color = color;
    };
    OtherClient.prototype.updateCursor = function(cursor) {
        this.removeCursor();
        this.cursor = cursor;
        this.mark = this.editorAdapter.setOtherCursor(cursor, this.color, this.id);
    };
    OtherClient.prototype.removeCursor = function() {
        if (this.mark) this.mark.clear();
    };
    function EditorClient(serverAdapter, editorAdapter) {
        (0, $6760987d7dd3f622$export$1f2bb630327ac4b6).call(this);
        this.serverAdapter = serverAdapter;
        this.editorAdapter = editorAdapter;
        this.undoManager = new (0, $a1153763a08bad2a$export$932a3f9a7e88971c)();
        this.clients = {};
        var self = this;
        this.editorAdapter.registerCallbacks({
            change: function(operation, inverse) {
                self.onChange(operation, inverse);
            },
            cursorActivity: function() {
                self.onCursorActivity();
            },
            blur: function() {
                self.onBlur();
            },
            focus: function() {
                self.onFocus();
            }
        });
        this.editorAdapter.registerUndo(function() {
            self.undo();
        });
        this.editorAdapter.registerRedo(function() {
            self.redo();
        });
        this.serverAdapter.registerCallbacks({
            ack: function() {
                self.serverAck();
                if (self.focused && self.state instanceof (0, $6760987d7dd3f622$export$1f2bb630327ac4b6).Synchronized) {
                    self.updateCursor();
                    self.sendCursor(self.cursor);
                }
                self.emitStatus();
            },
            retry: function() {
                self.serverRetry();
            },
            operation: function(operation) {
                self.applyServer(operation);
            },
            cursor: function(clientId, cursor, color) {
                if (self.serverAdapter.userId_ === clientId || !(self.state instanceof (0, $6760987d7dd3f622$export$1f2bb630327ac4b6).Synchronized)) return;
                var client = self.getClientObject(clientId);
                if (cursor) {
                    if (color) client.setColor(color);
                    client.updateCursor((0, $b1bab01e82df7ca2$export$b6a79797ad180576).fromJSON(cursor));
                } else client.removeCursor();
            }
        });
    }
    inherit(EditorClient, (0, $6760987d7dd3f622$export$1f2bb630327ac4b6));
    EditorClient.prototype.getClientObject = function(clientId) {
        var client = this.clients[clientId];
        if (client) return client;
        return this.clients[clientId] = new OtherClient(clientId, this.editorAdapter);
    };
    EditorClient.prototype.applyUnredo = function(operation) {
        this.undoManager.add(this.editorAdapter.invertOperation(operation));
        this.editorAdapter.applyOperation(operation.wrapped);
        this.cursor = operation.meta.cursorAfter;
        if (this.cursor) this.editorAdapter.setCursor(this.cursor);
        this.applyClient(operation.wrapped);
    };
    EditorClient.prototype.undo = function() {
        var self = this;
        if (!this.undoManager.canUndo()) return;
        this.undoManager.performUndo(function(o) {
            self.applyUnredo(o);
        });
    };
    EditorClient.prototype.redo = function() {
        var self = this;
        if (!this.undoManager.canRedo()) return;
        this.undoManager.performRedo(function(o) {
            self.applyUnredo(o);
        });
    };
    EditorClient.prototype.onChange = function(textOperation, inverse) {
        var cursorBefore = this.cursor;
        this.updateCursor();
        var compose = this.undoManager.undoStack.length > 0 && inverse.shouldBeComposedWithInverted(last(this.undoManager.undoStack).wrapped);
        var inverseMeta = new SelfMeta(this.cursor, cursorBefore);
        this.undoManager.add(new (0, $061c8e407d4012d9$export$44b9cd6bf5dc48fb)(inverse, inverseMeta), compose);
        this.applyClient(textOperation);
    };
    EditorClient.prototype.updateCursor = function() {
        this.cursor = this.editorAdapter.getCursor();
    };
    EditorClient.prototype.onCursorActivity = function() {
        var oldCursor = this.cursor;
        this.updateCursor();
        if (!this.focused || oldCursor && this.cursor.equals(oldCursor)) return;
        this.sendCursor(this.cursor);
    };
    EditorClient.prototype.onBlur = function() {
        this.cursor = null;
        this.sendCursor(null);
        this.focused = false;
    };
    EditorClient.prototype.onFocus = function() {
        this.focused = true;
        this.onCursorActivity();
    };
    EditorClient.prototype.sendCursor = function(cursor) {
        if (this.state instanceof (0, $6760987d7dd3f622$export$1f2bb630327ac4b6).AwaitingWithBuffer) return;
        this.serverAdapter.sendCursor(cursor);
    };
    EditorClient.prototype.sendOperation = function(operation) {
        this.serverAdapter.sendOperation(operation);
        this.emitStatus();
    };
    EditorClient.prototype.applyOperation = function(operation) {
        this.editorAdapter.applyOperation(operation);
        this.updateCursor();
        this.undoManager.transform(new (0, $061c8e407d4012d9$export$44b9cd6bf5dc48fb)(operation, null));
    };
    EditorClient.prototype.emitStatus = function() {
        var self = this;
        setTimeout(function() {
            self.trigger("synced", self.state instanceof (0, $6760987d7dd3f622$export$1f2bb630327ac4b6).Synchronized);
        }, 0);
    };
    // Set Const.prototype.__proto__ to Super.prototype
    function inherit(Const, Super) {
        function F() {}
        F.prototype = Super.prototype;
        Const.prototype = new F();
        Const.prototype.constructor = Const;
    }
    function last(arr) {
        return arr[arr.length - 1];
    }
    return EditorClient;
}();
(0, $5df98098fdb33638$export$eab97d15b1788b8d).makeEventEmitter($9697d3dc5736b1f3$export$74e430f5ecc76f59, [
    "synced"
]);









const $bb26a380d7bea108$export$9882b6cd53285b96 = function() {
    "use strict";
    function RichTextCodeMirrorAdapter(rtcm) {
        this.rtcm = rtcm;
        this.cm = rtcm.codeMirror;
        bind(this, "onChange");
        bind(this, "onAttributesChange");
        bind(this, "onCursorActivity");
        bind(this, "onFocus");
        bind(this, "onBlur");
        this.rtcm.on("change", this.onChange);
        this.rtcm.on("attributesChange", this.onAttributesChange);
        this.cm.on("cursorActivity", this.onCursorActivity);
        this.cm.on("focus", this.onFocus);
        this.cm.on("blur", this.onBlur);
    }
    // Removes all event listeners from the CodeMirror instance.
    RichTextCodeMirrorAdapter.prototype.detach = function() {
        this.rtcm.off("change", this.onChange);
        this.rtcm.off("attributesChange", this.onAttributesChange);
        this.cm.off("cursorActivity", this.onCursorActivity);
        this.cm.off("focus", this.onFocus);
        this.cm.off("blur", this.onBlur);
    };
    function cmpPos(a, b) {
        if (a.line < b.line) return -1;
        if (a.line > b.line) return 1;
        if (a.ch < b.ch) return -1;
        if (a.ch > b.ch) return 1;
        return 0;
    }
    function posEq(a, b) {
        return cmpPos(a, b) === 0;
    }
    function posLe(a, b) {
        return cmpPos(a, b) <= 0;
    }
    function codemirrorLength(cm) {
        var lastLine = cm.lineCount() - 1;
        return cm.indexFromPos({
            line: lastLine,
            ch: cm.getLine(lastLine).length
        });
    }
    // Converts a CodeMirror change object into a TextOperation and its inverse
    // and returns them as a two-element array.
    RichTextCodeMirrorAdapter.operationFromCodeMirrorChanges = function(changes, cm) {
        // Approach: Replay the changes, beginning with the most recent one, and
        // construct the operation and its inverse. We have to convert the position
        // in the pre-change coordinate system to an index. We have a method to
        // convert a position in the coordinate system after all changes to an index,
        // namely CodeMirror's `indexFromPos` method. We can use the information of
        // a single change object to convert a post-change coordinate system to a
        // pre-change coordinate system. We can now proceed inductively to get a
        // pre-change coordinate system for all changes in the linked list.
        // A disadvantage of this approach is its complexity `O(n^2)` in the length
        // of the linked list of changes.
        var docEndLength = codemirrorLength(cm);
        var operation = new (0, $8c3149d24978582c$export$b3669f5ec3045f43)().retain(docEndLength);
        var inverse = new (0, $8c3149d24978582c$export$b3669f5ec3045f43)().retain(docEndLength);
        for(var i = changes.length - 1; i >= 0; i--){
            var change = changes[i];
            var fromIndex = change.start;
            var restLength = docEndLength - fromIndex - change.text.length;
            operation = new (0, $8c3149d24978582c$export$b3669f5ec3045f43)().retain(fromIndex)["delete"](change.removed.length).insert(change.text, change.attributes).retain(restLength).compose(operation);
            inverse = inverse.compose(new (0, $8c3149d24978582c$export$b3669f5ec3045f43)().retain(fromIndex)["delete"](change.text.length).insert(change.removed, change.removedAttributes).retain(restLength));
            docEndLength += change.removed.length - change.text.length;
        }
        return [
            operation,
            inverse
        ];
    };
    // Converts an attributes changed object to an operation and its inverse.
    RichTextCodeMirrorAdapter.operationFromAttributesChanges = function(changes, cm) {
        var docEndLength = codemirrorLength(cm);
        var operation = new (0, $8c3149d24978582c$export$b3669f5ec3045f43)(), inverse = new (0, $8c3149d24978582c$export$b3669f5ec3045f43)();
        var pos = 0;
        for(var i = 0; i < changes.length; i++){
            var change = changes[i];
            var toRetain = change.start - pos;
            assert(toRetain >= 0) // changes should be in order and non-overlapping.
            ;
            operation.retain(toRetain);
            inverse.retain(toRetain);
            var length = change.end - change.start;
            operation.retain(length, change.attributes);
            inverse.retain(length, change.attributesInverse);
            pos = change.start + length;
        }
        operation.retain(docEndLength - pos);
        inverse.retain(docEndLength - pos);
        return [
            operation,
            inverse
        ];
    };
    RichTextCodeMirrorAdapter.prototype.registerCallbacks = function(cb) {
        this.callbacks = cb;
    };
    RichTextCodeMirrorAdapter.prototype.onChange = function(_, changes) {
        if (changes[0].origin !== "RTCMADAPTER") {
            var pair = RichTextCodeMirrorAdapter.operationFromCodeMirrorChanges(changes, this.cm);
            this.trigger("change", pair[0], pair[1]);
        }
    };
    RichTextCodeMirrorAdapter.prototype.onAttributesChange = function(_, changes) {
        if (changes[0].origin !== "RTCMADAPTER") {
            var pair = RichTextCodeMirrorAdapter.operationFromAttributesChanges(changes, this.cm);
            this.trigger("change", pair[0], pair[1]);
        }
    };
    RichTextCodeMirrorAdapter.prototype.onCursorActivity = function() {
        // We want to push cursor changes to Firebase AFTER edits to the history,
        // because the cursor coordinates will already be in post-change units.
        // Sleeping for 1ms ensures that sendCursor happens after sendOperation.
        var self = this;
        setTimeout(function() {
            self.trigger("cursorActivity");
        }, 1);
    };
    RichTextCodeMirrorAdapter.prototype.onFocus = function() {
        this.trigger("focus");
    };
    RichTextCodeMirrorAdapter.prototype.onBlur = function() {
        if (!this.cm.somethingSelected()) this.trigger("blur");
    };
    RichTextCodeMirrorAdapter.prototype.getValue = function() {
        return this.cm.getValue();
    };
    RichTextCodeMirrorAdapter.prototype.getCursor = function() {
        var cm = this.cm;
        var cursorPos = cm.getCursor();
        var position = cm.indexFromPos(cursorPos);
        var selectionEnd;
        if (cm.somethingSelected()) {
            var startPos = cm.getCursor(true);
            var selectionEndPos = posEq(cursorPos, startPos) ? cm.getCursor(false) : startPos;
            selectionEnd = cm.indexFromPos(selectionEndPos);
        } else selectionEnd = position;
        return new (0, $b1bab01e82df7ca2$export$b6a79797ad180576)(position, selectionEnd);
    };
    RichTextCodeMirrorAdapter.prototype.setCursor = function(cursor) {
        this.cm.setSelection(this.cm.posFromIndex(cursor.position), this.cm.posFromIndex(cursor.selectionEnd));
    };
    RichTextCodeMirrorAdapter.prototype.addStyleRule = function(css) {
        if (typeof document === "undefined" || document === null) return;
        if (!this.addedStyleRules) {
            this.addedStyleRules = {};
            var styleElement = document.createElement("style");
            document.documentElement.getElementsByTagName("head")[0].appendChild(styleElement);
            this.addedStyleSheet = styleElement.sheet;
        }
        if (this.addedStyleRules[css]) return;
        this.addedStyleRules[css] = true;
        return this.addedStyleSheet.insertRule(css, 0);
    };
    RichTextCodeMirrorAdapter.prototype.setOtherCursor = function(cursor, color, clientId) {
        var cursorPos = this.cm.posFromIndex(cursor.position);
        if (typeof color !== "string" || !color.match(/^#[a-fA-F0-9]{3,6}$/)) return;
        var end = this.rtcm.end();
        if (typeof cursor !== "object" || typeof cursor.position !== "number" || typeof cursor.selectionEnd !== "number") return;
        if (cursor.position < 0 || cursor.position > end || cursor.selectionEnd < 0 || cursor.selectionEnd > end) return;
        if (cursor.position === cursor.selectionEnd) {
            // show cursor
            var cursorCoords = this.cm.cursorCoords(cursorPos);
            var cursorEl = document.createElement("span");
            cursorEl.className = "other-client";
            cursorEl.style.borderLeftWidth = "2px";
            cursorEl.style.borderLeftStyle = "solid";
            cursorEl.style.borderLeftColor = color;
            cursorEl.style.marginLeft = cursorEl.style.marginRight = "-1px";
            cursorEl.style.height = (cursorCoords.bottom - cursorCoords.top) * 0.9 + "px";
            cursorEl.setAttribute("data-clientid", clientId);
            cursorEl.style.zIndex = 0;
            return this.cm.setBookmark(cursorPos, {
                widget: cursorEl,
                insertLeft: true
            });
        } else {
            // show selection
            var selectionClassName = "selection-" + color.replace("#", "");
            var transparency = 0.4;
            var rule = "." + selectionClassName + " {" + // fallback for browsers w/out rgba (rgb w/ transparency)
            " background: " + hex2rgb(color) + ";\n" + // rule with alpha takes precedence if supported
            " background: " + hex2rgb(color, transparency) + ";" + "}";
            this.addStyleRule(rule);
            var fromPos, toPos;
            if (cursor.selectionEnd > cursor.position) {
                fromPos = cursorPos;
                toPos = this.cm.posFromIndex(cursor.selectionEnd);
            } else {
                fromPos = this.cm.posFromIndex(cursor.selectionEnd);
                toPos = cursorPos;
            }
            return this.cm.markText(fromPos, toPos, {
                className: selectionClassName
            });
        }
    };
    RichTextCodeMirrorAdapter.prototype.trigger = function(event) {
        var args = Array.prototype.slice.call(arguments, 1);
        var action = this.callbacks && this.callbacks[event];
        if (action) action.apply(this, args);
    };
    // Apply an operation to a CodeMirror instance.
    RichTextCodeMirrorAdapter.prototype.applyOperation = function(operation) {
        // HACK: If there are a lot of operations; hide CodeMirror so that it doesn't re-render constantly.
        if (operation.ops.length > 10) this.rtcm.codeMirror.getWrapperElement().setAttribute("style", "display: none");
        var ops = operation.ops;
        var index = 0 // holds the current index into CodeMirror's content
        ;
        for(var i = 0, l = ops.length; i < l; i++){
            var op = ops[i];
            if (op.isRetain()) {
                if (!emptyAttributes(op.attributes)) this.rtcm.updateTextAttributes(index, index + op.chars, function(attributes) {
                    for(var attr in op.attributes)if (op.attributes[attr] === false) delete attributes[attr];
                    else attributes[attr] = op.attributes[attr];
                }, "RTCMADAPTER", /*doLineAttributes=*/ true);
                index += op.chars;
            } else if (op.isInsert()) {
                this.rtcm.insertText(index, op.text, op.attributes, "RTCMADAPTER");
                index += op.text.length;
            } else if (op.isDelete()) this.rtcm.removeText(index, index + op.chars, "RTCMADAPTER");
        }
        if (operation.ops.length > 10) {
            this.rtcm.codeMirror.getWrapperElement().setAttribute("style", "");
            this.rtcm.codeMirror.refresh();
        }
    };
    RichTextCodeMirrorAdapter.prototype.registerUndo = function(undoFn) {
        this.cm.undo = undoFn;
    };
    RichTextCodeMirrorAdapter.prototype.registerRedo = function(redoFn) {
        this.cm.redo = redoFn;
    };
    RichTextCodeMirrorAdapter.prototype.invertOperation = function(operation) {
        var pos = 0, cm = this.rtcm.codeMirror, spans, i;
        var inverse = new (0, $8c3149d24978582c$export$b3669f5ec3045f43)();
        for(var opIndex = 0; opIndex < operation.wrapped.ops.length; opIndex++){
            var op = operation.wrapped.ops[opIndex];
            if (op.isRetain()) {
                if (emptyAttributes(op.attributes)) {
                    inverse.retain(op.chars);
                    pos += op.chars;
                } else {
                    spans = this.rtcm.getAttributeSpans(pos, pos + op.chars);
                    for(i = 0; i < spans.length; i++){
                        var inverseAttributes = {};
                        for(var attr in op.attributes){
                            var opValue = op.attributes[attr];
                            var curValue = spans[i].attributes[attr];
                            if (opValue === false) {
                                if (curValue) inverseAttributes[attr] = curValue;
                            } else if (opValue !== curValue) inverseAttributes[attr] = curValue || false;
                        }
                        inverse.retain(spans[i].length, inverseAttributes);
                        pos += spans[i].length;
                    }
                }
            } else if (op.isInsert()) inverse["delete"](op.text.length);
            else if (op.isDelete()) {
                var text = cm.getRange(cm.posFromIndex(pos), cm.posFromIndex(pos + op.chars));
                spans = this.rtcm.getAttributeSpans(pos, pos + op.chars);
                var delTextPos = 0;
                for(i = 0; i < spans.length; i++){
                    inverse.insert(text.substr(delTextPos, spans[i].length), spans[i].attributes);
                    delTextPos += spans[i].length;
                }
                pos += op.chars;
            }
        }
        return new (0, $061c8e407d4012d9$export$44b9cd6bf5dc48fb)(inverse, operation.meta.invert());
    };
    // Throws an error if the first argument is falsy. Useful for debugging.
    function assert(b, msg) {
        if (!b) throw new Error(msg || "assertion error");
    }
    // Bind a method to an object, so it doesn't matter whether you call
    // object.method() directly or pass object.method as a reference to another
    // function.
    function bind(obj, method) {
        var fn = obj[method];
        obj[method] = function() {
            fn.apply(obj, arguments);
        };
    }
    function emptyAttributes(attrs) {
        for(var attr in attrs)return false;
        return true;
    }
    function hex2rgb(hex, transparency) {
        if (typeof hex !== "string") throw new TypeError("Expected a string");
        hex = hex.replace(/^#/, "");
        if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        var num = parseInt(hex, 16);
        var rgb = [
            num >> 16,
            num >> 8 & 255,
            num & 255
        ];
        var type = "rgb";
        if (exists(transparency)) {
            type = "rgba";
            rgb.push(transparency);
        }
        // rgb(r, g, b) or rgba(r, g, b, t)
        return type + "(" + rgb.join(",") + ")";
    }
    function exists(val) {
        return val !== null && val !== undefined;
    }
    return RichTextCodeMirrorAdapter;
}();


const $553edfb3b2f13454$export$5f1714a13ed34c01 = function() {
    function Span(pos, length) {
        this.pos = pos;
        this.length = length;
    }
    Span.prototype.end = function() {
        return this.pos + this.length;
    };
    return Span;
}();






const $c8ed6adb08c5f934$export$f02acd808977a663 = function() {
    function assert(bool, text) {
        if (!bool) throw new Error("AnnotationList assertion failed" + (text ? ": " + text : ""));
    }
    function OldAnnotatedSpan(pos, node) {
        this.pos = pos;
        this.length = node.length;
        this.annotation = node.annotation;
        this.attachedObject_ = node.attachedObject;
    }
    OldAnnotatedSpan.prototype.getAttachedObject = function() {
        return this.attachedObject_;
    };
    function NewAnnotatedSpan(pos, node) {
        this.pos = pos;
        this.length = node.length;
        this.annotation = node.annotation;
        this.node_ = node;
    }
    NewAnnotatedSpan.prototype.attachObject = function(object) {
        this.node_.attachedObject = object;
    };
    var NullAnnotation = {
        equals: function() {
            return false;
        }
    };
    function AnnotationList(changeHandler) {
        // There's always a head node; to avoid special cases.
        this.head_ = new Node(0, NullAnnotation);
        this.changeHandler_ = changeHandler;
    }
    AnnotationList.prototype.insertAnnotatedSpan = function(span, annotation) {
        this.wrapOperation_(new (0, $553edfb3b2f13454$export$5f1714a13ed34c01)(span.pos, 0), function(oldPos, old) {
            assert(!old || old.next === null) // should be 0 or 1 nodes.
            ;
            var toInsert = new Node(span.length, annotation);
            if (!old) return toInsert;
            else {
                assert(span.pos > oldPos && span.pos < oldPos + old.length);
                var newNodes = new Node(0, NullAnnotation);
                // Insert part of old before insertion point.
                newNodes.next = new Node(span.pos - oldPos, old.annotation);
                // Insert new node.
                newNodes.next.next = toInsert;
                // Insert part of old after insertion point.
                toInsert.next = new Node(oldPos + old.length - span.pos, old.annotation);
                return newNodes.next;
            }
        });
    };
    AnnotationList.prototype.removeSpan = function(removeSpan) {
        if (removeSpan.length === 0) return;
        this.wrapOperation_(removeSpan, function(oldPos, old) {
            assert(old !== null);
            var newNodes = new Node(0, NullAnnotation), current = newNodes;
            // Add new node for part before the removed span (if any).
            if (removeSpan.pos > oldPos) {
                current.next = new Node(removeSpan.pos - oldPos, old.annotation);
                current = current.next;
            }
            // Skip over removed nodes.
            while(removeSpan.end() > oldPos + old.length){
                oldPos += old.length;
                old = old.next;
            }
            // Add new node for part after the removed span (if any).
            var afterChars = oldPos + old.length - removeSpan.end();
            if (afterChars > 0) current.next = new Node(afterChars, old.annotation);
            return newNodes.next;
        });
    };
    AnnotationList.prototype.updateSpan = function(span, updateFn) {
        if (span.length === 0) return;
        this.wrapOperation_(span, function(oldPos, old) {
            assert(old !== null);
            var newNodes = new Node(0, NullAnnotation), current = newNodes, currentPos = oldPos;
            // Add node for any characters before the span we're updating.
            var beforeChars = span.pos - currentPos;
            assert(beforeChars < old.length);
            if (beforeChars > 0) {
                current.next = new Node(beforeChars, old.annotation);
                current = current.next;
                currentPos += current.length;
            }
            // Add updated nodes for entirely updated nodes.
            while(old !== null && span.end() >= oldPos + old.length){
                var length = oldPos + old.length - currentPos;
                current.next = new Node(length, updateFn(old.annotation, length));
                current = current.next;
                oldPos += old.length;
                old = old.next;
                currentPos = oldPos;
            }
            // Add updated nodes for last node.
            var updateChars = span.end() - currentPos;
            if (updateChars > 0) {
                assert(updateChars < old.length);
                current.next = new Node(updateChars, updateFn(old.annotation, updateChars));
                current = current.next;
                currentPos += current.length;
                // Add non-updated remaining part of node.
                current.next = new Node(oldPos + old.length - currentPos, old.annotation);
            }
            return newNodes.next;
        });
    };
    AnnotationList.prototype.wrapOperation_ = function(span, operationFn) {
        if (span.pos < 0) throw new Error("Span start cannot be negative.");
        var oldNodes = [], newNodes = [];
        var res = this.getAffectedNodes_(span);
        var tail;
        if (res.start !== null) {
            tail = res.end.next;
            // Temporarily truncate list so we can pass it to operationFn.  We'll splice it back in later.
            res.end.next = null;
        } else // start and end are null, because span is empty and lies on the border of two nodes.
        tail = res.succ;
        // Create a new segment to replace the affected nodes.
        var newSegment = operationFn(res.startPos, res.start);
        var includePredInOldNodes = false, includeSuccInOldNodes = false;
        if (newSegment) {
            this.mergeNodesWithSameAnnotations_(newSegment);
            var newPos;
            if (res.pred && res.pred.annotation.equals(newSegment.annotation)) {
                // We can merge the pred node with newSegment's first node.
                includePredInOldNodes = true;
                newSegment.length += res.pred.length;
                // Splice newSegment in after beforePred.
                res.beforePred.next = newSegment;
                newPos = res.predPos;
            } else {
                // Splice newSegment in after beforeStart.
                res.beforeStart.next = newSegment;
                newPos = res.startPos;
            }
            // Generate newNodes, but not the last one (since we may be able to merge it with succ).
            while(newSegment.next){
                newNodes.push(new NewAnnotatedSpan(newPos, newSegment));
                newPos += newSegment.length;
                newSegment = newSegment.next;
            }
            if (res.succ && res.succ.annotation.equals(newSegment.annotation)) {
                // We can merge newSegment's last node with the succ node.
                newSegment.length += res.succ.length;
                includeSuccInOldNodes = true;
                // Splice rest of list after succ after newSegment.
                newSegment.next = res.succ.next;
            } else // Splice tail after newSegment.
            newSegment.next = tail;
            // Add last newSegment node to newNodes.
            newNodes.push(new NewAnnotatedSpan(newPos, newSegment));
        } else // newList is empty.  Try to merge pred and succ.
        if (res.pred && res.succ && res.pred.annotation.equals(res.succ.annotation)) {
            includePredInOldNodes = true;
            includeSuccInOldNodes = true;
            // Create succ + pred merged node and splice list together.
            newSegment = new Node(res.pred.length + res.succ.length, res.pred.annotation);
            res.beforePred.next = newSegment;
            newSegment.next = res.succ.next;
            newNodes.push(new NewAnnotatedSpan(res.startPos - res.pred.length, newSegment));
        } else // Just splice list back together.
        res.beforeStart.next = tail;
        // Build list of oldNodes.
        if (includePredInOldNodes) oldNodes.push(new OldAnnotatedSpan(res.predPos, res.pred));
        var oldPos = res.startPos, oldSegment = res.start;
        while(oldSegment !== null){
            oldNodes.push(new OldAnnotatedSpan(oldPos, oldSegment));
            oldPos += oldSegment.length;
            oldSegment = oldSegment.next;
        }
        if (includeSuccInOldNodes) oldNodes.push(new OldAnnotatedSpan(oldPos, res.succ));
        this.changeHandler_(oldNodes, newNodes);
    };
    AnnotationList.prototype.getAffectedNodes_ = function(span) {
        // We want to find nodes 'start', 'end', 'beforeStart', 'pred', and 'succ' where:
        //  - 'start' contains the first character in span.
        //  - 'end' contains the last character in span.
        //  - 'beforeStart' is the node before 'start'.
        //  - 'beforePred' is the node before 'pred'.
        //  - 'succ' contains the node after 'end' if span.end() was on a node boundary, else null.
        //  - 'pred' contains the node before 'start' if span.pos was on a node boundary, else null.
        var result = {};
        var prevprev = null, prev = this.head_, current = prev.next, currentPos = 0;
        while(current !== null && span.pos >= currentPos + current.length){
            currentPos += current.length;
            prevprev = prev;
            prev = current;
            current = current.next;
        }
        if (current === null && !(span.length === 0 && span.pos === currentPos)) throw new Error("Span start exceeds the bounds of the AnnotationList.");
        result.startPos = currentPos;
        // Special case if span is empty and on the border of two nodes
        if (span.length === 0 && span.pos === currentPos) result.start = null;
        else result.start = current;
        result.beforeStart = prev;
        if (currentPos === span.pos && currentPos > 0) {
            result.pred = prev;
            result.predPos = currentPos - prev.length;
            result.beforePred = prevprev;
        } else result.pred = null;
        while(current !== null && span.end() > currentPos){
            currentPos += current.length;
            prev = current;
            current = current.next;
        }
        if (span.end() > currentPos) throw new Error("Span end exceeds the bounds of the AnnotationList.");
        // Special case if span is empty and on the border of two nodes.
        if (span.length === 0 && span.end() === currentPos) result.end = null;
        else result.end = prev;
        result.succ = currentPos === span.end() ? current : null;
        return result;
    };
    AnnotationList.prototype.mergeNodesWithSameAnnotations_ = function(list) {
        if (!list) return;
        var prev = null, curr = list;
        while(curr){
            if (prev && prev.annotation.equals(curr.annotation)) {
                prev.length += curr.length;
                prev.next = curr.next;
            } else prev = curr;
            curr = curr.next;
        }
    };
    AnnotationList.prototype.forEach = function(callback) {
        var current = this.head_.next;
        while(current !== null){
            callback(current.length, current.annotation, current.attachedObject);
            current = current.next;
        }
    };
    AnnotationList.prototype.getAnnotatedSpansForPos = function(pos) {
        var currentPos = 0;
        var current = this.head_.next, prev = null;
        while(current !== null && currentPos + current.length <= pos){
            currentPos += current.length;
            prev = current;
            current = current.next;
        }
        if (current === null && currentPos !== pos) throw new Error("pos exceeds the bounds of the AnnotationList");
        var res = [];
        if (currentPos === pos && prev) res.push(new OldAnnotatedSpan(currentPos - prev.length, prev));
        if (current) res.push(new OldAnnotatedSpan(currentPos, current));
        return res;
    };
    AnnotationList.prototype.getAnnotatedSpansForSpan = function(span) {
        if (span.length === 0) return [];
        var oldSpans = [];
        var res = this.getAffectedNodes_(span);
        var currentPos = res.startPos, current = res.start;
        while(current !== null && currentPos < span.end()){
            var start = Math.max(currentPos, span.pos), end = Math.min(currentPos + current.length, span.end());
            var oldSpan = new (0, $553edfb3b2f13454$export$5f1714a13ed34c01)(start, end - start);
            oldSpan.annotation = current.annotation;
            oldSpans.push(oldSpan);
            currentPos += current.length;
            current = current.next;
        }
        return oldSpans;
    };
    // For testing.
    AnnotationList.prototype.count = function() {
        var count = 0;
        var current = this.head_.next, prev = null;
        while(current !== null){
            if (prev) assert(!prev.annotation.equals(current.annotation));
            prev = current;
            current = current.next;
            count++;
        }
        return count;
    };
    function Node(length, annotation) {
        this.length = length;
        this.annotation = annotation;
        this.attachedObject = null;
        this.next = null;
    }
    Node.prototype.clone = function() {
        var node = new Node(this.spanLength, this.annotation);
        node.next = this.next;
        return node;
    };
    return AnnotationList;
}();


const $15380d2091620678$export$e6b06cc764358bfa = function() {
    var RichTextClassPrefixDefault = "cmrt-";
    var RichTextOriginPrefix = "cmrt-";
    // These attributes will have styles generated dynamically in the page.
    var DynamicStyleAttributes = {
        c: "color",
        bc: "background-color",
        fs: "font-size",
        li: function(indent) {
            return "padding-left: " + indent * 40 + "px";
        }
    };
    // A cache of dynamically-created styles so we can re-use them.
    var StyleCache_ = {};
    function RichTextCodeMirror(codeMirror, entityManager, options) {
        this.codeMirror = codeMirror;
        this.options_ = options || {};
        this.entityManager_ = entityManager;
        this.currentAttributes_ = null;
        var self = this;
        this.annotationList_ = new (0, $c8ed6adb08c5f934$export$f02acd808977a663)(function(oldNodes, newNodes) {
            self.onAnnotationsChanged_(oldNodes, newNodes);
        });
        // Ensure annotationList is in sync with any existing codemirror contents.
        this.initAnnotationList_();
        bind(this, "onCodeMirrorBeforeChange_");
        bind(this, "onCodeMirrorChange_");
        bind(this, "onCursorActivity_");
        if (parseInt(CodeMirror.version) >= 4) this.codeMirror.on("changes", this.onCodeMirrorChange_);
        else this.codeMirror.on("change", this.onCodeMirrorChange_);
        this.codeMirror.on("beforeChange", this.onCodeMirrorBeforeChange_);
        this.codeMirror.on("cursorActivity", this.onCursorActivity_);
        this.changeId_ = 0;
        this.outstandingChanges_ = {};
        this.dirtyLines_ = [];
    }
    (0, $5df98098fdb33638$export$eab97d15b1788b8d).makeEventEmitter(RichTextCodeMirror, [
        "change",
        "attributesChange",
        "newLine"
    ]);
    var LineSentinelCharacter = (0, $92ae9a1f0d0fdb02$export$b0a31bc53419a761).LINE_SENTINEL_CHARACTER;
    var EntitySentinelCharacter = (0, $92ae9a1f0d0fdb02$export$b0a31bc53419a761).ENTITY_SENTINEL_CHARACTER;
    RichTextCodeMirror.prototype.detach = function() {
        this.codeMirror.off("beforeChange", this.onCodeMirrorBeforeChange_);
        this.codeMirror.off("change", this.onCodeMirrorChange_);
        this.codeMirror.off("changes", this.onCodeMirrorChange_);
        this.codeMirror.off("cursorActivity", this.onCursorActivity_);
        this.clearAnnotations_();
    };
    RichTextCodeMirror.prototype.toggleAttribute = function(attribute, value) {
        var trueValue = value || true;
        if (this.emptySelection_()) {
            var attrs = this.getCurrentAttributes_();
            if (attrs[attribute] === trueValue) delete attrs[attribute];
            else attrs[attribute] = trueValue;
            this.currentAttributes_ = attrs;
        } else {
            var attributes = this.getCurrentAttributes_();
            var newValue = attributes[attribute] !== trueValue ? trueValue : false;
            this.setAttribute(attribute, newValue);
        }
    };
    RichTextCodeMirror.prototype.setAttribute = function(attribute, value) {
        var cm = this.codeMirror;
        if (this.emptySelection_()) {
            var attrs = this.getCurrentAttributes_();
            if (value === false) delete attrs[attribute];
            else attrs[attribute] = value;
            this.currentAttributes_ = attrs;
        } else {
            this.updateTextAttributes(cm.indexFromPos(cm.getCursor("start")), cm.indexFromPos(cm.getCursor("end")), function(attributes) {
                if (value === false) delete attributes[attribute];
                else attributes[attribute] = value;
            });
            this.updateCurrentAttributes_();
        }
    };
    RichTextCodeMirror.prototype.updateTextAttributes = function(start, end, updateFn, origin, doLineAttributes) {
        var newChanges = [];
        var pos = start, self = this;
        this.annotationList_.updateSpan(new (0, $553edfb3b2f13454$export$5f1714a13ed34c01)(start, end - start), function(annotation, length) {
            var attributes = {};
            for(var attr in annotation.attributes)attributes[attr] = annotation.attributes[attr];
            // Don't modify if this is a line sentinel.
            if (!attributes[(0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_SENTINEL] || doLineAttributes) updateFn(attributes);
            // changedAttributes will be the attributes we changed, with their new values.
            // changedAttributesInverse will be the attributes we changed, with their old values.
            var changedAttributes = {}, changedAttributesInverse = {};
            self.computeChangedAttributes_(annotation.attributes, attributes, changedAttributes, changedAttributesInverse);
            if (!emptyAttributes(changedAttributes)) newChanges.push({
                start: pos,
                end: pos + length,
                attributes: changedAttributes,
                attributesInverse: changedAttributesInverse,
                origin: origin
            });
            pos += length;
            return new RichTextAnnotation(attributes);
        });
        if (newChanges.length > 0) this.trigger("attributesChange", this, newChanges);
    };
    RichTextCodeMirror.prototype.computeChangedAttributes_ = function(oldAttrs, newAttrs, changed, inverseChanged) {
        var attrs = {}, attr;
        for(attr in oldAttrs)attrs[attr] = true;
        for(attr in newAttrs)attrs[attr] = true;
        for(attr in attrs){
            if (!(attr in newAttrs)) {
                // it was removed.
                changed[attr] = false;
                inverseChanged[attr] = oldAttrs[attr];
            } else if (!(attr in oldAttrs)) {
                // it was added.
                changed[attr] = newAttrs[attr];
                inverseChanged[attr] = false;
            } else if (oldAttrs[attr] !== newAttrs[attr]) {
                // it was changed.
                changed[attr] = newAttrs[attr];
                inverseChanged[attr] = oldAttrs[attr];
            }
        }
    };
    RichTextCodeMirror.prototype.toggleLineAttribute = function(attribute, value) {
        var currentAttributes = this.getCurrentLineAttributes_();
        var newValue;
        if (!(attribute in currentAttributes) || currentAttributes[attribute] !== value) newValue = value;
        else newValue = false;
        this.setLineAttribute(attribute, newValue);
    };
    RichTextCodeMirror.prototype.setLineAttribute = function(attribute, value) {
        this.updateLineAttributesForSelection(function(attributes) {
            if (value === false) delete attributes[attribute];
            else attributes[attribute] = value;
        });
    };
    RichTextCodeMirror.prototype.updateLineAttributesForSelection = function(updateFn) {
        var cm = this.codeMirror;
        var start = cm.getCursor("start"), end = cm.getCursor("end");
        var startLine = start.line, endLine = end.line;
        var endLineText = cm.getLine(endLine);
        var endsAtBeginningOfLine = this.areLineSentinelCharacters_(endLineText.substr(0, end.ch));
        if (endLine > startLine && endsAtBeginningOfLine) // If the selection ends at the beginning of a line, don't include that line.
        endLine--;
        this.updateLineAttributes(startLine, endLine, updateFn);
    };
    RichTextCodeMirror.prototype.updateLineAttributes = function(startLine, endLine, updateFn) {
        // TODO: Batch this into a single operation somehow.
        for(var line = startLine; line <= endLine; line++){
            var text = this.codeMirror.getLine(line);
            var lineStartIndex = this.codeMirror.indexFromPos({
                line: line,
                ch: 0
            });
            // Create line sentinel character if necessary.
            if (text[0] !== LineSentinelCharacter) {
                var attributes = {};
                attributes[(0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_SENTINEL] = true;
                updateFn(attributes);
                this.insertText(lineStartIndex, LineSentinelCharacter, attributes);
            } else this.updateTextAttributes(lineStartIndex, lineStartIndex + 1, updateFn, /*origin=*/ null, /*doLineAttributes=*/ true);
        }
    };
    RichTextCodeMirror.prototype.replaceText = function(start, end, text, attributes, origin) {
        this.changeId_++;
        var newOrigin = RichTextOriginPrefix + this.changeId_;
        this.outstandingChanges_[newOrigin] = {
            origOrigin: origin,
            attributes: attributes
        };
        var cm = this.codeMirror;
        var from = cm.posFromIndex(start);
        var to = typeof end === "number" ? cm.posFromIndex(end) : null;
        cm.replaceRange(text, from, to, newOrigin);
    };
    RichTextCodeMirror.prototype.insertText = function(index, text, attributes, origin) {
        var cm = this.codeMirror;
        var cursor = cm.getCursor();
        var resetCursor = origin == "RTCMADAPTER" && !cm.somethingSelected() && index == cm.indexFromPos(cursor);
        this.replaceText(index, null, text, attributes, origin);
        if (resetCursor) cm.setCursor(cursor);
    };
    RichTextCodeMirror.prototype.removeText = function(start, end, origin) {
        var cm = this.codeMirror;
        cm.replaceRange("", cm.posFromIndex(start), cm.posFromIndex(end), origin);
    };
    RichTextCodeMirror.prototype.insertEntityAtCursor = function(type, info, origin) {
        var cm = this.codeMirror;
        var index = cm.indexFromPos(cm.getCursor("head"));
        this.insertEntityAt(index, type, info, origin);
    };
    RichTextCodeMirror.prototype.insertEntityAt = function(index, type, info, origin) {
        var cm = this.codeMirror;
        this.insertEntity_(index, new (0, $1d816419b17b92b4$export$bc644a473284d944)(type, info), origin);
    };
    RichTextCodeMirror.prototype.insertEntity_ = function(index, entity, origin) {
        this.replaceText(index, null, EntitySentinelCharacter, entity.toAttributes(), origin);
    };
    RichTextCodeMirror.prototype.getAttributeSpans = function(start, end) {
        var spans = [];
        var annotatedSpans = this.annotationList_.getAnnotatedSpansForSpan(new (0, $553edfb3b2f13454$export$5f1714a13ed34c01)(start, end - start));
        for(var i = 0; i < annotatedSpans.length; i++)spans.push({
            length: annotatedSpans[i].length,
            attributes: annotatedSpans[i].annotation.attributes
        });
        return spans;
    };
    RichTextCodeMirror.prototype.end = function() {
        var lastLine = this.codeMirror.lineCount() - 1;
        return this.codeMirror.indexFromPos({
            line: lastLine,
            ch: this.codeMirror.getLine(lastLine).length
        });
    };
    RichTextCodeMirror.prototype.getRange = function(start, end) {
        var from = this.codeMirror.posFromIndex(start), to = this.codeMirror.posFromIndex(end);
        return this.codeMirror.getRange(from, to);
    };
    RichTextCodeMirror.prototype.initAnnotationList_ = function() {
        // Insert empty annotation span for existing content.
        var end = this.end();
        if (end !== 0) this.annotationList_.insertAnnotatedSpan(new (0, $553edfb3b2f13454$export$5f1714a13ed34c01)(0, end), new RichTextAnnotation());
    };
    /**
   * Updates the nodes of an Annotation.
   * @param {Array.<OldAnnotatedSpan>} oldNodes The list of nodes to replace.
   * @param {Array.<NewAnnotatedSpan>} newNodes The new list of nodes.
   */ RichTextCodeMirror.prototype.onAnnotationsChanged_ = function(oldNodes, newNodes) {
        var marker;
        var linesToReMark = {};
        // Update any entities in-place that we can.  This will remove them from the oldNodes/newNodes lists
        // so we don't remove and recreate them below.
        this.tryToUpdateEntitiesInPlace(oldNodes, newNodes);
        for(var i = 0; i < oldNodes.length; i++){
            var attributes = oldNodes[i].annotation.attributes;
            if ((0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_SENTINEL in attributes) linesToReMark[this.codeMirror.posFromIndex(oldNodes[i].pos).line] = true;
            marker = oldNodes[i].getAttachedObject();
            if (marker) marker.clear();
        }
        for(i = 0; i < newNodes.length; i++){
            var annotation = newNodes[i].annotation;
            var forLine = (0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_SENTINEL in annotation.attributes;
            var entity = (0, $92ae9a1f0d0fdb02$export$d1932274993801ff).ENTITY_SENTINEL in annotation.attributes;
            var from = this.codeMirror.posFromIndex(newNodes[i].pos);
            if (forLine) linesToReMark[from.line] = true;
            else if (entity) this.markEntity_(newNodes[i]);
            else {
                var className = this.getClassNameForAttributes_(annotation.attributes);
                if (className !== "") {
                    var to = this.codeMirror.posFromIndex(newNodes[i].pos + newNodes[i].length);
                    marker = this.codeMirror.markText(from, to, {
                        className: className
                    });
                    newNodes[i].attachObject(marker);
                }
            }
        }
        for(var line in linesToReMark){
            this.dirtyLines_.push(this.codeMirror.getLineHandle(Number(line)));
            this.queueLineMarking_();
        }
    };
    RichTextCodeMirror.prototype.tryToUpdateEntitiesInPlace = function(oldNodes, newNodes) {
        // Loop over nodes in reverse order so we can easily splice them out as necessary.
        var oldNodesLen = oldNodes.length;
        while(oldNodesLen--){
            var oldNode = oldNodes[oldNodesLen];
            var newNodesLen = newNodes.length;
            while(newNodesLen--){
                var newNode = newNodes[newNodesLen];
                if (oldNode.pos == newNode.pos && oldNode.length == newNode.length && oldNode.annotation.attributes["ent"] && oldNode.annotation.attributes["ent"] == newNode.annotation.attributes["ent"]) {
                    var entityType = newNode.annotation.attributes["ent"];
                    if (this.entityManager_.entitySupportsUpdate(entityType)) {
                        // Update it in place and remove the change from oldNodes / newNodes so we don't process it below.
                        oldNodes.splice(oldNodesLen, 1);
                        newNodes.splice(newNodesLen, 1);
                        var marker = oldNode.getAttachedObject();
                        marker.update(newNode.annotation.attributes);
                        newNode.attachObject(marker);
                    }
                }
            }
        }
    };
    RichTextCodeMirror.prototype.queueLineMarking_ = function() {
        if (this.lineMarkTimeout_ != null) return;
        var self = this;
        this.lineMarkTimeout_ = setTimeout(function() {
            self.lineMarkTimeout_ = null;
            var dirtyLineNumbers = [];
            for(var i = 0; i < self.dirtyLines_.length; i++){
                var lineNum = self.codeMirror.getLineNumber(self.dirtyLines_[i]);
                dirtyLineNumbers.push(Number(lineNum));
            }
            self.dirtyLines_ = [];
            dirtyLineNumbers.sort(function(a, b) {
                return a - b;
            });
            var lastLineMarked = -1;
            for(i = 0; i < dirtyLineNumbers.length; i++){
                var lineNumber = dirtyLineNumbers[i];
                if (lineNumber > lastLineMarked) lastLineMarked = self.markLineSentinelCharactersForChangedLines_(lineNumber, lineNumber);
            }
        }, 0);
    };
    RichTextCodeMirror.prototype.addStyleWithCSS_ = function(css) {
        var head = document.getElementsByTagName("head")[0], style = document.createElement("style");
        style.type = "text/css";
        if (style.styleSheet) style.styleSheet.cssText = css;
        else style.appendChild(document.createTextNode(css));
        head.appendChild(style);
    };
    RichTextCodeMirror.prototype.getClassNameForAttributes_ = function(attributes) {
        var globalClassName = "";
        for(var attr in attributes){
            var val = attributes[attr];
            if (attr === (0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_SENTINEL) (0, $5df98098fdb33638$export$eab97d15b1788b8d).assert(val === true, "LINE_SENTINEL attribute should be true if it exists.");
            else {
                var className = (this.options_["cssPrefix"] || RichTextClassPrefixDefault) + attr;
                if (val !== true) {
                    // Append "px" to font size if it's missing.
                    // Probably could be removed now as parseHtml automatically adds px when required
                    if (attr === (0, $92ae9a1f0d0fdb02$export$d1932274993801ff).FONT_SIZE && typeof val !== "string") val = val + "px";
                    var classVal = val.toString().toLowerCase().replace(/[^a-z0-9-_]/g, "-");
                    className += "-" + classVal;
                    if (DynamicStyleAttributes[attr]) {
                        if (!StyleCache_[attr]) StyleCache_[attr] = {};
                        if (!StyleCache_[attr][classVal]) {
                            StyleCache_[attr][classVal] = true;
                            var dynStyle = DynamicStyleAttributes[attr];
                            var css = typeof dynStyle === "function" ? dynStyle(val) : dynStyle + ": " + val;
                            var selector = attr == (0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_INDENT ? "pre." + className : "." + className;
                            this.addStyleWithCSS_(selector + " { " + css + " }");
                            // As of v5.48, CodeMirror applies its own pre style which conflicts with ours, so we
                            // need to make sure we add our styles with a more-specific css selector as well.
                            if (attr === (0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_INDENT) {
                                var selector = "pre.CodeMirror-line." + className;
                                this.addStyleWithCSS_(selector + " { " + css + " }");
                            }
                        }
                    }
                }
                globalClassName = globalClassName + " " + className;
            }
        }
        return globalClassName;
    };
    RichTextCodeMirror.prototype.markEntity_ = function(annotationNode) {
        var attributes = annotationNode.annotation.attributes;
        var entity = (0, $1d816419b17b92b4$export$bc644a473284d944).fromAttributes(attributes);
        var cm = this.codeMirror;
        var self = this;
        var markers = [];
        for(var i = 0; i < annotationNode.length; i++){
            var from = cm.posFromIndex(annotationNode.pos + i);
            var to = cm.posFromIndex(annotationNode.pos + i + 1);
            var options = {
                collapsed: true,
                atomic: true,
                inclusiveLeft: false,
                inclusiveRight: false
            };
            var entityHandle = this.createEntityHandle_(entity, annotationNode.pos);
            var element = this.entityManager_.renderToElement(entity, entityHandle);
            if (element) options.replacedWith = element;
            var marker = cm.markText(from, to, options);
            markers.push(marker);
            entityHandle.setMarker(marker);
        }
        annotationNode.attachObject({
            clear: function() {
                for(var i = 0; i < markers.length; i++)markers[i].clear();
            },
            /**
       * Updates the attributes of all the AnnotationNode entities.
       * @param {Object.<string, string>} info The full list of new
       *     attributes to apply.
       */ update: function(info) {
                var entity = (0, $1d816419b17b92b4$export$bc644a473284d944).fromAttributes(info);
                for(var i = 0; i < markers.length; i++)self.entityManager_.updateElement(entity, markers[i].replacedWith);
            }
        });
        // This probably shouldn't be necessary.  There must be a lurking CodeMirror bug.
        this.queueRefresh_();
    };
    RichTextCodeMirror.prototype.queueRefresh_ = function() {
        var self = this;
        if (!this.refreshTimer_) this.refreshTimer_ = setTimeout(function() {
            self.codeMirror.refresh();
            self.refreshTimer_ = null;
        }, 0);
    };
    RichTextCodeMirror.prototype.createEntityHandle_ = function(entity, location) {
        var marker = null;
        var self = this;
        function find() {
            if (marker) {
                var where = marker.find();
                return where ? self.codeMirror.indexFromPos(where.from) : null;
            } else return location;
        }
        function remove() {
            var at = find();
            if (at != null) {
                self.codeMirror.focus();
                self.removeText(at, at + 1);
            }
        }
        /**
     * Updates the attributes of an Entity.  Will call .update() if the entity supports it,
     * else it'll just remove / re-create the entity.
     * @param {Object.<string, string>} info The full list of new
     *     attributes to apply.
     */ function replace(info) {
            var SENTINEL = (0, $92ae9a1f0d0fdb02$export$d1932274993801ff).ENTITY_SENTINEL;
            var PREFIX = SENTINEL + "_";
            var at = find();
            self.updateTextAttributes(at, at + 1, function(attrs) {
                for(var member in attrs)delete attrs[member];
                attrs[SENTINEL] = entity.type;
                for(var attr in info)attrs[PREFIX + attr] = info[attr];
            });
        }
        function setMarker(m) {
            marker = m;
        }
        return {
            find: find,
            remove: remove,
            replace: replace,
            setMarker: setMarker
        };
    };
    RichTextCodeMirror.prototype.lineClassRemover_ = function(lineNum) {
        var cm = this.codeMirror;
        var lineHandle = cm.getLineHandle(lineNum);
        return {
            clear: function() {
                // HACK to remove all classes (since CodeMirror treats this as a regex internally).
                cm.removeLineClass(lineHandle, "text", ".*");
            }
        };
    };
    RichTextCodeMirror.prototype.emptySelection_ = function() {
        var start = this.codeMirror.getCursor("start"), end = this.codeMirror.getCursor("end");
        return start.line === end.line && start.ch === end.ch;
    };
    RichTextCodeMirror.prototype.onCodeMirrorBeforeChange_ = function(cm, change) {
        // Remove LineSentinelCharacters from incoming input (e.g copy/pasting)
        if (change.origin === "+input" || change.origin === "paste") {
            var newText = [];
            for(var i = 0; i < change.text.length; i++){
                var t = change.text[i];
                t = t.replace(new RegExp("[" + LineSentinelCharacter + EntitySentinelCharacter + "]", "g"), "");
                newText.push(t);
            }
            change.update(change.from, change.to, newText);
        }
    };
    function cmpPos(a, b) {
        return a.line - b.line || a.ch - b.ch;
    }
    function posEq(a, b) {
        return cmpPos(a, b) === 0;
    }
    function posLe(a, b) {
        return cmpPos(a, b) <= 0;
    }
    function last(arr) {
        return arr[arr.length - 1];
    }
    function sumLengths(strArr) {
        if (strArr.length === 0) return 0;
        var sum = 0;
        for(var i = 0; i < strArr.length; i++)sum += strArr[i].length;
        return sum + strArr.length - 1;
    }
    RichTextCodeMirror.prototype.onCodeMirrorChange_ = function(cm, cmChanges) {
        // Handle single change objects and linked lists of change objects.
        if (typeof cmChanges.from === "object") {
            var changeArray = [];
            while(cmChanges){
                changeArray.push(cmChanges);
                cmChanges = cmChanges.next;
            }
            cmChanges = changeArray;
        }
        var changes = this.convertCoordinateSystemForChanges_(cmChanges);
        var newChanges = [];
        for(var i = 0; i < changes.length; i++){
            var change = changes[i];
            var start = change.start, end = change.end, text = change.text, removed = change.removed, origin = change.origin;
            // When text with multiple sets of attributes on it is removed, we need to split it into separate remove changes.
            if (removed.length > 0) {
                var oldAnnotationSpans = this.annotationList_.getAnnotatedSpansForSpan(new (0, $553edfb3b2f13454$export$5f1714a13ed34c01)(start, removed.length));
                var removedPos = 0;
                for(var j = 0; j < oldAnnotationSpans.length; j++){
                    var span = oldAnnotationSpans[j];
                    newChanges.push({
                        start: start,
                        end: start + span.length,
                        removedAttributes: span.annotation.attributes,
                        removed: removed.substr(removedPos, span.length),
                        attributes: {},
                        text: "",
                        origin: change.origin
                    });
                    removedPos += span.length;
                }
                this.annotationList_.removeSpan(new (0, $553edfb3b2f13454$export$5f1714a13ed34c01)(start, removed.length));
            }
            if (text.length > 0) {
                var attributes;
                // TODO: Handle 'paste' differently?
                if (change.origin === "+input" || change.origin === "paste") attributes = this.currentAttributes_ || {};
                else if (origin in this.outstandingChanges_) {
                    attributes = this.outstandingChanges_[origin].attributes;
                    origin = this.outstandingChanges_[origin].origOrigin;
                    delete this.outstandingChanges_[origin];
                } else attributes = {};
                this.annotationList_.insertAnnotatedSpan(new (0, $553edfb3b2f13454$export$5f1714a13ed34c01)(start, text.length), new RichTextAnnotation(attributes));
                newChanges.push({
                    start: start,
                    end: start,
                    removedAttributes: {},
                    removed: "",
                    text: text,
                    attributes: attributes,
                    origin: origin
                });
            }
        }
        this.markLineSentinelCharactersForChanges_(cmChanges);
        if (newChanges.length > 0) this.trigger("change", this, newChanges);
    };
    RichTextCodeMirror.prototype.convertCoordinateSystemForChanges_ = function(changes) {
        // We have to convert the positions in the pre-change coordinate system to indexes.
        // CodeMirror's `indexFromPos` method does this for the current state of the editor.
        // We can use the information of a single change object to convert a post-change
        // coordinate system to a pre-change coordinate system. We can now proceed inductively
        // to get a pre-change coordinate system for all changes in the linked list.  A
        // disadvantage of this approach is its complexity `O(n^2)` in the length of the
        // linked list of changes.
        var self = this;
        var indexFromPos = function(pos) {
            return self.codeMirror.indexFromPos(pos);
        };
        function updateIndexFromPos(indexFromPos, change) {
            return function(pos) {
                if (posLe(pos, change.from)) return indexFromPos(pos);
                if (posLe(change.to, pos)) return indexFromPos({
                    line: pos.line + change.text.length - 1 - (change.to.line - change.from.line),
                    ch: change.to.line < pos.line ? pos.ch : change.text.length <= 1 ? pos.ch - (change.to.ch - change.from.ch) + sumLengths(change.text) : pos.ch - change.to.ch + last(change.text).length
                }) + sumLengths(change.removed) - sumLengths(change.text);
                if (change.from.line === pos.line) return indexFromPos(change.from) + pos.ch - change.from.ch;
                return indexFromPos(change.from) + sumLengths(change.removed.slice(0, pos.line - change.from.line)) + 1 + pos.ch;
            };
        }
        var newChanges = [];
        for(var i = changes.length - 1; i >= 0; i--){
            var change = changes[i];
            indexFromPos = updateIndexFromPos(indexFromPos, change);
            var start = indexFromPos(change.from);
            var removedText = change.removed.join("\n");
            var text = change.text.join("\n");
            newChanges.unshift({
                start: start,
                end: start + removedText.length,
                removed: removedText,
                text: text,
                origin: change.origin
            });
        }
        return newChanges;
    };
    /**
   * Detects whether any line sentinel characters were added or removed by the change and if so,
   * re-marks line sentinel characters on the affected range of lines.
   * @param changes
   * @private
   */ RichTextCodeMirror.prototype.markLineSentinelCharactersForChanges_ = function(changes) {
        // TODO: This doesn't handle multiple changes correctly (overlapping, out-of-oder, etc.).
        // But In practice, people using firepad for rich-text editing don't batch multiple changes
        // together, so this isn't quite as bad as it seems.
        var startLine = Number.MAX_VALUE, endLine = -1;
        for(var i = 0; i < changes.length; i++){
            var change = changes[i];
            var line = change.from.line, ch = change.from.ch;
            if (change.removed.length > 1 || change.removed[0].indexOf(LineSentinelCharacter) >= 0) {
                // We removed 1+ newlines or line sentinel characters.
                startLine = Math.min(startLine, line);
                endLine = Math.max(endLine, line);
            }
            if (change.text.length > 1) {
                // 1+ newlines
                startLine = Math.min(startLine, line);
                endLine = Math.max(endLine, line + change.text.length - 1);
            } else if (change.text[0].indexOf(LineSentinelCharacter) >= 0) {
                startLine = Math.min(startLine, line);
                endLine = Math.max(endLine, line);
            }
        }
        // HACK: Because the above code doesn't handle multiple changes correctly, endLine might be invalid.  To
        // avoid crashing, we just cap it at the line count.
        endLine = Math.min(endLine, this.codeMirror.lineCount() - 1);
        this.markLineSentinelCharactersForChangedLines_(startLine, endLine);
    };
    RichTextCodeMirror.prototype.markLineSentinelCharactersForChangedLines_ = function(startLine, endLine) {
        // Back up to first list item.
        if (startLine < Number.MAX_VALUE) while(startLine > 0 && this.lineIsListItemOrIndented_(startLine - 1))startLine--;
        // Advance to last list item.
        if (endLine > -1) {
            var lineCount = this.codeMirror.lineCount();
            while(endLine + 1 < lineCount && this.lineIsListItemOrIndented_(endLine + 1))endLine++;
        }
        // keeps track of the list number at each indent level.
        var listNumber = [];
        var cm = this.codeMirror;
        for(var line = startLine; line <= endLine; line++){
            var text = cm.getLine(line);
            // Remove any existing line classes.
            var lineHandle = cm.getLineHandle(line);
            cm.removeLineClass(lineHandle, "text", ".*");
            if (text.length > 0) {
                var markIndex = text.indexOf(LineSentinelCharacter);
                while(markIndex >= 0){
                    var markStartIndex = markIndex;
                    // Find the end of this series of sentinel characters, and remove any existing markers.
                    while(markIndex < text.length && text[markIndex] === LineSentinelCharacter){
                        var marks = cm.findMarksAt({
                            line: line,
                            ch: markIndex
                        });
                        for(var i = 0; i < marks.length; i++)if (marks[i].isForLineSentinel) marks[i].clear();
                        markIndex++;
                    }
                    this.markLineSentinelCharacters_(line, markStartIndex, markIndex, listNumber);
                    markIndex = text.indexOf(LineSentinelCharacter, markIndex);
                }
            } else // Reset all indents.
            listNumber = [];
        }
        return endLine;
    };
    RichTextCodeMirror.prototype.markLineSentinelCharacters_ = function(line, startIndex, endIndex, listNumber) {
        var cm = this.codeMirror;
        // If the mark is at the beginning of the line and it represents a list element, we need to replace it with
        // the appropriate html element for the list heading.
        var element = null;
        var marker = null;
        var getMarkerLine = function() {
            var span = marker.find();
            return span ? span.from.line : null;
        };
        if (startIndex === 0) {
            var attributes = this.getLineAttributes_(line);
            var listType = attributes[(0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LIST_TYPE];
            var indent = attributes[(0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_INDENT] || 0;
            if (listType && indent === 0) indent = 1;
            while(indent >= listNumber.length)listNumber.push(1);
            if (listType === "o") {
                element = this.makeOrderedListElement_(listNumber[indent]);
                listNumber[indent]++;
            } else if (listType === "u") {
                element = this.makeUnorderedListElement_();
                listNumber[indent] = 1;
            } else if (listType === "t") {
                element = this.makeTodoListElement_(false, getMarkerLine);
                listNumber[indent] = 1;
            } else if (listType === "tc") {
                element = this.makeTodoListElement_(true, getMarkerLine);
                listNumber[indent] = 1;
            }
            var className = this.getClassNameForAttributes_(attributes);
            if (className !== "") this.codeMirror.addLineClass(line, "text", className);
            // Reset deeper indents back to 1.
            listNumber[indent + 1] = 1;
        }
        // Create a marker to cover this series of sentinel characters.
        // NOTE: The reason we treat them as a group (one marker for all subsequent sentinel characters instead of
        // one marker for each sentinel character) is that CodeMirror seems to get angry if we don't.
        var markerOptions = {
            inclusiveLeft: true,
            collapsed: true
        };
        if (element) markerOptions.replacedWith = element;
        var marker = cm.markText({
            line: line,
            ch: startIndex
        }, {
            line: line,
            ch: endIndex
        }, markerOptions);
        // track that it's a line-sentinel character so we can identify it later.
        marker.isForLineSentinel = true;
    };
    RichTextCodeMirror.prototype.makeOrderedListElement_ = function(number) {
        return (0, $5df98098fdb33638$export$eab97d15b1788b8d).elt("div", number + ".", {
            class: "firepad-list-left"
        });
    };
    RichTextCodeMirror.prototype.makeUnorderedListElement_ = function() {
        return (0, $5df98098fdb33638$export$eab97d15b1788b8d).elt("div", "\u2022", {
            class: "firepad-list-left"
        });
    };
    RichTextCodeMirror.prototype.toggleTodo = function(noRemove) {
        var attribute = (0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LIST_TYPE;
        var currentAttributes = this.getCurrentLineAttributes_();
        var newValue;
        if (!(attribute in currentAttributes) || currentAttributes[attribute] !== "t" && currentAttributes[attribute] !== "tc") newValue = "t";
        else if (currentAttributes[attribute] === "t") newValue = "tc";
        else if (currentAttributes[attribute] === "tc") newValue = noRemove ? "t" : false;
        this.setLineAttribute(attribute, newValue);
    };
    RichTextCodeMirror.prototype.makeTodoListElement_ = function(checked, getMarkerLine) {
        var params = {
            type: "checkbox",
            class: "firepad-todo-left"
        };
        if (checked) params["checked"] = true;
        var el = (0, $5df98098fdb33638$export$eab97d15b1788b8d).elt("input", false, params);
        var self = this;
        (0, $5df98098fdb33638$export$eab97d15b1788b8d).on(el, "click", (0, $5df98098fdb33638$export$eab97d15b1788b8d).stopEventAnd(function(e) {
            self.codeMirror.setCursor({
                line: getMarkerLine(),
                ch: 1
            });
            self.toggleTodo(true);
        }));
        return el;
    };
    RichTextCodeMirror.prototype.lineIsListItemOrIndented_ = function(lineNum) {
        var attrs = this.getLineAttributes_(lineNum);
        return (attrs[(0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LIST_TYPE] || false) !== false || (attrs[(0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_INDENT] || 0) !== 0;
    };
    RichTextCodeMirror.prototype.onCursorActivity_ = function() {
        var self = this;
        setTimeout(function() {
            self.updateCurrentAttributes_();
        }, 1);
    };
    RichTextCodeMirror.prototype.getCurrentAttributes_ = function() {
        if (!this.currentAttributes_) this.updateCurrentAttributes_();
        return this.currentAttributes_;
    };
    RichTextCodeMirror.prototype.updateCurrentAttributes_ = function() {
        var cm = this.codeMirror;
        var anchor = cm.indexFromPos(cm.getCursor("anchor")), head = cm.indexFromPos(cm.getCursor("head"));
        var pos = head;
        if (anchor > head) {
            // backwards selection
            // Advance past any newlines or line sentinels.
            while(pos < this.end()){
                var c = this.getRange(pos, pos + 1);
                if (c !== "\n" && c !== LineSentinelCharacter) break;
                pos++;
            }
            if (pos < this.end()) pos++ // since we're going to look at the annotation span to the left to decide what attributes to use.
            ;
        } else // Back up before any newlines or line sentinels.
        while(pos > 0){
            c = this.getRange(pos - 1, pos);
            if (c !== "\n" && c !== LineSentinelCharacter) break;
            pos--;
        }
        var spans = this.annotationList_.getAnnotatedSpansForPos(pos);
        this.currentAttributes_ = {};
        var attributes = {};
        // Use the attributes to the left unless they're line attributes (in which case use the ones to the right.
        if (spans.length > 0 && !((0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_SENTINEL in spans[0].annotation.attributes)) attributes = spans[0].annotation.attributes;
        else if (spans.length > 1) {
            (0, $5df98098fdb33638$export$eab97d15b1788b8d).assert(!((0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_SENTINEL in spans[1].annotation.attributes), "Cursor can't be between two line sentinel characters.");
            attributes = spans[1].annotation.attributes;
        }
        for(var attr in attributes)// Don't copy line or entity attributes.
        if (attr !== "l" && attr !== "lt" && attr !== "li" && attr.indexOf((0, $92ae9a1f0d0fdb02$export$d1932274993801ff).ENTITY_SENTINEL) !== 0) this.currentAttributes_[attr] = attributes[attr];
    };
    RichTextCodeMirror.prototype.getCurrentLineAttributes_ = function() {
        var cm = this.codeMirror;
        var anchor = cm.getCursor("anchor"), head = cm.getCursor("head");
        var line = head.line;
        // If it's a forward selection and the cursor is at the beginning of a line, use the previous line.
        if (head.ch === 0 && anchor.line < head.line) line--;
        return this.getLineAttributes_(line);
    };
    RichTextCodeMirror.prototype.getLineAttributes_ = function(lineNum) {
        var attributes = {};
        var line = this.codeMirror.getLine(lineNum);
        if (line.length > 0 && line[0] === LineSentinelCharacter) {
            var lineStartIndex = this.codeMirror.indexFromPos({
                line: lineNum,
                ch: 0
            });
            var spans = this.annotationList_.getAnnotatedSpansForSpan(new (0, $553edfb3b2f13454$export$5f1714a13ed34c01)(lineStartIndex, 1));
            (0, $5df98098fdb33638$export$eab97d15b1788b8d).assert(spans.length === 1);
            for(var attr in spans[0].annotation.attributes)attributes[attr] = spans[0].annotation.attributes[attr];
        }
        return attributes;
    };
    RichTextCodeMirror.prototype.clearAnnotations_ = function() {
        this.annotationList_.updateSpan(new (0, $553edfb3b2f13454$export$5f1714a13ed34c01)(0, this.end()), function(annotation, length) {
            return new RichTextAnnotation({});
        });
    };
    RichTextCodeMirror.prototype.newline = function() {
        var cm = this.codeMirror;
        var self = this;
        if (!this.emptySelection_()) cm.replaceSelection("\n", "end", "+input");
        else {
            var cursorLine = cm.getCursor("head").line;
            var lineAttributes = this.getLineAttributes_(cursorLine);
            var listType = lineAttributes[(0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LIST_TYPE];
            if (listType && cm.getLine(cursorLine).length === 1) // They hit enter on a line with just a list heading.  Just remove the list heading.
            this.updateLineAttributes(cursorLine, cursorLine, function(attributes) {
                delete attributes[(0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LIST_TYPE];
                delete attributes[(0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_INDENT];
            });
            else {
                cm.replaceSelection("\n", "end", "+input");
                // Copy line attributes forward.
                this.updateLineAttributes(cursorLine + 1, cursorLine + 1, function(attributes) {
                    for(var attr in lineAttributes)attributes[attr] = lineAttributes[attr];
                    // Don't mark new todo items as completed.
                    if (listType === "tc") attributes[(0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LIST_TYPE] = "t";
                    self.trigger("newLine", {
                        line: cursorLine + 1,
                        attr: attributes
                    });
                });
            }
        }
    };
    RichTextCodeMirror.prototype.deleteLeft = function() {
        var cm = this.codeMirror;
        var cursorPos = cm.getCursor("head");
        var lineAttributes = this.getLineAttributes_(cursorPos.line);
        var listType = lineAttributes[(0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LIST_TYPE];
        var indent = lineAttributes[(0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_INDENT];
        var backspaceAtStartOfLine = this.emptySelection_() && cursorPos.ch === 1;
        if (backspaceAtStartOfLine && listType) // They hit backspace at the beginning of a line with a list heading.  Just remove the list heading.
        this.updateLineAttributes(cursorPos.line, cursorPos.line, function(attributes) {
            delete attributes[(0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LIST_TYPE];
            delete attributes[(0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_INDENT];
        });
        else if (backspaceAtStartOfLine && indent && indent > 0) this.unindent();
        else cm.deleteH(-1, "char");
    };
    RichTextCodeMirror.prototype.deleteRight = function() {
        var cm = this.codeMirror;
        var cursorPos = cm.getCursor("head");
        var text = cm.getLine(cursorPos.line);
        var emptyLine = this.areLineSentinelCharacters_(text);
        var nextLineText = cursorPos.line + 1 < cm.lineCount() ? cm.getLine(cursorPos.line + 1) : "";
        if (this.emptySelection_() && emptyLine && nextLineText[0] === LineSentinelCharacter) {
            // Delete the empty line but not the line sentinel character on the next line.
            cm.replaceRange("", {
                line: cursorPos.line,
                ch: 0
            }, {
                line: cursorPos.line + 1,
                ch: 0
            }, "+input");
            // HACK: Once we've deleted this line, the cursor will be between the newline on the previous
            // line and the line sentinel character on the next line, which is an invalid position.
            // CodeMirror tends to therefore move it to the end of the previous line, which is undesired.
            // So we explicitly set it to ch: 0 on the current line, which seems to move it after the line
            // sentinel character(s) as desired.
            // (see https://github.com/firebase/firepad/issues/209).
            cm.setCursor({
                line: cursorPos.line,
                ch: 0
            });
        } else cm.deleteH(1, "char");
    };
    RichTextCodeMirror.prototype.indent = function() {
        this.updateLineAttributesForSelection(function(attributes) {
            var indent = attributes[(0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_INDENT];
            var listType = attributes[(0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LIST_TYPE];
            if (indent) attributes[(0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_INDENT]++;
            else if (listType) // lists are implicitly already indented once.
            attributes[(0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_INDENT] = 2;
            else attributes[(0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_INDENT] = 1;
        });
    };
    RichTextCodeMirror.prototype.unindent = function() {
        this.updateLineAttributesForSelection(function(attributes) {
            var indent = attributes[(0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_INDENT];
            if (indent && indent > 1) attributes[(0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_INDENT] = indent - 1;
            else {
                delete attributes[(0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LIST_TYPE];
                delete attributes[(0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_INDENT];
            }
        });
    };
    RichTextCodeMirror.prototype.getText = function() {
        return this.codeMirror.getValue().replace(new RegExp(LineSentinelCharacter, "g"), "");
    };
    RichTextCodeMirror.prototype.areLineSentinelCharacters_ = function(text) {
        for(var i = 0; i < text.length; i++){
            if (text[i] !== LineSentinelCharacter) return false;
        }
        return true;
    };
    /**
   * Used for the annotations we store in our AnnotationList.
   * @param attributes
   * @constructor
   */ function RichTextAnnotation(attributes) {
        this.attributes = attributes || {};
    }
    RichTextAnnotation.prototype.equals = function(other) {
        if (!(other instanceof RichTextAnnotation)) return false;
        var attr;
        for(attr in this.attributes){
            if (other.attributes[attr] !== this.attributes[attr]) return false;
        }
        for(attr in other.attributes){
            if (other.attributes[attr] !== this.attributes[attr]) return false;
        }
        return true;
    };
    function emptyAttributes(attributes) {
        for(var attr in attributes)return false;
        return true;
    }
    // Bind a method to an object, so it doesn't matter whether you call
    // object.method() directly or pass object.method as a reference to another
    // function.
    function bind(obj, method) {
        var fn = obj[method];
        obj[method] = function() {
            fn.apply(obj, arguments);
        };
    }
    return RichTextCodeMirror;
}();



const $9138ef08a2a5254f$export$769861099ce70fb8 = function(global) {
    function RichTextToolbar(imageInsertionUI) {
        this.imageInsertionUI = imageInsertionUI;
        this.element_ = this.makeElement_();
    }
    (0, $5df98098fdb33638$export$eab97d15b1788b8d).makeEventEmitter(RichTextToolbar, [
        "bold",
        "italic",
        "underline",
        "strike",
        "font",
        "font-size",
        "color",
        "left",
        "center",
        "right",
        "unordered-list",
        "ordered-list",
        "todo-list",
        "indent-increase",
        "indent-decrease",
        "undo",
        "redo",
        "insert-image"
    ]);
    RichTextToolbar.prototype.element = function() {
        return this.element_;
    };
    RichTextToolbar.prototype.makeButton_ = function(eventName, iconName) {
        var self = this;
        iconName = iconName || eventName;
        var btn = (0, $5df98098fdb33638$export$eab97d15b1788b8d).elt("a", [
            (0, $5df98098fdb33638$export$eab97d15b1788b8d).elt("span", "", {
                class: "firepad-tb-" + iconName
            })
        ], {
            class: "firepad-btn"
        });
        (0, $5df98098fdb33638$export$eab97d15b1788b8d).on(btn, "click", (0, $5df98098fdb33638$export$eab97d15b1788b8d).stopEventAnd(function() {
            self.trigger(eventName);
        }));
        return btn;
    };
    RichTextToolbar.prototype.makeElement_ = function() {
        var self = this;
        var font = this.makeFontDropdown_();
        var fontSize = this.makeFontSizeDropdown_();
        var color = this.makeColorDropdown_();
        var toolbarOptions = [
            (0, $5df98098fdb33638$export$eab97d15b1788b8d).elt("div", [
                font
            ], {
                class: "firepad-btn-group"
            }),
            (0, $5df98098fdb33638$export$eab97d15b1788b8d).elt("div", [
                fontSize
            ], {
                class: "firepad-btn-group"
            }),
            (0, $5df98098fdb33638$export$eab97d15b1788b8d).elt("div", [
                color
            ], {
                class: "firepad-btn-group"
            }),
            (0, $5df98098fdb33638$export$eab97d15b1788b8d).elt("div", [
                self.makeButton_("bold"),
                self.makeButton_("italic"),
                self.makeButton_("underline"),
                self.makeButton_("strike", "strikethrough")
            ], {
                class: "firepad-btn-group"
            }),
            (0, $5df98098fdb33638$export$eab97d15b1788b8d).elt("div", [
                self.makeButton_("unordered-list", "list-2"),
                self.makeButton_("ordered-list", "numbered-list"),
                self.makeButton_("todo-list", "list")
            ], {
                class: "firepad-btn-group"
            }),
            (0, $5df98098fdb33638$export$eab97d15b1788b8d).elt("div", [
                self.makeButton_("indent-decrease"),
                self.makeButton_("indent-increase")
            ], {
                class: "firepad-btn-group"
            }),
            (0, $5df98098fdb33638$export$eab97d15b1788b8d).elt("div", [
                self.makeButton_("left", "paragraph-left"),
                self.makeButton_("center", "paragraph-center"),
                self.makeButton_("right", "paragraph-right")
            ], {
                class: "firepad-btn-group"
            }),
            (0, $5df98098fdb33638$export$eab97d15b1788b8d).elt("div", [
                self.makeButton_("undo"),
                self.makeButton_("redo")
            ], {
                class: "firepad-btn-group"
            })
        ];
        if (self.imageInsertionUI) toolbarOptions.push((0, $5df98098fdb33638$export$eab97d15b1788b8d).elt("div", [
            self.makeButton_("insert-image")
        ], {
            class: "firepad-btn-group"
        }));
        var toolbarWrapper = (0, $5df98098fdb33638$export$eab97d15b1788b8d).elt("div", toolbarOptions, {
            class: "firepad-toolbar-wrapper"
        });
        var toolbar = (0, $5df98098fdb33638$export$eab97d15b1788b8d).elt("div", null, {
            class: "firepad-toolbar"
        });
        toolbar.appendChild(toolbarWrapper);
        return toolbar;
    };
    RichTextToolbar.prototype.makeFontDropdown_ = function() {
        // NOTE: There must be matching .css styles in firepad.css.
        var fonts = [
            "Arial",
            "Comic Sans MS",
            "Courier New",
            "Impact",
            "Times New Roman",
            "Verdana"
        ];
        var items = [];
        for(var i = 0; i < fonts.length; i++){
            var content = (0, $5df98098fdb33638$export$eab97d15b1788b8d).elt("span", fonts[i]);
            content.setAttribute("style", "font-family:" + fonts[i]);
            items.push({
                content: content,
                value: fonts[i]
            });
        }
        return this.makeDropdown_("Font", "font", items);
    };
    RichTextToolbar.prototype.makeFontSizeDropdown_ = function() {
        // NOTE: There must be matching .css styles in firepad.css.
        var sizes = [
            9,
            10,
            12,
            14,
            18,
            24,
            32,
            42
        ];
        var items = [];
        for(var i = 0; i < sizes.length; i++){
            var content = (0, $5df98098fdb33638$export$eab97d15b1788b8d).elt("span", sizes[i].toString());
            content.setAttribute("style", "font-size:" + sizes[i] + "px; line-height:" + (sizes[i] - 6) + "px;");
            items.push({
                content: content,
                value: sizes[i]
            });
        }
        return this.makeDropdown_("Size", "font-size", items, "px");
    };
    RichTextToolbar.prototype.makeColorDropdown_ = function() {
        var colors = [
            "black",
            "red",
            "green",
            "blue",
            "yellow",
            "cyan",
            "magenta",
            "grey"
        ];
        var items = [];
        for(var i = 0; i < colors.length; i++){
            var content = (0, $5df98098fdb33638$export$eab97d15b1788b8d).elt("div");
            content.className = "firepad-color-dropdown-item";
            content.setAttribute("style", "background-color:" + colors[i]);
            items.push({
                content: content,
                value: colors[i]
            });
        }
        return this.makeDropdown_("Color", "color", items);
    };
    RichTextToolbar.prototype.makeDropdown_ = function(title, eventName, items, value_suffix) {
        value_suffix = value_suffix || "";
        var self = this;
        var button = (0, $5df98098fdb33638$export$eab97d15b1788b8d).elt("a", title + " \u25be", {
            class: "firepad-btn firepad-dropdown"
        });
        var list = (0, $5df98098fdb33638$export$eab97d15b1788b8d).elt("ul", [], {
            class: "firepad-dropdown-menu"
        });
        button.appendChild(list);
        var isShown = false;
        function showDropdown() {
            if (!isShown) {
                list.style.display = "block";
                (0, $5df98098fdb33638$export$eab97d15b1788b8d).on(document, "click", hideDropdown, /*capture=*/ true);
                isShown = true;
            }
        }
        var justDismissed = false;
        function hideDropdown() {
            if (isShown) {
                list.style.display = "";
                (0, $5df98098fdb33638$export$eab97d15b1788b8d).off(document, "click", hideDropdown, /*capture=*/ true);
                isShown = false;
            }
            // HACK so we can avoid re-showing the dropdown if you click on the dropdown header to dismiss it.
            justDismissed = true;
            setTimeout(function() {
                justDismissed = false;
            }, 0);
        }
        function addItem(content, value) {
            if (typeof content !== "object") content = document.createTextNode(String(content));
            var element = (0, $5df98098fdb33638$export$eab97d15b1788b8d).elt("a", [
                content
            ]);
            (0, $5df98098fdb33638$export$eab97d15b1788b8d).on(element, "click", (0, $5df98098fdb33638$export$eab97d15b1788b8d).stopEventAnd(function() {
                hideDropdown();
                self.trigger(eventName, value + value_suffix);
            }));
            list.appendChild(element);
        }
        for(var i = 0; i < items.length; i++){
            var content = items[i].content, value = items[i].value;
            addItem(content, value);
        }
        (0, $5df98098fdb33638$export$eab97d15b1788b8d).on(button, "click", (0, $5df98098fdb33638$export$eab97d15b1788b8d).stopEventAnd(function() {
            if (!justDismissed) showDropdown();
        }));
        return button;
    };
    return RichTextToolbar;
}();


// Written from a file generated by CoffeeScript 2.7.0


const $4cacfb9bebf98d31$export$8ecdeaeed6359410 = function() {
    class ACEAdapter {
        constructor(aceInstance){
            var ref;
            this.onChange = this.onChange.bind(this);
            this.onBlur = this.onBlur.bind(this);
            this.onFocus = this.onFocus.bind(this);
            this.onCursorActivity = this.onCursorActivity.bind(this);
            this.ace = aceInstance;
            this.aceSession = this.ace.getSession();
            this.aceDoc = this.aceSession.getDocument();
            this.aceDoc.setNewLineMode("unix");
            this.grabDocumentState();
            this.ace.on("change", this.onChange);
            this.ace.on("blur", this.onBlur);
            this.ace.on("focus", this.onFocus);
            this.aceSession.selection.on("changeCursor", this.onCursorActivity);
            if (this.aceRange == null) this.aceRange = ((ref = ace.require) != null ? ref : undefined)("ace/range").Range;
        }
        grabDocumentState() {
            this.lastDocLines = this.aceDoc.getAllLines();
            return this.lastCursorRange = this.aceSession.selection.getRange();
        }
        // Removes all event listeners from the ACE editor instance
        detach() {
            this.ace.removeListener("change", this.onChange);
            this.ace.removeListener("blur", this.onBlur);
            this.ace.removeListener("focus", this.onFocus);
            return this.aceSession.selection.removeListener("changeCursor", this.onCursorActivity);
        }
        onChange(change) {
            var pair;
            if (!this.ignoreChanges) {
                pair = this.operationFromACEChange(change);
                this.trigger("change", ...pair);
                return this.grabDocumentState();
            }
        }
        onBlur() {
            if (this.ace.selection.isEmpty()) return this.trigger("blur");
        }
        onFocus() {
            return this.trigger("focus");
        }
        onCursorActivity() {
            return setTimeout(()=>{
                return this.trigger("cursorActivity");
            }, 0);
        }
        // Converts an ACE change object into a TextOperation and its inverse
        // and returns them as a two-element array.
        operationFromACEChange(change) {
            var action, delete_op, delta, insert_op, ref, restLength, start, text;
            if (change.data) {
                // Ace < 1.2.0
                delta = change.data;
                if ((ref = delta.action) === "insertLines" || ref === "removeLines") {
                    text = delta.lines.join("\n") + "\n";
                    action = delta.action.replace("Lines", "");
                } else {
                    text = delta.text.replace(this.aceDoc.getNewLineCharacter(), "\n");
                    action = delta.action.replace("Text", "");
                }
                start = this.indexFromPos(delta.range.start);
            } else {
                // Ace 1.2.0+
                text = change.lines.join("\n");
                start = this.indexFromPos(change.start);
            }
            restLength = this.lastDocLines.join("\n").length - start;
            if (change.action === "remove") restLength -= text.length;
            insert_op = new (0, $8c3149d24978582c$export$b3669f5ec3045f43)().retain(start).insert(text).retain(restLength);
            delete_op = new (0, $8c3149d24978582c$export$b3669f5ec3045f43)().retain(start).delete(text).retain(restLength);
            if (change.action === "remove") return [
                delete_op,
                insert_op
            ];
            else return [
                insert_op,
                delete_op
            ];
        }
        // Apply an operation to an ACE instance.
        applyOperationToACE(operation) {
            var from, index, j, len, op, range, ref, to;
            index = 0;
            ref = operation.ops;
            for(j = 0, len = ref.length; j < len; j++){
                op = ref[j];
                if (op.isRetain()) index += op.chars;
                else if (op.isInsert()) {
                    this.aceDoc.insert(this.posFromIndex(index), op.text);
                    index += op.text.length;
                } else if (op.isDelete()) {
                    from = this.posFromIndex(index);
                    to = this.posFromIndex(index + op.chars);
                    range = this.aceRange.fromPoints(from, to);
                    this.aceDoc.remove(range);
                }
            }
            return this.grabDocumentState();
        }
        posFromIndex(index) {
            var j, len, line, ref, row;
            ref = this.aceDoc.$lines;
            for(row = j = 0, len = ref.length; j < len; row = ++j){
                line = ref[row];
                if (index <= line.length) break;
                index -= line.length + 1;
            }
            return {
                row: row,
                column: index
            };
        }
        indexFromPos(pos, lines) {
            var i, index, j, ref;
            if (lines == null) lines = this.lastDocLines;
            index = 0;
            for(i = j = 0, ref = pos.row; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j)index += this.lastDocLines[i].length + 1;
            return index += pos.column;
        }
        getValue() {
            return this.aceDoc.getValue();
        }
        getCursor() {
            var e, e2, end, start;
            try {
                start = this.indexFromPos(this.aceSession.selection.getRange().start, this.aceDoc.$lines);
                end = this.indexFromPos(this.aceSession.selection.getRange().end, this.aceDoc.$lines);
            } catch (error) {
                e = error;
                try {
                    // If the new range doesn't work (sometimes with setValue), we'll use the old range
                    start = this.indexFromPos(this.lastCursorRange.start);
                    end = this.indexFromPos(this.lastCursorRange.end);
                } catch (error) {
                    e2 = error;
                    console.log("Couldn't figure out the cursor range:", e2, "-- setting it to 0:0.");
                    [start, end] = [
                        0,
                        0
                    ];
                }
            }
            if (start > end) [start, end] = [
                end,
                start
            ];
            return new (0, $b1bab01e82df7ca2$export$b6a79797ad180576)(start, end);
        }
        setCursor(cursor) {
            var end, start;
            start = this.posFromIndex(cursor.position);
            end = this.posFromIndex(cursor.selectionEnd);
            if (cursor.position > cursor.selectionEnd) [start, end] = [
                end,
                start
            ];
            return this.aceSession.selection.setSelectionRange(new this.aceRange(start.row, start.column, end.row, end.column));
        }
        setOtherCursor(cursor, color, clientId) {
            var clazz, css, cursorRange, end, justCursor, self, start;
            if (this.otherCursors == null) this.otherCursors = {};
            cursorRange = this.otherCursors[clientId];
            if (cursorRange) {
                cursorRange.start.detach();
                cursorRange.end.detach();
                this.aceSession.removeMarker(cursorRange.id);
            }
            start = this.posFromIndex(cursor.position);
            end = this.posFromIndex(cursor.selectionEnd);
            if (cursor.selectionEnd < cursor.position) [start, end] = [
                end,
                start
            ];
            clazz = `other-client-selection-${color.replace("#", "")}`;
            justCursor = cursor.position === cursor.selectionEnd;
            if (justCursor) clazz = clazz.replace("selection", "cursor");
            css = `.${clazz} {
  position: absolute;
  background-color: ${justCursor ? "transparent" : color};
  border-left: 2px solid ${color};
}`;
            this.addStyleRule(css);
            this.otherCursors[clientId] = cursorRange = new this.aceRange(start.row, start.column, end.row, end.column);
            // Hack this specific range to, when clipped, return an empty range that
            // pretends to not be empty. This lets us draw markers at the ends of lines.
            // This might be brittle in the future.
            self = this;
            cursorRange.clipRows = function() {
                var range;
                range = self.aceRange.prototype.clipRows.apply(this, arguments);
                range.isEmpty = function() {
                    return false;
                };
                return range;
            };
            cursorRange.start = this.aceDoc.createAnchor(cursorRange.start);
            cursorRange.end = this.aceDoc.createAnchor(cursorRange.end);
            cursorRange.id = this.aceSession.addMarker(cursorRange, clazz, "text");
            return {
                // Return something with a clear method to mimic expected API from CodeMirror
                clear: ()=>{
                    cursorRange.start.detach();
                    cursorRange.end.detach();
                    return this.aceSession.removeMarker(cursorRange.id);
                }
            };
        }
        addStyleRule(css) {
            var styleElement;
            if (typeof document === "undefined" || document === null) return;
            if (!this.addedStyleRules) {
                this.addedStyleRules = {};
                styleElement = document.createElement("style");
                document.documentElement.getElementsByTagName("head")[0].appendChild(styleElement);
                this.addedStyleSheet = styleElement.sheet;
            }
            if (this.addedStyleRules[css]) return;
            this.addedStyleRules[css] = true;
            return this.addedStyleSheet.insertRule(css, 0);
        }
        registerCallbacks(callbacks) {
            this.callbacks = callbacks;
        }
        trigger(event, ...args) {
            var ref, ref1;
            return (ref = this.callbacks) != null ? (ref1 = ref[event]) != null ? ref1.apply(this, args) : void 0 : void 0;
        }
        applyOperation(operation) {
            if (!operation.isNoop()) this.ignoreChanges = true;
            this.applyOperationToACE(operation);
            return this.ignoreChanges = false;
        }
        registerUndo(undoFn) {
            return this.ace.undo = undoFn;
        }
        registerRedo(redoFn) {
            return this.ace.redo = redoFn;
        }
        invertOperation(operation) {
            // TODO: Optimize to avoid copying entire text?
            return operation.invert(this.getValue());
        }
    }
    ACEAdapter.prototype.ignoreChanges = false;
    return ACEAdapter;
}();




"use strict";
/**
 * @function getCSS - For Internal Usage Only
 * @param {String} clazz - CSS Class Name
 * @param {String} bgColor - Background Color
 * @param {String} color - Font Color
 * @returns CSS Style Rules according to Parameters
 */ var $d138e4c6cc56aece$var$getCSS = function getCSS(clazz, bgColor, color) {
    return "." + clazz + " {\n  position: relative;\n" + "background-color: " + bgColor + ";\n" + "border-left: 2px solid " + color + ";\n}";
};
/**
 * @function addStyleRule - For Internal Usage Only
 * @desc Creates style element in document head and pushed all the style rules
 * @param {String} clazz - CSS Class Name
 * @param {String} css - CSS Style Rules
 */ var $d138e4c6cc56aece$var$addStyleRule = function addStyleRule(clazz, css) {
    /** House Keeping */ if (typeof document === "undefined" || document === null) return false;
    /** Add style rules only once */ if (this.addedStyleRules.indexOf(clazz) === -1) {
        var styleElement = document.createElement("style");
        var styleSheet = document.createTextNode(css);
        styleElement.appendChild(styleSheet);
        document.head.appendChild(styleElement);
        this.addedStyleRules.push(clazz);
    }
};
/**
 * Monaco Adapter
 * Create Pipe between Firebase and Monaco Text Editor
 */ var $d138e4c6cc56aece$export$92b0a973cd77f423 = function() {
    /**
   * @constructor MonacoEditor
   * @param {MonacoEditor} monacoInstance - Editor Instance
   * @prop {MonacoEditor} monaco - Monaco Instance passed as Parameter
   * @prop {MonacoITextModel} monacoModel - Data Model of the Monaco Instance
   * @prop {string[]} lastDocLines - Text for all Lines in the Editor
   * @prop {MonacoSelection} lastCursorRange - Primary Selection of the Editor
   * @prop {function} onChange - Change Event Handler bound Local Object
   * @prop {function} onBlur - Blur Event Handler bound Local Object
   * @prop {function} onFocus - Focus Event Handler bound Local Object
   * @prop {function} onCursorActivity - Cursor Activity Handler bound Local Object
   * @prop {Boolean} ignoreChanges - Should Avoid OnChange Event Handling
   * @prop {MonacoIDisposable} changeHandler - Event Handler for Model Content Change
   * @prop {MonacoIDisposable} didBlurHandler - Event Handler for Focus Lost on Editor Text/Widget
   * @prop {MonacoIDisposable} didFocusHandler - Event Handler for Focus Gain on Editor Text/Widget
   * @prop {MonacoIDisposable} didChangeCursorPositionHandler - Event Handler for Cursor Position Change
   */ function MonacoAdapter(monacoInstance) {
        /** House Keeping */ // Make sure this looks like a valid monaco instance.
        if (!monacoInstance || typeof monacoInstance.getModel !== "function") throw new Error("MonacoAdapter: Incorrect Parameter Recieved in constructor, expected valid Monaco Instance");
        /** Monaco Member Variables */ this.monaco = monacoInstance;
        this.monacoModel = this.monaco.getModel();
        this.lastDocLines = this.monacoModel.getLinesContent();
        this.lastCursorRange = this.monaco.getSelection();
        /** Monaco Editor Configurations */ this.callbacks = {};
        this.otherCursors = [];
        this.addedStyleRules = [];
        this.ignoreChanges = false;
        /** Adapter Callback Functions */ this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onCursorActivity = this.onCursorActivity.bind(this);
        /** Editor Callback Handler */ this.changeHandler = this.monaco.onDidChangeModelContent(this.onChange);
        this.didBlurHandler = this.monaco.onDidBlurEditorWidget(this.onBlur);
        this.didFocusHandler = this.monaco.onDidFocusEditorWidget(this.onFocus);
        this.didChangeCursorPositionHandler = this.monaco.onDidChangeCursorPosition(this.onCursorActivity);
    }
    /**
   * @method detach - Clears an Instance of Editor Adapter
   */ MonacoAdapter.prototype.detach = function detach() {
        this.changeHandler.dispose();
        this.didBlurHandler.dispose();
        this.didFocusHandler.dispose();
        this.didChangeCursorPositionHandler.dispose();
    };
    /**
   * @method getCursor - Get current cursor position
   * @returns Firepad Cursor object
   */ MonacoAdapter.prototype.getCursor = function getCursor() {
        var selection = this.monaco.getSelection();
        /** Fallback to last cursor change */ if (typeof selection === "undefined" || selection === null) selection = this.lastCursorRange;
        /** Obtain selection indexes */ var startPos = selection.getStartPosition();
        var endPos = selection.getEndPosition();
        var start = this.monacoModel.getOffsetAt(startPos);
        var end = this.monacoModel.getOffsetAt(endPos);
        /** If Selection is Inversed */ if (start > end) {
            var _ref = [
                end,
                start
            ];
            start = _ref[0];
            end = _ref[1];
        }
        /** Return cursor position */ return new (0, $b1bab01e82df7ca2$export$b6a79797ad180576)(start, end);
    };
    /**
   * @method setCursor - Set Selection on Monaco Editor Instance
   * @param {Object} cursor - Cursor Position (start and end)
   * @param {Number} cursor.position - Starting Position of the Cursor
   * @param {Number} cursor.selectionEnd - Ending Position of the Cursor
   */ MonacoAdapter.prototype.setCursor = function setCursor(cursor) {
        var position = cursor.position;
        var selectionEnd = cursor.selectionEnd;
        var start = this.monacoModel.getPositionAt(position);
        var end = this.monacoModel.getPositionAt(selectionEnd);
        /** If selection is inversed */ if (position > selectionEnd) {
            var _ref = [
                end,
                start
            ];
            start = _ref[0];
            end = _ref[1];
        }
        /** Create Selection in the Editor */ this.monaco.setSelection(new monaco.Range(start.lineNumber, start.column, end.lineNumber, end.column));
    };
    /**
   * @method setOtherCursor - Set Remote Selection on Monaco Editor
   * @param {Number} cursor.position - Starting Position of the Selection
   * @param {Number} cursor.selectionEnd - Ending Position of the Selection
   * @param {String} color - Hex Color codes for Styling
   * @param {any} clientID - ID number of the Remote Client
   */ MonacoAdapter.prototype.setOtherCursor = function setOtherCursor(cursor, color, clientID) {
        /** House Keeping */ if (typeof cursor !== "object" || typeof cursor.position !== "number" || typeof cursor.selectionEnd !== "number") return false;
        if (typeof color !== "string" || !color.match(/^#[a-fA-F0-9]{3,6}$/)) return false;
        /** Extract Positions */ var position = cursor.position;
        var selectionEnd = cursor.selectionEnd;
        if (position < 0 || selectionEnd < 0) return false;
        /** Fetch Client Cursor Information */ var otherCursor = this.otherCursors.find(function(cursor) {
            return cursor.clientID === clientID;
        });
        /** Initialize empty array, if client does not exist */ if (!otherCursor) {
            otherCursor = {
                clientID: clientID,
                decoration: []
            };
            this.otherCursors.push(otherCursor);
        }
        /** Remove Earlier Decorations, if any, or initialize empty decor */ otherCursor.decoration = this.monaco.deltaDecorations(otherCursor.decoration, []);
        var clazz = "other-client-selection-" + color.replace("#", "");
        var css, ret;
        if (position === selectionEnd) {
            /** Show only cursor */ clazz = clazz.replace("selection", "cursor");
            /** Generate Style rules and add them to document */ css = $d138e4c6cc56aece$var$getCSS(clazz, "transparent", color);
            ret = $d138e4c6cc56aece$var$addStyleRule.call(this, clazz, css);
        } else {
            /** Generate Style rules and add them to document */ css = $d138e4c6cc56aece$var$getCSS(clazz, color, color);
            ret = $d138e4c6cc56aece$var$addStyleRule.call(this, clazz, css);
        }
        /** Return if failed to add css */ if (ret == false) console.log("Monaco Adapter: Failed to add some css style.\nPlease make sure you're running on supported environment.");
        /** Get co-ordinate position in Editor */ var start = this.monacoModel.getPositionAt(position);
        var end = this.monacoModel.getPositionAt(selectionEnd);
        /** Selection is inversed */ if (position > selectionEnd) {
            var _ref = [
                end,
                start
            ];
            start = _ref[0];
            end = _ref[1];
        }
        /** Add decoration to the Editor */ otherCursor.decoration = this.monaco.deltaDecorations(otherCursor.decoration, [
            {
                range: new monaco.Range(start.lineNumber, start.column, end.lineNumber, end.column),
                options: {
                    className: clazz
                }
            }
        ]);
        /** Clear cursor method */ var _this = this;
        return {
            clear: function clear() {
                otherCursor.decoration = _this.monaco.deltaDecorations(otherCursor.decoration, []);
            }
        };
    };
    /**
   * @method registerCallbacks - Assign callback functions to internal property
   * @param {function[]} callbacks - Set of callback functions
   */ MonacoAdapter.prototype.registerCallbacks = function registerCallbacks(callbacks) {
        this.callbacks = Object.assign({}, this.callbacks, callbacks);
    };
    /**
   * @method registerUndo
   * @param {function} callback - Callback Handler for Undo Event
   */ MonacoAdapter.prototype.registerUndo = function registerUndo(callback) {
        if (typeof callback === "function") this.callbacks.undo = callback;
        else throw new Error("MonacoAdapter: registerUndo method expects a callback function in parameter");
    };
    /**
   * @method registerRedo
   * @param {function} callback - Callback Handler for Redo Event
   */ MonacoAdapter.prototype.registerRedo = function registerRedo(callback) {
        if (typeof callback === "function") this.callbacks.redo = callback;
        else throw new Error("MonacoAdapter: registerRedo method expects a callback function in parameter");
    };
    /**
   * @method operationFromMonacoChanges - Convert Monaco Changes to OT.js Ops
   * @param {Object} change - Change in Editor
   * @param {string} content - Last Editor Content
   * @param {Number} offset - Offset between changes of same event
   * @returns Pair of Operation and Inverse
   * Note: OT.js Operation expects the cursor to be at the end of content
   */ MonacoAdapter.prototype.operationFromMonacoChanges = function operationFromMonacoChanges(change, content, offset) {
        /** Change Informations */ var text = change.text;
        var rangeLength = change.rangeLength;
        var rangeOffset = change.rangeOffset;
        /** Additional SEEK distance */ var restLength = content.length + offset - rangeOffset;
        /** Declare OT.js Operation Variables */ var change_op, inverse_op, replaced_text;
        if (text.length === 0 && rangeLength > 0) {
            /** Delete Operation */ replaced_text = content.slice(rangeOffset, rangeOffset + rangeLength);
            change_op = new (0, $8c3149d24978582c$export$b3669f5ec3045f43)().retain(rangeOffset).delete(rangeLength).retain(restLength - rangeLength);
            inverse_op = new (0, $8c3149d24978582c$export$b3669f5ec3045f43)().retain(rangeOffset).insert(replaced_text).retain(restLength - rangeLength);
        } else if (text.length > 0 && rangeLength > 0) {
            /** Replace Operation */ replaced_text = content.slice(rangeOffset, rangeOffset + rangeLength);
            change_op = new (0, $8c3149d24978582c$export$b3669f5ec3045f43)().retain(rangeOffset).delete(rangeLength).insert(text).retain(restLength - rangeLength);
            inverse_op = new (0, $8c3149d24978582c$export$b3669f5ec3045f43)().retain(rangeOffset).delete(text.length).insert(replaced_text).retain(restLength - rangeLength);
        } else {
            /** Insert Operation */ change_op = new (0, $8c3149d24978582c$export$b3669f5ec3045f43)().retain(rangeOffset).insert(text).retain(restLength);
            inverse_op = new (0, $8c3149d24978582c$export$b3669f5ec3045f43)().retain(rangeOffset).delete(text).retain(restLength);
        }
        return [
            change_op,
            inverse_op
        ];
    };
    /**
   * @method onChange - OnChange Event Handler
   * @param {Object} event - OnChange Event Delegate
   */ MonacoAdapter.prototype.onChange = function onChange(event) {
        var _this = this;
        if (!this.ignoreChanges) {
            var content = this.lastDocLines.join(this.monacoModel.getEOL());
            var offset = 0;
            /** If no change information recieved */ if (!event.changes) {
                var op = new (0, $8c3149d24978582c$export$b3669f5ec3045f43)().retain(content.length);
                this.trigger("change", op, op);
            }
            /** Iterate through all changes */ event.changes.forEach(function(change) {
                var pair = _this.operationFromMonacoChanges(change, content, offset);
                offset += pair[0].targetLength - pair[0].baseLength;
                _this.trigger.apply(_this, [
                    "change"
                ].concat(pair));
            });
            /** Update Editor Content */ this.lastDocLines = this.monacoModel.getLinesContent();
        }
    };
    /**
   * @method trigger - Event Handler
   * @param {string} event - Event name
   * @param  {...any} args - Callback arguments
   */ MonacoAdapter.prototype.trigger = function trigger(event) {
        if (!this.callbacks.hasOwnProperty(event)) return;
        var action = this.callbacks[event];
        var args = [];
        if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
        action.apply(null, args);
    };
    /**
   * @method onBlur - Blur event handler
   */ MonacoAdapter.prototype.onBlur = function onBlur() {
        if (this.monaco.getSelection().isEmpty()) this.trigger("blur");
    };
    /**
   * @method onFocus - Focus event handler
   */ MonacoAdapter.prototype.onFocus = function onFocus() {
        this.trigger("focus");
    };
    /**
   * @method onCursorActivity - CursorActivity event handler
   */ MonacoAdapter.prototype.onCursorActivity = function onCursorActivity() {
        var _this = this;
        setTimeout(function() {
            return _this.trigger("cursorActivity");
        }, 1);
    };
    /**
   * @method applyOperation
   * @param {Operation} operation - OT.js Operation Object
   */ MonacoAdapter.prototype.applyOperation = function applyOperation(operation) {
        if (!operation.isNoop()) this.ignoreChanges = true;
        /** Get Operations List */ var opsList = operation.ops;
        var index = 0;
        var _this = this;
        opsList.forEach(function(op) {
            /** Retain Operation */ if (op.isRetain()) index += op.chars;
            else if (op.isInsert()) {
                /** Insert Operation */ var pos = _this.monacoModel.getPositionAt(index);
                _this.monaco.executeEdits("my-source", [
                    {
                        range: new monaco.Range(pos.lineNumber, pos.column, pos.lineNumber, pos.column),
                        text: op.text,
                        forceMoveMarkers: true
                    }
                ]);
                index += op.text.length;
            } else if (op.isDelete()) {
                /** Delete Operation */ var from = _this.monacoModel.getPositionAt(index);
                var to = _this.monacoModel.getPositionAt(index + op.chars);
                _this.monaco.executeEdits("my-source", [
                    {
                        range: new monaco.Range(from.lineNumber, from.column, to.lineNumber, to.column),
                        text: "",
                        forceMoveMarkers: true
                    }
                ]);
            }
        });
        /** Update Editor Content and Reset Config */ this.lastDocLines = this.monacoModel.getLinesContent();
        this.ignoreChanges = false;
    };
    /**
   * @method invertOperation
   * @param {Operation} operation - OT.js Operation Object
   */ MonacoAdapter.prototype.invertOperation = function invertOperation(operation) {
        operation.invert(this.getValue());
    };
    return MonacoAdapter;
}();












const $c5088864b58856ac$export$7b51929e2b398ed4 = function() {
    function Headless(refOrPath) {
        // Allow calling without new.
        if (!(this instanceof Headless)) return new Headless(refOrPath);
        var ref;
        if (typeof refOrPath === "string") ref = (0, $42ddf94e6f3c0a26$export$2e2bcd8739ae039).database().refFromURL(refOrPath);
        else ref = refOrPath;
        this.entityManager_ = new (0, $ba56c4a0d7a50403$export$c7b7134fd828a5)();
        this.firebaseAdapter_ = new (0, $0ff6f7b2241dad9a$export$79ad5a80dedb955b)(ref);
        this.ready_ = false;
        this.zombie_ = false;
    }
    Headless.prototype.getDocument = function(callback) {
        var self = this;
        if (self.ready_) return callback(self.firebaseAdapter_.getDocument());
        self.firebaseAdapter_.on("ready", function() {
            self.ready_ = true;
            callback(self.firebaseAdapter_.getDocument());
        });
    };
    Headless.prototype.getText = function(callback) {
        if (this.zombie_) throw new Error("You can't use a firepad.Headless after calling dispose()!");
        this.getDocument(function(doc) {
            var text = doc.apply("");
            // Strip out any special characters from Rich Text formatting
            for(var key in 0, $92ae9a1f0d0fdb02$export$b0a31bc53419a761)text = text.replace(new RegExp((0, $92ae9a1f0d0fdb02$export$b0a31bc53419a761)[key], "g"), "");
            callback(text);
        });
    };
    Headless.prototype.setText = function(text, callback) {
        if (this.zombie_) throw new Error("You can't use a firepad.Headless after calling dispose()!");
        var op = (0, $8c3149d24978582c$export$b3669f5ec3045f43)().insert(text);
        this.sendOperationWithRetry(op, callback);
    };
    Headless.prototype.initializeFakeDom = function(callback) {
        if (typeof (0, $c52e54ea9957251e$export$f65ca476c09acec0)() === "object") callback();
        else {
            const require = $parcel$global.require;
            const jsdom = require("jsdom");
            const { JSDOM: JSDOM } = jsdom;
            const { window: window } = new JSDOM("<head></head><body></body>");
            if ((0, $c52e54ea9957251e$export$f65ca476c09acec0)()) {
                // Return if we've already made a jsdom to avoid making more than one
                // This would be easier with promises but we want to avoid introducing
                // another dependency for just headless mode.
                window.close();
                return callback();
            }
            (0, $c52e54ea9957251e$export$65af85b1e66fbfaf)(window.document);
            callback();
        }
    };
    Headless.prototype.getHtml = function(callback) {
        var self = this;
        if (this.zombie_) throw new Error("You can't use a firepad.Headless after calling dispose()!");
        self.initializeFakeDom(function() {
            self.getDocument(function(doc) {
                callback((0, $e87cd51840064746$export$84445af632c3c500)(doc, self.entityManager_));
            });
        });
    };
    Headless.prototype.setHtml = function(html, callback) {
        var self = this;
        if (this.zombie_) throw new Error("You can't use a firepad.Headless after calling dispose()!");
        self.initializeFakeDom(function() {
            var textPieces = (0, $0e7c7a2651049be8$export$f6e976a3dcab89f5)(html, self.entityManager_);
            var inserts = (0, $ffe3e1aa8856b10b$export$74debc3f43f46569)(true, textPieces);
            var op = new (0, $8c3149d24978582c$export$b3669f5ec3045f43)();
            for(var i = 0; i < inserts.length; i++)op.insert(inserts[i].string, inserts[i].attributes);
            self.sendOperationWithRetry(op, callback);
        });
    };
    Headless.prototype.sendOperationWithRetry = function(operation, callback) {
        var self = this;
        self.getDocument(function(doc) {
            var op = operation.clone()["delete"](doc.targetLength);
            self.firebaseAdapter_.sendOperation(op, function(err, committed) {
                if (committed) {
                    if (typeof callback !== "undefined") callback(null, committed);
                } else self.sendOperationWithRetry(operation, callback);
            });
        });
    };
    Headless.prototype.dispose = function() {
        this.zombie_ = true // We've been disposed.  No longer valid to do anything.
        ;
        this.firebaseAdapter_.dispose();
    };
    return Headless;
}();


// import { CodeMirror6Adapter } from "./codemirror6-adapter.js"
// TODO - change this hack to a real solution
// https://stackoverflow.com/questions/3277182/how-to-get-the-global-object-in-javascript
let $1ceaeeb694392773$var$global;
try {
    $1ceaeeb694392773$var$global = Function("return this")();
} catch (e) {
    $1ceaeeb694392773$var$global = window;
}
const $1ceaeeb694392773$var$Firepad = function() {
    var { LIST_TYPE: LIST_TYPE } = (0, $63b49bdfe1946b13$export$c991cff49f3b4249);
    var CodeMirror = $1ceaeeb694392773$var$global.CodeMirror;
    var ace = $1ceaeeb694392773$var$global.ace;
    var monaco = $1ceaeeb694392773$var$global.monaco;
    function Firepad(ref, place, options) {
        if (!(this instanceof Firepad)) return new Firepad(ref, place, options);
        if (!CodeMirror && !ace && !$1ceaeeb694392773$var$global.monaco && !(place.type === "CodeMirror6")) throw new Error("Couldn't find CodeMirror, ACE or Monaco.  Did you forget to include codemirror.js/ace.js or import monaco?");
        this.zombie_ = false;
        if (place.type === "CodeMirror6") {
            this.codeMirror6_ = this.editor_ = place.editor;
            const curValue = this.codeMirror6_.state.doc.toString();
            if (curValue !== "") throw new Error("Can't initialize Firepad with a CodeMirror6 instance that already contains text.");
        } else if (CodeMirror && place instanceof CodeMirror) {
            this.codeMirror_ = this.editor_ = place;
            var curValue = this.codeMirror_.getValue();
            if (curValue !== "") throw new Error("Can't initialize Firepad with a CodeMirror instance that already contains text.");
        } else if (ace && place && place.session instanceof ace.EditSession) {
            this.ace_ = this.editor_ = place;
            curValue = this.ace_.getValue();
            if (curValue !== "") throw new Error("Can't initialize Firepad with an ACE instance that already contains text.");
        } else if ($1ceaeeb694392773$var$global.monaco && place && place instanceof $1ceaeeb694392773$var$global.monaco.constructor) {
            monaco = $1ceaeeb694392773$var$global.monaco;
            this.monaco_ = this.editor_ = place;
            curValue = this.monaco_.getValue();
            if (curValue !== "") throw new Error("Can't initialize Firepad with a Monaco instance that already contains text.");
        } else this.codeMirror_ = this.editor_ = new CodeMirror(place);
        var editorWrapper;
        if (this.codeMirror6_) editorWrapper = this.codeMirror6_.dom;
        else if (this.codeMirror_) editorWrapper = this.codeMirror_.getWrapperElement();
        else if (this.ace_) editorWrapper = this.ace_.container;
        else editorWrapper = this.monaco_.getDomNode();
        // var editorWrapper = this.codeMirror_ ? this.codeMirror_.getWrapperElement() : this.ace_.container;
        this.firepadWrapper_ = (0, $5df98098fdb33638$export$eab97d15b1788b8d).elt("div", null, {
            class: "firepad"
        });
        editorWrapper.parentNode.replaceChild(this.firepadWrapper_, editorWrapper);
        this.firepadWrapper_.appendChild(editorWrapper);
        // Provide an easy way to get the firepad instance associated with this CodeMirror instance.
        this.editor_.firepad = this;
        this.options_ = options || {};
        if (this.getOption("richTextShortcuts", false)) {
            if (!CodeMirror.keyMap["richtext"]) this.initializeKeyMap_();
            this.codeMirror_.setOption("keyMap", "richtext");
            this.firepadWrapper_.className += " firepad-richtext";
        }
        this.imageInsertionUI = this.getOption("imageInsertionUI", true);
        if (this.getOption("richTextToolbar", false)) {
            this.addToolbar_();
            this.firepadWrapper_.className += " firepad-richtext firepad-with-toolbar";
        }
        this.addPoweredByLogo_();
        // Now that we've mucked with CodeMirror, refresh it.
        if (this.codeMirror_) this.codeMirror_.refresh();
        var userId = this.getOption("userId", ref.push().key);
        var userColor = this.getOption("userColor", colorFromUserId(userId));
        this.entityManager_ = new (0, $ba56c4a0d7a50403$export$c7b7134fd828a5)();
        this.firebaseAdapter_ = new (0, $0ff6f7b2241dad9a$export$79ad5a80dedb955b)(ref, userId, userColor);
        // if (this.codeMirror6_) {
        //   this.editorAdapter_ = new CodeMirror6Adapter(
        //     this.codeMirror6_,
        //     this.options_
        //   )
        // } else if (this.codeMirror_) {
        if (this.codeMirror_) {
            this.richTextCodeMirror_ = new (0, $15380d2091620678$export$e6b06cc764358bfa)(this.codeMirror_, this.entityManager_, {
                cssPrefix: "firepad-"
            });
            this.editorAdapter_ = new (0, $bb26a380d7bea108$export$9882b6cd53285b96)(this.richTextCodeMirror_);
        } else if (this.ace_) this.editorAdapter_ = new (0, $4cacfb9bebf98d31$export$8ecdeaeed6359410)(this.ace_);
        else this.editorAdapter_ = new (0, $d138e4c6cc56aece$export$92b0a973cd77f423)(this.monaco_);
        this.client_ = new (0, $9697d3dc5736b1f3$export$74e430f5ecc76f59)(this.firebaseAdapter_, this.editorAdapter_);
        var self = this;
        this.firebaseAdapter_.on("cursor", function() {
            self.trigger.apply(self, [
                "cursor"
            ].concat([].slice.call(arguments)));
        });
        if (this.codeMirror_) this.richTextCodeMirror_.on("newLine", function() {
            self.trigger.apply(self, [
                "newLine"
            ].concat([].slice.call(arguments)));
        });
        this.firebaseAdapter_.on("ready", function() {
            self.ready_ = true;
            if (self.ace_) self.editorAdapter_.grabDocumentState();
            if (self.monaco_) self.editorAdapter_.grabDocumentState();
            var defaultText = self.getOption("defaultText", null);
            if (defaultText && self.isHistoryEmpty()) self.setText(defaultText);
            self.trigger("ready");
        });
        this.client_.on("synced", function(isSynced) {
            self.trigger("synced", isSynced);
        });
        // Hack for IE8 to make font icons work more reliably.
        // http://stackoverflow.com/questions/9809351/ie8-css-font-face-fonts-only-working-for-before-content-on-over-and-sometimes
        if (navigator.appName == "Microsoft Internet Explorer" && navigator.userAgent.match(/MSIE 8\./)) window.onload = function() {
            var head = document.getElementsByTagName("head")[0], style = document.createElement("style");
            style.type = "text/css";
            style.styleSheet.cssText = ":before,:after{content:none !important;}";
            head.appendChild(style);
            setTimeout(function() {
                head.removeChild(style);
            }, 0);
        };
    }
    (0, $5df98098fdb33638$export$eab97d15b1788b8d).makeEventEmitter(Firepad);
    // For readability, these are the primary "constructors", even though right now they're just aliases for Firepad.
    Firepad.fromCodeMirror = Firepad;
    Firepad.fromACE = Firepad;
    Firepad.fromMonaco = Firepad;
    Firepad.fromCodeMirror6 = (ref, editor, ...e)=>Firepad(ref, {
            type: "CodeMirror6",
            editor: editor
        }, ...e);
    Firepad.prototype.dispose = function() {
        this.zombie_ = true // We've been disposed.  No longer valid to do anything.
        ;
        // Unwrap the editor.
        var editorWrapper;
        if (this.codeMirror_) editorWrapper = this.codeMirror_.getWrapperElement();
        else if (this.ace_) editorWrapper = this.ace_.container;
        else editorWrapper = this.monaco_.getDomNode();
        this.firepadWrapper_.removeChild(editorWrapper);
        this.firepadWrapper_.parentNode.replaceChild(editorWrapper, this.firepadWrapper_);
        this.editor_.firepad = null;
        if (this.codeMirror_ && this.codeMirror_.getOption("keyMap") === "richtext") this.codeMirror_.setOption("keyMap", "default");
        this.firebaseAdapter_.dispose();
        this.editorAdapter_.detach();
        if (this.richTextCodeMirror_) this.richTextCodeMirror_.detach();
    };
    Firepad.prototype.setUserId = function(userId) {
        this.firebaseAdapter_.setUserId(userId);
    };
    Firepad.prototype.setUserColor = function(color) {
        this.firebaseAdapter_.setColor(color);
    };
    Firepad.prototype.getText = function() {
        this.assertReady_("getText");
        if (this.codeMirror6_) return this.codeMirror6_.state.doc.toString();
        if (this.codeMirror_) return this.richTextCodeMirror_.getText();
        else if (this.ace_) return this.ace_.getSession().getDocument().getValue();
        else return this.monaco_.getModel().getValue();
    };
    Firepad.prototype.setText = function(textPieces) {
        this.assertReady_("setText");
        if (this.codeMirror6_) return this.codeMirror6_.dispatch({
            changes: {
                from: 0,
                to: this.codeMirror6_.state.doc.length,
                insert: textPieces
            }
        });
        else if (this.monaco_) return this.monaco_.getModel().setValue(textPieces);
        else if (this.ace_) return this.ace_.getSession().getDocument().setValue(textPieces);
        else {
            // HACK: Hide CodeMirror during setText to prevent lots of extra renders.
            this.codeMirror_.getWrapperElement().style.display = "none";
            this.codeMirror_.setValue("");
            this.insertText(0, textPieces);
            this.codeMirror_.getWrapperElement().style.display = "";
            this.codeMirror_.refresh();
        }
        this.editorAdapter_.setCursor({
            position: 0,
            selectionEnd: 0
        });
    };
    Firepad.prototype.insertTextAtCursor = function(textPieces) {
        this.insertText(this.codeMirror_.indexFromPos(this.codeMirror_.getCursor()), textPieces);
    };
    Firepad.prototype.insertText = function(index, textPieces) {
        (0, $5df98098fdb33638$export$eab97d15b1788b8d).assert(!this.ace_, "Not supported for ace yet.");
        (0, $5df98098fdb33638$export$eab97d15b1788b8d).assert(!this.monaco_, "Not supported for monaco yet.");
        this.assertReady_("insertText");
        // Wrap it in an array if it's not already.
        if (Object.prototype.toString.call(textPieces) !== "[object Array]") textPieces = [
            textPieces
        ];
        var self = this;
        self.codeMirror_.operation(function() {
            // HACK: We should check if we're actually at the beginning of a line; but checking for index == 0 is sufficient
            // for the setText() case.
            var atNewLine = index === 0;
            var inserts = (0, $ffe3e1aa8856b10b$export$74debc3f43f46569)(atNewLine, textPieces);
            for(var i = 0; i < inserts.length; i++){
                var string = inserts[i].string;
                var attributes = inserts[i].attributes;
                self.richTextCodeMirror_.insertText(index, string, attributes);
                index += string.length;
            }
        });
    };
    Firepad.prototype.getOperationForSpan = function(start, end) {
        var text = this.richTextCodeMirror_.getRange(start, end);
        var spans = this.richTextCodeMirror_.getAttributeSpans(start, end);
        var pos = 0;
        var op = new (0, $8c3149d24978582c$export$b3669f5ec3045f43)();
        for(var i = 0; i < spans.length; i++){
            op.insert(text.substr(pos, spans[i].length), spans[i].attributes);
            pos += spans[i].length;
        }
        return op;
    };
    Firepad.prototype.getHtml = function() {
        return this.getHtmlFromRange(null, null);
    };
    Firepad.prototype.getHtmlFromSelection = function() {
        var startPos = this.codeMirror_.getCursor("start"), endPos = this.codeMirror_.getCursor("end");
        var startIndex = this.codeMirror_.indexFromPos(startPos), endIndex = this.codeMirror_.indexFromPos(endPos);
        return this.getHtmlFromRange(startIndex, endIndex);
    };
    Firepad.prototype.getHtmlFromRange = function(start, end) {
        this.assertReady_("getHtmlFromRange");
        var doc = start != null && end != null ? this.getOperationForSpan(start, end) : this.getOperationForSpan(0, this.codeMirror_.getValue().length);
        return (0, $e87cd51840064746$export$84445af632c3c500)(doc, this.entityManager_);
    };
    Firepad.prototype.insertHtml = function(index, html) {
        var lines = (0, $0e7c7a2651049be8$export$f6e976a3dcab89f5)(html, this.entityManager_);
        this.insertText(index, lines);
    };
    Firepad.prototype.insertHtmlAtCursor = function(html) {
        this.insertHtml(this.codeMirror_.indexFromPos(this.codeMirror_.getCursor()), html);
    };
    Firepad.prototype.setHtml = function(html) {
        var lines = (0, $0e7c7a2651049be8$export$f6e976a3dcab89f5)(html, this.entityManager_);
        this.setText(lines);
    };
    Firepad.prototype.isHistoryEmpty = function() {
        this.assertReady_("isHistoryEmpty");
        return this.firebaseAdapter_.isHistoryEmpty();
    };
    Firepad.prototype.bold = function() {
        this.richTextCodeMirror_.toggleAttribute((0, $92ae9a1f0d0fdb02$export$d1932274993801ff).BOLD);
        this.codeMirror_.focus();
    };
    Firepad.prototype.italic = function() {
        this.richTextCodeMirror_.toggleAttribute((0, $92ae9a1f0d0fdb02$export$d1932274993801ff).ITALIC);
        this.codeMirror_.focus();
    };
    Firepad.prototype.underline = function() {
        this.richTextCodeMirror_.toggleAttribute((0, $92ae9a1f0d0fdb02$export$d1932274993801ff).UNDERLINE);
        this.codeMirror_.focus();
    };
    Firepad.prototype.strike = function() {
        this.richTextCodeMirror_.toggleAttribute((0, $92ae9a1f0d0fdb02$export$d1932274993801ff).STRIKE);
        this.codeMirror_.focus();
    };
    Firepad.prototype.fontSize = function(size) {
        this.richTextCodeMirror_.setAttribute((0, $92ae9a1f0d0fdb02$export$d1932274993801ff).FONT_SIZE, size);
        this.codeMirror_.focus();
    };
    Firepad.prototype.font = function(font) {
        this.richTextCodeMirror_.setAttribute((0, $92ae9a1f0d0fdb02$export$d1932274993801ff).FONT, font);
        this.codeMirror_.focus();
    };
    Firepad.prototype.color = function(color) {
        this.richTextCodeMirror_.setAttribute((0, $92ae9a1f0d0fdb02$export$d1932274993801ff).COLOR, color);
        this.codeMirror_.focus();
    };
    Firepad.prototype.highlight = function() {
        this.richTextCodeMirror_.toggleAttribute((0, $92ae9a1f0d0fdb02$export$d1932274993801ff).BACKGROUND_COLOR, "rgba(255,255,0,.65)");
        this.codeMirror_.focus();
    };
    Firepad.prototype.align = function(alignment) {
        if (alignment !== "left" && alignment !== "center" && alignment !== "right") throw new Error('align() must be passed "left", "center", or "right".');
        this.richTextCodeMirror_.setLineAttribute((0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LINE_ALIGN, alignment);
        this.codeMirror_.focus();
    };
    Firepad.prototype.orderedList = function() {
        this.richTextCodeMirror_.toggleLineAttribute((0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LIST_TYPE, "o");
        this.codeMirror_.focus();
    };
    Firepad.prototype.unorderedList = function() {
        this.richTextCodeMirror_.toggleLineAttribute((0, $92ae9a1f0d0fdb02$export$d1932274993801ff).LIST_TYPE, "u");
        this.codeMirror_.focus();
    };
    Firepad.prototype.todo = function() {
        this.richTextCodeMirror_.toggleTodo();
        this.codeMirror_.focus();
    };
    Firepad.prototype.newline = function() {
        this.richTextCodeMirror_.newline();
    };
    Firepad.prototype.deleteLeft = function() {
        this.richTextCodeMirror_.deleteLeft();
    };
    Firepad.prototype.deleteRight = function() {
        this.richTextCodeMirror_.deleteRight();
    };
    Firepad.prototype.indent = function() {
        this.richTextCodeMirror_.indent();
        this.codeMirror_.focus();
    };
    Firepad.prototype.unindent = function() {
        this.richTextCodeMirror_.unindent();
        this.codeMirror_.focus();
    };
    Firepad.prototype.undo = function() {
        this.codeMirror_.undo();
    };
    Firepad.prototype.redo = function() {
        this.codeMirror_.redo();
    };
    Firepad.prototype.insertEntity = function(type, info, origin) {
        this.richTextCodeMirror_.insertEntityAtCursor(type, info, origin);
    };
    Firepad.prototype.insertEntityAt = function(index, type, info, origin) {
        this.richTextCodeMirror_.insertEntityAt(index, type, info, origin);
    };
    Firepad.prototype.registerEntity = function(type, options) {
        this.entityManager_.register(type, options);
    };
    Firepad.prototype.getOption = function(option, def) {
        return option in this.options_ ? this.options_[option] : def;
    };
    Firepad.prototype.assertReady_ = function(funcName) {
        if (!this.ready_) throw new Error('You must wait for the "ready" event before calling ' + funcName + ".");
        if (this.zombie_) throw new Error("You can't use a Firepad after calling dispose()!  [called " + funcName + "]");
    };
    Firepad.prototype.makeImageDialog_ = function() {
        this.makeDialog_("img", "Insert image url");
    };
    Firepad.prototype.makeDialog_ = function(id, placeholder) {
        var self = this;
        var hideDialog = function() {
            var dialog = document.getElementById("overlay");
            dialog.style.visibility = "hidden";
            self.firepadWrapper_.removeChild(dialog);
        };
        var cb = function() {
            var dialog = document.getElementById("overlay");
            dialog.style.visibility = "hidden";
            var src = document.getElementById(id).value;
            if (src !== null) self.insertEntity(id, {
                src: src
            });
            self.firepadWrapper_.removeChild(dialog);
        };
        var input = (0, $5df98098fdb33638$export$eab97d15b1788b8d).elt("input", null, {
            class: "firepad-dialog-input",
            id: id,
            type: "text",
            placeholder: placeholder,
            autofocus: "autofocus"
        });
        var submit = (0, $5df98098fdb33638$export$eab97d15b1788b8d).elt("a", "Submit", {
            class: "firepad-btn",
            id: "submitbtn"
        });
        (0, $5df98098fdb33638$export$eab97d15b1788b8d).on(submit, "click", (0, $5df98098fdb33638$export$eab97d15b1788b8d).stopEventAnd(cb));
        var cancel = (0, $5df98098fdb33638$export$eab97d15b1788b8d).elt("a", "Cancel", {
            class: "firepad-btn"
        });
        (0, $5df98098fdb33638$export$eab97d15b1788b8d).on(cancel, "click", (0, $5df98098fdb33638$export$eab97d15b1788b8d).stopEventAnd(hideDialog));
        var buttonsdiv = (0, $5df98098fdb33638$export$eab97d15b1788b8d).elt("div", [
            submit,
            cancel
        ], {
            class: "firepad-btn-group"
        });
        var div = (0, $5df98098fdb33638$export$eab97d15b1788b8d).elt("div", [
            input,
            buttonsdiv
        ], {
            class: "firepad-dialog-div"
        });
        var dialog = (0, $5df98098fdb33638$export$eab97d15b1788b8d).elt("div", [
            div
        ], {
            class: "firepad-dialog",
            id: "overlay"
        });
        this.firepadWrapper_.appendChild(dialog);
    };
    Firepad.prototype.addToolbar_ = function() {
        this.toolbar = new (0, $9138ef08a2a5254f$export$769861099ce70fb8)(this.imageInsertionUI);
        this.toolbar.on("undo", this.undo, this);
        this.toolbar.on("redo", this.redo, this);
        this.toolbar.on("bold", this.bold, this);
        this.toolbar.on("italic", this.italic, this);
        this.toolbar.on("underline", this.underline, this);
        this.toolbar.on("strike", this.strike, this);
        this.toolbar.on("font-size", this.fontSize, this);
        this.toolbar.on("font", this.font, this);
        this.toolbar.on("color", this.color, this);
        this.toolbar.on("left", function() {
            this.align("left");
        }, this);
        this.toolbar.on("center", function() {
            this.align("center");
        }, this);
        this.toolbar.on("right", function() {
            this.align("right");
        }, this);
        this.toolbar.on("ordered-list", this.orderedList, this);
        this.toolbar.on("unordered-list", this.unorderedList, this);
        this.toolbar.on("todo-list", this.todo, this);
        this.toolbar.on("indent-increase", this.indent, this);
        this.toolbar.on("indent-decrease", this.unindent, this);
        this.toolbar.on("insert-image", this.makeImageDialog_, this);
        this.firepadWrapper_.insertBefore(this.toolbar.element(), this.firepadWrapper_.firstChild);
    };
    Firepad.prototype.addPoweredByLogo_ = function() {
        var poweredBy = (0, $5df98098fdb33638$export$eab97d15b1788b8d).elt("a", null, {
            class: "powered-by-firepad"
        });
        poweredBy.setAttribute("href", "http://www.firepad.io/");
        poweredBy.setAttribute("target", "_blank");
        this.firepadWrapper_.appendChild(poweredBy);
    };
    Firepad.prototype.initializeKeyMap_ = function() {
        function binder(fn) {
            return function(cm) {
                // HACK: CodeMirror will often call our key handlers within a cm.operation(), and that
                // can mess us up (we rely on events being triggered synchronously when we make CodeMirror
                // edits).  So to escape any cm.operation(), we do a setTimeout.
                setTimeout(function() {
                    fn.call(cm.firepad);
                }, 0);
            };
        }
        CodeMirror.keyMap["richtext"] = {
            "Ctrl-B": binder(this.bold),
            "Cmd-B": binder(this.bold),
            "Ctrl-I": binder(this.italic),
            "Cmd-I": binder(this.italic),
            "Ctrl-U": binder(this.underline),
            "Cmd-U": binder(this.underline),
            "Ctrl-H": binder(this.highlight),
            "Cmd-H": binder(this.highlight),
            Enter: binder(this.newline),
            Delete: binder(this.deleteRight),
            Backspace: binder(this.deleteLeft),
            Tab: binder(this.indent),
            "Shift-Tab": binder(this.unindent),
            fallthrough: [
                "default"
            ]
        };
    };
    function colorFromUserId(userId) {
        var a = 1;
        for(var i = 0; i < userId.length; i++)a = 17 * (a + userId.charCodeAt(i)) % 360;
        var hue = a / 360;
        return hsl2hex(hue, 1, 0.75);
    }
    function rgb2hex(r, g, b) {
        function digits(n) {
            var m = Math.round(255 * n).toString(16);
            return m.length === 1 ? "0" + m : m;
        }
        return "#" + digits(r) + digits(g) + digits(b);
    }
    function hsl2hex(h, s, l) {
        if (s === 0) return rgb2hex(l, l, l);
        var var2 = l < 0.5 ? l * (1 + s) : l + s - s * l;
        var var1 = 2 * l - var2;
        var hue2rgb = function(hue) {
            if (hue < 0) hue += 1;
            if (hue > 1) hue -= 1;
            if (6 * hue < 1) return var1 + (var2 - var1) * 6 * hue;
            if (2 * hue < 1) return var2;
            if (3 * hue < 2) return var1 + (var2 - var1) * 6 * (2 / 3 - hue);
            return var1;
        };
        return rgb2hex(hue2rgb(h + 1 / 3), hue2rgb(h), hue2rgb(h - 1 / 3));
    }
    return Firepad;
}();
Object.assign($1ceaeeb694392773$var$Firepad, {
    Formatting: // Export Text classes
    $cd3ebf067d86332d$export$5bb3fe2f313a36ca,
    Text: $91f3c0029e0bc586$export$5f1af8db9871e1d6,
    Entity: $1d816419b17b92b4$export$bc644a473284d944,
    LineFormatting: $63b49bdfe1946b13$export$c991cff49f3b4249,
    Line: $602b0556d8a1c74a$export$17d680238e50603e,
    TextOperation: $8c3149d24978582c$export$b3669f5ec3045f43,
    RichTextCodeMirrorAdapter: // Export adapters
    $bb26a380d7bea108$export$9882b6cd53285b96,
    ACEAdapter: $4cacfb9bebf98d31$export$8ecdeaeed6359410,
    MonacoAdapter: $d138e4c6cc56aece$export$92b0a973cd77f423
});
var $1ceaeeb694392773$export$2e2bcd8739ae039 = $1ceaeeb694392773$var$Firepad;



var $3UKyI = parcelRequire("3UKyI");
const $3b6f5d857e82afe2$var$cookies = new (0, $9bfae0a1a4fe450e$export$2e2bcd8739ae039)();
// Add all scopes to base app so that everything is added on login
const $3b6f5d857e82afe2$var$BASE_GOOGLE_SCOPE = "profile https://www.googleapis.com/auth/drive.readonly https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/drive.install";
const $3b6f5d857e82afe2$var$BASE_GOOGLE_TOKEN_INFO_URL = "https://oauth2.googleapis.com/tokeninfo";
class $3b6f5d857e82afe2$export$2e2bcd8739ae039 extends (0, $6wXVr.Component) {
    constructor(){
        super();
        this.youTubeModalId = 'youTubeModal';
        this.searchWebModalId = 'searchWebModal';
        this.enterURLModalId = 'enterURLModal';
        // Binding is required in order for methods of the class to have access to "this".
        this.authorize = this.authorize.bind(this);
        this.authorizeWithPopUp = this.authorizeWithPopUp.bind(this);
        this.afterAuthorized = this.afterAuthorized.bind(this);
        this.loadGoogleClientApiAndAuthorize = this.loadGoogleClientApiAndAuthorize.bind(this);
        this.loadFileBasedOnUrl = this.loadFileBasedOnUrl.bind(this);
        this.loadFile = this.loadFile.bind(this);
        this.onFileLoaded = this.onFileLoaded.bind(this);
        this.closeFile = this.closeFile.bind(this);
        this.getMetadata = this.getMetadata.bind(this);
        this.createDoc = this.createDoc.bind(this);
        this.createDriveFile = this.createDriveFile.bind(this);
        this.updateDriveFile = this.updateDriveFile.bind(this);
        this.createRealtimeFile = this.createRealtimeFile.bind(this);
        this.shareFile = this.shareFile.bind(this);
        this.doNewDoc = this.doNewDoc.bind(this);
        this.handleNewDocButton = this.handleNewDocButton.bind(this);
        this.handleCopyButton = this.handleCopyButton.bind(this);
        this.copyFile = this.copyFile.bind(this);
        this.renameDoc = this.renameDoc.bind(this);
        this.updateModifiedTime = this.updateModifiedTime.bind(this);
        this.isFileTypeValid = this.isFileTypeValid.bind(this);
        this.toggleAside = this.toggleAside.bind(this);
        this.openEnterURLModal = this.openEnterURLModal.bind(this);
        this.openYouTubeModal = this.openYouTubeModal.bind(this);
        this.closeYouTubeModal = this.closeYouTubeModal.bind(this);
        this.handleEnterURLSave = this.handleEnterURLSave.bind(this);
        this.handleYouTubeSave = this.handleYouTubeSave.bind(this);
        this.handleImageSave = this.handleImageSave.bind(this);
        this.openSearchWebModal = this.openSearchWebModal.bind(this);
        this.contentUpdated = this.contentUpdated.bind(this);
        this.updateOpenedTime = this.updateOpenedTime.bind(this);
        this.updateFileName = this.updateFileName.bind(this);
        this.updateAccountType = this.updateAccountType.bind(this);
        this.addGoogleScope = this.addGoogleScope.bind(this);
        this.hasGrantedScopesAll = this.hasGrantedScopesAll.bind(this);
        this.handleAccessTokenExpired = this.handleAccessTokenExpired.bind(this);
        this.checkAccessTokenBeforeInitGooglePicker = this.checkAccessTokenBeforeInitGooglePicker.bind(this);
        this.state = {
            // Set up speech to text
            recognition: new (0, $bb4d3f4172bdb318$export$2e2bcd8739ae039)(),
            loading: true,
            authorized: false,
            loginRequired: false,
            createPending: null,
            copyPending: null,
            fileIdLoaded: false,
            fileId: null,
            newFileId: null,
            fileType: null,
            fileName: null,
            fileTypeValid: false,
            metadata: null,
            currentUser: null,
            error: 0,
            hosting: undefined !== (0, $220c2d58964ba595$export$fcc0626890c55730).hosting ? (0, $220c2d58964ba595$export$fcc0626890c55730).hosting : undefined,
            storage: "https://storage.googleapis.com/storage/v1/b/corgi-dev.appspot.com/o/",
            asideOpen: false,
            toggleAside: this.toggleAside,
            openYouTubeModal: this.openYouTubeModal,
            openSearchWebModal: this.openSearchWebModal,
            openEnterURLModal: this.openEnterURLModal,
            contentUpdated: this.contentUpdated,
            updateOpenedTime: this.updateOpenedTime,
            updateFileName: this.updateFileName,
            updateAccountType: this.updateAccountType,
            addGoogleScope: this.addGoogleScope,
            hasGrantedScopesAll: this.hasGrantedScopesAll,
            handleAccessTokenExpired: this.handleAccessTokenExpired,
            checkAccessTokenBeforeInitGooglePicker: this.checkAccessTokenBeforeInitGooglePicker
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).setTexts((0, $198066ba87364cec$export$2e2bcd8739ae039));
        window.tracker = new (0, $5198a75994f13aea$export$2e2bcd8739ae039)();
        window.Firepad = (0, $1ceaeeb694392773$export$2e2bcd8739ae039);
        window.Firepad.Headless = (0, $c5088864b58856ac$export$7b51929e2b398ed4);
        //Init realtime db connection and relative api
        new (0, $220c2d58964ba595$export$2e2bcd8739ae039).ReatimeDbUtils();
        window.firebase = (0, $42ddf94e6f3c0a26$export$2e2bcd8739ae039);
        //window.storage = new Storage();
        // possibly decouple using something like https://github.com/tylermcginnis/re-base
        this.childRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createRef();
    }
    render() {
        const shareMethod = this.shareFile; // (this.state.metadata && this.state.metadata.capabilities.canShare) ? this.shareFile : null;
        //const header = <Header />;
        const footer = this.state.loading ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $cdcd31d564710d43$export$2e2bcd8739ae039), {
            valid: this.state.fileTypeValid
        });
        const main = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $bc34d6c4fed03120$export$2e2bcd8739ae039), {
            valid: this.state.fileTypeValid,
            shareMethod: shareMethod,
            loadDocMethod: this.loadFileBasedOnUrl,
            newDocButtonMethod: this.handleNewDocButton,
            createDocMethod: this.createDoc,
            copyButtonMethod: this.handleCopyButton,
            copyDocMethod: this.copyFile,
            renameDocMethod: this.renameDoc,
            authorizeWithPopUp: this.authorizeWithPopUp,
            filename: this.state.metadata ? this.state.fileName : null
        });
        if (this.state.hasError) // You can render any custom fallback UI
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $0893f709ff34df68$export$2e2bcd8739ae039), null, "Something went wrong.");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $0f09ddde1e7ea4cb$export$20d2b7652facc723), {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $164886e74c3a88c8$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $02aae4bdeb427b3e$export$2e2bcd8739ae039), {
            main: main,
            footer: footer,
            shareMethod: shareMethod,
            newDocButtonMethod: this.handleNewDocButton,
            createDocMethod: this.createDoc,
            copyButtonMethod: this.handleCopyButton,
            copyDocMethod: this.handleCopyButton,
            renameDocMethod: this.renameDoc
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $f33014965c9c8d29$export$2e2bcd8739ae039), {
            ref: this.childRef,
            currentUser: this.state.currentUser
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $a9fae44aeb551fe1$export$2e2bcd8739ae039), {
            id: this.youTubeModalId,
            saveMethod: this.handleYouTubeSave
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $e9bcbf5b98dbad96$export$2e2bcd8739ae039), {
            id: this.searchWebModalId,
            saveMethod: this.handleImageSave
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $b33ca804eb3e243c$export$2e2bcd8739ae039), {
            id: this.enterURLModalId,
            saveMethod: this.handleEnterURLSave
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $19a2c46de016b524$export$2e2bcd8739ae039), null));
    }
    // realtimeUtils is deprecated TODO: replace with ???
    componentDidMount() {
        // Try a quick, no-popup authorization for the case where user is already logged in.
        // If this fails, they will have to click the "Authenticate" button to launch the pop-up.
        this.authorize();
        // Remove user from collaborative user list when close window
        window.addEventListener("beforeunload", (e)=>{
            window.realtimeUtils.removeCollaborativeUser(this.state.fileType, this.state.fileId, this.state.currentUser);
        });
        // Load TextHelp toolbar
        // window.TexthelpSpeechStream.addToolbar();
        if (window.developmentTools !== true) (0, $0951650939e65d98$export$e7d6ca579af3977d)(true);
    }
    componentWillUnmount() {}
    isIOS() {
        // Second test is needed for iOS 13+
        return navigator.userAgent.match(/iPhone|iPad|iPod/i) != null || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
    }
    // Attempt to auto authorize with Google Firebase.
    authorize() {
        if (this.isIOS()) window.onpageshow = function(event) {
            if (event.persisted) window.location.reload();
        };
        const idToken = $3b6f5d857e82afe2$var$cookies.get("corgi_id_token");
        if (idToken != null) {
            if (window.google) this.initGISClient(idToken);
            else document.getElementById("gsiClientScript").addEventListener("load", ()=>{
                this.initGISClient(idToken);
            });
        } else {
            console.log("Auto-authorize did not work, redirect to pre-login");
            this.setState({
                loginRequired: true,
                loading: false
            });
        }
    }
    initGISClient(idToken) {
        const access_token = $3b6f5d857e82afe2$var$cookies.get("corgi_access_token");
        if (access_token) this.validateAccessToken(access_token, ()=>{
            this.loadGoogleClientApiAndAuthorize(access_token).then(()=>{
                this.afterAuthorized();
            });
        }, ()=>{
            this.handleAccessTokenExpired();
        });
        else this.requestNewAccessToken(idToken);
    }
    requestNewAccessToken(idToken) {
        const gisClient = window.google.accounts.oauth2.initTokenClient({
            client_id: window.firebaseConfig.clientId,
            hint: (0, $17a7e6a65f1eecc1$export$4b61618bdb99cb7e)(idToken).email,
            scope: $3b6f5d857e82afe2$var$BASE_GOOGLE_SCOPE,
            prompt: '',
            callback: (tokenResponse)=>{
                $3b6f5d857e82afe2$var$cookies.set("corgi_access_token", tokenResponse.access_token, {
                    path: '/',
                    sameSite: 'strict'
                });
                console.log("tokenResponse.scope", tokenResponse.scope);
                // Save the actual reported scopes  - not the assumed ones
                //cookies.set("corgi_granted_scopes", BASE_GOOGLE_SCOPE, {path: '/'});
                $3b6f5d857e82afe2$var$cookies.set("corgi_granted_scopes", tokenResponse.scope, {
                    path: '/',
                    sameSite: 'strict'
                });
                this.loadGoogleClientApiAndAuthorize(tokenResponse.access_token).then(()=>{
                    this.afterAuthorized();
                });
            }
        });
        gisClient.requestAccessToken();
    }
    loadGoogleClientApiAndAuthorize(accessToken) {
        return new Promise((resolve)=>{
            const script = document.createElement("script");
            script.src = "https://apis.google.com/js/api.js";
            script.onload = (e)=>{
                window.gapi.load("client", ()=>{
                    window.gapi.client.init({}).then(()=>{
                        window.gapi.auth.setToken({
                            access_token: accessToken
                        });
                        window.gapi.client.load('drive', 'v3', ()=>{
                            console.log("drive v3 client loaded");
                            resolve();
                        }, (error)=>console.error("Failed to load drive client API", error));
                    });
                });
                window.gapi.load("drive-share", ()=>{
                    console.log("drive-share loaded");
                }, (error)=>console.error("can not load drive-share", error));
            };
            document.body.appendChild(script);
        });
    }
    afterAuthorized() {
        const inspectedIDToken = (0, $17a7e6a65f1eecc1$export$4b61618bdb99cb7e)($3b6f5d857e82afe2$var$cookies.get("corgi_id_token"));
        let currentUser = {
            uid: $3b6f5d857e82afe2$var$cookies.get("corgi_firebase_uid"),
            displayName: inspectedIDToken.name,
            photoURL: inspectedIDToken.picture,
            emailAddress: inspectedIDToken.email,
            role: ""
        };
        this.setState({
            authorized: true,
            loginRequired: false,
            loading: false,
            currentUser: currentUser
        }, ()=>{
            this.loadFileBasedOnUrl();
            this.checkAccountType();
        });
    }
    checkAccountType() {
        console.log("Check Account Type");
        const roleNode = "user/" + this.state.currentUser.uid;
        let roleRef = window.firebase.database().ref(roleNode);
        let self = this;
        roleRef.once('value', function(snapshot) {
            if (!snapshot.exists()) {
                console.log("Don't have role in Firebase -> show popup");
                (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#modalUserType0').CFW_Modal('show');
            } else {
                let user = self.state.currentUser;
                user.role = snapshot.val().role;
                self.setState({
                    currentUser: user
                }, ()=>{
                    self.childRef.current.updateRole(user.role);
                });
            }
        });
    }
    updateAccountType(role) {
        const roleNode = "user/" + this.state.currentUser.uid;
        let roleRef = window.firebase.database().ref(roleNode);
        let self = this;
        roleRef.update({
            role: role
        }, ()=>{
            console.log("Update role success");
            let user = self.state.currentUser;
            user.role = role;
            self.setState({
                currentUser: user
            });
        });
    }
    openEnterURLModal(triggerId, saveMethod) {
        this.enterURLSaveMethod = saveMethod;
        (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#' + triggerId).CFW_Modal({
            'target': '#' + this.enterURLModalId,
            'unlink': true,
            'show': true
        });
    }
    handleEnterURLSave(url) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#' + this.enterURLModalId).CFW_Modal('hide');
        if (this.enterURLSaveMethod) this.enterURLSaveMethod(url);
    }
    openYouTubeModal(triggerId, saveMethod) {
        this.youTubeSaveMethod = saveMethod;
        (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#' + triggerId).CFW_Modal({
            'target': '#' + this.youTubeModalId,
            'unlink': true,
            'show': true
        });
    }
    closeYouTubeModal() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#' + this.youTubeModalId).CFW_Modal('hide');
    }
    handleYouTubeSave(url) {
        this.closeYouTubeModal();
        if (this.youTubeSaveMethod) this.youTubeSaveMethod(url);
        else console.error('YouTube Video save called without a save method defined');
    }
    openSearchWebModal(triggerId, saveMethod) {
        this.imageSaveMethod = saveMethod;
        (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#' + triggerId).CFW_Modal({
            'target': '#' + this.searchWebModalId,
            'unlink': true,
            'show': true
        });
    }
    handleImageSave(url) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#' + this.searchWebModalId).CFW_Modal('hide');
        if (this.imageSaveMethod) this.imageSaveMethod(url);
    }
    handleAccessTokenExpired() {
        $3b6f5d857e82afe2$var$cookies.remove("corgi_access_token", {
            path: '/',
            sameSite: 'strict'
        });
        $3b6f5d857e82afe2$var$cookies.remove("corgi_granted_scopes", {
            path: '/',
            sameSite: 'strict'
        });
        this.requestNewAccessToken($3b6f5d857e82afe2$var$cookies.get("corgi_id_token"));
    }
    // Login with Google
    authorizeWithPopUp(googleAuthResponse) {
        $3b6f5d857e82afe2$var$cookies.set("corgi_id_token", googleAuthResponse.credential, {
            path: '/',
            sameSite: 'strict'
        });
        (0, $42ddf94e6f3c0a26$export$2e2bcd8739ae039).auth().signInWithCredential((0, $42ddf94e6f3c0a26$export$2e2bcd8739ae039).auth.GoogleAuthProvider.credential(googleAuthResponse.credential)).then((userCre)=>{
            let user = userCre.user;
            if (user) {
                console.log("Sign in Firebase successfully");
                $3b6f5d857e82afe2$var$cookies.set("corgi_firebase_uid", user.uid, {
                    path: '/',
                    sameSite: 'strict'
                });
                this.authorize();
            }
        });
    }
    loadFileBasedOnUrl() {
        const docType = (0, $220c2d58964ba595$export$ecf541e09a511845)('type');
        const id = (0, $220c2d58964ba595$export$ecf541e09a511845)('id');
        console.debug("App.loadFileBasedOnUrl " + id);
        if (this.isFileTypeValid(docType) && id) {
            if (id !== this.state.fileId) this.loadFile(id);
        } else console.log("No document to load.");
    }
    // Retrieve the file with the given ID from Google Drive.
    loadFile(id) {
        console.debug("App.loadFile " + id);
        if (this.state.fileIdLoaded) this.setState({
            fileIdLoaded: false
        });
        this.getMetadata(id).then((metadata)=>{
            // The "type" section of the URL can be wrong when Google Drive redirects to Corgi
            if (metadata.properties.type !== (0, $220c2d58964ba595$export$ecf541e09a511845)('type')) {
                console.warn('Redicting because document is actually ', metadata.properties.type);
                window.location = '/' + metadata.properties.type + '/' + id;
                return;
            }
            this.onFileLoaded(id, metadata);
        });
    }
    isFileTypeValid(type) {
        return [
            'cause-effect',
            'question-exp',
            'comparison',
            'cera'
        ].includes(type);
    }
    // Called when we have connected to a file.
    // and set state variables which will connect the data model to the UI.
    onFileLoaded(id, metadata) {
        console.debug("App.onFileLoaded " + id);
        // We write the ID of the file into the file metadata.
        // This lets us detect if the file has been copied by Google Drive outside of Corgi
        // If so, we copy the original content the first time the copied file is opened.
        let origId = metadata.properties.origId;
        if (origId === id) console.debug("Original ID matches current ID: " + origId);
        else if (origId) {
            // Note: this pathway is currently unused. Google Drive won't let users copy these files.
            console.debug("Original ID does not match - file was copied outside of Corgi.");
            console.info("Copying file contents from " + origId + " into " + id);
            window.realtimeUtils.getDoc(metadata.properties.type, origId).once("value", (data)=>{
                this.copyRealtimeFile(data.val(), id);
            });
        } else {
            console.info("Original ID is missing; adding it to the metadata");
            this.updateDriveFile(id, {
                properties: {
                    origId: id
                }
            });
        }
        this.setState({
            fileIdLoaded: true,
            fileId: id,
            newFileId: null,
            fileType: metadata.properties.type,
            fileName: metadata.name,
            fileSection: (0, $220c2d58964ba595$export$ecf541e09a511845)("section"),
            metadata: metadata,
            canEdit: metadata.capabilities.canEdit,
            fileTypeValid: this.isFileTypeValid(metadata.properties.type),
            asideOpen: true,
            loading: false,
            copyPending: null,
            createPending: null
        });
        console.log("Parents of loaded file: ", metadata.parents);
        if (metadata.capabilities.canEdit) window.realtimeUtils.addCollaborativeUser(metadata.properties.type, id, this.state.currentUser);
        this.updateOpenedTime();
    }
    getRoutineTitle = (prompt, oldName)=>{
        const newName = window.prompt(prompt, oldName);
        if (!(0, $2f05acbc3da55feb$export$236eb756c096e00e)(newName)) return null;
        return newName.trim();
    };
    // Creates a new file and attaches to it a new realtime document of the given type.
    createDoc(page, type) {
        console.log("App.createDoc " + type);
        if (this.state.createPending) {
            this.setState({
                fileId: null,
                newFileId: null
            });
            this.createDriveFile(this.state.createPending, type).then((id)=>{
                this.createRealtimeFile(id, type).then(()=>{
                    this.setState({
                        createPending: null,
                        newFileId: id
                    });
                    (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#offcanvasNavbar').CFW_Offcanvas('hide');
                });
            }).catch((error)=>{
                console.log("Error while creating drive file", error);
            });
            // window.tracker.trackEvent(page, "create-new", type);
            window.tracker.trackEvent("Guide", "create guide", "");
        } else console.log('null %s createPending', type);
        return false;
    }
    createRealtimeFile(id, type) {
        console.debug("App.createRealtimeFile " + id);
        return window.realtimeUtils.createDoc(type, id, {
            type: type
        }).then(()=>{}).catch((error)=>{
            console.log("Error while creating realtime file", error);
        });
    }
    updateDriveFile(fileId, changes) {
        return new Promise((resolve, reject)=>{
            window.gapi.client.request({
                path: "https://www.googleapis.com/drive/v3/files/" + fileId,
                method: "PATCH",
                body: changes
            }).then((response)=>{
                console.log("Metadata update successful " + $3UKyI.inspect(changes));
                resolve(response.result);
            }, (error)=>{
                console.error("Could not update metadata: " + error.result.error.message);
                if (error.result.error.code === 401) this.handleAccessTokenExpired();
                else reject(error);
            });
        });
    }
    // Creates a new Google Drive file and runs the given callback with the result.
    createDriveFile(title, type) {
        console.debug("App.createDriveFile " + type);
        return new Promise((resolve, reject)=>{
            window.gapi.client.request({
                path: "https://www.googleapis.com/drive/v3/files",
                method: "POST",
                body: {
                    mimeType: "application/vnd.google-apps.drive-sdk",
                    name: title,
                    properties: {
                        type: type
                    },
                    contentHints: {
                        thumbnail: {
                            image: (0, $294eb611d6d6000b$export$2e2bcd8739ae039)[type],
                            mimeType: "image/png"
                        }
                    },
                    description: "CORGI document: " + (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(type + ".title")
                }
            }).then((response)=>{
                const id = response.result.id;
                resolve(id);
            }, (error)=>{
                if (error.result.error.code === 401) this.handleAccessTokenExpired();
                else reject(error);
            });
        });
    }
    getMetadata(id) {
        console.debug("App.getMetadata " + id);
        return new Promise((resolve)=>{
            window.gapi.client.request({
                path: "https://www.googleapis.com/drive/v3/files/" + id,
                method: "GET",
                params: {
                    fields: "capabilities, properties, id, name, mimeType, kind, parents"
                }
            }).then((response)=>{
                resolve(response.result);
            }, (err_reason)=>{
                console.log("Could not get file metadata: " + err_reason.result.error.message);
                this.setState({
                    error: 1
                });
                if (err_reason.result.error.code === 401) this.handleAccessTokenExpired();
            });
        });
    }
    updateFileName(newName) {
        this.setState({
            fileName: newName
        });
    }
    renameDoc(newName) {
        return this.updateDriveFile(this.state.fileId, {
            name: newName
        });
    }
    contentUpdated() {
        if (undefined === this.lastUpdateTime || null === this.lastUpdateTime) {
            this.updateModifiedTime();
            this.lastUpdateTime = new Date().getTime();
        } else {
            let diffTime = new Date().getTime() - this.lastUpdateTime;
            if (diffTime > 60000) {
                this.updateModifiedTime();
                this.lastUpdateTime = new Date().getTime();
            }
        }
    }
    updateModifiedTime() {
        this.updateDriveFile(this.state.fileId, {
            modifiedTime: new Date()
        });
    }
    updateOpenedTime() {
        if (undefined === this.lastOpenedTime || null === this.lastOpenedTime) {
            this.updateViewedByMeTime();
            this.lastOpenedTime = new Date().getTime();
        } else {
            let diffTime = new Date().getTime() - this.lastOpenedTime;
            if (diffTime > 60000) {
                this.updateViewedByMeTime();
                this.lastOpenedTime = new Date().getTime();
            }
        }
    }
    updateViewedByMeTime() {
        this.updateDriveFile(this.state.fileId, {
            viewedByMeTime: new Date()
        });
    }
    // Stop editing document and revert to the create-a-new-doc view.
    closeFile() {
        //window.history.pushState(null, "", '?');
        window.realtimeUtils.removeCollaborativeUser(this.state.fileType, this.state.fileId, this.state.currentUser);
        this.setState({
            doc: null,
            fileId: null,
            filename: null,
            fileType: null,
            metadata: null
        });
    }
    addGoogleScope(scopes, callback) {
        const grantedScopes = $3b6f5d857e82afe2$var$cookies.get("corgi_granted_scopes");
        if (!grantedScopes.includes(scopes)) {
            const newScopes = grantedScopes + " " + scopes;
            const gisClient = window.google.accounts.oauth2.initTokenClient({
                client_id: window.firebaseConfig.clientId,
                hint: (0, $17a7e6a65f1eecc1$export$4b61618bdb99cb7e)($3b6f5d857e82afe2$var$cookies.get("corgi_id_token")).email,
                scope: newScopes,
                prompt: '',
                callback: (tokenResponse)=>{
                    $3b6f5d857e82afe2$var$cookies.set("corgi_access_token", tokenResponse.access_token, {
                        path: '/',
                        sameSite: 'strict'
                    });
                    // Save the actual scopes allowed as known by Google
                    //cookies.set("corgi_granted_scopes", newScopes, {path: '/'});
                    $3b6f5d857e82afe2$var$cookies.set("corgi_granted_scopes", tokenResponse.scope, {
                        path: '/',
                        sameSite: 'strict'
                    });
                    this.loadGoogleClientApiAndAuthorize(tokenResponse.access_token).then(()=>{
                        callback(window.google.accounts.oauth2.hasGrantedAnyScope(tokenResponse, "profile", scopes));
                    });
                }
            });
            gisClient.requestAccessToken();
        } else callback(true);
    }
    // Match *all* the scopes against the ones currently reported from Google
    // Make sure the cookie set uses the actual scopes permitted as reported from Google
    hasGrantedScopesAll(scopes) {
        const grantedScopes = $3b6f5d857e82afe2$var$cookies.get("corgi_granted_scopes");
        const scopesString = scopes.toString();
        const scopesArray = scopesString.split(/\s+/);
        console.log("GRANTEDSCOPES", grantedScopes);
        console.log("SCOPES", scopes);
        // Check if all scopes are present in grantedScopes
        for (let scopeToFind of scopesArray){
            // If the requested scope is not found in grantedScopes
            if (!grantedScopes.includes(scopeToFind)) return false;
        }
        // If all scopes are found
        return true;
    }
    getDocsTitle(type, reloadIfCancel) {
        const title = this.getRoutineTitle("Create guide named:", "Untitled " + (0, (/*@__PURE__*/$parcel$interopDefault($c9687236993bf07d$exports))).translate(type + ".title"));
        if (!(0, $2f05acbc3da55feb$export$236eb756c096e00e)(title)) {
            console.log("Invalid title, new guide operation cancelled");
            if (null === reloadIfCancel || undefined === reloadIfCancel || true === reloadIfCancel) window.location = '/docs';
            else {
                (0, (/*@__PURE__*/$parcel$interopDefault($9beff9bd740cb2a0$exports)))('#offcanvasNavbar').CFW_Offcanvas('hide');
                window.location = window.location.pathname;
            }
            return null;
        }
        return title;
    }
    doNewDoc(type, reloadIfCancel) {
        let title = this.getDocsTitle(type, reloadIfCancel);
        if (title != null) this.setState({
            createPending: title,
            fileType: type,
            doc: null,
            fileId: null,
            filename: null,
            metadata: null
        }, ()=>{
            this.createDoc("", type);
        });
    }
    handleNewDocButton(type, reloadIfCancel) {
        let driveScopes = "https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/drive.install";
        if (this.hasGrantedScopesAll(driveScopes)) this.doNewDoc(type, reloadIfCancel);
        else this.addGoogleScope(driveScopes, (succeed)=>{
            if (succeed) this.doNewDoc(type, reloadIfCancel);
        });
    }
    handleCopyButton() {
        let oldName = this.state.fileName;
        const newName = this.getRoutineTitle("Copy guide to new name:", "Copy of " + oldName);
        if (!(0, $2f05acbc3da55feb$export$236eb756c096e00e)(newName)) {
            console.log("No new name, copy operation cancelled");
            return;
        }
        this.setState({
            copyPending: newName
        });
    }
    copyFile() {
        const newName = this.state.copyPending;
        const fileType = this.state.fileType;
        this.createDriveFile(newName, fileType).then((id)=>{
            window.tracker.trackEvent("Guide", "copy guide", "");
            window.realtimeUtils.getDoc(fileType, this.state.fileId).once("value", (data)=>{
                this.copyRealtimeFile(data.val(), id);
            });
        });
    }
    // Copy the given Realtime document into a new Realtime doc model.
    copyRealtimeFile(docToCopy, id) {
        docToCopy.users = null;
        window.realtimeUtils.createDoc(docToCopy.type, id, docToCopy).then(()=>{
            // All set. Redirect to edit the new file.
            this.setState({
                copyPending: null,
                newFileId: id
            });
        }).catch((error)=>{
            console.log("Error while copying realtime file", error);
        });
    }
    shareFile() {
        const shareClient = new window.gapi.drive.share.ShareClient();
        shareClient.setOAuthToken(window.gapi.auth.getToken().access_token);
        shareClient.setItemIds(this.state.fileId);
        shareClient.showSettingsDialog();
        // window.tracker.trackEvent(this.state.fileType, "share-doc", this.state.fileName);
        window.tracker.trackEvent("Guide", "share guide", "");
    }
    toggleAside() {
        this.setState({
            asideOpen: !this.state.asideOpen
        });
    }
    validateAccessToken(token, validTokenCallBack, invalidTokenCallback) {
        (0, $c45ae7d48e64ecd8$export$2e2bcd8739ae039).get($3b6f5d857e82afe2$var$BASE_GOOGLE_TOKEN_INFO_URL + "?access_token=" + token, {
            validateStatus: function(status) {
                return status === 400 || status === 200;
            }
        }).then((res)=>{
            if (res.data.expires_in && res.data.expires_in > 0) validTokenCallBack();
            else invalidTokenCallback();
        }).catch(function(error) {
            console.error(error);
        });
    }
    checkAccessTokenBeforeInitGooglePicker(access_token) {
        this.validateAccessToken(access_token, ()=>{}, ()=>{
            window.location.reload();
        });
    }
}



(0, (/*@__PURE__*/$parcel$interopDefault($39d800d77e473b3f$exports))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $923ec6a2a40b86c6$export$9ba4e89fdfa1fc54), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6wXVr))).createElement((0, $3b6f5d857e82afe2$export$2e2bcd8739ae039), null)), document.getElementById('root'));


//# sourceMappingURL=public.5f2cc5de.js.map
